// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%237E8299%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 13 11%27 width=%2713%27 height=%2711%27 fill=%27none%27%3e%3cpath d=%27M11.0426 1.02893C11.3258 0.695792 11.8254 0.655283 12.1585 0.938451C12.4917 1.22162 12.5322 1.72124 12.249 2.05437L5.51985 9.97104C5.23224 10.3094 4.72261 10.3451 4.3907 10.05L0.828197 6.88335C0.50141 6.59288 0.471975 6.09249 0.762452 5.7657C1.05293 5.43891 1.55332 5.40948 1.88011 5.69995L4.83765 8.32889L11.0426 1.02893Z%27 fill=%27%23FFFFFF%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23FFFFFF%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23FFFFFF%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23B5B5C3%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23FFFFFF%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2350CD89%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23F1416C%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23F1416C%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2824, 28, 50, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23181C32%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23009EF7%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23ffffff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23ffffff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%235E6278%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%235E6278%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%23009EF7%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%23009EF7%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%23FFFFFF%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%23FFFFFF%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%23B5B5C3%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%23B5B5C3%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%23A1A5B7%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%23A1A5B7%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%23ffffff%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%23ffffff%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%23E4E6EF%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%23E4E6EF%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%23F5F8FA%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%23F5F8FA%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%2350CD89%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%2350CD89%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%237239EA%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%237239EA%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%23FFC700%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%23FFC700%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%23F1416C%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%23F1416C%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%23181C32%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%23181C32%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%23EFF2F5%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%23EFF2F5%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%237E8299%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%237E8299%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%233F4254%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%233F4254%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23ffffff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%239899ac%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 9%27 fill=%27%239899ac%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-white {
  color: #000000 !important;
  background-color: RGBA(var(--bs-white-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-primary {
  color: #000000 !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #000000 !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #000000 !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #000000 !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-white {
  color: RGBA(var(--bs-white-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-white-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-white:hover, .link-white:focus {
  color: RGBA(255, 255, 255, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 255, 255, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(247, 249, 251, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(247, 249, 251, var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(51, 177, 249, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(51, 177, 249, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(233, 235, 242, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(233, 235, 242, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(115, 215, 161, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(115, 215, 161, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(91, 46, 187, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(91, 46, 187, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 210, 51, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 210, 51, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(244, 103, 137, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(244, 103, 137, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(19, 22, 40, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(19, 22, 40, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: calc(3 / 4 * 100%);
}

.ratio-16x9 {
  --bs-aspect-ratio: calc(9 / 16 * 100%);
}

.ratio-21x9 {
  --bs-aspect-ratio: calc(9 / 21 * 100%);
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}
.visually-hidden *,
.visually-hidden-focusable:not(:focus):not(:focus-within) * {
  overflow: hidden !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-white {
  --bs-focus-ring-color: rgba(var(--bs-white-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-25 {
  top: 25% !important;
}

.top-50 {
  top: 50% !important;
}

.top-75 {
  top: 75% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-25 {
  bottom: 25% !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-75 {
  bottom: 75% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-25 {
  left: 25% !important;
}

.start-50 {
  left: 50% !important;
}

.start-75 {
  left: 75% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-25 {
  right: 25% !important;
}

.end-50 {
  right: 50% !important;
}

.end-75 {
  right: 75% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-0 {
  border-width: 0 !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 0.75rem !important;
}

.m-4 {
  margin: 1rem !important;
}

.m-5 {
  margin: 1.25rem !important;
}

.m-6 {
  margin: 1.5rem !important;
}

.m-7 {
  margin: 1.75rem !important;
}

.m-8 {
  margin: 2rem !important;
}

.m-9 {
  margin: 2.25rem !important;
}

.m-10 {
  margin: 2.5rem !important;
}

.m-11 {
  margin: 2.75rem !important;
}

.m-12 {
  margin: 3rem !important;
}

.m-13 {
  margin: 3.25rem !important;
}

.m-14 {
  margin: 3.5rem !important;
}

.m-15 {
  margin: 3.75rem !important;
}

.m-16 {
  margin: 4rem !important;
}

.m-17 {
  margin: 4.25rem !important;
}

.m-18 {
  margin: 4.5rem !important;
}

.m-19 {
  margin: 4.75rem !important;
}

.m-20 {
  margin: 5rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 0.75rem !important;
  margin-left: 0.75rem !important;
}

.mx-4 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-5 {
  margin-right: 1.25rem !important;
  margin-left: 1.25rem !important;
}

.mx-6 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-7 {
  margin-right: 1.75rem !important;
  margin-left: 1.75rem !important;
}

.mx-8 {
  margin-right: 2rem !important;
  margin-left: 2rem !important;
}

.mx-9 {
  margin-right: 2.25rem !important;
  margin-left: 2.25rem !important;
}

.mx-10 {
  margin-right: 2.5rem !important;
  margin-left: 2.5rem !important;
}

.mx-11 {
  margin-right: 2.75rem !important;
  margin-left: 2.75rem !important;
}

.mx-12 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-13 {
  margin-right: 3.25rem !important;
  margin-left: 3.25rem !important;
}

.mx-14 {
  margin-right: 3.5rem !important;
  margin-left: 3.5rem !important;
}

.mx-15 {
  margin-right: 3.75rem !important;
  margin-left: 3.75rem !important;
}

.mx-16 {
  margin-right: 4rem !important;
  margin-left: 4rem !important;
}

.mx-17 {
  margin-right: 4.25rem !important;
  margin-left: 4.25rem !important;
}

.mx-18 {
  margin-right: 4.5rem !important;
  margin-left: 4.5rem !important;
}

.mx-19 {
  margin-right: 4.75rem !important;
  margin-left: 4.75rem !important;
}

.mx-20 {
  margin-right: 5rem !important;
  margin-left: 5rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}

.my-4 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-5 {
  margin-top: 1.25rem !important;
  margin-bottom: 1.25rem !important;
}

.my-6 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-7 {
  margin-top: 1.75rem !important;
  margin-bottom: 1.75rem !important;
}

.my-8 {
  margin-top: 2rem !important;
  margin-bottom: 2rem !important;
}

.my-9 {
  margin-top: 2.25rem !important;
  margin-bottom: 2.25rem !important;
}

.my-10 {
  margin-top: 2.5rem !important;
  margin-bottom: 2.5rem !important;
}

.my-11 {
  margin-top: 2.75rem !important;
  margin-bottom: 2.75rem !important;
}

.my-12 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-13 {
  margin-top: 3.25rem !important;
  margin-bottom: 3.25rem !important;
}

.my-14 {
  margin-top: 3.5rem !important;
  margin-bottom: 3.5rem !important;
}

.my-15 {
  margin-top: 3.75rem !important;
  margin-bottom: 3.75rem !important;
}

.my-16 {
  margin-top: 4rem !important;
  margin-bottom: 4rem !important;
}

.my-17 {
  margin-top: 4.25rem !important;
  margin-bottom: 4.25rem !important;
}

.my-18 {
  margin-top: 4.5rem !important;
  margin-bottom: 4.5rem !important;
}

.my-19 {
  margin-top: 4.75rem !important;
  margin-bottom: 4.75rem !important;
}

.my-20 {
  margin-top: 5rem !important;
  margin-bottom: 5rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 0.75rem !important;
}

.mt-4 {
  margin-top: 1rem !important;
}

.mt-5 {
  margin-top: 1.25rem !important;
}

.mt-6 {
  margin-top: 1.5rem !important;
}

.mt-7 {
  margin-top: 1.75rem !important;
}

.mt-8 {
  margin-top: 2rem !important;
}

.mt-9 {
  margin-top: 2.25rem !important;
}

.mt-10 {
  margin-top: 2.5rem !important;
}

.mt-11 {
  margin-top: 2.75rem !important;
}

.mt-12 {
  margin-top: 3rem !important;
}

.mt-13 {
  margin-top: 3.25rem !important;
}

.mt-14 {
  margin-top: 3.5rem !important;
}

.mt-15 {
  margin-top: 3.75rem !important;
}

.mt-16 {
  margin-top: 4rem !important;
}

.mt-17 {
  margin-top: 4.25rem !important;
}

.mt-18 {
  margin-top: 4.5rem !important;
}

.mt-19 {
  margin-top: 4.75rem !important;
}

.mt-20 {
  margin-top: 5rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 0.75rem !important;
}

.me-4 {
  margin-right: 1rem !important;
}

.me-5 {
  margin-right: 1.25rem !important;
}

.me-6 {
  margin-right: 1.5rem !important;
}

.me-7 {
  margin-right: 1.75rem !important;
}

.me-8 {
  margin-right: 2rem !important;
}

.me-9 {
  margin-right: 2.25rem !important;
}

.me-10 {
  margin-right: 2.5rem !important;
}

.me-11 {
  margin-right: 2.75rem !important;
}

.me-12 {
  margin-right: 3rem !important;
}

.me-13 {
  margin-right: 3.25rem !important;
}

.me-14 {
  margin-right: 3.5rem !important;
}

.me-15 {
  margin-right: 3.75rem !important;
}

.me-16 {
  margin-right: 4rem !important;
}

.me-17 {
  margin-right: 4.25rem !important;
}

.me-18 {
  margin-right: 4.5rem !important;
}

.me-19 {
  margin-right: 4.75rem !important;
}

.me-20 {
  margin-right: 5rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 0.75rem !important;
}

.mb-4 {
  margin-bottom: 1rem !important;
}

.mb-5 {
  margin-bottom: 1.25rem !important;
}

.mb-6 {
  margin-bottom: 1.5rem !important;
}

.mb-7 {
  margin-bottom: 1.75rem !important;
}

.mb-8 {
  margin-bottom: 2rem !important;
}

.mb-9 {
  margin-bottom: 2.25rem !important;
}

.mb-10 {
  margin-bottom: 2.5rem !important;
}

.mb-11 {
  margin-bottom: 2.75rem !important;
}

.mb-12 {
  margin-bottom: 3rem !important;
}

.mb-13 {
  margin-bottom: 3.25rem !important;
}

.mb-14 {
  margin-bottom: 3.5rem !important;
}

.mb-15 {
  margin-bottom: 3.75rem !important;
}

.mb-16 {
  margin-bottom: 4rem !important;
}

.mb-17 {
  margin-bottom: 4.25rem !important;
}

.mb-18 {
  margin-bottom: 4.5rem !important;
}

.mb-19 {
  margin-bottom: 4.75rem !important;
}

.mb-20 {
  margin-bottom: 5rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 0.75rem !important;
}

.ms-4 {
  margin-left: 1rem !important;
}

.ms-5 {
  margin-left: 1.25rem !important;
}

.ms-6 {
  margin-left: 1.5rem !important;
}

.ms-7 {
  margin-left: 1.75rem !important;
}

.ms-8 {
  margin-left: 2rem !important;
}

.ms-9 {
  margin-left: 2.25rem !important;
}

.ms-10 {
  margin-left: 2.5rem !important;
}

.ms-11 {
  margin-left: 2.75rem !important;
}

.ms-12 {
  margin-left: 3rem !important;
}

.ms-13 {
  margin-left: 3.25rem !important;
}

.ms-14 {
  margin-left: 3.5rem !important;
}

.ms-15 {
  margin-left: 3.75rem !important;
}

.ms-16 {
  margin-left: 4rem !important;
}

.ms-17 {
  margin-left: 4.25rem !important;
}

.ms-18 {
  margin-left: 4.5rem !important;
}

.ms-19 {
  margin-left: 4.75rem !important;
}

.ms-20 {
  margin-left: 5rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.m-n3 {
  margin: -0.75rem !important;
}

.m-n4 {
  margin: -1rem !important;
}

.m-n5 {
  margin: -1.25rem !important;
}

.m-n6 {
  margin: -1.5rem !important;
}

.m-n7 {
  margin: -1.75rem !important;
}

.m-n8 {
  margin: -2rem !important;
}

.m-n9 {
  margin: -2.25rem !important;
}

.m-n10 {
  margin: -2.5rem !important;
}

.m-n11 {
  margin: -2.75rem !important;
}

.m-n12 {
  margin: -3rem !important;
}

.m-n13 {
  margin: -3.25rem !important;
}

.m-n14 {
  margin: -3.5rem !important;
}

.m-n15 {
  margin: -3.75rem !important;
}

.m-n16 {
  margin: -4rem !important;
}

.m-n17 {
  margin: -4.25rem !important;
}

.m-n18 {
  margin: -4.5rem !important;
}

.m-n19 {
  margin: -4.75rem !important;
}

.m-n20 {
  margin: -5rem !important;
}

.mx-n1 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important;
}

.mx-n2 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important;
}

.mx-n3 {
  margin-right: -0.75rem !important;
  margin-left: -0.75rem !important;
}

.mx-n4 {
  margin-right: -1rem !important;
  margin-left: -1rem !important;
}

.mx-n5 {
  margin-right: -1.25rem !important;
  margin-left: -1.25rem !important;
}

.mx-n6 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important;
}

.mx-n7 {
  margin-right: -1.75rem !important;
  margin-left: -1.75rem !important;
}

.mx-n8 {
  margin-right: -2rem !important;
  margin-left: -2rem !important;
}

.mx-n9 {
  margin-right: -2.25rem !important;
  margin-left: -2.25rem !important;
}

.mx-n10 {
  margin-right: -2.5rem !important;
  margin-left: -2.5rem !important;
}

.mx-n11 {
  margin-right: -2.75rem !important;
  margin-left: -2.75rem !important;
}

.mx-n12 {
  margin-right: -3rem !important;
  margin-left: -3rem !important;
}

.mx-n13 {
  margin-right: -3.25rem !important;
  margin-left: -3.25rem !important;
}

.mx-n14 {
  margin-right: -3.5rem !important;
  margin-left: -3.5rem !important;
}

.mx-n15 {
  margin-right: -3.75rem !important;
  margin-left: -3.75rem !important;
}

.mx-n16 {
  margin-right: -4rem !important;
  margin-left: -4rem !important;
}

.mx-n17 {
  margin-right: -4.25rem !important;
  margin-left: -4.25rem !important;
}

.mx-n18 {
  margin-right: -4.5rem !important;
  margin-left: -4.5rem !important;
}

.mx-n19 {
  margin-right: -4.75rem !important;
  margin-left: -4.75rem !important;
}

.mx-n20 {
  margin-right: -5rem !important;
  margin-left: -5rem !important;
}

.my-n1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}

.my-n2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}

.my-n3 {
  margin-top: -0.75rem !important;
  margin-bottom: -0.75rem !important;
}

.my-n4 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important;
}

.my-n5 {
  margin-top: -1.25rem !important;
  margin-bottom: -1.25rem !important;
}

.my-n6 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}

.my-n7 {
  margin-top: -1.75rem !important;
  margin-bottom: -1.75rem !important;
}

.my-n8 {
  margin-top: -2rem !important;
  margin-bottom: -2rem !important;
}

.my-n9 {
  margin-top: -2.25rem !important;
  margin-bottom: -2.25rem !important;
}

.my-n10 {
  margin-top: -2.5rem !important;
  margin-bottom: -2.5rem !important;
}

.my-n11 {
  margin-top: -2.75rem !important;
  margin-bottom: -2.75rem !important;
}

.my-n12 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important;
}

.my-n13 {
  margin-top: -3.25rem !important;
  margin-bottom: -3.25rem !important;
}

.my-n14 {
  margin-top: -3.5rem !important;
  margin-bottom: -3.5rem !important;
}

.my-n15 {
  margin-top: -3.75rem !important;
  margin-bottom: -3.75rem !important;
}

.my-n16 {
  margin-top: -4rem !important;
  margin-bottom: -4rem !important;
}

.my-n17 {
  margin-top: -4.25rem !important;
  margin-bottom: -4.25rem !important;
}

.my-n18 {
  margin-top: -4.5rem !important;
  margin-bottom: -4.5rem !important;
}

.my-n19 {
  margin-top: -4.75rem !important;
  margin-bottom: -4.75rem !important;
}

.my-n20 {
  margin-top: -5rem !important;
  margin-bottom: -5rem !important;
}

.mt-n1 {
  margin-top: -0.25rem !important;
}

.mt-n2 {
  margin-top: -0.5rem !important;
}

.mt-n3 {
  margin-top: -0.75rem !important;
}

.mt-n4 {
  margin-top: -1rem !important;
}

.mt-n5 {
  margin-top: -1.25rem !important;
}

.mt-n6 {
  margin-top: -1.5rem !important;
}

.mt-n7 {
  margin-top: -1.75rem !important;
}

.mt-n8 {
  margin-top: -2rem !important;
}

.mt-n9 {
  margin-top: -2.25rem !important;
}

.mt-n10 {
  margin-top: -2.5rem !important;
}

.mt-n11 {
  margin-top: -2.75rem !important;
}

.mt-n12 {
  margin-top: -3rem !important;
}

.mt-n13 {
  margin-top: -3.25rem !important;
}

.mt-n14 {
  margin-top: -3.5rem !important;
}

.mt-n15 {
  margin-top: -3.75rem !important;
}

.mt-n16 {
  margin-top: -4rem !important;
}

.mt-n17 {
  margin-top: -4.25rem !important;
}

.mt-n18 {
  margin-top: -4.5rem !important;
}

.mt-n19 {
  margin-top: -4.75rem !important;
}

.mt-n20 {
  margin-top: -5rem !important;
}

.me-n1 {
  margin-right: -0.25rem !important;
}

.me-n2 {
  margin-right: -0.5rem !important;
}

.me-n3 {
  margin-right: -0.75rem !important;
}

.me-n4 {
  margin-right: -1rem !important;
}

.me-n5 {
  margin-right: -1.25rem !important;
}

.me-n6 {
  margin-right: -1.5rem !important;
}

.me-n7 {
  margin-right: -1.75rem !important;
}

.me-n8 {
  margin-right: -2rem !important;
}

.me-n9 {
  margin-right: -2.25rem !important;
}

.me-n10 {
  margin-right: -2.5rem !important;
}

.me-n11 {
  margin-right: -2.75rem !important;
}

.me-n12 {
  margin-right: -3rem !important;
}

.me-n13 {
  margin-right: -3.25rem !important;
}

.me-n14 {
  margin-right: -3.5rem !important;
}

.me-n15 {
  margin-right: -3.75rem !important;
}

.me-n16 {
  margin-right: -4rem !important;
}

.me-n17 {
  margin-right: -4.25rem !important;
}

.me-n18 {
  margin-right: -4.5rem !important;
}

.me-n19 {
  margin-right: -4.75rem !important;
}

.me-n20 {
  margin-right: -5rem !important;
}

.mb-n1 {
  margin-bottom: -0.25rem !important;
}

.mb-n2 {
  margin-bottom: -0.5rem !important;
}

.mb-n3 {
  margin-bottom: -0.75rem !important;
}

.mb-n4 {
  margin-bottom: -1rem !important;
}

.mb-n5 {
  margin-bottom: -1.25rem !important;
}

.mb-n6 {
  margin-bottom: -1.5rem !important;
}

.mb-n7 {
  margin-bottom: -1.75rem !important;
}

.mb-n8 {
  margin-bottom: -2rem !important;
}

.mb-n9 {
  margin-bottom: -2.25rem !important;
}

.mb-n10 {
  margin-bottom: -2.5rem !important;
}

.mb-n11 {
  margin-bottom: -2.75rem !important;
}

.mb-n12 {
  margin-bottom: -3rem !important;
}

.mb-n13 {
  margin-bottom: -3.25rem !important;
}

.mb-n14 {
  margin-bottom: -3.5rem !important;
}

.mb-n15 {
  margin-bottom: -3.75rem !important;
}

.mb-n16 {
  margin-bottom: -4rem !important;
}

.mb-n17 {
  margin-bottom: -4.25rem !important;
}

.mb-n18 {
  margin-bottom: -4.5rem !important;
}

.mb-n19 {
  margin-bottom: -4.75rem !important;
}

.mb-n20 {
  margin-bottom: -5rem !important;
}

.ms-n1 {
  margin-left: -0.25rem !important;
}

.ms-n2 {
  margin-left: -0.5rem !important;
}

.ms-n3 {
  margin-left: -0.75rem !important;
}

.ms-n4 {
  margin-left: -1rem !important;
}

.ms-n5 {
  margin-left: -1.25rem !important;
}

.ms-n6 {
  margin-left: -1.5rem !important;
}

.ms-n7 {
  margin-left: -1.75rem !important;
}

.ms-n8 {
  margin-left: -2rem !important;
}

.ms-n9 {
  margin-left: -2.25rem !important;
}

.ms-n10 {
  margin-left: -2.5rem !important;
}

.ms-n11 {
  margin-left: -2.75rem !important;
}

.ms-n12 {
  margin-left: -3rem !important;
}

.ms-n13 {
  margin-left: -3.25rem !important;
}

.ms-n14 {
  margin-left: -3.5rem !important;
}

.ms-n15 {
  margin-left: -3.75rem !important;
}

.ms-n16 {
  margin-left: -4rem !important;
}

.ms-n17 {
  margin-left: -4.25rem !important;
}

.ms-n18 {
  margin-left: -4.5rem !important;
}

.ms-n19 {
  margin-left: -4.75rem !important;
}

.ms-n20 {
  margin-left: -5rem !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 0.75rem !important;
}

.p-4 {
  padding: 1rem !important;
}

.p-5 {
  padding: 1.25rem !important;
}

.p-6 {
  padding: 1.5rem !important;
}

.p-7 {
  padding: 1.75rem !important;
}

.p-8 {
  padding: 2rem !important;
}

.p-9 {
  padding: 2.25rem !important;
}

.p-10 {
  padding: 2.5rem !important;
}

.p-11 {
  padding: 2.75rem !important;
}

.p-12 {
  padding: 3rem !important;
}

.p-13 {
  padding: 3.25rem !important;
}

.p-14 {
  padding: 3.5rem !important;
}

.p-15 {
  padding: 3.75rem !important;
}

.p-16 {
  padding: 4rem !important;
}

.p-17 {
  padding: 4.25rem !important;
}

.p-18 {
  padding: 4.5rem !important;
}

.p-19 {
  padding: 4.75rem !important;
}

.p-20 {
  padding: 5rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 0.75rem !important;
  padding-left: 0.75rem !important;
}

.px-4 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-5 {
  padding-right: 1.25rem !important;
  padding-left: 1.25rem !important;
}

.px-6 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-7 {
  padding-right: 1.75rem !important;
  padding-left: 1.75rem !important;
}

.px-8 {
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}

.px-9 {
  padding-right: 2.25rem !important;
  padding-left: 2.25rem !important;
}

.px-10 {
  padding-right: 2.5rem !important;
  padding-left: 2.5rem !important;
}

.px-11 {
  padding-right: 2.75rem !important;
  padding-left: 2.75rem !important;
}

.px-12 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.px-13 {
  padding-right: 3.25rem !important;
  padding-left: 3.25rem !important;
}

.px-14 {
  padding-right: 3.5rem !important;
  padding-left: 3.5rem !important;
}

.px-15 {
  padding-right: 3.75rem !important;
  padding-left: 3.75rem !important;
}

.px-16 {
  padding-right: 4rem !important;
  padding-left: 4rem !important;
}

.px-17 {
  padding-right: 4.25rem !important;
  padding-left: 4.25rem !important;
}

.px-18 {
  padding-right: 4.5rem !important;
  padding-left: 4.5rem !important;
}

.px-19 {
  padding-right: 4.75rem !important;
  padding-left: 4.75rem !important;
}

.px-20 {
  padding-right: 5rem !important;
  padding-left: 5rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}

.py-4 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-5 {
  padding-top: 1.25rem !important;
  padding-bottom: 1.25rem !important;
}

.py-6 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-7 {
  padding-top: 1.75rem !important;
  padding-bottom: 1.75rem !important;
}

.py-8 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}

.py-9 {
  padding-top: 2.25rem !important;
  padding-bottom: 2.25rem !important;
}

.py-10 {
  padding-top: 2.5rem !important;
  padding-bottom: 2.5rem !important;
}

.py-11 {
  padding-top: 2.75rem !important;
  padding-bottom: 2.75rem !important;
}

.py-12 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.py-13 {
  padding-top: 3.25rem !important;
  padding-bottom: 3.25rem !important;
}

.py-14 {
  padding-top: 3.5rem !important;
  padding-bottom: 3.5rem !important;
}

.py-15 {
  padding-top: 3.75rem !important;
  padding-bottom: 3.75rem !important;
}

.py-16 {
  padding-top: 4rem !important;
  padding-bottom: 4rem !important;
}

.py-17 {
  padding-top: 4.25rem !important;
  padding-bottom: 4.25rem !important;
}

.py-18 {
  padding-top: 4.5rem !important;
  padding-bottom: 4.5rem !important;
}

.py-19 {
  padding-top: 4.75rem !important;
  padding-bottom: 4.75rem !important;
}

.py-20 {
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 0.75rem !important;
}

.pt-4 {
  padding-top: 1rem !important;
}

.pt-5 {
  padding-top: 1.25rem !important;
}

.pt-6 {
  padding-top: 1.5rem !important;
}

.pt-7 {
  padding-top: 1.75rem !important;
}

.pt-8 {
  padding-top: 2rem !important;
}

.pt-9 {
  padding-top: 2.25rem !important;
}

.pt-10 {
  padding-top: 2.5rem !important;
}

.pt-11 {
  padding-top: 2.75rem !important;
}

.pt-12 {
  padding-top: 3rem !important;
}

.pt-13 {
  padding-top: 3.25rem !important;
}

.pt-14 {
  padding-top: 3.5rem !important;
}

.pt-15 {
  padding-top: 3.75rem !important;
}

.pt-16 {
  padding-top: 4rem !important;
}

.pt-17 {
  padding-top: 4.25rem !important;
}

.pt-18 {
  padding-top: 4.5rem !important;
}

.pt-19 {
  padding-top: 4.75rem !important;
}

.pt-20 {
  padding-top: 5rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 0.75rem !important;
}

.pe-4 {
  padding-right: 1rem !important;
}

.pe-5 {
  padding-right: 1.25rem !important;
}

.pe-6 {
  padding-right: 1.5rem !important;
}

.pe-7 {
  padding-right: 1.75rem !important;
}

.pe-8 {
  padding-right: 2rem !important;
}

.pe-9 {
  padding-right: 2.25rem !important;
}

.pe-10 {
  padding-right: 2.5rem !important;
}

.pe-11 {
  padding-right: 2.75rem !important;
}

.pe-12 {
  padding-right: 3rem !important;
}

.pe-13 {
  padding-right: 3.25rem !important;
}

.pe-14 {
  padding-right: 3.5rem !important;
}

.pe-15 {
  padding-right: 3.75rem !important;
}

.pe-16 {
  padding-right: 4rem !important;
}

.pe-17 {
  padding-right: 4.25rem !important;
}

.pe-18 {
  padding-right: 4.5rem !important;
}

.pe-19 {
  padding-right: 4.75rem !important;
}

.pe-20 {
  padding-right: 5rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 0.75rem !important;
}

.pb-4 {
  padding-bottom: 1rem !important;
}

.pb-5 {
  padding-bottom: 1.25rem !important;
}

.pb-6 {
  padding-bottom: 1.5rem !important;
}

.pb-7 {
  padding-bottom: 1.75rem !important;
}

.pb-8 {
  padding-bottom: 2rem !important;
}

.pb-9 {
  padding-bottom: 2.25rem !important;
}

.pb-10 {
  padding-bottom: 2.5rem !important;
}

.pb-11 {
  padding-bottom: 2.75rem !important;
}

.pb-12 {
  padding-bottom: 3rem !important;
}

.pb-13 {
  padding-bottom: 3.25rem !important;
}

.pb-14 {
  padding-bottom: 3.5rem !important;
}

.pb-15 {
  padding-bottom: 3.75rem !important;
}

.pb-16 {
  padding-bottom: 4rem !important;
}

.pb-17 {
  padding-bottom: 4.25rem !important;
}

.pb-18 {
  padding-bottom: 4.5rem !important;
}

.pb-19 {
  padding-bottom: 4.75rem !important;
}

.pb-20 {
  padding-bottom: 5rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 0.75rem !important;
}

.ps-4 {
  padding-left: 1rem !important;
}

.ps-5 {
  padding-left: 1.25rem !important;
}

.ps-6 {
  padding-left: 1.5rem !important;
}

.ps-7 {
  padding-left: 1.75rem !important;
}

.ps-8 {
  padding-left: 2rem !important;
}

.ps-9 {
  padding-left: 2.25rem !important;
}

.ps-10 {
  padding-left: 2.5rem !important;
}

.ps-11 {
  padding-left: 2.75rem !important;
}

.ps-12 {
  padding-left: 3rem !important;
}

.ps-13 {
  padding-left: 3.25rem !important;
}

.ps-14 {
  padding-left: 3.5rem !important;
}

.ps-15 {
  padding-left: 3.75rem !important;
}

.ps-16 {
  padding-left: 4rem !important;
}

.ps-17 {
  padding-left: 4.25rem !important;
}

.ps-18 {
  padding-left: 4.5rem !important;
}

.ps-19 {
  padding-left: 4.75rem !important;
}

.ps-20 {
  padding-left: 5rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 0.75rem !important;
}

.gap-4 {
  gap: 1rem !important;
}

.gap-5 {
  gap: 1.25rem !important;
}

.gap-6 {
  gap: 1.5rem !important;
}

.gap-7 {
  gap: 1.75rem !important;
}

.gap-8 {
  gap: 2rem !important;
}

.gap-9 {
  gap: 2.25rem !important;
}

.gap-10 {
  gap: 2.5rem !important;
}

.gap-11 {
  gap: 2.75rem !important;
}

.gap-12 {
  gap: 3rem !important;
}

.gap-13 {
  gap: 3.25rem !important;
}

.gap-14 {
  gap: 3.5rem !important;
}

.gap-15 {
  gap: 3.75rem !important;
}

.gap-16 {
  gap: 4rem !important;
}

.gap-17 {
  gap: 4.25rem !important;
}

.gap-18 {
  gap: 4.5rem !important;
}

.gap-19 {
  gap: 4.75rem !important;
}

.gap-20 {
  gap: 5rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 0.75rem !important;
}

.row-gap-4 {
  row-gap: 1rem !important;
}

.row-gap-5 {
  row-gap: 1.25rem !important;
}

.row-gap-6 {
  row-gap: 1.5rem !important;
}

.row-gap-7 {
  row-gap: 1.75rem !important;
}

.row-gap-8 {
  row-gap: 2rem !important;
}

.row-gap-9 {
  row-gap: 2.25rem !important;
}

.row-gap-10 {
  row-gap: 2.5rem !important;
}

.row-gap-11 {
  row-gap: 2.75rem !important;
}

.row-gap-12 {
  row-gap: 3rem !important;
}

.row-gap-13 {
  row-gap: 3.25rem !important;
}

.row-gap-14 {
  row-gap: 3.5rem !important;
}

.row-gap-15 {
  row-gap: 3.75rem !important;
}

.row-gap-16 {
  row-gap: 4rem !important;
}

.row-gap-17 {
  row-gap: 4.25rem !important;
}

.row-gap-18 {
  row-gap: 4.5rem !important;
}

.row-gap-19 {
  row-gap: 4.75rem !important;
}

.row-gap-20 {
  row-gap: 5rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 0.75rem !important;
}

.column-gap-4 {
  column-gap: 1rem !important;
}

.column-gap-5 {
  column-gap: 1.25rem !important;
}

.column-gap-6 {
  column-gap: 1.5rem !important;
}

.column-gap-7 {
  column-gap: 1.75rem !important;
}

.column-gap-8 {
  column-gap: 2rem !important;
}

.column-gap-9 {
  column-gap: 2.25rem !important;
}

.column-gap-10 {
  column-gap: 2.5rem !important;
}

.column-gap-11 {
  column-gap: 2.75rem !important;
}

.column-gap-12 {
  column-gap: 3rem !important;
}

.column-gap-13 {
  column-gap: 3.25rem !important;
}

.column-gap-14 {
  column-gap: 3.5rem !important;
}

.column-gap-15 {
  column-gap: 3.75rem !important;
}

.column-gap-16 {
  column-gap: 4rem !important;
}

.column-gap-17 {
  column-gap: 4.25rem !important;
}

.column-gap-18 {
  column-gap: 4.5rem !important;
}

.column-gap-19 {
  column-gap: 4.75rem !important;
}

.column-gap-20 {
  column-gap: 5rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-2 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-3 {
  font-size: calc(1.26rem + 0.12vw) !important;
}

.fs-4 {
  font-size: 1.25rem !important;
}

.fs-5 {
  font-size: 1.15rem !important;
}

.fs-6 {
  font-size: 1.075rem !important;
}

.fs-7 {
  font-size: 0.95rem !important;
}

.fs-8 {
  font-size: 0.85rem !important;
}

.fs-9 {
  font-size: 0.75rem !important;
}

.fs-10 {
  font-size: 0.5rem !important;
}

.fs-base {
  font-size: 1rem !important;
}

.fs-fluid {
  font-size: 100% !important;
}

.fs-2x {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-2qx {
  font-size: calc(1.35rem + 1.2vw) !important;
}

.fs-2hx {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2tx {
  font-size: calc(1.4rem + 1.8vw) !important;
}

.fs-3x {
  font-size: calc(1.425rem + 2.1vw) !important;
}

.fs-3qx {
  font-size: calc(1.45rem + 2.4vw) !important;
}

.fs-3hx {
  font-size: calc(1.475rem + 2.7vw) !important;
}

.fs-3tx {
  font-size: calc(1.5rem + 3vw) !important;
}

.fs-4x {
  font-size: calc(1.525rem + 3.3vw) !important;
}

.fs-4qx {
  font-size: calc(1.55rem + 3.6vw) !important;
}

.fs-4hx {
  font-size: calc(1.575rem + 3.9vw) !important;
}

.fs-4tx {
  font-size: calc(1.6rem + 4.2vw) !important;
}

.fs-5x {
  font-size: calc(1.625rem + 4.5vw) !important;
}

.fs-5qx {
  font-size: calc(1.65rem + 4.8vw) !important;
}

.fs-5hx {
  font-size: calc(1.675rem + 5.1vw) !important;
}

.fs-5tx {
  font-size: calc(1.7rem + 5.4vw) !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 500 !important;
}

.fw-bolder {
  font-weight: 600 !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 1.75 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-white {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-white-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }

  .float-sm-end {
    float: right !important;
  }

  .float-sm-none {
    float: none !important;
  }

  .object-fit-sm-contain {
    object-fit: contain !important;
  }

  .object-fit-sm-cover {
    object-fit: cover !important;
  }

  .object-fit-sm-fill {
    object-fit: fill !important;
  }

  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }

  .object-fit-sm-none {
    object-fit: none !important;
  }

  .d-sm-inline {
    display: inline !important;
  }

  .d-sm-inline-block {
    display: inline-block !important;
  }

  .d-sm-block {
    display: block !important;
  }

  .d-sm-grid {
    display: grid !important;
  }

  .d-sm-inline-grid {
    display: inline-grid !important;
  }

  .d-sm-table {
    display: table !important;
  }

  .d-sm-table-row {
    display: table-row !important;
  }

  .d-sm-table-cell {
    display: table-cell !important;
  }

  .d-sm-flex {
    display: flex !important;
  }

  .d-sm-inline-flex {
    display: inline-flex !important;
  }

  .d-sm-none {
    display: none !important;
  }

  .flex-sm-fill {
    flex: 1 1 auto !important;
  }

  .flex-sm-row {
    flex-direction: row !important;
  }

  .flex-sm-column {
    flex-direction: column !important;
  }

  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }

  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-sm-start {
    justify-content: flex-start !important;
  }

  .justify-content-sm-end {
    justify-content: flex-end !important;
  }

  .justify-content-sm-center {
    justify-content: center !important;
  }

  .justify-content-sm-between {
    justify-content: space-between !important;
  }

  .justify-content-sm-around {
    justify-content: space-around !important;
  }

  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-sm-start {
    align-items: flex-start !important;
  }

  .align-items-sm-end {
    align-items: flex-end !important;
  }

  .align-items-sm-center {
    align-items: center !important;
  }

  .align-items-sm-baseline {
    align-items: baseline !important;
  }

  .align-items-sm-stretch {
    align-items: stretch !important;
  }

  .align-content-sm-start {
    align-content: flex-start !important;
  }

  .align-content-sm-end {
    align-content: flex-end !important;
  }

  .align-content-sm-center {
    align-content: center !important;
  }

  .align-content-sm-between {
    align-content: space-between !important;
  }

  .align-content-sm-around {
    align-content: space-around !important;
  }

  .align-content-sm-stretch {
    align-content: stretch !important;
  }

  .align-self-sm-auto {
    align-self: auto !important;
  }

  .align-self-sm-start {
    align-self: flex-start !important;
  }

  .align-self-sm-end {
    align-self: flex-end !important;
  }

  .align-self-sm-center {
    align-self: center !important;
  }

  .align-self-sm-baseline {
    align-self: baseline !important;
  }

  .align-self-sm-stretch {
    align-self: stretch !important;
  }

  .order-sm-first {
    order: -1 !important;
  }

  .order-sm-0 {
    order: 0 !important;
  }

  .order-sm-1 {
    order: 1 !important;
  }

  .order-sm-2 {
    order: 2 !important;
  }

  .order-sm-3 {
    order: 3 !important;
  }

  .order-sm-4 {
    order: 4 !important;
  }

  .order-sm-5 {
    order: 5 !important;
  }

  .order-sm-last {
    order: 6 !important;
  }

  .m-sm-0 {
    margin: 0 !important;
  }

  .m-sm-1 {
    margin: 0.25rem !important;
  }

  .m-sm-2 {
    margin: 0.5rem !important;
  }

  .m-sm-3 {
    margin: 0.75rem !important;
  }

  .m-sm-4 {
    margin: 1rem !important;
  }

  .m-sm-5 {
    margin: 1.25rem !important;
  }

  .m-sm-6 {
    margin: 1.5rem !important;
  }

  .m-sm-7 {
    margin: 1.75rem !important;
  }

  .m-sm-8 {
    margin: 2rem !important;
  }

  .m-sm-9 {
    margin: 2.25rem !important;
  }

  .m-sm-10 {
    margin: 2.5rem !important;
  }

  .m-sm-11 {
    margin: 2.75rem !important;
  }

  .m-sm-12 {
    margin: 3rem !important;
  }

  .m-sm-13 {
    margin: 3.25rem !important;
  }

  .m-sm-14 {
    margin: 3.5rem !important;
  }

  .m-sm-15 {
    margin: 3.75rem !important;
  }

  .m-sm-16 {
    margin: 4rem !important;
  }

  .m-sm-17 {
    margin: 4.25rem !important;
  }

  .m-sm-18 {
    margin: 4.5rem !important;
  }

  .m-sm-19 {
    margin: 4.75rem !important;
  }

  .m-sm-20 {
    margin: 5rem !important;
  }

  .m-sm-auto {
    margin: auto !important;
  }

  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-sm-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }

  .mx-sm-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-sm-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }

  .mx-sm-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-sm-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }

  .mx-sm-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }

  .mx-sm-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }

  .mx-sm-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }

  .mx-sm-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }

  .mx-sm-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-sm-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }

  .mx-sm-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }

  .mx-sm-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }

  .mx-sm-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  .mx-sm-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }

  .mx-sm-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }

  .mx-sm-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }

  .mx-sm-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-sm-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }

  .my-sm-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-sm-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }

  .my-sm-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-sm-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }

  .my-sm-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  .my-sm-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }

  .my-sm-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  .my-sm-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }

  .my-sm-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-sm-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }

  .my-sm-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-sm-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }

  .my-sm-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-sm-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }

  .my-sm-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-sm-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }

  .my-sm-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-sm-0 {
    margin-top: 0 !important;
  }

  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }

  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }

  .mt-sm-3 {
    margin-top: 0.75rem !important;
  }

  .mt-sm-4 {
    margin-top: 1rem !important;
  }

  .mt-sm-5 {
    margin-top: 1.25rem !important;
  }

  .mt-sm-6 {
    margin-top: 1.5rem !important;
  }

  .mt-sm-7 {
    margin-top: 1.75rem !important;
  }

  .mt-sm-8 {
    margin-top: 2rem !important;
  }

  .mt-sm-9 {
    margin-top: 2.25rem !important;
  }

  .mt-sm-10 {
    margin-top: 2.5rem !important;
  }

  .mt-sm-11 {
    margin-top: 2.75rem !important;
  }

  .mt-sm-12 {
    margin-top: 3rem !important;
  }

  .mt-sm-13 {
    margin-top: 3.25rem !important;
  }

  .mt-sm-14 {
    margin-top: 3.5rem !important;
  }

  .mt-sm-15 {
    margin-top: 3.75rem !important;
  }

  .mt-sm-16 {
    margin-top: 4rem !important;
  }

  .mt-sm-17 {
    margin-top: 4.25rem !important;
  }

  .mt-sm-18 {
    margin-top: 4.5rem !important;
  }

  .mt-sm-19 {
    margin-top: 4.75rem !important;
  }

  .mt-sm-20 {
    margin-top: 5rem !important;
  }

  .mt-sm-auto {
    margin-top: auto !important;
  }

  .me-sm-0 {
    margin-right: 0 !important;
  }

  .me-sm-1 {
    margin-right: 0.25rem !important;
  }

  .me-sm-2 {
    margin-right: 0.5rem !important;
  }

  .me-sm-3 {
    margin-right: 0.75rem !important;
  }

  .me-sm-4 {
    margin-right: 1rem !important;
  }

  .me-sm-5 {
    margin-right: 1.25rem !important;
  }

  .me-sm-6 {
    margin-right: 1.5rem !important;
  }

  .me-sm-7 {
    margin-right: 1.75rem !important;
  }

  .me-sm-8 {
    margin-right: 2rem !important;
  }

  .me-sm-9 {
    margin-right: 2.25rem !important;
  }

  .me-sm-10 {
    margin-right: 2.5rem !important;
  }

  .me-sm-11 {
    margin-right: 2.75rem !important;
  }

  .me-sm-12 {
    margin-right: 3rem !important;
  }

  .me-sm-13 {
    margin-right: 3.25rem !important;
  }

  .me-sm-14 {
    margin-right: 3.5rem !important;
  }

  .me-sm-15 {
    margin-right: 3.75rem !important;
  }

  .me-sm-16 {
    margin-right: 4rem !important;
  }

  .me-sm-17 {
    margin-right: 4.25rem !important;
  }

  .me-sm-18 {
    margin-right: 4.5rem !important;
  }

  .me-sm-19 {
    margin-right: 4.75rem !important;
  }

  .me-sm-20 {
    margin-right: 5rem !important;
  }

  .me-sm-auto {
    margin-right: auto !important;
  }

  .mb-sm-0 {
    margin-bottom: 0 !important;
  }

  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-sm-3 {
    margin-bottom: 0.75rem !important;
  }

  .mb-sm-4 {
    margin-bottom: 1rem !important;
  }

  .mb-sm-5 {
    margin-bottom: 1.25rem !important;
  }

  .mb-sm-6 {
    margin-bottom: 1.5rem !important;
  }

  .mb-sm-7 {
    margin-bottom: 1.75rem !important;
  }

  .mb-sm-8 {
    margin-bottom: 2rem !important;
  }

  .mb-sm-9 {
    margin-bottom: 2.25rem !important;
  }

  .mb-sm-10 {
    margin-bottom: 2.5rem !important;
  }

  .mb-sm-11 {
    margin-bottom: 2.75rem !important;
  }

  .mb-sm-12 {
    margin-bottom: 3rem !important;
  }

  .mb-sm-13 {
    margin-bottom: 3.25rem !important;
  }

  .mb-sm-14 {
    margin-bottom: 3.5rem !important;
  }

  .mb-sm-15 {
    margin-bottom: 3.75rem !important;
  }

  .mb-sm-16 {
    margin-bottom: 4rem !important;
  }

  .mb-sm-17 {
    margin-bottom: 4.25rem !important;
  }

  .mb-sm-18 {
    margin-bottom: 4.5rem !important;
  }

  .mb-sm-19 {
    margin-bottom: 4.75rem !important;
  }

  .mb-sm-20 {
    margin-bottom: 5rem !important;
  }

  .mb-sm-auto {
    margin-bottom: auto !important;
  }

  .ms-sm-0 {
    margin-left: 0 !important;
  }

  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }

  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }

  .ms-sm-3 {
    margin-left: 0.75rem !important;
  }

  .ms-sm-4 {
    margin-left: 1rem !important;
  }

  .ms-sm-5 {
    margin-left: 1.25rem !important;
  }

  .ms-sm-6 {
    margin-left: 1.5rem !important;
  }

  .ms-sm-7 {
    margin-left: 1.75rem !important;
  }

  .ms-sm-8 {
    margin-left: 2rem !important;
  }

  .ms-sm-9 {
    margin-left: 2.25rem !important;
  }

  .ms-sm-10 {
    margin-left: 2.5rem !important;
  }

  .ms-sm-11 {
    margin-left: 2.75rem !important;
  }

  .ms-sm-12 {
    margin-left: 3rem !important;
  }

  .ms-sm-13 {
    margin-left: 3.25rem !important;
  }

  .ms-sm-14 {
    margin-left: 3.5rem !important;
  }

  .ms-sm-15 {
    margin-left: 3.75rem !important;
  }

  .ms-sm-16 {
    margin-left: 4rem !important;
  }

  .ms-sm-17 {
    margin-left: 4.25rem !important;
  }

  .ms-sm-18 {
    margin-left: 4.5rem !important;
  }

  .ms-sm-19 {
    margin-left: 4.75rem !important;
  }

  .ms-sm-20 {
    margin-left: 5rem !important;
  }

  .ms-sm-auto {
    margin-left: auto !important;
  }

  .m-sm-n1 {
    margin: -0.25rem !important;
  }

  .m-sm-n2 {
    margin: -0.5rem !important;
  }

  .m-sm-n3 {
    margin: -0.75rem !important;
  }

  .m-sm-n4 {
    margin: -1rem !important;
  }

  .m-sm-n5 {
    margin: -1.25rem !important;
  }

  .m-sm-n6 {
    margin: -1.5rem !important;
  }

  .m-sm-n7 {
    margin: -1.75rem !important;
  }

  .m-sm-n8 {
    margin: -2rem !important;
  }

  .m-sm-n9 {
    margin: -2.25rem !important;
  }

  .m-sm-n10 {
    margin: -2.5rem !important;
  }

  .m-sm-n11 {
    margin: -2.75rem !important;
  }

  .m-sm-n12 {
    margin: -3rem !important;
  }

  .m-sm-n13 {
    margin: -3.25rem !important;
  }

  .m-sm-n14 {
    margin: -3.5rem !important;
  }

  .m-sm-n15 {
    margin: -3.75rem !important;
  }

  .m-sm-n16 {
    margin: -4rem !important;
  }

  .m-sm-n17 {
    margin: -4.25rem !important;
  }

  .m-sm-n18 {
    margin: -4.5rem !important;
  }

  .m-sm-n19 {
    margin: -4.75rem !important;
  }

  .m-sm-n20 {
    margin: -5rem !important;
  }

  .mx-sm-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-sm-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-sm-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }

  .mx-sm-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-sm-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }

  .mx-sm-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-sm-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }

  .mx-sm-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }

  .mx-sm-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }

  .mx-sm-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }

  .mx-sm-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }

  .mx-sm-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .mx-sm-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }

  .mx-sm-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }

  .mx-sm-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }

  .mx-sm-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }

  .mx-sm-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }

  .mx-sm-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }

  .mx-sm-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }

  .mx-sm-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }

  .my-sm-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-sm-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-sm-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }

  .my-sm-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-sm-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }

  .my-sm-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-sm-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }

  .my-sm-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }

  .my-sm-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }

  .my-sm-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }

  .my-sm-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }

  .my-sm-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .my-sm-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }

  .my-sm-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }

  .my-sm-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }

  .my-sm-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }

  .my-sm-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }

  .my-sm-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }

  .my-sm-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }

  .my-sm-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }

  .mt-sm-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-sm-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-sm-n3 {
    margin-top: -0.75rem !important;
  }

  .mt-sm-n4 {
    margin-top: -1rem !important;
  }

  .mt-sm-n5 {
    margin-top: -1.25rem !important;
  }

  .mt-sm-n6 {
    margin-top: -1.5rem !important;
  }

  .mt-sm-n7 {
    margin-top: -1.75rem !important;
  }

  .mt-sm-n8 {
    margin-top: -2rem !important;
  }

  .mt-sm-n9 {
    margin-top: -2.25rem !important;
  }

  .mt-sm-n10 {
    margin-top: -2.5rem !important;
  }

  .mt-sm-n11 {
    margin-top: -2.75rem !important;
  }

  .mt-sm-n12 {
    margin-top: -3rem !important;
  }

  .mt-sm-n13 {
    margin-top: -3.25rem !important;
  }

  .mt-sm-n14 {
    margin-top: -3.5rem !important;
  }

  .mt-sm-n15 {
    margin-top: -3.75rem !important;
  }

  .mt-sm-n16 {
    margin-top: -4rem !important;
  }

  .mt-sm-n17 {
    margin-top: -4.25rem !important;
  }

  .mt-sm-n18 {
    margin-top: -4.5rem !important;
  }

  .mt-sm-n19 {
    margin-top: -4.75rem !important;
  }

  .mt-sm-n20 {
    margin-top: -5rem !important;
  }

  .me-sm-n1 {
    margin-right: -0.25rem !important;
  }

  .me-sm-n2 {
    margin-right: -0.5rem !important;
  }

  .me-sm-n3 {
    margin-right: -0.75rem !important;
  }

  .me-sm-n4 {
    margin-right: -1rem !important;
  }

  .me-sm-n5 {
    margin-right: -1.25rem !important;
  }

  .me-sm-n6 {
    margin-right: -1.5rem !important;
  }

  .me-sm-n7 {
    margin-right: -1.75rem !important;
  }

  .me-sm-n8 {
    margin-right: -2rem !important;
  }

  .me-sm-n9 {
    margin-right: -2.25rem !important;
  }

  .me-sm-n10 {
    margin-right: -2.5rem !important;
  }

  .me-sm-n11 {
    margin-right: -2.75rem !important;
  }

  .me-sm-n12 {
    margin-right: -3rem !important;
  }

  .me-sm-n13 {
    margin-right: -3.25rem !important;
  }

  .me-sm-n14 {
    margin-right: -3.5rem !important;
  }

  .me-sm-n15 {
    margin-right: -3.75rem !important;
  }

  .me-sm-n16 {
    margin-right: -4rem !important;
  }

  .me-sm-n17 {
    margin-right: -4.25rem !important;
  }

  .me-sm-n18 {
    margin-right: -4.5rem !important;
  }

  .me-sm-n19 {
    margin-right: -4.75rem !important;
  }

  .me-sm-n20 {
    margin-right: -5rem !important;
  }

  .mb-sm-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-sm-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-sm-n3 {
    margin-bottom: -0.75rem !important;
  }

  .mb-sm-n4 {
    margin-bottom: -1rem !important;
  }

  .mb-sm-n5 {
    margin-bottom: -1.25rem !important;
  }

  .mb-sm-n6 {
    margin-bottom: -1.5rem !important;
  }

  .mb-sm-n7 {
    margin-bottom: -1.75rem !important;
  }

  .mb-sm-n8 {
    margin-bottom: -2rem !important;
  }

  .mb-sm-n9 {
    margin-bottom: -2.25rem !important;
  }

  .mb-sm-n10 {
    margin-bottom: -2.5rem !important;
  }

  .mb-sm-n11 {
    margin-bottom: -2.75rem !important;
  }

  .mb-sm-n12 {
    margin-bottom: -3rem !important;
  }

  .mb-sm-n13 {
    margin-bottom: -3.25rem !important;
  }

  .mb-sm-n14 {
    margin-bottom: -3.5rem !important;
  }

  .mb-sm-n15 {
    margin-bottom: -3.75rem !important;
  }

  .mb-sm-n16 {
    margin-bottom: -4rem !important;
  }

  .mb-sm-n17 {
    margin-bottom: -4.25rem !important;
  }

  .mb-sm-n18 {
    margin-bottom: -4.5rem !important;
  }

  .mb-sm-n19 {
    margin-bottom: -4.75rem !important;
  }

  .mb-sm-n20 {
    margin-bottom: -5rem !important;
  }

  .ms-sm-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-sm-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-sm-n3 {
    margin-left: -0.75rem !important;
  }

  .ms-sm-n4 {
    margin-left: -1rem !important;
  }

  .ms-sm-n5 {
    margin-left: -1.25rem !important;
  }

  .ms-sm-n6 {
    margin-left: -1.5rem !important;
  }

  .ms-sm-n7 {
    margin-left: -1.75rem !important;
  }

  .ms-sm-n8 {
    margin-left: -2rem !important;
  }

  .ms-sm-n9 {
    margin-left: -2.25rem !important;
  }

  .ms-sm-n10 {
    margin-left: -2.5rem !important;
  }

  .ms-sm-n11 {
    margin-left: -2.75rem !important;
  }

  .ms-sm-n12 {
    margin-left: -3rem !important;
  }

  .ms-sm-n13 {
    margin-left: -3.25rem !important;
  }

  .ms-sm-n14 {
    margin-left: -3.5rem !important;
  }

  .ms-sm-n15 {
    margin-left: -3.75rem !important;
  }

  .ms-sm-n16 {
    margin-left: -4rem !important;
  }

  .ms-sm-n17 {
    margin-left: -4.25rem !important;
  }

  .ms-sm-n18 {
    margin-left: -4.5rem !important;
  }

  .ms-sm-n19 {
    margin-left: -4.75rem !important;
  }

  .ms-sm-n20 {
    margin-left: -5rem !important;
  }

  .p-sm-0 {
    padding: 0 !important;
  }

  .p-sm-1 {
    padding: 0.25rem !important;
  }

  .p-sm-2 {
    padding: 0.5rem !important;
  }

  .p-sm-3 {
    padding: 0.75rem !important;
  }

  .p-sm-4 {
    padding: 1rem !important;
  }

  .p-sm-5 {
    padding: 1.25rem !important;
  }

  .p-sm-6 {
    padding: 1.5rem !important;
  }

  .p-sm-7 {
    padding: 1.75rem !important;
  }

  .p-sm-8 {
    padding: 2rem !important;
  }

  .p-sm-9 {
    padding: 2.25rem !important;
  }

  .p-sm-10 {
    padding: 2.5rem !important;
  }

  .p-sm-11 {
    padding: 2.75rem !important;
  }

  .p-sm-12 {
    padding: 3rem !important;
  }

  .p-sm-13 {
    padding: 3.25rem !important;
  }

  .p-sm-14 {
    padding: 3.5rem !important;
  }

  .p-sm-15 {
    padding: 3.75rem !important;
  }

  .p-sm-16 {
    padding: 4rem !important;
  }

  .p-sm-17 {
    padding: 4.25rem !important;
  }

  .p-sm-18 {
    padding: 4.5rem !important;
  }

  .p-sm-19 {
    padding: 4.75rem !important;
  }

  .p-sm-20 {
    padding: 5rem !important;
  }

  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-sm-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }

  .px-sm-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-sm-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }

  .px-sm-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-sm-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }

  .px-sm-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }

  .px-sm-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }

  .px-sm-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }

  .px-sm-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }

  .px-sm-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .px-sm-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }

  .px-sm-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }

  .px-sm-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }

  .px-sm-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  .px-sm-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }

  .px-sm-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }

  .px-sm-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }

  .px-sm-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-sm-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  .py-sm-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-sm-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }

  .py-sm-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-sm-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }

  .py-sm-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .py-sm-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }

  .py-sm-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  .py-sm-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }

  .py-sm-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .py-sm-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }

  .py-sm-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-sm-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }

  .py-sm-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-sm-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }

  .py-sm-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-sm-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }

  .py-sm-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .pt-sm-0 {
    padding-top: 0 !important;
  }

  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }

  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }

  .pt-sm-3 {
    padding-top: 0.75rem !important;
  }

  .pt-sm-4 {
    padding-top: 1rem !important;
  }

  .pt-sm-5 {
    padding-top: 1.25rem !important;
  }

  .pt-sm-6 {
    padding-top: 1.5rem !important;
  }

  .pt-sm-7 {
    padding-top: 1.75rem !important;
  }

  .pt-sm-8 {
    padding-top: 2rem !important;
  }

  .pt-sm-9 {
    padding-top: 2.25rem !important;
  }

  .pt-sm-10 {
    padding-top: 2.5rem !important;
  }

  .pt-sm-11 {
    padding-top: 2.75rem !important;
  }

  .pt-sm-12 {
    padding-top: 3rem !important;
  }

  .pt-sm-13 {
    padding-top: 3.25rem !important;
  }

  .pt-sm-14 {
    padding-top: 3.5rem !important;
  }

  .pt-sm-15 {
    padding-top: 3.75rem !important;
  }

  .pt-sm-16 {
    padding-top: 4rem !important;
  }

  .pt-sm-17 {
    padding-top: 4.25rem !important;
  }

  .pt-sm-18 {
    padding-top: 4.5rem !important;
  }

  .pt-sm-19 {
    padding-top: 4.75rem !important;
  }

  .pt-sm-20 {
    padding-top: 5rem !important;
  }

  .pe-sm-0 {
    padding-right: 0 !important;
  }

  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }

  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }

  .pe-sm-3 {
    padding-right: 0.75rem !important;
  }

  .pe-sm-4 {
    padding-right: 1rem !important;
  }

  .pe-sm-5 {
    padding-right: 1.25rem !important;
  }

  .pe-sm-6 {
    padding-right: 1.5rem !important;
  }

  .pe-sm-7 {
    padding-right: 1.75rem !important;
  }

  .pe-sm-8 {
    padding-right: 2rem !important;
  }

  .pe-sm-9 {
    padding-right: 2.25rem !important;
  }

  .pe-sm-10 {
    padding-right: 2.5rem !important;
  }

  .pe-sm-11 {
    padding-right: 2.75rem !important;
  }

  .pe-sm-12 {
    padding-right: 3rem !important;
  }

  .pe-sm-13 {
    padding-right: 3.25rem !important;
  }

  .pe-sm-14 {
    padding-right: 3.5rem !important;
  }

  .pe-sm-15 {
    padding-right: 3.75rem !important;
  }

  .pe-sm-16 {
    padding-right: 4rem !important;
  }

  .pe-sm-17 {
    padding-right: 4.25rem !important;
  }

  .pe-sm-18 {
    padding-right: 4.5rem !important;
  }

  .pe-sm-19 {
    padding-right: 4.75rem !important;
  }

  .pe-sm-20 {
    padding-right: 5rem !important;
  }

  .pb-sm-0 {
    padding-bottom: 0 !important;
  }

  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-sm-3 {
    padding-bottom: 0.75rem !important;
  }

  .pb-sm-4 {
    padding-bottom: 1rem !important;
  }

  .pb-sm-5 {
    padding-bottom: 1.25rem !important;
  }

  .pb-sm-6 {
    padding-bottom: 1.5rem !important;
  }

  .pb-sm-7 {
    padding-bottom: 1.75rem !important;
  }

  .pb-sm-8 {
    padding-bottom: 2rem !important;
  }

  .pb-sm-9 {
    padding-bottom: 2.25rem !important;
  }

  .pb-sm-10 {
    padding-bottom: 2.5rem !important;
  }

  .pb-sm-11 {
    padding-bottom: 2.75rem !important;
  }

  .pb-sm-12 {
    padding-bottom: 3rem !important;
  }

  .pb-sm-13 {
    padding-bottom: 3.25rem !important;
  }

  .pb-sm-14 {
    padding-bottom: 3.5rem !important;
  }

  .pb-sm-15 {
    padding-bottom: 3.75rem !important;
  }

  .pb-sm-16 {
    padding-bottom: 4rem !important;
  }

  .pb-sm-17 {
    padding-bottom: 4.25rem !important;
  }

  .pb-sm-18 {
    padding-bottom: 4.5rem !important;
  }

  .pb-sm-19 {
    padding-bottom: 4.75rem !important;
  }

  .pb-sm-20 {
    padding-bottom: 5rem !important;
  }

  .ps-sm-0 {
    padding-left: 0 !important;
  }

  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }

  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }

  .ps-sm-3 {
    padding-left: 0.75rem !important;
  }

  .ps-sm-4 {
    padding-left: 1rem !important;
  }

  .ps-sm-5 {
    padding-left: 1.25rem !important;
  }

  .ps-sm-6 {
    padding-left: 1.5rem !important;
  }

  .ps-sm-7 {
    padding-left: 1.75rem !important;
  }

  .ps-sm-8 {
    padding-left: 2rem !important;
  }

  .ps-sm-9 {
    padding-left: 2.25rem !important;
  }

  .ps-sm-10 {
    padding-left: 2.5rem !important;
  }

  .ps-sm-11 {
    padding-left: 2.75rem !important;
  }

  .ps-sm-12 {
    padding-left: 3rem !important;
  }

  .ps-sm-13 {
    padding-left: 3.25rem !important;
  }

  .ps-sm-14 {
    padding-left: 3.5rem !important;
  }

  .ps-sm-15 {
    padding-left: 3.75rem !important;
  }

  .ps-sm-16 {
    padding-left: 4rem !important;
  }

  .ps-sm-17 {
    padding-left: 4.25rem !important;
  }

  .ps-sm-18 {
    padding-left: 4.5rem !important;
  }

  .ps-sm-19 {
    padding-left: 4.75rem !important;
  }

  .ps-sm-20 {
    padding-left: 5rem !important;
  }

  .gap-sm-0 {
    gap: 0 !important;
  }

  .gap-sm-1 {
    gap: 0.25rem !important;
  }

  .gap-sm-2 {
    gap: 0.5rem !important;
  }

  .gap-sm-3 {
    gap: 0.75rem !important;
  }

  .gap-sm-4 {
    gap: 1rem !important;
  }

  .gap-sm-5 {
    gap: 1.25rem !important;
  }

  .gap-sm-6 {
    gap: 1.5rem !important;
  }

  .gap-sm-7 {
    gap: 1.75rem !important;
  }

  .gap-sm-8 {
    gap: 2rem !important;
  }

  .gap-sm-9 {
    gap: 2.25rem !important;
  }

  .gap-sm-10 {
    gap: 2.5rem !important;
  }

  .gap-sm-11 {
    gap: 2.75rem !important;
  }

  .gap-sm-12 {
    gap: 3rem !important;
  }

  .gap-sm-13 {
    gap: 3.25rem !important;
  }

  .gap-sm-14 {
    gap: 3.5rem !important;
  }

  .gap-sm-15 {
    gap: 3.75rem !important;
  }

  .gap-sm-16 {
    gap: 4rem !important;
  }

  .gap-sm-17 {
    gap: 4.25rem !important;
  }

  .gap-sm-18 {
    gap: 4.5rem !important;
  }

  .gap-sm-19 {
    gap: 4.75rem !important;
  }

  .gap-sm-20 {
    gap: 5rem !important;
  }

  .row-gap-sm-0 {
    row-gap: 0 !important;
  }

  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-sm-3 {
    row-gap: 0.75rem !important;
  }

  .row-gap-sm-4 {
    row-gap: 1rem !important;
  }

  .row-gap-sm-5 {
    row-gap: 1.25rem !important;
  }

  .row-gap-sm-6 {
    row-gap: 1.5rem !important;
  }

  .row-gap-sm-7 {
    row-gap: 1.75rem !important;
  }

  .row-gap-sm-8 {
    row-gap: 2rem !important;
  }

  .row-gap-sm-9 {
    row-gap: 2.25rem !important;
  }

  .row-gap-sm-10 {
    row-gap: 2.5rem !important;
  }

  .row-gap-sm-11 {
    row-gap: 2.75rem !important;
  }

  .row-gap-sm-12 {
    row-gap: 3rem !important;
  }

  .row-gap-sm-13 {
    row-gap: 3.25rem !important;
  }

  .row-gap-sm-14 {
    row-gap: 3.5rem !important;
  }

  .row-gap-sm-15 {
    row-gap: 3.75rem !important;
  }

  .row-gap-sm-16 {
    row-gap: 4rem !important;
  }

  .row-gap-sm-17 {
    row-gap: 4.25rem !important;
  }

  .row-gap-sm-18 {
    row-gap: 4.5rem !important;
  }

  .row-gap-sm-19 {
    row-gap: 4.75rem !important;
  }

  .row-gap-sm-20 {
    row-gap: 5rem !important;
  }

  .column-gap-sm-0 {
    column-gap: 0 !important;
  }

  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-sm-3 {
    column-gap: 0.75rem !important;
  }

  .column-gap-sm-4 {
    column-gap: 1rem !important;
  }

  .column-gap-sm-5 {
    column-gap: 1.25rem !important;
  }

  .column-gap-sm-6 {
    column-gap: 1.5rem !important;
  }

  .column-gap-sm-7 {
    column-gap: 1.75rem !important;
  }

  .column-gap-sm-8 {
    column-gap: 2rem !important;
  }

  .column-gap-sm-9 {
    column-gap: 2.25rem !important;
  }

  .column-gap-sm-10 {
    column-gap: 2.5rem !important;
  }

  .column-gap-sm-11 {
    column-gap: 2.75rem !important;
  }

  .column-gap-sm-12 {
    column-gap: 3rem !important;
  }

  .column-gap-sm-13 {
    column-gap: 3.25rem !important;
  }

  .column-gap-sm-14 {
    column-gap: 3.5rem !important;
  }

  .column-gap-sm-15 {
    column-gap: 3.75rem !important;
  }

  .column-gap-sm-16 {
    column-gap: 4rem !important;
  }

  .column-gap-sm-17 {
    column-gap: 4.25rem !important;
  }

  .column-gap-sm-18 {
    column-gap: 4.5rem !important;
  }

  .column-gap-sm-19 {
    column-gap: 4.75rem !important;
  }

  .column-gap-sm-20 {
    column-gap: 5rem !important;
  }

  .text-sm-start {
    text-align: left !important;
  }

  .text-sm-end {
    text-align: right !important;
  }

  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }

  .float-md-end {
    float: right !important;
  }

  .float-md-none {
    float: none !important;
  }

  .object-fit-md-contain {
    object-fit: contain !important;
  }

  .object-fit-md-cover {
    object-fit: cover !important;
  }

  .object-fit-md-fill {
    object-fit: fill !important;
  }

  .object-fit-md-scale {
    object-fit: scale-down !important;
  }

  .object-fit-md-none {
    object-fit: none !important;
  }

  .d-md-inline {
    display: inline !important;
  }

  .d-md-inline-block {
    display: inline-block !important;
  }

  .d-md-block {
    display: block !important;
  }

  .d-md-grid {
    display: grid !important;
  }

  .d-md-inline-grid {
    display: inline-grid !important;
  }

  .d-md-table {
    display: table !important;
  }

  .d-md-table-row {
    display: table-row !important;
  }

  .d-md-table-cell {
    display: table-cell !important;
  }

  .d-md-flex {
    display: flex !important;
  }

  .d-md-inline-flex {
    display: inline-flex !important;
  }

  .d-md-none {
    display: none !important;
  }

  .flex-md-fill {
    flex: 1 1 auto !important;
  }

  .flex-md-row {
    flex-direction: row !important;
  }

  .flex-md-column {
    flex-direction: column !important;
  }

  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-md-wrap {
    flex-wrap: wrap !important;
  }

  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-md-start {
    justify-content: flex-start !important;
  }

  .justify-content-md-end {
    justify-content: flex-end !important;
  }

  .justify-content-md-center {
    justify-content: center !important;
  }

  .justify-content-md-between {
    justify-content: space-between !important;
  }

  .justify-content-md-around {
    justify-content: space-around !important;
  }

  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-md-start {
    align-items: flex-start !important;
  }

  .align-items-md-end {
    align-items: flex-end !important;
  }

  .align-items-md-center {
    align-items: center !important;
  }

  .align-items-md-baseline {
    align-items: baseline !important;
  }

  .align-items-md-stretch {
    align-items: stretch !important;
  }

  .align-content-md-start {
    align-content: flex-start !important;
  }

  .align-content-md-end {
    align-content: flex-end !important;
  }

  .align-content-md-center {
    align-content: center !important;
  }

  .align-content-md-between {
    align-content: space-between !important;
  }

  .align-content-md-around {
    align-content: space-around !important;
  }

  .align-content-md-stretch {
    align-content: stretch !important;
  }

  .align-self-md-auto {
    align-self: auto !important;
  }

  .align-self-md-start {
    align-self: flex-start !important;
  }

  .align-self-md-end {
    align-self: flex-end !important;
  }

  .align-self-md-center {
    align-self: center !important;
  }

  .align-self-md-baseline {
    align-self: baseline !important;
  }

  .align-self-md-stretch {
    align-self: stretch !important;
  }

  .order-md-first {
    order: -1 !important;
  }

  .order-md-0 {
    order: 0 !important;
  }

  .order-md-1 {
    order: 1 !important;
  }

  .order-md-2 {
    order: 2 !important;
  }

  .order-md-3 {
    order: 3 !important;
  }

  .order-md-4 {
    order: 4 !important;
  }

  .order-md-5 {
    order: 5 !important;
  }

  .order-md-last {
    order: 6 !important;
  }

  .m-md-0 {
    margin: 0 !important;
  }

  .m-md-1 {
    margin: 0.25rem !important;
  }

  .m-md-2 {
    margin: 0.5rem !important;
  }

  .m-md-3 {
    margin: 0.75rem !important;
  }

  .m-md-4 {
    margin: 1rem !important;
  }

  .m-md-5 {
    margin: 1.25rem !important;
  }

  .m-md-6 {
    margin: 1.5rem !important;
  }

  .m-md-7 {
    margin: 1.75rem !important;
  }

  .m-md-8 {
    margin: 2rem !important;
  }

  .m-md-9 {
    margin: 2.25rem !important;
  }

  .m-md-10 {
    margin: 2.5rem !important;
  }

  .m-md-11 {
    margin: 2.75rem !important;
  }

  .m-md-12 {
    margin: 3rem !important;
  }

  .m-md-13 {
    margin: 3.25rem !important;
  }

  .m-md-14 {
    margin: 3.5rem !important;
  }

  .m-md-15 {
    margin: 3.75rem !important;
  }

  .m-md-16 {
    margin: 4rem !important;
  }

  .m-md-17 {
    margin: 4.25rem !important;
  }

  .m-md-18 {
    margin: 4.5rem !important;
  }

  .m-md-19 {
    margin: 4.75rem !important;
  }

  .m-md-20 {
    margin: 5rem !important;
  }

  .m-md-auto {
    margin: auto !important;
  }

  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-md-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }

  .mx-md-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-md-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }

  .mx-md-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-md-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }

  .mx-md-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }

  .mx-md-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }

  .mx-md-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }

  .mx-md-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }

  .mx-md-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-md-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }

  .mx-md-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }

  .mx-md-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }

  .mx-md-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  .mx-md-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }

  .mx-md-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }

  .mx-md-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }

  .mx-md-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-md-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }

  .my-md-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-md-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }

  .my-md-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-md-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }

  .my-md-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  .my-md-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }

  .my-md-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  .my-md-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }

  .my-md-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-md-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }

  .my-md-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-md-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }

  .my-md-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-md-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }

  .my-md-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-md-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }

  .my-md-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-md-0 {
    margin-top: 0 !important;
  }

  .mt-md-1 {
    margin-top: 0.25rem !important;
  }

  .mt-md-2 {
    margin-top: 0.5rem !important;
  }

  .mt-md-3 {
    margin-top: 0.75rem !important;
  }

  .mt-md-4 {
    margin-top: 1rem !important;
  }

  .mt-md-5 {
    margin-top: 1.25rem !important;
  }

  .mt-md-6 {
    margin-top: 1.5rem !important;
  }

  .mt-md-7 {
    margin-top: 1.75rem !important;
  }

  .mt-md-8 {
    margin-top: 2rem !important;
  }

  .mt-md-9 {
    margin-top: 2.25rem !important;
  }

  .mt-md-10 {
    margin-top: 2.5rem !important;
  }

  .mt-md-11 {
    margin-top: 2.75rem !important;
  }

  .mt-md-12 {
    margin-top: 3rem !important;
  }

  .mt-md-13 {
    margin-top: 3.25rem !important;
  }

  .mt-md-14 {
    margin-top: 3.5rem !important;
  }

  .mt-md-15 {
    margin-top: 3.75rem !important;
  }

  .mt-md-16 {
    margin-top: 4rem !important;
  }

  .mt-md-17 {
    margin-top: 4.25rem !important;
  }

  .mt-md-18 {
    margin-top: 4.5rem !important;
  }

  .mt-md-19 {
    margin-top: 4.75rem !important;
  }

  .mt-md-20 {
    margin-top: 5rem !important;
  }

  .mt-md-auto {
    margin-top: auto !important;
  }

  .me-md-0 {
    margin-right: 0 !important;
  }

  .me-md-1 {
    margin-right: 0.25rem !important;
  }

  .me-md-2 {
    margin-right: 0.5rem !important;
  }

  .me-md-3 {
    margin-right: 0.75rem !important;
  }

  .me-md-4 {
    margin-right: 1rem !important;
  }

  .me-md-5 {
    margin-right: 1.25rem !important;
  }

  .me-md-6 {
    margin-right: 1.5rem !important;
  }

  .me-md-7 {
    margin-right: 1.75rem !important;
  }

  .me-md-8 {
    margin-right: 2rem !important;
  }

  .me-md-9 {
    margin-right: 2.25rem !important;
  }

  .me-md-10 {
    margin-right: 2.5rem !important;
  }

  .me-md-11 {
    margin-right: 2.75rem !important;
  }

  .me-md-12 {
    margin-right: 3rem !important;
  }

  .me-md-13 {
    margin-right: 3.25rem !important;
  }

  .me-md-14 {
    margin-right: 3.5rem !important;
  }

  .me-md-15 {
    margin-right: 3.75rem !important;
  }

  .me-md-16 {
    margin-right: 4rem !important;
  }

  .me-md-17 {
    margin-right: 4.25rem !important;
  }

  .me-md-18 {
    margin-right: 4.5rem !important;
  }

  .me-md-19 {
    margin-right: 4.75rem !important;
  }

  .me-md-20 {
    margin-right: 5rem !important;
  }

  .me-md-auto {
    margin-right: auto !important;
  }

  .mb-md-0 {
    margin-bottom: 0 !important;
  }

  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-md-3 {
    margin-bottom: 0.75rem !important;
  }

  .mb-md-4 {
    margin-bottom: 1rem !important;
  }

  .mb-md-5 {
    margin-bottom: 1.25rem !important;
  }

  .mb-md-6 {
    margin-bottom: 1.5rem !important;
  }

  .mb-md-7 {
    margin-bottom: 1.75rem !important;
  }

  .mb-md-8 {
    margin-bottom: 2rem !important;
  }

  .mb-md-9 {
    margin-bottom: 2.25rem !important;
  }

  .mb-md-10 {
    margin-bottom: 2.5rem !important;
  }

  .mb-md-11 {
    margin-bottom: 2.75rem !important;
  }

  .mb-md-12 {
    margin-bottom: 3rem !important;
  }

  .mb-md-13 {
    margin-bottom: 3.25rem !important;
  }

  .mb-md-14 {
    margin-bottom: 3.5rem !important;
  }

  .mb-md-15 {
    margin-bottom: 3.75rem !important;
  }

  .mb-md-16 {
    margin-bottom: 4rem !important;
  }

  .mb-md-17 {
    margin-bottom: 4.25rem !important;
  }

  .mb-md-18 {
    margin-bottom: 4.5rem !important;
  }

  .mb-md-19 {
    margin-bottom: 4.75rem !important;
  }

  .mb-md-20 {
    margin-bottom: 5rem !important;
  }

  .mb-md-auto {
    margin-bottom: auto !important;
  }

  .ms-md-0 {
    margin-left: 0 !important;
  }

  .ms-md-1 {
    margin-left: 0.25rem !important;
  }

  .ms-md-2 {
    margin-left: 0.5rem !important;
  }

  .ms-md-3 {
    margin-left: 0.75rem !important;
  }

  .ms-md-4 {
    margin-left: 1rem !important;
  }

  .ms-md-5 {
    margin-left: 1.25rem !important;
  }

  .ms-md-6 {
    margin-left: 1.5rem !important;
  }

  .ms-md-7 {
    margin-left: 1.75rem !important;
  }

  .ms-md-8 {
    margin-left: 2rem !important;
  }

  .ms-md-9 {
    margin-left: 2.25rem !important;
  }

  .ms-md-10 {
    margin-left: 2.5rem !important;
  }

  .ms-md-11 {
    margin-left: 2.75rem !important;
  }

  .ms-md-12 {
    margin-left: 3rem !important;
  }

  .ms-md-13 {
    margin-left: 3.25rem !important;
  }

  .ms-md-14 {
    margin-left: 3.5rem !important;
  }

  .ms-md-15 {
    margin-left: 3.75rem !important;
  }

  .ms-md-16 {
    margin-left: 4rem !important;
  }

  .ms-md-17 {
    margin-left: 4.25rem !important;
  }

  .ms-md-18 {
    margin-left: 4.5rem !important;
  }

  .ms-md-19 {
    margin-left: 4.75rem !important;
  }

  .ms-md-20 {
    margin-left: 5rem !important;
  }

  .ms-md-auto {
    margin-left: auto !important;
  }

  .m-md-n1 {
    margin: -0.25rem !important;
  }

  .m-md-n2 {
    margin: -0.5rem !important;
  }

  .m-md-n3 {
    margin: -0.75rem !important;
  }

  .m-md-n4 {
    margin: -1rem !important;
  }

  .m-md-n5 {
    margin: -1.25rem !important;
  }

  .m-md-n6 {
    margin: -1.5rem !important;
  }

  .m-md-n7 {
    margin: -1.75rem !important;
  }

  .m-md-n8 {
    margin: -2rem !important;
  }

  .m-md-n9 {
    margin: -2.25rem !important;
  }

  .m-md-n10 {
    margin: -2.5rem !important;
  }

  .m-md-n11 {
    margin: -2.75rem !important;
  }

  .m-md-n12 {
    margin: -3rem !important;
  }

  .m-md-n13 {
    margin: -3.25rem !important;
  }

  .m-md-n14 {
    margin: -3.5rem !important;
  }

  .m-md-n15 {
    margin: -3.75rem !important;
  }

  .m-md-n16 {
    margin: -4rem !important;
  }

  .m-md-n17 {
    margin: -4.25rem !important;
  }

  .m-md-n18 {
    margin: -4.5rem !important;
  }

  .m-md-n19 {
    margin: -4.75rem !important;
  }

  .m-md-n20 {
    margin: -5rem !important;
  }

  .mx-md-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-md-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-md-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }

  .mx-md-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-md-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }

  .mx-md-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-md-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }

  .mx-md-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }

  .mx-md-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }

  .mx-md-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }

  .mx-md-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }

  .mx-md-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .mx-md-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }

  .mx-md-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }

  .mx-md-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }

  .mx-md-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }

  .mx-md-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }

  .mx-md-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }

  .mx-md-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }

  .mx-md-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }

  .my-md-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-md-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-md-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }

  .my-md-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-md-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }

  .my-md-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-md-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }

  .my-md-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }

  .my-md-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }

  .my-md-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }

  .my-md-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }

  .my-md-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .my-md-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }

  .my-md-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }

  .my-md-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }

  .my-md-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }

  .my-md-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }

  .my-md-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }

  .my-md-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }

  .my-md-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }

  .mt-md-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-md-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-md-n3 {
    margin-top: -0.75rem !important;
  }

  .mt-md-n4 {
    margin-top: -1rem !important;
  }

  .mt-md-n5 {
    margin-top: -1.25rem !important;
  }

  .mt-md-n6 {
    margin-top: -1.5rem !important;
  }

  .mt-md-n7 {
    margin-top: -1.75rem !important;
  }

  .mt-md-n8 {
    margin-top: -2rem !important;
  }

  .mt-md-n9 {
    margin-top: -2.25rem !important;
  }

  .mt-md-n10 {
    margin-top: -2.5rem !important;
  }

  .mt-md-n11 {
    margin-top: -2.75rem !important;
  }

  .mt-md-n12 {
    margin-top: -3rem !important;
  }

  .mt-md-n13 {
    margin-top: -3.25rem !important;
  }

  .mt-md-n14 {
    margin-top: -3.5rem !important;
  }

  .mt-md-n15 {
    margin-top: -3.75rem !important;
  }

  .mt-md-n16 {
    margin-top: -4rem !important;
  }

  .mt-md-n17 {
    margin-top: -4.25rem !important;
  }

  .mt-md-n18 {
    margin-top: -4.5rem !important;
  }

  .mt-md-n19 {
    margin-top: -4.75rem !important;
  }

  .mt-md-n20 {
    margin-top: -5rem !important;
  }

  .me-md-n1 {
    margin-right: -0.25rem !important;
  }

  .me-md-n2 {
    margin-right: -0.5rem !important;
  }

  .me-md-n3 {
    margin-right: -0.75rem !important;
  }

  .me-md-n4 {
    margin-right: -1rem !important;
  }

  .me-md-n5 {
    margin-right: -1.25rem !important;
  }

  .me-md-n6 {
    margin-right: -1.5rem !important;
  }

  .me-md-n7 {
    margin-right: -1.75rem !important;
  }

  .me-md-n8 {
    margin-right: -2rem !important;
  }

  .me-md-n9 {
    margin-right: -2.25rem !important;
  }

  .me-md-n10 {
    margin-right: -2.5rem !important;
  }

  .me-md-n11 {
    margin-right: -2.75rem !important;
  }

  .me-md-n12 {
    margin-right: -3rem !important;
  }

  .me-md-n13 {
    margin-right: -3.25rem !important;
  }

  .me-md-n14 {
    margin-right: -3.5rem !important;
  }

  .me-md-n15 {
    margin-right: -3.75rem !important;
  }

  .me-md-n16 {
    margin-right: -4rem !important;
  }

  .me-md-n17 {
    margin-right: -4.25rem !important;
  }

  .me-md-n18 {
    margin-right: -4.5rem !important;
  }

  .me-md-n19 {
    margin-right: -4.75rem !important;
  }

  .me-md-n20 {
    margin-right: -5rem !important;
  }

  .mb-md-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-md-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-md-n3 {
    margin-bottom: -0.75rem !important;
  }

  .mb-md-n4 {
    margin-bottom: -1rem !important;
  }

  .mb-md-n5 {
    margin-bottom: -1.25rem !important;
  }

  .mb-md-n6 {
    margin-bottom: -1.5rem !important;
  }

  .mb-md-n7 {
    margin-bottom: -1.75rem !important;
  }

  .mb-md-n8 {
    margin-bottom: -2rem !important;
  }

  .mb-md-n9 {
    margin-bottom: -2.25rem !important;
  }

  .mb-md-n10 {
    margin-bottom: -2.5rem !important;
  }

  .mb-md-n11 {
    margin-bottom: -2.75rem !important;
  }

  .mb-md-n12 {
    margin-bottom: -3rem !important;
  }

  .mb-md-n13 {
    margin-bottom: -3.25rem !important;
  }

  .mb-md-n14 {
    margin-bottom: -3.5rem !important;
  }

  .mb-md-n15 {
    margin-bottom: -3.75rem !important;
  }

  .mb-md-n16 {
    margin-bottom: -4rem !important;
  }

  .mb-md-n17 {
    margin-bottom: -4.25rem !important;
  }

  .mb-md-n18 {
    margin-bottom: -4.5rem !important;
  }

  .mb-md-n19 {
    margin-bottom: -4.75rem !important;
  }

  .mb-md-n20 {
    margin-bottom: -5rem !important;
  }

  .ms-md-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-md-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-md-n3 {
    margin-left: -0.75rem !important;
  }

  .ms-md-n4 {
    margin-left: -1rem !important;
  }

  .ms-md-n5 {
    margin-left: -1.25rem !important;
  }

  .ms-md-n6 {
    margin-left: -1.5rem !important;
  }

  .ms-md-n7 {
    margin-left: -1.75rem !important;
  }

  .ms-md-n8 {
    margin-left: -2rem !important;
  }

  .ms-md-n9 {
    margin-left: -2.25rem !important;
  }

  .ms-md-n10 {
    margin-left: -2.5rem !important;
  }

  .ms-md-n11 {
    margin-left: -2.75rem !important;
  }

  .ms-md-n12 {
    margin-left: -3rem !important;
  }

  .ms-md-n13 {
    margin-left: -3.25rem !important;
  }

  .ms-md-n14 {
    margin-left: -3.5rem !important;
  }

  .ms-md-n15 {
    margin-left: -3.75rem !important;
  }

  .ms-md-n16 {
    margin-left: -4rem !important;
  }

  .ms-md-n17 {
    margin-left: -4.25rem !important;
  }

  .ms-md-n18 {
    margin-left: -4.5rem !important;
  }

  .ms-md-n19 {
    margin-left: -4.75rem !important;
  }

  .ms-md-n20 {
    margin-left: -5rem !important;
  }

  .p-md-0 {
    padding: 0 !important;
  }

  .p-md-1 {
    padding: 0.25rem !important;
  }

  .p-md-2 {
    padding: 0.5rem !important;
  }

  .p-md-3 {
    padding: 0.75rem !important;
  }

  .p-md-4 {
    padding: 1rem !important;
  }

  .p-md-5 {
    padding: 1.25rem !important;
  }

  .p-md-6 {
    padding: 1.5rem !important;
  }

  .p-md-7 {
    padding: 1.75rem !important;
  }

  .p-md-8 {
    padding: 2rem !important;
  }

  .p-md-9 {
    padding: 2.25rem !important;
  }

  .p-md-10 {
    padding: 2.5rem !important;
  }

  .p-md-11 {
    padding: 2.75rem !important;
  }

  .p-md-12 {
    padding: 3rem !important;
  }

  .p-md-13 {
    padding: 3.25rem !important;
  }

  .p-md-14 {
    padding: 3.5rem !important;
  }

  .p-md-15 {
    padding: 3.75rem !important;
  }

  .p-md-16 {
    padding: 4rem !important;
  }

  .p-md-17 {
    padding: 4.25rem !important;
  }

  .p-md-18 {
    padding: 4.5rem !important;
  }

  .p-md-19 {
    padding: 4.75rem !important;
  }

  .p-md-20 {
    padding: 5rem !important;
  }

  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-md-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }

  .px-md-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-md-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }

  .px-md-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-md-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }

  .px-md-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }

  .px-md-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }

  .px-md-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }

  .px-md-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }

  .px-md-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .px-md-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }

  .px-md-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }

  .px-md-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }

  .px-md-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  .px-md-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }

  .px-md-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }

  .px-md-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }

  .px-md-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-md-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  .py-md-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-md-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }

  .py-md-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-md-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }

  .py-md-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .py-md-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }

  .py-md-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  .py-md-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }

  .py-md-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .py-md-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }

  .py-md-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-md-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }

  .py-md-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-md-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }

  .py-md-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-md-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }

  .py-md-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .pt-md-0 {
    padding-top: 0 !important;
  }

  .pt-md-1 {
    padding-top: 0.25rem !important;
  }

  .pt-md-2 {
    padding-top: 0.5rem !important;
  }

  .pt-md-3 {
    padding-top: 0.75rem !important;
  }

  .pt-md-4 {
    padding-top: 1rem !important;
  }

  .pt-md-5 {
    padding-top: 1.25rem !important;
  }

  .pt-md-6 {
    padding-top: 1.5rem !important;
  }

  .pt-md-7 {
    padding-top: 1.75rem !important;
  }

  .pt-md-8 {
    padding-top: 2rem !important;
  }

  .pt-md-9 {
    padding-top: 2.25rem !important;
  }

  .pt-md-10 {
    padding-top: 2.5rem !important;
  }

  .pt-md-11 {
    padding-top: 2.75rem !important;
  }

  .pt-md-12 {
    padding-top: 3rem !important;
  }

  .pt-md-13 {
    padding-top: 3.25rem !important;
  }

  .pt-md-14 {
    padding-top: 3.5rem !important;
  }

  .pt-md-15 {
    padding-top: 3.75rem !important;
  }

  .pt-md-16 {
    padding-top: 4rem !important;
  }

  .pt-md-17 {
    padding-top: 4.25rem !important;
  }

  .pt-md-18 {
    padding-top: 4.5rem !important;
  }

  .pt-md-19 {
    padding-top: 4.75rem !important;
  }

  .pt-md-20 {
    padding-top: 5rem !important;
  }

  .pe-md-0 {
    padding-right: 0 !important;
  }

  .pe-md-1 {
    padding-right: 0.25rem !important;
  }

  .pe-md-2 {
    padding-right: 0.5rem !important;
  }

  .pe-md-3 {
    padding-right: 0.75rem !important;
  }

  .pe-md-4 {
    padding-right: 1rem !important;
  }

  .pe-md-5 {
    padding-right: 1.25rem !important;
  }

  .pe-md-6 {
    padding-right: 1.5rem !important;
  }

  .pe-md-7 {
    padding-right: 1.75rem !important;
  }

  .pe-md-8 {
    padding-right: 2rem !important;
  }

  .pe-md-9 {
    padding-right: 2.25rem !important;
  }

  .pe-md-10 {
    padding-right: 2.5rem !important;
  }

  .pe-md-11 {
    padding-right: 2.75rem !important;
  }

  .pe-md-12 {
    padding-right: 3rem !important;
  }

  .pe-md-13 {
    padding-right: 3.25rem !important;
  }

  .pe-md-14 {
    padding-right: 3.5rem !important;
  }

  .pe-md-15 {
    padding-right: 3.75rem !important;
  }

  .pe-md-16 {
    padding-right: 4rem !important;
  }

  .pe-md-17 {
    padding-right: 4.25rem !important;
  }

  .pe-md-18 {
    padding-right: 4.5rem !important;
  }

  .pe-md-19 {
    padding-right: 4.75rem !important;
  }

  .pe-md-20 {
    padding-right: 5rem !important;
  }

  .pb-md-0 {
    padding-bottom: 0 !important;
  }

  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-md-3 {
    padding-bottom: 0.75rem !important;
  }

  .pb-md-4 {
    padding-bottom: 1rem !important;
  }

  .pb-md-5 {
    padding-bottom: 1.25rem !important;
  }

  .pb-md-6 {
    padding-bottom: 1.5rem !important;
  }

  .pb-md-7 {
    padding-bottom: 1.75rem !important;
  }

  .pb-md-8 {
    padding-bottom: 2rem !important;
  }

  .pb-md-9 {
    padding-bottom: 2.25rem !important;
  }

  .pb-md-10 {
    padding-bottom: 2.5rem !important;
  }

  .pb-md-11 {
    padding-bottom: 2.75rem !important;
  }

  .pb-md-12 {
    padding-bottom: 3rem !important;
  }

  .pb-md-13 {
    padding-bottom: 3.25rem !important;
  }

  .pb-md-14 {
    padding-bottom: 3.5rem !important;
  }

  .pb-md-15 {
    padding-bottom: 3.75rem !important;
  }

  .pb-md-16 {
    padding-bottom: 4rem !important;
  }

  .pb-md-17 {
    padding-bottom: 4.25rem !important;
  }

  .pb-md-18 {
    padding-bottom: 4.5rem !important;
  }

  .pb-md-19 {
    padding-bottom: 4.75rem !important;
  }

  .pb-md-20 {
    padding-bottom: 5rem !important;
  }

  .ps-md-0 {
    padding-left: 0 !important;
  }

  .ps-md-1 {
    padding-left: 0.25rem !important;
  }

  .ps-md-2 {
    padding-left: 0.5rem !important;
  }

  .ps-md-3 {
    padding-left: 0.75rem !important;
  }

  .ps-md-4 {
    padding-left: 1rem !important;
  }

  .ps-md-5 {
    padding-left: 1.25rem !important;
  }

  .ps-md-6 {
    padding-left: 1.5rem !important;
  }

  .ps-md-7 {
    padding-left: 1.75rem !important;
  }

  .ps-md-8 {
    padding-left: 2rem !important;
  }

  .ps-md-9 {
    padding-left: 2.25rem !important;
  }

  .ps-md-10 {
    padding-left: 2.5rem !important;
  }

  .ps-md-11 {
    padding-left: 2.75rem !important;
  }

  .ps-md-12 {
    padding-left: 3rem !important;
  }

  .ps-md-13 {
    padding-left: 3.25rem !important;
  }

  .ps-md-14 {
    padding-left: 3.5rem !important;
  }

  .ps-md-15 {
    padding-left: 3.75rem !important;
  }

  .ps-md-16 {
    padding-left: 4rem !important;
  }

  .ps-md-17 {
    padding-left: 4.25rem !important;
  }

  .ps-md-18 {
    padding-left: 4.5rem !important;
  }

  .ps-md-19 {
    padding-left: 4.75rem !important;
  }

  .ps-md-20 {
    padding-left: 5rem !important;
  }

  .gap-md-0 {
    gap: 0 !important;
  }

  .gap-md-1 {
    gap: 0.25rem !important;
  }

  .gap-md-2 {
    gap: 0.5rem !important;
  }

  .gap-md-3 {
    gap: 0.75rem !important;
  }

  .gap-md-4 {
    gap: 1rem !important;
  }

  .gap-md-5 {
    gap: 1.25rem !important;
  }

  .gap-md-6 {
    gap: 1.5rem !important;
  }

  .gap-md-7 {
    gap: 1.75rem !important;
  }

  .gap-md-8 {
    gap: 2rem !important;
  }

  .gap-md-9 {
    gap: 2.25rem !important;
  }

  .gap-md-10 {
    gap: 2.5rem !important;
  }

  .gap-md-11 {
    gap: 2.75rem !important;
  }

  .gap-md-12 {
    gap: 3rem !important;
  }

  .gap-md-13 {
    gap: 3.25rem !important;
  }

  .gap-md-14 {
    gap: 3.5rem !important;
  }

  .gap-md-15 {
    gap: 3.75rem !important;
  }

  .gap-md-16 {
    gap: 4rem !important;
  }

  .gap-md-17 {
    gap: 4.25rem !important;
  }

  .gap-md-18 {
    gap: 4.5rem !important;
  }

  .gap-md-19 {
    gap: 4.75rem !important;
  }

  .gap-md-20 {
    gap: 5rem !important;
  }

  .row-gap-md-0 {
    row-gap: 0 !important;
  }

  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-md-3 {
    row-gap: 0.75rem !important;
  }

  .row-gap-md-4 {
    row-gap: 1rem !important;
  }

  .row-gap-md-5 {
    row-gap: 1.25rem !important;
  }

  .row-gap-md-6 {
    row-gap: 1.5rem !important;
  }

  .row-gap-md-7 {
    row-gap: 1.75rem !important;
  }

  .row-gap-md-8 {
    row-gap: 2rem !important;
  }

  .row-gap-md-9 {
    row-gap: 2.25rem !important;
  }

  .row-gap-md-10 {
    row-gap: 2.5rem !important;
  }

  .row-gap-md-11 {
    row-gap: 2.75rem !important;
  }

  .row-gap-md-12 {
    row-gap: 3rem !important;
  }

  .row-gap-md-13 {
    row-gap: 3.25rem !important;
  }

  .row-gap-md-14 {
    row-gap: 3.5rem !important;
  }

  .row-gap-md-15 {
    row-gap: 3.75rem !important;
  }

  .row-gap-md-16 {
    row-gap: 4rem !important;
  }

  .row-gap-md-17 {
    row-gap: 4.25rem !important;
  }

  .row-gap-md-18 {
    row-gap: 4.5rem !important;
  }

  .row-gap-md-19 {
    row-gap: 4.75rem !important;
  }

  .row-gap-md-20 {
    row-gap: 5rem !important;
  }

  .column-gap-md-0 {
    column-gap: 0 !important;
  }

  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-md-3 {
    column-gap: 0.75rem !important;
  }

  .column-gap-md-4 {
    column-gap: 1rem !important;
  }

  .column-gap-md-5 {
    column-gap: 1.25rem !important;
  }

  .column-gap-md-6 {
    column-gap: 1.5rem !important;
  }

  .column-gap-md-7 {
    column-gap: 1.75rem !important;
  }

  .column-gap-md-8 {
    column-gap: 2rem !important;
  }

  .column-gap-md-9 {
    column-gap: 2.25rem !important;
  }

  .column-gap-md-10 {
    column-gap: 2.5rem !important;
  }

  .column-gap-md-11 {
    column-gap: 2.75rem !important;
  }

  .column-gap-md-12 {
    column-gap: 3rem !important;
  }

  .column-gap-md-13 {
    column-gap: 3.25rem !important;
  }

  .column-gap-md-14 {
    column-gap: 3.5rem !important;
  }

  .column-gap-md-15 {
    column-gap: 3.75rem !important;
  }

  .column-gap-md-16 {
    column-gap: 4rem !important;
  }

  .column-gap-md-17 {
    column-gap: 4.25rem !important;
  }

  .column-gap-md-18 {
    column-gap: 4.5rem !important;
  }

  .column-gap-md-19 {
    column-gap: 4.75rem !important;
  }

  .column-gap-md-20 {
    column-gap: 5rem !important;
  }

  .text-md-start {
    text-align: left !important;
  }

  .text-md-end {
    text-align: right !important;
  }

  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }

  .float-lg-end {
    float: right !important;
  }

  .float-lg-none {
    float: none !important;
  }

  .object-fit-lg-contain {
    object-fit: contain !important;
  }

  .object-fit-lg-cover {
    object-fit: cover !important;
  }

  .object-fit-lg-fill {
    object-fit: fill !important;
  }

  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }

  .object-fit-lg-none {
    object-fit: none !important;
  }

  .d-lg-inline {
    display: inline !important;
  }

  .d-lg-inline-block {
    display: inline-block !important;
  }

  .d-lg-block {
    display: block !important;
  }

  .d-lg-grid {
    display: grid !important;
  }

  .d-lg-inline-grid {
    display: inline-grid !important;
  }

  .d-lg-table {
    display: table !important;
  }

  .d-lg-table-row {
    display: table-row !important;
  }

  .d-lg-table-cell {
    display: table-cell !important;
  }

  .d-lg-flex {
    display: flex !important;
  }

  .d-lg-inline-flex {
    display: inline-flex !important;
  }

  .d-lg-none {
    display: none !important;
  }

  .flex-lg-fill {
    flex: 1 1 auto !important;
  }

  .flex-lg-row {
    flex-direction: row !important;
  }

  .flex-lg-column {
    flex-direction: column !important;
  }

  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }

  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-lg-start {
    justify-content: flex-start !important;
  }

  .justify-content-lg-end {
    justify-content: flex-end !important;
  }

  .justify-content-lg-center {
    justify-content: center !important;
  }

  .justify-content-lg-between {
    justify-content: space-between !important;
  }

  .justify-content-lg-around {
    justify-content: space-around !important;
  }

  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-lg-start {
    align-items: flex-start !important;
  }

  .align-items-lg-end {
    align-items: flex-end !important;
  }

  .align-items-lg-center {
    align-items: center !important;
  }

  .align-items-lg-baseline {
    align-items: baseline !important;
  }

  .align-items-lg-stretch {
    align-items: stretch !important;
  }

  .align-content-lg-start {
    align-content: flex-start !important;
  }

  .align-content-lg-end {
    align-content: flex-end !important;
  }

  .align-content-lg-center {
    align-content: center !important;
  }

  .align-content-lg-between {
    align-content: space-between !important;
  }

  .align-content-lg-around {
    align-content: space-around !important;
  }

  .align-content-lg-stretch {
    align-content: stretch !important;
  }

  .align-self-lg-auto {
    align-self: auto !important;
  }

  .align-self-lg-start {
    align-self: flex-start !important;
  }

  .align-self-lg-end {
    align-self: flex-end !important;
  }

  .align-self-lg-center {
    align-self: center !important;
  }

  .align-self-lg-baseline {
    align-self: baseline !important;
  }

  .align-self-lg-stretch {
    align-self: stretch !important;
  }

  .order-lg-first {
    order: -1 !important;
  }

  .order-lg-0 {
    order: 0 !important;
  }

  .order-lg-1 {
    order: 1 !important;
  }

  .order-lg-2 {
    order: 2 !important;
  }

  .order-lg-3 {
    order: 3 !important;
  }

  .order-lg-4 {
    order: 4 !important;
  }

  .order-lg-5 {
    order: 5 !important;
  }

  .order-lg-last {
    order: 6 !important;
  }

  .m-lg-0 {
    margin: 0 !important;
  }

  .m-lg-1 {
    margin: 0.25rem !important;
  }

  .m-lg-2 {
    margin: 0.5rem !important;
  }

  .m-lg-3 {
    margin: 0.75rem !important;
  }

  .m-lg-4 {
    margin: 1rem !important;
  }

  .m-lg-5 {
    margin: 1.25rem !important;
  }

  .m-lg-6 {
    margin: 1.5rem !important;
  }

  .m-lg-7 {
    margin: 1.75rem !important;
  }

  .m-lg-8 {
    margin: 2rem !important;
  }

  .m-lg-9 {
    margin: 2.25rem !important;
  }

  .m-lg-10 {
    margin: 2.5rem !important;
  }

  .m-lg-11 {
    margin: 2.75rem !important;
  }

  .m-lg-12 {
    margin: 3rem !important;
  }

  .m-lg-13 {
    margin: 3.25rem !important;
  }

  .m-lg-14 {
    margin: 3.5rem !important;
  }

  .m-lg-15 {
    margin: 3.75rem !important;
  }

  .m-lg-16 {
    margin: 4rem !important;
  }

  .m-lg-17 {
    margin: 4.25rem !important;
  }

  .m-lg-18 {
    margin: 4.5rem !important;
  }

  .m-lg-19 {
    margin: 4.75rem !important;
  }

  .m-lg-20 {
    margin: 5rem !important;
  }

  .m-lg-auto {
    margin: auto !important;
  }

  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-lg-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }

  .mx-lg-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-lg-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }

  .mx-lg-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-lg-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }

  .mx-lg-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }

  .mx-lg-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }

  .mx-lg-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }

  .mx-lg-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }

  .mx-lg-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-lg-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }

  .mx-lg-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }

  .mx-lg-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }

  .mx-lg-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  .mx-lg-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }

  .mx-lg-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }

  .mx-lg-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }

  .mx-lg-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-lg-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }

  .my-lg-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-lg-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }

  .my-lg-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-lg-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }

  .my-lg-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  .my-lg-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }

  .my-lg-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  .my-lg-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }

  .my-lg-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-lg-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }

  .my-lg-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-lg-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }

  .my-lg-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-lg-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }

  .my-lg-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-lg-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }

  .my-lg-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-lg-0 {
    margin-top: 0 !important;
  }

  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }

  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }

  .mt-lg-3 {
    margin-top: 0.75rem !important;
  }

  .mt-lg-4 {
    margin-top: 1rem !important;
  }

  .mt-lg-5 {
    margin-top: 1.25rem !important;
  }

  .mt-lg-6 {
    margin-top: 1.5rem !important;
  }

  .mt-lg-7 {
    margin-top: 1.75rem !important;
  }

  .mt-lg-8 {
    margin-top: 2rem !important;
  }

  .mt-lg-9 {
    margin-top: 2.25rem !important;
  }

  .mt-lg-10 {
    margin-top: 2.5rem !important;
  }

  .mt-lg-11 {
    margin-top: 2.75rem !important;
  }

  .mt-lg-12 {
    margin-top: 3rem !important;
  }

  .mt-lg-13 {
    margin-top: 3.25rem !important;
  }

  .mt-lg-14 {
    margin-top: 3.5rem !important;
  }

  .mt-lg-15 {
    margin-top: 3.75rem !important;
  }

  .mt-lg-16 {
    margin-top: 4rem !important;
  }

  .mt-lg-17 {
    margin-top: 4.25rem !important;
  }

  .mt-lg-18 {
    margin-top: 4.5rem !important;
  }

  .mt-lg-19 {
    margin-top: 4.75rem !important;
  }

  .mt-lg-20 {
    margin-top: 5rem !important;
  }

  .mt-lg-auto {
    margin-top: auto !important;
  }

  .me-lg-0 {
    margin-right: 0 !important;
  }

  .me-lg-1 {
    margin-right: 0.25rem !important;
  }

  .me-lg-2 {
    margin-right: 0.5rem !important;
  }

  .me-lg-3 {
    margin-right: 0.75rem !important;
  }

  .me-lg-4 {
    margin-right: 1rem !important;
  }

  .me-lg-5 {
    margin-right: 1.25rem !important;
  }

  .me-lg-6 {
    margin-right: 1.5rem !important;
  }

  .me-lg-7 {
    margin-right: 1.75rem !important;
  }

  .me-lg-8 {
    margin-right: 2rem !important;
  }

  .me-lg-9 {
    margin-right: 2.25rem !important;
  }

  .me-lg-10 {
    margin-right: 2.5rem !important;
  }

  .me-lg-11 {
    margin-right: 2.75rem !important;
  }

  .me-lg-12 {
    margin-right: 3rem !important;
  }

  .me-lg-13 {
    margin-right: 3.25rem !important;
  }

  .me-lg-14 {
    margin-right: 3.5rem !important;
  }

  .me-lg-15 {
    margin-right: 3.75rem !important;
  }

  .me-lg-16 {
    margin-right: 4rem !important;
  }

  .me-lg-17 {
    margin-right: 4.25rem !important;
  }

  .me-lg-18 {
    margin-right: 4.5rem !important;
  }

  .me-lg-19 {
    margin-right: 4.75rem !important;
  }

  .me-lg-20 {
    margin-right: 5rem !important;
  }

  .me-lg-auto {
    margin-right: auto !important;
  }

  .mb-lg-0 {
    margin-bottom: 0 !important;
  }

  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-lg-3 {
    margin-bottom: 0.75rem !important;
  }

  .mb-lg-4 {
    margin-bottom: 1rem !important;
  }

  .mb-lg-5 {
    margin-bottom: 1.25rem !important;
  }

  .mb-lg-6 {
    margin-bottom: 1.5rem !important;
  }

  .mb-lg-7 {
    margin-bottom: 1.75rem !important;
  }

  .mb-lg-8 {
    margin-bottom: 2rem !important;
  }

  .mb-lg-9 {
    margin-bottom: 2.25rem !important;
  }

  .mb-lg-10 {
    margin-bottom: 2.5rem !important;
  }

  .mb-lg-11 {
    margin-bottom: 2.75rem !important;
  }

  .mb-lg-12 {
    margin-bottom: 3rem !important;
  }

  .mb-lg-13 {
    margin-bottom: 3.25rem !important;
  }

  .mb-lg-14 {
    margin-bottom: 3.5rem !important;
  }

  .mb-lg-15 {
    margin-bottom: 3.75rem !important;
  }

  .mb-lg-16 {
    margin-bottom: 4rem !important;
  }

  .mb-lg-17 {
    margin-bottom: 4.25rem !important;
  }

  .mb-lg-18 {
    margin-bottom: 4.5rem !important;
  }

  .mb-lg-19 {
    margin-bottom: 4.75rem !important;
  }

  .mb-lg-20 {
    margin-bottom: 5rem !important;
  }

  .mb-lg-auto {
    margin-bottom: auto !important;
  }

  .ms-lg-0 {
    margin-left: 0 !important;
  }

  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }

  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }

  .ms-lg-3 {
    margin-left: 0.75rem !important;
  }

  .ms-lg-4 {
    margin-left: 1rem !important;
  }

  .ms-lg-5 {
    margin-left: 1.25rem !important;
  }

  .ms-lg-6 {
    margin-left: 1.5rem !important;
  }

  .ms-lg-7 {
    margin-left: 1.75rem !important;
  }

  .ms-lg-8 {
    margin-left: 2rem !important;
  }

  .ms-lg-9 {
    margin-left: 2.25rem !important;
  }

  .ms-lg-10 {
    margin-left: 2.5rem !important;
  }

  .ms-lg-11 {
    margin-left: 2.75rem !important;
  }

  .ms-lg-12 {
    margin-left: 3rem !important;
  }

  .ms-lg-13 {
    margin-left: 3.25rem !important;
  }

  .ms-lg-14 {
    margin-left: 3.5rem !important;
  }

  .ms-lg-15 {
    margin-left: 3.75rem !important;
  }

  .ms-lg-16 {
    margin-left: 4rem !important;
  }

  .ms-lg-17 {
    margin-left: 4.25rem !important;
  }

  .ms-lg-18 {
    margin-left: 4.5rem !important;
  }

  .ms-lg-19 {
    margin-left: 4.75rem !important;
  }

  .ms-lg-20 {
    margin-left: 5rem !important;
  }

  .ms-lg-auto {
    margin-left: auto !important;
  }

  .m-lg-n1 {
    margin: -0.25rem !important;
  }

  .m-lg-n2 {
    margin: -0.5rem !important;
  }

  .m-lg-n3 {
    margin: -0.75rem !important;
  }

  .m-lg-n4 {
    margin: -1rem !important;
  }

  .m-lg-n5 {
    margin: -1.25rem !important;
  }

  .m-lg-n6 {
    margin: -1.5rem !important;
  }

  .m-lg-n7 {
    margin: -1.75rem !important;
  }

  .m-lg-n8 {
    margin: -2rem !important;
  }

  .m-lg-n9 {
    margin: -2.25rem !important;
  }

  .m-lg-n10 {
    margin: -2.5rem !important;
  }

  .m-lg-n11 {
    margin: -2.75rem !important;
  }

  .m-lg-n12 {
    margin: -3rem !important;
  }

  .m-lg-n13 {
    margin: -3.25rem !important;
  }

  .m-lg-n14 {
    margin: -3.5rem !important;
  }

  .m-lg-n15 {
    margin: -3.75rem !important;
  }

  .m-lg-n16 {
    margin: -4rem !important;
  }

  .m-lg-n17 {
    margin: -4.25rem !important;
  }

  .m-lg-n18 {
    margin: -4.5rem !important;
  }

  .m-lg-n19 {
    margin: -4.75rem !important;
  }

  .m-lg-n20 {
    margin: -5rem !important;
  }

  .mx-lg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-lg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-lg-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }

  .mx-lg-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-lg-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }

  .mx-lg-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-lg-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }

  .mx-lg-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }

  .mx-lg-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }

  .mx-lg-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }

  .mx-lg-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }

  .mx-lg-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .mx-lg-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }

  .mx-lg-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }

  .mx-lg-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }

  .mx-lg-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }

  .mx-lg-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }

  .mx-lg-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }

  .mx-lg-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }

  .mx-lg-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }

  .my-lg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-lg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-lg-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }

  .my-lg-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-lg-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }

  .my-lg-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-lg-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }

  .my-lg-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }

  .my-lg-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }

  .my-lg-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }

  .my-lg-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }

  .my-lg-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .my-lg-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }

  .my-lg-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }

  .my-lg-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }

  .my-lg-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }

  .my-lg-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }

  .my-lg-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }

  .my-lg-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }

  .my-lg-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }

  .mt-lg-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-lg-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-lg-n3 {
    margin-top: -0.75rem !important;
  }

  .mt-lg-n4 {
    margin-top: -1rem !important;
  }

  .mt-lg-n5 {
    margin-top: -1.25rem !important;
  }

  .mt-lg-n6 {
    margin-top: -1.5rem !important;
  }

  .mt-lg-n7 {
    margin-top: -1.75rem !important;
  }

  .mt-lg-n8 {
    margin-top: -2rem !important;
  }

  .mt-lg-n9 {
    margin-top: -2.25rem !important;
  }

  .mt-lg-n10 {
    margin-top: -2.5rem !important;
  }

  .mt-lg-n11 {
    margin-top: -2.75rem !important;
  }

  .mt-lg-n12 {
    margin-top: -3rem !important;
  }

  .mt-lg-n13 {
    margin-top: -3.25rem !important;
  }

  .mt-lg-n14 {
    margin-top: -3.5rem !important;
  }

  .mt-lg-n15 {
    margin-top: -3.75rem !important;
  }

  .mt-lg-n16 {
    margin-top: -4rem !important;
  }

  .mt-lg-n17 {
    margin-top: -4.25rem !important;
  }

  .mt-lg-n18 {
    margin-top: -4.5rem !important;
  }

  .mt-lg-n19 {
    margin-top: -4.75rem !important;
  }

  .mt-lg-n20 {
    margin-top: -5rem !important;
  }

  .me-lg-n1 {
    margin-right: -0.25rem !important;
  }

  .me-lg-n2 {
    margin-right: -0.5rem !important;
  }

  .me-lg-n3 {
    margin-right: -0.75rem !important;
  }

  .me-lg-n4 {
    margin-right: -1rem !important;
  }

  .me-lg-n5 {
    margin-right: -1.25rem !important;
  }

  .me-lg-n6 {
    margin-right: -1.5rem !important;
  }

  .me-lg-n7 {
    margin-right: -1.75rem !important;
  }

  .me-lg-n8 {
    margin-right: -2rem !important;
  }

  .me-lg-n9 {
    margin-right: -2.25rem !important;
  }

  .me-lg-n10 {
    margin-right: -2.5rem !important;
  }

  .me-lg-n11 {
    margin-right: -2.75rem !important;
  }

  .me-lg-n12 {
    margin-right: -3rem !important;
  }

  .me-lg-n13 {
    margin-right: -3.25rem !important;
  }

  .me-lg-n14 {
    margin-right: -3.5rem !important;
  }

  .me-lg-n15 {
    margin-right: -3.75rem !important;
  }

  .me-lg-n16 {
    margin-right: -4rem !important;
  }

  .me-lg-n17 {
    margin-right: -4.25rem !important;
  }

  .me-lg-n18 {
    margin-right: -4.5rem !important;
  }

  .me-lg-n19 {
    margin-right: -4.75rem !important;
  }

  .me-lg-n20 {
    margin-right: -5rem !important;
  }

  .mb-lg-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-lg-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-lg-n3 {
    margin-bottom: -0.75rem !important;
  }

  .mb-lg-n4 {
    margin-bottom: -1rem !important;
  }

  .mb-lg-n5 {
    margin-bottom: -1.25rem !important;
  }

  .mb-lg-n6 {
    margin-bottom: -1.5rem !important;
  }

  .mb-lg-n7 {
    margin-bottom: -1.75rem !important;
  }

  .mb-lg-n8 {
    margin-bottom: -2rem !important;
  }

  .mb-lg-n9 {
    margin-bottom: -2.25rem !important;
  }

  .mb-lg-n10 {
    margin-bottom: -2.5rem !important;
  }

  .mb-lg-n11 {
    margin-bottom: -2.75rem !important;
  }

  .mb-lg-n12 {
    margin-bottom: -3rem !important;
  }

  .mb-lg-n13 {
    margin-bottom: -3.25rem !important;
  }

  .mb-lg-n14 {
    margin-bottom: -3.5rem !important;
  }

  .mb-lg-n15 {
    margin-bottom: -3.75rem !important;
  }

  .mb-lg-n16 {
    margin-bottom: -4rem !important;
  }

  .mb-lg-n17 {
    margin-bottom: -4.25rem !important;
  }

  .mb-lg-n18 {
    margin-bottom: -4.5rem !important;
  }

  .mb-lg-n19 {
    margin-bottom: -4.75rem !important;
  }

  .mb-lg-n20 {
    margin-bottom: -5rem !important;
  }

  .ms-lg-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-lg-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-lg-n3 {
    margin-left: -0.75rem !important;
  }

  .ms-lg-n4 {
    margin-left: -1rem !important;
  }

  .ms-lg-n5 {
    margin-left: -1.25rem !important;
  }

  .ms-lg-n6 {
    margin-left: -1.5rem !important;
  }

  .ms-lg-n7 {
    margin-left: -1.75rem !important;
  }

  .ms-lg-n8 {
    margin-left: -2rem !important;
  }

  .ms-lg-n9 {
    margin-left: -2.25rem !important;
  }

  .ms-lg-n10 {
    margin-left: -2.5rem !important;
  }

  .ms-lg-n11 {
    margin-left: -2.75rem !important;
  }

  .ms-lg-n12 {
    margin-left: -3rem !important;
  }

  .ms-lg-n13 {
    margin-left: -3.25rem !important;
  }

  .ms-lg-n14 {
    margin-left: -3.5rem !important;
  }

  .ms-lg-n15 {
    margin-left: -3.75rem !important;
  }

  .ms-lg-n16 {
    margin-left: -4rem !important;
  }

  .ms-lg-n17 {
    margin-left: -4.25rem !important;
  }

  .ms-lg-n18 {
    margin-left: -4.5rem !important;
  }

  .ms-lg-n19 {
    margin-left: -4.75rem !important;
  }

  .ms-lg-n20 {
    margin-left: -5rem !important;
  }

  .p-lg-0 {
    padding: 0 !important;
  }

  .p-lg-1 {
    padding: 0.25rem !important;
  }

  .p-lg-2 {
    padding: 0.5rem !important;
  }

  .p-lg-3 {
    padding: 0.75rem !important;
  }

  .p-lg-4 {
    padding: 1rem !important;
  }

  .p-lg-5 {
    padding: 1.25rem !important;
  }

  .p-lg-6 {
    padding: 1.5rem !important;
  }

  .p-lg-7 {
    padding: 1.75rem !important;
  }

  .p-lg-8 {
    padding: 2rem !important;
  }

  .p-lg-9 {
    padding: 2.25rem !important;
  }

  .p-lg-10 {
    padding: 2.5rem !important;
  }

  .p-lg-11 {
    padding: 2.75rem !important;
  }

  .p-lg-12 {
    padding: 3rem !important;
  }

  .p-lg-13 {
    padding: 3.25rem !important;
  }

  .p-lg-14 {
    padding: 3.5rem !important;
  }

  .p-lg-15 {
    padding: 3.75rem !important;
  }

  .p-lg-16 {
    padding: 4rem !important;
  }

  .p-lg-17 {
    padding: 4.25rem !important;
  }

  .p-lg-18 {
    padding: 4.5rem !important;
  }

  .p-lg-19 {
    padding: 4.75rem !important;
  }

  .p-lg-20 {
    padding: 5rem !important;
  }

  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-lg-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }

  .px-lg-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-lg-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }

  .px-lg-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-lg-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }

  .px-lg-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }

  .px-lg-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }

  .px-lg-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }

  .px-lg-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }

  .px-lg-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .px-lg-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }

  .px-lg-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }

  .px-lg-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }

  .px-lg-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  .px-lg-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }

  .px-lg-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }

  .px-lg-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }

  .px-lg-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-lg-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  .py-lg-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-lg-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }

  .py-lg-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-lg-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }

  .py-lg-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .py-lg-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }

  .py-lg-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  .py-lg-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }

  .py-lg-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .py-lg-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }

  .py-lg-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-lg-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }

  .py-lg-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-lg-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }

  .py-lg-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-lg-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }

  .py-lg-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .pt-lg-0 {
    padding-top: 0 !important;
  }

  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }

  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }

  .pt-lg-3 {
    padding-top: 0.75rem !important;
  }

  .pt-lg-4 {
    padding-top: 1rem !important;
  }

  .pt-lg-5 {
    padding-top: 1.25rem !important;
  }

  .pt-lg-6 {
    padding-top: 1.5rem !important;
  }

  .pt-lg-7 {
    padding-top: 1.75rem !important;
  }

  .pt-lg-8 {
    padding-top: 2rem !important;
  }

  .pt-lg-9 {
    padding-top: 2.25rem !important;
  }

  .pt-lg-10 {
    padding-top: 2.5rem !important;
  }

  .pt-lg-11 {
    padding-top: 2.75rem !important;
  }

  .pt-lg-12 {
    padding-top: 3rem !important;
  }

  .pt-lg-13 {
    padding-top: 3.25rem !important;
  }

  .pt-lg-14 {
    padding-top: 3.5rem !important;
  }

  .pt-lg-15 {
    padding-top: 3.75rem !important;
  }

  .pt-lg-16 {
    padding-top: 4rem !important;
  }

  .pt-lg-17 {
    padding-top: 4.25rem !important;
  }

  .pt-lg-18 {
    padding-top: 4.5rem !important;
  }

  .pt-lg-19 {
    padding-top: 4.75rem !important;
  }

  .pt-lg-20 {
    padding-top: 5rem !important;
  }

  .pe-lg-0 {
    padding-right: 0 !important;
  }

  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }

  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }

  .pe-lg-3 {
    padding-right: 0.75rem !important;
  }

  .pe-lg-4 {
    padding-right: 1rem !important;
  }

  .pe-lg-5 {
    padding-right: 1.25rem !important;
  }

  .pe-lg-6 {
    padding-right: 1.5rem !important;
  }

  .pe-lg-7 {
    padding-right: 1.75rem !important;
  }

  .pe-lg-8 {
    padding-right: 2rem !important;
  }

  .pe-lg-9 {
    padding-right: 2.25rem !important;
  }

  .pe-lg-10 {
    padding-right: 2.5rem !important;
  }

  .pe-lg-11 {
    padding-right: 2.75rem !important;
  }

  .pe-lg-12 {
    padding-right: 3rem !important;
  }

  .pe-lg-13 {
    padding-right: 3.25rem !important;
  }

  .pe-lg-14 {
    padding-right: 3.5rem !important;
  }

  .pe-lg-15 {
    padding-right: 3.75rem !important;
  }

  .pe-lg-16 {
    padding-right: 4rem !important;
  }

  .pe-lg-17 {
    padding-right: 4.25rem !important;
  }

  .pe-lg-18 {
    padding-right: 4.5rem !important;
  }

  .pe-lg-19 {
    padding-right: 4.75rem !important;
  }

  .pe-lg-20 {
    padding-right: 5rem !important;
  }

  .pb-lg-0 {
    padding-bottom: 0 !important;
  }

  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-lg-3 {
    padding-bottom: 0.75rem !important;
  }

  .pb-lg-4 {
    padding-bottom: 1rem !important;
  }

  .pb-lg-5 {
    padding-bottom: 1.25rem !important;
  }

  .pb-lg-6 {
    padding-bottom: 1.5rem !important;
  }

  .pb-lg-7 {
    padding-bottom: 1.75rem !important;
  }

  .pb-lg-8 {
    padding-bottom: 2rem !important;
  }

  .pb-lg-9 {
    padding-bottom: 2.25rem !important;
  }

  .pb-lg-10 {
    padding-bottom: 2.5rem !important;
  }

  .pb-lg-11 {
    padding-bottom: 2.75rem !important;
  }

  .pb-lg-12 {
    padding-bottom: 3rem !important;
  }

  .pb-lg-13 {
    padding-bottom: 3.25rem !important;
  }

  .pb-lg-14 {
    padding-bottom: 3.5rem !important;
  }

  .pb-lg-15 {
    padding-bottom: 3.75rem !important;
  }

  .pb-lg-16 {
    padding-bottom: 4rem !important;
  }

  .pb-lg-17 {
    padding-bottom: 4.25rem !important;
  }

  .pb-lg-18 {
    padding-bottom: 4.5rem !important;
  }

  .pb-lg-19 {
    padding-bottom: 4.75rem !important;
  }

  .pb-lg-20 {
    padding-bottom: 5rem !important;
  }

  .ps-lg-0 {
    padding-left: 0 !important;
  }

  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }

  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }

  .ps-lg-3 {
    padding-left: 0.75rem !important;
  }

  .ps-lg-4 {
    padding-left: 1rem !important;
  }

  .ps-lg-5 {
    padding-left: 1.25rem !important;
  }

  .ps-lg-6 {
    padding-left: 1.5rem !important;
  }

  .ps-lg-7 {
    padding-left: 1.75rem !important;
  }

  .ps-lg-8 {
    padding-left: 2rem !important;
  }

  .ps-lg-9 {
    padding-left: 2.25rem !important;
  }

  .ps-lg-10 {
    padding-left: 2.5rem !important;
  }

  .ps-lg-11 {
    padding-left: 2.75rem !important;
  }

  .ps-lg-12 {
    padding-left: 3rem !important;
  }

  .ps-lg-13 {
    padding-left: 3.25rem !important;
  }

  .ps-lg-14 {
    padding-left: 3.5rem !important;
  }

  .ps-lg-15 {
    padding-left: 3.75rem !important;
  }

  .ps-lg-16 {
    padding-left: 4rem !important;
  }

  .ps-lg-17 {
    padding-left: 4.25rem !important;
  }

  .ps-lg-18 {
    padding-left: 4.5rem !important;
  }

  .ps-lg-19 {
    padding-left: 4.75rem !important;
  }

  .ps-lg-20 {
    padding-left: 5rem !important;
  }

  .gap-lg-0 {
    gap: 0 !important;
  }

  .gap-lg-1 {
    gap: 0.25rem !important;
  }

  .gap-lg-2 {
    gap: 0.5rem !important;
  }

  .gap-lg-3 {
    gap: 0.75rem !important;
  }

  .gap-lg-4 {
    gap: 1rem !important;
  }

  .gap-lg-5 {
    gap: 1.25rem !important;
  }

  .gap-lg-6 {
    gap: 1.5rem !important;
  }

  .gap-lg-7 {
    gap: 1.75rem !important;
  }

  .gap-lg-8 {
    gap: 2rem !important;
  }

  .gap-lg-9 {
    gap: 2.25rem !important;
  }

  .gap-lg-10 {
    gap: 2.5rem !important;
  }

  .gap-lg-11 {
    gap: 2.75rem !important;
  }

  .gap-lg-12 {
    gap: 3rem !important;
  }

  .gap-lg-13 {
    gap: 3.25rem !important;
  }

  .gap-lg-14 {
    gap: 3.5rem !important;
  }

  .gap-lg-15 {
    gap: 3.75rem !important;
  }

  .gap-lg-16 {
    gap: 4rem !important;
  }

  .gap-lg-17 {
    gap: 4.25rem !important;
  }

  .gap-lg-18 {
    gap: 4.5rem !important;
  }

  .gap-lg-19 {
    gap: 4.75rem !important;
  }

  .gap-lg-20 {
    gap: 5rem !important;
  }

  .row-gap-lg-0 {
    row-gap: 0 !important;
  }

  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-lg-3 {
    row-gap: 0.75rem !important;
  }

  .row-gap-lg-4 {
    row-gap: 1rem !important;
  }

  .row-gap-lg-5 {
    row-gap: 1.25rem !important;
  }

  .row-gap-lg-6 {
    row-gap: 1.5rem !important;
  }

  .row-gap-lg-7 {
    row-gap: 1.75rem !important;
  }

  .row-gap-lg-8 {
    row-gap: 2rem !important;
  }

  .row-gap-lg-9 {
    row-gap: 2.25rem !important;
  }

  .row-gap-lg-10 {
    row-gap: 2.5rem !important;
  }

  .row-gap-lg-11 {
    row-gap: 2.75rem !important;
  }

  .row-gap-lg-12 {
    row-gap: 3rem !important;
  }

  .row-gap-lg-13 {
    row-gap: 3.25rem !important;
  }

  .row-gap-lg-14 {
    row-gap: 3.5rem !important;
  }

  .row-gap-lg-15 {
    row-gap: 3.75rem !important;
  }

  .row-gap-lg-16 {
    row-gap: 4rem !important;
  }

  .row-gap-lg-17 {
    row-gap: 4.25rem !important;
  }

  .row-gap-lg-18 {
    row-gap: 4.5rem !important;
  }

  .row-gap-lg-19 {
    row-gap: 4.75rem !important;
  }

  .row-gap-lg-20 {
    row-gap: 5rem !important;
  }

  .column-gap-lg-0 {
    column-gap: 0 !important;
  }

  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-lg-3 {
    column-gap: 0.75rem !important;
  }

  .column-gap-lg-4 {
    column-gap: 1rem !important;
  }

  .column-gap-lg-5 {
    column-gap: 1.25rem !important;
  }

  .column-gap-lg-6 {
    column-gap: 1.5rem !important;
  }

  .column-gap-lg-7 {
    column-gap: 1.75rem !important;
  }

  .column-gap-lg-8 {
    column-gap: 2rem !important;
  }

  .column-gap-lg-9 {
    column-gap: 2.25rem !important;
  }

  .column-gap-lg-10 {
    column-gap: 2.5rem !important;
  }

  .column-gap-lg-11 {
    column-gap: 2.75rem !important;
  }

  .column-gap-lg-12 {
    column-gap: 3rem !important;
  }

  .column-gap-lg-13 {
    column-gap: 3.25rem !important;
  }

  .column-gap-lg-14 {
    column-gap: 3.5rem !important;
  }

  .column-gap-lg-15 {
    column-gap: 3.75rem !important;
  }

  .column-gap-lg-16 {
    column-gap: 4rem !important;
  }

  .column-gap-lg-17 {
    column-gap: 4.25rem !important;
  }

  .column-gap-lg-18 {
    column-gap: 4.5rem !important;
  }

  .column-gap-lg-19 {
    column-gap: 4.75rem !important;
  }

  .column-gap-lg-20 {
    column-gap: 5rem !important;
  }

  .text-lg-start {
    text-align: left !important;
  }

  .text-lg-end {
    text-align: right !important;
  }

  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }

  .float-xl-end {
    float: right !important;
  }

  .float-xl-none {
    float: none !important;
  }

  .object-fit-xl-contain {
    object-fit: contain !important;
  }

  .object-fit-xl-cover {
    object-fit: cover !important;
  }

  .object-fit-xl-fill {
    object-fit: fill !important;
  }

  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }

  .object-fit-xl-none {
    object-fit: none !important;
  }

  .d-xl-inline {
    display: inline !important;
  }

  .d-xl-inline-block {
    display: inline-block !important;
  }

  .d-xl-block {
    display: block !important;
  }

  .d-xl-grid {
    display: grid !important;
  }

  .d-xl-inline-grid {
    display: inline-grid !important;
  }

  .d-xl-table {
    display: table !important;
  }

  .d-xl-table-row {
    display: table-row !important;
  }

  .d-xl-table-cell {
    display: table-cell !important;
  }

  .d-xl-flex {
    display: flex !important;
  }

  .d-xl-inline-flex {
    display: inline-flex !important;
  }

  .d-xl-none {
    display: none !important;
  }

  .flex-xl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xl-row {
    flex-direction: row !important;
  }

  .flex-xl-column {
    flex-direction: column !important;
  }

  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-xl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xl-center {
    justify-content: center !important;
  }

  .justify-content-xl-between {
    justify-content: space-between !important;
  }

  .justify-content-xl-around {
    justify-content: space-around !important;
  }

  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-xl-start {
    align-items: flex-start !important;
  }

  .align-items-xl-end {
    align-items: flex-end !important;
  }

  .align-items-xl-center {
    align-items: center !important;
  }

  .align-items-xl-baseline {
    align-items: baseline !important;
  }

  .align-items-xl-stretch {
    align-items: stretch !important;
  }

  .align-content-xl-start {
    align-content: flex-start !important;
  }

  .align-content-xl-end {
    align-content: flex-end !important;
  }

  .align-content-xl-center {
    align-content: center !important;
  }

  .align-content-xl-between {
    align-content: space-between !important;
  }

  .align-content-xl-around {
    align-content: space-around !important;
  }

  .align-content-xl-stretch {
    align-content: stretch !important;
  }

  .align-self-xl-auto {
    align-self: auto !important;
  }

  .align-self-xl-start {
    align-self: flex-start !important;
  }

  .align-self-xl-end {
    align-self: flex-end !important;
  }

  .align-self-xl-center {
    align-self: center !important;
  }

  .align-self-xl-baseline {
    align-self: baseline !important;
  }

  .align-self-xl-stretch {
    align-self: stretch !important;
  }

  .order-xl-first {
    order: -1 !important;
  }

  .order-xl-0 {
    order: 0 !important;
  }

  .order-xl-1 {
    order: 1 !important;
  }

  .order-xl-2 {
    order: 2 !important;
  }

  .order-xl-3 {
    order: 3 !important;
  }

  .order-xl-4 {
    order: 4 !important;
  }

  .order-xl-5 {
    order: 5 !important;
  }

  .order-xl-last {
    order: 6 !important;
  }

  .m-xl-0 {
    margin: 0 !important;
  }

  .m-xl-1 {
    margin: 0.25rem !important;
  }

  .m-xl-2 {
    margin: 0.5rem !important;
  }

  .m-xl-3 {
    margin: 0.75rem !important;
  }

  .m-xl-4 {
    margin: 1rem !important;
  }

  .m-xl-5 {
    margin: 1.25rem !important;
  }

  .m-xl-6 {
    margin: 1.5rem !important;
  }

  .m-xl-7 {
    margin: 1.75rem !important;
  }

  .m-xl-8 {
    margin: 2rem !important;
  }

  .m-xl-9 {
    margin: 2.25rem !important;
  }

  .m-xl-10 {
    margin: 2.5rem !important;
  }

  .m-xl-11 {
    margin: 2.75rem !important;
  }

  .m-xl-12 {
    margin: 3rem !important;
  }

  .m-xl-13 {
    margin: 3.25rem !important;
  }

  .m-xl-14 {
    margin: 3.5rem !important;
  }

  .m-xl-15 {
    margin: 3.75rem !important;
  }

  .m-xl-16 {
    margin: 4rem !important;
  }

  .m-xl-17 {
    margin: 4.25rem !important;
  }

  .m-xl-18 {
    margin: 4.5rem !important;
  }

  .m-xl-19 {
    margin: 4.75rem !important;
  }

  .m-xl-20 {
    margin: 5rem !important;
  }

  .m-xl-auto {
    margin: auto !important;
  }

  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-xl-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }

  .mx-xl-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-xl-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }

  .mx-xl-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-xl-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }

  .mx-xl-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }

  .mx-xl-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }

  .mx-xl-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }

  .mx-xl-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }

  .mx-xl-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-xl-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }

  .mx-xl-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }

  .mx-xl-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }

  .mx-xl-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  .mx-xl-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }

  .mx-xl-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }

  .mx-xl-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }

  .mx-xl-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-xl-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }

  .my-xl-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-xl-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }

  .my-xl-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-xl-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }

  .my-xl-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  .my-xl-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }

  .my-xl-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  .my-xl-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }

  .my-xl-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-xl-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }

  .my-xl-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-xl-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }

  .my-xl-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-xl-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }

  .my-xl-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-xl-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }

  .my-xl-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-xl-0 {
    margin-top: 0 !important;
  }

  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }

  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }

  .mt-xl-3 {
    margin-top: 0.75rem !important;
  }

  .mt-xl-4 {
    margin-top: 1rem !important;
  }

  .mt-xl-5 {
    margin-top: 1.25rem !important;
  }

  .mt-xl-6 {
    margin-top: 1.5rem !important;
  }

  .mt-xl-7 {
    margin-top: 1.75rem !important;
  }

  .mt-xl-8 {
    margin-top: 2rem !important;
  }

  .mt-xl-9 {
    margin-top: 2.25rem !important;
  }

  .mt-xl-10 {
    margin-top: 2.5rem !important;
  }

  .mt-xl-11 {
    margin-top: 2.75rem !important;
  }

  .mt-xl-12 {
    margin-top: 3rem !important;
  }

  .mt-xl-13 {
    margin-top: 3.25rem !important;
  }

  .mt-xl-14 {
    margin-top: 3.5rem !important;
  }

  .mt-xl-15 {
    margin-top: 3.75rem !important;
  }

  .mt-xl-16 {
    margin-top: 4rem !important;
  }

  .mt-xl-17 {
    margin-top: 4.25rem !important;
  }

  .mt-xl-18 {
    margin-top: 4.5rem !important;
  }

  .mt-xl-19 {
    margin-top: 4.75rem !important;
  }

  .mt-xl-20 {
    margin-top: 5rem !important;
  }

  .mt-xl-auto {
    margin-top: auto !important;
  }

  .me-xl-0 {
    margin-right: 0 !important;
  }

  .me-xl-1 {
    margin-right: 0.25rem !important;
  }

  .me-xl-2 {
    margin-right: 0.5rem !important;
  }

  .me-xl-3 {
    margin-right: 0.75rem !important;
  }

  .me-xl-4 {
    margin-right: 1rem !important;
  }

  .me-xl-5 {
    margin-right: 1.25rem !important;
  }

  .me-xl-6 {
    margin-right: 1.5rem !important;
  }

  .me-xl-7 {
    margin-right: 1.75rem !important;
  }

  .me-xl-8 {
    margin-right: 2rem !important;
  }

  .me-xl-9 {
    margin-right: 2.25rem !important;
  }

  .me-xl-10 {
    margin-right: 2.5rem !important;
  }

  .me-xl-11 {
    margin-right: 2.75rem !important;
  }

  .me-xl-12 {
    margin-right: 3rem !important;
  }

  .me-xl-13 {
    margin-right: 3.25rem !important;
  }

  .me-xl-14 {
    margin-right: 3.5rem !important;
  }

  .me-xl-15 {
    margin-right: 3.75rem !important;
  }

  .me-xl-16 {
    margin-right: 4rem !important;
  }

  .me-xl-17 {
    margin-right: 4.25rem !important;
  }

  .me-xl-18 {
    margin-right: 4.5rem !important;
  }

  .me-xl-19 {
    margin-right: 4.75rem !important;
  }

  .me-xl-20 {
    margin-right: 5rem !important;
  }

  .me-xl-auto {
    margin-right: auto !important;
  }

  .mb-xl-0 {
    margin-bottom: 0 !important;
  }

  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-xl-3 {
    margin-bottom: 0.75rem !important;
  }

  .mb-xl-4 {
    margin-bottom: 1rem !important;
  }

  .mb-xl-5 {
    margin-bottom: 1.25rem !important;
  }

  .mb-xl-6 {
    margin-bottom: 1.5rem !important;
  }

  .mb-xl-7 {
    margin-bottom: 1.75rem !important;
  }

  .mb-xl-8 {
    margin-bottom: 2rem !important;
  }

  .mb-xl-9 {
    margin-bottom: 2.25rem !important;
  }

  .mb-xl-10 {
    margin-bottom: 2.5rem !important;
  }

  .mb-xl-11 {
    margin-bottom: 2.75rem !important;
  }

  .mb-xl-12 {
    margin-bottom: 3rem !important;
  }

  .mb-xl-13 {
    margin-bottom: 3.25rem !important;
  }

  .mb-xl-14 {
    margin-bottom: 3.5rem !important;
  }

  .mb-xl-15 {
    margin-bottom: 3.75rem !important;
  }

  .mb-xl-16 {
    margin-bottom: 4rem !important;
  }

  .mb-xl-17 {
    margin-bottom: 4.25rem !important;
  }

  .mb-xl-18 {
    margin-bottom: 4.5rem !important;
  }

  .mb-xl-19 {
    margin-bottom: 4.75rem !important;
  }

  .mb-xl-20 {
    margin-bottom: 5rem !important;
  }

  .mb-xl-auto {
    margin-bottom: auto !important;
  }

  .ms-xl-0 {
    margin-left: 0 !important;
  }

  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }

  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }

  .ms-xl-3 {
    margin-left: 0.75rem !important;
  }

  .ms-xl-4 {
    margin-left: 1rem !important;
  }

  .ms-xl-5 {
    margin-left: 1.25rem !important;
  }

  .ms-xl-6 {
    margin-left: 1.5rem !important;
  }

  .ms-xl-7 {
    margin-left: 1.75rem !important;
  }

  .ms-xl-8 {
    margin-left: 2rem !important;
  }

  .ms-xl-9 {
    margin-left: 2.25rem !important;
  }

  .ms-xl-10 {
    margin-left: 2.5rem !important;
  }

  .ms-xl-11 {
    margin-left: 2.75rem !important;
  }

  .ms-xl-12 {
    margin-left: 3rem !important;
  }

  .ms-xl-13 {
    margin-left: 3.25rem !important;
  }

  .ms-xl-14 {
    margin-left: 3.5rem !important;
  }

  .ms-xl-15 {
    margin-left: 3.75rem !important;
  }

  .ms-xl-16 {
    margin-left: 4rem !important;
  }

  .ms-xl-17 {
    margin-left: 4.25rem !important;
  }

  .ms-xl-18 {
    margin-left: 4.5rem !important;
  }

  .ms-xl-19 {
    margin-left: 4.75rem !important;
  }

  .ms-xl-20 {
    margin-left: 5rem !important;
  }

  .ms-xl-auto {
    margin-left: auto !important;
  }

  .m-xl-n1 {
    margin: -0.25rem !important;
  }

  .m-xl-n2 {
    margin: -0.5rem !important;
  }

  .m-xl-n3 {
    margin: -0.75rem !important;
  }

  .m-xl-n4 {
    margin: -1rem !important;
  }

  .m-xl-n5 {
    margin: -1.25rem !important;
  }

  .m-xl-n6 {
    margin: -1.5rem !important;
  }

  .m-xl-n7 {
    margin: -1.75rem !important;
  }

  .m-xl-n8 {
    margin: -2rem !important;
  }

  .m-xl-n9 {
    margin: -2.25rem !important;
  }

  .m-xl-n10 {
    margin: -2.5rem !important;
  }

  .m-xl-n11 {
    margin: -2.75rem !important;
  }

  .m-xl-n12 {
    margin: -3rem !important;
  }

  .m-xl-n13 {
    margin: -3.25rem !important;
  }

  .m-xl-n14 {
    margin: -3.5rem !important;
  }

  .m-xl-n15 {
    margin: -3.75rem !important;
  }

  .m-xl-n16 {
    margin: -4rem !important;
  }

  .m-xl-n17 {
    margin: -4.25rem !important;
  }

  .m-xl-n18 {
    margin: -4.5rem !important;
  }

  .m-xl-n19 {
    margin: -4.75rem !important;
  }

  .m-xl-n20 {
    margin: -5rem !important;
  }

  .mx-xl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-xl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-xl-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }

  .mx-xl-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-xl-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }

  .mx-xl-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-xl-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }

  .mx-xl-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }

  .mx-xl-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }

  .mx-xl-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }

  .mx-xl-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }

  .mx-xl-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .mx-xl-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }

  .mx-xl-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }

  .mx-xl-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }

  .mx-xl-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }

  .mx-xl-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }

  .mx-xl-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }

  .mx-xl-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }

  .mx-xl-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }

  .my-xl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-xl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-xl-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }

  .my-xl-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-xl-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }

  .my-xl-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-xl-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }

  .my-xl-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }

  .my-xl-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }

  .my-xl-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }

  .my-xl-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }

  .my-xl-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .my-xl-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }

  .my-xl-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }

  .my-xl-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }

  .my-xl-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }

  .my-xl-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }

  .my-xl-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }

  .my-xl-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }

  .my-xl-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }

  .mt-xl-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-xl-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-xl-n3 {
    margin-top: -0.75rem !important;
  }

  .mt-xl-n4 {
    margin-top: -1rem !important;
  }

  .mt-xl-n5 {
    margin-top: -1.25rem !important;
  }

  .mt-xl-n6 {
    margin-top: -1.5rem !important;
  }

  .mt-xl-n7 {
    margin-top: -1.75rem !important;
  }

  .mt-xl-n8 {
    margin-top: -2rem !important;
  }

  .mt-xl-n9 {
    margin-top: -2.25rem !important;
  }

  .mt-xl-n10 {
    margin-top: -2.5rem !important;
  }

  .mt-xl-n11 {
    margin-top: -2.75rem !important;
  }

  .mt-xl-n12 {
    margin-top: -3rem !important;
  }

  .mt-xl-n13 {
    margin-top: -3.25rem !important;
  }

  .mt-xl-n14 {
    margin-top: -3.5rem !important;
  }

  .mt-xl-n15 {
    margin-top: -3.75rem !important;
  }

  .mt-xl-n16 {
    margin-top: -4rem !important;
  }

  .mt-xl-n17 {
    margin-top: -4.25rem !important;
  }

  .mt-xl-n18 {
    margin-top: -4.5rem !important;
  }

  .mt-xl-n19 {
    margin-top: -4.75rem !important;
  }

  .mt-xl-n20 {
    margin-top: -5rem !important;
  }

  .me-xl-n1 {
    margin-right: -0.25rem !important;
  }

  .me-xl-n2 {
    margin-right: -0.5rem !important;
  }

  .me-xl-n3 {
    margin-right: -0.75rem !important;
  }

  .me-xl-n4 {
    margin-right: -1rem !important;
  }

  .me-xl-n5 {
    margin-right: -1.25rem !important;
  }

  .me-xl-n6 {
    margin-right: -1.5rem !important;
  }

  .me-xl-n7 {
    margin-right: -1.75rem !important;
  }

  .me-xl-n8 {
    margin-right: -2rem !important;
  }

  .me-xl-n9 {
    margin-right: -2.25rem !important;
  }

  .me-xl-n10 {
    margin-right: -2.5rem !important;
  }

  .me-xl-n11 {
    margin-right: -2.75rem !important;
  }

  .me-xl-n12 {
    margin-right: -3rem !important;
  }

  .me-xl-n13 {
    margin-right: -3.25rem !important;
  }

  .me-xl-n14 {
    margin-right: -3.5rem !important;
  }

  .me-xl-n15 {
    margin-right: -3.75rem !important;
  }

  .me-xl-n16 {
    margin-right: -4rem !important;
  }

  .me-xl-n17 {
    margin-right: -4.25rem !important;
  }

  .me-xl-n18 {
    margin-right: -4.5rem !important;
  }

  .me-xl-n19 {
    margin-right: -4.75rem !important;
  }

  .me-xl-n20 {
    margin-right: -5rem !important;
  }

  .mb-xl-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-xl-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-xl-n3 {
    margin-bottom: -0.75rem !important;
  }

  .mb-xl-n4 {
    margin-bottom: -1rem !important;
  }

  .mb-xl-n5 {
    margin-bottom: -1.25rem !important;
  }

  .mb-xl-n6 {
    margin-bottom: -1.5rem !important;
  }

  .mb-xl-n7 {
    margin-bottom: -1.75rem !important;
  }

  .mb-xl-n8 {
    margin-bottom: -2rem !important;
  }

  .mb-xl-n9 {
    margin-bottom: -2.25rem !important;
  }

  .mb-xl-n10 {
    margin-bottom: -2.5rem !important;
  }

  .mb-xl-n11 {
    margin-bottom: -2.75rem !important;
  }

  .mb-xl-n12 {
    margin-bottom: -3rem !important;
  }

  .mb-xl-n13 {
    margin-bottom: -3.25rem !important;
  }

  .mb-xl-n14 {
    margin-bottom: -3.5rem !important;
  }

  .mb-xl-n15 {
    margin-bottom: -3.75rem !important;
  }

  .mb-xl-n16 {
    margin-bottom: -4rem !important;
  }

  .mb-xl-n17 {
    margin-bottom: -4.25rem !important;
  }

  .mb-xl-n18 {
    margin-bottom: -4.5rem !important;
  }

  .mb-xl-n19 {
    margin-bottom: -4.75rem !important;
  }

  .mb-xl-n20 {
    margin-bottom: -5rem !important;
  }

  .ms-xl-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-xl-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-xl-n3 {
    margin-left: -0.75rem !important;
  }

  .ms-xl-n4 {
    margin-left: -1rem !important;
  }

  .ms-xl-n5 {
    margin-left: -1.25rem !important;
  }

  .ms-xl-n6 {
    margin-left: -1.5rem !important;
  }

  .ms-xl-n7 {
    margin-left: -1.75rem !important;
  }

  .ms-xl-n8 {
    margin-left: -2rem !important;
  }

  .ms-xl-n9 {
    margin-left: -2.25rem !important;
  }

  .ms-xl-n10 {
    margin-left: -2.5rem !important;
  }

  .ms-xl-n11 {
    margin-left: -2.75rem !important;
  }

  .ms-xl-n12 {
    margin-left: -3rem !important;
  }

  .ms-xl-n13 {
    margin-left: -3.25rem !important;
  }

  .ms-xl-n14 {
    margin-left: -3.5rem !important;
  }

  .ms-xl-n15 {
    margin-left: -3.75rem !important;
  }

  .ms-xl-n16 {
    margin-left: -4rem !important;
  }

  .ms-xl-n17 {
    margin-left: -4.25rem !important;
  }

  .ms-xl-n18 {
    margin-left: -4.5rem !important;
  }

  .ms-xl-n19 {
    margin-left: -4.75rem !important;
  }

  .ms-xl-n20 {
    margin-left: -5rem !important;
  }

  .p-xl-0 {
    padding: 0 !important;
  }

  .p-xl-1 {
    padding: 0.25rem !important;
  }

  .p-xl-2 {
    padding: 0.5rem !important;
  }

  .p-xl-3 {
    padding: 0.75rem !important;
  }

  .p-xl-4 {
    padding: 1rem !important;
  }

  .p-xl-5 {
    padding: 1.25rem !important;
  }

  .p-xl-6 {
    padding: 1.5rem !important;
  }

  .p-xl-7 {
    padding: 1.75rem !important;
  }

  .p-xl-8 {
    padding: 2rem !important;
  }

  .p-xl-9 {
    padding: 2.25rem !important;
  }

  .p-xl-10 {
    padding: 2.5rem !important;
  }

  .p-xl-11 {
    padding: 2.75rem !important;
  }

  .p-xl-12 {
    padding: 3rem !important;
  }

  .p-xl-13 {
    padding: 3.25rem !important;
  }

  .p-xl-14 {
    padding: 3.5rem !important;
  }

  .p-xl-15 {
    padding: 3.75rem !important;
  }

  .p-xl-16 {
    padding: 4rem !important;
  }

  .p-xl-17 {
    padding: 4.25rem !important;
  }

  .p-xl-18 {
    padding: 4.5rem !important;
  }

  .p-xl-19 {
    padding: 4.75rem !important;
  }

  .p-xl-20 {
    padding: 5rem !important;
  }

  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-xl-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }

  .px-xl-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-xl-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }

  .px-xl-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-xl-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }

  .px-xl-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }

  .px-xl-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }

  .px-xl-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }

  .px-xl-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }

  .px-xl-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .px-xl-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }

  .px-xl-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }

  .px-xl-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }

  .px-xl-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  .px-xl-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }

  .px-xl-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }

  .px-xl-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }

  .px-xl-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-xl-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  .py-xl-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-xl-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }

  .py-xl-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-xl-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }

  .py-xl-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .py-xl-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }

  .py-xl-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  .py-xl-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }

  .py-xl-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .py-xl-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }

  .py-xl-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-xl-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }

  .py-xl-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-xl-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }

  .py-xl-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-xl-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }

  .py-xl-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .pt-xl-0 {
    padding-top: 0 !important;
  }

  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }

  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }

  .pt-xl-3 {
    padding-top: 0.75rem !important;
  }

  .pt-xl-4 {
    padding-top: 1rem !important;
  }

  .pt-xl-5 {
    padding-top: 1.25rem !important;
  }

  .pt-xl-6 {
    padding-top: 1.5rem !important;
  }

  .pt-xl-7 {
    padding-top: 1.75rem !important;
  }

  .pt-xl-8 {
    padding-top: 2rem !important;
  }

  .pt-xl-9 {
    padding-top: 2.25rem !important;
  }

  .pt-xl-10 {
    padding-top: 2.5rem !important;
  }

  .pt-xl-11 {
    padding-top: 2.75rem !important;
  }

  .pt-xl-12 {
    padding-top: 3rem !important;
  }

  .pt-xl-13 {
    padding-top: 3.25rem !important;
  }

  .pt-xl-14 {
    padding-top: 3.5rem !important;
  }

  .pt-xl-15 {
    padding-top: 3.75rem !important;
  }

  .pt-xl-16 {
    padding-top: 4rem !important;
  }

  .pt-xl-17 {
    padding-top: 4.25rem !important;
  }

  .pt-xl-18 {
    padding-top: 4.5rem !important;
  }

  .pt-xl-19 {
    padding-top: 4.75rem !important;
  }

  .pt-xl-20 {
    padding-top: 5rem !important;
  }

  .pe-xl-0 {
    padding-right: 0 !important;
  }

  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }

  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }

  .pe-xl-3 {
    padding-right: 0.75rem !important;
  }

  .pe-xl-4 {
    padding-right: 1rem !important;
  }

  .pe-xl-5 {
    padding-right: 1.25rem !important;
  }

  .pe-xl-6 {
    padding-right: 1.5rem !important;
  }

  .pe-xl-7 {
    padding-right: 1.75rem !important;
  }

  .pe-xl-8 {
    padding-right: 2rem !important;
  }

  .pe-xl-9 {
    padding-right: 2.25rem !important;
  }

  .pe-xl-10 {
    padding-right: 2.5rem !important;
  }

  .pe-xl-11 {
    padding-right: 2.75rem !important;
  }

  .pe-xl-12 {
    padding-right: 3rem !important;
  }

  .pe-xl-13 {
    padding-right: 3.25rem !important;
  }

  .pe-xl-14 {
    padding-right: 3.5rem !important;
  }

  .pe-xl-15 {
    padding-right: 3.75rem !important;
  }

  .pe-xl-16 {
    padding-right: 4rem !important;
  }

  .pe-xl-17 {
    padding-right: 4.25rem !important;
  }

  .pe-xl-18 {
    padding-right: 4.5rem !important;
  }

  .pe-xl-19 {
    padding-right: 4.75rem !important;
  }

  .pe-xl-20 {
    padding-right: 5rem !important;
  }

  .pb-xl-0 {
    padding-bottom: 0 !important;
  }

  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-xl-3 {
    padding-bottom: 0.75rem !important;
  }

  .pb-xl-4 {
    padding-bottom: 1rem !important;
  }

  .pb-xl-5 {
    padding-bottom: 1.25rem !important;
  }

  .pb-xl-6 {
    padding-bottom: 1.5rem !important;
  }

  .pb-xl-7 {
    padding-bottom: 1.75rem !important;
  }

  .pb-xl-8 {
    padding-bottom: 2rem !important;
  }

  .pb-xl-9 {
    padding-bottom: 2.25rem !important;
  }

  .pb-xl-10 {
    padding-bottom: 2.5rem !important;
  }

  .pb-xl-11 {
    padding-bottom: 2.75rem !important;
  }

  .pb-xl-12 {
    padding-bottom: 3rem !important;
  }

  .pb-xl-13 {
    padding-bottom: 3.25rem !important;
  }

  .pb-xl-14 {
    padding-bottom: 3.5rem !important;
  }

  .pb-xl-15 {
    padding-bottom: 3.75rem !important;
  }

  .pb-xl-16 {
    padding-bottom: 4rem !important;
  }

  .pb-xl-17 {
    padding-bottom: 4.25rem !important;
  }

  .pb-xl-18 {
    padding-bottom: 4.5rem !important;
  }

  .pb-xl-19 {
    padding-bottom: 4.75rem !important;
  }

  .pb-xl-20 {
    padding-bottom: 5rem !important;
  }

  .ps-xl-0 {
    padding-left: 0 !important;
  }

  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }

  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }

  .ps-xl-3 {
    padding-left: 0.75rem !important;
  }

  .ps-xl-4 {
    padding-left: 1rem !important;
  }

  .ps-xl-5 {
    padding-left: 1.25rem !important;
  }

  .ps-xl-6 {
    padding-left: 1.5rem !important;
  }

  .ps-xl-7 {
    padding-left: 1.75rem !important;
  }

  .ps-xl-8 {
    padding-left: 2rem !important;
  }

  .ps-xl-9 {
    padding-left: 2.25rem !important;
  }

  .ps-xl-10 {
    padding-left: 2.5rem !important;
  }

  .ps-xl-11 {
    padding-left: 2.75rem !important;
  }

  .ps-xl-12 {
    padding-left: 3rem !important;
  }

  .ps-xl-13 {
    padding-left: 3.25rem !important;
  }

  .ps-xl-14 {
    padding-left: 3.5rem !important;
  }

  .ps-xl-15 {
    padding-left: 3.75rem !important;
  }

  .ps-xl-16 {
    padding-left: 4rem !important;
  }

  .ps-xl-17 {
    padding-left: 4.25rem !important;
  }

  .ps-xl-18 {
    padding-left: 4.5rem !important;
  }

  .ps-xl-19 {
    padding-left: 4.75rem !important;
  }

  .ps-xl-20 {
    padding-left: 5rem !important;
  }

  .gap-xl-0 {
    gap: 0 !important;
  }

  .gap-xl-1 {
    gap: 0.25rem !important;
  }

  .gap-xl-2 {
    gap: 0.5rem !important;
  }

  .gap-xl-3 {
    gap: 0.75rem !important;
  }

  .gap-xl-4 {
    gap: 1rem !important;
  }

  .gap-xl-5 {
    gap: 1.25rem !important;
  }

  .gap-xl-6 {
    gap: 1.5rem !important;
  }

  .gap-xl-7 {
    gap: 1.75rem !important;
  }

  .gap-xl-8 {
    gap: 2rem !important;
  }

  .gap-xl-9 {
    gap: 2.25rem !important;
  }

  .gap-xl-10 {
    gap: 2.5rem !important;
  }

  .gap-xl-11 {
    gap: 2.75rem !important;
  }

  .gap-xl-12 {
    gap: 3rem !important;
  }

  .gap-xl-13 {
    gap: 3.25rem !important;
  }

  .gap-xl-14 {
    gap: 3.5rem !important;
  }

  .gap-xl-15 {
    gap: 3.75rem !important;
  }

  .gap-xl-16 {
    gap: 4rem !important;
  }

  .gap-xl-17 {
    gap: 4.25rem !important;
  }

  .gap-xl-18 {
    gap: 4.5rem !important;
  }

  .gap-xl-19 {
    gap: 4.75rem !important;
  }

  .gap-xl-20 {
    gap: 5rem !important;
  }

  .row-gap-xl-0 {
    row-gap: 0 !important;
  }

  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-xl-3 {
    row-gap: 0.75rem !important;
  }

  .row-gap-xl-4 {
    row-gap: 1rem !important;
  }

  .row-gap-xl-5 {
    row-gap: 1.25rem !important;
  }

  .row-gap-xl-6 {
    row-gap: 1.5rem !important;
  }

  .row-gap-xl-7 {
    row-gap: 1.75rem !important;
  }

  .row-gap-xl-8 {
    row-gap: 2rem !important;
  }

  .row-gap-xl-9 {
    row-gap: 2.25rem !important;
  }

  .row-gap-xl-10 {
    row-gap: 2.5rem !important;
  }

  .row-gap-xl-11 {
    row-gap: 2.75rem !important;
  }

  .row-gap-xl-12 {
    row-gap: 3rem !important;
  }

  .row-gap-xl-13 {
    row-gap: 3.25rem !important;
  }

  .row-gap-xl-14 {
    row-gap: 3.5rem !important;
  }

  .row-gap-xl-15 {
    row-gap: 3.75rem !important;
  }

  .row-gap-xl-16 {
    row-gap: 4rem !important;
  }

  .row-gap-xl-17 {
    row-gap: 4.25rem !important;
  }

  .row-gap-xl-18 {
    row-gap: 4.5rem !important;
  }

  .row-gap-xl-19 {
    row-gap: 4.75rem !important;
  }

  .row-gap-xl-20 {
    row-gap: 5rem !important;
  }

  .column-gap-xl-0 {
    column-gap: 0 !important;
  }

  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-xl-3 {
    column-gap: 0.75rem !important;
  }

  .column-gap-xl-4 {
    column-gap: 1rem !important;
  }

  .column-gap-xl-5 {
    column-gap: 1.25rem !important;
  }

  .column-gap-xl-6 {
    column-gap: 1.5rem !important;
  }

  .column-gap-xl-7 {
    column-gap: 1.75rem !important;
  }

  .column-gap-xl-8 {
    column-gap: 2rem !important;
  }

  .column-gap-xl-9 {
    column-gap: 2.25rem !important;
  }

  .column-gap-xl-10 {
    column-gap: 2.5rem !important;
  }

  .column-gap-xl-11 {
    column-gap: 2.75rem !important;
  }

  .column-gap-xl-12 {
    column-gap: 3rem !important;
  }

  .column-gap-xl-13 {
    column-gap: 3.25rem !important;
  }

  .column-gap-xl-14 {
    column-gap: 3.5rem !important;
  }

  .column-gap-xl-15 {
    column-gap: 3.75rem !important;
  }

  .column-gap-xl-16 {
    column-gap: 4rem !important;
  }

  .column-gap-xl-17 {
    column-gap: 4.25rem !important;
  }

  .column-gap-xl-18 {
    column-gap: 4.5rem !important;
  }

  .column-gap-xl-19 {
    column-gap: 4.75rem !important;
  }

  .column-gap-xl-20 {
    column-gap: 5rem !important;
  }

  .text-xl-start {
    text-align: left !important;
  }

  .text-xl-end {
    text-align: right !important;
  }

  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }

  .float-xxl-end {
    float: right !important;
  }

  .float-xxl-none {
    float: none !important;
  }

  .object-fit-xxl-contain {
    object-fit: contain !important;
  }

  .object-fit-xxl-cover {
    object-fit: cover !important;
  }

  .object-fit-xxl-fill {
    object-fit: fill !important;
  }

  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }

  .object-fit-xxl-none {
    object-fit: none !important;
  }

  .d-xxl-inline {
    display: inline !important;
  }

  .d-xxl-inline-block {
    display: inline-block !important;
  }

  .d-xxl-block {
    display: block !important;
  }

  .d-xxl-grid {
    display: grid !important;
  }

  .d-xxl-inline-grid {
    display: inline-grid !important;
  }

  .d-xxl-table {
    display: table !important;
  }

  .d-xxl-table-row {
    display: table-row !important;
  }

  .d-xxl-table-cell {
    display: table-cell !important;
  }

  .d-xxl-flex {
    display: flex !important;
  }

  .d-xxl-inline-flex {
    display: inline-flex !important;
  }

  .d-xxl-none {
    display: none !important;
  }

  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xxl-row {
    flex-direction: row !important;
  }

  .flex-xxl-column {
    flex-direction: column !important;
  }

  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xxl-center {
    justify-content: center !important;
  }

  .justify-content-xxl-between {
    justify-content: space-between !important;
  }

  .justify-content-xxl-around {
    justify-content: space-around !important;
  }

  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-xxl-start {
    align-items: flex-start !important;
  }

  .align-items-xxl-end {
    align-items: flex-end !important;
  }

  .align-items-xxl-center {
    align-items: center !important;
  }

  .align-items-xxl-baseline {
    align-items: baseline !important;
  }

  .align-items-xxl-stretch {
    align-items: stretch !important;
  }

  .align-content-xxl-start {
    align-content: flex-start !important;
  }

  .align-content-xxl-end {
    align-content: flex-end !important;
  }

  .align-content-xxl-center {
    align-content: center !important;
  }

  .align-content-xxl-between {
    align-content: space-between !important;
  }

  .align-content-xxl-around {
    align-content: space-around !important;
  }

  .align-content-xxl-stretch {
    align-content: stretch !important;
  }

  .align-self-xxl-auto {
    align-self: auto !important;
  }

  .align-self-xxl-start {
    align-self: flex-start !important;
  }

  .align-self-xxl-end {
    align-self: flex-end !important;
  }

  .align-self-xxl-center {
    align-self: center !important;
  }

  .align-self-xxl-baseline {
    align-self: baseline !important;
  }

  .align-self-xxl-stretch {
    align-self: stretch !important;
  }

  .order-xxl-first {
    order: -1 !important;
  }

  .order-xxl-0 {
    order: 0 !important;
  }

  .order-xxl-1 {
    order: 1 !important;
  }

  .order-xxl-2 {
    order: 2 !important;
  }

  .order-xxl-3 {
    order: 3 !important;
  }

  .order-xxl-4 {
    order: 4 !important;
  }

  .order-xxl-5 {
    order: 5 !important;
  }

  .order-xxl-last {
    order: 6 !important;
  }

  .m-xxl-0 {
    margin: 0 !important;
  }

  .m-xxl-1 {
    margin: 0.25rem !important;
  }

  .m-xxl-2 {
    margin: 0.5rem !important;
  }

  .m-xxl-3 {
    margin: 0.75rem !important;
  }

  .m-xxl-4 {
    margin: 1rem !important;
  }

  .m-xxl-5 {
    margin: 1.25rem !important;
  }

  .m-xxl-6 {
    margin: 1.5rem !important;
  }

  .m-xxl-7 {
    margin: 1.75rem !important;
  }

  .m-xxl-8 {
    margin: 2rem !important;
  }

  .m-xxl-9 {
    margin: 2.25rem !important;
  }

  .m-xxl-10 {
    margin: 2.5rem !important;
  }

  .m-xxl-11 {
    margin: 2.75rem !important;
  }

  .m-xxl-12 {
    margin: 3rem !important;
  }

  .m-xxl-13 {
    margin: 3.25rem !important;
  }

  .m-xxl-14 {
    margin: 3.5rem !important;
  }

  .m-xxl-15 {
    margin: 3.75rem !important;
  }

  .m-xxl-16 {
    margin: 4rem !important;
  }

  .m-xxl-17 {
    margin: 4.25rem !important;
  }

  .m-xxl-18 {
    margin: 4.5rem !important;
  }

  .m-xxl-19 {
    margin: 4.75rem !important;
  }

  .m-xxl-20 {
    margin: 5rem !important;
  }

  .m-xxl-auto {
    margin: auto !important;
  }

  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-xxl-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }

  .mx-xxl-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-xxl-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }

  .mx-xxl-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-xxl-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }

  .mx-xxl-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }

  .mx-xxl-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }

  .mx-xxl-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }

  .mx-xxl-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }

  .mx-xxl-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-xxl-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }

  .mx-xxl-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }

  .mx-xxl-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }

  .mx-xxl-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  .mx-xxl-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }

  .mx-xxl-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }

  .mx-xxl-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }

  .mx-xxl-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-xxl-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }

  .my-xxl-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-xxl-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }

  .my-xxl-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-xxl-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }

  .my-xxl-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  .my-xxl-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }

  .my-xxl-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  .my-xxl-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }

  .my-xxl-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-xxl-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }

  .my-xxl-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-xxl-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }

  .my-xxl-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-xxl-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }

  .my-xxl-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-xxl-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }

  .my-xxl-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-xxl-0 {
    margin-top: 0 !important;
  }

  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }

  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }

  .mt-xxl-3 {
    margin-top: 0.75rem !important;
  }

  .mt-xxl-4 {
    margin-top: 1rem !important;
  }

  .mt-xxl-5 {
    margin-top: 1.25rem !important;
  }

  .mt-xxl-6 {
    margin-top: 1.5rem !important;
  }

  .mt-xxl-7 {
    margin-top: 1.75rem !important;
  }

  .mt-xxl-8 {
    margin-top: 2rem !important;
  }

  .mt-xxl-9 {
    margin-top: 2.25rem !important;
  }

  .mt-xxl-10 {
    margin-top: 2.5rem !important;
  }

  .mt-xxl-11 {
    margin-top: 2.75rem !important;
  }

  .mt-xxl-12 {
    margin-top: 3rem !important;
  }

  .mt-xxl-13 {
    margin-top: 3.25rem !important;
  }

  .mt-xxl-14 {
    margin-top: 3.5rem !important;
  }

  .mt-xxl-15 {
    margin-top: 3.75rem !important;
  }

  .mt-xxl-16 {
    margin-top: 4rem !important;
  }

  .mt-xxl-17 {
    margin-top: 4.25rem !important;
  }

  .mt-xxl-18 {
    margin-top: 4.5rem !important;
  }

  .mt-xxl-19 {
    margin-top: 4.75rem !important;
  }

  .mt-xxl-20 {
    margin-top: 5rem !important;
  }

  .mt-xxl-auto {
    margin-top: auto !important;
  }

  .me-xxl-0 {
    margin-right: 0 !important;
  }

  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }

  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }

  .me-xxl-3 {
    margin-right: 0.75rem !important;
  }

  .me-xxl-4 {
    margin-right: 1rem !important;
  }

  .me-xxl-5 {
    margin-right: 1.25rem !important;
  }

  .me-xxl-6 {
    margin-right: 1.5rem !important;
  }

  .me-xxl-7 {
    margin-right: 1.75rem !important;
  }

  .me-xxl-8 {
    margin-right: 2rem !important;
  }

  .me-xxl-9 {
    margin-right: 2.25rem !important;
  }

  .me-xxl-10 {
    margin-right: 2.5rem !important;
  }

  .me-xxl-11 {
    margin-right: 2.75rem !important;
  }

  .me-xxl-12 {
    margin-right: 3rem !important;
  }

  .me-xxl-13 {
    margin-right: 3.25rem !important;
  }

  .me-xxl-14 {
    margin-right: 3.5rem !important;
  }

  .me-xxl-15 {
    margin-right: 3.75rem !important;
  }

  .me-xxl-16 {
    margin-right: 4rem !important;
  }

  .me-xxl-17 {
    margin-right: 4.25rem !important;
  }

  .me-xxl-18 {
    margin-right: 4.5rem !important;
  }

  .me-xxl-19 {
    margin-right: 4.75rem !important;
  }

  .me-xxl-20 {
    margin-right: 5rem !important;
  }

  .me-xxl-auto {
    margin-right: auto !important;
  }

  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }

  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-xxl-3 {
    margin-bottom: 0.75rem !important;
  }

  .mb-xxl-4 {
    margin-bottom: 1rem !important;
  }

  .mb-xxl-5 {
    margin-bottom: 1.25rem !important;
  }

  .mb-xxl-6 {
    margin-bottom: 1.5rem !important;
  }

  .mb-xxl-7 {
    margin-bottom: 1.75rem !important;
  }

  .mb-xxl-8 {
    margin-bottom: 2rem !important;
  }

  .mb-xxl-9 {
    margin-bottom: 2.25rem !important;
  }

  .mb-xxl-10 {
    margin-bottom: 2.5rem !important;
  }

  .mb-xxl-11 {
    margin-bottom: 2.75rem !important;
  }

  .mb-xxl-12 {
    margin-bottom: 3rem !important;
  }

  .mb-xxl-13 {
    margin-bottom: 3.25rem !important;
  }

  .mb-xxl-14 {
    margin-bottom: 3.5rem !important;
  }

  .mb-xxl-15 {
    margin-bottom: 3.75rem !important;
  }

  .mb-xxl-16 {
    margin-bottom: 4rem !important;
  }

  .mb-xxl-17 {
    margin-bottom: 4.25rem !important;
  }

  .mb-xxl-18 {
    margin-bottom: 4.5rem !important;
  }

  .mb-xxl-19 {
    margin-bottom: 4.75rem !important;
  }

  .mb-xxl-20 {
    margin-bottom: 5rem !important;
  }

  .mb-xxl-auto {
    margin-bottom: auto !important;
  }

  .ms-xxl-0 {
    margin-left: 0 !important;
  }

  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }

  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }

  .ms-xxl-3 {
    margin-left: 0.75rem !important;
  }

  .ms-xxl-4 {
    margin-left: 1rem !important;
  }

  .ms-xxl-5 {
    margin-left: 1.25rem !important;
  }

  .ms-xxl-6 {
    margin-left: 1.5rem !important;
  }

  .ms-xxl-7 {
    margin-left: 1.75rem !important;
  }

  .ms-xxl-8 {
    margin-left: 2rem !important;
  }

  .ms-xxl-9 {
    margin-left: 2.25rem !important;
  }

  .ms-xxl-10 {
    margin-left: 2.5rem !important;
  }

  .ms-xxl-11 {
    margin-left: 2.75rem !important;
  }

  .ms-xxl-12 {
    margin-left: 3rem !important;
  }

  .ms-xxl-13 {
    margin-left: 3.25rem !important;
  }

  .ms-xxl-14 {
    margin-left: 3.5rem !important;
  }

  .ms-xxl-15 {
    margin-left: 3.75rem !important;
  }

  .ms-xxl-16 {
    margin-left: 4rem !important;
  }

  .ms-xxl-17 {
    margin-left: 4.25rem !important;
  }

  .ms-xxl-18 {
    margin-left: 4.5rem !important;
  }

  .ms-xxl-19 {
    margin-left: 4.75rem !important;
  }

  .ms-xxl-20 {
    margin-left: 5rem !important;
  }

  .ms-xxl-auto {
    margin-left: auto !important;
  }

  .m-xxl-n1 {
    margin: -0.25rem !important;
  }

  .m-xxl-n2 {
    margin: -0.5rem !important;
  }

  .m-xxl-n3 {
    margin: -0.75rem !important;
  }

  .m-xxl-n4 {
    margin: -1rem !important;
  }

  .m-xxl-n5 {
    margin: -1.25rem !important;
  }

  .m-xxl-n6 {
    margin: -1.5rem !important;
  }

  .m-xxl-n7 {
    margin: -1.75rem !important;
  }

  .m-xxl-n8 {
    margin: -2rem !important;
  }

  .m-xxl-n9 {
    margin: -2.25rem !important;
  }

  .m-xxl-n10 {
    margin: -2.5rem !important;
  }

  .m-xxl-n11 {
    margin: -2.75rem !important;
  }

  .m-xxl-n12 {
    margin: -3rem !important;
  }

  .m-xxl-n13 {
    margin: -3.25rem !important;
  }

  .m-xxl-n14 {
    margin: -3.5rem !important;
  }

  .m-xxl-n15 {
    margin: -3.75rem !important;
  }

  .m-xxl-n16 {
    margin: -4rem !important;
  }

  .m-xxl-n17 {
    margin: -4.25rem !important;
  }

  .m-xxl-n18 {
    margin: -4.5rem !important;
  }

  .m-xxl-n19 {
    margin: -4.75rem !important;
  }

  .m-xxl-n20 {
    margin: -5rem !important;
  }

  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-xxl-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }

  .mx-xxl-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-xxl-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }

  .mx-xxl-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-xxl-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }

  .mx-xxl-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }

  .mx-xxl-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }

  .mx-xxl-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }

  .mx-xxl-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }

  .mx-xxl-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .mx-xxl-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }

  .mx-xxl-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }

  .mx-xxl-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }

  .mx-xxl-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }

  .mx-xxl-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }

  .mx-xxl-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }

  .mx-xxl-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }

  .mx-xxl-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }

  .my-xxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-xxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-xxl-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }

  .my-xxl-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-xxl-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }

  .my-xxl-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-xxl-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }

  .my-xxl-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }

  .my-xxl-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }

  .my-xxl-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }

  .my-xxl-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }

  .my-xxl-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .my-xxl-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }

  .my-xxl-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }

  .my-xxl-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }

  .my-xxl-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }

  .my-xxl-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }

  .my-xxl-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }

  .my-xxl-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }

  .my-xxl-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }

  .mt-xxl-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-xxl-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-xxl-n3 {
    margin-top: -0.75rem !important;
  }

  .mt-xxl-n4 {
    margin-top: -1rem !important;
  }

  .mt-xxl-n5 {
    margin-top: -1.25rem !important;
  }

  .mt-xxl-n6 {
    margin-top: -1.5rem !important;
  }

  .mt-xxl-n7 {
    margin-top: -1.75rem !important;
  }

  .mt-xxl-n8 {
    margin-top: -2rem !important;
  }

  .mt-xxl-n9 {
    margin-top: -2.25rem !important;
  }

  .mt-xxl-n10 {
    margin-top: -2.5rem !important;
  }

  .mt-xxl-n11 {
    margin-top: -2.75rem !important;
  }

  .mt-xxl-n12 {
    margin-top: -3rem !important;
  }

  .mt-xxl-n13 {
    margin-top: -3.25rem !important;
  }

  .mt-xxl-n14 {
    margin-top: -3.5rem !important;
  }

  .mt-xxl-n15 {
    margin-top: -3.75rem !important;
  }

  .mt-xxl-n16 {
    margin-top: -4rem !important;
  }

  .mt-xxl-n17 {
    margin-top: -4.25rem !important;
  }

  .mt-xxl-n18 {
    margin-top: -4.5rem !important;
  }

  .mt-xxl-n19 {
    margin-top: -4.75rem !important;
  }

  .mt-xxl-n20 {
    margin-top: -5rem !important;
  }

  .me-xxl-n1 {
    margin-right: -0.25rem !important;
  }

  .me-xxl-n2 {
    margin-right: -0.5rem !important;
  }

  .me-xxl-n3 {
    margin-right: -0.75rem !important;
  }

  .me-xxl-n4 {
    margin-right: -1rem !important;
  }

  .me-xxl-n5 {
    margin-right: -1.25rem !important;
  }

  .me-xxl-n6 {
    margin-right: -1.5rem !important;
  }

  .me-xxl-n7 {
    margin-right: -1.75rem !important;
  }

  .me-xxl-n8 {
    margin-right: -2rem !important;
  }

  .me-xxl-n9 {
    margin-right: -2.25rem !important;
  }

  .me-xxl-n10 {
    margin-right: -2.5rem !important;
  }

  .me-xxl-n11 {
    margin-right: -2.75rem !important;
  }

  .me-xxl-n12 {
    margin-right: -3rem !important;
  }

  .me-xxl-n13 {
    margin-right: -3.25rem !important;
  }

  .me-xxl-n14 {
    margin-right: -3.5rem !important;
  }

  .me-xxl-n15 {
    margin-right: -3.75rem !important;
  }

  .me-xxl-n16 {
    margin-right: -4rem !important;
  }

  .me-xxl-n17 {
    margin-right: -4.25rem !important;
  }

  .me-xxl-n18 {
    margin-right: -4.5rem !important;
  }

  .me-xxl-n19 {
    margin-right: -4.75rem !important;
  }

  .me-xxl-n20 {
    margin-right: -5rem !important;
  }

  .mb-xxl-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-xxl-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-xxl-n3 {
    margin-bottom: -0.75rem !important;
  }

  .mb-xxl-n4 {
    margin-bottom: -1rem !important;
  }

  .mb-xxl-n5 {
    margin-bottom: -1.25rem !important;
  }

  .mb-xxl-n6 {
    margin-bottom: -1.5rem !important;
  }

  .mb-xxl-n7 {
    margin-bottom: -1.75rem !important;
  }

  .mb-xxl-n8 {
    margin-bottom: -2rem !important;
  }

  .mb-xxl-n9 {
    margin-bottom: -2.25rem !important;
  }

  .mb-xxl-n10 {
    margin-bottom: -2.5rem !important;
  }

  .mb-xxl-n11 {
    margin-bottom: -2.75rem !important;
  }

  .mb-xxl-n12 {
    margin-bottom: -3rem !important;
  }

  .mb-xxl-n13 {
    margin-bottom: -3.25rem !important;
  }

  .mb-xxl-n14 {
    margin-bottom: -3.5rem !important;
  }

  .mb-xxl-n15 {
    margin-bottom: -3.75rem !important;
  }

  .mb-xxl-n16 {
    margin-bottom: -4rem !important;
  }

  .mb-xxl-n17 {
    margin-bottom: -4.25rem !important;
  }

  .mb-xxl-n18 {
    margin-bottom: -4.5rem !important;
  }

  .mb-xxl-n19 {
    margin-bottom: -4.75rem !important;
  }

  .mb-xxl-n20 {
    margin-bottom: -5rem !important;
  }

  .ms-xxl-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-xxl-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-xxl-n3 {
    margin-left: -0.75rem !important;
  }

  .ms-xxl-n4 {
    margin-left: -1rem !important;
  }

  .ms-xxl-n5 {
    margin-left: -1.25rem !important;
  }

  .ms-xxl-n6 {
    margin-left: -1.5rem !important;
  }

  .ms-xxl-n7 {
    margin-left: -1.75rem !important;
  }

  .ms-xxl-n8 {
    margin-left: -2rem !important;
  }

  .ms-xxl-n9 {
    margin-left: -2.25rem !important;
  }

  .ms-xxl-n10 {
    margin-left: -2.5rem !important;
  }

  .ms-xxl-n11 {
    margin-left: -2.75rem !important;
  }

  .ms-xxl-n12 {
    margin-left: -3rem !important;
  }

  .ms-xxl-n13 {
    margin-left: -3.25rem !important;
  }

  .ms-xxl-n14 {
    margin-left: -3.5rem !important;
  }

  .ms-xxl-n15 {
    margin-left: -3.75rem !important;
  }

  .ms-xxl-n16 {
    margin-left: -4rem !important;
  }

  .ms-xxl-n17 {
    margin-left: -4.25rem !important;
  }

  .ms-xxl-n18 {
    margin-left: -4.5rem !important;
  }

  .ms-xxl-n19 {
    margin-left: -4.75rem !important;
  }

  .ms-xxl-n20 {
    margin-left: -5rem !important;
  }

  .p-xxl-0 {
    padding: 0 !important;
  }

  .p-xxl-1 {
    padding: 0.25rem !important;
  }

  .p-xxl-2 {
    padding: 0.5rem !important;
  }

  .p-xxl-3 {
    padding: 0.75rem !important;
  }

  .p-xxl-4 {
    padding: 1rem !important;
  }

  .p-xxl-5 {
    padding: 1.25rem !important;
  }

  .p-xxl-6 {
    padding: 1.5rem !important;
  }

  .p-xxl-7 {
    padding: 1.75rem !important;
  }

  .p-xxl-8 {
    padding: 2rem !important;
  }

  .p-xxl-9 {
    padding: 2.25rem !important;
  }

  .p-xxl-10 {
    padding: 2.5rem !important;
  }

  .p-xxl-11 {
    padding: 2.75rem !important;
  }

  .p-xxl-12 {
    padding: 3rem !important;
  }

  .p-xxl-13 {
    padding: 3.25rem !important;
  }

  .p-xxl-14 {
    padding: 3.5rem !important;
  }

  .p-xxl-15 {
    padding: 3.75rem !important;
  }

  .p-xxl-16 {
    padding: 4rem !important;
  }

  .p-xxl-17 {
    padding: 4.25rem !important;
  }

  .p-xxl-18 {
    padding: 4.5rem !important;
  }

  .p-xxl-19 {
    padding: 4.75rem !important;
  }

  .p-xxl-20 {
    padding: 5rem !important;
  }

  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-xxl-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }

  .px-xxl-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-xxl-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }

  .px-xxl-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-xxl-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }

  .px-xxl-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }

  .px-xxl-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }

  .px-xxl-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }

  .px-xxl-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }

  .px-xxl-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .px-xxl-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }

  .px-xxl-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }

  .px-xxl-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }

  .px-xxl-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  .px-xxl-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }

  .px-xxl-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }

  .px-xxl-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }

  .px-xxl-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-xxl-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  .py-xxl-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-xxl-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }

  .py-xxl-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-xxl-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }

  .py-xxl-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .py-xxl-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }

  .py-xxl-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  .py-xxl-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }

  .py-xxl-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .py-xxl-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }

  .py-xxl-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-xxl-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }

  .py-xxl-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-xxl-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }

  .py-xxl-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-xxl-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }

  .py-xxl-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .pt-xxl-0 {
    padding-top: 0 !important;
  }

  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }

  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }

  .pt-xxl-3 {
    padding-top: 0.75rem !important;
  }

  .pt-xxl-4 {
    padding-top: 1rem !important;
  }

  .pt-xxl-5 {
    padding-top: 1.25rem !important;
  }

  .pt-xxl-6 {
    padding-top: 1.5rem !important;
  }

  .pt-xxl-7 {
    padding-top: 1.75rem !important;
  }

  .pt-xxl-8 {
    padding-top: 2rem !important;
  }

  .pt-xxl-9 {
    padding-top: 2.25rem !important;
  }

  .pt-xxl-10 {
    padding-top: 2.5rem !important;
  }

  .pt-xxl-11 {
    padding-top: 2.75rem !important;
  }

  .pt-xxl-12 {
    padding-top: 3rem !important;
  }

  .pt-xxl-13 {
    padding-top: 3.25rem !important;
  }

  .pt-xxl-14 {
    padding-top: 3.5rem !important;
  }

  .pt-xxl-15 {
    padding-top: 3.75rem !important;
  }

  .pt-xxl-16 {
    padding-top: 4rem !important;
  }

  .pt-xxl-17 {
    padding-top: 4.25rem !important;
  }

  .pt-xxl-18 {
    padding-top: 4.5rem !important;
  }

  .pt-xxl-19 {
    padding-top: 4.75rem !important;
  }

  .pt-xxl-20 {
    padding-top: 5rem !important;
  }

  .pe-xxl-0 {
    padding-right: 0 !important;
  }

  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }

  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }

  .pe-xxl-3 {
    padding-right: 0.75rem !important;
  }

  .pe-xxl-4 {
    padding-right: 1rem !important;
  }

  .pe-xxl-5 {
    padding-right: 1.25rem !important;
  }

  .pe-xxl-6 {
    padding-right: 1.5rem !important;
  }

  .pe-xxl-7 {
    padding-right: 1.75rem !important;
  }

  .pe-xxl-8 {
    padding-right: 2rem !important;
  }

  .pe-xxl-9 {
    padding-right: 2.25rem !important;
  }

  .pe-xxl-10 {
    padding-right: 2.5rem !important;
  }

  .pe-xxl-11 {
    padding-right: 2.75rem !important;
  }

  .pe-xxl-12 {
    padding-right: 3rem !important;
  }

  .pe-xxl-13 {
    padding-right: 3.25rem !important;
  }

  .pe-xxl-14 {
    padding-right: 3.5rem !important;
  }

  .pe-xxl-15 {
    padding-right: 3.75rem !important;
  }

  .pe-xxl-16 {
    padding-right: 4rem !important;
  }

  .pe-xxl-17 {
    padding-right: 4.25rem !important;
  }

  .pe-xxl-18 {
    padding-right: 4.5rem !important;
  }

  .pe-xxl-19 {
    padding-right: 4.75rem !important;
  }

  .pe-xxl-20 {
    padding-right: 5rem !important;
  }

  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }

  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-xxl-3 {
    padding-bottom: 0.75rem !important;
  }

  .pb-xxl-4 {
    padding-bottom: 1rem !important;
  }

  .pb-xxl-5 {
    padding-bottom: 1.25rem !important;
  }

  .pb-xxl-6 {
    padding-bottom: 1.5rem !important;
  }

  .pb-xxl-7 {
    padding-bottom: 1.75rem !important;
  }

  .pb-xxl-8 {
    padding-bottom: 2rem !important;
  }

  .pb-xxl-9 {
    padding-bottom: 2.25rem !important;
  }

  .pb-xxl-10 {
    padding-bottom: 2.5rem !important;
  }

  .pb-xxl-11 {
    padding-bottom: 2.75rem !important;
  }

  .pb-xxl-12 {
    padding-bottom: 3rem !important;
  }

  .pb-xxl-13 {
    padding-bottom: 3.25rem !important;
  }

  .pb-xxl-14 {
    padding-bottom: 3.5rem !important;
  }

  .pb-xxl-15 {
    padding-bottom: 3.75rem !important;
  }

  .pb-xxl-16 {
    padding-bottom: 4rem !important;
  }

  .pb-xxl-17 {
    padding-bottom: 4.25rem !important;
  }

  .pb-xxl-18 {
    padding-bottom: 4.5rem !important;
  }

  .pb-xxl-19 {
    padding-bottom: 4.75rem !important;
  }

  .pb-xxl-20 {
    padding-bottom: 5rem !important;
  }

  .ps-xxl-0 {
    padding-left: 0 !important;
  }

  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }

  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }

  .ps-xxl-3 {
    padding-left: 0.75rem !important;
  }

  .ps-xxl-4 {
    padding-left: 1rem !important;
  }

  .ps-xxl-5 {
    padding-left: 1.25rem !important;
  }

  .ps-xxl-6 {
    padding-left: 1.5rem !important;
  }

  .ps-xxl-7 {
    padding-left: 1.75rem !important;
  }

  .ps-xxl-8 {
    padding-left: 2rem !important;
  }

  .ps-xxl-9 {
    padding-left: 2.25rem !important;
  }

  .ps-xxl-10 {
    padding-left: 2.5rem !important;
  }

  .ps-xxl-11 {
    padding-left: 2.75rem !important;
  }

  .ps-xxl-12 {
    padding-left: 3rem !important;
  }

  .ps-xxl-13 {
    padding-left: 3.25rem !important;
  }

  .ps-xxl-14 {
    padding-left: 3.5rem !important;
  }

  .ps-xxl-15 {
    padding-left: 3.75rem !important;
  }

  .ps-xxl-16 {
    padding-left: 4rem !important;
  }

  .ps-xxl-17 {
    padding-left: 4.25rem !important;
  }

  .ps-xxl-18 {
    padding-left: 4.5rem !important;
  }

  .ps-xxl-19 {
    padding-left: 4.75rem !important;
  }

  .ps-xxl-20 {
    padding-left: 5rem !important;
  }

  .gap-xxl-0 {
    gap: 0 !important;
  }

  .gap-xxl-1 {
    gap: 0.25rem !important;
  }

  .gap-xxl-2 {
    gap: 0.5rem !important;
  }

  .gap-xxl-3 {
    gap: 0.75rem !important;
  }

  .gap-xxl-4 {
    gap: 1rem !important;
  }

  .gap-xxl-5 {
    gap: 1.25rem !important;
  }

  .gap-xxl-6 {
    gap: 1.5rem !important;
  }

  .gap-xxl-7 {
    gap: 1.75rem !important;
  }

  .gap-xxl-8 {
    gap: 2rem !important;
  }

  .gap-xxl-9 {
    gap: 2.25rem !important;
  }

  .gap-xxl-10 {
    gap: 2.5rem !important;
  }

  .gap-xxl-11 {
    gap: 2.75rem !important;
  }

  .gap-xxl-12 {
    gap: 3rem !important;
  }

  .gap-xxl-13 {
    gap: 3.25rem !important;
  }

  .gap-xxl-14 {
    gap: 3.5rem !important;
  }

  .gap-xxl-15 {
    gap: 3.75rem !important;
  }

  .gap-xxl-16 {
    gap: 4rem !important;
  }

  .gap-xxl-17 {
    gap: 4.25rem !important;
  }

  .gap-xxl-18 {
    gap: 4.5rem !important;
  }

  .gap-xxl-19 {
    gap: 4.75rem !important;
  }

  .gap-xxl-20 {
    gap: 5rem !important;
  }

  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }

  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-xxl-3 {
    row-gap: 0.75rem !important;
  }

  .row-gap-xxl-4 {
    row-gap: 1rem !important;
  }

  .row-gap-xxl-5 {
    row-gap: 1.25rem !important;
  }

  .row-gap-xxl-6 {
    row-gap: 1.5rem !important;
  }

  .row-gap-xxl-7 {
    row-gap: 1.75rem !important;
  }

  .row-gap-xxl-8 {
    row-gap: 2rem !important;
  }

  .row-gap-xxl-9 {
    row-gap: 2.25rem !important;
  }

  .row-gap-xxl-10 {
    row-gap: 2.5rem !important;
  }

  .row-gap-xxl-11 {
    row-gap: 2.75rem !important;
  }

  .row-gap-xxl-12 {
    row-gap: 3rem !important;
  }

  .row-gap-xxl-13 {
    row-gap: 3.25rem !important;
  }

  .row-gap-xxl-14 {
    row-gap: 3.5rem !important;
  }

  .row-gap-xxl-15 {
    row-gap: 3.75rem !important;
  }

  .row-gap-xxl-16 {
    row-gap: 4rem !important;
  }

  .row-gap-xxl-17 {
    row-gap: 4.25rem !important;
  }

  .row-gap-xxl-18 {
    row-gap: 4.5rem !important;
  }

  .row-gap-xxl-19 {
    row-gap: 4.75rem !important;
  }

  .row-gap-xxl-20 {
    row-gap: 5rem !important;
  }

  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }

  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-xxl-3 {
    column-gap: 0.75rem !important;
  }

  .column-gap-xxl-4 {
    column-gap: 1rem !important;
  }

  .column-gap-xxl-5 {
    column-gap: 1.25rem !important;
  }

  .column-gap-xxl-6 {
    column-gap: 1.5rem !important;
  }

  .column-gap-xxl-7 {
    column-gap: 1.75rem !important;
  }

  .column-gap-xxl-8 {
    column-gap: 2rem !important;
  }

  .column-gap-xxl-9 {
    column-gap: 2.25rem !important;
  }

  .column-gap-xxl-10 {
    column-gap: 2.5rem !important;
  }

  .column-gap-xxl-11 {
    column-gap: 2.75rem !important;
  }

  .column-gap-xxl-12 {
    column-gap: 3rem !important;
  }

  .column-gap-xxl-13 {
    column-gap: 3.25rem !important;
  }

  .column-gap-xxl-14 {
    column-gap: 3.5rem !important;
  }

  .column-gap-xxl-15 {
    column-gap: 3.75rem !important;
  }

  .column-gap-xxl-16 {
    column-gap: 4rem !important;
  }

  .column-gap-xxl-17 {
    column-gap: 4.25rem !important;
  }

  .column-gap-xxl-18 {
    column-gap: 4.5rem !important;
  }

  .column-gap-xxl-19 {
    column-gap: 4.75rem !important;
  }

  .column-gap-xxl-20 {
    column-gap: 5rem !important;
  }

  .text-xxl-start {
    text-align: left !important;
  }

  .text-xxl-end {
    text-align: right !important;
  }

  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 1.75rem !important;
  }

  .fs-2 {
    font-size: 1.5rem !important;
  }

  .fs-3 {
    font-size: 1.35rem !important;
  }

  .fs-2x {
    font-size: 2rem !important;
  }

  .fs-2qx {
    font-size: 2.25rem !important;
  }

  .fs-2hx {
    font-size: 2.5rem !important;
  }

  .fs-2tx {
    font-size: 2.75rem !important;
  }

  .fs-3x {
    font-size: 3rem !important;
  }

  .fs-3qx {
    font-size: 3.25rem !important;
  }

  .fs-3hx {
    font-size: 3.5rem !important;
  }

  .fs-3tx {
    font-size: 3.75rem !important;
  }

  .fs-4x {
    font-size: 4rem !important;
  }

  .fs-4qx {
    font-size: 4.25rem !important;
  }

  .fs-4hx {
    font-size: 4.5rem !important;
  }

  .fs-4tx {
    font-size: 4.75rem !important;
  }

  .fs-5x {
    font-size: 5rem !important;
  }

  .fs-5qx {
    font-size: 5.25rem !important;
  }

  .fs-5hx {
    font-size: 5.5rem !important;
  }

  .fs-5tx {
    font-size: 5.75rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }

  .d-print-inline-block {
    display: inline-block !important;
  }

  .d-print-block {
    display: block !important;
  }

  .d-print-grid {
    display: grid !important;
  }

  .d-print-inline-grid {
    display: inline-grid !important;
  }

  .d-print-table {
    display: table !important;
  }

  .d-print-table-row {
    display: table-row !important;
  }

  .d-print-table-cell {
    display: table-cell !important;
  }

  .d-print-flex {
    display: flex !important;
  }

  .d-print-inline-flex {
    display: inline-flex !important;
  }

  .d-print-none {
    display: none !important;
  }
}
body > iframe[style*="2147483647"] {
  display: none;
}

:root,
[data-bs-theme=light] {
  --bs-blue: #009ef6;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-gray: #7E8299;
  --bs-gray-dark: #3F4254;
  --bs-gray-100: #F5F8FA;
  --bs-gray-200: #EFF2F5;
  --bs-gray-300: #E4E6EF;
  --bs-gray-400: #B5B5C3;
  --bs-gray-500: #A1A5B7;
  --bs-gray-600: #7E8299;
  --bs-gray-700: #5E6278;
  --bs-gray-800: #3F4254;
  --bs-gray-900: #181C32;
  --bs-white: #ffffff;
  --bs-light: #F5F8FA;
  --bs-primary: #009EF7;
  --bs-secondary: #E4E6EF;
  --bs-success: #50CD89;
  --bs-info: #7239EA;
  --bs-warning: #FFC700;
  --bs-danger: #F1416C;
  --bs-dark: #181C32;
  --bs-white-rgb: 255, 255, 255;
  --bs-light-rgb: 245, 248, 250;
  --bs-primary-rgb: 0, 158, 247;
  --bs-secondary-rgb: 228, 230, 239;
  --bs-success-rgb: 80, 205, 137;
  --bs-info-rgb: 114, 57, 234;
  --bs-warning-rgb: 255, 199, 0;
  --bs-danger-rgb: 241, 65, 108;
  --bs-dark-rgb: 24, 28, 50;
  --bs-primary-text-emphasis: #003f63;
  --bs-secondary-text-emphasis: #5b5c60;
  --bs-success-text-emphasis: #205237;
  --bs-info-text-emphasis: #2e175e;
  --bs-warning-text-emphasis: #665000;
  --bs-danger-text-emphasis: #601a2b;
  --bs-light-text-emphasis: #5E6278;
  --bs-dark-text-emphasis: #5E6278;
  --bs-primary-bg-subtle: #ccecfd;
  --bs-secondary-bg-subtle: #fafafc;
  --bs-success-bg-subtle: #dcf5e7;
  --bs-info-bg-subtle: #e3d7fb;
  --bs-warning-bg-subtle: #fff4cc;
  --bs-danger-bg-subtle: #fcd9e2;
  --bs-light-bg-subtle: #fafcfd;
  --bs-dark-bg-subtle: #B5B5C3;
  --bs-primary-border-subtle: #99d8fc;
  --bs-secondary-border-subtle: #f4f5f9;
  --bs-success-border-subtle: #b9ebd0;
  --bs-info-border-subtle: #c7b0f7;
  --bs-warning-border-subtle: #ffe999;
  --bs-danger-border-subtle: #f9b3c4;
  --bs-light-border-subtle: #EFF2F5;
  --bs-dark-border-subtle: #A1A5B7;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: Poppins, Helvetica, "sans-serif";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #181C32;
  --bs-body-color-rgb: 24, 28, 50;
  --bs-body-bg: #ffffff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(24, 28, 50, 0.75);
  --bs-secondary-color-rgb: 24, 28, 50;
  --bs-secondary-bg: #EFF2F5;
  --bs-secondary-bg-rgb: 239, 242, 245;
  --bs-tertiary-color: rgba(24, 28, 50, 0.5);
  --bs-tertiary-color-rgb: 24, 28, 50;
  --bs-tertiary-bg: #F5F8FA;
  --bs-tertiary-bg-rgb: 245, 248, 250;
  --bs-heading-color: #181C32;
  --bs-link-color: #009EF7;
  --bs-link-color-rgb: 0, 158, 247;
  --bs-link-decoration: none;
  --bs-link-hover-color: #006dab;
  --bs-link-hover-color-rgb: 0, 109, 171;
  --bs-link-hover-decoration: underline;
  --bs-code-color: #b93993;
  --bs-highlight-color: #181C32;
  --bs-highlight-bg: #fff3cd;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #EFF2F5;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.475rem;
  --bs-border-radius-sm: 0.275rem;
  --bs-border-radius-lg: 0.775rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-sm: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);
  --bs-box-shadow-lg: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.1);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(0, 158, 247, 0.25);
  --bs-form-valid-color: #50CD89;
  --bs-form-valid-border-color: #50CD89;
  --bs-form-invalid-color: #F1416C;
  --bs-form-invalid-border-color: #F1416C;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 1.75rem;
  }
}

h2, .h2 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.5rem;
  }
}

h3, .h3 {
  font-size: calc(1.26rem + 0.12vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.35rem;
  }
}

h4, .h4 {
  font-size: 1.25rem;
}

h5, .h5 {
  font-size: 1.15rem;
}

h6, .h6 {
  font-size: 1.075rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 500;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: 600;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: none;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
  text-decoration: underline;
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.275rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  line-height: inherit;
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}
[type=search]::-webkit-search-cancel-button {
  cursor: pointer;
  filter: grayscale(1);
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-weight: 600;
  line-height: 1.2;
  font-size: calc(1.625rem + 4.5vw);
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-weight: 600;
  line-height: 1.2;
  font-size: calc(1.575rem + 3.9vw);
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-weight: 600;
  line-height: 1.2;
  font-size: calc(1.525rem + 3.3vw);
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-weight: 600;
  line-height: 1.2;
  font-size: calc(1.475rem + 2.7vw);
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-weight: 600;
  line-height: 1.2;
  font-size: calc(1.425rem + 2.1vw);
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-weight: 600;
  line-height: 1.2;
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #7E8299;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  box-shadow: var(--bs-box-shadow-sm);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * .5);
  padding-left: calc(var(--bs-gutter-x) * .5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-.5 * var(--bs-gutter-x));
  margin-left: calc(-.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * .5);
  padding-left: calc(var(--bs-gutter-x) * .5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0rem;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0rem;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 0.75rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 0.75rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 1.25rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 1.25rem;
}

.g-6,
.gx-6 {
  --bs-gutter-x: 1.5rem;
}

.g-6,
.gy-6 {
  --bs-gutter-y: 1.5rem;
}

.g-7,
.gx-7 {
  --bs-gutter-x: 1.75rem;
}

.g-7,
.gy-7 {
  --bs-gutter-y: 1.75rem;
}

.g-8,
.gx-8 {
  --bs-gutter-x: 2rem;
}

.g-8,
.gy-8 {
  --bs-gutter-y: 2rem;
}

.g-9,
.gx-9 {
  --bs-gutter-x: 2.25rem;
}

.g-9,
.gy-9 {
  --bs-gutter-y: 2.25rem;
}

.g-10,
.gx-10 {
  --bs-gutter-x: 2.5rem;
}

.g-10,
.gy-10 {
  --bs-gutter-y: 2.5rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }

  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-sm-0 {
    margin-left: 0;
  }

  .offset-sm-1 {
    margin-left: 8.33333333%;
  }

  .offset-sm-2 {
    margin-left: 16.66666667%;
  }

  .offset-sm-3 {
    margin-left: 25%;
  }

  .offset-sm-4 {
    margin-left: 33.33333333%;
  }

  .offset-sm-5 {
    margin-left: 41.66666667%;
  }

  .offset-sm-6 {
    margin-left: 50%;
  }

  .offset-sm-7 {
    margin-left: 58.33333333%;
  }

  .offset-sm-8 {
    margin-left: 66.66666667%;
  }

  .offset-sm-9 {
    margin-left: 75%;
  }

  .offset-sm-10 {
    margin-left: 83.33333333%;
  }

  .offset-sm-11 {
    margin-left: 91.66666667%;
  }

  .g-sm-0,
.gx-sm-0 {
    --bs-gutter-x: 0rem;
  }

  .g-sm-0,
.gy-sm-0 {
    --bs-gutter-y: 0rem;
  }

  .g-sm-1,
.gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-sm-1,
.gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-sm-2,
.gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-sm-2,
.gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-sm-3,
.gx-sm-3 {
    --bs-gutter-x: 0.75rem;
  }

  .g-sm-3,
.gy-sm-3 {
    --bs-gutter-y: 0.75rem;
  }

  .g-sm-4,
.gx-sm-4 {
    --bs-gutter-x: 1rem;
  }

  .g-sm-4,
.gy-sm-4 {
    --bs-gutter-y: 1rem;
  }

  .g-sm-5,
.gx-sm-5 {
    --bs-gutter-x: 1.25rem;
  }

  .g-sm-5,
.gy-sm-5 {
    --bs-gutter-y: 1.25rem;
  }

  .g-sm-6,
.gx-sm-6 {
    --bs-gutter-x: 1.5rem;
  }

  .g-sm-6,
.gy-sm-6 {
    --bs-gutter-y: 1.5rem;
  }

  .g-sm-7,
.gx-sm-7 {
    --bs-gutter-x: 1.75rem;
  }

  .g-sm-7,
.gy-sm-7 {
    --bs-gutter-y: 1.75rem;
  }

  .g-sm-8,
.gx-sm-8 {
    --bs-gutter-x: 2rem;
  }

  .g-sm-8,
.gy-sm-8 {
    --bs-gutter-y: 2rem;
  }

  .g-sm-9,
.gx-sm-9 {
    --bs-gutter-x: 2.25rem;
  }

  .g-sm-9,
.gy-sm-9 {
    --bs-gutter-y: 2.25rem;
  }

  .g-sm-10,
.gx-sm-10 {
    --bs-gutter-x: 2.5rem;
  }

  .g-sm-10,
.gy-sm-10 {
    --bs-gutter-y: 2.5rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }

  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-md-0 {
    margin-left: 0;
  }

  .offset-md-1 {
    margin-left: 8.33333333%;
  }

  .offset-md-2 {
    margin-left: 16.66666667%;
  }

  .offset-md-3 {
    margin-left: 25%;
  }

  .offset-md-4 {
    margin-left: 33.33333333%;
  }

  .offset-md-5 {
    margin-left: 41.66666667%;
  }

  .offset-md-6 {
    margin-left: 50%;
  }

  .offset-md-7 {
    margin-left: 58.33333333%;
  }

  .offset-md-8 {
    margin-left: 66.66666667%;
  }

  .offset-md-9 {
    margin-left: 75%;
  }

  .offset-md-10 {
    margin-left: 83.33333333%;
  }

  .offset-md-11 {
    margin-left: 91.66666667%;
  }

  .g-md-0,
.gx-md-0 {
    --bs-gutter-x: 0rem;
  }

  .g-md-0,
.gy-md-0 {
    --bs-gutter-y: 0rem;
  }

  .g-md-1,
.gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-md-1,
.gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-md-2,
.gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-md-2,
.gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-md-3,
.gx-md-3 {
    --bs-gutter-x: 0.75rem;
  }

  .g-md-3,
.gy-md-3 {
    --bs-gutter-y: 0.75rem;
  }

  .g-md-4,
.gx-md-4 {
    --bs-gutter-x: 1rem;
  }

  .g-md-4,
.gy-md-4 {
    --bs-gutter-y: 1rem;
  }

  .g-md-5,
.gx-md-5 {
    --bs-gutter-x: 1.25rem;
  }

  .g-md-5,
.gy-md-5 {
    --bs-gutter-y: 1.25rem;
  }

  .g-md-6,
.gx-md-6 {
    --bs-gutter-x: 1.5rem;
  }

  .g-md-6,
.gy-md-6 {
    --bs-gutter-y: 1.5rem;
  }

  .g-md-7,
.gx-md-7 {
    --bs-gutter-x: 1.75rem;
  }

  .g-md-7,
.gy-md-7 {
    --bs-gutter-y: 1.75rem;
  }

  .g-md-8,
.gx-md-8 {
    --bs-gutter-x: 2rem;
  }

  .g-md-8,
.gy-md-8 {
    --bs-gutter-y: 2rem;
  }

  .g-md-9,
.gx-md-9 {
    --bs-gutter-x: 2.25rem;
  }

  .g-md-9,
.gy-md-9 {
    --bs-gutter-y: 2.25rem;
  }

  .g-md-10,
.gx-md-10 {
    --bs-gutter-x: 2.5rem;
  }

  .g-md-10,
.gy-md-10 {
    --bs-gutter-y: 2.5rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }

  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-lg-0 {
    margin-left: 0;
  }

  .offset-lg-1 {
    margin-left: 8.33333333%;
  }

  .offset-lg-2 {
    margin-left: 16.66666667%;
  }

  .offset-lg-3 {
    margin-left: 25%;
  }

  .offset-lg-4 {
    margin-left: 33.33333333%;
  }

  .offset-lg-5 {
    margin-left: 41.66666667%;
  }

  .offset-lg-6 {
    margin-left: 50%;
  }

  .offset-lg-7 {
    margin-left: 58.33333333%;
  }

  .offset-lg-8 {
    margin-left: 66.66666667%;
  }

  .offset-lg-9 {
    margin-left: 75%;
  }

  .offset-lg-10 {
    margin-left: 83.33333333%;
  }

  .offset-lg-11 {
    margin-left: 91.66666667%;
  }

  .g-lg-0,
.gx-lg-0 {
    --bs-gutter-x: 0rem;
  }

  .g-lg-0,
.gy-lg-0 {
    --bs-gutter-y: 0rem;
  }

  .g-lg-1,
.gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-lg-1,
.gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-lg-2,
.gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-lg-2,
.gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-lg-3,
.gx-lg-3 {
    --bs-gutter-x: 0.75rem;
  }

  .g-lg-3,
.gy-lg-3 {
    --bs-gutter-y: 0.75rem;
  }

  .g-lg-4,
.gx-lg-4 {
    --bs-gutter-x: 1rem;
  }

  .g-lg-4,
.gy-lg-4 {
    --bs-gutter-y: 1rem;
  }

  .g-lg-5,
.gx-lg-5 {
    --bs-gutter-x: 1.25rem;
  }

  .g-lg-5,
.gy-lg-5 {
    --bs-gutter-y: 1.25rem;
  }

  .g-lg-6,
.gx-lg-6 {
    --bs-gutter-x: 1.5rem;
  }

  .g-lg-6,
.gy-lg-6 {
    --bs-gutter-y: 1.5rem;
  }

  .g-lg-7,
.gx-lg-7 {
    --bs-gutter-x: 1.75rem;
  }

  .g-lg-7,
.gy-lg-7 {
    --bs-gutter-y: 1.75rem;
  }

  .g-lg-8,
.gx-lg-8 {
    --bs-gutter-x: 2rem;
  }

  .g-lg-8,
.gy-lg-8 {
    --bs-gutter-y: 2rem;
  }

  .g-lg-9,
.gx-lg-9 {
    --bs-gutter-x: 2.25rem;
  }

  .g-lg-9,
.gy-lg-9 {
    --bs-gutter-y: 2.25rem;
  }

  .g-lg-10,
.gx-lg-10 {
    --bs-gutter-x: 2.5rem;
  }

  .g-lg-10,
.gy-lg-10 {
    --bs-gutter-y: 2.5rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }

  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-xl-0 {
    margin-left: 0;
  }

  .offset-xl-1 {
    margin-left: 8.33333333%;
  }

  .offset-xl-2 {
    margin-left: 16.66666667%;
  }

  .offset-xl-3 {
    margin-left: 25%;
  }

  .offset-xl-4 {
    margin-left: 33.33333333%;
  }

  .offset-xl-5 {
    margin-left: 41.66666667%;
  }

  .offset-xl-6 {
    margin-left: 50%;
  }

  .offset-xl-7 {
    margin-left: 58.33333333%;
  }

  .offset-xl-8 {
    margin-left: 66.66666667%;
  }

  .offset-xl-9 {
    margin-left: 75%;
  }

  .offset-xl-10 {
    margin-left: 83.33333333%;
  }

  .offset-xl-11 {
    margin-left: 91.66666667%;
  }

  .g-xl-0,
.gx-xl-0 {
    --bs-gutter-x: 0rem;
  }

  .g-xl-0,
.gy-xl-0 {
    --bs-gutter-y: 0rem;
  }

  .g-xl-1,
.gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-xl-1,
.gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-xl-2,
.gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-xl-2,
.gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-xl-3,
.gx-xl-3 {
    --bs-gutter-x: 0.75rem;
  }

  .g-xl-3,
.gy-xl-3 {
    --bs-gutter-y: 0.75rem;
  }

  .g-xl-4,
.gx-xl-4 {
    --bs-gutter-x: 1rem;
  }

  .g-xl-4,
.gy-xl-4 {
    --bs-gutter-y: 1rem;
  }

  .g-xl-5,
.gx-xl-5 {
    --bs-gutter-x: 1.25rem;
  }

  .g-xl-5,
.gy-xl-5 {
    --bs-gutter-y: 1.25rem;
  }

  .g-xl-6,
.gx-xl-6 {
    --bs-gutter-x: 1.5rem;
  }

  .g-xl-6,
.gy-xl-6 {
    --bs-gutter-y: 1.5rem;
  }

  .g-xl-7,
.gx-xl-7 {
    --bs-gutter-x: 1.75rem;
  }

  .g-xl-7,
.gy-xl-7 {
    --bs-gutter-y: 1.75rem;
  }

  .g-xl-8,
.gx-xl-8 {
    --bs-gutter-x: 2rem;
  }

  .g-xl-8,
.gy-xl-8 {
    --bs-gutter-y: 2rem;
  }

  .g-xl-9,
.gx-xl-9 {
    --bs-gutter-x: 2.25rem;
  }

  .g-xl-9,
.gy-xl-9 {
    --bs-gutter-y: 2.25rem;
  }

  .g-xl-10,
.gx-xl-10 {
    --bs-gutter-x: 2.5rem;
  }

  .g-xl-10,
.gy-xl-10 {
    --bs-gutter-y: 2.5rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }

  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-xxl-0 {
    margin-left: 0;
  }

  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }

  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }

  .offset-xxl-3 {
    margin-left: 25%;
  }

  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }

  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }

  .offset-xxl-6 {
    margin-left: 50%;
  }

  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }

  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }

  .offset-xxl-9 {
    margin-left: 75%;
  }

  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }

  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }

  .g-xxl-0,
.gx-xxl-0 {
    --bs-gutter-x: 0rem;
  }

  .g-xxl-0,
.gy-xxl-0 {
    --bs-gutter-y: 0rem;
  }

  .g-xxl-1,
.gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-xxl-1,
.gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-xxl-2,
.gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-xxl-2,
.gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-xxl-3,
.gx-xxl-3 {
    --bs-gutter-x: 0.75rem;
  }

  .g-xxl-3,
.gy-xxl-3 {
    --bs-gutter-y: 0.75rem;
  }

  .g-xxl-4,
.gx-xxl-4 {
    --bs-gutter-x: 1rem;
  }

  .g-xxl-4,
.gy-xxl-4 {
    --bs-gutter-y: 1rem;
  }

  .g-xxl-5,
.gx-xxl-5 {
    --bs-gutter-x: 1.25rem;
  }

  .g-xxl-5,
.gy-xxl-5 {
    --bs-gutter-y: 1.25rem;
  }

  .g-xxl-6,
.gx-xxl-6 {
    --bs-gutter-x: 1.5rem;
  }

  .g-xxl-6,
.gy-xxl-6 {
    --bs-gutter-y: 1.5rem;
  }

  .g-xxl-7,
.gx-xxl-7 {
    --bs-gutter-x: 1.75rem;
  }

  .g-xxl-7,
.gy-xxl-7 {
    --bs-gutter-y: 1.75rem;
  }

  .g-xxl-8,
.gx-xxl-8 {
    --bs-gutter-x: 2rem;
  }

  .g-xxl-8,
.gy-xxl-8 {
    --bs-gutter-y: 2rem;
  }

  .g-xxl-9,
.gx-xxl-9 {
    --bs-gutter-x: 2.25rem;
  }

  .g-xxl-9,
.gy-xxl-9 {
    --bs-gutter-y: 2.25rem;
  }

  .g-xxl-10,
.gx-xxl-10 {
    --bs-gutter-x: 2.5rem;
  }

  .g-xxl-10,
.gy-xxl-10 {
    --bs-gutter-y: 2.5rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: #181C32;
  --bs-table-bg: transparent;
  --bs-table-border-color: #EFF2F5;
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: #181C32;
  --bs-table-striped-bg: rgba(245, 248, 250, 0.75);
  --bs-table-active-color: #181C32;
  --bs-table-active-bg: #F5F8FA;
  --bs-table-hover-color: #181C32;
  --bs-table-hover-bg: #F5F8FA;
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.75rem 0.75rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(1px * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
}

.table-bordered > :not(caption) > * {
  border-width: 1px 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 1px;
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000000;
  --bs-table-bg: #ccecfd;
  --bs-table-border-color: #b8d4e4;
  --bs-table-striped-bg: #c2e0f0;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #b8d4e4;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #bddaea;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000000;
  --bs-table-bg: #fafafc;
  --bs-table-border-color: #e1e1e3;
  --bs-table-striped-bg: #eeeeef;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #e1e1e3;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #e7e7e9;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000000;
  --bs-table-bg: #dcf5e7;
  --bs-table-border-color: #c6ddd0;
  --bs-table-striped-bg: #d1e9db;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #c6ddd0;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #cce3d6;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000000;
  --bs-table-bg: #e3d7fb;
  --bs-table-border-color: #ccc2e2;
  --bs-table-striped-bg: #d8ccee;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #ccc2e2;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #d2c7e8;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000000;
  --bs-table-bg: #fff4cc;
  --bs-table-border-color: #e6dcb8;
  --bs-table-striped-bg: #f2e8c2;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #e6dcb8;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #ece2bd;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000000;
  --bs-table-bg: #fcd9e2;
  --bs-table-border-color: #e3c3cb;
  --bs-table-striped-bg: #efced7;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #e3c3cb;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #e9c9d1;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000000;
  --bs-table-bg: #F5F8FA;
  --bs-table-border-color: #dddfe1;
  --bs-table-striped-bg: #e9ecee;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #dddfe1;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #e3e5e7;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #ffffff;
  --bs-table-bg: #181C32;
  --bs-table-border-color: #2f3347;
  --bs-table-striped-bg: #24273c;
  --bs-table-striped-color: #ffffff;
  --bs-table-active-bg: #2f3347;
  --bs-table-active-color: #ffffff;
  --bs-table-hover-bg: #292d41;
  --bs-table-hover-color: #ffffff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
  font-size: 1.05rem;
  font-weight: 500;
  color: #3F4254;
}

.col-form-label {
  padding-top: calc(0.75rem + 1px);
  padding-bottom: calc(0.75rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  font-weight: 500;
  line-height: 1.5;
  color: #3F4254;
}

.col-form-label-lg {
  padding-top: calc(0.825rem + 1px);
  padding-bottom: calc(0.825rem + 1px);
  font-size: 1.15rem;
}

.col-form-label-sm {
  padding-top: calc(0.65rem + 1px);
  padding-bottom: calc(0.65rem + 1px);
  font-size: 0.925rem;
}

.form-text {
  margin-top: 0.5rem;
  font-size: 0.925rem;
  color: #A1A5B7;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.5;
  color: #181C32;
  appearance: none;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid #E4E6EF;
  border-radius: 0.475rem;
  box-shadow: var(--bs-box-shadow-inset);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: #181C32;
  background-color: #ffffff;
  border-color: #B5B5C3;
  outline: 0;
  box-shadow: var(--bs-box-shadow-inset), 0 0 0 0.25rem rgba(0, 158, 247, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: #A1A5B7;
  opacity: 1;
}
.form-control:disabled {
  background-color: #EFF2F5;
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.75rem 1rem;
  margin: -0.75rem -1rem;
  margin-inline-end: 1rem;
  color: #181C32;
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.75rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: #181C32;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 1.3rem + calc(1px * 2));
  padding: 0.65rem 0.75rem;
  font-size: 0.925rem;
  border-radius: 0.475rem;
}
.form-control-sm::file-selector-button {
  padding: 0.65rem 0.75rem;
  margin: -0.65rem -0.75rem;
  margin-inline-end: 0.75rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1.65rem + calc(1px * 2));
  padding: 0.825rem 1.5rem;
  font-size: 1.15rem;
  border-radius: 0.475rem;
}
.form-control-lg::file-selector-button {
  padding: 0.825rem 1.5rem;
  margin: -0.825rem -1.5rem;
  margin-inline-end: 1.5rem;
}

textarea.form-control {
  min-height: calc(1.5em + 1.5rem + calc(1px * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 1.3rem + calc(1px * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1.65rem + calc(1px * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 1.5rem + calc(1px * 2));
  padding: 0.75rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 0.475rem;
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: 0.475rem;
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 1.3rem + calc(1px * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1.65rem + calc(1px * 2));
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.75rem 3rem 0.75rem 1rem;
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.5;
  color: #181C32;
  appearance: none;
  background-color: #ffffff;
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 16px 12px;
  border: 1px solid #E4E6EF;
  border-radius: 0.475rem;
  box-shadow: var(--bs-box-shadow-inset);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: #B5B5C3;
  outline: 0;
  box-shadow: var(--bs-box-shadow-inset), 0 0 0 0.25rem rgba(0, 158, 247, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 1rem;
  background-image: none;
}
.form-select:disabled {
  background-color: #EFF2F5;
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #181C32;
}

.form-select-sm {
  padding-top: 0.65rem;
  padding-bottom: 0.65rem;
  padding-left: 0.75rem;
  font-size: 0.925rem;
  border-radius: 0.475rem;
}

.form-select-lg {
  padding-top: 0.825rem;
  padding-bottom: 0.825rem;
  padding-left: 1.5rem;
  font-size: 1.15rem;
  border-radius: 0.475rem;
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 2.25rem;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -2.25rem;
}

.form-check-reverse {
  padding-right: 2.25rem;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -2.25rem;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: #ffffff;
  flex-shrink: 0;
  width: 1.75rem;
  height: 1.75rem;
  margin-top: -0.125rem;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid rgba(0, 0, 0, 0.25);
  print-color-adjust: exact;
  transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-check-input {
    transition: none;
  }
}
.form-check-input[type=checkbox] {
  border-radius: 0.45em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: #B5B5C3;
  outline: 0;
  box-shadow: none;
}
.form-check-input:checked {
  background-color: #009EF7;
  border-color: #009EF7;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #009EF7;
  border-color: #009EF7;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 3.75rem;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  width: 3.25rem;
  margin-left: -3.75rem;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 3.25rem;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-switch.form-check-reverse {
  padding-right: 3.75rem;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -3.75rem;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.6;
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.25rem rgba(0, 158, 247, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.25rem rgba(0, 158, 247, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #009EF7;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: #b3e2fd;
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
  box-shadow: var(--bs-box-shadow-inset);
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #009EF7;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: #b3e2fd;
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
  box-shadow: var(--bs-box-shadow-inset);
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(1px * 2));
  min-height: calc(3.5rem + calc(1px * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  max-width: 100%;
  height: 100%;
  padding: 1rem 1rem;
  overflow: hidden;
  color: rgba(var(--bs-body-color-rgb), 0.65);
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 1rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
  padding-left: 1rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > textarea:focus ~ label::after,
.form-floating > textarea:not(:placeholder-shown) ~ label::after {
  position: absolute;
  inset: 1rem 0.5rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: #ffffff;
  border-radius: 0.475rem;
}
.form-floating > textarea:disabled ~ label::after {
  background-color: #EFF2F5;
}
.form-floating > .form-control-plaintext ~ label {
  border-width: 1px 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #7E8299;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.5;
  color: #181C32;
  text-align: center;
  white-space: nowrap;
  background-color: #F5F8FA;
  border: 1px solid #E4E6EF;
  border-radius: 0.475rem;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.825rem 1.5rem;
  font-size: 1.15rem;
  border-radius: 0.475rem;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.65rem 0.75rem;
  font-size: 0.925rem;
  border-radius: 0.475rem;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 4rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(-1 * 1px);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.5rem;
  font-size: 0.925rem;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.75rem 1rem;
  margin-top: 0.1rem;
  font-size: 0.925rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: 0.475rem;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 1.5rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.375rem) center;
  background-size: calc(0.75em + 0.75rem) calc(0.75em + 0.75rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: var(--bs-box-shadow-inset), 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 1.5rem);
  background-position: top calc(0.375em + 0.375rem) right calc(0.375em + 0.375rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  padding-right: 5.5rem;
  background-position: right 1rem center, center right 3rem;
  background-size: 16px 12px, calc(0.75em + 0.75rem) calc(0.75em + 0.75rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: var(--bs-box-shadow-inset), 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 1.5rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.5rem;
  font-size: 0.925rem;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.75rem 1rem;
  margin-top: 0.1rem;
  font-size: 0.925rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: 0.475rem;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 1.5rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.375rem) center;
  background-size: calc(0.75em + 0.75rem) calc(0.75em + 0.75rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: var(--bs-box-shadow-inset), 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 1.5rem);
  background-position: top calc(0.375em + 0.375rem) right calc(0.375em + 0.375rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  padding-right: 5.5rem;
  background-position: right 1rem center, center right 3rem;
  background-size: 16px 12px, calc(0.75em + 0.75rem) calc(0.75em + 0.75rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: var(--bs-box-shadow-inset), 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 1.5rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 1.5rem;
  --bs-btn-padding-y: 0.75rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1.1rem;
  --bs-btn-font-weight: 500;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: 1px;
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: 0.475rem;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.6;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  box-shadow: var(--bs-btn-box-shadow);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  text-decoration: none;
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-box-shadow), var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-box-shadow), var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
  box-shadow: var(--bs-btn-active-shadow);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-active-shadow), var(--bs-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-active-shadow), var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
  box-shadow: none;
}

.btn-white {
  --bs-btn-color: #000000;
  --bs-btn-bg: #ffffff;
  --bs-btn-border-color: #ffffff;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: white;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 217, 217, 217;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: white;
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #ffffff;
  --bs-btn-disabled-border-color: #ffffff;
}

.btn-light {
  --bs-btn-color: #000000;
  --bs-btn-bg: #F5F8FA;
  --bs-btn-border-color: #F5F8FA;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #d0d3d5;
  --bs-btn-hover-border-color: #c4c6c8;
  --bs-btn-focus-shadow-rgb: 208, 211, 213;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #c4c6c8;
  --bs-btn-active-border-color: #b8babc;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #F5F8FA;
  --bs-btn-disabled-border-color: #F5F8FA;
}

.btn-primary {
  --bs-btn-color: #000000;
  --bs-btn-bg: #009EF7;
  --bs-btn-border-color: #009EF7;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #26adf8;
  --bs-btn-hover-border-color: #1aa8f8;
  --bs-btn-focus-shadow-rgb: 0, 134, 210;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #33b1f9;
  --bs-btn-active-border-color: #1aa8f8;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #009EF7;
  --bs-btn-disabled-border-color: #009EF7;
}

.btn-secondary {
  --bs-btn-color: #000000;
  --bs-btn-bg: #E4E6EF;
  --bs-btn-border-color: #E4E6EF;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #e8eaf1;
  --bs-btn-hover-border-color: #e7e9f1;
  --bs-btn-focus-shadow-rgb: 194, 196, 203;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #e9ebf2;
  --bs-btn-active-border-color: #e7e9f1;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #E4E6EF;
  --bs-btn-disabled-border-color: #E4E6EF;
}

.btn-success {
  --bs-btn-color: #000000;
  --bs-btn-bg: #50CD89;
  --bs-btn-border-color: #50CD89;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #6ad59b;
  --bs-btn-hover-border-color: #62d295;
  --bs-btn-focus-shadow-rgb: 68, 174, 116;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #73d7a1;
  --bs-btn-active-border-color: #62d295;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #50CD89;
  --bs-btn-disabled-border-color: #50CD89;
}

.btn-info {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #7239EA;
  --bs-btn-border-color: #7239EA;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #6130c7;
  --bs-btn-hover-border-color: #5b2ebb;
  --bs-btn-focus-shadow-rgb: 135, 87, 237;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #5b2ebb;
  --bs-btn-active-border-color: #562bb0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #7239EA;
  --bs-btn-disabled-border-color: #7239EA;
}

.btn-warning {
  --bs-btn-color: #000000;
  --bs-btn-bg: #FFC700;
  --bs-btn-border-color: #FFC700;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #ffcf26;
  --bs-btn-hover-border-color: #ffcd1a;
  --bs-btn-focus-shadow-rgb: 217, 169, 0;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #ffd233;
  --bs-btn-active-border-color: #ffcd1a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #FFC700;
  --bs-btn-disabled-border-color: #FFC700;
}

.btn-danger {
  --bs-btn-color: #000000;
  --bs-btn-bg: #F1416C;
  --bs-btn-border-color: #F1416C;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #f35e82;
  --bs-btn-hover-border-color: #f2547b;
  --bs-btn-focus-shadow-rgb: 205, 55, 92;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #f46789;
  --bs-btn-active-border-color: #f2547b;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #F1416C;
  --bs-btn-disabled-border-color: #F1416C;
}

.btn-dark {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #181C32;
  --bs-btn-border-color: #181C32;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #3b3e51;
  --bs-btn-hover-border-color: #2f3347;
  --bs-btn-focus-shadow-rgb: 59, 62, 81;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #46495b;
  --bs-btn-active-border-color: #2f3347;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #181C32;
  --bs-btn-disabled-border-color: #181C32;
}

.btn-outline-white {
  --bs-btn-color: #ffffff;
  --bs-btn-border-color: #ffffff;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #ffffff;
  --bs-btn-hover-border-color: #ffffff;
  --bs-btn-focus-shadow-rgb: 255, 255, 255;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #ffffff;
  --bs-btn-active-border-color: #ffffff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffffff;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #F5F8FA;
  --bs-btn-border-color: #F5F8FA;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #F5F8FA;
  --bs-btn-hover-border-color: #F5F8FA;
  --bs-btn-focus-shadow-rgb: 245, 248, 250;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #F5F8FA;
  --bs-btn-active-border-color: #F5F8FA;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #F5F8FA;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #F5F8FA;
  --bs-gradient: none;
}

.btn-outline-primary {
  --bs-btn-color: #009EF7;
  --bs-btn-border-color: #009EF7;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #009EF7;
  --bs-btn-hover-border-color: #009EF7;
  --bs-btn-focus-shadow-rgb: 0, 158, 247;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #009EF7;
  --bs-btn-active-border-color: #009EF7;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #009EF7;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #009EF7;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #E4E6EF;
  --bs-btn-border-color: #E4E6EF;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #E4E6EF;
  --bs-btn-hover-border-color: #E4E6EF;
  --bs-btn-focus-shadow-rgb: 228, 230, 239;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #E4E6EF;
  --bs-btn-active-border-color: #E4E6EF;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #E4E6EF;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #E4E6EF;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #50CD89;
  --bs-btn-border-color: #50CD89;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #50CD89;
  --bs-btn-hover-border-color: #50CD89;
  --bs-btn-focus-shadow-rgb: 80, 205, 137;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #50CD89;
  --bs-btn-active-border-color: #50CD89;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #50CD89;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #50CD89;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #7239EA;
  --bs-btn-border-color: #7239EA;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #7239EA;
  --bs-btn-hover-border-color: #7239EA;
  --bs-btn-focus-shadow-rgb: 114, 57, 234;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #7239EA;
  --bs-btn-active-border-color: #7239EA;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #7239EA;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #7239EA;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #FFC700;
  --bs-btn-border-color: #FFC700;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #FFC700;
  --bs-btn-hover-border-color: #FFC700;
  --bs-btn-focus-shadow-rgb: 255, 199, 0;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #FFC700;
  --bs-btn-active-border-color: #FFC700;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFC700;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #FFC700;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #F1416C;
  --bs-btn-border-color: #F1416C;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #F1416C;
  --bs-btn-hover-border-color: #F1416C;
  --bs-btn-focus-shadow-rgb: 241, 65, 108;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #F1416C;
  --bs-btn-active-border-color: #F1416C;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #F1416C;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #F1416C;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #181C32;
  --bs-btn-border-color: #181C32;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #181C32;
  --bs-btn-hover-border-color: #181C32;
  --bs-btn-focus-shadow-rgb: 24, 28, 50;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #181C32;
  --bs-btn-active-border-color: #181C32;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #181C32;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #181C32;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: #009EF7;
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: #006dab;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: #006dab;
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #7E8299;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 0, 134, 210;
  text-decoration: none;
}
.btn-link:hover, .btn-link:focus-visible {
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.825rem;
  --bs-btn-padding-x: 1.75rem;
  --bs-btn-font-size: 1.15rem;
  --bs-btn-border-radius: 0.475rem;
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.65rem;
  --bs-btn-padding-x: 1.25rem;
  --bs-btn-font-size: 0.925rem;
  --bs-btn-border-radius: 0.475rem;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: #ffffff;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: 0.475rem;
  --bs-dropdown-border-width: 0;
  --bs-dropdown-inner-border-radius: calc(0.475rem - 0);
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: #FFFFFF;
  --bs-dropdown-link-active-bg: #009EF7;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #7E8299;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
  box-shadow: var(--bs-dropdown-box-shadow);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.925rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #E4E6EF;
  --bs-dropdown-bg: #3F4254;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #E4E6EF;
  --bs-dropdown-link-hover-color: #ffffff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #FFFFFF;
  --bs-dropdown-link-active-bg: #009EF7;
  --bs-dropdown-link-disabled-color: #A1A5B7;
  --bs-dropdown-header-color: #A1A5B7;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: 0.475rem;
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(-1 * 1px);
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 1.125rem;
  padding-left: 1.125rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.9375rem;
  padding-left: 0.9375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 1.3125rem;
  padding-left: 1.3125rem;
}

.btn-group.show .dropdown-toggle {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}
.btn-group.show .dropdown-toggle.btn-link {
  box-shadow: none;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(-1 * 1px);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:nth-child(n+3),
.btn-group-vertical > :not(.btn-check) + .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
  text-decoration: none;
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(0, 158, 247, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: 1px;
  --bs-nav-tabs-border-color: #EFF2F5;
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) #EFF2F5;
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #FFFFFF;
  --bs-nav-pills-link-active-bg: #009EF7;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 500;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-grow: 1;
  flex-basis: 0;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.44375rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.075rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.075rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: 0.475rem;
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
  text-decoration: none;
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-grow: 1;
  flex-basis: 100%;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  box-shadow: none;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #ffffff;
  --bs-navbar-brand-color: #ffffff;
  --bs-navbar-brand-hover-color: #ffffff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: #EFF2F5;
  --bs-card-border-radius: 0.475rem;
  --bs-card-box-shadow: 0px 0px 20px 0px rgba(76, 87, 125, 0.02);
  --bs-card-inner-border-radius: calc(0.475rem - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: #ffffff;
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: #ffffff;
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
  box-shadow: var(--bs-card-box-shadow);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-top,
.card-group > .card:not(:last-child) > .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-bottom,
.card-group > .card:not(:last-child) > .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-top,
.card-group > .card:not(:first-child) > .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-bottom,
.card-group > .card:not(:first-child) > .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: #181C32;
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: #EFF2F5;
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: 0.475rem;
  --bs-accordion-inner-border-radius: calc(0.475rem - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.5rem;
  --bs-accordion-btn-padding-y: 1.5rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-accordion-btn-icon-width: 1.15rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  --bs-accordion-btn-focus-box-shadow: none;
  --bs-accordion-body-padding-x: 1.5rem;
  --bs-accordion-body-padding-y: 1.5rem;
  --bs-accordion-active-color: #009EF7;
  --bs-accordion-active-bg: #F5F8FA;
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse,
.accordion-flush > .accordion-item > .accordion-header .accordion-button,
.accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: #7E8299;
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: #009EF7;
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1.075rem;
  --bs-pagination-color: #5E6278;
  --bs-pagination-bg: transparent;
  --bs-pagination-border-width: 0;
  --bs-pagination-border-color: transparent;
  --bs-pagination-border-radius: 0.475rem;
  --bs-pagination-hover-color: #009EF7;
  --bs-pagination-hover-bg: #F1FAFF;
  --bs-pagination-hover-border-color: transparent;
  --bs-pagination-focus-color: #009EF7;
  --bs-pagination-focus-bg: #F1FAFF;
  --bs-pagination-focus-box-shadow: none;
  --bs-pagination-active-color: #FFFFFF;
  --bs-pagination-active-bg: #009EF7;
  --bs-pagination-active-border-color: transparent;
  --bs-pagination-disabled-color: #B5B5C3;
  --bs-pagination-disabled-bg: transparent;
  --bs-pagination-disabled-border-color: transparent;
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  text-decoration: none;
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(-1 * 0);
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.075rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.925rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.85em;
  --bs-badge-padding-y: 0.5em;
  --bs-badge-font-size: 0.85rem;
  --bs-badge-font-weight: 600;
  --bs-badge-color: #ffffff;
  --bs-badge-border-radius: 0.475rem;
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 500;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-white {
  --bs-alert-color: var(--bs-white-text-emphasis);
  --bs-alert-bg: var(--bs-white-bg-subtle);
  --bs-alert-border-color: var(--bs-white-border-subtle);
  --bs-alert-link-color: var(--bs-white-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: var(--bs-progress-height);
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: #F5F8FA;
  --bs-progress-border-radius: 6px;
  --bs-progress-box-shadow: none;
  --bs-progress-bar-color: #ffffff;
  --bs-progress-bar-bg: #009EF7;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
  box-shadow: var(--bs-progress-box-shadow);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #FFFFFF;
  --bs-list-group-active-bg: #009EF7;
  --bs-list-group-active-border-color: #009EF7;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:not(.active):hover, .list-group-item-action:not(.active):focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:not(.active):active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-white {
  --bs-list-group-color: var(--bs-white-text-emphasis);
  --bs-list-group-bg: var(--bs-white-bg-subtle);
  --bs-list-group-border-color: var(--bs-white-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-white-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-white-border-subtle);
  --bs-list-group-active-color: var(--bs-white-bg-subtle);
  --bs-list-group-active-bg: var(--bs-white-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-white-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(0, 158, 247, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  filter: var(--bs-btn-close-filter);
  border: 0;
  border-radius: 0.475rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

:root,
[data-bs-theme=light] {
  --bs-btn-close-filter: ;
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1.75rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: var(--bs-body-color);
  --bs-modal-bg: #ffffff;
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: 0;
  --bs-modal-border-radius: 0.475rem;
  --bs-modal-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);
  --bs-modal-inner-border-radius: 0.475rem;
  --bs-modal-header-padding-x: 1.75rem;
  --bs-modal-header-padding-y: 1.75rem;
  --bs-modal-header-padding: 1.75rem 1.75rem;
  --bs-modal-header-border-color: #EFF2F5;
  --bs-modal-header-border-width: 1px;
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: #EFF2F5;
  --bs-modal-footer-border-width: 1px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transform: translate(0, -50px);
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  box-shadow: var(--bs-modal-box-shadow);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000000;
  --bs-backdrop-opacity: 0.3;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * .5) calc(var(--bs-modal-header-padding-x) * .5);
  margin-top: calc(-.5 * var(--bs-modal-header-padding-y));
  margin-right: calc(-.5 * var(--bs-modal-header-padding-x));
  margin-bottom: calc(-.5 * var(--bs-modal-header-padding-y));
  margin-left: auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * .5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * .5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
  }

  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }

  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
.modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
.modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
.modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
.modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
.modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
.modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 1rem;
  --bs-tooltip-padding-y: 0.75rem;
  --bs-tooltip-margin: 0;
  --bs-tooltip-font-size: 0.925rem;
  --bs-tooltip-color: #3F4254;
  --bs-tooltip-bg: #ffffff;
  --bs-tooltip-border-radius: 0.475rem;
  --bs-tooltip-opacity: 1;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * .5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * .5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * .5) 0 calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 1rem;
  --bs-popover-bg: #ffffff;
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: #ffffff;
  --bs-popover-border-radius: 0.475rem;
  --bs-popover-inner-border-radius: calc(0.475rem - var(--bs-border-width));
  --bs-popover-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  --bs-popover-header-padding-x: 1.25rem;
  --bs-popover-header-padding-y: 1rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: #3F4254;
  --bs-popover-header-bg: #ffffff;
  --bs-popover-body-padding-x: 1.25rem;
  --bs-popover-body-padding-y: 1.25rem;
  --bs-popover-body-color: #3F4254;
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
  box-shadow: var(--bs-popover-box-shadow);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * .5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * .5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * .5) 0 calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #ffffff;
  text-align: center;
  background: none;
  filter: var(--bs-carousel-control-icon-filter);
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
.carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #ffffff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e")*/;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/%3e%3c/svg%3e")*/;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: var(--bs-carousel-indicator-active-bg);
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: var(--bs-carousel-caption-color);
  text-align: center;
}

.carousel-dark {
  --bs-carousel-indicator-active-bg: #000000;
  --bs-carousel-caption-color: #000000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}

:root,
[data-bs-theme=light] {
  --bs-carousel-indicator-active-bg: #ffffff;
  --bs-carousel-caption-color: #ffffff;
  --bs-carousel-control-icon-filter: ;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  flex-shrink: 0;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.185em;
  --bs-spinner-animation-speed: 0.65s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.145em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.65s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
.spinner-grow {
    --bs-spinner-animation-speed: 1.3s;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-white {
  color: #000000 !important;
  background-color: RGBA(var(--bs-white-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-primary {
  color: #000000 !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #000000 !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #000000 !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #000000 !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-white {
  color: RGBA(var(--bs-white-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-white-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-white:hover, .link-white:focus {
  color: RGBA(255, 255, 255, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 255, 255, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(247, 249, 251, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(247, 249, 251, var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(51, 177, 249, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(51, 177, 249, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(233, 235, 242, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(233, 235, 242, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(115, 215, 161, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(115, 215, 161, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(91, 46, 187, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(91, 46, 187, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 210, 51, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 210, 51, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(244, 103, 137, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(244, 103, 137, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(19, 22, 40, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(19, 22, 40, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: calc(3 / 4 * 100%);
}

.ratio-16x9 {
  --bs-aspect-ratio: calc(9 / 16 * 100%);
}

.ratio-21x9 {
  --bs-aspect-ratio: calc(9 / 21 * 100%);
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}
.visually-hidden *,
.visually-hidden-focusable:not(:focus):not(:focus-within) * {
  overflow: hidden !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-5 {
  opacity: 0.05 !important;
}

.opacity-10 {
  opacity: 0.1 !important;
}

.opacity-15 {
  opacity: 0.15 !important;
}

.opacity-20 {
  opacity: 0.2 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-white {
  --bs-focus-ring-color: rgba(var(--bs-white-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-25 {
  top: 25% !important;
}

.top-50 {
  top: 50% !important;
}

.top-75 {
  top: 75% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-25 {
  bottom: 25% !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-75 {
  bottom: 75% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-25 {
  left: 25% !important;
}

.start-50 {
  left: 50% !important;
}

.start-75 {
  left: 75% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-25 {
  right: 25% !important;
}

.end-50 {
  right: 50% !important;
}

.end-75 {
  right: 75% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-0 {
  border-width: 0 !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-unset {
  width: unset !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.w-1px {
  width: 1px !important;
}

.w-2px {
  width: 2px !important;
}

.w-3px {
  width: 3px !important;
}

.w-4px {
  width: 4px !important;
}

.w-5px {
  width: 5px !important;
}

.w-6px {
  width: 6px !important;
}

.w-7px {
  width: 7px !important;
}

.w-8px {
  width: 8px !important;
}

.w-9px {
  width: 9px !important;
}

.w-10px {
  width: 10px !important;
}

.w-15px {
  width: 15px !important;
}

.w-20px {
  width: 20px !important;
}

.w-25px {
  width: 25px !important;
}

.w-30px {
  width: 30px !important;
}

.w-35px {
  width: 35px !important;
}

.w-40px {
  width: 40px !important;
}

.w-45px {
  width: 45px !important;
}

.w-50px {
  width: 50px !important;
}

.w-55px {
  width: 55px !important;
}

.w-60px {
  width: 60px !important;
}

.w-65px {
  width: 65px !important;
}

.w-70px {
  width: 70px !important;
}

.w-75px {
  width: 75px !important;
}

.w-80px {
  width: 80px !important;
}

.w-85px {
  width: 85px !important;
}

.w-90px {
  width: 90px !important;
}

.w-95px {
  width: 95px !important;
}

.w-100px {
  width: 100px !important;
}

.w-125px {
  width: 125px !important;
}

.w-150px {
  width: 150px !important;
}

.w-175px {
  width: 175px !important;
}

.w-200px {
  width: 200px !important;
}

.w-225px {
  width: 225px !important;
}

.w-250px {
  width: 250px !important;
}

.w-275px {
  width: 275px !important;
}

.w-300px {
  width: 300px !important;
}

.w-325px {
  width: 325px !important;
}

.w-350px {
  width: 350px !important;
}

.w-375px {
  width: 375px !important;
}

.w-400px {
  width: 400px !important;
}

.w-425px {
  width: 425px !important;
}

.w-450px {
  width: 450px !important;
}

.w-475px {
  width: 475px !important;
}

.w-500px {
  width: 500px !important;
}

.w-550px {
  width: 550px !important;
}

.w-600px {
  width: 600px !important;
}

.w-650px {
  width: 650px !important;
}

.w-700px {
  width: 700px !important;
}

.w-750px {
  width: 750px !important;
}

.w-800px {
  width: 800px !important;
}

.w-850px {
  width: 850px !important;
}

.w-900px {
  width: 900px !important;
}

.w-950px {
  width: 950px !important;
}

.w-1000px {
  width: 1000px !important;
}

.mw-unset {
  max-width: unset !important;
}

.mw-25 {
  max-width: 25% !important;
}

.mw-50 {
  max-width: 50% !important;
}

.mw-75 {
  max-width: 75% !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mw-auto {
  max-width: auto !important;
}

.mw-1px {
  max-width: 1px !important;
}

.mw-2px {
  max-width: 2px !important;
}

.mw-3px {
  max-width: 3px !important;
}

.mw-4px {
  max-width: 4px !important;
}

.mw-5px {
  max-width: 5px !important;
}

.mw-6px {
  max-width: 6px !important;
}

.mw-7px {
  max-width: 7px !important;
}

.mw-8px {
  max-width: 8px !important;
}

.mw-9px {
  max-width: 9px !important;
}

.mw-10px {
  max-width: 10px !important;
}

.mw-15px {
  max-width: 15px !important;
}

.mw-20px {
  max-width: 20px !important;
}

.mw-25px {
  max-width: 25px !important;
}

.mw-30px {
  max-width: 30px !important;
}

.mw-35px {
  max-width: 35px !important;
}

.mw-40px {
  max-width: 40px !important;
}

.mw-45px {
  max-width: 45px !important;
}

.mw-50px {
  max-width: 50px !important;
}

.mw-55px {
  max-width: 55px !important;
}

.mw-60px {
  max-width: 60px !important;
}

.mw-65px {
  max-width: 65px !important;
}

.mw-70px {
  max-width: 70px !important;
}

.mw-75px {
  max-width: 75px !important;
}

.mw-80px {
  max-width: 80px !important;
}

.mw-85px {
  max-width: 85px !important;
}

.mw-90px {
  max-width: 90px !important;
}

.mw-95px {
  max-width: 95px !important;
}

.mw-100px {
  max-width: 100px !important;
}

.mw-125px {
  max-width: 125px !important;
}

.mw-150px {
  max-width: 150px !important;
}

.mw-175px {
  max-width: 175px !important;
}

.mw-200px {
  max-width: 200px !important;
}

.mw-225px {
  max-width: 225px !important;
}

.mw-250px {
  max-width: 250px !important;
}

.mw-275px {
  max-width: 275px !important;
}

.mw-300px {
  max-width: 300px !important;
}

.mw-325px {
  max-width: 325px !important;
}

.mw-350px {
  max-width: 350px !important;
}

.mw-375px {
  max-width: 375px !important;
}

.mw-400px {
  max-width: 400px !important;
}

.mw-425px {
  max-width: 425px !important;
}

.mw-450px {
  max-width: 450px !important;
}

.mw-475px {
  max-width: 475px !important;
}

.mw-500px {
  max-width: 500px !important;
}

.mw-550px {
  max-width: 550px !important;
}

.mw-600px {
  max-width: 600px !important;
}

.mw-650px {
  max-width: 650px !important;
}

.mw-700px {
  max-width: 700px !important;
}

.mw-750px {
  max-width: 750px !important;
}

.mw-800px {
  max-width: 800px !important;
}

.mw-850px {
  max-width: 850px !important;
}

.mw-900px {
  max-width: 900px !important;
}

.mw-950px {
  max-width: 950px !important;
}

.mw-1000px {
  max-width: 1000px !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-unset {
  height: unset !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.h-1px {
  height: 1px !important;
}

.h-2px {
  height: 2px !important;
}

.h-3px {
  height: 3px !important;
}

.h-4px {
  height: 4px !important;
}

.h-5px {
  height: 5px !important;
}

.h-6px {
  height: 6px !important;
}

.h-7px {
  height: 7px !important;
}

.h-8px {
  height: 8px !important;
}

.h-9px {
  height: 9px !important;
}

.h-10px {
  height: 10px !important;
}

.h-15px {
  height: 15px !important;
}

.h-20px {
  height: 20px !important;
}

.h-25px {
  height: 25px !important;
}

.h-30px {
  height: 30px !important;
}

.h-35px {
  height: 35px !important;
}

.h-40px {
  height: 40px !important;
}

.h-45px {
  height: 45px !important;
}

.h-50px {
  height: 50px !important;
}

.h-55px {
  height: 55px !important;
}

.h-60px {
  height: 60px !important;
}

.h-65px {
  height: 65px !important;
}

.h-70px {
  height: 70px !important;
}

.h-75px {
  height: 75px !important;
}

.h-80px {
  height: 80px !important;
}

.h-85px {
  height: 85px !important;
}

.h-90px {
  height: 90px !important;
}

.h-95px {
  height: 95px !important;
}

.h-100px {
  height: 100px !important;
}

.h-125px {
  height: 125px !important;
}

.h-150px {
  height: 150px !important;
}

.h-175px {
  height: 175px !important;
}

.h-200px {
  height: 200px !important;
}

.h-225px {
  height: 225px !important;
}

.h-250px {
  height: 250px !important;
}

.h-275px {
  height: 275px !important;
}

.h-300px {
  height: 300px !important;
}

.h-325px {
  height: 325px !important;
}

.h-350px {
  height: 350px !important;
}

.h-375px {
  height: 375px !important;
}

.h-400px {
  height: 400px !important;
}

.h-425px {
  height: 425px !important;
}

.h-450px {
  height: 450px !important;
}

.h-475px {
  height: 475px !important;
}

.h-500px {
  height: 500px !important;
}

.h-550px {
  height: 550px !important;
}

.h-600px {
  height: 600px !important;
}

.h-650px {
  height: 650px !important;
}

.h-700px {
  height: 700px !important;
}

.h-750px {
  height: 750px !important;
}

.h-800px {
  height: 800px !important;
}

.h-850px {
  height: 850px !important;
}

.h-900px {
  height: 900px !important;
}

.h-950px {
  height: 950px !important;
}

.h-1000px {
  height: 1000px !important;
}

.mh-unset {
  max-height: unset !important;
}

.mh-25 {
  max-height: 25% !important;
}

.mh-50 {
  max-height: 50% !important;
}

.mh-75 {
  max-height: 75% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.mh-auto {
  max-height: auto !important;
}

.mh-1px {
  max-height: 1px !important;
}

.mh-2px {
  max-height: 2px !important;
}

.mh-3px {
  max-height: 3px !important;
}

.mh-4px {
  max-height: 4px !important;
}

.mh-5px {
  max-height: 5px !important;
}

.mh-6px {
  max-height: 6px !important;
}

.mh-7px {
  max-height: 7px !important;
}

.mh-8px {
  max-height: 8px !important;
}

.mh-9px {
  max-height: 9px !important;
}

.mh-10px {
  max-height: 10px !important;
}

.mh-15px {
  max-height: 15px !important;
}

.mh-20px {
  max-height: 20px !important;
}

.mh-25px {
  max-height: 25px !important;
}

.mh-30px {
  max-height: 30px !important;
}

.mh-35px {
  max-height: 35px !important;
}

.mh-40px {
  max-height: 40px !important;
}

.mh-45px {
  max-height: 45px !important;
}

.mh-50px {
  max-height: 50px !important;
}

.mh-55px {
  max-height: 55px !important;
}

.mh-60px {
  max-height: 60px !important;
}

.mh-65px {
  max-height: 65px !important;
}

.mh-70px {
  max-height: 70px !important;
}

.mh-75px {
  max-height: 75px !important;
}

.mh-80px {
  max-height: 80px !important;
}

.mh-85px {
  max-height: 85px !important;
}

.mh-90px {
  max-height: 90px !important;
}

.mh-95px {
  max-height: 95px !important;
}

.mh-100px {
  max-height: 100px !important;
}

.mh-125px {
  max-height: 125px !important;
}

.mh-150px {
  max-height: 150px !important;
}

.mh-175px {
  max-height: 175px !important;
}

.mh-200px {
  max-height: 200px !important;
}

.mh-225px {
  max-height: 225px !important;
}

.mh-250px {
  max-height: 250px !important;
}

.mh-275px {
  max-height: 275px !important;
}

.mh-300px {
  max-height: 300px !important;
}

.mh-325px {
  max-height: 325px !important;
}

.mh-350px {
  max-height: 350px !important;
}

.mh-375px {
  max-height: 375px !important;
}

.mh-400px {
  max-height: 400px !important;
}

.mh-425px {
  max-height: 425px !important;
}

.mh-450px {
  max-height: 450px !important;
}

.mh-475px {
  max-height: 475px !important;
}

.mh-500px {
  max-height: 500px !important;
}

.mh-550px {
  max-height: 550px !important;
}

.mh-600px {
  max-height: 600px !important;
}

.mh-650px {
  max-height: 650px !important;
}

.mh-700px {
  max-height: 700px !important;
}

.mh-750px {
  max-height: 750px !important;
}

.mh-800px {
  max-height: 800px !important;
}

.mh-850px {
  max-height: 850px !important;
}

.mh-900px {
  max-height: 900px !important;
}

.mh-950px {
  max-height: 950px !important;
}

.mh-1000px {
  max-height: 1000px !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 0.75rem !important;
}

.m-4 {
  margin: 1rem !important;
}

.m-5 {
  margin: 1.25rem !important;
}

.m-6 {
  margin: 1.5rem !important;
}

.m-7 {
  margin: 1.75rem !important;
}

.m-8 {
  margin: 2rem !important;
}

.m-9 {
  margin: 2.25rem !important;
}

.m-10 {
  margin: 2.5rem !important;
}

.m-11 {
  margin: 2.75rem !important;
}

.m-12 {
  margin: 3rem !important;
}

.m-13 {
  margin: 3.25rem !important;
}

.m-14 {
  margin: 3.5rem !important;
}

.m-15 {
  margin: 3.75rem !important;
}

.m-16 {
  margin: 4rem !important;
}

.m-17 {
  margin: 4.25rem !important;
}

.m-18 {
  margin: 4.5rem !important;
}

.m-19 {
  margin: 4.75rem !important;
}

.m-20 {
  margin: 5rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 0.75rem !important;
  margin-left: 0.75rem !important;
}

.mx-4 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-5 {
  margin-right: 1.25rem !important;
  margin-left: 1.25rem !important;
}

.mx-6 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-7 {
  margin-right: 1.75rem !important;
  margin-left: 1.75rem !important;
}

.mx-8 {
  margin-right: 2rem !important;
  margin-left: 2rem !important;
}

.mx-9 {
  margin-right: 2.25rem !important;
  margin-left: 2.25rem !important;
}

.mx-10 {
  margin-right: 2.5rem !important;
  margin-left: 2.5rem !important;
}

.mx-11 {
  margin-right: 2.75rem !important;
  margin-left: 2.75rem !important;
}

.mx-12 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-13 {
  margin-right: 3.25rem !important;
  margin-left: 3.25rem !important;
}

.mx-14 {
  margin-right: 3.5rem !important;
  margin-left: 3.5rem !important;
}

.mx-15 {
  margin-right: 3.75rem !important;
  margin-left: 3.75rem !important;
}

.mx-16 {
  margin-right: 4rem !important;
  margin-left: 4rem !important;
}

.mx-17 {
  margin-right: 4.25rem !important;
  margin-left: 4.25rem !important;
}

.mx-18 {
  margin-right: 4.5rem !important;
  margin-left: 4.5rem !important;
}

.mx-19 {
  margin-right: 4.75rem !important;
  margin-left: 4.75rem !important;
}

.mx-20 {
  margin-right: 5rem !important;
  margin-left: 5rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}

.my-4 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-5 {
  margin-top: 1.25rem !important;
  margin-bottom: 1.25rem !important;
}

.my-6 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-7 {
  margin-top: 1.75rem !important;
  margin-bottom: 1.75rem !important;
}

.my-8 {
  margin-top: 2rem !important;
  margin-bottom: 2rem !important;
}

.my-9 {
  margin-top: 2.25rem !important;
  margin-bottom: 2.25rem !important;
}

.my-10 {
  margin-top: 2.5rem !important;
  margin-bottom: 2.5rem !important;
}

.my-11 {
  margin-top: 2.75rem !important;
  margin-bottom: 2.75rem !important;
}

.my-12 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-13 {
  margin-top: 3.25rem !important;
  margin-bottom: 3.25rem !important;
}

.my-14 {
  margin-top: 3.5rem !important;
  margin-bottom: 3.5rem !important;
}

.my-15 {
  margin-top: 3.75rem !important;
  margin-bottom: 3.75rem !important;
}

.my-16 {
  margin-top: 4rem !important;
  margin-bottom: 4rem !important;
}

.my-17 {
  margin-top: 4.25rem !important;
  margin-bottom: 4.25rem !important;
}

.my-18 {
  margin-top: 4.5rem !important;
  margin-bottom: 4.5rem !important;
}

.my-19 {
  margin-top: 4.75rem !important;
  margin-bottom: 4.75rem !important;
}

.my-20 {
  margin-top: 5rem !important;
  margin-bottom: 5rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 0.75rem !important;
}

.mt-4 {
  margin-top: 1rem !important;
}

.mt-5 {
  margin-top: 1.25rem !important;
}

.mt-6 {
  margin-top: 1.5rem !important;
}

.mt-7 {
  margin-top: 1.75rem !important;
}

.mt-8 {
  margin-top: 2rem !important;
}

.mt-9 {
  margin-top: 2.25rem !important;
}

.mt-10 {
  margin-top: 2.5rem !important;
}

.mt-11 {
  margin-top: 2.75rem !important;
}

.mt-12 {
  margin-top: 3rem !important;
}

.mt-13 {
  margin-top: 3.25rem !important;
}

.mt-14 {
  margin-top: 3.5rem !important;
}

.mt-15 {
  margin-top: 3.75rem !important;
}

.mt-16 {
  margin-top: 4rem !important;
}

.mt-17 {
  margin-top: 4.25rem !important;
}

.mt-18 {
  margin-top: 4.5rem !important;
}

.mt-19 {
  margin-top: 4.75rem !important;
}

.mt-20 {
  margin-top: 5rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 0.75rem !important;
}

.me-4 {
  margin-right: 1rem !important;
}

.me-5 {
  margin-right: 1.25rem !important;
}

.me-6 {
  margin-right: 1.5rem !important;
}

.me-7 {
  margin-right: 1.75rem !important;
}

.me-8 {
  margin-right: 2rem !important;
}

.me-9 {
  margin-right: 2.25rem !important;
}

.me-10 {
  margin-right: 2.5rem !important;
}

.me-11 {
  margin-right: 2.75rem !important;
}

.me-12 {
  margin-right: 3rem !important;
}

.me-13 {
  margin-right: 3.25rem !important;
}

.me-14 {
  margin-right: 3.5rem !important;
}

.me-15 {
  margin-right: 3.75rem !important;
}

.me-16 {
  margin-right: 4rem !important;
}

.me-17 {
  margin-right: 4.25rem !important;
}

.me-18 {
  margin-right: 4.5rem !important;
}

.me-19 {
  margin-right: 4.75rem !important;
}

.me-20 {
  margin-right: 5rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 0.75rem !important;
}

.mb-4 {
  margin-bottom: 1rem !important;
}

.mb-5 {
  margin-bottom: 1.25rem !important;
}

.mb-6 {
  margin-bottom: 1.5rem !important;
}

.mb-7 {
  margin-bottom: 1.75rem !important;
}

.mb-8 {
  margin-bottom: 2rem !important;
}

.mb-9 {
  margin-bottom: 2.25rem !important;
}

.mb-10 {
  margin-bottom: 2.5rem !important;
}

.mb-11 {
  margin-bottom: 2.75rem !important;
}

.mb-12 {
  margin-bottom: 3rem !important;
}

.mb-13 {
  margin-bottom: 3.25rem !important;
}

.mb-14 {
  margin-bottom: 3.5rem !important;
}

.mb-15 {
  margin-bottom: 3.75rem !important;
}

.mb-16 {
  margin-bottom: 4rem !important;
}

.mb-17 {
  margin-bottom: 4.25rem !important;
}

.mb-18 {
  margin-bottom: 4.5rem !important;
}

.mb-19 {
  margin-bottom: 4.75rem !important;
}

.mb-20 {
  margin-bottom: 5rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 0.75rem !important;
}

.ms-4 {
  margin-left: 1rem !important;
}

.ms-5 {
  margin-left: 1.25rem !important;
}

.ms-6 {
  margin-left: 1.5rem !important;
}

.ms-7 {
  margin-left: 1.75rem !important;
}

.ms-8 {
  margin-left: 2rem !important;
}

.ms-9 {
  margin-left: 2.25rem !important;
}

.ms-10 {
  margin-left: 2.5rem !important;
}

.ms-11 {
  margin-left: 2.75rem !important;
}

.ms-12 {
  margin-left: 3rem !important;
}

.ms-13 {
  margin-left: 3.25rem !important;
}

.ms-14 {
  margin-left: 3.5rem !important;
}

.ms-15 {
  margin-left: 3.75rem !important;
}

.ms-16 {
  margin-left: 4rem !important;
}

.ms-17 {
  margin-left: 4.25rem !important;
}

.ms-18 {
  margin-left: 4.5rem !important;
}

.ms-19 {
  margin-left: 4.75rem !important;
}

.ms-20 {
  margin-left: 5rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.m-n3 {
  margin: -0.75rem !important;
}

.m-n4 {
  margin: -1rem !important;
}

.m-n5 {
  margin: -1.25rem !important;
}

.m-n6 {
  margin: -1.5rem !important;
}

.m-n7 {
  margin: -1.75rem !important;
}

.m-n8 {
  margin: -2rem !important;
}

.m-n9 {
  margin: -2.25rem !important;
}

.m-n10 {
  margin: -2.5rem !important;
}

.m-n11 {
  margin: -2.75rem !important;
}

.m-n12 {
  margin: -3rem !important;
}

.m-n13 {
  margin: -3.25rem !important;
}

.m-n14 {
  margin: -3.5rem !important;
}

.m-n15 {
  margin: -3.75rem !important;
}

.m-n16 {
  margin: -4rem !important;
}

.m-n17 {
  margin: -4.25rem !important;
}

.m-n18 {
  margin: -4.5rem !important;
}

.m-n19 {
  margin: -4.75rem !important;
}

.m-n20 {
  margin: -5rem !important;
}

.mx-n1 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important;
}

.mx-n2 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important;
}

.mx-n3 {
  margin-right: -0.75rem !important;
  margin-left: -0.75rem !important;
}

.mx-n4 {
  margin-right: -1rem !important;
  margin-left: -1rem !important;
}

.mx-n5 {
  margin-right: -1.25rem !important;
  margin-left: -1.25rem !important;
}

.mx-n6 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important;
}

.mx-n7 {
  margin-right: -1.75rem !important;
  margin-left: -1.75rem !important;
}

.mx-n8 {
  margin-right: -2rem !important;
  margin-left: -2rem !important;
}

.mx-n9 {
  margin-right: -2.25rem !important;
  margin-left: -2.25rem !important;
}

.mx-n10 {
  margin-right: -2.5rem !important;
  margin-left: -2.5rem !important;
}

.mx-n11 {
  margin-right: -2.75rem !important;
  margin-left: -2.75rem !important;
}

.mx-n12 {
  margin-right: -3rem !important;
  margin-left: -3rem !important;
}

.mx-n13 {
  margin-right: -3.25rem !important;
  margin-left: -3.25rem !important;
}

.mx-n14 {
  margin-right: -3.5rem !important;
  margin-left: -3.5rem !important;
}

.mx-n15 {
  margin-right: -3.75rem !important;
  margin-left: -3.75rem !important;
}

.mx-n16 {
  margin-right: -4rem !important;
  margin-left: -4rem !important;
}

.mx-n17 {
  margin-right: -4.25rem !important;
  margin-left: -4.25rem !important;
}

.mx-n18 {
  margin-right: -4.5rem !important;
  margin-left: -4.5rem !important;
}

.mx-n19 {
  margin-right: -4.75rem !important;
  margin-left: -4.75rem !important;
}

.mx-n20 {
  margin-right: -5rem !important;
  margin-left: -5rem !important;
}

.my-n1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}

.my-n2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}

.my-n3 {
  margin-top: -0.75rem !important;
  margin-bottom: -0.75rem !important;
}

.my-n4 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important;
}

.my-n5 {
  margin-top: -1.25rem !important;
  margin-bottom: -1.25rem !important;
}

.my-n6 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}

.my-n7 {
  margin-top: -1.75rem !important;
  margin-bottom: -1.75rem !important;
}

.my-n8 {
  margin-top: -2rem !important;
  margin-bottom: -2rem !important;
}

.my-n9 {
  margin-top: -2.25rem !important;
  margin-bottom: -2.25rem !important;
}

.my-n10 {
  margin-top: -2.5rem !important;
  margin-bottom: -2.5rem !important;
}

.my-n11 {
  margin-top: -2.75rem !important;
  margin-bottom: -2.75rem !important;
}

.my-n12 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important;
}

.my-n13 {
  margin-top: -3.25rem !important;
  margin-bottom: -3.25rem !important;
}

.my-n14 {
  margin-top: -3.5rem !important;
  margin-bottom: -3.5rem !important;
}

.my-n15 {
  margin-top: -3.75rem !important;
  margin-bottom: -3.75rem !important;
}

.my-n16 {
  margin-top: -4rem !important;
  margin-bottom: -4rem !important;
}

.my-n17 {
  margin-top: -4.25rem !important;
  margin-bottom: -4.25rem !important;
}

.my-n18 {
  margin-top: -4.5rem !important;
  margin-bottom: -4.5rem !important;
}

.my-n19 {
  margin-top: -4.75rem !important;
  margin-bottom: -4.75rem !important;
}

.my-n20 {
  margin-top: -5rem !important;
  margin-bottom: -5rem !important;
}

.mt-n1 {
  margin-top: -0.25rem !important;
}

.mt-n2 {
  margin-top: -0.5rem !important;
}

.mt-n3 {
  margin-top: -0.75rem !important;
}

.mt-n4 {
  margin-top: -1rem !important;
}

.mt-n5 {
  margin-top: -1.25rem !important;
}

.mt-n6 {
  margin-top: -1.5rem !important;
}

.mt-n7 {
  margin-top: -1.75rem !important;
}

.mt-n8 {
  margin-top: -2rem !important;
}

.mt-n9 {
  margin-top: -2.25rem !important;
}

.mt-n10 {
  margin-top: -2.5rem !important;
}

.mt-n11 {
  margin-top: -2.75rem !important;
}

.mt-n12 {
  margin-top: -3rem !important;
}

.mt-n13 {
  margin-top: -3.25rem !important;
}

.mt-n14 {
  margin-top: -3.5rem !important;
}

.mt-n15 {
  margin-top: -3.75rem !important;
}

.mt-n16 {
  margin-top: -4rem !important;
}

.mt-n17 {
  margin-top: -4.25rem !important;
}

.mt-n18 {
  margin-top: -4.5rem !important;
}

.mt-n19 {
  margin-top: -4.75rem !important;
}

.mt-n20 {
  margin-top: -5rem !important;
}

.me-n1 {
  margin-right: -0.25rem !important;
}

.me-n2 {
  margin-right: -0.5rem !important;
}

.me-n3 {
  margin-right: -0.75rem !important;
}

.me-n4 {
  margin-right: -1rem !important;
}

.me-n5 {
  margin-right: -1.25rem !important;
}

.me-n6 {
  margin-right: -1.5rem !important;
}

.me-n7 {
  margin-right: -1.75rem !important;
}

.me-n8 {
  margin-right: -2rem !important;
}

.me-n9 {
  margin-right: -2.25rem !important;
}

.me-n10 {
  margin-right: -2.5rem !important;
}

.me-n11 {
  margin-right: -2.75rem !important;
}

.me-n12 {
  margin-right: -3rem !important;
}

.me-n13 {
  margin-right: -3.25rem !important;
}

.me-n14 {
  margin-right: -3.5rem !important;
}

.me-n15 {
  margin-right: -3.75rem !important;
}

.me-n16 {
  margin-right: -4rem !important;
}

.me-n17 {
  margin-right: -4.25rem !important;
}

.me-n18 {
  margin-right: -4.5rem !important;
}

.me-n19 {
  margin-right: -4.75rem !important;
}

.me-n20 {
  margin-right: -5rem !important;
}

.mb-n1 {
  margin-bottom: -0.25rem !important;
}

.mb-n2 {
  margin-bottom: -0.5rem !important;
}

.mb-n3 {
  margin-bottom: -0.75rem !important;
}

.mb-n4 {
  margin-bottom: -1rem !important;
}

.mb-n5 {
  margin-bottom: -1.25rem !important;
}

.mb-n6 {
  margin-bottom: -1.5rem !important;
}

.mb-n7 {
  margin-bottom: -1.75rem !important;
}

.mb-n8 {
  margin-bottom: -2rem !important;
}

.mb-n9 {
  margin-bottom: -2.25rem !important;
}

.mb-n10 {
  margin-bottom: -2.5rem !important;
}

.mb-n11 {
  margin-bottom: -2.75rem !important;
}

.mb-n12 {
  margin-bottom: -3rem !important;
}

.mb-n13 {
  margin-bottom: -3.25rem !important;
}

.mb-n14 {
  margin-bottom: -3.5rem !important;
}

.mb-n15 {
  margin-bottom: -3.75rem !important;
}

.mb-n16 {
  margin-bottom: -4rem !important;
}

.mb-n17 {
  margin-bottom: -4.25rem !important;
}

.mb-n18 {
  margin-bottom: -4.5rem !important;
}

.mb-n19 {
  margin-bottom: -4.75rem !important;
}

.mb-n20 {
  margin-bottom: -5rem !important;
}

.ms-n1 {
  margin-left: -0.25rem !important;
}

.ms-n2 {
  margin-left: -0.5rem !important;
}

.ms-n3 {
  margin-left: -0.75rem !important;
}

.ms-n4 {
  margin-left: -1rem !important;
}

.ms-n5 {
  margin-left: -1.25rem !important;
}

.ms-n6 {
  margin-left: -1.5rem !important;
}

.ms-n7 {
  margin-left: -1.75rem !important;
}

.ms-n8 {
  margin-left: -2rem !important;
}

.ms-n9 {
  margin-left: -2.25rem !important;
}

.ms-n10 {
  margin-left: -2.5rem !important;
}

.ms-n11 {
  margin-left: -2.75rem !important;
}

.ms-n12 {
  margin-left: -3rem !important;
}

.ms-n13 {
  margin-left: -3.25rem !important;
}

.ms-n14 {
  margin-left: -3.5rem !important;
}

.ms-n15 {
  margin-left: -3.75rem !important;
}

.ms-n16 {
  margin-left: -4rem !important;
}

.ms-n17 {
  margin-left: -4.25rem !important;
}

.ms-n18 {
  margin-left: -4.5rem !important;
}

.ms-n19 {
  margin-left: -4.75rem !important;
}

.ms-n20 {
  margin-left: -5rem !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 0.75rem !important;
}

.p-4 {
  padding: 1rem !important;
}

.p-5 {
  padding: 1.25rem !important;
}

.p-6 {
  padding: 1.5rem !important;
}

.p-7 {
  padding: 1.75rem !important;
}

.p-8 {
  padding: 2rem !important;
}

.p-9 {
  padding: 2.25rem !important;
}

.p-10 {
  padding: 2.5rem !important;
}

.p-11 {
  padding: 2.75rem !important;
}

.p-12 {
  padding: 3rem !important;
}

.p-13 {
  padding: 3.25rem !important;
}

.p-14 {
  padding: 3.5rem !important;
}

.p-15 {
  padding: 3.75rem !important;
}

.p-16 {
  padding: 4rem !important;
}

.p-17 {
  padding: 4.25rem !important;
}

.p-18 {
  padding: 4.5rem !important;
}

.p-19 {
  padding: 4.75rem !important;
}

.p-20 {
  padding: 5rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 0.75rem !important;
  padding-left: 0.75rem !important;
}

.px-4 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-5 {
  padding-right: 1.25rem !important;
  padding-left: 1.25rem !important;
}

.px-6 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-7 {
  padding-right: 1.75rem !important;
  padding-left: 1.75rem !important;
}

.px-8 {
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}

.px-9 {
  padding-right: 2.25rem !important;
  padding-left: 2.25rem !important;
}

.px-10 {
  padding-right: 2.5rem !important;
  padding-left: 2.5rem !important;
}

.px-11 {
  padding-right: 2.75rem !important;
  padding-left: 2.75rem !important;
}

.px-12 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.px-13 {
  padding-right: 3.25rem !important;
  padding-left: 3.25rem !important;
}

.px-14 {
  padding-right: 3.5rem !important;
  padding-left: 3.5rem !important;
}

.px-15 {
  padding-right: 3.75rem !important;
  padding-left: 3.75rem !important;
}

.px-16 {
  padding-right: 4rem !important;
  padding-left: 4rem !important;
}

.px-17 {
  padding-right: 4.25rem !important;
  padding-left: 4.25rem !important;
}

.px-18 {
  padding-right: 4.5rem !important;
  padding-left: 4.5rem !important;
}

.px-19 {
  padding-right: 4.75rem !important;
  padding-left: 4.75rem !important;
}

.px-20 {
  padding-right: 5rem !important;
  padding-left: 5rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}

.py-4 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-5 {
  padding-top: 1.25rem !important;
  padding-bottom: 1.25rem !important;
}

.py-6 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-7 {
  padding-top: 1.75rem !important;
  padding-bottom: 1.75rem !important;
}

.py-8 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}

.py-9 {
  padding-top: 2.25rem !important;
  padding-bottom: 2.25rem !important;
}

.py-10 {
  padding-top: 2.5rem !important;
  padding-bottom: 2.5rem !important;
}

.py-11 {
  padding-top: 2.75rem !important;
  padding-bottom: 2.75rem !important;
}

.py-12 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.py-13 {
  padding-top: 3.25rem !important;
  padding-bottom: 3.25rem !important;
}

.py-14 {
  padding-top: 3.5rem !important;
  padding-bottom: 3.5rem !important;
}

.py-15 {
  padding-top: 3.75rem !important;
  padding-bottom: 3.75rem !important;
}

.py-16 {
  padding-top: 4rem !important;
  padding-bottom: 4rem !important;
}

.py-17 {
  padding-top: 4.25rem !important;
  padding-bottom: 4.25rem !important;
}

.py-18 {
  padding-top: 4.5rem !important;
  padding-bottom: 4.5rem !important;
}

.py-19 {
  padding-top: 4.75rem !important;
  padding-bottom: 4.75rem !important;
}

.py-20 {
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 0.75rem !important;
}

.pt-4 {
  padding-top: 1rem !important;
}

.pt-5 {
  padding-top: 1.25rem !important;
}

.pt-6 {
  padding-top: 1.5rem !important;
}

.pt-7 {
  padding-top: 1.75rem !important;
}

.pt-8 {
  padding-top: 2rem !important;
}

.pt-9 {
  padding-top: 2.25rem !important;
}

.pt-10 {
  padding-top: 2.5rem !important;
}

.pt-11 {
  padding-top: 2.75rem !important;
}

.pt-12 {
  padding-top: 3rem !important;
}

.pt-13 {
  padding-top: 3.25rem !important;
}

.pt-14 {
  padding-top: 3.5rem !important;
}

.pt-15 {
  padding-top: 3.75rem !important;
}

.pt-16 {
  padding-top: 4rem !important;
}

.pt-17 {
  padding-top: 4.25rem !important;
}

.pt-18 {
  padding-top: 4.5rem !important;
}

.pt-19 {
  padding-top: 4.75rem !important;
}

.pt-20 {
  padding-top: 5rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 0.75rem !important;
}

.pe-4 {
  padding-right: 1rem !important;
}

.pe-5 {
  padding-right: 1.25rem !important;
}

.pe-6 {
  padding-right: 1.5rem !important;
}

.pe-7 {
  padding-right: 1.75rem !important;
}

.pe-8 {
  padding-right: 2rem !important;
}

.pe-9 {
  padding-right: 2.25rem !important;
}

.pe-10 {
  padding-right: 2.5rem !important;
}

.pe-11 {
  padding-right: 2.75rem !important;
}

.pe-12 {
  padding-right: 3rem !important;
}

.pe-13 {
  padding-right: 3.25rem !important;
}

.pe-14 {
  padding-right: 3.5rem !important;
}

.pe-15 {
  padding-right: 3.75rem !important;
}

.pe-16 {
  padding-right: 4rem !important;
}

.pe-17 {
  padding-right: 4.25rem !important;
}

.pe-18 {
  padding-right: 4.5rem !important;
}

.pe-19 {
  padding-right: 4.75rem !important;
}

.pe-20 {
  padding-right: 5rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 0.75rem !important;
}

.pb-4 {
  padding-bottom: 1rem !important;
}

.pb-5 {
  padding-bottom: 1.25rem !important;
}

.pb-6 {
  padding-bottom: 1.5rem !important;
}

.pb-7 {
  padding-bottom: 1.75rem !important;
}

.pb-8 {
  padding-bottom: 2rem !important;
}

.pb-9 {
  padding-bottom: 2.25rem !important;
}

.pb-10 {
  padding-bottom: 2.5rem !important;
}

.pb-11 {
  padding-bottom: 2.75rem !important;
}

.pb-12 {
  padding-bottom: 3rem !important;
}

.pb-13 {
  padding-bottom: 3.25rem !important;
}

.pb-14 {
  padding-bottom: 3.5rem !important;
}

.pb-15 {
  padding-bottom: 3.75rem !important;
}

.pb-16 {
  padding-bottom: 4rem !important;
}

.pb-17 {
  padding-bottom: 4.25rem !important;
}

.pb-18 {
  padding-bottom: 4.5rem !important;
}

.pb-19 {
  padding-bottom: 4.75rem !important;
}

.pb-20 {
  padding-bottom: 5rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 0.75rem !important;
}

.ps-4 {
  padding-left: 1rem !important;
}

.ps-5 {
  padding-left: 1.25rem !important;
}

.ps-6 {
  padding-left: 1.5rem !important;
}

.ps-7 {
  padding-left: 1.75rem !important;
}

.ps-8 {
  padding-left: 2rem !important;
}

.ps-9 {
  padding-left: 2.25rem !important;
}

.ps-10 {
  padding-left: 2.5rem !important;
}

.ps-11 {
  padding-left: 2.75rem !important;
}

.ps-12 {
  padding-left: 3rem !important;
}

.ps-13 {
  padding-left: 3.25rem !important;
}

.ps-14 {
  padding-left: 3.5rem !important;
}

.ps-15 {
  padding-left: 3.75rem !important;
}

.ps-16 {
  padding-left: 4rem !important;
}

.ps-17 {
  padding-left: 4.25rem !important;
}

.ps-18 {
  padding-left: 4.5rem !important;
}

.ps-19 {
  padding-left: 4.75rem !important;
}

.ps-20 {
  padding-left: 5rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 0.75rem !important;
}

.gap-4 {
  gap: 1rem !important;
}

.gap-5 {
  gap: 1.25rem !important;
}

.gap-6 {
  gap: 1.5rem !important;
}

.gap-7 {
  gap: 1.75rem !important;
}

.gap-8 {
  gap: 2rem !important;
}

.gap-9 {
  gap: 2.25rem !important;
}

.gap-10 {
  gap: 2.5rem !important;
}

.gap-11 {
  gap: 2.75rem !important;
}

.gap-12 {
  gap: 3rem !important;
}

.gap-13 {
  gap: 3.25rem !important;
}

.gap-14 {
  gap: 3.5rem !important;
}

.gap-15 {
  gap: 3.75rem !important;
}

.gap-16 {
  gap: 4rem !important;
}

.gap-17 {
  gap: 4.25rem !important;
}

.gap-18 {
  gap: 4.5rem !important;
}

.gap-19 {
  gap: 4.75rem !important;
}

.gap-20 {
  gap: 5rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 0.75rem !important;
}

.row-gap-4 {
  row-gap: 1rem !important;
}

.row-gap-5 {
  row-gap: 1.25rem !important;
}

.row-gap-6 {
  row-gap: 1.5rem !important;
}

.row-gap-7 {
  row-gap: 1.75rem !important;
}

.row-gap-8 {
  row-gap: 2rem !important;
}

.row-gap-9 {
  row-gap: 2.25rem !important;
}

.row-gap-10 {
  row-gap: 2.5rem !important;
}

.row-gap-11 {
  row-gap: 2.75rem !important;
}

.row-gap-12 {
  row-gap: 3rem !important;
}

.row-gap-13 {
  row-gap: 3.25rem !important;
}

.row-gap-14 {
  row-gap: 3.5rem !important;
}

.row-gap-15 {
  row-gap: 3.75rem !important;
}

.row-gap-16 {
  row-gap: 4rem !important;
}

.row-gap-17 {
  row-gap: 4.25rem !important;
}

.row-gap-18 {
  row-gap: 4.5rem !important;
}

.row-gap-19 {
  row-gap: 4.75rem !important;
}

.row-gap-20 {
  row-gap: 5rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 0.75rem !important;
}

.column-gap-4 {
  column-gap: 1rem !important;
}

.column-gap-5 {
  column-gap: 1.25rem !important;
}

.column-gap-6 {
  column-gap: 1.5rem !important;
}

.column-gap-7 {
  column-gap: 1.75rem !important;
}

.column-gap-8 {
  column-gap: 2rem !important;
}

.column-gap-9 {
  column-gap: 2.25rem !important;
}

.column-gap-10 {
  column-gap: 2.5rem !important;
}

.column-gap-11 {
  column-gap: 2.75rem !important;
}

.column-gap-12 {
  column-gap: 3rem !important;
}

.column-gap-13 {
  column-gap: 3.25rem !important;
}

.column-gap-14 {
  column-gap: 3.5rem !important;
}

.column-gap-15 {
  column-gap: 3.75rem !important;
}

.column-gap-16 {
  column-gap: 4rem !important;
}

.column-gap-17 {
  column-gap: 4.25rem !important;
}

.column-gap-18 {
  column-gap: 4.5rem !important;
}

.column-gap-19 {
  column-gap: 4.75rem !important;
}

.column-gap-20 {
  column-gap: 5rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-2 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-3 {
  font-size: calc(1.26rem + 0.12vw) !important;
}

.fs-4 {
  font-size: 1.25rem !important;
}

.fs-5 {
  font-size: 1.15rem !important;
}

.fs-6 {
  font-size: 1.075rem !important;
}

.fs-7 {
  font-size: 0.95rem !important;
}

.fs-8 {
  font-size: 0.85rem !important;
}

.fs-9 {
  font-size: 0.75rem !important;
}

.fs-10 {
  font-size: 0.5rem !important;
}

.fs-base {
  font-size: 1rem !important;
}

.fs-fluid {
  font-size: 100% !important;
}

.fs-2x {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-2qx {
  font-size: calc(1.35rem + 1.2vw) !important;
}

.fs-2hx {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2tx {
  font-size: calc(1.4rem + 1.8vw) !important;
}

.fs-3x {
  font-size: calc(1.425rem + 2.1vw) !important;
}

.fs-3qx {
  font-size: calc(1.45rem + 2.4vw) !important;
}

.fs-3hx {
  font-size: calc(1.475rem + 2.7vw) !important;
}

.fs-3tx {
  font-size: calc(1.5rem + 3vw) !important;
}

.fs-4x {
  font-size: calc(1.525rem + 3.3vw) !important;
}

.fs-4qx {
  font-size: calc(1.55rem + 3.6vw) !important;
}

.fs-4hx {
  font-size: calc(1.575rem + 3.9vw) !important;
}

.fs-4tx {
  font-size: calc(1.6rem + 4.2vw) !important;
}

.fs-5x {
  font-size: calc(1.625rem + 4.5vw) !important;
}

.fs-5qx {
  font-size: calc(1.65rem + 4.8vw) !important;
}

.fs-5hx {
  font-size: calc(1.675rem + 5.1vw) !important;
}

.fs-5tx {
  font-size: calc(1.7rem + 5.4vw) !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 500 !important;
}

.fw-bolder {
  font-weight: 600 !important;
}

.lh-0 {
  line-height: 0 !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 1.75 !important;
}

.lh-xl {
  line-height: 2 !important;
}

.lh-xxl {
  line-height: 2.25 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-white {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-white-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-index-n1 {
  z-index: -1 !important;
}

.z-index-n2 {
  z-index: -2 !important;
}

.z-index-0 {
  z-index: 0 !important;
}

.z-index-1 {
  z-index: 1 !important;
}

.z-index-2 {
  z-index: 2 !important;
}

.z-index-3 {
  z-index: 3 !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-0-hover:hover {
  opacity: 0 !important;
}

.opacity-5 {
  opacity: 0.05 !important;
}

.opacity-5-hover:hover {
  opacity: 0.05 !important;
}

.opacity-10 {
  opacity: 0.1 !important;
}

.opacity-10-hover:hover {
  opacity: 0.1 !important;
}

.opacity-15 {
  opacity: 0.15 !important;
}

.opacity-15-hover:hover {
  opacity: 0.15 !important;
}

.opacity-20 {
  opacity: 0.2 !important;
}

.opacity-20-hover:hover {
  opacity: 0.2 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-25-hover:hover {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-50-hover:hover {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-75-hover:hover {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.opacity-100-hover:hover {
  opacity: 1 !important;
}

.min-w-unset {
  min-width: unset !important;
}

.min-w-25 {
  min-width: 25% !important;
}

.min-w-50 {
  min-width: 50% !important;
}

.min-w-75 {
  min-width: 75% !important;
}

.min-w-100 {
  min-width: 100% !important;
}

.min-w-auto {
  min-width: auto !important;
}

.min-w-1px {
  min-width: 1px !important;
}

.min-w-2px {
  min-width: 2px !important;
}

.min-w-3px {
  min-width: 3px !important;
}

.min-w-4px {
  min-width: 4px !important;
}

.min-w-5px {
  min-width: 5px !important;
}

.min-w-6px {
  min-width: 6px !important;
}

.min-w-7px {
  min-width: 7px !important;
}

.min-w-8px {
  min-width: 8px !important;
}

.min-w-9px {
  min-width: 9px !important;
}

.min-w-10px {
  min-width: 10px !important;
}

.min-w-15px {
  min-width: 15px !important;
}

.min-w-20px {
  min-width: 20px !important;
}

.min-w-25px {
  min-width: 25px !important;
}

.min-w-30px {
  min-width: 30px !important;
}

.min-w-35px {
  min-width: 35px !important;
}

.min-w-40px {
  min-width: 40px !important;
}

.min-w-45px {
  min-width: 45px !important;
}

.min-w-50px {
  min-width: 50px !important;
}

.min-w-55px {
  min-width: 55px !important;
}

.min-w-60px {
  min-width: 60px !important;
}

.min-w-65px {
  min-width: 65px !important;
}

.min-w-70px {
  min-width: 70px !important;
}

.min-w-75px {
  min-width: 75px !important;
}

.min-w-80px {
  min-width: 80px !important;
}

.min-w-85px {
  min-width: 85px !important;
}

.min-w-90px {
  min-width: 90px !important;
}

.min-w-95px {
  min-width: 95px !important;
}

.min-w-100px {
  min-width: 100px !important;
}

.min-w-125px {
  min-width: 125px !important;
}

.min-w-150px {
  min-width: 150px !important;
}

.min-w-175px {
  min-width: 175px !important;
}

.min-w-200px {
  min-width: 200px !important;
}

.min-w-225px {
  min-width: 225px !important;
}

.min-w-250px {
  min-width: 250px !important;
}

.min-w-275px {
  min-width: 275px !important;
}

.min-w-300px {
  min-width: 300px !important;
}

.min-w-325px {
  min-width: 325px !important;
}

.min-w-350px {
  min-width: 350px !important;
}

.min-w-375px {
  min-width: 375px !important;
}

.min-w-400px {
  min-width: 400px !important;
}

.min-w-425px {
  min-width: 425px !important;
}

.min-w-450px {
  min-width: 450px !important;
}

.min-w-475px {
  min-width: 475px !important;
}

.min-w-500px {
  min-width: 500px !important;
}

.min-w-550px {
  min-width: 550px !important;
}

.min-w-600px {
  min-width: 600px !important;
}

.min-w-650px {
  min-width: 650px !important;
}

.min-w-700px {
  min-width: 700px !important;
}

.min-w-750px {
  min-width: 750px !important;
}

.min-w-800px {
  min-width: 800px !important;
}

.min-w-850px {
  min-width: 850px !important;
}

.min-w-900px {
  min-width: 900px !important;
}

.min-w-950px {
  min-width: 950px !important;
}

.min-w-1000px {
  min-width: 1000px !important;
}

.min-h-unset {
  min-height: unset !important;
}

.min-h-25 {
  min-height: 25% !important;
}

.min-h-50 {
  min-height: 50% !important;
}

.min-h-75 {
  min-height: 75% !important;
}

.min-h-100 {
  min-height: 100% !important;
}

.min-h-auto {
  min-height: auto !important;
}

.min-h-1px {
  min-height: 1px !important;
}

.min-h-2px {
  min-height: 2px !important;
}

.min-h-3px {
  min-height: 3px !important;
}

.min-h-4px {
  min-height: 4px !important;
}

.min-h-5px {
  min-height: 5px !important;
}

.min-h-6px {
  min-height: 6px !important;
}

.min-h-7px {
  min-height: 7px !important;
}

.min-h-8px {
  min-height: 8px !important;
}

.min-h-9px {
  min-height: 9px !important;
}

.min-h-10px {
  min-height: 10px !important;
}

.min-h-15px {
  min-height: 15px !important;
}

.min-h-20px {
  min-height: 20px !important;
}

.min-h-25px {
  min-height: 25px !important;
}

.min-h-30px {
  min-height: 30px !important;
}

.min-h-35px {
  min-height: 35px !important;
}

.min-h-40px {
  min-height: 40px !important;
}

.min-h-45px {
  min-height: 45px !important;
}

.min-h-50px {
  min-height: 50px !important;
}

.min-h-55px {
  min-height: 55px !important;
}

.min-h-60px {
  min-height: 60px !important;
}

.min-h-65px {
  min-height: 65px !important;
}

.min-h-70px {
  min-height: 70px !important;
}

.min-h-75px {
  min-height: 75px !important;
}

.min-h-80px {
  min-height: 80px !important;
}

.min-h-85px {
  min-height: 85px !important;
}

.min-h-90px {
  min-height: 90px !important;
}

.min-h-95px {
  min-height: 95px !important;
}

.min-h-100px {
  min-height: 100px !important;
}

.min-h-125px {
  min-height: 125px !important;
}

.min-h-150px {
  min-height: 150px !important;
}

.min-h-175px {
  min-height: 175px !important;
}

.min-h-200px {
  min-height: 200px !important;
}

.min-h-225px {
  min-height: 225px !important;
}

.min-h-250px {
  min-height: 250px !important;
}

.min-h-275px {
  min-height: 275px !important;
}

.min-h-300px {
  min-height: 300px !important;
}

.min-h-325px {
  min-height: 325px !important;
}

.min-h-350px {
  min-height: 350px !important;
}

.min-h-375px {
  min-height: 375px !important;
}

.min-h-400px {
  min-height: 400px !important;
}

.min-h-425px {
  min-height: 425px !important;
}

.min-h-450px {
  min-height: 450px !important;
}

.min-h-475px {
  min-height: 475px !important;
}

.min-h-500px {
  min-height: 500px !important;
}

.min-h-550px {
  min-height: 550px !important;
}

.min-h-600px {
  min-height: 600px !important;
}

.min-h-650px {
  min-height: 650px !important;
}

.min-h-700px {
  min-height: 700px !important;
}

.min-h-750px {
  min-height: 750px !important;
}

.min-h-800px {
  min-height: 800px !important;
}

.min-h-850px {
  min-height: 850px !important;
}

.min-h-900px {
  min-height: 900px !important;
}

.min-h-950px {
  min-height: 950px !important;
}

.min-h-1000px {
  min-height: 1000px !important;
}

.border-top-0 {
  border-top-width: 0 !important;
}

.border-top-1 {
  border-top-width: 1px !important;
}

.border-top-2 {
  border-top-width: 2px !important;
}

.border-top-3 {
  border-top-width: 3px !important;
}

.border-top-4 {
  border-top-width: 4px !important;
}

.border-top-5 {
  border-top-width: 5px !important;
}

.border-bottom-0 {
  border-bottom-width: 0 !important;
}

.border-bottom-1 {
  border-bottom-width: 1px !important;
}

.border-bottom-2 {
  border-bottom-width: 2px !important;
}

.border-bottom-3 {
  border-bottom-width: 3px !important;
}

.border-bottom-4 {
  border-bottom-width: 4px !important;
}

.border-bottom-5 {
  border-bottom-width: 5px !important;
}

.border-right-0 {
  border-right-width: 0 !important;
}

.border-right-1 {
  border-right-width: 1px !important;
}

.border-right-2 {
  border-right-width: 2px !important;
}

.border-right-3 {
  border-right-width: 3px !important;
}

.border-right-4 {
  border-right-width: 4px !important;
}

.border-right-5 {
  border-right-width: 5px !important;
}

.border-left-0 {
  border-left-width: 0 !important;
}

.border-left-1 {
  border-left-width: 1px !important;
}

.border-left-2 {
  border-left-width: 2px !important;
}

.border-left-3 {
  border-left-width: 3px !important;
}

.border-left-4 {
  border-left-width: 4px !important;
}

.border-left-5 {
  border-left-width: 5px !important;
}

.ls-1 {
  letter-spacing: 0.1rem !important;
}

.ls-2 {
  letter-spacing: 0.115rem !important;
}

.ls-3 {
  letter-spacing: 0.125rem !important;
}

.ls-4 {
  letter-spacing: 0.25rem !important;
}

.ls-5 {
  letter-spacing: 0.5rem !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }

  .float-sm-end {
    float: right !important;
  }

  .float-sm-none {
    float: none !important;
  }

  .object-fit-sm-contain {
    object-fit: contain !important;
  }

  .object-fit-sm-cover {
    object-fit: cover !important;
  }

  .object-fit-sm-fill {
    object-fit: fill !important;
  }

  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }

  .object-fit-sm-none {
    object-fit: none !important;
  }

  .d-sm-inline {
    display: inline !important;
  }

  .d-sm-inline-block {
    display: inline-block !important;
  }

  .d-sm-block {
    display: block !important;
  }

  .d-sm-grid {
    display: grid !important;
  }

  .d-sm-inline-grid {
    display: inline-grid !important;
  }

  .d-sm-table {
    display: table !important;
  }

  .d-sm-table-row {
    display: table-row !important;
  }

  .d-sm-table-cell {
    display: table-cell !important;
  }

  .d-sm-flex {
    display: flex !important;
  }

  .d-sm-inline-flex {
    display: inline-flex !important;
  }

  .d-sm-none {
    display: none !important;
  }

  .position-sm-static {
    position: static !important;
  }

  .position-sm-relative {
    position: relative !important;
  }

  .position-sm-absolute {
    position: absolute !important;
  }

  .position-sm-fixed {
    position: fixed !important;
  }

  .position-sm-sticky {
    position: sticky !important;
  }

  .w-sm-unset {
    width: unset !important;
  }

  .w-sm-25 {
    width: 25% !important;
  }

  .w-sm-50 {
    width: 50% !important;
  }

  .w-sm-75 {
    width: 75% !important;
  }

  .w-sm-100 {
    width: 100% !important;
  }

  .w-sm-auto {
    width: auto !important;
  }

  .w-sm-1px {
    width: 1px !important;
  }

  .w-sm-2px {
    width: 2px !important;
  }

  .w-sm-3px {
    width: 3px !important;
  }

  .w-sm-4px {
    width: 4px !important;
  }

  .w-sm-5px {
    width: 5px !important;
  }

  .w-sm-6px {
    width: 6px !important;
  }

  .w-sm-7px {
    width: 7px !important;
  }

  .w-sm-8px {
    width: 8px !important;
  }

  .w-sm-9px {
    width: 9px !important;
  }

  .w-sm-10px {
    width: 10px !important;
  }

  .w-sm-15px {
    width: 15px !important;
  }

  .w-sm-20px {
    width: 20px !important;
  }

  .w-sm-25px {
    width: 25px !important;
  }

  .w-sm-30px {
    width: 30px !important;
  }

  .w-sm-35px {
    width: 35px !important;
  }

  .w-sm-40px {
    width: 40px !important;
  }

  .w-sm-45px {
    width: 45px !important;
  }

  .w-sm-50px {
    width: 50px !important;
  }

  .w-sm-55px {
    width: 55px !important;
  }

  .w-sm-60px {
    width: 60px !important;
  }

  .w-sm-65px {
    width: 65px !important;
  }

  .w-sm-70px {
    width: 70px !important;
  }

  .w-sm-75px {
    width: 75px !important;
  }

  .w-sm-80px {
    width: 80px !important;
  }

  .w-sm-85px {
    width: 85px !important;
  }

  .w-sm-90px {
    width: 90px !important;
  }

  .w-sm-95px {
    width: 95px !important;
  }

  .w-sm-100px {
    width: 100px !important;
  }

  .w-sm-125px {
    width: 125px !important;
  }

  .w-sm-150px {
    width: 150px !important;
  }

  .w-sm-175px {
    width: 175px !important;
  }

  .w-sm-200px {
    width: 200px !important;
  }

  .w-sm-225px {
    width: 225px !important;
  }

  .w-sm-250px {
    width: 250px !important;
  }

  .w-sm-275px {
    width: 275px !important;
  }

  .w-sm-300px {
    width: 300px !important;
  }

  .w-sm-325px {
    width: 325px !important;
  }

  .w-sm-350px {
    width: 350px !important;
  }

  .w-sm-375px {
    width: 375px !important;
  }

  .w-sm-400px {
    width: 400px !important;
  }

  .w-sm-425px {
    width: 425px !important;
  }

  .w-sm-450px {
    width: 450px !important;
  }

  .w-sm-475px {
    width: 475px !important;
  }

  .w-sm-500px {
    width: 500px !important;
  }

  .w-sm-550px {
    width: 550px !important;
  }

  .w-sm-600px {
    width: 600px !important;
  }

  .w-sm-650px {
    width: 650px !important;
  }

  .w-sm-700px {
    width: 700px !important;
  }

  .w-sm-750px {
    width: 750px !important;
  }

  .w-sm-800px {
    width: 800px !important;
  }

  .w-sm-850px {
    width: 850px !important;
  }

  .w-sm-900px {
    width: 900px !important;
  }

  .w-sm-950px {
    width: 950px !important;
  }

  .w-sm-1000px {
    width: 1000px !important;
  }

  .mw-sm-unset {
    max-width: unset !important;
  }

  .mw-sm-25 {
    max-width: 25% !important;
  }

  .mw-sm-50 {
    max-width: 50% !important;
  }

  .mw-sm-75 {
    max-width: 75% !important;
  }

  .mw-sm-100 {
    max-width: 100% !important;
  }

  .mw-sm-auto {
    max-width: auto !important;
  }

  .mw-sm-1px {
    max-width: 1px !important;
  }

  .mw-sm-2px {
    max-width: 2px !important;
  }

  .mw-sm-3px {
    max-width: 3px !important;
  }

  .mw-sm-4px {
    max-width: 4px !important;
  }

  .mw-sm-5px {
    max-width: 5px !important;
  }

  .mw-sm-6px {
    max-width: 6px !important;
  }

  .mw-sm-7px {
    max-width: 7px !important;
  }

  .mw-sm-8px {
    max-width: 8px !important;
  }

  .mw-sm-9px {
    max-width: 9px !important;
  }

  .mw-sm-10px {
    max-width: 10px !important;
  }

  .mw-sm-15px {
    max-width: 15px !important;
  }

  .mw-sm-20px {
    max-width: 20px !important;
  }

  .mw-sm-25px {
    max-width: 25px !important;
  }

  .mw-sm-30px {
    max-width: 30px !important;
  }

  .mw-sm-35px {
    max-width: 35px !important;
  }

  .mw-sm-40px {
    max-width: 40px !important;
  }

  .mw-sm-45px {
    max-width: 45px !important;
  }

  .mw-sm-50px {
    max-width: 50px !important;
  }

  .mw-sm-55px {
    max-width: 55px !important;
  }

  .mw-sm-60px {
    max-width: 60px !important;
  }

  .mw-sm-65px {
    max-width: 65px !important;
  }

  .mw-sm-70px {
    max-width: 70px !important;
  }

  .mw-sm-75px {
    max-width: 75px !important;
  }

  .mw-sm-80px {
    max-width: 80px !important;
  }

  .mw-sm-85px {
    max-width: 85px !important;
  }

  .mw-sm-90px {
    max-width: 90px !important;
  }

  .mw-sm-95px {
    max-width: 95px !important;
  }

  .mw-sm-100px {
    max-width: 100px !important;
  }

  .mw-sm-125px {
    max-width: 125px !important;
  }

  .mw-sm-150px {
    max-width: 150px !important;
  }

  .mw-sm-175px {
    max-width: 175px !important;
  }

  .mw-sm-200px {
    max-width: 200px !important;
  }

  .mw-sm-225px {
    max-width: 225px !important;
  }

  .mw-sm-250px {
    max-width: 250px !important;
  }

  .mw-sm-275px {
    max-width: 275px !important;
  }

  .mw-sm-300px {
    max-width: 300px !important;
  }

  .mw-sm-325px {
    max-width: 325px !important;
  }

  .mw-sm-350px {
    max-width: 350px !important;
  }

  .mw-sm-375px {
    max-width: 375px !important;
  }

  .mw-sm-400px {
    max-width: 400px !important;
  }

  .mw-sm-425px {
    max-width: 425px !important;
  }

  .mw-sm-450px {
    max-width: 450px !important;
  }

  .mw-sm-475px {
    max-width: 475px !important;
  }

  .mw-sm-500px {
    max-width: 500px !important;
  }

  .mw-sm-550px {
    max-width: 550px !important;
  }

  .mw-sm-600px {
    max-width: 600px !important;
  }

  .mw-sm-650px {
    max-width: 650px !important;
  }

  .mw-sm-700px {
    max-width: 700px !important;
  }

  .mw-sm-750px {
    max-width: 750px !important;
  }

  .mw-sm-800px {
    max-width: 800px !important;
  }

  .mw-sm-850px {
    max-width: 850px !important;
  }

  .mw-sm-900px {
    max-width: 900px !important;
  }

  .mw-sm-950px {
    max-width: 950px !important;
  }

  .mw-sm-1000px {
    max-width: 1000px !important;
  }

  .h-sm-unset {
    height: unset !important;
  }

  .h-sm-25 {
    height: 25% !important;
  }

  .h-sm-50 {
    height: 50% !important;
  }

  .h-sm-75 {
    height: 75% !important;
  }

  .h-sm-100 {
    height: 100% !important;
  }

  .h-sm-auto {
    height: auto !important;
  }

  .h-sm-1px {
    height: 1px !important;
  }

  .h-sm-2px {
    height: 2px !important;
  }

  .h-sm-3px {
    height: 3px !important;
  }

  .h-sm-4px {
    height: 4px !important;
  }

  .h-sm-5px {
    height: 5px !important;
  }

  .h-sm-6px {
    height: 6px !important;
  }

  .h-sm-7px {
    height: 7px !important;
  }

  .h-sm-8px {
    height: 8px !important;
  }

  .h-sm-9px {
    height: 9px !important;
  }

  .h-sm-10px {
    height: 10px !important;
  }

  .h-sm-15px {
    height: 15px !important;
  }

  .h-sm-20px {
    height: 20px !important;
  }

  .h-sm-25px {
    height: 25px !important;
  }

  .h-sm-30px {
    height: 30px !important;
  }

  .h-sm-35px {
    height: 35px !important;
  }

  .h-sm-40px {
    height: 40px !important;
  }

  .h-sm-45px {
    height: 45px !important;
  }

  .h-sm-50px {
    height: 50px !important;
  }

  .h-sm-55px {
    height: 55px !important;
  }

  .h-sm-60px {
    height: 60px !important;
  }

  .h-sm-65px {
    height: 65px !important;
  }

  .h-sm-70px {
    height: 70px !important;
  }

  .h-sm-75px {
    height: 75px !important;
  }

  .h-sm-80px {
    height: 80px !important;
  }

  .h-sm-85px {
    height: 85px !important;
  }

  .h-sm-90px {
    height: 90px !important;
  }

  .h-sm-95px {
    height: 95px !important;
  }

  .h-sm-100px {
    height: 100px !important;
  }

  .h-sm-125px {
    height: 125px !important;
  }

  .h-sm-150px {
    height: 150px !important;
  }

  .h-sm-175px {
    height: 175px !important;
  }

  .h-sm-200px {
    height: 200px !important;
  }

  .h-sm-225px {
    height: 225px !important;
  }

  .h-sm-250px {
    height: 250px !important;
  }

  .h-sm-275px {
    height: 275px !important;
  }

  .h-sm-300px {
    height: 300px !important;
  }

  .h-sm-325px {
    height: 325px !important;
  }

  .h-sm-350px {
    height: 350px !important;
  }

  .h-sm-375px {
    height: 375px !important;
  }

  .h-sm-400px {
    height: 400px !important;
  }

  .h-sm-425px {
    height: 425px !important;
  }

  .h-sm-450px {
    height: 450px !important;
  }

  .h-sm-475px {
    height: 475px !important;
  }

  .h-sm-500px {
    height: 500px !important;
  }

  .h-sm-550px {
    height: 550px !important;
  }

  .h-sm-600px {
    height: 600px !important;
  }

  .h-sm-650px {
    height: 650px !important;
  }

  .h-sm-700px {
    height: 700px !important;
  }

  .h-sm-750px {
    height: 750px !important;
  }

  .h-sm-800px {
    height: 800px !important;
  }

  .h-sm-850px {
    height: 850px !important;
  }

  .h-sm-900px {
    height: 900px !important;
  }

  .h-sm-950px {
    height: 950px !important;
  }

  .h-sm-1000px {
    height: 1000px !important;
  }

  .mh-sm-unset {
    max-height: unset !important;
  }

  .mh-sm-25 {
    max-height: 25% !important;
  }

  .mh-sm-50 {
    max-height: 50% !important;
  }

  .mh-sm-75 {
    max-height: 75% !important;
  }

  .mh-sm-100 {
    max-height: 100% !important;
  }

  .mh-sm-auto {
    max-height: auto !important;
  }

  .mh-sm-1px {
    max-height: 1px !important;
  }

  .mh-sm-2px {
    max-height: 2px !important;
  }

  .mh-sm-3px {
    max-height: 3px !important;
  }

  .mh-sm-4px {
    max-height: 4px !important;
  }

  .mh-sm-5px {
    max-height: 5px !important;
  }

  .mh-sm-6px {
    max-height: 6px !important;
  }

  .mh-sm-7px {
    max-height: 7px !important;
  }

  .mh-sm-8px {
    max-height: 8px !important;
  }

  .mh-sm-9px {
    max-height: 9px !important;
  }

  .mh-sm-10px {
    max-height: 10px !important;
  }

  .mh-sm-15px {
    max-height: 15px !important;
  }

  .mh-sm-20px {
    max-height: 20px !important;
  }

  .mh-sm-25px {
    max-height: 25px !important;
  }

  .mh-sm-30px {
    max-height: 30px !important;
  }

  .mh-sm-35px {
    max-height: 35px !important;
  }

  .mh-sm-40px {
    max-height: 40px !important;
  }

  .mh-sm-45px {
    max-height: 45px !important;
  }

  .mh-sm-50px {
    max-height: 50px !important;
  }

  .mh-sm-55px {
    max-height: 55px !important;
  }

  .mh-sm-60px {
    max-height: 60px !important;
  }

  .mh-sm-65px {
    max-height: 65px !important;
  }

  .mh-sm-70px {
    max-height: 70px !important;
  }

  .mh-sm-75px {
    max-height: 75px !important;
  }

  .mh-sm-80px {
    max-height: 80px !important;
  }

  .mh-sm-85px {
    max-height: 85px !important;
  }

  .mh-sm-90px {
    max-height: 90px !important;
  }

  .mh-sm-95px {
    max-height: 95px !important;
  }

  .mh-sm-100px {
    max-height: 100px !important;
  }

  .mh-sm-125px {
    max-height: 125px !important;
  }

  .mh-sm-150px {
    max-height: 150px !important;
  }

  .mh-sm-175px {
    max-height: 175px !important;
  }

  .mh-sm-200px {
    max-height: 200px !important;
  }

  .mh-sm-225px {
    max-height: 225px !important;
  }

  .mh-sm-250px {
    max-height: 250px !important;
  }

  .mh-sm-275px {
    max-height: 275px !important;
  }

  .mh-sm-300px {
    max-height: 300px !important;
  }

  .mh-sm-325px {
    max-height: 325px !important;
  }

  .mh-sm-350px {
    max-height: 350px !important;
  }

  .mh-sm-375px {
    max-height: 375px !important;
  }

  .mh-sm-400px {
    max-height: 400px !important;
  }

  .mh-sm-425px {
    max-height: 425px !important;
  }

  .mh-sm-450px {
    max-height: 450px !important;
  }

  .mh-sm-475px {
    max-height: 475px !important;
  }

  .mh-sm-500px {
    max-height: 500px !important;
  }

  .mh-sm-550px {
    max-height: 550px !important;
  }

  .mh-sm-600px {
    max-height: 600px !important;
  }

  .mh-sm-650px {
    max-height: 650px !important;
  }

  .mh-sm-700px {
    max-height: 700px !important;
  }

  .mh-sm-750px {
    max-height: 750px !important;
  }

  .mh-sm-800px {
    max-height: 800px !important;
  }

  .mh-sm-850px {
    max-height: 850px !important;
  }

  .mh-sm-900px {
    max-height: 900px !important;
  }

  .mh-sm-950px {
    max-height: 950px !important;
  }

  .mh-sm-1000px {
    max-height: 1000px !important;
  }

  .flex-sm-fill {
    flex: 1 1 auto !important;
  }

  .flex-sm-row {
    flex-direction: row !important;
  }

  .flex-sm-column {
    flex-direction: column !important;
  }

  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }

  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-sm-start {
    justify-content: flex-start !important;
  }

  .justify-content-sm-end {
    justify-content: flex-end !important;
  }

  .justify-content-sm-center {
    justify-content: center !important;
  }

  .justify-content-sm-between {
    justify-content: space-between !important;
  }

  .justify-content-sm-around {
    justify-content: space-around !important;
  }

  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-sm-start {
    align-items: flex-start !important;
  }

  .align-items-sm-end {
    align-items: flex-end !important;
  }

  .align-items-sm-center {
    align-items: center !important;
  }

  .align-items-sm-baseline {
    align-items: baseline !important;
  }

  .align-items-sm-stretch {
    align-items: stretch !important;
  }

  .align-content-sm-start {
    align-content: flex-start !important;
  }

  .align-content-sm-end {
    align-content: flex-end !important;
  }

  .align-content-sm-center {
    align-content: center !important;
  }

  .align-content-sm-between {
    align-content: space-between !important;
  }

  .align-content-sm-around {
    align-content: space-around !important;
  }

  .align-content-sm-stretch {
    align-content: stretch !important;
  }

  .align-self-sm-auto {
    align-self: auto !important;
  }

  .align-self-sm-start {
    align-self: flex-start !important;
  }

  .align-self-sm-end {
    align-self: flex-end !important;
  }

  .align-self-sm-center {
    align-self: center !important;
  }

  .align-self-sm-baseline {
    align-self: baseline !important;
  }

  .align-self-sm-stretch {
    align-self: stretch !important;
  }

  .order-sm-first {
    order: -1 !important;
  }

  .order-sm-0 {
    order: 0 !important;
  }

  .order-sm-1 {
    order: 1 !important;
  }

  .order-sm-2 {
    order: 2 !important;
  }

  .order-sm-3 {
    order: 3 !important;
  }

  .order-sm-4 {
    order: 4 !important;
  }

  .order-sm-5 {
    order: 5 !important;
  }

  .order-sm-last {
    order: 6 !important;
  }

  .m-sm-0 {
    margin: 0 !important;
  }

  .m-sm-1 {
    margin: 0.25rem !important;
  }

  .m-sm-2 {
    margin: 0.5rem !important;
  }

  .m-sm-3 {
    margin: 0.75rem !important;
  }

  .m-sm-4 {
    margin: 1rem !important;
  }

  .m-sm-5 {
    margin: 1.25rem !important;
  }

  .m-sm-6 {
    margin: 1.5rem !important;
  }

  .m-sm-7 {
    margin: 1.75rem !important;
  }

  .m-sm-8 {
    margin: 2rem !important;
  }

  .m-sm-9 {
    margin: 2.25rem !important;
  }

  .m-sm-10 {
    margin: 2.5rem !important;
  }

  .m-sm-11 {
    margin: 2.75rem !important;
  }

  .m-sm-12 {
    margin: 3rem !important;
  }

  .m-sm-13 {
    margin: 3.25rem !important;
  }

  .m-sm-14 {
    margin: 3.5rem !important;
  }

  .m-sm-15 {
    margin: 3.75rem !important;
  }

  .m-sm-16 {
    margin: 4rem !important;
  }

  .m-sm-17 {
    margin: 4.25rem !important;
  }

  .m-sm-18 {
    margin: 4.5rem !important;
  }

  .m-sm-19 {
    margin: 4.75rem !important;
  }

  .m-sm-20 {
    margin: 5rem !important;
  }

  .m-sm-auto {
    margin: auto !important;
  }

  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-sm-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }

  .mx-sm-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-sm-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }

  .mx-sm-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-sm-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }

  .mx-sm-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }

  .mx-sm-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }

  .mx-sm-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }

  .mx-sm-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }

  .mx-sm-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-sm-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }

  .mx-sm-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }

  .mx-sm-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }

  .mx-sm-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  .mx-sm-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }

  .mx-sm-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }

  .mx-sm-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }

  .mx-sm-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-sm-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }

  .my-sm-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-sm-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }

  .my-sm-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-sm-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }

  .my-sm-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  .my-sm-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }

  .my-sm-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  .my-sm-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }

  .my-sm-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-sm-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }

  .my-sm-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-sm-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }

  .my-sm-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-sm-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }

  .my-sm-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-sm-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }

  .my-sm-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-sm-0 {
    margin-top: 0 !important;
  }

  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }

  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }

  .mt-sm-3 {
    margin-top: 0.75rem !important;
  }

  .mt-sm-4 {
    margin-top: 1rem !important;
  }

  .mt-sm-5 {
    margin-top: 1.25rem !important;
  }

  .mt-sm-6 {
    margin-top: 1.5rem !important;
  }

  .mt-sm-7 {
    margin-top: 1.75rem !important;
  }

  .mt-sm-8 {
    margin-top: 2rem !important;
  }

  .mt-sm-9 {
    margin-top: 2.25rem !important;
  }

  .mt-sm-10 {
    margin-top: 2.5rem !important;
  }

  .mt-sm-11 {
    margin-top: 2.75rem !important;
  }

  .mt-sm-12 {
    margin-top: 3rem !important;
  }

  .mt-sm-13 {
    margin-top: 3.25rem !important;
  }

  .mt-sm-14 {
    margin-top: 3.5rem !important;
  }

  .mt-sm-15 {
    margin-top: 3.75rem !important;
  }

  .mt-sm-16 {
    margin-top: 4rem !important;
  }

  .mt-sm-17 {
    margin-top: 4.25rem !important;
  }

  .mt-sm-18 {
    margin-top: 4.5rem !important;
  }

  .mt-sm-19 {
    margin-top: 4.75rem !important;
  }

  .mt-sm-20 {
    margin-top: 5rem !important;
  }

  .mt-sm-auto {
    margin-top: auto !important;
  }

  .me-sm-0 {
    margin-right: 0 !important;
  }

  .me-sm-1 {
    margin-right: 0.25rem !important;
  }

  .me-sm-2 {
    margin-right: 0.5rem !important;
  }

  .me-sm-3 {
    margin-right: 0.75rem !important;
  }

  .me-sm-4 {
    margin-right: 1rem !important;
  }

  .me-sm-5 {
    margin-right: 1.25rem !important;
  }

  .me-sm-6 {
    margin-right: 1.5rem !important;
  }

  .me-sm-7 {
    margin-right: 1.75rem !important;
  }

  .me-sm-8 {
    margin-right: 2rem !important;
  }

  .me-sm-9 {
    margin-right: 2.25rem !important;
  }

  .me-sm-10 {
    margin-right: 2.5rem !important;
  }

  .me-sm-11 {
    margin-right: 2.75rem !important;
  }

  .me-sm-12 {
    margin-right: 3rem !important;
  }

  .me-sm-13 {
    margin-right: 3.25rem !important;
  }

  .me-sm-14 {
    margin-right: 3.5rem !important;
  }

  .me-sm-15 {
    margin-right: 3.75rem !important;
  }

  .me-sm-16 {
    margin-right: 4rem !important;
  }

  .me-sm-17 {
    margin-right: 4.25rem !important;
  }

  .me-sm-18 {
    margin-right: 4.5rem !important;
  }

  .me-sm-19 {
    margin-right: 4.75rem !important;
  }

  .me-sm-20 {
    margin-right: 5rem !important;
  }

  .me-sm-auto {
    margin-right: auto !important;
  }

  .mb-sm-0 {
    margin-bottom: 0 !important;
  }

  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-sm-3 {
    margin-bottom: 0.75rem !important;
  }

  .mb-sm-4 {
    margin-bottom: 1rem !important;
  }

  .mb-sm-5 {
    margin-bottom: 1.25rem !important;
  }

  .mb-sm-6 {
    margin-bottom: 1.5rem !important;
  }

  .mb-sm-7 {
    margin-bottom: 1.75rem !important;
  }

  .mb-sm-8 {
    margin-bottom: 2rem !important;
  }

  .mb-sm-9 {
    margin-bottom: 2.25rem !important;
  }

  .mb-sm-10 {
    margin-bottom: 2.5rem !important;
  }

  .mb-sm-11 {
    margin-bottom: 2.75rem !important;
  }

  .mb-sm-12 {
    margin-bottom: 3rem !important;
  }

  .mb-sm-13 {
    margin-bottom: 3.25rem !important;
  }

  .mb-sm-14 {
    margin-bottom: 3.5rem !important;
  }

  .mb-sm-15 {
    margin-bottom: 3.75rem !important;
  }

  .mb-sm-16 {
    margin-bottom: 4rem !important;
  }

  .mb-sm-17 {
    margin-bottom: 4.25rem !important;
  }

  .mb-sm-18 {
    margin-bottom: 4.5rem !important;
  }

  .mb-sm-19 {
    margin-bottom: 4.75rem !important;
  }

  .mb-sm-20 {
    margin-bottom: 5rem !important;
  }

  .mb-sm-auto {
    margin-bottom: auto !important;
  }

  .ms-sm-0 {
    margin-left: 0 !important;
  }

  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }

  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }

  .ms-sm-3 {
    margin-left: 0.75rem !important;
  }

  .ms-sm-4 {
    margin-left: 1rem !important;
  }

  .ms-sm-5 {
    margin-left: 1.25rem !important;
  }

  .ms-sm-6 {
    margin-left: 1.5rem !important;
  }

  .ms-sm-7 {
    margin-left: 1.75rem !important;
  }

  .ms-sm-8 {
    margin-left: 2rem !important;
  }

  .ms-sm-9 {
    margin-left: 2.25rem !important;
  }

  .ms-sm-10 {
    margin-left: 2.5rem !important;
  }

  .ms-sm-11 {
    margin-left: 2.75rem !important;
  }

  .ms-sm-12 {
    margin-left: 3rem !important;
  }

  .ms-sm-13 {
    margin-left: 3.25rem !important;
  }

  .ms-sm-14 {
    margin-left: 3.5rem !important;
  }

  .ms-sm-15 {
    margin-left: 3.75rem !important;
  }

  .ms-sm-16 {
    margin-left: 4rem !important;
  }

  .ms-sm-17 {
    margin-left: 4.25rem !important;
  }

  .ms-sm-18 {
    margin-left: 4.5rem !important;
  }

  .ms-sm-19 {
    margin-left: 4.75rem !important;
  }

  .ms-sm-20 {
    margin-left: 5rem !important;
  }

  .ms-sm-auto {
    margin-left: auto !important;
  }

  .m-sm-n1 {
    margin: -0.25rem !important;
  }

  .m-sm-n2 {
    margin: -0.5rem !important;
  }

  .m-sm-n3 {
    margin: -0.75rem !important;
  }

  .m-sm-n4 {
    margin: -1rem !important;
  }

  .m-sm-n5 {
    margin: -1.25rem !important;
  }

  .m-sm-n6 {
    margin: -1.5rem !important;
  }

  .m-sm-n7 {
    margin: -1.75rem !important;
  }

  .m-sm-n8 {
    margin: -2rem !important;
  }

  .m-sm-n9 {
    margin: -2.25rem !important;
  }

  .m-sm-n10 {
    margin: -2.5rem !important;
  }

  .m-sm-n11 {
    margin: -2.75rem !important;
  }

  .m-sm-n12 {
    margin: -3rem !important;
  }

  .m-sm-n13 {
    margin: -3.25rem !important;
  }

  .m-sm-n14 {
    margin: -3.5rem !important;
  }

  .m-sm-n15 {
    margin: -3.75rem !important;
  }

  .m-sm-n16 {
    margin: -4rem !important;
  }

  .m-sm-n17 {
    margin: -4.25rem !important;
  }

  .m-sm-n18 {
    margin: -4.5rem !important;
  }

  .m-sm-n19 {
    margin: -4.75rem !important;
  }

  .m-sm-n20 {
    margin: -5rem !important;
  }

  .mx-sm-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-sm-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-sm-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }

  .mx-sm-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-sm-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }

  .mx-sm-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-sm-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }

  .mx-sm-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }

  .mx-sm-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }

  .mx-sm-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }

  .mx-sm-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }

  .mx-sm-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .mx-sm-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }

  .mx-sm-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }

  .mx-sm-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }

  .mx-sm-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }

  .mx-sm-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }

  .mx-sm-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }

  .mx-sm-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }

  .mx-sm-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }

  .my-sm-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-sm-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-sm-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }

  .my-sm-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-sm-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }

  .my-sm-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-sm-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }

  .my-sm-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }

  .my-sm-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }

  .my-sm-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }

  .my-sm-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }

  .my-sm-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .my-sm-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }

  .my-sm-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }

  .my-sm-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }

  .my-sm-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }

  .my-sm-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }

  .my-sm-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }

  .my-sm-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }

  .my-sm-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }

  .mt-sm-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-sm-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-sm-n3 {
    margin-top: -0.75rem !important;
  }

  .mt-sm-n4 {
    margin-top: -1rem !important;
  }

  .mt-sm-n5 {
    margin-top: -1.25rem !important;
  }

  .mt-sm-n6 {
    margin-top: -1.5rem !important;
  }

  .mt-sm-n7 {
    margin-top: -1.75rem !important;
  }

  .mt-sm-n8 {
    margin-top: -2rem !important;
  }

  .mt-sm-n9 {
    margin-top: -2.25rem !important;
  }

  .mt-sm-n10 {
    margin-top: -2.5rem !important;
  }

  .mt-sm-n11 {
    margin-top: -2.75rem !important;
  }

  .mt-sm-n12 {
    margin-top: -3rem !important;
  }

  .mt-sm-n13 {
    margin-top: -3.25rem !important;
  }

  .mt-sm-n14 {
    margin-top: -3.5rem !important;
  }

  .mt-sm-n15 {
    margin-top: -3.75rem !important;
  }

  .mt-sm-n16 {
    margin-top: -4rem !important;
  }

  .mt-sm-n17 {
    margin-top: -4.25rem !important;
  }

  .mt-sm-n18 {
    margin-top: -4.5rem !important;
  }

  .mt-sm-n19 {
    margin-top: -4.75rem !important;
  }

  .mt-sm-n20 {
    margin-top: -5rem !important;
  }

  .me-sm-n1 {
    margin-right: -0.25rem !important;
  }

  .me-sm-n2 {
    margin-right: -0.5rem !important;
  }

  .me-sm-n3 {
    margin-right: -0.75rem !important;
  }

  .me-sm-n4 {
    margin-right: -1rem !important;
  }

  .me-sm-n5 {
    margin-right: -1.25rem !important;
  }

  .me-sm-n6 {
    margin-right: -1.5rem !important;
  }

  .me-sm-n7 {
    margin-right: -1.75rem !important;
  }

  .me-sm-n8 {
    margin-right: -2rem !important;
  }

  .me-sm-n9 {
    margin-right: -2.25rem !important;
  }

  .me-sm-n10 {
    margin-right: -2.5rem !important;
  }

  .me-sm-n11 {
    margin-right: -2.75rem !important;
  }

  .me-sm-n12 {
    margin-right: -3rem !important;
  }

  .me-sm-n13 {
    margin-right: -3.25rem !important;
  }

  .me-sm-n14 {
    margin-right: -3.5rem !important;
  }

  .me-sm-n15 {
    margin-right: -3.75rem !important;
  }

  .me-sm-n16 {
    margin-right: -4rem !important;
  }

  .me-sm-n17 {
    margin-right: -4.25rem !important;
  }

  .me-sm-n18 {
    margin-right: -4.5rem !important;
  }

  .me-sm-n19 {
    margin-right: -4.75rem !important;
  }

  .me-sm-n20 {
    margin-right: -5rem !important;
  }

  .mb-sm-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-sm-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-sm-n3 {
    margin-bottom: -0.75rem !important;
  }

  .mb-sm-n4 {
    margin-bottom: -1rem !important;
  }

  .mb-sm-n5 {
    margin-bottom: -1.25rem !important;
  }

  .mb-sm-n6 {
    margin-bottom: -1.5rem !important;
  }

  .mb-sm-n7 {
    margin-bottom: -1.75rem !important;
  }

  .mb-sm-n8 {
    margin-bottom: -2rem !important;
  }

  .mb-sm-n9 {
    margin-bottom: -2.25rem !important;
  }

  .mb-sm-n10 {
    margin-bottom: -2.5rem !important;
  }

  .mb-sm-n11 {
    margin-bottom: -2.75rem !important;
  }

  .mb-sm-n12 {
    margin-bottom: -3rem !important;
  }

  .mb-sm-n13 {
    margin-bottom: -3.25rem !important;
  }

  .mb-sm-n14 {
    margin-bottom: -3.5rem !important;
  }

  .mb-sm-n15 {
    margin-bottom: -3.75rem !important;
  }

  .mb-sm-n16 {
    margin-bottom: -4rem !important;
  }

  .mb-sm-n17 {
    margin-bottom: -4.25rem !important;
  }

  .mb-sm-n18 {
    margin-bottom: -4.5rem !important;
  }

  .mb-sm-n19 {
    margin-bottom: -4.75rem !important;
  }

  .mb-sm-n20 {
    margin-bottom: -5rem !important;
  }

  .ms-sm-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-sm-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-sm-n3 {
    margin-left: -0.75rem !important;
  }

  .ms-sm-n4 {
    margin-left: -1rem !important;
  }

  .ms-sm-n5 {
    margin-left: -1.25rem !important;
  }

  .ms-sm-n6 {
    margin-left: -1.5rem !important;
  }

  .ms-sm-n7 {
    margin-left: -1.75rem !important;
  }

  .ms-sm-n8 {
    margin-left: -2rem !important;
  }

  .ms-sm-n9 {
    margin-left: -2.25rem !important;
  }

  .ms-sm-n10 {
    margin-left: -2.5rem !important;
  }

  .ms-sm-n11 {
    margin-left: -2.75rem !important;
  }

  .ms-sm-n12 {
    margin-left: -3rem !important;
  }

  .ms-sm-n13 {
    margin-left: -3.25rem !important;
  }

  .ms-sm-n14 {
    margin-left: -3.5rem !important;
  }

  .ms-sm-n15 {
    margin-left: -3.75rem !important;
  }

  .ms-sm-n16 {
    margin-left: -4rem !important;
  }

  .ms-sm-n17 {
    margin-left: -4.25rem !important;
  }

  .ms-sm-n18 {
    margin-left: -4.5rem !important;
  }

  .ms-sm-n19 {
    margin-left: -4.75rem !important;
  }

  .ms-sm-n20 {
    margin-left: -5rem !important;
  }

  .p-sm-0 {
    padding: 0 !important;
  }

  .p-sm-1 {
    padding: 0.25rem !important;
  }

  .p-sm-2 {
    padding: 0.5rem !important;
  }

  .p-sm-3 {
    padding: 0.75rem !important;
  }

  .p-sm-4 {
    padding: 1rem !important;
  }

  .p-sm-5 {
    padding: 1.25rem !important;
  }

  .p-sm-6 {
    padding: 1.5rem !important;
  }

  .p-sm-7 {
    padding: 1.75rem !important;
  }

  .p-sm-8 {
    padding: 2rem !important;
  }

  .p-sm-9 {
    padding: 2.25rem !important;
  }

  .p-sm-10 {
    padding: 2.5rem !important;
  }

  .p-sm-11 {
    padding: 2.75rem !important;
  }

  .p-sm-12 {
    padding: 3rem !important;
  }

  .p-sm-13 {
    padding: 3.25rem !important;
  }

  .p-sm-14 {
    padding: 3.5rem !important;
  }

  .p-sm-15 {
    padding: 3.75rem !important;
  }

  .p-sm-16 {
    padding: 4rem !important;
  }

  .p-sm-17 {
    padding: 4.25rem !important;
  }

  .p-sm-18 {
    padding: 4.5rem !important;
  }

  .p-sm-19 {
    padding: 4.75rem !important;
  }

  .p-sm-20 {
    padding: 5rem !important;
  }

  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-sm-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }

  .px-sm-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-sm-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }

  .px-sm-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-sm-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }

  .px-sm-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }

  .px-sm-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }

  .px-sm-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }

  .px-sm-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }

  .px-sm-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .px-sm-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }

  .px-sm-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }

  .px-sm-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }

  .px-sm-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  .px-sm-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }

  .px-sm-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }

  .px-sm-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }

  .px-sm-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-sm-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  .py-sm-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-sm-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }

  .py-sm-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-sm-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }

  .py-sm-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .py-sm-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }

  .py-sm-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  .py-sm-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }

  .py-sm-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .py-sm-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }

  .py-sm-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-sm-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }

  .py-sm-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-sm-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }

  .py-sm-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-sm-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }

  .py-sm-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .pt-sm-0 {
    padding-top: 0 !important;
  }

  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }

  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }

  .pt-sm-3 {
    padding-top: 0.75rem !important;
  }

  .pt-sm-4 {
    padding-top: 1rem !important;
  }

  .pt-sm-5 {
    padding-top: 1.25rem !important;
  }

  .pt-sm-6 {
    padding-top: 1.5rem !important;
  }

  .pt-sm-7 {
    padding-top: 1.75rem !important;
  }

  .pt-sm-8 {
    padding-top: 2rem !important;
  }

  .pt-sm-9 {
    padding-top: 2.25rem !important;
  }

  .pt-sm-10 {
    padding-top: 2.5rem !important;
  }

  .pt-sm-11 {
    padding-top: 2.75rem !important;
  }

  .pt-sm-12 {
    padding-top: 3rem !important;
  }

  .pt-sm-13 {
    padding-top: 3.25rem !important;
  }

  .pt-sm-14 {
    padding-top: 3.5rem !important;
  }

  .pt-sm-15 {
    padding-top: 3.75rem !important;
  }

  .pt-sm-16 {
    padding-top: 4rem !important;
  }

  .pt-sm-17 {
    padding-top: 4.25rem !important;
  }

  .pt-sm-18 {
    padding-top: 4.5rem !important;
  }

  .pt-sm-19 {
    padding-top: 4.75rem !important;
  }

  .pt-sm-20 {
    padding-top: 5rem !important;
  }

  .pe-sm-0 {
    padding-right: 0 !important;
  }

  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }

  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }

  .pe-sm-3 {
    padding-right: 0.75rem !important;
  }

  .pe-sm-4 {
    padding-right: 1rem !important;
  }

  .pe-sm-5 {
    padding-right: 1.25rem !important;
  }

  .pe-sm-6 {
    padding-right: 1.5rem !important;
  }

  .pe-sm-7 {
    padding-right: 1.75rem !important;
  }

  .pe-sm-8 {
    padding-right: 2rem !important;
  }

  .pe-sm-9 {
    padding-right: 2.25rem !important;
  }

  .pe-sm-10 {
    padding-right: 2.5rem !important;
  }

  .pe-sm-11 {
    padding-right: 2.75rem !important;
  }

  .pe-sm-12 {
    padding-right: 3rem !important;
  }

  .pe-sm-13 {
    padding-right: 3.25rem !important;
  }

  .pe-sm-14 {
    padding-right: 3.5rem !important;
  }

  .pe-sm-15 {
    padding-right: 3.75rem !important;
  }

  .pe-sm-16 {
    padding-right: 4rem !important;
  }

  .pe-sm-17 {
    padding-right: 4.25rem !important;
  }

  .pe-sm-18 {
    padding-right: 4.5rem !important;
  }

  .pe-sm-19 {
    padding-right: 4.75rem !important;
  }

  .pe-sm-20 {
    padding-right: 5rem !important;
  }

  .pb-sm-0 {
    padding-bottom: 0 !important;
  }

  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-sm-3 {
    padding-bottom: 0.75rem !important;
  }

  .pb-sm-4 {
    padding-bottom: 1rem !important;
  }

  .pb-sm-5 {
    padding-bottom: 1.25rem !important;
  }

  .pb-sm-6 {
    padding-bottom: 1.5rem !important;
  }

  .pb-sm-7 {
    padding-bottom: 1.75rem !important;
  }

  .pb-sm-8 {
    padding-bottom: 2rem !important;
  }

  .pb-sm-9 {
    padding-bottom: 2.25rem !important;
  }

  .pb-sm-10 {
    padding-bottom: 2.5rem !important;
  }

  .pb-sm-11 {
    padding-bottom: 2.75rem !important;
  }

  .pb-sm-12 {
    padding-bottom: 3rem !important;
  }

  .pb-sm-13 {
    padding-bottom: 3.25rem !important;
  }

  .pb-sm-14 {
    padding-bottom: 3.5rem !important;
  }

  .pb-sm-15 {
    padding-bottom: 3.75rem !important;
  }

  .pb-sm-16 {
    padding-bottom: 4rem !important;
  }

  .pb-sm-17 {
    padding-bottom: 4.25rem !important;
  }

  .pb-sm-18 {
    padding-bottom: 4.5rem !important;
  }

  .pb-sm-19 {
    padding-bottom: 4.75rem !important;
  }

  .pb-sm-20 {
    padding-bottom: 5rem !important;
  }

  .ps-sm-0 {
    padding-left: 0 !important;
  }

  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }

  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }

  .ps-sm-3 {
    padding-left: 0.75rem !important;
  }

  .ps-sm-4 {
    padding-left: 1rem !important;
  }

  .ps-sm-5 {
    padding-left: 1.25rem !important;
  }

  .ps-sm-6 {
    padding-left: 1.5rem !important;
  }

  .ps-sm-7 {
    padding-left: 1.75rem !important;
  }

  .ps-sm-8 {
    padding-left: 2rem !important;
  }

  .ps-sm-9 {
    padding-left: 2.25rem !important;
  }

  .ps-sm-10 {
    padding-left: 2.5rem !important;
  }

  .ps-sm-11 {
    padding-left: 2.75rem !important;
  }

  .ps-sm-12 {
    padding-left: 3rem !important;
  }

  .ps-sm-13 {
    padding-left: 3.25rem !important;
  }

  .ps-sm-14 {
    padding-left: 3.5rem !important;
  }

  .ps-sm-15 {
    padding-left: 3.75rem !important;
  }

  .ps-sm-16 {
    padding-left: 4rem !important;
  }

  .ps-sm-17 {
    padding-left: 4.25rem !important;
  }

  .ps-sm-18 {
    padding-left: 4.5rem !important;
  }

  .ps-sm-19 {
    padding-left: 4.75rem !important;
  }

  .ps-sm-20 {
    padding-left: 5rem !important;
  }

  .gap-sm-0 {
    gap: 0 !important;
  }

  .gap-sm-1 {
    gap: 0.25rem !important;
  }

  .gap-sm-2 {
    gap: 0.5rem !important;
  }

  .gap-sm-3 {
    gap: 0.75rem !important;
  }

  .gap-sm-4 {
    gap: 1rem !important;
  }

  .gap-sm-5 {
    gap: 1.25rem !important;
  }

  .gap-sm-6 {
    gap: 1.5rem !important;
  }

  .gap-sm-7 {
    gap: 1.75rem !important;
  }

  .gap-sm-8 {
    gap: 2rem !important;
  }

  .gap-sm-9 {
    gap: 2.25rem !important;
  }

  .gap-sm-10 {
    gap: 2.5rem !important;
  }

  .gap-sm-11 {
    gap: 2.75rem !important;
  }

  .gap-sm-12 {
    gap: 3rem !important;
  }

  .gap-sm-13 {
    gap: 3.25rem !important;
  }

  .gap-sm-14 {
    gap: 3.5rem !important;
  }

  .gap-sm-15 {
    gap: 3.75rem !important;
  }

  .gap-sm-16 {
    gap: 4rem !important;
  }

  .gap-sm-17 {
    gap: 4.25rem !important;
  }

  .gap-sm-18 {
    gap: 4.5rem !important;
  }

  .gap-sm-19 {
    gap: 4.75rem !important;
  }

  .gap-sm-20 {
    gap: 5rem !important;
  }

  .row-gap-sm-0 {
    row-gap: 0 !important;
  }

  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-sm-3 {
    row-gap: 0.75rem !important;
  }

  .row-gap-sm-4 {
    row-gap: 1rem !important;
  }

  .row-gap-sm-5 {
    row-gap: 1.25rem !important;
  }

  .row-gap-sm-6 {
    row-gap: 1.5rem !important;
  }

  .row-gap-sm-7 {
    row-gap: 1.75rem !important;
  }

  .row-gap-sm-8 {
    row-gap: 2rem !important;
  }

  .row-gap-sm-9 {
    row-gap: 2.25rem !important;
  }

  .row-gap-sm-10 {
    row-gap: 2.5rem !important;
  }

  .row-gap-sm-11 {
    row-gap: 2.75rem !important;
  }

  .row-gap-sm-12 {
    row-gap: 3rem !important;
  }

  .row-gap-sm-13 {
    row-gap: 3.25rem !important;
  }

  .row-gap-sm-14 {
    row-gap: 3.5rem !important;
  }

  .row-gap-sm-15 {
    row-gap: 3.75rem !important;
  }

  .row-gap-sm-16 {
    row-gap: 4rem !important;
  }

  .row-gap-sm-17 {
    row-gap: 4.25rem !important;
  }

  .row-gap-sm-18 {
    row-gap: 4.5rem !important;
  }

  .row-gap-sm-19 {
    row-gap: 4.75rem !important;
  }

  .row-gap-sm-20 {
    row-gap: 5rem !important;
  }

  .column-gap-sm-0 {
    column-gap: 0 !important;
  }

  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-sm-3 {
    column-gap: 0.75rem !important;
  }

  .column-gap-sm-4 {
    column-gap: 1rem !important;
  }

  .column-gap-sm-5 {
    column-gap: 1.25rem !important;
  }

  .column-gap-sm-6 {
    column-gap: 1.5rem !important;
  }

  .column-gap-sm-7 {
    column-gap: 1.75rem !important;
  }

  .column-gap-sm-8 {
    column-gap: 2rem !important;
  }

  .column-gap-sm-9 {
    column-gap: 2.25rem !important;
  }

  .column-gap-sm-10 {
    column-gap: 2.5rem !important;
  }

  .column-gap-sm-11 {
    column-gap: 2.75rem !important;
  }

  .column-gap-sm-12 {
    column-gap: 3rem !important;
  }

  .column-gap-sm-13 {
    column-gap: 3.25rem !important;
  }

  .column-gap-sm-14 {
    column-gap: 3.5rem !important;
  }

  .column-gap-sm-15 {
    column-gap: 3.75rem !important;
  }

  .column-gap-sm-16 {
    column-gap: 4rem !important;
  }

  .column-gap-sm-17 {
    column-gap: 4.25rem !important;
  }

  .column-gap-sm-18 {
    column-gap: 4.5rem !important;
  }

  .column-gap-sm-19 {
    column-gap: 4.75rem !important;
  }

  .column-gap-sm-20 {
    column-gap: 5rem !important;
  }

  .fs-sm-1 {
    font-size: calc(1.3rem + 0.6vw) !important;
  }

  .fs-sm-2 {
    font-size: calc(1.275rem + 0.3vw) !important;
  }

  .fs-sm-3 {
    font-size: calc(1.26rem + 0.12vw) !important;
  }

  .fs-sm-4 {
    font-size: 1.25rem !important;
  }

  .fs-sm-5 {
    font-size: 1.15rem !important;
  }

  .fs-sm-6 {
    font-size: 1.075rem !important;
  }

  .fs-sm-7 {
    font-size: 0.95rem !important;
  }

  .fs-sm-8 {
    font-size: 0.85rem !important;
  }

  .fs-sm-9 {
    font-size: 0.75rem !important;
  }

  .fs-sm-10 {
    font-size: 0.5rem !important;
  }

  .fs-sm-base {
    font-size: 1rem !important;
  }

  .fs-sm-fluid {
    font-size: 100% !important;
  }

  .fs-sm-2x {
    font-size: calc(1.325rem + 0.9vw) !important;
  }

  .fs-sm-2qx {
    font-size: calc(1.35rem + 1.2vw) !important;
  }

  .fs-sm-2hx {
    font-size: calc(1.375rem + 1.5vw) !important;
  }

  .fs-sm-2tx {
    font-size: calc(1.4rem + 1.8vw) !important;
  }

  .fs-sm-3x {
    font-size: calc(1.425rem + 2.1vw) !important;
  }

  .fs-sm-3qx {
    font-size: calc(1.45rem + 2.4vw) !important;
  }

  .fs-sm-3hx {
    font-size: calc(1.475rem + 2.7vw) !important;
  }

  .fs-sm-3tx {
    font-size: calc(1.5rem + 3vw) !important;
  }

  .fs-sm-4x {
    font-size: calc(1.525rem + 3.3vw) !important;
  }

  .fs-sm-4qx {
    font-size: calc(1.55rem + 3.6vw) !important;
  }

  .fs-sm-4hx {
    font-size: calc(1.575rem + 3.9vw) !important;
  }

  .fs-sm-4tx {
    font-size: calc(1.6rem + 4.2vw) !important;
  }

  .fs-sm-5x {
    font-size: calc(1.625rem + 4.5vw) !important;
  }

  .fs-sm-5qx {
    font-size: calc(1.65rem + 4.8vw) !important;
  }

  .fs-sm-5hx {
    font-size: calc(1.675rem + 5.1vw) !important;
  }

  .fs-sm-5tx {
    font-size: calc(1.7rem + 5.4vw) !important;
  }

  .text-sm-start {
    text-align: left !important;
  }

  .text-sm-end {
    text-align: right !important;
  }

  .text-sm-center {
    text-align: center !important;
  }

  .min-w-sm-unset {
    min-width: unset !important;
  }

  .min-w-sm-25 {
    min-width: 25% !important;
  }

  .min-w-sm-50 {
    min-width: 50% !important;
  }

  .min-w-sm-75 {
    min-width: 75% !important;
  }

  .min-w-sm-100 {
    min-width: 100% !important;
  }

  .min-w-sm-auto {
    min-width: auto !important;
  }

  .min-w-sm-1px {
    min-width: 1px !important;
  }

  .min-w-sm-2px {
    min-width: 2px !important;
  }

  .min-w-sm-3px {
    min-width: 3px !important;
  }

  .min-w-sm-4px {
    min-width: 4px !important;
  }

  .min-w-sm-5px {
    min-width: 5px !important;
  }

  .min-w-sm-6px {
    min-width: 6px !important;
  }

  .min-w-sm-7px {
    min-width: 7px !important;
  }

  .min-w-sm-8px {
    min-width: 8px !important;
  }

  .min-w-sm-9px {
    min-width: 9px !important;
  }

  .min-w-sm-10px {
    min-width: 10px !important;
  }

  .min-w-sm-15px {
    min-width: 15px !important;
  }

  .min-w-sm-20px {
    min-width: 20px !important;
  }

  .min-w-sm-25px {
    min-width: 25px !important;
  }

  .min-w-sm-30px {
    min-width: 30px !important;
  }

  .min-w-sm-35px {
    min-width: 35px !important;
  }

  .min-w-sm-40px {
    min-width: 40px !important;
  }

  .min-w-sm-45px {
    min-width: 45px !important;
  }

  .min-w-sm-50px {
    min-width: 50px !important;
  }

  .min-w-sm-55px {
    min-width: 55px !important;
  }

  .min-w-sm-60px {
    min-width: 60px !important;
  }

  .min-w-sm-65px {
    min-width: 65px !important;
  }

  .min-w-sm-70px {
    min-width: 70px !important;
  }

  .min-w-sm-75px {
    min-width: 75px !important;
  }

  .min-w-sm-80px {
    min-width: 80px !important;
  }

  .min-w-sm-85px {
    min-width: 85px !important;
  }

  .min-w-sm-90px {
    min-width: 90px !important;
  }

  .min-w-sm-95px {
    min-width: 95px !important;
  }

  .min-w-sm-100px {
    min-width: 100px !important;
  }

  .min-w-sm-125px {
    min-width: 125px !important;
  }

  .min-w-sm-150px {
    min-width: 150px !important;
  }

  .min-w-sm-175px {
    min-width: 175px !important;
  }

  .min-w-sm-200px {
    min-width: 200px !important;
  }

  .min-w-sm-225px {
    min-width: 225px !important;
  }

  .min-w-sm-250px {
    min-width: 250px !important;
  }

  .min-w-sm-275px {
    min-width: 275px !important;
  }

  .min-w-sm-300px {
    min-width: 300px !important;
  }

  .min-w-sm-325px {
    min-width: 325px !important;
  }

  .min-w-sm-350px {
    min-width: 350px !important;
  }

  .min-w-sm-375px {
    min-width: 375px !important;
  }

  .min-w-sm-400px {
    min-width: 400px !important;
  }

  .min-w-sm-425px {
    min-width: 425px !important;
  }

  .min-w-sm-450px {
    min-width: 450px !important;
  }

  .min-w-sm-475px {
    min-width: 475px !important;
  }

  .min-w-sm-500px {
    min-width: 500px !important;
  }

  .min-w-sm-550px {
    min-width: 550px !important;
  }

  .min-w-sm-600px {
    min-width: 600px !important;
  }

  .min-w-sm-650px {
    min-width: 650px !important;
  }

  .min-w-sm-700px {
    min-width: 700px !important;
  }

  .min-w-sm-750px {
    min-width: 750px !important;
  }

  .min-w-sm-800px {
    min-width: 800px !important;
  }

  .min-w-sm-850px {
    min-width: 850px !important;
  }

  .min-w-sm-900px {
    min-width: 900px !important;
  }

  .min-w-sm-950px {
    min-width: 950px !important;
  }

  .min-w-sm-1000px {
    min-width: 1000px !important;
  }

  .min-h-sm-unset {
    min-height: unset !important;
  }

  .min-h-sm-25 {
    min-height: 25% !important;
  }

  .min-h-sm-50 {
    min-height: 50% !important;
  }

  .min-h-sm-75 {
    min-height: 75% !important;
  }

  .min-h-sm-100 {
    min-height: 100% !important;
  }

  .min-h-sm-auto {
    min-height: auto !important;
  }

  .min-h-sm-1px {
    min-height: 1px !important;
  }

  .min-h-sm-2px {
    min-height: 2px !important;
  }

  .min-h-sm-3px {
    min-height: 3px !important;
  }

  .min-h-sm-4px {
    min-height: 4px !important;
  }

  .min-h-sm-5px {
    min-height: 5px !important;
  }

  .min-h-sm-6px {
    min-height: 6px !important;
  }

  .min-h-sm-7px {
    min-height: 7px !important;
  }

  .min-h-sm-8px {
    min-height: 8px !important;
  }

  .min-h-sm-9px {
    min-height: 9px !important;
  }

  .min-h-sm-10px {
    min-height: 10px !important;
  }

  .min-h-sm-15px {
    min-height: 15px !important;
  }

  .min-h-sm-20px {
    min-height: 20px !important;
  }

  .min-h-sm-25px {
    min-height: 25px !important;
  }

  .min-h-sm-30px {
    min-height: 30px !important;
  }

  .min-h-sm-35px {
    min-height: 35px !important;
  }

  .min-h-sm-40px {
    min-height: 40px !important;
  }

  .min-h-sm-45px {
    min-height: 45px !important;
  }

  .min-h-sm-50px {
    min-height: 50px !important;
  }

  .min-h-sm-55px {
    min-height: 55px !important;
  }

  .min-h-sm-60px {
    min-height: 60px !important;
  }

  .min-h-sm-65px {
    min-height: 65px !important;
  }

  .min-h-sm-70px {
    min-height: 70px !important;
  }

  .min-h-sm-75px {
    min-height: 75px !important;
  }

  .min-h-sm-80px {
    min-height: 80px !important;
  }

  .min-h-sm-85px {
    min-height: 85px !important;
  }

  .min-h-sm-90px {
    min-height: 90px !important;
  }

  .min-h-sm-95px {
    min-height: 95px !important;
  }

  .min-h-sm-100px {
    min-height: 100px !important;
  }

  .min-h-sm-125px {
    min-height: 125px !important;
  }

  .min-h-sm-150px {
    min-height: 150px !important;
  }

  .min-h-sm-175px {
    min-height: 175px !important;
  }

  .min-h-sm-200px {
    min-height: 200px !important;
  }

  .min-h-sm-225px {
    min-height: 225px !important;
  }

  .min-h-sm-250px {
    min-height: 250px !important;
  }

  .min-h-sm-275px {
    min-height: 275px !important;
  }

  .min-h-sm-300px {
    min-height: 300px !important;
  }

  .min-h-sm-325px {
    min-height: 325px !important;
  }

  .min-h-sm-350px {
    min-height: 350px !important;
  }

  .min-h-sm-375px {
    min-height: 375px !important;
  }

  .min-h-sm-400px {
    min-height: 400px !important;
  }

  .min-h-sm-425px {
    min-height: 425px !important;
  }

  .min-h-sm-450px {
    min-height: 450px !important;
  }

  .min-h-sm-475px {
    min-height: 475px !important;
  }

  .min-h-sm-500px {
    min-height: 500px !important;
  }

  .min-h-sm-550px {
    min-height: 550px !important;
  }

  .min-h-sm-600px {
    min-height: 600px !important;
  }

  .min-h-sm-650px {
    min-height: 650px !important;
  }

  .min-h-sm-700px {
    min-height: 700px !important;
  }

  .min-h-sm-750px {
    min-height: 750px !important;
  }

  .min-h-sm-800px {
    min-height: 800px !important;
  }

  .min-h-sm-850px {
    min-height: 850px !important;
  }

  .min-h-sm-900px {
    min-height: 900px !important;
  }

  .min-h-sm-950px {
    min-height: 950px !important;
  }

  .min-h-sm-1000px {
    min-height: 1000px !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }

  .float-md-end {
    float: right !important;
  }

  .float-md-none {
    float: none !important;
  }

  .object-fit-md-contain {
    object-fit: contain !important;
  }

  .object-fit-md-cover {
    object-fit: cover !important;
  }

  .object-fit-md-fill {
    object-fit: fill !important;
  }

  .object-fit-md-scale {
    object-fit: scale-down !important;
  }

  .object-fit-md-none {
    object-fit: none !important;
  }

  .d-md-inline {
    display: inline !important;
  }

  .d-md-inline-block {
    display: inline-block !important;
  }

  .d-md-block {
    display: block !important;
  }

  .d-md-grid {
    display: grid !important;
  }

  .d-md-inline-grid {
    display: inline-grid !important;
  }

  .d-md-table {
    display: table !important;
  }

  .d-md-table-row {
    display: table-row !important;
  }

  .d-md-table-cell {
    display: table-cell !important;
  }

  .d-md-flex {
    display: flex !important;
  }

  .d-md-inline-flex {
    display: inline-flex !important;
  }

  .d-md-none {
    display: none !important;
  }

  .position-md-static {
    position: static !important;
  }

  .position-md-relative {
    position: relative !important;
  }

  .position-md-absolute {
    position: absolute !important;
  }

  .position-md-fixed {
    position: fixed !important;
  }

  .position-md-sticky {
    position: sticky !important;
  }

  .w-md-unset {
    width: unset !important;
  }

  .w-md-25 {
    width: 25% !important;
  }

  .w-md-50 {
    width: 50% !important;
  }

  .w-md-75 {
    width: 75% !important;
  }

  .w-md-100 {
    width: 100% !important;
  }

  .w-md-auto {
    width: auto !important;
  }

  .w-md-1px {
    width: 1px !important;
  }

  .w-md-2px {
    width: 2px !important;
  }

  .w-md-3px {
    width: 3px !important;
  }

  .w-md-4px {
    width: 4px !important;
  }

  .w-md-5px {
    width: 5px !important;
  }

  .w-md-6px {
    width: 6px !important;
  }

  .w-md-7px {
    width: 7px !important;
  }

  .w-md-8px {
    width: 8px !important;
  }

  .w-md-9px {
    width: 9px !important;
  }

  .w-md-10px {
    width: 10px !important;
  }

  .w-md-15px {
    width: 15px !important;
  }

  .w-md-20px {
    width: 20px !important;
  }

  .w-md-25px {
    width: 25px !important;
  }

  .w-md-30px {
    width: 30px !important;
  }

  .w-md-35px {
    width: 35px !important;
  }

  .w-md-40px {
    width: 40px !important;
  }

  .w-md-45px {
    width: 45px !important;
  }

  .w-md-50px {
    width: 50px !important;
  }

  .w-md-55px {
    width: 55px !important;
  }

  .w-md-60px {
    width: 60px !important;
  }

  .w-md-65px {
    width: 65px !important;
  }

  .w-md-70px {
    width: 70px !important;
  }

  .w-md-75px {
    width: 75px !important;
  }

  .w-md-80px {
    width: 80px !important;
  }

  .w-md-85px {
    width: 85px !important;
  }

  .w-md-90px {
    width: 90px !important;
  }

  .w-md-95px {
    width: 95px !important;
  }

  .w-md-100px {
    width: 100px !important;
  }

  .w-md-125px {
    width: 125px !important;
  }

  .w-md-150px {
    width: 150px !important;
  }

  .w-md-175px {
    width: 175px !important;
  }

  .w-md-200px {
    width: 200px !important;
  }

  .w-md-225px {
    width: 225px !important;
  }

  .w-md-250px {
    width: 250px !important;
  }

  .w-md-275px {
    width: 275px !important;
  }

  .w-md-300px {
    width: 300px !important;
  }

  .w-md-325px {
    width: 325px !important;
  }

  .w-md-350px {
    width: 350px !important;
  }

  .w-md-375px {
    width: 375px !important;
  }

  .w-md-400px {
    width: 400px !important;
  }

  .w-md-425px {
    width: 425px !important;
  }

  .w-md-450px {
    width: 450px !important;
  }

  .w-md-475px {
    width: 475px !important;
  }

  .w-md-500px {
    width: 500px !important;
  }

  .w-md-550px {
    width: 550px !important;
  }

  .w-md-600px {
    width: 600px !important;
  }

  .w-md-650px {
    width: 650px !important;
  }

  .w-md-700px {
    width: 700px !important;
  }

  .w-md-750px {
    width: 750px !important;
  }

  .w-md-800px {
    width: 800px !important;
  }

  .w-md-850px {
    width: 850px !important;
  }

  .w-md-900px {
    width: 900px !important;
  }

  .w-md-950px {
    width: 950px !important;
  }

  .w-md-1000px {
    width: 1000px !important;
  }

  .mw-md-unset {
    max-width: unset !important;
  }

  .mw-md-25 {
    max-width: 25% !important;
  }

  .mw-md-50 {
    max-width: 50% !important;
  }

  .mw-md-75 {
    max-width: 75% !important;
  }

  .mw-md-100 {
    max-width: 100% !important;
  }

  .mw-md-auto {
    max-width: auto !important;
  }

  .mw-md-1px {
    max-width: 1px !important;
  }

  .mw-md-2px {
    max-width: 2px !important;
  }

  .mw-md-3px {
    max-width: 3px !important;
  }

  .mw-md-4px {
    max-width: 4px !important;
  }

  .mw-md-5px {
    max-width: 5px !important;
  }

  .mw-md-6px {
    max-width: 6px !important;
  }

  .mw-md-7px {
    max-width: 7px !important;
  }

  .mw-md-8px {
    max-width: 8px !important;
  }

  .mw-md-9px {
    max-width: 9px !important;
  }

  .mw-md-10px {
    max-width: 10px !important;
  }

  .mw-md-15px {
    max-width: 15px !important;
  }

  .mw-md-20px {
    max-width: 20px !important;
  }

  .mw-md-25px {
    max-width: 25px !important;
  }

  .mw-md-30px {
    max-width: 30px !important;
  }

  .mw-md-35px {
    max-width: 35px !important;
  }

  .mw-md-40px {
    max-width: 40px !important;
  }

  .mw-md-45px {
    max-width: 45px !important;
  }

  .mw-md-50px {
    max-width: 50px !important;
  }

  .mw-md-55px {
    max-width: 55px !important;
  }

  .mw-md-60px {
    max-width: 60px !important;
  }

  .mw-md-65px {
    max-width: 65px !important;
  }

  .mw-md-70px {
    max-width: 70px !important;
  }

  .mw-md-75px {
    max-width: 75px !important;
  }

  .mw-md-80px {
    max-width: 80px !important;
  }

  .mw-md-85px {
    max-width: 85px !important;
  }

  .mw-md-90px {
    max-width: 90px !important;
  }

  .mw-md-95px {
    max-width: 95px !important;
  }

  .mw-md-100px {
    max-width: 100px !important;
  }

  .mw-md-125px {
    max-width: 125px !important;
  }

  .mw-md-150px {
    max-width: 150px !important;
  }

  .mw-md-175px {
    max-width: 175px !important;
  }

  .mw-md-200px {
    max-width: 200px !important;
  }

  .mw-md-225px {
    max-width: 225px !important;
  }

  .mw-md-250px {
    max-width: 250px !important;
  }

  .mw-md-275px {
    max-width: 275px !important;
  }

  .mw-md-300px {
    max-width: 300px !important;
  }

  .mw-md-325px {
    max-width: 325px !important;
  }

  .mw-md-350px {
    max-width: 350px !important;
  }

  .mw-md-375px {
    max-width: 375px !important;
  }

  .mw-md-400px {
    max-width: 400px !important;
  }

  .mw-md-425px {
    max-width: 425px !important;
  }

  .mw-md-450px {
    max-width: 450px !important;
  }

  .mw-md-475px {
    max-width: 475px !important;
  }

  .mw-md-500px {
    max-width: 500px !important;
  }

  .mw-md-550px {
    max-width: 550px !important;
  }

  .mw-md-600px {
    max-width: 600px !important;
  }

  .mw-md-650px {
    max-width: 650px !important;
  }

  .mw-md-700px {
    max-width: 700px !important;
  }

  .mw-md-750px {
    max-width: 750px !important;
  }

  .mw-md-800px {
    max-width: 800px !important;
  }

  .mw-md-850px {
    max-width: 850px !important;
  }

  .mw-md-900px {
    max-width: 900px !important;
  }

  .mw-md-950px {
    max-width: 950px !important;
  }

  .mw-md-1000px {
    max-width: 1000px !important;
  }

  .h-md-unset {
    height: unset !important;
  }

  .h-md-25 {
    height: 25% !important;
  }

  .h-md-50 {
    height: 50% !important;
  }

  .h-md-75 {
    height: 75% !important;
  }

  .h-md-100 {
    height: 100% !important;
  }

  .h-md-auto {
    height: auto !important;
  }

  .h-md-1px {
    height: 1px !important;
  }

  .h-md-2px {
    height: 2px !important;
  }

  .h-md-3px {
    height: 3px !important;
  }

  .h-md-4px {
    height: 4px !important;
  }

  .h-md-5px {
    height: 5px !important;
  }

  .h-md-6px {
    height: 6px !important;
  }

  .h-md-7px {
    height: 7px !important;
  }

  .h-md-8px {
    height: 8px !important;
  }

  .h-md-9px {
    height: 9px !important;
  }

  .h-md-10px {
    height: 10px !important;
  }

  .h-md-15px {
    height: 15px !important;
  }

  .h-md-20px {
    height: 20px !important;
  }

  .h-md-25px {
    height: 25px !important;
  }

  .h-md-30px {
    height: 30px !important;
  }

  .h-md-35px {
    height: 35px !important;
  }

  .h-md-40px {
    height: 40px !important;
  }

  .h-md-45px {
    height: 45px !important;
  }

  .h-md-50px {
    height: 50px !important;
  }

  .h-md-55px {
    height: 55px !important;
  }

  .h-md-60px {
    height: 60px !important;
  }

  .h-md-65px {
    height: 65px !important;
  }

  .h-md-70px {
    height: 70px !important;
  }

  .h-md-75px {
    height: 75px !important;
  }

  .h-md-80px {
    height: 80px !important;
  }

  .h-md-85px {
    height: 85px !important;
  }

  .h-md-90px {
    height: 90px !important;
  }

  .h-md-95px {
    height: 95px !important;
  }

  .h-md-100px {
    height: 100px !important;
  }

  .h-md-125px {
    height: 125px !important;
  }

  .h-md-150px {
    height: 150px !important;
  }

  .h-md-175px {
    height: 175px !important;
  }

  .h-md-200px {
    height: 200px !important;
  }

  .h-md-225px {
    height: 225px !important;
  }

  .h-md-250px {
    height: 250px !important;
  }

  .h-md-275px {
    height: 275px !important;
  }

  .h-md-300px {
    height: 300px !important;
  }

  .h-md-325px {
    height: 325px !important;
  }

  .h-md-350px {
    height: 350px !important;
  }

  .h-md-375px {
    height: 375px !important;
  }

  .h-md-400px {
    height: 400px !important;
  }

  .h-md-425px {
    height: 425px !important;
  }

  .h-md-450px {
    height: 450px !important;
  }

  .h-md-475px {
    height: 475px !important;
  }

  .h-md-500px {
    height: 500px !important;
  }

  .h-md-550px {
    height: 550px !important;
  }

  .h-md-600px {
    height: 600px !important;
  }

  .h-md-650px {
    height: 650px !important;
  }

  .h-md-700px {
    height: 700px !important;
  }

  .h-md-750px {
    height: 750px !important;
  }

  .h-md-800px {
    height: 800px !important;
  }

  .h-md-850px {
    height: 850px !important;
  }

  .h-md-900px {
    height: 900px !important;
  }

  .h-md-950px {
    height: 950px !important;
  }

  .h-md-1000px {
    height: 1000px !important;
  }

  .mh-md-unset {
    max-height: unset !important;
  }

  .mh-md-25 {
    max-height: 25% !important;
  }

  .mh-md-50 {
    max-height: 50% !important;
  }

  .mh-md-75 {
    max-height: 75% !important;
  }

  .mh-md-100 {
    max-height: 100% !important;
  }

  .mh-md-auto {
    max-height: auto !important;
  }

  .mh-md-1px {
    max-height: 1px !important;
  }

  .mh-md-2px {
    max-height: 2px !important;
  }

  .mh-md-3px {
    max-height: 3px !important;
  }

  .mh-md-4px {
    max-height: 4px !important;
  }

  .mh-md-5px {
    max-height: 5px !important;
  }

  .mh-md-6px {
    max-height: 6px !important;
  }

  .mh-md-7px {
    max-height: 7px !important;
  }

  .mh-md-8px {
    max-height: 8px !important;
  }

  .mh-md-9px {
    max-height: 9px !important;
  }

  .mh-md-10px {
    max-height: 10px !important;
  }

  .mh-md-15px {
    max-height: 15px !important;
  }

  .mh-md-20px {
    max-height: 20px !important;
  }

  .mh-md-25px {
    max-height: 25px !important;
  }

  .mh-md-30px {
    max-height: 30px !important;
  }

  .mh-md-35px {
    max-height: 35px !important;
  }

  .mh-md-40px {
    max-height: 40px !important;
  }

  .mh-md-45px {
    max-height: 45px !important;
  }

  .mh-md-50px {
    max-height: 50px !important;
  }

  .mh-md-55px {
    max-height: 55px !important;
  }

  .mh-md-60px {
    max-height: 60px !important;
  }

  .mh-md-65px {
    max-height: 65px !important;
  }

  .mh-md-70px {
    max-height: 70px !important;
  }

  .mh-md-75px {
    max-height: 75px !important;
  }

  .mh-md-80px {
    max-height: 80px !important;
  }

  .mh-md-85px {
    max-height: 85px !important;
  }

  .mh-md-90px {
    max-height: 90px !important;
  }

  .mh-md-95px {
    max-height: 95px !important;
  }

  .mh-md-100px {
    max-height: 100px !important;
  }

  .mh-md-125px {
    max-height: 125px !important;
  }

  .mh-md-150px {
    max-height: 150px !important;
  }

  .mh-md-175px {
    max-height: 175px !important;
  }

  .mh-md-200px {
    max-height: 200px !important;
  }

  .mh-md-225px {
    max-height: 225px !important;
  }

  .mh-md-250px {
    max-height: 250px !important;
  }

  .mh-md-275px {
    max-height: 275px !important;
  }

  .mh-md-300px {
    max-height: 300px !important;
  }

  .mh-md-325px {
    max-height: 325px !important;
  }

  .mh-md-350px {
    max-height: 350px !important;
  }

  .mh-md-375px {
    max-height: 375px !important;
  }

  .mh-md-400px {
    max-height: 400px !important;
  }

  .mh-md-425px {
    max-height: 425px !important;
  }

  .mh-md-450px {
    max-height: 450px !important;
  }

  .mh-md-475px {
    max-height: 475px !important;
  }

  .mh-md-500px {
    max-height: 500px !important;
  }

  .mh-md-550px {
    max-height: 550px !important;
  }

  .mh-md-600px {
    max-height: 600px !important;
  }

  .mh-md-650px {
    max-height: 650px !important;
  }

  .mh-md-700px {
    max-height: 700px !important;
  }

  .mh-md-750px {
    max-height: 750px !important;
  }

  .mh-md-800px {
    max-height: 800px !important;
  }

  .mh-md-850px {
    max-height: 850px !important;
  }

  .mh-md-900px {
    max-height: 900px !important;
  }

  .mh-md-950px {
    max-height: 950px !important;
  }

  .mh-md-1000px {
    max-height: 1000px !important;
  }

  .flex-md-fill {
    flex: 1 1 auto !important;
  }

  .flex-md-row {
    flex-direction: row !important;
  }

  .flex-md-column {
    flex-direction: column !important;
  }

  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-md-wrap {
    flex-wrap: wrap !important;
  }

  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-md-start {
    justify-content: flex-start !important;
  }

  .justify-content-md-end {
    justify-content: flex-end !important;
  }

  .justify-content-md-center {
    justify-content: center !important;
  }

  .justify-content-md-between {
    justify-content: space-between !important;
  }

  .justify-content-md-around {
    justify-content: space-around !important;
  }

  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-md-start {
    align-items: flex-start !important;
  }

  .align-items-md-end {
    align-items: flex-end !important;
  }

  .align-items-md-center {
    align-items: center !important;
  }

  .align-items-md-baseline {
    align-items: baseline !important;
  }

  .align-items-md-stretch {
    align-items: stretch !important;
  }

  .align-content-md-start {
    align-content: flex-start !important;
  }

  .align-content-md-end {
    align-content: flex-end !important;
  }

  .align-content-md-center {
    align-content: center !important;
  }

  .align-content-md-between {
    align-content: space-between !important;
  }

  .align-content-md-around {
    align-content: space-around !important;
  }

  .align-content-md-stretch {
    align-content: stretch !important;
  }

  .align-self-md-auto {
    align-self: auto !important;
  }

  .align-self-md-start {
    align-self: flex-start !important;
  }

  .align-self-md-end {
    align-self: flex-end !important;
  }

  .align-self-md-center {
    align-self: center !important;
  }

  .align-self-md-baseline {
    align-self: baseline !important;
  }

  .align-self-md-stretch {
    align-self: stretch !important;
  }

  .order-md-first {
    order: -1 !important;
  }

  .order-md-0 {
    order: 0 !important;
  }

  .order-md-1 {
    order: 1 !important;
  }

  .order-md-2 {
    order: 2 !important;
  }

  .order-md-3 {
    order: 3 !important;
  }

  .order-md-4 {
    order: 4 !important;
  }

  .order-md-5 {
    order: 5 !important;
  }

  .order-md-last {
    order: 6 !important;
  }

  .m-md-0 {
    margin: 0 !important;
  }

  .m-md-1 {
    margin: 0.25rem !important;
  }

  .m-md-2 {
    margin: 0.5rem !important;
  }

  .m-md-3 {
    margin: 0.75rem !important;
  }

  .m-md-4 {
    margin: 1rem !important;
  }

  .m-md-5 {
    margin: 1.25rem !important;
  }

  .m-md-6 {
    margin: 1.5rem !important;
  }

  .m-md-7 {
    margin: 1.75rem !important;
  }

  .m-md-8 {
    margin: 2rem !important;
  }

  .m-md-9 {
    margin: 2.25rem !important;
  }

  .m-md-10 {
    margin: 2.5rem !important;
  }

  .m-md-11 {
    margin: 2.75rem !important;
  }

  .m-md-12 {
    margin: 3rem !important;
  }

  .m-md-13 {
    margin: 3.25rem !important;
  }

  .m-md-14 {
    margin: 3.5rem !important;
  }

  .m-md-15 {
    margin: 3.75rem !important;
  }

  .m-md-16 {
    margin: 4rem !important;
  }

  .m-md-17 {
    margin: 4.25rem !important;
  }

  .m-md-18 {
    margin: 4.5rem !important;
  }

  .m-md-19 {
    margin: 4.75rem !important;
  }

  .m-md-20 {
    margin: 5rem !important;
  }

  .m-md-auto {
    margin: auto !important;
  }

  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-md-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }

  .mx-md-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-md-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }

  .mx-md-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-md-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }

  .mx-md-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }

  .mx-md-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }

  .mx-md-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }

  .mx-md-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }

  .mx-md-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-md-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }

  .mx-md-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }

  .mx-md-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }

  .mx-md-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  .mx-md-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }

  .mx-md-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }

  .mx-md-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }

  .mx-md-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-md-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }

  .my-md-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-md-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }

  .my-md-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-md-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }

  .my-md-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  .my-md-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }

  .my-md-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  .my-md-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }

  .my-md-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-md-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }

  .my-md-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-md-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }

  .my-md-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-md-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }

  .my-md-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-md-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }

  .my-md-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-md-0 {
    margin-top: 0 !important;
  }

  .mt-md-1 {
    margin-top: 0.25rem !important;
  }

  .mt-md-2 {
    margin-top: 0.5rem !important;
  }

  .mt-md-3 {
    margin-top: 0.75rem !important;
  }

  .mt-md-4 {
    margin-top: 1rem !important;
  }

  .mt-md-5 {
    margin-top: 1.25rem !important;
  }

  .mt-md-6 {
    margin-top: 1.5rem !important;
  }

  .mt-md-7 {
    margin-top: 1.75rem !important;
  }

  .mt-md-8 {
    margin-top: 2rem !important;
  }

  .mt-md-9 {
    margin-top: 2.25rem !important;
  }

  .mt-md-10 {
    margin-top: 2.5rem !important;
  }

  .mt-md-11 {
    margin-top: 2.75rem !important;
  }

  .mt-md-12 {
    margin-top: 3rem !important;
  }

  .mt-md-13 {
    margin-top: 3.25rem !important;
  }

  .mt-md-14 {
    margin-top: 3.5rem !important;
  }

  .mt-md-15 {
    margin-top: 3.75rem !important;
  }

  .mt-md-16 {
    margin-top: 4rem !important;
  }

  .mt-md-17 {
    margin-top: 4.25rem !important;
  }

  .mt-md-18 {
    margin-top: 4.5rem !important;
  }

  .mt-md-19 {
    margin-top: 4.75rem !important;
  }

  .mt-md-20 {
    margin-top: 5rem !important;
  }

  .mt-md-auto {
    margin-top: auto !important;
  }

  .me-md-0 {
    margin-right: 0 !important;
  }

  .me-md-1 {
    margin-right: 0.25rem !important;
  }

  .me-md-2 {
    margin-right: 0.5rem !important;
  }

  .me-md-3 {
    margin-right: 0.75rem !important;
  }

  .me-md-4 {
    margin-right: 1rem !important;
  }

  .me-md-5 {
    margin-right: 1.25rem !important;
  }

  .me-md-6 {
    margin-right: 1.5rem !important;
  }

  .me-md-7 {
    margin-right: 1.75rem !important;
  }

  .me-md-8 {
    margin-right: 2rem !important;
  }

  .me-md-9 {
    margin-right: 2.25rem !important;
  }

  .me-md-10 {
    margin-right: 2.5rem !important;
  }

  .me-md-11 {
    margin-right: 2.75rem !important;
  }

  .me-md-12 {
    margin-right: 3rem !important;
  }

  .me-md-13 {
    margin-right: 3.25rem !important;
  }

  .me-md-14 {
    margin-right: 3.5rem !important;
  }

  .me-md-15 {
    margin-right: 3.75rem !important;
  }

  .me-md-16 {
    margin-right: 4rem !important;
  }

  .me-md-17 {
    margin-right: 4.25rem !important;
  }

  .me-md-18 {
    margin-right: 4.5rem !important;
  }

  .me-md-19 {
    margin-right: 4.75rem !important;
  }

  .me-md-20 {
    margin-right: 5rem !important;
  }

  .me-md-auto {
    margin-right: auto !important;
  }

  .mb-md-0 {
    margin-bottom: 0 !important;
  }

  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-md-3 {
    margin-bottom: 0.75rem !important;
  }

  .mb-md-4 {
    margin-bottom: 1rem !important;
  }

  .mb-md-5 {
    margin-bottom: 1.25rem !important;
  }

  .mb-md-6 {
    margin-bottom: 1.5rem !important;
  }

  .mb-md-7 {
    margin-bottom: 1.75rem !important;
  }

  .mb-md-8 {
    margin-bottom: 2rem !important;
  }

  .mb-md-9 {
    margin-bottom: 2.25rem !important;
  }

  .mb-md-10 {
    margin-bottom: 2.5rem !important;
  }

  .mb-md-11 {
    margin-bottom: 2.75rem !important;
  }

  .mb-md-12 {
    margin-bottom: 3rem !important;
  }

  .mb-md-13 {
    margin-bottom: 3.25rem !important;
  }

  .mb-md-14 {
    margin-bottom: 3.5rem !important;
  }

  .mb-md-15 {
    margin-bottom: 3.75rem !important;
  }

  .mb-md-16 {
    margin-bottom: 4rem !important;
  }

  .mb-md-17 {
    margin-bottom: 4.25rem !important;
  }

  .mb-md-18 {
    margin-bottom: 4.5rem !important;
  }

  .mb-md-19 {
    margin-bottom: 4.75rem !important;
  }

  .mb-md-20 {
    margin-bottom: 5rem !important;
  }

  .mb-md-auto {
    margin-bottom: auto !important;
  }

  .ms-md-0 {
    margin-left: 0 !important;
  }

  .ms-md-1 {
    margin-left: 0.25rem !important;
  }

  .ms-md-2 {
    margin-left: 0.5rem !important;
  }

  .ms-md-3 {
    margin-left: 0.75rem !important;
  }

  .ms-md-4 {
    margin-left: 1rem !important;
  }

  .ms-md-5 {
    margin-left: 1.25rem !important;
  }

  .ms-md-6 {
    margin-left: 1.5rem !important;
  }

  .ms-md-7 {
    margin-left: 1.75rem !important;
  }

  .ms-md-8 {
    margin-left: 2rem !important;
  }

  .ms-md-9 {
    margin-left: 2.25rem !important;
  }

  .ms-md-10 {
    margin-left: 2.5rem !important;
  }

  .ms-md-11 {
    margin-left: 2.75rem !important;
  }

  .ms-md-12 {
    margin-left: 3rem !important;
  }

  .ms-md-13 {
    margin-left: 3.25rem !important;
  }

  .ms-md-14 {
    margin-left: 3.5rem !important;
  }

  .ms-md-15 {
    margin-left: 3.75rem !important;
  }

  .ms-md-16 {
    margin-left: 4rem !important;
  }

  .ms-md-17 {
    margin-left: 4.25rem !important;
  }

  .ms-md-18 {
    margin-left: 4.5rem !important;
  }

  .ms-md-19 {
    margin-left: 4.75rem !important;
  }

  .ms-md-20 {
    margin-left: 5rem !important;
  }

  .ms-md-auto {
    margin-left: auto !important;
  }

  .m-md-n1 {
    margin: -0.25rem !important;
  }

  .m-md-n2 {
    margin: -0.5rem !important;
  }

  .m-md-n3 {
    margin: -0.75rem !important;
  }

  .m-md-n4 {
    margin: -1rem !important;
  }

  .m-md-n5 {
    margin: -1.25rem !important;
  }

  .m-md-n6 {
    margin: -1.5rem !important;
  }

  .m-md-n7 {
    margin: -1.75rem !important;
  }

  .m-md-n8 {
    margin: -2rem !important;
  }

  .m-md-n9 {
    margin: -2.25rem !important;
  }

  .m-md-n10 {
    margin: -2.5rem !important;
  }

  .m-md-n11 {
    margin: -2.75rem !important;
  }

  .m-md-n12 {
    margin: -3rem !important;
  }

  .m-md-n13 {
    margin: -3.25rem !important;
  }

  .m-md-n14 {
    margin: -3.5rem !important;
  }

  .m-md-n15 {
    margin: -3.75rem !important;
  }

  .m-md-n16 {
    margin: -4rem !important;
  }

  .m-md-n17 {
    margin: -4.25rem !important;
  }

  .m-md-n18 {
    margin: -4.5rem !important;
  }

  .m-md-n19 {
    margin: -4.75rem !important;
  }

  .m-md-n20 {
    margin: -5rem !important;
  }

  .mx-md-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-md-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-md-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }

  .mx-md-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-md-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }

  .mx-md-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-md-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }

  .mx-md-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }

  .mx-md-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }

  .mx-md-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }

  .mx-md-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }

  .mx-md-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .mx-md-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }

  .mx-md-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }

  .mx-md-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }

  .mx-md-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }

  .mx-md-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }

  .mx-md-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }

  .mx-md-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }

  .mx-md-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }

  .my-md-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-md-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-md-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }

  .my-md-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-md-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }

  .my-md-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-md-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }

  .my-md-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }

  .my-md-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }

  .my-md-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }

  .my-md-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }

  .my-md-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .my-md-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }

  .my-md-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }

  .my-md-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }

  .my-md-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }

  .my-md-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }

  .my-md-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }

  .my-md-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }

  .my-md-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }

  .mt-md-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-md-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-md-n3 {
    margin-top: -0.75rem !important;
  }

  .mt-md-n4 {
    margin-top: -1rem !important;
  }

  .mt-md-n5 {
    margin-top: -1.25rem !important;
  }

  .mt-md-n6 {
    margin-top: -1.5rem !important;
  }

  .mt-md-n7 {
    margin-top: -1.75rem !important;
  }

  .mt-md-n8 {
    margin-top: -2rem !important;
  }

  .mt-md-n9 {
    margin-top: -2.25rem !important;
  }

  .mt-md-n10 {
    margin-top: -2.5rem !important;
  }

  .mt-md-n11 {
    margin-top: -2.75rem !important;
  }

  .mt-md-n12 {
    margin-top: -3rem !important;
  }

  .mt-md-n13 {
    margin-top: -3.25rem !important;
  }

  .mt-md-n14 {
    margin-top: -3.5rem !important;
  }

  .mt-md-n15 {
    margin-top: -3.75rem !important;
  }

  .mt-md-n16 {
    margin-top: -4rem !important;
  }

  .mt-md-n17 {
    margin-top: -4.25rem !important;
  }

  .mt-md-n18 {
    margin-top: -4.5rem !important;
  }

  .mt-md-n19 {
    margin-top: -4.75rem !important;
  }

  .mt-md-n20 {
    margin-top: -5rem !important;
  }

  .me-md-n1 {
    margin-right: -0.25rem !important;
  }

  .me-md-n2 {
    margin-right: -0.5rem !important;
  }

  .me-md-n3 {
    margin-right: -0.75rem !important;
  }

  .me-md-n4 {
    margin-right: -1rem !important;
  }

  .me-md-n5 {
    margin-right: -1.25rem !important;
  }

  .me-md-n6 {
    margin-right: -1.5rem !important;
  }

  .me-md-n7 {
    margin-right: -1.75rem !important;
  }

  .me-md-n8 {
    margin-right: -2rem !important;
  }

  .me-md-n9 {
    margin-right: -2.25rem !important;
  }

  .me-md-n10 {
    margin-right: -2.5rem !important;
  }

  .me-md-n11 {
    margin-right: -2.75rem !important;
  }

  .me-md-n12 {
    margin-right: -3rem !important;
  }

  .me-md-n13 {
    margin-right: -3.25rem !important;
  }

  .me-md-n14 {
    margin-right: -3.5rem !important;
  }

  .me-md-n15 {
    margin-right: -3.75rem !important;
  }

  .me-md-n16 {
    margin-right: -4rem !important;
  }

  .me-md-n17 {
    margin-right: -4.25rem !important;
  }

  .me-md-n18 {
    margin-right: -4.5rem !important;
  }

  .me-md-n19 {
    margin-right: -4.75rem !important;
  }

  .me-md-n20 {
    margin-right: -5rem !important;
  }

  .mb-md-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-md-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-md-n3 {
    margin-bottom: -0.75rem !important;
  }

  .mb-md-n4 {
    margin-bottom: -1rem !important;
  }

  .mb-md-n5 {
    margin-bottom: -1.25rem !important;
  }

  .mb-md-n6 {
    margin-bottom: -1.5rem !important;
  }

  .mb-md-n7 {
    margin-bottom: -1.75rem !important;
  }

  .mb-md-n8 {
    margin-bottom: -2rem !important;
  }

  .mb-md-n9 {
    margin-bottom: -2.25rem !important;
  }

  .mb-md-n10 {
    margin-bottom: -2.5rem !important;
  }

  .mb-md-n11 {
    margin-bottom: -2.75rem !important;
  }

  .mb-md-n12 {
    margin-bottom: -3rem !important;
  }

  .mb-md-n13 {
    margin-bottom: -3.25rem !important;
  }

  .mb-md-n14 {
    margin-bottom: -3.5rem !important;
  }

  .mb-md-n15 {
    margin-bottom: -3.75rem !important;
  }

  .mb-md-n16 {
    margin-bottom: -4rem !important;
  }

  .mb-md-n17 {
    margin-bottom: -4.25rem !important;
  }

  .mb-md-n18 {
    margin-bottom: -4.5rem !important;
  }

  .mb-md-n19 {
    margin-bottom: -4.75rem !important;
  }

  .mb-md-n20 {
    margin-bottom: -5rem !important;
  }

  .ms-md-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-md-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-md-n3 {
    margin-left: -0.75rem !important;
  }

  .ms-md-n4 {
    margin-left: -1rem !important;
  }

  .ms-md-n5 {
    margin-left: -1.25rem !important;
  }

  .ms-md-n6 {
    margin-left: -1.5rem !important;
  }

  .ms-md-n7 {
    margin-left: -1.75rem !important;
  }

  .ms-md-n8 {
    margin-left: -2rem !important;
  }

  .ms-md-n9 {
    margin-left: -2.25rem !important;
  }

  .ms-md-n10 {
    margin-left: -2.5rem !important;
  }

  .ms-md-n11 {
    margin-left: -2.75rem !important;
  }

  .ms-md-n12 {
    margin-left: -3rem !important;
  }

  .ms-md-n13 {
    margin-left: -3.25rem !important;
  }

  .ms-md-n14 {
    margin-left: -3.5rem !important;
  }

  .ms-md-n15 {
    margin-left: -3.75rem !important;
  }

  .ms-md-n16 {
    margin-left: -4rem !important;
  }

  .ms-md-n17 {
    margin-left: -4.25rem !important;
  }

  .ms-md-n18 {
    margin-left: -4.5rem !important;
  }

  .ms-md-n19 {
    margin-left: -4.75rem !important;
  }

  .ms-md-n20 {
    margin-left: -5rem !important;
  }

  .p-md-0 {
    padding: 0 !important;
  }

  .p-md-1 {
    padding: 0.25rem !important;
  }

  .p-md-2 {
    padding: 0.5rem !important;
  }

  .p-md-3 {
    padding: 0.75rem !important;
  }

  .p-md-4 {
    padding: 1rem !important;
  }

  .p-md-5 {
    padding: 1.25rem !important;
  }

  .p-md-6 {
    padding: 1.5rem !important;
  }

  .p-md-7 {
    padding: 1.75rem !important;
  }

  .p-md-8 {
    padding: 2rem !important;
  }

  .p-md-9 {
    padding: 2.25rem !important;
  }

  .p-md-10 {
    padding: 2.5rem !important;
  }

  .p-md-11 {
    padding: 2.75rem !important;
  }

  .p-md-12 {
    padding: 3rem !important;
  }

  .p-md-13 {
    padding: 3.25rem !important;
  }

  .p-md-14 {
    padding: 3.5rem !important;
  }

  .p-md-15 {
    padding: 3.75rem !important;
  }

  .p-md-16 {
    padding: 4rem !important;
  }

  .p-md-17 {
    padding: 4.25rem !important;
  }

  .p-md-18 {
    padding: 4.5rem !important;
  }

  .p-md-19 {
    padding: 4.75rem !important;
  }

  .p-md-20 {
    padding: 5rem !important;
  }

  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-md-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }

  .px-md-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-md-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }

  .px-md-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-md-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }

  .px-md-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }

  .px-md-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }

  .px-md-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }

  .px-md-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }

  .px-md-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .px-md-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }

  .px-md-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }

  .px-md-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }

  .px-md-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  .px-md-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }

  .px-md-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }

  .px-md-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }

  .px-md-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-md-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  .py-md-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-md-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }

  .py-md-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-md-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }

  .py-md-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .py-md-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }

  .py-md-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  .py-md-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }

  .py-md-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .py-md-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }

  .py-md-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-md-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }

  .py-md-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-md-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }

  .py-md-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-md-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }

  .py-md-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .pt-md-0 {
    padding-top: 0 !important;
  }

  .pt-md-1 {
    padding-top: 0.25rem !important;
  }

  .pt-md-2 {
    padding-top: 0.5rem !important;
  }

  .pt-md-3 {
    padding-top: 0.75rem !important;
  }

  .pt-md-4 {
    padding-top: 1rem !important;
  }

  .pt-md-5 {
    padding-top: 1.25rem !important;
  }

  .pt-md-6 {
    padding-top: 1.5rem !important;
  }

  .pt-md-7 {
    padding-top: 1.75rem !important;
  }

  .pt-md-8 {
    padding-top: 2rem !important;
  }

  .pt-md-9 {
    padding-top: 2.25rem !important;
  }

  .pt-md-10 {
    padding-top: 2.5rem !important;
  }

  .pt-md-11 {
    padding-top: 2.75rem !important;
  }

  .pt-md-12 {
    padding-top: 3rem !important;
  }

  .pt-md-13 {
    padding-top: 3.25rem !important;
  }

  .pt-md-14 {
    padding-top: 3.5rem !important;
  }

  .pt-md-15 {
    padding-top: 3.75rem !important;
  }

  .pt-md-16 {
    padding-top: 4rem !important;
  }

  .pt-md-17 {
    padding-top: 4.25rem !important;
  }

  .pt-md-18 {
    padding-top: 4.5rem !important;
  }

  .pt-md-19 {
    padding-top: 4.75rem !important;
  }

  .pt-md-20 {
    padding-top: 5rem !important;
  }

  .pe-md-0 {
    padding-right: 0 !important;
  }

  .pe-md-1 {
    padding-right: 0.25rem !important;
  }

  .pe-md-2 {
    padding-right: 0.5rem !important;
  }

  .pe-md-3 {
    padding-right: 0.75rem !important;
  }

  .pe-md-4 {
    padding-right: 1rem !important;
  }

  .pe-md-5 {
    padding-right: 1.25rem !important;
  }

  .pe-md-6 {
    padding-right: 1.5rem !important;
  }

  .pe-md-7 {
    padding-right: 1.75rem !important;
  }

  .pe-md-8 {
    padding-right: 2rem !important;
  }

  .pe-md-9 {
    padding-right: 2.25rem !important;
  }

  .pe-md-10 {
    padding-right: 2.5rem !important;
  }

  .pe-md-11 {
    padding-right: 2.75rem !important;
  }

  .pe-md-12 {
    padding-right: 3rem !important;
  }

  .pe-md-13 {
    padding-right: 3.25rem !important;
  }

  .pe-md-14 {
    padding-right: 3.5rem !important;
  }

  .pe-md-15 {
    padding-right: 3.75rem !important;
  }

  .pe-md-16 {
    padding-right: 4rem !important;
  }

  .pe-md-17 {
    padding-right: 4.25rem !important;
  }

  .pe-md-18 {
    padding-right: 4.5rem !important;
  }

  .pe-md-19 {
    padding-right: 4.75rem !important;
  }

  .pe-md-20 {
    padding-right: 5rem !important;
  }

  .pb-md-0 {
    padding-bottom: 0 !important;
  }

  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-md-3 {
    padding-bottom: 0.75rem !important;
  }

  .pb-md-4 {
    padding-bottom: 1rem !important;
  }

  .pb-md-5 {
    padding-bottom: 1.25rem !important;
  }

  .pb-md-6 {
    padding-bottom: 1.5rem !important;
  }

  .pb-md-7 {
    padding-bottom: 1.75rem !important;
  }

  .pb-md-8 {
    padding-bottom: 2rem !important;
  }

  .pb-md-9 {
    padding-bottom: 2.25rem !important;
  }

  .pb-md-10 {
    padding-bottom: 2.5rem !important;
  }

  .pb-md-11 {
    padding-bottom: 2.75rem !important;
  }

  .pb-md-12 {
    padding-bottom: 3rem !important;
  }

  .pb-md-13 {
    padding-bottom: 3.25rem !important;
  }

  .pb-md-14 {
    padding-bottom: 3.5rem !important;
  }

  .pb-md-15 {
    padding-bottom: 3.75rem !important;
  }

  .pb-md-16 {
    padding-bottom: 4rem !important;
  }

  .pb-md-17 {
    padding-bottom: 4.25rem !important;
  }

  .pb-md-18 {
    padding-bottom: 4.5rem !important;
  }

  .pb-md-19 {
    padding-bottom: 4.75rem !important;
  }

  .pb-md-20 {
    padding-bottom: 5rem !important;
  }

  .ps-md-0 {
    padding-left: 0 !important;
  }

  .ps-md-1 {
    padding-left: 0.25rem !important;
  }

  .ps-md-2 {
    padding-left: 0.5rem !important;
  }

  .ps-md-3 {
    padding-left: 0.75rem !important;
  }

  .ps-md-4 {
    padding-left: 1rem !important;
  }

  .ps-md-5 {
    padding-left: 1.25rem !important;
  }

  .ps-md-6 {
    padding-left: 1.5rem !important;
  }

  .ps-md-7 {
    padding-left: 1.75rem !important;
  }

  .ps-md-8 {
    padding-left: 2rem !important;
  }

  .ps-md-9 {
    padding-left: 2.25rem !important;
  }

  .ps-md-10 {
    padding-left: 2.5rem !important;
  }

  .ps-md-11 {
    padding-left: 2.75rem !important;
  }

  .ps-md-12 {
    padding-left: 3rem !important;
  }

  .ps-md-13 {
    padding-left: 3.25rem !important;
  }

  .ps-md-14 {
    padding-left: 3.5rem !important;
  }

  .ps-md-15 {
    padding-left: 3.75rem !important;
  }

  .ps-md-16 {
    padding-left: 4rem !important;
  }

  .ps-md-17 {
    padding-left: 4.25rem !important;
  }

  .ps-md-18 {
    padding-left: 4.5rem !important;
  }

  .ps-md-19 {
    padding-left: 4.75rem !important;
  }

  .ps-md-20 {
    padding-left: 5rem !important;
  }

  .gap-md-0 {
    gap: 0 !important;
  }

  .gap-md-1 {
    gap: 0.25rem !important;
  }

  .gap-md-2 {
    gap: 0.5rem !important;
  }

  .gap-md-3 {
    gap: 0.75rem !important;
  }

  .gap-md-4 {
    gap: 1rem !important;
  }

  .gap-md-5 {
    gap: 1.25rem !important;
  }

  .gap-md-6 {
    gap: 1.5rem !important;
  }

  .gap-md-7 {
    gap: 1.75rem !important;
  }

  .gap-md-8 {
    gap: 2rem !important;
  }

  .gap-md-9 {
    gap: 2.25rem !important;
  }

  .gap-md-10 {
    gap: 2.5rem !important;
  }

  .gap-md-11 {
    gap: 2.75rem !important;
  }

  .gap-md-12 {
    gap: 3rem !important;
  }

  .gap-md-13 {
    gap: 3.25rem !important;
  }

  .gap-md-14 {
    gap: 3.5rem !important;
  }

  .gap-md-15 {
    gap: 3.75rem !important;
  }

  .gap-md-16 {
    gap: 4rem !important;
  }

  .gap-md-17 {
    gap: 4.25rem !important;
  }

  .gap-md-18 {
    gap: 4.5rem !important;
  }

  .gap-md-19 {
    gap: 4.75rem !important;
  }

  .gap-md-20 {
    gap: 5rem !important;
  }

  .row-gap-md-0 {
    row-gap: 0 !important;
  }

  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-md-3 {
    row-gap: 0.75rem !important;
  }

  .row-gap-md-4 {
    row-gap: 1rem !important;
  }

  .row-gap-md-5 {
    row-gap: 1.25rem !important;
  }

  .row-gap-md-6 {
    row-gap: 1.5rem !important;
  }

  .row-gap-md-7 {
    row-gap: 1.75rem !important;
  }

  .row-gap-md-8 {
    row-gap: 2rem !important;
  }

  .row-gap-md-9 {
    row-gap: 2.25rem !important;
  }

  .row-gap-md-10 {
    row-gap: 2.5rem !important;
  }

  .row-gap-md-11 {
    row-gap: 2.75rem !important;
  }

  .row-gap-md-12 {
    row-gap: 3rem !important;
  }

  .row-gap-md-13 {
    row-gap: 3.25rem !important;
  }

  .row-gap-md-14 {
    row-gap: 3.5rem !important;
  }

  .row-gap-md-15 {
    row-gap: 3.75rem !important;
  }

  .row-gap-md-16 {
    row-gap: 4rem !important;
  }

  .row-gap-md-17 {
    row-gap: 4.25rem !important;
  }

  .row-gap-md-18 {
    row-gap: 4.5rem !important;
  }

  .row-gap-md-19 {
    row-gap: 4.75rem !important;
  }

  .row-gap-md-20 {
    row-gap: 5rem !important;
  }

  .column-gap-md-0 {
    column-gap: 0 !important;
  }

  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-md-3 {
    column-gap: 0.75rem !important;
  }

  .column-gap-md-4 {
    column-gap: 1rem !important;
  }

  .column-gap-md-5 {
    column-gap: 1.25rem !important;
  }

  .column-gap-md-6 {
    column-gap: 1.5rem !important;
  }

  .column-gap-md-7 {
    column-gap: 1.75rem !important;
  }

  .column-gap-md-8 {
    column-gap: 2rem !important;
  }

  .column-gap-md-9 {
    column-gap: 2.25rem !important;
  }

  .column-gap-md-10 {
    column-gap: 2.5rem !important;
  }

  .column-gap-md-11 {
    column-gap: 2.75rem !important;
  }

  .column-gap-md-12 {
    column-gap: 3rem !important;
  }

  .column-gap-md-13 {
    column-gap: 3.25rem !important;
  }

  .column-gap-md-14 {
    column-gap: 3.5rem !important;
  }

  .column-gap-md-15 {
    column-gap: 3.75rem !important;
  }

  .column-gap-md-16 {
    column-gap: 4rem !important;
  }

  .column-gap-md-17 {
    column-gap: 4.25rem !important;
  }

  .column-gap-md-18 {
    column-gap: 4.5rem !important;
  }

  .column-gap-md-19 {
    column-gap: 4.75rem !important;
  }

  .column-gap-md-20 {
    column-gap: 5rem !important;
  }

  .fs-md-1 {
    font-size: calc(1.3rem + 0.6vw) !important;
  }

  .fs-md-2 {
    font-size: calc(1.275rem + 0.3vw) !important;
  }

  .fs-md-3 {
    font-size: calc(1.26rem + 0.12vw) !important;
  }

  .fs-md-4 {
    font-size: 1.25rem !important;
  }

  .fs-md-5 {
    font-size: 1.15rem !important;
  }

  .fs-md-6 {
    font-size: 1.075rem !important;
  }

  .fs-md-7 {
    font-size: 0.95rem !important;
  }

  .fs-md-8 {
    font-size: 0.85rem !important;
  }

  .fs-md-9 {
    font-size: 0.75rem !important;
  }

  .fs-md-10 {
    font-size: 0.5rem !important;
  }

  .fs-md-base {
    font-size: 1rem !important;
  }

  .fs-md-fluid {
    font-size: 100% !important;
  }

  .fs-md-2x {
    font-size: calc(1.325rem + 0.9vw) !important;
  }

  .fs-md-2qx {
    font-size: calc(1.35rem + 1.2vw) !important;
  }

  .fs-md-2hx {
    font-size: calc(1.375rem + 1.5vw) !important;
  }

  .fs-md-2tx {
    font-size: calc(1.4rem + 1.8vw) !important;
  }

  .fs-md-3x {
    font-size: calc(1.425rem + 2.1vw) !important;
  }

  .fs-md-3qx {
    font-size: calc(1.45rem + 2.4vw) !important;
  }

  .fs-md-3hx {
    font-size: calc(1.475rem + 2.7vw) !important;
  }

  .fs-md-3tx {
    font-size: calc(1.5rem + 3vw) !important;
  }

  .fs-md-4x {
    font-size: calc(1.525rem + 3.3vw) !important;
  }

  .fs-md-4qx {
    font-size: calc(1.55rem + 3.6vw) !important;
  }

  .fs-md-4hx {
    font-size: calc(1.575rem + 3.9vw) !important;
  }

  .fs-md-4tx {
    font-size: calc(1.6rem + 4.2vw) !important;
  }

  .fs-md-5x {
    font-size: calc(1.625rem + 4.5vw) !important;
  }

  .fs-md-5qx {
    font-size: calc(1.65rem + 4.8vw) !important;
  }

  .fs-md-5hx {
    font-size: calc(1.675rem + 5.1vw) !important;
  }

  .fs-md-5tx {
    font-size: calc(1.7rem + 5.4vw) !important;
  }

  .text-md-start {
    text-align: left !important;
  }

  .text-md-end {
    text-align: right !important;
  }

  .text-md-center {
    text-align: center !important;
  }

  .min-w-md-unset {
    min-width: unset !important;
  }

  .min-w-md-25 {
    min-width: 25% !important;
  }

  .min-w-md-50 {
    min-width: 50% !important;
  }

  .min-w-md-75 {
    min-width: 75% !important;
  }

  .min-w-md-100 {
    min-width: 100% !important;
  }

  .min-w-md-auto {
    min-width: auto !important;
  }

  .min-w-md-1px {
    min-width: 1px !important;
  }

  .min-w-md-2px {
    min-width: 2px !important;
  }

  .min-w-md-3px {
    min-width: 3px !important;
  }

  .min-w-md-4px {
    min-width: 4px !important;
  }

  .min-w-md-5px {
    min-width: 5px !important;
  }

  .min-w-md-6px {
    min-width: 6px !important;
  }

  .min-w-md-7px {
    min-width: 7px !important;
  }

  .min-w-md-8px {
    min-width: 8px !important;
  }

  .min-w-md-9px {
    min-width: 9px !important;
  }

  .min-w-md-10px {
    min-width: 10px !important;
  }

  .min-w-md-15px {
    min-width: 15px !important;
  }

  .min-w-md-20px {
    min-width: 20px !important;
  }

  .min-w-md-25px {
    min-width: 25px !important;
  }

  .min-w-md-30px {
    min-width: 30px !important;
  }

  .min-w-md-35px {
    min-width: 35px !important;
  }

  .min-w-md-40px {
    min-width: 40px !important;
  }

  .min-w-md-45px {
    min-width: 45px !important;
  }

  .min-w-md-50px {
    min-width: 50px !important;
  }

  .min-w-md-55px {
    min-width: 55px !important;
  }

  .min-w-md-60px {
    min-width: 60px !important;
  }

  .min-w-md-65px {
    min-width: 65px !important;
  }

  .min-w-md-70px {
    min-width: 70px !important;
  }

  .min-w-md-75px {
    min-width: 75px !important;
  }

  .min-w-md-80px {
    min-width: 80px !important;
  }

  .min-w-md-85px {
    min-width: 85px !important;
  }

  .min-w-md-90px {
    min-width: 90px !important;
  }

  .min-w-md-95px {
    min-width: 95px !important;
  }

  .min-w-md-100px {
    min-width: 100px !important;
  }

  .min-w-md-125px {
    min-width: 125px !important;
  }

  .min-w-md-150px {
    min-width: 150px !important;
  }

  .min-w-md-175px {
    min-width: 175px !important;
  }

  .min-w-md-200px {
    min-width: 200px !important;
  }

  .min-w-md-225px {
    min-width: 225px !important;
  }

  .min-w-md-250px {
    min-width: 250px !important;
  }

  .min-w-md-275px {
    min-width: 275px !important;
  }

  .min-w-md-300px {
    min-width: 300px !important;
  }

  .min-w-md-325px {
    min-width: 325px !important;
  }

  .min-w-md-350px {
    min-width: 350px !important;
  }

  .min-w-md-375px {
    min-width: 375px !important;
  }

  .min-w-md-400px {
    min-width: 400px !important;
  }

  .min-w-md-425px {
    min-width: 425px !important;
  }

  .min-w-md-450px {
    min-width: 450px !important;
  }

  .min-w-md-475px {
    min-width: 475px !important;
  }

  .min-w-md-500px {
    min-width: 500px !important;
  }

  .min-w-md-550px {
    min-width: 550px !important;
  }

  .min-w-md-600px {
    min-width: 600px !important;
  }

  .min-w-md-650px {
    min-width: 650px !important;
  }

  .min-w-md-700px {
    min-width: 700px !important;
  }

  .min-w-md-750px {
    min-width: 750px !important;
  }

  .min-w-md-800px {
    min-width: 800px !important;
  }

  .min-w-md-850px {
    min-width: 850px !important;
  }

  .min-w-md-900px {
    min-width: 900px !important;
  }

  .min-w-md-950px {
    min-width: 950px !important;
  }

  .min-w-md-1000px {
    min-width: 1000px !important;
  }

  .min-h-md-unset {
    min-height: unset !important;
  }

  .min-h-md-25 {
    min-height: 25% !important;
  }

  .min-h-md-50 {
    min-height: 50% !important;
  }

  .min-h-md-75 {
    min-height: 75% !important;
  }

  .min-h-md-100 {
    min-height: 100% !important;
  }

  .min-h-md-auto {
    min-height: auto !important;
  }

  .min-h-md-1px {
    min-height: 1px !important;
  }

  .min-h-md-2px {
    min-height: 2px !important;
  }

  .min-h-md-3px {
    min-height: 3px !important;
  }

  .min-h-md-4px {
    min-height: 4px !important;
  }

  .min-h-md-5px {
    min-height: 5px !important;
  }

  .min-h-md-6px {
    min-height: 6px !important;
  }

  .min-h-md-7px {
    min-height: 7px !important;
  }

  .min-h-md-8px {
    min-height: 8px !important;
  }

  .min-h-md-9px {
    min-height: 9px !important;
  }

  .min-h-md-10px {
    min-height: 10px !important;
  }

  .min-h-md-15px {
    min-height: 15px !important;
  }

  .min-h-md-20px {
    min-height: 20px !important;
  }

  .min-h-md-25px {
    min-height: 25px !important;
  }

  .min-h-md-30px {
    min-height: 30px !important;
  }

  .min-h-md-35px {
    min-height: 35px !important;
  }

  .min-h-md-40px {
    min-height: 40px !important;
  }

  .min-h-md-45px {
    min-height: 45px !important;
  }

  .min-h-md-50px {
    min-height: 50px !important;
  }

  .min-h-md-55px {
    min-height: 55px !important;
  }

  .min-h-md-60px {
    min-height: 60px !important;
  }

  .min-h-md-65px {
    min-height: 65px !important;
  }

  .min-h-md-70px {
    min-height: 70px !important;
  }

  .min-h-md-75px {
    min-height: 75px !important;
  }

  .min-h-md-80px {
    min-height: 80px !important;
  }

  .min-h-md-85px {
    min-height: 85px !important;
  }

  .min-h-md-90px {
    min-height: 90px !important;
  }

  .min-h-md-95px {
    min-height: 95px !important;
  }

  .min-h-md-100px {
    min-height: 100px !important;
  }

  .min-h-md-125px {
    min-height: 125px !important;
  }

  .min-h-md-150px {
    min-height: 150px !important;
  }

  .min-h-md-175px {
    min-height: 175px !important;
  }

  .min-h-md-200px {
    min-height: 200px !important;
  }

  .min-h-md-225px {
    min-height: 225px !important;
  }

  .min-h-md-250px {
    min-height: 250px !important;
  }

  .min-h-md-275px {
    min-height: 275px !important;
  }

  .min-h-md-300px {
    min-height: 300px !important;
  }

  .min-h-md-325px {
    min-height: 325px !important;
  }

  .min-h-md-350px {
    min-height: 350px !important;
  }

  .min-h-md-375px {
    min-height: 375px !important;
  }

  .min-h-md-400px {
    min-height: 400px !important;
  }

  .min-h-md-425px {
    min-height: 425px !important;
  }

  .min-h-md-450px {
    min-height: 450px !important;
  }

  .min-h-md-475px {
    min-height: 475px !important;
  }

  .min-h-md-500px {
    min-height: 500px !important;
  }

  .min-h-md-550px {
    min-height: 550px !important;
  }

  .min-h-md-600px {
    min-height: 600px !important;
  }

  .min-h-md-650px {
    min-height: 650px !important;
  }

  .min-h-md-700px {
    min-height: 700px !important;
  }

  .min-h-md-750px {
    min-height: 750px !important;
  }

  .min-h-md-800px {
    min-height: 800px !important;
  }

  .min-h-md-850px {
    min-height: 850px !important;
  }

  .min-h-md-900px {
    min-height: 900px !important;
  }

  .min-h-md-950px {
    min-height: 950px !important;
  }

  .min-h-md-1000px {
    min-height: 1000px !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }

  .float-lg-end {
    float: right !important;
  }

  .float-lg-none {
    float: none !important;
  }

  .object-fit-lg-contain {
    object-fit: contain !important;
  }

  .object-fit-lg-cover {
    object-fit: cover !important;
  }

  .object-fit-lg-fill {
    object-fit: fill !important;
  }

  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }

  .object-fit-lg-none {
    object-fit: none !important;
  }

  .d-lg-inline {
    display: inline !important;
  }

  .d-lg-inline-block {
    display: inline-block !important;
  }

  .d-lg-block {
    display: block !important;
  }

  .d-lg-grid {
    display: grid !important;
  }

  .d-lg-inline-grid {
    display: inline-grid !important;
  }

  .d-lg-table {
    display: table !important;
  }

  .d-lg-table-row {
    display: table-row !important;
  }

  .d-lg-table-cell {
    display: table-cell !important;
  }

  .d-lg-flex {
    display: flex !important;
  }

  .d-lg-inline-flex {
    display: inline-flex !important;
  }

  .d-lg-none {
    display: none !important;
  }

  .position-lg-static {
    position: static !important;
  }

  .position-lg-relative {
    position: relative !important;
  }

  .position-lg-absolute {
    position: absolute !important;
  }

  .position-lg-fixed {
    position: fixed !important;
  }

  .position-lg-sticky {
    position: sticky !important;
  }

  .w-lg-unset {
    width: unset !important;
  }

  .w-lg-25 {
    width: 25% !important;
  }

  .w-lg-50 {
    width: 50% !important;
  }

  .w-lg-75 {
    width: 75% !important;
  }

  .w-lg-100 {
    width: 100% !important;
  }

  .w-lg-auto {
    width: auto !important;
  }

  .w-lg-1px {
    width: 1px !important;
  }

  .w-lg-2px {
    width: 2px !important;
  }

  .w-lg-3px {
    width: 3px !important;
  }

  .w-lg-4px {
    width: 4px !important;
  }

  .w-lg-5px {
    width: 5px !important;
  }

  .w-lg-6px {
    width: 6px !important;
  }

  .w-lg-7px {
    width: 7px !important;
  }

  .w-lg-8px {
    width: 8px !important;
  }

  .w-lg-9px {
    width: 9px !important;
  }

  .w-lg-10px {
    width: 10px !important;
  }

  .w-lg-15px {
    width: 15px !important;
  }

  .w-lg-20px {
    width: 20px !important;
  }

  .w-lg-25px {
    width: 25px !important;
  }

  .w-lg-30px {
    width: 30px !important;
  }

  .w-lg-35px {
    width: 35px !important;
  }

  .w-lg-40px {
    width: 40px !important;
  }

  .w-lg-45px {
    width: 45px !important;
  }

  .w-lg-50px {
    width: 50px !important;
  }

  .w-lg-55px {
    width: 55px !important;
  }

  .w-lg-60px {
    width: 60px !important;
  }

  .w-lg-65px {
    width: 65px !important;
  }

  .w-lg-70px {
    width: 70px !important;
  }

  .w-lg-75px {
    width: 75px !important;
  }

  .w-lg-80px {
    width: 80px !important;
  }

  .w-lg-85px {
    width: 85px !important;
  }

  .w-lg-90px {
    width: 90px !important;
  }

  .w-lg-95px {
    width: 95px !important;
  }

  .w-lg-100px {
    width: 100px !important;
  }

  .w-lg-125px {
    width: 125px !important;
  }

  .w-lg-150px {
    width: 150px !important;
  }

  .w-lg-175px {
    width: 175px !important;
  }

  .w-lg-200px {
    width: 200px !important;
  }

  .w-lg-225px {
    width: 225px !important;
  }

  .w-lg-250px {
    width: 250px !important;
  }

  .w-lg-275px {
    width: 275px !important;
  }

  .w-lg-300px {
    width: 300px !important;
  }

  .w-lg-325px {
    width: 325px !important;
  }

  .w-lg-350px {
    width: 350px !important;
  }

  .w-lg-375px {
    width: 375px !important;
  }

  .w-lg-400px {
    width: 400px !important;
  }

  .w-lg-425px {
    width: 425px !important;
  }

  .w-lg-450px {
    width: 450px !important;
  }

  .w-lg-475px {
    width: 475px !important;
  }

  .w-lg-500px {
    width: 500px !important;
  }

  .w-lg-550px {
    width: 550px !important;
  }

  .w-lg-600px {
    width: 600px !important;
  }

  .w-lg-650px {
    width: 650px !important;
  }

  .w-lg-700px {
    width: 700px !important;
  }

  .w-lg-750px {
    width: 750px !important;
  }

  .w-lg-800px {
    width: 800px !important;
  }

  .w-lg-850px {
    width: 850px !important;
  }

  .w-lg-900px {
    width: 900px !important;
  }

  .w-lg-950px {
    width: 950px !important;
  }

  .w-lg-1000px {
    width: 1000px !important;
  }

  .mw-lg-unset {
    max-width: unset !important;
  }

  .mw-lg-25 {
    max-width: 25% !important;
  }

  .mw-lg-50 {
    max-width: 50% !important;
  }

  .mw-lg-75 {
    max-width: 75% !important;
  }

  .mw-lg-100 {
    max-width: 100% !important;
  }

  .mw-lg-auto {
    max-width: auto !important;
  }

  .mw-lg-1px {
    max-width: 1px !important;
  }

  .mw-lg-2px {
    max-width: 2px !important;
  }

  .mw-lg-3px {
    max-width: 3px !important;
  }

  .mw-lg-4px {
    max-width: 4px !important;
  }

  .mw-lg-5px {
    max-width: 5px !important;
  }

  .mw-lg-6px {
    max-width: 6px !important;
  }

  .mw-lg-7px {
    max-width: 7px !important;
  }

  .mw-lg-8px {
    max-width: 8px !important;
  }

  .mw-lg-9px {
    max-width: 9px !important;
  }

  .mw-lg-10px {
    max-width: 10px !important;
  }

  .mw-lg-15px {
    max-width: 15px !important;
  }

  .mw-lg-20px {
    max-width: 20px !important;
  }

  .mw-lg-25px {
    max-width: 25px !important;
  }

  .mw-lg-30px {
    max-width: 30px !important;
  }

  .mw-lg-35px {
    max-width: 35px !important;
  }

  .mw-lg-40px {
    max-width: 40px !important;
  }

  .mw-lg-45px {
    max-width: 45px !important;
  }

  .mw-lg-50px {
    max-width: 50px !important;
  }

  .mw-lg-55px {
    max-width: 55px !important;
  }

  .mw-lg-60px {
    max-width: 60px !important;
  }

  .mw-lg-65px {
    max-width: 65px !important;
  }

  .mw-lg-70px {
    max-width: 70px !important;
  }

  .mw-lg-75px {
    max-width: 75px !important;
  }

  .mw-lg-80px {
    max-width: 80px !important;
  }

  .mw-lg-85px {
    max-width: 85px !important;
  }

  .mw-lg-90px {
    max-width: 90px !important;
  }

  .mw-lg-95px {
    max-width: 95px !important;
  }

  .mw-lg-100px {
    max-width: 100px !important;
  }

  .mw-lg-125px {
    max-width: 125px !important;
  }

  .mw-lg-150px {
    max-width: 150px !important;
  }

  .mw-lg-175px {
    max-width: 175px !important;
  }

  .mw-lg-200px {
    max-width: 200px !important;
  }

  .mw-lg-225px {
    max-width: 225px !important;
  }

  .mw-lg-250px {
    max-width: 250px !important;
  }

  .mw-lg-275px {
    max-width: 275px !important;
  }

  .mw-lg-300px {
    max-width: 300px !important;
  }

  .mw-lg-325px {
    max-width: 325px !important;
  }

  .mw-lg-350px {
    max-width: 350px !important;
  }

  .mw-lg-375px {
    max-width: 375px !important;
  }

  .mw-lg-400px {
    max-width: 400px !important;
  }

  .mw-lg-425px {
    max-width: 425px !important;
  }

  .mw-lg-450px {
    max-width: 450px !important;
  }

  .mw-lg-475px {
    max-width: 475px !important;
  }

  .mw-lg-500px {
    max-width: 500px !important;
  }

  .mw-lg-550px {
    max-width: 550px !important;
  }

  .mw-lg-600px {
    max-width: 600px !important;
  }

  .mw-lg-650px {
    max-width: 650px !important;
  }

  .mw-lg-700px {
    max-width: 700px !important;
  }

  .mw-lg-750px {
    max-width: 750px !important;
  }

  .mw-lg-800px {
    max-width: 800px !important;
  }

  .mw-lg-850px {
    max-width: 850px !important;
  }

  .mw-lg-900px {
    max-width: 900px !important;
  }

  .mw-lg-950px {
    max-width: 950px !important;
  }

  .mw-lg-1000px {
    max-width: 1000px !important;
  }

  .h-lg-unset {
    height: unset !important;
  }

  .h-lg-25 {
    height: 25% !important;
  }

  .h-lg-50 {
    height: 50% !important;
  }

  .h-lg-75 {
    height: 75% !important;
  }

  .h-lg-100 {
    height: 100% !important;
  }

  .h-lg-auto {
    height: auto !important;
  }

  .h-lg-1px {
    height: 1px !important;
  }

  .h-lg-2px {
    height: 2px !important;
  }

  .h-lg-3px {
    height: 3px !important;
  }

  .h-lg-4px {
    height: 4px !important;
  }

  .h-lg-5px {
    height: 5px !important;
  }

  .h-lg-6px {
    height: 6px !important;
  }

  .h-lg-7px {
    height: 7px !important;
  }

  .h-lg-8px {
    height: 8px !important;
  }

  .h-lg-9px {
    height: 9px !important;
  }

  .h-lg-10px {
    height: 10px !important;
  }

  .h-lg-15px {
    height: 15px !important;
  }

  .h-lg-20px {
    height: 20px !important;
  }

  .h-lg-25px {
    height: 25px !important;
  }

  .h-lg-30px {
    height: 30px !important;
  }

  .h-lg-35px {
    height: 35px !important;
  }

  .h-lg-40px {
    height: 40px !important;
  }

  .h-lg-45px {
    height: 45px !important;
  }

  .h-lg-50px {
    height: 50px !important;
  }

  .h-lg-55px {
    height: 55px !important;
  }

  .h-lg-60px {
    height: 60px !important;
  }

  .h-lg-65px {
    height: 65px !important;
  }

  .h-lg-70px {
    height: 70px !important;
  }

  .h-lg-75px {
    height: 75px !important;
  }

  .h-lg-80px {
    height: 80px !important;
  }

  .h-lg-85px {
    height: 85px !important;
  }

  .h-lg-90px {
    height: 90px !important;
  }

  .h-lg-95px {
    height: 95px !important;
  }

  .h-lg-100px {
    height: 100px !important;
  }

  .h-lg-125px {
    height: 125px !important;
  }

  .h-lg-150px {
    height: 150px !important;
  }

  .h-lg-175px {
    height: 175px !important;
  }

  .h-lg-200px {
    height: 200px !important;
  }

  .h-lg-225px {
    height: 225px !important;
  }

  .h-lg-250px {
    height: 250px !important;
  }

  .h-lg-275px {
    height: 275px !important;
  }

  .h-lg-300px {
    height: 300px !important;
  }

  .h-lg-325px {
    height: 325px !important;
  }

  .h-lg-350px {
    height: 350px !important;
  }

  .h-lg-375px {
    height: 375px !important;
  }

  .h-lg-400px {
    height: 400px !important;
  }

  .h-lg-425px {
    height: 425px !important;
  }

  .h-lg-450px {
    height: 450px !important;
  }

  .h-lg-475px {
    height: 475px !important;
  }

  .h-lg-500px {
    height: 500px !important;
  }

  .h-lg-550px {
    height: 550px !important;
  }

  .h-lg-600px {
    height: 600px !important;
  }

  .h-lg-650px {
    height: 650px !important;
  }

  .h-lg-700px {
    height: 700px !important;
  }

  .h-lg-750px {
    height: 750px !important;
  }

  .h-lg-800px {
    height: 800px !important;
  }

  .h-lg-850px {
    height: 850px !important;
  }

  .h-lg-900px {
    height: 900px !important;
  }

  .h-lg-950px {
    height: 950px !important;
  }

  .h-lg-1000px {
    height: 1000px !important;
  }

  .mh-lg-unset {
    max-height: unset !important;
  }

  .mh-lg-25 {
    max-height: 25% !important;
  }

  .mh-lg-50 {
    max-height: 50% !important;
  }

  .mh-lg-75 {
    max-height: 75% !important;
  }

  .mh-lg-100 {
    max-height: 100% !important;
  }

  .mh-lg-auto {
    max-height: auto !important;
  }

  .mh-lg-1px {
    max-height: 1px !important;
  }

  .mh-lg-2px {
    max-height: 2px !important;
  }

  .mh-lg-3px {
    max-height: 3px !important;
  }

  .mh-lg-4px {
    max-height: 4px !important;
  }

  .mh-lg-5px {
    max-height: 5px !important;
  }

  .mh-lg-6px {
    max-height: 6px !important;
  }

  .mh-lg-7px {
    max-height: 7px !important;
  }

  .mh-lg-8px {
    max-height: 8px !important;
  }

  .mh-lg-9px {
    max-height: 9px !important;
  }

  .mh-lg-10px {
    max-height: 10px !important;
  }

  .mh-lg-15px {
    max-height: 15px !important;
  }

  .mh-lg-20px {
    max-height: 20px !important;
  }

  .mh-lg-25px {
    max-height: 25px !important;
  }

  .mh-lg-30px {
    max-height: 30px !important;
  }

  .mh-lg-35px {
    max-height: 35px !important;
  }

  .mh-lg-40px {
    max-height: 40px !important;
  }

  .mh-lg-45px {
    max-height: 45px !important;
  }

  .mh-lg-50px {
    max-height: 50px !important;
  }

  .mh-lg-55px {
    max-height: 55px !important;
  }

  .mh-lg-60px {
    max-height: 60px !important;
  }

  .mh-lg-65px {
    max-height: 65px !important;
  }

  .mh-lg-70px {
    max-height: 70px !important;
  }

  .mh-lg-75px {
    max-height: 75px !important;
  }

  .mh-lg-80px {
    max-height: 80px !important;
  }

  .mh-lg-85px {
    max-height: 85px !important;
  }

  .mh-lg-90px {
    max-height: 90px !important;
  }

  .mh-lg-95px {
    max-height: 95px !important;
  }

  .mh-lg-100px {
    max-height: 100px !important;
  }

  .mh-lg-125px {
    max-height: 125px !important;
  }

  .mh-lg-150px {
    max-height: 150px !important;
  }

  .mh-lg-175px {
    max-height: 175px !important;
  }

  .mh-lg-200px {
    max-height: 200px !important;
  }

  .mh-lg-225px {
    max-height: 225px !important;
  }

  .mh-lg-250px {
    max-height: 250px !important;
  }

  .mh-lg-275px {
    max-height: 275px !important;
  }

  .mh-lg-300px {
    max-height: 300px !important;
  }

  .mh-lg-325px {
    max-height: 325px !important;
  }

  .mh-lg-350px {
    max-height: 350px !important;
  }

  .mh-lg-375px {
    max-height: 375px !important;
  }

  .mh-lg-400px {
    max-height: 400px !important;
  }

  .mh-lg-425px {
    max-height: 425px !important;
  }

  .mh-lg-450px {
    max-height: 450px !important;
  }

  .mh-lg-475px {
    max-height: 475px !important;
  }

  .mh-lg-500px {
    max-height: 500px !important;
  }

  .mh-lg-550px {
    max-height: 550px !important;
  }

  .mh-lg-600px {
    max-height: 600px !important;
  }

  .mh-lg-650px {
    max-height: 650px !important;
  }

  .mh-lg-700px {
    max-height: 700px !important;
  }

  .mh-lg-750px {
    max-height: 750px !important;
  }

  .mh-lg-800px {
    max-height: 800px !important;
  }

  .mh-lg-850px {
    max-height: 850px !important;
  }

  .mh-lg-900px {
    max-height: 900px !important;
  }

  .mh-lg-950px {
    max-height: 950px !important;
  }

  .mh-lg-1000px {
    max-height: 1000px !important;
  }

  .flex-lg-fill {
    flex: 1 1 auto !important;
  }

  .flex-lg-row {
    flex-direction: row !important;
  }

  .flex-lg-column {
    flex-direction: column !important;
  }

  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }

  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-lg-start {
    justify-content: flex-start !important;
  }

  .justify-content-lg-end {
    justify-content: flex-end !important;
  }

  .justify-content-lg-center {
    justify-content: center !important;
  }

  .justify-content-lg-between {
    justify-content: space-between !important;
  }

  .justify-content-lg-around {
    justify-content: space-around !important;
  }

  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-lg-start {
    align-items: flex-start !important;
  }

  .align-items-lg-end {
    align-items: flex-end !important;
  }

  .align-items-lg-center {
    align-items: center !important;
  }

  .align-items-lg-baseline {
    align-items: baseline !important;
  }

  .align-items-lg-stretch {
    align-items: stretch !important;
  }

  .align-content-lg-start {
    align-content: flex-start !important;
  }

  .align-content-lg-end {
    align-content: flex-end !important;
  }

  .align-content-lg-center {
    align-content: center !important;
  }

  .align-content-lg-between {
    align-content: space-between !important;
  }

  .align-content-lg-around {
    align-content: space-around !important;
  }

  .align-content-lg-stretch {
    align-content: stretch !important;
  }

  .align-self-lg-auto {
    align-self: auto !important;
  }

  .align-self-lg-start {
    align-self: flex-start !important;
  }

  .align-self-lg-end {
    align-self: flex-end !important;
  }

  .align-self-lg-center {
    align-self: center !important;
  }

  .align-self-lg-baseline {
    align-self: baseline !important;
  }

  .align-self-lg-stretch {
    align-self: stretch !important;
  }

  .order-lg-first {
    order: -1 !important;
  }

  .order-lg-0 {
    order: 0 !important;
  }

  .order-lg-1 {
    order: 1 !important;
  }

  .order-lg-2 {
    order: 2 !important;
  }

  .order-lg-3 {
    order: 3 !important;
  }

  .order-lg-4 {
    order: 4 !important;
  }

  .order-lg-5 {
    order: 5 !important;
  }

  .order-lg-last {
    order: 6 !important;
  }

  .m-lg-0 {
    margin: 0 !important;
  }

  .m-lg-1 {
    margin: 0.25rem !important;
  }

  .m-lg-2 {
    margin: 0.5rem !important;
  }

  .m-lg-3 {
    margin: 0.75rem !important;
  }

  .m-lg-4 {
    margin: 1rem !important;
  }

  .m-lg-5 {
    margin: 1.25rem !important;
  }

  .m-lg-6 {
    margin: 1.5rem !important;
  }

  .m-lg-7 {
    margin: 1.75rem !important;
  }

  .m-lg-8 {
    margin: 2rem !important;
  }

  .m-lg-9 {
    margin: 2.25rem !important;
  }

  .m-lg-10 {
    margin: 2.5rem !important;
  }

  .m-lg-11 {
    margin: 2.75rem !important;
  }

  .m-lg-12 {
    margin: 3rem !important;
  }

  .m-lg-13 {
    margin: 3.25rem !important;
  }

  .m-lg-14 {
    margin: 3.5rem !important;
  }

  .m-lg-15 {
    margin: 3.75rem !important;
  }

  .m-lg-16 {
    margin: 4rem !important;
  }

  .m-lg-17 {
    margin: 4.25rem !important;
  }

  .m-lg-18 {
    margin: 4.5rem !important;
  }

  .m-lg-19 {
    margin: 4.75rem !important;
  }

  .m-lg-20 {
    margin: 5rem !important;
  }

  .m-lg-auto {
    margin: auto !important;
  }

  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-lg-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }

  .mx-lg-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-lg-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }

  .mx-lg-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-lg-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }

  .mx-lg-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }

  .mx-lg-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }

  .mx-lg-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }

  .mx-lg-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }

  .mx-lg-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-lg-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }

  .mx-lg-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }

  .mx-lg-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }

  .mx-lg-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  .mx-lg-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }

  .mx-lg-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }

  .mx-lg-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }

  .mx-lg-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-lg-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }

  .my-lg-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-lg-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }

  .my-lg-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-lg-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }

  .my-lg-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  .my-lg-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }

  .my-lg-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  .my-lg-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }

  .my-lg-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-lg-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }

  .my-lg-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-lg-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }

  .my-lg-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-lg-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }

  .my-lg-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-lg-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }

  .my-lg-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-lg-0 {
    margin-top: 0 !important;
  }

  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }

  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }

  .mt-lg-3 {
    margin-top: 0.75rem !important;
  }

  .mt-lg-4 {
    margin-top: 1rem !important;
  }

  .mt-lg-5 {
    margin-top: 1.25rem !important;
  }

  .mt-lg-6 {
    margin-top: 1.5rem !important;
  }

  .mt-lg-7 {
    margin-top: 1.75rem !important;
  }

  .mt-lg-8 {
    margin-top: 2rem !important;
  }

  .mt-lg-9 {
    margin-top: 2.25rem !important;
  }

  .mt-lg-10 {
    margin-top: 2.5rem !important;
  }

  .mt-lg-11 {
    margin-top: 2.75rem !important;
  }

  .mt-lg-12 {
    margin-top: 3rem !important;
  }

  .mt-lg-13 {
    margin-top: 3.25rem !important;
  }

  .mt-lg-14 {
    margin-top: 3.5rem !important;
  }

  .mt-lg-15 {
    margin-top: 3.75rem !important;
  }

  .mt-lg-16 {
    margin-top: 4rem !important;
  }

  .mt-lg-17 {
    margin-top: 4.25rem !important;
  }

  .mt-lg-18 {
    margin-top: 4.5rem !important;
  }

  .mt-lg-19 {
    margin-top: 4.75rem !important;
  }

  .mt-lg-20 {
    margin-top: 5rem !important;
  }

  .mt-lg-auto {
    margin-top: auto !important;
  }

  .me-lg-0 {
    margin-right: 0 !important;
  }

  .me-lg-1 {
    margin-right: 0.25rem !important;
  }

  .me-lg-2 {
    margin-right: 0.5rem !important;
  }

  .me-lg-3 {
    margin-right: 0.75rem !important;
  }

  .me-lg-4 {
    margin-right: 1rem !important;
  }

  .me-lg-5 {
    margin-right: 1.25rem !important;
  }

  .me-lg-6 {
    margin-right: 1.5rem !important;
  }

  .me-lg-7 {
    margin-right: 1.75rem !important;
  }

  .me-lg-8 {
    margin-right: 2rem !important;
  }

  .me-lg-9 {
    margin-right: 2.25rem !important;
  }

  .me-lg-10 {
    margin-right: 2.5rem !important;
  }

  .me-lg-11 {
    margin-right: 2.75rem !important;
  }

  .me-lg-12 {
    margin-right: 3rem !important;
  }

  .me-lg-13 {
    margin-right: 3.25rem !important;
  }

  .me-lg-14 {
    margin-right: 3.5rem !important;
  }

  .me-lg-15 {
    margin-right: 3.75rem !important;
  }

  .me-lg-16 {
    margin-right: 4rem !important;
  }

  .me-lg-17 {
    margin-right: 4.25rem !important;
  }

  .me-lg-18 {
    margin-right: 4.5rem !important;
  }

  .me-lg-19 {
    margin-right: 4.75rem !important;
  }

  .me-lg-20 {
    margin-right: 5rem !important;
  }

  .me-lg-auto {
    margin-right: auto !important;
  }

  .mb-lg-0 {
    margin-bottom: 0 !important;
  }

  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-lg-3 {
    margin-bottom: 0.75rem !important;
  }

  .mb-lg-4 {
    margin-bottom: 1rem !important;
  }

  .mb-lg-5 {
    margin-bottom: 1.25rem !important;
  }

  .mb-lg-6 {
    margin-bottom: 1.5rem !important;
  }

  .mb-lg-7 {
    margin-bottom: 1.75rem !important;
  }

  .mb-lg-8 {
    margin-bottom: 2rem !important;
  }

  .mb-lg-9 {
    margin-bottom: 2.25rem !important;
  }

  .mb-lg-10 {
    margin-bottom: 2.5rem !important;
  }

  .mb-lg-11 {
    margin-bottom: 2.75rem !important;
  }

  .mb-lg-12 {
    margin-bottom: 3rem !important;
  }

  .mb-lg-13 {
    margin-bottom: 3.25rem !important;
  }

  .mb-lg-14 {
    margin-bottom: 3.5rem !important;
  }

  .mb-lg-15 {
    margin-bottom: 3.75rem !important;
  }

  .mb-lg-16 {
    margin-bottom: 4rem !important;
  }

  .mb-lg-17 {
    margin-bottom: 4.25rem !important;
  }

  .mb-lg-18 {
    margin-bottom: 4.5rem !important;
  }

  .mb-lg-19 {
    margin-bottom: 4.75rem !important;
  }

  .mb-lg-20 {
    margin-bottom: 5rem !important;
  }

  .mb-lg-auto {
    margin-bottom: auto !important;
  }

  .ms-lg-0 {
    margin-left: 0 !important;
  }

  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }

  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }

  .ms-lg-3 {
    margin-left: 0.75rem !important;
  }

  .ms-lg-4 {
    margin-left: 1rem !important;
  }

  .ms-lg-5 {
    margin-left: 1.25rem !important;
  }

  .ms-lg-6 {
    margin-left: 1.5rem !important;
  }

  .ms-lg-7 {
    margin-left: 1.75rem !important;
  }

  .ms-lg-8 {
    margin-left: 2rem !important;
  }

  .ms-lg-9 {
    margin-left: 2.25rem !important;
  }

  .ms-lg-10 {
    margin-left: 2.5rem !important;
  }

  .ms-lg-11 {
    margin-left: 2.75rem !important;
  }

  .ms-lg-12 {
    margin-left: 3rem !important;
  }

  .ms-lg-13 {
    margin-left: 3.25rem !important;
  }

  .ms-lg-14 {
    margin-left: 3.5rem !important;
  }

  .ms-lg-15 {
    margin-left: 3.75rem !important;
  }

  .ms-lg-16 {
    margin-left: 4rem !important;
  }

  .ms-lg-17 {
    margin-left: 4.25rem !important;
  }

  .ms-lg-18 {
    margin-left: 4.5rem !important;
  }

  .ms-lg-19 {
    margin-left: 4.75rem !important;
  }

  .ms-lg-20 {
    margin-left: 5rem !important;
  }

  .ms-lg-auto {
    margin-left: auto !important;
  }

  .m-lg-n1 {
    margin: -0.25rem !important;
  }

  .m-lg-n2 {
    margin: -0.5rem !important;
  }

  .m-lg-n3 {
    margin: -0.75rem !important;
  }

  .m-lg-n4 {
    margin: -1rem !important;
  }

  .m-lg-n5 {
    margin: -1.25rem !important;
  }

  .m-lg-n6 {
    margin: -1.5rem !important;
  }

  .m-lg-n7 {
    margin: -1.75rem !important;
  }

  .m-lg-n8 {
    margin: -2rem !important;
  }

  .m-lg-n9 {
    margin: -2.25rem !important;
  }

  .m-lg-n10 {
    margin: -2.5rem !important;
  }

  .m-lg-n11 {
    margin: -2.75rem !important;
  }

  .m-lg-n12 {
    margin: -3rem !important;
  }

  .m-lg-n13 {
    margin: -3.25rem !important;
  }

  .m-lg-n14 {
    margin: -3.5rem !important;
  }

  .m-lg-n15 {
    margin: -3.75rem !important;
  }

  .m-lg-n16 {
    margin: -4rem !important;
  }

  .m-lg-n17 {
    margin: -4.25rem !important;
  }

  .m-lg-n18 {
    margin: -4.5rem !important;
  }

  .m-lg-n19 {
    margin: -4.75rem !important;
  }

  .m-lg-n20 {
    margin: -5rem !important;
  }

  .mx-lg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-lg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-lg-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }

  .mx-lg-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-lg-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }

  .mx-lg-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-lg-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }

  .mx-lg-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }

  .mx-lg-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }

  .mx-lg-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }

  .mx-lg-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }

  .mx-lg-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .mx-lg-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }

  .mx-lg-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }

  .mx-lg-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }

  .mx-lg-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }

  .mx-lg-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }

  .mx-lg-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }

  .mx-lg-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }

  .mx-lg-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }

  .my-lg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-lg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-lg-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }

  .my-lg-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-lg-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }

  .my-lg-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-lg-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }

  .my-lg-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }

  .my-lg-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }

  .my-lg-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }

  .my-lg-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }

  .my-lg-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .my-lg-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }

  .my-lg-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }

  .my-lg-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }

  .my-lg-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }

  .my-lg-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }

  .my-lg-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }

  .my-lg-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }

  .my-lg-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }

  .mt-lg-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-lg-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-lg-n3 {
    margin-top: -0.75rem !important;
  }

  .mt-lg-n4 {
    margin-top: -1rem !important;
  }

  .mt-lg-n5 {
    margin-top: -1.25rem !important;
  }

  .mt-lg-n6 {
    margin-top: -1.5rem !important;
  }

  .mt-lg-n7 {
    margin-top: -1.75rem !important;
  }

  .mt-lg-n8 {
    margin-top: -2rem !important;
  }

  .mt-lg-n9 {
    margin-top: -2.25rem !important;
  }

  .mt-lg-n10 {
    margin-top: -2.5rem !important;
  }

  .mt-lg-n11 {
    margin-top: -2.75rem !important;
  }

  .mt-lg-n12 {
    margin-top: -3rem !important;
  }

  .mt-lg-n13 {
    margin-top: -3.25rem !important;
  }

  .mt-lg-n14 {
    margin-top: -3.5rem !important;
  }

  .mt-lg-n15 {
    margin-top: -3.75rem !important;
  }

  .mt-lg-n16 {
    margin-top: -4rem !important;
  }

  .mt-lg-n17 {
    margin-top: -4.25rem !important;
  }

  .mt-lg-n18 {
    margin-top: -4.5rem !important;
  }

  .mt-lg-n19 {
    margin-top: -4.75rem !important;
  }

  .mt-lg-n20 {
    margin-top: -5rem !important;
  }

  .me-lg-n1 {
    margin-right: -0.25rem !important;
  }

  .me-lg-n2 {
    margin-right: -0.5rem !important;
  }

  .me-lg-n3 {
    margin-right: -0.75rem !important;
  }

  .me-lg-n4 {
    margin-right: -1rem !important;
  }

  .me-lg-n5 {
    margin-right: -1.25rem !important;
  }

  .me-lg-n6 {
    margin-right: -1.5rem !important;
  }

  .me-lg-n7 {
    margin-right: -1.75rem !important;
  }

  .me-lg-n8 {
    margin-right: -2rem !important;
  }

  .me-lg-n9 {
    margin-right: -2.25rem !important;
  }

  .me-lg-n10 {
    margin-right: -2.5rem !important;
  }

  .me-lg-n11 {
    margin-right: -2.75rem !important;
  }

  .me-lg-n12 {
    margin-right: -3rem !important;
  }

  .me-lg-n13 {
    margin-right: -3.25rem !important;
  }

  .me-lg-n14 {
    margin-right: -3.5rem !important;
  }

  .me-lg-n15 {
    margin-right: -3.75rem !important;
  }

  .me-lg-n16 {
    margin-right: -4rem !important;
  }

  .me-lg-n17 {
    margin-right: -4.25rem !important;
  }

  .me-lg-n18 {
    margin-right: -4.5rem !important;
  }

  .me-lg-n19 {
    margin-right: -4.75rem !important;
  }

  .me-lg-n20 {
    margin-right: -5rem !important;
  }

  .mb-lg-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-lg-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-lg-n3 {
    margin-bottom: -0.75rem !important;
  }

  .mb-lg-n4 {
    margin-bottom: -1rem !important;
  }

  .mb-lg-n5 {
    margin-bottom: -1.25rem !important;
  }

  .mb-lg-n6 {
    margin-bottom: -1.5rem !important;
  }

  .mb-lg-n7 {
    margin-bottom: -1.75rem !important;
  }

  .mb-lg-n8 {
    margin-bottom: -2rem !important;
  }

  .mb-lg-n9 {
    margin-bottom: -2.25rem !important;
  }

  .mb-lg-n10 {
    margin-bottom: -2.5rem !important;
  }

  .mb-lg-n11 {
    margin-bottom: -2.75rem !important;
  }

  .mb-lg-n12 {
    margin-bottom: -3rem !important;
  }

  .mb-lg-n13 {
    margin-bottom: -3.25rem !important;
  }

  .mb-lg-n14 {
    margin-bottom: -3.5rem !important;
  }

  .mb-lg-n15 {
    margin-bottom: -3.75rem !important;
  }

  .mb-lg-n16 {
    margin-bottom: -4rem !important;
  }

  .mb-lg-n17 {
    margin-bottom: -4.25rem !important;
  }

  .mb-lg-n18 {
    margin-bottom: -4.5rem !important;
  }

  .mb-lg-n19 {
    margin-bottom: -4.75rem !important;
  }

  .mb-lg-n20 {
    margin-bottom: -5rem !important;
  }

  .ms-lg-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-lg-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-lg-n3 {
    margin-left: -0.75rem !important;
  }

  .ms-lg-n4 {
    margin-left: -1rem !important;
  }

  .ms-lg-n5 {
    margin-left: -1.25rem !important;
  }

  .ms-lg-n6 {
    margin-left: -1.5rem !important;
  }

  .ms-lg-n7 {
    margin-left: -1.75rem !important;
  }

  .ms-lg-n8 {
    margin-left: -2rem !important;
  }

  .ms-lg-n9 {
    margin-left: -2.25rem !important;
  }

  .ms-lg-n10 {
    margin-left: -2.5rem !important;
  }

  .ms-lg-n11 {
    margin-left: -2.75rem !important;
  }

  .ms-lg-n12 {
    margin-left: -3rem !important;
  }

  .ms-lg-n13 {
    margin-left: -3.25rem !important;
  }

  .ms-lg-n14 {
    margin-left: -3.5rem !important;
  }

  .ms-lg-n15 {
    margin-left: -3.75rem !important;
  }

  .ms-lg-n16 {
    margin-left: -4rem !important;
  }

  .ms-lg-n17 {
    margin-left: -4.25rem !important;
  }

  .ms-lg-n18 {
    margin-left: -4.5rem !important;
  }

  .ms-lg-n19 {
    margin-left: -4.75rem !important;
  }

  .ms-lg-n20 {
    margin-left: -5rem !important;
  }

  .p-lg-0 {
    padding: 0 !important;
  }

  .p-lg-1 {
    padding: 0.25rem !important;
  }

  .p-lg-2 {
    padding: 0.5rem !important;
  }

  .p-lg-3 {
    padding: 0.75rem !important;
  }

  .p-lg-4 {
    padding: 1rem !important;
  }

  .p-lg-5 {
    padding: 1.25rem !important;
  }

  .p-lg-6 {
    padding: 1.5rem !important;
  }

  .p-lg-7 {
    padding: 1.75rem !important;
  }

  .p-lg-8 {
    padding: 2rem !important;
  }

  .p-lg-9 {
    padding: 2.25rem !important;
  }

  .p-lg-10 {
    padding: 2.5rem !important;
  }

  .p-lg-11 {
    padding: 2.75rem !important;
  }

  .p-lg-12 {
    padding: 3rem !important;
  }

  .p-lg-13 {
    padding: 3.25rem !important;
  }

  .p-lg-14 {
    padding: 3.5rem !important;
  }

  .p-lg-15 {
    padding: 3.75rem !important;
  }

  .p-lg-16 {
    padding: 4rem !important;
  }

  .p-lg-17 {
    padding: 4.25rem !important;
  }

  .p-lg-18 {
    padding: 4.5rem !important;
  }

  .p-lg-19 {
    padding: 4.75rem !important;
  }

  .p-lg-20 {
    padding: 5rem !important;
  }

  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-lg-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }

  .px-lg-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-lg-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }

  .px-lg-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-lg-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }

  .px-lg-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }

  .px-lg-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }

  .px-lg-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }

  .px-lg-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }

  .px-lg-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .px-lg-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }

  .px-lg-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }

  .px-lg-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }

  .px-lg-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  .px-lg-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }

  .px-lg-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }

  .px-lg-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }

  .px-lg-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-lg-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  .py-lg-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-lg-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }

  .py-lg-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-lg-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }

  .py-lg-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .py-lg-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }

  .py-lg-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  .py-lg-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }

  .py-lg-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .py-lg-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }

  .py-lg-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-lg-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }

  .py-lg-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-lg-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }

  .py-lg-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-lg-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }

  .py-lg-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .pt-lg-0 {
    padding-top: 0 !important;
  }

  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }

  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }

  .pt-lg-3 {
    padding-top: 0.75rem !important;
  }

  .pt-lg-4 {
    padding-top: 1rem !important;
  }

  .pt-lg-5 {
    padding-top: 1.25rem !important;
  }

  .pt-lg-6 {
    padding-top: 1.5rem !important;
  }

  .pt-lg-7 {
    padding-top: 1.75rem !important;
  }

  .pt-lg-8 {
    padding-top: 2rem !important;
  }

  .pt-lg-9 {
    padding-top: 2.25rem !important;
  }

  .pt-lg-10 {
    padding-top: 2.5rem !important;
  }

  .pt-lg-11 {
    padding-top: 2.75rem !important;
  }

  .pt-lg-12 {
    padding-top: 3rem !important;
  }

  .pt-lg-13 {
    padding-top: 3.25rem !important;
  }

  .pt-lg-14 {
    padding-top: 3.5rem !important;
  }

  .pt-lg-15 {
    padding-top: 3.75rem !important;
  }

  .pt-lg-16 {
    padding-top: 4rem !important;
  }

  .pt-lg-17 {
    padding-top: 4.25rem !important;
  }

  .pt-lg-18 {
    padding-top: 4.5rem !important;
  }

  .pt-lg-19 {
    padding-top: 4.75rem !important;
  }

  .pt-lg-20 {
    padding-top: 5rem !important;
  }

  .pe-lg-0 {
    padding-right: 0 !important;
  }

  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }

  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }

  .pe-lg-3 {
    padding-right: 0.75rem !important;
  }

  .pe-lg-4 {
    padding-right: 1rem !important;
  }

  .pe-lg-5 {
    padding-right: 1.25rem !important;
  }

  .pe-lg-6 {
    padding-right: 1.5rem !important;
  }

  .pe-lg-7 {
    padding-right: 1.75rem !important;
  }

  .pe-lg-8 {
    padding-right: 2rem !important;
  }

  .pe-lg-9 {
    padding-right: 2.25rem !important;
  }

  .pe-lg-10 {
    padding-right: 2.5rem !important;
  }

  .pe-lg-11 {
    padding-right: 2.75rem !important;
  }

  .pe-lg-12 {
    padding-right: 3rem !important;
  }

  .pe-lg-13 {
    padding-right: 3.25rem !important;
  }

  .pe-lg-14 {
    padding-right: 3.5rem !important;
  }

  .pe-lg-15 {
    padding-right: 3.75rem !important;
  }

  .pe-lg-16 {
    padding-right: 4rem !important;
  }

  .pe-lg-17 {
    padding-right: 4.25rem !important;
  }

  .pe-lg-18 {
    padding-right: 4.5rem !important;
  }

  .pe-lg-19 {
    padding-right: 4.75rem !important;
  }

  .pe-lg-20 {
    padding-right: 5rem !important;
  }

  .pb-lg-0 {
    padding-bottom: 0 !important;
  }

  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-lg-3 {
    padding-bottom: 0.75rem !important;
  }

  .pb-lg-4 {
    padding-bottom: 1rem !important;
  }

  .pb-lg-5 {
    padding-bottom: 1.25rem !important;
  }

  .pb-lg-6 {
    padding-bottom: 1.5rem !important;
  }

  .pb-lg-7 {
    padding-bottom: 1.75rem !important;
  }

  .pb-lg-8 {
    padding-bottom: 2rem !important;
  }

  .pb-lg-9 {
    padding-bottom: 2.25rem !important;
  }

  .pb-lg-10 {
    padding-bottom: 2.5rem !important;
  }

  .pb-lg-11 {
    padding-bottom: 2.75rem !important;
  }

  .pb-lg-12 {
    padding-bottom: 3rem !important;
  }

  .pb-lg-13 {
    padding-bottom: 3.25rem !important;
  }

  .pb-lg-14 {
    padding-bottom: 3.5rem !important;
  }

  .pb-lg-15 {
    padding-bottom: 3.75rem !important;
  }

  .pb-lg-16 {
    padding-bottom: 4rem !important;
  }

  .pb-lg-17 {
    padding-bottom: 4.25rem !important;
  }

  .pb-lg-18 {
    padding-bottom: 4.5rem !important;
  }

  .pb-lg-19 {
    padding-bottom: 4.75rem !important;
  }

  .pb-lg-20 {
    padding-bottom: 5rem !important;
  }

  .ps-lg-0 {
    padding-left: 0 !important;
  }

  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }

  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }

  .ps-lg-3 {
    padding-left: 0.75rem !important;
  }

  .ps-lg-4 {
    padding-left: 1rem !important;
  }

  .ps-lg-5 {
    padding-left: 1.25rem !important;
  }

  .ps-lg-6 {
    padding-left: 1.5rem !important;
  }

  .ps-lg-7 {
    padding-left: 1.75rem !important;
  }

  .ps-lg-8 {
    padding-left: 2rem !important;
  }

  .ps-lg-9 {
    padding-left: 2.25rem !important;
  }

  .ps-lg-10 {
    padding-left: 2.5rem !important;
  }

  .ps-lg-11 {
    padding-left: 2.75rem !important;
  }

  .ps-lg-12 {
    padding-left: 3rem !important;
  }

  .ps-lg-13 {
    padding-left: 3.25rem !important;
  }

  .ps-lg-14 {
    padding-left: 3.5rem !important;
  }

  .ps-lg-15 {
    padding-left: 3.75rem !important;
  }

  .ps-lg-16 {
    padding-left: 4rem !important;
  }

  .ps-lg-17 {
    padding-left: 4.25rem !important;
  }

  .ps-lg-18 {
    padding-left: 4.5rem !important;
  }

  .ps-lg-19 {
    padding-left: 4.75rem !important;
  }

  .ps-lg-20 {
    padding-left: 5rem !important;
  }

  .gap-lg-0 {
    gap: 0 !important;
  }

  .gap-lg-1 {
    gap: 0.25rem !important;
  }

  .gap-lg-2 {
    gap: 0.5rem !important;
  }

  .gap-lg-3 {
    gap: 0.75rem !important;
  }

  .gap-lg-4 {
    gap: 1rem !important;
  }

  .gap-lg-5 {
    gap: 1.25rem !important;
  }

  .gap-lg-6 {
    gap: 1.5rem !important;
  }

  .gap-lg-7 {
    gap: 1.75rem !important;
  }

  .gap-lg-8 {
    gap: 2rem !important;
  }

  .gap-lg-9 {
    gap: 2.25rem !important;
  }

  .gap-lg-10 {
    gap: 2.5rem !important;
  }

  .gap-lg-11 {
    gap: 2.75rem !important;
  }

  .gap-lg-12 {
    gap: 3rem !important;
  }

  .gap-lg-13 {
    gap: 3.25rem !important;
  }

  .gap-lg-14 {
    gap: 3.5rem !important;
  }

  .gap-lg-15 {
    gap: 3.75rem !important;
  }

  .gap-lg-16 {
    gap: 4rem !important;
  }

  .gap-lg-17 {
    gap: 4.25rem !important;
  }

  .gap-lg-18 {
    gap: 4.5rem !important;
  }

  .gap-lg-19 {
    gap: 4.75rem !important;
  }

  .gap-lg-20 {
    gap: 5rem !important;
  }

  .row-gap-lg-0 {
    row-gap: 0 !important;
  }

  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-lg-3 {
    row-gap: 0.75rem !important;
  }

  .row-gap-lg-4 {
    row-gap: 1rem !important;
  }

  .row-gap-lg-5 {
    row-gap: 1.25rem !important;
  }

  .row-gap-lg-6 {
    row-gap: 1.5rem !important;
  }

  .row-gap-lg-7 {
    row-gap: 1.75rem !important;
  }

  .row-gap-lg-8 {
    row-gap: 2rem !important;
  }

  .row-gap-lg-9 {
    row-gap: 2.25rem !important;
  }

  .row-gap-lg-10 {
    row-gap: 2.5rem !important;
  }

  .row-gap-lg-11 {
    row-gap: 2.75rem !important;
  }

  .row-gap-lg-12 {
    row-gap: 3rem !important;
  }

  .row-gap-lg-13 {
    row-gap: 3.25rem !important;
  }

  .row-gap-lg-14 {
    row-gap: 3.5rem !important;
  }

  .row-gap-lg-15 {
    row-gap: 3.75rem !important;
  }

  .row-gap-lg-16 {
    row-gap: 4rem !important;
  }

  .row-gap-lg-17 {
    row-gap: 4.25rem !important;
  }

  .row-gap-lg-18 {
    row-gap: 4.5rem !important;
  }

  .row-gap-lg-19 {
    row-gap: 4.75rem !important;
  }

  .row-gap-lg-20 {
    row-gap: 5rem !important;
  }

  .column-gap-lg-0 {
    column-gap: 0 !important;
  }

  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-lg-3 {
    column-gap: 0.75rem !important;
  }

  .column-gap-lg-4 {
    column-gap: 1rem !important;
  }

  .column-gap-lg-5 {
    column-gap: 1.25rem !important;
  }

  .column-gap-lg-6 {
    column-gap: 1.5rem !important;
  }

  .column-gap-lg-7 {
    column-gap: 1.75rem !important;
  }

  .column-gap-lg-8 {
    column-gap: 2rem !important;
  }

  .column-gap-lg-9 {
    column-gap: 2.25rem !important;
  }

  .column-gap-lg-10 {
    column-gap: 2.5rem !important;
  }

  .column-gap-lg-11 {
    column-gap: 2.75rem !important;
  }

  .column-gap-lg-12 {
    column-gap: 3rem !important;
  }

  .column-gap-lg-13 {
    column-gap: 3.25rem !important;
  }

  .column-gap-lg-14 {
    column-gap: 3.5rem !important;
  }

  .column-gap-lg-15 {
    column-gap: 3.75rem !important;
  }

  .column-gap-lg-16 {
    column-gap: 4rem !important;
  }

  .column-gap-lg-17 {
    column-gap: 4.25rem !important;
  }

  .column-gap-lg-18 {
    column-gap: 4.5rem !important;
  }

  .column-gap-lg-19 {
    column-gap: 4.75rem !important;
  }

  .column-gap-lg-20 {
    column-gap: 5rem !important;
  }

  .fs-lg-1 {
    font-size: calc(1.3rem + 0.6vw) !important;
  }

  .fs-lg-2 {
    font-size: calc(1.275rem + 0.3vw) !important;
  }

  .fs-lg-3 {
    font-size: calc(1.26rem + 0.12vw) !important;
  }

  .fs-lg-4 {
    font-size: 1.25rem !important;
  }

  .fs-lg-5 {
    font-size: 1.15rem !important;
  }

  .fs-lg-6 {
    font-size: 1.075rem !important;
  }

  .fs-lg-7 {
    font-size: 0.95rem !important;
  }

  .fs-lg-8 {
    font-size: 0.85rem !important;
  }

  .fs-lg-9 {
    font-size: 0.75rem !important;
  }

  .fs-lg-10 {
    font-size: 0.5rem !important;
  }

  .fs-lg-base {
    font-size: 1rem !important;
  }

  .fs-lg-fluid {
    font-size: 100% !important;
  }

  .fs-lg-2x {
    font-size: calc(1.325rem + 0.9vw) !important;
  }

  .fs-lg-2qx {
    font-size: calc(1.35rem + 1.2vw) !important;
  }

  .fs-lg-2hx {
    font-size: calc(1.375rem + 1.5vw) !important;
  }

  .fs-lg-2tx {
    font-size: calc(1.4rem + 1.8vw) !important;
  }

  .fs-lg-3x {
    font-size: calc(1.425rem + 2.1vw) !important;
  }

  .fs-lg-3qx {
    font-size: calc(1.45rem + 2.4vw) !important;
  }

  .fs-lg-3hx {
    font-size: calc(1.475rem + 2.7vw) !important;
  }

  .fs-lg-3tx {
    font-size: calc(1.5rem + 3vw) !important;
  }

  .fs-lg-4x {
    font-size: calc(1.525rem + 3.3vw) !important;
  }

  .fs-lg-4qx {
    font-size: calc(1.55rem + 3.6vw) !important;
  }

  .fs-lg-4hx {
    font-size: calc(1.575rem + 3.9vw) !important;
  }

  .fs-lg-4tx {
    font-size: calc(1.6rem + 4.2vw) !important;
  }

  .fs-lg-5x {
    font-size: calc(1.625rem + 4.5vw) !important;
  }

  .fs-lg-5qx {
    font-size: calc(1.65rem + 4.8vw) !important;
  }

  .fs-lg-5hx {
    font-size: calc(1.675rem + 5.1vw) !important;
  }

  .fs-lg-5tx {
    font-size: calc(1.7rem + 5.4vw) !important;
  }

  .text-lg-start {
    text-align: left !important;
  }

  .text-lg-end {
    text-align: right !important;
  }

  .text-lg-center {
    text-align: center !important;
  }

  .min-w-lg-unset {
    min-width: unset !important;
  }

  .min-w-lg-25 {
    min-width: 25% !important;
  }

  .min-w-lg-50 {
    min-width: 50% !important;
  }

  .min-w-lg-75 {
    min-width: 75% !important;
  }

  .min-w-lg-100 {
    min-width: 100% !important;
  }

  .min-w-lg-auto {
    min-width: auto !important;
  }

  .min-w-lg-1px {
    min-width: 1px !important;
  }

  .min-w-lg-2px {
    min-width: 2px !important;
  }

  .min-w-lg-3px {
    min-width: 3px !important;
  }

  .min-w-lg-4px {
    min-width: 4px !important;
  }

  .min-w-lg-5px {
    min-width: 5px !important;
  }

  .min-w-lg-6px {
    min-width: 6px !important;
  }

  .min-w-lg-7px {
    min-width: 7px !important;
  }

  .min-w-lg-8px {
    min-width: 8px !important;
  }

  .min-w-lg-9px {
    min-width: 9px !important;
  }

  .min-w-lg-10px {
    min-width: 10px !important;
  }

  .min-w-lg-15px {
    min-width: 15px !important;
  }

  .min-w-lg-20px {
    min-width: 20px !important;
  }

  .min-w-lg-25px {
    min-width: 25px !important;
  }

  .min-w-lg-30px {
    min-width: 30px !important;
  }

  .min-w-lg-35px {
    min-width: 35px !important;
  }

  .min-w-lg-40px {
    min-width: 40px !important;
  }

  .min-w-lg-45px {
    min-width: 45px !important;
  }

  .min-w-lg-50px {
    min-width: 50px !important;
  }

  .min-w-lg-55px {
    min-width: 55px !important;
  }

  .min-w-lg-60px {
    min-width: 60px !important;
  }

  .min-w-lg-65px {
    min-width: 65px !important;
  }

  .min-w-lg-70px {
    min-width: 70px !important;
  }

  .min-w-lg-75px {
    min-width: 75px !important;
  }

  .min-w-lg-80px {
    min-width: 80px !important;
  }

  .min-w-lg-85px {
    min-width: 85px !important;
  }

  .min-w-lg-90px {
    min-width: 90px !important;
  }

  .min-w-lg-95px {
    min-width: 95px !important;
  }

  .min-w-lg-100px {
    min-width: 100px !important;
  }

  .min-w-lg-125px {
    min-width: 125px !important;
  }

  .min-w-lg-150px {
    min-width: 150px !important;
  }

  .min-w-lg-175px {
    min-width: 175px !important;
  }

  .min-w-lg-200px {
    min-width: 200px !important;
  }

  .min-w-lg-225px {
    min-width: 225px !important;
  }

  .min-w-lg-250px {
    min-width: 250px !important;
  }

  .min-w-lg-275px {
    min-width: 275px !important;
  }

  .min-w-lg-300px {
    min-width: 300px !important;
  }

  .min-w-lg-325px {
    min-width: 325px !important;
  }

  .min-w-lg-350px {
    min-width: 350px !important;
  }

  .min-w-lg-375px {
    min-width: 375px !important;
  }

  .min-w-lg-400px {
    min-width: 400px !important;
  }

  .min-w-lg-425px {
    min-width: 425px !important;
  }

  .min-w-lg-450px {
    min-width: 450px !important;
  }

  .min-w-lg-475px {
    min-width: 475px !important;
  }

  .min-w-lg-500px {
    min-width: 500px !important;
  }

  .min-w-lg-550px {
    min-width: 550px !important;
  }

  .min-w-lg-600px {
    min-width: 600px !important;
  }

  .min-w-lg-650px {
    min-width: 650px !important;
  }

  .min-w-lg-700px {
    min-width: 700px !important;
  }

  .min-w-lg-750px {
    min-width: 750px !important;
  }

  .min-w-lg-800px {
    min-width: 800px !important;
  }

  .min-w-lg-850px {
    min-width: 850px !important;
  }

  .min-w-lg-900px {
    min-width: 900px !important;
  }

  .min-w-lg-950px {
    min-width: 950px !important;
  }

  .min-w-lg-1000px {
    min-width: 1000px !important;
  }

  .min-h-lg-unset {
    min-height: unset !important;
  }

  .min-h-lg-25 {
    min-height: 25% !important;
  }

  .min-h-lg-50 {
    min-height: 50% !important;
  }

  .min-h-lg-75 {
    min-height: 75% !important;
  }

  .min-h-lg-100 {
    min-height: 100% !important;
  }

  .min-h-lg-auto {
    min-height: auto !important;
  }

  .min-h-lg-1px {
    min-height: 1px !important;
  }

  .min-h-lg-2px {
    min-height: 2px !important;
  }

  .min-h-lg-3px {
    min-height: 3px !important;
  }

  .min-h-lg-4px {
    min-height: 4px !important;
  }

  .min-h-lg-5px {
    min-height: 5px !important;
  }

  .min-h-lg-6px {
    min-height: 6px !important;
  }

  .min-h-lg-7px {
    min-height: 7px !important;
  }

  .min-h-lg-8px {
    min-height: 8px !important;
  }

  .min-h-lg-9px {
    min-height: 9px !important;
  }

  .min-h-lg-10px {
    min-height: 10px !important;
  }

  .min-h-lg-15px {
    min-height: 15px !important;
  }

  .min-h-lg-20px {
    min-height: 20px !important;
  }

  .min-h-lg-25px {
    min-height: 25px !important;
  }

  .min-h-lg-30px {
    min-height: 30px !important;
  }

  .min-h-lg-35px {
    min-height: 35px !important;
  }

  .min-h-lg-40px {
    min-height: 40px !important;
  }

  .min-h-lg-45px {
    min-height: 45px !important;
  }

  .min-h-lg-50px {
    min-height: 50px !important;
  }

  .min-h-lg-55px {
    min-height: 55px !important;
  }

  .min-h-lg-60px {
    min-height: 60px !important;
  }

  .min-h-lg-65px {
    min-height: 65px !important;
  }

  .min-h-lg-70px {
    min-height: 70px !important;
  }

  .min-h-lg-75px {
    min-height: 75px !important;
  }

  .min-h-lg-80px {
    min-height: 80px !important;
  }

  .min-h-lg-85px {
    min-height: 85px !important;
  }

  .min-h-lg-90px {
    min-height: 90px !important;
  }

  .min-h-lg-95px {
    min-height: 95px !important;
  }

  .min-h-lg-100px {
    min-height: 100px !important;
  }

  .min-h-lg-125px {
    min-height: 125px !important;
  }

  .min-h-lg-150px {
    min-height: 150px !important;
  }

  .min-h-lg-175px {
    min-height: 175px !important;
  }

  .min-h-lg-200px {
    min-height: 200px !important;
  }

  .min-h-lg-225px {
    min-height: 225px !important;
  }

  .min-h-lg-250px {
    min-height: 250px !important;
  }

  .min-h-lg-275px {
    min-height: 275px !important;
  }

  .min-h-lg-300px {
    min-height: 300px !important;
  }

  .min-h-lg-325px {
    min-height: 325px !important;
  }

  .min-h-lg-350px {
    min-height: 350px !important;
  }

  .min-h-lg-375px {
    min-height: 375px !important;
  }

  .min-h-lg-400px {
    min-height: 400px !important;
  }

  .min-h-lg-425px {
    min-height: 425px !important;
  }

  .min-h-lg-450px {
    min-height: 450px !important;
  }

  .min-h-lg-475px {
    min-height: 475px !important;
  }

  .min-h-lg-500px {
    min-height: 500px !important;
  }

  .min-h-lg-550px {
    min-height: 550px !important;
  }

  .min-h-lg-600px {
    min-height: 600px !important;
  }

  .min-h-lg-650px {
    min-height: 650px !important;
  }

  .min-h-lg-700px {
    min-height: 700px !important;
  }

  .min-h-lg-750px {
    min-height: 750px !important;
  }

  .min-h-lg-800px {
    min-height: 800px !important;
  }

  .min-h-lg-850px {
    min-height: 850px !important;
  }

  .min-h-lg-900px {
    min-height: 900px !important;
  }

  .min-h-lg-950px {
    min-height: 950px !important;
  }

  .min-h-lg-1000px {
    min-height: 1000px !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }

  .float-xl-end {
    float: right !important;
  }

  .float-xl-none {
    float: none !important;
  }

  .object-fit-xl-contain {
    object-fit: contain !important;
  }

  .object-fit-xl-cover {
    object-fit: cover !important;
  }

  .object-fit-xl-fill {
    object-fit: fill !important;
  }

  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }

  .object-fit-xl-none {
    object-fit: none !important;
  }

  .d-xl-inline {
    display: inline !important;
  }

  .d-xl-inline-block {
    display: inline-block !important;
  }

  .d-xl-block {
    display: block !important;
  }

  .d-xl-grid {
    display: grid !important;
  }

  .d-xl-inline-grid {
    display: inline-grid !important;
  }

  .d-xl-table {
    display: table !important;
  }

  .d-xl-table-row {
    display: table-row !important;
  }

  .d-xl-table-cell {
    display: table-cell !important;
  }

  .d-xl-flex {
    display: flex !important;
  }

  .d-xl-inline-flex {
    display: inline-flex !important;
  }

  .d-xl-none {
    display: none !important;
  }

  .position-xl-static {
    position: static !important;
  }

  .position-xl-relative {
    position: relative !important;
  }

  .position-xl-absolute {
    position: absolute !important;
  }

  .position-xl-fixed {
    position: fixed !important;
  }

  .position-xl-sticky {
    position: sticky !important;
  }

  .w-xl-unset {
    width: unset !important;
  }

  .w-xl-25 {
    width: 25% !important;
  }

  .w-xl-50 {
    width: 50% !important;
  }

  .w-xl-75 {
    width: 75% !important;
  }

  .w-xl-100 {
    width: 100% !important;
  }

  .w-xl-auto {
    width: auto !important;
  }

  .w-xl-1px {
    width: 1px !important;
  }

  .w-xl-2px {
    width: 2px !important;
  }

  .w-xl-3px {
    width: 3px !important;
  }

  .w-xl-4px {
    width: 4px !important;
  }

  .w-xl-5px {
    width: 5px !important;
  }

  .w-xl-6px {
    width: 6px !important;
  }

  .w-xl-7px {
    width: 7px !important;
  }

  .w-xl-8px {
    width: 8px !important;
  }

  .w-xl-9px {
    width: 9px !important;
  }

  .w-xl-10px {
    width: 10px !important;
  }

  .w-xl-15px {
    width: 15px !important;
  }

  .w-xl-20px {
    width: 20px !important;
  }

  .w-xl-25px {
    width: 25px !important;
  }

  .w-xl-30px {
    width: 30px !important;
  }

  .w-xl-35px {
    width: 35px !important;
  }

  .w-xl-40px {
    width: 40px !important;
  }

  .w-xl-45px {
    width: 45px !important;
  }

  .w-xl-50px {
    width: 50px !important;
  }

  .w-xl-55px {
    width: 55px !important;
  }

  .w-xl-60px {
    width: 60px !important;
  }

  .w-xl-65px {
    width: 65px !important;
  }

  .w-xl-70px {
    width: 70px !important;
  }

  .w-xl-75px {
    width: 75px !important;
  }

  .w-xl-80px {
    width: 80px !important;
  }

  .w-xl-85px {
    width: 85px !important;
  }

  .w-xl-90px {
    width: 90px !important;
  }

  .w-xl-95px {
    width: 95px !important;
  }

  .w-xl-100px {
    width: 100px !important;
  }

  .w-xl-125px {
    width: 125px !important;
  }

  .w-xl-150px {
    width: 150px !important;
  }

  .w-xl-175px {
    width: 175px !important;
  }

  .w-xl-200px {
    width: 200px !important;
  }

  .w-xl-225px {
    width: 225px !important;
  }

  .w-xl-250px {
    width: 250px !important;
  }

  .w-xl-275px {
    width: 275px !important;
  }

  .w-xl-300px {
    width: 300px !important;
  }

  .w-xl-325px {
    width: 325px !important;
  }

  .w-xl-350px {
    width: 350px !important;
  }

  .w-xl-375px {
    width: 375px !important;
  }

  .w-xl-400px {
    width: 400px !important;
  }

  .w-xl-425px {
    width: 425px !important;
  }

  .w-xl-450px {
    width: 450px !important;
  }

  .w-xl-475px {
    width: 475px !important;
  }

  .w-xl-500px {
    width: 500px !important;
  }

  .w-xl-550px {
    width: 550px !important;
  }

  .w-xl-600px {
    width: 600px !important;
  }

  .w-xl-650px {
    width: 650px !important;
  }

  .w-xl-700px {
    width: 700px !important;
  }

  .w-xl-750px {
    width: 750px !important;
  }

  .w-xl-800px {
    width: 800px !important;
  }

  .w-xl-850px {
    width: 850px !important;
  }

  .w-xl-900px {
    width: 900px !important;
  }

  .w-xl-950px {
    width: 950px !important;
  }

  .w-xl-1000px {
    width: 1000px !important;
  }

  .mw-xl-unset {
    max-width: unset !important;
  }

  .mw-xl-25 {
    max-width: 25% !important;
  }

  .mw-xl-50 {
    max-width: 50% !important;
  }

  .mw-xl-75 {
    max-width: 75% !important;
  }

  .mw-xl-100 {
    max-width: 100% !important;
  }

  .mw-xl-auto {
    max-width: auto !important;
  }

  .mw-xl-1px {
    max-width: 1px !important;
  }

  .mw-xl-2px {
    max-width: 2px !important;
  }

  .mw-xl-3px {
    max-width: 3px !important;
  }

  .mw-xl-4px {
    max-width: 4px !important;
  }

  .mw-xl-5px {
    max-width: 5px !important;
  }

  .mw-xl-6px {
    max-width: 6px !important;
  }

  .mw-xl-7px {
    max-width: 7px !important;
  }

  .mw-xl-8px {
    max-width: 8px !important;
  }

  .mw-xl-9px {
    max-width: 9px !important;
  }

  .mw-xl-10px {
    max-width: 10px !important;
  }

  .mw-xl-15px {
    max-width: 15px !important;
  }

  .mw-xl-20px {
    max-width: 20px !important;
  }

  .mw-xl-25px {
    max-width: 25px !important;
  }

  .mw-xl-30px {
    max-width: 30px !important;
  }

  .mw-xl-35px {
    max-width: 35px !important;
  }

  .mw-xl-40px {
    max-width: 40px !important;
  }

  .mw-xl-45px {
    max-width: 45px !important;
  }

  .mw-xl-50px {
    max-width: 50px !important;
  }

  .mw-xl-55px {
    max-width: 55px !important;
  }

  .mw-xl-60px {
    max-width: 60px !important;
  }

  .mw-xl-65px {
    max-width: 65px !important;
  }

  .mw-xl-70px {
    max-width: 70px !important;
  }

  .mw-xl-75px {
    max-width: 75px !important;
  }

  .mw-xl-80px {
    max-width: 80px !important;
  }

  .mw-xl-85px {
    max-width: 85px !important;
  }

  .mw-xl-90px {
    max-width: 90px !important;
  }

  .mw-xl-95px {
    max-width: 95px !important;
  }

  .mw-xl-100px {
    max-width: 100px !important;
  }

  .mw-xl-125px {
    max-width: 125px !important;
  }

  .mw-xl-150px {
    max-width: 150px !important;
  }

  .mw-xl-175px {
    max-width: 175px !important;
  }

  .mw-xl-200px {
    max-width: 200px !important;
  }

  .mw-xl-225px {
    max-width: 225px !important;
  }

  .mw-xl-250px {
    max-width: 250px !important;
  }

  .mw-xl-275px {
    max-width: 275px !important;
  }

  .mw-xl-300px {
    max-width: 300px !important;
  }

  .mw-xl-325px {
    max-width: 325px !important;
  }

  .mw-xl-350px {
    max-width: 350px !important;
  }

  .mw-xl-375px {
    max-width: 375px !important;
  }

  .mw-xl-400px {
    max-width: 400px !important;
  }

  .mw-xl-425px {
    max-width: 425px !important;
  }

  .mw-xl-450px {
    max-width: 450px !important;
  }

  .mw-xl-475px {
    max-width: 475px !important;
  }

  .mw-xl-500px {
    max-width: 500px !important;
  }

  .mw-xl-550px {
    max-width: 550px !important;
  }

  .mw-xl-600px {
    max-width: 600px !important;
  }

  .mw-xl-650px {
    max-width: 650px !important;
  }

  .mw-xl-700px {
    max-width: 700px !important;
  }

  .mw-xl-750px {
    max-width: 750px !important;
  }

  .mw-xl-800px {
    max-width: 800px !important;
  }

  .mw-xl-850px {
    max-width: 850px !important;
  }

  .mw-xl-900px {
    max-width: 900px !important;
  }

  .mw-xl-950px {
    max-width: 950px !important;
  }

  .mw-xl-1000px {
    max-width: 1000px !important;
  }

  .h-xl-unset {
    height: unset !important;
  }

  .h-xl-25 {
    height: 25% !important;
  }

  .h-xl-50 {
    height: 50% !important;
  }

  .h-xl-75 {
    height: 75% !important;
  }

  .h-xl-100 {
    height: 100% !important;
  }

  .h-xl-auto {
    height: auto !important;
  }

  .h-xl-1px {
    height: 1px !important;
  }

  .h-xl-2px {
    height: 2px !important;
  }

  .h-xl-3px {
    height: 3px !important;
  }

  .h-xl-4px {
    height: 4px !important;
  }

  .h-xl-5px {
    height: 5px !important;
  }

  .h-xl-6px {
    height: 6px !important;
  }

  .h-xl-7px {
    height: 7px !important;
  }

  .h-xl-8px {
    height: 8px !important;
  }

  .h-xl-9px {
    height: 9px !important;
  }

  .h-xl-10px {
    height: 10px !important;
  }

  .h-xl-15px {
    height: 15px !important;
  }

  .h-xl-20px {
    height: 20px !important;
  }

  .h-xl-25px {
    height: 25px !important;
  }

  .h-xl-30px {
    height: 30px !important;
  }

  .h-xl-35px {
    height: 35px !important;
  }

  .h-xl-40px {
    height: 40px !important;
  }

  .h-xl-45px {
    height: 45px !important;
  }

  .h-xl-50px {
    height: 50px !important;
  }

  .h-xl-55px {
    height: 55px !important;
  }

  .h-xl-60px {
    height: 60px !important;
  }

  .h-xl-65px {
    height: 65px !important;
  }

  .h-xl-70px {
    height: 70px !important;
  }

  .h-xl-75px {
    height: 75px !important;
  }

  .h-xl-80px {
    height: 80px !important;
  }

  .h-xl-85px {
    height: 85px !important;
  }

  .h-xl-90px {
    height: 90px !important;
  }

  .h-xl-95px {
    height: 95px !important;
  }

  .h-xl-100px {
    height: 100px !important;
  }

  .h-xl-125px {
    height: 125px !important;
  }

  .h-xl-150px {
    height: 150px !important;
  }

  .h-xl-175px {
    height: 175px !important;
  }

  .h-xl-200px {
    height: 200px !important;
  }

  .h-xl-225px {
    height: 225px !important;
  }

  .h-xl-250px {
    height: 250px !important;
  }

  .h-xl-275px {
    height: 275px !important;
  }

  .h-xl-300px {
    height: 300px !important;
  }

  .h-xl-325px {
    height: 325px !important;
  }

  .h-xl-350px {
    height: 350px !important;
  }

  .h-xl-375px {
    height: 375px !important;
  }

  .h-xl-400px {
    height: 400px !important;
  }

  .h-xl-425px {
    height: 425px !important;
  }

  .h-xl-450px {
    height: 450px !important;
  }

  .h-xl-475px {
    height: 475px !important;
  }

  .h-xl-500px {
    height: 500px !important;
  }

  .h-xl-550px {
    height: 550px !important;
  }

  .h-xl-600px {
    height: 600px !important;
  }

  .h-xl-650px {
    height: 650px !important;
  }

  .h-xl-700px {
    height: 700px !important;
  }

  .h-xl-750px {
    height: 750px !important;
  }

  .h-xl-800px {
    height: 800px !important;
  }

  .h-xl-850px {
    height: 850px !important;
  }

  .h-xl-900px {
    height: 900px !important;
  }

  .h-xl-950px {
    height: 950px !important;
  }

  .h-xl-1000px {
    height: 1000px !important;
  }

  .mh-xl-unset {
    max-height: unset !important;
  }

  .mh-xl-25 {
    max-height: 25% !important;
  }

  .mh-xl-50 {
    max-height: 50% !important;
  }

  .mh-xl-75 {
    max-height: 75% !important;
  }

  .mh-xl-100 {
    max-height: 100% !important;
  }

  .mh-xl-auto {
    max-height: auto !important;
  }

  .mh-xl-1px {
    max-height: 1px !important;
  }

  .mh-xl-2px {
    max-height: 2px !important;
  }

  .mh-xl-3px {
    max-height: 3px !important;
  }

  .mh-xl-4px {
    max-height: 4px !important;
  }

  .mh-xl-5px {
    max-height: 5px !important;
  }

  .mh-xl-6px {
    max-height: 6px !important;
  }

  .mh-xl-7px {
    max-height: 7px !important;
  }

  .mh-xl-8px {
    max-height: 8px !important;
  }

  .mh-xl-9px {
    max-height: 9px !important;
  }

  .mh-xl-10px {
    max-height: 10px !important;
  }

  .mh-xl-15px {
    max-height: 15px !important;
  }

  .mh-xl-20px {
    max-height: 20px !important;
  }

  .mh-xl-25px {
    max-height: 25px !important;
  }

  .mh-xl-30px {
    max-height: 30px !important;
  }

  .mh-xl-35px {
    max-height: 35px !important;
  }

  .mh-xl-40px {
    max-height: 40px !important;
  }

  .mh-xl-45px {
    max-height: 45px !important;
  }

  .mh-xl-50px {
    max-height: 50px !important;
  }

  .mh-xl-55px {
    max-height: 55px !important;
  }

  .mh-xl-60px {
    max-height: 60px !important;
  }

  .mh-xl-65px {
    max-height: 65px !important;
  }

  .mh-xl-70px {
    max-height: 70px !important;
  }

  .mh-xl-75px {
    max-height: 75px !important;
  }

  .mh-xl-80px {
    max-height: 80px !important;
  }

  .mh-xl-85px {
    max-height: 85px !important;
  }

  .mh-xl-90px {
    max-height: 90px !important;
  }

  .mh-xl-95px {
    max-height: 95px !important;
  }

  .mh-xl-100px {
    max-height: 100px !important;
  }

  .mh-xl-125px {
    max-height: 125px !important;
  }

  .mh-xl-150px {
    max-height: 150px !important;
  }

  .mh-xl-175px {
    max-height: 175px !important;
  }

  .mh-xl-200px {
    max-height: 200px !important;
  }

  .mh-xl-225px {
    max-height: 225px !important;
  }

  .mh-xl-250px {
    max-height: 250px !important;
  }

  .mh-xl-275px {
    max-height: 275px !important;
  }

  .mh-xl-300px {
    max-height: 300px !important;
  }

  .mh-xl-325px {
    max-height: 325px !important;
  }

  .mh-xl-350px {
    max-height: 350px !important;
  }

  .mh-xl-375px {
    max-height: 375px !important;
  }

  .mh-xl-400px {
    max-height: 400px !important;
  }

  .mh-xl-425px {
    max-height: 425px !important;
  }

  .mh-xl-450px {
    max-height: 450px !important;
  }

  .mh-xl-475px {
    max-height: 475px !important;
  }

  .mh-xl-500px {
    max-height: 500px !important;
  }

  .mh-xl-550px {
    max-height: 550px !important;
  }

  .mh-xl-600px {
    max-height: 600px !important;
  }

  .mh-xl-650px {
    max-height: 650px !important;
  }

  .mh-xl-700px {
    max-height: 700px !important;
  }

  .mh-xl-750px {
    max-height: 750px !important;
  }

  .mh-xl-800px {
    max-height: 800px !important;
  }

  .mh-xl-850px {
    max-height: 850px !important;
  }

  .mh-xl-900px {
    max-height: 900px !important;
  }

  .mh-xl-950px {
    max-height: 950px !important;
  }

  .mh-xl-1000px {
    max-height: 1000px !important;
  }

  .flex-xl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xl-row {
    flex-direction: row !important;
  }

  .flex-xl-column {
    flex-direction: column !important;
  }

  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-xl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xl-center {
    justify-content: center !important;
  }

  .justify-content-xl-between {
    justify-content: space-between !important;
  }

  .justify-content-xl-around {
    justify-content: space-around !important;
  }

  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-xl-start {
    align-items: flex-start !important;
  }

  .align-items-xl-end {
    align-items: flex-end !important;
  }

  .align-items-xl-center {
    align-items: center !important;
  }

  .align-items-xl-baseline {
    align-items: baseline !important;
  }

  .align-items-xl-stretch {
    align-items: stretch !important;
  }

  .align-content-xl-start {
    align-content: flex-start !important;
  }

  .align-content-xl-end {
    align-content: flex-end !important;
  }

  .align-content-xl-center {
    align-content: center !important;
  }

  .align-content-xl-between {
    align-content: space-between !important;
  }

  .align-content-xl-around {
    align-content: space-around !important;
  }

  .align-content-xl-stretch {
    align-content: stretch !important;
  }

  .align-self-xl-auto {
    align-self: auto !important;
  }

  .align-self-xl-start {
    align-self: flex-start !important;
  }

  .align-self-xl-end {
    align-self: flex-end !important;
  }

  .align-self-xl-center {
    align-self: center !important;
  }

  .align-self-xl-baseline {
    align-self: baseline !important;
  }

  .align-self-xl-stretch {
    align-self: stretch !important;
  }

  .order-xl-first {
    order: -1 !important;
  }

  .order-xl-0 {
    order: 0 !important;
  }

  .order-xl-1 {
    order: 1 !important;
  }

  .order-xl-2 {
    order: 2 !important;
  }

  .order-xl-3 {
    order: 3 !important;
  }

  .order-xl-4 {
    order: 4 !important;
  }

  .order-xl-5 {
    order: 5 !important;
  }

  .order-xl-last {
    order: 6 !important;
  }

  .m-xl-0 {
    margin: 0 !important;
  }

  .m-xl-1 {
    margin: 0.25rem !important;
  }

  .m-xl-2 {
    margin: 0.5rem !important;
  }

  .m-xl-3 {
    margin: 0.75rem !important;
  }

  .m-xl-4 {
    margin: 1rem !important;
  }

  .m-xl-5 {
    margin: 1.25rem !important;
  }

  .m-xl-6 {
    margin: 1.5rem !important;
  }

  .m-xl-7 {
    margin: 1.75rem !important;
  }

  .m-xl-8 {
    margin: 2rem !important;
  }

  .m-xl-9 {
    margin: 2.25rem !important;
  }

  .m-xl-10 {
    margin: 2.5rem !important;
  }

  .m-xl-11 {
    margin: 2.75rem !important;
  }

  .m-xl-12 {
    margin: 3rem !important;
  }

  .m-xl-13 {
    margin: 3.25rem !important;
  }

  .m-xl-14 {
    margin: 3.5rem !important;
  }

  .m-xl-15 {
    margin: 3.75rem !important;
  }

  .m-xl-16 {
    margin: 4rem !important;
  }

  .m-xl-17 {
    margin: 4.25rem !important;
  }

  .m-xl-18 {
    margin: 4.5rem !important;
  }

  .m-xl-19 {
    margin: 4.75rem !important;
  }

  .m-xl-20 {
    margin: 5rem !important;
  }

  .m-xl-auto {
    margin: auto !important;
  }

  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-xl-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }

  .mx-xl-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-xl-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }

  .mx-xl-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-xl-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }

  .mx-xl-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }

  .mx-xl-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }

  .mx-xl-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }

  .mx-xl-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }

  .mx-xl-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-xl-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }

  .mx-xl-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }

  .mx-xl-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }

  .mx-xl-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  .mx-xl-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }

  .mx-xl-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }

  .mx-xl-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }

  .mx-xl-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-xl-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }

  .my-xl-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-xl-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }

  .my-xl-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-xl-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }

  .my-xl-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  .my-xl-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }

  .my-xl-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  .my-xl-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }

  .my-xl-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-xl-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }

  .my-xl-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-xl-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }

  .my-xl-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-xl-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }

  .my-xl-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-xl-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }

  .my-xl-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-xl-0 {
    margin-top: 0 !important;
  }

  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }

  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }

  .mt-xl-3 {
    margin-top: 0.75rem !important;
  }

  .mt-xl-4 {
    margin-top: 1rem !important;
  }

  .mt-xl-5 {
    margin-top: 1.25rem !important;
  }

  .mt-xl-6 {
    margin-top: 1.5rem !important;
  }

  .mt-xl-7 {
    margin-top: 1.75rem !important;
  }

  .mt-xl-8 {
    margin-top: 2rem !important;
  }

  .mt-xl-9 {
    margin-top: 2.25rem !important;
  }

  .mt-xl-10 {
    margin-top: 2.5rem !important;
  }

  .mt-xl-11 {
    margin-top: 2.75rem !important;
  }

  .mt-xl-12 {
    margin-top: 3rem !important;
  }

  .mt-xl-13 {
    margin-top: 3.25rem !important;
  }

  .mt-xl-14 {
    margin-top: 3.5rem !important;
  }

  .mt-xl-15 {
    margin-top: 3.75rem !important;
  }

  .mt-xl-16 {
    margin-top: 4rem !important;
  }

  .mt-xl-17 {
    margin-top: 4.25rem !important;
  }

  .mt-xl-18 {
    margin-top: 4.5rem !important;
  }

  .mt-xl-19 {
    margin-top: 4.75rem !important;
  }

  .mt-xl-20 {
    margin-top: 5rem !important;
  }

  .mt-xl-auto {
    margin-top: auto !important;
  }

  .me-xl-0 {
    margin-right: 0 !important;
  }

  .me-xl-1 {
    margin-right: 0.25rem !important;
  }

  .me-xl-2 {
    margin-right: 0.5rem !important;
  }

  .me-xl-3 {
    margin-right: 0.75rem !important;
  }

  .me-xl-4 {
    margin-right: 1rem !important;
  }

  .me-xl-5 {
    margin-right: 1.25rem !important;
  }

  .me-xl-6 {
    margin-right: 1.5rem !important;
  }

  .me-xl-7 {
    margin-right: 1.75rem !important;
  }

  .me-xl-8 {
    margin-right: 2rem !important;
  }

  .me-xl-9 {
    margin-right: 2.25rem !important;
  }

  .me-xl-10 {
    margin-right: 2.5rem !important;
  }

  .me-xl-11 {
    margin-right: 2.75rem !important;
  }

  .me-xl-12 {
    margin-right: 3rem !important;
  }

  .me-xl-13 {
    margin-right: 3.25rem !important;
  }

  .me-xl-14 {
    margin-right: 3.5rem !important;
  }

  .me-xl-15 {
    margin-right: 3.75rem !important;
  }

  .me-xl-16 {
    margin-right: 4rem !important;
  }

  .me-xl-17 {
    margin-right: 4.25rem !important;
  }

  .me-xl-18 {
    margin-right: 4.5rem !important;
  }

  .me-xl-19 {
    margin-right: 4.75rem !important;
  }

  .me-xl-20 {
    margin-right: 5rem !important;
  }

  .me-xl-auto {
    margin-right: auto !important;
  }

  .mb-xl-0 {
    margin-bottom: 0 !important;
  }

  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-xl-3 {
    margin-bottom: 0.75rem !important;
  }

  .mb-xl-4 {
    margin-bottom: 1rem !important;
  }

  .mb-xl-5 {
    margin-bottom: 1.25rem !important;
  }

  .mb-xl-6 {
    margin-bottom: 1.5rem !important;
  }

  .mb-xl-7 {
    margin-bottom: 1.75rem !important;
  }

  .mb-xl-8 {
    margin-bottom: 2rem !important;
  }

  .mb-xl-9 {
    margin-bottom: 2.25rem !important;
  }

  .mb-xl-10 {
    margin-bottom: 2.5rem !important;
  }

  .mb-xl-11 {
    margin-bottom: 2.75rem !important;
  }

  .mb-xl-12 {
    margin-bottom: 3rem !important;
  }

  .mb-xl-13 {
    margin-bottom: 3.25rem !important;
  }

  .mb-xl-14 {
    margin-bottom: 3.5rem !important;
  }

  .mb-xl-15 {
    margin-bottom: 3.75rem !important;
  }

  .mb-xl-16 {
    margin-bottom: 4rem !important;
  }

  .mb-xl-17 {
    margin-bottom: 4.25rem !important;
  }

  .mb-xl-18 {
    margin-bottom: 4.5rem !important;
  }

  .mb-xl-19 {
    margin-bottom: 4.75rem !important;
  }

  .mb-xl-20 {
    margin-bottom: 5rem !important;
  }

  .mb-xl-auto {
    margin-bottom: auto !important;
  }

  .ms-xl-0 {
    margin-left: 0 !important;
  }

  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }

  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }

  .ms-xl-3 {
    margin-left: 0.75rem !important;
  }

  .ms-xl-4 {
    margin-left: 1rem !important;
  }

  .ms-xl-5 {
    margin-left: 1.25rem !important;
  }

  .ms-xl-6 {
    margin-left: 1.5rem !important;
  }

  .ms-xl-7 {
    margin-left: 1.75rem !important;
  }

  .ms-xl-8 {
    margin-left: 2rem !important;
  }

  .ms-xl-9 {
    margin-left: 2.25rem !important;
  }

  .ms-xl-10 {
    margin-left: 2.5rem !important;
  }

  .ms-xl-11 {
    margin-left: 2.75rem !important;
  }

  .ms-xl-12 {
    margin-left: 3rem !important;
  }

  .ms-xl-13 {
    margin-left: 3.25rem !important;
  }

  .ms-xl-14 {
    margin-left: 3.5rem !important;
  }

  .ms-xl-15 {
    margin-left: 3.75rem !important;
  }

  .ms-xl-16 {
    margin-left: 4rem !important;
  }

  .ms-xl-17 {
    margin-left: 4.25rem !important;
  }

  .ms-xl-18 {
    margin-left: 4.5rem !important;
  }

  .ms-xl-19 {
    margin-left: 4.75rem !important;
  }

  .ms-xl-20 {
    margin-left: 5rem !important;
  }

  .ms-xl-auto {
    margin-left: auto !important;
  }

  .m-xl-n1 {
    margin: -0.25rem !important;
  }

  .m-xl-n2 {
    margin: -0.5rem !important;
  }

  .m-xl-n3 {
    margin: -0.75rem !important;
  }

  .m-xl-n4 {
    margin: -1rem !important;
  }

  .m-xl-n5 {
    margin: -1.25rem !important;
  }

  .m-xl-n6 {
    margin: -1.5rem !important;
  }

  .m-xl-n7 {
    margin: -1.75rem !important;
  }

  .m-xl-n8 {
    margin: -2rem !important;
  }

  .m-xl-n9 {
    margin: -2.25rem !important;
  }

  .m-xl-n10 {
    margin: -2.5rem !important;
  }

  .m-xl-n11 {
    margin: -2.75rem !important;
  }

  .m-xl-n12 {
    margin: -3rem !important;
  }

  .m-xl-n13 {
    margin: -3.25rem !important;
  }

  .m-xl-n14 {
    margin: -3.5rem !important;
  }

  .m-xl-n15 {
    margin: -3.75rem !important;
  }

  .m-xl-n16 {
    margin: -4rem !important;
  }

  .m-xl-n17 {
    margin: -4.25rem !important;
  }

  .m-xl-n18 {
    margin: -4.5rem !important;
  }

  .m-xl-n19 {
    margin: -4.75rem !important;
  }

  .m-xl-n20 {
    margin: -5rem !important;
  }

  .mx-xl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-xl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-xl-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }

  .mx-xl-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-xl-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }

  .mx-xl-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-xl-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }

  .mx-xl-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }

  .mx-xl-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }

  .mx-xl-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }

  .mx-xl-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }

  .mx-xl-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .mx-xl-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }

  .mx-xl-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }

  .mx-xl-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }

  .mx-xl-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }

  .mx-xl-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }

  .mx-xl-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }

  .mx-xl-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }

  .mx-xl-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }

  .my-xl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-xl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-xl-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }

  .my-xl-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-xl-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }

  .my-xl-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-xl-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }

  .my-xl-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }

  .my-xl-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }

  .my-xl-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }

  .my-xl-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }

  .my-xl-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .my-xl-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }

  .my-xl-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }

  .my-xl-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }

  .my-xl-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }

  .my-xl-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }

  .my-xl-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }

  .my-xl-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }

  .my-xl-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }

  .mt-xl-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-xl-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-xl-n3 {
    margin-top: -0.75rem !important;
  }

  .mt-xl-n4 {
    margin-top: -1rem !important;
  }

  .mt-xl-n5 {
    margin-top: -1.25rem !important;
  }

  .mt-xl-n6 {
    margin-top: -1.5rem !important;
  }

  .mt-xl-n7 {
    margin-top: -1.75rem !important;
  }

  .mt-xl-n8 {
    margin-top: -2rem !important;
  }

  .mt-xl-n9 {
    margin-top: -2.25rem !important;
  }

  .mt-xl-n10 {
    margin-top: -2.5rem !important;
  }

  .mt-xl-n11 {
    margin-top: -2.75rem !important;
  }

  .mt-xl-n12 {
    margin-top: -3rem !important;
  }

  .mt-xl-n13 {
    margin-top: -3.25rem !important;
  }

  .mt-xl-n14 {
    margin-top: -3.5rem !important;
  }

  .mt-xl-n15 {
    margin-top: -3.75rem !important;
  }

  .mt-xl-n16 {
    margin-top: -4rem !important;
  }

  .mt-xl-n17 {
    margin-top: -4.25rem !important;
  }

  .mt-xl-n18 {
    margin-top: -4.5rem !important;
  }

  .mt-xl-n19 {
    margin-top: -4.75rem !important;
  }

  .mt-xl-n20 {
    margin-top: -5rem !important;
  }

  .me-xl-n1 {
    margin-right: -0.25rem !important;
  }

  .me-xl-n2 {
    margin-right: -0.5rem !important;
  }

  .me-xl-n3 {
    margin-right: -0.75rem !important;
  }

  .me-xl-n4 {
    margin-right: -1rem !important;
  }

  .me-xl-n5 {
    margin-right: -1.25rem !important;
  }

  .me-xl-n6 {
    margin-right: -1.5rem !important;
  }

  .me-xl-n7 {
    margin-right: -1.75rem !important;
  }

  .me-xl-n8 {
    margin-right: -2rem !important;
  }

  .me-xl-n9 {
    margin-right: -2.25rem !important;
  }

  .me-xl-n10 {
    margin-right: -2.5rem !important;
  }

  .me-xl-n11 {
    margin-right: -2.75rem !important;
  }

  .me-xl-n12 {
    margin-right: -3rem !important;
  }

  .me-xl-n13 {
    margin-right: -3.25rem !important;
  }

  .me-xl-n14 {
    margin-right: -3.5rem !important;
  }

  .me-xl-n15 {
    margin-right: -3.75rem !important;
  }

  .me-xl-n16 {
    margin-right: -4rem !important;
  }

  .me-xl-n17 {
    margin-right: -4.25rem !important;
  }

  .me-xl-n18 {
    margin-right: -4.5rem !important;
  }

  .me-xl-n19 {
    margin-right: -4.75rem !important;
  }

  .me-xl-n20 {
    margin-right: -5rem !important;
  }

  .mb-xl-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-xl-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-xl-n3 {
    margin-bottom: -0.75rem !important;
  }

  .mb-xl-n4 {
    margin-bottom: -1rem !important;
  }

  .mb-xl-n5 {
    margin-bottom: -1.25rem !important;
  }

  .mb-xl-n6 {
    margin-bottom: -1.5rem !important;
  }

  .mb-xl-n7 {
    margin-bottom: -1.75rem !important;
  }

  .mb-xl-n8 {
    margin-bottom: -2rem !important;
  }

  .mb-xl-n9 {
    margin-bottom: -2.25rem !important;
  }

  .mb-xl-n10 {
    margin-bottom: -2.5rem !important;
  }

  .mb-xl-n11 {
    margin-bottom: -2.75rem !important;
  }

  .mb-xl-n12 {
    margin-bottom: -3rem !important;
  }

  .mb-xl-n13 {
    margin-bottom: -3.25rem !important;
  }

  .mb-xl-n14 {
    margin-bottom: -3.5rem !important;
  }

  .mb-xl-n15 {
    margin-bottom: -3.75rem !important;
  }

  .mb-xl-n16 {
    margin-bottom: -4rem !important;
  }

  .mb-xl-n17 {
    margin-bottom: -4.25rem !important;
  }

  .mb-xl-n18 {
    margin-bottom: -4.5rem !important;
  }

  .mb-xl-n19 {
    margin-bottom: -4.75rem !important;
  }

  .mb-xl-n20 {
    margin-bottom: -5rem !important;
  }

  .ms-xl-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-xl-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-xl-n3 {
    margin-left: -0.75rem !important;
  }

  .ms-xl-n4 {
    margin-left: -1rem !important;
  }

  .ms-xl-n5 {
    margin-left: -1.25rem !important;
  }

  .ms-xl-n6 {
    margin-left: -1.5rem !important;
  }

  .ms-xl-n7 {
    margin-left: -1.75rem !important;
  }

  .ms-xl-n8 {
    margin-left: -2rem !important;
  }

  .ms-xl-n9 {
    margin-left: -2.25rem !important;
  }

  .ms-xl-n10 {
    margin-left: -2.5rem !important;
  }

  .ms-xl-n11 {
    margin-left: -2.75rem !important;
  }

  .ms-xl-n12 {
    margin-left: -3rem !important;
  }

  .ms-xl-n13 {
    margin-left: -3.25rem !important;
  }

  .ms-xl-n14 {
    margin-left: -3.5rem !important;
  }

  .ms-xl-n15 {
    margin-left: -3.75rem !important;
  }

  .ms-xl-n16 {
    margin-left: -4rem !important;
  }

  .ms-xl-n17 {
    margin-left: -4.25rem !important;
  }

  .ms-xl-n18 {
    margin-left: -4.5rem !important;
  }

  .ms-xl-n19 {
    margin-left: -4.75rem !important;
  }

  .ms-xl-n20 {
    margin-left: -5rem !important;
  }

  .p-xl-0 {
    padding: 0 !important;
  }

  .p-xl-1 {
    padding: 0.25rem !important;
  }

  .p-xl-2 {
    padding: 0.5rem !important;
  }

  .p-xl-3 {
    padding: 0.75rem !important;
  }

  .p-xl-4 {
    padding: 1rem !important;
  }

  .p-xl-5 {
    padding: 1.25rem !important;
  }

  .p-xl-6 {
    padding: 1.5rem !important;
  }

  .p-xl-7 {
    padding: 1.75rem !important;
  }

  .p-xl-8 {
    padding: 2rem !important;
  }

  .p-xl-9 {
    padding: 2.25rem !important;
  }

  .p-xl-10 {
    padding: 2.5rem !important;
  }

  .p-xl-11 {
    padding: 2.75rem !important;
  }

  .p-xl-12 {
    padding: 3rem !important;
  }

  .p-xl-13 {
    padding: 3.25rem !important;
  }

  .p-xl-14 {
    padding: 3.5rem !important;
  }

  .p-xl-15 {
    padding: 3.75rem !important;
  }

  .p-xl-16 {
    padding: 4rem !important;
  }

  .p-xl-17 {
    padding: 4.25rem !important;
  }

  .p-xl-18 {
    padding: 4.5rem !important;
  }

  .p-xl-19 {
    padding: 4.75rem !important;
  }

  .p-xl-20 {
    padding: 5rem !important;
  }

  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-xl-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }

  .px-xl-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-xl-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }

  .px-xl-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-xl-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }

  .px-xl-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }

  .px-xl-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }

  .px-xl-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }

  .px-xl-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }

  .px-xl-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .px-xl-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }

  .px-xl-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }

  .px-xl-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }

  .px-xl-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  .px-xl-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }

  .px-xl-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }

  .px-xl-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }

  .px-xl-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-xl-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  .py-xl-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-xl-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }

  .py-xl-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-xl-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }

  .py-xl-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .py-xl-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }

  .py-xl-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  .py-xl-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }

  .py-xl-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .py-xl-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }

  .py-xl-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-xl-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }

  .py-xl-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-xl-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }

  .py-xl-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-xl-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }

  .py-xl-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .pt-xl-0 {
    padding-top: 0 !important;
  }

  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }

  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }

  .pt-xl-3 {
    padding-top: 0.75rem !important;
  }

  .pt-xl-4 {
    padding-top: 1rem !important;
  }

  .pt-xl-5 {
    padding-top: 1.25rem !important;
  }

  .pt-xl-6 {
    padding-top: 1.5rem !important;
  }

  .pt-xl-7 {
    padding-top: 1.75rem !important;
  }

  .pt-xl-8 {
    padding-top: 2rem !important;
  }

  .pt-xl-9 {
    padding-top: 2.25rem !important;
  }

  .pt-xl-10 {
    padding-top: 2.5rem !important;
  }

  .pt-xl-11 {
    padding-top: 2.75rem !important;
  }

  .pt-xl-12 {
    padding-top: 3rem !important;
  }

  .pt-xl-13 {
    padding-top: 3.25rem !important;
  }

  .pt-xl-14 {
    padding-top: 3.5rem !important;
  }

  .pt-xl-15 {
    padding-top: 3.75rem !important;
  }

  .pt-xl-16 {
    padding-top: 4rem !important;
  }

  .pt-xl-17 {
    padding-top: 4.25rem !important;
  }

  .pt-xl-18 {
    padding-top: 4.5rem !important;
  }

  .pt-xl-19 {
    padding-top: 4.75rem !important;
  }

  .pt-xl-20 {
    padding-top: 5rem !important;
  }

  .pe-xl-0 {
    padding-right: 0 !important;
  }

  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }

  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }

  .pe-xl-3 {
    padding-right: 0.75rem !important;
  }

  .pe-xl-4 {
    padding-right: 1rem !important;
  }

  .pe-xl-5 {
    padding-right: 1.25rem !important;
  }

  .pe-xl-6 {
    padding-right: 1.5rem !important;
  }

  .pe-xl-7 {
    padding-right: 1.75rem !important;
  }

  .pe-xl-8 {
    padding-right: 2rem !important;
  }

  .pe-xl-9 {
    padding-right: 2.25rem !important;
  }

  .pe-xl-10 {
    padding-right: 2.5rem !important;
  }

  .pe-xl-11 {
    padding-right: 2.75rem !important;
  }

  .pe-xl-12 {
    padding-right: 3rem !important;
  }

  .pe-xl-13 {
    padding-right: 3.25rem !important;
  }

  .pe-xl-14 {
    padding-right: 3.5rem !important;
  }

  .pe-xl-15 {
    padding-right: 3.75rem !important;
  }

  .pe-xl-16 {
    padding-right: 4rem !important;
  }

  .pe-xl-17 {
    padding-right: 4.25rem !important;
  }

  .pe-xl-18 {
    padding-right: 4.5rem !important;
  }

  .pe-xl-19 {
    padding-right: 4.75rem !important;
  }

  .pe-xl-20 {
    padding-right: 5rem !important;
  }

  .pb-xl-0 {
    padding-bottom: 0 !important;
  }

  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-xl-3 {
    padding-bottom: 0.75rem !important;
  }

  .pb-xl-4 {
    padding-bottom: 1rem !important;
  }

  .pb-xl-5 {
    padding-bottom: 1.25rem !important;
  }

  .pb-xl-6 {
    padding-bottom: 1.5rem !important;
  }

  .pb-xl-7 {
    padding-bottom: 1.75rem !important;
  }

  .pb-xl-8 {
    padding-bottom: 2rem !important;
  }

  .pb-xl-9 {
    padding-bottom: 2.25rem !important;
  }

  .pb-xl-10 {
    padding-bottom: 2.5rem !important;
  }

  .pb-xl-11 {
    padding-bottom: 2.75rem !important;
  }

  .pb-xl-12 {
    padding-bottom: 3rem !important;
  }

  .pb-xl-13 {
    padding-bottom: 3.25rem !important;
  }

  .pb-xl-14 {
    padding-bottom: 3.5rem !important;
  }

  .pb-xl-15 {
    padding-bottom: 3.75rem !important;
  }

  .pb-xl-16 {
    padding-bottom: 4rem !important;
  }

  .pb-xl-17 {
    padding-bottom: 4.25rem !important;
  }

  .pb-xl-18 {
    padding-bottom: 4.5rem !important;
  }

  .pb-xl-19 {
    padding-bottom: 4.75rem !important;
  }

  .pb-xl-20 {
    padding-bottom: 5rem !important;
  }

  .ps-xl-0 {
    padding-left: 0 !important;
  }

  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }

  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }

  .ps-xl-3 {
    padding-left: 0.75rem !important;
  }

  .ps-xl-4 {
    padding-left: 1rem !important;
  }

  .ps-xl-5 {
    padding-left: 1.25rem !important;
  }

  .ps-xl-6 {
    padding-left: 1.5rem !important;
  }

  .ps-xl-7 {
    padding-left: 1.75rem !important;
  }

  .ps-xl-8 {
    padding-left: 2rem !important;
  }

  .ps-xl-9 {
    padding-left: 2.25rem !important;
  }

  .ps-xl-10 {
    padding-left: 2.5rem !important;
  }

  .ps-xl-11 {
    padding-left: 2.75rem !important;
  }

  .ps-xl-12 {
    padding-left: 3rem !important;
  }

  .ps-xl-13 {
    padding-left: 3.25rem !important;
  }

  .ps-xl-14 {
    padding-left: 3.5rem !important;
  }

  .ps-xl-15 {
    padding-left: 3.75rem !important;
  }

  .ps-xl-16 {
    padding-left: 4rem !important;
  }

  .ps-xl-17 {
    padding-left: 4.25rem !important;
  }

  .ps-xl-18 {
    padding-left: 4.5rem !important;
  }

  .ps-xl-19 {
    padding-left: 4.75rem !important;
  }

  .ps-xl-20 {
    padding-left: 5rem !important;
  }

  .gap-xl-0 {
    gap: 0 !important;
  }

  .gap-xl-1 {
    gap: 0.25rem !important;
  }

  .gap-xl-2 {
    gap: 0.5rem !important;
  }

  .gap-xl-3 {
    gap: 0.75rem !important;
  }

  .gap-xl-4 {
    gap: 1rem !important;
  }

  .gap-xl-5 {
    gap: 1.25rem !important;
  }

  .gap-xl-6 {
    gap: 1.5rem !important;
  }

  .gap-xl-7 {
    gap: 1.75rem !important;
  }

  .gap-xl-8 {
    gap: 2rem !important;
  }

  .gap-xl-9 {
    gap: 2.25rem !important;
  }

  .gap-xl-10 {
    gap: 2.5rem !important;
  }

  .gap-xl-11 {
    gap: 2.75rem !important;
  }

  .gap-xl-12 {
    gap: 3rem !important;
  }

  .gap-xl-13 {
    gap: 3.25rem !important;
  }

  .gap-xl-14 {
    gap: 3.5rem !important;
  }

  .gap-xl-15 {
    gap: 3.75rem !important;
  }

  .gap-xl-16 {
    gap: 4rem !important;
  }

  .gap-xl-17 {
    gap: 4.25rem !important;
  }

  .gap-xl-18 {
    gap: 4.5rem !important;
  }

  .gap-xl-19 {
    gap: 4.75rem !important;
  }

  .gap-xl-20 {
    gap: 5rem !important;
  }

  .row-gap-xl-0 {
    row-gap: 0 !important;
  }

  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-xl-3 {
    row-gap: 0.75rem !important;
  }

  .row-gap-xl-4 {
    row-gap: 1rem !important;
  }

  .row-gap-xl-5 {
    row-gap: 1.25rem !important;
  }

  .row-gap-xl-6 {
    row-gap: 1.5rem !important;
  }

  .row-gap-xl-7 {
    row-gap: 1.75rem !important;
  }

  .row-gap-xl-8 {
    row-gap: 2rem !important;
  }

  .row-gap-xl-9 {
    row-gap: 2.25rem !important;
  }

  .row-gap-xl-10 {
    row-gap: 2.5rem !important;
  }

  .row-gap-xl-11 {
    row-gap: 2.75rem !important;
  }

  .row-gap-xl-12 {
    row-gap: 3rem !important;
  }

  .row-gap-xl-13 {
    row-gap: 3.25rem !important;
  }

  .row-gap-xl-14 {
    row-gap: 3.5rem !important;
  }

  .row-gap-xl-15 {
    row-gap: 3.75rem !important;
  }

  .row-gap-xl-16 {
    row-gap: 4rem !important;
  }

  .row-gap-xl-17 {
    row-gap: 4.25rem !important;
  }

  .row-gap-xl-18 {
    row-gap: 4.5rem !important;
  }

  .row-gap-xl-19 {
    row-gap: 4.75rem !important;
  }

  .row-gap-xl-20 {
    row-gap: 5rem !important;
  }

  .column-gap-xl-0 {
    column-gap: 0 !important;
  }

  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-xl-3 {
    column-gap: 0.75rem !important;
  }

  .column-gap-xl-4 {
    column-gap: 1rem !important;
  }

  .column-gap-xl-5 {
    column-gap: 1.25rem !important;
  }

  .column-gap-xl-6 {
    column-gap: 1.5rem !important;
  }

  .column-gap-xl-7 {
    column-gap: 1.75rem !important;
  }

  .column-gap-xl-8 {
    column-gap: 2rem !important;
  }

  .column-gap-xl-9 {
    column-gap: 2.25rem !important;
  }

  .column-gap-xl-10 {
    column-gap: 2.5rem !important;
  }

  .column-gap-xl-11 {
    column-gap: 2.75rem !important;
  }

  .column-gap-xl-12 {
    column-gap: 3rem !important;
  }

  .column-gap-xl-13 {
    column-gap: 3.25rem !important;
  }

  .column-gap-xl-14 {
    column-gap: 3.5rem !important;
  }

  .column-gap-xl-15 {
    column-gap: 3.75rem !important;
  }

  .column-gap-xl-16 {
    column-gap: 4rem !important;
  }

  .column-gap-xl-17 {
    column-gap: 4.25rem !important;
  }

  .column-gap-xl-18 {
    column-gap: 4.5rem !important;
  }

  .column-gap-xl-19 {
    column-gap: 4.75rem !important;
  }

  .column-gap-xl-20 {
    column-gap: 5rem !important;
  }

  .fs-xl-1 {
    font-size: calc(1.3rem + 0.6vw) !important;
  }

  .fs-xl-2 {
    font-size: calc(1.275rem + 0.3vw) !important;
  }

  .fs-xl-3 {
    font-size: calc(1.26rem + 0.12vw) !important;
  }

  .fs-xl-4 {
    font-size: 1.25rem !important;
  }

  .fs-xl-5 {
    font-size: 1.15rem !important;
  }

  .fs-xl-6 {
    font-size: 1.075rem !important;
  }

  .fs-xl-7 {
    font-size: 0.95rem !important;
  }

  .fs-xl-8 {
    font-size: 0.85rem !important;
  }

  .fs-xl-9 {
    font-size: 0.75rem !important;
  }

  .fs-xl-10 {
    font-size: 0.5rem !important;
  }

  .fs-xl-base {
    font-size: 1rem !important;
  }

  .fs-xl-fluid {
    font-size: 100% !important;
  }

  .fs-xl-2x {
    font-size: calc(1.325rem + 0.9vw) !important;
  }

  .fs-xl-2qx {
    font-size: calc(1.35rem + 1.2vw) !important;
  }

  .fs-xl-2hx {
    font-size: calc(1.375rem + 1.5vw) !important;
  }

  .fs-xl-2tx {
    font-size: calc(1.4rem + 1.8vw) !important;
  }

  .fs-xl-3x {
    font-size: calc(1.425rem + 2.1vw) !important;
  }

  .fs-xl-3qx {
    font-size: calc(1.45rem + 2.4vw) !important;
  }

  .fs-xl-3hx {
    font-size: calc(1.475rem + 2.7vw) !important;
  }

  .fs-xl-3tx {
    font-size: calc(1.5rem + 3vw) !important;
  }

  .fs-xl-4x {
    font-size: calc(1.525rem + 3.3vw) !important;
  }

  .fs-xl-4qx {
    font-size: calc(1.55rem + 3.6vw) !important;
  }

  .fs-xl-4hx {
    font-size: calc(1.575rem + 3.9vw) !important;
  }

  .fs-xl-4tx {
    font-size: calc(1.6rem + 4.2vw) !important;
  }

  .fs-xl-5x {
    font-size: calc(1.625rem + 4.5vw) !important;
  }

  .fs-xl-5qx {
    font-size: calc(1.65rem + 4.8vw) !important;
  }

  .fs-xl-5hx {
    font-size: calc(1.675rem + 5.1vw) !important;
  }

  .fs-xl-5tx {
    font-size: calc(1.7rem + 5.4vw) !important;
  }

  .text-xl-start {
    text-align: left !important;
  }

  .text-xl-end {
    text-align: right !important;
  }

  .text-xl-center {
    text-align: center !important;
  }

  .min-w-xl-unset {
    min-width: unset !important;
  }

  .min-w-xl-25 {
    min-width: 25% !important;
  }

  .min-w-xl-50 {
    min-width: 50% !important;
  }

  .min-w-xl-75 {
    min-width: 75% !important;
  }

  .min-w-xl-100 {
    min-width: 100% !important;
  }

  .min-w-xl-auto {
    min-width: auto !important;
  }

  .min-w-xl-1px {
    min-width: 1px !important;
  }

  .min-w-xl-2px {
    min-width: 2px !important;
  }

  .min-w-xl-3px {
    min-width: 3px !important;
  }

  .min-w-xl-4px {
    min-width: 4px !important;
  }

  .min-w-xl-5px {
    min-width: 5px !important;
  }

  .min-w-xl-6px {
    min-width: 6px !important;
  }

  .min-w-xl-7px {
    min-width: 7px !important;
  }

  .min-w-xl-8px {
    min-width: 8px !important;
  }

  .min-w-xl-9px {
    min-width: 9px !important;
  }

  .min-w-xl-10px {
    min-width: 10px !important;
  }

  .min-w-xl-15px {
    min-width: 15px !important;
  }

  .min-w-xl-20px {
    min-width: 20px !important;
  }

  .min-w-xl-25px {
    min-width: 25px !important;
  }

  .min-w-xl-30px {
    min-width: 30px !important;
  }

  .min-w-xl-35px {
    min-width: 35px !important;
  }

  .min-w-xl-40px {
    min-width: 40px !important;
  }

  .min-w-xl-45px {
    min-width: 45px !important;
  }

  .min-w-xl-50px {
    min-width: 50px !important;
  }

  .min-w-xl-55px {
    min-width: 55px !important;
  }

  .min-w-xl-60px {
    min-width: 60px !important;
  }

  .min-w-xl-65px {
    min-width: 65px !important;
  }

  .min-w-xl-70px {
    min-width: 70px !important;
  }

  .min-w-xl-75px {
    min-width: 75px !important;
  }

  .min-w-xl-80px {
    min-width: 80px !important;
  }

  .min-w-xl-85px {
    min-width: 85px !important;
  }

  .min-w-xl-90px {
    min-width: 90px !important;
  }

  .min-w-xl-95px {
    min-width: 95px !important;
  }

  .min-w-xl-100px {
    min-width: 100px !important;
  }

  .min-w-xl-125px {
    min-width: 125px !important;
  }

  .min-w-xl-150px {
    min-width: 150px !important;
  }

  .min-w-xl-175px {
    min-width: 175px !important;
  }

  .min-w-xl-200px {
    min-width: 200px !important;
  }

  .min-w-xl-225px {
    min-width: 225px !important;
  }

  .min-w-xl-250px {
    min-width: 250px !important;
  }

  .min-w-xl-275px {
    min-width: 275px !important;
  }

  .min-w-xl-300px {
    min-width: 300px !important;
  }

  .min-w-xl-325px {
    min-width: 325px !important;
  }

  .min-w-xl-350px {
    min-width: 350px !important;
  }

  .min-w-xl-375px {
    min-width: 375px !important;
  }

  .min-w-xl-400px {
    min-width: 400px !important;
  }

  .min-w-xl-425px {
    min-width: 425px !important;
  }

  .min-w-xl-450px {
    min-width: 450px !important;
  }

  .min-w-xl-475px {
    min-width: 475px !important;
  }

  .min-w-xl-500px {
    min-width: 500px !important;
  }

  .min-w-xl-550px {
    min-width: 550px !important;
  }

  .min-w-xl-600px {
    min-width: 600px !important;
  }

  .min-w-xl-650px {
    min-width: 650px !important;
  }

  .min-w-xl-700px {
    min-width: 700px !important;
  }

  .min-w-xl-750px {
    min-width: 750px !important;
  }

  .min-w-xl-800px {
    min-width: 800px !important;
  }

  .min-w-xl-850px {
    min-width: 850px !important;
  }

  .min-w-xl-900px {
    min-width: 900px !important;
  }

  .min-w-xl-950px {
    min-width: 950px !important;
  }

  .min-w-xl-1000px {
    min-width: 1000px !important;
  }

  .min-h-xl-unset {
    min-height: unset !important;
  }

  .min-h-xl-25 {
    min-height: 25% !important;
  }

  .min-h-xl-50 {
    min-height: 50% !important;
  }

  .min-h-xl-75 {
    min-height: 75% !important;
  }

  .min-h-xl-100 {
    min-height: 100% !important;
  }

  .min-h-xl-auto {
    min-height: auto !important;
  }

  .min-h-xl-1px {
    min-height: 1px !important;
  }

  .min-h-xl-2px {
    min-height: 2px !important;
  }

  .min-h-xl-3px {
    min-height: 3px !important;
  }

  .min-h-xl-4px {
    min-height: 4px !important;
  }

  .min-h-xl-5px {
    min-height: 5px !important;
  }

  .min-h-xl-6px {
    min-height: 6px !important;
  }

  .min-h-xl-7px {
    min-height: 7px !important;
  }

  .min-h-xl-8px {
    min-height: 8px !important;
  }

  .min-h-xl-9px {
    min-height: 9px !important;
  }

  .min-h-xl-10px {
    min-height: 10px !important;
  }

  .min-h-xl-15px {
    min-height: 15px !important;
  }

  .min-h-xl-20px {
    min-height: 20px !important;
  }

  .min-h-xl-25px {
    min-height: 25px !important;
  }

  .min-h-xl-30px {
    min-height: 30px !important;
  }

  .min-h-xl-35px {
    min-height: 35px !important;
  }

  .min-h-xl-40px {
    min-height: 40px !important;
  }

  .min-h-xl-45px {
    min-height: 45px !important;
  }

  .min-h-xl-50px {
    min-height: 50px !important;
  }

  .min-h-xl-55px {
    min-height: 55px !important;
  }

  .min-h-xl-60px {
    min-height: 60px !important;
  }

  .min-h-xl-65px {
    min-height: 65px !important;
  }

  .min-h-xl-70px {
    min-height: 70px !important;
  }

  .min-h-xl-75px {
    min-height: 75px !important;
  }

  .min-h-xl-80px {
    min-height: 80px !important;
  }

  .min-h-xl-85px {
    min-height: 85px !important;
  }

  .min-h-xl-90px {
    min-height: 90px !important;
  }

  .min-h-xl-95px {
    min-height: 95px !important;
  }

  .min-h-xl-100px {
    min-height: 100px !important;
  }

  .min-h-xl-125px {
    min-height: 125px !important;
  }

  .min-h-xl-150px {
    min-height: 150px !important;
  }

  .min-h-xl-175px {
    min-height: 175px !important;
  }

  .min-h-xl-200px {
    min-height: 200px !important;
  }

  .min-h-xl-225px {
    min-height: 225px !important;
  }

  .min-h-xl-250px {
    min-height: 250px !important;
  }

  .min-h-xl-275px {
    min-height: 275px !important;
  }

  .min-h-xl-300px {
    min-height: 300px !important;
  }

  .min-h-xl-325px {
    min-height: 325px !important;
  }

  .min-h-xl-350px {
    min-height: 350px !important;
  }

  .min-h-xl-375px {
    min-height: 375px !important;
  }

  .min-h-xl-400px {
    min-height: 400px !important;
  }

  .min-h-xl-425px {
    min-height: 425px !important;
  }

  .min-h-xl-450px {
    min-height: 450px !important;
  }

  .min-h-xl-475px {
    min-height: 475px !important;
  }

  .min-h-xl-500px {
    min-height: 500px !important;
  }

  .min-h-xl-550px {
    min-height: 550px !important;
  }

  .min-h-xl-600px {
    min-height: 600px !important;
  }

  .min-h-xl-650px {
    min-height: 650px !important;
  }

  .min-h-xl-700px {
    min-height: 700px !important;
  }

  .min-h-xl-750px {
    min-height: 750px !important;
  }

  .min-h-xl-800px {
    min-height: 800px !important;
  }

  .min-h-xl-850px {
    min-height: 850px !important;
  }

  .min-h-xl-900px {
    min-height: 900px !important;
  }

  .min-h-xl-950px {
    min-height: 950px !important;
  }

  .min-h-xl-1000px {
    min-height: 1000px !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }

  .float-xxl-end {
    float: right !important;
  }

  .float-xxl-none {
    float: none !important;
  }

  .object-fit-xxl-contain {
    object-fit: contain !important;
  }

  .object-fit-xxl-cover {
    object-fit: cover !important;
  }

  .object-fit-xxl-fill {
    object-fit: fill !important;
  }

  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }

  .object-fit-xxl-none {
    object-fit: none !important;
  }

  .d-xxl-inline {
    display: inline !important;
  }

  .d-xxl-inline-block {
    display: inline-block !important;
  }

  .d-xxl-block {
    display: block !important;
  }

  .d-xxl-grid {
    display: grid !important;
  }

  .d-xxl-inline-grid {
    display: inline-grid !important;
  }

  .d-xxl-table {
    display: table !important;
  }

  .d-xxl-table-row {
    display: table-row !important;
  }

  .d-xxl-table-cell {
    display: table-cell !important;
  }

  .d-xxl-flex {
    display: flex !important;
  }

  .d-xxl-inline-flex {
    display: inline-flex !important;
  }

  .d-xxl-none {
    display: none !important;
  }

  .position-xxl-static {
    position: static !important;
  }

  .position-xxl-relative {
    position: relative !important;
  }

  .position-xxl-absolute {
    position: absolute !important;
  }

  .position-xxl-fixed {
    position: fixed !important;
  }

  .position-xxl-sticky {
    position: sticky !important;
  }

  .w-xxl-unset {
    width: unset !important;
  }

  .w-xxl-25 {
    width: 25% !important;
  }

  .w-xxl-50 {
    width: 50% !important;
  }

  .w-xxl-75 {
    width: 75% !important;
  }

  .w-xxl-100 {
    width: 100% !important;
  }

  .w-xxl-auto {
    width: auto !important;
  }

  .w-xxl-1px {
    width: 1px !important;
  }

  .w-xxl-2px {
    width: 2px !important;
  }

  .w-xxl-3px {
    width: 3px !important;
  }

  .w-xxl-4px {
    width: 4px !important;
  }

  .w-xxl-5px {
    width: 5px !important;
  }

  .w-xxl-6px {
    width: 6px !important;
  }

  .w-xxl-7px {
    width: 7px !important;
  }

  .w-xxl-8px {
    width: 8px !important;
  }

  .w-xxl-9px {
    width: 9px !important;
  }

  .w-xxl-10px {
    width: 10px !important;
  }

  .w-xxl-15px {
    width: 15px !important;
  }

  .w-xxl-20px {
    width: 20px !important;
  }

  .w-xxl-25px {
    width: 25px !important;
  }

  .w-xxl-30px {
    width: 30px !important;
  }

  .w-xxl-35px {
    width: 35px !important;
  }

  .w-xxl-40px {
    width: 40px !important;
  }

  .w-xxl-45px {
    width: 45px !important;
  }

  .w-xxl-50px {
    width: 50px !important;
  }

  .w-xxl-55px {
    width: 55px !important;
  }

  .w-xxl-60px {
    width: 60px !important;
  }

  .w-xxl-65px {
    width: 65px !important;
  }

  .w-xxl-70px {
    width: 70px !important;
  }

  .w-xxl-75px {
    width: 75px !important;
  }

  .w-xxl-80px {
    width: 80px !important;
  }

  .w-xxl-85px {
    width: 85px !important;
  }

  .w-xxl-90px {
    width: 90px !important;
  }

  .w-xxl-95px {
    width: 95px !important;
  }

  .w-xxl-100px {
    width: 100px !important;
  }

  .w-xxl-125px {
    width: 125px !important;
  }

  .w-xxl-150px {
    width: 150px !important;
  }

  .w-xxl-175px {
    width: 175px !important;
  }

  .w-xxl-200px {
    width: 200px !important;
  }

  .w-xxl-225px {
    width: 225px !important;
  }

  .w-xxl-250px {
    width: 250px !important;
  }

  .w-xxl-275px {
    width: 275px !important;
  }

  .w-xxl-300px {
    width: 300px !important;
  }

  .w-xxl-325px {
    width: 325px !important;
  }

  .w-xxl-350px {
    width: 350px !important;
  }

  .w-xxl-375px {
    width: 375px !important;
  }

  .w-xxl-400px {
    width: 400px !important;
  }

  .w-xxl-425px {
    width: 425px !important;
  }

  .w-xxl-450px {
    width: 450px !important;
  }

  .w-xxl-475px {
    width: 475px !important;
  }

  .w-xxl-500px {
    width: 500px !important;
  }

  .w-xxl-550px {
    width: 550px !important;
  }

  .w-xxl-600px {
    width: 600px !important;
  }

  .w-xxl-650px {
    width: 650px !important;
  }

  .w-xxl-700px {
    width: 700px !important;
  }

  .w-xxl-750px {
    width: 750px !important;
  }

  .w-xxl-800px {
    width: 800px !important;
  }

  .w-xxl-850px {
    width: 850px !important;
  }

  .w-xxl-900px {
    width: 900px !important;
  }

  .w-xxl-950px {
    width: 950px !important;
  }

  .w-xxl-1000px {
    width: 1000px !important;
  }

  .mw-xxl-unset {
    max-width: unset !important;
  }

  .mw-xxl-25 {
    max-width: 25% !important;
  }

  .mw-xxl-50 {
    max-width: 50% !important;
  }

  .mw-xxl-75 {
    max-width: 75% !important;
  }

  .mw-xxl-100 {
    max-width: 100% !important;
  }

  .mw-xxl-auto {
    max-width: auto !important;
  }

  .mw-xxl-1px {
    max-width: 1px !important;
  }

  .mw-xxl-2px {
    max-width: 2px !important;
  }

  .mw-xxl-3px {
    max-width: 3px !important;
  }

  .mw-xxl-4px {
    max-width: 4px !important;
  }

  .mw-xxl-5px {
    max-width: 5px !important;
  }

  .mw-xxl-6px {
    max-width: 6px !important;
  }

  .mw-xxl-7px {
    max-width: 7px !important;
  }

  .mw-xxl-8px {
    max-width: 8px !important;
  }

  .mw-xxl-9px {
    max-width: 9px !important;
  }

  .mw-xxl-10px {
    max-width: 10px !important;
  }

  .mw-xxl-15px {
    max-width: 15px !important;
  }

  .mw-xxl-20px {
    max-width: 20px !important;
  }

  .mw-xxl-25px {
    max-width: 25px !important;
  }

  .mw-xxl-30px {
    max-width: 30px !important;
  }

  .mw-xxl-35px {
    max-width: 35px !important;
  }

  .mw-xxl-40px {
    max-width: 40px !important;
  }

  .mw-xxl-45px {
    max-width: 45px !important;
  }

  .mw-xxl-50px {
    max-width: 50px !important;
  }

  .mw-xxl-55px {
    max-width: 55px !important;
  }

  .mw-xxl-60px {
    max-width: 60px !important;
  }

  .mw-xxl-65px {
    max-width: 65px !important;
  }

  .mw-xxl-70px {
    max-width: 70px !important;
  }

  .mw-xxl-75px {
    max-width: 75px !important;
  }

  .mw-xxl-80px {
    max-width: 80px !important;
  }

  .mw-xxl-85px {
    max-width: 85px !important;
  }

  .mw-xxl-90px {
    max-width: 90px !important;
  }

  .mw-xxl-95px {
    max-width: 95px !important;
  }

  .mw-xxl-100px {
    max-width: 100px !important;
  }

  .mw-xxl-125px {
    max-width: 125px !important;
  }

  .mw-xxl-150px {
    max-width: 150px !important;
  }

  .mw-xxl-175px {
    max-width: 175px !important;
  }

  .mw-xxl-200px {
    max-width: 200px !important;
  }

  .mw-xxl-225px {
    max-width: 225px !important;
  }

  .mw-xxl-250px {
    max-width: 250px !important;
  }

  .mw-xxl-275px {
    max-width: 275px !important;
  }

  .mw-xxl-300px {
    max-width: 300px !important;
  }

  .mw-xxl-325px {
    max-width: 325px !important;
  }

  .mw-xxl-350px {
    max-width: 350px !important;
  }

  .mw-xxl-375px {
    max-width: 375px !important;
  }

  .mw-xxl-400px {
    max-width: 400px !important;
  }

  .mw-xxl-425px {
    max-width: 425px !important;
  }

  .mw-xxl-450px {
    max-width: 450px !important;
  }

  .mw-xxl-475px {
    max-width: 475px !important;
  }

  .mw-xxl-500px {
    max-width: 500px !important;
  }

  .mw-xxl-550px {
    max-width: 550px !important;
  }

  .mw-xxl-600px {
    max-width: 600px !important;
  }

  .mw-xxl-650px {
    max-width: 650px !important;
  }

  .mw-xxl-700px {
    max-width: 700px !important;
  }

  .mw-xxl-750px {
    max-width: 750px !important;
  }

  .mw-xxl-800px {
    max-width: 800px !important;
  }

  .mw-xxl-850px {
    max-width: 850px !important;
  }

  .mw-xxl-900px {
    max-width: 900px !important;
  }

  .mw-xxl-950px {
    max-width: 950px !important;
  }

  .mw-xxl-1000px {
    max-width: 1000px !important;
  }

  .h-xxl-unset {
    height: unset !important;
  }

  .h-xxl-25 {
    height: 25% !important;
  }

  .h-xxl-50 {
    height: 50% !important;
  }

  .h-xxl-75 {
    height: 75% !important;
  }

  .h-xxl-100 {
    height: 100% !important;
  }

  .h-xxl-auto {
    height: auto !important;
  }

  .h-xxl-1px {
    height: 1px !important;
  }

  .h-xxl-2px {
    height: 2px !important;
  }

  .h-xxl-3px {
    height: 3px !important;
  }

  .h-xxl-4px {
    height: 4px !important;
  }

  .h-xxl-5px {
    height: 5px !important;
  }

  .h-xxl-6px {
    height: 6px !important;
  }

  .h-xxl-7px {
    height: 7px !important;
  }

  .h-xxl-8px {
    height: 8px !important;
  }

  .h-xxl-9px {
    height: 9px !important;
  }

  .h-xxl-10px {
    height: 10px !important;
  }

  .h-xxl-15px {
    height: 15px !important;
  }

  .h-xxl-20px {
    height: 20px !important;
  }

  .h-xxl-25px {
    height: 25px !important;
  }

  .h-xxl-30px {
    height: 30px !important;
  }

  .h-xxl-35px {
    height: 35px !important;
  }

  .h-xxl-40px {
    height: 40px !important;
  }

  .h-xxl-45px {
    height: 45px !important;
  }

  .h-xxl-50px {
    height: 50px !important;
  }

  .h-xxl-55px {
    height: 55px !important;
  }

  .h-xxl-60px {
    height: 60px !important;
  }

  .h-xxl-65px {
    height: 65px !important;
  }

  .h-xxl-70px {
    height: 70px !important;
  }

  .h-xxl-75px {
    height: 75px !important;
  }

  .h-xxl-80px {
    height: 80px !important;
  }

  .h-xxl-85px {
    height: 85px !important;
  }

  .h-xxl-90px {
    height: 90px !important;
  }

  .h-xxl-95px {
    height: 95px !important;
  }

  .h-xxl-100px {
    height: 100px !important;
  }

  .h-xxl-125px {
    height: 125px !important;
  }

  .h-xxl-150px {
    height: 150px !important;
  }

  .h-xxl-175px {
    height: 175px !important;
  }

  .h-xxl-200px {
    height: 200px !important;
  }

  .h-xxl-225px {
    height: 225px !important;
  }

  .h-xxl-250px {
    height: 250px !important;
  }

  .h-xxl-275px {
    height: 275px !important;
  }

  .h-xxl-300px {
    height: 300px !important;
  }

  .h-xxl-325px {
    height: 325px !important;
  }

  .h-xxl-350px {
    height: 350px !important;
  }

  .h-xxl-375px {
    height: 375px !important;
  }

  .h-xxl-400px {
    height: 400px !important;
  }

  .h-xxl-425px {
    height: 425px !important;
  }

  .h-xxl-450px {
    height: 450px !important;
  }

  .h-xxl-475px {
    height: 475px !important;
  }

  .h-xxl-500px {
    height: 500px !important;
  }

  .h-xxl-550px {
    height: 550px !important;
  }

  .h-xxl-600px {
    height: 600px !important;
  }

  .h-xxl-650px {
    height: 650px !important;
  }

  .h-xxl-700px {
    height: 700px !important;
  }

  .h-xxl-750px {
    height: 750px !important;
  }

  .h-xxl-800px {
    height: 800px !important;
  }

  .h-xxl-850px {
    height: 850px !important;
  }

  .h-xxl-900px {
    height: 900px !important;
  }

  .h-xxl-950px {
    height: 950px !important;
  }

  .h-xxl-1000px {
    height: 1000px !important;
  }

  .mh-xxl-unset {
    max-height: unset !important;
  }

  .mh-xxl-25 {
    max-height: 25% !important;
  }

  .mh-xxl-50 {
    max-height: 50% !important;
  }

  .mh-xxl-75 {
    max-height: 75% !important;
  }

  .mh-xxl-100 {
    max-height: 100% !important;
  }

  .mh-xxl-auto {
    max-height: auto !important;
  }

  .mh-xxl-1px {
    max-height: 1px !important;
  }

  .mh-xxl-2px {
    max-height: 2px !important;
  }

  .mh-xxl-3px {
    max-height: 3px !important;
  }

  .mh-xxl-4px {
    max-height: 4px !important;
  }

  .mh-xxl-5px {
    max-height: 5px !important;
  }

  .mh-xxl-6px {
    max-height: 6px !important;
  }

  .mh-xxl-7px {
    max-height: 7px !important;
  }

  .mh-xxl-8px {
    max-height: 8px !important;
  }

  .mh-xxl-9px {
    max-height: 9px !important;
  }

  .mh-xxl-10px {
    max-height: 10px !important;
  }

  .mh-xxl-15px {
    max-height: 15px !important;
  }

  .mh-xxl-20px {
    max-height: 20px !important;
  }

  .mh-xxl-25px {
    max-height: 25px !important;
  }

  .mh-xxl-30px {
    max-height: 30px !important;
  }

  .mh-xxl-35px {
    max-height: 35px !important;
  }

  .mh-xxl-40px {
    max-height: 40px !important;
  }

  .mh-xxl-45px {
    max-height: 45px !important;
  }

  .mh-xxl-50px {
    max-height: 50px !important;
  }

  .mh-xxl-55px {
    max-height: 55px !important;
  }

  .mh-xxl-60px {
    max-height: 60px !important;
  }

  .mh-xxl-65px {
    max-height: 65px !important;
  }

  .mh-xxl-70px {
    max-height: 70px !important;
  }

  .mh-xxl-75px {
    max-height: 75px !important;
  }

  .mh-xxl-80px {
    max-height: 80px !important;
  }

  .mh-xxl-85px {
    max-height: 85px !important;
  }

  .mh-xxl-90px {
    max-height: 90px !important;
  }

  .mh-xxl-95px {
    max-height: 95px !important;
  }

  .mh-xxl-100px {
    max-height: 100px !important;
  }

  .mh-xxl-125px {
    max-height: 125px !important;
  }

  .mh-xxl-150px {
    max-height: 150px !important;
  }

  .mh-xxl-175px {
    max-height: 175px !important;
  }

  .mh-xxl-200px {
    max-height: 200px !important;
  }

  .mh-xxl-225px {
    max-height: 225px !important;
  }

  .mh-xxl-250px {
    max-height: 250px !important;
  }

  .mh-xxl-275px {
    max-height: 275px !important;
  }

  .mh-xxl-300px {
    max-height: 300px !important;
  }

  .mh-xxl-325px {
    max-height: 325px !important;
  }

  .mh-xxl-350px {
    max-height: 350px !important;
  }

  .mh-xxl-375px {
    max-height: 375px !important;
  }

  .mh-xxl-400px {
    max-height: 400px !important;
  }

  .mh-xxl-425px {
    max-height: 425px !important;
  }

  .mh-xxl-450px {
    max-height: 450px !important;
  }

  .mh-xxl-475px {
    max-height: 475px !important;
  }

  .mh-xxl-500px {
    max-height: 500px !important;
  }

  .mh-xxl-550px {
    max-height: 550px !important;
  }

  .mh-xxl-600px {
    max-height: 600px !important;
  }

  .mh-xxl-650px {
    max-height: 650px !important;
  }

  .mh-xxl-700px {
    max-height: 700px !important;
  }

  .mh-xxl-750px {
    max-height: 750px !important;
  }

  .mh-xxl-800px {
    max-height: 800px !important;
  }

  .mh-xxl-850px {
    max-height: 850px !important;
  }

  .mh-xxl-900px {
    max-height: 900px !important;
  }

  .mh-xxl-950px {
    max-height: 950px !important;
  }

  .mh-xxl-1000px {
    max-height: 1000px !important;
  }

  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xxl-row {
    flex-direction: row !important;
  }

  .flex-xxl-column {
    flex-direction: column !important;
  }

  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xxl-center {
    justify-content: center !important;
  }

  .justify-content-xxl-between {
    justify-content: space-between !important;
  }

  .justify-content-xxl-around {
    justify-content: space-around !important;
  }

  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-xxl-start {
    align-items: flex-start !important;
  }

  .align-items-xxl-end {
    align-items: flex-end !important;
  }

  .align-items-xxl-center {
    align-items: center !important;
  }

  .align-items-xxl-baseline {
    align-items: baseline !important;
  }

  .align-items-xxl-stretch {
    align-items: stretch !important;
  }

  .align-content-xxl-start {
    align-content: flex-start !important;
  }

  .align-content-xxl-end {
    align-content: flex-end !important;
  }

  .align-content-xxl-center {
    align-content: center !important;
  }

  .align-content-xxl-between {
    align-content: space-between !important;
  }

  .align-content-xxl-around {
    align-content: space-around !important;
  }

  .align-content-xxl-stretch {
    align-content: stretch !important;
  }

  .align-self-xxl-auto {
    align-self: auto !important;
  }

  .align-self-xxl-start {
    align-self: flex-start !important;
  }

  .align-self-xxl-end {
    align-self: flex-end !important;
  }

  .align-self-xxl-center {
    align-self: center !important;
  }

  .align-self-xxl-baseline {
    align-self: baseline !important;
  }

  .align-self-xxl-stretch {
    align-self: stretch !important;
  }

  .order-xxl-first {
    order: -1 !important;
  }

  .order-xxl-0 {
    order: 0 !important;
  }

  .order-xxl-1 {
    order: 1 !important;
  }

  .order-xxl-2 {
    order: 2 !important;
  }

  .order-xxl-3 {
    order: 3 !important;
  }

  .order-xxl-4 {
    order: 4 !important;
  }

  .order-xxl-5 {
    order: 5 !important;
  }

  .order-xxl-last {
    order: 6 !important;
  }

  .m-xxl-0 {
    margin: 0 !important;
  }

  .m-xxl-1 {
    margin: 0.25rem !important;
  }

  .m-xxl-2 {
    margin: 0.5rem !important;
  }

  .m-xxl-3 {
    margin: 0.75rem !important;
  }

  .m-xxl-4 {
    margin: 1rem !important;
  }

  .m-xxl-5 {
    margin: 1.25rem !important;
  }

  .m-xxl-6 {
    margin: 1.5rem !important;
  }

  .m-xxl-7 {
    margin: 1.75rem !important;
  }

  .m-xxl-8 {
    margin: 2rem !important;
  }

  .m-xxl-9 {
    margin: 2.25rem !important;
  }

  .m-xxl-10 {
    margin: 2.5rem !important;
  }

  .m-xxl-11 {
    margin: 2.75rem !important;
  }

  .m-xxl-12 {
    margin: 3rem !important;
  }

  .m-xxl-13 {
    margin: 3.25rem !important;
  }

  .m-xxl-14 {
    margin: 3.5rem !important;
  }

  .m-xxl-15 {
    margin: 3.75rem !important;
  }

  .m-xxl-16 {
    margin: 4rem !important;
  }

  .m-xxl-17 {
    margin: 4.25rem !important;
  }

  .m-xxl-18 {
    margin: 4.5rem !important;
  }

  .m-xxl-19 {
    margin: 4.75rem !important;
  }

  .m-xxl-20 {
    margin: 5rem !important;
  }

  .m-xxl-auto {
    margin: auto !important;
  }

  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-xxl-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }

  .mx-xxl-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-xxl-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }

  .mx-xxl-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-xxl-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }

  .mx-xxl-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }

  .mx-xxl-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }

  .mx-xxl-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }

  .mx-xxl-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }

  .mx-xxl-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-xxl-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }

  .mx-xxl-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }

  .mx-xxl-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }

  .mx-xxl-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  .mx-xxl-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }

  .mx-xxl-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }

  .mx-xxl-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }

  .mx-xxl-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-xxl-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }

  .my-xxl-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-xxl-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }

  .my-xxl-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-xxl-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }

  .my-xxl-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  .my-xxl-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }

  .my-xxl-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  .my-xxl-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }

  .my-xxl-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-xxl-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }

  .my-xxl-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-xxl-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }

  .my-xxl-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-xxl-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }

  .my-xxl-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-xxl-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }

  .my-xxl-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-xxl-0 {
    margin-top: 0 !important;
  }

  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }

  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }

  .mt-xxl-3 {
    margin-top: 0.75rem !important;
  }

  .mt-xxl-4 {
    margin-top: 1rem !important;
  }

  .mt-xxl-5 {
    margin-top: 1.25rem !important;
  }

  .mt-xxl-6 {
    margin-top: 1.5rem !important;
  }

  .mt-xxl-7 {
    margin-top: 1.75rem !important;
  }

  .mt-xxl-8 {
    margin-top: 2rem !important;
  }

  .mt-xxl-9 {
    margin-top: 2.25rem !important;
  }

  .mt-xxl-10 {
    margin-top: 2.5rem !important;
  }

  .mt-xxl-11 {
    margin-top: 2.75rem !important;
  }

  .mt-xxl-12 {
    margin-top: 3rem !important;
  }

  .mt-xxl-13 {
    margin-top: 3.25rem !important;
  }

  .mt-xxl-14 {
    margin-top: 3.5rem !important;
  }

  .mt-xxl-15 {
    margin-top: 3.75rem !important;
  }

  .mt-xxl-16 {
    margin-top: 4rem !important;
  }

  .mt-xxl-17 {
    margin-top: 4.25rem !important;
  }

  .mt-xxl-18 {
    margin-top: 4.5rem !important;
  }

  .mt-xxl-19 {
    margin-top: 4.75rem !important;
  }

  .mt-xxl-20 {
    margin-top: 5rem !important;
  }

  .mt-xxl-auto {
    margin-top: auto !important;
  }

  .me-xxl-0 {
    margin-right: 0 !important;
  }

  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }

  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }

  .me-xxl-3 {
    margin-right: 0.75rem !important;
  }

  .me-xxl-4 {
    margin-right: 1rem !important;
  }

  .me-xxl-5 {
    margin-right: 1.25rem !important;
  }

  .me-xxl-6 {
    margin-right: 1.5rem !important;
  }

  .me-xxl-7 {
    margin-right: 1.75rem !important;
  }

  .me-xxl-8 {
    margin-right: 2rem !important;
  }

  .me-xxl-9 {
    margin-right: 2.25rem !important;
  }

  .me-xxl-10 {
    margin-right: 2.5rem !important;
  }

  .me-xxl-11 {
    margin-right: 2.75rem !important;
  }

  .me-xxl-12 {
    margin-right: 3rem !important;
  }

  .me-xxl-13 {
    margin-right: 3.25rem !important;
  }

  .me-xxl-14 {
    margin-right: 3.5rem !important;
  }

  .me-xxl-15 {
    margin-right: 3.75rem !important;
  }

  .me-xxl-16 {
    margin-right: 4rem !important;
  }

  .me-xxl-17 {
    margin-right: 4.25rem !important;
  }

  .me-xxl-18 {
    margin-right: 4.5rem !important;
  }

  .me-xxl-19 {
    margin-right: 4.75rem !important;
  }

  .me-xxl-20 {
    margin-right: 5rem !important;
  }

  .me-xxl-auto {
    margin-right: auto !important;
  }

  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }

  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-xxl-3 {
    margin-bottom: 0.75rem !important;
  }

  .mb-xxl-4 {
    margin-bottom: 1rem !important;
  }

  .mb-xxl-5 {
    margin-bottom: 1.25rem !important;
  }

  .mb-xxl-6 {
    margin-bottom: 1.5rem !important;
  }

  .mb-xxl-7 {
    margin-bottom: 1.75rem !important;
  }

  .mb-xxl-8 {
    margin-bottom: 2rem !important;
  }

  .mb-xxl-9 {
    margin-bottom: 2.25rem !important;
  }

  .mb-xxl-10 {
    margin-bottom: 2.5rem !important;
  }

  .mb-xxl-11 {
    margin-bottom: 2.75rem !important;
  }

  .mb-xxl-12 {
    margin-bottom: 3rem !important;
  }

  .mb-xxl-13 {
    margin-bottom: 3.25rem !important;
  }

  .mb-xxl-14 {
    margin-bottom: 3.5rem !important;
  }

  .mb-xxl-15 {
    margin-bottom: 3.75rem !important;
  }

  .mb-xxl-16 {
    margin-bottom: 4rem !important;
  }

  .mb-xxl-17 {
    margin-bottom: 4.25rem !important;
  }

  .mb-xxl-18 {
    margin-bottom: 4.5rem !important;
  }

  .mb-xxl-19 {
    margin-bottom: 4.75rem !important;
  }

  .mb-xxl-20 {
    margin-bottom: 5rem !important;
  }

  .mb-xxl-auto {
    margin-bottom: auto !important;
  }

  .ms-xxl-0 {
    margin-left: 0 !important;
  }

  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }

  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }

  .ms-xxl-3 {
    margin-left: 0.75rem !important;
  }

  .ms-xxl-4 {
    margin-left: 1rem !important;
  }

  .ms-xxl-5 {
    margin-left: 1.25rem !important;
  }

  .ms-xxl-6 {
    margin-left: 1.5rem !important;
  }

  .ms-xxl-7 {
    margin-left: 1.75rem !important;
  }

  .ms-xxl-8 {
    margin-left: 2rem !important;
  }

  .ms-xxl-9 {
    margin-left: 2.25rem !important;
  }

  .ms-xxl-10 {
    margin-left: 2.5rem !important;
  }

  .ms-xxl-11 {
    margin-left: 2.75rem !important;
  }

  .ms-xxl-12 {
    margin-left: 3rem !important;
  }

  .ms-xxl-13 {
    margin-left: 3.25rem !important;
  }

  .ms-xxl-14 {
    margin-left: 3.5rem !important;
  }

  .ms-xxl-15 {
    margin-left: 3.75rem !important;
  }

  .ms-xxl-16 {
    margin-left: 4rem !important;
  }

  .ms-xxl-17 {
    margin-left: 4.25rem !important;
  }

  .ms-xxl-18 {
    margin-left: 4.5rem !important;
  }

  .ms-xxl-19 {
    margin-left: 4.75rem !important;
  }

  .ms-xxl-20 {
    margin-left: 5rem !important;
  }

  .ms-xxl-auto {
    margin-left: auto !important;
  }

  .m-xxl-n1 {
    margin: -0.25rem !important;
  }

  .m-xxl-n2 {
    margin: -0.5rem !important;
  }

  .m-xxl-n3 {
    margin: -0.75rem !important;
  }

  .m-xxl-n4 {
    margin: -1rem !important;
  }

  .m-xxl-n5 {
    margin: -1.25rem !important;
  }

  .m-xxl-n6 {
    margin: -1.5rem !important;
  }

  .m-xxl-n7 {
    margin: -1.75rem !important;
  }

  .m-xxl-n8 {
    margin: -2rem !important;
  }

  .m-xxl-n9 {
    margin: -2.25rem !important;
  }

  .m-xxl-n10 {
    margin: -2.5rem !important;
  }

  .m-xxl-n11 {
    margin: -2.75rem !important;
  }

  .m-xxl-n12 {
    margin: -3rem !important;
  }

  .m-xxl-n13 {
    margin: -3.25rem !important;
  }

  .m-xxl-n14 {
    margin: -3.5rem !important;
  }

  .m-xxl-n15 {
    margin: -3.75rem !important;
  }

  .m-xxl-n16 {
    margin: -4rem !important;
  }

  .m-xxl-n17 {
    margin: -4.25rem !important;
  }

  .m-xxl-n18 {
    margin: -4.5rem !important;
  }

  .m-xxl-n19 {
    margin: -4.75rem !important;
  }

  .m-xxl-n20 {
    margin: -5rem !important;
  }

  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-xxl-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }

  .mx-xxl-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-xxl-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }

  .mx-xxl-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-xxl-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }

  .mx-xxl-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }

  .mx-xxl-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }

  .mx-xxl-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }

  .mx-xxl-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }

  .mx-xxl-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .mx-xxl-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }

  .mx-xxl-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }

  .mx-xxl-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }

  .mx-xxl-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }

  .mx-xxl-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }

  .mx-xxl-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }

  .mx-xxl-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }

  .mx-xxl-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }

  .my-xxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-xxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-xxl-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }

  .my-xxl-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-xxl-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }

  .my-xxl-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-xxl-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }

  .my-xxl-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }

  .my-xxl-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }

  .my-xxl-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }

  .my-xxl-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }

  .my-xxl-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .my-xxl-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }

  .my-xxl-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }

  .my-xxl-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }

  .my-xxl-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }

  .my-xxl-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }

  .my-xxl-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }

  .my-xxl-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }

  .my-xxl-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }

  .mt-xxl-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-xxl-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-xxl-n3 {
    margin-top: -0.75rem !important;
  }

  .mt-xxl-n4 {
    margin-top: -1rem !important;
  }

  .mt-xxl-n5 {
    margin-top: -1.25rem !important;
  }

  .mt-xxl-n6 {
    margin-top: -1.5rem !important;
  }

  .mt-xxl-n7 {
    margin-top: -1.75rem !important;
  }

  .mt-xxl-n8 {
    margin-top: -2rem !important;
  }

  .mt-xxl-n9 {
    margin-top: -2.25rem !important;
  }

  .mt-xxl-n10 {
    margin-top: -2.5rem !important;
  }

  .mt-xxl-n11 {
    margin-top: -2.75rem !important;
  }

  .mt-xxl-n12 {
    margin-top: -3rem !important;
  }

  .mt-xxl-n13 {
    margin-top: -3.25rem !important;
  }

  .mt-xxl-n14 {
    margin-top: -3.5rem !important;
  }

  .mt-xxl-n15 {
    margin-top: -3.75rem !important;
  }

  .mt-xxl-n16 {
    margin-top: -4rem !important;
  }

  .mt-xxl-n17 {
    margin-top: -4.25rem !important;
  }

  .mt-xxl-n18 {
    margin-top: -4.5rem !important;
  }

  .mt-xxl-n19 {
    margin-top: -4.75rem !important;
  }

  .mt-xxl-n20 {
    margin-top: -5rem !important;
  }

  .me-xxl-n1 {
    margin-right: -0.25rem !important;
  }

  .me-xxl-n2 {
    margin-right: -0.5rem !important;
  }

  .me-xxl-n3 {
    margin-right: -0.75rem !important;
  }

  .me-xxl-n4 {
    margin-right: -1rem !important;
  }

  .me-xxl-n5 {
    margin-right: -1.25rem !important;
  }

  .me-xxl-n6 {
    margin-right: -1.5rem !important;
  }

  .me-xxl-n7 {
    margin-right: -1.75rem !important;
  }

  .me-xxl-n8 {
    margin-right: -2rem !important;
  }

  .me-xxl-n9 {
    margin-right: -2.25rem !important;
  }

  .me-xxl-n10 {
    margin-right: -2.5rem !important;
  }

  .me-xxl-n11 {
    margin-right: -2.75rem !important;
  }

  .me-xxl-n12 {
    margin-right: -3rem !important;
  }

  .me-xxl-n13 {
    margin-right: -3.25rem !important;
  }

  .me-xxl-n14 {
    margin-right: -3.5rem !important;
  }

  .me-xxl-n15 {
    margin-right: -3.75rem !important;
  }

  .me-xxl-n16 {
    margin-right: -4rem !important;
  }

  .me-xxl-n17 {
    margin-right: -4.25rem !important;
  }

  .me-xxl-n18 {
    margin-right: -4.5rem !important;
  }

  .me-xxl-n19 {
    margin-right: -4.75rem !important;
  }

  .me-xxl-n20 {
    margin-right: -5rem !important;
  }

  .mb-xxl-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-xxl-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-xxl-n3 {
    margin-bottom: -0.75rem !important;
  }

  .mb-xxl-n4 {
    margin-bottom: -1rem !important;
  }

  .mb-xxl-n5 {
    margin-bottom: -1.25rem !important;
  }

  .mb-xxl-n6 {
    margin-bottom: -1.5rem !important;
  }

  .mb-xxl-n7 {
    margin-bottom: -1.75rem !important;
  }

  .mb-xxl-n8 {
    margin-bottom: -2rem !important;
  }

  .mb-xxl-n9 {
    margin-bottom: -2.25rem !important;
  }

  .mb-xxl-n10 {
    margin-bottom: -2.5rem !important;
  }

  .mb-xxl-n11 {
    margin-bottom: -2.75rem !important;
  }

  .mb-xxl-n12 {
    margin-bottom: -3rem !important;
  }

  .mb-xxl-n13 {
    margin-bottom: -3.25rem !important;
  }

  .mb-xxl-n14 {
    margin-bottom: -3.5rem !important;
  }

  .mb-xxl-n15 {
    margin-bottom: -3.75rem !important;
  }

  .mb-xxl-n16 {
    margin-bottom: -4rem !important;
  }

  .mb-xxl-n17 {
    margin-bottom: -4.25rem !important;
  }

  .mb-xxl-n18 {
    margin-bottom: -4.5rem !important;
  }

  .mb-xxl-n19 {
    margin-bottom: -4.75rem !important;
  }

  .mb-xxl-n20 {
    margin-bottom: -5rem !important;
  }

  .ms-xxl-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-xxl-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-xxl-n3 {
    margin-left: -0.75rem !important;
  }

  .ms-xxl-n4 {
    margin-left: -1rem !important;
  }

  .ms-xxl-n5 {
    margin-left: -1.25rem !important;
  }

  .ms-xxl-n6 {
    margin-left: -1.5rem !important;
  }

  .ms-xxl-n7 {
    margin-left: -1.75rem !important;
  }

  .ms-xxl-n8 {
    margin-left: -2rem !important;
  }

  .ms-xxl-n9 {
    margin-left: -2.25rem !important;
  }

  .ms-xxl-n10 {
    margin-left: -2.5rem !important;
  }

  .ms-xxl-n11 {
    margin-left: -2.75rem !important;
  }

  .ms-xxl-n12 {
    margin-left: -3rem !important;
  }

  .ms-xxl-n13 {
    margin-left: -3.25rem !important;
  }

  .ms-xxl-n14 {
    margin-left: -3.5rem !important;
  }

  .ms-xxl-n15 {
    margin-left: -3.75rem !important;
  }

  .ms-xxl-n16 {
    margin-left: -4rem !important;
  }

  .ms-xxl-n17 {
    margin-left: -4.25rem !important;
  }

  .ms-xxl-n18 {
    margin-left: -4.5rem !important;
  }

  .ms-xxl-n19 {
    margin-left: -4.75rem !important;
  }

  .ms-xxl-n20 {
    margin-left: -5rem !important;
  }

  .p-xxl-0 {
    padding: 0 !important;
  }

  .p-xxl-1 {
    padding: 0.25rem !important;
  }

  .p-xxl-2 {
    padding: 0.5rem !important;
  }

  .p-xxl-3 {
    padding: 0.75rem !important;
  }

  .p-xxl-4 {
    padding: 1rem !important;
  }

  .p-xxl-5 {
    padding: 1.25rem !important;
  }

  .p-xxl-6 {
    padding: 1.5rem !important;
  }

  .p-xxl-7 {
    padding: 1.75rem !important;
  }

  .p-xxl-8 {
    padding: 2rem !important;
  }

  .p-xxl-9 {
    padding: 2.25rem !important;
  }

  .p-xxl-10 {
    padding: 2.5rem !important;
  }

  .p-xxl-11 {
    padding: 2.75rem !important;
  }

  .p-xxl-12 {
    padding: 3rem !important;
  }

  .p-xxl-13 {
    padding: 3.25rem !important;
  }

  .p-xxl-14 {
    padding: 3.5rem !important;
  }

  .p-xxl-15 {
    padding: 3.75rem !important;
  }

  .p-xxl-16 {
    padding: 4rem !important;
  }

  .p-xxl-17 {
    padding: 4.25rem !important;
  }

  .p-xxl-18 {
    padding: 4.5rem !important;
  }

  .p-xxl-19 {
    padding: 4.75rem !important;
  }

  .p-xxl-20 {
    padding: 5rem !important;
  }

  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-xxl-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }

  .px-xxl-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-xxl-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }

  .px-xxl-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-xxl-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }

  .px-xxl-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }

  .px-xxl-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }

  .px-xxl-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }

  .px-xxl-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }

  .px-xxl-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .px-xxl-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }

  .px-xxl-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }

  .px-xxl-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }

  .px-xxl-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  .px-xxl-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }

  .px-xxl-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }

  .px-xxl-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }

  .px-xxl-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-xxl-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  .py-xxl-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-xxl-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }

  .py-xxl-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-xxl-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }

  .py-xxl-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .py-xxl-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }

  .py-xxl-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  .py-xxl-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }

  .py-xxl-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .py-xxl-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }

  .py-xxl-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-xxl-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }

  .py-xxl-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-xxl-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }

  .py-xxl-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-xxl-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }

  .py-xxl-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .pt-xxl-0 {
    padding-top: 0 !important;
  }

  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }

  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }

  .pt-xxl-3 {
    padding-top: 0.75rem !important;
  }

  .pt-xxl-4 {
    padding-top: 1rem !important;
  }

  .pt-xxl-5 {
    padding-top: 1.25rem !important;
  }

  .pt-xxl-6 {
    padding-top: 1.5rem !important;
  }

  .pt-xxl-7 {
    padding-top: 1.75rem !important;
  }

  .pt-xxl-8 {
    padding-top: 2rem !important;
  }

  .pt-xxl-9 {
    padding-top: 2.25rem !important;
  }

  .pt-xxl-10 {
    padding-top: 2.5rem !important;
  }

  .pt-xxl-11 {
    padding-top: 2.75rem !important;
  }

  .pt-xxl-12 {
    padding-top: 3rem !important;
  }

  .pt-xxl-13 {
    padding-top: 3.25rem !important;
  }

  .pt-xxl-14 {
    padding-top: 3.5rem !important;
  }

  .pt-xxl-15 {
    padding-top: 3.75rem !important;
  }

  .pt-xxl-16 {
    padding-top: 4rem !important;
  }

  .pt-xxl-17 {
    padding-top: 4.25rem !important;
  }

  .pt-xxl-18 {
    padding-top: 4.5rem !important;
  }

  .pt-xxl-19 {
    padding-top: 4.75rem !important;
  }

  .pt-xxl-20 {
    padding-top: 5rem !important;
  }

  .pe-xxl-0 {
    padding-right: 0 !important;
  }

  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }

  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }

  .pe-xxl-3 {
    padding-right: 0.75rem !important;
  }

  .pe-xxl-4 {
    padding-right: 1rem !important;
  }

  .pe-xxl-5 {
    padding-right: 1.25rem !important;
  }

  .pe-xxl-6 {
    padding-right: 1.5rem !important;
  }

  .pe-xxl-7 {
    padding-right: 1.75rem !important;
  }

  .pe-xxl-8 {
    padding-right: 2rem !important;
  }

  .pe-xxl-9 {
    padding-right: 2.25rem !important;
  }

  .pe-xxl-10 {
    padding-right: 2.5rem !important;
  }

  .pe-xxl-11 {
    padding-right: 2.75rem !important;
  }

  .pe-xxl-12 {
    padding-right: 3rem !important;
  }

  .pe-xxl-13 {
    padding-right: 3.25rem !important;
  }

  .pe-xxl-14 {
    padding-right: 3.5rem !important;
  }

  .pe-xxl-15 {
    padding-right: 3.75rem !important;
  }

  .pe-xxl-16 {
    padding-right: 4rem !important;
  }

  .pe-xxl-17 {
    padding-right: 4.25rem !important;
  }

  .pe-xxl-18 {
    padding-right: 4.5rem !important;
  }

  .pe-xxl-19 {
    padding-right: 4.75rem !important;
  }

  .pe-xxl-20 {
    padding-right: 5rem !important;
  }

  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }

  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-xxl-3 {
    padding-bottom: 0.75rem !important;
  }

  .pb-xxl-4 {
    padding-bottom: 1rem !important;
  }

  .pb-xxl-5 {
    padding-bottom: 1.25rem !important;
  }

  .pb-xxl-6 {
    padding-bottom: 1.5rem !important;
  }

  .pb-xxl-7 {
    padding-bottom: 1.75rem !important;
  }

  .pb-xxl-8 {
    padding-bottom: 2rem !important;
  }

  .pb-xxl-9 {
    padding-bottom: 2.25rem !important;
  }

  .pb-xxl-10 {
    padding-bottom: 2.5rem !important;
  }

  .pb-xxl-11 {
    padding-bottom: 2.75rem !important;
  }

  .pb-xxl-12 {
    padding-bottom: 3rem !important;
  }

  .pb-xxl-13 {
    padding-bottom: 3.25rem !important;
  }

  .pb-xxl-14 {
    padding-bottom: 3.5rem !important;
  }

  .pb-xxl-15 {
    padding-bottom: 3.75rem !important;
  }

  .pb-xxl-16 {
    padding-bottom: 4rem !important;
  }

  .pb-xxl-17 {
    padding-bottom: 4.25rem !important;
  }

  .pb-xxl-18 {
    padding-bottom: 4.5rem !important;
  }

  .pb-xxl-19 {
    padding-bottom: 4.75rem !important;
  }

  .pb-xxl-20 {
    padding-bottom: 5rem !important;
  }

  .ps-xxl-0 {
    padding-left: 0 !important;
  }

  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }

  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }

  .ps-xxl-3 {
    padding-left: 0.75rem !important;
  }

  .ps-xxl-4 {
    padding-left: 1rem !important;
  }

  .ps-xxl-5 {
    padding-left: 1.25rem !important;
  }

  .ps-xxl-6 {
    padding-left: 1.5rem !important;
  }

  .ps-xxl-7 {
    padding-left: 1.75rem !important;
  }

  .ps-xxl-8 {
    padding-left: 2rem !important;
  }

  .ps-xxl-9 {
    padding-left: 2.25rem !important;
  }

  .ps-xxl-10 {
    padding-left: 2.5rem !important;
  }

  .ps-xxl-11 {
    padding-left: 2.75rem !important;
  }

  .ps-xxl-12 {
    padding-left: 3rem !important;
  }

  .ps-xxl-13 {
    padding-left: 3.25rem !important;
  }

  .ps-xxl-14 {
    padding-left: 3.5rem !important;
  }

  .ps-xxl-15 {
    padding-left: 3.75rem !important;
  }

  .ps-xxl-16 {
    padding-left: 4rem !important;
  }

  .ps-xxl-17 {
    padding-left: 4.25rem !important;
  }

  .ps-xxl-18 {
    padding-left: 4.5rem !important;
  }

  .ps-xxl-19 {
    padding-left: 4.75rem !important;
  }

  .ps-xxl-20 {
    padding-left: 5rem !important;
  }

  .gap-xxl-0 {
    gap: 0 !important;
  }

  .gap-xxl-1 {
    gap: 0.25rem !important;
  }

  .gap-xxl-2 {
    gap: 0.5rem !important;
  }

  .gap-xxl-3 {
    gap: 0.75rem !important;
  }

  .gap-xxl-4 {
    gap: 1rem !important;
  }

  .gap-xxl-5 {
    gap: 1.25rem !important;
  }

  .gap-xxl-6 {
    gap: 1.5rem !important;
  }

  .gap-xxl-7 {
    gap: 1.75rem !important;
  }

  .gap-xxl-8 {
    gap: 2rem !important;
  }

  .gap-xxl-9 {
    gap: 2.25rem !important;
  }

  .gap-xxl-10 {
    gap: 2.5rem !important;
  }

  .gap-xxl-11 {
    gap: 2.75rem !important;
  }

  .gap-xxl-12 {
    gap: 3rem !important;
  }

  .gap-xxl-13 {
    gap: 3.25rem !important;
  }

  .gap-xxl-14 {
    gap: 3.5rem !important;
  }

  .gap-xxl-15 {
    gap: 3.75rem !important;
  }

  .gap-xxl-16 {
    gap: 4rem !important;
  }

  .gap-xxl-17 {
    gap: 4.25rem !important;
  }

  .gap-xxl-18 {
    gap: 4.5rem !important;
  }

  .gap-xxl-19 {
    gap: 4.75rem !important;
  }

  .gap-xxl-20 {
    gap: 5rem !important;
  }

  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }

  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-xxl-3 {
    row-gap: 0.75rem !important;
  }

  .row-gap-xxl-4 {
    row-gap: 1rem !important;
  }

  .row-gap-xxl-5 {
    row-gap: 1.25rem !important;
  }

  .row-gap-xxl-6 {
    row-gap: 1.5rem !important;
  }

  .row-gap-xxl-7 {
    row-gap: 1.75rem !important;
  }

  .row-gap-xxl-8 {
    row-gap: 2rem !important;
  }

  .row-gap-xxl-9 {
    row-gap: 2.25rem !important;
  }

  .row-gap-xxl-10 {
    row-gap: 2.5rem !important;
  }

  .row-gap-xxl-11 {
    row-gap: 2.75rem !important;
  }

  .row-gap-xxl-12 {
    row-gap: 3rem !important;
  }

  .row-gap-xxl-13 {
    row-gap: 3.25rem !important;
  }

  .row-gap-xxl-14 {
    row-gap: 3.5rem !important;
  }

  .row-gap-xxl-15 {
    row-gap: 3.75rem !important;
  }

  .row-gap-xxl-16 {
    row-gap: 4rem !important;
  }

  .row-gap-xxl-17 {
    row-gap: 4.25rem !important;
  }

  .row-gap-xxl-18 {
    row-gap: 4.5rem !important;
  }

  .row-gap-xxl-19 {
    row-gap: 4.75rem !important;
  }

  .row-gap-xxl-20 {
    row-gap: 5rem !important;
  }

  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }

  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-xxl-3 {
    column-gap: 0.75rem !important;
  }

  .column-gap-xxl-4 {
    column-gap: 1rem !important;
  }

  .column-gap-xxl-5 {
    column-gap: 1.25rem !important;
  }

  .column-gap-xxl-6 {
    column-gap: 1.5rem !important;
  }

  .column-gap-xxl-7 {
    column-gap: 1.75rem !important;
  }

  .column-gap-xxl-8 {
    column-gap: 2rem !important;
  }

  .column-gap-xxl-9 {
    column-gap: 2.25rem !important;
  }

  .column-gap-xxl-10 {
    column-gap: 2.5rem !important;
  }

  .column-gap-xxl-11 {
    column-gap: 2.75rem !important;
  }

  .column-gap-xxl-12 {
    column-gap: 3rem !important;
  }

  .column-gap-xxl-13 {
    column-gap: 3.25rem !important;
  }

  .column-gap-xxl-14 {
    column-gap: 3.5rem !important;
  }

  .column-gap-xxl-15 {
    column-gap: 3.75rem !important;
  }

  .column-gap-xxl-16 {
    column-gap: 4rem !important;
  }

  .column-gap-xxl-17 {
    column-gap: 4.25rem !important;
  }

  .column-gap-xxl-18 {
    column-gap: 4.5rem !important;
  }

  .column-gap-xxl-19 {
    column-gap: 4.75rem !important;
  }

  .column-gap-xxl-20 {
    column-gap: 5rem !important;
  }

  .fs-xxl-1 {
    font-size: calc(1.3rem + 0.6vw) !important;
  }

  .fs-xxl-2 {
    font-size: calc(1.275rem + 0.3vw) !important;
  }

  .fs-xxl-3 {
    font-size: calc(1.26rem + 0.12vw) !important;
  }

  .fs-xxl-4 {
    font-size: 1.25rem !important;
  }

  .fs-xxl-5 {
    font-size: 1.15rem !important;
  }

  .fs-xxl-6 {
    font-size: 1.075rem !important;
  }

  .fs-xxl-7 {
    font-size: 0.95rem !important;
  }

  .fs-xxl-8 {
    font-size: 0.85rem !important;
  }

  .fs-xxl-9 {
    font-size: 0.75rem !important;
  }

  .fs-xxl-10 {
    font-size: 0.5rem !important;
  }

  .fs-xxl-base {
    font-size: 1rem !important;
  }

  .fs-xxl-fluid {
    font-size: 100% !important;
  }

  .fs-xxl-2x {
    font-size: calc(1.325rem + 0.9vw) !important;
  }

  .fs-xxl-2qx {
    font-size: calc(1.35rem + 1.2vw) !important;
  }

  .fs-xxl-2hx {
    font-size: calc(1.375rem + 1.5vw) !important;
  }

  .fs-xxl-2tx {
    font-size: calc(1.4rem + 1.8vw) !important;
  }

  .fs-xxl-3x {
    font-size: calc(1.425rem + 2.1vw) !important;
  }

  .fs-xxl-3qx {
    font-size: calc(1.45rem + 2.4vw) !important;
  }

  .fs-xxl-3hx {
    font-size: calc(1.475rem + 2.7vw) !important;
  }

  .fs-xxl-3tx {
    font-size: calc(1.5rem + 3vw) !important;
  }

  .fs-xxl-4x {
    font-size: calc(1.525rem + 3.3vw) !important;
  }

  .fs-xxl-4qx {
    font-size: calc(1.55rem + 3.6vw) !important;
  }

  .fs-xxl-4hx {
    font-size: calc(1.575rem + 3.9vw) !important;
  }

  .fs-xxl-4tx {
    font-size: calc(1.6rem + 4.2vw) !important;
  }

  .fs-xxl-5x {
    font-size: calc(1.625rem + 4.5vw) !important;
  }

  .fs-xxl-5qx {
    font-size: calc(1.65rem + 4.8vw) !important;
  }

  .fs-xxl-5hx {
    font-size: calc(1.675rem + 5.1vw) !important;
  }

  .fs-xxl-5tx {
    font-size: calc(1.7rem + 5.4vw) !important;
  }

  .text-xxl-start {
    text-align: left !important;
  }

  .text-xxl-end {
    text-align: right !important;
  }

  .text-xxl-center {
    text-align: center !important;
  }

  .min-w-xxl-unset {
    min-width: unset !important;
  }

  .min-w-xxl-25 {
    min-width: 25% !important;
  }

  .min-w-xxl-50 {
    min-width: 50% !important;
  }

  .min-w-xxl-75 {
    min-width: 75% !important;
  }

  .min-w-xxl-100 {
    min-width: 100% !important;
  }

  .min-w-xxl-auto {
    min-width: auto !important;
  }

  .min-w-xxl-1px {
    min-width: 1px !important;
  }

  .min-w-xxl-2px {
    min-width: 2px !important;
  }

  .min-w-xxl-3px {
    min-width: 3px !important;
  }

  .min-w-xxl-4px {
    min-width: 4px !important;
  }

  .min-w-xxl-5px {
    min-width: 5px !important;
  }

  .min-w-xxl-6px {
    min-width: 6px !important;
  }

  .min-w-xxl-7px {
    min-width: 7px !important;
  }

  .min-w-xxl-8px {
    min-width: 8px !important;
  }

  .min-w-xxl-9px {
    min-width: 9px !important;
  }

  .min-w-xxl-10px {
    min-width: 10px !important;
  }

  .min-w-xxl-15px {
    min-width: 15px !important;
  }

  .min-w-xxl-20px {
    min-width: 20px !important;
  }

  .min-w-xxl-25px {
    min-width: 25px !important;
  }

  .min-w-xxl-30px {
    min-width: 30px !important;
  }

  .min-w-xxl-35px {
    min-width: 35px !important;
  }

  .min-w-xxl-40px {
    min-width: 40px !important;
  }

  .min-w-xxl-45px {
    min-width: 45px !important;
  }

  .min-w-xxl-50px {
    min-width: 50px !important;
  }

  .min-w-xxl-55px {
    min-width: 55px !important;
  }

  .min-w-xxl-60px {
    min-width: 60px !important;
  }

  .min-w-xxl-65px {
    min-width: 65px !important;
  }

  .min-w-xxl-70px {
    min-width: 70px !important;
  }

  .min-w-xxl-75px {
    min-width: 75px !important;
  }

  .min-w-xxl-80px {
    min-width: 80px !important;
  }

  .min-w-xxl-85px {
    min-width: 85px !important;
  }

  .min-w-xxl-90px {
    min-width: 90px !important;
  }

  .min-w-xxl-95px {
    min-width: 95px !important;
  }

  .min-w-xxl-100px {
    min-width: 100px !important;
  }

  .min-w-xxl-125px {
    min-width: 125px !important;
  }

  .min-w-xxl-150px {
    min-width: 150px !important;
  }

  .min-w-xxl-175px {
    min-width: 175px !important;
  }

  .min-w-xxl-200px {
    min-width: 200px !important;
  }

  .min-w-xxl-225px {
    min-width: 225px !important;
  }

  .min-w-xxl-250px {
    min-width: 250px !important;
  }

  .min-w-xxl-275px {
    min-width: 275px !important;
  }

  .min-w-xxl-300px {
    min-width: 300px !important;
  }

  .min-w-xxl-325px {
    min-width: 325px !important;
  }

  .min-w-xxl-350px {
    min-width: 350px !important;
  }

  .min-w-xxl-375px {
    min-width: 375px !important;
  }

  .min-w-xxl-400px {
    min-width: 400px !important;
  }

  .min-w-xxl-425px {
    min-width: 425px !important;
  }

  .min-w-xxl-450px {
    min-width: 450px !important;
  }

  .min-w-xxl-475px {
    min-width: 475px !important;
  }

  .min-w-xxl-500px {
    min-width: 500px !important;
  }

  .min-w-xxl-550px {
    min-width: 550px !important;
  }

  .min-w-xxl-600px {
    min-width: 600px !important;
  }

  .min-w-xxl-650px {
    min-width: 650px !important;
  }

  .min-w-xxl-700px {
    min-width: 700px !important;
  }

  .min-w-xxl-750px {
    min-width: 750px !important;
  }

  .min-w-xxl-800px {
    min-width: 800px !important;
  }

  .min-w-xxl-850px {
    min-width: 850px !important;
  }

  .min-w-xxl-900px {
    min-width: 900px !important;
  }

  .min-w-xxl-950px {
    min-width: 950px !important;
  }

  .min-w-xxl-1000px {
    min-width: 1000px !important;
  }

  .min-h-xxl-unset {
    min-height: unset !important;
  }

  .min-h-xxl-25 {
    min-height: 25% !important;
  }

  .min-h-xxl-50 {
    min-height: 50% !important;
  }

  .min-h-xxl-75 {
    min-height: 75% !important;
  }

  .min-h-xxl-100 {
    min-height: 100% !important;
  }

  .min-h-xxl-auto {
    min-height: auto !important;
  }

  .min-h-xxl-1px {
    min-height: 1px !important;
  }

  .min-h-xxl-2px {
    min-height: 2px !important;
  }

  .min-h-xxl-3px {
    min-height: 3px !important;
  }

  .min-h-xxl-4px {
    min-height: 4px !important;
  }

  .min-h-xxl-5px {
    min-height: 5px !important;
  }

  .min-h-xxl-6px {
    min-height: 6px !important;
  }

  .min-h-xxl-7px {
    min-height: 7px !important;
  }

  .min-h-xxl-8px {
    min-height: 8px !important;
  }

  .min-h-xxl-9px {
    min-height: 9px !important;
  }

  .min-h-xxl-10px {
    min-height: 10px !important;
  }

  .min-h-xxl-15px {
    min-height: 15px !important;
  }

  .min-h-xxl-20px {
    min-height: 20px !important;
  }

  .min-h-xxl-25px {
    min-height: 25px !important;
  }

  .min-h-xxl-30px {
    min-height: 30px !important;
  }

  .min-h-xxl-35px {
    min-height: 35px !important;
  }

  .min-h-xxl-40px {
    min-height: 40px !important;
  }

  .min-h-xxl-45px {
    min-height: 45px !important;
  }

  .min-h-xxl-50px {
    min-height: 50px !important;
  }

  .min-h-xxl-55px {
    min-height: 55px !important;
  }

  .min-h-xxl-60px {
    min-height: 60px !important;
  }

  .min-h-xxl-65px {
    min-height: 65px !important;
  }

  .min-h-xxl-70px {
    min-height: 70px !important;
  }

  .min-h-xxl-75px {
    min-height: 75px !important;
  }

  .min-h-xxl-80px {
    min-height: 80px !important;
  }

  .min-h-xxl-85px {
    min-height: 85px !important;
  }

  .min-h-xxl-90px {
    min-height: 90px !important;
  }

  .min-h-xxl-95px {
    min-height: 95px !important;
  }

  .min-h-xxl-100px {
    min-height: 100px !important;
  }

  .min-h-xxl-125px {
    min-height: 125px !important;
  }

  .min-h-xxl-150px {
    min-height: 150px !important;
  }

  .min-h-xxl-175px {
    min-height: 175px !important;
  }

  .min-h-xxl-200px {
    min-height: 200px !important;
  }

  .min-h-xxl-225px {
    min-height: 225px !important;
  }

  .min-h-xxl-250px {
    min-height: 250px !important;
  }

  .min-h-xxl-275px {
    min-height: 275px !important;
  }

  .min-h-xxl-300px {
    min-height: 300px !important;
  }

  .min-h-xxl-325px {
    min-height: 325px !important;
  }

  .min-h-xxl-350px {
    min-height: 350px !important;
  }

  .min-h-xxl-375px {
    min-height: 375px !important;
  }

  .min-h-xxl-400px {
    min-height: 400px !important;
  }

  .min-h-xxl-425px {
    min-height: 425px !important;
  }

  .min-h-xxl-450px {
    min-height: 450px !important;
  }

  .min-h-xxl-475px {
    min-height: 475px !important;
  }

  .min-h-xxl-500px {
    min-height: 500px !important;
  }

  .min-h-xxl-550px {
    min-height: 550px !important;
  }

  .min-h-xxl-600px {
    min-height: 600px !important;
  }

  .min-h-xxl-650px {
    min-height: 650px !important;
  }

  .min-h-xxl-700px {
    min-height: 700px !important;
  }

  .min-h-xxl-750px {
    min-height: 750px !important;
  }

  .min-h-xxl-800px {
    min-height: 800px !important;
  }

  .min-h-xxl-850px {
    min-height: 850px !important;
  }

  .min-h-xxl-900px {
    min-height: 900px !important;
  }

  .min-h-xxl-950px {
    min-height: 950px !important;
  }

  .min-h-xxl-1000px {
    min-height: 1000px !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 1.75rem !important;
  }

  .fs-2 {
    font-size: 1.5rem !important;
  }

  .fs-3 {
    font-size: 1.35rem !important;
  }

  .fs-2x {
    font-size: 2rem !important;
  }

  .fs-2qx {
    font-size: 2.25rem !important;
  }

  .fs-2hx {
    font-size: 2.5rem !important;
  }

  .fs-2tx {
    font-size: 2.75rem !important;
  }

  .fs-3x {
    font-size: 3rem !important;
  }

  .fs-3qx {
    font-size: 3.25rem !important;
  }

  .fs-3hx {
    font-size: 3.5rem !important;
  }

  .fs-3tx {
    font-size: 3.75rem !important;
  }

  .fs-4x {
    font-size: 4rem !important;
  }

  .fs-4qx {
    font-size: 4.25rem !important;
  }

  .fs-4hx {
    font-size: 4.5rem !important;
  }

  .fs-4tx {
    font-size: 4.75rem !important;
  }

  .fs-5x {
    font-size: 5rem !important;
  }

  .fs-5qx {
    font-size: 5.25rem !important;
  }

  .fs-5hx {
    font-size: 5.5rem !important;
  }

  .fs-5tx {
    font-size: 5.75rem !important;
  }

  .fs-sm-1 {
    font-size: 1.75rem !important;
  }

  .fs-sm-2 {
    font-size: 1.5rem !important;
  }

  .fs-sm-3 {
    font-size: 1.35rem !important;
  }

  .fs-sm-2x {
    font-size: 2rem !important;
  }

  .fs-sm-2qx {
    font-size: 2.25rem !important;
  }

  .fs-sm-2hx {
    font-size: 2.5rem !important;
  }

  .fs-sm-2tx {
    font-size: 2.75rem !important;
  }

  .fs-sm-3x {
    font-size: 3rem !important;
  }

  .fs-sm-3qx {
    font-size: 3.25rem !important;
  }

  .fs-sm-3hx {
    font-size: 3.5rem !important;
  }

  .fs-sm-3tx {
    font-size: 3.75rem !important;
  }

  .fs-sm-4x {
    font-size: 4rem !important;
  }

  .fs-sm-4qx {
    font-size: 4.25rem !important;
  }

  .fs-sm-4hx {
    font-size: 4.5rem !important;
  }

  .fs-sm-4tx {
    font-size: 4.75rem !important;
  }

  .fs-sm-5x {
    font-size: 5rem !important;
  }

  .fs-sm-5qx {
    font-size: 5.25rem !important;
  }

  .fs-sm-5hx {
    font-size: 5.5rem !important;
  }

  .fs-sm-5tx {
    font-size: 5.75rem !important;
  }

  .fs-md-1 {
    font-size: 1.75rem !important;
  }

  .fs-md-2 {
    font-size: 1.5rem !important;
  }

  .fs-md-3 {
    font-size: 1.35rem !important;
  }

  .fs-md-2x {
    font-size: 2rem !important;
  }

  .fs-md-2qx {
    font-size: 2.25rem !important;
  }

  .fs-md-2hx {
    font-size: 2.5rem !important;
  }

  .fs-md-2tx {
    font-size: 2.75rem !important;
  }

  .fs-md-3x {
    font-size: 3rem !important;
  }

  .fs-md-3qx {
    font-size: 3.25rem !important;
  }

  .fs-md-3hx {
    font-size: 3.5rem !important;
  }

  .fs-md-3tx {
    font-size: 3.75rem !important;
  }

  .fs-md-4x {
    font-size: 4rem !important;
  }

  .fs-md-4qx {
    font-size: 4.25rem !important;
  }

  .fs-md-4hx {
    font-size: 4.5rem !important;
  }

  .fs-md-4tx {
    font-size: 4.75rem !important;
  }

  .fs-md-5x {
    font-size: 5rem !important;
  }

  .fs-md-5qx {
    font-size: 5.25rem !important;
  }

  .fs-md-5hx {
    font-size: 5.5rem !important;
  }

  .fs-md-5tx {
    font-size: 5.75rem !important;
  }

  .fs-lg-1 {
    font-size: 1.75rem !important;
  }

  .fs-lg-2 {
    font-size: 1.5rem !important;
  }

  .fs-lg-3 {
    font-size: 1.35rem !important;
  }

  .fs-lg-2x {
    font-size: 2rem !important;
  }

  .fs-lg-2qx {
    font-size: 2.25rem !important;
  }

  .fs-lg-2hx {
    font-size: 2.5rem !important;
  }

  .fs-lg-2tx {
    font-size: 2.75rem !important;
  }

  .fs-lg-3x {
    font-size: 3rem !important;
  }

  .fs-lg-3qx {
    font-size: 3.25rem !important;
  }

  .fs-lg-3hx {
    font-size: 3.5rem !important;
  }

  .fs-lg-3tx {
    font-size: 3.75rem !important;
  }

  .fs-lg-4x {
    font-size: 4rem !important;
  }

  .fs-lg-4qx {
    font-size: 4.25rem !important;
  }

  .fs-lg-4hx {
    font-size: 4.5rem !important;
  }

  .fs-lg-4tx {
    font-size: 4.75rem !important;
  }

  .fs-lg-5x {
    font-size: 5rem !important;
  }

  .fs-lg-5qx {
    font-size: 5.25rem !important;
  }

  .fs-lg-5hx {
    font-size: 5.5rem !important;
  }

  .fs-lg-5tx {
    font-size: 5.75rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }

  .d-print-inline-block {
    display: inline-block !important;
  }

  .d-print-block {
    display: block !important;
  }

  .d-print-grid {
    display: grid !important;
  }

  .d-print-inline-grid {
    display: inline-grid !important;
  }

  .d-print-table {
    display: table !important;
  }

  .d-print-table-row {
    display: table-row !important;
  }

  .d-print-table-cell {
    display: table-cell !important;
  }

  .d-print-flex {
    display: flex !important;
  }

  .d-print-inline-flex {
    display: inline-flex !important;
  }

  .d-print-none {
    display: none !important;
  }
}
:root {
  --bs-light-primary:#F1FAFF;
  --bs-active-primary:#0095E8;
  --bs-light-success:#E8FFF3;
  --bs-active-success:#47BE7D;
  --bs-light-info:#F8F5FF;
  --bs-active-info:#5014D0;
  --bs-light-warning:#FFF8DD;
  --bs-active-warning:#F1BC00;
  --bs-light-danger:#FFF5F8;
  --bs-active-danger:#D9214E;
  --bs-light-dark:#EFF2F5;
  --bs-active-dark:#131628;
  --bs-gray-100:#F5F8FA;
  --bs-gray-200:#EFF2F5;
  --bs-gray-300:#E4E6EF;
  --bs-gray-400:#B5B5C3;
  --bs-gray-500:#A1A5B7;
  --bs-gray-600:#7E8299;
  --bs-gray-700:#5E6278;
  --bs-gray-800:#3F4254;
  --bs-gray-900:#181C32;
  --bs-xs:0;
  --bs-sm:576px;
  --bs-md:768px;
  --bs-lg:992px;
  --bs-xl:1200px;
  --bs-xxl:1400px;
  --bs-border-color:#EFF2F5;
  --bs-border-dashed-color:#E4E6EF;
}

.bg-white {
  --bg-color: 255, 255, 255;
}
.bg-white.hoverable:hover {
  background-color: #F5F8FA !important;
}

.bg-hover-white {
  cursor: pointer;
}
.bg-hover-white:hover {
  --bg-color: 255, 255, 255;
  background-color: #ffffff !important;
}

.bg-active-white.active {
  --bg-color: 255, 255, 255;
  background-color: #ffffff !important;
}

.bg-state-white {
  cursor: pointer;
}
.bg-state-white.active, .bg-state-white:hover {
  --bg-color: 255, 255, 255;
  background-color: #ffffff !important;
}

.bg-light {
  --bg-color: 245, 248, 250;
}
.bg-light.hoverable:hover {
  background-color: #EFF2F5 !important;
}

.bg-hover-light {
  cursor: pointer;
}
.bg-hover-light:hover {
  --bg-color: 245, 248, 250;
  background-color: #F5F8FA !important;
}

.bg-active-light.active {
  --bg-color: 245, 248, 250;
  background-color: #F5F8FA !important;
}

.bg-state-light {
  cursor: pointer;
}
.bg-state-light.active, .bg-state-light:hover {
  --bg-color: 245, 248, 250;
  background-color: #F5F8FA !important;
}

.bg-light-primary {
  background-color: #F1FAFF !important;
}
.bg-light-primary.hoverable:hover {
  background-color: #d2efff !important;
}

.bg-primary {
  --bg-color: 0, 158, 247;
}
.bg-primary.hoverable:hover {
  background-color: #0095E8 !important;
}

.bg-hover-light-primary {
  cursor: pointer;
}
.bg-hover-light-primary:hover {
  background-color: #F1FAFF !important;
}

.bg-state-light-primary {
  cursor: pointer;
}
.bg-state-light-primary.active, .bg-state-light-primary:hover {
  background-color: #F1FAFF !important;
}

.bg-hover-primary {
  cursor: pointer;
}
.bg-hover-primary:hover {
  --bg-color: 0, 158, 247;
  background-color: #009EF7 !important;
}

.bg-active-primary.active {
  --bg-color: 0, 158, 247;
  background-color: #009EF7 !important;
}

.bg-state-primary {
  cursor: pointer;
}
.bg-state-primary.active, .bg-state-primary:hover {
  --bg-color: 0, 158, 247;
  background-color: #009EF7 !important;
}

.bg-secondary {
  --bg-color: 228, 230, 239;
}
.bg-secondary.hoverable:hover {
  background-color: #B5B5C3 !important;
}

.bg-hover-secondary {
  cursor: pointer;
}
.bg-hover-secondary:hover {
  --bg-color: 228, 230, 239;
  background-color: #E4E6EF !important;
}

.bg-active-secondary.active {
  --bg-color: 228, 230, 239;
  background-color: #E4E6EF !important;
}

.bg-state-secondary {
  cursor: pointer;
}
.bg-state-secondary.active, .bg-state-secondary:hover {
  --bg-color: 228, 230, 239;
  background-color: #E4E6EF !important;
}

.bg-light-success {
  background-color: #E8FFF3 !important;
}
.bg-light-success.hoverable:hover {
  background-color: #c9ffe3 !important;
}

.bg-success {
  --bg-color: 80, 205, 137;
}
.bg-success.hoverable:hover {
  background-color: #47BE7D !important;
}

.bg-hover-light-success {
  cursor: pointer;
}
.bg-hover-light-success:hover {
  background-color: #E8FFF3 !important;
}

.bg-state-light-success {
  cursor: pointer;
}
.bg-state-light-success.active, .bg-state-light-success:hover {
  background-color: #E8FFF3 !important;
}

.bg-hover-success {
  cursor: pointer;
}
.bg-hover-success:hover {
  --bg-color: 80, 205, 137;
  background-color: #50CD89 !important;
}

.bg-active-success.active {
  --bg-color: 80, 205, 137;
  background-color: #50CD89 !important;
}

.bg-state-success {
  cursor: pointer;
}
.bg-state-success.active, .bg-state-success:hover {
  --bg-color: 80, 205, 137;
  background-color: #50CD89 !important;
}

.bg-light-info {
  background-color: #F8F5FF !important;
}
.bg-light-info.hoverable:hover {
  background-color: #e3d6ff !important;
}

.bg-info {
  --bg-color: 114, 57, 234;
}
.bg-info.hoverable:hover {
  background-color: #5014D0 !important;
}

.bg-hover-light-info {
  cursor: pointer;
}
.bg-hover-light-info:hover {
  background-color: #F8F5FF !important;
}

.bg-state-light-info {
  cursor: pointer;
}
.bg-state-light-info.active, .bg-state-light-info:hover {
  background-color: #F8F5FF !important;
}

.bg-hover-info {
  cursor: pointer;
}
.bg-hover-info:hover {
  --bg-color: 114, 57, 234;
  background-color: #7239EA !important;
}

.bg-active-info.active {
  --bg-color: 114, 57, 234;
  background-color: #7239EA !important;
}

.bg-state-info {
  cursor: pointer;
}
.bg-state-info.active, .bg-state-info:hover {
  --bg-color: 114, 57, 234;
  background-color: #7239EA !important;
}

.bg-light-warning {
  background-color: #FFF8DD !important;
}
.bg-light-warning.hoverable:hover {
  background-color: #fff2be !important;
}

.bg-warning {
  --bg-color: 255, 199, 0;
}
.bg-warning.hoverable:hover {
  background-color: #F1BC00 !important;
}

.bg-hover-light-warning {
  cursor: pointer;
}
.bg-hover-light-warning:hover {
  background-color: #FFF8DD !important;
}

.bg-state-light-warning {
  cursor: pointer;
}
.bg-state-light-warning.active, .bg-state-light-warning:hover {
  background-color: #FFF8DD !important;
}

.bg-hover-warning {
  cursor: pointer;
}
.bg-hover-warning:hover {
  --bg-color: 255, 199, 0;
  background-color: #FFC700 !important;
}

.bg-active-warning.active {
  --bg-color: 255, 199, 0;
  background-color: #FFC700 !important;
}

.bg-state-warning {
  cursor: pointer;
}
.bg-state-warning.active, .bg-state-warning:hover {
  --bg-color: 255, 199, 0;
  background-color: #FFC700 !important;
}

.bg-light-danger {
  background-color: #FFF5F8 !important;
}
.bg-light-danger.hoverable:hover {
  background-color: #ffd6e3 !important;
}

.bg-danger {
  --bg-color: 241, 65, 108;
}
.bg-danger.hoverable:hover {
  background-color: #D9214E !important;
}

.bg-hover-light-danger {
  cursor: pointer;
}
.bg-hover-light-danger:hover {
  background-color: #FFF5F8 !important;
}

.bg-state-light-danger {
  cursor: pointer;
}
.bg-state-light-danger.active, .bg-state-light-danger:hover {
  background-color: #FFF5F8 !important;
}

.bg-hover-danger {
  cursor: pointer;
}
.bg-hover-danger:hover {
  --bg-color: 241, 65, 108;
  background-color: #F1416C !important;
}

.bg-active-danger.active {
  --bg-color: 241, 65, 108;
  background-color: #F1416C !important;
}

.bg-state-danger {
  cursor: pointer;
}
.bg-state-danger.active, .bg-state-danger:hover {
  --bg-color: 241, 65, 108;
  background-color: #F1416C !important;
}

.bg-light-dark {
  background-color: #EFF2F5 !important;
}
.bg-light-dark.hoverable:hover {
  background-color: #dce3e9 !important;
}

.bg-dark {
  --bg-color: 24, 28, 50;
}
.bg-dark.hoverable:hover {
  background-color: #131628 !important;
}

.bg-hover-light-dark {
  cursor: pointer;
}
.bg-hover-light-dark:hover {
  background-color: #EFF2F5 !important;
}

.bg-state-light-dark {
  cursor: pointer;
}
.bg-state-light-dark.active, .bg-state-light-dark:hover {
  background-color: #EFF2F5 !important;
}

.bg-hover-dark {
  cursor: pointer;
}
.bg-hover-dark:hover {
  --bg-color: 24, 28, 50;
  background-color: #181C32 !important;
}

.bg-active-dark.active {
  --bg-color: 24, 28, 50;
  background-color: #181C32 !important;
}

.bg-state-dark {
  cursor: pointer;
}
.bg-state-dark.active, .bg-state-dark:hover {
  --bg-color: 24, 28, 50;
  background-color: #181C32 !important;
}

.bg-gray-100 {
  background-color: #F5F8FA !important;
}

.bg-gray-200 {
  background-color: #EFF2F5 !important;
}

.bg-gray-300 {
  background-color: #E4E6EF !important;
}

.bg-gray-400 {
  background-color: #B5B5C3 !important;
}

.bg-gray-500 {
  background-color: #A1A5B7 !important;
}

.bg-gray-600 {
  background-color: #7E8299 !important;
}

.bg-gray-700 {
  background-color: #5E6278 !important;
}

.bg-gray-800 {
  background-color: #3F4254 !important;
}

.bg-gray-900 {
  background-color: #181C32 !important;
}

.bg-opacity-0 {
  background-color: rgba(var(--bg-color), 0) !important;
}

.bg-hover-opacity-0:hover {
  background-color: rgba(var(--bg-color), 0) !important;
}

.bg-active-opacity-0.active {
  background-color: rgba(var(--bg-color), 0) !important;
}

.bg-state-opacity-0 .active, .bg-state-opacity-0:hover {
  background-color: rgba(var(--bg-color), 0) !important;
}

.bg-opacity-5 {
  background-color: rgba(var(--bg-color), 0.05) !important;
}

.bg-hover-opacity-5:hover {
  background-color: rgba(var(--bg-color), 0.05) !important;
}

.bg-active-opacity-5.active {
  background-color: rgba(var(--bg-color), 0.05) !important;
}

.bg-state-opacity-5 .active, .bg-state-opacity-5:hover {
  background-color: rgba(var(--bg-color), 0.05) !important;
}

.bg-opacity-10 {
  background-color: rgba(var(--bg-color), 0.1) !important;
}

.bg-hover-opacity-10:hover {
  background-color: rgba(var(--bg-color), 0.1) !important;
}

.bg-active-opacity-10.active {
  background-color: rgba(var(--bg-color), 0.1) !important;
}

.bg-state-opacity-10 .active, .bg-state-opacity-10:hover {
  background-color: rgba(var(--bg-color), 0.1) !important;
}

.bg-opacity-15 {
  background-color: rgba(var(--bg-color), 0.15) !important;
}

.bg-hover-opacity-15:hover {
  background-color: rgba(var(--bg-color), 0.15) !important;
}

.bg-active-opacity-15.active {
  background-color: rgba(var(--bg-color), 0.15) !important;
}

.bg-state-opacity-15 .active, .bg-state-opacity-15:hover {
  background-color: rgba(var(--bg-color), 0.15) !important;
}

.bg-opacity-20 {
  background-color: rgba(var(--bg-color), 0.2) !important;
}

.bg-hover-opacity-20:hover {
  background-color: rgba(var(--bg-color), 0.2) !important;
}

.bg-active-opacity-20.active {
  background-color: rgba(var(--bg-color), 0.2) !important;
}

.bg-state-opacity-20 .active, .bg-state-opacity-20:hover {
  background-color: rgba(var(--bg-color), 0.2) !important;
}

.bg-opacity-25 {
  background-color: rgba(var(--bg-color), 0.25) !important;
}

.bg-hover-opacity-25:hover {
  background-color: rgba(var(--bg-color), 0.25) !important;
}

.bg-active-opacity-25.active {
  background-color: rgba(var(--bg-color), 0.25) !important;
}

.bg-state-opacity-25 .active, .bg-state-opacity-25:hover {
  background-color: rgba(var(--bg-color), 0.25) !important;
}

.bg-opacity-50 {
  background-color: rgba(var(--bg-color), 0.5) !important;
}

.bg-hover-opacity-50:hover {
  background-color: rgba(var(--bg-color), 0.5) !important;
}

.bg-active-opacity-50.active {
  background-color: rgba(var(--bg-color), 0.5) !important;
}

.bg-state-opacity-50 .active, .bg-state-opacity-50:hover {
  background-color: rgba(var(--bg-color), 0.5) !important;
}

.bg-opacity-75 {
  background-color: rgba(var(--bg-color), 0.75) !important;
}

.bg-hover-opacity-75:hover {
  background-color: rgba(var(--bg-color), 0.75) !important;
}

.bg-active-opacity-75.active {
  background-color: rgba(var(--bg-color), 0.75) !important;
}

.bg-state-opacity-75 .active, .bg-state-opacity-75:hover {
  background-color: rgba(var(--bg-color), 0.75) !important;
}

.bg-opacity-100 {
  background-color: rgba(var(--bg-color), 1) !important;
}

.bg-hover-opacity-100:hover {
  background-color: rgba(var(--bg-color), 1) !important;
}

.bg-active-opacity-100.active {
  background-color: rgba(var(--bg-color), 1) !important;
}

.bg-state-opacity-100 .active, .bg-state-opacity-100:hover {
  background-color: rgba(var(--bg-color), 1) !important;
}

.bg-black {
  background-color: #000000 !important;
}

.bg-body {
  --bg-color: 255, 255, 255;
  background-color: #ffffff !important;
}

.bg-lighten {
  background-color: rgba(245, 248, 250, 0.5) !important;
}

.bg-hover-lighten {
  cursor: pointer;
}
.bg-hover-lighten:hover {
  background-color: rgba(245, 248, 250, 0.5) !important;
}

.bg-active-lighten.active {
  background-color: rgba(245, 248, 250, 0.5) !important;
}

.bg-state-lighten {
  cursor: pointer;
}
.bg-state-lighten.active, .bg-state-lighten:hover {
  background-color: rgba(245, 248, 250, 0.5) !important;
}

.hoverable {
  cursor: pointer;
  transition: all 0.2s ease;
}
.hoverable:hover {
  transition: all 0.2s ease;
}

.bgi-no-repeat {
  background-repeat: no-repeat;
}

.bgi-position-y-top {
  background-position-y: top;
}

.bgi-position-y-bottom {
  background-position-y: bottom;
}

.bgi-position-y-center {
  background-position-y: center;
}

.bgi-position-x-start {
  background-position-x: left;
}

.bgi-position-x-end {
  background-position-x: right;
}

.bgi-position-x-center {
  background-position-x: center;
}

.bgi-position-top {
  background-position: 0 top;
}

.bgi-position-bottom {
  background-position: 0 bottom;
}

.bgi-position-center {
  background-position: center;
}

.bgi-size-auto {
  background-size: auto;
}

.bgi-size-cover {
  background-size: cover;
}

.bgi-size-contain {
  background-size: contain;
}

.bgi-attachment-fixed {
  background-attachment: fixed;
}

.bgi-attachment-auto {
  background-attachment: auto;
}

@media (min-width: 576px) {
  .bgi-size-sm-auto {
    background-size: auto;
  }

  .bgi-size-sm-cover {
    background-size: cover;
  }

  .bgi-size-sm-contain {
    background-size: contain;
  }

  .bgi-attachment-sm-fixed {
    background-attachment: fixed;
  }

  .bgi-attachment-sm-auto {
    background-attachment: auto;
  }
}
@media (min-width: 768px) {
  .bgi-size-md-auto {
    background-size: auto;
  }

  .bgi-size-md-cover {
    background-size: cover;
  }

  .bgi-size-md-contain {
    background-size: contain;
  }

  .bgi-attachment-md-fixed {
    background-attachment: fixed;
  }

  .bgi-attachment-md-auto {
    background-attachment: auto;
  }
}
@media (min-width: 992px) {
  .bgi-size-lg-auto {
    background-size: auto;
  }

  .bgi-size-lg-cover {
    background-size: cover;
  }

  .bgi-size-lg-contain {
    background-size: contain;
  }

  .bgi-attachment-lg-fixed {
    background-attachment: fixed;
  }

  .bgi-attachment-lg-auto {
    background-attachment: auto;
  }
}
@media (min-width: 1200px) {
  .bgi-size-xl-auto {
    background-size: auto;
  }

  .bgi-size-xl-cover {
    background-size: cover;
  }

  .bgi-size-xl-contain {
    background-size: contain;
  }

  .bgi-attachment-xl-fixed {
    background-attachment: fixed;
  }

  .bgi-attachment-xl-auto {
    background-attachment: auto;
  }
}
@media (min-width: 1400px) {
  .bgi-size-xxl-auto {
    background-size: auto;
  }

  .bgi-size-xxl-cover {
    background-size: cover;
  }

  .bgi-size-xxl-contain {
    background-size: contain;
  }

  .bgi-attachment-xxl-fixed {
    background-attachment: fixed;
  }

  .bgi-attachment-xxl-auto {
    background-attachment: auto;
  }
}
.border-active:not(.active):not(:active):not(:hover):not(:focus) {
  border-color: transparent !important;
}

.border-hover:not(:hover):not(:focus):not(.active):not(:active) {
  cursor: pointer;
  border-color: transparent !important;
}

.border-gray-100 {
  border-color: #F5F8FA !important;
}

.border-gray-200 {
  border-color: #EFF2F5 !important;
}

.border-gray-300 {
  border-color: #E4E6EF !important;
}

.border-gray-400 {
  border-color: #B5B5C3 !important;
}

.border-gray-500 {
  border-color: #A1A5B7 !important;
}

.border-gray-600 {
  border-color: #7E8299 !important;
}

.border-gray-700 {
  border-color: #5E6278 !important;
}

.border-gray-800 {
  border-color: #3F4254 !important;
}

.border-gray-900 {
  border-color: #181C32 !important;
}

.border-hover-white:hover {
  border-color: #ffffff !important;
}

.border-active-white.active {
  border-color: #ffffff !important;
}

.border-hover-light:hover {
  border-color: #F5F8FA !important;
}

.border-active-light.active {
  border-color: #F5F8FA !important;
}

.border-hover-primary:hover {
  border-color: #009EF7 !important;
}

.border-active-primary.active {
  border-color: #009EF7 !important;
}

.border-hover-secondary:hover {
  border-color: #E4E6EF !important;
}

.border-active-secondary.active {
  border-color: #E4E6EF !important;
}

.border-hover-success:hover {
  border-color: #50CD89 !important;
}

.border-active-success.active {
  border-color: #50CD89 !important;
}

.border-hover-info:hover {
  border-color: #7239EA !important;
}

.border-active-info.active {
  border-color: #7239EA !important;
}

.border-hover-warning:hover {
  border-color: #FFC700 !important;
}

.border-active-warning.active {
  border-color: #FFC700 !important;
}

.border-hover-danger:hover {
  border-color: #F1416C !important;
}

.border-active-danger.active {
  border-color: #F1416C !important;
}

.border-hover-dark:hover {
  border-color: #181C32 !important;
}

.border-active-dark.active {
  border-color: #181C32 !important;
}

.border-hover-transparent:hover {
  border-color: transparent !important;
}

.border-dashed {
  border-style: dashed !important;
  border-color: #E4E6EF;
}

.border-top-dashed {
  border-top-style: dashed !important;
}

.border-bottom-dashed {
  border-bottom-style: dashed !important;
}

.border-start-dashed {
  border-left-style: dashed !important;
}

.border-end-dashed {
  border-right-style: dashed !important;
}

.border-dotted {
  border-style: dotted !important;
}

.border-top-dotted {
  border-top-style: dotted !important;
}

.border-bottom-dotted {
  border-bottom-style: dotted !important;
}

.border-start-dotted {
  border-left-style: dotted !important;
}

.border-end-dotted {
  border-right-style: dotted !important;
}

.border-transparent {
  border-color: transparent !important;
}

.border-body {
  border-color: #ffffff !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-bottom-0 {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-start-0 {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.flex-root {
  flex: 1 1;
}

.flex-column-auto {
  flex: none;
}

.flex-column-fluid {
  flex: 1 0 auto;
}

.flex-row-auto {
  flex: 0 0 auto;
}

.flex-row-fluid {
  flex: 1 1 auto;
  min-width: 0;
}

.flex-center {
  justify-content: center;
  align-items: center;
}

.flex-stack {
  justify-content: space-between;
  align-items: center;
}

@media (min-width: 576px) {
  .flex-sm-root {
    flex: 1 1;
  }

  .flex-sm-column-auto {
    flex: none;
  }

  .flex-sm-column-fluid {
    flex: 1 0 auto;
  }

  .flex-sm-row-auto {
    flex: 0 0 auto;
  }

  .flex-sm-row-fluid {
    flex: 1 1 auto;
    min-width: 0;
  }

  .flex-sm-center {
    justify-content: center;
    align-items: center;
  }

  .flex-sm-stack {
    justify-content: space-between;
    align-items: center;
  }
}
@media (min-width: 768px) {
  .flex-md-root {
    flex: 1 1;
  }

  .flex-md-column-auto {
    flex: none;
  }

  .flex-md-column-fluid {
    flex: 1 0 auto;
  }

  .flex-md-row-auto {
    flex: 0 0 auto;
  }

  .flex-md-row-fluid {
    flex: 1 1 auto;
    min-width: 0;
  }

  .flex-md-center {
    justify-content: center;
    align-items: center;
  }

  .flex-md-stack {
    justify-content: space-between;
    align-items: center;
  }
}
@media (min-width: 992px) {
  .flex-lg-root {
    flex: 1 1;
  }

  .flex-lg-column-auto {
    flex: none;
  }

  .flex-lg-column-fluid {
    flex: 1 0 auto;
  }

  .flex-lg-row-auto {
    flex: 0 0 auto;
  }

  .flex-lg-row-fluid {
    flex: 1 1 auto;
    min-width: 0;
  }

  .flex-lg-center {
    justify-content: center;
    align-items: center;
  }

  .flex-lg-stack {
    justify-content: space-between;
    align-items: center;
  }
}
@media (min-width: 1200px) {
  .flex-xl-root {
    flex: 1 1;
  }

  .flex-xl-column-auto {
    flex: none;
  }

  .flex-xl-column-fluid {
    flex: 1 0 auto;
  }

  .flex-xl-row-auto {
    flex: 0 0 auto;
  }

  .flex-xl-row-fluid {
    flex: 1 1 auto;
    min-width: 0;
  }

  .flex-xl-center {
    justify-content: center;
    align-items: center;
  }

  .flex-xl-stack {
    justify-content: space-between;
    align-items: center;
  }
}
@media (min-width: 1400px) {
  .flex-xxl-root {
    flex: 1 1;
  }

  .flex-xxl-column-auto {
    flex: none;
  }

  .flex-xxl-column-fluid {
    flex: 1 0 auto;
  }

  .flex-xxl-row-auto {
    flex: 0 0 auto;
  }

  .flex-xxl-row-fluid {
    flex: 1 1 auto;
    min-width: 0;
  }

  .flex-xxl-center {
    justify-content: center;
    align-items: center;
  }

  .flex-xxl-stack {
    justify-content: space-between;
    align-items: center;
  }
}
.flex-equal {
  flex-grow: 1;
  flex-basis: 0;
  flex-shrink: 0;
}

.shadow-xs {
  box-shadow: 0 0.1rem 0.75rem 0.25rem rgba(0, 0, 0, 0.05);
}

.text-white {
  color: #ffffff !important;
}

.text-inverse-white {
  color: #7E8299 !important;
}

.text-hover-white {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-white i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-white:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #ffffff !important;
}
.text-hover-white:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #ffffff !important;
}
.text-hover-white:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.text-hover-white:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-hover-inverse-white {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-inverse-white i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-inverse-white:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #7E8299 !important;
}
.text-hover-inverse-white:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #7E8299 !important;
}
.text-hover-inverse-white:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7E8299;
}
.text-hover-inverse-white:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-white {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-white i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-white.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #ffffff !important;
}
.text-active-white.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #ffffff !important;
}
.text-active-white.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.text-active-white.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-inverse-white {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-inverse-white i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-inverse-white.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #7E8299 !important;
}
.text-active-inverse-white.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #7E8299 !important;
}
.text-active-inverse-white.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7E8299;
}
.text-active-inverse-white.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-primary {
  color: #009EF7 !important;
}

.text-inverse-primary {
  color: #FFFFFF !important;
}

.text-light-primary {
  color: #F1FAFF !important;
}

.text-hover-primary {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-primary i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-primary:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #009EF7 !important;
}
.text-hover-primary:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #009EF7 !important;
}
.text-hover-primary:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.text-hover-primary:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-hover-inverse-primary {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-inverse-primary i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-inverse-primary:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFFFFF !important;
}
.text-hover-inverse-primary:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFFFFF !important;
}
.text-hover-inverse-primary:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.text-hover-inverse-primary:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-primary {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-primary i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-primary.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #009EF7 !important;
}
.text-active-primary.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #009EF7 !important;
}
.text-active-primary.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.text-active-primary.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-inverse-primary {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-inverse-primary i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-inverse-primary.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFFFFF !important;
}
.text-active-inverse-primary.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFFFFF !important;
}
.text-active-inverse-primary.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.text-active-inverse-primary.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-secondary {
  color: #E4E6EF !important;
}

.text-inverse-secondary {
  color: #3F4254 !important;
}

.text-hover-secondary {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-secondary i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-secondary:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #E4E6EF !important;
}
.text-hover-secondary:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #E4E6EF !important;
}
.text-hover-secondary:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #E4E6EF;
}
.text-hover-secondary:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-hover-inverse-secondary {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-inverse-secondary i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-inverse-secondary:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #3F4254 !important;
}
.text-hover-inverse-secondary:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #3F4254 !important;
}
.text-hover-inverse-secondary:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #3F4254;
}
.text-hover-inverse-secondary:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-secondary {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-secondary i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-secondary.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #E4E6EF !important;
}
.text-active-secondary.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #E4E6EF !important;
}
.text-active-secondary.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #E4E6EF;
}
.text-active-secondary.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-inverse-secondary {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-inverse-secondary i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-inverse-secondary.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #3F4254 !important;
}
.text-active-inverse-secondary.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #3F4254 !important;
}
.text-active-inverse-secondary.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #3F4254;
}
.text-active-inverse-secondary.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-light {
  color: #F5F8FA !important;
}

.text-inverse-light {
  color: #7E8299 !important;
}

.text-hover-light {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-light i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-light:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #F5F8FA !important;
}
.text-hover-light:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #F5F8FA !important;
}
.text-hover-light:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F5F8FA;
}
.text-hover-light:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-hover-inverse-light {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-inverse-light i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-inverse-light:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #7E8299 !important;
}
.text-hover-inverse-light:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #7E8299 !important;
}
.text-hover-inverse-light:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7E8299;
}
.text-hover-inverse-light:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-light {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-light i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-light.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #F5F8FA !important;
}
.text-active-light.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #F5F8FA !important;
}
.text-active-light.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F5F8FA;
}
.text-active-light.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-inverse-light {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-inverse-light i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-inverse-light.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #7E8299 !important;
}
.text-active-inverse-light.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #7E8299 !important;
}
.text-active-inverse-light.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7E8299;
}
.text-active-inverse-light.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-success {
  color: #50CD89 !important;
}

.text-inverse-success {
  color: #FFFFFF !important;
}

.text-light-success {
  color: #E8FFF3 !important;
}

.text-hover-success {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-success i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-success:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #50CD89 !important;
}
.text-hover-success:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #50CD89 !important;
}
.text-hover-success:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #50CD89;
}
.text-hover-success:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-hover-inverse-success {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-inverse-success i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-inverse-success:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFFFFF !important;
}
.text-hover-inverse-success:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFFFFF !important;
}
.text-hover-inverse-success:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.text-hover-inverse-success:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-success {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-success i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-success.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #50CD89 !important;
}
.text-active-success.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #50CD89 !important;
}
.text-active-success.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #50CD89;
}
.text-active-success.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-inverse-success {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-inverse-success i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-inverse-success.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFFFFF !important;
}
.text-active-inverse-success.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFFFFF !important;
}
.text-active-inverse-success.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.text-active-inverse-success.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-info {
  color: #7239EA !important;
}

.text-inverse-info {
  color: #FFFFFF !important;
}

.text-light-info {
  color: #F8F5FF !important;
}

.text-hover-info {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-info i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-info:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #7239EA !important;
}
.text-hover-info:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #7239EA !important;
}
.text-hover-info:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7239EA;
}
.text-hover-info:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-hover-inverse-info {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-inverse-info i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-inverse-info:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFFFFF !important;
}
.text-hover-inverse-info:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFFFFF !important;
}
.text-hover-inverse-info:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.text-hover-inverse-info:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-info {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-info i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-info.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #7239EA !important;
}
.text-active-info.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #7239EA !important;
}
.text-active-info.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7239EA;
}
.text-active-info.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-inverse-info {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-inverse-info i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-inverse-info.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFFFFF !important;
}
.text-active-inverse-info.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFFFFF !important;
}
.text-active-inverse-info.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.text-active-inverse-info.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-warning {
  color: #FFC700 !important;
}

.text-inverse-warning {
  color: #FFFFFF !important;
}

.text-light-warning {
  color: #FFF8DD !important;
}

.text-hover-warning {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-warning i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-warning:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFC700 !important;
}
.text-hover-warning:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFC700 !important;
}
.text-hover-warning:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFC700;
}
.text-hover-warning:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-hover-inverse-warning {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-inverse-warning i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-inverse-warning:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFFFFF !important;
}
.text-hover-inverse-warning:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFFFFF !important;
}
.text-hover-inverse-warning:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.text-hover-inverse-warning:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-warning {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-warning i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-warning.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFC700 !important;
}
.text-active-warning.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFC700 !important;
}
.text-active-warning.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFC700;
}
.text-active-warning.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-inverse-warning {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-inverse-warning i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-inverse-warning.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFFFFF !important;
}
.text-active-inverse-warning.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFFFFF !important;
}
.text-active-inverse-warning.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.text-active-inverse-warning.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-danger {
  color: #F1416C !important;
}

.text-inverse-danger {
  color: #FFFFFF !important;
}

.text-light-danger {
  color: #FFF5F8 !important;
}

.text-hover-danger {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-danger i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-danger:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #F1416C !important;
}
.text-hover-danger:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #F1416C !important;
}
.text-hover-danger:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F1416C;
}
.text-hover-danger:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-hover-inverse-danger {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-inverse-danger i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-inverse-danger:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFFFFF !important;
}
.text-hover-inverse-danger:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFFFFF !important;
}
.text-hover-inverse-danger:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.text-hover-inverse-danger:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-danger {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-danger i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-danger.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #F1416C !important;
}
.text-active-danger.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #F1416C !important;
}
.text-active-danger.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F1416C;
}
.text-active-danger.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-inverse-danger {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-inverse-danger i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-inverse-danger.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFFFFF !important;
}
.text-active-inverse-danger.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #FFFFFF !important;
}
.text-active-inverse-danger.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.text-active-inverse-danger.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-dark {
  color: #181C32 !important;
}

.text-inverse-dark {
  color: #ffffff !important;
}

.text-light-dark {
  color: #EFF2F5 !important;
}

.text-hover-dark {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-dark i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-dark:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #181C32 !important;
}
.text-hover-dark:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #181C32 !important;
}
.text-hover-dark:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #181C32;
}
.text-hover-dark:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-hover-inverse-dark {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-inverse-dark i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-inverse-dark:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #ffffff !important;
}
.text-hover-inverse-dark:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #ffffff !important;
}
.text-hover-inverse-dark:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.text-hover-inverse-dark:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-dark {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-dark i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-dark.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #181C32 !important;
}
.text-active-dark.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #181C32 !important;
}
.text-active-dark.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #181C32;
}
.text-active-dark.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-inverse-dark {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-inverse-dark i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-inverse-dark.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #ffffff !important;
}
.text-active-inverse-dark.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #ffffff !important;
}
.text-active-inverse-dark.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.text-active-inverse-dark.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-muted {
  color: #A1A5B7 !important;
}

.text-hover-muted {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-muted i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-muted:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #A1A5B7 !important;
}
.text-hover-muted:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #A1A5B7 !important;
}
.text-hover-muted:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.text-hover-muted:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-muted {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-muted i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-muted.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #A1A5B7 !important;
}
.text-active-muted.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #A1A5B7 !important;
}
.text-active-muted.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.text-active-muted.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-gray-100 {
  color: #F5F8FA !important;
}

.text-hover-gray-100 {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-gray-100 i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-gray-100:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #F5F8FA !important;
}
.text-hover-gray-100:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #F5F8FA !important;
}
.text-hover-gray-100:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F5F8FA;
}
.text-hover-gray-100:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-gray-100 {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-gray-100 i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-gray-100.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #F5F8FA !important;
}
.text-active-gray-100.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #F5F8FA !important;
}
.text-active-gray-100.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F5F8FA;
}
.text-active-gray-100.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-gray-200 {
  color: #EFF2F5 !important;
}

.text-hover-gray-200 {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-gray-200 i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-gray-200:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #EFF2F5 !important;
}
.text-hover-gray-200:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #EFF2F5 !important;
}
.text-hover-gray-200:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #EFF2F5;
}
.text-hover-gray-200:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-gray-200 {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-gray-200 i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-gray-200.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #EFF2F5 !important;
}
.text-active-gray-200.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #EFF2F5 !important;
}
.text-active-gray-200.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #EFF2F5;
}
.text-active-gray-200.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-gray-300 {
  color: #E4E6EF !important;
}

.text-hover-gray-300 {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-gray-300 i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-gray-300:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #E4E6EF !important;
}
.text-hover-gray-300:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #E4E6EF !important;
}
.text-hover-gray-300:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #E4E6EF;
}
.text-hover-gray-300:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-gray-300 {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-gray-300 i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-gray-300.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #E4E6EF !important;
}
.text-active-gray-300.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #E4E6EF !important;
}
.text-active-gray-300.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #E4E6EF;
}
.text-active-gray-300.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-gray-400 {
  color: #B5B5C3 !important;
}

.text-hover-gray-400 {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-gray-400 i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-gray-400:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #B5B5C3 !important;
}
.text-hover-gray-400:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #B5B5C3 !important;
}
.text-hover-gray-400:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #B5B5C3;
}
.text-hover-gray-400:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-gray-400 {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-gray-400 i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-gray-400.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #B5B5C3 !important;
}
.text-active-gray-400.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #B5B5C3 !important;
}
.text-active-gray-400.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #B5B5C3;
}
.text-active-gray-400.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-gray-500 {
  color: #A1A5B7 !important;
}

.text-hover-gray-500 {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-gray-500 i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-gray-500:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #A1A5B7 !important;
}
.text-hover-gray-500:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #A1A5B7 !important;
}
.text-hover-gray-500:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.text-hover-gray-500:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-gray-500 {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-gray-500 i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-gray-500.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #A1A5B7 !important;
}
.text-active-gray-500.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #A1A5B7 !important;
}
.text-active-gray-500.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.text-active-gray-500.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-gray-600 {
  color: #7E8299 !important;
}

.text-hover-gray-600 {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-gray-600 i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-gray-600:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #7E8299 !important;
}
.text-hover-gray-600:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #7E8299 !important;
}
.text-hover-gray-600:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7E8299;
}
.text-hover-gray-600:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-gray-600 {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-gray-600 i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-gray-600.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #7E8299 !important;
}
.text-active-gray-600.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #7E8299 !important;
}
.text-active-gray-600.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7E8299;
}
.text-active-gray-600.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-gray-700 {
  color: #5E6278 !important;
}

.text-hover-gray-700 {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-gray-700 i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-gray-700:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #5E6278 !important;
}
.text-hover-gray-700:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #5E6278 !important;
}
.text-hover-gray-700:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #5E6278;
}
.text-hover-gray-700:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-gray-700 {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-gray-700 i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-gray-700.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #5E6278 !important;
}
.text-active-gray-700.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #5E6278 !important;
}
.text-active-gray-700.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #5E6278;
}
.text-active-gray-700.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-gray-800 {
  color: #3F4254 !important;
}

.text-hover-gray-800 {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-gray-800 i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-gray-800:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #3F4254 !important;
}
.text-hover-gray-800:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #3F4254 !important;
}
.text-hover-gray-800:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #3F4254;
}
.text-hover-gray-800:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-gray-800 {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-gray-800 i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-gray-800.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #3F4254 !important;
}
.text-active-gray-800.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #3F4254 !important;
}
.text-active-gray-800.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #3F4254;
}
.text-active-gray-800.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-gray-900 {
  color: #181C32 !important;
}

.text-hover-gray-900 {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-gray-900 i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-hover-gray-900:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #181C32 !important;
}
.text-hover-gray-900:hover i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #181C32 !important;
}
.text-hover-gray-900:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #181C32;
}
.text-hover-gray-900:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.text-active-gray-900 {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-gray-900 i {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.text-active-gray-900.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #181C32 !important;
}
.text-active-gray-900.active i {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #181C32 !important;
}
.text-active-gray-900.active .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #181C32;
}
.text-active-gray-900.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.fw-boldest {
  font-weight: 700 !important;
}

.text-transparent {
  color: transparent;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-default {
  cursor: default;
}

.cursor-move {
  cursor: move;
}

i {
  line-height: 1;
  font-size: 1rem;
  color: #A1A5B7;
}

a {
  transition: color 0.2s ease, background-color 0.2s ease;
}
a:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
}

.opacity-active-0.active {
  opacity: 0 !important;
}

.opacity-state-0:hover, .opacity-state-0.active {
  opacity: 0 !important;
}

.opacity-active-5.active {
  opacity: 0.05 !important;
}

.opacity-state-5:hover, .opacity-state-5.active {
  opacity: 0.05 !important;
}

.opacity-active-10.active {
  opacity: 0.1 !important;
}

.opacity-state-10:hover, .opacity-state-10.active {
  opacity: 0.1 !important;
}

.opacity-active-15.active {
  opacity: 0.15 !important;
}

.opacity-state-15:hover, .opacity-state-15.active {
  opacity: 0.15 !important;
}

.opacity-active-20.active {
  opacity: 0.2 !important;
}

.opacity-state-20:hover, .opacity-state-20.active {
  opacity: 0.2 !important;
}

.opacity-active-25.active {
  opacity: 0.25 !important;
}

.opacity-state-25:hover, .opacity-state-25.active {
  opacity: 0.25 !important;
}

.opacity-active-50.active {
  opacity: 0.5 !important;
}

.opacity-state-50:hover, .opacity-state-50.active {
  opacity: 0.5 !important;
}

.opacity-active-75.active {
  opacity: 0.75 !important;
}

.opacity-state-75:hover, .opacity-state-75.active {
  opacity: 0.75 !important;
}

.opacity-active-100.active {
  opacity: 1 !important;
}

.opacity-state-100:hover, .opacity-state-100.active {
  opacity: 1 !important;
}

.transform-90 {
  transform: rotate(90deg);
  transform-origin: right top;
}

.animation {
  animation-duration: 1s;
  animation-fill-mode: both;
}

@keyframes animationSlideInDown {
  from {
    transform: translate3d(0, -100%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
.animation-slide-in-down {
  animation-name: animationSlideInDown;
}

@keyframes animationSlideInUp {
  from {
    transform: translate3d(0, 100%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
.animation-slide-in-up {
  animation-name: animationSlideInUp;
}

@keyframes animationFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.animation-fade-in {
  animation-name: animationFadeIn;
}

@keyframes animationFadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.animation-fade-out {
  animation-name: animationFadeOut;
}

.animation-blink {
  animation: animationBlink 1s steps(5, start) infinite;
}

@keyframes animationBlink {
  to {
    visibility: hidden;
  }
}
.nav-line-tabs {
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #EFF2F5;
}
.nav-line-tabs .nav-item {
  margin-bottom: -1px;
}
.nav-line-tabs .nav-item .nav-link {
  color: #A1A5B7;
  border: 0;
  border-bottom: 1px solid transparent;
  transition: color 0.2s ease, background-color 0.2s ease;
  padding: 0.5rem 0;
  margin: 0 1rem;
}
.nav-line-tabs .nav-item:first-child .nav-link {
  margin-left: 0;
}
.nav-line-tabs .nav-item:last-child .nav-link {
  margin-right: 0;
}
.nav-line-tabs .nav-item .nav-link.active,
.nav-line-tabs .nav-item.show .nav-link,
.nav-line-tabs .nav-item .nav-link:hover:not(.disabled) {
  background-color: transparent;
  border: 0;
  border-bottom: 1px solid #009EF7;
  transition: color 0.2s ease, background-color 0.2s ease;
}
.nav-line-tabs.nav-line-tabs-2x {
  border-bottom-width: 2px;
}
.nav-line-tabs.nav-line-tabs-2x .nav-item {
  margin-bottom: -2px;
}
.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link {
  border-bottom-width: 2px;
}
.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link.active,
.nav-line-tabs.nav-line-tabs-2x .nav-item.show .nav-link,
.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link:hover:not(.disabled) {
  border-bottom-width: 2px;
}

.nav-pills .nav-item {
  margin-right: 0.5rem;
}
.nav-pills .nav-item:last-child {
  margin-right: 0;
}

.nav-stretch {
  align-items: stretch;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.nav-stretch .nav-item {
  display: flex;
  align-items: stretch;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.nav-stretch .nav-link {
  display: flex;
  align-items: center;
}

.nav-group {
  padding: 0.35rem;
  border-radius: 0.475rem;
  background-color: #F5F8FA;
}
.nav-group.nav-group-outline {
  background-color: transparent;
  border: 1px solid #EFF2F5;
}
.nav-group.nav-group-fluid {
  display: flex;
}
.nav-group.nav-group-fluid > label,
.nav-group.nav-group-fluid > .btn {
  position: relative;
  flex-shrink: 0;
  flex-grow: 1;
  flex-basis: 0;
}
.nav-group.nav-group-fluid > label {
  margin-right: 0.1rem;
}
.nav-group.nav-group-fluid > label > .btn {
  width: 100%;
}
.nav-group.nav-group-fluid > label:last-child {
  margin-right: 0;
}

.nav.nav-pills.nav-pills-custom .show > .nav-link,
.nav.nav-pills.nav-pills-custom .nav-link {
  border: 1px dashed #E4E6EF;
  border-radius: 12px;
}
.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img,
.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img {
  width: 30px;
  transition: color 0.2s ease, background-color 0.2s ease;
}
.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img.default,
.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img.default {
  display: inline-block;
}
.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img.active,
.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img.active {
  display: none;
}
.nav.nav-pills.nav-pills-custom .show > .nav-link.active,
.nav.nav-pills.nav-pills-custom .nav-link.active {
  background-color: transparent;
  border: 1px solid #E4E6EF;
  transition-duration: 1ms;
  position: relative;
}
.nav.nav-pills.nav-pills-custom .show > .nav-link.active .nav-text,
.nav.nav-pills.nav-pills-custom .nav-link.active .nav-text {
  color: #3F4254 !important;
  transition: color 0.2s ease, background-color 0.2s ease;
}
.nav.nav-pills.nav-pills-custom .show > .nav-link.active .bullet-custom,
.nav.nav-pills.nav-pills-custom .nav-link.active .bullet-custom {
  display: block;
}
.nav.nav-pills.nav-pills-custom .show > .nav-link .bullet-custom,
.nav.nav-pills.nav-pills-custom .nav-link .bullet-custom {
  display: none;
}

.pagination {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0;
}
.pagination.pagination-circle .page-link {
  border-radius: 50%;
}
.pagination.pagination-outline .page-link {
  border: 1px solid #EFF2F5;
}
.pagination.pagination-outline .page-item:hover .page-link, .pagination.pagination-outline .page-item.active .page-link {
  border-color: #F1FAFF;
}

.page-item {
  margin-right: 0.5rem;
  /*rtl:options:{"autoRename":false}*/
  /*rtl:end:ignore*/
}
.page-item:last-child {
  margin-right: 0;
}
.page-item .page-link {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.475rem;
  height: 2.5rem;
  min-width: 2.5rem;
  font-weight: 500;
  font-size: 1.075rem;
  /*rtl:options:{"autoRename":false}*/
  /*rtl:end:ignore*/
  /*rtl:options:{"autoRename":false}*/
}
.page-item .page-link i {
  font-size: 0.85rem;
}
.page-item .page-link .previous,
.page-item .page-link .next {
  display: block;
  height: 0.875rem;
  width: 0.875rem;
  /*rtl:raw:transform: rotateZ(-180deg);*/
}
.page-item .page-link .previous {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}
.page-item .page-link .next {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}
.page-item.next .page-link, .page-item.previous .page-link {
  background-color: #ffffff;
}
.page-item.next .page-link i, .page-item.previous .page-link i {
  color: #5E6278;
}
.page-item.next .page-link .svg-icon svg [fill]:not(.permanent):not(g), .page-item.previous .page-link .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #5E6278;
}
.page-item.next .page-link .svg-icon svg:hover [fill]:not(.permanent):not(g), .page-item.previous .page-link .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.page-item:focus .page-link {
  /*rtl:options:{"autoRename":false}*/
}
.page-item:focus .page-link i {
  color: #009EF7;
}
.page-item:focus .page-link .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.page-item:focus .page-link .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.page-item:focus .page-link .previous {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}
.page-item:focus .page-link .next {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.page-item:hover .page-link {
  /*rtl:options:{"autoRename":false}*/
}
.page-item:hover .page-link i {
  color: #009EF7;
}
.page-item:hover .page-link .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.page-item:hover .page-link .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.page-item:hover .page-link .previous {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}
.page-item:hover .page-link .next {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.page-item.active .page-link {
  /*rtl:options:{"autoRename":false}*/
}
.page-item.active .page-link i {
  color: #FFFFFF;
}
.page-item.active .page-link .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.page-item.active .page-link .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.page-item.active .page-link .previous {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
.page-item.active .page-link .next {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
.page-item.disabled .page-link {
  /*rtl:options:{"autoRename":false}*/
}
.page-item.disabled .page-link i {
  color: #B5B5C3;
}
.page-item.disabled .page-link .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #B5B5C3;
}
.page-item.disabled .page-link .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.page-item.disabled .page-link .previous {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}
.page-item.disabled .page-link .next {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}

@media (max-width: 991.98px) {
  .page-item {
    margin-right: 0.25rem;
  }
  .page-item:last-child {
    margin-right: 0;
  }
}
.separator {
  display: block;
  height: 0;
  border-bottom: 1px solid #EFF2F5;
}
.separator.separator-dotted {
  border-bottom-style: dotted;
  border-bottom-color: #E4E6EF;
}
.separator.separator-dashed {
  border-bottom-style: dashed;
  border-bottom-color: #E4E6EF;
}
.separator.separator-content {
  display: flex;
  align-items: center;
  border-bottom: 0;
  text-align: center;
}
.separator.separator-content::before, .separator.separator-content::after {
  content: " ";
  width: 50%;
  border-bottom: 1px solid #EFF2F5;
}
.separator.separator-content::before {
  margin-right: 1.25rem;
}
.separator.separator-content::after {
  margin-left: 1.25rem;
}
.separator.separator-content.separator-dotted::before, .separator.separator-content.separator-dotted::after {
  border-bottom-style: dotted;
  border-bottom-color: #E4E6EF;
}
.separator.separator-content.separator-dashed::before, .separator.separator-content.separator-dashed::after {
  border-bottom-style: dashed;
  border-bottom-color: #E4E6EF;
}
.separator.separator-content.border-white::before, .separator.separator-content.border-white::after {
  border-color: #ffffff !important;
}
.separator.separator-content.border-light::before, .separator.separator-content.border-light::after {
  border-color: #F5F8FA !important;
}
.separator.separator-content.border-primary::before, .separator.separator-content.border-primary::after {
  border-color: #009EF7 !important;
}
.separator.separator-content.border-secondary::before, .separator.separator-content.border-secondary::after {
  border-color: #E4E6EF !important;
}
.separator.separator-content.border-success::before, .separator.separator-content.border-success::after {
  border-color: #50CD89 !important;
}
.separator.separator-content.border-info::before, .separator.separator-content.border-info::after {
  border-color: #7239EA !important;
}
.separator.separator-content.border-warning::before, .separator.separator-content.border-warning::after {
  border-color: #FFC700 !important;
}
.separator.separator-content.border-danger::before, .separator.separator-content.border-danger::after {
  border-color: #F1416C !important;
}
.separator.separator-content.border-dark::before, .separator.separator-content.border-dark::after {
  border-color: #181C32 !important;
}

.carousel.carousel-custom .carousel-indicators {
  align-items: center;
  position: static;
  z-index: auto;
  margin: 0;
  padding: 0;
  list-style: none;
}
.carousel.carousel-custom .carousel-indicators li {
  transform: none;
  opacity: 1;
}
.carousel.carousel-custom .carousel-indicators li.active {
  transform: none;
  opacity: 1;
}
.carousel.carousel-custom .carousel-indicators.carousel-indicators-dots li {
  border-radius: 0;
  background-color: transparent;
  height: 13px;
  width: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.carousel.carousel-custom .carousel-indicators.carousel-indicators-dots li:after {
  display: inline-block;
  content: " ";
  border-radius: 50%;
  transition: all 0.3s ease;
  background-color: #EFF2F5;
  height: 9px;
  width: 9px;
}
.carousel.carousel-custom .carousel-indicators.carousel-indicators-dots li.active {
  background-color: transparent;
}
.carousel.carousel-custom .carousel-indicators.carousel-indicators-dots li.active:after {
  transition: all 0.3s ease;
  height: 13px;
  width: 13px;
  background-color: #E4E6EF;
}
.carousel.carousel-custom.carousel-stretch {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.carousel.carousel-custom.carousel-stretch .carousel-inner {
  flex-grow: 1;
}
.carousel.carousel-custom.carousel-stretch .carousel-item {
  height: 100%;
}
.carousel.carousel-custom.carousel-stretch .carousel-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.menu-group {
  display: flex;
}

.menu,
.menu-wrapper {
  display: flex;
  padding: 0;
  margin: 0;
  list-style: none;
}

.menu-sub {
  display: none;
  padding: 0;
  margin: 0;
  list-style: none;
  flex-direction: column;
}

.menu-item {
  display: block;
  padding: 0;
}
.menu-item .menu-link {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0;
  flex: 0 0 100%;
  padding: 0.65rem 1rem;
  transition: none;
  outline: none !important;
}
.menu-item .menu-link .menu-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  margin-right: 0.5rem;
}
.menu-item .menu-link .menu-icon .svg-icon {
  line-height: 1;
}
.menu-item .menu-link .menu-bullet {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  margin-right: 0.5rem;
}
.menu-item .menu-link .menu-title {
  display: flex;
  align-items: center;
  flex-grow: 1;
}
.menu-item .menu-link .menu-badge {
  flex-shrink: 0;
  margin-left: 0.5rem;
}
.menu-item .menu-link .menu-arrow {
  display: flex;
  align-items: stretch;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  margin-left: 0.5rem;
  width: 0.8rem;
  height: 0.8rem;
}
.menu-item .menu-link .menu-arrow:after {
  display: block;
  width: 100%;
  content: " ";
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  /*rtl:end:remove*/
}
.menu-item .menu-content {
  padding: 0.65rem 1rem;
}

.menu-item.show .menu-link .menu-arrow:after {
  -webkit-backface-visibility: hidden;
  transition: transform 0.3s ease;
}

.menu-center {
  justify-content: center;
}

.menu-item.menu-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
  /*rtl:ignore*/
  transform: rotateZ(90deg);
  transition: transform 0.3s ease;
}
[direction=rtl] .menu-item.menu-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, [direction=rtl] .menu-item.menu-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
  /*rtl:ignore*/
  transform: rotateZ(-90deg);
}

.menu-sub-dropdown {
  display: none;
  border-radius: 0.475rem;
  background-color: #ffffff;
  box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  z-index: 105;
}
.show.menu-dropdown > .menu-sub-dropdown, .menu-sub-dropdown.menu.show, .menu-sub-dropdown.show[data-popper-placement] {
  display: flex;
  animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
}
.show.menu-dropdown > .menu-sub-dropdown[data-popper-placement=top], .show.menu-dropdown > .menu-sub-dropdown[data-popper-placement=top-start], .show.menu-dropdown > .menu-sub-dropdown[data-popper-placement=top-end], .menu-sub-dropdown.menu.show[data-popper-placement=top], .menu-sub-dropdown.menu.show[data-popper-placement=top-start], .menu-sub-dropdown.menu.show[data-popper-placement=top-end], .menu-sub-dropdown.show[data-popper-placement][data-popper-placement=top], .menu-sub-dropdown.show[data-popper-placement][data-popper-placement=top-start], .menu-sub-dropdown.show[data-popper-placement][data-popper-placement=top-end] {
  animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-down 0.3s ease 1;
}

.menu-sub-accordion {
  display: none;
}
.show:not(.menu-dropdown) > .menu-sub-accordion, .menu-sub-accordion.show {
  display: flex;
}

.menu-inline {
  display: flex;
}

.menu-fit > .menu-item > .menu-content,
.menu-fit > .menu-item > .menu-link {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.menu-column {
  flex-direction: column;
  width: 100%;
}

.menu-row {
  flex-direction: row;
}
.menu-row > .menu-item {
  display: flex;
  align-items: center;
}
.menu-row > .menu-item > .menu-link .menu-arrow:after {
  /*rtl:ignore*/
  transform: rotateZ(90deg);
  transition: transform 0.3s ease;
}
[direction=rtl] .menu-row > .menu-item > .menu-link .menu-arrow:after {
  /*rtl:ignore*/
  transform: rotateZ(-90deg);
}

.menu-rounded .menu-link {
  border-radius: 0.475rem;
}

.menu-pill .menu-link {
  border-radius: 50px;
}

.menu-rounded-0 .menu-link {
  border-radius: 0 !important;
}

@media (min-width: 576px) {
  .menu-item.menu-sm-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-sm-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  [direction=rtl] .menu-item.menu-sm-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, [direction=rtl] .menu-item.menu-sm-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
  }

  .menu-sub-sm-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: #ffffff;
    box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
    z-index: 105;
  }
  .show.menu-dropdown > .menu-sub-sm-dropdown, .menu-sub-sm-dropdown.menu.show, .menu-sub-sm-dropdown.show[data-popper-placement] {
    display: flex;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .show.menu-dropdown > .menu-sub-sm-dropdown[data-popper-placement=top], .show.menu-dropdown > .menu-sub-sm-dropdown[data-popper-placement=top-start], .show.menu-dropdown > .menu-sub-sm-dropdown[data-popper-placement=top-end], .menu-sub-sm-dropdown.menu.show[data-popper-placement=top], .menu-sub-sm-dropdown.menu.show[data-popper-placement=top-start], .menu-sub-sm-dropdown.menu.show[data-popper-placement=top-end], .menu-sub-sm-dropdown.show[data-popper-placement][data-popper-placement=top], .menu-sub-sm-dropdown.show[data-popper-placement][data-popper-placement=top-start], .menu-sub-sm-dropdown.show[data-popper-placement][data-popper-placement=top-end] {
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-down 0.3s ease 1;
  }

  .menu-sub-sm-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-sm-accordion, .menu-sub-sm-accordion.show {
    display: flex;
  }

  .menu-sm-inline {
    display: flex;
  }

  .menu-sm-fit > .menu-item > .menu-content,
.menu-sm-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .menu-sm-column {
    flex-direction: column;
    width: 100%;
  }

  .menu-sm-row {
    flex-direction: row;
  }
  .menu-sm-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-sm-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  [direction=rtl] .menu-sm-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
  }

  .menu-sm-rounded .menu-link {
    border-radius: 0.475rem;
  }

  .menu-sm-pill .menu-link {
    border-radius: 50px;
  }

  .menu-sm-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (min-width: 768px) {
  .menu-item.menu-md-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-md-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  [direction=rtl] .menu-item.menu-md-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, [direction=rtl] .menu-item.menu-md-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
  }

  .menu-sub-md-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: #ffffff;
    box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
    z-index: 105;
  }
  .show.menu-dropdown > .menu-sub-md-dropdown, .menu-sub-md-dropdown.menu.show, .menu-sub-md-dropdown.show[data-popper-placement] {
    display: flex;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .show.menu-dropdown > .menu-sub-md-dropdown[data-popper-placement=top], .show.menu-dropdown > .menu-sub-md-dropdown[data-popper-placement=top-start], .show.menu-dropdown > .menu-sub-md-dropdown[data-popper-placement=top-end], .menu-sub-md-dropdown.menu.show[data-popper-placement=top], .menu-sub-md-dropdown.menu.show[data-popper-placement=top-start], .menu-sub-md-dropdown.menu.show[data-popper-placement=top-end], .menu-sub-md-dropdown.show[data-popper-placement][data-popper-placement=top], .menu-sub-md-dropdown.show[data-popper-placement][data-popper-placement=top-start], .menu-sub-md-dropdown.show[data-popper-placement][data-popper-placement=top-end] {
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-down 0.3s ease 1;
  }

  .menu-sub-md-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-md-accordion, .menu-sub-md-accordion.show {
    display: flex;
  }

  .menu-md-inline {
    display: flex;
  }

  .menu-md-fit > .menu-item > .menu-content,
.menu-md-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .menu-md-column {
    flex-direction: column;
    width: 100%;
  }

  .menu-md-row {
    flex-direction: row;
  }
  .menu-md-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-md-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  [direction=rtl] .menu-md-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
  }

  .menu-md-rounded .menu-link {
    border-radius: 0.475rem;
  }

  .menu-md-pill .menu-link {
    border-radius: 50px;
  }

  .menu-md-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (min-width: 992px) {
  .menu-item.menu-lg-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-lg-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  [direction=rtl] .menu-item.menu-lg-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, [direction=rtl] .menu-item.menu-lg-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
  }

  .menu-sub-lg-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: #ffffff;
    box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
    z-index: 105;
  }
  .show.menu-dropdown > .menu-sub-lg-dropdown, .menu-sub-lg-dropdown.menu.show, .menu-sub-lg-dropdown.show[data-popper-placement] {
    display: flex;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .show.menu-dropdown > .menu-sub-lg-dropdown[data-popper-placement=top], .show.menu-dropdown > .menu-sub-lg-dropdown[data-popper-placement=top-start], .show.menu-dropdown > .menu-sub-lg-dropdown[data-popper-placement=top-end], .menu-sub-lg-dropdown.menu.show[data-popper-placement=top], .menu-sub-lg-dropdown.menu.show[data-popper-placement=top-start], .menu-sub-lg-dropdown.menu.show[data-popper-placement=top-end], .menu-sub-lg-dropdown.show[data-popper-placement][data-popper-placement=top], .menu-sub-lg-dropdown.show[data-popper-placement][data-popper-placement=top-start], .menu-sub-lg-dropdown.show[data-popper-placement][data-popper-placement=top-end] {
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-down 0.3s ease 1;
  }

  .menu-sub-lg-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-lg-accordion, .menu-sub-lg-accordion.show {
    display: flex;
  }

  .menu-lg-inline {
    display: flex;
  }

  .menu-lg-fit > .menu-item > .menu-content,
.menu-lg-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .menu-lg-column {
    flex-direction: column;
    width: 100%;
  }

  .menu-lg-row {
    flex-direction: row;
  }
  .menu-lg-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-lg-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  [direction=rtl] .menu-lg-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
  }

  .menu-lg-rounded .menu-link {
    border-radius: 0.475rem;
  }

  .menu-lg-pill .menu-link {
    border-radius: 50px;
  }

  .menu-lg-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (min-width: 1200px) {
  .menu-item.menu-xl-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xl-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  [direction=rtl] .menu-item.menu-xl-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, [direction=rtl] .menu-item.menu-xl-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
  }

  .menu-sub-xl-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: #ffffff;
    box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
    z-index: 105;
  }
  .show.menu-dropdown > .menu-sub-xl-dropdown, .menu-sub-xl-dropdown.menu.show, .menu-sub-xl-dropdown.show[data-popper-placement] {
    display: flex;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .show.menu-dropdown > .menu-sub-xl-dropdown[data-popper-placement=top], .show.menu-dropdown > .menu-sub-xl-dropdown[data-popper-placement=top-start], .show.menu-dropdown > .menu-sub-xl-dropdown[data-popper-placement=top-end], .menu-sub-xl-dropdown.menu.show[data-popper-placement=top], .menu-sub-xl-dropdown.menu.show[data-popper-placement=top-start], .menu-sub-xl-dropdown.menu.show[data-popper-placement=top-end], .menu-sub-xl-dropdown.show[data-popper-placement][data-popper-placement=top], .menu-sub-xl-dropdown.show[data-popper-placement][data-popper-placement=top-start], .menu-sub-xl-dropdown.show[data-popper-placement][data-popper-placement=top-end] {
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-down 0.3s ease 1;
  }

  .menu-sub-xl-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-xl-accordion, .menu-sub-xl-accordion.show {
    display: flex;
  }

  .menu-xl-inline {
    display: flex;
  }

  .menu-xl-fit > .menu-item > .menu-content,
.menu-xl-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .menu-xl-column {
    flex-direction: column;
    width: 100%;
  }

  .menu-xl-row {
    flex-direction: row;
  }
  .menu-xl-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-xl-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  [direction=rtl] .menu-xl-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
  }

  .menu-xl-rounded .menu-link {
    border-radius: 0.475rem;
  }

  .menu-xl-pill .menu-link {
    border-radius: 50px;
  }

  .menu-xl-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (min-width: 1400px) {
  .menu-item.menu-xxl-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xxl-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  [direction=rtl] .menu-item.menu-xxl-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, [direction=rtl] .menu-item.menu-xxl-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
  }

  .menu-sub-xxl-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: #ffffff;
    box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
    z-index: 105;
  }
  .show.menu-dropdown > .menu-sub-xxl-dropdown, .menu-sub-xxl-dropdown.menu.show, .menu-sub-xxl-dropdown.show[data-popper-placement] {
    display: flex;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .show.menu-dropdown > .menu-sub-xxl-dropdown[data-popper-placement=top], .show.menu-dropdown > .menu-sub-xxl-dropdown[data-popper-placement=top-start], .show.menu-dropdown > .menu-sub-xxl-dropdown[data-popper-placement=top-end], .menu-sub-xxl-dropdown.menu.show[data-popper-placement=top], .menu-sub-xxl-dropdown.menu.show[data-popper-placement=top-start], .menu-sub-xxl-dropdown.menu.show[data-popper-placement=top-end], .menu-sub-xxl-dropdown.show[data-popper-placement][data-popper-placement=top], .menu-sub-xxl-dropdown.show[data-popper-placement][data-popper-placement=top-start], .menu-sub-xxl-dropdown.show[data-popper-placement][data-popper-placement=top-end] {
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-down 0.3s ease 1;
  }

  .menu-sub-xxl-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-xxl-accordion, .menu-sub-xxl-accordion.show {
    display: flex;
  }

  .menu-xxl-inline {
    display: flex;
  }

  .menu-xxl-fit > .menu-item > .menu-content,
.menu-xxl-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .menu-xxl-column {
    flex-direction: column;
    width: 100%;
  }

  .menu-xxl-row {
    flex-direction: row;
  }
  .menu-xxl-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-xxl-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  [direction=rtl] .menu-xxl-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
  }

  .menu-xxl-rounded .menu-link {
    border-radius: 0.475rem;
  }

  .menu-xxl-pill .menu-link {
    border-radius: 50px;
  }

  .menu-xxl-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (max-width: 575.98px) {
  .menu-item.menu-sm-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-sm-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  [direction=rtl] .menu-item.menu-sm-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, [direction=rtl] .menu-item.menu-sm-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
  }

  .menu-sub-sm-down-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: #ffffff;
    box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
    z-index: 105;
  }
  .show.menu-dropdown > .menu-sub-sm-down-dropdown, .menu-sub-sm-down-dropdown.menu.show, .menu-sub-sm-down-dropdown.show[data-popper-placement] {
    display: flex;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .show.menu-dropdown > .menu-sub-sm-down-dropdown[data-popper-placement=top], .show.menu-dropdown > .menu-sub-sm-down-dropdown[data-popper-placement=top-start], .show.menu-dropdown > .menu-sub-sm-down-dropdown[data-popper-placement=top-end], .menu-sub-sm-down-dropdown.menu.show[data-popper-placement=top], .menu-sub-sm-down-dropdown.menu.show[data-popper-placement=top-start], .menu-sub-sm-down-dropdown.menu.show[data-popper-placement=top-end], .menu-sub-sm-down-dropdown.show[data-popper-placement][data-popper-placement=top], .menu-sub-sm-down-dropdown.show[data-popper-placement][data-popper-placement=top-start], .menu-sub-sm-down-dropdown.show[data-popper-placement][data-popper-placement=top-end] {
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-down 0.3s ease 1;
  }

  .menu-sub-sm-down-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-sm-down-accordion, .menu-sub-sm-down-accordion.show {
    display: flex;
  }

  .menu-sm-down-inline {
    display: flex;
  }

  .menu-sm-down-fit > .menu-item > .menu-content,
.menu-sm-down-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .menu-sm-down-column {
    flex-direction: column;
    width: 100%;
  }

  .menu-sm-down-row {
    flex-direction: row;
  }
  .menu-sm-down-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-sm-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  [direction=rtl] .menu-sm-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
  }

  .menu-sm-down-rounded .menu-link {
    border-radius: 0.475rem;
  }

  .menu-sm-down-pill .menu-link {
    border-radius: 50px;
  }

  .menu-sm-down-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (max-width: 767.98px) {
  .menu-item.menu-md-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-md-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  [direction=rtl] .menu-item.menu-md-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, [direction=rtl] .menu-item.menu-md-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
  }

  .menu-sub-md-down-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: #ffffff;
    box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
    z-index: 105;
  }
  .show.menu-dropdown > .menu-sub-md-down-dropdown, .menu-sub-md-down-dropdown.menu.show, .menu-sub-md-down-dropdown.show[data-popper-placement] {
    display: flex;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .show.menu-dropdown > .menu-sub-md-down-dropdown[data-popper-placement=top], .show.menu-dropdown > .menu-sub-md-down-dropdown[data-popper-placement=top-start], .show.menu-dropdown > .menu-sub-md-down-dropdown[data-popper-placement=top-end], .menu-sub-md-down-dropdown.menu.show[data-popper-placement=top], .menu-sub-md-down-dropdown.menu.show[data-popper-placement=top-start], .menu-sub-md-down-dropdown.menu.show[data-popper-placement=top-end], .menu-sub-md-down-dropdown.show[data-popper-placement][data-popper-placement=top], .menu-sub-md-down-dropdown.show[data-popper-placement][data-popper-placement=top-start], .menu-sub-md-down-dropdown.show[data-popper-placement][data-popper-placement=top-end] {
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-down 0.3s ease 1;
  }

  .menu-sub-md-down-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-md-down-accordion, .menu-sub-md-down-accordion.show {
    display: flex;
  }

  .menu-md-down-inline {
    display: flex;
  }

  .menu-md-down-fit > .menu-item > .menu-content,
.menu-md-down-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .menu-md-down-column {
    flex-direction: column;
    width: 100%;
  }

  .menu-md-down-row {
    flex-direction: row;
  }
  .menu-md-down-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-md-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  [direction=rtl] .menu-md-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
  }

  .menu-md-down-rounded .menu-link {
    border-radius: 0.475rem;
  }

  .menu-md-down-pill .menu-link {
    border-radius: 50px;
  }

  .menu-md-down-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (max-width: 991.98px) {
  .menu-item.menu-lg-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-lg-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  [direction=rtl] .menu-item.menu-lg-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, [direction=rtl] .menu-item.menu-lg-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
  }

  .menu-sub-lg-down-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: #ffffff;
    box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
    z-index: 105;
  }
  .show.menu-dropdown > .menu-sub-lg-down-dropdown, .menu-sub-lg-down-dropdown.menu.show, .menu-sub-lg-down-dropdown.show[data-popper-placement] {
    display: flex;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .show.menu-dropdown > .menu-sub-lg-down-dropdown[data-popper-placement=top], .show.menu-dropdown > .menu-sub-lg-down-dropdown[data-popper-placement=top-start], .show.menu-dropdown > .menu-sub-lg-down-dropdown[data-popper-placement=top-end], .menu-sub-lg-down-dropdown.menu.show[data-popper-placement=top], .menu-sub-lg-down-dropdown.menu.show[data-popper-placement=top-start], .menu-sub-lg-down-dropdown.menu.show[data-popper-placement=top-end], .menu-sub-lg-down-dropdown.show[data-popper-placement][data-popper-placement=top], .menu-sub-lg-down-dropdown.show[data-popper-placement][data-popper-placement=top-start], .menu-sub-lg-down-dropdown.show[data-popper-placement][data-popper-placement=top-end] {
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-down 0.3s ease 1;
  }

  .menu-sub-lg-down-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-lg-down-accordion, .menu-sub-lg-down-accordion.show {
    display: flex;
  }

  .menu-lg-down-inline {
    display: flex;
  }

  .menu-lg-down-fit > .menu-item > .menu-content,
.menu-lg-down-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .menu-lg-down-column {
    flex-direction: column;
    width: 100%;
  }

  .menu-lg-down-row {
    flex-direction: row;
  }
  .menu-lg-down-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-lg-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  [direction=rtl] .menu-lg-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
  }

  .menu-lg-down-rounded .menu-link {
    border-radius: 0.475rem;
  }

  .menu-lg-down-pill .menu-link {
    border-radius: 50px;
  }

  .menu-lg-down-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (max-width: 1199.98px) {
  .menu-item.menu-xl-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xl-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  [direction=rtl] .menu-item.menu-xl-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, [direction=rtl] .menu-item.menu-xl-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
  }

  .menu-sub-xl-down-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: #ffffff;
    box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
    z-index: 105;
  }
  .show.menu-dropdown > .menu-sub-xl-down-dropdown, .menu-sub-xl-down-dropdown.menu.show, .menu-sub-xl-down-dropdown.show[data-popper-placement] {
    display: flex;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .show.menu-dropdown > .menu-sub-xl-down-dropdown[data-popper-placement=top], .show.menu-dropdown > .menu-sub-xl-down-dropdown[data-popper-placement=top-start], .show.menu-dropdown > .menu-sub-xl-down-dropdown[data-popper-placement=top-end], .menu-sub-xl-down-dropdown.menu.show[data-popper-placement=top], .menu-sub-xl-down-dropdown.menu.show[data-popper-placement=top-start], .menu-sub-xl-down-dropdown.menu.show[data-popper-placement=top-end], .menu-sub-xl-down-dropdown.show[data-popper-placement][data-popper-placement=top], .menu-sub-xl-down-dropdown.show[data-popper-placement][data-popper-placement=top-start], .menu-sub-xl-down-dropdown.show[data-popper-placement][data-popper-placement=top-end] {
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-down 0.3s ease 1;
  }

  .menu-sub-xl-down-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-xl-down-accordion, .menu-sub-xl-down-accordion.show {
    display: flex;
  }

  .menu-xl-down-inline {
    display: flex;
  }

  .menu-xl-down-fit > .menu-item > .menu-content,
.menu-xl-down-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .menu-xl-down-column {
    flex-direction: column;
    width: 100%;
  }

  .menu-xl-down-row {
    flex-direction: row;
  }
  .menu-xl-down-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-xl-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  [direction=rtl] .menu-xl-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
  }

  .menu-xl-down-rounded .menu-link {
    border-radius: 0.475rem;
  }

  .menu-xl-down-pill .menu-link {
    border-radius: 50px;
  }

  .menu-xl-down-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (max-width: 1399.98px) {
  .menu-item.menu-xxl-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xxl-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  [direction=rtl] .menu-item.menu-xxl-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, [direction=rtl] .menu-item.menu-xxl-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
  }

  .menu-sub-xxl-down-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: #ffffff;
    box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
    z-index: 105;
  }
  .show.menu-dropdown > .menu-sub-xxl-down-dropdown, .menu-sub-xxl-down-dropdown.menu.show, .menu-sub-xxl-down-dropdown.show[data-popper-placement] {
    display: flex;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .show.menu-dropdown > .menu-sub-xxl-down-dropdown[data-popper-placement=top], .show.menu-dropdown > .menu-sub-xxl-down-dropdown[data-popper-placement=top-start], .show.menu-dropdown > .menu-sub-xxl-down-dropdown[data-popper-placement=top-end], .menu-sub-xxl-down-dropdown.menu.show[data-popper-placement=top], .menu-sub-xxl-down-dropdown.menu.show[data-popper-placement=top-start], .menu-sub-xxl-down-dropdown.menu.show[data-popper-placement=top-end], .menu-sub-xxl-down-dropdown.show[data-popper-placement][data-popper-placement=top], .menu-sub-xxl-down-dropdown.show[data-popper-placement][data-popper-placement=top-start], .menu-sub-xxl-down-dropdown.show[data-popper-placement][data-popper-placement=top-end] {
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-down 0.3s ease 1;
  }

  .menu-sub-xxl-down-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-xxl-down-accordion, .menu-sub-xxl-down-accordion.show {
    display: flex;
  }

  .menu-xxl-down-inline {
    display: flex;
  }

  .menu-xxl-down-fit > .menu-item > .menu-content,
.menu-xxl-down-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .menu-xxl-down-column {
    flex-direction: column;
    width: 100%;
  }

  .menu-xxl-down-row {
    flex-direction: row;
  }
  .menu-xxl-down-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-xxl-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  [direction=rtl] .menu-xxl-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
  }

  .menu-xxl-down-rounded .menu-link {
    border-radius: 0.475rem;
  }

  .menu-xxl-down-pill .menu-link {
    border-radius: 50px;
  }

  .menu-xxl-down-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
.menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: calc(1rem + 1rem);
}
.menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: calc(2rem + 1rem);
}
.menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: calc(3rem + 1rem);
}
.menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: calc(4rem + 1rem);
}
.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: 1rem;
  padding-right: 0;
}
.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: calc(2rem);
  padding-right: 0;
}
.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: calc(3rem);
  padding-right: 0;
}
.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: calc(4rem);
  padding-right: 0;
}

@keyframes menu-sub-dropdown-animation-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes menu-sub-dropdown-animation-move-up {
  from {
    margin-top: 0.75rem;
  }
  to {
    margin-top: 0;
  }
}
@keyframes menu-sub-dropdown-animation-move-down {
  from {
    margin-bottom: 0.75rem;
  }
  to {
    margin-bottom: 0;
  }
}
.menu-white .menu-item .menu-link {
  color: #ffffff;
}
.menu-white .menu-item .menu-link .menu-title {
  color: #ffffff;
}
.menu-white .menu-item .menu-link .menu-icon i {
  color: #ffffff;
}
.menu-white .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.menu-white .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-white .menu-item .menu-link .menu-bullet .bullet {
  background-color: #ffffff;
}
.menu-white .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  /*rtl:end:remove*/
}

.menu-title-white .menu-item .menu-link {
  color: #ffffff;
}
.menu-title-white .menu-item .menu-link .menu-title {
  color: #ffffff;
}

.menu-icon-white .menu-item .menu-link .menu-icon i {
  color: #ffffff;
}
.menu-icon-white .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.menu-icon-white .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-bullet-white .menu-item .menu-link .menu-bullet .bullet {
  background-color: #ffffff;
}

.menu-arrow-white .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  /*rtl:end:remove*/
}

.menu-primary .menu-item .menu-link {
  color: #009EF7;
}
.menu-primary .menu-item .menu-link .menu-title {
  color: #009EF7;
}
.menu-primary .menu-item .menu-link .menu-icon i {
  color: #009EF7;
}
.menu-primary .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-primary .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-primary .menu-item .menu-link .menu-bullet .bullet {
  background-color: #009EF7;
}
.menu-primary .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}

.menu-title-primary .menu-item .menu-link {
  color: #009EF7;
}
.menu-title-primary .menu-item .menu-link .menu-title {
  color: #009EF7;
}

.menu-icon-primary .menu-item .menu-link .menu-icon i {
  color: #009EF7;
}
.menu-icon-primary .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-icon-primary .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-bullet-primary .menu-item .menu-link .menu-bullet .bullet {
  background-color: #009EF7;
}

.menu-arrow-primary .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}

.menu-secondary .menu-item .menu-link {
  color: #E4E6EF;
}
.menu-secondary .menu-item .menu-link .menu-title {
  color: #E4E6EF;
}
.menu-secondary .menu-item .menu-link .menu-icon i {
  color: #E4E6EF;
}
.menu-secondary .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #E4E6EF;
}
.menu-secondary .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-secondary .menu-item .menu-link .menu-bullet .bullet {
  background-color: #E4E6EF;
}
.menu-secondary .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  /*rtl:end:remove*/
}

.menu-title-secondary .menu-item .menu-link {
  color: #E4E6EF;
}
.menu-title-secondary .menu-item .menu-link .menu-title {
  color: #E4E6EF;
}

.menu-icon-secondary .menu-item .menu-link .menu-icon i {
  color: #E4E6EF;
}
.menu-icon-secondary .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #E4E6EF;
}
.menu-icon-secondary .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-bullet-secondary .menu-item .menu-link .menu-bullet .bullet {
  background-color: #E4E6EF;
}

.menu-arrow-secondary .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  /*rtl:end:remove*/
}

.menu-light .menu-item .menu-link {
  color: #F5F8FA;
}
.menu-light .menu-item .menu-link .menu-title {
  color: #F5F8FA;
}
.menu-light .menu-item .menu-link .menu-icon i {
  color: #F5F8FA;
}
.menu-light .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F5F8FA;
}
.menu-light .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-light .menu-item .menu-link .menu-bullet .bullet {
  background-color: #F5F8FA;
}
.menu-light .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
  /*rtl:end:remove*/
}

.menu-title-light .menu-item .menu-link {
  color: #F5F8FA;
}
.menu-title-light .menu-item .menu-link .menu-title {
  color: #F5F8FA;
}

.menu-icon-light .menu-item .menu-link .menu-icon i {
  color: #F5F8FA;
}
.menu-icon-light .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F5F8FA;
}
.menu-icon-light .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-bullet-light .menu-item .menu-link .menu-bullet .bullet {
  background-color: #F5F8FA;
}

.menu-arrow-light .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
  /*rtl:end:remove*/
}

.menu-success .menu-item .menu-link {
  color: #50CD89;
}
.menu-success .menu-item .menu-link .menu-title {
  color: #50CD89;
}
.menu-success .menu-item .menu-link .menu-icon i {
  color: #50CD89;
}
.menu-success .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #50CD89;
}
.menu-success .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-success .menu-item .menu-link .menu-bullet .bullet {
  background-color: #50CD89;
}
.menu-success .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
  /*rtl:end:remove*/
}

.menu-title-success .menu-item .menu-link {
  color: #50CD89;
}
.menu-title-success .menu-item .menu-link .menu-title {
  color: #50CD89;
}

.menu-icon-success .menu-item .menu-link .menu-icon i {
  color: #50CD89;
}
.menu-icon-success .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #50CD89;
}
.menu-icon-success .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-bullet-success .menu-item .menu-link .menu-bullet .bullet {
  background-color: #50CD89;
}

.menu-arrow-success .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
  /*rtl:end:remove*/
}

.menu-info .menu-item .menu-link {
  color: #7239EA;
}
.menu-info .menu-item .menu-link .menu-title {
  color: #7239EA;
}
.menu-info .menu-item .menu-link .menu-icon i {
  color: #7239EA;
}
.menu-info .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7239EA;
}
.menu-info .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-info .menu-item .menu-link .menu-bullet .bullet {
  background-color: #7239EA;
}
.menu-info .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-title-info .menu-item .menu-link {
  color: #7239EA;
}
.menu-title-info .menu-item .menu-link .menu-title {
  color: #7239EA;
}

.menu-icon-info .menu-item .menu-link .menu-icon i {
  color: #7239EA;
}
.menu-icon-info .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7239EA;
}
.menu-icon-info .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-bullet-info .menu-item .menu-link .menu-bullet .bullet {
  background-color: #7239EA;
}

.menu-arrow-info .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-warning .menu-item .menu-link {
  color: #FFC700;
}
.menu-warning .menu-item .menu-link .menu-title {
  color: #FFC700;
}
.menu-warning .menu-item .menu-link .menu-icon i {
  color: #FFC700;
}
.menu-warning .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFC700;
}
.menu-warning .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-warning .menu-item .menu-link .menu-bullet .bullet {
  background-color: #FFC700;
}
.menu-warning .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
  /*rtl:end:remove*/
}

.menu-title-warning .menu-item .menu-link {
  color: #FFC700;
}
.menu-title-warning .menu-item .menu-link .menu-title {
  color: #FFC700;
}

.menu-icon-warning .menu-item .menu-link .menu-icon i {
  color: #FFC700;
}
.menu-icon-warning .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFC700;
}
.menu-icon-warning .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-bullet-warning .menu-item .menu-link .menu-bullet .bullet {
  background-color: #FFC700;
}

.menu-arrow-warning .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
  /*rtl:end:remove*/
}

.menu-danger .menu-item .menu-link {
  color: #F1416C;
}
.menu-danger .menu-item .menu-link .menu-title {
  color: #F1416C;
}
.menu-danger .menu-item .menu-link .menu-icon i {
  color: #F1416C;
}
.menu-danger .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F1416C;
}
.menu-danger .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-danger .menu-item .menu-link .menu-bullet .bullet {
  background-color: #F1416C;
}
.menu-danger .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}

.menu-title-danger .menu-item .menu-link {
  color: #F1416C;
}
.menu-title-danger .menu-item .menu-link .menu-title {
  color: #F1416C;
}

.menu-icon-danger .menu-item .menu-link .menu-icon i {
  color: #F1416C;
}
.menu-icon-danger .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F1416C;
}
.menu-icon-danger .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-bullet-danger .menu-item .menu-link .menu-bullet .bullet {
  background-color: #F1416C;
}

.menu-arrow-danger .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}

.menu-dark .menu-item .menu-link {
  color: #181C32;
}
.menu-dark .menu-item .menu-link .menu-title {
  color: #181C32;
}
.menu-dark .menu-item .menu-link .menu-icon i {
  color: #181C32;
}
.menu-dark .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #181C32;
}
.menu-dark .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-dark .menu-item .menu-link .menu-bullet .bullet {
  background-color: #181C32;
}
.menu-dark .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  /*rtl:end:remove*/
}

.menu-title-dark .menu-item .menu-link {
  color: #181C32;
}
.menu-title-dark .menu-item .menu-link .menu-title {
  color: #181C32;
}

.menu-icon-dark .menu-item .menu-link .menu-icon i {
  color: #181C32;
}
.menu-icon-dark .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #181C32;
}
.menu-icon-dark .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-bullet-dark .menu-item .menu-link .menu-bullet .bullet {
  background-color: #181C32;
}

.menu-arrow-dark .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  /*rtl:end:remove*/
}

.menu-muted .menu-item .menu-link {
  color: #A1A5B7;
}
.menu-muted .menu-item .menu-link .menu-title {
  color: #A1A5B7;
}
.menu-muted .menu-item .menu-link .menu-icon i {
  color: #A1A5B7;
}
.menu-muted .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.menu-muted .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-muted .menu-item .menu-link .menu-bullet .bullet {
  background-color: #A1A5B7;
}
.menu-muted .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  /*rtl:end:remove*/
}

.menu-title-muted .menu-item .menu-link {
  color: #A1A5B7;
}
.menu-title-muted .menu-item .menu-link .menu-title {
  color: #A1A5B7;
}

.menu-icon-muted .menu-item .menu-link .menu-icon i {
  color: #A1A5B7;
}
.menu-icon-muted .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.menu-icon-muted .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-bullet-muted .menu-item .menu-link .menu-bullet .bullet {
  background-color: #A1A5B7;
}

.menu-arrow-muted .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  /*rtl:end:remove*/
}

.menu-gray-100 .menu-item .menu-link {
  color: #F5F8FA;
}
.menu-gray-100 .menu-item .menu-link .menu-title {
  color: #F5F8FA;
}
.menu-gray-100 .menu-item .menu-link .menu-icon i {
  color: #F5F8FA;
}
.menu-gray-100 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F5F8FA;
}
.menu-gray-100 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-gray-100 .menu-item .menu-link .menu-bullet .bullet {
  background-color: #F5F8FA;
}
.menu-gray-100 .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
  /*rtl:end:remove*/
}

.menu-title-gray-100 .menu-item .menu-link {
  color: #F5F8FA;
}
.menu-title-gray-100 .menu-item .menu-link .menu-title {
  color: #F5F8FA;
}

.menu-icon-gray-100 .menu-item .menu-link .menu-icon i {
  color: #F5F8FA;
}
.menu-icon-gray-100 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F5F8FA;
}
.menu-icon-gray-100 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-bullet-gray-100 .menu-item .menu-link .menu-bullet .bullet {
  background-color: #F5F8FA;
}

.menu-arrow-gray-100 .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
  /*rtl:end:remove*/
}

.menu-gray-200 .menu-item .menu-link {
  color: #EFF2F5;
}
.menu-gray-200 .menu-item .menu-link .menu-title {
  color: #EFF2F5;
}
.menu-gray-200 .menu-item .menu-link .menu-icon i {
  color: #EFF2F5;
}
.menu-gray-200 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #EFF2F5;
}
.menu-gray-200 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-gray-200 .menu-item .menu-link .menu-bullet .bullet {
  background-color: #EFF2F5;
}
.menu-gray-200 .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  /*rtl:end:remove*/
}

.menu-title-gray-200 .menu-item .menu-link {
  color: #EFF2F5;
}
.menu-title-gray-200 .menu-item .menu-link .menu-title {
  color: #EFF2F5;
}

.menu-icon-gray-200 .menu-item .menu-link .menu-icon i {
  color: #EFF2F5;
}
.menu-icon-gray-200 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #EFF2F5;
}
.menu-icon-gray-200 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-bullet-gray-200 .menu-item .menu-link .menu-bullet .bullet {
  background-color: #EFF2F5;
}

.menu-arrow-gray-200 .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  /*rtl:end:remove*/
}

.menu-gray-300 .menu-item .menu-link {
  color: #E4E6EF;
}
.menu-gray-300 .menu-item .menu-link .menu-title {
  color: #E4E6EF;
}
.menu-gray-300 .menu-item .menu-link .menu-icon i {
  color: #E4E6EF;
}
.menu-gray-300 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #E4E6EF;
}
.menu-gray-300 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-gray-300 .menu-item .menu-link .menu-bullet .bullet {
  background-color: #E4E6EF;
}
.menu-gray-300 .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  /*rtl:end:remove*/
}

.menu-title-gray-300 .menu-item .menu-link {
  color: #E4E6EF;
}
.menu-title-gray-300 .menu-item .menu-link .menu-title {
  color: #E4E6EF;
}

.menu-icon-gray-300 .menu-item .menu-link .menu-icon i {
  color: #E4E6EF;
}
.menu-icon-gray-300 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #E4E6EF;
}
.menu-icon-gray-300 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-bullet-gray-300 .menu-item .menu-link .menu-bullet .bullet {
  background-color: #E4E6EF;
}

.menu-arrow-gray-300 .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  /*rtl:end:remove*/
}

.menu-gray-400 .menu-item .menu-link {
  color: #B5B5C3;
}
.menu-gray-400 .menu-item .menu-link .menu-title {
  color: #B5B5C3;
}
.menu-gray-400 .menu-item .menu-link .menu-icon i {
  color: #B5B5C3;
}
.menu-gray-400 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #B5B5C3;
}
.menu-gray-400 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-gray-400 .menu-item .menu-link .menu-bullet .bullet {
  background-color: #B5B5C3;
}
.menu-gray-400 .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  /*rtl:end:remove*/
}

.menu-title-gray-400 .menu-item .menu-link {
  color: #B5B5C3;
}
.menu-title-gray-400 .menu-item .menu-link .menu-title {
  color: #B5B5C3;
}

.menu-icon-gray-400 .menu-item .menu-link .menu-icon i {
  color: #B5B5C3;
}
.menu-icon-gray-400 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #B5B5C3;
}
.menu-icon-gray-400 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-bullet-gray-400 .menu-item .menu-link .menu-bullet .bullet {
  background-color: #B5B5C3;
}

.menu-arrow-gray-400 .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  /*rtl:end:remove*/
}

.menu-gray-500 .menu-item .menu-link {
  color: #A1A5B7;
}
.menu-gray-500 .menu-item .menu-link .menu-title {
  color: #A1A5B7;
}
.menu-gray-500 .menu-item .menu-link .menu-icon i {
  color: #A1A5B7;
}
.menu-gray-500 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.menu-gray-500 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-gray-500 .menu-item .menu-link .menu-bullet .bullet {
  background-color: #A1A5B7;
}
.menu-gray-500 .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  /*rtl:end:remove*/
}

.menu-title-gray-500 .menu-item .menu-link {
  color: #A1A5B7;
}
.menu-title-gray-500 .menu-item .menu-link .menu-title {
  color: #A1A5B7;
}

.menu-icon-gray-500 .menu-item .menu-link .menu-icon i {
  color: #A1A5B7;
}
.menu-icon-gray-500 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.menu-icon-gray-500 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-bullet-gray-500 .menu-item .menu-link .menu-bullet .bullet {
  background-color: #A1A5B7;
}

.menu-arrow-gray-500 .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  /*rtl:end:remove*/
}

.menu-gray-600 .menu-item .menu-link {
  color: #7E8299;
}
.menu-gray-600 .menu-item .menu-link .menu-title {
  color: #7E8299;
}
.menu-gray-600 .menu-item .menu-link .menu-icon i {
  color: #7E8299;
}
.menu-gray-600 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7E8299;
}
.menu-gray-600 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-gray-600 .menu-item .menu-link .menu-bullet .bullet {
  background-color: #7E8299;
}
.menu-gray-600 .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
  /*rtl:end:remove*/
}

.menu-title-gray-600 .menu-item .menu-link {
  color: #7E8299;
}
.menu-title-gray-600 .menu-item .menu-link .menu-title {
  color: #7E8299;
}

.menu-icon-gray-600 .menu-item .menu-link .menu-icon i {
  color: #7E8299;
}
.menu-icon-gray-600 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7E8299;
}
.menu-icon-gray-600 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-bullet-gray-600 .menu-item .menu-link .menu-bullet .bullet {
  background-color: #7E8299;
}

.menu-arrow-gray-600 .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
  /*rtl:end:remove*/
}

.menu-gray-700 .menu-item .menu-link {
  color: #5E6278;
}
.menu-gray-700 .menu-item .menu-link .menu-title {
  color: #5E6278;
}
.menu-gray-700 .menu-item .menu-link .menu-icon i {
  color: #5E6278;
}
.menu-gray-700 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #5E6278;
}
.menu-gray-700 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-gray-700 .menu-item .menu-link .menu-bullet .bullet {
  background-color: #5E6278;
}
.menu-gray-700 .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  /*rtl:end:remove*/
}

.menu-title-gray-700 .menu-item .menu-link {
  color: #5E6278;
}
.menu-title-gray-700 .menu-item .menu-link .menu-title {
  color: #5E6278;
}

.menu-icon-gray-700 .menu-item .menu-link .menu-icon i {
  color: #5E6278;
}
.menu-icon-gray-700 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #5E6278;
}
.menu-icon-gray-700 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-bullet-gray-700 .menu-item .menu-link .menu-bullet .bullet {
  background-color: #5E6278;
}

.menu-arrow-gray-700 .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  /*rtl:end:remove*/
}

.menu-gray-800 .menu-item .menu-link {
  color: #3F4254;
}
.menu-gray-800 .menu-item .menu-link .menu-title {
  color: #3F4254;
}
.menu-gray-800 .menu-item .menu-link .menu-icon i {
  color: #3F4254;
}
.menu-gray-800 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #3F4254;
}
.menu-gray-800 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-gray-800 .menu-item .menu-link .menu-bullet .bullet {
  background-color: #3F4254;
}
.menu-gray-800 .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
  /*rtl:end:remove*/
}

.menu-title-gray-800 .menu-item .menu-link {
  color: #3F4254;
}
.menu-title-gray-800 .menu-item .menu-link .menu-title {
  color: #3F4254;
}

.menu-icon-gray-800 .menu-item .menu-link .menu-icon i {
  color: #3F4254;
}
.menu-icon-gray-800 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #3F4254;
}
.menu-icon-gray-800 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-bullet-gray-800 .menu-item .menu-link .menu-bullet .bullet {
  background-color: #3F4254;
}

.menu-arrow-gray-800 .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
  /*rtl:end:remove*/
}

.menu-gray-900 .menu-item .menu-link {
  color: #181C32;
}
.menu-gray-900 .menu-item .menu-link .menu-title {
  color: #181C32;
}
.menu-gray-900 .menu-item .menu-link .menu-icon i {
  color: #181C32;
}
.menu-gray-900 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #181C32;
}
.menu-gray-900 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-gray-900 .menu-item .menu-link .menu-bullet .bullet {
  background-color: #181C32;
}
.menu-gray-900 .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  /*rtl:end:remove*/
}

.menu-title-gray-900 .menu-item .menu-link {
  color: #181C32;
}
.menu-title-gray-900 .menu-item .menu-link .menu-title {
  color: #181C32;
}

.menu-icon-gray-900 .menu-item .menu-link .menu-icon i {
  color: #181C32;
}
.menu-icon-gray-900 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #181C32;
}
.menu-icon-gray-900 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-bullet-gray-900 .menu-item .menu-link .menu-bullet .bullet {
  background-color: #181C32;
}

.menu-arrow-gray-900 .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  /*rtl:end:remove*/
}

.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: rgba(245, 248, 250, 0.8);
}

.menu-here-bg .menu-item.here > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: rgba(245, 248, 250, 0.8);
}

.menu-show-bg .menu-item.show > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: rgba(245, 248, 250, 0.8);
}

.menu-active-bg .menu-item .menu-link.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: rgba(245, 248, 250, 0.8);
}

.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: rgba(245, 248, 250, 0.8);
}
.menu-state-bg .menu-item.here > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: rgba(245, 248, 250, 0.8);
}
.menu-state-bg .menu-item.show > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: rgba(245, 248, 250, 0.8);
}
.menu-state-bg .menu-item .menu-link.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: rgba(245, 248, 250, 0.8);
}

.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #009EF7;
}
.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: #009EF7;
}
.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: #009EF7;
}
.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g), .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g), .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: #009EF7;
}
.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}

.menu-show-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #009EF7;
}
.menu-show-primary .menu-item.show > .menu-link .menu-title {
  color: #009EF7;
}
.menu-show-primary .menu-item.show > .menu-link .menu-icon i {
  color: #009EF7;
}
.menu-show-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-show-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-show-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: #009EF7;
}
.menu-show-primary .menu-item.show > .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}

.menu-here-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #009EF7;
}
.menu-here-primary .menu-item.here > .menu-link .menu-title {
  color: #009EF7;
}
.menu-here-primary .menu-item.here > .menu-link .menu-icon i {
  color: #009EF7;
}
.menu-here-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-here-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-here-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: #009EF7;
}
.menu-here-primary .menu-item.here > .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}

.menu-active-primary .menu-item .menu-link.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #009EF7;
}
.menu-active-primary .menu-item .menu-link.active .menu-title {
  color: #009EF7;
}
.menu-active-primary .menu-item .menu-link.active .menu-icon i {
  color: #009EF7;
}
.menu-active-primary .menu-item .menu-link.active .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-active-primary .menu-item .menu-link.active .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-active-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: #009EF7;
}
.menu-active-primary .menu-item .menu-link.active .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}

.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #009EF7;
}
.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: #009EF7;
}
.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: #009EF7;
}
.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g), .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g), .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: #009EF7;
}
.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}
.menu-state-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #009EF7;
}
.menu-state-primary .menu-item.show > .menu-link .menu-title {
  color: #009EF7;
}
.menu-state-primary .menu-item.show > .menu-link .menu-icon i {
  color: #009EF7;
}
.menu-state-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-state-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-state-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: #009EF7;
}
.menu-state-primary .menu-item.show > .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}
.menu-state-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #009EF7;
}
.menu-state-primary .menu-item.here > .menu-link .menu-title {
  color: #009EF7;
}
.menu-state-primary .menu-item.here > .menu-link .menu-icon i {
  color: #009EF7;
}
.menu-state-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-state-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-state-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: #009EF7;
}
.menu-state-primary .menu-item.here > .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}
.menu-state-primary .menu-item .menu-link.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #009EF7;
}
.menu-state-primary .menu-item .menu-link.active .menu-title {
  color: #009EF7;
}
.menu-state-primary .menu-item .menu-link.active .menu-icon i {
  color: #009EF7;
}
.menu-state-primary .menu-item .menu-link.active .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-state-primary .menu-item .menu-link.active .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-state-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: #009EF7;
}
.menu-state-primary .menu-item .menu-link.active .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}

.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: #009EF7;
  color: #FFFFFF;
}
.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: #FFFFFF;
}
.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: #FFFFFF;
}
.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g), .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g), .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: #FFFFFF;
}
.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  /*rtl:end:remove*/
}

.menu-show-bg-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: #009EF7;
  color: #FFFFFF;
}
.menu-show-bg-primary .menu-item.show > .menu-link .menu-title {
  color: #FFFFFF;
}
.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon i {
  color: #FFFFFF;
}
.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-show-bg-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: #FFFFFF;
}
.menu-show-bg-primary .menu-item.show > .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  /*rtl:end:remove*/
}

.menu-here-bg-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: #009EF7;
  color: #FFFFFF;
}
.menu-here-bg-primary .menu-item.here > .menu-link .menu-title {
  color: #FFFFFF;
}
.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon i {
  color: #FFFFFF;
}
.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-here-bg-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: #FFFFFF;
}
.menu-here-bg-primary .menu-item.here > .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  /*rtl:end:remove*/
}

.menu-active-bg-primary .menu-item .menu-link.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: #009EF7;
  color: #FFFFFF;
}
.menu-active-bg-primary .menu-item .menu-link.active .menu-title {
  color: #FFFFFF;
}
.menu-active-bg-primary .menu-item .menu-link.active .menu-icon i {
  color: #FFFFFF;
}
.menu-active-bg-primary .menu-item .menu-link.active .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.menu-active-bg-primary .menu-item .menu-link.active .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-active-bg-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: #FFFFFF;
}
.menu-active-bg-primary .menu-item .menu-link.active .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  /*rtl:end:remove*/
}

.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: #009EF7;
  color: #FFFFFF;
}
.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: #FFFFFF;
}
.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: #FFFFFF;
}
.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g), .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g), .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: #FFFFFF;
}
.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  /*rtl:end:remove*/
}
.menu-state-bg-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: #009EF7;
  color: #FFFFFF;
}
.menu-state-bg-primary .menu-item.show > .menu-link .menu-title {
  color: #FFFFFF;
}
.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon i {
  color: #FFFFFF;
}
.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-state-bg-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: #FFFFFF;
}
.menu-state-bg-primary .menu-item.show > .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  /*rtl:end:remove*/
}
.menu-state-bg-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: #009EF7;
  color: #FFFFFF;
}
.menu-state-bg-primary .menu-item.here > .menu-link .menu-title {
  color: #FFFFFF;
}
.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon i {
  color: #FFFFFF;
}
.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-state-bg-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: #FFFFFF;
}
.menu-state-bg-primary .menu-item.here > .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  /*rtl:end:remove*/
}
.menu-state-bg-primary .menu-item .menu-link.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: #009EF7;
  color: #FFFFFF;
}
.menu-state-bg-primary .menu-item .menu-link.active .menu-title {
  color: #FFFFFF;
}
.menu-state-bg-primary .menu-item .menu-link.active .menu-icon i {
  color: #FFFFFF;
}
.menu-state-bg-primary .menu-item .menu-link.active .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.menu-state-bg-primary .menu-item .menu-link.active .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-state-bg-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: #FFFFFF;
}
.menu-state-bg-primary .menu-item .menu-link.active .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  /*rtl:end:remove*/
}

.menu-show-bg-light-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: #F1FAFF;
  color: #009EF7;
}
.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-title {
  color: #009EF7;
}
.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon i {
  color: #009EF7;
}
.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: #009EF7;
}
.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}

.menu-here-bg-light-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: #F1FAFF;
  color: #009EF7;
}
.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-title {
  color: #009EF7;
}
.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon i {
  color: #009EF7;
}
.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: #009EF7;
}
.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}

.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: #F1FAFF;
  color: #009EF7;
}
.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: #009EF7;
}
.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: #009EF7;
}
.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g), .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g), .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: #009EF7;
}
.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}

.menu-active-bg-light-primary .menu-item .menu-link.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: #F1FAFF;
  color: #009EF7;
}
.menu-active-bg-light-primary .menu-item .menu-link.active .menu-title {
  color: #009EF7;
}
.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon i {
  color: #009EF7;
}
.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-active-bg-light-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: #009EF7;
}
.menu-active-bg-light-primary .menu-item .menu-link.active .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}

.menu-state-bg-light-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: #F1FAFF;
  color: #009EF7;
}
.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-title {
  color: #009EF7;
}
.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon i {
  color: #009EF7;
}
.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: #009EF7;
}
.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}
.menu-state-bg-light-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: #F1FAFF;
  color: #009EF7;
}
.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-title {
  color: #009EF7;
}
.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon i {
  color: #009EF7;
}
.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: #009EF7;
}
.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}
.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: #F1FAFF;
  color: #009EF7;
}
.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: #009EF7;
}
.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: #009EF7;
}
.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g), .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g), .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: #009EF7;
}
.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}
.menu-state-bg-light-primary .menu-item .menu-link.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: #F1FAFF;
  color: #009EF7;
}
.menu-state-bg-light-primary .menu-item .menu-link.active .menu-title {
  color: #009EF7;
}
.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon i {
  color: #009EF7;
}
.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-state-bg-light-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: #009EF7;
}
.menu-state-bg-light-primary .menu-item .menu-link.active .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}

.menu-hover-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #009EF7;
}
.menu-hover-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: #009EF7;
}

.menu-here-title-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #009EF7;
}
.menu-here-title-primary .menu-item.here > .menu-link .menu-title {
  color: #009EF7;
}

.menu-show-title-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #009EF7;
}
.menu-show-title-primary .menu-item.show > .menu-link .menu-title {
  color: #009EF7;
}

.menu-active-title-primary .menu-item .menu-link.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #009EF7;
}
.menu-active-title-primary .menu-item .menu-link.active .menu-title {
  color: #009EF7;
}

.menu-state-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #009EF7;
}
.menu-state-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: #009EF7;
}
.menu-state-title-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #009EF7;
}
.menu-state-title-primary .menu-item.show > .menu-link .menu-title {
  color: #009EF7;
}
.menu-state-title-primary .menu-item .menu-link.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #009EF7;
}
.menu-state-title-primary .menu-item .menu-link.active .menu-title {
  color: #009EF7;
}

.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: #009EF7;
}
.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g), .menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g), .menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-here-icon-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon i {
  color: #009EF7;
}
.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-show-icon-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon i {
  color: #009EF7;
}
.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-active-icon-primary .menu-item .menu-link.active {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.menu-active-icon-primary .menu-item .menu-link.active .menu-icon i {
  color: #009EF7;
}
.menu-active-icon-primary .menu-item .menu-link.active .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-active-icon-primary .menu-item .menu-link.active .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: #009EF7;
}
.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g), .menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g), .menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-state-icon-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon i {
  color: #009EF7;
}
.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.menu-state-icon-primary .menu-item .menu-link.active {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.menu-state-icon-primary .menu-item .menu-link.active .menu-icon i {
  color: #009EF7;
}
.menu-state-icon-primary .menu-item .menu-link.active .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.menu-state-icon-primary .menu-item .menu-link.active .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.menu-hover-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.menu-hover-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: #009EF7;
}

.menu-show-bullet-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.menu-show-bullet-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: #009EF7;
}

.menu-here-bullet-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.menu-here-bullet-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: #009EF7;
}

.menu-active-bullet-primary .menu-item .menu-link.active {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.menu-active-bullet-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: #009EF7;
}

.menu-state-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.menu-state-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: #009EF7;
}
.menu-state-bullet-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.menu-state-bullet-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: #009EF7;
}
.menu-state-bullet-primary .menu-item .menu-link.active {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.menu-state-bullet-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: #009EF7;
}

.menu-hover-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.menu-hover-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}

.menu-here-arrow-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.menu-here-arrow-primary .menu-item.here > .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}

.menu-show-arrow-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.menu-show-arrow-primary .menu-item.show > .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}

.menu-active-arrow-primary .menu-item .menu-link.active {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.menu-active-arrow-primary .menu-item .menu-link.active .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}

.menu-state-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.menu-state-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}
.menu-state-arrow-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.menu-state-arrow-primary .menu-item.show > .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}
.menu-state-arrow-primary .menu-item .menu-link.active {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.menu-state-arrow-primary .menu-item .menu-link.active .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}

.anchor {
  display: flex;
  align-items: center;
}
.anchor a {
  position: relative;
  display: none;
  align-items: center;
  justify-content: flex-start;
  height: 1em;
  width: 1.25em;
  margin-left: -1.25em;
  font-weight: 500;
  font-size: 0.8em;
  color: #A1A5B7;
  transition: all 0.2s ease;
}
.anchor a:before {
  content: "#";
}
.anchor:hover a {
  display: flex;
}
.anchor:hover a:hover {
  color: #009EF7;
  transition: all 0.2s ease;
}

.card {
  border: 0;
  box-shadow: 0px 0px 20px 0px rgba(76, 87, 125, 0.02);
}
.card .card-header {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  min-height: 70px;
  padding: 0 2.25rem;
  background-color: transparent;
  border-bottom: var(--bs-border-width) solid #EFF2F5;
}
.card .card-header .card-title {
  display: flex;
  align-items: center;
  margin: 0.5rem;
  margin-left: 0;
}
.card .card-header .card-title.flex-column {
  align-items: flex-start;
  justify-content: center;
}
.card .card-header .card-title .card-icon {
  margin-right: 0.75rem;
  line-height: 0;
}
.card .card-header .card-title .card-icon i {
  font-size: 1.25rem;
  color: #7E8299;
  line-height: 0;
}
.card .card-header .card-title .card-icon i:after, .card .card-header .card-title .card-icon i:before {
  line-height: 0;
}
.card .card-header .card-title .card-icon .svg-icon svg {
  height: 24px;
  width: 24px;
}
.card .card-header .card-title .card-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7E8299;
}
.card .card-header .card-title .card-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.card .card-header .card-title,
.card .card-header .card-title .card-label {
  font-weight: 500;
  font-size: 1.275rem;
  color: #181C32;
}
.card .card-header .card-title .card-label {
  margin: 0 0.75rem 0 0;
  flex-wrap: wrap;
}
.card .card-header .card-title small, .card .card-header .card-title .small {
  color: #A1A5B7;
  font-size: 1rem;
}
.card .card-header .card-title h1, .card .card-header .card-title .h1, .card .card-header .card-title h2, .card .card-header .card-title .h2, .card .card-header .card-title h3, .card .card-header .card-title .h3, .card .card-header .card-title h4, .card .card-header .card-title .h4, .card .card-header .card-title h5, .card .card-header .card-title .h5, .card .card-header .card-title h6, .card .card-header .card-title .h6 {
  margin-bottom: 0;
}
.card .card-header .card-toolbar {
  display: flex;
  align-items: center;
  margin: 0.5rem 0;
  flex-wrap: wrap;
}
.card .card-body {
  padding: 2rem 2.25rem;
}
.card .card-footer {
  padding: 2rem 2.25rem;
  background-color: transparent;
  border-top: var(--bs-border-width) solid #EFF2F5;
}
.card .card-scroll {
  position: relative;
  overflow: auto;
}
.card.card-px-0 .card-header,
.card.card-px-0 .card-body,
.card.card-px-0 .card-footer {
  padding-left: 0;
  padding-right: 0;
}
.card.card-py-0 .card-header,
.card.card-py-0 .card-body,
.card.card-py-0 .card-footer {
  padding-top: 0;
  padding-bottom: 0;
}
.card.card-p-0 .card-header,
.card.card-p-0 .card-body,
.card.card-p-0 .card-footer {
  padding: 0;
}
.card.card-dashed {
  box-shadow: none;
  border: var(--bs-border-width) dashed #E4E6EF;
}
.card.card-dashed > .card-header {
  border-bottom: 1px dashed #E4E6EF;
}
.card.card-dashed > .card-footer {
  border-top: 1px dashed #E4E6EF;
}
.card.card-bordered {
  box-shadow: none;
  border: var(--bs-border-width) solid #EFF2F5;
}
.card.card-flush > .card-header {
  border-bottom: 0;
}
.card.card-flush > .card-footer {
  border-top: 0;
}
.card.card-shadow {
  box-shadow: 0px 0px 20px 0px rgba(76, 87, 125, 0.02);
  border: 0;
}

.card.card-stretch {
  height: calc(100% - var(--bs-gutter-y));
}
.card.card-stretch-75 {
  height: calc(75% - var(--bs-gutter-y));
}
.card.card-stretch-50 {
  height: calc(50% - var(--bs-gutter-y));
}
.card.card-stretch-33 {
  height: calc(33.333% - var(--bs-gutter-y));
}
.card.card-stretch-25 {
  height: calc(25% - var(--bs-gutter-y));
}
.card .card-header-stretch {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  align-items: stretch;
}
.card .card-header-stretch .card-toolbar {
  margin: 0;
  align-items: stretch;
}
@media (min-width: 576px) {
  .card.card-sm-stretch {
    height: calc(100% - var(--bs-gutter-y));
  }
  .card.card-sm-stretch-75 {
    height: calc(75% - var(--bs-gutter-y));
  }
  .card.card-sm-stretch-50 {
    height: calc(50% - var(--bs-gutter-y));
  }
  .card.card-sm-stretch-33 {
    height: calc(33.333% - var(--bs-gutter-y));
  }
  .card.card-sm-stretch-25 {
    height: calc(25% - var(--bs-gutter-y));
  }
  .card .card-header-sm-stretch {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    align-items: stretch;
  }
  .card .card-header-sm-stretch .card-toolbar {
    margin: 0;
    align-items: stretch;
  }
}
@media (min-width: 768px) {
  .card.card-md-stretch {
    height: calc(100% - var(--bs-gutter-y));
  }
  .card.card-md-stretch-75 {
    height: calc(75% - var(--bs-gutter-y));
  }
  .card.card-md-stretch-50 {
    height: calc(50% - var(--bs-gutter-y));
  }
  .card.card-md-stretch-33 {
    height: calc(33.333% - var(--bs-gutter-y));
  }
  .card.card-md-stretch-25 {
    height: calc(25% - var(--bs-gutter-y));
  }
  .card .card-header-md-stretch {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    align-items: stretch;
  }
  .card .card-header-md-stretch .card-toolbar {
    margin: 0;
    align-items: stretch;
  }
}
@media (min-width: 992px) {
  .card.card-lg-stretch {
    height: calc(100% - var(--bs-gutter-y));
  }
  .card.card-lg-stretch-75 {
    height: calc(75% - var(--bs-gutter-y));
  }
  .card.card-lg-stretch-50 {
    height: calc(50% - var(--bs-gutter-y));
  }
  .card.card-lg-stretch-33 {
    height: calc(33.333% - var(--bs-gutter-y));
  }
  .card.card-lg-stretch-25 {
    height: calc(25% - var(--bs-gutter-y));
  }
  .card .card-header-lg-stretch {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    align-items: stretch;
  }
  .card .card-header-lg-stretch .card-toolbar {
    margin: 0;
    align-items: stretch;
  }
}
@media (min-width: 1200px) {
  .card.card-xl-stretch {
    height: calc(100% - var(--bs-gutter-y));
  }
  .card.card-xl-stretch-75 {
    height: calc(75% - var(--bs-gutter-y));
  }
  .card.card-xl-stretch-50 {
    height: calc(50% - var(--bs-gutter-y));
  }
  .card.card-xl-stretch-33 {
    height: calc(33.333% - var(--bs-gutter-y));
  }
  .card.card-xl-stretch-25 {
    height: calc(25% - var(--bs-gutter-y));
  }
  .card .card-header-xl-stretch {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    align-items: stretch;
  }
  .card .card-header-xl-stretch .card-toolbar {
    margin: 0;
    align-items: stretch;
  }
}
@media (min-width: 1400px) {
  .card.card-xxl-stretch {
    height: calc(100% - var(--bs-gutter-y));
  }
  .card.card-xxl-stretch-75 {
    height: calc(75% - var(--bs-gutter-y));
  }
  .card.card-xxl-stretch-50 {
    height: calc(50% - var(--bs-gutter-y));
  }
  .card.card-xxl-stretch-33 {
    height: calc(33.333% - var(--bs-gutter-y));
  }
  .card.card-xxl-stretch-25 {
    height: calc(25% - var(--bs-gutter-y));
  }
  .card .card-header-xxl-stretch {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    align-items: stretch;
  }
  .card .card-header-xxl-stretch .card-toolbar {
    margin: 0;
    align-items: stretch;
  }
}

.card-p {
  padding: 2rem 2.25rem !important;
}

.card-px {
  padding-left: 2.25rem !important;
  padding-right: 2.25rem !important;
}

.card-shadow {
  box-shadow: 0px 0px 20px 0px rgba(76, 87, 125, 0.02);
}

.card-py {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}

.card-rounded {
  border-radius: 0.475rem;
}

.card-rounded-start {
  border-top-left-radius: 0.475rem;
  border-bottom-left-radius: 0.475rem;
}

.card-rounded-end {
  border-top-right-radius: 0.475rem;
  border-bottom-right-radius: 0.475rem;
}

.card-rounded-top {
  border-top-left-radius: 0.475rem;
  border-top-right-radius: 0.475rem;
}

.card-rounded-bottom {
  border-bottom-left-radius: 0.475rem;
  border-bottom-right-radius: 0.475rem;
}

@media (max-width: 767.98px) {
  .card > .card-header:not(.flex-nowrap) {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
}
.breadcrumb {
  display: flex;
  align-items: center;
  background-color: transparent;
  padding: 0;
  margin: 0;
}
.breadcrumb .breadcrumb-item {
  display: flex;
  align-items: center;
  padding-left: 0;
  padding-right: 0.5rem;
}
.breadcrumb .breadcrumb-item:last-child {
  padding-right: 0;
}
.breadcrumb .breadcrumb-item:after {
  content: "/";
  padding-left: 0.5rem;
}
.breadcrumb .breadcrumb-item:before {
  display: none;
}
.breadcrumb .breadcrumb-item:last-child:after {
  display: none;
}

.breadcrumb-line .breadcrumb-item:after {
  content: "-";
}

.breadcrumb-dot .breadcrumb-item:after {
  content: "•";
}

.breadcrumb-separatorless .breadcrumb-item:after {
  display: none;
}

.btn {
  outline: none !important;
}
.btn:not(.btn-shadow):not(.shadow):not(.shadow-sm):not(.shadow-lg) {
  box-shadow: none !important;
}
.btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon) {
  border: 0;
  padding: calc(0.75rem + 1px) calc(1.5rem + 1px);
}
.btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon).btn-lg, .btn-group-lg > .btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon) {
  padding: calc(0.825rem + 1px) calc(1.75rem + 1px);
}
.btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon).btn-sm, .btn-group-sm > .btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon) {
  padding: calc(0.65rem + 1px) calc(1.25rem + 1px);
}
.btn.btn-link {
  border: 0;
  border-radius: 0;
  padding-left: 0 !important;
  padding-right: 0 !important;
  text-decoration: none;
  font-weight: 500;
}
.btn.btn-outline-dashed {
  border: 1px dashed #E4E6EF;
}
.btn.btn-outline-default {
  border: 1px solid #E4E6EF;
}
.btn.btn-flush {
  appearance: none;
  box-shadow: none;
  border-radius: 0;
  border: none;
  cursor: pointer;
  background-color: transparent;
  outline: none !important;
  margin: 0;
  padding: 0;
}
.btn.btn-flex {
  display: inline-flex;
  align-items: center;
}

.btn i {
  display: inline-flex;
  font-size: 1rem;
  padding-right: 0.35rem;
  vertical-align: middle;
  line-height: 0;
}
.btn .svg-icon {
  flex-shrink: 0;
  line-height: 0;
  margin-right: 0.5rem;
}
.btn.btn-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  height: calc(1.5em + 1.5rem + calc(1px * 2));
  width: calc(1.5em + 1.5rem + calc(1px * 2));
}
.btn.btn-icon:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush) {
  border: 0;
}
.btn.btn-icon.btn-sm, .btn-group-sm > .btn.btn-icon {
  height: calc(1.5em + 1.3rem + calc(1px * 2));
  width: calc(1.5em + 1.3rem + calc(1px * 2));
}
.btn.btn-icon.btn-lg, .btn-group-lg > .btn.btn-icon {
  height: calc(1.5em + 1.65rem + calc(1px * 2));
  width: calc(1.5em + 1.65rem + calc(1px * 2));
}
.btn.btn-icon.btn-circle {
  border-radius: 50%;
}
.btn.btn-icon i,
.btn.btn-icon .svg-icon {
  padding: 0;
  margin: 0;
  line-height: 1;
}

.btn.btn-hover-rise {
  transition: transform 0.3s ease;
}
.btn.btn-hover-rise:hover {
  transform: translateY(-10%);
  transition: transform 0.3s ease;
}

.btn.btn-hover-scale {
  transition: transform 0.3s ease;
}
.btn.btn-hover-scale:hover {
  transform: scale(1.1);
  transition: transform 0.3s ease;
}

.btn.btn-hover-rotate-end {
  transition: transform 0.3s ease;
}
.btn.btn-hover-rotate-end:hover {
  transform: rotate(4deg);
  transition: transform 0.3s ease;
}

.btn.btn-hover-rotate-start {
  transition: transform 0.3s ease;
}
.btn.btn-hover-rotate-start:hover {
  transform: rotate(-4deg);
  transition: transform 0.3s ease;
}

.btn.btn-white {
  color: #7E8299;
  border-color: #ffffff;
  background-color: #ffffff;
}
.btn.btn-white i {
  color: #7E8299;
}
.btn.btn-white .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7E8299;
}
.btn.btn-white .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-white.dropdown-toggle:after {
  color: #7E8299;
}
.btn-check:checked + .btn.btn-white, .btn-check:active + .btn.btn-white, .btn.btn-white:focus:not(.btn-active), .btn.btn-white:hover:not(.btn-active), .btn.btn-white:active:not(.btn-active), .btn.btn-white.active, .btn.btn-white.show, .show > .btn.btn-white {
  color: #7E8299;
  border-color: #F5F8FA;
  background-color: #F5F8FA !important;
}
.btn-check:checked + .btn.btn-white i, .btn-check:active + .btn.btn-white i, .btn.btn-white:focus:not(.btn-active) i, .btn.btn-white:hover:not(.btn-active) i, .btn.btn-white:active:not(.btn-active) i, .btn.btn-white.active i, .btn.btn-white.show i, .show > .btn.btn-white i {
  color: #7E8299;
}
.btn-check:checked + .btn.btn-white .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-white .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-white:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-white:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-white:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-white.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-white.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-white .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7E8299;
}
.btn-check:checked + .btn.btn-white .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-white .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-white:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-white:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-white:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-white.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-white.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-white .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-white.dropdown-toggle:after, .btn-check:active + .btn.btn-white.dropdown-toggle:after, .btn.btn-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-white.active.dropdown-toggle:after, .btn.btn-white.show.dropdown-toggle:after, .show > .btn.btn-white.dropdown-toggle:after {
  color: #7E8299;
}

.btn.btn-bg-white {
  border-color: #ffffff;
  background-color: #ffffff;
}
.btn-check:checked + .btn.btn-active-white, .btn-check:active + .btn.btn-active-white, .btn.btn-active-white:focus:not(.btn-active), .btn.btn-active-white:hover:not(.btn-active), .btn.btn-active-white:active:not(.btn-active), .btn.btn-active-white.active, .btn.btn-active-white.show, .show > .btn.btn-active-white {
  color: #7E8299;
  border-color: #ffffff;
  background-color: #ffffff !important;
}
.btn-check:checked + .btn.btn-active-white i, .btn-check:active + .btn.btn-active-white i, .btn.btn-active-white:focus:not(.btn-active) i, .btn.btn-active-white:hover:not(.btn-active) i, .btn.btn-active-white:active:not(.btn-active) i, .btn.btn-active-white.active i, .btn.btn-active-white.show i, .show > .btn.btn-active-white i {
  color: #7E8299;
}
.btn-check:checked + .btn.btn-active-white .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-white .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-white:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-white:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-white:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-white.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-white.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-white .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7E8299;
}
.btn-check:checked + .btn.btn-active-white .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-white .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-white:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-white:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-white:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-white.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-white.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-white .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-white.dropdown-toggle:after, .btn-check:active + .btn.btn-active-white.dropdown-toggle:after, .btn.btn-active-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-white.active.dropdown-toggle:after, .btn.btn-active-white.show.dropdown-toggle:after, .show > .btn.btn-active-white.dropdown-toggle:after {
  color: #7E8299;
}

.btn.btn-light {
  color: #7E8299;
  border-color: #F5F8FA;
  background-color: #F5F8FA;
}
.btn.btn-light i {
  color: #7E8299;
}
.btn.btn-light .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7E8299;
}
.btn.btn-light .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-light.dropdown-toggle:after {
  color: #7E8299;
}
.btn-check:checked + .btn.btn-light, .btn-check:active + .btn.btn-light, .btn.btn-light:focus:not(.btn-active), .btn.btn-light:hover:not(.btn-active), .btn.btn-light:active:not(.btn-active), .btn.btn-light.active, .btn.btn-light.show, .show > .btn.btn-light {
  color: #7E8299;
  border-color: #EFF2F5;
  background-color: #EFF2F5 !important;
}
.btn-check:checked + .btn.btn-light i, .btn-check:active + .btn.btn-light i, .btn.btn-light:focus:not(.btn-active) i, .btn.btn-light:hover:not(.btn-active) i, .btn.btn-light:active:not(.btn-active) i, .btn.btn-light.active i, .btn.btn-light.show i, .show > .btn.btn-light i {
  color: #7E8299;
}
.btn-check:checked + .btn.btn-light .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7E8299;
}
.btn-check:checked + .btn.btn-light .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-light.dropdown-toggle:after, .btn-check:active + .btn.btn-light.dropdown-toggle:after, .btn.btn-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light.active.dropdown-toggle:after, .btn.btn-light.show.dropdown-toggle:after, .show > .btn.btn-light.dropdown-toggle:after {
  color: #7E8299;
}

.btn.btn-bg-light {
  border-color: #F5F8FA;
  background-color: #F5F8FA;
}
.btn-check:checked + .btn.btn-active-light, .btn-check:active + .btn.btn-active-light, .btn.btn-active-light:focus:not(.btn-active), .btn.btn-active-light:hover:not(.btn-active), .btn.btn-active-light:active:not(.btn-active), .btn.btn-active-light.active, .btn.btn-active-light.show, .show > .btn.btn-active-light {
  color: #7E8299;
  border-color: #F5F8FA;
  background-color: #F5F8FA !important;
}
.btn-check:checked + .btn.btn-active-light i, .btn-check:active + .btn.btn-active-light i, .btn.btn-active-light:focus:not(.btn-active) i, .btn.btn-active-light:hover:not(.btn-active) i, .btn.btn-active-light:active:not(.btn-active) i, .btn.btn-active-light.active i, .btn.btn-active-light.show i, .show > .btn.btn-active-light i {
  color: #7E8299;
}
.btn-check:checked + .btn.btn-active-light .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-light .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7E8299;
}
.btn-check:checked + .btn.btn-active-light .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-light .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light.dropdown-toggle:after, .btn.btn-active-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light.active.dropdown-toggle:after, .btn.btn-active-light.show.dropdown-toggle:after, .show > .btn.btn-active-light.dropdown-toggle:after {
  color: #7E8299;
}

.btn.btn-primary {
  color: #FFFFFF;
  border-color: #009EF7;
  background-color: #009EF7;
}
.btn.btn-primary i {
  color: #FFFFFF;
}
.btn.btn-primary .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.btn.btn-primary .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-primary.dropdown-toggle:after {
  color: #FFFFFF;
}
.btn-check:checked + .btn.btn-primary, .btn-check:active + .btn.btn-primary, .btn.btn-primary:focus:not(.btn-active), .btn.btn-primary:hover:not(.btn-active), .btn.btn-primary:active:not(.btn-active), .btn.btn-primary.active, .btn.btn-primary.show, .show > .btn.btn-primary {
  color: #FFFFFF;
  border-color: #0095E8;
  background-color: #0095E8 !important;
}
.btn-check:checked + .btn.btn-primary i, .btn-check:active + .btn.btn-primary i, .btn.btn-primary:focus:not(.btn-active) i, .btn.btn-primary:hover:not(.btn-active) i, .btn.btn-primary:active:not(.btn-active) i, .btn.btn-primary.active i, .btn.btn-primary.show i, .show > .btn.btn-primary i {
  color: #FFFFFF;
}
.btn-check:checked + .btn.btn-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-primary:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-primary:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-primary:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-primary.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-primary.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-primary .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.btn-check:checked + .btn.btn-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-primary:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-primary:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-primary:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-primary.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-primary.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-primary .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-primary.dropdown-toggle:after, .btn.btn-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-primary.active.dropdown-toggle:after, .btn.btn-primary.show.dropdown-toggle:after, .show > .btn.btn-primary.dropdown-toggle:after {
  color: #FFFFFF;
}

.btn.btn-light-primary {
  color: #009EF7;
  border-color: #F1FAFF;
  background-color: #F1FAFF;
}
.btn.btn-light-primary i {
  color: #009EF7;
}
.btn.btn-light-primary .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.btn.btn-light-primary .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-light-primary.dropdown-toggle:after {
  color: #009EF7;
}
.btn-check:checked + .btn.btn-light-primary, .btn-check:active + .btn.btn-light-primary, .btn.btn-light-primary:focus:not(.btn-active), .btn.btn-light-primary:hover:not(.btn-active), .btn.btn-light-primary:active:not(.btn-active), .btn.btn-light-primary.active, .btn.btn-light-primary.show, .show > .btn.btn-light-primary {
  color: #FFFFFF;
  border-color: #009EF7;
  background-color: #009EF7 !important;
}
.btn-check:checked + .btn.btn-light-primary i, .btn-check:active + .btn.btn-light-primary i, .btn.btn-light-primary:focus:not(.btn-active) i, .btn.btn-light-primary:hover:not(.btn-active) i, .btn.btn-light-primary:active:not(.btn-active) i, .btn.btn-light-primary.active i, .btn.btn-light-primary.show i, .show > .btn.btn-light-primary i {
  color: #FFFFFF;
}
.btn-check:checked + .btn.btn-light-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-primary:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-primary:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-primary:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-primary.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-primary.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-primary .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.btn-check:checked + .btn.btn-light-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-primary:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-primary:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-primary:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-primary.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-primary.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-primary .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-light-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-light-primary.dropdown-toggle:after, .btn.btn-light-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary.active.dropdown-toggle:after, .btn.btn-light-primary.show.dropdown-toggle:after, .show > .btn.btn-light-primary.dropdown-toggle:after {
  color: #FFFFFF;
}

.btn.btn-bg-primary {
  border-color: #009EF7;
  background-color: #009EF7;
}
.btn-check:checked + .btn.btn-active-primary, .btn-check:active + .btn.btn-active-primary, .btn.btn-active-primary:focus:not(.btn-active), .btn.btn-active-primary:hover:not(.btn-active), .btn.btn-active-primary:active:not(.btn-active), .btn.btn-active-primary.active, .btn.btn-active-primary.show, .show > .btn.btn-active-primary {
  color: #FFFFFF;
  border-color: #009EF7;
  background-color: #009EF7 !important;
}
.btn-check:checked + .btn.btn-active-primary i, .btn-check:active + .btn.btn-active-primary i, .btn.btn-active-primary:focus:not(.btn-active) i, .btn.btn-active-primary:hover:not(.btn-active) i, .btn.btn-active-primary:active:not(.btn-active) i, .btn.btn-active-primary.active i, .btn.btn-active-primary.show i, .show > .btn.btn-active-primary i {
  color: #FFFFFF;
}
.btn-check:checked + .btn.btn-active-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-primary:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-primary:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-primary:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-primary.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-primary.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-primary .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.btn-check:checked + .btn.btn-active-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-primary:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-primary:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-primary:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-primary.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-primary.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-primary .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-primary.dropdown-toggle:after, .btn.btn-active-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary.active.dropdown-toggle:after, .btn.btn-active-primary.show.dropdown-toggle:after, .show > .btn.btn-active-primary.dropdown-toggle:after {
  color: #FFFFFF;
}

.btn-check:checked + .btn.btn-active-light-primary, .btn-check:active + .btn.btn-active-light-primary, .btn.btn-active-light-primary:focus:not(.btn-active), .btn.btn-active-light-primary:hover:not(.btn-active), .btn.btn-active-light-primary:active:not(.btn-active), .btn.btn-active-light-primary.active, .btn.btn-active-light-primary.show, .show > .btn.btn-active-light-primary {
  color: #009EF7;
  border-color: #F1FAFF;
  background-color: #F1FAFF !important;
}
.btn-check:checked + .btn.btn-active-light-primary i, .btn-check:active + .btn.btn-active-light-primary i, .btn.btn-active-light-primary:focus:not(.btn-active) i, .btn.btn-active-light-primary:hover:not(.btn-active) i, .btn.btn-active-light-primary:active:not(.btn-active) i, .btn.btn-active-light-primary.active i, .btn.btn-active-light-primary.show i, .show > .btn.btn-active-light-primary i {
  color: #009EF7;
}
.btn-check:checked + .btn.btn-active-light-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-primary:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-primary:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-primary:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-primary.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-primary.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-primary .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.btn-check:checked + .btn.btn-active-light-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-primary:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-primary:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-primary:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-primary.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-primary.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-primary .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-light-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-primary.dropdown-toggle:after, .btn.btn-active-light-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary.active.dropdown-toggle:after, .btn.btn-active-light-primary.show.dropdown-toggle:after, .show > .btn.btn-active-light-primary.dropdown-toggle:after {
  color: #009EF7;
}
.btn.btn-active-light-primary.btn-outline:not(.btn-outline-default) {
  border-color: #009EF7 !important;
}

.btn.btn-secondary {
  color: #3F4254;
  border-color: #E4E6EF;
  background-color: #E4E6EF;
}
.btn.btn-secondary i {
  color: #3F4254;
}
.btn.btn-secondary .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #3F4254;
}
.btn.btn-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-secondary.dropdown-toggle:after {
  color: #3F4254;
}
.btn-check:checked + .btn.btn-secondary, .btn-check:active + .btn.btn-secondary, .btn.btn-secondary:focus:not(.btn-active), .btn.btn-secondary:hover:not(.btn-active), .btn.btn-secondary:active:not(.btn-active), .btn.btn-secondary.active, .btn.btn-secondary.show, .show > .btn.btn-secondary {
  color: #3F4254;
  border-color: #B5B5C3;
  background-color: #B5B5C3 !important;
}
.btn-check:checked + .btn.btn-secondary i, .btn-check:active + .btn.btn-secondary i, .btn.btn-secondary:focus:not(.btn-active) i, .btn.btn-secondary:hover:not(.btn-active) i, .btn.btn-secondary:active:not(.btn-active) i, .btn.btn-secondary.active i, .btn.btn-secondary.show i, .show > .btn.btn-secondary i {
  color: #3F4254;
}
.btn-check:checked + .btn.btn-secondary .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-secondary .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-secondary:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-secondary:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-secondary:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-secondary.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-secondary.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-secondary .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #3F4254;
}
.btn-check:checked + .btn.btn-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-secondary:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-secondary:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-secondary:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-secondary.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-secondary.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-secondary.dropdown-toggle:after, .btn.btn-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary.active.dropdown-toggle:after, .btn.btn-secondary.show.dropdown-toggle:after, .show > .btn.btn-secondary.dropdown-toggle:after {
  color: #3F4254;
}

.btn.btn-bg-secondary {
  border-color: #E4E6EF;
  background-color: #E4E6EF;
}
.btn-check:checked + .btn.btn-active-secondary, .btn-check:active + .btn.btn-active-secondary, .btn.btn-active-secondary:focus:not(.btn-active), .btn.btn-active-secondary:hover:not(.btn-active), .btn.btn-active-secondary:active:not(.btn-active), .btn.btn-active-secondary.active, .btn.btn-active-secondary.show, .show > .btn.btn-active-secondary {
  color: #3F4254;
  border-color: #E4E6EF;
  background-color: #E4E6EF !important;
}
.btn-check:checked + .btn.btn-active-secondary i, .btn-check:active + .btn.btn-active-secondary i, .btn.btn-active-secondary:focus:not(.btn-active) i, .btn.btn-active-secondary:hover:not(.btn-active) i, .btn.btn-active-secondary:active:not(.btn-active) i, .btn.btn-active-secondary.active i, .btn.btn-active-secondary.show i, .show > .btn.btn-active-secondary i {
  color: #3F4254;
}
.btn-check:checked + .btn.btn-active-secondary .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-secondary .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-secondary:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-secondary:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-secondary:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-secondary.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-secondary.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-secondary .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #3F4254;
}
.btn-check:checked + .btn.btn-active-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-secondary:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-secondary:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-secondary:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-secondary.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-secondary.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-secondary.dropdown-toggle:after, .btn.btn-active-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary.active.dropdown-toggle:after, .btn.btn-active-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-secondary.dropdown-toggle:after {
  color: #3F4254;
}

.btn.btn-success {
  color: #FFFFFF;
  border-color: #50CD89;
  background-color: #50CD89;
}
.btn.btn-success i {
  color: #FFFFFF;
}
.btn.btn-success .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.btn.btn-success .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-success.dropdown-toggle:after {
  color: #FFFFFF;
}
.btn-check:checked + .btn.btn-success, .btn-check:active + .btn.btn-success, .btn.btn-success:focus:not(.btn-active), .btn.btn-success:hover:not(.btn-active), .btn.btn-success:active:not(.btn-active), .btn.btn-success.active, .btn.btn-success.show, .show > .btn.btn-success {
  color: #FFFFFF;
  border-color: #47BE7D;
  background-color: #47BE7D !important;
}
.btn-check:checked + .btn.btn-success i, .btn-check:active + .btn.btn-success i, .btn.btn-success:focus:not(.btn-active) i, .btn.btn-success:hover:not(.btn-active) i, .btn.btn-success:active:not(.btn-active) i, .btn.btn-success.active i, .btn.btn-success.show i, .show > .btn.btn-success i {
  color: #FFFFFF;
}
.btn-check:checked + .btn.btn-success .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-success .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-success:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-success:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-success:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-success.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-success.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-success .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.btn-check:checked + .btn.btn-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-success:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-success:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-success:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-success.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-success.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-success .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-success.dropdown-toggle:after, .btn-check:active + .btn.btn-success.dropdown-toggle:after, .btn.btn-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-success.active.dropdown-toggle:after, .btn.btn-success.show.dropdown-toggle:after, .show > .btn.btn-success.dropdown-toggle:after {
  color: #FFFFFF;
}

.btn.btn-light-success {
  color: #50CD89;
  border-color: #E8FFF3;
  background-color: #E8FFF3;
}
.btn.btn-light-success i {
  color: #50CD89;
}
.btn.btn-light-success .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #50CD89;
}
.btn.btn-light-success .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-light-success.dropdown-toggle:after {
  color: #50CD89;
}
.btn-check:checked + .btn.btn-light-success, .btn-check:active + .btn.btn-light-success, .btn.btn-light-success:focus:not(.btn-active), .btn.btn-light-success:hover:not(.btn-active), .btn.btn-light-success:active:not(.btn-active), .btn.btn-light-success.active, .btn.btn-light-success.show, .show > .btn.btn-light-success {
  color: #FFFFFF;
  border-color: #50CD89;
  background-color: #50CD89 !important;
}
.btn-check:checked + .btn.btn-light-success i, .btn-check:active + .btn.btn-light-success i, .btn.btn-light-success:focus:not(.btn-active) i, .btn.btn-light-success:hover:not(.btn-active) i, .btn.btn-light-success:active:not(.btn-active) i, .btn.btn-light-success.active i, .btn.btn-light-success.show i, .show > .btn.btn-light-success i {
  color: #FFFFFF;
}
.btn-check:checked + .btn.btn-light-success .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-success .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-success:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-success:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-success:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-success.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-success.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-success .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.btn-check:checked + .btn.btn-light-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-success:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-success:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-success:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-success.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-success.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-success .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-light-success.dropdown-toggle:after, .btn-check:active + .btn.btn-light-success.dropdown-toggle:after, .btn.btn-light-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success.active.dropdown-toggle:after, .btn.btn-light-success.show.dropdown-toggle:after, .show > .btn.btn-light-success.dropdown-toggle:after {
  color: #FFFFFF;
}

.btn.btn-bg-success {
  border-color: #50CD89;
  background-color: #50CD89;
}
.btn-check:checked + .btn.btn-active-success, .btn-check:active + .btn.btn-active-success, .btn.btn-active-success:focus:not(.btn-active), .btn.btn-active-success:hover:not(.btn-active), .btn.btn-active-success:active:not(.btn-active), .btn.btn-active-success.active, .btn.btn-active-success.show, .show > .btn.btn-active-success {
  color: #FFFFFF;
  border-color: #50CD89;
  background-color: #50CD89 !important;
}
.btn-check:checked + .btn.btn-active-success i, .btn-check:active + .btn.btn-active-success i, .btn.btn-active-success:focus:not(.btn-active) i, .btn.btn-active-success:hover:not(.btn-active) i, .btn.btn-active-success:active:not(.btn-active) i, .btn.btn-active-success.active i, .btn.btn-active-success.show i, .show > .btn.btn-active-success i {
  color: #FFFFFF;
}
.btn-check:checked + .btn.btn-active-success .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-success .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-success:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-success:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-success:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-success.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-success.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-success .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.btn-check:checked + .btn.btn-active-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-success:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-success:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-success:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-success.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-success.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-success .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-success.dropdown-toggle:after, .btn.btn-active-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success.active.dropdown-toggle:after, .btn.btn-active-success.show.dropdown-toggle:after, .show > .btn.btn-active-success.dropdown-toggle:after {
  color: #FFFFFF;
}

.btn-check:checked + .btn.btn-active-light-success, .btn-check:active + .btn.btn-active-light-success, .btn.btn-active-light-success:focus:not(.btn-active), .btn.btn-active-light-success:hover:not(.btn-active), .btn.btn-active-light-success:active:not(.btn-active), .btn.btn-active-light-success.active, .btn.btn-active-light-success.show, .show > .btn.btn-active-light-success {
  color: #50CD89;
  border-color: #E8FFF3;
  background-color: #E8FFF3 !important;
}
.btn-check:checked + .btn.btn-active-light-success i, .btn-check:active + .btn.btn-active-light-success i, .btn.btn-active-light-success:focus:not(.btn-active) i, .btn.btn-active-light-success:hover:not(.btn-active) i, .btn.btn-active-light-success:active:not(.btn-active) i, .btn.btn-active-light-success.active i, .btn.btn-active-light-success.show i, .show > .btn.btn-active-light-success i {
  color: #50CD89;
}
.btn-check:checked + .btn.btn-active-light-success .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-success .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-success:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-success:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-success:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-success.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-success.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-success .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #50CD89;
}
.btn-check:checked + .btn.btn-active-light-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-success:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-success:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-success:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-success.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-success.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-success .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-light-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-success.dropdown-toggle:after, .btn.btn-active-light-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success.active.dropdown-toggle:after, .btn.btn-active-light-success.show.dropdown-toggle:after, .show > .btn.btn-active-light-success.dropdown-toggle:after {
  color: #50CD89;
}
.btn.btn-active-light-success.btn-outline:not(.btn-outline-default) {
  border-color: #50CD89 !important;
}

.btn.btn-info {
  color: #FFFFFF;
  border-color: #7239EA;
  background-color: #7239EA;
}
.btn.btn-info i {
  color: #FFFFFF;
}
.btn.btn-info .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.btn.btn-info .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-info.dropdown-toggle:after {
  color: #FFFFFF;
}
.btn-check:checked + .btn.btn-info, .btn-check:active + .btn.btn-info, .btn.btn-info:focus:not(.btn-active), .btn.btn-info:hover:not(.btn-active), .btn.btn-info:active:not(.btn-active), .btn.btn-info.active, .btn.btn-info.show, .show > .btn.btn-info {
  color: #FFFFFF;
  border-color: #5014D0;
  background-color: #5014D0 !important;
}
.btn-check:checked + .btn.btn-info i, .btn-check:active + .btn.btn-info i, .btn.btn-info:focus:not(.btn-active) i, .btn.btn-info:hover:not(.btn-active) i, .btn.btn-info:active:not(.btn-active) i, .btn.btn-info.active i, .btn.btn-info.show i, .show > .btn.btn-info i {
  color: #FFFFFF;
}
.btn-check:checked + .btn.btn-info .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-info .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-info:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-info:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-info:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-info.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-info.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-info .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.btn-check:checked + .btn.btn-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-info:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-info:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-info:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-info.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-info.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-info .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-info.dropdown-toggle:after, .btn-check:active + .btn.btn-info.dropdown-toggle:after, .btn.btn-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-info.active.dropdown-toggle:after, .btn.btn-info.show.dropdown-toggle:after, .show > .btn.btn-info.dropdown-toggle:after {
  color: #FFFFFF;
}

.btn.btn-light-info {
  color: #7239EA;
  border-color: #F8F5FF;
  background-color: #F8F5FF;
}
.btn.btn-light-info i {
  color: #7239EA;
}
.btn.btn-light-info .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7239EA;
}
.btn.btn-light-info .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-light-info.dropdown-toggle:after {
  color: #7239EA;
}
.btn-check:checked + .btn.btn-light-info, .btn-check:active + .btn.btn-light-info, .btn.btn-light-info:focus:not(.btn-active), .btn.btn-light-info:hover:not(.btn-active), .btn.btn-light-info:active:not(.btn-active), .btn.btn-light-info.active, .btn.btn-light-info.show, .show > .btn.btn-light-info {
  color: #FFFFFF;
  border-color: #7239EA;
  background-color: #7239EA !important;
}
.btn-check:checked + .btn.btn-light-info i, .btn-check:active + .btn.btn-light-info i, .btn.btn-light-info:focus:not(.btn-active) i, .btn.btn-light-info:hover:not(.btn-active) i, .btn.btn-light-info:active:not(.btn-active) i, .btn.btn-light-info.active i, .btn.btn-light-info.show i, .show > .btn.btn-light-info i {
  color: #FFFFFF;
}
.btn-check:checked + .btn.btn-light-info .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-info .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-info:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-info:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-info:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-info.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-info.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-info .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.btn-check:checked + .btn.btn-light-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-info:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-info:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-info:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-info.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-info.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-info .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-light-info.dropdown-toggle:after, .btn-check:active + .btn.btn-light-info.dropdown-toggle:after, .btn.btn-light-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info.active.dropdown-toggle:after, .btn.btn-light-info.show.dropdown-toggle:after, .show > .btn.btn-light-info.dropdown-toggle:after {
  color: #FFFFFF;
}

.btn.btn-bg-info {
  border-color: #7239EA;
  background-color: #7239EA;
}
.btn-check:checked + .btn.btn-active-info, .btn-check:active + .btn.btn-active-info, .btn.btn-active-info:focus:not(.btn-active), .btn.btn-active-info:hover:not(.btn-active), .btn.btn-active-info:active:not(.btn-active), .btn.btn-active-info.active, .btn.btn-active-info.show, .show > .btn.btn-active-info {
  color: #FFFFFF;
  border-color: #7239EA;
  background-color: #7239EA !important;
}
.btn-check:checked + .btn.btn-active-info i, .btn-check:active + .btn.btn-active-info i, .btn.btn-active-info:focus:not(.btn-active) i, .btn.btn-active-info:hover:not(.btn-active) i, .btn.btn-active-info:active:not(.btn-active) i, .btn.btn-active-info.active i, .btn.btn-active-info.show i, .show > .btn.btn-active-info i {
  color: #FFFFFF;
}
.btn-check:checked + .btn.btn-active-info .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-info .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-info:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-info:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-info:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-info.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-info.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-info .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.btn-check:checked + .btn.btn-active-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-info:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-info:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-info:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-info.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-info.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-info .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-info.dropdown-toggle:after, .btn.btn-active-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info.active.dropdown-toggle:after, .btn.btn-active-info.show.dropdown-toggle:after, .show > .btn.btn-active-info.dropdown-toggle:after {
  color: #FFFFFF;
}

.btn-check:checked + .btn.btn-active-light-info, .btn-check:active + .btn.btn-active-light-info, .btn.btn-active-light-info:focus:not(.btn-active), .btn.btn-active-light-info:hover:not(.btn-active), .btn.btn-active-light-info:active:not(.btn-active), .btn.btn-active-light-info.active, .btn.btn-active-light-info.show, .show > .btn.btn-active-light-info {
  color: #7239EA;
  border-color: #F8F5FF;
  background-color: #F8F5FF !important;
}
.btn-check:checked + .btn.btn-active-light-info i, .btn-check:active + .btn.btn-active-light-info i, .btn.btn-active-light-info:focus:not(.btn-active) i, .btn.btn-active-light-info:hover:not(.btn-active) i, .btn.btn-active-light-info:active:not(.btn-active) i, .btn.btn-active-light-info.active i, .btn.btn-active-light-info.show i, .show > .btn.btn-active-light-info i {
  color: #7239EA;
}
.btn-check:checked + .btn.btn-active-light-info .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-info .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-info:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-info:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-info:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-info.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-info.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-info .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7239EA;
}
.btn-check:checked + .btn.btn-active-light-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-info:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-info:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-info:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-info.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-info.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-info .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-light-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-info.dropdown-toggle:after, .btn.btn-active-light-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info.active.dropdown-toggle:after, .btn.btn-active-light-info.show.dropdown-toggle:after, .show > .btn.btn-active-light-info.dropdown-toggle:after {
  color: #7239EA;
}
.btn.btn-active-light-info.btn-outline:not(.btn-outline-default) {
  border-color: #7239EA !important;
}

.btn.btn-warning {
  color: #FFFFFF;
  border-color: #FFC700;
  background-color: #FFC700;
}
.btn.btn-warning i {
  color: #FFFFFF;
}
.btn.btn-warning .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.btn.btn-warning .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-warning.dropdown-toggle:after {
  color: #FFFFFF;
}
.btn-check:checked + .btn.btn-warning, .btn-check:active + .btn.btn-warning, .btn.btn-warning:focus:not(.btn-active), .btn.btn-warning:hover:not(.btn-active), .btn.btn-warning:active:not(.btn-active), .btn.btn-warning.active, .btn.btn-warning.show, .show > .btn.btn-warning {
  color: #FFFFFF;
  border-color: #F1BC00;
  background-color: #F1BC00 !important;
}
.btn-check:checked + .btn.btn-warning i, .btn-check:active + .btn.btn-warning i, .btn.btn-warning:focus:not(.btn-active) i, .btn.btn-warning:hover:not(.btn-active) i, .btn.btn-warning:active:not(.btn-active) i, .btn.btn-warning.active i, .btn.btn-warning.show i, .show > .btn.btn-warning i {
  color: #FFFFFF;
}
.btn-check:checked + .btn.btn-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-warning:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-warning:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-warning:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-warning.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-warning.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-warning .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.btn-check:checked + .btn.btn-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-warning:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-warning:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-warning:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-warning.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-warning.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-warning .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-warning.dropdown-toggle:after, .btn.btn-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-warning.active.dropdown-toggle:after, .btn.btn-warning.show.dropdown-toggle:after, .show > .btn.btn-warning.dropdown-toggle:after {
  color: #FFFFFF;
}

.btn.btn-light-warning {
  color: #FFC700;
  border-color: #FFF8DD;
  background-color: #FFF8DD;
}
.btn.btn-light-warning i {
  color: #FFC700;
}
.btn.btn-light-warning .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFC700;
}
.btn.btn-light-warning .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-light-warning.dropdown-toggle:after {
  color: #FFC700;
}
.btn-check:checked + .btn.btn-light-warning, .btn-check:active + .btn.btn-light-warning, .btn.btn-light-warning:focus:not(.btn-active), .btn.btn-light-warning:hover:not(.btn-active), .btn.btn-light-warning:active:not(.btn-active), .btn.btn-light-warning.active, .btn.btn-light-warning.show, .show > .btn.btn-light-warning {
  color: #FFFFFF;
  border-color: #FFC700;
  background-color: #FFC700 !important;
}
.btn-check:checked + .btn.btn-light-warning i, .btn-check:active + .btn.btn-light-warning i, .btn.btn-light-warning:focus:not(.btn-active) i, .btn.btn-light-warning:hover:not(.btn-active) i, .btn.btn-light-warning:active:not(.btn-active) i, .btn.btn-light-warning.active i, .btn.btn-light-warning.show i, .show > .btn.btn-light-warning i {
  color: #FFFFFF;
}
.btn-check:checked + .btn.btn-light-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-warning:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-warning:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-warning:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-warning.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-warning.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-warning .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.btn-check:checked + .btn.btn-light-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-warning:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-warning:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-warning:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-warning.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-warning.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-warning .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-light-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-light-warning.dropdown-toggle:after, .btn.btn-light-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning.active.dropdown-toggle:after, .btn.btn-light-warning.show.dropdown-toggle:after, .show > .btn.btn-light-warning.dropdown-toggle:after {
  color: #FFFFFF;
}

.btn.btn-bg-warning {
  border-color: #FFC700;
  background-color: #FFC700;
}
.btn-check:checked + .btn.btn-active-warning, .btn-check:active + .btn.btn-active-warning, .btn.btn-active-warning:focus:not(.btn-active), .btn.btn-active-warning:hover:not(.btn-active), .btn.btn-active-warning:active:not(.btn-active), .btn.btn-active-warning.active, .btn.btn-active-warning.show, .show > .btn.btn-active-warning {
  color: #FFFFFF;
  border-color: #FFC700;
  background-color: #FFC700 !important;
}
.btn-check:checked + .btn.btn-active-warning i, .btn-check:active + .btn.btn-active-warning i, .btn.btn-active-warning:focus:not(.btn-active) i, .btn.btn-active-warning:hover:not(.btn-active) i, .btn.btn-active-warning:active:not(.btn-active) i, .btn.btn-active-warning.active i, .btn.btn-active-warning.show i, .show > .btn.btn-active-warning i {
  color: #FFFFFF;
}
.btn-check:checked + .btn.btn-active-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-warning:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-warning:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-warning:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-warning.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-warning.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-warning .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.btn-check:checked + .btn.btn-active-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-warning:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-warning:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-warning:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-warning.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-warning.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-warning .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-warning.dropdown-toggle:after, .btn.btn-active-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning.active.dropdown-toggle:after, .btn.btn-active-warning.show.dropdown-toggle:after, .show > .btn.btn-active-warning.dropdown-toggle:after {
  color: #FFFFFF;
}

.btn-check:checked + .btn.btn-active-light-warning, .btn-check:active + .btn.btn-active-light-warning, .btn.btn-active-light-warning:focus:not(.btn-active), .btn.btn-active-light-warning:hover:not(.btn-active), .btn.btn-active-light-warning:active:not(.btn-active), .btn.btn-active-light-warning.active, .btn.btn-active-light-warning.show, .show > .btn.btn-active-light-warning {
  color: #FFC700;
  border-color: #FFF8DD;
  background-color: #FFF8DD !important;
}
.btn-check:checked + .btn.btn-active-light-warning i, .btn-check:active + .btn.btn-active-light-warning i, .btn.btn-active-light-warning:focus:not(.btn-active) i, .btn.btn-active-light-warning:hover:not(.btn-active) i, .btn.btn-active-light-warning:active:not(.btn-active) i, .btn.btn-active-light-warning.active i, .btn.btn-active-light-warning.show i, .show > .btn.btn-active-light-warning i {
  color: #FFC700;
}
.btn-check:checked + .btn.btn-active-light-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-warning:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-warning:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-warning:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-warning.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-warning.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-warning .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFC700;
}
.btn-check:checked + .btn.btn-active-light-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-warning:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-warning:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-warning:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-warning.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-warning.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-warning .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-light-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-warning.dropdown-toggle:after, .btn.btn-active-light-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning.active.dropdown-toggle:after, .btn.btn-active-light-warning.show.dropdown-toggle:after, .show > .btn.btn-active-light-warning.dropdown-toggle:after {
  color: #FFC700;
}
.btn.btn-active-light-warning.btn-outline:not(.btn-outline-default) {
  border-color: #FFC700 !important;
}

.btn.btn-danger {
  color: #FFFFFF;
  border-color: #F1416C;
  background-color: #F1416C;
}
.btn.btn-danger i {
  color: #FFFFFF;
}
.btn.btn-danger .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.btn.btn-danger .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-danger.dropdown-toggle:after {
  color: #FFFFFF;
}
.btn-check:checked + .btn.btn-danger, .btn-check:active + .btn.btn-danger, .btn.btn-danger:focus:not(.btn-active), .btn.btn-danger:hover:not(.btn-active), .btn.btn-danger:active:not(.btn-active), .btn.btn-danger.active, .btn.btn-danger.show, .show > .btn.btn-danger {
  color: #FFFFFF;
  border-color: #D9214E;
  background-color: #D9214E !important;
}
.btn-check:checked + .btn.btn-danger i, .btn-check:active + .btn.btn-danger i, .btn.btn-danger:focus:not(.btn-active) i, .btn.btn-danger:hover:not(.btn-active) i, .btn.btn-danger:active:not(.btn-active) i, .btn.btn-danger.active i, .btn.btn-danger.show i, .show > .btn.btn-danger i {
  color: #FFFFFF;
}
.btn-check:checked + .btn.btn-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-danger:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-danger:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-danger:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-danger.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-danger.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-danger .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.btn-check:checked + .btn.btn-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-danger:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-danger:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-danger:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-danger.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-danger.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-danger .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-danger.dropdown-toggle:after, .btn.btn-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-danger.active.dropdown-toggle:after, .btn.btn-danger.show.dropdown-toggle:after, .show > .btn.btn-danger.dropdown-toggle:after {
  color: #FFFFFF;
}

.btn.btn-light-danger {
  color: #F1416C;
  border-color: #FFF5F8;
  background-color: #FFF5F8;
}
.btn.btn-light-danger i {
  color: #F1416C;
}
.btn.btn-light-danger .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F1416C;
}
.btn.btn-light-danger .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-light-danger.dropdown-toggle:after {
  color: #F1416C;
}
.btn-check:checked + .btn.btn-light-danger, .btn-check:active + .btn.btn-light-danger, .btn.btn-light-danger:focus:not(.btn-active), .btn.btn-light-danger:hover:not(.btn-active), .btn.btn-light-danger:active:not(.btn-active), .btn.btn-light-danger.active, .btn.btn-light-danger.show, .show > .btn.btn-light-danger {
  color: #FFFFFF;
  border-color: #F1416C;
  background-color: #F1416C !important;
}
.btn-check:checked + .btn.btn-light-danger i, .btn-check:active + .btn.btn-light-danger i, .btn.btn-light-danger:focus:not(.btn-active) i, .btn.btn-light-danger:hover:not(.btn-active) i, .btn.btn-light-danger:active:not(.btn-active) i, .btn.btn-light-danger.active i, .btn.btn-light-danger.show i, .show > .btn.btn-light-danger i {
  color: #FFFFFF;
}
.btn-check:checked + .btn.btn-light-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-danger:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-danger:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-danger:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-danger.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-danger.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-danger .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.btn-check:checked + .btn.btn-light-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-danger:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-danger:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-danger:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-danger.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-danger.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-danger .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-light-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-light-danger.dropdown-toggle:after, .btn.btn-light-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger.active.dropdown-toggle:after, .btn.btn-light-danger.show.dropdown-toggle:after, .show > .btn.btn-light-danger.dropdown-toggle:after {
  color: #FFFFFF;
}

.btn.btn-bg-danger {
  border-color: #F1416C;
  background-color: #F1416C;
}
.btn-check:checked + .btn.btn-active-danger, .btn-check:active + .btn.btn-active-danger, .btn.btn-active-danger:focus:not(.btn-active), .btn.btn-active-danger:hover:not(.btn-active), .btn.btn-active-danger:active:not(.btn-active), .btn.btn-active-danger.active, .btn.btn-active-danger.show, .show > .btn.btn-active-danger {
  color: #FFFFFF;
  border-color: #F1416C;
  background-color: #F1416C !important;
}
.btn-check:checked + .btn.btn-active-danger i, .btn-check:active + .btn.btn-active-danger i, .btn.btn-active-danger:focus:not(.btn-active) i, .btn.btn-active-danger:hover:not(.btn-active) i, .btn.btn-active-danger:active:not(.btn-active) i, .btn.btn-active-danger.active i, .btn.btn-active-danger.show i, .show > .btn.btn-active-danger i {
  color: #FFFFFF;
}
.btn-check:checked + .btn.btn-active-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-danger:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-danger:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-danger:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-danger.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-danger.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-danger .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFFFFF;
}
.btn-check:checked + .btn.btn-active-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-danger:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-danger:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-danger:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-danger.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-danger.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-danger .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-danger.dropdown-toggle:after, .btn.btn-active-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger.active.dropdown-toggle:after, .btn.btn-active-danger.show.dropdown-toggle:after, .show > .btn.btn-active-danger.dropdown-toggle:after {
  color: #FFFFFF;
}

.btn-check:checked + .btn.btn-active-light-danger, .btn-check:active + .btn.btn-active-light-danger, .btn.btn-active-light-danger:focus:not(.btn-active), .btn.btn-active-light-danger:hover:not(.btn-active), .btn.btn-active-light-danger:active:not(.btn-active), .btn.btn-active-light-danger.active, .btn.btn-active-light-danger.show, .show > .btn.btn-active-light-danger {
  color: #F1416C;
  border-color: #FFF5F8;
  background-color: #FFF5F8 !important;
}
.btn-check:checked + .btn.btn-active-light-danger i, .btn-check:active + .btn.btn-active-light-danger i, .btn.btn-active-light-danger:focus:not(.btn-active) i, .btn.btn-active-light-danger:hover:not(.btn-active) i, .btn.btn-active-light-danger:active:not(.btn-active) i, .btn.btn-active-light-danger.active i, .btn.btn-active-light-danger.show i, .show > .btn.btn-active-light-danger i {
  color: #F1416C;
}
.btn-check:checked + .btn.btn-active-light-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-danger:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-danger:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-danger:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-danger.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-danger.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-danger .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F1416C;
}
.btn-check:checked + .btn.btn-active-light-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-danger:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-danger:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-danger:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-danger.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-danger.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-danger .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-light-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-danger.dropdown-toggle:after, .btn.btn-active-light-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger.active.dropdown-toggle:after, .btn.btn-active-light-danger.show.dropdown-toggle:after, .show > .btn.btn-active-light-danger.dropdown-toggle:after {
  color: #F1416C;
}
.btn.btn-active-light-danger.btn-outline:not(.btn-outline-default) {
  border-color: #F1416C !important;
}

.btn.btn-dark {
  color: #ffffff;
  border-color: #181C32;
  background-color: #181C32;
}
.btn.btn-dark i {
  color: #ffffff;
}
.btn.btn-dark .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.btn.btn-dark .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-dark.dropdown-toggle:after {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-dark, .btn-check:active + .btn.btn-dark, .btn.btn-dark:focus:not(.btn-active), .btn.btn-dark:hover:not(.btn-active), .btn.btn-dark:active:not(.btn-active), .btn.btn-dark.active, .btn.btn-dark.show, .show > .btn.btn-dark {
  color: #ffffff;
  border-color: #131628;
  background-color: #131628 !important;
}
.btn-check:checked + .btn.btn-dark i, .btn-check:active + .btn.btn-dark i, .btn.btn-dark:focus:not(.btn-active) i, .btn.btn-dark:hover:not(.btn-active) i, .btn.btn-dark:active:not(.btn-active) i, .btn.btn-dark.active i, .btn.btn-dark.show i, .show > .btn.btn-dark i {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-dark:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-dark:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-dark:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-dark.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-dark.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-dark .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.btn-check:checked + .btn.btn-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-dark:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-dark:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-dark:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-dark.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-dark.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-dark .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-dark.dropdown-toggle:after, .btn.btn-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-dark.active.dropdown-toggle:after, .btn.btn-dark.show.dropdown-toggle:after, .show > .btn.btn-dark.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-light-dark {
  color: #181C32;
  border-color: #EFF2F5;
  background-color: #EFF2F5;
}
.btn.btn-light-dark i {
  color: #181C32;
}
.btn.btn-light-dark .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #181C32;
}
.btn.btn-light-dark .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-light-dark.dropdown-toggle:after {
  color: #181C32;
}
.btn-check:checked + .btn.btn-light-dark, .btn-check:active + .btn.btn-light-dark, .btn.btn-light-dark:focus:not(.btn-active), .btn.btn-light-dark:hover:not(.btn-active), .btn.btn-light-dark:active:not(.btn-active), .btn.btn-light-dark.active, .btn.btn-light-dark.show, .show > .btn.btn-light-dark {
  color: #ffffff;
  border-color: #181C32;
  background-color: #181C32 !important;
}
.btn-check:checked + .btn.btn-light-dark i, .btn-check:active + .btn.btn-light-dark i, .btn.btn-light-dark:focus:not(.btn-active) i, .btn.btn-light-dark:hover:not(.btn-active) i, .btn.btn-light-dark:active:not(.btn-active) i, .btn.btn-light-dark.active i, .btn.btn-light-dark.show i, .show > .btn.btn-light-dark i {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-light-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-dark:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-dark:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-dark:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-dark.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-dark.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-dark .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.btn-check:checked + .btn.btn-light-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-dark:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-dark:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-dark:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-dark.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-dark.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-dark .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-light-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-light-dark.dropdown-toggle:after, .btn.btn-light-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark.active.dropdown-toggle:after, .btn.btn-light-dark.show.dropdown-toggle:after, .show > .btn.btn-light-dark.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-bg-dark {
  border-color: #181C32;
  background-color: #181C32;
}
.btn-check:checked + .btn.btn-active-dark, .btn-check:active + .btn.btn-active-dark, .btn.btn-active-dark:focus:not(.btn-active), .btn.btn-active-dark:hover:not(.btn-active), .btn.btn-active-dark:active:not(.btn-active), .btn.btn-active-dark.active, .btn.btn-active-dark.show, .show > .btn.btn-active-dark {
  color: #ffffff;
  border-color: #181C32;
  background-color: #181C32 !important;
}
.btn-check:checked + .btn.btn-active-dark i, .btn-check:active + .btn.btn-active-dark i, .btn.btn-active-dark:focus:not(.btn-active) i, .btn.btn-active-dark:hover:not(.btn-active) i, .btn.btn-active-dark:active:not(.btn-active) i, .btn.btn-active-dark.active i, .btn.btn-active-dark.show i, .show > .btn.btn-active-dark i {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-active-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-dark:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-dark:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-dark:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-dark.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-dark.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-dark .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.btn-check:checked + .btn.btn-active-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-dark:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-dark:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-dark:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-dark.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-dark.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-dark .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-dark.dropdown-toggle:after, .btn.btn-active-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark.active.dropdown-toggle:after, .btn.btn-active-dark.show.dropdown-toggle:after, .show > .btn.btn-active-dark.dropdown-toggle:after {
  color: #ffffff;
}

.btn-check:checked + .btn.btn-active-light-dark, .btn-check:active + .btn.btn-active-light-dark, .btn.btn-active-light-dark:focus:not(.btn-active), .btn.btn-active-light-dark:hover:not(.btn-active), .btn.btn-active-light-dark:active:not(.btn-active), .btn.btn-active-light-dark.active, .btn.btn-active-light-dark.show, .show > .btn.btn-active-light-dark {
  color: #181C32;
  border-color: #EFF2F5;
  background-color: #EFF2F5 !important;
}
.btn-check:checked + .btn.btn-active-light-dark i, .btn-check:active + .btn.btn-active-light-dark i, .btn.btn-active-light-dark:focus:not(.btn-active) i, .btn.btn-active-light-dark:hover:not(.btn-active) i, .btn.btn-active-light-dark:active:not(.btn-active) i, .btn.btn-active-light-dark.active i, .btn.btn-active-light-dark.show i, .show > .btn.btn-active-light-dark i {
  color: #181C32;
}
.btn-check:checked + .btn.btn-active-light-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-dark:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-dark:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-dark:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-dark.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-dark.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-dark .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #181C32;
}
.btn-check:checked + .btn.btn-active-light-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-dark:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-dark:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-dark:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-dark.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-dark.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-dark .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-light-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-dark.dropdown-toggle:after, .btn.btn-active-light-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark.active.dropdown-toggle:after, .btn.btn-active-light-dark.show.dropdown-toggle:after, .show > .btn.btn-active-light-dark.dropdown-toggle:after {
  color: #181C32;
}
.btn.btn-active-light-dark.btn-outline:not(.btn-outline-default) {
  border-color: #181C32 !important;
}

.btn.btn-color-white {
  color: #ffffff;
}
.btn.btn-color-white i {
  color: #ffffff;
}
.btn.btn-color-white .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.btn.btn-color-white .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-color-white.dropdown-toggle:after {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-active-color-white, .btn-check:active + .btn.btn-active-color-white, .btn.btn-active-color-white:focus:not(.btn-active), .btn.btn-active-color-white:hover:not(.btn-active), .btn.btn-active-color-white:active:not(.btn-active), .btn.btn-active-color-white.active, .btn.btn-active-color-white.show, .show > .btn.btn-active-color-white {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-active-color-white i, .btn-check:active + .btn.btn-active-color-white i, .btn.btn-active-color-white:focus:not(.btn-active) i, .btn.btn-active-color-white:hover:not(.btn-active) i, .btn.btn-active-color-white:active:not(.btn-active) i, .btn.btn-active-color-white.active i, .btn.btn-active-color-white.show i, .show > .btn.btn-active-color-white i {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-active-color-white .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-white .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-white:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-white:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-white:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-white.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-white.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-white .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.btn-check:checked + .btn.btn-active-color-white .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-white .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-white:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-white:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-white:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-white.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-white.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-white .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-color-white.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-white.dropdown-toggle:after, .btn.btn-active-color-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white.active.dropdown-toggle:after, .btn.btn-active-color-white.show.dropdown-toggle:after, .show > .btn.btn-active-color-white.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-icon-white i {
  color: #ffffff;
}
.btn.btn-icon-white .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.btn.btn-icon-white .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-icon-white.dropdown-toggle:after {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-active-icon-white i, .btn-check:active + .btn.btn-active-icon-white i, .btn.btn-active-icon-white:focus:not(.btn-active) i, .btn.btn-active-icon-white:hover:not(.btn-active) i, .btn.btn-active-icon-white:active:not(.btn-active) i, .btn.btn-active-icon-white.active i, .btn.btn-active-icon-white.show i, .show > .btn.btn-active-icon-white i {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-active-icon-white .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-white .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-white:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-white:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-white:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-white.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-white.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-white .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.btn-check:checked + .btn.btn-active-icon-white .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-white .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-white:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-white:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-white:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-white.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-white.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-white .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-icon-white.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-white.dropdown-toggle:after, .btn.btn-active-icon-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white.active.dropdown-toggle:after, .btn.btn-active-icon-white.show.dropdown-toggle:after, .show > .btn.btn-active-icon-white.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-text-white {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-active-text-white, .btn-check:active + .btn.btn-active-text-white, .btn.btn-active-text-white:focus:not(.btn-active), .btn.btn-active-text-white:hover:not(.btn-active), .btn.btn-active-text-white:active:not(.btn-active), .btn.btn-active-text-white.active, .btn.btn-active-text-white.show, .show > .btn.btn-active-text-white {
  color: #ffffff;
}

.btn.btn-color-primary {
  color: #009EF7;
}
.btn.btn-color-primary i {
  color: #009EF7;
}
.btn.btn-color-primary .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.btn.btn-color-primary .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-color-primary.dropdown-toggle:after {
  color: #009EF7;
}
.btn-check:checked + .btn.btn-active-color-primary, .btn-check:active + .btn.btn-active-color-primary, .btn.btn-active-color-primary:focus:not(.btn-active), .btn.btn-active-color-primary:hover:not(.btn-active), .btn.btn-active-color-primary:active:not(.btn-active), .btn.btn-active-color-primary.active, .btn.btn-active-color-primary.show, .show > .btn.btn-active-color-primary {
  color: #009EF7;
}
.btn-check:checked + .btn.btn-active-color-primary i, .btn-check:active + .btn.btn-active-color-primary i, .btn.btn-active-color-primary:focus:not(.btn-active) i, .btn.btn-active-color-primary:hover:not(.btn-active) i, .btn.btn-active-color-primary:active:not(.btn-active) i, .btn.btn-active-color-primary.active i, .btn.btn-active-color-primary.show i, .show > .btn.btn-active-color-primary i {
  color: #009EF7;
}
.btn-check:checked + .btn.btn-active-color-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-primary:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-primary:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-primary:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-primary.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-primary.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-primary .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.btn-check:checked + .btn.btn-active-color-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-primary:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-primary:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-primary:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-primary.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-primary.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-primary .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-color-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-primary.dropdown-toggle:after, .btn.btn-active-color-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary.active.dropdown-toggle:after, .btn.btn-active-color-primary.show.dropdown-toggle:after, .show > .btn.btn-active-color-primary.dropdown-toggle:after {
  color: #009EF7;
}

.btn.btn-icon-primary i {
  color: #009EF7;
}
.btn.btn-icon-primary .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.btn.btn-icon-primary .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-icon-primary.dropdown-toggle:after {
  color: #009EF7;
}
.btn-check:checked + .btn.btn-active-icon-primary i, .btn-check:active + .btn.btn-active-icon-primary i, .btn.btn-active-icon-primary:focus:not(.btn-active) i, .btn.btn-active-icon-primary:hover:not(.btn-active) i, .btn.btn-active-icon-primary:active:not(.btn-active) i, .btn.btn-active-icon-primary.active i, .btn.btn-active-icon-primary.show i, .show > .btn.btn-active-icon-primary i {
  color: #009EF7;
}
.btn-check:checked + .btn.btn-active-icon-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-primary:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-primary:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-primary:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-primary.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-primary.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-primary .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.btn-check:checked + .btn.btn-active-icon-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-primary:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-primary:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-primary:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-primary.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-primary.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-primary .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-icon-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-primary.dropdown-toggle:after, .btn.btn-active-icon-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary.active.dropdown-toggle:after, .btn.btn-active-icon-primary.show.dropdown-toggle:after, .show > .btn.btn-active-icon-primary.dropdown-toggle:after {
  color: #009EF7;
}

.btn.btn-text-primary {
  color: #009EF7;
}
.btn-check:checked + .btn.btn-active-text-primary, .btn-check:active + .btn.btn-active-text-primary, .btn.btn-active-text-primary:focus:not(.btn-active), .btn.btn-active-text-primary:hover:not(.btn-active), .btn.btn-active-text-primary:active:not(.btn-active), .btn.btn-active-text-primary.active, .btn.btn-active-text-primary.show, .show > .btn.btn-active-text-primary {
  color: #009EF7;
}

.btn.btn-color-secondary {
  color: #E4E6EF;
}
.btn.btn-color-secondary i {
  color: #E4E6EF;
}
.btn.btn-color-secondary .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #E4E6EF;
}
.btn.btn-color-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-color-secondary.dropdown-toggle:after {
  color: #E4E6EF;
}
.btn-check:checked + .btn.btn-active-color-secondary, .btn-check:active + .btn.btn-active-color-secondary, .btn.btn-active-color-secondary:focus:not(.btn-active), .btn.btn-active-color-secondary:hover:not(.btn-active), .btn.btn-active-color-secondary:active:not(.btn-active), .btn.btn-active-color-secondary.active, .btn.btn-active-color-secondary.show, .show > .btn.btn-active-color-secondary {
  color: #E4E6EF;
}
.btn-check:checked + .btn.btn-active-color-secondary i, .btn-check:active + .btn.btn-active-color-secondary i, .btn.btn-active-color-secondary:focus:not(.btn-active) i, .btn.btn-active-color-secondary:hover:not(.btn-active) i, .btn.btn-active-color-secondary:active:not(.btn-active) i, .btn.btn-active-color-secondary.active i, .btn.btn-active-color-secondary.show i, .show > .btn.btn-active-color-secondary i {
  color: #E4E6EF;
}
.btn-check:checked + .btn.btn-active-color-secondary .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-secondary .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-secondary:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-secondary:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-secondary:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-secondary.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-secondary.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-secondary .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #E4E6EF;
}
.btn-check:checked + .btn.btn-active-color-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-secondary:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-secondary:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-secondary:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-secondary.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-secondary.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-color-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-secondary.dropdown-toggle:after, .btn.btn-active-color-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary.active.dropdown-toggle:after, .btn.btn-active-color-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-color-secondary.dropdown-toggle:after {
  color: #E4E6EF;
}

.btn.btn-icon-secondary i {
  color: #E4E6EF;
}
.btn.btn-icon-secondary .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #E4E6EF;
}
.btn.btn-icon-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-icon-secondary.dropdown-toggle:after {
  color: #E4E6EF;
}
.btn-check:checked + .btn.btn-active-icon-secondary i, .btn-check:active + .btn.btn-active-icon-secondary i, .btn.btn-active-icon-secondary:focus:not(.btn-active) i, .btn.btn-active-icon-secondary:hover:not(.btn-active) i, .btn.btn-active-icon-secondary:active:not(.btn-active) i, .btn.btn-active-icon-secondary.active i, .btn.btn-active-icon-secondary.show i, .show > .btn.btn-active-icon-secondary i {
  color: #E4E6EF;
}
.btn-check:checked + .btn.btn-active-icon-secondary .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-secondary .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-secondary:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-secondary:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-secondary:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-secondary.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-secondary.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-secondary .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #E4E6EF;
}
.btn-check:checked + .btn.btn-active-icon-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-secondary:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-secondary:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-secondary:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-secondary.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-secondary.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-icon-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-secondary.dropdown-toggle:after, .btn.btn-active-icon-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary.active.dropdown-toggle:after, .btn.btn-active-icon-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-icon-secondary.dropdown-toggle:after {
  color: #E4E6EF;
}

.btn.btn-text-secondary {
  color: #E4E6EF;
}
.btn-check:checked + .btn.btn-active-text-secondary, .btn-check:active + .btn.btn-active-text-secondary, .btn.btn-active-text-secondary:focus:not(.btn-active), .btn.btn-active-text-secondary:hover:not(.btn-active), .btn.btn-active-text-secondary:active:not(.btn-active), .btn.btn-active-text-secondary.active, .btn.btn-active-text-secondary.show, .show > .btn.btn-active-text-secondary {
  color: #E4E6EF;
}

.btn.btn-color-light {
  color: #F5F8FA;
}
.btn.btn-color-light i {
  color: #F5F8FA;
}
.btn.btn-color-light .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F5F8FA;
}
.btn.btn-color-light .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-color-light.dropdown-toggle:after {
  color: #F5F8FA;
}
.btn-check:checked + .btn.btn-active-color-light, .btn-check:active + .btn.btn-active-color-light, .btn.btn-active-color-light:focus:not(.btn-active), .btn.btn-active-color-light:hover:not(.btn-active), .btn.btn-active-color-light:active:not(.btn-active), .btn.btn-active-color-light.active, .btn.btn-active-color-light.show, .show > .btn.btn-active-color-light {
  color: #F5F8FA;
}
.btn-check:checked + .btn.btn-active-color-light i, .btn-check:active + .btn.btn-active-color-light i, .btn.btn-active-color-light:focus:not(.btn-active) i, .btn.btn-active-color-light:hover:not(.btn-active) i, .btn.btn-active-color-light:active:not(.btn-active) i, .btn.btn-active-color-light.active i, .btn.btn-active-color-light.show i, .show > .btn.btn-active-color-light i {
  color: #F5F8FA;
}
.btn-check:checked + .btn.btn-active-color-light .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-light .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-light:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-light:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-light:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-light.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-light.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-light .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F5F8FA;
}
.btn-check:checked + .btn.btn-active-color-light .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-light .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-light:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-light:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-light:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-light.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-light.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-light .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-color-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-light.dropdown-toggle:after, .btn.btn-active-color-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light.active.dropdown-toggle:after, .btn.btn-active-color-light.show.dropdown-toggle:after, .show > .btn.btn-active-color-light.dropdown-toggle:after {
  color: #F5F8FA;
}

.btn.btn-icon-light i {
  color: #F5F8FA;
}
.btn.btn-icon-light .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F5F8FA;
}
.btn.btn-icon-light .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-icon-light.dropdown-toggle:after {
  color: #F5F8FA;
}
.btn-check:checked + .btn.btn-active-icon-light i, .btn-check:active + .btn.btn-active-icon-light i, .btn.btn-active-icon-light:focus:not(.btn-active) i, .btn.btn-active-icon-light:hover:not(.btn-active) i, .btn.btn-active-icon-light:active:not(.btn-active) i, .btn.btn-active-icon-light.active i, .btn.btn-active-icon-light.show i, .show > .btn.btn-active-icon-light i {
  color: #F5F8FA;
}
.btn-check:checked + .btn.btn-active-icon-light .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-light .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-light:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-light:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-light:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-light.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-light.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-light .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F5F8FA;
}
.btn-check:checked + .btn.btn-active-icon-light .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-light .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-light:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-light:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-light:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-light.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-light.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-light .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-icon-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-light.dropdown-toggle:after, .btn.btn-active-icon-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light.active.dropdown-toggle:after, .btn.btn-active-icon-light.show.dropdown-toggle:after, .show > .btn.btn-active-icon-light.dropdown-toggle:after {
  color: #F5F8FA;
}

.btn.btn-text-light {
  color: #F5F8FA;
}
.btn-check:checked + .btn.btn-active-text-light, .btn-check:active + .btn.btn-active-text-light, .btn.btn-active-text-light:focus:not(.btn-active), .btn.btn-active-text-light:hover:not(.btn-active), .btn.btn-active-text-light:active:not(.btn-active), .btn.btn-active-text-light.active, .btn.btn-active-text-light.show, .show > .btn.btn-active-text-light {
  color: #F5F8FA;
}

.btn.btn-color-success {
  color: #50CD89;
}
.btn.btn-color-success i {
  color: #50CD89;
}
.btn.btn-color-success .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #50CD89;
}
.btn.btn-color-success .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-color-success.dropdown-toggle:after {
  color: #50CD89;
}
.btn-check:checked + .btn.btn-active-color-success, .btn-check:active + .btn.btn-active-color-success, .btn.btn-active-color-success:focus:not(.btn-active), .btn.btn-active-color-success:hover:not(.btn-active), .btn.btn-active-color-success:active:not(.btn-active), .btn.btn-active-color-success.active, .btn.btn-active-color-success.show, .show > .btn.btn-active-color-success {
  color: #50CD89;
}
.btn-check:checked + .btn.btn-active-color-success i, .btn-check:active + .btn.btn-active-color-success i, .btn.btn-active-color-success:focus:not(.btn-active) i, .btn.btn-active-color-success:hover:not(.btn-active) i, .btn.btn-active-color-success:active:not(.btn-active) i, .btn.btn-active-color-success.active i, .btn.btn-active-color-success.show i, .show > .btn.btn-active-color-success i {
  color: #50CD89;
}
.btn-check:checked + .btn.btn-active-color-success .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-success .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-success:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-success:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-success:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-success.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-success.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-success .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #50CD89;
}
.btn-check:checked + .btn.btn-active-color-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-success:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-success:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-success:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-success.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-success.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-success .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-color-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-success.dropdown-toggle:after, .btn.btn-active-color-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success.active.dropdown-toggle:after, .btn.btn-active-color-success.show.dropdown-toggle:after, .show > .btn.btn-active-color-success.dropdown-toggle:after {
  color: #50CD89;
}

.btn.btn-icon-success i {
  color: #50CD89;
}
.btn.btn-icon-success .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #50CD89;
}
.btn.btn-icon-success .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-icon-success.dropdown-toggle:after {
  color: #50CD89;
}
.btn-check:checked + .btn.btn-active-icon-success i, .btn-check:active + .btn.btn-active-icon-success i, .btn.btn-active-icon-success:focus:not(.btn-active) i, .btn.btn-active-icon-success:hover:not(.btn-active) i, .btn.btn-active-icon-success:active:not(.btn-active) i, .btn.btn-active-icon-success.active i, .btn.btn-active-icon-success.show i, .show > .btn.btn-active-icon-success i {
  color: #50CD89;
}
.btn-check:checked + .btn.btn-active-icon-success .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-success .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-success:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-success:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-success:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-success.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-success.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-success .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #50CD89;
}
.btn-check:checked + .btn.btn-active-icon-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-success:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-success:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-success:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-success.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-success.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-success .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-icon-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-success.dropdown-toggle:after, .btn.btn-active-icon-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success.active.dropdown-toggle:after, .btn.btn-active-icon-success.show.dropdown-toggle:after, .show > .btn.btn-active-icon-success.dropdown-toggle:after {
  color: #50CD89;
}

.btn.btn-text-success {
  color: #50CD89;
}
.btn-check:checked + .btn.btn-active-text-success, .btn-check:active + .btn.btn-active-text-success, .btn.btn-active-text-success:focus:not(.btn-active), .btn.btn-active-text-success:hover:not(.btn-active), .btn.btn-active-text-success:active:not(.btn-active), .btn.btn-active-text-success.active, .btn.btn-active-text-success.show, .show > .btn.btn-active-text-success {
  color: #50CD89;
}

.btn.btn-color-info {
  color: #7239EA;
}
.btn.btn-color-info i {
  color: #7239EA;
}
.btn.btn-color-info .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7239EA;
}
.btn.btn-color-info .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-color-info.dropdown-toggle:after {
  color: #7239EA;
}
.btn-check:checked + .btn.btn-active-color-info, .btn-check:active + .btn.btn-active-color-info, .btn.btn-active-color-info:focus:not(.btn-active), .btn.btn-active-color-info:hover:not(.btn-active), .btn.btn-active-color-info:active:not(.btn-active), .btn.btn-active-color-info.active, .btn.btn-active-color-info.show, .show > .btn.btn-active-color-info {
  color: #7239EA;
}
.btn-check:checked + .btn.btn-active-color-info i, .btn-check:active + .btn.btn-active-color-info i, .btn.btn-active-color-info:focus:not(.btn-active) i, .btn.btn-active-color-info:hover:not(.btn-active) i, .btn.btn-active-color-info:active:not(.btn-active) i, .btn.btn-active-color-info.active i, .btn.btn-active-color-info.show i, .show > .btn.btn-active-color-info i {
  color: #7239EA;
}
.btn-check:checked + .btn.btn-active-color-info .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-info .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-info:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-info:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-info:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-info.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-info.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-info .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7239EA;
}
.btn-check:checked + .btn.btn-active-color-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-info:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-info:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-info:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-info.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-info.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-info .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-color-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-info.dropdown-toggle:after, .btn.btn-active-color-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info.active.dropdown-toggle:after, .btn.btn-active-color-info.show.dropdown-toggle:after, .show > .btn.btn-active-color-info.dropdown-toggle:after {
  color: #7239EA;
}

.btn.btn-icon-info i {
  color: #7239EA;
}
.btn.btn-icon-info .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7239EA;
}
.btn.btn-icon-info .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-icon-info.dropdown-toggle:after {
  color: #7239EA;
}
.btn-check:checked + .btn.btn-active-icon-info i, .btn-check:active + .btn.btn-active-icon-info i, .btn.btn-active-icon-info:focus:not(.btn-active) i, .btn.btn-active-icon-info:hover:not(.btn-active) i, .btn.btn-active-icon-info:active:not(.btn-active) i, .btn.btn-active-icon-info.active i, .btn.btn-active-icon-info.show i, .show > .btn.btn-active-icon-info i {
  color: #7239EA;
}
.btn-check:checked + .btn.btn-active-icon-info .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-info .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-info:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-info:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-info:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-info.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-info.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-info .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7239EA;
}
.btn-check:checked + .btn.btn-active-icon-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-info:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-info:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-info:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-info.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-info.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-info .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-icon-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-info.dropdown-toggle:after, .btn.btn-active-icon-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info.active.dropdown-toggle:after, .btn.btn-active-icon-info.show.dropdown-toggle:after, .show > .btn.btn-active-icon-info.dropdown-toggle:after {
  color: #7239EA;
}

.btn.btn-text-info {
  color: #7239EA;
}
.btn-check:checked + .btn.btn-active-text-info, .btn-check:active + .btn.btn-active-text-info, .btn.btn-active-text-info:focus:not(.btn-active), .btn.btn-active-text-info:hover:not(.btn-active), .btn.btn-active-text-info:active:not(.btn-active), .btn.btn-active-text-info.active, .btn.btn-active-text-info.show, .show > .btn.btn-active-text-info {
  color: #7239EA;
}

.btn.btn-color-warning {
  color: #FFC700;
}
.btn.btn-color-warning i {
  color: #FFC700;
}
.btn.btn-color-warning .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFC700;
}
.btn.btn-color-warning .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-color-warning.dropdown-toggle:after {
  color: #FFC700;
}
.btn-check:checked + .btn.btn-active-color-warning, .btn-check:active + .btn.btn-active-color-warning, .btn.btn-active-color-warning:focus:not(.btn-active), .btn.btn-active-color-warning:hover:not(.btn-active), .btn.btn-active-color-warning:active:not(.btn-active), .btn.btn-active-color-warning.active, .btn.btn-active-color-warning.show, .show > .btn.btn-active-color-warning {
  color: #FFC700;
}
.btn-check:checked + .btn.btn-active-color-warning i, .btn-check:active + .btn.btn-active-color-warning i, .btn.btn-active-color-warning:focus:not(.btn-active) i, .btn.btn-active-color-warning:hover:not(.btn-active) i, .btn.btn-active-color-warning:active:not(.btn-active) i, .btn.btn-active-color-warning.active i, .btn.btn-active-color-warning.show i, .show > .btn.btn-active-color-warning i {
  color: #FFC700;
}
.btn-check:checked + .btn.btn-active-color-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-warning:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-warning:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-warning:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-warning.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-warning.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-warning .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFC700;
}
.btn-check:checked + .btn.btn-active-color-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-warning:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-warning:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-warning:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-warning.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-warning.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-warning .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-color-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-warning.dropdown-toggle:after, .btn.btn-active-color-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning.active.dropdown-toggle:after, .btn.btn-active-color-warning.show.dropdown-toggle:after, .show > .btn.btn-active-color-warning.dropdown-toggle:after {
  color: #FFC700;
}

.btn.btn-icon-warning i {
  color: #FFC700;
}
.btn.btn-icon-warning .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFC700;
}
.btn.btn-icon-warning .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-icon-warning.dropdown-toggle:after {
  color: #FFC700;
}
.btn-check:checked + .btn.btn-active-icon-warning i, .btn-check:active + .btn.btn-active-icon-warning i, .btn.btn-active-icon-warning:focus:not(.btn-active) i, .btn.btn-active-icon-warning:hover:not(.btn-active) i, .btn.btn-active-icon-warning:active:not(.btn-active) i, .btn.btn-active-icon-warning.active i, .btn.btn-active-icon-warning.show i, .show > .btn.btn-active-icon-warning i {
  color: #FFC700;
}
.btn-check:checked + .btn.btn-active-icon-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-warning:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-warning:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-warning:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-warning.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-warning.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-warning .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFC700;
}
.btn-check:checked + .btn.btn-active-icon-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-warning:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-warning:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-warning:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-warning.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-warning.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-warning .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-icon-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-warning.dropdown-toggle:after, .btn.btn-active-icon-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning.active.dropdown-toggle:after, .btn.btn-active-icon-warning.show.dropdown-toggle:after, .show > .btn.btn-active-icon-warning.dropdown-toggle:after {
  color: #FFC700;
}

.btn.btn-text-warning {
  color: #FFC700;
}
.btn-check:checked + .btn.btn-active-text-warning, .btn-check:active + .btn.btn-active-text-warning, .btn.btn-active-text-warning:focus:not(.btn-active), .btn.btn-active-text-warning:hover:not(.btn-active), .btn.btn-active-text-warning:active:not(.btn-active), .btn.btn-active-text-warning.active, .btn.btn-active-text-warning.show, .show > .btn.btn-active-text-warning {
  color: #FFC700;
}

.btn.btn-color-danger {
  color: #F1416C;
}
.btn.btn-color-danger i {
  color: #F1416C;
}
.btn.btn-color-danger .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F1416C;
}
.btn.btn-color-danger .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-color-danger.dropdown-toggle:after {
  color: #F1416C;
}
.btn-check:checked + .btn.btn-active-color-danger, .btn-check:active + .btn.btn-active-color-danger, .btn.btn-active-color-danger:focus:not(.btn-active), .btn.btn-active-color-danger:hover:not(.btn-active), .btn.btn-active-color-danger:active:not(.btn-active), .btn.btn-active-color-danger.active, .btn.btn-active-color-danger.show, .show > .btn.btn-active-color-danger {
  color: #F1416C;
}
.btn-check:checked + .btn.btn-active-color-danger i, .btn-check:active + .btn.btn-active-color-danger i, .btn.btn-active-color-danger:focus:not(.btn-active) i, .btn.btn-active-color-danger:hover:not(.btn-active) i, .btn.btn-active-color-danger:active:not(.btn-active) i, .btn.btn-active-color-danger.active i, .btn.btn-active-color-danger.show i, .show > .btn.btn-active-color-danger i {
  color: #F1416C;
}
.btn-check:checked + .btn.btn-active-color-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-danger:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-danger:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-danger:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-danger.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-danger.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-danger .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F1416C;
}
.btn-check:checked + .btn.btn-active-color-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-danger:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-danger:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-danger:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-danger.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-danger.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-danger .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-color-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-danger.dropdown-toggle:after, .btn.btn-active-color-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger.active.dropdown-toggle:after, .btn.btn-active-color-danger.show.dropdown-toggle:after, .show > .btn.btn-active-color-danger.dropdown-toggle:after {
  color: #F1416C;
}

.btn.btn-icon-danger i {
  color: #F1416C;
}
.btn.btn-icon-danger .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F1416C;
}
.btn.btn-icon-danger .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-icon-danger.dropdown-toggle:after {
  color: #F1416C;
}
.btn-check:checked + .btn.btn-active-icon-danger i, .btn-check:active + .btn.btn-active-icon-danger i, .btn.btn-active-icon-danger:focus:not(.btn-active) i, .btn.btn-active-icon-danger:hover:not(.btn-active) i, .btn.btn-active-icon-danger:active:not(.btn-active) i, .btn.btn-active-icon-danger.active i, .btn.btn-active-icon-danger.show i, .show > .btn.btn-active-icon-danger i {
  color: #F1416C;
}
.btn-check:checked + .btn.btn-active-icon-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-danger:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-danger:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-danger:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-danger.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-danger.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-danger .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F1416C;
}
.btn-check:checked + .btn.btn-active-icon-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-danger:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-danger:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-danger:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-danger.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-danger.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-danger .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-icon-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-danger.dropdown-toggle:after, .btn.btn-active-icon-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger.active.dropdown-toggle:after, .btn.btn-active-icon-danger.show.dropdown-toggle:after, .show > .btn.btn-active-icon-danger.dropdown-toggle:after {
  color: #F1416C;
}

.btn.btn-text-danger {
  color: #F1416C;
}
.btn-check:checked + .btn.btn-active-text-danger, .btn-check:active + .btn.btn-active-text-danger, .btn.btn-active-text-danger:focus:not(.btn-active), .btn.btn-active-text-danger:hover:not(.btn-active), .btn.btn-active-text-danger:active:not(.btn-active), .btn.btn-active-text-danger.active, .btn.btn-active-text-danger.show, .show > .btn.btn-active-text-danger {
  color: #F1416C;
}

.btn.btn-color-dark {
  color: #181C32;
}
.btn.btn-color-dark i {
  color: #181C32;
}
.btn.btn-color-dark .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #181C32;
}
.btn.btn-color-dark .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-color-dark.dropdown-toggle:after {
  color: #181C32;
}
.btn-check:checked + .btn.btn-active-color-dark, .btn-check:active + .btn.btn-active-color-dark, .btn.btn-active-color-dark:focus:not(.btn-active), .btn.btn-active-color-dark:hover:not(.btn-active), .btn.btn-active-color-dark:active:not(.btn-active), .btn.btn-active-color-dark.active, .btn.btn-active-color-dark.show, .show > .btn.btn-active-color-dark {
  color: #181C32;
}
.btn-check:checked + .btn.btn-active-color-dark i, .btn-check:active + .btn.btn-active-color-dark i, .btn.btn-active-color-dark:focus:not(.btn-active) i, .btn.btn-active-color-dark:hover:not(.btn-active) i, .btn.btn-active-color-dark:active:not(.btn-active) i, .btn.btn-active-color-dark.active i, .btn.btn-active-color-dark.show i, .show > .btn.btn-active-color-dark i {
  color: #181C32;
}
.btn-check:checked + .btn.btn-active-color-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-dark:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-dark:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-dark:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-dark.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-dark.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-dark .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #181C32;
}
.btn-check:checked + .btn.btn-active-color-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-dark:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-dark:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-dark:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-dark.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-dark.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-dark .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-color-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-dark.dropdown-toggle:after, .btn.btn-active-color-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark.active.dropdown-toggle:after, .btn.btn-active-color-dark.show.dropdown-toggle:after, .show > .btn.btn-active-color-dark.dropdown-toggle:after {
  color: #181C32;
}

.btn.btn-icon-dark i {
  color: #181C32;
}
.btn.btn-icon-dark .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #181C32;
}
.btn.btn-icon-dark .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-icon-dark.dropdown-toggle:after {
  color: #181C32;
}
.btn-check:checked + .btn.btn-active-icon-dark i, .btn-check:active + .btn.btn-active-icon-dark i, .btn.btn-active-icon-dark:focus:not(.btn-active) i, .btn.btn-active-icon-dark:hover:not(.btn-active) i, .btn.btn-active-icon-dark:active:not(.btn-active) i, .btn.btn-active-icon-dark.active i, .btn.btn-active-icon-dark.show i, .show > .btn.btn-active-icon-dark i {
  color: #181C32;
}
.btn-check:checked + .btn.btn-active-icon-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-dark:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-dark:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-dark:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-dark.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-dark.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-dark .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #181C32;
}
.btn-check:checked + .btn.btn-active-icon-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-dark:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-dark:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-dark:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-dark.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-dark.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-dark .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-icon-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-dark.dropdown-toggle:after, .btn.btn-active-icon-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark.active.dropdown-toggle:after, .btn.btn-active-icon-dark.show.dropdown-toggle:after, .show > .btn.btn-active-icon-dark.dropdown-toggle:after {
  color: #181C32;
}

.btn.btn-text-dark {
  color: #181C32;
}
.btn-check:checked + .btn.btn-active-text-dark, .btn-check:active + .btn.btn-active-text-dark, .btn.btn-active-text-dark:focus:not(.btn-active), .btn.btn-active-text-dark:hover:not(.btn-active), .btn.btn-active-text-dark:active:not(.btn-active), .btn.btn-active-text-dark.active, .btn.btn-active-text-dark.show, .show > .btn.btn-active-text-dark {
  color: #181C32;
}

.btn.btn-color-muted {
  color: #A1A5B7;
}
.btn.btn-color-muted i {
  color: #A1A5B7;
}
.btn.btn-color-muted .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.btn.btn-color-muted .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-color-muted.dropdown-toggle:after {
  color: #A1A5B7;
}
.btn-check:checked + .btn.btn-active-color-muted, .btn-check:active + .btn.btn-active-color-muted, .btn.btn-active-color-muted:focus:not(.btn-active), .btn.btn-active-color-muted:hover:not(.btn-active), .btn.btn-active-color-muted:active:not(.btn-active), .btn.btn-active-color-muted.active, .btn.btn-active-color-muted.show, .show > .btn.btn-active-color-muted {
  color: #A1A5B7;
}
.btn-check:checked + .btn.btn-active-color-muted i, .btn-check:active + .btn.btn-active-color-muted i, .btn.btn-active-color-muted:focus:not(.btn-active) i, .btn.btn-active-color-muted:hover:not(.btn-active) i, .btn.btn-active-color-muted:active:not(.btn-active) i, .btn.btn-active-color-muted.active i, .btn.btn-active-color-muted.show i, .show > .btn.btn-active-color-muted i {
  color: #A1A5B7;
}
.btn-check:checked + .btn.btn-active-color-muted .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-muted .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-muted:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-muted:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-muted:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-muted.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-muted.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-muted .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.btn-check:checked + .btn.btn-active-color-muted .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-muted .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-muted:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-muted:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-muted:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-muted.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-muted.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-muted .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-color-muted.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-muted.dropdown-toggle:after, .btn.btn-active-color-muted:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted.active.dropdown-toggle:after, .btn.btn-active-color-muted.show.dropdown-toggle:after, .show > .btn.btn-active-color-muted.dropdown-toggle:after {
  color: #A1A5B7;
}

.btn.btn-icon-muted i {
  color: #A1A5B7;
}
.btn.btn-icon-muted .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.btn.btn-icon-muted .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-icon-muted.dropdown-toggle:after {
  color: #A1A5B7;
}
.btn-check:checked + .btn.btn-active-icon-muted i, .btn-check:active + .btn.btn-active-icon-muted i, .btn.btn-active-icon-muted:focus:not(.btn-active) i, .btn.btn-active-icon-muted:hover:not(.btn-active) i, .btn.btn-active-icon-muted:active:not(.btn-active) i, .btn.btn-active-icon-muted.active i, .btn.btn-active-icon-muted.show i, .show > .btn.btn-active-icon-muted i {
  color: #A1A5B7;
}
.btn-check:checked + .btn.btn-active-icon-muted .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-muted .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-muted:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-muted:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-muted:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-muted.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-muted.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-muted .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.btn-check:checked + .btn.btn-active-icon-muted .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-muted .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-muted:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-muted:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-muted:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-muted.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-muted.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-muted .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-icon-muted.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-muted.dropdown-toggle:after, .btn.btn-active-icon-muted:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted.active.dropdown-toggle:after, .btn.btn-active-icon-muted.show.dropdown-toggle:after, .show > .btn.btn-active-icon-muted.dropdown-toggle:after {
  color: #A1A5B7;
}

.btn.btn-text-muted {
  color: #A1A5B7;
}
.btn-check:checked + .btn.btn-active-text-muted, .btn-check:active + .btn.btn-active-text-muted, .btn.btn-active-text-muted:focus:not(.btn-active), .btn.btn-active-text-muted:hover:not(.btn-active), .btn.btn-active-text-muted:active:not(.btn-active), .btn.btn-active-text-muted.active, .btn.btn-active-text-muted.show, .show > .btn.btn-active-text-muted {
  color: #A1A5B7;
}

.btn.btn-color-gray-100 {
  color: #F5F8FA;
}
.btn.btn-color-gray-100 i {
  color: #F5F8FA;
}
.btn.btn-color-gray-100 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F5F8FA;
}
.btn.btn-color-gray-100 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-color-gray-100.dropdown-toggle:after {
  color: #F5F8FA;
}
.btn-check:checked + .btn.btn-active-color-gray-100, .btn-check:active + .btn.btn-active-color-gray-100, .btn.btn-active-color-gray-100:focus:not(.btn-active), .btn.btn-active-color-gray-100:hover:not(.btn-active), .btn.btn-active-color-gray-100:active:not(.btn-active), .btn.btn-active-color-gray-100.active, .btn.btn-active-color-gray-100.show, .show > .btn.btn-active-color-gray-100 {
  color: #F5F8FA;
}
.btn-check:checked + .btn.btn-active-color-gray-100 i, .btn-check:active + .btn.btn-active-color-gray-100 i, .btn.btn-active-color-gray-100:focus:not(.btn-active) i, .btn.btn-active-color-gray-100:hover:not(.btn-active) i, .btn.btn-active-color-gray-100:active:not(.btn-active) i, .btn.btn-active-color-gray-100.active i, .btn.btn-active-color-gray-100.show i, .show > .btn.btn-active-color-gray-100 i {
  color: #F5F8FA;
}
.btn-check:checked + .btn.btn-active-color-gray-100 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-100 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-100:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-100:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-100:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-100.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-100.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-100 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F5F8FA;
}
.btn-check:checked + .btn.btn-active-color-gray-100 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-100 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-100:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-100:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-100:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-100.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-100.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-100 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-color-gray-100.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-100.dropdown-toggle:after, .btn.btn-active-color-gray-100:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100.active.dropdown-toggle:after, .btn.btn-active-color-gray-100.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-100.dropdown-toggle:after {
  color: #F5F8FA;
}

.btn.btn-icon-gray-100 i {
  color: #F5F8FA;
}
.btn.btn-icon-gray-100 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F5F8FA;
}
.btn.btn-icon-gray-100 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-icon-gray-100.dropdown-toggle:after {
  color: #F5F8FA;
}
.btn-check:checked + .btn.btn-active-icon-gray-100 i, .btn-check:active + .btn.btn-active-icon-gray-100 i, .btn.btn-active-icon-gray-100:focus:not(.btn-active) i, .btn.btn-active-icon-gray-100:hover:not(.btn-active) i, .btn.btn-active-icon-gray-100:active:not(.btn-active) i, .btn.btn-active-icon-gray-100.active i, .btn.btn-active-icon-gray-100.show i, .show > .btn.btn-active-icon-gray-100 i {
  color: #F5F8FA;
}
.btn-check:checked + .btn.btn-active-icon-gray-100 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-100 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-100:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-100:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-100:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-100.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-100.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-100 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F5F8FA;
}
.btn-check:checked + .btn.btn-active-icon-gray-100 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-100 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-100:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-100:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-100:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-100.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-100.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-100 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-icon-gray-100.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-100.dropdown-toggle:after, .btn.btn-active-icon-gray-100:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100.active.dropdown-toggle:after, .btn.btn-active-icon-gray-100.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-100.dropdown-toggle:after {
  color: #F5F8FA;
}

.btn.btn-text-gray-100 {
  color: #F5F8FA;
}
.btn-check:checked + .btn.btn-active-text-gray-100, .btn-check:active + .btn.btn-active-text-gray-100, .btn.btn-active-text-gray-100:focus:not(.btn-active), .btn.btn-active-text-gray-100:hover:not(.btn-active), .btn.btn-active-text-gray-100:active:not(.btn-active), .btn.btn-active-text-gray-100.active, .btn.btn-active-text-gray-100.show, .show > .btn.btn-active-text-gray-100 {
  color: #F5F8FA;
}

.btn.btn-color-gray-200 {
  color: #EFF2F5;
}
.btn.btn-color-gray-200 i {
  color: #EFF2F5;
}
.btn.btn-color-gray-200 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #EFF2F5;
}
.btn.btn-color-gray-200 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-color-gray-200.dropdown-toggle:after {
  color: #EFF2F5;
}
.btn-check:checked + .btn.btn-active-color-gray-200, .btn-check:active + .btn.btn-active-color-gray-200, .btn.btn-active-color-gray-200:focus:not(.btn-active), .btn.btn-active-color-gray-200:hover:not(.btn-active), .btn.btn-active-color-gray-200:active:not(.btn-active), .btn.btn-active-color-gray-200.active, .btn.btn-active-color-gray-200.show, .show > .btn.btn-active-color-gray-200 {
  color: #EFF2F5;
}
.btn-check:checked + .btn.btn-active-color-gray-200 i, .btn-check:active + .btn.btn-active-color-gray-200 i, .btn.btn-active-color-gray-200:focus:not(.btn-active) i, .btn.btn-active-color-gray-200:hover:not(.btn-active) i, .btn.btn-active-color-gray-200:active:not(.btn-active) i, .btn.btn-active-color-gray-200.active i, .btn.btn-active-color-gray-200.show i, .show > .btn.btn-active-color-gray-200 i {
  color: #EFF2F5;
}
.btn-check:checked + .btn.btn-active-color-gray-200 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-200 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-200:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-200:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-200:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-200.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-200.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-200 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #EFF2F5;
}
.btn-check:checked + .btn.btn-active-color-gray-200 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-200 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-200:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-200:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-200:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-200.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-200.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-200 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-color-gray-200.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-200.dropdown-toggle:after, .btn.btn-active-color-gray-200:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200.active.dropdown-toggle:after, .btn.btn-active-color-gray-200.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-200.dropdown-toggle:after {
  color: #EFF2F5;
}

.btn.btn-icon-gray-200 i {
  color: #EFF2F5;
}
.btn.btn-icon-gray-200 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #EFF2F5;
}
.btn.btn-icon-gray-200 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-icon-gray-200.dropdown-toggle:after {
  color: #EFF2F5;
}
.btn-check:checked + .btn.btn-active-icon-gray-200 i, .btn-check:active + .btn.btn-active-icon-gray-200 i, .btn.btn-active-icon-gray-200:focus:not(.btn-active) i, .btn.btn-active-icon-gray-200:hover:not(.btn-active) i, .btn.btn-active-icon-gray-200:active:not(.btn-active) i, .btn.btn-active-icon-gray-200.active i, .btn.btn-active-icon-gray-200.show i, .show > .btn.btn-active-icon-gray-200 i {
  color: #EFF2F5;
}
.btn-check:checked + .btn.btn-active-icon-gray-200 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-200 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-200:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-200:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-200:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-200.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-200.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-200 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #EFF2F5;
}
.btn-check:checked + .btn.btn-active-icon-gray-200 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-200 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-200:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-200:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-200:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-200.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-200.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-200 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-icon-gray-200.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-200.dropdown-toggle:after, .btn.btn-active-icon-gray-200:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200.active.dropdown-toggle:after, .btn.btn-active-icon-gray-200.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-200.dropdown-toggle:after {
  color: #EFF2F5;
}

.btn.btn-text-gray-200 {
  color: #EFF2F5;
}
.btn-check:checked + .btn.btn-active-text-gray-200, .btn-check:active + .btn.btn-active-text-gray-200, .btn.btn-active-text-gray-200:focus:not(.btn-active), .btn.btn-active-text-gray-200:hover:not(.btn-active), .btn.btn-active-text-gray-200:active:not(.btn-active), .btn.btn-active-text-gray-200.active, .btn.btn-active-text-gray-200.show, .show > .btn.btn-active-text-gray-200 {
  color: #EFF2F5;
}

.btn.btn-color-gray-300 {
  color: #E4E6EF;
}
.btn.btn-color-gray-300 i {
  color: #E4E6EF;
}
.btn.btn-color-gray-300 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #E4E6EF;
}
.btn.btn-color-gray-300 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-color-gray-300.dropdown-toggle:after {
  color: #E4E6EF;
}
.btn-check:checked + .btn.btn-active-color-gray-300, .btn-check:active + .btn.btn-active-color-gray-300, .btn.btn-active-color-gray-300:focus:not(.btn-active), .btn.btn-active-color-gray-300:hover:not(.btn-active), .btn.btn-active-color-gray-300:active:not(.btn-active), .btn.btn-active-color-gray-300.active, .btn.btn-active-color-gray-300.show, .show > .btn.btn-active-color-gray-300 {
  color: #E4E6EF;
}
.btn-check:checked + .btn.btn-active-color-gray-300 i, .btn-check:active + .btn.btn-active-color-gray-300 i, .btn.btn-active-color-gray-300:focus:not(.btn-active) i, .btn.btn-active-color-gray-300:hover:not(.btn-active) i, .btn.btn-active-color-gray-300:active:not(.btn-active) i, .btn.btn-active-color-gray-300.active i, .btn.btn-active-color-gray-300.show i, .show > .btn.btn-active-color-gray-300 i {
  color: #E4E6EF;
}
.btn-check:checked + .btn.btn-active-color-gray-300 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-300 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-300:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-300:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-300:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-300.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-300.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-300 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #E4E6EF;
}
.btn-check:checked + .btn.btn-active-color-gray-300 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-300 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-300:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-300:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-300:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-300.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-300.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-300 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-color-gray-300.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-300.dropdown-toggle:after, .btn.btn-active-color-gray-300:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300.active.dropdown-toggle:after, .btn.btn-active-color-gray-300.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-300.dropdown-toggle:after {
  color: #E4E6EF;
}

.btn.btn-icon-gray-300 i {
  color: #E4E6EF;
}
.btn.btn-icon-gray-300 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #E4E6EF;
}
.btn.btn-icon-gray-300 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-icon-gray-300.dropdown-toggle:after {
  color: #E4E6EF;
}
.btn-check:checked + .btn.btn-active-icon-gray-300 i, .btn-check:active + .btn.btn-active-icon-gray-300 i, .btn.btn-active-icon-gray-300:focus:not(.btn-active) i, .btn.btn-active-icon-gray-300:hover:not(.btn-active) i, .btn.btn-active-icon-gray-300:active:not(.btn-active) i, .btn.btn-active-icon-gray-300.active i, .btn.btn-active-icon-gray-300.show i, .show > .btn.btn-active-icon-gray-300 i {
  color: #E4E6EF;
}
.btn-check:checked + .btn.btn-active-icon-gray-300 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-300 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-300:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-300:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-300:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-300.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-300.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-300 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #E4E6EF;
}
.btn-check:checked + .btn.btn-active-icon-gray-300 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-300 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-300:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-300:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-300:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-300.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-300.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-300 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-icon-gray-300.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-300.dropdown-toggle:after, .btn.btn-active-icon-gray-300:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300.active.dropdown-toggle:after, .btn.btn-active-icon-gray-300.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-300.dropdown-toggle:after {
  color: #E4E6EF;
}

.btn.btn-text-gray-300 {
  color: #E4E6EF;
}
.btn-check:checked + .btn.btn-active-text-gray-300, .btn-check:active + .btn.btn-active-text-gray-300, .btn.btn-active-text-gray-300:focus:not(.btn-active), .btn.btn-active-text-gray-300:hover:not(.btn-active), .btn.btn-active-text-gray-300:active:not(.btn-active), .btn.btn-active-text-gray-300.active, .btn.btn-active-text-gray-300.show, .show > .btn.btn-active-text-gray-300 {
  color: #E4E6EF;
}

.btn.btn-color-gray-400 {
  color: #B5B5C3;
}
.btn.btn-color-gray-400 i {
  color: #B5B5C3;
}
.btn.btn-color-gray-400 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #B5B5C3;
}
.btn.btn-color-gray-400 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-color-gray-400.dropdown-toggle:after {
  color: #B5B5C3;
}
.btn-check:checked + .btn.btn-active-color-gray-400, .btn-check:active + .btn.btn-active-color-gray-400, .btn.btn-active-color-gray-400:focus:not(.btn-active), .btn.btn-active-color-gray-400:hover:not(.btn-active), .btn.btn-active-color-gray-400:active:not(.btn-active), .btn.btn-active-color-gray-400.active, .btn.btn-active-color-gray-400.show, .show > .btn.btn-active-color-gray-400 {
  color: #B5B5C3;
}
.btn-check:checked + .btn.btn-active-color-gray-400 i, .btn-check:active + .btn.btn-active-color-gray-400 i, .btn.btn-active-color-gray-400:focus:not(.btn-active) i, .btn.btn-active-color-gray-400:hover:not(.btn-active) i, .btn.btn-active-color-gray-400:active:not(.btn-active) i, .btn.btn-active-color-gray-400.active i, .btn.btn-active-color-gray-400.show i, .show > .btn.btn-active-color-gray-400 i {
  color: #B5B5C3;
}
.btn-check:checked + .btn.btn-active-color-gray-400 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-400 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-400:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-400:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-400:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-400.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-400.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-400 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #B5B5C3;
}
.btn-check:checked + .btn.btn-active-color-gray-400 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-400 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-400:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-400:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-400:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-400.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-400.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-400 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-color-gray-400.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-400.dropdown-toggle:after, .btn.btn-active-color-gray-400:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400.active.dropdown-toggle:after, .btn.btn-active-color-gray-400.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-400.dropdown-toggle:after {
  color: #B5B5C3;
}

.btn.btn-icon-gray-400 i {
  color: #B5B5C3;
}
.btn.btn-icon-gray-400 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #B5B5C3;
}
.btn.btn-icon-gray-400 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-icon-gray-400.dropdown-toggle:after {
  color: #B5B5C3;
}
.btn-check:checked + .btn.btn-active-icon-gray-400 i, .btn-check:active + .btn.btn-active-icon-gray-400 i, .btn.btn-active-icon-gray-400:focus:not(.btn-active) i, .btn.btn-active-icon-gray-400:hover:not(.btn-active) i, .btn.btn-active-icon-gray-400:active:not(.btn-active) i, .btn.btn-active-icon-gray-400.active i, .btn.btn-active-icon-gray-400.show i, .show > .btn.btn-active-icon-gray-400 i {
  color: #B5B5C3;
}
.btn-check:checked + .btn.btn-active-icon-gray-400 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-400 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-400:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-400:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-400:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-400.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-400.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-400 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #B5B5C3;
}
.btn-check:checked + .btn.btn-active-icon-gray-400 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-400 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-400:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-400:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-400:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-400.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-400.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-400 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-icon-gray-400.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-400.dropdown-toggle:after, .btn.btn-active-icon-gray-400:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400.active.dropdown-toggle:after, .btn.btn-active-icon-gray-400.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-400.dropdown-toggle:after {
  color: #B5B5C3;
}

.btn.btn-text-gray-400 {
  color: #B5B5C3;
}
.btn-check:checked + .btn.btn-active-text-gray-400, .btn-check:active + .btn.btn-active-text-gray-400, .btn.btn-active-text-gray-400:focus:not(.btn-active), .btn.btn-active-text-gray-400:hover:not(.btn-active), .btn.btn-active-text-gray-400:active:not(.btn-active), .btn.btn-active-text-gray-400.active, .btn.btn-active-text-gray-400.show, .show > .btn.btn-active-text-gray-400 {
  color: #B5B5C3;
}

.btn.btn-color-gray-500 {
  color: #A1A5B7;
}
.btn.btn-color-gray-500 i {
  color: #A1A5B7;
}
.btn.btn-color-gray-500 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.btn.btn-color-gray-500 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-color-gray-500.dropdown-toggle:after {
  color: #A1A5B7;
}
.btn-check:checked + .btn.btn-active-color-gray-500, .btn-check:active + .btn.btn-active-color-gray-500, .btn.btn-active-color-gray-500:focus:not(.btn-active), .btn.btn-active-color-gray-500:hover:not(.btn-active), .btn.btn-active-color-gray-500:active:not(.btn-active), .btn.btn-active-color-gray-500.active, .btn.btn-active-color-gray-500.show, .show > .btn.btn-active-color-gray-500 {
  color: #A1A5B7;
}
.btn-check:checked + .btn.btn-active-color-gray-500 i, .btn-check:active + .btn.btn-active-color-gray-500 i, .btn.btn-active-color-gray-500:focus:not(.btn-active) i, .btn.btn-active-color-gray-500:hover:not(.btn-active) i, .btn.btn-active-color-gray-500:active:not(.btn-active) i, .btn.btn-active-color-gray-500.active i, .btn.btn-active-color-gray-500.show i, .show > .btn.btn-active-color-gray-500 i {
  color: #A1A5B7;
}
.btn-check:checked + .btn.btn-active-color-gray-500 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-500 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-500:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-500:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-500:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-500.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-500.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-500 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.btn-check:checked + .btn.btn-active-color-gray-500 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-500 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-500:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-500:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-500:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-500.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-500.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-500 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-color-gray-500.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-500.dropdown-toggle:after, .btn.btn-active-color-gray-500:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500.active.dropdown-toggle:after, .btn.btn-active-color-gray-500.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-500.dropdown-toggle:after {
  color: #A1A5B7;
}

.btn.btn-icon-gray-500 i {
  color: #A1A5B7;
}
.btn.btn-icon-gray-500 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.btn.btn-icon-gray-500 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-icon-gray-500.dropdown-toggle:after {
  color: #A1A5B7;
}
.btn-check:checked + .btn.btn-active-icon-gray-500 i, .btn-check:active + .btn.btn-active-icon-gray-500 i, .btn.btn-active-icon-gray-500:focus:not(.btn-active) i, .btn.btn-active-icon-gray-500:hover:not(.btn-active) i, .btn.btn-active-icon-gray-500:active:not(.btn-active) i, .btn.btn-active-icon-gray-500.active i, .btn.btn-active-icon-gray-500.show i, .show > .btn.btn-active-icon-gray-500 i {
  color: #A1A5B7;
}
.btn-check:checked + .btn.btn-active-icon-gray-500 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-500 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-500:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-500:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-500:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-500.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-500.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-500 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.btn-check:checked + .btn.btn-active-icon-gray-500 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-500 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-500:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-500:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-500:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-500.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-500.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-500 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-icon-gray-500.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-500.dropdown-toggle:after, .btn.btn-active-icon-gray-500:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500.active.dropdown-toggle:after, .btn.btn-active-icon-gray-500.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-500.dropdown-toggle:after {
  color: #A1A5B7;
}

.btn.btn-text-gray-500 {
  color: #A1A5B7;
}
.btn-check:checked + .btn.btn-active-text-gray-500, .btn-check:active + .btn.btn-active-text-gray-500, .btn.btn-active-text-gray-500:focus:not(.btn-active), .btn.btn-active-text-gray-500:hover:not(.btn-active), .btn.btn-active-text-gray-500:active:not(.btn-active), .btn.btn-active-text-gray-500.active, .btn.btn-active-text-gray-500.show, .show > .btn.btn-active-text-gray-500 {
  color: #A1A5B7;
}

.btn.btn-color-gray-600 {
  color: #7E8299;
}
.btn.btn-color-gray-600 i {
  color: #7E8299;
}
.btn.btn-color-gray-600 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7E8299;
}
.btn.btn-color-gray-600 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-color-gray-600.dropdown-toggle:after {
  color: #7E8299;
}
.btn-check:checked + .btn.btn-active-color-gray-600, .btn-check:active + .btn.btn-active-color-gray-600, .btn.btn-active-color-gray-600:focus:not(.btn-active), .btn.btn-active-color-gray-600:hover:not(.btn-active), .btn.btn-active-color-gray-600:active:not(.btn-active), .btn.btn-active-color-gray-600.active, .btn.btn-active-color-gray-600.show, .show > .btn.btn-active-color-gray-600 {
  color: #7E8299;
}
.btn-check:checked + .btn.btn-active-color-gray-600 i, .btn-check:active + .btn.btn-active-color-gray-600 i, .btn.btn-active-color-gray-600:focus:not(.btn-active) i, .btn.btn-active-color-gray-600:hover:not(.btn-active) i, .btn.btn-active-color-gray-600:active:not(.btn-active) i, .btn.btn-active-color-gray-600.active i, .btn.btn-active-color-gray-600.show i, .show > .btn.btn-active-color-gray-600 i {
  color: #7E8299;
}
.btn-check:checked + .btn.btn-active-color-gray-600 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-600 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-600:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-600:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-600:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-600.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-600.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-600 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7E8299;
}
.btn-check:checked + .btn.btn-active-color-gray-600 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-600 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-600:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-600:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-600:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-600.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-600.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-600 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-color-gray-600.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-600.dropdown-toggle:after, .btn.btn-active-color-gray-600:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600.active.dropdown-toggle:after, .btn.btn-active-color-gray-600.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-600.dropdown-toggle:after {
  color: #7E8299;
}

.btn.btn-icon-gray-600 i {
  color: #7E8299;
}
.btn.btn-icon-gray-600 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7E8299;
}
.btn.btn-icon-gray-600 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-icon-gray-600.dropdown-toggle:after {
  color: #7E8299;
}
.btn-check:checked + .btn.btn-active-icon-gray-600 i, .btn-check:active + .btn.btn-active-icon-gray-600 i, .btn.btn-active-icon-gray-600:focus:not(.btn-active) i, .btn.btn-active-icon-gray-600:hover:not(.btn-active) i, .btn.btn-active-icon-gray-600:active:not(.btn-active) i, .btn.btn-active-icon-gray-600.active i, .btn.btn-active-icon-gray-600.show i, .show > .btn.btn-active-icon-gray-600 i {
  color: #7E8299;
}
.btn-check:checked + .btn.btn-active-icon-gray-600 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-600 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-600:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-600:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-600:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-600.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-600.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-600 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7E8299;
}
.btn-check:checked + .btn.btn-active-icon-gray-600 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-600 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-600:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-600:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-600:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-600.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-600.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-600 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-icon-gray-600.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-600.dropdown-toggle:after, .btn.btn-active-icon-gray-600:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600.active.dropdown-toggle:after, .btn.btn-active-icon-gray-600.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-600.dropdown-toggle:after {
  color: #7E8299;
}

.btn.btn-text-gray-600 {
  color: #7E8299;
}
.btn-check:checked + .btn.btn-active-text-gray-600, .btn-check:active + .btn.btn-active-text-gray-600, .btn.btn-active-text-gray-600:focus:not(.btn-active), .btn.btn-active-text-gray-600:hover:not(.btn-active), .btn.btn-active-text-gray-600:active:not(.btn-active), .btn.btn-active-text-gray-600.active, .btn.btn-active-text-gray-600.show, .show > .btn.btn-active-text-gray-600 {
  color: #7E8299;
}

.btn.btn-color-gray-700 {
  color: #5E6278;
}
.btn.btn-color-gray-700 i {
  color: #5E6278;
}
.btn.btn-color-gray-700 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #5E6278;
}
.btn.btn-color-gray-700 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-color-gray-700.dropdown-toggle:after {
  color: #5E6278;
}
.btn-check:checked + .btn.btn-active-color-gray-700, .btn-check:active + .btn.btn-active-color-gray-700, .btn.btn-active-color-gray-700:focus:not(.btn-active), .btn.btn-active-color-gray-700:hover:not(.btn-active), .btn.btn-active-color-gray-700:active:not(.btn-active), .btn.btn-active-color-gray-700.active, .btn.btn-active-color-gray-700.show, .show > .btn.btn-active-color-gray-700 {
  color: #5E6278;
}
.btn-check:checked + .btn.btn-active-color-gray-700 i, .btn-check:active + .btn.btn-active-color-gray-700 i, .btn.btn-active-color-gray-700:focus:not(.btn-active) i, .btn.btn-active-color-gray-700:hover:not(.btn-active) i, .btn.btn-active-color-gray-700:active:not(.btn-active) i, .btn.btn-active-color-gray-700.active i, .btn.btn-active-color-gray-700.show i, .show > .btn.btn-active-color-gray-700 i {
  color: #5E6278;
}
.btn-check:checked + .btn.btn-active-color-gray-700 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-700 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-700:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-700:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-700:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-700.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-700.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-700 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #5E6278;
}
.btn-check:checked + .btn.btn-active-color-gray-700 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-700 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-700:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-700:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-700:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-700.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-700.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-700 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-color-gray-700.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-700.dropdown-toggle:after, .btn.btn-active-color-gray-700:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700.active.dropdown-toggle:after, .btn.btn-active-color-gray-700.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-700.dropdown-toggle:after {
  color: #5E6278;
}

.btn.btn-icon-gray-700 i {
  color: #5E6278;
}
.btn.btn-icon-gray-700 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #5E6278;
}
.btn.btn-icon-gray-700 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-icon-gray-700.dropdown-toggle:after {
  color: #5E6278;
}
.btn-check:checked + .btn.btn-active-icon-gray-700 i, .btn-check:active + .btn.btn-active-icon-gray-700 i, .btn.btn-active-icon-gray-700:focus:not(.btn-active) i, .btn.btn-active-icon-gray-700:hover:not(.btn-active) i, .btn.btn-active-icon-gray-700:active:not(.btn-active) i, .btn.btn-active-icon-gray-700.active i, .btn.btn-active-icon-gray-700.show i, .show > .btn.btn-active-icon-gray-700 i {
  color: #5E6278;
}
.btn-check:checked + .btn.btn-active-icon-gray-700 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-700 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-700:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-700:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-700:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-700.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-700.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-700 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #5E6278;
}
.btn-check:checked + .btn.btn-active-icon-gray-700 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-700 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-700:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-700:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-700:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-700.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-700.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-700 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-icon-gray-700.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-700.dropdown-toggle:after, .btn.btn-active-icon-gray-700:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700.active.dropdown-toggle:after, .btn.btn-active-icon-gray-700.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-700.dropdown-toggle:after {
  color: #5E6278;
}

.btn.btn-text-gray-700 {
  color: #5E6278;
}
.btn-check:checked + .btn.btn-active-text-gray-700, .btn-check:active + .btn.btn-active-text-gray-700, .btn.btn-active-text-gray-700:focus:not(.btn-active), .btn.btn-active-text-gray-700:hover:not(.btn-active), .btn.btn-active-text-gray-700:active:not(.btn-active), .btn.btn-active-text-gray-700.active, .btn.btn-active-text-gray-700.show, .show > .btn.btn-active-text-gray-700 {
  color: #5E6278;
}

.btn.btn-color-gray-800 {
  color: #3F4254;
}
.btn.btn-color-gray-800 i {
  color: #3F4254;
}
.btn.btn-color-gray-800 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #3F4254;
}
.btn.btn-color-gray-800 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-color-gray-800.dropdown-toggle:after {
  color: #3F4254;
}
.btn-check:checked + .btn.btn-active-color-gray-800, .btn-check:active + .btn.btn-active-color-gray-800, .btn.btn-active-color-gray-800:focus:not(.btn-active), .btn.btn-active-color-gray-800:hover:not(.btn-active), .btn.btn-active-color-gray-800:active:not(.btn-active), .btn.btn-active-color-gray-800.active, .btn.btn-active-color-gray-800.show, .show > .btn.btn-active-color-gray-800 {
  color: #3F4254;
}
.btn-check:checked + .btn.btn-active-color-gray-800 i, .btn-check:active + .btn.btn-active-color-gray-800 i, .btn.btn-active-color-gray-800:focus:not(.btn-active) i, .btn.btn-active-color-gray-800:hover:not(.btn-active) i, .btn.btn-active-color-gray-800:active:not(.btn-active) i, .btn.btn-active-color-gray-800.active i, .btn.btn-active-color-gray-800.show i, .show > .btn.btn-active-color-gray-800 i {
  color: #3F4254;
}
.btn-check:checked + .btn.btn-active-color-gray-800 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-800 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-800:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-800:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-800:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-800.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-800.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-800 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #3F4254;
}
.btn-check:checked + .btn.btn-active-color-gray-800 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-800 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-800:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-800:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-800:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-800.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-800.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-800 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-color-gray-800.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-800.dropdown-toggle:after, .btn.btn-active-color-gray-800:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800.active.dropdown-toggle:after, .btn.btn-active-color-gray-800.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-800.dropdown-toggle:after {
  color: #3F4254;
}

.btn.btn-icon-gray-800 i {
  color: #3F4254;
}
.btn.btn-icon-gray-800 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #3F4254;
}
.btn.btn-icon-gray-800 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-icon-gray-800.dropdown-toggle:after {
  color: #3F4254;
}
.btn-check:checked + .btn.btn-active-icon-gray-800 i, .btn-check:active + .btn.btn-active-icon-gray-800 i, .btn.btn-active-icon-gray-800:focus:not(.btn-active) i, .btn.btn-active-icon-gray-800:hover:not(.btn-active) i, .btn.btn-active-icon-gray-800:active:not(.btn-active) i, .btn.btn-active-icon-gray-800.active i, .btn.btn-active-icon-gray-800.show i, .show > .btn.btn-active-icon-gray-800 i {
  color: #3F4254;
}
.btn-check:checked + .btn.btn-active-icon-gray-800 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-800 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-800:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-800:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-800:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-800.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-800.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-800 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #3F4254;
}
.btn-check:checked + .btn.btn-active-icon-gray-800 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-800 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-800:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-800:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-800:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-800.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-800.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-800 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-icon-gray-800.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-800.dropdown-toggle:after, .btn.btn-active-icon-gray-800:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800.active.dropdown-toggle:after, .btn.btn-active-icon-gray-800.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-800.dropdown-toggle:after {
  color: #3F4254;
}

.btn.btn-text-gray-800 {
  color: #3F4254;
}
.btn-check:checked + .btn.btn-active-text-gray-800, .btn-check:active + .btn.btn-active-text-gray-800, .btn.btn-active-text-gray-800:focus:not(.btn-active), .btn.btn-active-text-gray-800:hover:not(.btn-active), .btn.btn-active-text-gray-800:active:not(.btn-active), .btn.btn-active-text-gray-800.active, .btn.btn-active-text-gray-800.show, .show > .btn.btn-active-text-gray-800 {
  color: #3F4254;
}

.btn.btn-color-gray-900 {
  color: #181C32;
}
.btn.btn-color-gray-900 i {
  color: #181C32;
}
.btn.btn-color-gray-900 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #181C32;
}
.btn.btn-color-gray-900 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-color-gray-900.dropdown-toggle:after {
  color: #181C32;
}
.btn-check:checked + .btn.btn-active-color-gray-900, .btn-check:active + .btn.btn-active-color-gray-900, .btn.btn-active-color-gray-900:focus:not(.btn-active), .btn.btn-active-color-gray-900:hover:not(.btn-active), .btn.btn-active-color-gray-900:active:not(.btn-active), .btn.btn-active-color-gray-900.active, .btn.btn-active-color-gray-900.show, .show > .btn.btn-active-color-gray-900 {
  color: #181C32;
}
.btn-check:checked + .btn.btn-active-color-gray-900 i, .btn-check:active + .btn.btn-active-color-gray-900 i, .btn.btn-active-color-gray-900:focus:not(.btn-active) i, .btn.btn-active-color-gray-900:hover:not(.btn-active) i, .btn.btn-active-color-gray-900:active:not(.btn-active) i, .btn.btn-active-color-gray-900.active i, .btn.btn-active-color-gray-900.show i, .show > .btn.btn-active-color-gray-900 i {
  color: #181C32;
}
.btn-check:checked + .btn.btn-active-color-gray-900 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-900 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-900:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-900:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-900:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-900.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-900.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-900 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #181C32;
}
.btn-check:checked + .btn.btn-active-color-gray-900 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-900 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-900:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-900:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-900:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-900.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-900.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-900 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-color-gray-900.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-900.dropdown-toggle:after, .btn.btn-active-color-gray-900:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900.active.dropdown-toggle:after, .btn.btn-active-color-gray-900.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-900.dropdown-toggle:after {
  color: #181C32;
}

.btn.btn-icon-gray-900 i {
  color: #181C32;
}
.btn.btn-icon-gray-900 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #181C32;
}
.btn.btn-icon-gray-900 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-icon-gray-900.dropdown-toggle:after {
  color: #181C32;
}
.btn-check:checked + .btn.btn-active-icon-gray-900 i, .btn-check:active + .btn.btn-active-icon-gray-900 i, .btn.btn-active-icon-gray-900:focus:not(.btn-active) i, .btn.btn-active-icon-gray-900:hover:not(.btn-active) i, .btn.btn-active-icon-gray-900:active:not(.btn-active) i, .btn.btn-active-icon-gray-900.active i, .btn.btn-active-icon-gray-900.show i, .show > .btn.btn-active-icon-gray-900 i {
  color: #181C32;
}
.btn-check:checked + .btn.btn-active-icon-gray-900 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-900 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-900:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-900:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-900:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-900.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-900.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-900 .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #181C32;
}
.btn-check:checked + .btn.btn-active-icon-gray-900 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-900 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-900:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-900:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-900:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-900.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-900.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-900 .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-active-icon-gray-900.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-900.dropdown-toggle:after, .btn.btn-active-icon-gray-900:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900.active.dropdown-toggle:after, .btn.btn-active-icon-gray-900.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-900.dropdown-toggle:after {
  color: #181C32;
}

.btn.btn-text-gray-900 {
  color: #181C32;
}
.btn-check:checked + .btn.btn-active-text-gray-900, .btn-check:active + .btn.btn-active-text-gray-900, .btn.btn-active-text-gray-900:focus:not(.btn-active), .btn.btn-active-text-gray-900:hover:not(.btn-active), .btn.btn-active-text-gray-900:active:not(.btn-active), .btn.btn-active-text-gray-900.active, .btn.btn-active-text-gray-900.show, .show > .btn.btn-active-text-gray-900 {
  color: #181C32;
}

.btn.btn-facebook {
  color: #ffffff;
  border-color: #3b5998;
  background-color: #3b5998;
}
.btn.btn-facebook i {
  color: #ffffff;
}
.btn.btn-facebook .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.btn.btn-facebook .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-facebook.dropdown-toggle:after {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-facebook, .btn-check:active + .btn.btn-facebook, .btn.btn-facebook:focus:not(.btn-active), .btn.btn-facebook:hover:not(.btn-active), .btn.btn-facebook:active:not(.btn-active), .btn.btn-facebook.active, .btn.btn-facebook.show, .show > .btn.btn-facebook {
  border-color: #30497c;
  background-color: #30497c !important;
}

.btn.btn-light-facebook {
  color: #3b5998;
  border-color: rgba(59, 89, 152, 0.1);
  background-color: rgba(59, 89, 152, 0.1);
}
.btn.btn-light-facebook i {
  color: #3b5998;
}
.btn.btn-light-facebook .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #3b5998;
}
.btn.btn-light-facebook .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-light-facebook.dropdown-toggle:after {
  color: #3b5998;
}
.btn-check:checked + .btn.btn-light-facebook, .btn-check:active + .btn.btn-light-facebook, .btn.btn-light-facebook:focus:not(.btn-active), .btn.btn-light-facebook:hover:not(.btn-active), .btn.btn-light-facebook:active:not(.btn-active), .btn.btn-light-facebook.active, .btn.btn-light-facebook.show, .show > .btn.btn-light-facebook {
  color: #ffffff;
  border-color: #3b5998;
  background-color: #3b5998 !important;
}
.btn-check:checked + .btn.btn-light-facebook i, .btn-check:active + .btn.btn-light-facebook i, .btn.btn-light-facebook:focus:not(.btn-active) i, .btn.btn-light-facebook:hover:not(.btn-active) i, .btn.btn-light-facebook:active:not(.btn-active) i, .btn.btn-light-facebook.active i, .btn.btn-light-facebook.show i, .show > .btn.btn-light-facebook i {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-light-facebook .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-facebook .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-facebook:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-facebook:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-facebook:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-facebook.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-facebook.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-facebook .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.btn-check:checked + .btn.btn-light-facebook .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-facebook .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-facebook:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-facebook:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-facebook:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-facebook.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-facebook.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-facebook .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-light-facebook.dropdown-toggle:after, .btn-check:active + .btn.btn-light-facebook.dropdown-toggle:after, .btn.btn-light-facebook:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook.active.dropdown-toggle:after, .btn.btn-light-facebook.show.dropdown-toggle:after, .show > .btn.btn-light-facebook.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-google {
  color: #ffffff;
  border-color: #dd4b39;
  background-color: #dd4b39;
}
.btn.btn-google i {
  color: #ffffff;
}
.btn.btn-google .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.btn.btn-google .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-google.dropdown-toggle:after {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-google, .btn-check:active + .btn.btn-google, .btn.btn-google:focus:not(.btn-active), .btn.btn-google:hover:not(.btn-active), .btn.btn-google:active:not(.btn-active), .btn.btn-google.active, .btn.btn-google.show, .show > .btn.btn-google {
  border-color: #cd3623;
  background-color: #cd3623 !important;
}

.btn.btn-light-google {
  color: #dd4b39;
  border-color: rgba(221, 75, 57, 0.1);
  background-color: rgba(221, 75, 57, 0.1);
}
.btn.btn-light-google i {
  color: #dd4b39;
}
.btn.btn-light-google .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #dd4b39;
}
.btn.btn-light-google .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-light-google.dropdown-toggle:after {
  color: #dd4b39;
}
.btn-check:checked + .btn.btn-light-google, .btn-check:active + .btn.btn-light-google, .btn.btn-light-google:focus:not(.btn-active), .btn.btn-light-google:hover:not(.btn-active), .btn.btn-light-google:active:not(.btn-active), .btn.btn-light-google.active, .btn.btn-light-google.show, .show > .btn.btn-light-google {
  color: #ffffff;
  border-color: #dd4b39;
  background-color: #dd4b39 !important;
}
.btn-check:checked + .btn.btn-light-google i, .btn-check:active + .btn.btn-light-google i, .btn.btn-light-google:focus:not(.btn-active) i, .btn.btn-light-google:hover:not(.btn-active) i, .btn.btn-light-google:active:not(.btn-active) i, .btn.btn-light-google.active i, .btn.btn-light-google.show i, .show > .btn.btn-light-google i {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-light-google .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-google .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-google:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-google:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-google:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-google.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-google.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-google .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.btn-check:checked + .btn.btn-light-google .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-google .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-google:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-google:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-google:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-google.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-google.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-google .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-light-google.dropdown-toggle:after, .btn-check:active + .btn.btn-light-google.dropdown-toggle:after, .btn.btn-light-google:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google.active.dropdown-toggle:after, .btn.btn-light-google.show.dropdown-toggle:after, .show > .btn.btn-light-google.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-twitter {
  color: #ffffff;
  border-color: #1da1f2;
  background-color: #1da1f2;
}
.btn.btn-twitter i {
  color: #ffffff;
}
.btn.btn-twitter .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.btn.btn-twitter .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-twitter.dropdown-toggle:after {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-twitter, .btn-check:active + .btn.btn-twitter, .btn.btn-twitter:focus:not(.btn-active), .btn.btn-twitter:hover:not(.btn-active), .btn.btn-twitter:active:not(.btn-active), .btn.btn-twitter.active, .btn.btn-twitter.show, .show > .btn.btn-twitter {
  border-color: #0d8ddc;
  background-color: #0d8ddc !important;
}

.btn.btn-light-twitter {
  color: #1da1f2;
  border-color: rgba(29, 161, 242, 0.1);
  background-color: rgba(29, 161, 242, 0.1);
}
.btn.btn-light-twitter i {
  color: #1da1f2;
}
.btn.btn-light-twitter .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #1da1f2;
}
.btn.btn-light-twitter .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-light-twitter.dropdown-toggle:after {
  color: #1da1f2;
}
.btn-check:checked + .btn.btn-light-twitter, .btn-check:active + .btn.btn-light-twitter, .btn.btn-light-twitter:focus:not(.btn-active), .btn.btn-light-twitter:hover:not(.btn-active), .btn.btn-light-twitter:active:not(.btn-active), .btn.btn-light-twitter.active, .btn.btn-light-twitter.show, .show > .btn.btn-light-twitter {
  color: #ffffff;
  border-color: #1da1f2;
  background-color: #1da1f2 !important;
}
.btn-check:checked + .btn.btn-light-twitter i, .btn-check:active + .btn.btn-light-twitter i, .btn.btn-light-twitter:focus:not(.btn-active) i, .btn.btn-light-twitter:hover:not(.btn-active) i, .btn.btn-light-twitter:active:not(.btn-active) i, .btn.btn-light-twitter.active i, .btn.btn-light-twitter.show i, .show > .btn.btn-light-twitter i {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-light-twitter .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-twitter .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-twitter:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-twitter:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-twitter:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-twitter.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-twitter.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-twitter .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.btn-check:checked + .btn.btn-light-twitter .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-twitter .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-twitter:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-twitter:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-twitter:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-twitter.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-twitter.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-twitter .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-light-twitter.dropdown-toggle:after, .btn-check:active + .btn.btn-light-twitter.dropdown-toggle:after, .btn.btn-light-twitter:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter.active.dropdown-toggle:after, .btn.btn-light-twitter.show.dropdown-toggle:after, .show > .btn.btn-light-twitter.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-instagram {
  color: #ffffff;
  border-color: #e1306c;
  background-color: #e1306c;
}
.btn.btn-instagram i {
  color: #ffffff;
}
.btn.btn-instagram .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.btn.btn-instagram .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-instagram.dropdown-toggle:after {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-instagram, .btn-check:active + .btn.btn-instagram, .btn.btn-instagram:focus:not(.btn-active), .btn.btn-instagram:hover:not(.btn-active), .btn.btn-instagram:active:not(.btn-active), .btn.btn-instagram.active, .btn.btn-instagram.show, .show > .btn.btn-instagram {
  border-color: #cd1e59;
  background-color: #cd1e59 !important;
}

.btn.btn-light-instagram {
  color: #e1306c;
  border-color: rgba(225, 48, 108, 0.1);
  background-color: rgba(225, 48, 108, 0.1);
}
.btn.btn-light-instagram i {
  color: #e1306c;
}
.btn.btn-light-instagram .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #e1306c;
}
.btn.btn-light-instagram .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-light-instagram.dropdown-toggle:after {
  color: #e1306c;
}
.btn-check:checked + .btn.btn-light-instagram, .btn-check:active + .btn.btn-light-instagram, .btn.btn-light-instagram:focus:not(.btn-active), .btn.btn-light-instagram:hover:not(.btn-active), .btn.btn-light-instagram:active:not(.btn-active), .btn.btn-light-instagram.active, .btn.btn-light-instagram.show, .show > .btn.btn-light-instagram {
  color: #ffffff;
  border-color: #e1306c;
  background-color: #e1306c !important;
}
.btn-check:checked + .btn.btn-light-instagram i, .btn-check:active + .btn.btn-light-instagram i, .btn.btn-light-instagram:focus:not(.btn-active) i, .btn.btn-light-instagram:hover:not(.btn-active) i, .btn.btn-light-instagram:active:not(.btn-active) i, .btn.btn-light-instagram.active i, .btn.btn-light-instagram.show i, .show > .btn.btn-light-instagram i {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-light-instagram .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-instagram .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-instagram:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-instagram:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-instagram:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-instagram.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-instagram.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-instagram .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.btn-check:checked + .btn.btn-light-instagram .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-instagram .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-instagram:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-instagram:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-instagram:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-instagram.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-instagram.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-instagram .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-light-instagram.dropdown-toggle:after, .btn-check:active + .btn.btn-light-instagram.dropdown-toggle:after, .btn.btn-light-instagram:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram.active.dropdown-toggle:after, .btn.btn-light-instagram.show.dropdown-toggle:after, .show > .btn.btn-light-instagram.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-youtube {
  color: #ffffff;
  border-color: #ff0000;
  background-color: #ff0000;
}
.btn.btn-youtube i {
  color: #ffffff;
}
.btn.btn-youtube .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.btn.btn-youtube .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-youtube.dropdown-toggle:after {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-youtube, .btn-check:active + .btn.btn-youtube, .btn.btn-youtube:focus:not(.btn-active), .btn.btn-youtube:hover:not(.btn-active), .btn.btn-youtube:active:not(.btn-active), .btn.btn-youtube.active, .btn.btn-youtube.show, .show > .btn.btn-youtube {
  border-color: #d90000;
  background-color: #d90000 !important;
}

.btn.btn-light-youtube {
  color: #ff0000;
  border-color: rgba(255, 0, 0, 0.1);
  background-color: rgba(255, 0, 0, 0.1);
}
.btn.btn-light-youtube i {
  color: #ff0000;
}
.btn.btn-light-youtube .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ff0000;
}
.btn.btn-light-youtube .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-light-youtube.dropdown-toggle:after {
  color: #ff0000;
}
.btn-check:checked + .btn.btn-light-youtube, .btn-check:active + .btn.btn-light-youtube, .btn.btn-light-youtube:focus:not(.btn-active), .btn.btn-light-youtube:hover:not(.btn-active), .btn.btn-light-youtube:active:not(.btn-active), .btn.btn-light-youtube.active, .btn.btn-light-youtube.show, .show > .btn.btn-light-youtube {
  color: #ffffff;
  border-color: #ff0000;
  background-color: #ff0000 !important;
}
.btn-check:checked + .btn.btn-light-youtube i, .btn-check:active + .btn.btn-light-youtube i, .btn.btn-light-youtube:focus:not(.btn-active) i, .btn.btn-light-youtube:hover:not(.btn-active) i, .btn.btn-light-youtube:active:not(.btn-active) i, .btn.btn-light-youtube.active i, .btn.btn-light-youtube.show i, .show > .btn.btn-light-youtube i {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-light-youtube .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-youtube .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-youtube:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-youtube:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-youtube:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-youtube.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-youtube.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-youtube .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.btn-check:checked + .btn.btn-light-youtube .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-youtube .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-youtube:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-youtube:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-youtube:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-youtube.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-youtube.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-youtube .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-light-youtube.dropdown-toggle:after, .btn-check:active + .btn.btn-light-youtube.dropdown-toggle:after, .btn.btn-light-youtube:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube.active.dropdown-toggle:after, .btn.btn-light-youtube.show.dropdown-toggle:after, .show > .btn.btn-light-youtube.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-linkedin {
  color: #ffffff;
  border-color: #0077b5;
  background-color: #0077b5;
}
.btn.btn-linkedin i {
  color: #ffffff;
}
.btn.btn-linkedin .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.btn.btn-linkedin .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-linkedin.dropdown-toggle:after {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-linkedin, .btn-check:active + .btn.btn-linkedin, .btn.btn-linkedin:focus:not(.btn-active), .btn.btn-linkedin:hover:not(.btn-active), .btn.btn-linkedin:active:not(.btn-active), .btn.btn-linkedin.active, .btn.btn-linkedin.show, .show > .btn.btn-linkedin {
  border-color: #005e8f;
  background-color: #005e8f !important;
}

.btn.btn-light-linkedin {
  color: #0077b5;
  border-color: rgba(0, 119, 181, 0.1);
  background-color: rgba(0, 119, 181, 0.1);
}
.btn.btn-light-linkedin i {
  color: #0077b5;
}
.btn.btn-light-linkedin .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #0077b5;
}
.btn.btn-light-linkedin .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-light-linkedin.dropdown-toggle:after {
  color: #0077b5;
}
.btn-check:checked + .btn.btn-light-linkedin, .btn-check:active + .btn.btn-light-linkedin, .btn.btn-light-linkedin:focus:not(.btn-active), .btn.btn-light-linkedin:hover:not(.btn-active), .btn.btn-light-linkedin:active:not(.btn-active), .btn.btn-light-linkedin.active, .btn.btn-light-linkedin.show, .show > .btn.btn-light-linkedin {
  color: #ffffff;
  border-color: #0077b5;
  background-color: #0077b5 !important;
}
.btn-check:checked + .btn.btn-light-linkedin i, .btn-check:active + .btn.btn-light-linkedin i, .btn.btn-light-linkedin:focus:not(.btn-active) i, .btn.btn-light-linkedin:hover:not(.btn-active) i, .btn.btn-light-linkedin:active:not(.btn-active) i, .btn.btn-light-linkedin.active i, .btn.btn-light-linkedin.show i, .show > .btn.btn-light-linkedin i {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-light-linkedin .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-linkedin .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-linkedin:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-linkedin:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-linkedin:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-linkedin.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-linkedin.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-linkedin .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.btn-check:checked + .btn.btn-light-linkedin .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-linkedin .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-linkedin:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-linkedin:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-linkedin:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-linkedin.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-linkedin.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-linkedin .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-light-linkedin.dropdown-toggle:after, .btn-check:active + .btn.btn-light-linkedin.dropdown-toggle:after, .btn.btn-light-linkedin:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin.active.dropdown-toggle:after, .btn.btn-light-linkedin.show.dropdown-toggle:after, .show > .btn.btn-light-linkedin.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-outline.btn-outline-dashed {
  border-width: 1px;
  border-style: dashed;
}
.btn-check:checked + .btn.btn-outline.btn-outline-dashed, .btn-check:active + .btn.btn-outline.btn-outline-dashed, .btn.btn-outline.btn-outline-dashed:focus:not(.btn-active), .btn.btn-outline.btn-outline-dashed:hover:not(.btn-active), .btn.btn-outline.btn-outline-dashed:active:not(.btn-active), .btn.btn-outline.btn-outline-dashed.active, .btn.btn-outline.btn-outline-dashed.show, .show > .btn.btn-outline.btn-outline-dashed {
  border-color: #009EF7;
}

.btn.btn-outline.btn-outline-dashed.btn-outline-default {
  border-width: 1px;
  border-style: dashed;
  color: #7E8299;
  border-color: #E4E6EF;
}
.btn.btn-outline.btn-outline-dashed.btn-outline-default i {
  color: #7E8299;
}
.btn.btn-outline.btn-outline-dashed.btn-outline-default .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7E8299;
}
.btn.btn-outline.btn-outline-dashed.btn-outline-default .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn.btn-outline.btn-outline-dashed.btn-outline-default.dropdown-toggle:after {
  color: #7E8299;
}
.btn-check:checked + .btn.btn-outline.btn-outline-dashed.btn-outline-default, .btn-check:active + .btn.btn-outline.btn-outline-dashed.btn-outline-default, .btn.btn-outline.btn-outline-dashed.btn-outline-default:focus:not(.btn-active), .btn.btn-outline.btn-outline-dashed.btn-outline-default:hover:not(.btn-active), .btn.btn-outline.btn-outline-dashed.btn-outline-default:active:not(.btn-active), .btn.btn-outline.btn-outline-dashed.btn-outline-default.active, .btn.btn-outline.btn-outline-dashed.btn-outline-default.show, .show > .btn.btn-outline.btn-outline-dashed.btn-outline-default {
  color: #009EF7;
  border-color: #009EF7;
  background-color: #F1FAFF !important;
}
.btn-check:checked + .btn.btn-outline.btn-outline-dashed.btn-outline-default i, .btn-check:active + .btn.btn-outline.btn-outline-dashed.btn-outline-default i, .btn.btn-outline.btn-outline-dashed.btn-outline-default:focus:not(.btn-active) i, .btn.btn-outline.btn-outline-dashed.btn-outline-default:hover:not(.btn-active) i, .btn.btn-outline.btn-outline-dashed.btn-outline-default:active:not(.btn-active) i, .btn.btn-outline.btn-outline-dashed.btn-outline-default.active i, .btn.btn-outline.btn-outline-dashed.btn-outline-default.show i, .show > .btn.btn-outline.btn-outline-dashed.btn-outline-default i {
  color: #009EF7;
}
.btn-check:checked + .btn.btn-outline.btn-outline-dashed.btn-outline-default .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-outline.btn-outline-dashed.btn-outline-default .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-outline.btn-outline-dashed.btn-outline-default:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-outline.btn-outline-dashed.btn-outline-default:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-outline.btn-outline-dashed.btn-outline-default:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-outline.btn-outline-dashed.btn-outline-default.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-outline.btn-outline-dashed.btn-outline-default.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-outline.btn-outline-dashed.btn-outline-default .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.btn-check:checked + .btn.btn-outline.btn-outline-dashed.btn-outline-default .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-outline.btn-outline-dashed.btn-outline-default .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-outline.btn-outline-dashed.btn-outline-default:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-outline.btn-outline-dashed.btn-outline-default:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-outline.btn-outline-dashed.btn-outline-default:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-outline.btn-outline-dashed.btn-outline-default.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-outline.btn-outline-dashed.btn-outline-default.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-outline.btn-outline-dashed.btn-outline-default .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.btn-check:checked + .btn.btn-outline.btn-outline-dashed.btn-outline-default.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-dashed.btn-outline-default.dropdown-toggle:after, .btn.btn-outline.btn-outline-dashed.btn-outline-default:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dashed.btn-outline-default:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dashed.btn-outline-default:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dashed.btn-outline-default.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-dashed.btn-outline-default.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-dashed.btn-outline-default.dropdown-toggle:after {
  color: #009EF7;
}

code:not([class*=language-]) {
  font-weight: 400;
  color: #b93993;
  line-height: inherit;
  font-size: inherit;
  background-color: #F1F3F8;
  padding: 0.1rem 0.4rem;
  margin: 0 0.5rem;
  box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.08);
  border-radius: 0.3rem;
}

.form-control {
  box-shadow: none !important;
}
.dropdown.show > .form-control {
  color: #181C32;
  background-color: #ffffff;
  border-color: #B5B5C3;
}
.form-control[readonly] {
  background-color: #ffffff;
}
.form-control.form-control-solid {
  background-color: #F5F8FA;
  border-color: #F5F8FA;
  color: #5E6278;
  transition: color 0.2s ease, background-color 0.2s ease;
}
.form-control.form-control-solid::placeholder {
  color: #A1A5B7;
}
.form-control.form-control-solid::-moz-placeholder {
  color: #A1A5B7;
  opacity: 1;
}
.dropdown.show > .form-control.form-control-solid, .form-control.form-control-solid:active, .form-control.form-control-solid.active, .form-control.form-control-solid:focus, .form-control.form-control-solid.focus {
  background-color: #eef3f7;
  border-color: #eef3f7;
  color: #5E6278;
  transition: color 0.2s ease, background-color 0.2s ease;
}
.form-control.form-control-transparent {
  background-color: transparent;
  border-color: transparent;
}
.dropdown.show > .form-control.form-control-transparent, .form-control.form-control-transparent:active, .form-control.form-control-transparent.active, .form-control.form-control-transparent:focus, .form-control.form-control-transparent.focus {
  background-color: transparent;
  border-color: transparent;
}
.form-control.form-control-flush {
  border: 0;
  background-color: transparent;
  outline: none !important;
  box-shadow: none;
  border-radius: 0;
}

.placeholder-gray-500::placeholder {
  color: #A1A5B7;
}

.placeholder-white::placeholder {
  color: #ffffff;
}
.placeholder-white::-moz-placeholder {
  color: #ffffff;
  opacity: 1;
}

.resize-none {
  resize: none;
}

.form-select {
  box-shadow: none !important;
}
.form-select.form-select-solid {
  background-color: #F5F8FA;
  border-color: #F5F8FA;
  color: #5E6278;
  transition: color 0.2s ease, background-color 0.2s ease;
}
.form-select.form-select-solid::placeholder {
  color: #A1A5B7;
}
.form-select.form-select-solid::-moz-placeholder {
  color: #A1A5B7;
  opacity: 1;
}
.dropdown.show > .form-select.form-select-solid, .form-select.form-select-solid:active, .form-select.form-select-solid.active, .form-select.form-select-solid:focus, .form-select.form-select-solid.focus {
  background-color: #eef3f7;
  border-color: #eef3f7 !important;
  color: #5E6278;
  transition: color 0.2s ease, background-color 0.2s ease;
}
.form-select.form-select-transparent {
  background-color: transparent;
  border-color: transparent;
  color: #181C32;
}
.form-select.form-select-transparent::placeholder {
  color: #A1A5B7;
}
.form-select.form-select-transparent::-moz-placeholder {
  color: #A1A5B7;
  opacity: 1;
}
.dropdown.show > .form-select.form-select-transparent, .form-select.form-select-transparent:active, .form-select.form-select-transparent.active, .form-select.form-select-transparent:focus, .form-select.form-select-transparent.focus {
  background-color: transparent;
  border-color: transparent !important;
  color: #181C32;
}

.form-check .form-check-label {
  cursor: pointer;
}
.form-check .form-check-input {
  cursor: pointer;
  appearance: none;
}
.form-check.form-check-custom {
  display: flex;
  align-items: center;
  padding-left: 0;
  margin: 0;
}
.form-check.form-check-custom .form-check-input {
  margin: 0;
  float: none;
  flex-shrink: 0;
}
.form-check.form-check-custom .form-check-label {
  margin-left: 0.55rem;
}
.form-check:not(.form-switch) .form-check-input[type=checkbox] {
  background-size: 60% 60%;
}
.form-check.form-check-solid .form-check-input {
  border: 0;
  background-color: #EFF2F5;
}
.form-check.form-check-solid .form-check-input:active, .form-check.form-check-solid .form-check-input:focus {
  filter: none;
  background-color: #EFF2F5;
}
.form-check.form-check-solid .form-check-input:checked {
  background-color: #009EF7;
}
.form-check.form-check-success .form-check-input:checked {
  background-color: #50CD89;
}
.form-check.form-check-danger .form-check-input:checked {
  background-color: #F1416C;
}
.form-check.form-check-warning .form-check-input:checked {
  background-color: #FFC700;
}

.form-check.form-check-custom.form-check-sm .form-check-input {
  height: 1.5rem;
  width: 1.5rem;
}
.form-check.form-check-custom.form-check-lg .form-check-input {
  height: 2.25rem;
  width: 2.25rem;
}

.form-switch.form-check-solid .form-check-input {
  height: 2.25rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
  border-radius: 3.25rem;
}
.form-switch.form-check-solid .form-check-input:checked {
  filter: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-switch.form-check-solid.form-switch-sm .form-check-input {
  height: 1.5rem;
  width: 2.5rem;
}
.form-switch.form-check-solid.form-switch-lg .form-check-input {
  height: 2.75rem;
  width: 3.75rem;
}

.input-group.input-group-solid {
  background-color: #F5F8FA;
  border-color: #F5F8FA;
  border-radius: 0.475rem;
}
.input-group.input-group-solid.input-group-sm {
  border-radius: 0.475rem;
}
.input-group.input-group-solid.input-group-lg {
  border-radius: 0.475rem;
}
.input-group.input-group-solid .input-group-text {
  background-color: #F5F8FA;
  border-color: #F5F8FA;
}
.input-group.input-group-solid .input-group-text + .form-control {
  border-left-color: #E4E6EF;
}
.input-group.input-group-solid .form-control {
  background-color: transparent;
  border-color: transparent;
}
.input-group.input-group-solid .form-control + .input-group-text {
  border-left-color: #E4E6EF;
}

.required:after {
  content: "*";
  position: relative;
  font-size: inherit;
  color: #F1416C;
  padding-left: 0.25rem;
  font-weight: bold;
}

.modal .modal-header {
  align-items: center;
  justify-content: space-between;
  border-top-left-radius: 0.475rem;
  border-top-right-radius: 0.475rem;
}
.modal .modal-header h1, .modal .modal-header .h1, .modal .modal-header h2, .modal .modal-header .h2, .modal .modal-header h3, .modal .modal-header .h3, .modal .modal-header h4, .modal .modal-header .h4, .modal .modal-header h5, .modal .modal-header .h5, .modal .modal-header h6, .modal .modal-header .h6 {
  margin-bottom: 0;
}
.modal .modal-dialog {
  outline: none !important;
}

.modal-rounded {
  border-radius: 0.475rem !important;
}

.progress-vertical {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
}
.progress-vertical .progress {
  height: 100%;
  border-radius: 0.475rem;
  display: flex;
  align-items: flex-end;
  margin-right: 1rem;
}
.progress-vertical .progress:last-child {
  margin-right: 0;
}
.progress-vertical .progress .progress-bar {
  width: 8px;
  border-radius: 0.475rem;
}

.table > :not(:first-child) {
  border-color: transparent;
  border-width: 0;
  border-style: none;
}
.table > :not(:last-child) > :last-child > * {
  border-bottom-color: inherit;
}
.table tr, .table th, .table td {
  border-color: inherit;
  border-width: inherit;
  border-style: inherit;
  text-transform: inherit;
  font-weight: inherit;
  font-size: inherit;
  color: inherit;
  height: inherit;
  min-height: inherit;
}
.table tr:first-child, .table th:first-child, .table td:first-child {
  padding-left: 0;
}
.table tr:last-child, .table th:last-child, .table td:last-child {
  padding-right: 0;
}
.table tfoot tr:last-child,
.table tbody tr:last-child {
  border-bottom: 0 !important;
}
.table tfoot tr:last-child th, .table tfoot tr:last-child td,
.table tbody tr:last-child th,
.table tbody tr:last-child td {
  border-bottom: 0 !important;
}
.table tfoot th, .table tfoot td {
  border-top: inherit;
}
.table.table-rounded {
  border-radius: 0.475rem;
  border-spacing: 0;
  border-collapse: separate;
}
.table.table-flush tr, .table.table-flush th, .table.table-flush td {
  padding: inherit;
}
.table.table-row-bordered tr {
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #EFF2F5;
}
.table.table-row-bordered tfoot th, .table.table-row-bordered tfoot td {
  border-top-width: 1px !important;
}
.table.table-row-dashed tr {
  border-bottom-width: 1px;
  border-bottom-style: dashed;
  border-bottom-color: #EFF2F5;
}
.table.table-row-dashed tfoot th, .table.table-row-dashed tfoot td {
  border-top-width: 1px !important;
}
.table.table-row-gray-100 tr {
  border-bottom-color: #F5F8FA;
}
.table.table-row-gray-200 tr {
  border-bottom-color: #EFF2F5;
}
.table.table-row-gray-300 tr {
  border-bottom-color: #E4E6EF;
}
.table.table-row-gray-400 tr {
  border-bottom-color: #B5B5C3;
}
.table.table-row-gray-500 tr {
  border-bottom-color: #A1A5B7;
}
.table.table-row-gray-600 tr {
  border-bottom-color: #7E8299;
}
.table.table-row-gray-700 tr {
  border-bottom-color: #5E6278;
}
.table.table-row-gray-800 tr {
  border-bottom-color: #3F4254;
}
.table.table-row-gray-900 tr {
  border-bottom-color: #181C32;
}

.table.g-0 th, .table.g-0 td {
  padding: 0rem;
}
.table.g-0 th.dtr-control, .table.g-0 td.dtr-control {
  padding-left: 0rem !important;
}

.table.gy-0 th, .table.gy-0 td {
  padding-top: 0rem;
  padding-bottom: 0rem;
}

.table.gx-0 th, .table.gx-0 td {
  padding-left: 0rem;
  padding-right: 0rem;
}
.table.gx-0 th.dtr-control, .table.gx-0 td.dtr-control {
  padding-left: 0rem !important;
}

.table.gs-0 th:first-child, .table.gs-0 td:first-child {
  padding-left: 0rem;
}
.table.gs-0 th:last-child, .table.gs-0 td:last-child {
  padding-right: 0rem;
}
.table.gs-0 th.dtr-control:first-child, .table.gs-0 td.dtr-control:first-child {
  padding-left: 0rem !important;
}

.table.g-1 th, .table.g-1 td {
  padding: 0.25rem;
}
.table.g-1 th.dtr-control, .table.g-1 td.dtr-control {
  padding-left: 0.25rem !important;
}

.table.gy-1 th, .table.gy-1 td {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.table.gx-1 th, .table.gx-1 td {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.table.gx-1 th.dtr-control, .table.gx-1 td.dtr-control {
  padding-left: 0.25rem !important;
}

.table.gs-1 th:first-child, .table.gs-1 td:first-child {
  padding-left: 0.25rem;
}
.table.gs-1 th:last-child, .table.gs-1 td:last-child {
  padding-right: 0.25rem;
}
.table.gs-1 th.dtr-control:first-child, .table.gs-1 td.dtr-control:first-child {
  padding-left: 0.25rem !important;
}

.table.g-2 th, .table.g-2 td {
  padding: 0.5rem;
}
.table.g-2 th.dtr-control, .table.g-2 td.dtr-control {
  padding-left: 0.5rem !important;
}

.table.gy-2 th, .table.gy-2 td {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.table.gx-2 th, .table.gx-2 td {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.table.gx-2 th.dtr-control, .table.gx-2 td.dtr-control {
  padding-left: 0.5rem !important;
}

.table.gs-2 th:first-child, .table.gs-2 td:first-child {
  padding-left: 0.5rem;
}
.table.gs-2 th:last-child, .table.gs-2 td:last-child {
  padding-right: 0.5rem;
}
.table.gs-2 th.dtr-control:first-child, .table.gs-2 td.dtr-control:first-child {
  padding-left: 0.5rem !important;
}

.table.g-3 th, .table.g-3 td {
  padding: 0.75rem;
}
.table.g-3 th.dtr-control, .table.g-3 td.dtr-control {
  padding-left: 0.75rem !important;
}

.table.gy-3 th, .table.gy-3 td {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.table.gx-3 th, .table.gx-3 td {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.table.gx-3 th.dtr-control, .table.gx-3 td.dtr-control {
  padding-left: 0.75rem !important;
}

.table.gs-3 th:first-child, .table.gs-3 td:first-child {
  padding-left: 0.75rem;
}
.table.gs-3 th:last-child, .table.gs-3 td:last-child {
  padding-right: 0.75rem;
}
.table.gs-3 th.dtr-control:first-child, .table.gs-3 td.dtr-control:first-child {
  padding-left: 0.75rem !important;
}

.table.g-4 th, .table.g-4 td {
  padding: 1rem;
}
.table.g-4 th.dtr-control, .table.g-4 td.dtr-control {
  padding-left: 1rem !important;
}

.table.gy-4 th, .table.gy-4 td {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.table.gx-4 th, .table.gx-4 td {
  padding-left: 1rem;
  padding-right: 1rem;
}
.table.gx-4 th.dtr-control, .table.gx-4 td.dtr-control {
  padding-left: 1rem !important;
}

.table.gs-4 th:first-child, .table.gs-4 td:first-child {
  padding-left: 1rem;
}
.table.gs-4 th:last-child, .table.gs-4 td:last-child {
  padding-right: 1rem;
}
.table.gs-4 th.dtr-control:first-child, .table.gs-4 td.dtr-control:first-child {
  padding-left: 1rem !important;
}

.table.g-5 th, .table.g-5 td {
  padding: 1.25rem;
}
.table.g-5 th.dtr-control, .table.g-5 td.dtr-control {
  padding-left: 1.25rem !important;
}

.table.gy-5 th, .table.gy-5 td {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

.table.gx-5 th, .table.gx-5 td {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.table.gx-5 th.dtr-control, .table.gx-5 td.dtr-control {
  padding-left: 1.25rem !important;
}

.table.gs-5 th:first-child, .table.gs-5 td:first-child {
  padding-left: 1.25rem;
}
.table.gs-5 th:last-child, .table.gs-5 td:last-child {
  padding-right: 1.25rem;
}
.table.gs-5 th.dtr-control:first-child, .table.gs-5 td.dtr-control:first-child {
  padding-left: 1.25rem !important;
}

.table.g-6 th, .table.g-6 td {
  padding: 1.5rem;
}
.table.g-6 th.dtr-control, .table.g-6 td.dtr-control {
  padding-left: 1.5rem !important;
}

.table.gy-6 th, .table.gy-6 td {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.table.gx-6 th, .table.gx-6 td {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.table.gx-6 th.dtr-control, .table.gx-6 td.dtr-control {
  padding-left: 1.5rem !important;
}

.table.gs-6 th:first-child, .table.gs-6 td:first-child {
  padding-left: 1.5rem;
}
.table.gs-6 th:last-child, .table.gs-6 td:last-child {
  padding-right: 1.5rem;
}
.table.gs-6 th.dtr-control:first-child, .table.gs-6 td.dtr-control:first-child {
  padding-left: 1.5rem !important;
}

.table.g-7 th, .table.g-7 td {
  padding: 1.75rem;
}
.table.g-7 th.dtr-control, .table.g-7 td.dtr-control {
  padding-left: 1.75rem !important;
}

.table.gy-7 th, .table.gy-7 td {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}

.table.gx-7 th, .table.gx-7 td {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.table.gx-7 th.dtr-control, .table.gx-7 td.dtr-control {
  padding-left: 1.75rem !important;
}

.table.gs-7 th:first-child, .table.gs-7 td:first-child {
  padding-left: 1.75rem;
}
.table.gs-7 th:last-child, .table.gs-7 td:last-child {
  padding-right: 1.75rem;
}
.table.gs-7 th.dtr-control:first-child, .table.gs-7 td.dtr-control:first-child {
  padding-left: 1.75rem !important;
}

.table.g-8 th, .table.g-8 td {
  padding: 2rem;
}
.table.g-8 th.dtr-control, .table.g-8 td.dtr-control {
  padding-left: 2rem !important;
}

.table.gy-8 th, .table.gy-8 td {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.table.gx-8 th, .table.gx-8 td {
  padding-left: 2rem;
  padding-right: 2rem;
}
.table.gx-8 th.dtr-control, .table.gx-8 td.dtr-control {
  padding-left: 2rem !important;
}

.table.gs-8 th:first-child, .table.gs-8 td:first-child {
  padding-left: 2rem;
}
.table.gs-8 th:last-child, .table.gs-8 td:last-child {
  padding-right: 2rem;
}
.table.gs-8 th.dtr-control:first-child, .table.gs-8 td.dtr-control:first-child {
  padding-left: 2rem !important;
}

.table.g-9 th, .table.g-9 td {
  padding: 2.25rem;
}
.table.g-9 th.dtr-control, .table.g-9 td.dtr-control {
  padding-left: 2.25rem !important;
}

.table.gy-9 th, .table.gy-9 td {
  padding-top: 2.25rem;
  padding-bottom: 2.25rem;
}

.table.gx-9 th, .table.gx-9 td {
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}
.table.gx-9 th.dtr-control, .table.gx-9 td.dtr-control {
  padding-left: 2.25rem !important;
}

.table.gs-9 th:first-child, .table.gs-9 td:first-child {
  padding-left: 2.25rem;
}
.table.gs-9 th:last-child, .table.gs-9 td:last-child {
  padding-right: 2.25rem;
}
.table.gs-9 th.dtr-control:first-child, .table.gs-9 td.dtr-control:first-child {
  padding-left: 2.25rem !important;
}

.table.g-10 th, .table.g-10 td {
  padding: 2.5rem;
}
.table.g-10 th.dtr-control, .table.g-10 td.dtr-control {
  padding-left: 2.5rem !important;
}

.table.gy-10 th, .table.gy-10 td {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

.table.gx-10 th, .table.gx-10 td {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.table.gx-10 th.dtr-control, .table.gx-10 td.dtr-control {
  padding-left: 2.5rem !important;
}

.table.gs-10 th:first-child, .table.gs-10 td:first-child {
  padding-left: 2.5rem;
}
.table.gs-10 th:last-child, .table.gs-10 td:last-child {
  padding-right: 2.5rem;
}
.table.gs-10 th.dtr-control:first-child, .table.gs-10 td.dtr-control:first-child {
  padding-left: 2.5rem !important;
}

@media (min-width: 576px) {
  .table.g-sm-0 th, .table.g-sm-0 td {
    padding: 0rem;
  }
  .table.g-sm-0 th.dtr-control, .table.g-sm-0 td.dtr-control {
    padding-left: 0rem !important;
  }

  .table.gy-sm-0 th, .table.gy-sm-0 td {
    padding-top: 0rem;
    padding-bottom: 0rem;
  }

  .table.gx-sm-0 th, .table.gx-sm-0 td {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  .table.gx-sm-0 th.dtr-control, .table.gx-sm-0 td.dtr-control {
    padding-left: 0rem !important;
  }

  .table.gs-sm-0 th:first-child, .table.gs-sm-0 td:first-child {
    padding-left: 0rem;
  }
  .table.gs-sm-0 th:last-child, .table.gs-sm-0 td:last-child {
    padding-right: 0rem;
  }
  .table.gs-sm-0 th.dtr-control:first-child, .table.gs-sm-0 td.dtr-control:first-child {
    padding-left: 0rem !important;
  }

  .table.g-sm-1 th, .table.g-sm-1 td {
    padding: 0.25rem;
  }
  .table.g-sm-1 th.dtr-control, .table.g-sm-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }

  .table.gy-sm-1 th, .table.gy-sm-1 td {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .table.gx-sm-1 th, .table.gx-sm-1 td {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .table.gx-sm-1 th.dtr-control, .table.gx-sm-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }

  .table.gs-sm-1 th:first-child, .table.gs-sm-1 td:first-child {
    padding-left: 0.25rem;
  }
  .table.gs-sm-1 th:last-child, .table.gs-sm-1 td:last-child {
    padding-right: 0.25rem;
  }
  .table.gs-sm-1 th.dtr-control:first-child, .table.gs-sm-1 td.dtr-control:first-child {
    padding-left: 0.25rem !important;
  }

  .table.g-sm-2 th, .table.g-sm-2 td {
    padding: 0.5rem;
  }
  .table.g-sm-2 th.dtr-control, .table.g-sm-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }

  .table.gy-sm-2 th, .table.gy-sm-2 td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .table.gx-sm-2 th, .table.gx-sm-2 td {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .table.gx-sm-2 th.dtr-control, .table.gx-sm-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }

  .table.gs-sm-2 th:first-child, .table.gs-sm-2 td:first-child {
    padding-left: 0.5rem;
  }
  .table.gs-sm-2 th:last-child, .table.gs-sm-2 td:last-child {
    padding-right: 0.5rem;
  }
  .table.gs-sm-2 th.dtr-control:first-child, .table.gs-sm-2 td.dtr-control:first-child {
    padding-left: 0.5rem !important;
  }

  .table.g-sm-3 th, .table.g-sm-3 td {
    padding: 0.75rem;
  }
  .table.g-sm-3 th.dtr-control, .table.g-sm-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }

  .table.gy-sm-3 th, .table.gy-sm-3 td {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .table.gx-sm-3 th, .table.gx-sm-3 td {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .table.gx-sm-3 th.dtr-control, .table.gx-sm-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }

  .table.gs-sm-3 th:first-child, .table.gs-sm-3 td:first-child {
    padding-left: 0.75rem;
  }
  .table.gs-sm-3 th:last-child, .table.gs-sm-3 td:last-child {
    padding-right: 0.75rem;
  }
  .table.gs-sm-3 th.dtr-control:first-child, .table.gs-sm-3 td.dtr-control:first-child {
    padding-left: 0.75rem !important;
  }

  .table.g-sm-4 th, .table.g-sm-4 td {
    padding: 1rem;
  }
  .table.g-sm-4 th.dtr-control, .table.g-sm-4 td.dtr-control {
    padding-left: 1rem !important;
  }

  .table.gy-sm-4 th, .table.gy-sm-4 td {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .table.gx-sm-4 th, .table.gx-sm-4 td {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .table.gx-sm-4 th.dtr-control, .table.gx-sm-4 td.dtr-control {
    padding-left: 1rem !important;
  }

  .table.gs-sm-4 th:first-child, .table.gs-sm-4 td:first-child {
    padding-left: 1rem;
  }
  .table.gs-sm-4 th:last-child, .table.gs-sm-4 td:last-child {
    padding-right: 1rem;
  }
  .table.gs-sm-4 th.dtr-control:first-child, .table.gs-sm-4 td.dtr-control:first-child {
    padding-left: 1rem !important;
  }

  .table.g-sm-5 th, .table.g-sm-5 td {
    padding: 1.25rem;
  }
  .table.g-sm-5 th.dtr-control, .table.g-sm-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }

  .table.gy-sm-5 th, .table.gy-sm-5 td {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .table.gx-sm-5 th, .table.gx-sm-5 td {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .table.gx-sm-5 th.dtr-control, .table.gx-sm-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }

  .table.gs-sm-5 th:first-child, .table.gs-sm-5 td:first-child {
    padding-left: 1.25rem;
  }
  .table.gs-sm-5 th:last-child, .table.gs-sm-5 td:last-child {
    padding-right: 1.25rem;
  }
  .table.gs-sm-5 th.dtr-control:first-child, .table.gs-sm-5 td.dtr-control:first-child {
    padding-left: 1.25rem !important;
  }

  .table.g-sm-6 th, .table.g-sm-6 td {
    padding: 1.5rem;
  }
  .table.g-sm-6 th.dtr-control, .table.g-sm-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }

  .table.gy-sm-6 th, .table.gy-sm-6 td {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .table.gx-sm-6 th, .table.gx-sm-6 td {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .table.gx-sm-6 th.dtr-control, .table.gx-sm-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }

  .table.gs-sm-6 th:first-child, .table.gs-sm-6 td:first-child {
    padding-left: 1.5rem;
  }
  .table.gs-sm-6 th:last-child, .table.gs-sm-6 td:last-child {
    padding-right: 1.5rem;
  }
  .table.gs-sm-6 th.dtr-control:first-child, .table.gs-sm-6 td.dtr-control:first-child {
    padding-left: 1.5rem !important;
  }

  .table.g-sm-7 th, .table.g-sm-7 td {
    padding: 1.75rem;
  }
  .table.g-sm-7 th.dtr-control, .table.g-sm-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }

  .table.gy-sm-7 th, .table.gy-sm-7 td {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .table.gx-sm-7 th, .table.gx-sm-7 td {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .table.gx-sm-7 th.dtr-control, .table.gx-sm-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }

  .table.gs-sm-7 th:first-child, .table.gs-sm-7 td:first-child {
    padding-left: 1.75rem;
  }
  .table.gs-sm-7 th:last-child, .table.gs-sm-7 td:last-child {
    padding-right: 1.75rem;
  }
  .table.gs-sm-7 th.dtr-control:first-child, .table.gs-sm-7 td.dtr-control:first-child {
    padding-left: 1.75rem !important;
  }

  .table.g-sm-8 th, .table.g-sm-8 td {
    padding: 2rem;
  }
  .table.g-sm-8 th.dtr-control, .table.g-sm-8 td.dtr-control {
    padding-left: 2rem !important;
  }

  .table.gy-sm-8 th, .table.gy-sm-8 td {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .table.gx-sm-8 th, .table.gx-sm-8 td {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .table.gx-sm-8 th.dtr-control, .table.gx-sm-8 td.dtr-control {
    padding-left: 2rem !important;
  }

  .table.gs-sm-8 th:first-child, .table.gs-sm-8 td:first-child {
    padding-left: 2rem;
  }
  .table.gs-sm-8 th:last-child, .table.gs-sm-8 td:last-child {
    padding-right: 2rem;
  }
  .table.gs-sm-8 th.dtr-control:first-child, .table.gs-sm-8 td.dtr-control:first-child {
    padding-left: 2rem !important;
  }

  .table.g-sm-9 th, .table.g-sm-9 td {
    padding: 2.25rem;
  }
  .table.g-sm-9 th.dtr-control, .table.g-sm-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }

  .table.gy-sm-9 th, .table.gy-sm-9 td {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .table.gx-sm-9 th, .table.gx-sm-9 td {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .table.gx-sm-9 th.dtr-control, .table.gx-sm-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }

  .table.gs-sm-9 th:first-child, .table.gs-sm-9 td:first-child {
    padding-left: 2.25rem;
  }
  .table.gs-sm-9 th:last-child, .table.gs-sm-9 td:last-child {
    padding-right: 2.25rem;
  }
  .table.gs-sm-9 th.dtr-control:first-child, .table.gs-sm-9 td.dtr-control:first-child {
    padding-left: 2.25rem !important;
  }

  .table.g-sm-10 th, .table.g-sm-10 td {
    padding: 2.5rem;
  }
  .table.g-sm-10 th.dtr-control, .table.g-sm-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }

  .table.gy-sm-10 th, .table.gy-sm-10 td {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .table.gx-sm-10 th, .table.gx-sm-10 td {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .table.gx-sm-10 th.dtr-control, .table.gx-sm-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }

  .table.gs-sm-10 th:first-child, .table.gs-sm-10 td:first-child {
    padding-left: 2.5rem;
  }
  .table.gs-sm-10 th:last-child, .table.gs-sm-10 td:last-child {
    padding-right: 2.5rem;
  }
  .table.gs-sm-10 th.dtr-control:first-child, .table.gs-sm-10 td.dtr-control:first-child {
    padding-left: 2.5rem !important;
  }
}
@media (min-width: 768px) {
  .table.g-md-0 th, .table.g-md-0 td {
    padding: 0rem;
  }
  .table.g-md-0 th.dtr-control, .table.g-md-0 td.dtr-control {
    padding-left: 0rem !important;
  }

  .table.gy-md-0 th, .table.gy-md-0 td {
    padding-top: 0rem;
    padding-bottom: 0rem;
  }

  .table.gx-md-0 th, .table.gx-md-0 td {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  .table.gx-md-0 th.dtr-control, .table.gx-md-0 td.dtr-control {
    padding-left: 0rem !important;
  }

  .table.gs-md-0 th:first-child, .table.gs-md-0 td:first-child {
    padding-left: 0rem;
  }
  .table.gs-md-0 th:last-child, .table.gs-md-0 td:last-child {
    padding-right: 0rem;
  }
  .table.gs-md-0 th.dtr-control:first-child, .table.gs-md-0 td.dtr-control:first-child {
    padding-left: 0rem !important;
  }

  .table.g-md-1 th, .table.g-md-1 td {
    padding: 0.25rem;
  }
  .table.g-md-1 th.dtr-control, .table.g-md-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }

  .table.gy-md-1 th, .table.gy-md-1 td {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .table.gx-md-1 th, .table.gx-md-1 td {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .table.gx-md-1 th.dtr-control, .table.gx-md-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }

  .table.gs-md-1 th:first-child, .table.gs-md-1 td:first-child {
    padding-left: 0.25rem;
  }
  .table.gs-md-1 th:last-child, .table.gs-md-1 td:last-child {
    padding-right: 0.25rem;
  }
  .table.gs-md-1 th.dtr-control:first-child, .table.gs-md-1 td.dtr-control:first-child {
    padding-left: 0.25rem !important;
  }

  .table.g-md-2 th, .table.g-md-2 td {
    padding: 0.5rem;
  }
  .table.g-md-2 th.dtr-control, .table.g-md-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }

  .table.gy-md-2 th, .table.gy-md-2 td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .table.gx-md-2 th, .table.gx-md-2 td {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .table.gx-md-2 th.dtr-control, .table.gx-md-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }

  .table.gs-md-2 th:first-child, .table.gs-md-2 td:first-child {
    padding-left: 0.5rem;
  }
  .table.gs-md-2 th:last-child, .table.gs-md-2 td:last-child {
    padding-right: 0.5rem;
  }
  .table.gs-md-2 th.dtr-control:first-child, .table.gs-md-2 td.dtr-control:first-child {
    padding-left: 0.5rem !important;
  }

  .table.g-md-3 th, .table.g-md-3 td {
    padding: 0.75rem;
  }
  .table.g-md-3 th.dtr-control, .table.g-md-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }

  .table.gy-md-3 th, .table.gy-md-3 td {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .table.gx-md-3 th, .table.gx-md-3 td {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .table.gx-md-3 th.dtr-control, .table.gx-md-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }

  .table.gs-md-3 th:first-child, .table.gs-md-3 td:first-child {
    padding-left: 0.75rem;
  }
  .table.gs-md-3 th:last-child, .table.gs-md-3 td:last-child {
    padding-right: 0.75rem;
  }
  .table.gs-md-3 th.dtr-control:first-child, .table.gs-md-3 td.dtr-control:first-child {
    padding-left: 0.75rem !important;
  }

  .table.g-md-4 th, .table.g-md-4 td {
    padding: 1rem;
  }
  .table.g-md-4 th.dtr-control, .table.g-md-4 td.dtr-control {
    padding-left: 1rem !important;
  }

  .table.gy-md-4 th, .table.gy-md-4 td {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .table.gx-md-4 th, .table.gx-md-4 td {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .table.gx-md-4 th.dtr-control, .table.gx-md-4 td.dtr-control {
    padding-left: 1rem !important;
  }

  .table.gs-md-4 th:first-child, .table.gs-md-4 td:first-child {
    padding-left: 1rem;
  }
  .table.gs-md-4 th:last-child, .table.gs-md-4 td:last-child {
    padding-right: 1rem;
  }
  .table.gs-md-4 th.dtr-control:first-child, .table.gs-md-4 td.dtr-control:first-child {
    padding-left: 1rem !important;
  }

  .table.g-md-5 th, .table.g-md-5 td {
    padding: 1.25rem;
  }
  .table.g-md-5 th.dtr-control, .table.g-md-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }

  .table.gy-md-5 th, .table.gy-md-5 td {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .table.gx-md-5 th, .table.gx-md-5 td {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .table.gx-md-5 th.dtr-control, .table.gx-md-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }

  .table.gs-md-5 th:first-child, .table.gs-md-5 td:first-child {
    padding-left: 1.25rem;
  }
  .table.gs-md-5 th:last-child, .table.gs-md-5 td:last-child {
    padding-right: 1.25rem;
  }
  .table.gs-md-5 th.dtr-control:first-child, .table.gs-md-5 td.dtr-control:first-child {
    padding-left: 1.25rem !important;
  }

  .table.g-md-6 th, .table.g-md-6 td {
    padding: 1.5rem;
  }
  .table.g-md-6 th.dtr-control, .table.g-md-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }

  .table.gy-md-6 th, .table.gy-md-6 td {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .table.gx-md-6 th, .table.gx-md-6 td {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .table.gx-md-6 th.dtr-control, .table.gx-md-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }

  .table.gs-md-6 th:first-child, .table.gs-md-6 td:first-child {
    padding-left: 1.5rem;
  }
  .table.gs-md-6 th:last-child, .table.gs-md-6 td:last-child {
    padding-right: 1.5rem;
  }
  .table.gs-md-6 th.dtr-control:first-child, .table.gs-md-6 td.dtr-control:first-child {
    padding-left: 1.5rem !important;
  }

  .table.g-md-7 th, .table.g-md-7 td {
    padding: 1.75rem;
  }
  .table.g-md-7 th.dtr-control, .table.g-md-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }

  .table.gy-md-7 th, .table.gy-md-7 td {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .table.gx-md-7 th, .table.gx-md-7 td {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .table.gx-md-7 th.dtr-control, .table.gx-md-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }

  .table.gs-md-7 th:first-child, .table.gs-md-7 td:first-child {
    padding-left: 1.75rem;
  }
  .table.gs-md-7 th:last-child, .table.gs-md-7 td:last-child {
    padding-right: 1.75rem;
  }
  .table.gs-md-7 th.dtr-control:first-child, .table.gs-md-7 td.dtr-control:first-child {
    padding-left: 1.75rem !important;
  }

  .table.g-md-8 th, .table.g-md-8 td {
    padding: 2rem;
  }
  .table.g-md-8 th.dtr-control, .table.g-md-8 td.dtr-control {
    padding-left: 2rem !important;
  }

  .table.gy-md-8 th, .table.gy-md-8 td {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .table.gx-md-8 th, .table.gx-md-8 td {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .table.gx-md-8 th.dtr-control, .table.gx-md-8 td.dtr-control {
    padding-left: 2rem !important;
  }

  .table.gs-md-8 th:first-child, .table.gs-md-8 td:first-child {
    padding-left: 2rem;
  }
  .table.gs-md-8 th:last-child, .table.gs-md-8 td:last-child {
    padding-right: 2rem;
  }
  .table.gs-md-8 th.dtr-control:first-child, .table.gs-md-8 td.dtr-control:first-child {
    padding-left: 2rem !important;
  }

  .table.g-md-9 th, .table.g-md-9 td {
    padding: 2.25rem;
  }
  .table.g-md-9 th.dtr-control, .table.g-md-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }

  .table.gy-md-9 th, .table.gy-md-9 td {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .table.gx-md-9 th, .table.gx-md-9 td {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .table.gx-md-9 th.dtr-control, .table.gx-md-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }

  .table.gs-md-9 th:first-child, .table.gs-md-9 td:first-child {
    padding-left: 2.25rem;
  }
  .table.gs-md-9 th:last-child, .table.gs-md-9 td:last-child {
    padding-right: 2.25rem;
  }
  .table.gs-md-9 th.dtr-control:first-child, .table.gs-md-9 td.dtr-control:first-child {
    padding-left: 2.25rem !important;
  }

  .table.g-md-10 th, .table.g-md-10 td {
    padding: 2.5rem;
  }
  .table.g-md-10 th.dtr-control, .table.g-md-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }

  .table.gy-md-10 th, .table.gy-md-10 td {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .table.gx-md-10 th, .table.gx-md-10 td {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .table.gx-md-10 th.dtr-control, .table.gx-md-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }

  .table.gs-md-10 th:first-child, .table.gs-md-10 td:first-child {
    padding-left: 2.5rem;
  }
  .table.gs-md-10 th:last-child, .table.gs-md-10 td:last-child {
    padding-right: 2.5rem;
  }
  .table.gs-md-10 th.dtr-control:first-child, .table.gs-md-10 td.dtr-control:first-child {
    padding-left: 2.5rem !important;
  }
}
@media (min-width: 992px) {
  .table.g-lg-0 th, .table.g-lg-0 td {
    padding: 0rem;
  }
  .table.g-lg-0 th.dtr-control, .table.g-lg-0 td.dtr-control {
    padding-left: 0rem !important;
  }

  .table.gy-lg-0 th, .table.gy-lg-0 td {
    padding-top: 0rem;
    padding-bottom: 0rem;
  }

  .table.gx-lg-0 th, .table.gx-lg-0 td {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  .table.gx-lg-0 th.dtr-control, .table.gx-lg-0 td.dtr-control {
    padding-left: 0rem !important;
  }

  .table.gs-lg-0 th:first-child, .table.gs-lg-0 td:first-child {
    padding-left: 0rem;
  }
  .table.gs-lg-0 th:last-child, .table.gs-lg-0 td:last-child {
    padding-right: 0rem;
  }
  .table.gs-lg-0 th.dtr-control:first-child, .table.gs-lg-0 td.dtr-control:first-child {
    padding-left: 0rem !important;
  }

  .table.g-lg-1 th, .table.g-lg-1 td {
    padding: 0.25rem;
  }
  .table.g-lg-1 th.dtr-control, .table.g-lg-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }

  .table.gy-lg-1 th, .table.gy-lg-1 td {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .table.gx-lg-1 th, .table.gx-lg-1 td {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .table.gx-lg-1 th.dtr-control, .table.gx-lg-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }

  .table.gs-lg-1 th:first-child, .table.gs-lg-1 td:first-child {
    padding-left: 0.25rem;
  }
  .table.gs-lg-1 th:last-child, .table.gs-lg-1 td:last-child {
    padding-right: 0.25rem;
  }
  .table.gs-lg-1 th.dtr-control:first-child, .table.gs-lg-1 td.dtr-control:first-child {
    padding-left: 0.25rem !important;
  }

  .table.g-lg-2 th, .table.g-lg-2 td {
    padding: 0.5rem;
  }
  .table.g-lg-2 th.dtr-control, .table.g-lg-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }

  .table.gy-lg-2 th, .table.gy-lg-2 td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .table.gx-lg-2 th, .table.gx-lg-2 td {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .table.gx-lg-2 th.dtr-control, .table.gx-lg-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }

  .table.gs-lg-2 th:first-child, .table.gs-lg-2 td:first-child {
    padding-left: 0.5rem;
  }
  .table.gs-lg-2 th:last-child, .table.gs-lg-2 td:last-child {
    padding-right: 0.5rem;
  }
  .table.gs-lg-2 th.dtr-control:first-child, .table.gs-lg-2 td.dtr-control:first-child {
    padding-left: 0.5rem !important;
  }

  .table.g-lg-3 th, .table.g-lg-3 td {
    padding: 0.75rem;
  }
  .table.g-lg-3 th.dtr-control, .table.g-lg-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }

  .table.gy-lg-3 th, .table.gy-lg-3 td {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .table.gx-lg-3 th, .table.gx-lg-3 td {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .table.gx-lg-3 th.dtr-control, .table.gx-lg-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }

  .table.gs-lg-3 th:first-child, .table.gs-lg-3 td:first-child {
    padding-left: 0.75rem;
  }
  .table.gs-lg-3 th:last-child, .table.gs-lg-3 td:last-child {
    padding-right: 0.75rem;
  }
  .table.gs-lg-3 th.dtr-control:first-child, .table.gs-lg-3 td.dtr-control:first-child {
    padding-left: 0.75rem !important;
  }

  .table.g-lg-4 th, .table.g-lg-4 td {
    padding: 1rem;
  }
  .table.g-lg-4 th.dtr-control, .table.g-lg-4 td.dtr-control {
    padding-left: 1rem !important;
  }

  .table.gy-lg-4 th, .table.gy-lg-4 td {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .table.gx-lg-4 th, .table.gx-lg-4 td {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .table.gx-lg-4 th.dtr-control, .table.gx-lg-4 td.dtr-control {
    padding-left: 1rem !important;
  }

  .table.gs-lg-4 th:first-child, .table.gs-lg-4 td:first-child {
    padding-left: 1rem;
  }
  .table.gs-lg-4 th:last-child, .table.gs-lg-4 td:last-child {
    padding-right: 1rem;
  }
  .table.gs-lg-4 th.dtr-control:first-child, .table.gs-lg-4 td.dtr-control:first-child {
    padding-left: 1rem !important;
  }

  .table.g-lg-5 th, .table.g-lg-5 td {
    padding: 1.25rem;
  }
  .table.g-lg-5 th.dtr-control, .table.g-lg-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }

  .table.gy-lg-5 th, .table.gy-lg-5 td {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .table.gx-lg-5 th, .table.gx-lg-5 td {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .table.gx-lg-5 th.dtr-control, .table.gx-lg-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }

  .table.gs-lg-5 th:first-child, .table.gs-lg-5 td:first-child {
    padding-left: 1.25rem;
  }
  .table.gs-lg-5 th:last-child, .table.gs-lg-5 td:last-child {
    padding-right: 1.25rem;
  }
  .table.gs-lg-5 th.dtr-control:first-child, .table.gs-lg-5 td.dtr-control:first-child {
    padding-left: 1.25rem !important;
  }

  .table.g-lg-6 th, .table.g-lg-6 td {
    padding: 1.5rem;
  }
  .table.g-lg-6 th.dtr-control, .table.g-lg-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }

  .table.gy-lg-6 th, .table.gy-lg-6 td {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .table.gx-lg-6 th, .table.gx-lg-6 td {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .table.gx-lg-6 th.dtr-control, .table.gx-lg-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }

  .table.gs-lg-6 th:first-child, .table.gs-lg-6 td:first-child {
    padding-left: 1.5rem;
  }
  .table.gs-lg-6 th:last-child, .table.gs-lg-6 td:last-child {
    padding-right: 1.5rem;
  }
  .table.gs-lg-6 th.dtr-control:first-child, .table.gs-lg-6 td.dtr-control:first-child {
    padding-left: 1.5rem !important;
  }

  .table.g-lg-7 th, .table.g-lg-7 td {
    padding: 1.75rem;
  }
  .table.g-lg-7 th.dtr-control, .table.g-lg-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }

  .table.gy-lg-7 th, .table.gy-lg-7 td {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .table.gx-lg-7 th, .table.gx-lg-7 td {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .table.gx-lg-7 th.dtr-control, .table.gx-lg-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }

  .table.gs-lg-7 th:first-child, .table.gs-lg-7 td:first-child {
    padding-left: 1.75rem;
  }
  .table.gs-lg-7 th:last-child, .table.gs-lg-7 td:last-child {
    padding-right: 1.75rem;
  }
  .table.gs-lg-7 th.dtr-control:first-child, .table.gs-lg-7 td.dtr-control:first-child {
    padding-left: 1.75rem !important;
  }

  .table.g-lg-8 th, .table.g-lg-8 td {
    padding: 2rem;
  }
  .table.g-lg-8 th.dtr-control, .table.g-lg-8 td.dtr-control {
    padding-left: 2rem !important;
  }

  .table.gy-lg-8 th, .table.gy-lg-8 td {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .table.gx-lg-8 th, .table.gx-lg-8 td {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .table.gx-lg-8 th.dtr-control, .table.gx-lg-8 td.dtr-control {
    padding-left: 2rem !important;
  }

  .table.gs-lg-8 th:first-child, .table.gs-lg-8 td:first-child {
    padding-left: 2rem;
  }
  .table.gs-lg-8 th:last-child, .table.gs-lg-8 td:last-child {
    padding-right: 2rem;
  }
  .table.gs-lg-8 th.dtr-control:first-child, .table.gs-lg-8 td.dtr-control:first-child {
    padding-left: 2rem !important;
  }

  .table.g-lg-9 th, .table.g-lg-9 td {
    padding: 2.25rem;
  }
  .table.g-lg-9 th.dtr-control, .table.g-lg-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }

  .table.gy-lg-9 th, .table.gy-lg-9 td {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .table.gx-lg-9 th, .table.gx-lg-9 td {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .table.gx-lg-9 th.dtr-control, .table.gx-lg-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }

  .table.gs-lg-9 th:first-child, .table.gs-lg-9 td:first-child {
    padding-left: 2.25rem;
  }
  .table.gs-lg-9 th:last-child, .table.gs-lg-9 td:last-child {
    padding-right: 2.25rem;
  }
  .table.gs-lg-9 th.dtr-control:first-child, .table.gs-lg-9 td.dtr-control:first-child {
    padding-left: 2.25rem !important;
  }

  .table.g-lg-10 th, .table.g-lg-10 td {
    padding: 2.5rem;
  }
  .table.g-lg-10 th.dtr-control, .table.g-lg-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }

  .table.gy-lg-10 th, .table.gy-lg-10 td {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .table.gx-lg-10 th, .table.gx-lg-10 td {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .table.gx-lg-10 th.dtr-control, .table.gx-lg-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }

  .table.gs-lg-10 th:first-child, .table.gs-lg-10 td:first-child {
    padding-left: 2.5rem;
  }
  .table.gs-lg-10 th:last-child, .table.gs-lg-10 td:last-child {
    padding-right: 2.5rem;
  }
  .table.gs-lg-10 th.dtr-control:first-child, .table.gs-lg-10 td.dtr-control:first-child {
    padding-left: 2.5rem !important;
  }
}
@media (min-width: 1200px) {
  .table.g-xl-0 th, .table.g-xl-0 td {
    padding: 0rem;
  }
  .table.g-xl-0 th.dtr-control, .table.g-xl-0 td.dtr-control {
    padding-left: 0rem !important;
  }

  .table.gy-xl-0 th, .table.gy-xl-0 td {
    padding-top: 0rem;
    padding-bottom: 0rem;
  }

  .table.gx-xl-0 th, .table.gx-xl-0 td {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  .table.gx-xl-0 th.dtr-control, .table.gx-xl-0 td.dtr-control {
    padding-left: 0rem !important;
  }

  .table.gs-xl-0 th:first-child, .table.gs-xl-0 td:first-child {
    padding-left: 0rem;
  }
  .table.gs-xl-0 th:last-child, .table.gs-xl-0 td:last-child {
    padding-right: 0rem;
  }
  .table.gs-xl-0 th.dtr-control:first-child, .table.gs-xl-0 td.dtr-control:first-child {
    padding-left: 0rem !important;
  }

  .table.g-xl-1 th, .table.g-xl-1 td {
    padding: 0.25rem;
  }
  .table.g-xl-1 th.dtr-control, .table.g-xl-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }

  .table.gy-xl-1 th, .table.gy-xl-1 td {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .table.gx-xl-1 th, .table.gx-xl-1 td {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .table.gx-xl-1 th.dtr-control, .table.gx-xl-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }

  .table.gs-xl-1 th:first-child, .table.gs-xl-1 td:first-child {
    padding-left: 0.25rem;
  }
  .table.gs-xl-1 th:last-child, .table.gs-xl-1 td:last-child {
    padding-right: 0.25rem;
  }
  .table.gs-xl-1 th.dtr-control:first-child, .table.gs-xl-1 td.dtr-control:first-child {
    padding-left: 0.25rem !important;
  }

  .table.g-xl-2 th, .table.g-xl-2 td {
    padding: 0.5rem;
  }
  .table.g-xl-2 th.dtr-control, .table.g-xl-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }

  .table.gy-xl-2 th, .table.gy-xl-2 td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .table.gx-xl-2 th, .table.gx-xl-2 td {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .table.gx-xl-2 th.dtr-control, .table.gx-xl-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }

  .table.gs-xl-2 th:first-child, .table.gs-xl-2 td:first-child {
    padding-left: 0.5rem;
  }
  .table.gs-xl-2 th:last-child, .table.gs-xl-2 td:last-child {
    padding-right: 0.5rem;
  }
  .table.gs-xl-2 th.dtr-control:first-child, .table.gs-xl-2 td.dtr-control:first-child {
    padding-left: 0.5rem !important;
  }

  .table.g-xl-3 th, .table.g-xl-3 td {
    padding: 0.75rem;
  }
  .table.g-xl-3 th.dtr-control, .table.g-xl-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }

  .table.gy-xl-3 th, .table.gy-xl-3 td {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .table.gx-xl-3 th, .table.gx-xl-3 td {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .table.gx-xl-3 th.dtr-control, .table.gx-xl-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }

  .table.gs-xl-3 th:first-child, .table.gs-xl-3 td:first-child {
    padding-left: 0.75rem;
  }
  .table.gs-xl-3 th:last-child, .table.gs-xl-3 td:last-child {
    padding-right: 0.75rem;
  }
  .table.gs-xl-3 th.dtr-control:first-child, .table.gs-xl-3 td.dtr-control:first-child {
    padding-left: 0.75rem !important;
  }

  .table.g-xl-4 th, .table.g-xl-4 td {
    padding: 1rem;
  }
  .table.g-xl-4 th.dtr-control, .table.g-xl-4 td.dtr-control {
    padding-left: 1rem !important;
  }

  .table.gy-xl-4 th, .table.gy-xl-4 td {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .table.gx-xl-4 th, .table.gx-xl-4 td {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .table.gx-xl-4 th.dtr-control, .table.gx-xl-4 td.dtr-control {
    padding-left: 1rem !important;
  }

  .table.gs-xl-4 th:first-child, .table.gs-xl-4 td:first-child {
    padding-left: 1rem;
  }
  .table.gs-xl-4 th:last-child, .table.gs-xl-4 td:last-child {
    padding-right: 1rem;
  }
  .table.gs-xl-4 th.dtr-control:first-child, .table.gs-xl-4 td.dtr-control:first-child {
    padding-left: 1rem !important;
  }

  .table.g-xl-5 th, .table.g-xl-5 td {
    padding: 1.25rem;
  }
  .table.g-xl-5 th.dtr-control, .table.g-xl-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }

  .table.gy-xl-5 th, .table.gy-xl-5 td {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .table.gx-xl-5 th, .table.gx-xl-5 td {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .table.gx-xl-5 th.dtr-control, .table.gx-xl-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }

  .table.gs-xl-5 th:first-child, .table.gs-xl-5 td:first-child {
    padding-left: 1.25rem;
  }
  .table.gs-xl-5 th:last-child, .table.gs-xl-5 td:last-child {
    padding-right: 1.25rem;
  }
  .table.gs-xl-5 th.dtr-control:first-child, .table.gs-xl-5 td.dtr-control:first-child {
    padding-left: 1.25rem !important;
  }

  .table.g-xl-6 th, .table.g-xl-6 td {
    padding: 1.5rem;
  }
  .table.g-xl-6 th.dtr-control, .table.g-xl-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }

  .table.gy-xl-6 th, .table.gy-xl-6 td {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .table.gx-xl-6 th, .table.gx-xl-6 td {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .table.gx-xl-6 th.dtr-control, .table.gx-xl-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }

  .table.gs-xl-6 th:first-child, .table.gs-xl-6 td:first-child {
    padding-left: 1.5rem;
  }
  .table.gs-xl-6 th:last-child, .table.gs-xl-6 td:last-child {
    padding-right: 1.5rem;
  }
  .table.gs-xl-6 th.dtr-control:first-child, .table.gs-xl-6 td.dtr-control:first-child {
    padding-left: 1.5rem !important;
  }

  .table.g-xl-7 th, .table.g-xl-7 td {
    padding: 1.75rem;
  }
  .table.g-xl-7 th.dtr-control, .table.g-xl-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }

  .table.gy-xl-7 th, .table.gy-xl-7 td {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .table.gx-xl-7 th, .table.gx-xl-7 td {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .table.gx-xl-7 th.dtr-control, .table.gx-xl-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }

  .table.gs-xl-7 th:first-child, .table.gs-xl-7 td:first-child {
    padding-left: 1.75rem;
  }
  .table.gs-xl-7 th:last-child, .table.gs-xl-7 td:last-child {
    padding-right: 1.75rem;
  }
  .table.gs-xl-7 th.dtr-control:first-child, .table.gs-xl-7 td.dtr-control:first-child {
    padding-left: 1.75rem !important;
  }

  .table.g-xl-8 th, .table.g-xl-8 td {
    padding: 2rem;
  }
  .table.g-xl-8 th.dtr-control, .table.g-xl-8 td.dtr-control {
    padding-left: 2rem !important;
  }

  .table.gy-xl-8 th, .table.gy-xl-8 td {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .table.gx-xl-8 th, .table.gx-xl-8 td {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .table.gx-xl-8 th.dtr-control, .table.gx-xl-8 td.dtr-control {
    padding-left: 2rem !important;
  }

  .table.gs-xl-8 th:first-child, .table.gs-xl-8 td:first-child {
    padding-left: 2rem;
  }
  .table.gs-xl-8 th:last-child, .table.gs-xl-8 td:last-child {
    padding-right: 2rem;
  }
  .table.gs-xl-8 th.dtr-control:first-child, .table.gs-xl-8 td.dtr-control:first-child {
    padding-left: 2rem !important;
  }

  .table.g-xl-9 th, .table.g-xl-9 td {
    padding: 2.25rem;
  }
  .table.g-xl-9 th.dtr-control, .table.g-xl-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }

  .table.gy-xl-9 th, .table.gy-xl-9 td {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .table.gx-xl-9 th, .table.gx-xl-9 td {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .table.gx-xl-9 th.dtr-control, .table.gx-xl-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }

  .table.gs-xl-9 th:first-child, .table.gs-xl-9 td:first-child {
    padding-left: 2.25rem;
  }
  .table.gs-xl-9 th:last-child, .table.gs-xl-9 td:last-child {
    padding-right: 2.25rem;
  }
  .table.gs-xl-9 th.dtr-control:first-child, .table.gs-xl-9 td.dtr-control:first-child {
    padding-left: 2.25rem !important;
  }

  .table.g-xl-10 th, .table.g-xl-10 td {
    padding: 2.5rem;
  }
  .table.g-xl-10 th.dtr-control, .table.g-xl-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }

  .table.gy-xl-10 th, .table.gy-xl-10 td {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .table.gx-xl-10 th, .table.gx-xl-10 td {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .table.gx-xl-10 th.dtr-control, .table.gx-xl-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }

  .table.gs-xl-10 th:first-child, .table.gs-xl-10 td:first-child {
    padding-left: 2.5rem;
  }
  .table.gs-xl-10 th:last-child, .table.gs-xl-10 td:last-child {
    padding-right: 2.5rem;
  }
  .table.gs-xl-10 th.dtr-control:first-child, .table.gs-xl-10 td.dtr-control:first-child {
    padding-left: 2.5rem !important;
  }
}
@media (min-width: 1400px) {
  .table.g-xxl-0 th, .table.g-xxl-0 td {
    padding: 0rem;
  }
  .table.g-xxl-0 th.dtr-control, .table.g-xxl-0 td.dtr-control {
    padding-left: 0rem !important;
  }

  .table.gy-xxl-0 th, .table.gy-xxl-0 td {
    padding-top: 0rem;
    padding-bottom: 0rem;
  }

  .table.gx-xxl-0 th, .table.gx-xxl-0 td {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  .table.gx-xxl-0 th.dtr-control, .table.gx-xxl-0 td.dtr-control {
    padding-left: 0rem !important;
  }

  .table.gs-xxl-0 th:first-child, .table.gs-xxl-0 td:first-child {
    padding-left: 0rem;
  }
  .table.gs-xxl-0 th:last-child, .table.gs-xxl-0 td:last-child {
    padding-right: 0rem;
  }
  .table.gs-xxl-0 th.dtr-control:first-child, .table.gs-xxl-0 td.dtr-control:first-child {
    padding-left: 0rem !important;
  }

  .table.g-xxl-1 th, .table.g-xxl-1 td {
    padding: 0.25rem;
  }
  .table.g-xxl-1 th.dtr-control, .table.g-xxl-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }

  .table.gy-xxl-1 th, .table.gy-xxl-1 td {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .table.gx-xxl-1 th, .table.gx-xxl-1 td {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .table.gx-xxl-1 th.dtr-control, .table.gx-xxl-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }

  .table.gs-xxl-1 th:first-child, .table.gs-xxl-1 td:first-child {
    padding-left: 0.25rem;
  }
  .table.gs-xxl-1 th:last-child, .table.gs-xxl-1 td:last-child {
    padding-right: 0.25rem;
  }
  .table.gs-xxl-1 th.dtr-control:first-child, .table.gs-xxl-1 td.dtr-control:first-child {
    padding-left: 0.25rem !important;
  }

  .table.g-xxl-2 th, .table.g-xxl-2 td {
    padding: 0.5rem;
  }
  .table.g-xxl-2 th.dtr-control, .table.g-xxl-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }

  .table.gy-xxl-2 th, .table.gy-xxl-2 td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .table.gx-xxl-2 th, .table.gx-xxl-2 td {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .table.gx-xxl-2 th.dtr-control, .table.gx-xxl-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }

  .table.gs-xxl-2 th:first-child, .table.gs-xxl-2 td:first-child {
    padding-left: 0.5rem;
  }
  .table.gs-xxl-2 th:last-child, .table.gs-xxl-2 td:last-child {
    padding-right: 0.5rem;
  }
  .table.gs-xxl-2 th.dtr-control:first-child, .table.gs-xxl-2 td.dtr-control:first-child {
    padding-left: 0.5rem !important;
  }

  .table.g-xxl-3 th, .table.g-xxl-3 td {
    padding: 0.75rem;
  }
  .table.g-xxl-3 th.dtr-control, .table.g-xxl-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }

  .table.gy-xxl-3 th, .table.gy-xxl-3 td {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .table.gx-xxl-3 th, .table.gx-xxl-3 td {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .table.gx-xxl-3 th.dtr-control, .table.gx-xxl-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }

  .table.gs-xxl-3 th:first-child, .table.gs-xxl-3 td:first-child {
    padding-left: 0.75rem;
  }
  .table.gs-xxl-3 th:last-child, .table.gs-xxl-3 td:last-child {
    padding-right: 0.75rem;
  }
  .table.gs-xxl-3 th.dtr-control:first-child, .table.gs-xxl-3 td.dtr-control:first-child {
    padding-left: 0.75rem !important;
  }

  .table.g-xxl-4 th, .table.g-xxl-4 td {
    padding: 1rem;
  }
  .table.g-xxl-4 th.dtr-control, .table.g-xxl-4 td.dtr-control {
    padding-left: 1rem !important;
  }

  .table.gy-xxl-4 th, .table.gy-xxl-4 td {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .table.gx-xxl-4 th, .table.gx-xxl-4 td {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .table.gx-xxl-4 th.dtr-control, .table.gx-xxl-4 td.dtr-control {
    padding-left: 1rem !important;
  }

  .table.gs-xxl-4 th:first-child, .table.gs-xxl-4 td:first-child {
    padding-left: 1rem;
  }
  .table.gs-xxl-4 th:last-child, .table.gs-xxl-4 td:last-child {
    padding-right: 1rem;
  }
  .table.gs-xxl-4 th.dtr-control:first-child, .table.gs-xxl-4 td.dtr-control:first-child {
    padding-left: 1rem !important;
  }

  .table.g-xxl-5 th, .table.g-xxl-5 td {
    padding: 1.25rem;
  }
  .table.g-xxl-5 th.dtr-control, .table.g-xxl-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }

  .table.gy-xxl-5 th, .table.gy-xxl-5 td {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .table.gx-xxl-5 th, .table.gx-xxl-5 td {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .table.gx-xxl-5 th.dtr-control, .table.gx-xxl-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }

  .table.gs-xxl-5 th:first-child, .table.gs-xxl-5 td:first-child {
    padding-left: 1.25rem;
  }
  .table.gs-xxl-5 th:last-child, .table.gs-xxl-5 td:last-child {
    padding-right: 1.25rem;
  }
  .table.gs-xxl-5 th.dtr-control:first-child, .table.gs-xxl-5 td.dtr-control:first-child {
    padding-left: 1.25rem !important;
  }

  .table.g-xxl-6 th, .table.g-xxl-6 td {
    padding: 1.5rem;
  }
  .table.g-xxl-6 th.dtr-control, .table.g-xxl-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }

  .table.gy-xxl-6 th, .table.gy-xxl-6 td {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .table.gx-xxl-6 th, .table.gx-xxl-6 td {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .table.gx-xxl-6 th.dtr-control, .table.gx-xxl-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }

  .table.gs-xxl-6 th:first-child, .table.gs-xxl-6 td:first-child {
    padding-left: 1.5rem;
  }
  .table.gs-xxl-6 th:last-child, .table.gs-xxl-6 td:last-child {
    padding-right: 1.5rem;
  }
  .table.gs-xxl-6 th.dtr-control:first-child, .table.gs-xxl-6 td.dtr-control:first-child {
    padding-left: 1.5rem !important;
  }

  .table.g-xxl-7 th, .table.g-xxl-7 td {
    padding: 1.75rem;
  }
  .table.g-xxl-7 th.dtr-control, .table.g-xxl-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }

  .table.gy-xxl-7 th, .table.gy-xxl-7 td {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .table.gx-xxl-7 th, .table.gx-xxl-7 td {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .table.gx-xxl-7 th.dtr-control, .table.gx-xxl-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }

  .table.gs-xxl-7 th:first-child, .table.gs-xxl-7 td:first-child {
    padding-left: 1.75rem;
  }
  .table.gs-xxl-7 th:last-child, .table.gs-xxl-7 td:last-child {
    padding-right: 1.75rem;
  }
  .table.gs-xxl-7 th.dtr-control:first-child, .table.gs-xxl-7 td.dtr-control:first-child {
    padding-left: 1.75rem !important;
  }

  .table.g-xxl-8 th, .table.g-xxl-8 td {
    padding: 2rem;
  }
  .table.g-xxl-8 th.dtr-control, .table.g-xxl-8 td.dtr-control {
    padding-left: 2rem !important;
  }

  .table.gy-xxl-8 th, .table.gy-xxl-8 td {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .table.gx-xxl-8 th, .table.gx-xxl-8 td {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .table.gx-xxl-8 th.dtr-control, .table.gx-xxl-8 td.dtr-control {
    padding-left: 2rem !important;
  }

  .table.gs-xxl-8 th:first-child, .table.gs-xxl-8 td:first-child {
    padding-left: 2rem;
  }
  .table.gs-xxl-8 th:last-child, .table.gs-xxl-8 td:last-child {
    padding-right: 2rem;
  }
  .table.gs-xxl-8 th.dtr-control:first-child, .table.gs-xxl-8 td.dtr-control:first-child {
    padding-left: 2rem !important;
  }

  .table.g-xxl-9 th, .table.g-xxl-9 td {
    padding: 2.25rem;
  }
  .table.g-xxl-9 th.dtr-control, .table.g-xxl-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }

  .table.gy-xxl-9 th, .table.gy-xxl-9 td {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .table.gx-xxl-9 th, .table.gx-xxl-9 td {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .table.gx-xxl-9 th.dtr-control, .table.gx-xxl-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }

  .table.gs-xxl-9 th:first-child, .table.gs-xxl-9 td:first-child {
    padding-left: 2.25rem;
  }
  .table.gs-xxl-9 th:last-child, .table.gs-xxl-9 td:last-child {
    padding-right: 2.25rem;
  }
  .table.gs-xxl-9 th.dtr-control:first-child, .table.gs-xxl-9 td.dtr-control:first-child {
    padding-left: 2.25rem !important;
  }

  .table.g-xxl-10 th, .table.g-xxl-10 td {
    padding: 2.5rem;
  }
  .table.g-xxl-10 th.dtr-control, .table.g-xxl-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }

  .table.gy-xxl-10 th, .table.gy-xxl-10 td {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .table.gx-xxl-10 th, .table.gx-xxl-10 td {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .table.gx-xxl-10 th.dtr-control, .table.gx-xxl-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }

  .table.gs-xxl-10 th:first-child, .table.gs-xxl-10 td:first-child {
    padding-left: 2.5rem;
  }
  .table.gs-xxl-10 th:last-child, .table.gs-xxl-10 td:last-child {
    padding-right: 2.5rem;
  }
  .table.gs-xxl-10 th.dtr-control:first-child, .table.gs-xxl-10 td.dtr-control:first-child {
    padding-left: 2.5rem !important;
  }
}
.popover .popover-header {
  font-size: 1rem;
  font-weight: 500;
  border-bottom: 1px solid #F5F8FA;
}
.popover .popover-dismiss {
  position: absolute;
  top: 0.85rem;
  right: 0.85rem;
  height: 1.5rem;
  width: 1.5rem;
}
.popover .popover-dismiss i {
  color: #A1A5B7;
}
.popover .popover-dismiss:hover i {
  color: #009EF7;
}
.popover .popover-dismiss + .popover-header {
  padding-right: 2.75rem;
}

.popover-dark {
  background-color: #181C32;
  border: 0;
}
.popover-dark .popover-header {
  background-color: #181C32;
  color: #EFF2F5;
  border-bottom-color: #3F4254;
}
.popover-dark .popover-body {
  color: #B5B5C3;
}
.popover-dark.bs-popover-top > .popover-arrow::before, .popover-dark.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  border-top-color: #F5F8FA;
}
.popover-dark.bs-popover-top > .popover-arrow::after, .popover-dark.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-top-color: #181C32;
}
.popover-dark.bs-popover-end > .popover-arrow::before, .popover-dark.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  border-right-color: #F5F8FA;
}
.popover-dark.bs-popover-end > .popover-arrow::after, .popover-dark.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-right-color: #181C32;
}
.popover-dark.bs-popover-bottom > .popover-arrow::before, .popover-dark.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  border-bottom-color: #F5F8FA;
}
.popover-dark.bs-popover-bottom > .popover-arrow::after, .popover-dark.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-bottom-color: #181C32;
}
.popover-dark.bs-popover-bottom .popover-header::before, .popover-dark.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #181C32;
}
.popover-dark.bs-popover-start > .popover-arrow::before, .popover-dark.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  border-left-color: #F5F8FA;
}
.popover-dark.bs-popover-start > .popover-arrow::after, .popover-dark.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-left-color: #181C32;
}

.tooltip .tooltip-inner {
  box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
}
.tooltip.tooltop-auto-width .tooltip-inner {
  white-space: nowrap;
  max-width: none;
}
.tooltip.tooltip-dark .tooltip-inner {
  color: #ffffff;
  background-color: #181C32;
}
.tooltip.tooltip-dark.bs-tooltip-top .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  border-top-color: #181C32;
}
.tooltip.tooltip-dark.bs-tooltip-end .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  border-right-color: #181C32;
}
.tooltip.tooltip-dark.bs-tooltip-bottom .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  border-bottom-color: #181C32;
}
.tooltip.tooltip-dark.bs-tooltip-start .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  border-left-color: #181C32;
}

.accordion .accordion-header {
  cursor: pointer;
}
.accordion.accordion-icon-toggle .accordion-icon {
  display: flex;
  flex-shrink: 0;
  transition: all 0.2s ease;
  transform: rotate(90deg);
  align-items: center;
  justify-content: center;
}
.accordion.accordion-icon-toggle .accordion-icon i {
  color: #009EF7;
}
.accordion.accordion-icon-toggle .accordion-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.accordion.accordion-icon-toggle .accordion-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.accordion.accordion-icon-toggle .collapsed .accordion-icon {
  transition: all 0.2s ease;
  transform: rotate(0);
}
.accordion.accordion-icon-toggle .collapsed .accordion-icon i {
  color: #A1A5B7;
}
.accordion.accordion-icon-toggle .collapsed .accordion-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.accordion.accordion-icon-toggle .collapsed .accordion-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.accordion.accordion-borderless .accordion-item {
  border: 0;
}
.accordion.accordion-flush .accordion-item {
  background-color: transparent;
  border: 0;
  border-radius: none;
  padding-left: 0;
  padding-right: 0;
}

.feedback {
  display: none;
}

.feedback-popup {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  position: fixed;
  z-index: 1000;
  box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  background-color: #ffffff;
  border-radius: 0.475rem;
  padding: 1rem 1.25rem;
}

.feedback-top-center {
  display: flex;
  transition: top 0.6s ease;
  left: 50%;
  transform: translateX(-50%);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.feedback-top-center.feedback-shown {
  top: 0px;
  transition: top 0.6s ease;
}

.image-input {
  position: relative;
  display: inline-block;
  border-radius: 0.475rem;
  background-repeat: no-repeat;
  background-size: cover;
}
.image-input:not(.image-input-empty) {
  background-image: none !important;
}
.image-input .image-input-wrapper {
  width: 120px;
  height: 120px;
  border-radius: 0.475rem;
  background-repeat: no-repeat;
  background-size: cover;
}
.image-input [data-kt-image-input-action] {
  cursor: pointer;
  position: absolute;
  transform: translate(-50%, -50%);
}
.image-input [data-kt-image-input-action=change] {
  left: 100%;
  top: 0;
}
.image-input [data-kt-image-input-action=change] input {
  width: 0 !important;
  height: 0 !important;
  overflow: hidden;
  opacity: 0;
}
.image-input [data-kt-image-input-action=cancel],
.image-input [data-kt-image-input-action=remove] {
  position: absolute;
  left: 100%;
  top: 100%;
}
.image-input [data-kt-image-input-action=cancel] {
  display: none;
}
.image-input.image-input-changed [data-kt-image-input-action=cancel] {
  display: flex;
}
.image-input.image-input-changed [data-kt-image-input-action=remove] {
  display: none;
}
.image-input.image-input-empty [data-kt-image-input-action=remove],
.image-input.image-input-empty [data-kt-image-input-action=cancel] {
  display: none;
}
.image-input.image-input-circle {
  border-radius: 50%;
}
.image-input.image-input-circle .image-input-wrapper {
  border-radius: 50%;
}
.image-input.image-input-circle [data-kt-image-input-action=change] {
  left: 100%;
  top: 0;
  transform: translate(-100%, 0%);
}
.image-input.image-input-circle [data-kt-image-input-action=cancel],
.image-input.image-input-circle [data-kt-image-input-action=remove] {
  left: 100%;
  top: 100%;
  transform: translate(-100%, -100%);
}
.image-input.image-input-outline .image-input-wrapper {
  border: 3px solid #ffffff;
  box-shadow: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);
}

.symbol {
  display: inline-block;
  flex-shrink: 0;
  position: relative;
  border-radius: 0.475rem;
}
.symbol .symbol-label {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  color: #3F4254;
  background-color: #F5F8FA;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  border-radius: 0.475rem;
}
.symbol .symbol-badge {
  position: absolute;
  border: 2px solid #ffffff;
  border-radius: 100%;
  top: 0;
  left: 50%;
  transform: translateX(-50%) translateY(-50%) !important;
}
.symbol > img {
  width: 100%;
  flex-shrink: 0;
  display: inline-block;
  border-radius: 0.475rem;
}
.symbol.symbol-square,
.symbol.symbol-square > img,
.symbol.symbol-square .symbol-label {
  border-radius: 0 !important;
}
.symbol.symbol-circle,
.symbol.symbol-circle > img,
.symbol.symbol-circle .symbol-label {
  border-radius: 50%;
}
.symbol > img {
  width: 50px;
  height: 50px;
}
.symbol .symbol-label {
  width: 50px;
  height: 50px;
}
.symbol.symbol-fixed .symbol-label {
  width: 50px;
  height: 50px;
}
.symbol.symbol-fixed > img {
  width: 50px;
  height: 50px;
  max-width: auto;
}
.symbol.symbol-2by3 .symbol-label {
  height: 50px;
  width: 75px;
}
.symbol.symbol-2by3 > img {
  height: 50px;
  width: 75px;
  max-width: auto;
}
.symbol.symbol-20px > img {
  width: 20px;
  height: 20px;
}
.symbol.symbol-20px .symbol-label {
  width: 20px;
  height: 20px;
}
.symbol.symbol-20px.symbol-fixed .symbol-label {
  width: 20px;
  height: 20px;
}
.symbol.symbol-20px.symbol-fixed > img {
  width: 20px;
  height: 20px;
  max-width: auto;
}
.symbol.symbol-20px.symbol-2by3 .symbol-label {
  height: 20px;
  width: 30px;
}
.symbol.symbol-20px.symbol-2by3 > img {
  height: 20px;
  width: 30px;
  max-width: auto;
}
.symbol.symbol-25px > img {
  width: 25px;
  height: 25px;
}
.symbol.symbol-25px .symbol-label {
  width: 25px;
  height: 25px;
}
.symbol.symbol-25px.symbol-fixed .symbol-label {
  width: 25px;
  height: 25px;
}
.symbol.symbol-25px.symbol-fixed > img {
  width: 25px;
  height: 25px;
  max-width: auto;
}
.symbol.symbol-25px.symbol-2by3 .symbol-label {
  height: 25px;
  width: 37.5px;
}
.symbol.symbol-25px.symbol-2by3 > img {
  height: 25px;
  width: 37.5px;
  max-width: auto;
}
.symbol.symbol-30px > img {
  width: 30px;
  height: 30px;
}
.symbol.symbol-30px .symbol-label {
  width: 30px;
  height: 30px;
}
.symbol.symbol-30px.symbol-fixed .symbol-label {
  width: 30px;
  height: 30px;
}
.symbol.symbol-30px.symbol-fixed > img {
  width: 30px;
  height: 30px;
  max-width: auto;
}
.symbol.symbol-30px.symbol-2by3 .symbol-label {
  height: 30px;
  width: 45px;
}
.symbol.symbol-30px.symbol-2by3 > img {
  height: 30px;
  width: 45px;
  max-width: auto;
}
.symbol.symbol-35px > img {
  width: 35px;
  height: 35px;
}
.symbol.symbol-35px .symbol-label {
  width: 35px;
  height: 35px;
}
.symbol.symbol-35px.symbol-fixed .symbol-label {
  width: 35px;
  height: 35px;
}
.symbol.symbol-35px.symbol-fixed > img {
  width: 35px;
  height: 35px;
  max-width: auto;
}
.symbol.symbol-35px.symbol-2by3 .symbol-label {
  height: 35px;
  width: 52.5px;
}
.symbol.symbol-35px.symbol-2by3 > img {
  height: 35px;
  width: 52.5px;
  max-width: auto;
}
.symbol.symbol-40px > img {
  width: 40px;
  height: 40px;
}
.symbol.symbol-40px .symbol-label {
  width: 40px;
  height: 40px;
}
.symbol.symbol-40px.symbol-fixed .symbol-label {
  width: 40px;
  height: 40px;
}
.symbol.symbol-40px.symbol-fixed > img {
  width: 40px;
  height: 40px;
  max-width: auto;
}
.symbol.symbol-40px.symbol-2by3 .symbol-label {
  height: 40px;
  width: 60px;
}
.symbol.symbol-40px.symbol-2by3 > img {
  height: 40px;
  width: 60px;
  max-width: auto;
}
.symbol.symbol-45px > img {
  width: 45px;
  height: 45px;
}
.symbol.symbol-45px .symbol-label {
  width: 45px;
  height: 45px;
}
.symbol.symbol-45px.symbol-fixed .symbol-label {
  width: 45px;
  height: 45px;
}
.symbol.symbol-45px.symbol-fixed > img {
  width: 45px;
  height: 45px;
  max-width: auto;
}
.symbol.symbol-45px.symbol-2by3 .symbol-label {
  height: 45px;
  width: 67.5px;
}
.symbol.symbol-45px.symbol-2by3 > img {
  height: 45px;
  width: 67.5px;
  max-width: auto;
}
.symbol.symbol-50px > img {
  width: 50px;
  height: 50px;
}
.symbol.symbol-50px .symbol-label {
  width: 50px;
  height: 50px;
}
.symbol.symbol-50px.symbol-fixed .symbol-label {
  width: 50px;
  height: 50px;
}
.symbol.symbol-50px.symbol-fixed > img {
  width: 50px;
  height: 50px;
  max-width: auto;
}
.symbol.symbol-50px.symbol-2by3 .symbol-label {
  height: 50px;
  width: 75px;
}
.symbol.symbol-50px.symbol-2by3 > img {
  height: 50px;
  width: 75px;
  max-width: auto;
}
.symbol.symbol-55px > img {
  width: 55px;
  height: 55px;
}
.symbol.symbol-55px .symbol-label {
  width: 55px;
  height: 55px;
}
.symbol.symbol-55px.symbol-fixed .symbol-label {
  width: 55px;
  height: 55px;
}
.symbol.symbol-55px.symbol-fixed > img {
  width: 55px;
  height: 55px;
  max-width: auto;
}
.symbol.symbol-55px.symbol-2by3 .symbol-label {
  height: 55px;
  width: 82.5px;
}
.symbol.symbol-55px.symbol-2by3 > img {
  height: 55px;
  width: 82.5px;
  max-width: auto;
}
.symbol.symbol-60px > img {
  width: 60px;
  height: 60px;
}
.symbol.symbol-60px .symbol-label {
  width: 60px;
  height: 60px;
}
.symbol.symbol-60px.symbol-fixed .symbol-label {
  width: 60px;
  height: 60px;
}
.symbol.symbol-60px.symbol-fixed > img {
  width: 60px;
  height: 60px;
  max-width: auto;
}
.symbol.symbol-60px.symbol-2by3 .symbol-label {
  height: 60px;
  width: 90px;
}
.symbol.symbol-60px.symbol-2by3 > img {
  height: 60px;
  width: 90px;
  max-width: auto;
}
.symbol.symbol-65px > img {
  width: 65px;
  height: 65px;
}
.symbol.symbol-65px .symbol-label {
  width: 65px;
  height: 65px;
}
.symbol.symbol-65px.symbol-fixed .symbol-label {
  width: 65px;
  height: 65px;
}
.symbol.symbol-65px.symbol-fixed > img {
  width: 65px;
  height: 65px;
  max-width: auto;
}
.symbol.symbol-65px.symbol-2by3 .symbol-label {
  height: 65px;
  width: 97.5px;
}
.symbol.symbol-65px.symbol-2by3 > img {
  height: 65px;
  width: 97.5px;
  max-width: auto;
}
.symbol.symbol-70px > img {
  width: 70px;
  height: 70px;
}
.symbol.symbol-70px .symbol-label {
  width: 70px;
  height: 70px;
}
.symbol.symbol-70px.symbol-fixed .symbol-label {
  width: 70px;
  height: 70px;
}
.symbol.symbol-70px.symbol-fixed > img {
  width: 70px;
  height: 70px;
  max-width: auto;
}
.symbol.symbol-70px.symbol-2by3 .symbol-label {
  height: 70px;
  width: 105px;
}
.symbol.symbol-70px.symbol-2by3 > img {
  height: 70px;
  width: 105px;
  max-width: auto;
}
.symbol.symbol-75px > img {
  width: 75px;
  height: 75px;
}
.symbol.symbol-75px .symbol-label {
  width: 75px;
  height: 75px;
}
.symbol.symbol-75px.symbol-fixed .symbol-label {
  width: 75px;
  height: 75px;
}
.symbol.symbol-75px.symbol-fixed > img {
  width: 75px;
  height: 75px;
  max-width: auto;
}
.symbol.symbol-75px.symbol-2by3 .symbol-label {
  height: 75px;
  width: 112.5px;
}
.symbol.symbol-75px.symbol-2by3 > img {
  height: 75px;
  width: 112.5px;
  max-width: auto;
}
.symbol.symbol-100px > img {
  width: 100px;
  height: 100px;
}
.symbol.symbol-100px .symbol-label {
  width: 100px;
  height: 100px;
}
.symbol.symbol-100px.symbol-fixed .symbol-label {
  width: 100px;
  height: 100px;
}
.symbol.symbol-100px.symbol-fixed > img {
  width: 100px;
  height: 100px;
  max-width: auto;
}
.symbol.symbol-100px.symbol-2by3 .symbol-label {
  height: 100px;
  width: 150px;
}
.symbol.symbol-100px.symbol-2by3 > img {
  height: 100px;
  width: 150px;
  max-width: auto;
}
.symbol.symbol-125px > img {
  width: 125px;
  height: 125px;
}
.symbol.symbol-125px .symbol-label {
  width: 125px;
  height: 125px;
}
.symbol.symbol-125px.symbol-fixed .symbol-label {
  width: 125px;
  height: 125px;
}
.symbol.symbol-125px.symbol-fixed > img {
  width: 125px;
  height: 125px;
  max-width: auto;
}
.symbol.symbol-125px.symbol-2by3 .symbol-label {
  height: 125px;
  width: 187.5px;
}
.symbol.symbol-125px.symbol-2by3 > img {
  height: 125px;
  width: 187.5px;
  max-width: auto;
}
.symbol.symbol-150px > img {
  width: 150px;
  height: 150px;
}
.symbol.symbol-150px .symbol-label {
  width: 150px;
  height: 150px;
}
.symbol.symbol-150px.symbol-fixed .symbol-label {
  width: 150px;
  height: 150px;
}
.symbol.symbol-150px.symbol-fixed > img {
  width: 150px;
  height: 150px;
  max-width: auto;
}
.symbol.symbol-150px.symbol-2by3 .symbol-label {
  height: 150px;
  width: 225px;
}
.symbol.symbol-150px.symbol-2by3 > img {
  height: 150px;
  width: 225px;
  max-width: auto;
}
.symbol.symbol-160px > img {
  width: 160px;
  height: 160px;
}
.symbol.symbol-160px .symbol-label {
  width: 160px;
  height: 160px;
}
.symbol.symbol-160px.symbol-fixed .symbol-label {
  width: 160px;
  height: 160px;
}
.symbol.symbol-160px.symbol-fixed > img {
  width: 160px;
  height: 160px;
  max-width: auto;
}
.symbol.symbol-160px.symbol-2by3 .symbol-label {
  height: 160px;
  width: 240px;
}
.symbol.symbol-160px.symbol-2by3 > img {
  height: 160px;
  width: 240px;
  max-width: auto;
}
.symbol.symbol-175px > img {
  width: 175px;
  height: 175px;
}
.symbol.symbol-175px .symbol-label {
  width: 175px;
  height: 175px;
}
.symbol.symbol-175px.symbol-fixed .symbol-label {
  width: 175px;
  height: 175px;
}
.symbol.symbol-175px.symbol-fixed > img {
  width: 175px;
  height: 175px;
  max-width: auto;
}
.symbol.symbol-175px.symbol-2by3 .symbol-label {
  height: 175px;
  width: 262.5px;
}
.symbol.symbol-175px.symbol-2by3 > img {
  height: 175px;
  width: 262.5px;
  max-width: auto;
}
.symbol.symbol-200px > img {
  width: 200px;
  height: 200px;
}
.symbol.symbol-200px .symbol-label {
  width: 200px;
  height: 200px;
}
.symbol.symbol-200px.symbol-fixed .symbol-label {
  width: 200px;
  height: 200px;
}
.symbol.symbol-200px.symbol-fixed > img {
  width: 200px;
  height: 200px;
  max-width: auto;
}
.symbol.symbol-200px.symbol-2by3 .symbol-label {
  height: 200px;
  width: 300px;
}
.symbol.symbol-200px.symbol-2by3 > img {
  height: 200px;
  width: 300px;
  max-width: auto;
}
@media (min-width: 576px) {
  .symbol.symbol-sm-20px > img {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-sm-20px .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-sm-20px.symbol-fixed .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-sm-20px.symbol-fixed > img {
    width: 20px;
    height: 20px;
    max-width: auto;
  }
  .symbol.symbol-sm-20px.symbol-2by3 .symbol-label {
    height: 20px;
    width: 30px;
  }
  .symbol.symbol-sm-20px.symbol-2by3 > img {
    height: 20px;
    width: 30px;
    max-width: auto;
  }
  .symbol.symbol-sm-25px > img {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-sm-25px .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-sm-25px.symbol-fixed .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-sm-25px.symbol-fixed > img {
    width: 25px;
    height: 25px;
    max-width: auto;
  }
  .symbol.symbol-sm-25px.symbol-2by3 .symbol-label {
    height: 25px;
    width: 37.5px;
  }
  .symbol.symbol-sm-25px.symbol-2by3 > img {
    height: 25px;
    width: 37.5px;
    max-width: auto;
  }
  .symbol.symbol-sm-30px > img {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-sm-30px .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-sm-30px.symbol-fixed .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-sm-30px.symbol-fixed > img {
    width: 30px;
    height: 30px;
    max-width: auto;
  }
  .symbol.symbol-sm-30px.symbol-2by3 .symbol-label {
    height: 30px;
    width: 45px;
  }
  .symbol.symbol-sm-30px.symbol-2by3 > img {
    height: 30px;
    width: 45px;
    max-width: auto;
  }
  .symbol.symbol-sm-35px > img {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-sm-35px .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-sm-35px.symbol-fixed .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-sm-35px.symbol-fixed > img {
    width: 35px;
    height: 35px;
    max-width: auto;
  }
  .symbol.symbol-sm-35px.symbol-2by3 .symbol-label {
    height: 35px;
    width: 52.5px;
  }
  .symbol.symbol-sm-35px.symbol-2by3 > img {
    height: 35px;
    width: 52.5px;
    max-width: auto;
  }
  .symbol.symbol-sm-40px > img {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-sm-40px .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-sm-40px.symbol-fixed .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-sm-40px.symbol-fixed > img {
    width: 40px;
    height: 40px;
    max-width: auto;
  }
  .symbol.symbol-sm-40px.symbol-2by3 .symbol-label {
    height: 40px;
    width: 60px;
  }
  .symbol.symbol-sm-40px.symbol-2by3 > img {
    height: 40px;
    width: 60px;
    max-width: auto;
  }
  .symbol.symbol-sm-45px > img {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-sm-45px .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-sm-45px.symbol-fixed .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-sm-45px.symbol-fixed > img {
    width: 45px;
    height: 45px;
    max-width: auto;
  }
  .symbol.symbol-sm-45px.symbol-2by3 .symbol-label {
    height: 45px;
    width: 67.5px;
  }
  .symbol.symbol-sm-45px.symbol-2by3 > img {
    height: 45px;
    width: 67.5px;
    max-width: auto;
  }
  .symbol.symbol-sm-50px > img {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-sm-50px .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-sm-50px.symbol-fixed .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-sm-50px.symbol-fixed > img {
    width: 50px;
    height: 50px;
    max-width: auto;
  }
  .symbol.symbol-sm-50px.symbol-2by3 .symbol-label {
    height: 50px;
    width: 75px;
  }
  .symbol.symbol-sm-50px.symbol-2by3 > img {
    height: 50px;
    width: 75px;
    max-width: auto;
  }
  .symbol.symbol-sm-55px > img {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-sm-55px .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-sm-55px.symbol-fixed .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-sm-55px.symbol-fixed > img {
    width: 55px;
    height: 55px;
    max-width: auto;
  }
  .symbol.symbol-sm-55px.symbol-2by3 .symbol-label {
    height: 55px;
    width: 82.5px;
  }
  .symbol.symbol-sm-55px.symbol-2by3 > img {
    height: 55px;
    width: 82.5px;
    max-width: auto;
  }
  .symbol.symbol-sm-60px > img {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-sm-60px .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-sm-60px.symbol-fixed .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-sm-60px.symbol-fixed > img {
    width: 60px;
    height: 60px;
    max-width: auto;
  }
  .symbol.symbol-sm-60px.symbol-2by3 .symbol-label {
    height: 60px;
    width: 90px;
  }
  .symbol.symbol-sm-60px.symbol-2by3 > img {
    height: 60px;
    width: 90px;
    max-width: auto;
  }
  .symbol.symbol-sm-65px > img {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-sm-65px .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-sm-65px.symbol-fixed .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-sm-65px.symbol-fixed > img {
    width: 65px;
    height: 65px;
    max-width: auto;
  }
  .symbol.symbol-sm-65px.symbol-2by3 .symbol-label {
    height: 65px;
    width: 97.5px;
  }
  .symbol.symbol-sm-65px.symbol-2by3 > img {
    height: 65px;
    width: 97.5px;
    max-width: auto;
  }
  .symbol.symbol-sm-70px > img {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-sm-70px .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-sm-70px.symbol-fixed .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-sm-70px.symbol-fixed > img {
    width: 70px;
    height: 70px;
    max-width: auto;
  }
  .symbol.symbol-sm-70px.symbol-2by3 .symbol-label {
    height: 70px;
    width: 105px;
  }
  .symbol.symbol-sm-70px.symbol-2by3 > img {
    height: 70px;
    width: 105px;
    max-width: auto;
  }
  .symbol.symbol-sm-75px > img {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-sm-75px .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-sm-75px.symbol-fixed .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-sm-75px.symbol-fixed > img {
    width: 75px;
    height: 75px;
    max-width: auto;
  }
  .symbol.symbol-sm-75px.symbol-2by3 .symbol-label {
    height: 75px;
    width: 112.5px;
  }
  .symbol.symbol-sm-75px.symbol-2by3 > img {
    height: 75px;
    width: 112.5px;
    max-width: auto;
  }
  .symbol.symbol-sm-100px > img {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-sm-100px .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-sm-100px.symbol-fixed .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-sm-100px.symbol-fixed > img {
    width: 100px;
    height: 100px;
    max-width: auto;
  }
  .symbol.symbol-sm-100px.symbol-2by3 .symbol-label {
    height: 100px;
    width: 150px;
  }
  .symbol.symbol-sm-100px.symbol-2by3 > img {
    height: 100px;
    width: 150px;
    max-width: auto;
  }
  .symbol.symbol-sm-125px > img {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-sm-125px .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-sm-125px.symbol-fixed .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-sm-125px.symbol-fixed > img {
    width: 125px;
    height: 125px;
    max-width: auto;
  }
  .symbol.symbol-sm-125px.symbol-2by3 .symbol-label {
    height: 125px;
    width: 187.5px;
  }
  .symbol.symbol-sm-125px.symbol-2by3 > img {
    height: 125px;
    width: 187.5px;
    max-width: auto;
  }
  .symbol.symbol-sm-150px > img {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-sm-150px .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-sm-150px.symbol-fixed .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-sm-150px.symbol-fixed > img {
    width: 150px;
    height: 150px;
    max-width: auto;
  }
  .symbol.symbol-sm-150px.symbol-2by3 .symbol-label {
    height: 150px;
    width: 225px;
  }
  .symbol.symbol-sm-150px.symbol-2by3 > img {
    height: 150px;
    width: 225px;
    max-width: auto;
  }
  .symbol.symbol-sm-160px > img {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-sm-160px .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-sm-160px.symbol-fixed .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-sm-160px.symbol-fixed > img {
    width: 160px;
    height: 160px;
    max-width: auto;
  }
  .symbol.symbol-sm-160px.symbol-2by3 .symbol-label {
    height: 160px;
    width: 240px;
  }
  .symbol.symbol-sm-160px.symbol-2by3 > img {
    height: 160px;
    width: 240px;
    max-width: auto;
  }
  .symbol.symbol-sm-175px > img {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-sm-175px .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-sm-175px.symbol-fixed .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-sm-175px.symbol-fixed > img {
    width: 175px;
    height: 175px;
    max-width: auto;
  }
  .symbol.symbol-sm-175px.symbol-2by3 .symbol-label {
    height: 175px;
    width: 262.5px;
  }
  .symbol.symbol-sm-175px.symbol-2by3 > img {
    height: 175px;
    width: 262.5px;
    max-width: auto;
  }
  .symbol.symbol-sm-200px > img {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-sm-200px .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-sm-200px.symbol-fixed .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-sm-200px.symbol-fixed > img {
    width: 200px;
    height: 200px;
    max-width: auto;
  }
  .symbol.symbol-sm-200px.symbol-2by3 .symbol-label {
    height: 200px;
    width: 300px;
  }
  .symbol.symbol-sm-200px.symbol-2by3 > img {
    height: 200px;
    width: 300px;
    max-width: auto;
  }
}
@media (min-width: 768px) {
  .symbol.symbol-md-20px > img {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-md-20px .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-md-20px.symbol-fixed .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-md-20px.symbol-fixed > img {
    width: 20px;
    height: 20px;
    max-width: auto;
  }
  .symbol.symbol-md-20px.symbol-2by3 .symbol-label {
    height: 20px;
    width: 30px;
  }
  .symbol.symbol-md-20px.symbol-2by3 > img {
    height: 20px;
    width: 30px;
    max-width: auto;
  }
  .symbol.symbol-md-25px > img {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-md-25px .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-md-25px.symbol-fixed .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-md-25px.symbol-fixed > img {
    width: 25px;
    height: 25px;
    max-width: auto;
  }
  .symbol.symbol-md-25px.symbol-2by3 .symbol-label {
    height: 25px;
    width: 37.5px;
  }
  .symbol.symbol-md-25px.symbol-2by3 > img {
    height: 25px;
    width: 37.5px;
    max-width: auto;
  }
  .symbol.symbol-md-30px > img {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-md-30px .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-md-30px.symbol-fixed .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-md-30px.symbol-fixed > img {
    width: 30px;
    height: 30px;
    max-width: auto;
  }
  .symbol.symbol-md-30px.symbol-2by3 .symbol-label {
    height: 30px;
    width: 45px;
  }
  .symbol.symbol-md-30px.symbol-2by3 > img {
    height: 30px;
    width: 45px;
    max-width: auto;
  }
  .symbol.symbol-md-35px > img {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-md-35px .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-md-35px.symbol-fixed .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-md-35px.symbol-fixed > img {
    width: 35px;
    height: 35px;
    max-width: auto;
  }
  .symbol.symbol-md-35px.symbol-2by3 .symbol-label {
    height: 35px;
    width: 52.5px;
  }
  .symbol.symbol-md-35px.symbol-2by3 > img {
    height: 35px;
    width: 52.5px;
    max-width: auto;
  }
  .symbol.symbol-md-40px > img {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-md-40px .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-md-40px.symbol-fixed .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-md-40px.symbol-fixed > img {
    width: 40px;
    height: 40px;
    max-width: auto;
  }
  .symbol.symbol-md-40px.symbol-2by3 .symbol-label {
    height: 40px;
    width: 60px;
  }
  .symbol.symbol-md-40px.symbol-2by3 > img {
    height: 40px;
    width: 60px;
    max-width: auto;
  }
  .symbol.symbol-md-45px > img {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-md-45px .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-md-45px.symbol-fixed .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-md-45px.symbol-fixed > img {
    width: 45px;
    height: 45px;
    max-width: auto;
  }
  .symbol.symbol-md-45px.symbol-2by3 .symbol-label {
    height: 45px;
    width: 67.5px;
  }
  .symbol.symbol-md-45px.symbol-2by3 > img {
    height: 45px;
    width: 67.5px;
    max-width: auto;
  }
  .symbol.symbol-md-50px > img {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-md-50px .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-md-50px.symbol-fixed .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-md-50px.symbol-fixed > img {
    width: 50px;
    height: 50px;
    max-width: auto;
  }
  .symbol.symbol-md-50px.symbol-2by3 .symbol-label {
    height: 50px;
    width: 75px;
  }
  .symbol.symbol-md-50px.symbol-2by3 > img {
    height: 50px;
    width: 75px;
    max-width: auto;
  }
  .symbol.symbol-md-55px > img {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-md-55px .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-md-55px.symbol-fixed .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-md-55px.symbol-fixed > img {
    width: 55px;
    height: 55px;
    max-width: auto;
  }
  .symbol.symbol-md-55px.symbol-2by3 .symbol-label {
    height: 55px;
    width: 82.5px;
  }
  .symbol.symbol-md-55px.symbol-2by3 > img {
    height: 55px;
    width: 82.5px;
    max-width: auto;
  }
  .symbol.symbol-md-60px > img {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-md-60px .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-md-60px.symbol-fixed .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-md-60px.symbol-fixed > img {
    width: 60px;
    height: 60px;
    max-width: auto;
  }
  .symbol.symbol-md-60px.symbol-2by3 .symbol-label {
    height: 60px;
    width: 90px;
  }
  .symbol.symbol-md-60px.symbol-2by3 > img {
    height: 60px;
    width: 90px;
    max-width: auto;
  }
  .symbol.symbol-md-65px > img {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-md-65px .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-md-65px.symbol-fixed .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-md-65px.symbol-fixed > img {
    width: 65px;
    height: 65px;
    max-width: auto;
  }
  .symbol.symbol-md-65px.symbol-2by3 .symbol-label {
    height: 65px;
    width: 97.5px;
  }
  .symbol.symbol-md-65px.symbol-2by3 > img {
    height: 65px;
    width: 97.5px;
    max-width: auto;
  }
  .symbol.symbol-md-70px > img {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-md-70px .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-md-70px.symbol-fixed .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-md-70px.symbol-fixed > img {
    width: 70px;
    height: 70px;
    max-width: auto;
  }
  .symbol.symbol-md-70px.symbol-2by3 .symbol-label {
    height: 70px;
    width: 105px;
  }
  .symbol.symbol-md-70px.symbol-2by3 > img {
    height: 70px;
    width: 105px;
    max-width: auto;
  }
  .symbol.symbol-md-75px > img {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-md-75px .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-md-75px.symbol-fixed .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-md-75px.symbol-fixed > img {
    width: 75px;
    height: 75px;
    max-width: auto;
  }
  .symbol.symbol-md-75px.symbol-2by3 .symbol-label {
    height: 75px;
    width: 112.5px;
  }
  .symbol.symbol-md-75px.symbol-2by3 > img {
    height: 75px;
    width: 112.5px;
    max-width: auto;
  }
  .symbol.symbol-md-100px > img {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-md-100px .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-md-100px.symbol-fixed .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-md-100px.symbol-fixed > img {
    width: 100px;
    height: 100px;
    max-width: auto;
  }
  .symbol.symbol-md-100px.symbol-2by3 .symbol-label {
    height: 100px;
    width: 150px;
  }
  .symbol.symbol-md-100px.symbol-2by3 > img {
    height: 100px;
    width: 150px;
    max-width: auto;
  }
  .symbol.symbol-md-125px > img {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-md-125px .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-md-125px.symbol-fixed .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-md-125px.symbol-fixed > img {
    width: 125px;
    height: 125px;
    max-width: auto;
  }
  .symbol.symbol-md-125px.symbol-2by3 .symbol-label {
    height: 125px;
    width: 187.5px;
  }
  .symbol.symbol-md-125px.symbol-2by3 > img {
    height: 125px;
    width: 187.5px;
    max-width: auto;
  }
  .symbol.symbol-md-150px > img {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-md-150px .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-md-150px.symbol-fixed .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-md-150px.symbol-fixed > img {
    width: 150px;
    height: 150px;
    max-width: auto;
  }
  .symbol.symbol-md-150px.symbol-2by3 .symbol-label {
    height: 150px;
    width: 225px;
  }
  .symbol.symbol-md-150px.symbol-2by3 > img {
    height: 150px;
    width: 225px;
    max-width: auto;
  }
  .symbol.symbol-md-160px > img {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-md-160px .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-md-160px.symbol-fixed .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-md-160px.symbol-fixed > img {
    width: 160px;
    height: 160px;
    max-width: auto;
  }
  .symbol.symbol-md-160px.symbol-2by3 .symbol-label {
    height: 160px;
    width: 240px;
  }
  .symbol.symbol-md-160px.symbol-2by3 > img {
    height: 160px;
    width: 240px;
    max-width: auto;
  }
  .symbol.symbol-md-175px > img {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-md-175px .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-md-175px.symbol-fixed .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-md-175px.symbol-fixed > img {
    width: 175px;
    height: 175px;
    max-width: auto;
  }
  .symbol.symbol-md-175px.symbol-2by3 .symbol-label {
    height: 175px;
    width: 262.5px;
  }
  .symbol.symbol-md-175px.symbol-2by3 > img {
    height: 175px;
    width: 262.5px;
    max-width: auto;
  }
  .symbol.symbol-md-200px > img {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-md-200px .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-md-200px.symbol-fixed .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-md-200px.symbol-fixed > img {
    width: 200px;
    height: 200px;
    max-width: auto;
  }
  .symbol.symbol-md-200px.symbol-2by3 .symbol-label {
    height: 200px;
    width: 300px;
  }
  .symbol.symbol-md-200px.symbol-2by3 > img {
    height: 200px;
    width: 300px;
    max-width: auto;
  }
}
@media (min-width: 992px) {
  .symbol.symbol-lg-20px > img {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-lg-20px .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-lg-20px.symbol-fixed .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-lg-20px.symbol-fixed > img {
    width: 20px;
    height: 20px;
    max-width: auto;
  }
  .symbol.symbol-lg-20px.symbol-2by3 .symbol-label {
    height: 20px;
    width: 30px;
  }
  .symbol.symbol-lg-20px.symbol-2by3 > img {
    height: 20px;
    width: 30px;
    max-width: auto;
  }
  .symbol.symbol-lg-25px > img {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-lg-25px .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-lg-25px.symbol-fixed .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-lg-25px.symbol-fixed > img {
    width: 25px;
    height: 25px;
    max-width: auto;
  }
  .symbol.symbol-lg-25px.symbol-2by3 .symbol-label {
    height: 25px;
    width: 37.5px;
  }
  .symbol.symbol-lg-25px.symbol-2by3 > img {
    height: 25px;
    width: 37.5px;
    max-width: auto;
  }
  .symbol.symbol-lg-30px > img {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-lg-30px .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-lg-30px.symbol-fixed .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-lg-30px.symbol-fixed > img {
    width: 30px;
    height: 30px;
    max-width: auto;
  }
  .symbol.symbol-lg-30px.symbol-2by3 .symbol-label {
    height: 30px;
    width: 45px;
  }
  .symbol.symbol-lg-30px.symbol-2by3 > img {
    height: 30px;
    width: 45px;
    max-width: auto;
  }
  .symbol.symbol-lg-35px > img {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-lg-35px .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-lg-35px.symbol-fixed .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-lg-35px.symbol-fixed > img {
    width: 35px;
    height: 35px;
    max-width: auto;
  }
  .symbol.symbol-lg-35px.symbol-2by3 .symbol-label {
    height: 35px;
    width: 52.5px;
  }
  .symbol.symbol-lg-35px.symbol-2by3 > img {
    height: 35px;
    width: 52.5px;
    max-width: auto;
  }
  .symbol.symbol-lg-40px > img {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-lg-40px .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-lg-40px.symbol-fixed .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-lg-40px.symbol-fixed > img {
    width: 40px;
    height: 40px;
    max-width: auto;
  }
  .symbol.symbol-lg-40px.symbol-2by3 .symbol-label {
    height: 40px;
    width: 60px;
  }
  .symbol.symbol-lg-40px.symbol-2by3 > img {
    height: 40px;
    width: 60px;
    max-width: auto;
  }
  .symbol.symbol-lg-45px > img {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-lg-45px .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-lg-45px.symbol-fixed .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-lg-45px.symbol-fixed > img {
    width: 45px;
    height: 45px;
    max-width: auto;
  }
  .symbol.symbol-lg-45px.symbol-2by3 .symbol-label {
    height: 45px;
    width: 67.5px;
  }
  .symbol.symbol-lg-45px.symbol-2by3 > img {
    height: 45px;
    width: 67.5px;
    max-width: auto;
  }
  .symbol.symbol-lg-50px > img {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-lg-50px .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-lg-50px.symbol-fixed .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-lg-50px.symbol-fixed > img {
    width: 50px;
    height: 50px;
    max-width: auto;
  }
  .symbol.symbol-lg-50px.symbol-2by3 .symbol-label {
    height: 50px;
    width: 75px;
  }
  .symbol.symbol-lg-50px.symbol-2by3 > img {
    height: 50px;
    width: 75px;
    max-width: auto;
  }
  .symbol.symbol-lg-55px > img {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-lg-55px .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-lg-55px.symbol-fixed .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-lg-55px.symbol-fixed > img {
    width: 55px;
    height: 55px;
    max-width: auto;
  }
  .symbol.symbol-lg-55px.symbol-2by3 .symbol-label {
    height: 55px;
    width: 82.5px;
  }
  .symbol.symbol-lg-55px.symbol-2by3 > img {
    height: 55px;
    width: 82.5px;
    max-width: auto;
  }
  .symbol.symbol-lg-60px > img {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-lg-60px .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-lg-60px.symbol-fixed .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-lg-60px.symbol-fixed > img {
    width: 60px;
    height: 60px;
    max-width: auto;
  }
  .symbol.symbol-lg-60px.symbol-2by3 .symbol-label {
    height: 60px;
    width: 90px;
  }
  .symbol.symbol-lg-60px.symbol-2by3 > img {
    height: 60px;
    width: 90px;
    max-width: auto;
  }
  .symbol.symbol-lg-65px > img {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-lg-65px .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-lg-65px.symbol-fixed .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-lg-65px.symbol-fixed > img {
    width: 65px;
    height: 65px;
    max-width: auto;
  }
  .symbol.symbol-lg-65px.symbol-2by3 .symbol-label {
    height: 65px;
    width: 97.5px;
  }
  .symbol.symbol-lg-65px.symbol-2by3 > img {
    height: 65px;
    width: 97.5px;
    max-width: auto;
  }
  .symbol.symbol-lg-70px > img {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-lg-70px .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-lg-70px.symbol-fixed .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-lg-70px.symbol-fixed > img {
    width: 70px;
    height: 70px;
    max-width: auto;
  }
  .symbol.symbol-lg-70px.symbol-2by3 .symbol-label {
    height: 70px;
    width: 105px;
  }
  .symbol.symbol-lg-70px.symbol-2by3 > img {
    height: 70px;
    width: 105px;
    max-width: auto;
  }
  .symbol.symbol-lg-75px > img {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-lg-75px .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-lg-75px.symbol-fixed .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-lg-75px.symbol-fixed > img {
    width: 75px;
    height: 75px;
    max-width: auto;
  }
  .symbol.symbol-lg-75px.symbol-2by3 .symbol-label {
    height: 75px;
    width: 112.5px;
  }
  .symbol.symbol-lg-75px.symbol-2by3 > img {
    height: 75px;
    width: 112.5px;
    max-width: auto;
  }
  .symbol.symbol-lg-100px > img {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-lg-100px .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-lg-100px.symbol-fixed .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-lg-100px.symbol-fixed > img {
    width: 100px;
    height: 100px;
    max-width: auto;
  }
  .symbol.symbol-lg-100px.symbol-2by3 .symbol-label {
    height: 100px;
    width: 150px;
  }
  .symbol.symbol-lg-100px.symbol-2by3 > img {
    height: 100px;
    width: 150px;
    max-width: auto;
  }
  .symbol.symbol-lg-125px > img {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-lg-125px .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-lg-125px.symbol-fixed .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-lg-125px.symbol-fixed > img {
    width: 125px;
    height: 125px;
    max-width: auto;
  }
  .symbol.symbol-lg-125px.symbol-2by3 .symbol-label {
    height: 125px;
    width: 187.5px;
  }
  .symbol.symbol-lg-125px.symbol-2by3 > img {
    height: 125px;
    width: 187.5px;
    max-width: auto;
  }
  .symbol.symbol-lg-150px > img {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-lg-150px .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-lg-150px.symbol-fixed .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-lg-150px.symbol-fixed > img {
    width: 150px;
    height: 150px;
    max-width: auto;
  }
  .symbol.symbol-lg-150px.symbol-2by3 .symbol-label {
    height: 150px;
    width: 225px;
  }
  .symbol.symbol-lg-150px.symbol-2by3 > img {
    height: 150px;
    width: 225px;
    max-width: auto;
  }
  .symbol.symbol-lg-160px > img {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-lg-160px .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-lg-160px.symbol-fixed .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-lg-160px.symbol-fixed > img {
    width: 160px;
    height: 160px;
    max-width: auto;
  }
  .symbol.symbol-lg-160px.symbol-2by3 .symbol-label {
    height: 160px;
    width: 240px;
  }
  .symbol.symbol-lg-160px.symbol-2by3 > img {
    height: 160px;
    width: 240px;
    max-width: auto;
  }
  .symbol.symbol-lg-175px > img {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-lg-175px .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-lg-175px.symbol-fixed .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-lg-175px.symbol-fixed > img {
    width: 175px;
    height: 175px;
    max-width: auto;
  }
  .symbol.symbol-lg-175px.symbol-2by3 .symbol-label {
    height: 175px;
    width: 262.5px;
  }
  .symbol.symbol-lg-175px.symbol-2by3 > img {
    height: 175px;
    width: 262.5px;
    max-width: auto;
  }
  .symbol.symbol-lg-200px > img {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-lg-200px .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-lg-200px.symbol-fixed .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-lg-200px.symbol-fixed > img {
    width: 200px;
    height: 200px;
    max-width: auto;
  }
  .symbol.symbol-lg-200px.symbol-2by3 .symbol-label {
    height: 200px;
    width: 300px;
  }
  .symbol.symbol-lg-200px.symbol-2by3 > img {
    height: 200px;
    width: 300px;
    max-width: auto;
  }
}
@media (min-width: 1200px) {
  .symbol.symbol-xl-20px > img {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xl-20px .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xl-20px.symbol-fixed .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xl-20px.symbol-fixed > img {
    width: 20px;
    height: 20px;
    max-width: auto;
  }
  .symbol.symbol-xl-20px.symbol-2by3 .symbol-label {
    height: 20px;
    width: 30px;
  }
  .symbol.symbol-xl-20px.symbol-2by3 > img {
    height: 20px;
    width: 30px;
    max-width: auto;
  }
  .symbol.symbol-xl-25px > img {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xl-25px .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xl-25px.symbol-fixed .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xl-25px.symbol-fixed > img {
    width: 25px;
    height: 25px;
    max-width: auto;
  }
  .symbol.symbol-xl-25px.symbol-2by3 .symbol-label {
    height: 25px;
    width: 37.5px;
  }
  .symbol.symbol-xl-25px.symbol-2by3 > img {
    height: 25px;
    width: 37.5px;
    max-width: auto;
  }
  .symbol.symbol-xl-30px > img {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xl-30px .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xl-30px.symbol-fixed .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xl-30px.symbol-fixed > img {
    width: 30px;
    height: 30px;
    max-width: auto;
  }
  .symbol.symbol-xl-30px.symbol-2by3 .symbol-label {
    height: 30px;
    width: 45px;
  }
  .symbol.symbol-xl-30px.symbol-2by3 > img {
    height: 30px;
    width: 45px;
    max-width: auto;
  }
  .symbol.symbol-xl-35px > img {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xl-35px .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xl-35px.symbol-fixed .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xl-35px.symbol-fixed > img {
    width: 35px;
    height: 35px;
    max-width: auto;
  }
  .symbol.symbol-xl-35px.symbol-2by3 .symbol-label {
    height: 35px;
    width: 52.5px;
  }
  .symbol.symbol-xl-35px.symbol-2by3 > img {
    height: 35px;
    width: 52.5px;
    max-width: auto;
  }
  .symbol.symbol-xl-40px > img {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xl-40px .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xl-40px.symbol-fixed .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xl-40px.symbol-fixed > img {
    width: 40px;
    height: 40px;
    max-width: auto;
  }
  .symbol.symbol-xl-40px.symbol-2by3 .symbol-label {
    height: 40px;
    width: 60px;
  }
  .symbol.symbol-xl-40px.symbol-2by3 > img {
    height: 40px;
    width: 60px;
    max-width: auto;
  }
  .symbol.symbol-xl-45px > img {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xl-45px .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xl-45px.symbol-fixed .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xl-45px.symbol-fixed > img {
    width: 45px;
    height: 45px;
    max-width: auto;
  }
  .symbol.symbol-xl-45px.symbol-2by3 .symbol-label {
    height: 45px;
    width: 67.5px;
  }
  .symbol.symbol-xl-45px.symbol-2by3 > img {
    height: 45px;
    width: 67.5px;
    max-width: auto;
  }
  .symbol.symbol-xl-50px > img {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xl-50px .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xl-50px.symbol-fixed .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xl-50px.symbol-fixed > img {
    width: 50px;
    height: 50px;
    max-width: auto;
  }
  .symbol.symbol-xl-50px.symbol-2by3 .symbol-label {
    height: 50px;
    width: 75px;
  }
  .symbol.symbol-xl-50px.symbol-2by3 > img {
    height: 50px;
    width: 75px;
    max-width: auto;
  }
  .symbol.symbol-xl-55px > img {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xl-55px .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xl-55px.symbol-fixed .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xl-55px.symbol-fixed > img {
    width: 55px;
    height: 55px;
    max-width: auto;
  }
  .symbol.symbol-xl-55px.symbol-2by3 .symbol-label {
    height: 55px;
    width: 82.5px;
  }
  .symbol.symbol-xl-55px.symbol-2by3 > img {
    height: 55px;
    width: 82.5px;
    max-width: auto;
  }
  .symbol.symbol-xl-60px > img {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xl-60px .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xl-60px.symbol-fixed .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xl-60px.symbol-fixed > img {
    width: 60px;
    height: 60px;
    max-width: auto;
  }
  .symbol.symbol-xl-60px.symbol-2by3 .symbol-label {
    height: 60px;
    width: 90px;
  }
  .symbol.symbol-xl-60px.symbol-2by3 > img {
    height: 60px;
    width: 90px;
    max-width: auto;
  }
  .symbol.symbol-xl-65px > img {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xl-65px .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xl-65px.symbol-fixed .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xl-65px.symbol-fixed > img {
    width: 65px;
    height: 65px;
    max-width: auto;
  }
  .symbol.symbol-xl-65px.symbol-2by3 .symbol-label {
    height: 65px;
    width: 97.5px;
  }
  .symbol.symbol-xl-65px.symbol-2by3 > img {
    height: 65px;
    width: 97.5px;
    max-width: auto;
  }
  .symbol.symbol-xl-70px > img {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xl-70px .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xl-70px.symbol-fixed .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xl-70px.symbol-fixed > img {
    width: 70px;
    height: 70px;
    max-width: auto;
  }
  .symbol.symbol-xl-70px.symbol-2by3 .symbol-label {
    height: 70px;
    width: 105px;
  }
  .symbol.symbol-xl-70px.symbol-2by3 > img {
    height: 70px;
    width: 105px;
    max-width: auto;
  }
  .symbol.symbol-xl-75px > img {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xl-75px .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xl-75px.symbol-fixed .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xl-75px.symbol-fixed > img {
    width: 75px;
    height: 75px;
    max-width: auto;
  }
  .symbol.symbol-xl-75px.symbol-2by3 .symbol-label {
    height: 75px;
    width: 112.5px;
  }
  .symbol.symbol-xl-75px.symbol-2by3 > img {
    height: 75px;
    width: 112.5px;
    max-width: auto;
  }
  .symbol.symbol-xl-100px > img {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xl-100px .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xl-100px.symbol-fixed .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xl-100px.symbol-fixed > img {
    width: 100px;
    height: 100px;
    max-width: auto;
  }
  .symbol.symbol-xl-100px.symbol-2by3 .symbol-label {
    height: 100px;
    width: 150px;
  }
  .symbol.symbol-xl-100px.symbol-2by3 > img {
    height: 100px;
    width: 150px;
    max-width: auto;
  }
  .symbol.symbol-xl-125px > img {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xl-125px .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xl-125px.symbol-fixed .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xl-125px.symbol-fixed > img {
    width: 125px;
    height: 125px;
    max-width: auto;
  }
  .symbol.symbol-xl-125px.symbol-2by3 .symbol-label {
    height: 125px;
    width: 187.5px;
  }
  .symbol.symbol-xl-125px.symbol-2by3 > img {
    height: 125px;
    width: 187.5px;
    max-width: auto;
  }
  .symbol.symbol-xl-150px > img {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xl-150px .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xl-150px.symbol-fixed .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xl-150px.symbol-fixed > img {
    width: 150px;
    height: 150px;
    max-width: auto;
  }
  .symbol.symbol-xl-150px.symbol-2by3 .symbol-label {
    height: 150px;
    width: 225px;
  }
  .symbol.symbol-xl-150px.symbol-2by3 > img {
    height: 150px;
    width: 225px;
    max-width: auto;
  }
  .symbol.symbol-xl-160px > img {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xl-160px .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xl-160px.symbol-fixed .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xl-160px.symbol-fixed > img {
    width: 160px;
    height: 160px;
    max-width: auto;
  }
  .symbol.symbol-xl-160px.symbol-2by3 .symbol-label {
    height: 160px;
    width: 240px;
  }
  .symbol.symbol-xl-160px.symbol-2by3 > img {
    height: 160px;
    width: 240px;
    max-width: auto;
  }
  .symbol.symbol-xl-175px > img {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xl-175px .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xl-175px.symbol-fixed .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xl-175px.symbol-fixed > img {
    width: 175px;
    height: 175px;
    max-width: auto;
  }
  .symbol.symbol-xl-175px.symbol-2by3 .symbol-label {
    height: 175px;
    width: 262.5px;
  }
  .symbol.symbol-xl-175px.symbol-2by3 > img {
    height: 175px;
    width: 262.5px;
    max-width: auto;
  }
  .symbol.symbol-xl-200px > img {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xl-200px .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xl-200px.symbol-fixed .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xl-200px.symbol-fixed > img {
    width: 200px;
    height: 200px;
    max-width: auto;
  }
  .symbol.symbol-xl-200px.symbol-2by3 .symbol-label {
    height: 200px;
    width: 300px;
  }
  .symbol.symbol-xl-200px.symbol-2by3 > img {
    height: 200px;
    width: 300px;
    max-width: auto;
  }
}
@media (min-width: 1400px) {
  .symbol.symbol-xxl-20px > img {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xxl-20px .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xxl-20px.symbol-fixed .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xxl-20px.symbol-fixed > img {
    width: 20px;
    height: 20px;
    max-width: auto;
  }
  .symbol.symbol-xxl-20px.symbol-2by3 .symbol-label {
    height: 20px;
    width: 30px;
  }
  .symbol.symbol-xxl-20px.symbol-2by3 > img {
    height: 20px;
    width: 30px;
    max-width: auto;
  }
  .symbol.symbol-xxl-25px > img {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xxl-25px .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xxl-25px.symbol-fixed .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xxl-25px.symbol-fixed > img {
    width: 25px;
    height: 25px;
    max-width: auto;
  }
  .symbol.symbol-xxl-25px.symbol-2by3 .symbol-label {
    height: 25px;
    width: 37.5px;
  }
  .symbol.symbol-xxl-25px.symbol-2by3 > img {
    height: 25px;
    width: 37.5px;
    max-width: auto;
  }
  .symbol.symbol-xxl-30px > img {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xxl-30px .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xxl-30px.symbol-fixed .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xxl-30px.symbol-fixed > img {
    width: 30px;
    height: 30px;
    max-width: auto;
  }
  .symbol.symbol-xxl-30px.symbol-2by3 .symbol-label {
    height: 30px;
    width: 45px;
  }
  .symbol.symbol-xxl-30px.symbol-2by3 > img {
    height: 30px;
    width: 45px;
    max-width: auto;
  }
  .symbol.symbol-xxl-35px > img {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xxl-35px .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xxl-35px.symbol-fixed .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xxl-35px.symbol-fixed > img {
    width: 35px;
    height: 35px;
    max-width: auto;
  }
  .symbol.symbol-xxl-35px.symbol-2by3 .symbol-label {
    height: 35px;
    width: 52.5px;
  }
  .symbol.symbol-xxl-35px.symbol-2by3 > img {
    height: 35px;
    width: 52.5px;
    max-width: auto;
  }
  .symbol.symbol-xxl-40px > img {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xxl-40px .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xxl-40px.symbol-fixed .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xxl-40px.symbol-fixed > img {
    width: 40px;
    height: 40px;
    max-width: auto;
  }
  .symbol.symbol-xxl-40px.symbol-2by3 .symbol-label {
    height: 40px;
    width: 60px;
  }
  .symbol.symbol-xxl-40px.symbol-2by3 > img {
    height: 40px;
    width: 60px;
    max-width: auto;
  }
  .symbol.symbol-xxl-45px > img {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xxl-45px .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xxl-45px.symbol-fixed .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xxl-45px.symbol-fixed > img {
    width: 45px;
    height: 45px;
    max-width: auto;
  }
  .symbol.symbol-xxl-45px.symbol-2by3 .symbol-label {
    height: 45px;
    width: 67.5px;
  }
  .symbol.symbol-xxl-45px.symbol-2by3 > img {
    height: 45px;
    width: 67.5px;
    max-width: auto;
  }
  .symbol.symbol-xxl-50px > img {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xxl-50px .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xxl-50px.symbol-fixed .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xxl-50px.symbol-fixed > img {
    width: 50px;
    height: 50px;
    max-width: auto;
  }
  .symbol.symbol-xxl-50px.symbol-2by3 .symbol-label {
    height: 50px;
    width: 75px;
  }
  .symbol.symbol-xxl-50px.symbol-2by3 > img {
    height: 50px;
    width: 75px;
    max-width: auto;
  }
  .symbol.symbol-xxl-55px > img {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xxl-55px .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xxl-55px.symbol-fixed .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xxl-55px.symbol-fixed > img {
    width: 55px;
    height: 55px;
    max-width: auto;
  }
  .symbol.symbol-xxl-55px.symbol-2by3 .symbol-label {
    height: 55px;
    width: 82.5px;
  }
  .symbol.symbol-xxl-55px.symbol-2by3 > img {
    height: 55px;
    width: 82.5px;
    max-width: auto;
  }
  .symbol.symbol-xxl-60px > img {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xxl-60px .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xxl-60px.symbol-fixed .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xxl-60px.symbol-fixed > img {
    width: 60px;
    height: 60px;
    max-width: auto;
  }
  .symbol.symbol-xxl-60px.symbol-2by3 .symbol-label {
    height: 60px;
    width: 90px;
  }
  .symbol.symbol-xxl-60px.symbol-2by3 > img {
    height: 60px;
    width: 90px;
    max-width: auto;
  }
  .symbol.symbol-xxl-65px > img {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xxl-65px .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xxl-65px.symbol-fixed .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xxl-65px.symbol-fixed > img {
    width: 65px;
    height: 65px;
    max-width: auto;
  }
  .symbol.symbol-xxl-65px.symbol-2by3 .symbol-label {
    height: 65px;
    width: 97.5px;
  }
  .symbol.symbol-xxl-65px.symbol-2by3 > img {
    height: 65px;
    width: 97.5px;
    max-width: auto;
  }
  .symbol.symbol-xxl-70px > img {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xxl-70px .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xxl-70px.symbol-fixed .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xxl-70px.symbol-fixed > img {
    width: 70px;
    height: 70px;
    max-width: auto;
  }
  .symbol.symbol-xxl-70px.symbol-2by3 .symbol-label {
    height: 70px;
    width: 105px;
  }
  .symbol.symbol-xxl-70px.symbol-2by3 > img {
    height: 70px;
    width: 105px;
    max-width: auto;
  }
  .symbol.symbol-xxl-75px > img {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xxl-75px .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xxl-75px.symbol-fixed .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xxl-75px.symbol-fixed > img {
    width: 75px;
    height: 75px;
    max-width: auto;
  }
  .symbol.symbol-xxl-75px.symbol-2by3 .symbol-label {
    height: 75px;
    width: 112.5px;
  }
  .symbol.symbol-xxl-75px.symbol-2by3 > img {
    height: 75px;
    width: 112.5px;
    max-width: auto;
  }
  .symbol.symbol-xxl-100px > img {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xxl-100px .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xxl-100px.symbol-fixed .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xxl-100px.symbol-fixed > img {
    width: 100px;
    height: 100px;
    max-width: auto;
  }
  .symbol.symbol-xxl-100px.symbol-2by3 .symbol-label {
    height: 100px;
    width: 150px;
  }
  .symbol.symbol-xxl-100px.symbol-2by3 > img {
    height: 100px;
    width: 150px;
    max-width: auto;
  }
  .symbol.symbol-xxl-125px > img {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xxl-125px .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xxl-125px.symbol-fixed .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xxl-125px.symbol-fixed > img {
    width: 125px;
    height: 125px;
    max-width: auto;
  }
  .symbol.symbol-xxl-125px.symbol-2by3 .symbol-label {
    height: 125px;
    width: 187.5px;
  }
  .symbol.symbol-xxl-125px.symbol-2by3 > img {
    height: 125px;
    width: 187.5px;
    max-width: auto;
  }
  .symbol.symbol-xxl-150px > img {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xxl-150px .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xxl-150px.symbol-fixed .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xxl-150px.symbol-fixed > img {
    width: 150px;
    height: 150px;
    max-width: auto;
  }
  .symbol.symbol-xxl-150px.symbol-2by3 .symbol-label {
    height: 150px;
    width: 225px;
  }
  .symbol.symbol-xxl-150px.symbol-2by3 > img {
    height: 150px;
    width: 225px;
    max-width: auto;
  }
  .symbol.symbol-xxl-160px > img {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xxl-160px .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xxl-160px.symbol-fixed .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xxl-160px.symbol-fixed > img {
    width: 160px;
    height: 160px;
    max-width: auto;
  }
  .symbol.symbol-xxl-160px.symbol-2by3 .symbol-label {
    height: 160px;
    width: 240px;
  }
  .symbol.symbol-xxl-160px.symbol-2by3 > img {
    height: 160px;
    width: 240px;
    max-width: auto;
  }
  .symbol.symbol-xxl-175px > img {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xxl-175px .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xxl-175px.symbol-fixed .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xxl-175px.symbol-fixed > img {
    width: 175px;
    height: 175px;
    max-width: auto;
  }
  .symbol.symbol-xxl-175px.symbol-2by3 .symbol-label {
    height: 175px;
    width: 262.5px;
  }
  .symbol.symbol-xxl-175px.symbol-2by3 > img {
    height: 175px;
    width: 262.5px;
    max-width: auto;
  }
  .symbol.symbol-xxl-200px > img {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xxl-200px .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xxl-200px.symbol-fixed .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xxl-200px.symbol-fixed > img {
    width: 200px;
    height: 200px;
    max-width: auto;
  }
  .symbol.symbol-xxl-200px.symbol-2by3 .symbol-label {
    height: 200px;
    width: 300px;
  }
  .symbol.symbol-xxl-200px.symbol-2by3 > img {
    height: 200px;
    width: 300px;
    max-width: auto;
  }
}

.symbol-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-left: 10px;
}
.symbol-group .symbol {
  position: relative;
  z-index: 0;
  margin-left: -10px;
  border: 2px solid #ffffff;
  transition: all 0.3s ease;
}
.symbol-group .symbol:hover {
  transition: all 0.3s ease;
  z-index: 1;
}
.symbol-group.symbol-hover .symbol {
  cursor: pointer;
}

.pulse {
  position: relative;
}
.pulse.pulse-white .pulse-ring {
  border-color: #ffffff;
}
.pulse.pulse-light .pulse-ring {
  border-color: #F5F8FA;
}
.pulse.pulse-primary .pulse-ring {
  border-color: #009EF7;
}
.pulse.pulse-secondary .pulse-ring {
  border-color: #E4E6EF;
}
.pulse.pulse-success .pulse-ring {
  border-color: #50CD89;
}
.pulse.pulse-info .pulse-ring {
  border-color: #7239EA;
}
.pulse.pulse-warning .pulse-ring {
  border-color: #FFC700;
}
.pulse.pulse-danger .pulse-ring {
  border-color: #F1416C;
}
.pulse.pulse-dark .pulse-ring {
  border-color: #181C32;
}

.pulse-ring {
  display: block;
  border-radius: 40px;
  height: 40px;
  width: 40px;
  position: absolute;
  animation: animation-pulse 3.5s ease-out;
  animation-iteration-count: infinite;
  opacity: 0;
  border-width: 3px;
  border-style: solid;
  border-color: #A1A5B7;
}

@keyframes animation-pulse {
  0% {
    -webkit-transform: scale(0.1, 0.1);
    opacity: 0;
  }
  60% {
    -webkit-transform: scale(0.1, 0.1);
    opacity: 0;
  }
  65% {
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1.2, 1.2);
    opacity: 0;
  }
}
.page-loading * {
  transition: none !important;
}

.page-loader {
  background: #ffffff;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: none;
}
.page-loading .page-loader {
  display: flex;
  justify-content: center;
  align-items: center;
}

.scrolltop {
  position: fixed;
  display: none;
  cursor: pointer;
  z-index: 100;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  bottom: 40px;
  right: 20px;
  background-color: #009EF7;
  box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);
  opacity: 0;
  transition: color 0.2s ease, background-color 0.2s ease;
  border-radius: 0.475rem;
}
.scrolltop .svg-icon svg {
  height: 24px;
  width: 24px;
}
.scrolltop .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.scrolltop .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.scrolltop > i {
  font-size: 1.3rem;
  color: #ffffff;
}
.scrolltop:hover {
  background-color: #009EF7;
}
.scrolltop:hover > i {
  color: #ffffff;
}
.scrolltop:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.scrolltop:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
[data-kt-scrolltop=on] .scrolltop {
  opacity: 0.3;
  animation: animation-scrolltop 0.4s ease-out 1;
  display: flex;
}
[data-kt-scrolltop=on] .scrolltop:hover {
  transition: color 0.2s ease, background-color 0.2s ease;
  opacity: 1;
}
@media (max-width: 991.98px) {
  .scrolltop {
    bottom: 30px;
    right: 15px;
    width: 30px;
    height: 30px;
  }
}

@keyframes animation-scrolltop {
  from {
    margin-bottom: -15px;
  }
  to {
    margin-bottom: 0;
  }
}
.svg-icon {
  line-height: 1;
}
.svg-icon svg {
  height: 1.15rem;
  width: 1.15rem;
}
.svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-white svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.svg-icon.svg-icon-white svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-primary svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.svg-icon.svg-icon-primary svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-secondary svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #E4E6EF;
}
.svg-icon.svg-icon-secondary svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-light svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F5F8FA;
}
.svg-icon.svg-icon-light svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-success svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #50CD89;
}
.svg-icon.svg-icon-success svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-info svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7239EA;
}
.svg-icon.svg-icon-info svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-warning svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFC700;
}
.svg-icon.svg-icon-warning svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-danger svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F1416C;
}
.svg-icon.svg-icon-danger svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-dark svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #181C32;
}
.svg-icon.svg-icon-dark svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-muted svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.svg-icon.svg-icon-muted svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-gray-100 svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F5F8FA;
}
.svg-icon.svg-icon-gray-100 svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-gray-200 svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #EFF2F5;
}
.svg-icon.svg-icon-gray-200 svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-gray-300 svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #E4E6EF;
}
.svg-icon.svg-icon-gray-300 svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-gray-400 svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #B5B5C3;
}
.svg-icon.svg-icon-gray-400 svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-gray-500 svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.svg-icon.svg-icon-gray-500 svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-gray-600 svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7E8299;
}
.svg-icon.svg-icon-gray-600 svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-gray-700 svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #5E6278;
}
.svg-icon.svg-icon-gray-700 svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-gray-800 svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #3F4254;
}
.svg-icon.svg-icon-gray-800 svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-gray-900 svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #181C32;
}
.svg-icon.svg-icon-gray-900 svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-1 svg {
  height: 1.75rem !important;
  width: 1.75rem !important;
}
.svg-icon.svg-icon-2 svg {
  height: 1.5rem !important;
  width: 1.5rem !important;
}
.svg-icon.svg-icon-3 svg {
  height: 1.35rem !important;
  width: 1.35rem !important;
}
.svg-icon.svg-icon-4 svg {
  height: 1.25rem !important;
  width: 1.25rem !important;
}
.svg-icon.svg-icon-5 svg {
  height: 1.15rem !important;
  width: 1.15rem !important;
}
.svg-icon.svg-icon-6 svg {
  height: 1.075rem !important;
  width: 1.075rem !important;
}
.svg-icon.svg-icon-7 svg {
  height: 0.95rem !important;
  width: 0.95rem !important;
}
.svg-icon.svg-icon-8 svg {
  height: 0.85rem !important;
  width: 0.85rem !important;
}
.svg-icon.svg-icon-9 svg {
  height: 0.75rem !important;
  width: 0.75rem !important;
}
.svg-icon.svg-icon-10 svg {
  height: 0.5rem !important;
  width: 0.5rem !important;
}
.svg-icon.svg-icon-base svg {
  height: 1rem !important;
  width: 1rem !important;
}
.svg-icon.svg-icon-fluid svg {
  height: 100% !important;
  width: 100% !important;
}
.svg-icon.svg-icon-2x svg {
  height: 2rem !important;
  width: 2rem !important;
}
.svg-icon.svg-icon-2qx svg {
  height: 2.25rem !important;
  width: 2.25rem !important;
}
.svg-icon.svg-icon-2hx svg {
  height: 2.5rem !important;
  width: 2.5rem !important;
}
.svg-icon.svg-icon-2tx svg {
  height: 2.75rem !important;
  width: 2.75rem !important;
}
.svg-icon.svg-icon-3x svg {
  height: 3rem !important;
  width: 3rem !important;
}
.svg-icon.svg-icon-3qx svg {
  height: 3.25rem !important;
  width: 3.25rem !important;
}
.svg-icon.svg-icon-3hx svg {
  height: 3.5rem !important;
  width: 3.5rem !important;
}
.svg-icon.svg-icon-3tx svg {
  height: 3.75rem !important;
  width: 3.75rem !important;
}
.svg-icon.svg-icon-4x svg {
  height: 4rem !important;
  width: 4rem !important;
}
.svg-icon.svg-icon-4qx svg {
  height: 4.25rem !important;
  width: 4.25rem !important;
}
.svg-icon.svg-icon-4hx svg {
  height: 4.5rem !important;
  width: 4.5rem !important;
}
.svg-icon.svg-icon-4tx svg {
  height: 4.75rem !important;
  width: 4.75rem !important;
}
.svg-icon.svg-icon-5x svg {
  height: 5rem !important;
  width: 5rem !important;
}
.svg-icon.svg-icon-5qx svg {
  height: 5.25rem !important;
  width: 5.25rem !important;
}
.svg-icon.svg-icon-5hx svg {
  height: 5.5rem !important;
  width: 5.5rem !important;
}
.svg-icon.svg-icon-5tx svg {
  height: 5.75rem !important;
  width: 5.75rem !important;
}
@media (min-width: 576px) {
  .svg-icon.svg-icon-sm-1 svg {
    height: 1.75rem !important;
    width: 1.75rem !important;
  }
  .svg-icon.svg-icon-sm-2 svg {
    height: 1.5rem !important;
    width: 1.5rem !important;
  }
  .svg-icon.svg-icon-sm-3 svg {
    height: 1.35rem !important;
    width: 1.35rem !important;
  }
  .svg-icon.svg-icon-sm-4 svg {
    height: 1.25rem !important;
    width: 1.25rem !important;
  }
  .svg-icon.svg-icon-sm-5 svg {
    height: 1.15rem !important;
    width: 1.15rem !important;
  }
  .svg-icon.svg-icon-sm-6 svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-sm-7 svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-sm-8 svg {
    height: 0.85rem !important;
    width: 0.85rem !important;
  }
  .svg-icon.svg-icon-sm-9 svg {
    height: 0.75rem !important;
    width: 0.75rem !important;
  }
  .svg-icon.svg-icon-sm-10 svg {
    height: 0.5rem !important;
    width: 0.5rem !important;
  }
  .svg-icon.svg-icon-sm-base svg {
    height: 1rem !important;
    width: 1rem !important;
  }
  .svg-icon.svg-icon-sm-fluid svg {
    height: 100% !important;
    width: 100% !important;
  }
  .svg-icon.svg-icon-sm-2x svg {
    height: 2rem !important;
    width: 2rem !important;
  }
  .svg-icon.svg-icon-sm-2qx svg {
    height: 2.25rem !important;
    width: 2.25rem !important;
  }
  .svg-icon.svg-icon-sm-2hx svg {
    height: 2.5rem !important;
    width: 2.5rem !important;
  }
  .svg-icon.svg-icon-sm-2tx svg {
    height: 2.75rem !important;
    width: 2.75rem !important;
  }
  .svg-icon.svg-icon-sm-3x svg {
    height: 3rem !important;
    width: 3rem !important;
  }
  .svg-icon.svg-icon-sm-3qx svg {
    height: 3.25rem !important;
    width: 3.25rem !important;
  }
  .svg-icon.svg-icon-sm-3hx svg {
    height: 3.5rem !important;
    width: 3.5rem !important;
  }
  .svg-icon.svg-icon-sm-3tx svg {
    height: 3.75rem !important;
    width: 3.75rem !important;
  }
  .svg-icon.svg-icon-sm-4x svg {
    height: 4rem !important;
    width: 4rem !important;
  }
  .svg-icon.svg-icon-sm-4qx svg {
    height: 4.25rem !important;
    width: 4.25rem !important;
  }
  .svg-icon.svg-icon-sm-4hx svg {
    height: 4.5rem !important;
    width: 4.5rem !important;
  }
  .svg-icon.svg-icon-sm-4tx svg {
    height: 4.75rem !important;
    width: 4.75rem !important;
  }
  .svg-icon.svg-icon-sm-5x svg {
    height: 5rem !important;
    width: 5rem !important;
  }
  .svg-icon.svg-icon-sm-5qx svg {
    height: 5.25rem !important;
    width: 5.25rem !important;
  }
  .svg-icon.svg-icon-sm-5hx svg {
    height: 5.5rem !important;
    width: 5.5rem !important;
  }
  .svg-icon.svg-icon-sm-5tx svg {
    height: 5.75rem !important;
    width: 5.75rem !important;
  }
}
@media (min-width: 768px) {
  .svg-icon.svg-icon-md-1 svg {
    height: 1.75rem !important;
    width: 1.75rem !important;
  }
  .svg-icon.svg-icon-md-2 svg {
    height: 1.5rem !important;
    width: 1.5rem !important;
  }
  .svg-icon.svg-icon-md-3 svg {
    height: 1.35rem !important;
    width: 1.35rem !important;
  }
  .svg-icon.svg-icon-md-4 svg {
    height: 1.25rem !important;
    width: 1.25rem !important;
  }
  .svg-icon.svg-icon-md-5 svg {
    height: 1.15rem !important;
    width: 1.15rem !important;
  }
  .svg-icon.svg-icon-md-6 svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-md-7 svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-md-8 svg {
    height: 0.85rem !important;
    width: 0.85rem !important;
  }
  .svg-icon.svg-icon-md-9 svg {
    height: 0.75rem !important;
    width: 0.75rem !important;
  }
  .svg-icon.svg-icon-md-10 svg {
    height: 0.5rem !important;
    width: 0.5rem !important;
  }
  .svg-icon.svg-icon-md-base svg {
    height: 1rem !important;
    width: 1rem !important;
  }
  .svg-icon.svg-icon-md-fluid svg {
    height: 100% !important;
    width: 100% !important;
  }
  .svg-icon.svg-icon-md-2x svg {
    height: 2rem !important;
    width: 2rem !important;
  }
  .svg-icon.svg-icon-md-2qx svg {
    height: 2.25rem !important;
    width: 2.25rem !important;
  }
  .svg-icon.svg-icon-md-2hx svg {
    height: 2.5rem !important;
    width: 2.5rem !important;
  }
  .svg-icon.svg-icon-md-2tx svg {
    height: 2.75rem !important;
    width: 2.75rem !important;
  }
  .svg-icon.svg-icon-md-3x svg {
    height: 3rem !important;
    width: 3rem !important;
  }
  .svg-icon.svg-icon-md-3qx svg {
    height: 3.25rem !important;
    width: 3.25rem !important;
  }
  .svg-icon.svg-icon-md-3hx svg {
    height: 3.5rem !important;
    width: 3.5rem !important;
  }
  .svg-icon.svg-icon-md-3tx svg {
    height: 3.75rem !important;
    width: 3.75rem !important;
  }
  .svg-icon.svg-icon-md-4x svg {
    height: 4rem !important;
    width: 4rem !important;
  }
  .svg-icon.svg-icon-md-4qx svg {
    height: 4.25rem !important;
    width: 4.25rem !important;
  }
  .svg-icon.svg-icon-md-4hx svg {
    height: 4.5rem !important;
    width: 4.5rem !important;
  }
  .svg-icon.svg-icon-md-4tx svg {
    height: 4.75rem !important;
    width: 4.75rem !important;
  }
  .svg-icon.svg-icon-md-5x svg {
    height: 5rem !important;
    width: 5rem !important;
  }
  .svg-icon.svg-icon-md-5qx svg {
    height: 5.25rem !important;
    width: 5.25rem !important;
  }
  .svg-icon.svg-icon-md-5hx svg {
    height: 5.5rem !important;
    width: 5.5rem !important;
  }
  .svg-icon.svg-icon-md-5tx svg {
    height: 5.75rem !important;
    width: 5.75rem !important;
  }
}
@media (min-width: 992px) {
  .svg-icon.svg-icon-lg-1 svg {
    height: 1.75rem !important;
    width: 1.75rem !important;
  }
  .svg-icon.svg-icon-lg-2 svg {
    height: 1.5rem !important;
    width: 1.5rem !important;
  }
  .svg-icon.svg-icon-lg-3 svg {
    height: 1.35rem !important;
    width: 1.35rem !important;
  }
  .svg-icon.svg-icon-lg-4 svg {
    height: 1.25rem !important;
    width: 1.25rem !important;
  }
  .svg-icon.svg-icon-lg-5 svg {
    height: 1.15rem !important;
    width: 1.15rem !important;
  }
  .svg-icon.svg-icon-lg-6 svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-lg-7 svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-lg-8 svg {
    height: 0.85rem !important;
    width: 0.85rem !important;
  }
  .svg-icon.svg-icon-lg-9 svg {
    height: 0.75rem !important;
    width: 0.75rem !important;
  }
  .svg-icon.svg-icon-lg-10 svg {
    height: 0.5rem !important;
    width: 0.5rem !important;
  }
  .svg-icon.svg-icon-lg-base svg {
    height: 1rem !important;
    width: 1rem !important;
  }
  .svg-icon.svg-icon-lg-fluid svg {
    height: 100% !important;
    width: 100% !important;
  }
  .svg-icon.svg-icon-lg-2x svg {
    height: 2rem !important;
    width: 2rem !important;
  }
  .svg-icon.svg-icon-lg-2qx svg {
    height: 2.25rem !important;
    width: 2.25rem !important;
  }
  .svg-icon.svg-icon-lg-2hx svg {
    height: 2.5rem !important;
    width: 2.5rem !important;
  }
  .svg-icon.svg-icon-lg-2tx svg {
    height: 2.75rem !important;
    width: 2.75rem !important;
  }
  .svg-icon.svg-icon-lg-3x svg {
    height: 3rem !important;
    width: 3rem !important;
  }
  .svg-icon.svg-icon-lg-3qx svg {
    height: 3.25rem !important;
    width: 3.25rem !important;
  }
  .svg-icon.svg-icon-lg-3hx svg {
    height: 3.5rem !important;
    width: 3.5rem !important;
  }
  .svg-icon.svg-icon-lg-3tx svg {
    height: 3.75rem !important;
    width: 3.75rem !important;
  }
  .svg-icon.svg-icon-lg-4x svg {
    height: 4rem !important;
    width: 4rem !important;
  }
  .svg-icon.svg-icon-lg-4qx svg {
    height: 4.25rem !important;
    width: 4.25rem !important;
  }
  .svg-icon.svg-icon-lg-4hx svg {
    height: 4.5rem !important;
    width: 4.5rem !important;
  }
  .svg-icon.svg-icon-lg-4tx svg {
    height: 4.75rem !important;
    width: 4.75rem !important;
  }
  .svg-icon.svg-icon-lg-5x svg {
    height: 5rem !important;
    width: 5rem !important;
  }
  .svg-icon.svg-icon-lg-5qx svg {
    height: 5.25rem !important;
    width: 5.25rem !important;
  }
  .svg-icon.svg-icon-lg-5hx svg {
    height: 5.5rem !important;
    width: 5.5rem !important;
  }
  .svg-icon.svg-icon-lg-5tx svg {
    height: 5.75rem !important;
    width: 5.75rem !important;
  }
}
@media (min-width: 1200px) {
  .svg-icon.svg-icon-xl-1 svg {
    height: 1.75rem !important;
    width: 1.75rem !important;
  }
  .svg-icon.svg-icon-xl-2 svg {
    height: 1.5rem !important;
    width: 1.5rem !important;
  }
  .svg-icon.svg-icon-xl-3 svg {
    height: 1.35rem !important;
    width: 1.35rem !important;
  }
  .svg-icon.svg-icon-xl-4 svg {
    height: 1.25rem !important;
    width: 1.25rem !important;
  }
  .svg-icon.svg-icon-xl-5 svg {
    height: 1.15rem !important;
    width: 1.15rem !important;
  }
  .svg-icon.svg-icon-xl-6 svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-xl-7 svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-xl-8 svg {
    height: 0.85rem !important;
    width: 0.85rem !important;
  }
  .svg-icon.svg-icon-xl-9 svg {
    height: 0.75rem !important;
    width: 0.75rem !important;
  }
  .svg-icon.svg-icon-xl-10 svg {
    height: 0.5rem !important;
    width: 0.5rem !important;
  }
  .svg-icon.svg-icon-xl-base svg {
    height: 1rem !important;
    width: 1rem !important;
  }
  .svg-icon.svg-icon-xl-fluid svg {
    height: 100% !important;
    width: 100% !important;
  }
  .svg-icon.svg-icon-xl-2x svg {
    height: 2rem !important;
    width: 2rem !important;
  }
  .svg-icon.svg-icon-xl-2qx svg {
    height: 2.25rem !important;
    width: 2.25rem !important;
  }
  .svg-icon.svg-icon-xl-2hx svg {
    height: 2.5rem !important;
    width: 2.5rem !important;
  }
  .svg-icon.svg-icon-xl-2tx svg {
    height: 2.75rem !important;
    width: 2.75rem !important;
  }
  .svg-icon.svg-icon-xl-3x svg {
    height: 3rem !important;
    width: 3rem !important;
  }
  .svg-icon.svg-icon-xl-3qx svg {
    height: 3.25rem !important;
    width: 3.25rem !important;
  }
  .svg-icon.svg-icon-xl-3hx svg {
    height: 3.5rem !important;
    width: 3.5rem !important;
  }
  .svg-icon.svg-icon-xl-3tx svg {
    height: 3.75rem !important;
    width: 3.75rem !important;
  }
  .svg-icon.svg-icon-xl-4x svg {
    height: 4rem !important;
    width: 4rem !important;
  }
  .svg-icon.svg-icon-xl-4qx svg {
    height: 4.25rem !important;
    width: 4.25rem !important;
  }
  .svg-icon.svg-icon-xl-4hx svg {
    height: 4.5rem !important;
    width: 4.5rem !important;
  }
  .svg-icon.svg-icon-xl-4tx svg {
    height: 4.75rem !important;
    width: 4.75rem !important;
  }
  .svg-icon.svg-icon-xl-5x svg {
    height: 5rem !important;
    width: 5rem !important;
  }
  .svg-icon.svg-icon-xl-5qx svg {
    height: 5.25rem !important;
    width: 5.25rem !important;
  }
  .svg-icon.svg-icon-xl-5hx svg {
    height: 5.5rem !important;
    width: 5.5rem !important;
  }
  .svg-icon.svg-icon-xl-5tx svg {
    height: 5.75rem !important;
    width: 5.75rem !important;
  }
}
@media (min-width: 1400px) {
  .svg-icon.svg-icon-xxl-1 svg {
    height: 1.75rem !important;
    width: 1.75rem !important;
  }
  .svg-icon.svg-icon-xxl-2 svg {
    height: 1.5rem !important;
    width: 1.5rem !important;
  }
  .svg-icon.svg-icon-xxl-3 svg {
    height: 1.35rem !important;
    width: 1.35rem !important;
  }
  .svg-icon.svg-icon-xxl-4 svg {
    height: 1.25rem !important;
    width: 1.25rem !important;
  }
  .svg-icon.svg-icon-xxl-5 svg {
    height: 1.15rem !important;
    width: 1.15rem !important;
  }
  .svg-icon.svg-icon-xxl-6 svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-xxl-7 svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-xxl-8 svg {
    height: 0.85rem !important;
    width: 0.85rem !important;
  }
  .svg-icon.svg-icon-xxl-9 svg {
    height: 0.75rem !important;
    width: 0.75rem !important;
  }
  .svg-icon.svg-icon-xxl-10 svg {
    height: 0.5rem !important;
    width: 0.5rem !important;
  }
  .svg-icon.svg-icon-xxl-base svg {
    height: 1rem !important;
    width: 1rem !important;
  }
  .svg-icon.svg-icon-xxl-fluid svg {
    height: 100% !important;
    width: 100% !important;
  }
  .svg-icon.svg-icon-xxl-2x svg {
    height: 2rem !important;
    width: 2rem !important;
  }
  .svg-icon.svg-icon-xxl-2qx svg {
    height: 2.25rem !important;
    width: 2.25rem !important;
  }
  .svg-icon.svg-icon-xxl-2hx svg {
    height: 2.5rem !important;
    width: 2.5rem !important;
  }
  .svg-icon.svg-icon-xxl-2tx svg {
    height: 2.75rem !important;
    width: 2.75rem !important;
  }
  .svg-icon.svg-icon-xxl-3x svg {
    height: 3rem !important;
    width: 3rem !important;
  }
  .svg-icon.svg-icon-xxl-3qx svg {
    height: 3.25rem !important;
    width: 3.25rem !important;
  }
  .svg-icon.svg-icon-xxl-3hx svg {
    height: 3.5rem !important;
    width: 3.5rem !important;
  }
  .svg-icon.svg-icon-xxl-3tx svg {
    height: 3.75rem !important;
    width: 3.75rem !important;
  }
  .svg-icon.svg-icon-xxl-4x svg {
    height: 4rem !important;
    width: 4rem !important;
  }
  .svg-icon.svg-icon-xxl-4qx svg {
    height: 4.25rem !important;
    width: 4.25rem !important;
  }
  .svg-icon.svg-icon-xxl-4hx svg {
    height: 4.5rem !important;
    width: 4.5rem !important;
  }
  .svg-icon.svg-icon-xxl-4tx svg {
    height: 4.75rem !important;
    width: 4.75rem !important;
  }
  .svg-icon.svg-icon-xxl-5x svg {
    height: 5rem !important;
    width: 5rem !important;
  }
  .svg-icon.svg-icon-xxl-5qx svg {
    height: 5.25rem !important;
    width: 5.25rem !important;
  }
  .svg-icon.svg-icon-xxl-5hx svg {
    height: 5.5rem !important;
    width: 5.5rem !important;
  }
  .svg-icon.svg-icon-xxl-5tx svg {
    height: 5.75rem !important;
    width: 5.75rem !important;
  }
}

.timeline .timeline-item {
  position: relative;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: flex-start;
}
.timeline .timeline-item:last-child .timeline-line {
  bottom: 100%;
}
.timeline .timeline-line {
  display: block;
  content: " ";
  justify-content: center;
  position: absolute;
  z-index: 0;
  left: 0;
  top: 0;
  bottom: 0;
  transform: translate(50%);
  border-left-width: 1px;
  border-left-style: dashed;
  border-left-color: #E4E6EF;
}
.timeline .timeline-icon {
  z-index: 1;
  flex-shrink: 0;
  margin-right: 1rem;
}
.timeline .timeline-content {
  width: 100%;
  overflow: auto;
  margin-bottom: 1.5rem;
}
.timeline.timeline-center .timeline-item {
  align-items: center;
}
.timeline.timeline-center .timeline-item:first-child .timeline-line {
  top: 50%;
}
.timeline.timeline-center .timeline-item:last-child .timeline-line {
  bottom: 50%;
}

.overlay {
  position: relative;
}
.overlay .overlay-layer {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  opacity: 0;
}
.overlay.overlay-show .overlay-layer, .overlay.overlay-block .overlay-layer, .overlay:hover .overlay-layer {
  transition: all 0.3s ease;
  opacity: 1;
}
.overlay.overlay-block {
  cursor: wait;
}

.bullet {
  display: inline-block;
  background-color: #B5B5C3;
  border-radius: 6px;
  width: 8px;
  height: 4px;
  flex-shrink: 0;
}

.bullet-dot {
  width: 4px;
  height: 4px;
  border-radius: 100% !important;
}

.bullet-vertical {
  width: 4px;
  height: 8px;
}

.bullet-line {
  width: 5px;
  height: 1px;
  border-radius: none;
}

.drawer {
  display: flex !important;
  overflow: auto;
  z-index: 110;
  position: fixed;
  top: 0;
  bottom: 0;
  background-color: #ffffff;
  transition: transform 0.3s ease-in-out;
}
.drawer.drawer-start {
  left: 0;
  transform: translateX(-100%);
}
.drawer.drawer-end {
  right: 0;
  transform: translateX(100%);
}
.drawer.drawer-on {
  transform: none;
  box-shadow: 0px 1px 9px -3px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease-in-out;
}

.drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  z-index: 109;
  background-color: rgba(0, 0, 0, 0.2);
  animation: animation-drawer-fade-in 0.3s ease-in-out 1;
}

[data-kt-drawer=true] {
  display: none;
}

@keyframes animation-drawer-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@media (max-width: 991.98px) {
  body[data-kt-drawer=on] {
    overflow: hidden;
  }
}
.badge.badge-circle, .badge.badge-square {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 1.75rem;
  min-width: 1.75rem;
  padding: 0 0.1rem;
}
.badge.badge-circle {
  border-radius: 50%;
  padding: 0;
  min-width: unset;
  width: 1.75rem;
}
.badge.badge-sm {
  min-width: 1.5rem;
  font-size: 0.85rem;
}
.badge.badge-sm.badge-circle {
  width: 1.5rem;
  height: 1.5rem;
}
.badge.badge-lg {
  min-width: 2rem;
  font-size: 1rem;
}
.badge.badge-lg.badge-circle {
  width: 2rem;
  height: 2rem;
}

.badge-white {
  color: #7E8299;
  background-color: #ffffff;
}

.badge-light-white {
  color: #ffffff;
}

.badge-light {
  color: #7E8299;
  background-color: #F5F8FA;
}

.badge-light-light {
  color: #F5F8FA;
}

.badge-primary {
  color: #FFFFFF;
  background-color: #009EF7;
}

.badge-light-primary {
  color: #009EF7;
  background-color: #F1FAFF;
}

.badge-secondary {
  color: #3F4254;
  background-color: #E4E6EF;
}

.badge-light-secondary {
  color: #E4E6EF;
}

.badge-success {
  color: #FFFFFF;
  background-color: #50CD89;
}

.badge-light-success {
  color: #50CD89;
  background-color: #E8FFF3;
}

.badge-info {
  color: #FFFFFF;
  background-color: #7239EA;
}

.badge-light-info {
  color: #7239EA;
  background-color: #F8F5FF;
}

.badge-warning {
  color: #FFFFFF;
  background-color: #FFC700;
}

.badge-light-warning {
  color: #FFC700;
  background-color: #FFF8DD;
}

.badge-danger {
  color: #FFFFFF;
  background-color: #F1416C;
}

.badge-light-danger {
  color: #F1416C;
  background-color: #FFF5F8;
}

.badge-dark {
  color: #ffffff;
  background-color: #181C32;
}

.badge-light-dark {
  color: #181C32;
  background-color: #EFF2F5;
}

.indicator-progress {
  display: none;
}
[data-kt-indicator=on] > .indicator-progress {
  display: inline-block;
}

[data-kt-indicator=on] > .indicator-label {
  display: none;
}

.rotate {
  display: inline-flex;
  align-items: center;
}

.rotate-90 {
  transition: transform 0.3s ease;
  -webkit-backface-visibility: hidden;
}
.collapsible:not(.collapsed) > .rotate-90, .active > .rotate-90 {
  transform: rotateZ(90deg);
  transition: transform 0.3s ease;
}
[direction=rtl] .collapsible:not(.collapsed) > .rotate-90, [direction=rtl] .active > .rotate-90 {
  transform: rotateZ(-90deg);
}

.rotate-n90 {
  transition: transform 0.3s ease;
  -webkit-backface-visibility: hidden;
}
.collapsible:not(.collapsed) > .rotate-n90, .active > .rotate-n90 {
  transform: rotateZ(-90deg);
  transition: transform 0.3s ease;
}
[direction=rtl] .collapsible:not(.collapsed) > .rotate-n90, [direction=rtl] .active > .rotate-n90 {
  transform: rotateZ(90deg);
}

.rotate-180 {
  transition: transform 0.3s ease;
  -webkit-backface-visibility: hidden;
}
.collapsible:not(.collapsed) > .rotate-180, .active > .rotate-180 {
  transform: rotateZ(180deg);
  transition: transform 0.3s ease;
}
[direction=rtl] .collapsible:not(.collapsed) > .rotate-180, [direction=rtl] .active > .rotate-180 {
  transform: rotateZ(-180deg);
}

.rotate-n180 {
  transition: transform 0.3s ease;
  -webkit-backface-visibility: hidden;
}
.collapsible:not(.collapsed) > .rotate-n180, .active > .rotate-n180 {
  transform: rotateZ(-180deg);
  transition: transform 0.3s ease;
}
[direction=rtl] .collapsible:not(.collapsed) > .rotate-n180, [direction=rtl] .active > .rotate-n180 {
  transform: rotateZ(180deg);
}

.rotate-270 {
  transition: transform 0.3s ease;
  -webkit-backface-visibility: hidden;
}
.collapsible:not(.collapsed) > .rotate-270, .active > .rotate-270 {
  transform: rotateZ(270deg);
  transition: transform 0.3s ease;
}
[direction=rtl] .collapsible:not(.collapsed) > .rotate-270, [direction=rtl] .active > .rotate-270 {
  transform: rotateZ(-270deg);
}

.rotate-n270 {
  transition: transform 0.3s ease;
  -webkit-backface-visibility: hidden;
}
.collapsible:not(.collapsed) > .rotate-n270, .active > .rotate-n270 {
  transform: rotateZ(-270deg);
  transition: transform 0.3s ease;
}
[direction=rtl] .collapsible:not(.collapsed) > .rotate-n270, [direction=rtl] .active > .rotate-n270 {
  transform: rotateZ(270deg);
}

@media (min-width: 992px) {
  main,
span,
ol,
ul,
pre,
div {
    scrollbar-width: thin;
    scrollbar-color: #EFF2F5 transparent;
  }
  main::-webkit-scrollbar,
span::-webkit-scrollbar,
ol::-webkit-scrollbar,
ul::-webkit-scrollbar,
pre::-webkit-scrollbar,
div::-webkit-scrollbar {
    width: 0.4rem;
    height: 0.4rem;
  }
  main::-webkit-scrollbar-thumb,
span::-webkit-scrollbar-thumb,
ol::-webkit-scrollbar-thumb,
ul::-webkit-scrollbar-thumb,
pre::-webkit-scrollbar-thumb,
div::-webkit-scrollbar-thumb {
    background-color: #EFF2F5;
  }
  main:hover,
span:hover,
ol:hover,
ul:hover,
pre:hover,
div:hover {
    scrollbar-color: #e9edf1 transparent;
  }
  main:hover::-webkit-scrollbar-thumb,
span:hover::-webkit-scrollbar-thumb,
ol:hover::-webkit-scrollbar-thumb,
ul:hover::-webkit-scrollbar-thumb,
pre:hover::-webkit-scrollbar-thumb,
div:hover::-webkit-scrollbar-thumb {
    background-color: #e9edf1;
  }
}
.scroll {
  overflow: scroll;
  position: relative;
}
@media (max-width: 991.98px) {
  .scroll {
    overflow: auto;
  }
}

.scroll-x {
  overflow-x: scroll;
  position: relative;
}
@media (max-width: 991.98px) {
  .scroll-x {
    overflow-x: auto;
  }
}

.scroll-y {
  overflow-y: scroll;
  position: relative;
}
@media (max-width: 991.98px) {
  .scroll-y {
    overflow-y: auto;
  }
}

.hover-scroll {
  position: relative;
}
@media (min-width: 992px) {
  .hover-scroll {
    overflow: hidden;
    border-right: 0.4rem solid transparent;
    border-bottom: 0.4rem solid transparent;
    margin-right: -0.4rem;
    margin-bottom: -0.4rem;
  }
  .hover-scroll:hover {
    overflow: scroll;
    border-right: 0;
    border-bottom: 0;
  }
  @-moz-document url-prefix() {
    .hover-scroll {
      overflow: scroll;
      position: relative;
      border-right: 0;
      border-bottom: 0;
    }
  }
}
@media (max-width: 991.98px) {
  .hover-scroll {
    overflow: auto;
  }
}

.hover-scroll-y {
  position: relative;
}
@media (min-width: 992px) {
  .hover-scroll-y {
    overflow-y: hidden;
    border-right: 0.4rem solid transparent;
    margin-right: -0.4rem;
  }
  .hover-scroll-y:hover {
    overflow-y: scroll;
    border-right: 0;
  }
  @-moz-document url-prefix() {
    .hover-scroll-y {
      overflow-y: scroll;
      position: relative;
      border-right: 0;
    }
  }
}
@media (max-width: 991.98px) {
  .hover-scroll-y {
    overflow-y: auto;
  }
}

.hover-scroll-x {
  position: relative;
}
@media (min-width: 992px) {
  .hover-scroll-x {
    overflow-x: hidden;
    border-bottom: 0.4rem solid transparent;
  }
  .hover-scroll-x:hover {
    overflow-x: scroll;
    border-bottom: 0;
  }
  @-moz-document url-prefix() {
    .hover-scroll-x {
      overflow-x: scroll;
      position: relative;
      border-bottom: 0;
    }
  }
}
@media (max-width: 991.98px) {
  .hover-scroll-x {
    overflow-x: auto;
  }
}

.hover-scroll-overlay-y {
  overflow-y: hidden;
  position: relative;
  --scrollbar-space: 0.5rem;
}
.hover-scroll-overlay-y::-webkit-scrollbar {
  width: calc(0.4rem + var(--scrollbar-space));
}
.hover-scroll-overlay-y::-webkit-scrollbar-thumb {
  background-clip: content-box;
  border-right: var(--scrollbar-space) solid transparent;
}
.hover-scroll-overlay-y:hover {
  overflow-y: overlay;
}
@-moz-document url-prefix() {
  .hover-scroll-overlay-y {
    overflow-y: scroll;
    position: relative;
  }
}

.scroll-ps {
  padding-left: 0.4rem !important;
}

.scroll-ms {
  margin-left: 0.4rem !important;
}

.scroll-pe {
  padding-right: 0.4rem !important;
}

.scroll-me {
  margin-right: 0.4rem !important;
}

.scroll-px {
  padding-left: 0.4rem !important;
  padding-right: 0.4rem !important;
}

.scroll-mx {
  margin-left: 0.4rem !important;
  margin-right: 0.4rem !important;
}

.rating {
  display: flex;
  align-items: center;
}

.rating-input {
  position: absolute !important;
  left: -9999px !important;
}
.rating-input[disabled] {
  display: none;
}

.rating-label {
  padding: 0;
  margin: 0;
}
.rating-label > i {
  line-height: 1;
  color: #B5B5C3;
}
.rating-label > .svg-icon {
  line-height: 1;
}
.rating-label > .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #B5B5C3;
}
.rating-label > .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

label.rating-label {
  cursor: pointer;
}

div.rating-label.checked > i,
label.rating-label > i {
  color: #FFAD0F;
}
div.rating-label.checked > .svg-icon svg [fill]:not(.permanent):not(g),
label.rating-label > .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFAD0F;
}
div.rating-label.checked > .svg-icon svg:hover [fill]:not(.permanent):not(g),
label.rating-label > .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.rating-input:checked ~ .rating-label > i {
  color: #B5B5C3;
}

.rating-input:checked ~ .rating-label > .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #B5B5C3;
}
.rating-input:checked ~ .rating-label > .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.rating:hover label.rating-label > i {
  color: #FFAD0F;
}

.rating:hover label.rating-label > .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFAD0F;
}
.rating:hover label.rating-label > .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

label.rating-label:hover ~ .rating-label > i {
  color: #B5B5C3;
}

label.rating-label:hover ~ .rating-label > .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #B5B5C3;
}
label.rating-label:hover ~ .rating-label > .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.stepper [data-kt-stepper-element=info],
.stepper [data-kt-stepper-element=content] {
  display: none;
}
.stepper [data-kt-stepper-element=info].current,
.stepper [data-kt-stepper-element=content].current {
  display: flex;
}
.stepper .stepper-item[data-kt-stepper-action=step] {
  cursor: pointer;
}
.stepper [data-kt-stepper-action=previous] {
  display: none;
}
.stepper [data-kt-stepper-action=next] {
  display: inline-block;
}
.stepper [data-kt-stepper-action=submit] {
  display: none;
}
.stepper.first [data-kt-stepper-action=previous] {
  display: none;
}
.stepper.first [data-kt-stepper-action=next] {
  display: inline-block;
}
.stepper.first [data-kt-stepper-action=submit] {
  display: none;
}
.stepper.between [data-kt-stepper-action=previous] {
  display: inline-block;
}
.stepper.between [data-kt-stepper-action=next] {
  display: inline-block;
}
.stepper.between [data-kt-stepper-action=submit] {
  display: none;
}
.stepper.last [data-kt-stepper-action=previous] {
  display: inline-block;
}
.stepper.last [data-kt-stepper-action=next] {
  display: none;
}
.stepper.last [data-kt-stepper-action=submit] {
  display: inline-block;
}
.stepper.last [data-kt-stepper-action=submit].btn-flex {
  display: flex;
}

.stepper.stepper-pills .stepper-nav {
  display: flex;
}
.stepper.stepper-pills .stepper-item {
  display: flex;
  align-items: center;
  transition: color 0.2s ease, background-color 0.2s ease;
}
.stepper.stepper-pills .stepper-item .stepper-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease, background-color 0.2s ease;
  width: 40px;
  height: 40px;
  border-radius: 0.475rem;
  background-color: #F1FAFF;
  margin-right: 1.5rem;
}
.stepper.stepper-pills .stepper-item .stepper-icon .stepper-check {
  display: none;
  font-size: 1rem;
}
.stepper.stepper-pills .stepper-item .stepper-icon .stepper-number {
  font-weight: 600;
  color: #009EF7 !important;
  font-size: 1.25rem;
}
.stepper.stepper-pills .stepper-item .stepper-label {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.stepper.stepper-pills .stepper-item .stepper-label .stepper-title {
  color: #3F4254;
  font-weight: 600;
  font-size: 1.25rem;
  margin-bottom: 0.3rem;
}
.stepper.stepper-pills .stepper-item .stepper-label .stepper-desc {
  color: #A1A5B7;
}
.stepper.stepper-pills .stepper-item.current {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.stepper.stepper-pills .stepper-item.current .stepper-icon {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: #009EF7;
}
.stepper.stepper-pills .stepper-item.current .stepper-icon .stepper-check {
  color: #009EF7;
  display: none;
}
.stepper.stepper-pills .stepper-item.current .stepper-icon .stepper-number {
  color: #ffffff !important;
  font-size: 1.35rem;
}
.stepper.stepper-pills .stepper-item.current .stepper-label .stepper-title {
  color: #7E8299;
}
.stepper.stepper-pills .stepper-item.current .stepper-label .stepper-desc {
  color: #B5B5C3;
}
.stepper.stepper-pills .stepper-item.current:last-child .stepper-icon, .stepper.stepper-pills .stepper-item.completed .stepper-icon {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: #F1FAFF;
}
.stepper.stepper-pills .stepper-item.current:last-child .stepper-icon .stepper-check, .stepper.stepper-pills .stepper-item.completed .stepper-icon .stepper-check {
  color: #009EF7 !important;
  display: inline-block;
}
.stepper.stepper-pills .stepper-item.current:last-child .stepper-icon .stepper-number, .stepper.stepper-pills .stepper-item.completed .stepper-icon .stepper-number {
  display: none;
}
.stepper.stepper-pills .stepper-item.current:last-child .stepper-label .stepper-title, .stepper.stepper-pills .stepper-item.completed .stepper-label .stepper-title {
  color: #A1A5B7;
}
.stepper.stepper-pills .stepper-item.current:last-child .stepper-label .stepper-desc, .stepper.stepper-pills .stepper-item.completed .stepper-label .stepper-desc {
  color: #B5B5C3;
}
.stepper.stepper-pills.stepper-column .stepper-nav {
  flex-direction: column;
}
.stepper.stepper-pills.stepper-column .stepper-item {
  position: relative;
  padding: 0;
  margin: 0;
  padding-bottom: 2.5rem;
}
.stepper.stepper-pills.stepper-column .stepper-icon {
  z-index: 1;
}
.stepper.stepper-pills.stepper-column .stepper-line {
  display: block;
  content: " ";
  justify-content: center;
  position: absolute;
  z-index: 0;
  left: 0;
  top: 0;
  bottom: 0;
  width: 40px;
  transform: translate(50%);
  border-left-width: 1px;
  border-left-style: dashed;
  border-left-color: #E4E6EF;
}
.stepper.stepper-pills.stepper-column .stepper-item:first-child .stepper-line {
  top: 50%;
}
.stepper.stepper-pills.stepper-column .stepper-item:last-child .stepper-line {
  bottom: 50%;
}

.toggle.collapsible:not(.collapsed) .toggle-off, .toggle.active .toggle-off {
  display: none;
}
.toggle.collapsible.collapsed .toggle-on, .toggle:not(.collapsible):not(.active) .toggle-on {
  display: none;
}

.xehagon {
  clip-path: polygon(45% 1.3397459622%, 46.5797985667% 0.6030737921%, 48.2635182233% 0.1519224699%, 50% 0%, 51.7364817767% 0.1519224699%, 53.4202014333% 0.6030737921%, 55% 1.3397459622%, 89.6410161514% 21.3397459622%, 91.0688922482% 22.3395555688%, 92.3014605826% 23.5721239031%, 93.3012701892% 25%, 94.0379423592% 26.5797985667%, 94.4890936815% 28.2635182233%, 94.6410161514% 30%, 94.6410161514% 70%, 94.4890936815% 71.7364817767%, 94.0379423592% 73.4202014333%, 93.3012701892% 75%, 92.3014605826% 76.4278760969%, 91.0688922482% 77.6604444312%, 89.6410161514% 78.6602540378%, 55% 98.6602540378%, 53.4202014333% 99.3969262079%, 51.7364817767% 99.8480775301%, 50% 100%, 48.2635182233% 99.8480775301%, 46.5797985667% 99.3969262079%, 45% 98.6602540378%, 10.3589838486% 78.6602540378%, 8.9311077518% 77.6604444312%, 7.6985394174% 76.4278760969%, 6.6987298108% 75%, 5.9620576408% 73.4202014333%, 5.5109063185% 71.7364817767%, 5.3589838486% 70%, 5.3589838486% 30%, 5.5109063185% 28.2635182233%, 5.9620576408% 26.5797985667%, 6.6987298108% 25%, 7.6985394174% 23.5721239031%, 8.9311077518% 22.3395555688%, 10.3589838486% 21.3397459622%);
}

.octagon {
  clip-path: polygon(46.1731656763% 0.7612046749%, 47.411809549% 0.3407417371%, 48.6947380778% 0.0855513863%, 50% 0%, 51.3052619222% 0.0855513863%, 52.588190451% 0.3407417371%, 53.8268343237% 0.7612046749%, 82.1111055711% 12.4769334274%, 83.2842712475% 13.0554747147%, 84.3718855375% 13.7821953496%, 85.3553390593% 14.6446609407%, 86.2178046504% 15.6281144625%, 86.9445252853% 16.7157287525%, 87.5230665726% 17.8888944289%, 99.2387953251% 46.1731656763%, 99.6592582629% 47.411809549%, 99.9144486137% 48.6947380778%, 100% 50%, 99.9144486137% 51.3052619222%, 99.6592582629% 52.588190451%, 99.2387953251% 53.8268343237%, 87.5230665726% 82.1111055711%, 86.9445252853% 83.2842712475%, 86.2178046504% 84.3718855375%, 85.3553390593% 85.3553390593%, 84.3718855375% 86.2178046504%, 83.2842712475% 86.9445252853%, 82.1111055711% 87.5230665726%, 53.8268343237% 99.2387953251%, 52.588190451% 99.6592582629%, 51.3052619222% 99.9144486137%, 50% 100%, 48.6947380778% 99.9144486137%, 47.411809549% 99.6592582629%, 46.1731656763% 99.2387953251%, 17.8888944289% 87.5230665726%, 16.7157287525% 86.9445252853%, 15.6281144625% 86.2178046504%, 14.6446609407% 85.3553390593%, 13.7821953496% 84.3718855375%, 13.0554747147% 83.2842712475%, 12.4769334274% 82.1111055711%, 0.7612046749% 53.8268343237%, 0.3407417371% 52.588190451%, 0.0855513863% 51.3052619222%, 0% 50%, 0.0855513863% 48.6947380778%, 0.3407417371% 47.411809549%, 0.7612046749% 46.1731656763%, 12.4769334274% 17.8888944289%, 13.0554747147% 16.7157287525%, 13.7821953496% 15.6281144625%, 14.6446609407% 14.6446609407%, 15.6281144625% 13.7821953496%, 16.7157287525% 13.0554747147%, 17.8888944289% 12.4769334274%);
}

.ribbon {
  position: relative;
}
.ribbon .ribbon-label {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  position: absolute;
  z-index: 1;
  background-color: #009EF7;
  box-shadow: 0px -1px 5px 0px rgba(0, 0, 0, 0.1);
  color: #FFFFFF;
  top: 50%;
  right: 0;
  transform: translateX(5px) translateY(-50%);
}
.ribbon .ribbon-label > .ribbon-inner {
  z-index: -1;
  position: absolute;
  padding: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.ribbon .ribbon-label:after {
  border-color: #003c5e;
}
.ribbon-vertical .ribbon-label {
  padding: 5px 10px;
  min-width: 36px;
  min-height: 46px;
  text-align: center;
}
.ribbon.ribbon-top .ribbon-label {
  top: 0;
  transform: translateX(-15px) translateY(-4px);
  border-bottom-right-radius: 0.475rem;
  border-bottom-left-radius: 0.475rem;
}
.ribbon.ribbon-bottom .ribbon-label {
  border-top-right-radius: 0.475rem;
  border-top-left-radius: 0.475rem;
}
.ribbon.ribbon-start .ribbon-label {
  top: 50%;
  left: 0;
  right: auto;
  transform: translateX(-5px) translateY(-50%);
  border-top-right-radius: 0.475rem;
  border-bottom-right-radius: 0.475rem;
}
.ribbon.ribbon-end .ribbon-label {
  border-top-left-radius: 0.475rem;
  border-bottom-left-radius: 0.475rem;
}

.ribbon.ribbon-clip.ribbon-start .ribbon-label {
  left: -5px;
}
.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner {
  border-top-right-radius: 0.475rem;
  border-bottom-right-radius: 0.475rem;
}
.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:before, .ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:after {
  content: "";
  position: absolute;
  border-style: solid;
  border-color: transparent !important;
  bottom: -10px;
}
.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:before {
  border-width: 0 10px 10px 0;
  border-right-color: #181C32 !important;
  left: 0;
}
.ribbon.ribbon-clip.ribbon-end .ribbon-label {
  right: -5px;
}
.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner {
  border-top-left-radius: 0.475rem;
  border-bottom-left-radius: 0.475rem;
}
.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:before, .ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:after {
  content: "";
  position: absolute;
  border-style: solid;
  border-color: transparent !important;
  bottom: -10px;
}
.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:before {
  border-width: 0 0 10px 10px;
  border-left-color: #181C32 !important;
  right: 0;
}

.ribbon.ribbon-triangle {
  position: absolute;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.ribbon.ribbon-triangle.ribbon-top-start {
  top: 0;
  left: 0;
  width: 4rem;
  height: 4rem;
  border-bottom: solid 2rem transparent !important;
  border-left: solid 2rem red;
  border-right: solid 2rem transparent !important;
  border-top: solid 2rem red;
}
.ribbon.ribbon-triangle.ribbon-top-end {
  top: 0;
  right: 0;
  width: 4rem;
  height: 4rem;
  border-bottom: solid 2rem transparent !important;
  border-left: solid 2rem transparent !important;
  border-right: solid 2rem red;
  border-top: solid 2rem red;
}
.ribbon.ribbon-triangle.ribbon-bottom-start {
  bottom: 0;
  left: 0;
  width: 4rem;
  height: 4rem;
  border-bottom: solid 2rem red;
  border-left: solid 2rem red;
  border-right: solid 2rem transparent !important;
  border-top: solid 2rem transparent !important;
}
.ribbon.ribbon-triangle.ribbon-bottom-end {
  bottom: 0;
  right: 0;
  width: 4rem;
  height: 4rem;
  border-bottom: solid 2rem red;
  border-right: solid 2rem red;
  border-left: solid 2rem transparent !important;
  border-top: solid 2rem transparent !important;
}

.blockui {
  position: relative;
}
.blockui .blockui-overlay {
  transition: all 0.3s ease;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.05);
}
.blockui .blockui-overlay .spinner-border {
  height: 1.35rem;
  width: 1.35rem;
}
.blockui .blockui-message {
  display: flex;
  align-items: center;
  border-radius: 0.475rem;
  box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  background-color: #ffffff;
  color: #7E8299;
  font-weight: 500;
  margin: 0 !important;
  width: auto;
  padding: 0.85rem 1.75rem !important;
}
.blockui .blockui-message .spinner-border {
  margin-right: 0.65rem;
}

.explore-btn-toggle {
  color: #7E8299;
  background-color: #ffffff;
}
.explore-btn-toggle:hover, .explore-btn-toggle:focus, .explore-btn-toggle:active {
  color: #ffffff;
  background-color: #00B2FF;
}

.explore-btn-dismiss {
  border: 0;
}
.explore-btn-dismiss:hover i {
  color: #00B2FF;
}
.explore-btn-dismiss:hover .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #00B2FF;
}
.explore-btn-dismiss:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.explore-btn-primary {
  border: 0;
  color: #ffffff;
  background-color: #00B2FF;
}
.explore-btn-primary:hover {
  color: #ffffff;
  background-color: #0098DA;
}

.explore-btn-secondary {
  border: 0;
  color: #7E8299;
  background-color: #F5F8FA;
}
.explore-btn-secondary:hover {
  color: #3F4254;
  background-color: #EFF2F5;
}

.explore-btn-outline {
  border: 1px dashed #E4E6EF !important;
}
.explore-btn-outline:hover, .explore-btn-outline.active {
  border: 1px dashed #50CD89 !important;
  background-color: #E8FFF3;
}

.explore-link {
  color: #00B2FF;
}
.explore-link:hover {
  color: #0098DA;
}

.explore-link-hover:hover {
  color: #00B2FF !important;
}

.explore-icon-success {
  color: #50CD89;
}
.explore-icon-success svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #50CD89;
}
.explore-icon-success svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.explore-icon-danger {
  color: #F1416C;
}
.explore-icon-danger svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F1416C;
}
.explore-icon-danger svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}

.explore-label-free {
  color: #ffffff;
  background-color: #FFC700;
}

.explore-label-pro {
  color: #ffffff;
  background-color: #50CD89;
}

.cookiealert {
  background: inherit;
  color: inherit;
}

.stepper.stepper-links .stepper-nav {
  display: flex;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.stepper.stepper-links .stepper-nav .stepper-item {
  position: relative;
  flex-shrink: 0;
  margin: 1rem 1.5rem;
}
.stepper.stepper-links .stepper-nav .stepper-item:after {
  content: " ";
  position: absolute;
  top: 2.3rem;
  left: 0;
  height: 2px;
  width: 100%;
  background-color: transparent;
  transition: color 0.2s ease, background-color 0.2s ease;
}
.stepper.stepper-links .stepper-nav .stepper-item .stepper-title {
  color: #181C32;
  font-weight: 600;
  font-size: 1.25rem;
}
.stepper.stepper-links .stepper-nav .stepper-item.current {
  transition: color 0.2s ease, background-color 0.2s ease;
}
.stepper.stepper-links .stepper-nav .stepper-item.current .stepper-title {
  color: #009EF7;
}
.stepper.stepper-links .stepper-nav .stepper-item.current:after {
  background-color: #009EF7;
}
.stepper.stepper-links .stepper-nav .stepper-item.completed .stepper-title {
  color: #B5B5C3;
}

.timeline-label {
  position: relative;
}
.timeline-label:before {
  content: "";
  position: absolute;
  left: 51px;
  width: 3px;
  top: 0;
  bottom: 0;
  background-color: #EFF2F5;
}
.timeline-label .timeline-item {
  display: flex;
  align-items: flex-start;
  position: relative;
  margin-bottom: 1.7rem;
}
.timeline-label .timeline-item:last-child {
  margin-bottom: 0;
}
.timeline-label .timeline-label {
  width: 50px;
  flex-shrink: 0;
  position: relative;
  color: #3F4254;
}
.timeline-label .timeline-badge {
  flex-shrink: 0;
  background: #ffffff;
  width: 1rem;
  height: 1rem;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  position: relative;
  margin-top: 1px;
  margin-left: -0.5rem;
  padding: 3px !important;
  border: 6px solid #ffffff !important;
}
.timeline-label .timeline-badge span {
  display: block;
  border-radius: 100%;
  width: 6px;
  height: 6px;
  background-color: #EFF2F5;
}
.timeline-label .timeline-content {
  flex-grow: 1;
}

.placeholder-white-opacity-75::placeholder {
  color: rgba(255, 255, 255, 0.75);
}
.placeholder-white-opacity-75::-moz-placeholder {
  color: rgba(255, 255, 255, 0.75);
  opacity: 1;
}

.item-border-hover {
  border: 1px solid #fff;
  border-radius: 6px;
}
.item-border-hover:hover {
  border: 1px solid #EFF2F5;
  cursor: pointer;
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: rgba(245, 248, 250, 0.3);
}
.item-border-hover:hover .label {
  background-color: #00A3FF !important;
  transition: color 0.2s ease, background-color 0.2s ease;
  color: #fff;
}
.item-border-hover .label {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
}

.noUi-target.noUi-target-success .noUi-connects {
  background: #E8FFF3;
}
.noUi-target.noUi-target-success .noUi-connects .noUi-connect {
  background: #50CD89;
}
.noUi-target.noUi-target-success .noUi-handle {
  border: 1px solid #50CD89;
  box-shadow: 0 3px 6px -3px rgba(80, 205, 137, 0.7);
  background: #50CD89;
}

.landing-dark-bg {
  background-color: #13263C;
}

.landing-dark-color {
  color: #13263C;
}

.landing-dark-border {
  border: 1px dashed #2C3F5B;
}

.landing-dark-separator {
  border-top: 1px dashed #2C3F5B;
}

.landing-curve {
  position: relative;
}
.landing-curve svg {
  position: relative;
  top: 0;
  display: block;
}

.landing-header {
  display: flex;
  align-items: center;
  height: 100px;
}
.landing-header .logo-default {
  display: block;
}
.landing-header .logo-sticky {
  display: none;
}
.landing-header .menu .menu-link.active {
  color: #ffffff;
}
[data-kt-sticky-landing-header=on] .landing-header .menu .menu-link.active {
  color: #009EF7;
  background-color: rgba(239, 242, 245, 0.4);
}
[data-kt-sticky-landing-header=on] .landing-header {
  padding: 0;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 100;
  background-color: #ffffff;
  box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
  height: 70px;
}
[data-kt-sticky-landing-header=on] .landing-header .logo-sticky {
  display: block;
}
[data-kt-sticky-landing-header=on] .landing-header .logo-default {
  display: none;
}

body[data-kt-sticky-landing-header=on] {
  padding-top: 100px;
}

@media (max-width: 991.98px) {
  .landing-header {
    height: 70px;
  }
  .landing-header .landing-menu-wrapper {
    position: relative;
    overflow: auto;
  }
  [data-kt-sticky-landing-header=on] .landing-header {
    height: 70px;
  }
  .landing-header .menu .menu-link.active {
    color: #009EF7;
    background-color: rgba(239, 242, 245, 0.4);
  }

  body[data-kt-sticky-landing-header=on] {
    padding-top: 70px;
  }
}
html {
  font-family: sans-serif;
  text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

html,
body {
  height: 100%;
  margin: 0px;
  padding: 0px;
  font-size: 13px !important;
  font-weight: 400;
  font-family: Poppins, Helvetica, "sans-serif";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
@media (max-width: 991.98px) {
  html,
body {
    font-size: 13px !important;
  }
}
@media (max-width: 767.98px) {
  html,
body {
    font-size: 12px !important;
  }
}
html a:hover,
html a:active,
html a:focus,
body a:hover,
body a:active,
body a:focus {
  text-decoration: none !important;
}

body {
  display: flex;
  flex-direction: column;
  color: #181C32;
}

router-outlet {
  display: none;
}

canvas {
  -webkit-user-select: none;
          user-select: none;
}

@media print {
  .print-content-only {
    padding: 0 !important;
    background: none !important;
  }
  .print-content-only .wrapper,
.print-content-only .page,
.print-content-only .page-title .content,
.print-content-only .container,
.print-content-only .container-xxl,
.print-content-only .container-fluid,
.print-content-only .container-sm,
.print-content-only .container-md,
.print-content-only .container-lg,
.print-content-only .container-xl {
    background: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  .print-content-only .aside,
.print-content-only .sidebar,
.print-content-only .scrolltop,
.print-content-only .header,
.print-content-only .footer,
.print-content-only .toolbar,
.print-content-only .drawer,
.print-content-only .btn {
    display: none !important;
  }
}
body {
  background-color: #F5F8FA;
}

.text-page-bg {
  color: #F5F8FA;
}

@media (min-width: 992px) {
  .container,
.container-xxl,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl {
    padding: 0 30px;
  }

  .wrapper {
    transition: padding-left 0.3s ease, margin-right 0.3s ease;
  }
  .aside-enabled.aside-fixed .wrapper {
    transition: padding-left 0.3s ease;
    padding-left: 265px;
  }
  .aside-enabled.aside-fixed[data-kt-aside-minimize=on] .wrapper {
    transition: padding-left 0.3s ease;
    padding-left: 75px;
  }
  .header-fixed .wrapper {
    padding-top: 65px;
  }
  .header-fixed.toolbar-fixed .wrapper {
    padding-top: calc(65px + var(--kt-toolbar-height));
  }
}
@media (max-width: 991.98px) {
  .container,
.container-xxl,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl {
    max-width: none;
    padding: 0 15px;
  }

  .header-tablet-and-mobile-fixed .wrapper {
    padding-top: 55px;
  }
  .header-tablet-and-mobile-fixed.toolbar-tablet-and-mobile-fixed .wrapper {
    padding-top: calc(55px + var(--kt-toolbar-height-tablet-and-mobile));
  }
}
@media (min-width: 992px) {
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 2;
    height: 65px;
    transition: left 0.3s ease;
  }
  .header-fixed .header {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 100;
    background-color: #ffffff;
    height: 65px;
    padding: 0;
    box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
  }
  .header-fixed.toolbar-fixed .header {
    box-shadow: none;
  }
  .aside-enabled.aside-fixed.header-fixed .header {
    left: 265px;
    transition: left 0.3s ease;
  }
  .aside-enabled.aside-fixed.header-fixed[data-kt-aside-minimize=on] .header {
    left: 75px;
    transition: left 0.3s ease;
  }
  .header .header-menu {
    display: flex;
  }
}
@media (max-width: 991.98px) {
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 55px;
    position: relative;
    z-index: 3;
  }
  .header-tablet-and-mobile-fixed .header {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 100;
    height: 55px;
    min-height: 55px;
    background-color: #ffffff;
    box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
  }
  .header-tablet-and-mobile-fixed.toolbar-tablet-and-mobile-fixed .header {
    box-shadow: none;
  }
  .header .header-menu {
    display: none;
    z-index: 99;
  }
  .header .page-title {
    display: none !important;
  }
}
.horizontal-scroll-wrapper {
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: 80px;
  max-height: 500px;
  margin: 0;
  background: white;
  overflow-y: auto;
  overflow-x: hidden;
  transform: rotate(-90deg) translateY(-80px);
  transform-origin: right top;
}

.horizontal-scroll-wrapper > div {
  display: block;
  padding: 5px;
  background: white;
  transform: rotate(90deg);
  transform-origin: right top;
}

.squares {
  padding: 60px 0 0 0;
}

.squares > div {
  width: 80px;
  height: 60px;
  margin: 10px;
}

.toolbar {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  padding: 0.5rem 0;
}

@media (min-width: 992px) {
  .toolbar-fixed .toolbar {
    height: var(--kt-toolbar-height);
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 99;
    box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
  }
  .toolbar-enabled:not(.toolbar-fixed) .toolbar {
    margin-bottom: 30px;
  }
  .header-fixed.toolbar-fixed .toolbar {
    padding: 0;
    top: 65px;
    border-top: 1px solid #EFF2F5;
  }
  .aside-enabled.aside-fixed.toolbar-fixed .toolbar {
    left: 265px;
    transition: left 0.3s ease;
  }
  .aside-enabled.aside-fixed.toolbar-fixed[data-kt-aside-minimize=on] .toolbar {
    left: 75px;
    transition: left 0.3s ease;
  }
}
@media (max-width: 991.98px) {
  .toolbar-tablet-and-mobile-fixed .toolbar {
    height: var(--kt-toolbar-height-tablet-and-mobile);
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 99;
    box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
  }
  .toolbar-enabled:not(.toolbar-tablet-and-mobile-fixed) .toolbar {
    margin-bottom: 15px;
  }
  .header-tablet-and-mobile-fixed.toolbar-tablet-and-mobile-fixed .toolbar {
    padding: 0;
    top: 55px;
    border-top: 1px solid #EFF2F5;
  }
  .toolbar .page-title[data-kt-swapper=true] {
    display: none !important;
  }
}
.aside {
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 28px 0 rgba(82, 63, 105, 0.05);
  padding: 0;
}
.aside .btn-custom {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 0;
  padding-right: 0;
}
.aside .btn-custom .btn-label {
  transition: opacity 0.3s ease;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  opacity: 1;
}
.aside .btn-custom .btn-icon {
  display: inline-block;
  transition: opacity 0.3s ease;
  overflow: hidden;
  opacity: 0;
  margin: 0;
  width: 0;
}
.aside.aside-dark {
  background-color: #1e1e2d;
}
.aside.aside-dark .aside-logo {
  background-color: #1a1a27;
}
.aside.aside-dark .aside-toggle svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #494b74;
}
.aside.aside-dark .aside-toggle svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.aside.aside-dark .separator {
  border-bottom-color: #282a3d;
}
.aside.aside-dark .btn-custom {
  color: #B5B5C3;
  background-color: rgba(63, 66, 84, 0.35);
}
.btn-check:checked + .aside.aside-dark .btn-custom, .btn-check:active + .aside.aside-dark .btn-custom, .aside.aside-dark .btn-custom:focus:not(.btn-active), .aside.aside-dark .btn-custom:hover:not(.btn-active), .aside.aside-dark .btn-custom:active:not(.btn-active), .aside.aside-dark .btn-custom.active, .aside.aside-dark .btn-custom.show, .show > .aside.aside-dark .btn-custom {
  color: #B5B5C3;
  background-color: rgba(63, 66, 84, 0.35) !important;
}
.aside.aside-dark .btn-custom .btn-icon {
  color: #B5B5C3;
}
.aside.aside-dark .btn-custom .btn-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #B5B5C3;
}
.aside.aside-dark .btn-custom .btn-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.aside.aside-light {
  background-color: #ffffff;
}

@media (min-width: 992px) {
  .aside {
    width: 265px;
    transition: width 0.3s ease;
  }
  .aside .aside-logo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 65px;
    padding: 0 25px;
  }
  .aside .aside-menu {
    width: 265px;
  }
  .aside-fixed .aside {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 101;
    overflow: hidden;
  }
  .aside-static .aside {
    position: relative;
    z-index: 1;
  }
  [data-kt-aside-minimize=on] .aside {
    width: 75px;
    transition: width 0.3s ease;
  }
  [data-kt-aside-minimize=on] .aside .aside-logo .logo-default {
    display: inline-block;
  }
  [data-kt-aside-minimize=on] .aside .aside-logo .logo-minimize {
    display: none;
  }
  [data-kt-aside-minimize=on] .aside.aside-hoverable:hover:not(.animating) {
    transition: width 0.3s ease;
    width: 265px;
    box-shadow: 5px 0px 10px rgba(70, 78, 95, 0.075);
  }
  [data-kt-aside-minimize=on] .aside:not(.aside-hoverable) .aside-logo, [data-kt-aside-minimize=on] .aside:not(:hover) .aside-logo {
    justify-content: center;
  }
  [data-kt-aside-minimize=on] .aside:not(.aside-hoverable) .aside-logo .logo, [data-kt-aside-minimize=on] .aside:not(:hover) .aside-logo .logo {
    display: none;
  }
  [data-kt-aside-minimize=on] .aside:not(.aside-hoverable) .aside-logo .logo-default, [data-kt-aside-minimize=on] .aside:not(:hover) .aside-logo .logo-default {
    display: none;
  }
  [data-kt-aside-minimize=on] .aside:not(.aside-hoverable) .aside-logo .logo-minimize, [data-kt-aside-minimize=on] .aside:not(:hover) .aside-logo .logo-minimize {
    display: inline-block;
  }
  [data-kt-aside-minimize=on] .aside:not(.aside-hoverable) .aside-menu .menu-content,
[data-kt-aside-minimize=on] .aside:not(.aside-hoverable) .aside-menu .menu-title, [data-kt-aside-minimize=on] .aside:not(:hover) .aside-menu .menu-content,
[data-kt-aside-minimize=on] .aside:not(:hover) .aside-menu .menu-title {
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  [data-kt-aside-minimize=on] .aside:not(.aside-hoverable) .aside-menu .menu-item.show > .menu-sub, [data-kt-aside-minimize=on] .aside:not(:hover) .aside-menu .menu-item.show > .menu-sub {
    height: 0;
    overflow: hidden;
    transition: height 0.3s ease;
  }
  [data-kt-aside-minimize=on] .aside:not(.aside-hoverable) .btn-custom .btn-label, [data-kt-aside-minimize=on] .aside:not(:hover) .btn-custom .btn-label {
    width: 0;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  [data-kt-aside-minimize=on] .aside:not(.aside-hoverable) .btn-custom .btn-icon, [data-kt-aside-minimize=on] .aside:not(:hover) .btn-custom .btn-icon {
    width: auto;
    opacity: 1;
    transition: opacity 0.3s ease;
  }
}
@media (max-width: 991.98px) {
  .aside {
    display: none;
  }
  .aside .aside-logo {
    display: none;
  }
}
.aside-menu .menu .menu-item .menu-link,
.aside-menu .menu .menu-item .menu-content {
  padding-left: 25px;
  padding-right: 25px;
}
.aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: calc(0.75rem + 25px);
}
.aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: calc(1.5rem + 25px);
}
.aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: calc(2.25rem + 25px);
}
.aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: calc(3rem + 25px);
}
.menu-fit .aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-fit .aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: 0.75rem;
  padding-right: 0;
}
.menu-fit .aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-fit .aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: calc(1.5rem);
  padding-right: 0;
}
.menu-fit .aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-fit .aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: calc(2.25rem);
  padding-right: 0;
}
.menu-fit .aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-fit .aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: calc(3rem);
  padding-right: 0;
}
.aside-menu .menu-item {
  padding: 0;
}
.aside-menu .menu-item .menu-link {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.aside-menu .menu-item .menu-icon {
  justify-content: flex-start;
}

.aside-dark .hover-scroll-overlay-y {
  --scrollbar-space: 0.4rem;
  scrollbar-color: #3b3b64 transparent;
}
.aside-dark .hover-scroll-overlay-y::-webkit-scrollbar-thumb {
  background-color: #3b3b64;
}
.aside-dark .hover-scroll-overlay-y:hover {
  scrollbar-color: #41416e transparent;
}
.aside-dark .hover-scroll-overlay-y:hover::-webkit-scrollbar-thumb {
  background-color: #41416e;
}
.aside-dark .menu .menu-item .menu-section {
  color: #b2b3c2 !important;
}
.aside-dark .menu .menu-item .menu-link {
  color: #9899ac;
}
.aside-dark .menu .menu-item .menu-link .menu-title {
  color: #9899ac;
}
.aside-dark .menu .menu-item .menu-link .menu-icon i {
  color: #494b74;
}
.aside-dark .menu .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #494b74;
}
.aside-dark .menu .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.aside-dark .menu .menu-item .menu-link .menu-bullet .bullet {
  background-color: #9899ac;
}
.aside-dark .menu .menu-item .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
  /*rtl:end:remove*/
}
.aside-dark .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .aside-dark .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: #1b1b28;
  color: #ffffff;
}
.aside-dark .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .aside-dark .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: #ffffff;
}
.aside-dark .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .aside-dark .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: #009EF7;
}
.aside-dark .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g), .aside-dark .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.aside-dark .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g), .aside-dark .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.aside-dark .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .aside-dark .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: #009EF7;
}
.aside-dark .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .aside-dark .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  /*rtl:end:remove*/
}
.aside-dark .menu .menu-item.here > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: #1b1b28;
  color: #ffffff;
}
.aside-dark .menu .menu-item.here > .menu-link .menu-title {
  color: #ffffff;
}
.aside-dark .menu .menu-item.here > .menu-link .menu-icon i {
  color: #009EF7;
}
.aside-dark .menu .menu-item.here > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.aside-dark .menu .menu-item.here > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.aside-dark .menu .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: #009EF7;
}
.aside-dark .menu .menu-item.here > .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  /*rtl:end:remove*/
}
.aside-dark .menu .menu-item.show > .menu-link {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: #1b1b28;
  color: #ffffff;
}
.aside-dark .menu .menu-item.show > .menu-link .menu-title {
  color: #ffffff;
}
.aside-dark .menu .menu-item.show > .menu-link .menu-icon i {
  color: #009EF7;
}
.aside-dark .menu .menu-item.show > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.aside-dark .menu .menu-item.show > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.aside-dark .menu .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: #009EF7;
}
.aside-dark .menu .menu-item.show > .menu-link .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  /*rtl:end:remove*/
}
.aside-dark .menu .menu-item .menu-link.active {
  transition: color 0.2s ease, background-color 0.2s ease;
  background-color: #1b1b28;
  color: #ffffff;
}
.aside-dark .menu .menu-item .menu-link.active .menu-title {
  color: #ffffff;
}
.aside-dark .menu .menu-item .menu-link.active .menu-icon i {
  color: #009EF7;
}
.aside-dark .menu .menu-item .menu-link.active .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.aside-dark .menu .menu-item .menu-link.active .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.aside-dark .menu .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: #009EF7;
}
.aside-dark .menu .menu-item .menu-link.active .menu-arrow:after {
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  /*rtl:begin:remove*/
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  /*rtl:end:remove*/
}

.aside-light .menu .menu-title {
  font-weight: 500;
}

@media (min-width: 992px) {
  .content {
    padding: 30px 0;
  }
  .toolbar-enabled:not(.toolbar-fixed) .content {
    padding-top: 0;
  }
}
@media (max-width: 991.98px) {
  .content {
    padding: 15px 0;
  }
  .toolbar-enabled:not(.toolbar-tablet-and-mobile-fixed) .content {
    padding-top: 0;
  }
}
.footer {
  background-color: #ffffff;
}

@media print {
  .print-content-only {
    padding: 0 !important;
    background: none !important;
  }
  .print-content-only .docs-wrapper,
.print-content-only .docs-page,
.print-content-only .docs-page-title .docs-content,
.print-content-only .container,
.print-content-only .container-fluid,
.print-content-only .container-sm,
.print-content-only .container-md,
.print-content-only .container-lg,
.print-content-only .container-xl,
.print-content-only .container-xxl {
    background: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  .print-content-only .docs-aside, .print-content-only docs- .scrolltop,
.print-content-only .docs-header,
.print-content-only .drawer,
.print-content-only .btn {
    display: none !important;
  }
}
.docs-wrapper {
  background-color: #F5F8FA;
}

@media (min-width: 992px) {
  .container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl,
.container-xxl {
    padding: 0 30px;
  }

  .docs-wrapper {
    padding-left: 265px;
  }
}
@media (max-width: 991.98px) {
  .container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl,
.container-xxl {
    max-width: none;
    padding: 0 15px;
  }
}
@media (min-width: 992px) {
  .docs-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
@media (max-width: 991.98px) {
  .docs-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .docs-header .docs-page-title[data-kt-swapper=true] {
    display: none !important;
  }
}
.docs-aside {
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 28px 0 rgba(82, 63, 105, 0.025);
  background-color: #ffffff;
  padding: 0;
}

@media (min-width: 992px) {
  .docs-aside {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 101;
    overflow: hidden;
    width: 265px;
  }
  .docs-aside .docs-aside-logo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 25px;
  }
  .docs-aside .docs-aside-menu {
    width: 265px;
  }
}
@media (max-width: 991.98px) {
  .docs-aside {
    display: none;
  }
  .docs-aside .docs-aside-logo {
    display: none;
  }
}
.docs-aside-menu .menu .menu-item .menu-link,
.docs-aside-menu .menu .menu-item .menu-content {
  padding-left: 25px;
  padding-right: 25px;
}
.docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: calc(0.75rem + 25px);
}
.docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: calc(1.5rem + 25px);
}
.docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: calc(2.25rem + 25px);
}
.docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: calc(3rem + 25px);
}
.menu-fit .docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-fit .docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: 0.75rem;
  padding-right: 0;
}
.menu-fit .docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-fit .docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: calc(1.5rem);
  padding-right: 0;
}
.menu-fit .docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-fit .docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: calc(2.25rem);
  padding-right: 0;
}
.menu-fit .docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-fit .docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {
  padding-left: calc(3rem);
  padding-right: 0;
}
.docs-aside-menu .menu-item {
  padding: 0;
}
.docs-aside-menu .menu-item .menu-link {
  font-weight: 500;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.docs-aside-menu .menu-item .menu-icon {
  justify-content: flex-start;
}

.card.card-docs {
  background-color: #ffffff;
  border: 0;
}`, "",{"version":3,"sources":["webpack://./src/_metronic/assets/sass/style.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/_metronic/assets/sass/_init.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./src/_metronic/assets/sass/core/components/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/mixins/_box-shadow.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./src/_metronic/assets/sass/components/_variables.custom.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./src/_metronic/assets/sass/core/components/_root.scss","webpack://./src/_metronic/assets/sass/core/components/helpers/_background.scss","webpack://./src/_metronic/assets/sass/core/components/helpers/_borders.scss","webpack://./src/_metronic/assets/sass/core/components/helpers/_flex.scss","webpack://./src/_metronic/assets/sass/core/components/helpers/_shadow.scss","webpack://./src/_metronic/assets/sass/core/components/helpers/_text.scss","webpack://./src/_metronic/assets/sass/core/components/mixins/_svg-icon.scss","webpack://./src/_metronic/assets/sass/core/components/helpers/_opacity.scss","webpack://./src/_metronic/assets/sass/core/components/helpers/_transform.scss","webpack://./src/_metronic/assets/sass/core/components/_animation.scss","webpack://./src/_metronic/assets/sass/core/components/_nav.scss","webpack://./src/_metronic/assets/sass/core/components/_nav-pills-custom.scss","webpack://./src/_metronic/assets/sass/core/components/_pagination.scss","webpack://./src/_metronic/assets/sass/core/components/mixins/_svg-bg-icon.scss","webpack://./src/_metronic/assets/sass/core/components/_separator.scss","webpack://./src/_metronic/assets/sass/core/components/_carousel.scss","webpack://./src/_metronic/assets/sass/core/components/menu/_base.scss","webpack://./src/_metronic/assets/sass/core/components/mixins/_menu.scss","webpack://./src/_metronic/assets/sass/core/base/mixins/_breakpoints.scss","webpack://./src/_metronic/assets/sass/core/components/menu/_theme.scss","webpack://./src/_metronic/assets/sass/core/components/_anchor.scss","webpack://./src/_metronic/assets/sass/core/components/_card.scss","webpack://./src/_metronic/assets/sass/core/components/_breadcrumb.scss","webpack://./src/_metronic/assets/sass/core/components/buttons/_base.scss","webpack://./src/_metronic/assets/sass/core/base/mixins/_reset.scss","webpack://./src/_metronic/assets/sass/core/components/buttons/_theme.scss","webpack://./src/_metronic/assets/sass/core/components/mixins/_buttons.scss","webpack://./src/_metronic/assets/sass/core/components/_code.scss","webpack://./src/_metronic/assets/sass/core/components/forms/_form-control.scss","webpack://./src/_metronic/assets/sass/core/base/mixins/_placeholder.scss","webpack://./src/_metronic/assets/sass/core/components/forms/_form-select.scss","webpack://./src/_metronic/assets/sass/core/components/forms/_form-check.scss","webpack://./src/_metronic/assets/sass/core/components/forms/_input-group.scss","webpack://./src/_metronic/assets/sass/core/components/forms/_required.scss","webpack://./src/_metronic/assets/sass/core/components/_modal.scss","webpack://./src/_metronic/assets/sass/core/components/_progress.scss","webpack://./src/_metronic/assets/sass/core/components/_tables.scss","webpack://./src/_metronic/assets/sass/core/components/_popover.scss","webpack://./src/_metronic/assets/sass/core/components/mixins/_popover.scss","webpack://./src/_metronic/assets/sass/core/components/_tooltip.scss","webpack://./src/_metronic/assets/sass/core/components/mixins/_tooltip.scss","webpack://./src/_metronic/assets/sass/core/components/_accordion.scss","webpack://./src/_metronic/assets/sass/core/components/_feedback.scss","webpack://./src/_metronic/assets/sass/core/components/_image-input.scss","webpack://./src/_metronic/assets/sass/core/components/_symbol.scss","webpack://./src/_metronic/assets/sass/core/components/mixins/_symbol.scss","webpack://./src/_metronic/assets/sass/core/components/_pulse.scss","webpack://./src/_metronic/assets/sass/core/components/_page-loader.scss","webpack://./src/_metronic/assets/sass/core/components/_scrolltop.scss","webpack://./src/_metronic/assets/sass/core/components/_svg-icon.scss","webpack://./src/_metronic/assets/sass/core/components/_timeline.scss","webpack://./src/_metronic/assets/sass/core/components/_overlay.scss","webpack://./src/_metronic/assets/sass/core/components/_bullet.scss","webpack://./src/_metronic/assets/sass/core/components/_drawer.scss","webpack://./src/_metronic/assets/sass/core/components/_badge.scss","webpack://./src/_metronic/assets/sass/core/components/_indicator.scss","webpack://./src/_metronic/assets/sass/core/components/_rotate.scss","webpack://./src/_metronic/assets/sass/core/components/_scroll.scss","webpack://./src/_metronic/assets/sass/core/components/mixins/_scroll.scss","webpack://./src/_metronic/assets/sass/core/components/_rating.scss","webpack://./src/_metronic/assets/sass/core/components/stepper/_base.scss","webpack://./src/_metronic/assets/sass/core/components/stepper/_pills.scss","webpack://./src/_metronic/assets/sass/core/components/_toggle.scss","webpack://./src/_metronic/assets/sass/core/components/_shape.scss","webpack://./src/_metronic/assets/sass/core/components/mixins/_shape.scss","webpack://./src/_metronic/assets/sass/core/components/_ribbon.scss","webpack://./src/_metronic/assets/sass/core/components/_blockui.scss","webpack://./src/_metronic/assets/sass/core/components/_explore.scss","webpack://./src/_metronic/assets/sass/core/components/_cookiealert.scss","webpack://./src/_metronic/assets/sass/components/_stepper-links.scss","webpack://./src/_metronic/assets/sass/components/_timeline-label.scss","webpack://./src/_metronic/assets/sass/components/_placeholder-custom.scss","webpack://./src/_metronic/assets/sass/components/_item-hover-custom.scss","webpack://./src/_metronic/assets/sass/components/_nouislider-custom.scss","webpack://./src/_metronic/assets/sass/components/_landing.scss","webpack://./src/_metronic/assets/sass/core/layout/_base.scss","webpack://./src/_metronic/assets/sass/layout/_print.scss","webpack://./src/_metronic/assets/sass/layout/_main.scss","webpack://./src/_metronic/assets/sass/layout/_variables.scss","webpack://./src/_metronic/assets/sass/layout/_header.scss","webpack://./src/_metronic/assets/sass/layout/_toolbar.scss","webpack://./src/_metronic/assets/sass/layout/aside/_base.scss","webpack://./src/_metronic/assets/sass/layout/aside/_menu.scss","webpack://./src/_metronic/assets/sass/layout/_content.scss","webpack://./src/_metronic/assets/sass/layout/_footer.scss","webpack://./src/_metronic/assets/sass/core/layout/docs/_print.scss","webpack://./src/_metronic/assets/sass/core/layout/docs/_main.scss","webpack://./src/_metronic/assets/sass/core/layout/docs/_variables.scss","webpack://./src/_metronic/assets/sass/core/layout/docs/_header.scss","webpack://./src/_metronic/assets/sass/core/layout/docs/_aside.scss","webpack://./src/_metronic/assets/sass/core/layout/docs/_menu.scss","webpack://./src/_metronic/assets/sass/core/layout/docs/_content.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACEd;EACE,cAAA;EACA,WAAA;EACA,WAAA;ADAJ;;AEHE;EACE,yBAAA;EACA,+EAAA;AFMJ;;AERE;EACE,yBAAA;EACA,+EAAA;AFWJ;;AEbE;EACE,yBAAA;EACA,iFAAA;AFgBJ;;AElBE;EACE,yBAAA;EACA,mFAAA;AFqBJ;;AEvBE;EACE,yBAAA;EACA,iFAAA;AF0BJ;;AE5BE;EACE,yBAAA;EACA,8EAAA;AF+BJ;;AEjCE;EACE,yBAAA;EACA,iFAAA;AFoCJ;;AEtCE;EACE,yBAAA;EACA,gFAAA;AFyCJ;;AE3CE;EACE,yBAAA;EACA,8EAAA;AF8CJ;;AGhDE;EACE,sEAAA;EACA,gGAAA;AHmDJ;AGhDM;EAGE,gEAAA;EACA,0FAAA;AHgDR;;AGzDE;EACE,sEAAA;EACA,gGAAA;AH4DJ;AGzDM;EAGE,gEAAA;EACA,0FAAA;AHyDR;;AGlEE;EACE,wEAAA;EACA,kGAAA;AHqEJ;AGlEM;EAGE,+DAAA;EACA,yFAAA;AHkER;;AG3EE;EACE,0EAAA;EACA,oGAAA;AH8EJ;AG3EM;EAGE,gEAAA;EACA,0FAAA;AH2ER;;AGpFE;EACE,wEAAA;EACA,kGAAA;AHuFJ;AGpFM;EAGE,gEAAA;EACA,0FAAA;AHoFR;;AG7FE;EACE,qEAAA;EACA,+FAAA;AHgGJ;AG7FM;EAGE,8DAAA;EACA,wFAAA;AH6FR;;AGtGE;EACE,wEAAA;EACA,kGAAA;AHyGJ;AGtGM;EAGE,+DAAA;EACA,yFAAA;AHsGR;;AG/GE;EACE,uEAAA;EACA,iGAAA;AHkHJ;AG/GM;EAGE,gEAAA;EACA,0FAAA;AH+GR;;AGxHE;EACE,qEAAA;EACA,+FAAA;AH2HJ;AGxHM;EAGE,6DAAA;EACA,uFAAA;AHwHR;;AGjHA;EACE,+EAAA;EACA,yGAAA;AHoHF;AGjHI;EAEE,kFAAA;EACA,4GAAA;AHkHN;;AI5IA;EACE,UAAA;EAEA,kJAAA;AJ8IF;;AKjJA;EACE,oBAAA;EACA,aC6c4B;ED5c5B,mBAAA;EACA,kFAAA;EACA,6BC2c4B;ED1c5B,2BAAA;ALoJF;AKlJE;EACE,cAAA;EACA,UCuc0B;EDtc1B,WCsc0B;EDrc1B,kBAAA;EEIE,sCFHF;ALoJJ;AO7IM;EFZJ;IEaM,gBAAA;EPgJN;AACF;;AKlJI;EACE,mEAAA;ALqJN;;AQxKA;EACE,kBAAA;EACA,WAAA;AR2KF;AQzKE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AR2KJ;AQxKE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AR0KJ;;AQrKE;EACE,uBAAA;ARwKJ;;AQzKE;EACE,qCAAA;AR4KJ;;AQ7KE;EACE,sCAAA;ARgLJ;;AQjLE;EACE,sCAAA;ARoLJ;;ASzMA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,aHumCkC;AN35BpC;;ASzMA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aH+lCkC;ANn5BpC;;ASpMI;EACE,gBAAA;EACA,MAAA;EACA,aHmlC8B;AN54BpC;;ASpMI;EACE,gBAAA;EACA,SAAA;EACA,aH6kC8B;ANt4BpC;;AUxKI;EDxCA;IACE,gBAAA;IACA,MAAA;IACA,aHmlC8B;EN/3BlC;;ESjNE;IACE,gBAAA;IACA,SAAA;IACA,aH6kC8B;ENz3BlC;AACF;AUtLI;EDxCA;IACE,gBAAA;IACA,MAAA;IACA,aHmlC8B;ENl3BlC;;ES9NE;IACE,gBAAA;IACA,SAAA;IACA,aH6kC8B;EN52BlC;AACF;AUnMI;EDxCA;IACE,gBAAA;IACA,MAAA;IACA,aHmlC8B;ENr2BlC;;ES3OE;IACE,gBAAA;IACA,SAAA;IACA,aH6kC8B;EN/1BlC;AACF;AUhNI;EDxCA;IACE,gBAAA;IACA,MAAA;IACA,aHmlC8B;ENx1BlC;;ESxPE;IACE,gBAAA;IACA,SAAA;IACA,aH6kC8B;ENl1BlC;AACF;AU7NI;EDxCA;IACE,gBAAA;IACA,MAAA;IACA,aHmlC8B;EN30BlC;;ESrQE;IACE,gBAAA;IACA,SAAA;IACA,aH6kC8B;ENr0BlC;AACF;AWxSA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AX0SF;;AWvSA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AX0SF;;AYlTA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AbmTF;AahTE;;EACE,6BAAA;AbmTJ;Aa/SE;;EACE,2BAAA;AbkTJ;;AcrUE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,URgcsC;EQ/btC,WAAA;AdwUJ;;AehVA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AhBoVF;;AiB1VA;EACE,qBAAA;EACA,mBAAA;EACA,6BXisB4B;EWhsB5B,eAAA;EACA,8BAAA;EACA,aX2rB4B;AN9V9B;;AkBjSQ;EAOI,mCAAA;AlB8RZ;;AkBrSQ;EAOI,8BAAA;AlBkSZ;;AkBzSQ;EAOI,iCAAA;AlBsSZ;;AkB7SQ;EAOI,iCAAA;AlB0SZ;;AkBjTQ;EAOI,sCAAA;AlB8SZ;;AkBrTQ;EAOI,mCAAA;AlBkTZ;;AkBzTQ;EAOI,sBAAA;AlBsTZ;;AkB7TQ;EAOI,uBAAA;AlB0TZ;;AkBjUQ;EAOI,sBAAA;AlB8TZ;;AkBrUQ;EAOI,8BAAA;AlBkUZ;;AkBzUQ;EAOI,4BAAA;AlBsUZ;;AkB7UQ;EAOI,2BAAA;AlB0UZ;;AkBjVQ;EAOI,iCAAA;AlB8UZ;;AkBrVQ;EAOI,2BAAA;AlBkVZ;;AkBzVQ;EAOI,qBAAA;AlBsVZ;;AkB7VQ;EAOI,wBAAA;AlB0VZ;;AkBjWQ;EAOI,uBAAA;AlB8VZ;;AkBrWQ;EAOI,wBAAA;AlBkWZ;;AkBzWQ;EAOI,qBAAA;AlBsWZ;;AkB7WQ;EAOI,yBAAA;AlB0WZ;;AkBjXQ;EAOI,2BAAA;AlB8WZ;;AkBrXQ;EAOI,4BAAA;AlBkXZ;;AkBzXQ;EAOI,2BAAA;AlBsXZ;;AkB7XQ;EAOI,2BAAA;AlB0XZ;;AkBjYQ;EAOI,6BAAA;AlB8XZ;;AkBrYQ;EAOI,8BAAA;AlBkYZ;;AkBzYQ;EAOI,6BAAA;AlBsYZ;;AkB7YQ;EAOI,2BAAA;AlB0YZ;;AkBjZQ;EAOI,6BAAA;AlB8YZ;;AkBrZQ;EAOI,8BAAA;AlBkZZ;;AkBzZQ;EAOI,6BAAA;AlBsZZ;;AkB7ZQ;EAOI,0BAAA;AlB0ZZ;;AkBjaQ;EAOI,gCAAA;AlB8ZZ;;AkBraQ;EAOI,yBAAA;AlBkaZ;;AkBzaQ;EAOI,wBAAA;AlBsaZ;;AkB7aQ;EAOI,+BAAA;AlB0aZ;;AkBjbQ;EAOI,yBAAA;AlB8aZ;;AkBrbQ;EAOI,6BAAA;AlBkbZ;;AkBzbQ;EAOI,8BAAA;AlBsbZ;;AkB7bQ;EAOI,wBAAA;AlB0bZ;;AkBjcQ;EAOI,+BAAA;AlB8bZ;;AkBrcQ;EAOI,wBAAA;AlBkcZ;;AkBzcQ;EAOI,2CAAA;AlBscZ;;AkB7cQ;EAOI,8CAAA;AlB0cZ;;AkBjdQ;EAOI,8CAAA;AlB8cZ;;AkBrdQ;EAOI,2BAAA;AlBkdZ;;AkBneQ;EACE,8EAAA;AlBseV;;AkBveQ;EACE,8EAAA;AlB0eV;;AkB3eQ;EACE,gFAAA;AlB8eV;;AkB/eQ;EACE,kFAAA;AlBkfV;;AkBnfQ;EACE,gFAAA;AlBsfV;;AkBvfQ;EACE,6EAAA;AlB0fV;;AkB3fQ;EACE,gFAAA;AlB8fV;;AkB/fQ;EACE,+EAAA;AlBkgBV;;AkBngBQ;EACE,6EAAA;AlBsgBV;;AkB7fQ;EAOI,2BAAA;AlB0fZ;;AkBjgBQ;EAOI,6BAAA;AlB8fZ;;AkBrgBQ;EAOI,6BAAA;AlBkgBZ;;AkBzgBQ;EAOI,0BAAA;AlBsgBZ;;AkB7gBQ;EAOI,2BAAA;AlB0gBZ;;AkBjhBQ;EAOI,iBAAA;AlB8gBZ;;AkBrhBQ;EAOI,mBAAA;AlBkhBZ;;AkBzhBQ;EAOI,mBAAA;AlBshBZ;;AkB7hBQ;EAOI,mBAAA;AlB0hBZ;;AkBjiBQ;EAOI,oBAAA;AlB8hBZ;;AkBriBQ;EAOI,oBAAA;AlBkiBZ;;AkBziBQ;EAOI,sBAAA;AlBsiBZ;;AkB7iBQ;EAOI,sBAAA;AlB0iBZ;;AkBjjBQ;EAOI,sBAAA;AlB8iBZ;;AkBrjBQ;EAOI,uBAAA;AlBkjBZ;;AkBzjBQ;EAOI,kBAAA;AlBsjBZ;;AkB7jBQ;EAOI,oBAAA;AlB0jBZ;;AkBjkBQ;EAOI,oBAAA;AlB8jBZ;;AkBrkBQ;EAOI,oBAAA;AlBkkBZ;;AkBzkBQ;EAOI,qBAAA;AlBskBZ;;AkB7kBQ;EAOI,mBAAA;AlB0kBZ;;AkBjlBQ;EAOI,qBAAA;AlB8kBZ;;AkBrlBQ;EAOI,qBAAA;AlBklBZ;;AkBzlBQ;EAOI,qBAAA;AlBslBZ;;AkB7lBQ;EAOI,sBAAA;AlB0lBZ;;AkBjmBQ;EAOI,2CAAA;AlB8lBZ;;AkBrmBQ;EAOI,sCAAA;AlBkmBZ;;AkBzmBQ;EAOI,sCAAA;AlBsmBZ;;AkB7mBQ;EAOI,uFAAA;AlB0mBZ;;AkBjnBQ;EAOI,oBAAA;AlB8mBZ;;AkBrnBQ;EAOI,2FAAA;AlBknBZ;;AkBznBQ;EAOI,wBAAA;AlBsnBZ;;AkB7nBQ;EAOI,6FAAA;AlB0nBZ;;AkBjoBQ;EAOI,0BAAA;AlB8nBZ;;AkBroBQ;EAOI,8FAAA;AlBkoBZ;;AkBzoBQ;EAOI,2BAAA;AlBsoBZ;;AkB7oBQ;EAOI,4FAAA;AlB0oBZ;;AkBjpBQ;EAOI,yBAAA;AlB8oBZ;;AkBrpBQ;EAIQ,sBAAA;EAGJ,4EAAA;AlBmpBZ;;AkB1pBQ;EAIQ,sBAAA;EAGJ,4EAAA;AlBwpBZ;;AkB/pBQ;EAIQ,sBAAA;EAGJ,8EAAA;AlB6pBZ;;AkBpqBQ;EAIQ,sBAAA;EAGJ,gFAAA;AlBkqBZ;;AkBzqBQ;EAIQ,sBAAA;EAGJ,8EAAA;AlBuqBZ;;AkB9qBQ;EAIQ,sBAAA;EAGJ,2EAAA;AlB4qBZ;;AkBnrBQ;EAIQ,sBAAA;EAGJ,8EAAA;AlBirBZ;;AkBxrBQ;EAIQ,sBAAA;EAGJ,6EAAA;AlBsrBZ;;AkB7rBQ;EAIQ,sBAAA;EAGJ,2EAAA;AlB2rBZ;;AkBlsBQ;EAIQ,sBAAA;EAGJ,4EAAA;AlBgsBZ;;AkBvsBQ;EAOI,wDAAA;AlBosBZ;;AkB3sBQ;EAOI,0DAAA;AlBwsBZ;;AkB/sBQ;EAOI,wDAAA;AlB4sBZ;;AkBntBQ;EAOI,qDAAA;AlBgtBZ;;AkBvtBQ;EAOI,wDAAA;AlBotBZ;;AkB3tBQ;EAOI,uDAAA;AlBwtBZ;;AkB/tBQ;EAOI,sDAAA;AlB4tBZ;;AkBnuBQ;EAOI,qDAAA;AlBguBZ;;AkBvuBQ;EAOI,0BAAA;AlBouBZ;;AkB3uBQ;EAOI,4BAAA;AlBwuBZ;;AkB/uBQ;EAOI,4BAAA;AlB4uBZ;;AkBnvBQ;EAOI,4BAAA;AlBgvBZ;;AkBvvBQ;EAOI,4BAAA;AlBovBZ;;AkB3vBQ;EAOI,4BAAA;AlBwvBZ;;AkBzwBQ;EACE,wBAAA;AlB4wBV;;AkB7wBQ;EACE,yBAAA;AlBgxBV;;AkBjxBQ;EACE,wBAAA;AlBoxBV;;AkBrxBQ;EACE,yBAAA;AlBwxBV;;AkBzxBQ;EACE,sBAAA;AlB4xBV;;AkBnxBQ;EAOI,qBAAA;AlBgxBZ;;AkBvxBQ;EAOI,qBAAA;AlBoxBZ;;AkB3xBQ;EAOI,qBAAA;AlBwxBZ;;AkB/xBQ;EAOI,sBAAA;AlB4xBZ;;AkBnyBQ;EAOI,sBAAA;AlBgyBZ;;AkBvyBQ;EAOI,0BAAA;AlBoyBZ;;AkB3yBQ;EAOI,uBAAA;AlBwyBZ;;AkB/yBQ;EAOI,2BAAA;AlB4yBZ;;AkBnzBQ;EAOI,sBAAA;AlBgzBZ;;AkBvzBQ;EAOI,sBAAA;AlBozBZ;;AkB3zBQ;EAOI,sBAAA;AlBwzBZ;;AkB/zBQ;EAOI,uBAAA;AlB4zBZ;;AkBn0BQ;EAOI,uBAAA;AlBg0BZ;;AkBv0BQ;EAOI,2BAAA;AlBo0BZ;;AkB30BQ;EAOI,wBAAA;AlBw0BZ;;AkB/0BQ;EAOI,4BAAA;AlB40BZ;;AkBn1BQ;EAOI,yBAAA;AlBg1BZ;;AkBv1BQ;EAOI,8BAAA;AlBo1BZ;;AkB31BQ;EAOI,iCAAA;AlBw1BZ;;AkB/1BQ;EAOI,sCAAA;AlB41BZ;;AkBn2BQ;EAOI,yCAAA;AlBg2BZ;;AkBv2BQ;EAOI,uBAAA;AlBo2BZ;;AkB32BQ;EAOI,uBAAA;AlBw2BZ;;AkB/2BQ;EAOI,yBAAA;AlB42BZ;;AkBn3BQ;EAOI,yBAAA;AlBg3BZ;;AkBv3BQ;EAOI,0BAAA;AlBo3BZ;;AkB33BQ;EAOI,4BAAA;AlBw3BZ;;AkB/3BQ;EAOI,kCAAA;AlB43BZ;;AkBn4BQ;EAOI,sCAAA;AlBg4BZ;;AkBv4BQ;EAOI,oCAAA;AlBo4BZ;;AkB34BQ;EAOI,kCAAA;AlBw4BZ;;AkB/4BQ;EAOI,yCAAA;AlB44BZ;;AkBn5BQ;EAOI,wCAAA;AlBg5BZ;;AkBv5BQ;EAOI,wCAAA;AlBo5BZ;;AkB35BQ;EAOI,kCAAA;AlBw5BZ;;AkB/5BQ;EAOI,gCAAA;AlB45BZ;;AkBn6BQ;EAOI,8BAAA;AlBg6BZ;;AkBv6BQ;EAOI,gCAAA;AlBo6BZ;;AkB36BQ;EAOI,+BAAA;AlBw6BZ;;AkB/6BQ;EAOI,oCAAA;AlB46BZ;;AkBn7BQ;EAOI,kCAAA;AlBg7BZ;;AkBv7BQ;EAOI,gCAAA;AlBo7BZ;;AkB37BQ;EAOI,uCAAA;AlBw7BZ;;AkB/7BQ;EAOI,sCAAA;AlB47BZ;;AkBn8BQ;EAOI,iCAAA;AlBg8BZ;;AkBv8BQ;EAOI,2BAAA;AlBo8BZ;;AkB38BQ;EAOI,iCAAA;AlBw8BZ;;AkB/8BQ;EAOI,+BAAA;AlB48BZ;;AkBn9BQ;EAOI,6BAAA;AlBg9BZ;;AkBv9BQ;EAOI,+BAAA;AlBo9BZ;;AkB39BQ;EAOI,8BAAA;AlBw9BZ;;AkB/9BQ;EAOI,oBAAA;AlB49BZ;;AkBn+BQ;EAOI,mBAAA;AlBg+BZ;;AkBv+BQ;EAOI,mBAAA;AlBo+BZ;;AkB3+BQ;EAOI,mBAAA;AlBw+BZ;;AkB/+BQ;EAOI,mBAAA;AlB4+BZ;;AkBn/BQ;EAOI,mBAAA;AlBg/BZ;;AkBv/BQ;EAOI,mBAAA;AlBo/BZ;;AkB3/BQ;EAOI,mBAAA;AlBw/BZ;;AkB//BQ;EAOI,oBAAA;AlB4/BZ;;AkBngCQ;EAOI,0BAAA;AlBggCZ;;AkBvgCQ;EAOI,yBAAA;AlBogCZ;;AkB3gCQ;EAOI,0BAAA;AlBwgCZ;;AkB/gCQ;EAOI,uBAAA;AlB4gCZ;;AkBnhCQ;EAOI,0BAAA;AlBghCZ;;AkBvhCQ;EAOI,yBAAA;AlBohCZ;;AkB3hCQ;EAOI,0BAAA;AlBwhCZ;;AkB/hCQ;EAOI,uBAAA;AlB4hCZ;;AkBniCQ;EAOI,0BAAA;AlBgiCZ;;AkBviCQ;EAOI,yBAAA;AlBoiCZ;;AkB3iCQ;EAOI,0BAAA;AlBwiCZ;;AkB/iCQ;EAOI,uBAAA;AlB4iCZ;;AkBnjCQ;EAOI,0BAAA;AlBgjCZ;;AkBvjCQ;EAOI,yBAAA;AlBojCZ;;AkB3jCQ;EAOI,0BAAA;AlBwjCZ;;AkB/jCQ;EAOI,uBAAA;AlB4jCZ;;AkBnkCQ;EAOI,0BAAA;AlBgkCZ;;AkBvkCQ;EAOI,yBAAA;AlBokCZ;;AkB3kCQ;EAOI,0BAAA;AlBwkCZ;;AkB/kCQ;EAOI,uBAAA;AlB4kCZ;;AkBnlCQ;EAOI,uBAAA;AlBglCZ;;AkBvlCQ;EAOI,0BAAA;EAAA,yBAAA;AlBqlCZ;;AkB5lCQ;EAOI,gCAAA;EAAA,+BAAA;AlB0lCZ;;AkBjmCQ;EAOI,+BAAA;EAAA,8BAAA;AlB+lCZ;;AkBtmCQ;EAOI,gCAAA;EAAA,+BAAA;AlBomCZ;;AkB3mCQ;EAOI,6BAAA;EAAA,4BAAA;AlBymCZ;;AkBhnCQ;EAOI,gCAAA;EAAA,+BAAA;AlB8mCZ;;AkBrnCQ;EAOI,+BAAA;EAAA,8BAAA;AlBmnCZ;;AkB1nCQ;EAOI,gCAAA;EAAA,+BAAA;AlBwnCZ;;AkB/nCQ;EAOI,6BAAA;EAAA,4BAAA;AlB6nCZ;;AkBpoCQ;EAOI,gCAAA;EAAA,+BAAA;AlBkoCZ;;AkBzoCQ;EAOI,+BAAA;EAAA,8BAAA;AlBuoCZ;;AkB9oCQ;EAOI,gCAAA;EAAA,+BAAA;AlB4oCZ;;AkBnpCQ;EAOI,6BAAA;EAAA,4BAAA;AlBipCZ;;AkBxpCQ;EAOI,gCAAA;EAAA,+BAAA;AlBspCZ;;AkB7pCQ;EAOI,+BAAA;EAAA,8BAAA;AlB2pCZ;;AkBlqCQ;EAOI,gCAAA;EAAA,+BAAA;AlBgqCZ;;AkBvqCQ;EAOI,6BAAA;EAAA,4BAAA;AlBqqCZ;;AkB5qCQ;EAOI,gCAAA;EAAA,+BAAA;AlB0qCZ;;AkBjrCQ;EAOI,+BAAA;EAAA,8BAAA;AlB+qCZ;;AkBtrCQ;EAOI,gCAAA;EAAA,+BAAA;AlBorCZ;;AkB3rCQ;EAOI,6BAAA;EAAA,4BAAA;AlByrCZ;;AkBhsCQ;EAOI,6BAAA;EAAA,4BAAA;AlB8rCZ;;AkBrsCQ;EAOI,wBAAA;EAAA,2BAAA;AlBmsCZ;;AkB1sCQ;EAOI,8BAAA;EAAA,iCAAA;AlBwsCZ;;AkB/sCQ;EAOI,6BAAA;EAAA,gCAAA;AlB6sCZ;;AkBptCQ;EAOI,8BAAA;EAAA,iCAAA;AlBktCZ;;AkBztCQ;EAOI,2BAAA;EAAA,8BAAA;AlButCZ;;AkB9tCQ;EAOI,8BAAA;EAAA,iCAAA;AlB4tCZ;;AkBnuCQ;EAOI,6BAAA;EAAA,gCAAA;AlBiuCZ;;AkBxuCQ;EAOI,8BAAA;EAAA,iCAAA;AlBsuCZ;;AkB7uCQ;EAOI,2BAAA;EAAA,8BAAA;AlB2uCZ;;AkBlvCQ;EAOI,8BAAA;EAAA,iCAAA;AlBgvCZ;;AkBvvCQ;EAOI,6BAAA;EAAA,gCAAA;AlBqvCZ;;AkB5vCQ;EAOI,8BAAA;EAAA,iCAAA;AlB0vCZ;;AkBjwCQ;EAOI,2BAAA;EAAA,8BAAA;AlB+vCZ;;AkBtwCQ;EAOI,8BAAA;EAAA,iCAAA;AlBowCZ;;AkB3wCQ;EAOI,6BAAA;EAAA,gCAAA;AlBywCZ;;AkBhxCQ;EAOI,8BAAA;EAAA,iCAAA;AlB8wCZ;;AkBrxCQ;EAOI,2BAAA;EAAA,8BAAA;AlBmxCZ;;AkB1xCQ;EAOI,8BAAA;EAAA,iCAAA;AlBwxCZ;;AkB/xCQ;EAOI,6BAAA;EAAA,gCAAA;AlB6xCZ;;AkBpyCQ;EAOI,8BAAA;EAAA,iCAAA;AlBkyCZ;;AkBzyCQ;EAOI,2BAAA;EAAA,8BAAA;AlBuyCZ;;AkB9yCQ;EAOI,2BAAA;EAAA,8BAAA;AlB4yCZ;;AkBnzCQ;EAOI,wBAAA;AlBgzCZ;;AkBvzCQ;EAOI,8BAAA;AlBozCZ;;AkB3zCQ;EAOI,6BAAA;AlBwzCZ;;AkB/zCQ;EAOI,8BAAA;AlB4zCZ;;AkBn0CQ;EAOI,2BAAA;AlBg0CZ;;AkBv0CQ;EAOI,8BAAA;AlBo0CZ;;AkB30CQ;EAOI,6BAAA;AlBw0CZ;;AkB/0CQ;EAOI,8BAAA;AlB40CZ;;AkBn1CQ;EAOI,2BAAA;AlBg1CZ;;AkBv1CQ;EAOI,8BAAA;AlBo1CZ;;AkB31CQ;EAOI,6BAAA;AlBw1CZ;;AkB/1CQ;EAOI,8BAAA;AlB41CZ;;AkBn2CQ;EAOI,2BAAA;AlBg2CZ;;AkBv2CQ;EAOI,8BAAA;AlBo2CZ;;AkB32CQ;EAOI,6BAAA;AlBw2CZ;;AkB/2CQ;EAOI,8BAAA;AlB42CZ;;AkBn3CQ;EAOI,2BAAA;AlBg3CZ;;AkBv3CQ;EAOI,8BAAA;AlBo3CZ;;AkB33CQ;EAOI,6BAAA;AlBw3CZ;;AkB/3CQ;EAOI,8BAAA;AlB43CZ;;AkBn4CQ;EAOI,2BAAA;AlBg4CZ;;AkBv4CQ;EAOI,2BAAA;AlBo4CZ;;AkB34CQ;EAOI,0BAAA;AlBw4CZ;;AkB/4CQ;EAOI,gCAAA;AlB44CZ;;AkBn5CQ;EAOI,+BAAA;AlBg5CZ;;AkBv5CQ;EAOI,gCAAA;AlBo5CZ;;AkB35CQ;EAOI,6BAAA;AlBw5CZ;;AkB/5CQ;EAOI,gCAAA;AlB45CZ;;AkBn6CQ;EAOI,+BAAA;AlBg6CZ;;AkBv6CQ;EAOI,gCAAA;AlBo6CZ;;AkB36CQ;EAOI,6BAAA;AlBw6CZ;;AkB/6CQ;EAOI,gCAAA;AlB46CZ;;AkBn7CQ;EAOI,+BAAA;AlBg7CZ;;AkBv7CQ;EAOI,gCAAA;AlBo7CZ;;AkB37CQ;EAOI,6BAAA;AlBw7CZ;;AkB/7CQ;EAOI,gCAAA;AlB47CZ;;AkBn8CQ;EAOI,+BAAA;AlBg8CZ;;AkBv8CQ;EAOI,gCAAA;AlBo8CZ;;AkB38CQ;EAOI,6BAAA;AlBw8CZ;;AkB/8CQ;EAOI,gCAAA;AlB48CZ;;AkBn9CQ;EAOI,+BAAA;AlBg9CZ;;AkBv9CQ;EAOI,gCAAA;AlBo9CZ;;AkB39CQ;EAOI,6BAAA;AlBw9CZ;;AkB/9CQ;EAOI,6BAAA;AlB49CZ;;AkBn+CQ;EAOI,2BAAA;AlBg+CZ;;AkBv+CQ;EAOI,iCAAA;AlBo+CZ;;AkB3+CQ;EAOI,gCAAA;AlBw+CZ;;AkB/+CQ;EAOI,iCAAA;AlB4+CZ;;AkBn/CQ;EAOI,8BAAA;AlBg/CZ;;AkBv/CQ;EAOI,iCAAA;AlBo/CZ;;AkB3/CQ;EAOI,gCAAA;AlBw/CZ;;AkB//CQ;EAOI,iCAAA;AlB4/CZ;;AkBngDQ;EAOI,8BAAA;AlBggDZ;;AkBvgDQ;EAOI,iCAAA;AlBogDZ;;AkB3gDQ;EAOI,gCAAA;AlBwgDZ;;AkB/gDQ;EAOI,iCAAA;AlB4gDZ;;AkBnhDQ;EAOI,8BAAA;AlBghDZ;;AkBvhDQ;EAOI,iCAAA;AlBohDZ;;AkB3hDQ;EAOI,gCAAA;AlBwhDZ;;AkB/hDQ;EAOI,iCAAA;AlB4hDZ;;AkBniDQ;EAOI,8BAAA;AlBgiDZ;;AkBviDQ;EAOI,iCAAA;AlBoiDZ;;AkB3iDQ;EAOI,gCAAA;AlBwiDZ;;AkB/iDQ;EAOI,iCAAA;AlB4iDZ;;AkBnjDQ;EAOI,8BAAA;AlBgjDZ;;AkBvjDQ;EAOI,8BAAA;AlBojDZ;;AkB3jDQ;EAOI,yBAAA;AlBwjDZ;;AkB/jDQ;EAOI,+BAAA;AlB4jDZ;;AkBnkDQ;EAOI,8BAAA;AlBgkDZ;;AkBvkDQ;EAOI,+BAAA;AlBokDZ;;AkB3kDQ;EAOI,4BAAA;AlBwkDZ;;AkB/kDQ;EAOI,+BAAA;AlB4kDZ;;AkBnlDQ;EAOI,8BAAA;AlBglDZ;;AkBvlDQ;EAOI,+BAAA;AlBolDZ;;AkB3lDQ;EAOI,4BAAA;AlBwlDZ;;AkB/lDQ;EAOI,+BAAA;AlB4lDZ;;AkBnmDQ;EAOI,8BAAA;AlBgmDZ;;AkBvmDQ;EAOI,+BAAA;AlBomDZ;;AkB3mDQ;EAOI,4BAAA;AlBwmDZ;;AkB/mDQ;EAOI,+BAAA;AlB4mDZ;;AkBnnDQ;EAOI,8BAAA;AlBgnDZ;;AkBvnDQ;EAOI,+BAAA;AlBonDZ;;AkB3nDQ;EAOI,4BAAA;AlBwnDZ;;AkB/nDQ;EAOI,+BAAA;AlB4nDZ;;AkBnoDQ;EAOI,8BAAA;AlBgoDZ;;AkBvoDQ;EAOI,+BAAA;AlBooDZ;;AkB3oDQ;EAOI,4BAAA;AlBwoDZ;;AkB/oDQ;EAOI,4BAAA;AlB4oDZ;;AkBnpDQ;EAOI,2BAAA;AlBgpDZ;;AkBvpDQ;EAOI,0BAAA;AlBopDZ;;AkB3pDQ;EAOI,2BAAA;AlBwpDZ;;AkB/pDQ;EAOI,wBAAA;AlB4pDZ;;AkBnqDQ;EAOI,2BAAA;AlBgqDZ;;AkBvqDQ;EAOI,0BAAA;AlBoqDZ;;AkB3qDQ;EAOI,2BAAA;AlBwqDZ;;AkB/qDQ;EAOI,wBAAA;AlB4qDZ;;AkBnrDQ;EAOI,2BAAA;AlBgrDZ;;AkBvrDQ;EAOI,0BAAA;AlBorDZ;;AkB3rDQ;EAOI,2BAAA;AlBwrDZ;;AkB/rDQ;EAOI,wBAAA;AlB4rDZ;;AkBnsDQ;EAOI,2BAAA;AlBgsDZ;;AkBvsDQ;EAOI,0BAAA;AlBosDZ;;AkB3sDQ;EAOI,2BAAA;AlBwsDZ;;AkB/sDQ;EAOI,wBAAA;AlB4sDZ;;AkBntDQ;EAOI,2BAAA;AlBgtDZ;;AkBvtDQ;EAOI,0BAAA;AlBotDZ;;AkB3tDQ;EAOI,2BAAA;AlBwtDZ;;AkB/tDQ;EAOI,wBAAA;AlB4tDZ;;AkBnuDQ;EAOI,iCAAA;EAAA,gCAAA;AlBiuDZ;;AkBxuDQ;EAOI,gCAAA;EAAA,+BAAA;AlBsuDZ;;AkB7uDQ;EAOI,iCAAA;EAAA,gCAAA;AlB2uDZ;;AkBlvDQ;EAOI,8BAAA;EAAA,6BAAA;AlBgvDZ;;AkBvvDQ;EAOI,iCAAA;EAAA,gCAAA;AlBqvDZ;;AkB5vDQ;EAOI,gCAAA;EAAA,+BAAA;AlB0vDZ;;AkBjwDQ;EAOI,iCAAA;EAAA,gCAAA;AlB+vDZ;;AkBtwDQ;EAOI,8BAAA;EAAA,6BAAA;AlBowDZ;;AkB3wDQ;EAOI,iCAAA;EAAA,gCAAA;AlBywDZ;;AkBhxDQ;EAOI,gCAAA;EAAA,+BAAA;AlB8wDZ;;AkBrxDQ;EAOI,iCAAA;EAAA,gCAAA;AlBmxDZ;;AkB1xDQ;EAOI,8BAAA;EAAA,6BAAA;AlBwxDZ;;AkB/xDQ;EAOI,iCAAA;EAAA,gCAAA;AlB6xDZ;;AkBpyDQ;EAOI,gCAAA;EAAA,+BAAA;AlBkyDZ;;AkBzyDQ;EAOI,iCAAA;EAAA,gCAAA;AlBuyDZ;;AkB9yDQ;EAOI,8BAAA;EAAA,6BAAA;AlB4yDZ;;AkBnzDQ;EAOI,iCAAA;EAAA,gCAAA;AlBizDZ;;AkBxzDQ;EAOI,gCAAA;EAAA,+BAAA;AlBszDZ;;AkB7zDQ;EAOI,iCAAA;EAAA,gCAAA;AlB2zDZ;;AkBl0DQ;EAOI,8BAAA;EAAA,6BAAA;AlBg0DZ;;AkBv0DQ;EAOI,+BAAA;EAAA,kCAAA;AlBq0DZ;;AkB50DQ;EAOI,8BAAA;EAAA,iCAAA;AlB00DZ;;AkBj1DQ;EAOI,+BAAA;EAAA,kCAAA;AlB+0DZ;;AkBt1DQ;EAOI,4BAAA;EAAA,+BAAA;AlBo1DZ;;AkB31DQ;EAOI,+BAAA;EAAA,kCAAA;AlBy1DZ;;AkBh2DQ;EAOI,8BAAA;EAAA,iCAAA;AlB81DZ;;AkBr2DQ;EAOI,+BAAA;EAAA,kCAAA;AlBm2DZ;;AkB12DQ;EAOI,4BAAA;EAAA,+BAAA;AlBw2DZ;;AkB/2DQ;EAOI,+BAAA;EAAA,kCAAA;AlB62DZ;;AkBp3DQ;EAOI,8BAAA;EAAA,iCAAA;AlBk3DZ;;AkBz3DQ;EAOI,+BAAA;EAAA,kCAAA;AlBu3DZ;;AkB93DQ;EAOI,4BAAA;EAAA,+BAAA;AlB43DZ;;AkBn4DQ;EAOI,+BAAA;EAAA,kCAAA;AlBi4DZ;;AkBx4DQ;EAOI,8BAAA;EAAA,iCAAA;AlBs4DZ;;AkB74DQ;EAOI,+BAAA;EAAA,kCAAA;AlB24DZ;;AkBl5DQ;EAOI,4BAAA;EAAA,+BAAA;AlBg5DZ;;AkBv5DQ;EAOI,+BAAA;EAAA,kCAAA;AlBq5DZ;;AkB55DQ;EAOI,8BAAA;EAAA,iCAAA;AlB05DZ;;AkBj6DQ;EAOI,+BAAA;EAAA,kCAAA;AlB+5DZ;;AkBt6DQ;EAOI,4BAAA;EAAA,+BAAA;AlBo6DZ;;AkB36DQ;EAOI,+BAAA;AlBw6DZ;;AkB/6DQ;EAOI,8BAAA;AlB46DZ;;AkBn7DQ;EAOI,+BAAA;AlBg7DZ;;AkBv7DQ;EAOI,4BAAA;AlBo7DZ;;AkB37DQ;EAOI,+BAAA;AlBw7DZ;;AkB/7DQ;EAOI,8BAAA;AlB47DZ;;AkBn8DQ;EAOI,+BAAA;AlBg8DZ;;AkBv8DQ;EAOI,4BAAA;AlBo8DZ;;AkB38DQ;EAOI,+BAAA;AlBw8DZ;;AkB/8DQ;EAOI,8BAAA;AlB48DZ;;AkBn9DQ;EAOI,+BAAA;AlBg9DZ;;AkBv9DQ;EAOI,4BAAA;AlBo9DZ;;AkB39DQ;EAOI,+BAAA;AlBw9DZ;;AkB/9DQ;EAOI,8BAAA;AlB49DZ;;AkBn+DQ;EAOI,+BAAA;AlBg+DZ;;AkBv+DQ;EAOI,4BAAA;AlBo+DZ;;AkB3+DQ;EAOI,+BAAA;AlBw+DZ;;AkB/+DQ;EAOI,8BAAA;AlB4+DZ;;AkBn/DQ;EAOI,+BAAA;AlBg/DZ;;AkBv/DQ;EAOI,4BAAA;AlBo/DZ;;AkB3/DQ;EAOI,iCAAA;AlBw/DZ;;AkB//DQ;EAOI,gCAAA;AlB4/DZ;;AkBngEQ;EAOI,iCAAA;AlBggEZ;;AkBvgEQ;EAOI,8BAAA;AlBogEZ;;AkB3gEQ;EAOI,iCAAA;AlBwgEZ;;AkB/gEQ;EAOI,gCAAA;AlB4gEZ;;AkBnhEQ;EAOI,iCAAA;AlBghEZ;;AkBvhEQ;EAOI,8BAAA;AlBohEZ;;AkB3hEQ;EAOI,iCAAA;AlBwhEZ;;AkB/hEQ;EAOI,gCAAA;AlB4hEZ;;AkBniEQ;EAOI,iCAAA;AlBgiEZ;;AkBviEQ;EAOI,8BAAA;AlBoiEZ;;AkB3iEQ;EAOI,iCAAA;AlBwiEZ;;AkB/iEQ;EAOI,gCAAA;AlB4iEZ;;AkBnjEQ;EAOI,iCAAA;AlBgjEZ;;AkBvjEQ;EAOI,8BAAA;AlBojEZ;;AkB3jEQ;EAOI,iCAAA;AlBwjEZ;;AkB/jEQ;EAOI,gCAAA;AlB4jEZ;;AkBnkEQ;EAOI,iCAAA;AlBgkEZ;;AkBvkEQ;EAOI,8BAAA;AlBokEZ;;AkB3kEQ;EAOI,kCAAA;AlBwkEZ;;AkB/kEQ;EAOI,iCAAA;AlB4kEZ;;AkBnlEQ;EAOI,kCAAA;AlBglEZ;;AkBvlEQ;EAOI,+BAAA;AlBolEZ;;AkB3lEQ;EAOI,kCAAA;AlBwlEZ;;AkB/lEQ;EAOI,iCAAA;AlB4lEZ;;AkBnmEQ;EAOI,kCAAA;AlBgmEZ;;AkBvmEQ;EAOI,+BAAA;AlBomEZ;;AkB3mEQ;EAOI,kCAAA;AlBwmEZ;;AkB/mEQ;EAOI,iCAAA;AlB4mEZ;;AkBnnEQ;EAOI,kCAAA;AlBgnEZ;;AkBvnEQ;EAOI,+BAAA;AlBonEZ;;AkB3nEQ;EAOI,kCAAA;AlBwnEZ;;AkB/nEQ;EAOI,iCAAA;AlB4nEZ;;AkBnoEQ;EAOI,kCAAA;AlBgoEZ;;AkBvoEQ;EAOI,+BAAA;AlBooEZ;;AkB3oEQ;EAOI,kCAAA;AlBwoEZ;;AkB/oEQ;EAOI,iCAAA;AlB4oEZ;;AkBnpEQ;EAOI,kCAAA;AlBgpEZ;;AkBvpEQ;EAOI,+BAAA;AlBopEZ;;AkB3pEQ;EAOI,gCAAA;AlBwpEZ;;AkB/pEQ;EAOI,+BAAA;AlB4pEZ;;AkBnqEQ;EAOI,gCAAA;AlBgqEZ;;AkBvqEQ;EAOI,6BAAA;AlBoqEZ;;AkB3qEQ;EAOI,gCAAA;AlBwqEZ;;AkB/qEQ;EAOI,+BAAA;AlB4qEZ;;AkBnrEQ;EAOI,gCAAA;AlBgrEZ;;AkBvrEQ;EAOI,6BAAA;AlBorEZ;;AkB3rEQ;EAOI,gCAAA;AlBwrEZ;;AkB/rEQ;EAOI,+BAAA;AlB4rEZ;;AkBnsEQ;EAOI,gCAAA;AlBgsEZ;;AkBvsEQ;EAOI,6BAAA;AlBosEZ;;AkB3sEQ;EAOI,gCAAA;AlBwsEZ;;AkB/sEQ;EAOI,+BAAA;AlB4sEZ;;AkBntEQ;EAOI,gCAAA;AlBgtEZ;;AkBvtEQ;EAOI,6BAAA;AlBotEZ;;AkB3tEQ;EAOI,gCAAA;AlBwtEZ;;AkB/tEQ;EAOI,+BAAA;AlB4tEZ;;AkBnuEQ;EAOI,gCAAA;AlBguEZ;;AkBvuEQ;EAOI,6BAAA;AlBouEZ;;AkB3uEQ;EAOI,qBAAA;AlBwuEZ;;AkB/uEQ;EAOI,2BAAA;AlB4uEZ;;AkBnvEQ;EAOI,0BAAA;AlBgvEZ;;AkBvvEQ;EAOI,2BAAA;AlBovEZ;;AkB3vEQ;EAOI,wBAAA;AlBwvEZ;;AkB/vEQ;EAOI,2BAAA;AlB4vEZ;;AkBnwEQ;EAOI,0BAAA;AlBgwEZ;;AkBvwEQ;EAOI,2BAAA;AlBowEZ;;AkB3wEQ;EAOI,wBAAA;AlBwwEZ;;AkB/wEQ;EAOI,2BAAA;AlB4wEZ;;AkBnxEQ;EAOI,0BAAA;AlBgxEZ;;AkBvxEQ;EAOI,2BAAA;AlBoxEZ;;AkB3xEQ;EAOI,wBAAA;AlBwxEZ;;AkB/xEQ;EAOI,2BAAA;AlB4xEZ;;AkBnyEQ;EAOI,0BAAA;AlBgyEZ;;AkBvyEQ;EAOI,2BAAA;AlBoyEZ;;AkB3yEQ;EAOI,wBAAA;AlBwyEZ;;AkB/yEQ;EAOI,2BAAA;AlB4yEZ;;AkBnzEQ;EAOI,0BAAA;AlBgzEZ;;AkBvzEQ;EAOI,2BAAA;AlBozEZ;;AkB3zEQ;EAOI,wBAAA;AlBwzEZ;;AkB/zEQ;EAOI,2BAAA;EAAA,0BAAA;AlB6zEZ;;AkBp0EQ;EAOI,iCAAA;EAAA,gCAAA;AlBk0EZ;;AkBz0EQ;EAOI,gCAAA;EAAA,+BAAA;AlBu0EZ;;AkB90EQ;EAOI,iCAAA;EAAA,gCAAA;AlB40EZ;;AkBn1EQ;EAOI,8BAAA;EAAA,6BAAA;AlBi1EZ;;AkBx1EQ;EAOI,iCAAA;EAAA,gCAAA;AlBs1EZ;;AkB71EQ;EAOI,gCAAA;EAAA,+BAAA;AlB21EZ;;AkBl2EQ;EAOI,iCAAA;EAAA,gCAAA;AlBg2EZ;;AkBv2EQ;EAOI,8BAAA;EAAA,6BAAA;AlBq2EZ;;AkB52EQ;EAOI,iCAAA;EAAA,gCAAA;AlB02EZ;;AkBj3EQ;EAOI,gCAAA;EAAA,+BAAA;AlB+2EZ;;AkBt3EQ;EAOI,iCAAA;EAAA,gCAAA;AlBo3EZ;;AkB33EQ;EAOI,8BAAA;EAAA,6BAAA;AlBy3EZ;;AkBh4EQ;EAOI,iCAAA;EAAA,gCAAA;AlB83EZ;;AkBr4EQ;EAOI,gCAAA;EAAA,+BAAA;AlBm4EZ;;AkB14EQ;EAOI,iCAAA;EAAA,gCAAA;AlBw4EZ;;AkB/4EQ;EAOI,8BAAA;EAAA,6BAAA;AlB64EZ;;AkBp5EQ;EAOI,iCAAA;EAAA,gCAAA;AlBk5EZ;;AkBz5EQ;EAOI,gCAAA;EAAA,+BAAA;AlBu5EZ;;AkB95EQ;EAOI,iCAAA;EAAA,gCAAA;AlB45EZ;;AkBn6EQ;EAOI,8BAAA;EAAA,6BAAA;AlBi6EZ;;AkBx6EQ;EAOI,yBAAA;EAAA,4BAAA;AlBs6EZ;;AkB76EQ;EAOI,+BAAA;EAAA,kCAAA;AlB26EZ;;AkBl7EQ;EAOI,8BAAA;EAAA,iCAAA;AlBg7EZ;;AkBv7EQ;EAOI,+BAAA;EAAA,kCAAA;AlBq7EZ;;AkB57EQ;EAOI,4BAAA;EAAA,+BAAA;AlB07EZ;;AkBj8EQ;EAOI,+BAAA;EAAA,kCAAA;AlB+7EZ;;AkBt8EQ;EAOI,8BAAA;EAAA,iCAAA;AlBo8EZ;;AkB38EQ;EAOI,+BAAA;EAAA,kCAAA;AlBy8EZ;;AkBh9EQ;EAOI,4BAAA;EAAA,+BAAA;AlB88EZ;;AkBr9EQ;EAOI,+BAAA;EAAA,kCAAA;AlBm9EZ;;AkB19EQ;EAOI,8BAAA;EAAA,iCAAA;AlBw9EZ;;AkB/9EQ;EAOI,+BAAA;EAAA,kCAAA;AlB69EZ;;AkBp+EQ;EAOI,4BAAA;EAAA,+BAAA;AlBk+EZ;;AkBz+EQ;EAOI,+BAAA;EAAA,kCAAA;AlBu+EZ;;AkB9+EQ;EAOI,8BAAA;EAAA,iCAAA;AlB4+EZ;;AkBn/EQ;EAOI,+BAAA;EAAA,kCAAA;AlBi/EZ;;AkBx/EQ;EAOI,4BAAA;EAAA,+BAAA;AlBs/EZ;;AkB7/EQ;EAOI,+BAAA;EAAA,kCAAA;AlB2/EZ;;AkBlgFQ;EAOI,8BAAA;EAAA,iCAAA;AlBggFZ;;AkBvgFQ;EAOI,+BAAA;EAAA,kCAAA;AlBqgFZ;;AkB5gFQ;EAOI,4BAAA;EAAA,+BAAA;AlB0gFZ;;AkBjhFQ;EAOI,yBAAA;AlB8gFZ;;AkBrhFQ;EAOI,+BAAA;AlBkhFZ;;AkBzhFQ;EAOI,8BAAA;AlBshFZ;;AkB7hFQ;EAOI,+BAAA;AlB0hFZ;;AkBjiFQ;EAOI,4BAAA;AlB8hFZ;;AkBriFQ;EAOI,+BAAA;AlBkiFZ;;AkBziFQ;EAOI,8BAAA;AlBsiFZ;;AkB7iFQ;EAOI,+BAAA;AlB0iFZ;;AkBjjFQ;EAOI,4BAAA;AlB8iFZ;;AkBrjFQ;EAOI,+BAAA;AlBkjFZ;;AkBzjFQ;EAOI,8BAAA;AlBsjFZ;;AkB7jFQ;EAOI,+BAAA;AlB0jFZ;;AkBjkFQ;EAOI,4BAAA;AlB8jFZ;;AkBrkFQ;EAOI,+BAAA;AlBkkFZ;;AkBzkFQ;EAOI,8BAAA;AlBskFZ;;AkB7kFQ;EAOI,+BAAA;AlB0kFZ;;AkBjlFQ;EAOI,4BAAA;AlB8kFZ;;AkBrlFQ;EAOI,+BAAA;AlBklFZ;;AkBzlFQ;EAOI,8BAAA;AlBslFZ;;AkB7lFQ;EAOI,+BAAA;AlB0lFZ;;AkBjmFQ;EAOI,4BAAA;AlB8lFZ;;AkBrmFQ;EAOI,2BAAA;AlBkmFZ;;AkBzmFQ;EAOI,iCAAA;AlBsmFZ;;AkB7mFQ;EAOI,gCAAA;AlB0mFZ;;AkBjnFQ;EAOI,iCAAA;AlB8mFZ;;AkBrnFQ;EAOI,8BAAA;AlBknFZ;;AkBznFQ;EAOI,iCAAA;AlBsnFZ;;AkB7nFQ;EAOI,gCAAA;AlB0nFZ;;AkBjoFQ;EAOI,iCAAA;AlB8nFZ;;AkBroFQ;EAOI,8BAAA;AlBkoFZ;;AkBzoFQ;EAOI,iCAAA;AlBsoFZ;;AkB7oFQ;EAOI,gCAAA;AlB0oFZ;;AkBjpFQ;EAOI,iCAAA;AlB8oFZ;;AkBrpFQ;EAOI,8BAAA;AlBkpFZ;;AkBzpFQ;EAOI,iCAAA;AlBspFZ;;AkB7pFQ;EAOI,gCAAA;AlB0pFZ;;AkBjqFQ;EAOI,iCAAA;AlB8pFZ;;AkBrqFQ;EAOI,8BAAA;AlBkqFZ;;AkBzqFQ;EAOI,iCAAA;AlBsqFZ;;AkB7qFQ;EAOI,gCAAA;AlB0qFZ;;AkBjrFQ;EAOI,iCAAA;AlB8qFZ;;AkBrrFQ;EAOI,8BAAA;AlBkrFZ;;AkBzrFQ;EAOI,4BAAA;AlBsrFZ;;AkB7rFQ;EAOI,kCAAA;AlB0rFZ;;AkBjsFQ;EAOI,iCAAA;AlB8rFZ;;AkBrsFQ;EAOI,kCAAA;AlBksFZ;;AkBzsFQ;EAOI,+BAAA;AlBssFZ;;AkB7sFQ;EAOI,kCAAA;AlB0sFZ;;AkBjtFQ;EAOI,iCAAA;AlB8sFZ;;AkBrtFQ;EAOI,kCAAA;AlBktFZ;;AkBztFQ;EAOI,+BAAA;AlBstFZ;;AkB7tFQ;EAOI,kCAAA;AlB0tFZ;;AkBjuFQ;EAOI,iCAAA;AlB8tFZ;;AkBruFQ;EAOI,kCAAA;AlBkuFZ;;AkBzuFQ;EAOI,+BAAA;AlBsuFZ;;AkB7uFQ;EAOI,kCAAA;AlB0uFZ;;AkBjvFQ;EAOI,iCAAA;AlB8uFZ;;AkBrvFQ;EAOI,kCAAA;AlBkvFZ;;AkBzvFQ;EAOI,+BAAA;AlBsvFZ;;AkB7vFQ;EAOI,kCAAA;AlB0vFZ;;AkBjwFQ;EAOI,iCAAA;AlB8vFZ;;AkBrwFQ;EAOI,kCAAA;AlBkwFZ;;AkBzwFQ;EAOI,+BAAA;AlBswFZ;;AkB7wFQ;EAOI,0BAAA;AlB0wFZ;;AkBjxFQ;EAOI,gCAAA;AlB8wFZ;;AkBrxFQ;EAOI,+BAAA;AlBkxFZ;;AkBzxFQ;EAOI,gCAAA;AlBsxFZ;;AkB7xFQ;EAOI,6BAAA;AlB0xFZ;;AkBjyFQ;EAOI,gCAAA;AlB8xFZ;;AkBryFQ;EAOI,+BAAA;AlBkyFZ;;AkBzyFQ;EAOI,gCAAA;AlBsyFZ;;AkB7yFQ;EAOI,6BAAA;AlB0yFZ;;AkBjzFQ;EAOI,gCAAA;AlB8yFZ;;AkBrzFQ;EAOI,+BAAA;AlBkzFZ;;AkBzzFQ;EAOI,gCAAA;AlBszFZ;;AkB7zFQ;EAOI,6BAAA;AlB0zFZ;;AkBj0FQ;EAOI,gCAAA;AlB8zFZ;;AkBr0FQ;EAOI,+BAAA;AlBk0FZ;;AkBz0FQ;EAOI,gCAAA;AlBs0FZ;;AkB70FQ;EAOI,6BAAA;AlB00FZ;;AkBj1FQ;EAOI,gCAAA;AlB80FZ;;AkBr1FQ;EAOI,+BAAA;AlBk1FZ;;AkBz1FQ;EAOI,gCAAA;AlBs1FZ;;AkB71FQ;EAOI,6BAAA;AlB01FZ;;AkBj2FQ;EAOI,iBAAA;AlB81FZ;;AkBr2FQ;EAOI,uBAAA;AlBk2FZ;;AkBz2FQ;EAOI,sBAAA;AlBs2FZ;;AkB72FQ;EAOI,uBAAA;AlB02FZ;;AkBj3FQ;EAOI,oBAAA;AlB82FZ;;AkBr3FQ;EAOI,uBAAA;AlBk3FZ;;AkBz3FQ;EAOI,sBAAA;AlBs3FZ;;AkB73FQ;EAOI,uBAAA;AlB03FZ;;AkBj4FQ;EAOI,oBAAA;AlB83FZ;;AkBr4FQ;EAOI,uBAAA;AlBk4FZ;;AkBz4FQ;EAOI,sBAAA;AlBs4FZ;;AkB74FQ;EAOI,uBAAA;AlB04FZ;;AkBj5FQ;EAOI,oBAAA;AlB84FZ;;AkBr5FQ;EAOI,uBAAA;AlBk5FZ;;AkBz5FQ;EAOI,sBAAA;AlBs5FZ;;AkB75FQ;EAOI,uBAAA;AlB05FZ;;AkBj6FQ;EAOI,oBAAA;AlB85FZ;;AkBr6FQ;EAOI,uBAAA;AlBk6FZ;;AkBz6FQ;EAOI,sBAAA;AlBs6FZ;;AkB76FQ;EAOI,uBAAA;AlB06FZ;;AkBj7FQ;EAOI,oBAAA;AlB86FZ;;AkBr7FQ;EAOI,qBAAA;AlBk7FZ;;AkBz7FQ;EAOI,2BAAA;AlBs7FZ;;AkB77FQ;EAOI,0BAAA;AlB07FZ;;AkBj8FQ;EAOI,2BAAA;AlB87FZ;;AkBr8FQ;EAOI,wBAAA;AlBk8FZ;;AkBz8FQ;EAOI,2BAAA;AlBs8FZ;;AkB78FQ;EAOI,0BAAA;AlB08FZ;;AkBj9FQ;EAOI,2BAAA;AlB88FZ;;AkBr9FQ;EAOI,wBAAA;AlBk9FZ;;AkBz9FQ;EAOI,2BAAA;AlBs9FZ;;AkB79FQ;EAOI,0BAAA;AlB09FZ;;AkBj+FQ;EAOI,2BAAA;AlB89FZ;;AkBr+FQ;EAOI,wBAAA;AlBk+FZ;;AkBz+FQ;EAOI,2BAAA;AlBs+FZ;;AkB7+FQ;EAOI,0BAAA;AlB0+FZ;;AkBj/FQ;EAOI,2BAAA;AlB8+FZ;;AkBr/FQ;EAOI,wBAAA;AlBk/FZ;;AkBz/FQ;EAOI,2BAAA;AlBs/FZ;;AkB7/FQ;EAOI,0BAAA;AlB0/FZ;;AkBjgGQ;EAOI,2BAAA;AlB8/FZ;;AkBrgGQ;EAOI,wBAAA;AlBkgGZ;;AkBzgGQ;EAOI,wBAAA;AlBsgGZ;;AkB7gGQ;EAOI,8BAAA;AlB0gGZ;;AkBjhGQ;EAOI,6BAAA;AlB8gGZ;;AkBrhGQ;EAOI,8BAAA;AlBkhGZ;;AkBzhGQ;EAOI,2BAAA;AlBshGZ;;AkB7hGQ;EAOI,8BAAA;AlB0hGZ;;AkBjiGQ;EAOI,6BAAA;AlB8hGZ;;AkBriGQ;EAOI,8BAAA;AlBkiGZ;;AkBziGQ;EAOI,2BAAA;AlBsiGZ;;AkB7iGQ;EAOI,8BAAA;AlB0iGZ;;AkBjjGQ;EAOI,6BAAA;AlB8iGZ;;AkBrjGQ;EAOI,8BAAA;AlBkjGZ;;AkBzjGQ;EAOI,2BAAA;AlBsjGZ;;AkB7jGQ;EAOI,8BAAA;AlB0jGZ;;AkBjkGQ;EAOI,6BAAA;AlB8jGZ;;AkBrkGQ;EAOI,8BAAA;AlBkkGZ;;AkBzkGQ;EAOI,2BAAA;AlBskGZ;;AkB7kGQ;EAOI,8BAAA;AlB0kGZ;;AkBjlGQ;EAOI,6BAAA;AlB8kGZ;;AkBrlGQ;EAOI,8BAAA;AlBklGZ;;AkBzlGQ;EAOI,2BAAA;AlBslGZ;;AkB7lGQ;EAOI,gDAAA;AlB0lGZ;;AkBjmGQ;EAOI,0CAAA;AlB8lGZ;;AkBrmGQ;EAOI,4CAAA;AlBkmGZ;;AkBzmGQ;EAOI,4CAAA;AlBsmGZ;;AkB7mGQ;EAOI,6BAAA;AlB0mGZ;;AkBjnGQ;EAOI,6BAAA;AlB8mGZ;;AkBrnGQ;EAOI,8BAAA;AlBknGZ;;AkBznGQ;EAOI,6BAAA;AlBsnGZ;;AkB7nGQ;EAOI,6BAAA;AlB0nGZ;;AkBjoGQ;EAOI,6BAAA;AlB8nGZ;;AkBroGQ;EAOI,4BAAA;AlBkoGZ;;AkBzoGQ;EAOI,0BAAA;AlBsoGZ;;AkB7oGQ;EAOI,0BAAA;AlB0oGZ;;AkBjpGQ;EAOI,4CAAA;AlB8oGZ;;AkBrpGQ;EAOI,2CAAA;AlBkpGZ;;AkBzpGQ;EAOI,4CAAA;AlBspGZ;;AkB7pGQ;EAOI,0CAAA;AlB0pGZ;;AkBjqGQ;EAOI,4CAAA;AlB8pGZ;;AkBrqGQ;EAOI,2CAAA;AlBkqGZ;;AkBzqGQ;EAOI,4CAAA;AlBsqGZ;;AkB7qGQ;EAOI,wCAAA;AlB0qGZ;;AkBjrGQ;EAOI,4CAAA;AlB8qGZ;;AkBrrGQ;EAOI,2CAAA;AlBkrGZ;;AkBzrGQ;EAOI,4CAAA;AlBsrGZ;;AkB7rGQ;EAOI,0CAAA;AlB0rGZ;;AkBjsGQ;EAOI,4CAAA;AlB8rGZ;;AkBrsGQ;EAOI,2CAAA;AlBksGZ;;AkBzsGQ;EAOI,4CAAA;AlBssGZ;;AkB7sGQ;EAOI,0CAAA;AlB0sGZ;;AkBjtGQ;EAOI,6BAAA;AlB8sGZ;;AkBrtGQ;EAOI,6BAAA;AlBktGZ;;AkBztGQ;EAOI,+BAAA;AlBstGZ;;AkB7tGQ;EAOI,2BAAA;AlB0tGZ;;AkBjuGQ;EAOI,2BAAA;AlB8tGZ;;AkBruGQ;EAOI,2BAAA;AlBkuGZ;;AkBzuGQ;EAOI,2BAAA;AlBsuGZ;;AkB7uGQ;EAOI,2BAAA;AlB0uGZ;;AkBjvGQ;EAOI,2BAAA;AlB8uGZ;;AkBrvGQ;EAOI,yBAAA;AlBkvGZ;;AkBzvGQ;EAOI,4BAAA;AlBsvGZ;;AkB7vGQ;EAOI,2BAAA;AlB0vGZ;;AkBjwGQ;EAOI,4BAAA;AlB8vGZ;;AkBrwGQ;EAOI,2BAAA;AlBkwGZ;;AkBzwGQ;EAOI,4BAAA;AlBswGZ;;AkB7wGQ;EAOI,6BAAA;AlB0wGZ;;AkBjxGQ;EAOI,gCAAA;AlB8wGZ;;AkBrxGQ;EAOI,qCAAA;AlBkxGZ;;AkBzxGQ;EAOI,wCAAA;AlBsxGZ;;AkB7xGQ;EAOI,oCAAA;AlB0xGZ;;AkBjyGQ;EAOI,oCAAA;AlB8xGZ;;AkBryGQ;EAOI,qCAAA;AlBkyGZ;;AkBzyGQ;EAOI,8BAAA;AlBsyGZ;;AkB7yGQ;EAOI,8BAAA;AlB0yGZ;;AkB/zGQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AlBgzGZ;;AkB7xGQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,mEAAA;AlBszGZ;;AkB7zGQ;EAIQ,oBAAA;EAGJ,mEAAA;AlB2zGZ;;AkBl0GQ;EAIQ,oBAAA;EAGJ,qEAAA;AlBg0GZ;;AkBv0GQ;EAIQ,oBAAA;EAGJ,uEAAA;AlBq0GZ;;AkB50GQ;EAIQ,oBAAA;EAGJ,qEAAA;AlB00GZ;;AkBj1GQ;EAIQ,oBAAA;EAGJ,kEAAA;AlB+0GZ;;AkBt1GQ;EAIQ,oBAAA;EAGJ,qEAAA;AlBo1GZ;;AkB31GQ;EAIQ,oBAAA;EAGJ,oEAAA;AlBy1GZ;;AkBh2GQ;EAIQ,oBAAA;EAGJ,kEAAA;AlB81GZ;;AkBr2GQ;EAIQ,oBAAA;EAGJ,mEAAA;AlBm2GZ;;AkB12GQ;EAIQ,oBAAA;EAGJ,wEAAA;AlBw2GZ;;AkB/2GQ;EAIQ,oBAAA;EAGJ,2CAAA;AlB62GZ;;AkBp3GQ;EAIQ,oBAAA;EAGJ,oCAAA;AlBk3GZ;;AkBz3GQ;EAIQ,oBAAA;EAGJ,0CAAA;AlBu3GZ;;AkB93GQ;EAIQ,oBAAA;EAGJ,2CAAA;AlB43GZ;;AkBn4GQ;EAIQ,oBAAA;EAGJ,0CAAA;AlBi4GZ;;AkBx4GQ;EAIQ,oBAAA;EAGJ,0CAAA;AlBs4GZ;;AkB74GQ;EAIQ,oBAAA;EAGJ,yBAAA;AlB24GZ;;AkB55GQ;EACE,uBAAA;AlB+5GV;;AkBh6GQ;EACE,sBAAA;AlBm6GV;;AkBp6GQ;EACE,uBAAA;AlBu6GV;;AkBx6GQ;EACE,oBAAA;AlB26GV;;AkBl6GQ;EAOI,iDAAA;AlB+5GZ;;AkBt6GQ;EAOI,mDAAA;AlBm6GZ;;AkB16GQ;EAOI,iDAAA;AlBu6GZ;;AkB96GQ;EAOI,8CAAA;AlB26GZ;;AkBl7GQ;EAOI,iDAAA;AlB+6GZ;;AkBt7GQ;EAOI,gDAAA;AlBm7GZ;;AkB17GQ;EAOI,+CAAA;AlBu7GZ;;AkB97GQ;EAOI,8CAAA;AlB27GZ;;AkB58GQ;EACE,sBAAA;AlB+8GV;;AkB38GU;EACE,sBAAA;AlB88GZ;;AkBp9GQ;EACE,uBAAA;AlBu9GV;;AkBn9GU;EACE,uBAAA;AlBs9GZ;;AkB59GQ;EACE,sBAAA;AlB+9GV;;AkB39GU;EACE,sBAAA;AlB89GZ;;AkBp+GQ;EACE,uBAAA;AlBu+GV;;AkBn+GU;EACE,uBAAA;AlBs+GZ;;AkB5+GQ;EACE,oBAAA;AlB++GV;;AkB3+GU;EACE,oBAAA;AlB8+GZ;;AkB1+GQ;EAOI,yCAAA;AlBu+GZ;;AkBl+GU;EAOI,yCAAA;AlB+9Gd;;AkBl/GQ;EAOI,wCAAA;AlB++GZ;;AkB1+GU;EAOI,wCAAA;AlBu+Gd;;AkB1/GQ;EAOI,yCAAA;AlBu/GZ;;AkBl/GU;EAOI,yCAAA;AlB++Gd;;AkBlgHQ;EAIQ,8BAAA;EAGJ,6FAAA;AlBggHZ;;AkBvgHQ;EAIQ,8BAAA;EAGJ,6FAAA;AlBqgHZ;;AkB5gHQ;EAIQ,8BAAA;EAGJ,+FAAA;AlB0gHZ;;AkBjhHQ;EAIQ,8BAAA;EAGJ,iGAAA;AlB+gHZ;;AkBthHQ;EAIQ,8BAAA;EAGJ,+FAAA;AlBohHZ;;AkB3hHQ;EAIQ,8BAAA;EAGJ,4FAAA;AlByhHZ;;AkBhiHQ;EAIQ,8BAAA;EAGJ,+FAAA;AlB8hHZ;;AkBriHQ;EAIQ,8BAAA;EAGJ,8FAAA;AlBmiHZ;;AkB1iHQ;EAIQ,8BAAA;EAGJ,4FAAA;AlBwiHZ;;AkB/iHQ;EAIQ,8BAAA;EAGJ,qGAAA;AlB6iHZ;;AkB9jHQ;EACE,8BAAA;AlBikHV;;AkB7jHU;EACE,8BAAA;AlBgkHZ;;AkBtkHQ;EACE,gCAAA;AlBykHV;;AkBrkHU;EACE,gCAAA;AlBwkHZ;;AkB9kHQ;EACE,iCAAA;AlBilHV;;AkB7kHU;EACE,iCAAA;AlBglHZ;;AkBtlHQ;EACE,gCAAA;AlBylHV;;AkBrlHU;EACE,gCAAA;AlBwlHZ;;AkB9lHQ;EACE,iCAAA;AlBimHV;;AkB7lHU;EACE,iCAAA;AlBgmHZ;;AkBtmHQ;EACE,8BAAA;AlBymHV;;AkBrmHU;EACE,8BAAA;AlBwmHZ;;AkBpmHQ;EAIQ,kBAAA;EAGJ,4EAAA;AlBkmHZ;;AkBzmHQ;EAIQ,kBAAA;EAGJ,4EAAA;AlBumHZ;;AkB9mHQ;EAIQ,kBAAA;EAGJ,8EAAA;AlB4mHZ;;AkBnnHQ;EAIQ,kBAAA;EAGJ,gFAAA;AlBinHZ;;AkBxnHQ;EAIQ,kBAAA;EAGJ,8EAAA;AlBsnHZ;;AkB7nHQ;EAIQ,kBAAA;EAGJ,2EAAA;AlB2nHZ;;AkBloHQ;EAIQ,kBAAA;EAGJ,8EAAA;AlBgoHZ;;AkBvoHQ;EAIQ,kBAAA;EAGJ,6EAAA;AlBqoHZ;;AkB5oHQ;EAIQ,kBAAA;EAGJ,2EAAA;AlB0oHZ;;AkBjpHQ;EAIQ,kBAAA;EAGJ,4EAAA;AlB+oHZ;;AkBtpHQ;EAIQ,kBAAA;EAGJ,8EAAA;AlBopHZ;;AkB3pHQ;EAIQ,kBAAA;EAGJ,wCAAA;AlBypHZ;;AkBhqHQ;EAIQ,kBAAA;EAGJ,mFAAA;AlB8pHZ;;AkBrqHQ;EAIQ,kBAAA;EAGJ,kFAAA;AlBmqHZ;;AkBprHQ;EACE,oBAAA;AlBurHV;;AkBxrHQ;EACE,qBAAA;AlB2rHV;;AkB5rHQ;EACE,oBAAA;AlB+rHV;;AkBhsHQ;EACE,qBAAA;AlBmsHV;;AkBpsHQ;EACE,kBAAA;AlBusHV;;AkB9rHQ;EAOI,wDAAA;AlB2rHZ;;AkBlsHQ;EAOI,0DAAA;AlB+rHZ;;AkBtsHQ;EAOI,wDAAA;AlBmsHZ;;AkB1sHQ;EAOI,qDAAA;AlBusHZ;;AkB9sHQ;EAOI,wDAAA;AlB2sHZ;;AkBltHQ;EAOI,uDAAA;AlB+sHZ;;AkBttHQ;EAOI,sDAAA;AlBmtHZ;;AkB1tHQ;EAOI,qDAAA;AlButHZ;;AkB9tHQ;EAOI,+CAAA;AlB2tHZ;;AkBluHQ;EAOI,mCAAA;UAAA,2BAAA;AlB+tHZ;;AkBtuHQ;EAOI,oCAAA;UAAA,4BAAA;AlBmuHZ;;AkB1uHQ;EAOI,oCAAA;UAAA,4BAAA;AlBuuHZ;;AkB9uHQ;EAOI,+BAAA;AlB2uHZ;;AkBlvHQ;EAOI,+BAAA;AlB+uHZ;;AkBtvHQ;EAOI,iDAAA;AlBmvHZ;;AkB1vHQ;EAOI,2BAAA;AlBuvHZ;;AkB9vHQ;EAOI,oDAAA;AlB2vHZ;;AkBlwHQ;EAOI,iDAAA;AlB+vHZ;;AkBtwHQ;EAOI,oDAAA;AlBmwHZ;;AkB1wHQ;EAOI,oDAAA;AlBuwHZ;;AkB9wHQ;EAOI,qDAAA;AlB2wHZ;;AkBlxHQ;EAOI,6BAAA;AlB+wHZ;;AkBtxHQ;EAOI,sDAAA;AlBmxHZ;;AkB1xHQ;EAOI,0DAAA;EAAA,2DAAA;AlBwxHZ;;AkB/xHQ;EAOI,oCAAA;EAAA,qCAAA;AlB6xHZ;;AkBpyHQ;EAOI,6DAAA;EAAA,8DAAA;AlBkyHZ;;AkBzyHQ;EAOI,0DAAA;EAAA,2DAAA;AlBuyHZ;;AkB9yHQ;EAOI,6DAAA;EAAA,8DAAA;AlB4yHZ;;AkBnzHQ;EAOI,6DAAA;EAAA,8DAAA;AlBizHZ;;AkBxzHQ;EAOI,8DAAA;EAAA,+DAAA;AlBszHZ;;AkB7zHQ;EAOI,sCAAA;EAAA,uCAAA;AlB2zHZ;;AkBl0HQ;EAOI,+DAAA;EAAA,gEAAA;AlBg0HZ;;AkBv0HQ;EAOI,2DAAA;EAAA,8DAAA;AlBq0HZ;;AkB50HQ;EAOI,qCAAA;EAAA,wCAAA;AlB00HZ;;AkBj1HQ;EAOI,8DAAA;EAAA,iEAAA;AlB+0HZ;;AkBt1HQ;EAOI,2DAAA;EAAA,8DAAA;AlBo1HZ;;AkB31HQ;EAOI,8DAAA;EAAA,iEAAA;AlBy1HZ;;AkBh2HQ;EAOI,8DAAA;EAAA,iEAAA;AlB81HZ;;AkBr2HQ;EAOI,+DAAA;EAAA,kEAAA;AlBm2HZ;;AkB12HQ;EAOI,uCAAA;EAAA,0CAAA;AlBw2HZ;;AkB/2HQ;EAOI,gEAAA;EAAA,mEAAA;AlB62HZ;;AkBp3HQ;EAOI,8DAAA;EAAA,6DAAA;AlBk3HZ;;AkBz3HQ;EAOI,wCAAA;EAAA,uCAAA;AlBu3HZ;;AkB93HQ;EAOI,iEAAA;EAAA,gEAAA;AlB43HZ;;AkBn4HQ;EAOI,8DAAA;EAAA,6DAAA;AlBi4HZ;;AkBx4HQ;EAOI,iEAAA;EAAA,gEAAA;AlBs4HZ;;AkB74HQ;EAOI,iEAAA;EAAA,gEAAA;AlB24HZ;;AkBl5HQ;EAOI,kEAAA;EAAA,iEAAA;AlBg5HZ;;AkBv5HQ;EAOI,0CAAA;EAAA,yCAAA;AlBq5HZ;;AkB55HQ;EAOI,mEAAA;EAAA,kEAAA;AlB05HZ;;AkBj6HQ;EAOI,6DAAA;EAAA,0DAAA;AlB+5HZ;;AkBt6HQ;EAOI,uCAAA;EAAA,oCAAA;AlBo6HZ;;AkB36HQ;EAOI,gEAAA;EAAA,6DAAA;AlBy6HZ;;AkBh7HQ;EAOI,6DAAA;EAAA,0DAAA;AlB86HZ;;AkBr7HQ;EAOI,gEAAA;EAAA,6DAAA;AlBm7HZ;;AkB17HQ;EAOI,gEAAA;EAAA,6DAAA;AlBw7HZ;;AkB/7HQ;EAOI,iEAAA;EAAA,8DAAA;AlB67HZ;;AkBp8HQ;EAOI,yCAAA;EAAA,sCAAA;AlBk8HZ;;AkBz8HQ;EAOI,kEAAA;EAAA,+DAAA;AlBu8HZ;;AkB98HQ;EAOI,8BAAA;AlB28HZ;;AkBl9HQ;EAOI,6BAAA;AlB+8HZ;;AkBt9HQ;EAOI,sBAAA;AlBm9HZ;;AkB19HQ;EAOI,qBAAA;AlBu9HZ;;AkB99HQ;EAOI,qBAAA;AlB29HZ;;AkBl+HQ;EAOI,qBAAA;AlB+9HZ;;AkBt+HQ;EAOI,qBAAA;AlBm+HZ;;AU7+HI;EQGI;IAOI,sBAAA;ElBw+HV;;EkB/+HM;IAOI,uBAAA;ElB4+HV;;EkBn/HM;IAOI,sBAAA;ElBg/HV;;EkBv/HM;IAOI,8BAAA;ElBo/HV;;EkB3/HM;IAOI,4BAAA;ElBw/HV;;EkB//HM;IAOI,2BAAA;ElB4/HV;;EkBngIM;IAOI,iCAAA;ElBggIV;;EkBvgIM;IAOI,2BAAA;ElBogIV;;EkB3gIM;IAOI,0BAAA;ElBwgIV;;EkB/gIM;IAOI,gCAAA;ElB4gIV;;EkBnhIM;IAOI,yBAAA;ElBghIV;;EkBvhIM;IAOI,wBAAA;ElBohIV;;EkB3hIM;IAOI,+BAAA;ElBwhIV;;EkB/hIM;IAOI,yBAAA;ElB4hIV;;EkBniIM;IAOI,6BAAA;ElBgiIV;;EkBviIM;IAOI,8BAAA;ElBoiIV;;EkB3iIM;IAOI,wBAAA;ElBwiIV;;EkB/iIM;IAOI,+BAAA;ElB4iIV;;EkBnjIM;IAOI,wBAAA;ElBgjIV;;EkBvjIM;IAOI,yBAAA;ElBojIV;;EkB3jIM;IAOI,8BAAA;ElBwjIV;;EkB/jIM;IAOI,iCAAA;ElB4jIV;;EkBnkIM;IAOI,sCAAA;ElBgkIV;;EkBvkIM;IAOI,yCAAA;ElBokIV;;EkB3kIM;IAOI,uBAAA;ElBwkIV;;EkB/kIM;IAOI,uBAAA;ElB4kIV;;EkBnlIM;IAOI,yBAAA;ElBglIV;;EkBvlIM;IAOI,yBAAA;ElBolIV;;EkB3lIM;IAOI,0BAAA;ElBwlIV;;EkB/lIM;IAOI,4BAAA;ElB4lIV;;EkBnmIM;IAOI,kCAAA;ElBgmIV;;EkBvmIM;IAOI,sCAAA;ElBomIV;;EkB3mIM;IAOI,oCAAA;ElBwmIV;;EkB/mIM;IAOI,kCAAA;ElB4mIV;;EkBnnIM;IAOI,yCAAA;ElBgnIV;;EkBvnIM;IAOI,wCAAA;ElBonIV;;EkB3nIM;IAOI,wCAAA;ElBwnIV;;EkB/nIM;IAOI,kCAAA;ElB4nIV;;EkBnoIM;IAOI,gCAAA;ElBgoIV;;EkBvoIM;IAOI,8BAAA;ElBooIV;;EkB3oIM;IAOI,gCAAA;ElBwoIV;;EkB/oIM;IAOI,+BAAA;ElB4oIV;;EkBnpIM;IAOI,oCAAA;ElBgpIV;;EkBvpIM;IAOI,kCAAA;ElBopIV;;EkB3pIM;IAOI,gCAAA;ElBwpIV;;EkB/pIM;IAOI,uCAAA;ElB4pIV;;EkBnqIM;IAOI,sCAAA;ElBgqIV;;EkBvqIM;IAOI,iCAAA;ElBoqIV;;EkB3qIM;IAOI,2BAAA;ElBwqIV;;EkB/qIM;IAOI,iCAAA;ElB4qIV;;EkBnrIM;IAOI,+BAAA;ElBgrIV;;EkBvrIM;IAOI,6BAAA;ElBorIV;;EkB3rIM;IAOI,+BAAA;ElBwrIV;;EkB/rIM;IAOI,8BAAA;ElB4rIV;;EkBnsIM;IAOI,oBAAA;ElBgsIV;;EkBvsIM;IAOI,mBAAA;ElBosIV;;EkB3sIM;IAOI,mBAAA;ElBwsIV;;EkB/sIM;IAOI,mBAAA;ElB4sIV;;EkBntIM;IAOI,mBAAA;ElBgtIV;;EkBvtIM;IAOI,mBAAA;ElBotIV;;EkB3tIM;IAOI,mBAAA;ElBwtIV;;EkB/tIM;IAOI,mBAAA;ElB4tIV;;EkBnuIM;IAOI,oBAAA;ElBguIV;;EkBvuIM;IAOI,0BAAA;ElBouIV;;EkB3uIM;IAOI,yBAAA;ElBwuIV;;EkB/uIM;IAOI,0BAAA;ElB4uIV;;EkBnvIM;IAOI,uBAAA;ElBgvIV;;EkBvvIM;IAOI,0BAAA;ElBovIV;;EkB3vIM;IAOI,yBAAA;ElBwvIV;;EkB/vIM;IAOI,0BAAA;ElB4vIV;;EkBnwIM;IAOI,uBAAA;ElBgwIV;;EkBvwIM;IAOI,0BAAA;ElBowIV;;EkB3wIM;IAOI,yBAAA;ElBwwIV;;EkB/wIM;IAOI,0BAAA;ElB4wIV;;EkBnxIM;IAOI,uBAAA;ElBgxIV;;EkBvxIM;IAOI,0BAAA;ElBoxIV;;EkB3xIM;IAOI,yBAAA;ElBwxIV;;EkB/xIM;IAOI,0BAAA;ElB4xIV;;EkBnyIM;IAOI,uBAAA;ElBgyIV;;EkBvyIM;IAOI,0BAAA;ElBoyIV;;EkB3yIM;IAOI,yBAAA;ElBwyIV;;EkB/yIM;IAOI,0BAAA;ElB4yIV;;EkBnzIM;IAOI,uBAAA;ElBgzIV;;EkBvzIM;IAOI,uBAAA;ElBozIV;;EkB3zIM;IAOI,0BAAA;IAAA,yBAAA;ElByzIV;;EkBh0IM;IAOI,gCAAA;IAAA,+BAAA;ElB8zIV;;EkBr0IM;IAOI,+BAAA;IAAA,8BAAA;ElBm0IV;;EkB10IM;IAOI,gCAAA;IAAA,+BAAA;ElBw0IV;;EkB/0IM;IAOI,6BAAA;IAAA,4BAAA;ElB60IV;;EkBp1IM;IAOI,gCAAA;IAAA,+BAAA;ElBk1IV;;EkBz1IM;IAOI,+BAAA;IAAA,8BAAA;ElBu1IV;;EkB91IM;IAOI,gCAAA;IAAA,+BAAA;ElB41IV;;EkBn2IM;IAOI,6BAAA;IAAA,4BAAA;ElBi2IV;;EkBx2IM;IAOI,gCAAA;IAAA,+BAAA;ElBs2IV;;EkB72IM;IAOI,+BAAA;IAAA,8BAAA;ElB22IV;;EkBl3IM;IAOI,gCAAA;IAAA,+BAAA;ElBg3IV;;EkBv3IM;IAOI,6BAAA;IAAA,4BAAA;ElBq3IV;;EkB53IM;IAOI,gCAAA;IAAA,+BAAA;ElB03IV;;EkBj4IM;IAOI,+BAAA;IAAA,8BAAA;ElB+3IV;;EkBt4IM;IAOI,gCAAA;IAAA,+BAAA;ElBo4IV;;EkB34IM;IAOI,6BAAA;IAAA,4BAAA;ElBy4IV;;EkBh5IM;IAOI,gCAAA;IAAA,+BAAA;ElB84IV;;EkBr5IM;IAOI,+BAAA;IAAA,8BAAA;ElBm5IV;;EkB15IM;IAOI,gCAAA;IAAA,+BAAA;ElBw5IV;;EkB/5IM;IAOI,6BAAA;IAAA,4BAAA;ElB65IV;;EkBp6IM;IAOI,6BAAA;IAAA,4BAAA;ElBk6IV;;EkBz6IM;IAOI,wBAAA;IAAA,2BAAA;ElBu6IV;;EkB96IM;IAOI,8BAAA;IAAA,iCAAA;ElB46IV;;EkBn7IM;IAOI,6BAAA;IAAA,gCAAA;ElBi7IV;;EkBx7IM;IAOI,8BAAA;IAAA,iCAAA;ElBs7IV;;EkB77IM;IAOI,2BAAA;IAAA,8BAAA;ElB27IV;;EkBl8IM;IAOI,8BAAA;IAAA,iCAAA;ElBg8IV;;EkBv8IM;IAOI,6BAAA;IAAA,gCAAA;ElBq8IV;;EkB58IM;IAOI,8BAAA;IAAA,iCAAA;ElB08IV;;EkBj9IM;IAOI,2BAAA;IAAA,8BAAA;ElB+8IV;;EkBt9IM;IAOI,8BAAA;IAAA,iCAAA;ElBo9IV;;EkB39IM;IAOI,6BAAA;IAAA,gCAAA;ElBy9IV;;EkBh+IM;IAOI,8BAAA;IAAA,iCAAA;ElB89IV;;EkBr+IM;IAOI,2BAAA;IAAA,8BAAA;ElBm+IV;;EkB1+IM;IAOI,8BAAA;IAAA,iCAAA;ElBw+IV;;EkB/+IM;IAOI,6BAAA;IAAA,gCAAA;ElB6+IV;;EkBp/IM;IAOI,8BAAA;IAAA,iCAAA;ElBk/IV;;EkBz/IM;IAOI,2BAAA;IAAA,8BAAA;ElBu/IV;;EkB9/IM;IAOI,8BAAA;IAAA,iCAAA;ElB4/IV;;EkBngJM;IAOI,6BAAA;IAAA,gCAAA;ElBigJV;;EkBxgJM;IAOI,8BAAA;IAAA,iCAAA;ElBsgJV;;EkB7gJM;IAOI,2BAAA;IAAA,8BAAA;ElB2gJV;;EkBlhJM;IAOI,2BAAA;IAAA,8BAAA;ElBghJV;;EkBvhJM;IAOI,wBAAA;ElBohJV;;EkB3hJM;IAOI,8BAAA;ElBwhJV;;EkB/hJM;IAOI,6BAAA;ElB4hJV;;EkBniJM;IAOI,8BAAA;ElBgiJV;;EkBviJM;IAOI,2BAAA;ElBoiJV;;EkB3iJM;IAOI,8BAAA;ElBwiJV;;EkB/iJM;IAOI,6BAAA;ElB4iJV;;EkBnjJM;IAOI,8BAAA;ElBgjJV;;EkBvjJM;IAOI,2BAAA;ElBojJV;;EkB3jJM;IAOI,8BAAA;ElBwjJV;;EkB/jJM;IAOI,6BAAA;ElB4jJV;;EkBnkJM;IAOI,8BAAA;ElBgkJV;;EkBvkJM;IAOI,2BAAA;ElBokJV;;EkB3kJM;IAOI,8BAAA;ElBwkJV;;EkB/kJM;IAOI,6BAAA;ElB4kJV;;EkBnlJM;IAOI,8BAAA;ElBglJV;;EkBvlJM;IAOI,2BAAA;ElBolJV;;EkB3lJM;IAOI,8BAAA;ElBwlJV;;EkB/lJM;IAOI,6BAAA;ElB4lJV;;EkBnmJM;IAOI,8BAAA;ElBgmJV;;EkBvmJM;IAOI,2BAAA;ElBomJV;;EkB3mJM;IAOI,2BAAA;ElBwmJV;;EkB/mJM;IAOI,0BAAA;ElB4mJV;;EkBnnJM;IAOI,gCAAA;ElBgnJV;;EkBvnJM;IAOI,+BAAA;ElBonJV;;EkB3nJM;IAOI,gCAAA;ElBwnJV;;EkB/nJM;IAOI,6BAAA;ElB4nJV;;EkBnoJM;IAOI,gCAAA;ElBgoJV;;EkBvoJM;IAOI,+BAAA;ElBooJV;;EkB3oJM;IAOI,gCAAA;ElBwoJV;;EkB/oJM;IAOI,6BAAA;ElB4oJV;;EkBnpJM;IAOI,gCAAA;ElBgpJV;;EkBvpJM;IAOI,+BAAA;ElBopJV;;EkB3pJM;IAOI,gCAAA;ElBwpJV;;EkB/pJM;IAOI,6BAAA;ElB4pJV;;EkBnqJM;IAOI,gCAAA;ElBgqJV;;EkBvqJM;IAOI,+BAAA;ElBoqJV;;EkB3qJM;IAOI,gCAAA;ElBwqJV;;EkB/qJM;IAOI,6BAAA;ElB4qJV;;EkBnrJM;IAOI,gCAAA;ElBgrJV;;EkBvrJM;IAOI,+BAAA;ElBorJV;;EkB3rJM;IAOI,gCAAA;ElBwrJV;;EkB/rJM;IAOI,6BAAA;ElB4rJV;;EkBnsJM;IAOI,6BAAA;ElBgsJV;;EkBvsJM;IAOI,2BAAA;ElBosJV;;EkB3sJM;IAOI,iCAAA;ElBwsJV;;EkB/sJM;IAOI,gCAAA;ElB4sJV;;EkBntJM;IAOI,iCAAA;ElBgtJV;;EkBvtJM;IAOI,8BAAA;ElBotJV;;EkB3tJM;IAOI,iCAAA;ElBwtJV;;EkB/tJM;IAOI,gCAAA;ElB4tJV;;EkBnuJM;IAOI,iCAAA;ElBguJV;;EkBvuJM;IAOI,8BAAA;ElBouJV;;EkB3uJM;IAOI,iCAAA;ElBwuJV;;EkB/uJM;IAOI,gCAAA;ElB4uJV;;EkBnvJM;IAOI,iCAAA;ElBgvJV;;EkBvvJM;IAOI,8BAAA;ElBovJV;;EkB3vJM;IAOI,iCAAA;ElBwvJV;;EkB/vJM;IAOI,gCAAA;ElB4vJV;;EkBnwJM;IAOI,iCAAA;ElBgwJV;;EkBvwJM;IAOI,8BAAA;ElBowJV;;EkB3wJM;IAOI,iCAAA;ElBwwJV;;EkB/wJM;IAOI,gCAAA;ElB4wJV;;EkBnxJM;IAOI,iCAAA;ElBgxJV;;EkBvxJM;IAOI,8BAAA;ElBoxJV;;EkB3xJM;IAOI,8BAAA;ElBwxJV;;EkB/xJM;IAOI,yBAAA;ElB4xJV;;EkBnyJM;IAOI,+BAAA;ElBgyJV;;EkBvyJM;IAOI,8BAAA;ElBoyJV;;EkB3yJM;IAOI,+BAAA;ElBwyJV;;EkB/yJM;IAOI,4BAAA;ElB4yJV;;EkBnzJM;IAOI,+BAAA;ElBgzJV;;EkBvzJM;IAOI,8BAAA;ElBozJV;;EkB3zJM;IAOI,+BAAA;ElBwzJV;;EkB/zJM;IAOI,4BAAA;ElB4zJV;;EkBn0JM;IAOI,+BAAA;ElBg0JV;;EkBv0JM;IAOI,8BAAA;ElBo0JV;;EkB30JM;IAOI,+BAAA;ElBw0JV;;EkB/0JM;IAOI,4BAAA;ElB40JV;;EkBn1JM;IAOI,+BAAA;ElBg1JV;;EkBv1JM;IAOI,8BAAA;ElBo1JV;;EkB31JM;IAOI,+BAAA;ElBw1JV;;EkB/1JM;IAOI,4BAAA;ElB41JV;;EkBn2JM;IAOI,+BAAA;ElBg2JV;;EkBv2JM;IAOI,8BAAA;ElBo2JV;;EkB32JM;IAOI,+BAAA;ElBw2JV;;EkB/2JM;IAOI,4BAAA;ElB42JV;;EkBn3JM;IAOI,4BAAA;ElBg3JV;;EkBv3JM;IAOI,2BAAA;ElBo3JV;;EkB33JM;IAOI,0BAAA;ElBw3JV;;EkB/3JM;IAOI,2BAAA;ElB43JV;;EkBn4JM;IAOI,wBAAA;ElBg4JV;;EkBv4JM;IAOI,2BAAA;ElBo4JV;;EkB34JM;IAOI,0BAAA;ElBw4JV;;EkB/4JM;IAOI,2BAAA;ElB44JV;;EkBn5JM;IAOI,wBAAA;ElBg5JV;;EkBv5JM;IAOI,2BAAA;ElBo5JV;;EkB35JM;IAOI,0BAAA;ElBw5JV;;EkB/5JM;IAOI,2BAAA;ElB45JV;;EkBn6JM;IAOI,wBAAA;ElBg6JV;;EkBv6JM;IAOI,2BAAA;ElBo6JV;;EkB36JM;IAOI,0BAAA;ElBw6JV;;EkB/6JM;IAOI,2BAAA;ElB46JV;;EkBn7JM;IAOI,wBAAA;ElBg7JV;;EkBv7JM;IAOI,2BAAA;ElBo7JV;;EkB37JM;IAOI,0BAAA;ElBw7JV;;EkB/7JM;IAOI,2BAAA;ElB47JV;;EkBn8JM;IAOI,wBAAA;ElBg8JV;;EkBv8JM;IAOI,iCAAA;IAAA,gCAAA;ElBq8JV;;EkB58JM;IAOI,gCAAA;IAAA,+BAAA;ElB08JV;;EkBj9JM;IAOI,iCAAA;IAAA,gCAAA;ElB+8JV;;EkBt9JM;IAOI,8BAAA;IAAA,6BAAA;ElBo9JV;;EkB39JM;IAOI,iCAAA;IAAA,gCAAA;ElBy9JV;;EkBh+JM;IAOI,gCAAA;IAAA,+BAAA;ElB89JV;;EkBr+JM;IAOI,iCAAA;IAAA,gCAAA;ElBm+JV;;EkB1+JM;IAOI,8BAAA;IAAA,6BAAA;ElBw+JV;;EkB/+JM;IAOI,iCAAA;IAAA,gCAAA;ElB6+JV;;EkBp/JM;IAOI,gCAAA;IAAA,+BAAA;ElBk/JV;;EkBz/JM;IAOI,iCAAA;IAAA,gCAAA;ElBu/JV;;EkB9/JM;IAOI,8BAAA;IAAA,6BAAA;ElB4/JV;;EkBngKM;IAOI,iCAAA;IAAA,gCAAA;ElBigKV;;EkBxgKM;IAOI,gCAAA;IAAA,+BAAA;ElBsgKV;;EkB7gKM;IAOI,iCAAA;IAAA,gCAAA;ElB2gKV;;EkBlhKM;IAOI,8BAAA;IAAA,6BAAA;ElBghKV;;EkBvhKM;IAOI,iCAAA;IAAA,gCAAA;ElBqhKV;;EkB5hKM;IAOI,gCAAA;IAAA,+BAAA;ElB0hKV;;EkBjiKM;IAOI,iCAAA;IAAA,gCAAA;ElB+hKV;;EkBtiKM;IAOI,8BAAA;IAAA,6BAAA;ElBoiKV;;EkB3iKM;IAOI,+BAAA;IAAA,kCAAA;ElByiKV;;EkBhjKM;IAOI,8BAAA;IAAA,iCAAA;ElB8iKV;;EkBrjKM;IAOI,+BAAA;IAAA,kCAAA;ElBmjKV;;EkB1jKM;IAOI,4BAAA;IAAA,+BAAA;ElBwjKV;;EkB/jKM;IAOI,+BAAA;IAAA,kCAAA;ElB6jKV;;EkBpkKM;IAOI,8BAAA;IAAA,iCAAA;ElBkkKV;;EkBzkKM;IAOI,+BAAA;IAAA,kCAAA;ElBukKV;;EkB9kKM;IAOI,4BAAA;IAAA,+BAAA;ElB4kKV;;EkBnlKM;IAOI,+BAAA;IAAA,kCAAA;ElBilKV;;EkBxlKM;IAOI,8BAAA;IAAA,iCAAA;ElBslKV;;EkB7lKM;IAOI,+BAAA;IAAA,kCAAA;ElB2lKV;;EkBlmKM;IAOI,4BAAA;IAAA,+BAAA;ElBgmKV;;EkBvmKM;IAOI,+BAAA;IAAA,kCAAA;ElBqmKV;;EkB5mKM;IAOI,8BAAA;IAAA,iCAAA;ElB0mKV;;EkBjnKM;IAOI,+BAAA;IAAA,kCAAA;ElB+mKV;;EkBtnKM;IAOI,4BAAA;IAAA,+BAAA;ElBonKV;;EkB3nKM;IAOI,+BAAA;IAAA,kCAAA;ElBynKV;;EkBhoKM;IAOI,8BAAA;IAAA,iCAAA;ElB8nKV;;EkBroKM;IAOI,+BAAA;IAAA,kCAAA;ElBmoKV;;EkB1oKM;IAOI,4BAAA;IAAA,+BAAA;ElBwoKV;;EkB/oKM;IAOI,+BAAA;ElB4oKV;;EkBnpKM;IAOI,8BAAA;ElBgpKV;;EkBvpKM;IAOI,+BAAA;ElBopKV;;EkB3pKM;IAOI,4BAAA;ElBwpKV;;EkB/pKM;IAOI,+BAAA;ElB4pKV;;EkBnqKM;IAOI,8BAAA;ElBgqKV;;EkBvqKM;IAOI,+BAAA;ElBoqKV;;EkB3qKM;IAOI,4BAAA;ElBwqKV;;EkB/qKM;IAOI,+BAAA;ElB4qKV;;EkBnrKM;IAOI,8BAAA;ElBgrKV;;EkBvrKM;IAOI,+BAAA;ElBorKV;;EkB3rKM;IAOI,4BAAA;ElBwrKV;;EkB/rKM;IAOI,+BAAA;ElB4rKV;;EkBnsKM;IAOI,8BAAA;ElBgsKV;;EkBvsKM;IAOI,+BAAA;ElBosKV;;EkB3sKM;IAOI,4BAAA;ElBwsKV;;EkB/sKM;IAOI,+BAAA;ElB4sKV;;EkBntKM;IAOI,8BAAA;ElBgtKV;;EkBvtKM;IAOI,+BAAA;ElBotKV;;EkB3tKM;IAOI,4BAAA;ElBwtKV;;EkB/tKM;IAOI,iCAAA;ElB4tKV;;EkBnuKM;IAOI,gCAAA;ElBguKV;;EkBvuKM;IAOI,iCAAA;ElBouKV;;EkB3uKM;IAOI,8BAAA;ElBwuKV;;EkB/uKM;IAOI,iCAAA;ElB4uKV;;EkBnvKM;IAOI,gCAAA;ElBgvKV;;EkBvvKM;IAOI,iCAAA;ElBovKV;;EkB3vKM;IAOI,8BAAA;ElBwvKV;;EkB/vKM;IAOI,iCAAA;ElB4vKV;;EkBnwKM;IAOI,gCAAA;ElBgwKV;;EkBvwKM;IAOI,iCAAA;ElBowKV;;EkB3wKM;IAOI,8BAAA;ElBwwKV;;EkB/wKM;IAOI,iCAAA;ElB4wKV;;EkBnxKM;IAOI,gCAAA;ElBgxKV;;EkBvxKM;IAOI,iCAAA;ElBoxKV;;EkB3xKM;IAOI,8BAAA;ElBwxKV;;EkB/xKM;IAOI,iCAAA;ElB4xKV;;EkBnyKM;IAOI,gCAAA;ElBgyKV;;EkBvyKM;IAOI,iCAAA;ElBoyKV;;EkB3yKM;IAOI,8BAAA;ElBwyKV;;EkB/yKM;IAOI,kCAAA;ElB4yKV;;EkBnzKM;IAOI,iCAAA;ElBgzKV;;EkBvzKM;IAOI,kCAAA;ElBozKV;;EkB3zKM;IAOI,+BAAA;ElBwzKV;;EkB/zKM;IAOI,kCAAA;ElB4zKV;;EkBn0KM;IAOI,iCAAA;ElBg0KV;;EkBv0KM;IAOI,kCAAA;ElBo0KV;;EkB30KM;IAOI,+BAAA;ElBw0KV;;EkB/0KM;IAOI,kCAAA;ElB40KV;;EkBn1KM;IAOI,iCAAA;ElBg1KV;;EkBv1KM;IAOI,kCAAA;ElBo1KV;;EkB31KM;IAOI,+BAAA;ElBw1KV;;EkB/1KM;IAOI,kCAAA;ElB41KV;;EkBn2KM;IAOI,iCAAA;ElBg2KV;;EkBv2KM;IAOI,kCAAA;ElBo2KV;;EkB32KM;IAOI,+BAAA;ElBw2KV;;EkB/2KM;IAOI,kCAAA;ElB42KV;;EkBn3KM;IAOI,iCAAA;ElBg3KV;;EkBv3KM;IAOI,kCAAA;ElBo3KV;;EkB33KM;IAOI,+BAAA;ElBw3KV;;EkB/3KM;IAOI,gCAAA;ElB43KV;;EkBn4KM;IAOI,+BAAA;ElBg4KV;;EkBv4KM;IAOI,gCAAA;ElBo4KV;;EkB34KM;IAOI,6BAAA;ElBw4KV;;EkB/4KM;IAOI,gCAAA;ElB44KV;;EkBn5KM;IAOI,+BAAA;ElBg5KV;;EkBv5KM;IAOI,gCAAA;ElBo5KV;;EkB35KM;IAOI,6BAAA;ElBw5KV;;EkB/5KM;IAOI,gCAAA;ElB45KV;;EkBn6KM;IAOI,+BAAA;ElBg6KV;;EkBv6KM;IAOI,gCAAA;ElBo6KV;;EkB36KM;IAOI,6BAAA;ElBw6KV;;EkB/6KM;IAOI,gCAAA;ElB46KV;;EkBn7KM;IAOI,+BAAA;ElBg7KV;;EkBv7KM;IAOI,gCAAA;ElBo7KV;;EkB37KM;IAOI,6BAAA;ElBw7KV;;EkB/7KM;IAOI,gCAAA;ElB47KV;;EkBn8KM;IAOI,+BAAA;ElBg8KV;;EkBv8KM;IAOI,gCAAA;ElBo8KV;;EkB38KM;IAOI,6BAAA;ElBw8KV;;EkB/8KM;IAOI,qBAAA;ElB48KV;;EkBn9KM;IAOI,2BAAA;ElBg9KV;;EkBv9KM;IAOI,0BAAA;ElBo9KV;;EkB39KM;IAOI,2BAAA;ElBw9KV;;EkB/9KM;IAOI,wBAAA;ElB49KV;;EkBn+KM;IAOI,2BAAA;ElBg+KV;;EkBv+KM;IAOI,0BAAA;ElBo+KV;;EkB3+KM;IAOI,2BAAA;ElBw+KV;;EkB/+KM;IAOI,wBAAA;ElB4+KV;;EkBn/KM;IAOI,2BAAA;ElBg/KV;;EkBv/KM;IAOI,0BAAA;ElBo/KV;;EkB3/KM;IAOI,2BAAA;ElBw/KV;;EkB//KM;IAOI,wBAAA;ElB4/KV;;EkBngLM;IAOI,2BAAA;ElBggLV;;EkBvgLM;IAOI,0BAAA;ElBogLV;;EkB3gLM;IAOI,2BAAA;ElBwgLV;;EkB/gLM;IAOI,wBAAA;ElB4gLV;;EkBnhLM;IAOI,2BAAA;ElBghLV;;EkBvhLM;IAOI,0BAAA;ElBohLV;;EkB3hLM;IAOI,2BAAA;ElBwhLV;;EkB/hLM;IAOI,wBAAA;ElB4hLV;;EkBniLM;IAOI,2BAAA;IAAA,0BAAA;ElBiiLV;;EkBxiLM;IAOI,iCAAA;IAAA,gCAAA;ElBsiLV;;EkB7iLM;IAOI,gCAAA;IAAA,+BAAA;ElB2iLV;;EkBljLM;IAOI,iCAAA;IAAA,gCAAA;ElBgjLV;;EkBvjLM;IAOI,8BAAA;IAAA,6BAAA;ElBqjLV;;EkB5jLM;IAOI,iCAAA;IAAA,gCAAA;ElB0jLV;;EkBjkLM;IAOI,gCAAA;IAAA,+BAAA;ElB+jLV;;EkBtkLM;IAOI,iCAAA;IAAA,gCAAA;ElBokLV;;EkB3kLM;IAOI,8BAAA;IAAA,6BAAA;ElBykLV;;EkBhlLM;IAOI,iCAAA;IAAA,gCAAA;ElB8kLV;;EkBrlLM;IAOI,gCAAA;IAAA,+BAAA;ElBmlLV;;EkB1lLM;IAOI,iCAAA;IAAA,gCAAA;ElBwlLV;;EkB/lLM;IAOI,8BAAA;IAAA,6BAAA;ElB6lLV;;EkBpmLM;IAOI,iCAAA;IAAA,gCAAA;ElBkmLV;;EkBzmLM;IAOI,gCAAA;IAAA,+BAAA;ElBumLV;;EkB9mLM;IAOI,iCAAA;IAAA,gCAAA;ElB4mLV;;EkBnnLM;IAOI,8BAAA;IAAA,6BAAA;ElBinLV;;EkBxnLM;IAOI,iCAAA;IAAA,gCAAA;ElBsnLV;;EkB7nLM;IAOI,gCAAA;IAAA,+BAAA;ElB2nLV;;EkBloLM;IAOI,iCAAA;IAAA,gCAAA;ElBgoLV;;EkBvoLM;IAOI,8BAAA;IAAA,6BAAA;ElBqoLV;;EkB5oLM;IAOI,yBAAA;IAAA,4BAAA;ElB0oLV;;EkBjpLM;IAOI,+BAAA;IAAA,kCAAA;ElB+oLV;;EkBtpLM;IAOI,8BAAA;IAAA,iCAAA;ElBopLV;;EkB3pLM;IAOI,+BAAA;IAAA,kCAAA;ElBypLV;;EkBhqLM;IAOI,4BAAA;IAAA,+BAAA;ElB8pLV;;EkBrqLM;IAOI,+BAAA;IAAA,kCAAA;ElBmqLV;;EkB1qLM;IAOI,8BAAA;IAAA,iCAAA;ElBwqLV;;EkB/qLM;IAOI,+BAAA;IAAA,kCAAA;ElB6qLV;;EkBprLM;IAOI,4BAAA;IAAA,+BAAA;ElBkrLV;;EkBzrLM;IAOI,+BAAA;IAAA,kCAAA;ElBurLV;;EkB9rLM;IAOI,8BAAA;IAAA,iCAAA;ElB4rLV;;EkBnsLM;IAOI,+BAAA;IAAA,kCAAA;ElBisLV;;EkBxsLM;IAOI,4BAAA;IAAA,+BAAA;ElBssLV;;EkB7sLM;IAOI,+BAAA;IAAA,kCAAA;ElB2sLV;;EkBltLM;IAOI,8BAAA;IAAA,iCAAA;ElBgtLV;;EkBvtLM;IAOI,+BAAA;IAAA,kCAAA;ElBqtLV;;EkB5tLM;IAOI,4BAAA;IAAA,+BAAA;ElB0tLV;;EkBjuLM;IAOI,+BAAA;IAAA,kCAAA;ElB+tLV;;EkBtuLM;IAOI,8BAAA;IAAA,iCAAA;ElBouLV;;EkB3uLM;IAOI,+BAAA;IAAA,kCAAA;ElByuLV;;EkBhvLM;IAOI,4BAAA;IAAA,+BAAA;ElB8uLV;;EkBrvLM;IAOI,yBAAA;ElBkvLV;;EkBzvLM;IAOI,+BAAA;ElBsvLV;;EkB7vLM;IAOI,8BAAA;ElB0vLV;;EkBjwLM;IAOI,+BAAA;ElB8vLV;;EkBrwLM;IAOI,4BAAA;ElBkwLV;;EkBzwLM;IAOI,+BAAA;ElBswLV;;EkB7wLM;IAOI,8BAAA;ElB0wLV;;EkBjxLM;IAOI,+BAAA;ElB8wLV;;EkBrxLM;IAOI,4BAAA;ElBkxLV;;EkBzxLM;IAOI,+BAAA;ElBsxLV;;EkB7xLM;IAOI,8BAAA;ElB0xLV;;EkBjyLM;IAOI,+BAAA;ElB8xLV;;EkBryLM;IAOI,4BAAA;ElBkyLV;;EkBzyLM;IAOI,+BAAA;ElBsyLV;;EkB7yLM;IAOI,8BAAA;ElB0yLV;;EkBjzLM;IAOI,+BAAA;ElB8yLV;;EkBrzLM;IAOI,4BAAA;ElBkzLV;;EkBzzLM;IAOI,+BAAA;ElBszLV;;EkB7zLM;IAOI,8BAAA;ElB0zLV;;EkBj0LM;IAOI,+BAAA;ElB8zLV;;EkBr0LM;IAOI,4BAAA;ElBk0LV;;EkBz0LM;IAOI,2BAAA;ElBs0LV;;EkB70LM;IAOI,iCAAA;ElB00LV;;EkBj1LM;IAOI,gCAAA;ElB80LV;;EkBr1LM;IAOI,iCAAA;ElBk1LV;;EkBz1LM;IAOI,8BAAA;ElBs1LV;;EkB71LM;IAOI,iCAAA;ElB01LV;;EkBj2LM;IAOI,gCAAA;ElB81LV;;EkBr2LM;IAOI,iCAAA;ElBk2LV;;EkBz2LM;IAOI,8BAAA;ElBs2LV;;EkB72LM;IAOI,iCAAA;ElB02LV;;EkBj3LM;IAOI,gCAAA;ElB82LV;;EkBr3LM;IAOI,iCAAA;ElBk3LV;;EkBz3LM;IAOI,8BAAA;ElBs3LV;;EkB73LM;IAOI,iCAAA;ElB03LV;;EkBj4LM;IAOI,gCAAA;ElB83LV;;EkBr4LM;IAOI,iCAAA;ElBk4LV;;EkBz4LM;IAOI,8BAAA;ElBs4LV;;EkB74LM;IAOI,iCAAA;ElB04LV;;EkBj5LM;IAOI,gCAAA;ElB84LV;;EkBr5LM;IAOI,iCAAA;ElBk5LV;;EkBz5LM;IAOI,8BAAA;ElBs5LV;;EkB75LM;IAOI,4BAAA;ElB05LV;;EkBj6LM;IAOI,kCAAA;ElB85LV;;EkBr6LM;IAOI,iCAAA;ElBk6LV;;EkBz6LM;IAOI,kCAAA;ElBs6LV;;EkB76LM;IAOI,+BAAA;ElB06LV;;EkBj7LM;IAOI,kCAAA;ElB86LV;;EkBr7LM;IAOI,iCAAA;ElBk7LV;;EkBz7LM;IAOI,kCAAA;ElBs7LV;;EkB77LM;IAOI,+BAAA;ElB07LV;;EkBj8LM;IAOI,kCAAA;ElB87LV;;EkBr8LM;IAOI,iCAAA;ElBk8LV;;EkBz8LM;IAOI,kCAAA;ElBs8LV;;EkB78LM;IAOI,+BAAA;ElB08LV;;EkBj9LM;IAOI,kCAAA;ElB88LV;;EkBr9LM;IAOI,iCAAA;ElBk9LV;;EkBz9LM;IAOI,kCAAA;ElBs9LV;;EkB79LM;IAOI,+BAAA;ElB09LV;;EkBj+LM;IAOI,kCAAA;ElB89LV;;EkBr+LM;IAOI,iCAAA;ElBk+LV;;EkBz+LM;IAOI,kCAAA;ElBs+LV;;EkB7+LM;IAOI,+BAAA;ElB0+LV;;EkBj/LM;IAOI,0BAAA;ElB8+LV;;EkBr/LM;IAOI,gCAAA;ElBk/LV;;EkBz/LM;IAOI,+BAAA;ElBs/LV;;EkB7/LM;IAOI,gCAAA;ElB0/LV;;EkBjgMM;IAOI,6BAAA;ElB8/LV;;EkBrgMM;IAOI,gCAAA;ElBkgMV;;EkBzgMM;IAOI,+BAAA;ElBsgMV;;EkB7gMM;IAOI,gCAAA;ElB0gMV;;EkBjhMM;IAOI,6BAAA;ElB8gMV;;EkBrhMM;IAOI,gCAAA;ElBkhMV;;EkBzhMM;IAOI,+BAAA;ElBshMV;;EkB7hMM;IAOI,gCAAA;ElB0hMV;;EkBjiMM;IAOI,6BAAA;ElB8hMV;;EkBriMM;IAOI,gCAAA;ElBkiMV;;EkBziMM;IAOI,+BAAA;ElBsiMV;;EkB7iMM;IAOI,gCAAA;ElB0iMV;;EkBjjMM;IAOI,6BAAA;ElB8iMV;;EkBrjMM;IAOI,gCAAA;ElBkjMV;;EkBzjMM;IAOI,+BAAA;ElBsjMV;;EkB7jMM;IAOI,gCAAA;ElB0jMV;;EkBjkMM;IAOI,6BAAA;ElB8jMV;;EkBrkMM;IAOI,iBAAA;ElBkkMV;;EkBzkMM;IAOI,uBAAA;ElBskMV;;EkB7kMM;IAOI,sBAAA;ElB0kMV;;EkBjlMM;IAOI,uBAAA;ElB8kMV;;EkBrlMM;IAOI,oBAAA;ElBklMV;;EkBzlMM;IAOI,uBAAA;ElBslMV;;EkB7lMM;IAOI,sBAAA;ElB0lMV;;EkBjmMM;IAOI,uBAAA;ElB8lMV;;EkBrmMM;IAOI,oBAAA;ElBkmMV;;EkBzmMM;IAOI,uBAAA;ElBsmMV;;EkB7mMM;IAOI,sBAAA;ElB0mMV;;EkBjnMM;IAOI,uBAAA;ElB8mMV;;EkBrnMM;IAOI,oBAAA;ElBknMV;;EkBznMM;IAOI,uBAAA;ElBsnMV;;EkB7nMM;IAOI,sBAAA;ElB0nMV;;EkBjoMM;IAOI,uBAAA;ElB8nMV;;EkBroMM;IAOI,oBAAA;ElBkoMV;;EkBzoMM;IAOI,uBAAA;ElBsoMV;;EkB7oMM;IAOI,sBAAA;ElB0oMV;;EkBjpMM;IAOI,uBAAA;ElB8oMV;;EkBrpMM;IAOI,oBAAA;ElBkpMV;;EkBzpMM;IAOI,qBAAA;ElBspMV;;EkB7pMM;IAOI,2BAAA;ElB0pMV;;EkBjqMM;IAOI,0BAAA;ElB8pMV;;EkBrqMM;IAOI,2BAAA;ElBkqMV;;EkBzqMM;IAOI,wBAAA;ElBsqMV;;EkB7qMM;IAOI,2BAAA;ElB0qMV;;EkBjrMM;IAOI,0BAAA;ElB8qMV;;EkBrrMM;IAOI,2BAAA;ElBkrMV;;EkBzrMM;IAOI,wBAAA;ElBsrMV;;EkB7rMM;IAOI,2BAAA;ElB0rMV;;EkBjsMM;IAOI,0BAAA;ElB8rMV;;EkBrsMM;IAOI,2BAAA;ElBksMV;;EkBzsMM;IAOI,wBAAA;ElBssMV;;EkB7sMM;IAOI,2BAAA;ElB0sMV;;EkBjtMM;IAOI,0BAAA;ElB8sMV;;EkBrtMM;IAOI,2BAAA;ElBktMV;;EkBztMM;IAOI,wBAAA;ElBstMV;;EkB7tMM;IAOI,2BAAA;ElB0tMV;;EkBjuMM;IAOI,0BAAA;ElB8tMV;;EkBruMM;IAOI,2BAAA;ElBkuMV;;EkBzuMM;IAOI,wBAAA;ElBsuMV;;EkB7uMM;IAOI,wBAAA;ElB0uMV;;EkBjvMM;IAOI,8BAAA;ElB8uMV;;EkBrvMM;IAOI,6BAAA;ElBkvMV;;EkBzvMM;IAOI,8BAAA;ElBsvMV;;EkB7vMM;IAOI,2BAAA;ElB0vMV;;EkBjwMM;IAOI,8BAAA;ElB8vMV;;EkBrwMM;IAOI,6BAAA;ElBkwMV;;EkBzwMM;IAOI,8BAAA;ElBswMV;;EkB7wMM;IAOI,2BAAA;ElB0wMV;;EkBjxMM;IAOI,8BAAA;ElB8wMV;;EkBrxMM;IAOI,6BAAA;ElBkxMV;;EkBzxMM;IAOI,8BAAA;ElBsxMV;;EkB7xMM;IAOI,2BAAA;ElB0xMV;;EkBjyMM;IAOI,8BAAA;ElB8xMV;;EkBryMM;IAOI,6BAAA;ElBkyMV;;EkBzyMM;IAOI,8BAAA;ElBsyMV;;EkB7yMM;IAOI,2BAAA;ElB0yMV;;EkBjzMM;IAOI,8BAAA;ElB8yMV;;EkBrzMM;IAOI,6BAAA;ElBkzMV;;EkBzzMM;IAOI,8BAAA;ElBszMV;;EkB7zMM;IAOI,2BAAA;ElB0zMV;;EkBj0MM;IAOI,2BAAA;ElB8zMV;;EkBr0MM;IAOI,4BAAA;ElBk0MV;;EkBz0MM;IAOI,6BAAA;ElBs0MV;AACF;AUj1MI;EQGI;IAOI,sBAAA;ElB20MV;;EkBl1MM;IAOI,uBAAA;ElB+0MV;;EkBt1MM;IAOI,sBAAA;ElBm1MV;;EkB11MM;IAOI,8BAAA;ElBu1MV;;EkB91MM;IAOI,4BAAA;ElB21MV;;EkBl2MM;IAOI,2BAAA;ElB+1MV;;EkBt2MM;IAOI,iCAAA;ElBm2MV;;EkB12MM;IAOI,2BAAA;ElBu2MV;;EkB92MM;IAOI,0BAAA;ElB22MV;;EkBl3MM;IAOI,gCAAA;ElB+2MV;;EkBt3MM;IAOI,yBAAA;ElBm3MV;;EkB13MM;IAOI,wBAAA;ElBu3MV;;EkB93MM;IAOI,+BAAA;ElB23MV;;EkBl4MM;IAOI,yBAAA;ElB+3MV;;EkBt4MM;IAOI,6BAAA;ElBm4MV;;EkB14MM;IAOI,8BAAA;ElBu4MV;;EkB94MM;IAOI,wBAAA;ElB24MV;;EkBl5MM;IAOI,+BAAA;ElB+4MV;;EkBt5MM;IAOI,wBAAA;ElBm5MV;;EkB15MM;IAOI,yBAAA;ElBu5MV;;EkB95MM;IAOI,8BAAA;ElB25MV;;EkBl6MM;IAOI,iCAAA;ElB+5MV;;EkBt6MM;IAOI,sCAAA;ElBm6MV;;EkB16MM;IAOI,yCAAA;ElBu6MV;;EkB96MM;IAOI,uBAAA;ElB26MV;;EkBl7MM;IAOI,uBAAA;ElB+6MV;;EkBt7MM;IAOI,yBAAA;ElBm7MV;;EkB17MM;IAOI,yBAAA;ElBu7MV;;EkB97MM;IAOI,0BAAA;ElB27MV;;EkBl8MM;IAOI,4BAAA;ElB+7MV;;EkBt8MM;IAOI,kCAAA;ElBm8MV;;EkB18MM;IAOI,sCAAA;ElBu8MV;;EkB98MM;IAOI,oCAAA;ElB28MV;;EkBl9MM;IAOI,kCAAA;ElB+8MV;;EkBt9MM;IAOI,yCAAA;ElBm9MV;;EkB19MM;IAOI,wCAAA;ElBu9MV;;EkB99MM;IAOI,wCAAA;ElB29MV;;EkBl+MM;IAOI,kCAAA;ElB+9MV;;EkBt+MM;IAOI,gCAAA;ElBm+MV;;EkB1+MM;IAOI,8BAAA;ElBu+MV;;EkB9+MM;IAOI,gCAAA;ElB2+MV;;EkBl/MM;IAOI,+BAAA;ElB++MV;;EkBt/MM;IAOI,oCAAA;ElBm/MV;;EkB1/MM;IAOI,kCAAA;ElBu/MV;;EkB9/MM;IAOI,gCAAA;ElB2/MV;;EkBlgNM;IAOI,uCAAA;ElB+/MV;;EkBtgNM;IAOI,sCAAA;ElBmgNV;;EkB1gNM;IAOI,iCAAA;ElBugNV;;EkB9gNM;IAOI,2BAAA;ElB2gNV;;EkBlhNM;IAOI,iCAAA;ElB+gNV;;EkBthNM;IAOI,+BAAA;ElBmhNV;;EkB1hNM;IAOI,6BAAA;ElBuhNV;;EkB9hNM;IAOI,+BAAA;ElB2hNV;;EkBliNM;IAOI,8BAAA;ElB+hNV;;EkBtiNM;IAOI,oBAAA;ElBmiNV;;EkB1iNM;IAOI,mBAAA;ElBuiNV;;EkB9iNM;IAOI,mBAAA;ElB2iNV;;EkBljNM;IAOI,mBAAA;ElB+iNV;;EkBtjNM;IAOI,mBAAA;ElBmjNV;;EkB1jNM;IAOI,mBAAA;ElBujNV;;EkB9jNM;IAOI,mBAAA;ElB2jNV;;EkBlkNM;IAOI,mBAAA;ElB+jNV;;EkBtkNM;IAOI,oBAAA;ElBmkNV;;EkB1kNM;IAOI,0BAAA;ElBukNV;;EkB9kNM;IAOI,yBAAA;ElB2kNV;;EkBllNM;IAOI,0BAAA;ElB+kNV;;EkBtlNM;IAOI,uBAAA;ElBmlNV;;EkB1lNM;IAOI,0BAAA;ElBulNV;;EkB9lNM;IAOI,yBAAA;ElB2lNV;;EkBlmNM;IAOI,0BAAA;ElB+lNV;;EkBtmNM;IAOI,uBAAA;ElBmmNV;;EkB1mNM;IAOI,0BAAA;ElBumNV;;EkB9mNM;IAOI,yBAAA;ElB2mNV;;EkBlnNM;IAOI,0BAAA;ElB+mNV;;EkBtnNM;IAOI,uBAAA;ElBmnNV;;EkB1nNM;IAOI,0BAAA;ElBunNV;;EkB9nNM;IAOI,yBAAA;ElB2nNV;;EkBloNM;IAOI,0BAAA;ElB+nNV;;EkBtoNM;IAOI,uBAAA;ElBmoNV;;EkB1oNM;IAOI,0BAAA;ElBuoNV;;EkB9oNM;IAOI,yBAAA;ElB2oNV;;EkBlpNM;IAOI,0BAAA;ElB+oNV;;EkBtpNM;IAOI,uBAAA;ElBmpNV;;EkB1pNM;IAOI,uBAAA;ElBupNV;;EkB9pNM;IAOI,0BAAA;IAAA,yBAAA;ElB4pNV;;EkBnqNM;IAOI,gCAAA;IAAA,+BAAA;ElBiqNV;;EkBxqNM;IAOI,+BAAA;IAAA,8BAAA;ElBsqNV;;EkB7qNM;IAOI,gCAAA;IAAA,+BAAA;ElB2qNV;;EkBlrNM;IAOI,6BAAA;IAAA,4BAAA;ElBgrNV;;EkBvrNM;IAOI,gCAAA;IAAA,+BAAA;ElBqrNV;;EkB5rNM;IAOI,+BAAA;IAAA,8BAAA;ElB0rNV;;EkBjsNM;IAOI,gCAAA;IAAA,+BAAA;ElB+rNV;;EkBtsNM;IAOI,6BAAA;IAAA,4BAAA;ElBosNV;;EkB3sNM;IAOI,gCAAA;IAAA,+BAAA;ElBysNV;;EkBhtNM;IAOI,+BAAA;IAAA,8BAAA;ElB8sNV;;EkBrtNM;IAOI,gCAAA;IAAA,+BAAA;ElBmtNV;;EkB1tNM;IAOI,6BAAA;IAAA,4BAAA;ElBwtNV;;EkB/tNM;IAOI,gCAAA;IAAA,+BAAA;ElB6tNV;;EkBpuNM;IAOI,+BAAA;IAAA,8BAAA;ElBkuNV;;EkBzuNM;IAOI,gCAAA;IAAA,+BAAA;ElBuuNV;;EkB9uNM;IAOI,6BAAA;IAAA,4BAAA;ElB4uNV;;EkBnvNM;IAOI,gCAAA;IAAA,+BAAA;ElBivNV;;EkBxvNM;IAOI,+BAAA;IAAA,8BAAA;ElBsvNV;;EkB7vNM;IAOI,gCAAA;IAAA,+BAAA;ElB2vNV;;EkBlwNM;IAOI,6BAAA;IAAA,4BAAA;ElBgwNV;;EkBvwNM;IAOI,6BAAA;IAAA,4BAAA;ElBqwNV;;EkB5wNM;IAOI,wBAAA;IAAA,2BAAA;ElB0wNV;;EkBjxNM;IAOI,8BAAA;IAAA,iCAAA;ElB+wNV;;EkBtxNM;IAOI,6BAAA;IAAA,gCAAA;ElBoxNV;;EkB3xNM;IAOI,8BAAA;IAAA,iCAAA;ElByxNV;;EkBhyNM;IAOI,2BAAA;IAAA,8BAAA;ElB8xNV;;EkBryNM;IAOI,8BAAA;IAAA,iCAAA;ElBmyNV;;EkB1yNM;IAOI,6BAAA;IAAA,gCAAA;ElBwyNV;;EkB/yNM;IAOI,8BAAA;IAAA,iCAAA;ElB6yNV;;EkBpzNM;IAOI,2BAAA;IAAA,8BAAA;ElBkzNV;;EkBzzNM;IAOI,8BAAA;IAAA,iCAAA;ElBuzNV;;EkB9zNM;IAOI,6BAAA;IAAA,gCAAA;ElB4zNV;;EkBn0NM;IAOI,8BAAA;IAAA,iCAAA;ElBi0NV;;EkBx0NM;IAOI,2BAAA;IAAA,8BAAA;ElBs0NV;;EkB70NM;IAOI,8BAAA;IAAA,iCAAA;ElB20NV;;EkBl1NM;IAOI,6BAAA;IAAA,gCAAA;ElBg1NV;;EkBv1NM;IAOI,8BAAA;IAAA,iCAAA;ElBq1NV;;EkB51NM;IAOI,2BAAA;IAAA,8BAAA;ElB01NV;;EkBj2NM;IAOI,8BAAA;IAAA,iCAAA;ElB+1NV;;EkBt2NM;IAOI,6BAAA;IAAA,gCAAA;ElBo2NV;;EkB32NM;IAOI,8BAAA;IAAA,iCAAA;ElBy2NV;;EkBh3NM;IAOI,2BAAA;IAAA,8BAAA;ElB82NV;;EkBr3NM;IAOI,2BAAA;IAAA,8BAAA;ElBm3NV;;EkB13NM;IAOI,wBAAA;ElBu3NV;;EkB93NM;IAOI,8BAAA;ElB23NV;;EkBl4NM;IAOI,6BAAA;ElB+3NV;;EkBt4NM;IAOI,8BAAA;ElBm4NV;;EkB14NM;IAOI,2BAAA;ElBu4NV;;EkB94NM;IAOI,8BAAA;ElB24NV;;EkBl5NM;IAOI,6BAAA;ElB+4NV;;EkBt5NM;IAOI,8BAAA;ElBm5NV;;EkB15NM;IAOI,2BAAA;ElBu5NV;;EkB95NM;IAOI,8BAAA;ElB25NV;;EkBl6NM;IAOI,6BAAA;ElB+5NV;;EkBt6NM;IAOI,8BAAA;ElBm6NV;;EkB16NM;IAOI,2BAAA;ElBu6NV;;EkB96NM;IAOI,8BAAA;ElB26NV;;EkBl7NM;IAOI,6BAAA;ElB+6NV;;EkBt7NM;IAOI,8BAAA;ElBm7NV;;EkB17NM;IAOI,2BAAA;ElBu7NV;;EkB97NM;IAOI,8BAAA;ElB27NV;;EkBl8NM;IAOI,6BAAA;ElB+7NV;;EkBt8NM;IAOI,8BAAA;ElBm8NV;;EkB18NM;IAOI,2BAAA;ElBu8NV;;EkB98NM;IAOI,2BAAA;ElB28NV;;EkBl9NM;IAOI,0BAAA;ElB+8NV;;EkBt9NM;IAOI,gCAAA;ElBm9NV;;EkB19NM;IAOI,+BAAA;ElBu9NV;;EkB99NM;IAOI,gCAAA;ElB29NV;;EkBl+NM;IAOI,6BAAA;ElB+9NV;;EkBt+NM;IAOI,gCAAA;ElBm+NV;;EkB1+NM;IAOI,+BAAA;ElBu+NV;;EkB9+NM;IAOI,gCAAA;ElB2+NV;;EkBl/NM;IAOI,6BAAA;ElB++NV;;EkBt/NM;IAOI,gCAAA;ElBm/NV;;EkB1/NM;IAOI,+BAAA;ElBu/NV;;EkB9/NM;IAOI,gCAAA;ElB2/NV;;EkBlgOM;IAOI,6BAAA;ElB+/NV;;EkBtgOM;IAOI,gCAAA;ElBmgOV;;EkB1gOM;IAOI,+BAAA;ElBugOV;;EkB9gOM;IAOI,gCAAA;ElB2gOV;;EkBlhOM;IAOI,6BAAA;ElB+gOV;;EkBthOM;IAOI,gCAAA;ElBmhOV;;EkB1hOM;IAOI,+BAAA;ElBuhOV;;EkB9hOM;IAOI,gCAAA;ElB2hOV;;EkBliOM;IAOI,6BAAA;ElB+hOV;;EkBtiOM;IAOI,6BAAA;ElBmiOV;;EkB1iOM;IAOI,2BAAA;ElBuiOV;;EkB9iOM;IAOI,iCAAA;ElB2iOV;;EkBljOM;IAOI,gCAAA;ElB+iOV;;EkBtjOM;IAOI,iCAAA;ElBmjOV;;EkB1jOM;IAOI,8BAAA;ElBujOV;;EkB9jOM;IAOI,iCAAA;ElB2jOV;;EkBlkOM;IAOI,gCAAA;ElB+jOV;;EkBtkOM;IAOI,iCAAA;ElBmkOV;;EkB1kOM;IAOI,8BAAA;ElBukOV;;EkB9kOM;IAOI,iCAAA;ElB2kOV;;EkBllOM;IAOI,gCAAA;ElB+kOV;;EkBtlOM;IAOI,iCAAA;ElBmlOV;;EkB1lOM;IAOI,8BAAA;ElBulOV;;EkB9lOM;IAOI,iCAAA;ElB2lOV;;EkBlmOM;IAOI,gCAAA;ElB+lOV;;EkBtmOM;IAOI,iCAAA;ElBmmOV;;EkB1mOM;IAOI,8BAAA;ElBumOV;;EkB9mOM;IAOI,iCAAA;ElB2mOV;;EkBlnOM;IAOI,gCAAA;ElB+mOV;;EkBtnOM;IAOI,iCAAA;ElBmnOV;;EkB1nOM;IAOI,8BAAA;ElBunOV;;EkB9nOM;IAOI,8BAAA;ElB2nOV;;EkBloOM;IAOI,yBAAA;ElB+nOV;;EkBtoOM;IAOI,+BAAA;ElBmoOV;;EkB1oOM;IAOI,8BAAA;ElBuoOV;;EkB9oOM;IAOI,+BAAA;ElB2oOV;;EkBlpOM;IAOI,4BAAA;ElB+oOV;;EkBtpOM;IAOI,+BAAA;ElBmpOV;;EkB1pOM;IAOI,8BAAA;ElBupOV;;EkB9pOM;IAOI,+BAAA;ElB2pOV;;EkBlqOM;IAOI,4BAAA;ElB+pOV;;EkBtqOM;IAOI,+BAAA;ElBmqOV;;EkB1qOM;IAOI,8BAAA;ElBuqOV;;EkB9qOM;IAOI,+BAAA;ElB2qOV;;EkBlrOM;IAOI,4BAAA;ElB+qOV;;EkBtrOM;IAOI,+BAAA;ElBmrOV;;EkB1rOM;IAOI,8BAAA;ElBurOV;;EkB9rOM;IAOI,+BAAA;ElB2rOV;;EkBlsOM;IAOI,4BAAA;ElB+rOV;;EkBtsOM;IAOI,+BAAA;ElBmsOV;;EkB1sOM;IAOI,8BAAA;ElBusOV;;EkB9sOM;IAOI,+BAAA;ElB2sOV;;EkBltOM;IAOI,4BAAA;ElB+sOV;;EkBttOM;IAOI,4BAAA;ElBmtOV;;EkB1tOM;IAOI,2BAAA;ElButOV;;EkB9tOM;IAOI,0BAAA;ElB2tOV;;EkBluOM;IAOI,2BAAA;ElB+tOV;;EkBtuOM;IAOI,wBAAA;ElBmuOV;;EkB1uOM;IAOI,2BAAA;ElBuuOV;;EkB9uOM;IAOI,0BAAA;ElB2uOV;;EkBlvOM;IAOI,2BAAA;ElB+uOV;;EkBtvOM;IAOI,wBAAA;ElBmvOV;;EkB1vOM;IAOI,2BAAA;ElBuvOV;;EkB9vOM;IAOI,0BAAA;ElB2vOV;;EkBlwOM;IAOI,2BAAA;ElB+vOV;;EkBtwOM;IAOI,wBAAA;ElBmwOV;;EkB1wOM;IAOI,2BAAA;ElBuwOV;;EkB9wOM;IAOI,0BAAA;ElB2wOV;;EkBlxOM;IAOI,2BAAA;ElB+wOV;;EkBtxOM;IAOI,wBAAA;ElBmxOV;;EkB1xOM;IAOI,2BAAA;ElBuxOV;;EkB9xOM;IAOI,0BAAA;ElB2xOV;;EkBlyOM;IAOI,2BAAA;ElB+xOV;;EkBtyOM;IAOI,wBAAA;ElBmyOV;;EkB1yOM;IAOI,iCAAA;IAAA,gCAAA;ElBwyOV;;EkB/yOM;IAOI,gCAAA;IAAA,+BAAA;ElB6yOV;;EkBpzOM;IAOI,iCAAA;IAAA,gCAAA;ElBkzOV;;EkBzzOM;IAOI,8BAAA;IAAA,6BAAA;ElBuzOV;;EkB9zOM;IAOI,iCAAA;IAAA,gCAAA;ElB4zOV;;EkBn0OM;IAOI,gCAAA;IAAA,+BAAA;ElBi0OV;;EkBx0OM;IAOI,iCAAA;IAAA,gCAAA;ElBs0OV;;EkB70OM;IAOI,8BAAA;IAAA,6BAAA;ElB20OV;;EkBl1OM;IAOI,iCAAA;IAAA,gCAAA;ElBg1OV;;EkBv1OM;IAOI,gCAAA;IAAA,+BAAA;ElBq1OV;;EkB51OM;IAOI,iCAAA;IAAA,gCAAA;ElB01OV;;EkBj2OM;IAOI,8BAAA;IAAA,6BAAA;ElB+1OV;;EkBt2OM;IAOI,iCAAA;IAAA,gCAAA;ElBo2OV;;EkB32OM;IAOI,gCAAA;IAAA,+BAAA;ElBy2OV;;EkBh3OM;IAOI,iCAAA;IAAA,gCAAA;ElB82OV;;EkBr3OM;IAOI,8BAAA;IAAA,6BAAA;ElBm3OV;;EkB13OM;IAOI,iCAAA;IAAA,gCAAA;ElBw3OV;;EkB/3OM;IAOI,gCAAA;IAAA,+BAAA;ElB63OV;;EkBp4OM;IAOI,iCAAA;IAAA,gCAAA;ElBk4OV;;EkBz4OM;IAOI,8BAAA;IAAA,6BAAA;ElBu4OV;;EkB94OM;IAOI,+BAAA;IAAA,kCAAA;ElB44OV;;EkBn5OM;IAOI,8BAAA;IAAA,iCAAA;ElBi5OV;;EkBx5OM;IAOI,+BAAA;IAAA,kCAAA;ElBs5OV;;EkB75OM;IAOI,4BAAA;IAAA,+BAAA;ElB25OV;;EkBl6OM;IAOI,+BAAA;IAAA,kCAAA;ElBg6OV;;EkBv6OM;IAOI,8BAAA;IAAA,iCAAA;ElBq6OV;;EkB56OM;IAOI,+BAAA;IAAA,kCAAA;ElB06OV;;EkBj7OM;IAOI,4BAAA;IAAA,+BAAA;ElB+6OV;;EkBt7OM;IAOI,+BAAA;IAAA,kCAAA;ElBo7OV;;EkB37OM;IAOI,8BAAA;IAAA,iCAAA;ElBy7OV;;EkBh8OM;IAOI,+BAAA;IAAA,kCAAA;ElB87OV;;EkBr8OM;IAOI,4BAAA;IAAA,+BAAA;ElBm8OV;;EkB18OM;IAOI,+BAAA;IAAA,kCAAA;ElBw8OV;;EkB/8OM;IAOI,8BAAA;IAAA,iCAAA;ElB68OV;;EkBp9OM;IAOI,+BAAA;IAAA,kCAAA;ElBk9OV;;EkBz9OM;IAOI,4BAAA;IAAA,+BAAA;ElBu9OV;;EkB99OM;IAOI,+BAAA;IAAA,kCAAA;ElB49OV;;EkBn+OM;IAOI,8BAAA;IAAA,iCAAA;ElBi+OV;;EkBx+OM;IAOI,+BAAA;IAAA,kCAAA;ElBs+OV;;EkB7+OM;IAOI,4BAAA;IAAA,+BAAA;ElB2+OV;;EkBl/OM;IAOI,+BAAA;ElB++OV;;EkBt/OM;IAOI,8BAAA;ElBm/OV;;EkB1/OM;IAOI,+BAAA;ElBu/OV;;EkB9/OM;IAOI,4BAAA;ElB2/OV;;EkBlgPM;IAOI,+BAAA;ElB+/OV;;EkBtgPM;IAOI,8BAAA;ElBmgPV;;EkB1gPM;IAOI,+BAAA;ElBugPV;;EkB9gPM;IAOI,4BAAA;ElB2gPV;;EkBlhPM;IAOI,+BAAA;ElB+gPV;;EkBthPM;IAOI,8BAAA;ElBmhPV;;EkB1hPM;IAOI,+BAAA;ElBuhPV;;EkB9hPM;IAOI,4BAAA;ElB2hPV;;EkBliPM;IAOI,+BAAA;ElB+hPV;;EkBtiPM;IAOI,8BAAA;ElBmiPV;;EkB1iPM;IAOI,+BAAA;ElBuiPV;;EkB9iPM;IAOI,4BAAA;ElB2iPV;;EkBljPM;IAOI,+BAAA;ElB+iPV;;EkBtjPM;IAOI,8BAAA;ElBmjPV;;EkB1jPM;IAOI,+BAAA;ElBujPV;;EkB9jPM;IAOI,4BAAA;ElB2jPV;;EkBlkPM;IAOI,iCAAA;ElB+jPV;;EkBtkPM;IAOI,gCAAA;ElBmkPV;;EkB1kPM;IAOI,iCAAA;ElBukPV;;EkB9kPM;IAOI,8BAAA;ElB2kPV;;EkBllPM;IAOI,iCAAA;ElB+kPV;;EkBtlPM;IAOI,gCAAA;ElBmlPV;;EkB1lPM;IAOI,iCAAA;ElBulPV;;EkB9lPM;IAOI,8BAAA;ElB2lPV;;EkBlmPM;IAOI,iCAAA;ElB+lPV;;EkBtmPM;IAOI,gCAAA;ElBmmPV;;EkB1mPM;IAOI,iCAAA;ElBumPV;;EkB9mPM;IAOI,8BAAA;ElB2mPV;;EkBlnPM;IAOI,iCAAA;ElB+mPV;;EkBtnPM;IAOI,gCAAA;ElBmnPV;;EkB1nPM;IAOI,iCAAA;ElBunPV;;EkB9nPM;IAOI,8BAAA;ElB2nPV;;EkBloPM;IAOI,iCAAA;ElB+nPV;;EkBtoPM;IAOI,gCAAA;ElBmoPV;;EkB1oPM;IAOI,iCAAA;ElBuoPV;;EkB9oPM;IAOI,8BAAA;ElB2oPV;;EkBlpPM;IAOI,kCAAA;ElB+oPV;;EkBtpPM;IAOI,iCAAA;ElBmpPV;;EkB1pPM;IAOI,kCAAA;ElBupPV;;EkB9pPM;IAOI,+BAAA;ElB2pPV;;EkBlqPM;IAOI,kCAAA;ElB+pPV;;EkBtqPM;IAOI,iCAAA;ElBmqPV;;EkB1qPM;IAOI,kCAAA;ElBuqPV;;EkB9qPM;IAOI,+BAAA;ElB2qPV;;EkBlrPM;IAOI,kCAAA;ElB+qPV;;EkBtrPM;IAOI,iCAAA;ElBmrPV;;EkB1rPM;IAOI,kCAAA;ElBurPV;;EkB9rPM;IAOI,+BAAA;ElB2rPV;;EkBlsPM;IAOI,kCAAA;ElB+rPV;;EkBtsPM;IAOI,iCAAA;ElBmsPV;;EkB1sPM;IAOI,kCAAA;ElBusPV;;EkB9sPM;IAOI,+BAAA;ElB2sPV;;EkBltPM;IAOI,kCAAA;ElB+sPV;;EkBttPM;IAOI,iCAAA;ElBmtPV;;EkB1tPM;IAOI,kCAAA;ElButPV;;EkB9tPM;IAOI,+BAAA;ElB2tPV;;EkBluPM;IAOI,gCAAA;ElB+tPV;;EkBtuPM;IAOI,+BAAA;ElBmuPV;;EkB1uPM;IAOI,gCAAA;ElBuuPV;;EkB9uPM;IAOI,6BAAA;ElB2uPV;;EkBlvPM;IAOI,gCAAA;ElB+uPV;;EkBtvPM;IAOI,+BAAA;ElBmvPV;;EkB1vPM;IAOI,gCAAA;ElBuvPV;;EkB9vPM;IAOI,6BAAA;ElB2vPV;;EkBlwPM;IAOI,gCAAA;ElB+vPV;;EkBtwPM;IAOI,+BAAA;ElBmwPV;;EkB1wPM;IAOI,gCAAA;ElBuwPV;;EkB9wPM;IAOI,6BAAA;ElB2wPV;;EkBlxPM;IAOI,gCAAA;ElB+wPV;;EkBtxPM;IAOI,+BAAA;ElBmxPV;;EkB1xPM;IAOI,gCAAA;ElBuxPV;;EkB9xPM;IAOI,6BAAA;ElB2xPV;;EkBlyPM;IAOI,gCAAA;ElB+xPV;;EkBtyPM;IAOI,+BAAA;ElBmyPV;;EkB1yPM;IAOI,gCAAA;ElBuyPV;;EkB9yPM;IAOI,6BAAA;ElB2yPV;;EkBlzPM;IAOI,qBAAA;ElB+yPV;;EkBtzPM;IAOI,2BAAA;ElBmzPV;;EkB1zPM;IAOI,0BAAA;ElBuzPV;;EkB9zPM;IAOI,2BAAA;ElB2zPV;;EkBl0PM;IAOI,wBAAA;ElB+zPV;;EkBt0PM;IAOI,2BAAA;ElBm0PV;;EkB10PM;IAOI,0BAAA;ElBu0PV;;EkB90PM;IAOI,2BAAA;ElB20PV;;EkBl1PM;IAOI,wBAAA;ElB+0PV;;EkBt1PM;IAOI,2BAAA;ElBm1PV;;EkB11PM;IAOI,0BAAA;ElBu1PV;;EkB91PM;IAOI,2BAAA;ElB21PV;;EkBl2PM;IAOI,wBAAA;ElB+1PV;;EkBt2PM;IAOI,2BAAA;ElBm2PV;;EkB12PM;IAOI,0BAAA;ElBu2PV;;EkB92PM;IAOI,2BAAA;ElB22PV;;EkBl3PM;IAOI,wBAAA;ElB+2PV;;EkBt3PM;IAOI,2BAAA;ElBm3PV;;EkB13PM;IAOI,0BAAA;ElBu3PV;;EkB93PM;IAOI,2BAAA;ElB23PV;;EkBl4PM;IAOI,wBAAA;ElB+3PV;;EkBt4PM;IAOI,2BAAA;IAAA,0BAAA;ElBo4PV;;EkB34PM;IAOI,iCAAA;IAAA,gCAAA;ElBy4PV;;EkBh5PM;IAOI,gCAAA;IAAA,+BAAA;ElB84PV;;EkBr5PM;IAOI,iCAAA;IAAA,gCAAA;ElBm5PV;;EkB15PM;IAOI,8BAAA;IAAA,6BAAA;ElBw5PV;;EkB/5PM;IAOI,iCAAA;IAAA,gCAAA;ElB65PV;;EkBp6PM;IAOI,gCAAA;IAAA,+BAAA;ElBk6PV;;EkBz6PM;IAOI,iCAAA;IAAA,gCAAA;ElBu6PV;;EkB96PM;IAOI,8BAAA;IAAA,6BAAA;ElB46PV;;EkBn7PM;IAOI,iCAAA;IAAA,gCAAA;ElBi7PV;;EkBx7PM;IAOI,gCAAA;IAAA,+BAAA;ElBs7PV;;EkB77PM;IAOI,iCAAA;IAAA,gCAAA;ElB27PV;;EkBl8PM;IAOI,8BAAA;IAAA,6BAAA;ElBg8PV;;EkBv8PM;IAOI,iCAAA;IAAA,gCAAA;ElBq8PV;;EkB58PM;IAOI,gCAAA;IAAA,+BAAA;ElB08PV;;EkBj9PM;IAOI,iCAAA;IAAA,gCAAA;ElB+8PV;;EkBt9PM;IAOI,8BAAA;IAAA,6BAAA;ElBo9PV;;EkB39PM;IAOI,iCAAA;IAAA,gCAAA;ElBy9PV;;EkBh+PM;IAOI,gCAAA;IAAA,+BAAA;ElB89PV;;EkBr+PM;IAOI,iCAAA;IAAA,gCAAA;ElBm+PV;;EkB1+PM;IAOI,8BAAA;IAAA,6BAAA;ElBw+PV;;EkB/+PM;IAOI,yBAAA;IAAA,4BAAA;ElB6+PV;;EkBp/PM;IAOI,+BAAA;IAAA,kCAAA;ElBk/PV;;EkBz/PM;IAOI,8BAAA;IAAA,iCAAA;ElBu/PV;;EkB9/PM;IAOI,+BAAA;IAAA,kCAAA;ElB4/PV;;EkBngQM;IAOI,4BAAA;IAAA,+BAAA;ElBigQV;;EkBxgQM;IAOI,+BAAA;IAAA,kCAAA;ElBsgQV;;EkB7gQM;IAOI,8BAAA;IAAA,iCAAA;ElB2gQV;;EkBlhQM;IAOI,+BAAA;IAAA,kCAAA;ElBghQV;;EkBvhQM;IAOI,4BAAA;IAAA,+BAAA;ElBqhQV;;EkB5hQM;IAOI,+BAAA;IAAA,kCAAA;ElB0hQV;;EkBjiQM;IAOI,8BAAA;IAAA,iCAAA;ElB+hQV;;EkBtiQM;IAOI,+BAAA;IAAA,kCAAA;ElBoiQV;;EkB3iQM;IAOI,4BAAA;IAAA,+BAAA;ElByiQV;;EkBhjQM;IAOI,+BAAA;IAAA,kCAAA;ElB8iQV;;EkBrjQM;IAOI,8BAAA;IAAA,iCAAA;ElBmjQV;;EkB1jQM;IAOI,+BAAA;IAAA,kCAAA;ElBwjQV;;EkB/jQM;IAOI,4BAAA;IAAA,+BAAA;ElB6jQV;;EkBpkQM;IAOI,+BAAA;IAAA,kCAAA;ElBkkQV;;EkBzkQM;IAOI,8BAAA;IAAA,iCAAA;ElBukQV;;EkB9kQM;IAOI,+BAAA;IAAA,kCAAA;ElB4kQV;;EkBnlQM;IAOI,4BAAA;IAAA,+BAAA;ElBilQV;;EkBxlQM;IAOI,yBAAA;ElBqlQV;;EkB5lQM;IAOI,+BAAA;ElBylQV;;EkBhmQM;IAOI,8BAAA;ElB6lQV;;EkBpmQM;IAOI,+BAAA;ElBimQV;;EkBxmQM;IAOI,4BAAA;ElBqmQV;;EkB5mQM;IAOI,+BAAA;ElBymQV;;EkBhnQM;IAOI,8BAAA;ElB6mQV;;EkBpnQM;IAOI,+BAAA;ElBinQV;;EkBxnQM;IAOI,4BAAA;ElBqnQV;;EkB5nQM;IAOI,+BAAA;ElBynQV;;EkBhoQM;IAOI,8BAAA;ElB6nQV;;EkBpoQM;IAOI,+BAAA;ElBioQV;;EkBxoQM;IAOI,4BAAA;ElBqoQV;;EkB5oQM;IAOI,+BAAA;ElByoQV;;EkBhpQM;IAOI,8BAAA;ElB6oQV;;EkBppQM;IAOI,+BAAA;ElBipQV;;EkBxpQM;IAOI,4BAAA;ElBqpQV;;EkB5pQM;IAOI,+BAAA;ElBypQV;;EkBhqQM;IAOI,8BAAA;ElB6pQV;;EkBpqQM;IAOI,+BAAA;ElBiqQV;;EkBxqQM;IAOI,4BAAA;ElBqqQV;;EkB5qQM;IAOI,2BAAA;ElByqQV;;EkBhrQM;IAOI,iCAAA;ElB6qQV;;EkBprQM;IAOI,gCAAA;ElBirQV;;EkBxrQM;IAOI,iCAAA;ElBqrQV;;EkB5rQM;IAOI,8BAAA;ElByrQV;;EkBhsQM;IAOI,iCAAA;ElB6rQV;;EkBpsQM;IAOI,gCAAA;ElBisQV;;EkBxsQM;IAOI,iCAAA;ElBqsQV;;EkB5sQM;IAOI,8BAAA;ElBysQV;;EkBhtQM;IAOI,iCAAA;ElB6sQV;;EkBptQM;IAOI,gCAAA;ElBitQV;;EkBxtQM;IAOI,iCAAA;ElBqtQV;;EkB5tQM;IAOI,8BAAA;ElBytQV;;EkBhuQM;IAOI,iCAAA;ElB6tQV;;EkBpuQM;IAOI,gCAAA;ElBiuQV;;EkBxuQM;IAOI,iCAAA;ElBquQV;;EkB5uQM;IAOI,8BAAA;ElByuQV;;EkBhvQM;IAOI,iCAAA;ElB6uQV;;EkBpvQM;IAOI,gCAAA;ElBivQV;;EkBxvQM;IAOI,iCAAA;ElBqvQV;;EkB5vQM;IAOI,8BAAA;ElByvQV;;EkBhwQM;IAOI,4BAAA;ElB6vQV;;EkBpwQM;IAOI,kCAAA;ElBiwQV;;EkBxwQM;IAOI,iCAAA;ElBqwQV;;EkB5wQM;IAOI,kCAAA;ElBywQV;;EkBhxQM;IAOI,+BAAA;ElB6wQV;;EkBpxQM;IAOI,kCAAA;ElBixQV;;EkBxxQM;IAOI,iCAAA;ElBqxQV;;EkB5xQM;IAOI,kCAAA;ElByxQV;;EkBhyQM;IAOI,+BAAA;ElB6xQV;;EkBpyQM;IAOI,kCAAA;ElBiyQV;;EkBxyQM;IAOI,iCAAA;ElBqyQV;;EkB5yQM;IAOI,kCAAA;ElByyQV;;EkBhzQM;IAOI,+BAAA;ElB6yQV;;EkBpzQM;IAOI,kCAAA;ElBizQV;;EkBxzQM;IAOI,iCAAA;ElBqzQV;;EkB5zQM;IAOI,kCAAA;ElByzQV;;EkBh0QM;IAOI,+BAAA;ElB6zQV;;EkBp0QM;IAOI,kCAAA;ElBi0QV;;EkBx0QM;IAOI,iCAAA;ElBq0QV;;EkB50QM;IAOI,kCAAA;ElBy0QV;;EkBh1QM;IAOI,+BAAA;ElB60QV;;EkBp1QM;IAOI,0BAAA;ElBi1QV;;EkBx1QM;IAOI,gCAAA;ElBq1QV;;EkB51QM;IAOI,+BAAA;ElBy1QV;;EkBh2QM;IAOI,gCAAA;ElB61QV;;EkBp2QM;IAOI,6BAAA;ElBi2QV;;EkBx2QM;IAOI,gCAAA;ElBq2QV;;EkB52QM;IAOI,+BAAA;ElBy2QV;;EkBh3QM;IAOI,gCAAA;ElB62QV;;EkBp3QM;IAOI,6BAAA;ElBi3QV;;EkBx3QM;IAOI,gCAAA;ElBq3QV;;EkB53QM;IAOI,+BAAA;ElBy3QV;;EkBh4QM;IAOI,gCAAA;ElB63QV;;EkBp4QM;IAOI,6BAAA;ElBi4QV;;EkBx4QM;IAOI,gCAAA;ElBq4QV;;EkB54QM;IAOI,+BAAA;ElBy4QV;;EkBh5QM;IAOI,gCAAA;ElB64QV;;EkBp5QM;IAOI,6BAAA;ElBi5QV;;EkBx5QM;IAOI,gCAAA;ElBq5QV;;EkB55QM;IAOI,+BAAA;ElBy5QV;;EkBh6QM;IAOI,gCAAA;ElB65QV;;EkBp6QM;IAOI,6BAAA;ElBi6QV;;EkBx6QM;IAOI,iBAAA;ElBq6QV;;EkB56QM;IAOI,uBAAA;ElBy6QV;;EkBh7QM;IAOI,sBAAA;ElB66QV;;EkBp7QM;IAOI,uBAAA;ElBi7QV;;EkBx7QM;IAOI,oBAAA;ElBq7QV;;EkB57QM;IAOI,uBAAA;ElBy7QV;;EkBh8QM;IAOI,sBAAA;ElB67QV;;EkBp8QM;IAOI,uBAAA;ElBi8QV;;EkBx8QM;IAOI,oBAAA;ElBq8QV;;EkB58QM;IAOI,uBAAA;ElBy8QV;;EkBh9QM;IAOI,sBAAA;ElB68QV;;EkBp9QM;IAOI,uBAAA;ElBi9QV;;EkBx9QM;IAOI,oBAAA;ElBq9QV;;EkB59QM;IAOI,uBAAA;ElBy9QV;;EkBh+QM;IAOI,sBAAA;ElB69QV;;EkBp+QM;IAOI,uBAAA;ElBi+QV;;EkBx+QM;IAOI,oBAAA;ElBq+QV;;EkB5+QM;IAOI,uBAAA;ElBy+QV;;EkBh/QM;IAOI,sBAAA;ElB6+QV;;EkBp/QM;IAOI,uBAAA;ElBi/QV;;EkBx/QM;IAOI,oBAAA;ElBq/QV;;EkB5/QM;IAOI,qBAAA;ElBy/QV;;EkBhgRM;IAOI,2BAAA;ElB6/QV;;EkBpgRM;IAOI,0BAAA;ElBigRV;;EkBxgRM;IAOI,2BAAA;ElBqgRV;;EkB5gRM;IAOI,wBAAA;ElBygRV;;EkBhhRM;IAOI,2BAAA;ElB6gRV;;EkBphRM;IAOI,0BAAA;ElBihRV;;EkBxhRM;IAOI,2BAAA;ElBqhRV;;EkB5hRM;IAOI,wBAAA;ElByhRV;;EkBhiRM;IAOI,2BAAA;ElB6hRV;;EkBpiRM;IAOI,0BAAA;ElBiiRV;;EkBxiRM;IAOI,2BAAA;ElBqiRV;;EkB5iRM;IAOI,wBAAA;ElByiRV;;EkBhjRM;IAOI,2BAAA;ElB6iRV;;EkBpjRM;IAOI,0BAAA;ElBijRV;;EkBxjRM;IAOI,2BAAA;ElBqjRV;;EkB5jRM;IAOI,wBAAA;ElByjRV;;EkBhkRM;IAOI,2BAAA;ElB6jRV;;EkBpkRM;IAOI,0BAAA;ElBikRV;;EkBxkRM;IAOI,2BAAA;ElBqkRV;;EkB5kRM;IAOI,wBAAA;ElBykRV;;EkBhlRM;IAOI,wBAAA;ElB6kRV;;EkBplRM;IAOI,8BAAA;ElBilRV;;EkBxlRM;IAOI,6BAAA;ElBqlRV;;EkB5lRM;IAOI,8BAAA;ElBylRV;;EkBhmRM;IAOI,2BAAA;ElB6lRV;;EkBpmRM;IAOI,8BAAA;ElBimRV;;EkBxmRM;IAOI,6BAAA;ElBqmRV;;EkB5mRM;IAOI,8BAAA;ElBymRV;;EkBhnRM;IAOI,2BAAA;ElB6mRV;;EkBpnRM;IAOI,8BAAA;ElBinRV;;EkBxnRM;IAOI,6BAAA;ElBqnRV;;EkB5nRM;IAOI,8BAAA;ElBynRV;;EkBhoRM;IAOI,2BAAA;ElB6nRV;;EkBpoRM;IAOI,8BAAA;ElBioRV;;EkBxoRM;IAOI,6BAAA;ElBqoRV;;EkB5oRM;IAOI,8BAAA;ElByoRV;;EkBhpRM;IAOI,2BAAA;ElB6oRV;;EkBppRM;IAOI,8BAAA;ElBipRV;;EkBxpRM;IAOI,6BAAA;ElBqpRV;;EkB5pRM;IAOI,8BAAA;ElBypRV;;EkBhqRM;IAOI,2BAAA;ElB6pRV;;EkBpqRM;IAOI,2BAAA;ElBiqRV;;EkBxqRM;IAOI,4BAAA;ElBqqRV;;EkB5qRM;IAOI,6BAAA;ElByqRV;AACF;AUprRI;EQGI;IAOI,sBAAA;ElB8qRV;;EkBrrRM;IAOI,uBAAA;ElBkrRV;;EkBzrRM;IAOI,sBAAA;ElBsrRV;;EkB7rRM;IAOI,8BAAA;ElB0rRV;;EkBjsRM;IAOI,4BAAA;ElB8rRV;;EkBrsRM;IAOI,2BAAA;ElBksRV;;EkBzsRM;IAOI,iCAAA;ElBssRV;;EkB7sRM;IAOI,2BAAA;ElB0sRV;;EkBjtRM;IAOI,0BAAA;ElB8sRV;;EkBrtRM;IAOI,gCAAA;ElBktRV;;EkBztRM;IAOI,yBAAA;ElBstRV;;EkB7tRM;IAOI,wBAAA;ElB0tRV;;EkBjuRM;IAOI,+BAAA;ElB8tRV;;EkBruRM;IAOI,yBAAA;ElBkuRV;;EkBzuRM;IAOI,6BAAA;ElBsuRV;;EkB7uRM;IAOI,8BAAA;ElB0uRV;;EkBjvRM;IAOI,wBAAA;ElB8uRV;;EkBrvRM;IAOI,+BAAA;ElBkvRV;;EkBzvRM;IAOI,wBAAA;ElBsvRV;;EkB7vRM;IAOI,yBAAA;ElB0vRV;;EkBjwRM;IAOI,8BAAA;ElB8vRV;;EkBrwRM;IAOI,iCAAA;ElBkwRV;;EkBzwRM;IAOI,sCAAA;ElBswRV;;EkB7wRM;IAOI,yCAAA;ElB0wRV;;EkBjxRM;IAOI,uBAAA;ElB8wRV;;EkBrxRM;IAOI,uBAAA;ElBkxRV;;EkBzxRM;IAOI,yBAAA;ElBsxRV;;EkB7xRM;IAOI,yBAAA;ElB0xRV;;EkBjyRM;IAOI,0BAAA;ElB8xRV;;EkBryRM;IAOI,4BAAA;ElBkyRV;;EkBzyRM;IAOI,kCAAA;ElBsyRV;;EkB7yRM;IAOI,sCAAA;ElB0yRV;;EkBjzRM;IAOI,oCAAA;ElB8yRV;;EkBrzRM;IAOI,kCAAA;ElBkzRV;;EkBzzRM;IAOI,yCAAA;ElBszRV;;EkB7zRM;IAOI,wCAAA;ElB0zRV;;EkBj0RM;IAOI,wCAAA;ElB8zRV;;EkBr0RM;IAOI,kCAAA;ElBk0RV;;EkBz0RM;IAOI,gCAAA;ElBs0RV;;EkB70RM;IAOI,8BAAA;ElB00RV;;EkBj1RM;IAOI,gCAAA;ElB80RV;;EkBr1RM;IAOI,+BAAA;ElBk1RV;;EkBz1RM;IAOI,oCAAA;ElBs1RV;;EkB71RM;IAOI,kCAAA;ElB01RV;;EkBj2RM;IAOI,gCAAA;ElB81RV;;EkBr2RM;IAOI,uCAAA;ElBk2RV;;EkBz2RM;IAOI,sCAAA;ElBs2RV;;EkB72RM;IAOI,iCAAA;ElB02RV;;EkBj3RM;IAOI,2BAAA;ElB82RV;;EkBr3RM;IAOI,iCAAA;ElBk3RV;;EkBz3RM;IAOI,+BAAA;ElBs3RV;;EkB73RM;IAOI,6BAAA;ElB03RV;;EkBj4RM;IAOI,+BAAA;ElB83RV;;EkBr4RM;IAOI,8BAAA;ElBk4RV;;EkBz4RM;IAOI,oBAAA;ElBs4RV;;EkB74RM;IAOI,mBAAA;ElB04RV;;EkBj5RM;IAOI,mBAAA;ElB84RV;;EkBr5RM;IAOI,mBAAA;ElBk5RV;;EkBz5RM;IAOI,mBAAA;ElBs5RV;;EkB75RM;IAOI,mBAAA;ElB05RV;;EkBj6RM;IAOI,mBAAA;ElB85RV;;EkBr6RM;IAOI,mBAAA;ElBk6RV;;EkBz6RM;IAOI,oBAAA;ElBs6RV;;EkB76RM;IAOI,0BAAA;ElB06RV;;EkBj7RM;IAOI,yBAAA;ElB86RV;;EkBr7RM;IAOI,0BAAA;ElBk7RV;;EkBz7RM;IAOI,uBAAA;ElBs7RV;;EkB77RM;IAOI,0BAAA;ElB07RV;;EkBj8RM;IAOI,yBAAA;ElB87RV;;EkBr8RM;IAOI,0BAAA;ElBk8RV;;EkBz8RM;IAOI,uBAAA;ElBs8RV;;EkB78RM;IAOI,0BAAA;ElB08RV;;EkBj9RM;IAOI,yBAAA;ElB88RV;;EkBr9RM;IAOI,0BAAA;ElBk9RV;;EkBz9RM;IAOI,uBAAA;ElBs9RV;;EkB79RM;IAOI,0BAAA;ElB09RV;;EkBj+RM;IAOI,yBAAA;ElB89RV;;EkBr+RM;IAOI,0BAAA;ElBk+RV;;EkBz+RM;IAOI,uBAAA;ElBs+RV;;EkB7+RM;IAOI,0BAAA;ElB0+RV;;EkBj/RM;IAOI,yBAAA;ElB8+RV;;EkBr/RM;IAOI,0BAAA;ElBk/RV;;EkBz/RM;IAOI,uBAAA;ElBs/RV;;EkB7/RM;IAOI,uBAAA;ElB0/RV;;EkBjgSM;IAOI,0BAAA;IAAA,yBAAA;ElB+/RV;;EkBtgSM;IAOI,gCAAA;IAAA,+BAAA;ElBogSV;;EkB3gSM;IAOI,+BAAA;IAAA,8BAAA;ElBygSV;;EkBhhSM;IAOI,gCAAA;IAAA,+BAAA;ElB8gSV;;EkBrhSM;IAOI,6BAAA;IAAA,4BAAA;ElBmhSV;;EkB1hSM;IAOI,gCAAA;IAAA,+BAAA;ElBwhSV;;EkB/hSM;IAOI,+BAAA;IAAA,8BAAA;ElB6hSV;;EkBpiSM;IAOI,gCAAA;IAAA,+BAAA;ElBkiSV;;EkBziSM;IAOI,6BAAA;IAAA,4BAAA;ElBuiSV;;EkB9iSM;IAOI,gCAAA;IAAA,+BAAA;ElB4iSV;;EkBnjSM;IAOI,+BAAA;IAAA,8BAAA;ElBijSV;;EkBxjSM;IAOI,gCAAA;IAAA,+BAAA;ElBsjSV;;EkB7jSM;IAOI,6BAAA;IAAA,4BAAA;ElB2jSV;;EkBlkSM;IAOI,gCAAA;IAAA,+BAAA;ElBgkSV;;EkBvkSM;IAOI,+BAAA;IAAA,8BAAA;ElBqkSV;;EkB5kSM;IAOI,gCAAA;IAAA,+BAAA;ElB0kSV;;EkBjlSM;IAOI,6BAAA;IAAA,4BAAA;ElB+kSV;;EkBtlSM;IAOI,gCAAA;IAAA,+BAAA;ElBolSV;;EkB3lSM;IAOI,+BAAA;IAAA,8BAAA;ElBylSV;;EkBhmSM;IAOI,gCAAA;IAAA,+BAAA;ElB8lSV;;EkBrmSM;IAOI,6BAAA;IAAA,4BAAA;ElBmmSV;;EkB1mSM;IAOI,6BAAA;IAAA,4BAAA;ElBwmSV;;EkB/mSM;IAOI,wBAAA;IAAA,2BAAA;ElB6mSV;;EkBpnSM;IAOI,8BAAA;IAAA,iCAAA;ElBknSV;;EkBznSM;IAOI,6BAAA;IAAA,gCAAA;ElBunSV;;EkB9nSM;IAOI,8BAAA;IAAA,iCAAA;ElB4nSV;;EkBnoSM;IAOI,2BAAA;IAAA,8BAAA;ElBioSV;;EkBxoSM;IAOI,8BAAA;IAAA,iCAAA;ElBsoSV;;EkB7oSM;IAOI,6BAAA;IAAA,gCAAA;ElB2oSV;;EkBlpSM;IAOI,8BAAA;IAAA,iCAAA;ElBgpSV;;EkBvpSM;IAOI,2BAAA;IAAA,8BAAA;ElBqpSV;;EkB5pSM;IAOI,8BAAA;IAAA,iCAAA;ElB0pSV;;EkBjqSM;IAOI,6BAAA;IAAA,gCAAA;ElB+pSV;;EkBtqSM;IAOI,8BAAA;IAAA,iCAAA;ElBoqSV;;EkB3qSM;IAOI,2BAAA;IAAA,8BAAA;ElByqSV;;EkBhrSM;IAOI,8BAAA;IAAA,iCAAA;ElB8qSV;;EkBrrSM;IAOI,6BAAA;IAAA,gCAAA;ElBmrSV;;EkB1rSM;IAOI,8BAAA;IAAA,iCAAA;ElBwrSV;;EkB/rSM;IAOI,2BAAA;IAAA,8BAAA;ElB6rSV;;EkBpsSM;IAOI,8BAAA;IAAA,iCAAA;ElBksSV;;EkBzsSM;IAOI,6BAAA;IAAA,gCAAA;ElBusSV;;EkB9sSM;IAOI,8BAAA;IAAA,iCAAA;ElB4sSV;;EkBntSM;IAOI,2BAAA;IAAA,8BAAA;ElBitSV;;EkBxtSM;IAOI,2BAAA;IAAA,8BAAA;ElBstSV;;EkB7tSM;IAOI,wBAAA;ElB0tSV;;EkBjuSM;IAOI,8BAAA;ElB8tSV;;EkBruSM;IAOI,6BAAA;ElBkuSV;;EkBzuSM;IAOI,8BAAA;ElBsuSV;;EkB7uSM;IAOI,2BAAA;ElB0uSV;;EkBjvSM;IAOI,8BAAA;ElB8uSV;;EkBrvSM;IAOI,6BAAA;ElBkvSV;;EkBzvSM;IAOI,8BAAA;ElBsvSV;;EkB7vSM;IAOI,2BAAA;ElB0vSV;;EkBjwSM;IAOI,8BAAA;ElB8vSV;;EkBrwSM;IAOI,6BAAA;ElBkwSV;;EkBzwSM;IAOI,8BAAA;ElBswSV;;EkB7wSM;IAOI,2BAAA;ElB0wSV;;EkBjxSM;IAOI,8BAAA;ElB8wSV;;EkBrxSM;IAOI,6BAAA;ElBkxSV;;EkBzxSM;IAOI,8BAAA;ElBsxSV;;EkB7xSM;IAOI,2BAAA;ElB0xSV;;EkBjySM;IAOI,8BAAA;ElB8xSV;;EkBrySM;IAOI,6BAAA;ElBkySV;;EkBzySM;IAOI,8BAAA;ElBsySV;;EkB7ySM;IAOI,2BAAA;ElB0ySV;;EkBjzSM;IAOI,2BAAA;ElB8ySV;;EkBrzSM;IAOI,0BAAA;ElBkzSV;;EkBzzSM;IAOI,gCAAA;ElBszSV;;EkB7zSM;IAOI,+BAAA;ElB0zSV;;EkBj0SM;IAOI,gCAAA;ElB8zSV;;EkBr0SM;IAOI,6BAAA;ElBk0SV;;EkBz0SM;IAOI,gCAAA;ElBs0SV;;EkB70SM;IAOI,+BAAA;ElB00SV;;EkBj1SM;IAOI,gCAAA;ElB80SV;;EkBr1SM;IAOI,6BAAA;ElBk1SV;;EkBz1SM;IAOI,gCAAA;ElBs1SV;;EkB71SM;IAOI,+BAAA;ElB01SV;;EkBj2SM;IAOI,gCAAA;ElB81SV;;EkBr2SM;IAOI,6BAAA;ElBk2SV;;EkBz2SM;IAOI,gCAAA;ElBs2SV;;EkB72SM;IAOI,+BAAA;ElB02SV;;EkBj3SM;IAOI,gCAAA;ElB82SV;;EkBr3SM;IAOI,6BAAA;ElBk3SV;;EkBz3SM;IAOI,gCAAA;ElBs3SV;;EkB73SM;IAOI,+BAAA;ElB03SV;;EkBj4SM;IAOI,gCAAA;ElB83SV;;EkBr4SM;IAOI,6BAAA;ElBk4SV;;EkBz4SM;IAOI,6BAAA;ElBs4SV;;EkB74SM;IAOI,2BAAA;ElB04SV;;EkBj5SM;IAOI,iCAAA;ElB84SV;;EkBr5SM;IAOI,gCAAA;ElBk5SV;;EkBz5SM;IAOI,iCAAA;ElBs5SV;;EkB75SM;IAOI,8BAAA;ElB05SV;;EkBj6SM;IAOI,iCAAA;ElB85SV;;EkBr6SM;IAOI,gCAAA;ElBk6SV;;EkBz6SM;IAOI,iCAAA;ElBs6SV;;EkB76SM;IAOI,8BAAA;ElB06SV;;EkBj7SM;IAOI,iCAAA;ElB86SV;;EkBr7SM;IAOI,gCAAA;ElBk7SV;;EkBz7SM;IAOI,iCAAA;ElBs7SV;;EkB77SM;IAOI,8BAAA;ElB07SV;;EkBj8SM;IAOI,iCAAA;ElB87SV;;EkBr8SM;IAOI,gCAAA;ElBk8SV;;EkBz8SM;IAOI,iCAAA;ElBs8SV;;EkB78SM;IAOI,8BAAA;ElB08SV;;EkBj9SM;IAOI,iCAAA;ElB88SV;;EkBr9SM;IAOI,gCAAA;ElBk9SV;;EkBz9SM;IAOI,iCAAA;ElBs9SV;;EkB79SM;IAOI,8BAAA;ElB09SV;;EkBj+SM;IAOI,8BAAA;ElB89SV;;EkBr+SM;IAOI,yBAAA;ElBk+SV;;EkBz+SM;IAOI,+BAAA;ElBs+SV;;EkB7+SM;IAOI,8BAAA;ElB0+SV;;EkBj/SM;IAOI,+BAAA;ElB8+SV;;EkBr/SM;IAOI,4BAAA;ElBk/SV;;EkBz/SM;IAOI,+BAAA;ElBs/SV;;EkB7/SM;IAOI,8BAAA;ElB0/SV;;EkBjgTM;IAOI,+BAAA;ElB8/SV;;EkBrgTM;IAOI,4BAAA;ElBkgTV;;EkBzgTM;IAOI,+BAAA;ElBsgTV;;EkB7gTM;IAOI,8BAAA;ElB0gTV;;EkBjhTM;IAOI,+BAAA;ElB8gTV;;EkBrhTM;IAOI,4BAAA;ElBkhTV;;EkBzhTM;IAOI,+BAAA;ElBshTV;;EkB7hTM;IAOI,8BAAA;ElB0hTV;;EkBjiTM;IAOI,+BAAA;ElB8hTV;;EkBriTM;IAOI,4BAAA;ElBkiTV;;EkBziTM;IAOI,+BAAA;ElBsiTV;;EkB7iTM;IAOI,8BAAA;ElB0iTV;;EkBjjTM;IAOI,+BAAA;ElB8iTV;;EkBrjTM;IAOI,4BAAA;ElBkjTV;;EkBzjTM;IAOI,4BAAA;ElBsjTV;;EkB7jTM;IAOI,2BAAA;ElB0jTV;;EkBjkTM;IAOI,0BAAA;ElB8jTV;;EkBrkTM;IAOI,2BAAA;ElBkkTV;;EkBzkTM;IAOI,wBAAA;ElBskTV;;EkB7kTM;IAOI,2BAAA;ElB0kTV;;EkBjlTM;IAOI,0BAAA;ElB8kTV;;EkBrlTM;IAOI,2BAAA;ElBklTV;;EkBzlTM;IAOI,wBAAA;ElBslTV;;EkB7lTM;IAOI,2BAAA;ElB0lTV;;EkBjmTM;IAOI,0BAAA;ElB8lTV;;EkBrmTM;IAOI,2BAAA;ElBkmTV;;EkBzmTM;IAOI,wBAAA;ElBsmTV;;EkB7mTM;IAOI,2BAAA;ElB0mTV;;EkBjnTM;IAOI,0BAAA;ElB8mTV;;EkBrnTM;IAOI,2BAAA;ElBknTV;;EkBznTM;IAOI,wBAAA;ElBsnTV;;EkB7nTM;IAOI,2BAAA;ElB0nTV;;EkBjoTM;IAOI,0BAAA;ElB8nTV;;EkBroTM;IAOI,2BAAA;ElBkoTV;;EkBzoTM;IAOI,wBAAA;ElBsoTV;;EkB7oTM;IAOI,iCAAA;IAAA,gCAAA;ElB2oTV;;EkBlpTM;IAOI,gCAAA;IAAA,+BAAA;ElBgpTV;;EkBvpTM;IAOI,iCAAA;IAAA,gCAAA;ElBqpTV;;EkB5pTM;IAOI,8BAAA;IAAA,6BAAA;ElB0pTV;;EkBjqTM;IAOI,iCAAA;IAAA,gCAAA;ElB+pTV;;EkBtqTM;IAOI,gCAAA;IAAA,+BAAA;ElBoqTV;;EkB3qTM;IAOI,iCAAA;IAAA,gCAAA;ElByqTV;;EkBhrTM;IAOI,8BAAA;IAAA,6BAAA;ElB8qTV;;EkBrrTM;IAOI,iCAAA;IAAA,gCAAA;ElBmrTV;;EkB1rTM;IAOI,gCAAA;IAAA,+BAAA;ElBwrTV;;EkB/rTM;IAOI,iCAAA;IAAA,gCAAA;ElB6rTV;;EkBpsTM;IAOI,8BAAA;IAAA,6BAAA;ElBksTV;;EkBzsTM;IAOI,iCAAA;IAAA,gCAAA;ElBusTV;;EkB9sTM;IAOI,gCAAA;IAAA,+BAAA;ElB4sTV;;EkBntTM;IAOI,iCAAA;IAAA,gCAAA;ElBitTV;;EkBxtTM;IAOI,8BAAA;IAAA,6BAAA;ElBstTV;;EkB7tTM;IAOI,iCAAA;IAAA,gCAAA;ElB2tTV;;EkBluTM;IAOI,gCAAA;IAAA,+BAAA;ElBguTV;;EkBvuTM;IAOI,iCAAA;IAAA,gCAAA;ElBquTV;;EkB5uTM;IAOI,8BAAA;IAAA,6BAAA;ElB0uTV;;EkBjvTM;IAOI,+BAAA;IAAA,kCAAA;ElB+uTV;;EkBtvTM;IAOI,8BAAA;IAAA,iCAAA;ElBovTV;;EkB3vTM;IAOI,+BAAA;IAAA,kCAAA;ElByvTV;;EkBhwTM;IAOI,4BAAA;IAAA,+BAAA;ElB8vTV;;EkBrwTM;IAOI,+BAAA;IAAA,kCAAA;ElBmwTV;;EkB1wTM;IAOI,8BAAA;IAAA,iCAAA;ElBwwTV;;EkB/wTM;IAOI,+BAAA;IAAA,kCAAA;ElB6wTV;;EkBpxTM;IAOI,4BAAA;IAAA,+BAAA;ElBkxTV;;EkBzxTM;IAOI,+BAAA;IAAA,kCAAA;ElBuxTV;;EkB9xTM;IAOI,8BAAA;IAAA,iCAAA;ElB4xTV;;EkBnyTM;IAOI,+BAAA;IAAA,kCAAA;ElBiyTV;;EkBxyTM;IAOI,4BAAA;IAAA,+BAAA;ElBsyTV;;EkB7yTM;IAOI,+BAAA;IAAA,kCAAA;ElB2yTV;;EkBlzTM;IAOI,8BAAA;IAAA,iCAAA;ElBgzTV;;EkBvzTM;IAOI,+BAAA;IAAA,kCAAA;ElBqzTV;;EkB5zTM;IAOI,4BAAA;IAAA,+BAAA;ElB0zTV;;EkBj0TM;IAOI,+BAAA;IAAA,kCAAA;ElB+zTV;;EkBt0TM;IAOI,8BAAA;IAAA,iCAAA;ElBo0TV;;EkB30TM;IAOI,+BAAA;IAAA,kCAAA;ElBy0TV;;EkBh1TM;IAOI,4BAAA;IAAA,+BAAA;ElB80TV;;EkBr1TM;IAOI,+BAAA;ElBk1TV;;EkBz1TM;IAOI,8BAAA;ElBs1TV;;EkB71TM;IAOI,+BAAA;ElB01TV;;EkBj2TM;IAOI,4BAAA;ElB81TV;;EkBr2TM;IAOI,+BAAA;ElBk2TV;;EkBz2TM;IAOI,8BAAA;ElBs2TV;;EkB72TM;IAOI,+BAAA;ElB02TV;;EkBj3TM;IAOI,4BAAA;ElB82TV;;EkBr3TM;IAOI,+BAAA;ElBk3TV;;EkBz3TM;IAOI,8BAAA;ElBs3TV;;EkB73TM;IAOI,+BAAA;ElB03TV;;EkBj4TM;IAOI,4BAAA;ElB83TV;;EkBr4TM;IAOI,+BAAA;ElBk4TV;;EkBz4TM;IAOI,8BAAA;ElBs4TV;;EkB74TM;IAOI,+BAAA;ElB04TV;;EkBj5TM;IAOI,4BAAA;ElB84TV;;EkBr5TM;IAOI,+BAAA;ElBk5TV;;EkBz5TM;IAOI,8BAAA;ElBs5TV;;EkB75TM;IAOI,+BAAA;ElB05TV;;EkBj6TM;IAOI,4BAAA;ElB85TV;;EkBr6TM;IAOI,iCAAA;ElBk6TV;;EkBz6TM;IAOI,gCAAA;ElBs6TV;;EkB76TM;IAOI,iCAAA;ElB06TV;;EkBj7TM;IAOI,8BAAA;ElB86TV;;EkBr7TM;IAOI,iCAAA;ElBk7TV;;EkBz7TM;IAOI,gCAAA;ElBs7TV;;EkB77TM;IAOI,iCAAA;ElB07TV;;EkBj8TM;IAOI,8BAAA;ElB87TV;;EkBr8TM;IAOI,iCAAA;ElBk8TV;;EkBz8TM;IAOI,gCAAA;ElBs8TV;;EkB78TM;IAOI,iCAAA;ElB08TV;;EkBj9TM;IAOI,8BAAA;ElB88TV;;EkBr9TM;IAOI,iCAAA;ElBk9TV;;EkBz9TM;IAOI,gCAAA;ElBs9TV;;EkB79TM;IAOI,iCAAA;ElB09TV;;EkBj+TM;IAOI,8BAAA;ElB89TV;;EkBr+TM;IAOI,iCAAA;ElBk+TV;;EkBz+TM;IAOI,gCAAA;ElBs+TV;;EkB7+TM;IAOI,iCAAA;ElB0+TV;;EkBj/TM;IAOI,8BAAA;ElB8+TV;;EkBr/TM;IAOI,kCAAA;ElBk/TV;;EkBz/TM;IAOI,iCAAA;ElBs/TV;;EkB7/TM;IAOI,kCAAA;ElB0/TV;;EkBjgUM;IAOI,+BAAA;ElB8/TV;;EkBrgUM;IAOI,kCAAA;ElBkgUV;;EkBzgUM;IAOI,iCAAA;ElBsgUV;;EkB7gUM;IAOI,kCAAA;ElB0gUV;;EkBjhUM;IAOI,+BAAA;ElB8gUV;;EkBrhUM;IAOI,kCAAA;ElBkhUV;;EkBzhUM;IAOI,iCAAA;ElBshUV;;EkB7hUM;IAOI,kCAAA;ElB0hUV;;EkBjiUM;IAOI,+BAAA;ElB8hUV;;EkBriUM;IAOI,kCAAA;ElBkiUV;;EkBziUM;IAOI,iCAAA;ElBsiUV;;EkB7iUM;IAOI,kCAAA;ElB0iUV;;EkBjjUM;IAOI,+BAAA;ElB8iUV;;EkBrjUM;IAOI,kCAAA;ElBkjUV;;EkBzjUM;IAOI,iCAAA;ElBsjUV;;EkB7jUM;IAOI,kCAAA;ElB0jUV;;EkBjkUM;IAOI,+BAAA;ElB8jUV;;EkBrkUM;IAOI,gCAAA;ElBkkUV;;EkBzkUM;IAOI,+BAAA;ElBskUV;;EkB7kUM;IAOI,gCAAA;ElB0kUV;;EkBjlUM;IAOI,6BAAA;ElB8kUV;;EkBrlUM;IAOI,gCAAA;ElBklUV;;EkBzlUM;IAOI,+BAAA;ElBslUV;;EkB7lUM;IAOI,gCAAA;ElB0lUV;;EkBjmUM;IAOI,6BAAA;ElB8lUV;;EkBrmUM;IAOI,gCAAA;ElBkmUV;;EkBzmUM;IAOI,+BAAA;ElBsmUV;;EkB7mUM;IAOI,gCAAA;ElB0mUV;;EkBjnUM;IAOI,6BAAA;ElB8mUV;;EkBrnUM;IAOI,gCAAA;ElBknUV;;EkBznUM;IAOI,+BAAA;ElBsnUV;;EkB7nUM;IAOI,gCAAA;ElB0nUV;;EkBjoUM;IAOI,6BAAA;ElB8nUV;;EkBroUM;IAOI,gCAAA;ElBkoUV;;EkBzoUM;IAOI,+BAAA;ElBsoUV;;EkB7oUM;IAOI,gCAAA;ElB0oUV;;EkBjpUM;IAOI,6BAAA;ElB8oUV;;EkBrpUM;IAOI,qBAAA;ElBkpUV;;EkBzpUM;IAOI,2BAAA;ElBspUV;;EkB7pUM;IAOI,0BAAA;ElB0pUV;;EkBjqUM;IAOI,2BAAA;ElB8pUV;;EkBrqUM;IAOI,wBAAA;ElBkqUV;;EkBzqUM;IAOI,2BAAA;ElBsqUV;;EkB7qUM;IAOI,0BAAA;ElB0qUV;;EkBjrUM;IAOI,2BAAA;ElB8qUV;;EkBrrUM;IAOI,wBAAA;ElBkrUV;;EkBzrUM;IAOI,2BAAA;ElBsrUV;;EkB7rUM;IAOI,0BAAA;ElB0rUV;;EkBjsUM;IAOI,2BAAA;ElB8rUV;;EkBrsUM;IAOI,wBAAA;ElBksUV;;EkBzsUM;IAOI,2BAAA;ElBssUV;;EkB7sUM;IAOI,0BAAA;ElB0sUV;;EkBjtUM;IAOI,2BAAA;ElB8sUV;;EkBrtUM;IAOI,wBAAA;ElBktUV;;EkBztUM;IAOI,2BAAA;ElBstUV;;EkB7tUM;IAOI,0BAAA;ElB0tUV;;EkBjuUM;IAOI,2BAAA;ElB8tUV;;EkBruUM;IAOI,wBAAA;ElBkuUV;;EkBzuUM;IAOI,2BAAA;IAAA,0BAAA;ElBuuUV;;EkB9uUM;IAOI,iCAAA;IAAA,gCAAA;ElB4uUV;;EkBnvUM;IAOI,gCAAA;IAAA,+BAAA;ElBivUV;;EkBxvUM;IAOI,iCAAA;IAAA,gCAAA;ElBsvUV;;EkB7vUM;IAOI,8BAAA;IAAA,6BAAA;ElB2vUV;;EkBlwUM;IAOI,iCAAA;IAAA,gCAAA;ElBgwUV;;EkBvwUM;IAOI,gCAAA;IAAA,+BAAA;ElBqwUV;;EkB5wUM;IAOI,iCAAA;IAAA,gCAAA;ElB0wUV;;EkBjxUM;IAOI,8BAAA;IAAA,6BAAA;ElB+wUV;;EkBtxUM;IAOI,iCAAA;IAAA,gCAAA;ElBoxUV;;EkB3xUM;IAOI,gCAAA;IAAA,+BAAA;ElByxUV;;EkBhyUM;IAOI,iCAAA;IAAA,gCAAA;ElB8xUV;;EkBryUM;IAOI,8BAAA;IAAA,6BAAA;ElBmyUV;;EkB1yUM;IAOI,iCAAA;IAAA,gCAAA;ElBwyUV;;EkB/yUM;IAOI,gCAAA;IAAA,+BAAA;ElB6yUV;;EkBpzUM;IAOI,iCAAA;IAAA,gCAAA;ElBkzUV;;EkBzzUM;IAOI,8BAAA;IAAA,6BAAA;ElBuzUV;;EkB9zUM;IAOI,iCAAA;IAAA,gCAAA;ElB4zUV;;EkBn0UM;IAOI,gCAAA;IAAA,+BAAA;ElBi0UV;;EkBx0UM;IAOI,iCAAA;IAAA,gCAAA;ElBs0UV;;EkB70UM;IAOI,8BAAA;IAAA,6BAAA;ElB20UV;;EkBl1UM;IAOI,yBAAA;IAAA,4BAAA;ElBg1UV;;EkBv1UM;IAOI,+BAAA;IAAA,kCAAA;ElBq1UV;;EkB51UM;IAOI,8BAAA;IAAA,iCAAA;ElB01UV;;EkBj2UM;IAOI,+BAAA;IAAA,kCAAA;ElB+1UV;;EkBt2UM;IAOI,4BAAA;IAAA,+BAAA;ElBo2UV;;EkB32UM;IAOI,+BAAA;IAAA,kCAAA;ElBy2UV;;EkBh3UM;IAOI,8BAAA;IAAA,iCAAA;ElB82UV;;EkBr3UM;IAOI,+BAAA;IAAA,kCAAA;ElBm3UV;;EkB13UM;IAOI,4BAAA;IAAA,+BAAA;ElBw3UV;;EkB/3UM;IAOI,+BAAA;IAAA,kCAAA;ElB63UV;;EkBp4UM;IAOI,8BAAA;IAAA,iCAAA;ElBk4UV;;EkBz4UM;IAOI,+BAAA;IAAA,kCAAA;ElBu4UV;;EkB94UM;IAOI,4BAAA;IAAA,+BAAA;ElB44UV;;EkBn5UM;IAOI,+BAAA;IAAA,kCAAA;ElBi5UV;;EkBx5UM;IAOI,8BAAA;IAAA,iCAAA;ElBs5UV;;EkB75UM;IAOI,+BAAA;IAAA,kCAAA;ElB25UV;;EkBl6UM;IAOI,4BAAA;IAAA,+BAAA;ElBg6UV;;EkBv6UM;IAOI,+BAAA;IAAA,kCAAA;ElBq6UV;;EkB56UM;IAOI,8BAAA;IAAA,iCAAA;ElB06UV;;EkBj7UM;IAOI,+BAAA;IAAA,kCAAA;ElB+6UV;;EkBt7UM;IAOI,4BAAA;IAAA,+BAAA;ElBo7UV;;EkB37UM;IAOI,yBAAA;ElBw7UV;;EkB/7UM;IAOI,+BAAA;ElB47UV;;EkBn8UM;IAOI,8BAAA;ElBg8UV;;EkBv8UM;IAOI,+BAAA;ElBo8UV;;EkB38UM;IAOI,4BAAA;ElBw8UV;;EkB/8UM;IAOI,+BAAA;ElB48UV;;EkBn9UM;IAOI,8BAAA;ElBg9UV;;EkBv9UM;IAOI,+BAAA;ElBo9UV;;EkB39UM;IAOI,4BAAA;ElBw9UV;;EkB/9UM;IAOI,+BAAA;ElB49UV;;EkBn+UM;IAOI,8BAAA;ElBg+UV;;EkBv+UM;IAOI,+BAAA;ElBo+UV;;EkB3+UM;IAOI,4BAAA;ElBw+UV;;EkB/+UM;IAOI,+BAAA;ElB4+UV;;EkBn/UM;IAOI,8BAAA;ElBg/UV;;EkBv/UM;IAOI,+BAAA;ElBo/UV;;EkB3/UM;IAOI,4BAAA;ElBw/UV;;EkB//UM;IAOI,+BAAA;ElB4/UV;;EkBngVM;IAOI,8BAAA;ElBggVV;;EkBvgVM;IAOI,+BAAA;ElBogVV;;EkB3gVM;IAOI,4BAAA;ElBwgVV;;EkB/gVM;IAOI,2BAAA;ElB4gVV;;EkBnhVM;IAOI,iCAAA;ElBghVV;;EkBvhVM;IAOI,gCAAA;ElBohVV;;EkB3hVM;IAOI,iCAAA;ElBwhVV;;EkB/hVM;IAOI,8BAAA;ElB4hVV;;EkBniVM;IAOI,iCAAA;ElBgiVV;;EkBviVM;IAOI,gCAAA;ElBoiVV;;EkB3iVM;IAOI,iCAAA;ElBwiVV;;EkB/iVM;IAOI,8BAAA;ElB4iVV;;EkBnjVM;IAOI,iCAAA;ElBgjVV;;EkBvjVM;IAOI,gCAAA;ElBojVV;;EkB3jVM;IAOI,iCAAA;ElBwjVV;;EkB/jVM;IAOI,8BAAA;ElB4jVV;;EkBnkVM;IAOI,iCAAA;ElBgkVV;;EkBvkVM;IAOI,gCAAA;ElBokVV;;EkB3kVM;IAOI,iCAAA;ElBwkVV;;EkB/kVM;IAOI,8BAAA;ElB4kVV;;EkBnlVM;IAOI,iCAAA;ElBglVV;;EkBvlVM;IAOI,gCAAA;ElBolVV;;EkB3lVM;IAOI,iCAAA;ElBwlVV;;EkB/lVM;IAOI,8BAAA;ElB4lVV;;EkBnmVM;IAOI,4BAAA;ElBgmVV;;EkBvmVM;IAOI,kCAAA;ElBomVV;;EkB3mVM;IAOI,iCAAA;ElBwmVV;;EkB/mVM;IAOI,kCAAA;ElB4mVV;;EkBnnVM;IAOI,+BAAA;ElBgnVV;;EkBvnVM;IAOI,kCAAA;ElBonVV;;EkB3nVM;IAOI,iCAAA;ElBwnVV;;EkB/nVM;IAOI,kCAAA;ElB4nVV;;EkBnoVM;IAOI,+BAAA;ElBgoVV;;EkBvoVM;IAOI,kCAAA;ElBooVV;;EkB3oVM;IAOI,iCAAA;ElBwoVV;;EkB/oVM;IAOI,kCAAA;ElB4oVV;;EkBnpVM;IAOI,+BAAA;ElBgpVV;;EkBvpVM;IAOI,kCAAA;ElBopVV;;EkB3pVM;IAOI,iCAAA;ElBwpVV;;EkB/pVM;IAOI,kCAAA;ElB4pVV;;EkBnqVM;IAOI,+BAAA;ElBgqVV;;EkBvqVM;IAOI,kCAAA;ElBoqVV;;EkB3qVM;IAOI,iCAAA;ElBwqVV;;EkB/qVM;IAOI,kCAAA;ElB4qVV;;EkBnrVM;IAOI,+BAAA;ElBgrVV;;EkBvrVM;IAOI,0BAAA;ElBorVV;;EkB3rVM;IAOI,gCAAA;ElBwrVV;;EkB/rVM;IAOI,+BAAA;ElB4rVV;;EkBnsVM;IAOI,gCAAA;ElBgsVV;;EkBvsVM;IAOI,6BAAA;ElBosVV;;EkB3sVM;IAOI,gCAAA;ElBwsVV;;EkB/sVM;IAOI,+BAAA;ElB4sVV;;EkBntVM;IAOI,gCAAA;ElBgtVV;;EkBvtVM;IAOI,6BAAA;ElBotVV;;EkB3tVM;IAOI,gCAAA;ElBwtVV;;EkB/tVM;IAOI,+BAAA;ElB4tVV;;EkBnuVM;IAOI,gCAAA;ElBguVV;;EkBvuVM;IAOI,6BAAA;ElBouVV;;EkB3uVM;IAOI,gCAAA;ElBwuVV;;EkB/uVM;IAOI,+BAAA;ElB4uVV;;EkBnvVM;IAOI,gCAAA;ElBgvVV;;EkBvvVM;IAOI,6BAAA;ElBovVV;;EkB3vVM;IAOI,gCAAA;ElBwvVV;;EkB/vVM;IAOI,+BAAA;ElB4vVV;;EkBnwVM;IAOI,gCAAA;ElBgwVV;;EkBvwVM;IAOI,6BAAA;ElBowVV;;EkB3wVM;IAOI,iBAAA;ElBwwVV;;EkB/wVM;IAOI,uBAAA;ElB4wVV;;EkBnxVM;IAOI,sBAAA;ElBgxVV;;EkBvxVM;IAOI,uBAAA;ElBoxVV;;EkB3xVM;IAOI,oBAAA;ElBwxVV;;EkB/xVM;IAOI,uBAAA;ElB4xVV;;EkBnyVM;IAOI,sBAAA;ElBgyVV;;EkBvyVM;IAOI,uBAAA;ElBoyVV;;EkB3yVM;IAOI,oBAAA;ElBwyVV;;EkB/yVM;IAOI,uBAAA;ElB4yVV;;EkBnzVM;IAOI,sBAAA;ElBgzVV;;EkBvzVM;IAOI,uBAAA;ElBozVV;;EkB3zVM;IAOI,oBAAA;ElBwzVV;;EkB/zVM;IAOI,uBAAA;ElB4zVV;;EkBn0VM;IAOI,sBAAA;ElBg0VV;;EkBv0VM;IAOI,uBAAA;ElBo0VV;;EkB30VM;IAOI,oBAAA;ElBw0VV;;EkB/0VM;IAOI,uBAAA;ElB40VV;;EkBn1VM;IAOI,sBAAA;ElBg1VV;;EkBv1VM;IAOI,uBAAA;ElBo1VV;;EkB31VM;IAOI,oBAAA;ElBw1VV;;EkB/1VM;IAOI,qBAAA;ElB41VV;;EkBn2VM;IAOI,2BAAA;ElBg2VV;;EkBv2VM;IAOI,0BAAA;ElBo2VV;;EkB32VM;IAOI,2BAAA;ElBw2VV;;EkB/2VM;IAOI,wBAAA;ElB42VV;;EkBn3VM;IAOI,2BAAA;ElBg3VV;;EkBv3VM;IAOI,0BAAA;ElBo3VV;;EkB33VM;IAOI,2BAAA;ElBw3VV;;EkB/3VM;IAOI,wBAAA;ElB43VV;;EkBn4VM;IAOI,2BAAA;ElBg4VV;;EkBv4VM;IAOI,0BAAA;ElBo4VV;;EkB34VM;IAOI,2BAAA;ElBw4VV;;EkB/4VM;IAOI,wBAAA;ElB44VV;;EkBn5VM;IAOI,2BAAA;ElBg5VV;;EkBv5VM;IAOI,0BAAA;ElBo5VV;;EkB35VM;IAOI,2BAAA;ElBw5VV;;EkB/5VM;IAOI,wBAAA;ElB45VV;;EkBn6VM;IAOI,2BAAA;ElBg6VV;;EkBv6VM;IAOI,0BAAA;ElBo6VV;;EkB36VM;IAOI,2BAAA;ElBw6VV;;EkB/6VM;IAOI,wBAAA;ElB46VV;;EkBn7VM;IAOI,wBAAA;ElBg7VV;;EkBv7VM;IAOI,8BAAA;ElBo7VV;;EkB37VM;IAOI,6BAAA;ElBw7VV;;EkB/7VM;IAOI,8BAAA;ElB47VV;;EkBn8VM;IAOI,2BAAA;ElBg8VV;;EkBv8VM;IAOI,8BAAA;ElBo8VV;;EkB38VM;IAOI,6BAAA;ElBw8VV;;EkB/8VM;IAOI,8BAAA;ElB48VV;;EkBn9VM;IAOI,2BAAA;ElBg9VV;;EkBv9VM;IAOI,8BAAA;ElBo9VV;;EkB39VM;IAOI,6BAAA;ElBw9VV;;EkB/9VM;IAOI,8BAAA;ElB49VV;;EkBn+VM;IAOI,2BAAA;ElBg+VV;;EkBv+VM;IAOI,8BAAA;ElBo+VV;;EkB3+VM;IAOI,6BAAA;ElBw+VV;;EkB/+VM;IAOI,8BAAA;ElB4+VV;;EkBn/VM;IAOI,2BAAA;ElBg/VV;;EkBv/VM;IAOI,8BAAA;ElBo/VV;;EkB3/VM;IAOI,6BAAA;ElBw/VV;;EkB//VM;IAOI,8BAAA;ElB4/VV;;EkBngWM;IAOI,2BAAA;ElBggWV;;EkBvgWM;IAOI,2BAAA;ElBogWV;;EkB3gWM;IAOI,4BAAA;ElBwgWV;;EkB/gWM;IAOI,6BAAA;ElB4gWV;AACF;AUvhWI;EQGI;IAOI,sBAAA;ElBihWV;;EkBxhWM;IAOI,uBAAA;ElBqhWV;;EkB5hWM;IAOI,sBAAA;ElByhWV;;EkBhiWM;IAOI,8BAAA;ElB6hWV;;EkBpiWM;IAOI,4BAAA;ElBiiWV;;EkBxiWM;IAOI,2BAAA;ElBqiWV;;EkB5iWM;IAOI,iCAAA;ElByiWV;;EkBhjWM;IAOI,2BAAA;ElB6iWV;;EkBpjWM;IAOI,0BAAA;ElBijWV;;EkBxjWM;IAOI,gCAAA;ElBqjWV;;EkB5jWM;IAOI,yBAAA;ElByjWV;;EkBhkWM;IAOI,wBAAA;ElB6jWV;;EkBpkWM;IAOI,+BAAA;ElBikWV;;EkBxkWM;IAOI,yBAAA;ElBqkWV;;EkB5kWM;IAOI,6BAAA;ElBykWV;;EkBhlWM;IAOI,8BAAA;ElB6kWV;;EkBplWM;IAOI,wBAAA;ElBilWV;;EkBxlWM;IAOI,+BAAA;ElBqlWV;;EkB5lWM;IAOI,wBAAA;ElBylWV;;EkBhmWM;IAOI,yBAAA;ElB6lWV;;EkBpmWM;IAOI,8BAAA;ElBimWV;;EkBxmWM;IAOI,iCAAA;ElBqmWV;;EkB5mWM;IAOI,sCAAA;ElBymWV;;EkBhnWM;IAOI,yCAAA;ElB6mWV;;EkBpnWM;IAOI,uBAAA;ElBinWV;;EkBxnWM;IAOI,uBAAA;ElBqnWV;;EkB5nWM;IAOI,yBAAA;ElBynWV;;EkBhoWM;IAOI,yBAAA;ElB6nWV;;EkBpoWM;IAOI,0BAAA;ElBioWV;;EkBxoWM;IAOI,4BAAA;ElBqoWV;;EkB5oWM;IAOI,kCAAA;ElByoWV;;EkBhpWM;IAOI,sCAAA;ElB6oWV;;EkBppWM;IAOI,oCAAA;ElBipWV;;EkBxpWM;IAOI,kCAAA;ElBqpWV;;EkB5pWM;IAOI,yCAAA;ElBypWV;;EkBhqWM;IAOI,wCAAA;ElB6pWV;;EkBpqWM;IAOI,wCAAA;ElBiqWV;;EkBxqWM;IAOI,kCAAA;ElBqqWV;;EkB5qWM;IAOI,gCAAA;ElByqWV;;EkBhrWM;IAOI,8BAAA;ElB6qWV;;EkBprWM;IAOI,gCAAA;ElBirWV;;EkBxrWM;IAOI,+BAAA;ElBqrWV;;EkB5rWM;IAOI,oCAAA;ElByrWV;;EkBhsWM;IAOI,kCAAA;ElB6rWV;;EkBpsWM;IAOI,gCAAA;ElBisWV;;EkBxsWM;IAOI,uCAAA;ElBqsWV;;EkB5sWM;IAOI,sCAAA;ElBysWV;;EkBhtWM;IAOI,iCAAA;ElB6sWV;;EkBptWM;IAOI,2BAAA;ElBitWV;;EkBxtWM;IAOI,iCAAA;ElBqtWV;;EkB5tWM;IAOI,+BAAA;ElBytWV;;EkBhuWM;IAOI,6BAAA;ElB6tWV;;EkBpuWM;IAOI,+BAAA;ElBiuWV;;EkBxuWM;IAOI,8BAAA;ElBquWV;;EkB5uWM;IAOI,oBAAA;ElByuWV;;EkBhvWM;IAOI,mBAAA;ElB6uWV;;EkBpvWM;IAOI,mBAAA;ElBivWV;;EkBxvWM;IAOI,mBAAA;ElBqvWV;;EkB5vWM;IAOI,mBAAA;ElByvWV;;EkBhwWM;IAOI,mBAAA;ElB6vWV;;EkBpwWM;IAOI,mBAAA;ElBiwWV;;EkBxwWM;IAOI,mBAAA;ElBqwWV;;EkB5wWM;IAOI,oBAAA;ElBywWV;;EkBhxWM;IAOI,0BAAA;ElB6wWV;;EkBpxWM;IAOI,yBAAA;ElBixWV;;EkBxxWM;IAOI,0BAAA;ElBqxWV;;EkB5xWM;IAOI,uBAAA;ElByxWV;;EkBhyWM;IAOI,0BAAA;ElB6xWV;;EkBpyWM;IAOI,yBAAA;ElBiyWV;;EkBxyWM;IAOI,0BAAA;ElBqyWV;;EkB5yWM;IAOI,uBAAA;ElByyWV;;EkBhzWM;IAOI,0BAAA;ElB6yWV;;EkBpzWM;IAOI,yBAAA;ElBizWV;;EkBxzWM;IAOI,0BAAA;ElBqzWV;;EkB5zWM;IAOI,uBAAA;ElByzWV;;EkBh0WM;IAOI,0BAAA;ElB6zWV;;EkBp0WM;IAOI,yBAAA;ElBi0WV;;EkBx0WM;IAOI,0BAAA;ElBq0WV;;EkB50WM;IAOI,uBAAA;ElBy0WV;;EkBh1WM;IAOI,0BAAA;ElB60WV;;EkBp1WM;IAOI,yBAAA;ElBi1WV;;EkBx1WM;IAOI,0BAAA;ElBq1WV;;EkB51WM;IAOI,uBAAA;ElBy1WV;;EkBh2WM;IAOI,uBAAA;ElB61WV;;EkBp2WM;IAOI,0BAAA;IAAA,yBAAA;ElBk2WV;;EkBz2WM;IAOI,gCAAA;IAAA,+BAAA;ElBu2WV;;EkB92WM;IAOI,+BAAA;IAAA,8BAAA;ElB42WV;;EkBn3WM;IAOI,gCAAA;IAAA,+BAAA;ElBi3WV;;EkBx3WM;IAOI,6BAAA;IAAA,4BAAA;ElBs3WV;;EkB73WM;IAOI,gCAAA;IAAA,+BAAA;ElB23WV;;EkBl4WM;IAOI,+BAAA;IAAA,8BAAA;ElBg4WV;;EkBv4WM;IAOI,gCAAA;IAAA,+BAAA;ElBq4WV;;EkB54WM;IAOI,6BAAA;IAAA,4BAAA;ElB04WV;;EkBj5WM;IAOI,gCAAA;IAAA,+BAAA;ElB+4WV;;EkBt5WM;IAOI,+BAAA;IAAA,8BAAA;ElBo5WV;;EkB35WM;IAOI,gCAAA;IAAA,+BAAA;ElBy5WV;;EkBh6WM;IAOI,6BAAA;IAAA,4BAAA;ElB85WV;;EkBr6WM;IAOI,gCAAA;IAAA,+BAAA;ElBm6WV;;EkB16WM;IAOI,+BAAA;IAAA,8BAAA;ElBw6WV;;EkB/6WM;IAOI,gCAAA;IAAA,+BAAA;ElB66WV;;EkBp7WM;IAOI,6BAAA;IAAA,4BAAA;ElBk7WV;;EkBz7WM;IAOI,gCAAA;IAAA,+BAAA;ElBu7WV;;EkB97WM;IAOI,+BAAA;IAAA,8BAAA;ElB47WV;;EkBn8WM;IAOI,gCAAA;IAAA,+BAAA;ElBi8WV;;EkBx8WM;IAOI,6BAAA;IAAA,4BAAA;ElBs8WV;;EkB78WM;IAOI,6BAAA;IAAA,4BAAA;ElB28WV;;EkBl9WM;IAOI,wBAAA;IAAA,2BAAA;ElBg9WV;;EkBv9WM;IAOI,8BAAA;IAAA,iCAAA;ElBq9WV;;EkB59WM;IAOI,6BAAA;IAAA,gCAAA;ElB09WV;;EkBj+WM;IAOI,8BAAA;IAAA,iCAAA;ElB+9WV;;EkBt+WM;IAOI,2BAAA;IAAA,8BAAA;ElBo+WV;;EkB3+WM;IAOI,8BAAA;IAAA,iCAAA;ElBy+WV;;EkBh/WM;IAOI,6BAAA;IAAA,gCAAA;ElB8+WV;;EkBr/WM;IAOI,8BAAA;IAAA,iCAAA;ElBm/WV;;EkB1/WM;IAOI,2BAAA;IAAA,8BAAA;ElBw/WV;;EkB//WM;IAOI,8BAAA;IAAA,iCAAA;ElB6/WV;;EkBpgXM;IAOI,6BAAA;IAAA,gCAAA;ElBkgXV;;EkBzgXM;IAOI,8BAAA;IAAA,iCAAA;ElBugXV;;EkB9gXM;IAOI,2BAAA;IAAA,8BAAA;ElB4gXV;;EkBnhXM;IAOI,8BAAA;IAAA,iCAAA;ElBihXV;;EkBxhXM;IAOI,6BAAA;IAAA,gCAAA;ElBshXV;;EkB7hXM;IAOI,8BAAA;IAAA,iCAAA;ElB2hXV;;EkBliXM;IAOI,2BAAA;IAAA,8BAAA;ElBgiXV;;EkBviXM;IAOI,8BAAA;IAAA,iCAAA;ElBqiXV;;EkB5iXM;IAOI,6BAAA;IAAA,gCAAA;ElB0iXV;;EkBjjXM;IAOI,8BAAA;IAAA,iCAAA;ElB+iXV;;EkBtjXM;IAOI,2BAAA;IAAA,8BAAA;ElBojXV;;EkB3jXM;IAOI,2BAAA;IAAA,8BAAA;ElByjXV;;EkBhkXM;IAOI,wBAAA;ElB6jXV;;EkBpkXM;IAOI,8BAAA;ElBikXV;;EkBxkXM;IAOI,6BAAA;ElBqkXV;;EkB5kXM;IAOI,8BAAA;ElBykXV;;EkBhlXM;IAOI,2BAAA;ElB6kXV;;EkBplXM;IAOI,8BAAA;ElBilXV;;EkBxlXM;IAOI,6BAAA;ElBqlXV;;EkB5lXM;IAOI,8BAAA;ElBylXV;;EkBhmXM;IAOI,2BAAA;ElB6lXV;;EkBpmXM;IAOI,8BAAA;ElBimXV;;EkBxmXM;IAOI,6BAAA;ElBqmXV;;EkB5mXM;IAOI,8BAAA;ElBymXV;;EkBhnXM;IAOI,2BAAA;ElB6mXV;;EkBpnXM;IAOI,8BAAA;ElBinXV;;EkBxnXM;IAOI,6BAAA;ElBqnXV;;EkB5nXM;IAOI,8BAAA;ElBynXV;;EkBhoXM;IAOI,2BAAA;ElB6nXV;;EkBpoXM;IAOI,8BAAA;ElBioXV;;EkBxoXM;IAOI,6BAAA;ElBqoXV;;EkB5oXM;IAOI,8BAAA;ElByoXV;;EkBhpXM;IAOI,2BAAA;ElB6oXV;;EkBppXM;IAOI,2BAAA;ElBipXV;;EkBxpXM;IAOI,0BAAA;ElBqpXV;;EkB5pXM;IAOI,gCAAA;ElBypXV;;EkBhqXM;IAOI,+BAAA;ElB6pXV;;EkBpqXM;IAOI,gCAAA;ElBiqXV;;EkBxqXM;IAOI,6BAAA;ElBqqXV;;EkB5qXM;IAOI,gCAAA;ElByqXV;;EkBhrXM;IAOI,+BAAA;ElB6qXV;;EkBprXM;IAOI,gCAAA;ElBirXV;;EkBxrXM;IAOI,6BAAA;ElBqrXV;;EkB5rXM;IAOI,gCAAA;ElByrXV;;EkBhsXM;IAOI,+BAAA;ElB6rXV;;EkBpsXM;IAOI,gCAAA;ElBisXV;;EkBxsXM;IAOI,6BAAA;ElBqsXV;;EkB5sXM;IAOI,gCAAA;ElBysXV;;EkBhtXM;IAOI,+BAAA;ElB6sXV;;EkBptXM;IAOI,gCAAA;ElBitXV;;EkBxtXM;IAOI,6BAAA;ElBqtXV;;EkB5tXM;IAOI,gCAAA;ElBytXV;;EkBhuXM;IAOI,+BAAA;ElB6tXV;;EkBpuXM;IAOI,gCAAA;ElBiuXV;;EkBxuXM;IAOI,6BAAA;ElBquXV;;EkB5uXM;IAOI,6BAAA;ElByuXV;;EkBhvXM;IAOI,2BAAA;ElB6uXV;;EkBpvXM;IAOI,iCAAA;ElBivXV;;EkBxvXM;IAOI,gCAAA;ElBqvXV;;EkB5vXM;IAOI,iCAAA;ElByvXV;;EkBhwXM;IAOI,8BAAA;ElB6vXV;;EkBpwXM;IAOI,iCAAA;ElBiwXV;;EkBxwXM;IAOI,gCAAA;ElBqwXV;;EkB5wXM;IAOI,iCAAA;ElBywXV;;EkBhxXM;IAOI,8BAAA;ElB6wXV;;EkBpxXM;IAOI,iCAAA;ElBixXV;;EkBxxXM;IAOI,gCAAA;ElBqxXV;;EkB5xXM;IAOI,iCAAA;ElByxXV;;EkBhyXM;IAOI,8BAAA;ElB6xXV;;EkBpyXM;IAOI,iCAAA;ElBiyXV;;EkBxyXM;IAOI,gCAAA;ElBqyXV;;EkB5yXM;IAOI,iCAAA;ElByyXV;;EkBhzXM;IAOI,8BAAA;ElB6yXV;;EkBpzXM;IAOI,iCAAA;ElBizXV;;EkBxzXM;IAOI,gCAAA;ElBqzXV;;EkB5zXM;IAOI,iCAAA;ElByzXV;;EkBh0XM;IAOI,8BAAA;ElB6zXV;;EkBp0XM;IAOI,8BAAA;ElBi0XV;;EkBx0XM;IAOI,yBAAA;ElBq0XV;;EkB50XM;IAOI,+BAAA;ElBy0XV;;EkBh1XM;IAOI,8BAAA;ElB60XV;;EkBp1XM;IAOI,+BAAA;ElBi1XV;;EkBx1XM;IAOI,4BAAA;ElBq1XV;;EkB51XM;IAOI,+BAAA;ElBy1XV;;EkBh2XM;IAOI,8BAAA;ElB61XV;;EkBp2XM;IAOI,+BAAA;ElBi2XV;;EkBx2XM;IAOI,4BAAA;ElBq2XV;;EkB52XM;IAOI,+BAAA;ElBy2XV;;EkBh3XM;IAOI,8BAAA;ElB62XV;;EkBp3XM;IAOI,+BAAA;ElBi3XV;;EkBx3XM;IAOI,4BAAA;ElBq3XV;;EkB53XM;IAOI,+BAAA;ElBy3XV;;EkBh4XM;IAOI,8BAAA;ElB63XV;;EkBp4XM;IAOI,+BAAA;ElBi4XV;;EkBx4XM;IAOI,4BAAA;ElBq4XV;;EkB54XM;IAOI,+BAAA;ElBy4XV;;EkBh5XM;IAOI,8BAAA;ElB64XV;;EkBp5XM;IAOI,+BAAA;ElBi5XV;;EkBx5XM;IAOI,4BAAA;ElBq5XV;;EkB55XM;IAOI,4BAAA;ElBy5XV;;EkBh6XM;IAOI,2BAAA;ElB65XV;;EkBp6XM;IAOI,0BAAA;ElBi6XV;;EkBx6XM;IAOI,2BAAA;ElBq6XV;;EkB56XM;IAOI,wBAAA;ElBy6XV;;EkBh7XM;IAOI,2BAAA;ElB66XV;;EkBp7XM;IAOI,0BAAA;ElBi7XV;;EkBx7XM;IAOI,2BAAA;ElBq7XV;;EkB57XM;IAOI,wBAAA;ElBy7XV;;EkBh8XM;IAOI,2BAAA;ElB67XV;;EkBp8XM;IAOI,0BAAA;ElBi8XV;;EkBx8XM;IAOI,2BAAA;ElBq8XV;;EkB58XM;IAOI,wBAAA;ElBy8XV;;EkBh9XM;IAOI,2BAAA;ElB68XV;;EkBp9XM;IAOI,0BAAA;ElBi9XV;;EkBx9XM;IAOI,2BAAA;ElBq9XV;;EkB59XM;IAOI,wBAAA;ElBy9XV;;EkBh+XM;IAOI,2BAAA;ElB69XV;;EkBp+XM;IAOI,0BAAA;ElBi+XV;;EkBx+XM;IAOI,2BAAA;ElBq+XV;;EkB5+XM;IAOI,wBAAA;ElBy+XV;;EkBh/XM;IAOI,iCAAA;IAAA,gCAAA;ElB8+XV;;EkBr/XM;IAOI,gCAAA;IAAA,+BAAA;ElBm/XV;;EkB1/XM;IAOI,iCAAA;IAAA,gCAAA;ElBw/XV;;EkB//XM;IAOI,8BAAA;IAAA,6BAAA;ElB6/XV;;EkBpgYM;IAOI,iCAAA;IAAA,gCAAA;ElBkgYV;;EkBzgYM;IAOI,gCAAA;IAAA,+BAAA;ElBugYV;;EkB9gYM;IAOI,iCAAA;IAAA,gCAAA;ElB4gYV;;EkBnhYM;IAOI,8BAAA;IAAA,6BAAA;ElBihYV;;EkBxhYM;IAOI,iCAAA;IAAA,gCAAA;ElBshYV;;EkB7hYM;IAOI,gCAAA;IAAA,+BAAA;ElB2hYV;;EkBliYM;IAOI,iCAAA;IAAA,gCAAA;ElBgiYV;;EkBviYM;IAOI,8BAAA;IAAA,6BAAA;ElBqiYV;;EkB5iYM;IAOI,iCAAA;IAAA,gCAAA;ElB0iYV;;EkBjjYM;IAOI,gCAAA;IAAA,+BAAA;ElB+iYV;;EkBtjYM;IAOI,iCAAA;IAAA,gCAAA;ElBojYV;;EkB3jYM;IAOI,8BAAA;IAAA,6BAAA;ElByjYV;;EkBhkYM;IAOI,iCAAA;IAAA,gCAAA;ElB8jYV;;EkBrkYM;IAOI,gCAAA;IAAA,+BAAA;ElBmkYV;;EkB1kYM;IAOI,iCAAA;IAAA,gCAAA;ElBwkYV;;EkB/kYM;IAOI,8BAAA;IAAA,6BAAA;ElB6kYV;;EkBplYM;IAOI,+BAAA;IAAA,kCAAA;ElBklYV;;EkBzlYM;IAOI,8BAAA;IAAA,iCAAA;ElBulYV;;EkB9lYM;IAOI,+BAAA;IAAA,kCAAA;ElB4lYV;;EkBnmYM;IAOI,4BAAA;IAAA,+BAAA;ElBimYV;;EkBxmYM;IAOI,+BAAA;IAAA,kCAAA;ElBsmYV;;EkB7mYM;IAOI,8BAAA;IAAA,iCAAA;ElB2mYV;;EkBlnYM;IAOI,+BAAA;IAAA,kCAAA;ElBgnYV;;EkBvnYM;IAOI,4BAAA;IAAA,+BAAA;ElBqnYV;;EkB5nYM;IAOI,+BAAA;IAAA,kCAAA;ElB0nYV;;EkBjoYM;IAOI,8BAAA;IAAA,iCAAA;ElB+nYV;;EkBtoYM;IAOI,+BAAA;IAAA,kCAAA;ElBooYV;;EkB3oYM;IAOI,4BAAA;IAAA,+BAAA;ElByoYV;;EkBhpYM;IAOI,+BAAA;IAAA,kCAAA;ElB8oYV;;EkBrpYM;IAOI,8BAAA;IAAA,iCAAA;ElBmpYV;;EkB1pYM;IAOI,+BAAA;IAAA,kCAAA;ElBwpYV;;EkB/pYM;IAOI,4BAAA;IAAA,+BAAA;ElB6pYV;;EkBpqYM;IAOI,+BAAA;IAAA,kCAAA;ElBkqYV;;EkBzqYM;IAOI,8BAAA;IAAA,iCAAA;ElBuqYV;;EkB9qYM;IAOI,+BAAA;IAAA,kCAAA;ElB4qYV;;EkBnrYM;IAOI,4BAAA;IAAA,+BAAA;ElBirYV;;EkBxrYM;IAOI,+BAAA;ElBqrYV;;EkB5rYM;IAOI,8BAAA;ElByrYV;;EkBhsYM;IAOI,+BAAA;ElB6rYV;;EkBpsYM;IAOI,4BAAA;ElBisYV;;EkBxsYM;IAOI,+BAAA;ElBqsYV;;EkB5sYM;IAOI,8BAAA;ElBysYV;;EkBhtYM;IAOI,+BAAA;ElB6sYV;;EkBptYM;IAOI,4BAAA;ElBitYV;;EkBxtYM;IAOI,+BAAA;ElBqtYV;;EkB5tYM;IAOI,8BAAA;ElBytYV;;EkBhuYM;IAOI,+BAAA;ElB6tYV;;EkBpuYM;IAOI,4BAAA;ElBiuYV;;EkBxuYM;IAOI,+BAAA;ElBquYV;;EkB5uYM;IAOI,8BAAA;ElByuYV;;EkBhvYM;IAOI,+BAAA;ElB6uYV;;EkBpvYM;IAOI,4BAAA;ElBivYV;;EkBxvYM;IAOI,+BAAA;ElBqvYV;;EkB5vYM;IAOI,8BAAA;ElByvYV;;EkBhwYM;IAOI,+BAAA;ElB6vYV;;EkBpwYM;IAOI,4BAAA;ElBiwYV;;EkBxwYM;IAOI,iCAAA;ElBqwYV;;EkB5wYM;IAOI,gCAAA;ElBywYV;;EkBhxYM;IAOI,iCAAA;ElB6wYV;;EkBpxYM;IAOI,8BAAA;ElBixYV;;EkBxxYM;IAOI,iCAAA;ElBqxYV;;EkB5xYM;IAOI,gCAAA;ElByxYV;;EkBhyYM;IAOI,iCAAA;ElB6xYV;;EkBpyYM;IAOI,8BAAA;ElBiyYV;;EkBxyYM;IAOI,iCAAA;ElBqyYV;;EkB5yYM;IAOI,gCAAA;ElByyYV;;EkBhzYM;IAOI,iCAAA;ElB6yYV;;EkBpzYM;IAOI,8BAAA;ElBizYV;;EkBxzYM;IAOI,iCAAA;ElBqzYV;;EkB5zYM;IAOI,gCAAA;ElByzYV;;EkBh0YM;IAOI,iCAAA;ElB6zYV;;EkBp0YM;IAOI,8BAAA;ElBi0YV;;EkBx0YM;IAOI,iCAAA;ElBq0YV;;EkB50YM;IAOI,gCAAA;ElBy0YV;;EkBh1YM;IAOI,iCAAA;ElB60YV;;EkBp1YM;IAOI,8BAAA;ElBi1YV;;EkBx1YM;IAOI,kCAAA;ElBq1YV;;EkB51YM;IAOI,iCAAA;ElBy1YV;;EkBh2YM;IAOI,kCAAA;ElB61YV;;EkBp2YM;IAOI,+BAAA;ElBi2YV;;EkBx2YM;IAOI,kCAAA;ElBq2YV;;EkB52YM;IAOI,iCAAA;ElBy2YV;;EkBh3YM;IAOI,kCAAA;ElB62YV;;EkBp3YM;IAOI,+BAAA;ElBi3YV;;EkBx3YM;IAOI,kCAAA;ElBq3YV;;EkB53YM;IAOI,iCAAA;ElBy3YV;;EkBh4YM;IAOI,kCAAA;ElB63YV;;EkBp4YM;IAOI,+BAAA;ElBi4YV;;EkBx4YM;IAOI,kCAAA;ElBq4YV;;EkB54YM;IAOI,iCAAA;ElBy4YV;;EkBh5YM;IAOI,kCAAA;ElB64YV;;EkBp5YM;IAOI,+BAAA;ElBi5YV;;EkBx5YM;IAOI,kCAAA;ElBq5YV;;EkB55YM;IAOI,iCAAA;ElBy5YV;;EkBh6YM;IAOI,kCAAA;ElB65YV;;EkBp6YM;IAOI,+BAAA;ElBi6YV;;EkBx6YM;IAOI,gCAAA;ElBq6YV;;EkB56YM;IAOI,+BAAA;ElBy6YV;;EkBh7YM;IAOI,gCAAA;ElB66YV;;EkBp7YM;IAOI,6BAAA;ElBi7YV;;EkBx7YM;IAOI,gCAAA;ElBq7YV;;EkB57YM;IAOI,+BAAA;ElBy7YV;;EkBh8YM;IAOI,gCAAA;ElB67YV;;EkBp8YM;IAOI,6BAAA;ElBi8YV;;EkBx8YM;IAOI,gCAAA;ElBq8YV;;EkB58YM;IAOI,+BAAA;ElBy8YV;;EkBh9YM;IAOI,gCAAA;ElB68YV;;EkBp9YM;IAOI,6BAAA;ElBi9YV;;EkBx9YM;IAOI,gCAAA;ElBq9YV;;EkB59YM;IAOI,+BAAA;ElBy9YV;;EkBh+YM;IAOI,gCAAA;ElB69YV;;EkBp+YM;IAOI,6BAAA;ElBi+YV;;EkBx+YM;IAOI,gCAAA;ElBq+YV;;EkB5+YM;IAOI,+BAAA;ElBy+YV;;EkBh/YM;IAOI,gCAAA;ElB6+YV;;EkBp/YM;IAOI,6BAAA;ElBi/YV;;EkBx/YM;IAOI,qBAAA;ElBq/YV;;EkB5/YM;IAOI,2BAAA;ElBy/YV;;EkBhgZM;IAOI,0BAAA;ElB6/YV;;EkBpgZM;IAOI,2BAAA;ElBigZV;;EkBxgZM;IAOI,wBAAA;ElBqgZV;;EkB5gZM;IAOI,2BAAA;ElBygZV;;EkBhhZM;IAOI,0BAAA;ElB6gZV;;EkBphZM;IAOI,2BAAA;ElBihZV;;EkBxhZM;IAOI,wBAAA;ElBqhZV;;EkB5hZM;IAOI,2BAAA;ElByhZV;;EkBhiZM;IAOI,0BAAA;ElB6hZV;;EkBpiZM;IAOI,2BAAA;ElBiiZV;;EkBxiZM;IAOI,wBAAA;ElBqiZV;;EkB5iZM;IAOI,2BAAA;ElByiZV;;EkBhjZM;IAOI,0BAAA;ElB6iZV;;EkBpjZM;IAOI,2BAAA;ElBijZV;;EkBxjZM;IAOI,wBAAA;ElBqjZV;;EkB5jZM;IAOI,2BAAA;ElByjZV;;EkBhkZM;IAOI,0BAAA;ElB6jZV;;EkBpkZM;IAOI,2BAAA;ElBikZV;;EkBxkZM;IAOI,wBAAA;ElBqkZV;;EkB5kZM;IAOI,2BAAA;IAAA,0BAAA;ElB0kZV;;EkBjlZM;IAOI,iCAAA;IAAA,gCAAA;ElB+kZV;;EkBtlZM;IAOI,gCAAA;IAAA,+BAAA;ElBolZV;;EkB3lZM;IAOI,iCAAA;IAAA,gCAAA;ElBylZV;;EkBhmZM;IAOI,8BAAA;IAAA,6BAAA;ElB8lZV;;EkBrmZM;IAOI,iCAAA;IAAA,gCAAA;ElBmmZV;;EkB1mZM;IAOI,gCAAA;IAAA,+BAAA;ElBwmZV;;EkB/mZM;IAOI,iCAAA;IAAA,gCAAA;ElB6mZV;;EkBpnZM;IAOI,8BAAA;IAAA,6BAAA;ElBknZV;;EkBznZM;IAOI,iCAAA;IAAA,gCAAA;ElBunZV;;EkB9nZM;IAOI,gCAAA;IAAA,+BAAA;ElB4nZV;;EkBnoZM;IAOI,iCAAA;IAAA,gCAAA;ElBioZV;;EkBxoZM;IAOI,8BAAA;IAAA,6BAAA;ElBsoZV;;EkB7oZM;IAOI,iCAAA;IAAA,gCAAA;ElB2oZV;;EkBlpZM;IAOI,gCAAA;IAAA,+BAAA;ElBgpZV;;EkBvpZM;IAOI,iCAAA;IAAA,gCAAA;ElBqpZV;;EkB5pZM;IAOI,8BAAA;IAAA,6BAAA;ElB0pZV;;EkBjqZM;IAOI,iCAAA;IAAA,gCAAA;ElB+pZV;;EkBtqZM;IAOI,gCAAA;IAAA,+BAAA;ElBoqZV;;EkB3qZM;IAOI,iCAAA;IAAA,gCAAA;ElByqZV;;EkBhrZM;IAOI,8BAAA;IAAA,6BAAA;ElB8qZV;;EkBrrZM;IAOI,yBAAA;IAAA,4BAAA;ElBmrZV;;EkB1rZM;IAOI,+BAAA;IAAA,kCAAA;ElBwrZV;;EkB/rZM;IAOI,8BAAA;IAAA,iCAAA;ElB6rZV;;EkBpsZM;IAOI,+BAAA;IAAA,kCAAA;ElBksZV;;EkBzsZM;IAOI,4BAAA;IAAA,+BAAA;ElBusZV;;EkB9sZM;IAOI,+BAAA;IAAA,kCAAA;ElB4sZV;;EkBntZM;IAOI,8BAAA;IAAA,iCAAA;ElBitZV;;EkBxtZM;IAOI,+BAAA;IAAA,kCAAA;ElBstZV;;EkB7tZM;IAOI,4BAAA;IAAA,+BAAA;ElB2tZV;;EkBluZM;IAOI,+BAAA;IAAA,kCAAA;ElBguZV;;EkBvuZM;IAOI,8BAAA;IAAA,iCAAA;ElBquZV;;EkB5uZM;IAOI,+BAAA;IAAA,kCAAA;ElB0uZV;;EkBjvZM;IAOI,4BAAA;IAAA,+BAAA;ElB+uZV;;EkBtvZM;IAOI,+BAAA;IAAA,kCAAA;ElBovZV;;EkB3vZM;IAOI,8BAAA;IAAA,iCAAA;ElByvZV;;EkBhwZM;IAOI,+BAAA;IAAA,kCAAA;ElB8vZV;;EkBrwZM;IAOI,4BAAA;IAAA,+BAAA;ElBmwZV;;EkB1wZM;IAOI,+BAAA;IAAA,kCAAA;ElBwwZV;;EkB/wZM;IAOI,8BAAA;IAAA,iCAAA;ElB6wZV;;EkBpxZM;IAOI,+BAAA;IAAA,kCAAA;ElBkxZV;;EkBzxZM;IAOI,4BAAA;IAAA,+BAAA;ElBuxZV;;EkB9xZM;IAOI,yBAAA;ElB2xZV;;EkBlyZM;IAOI,+BAAA;ElB+xZV;;EkBtyZM;IAOI,8BAAA;ElBmyZV;;EkB1yZM;IAOI,+BAAA;ElBuyZV;;EkB9yZM;IAOI,4BAAA;ElB2yZV;;EkBlzZM;IAOI,+BAAA;ElB+yZV;;EkBtzZM;IAOI,8BAAA;ElBmzZV;;EkB1zZM;IAOI,+BAAA;ElBuzZV;;EkB9zZM;IAOI,4BAAA;ElB2zZV;;EkBl0ZM;IAOI,+BAAA;ElB+zZV;;EkBt0ZM;IAOI,8BAAA;ElBm0ZV;;EkB10ZM;IAOI,+BAAA;ElBu0ZV;;EkB90ZM;IAOI,4BAAA;ElB20ZV;;EkBl1ZM;IAOI,+BAAA;ElB+0ZV;;EkBt1ZM;IAOI,8BAAA;ElBm1ZV;;EkB11ZM;IAOI,+BAAA;ElBu1ZV;;EkB91ZM;IAOI,4BAAA;ElB21ZV;;EkBl2ZM;IAOI,+BAAA;ElB+1ZV;;EkBt2ZM;IAOI,8BAAA;ElBm2ZV;;EkB12ZM;IAOI,+BAAA;ElBu2ZV;;EkB92ZM;IAOI,4BAAA;ElB22ZV;;EkBl3ZM;IAOI,2BAAA;ElB+2ZV;;EkBt3ZM;IAOI,iCAAA;ElBm3ZV;;EkB13ZM;IAOI,gCAAA;ElBu3ZV;;EkB93ZM;IAOI,iCAAA;ElB23ZV;;EkBl4ZM;IAOI,8BAAA;ElB+3ZV;;EkBt4ZM;IAOI,iCAAA;ElBm4ZV;;EkB14ZM;IAOI,gCAAA;ElBu4ZV;;EkB94ZM;IAOI,iCAAA;ElB24ZV;;EkBl5ZM;IAOI,8BAAA;ElB+4ZV;;EkBt5ZM;IAOI,iCAAA;ElBm5ZV;;EkB15ZM;IAOI,gCAAA;ElBu5ZV;;EkB95ZM;IAOI,iCAAA;ElB25ZV;;EkBl6ZM;IAOI,8BAAA;ElB+5ZV;;EkBt6ZM;IAOI,iCAAA;ElBm6ZV;;EkB16ZM;IAOI,gCAAA;ElBu6ZV;;EkB96ZM;IAOI,iCAAA;ElB26ZV;;EkBl7ZM;IAOI,8BAAA;ElB+6ZV;;EkBt7ZM;IAOI,iCAAA;ElBm7ZV;;EkB17ZM;IAOI,gCAAA;ElBu7ZV;;EkB97ZM;IAOI,iCAAA;ElB27ZV;;EkBl8ZM;IAOI,8BAAA;ElB+7ZV;;EkBt8ZM;IAOI,4BAAA;ElBm8ZV;;EkB18ZM;IAOI,kCAAA;ElBu8ZV;;EkB98ZM;IAOI,iCAAA;ElB28ZV;;EkBl9ZM;IAOI,kCAAA;ElB+8ZV;;EkBt9ZM;IAOI,+BAAA;ElBm9ZV;;EkB19ZM;IAOI,kCAAA;ElBu9ZV;;EkB99ZM;IAOI,iCAAA;ElB29ZV;;EkBl+ZM;IAOI,kCAAA;ElB+9ZV;;EkBt+ZM;IAOI,+BAAA;ElBm+ZV;;EkB1+ZM;IAOI,kCAAA;ElBu+ZV;;EkB9+ZM;IAOI,iCAAA;ElB2+ZV;;EkBl/ZM;IAOI,kCAAA;ElB++ZV;;EkBt/ZM;IAOI,+BAAA;ElBm/ZV;;EkB1/ZM;IAOI,kCAAA;ElBu/ZV;;EkB9/ZM;IAOI,iCAAA;ElB2/ZV;;EkBlgaM;IAOI,kCAAA;ElB+/ZV;;EkBtgaM;IAOI,+BAAA;ElBmgaV;;EkB1gaM;IAOI,kCAAA;ElBugaV;;EkB9gaM;IAOI,iCAAA;ElB2gaV;;EkBlhaM;IAOI,kCAAA;ElB+gaV;;EkBthaM;IAOI,+BAAA;ElBmhaV;;EkB1haM;IAOI,0BAAA;ElBuhaV;;EkB9haM;IAOI,gCAAA;ElB2haV;;EkBliaM;IAOI,+BAAA;ElB+haV;;EkBtiaM;IAOI,gCAAA;ElBmiaV;;EkB1iaM;IAOI,6BAAA;ElBuiaV;;EkB9iaM;IAOI,gCAAA;ElB2iaV;;EkBljaM;IAOI,+BAAA;ElB+iaV;;EkBtjaM;IAOI,gCAAA;ElBmjaV;;EkB1jaM;IAOI,6BAAA;ElBujaV;;EkB9jaM;IAOI,gCAAA;ElB2jaV;;EkBlkaM;IAOI,+BAAA;ElB+jaV;;EkBtkaM;IAOI,gCAAA;ElBmkaV;;EkB1kaM;IAOI,6BAAA;ElBukaV;;EkB9kaM;IAOI,gCAAA;ElB2kaV;;EkBllaM;IAOI,+BAAA;ElB+kaV;;EkBtlaM;IAOI,gCAAA;ElBmlaV;;EkB1laM;IAOI,6BAAA;ElBulaV;;EkB9laM;IAOI,gCAAA;ElB2laV;;EkBlmaM;IAOI,+BAAA;ElB+laV;;EkBtmaM;IAOI,gCAAA;ElBmmaV;;EkB1maM;IAOI,6BAAA;ElBumaV;;EkB9maM;IAOI,iBAAA;ElB2maV;;EkBlnaM;IAOI,uBAAA;ElB+maV;;EkBtnaM;IAOI,sBAAA;ElBmnaV;;EkB1naM;IAOI,uBAAA;ElBunaV;;EkB9naM;IAOI,oBAAA;ElB2naV;;EkBloaM;IAOI,uBAAA;ElB+naV;;EkBtoaM;IAOI,sBAAA;ElBmoaV;;EkB1oaM;IAOI,uBAAA;ElBuoaV;;EkB9oaM;IAOI,oBAAA;ElB2oaV;;EkBlpaM;IAOI,uBAAA;ElB+oaV;;EkBtpaM;IAOI,sBAAA;ElBmpaV;;EkB1paM;IAOI,uBAAA;ElBupaV;;EkB9paM;IAOI,oBAAA;ElB2paV;;EkBlqaM;IAOI,uBAAA;ElB+paV;;EkBtqaM;IAOI,sBAAA;ElBmqaV;;EkB1qaM;IAOI,uBAAA;ElBuqaV;;EkB9qaM;IAOI,oBAAA;ElB2qaV;;EkBlraM;IAOI,uBAAA;ElB+qaV;;EkBtraM;IAOI,sBAAA;ElBmraV;;EkB1raM;IAOI,uBAAA;ElBuraV;;EkB9raM;IAOI,oBAAA;ElB2raV;;EkBlsaM;IAOI,qBAAA;ElB+raV;;EkBtsaM;IAOI,2BAAA;ElBmsaV;;EkB1saM;IAOI,0BAAA;ElBusaV;;EkB9saM;IAOI,2BAAA;ElB2saV;;EkBltaM;IAOI,wBAAA;ElB+saV;;EkBttaM;IAOI,2BAAA;ElBmtaV;;EkB1taM;IAOI,0BAAA;ElButaV;;EkB9taM;IAOI,2BAAA;ElB2taV;;EkBluaM;IAOI,wBAAA;ElB+taV;;EkBtuaM;IAOI,2BAAA;ElBmuaV;;EkB1uaM;IAOI,0BAAA;ElBuuaV;;EkB9uaM;IAOI,2BAAA;ElB2uaV;;EkBlvaM;IAOI,wBAAA;ElB+uaV;;EkBtvaM;IAOI,2BAAA;ElBmvaV;;EkB1vaM;IAOI,0BAAA;ElBuvaV;;EkB9vaM;IAOI,2BAAA;ElB2vaV;;EkBlwaM;IAOI,wBAAA;ElB+vaV;;EkBtwaM;IAOI,2BAAA;ElBmwaV;;EkB1waM;IAOI,0BAAA;ElBuwaV;;EkB9waM;IAOI,2BAAA;ElB2waV;;EkBlxaM;IAOI,wBAAA;ElB+waV;;EkBtxaM;IAOI,wBAAA;ElBmxaV;;EkB1xaM;IAOI,8BAAA;ElBuxaV;;EkB9xaM;IAOI,6BAAA;ElB2xaV;;EkBlyaM;IAOI,8BAAA;ElB+xaV;;EkBtyaM;IAOI,2BAAA;ElBmyaV;;EkB1yaM;IAOI,8BAAA;ElBuyaV;;EkB9yaM;IAOI,6BAAA;ElB2yaV;;EkBlzaM;IAOI,8BAAA;ElB+yaV;;EkBtzaM;IAOI,2BAAA;ElBmzaV;;EkB1zaM;IAOI,8BAAA;ElBuzaV;;EkB9zaM;IAOI,6BAAA;ElB2zaV;;EkBl0aM;IAOI,8BAAA;ElB+zaV;;EkBt0aM;IAOI,2BAAA;ElBm0aV;;EkB10aM;IAOI,8BAAA;ElBu0aV;;EkB90aM;IAOI,6BAAA;ElB20aV;;EkBl1aM;IAOI,8BAAA;ElB+0aV;;EkBt1aM;IAOI,2BAAA;ElBm1aV;;EkB11aM;IAOI,8BAAA;ElBu1aV;;EkB91aM;IAOI,6BAAA;ElB21aV;;EkBl2aM;IAOI,8BAAA;ElB+1aV;;EkBt2aM;IAOI,2BAAA;ElBm2aV;;EkB12aM;IAOI,2BAAA;ElBu2aV;;EkB92aM;IAOI,4BAAA;ElB22aV;;EkBl3aM;IAOI,6BAAA;ElB+2aV;AACF;AU13aI;EQGI;IAOI,sBAAA;ElBo3aV;;EkB33aM;IAOI,uBAAA;ElBw3aV;;EkB/3aM;IAOI,sBAAA;ElB43aV;;EkBn4aM;IAOI,8BAAA;ElBg4aV;;EkBv4aM;IAOI,4BAAA;ElBo4aV;;EkB34aM;IAOI,2BAAA;ElBw4aV;;EkB/4aM;IAOI,iCAAA;ElB44aV;;EkBn5aM;IAOI,2BAAA;ElBg5aV;;EkBv5aM;IAOI,0BAAA;ElBo5aV;;EkB35aM;IAOI,gCAAA;ElBw5aV;;EkB/5aM;IAOI,yBAAA;ElB45aV;;EkBn6aM;IAOI,wBAAA;ElBg6aV;;EkBv6aM;IAOI,+BAAA;ElBo6aV;;EkB36aM;IAOI,yBAAA;ElBw6aV;;EkB/6aM;IAOI,6BAAA;ElB46aV;;EkBn7aM;IAOI,8BAAA;ElBg7aV;;EkBv7aM;IAOI,wBAAA;ElBo7aV;;EkB37aM;IAOI,+BAAA;ElBw7aV;;EkB/7aM;IAOI,wBAAA;ElB47aV;;EkBn8aM;IAOI,yBAAA;ElBg8aV;;EkBv8aM;IAOI,8BAAA;ElBo8aV;;EkB38aM;IAOI,iCAAA;ElBw8aV;;EkB/8aM;IAOI,sCAAA;ElB48aV;;EkBn9aM;IAOI,yCAAA;ElBg9aV;;EkBv9aM;IAOI,uBAAA;ElBo9aV;;EkB39aM;IAOI,uBAAA;ElBw9aV;;EkB/9aM;IAOI,yBAAA;ElB49aV;;EkBn+aM;IAOI,yBAAA;ElBg+aV;;EkBv+aM;IAOI,0BAAA;ElBo+aV;;EkB3+aM;IAOI,4BAAA;ElBw+aV;;EkB/+aM;IAOI,kCAAA;ElB4+aV;;EkBn/aM;IAOI,sCAAA;ElBg/aV;;EkBv/aM;IAOI,oCAAA;ElBo/aV;;EkB3/aM;IAOI,kCAAA;ElBw/aV;;EkB//aM;IAOI,yCAAA;ElB4/aV;;EkBngbM;IAOI,wCAAA;ElBggbV;;EkBvgbM;IAOI,wCAAA;ElBogbV;;EkB3gbM;IAOI,kCAAA;ElBwgbV;;EkB/gbM;IAOI,gCAAA;ElB4gbV;;EkBnhbM;IAOI,8BAAA;ElBghbV;;EkBvhbM;IAOI,gCAAA;ElBohbV;;EkB3hbM;IAOI,+BAAA;ElBwhbV;;EkB/hbM;IAOI,oCAAA;ElB4hbV;;EkBnibM;IAOI,kCAAA;ElBgibV;;EkBvibM;IAOI,gCAAA;ElBoibV;;EkB3ibM;IAOI,uCAAA;ElBwibV;;EkB/ibM;IAOI,sCAAA;ElB4ibV;;EkBnjbM;IAOI,iCAAA;ElBgjbV;;EkBvjbM;IAOI,2BAAA;ElBojbV;;EkB3jbM;IAOI,iCAAA;ElBwjbV;;EkB/jbM;IAOI,+BAAA;ElB4jbV;;EkBnkbM;IAOI,6BAAA;ElBgkbV;;EkBvkbM;IAOI,+BAAA;ElBokbV;;EkB3kbM;IAOI,8BAAA;ElBwkbV;;EkB/kbM;IAOI,oBAAA;ElB4kbV;;EkBnlbM;IAOI,mBAAA;ElBglbV;;EkBvlbM;IAOI,mBAAA;ElBolbV;;EkB3lbM;IAOI,mBAAA;ElBwlbV;;EkB/lbM;IAOI,mBAAA;ElB4lbV;;EkBnmbM;IAOI,mBAAA;ElBgmbV;;EkBvmbM;IAOI,mBAAA;ElBombV;;EkB3mbM;IAOI,mBAAA;ElBwmbV;;EkB/mbM;IAOI,oBAAA;ElB4mbV;;EkBnnbM;IAOI,0BAAA;ElBgnbV;;EkBvnbM;IAOI,yBAAA;ElBonbV;;EkB3nbM;IAOI,0BAAA;ElBwnbV;;EkB/nbM;IAOI,uBAAA;ElB4nbV;;EkBnobM;IAOI,0BAAA;ElBgobV;;EkBvobM;IAOI,yBAAA;ElBoobV;;EkB3obM;IAOI,0BAAA;ElBwobV;;EkB/obM;IAOI,uBAAA;ElB4obV;;EkBnpbM;IAOI,0BAAA;ElBgpbV;;EkBvpbM;IAOI,yBAAA;ElBopbV;;EkB3pbM;IAOI,0BAAA;ElBwpbV;;EkB/pbM;IAOI,uBAAA;ElB4pbV;;EkBnqbM;IAOI,0BAAA;ElBgqbV;;EkBvqbM;IAOI,yBAAA;ElBoqbV;;EkB3qbM;IAOI,0BAAA;ElBwqbV;;EkB/qbM;IAOI,uBAAA;ElB4qbV;;EkBnrbM;IAOI,0BAAA;ElBgrbV;;EkBvrbM;IAOI,yBAAA;ElBorbV;;EkB3rbM;IAOI,0BAAA;ElBwrbV;;EkB/rbM;IAOI,uBAAA;ElB4rbV;;EkBnsbM;IAOI,uBAAA;ElBgsbV;;EkBvsbM;IAOI,0BAAA;IAAA,yBAAA;ElBqsbV;;EkB5sbM;IAOI,gCAAA;IAAA,+BAAA;ElB0sbV;;EkBjtbM;IAOI,+BAAA;IAAA,8BAAA;ElB+sbV;;EkBttbM;IAOI,gCAAA;IAAA,+BAAA;ElBotbV;;EkB3tbM;IAOI,6BAAA;IAAA,4BAAA;ElBytbV;;EkBhubM;IAOI,gCAAA;IAAA,+BAAA;ElB8tbV;;EkBrubM;IAOI,+BAAA;IAAA,8BAAA;ElBmubV;;EkB1ubM;IAOI,gCAAA;IAAA,+BAAA;ElBwubV;;EkB/ubM;IAOI,6BAAA;IAAA,4BAAA;ElB6ubV;;EkBpvbM;IAOI,gCAAA;IAAA,+BAAA;ElBkvbV;;EkBzvbM;IAOI,+BAAA;IAAA,8BAAA;ElBuvbV;;EkB9vbM;IAOI,gCAAA;IAAA,+BAAA;ElB4vbV;;EkBnwbM;IAOI,6BAAA;IAAA,4BAAA;ElBiwbV;;EkBxwbM;IAOI,gCAAA;IAAA,+BAAA;ElBswbV;;EkB7wbM;IAOI,+BAAA;IAAA,8BAAA;ElB2wbV;;EkBlxbM;IAOI,gCAAA;IAAA,+BAAA;ElBgxbV;;EkBvxbM;IAOI,6BAAA;IAAA,4BAAA;ElBqxbV;;EkB5xbM;IAOI,gCAAA;IAAA,+BAAA;ElB0xbV;;EkBjybM;IAOI,+BAAA;IAAA,8BAAA;ElB+xbV;;EkBtybM;IAOI,gCAAA;IAAA,+BAAA;ElBoybV;;EkB3ybM;IAOI,6BAAA;IAAA,4BAAA;ElByybV;;EkBhzbM;IAOI,6BAAA;IAAA,4BAAA;ElB8ybV;;EkBrzbM;IAOI,wBAAA;IAAA,2BAAA;ElBmzbV;;EkB1zbM;IAOI,8BAAA;IAAA,iCAAA;ElBwzbV;;EkB/zbM;IAOI,6BAAA;IAAA,gCAAA;ElB6zbV;;EkBp0bM;IAOI,8BAAA;IAAA,iCAAA;ElBk0bV;;EkBz0bM;IAOI,2BAAA;IAAA,8BAAA;ElBu0bV;;EkB90bM;IAOI,8BAAA;IAAA,iCAAA;ElB40bV;;EkBn1bM;IAOI,6BAAA;IAAA,gCAAA;ElBi1bV;;EkBx1bM;IAOI,8BAAA;IAAA,iCAAA;ElBs1bV;;EkB71bM;IAOI,2BAAA;IAAA,8BAAA;ElB21bV;;EkBl2bM;IAOI,8BAAA;IAAA,iCAAA;ElBg2bV;;EkBv2bM;IAOI,6BAAA;IAAA,gCAAA;ElBq2bV;;EkB52bM;IAOI,8BAAA;IAAA,iCAAA;ElB02bV;;EkBj3bM;IAOI,2BAAA;IAAA,8BAAA;ElB+2bV;;EkBt3bM;IAOI,8BAAA;IAAA,iCAAA;ElBo3bV;;EkB33bM;IAOI,6BAAA;IAAA,gCAAA;ElBy3bV;;EkBh4bM;IAOI,8BAAA;IAAA,iCAAA;ElB83bV;;EkBr4bM;IAOI,2BAAA;IAAA,8BAAA;ElBm4bV;;EkB14bM;IAOI,8BAAA;IAAA,iCAAA;ElBw4bV;;EkB/4bM;IAOI,6BAAA;IAAA,gCAAA;ElB64bV;;EkBp5bM;IAOI,8BAAA;IAAA,iCAAA;ElBk5bV;;EkBz5bM;IAOI,2BAAA;IAAA,8BAAA;ElBu5bV;;EkB95bM;IAOI,2BAAA;IAAA,8BAAA;ElB45bV;;EkBn6bM;IAOI,wBAAA;ElBg6bV;;EkBv6bM;IAOI,8BAAA;ElBo6bV;;EkB36bM;IAOI,6BAAA;ElBw6bV;;EkB/6bM;IAOI,8BAAA;ElB46bV;;EkBn7bM;IAOI,2BAAA;ElBg7bV;;EkBv7bM;IAOI,8BAAA;ElBo7bV;;EkB37bM;IAOI,6BAAA;ElBw7bV;;EkB/7bM;IAOI,8BAAA;ElB47bV;;EkBn8bM;IAOI,2BAAA;ElBg8bV;;EkBv8bM;IAOI,8BAAA;ElBo8bV;;EkB38bM;IAOI,6BAAA;ElBw8bV;;EkB/8bM;IAOI,8BAAA;ElB48bV;;EkBn9bM;IAOI,2BAAA;ElBg9bV;;EkBv9bM;IAOI,8BAAA;ElBo9bV;;EkB39bM;IAOI,6BAAA;ElBw9bV;;EkB/9bM;IAOI,8BAAA;ElB49bV;;EkBn+bM;IAOI,2BAAA;ElBg+bV;;EkBv+bM;IAOI,8BAAA;ElBo+bV;;EkB3+bM;IAOI,6BAAA;ElBw+bV;;EkB/+bM;IAOI,8BAAA;ElB4+bV;;EkBn/bM;IAOI,2BAAA;ElBg/bV;;EkBv/bM;IAOI,2BAAA;ElBo/bV;;EkB3/bM;IAOI,0BAAA;ElBw/bV;;EkB//bM;IAOI,gCAAA;ElB4/bV;;EkBngcM;IAOI,+BAAA;ElBggcV;;EkBvgcM;IAOI,gCAAA;ElBogcV;;EkB3gcM;IAOI,6BAAA;ElBwgcV;;EkB/gcM;IAOI,gCAAA;ElB4gcV;;EkBnhcM;IAOI,+BAAA;ElBghcV;;EkBvhcM;IAOI,gCAAA;ElBohcV;;EkB3hcM;IAOI,6BAAA;ElBwhcV;;EkB/hcM;IAOI,gCAAA;ElB4hcV;;EkBnicM;IAOI,+BAAA;ElBgicV;;EkBvicM;IAOI,gCAAA;ElBoicV;;EkB3icM;IAOI,6BAAA;ElBwicV;;EkB/icM;IAOI,gCAAA;ElB4icV;;EkBnjcM;IAOI,+BAAA;ElBgjcV;;EkBvjcM;IAOI,gCAAA;ElBojcV;;EkB3jcM;IAOI,6BAAA;ElBwjcV;;EkB/jcM;IAOI,gCAAA;ElB4jcV;;EkBnkcM;IAOI,+BAAA;ElBgkcV;;EkBvkcM;IAOI,gCAAA;ElBokcV;;EkB3kcM;IAOI,6BAAA;ElBwkcV;;EkB/kcM;IAOI,6BAAA;ElB4kcV;;EkBnlcM;IAOI,2BAAA;ElBglcV;;EkBvlcM;IAOI,iCAAA;ElBolcV;;EkB3lcM;IAOI,gCAAA;ElBwlcV;;EkB/lcM;IAOI,iCAAA;ElB4lcV;;EkBnmcM;IAOI,8BAAA;ElBgmcV;;EkBvmcM;IAOI,iCAAA;ElBomcV;;EkB3mcM;IAOI,gCAAA;ElBwmcV;;EkB/mcM;IAOI,iCAAA;ElB4mcV;;EkBnncM;IAOI,8BAAA;ElBgncV;;EkBvncM;IAOI,iCAAA;ElBoncV;;EkB3ncM;IAOI,gCAAA;ElBwncV;;EkB/ncM;IAOI,iCAAA;ElB4ncV;;EkBnocM;IAOI,8BAAA;ElBgocV;;EkBvocM;IAOI,iCAAA;ElBoocV;;EkB3ocM;IAOI,gCAAA;ElBwocV;;EkB/ocM;IAOI,iCAAA;ElB4ocV;;EkBnpcM;IAOI,8BAAA;ElBgpcV;;EkBvpcM;IAOI,iCAAA;ElBopcV;;EkB3pcM;IAOI,gCAAA;ElBwpcV;;EkB/pcM;IAOI,iCAAA;ElB4pcV;;EkBnqcM;IAOI,8BAAA;ElBgqcV;;EkBvqcM;IAOI,8BAAA;ElBoqcV;;EkB3qcM;IAOI,yBAAA;ElBwqcV;;EkB/qcM;IAOI,+BAAA;ElB4qcV;;EkBnrcM;IAOI,8BAAA;ElBgrcV;;EkBvrcM;IAOI,+BAAA;ElBorcV;;EkB3rcM;IAOI,4BAAA;ElBwrcV;;EkB/rcM;IAOI,+BAAA;ElB4rcV;;EkBnscM;IAOI,8BAAA;ElBgscV;;EkBvscM;IAOI,+BAAA;ElBoscV;;EkB3scM;IAOI,4BAAA;ElBwscV;;EkB/scM;IAOI,+BAAA;ElB4scV;;EkBntcM;IAOI,8BAAA;ElBgtcV;;EkBvtcM;IAOI,+BAAA;ElBotcV;;EkB3tcM;IAOI,4BAAA;ElBwtcV;;EkB/tcM;IAOI,+BAAA;ElB4tcV;;EkBnucM;IAOI,8BAAA;ElBgucV;;EkBvucM;IAOI,+BAAA;ElBoucV;;EkB3ucM;IAOI,4BAAA;ElBwucV;;EkB/ucM;IAOI,+BAAA;ElB4ucV;;EkBnvcM;IAOI,8BAAA;ElBgvcV;;EkBvvcM;IAOI,+BAAA;ElBovcV;;EkB3vcM;IAOI,4BAAA;ElBwvcV;;EkB/vcM;IAOI,4BAAA;ElB4vcV;;EkBnwcM;IAOI,2BAAA;ElBgwcV;;EkBvwcM;IAOI,0BAAA;ElBowcV;;EkB3wcM;IAOI,2BAAA;ElBwwcV;;EkB/wcM;IAOI,wBAAA;ElB4wcV;;EkBnxcM;IAOI,2BAAA;ElBgxcV;;EkBvxcM;IAOI,0BAAA;ElBoxcV;;EkB3xcM;IAOI,2BAAA;ElBwxcV;;EkB/xcM;IAOI,wBAAA;ElB4xcV;;EkBnycM;IAOI,2BAAA;ElBgycV;;EkBvycM;IAOI,0BAAA;ElBoycV;;EkB3ycM;IAOI,2BAAA;ElBwycV;;EkB/ycM;IAOI,wBAAA;ElB4ycV;;EkBnzcM;IAOI,2BAAA;ElBgzcV;;EkBvzcM;IAOI,0BAAA;ElBozcV;;EkB3zcM;IAOI,2BAAA;ElBwzcV;;EkB/zcM;IAOI,wBAAA;ElB4zcV;;EkBn0cM;IAOI,2BAAA;ElBg0cV;;EkBv0cM;IAOI,0BAAA;ElBo0cV;;EkB30cM;IAOI,2BAAA;ElBw0cV;;EkB/0cM;IAOI,wBAAA;ElB40cV;;EkBn1cM;IAOI,iCAAA;IAAA,gCAAA;ElBi1cV;;EkBx1cM;IAOI,gCAAA;IAAA,+BAAA;ElBs1cV;;EkB71cM;IAOI,iCAAA;IAAA,gCAAA;ElB21cV;;EkBl2cM;IAOI,8BAAA;IAAA,6BAAA;ElBg2cV;;EkBv2cM;IAOI,iCAAA;IAAA,gCAAA;ElBq2cV;;EkB52cM;IAOI,gCAAA;IAAA,+BAAA;ElB02cV;;EkBj3cM;IAOI,iCAAA;IAAA,gCAAA;ElB+2cV;;EkBt3cM;IAOI,8BAAA;IAAA,6BAAA;ElBo3cV;;EkB33cM;IAOI,iCAAA;IAAA,gCAAA;ElBy3cV;;EkBh4cM;IAOI,gCAAA;IAAA,+BAAA;ElB83cV;;EkBr4cM;IAOI,iCAAA;IAAA,gCAAA;ElBm4cV;;EkB14cM;IAOI,8BAAA;IAAA,6BAAA;ElBw4cV;;EkB/4cM;IAOI,iCAAA;IAAA,gCAAA;ElB64cV;;EkBp5cM;IAOI,gCAAA;IAAA,+BAAA;ElBk5cV;;EkBz5cM;IAOI,iCAAA;IAAA,gCAAA;ElBu5cV;;EkB95cM;IAOI,8BAAA;IAAA,6BAAA;ElB45cV;;EkBn6cM;IAOI,iCAAA;IAAA,gCAAA;ElBi6cV;;EkBx6cM;IAOI,gCAAA;IAAA,+BAAA;ElBs6cV;;EkB76cM;IAOI,iCAAA;IAAA,gCAAA;ElB26cV;;EkBl7cM;IAOI,8BAAA;IAAA,6BAAA;ElBg7cV;;EkBv7cM;IAOI,+BAAA;IAAA,kCAAA;ElBq7cV;;EkB57cM;IAOI,8BAAA;IAAA,iCAAA;ElB07cV;;EkBj8cM;IAOI,+BAAA;IAAA,kCAAA;ElB+7cV;;EkBt8cM;IAOI,4BAAA;IAAA,+BAAA;ElBo8cV;;EkB38cM;IAOI,+BAAA;IAAA,kCAAA;ElBy8cV;;EkBh9cM;IAOI,8BAAA;IAAA,iCAAA;ElB88cV;;EkBr9cM;IAOI,+BAAA;IAAA,kCAAA;ElBm9cV;;EkB19cM;IAOI,4BAAA;IAAA,+BAAA;ElBw9cV;;EkB/9cM;IAOI,+BAAA;IAAA,kCAAA;ElB69cV;;EkBp+cM;IAOI,8BAAA;IAAA,iCAAA;ElBk+cV;;EkBz+cM;IAOI,+BAAA;IAAA,kCAAA;ElBu+cV;;EkB9+cM;IAOI,4BAAA;IAAA,+BAAA;ElB4+cV;;EkBn/cM;IAOI,+BAAA;IAAA,kCAAA;ElBi/cV;;EkBx/cM;IAOI,8BAAA;IAAA,iCAAA;ElBs/cV;;EkB7/cM;IAOI,+BAAA;IAAA,kCAAA;ElB2/cV;;EkBlgdM;IAOI,4BAAA;IAAA,+BAAA;ElBggdV;;EkBvgdM;IAOI,+BAAA;IAAA,kCAAA;ElBqgdV;;EkB5gdM;IAOI,8BAAA;IAAA,iCAAA;ElB0gdV;;EkBjhdM;IAOI,+BAAA;IAAA,kCAAA;ElB+gdV;;EkBthdM;IAOI,4BAAA;IAAA,+BAAA;ElBohdV;;EkB3hdM;IAOI,+BAAA;ElBwhdV;;EkB/hdM;IAOI,8BAAA;ElB4hdV;;EkBnidM;IAOI,+BAAA;ElBgidV;;EkBvidM;IAOI,4BAAA;ElBoidV;;EkB3idM;IAOI,+BAAA;ElBwidV;;EkB/idM;IAOI,8BAAA;ElB4idV;;EkBnjdM;IAOI,+BAAA;ElBgjdV;;EkBvjdM;IAOI,4BAAA;ElBojdV;;EkB3jdM;IAOI,+BAAA;ElBwjdV;;EkB/jdM;IAOI,8BAAA;ElB4jdV;;EkBnkdM;IAOI,+BAAA;ElBgkdV;;EkBvkdM;IAOI,4BAAA;ElBokdV;;EkB3kdM;IAOI,+BAAA;ElBwkdV;;EkB/kdM;IAOI,8BAAA;ElB4kdV;;EkBnldM;IAOI,+BAAA;ElBgldV;;EkBvldM;IAOI,4BAAA;ElBoldV;;EkB3ldM;IAOI,+BAAA;ElBwldV;;EkB/ldM;IAOI,8BAAA;ElB4ldV;;EkBnmdM;IAOI,+BAAA;ElBgmdV;;EkBvmdM;IAOI,4BAAA;ElBomdV;;EkB3mdM;IAOI,iCAAA;ElBwmdV;;EkB/mdM;IAOI,gCAAA;ElB4mdV;;EkBnndM;IAOI,iCAAA;ElBgndV;;EkBvndM;IAOI,8BAAA;ElBondV;;EkB3ndM;IAOI,iCAAA;ElBwndV;;EkB/ndM;IAOI,gCAAA;ElB4ndV;;EkBnodM;IAOI,iCAAA;ElBgodV;;EkBvodM;IAOI,8BAAA;ElBoodV;;EkB3odM;IAOI,iCAAA;ElBwodV;;EkB/odM;IAOI,gCAAA;ElB4odV;;EkBnpdM;IAOI,iCAAA;ElBgpdV;;EkBvpdM;IAOI,8BAAA;ElBopdV;;EkB3pdM;IAOI,iCAAA;ElBwpdV;;EkB/pdM;IAOI,gCAAA;ElB4pdV;;EkBnqdM;IAOI,iCAAA;ElBgqdV;;EkBvqdM;IAOI,8BAAA;ElBoqdV;;EkB3qdM;IAOI,iCAAA;ElBwqdV;;EkB/qdM;IAOI,gCAAA;ElB4qdV;;EkBnrdM;IAOI,iCAAA;ElBgrdV;;EkBvrdM;IAOI,8BAAA;ElBordV;;EkB3rdM;IAOI,kCAAA;ElBwrdV;;EkB/rdM;IAOI,iCAAA;ElB4rdV;;EkBnsdM;IAOI,kCAAA;ElBgsdV;;EkBvsdM;IAOI,+BAAA;ElBosdV;;EkB3sdM;IAOI,kCAAA;ElBwsdV;;EkB/sdM;IAOI,iCAAA;ElB4sdV;;EkBntdM;IAOI,kCAAA;ElBgtdV;;EkBvtdM;IAOI,+BAAA;ElBotdV;;EkB3tdM;IAOI,kCAAA;ElBwtdV;;EkB/tdM;IAOI,iCAAA;ElB4tdV;;EkBnudM;IAOI,kCAAA;ElBgudV;;EkBvudM;IAOI,+BAAA;ElBoudV;;EkB3udM;IAOI,kCAAA;ElBwudV;;EkB/udM;IAOI,iCAAA;ElB4udV;;EkBnvdM;IAOI,kCAAA;ElBgvdV;;EkBvvdM;IAOI,+BAAA;ElBovdV;;EkB3vdM;IAOI,kCAAA;ElBwvdV;;EkB/vdM;IAOI,iCAAA;ElB4vdV;;EkBnwdM;IAOI,kCAAA;ElBgwdV;;EkBvwdM;IAOI,+BAAA;ElBowdV;;EkB3wdM;IAOI,gCAAA;ElBwwdV;;EkB/wdM;IAOI,+BAAA;ElB4wdV;;EkBnxdM;IAOI,gCAAA;ElBgxdV;;EkBvxdM;IAOI,6BAAA;ElBoxdV;;EkB3xdM;IAOI,gCAAA;ElBwxdV;;EkB/xdM;IAOI,+BAAA;ElB4xdV;;EkBnydM;IAOI,gCAAA;ElBgydV;;EkBvydM;IAOI,6BAAA;ElBoydV;;EkB3ydM;IAOI,gCAAA;ElBwydV;;EkB/ydM;IAOI,+BAAA;ElB4ydV;;EkBnzdM;IAOI,gCAAA;ElBgzdV;;EkBvzdM;IAOI,6BAAA;ElBozdV;;EkB3zdM;IAOI,gCAAA;ElBwzdV;;EkB/zdM;IAOI,+BAAA;ElB4zdV;;EkBn0dM;IAOI,gCAAA;ElBg0dV;;EkBv0dM;IAOI,6BAAA;ElBo0dV;;EkB30dM;IAOI,gCAAA;ElBw0dV;;EkB/0dM;IAOI,+BAAA;ElB40dV;;EkBn1dM;IAOI,gCAAA;ElBg1dV;;EkBv1dM;IAOI,6BAAA;ElBo1dV;;EkB31dM;IAOI,qBAAA;ElBw1dV;;EkB/1dM;IAOI,2BAAA;ElB41dV;;EkBn2dM;IAOI,0BAAA;ElBg2dV;;EkBv2dM;IAOI,2BAAA;ElBo2dV;;EkB32dM;IAOI,wBAAA;ElBw2dV;;EkB/2dM;IAOI,2BAAA;ElB42dV;;EkBn3dM;IAOI,0BAAA;ElBg3dV;;EkBv3dM;IAOI,2BAAA;ElBo3dV;;EkB33dM;IAOI,wBAAA;ElBw3dV;;EkB/3dM;IAOI,2BAAA;ElB43dV;;EkBn4dM;IAOI,0BAAA;ElBg4dV;;EkBv4dM;IAOI,2BAAA;ElBo4dV;;EkB34dM;IAOI,wBAAA;ElBw4dV;;EkB/4dM;IAOI,2BAAA;ElB44dV;;EkBn5dM;IAOI,0BAAA;ElBg5dV;;EkBv5dM;IAOI,2BAAA;ElBo5dV;;EkB35dM;IAOI,wBAAA;ElBw5dV;;EkB/5dM;IAOI,2BAAA;ElB45dV;;EkBn6dM;IAOI,0BAAA;ElBg6dV;;EkBv6dM;IAOI,2BAAA;ElBo6dV;;EkB36dM;IAOI,wBAAA;ElBw6dV;;EkB/6dM;IAOI,2BAAA;IAAA,0BAAA;ElB66dV;;EkBp7dM;IAOI,iCAAA;IAAA,gCAAA;ElBk7dV;;EkBz7dM;IAOI,gCAAA;IAAA,+BAAA;ElBu7dV;;EkB97dM;IAOI,iCAAA;IAAA,gCAAA;ElB47dV;;EkBn8dM;IAOI,8BAAA;IAAA,6BAAA;ElBi8dV;;EkBx8dM;IAOI,iCAAA;IAAA,gCAAA;ElBs8dV;;EkB78dM;IAOI,gCAAA;IAAA,+BAAA;ElB28dV;;EkBl9dM;IAOI,iCAAA;IAAA,gCAAA;ElBg9dV;;EkBv9dM;IAOI,8BAAA;IAAA,6BAAA;ElBq9dV;;EkB59dM;IAOI,iCAAA;IAAA,gCAAA;ElB09dV;;EkBj+dM;IAOI,gCAAA;IAAA,+BAAA;ElB+9dV;;EkBt+dM;IAOI,iCAAA;IAAA,gCAAA;ElBo+dV;;EkB3+dM;IAOI,8BAAA;IAAA,6BAAA;ElBy+dV;;EkBh/dM;IAOI,iCAAA;IAAA,gCAAA;ElB8+dV;;EkBr/dM;IAOI,gCAAA;IAAA,+BAAA;ElBm/dV;;EkB1/dM;IAOI,iCAAA;IAAA,gCAAA;ElBw/dV;;EkB//dM;IAOI,8BAAA;IAAA,6BAAA;ElB6/dV;;EkBpgeM;IAOI,iCAAA;IAAA,gCAAA;ElBkgeV;;EkBzgeM;IAOI,gCAAA;IAAA,+BAAA;ElBugeV;;EkB9geM;IAOI,iCAAA;IAAA,gCAAA;ElB4geV;;EkBnheM;IAOI,8BAAA;IAAA,6BAAA;ElBiheV;;EkBxheM;IAOI,yBAAA;IAAA,4BAAA;ElBsheV;;EkB7heM;IAOI,+BAAA;IAAA,kCAAA;ElB2heV;;EkBlieM;IAOI,8BAAA;IAAA,iCAAA;ElBgieV;;EkBvieM;IAOI,+BAAA;IAAA,kCAAA;ElBqieV;;EkB5ieM;IAOI,4BAAA;IAAA,+BAAA;ElB0ieV;;EkBjjeM;IAOI,+BAAA;IAAA,kCAAA;ElB+ieV;;EkBtjeM;IAOI,8BAAA;IAAA,iCAAA;ElBojeV;;EkB3jeM;IAOI,+BAAA;IAAA,kCAAA;ElByjeV;;EkBhkeM;IAOI,4BAAA;IAAA,+BAAA;ElB8jeV;;EkBrkeM;IAOI,+BAAA;IAAA,kCAAA;ElBmkeV;;EkB1keM;IAOI,8BAAA;IAAA,iCAAA;ElBwkeV;;EkB/keM;IAOI,+BAAA;IAAA,kCAAA;ElB6keV;;EkBpleM;IAOI,4BAAA;IAAA,+BAAA;ElBkleV;;EkBzleM;IAOI,+BAAA;IAAA,kCAAA;ElBuleV;;EkB9leM;IAOI,8BAAA;IAAA,iCAAA;ElB4leV;;EkBnmeM;IAOI,+BAAA;IAAA,kCAAA;ElBimeV;;EkBxmeM;IAOI,4BAAA;IAAA,+BAAA;ElBsmeV;;EkB7meM;IAOI,+BAAA;IAAA,kCAAA;ElB2meV;;EkBlneM;IAOI,8BAAA;IAAA,iCAAA;ElBgneV;;EkBvneM;IAOI,+BAAA;IAAA,kCAAA;ElBqneV;;EkB5neM;IAOI,4BAAA;IAAA,+BAAA;ElB0neV;;EkBjoeM;IAOI,yBAAA;ElB8neV;;EkBroeM;IAOI,+BAAA;ElBkoeV;;EkBzoeM;IAOI,8BAAA;ElBsoeV;;EkB7oeM;IAOI,+BAAA;ElB0oeV;;EkBjpeM;IAOI,4BAAA;ElB8oeV;;EkBrpeM;IAOI,+BAAA;ElBkpeV;;EkBzpeM;IAOI,8BAAA;ElBspeV;;EkB7peM;IAOI,+BAAA;ElB0peV;;EkBjqeM;IAOI,4BAAA;ElB8peV;;EkBrqeM;IAOI,+BAAA;ElBkqeV;;EkBzqeM;IAOI,8BAAA;ElBsqeV;;EkB7qeM;IAOI,+BAAA;ElB0qeV;;EkBjreM;IAOI,4BAAA;ElB8qeV;;EkBrreM;IAOI,+BAAA;ElBkreV;;EkBzreM;IAOI,8BAAA;ElBsreV;;EkB7reM;IAOI,+BAAA;ElB0reV;;EkBjseM;IAOI,4BAAA;ElB8reV;;EkBrseM;IAOI,+BAAA;ElBkseV;;EkBzseM;IAOI,8BAAA;ElBsseV;;EkB7seM;IAOI,+BAAA;ElB0seV;;EkBjteM;IAOI,4BAAA;ElB8seV;;EkBrteM;IAOI,2BAAA;ElBkteV;;EkBzteM;IAOI,iCAAA;ElBsteV;;EkB7teM;IAOI,gCAAA;ElB0teV;;EkBjueM;IAOI,iCAAA;ElB8teV;;EkBrueM;IAOI,8BAAA;ElBkueV;;EkBzueM;IAOI,iCAAA;ElBsueV;;EkB7ueM;IAOI,gCAAA;ElB0ueV;;EkBjveM;IAOI,iCAAA;ElB8ueV;;EkBrveM;IAOI,8BAAA;ElBkveV;;EkBzveM;IAOI,iCAAA;ElBsveV;;EkB7veM;IAOI,gCAAA;ElB0veV;;EkBjweM;IAOI,iCAAA;ElB8veV;;EkBrweM;IAOI,8BAAA;ElBkweV;;EkBzweM;IAOI,iCAAA;ElBsweV;;EkB7weM;IAOI,gCAAA;ElB0weV;;EkBjxeM;IAOI,iCAAA;ElB8weV;;EkBrxeM;IAOI,8BAAA;ElBkxeV;;EkBzxeM;IAOI,iCAAA;ElBsxeV;;EkB7xeM;IAOI,gCAAA;ElB0xeV;;EkBjyeM;IAOI,iCAAA;ElB8xeV;;EkBryeM;IAOI,8BAAA;ElBkyeV;;EkBzyeM;IAOI,4BAAA;ElBsyeV;;EkB7yeM;IAOI,kCAAA;ElB0yeV;;EkBjzeM;IAOI,iCAAA;ElB8yeV;;EkBrzeM;IAOI,kCAAA;ElBkzeV;;EkBzzeM;IAOI,+BAAA;ElBszeV;;EkB7zeM;IAOI,kCAAA;ElB0zeV;;EkBj0eM;IAOI,iCAAA;ElB8zeV;;EkBr0eM;IAOI,kCAAA;ElBk0eV;;EkBz0eM;IAOI,+BAAA;ElBs0eV;;EkB70eM;IAOI,kCAAA;ElB00eV;;EkBj1eM;IAOI,iCAAA;ElB80eV;;EkBr1eM;IAOI,kCAAA;ElBk1eV;;EkBz1eM;IAOI,+BAAA;ElBs1eV;;EkB71eM;IAOI,kCAAA;ElB01eV;;EkBj2eM;IAOI,iCAAA;ElB81eV;;EkBr2eM;IAOI,kCAAA;ElBk2eV;;EkBz2eM;IAOI,+BAAA;ElBs2eV;;EkB72eM;IAOI,kCAAA;ElB02eV;;EkBj3eM;IAOI,iCAAA;ElB82eV;;EkBr3eM;IAOI,kCAAA;ElBk3eV;;EkBz3eM;IAOI,+BAAA;ElBs3eV;;EkB73eM;IAOI,0BAAA;ElB03eV;;EkBj4eM;IAOI,gCAAA;ElB83eV;;EkBr4eM;IAOI,+BAAA;ElBk4eV;;EkBz4eM;IAOI,gCAAA;ElBs4eV;;EkB74eM;IAOI,6BAAA;ElB04eV;;EkBj5eM;IAOI,gCAAA;ElB84eV;;EkBr5eM;IAOI,+BAAA;ElBk5eV;;EkBz5eM;IAOI,gCAAA;ElBs5eV;;EkB75eM;IAOI,6BAAA;ElB05eV;;EkBj6eM;IAOI,gCAAA;ElB85eV;;EkBr6eM;IAOI,+BAAA;ElBk6eV;;EkBz6eM;IAOI,gCAAA;ElBs6eV;;EkB76eM;IAOI,6BAAA;ElB06eV;;EkBj7eM;IAOI,gCAAA;ElB86eV;;EkBr7eM;IAOI,+BAAA;ElBk7eV;;EkBz7eM;IAOI,gCAAA;ElBs7eV;;EkB77eM;IAOI,6BAAA;ElB07eV;;EkBj8eM;IAOI,gCAAA;ElB87eV;;EkBr8eM;IAOI,+BAAA;ElBk8eV;;EkBz8eM;IAOI,gCAAA;ElBs8eV;;EkB78eM;IAOI,6BAAA;ElB08eV;;EkBj9eM;IAOI,iBAAA;ElB88eV;;EkBr9eM;IAOI,uBAAA;ElBk9eV;;EkBz9eM;IAOI,sBAAA;ElBs9eV;;EkB79eM;IAOI,uBAAA;ElB09eV;;EkBj+eM;IAOI,oBAAA;ElB89eV;;EkBr+eM;IAOI,uBAAA;ElBk+eV;;EkBz+eM;IAOI,sBAAA;ElBs+eV;;EkB7+eM;IAOI,uBAAA;ElB0+eV;;EkBj/eM;IAOI,oBAAA;ElB8+eV;;EkBr/eM;IAOI,uBAAA;ElBk/eV;;EkBz/eM;IAOI,sBAAA;ElBs/eV;;EkB7/eM;IAOI,uBAAA;ElB0/eV;;EkBjgfM;IAOI,oBAAA;ElB8/eV;;EkBrgfM;IAOI,uBAAA;ElBkgfV;;EkBzgfM;IAOI,sBAAA;ElBsgfV;;EkB7gfM;IAOI,uBAAA;ElB0gfV;;EkBjhfM;IAOI,oBAAA;ElB8gfV;;EkBrhfM;IAOI,uBAAA;ElBkhfV;;EkBzhfM;IAOI,sBAAA;ElBshfV;;EkB7hfM;IAOI,uBAAA;ElB0hfV;;EkBjifM;IAOI,oBAAA;ElB8hfV;;EkBrifM;IAOI,qBAAA;ElBkifV;;EkBzifM;IAOI,2BAAA;ElBsifV;;EkB7ifM;IAOI,0BAAA;ElB0ifV;;EkBjjfM;IAOI,2BAAA;ElB8ifV;;EkBrjfM;IAOI,wBAAA;ElBkjfV;;EkBzjfM;IAOI,2BAAA;ElBsjfV;;EkB7jfM;IAOI,0BAAA;ElB0jfV;;EkBjkfM;IAOI,2BAAA;ElB8jfV;;EkBrkfM;IAOI,wBAAA;ElBkkfV;;EkBzkfM;IAOI,2BAAA;ElBskfV;;EkB7kfM;IAOI,0BAAA;ElB0kfV;;EkBjlfM;IAOI,2BAAA;ElB8kfV;;EkBrlfM;IAOI,wBAAA;ElBklfV;;EkBzlfM;IAOI,2BAAA;ElBslfV;;EkB7lfM;IAOI,0BAAA;ElB0lfV;;EkBjmfM;IAOI,2BAAA;ElB8lfV;;EkBrmfM;IAOI,wBAAA;ElBkmfV;;EkBzmfM;IAOI,2BAAA;ElBsmfV;;EkB7mfM;IAOI,0BAAA;ElB0mfV;;EkBjnfM;IAOI,2BAAA;ElB8mfV;;EkBrnfM;IAOI,wBAAA;ElBknfV;;EkBznfM;IAOI,wBAAA;ElBsnfV;;EkB7nfM;IAOI,8BAAA;ElB0nfV;;EkBjofM;IAOI,6BAAA;ElB8nfV;;EkBrofM;IAOI,8BAAA;ElBkofV;;EkBzofM;IAOI,2BAAA;ElBsofV;;EkB7ofM;IAOI,8BAAA;ElB0ofV;;EkBjpfM;IAOI,6BAAA;ElB8ofV;;EkBrpfM;IAOI,8BAAA;ElBkpfV;;EkBzpfM;IAOI,2BAAA;ElBspfV;;EkB7pfM;IAOI,8BAAA;ElB0pfV;;EkBjqfM;IAOI,6BAAA;ElB8pfV;;EkBrqfM;IAOI,8BAAA;ElBkqfV;;EkBzqfM;IAOI,2BAAA;ElBsqfV;;EkB7qfM;IAOI,8BAAA;ElB0qfV;;EkBjrfM;IAOI,6BAAA;ElB8qfV;;EkBrrfM;IAOI,8BAAA;ElBkrfV;;EkBzrfM;IAOI,2BAAA;ElBsrfV;;EkB7rfM;IAOI,8BAAA;ElB0rfV;;EkBjsfM;IAOI,6BAAA;ElB8rfV;;EkBrsfM;IAOI,8BAAA;ElBksfV;;EkBzsfM;IAOI,2BAAA;ElBssfV;;EkB7sfM;IAOI,2BAAA;ElB0sfV;;EkBjtfM;IAOI,4BAAA;ElB8sfV;;EkBrtfM;IAOI,6BAAA;ElBktfV;AACF;AmBzwfA;ED+CQ;IAOI,6BAAA;ElButfV;;EkB9tfM;IAOI,4BAAA;ElB2tfV;;EkBlufM;IAOI,6BAAA;ElB+tfV;;EkBtufM;IAOI,0BAAA;ElBmufV;;EkB1ufM;IAOI,6BAAA;ElBuufV;;EkB9ufM;IAOI,4BAAA;ElB2ufV;;EkBlvfM;IAOI,6BAAA;ElB+ufV;;EkBtvfM;IAOI,0BAAA;ElBmvfV;;EkB1vfM;IAOI,6BAAA;ElBuvfV;;EkB9vfM;IAOI,4BAAA;ElB2vfV;;EkBlwfM;IAOI,6BAAA;ElB+vfV;;EkBtwfM;IAOI,0BAAA;ElBmwfV;;EkB1wfM;IAOI,6BAAA;ElBuwfV;;EkB9wfM;IAOI,4BAAA;ElB2wfV;;EkBlxfM;IAOI,6BAAA;ElB+wfV;;EkBtxfM;IAOI,0BAAA;ElBmxfV;;EkB1xfM;IAOI,6BAAA;ElBuxfV;;EkB9xfM;IAOI,4BAAA;ElB2xfV;;EkBlyfM;IAOI,6BAAA;ElB+xfV;AACF;AmBn0fA;ED4BQ;IAOI,0BAAA;ElBoyfV;;EkB3yfM;IAOI,gCAAA;ElBwyfV;;EkB/yfM;IAOI,yBAAA;ElB4yfV;;EkBnzfM;IAOI,wBAAA;ElBgzfV;;EkBvzfM;IAOI,+BAAA;ElBozfV;;EkB3zfM;IAOI,yBAAA;ElBwzfV;;EkB/zfM;IAOI,6BAAA;ElB4zfV;;EkBn0fM;IAOI,8BAAA;ElBg0fV;;EkBv0fM;IAOI,wBAAA;ElBo0fV;;EkB30fM;IAOI,+BAAA;ElBw0fV;;EkB/0fM;IAOI,wBAAA;ElB40fV;AACF;AoB72fA;EACI,aAAA;ApB+2fJ;;AqBz5fA;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,mBAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,kBAAA;EAIA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,yBAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,sDAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,yBALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,qBAAA;EACA,+BAAA;EAEA,4BAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,gCAAA;EACA,0BAAA;EAEA,8BAAA;EACA,sCAAA;EAGE,qCAAA;EAGF,wBAAA;EACA,6BAAA;EACA,0BAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,+BAAA;EACA,+BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,4DAAA;EACA,6DAAA;EACA,uDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,8CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;ArBo5fF;;AuBpggBA;;;EAGE,sBAAA;AvBuggBF;;AuBz+fA;EACE,SAAA;EACA,uCAAA;ED6OI,mCALI;ECtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;AvB4+fF;;AuBn+fA;EACE,cAAA;EACA,cjBmnB4B;EiBlnB5B,SAAA;EACA,wCAAA;EACA,ajBynB4B;AN62e9B;;AuB59fA;EACE,aAAA;EACA,qBCoYkD;EDjYlD,gBCsUkD;EDrUlD,gBCoYkD;EDnYlD,8BAAA;AvB69fF;;AuB19fA;EDuMQ,+BAAA;AtBuxfR;AsBn7fI;EC3CJ;ID8MQ,kBAAA;EtBoxfN;AACF;;AuB99fA;EDkMQ,iCAAA;AtBgyfR;AsB57fI;ECtCJ;IDyMQ,iBAAA;EtB6xfN;AACF;;AuBl+fA;ED6LQ,iCAAA;AtByyfR;AsBr8fI;ECjCJ;IDoMQ,kBAAA;EtBsyfN;AACF;;AuBt+fA;EDoLM,kBALI;AtB2zfV;;AuBr+fA;ED+KM,kBALI;AtB+zfV;;AuBp+fA;ED0KM,mBALI;AtBm0fV;;AuB79fA;EACE,aAAA;EACA,mBC0IkD;AxBs1fpD;;AuBt9fA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;AvBy9fF;;AuBn9fA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AvBs9fF;;AuBh9fA;;EAEE,kBAAA;AvBm9fF;;AuBh9fA;;;EAGE,aAAA;EACA,mBAAA;AvBm9fF;;AuBh9fA;;;;EAIE,gBAAA;AvBm9fF;;AuBh9fA;EACE,gBC0OkD;AxByufpD;;AuB98fA;EACE,qBAAA;EACA,cAAA;AvBi9fF;;AuB38fA;EACE,gBAAA;AvB88fF;;AuBt8fA;;EAEE,gBCmNkD;AxBsvfpD;;AuBj8fA;ED6EM,kBALI;AtB63fV;;AuB97fA;EACE,iBjBqf4B;EiBpf5B,gCAAA;EACA,wCAAA;AvBi8fF;;AuBx7fA;;EAEE,kBAAA;EDwDI,iBALI;ECjDR,cAAA;EACA,wBAAA;AvB27fF;;AuBx7fA;EAAM,eAAA;AvB47fN;;AuB37fA;EAAM,WAAA;AvB+7fN;;AuB17fA;EACE,gEAAA;EACA,qBCYkD;AxBi7fpD;AuB37fE;EACE,mDAAA;EACA,0BCUgD;AxBm7fpD;;AuBn7fE;EAEE,cAAA;EACA,qBAAA;AvBq7fJ;;AuB96fA;;;;EAIE,qCjBgV4B;EgBlUxB,cALI;AtBy6fV;;AuB16fA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EDEI,kBALI;AtBi7fV;AuBz6fE;EDHI,kBALI;ECUN,cAAA;EACA,kBAAA;AvB26fJ;;AuBv6fA;EDVM,kBALI;ECiBR,2BAAA;EACA,qBAAA;AvB06fF;AuBv6fE;EACE,cAAA;AvBy6fJ;;AuBr6fA;EACE,2BAAA;EDtBI,kBALI;EC6BR,wBjB25CkC;EiB15ClC,sCjB25CkC;EmBhsDhC,uBAAA;AzB8sgBJ;AuBt6fE;EACE,UAAA;ED7BE,cALI;AtB28fV;;AuB95fA;EACE,gBAAA;AvBi6fF;;AuB35fA;;EAEE,sBAAA;AvB85fF;;AuBt5fA;EACE,oBAAA;EACA,yBAAA;AvBy5fF;;AuBt5fA;EACE,oBCgjBkD;ED/iBlD,uBC+iBkD;ED9iBlD,gCjB4Z4B;EiB3Z5B,gBAAA;AvBy5fF;;AuBl5fA;EAEE,mBAAA;EACA,gCAAA;AvBo5fF;;AuBj5fA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AvBo5fF;;AuB54fA;EACE,qBAAA;AvB+4fF;;AuBz4fA;EAEE,gBAAA;AvB24fF;;AuBn4fA;EACE,UAAA;AvBs4fF;;AuBj4fA;;;;;EAKE,SAAA;EACA,oBAAA;ED5HI,kBALI;ECmIR,oBAAA;AvBo4fF;;AuBh4fA;;EAEE,oBAAA;AvBm4fF;;AuB93fA;EACE,eAAA;AvBi4fF;;AuB93fA;EAGE,iBAAA;AvB+3fF;AuB53fE;EACE,UAAA;AvB83fJ;;AuBv3fA;EACE,wBAAA;AvB03fF;;AuBl3fA;;;;EAIE,0BAAA;AvBq3fF;AuBl3fI;;;;EACE,eAAA;AvBu3fN;;AuBh3fA;EACE,UAAA;EACA,kBAAA;AvBm3fF;;AuB92fA;EACE,gBAAA;AvBi3fF;;AuBv2fA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AvB02fF;;AuBl2fA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBjBmN4B;EiBjN5B,oBAAA;EDnNM,iCAAA;AtBwjgBR;AsBptgBI;ECyWJ;IDtMQ,iBAAA;EtBqjgBN;AACF;AuBv2fE;EACE,WAAA;AvBy2fJ;;AuBl2fA;;;;;;;EAOE,UAAA;AvBq2fF;;AuBl2fA;EACE,YAAA;AvBq2fF;;AuB51fA;EACE,6BAAA;EACA,oBAAA;AvB+1fF;AuB51fE;EACE,eAAA;EACA,oBAAA;AvB81fJ;;AuBr1fA;;;;;;;CAAA;AAWA;EACE,wBAAA;AvBq1fF;;AuBh1fA;EACE,UAAA;AvBm1fF;;AuB50fA;EACE,aAAA;EACA,0BAAA;AvB+0fF;;AuB10fA;EACE,qBAAA;AvB60fF;;AuBx0fA;EACE,SAAA;AvB20fF;;AuBp0fA;EACE,kBAAA;EACA,eAAA;AvBu0fF;;AuB/zfA;EACE,wBAAA;AvBk0fF;;AuB1zfA;EACE,wBAAA;AvB6zfF;;A0Bx4gBA;EJmQM,kBALI;EI5PR,gBpBwoB4B;ANmwf9B;;A0Bt4gBE;EAGE,gBFuXgD;EEtXhD,gBFqbgD;EFzL5C,iCAAA;AtB4ogBR;AsBxygBI;EIpGF;IJuQM,eAAA;EtByogBN;AACF;;A0Bj5gBE;EAGE,gBFuXgD;EEtXhD,gBFqbgD;EFzL5C,iCAAA;AtBupgBR;AsBnzgBI;EIpGF;IJuQM,iBAAA;EtBopgBN;AACF;;A0B55gBE;EAGE,gBFuXgD;EEtXhD,gBFqbgD;EFzL5C,iCAAA;AtBkqgBR;AsB9zgBI;EIpGF;IJuQM,eAAA;EtB+pgBN;AACF;;A0Bv6gBE;EAGE,gBFuXgD;EEtXhD,gBFqbgD;EFzL5C,iCAAA;AtB6qgBR;AsBz0gBI;EIpGF;IJuQM,iBAAA;EtB0qgBN;AACF;;A0Bl7gBE;EAGE,gBFuXgD;EEtXhD,gBFqbgD;EFzL5C,iCAAA;AtBwrgBR;AsBp1gBI;EIpGF;IJuQM,eAAA;EtBqrgBN;AACF;;A0B77gBE;EAGE,gBFuXgD;EEtXhD,gBFqbgD;EFzL5C,iCAAA;AtBmsgBR;AsB/1gBI;EIpGF;IJuQM,iBAAA;EtBgsgBN;AACF;;A0Bh7gBA;ECvDE,eAAA;EACA,gBAAA;A3B2+gBF;;A0Bh7gBA;EC5DE,eAAA;EACA,gBAAA;A3Bg/gBF;;A0Bl7gBA;EACE,qBAAA;A1Bq7gBF;A0Bn7gBE;EACE,oBpBsoB0B;AN+yf9B;;A0B36gBA;EJ8MM,kBALI;EIvMR,yBAAA;A1B86gBF;;A0B16gBA;EACE,mBFoHO;EFmFH,kBALI;AtB4ugBV;A0B36gBE;EACE,gBAAA;A1B66gBJ;;A0Bz6gBA;EACE,iBAAA;EACA,mBF0GO;EFmFH,kBALI;EItLR,cFvFuB;AxBmghBzB;A0B16gBE;EACE,aAAA;A1B46gBJ;;A4B5ghBA;ECIE,eAAA;EAGA,YAAA;A7B0ghBF;;A4B3ghBA;EACE,gBtB+jDkC;EsB9jDlC,mCtB+jDkC;EsB9jDlC,2DAAA;EHGE,sCAAA;EKCE,mCARa;EDDjB,eAAA;EAGA,YAAA;A7BohhBF;;A4BtghBA;EAEE,qBAAA;A5BwghBF;;A4BrghBA;EACE,qBAAA;EACA,cAAA;A5BwghBF;;A4BrghBA;ENyPM,kBALI;EMlPR,gCtBkjDkC;ANs9dpC;;A+B1ihBE;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,4CAAA;EACA,2CAAA;EACA,kBAAA;EACA,iBAAA;AhCujhBF;;AUjghBI;EqB5CE;IACE,gBPkRe;ExB+xgBrB;AACF;AUvghBI;EqB5CE;IACE,gBPkRe;ExBoygBrB;AACF;AU5ghBI;EqB5CE;IACE,gBPkRe;ExByygBrB;AACF;AUjhhBI;EqB5CE;IACE,iBPkRe;ExB8ygBrB;AACF;AUthhBI;EqB5CE;IACE,iBPkRe;ExBmzgBrB;AACF;AiCtlhBA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AjC4lhBJ;;AiCvlhBE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,4CAAA;EACA,2CAAA;AlCgmhBF;AiC9lhBI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,4CAAA;EACA,2CAAA;EACA,8BAAA;AlC0lhBF;;AkC3ihBM;EACE,SAAA;AlC8ihBR;;AkC3ihBM;EApCJ,cAAA;EACA,WAAA;AlCmlhBF;;AkCrkhBE;EACE,cAAA;EACA,WAAA;AlCwkhBJ;;AkC1khBE;EACE,cAAA;EACA,UAAA;AlC6khBJ;;AkC/khBE;EACE,cAAA;EACA,mBAAA;AlCklhBJ;;AkCplhBE;EACE,cAAA;EACA,UAAA;AlCulhBJ;;AkCzlhBE;EACE,cAAA;EACA,UAAA;AlC4lhBJ;;AkC9lhBE;EACE,cAAA;EACA,mBAAA;AlCimhBJ;;AkClkhBM;EAhDJ,cAAA;EACA,WAAA;AlCsnhBF;;AkCjkhBU;EAhEN,cAAA;EACA,kBAAA;AlCqohBJ;;AkCtkhBU;EAhEN,cAAA;EACA,mBAAA;AlC0ohBJ;;AkC3khBU;EAhEN,cAAA;EACA,UAAA;AlC+ohBJ;;AkChlhBU;EAhEN,cAAA;EACA,mBAAA;AlCophBJ;;AkCrlhBU;EAhEN,cAAA;EACA,mBAAA;AlCyphBJ;;AkC1lhBU;EAhEN,cAAA;EACA,UAAA;AlC8phBJ;;AkC/lhBU;EAhEN,cAAA;EACA,mBAAA;AlCmqhBJ;;AkCpmhBU;EAhEN,cAAA;EACA,mBAAA;AlCwqhBJ;;AkCzmhBU;EAhEN,cAAA;EACA,UAAA;AlC6qhBJ;;AkC9mhBU;EAhEN,cAAA;EACA,mBAAA;AlCkrhBJ;;AkCnnhBU;EAhEN,cAAA;EACA,mBAAA;AlCurhBJ;;AkCxnhBU;EAhEN,cAAA;EACA,WAAA;AlC4rhBJ;;AkCrnhBY;EAxDV,wBAAA;AlCirhBF;;AkCznhBY;EAxDV,yBAAA;AlCqrhBF;;AkC7nhBY;EAxDV,gBAAA;AlCyrhBF;;AkCjohBY;EAxDV,yBAAA;AlC6rhBF;;AkCrohBY;EAxDV,yBAAA;AlCishBF;;AkCzohBY;EAxDV,gBAAA;AlCqshBF;;AkC7ohBY;EAxDV,yBAAA;AlCyshBF;;AkCjphBY;EAxDV,yBAAA;AlC6shBF;;AkCrphBY;EAxDV,gBAAA;AlCithBF;;AkCzphBY;EAxDV,yBAAA;AlCqthBF;;AkC7phBY;EAxDV,yBAAA;AlCythBF;;AkCtphBQ;;EAEE,mBAAA;AlCyphBV;;AkCtphBQ;;EAEE,mBAAA;AlCyphBV;;AkChqhBQ;;EAEE,sBAAA;AlCmqhBV;;AkChqhBQ;;EAEE,sBAAA;AlCmqhBV;;AkC1qhBQ;;EAEE,qBAAA;AlC6qhBV;;AkC1qhBQ;;EAEE,qBAAA;AlC6qhBV;;AkCprhBQ;;EAEE,sBAAA;AlCurhBV;;AkCprhBQ;;EAEE,sBAAA;AlCurhBV;;AkC9rhBQ;;EAEE,mBAAA;AlCishBV;;AkC9rhBQ;;EAEE,mBAAA;AlCishBV;;AkCxshBQ;;EAEE,sBAAA;AlC2shBV;;AkCxshBQ;;EAEE,sBAAA;AlC2shBV;;AkClthBQ;;EAEE,qBAAA;AlCqthBV;;AkClthBQ;;EAEE,qBAAA;AlCqthBV;;AkC5thBQ;;EAEE,sBAAA;AlC+thBV;;AkC5thBQ;;EAEE,sBAAA;AlC+thBV;;AkCtuhBQ;;EAEE,mBAAA;AlCyuhBV;;AkCtuhBQ;;EAEE,mBAAA;AlCyuhBV;;AkChvhBQ;;EAEE,sBAAA;AlCmvhBV;;AkChvhBQ;;EAEE,sBAAA;AlCmvhBV;;AkC1vhBQ;;EAEE,qBAAA;AlC6vhBV;;AkC1vhBQ;;EAEE,qBAAA;AlC6vhBV;;AUvzhBI;EwBUE;IACE,SAAA;ElCizhBN;;EkC9yhBI;IApCJ,cAAA;IACA,WAAA;ElCs1hBA;;EkCx0hBA;IACE,cAAA;IACA,WAAA;ElC20hBF;;EkC70hBA;IACE,cAAA;IACA,UAAA;ElCg1hBF;;EkCl1hBA;IACE,cAAA;IACA,mBAAA;ElCq1hBF;;EkCv1hBA;IACE,cAAA;IACA,UAAA;ElC01hBF;;EkC51hBA;IACE,cAAA;IACA,UAAA;ElC+1hBF;;EkCj2hBA;IACE,cAAA;IACA,mBAAA;ElCo2hBF;;EkCr0hBI;IAhDJ,cAAA;IACA,WAAA;ElCy3hBA;;EkCp0hBQ;IAhEN,cAAA;IACA,kBAAA;ElCw4hBF;;EkCz0hBQ;IAhEN,cAAA;IACA,mBAAA;ElC64hBF;;EkC90hBQ;IAhEN,cAAA;IACA,UAAA;ElCk5hBF;;EkCn1hBQ;IAhEN,cAAA;IACA,mBAAA;ElCu5hBF;;EkCx1hBQ;IAhEN,cAAA;IACA,mBAAA;ElC45hBF;;EkC71hBQ;IAhEN,cAAA;IACA,UAAA;ElCi6hBF;;EkCl2hBQ;IAhEN,cAAA;IACA,mBAAA;ElCs6hBF;;EkCv2hBQ;IAhEN,cAAA;IACA,mBAAA;ElC26hBF;;EkC52hBQ;IAhEN,cAAA;IACA,UAAA;ElCg7hBF;;EkCj3hBQ;IAhEN,cAAA;IACA,mBAAA;ElCq7hBF;;EkCt3hBQ;IAhEN,cAAA;IACA,mBAAA;ElC07hBF;;EkC33hBQ;IAhEN,cAAA;IACA,WAAA;ElC+7hBF;;EkCx3hBU;IAxDV,cAAA;ElCo7hBA;;EkC53hBU;IAxDV,wBAAA;ElCw7hBA;;EkCh4hBU;IAxDV,yBAAA;ElC47hBA;;EkCp4hBU;IAxDV,gBAAA;ElCg8hBA;;EkCx4hBU;IAxDV,yBAAA;ElCo8hBA;;EkC54hBU;IAxDV,yBAAA;ElCw8hBA;;EkCh5hBU;IAxDV,gBAAA;ElC48hBA;;EkCp5hBU;IAxDV,yBAAA;ElCg9hBA;;EkCx5hBU;IAxDV,yBAAA;ElCo9hBA;;EkC55hBU;IAxDV,gBAAA;ElCw9hBA;;EkCh6hBU;IAxDV,yBAAA;ElC49hBA;;EkCp6hBU;IAxDV,yBAAA;ElCg+hBA;;EkC75hBM;;IAEE,mBAAA;ElCg6hBR;;EkC75hBM;;IAEE,mBAAA;ElCg6hBR;;EkCv6hBM;;IAEE,sBAAA;ElC06hBR;;EkCv6hBM;;IAEE,sBAAA;ElC06hBR;;EkCj7hBM;;IAEE,qBAAA;ElCo7hBR;;EkCj7hBM;;IAEE,qBAAA;ElCo7hBR;;EkC37hBM;;IAEE,sBAAA;ElC87hBR;;EkC37hBM;;IAEE,sBAAA;ElC87hBR;;EkCr8hBM;;IAEE,mBAAA;ElCw8hBR;;EkCr8hBM;;IAEE,mBAAA;ElCw8hBR;;EkC/8hBM;;IAEE,sBAAA;ElCk9hBR;;EkC/8hBM;;IAEE,sBAAA;ElCk9hBR;;EkCz9hBM;;IAEE,qBAAA;ElC49hBR;;EkCz9hBM;;IAEE,qBAAA;ElC49hBR;;EkCn+hBM;;IAEE,sBAAA;ElCs+hBR;;EkCn+hBM;;IAEE,sBAAA;ElCs+hBR;;EkC7+hBM;;IAEE,mBAAA;ElCg/hBR;;EkC7+hBM;;IAEE,mBAAA;ElCg/hBR;;EkCv/hBM;;IAEE,sBAAA;ElC0/hBR;;EkCv/hBM;;IAEE,sBAAA;ElC0/hBR;;EkCjgiBM;;IAEE,qBAAA;ElCogiBR;;EkCjgiBM;;IAEE,qBAAA;ElCogiBR;AACF;AU/jiBI;EwBUE;IACE,SAAA;ElCwjiBN;;EkCrjiBI;IApCJ,cAAA;IACA,WAAA;ElC6liBA;;EkC/kiBA;IACE,cAAA;IACA,WAAA;ElCkliBF;;EkCpliBA;IACE,cAAA;IACA,UAAA;ElCuliBF;;EkCzliBA;IACE,cAAA;IACA,mBAAA;ElC4liBF;;EkC9liBA;IACE,cAAA;IACA,UAAA;ElCimiBF;;EkCnmiBA;IACE,cAAA;IACA,UAAA;ElCsmiBF;;EkCxmiBA;IACE,cAAA;IACA,mBAAA;ElC2miBF;;EkC5kiBI;IAhDJ,cAAA;IACA,WAAA;ElCgoiBA;;EkC3kiBQ;IAhEN,cAAA;IACA,kBAAA;ElC+oiBF;;EkChliBQ;IAhEN,cAAA;IACA,mBAAA;ElCopiBF;;EkCrliBQ;IAhEN,cAAA;IACA,UAAA;ElCypiBF;;EkC1liBQ;IAhEN,cAAA;IACA,mBAAA;ElC8piBF;;EkC/liBQ;IAhEN,cAAA;IACA,mBAAA;ElCmqiBF;;EkCpmiBQ;IAhEN,cAAA;IACA,UAAA;ElCwqiBF;;EkCzmiBQ;IAhEN,cAAA;IACA,mBAAA;ElC6qiBF;;EkC9miBQ;IAhEN,cAAA;IACA,mBAAA;ElCkriBF;;EkCnniBQ;IAhEN,cAAA;IACA,UAAA;ElCuriBF;;EkCxniBQ;IAhEN,cAAA;IACA,mBAAA;ElC4riBF;;EkC7niBQ;IAhEN,cAAA;IACA,mBAAA;ElCisiBF;;EkCloiBQ;IAhEN,cAAA;IACA,WAAA;ElCssiBF;;EkC/niBU;IAxDV,cAAA;ElC2riBA;;EkCnoiBU;IAxDV,wBAAA;ElC+riBA;;EkCvoiBU;IAxDV,yBAAA;ElCmsiBA;;EkC3oiBU;IAxDV,gBAAA;ElCusiBA;;EkC/oiBU;IAxDV,yBAAA;ElC2siBA;;EkCnpiBU;IAxDV,yBAAA;ElC+siBA;;EkCvpiBU;IAxDV,gBAAA;ElCmtiBA;;EkC3piBU;IAxDV,yBAAA;ElCutiBA;;EkC/piBU;IAxDV,yBAAA;ElC2tiBA;;EkCnqiBU;IAxDV,gBAAA;ElC+tiBA;;EkCvqiBU;IAxDV,yBAAA;ElCmuiBA;;EkC3qiBU;IAxDV,yBAAA;ElCuuiBA;;EkCpqiBM;;IAEE,mBAAA;ElCuqiBR;;EkCpqiBM;;IAEE,mBAAA;ElCuqiBR;;EkC9qiBM;;IAEE,sBAAA;ElCiriBR;;EkC9qiBM;;IAEE,sBAAA;ElCiriBR;;EkCxriBM;;IAEE,qBAAA;ElC2riBR;;EkCxriBM;;IAEE,qBAAA;ElC2riBR;;EkClsiBM;;IAEE,sBAAA;ElCqsiBR;;EkClsiBM;;IAEE,sBAAA;ElCqsiBR;;EkC5siBM;;IAEE,mBAAA;ElC+siBR;;EkC5siBM;;IAEE,mBAAA;ElC+siBR;;EkCttiBM;;IAEE,sBAAA;ElCytiBR;;EkCttiBM;;IAEE,sBAAA;ElCytiBR;;EkChuiBM;;IAEE,qBAAA;ElCmuiBR;;EkChuiBM;;IAEE,qBAAA;ElCmuiBR;;EkC1uiBM;;IAEE,sBAAA;ElC6uiBR;;EkC1uiBM;;IAEE,sBAAA;ElC6uiBR;;EkCpviBM;;IAEE,mBAAA;ElCuviBR;;EkCpviBM;;IAEE,mBAAA;ElCuviBR;;EkC9viBM;;IAEE,sBAAA;ElCiwiBR;;EkC9viBM;;IAEE,sBAAA;ElCiwiBR;;EkCxwiBM;;IAEE,qBAAA;ElC2wiBR;;EkCxwiBM;;IAEE,qBAAA;ElC2wiBR;AACF;AUt0iBI;EwBUE;IACE,SAAA;ElC+ziBN;;EkC5ziBI;IApCJ,cAAA;IACA,WAAA;ElCo2iBA;;EkCt1iBA;IACE,cAAA;IACA,WAAA;ElCy1iBF;;EkC31iBA;IACE,cAAA;IACA,UAAA;ElC81iBF;;EkCh2iBA;IACE,cAAA;IACA,mBAAA;ElCm2iBF;;EkCr2iBA;IACE,cAAA;IACA,UAAA;ElCw2iBF;;EkC12iBA;IACE,cAAA;IACA,UAAA;ElC62iBF;;EkC/2iBA;IACE,cAAA;IACA,mBAAA;ElCk3iBF;;EkCn1iBI;IAhDJ,cAAA;IACA,WAAA;ElCu4iBA;;EkCl1iBQ;IAhEN,cAAA;IACA,kBAAA;ElCs5iBF;;EkCv1iBQ;IAhEN,cAAA;IACA,mBAAA;ElC25iBF;;EkC51iBQ;IAhEN,cAAA;IACA,UAAA;ElCg6iBF;;EkCj2iBQ;IAhEN,cAAA;IACA,mBAAA;ElCq6iBF;;EkCt2iBQ;IAhEN,cAAA;IACA,mBAAA;ElC06iBF;;EkC32iBQ;IAhEN,cAAA;IACA,UAAA;ElC+6iBF;;EkCh3iBQ;IAhEN,cAAA;IACA,mBAAA;ElCo7iBF;;EkCr3iBQ;IAhEN,cAAA;IACA,mBAAA;ElCy7iBF;;EkC13iBQ;IAhEN,cAAA;IACA,UAAA;ElC87iBF;;EkC/3iBQ;IAhEN,cAAA;IACA,mBAAA;ElCm8iBF;;EkCp4iBQ;IAhEN,cAAA;IACA,mBAAA;ElCw8iBF;;EkCz4iBQ;IAhEN,cAAA;IACA,WAAA;ElC68iBF;;EkCt4iBU;IAxDV,cAAA;ElCk8iBA;;EkC14iBU;IAxDV,wBAAA;ElCs8iBA;;EkC94iBU;IAxDV,yBAAA;ElC08iBA;;EkCl5iBU;IAxDV,gBAAA;ElC88iBA;;EkCt5iBU;IAxDV,yBAAA;ElCk9iBA;;EkC15iBU;IAxDV,yBAAA;ElCs9iBA;;EkC95iBU;IAxDV,gBAAA;ElC09iBA;;EkCl6iBU;IAxDV,yBAAA;ElC89iBA;;EkCt6iBU;IAxDV,yBAAA;ElCk+iBA;;EkC16iBU;IAxDV,gBAAA;ElCs+iBA;;EkC96iBU;IAxDV,yBAAA;ElC0+iBA;;EkCl7iBU;IAxDV,yBAAA;ElC8+iBA;;EkC36iBM;;IAEE,mBAAA;ElC86iBR;;EkC36iBM;;IAEE,mBAAA;ElC86iBR;;EkCr7iBM;;IAEE,sBAAA;ElCw7iBR;;EkCr7iBM;;IAEE,sBAAA;ElCw7iBR;;EkC/7iBM;;IAEE,qBAAA;ElCk8iBR;;EkC/7iBM;;IAEE,qBAAA;ElCk8iBR;;EkCz8iBM;;IAEE,sBAAA;ElC48iBR;;EkCz8iBM;;IAEE,sBAAA;ElC48iBR;;EkCn9iBM;;IAEE,mBAAA;ElCs9iBR;;EkCn9iBM;;IAEE,mBAAA;ElCs9iBR;;EkC79iBM;;IAEE,sBAAA;ElCg+iBR;;EkC79iBM;;IAEE,sBAAA;ElCg+iBR;;EkCv+iBM;;IAEE,qBAAA;ElC0+iBR;;EkCv+iBM;;IAEE,qBAAA;ElC0+iBR;;EkCj/iBM;;IAEE,sBAAA;ElCo/iBR;;EkCj/iBM;;IAEE,sBAAA;ElCo/iBR;;EkC3/iBM;;IAEE,mBAAA;ElC8/iBR;;EkC3/iBM;;IAEE,mBAAA;ElC8/iBR;;EkCrgjBM;;IAEE,sBAAA;ElCwgjBR;;EkCrgjBM;;IAEE,sBAAA;ElCwgjBR;;EkC/gjBM;;IAEE,qBAAA;ElCkhjBR;;EkC/gjBM;;IAEE,qBAAA;ElCkhjBR;AACF;AU7kjBI;EwBUE;IACE,SAAA;ElCskjBN;;EkCnkjBI;IApCJ,cAAA;IACA,WAAA;ElC2mjBA;;EkC7ljBA;IACE,cAAA;IACA,WAAA;ElCgmjBF;;EkClmjBA;IACE,cAAA;IACA,UAAA;ElCqmjBF;;EkCvmjBA;IACE,cAAA;IACA,mBAAA;ElC0mjBF;;EkC5mjBA;IACE,cAAA;IACA,UAAA;ElC+mjBF;;EkCjnjBA;IACE,cAAA;IACA,UAAA;ElConjBF;;EkCtnjBA;IACE,cAAA;IACA,mBAAA;ElCynjBF;;EkC1ljBI;IAhDJ,cAAA;IACA,WAAA;ElC8ojBA;;EkCzljBQ;IAhEN,cAAA;IACA,kBAAA;ElC6pjBF;;EkC9ljBQ;IAhEN,cAAA;IACA,mBAAA;ElCkqjBF;;EkCnmjBQ;IAhEN,cAAA;IACA,UAAA;ElCuqjBF;;EkCxmjBQ;IAhEN,cAAA;IACA,mBAAA;ElC4qjBF;;EkC7mjBQ;IAhEN,cAAA;IACA,mBAAA;ElCirjBF;;EkClnjBQ;IAhEN,cAAA;IACA,UAAA;ElCsrjBF;;EkCvnjBQ;IAhEN,cAAA;IACA,mBAAA;ElC2rjBF;;EkC5njBQ;IAhEN,cAAA;IACA,mBAAA;ElCgsjBF;;EkCjojBQ;IAhEN,cAAA;IACA,UAAA;ElCqsjBF;;EkCtojBQ;IAhEN,cAAA;IACA,mBAAA;ElC0sjBF;;EkC3ojBQ;IAhEN,cAAA;IACA,mBAAA;ElC+sjBF;;EkChpjBQ;IAhEN,cAAA;IACA,WAAA;ElCotjBF;;EkC7ojBU;IAxDV,cAAA;ElCysjBA;;EkCjpjBU;IAxDV,wBAAA;ElC6sjBA;;EkCrpjBU;IAxDV,yBAAA;ElCitjBA;;EkCzpjBU;IAxDV,gBAAA;ElCqtjBA;;EkC7pjBU;IAxDV,yBAAA;ElCytjBA;;EkCjqjBU;IAxDV,yBAAA;ElC6tjBA;;EkCrqjBU;IAxDV,gBAAA;ElCiujBA;;EkCzqjBU;IAxDV,yBAAA;ElCqujBA;;EkC7qjBU;IAxDV,yBAAA;ElCyujBA;;EkCjrjBU;IAxDV,gBAAA;ElC6ujBA;;EkCrrjBU;IAxDV,yBAAA;ElCivjBA;;EkCzrjBU;IAxDV,yBAAA;ElCqvjBA;;EkClrjBM;;IAEE,mBAAA;ElCqrjBR;;EkClrjBM;;IAEE,mBAAA;ElCqrjBR;;EkC5rjBM;;IAEE,sBAAA;ElC+rjBR;;EkC5rjBM;;IAEE,sBAAA;ElC+rjBR;;EkCtsjBM;;IAEE,qBAAA;ElCysjBR;;EkCtsjBM;;IAEE,qBAAA;ElCysjBR;;EkChtjBM;;IAEE,sBAAA;ElCmtjBR;;EkChtjBM;;IAEE,sBAAA;ElCmtjBR;;EkC1tjBM;;IAEE,mBAAA;ElC6tjBR;;EkC1tjBM;;IAEE,mBAAA;ElC6tjBR;;EkCpujBM;;IAEE,sBAAA;ElCuujBR;;EkCpujBM;;IAEE,sBAAA;ElCuujBR;;EkC9ujBM;;IAEE,qBAAA;ElCivjBR;;EkC9ujBM;;IAEE,qBAAA;ElCivjBR;;EkCxvjBM;;IAEE,sBAAA;ElC2vjBR;;EkCxvjBM;;IAEE,sBAAA;ElC2vjBR;;EkClwjBM;;IAEE,mBAAA;ElCqwjBR;;EkClwjBM;;IAEE,mBAAA;ElCqwjBR;;EkC5wjBM;;IAEE,sBAAA;ElC+wjBR;;EkC5wjBM;;IAEE,sBAAA;ElC+wjBR;;EkCtxjBM;;IAEE,qBAAA;ElCyxjBR;;EkCtxjBM;;IAEE,qBAAA;ElCyxjBR;AACF;AUp1jBI;EwBUE;IACE,SAAA;ElC60jBN;;EkC10jBI;IApCJ,cAAA;IACA,WAAA;ElCk3jBA;;EkCp2jBA;IACE,cAAA;IACA,WAAA;ElCu2jBF;;EkCz2jBA;IACE,cAAA;IACA,UAAA;ElC42jBF;;EkC92jBA;IACE,cAAA;IACA,mBAAA;ElCi3jBF;;EkCn3jBA;IACE,cAAA;IACA,UAAA;ElCs3jBF;;EkCx3jBA;IACE,cAAA;IACA,UAAA;ElC23jBF;;EkC73jBA;IACE,cAAA;IACA,mBAAA;ElCg4jBF;;EkCj2jBI;IAhDJ,cAAA;IACA,WAAA;ElCq5jBA;;EkCh2jBQ;IAhEN,cAAA;IACA,kBAAA;ElCo6jBF;;EkCr2jBQ;IAhEN,cAAA;IACA,mBAAA;ElCy6jBF;;EkC12jBQ;IAhEN,cAAA;IACA,UAAA;ElC86jBF;;EkC/2jBQ;IAhEN,cAAA;IACA,mBAAA;ElCm7jBF;;EkCp3jBQ;IAhEN,cAAA;IACA,mBAAA;ElCw7jBF;;EkCz3jBQ;IAhEN,cAAA;IACA,UAAA;ElC67jBF;;EkC93jBQ;IAhEN,cAAA;IACA,mBAAA;ElCk8jBF;;EkCn4jBQ;IAhEN,cAAA;IACA,mBAAA;ElCu8jBF;;EkCx4jBQ;IAhEN,cAAA;IACA,UAAA;ElC48jBF;;EkC74jBQ;IAhEN,cAAA;IACA,mBAAA;ElCi9jBF;;EkCl5jBQ;IAhEN,cAAA;IACA,mBAAA;ElCs9jBF;;EkCv5jBQ;IAhEN,cAAA;IACA,WAAA;ElC29jBF;;EkCp5jBU;IAxDV,cAAA;ElCg9jBA;;EkCx5jBU;IAxDV,wBAAA;ElCo9jBA;;EkC55jBU;IAxDV,yBAAA;ElCw9jBA;;EkCh6jBU;IAxDV,gBAAA;ElC49jBA;;EkCp6jBU;IAxDV,yBAAA;ElCg+jBA;;EkCx6jBU;IAxDV,yBAAA;ElCo+jBA;;EkC56jBU;IAxDV,gBAAA;ElCw+jBA;;EkCh7jBU;IAxDV,yBAAA;ElC4+jBA;;EkCp7jBU;IAxDV,yBAAA;ElCg/jBA;;EkCx7jBU;IAxDV,gBAAA;ElCo/jBA;;EkC57jBU;IAxDV,yBAAA;ElCw/jBA;;EkCh8jBU;IAxDV,yBAAA;ElC4/jBA;;EkCz7jBM;;IAEE,mBAAA;ElC47jBR;;EkCz7jBM;;IAEE,mBAAA;ElC47jBR;;EkCn8jBM;;IAEE,sBAAA;ElCs8jBR;;EkCn8jBM;;IAEE,sBAAA;ElCs8jBR;;EkC78jBM;;IAEE,qBAAA;ElCg9jBR;;EkC78jBM;;IAEE,qBAAA;ElCg9jBR;;EkCv9jBM;;IAEE,sBAAA;ElC09jBR;;EkCv9jBM;;IAEE,sBAAA;ElC09jBR;;EkCj+jBM;;IAEE,mBAAA;ElCo+jBR;;EkCj+jBM;;IAEE,mBAAA;ElCo+jBR;;EkC3+jBM;;IAEE,sBAAA;ElC8+jBR;;EkC3+jBM;;IAEE,sBAAA;ElC8+jBR;;EkCr/jBM;;IAEE,qBAAA;ElCw/jBR;;EkCr/jBM;;IAEE,qBAAA;ElCw/jBR;;EkC//jBM;;IAEE,sBAAA;ElCkgkBR;;EkC//jBM;;IAEE,sBAAA;ElCkgkBR;;EkCzgkBM;;IAEE,mBAAA;ElC4gkBR;;EkCzgkBM;;IAEE,mBAAA;ElC4gkBR;;EkCnhkBM;;IAEE,sBAAA;ElCshkBR;;EkCnhkBM;;IAEE,sBAAA;ElCshkBR;;EkC7hkBM;;IAEE,qBAAA;ElCgikBR;;EkC7hkBM;;IAEE,qBAAA;ElCgikBR;AACF;AmCtpkBA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,yBAAA;EACA,0BAAA;EACA,gCAAA;EACA,iCAAA;EACA,iCAAA;EACA,gDAAA;EACA,gCAAA;EACA,6BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,WAAA;EACA,mBXqLO;EWpLP,mB7BusB4B;E6BtsB5B,0CAAA;AnCqpkBF;AmC9okBE;EACE,wBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,wBXgRgD;EW/QhD,2GAAA;AnC+okBJ;AmC5okBE;EACE,uBAAA;AnC8okBJ;AmC3okBE;EACE,sBAAA;AnC6okBJ;;AmCzokBA;EACE,4CAAA;AnC4okBF;;AmCrokBA;EACE,iBAAA;AnCwokBF;;AmC9nkBE;EACE,sBAAA;AnCiokBJ;;AmClnkBE;EACE,mBAAA;AnCqnkBJ;AmClnkBI;EACE,mBAAA;AnConkBN;;AmC7mkBE;EACE,sBAAA;AnCgnkBJ;AmC7mkBE;EACE,mBAAA;AnC+mkBJ;;AmCrmkBE;EACE,oDAAA;EACA,8CAAA;AnCwmkBJ;;AmClmkBE;EACE,oDAAA;EACA,8CAAA;AnCqmkBJ;;AmC7lkBA;EACE,oDAAA;EACA,8CAAA;AnCgmkBF;;AmCxlkBE;EACE,mDAAA;EACA,6CAAA;AnC2lkBJ;;AoCvukBE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApCmukBJ;;AoCrvkBE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApCivkBJ;;AoCnwkBE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApC+vkBJ;;AoCjxkBE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApC6wkBJ;;AoC/xkBE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApC2xkBJ;;AoC7ykBE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApCyykBJ;;AoC3zkBE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApCuzkBJ;;AoCz0kBE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApCq0kBJ;;AmCprkBI;EACE,gBAAA;EACA,iCAAA;AnCurkBN;;AUlxkBI;EyByFA;IACE,gBAAA;IACA,iCAAA;EnC6rkBJ;AACF;AUzxkBI;EyByFA;IACE,gBAAA;IACA,iCAAA;EnCmskBJ;AACF;AU/xkBI;EyByFA;IACE,gBAAA;IACA,iCAAA;EnCyskBJ;AACF;AUrykBI;EyByFA;IACE,gBAAA;IACA,iCAAA;EnC+skBJ;AACF;AU3ykBI;EyByFA;IACE,gBAAA;IACA,iCAAA;EnCqtkBJ;AACF;AqCz3kBA;EACE,qBbijBkD;EFvR9C,kBALI;EelRR,gBbgjBkD;Ea/iBlD,cbMuB;AxBo3kBzB;;AqCr3kBA;EACE,gCAAA;EACA,mCAAA;EACA,gBAAA;Ef8QI,kBALI;EetQR,gBboiBkD;EaniBlD,gBb8YkD;Ea7YlD,cbPuB;AxB83kBzB;;AqCp3kBA;EACE,iCAAA;EACA,oCAAA;EfoQI,kBALI;AtBynkBV;;AqCp3kBA;EACE,gCAAA;EACA,mCAAA;Ef8PI,mBALI;AtB+nkBV;;AsCr5kBA;EACE,kBdsjBkD;EF5R9C,mBALI;EgBjRR,cdGuB;AxBm5kBzB;;AuC35kBA;EACE,cAAA;EACA,WAAA;EACA,qBAAA;EjBwRI,iBALI;EiBhRR,gBfkZkD;EejZlD,gBfwZkD;EevZlD,cfIuB;EeHvB,gBAAA;EACA,yBf0OkD;EezOlD,4BAAA;EACA,yBAAA;EdGE,uBAAA;EKCE,sCARa;EvBIb,wEgCMJ;AvC05kBF;AO55kBM;EgChBN;IhCiBQ,gBAAA;EP+5kBN;AACF;AuC75kBE;EACE,gBAAA;AvC+5kBJ;AuC75kBI;EACE,eAAA;AvC+5kBN;AuC15kBE;EACE,cflBqB;EemBrB,yBfqNgD;EepNhD,qBfzBqB;Ee0BrB,UAAA;ETjBE,6EARa;A9Bs7kBnB;AuCp5kBE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;AvCw4kBJ;AuCn4kBE;EACE,cAAA;EACA,UAAA;AvCq4kBJ;AuCj4kBE;EACE,cf/DqB;EeiErB,UAAA;AvCk4kBJ;AuC13kBE;EAEE,yBf9EqB;EeiFrB,UAAA;AvCy3kBJ;AuCr3kBE;EACE,qBAAA;EACA,sBAAA;EACA,uBfiZgD;EehZhD,cflFqB;EgBZvB,uClCqiCgC;EiCr8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4Bf6MgD;Ee5MhD,gBAAA;EhCzFE,qIgC0FF;AvCu3kBJ;AO78kBM;EgC0EJ;IhCzEM,gBAAA;EPg9kBN;AACF;AuCz3kBE;EACE,wCjC47B8B;AN+7iBlC;;AuCl3kBA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBfuSkD;EetSlD,cf7GuB;Ee8GvB,6BAAA;EACA,yBAAA;EACA,mBAAA;AvCq3kBF;AuCn3kBE;EACE,UAAA;AvCq3kBJ;AuCl3kBE;EAEE,gBAAA;EACA,eAAA;AvCm3kBJ;;AuCx2kBA;EACE,gDjC4wBsC;EiC3wBtC,wBAAA;EjByII,mBALI;EGvQN,uBAAA;AzBg/kBJ;AuCz2kBE;EACE,wBAAA;EACA,yBAAA;EACA,0BfmWgD;AxBwgkBpD;;AuCv2kBA;EACE,iDjCgwBsC;EiC/vBtC,wBAAA;EjB4HI,kBALI;EGvQN,uBAAA;AzB4/kBJ;AuCx2kBE;EACE,wBAAA;EACA,yBAAA;EACA,yBf0VgD;AxBghkBpD;;AuCl2kBE;EACE,gDjC6uBoC;ANwnjBxC;AuCl2kBE;EACE,gDjC0uBoC;AN0njBxC;AuCj2kBE;EACE,iDjCuuBoC;AN4njBxC;;AuC91kBA;EACE,WjCquBsC;EiCpuBtC,4CjC8tBsC;EiC7tBtC,gBf8SkD;AxBmjkBpD;AuC/1kBE;EACE,eAAA;AvCi2kBJ;AuC91kBE;EACE,oBAAA;EdvLA,uBAAA;AzBwhlBJ;AuC71kBE;EACE,oBAAA;Ed5LA,uBAAA;AzB4hlBJ;AuC51kBE;EAAoB,4CjC8sBkB;ANipjBxC;AuC91kBE;EAAoB,6CjC8sBkB;ANmpjBxC;;AyChjlBA;EACE,gEAAA;EAEA,cAAA;EACA,WAAA;EACA,kCAAA;EnBqRI,iBALI;EmB7QR,gBjB+YkD;EiB9YlD,gBjBqZkD;EiBpZlD,cjBCuB;EiBAvB,gBAAA;EACA,yBjBuOkD;EiBtOlD,mFAAA;EACA,4BAAA;EACA,sCnC+9BkC;EmC99BlC,0BnC+9BkC;EmC99BlC,yBAAA;EhBHE,uBAAA;EKCE,sCARa;EvBIb,wEkCSJ;AzCijlBF;AOtjlBM;EkCfN;IlCgBQ,gBAAA;EPyjlBN;AACF;AyCpjlBE;EACE,qBjBjBqB;EiBkBrB,UAAA;EXTE,6EARa;A9BwklBnB;AyC9ilBE;EAEE,mBjB0cgD;EiBzchD,sBAAA;AzC+ilBJ;AyC5ilBE;EAEE,yBjBrCqB;AxBkllBzB;AyCxilBE;EACE,kBAAA;EACA,0BAAA;AzC0ilBJ;;AyCtilBA;EACE,oBjBqckD;EiBpclD,uBjBockD;EiBnclD,qBjBockD;EFjO9C,mBALI;EGvQN,uBAAA;AzBollBJ;;AyCtilBA;EACE,qBjBickD;EiBhclD,wBjBgckD;EiB/blD,oBjBgckD;EFrO9C,kBALI;EGvQN,uBAAA;AzB4llBJ;;A0C3mlBA;EACE,cAAA;EACA,kBlBylBkD;EkBxlBlD,qBlBylBkD;EkBxlBlD,uBlB0lBkD;AxBohkBpD;A0C5mlBE;EACE,WAAA;EACA,qBAAA;A1C8mlBJ;;A0C1mlBA;EACE,sBlB+kBkD;EkB9kBlD,eAAA;EACA,iBAAA;A1C6mlBF;A0C3mlBE;EACE,YAAA;EACA,sBAAA;EACA,cAAA;A1C6mlBJ;;A0CzmlBA;EACE,2BAAA;EAEA,cAAA;EACA,clB2jBkD;EkB1jBlD,elB0jBkD;EkBzjBlD,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,qClBikBkD;EkBhkBlD,yBAAA;EnC3BI,mJmC4BJ;A1C2mlBF;AOnolBM;EmCQN;InCPQ,gBAAA;EPsolBN;AACF;A0C9mlBE;EjB3BE,qBAAA;AzB4olBJ;A0C7mlBE;EAEE,kBlByjBgD;AxBqjkBpD;A0C3mlBE;EACE,uBlB+iBgD;AxB8jkBpD;A0C1mlBE;EACE,qBlBjDqB;EkBkDrB,UAAA;EACA,gBlBijBgD;AxB2jkBpD;A0CzmlBE;EACE,yBC1DqB;ED2DrB,qBC3DqB;A3CsqlBzB;A0CzmlBI;EAII,iEAAA;A1CwmlBR;A0CpmlBI;EAII,iEAAA;A1CmmlBR;A0C9llBE;EACE,yBC/EqB;EDgFrB,qBChFqB;EDqFnB,iEAAA;A1C4llBN;A0CxllBE;EACE,oBAAA;EACA,YAAA;EACA,YlBwhBgD;AxBkkkBpD;A0CnllBI;EACE,eAAA;EACA,YlB+gB8C;AxBskkBpD;;A0CvklBA;EACE,qBlB6gBkD;AxB6jkBpD;A0CxklBE;EACE,4DAAA;EAEA,clBigBgD;EkBhgBhD,qBAAA;EACA,0CAAA;EACA,gCAAA;EjBjHA,sBAAA;ElBHE,iDmCsHF;A1CyklBJ;AO3rlBM;EmC0GJ;InCzGM,gBAAA;EP8rlBN;AACF;A0C5klBI;EACE,4DAAA;A1C8klBN;A0C3klBI;EACE,iClBugB8C;EkBlgB5C,4DAAA;A1CyklBR;A0CpklBE;EACE,sBlBifgD;EkBhfhD,eAAA;A1CsklBJ;A0CpklBI;EACE,sBAAA;EACA,cAAA;A1CsklBN;;A0CjklBA;EACE,qBAAA;EACA,kBpCsyBgC;AN8xjBlC;;A0CjklBA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A1CoklBF;A0ChklBI;EACE,oBAAA;EACA,YAAA;EACA,YlBmX8C;AxB+skBpD;;A4C7ulBA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A5CgvlBF;A4C9ulBE;EACE,UAAA;A5CgvlBJ;A4C5ulBI;EAA0B,oEtC8gCa;ANiujB3C;A4C9ulBI;EAA0B,oEtC6gCa;ANoujB3C;A4C9ulBE;EACE,SAAA;A5CgvlBJ;A4C7ulBE;EACE,WtC+/BuC;EsC9/BvC,YtC8/BuC;EsC7/BvC,oBAAA;EACA,gBAAA;EJ1BF,yBGIuB;ECwBrB,StC6/BuC;EmB1gCvC,mBAAA;EKCE,+CARa;EvBIb,oHqCmBF;ErCnBE,4GqCmBF;A5C+ulBJ;AO9vlBM;EqCMJ;IrCLM,wBAAA;IAAA,gBAAA;EPiwlBN;AACF;A4ClvlBI;EJjCF,yBlC8hCyC;ANwvjB3C;A4ChvlBE;EACE,WtCw+B8B;EsCv+B9B,ctCw+B8B;EsCv+B9B,kBAAA;EACA,etCu+B8B;EsCt+B9B,wCtCu+B8B;EsCt+B9B,yBAAA;EnB7BA,mBAAA;EKCE,sCARa;A9BwxlBnB;A4C/ulBE;EACE,WtCo+BuC;EsCn+BvC,YtCm+BuC;EsCl+BvC,gBAAA;EJpDF,yBGIuB;ECkDrB,StCm+BuC;EmB1gCvC,mBAAA;EKCE,+CARa;EvBIb,iHqC6CF;ErC7CE,4GqC6CF;A5CivlBJ;AO1xlBM;EqCiCJ;IrChCM,qBAAA;IAAA,gBAAA;EP6xlBN;AACF;A4CpvlBI;EJ3DF,yBlC8hCyC;ANoxjB3C;A4ClvlBE;EACE,WtC88B8B;EsC78B9B,ctC88B8B;EsC78B9B,kBAAA;EACA,etC68B8B;EsC58B9B,wCtC68B8B;EsC58B9B,yBAAA;EnBvDA,mBAAA;EKCE,sCARa;A9BozlBnB;A4CjvlBE;EACE,oBAAA;A5CmvlBJ;A4CjvlBI;EACE,2CtCg9BqC;ANmyjB3C;A4ChvlBI;EACE,2CtC48BqC;ANsyjB3C;;A6Cz0lBA;EACE,kBAAA;A7C40lBF;A6C10lBE;;;EAGE,oCvCwiCoC;EuCviCpC,wCvCuiCoC;EuCtiCpC,iBvCuiCoC;ANqyjBxC;A6Cz0lBE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,2CAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;EACA,qBAAA;EtCVE,gEsCWF;A7C20lBJ;AOl1lBM;EsCTJ;ItCUM,gBAAA;EPq1lBN;AACF;A6C70lBE;;EAEE,kBAAA;A7C+0lBJ;A6C70lBI;;EACE,kBAAA;A7Cg1lBN;A6C70lBI;;;EAEE,qBvC0gCkC;EuCzgClC,wBvC0gCkC;ANs0jBxC;A6C70lBI;;EACE,qBvCqgCkC;EuCpgClC,wBvCqgCkC;AN20jBxC;A6C50lBE;EACE,qBvC+/BoC;EuC9/BpC,wBvC+/BoC;EuC9/BpC,kBrB6bgD;AxBi5kBpD;A6Cv0lBI;;;;EACE,8DvCy/BkC;ANm1jBxC;A6Cv0lBI;EACE,8DvCm/BkC;ANs1jBxC;A6Cp0lBI;;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,avCw+BkC;EuCv+BlC,WAAA;EACA,yBrB0K8C;ECrOhD,uBAAA;AzBm4lBJ;A6Cp0lBE;EACE,yBrB1EqB;AxBg5lBzB;A6Cl0lBI;EACE,mBAAA;A7Co0lBN;A6Ch0lBE;;EAEE,crBjFqB;AxBm5lBzB;;A8C55lBA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A9C+5lBF;A8C75lBE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A9C+5lBJ;A8C35lBE;;;EAGE,UAAA;A9C65lBJ;A8Cv5lBE;EACE,kBAAA;EACA,UAAA;A9Cy5lBJ;A8Cv5lBI;EACE,UAAA;A9Cy5lBN;;A8C94lBA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;ExB8OI,iBALI;EwBvOR,gBtByWkD;EsBxWlD,gBtB+WkD;EsB9WlD,ctBrCuB;EsBsCvB,kBAAA;EACA,mBAAA;EACA,yBtBhDuB;EsBiDvB,yBAAA;ErBtCE,uBAAA;AzBw7lBJ;;A8Cx4lBA;;;;EAIE,wBAAA;ExBwNI,kBALI;EGvQN,uBAAA;AzBi8lBJ;;A8Cx4lBA;;;;EAIE,wBAAA;ExB+MI,mBALI;EGvQN,uBAAA;AzB08lBJ;;A8Cx4lBA;;EAEE,mBAAA;A9C24lBF;;A8C93lBI;;;;ErBjEA,0BAAA;EACA,6BAAA;AzBs8lBJ;A8C73lBI;;;;ErB1EA,0BAAA;EACA,6BAAA;AzB68lBJ;A8Cv3lBE;EACE,2BAAA;ErB1EA,yBAAA;EACA,4BAAA;AzBo8lBJ;A8Cv3lBE;;ErB9EE,yBAAA;EACA,4BAAA;AzBy8lBJ;;A+Cj+lBE;EACE,aAAA;EACA,WAAA;EACA,kBvB8hBgD;EF5R9C,mBALI;EyB1PN,iCzCkjCqB;ANi7jBzB;;A+Ch+lBE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EzBqPE,mBALI;EyB7ON,WzCqiCqB;EyCpiCrB,mCzCoiCqB;EmB/jCrB,uBAAA;AzB8/lBJ;;A+C99lBI;;;;EAEE,cAAA;A/Cm+lBN;;A+ClhmBI;EAqDE,+CzCuhCmB;EyCphCjB,mCzC81BgC;EyC71BhC,yDAAA;EACA,4BAAA;EACA,0DAAA;EACA,8DAAA;A/C+9lBR;A+C59lBM;EACE,+CzC4gCiB;EwB9jCnB,uFARa;A9ByhmBnB;;A+C/hmBI;EA+EI,mCzCu0BgC;EyCt0BhC,gFAAA;A/Co9lBR;;A+CpimBI;EAuFE,+CzCq/BmB;AN49jBzB;A+C98lBQ;EAEE,iEAAA;EACA,qBzCq5B8B;EyCp5B9B,yDAAA;EACA,yEAAA;A/C+8lBV;A+C38lBM;EACE,+CzCw+BiB;EwB9jCnB,uFARa;A9B4imBnB;;A+CljmBI;EAkHI,wCAAA;A/Co8lBR;;A+CtjmBI;EAyHE,+CzCm9BmB;AN8+jBzB;A+C/7lBM;EACE,4CzCg9BiB;ANi/jBzB;A+C97lBM;EACE,2DzC48BiB;ANo/jBzB;A+C77lBM;EACE,iCzCw8BiB;ANu/jBzB;;A+C17lBI;EACE,kBAAA;A/C67lBN;;A+CvkmBI;;;;;EAoJM,UAAA;A/C27lBV;;A+C3jmBE;EACE,aAAA;EACA,WAAA;EACA,kBvB8hBgD;EF5R9C,mBALI;EyB1PN,mCzCkjCqB;AN2gkBzB;;A+C1jmBE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EzBqPE,mBALI;EyB7ON,WzCqiCqB;EyCpiCrB,kCzCoiCqB;EmB/jCrB,uBAAA;AzBwlmBJ;;A+CxjmBI;;;;EAEE,cAAA;A/C6jmBN;;A+C5mmBI;EAqDE,iDzCuhCmB;EyCphCjB,mCzC81BgC;EyC71BhC,yDAAA;EACA,4BAAA;EACA,0DAAA;EACA,8DAAA;A/CyjmBR;A+CtjmBM;EACE,iDzC4gCiB;EwB9jCnB,sFARa;A9BmnmBnB;;A+CznmBI;EA+EI,mCzCu0BgC;EyCt0BhC,gFAAA;A/C8imBR;;A+C9nmBI;EAuFE,iDzCq/BmB;ANsjkBzB;A+CximBQ;EAEE,iEAAA;EACA,qBzCq5B8B;EyCp5B9B,yDAAA;EACA,yEAAA;A/CyimBV;A+CrimBM;EACE,iDzCw+BiB;EwB9jCnB,sFARa;A9BsomBnB;;A+C5omBI;EAkHI,wCAAA;A/C8hmBR;;A+ChpmBI;EAyHE,iDzCm9BmB;ANwkkBzB;A+CzhmBM;EACE,8CzCg9BiB;AN2kkBzB;A+CxhmBM;EACE,0DzC48BiB;AN8kkBzB;A+CvhmBM;EACE,mCzCw8BiB;ANilkBzB;;A+CphmBI;EACE,kBAAA;A/CuhmBN;;A+CjqmBI;;;;;EAsJM,UAAA;A/CmhmBV;;AgD3qmBA;EAEE,0BAAA;EACA,2BAAA;EACA,sBAAA;E1BuRI,0BALI;E0BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,0BAAA;EACA,kCAAA;EACA,gCAAA;EACA,wCAAA;EACA,4FAAA;EACA,8BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E1BsQI,kCALI;E0B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EAGA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;EvBjBE,0CAAA;EefF,kCQkCqB;ElBlBjB,oCARa;EvBIb,qIyCwBJ;AhDyqmBF;AO7rmBM;EyChBN;IzCiBQ,gBAAA;EPgsmBN;AACF;AgD5qmBE;EACE,gCAAA;EACA,qBAAA;EACA,wCAAA;EACA,8CAAA;AhD8qmBJ;AgD3qmBE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;AhD4qmBJ;AgDzqmBE;EACE,gCAAA;ERrDF,wCQsDuB;EACrB,8CAAA;EACA,UAAA;EAGE,oEAAA;AhDyqmBN;AgDnqmBE;EACE,8CAAA;EACA,UAAA;EAGE,oEAAA;AhDmqmBN;AgD7pmBE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;ElBrEE,uCARa;A9BuumBnB;AgDvpmBI;EAGI,uEAAA;AhDupmBR;AgDhpmBE;EAGI,uEAAA;AhDgpmBN;AgD1omBE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;ElBrGE,gBkBsGF;AhDyomBJ;;AgD9nmBE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,wBAAA;EACA,kCAAA;EACA,wCAAA;EACA,8BAAA;EACA,yBAAA;EACA,mCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjDivmBF;;AgD/omBE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjDkwmBF;;AgDhqmBE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjDmxmBF;;AgDjrmBE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjDoymBF;;AgDlsmBE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjDqzmBF;;AgDntmBE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjDs0mBF;;AgDpumBE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjDu1mBF;;AgDrvmBE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjDw2mBF;;AgDtwmBE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjDy3mBF;;AgD7vmBE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjDi3mBF;;AgD9wmBE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjDk4mBF;;AgD/xmBE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjDm5mBF;;AgDhzmBE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjDo6mBF;;AgDj0mBE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjDq7mBF;;AgDl1mBE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjDs8mBF;;AgDn2mBE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjDu9mBF;;AgDp3mBE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjDw+mBF;;AgDr4mBE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjDy/mBF;;AgD14mBA;EACE,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,kCAAA;EACA,6BAAA;EACA,wCAAA;EACA,8BAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,sCAAA;EAEA,qBxB0EkD;AxBk0mBpD;AgDv4mBE;EAEE,0BxBqEgD;AxBm0mBpD;AgDr4mBE;EACE,0BAAA;AhDu4mBJ;AgDp4mBE;EACE,gCAAA;AhDs4mBJ;;AgD33mBA;ECjJE,4BAAA;EACA,2BAAA;E3B8NI,2BALI;E2BvNR,gCAAA;AjDghnBF;;AgD93mBA;ECrJE,2BAAA;EACA,2BAAA;E3B8NI,4BALI;E2BvNR,gCAAA;AjDuhnBF;;AkD1lnBA;E3CgBM,gC2CfJ;AlD6lnBF;AO1knBM;E2CpBN;I3CqBQ,gBAAA;EP6knBN;AACF;AkDhmnBE;EACE,UAAA;AlDkmnBJ;;AkD5lnBE;EACE,aAAA;AlD+lnBJ;;AkD3lnBA;EACE,SAAA;EACA,gBAAA;E3CDI,6B2CEJ;AlD8lnBF;AO5lnBM;E2CLN;I3CMQ,gBAAA;EP+lnBN;AACF;AkDjmnBE;EACE,QAAA;EACA,YAAA;E3CNE,4B2COF;AlDmmnBJ;AOtmnBM;E2CAJ;I3CCM,gBAAA;EPymnBN;AACF;;AmD9nnBA;;;;;;EAME,kBAAA;AnDionBF;;AmD9nnBA;EACE,mBAAA;AnDionBF;AoDzmnBI;EACE,qBAAA;EACA,oB5BsS8C;E4BrS9C,uB5BoS8C;E4BnS9C,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;ApDipnBF;AoDvlnBI;EACE,cAAA;ApDylnBN;;AmDvonBA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E7BuQI,6BALI;E6BhQR,yCAAA;EACA,yBAAA;EACA,8DAAA;EACA,qCAAA;EACA,6BAAA;EACA,qDAAA;EACA,4DAAA;EACA,sCAAA;EACA,kEAAA;EACA,8CAAA;EACA,oDAAA;EACA,kDAAA;EACA,wCAAA;EACA,qCAAA;EACA,2DAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E7B0OI,uCALI;E6BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E1BzCE,+CAAA;EKCE,yCARa;A9ByrnBnB;AmDronBE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AnDuonBJ;;AmD/mnBI;EACE,oBAAA;AnDknnBN;AmDhnnBM;EACE,WAAA;EACA,OAAA;AnDknnBR;;AmD9mnBI;EACE,kBAAA;AnDinnBN;AmD/mnBM;EACE,QAAA;EACA,UAAA;AnDinnBR;;AU3pnBI;EyC4BA;IACE,oBAAA;EnDmonBJ;EmDjonBI;IACE,WAAA;IACA,OAAA;EnDmonBN;;EmD/nnBE;IACE,kBAAA;EnDkonBJ;EmDhonBI;IACE,QAAA;IACA,UAAA;EnDkonBN;AACF;AU7qnBI;EyC4BA;IACE,oBAAA;EnDopnBJ;EmDlpnBI;IACE,WAAA;IACA,OAAA;EnDopnBN;;EmDhpnBE;IACE,kBAAA;EnDmpnBJ;EmDjpnBI;IACE,QAAA;IACA,UAAA;EnDmpnBN;AACF;AU9rnBI;EyC4BA;IACE,oBAAA;EnDqqnBJ;EmDnqnBI;IACE,WAAA;IACA,OAAA;EnDqqnBN;;EmDjqnBE;IACE,kBAAA;EnDoqnBJ;EmDlqnBI;IACE,QAAA;IACA,UAAA;EnDoqnBN;AACF;AU/snBI;EyC4BA;IACE,oBAAA;EnDsrnBJ;EmDprnBI;IACE,WAAA;IACA,OAAA;EnDsrnBN;;EmDlrnBE;IACE,kBAAA;EnDqrnBJ;EmDnrnBI;IACE,QAAA;IACA,UAAA;EnDqrnBN;AACF;AUhunBI;EyC4BA;IACE,oBAAA;EnDusnBJ;EmDrsnBI;IACE,WAAA;IACA,OAAA;EnDusnBN;;EmDnsnBE;IACE,kBAAA;EnDssnBJ;EmDpsnBI;IACE,QAAA;IACA,UAAA;EnDssnBN;AACF;AmD7rnBE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AnD+rnBJ;AoDnxnBI;EACE,qBAAA;EACA,oB5BsS8C;E4BrS9C,uB5BoS8C;E4BnS9C,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;ApDoznBF;AoDjwnBI;EACE,cAAA;ApDmwnBN;;AmDnsnBE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AnDssnBJ;AoDxynBI;EACE,qBAAA;EACA,oB5BsS8C;E4BrS9C,uB5BoS8C;E4BnS9C,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;ApDk0nBF;AoDtxnBI;EACE,cAAA;ApDwxnBN;AmD9snBI;EACE,iBAAA;AnDgtnBN;;AmD1snBE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AnD6snBJ;AoDh0nBI;EACE,qBAAA;EACA,oB5BsS8C;E4BrS9C,uB5BoS8C;E4BnS9C,WAAA;ApDk0nBN;AoDvznBM;EACE,aAAA;ApDyznBR;AoDtznBM;EACE,qBAAA;EACA,qB5BmR4C;E4BlR5C,uB5BiR4C;E4BhR5C,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;ApD41nBF;AoDtznBI;EACE,cAAA;ApDwznBN;AmD7tnBI;EACE,iBAAA;AnD+tnBN;;AmDxtnBA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AnD2tnBF;;AmDrtnBA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB3BwOkD;E2BvOlD,oCAAA;EACA,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;E1BtKE,uDAAA;AzB83nBJ;AmDrtnBE;EAEE,0CAAA;EACA,qBAAA;EX3LF,kDW4LuB;AnDstnBzB;AmDntnBE;EAEE,2CAAA;EACA,qBAAA;EXlMF,mDWmMuB;AnDotnBzB;AmDjtnBE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AnDktnBJ;;AmD5snBA;EACE,cAAA;AnD+snBF;;AmD3snBA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E7BmEI,mBALI;E6B5DR,sCAAA;EACA,mBAAA;AnD8snBF;;AmD1snBA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AnD6snBF;;AmDzsnBA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,uCAAA;EACA,4DAAA;EACA,sDAAA;EACA,wCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AnD2snBF;;AqDj8nBA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;ArDo8nBF;AqDl8nBE;;EACE,kBAAA;EACA,cAAA;ArDq8nBJ;AqDh8nBE;;;;;;;;;;;;EAME,UAAA;ArDw8nBJ;;AqDn8nBA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;ArDs8nBF;AqDp8nBE;EACE,WAAA;ArDs8nBJ;;AqDl8nBA;E5BhBI,uBAAA;AzBs9nBJ;AqDl8nBE;;EAEE,2BAAA;ArDo8nBJ;AqDh8nBE;;;E5BVE,0BAAA;EACA,6BAAA;AzB+8nBJ;AqD57nBE;;;E5BNE,yBAAA;EACA,4BAAA;AzBu8nBJ;;AqD/6nBA;EACE,uBAAA;EACA,sBAAA;ArDk7nBF;AqDh7nBE;EAGE,cAAA;ArDg7nBJ;AqD76nBE;EACE,eAAA;ArD+6nBJ;;AqD36nBA;EACE,wBAAA;EACA,uBAAA;ArD86nBF;;AqD36nBA;EACE,wBAAA;EACA,uBAAA;ArD86nBF;;AqDx6nBA;EvBlFM,gDARa;A9BsgoBnB;AqDx6nBE;EvBxFI,gBuByFF;ArD06nBJ;;AqDj6nBA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;ArDo6nBF;AqDl6nBE;;EAEE,WAAA;ArDo6nBJ;AqDj6nBE;;EAEE,0BAAA;ArDm6nBJ;AqD/5nBE;;E5B1FE,6BAAA;EACA,4BAAA;AzB6/nBJ;AqD35nBE;;;E5BjHE,yBAAA;EACA,0BAAA;AzBihoBJ;;AsDzioBA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AtDwioBF;;AsDrioBA;EACE,cAAA;EACA,kEAAA;EhCsQI,uCALI;EgC/PR,2CAAA;EACA,+BAAA;EAEA,gBAAA;EACA,SAAA;E/CfI,uG+CgBJ;AtDuioBF;AOnjoBM;E+CGN;I/CFQ,gBAAA;EPsjoBN;AACF;AsD1ioBE;EAEE,qCAAA;EACA,qBAAA;AtD2ioBJ;AsDxioBE;EACE,UAAA;EACA,iDhDkhBoB;ANwhnBxB;AsDtioBE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;AtDuioBJ;;AsD/hoBA;EAEE,+BAAA;EACA,mCAAA;EACA,oDAAA;EACA,4FAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EAGA,oFAAA;AtD+hoBF;AsD7hoBE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;AzB6koBJ;AsD9hoBI;EAGE,kBAAA;EACA,wDAAA;AtD8hoBN;AsD1hoBE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;AtD4hoBJ;AsDzhoBE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;AzB4loBJ;;AsDjhoBA;EAEE,qDAAA;EACA,yCAAA;EACA,sCAAA;AtDmhoBF;AsDhhoBE;E7B5FE,gDAAA;AzB+moBJ;AsD/goBE;;EAEE,4CAAA;EdjHF,oDckHuB;AtDihoBzB;;AsDxgoBA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;AtDwgoBF;AsDtgoBE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;AtDwgoBJ;AsDtgoBI;EAEE,iCAAA;AtDugoBN;AsDngoBE;;EAEE,gB9BuQgD;E8BtQhD,gDAAA;EACA,iCAAA;AtDqgoBJ;;AsD3/nBE;;EAEE,cAAA;EACA,kBAAA;AtD8/nBJ;;AsDz/nBE;;EAEE,YAAA;EACA,aAAA;EACA,kBAAA;AtD4/nBJ;;AsDt/nBE;;EACE,WAAA;AtD0/nBJ;;AsDh/nBE;EACE,aAAA;AtDm/nBJ;AsDj/nBE;EACE,cAAA;AtDm/nBJ;;AuDhroBA;EAEE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,uCAAA;EACA,kCAAA;EACA,qCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,uCAAA;EACA,oEAAA;EACA,0EAAA;EACA,2CAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;AvDgroBF;AuD1qoBE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AvDkroBJ;AuD9poBA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;EjC4NI,2CALI;EiCrNR,mCAAA;EAEA,mBAAA;AvD+poBF;AuD7poBE;EAEE,yCAAA;EACA,qBAAA;AvD8poBJ;;AuDrpoBA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AvDopoBF;AuDjpoBI;EAEE,oCAAA;AvDkpoBN;AuD9ooBE;EACE,gBAAA;AvDgpoBJ;;AuDvooBA;EACE,mBjD8gCkC;EiD7gClC,sBjD6gCkC;EiD5gClC,6BAAA;AvD0ooBF;AuDxooBE;;;EAGE,oCAAA;AvD0ooBJ;;AuD7noBA;EACE,YAAA;EACA,gBAAA;EAGA,mBAAA;AvD8noBF;;AuD1noBA;EACE,8EAAA;EjCyII,6CALI;EiClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BxIE,qDAAA;ElBHE,+CgD6IJ;AvD6noBF;AOtwoBM;EgDiIN;IhDhIQ,gBAAA;EPywoBN;AACF;AuDhooBE;EACE,qBAAA;AvDkooBJ;AuD/noBE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;AvDiooBJ;;AuD3noBA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AvD8noBF;;AuD3noBA;EACE,yCAAA;EACA,gBAAA;AvD8noBF;;AUxvoBI;E6CsIA;IAEI,iBAAA;IACA,2BAAA;EvDqnoBN;EuDnnoBM;IACE,mBAAA;EvDqnoBR;EuDnnoBQ;IACE,kBAAA;EvDqnoBV;EuDlnoBQ;IACE,kDAAA;IACA,iDAAA;EvDonoBV;EuDhnoBM;IACE,iBAAA;EvDknoBR;EuD/moBM;IACE,wBAAA;IACA,gBAAA;EvDinoBR;EuD9moBM;IACE,aAAA;EvDgnoBR;EuD7moBM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IzB5NJ,gByB6NI;IhD/NJ,gBgDgOI;EvD8moBR;EuD3moBQ;IACE,aAAA;EvD6moBV;EuD1moBQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvD4moBV;AACF;AUzyoBI;E6CsIA;IAEI,iBAAA;IACA,2BAAA;EvDqqoBN;EuDnqoBM;IACE,mBAAA;EvDqqoBR;EuDnqoBQ;IACE,kBAAA;EvDqqoBV;EuDlqoBQ;IACE,kDAAA;IACA,iDAAA;EvDoqoBV;EuDhqoBM;IACE,iBAAA;EvDkqoBR;EuD/poBM;IACE,wBAAA;IACA,gBAAA;EvDiqoBR;EuD9poBM;IACE,aAAA;EvDgqoBR;EuD7poBM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IzB5NJ,gByB6NI;IhD/NJ,gBgDgOI;EvD8poBR;EuD3poBQ;IACE,aAAA;EvD6poBV;EuD1poBQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvD4poBV;AACF;AUz1oBI;E6CsIA;IAEI,iBAAA;IACA,2BAAA;EvDqtoBN;EuDntoBM;IACE,mBAAA;EvDqtoBR;EuDntoBQ;IACE,kBAAA;EvDqtoBV;EuDltoBQ;IACE,kDAAA;IACA,iDAAA;EvDotoBV;EuDhtoBM;IACE,iBAAA;EvDktoBR;EuD/soBM;IACE,wBAAA;IACA,gBAAA;EvDitoBR;EuD9soBM;IACE,aAAA;EvDgtoBR;EuD7soBM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IzB5NJ,gByB6NI;IhD/NJ,gBgDgOI;EvD8soBR;EuD3soBQ;IACE,aAAA;EvD6soBV;EuD1soBQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvD4soBV;AACF;AUz4oBI;E6CsIA;IAEI,iBAAA;IACA,2BAAA;EvDqwoBN;EuDnwoBM;IACE,mBAAA;EvDqwoBR;EuDnwoBQ;IACE,kBAAA;EvDqwoBV;EuDlwoBQ;IACE,kDAAA;IACA,iDAAA;EvDowoBV;EuDhwoBM;IACE,iBAAA;EvDkwoBR;EuD/voBM;IACE,wBAAA;IACA,gBAAA;EvDiwoBR;EuD9voBM;IACE,aAAA;EvDgwoBR;EuD7voBM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IzB5NJ,gByB6NI;IhD/NJ,gBgDgOI;EvD8voBR;EuD3voBQ;IACE,aAAA;EvD6voBV;EuD1voBQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvD4voBV;AACF;AUz7oBI;E6CsIA;IAEI,iBAAA;IACA,2BAAA;EvDqzoBN;EuDnzoBM;IACE,mBAAA;EvDqzoBR;EuDnzoBQ;IACE,kBAAA;EvDqzoBV;EuDlzoBQ;IACE,kDAAA;IACA,iDAAA;EvDozoBV;EuDhzoBM;IACE,iBAAA;EvDkzoBR;EuD/yoBM;IACE,wBAAA;IACA,gBAAA;EvDizoBR;EuD9yoBM;IACE,aAAA;EvDgzoBR;EuD7yoBM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IzB5NJ,gByB6NI;IhD/NJ,gBgDgOI;EvD8yoBR;EuD3yoBQ;IACE,aAAA;EvD6yoBV;EuD1yoBQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvD4yoBV;AACF;AuDn2oBI;EAEI,iBAAA;EACA,2BAAA;AvDo2oBR;AuDl2oBQ;EACE,mBAAA;AvDo2oBV;AuDl2oBU;EACE,kBAAA;AvDo2oBZ;AuDj2oBU;EACE,kDAAA;EACA,iDAAA;AvDm2oBZ;AuD/1oBQ;EACE,iBAAA;AvDi2oBV;AuD91oBQ;EACE,wBAAA;EACA,gBAAA;AvDg2oBV;AuD71oBQ;EACE,aAAA;AvD+1oBV;AuD51oBQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;EzB5NJ,gByB6NI;EhD/NJ,gBgDgOI;AvD61oBV;AuD11oBU;EACE,aAAA;AvD41oBZ;AuDz1oBU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AvD21oBZ;;AuD10oBA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,iCAAA;EACA,gCAAA;EACA,sCAAA;EACA,0DAAA;EACA,qEAAA;AvD40oBF;;AwD9lpBA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,+BAAA;EACA,iCAAA;EACA,8DAAA;EACA,wEAAA;EACA,+BAAA;EACA,6BAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,mCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;EKCE,qCARa;A9BwnpBnB;AwD5lpBE;EACE,eAAA;EACA,cAAA;AxD8lpBJ;AwD3lpBE;EACE,mBAAA;EACA,sBAAA;AxD6lpBJ;AwD3lpBI;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;AzBonpBJ;AwD3lpBI;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;AzB2mpBJ;AwDxlpBE;;EAEE,aAAA;AxD0lpBJ;;AwDtlpBA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AxDulpBF;;AwDplpBA;EACE,4CAAA;EACA,iCAAA;AxDulpBF;;AwDplpBA;EACE,qDAAA;EACA,gBAAA;EACA,oCAAA;AxDulpBF;;AwDplpBA;EACE,gBAAA;AxDulpBF;;AwDnlpBE;EACE,qBAAA;AxDslpBJ;AwDnlpBE;EACE,oCAAA;AxDqlpBJ;;AwD7kpBA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AxDglpBF;AwD9kpBE;E/B7FE,wFAAA;AzB8qpBJ;;AwD5kpBA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AxD+kpBF;AwD7kpBE;E/BxGE,wFAAA;AzBwrpBJ;;AwDtkpBA;EACE,sDAAA;EACA,sDAAA;EACA,qDAAA;EACA,gBAAA;AxDykpBF;AwDvkpBE;EACE,mCAAA;EACA,sCAAA;AxDykpBJ;;AwDrkpBA;EACE,sDAAA;EACA,qDAAA;AxDwkpBF;;AwDpkpBA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;AzBktpBJ;;AwDpkpBA;;;EAGE,WAAA;AxDukpBF;;AwDpkpBA;;E/B3II,0DAAA;EACA,2DAAA;AzBotpBJ;;AwDrkpBA;;E/BlII,8DAAA;EACA,6DAAA;AzB4spBJ;;AwD9jpBE;EACE,0CAAA;AxDikpBJ;AU5rpBI;E8CuHJ;IAQI,aAAA;IACA,mBAAA;ExDikpBF;EwD9jpBE;IACE,SAAA;IACA,gBAAA;ExDgkpBJ;EwD9jpBI;IACE,cAAA;IACA,cAAA;ExDgkpBN;EwD3jpBM;I/B1KJ,0BAAA;IACA,6BAAA;EzBwupBF;EwD5jpBQ;;IAGE,0BAAA;ExD6jpBV;EwD3jpBQ;;IAGE,6BAAA;ExD4jpBV;EwDxjpBM;I/B3KJ,yBAAA;IACA,4BAAA;EzBsupBF;EwDzjpBQ;;IAGE,yBAAA;ExD0jpBV;EwDxjpBQ;;IAGE,4BAAA;ExDyjpBV;AACF;;AyD7xpBA;EAEE,6BAAA;EACA,oCAAA;EACA,8KAAA;EACA,oCAAA;EACA,mDAAA;EACA,sCAAA;EACA,6EAAA;EACA,oCAAA;EACA,oCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,yCAAA;EACA,qCAAA;EACA,qCAAA;EACA,oCAAA;EACA,iCAAA;AzD+xpBF;;AyD3xpBA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EnC4PI,eALI;EmCrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCrBE,gBAAA;EgCuBF,qBAAA;ElD1BI,0CkD2BJ;AzD8xpBF;AOrzpBM;EkDUN;IlDTQ,gBAAA;EPwzpBN;AACF;AyDjypBE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AzDmypBJ;AyDjypBI;EACE,qDAAA;EACA,iDAAA;AzDmypBN;AyD9xpBE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;ElDjDE,mDkDkDF;AzDgypBJ;AO90pBM;EkDqCJ;IlDpCM,gBAAA;EPi1pBN;AACF;AyDlypBE;EACE,UAAA;AzDoypBJ;AyDjypBE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;AzDmypBJ;;AyD/xpBA;EACE,gBAAA;AzDkypBF;;AyD/xpBA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AzDkypBF;AyDhypBE;EhC7DE,yDAAA;EACA,0DAAA;AzBg2pBJ;AyDjypBI;EhChEA,+DAAA;EACA,gEAAA;AzBo2pBJ;AyDhypBE;EACE,aAAA;AzDkypBJ;AyD9xpBE;EhC5DE,6DAAA;EACA,4DAAA;AzB61pBJ;AyD9xpBM;EhChEF,mEAAA;EACA,kEAAA;AzBi2pBJ;AyD7xpBI;EhCrEA,6DAAA;EACA,4DAAA;AzBq2pBJ;;AyD3xpBA;EACE,8EAAA;AzD8xpBF;;AyDrxpBE;EACE,eAAA;EACA,cAAA;EhC9GA,gBAAA;AzBu4pBJ;AyDtxpBI;EAAgB,aAAA;AzDyxpBpB;AyDxxpBI;EAAe,gBAAA;AzD2xpBnB;AyDxxpBI;;;EhCrHA,gBAAA;AzBk5pBJ;;A0Dr6pBA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,sCAAA;EACA,sCAAA;EACA,0CAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;EpC+QI,yCALI;EoCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;AzBq6pBJ;;A0D/5pBE;EACE,iDAAA;A1Dk6pBJ;A0Dh6pBI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;A1Dk6pBN;A0D95pBE;EACE,6CAAA;A1Dg6pBJ;;A2Dr8pBA;EAEE,kCAAA;EACA,mCAAA;ErC4RI,mCALI;EqCrRR,8BAAA;EACA,+BAAA;EACA,+BAAA;EACA,yCAAA;EACA,uCAAA;EACA,oCAAA;EACA,iCAAA;EACA,+CAAA;EACA,oCAAA;EACA,iCAAA;EACA,sCAAA;EACA,qCAAA;EACA,kCAAA;EACA,gDAAA;EACA,uCAAA;EACA,wCAAA;EACA,kDAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;A3B09pBF;;A2Dn8pBA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;ErCgQI,yCALI;EqCzPR,iCAAA;EAEA,yCAAA;EACA,iFAAA;EpDpBI,qIoDqBJ;A3Dq8pBF;AOt9pBM;EoDQN;IpDPQ,gBAAA;EPy9pBN;AACF;A2Dx8pBE;EACE,UAAA;EACA,uCAAA;EACA,qBAAA;EACA,+CAAA;EACA,qDAAA;A3D08pBJ;A2Dv8pBE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UnCwuBgD;EmCvuBhD,iDAAA;A3Dy8pBJ;A2Dt8pBE;EAEE,UAAA;EACA,wCAAA;EnBtDF,gDmBuDuB;EACrB,sDAAA;A3Du8pBJ;A2Dp8pBE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;A3Dq8pBJ;;A2Dh8pBE;EACE,yBrD8sCgC;ANqvnBpC;A2D97pBM;ElC9BF,0DAAA;EACA,6DAAA;AzB+9pBJ;A2D57pBM;ElClDF,2DAAA;EACA,8DAAA;AzBi/pBJ;;A2D/6pBA;EClGE,iCAAA;EACA,kCAAA;EtC0RI,mCALI;EsCnRR,yDAAA;A5DqhqBF;;A2Dl7pBA;ECtGE,iCAAA;EACA,kCAAA;EtC0RI,mCALI;EsCnRR,yDAAA;A5D4hqBF;;A6D9hqBA;EAEE,4BAAA;EACA,2BAAA;EvCuRI,6BALI;EuChRR,2BAAA;EACA,yBAAA;EACA,kCAAA;EAGA,qBAAA;EACA,4DAAA;EvC+QI,oCALI;EuCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;AzBmiqBJ;A6D1hqBE;EACE,aAAA;A7D4hqBJ;;A6DvhqBA;EACE,kBAAA;EACA,SAAA;A7D0hqBF;;A8D1jqBA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;AzB8jqBJ;;A8DtjqBA;EAEE,cAAA;A9DwjqBF;;A8DpjqBA;EACE,gBtC0XkD;EsCzXlD,iCAAA;A9DujqBF;;A8D/iqBA;EACE,mBxDs+C8B;AN4knBhC;A8D/iqBE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A9DijqBJ;;A8DziqBE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A9D4iqBJ;;A8DhjqBE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A9DmjqBJ;;A8DvjqBE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9D0jqBJ;;A8D9jqBE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A9DikqBJ;;A8DrkqBE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9DwkqBJ;;A8D5kqBE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A9D+kqBJ;;A8DnlqBE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9DslqBJ;;A8D1lqBE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A9D6lqBJ;;A8DjmqBE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A9DomqBJ;;A+DhqqBE;EACE;IAAK,gDAAA;E/DoqqBP;AACF;A+DhqqBA;;EAGE,0BAAA;EzCkRI,gCALI;EyC3QR,yBAAA;EACA,gCAAA;EACA,8BAAA;EACA,gCAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;EzCsQI,uCALI;EyC/PR,uCAAA;EtCRE,+CAAA;EKCE,yCARa;A9BgrqBnB;;A+D5pqBA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;ExDxBI,6CwDyBJ;A/D+pqBF;AOprqBM;EwDYN;IxDXQ,gBAAA;EPurqBN;AACF;;A+DjqqBA;EvBAE,qMAAA;EuBEA,oEAAA;A/DoqqBF;;A+DjqqBA;EACE,iBAAA;A/DoqqBF;;A+DjqqBA;EACE,WAAA;A/DoqqBF;;A+DhqqBE;EACE,kDAAA;A/DmqqBJ;A+DhqqBM;EAJJ;IAKM,eAAA;E/DmqqBN;AACF;;AgE/tqBA;EAEE,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,8CAAA;EACA,qCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;AzByuqBJ;;AgE1tqBA;EACE,qBAAA;EACA,sBAAA;AhE6tqBF;AgE3tqBE;EAEE,oCAAA;EACA,0BAAA;AhE4tqBJ;;AgEptqBA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EAEA,yCAAA;EACA,iFAAA;AhEstqBF;AgEptqBE;EvC9BE,+BAAA;EACA,gCAAA;AzBqvqBJ;AgEptqBE;EvCpBE,mCAAA;EACA,kCAAA;AzB2uqBJ;AgEptqBE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;AhEqtqBJ;AgEjtqBE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;AhEmtqBJ;AgE/sqBE;EACE,mBAAA;AhEitqBJ;AgE/sqBI;EACE,wDAAA;EACA,mDAAA;AhEitqBN;;AgEvsqBA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;AhE0sqBF;AgEtsqBI;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;AhEusqBN;AgEpsqBI;EACE,+CAAA;EACA,uDAAA;AhEssqBN;;AgEzrqBI;EACE,mBAAA;AhE4rqBN;AgEzrqBQ;EvCzDJ,6DAAA;EAZA,0BAAA;AzBkwqBJ;AgExrqBQ;EvC1EJ,2DAAA;EAYA,4BAAA;AzB0vqBJ;AgEvrqBQ;EACE,aAAA;AhEyrqBV;AgEtrqBQ;EACE,mDAAA;EACA,oBAAA;AhEwrqBV;AgEtrqBU;EACE,yDAAA;EACA,oDAAA;AhEwrqBZ;;AUhxqBI;EsDgEA;IACE,mBAAA;EhEotqBJ;EgEjtqBM;IvCzDJ,6DAAA;IAZA,0BAAA;EzB0xqBF;EgEhtqBM;IvC1EJ,2DAAA;IAYA,4BAAA;EzBkxqBF;EgE/sqBM;IACE,aAAA;EhEitqBR;EgE9sqBM;IACE,mDAAA;IACA,oBAAA;EhEgtqBR;EgE9sqBQ;IACE,yDAAA;IACA,oDAAA;EhEgtqBV;AACF;AUzyqBI;EsDgEA;IACE,mBAAA;EhE4uqBJ;EgEzuqBM;IvCzDJ,6DAAA;IAZA,0BAAA;EzBkzqBF;EgExuqBM;IvC1EJ,2DAAA;IAYA,4BAAA;EzB0yqBF;EgEvuqBM;IACE,aAAA;EhEyuqBR;EgEtuqBM;IACE,mDAAA;IACA,oBAAA;EhEwuqBR;EgEtuqBQ;IACE,yDAAA;IACA,oDAAA;EhEwuqBV;AACF;AUj0qBI;EsDgEA;IACE,mBAAA;EhEowqBJ;EgEjwqBM;IvCzDJ,6DAAA;IAZA,0BAAA;EzB00qBF;EgEhwqBM;IvC1EJ,2DAAA;IAYA,4BAAA;EzBk0qBF;EgE/vqBM;IACE,aAAA;EhEiwqBR;EgE9vqBM;IACE,mDAAA;IACA,oBAAA;EhEgwqBR;EgE9vqBQ;IACE,yDAAA;IACA,oDAAA;EhEgwqBV;AACF;AUz1qBI;EsDgEA;IACE,mBAAA;EhE4xqBJ;EgEzxqBM;IvCzDJ,6DAAA;IAZA,0BAAA;EzBk2qBF;EgExxqBM;IvC1EJ,2DAAA;IAYA,4BAAA;EzB01qBF;EgEvxqBM;IACE,aAAA;EhEyxqBR;EgEtxqBM;IACE,mDAAA;IACA,oBAAA;EhEwxqBR;EgEtxqBQ;IACE,yDAAA;IACA,oDAAA;EhEwxqBV;AACF;AUj3qBI;EsDgEA;IACE,mBAAA;EhEozqBJ;EgEjzqBM;IvCzDJ,6DAAA;IAZA,0BAAA;EzB03qBF;EgEhzqBM;IvC1EJ,2DAAA;IAYA,4BAAA;EzBk3qBF;EgE/yqBM;IACE,aAAA;EhEizqBR;EgE9yqBM;IACE,mDAAA;IACA,oBAAA;EhEgzqBR;EgE9yqBQ;IACE,yDAAA;IACA,oDAAA;EhEgzqBV;AACF;AgEnyqBA;EvClJI,gBAAA;AzBw7qBJ;AgEnyqBE;EACE,mDAAA;AhEqyqBJ;AgEnyqBI;EACE,sBAAA;AhEqyqBN;;AgExxqBE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;AhE2xqBJ;;AgEryqBE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;AhEwyqBJ;;AgElzqBE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhEqzqBJ;;AgE/zqBE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;AhEk0qBJ;;AgE50qBE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhE+0qBJ;;AgEz1qBE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AhE41qBJ;;AgEt2qBE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhEy2qBJ;;AgEn3qBE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;AhEs3qBJ;;AgEh4qBE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AhEm4qBJ;;AiEjkrBA;EAEE,6BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,kEAAA;EACA,+BAAA;EACA,qCAAA;EAGA,uBAAA;EACA,U3DupD2B;E2DtpD3B,W3DspD2B;E2DrpD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,kCAAA;EACA,SAAA;ExCJE,uBAAA;EwCMF,oCAAA;AjEikrBF;AiE9jrBE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;AjEgkrBJ;AiE7jrBE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;AjE+jrBJ;AiE5jrBE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;AjE6jrBJ;;AiErjrBA;EAHE,iEAAA;AjE4jrBF;;AiErjrBA;;EAEE,uBAAA;AjEwjrBF;;AkElnrBA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;E5CyRI,8BALI;E4ClRR,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;E5C2QI,oCALI;E4CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;AzB2nrBJ;AkEhnrBE;EACE,UAAA;AlEknrBJ;AkE/mrBE;EACE,aAAA;AlEinrBJ;;AkE7mrBA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AlE+mrBF;AkE7mrBE;EACE,sCAAA;AlE+mrBJ;;AkE3mrBA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;AzB+orBJ;AkE7mrBE;EACE,mDAAA;EACA,sCAAA;AlE+mrBJ;;AkE3mrBA;EACE,kCAAA;EACA,qBAAA;AlE8mrBF;;AmE5qrBA;EAEE,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,yBAAA;EACA,sCAAA;EACA,sBAAA;EACA,2DAAA;EACA,0BAAA;EACA,kCAAA;EACA,0DAAA;EACA,wCAAA;EACA,oCAAA;EACA,oCAAA;EACA,0CAAA;EACA,uCAAA;EACA,mCAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,uCAAA;EACA,mCAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AnE0qrBF;;AmEnqrBA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AnEqqrBF;AmElqrBE;EACE,8B7Dm8CgC;ECh/C9B,mC4D8CF;AnEoqrBJ;AO9srBM;E4DwCJ;I5DvCM,gBAAA;EPitrBN;AACF;AmEvqrBE;EACE,e7Dg8CgC;ANyuoBpC;AmErqrBE;EACE,sB7D67CgC;AN0uoBpC;;AmEnqrBA;EACE,+CAAA;AnEsqrBF;AmEpqrBE;EACE,gBAAA;EACA,gBAAA;AnEsqrBJ;AmEnqrBE;EACE,gBAAA;AnEqqrBJ;;AmEjqrBA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AnEoqrBF;;AmEhqrBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;EKCE,sCARa;EqCgGjB,UAAA;AnEiqrBF;;AmE7prBA;EAEE,0BAAA;EACA,yBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AnEmqrB9D;AoE/wrBE;EAAS,UAAA;ApEkxrBX;AoEjxrBE;EAAS,mCD2GiF;AnEyqrB5F;;AmEpqrBA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;E1CrGE,2DAAA;EACA,4DAAA;AzB6wrBJ;AmEtqrBE;EACE,gGAAA;EAEA,wDAAA;EACA,0DAAA;EACA,2DAAA;EACA,iBAAA;AnEuqrBJ;;AmElqrBA;EACE,gBAAA;EACA,8CAAA;AnEqqrBF;;AmEhqrBA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AnEiqrBF;;AmE7prBA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,wEAAA;EACA,2CAAA;EACA,yFAAA;E1C7HE,+DAAA;EACA,8DAAA;AzB8xrBJ;AmE5prBE;EACE,6CAAA;AnE8prBJ;;AU7wrBI;EyDqHF;IACE,0BAAA;IACA,uDAAA;EnE4prBF;;EmExprBA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EnE2prBF;;EmExprBA;IACE,uBAAA;EnE2prBF;AACF;AU9xrBI;EyDuIF;;IAEE,uBAAA;EnE0prBF;AACF;AUpyrBI;EyD8IF;IACE,wBAAA;EnEyprBF;AACF;AmEhprBI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AnEkprBN;AmEhprBM;EACE,YAAA;EACA,SAAA;E1C7MJ,gBAAA;AzBg2rBJ;AmE/orBM;;E1CjNF,gBAAA;AzBo2rBJ;AmE9orBM;EACE,gBAAA;AnEgprBR;;AU9yrBI;EyD4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnEsqrBJ;EmEpqrBI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EzBo3rBF;EmEnqrBI;;I1CjNF,gBAAA;EzBw3rBF;EmElqrBI;IACE,gBAAA;EnEoqrBN;AACF;AUn0rBI;EyD4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnE0rrBJ;EmExrrBI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EzBw4rBF;EmEvrrBI;;I1CjNF,gBAAA;EzB44rBF;EmEtrrBI;IACE,gBAAA;EnEwrrBN;AACF;AUv1rBI;EyD4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnE8srBJ;EmE5srBI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EzB45rBF;EmE3srBI;;I1CjNF,gBAAA;EzBg6rBF;EmE1srBI;IACE,gBAAA;EnE4srBN;AACF;AU32rBI;EyD4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnEkurBJ;EmEhurBI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EzBg7rBF;EmE/trBI;;I1CjNF,gBAAA;EzBo7rBF;EmE9trBI;IACE,gBAAA;EnEgurBN;AACF;AU/3rBI;EyD4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnEsvrBJ;EmEpvrBI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EzBo8rBF;EmEnvrBI;;I1CjNF,gBAAA;EzBw8rBF;EmElvrBI;IACE,gBAAA;EnEovrBN;AACF;AqE99rBA;EAEE,yBAAA;EACA,6BAAA;EACA,4BAAA;EACA,+BAAA;EACA,sBAAA;E/CwRI,gCALI;E+CjRR,2BAAA;EACA,wBAAA;EACA,oCAAA;EACA,uBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,sChE+lB4B;EgE7lB5B,kBAAA;EACA,gB9CuZkD;E8CtZlD,gB9C8ZkD;E8C7ZlD,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EhDgRI,sCALI;E+ChQR,qBAAA;EACA,UAAA;ArEs+rBF;AqEp+rBE;EAAS,kCAAA;ArEu+rBX;AqEr+rBE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ArEu+rBJ;AqEr+rBI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ArEu+rBN;;AqEl+rBA;EACE,iDAAA;ArEq+rBF;AqEn+rBE;EACE,SAAA;EACA,uFAAA;EACA,sCAAA;ArEq+rBJ;;AqEj+rBA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;ArEo+rBF;AqEl+rBE;EACE,WAAA;EACA,gIAAA;EACA,wCAAA;ArEo+rBJ;;AqEh+rBA,mBAAA;AAEA;EACE,8CAAA;ArEk+rBF;AqEh+rBE;EACE,YAAA;EACA,uFAAA;EACA,yCAAA;ArEk+rBJ;;AqE99rBA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;ArEi+rBF;AqE/9rBE;EACE,UAAA;EACA,gIAAA;EACA,uCAAA;ArEi+rBJ;;AqE79rBA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;AzBijsBJ;;AuEpksBA;EAEE,yBAAA;EACA,6BAAA;EjD4RI,4BALI;EiDrRR,wBAAA;EACA,iDAAA;EACA,kCAAA;EACA,oCAAA;EACA,yEAAA;EACA,iEAAA;EACA,sCAAA;EACA,mCAAA;EjDmRI,mCALI;EiD5QR,kCAAA;EACA,+BAAA;EACA,oCAAA;EACA,oCAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sChE+lB4B;EgE7lB5B,kBAAA;EACA,gB9CuZkD;E8CtZlD,gB9C8ZkD;E8C7ZlD,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EhDgRI,sCALI;EiD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;EKCE,wCARa;A9BumsBnB;AuE5ksBE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AvE8ksBJ;AuE5ksBI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AvE6ksBN;;AuEvksBE;EACE,oFAAA;AvE0ksBJ;AuExksBI;EAEE,uFAAA;AvEyksBN;AuEtksBI;EACE,SAAA;EACA,gDAAA;AvEwksBN;AuErksBI;EACE,sCAAA;EACA,sCAAA;AvEuksBN;;AuElksBA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;AvEoksBJ;AuElksBI;EAEE,gIAAA;AvEmksBN;AuEhksBI;EACE,OAAA;EACA,kDAAA;AvEkksBN;AuE/jsBI;EACE,oCAAA;EACA,wCAAA;AvEiksBN;;AuE5jsBA,mBAAA;AAGE;EACE,iFAAA;AvE6jsBJ;AuE3jsBI;EAEE,uFAAA;AvE4jsBN;AuEzjsBI;EACE,MAAA;EACA,mDAAA;AvE2jsBN;AuExjsBI;EACE,mCAAA;EACA,yCAAA;AvE0jsBN;AuErjsBE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,sDAAA;EACA,WAAA;EACA,+EAAA;AvEujsBJ;;AuEnjsBA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;AvEqjsBJ;AuEnjsBI;EAEE,gIAAA;AvEojsBN;AuEjjsBI;EACE,QAAA;EACA,iDAAA;AvEmjsBN;AuEhjsBI;EACE,qCAAA;EACA,uCAAA;AvEkjsBN;;AuE7isBA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;EjD2GI,6CALI;EiDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;AzB4rsBJ;AuE9hsBE;EACE,aAAA;AvEgisBJ;;AuE5hsBA;EACE,0EAAA;EACA,mCAAA;AvE+hsBF;;AwEptsBA;EACE,kBAAA;AxEutsBF;;AwEptsBA;EACE,mBAAA;AxEutsBF;;AwEptsBA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AxEutsBF;AC7usBE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AD+usBJ;;AwExtsBA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EjElBI,sCiEmBJ;AxE2tsBF;AO1usBM;EiEQN;IjEPQ,gBAAA;EP6usBN;AACF;;AwE7tsBA;;;EAGE,cAAA;AxEgusBF;;AwE7tsBA;;EAEE,2BAAA;AxEgusBF;;AwE7tsBA;;EAEE,4BAAA;AxEgusBF;;AwEvtsBE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AxE0tsBJ;AwEvtsBE;;;EAGE,UAAA;EACA,UAAA;AxEytsBJ;AwEttsBE;;EAEE,UAAA;EACA,UAAA;EjE5DE,2BiE6DF;AxEwtsBJ;AOjxsBM;EiEqDJ;;IjEpDM,gBAAA;EPqxsBN;AACF;;AwErtsBA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UlEkhDmC;EkEjhDnC,UAAA;EACA,chD5FoB;EgD6FpB,kBAAA;EACA,gBAAA;EACA,8CAAA;EACA,SAAA;EACA,YlE4gDmC;ECnmD/B,8BiEwFJ;AxEutsBF;AO3ysBM;EiEkEN;;IjEjEQ,gBAAA;EP+ysBN;AACF;AwE1tsBE;;;EAEE,chDvGkB;EgDwGlB,qBAAA;EACA,UAAA;EACA,YlEogDiC;ANytpBrC;;AwE1tsBA;EACE,OAAA;AxE6tsBF;;AwE1tsBA;EACE,QAAA;AxE6tsBF;;AwExtsBA;;EAEE,qBAAA;EACA,WlEsgDmC;EkErgDnC,YlEqgDmC;EkEpgDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AxE2tsBF;;AwExtsBA;EACE,6TAAA;AxE2tsBF;;AwEztsBA;EACE,4TAAA;AxE4tsBF;;AwEptsBA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBlEq9CmC;EkEp9CnC,mBAAA;EACA,gBlEm9CmC;ANmwpBrC;AwEptsBE;EACE,uBAAA;EACA,cAAA;EACA,WlEo9CiC;EkEn9CjC,WlEo9CiC;EkEn9CjC,UAAA;EACA,iBlEo9CiC;EkEn9CjC,gBlEm9CiC;EkEl9CjC,mBAAA;EACA,eAAA;EACA,wDAAA;EACA,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YlE28CiC;EC5mD/B,6BiEkKF;AxEqtsBJ;AOn3sBM;EiE6IJ;IjE5IM,gBAAA;EPs3sBN;AACF;AwEvtsBE;EACE,UlEw8CiC;ANixpBrC;;AwEhtsBA;EACE,kBAAA;EACA,UAAA;EACA,elEk8CmC;EkEj8CnC,SAAA;EACA,oBlE+7CmC;EkE97CnC,uBlE87CmC;EkE77CnC,uCAAA;EACA,kBAAA;AxEmtsBF;;AwExssBA;EALE,0CAAA;EACA,oCAAA;EACA,2DAAA;AxEitsBF;;AwE1ssBA;;EAEE,0CAAA;EACA,oCAAA;EACA,mCAAA;AxE6ssBF;;AyEn6sBA;;EAEE,qBAAA;EACA,cAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;AzEq6sBF;;AyEj6sBA;EACE;IAAK,0CAAA;EzEq6sBL;AACF;AyEl6sBA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,kCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;AzEi6sBF;;AyE95sBA;EAEE,wBAAA;EACA,yBAAA;EACA,kCAAA;AzEg6sBF;;AyEv5sBA;EACE;IACE,mBAAA;EzE05sBF;EyEx5sBA;IACE,UAAA;IACA,eAAA;EzE05sBF;AACF;AyEt5sBA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;AzEq5sBF;;AyEl5sBA;EACE,wBAAA;EACA,yBAAA;AzEq5sBF;;AyEj5sBE;EACE;;IAEE,kCAAA;EzEo5sBJ;AACF;ACr+sBE;EACE,cAAA;EACA,WAAA;EACA,WAAA;ADu+sBJ;;AE1+sBE;EACE,yBAAA;EACA,+EAAA;AF6+sBJ;;AE/+sBE;EACE,yBAAA;EACA,+EAAA;AFk/sBJ;;AEp/sBE;EACE,yBAAA;EACA,iFAAA;AFu/sBJ;;AEz/sBE;EACE,yBAAA;EACA,mFAAA;AF4/sBJ;;AE9/sBE;EACE,yBAAA;EACA,iFAAA;AFigtBJ;;AEngtBE;EACE,yBAAA;EACA,8EAAA;AFsgtBJ;;AExgtBE;EACE,yBAAA;EACA,iFAAA;AF2gtBJ;;AE7gtBE;EACE,yBAAA;EACA,gFAAA;AFghtBJ;;AElhtBE;EACE,yBAAA;EACA,8EAAA;AFqhtBJ;;AGvhtBE;EACE,sEAAA;EACA,gGAAA;AH0htBJ;AGvhtBM;EAGE,gEAAA;EACA,0FAAA;AHuhtBR;;AGhitBE;EACE,sEAAA;EACA,gGAAA;AHmitBJ;AGhitBM;EAGE,gEAAA;EACA,0FAAA;AHgitBR;;AGzitBE;EACE,wEAAA;EACA,kGAAA;AH4itBJ;AGzitBM;EAGE,+DAAA;EACA,yFAAA;AHyitBR;;AGljtBE;EACE,0EAAA;EACA,oGAAA;AHqjtBJ;AGljtBM;EAGE,gEAAA;EACA,0FAAA;AHkjtBR;;AG3jtBE;EACE,wEAAA;EACA,kGAAA;AH8jtBJ;AG3jtBM;EAGE,gEAAA;EACA,0FAAA;AH2jtBR;;AGpktBE;EACE,qEAAA;EACA,+FAAA;AHuktBJ;AGpktBM;EAGE,8DAAA;EACA,wFAAA;AHoktBR;;AG7ktBE;EACE,wEAAA;EACA,kGAAA;AHgltBJ;AG7ktBM;EAGE,+DAAA;EACA,yFAAA;AH6ktBR;;AGtltBE;EACE,uEAAA;EACA,iGAAA;AHyltBJ;AGtltBM;EAGE,gEAAA;EACA,0FAAA;AHsltBR;;AG/ltBE;EACE,qEAAA;EACA,+FAAA;AHkmtBJ;AG/ltBM;EAGE,6DAAA;EACA,uFAAA;AH+ltBR;;AGxltBA;EACE,+EAAA;EACA,yGAAA;AH2ltBF;AGxltBI;EAEE,kFAAA;EACA,4GAAA;AHyltBN;;AInntBA;EACE,UAAA;EAEA,kJAAA;AJqntBF;;AKxntBA;EACE,oBAAA;EACA,aC6c4B;ED5c5B,mBAAA;EACA,kFAAA;EACA,6BC2c4B;ED1c5B,2BAAA;AL2ntBF;AKzntBE;EACE,cAAA;EACA,UCuc0B;EDtc1B,WCsc0B;EDrc1B,kBAAA;EEIE,sCFHF;AL2ntBJ;AOpntBM;EFZJ;IEaM,gBAAA;EPuntBN;AACF;;AKzntBI;EACE,mEAAA;AL4ntBN;;AQ/otBA;EACE,kBAAA;EACA,WAAA;ARkptBF;AQhptBE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;ARkptBJ;AQ/otBE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;ARiptBJ;;AQ5otBE;EACE,uBAAA;AR+otBJ;;AQhptBE;EACE,qCAAA;ARmptBJ;;AQpptBE;EACE,sCAAA;ARuptBJ;;AQxptBE;EACE,sCAAA;AR2ptBJ;;AShrtBA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,aHumCkC;AN4krBpC;;AShrtBA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aH+lCkC;ANolrBpC;;AS3qtBI;EACE,gBAAA;EACA,MAAA;EACA,aHmlC8B;AN2lrBpC;;AS3qtBI;EACE,gBAAA;EACA,SAAA;EACA,aH6kC8B;ANimrBpC;;AU/otBI;EDxCA;IACE,gBAAA;IACA,MAAA;IACA,aHmlC8B;ENwmrBlC;;ESxrtBE;IACE,gBAAA;IACA,SAAA;IACA,aH6kC8B;EN8mrBlC;AACF;AU7ptBI;EDxCA;IACE,gBAAA;IACA,MAAA;IACA,aHmlC8B;ENqnrBlC;;ESrstBE;IACE,gBAAA;IACA,SAAA;IACA,aH6kC8B;EN2nrBlC;AACF;AU1qtBI;EDxCA;IACE,gBAAA;IACA,MAAA;IACA,aHmlC8B;ENkorBlC;;ESlttBE;IACE,gBAAA;IACA,SAAA;IACA,aH6kC8B;ENworBlC;AACF;AUvrtBI;EDxCA;IACE,gBAAA;IACA,MAAA;IACA,aHmlC8B;EN+orBlC;;ES/ttBE;IACE,gBAAA;IACA,SAAA;IACA,aH6kC8B;ENqprBlC;AACF;AUpstBI;EDxCA;IACE,gBAAA;IACA,MAAA;IACA,aHmlC8B;EN4prBlC;;ES5utBE;IACE,gBAAA;IACA,SAAA;IACA,aH6kC8B;ENkqrBlC;AACF;AW/wtBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AXixtBF;;AW9wtBA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AXixtBF;;AYzxtBA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;Ab0xtBF;AavxtBE;;EACE,6BAAA;Ab0xtBJ;AatxtBE;;EACE,2BAAA;AbyxtBJ;;Ac5ytBE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,URgcsC;EQ/btC,WAAA;Ad+ytBJ;;AevztBA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AhB2ztBF;;AiBj0tBA;EACE,qBAAA;EACA,mBAAA;EACA,6BXisB4B;EWhsB5B,eAAA;EACA,8BAAA;EACA,aX2rB4B;ANyosB9B;;AkBxwtBQ;EAOI,mCAAA;AlBqwtBZ;;AkB5wtBQ;EAOI,8BAAA;AlBywtBZ;;AkBhxtBQ;EAOI,iCAAA;AlB6wtBZ;;AkBpxtBQ;EAOI,iCAAA;AlBixtBZ;;AkBxxtBQ;EAOI,sCAAA;AlBqxtBZ;;AkB5xtBQ;EAOI,mCAAA;AlByxtBZ;;AkBhytBQ;EAOI,sBAAA;AlB6xtBZ;;AkBpytBQ;EAOI,uBAAA;AlBiytBZ;;AkBxytBQ;EAOI,sBAAA;AlBqytBZ;;AkB5ytBQ;EAOI,8BAAA;AlByytBZ;;AkBhztBQ;EAOI,4BAAA;AlB6ytBZ;;AkBpztBQ;EAOI,2BAAA;AlBiztBZ;;AkBxztBQ;EAOI,iCAAA;AlBqztBZ;;AkB5ztBQ;EAOI,2BAAA;AlByztBZ;;AkBh0tBQ;EAOI,qBAAA;AlB6ztBZ;;AkBp0tBQ;EAOI,wBAAA;AlBi0tBZ;;AkBx0tBQ;EAOI,uBAAA;AlBq0tBZ;;AkB50tBQ;EAOI,wBAAA;AlBy0tBZ;;AkBh1tBQ;EAOI,uBAAA;AlB60tBZ;;AkBp1tBQ;EAOI,wBAAA;AlBi1tBZ;;AkBx1tBQ;EAOI,uBAAA;AlBq1tBZ;;AkB51tBQ;EAOI,wBAAA;AlBy1tBZ;;AkBh2tBQ;EAOI,qBAAA;AlB61tBZ;;AkBp2tBQ;EAOI,yBAAA;AlBi2tBZ;;AkBx2tBQ;EAOI,2BAAA;AlBq2tBZ;;AkB52tBQ;EAOI,4BAAA;AlBy2tBZ;;AkBh3tBQ;EAOI,2BAAA;AlB62tBZ;;AkBp3tBQ;EAOI,2BAAA;AlBi3tBZ;;AkBx3tBQ;EAOI,6BAAA;AlBq3tBZ;;AkB53tBQ;EAOI,8BAAA;AlBy3tBZ;;AkBh4tBQ;EAOI,6BAAA;AlB63tBZ;;AkBp4tBQ;EAOI,2BAAA;AlBi4tBZ;;AkBx4tBQ;EAOI,6BAAA;AlBq4tBZ;;AkB54tBQ;EAOI,8BAAA;AlBy4tBZ;;AkBh5tBQ;EAOI,6BAAA;AlB64tBZ;;AkBp5tBQ;EAOI,0BAAA;AlBi5tBZ;;AkBx5tBQ;EAOI,gCAAA;AlBq5tBZ;;AkB55tBQ;EAOI,yBAAA;AlBy5tBZ;;AkBh6tBQ;EAOI,wBAAA;AlB65tBZ;;AkBp6tBQ;EAOI,+BAAA;AlBi6tBZ;;AkBx6tBQ;EAOI,yBAAA;AlBq6tBZ;;AkB56tBQ;EAOI,6BAAA;AlBy6tBZ;;AkBh7tBQ;EAOI,8BAAA;AlB66tBZ;;AkBp7tBQ;EAOI,wBAAA;AlBi7tBZ;;AkBx7tBQ;EAOI,+BAAA;AlBq7tBZ;;AkB57tBQ;EAOI,wBAAA;AlBy7tBZ;;AkBh8tBQ;EAOI,2CAAA;AlB67tBZ;;AkBp8tBQ;EAOI,8CAAA;AlBi8tBZ;;AkBx8tBQ;EAOI,8CAAA;AlBq8tBZ;;AkB58tBQ;EAOI,2BAAA;AlBy8tBZ;;AkB19tBQ;EACE,8EAAA;AlB69tBV;;AkB99tBQ;EACE,8EAAA;AlBi+tBV;;AkBl+tBQ;EACE,gFAAA;AlBq+tBV;;AkBt+tBQ;EACE,kFAAA;AlBy+tBV;;AkB1+tBQ;EACE,gFAAA;AlB6+tBV;;AkB9+tBQ;EACE,6EAAA;AlBi/tBV;;AkBl/tBQ;EACE,gFAAA;AlBq/tBV;;AkBt/tBQ;EACE,+EAAA;AlBy/tBV;;AkB1/tBQ;EACE,6EAAA;AlB6/tBV;;AkBp/tBQ;EAOI,2BAAA;AlBi/tBZ;;AkBx/tBQ;EAOI,6BAAA;AlBq/tBZ;;AkB5/tBQ;EAOI,6BAAA;AlBy/tBZ;;AkBhguBQ;EAOI,0BAAA;AlB6/tBZ;;AkBpguBQ;EAOI,2BAAA;AlBiguBZ;;AkBxguBQ;EAOI,iBAAA;AlBqguBZ;;AkB5guBQ;EAOI,mBAAA;AlByguBZ;;AkBhhuBQ;EAOI,mBAAA;AlB6guBZ;;AkBphuBQ;EAOI,mBAAA;AlBihuBZ;;AkBxhuBQ;EAOI,oBAAA;AlBqhuBZ;;AkB5huBQ;EAOI,oBAAA;AlByhuBZ;;AkBhiuBQ;EAOI,sBAAA;AlB6huBZ;;AkBpiuBQ;EAOI,sBAAA;AlBiiuBZ;;AkBxiuBQ;EAOI,sBAAA;AlBqiuBZ;;AkB5iuBQ;EAOI,uBAAA;AlByiuBZ;;AkBhjuBQ;EAOI,kBAAA;AlB6iuBZ;;AkBpjuBQ;EAOI,oBAAA;AlBijuBZ;;AkBxjuBQ;EAOI,oBAAA;AlBqjuBZ;;AkB5juBQ;EAOI,oBAAA;AlByjuBZ;;AkBhkuBQ;EAOI,qBAAA;AlB6juBZ;;AkBpkuBQ;EAOI,mBAAA;AlBikuBZ;;AkBxkuBQ;EAOI,qBAAA;AlBqkuBZ;;AkB5kuBQ;EAOI,qBAAA;AlBykuBZ;;AkBhluBQ;EAOI,qBAAA;AlB6kuBZ;;AkBpluBQ;EAOI,sBAAA;AlBiluBZ;;AkBxluBQ;EAOI,2CAAA;AlBqluBZ;;AkB5luBQ;EAOI,sCAAA;AlByluBZ;;AkBhmuBQ;EAOI,sCAAA;AlB6luBZ;;AkBpmuBQ;EAOI,uFAAA;AlBimuBZ;;AkBxmuBQ;EAOI,oBAAA;AlBqmuBZ;;AkB5muBQ;EAOI,2FAAA;AlBymuBZ;;AkBhnuBQ;EAOI,wBAAA;AlB6muBZ;;AkBpnuBQ;EAOI,6FAAA;AlBinuBZ;;AkBxnuBQ;EAOI,0BAAA;AlBqnuBZ;;AkB5nuBQ;EAOI,8FAAA;AlBynuBZ;;AkBhouBQ;EAOI,2BAAA;AlB6nuBZ;;AkBpouBQ;EAOI,4FAAA;AlBiouBZ;;AkBxouBQ;EAOI,yBAAA;AlBqouBZ;;AkB5ouBQ;EAIQ,sBAAA;EAGJ,4EAAA;AlB0ouBZ;;AkBjpuBQ;EAIQ,sBAAA;EAGJ,4EAAA;AlB+ouBZ;;AkBtpuBQ;EAIQ,sBAAA;EAGJ,8EAAA;AlBopuBZ;;AkB3puBQ;EAIQ,sBAAA;EAGJ,gFAAA;AlBypuBZ;;AkBhquBQ;EAIQ,sBAAA;EAGJ,8EAAA;AlB8puBZ;;AkBrquBQ;EAIQ,sBAAA;EAGJ,2EAAA;AlBmquBZ;;AkB1quBQ;EAIQ,sBAAA;EAGJ,8EAAA;AlBwquBZ;;AkB/quBQ;EAIQ,sBAAA;EAGJ,6EAAA;AlB6quBZ;;AkBpruBQ;EAIQ,sBAAA;EAGJ,2EAAA;AlBkruBZ;;AkBzruBQ;EAIQ,sBAAA;EAGJ,4EAAA;AlBuruBZ;;AkB9ruBQ;EAOI,wDAAA;AlB2ruBZ;;AkBlsuBQ;EAOI,0DAAA;AlB+ruBZ;;AkBtsuBQ;EAOI,wDAAA;AlBmsuBZ;;AkB1suBQ;EAOI,qDAAA;AlBusuBZ;;AkB9suBQ;EAOI,wDAAA;AlB2suBZ;;AkBltuBQ;EAOI,uDAAA;AlB+suBZ;;AkBttuBQ;EAOI,sDAAA;AlBmtuBZ;;AkB1tuBQ;EAOI,qDAAA;AlButuBZ;;AkB9tuBQ;EAOI,0BAAA;AlB2tuBZ;;AkBluuBQ;EAOI,4BAAA;AlB+tuBZ;;AkBtuuBQ;EAOI,4BAAA;AlBmuuBZ;;AkB1uuBQ;EAOI,4BAAA;AlBuuuBZ;;AkB9uuBQ;EAOI,4BAAA;AlB2uuBZ;;AkBlvuBQ;EAOI,4BAAA;AlB+uuBZ;;AkBhwuBQ;EACE,wBAAA;AlBmwuBV;;AkBpwuBQ;EACE,yBAAA;AlBuwuBV;;AkBxwuBQ;EACE,wBAAA;AlB2wuBV;;AkB5wuBQ;EACE,yBAAA;AlB+wuBV;;AkBhxuBQ;EACE,sBAAA;AlBmxuBV;;AkB1wuBQ;EAOI,uBAAA;AlBuwuBZ;;AkB9wuBQ;EAOI,qBAAA;AlB2wuBZ;;AkBlxuBQ;EAOI,qBAAA;AlB+wuBZ;;AkBtxuBQ;EAOI,qBAAA;AlBmxuBZ;;AkB1xuBQ;EAOI,sBAAA;AlBuxuBZ;;AkB9xuBQ;EAOI,sBAAA;AlB2xuBZ;;AkBlyuBQ;EAOI,qBAAA;AlB+xuBZ;;AkBtyuBQ;EAOI,qBAAA;AlBmyuBZ;;AkB1yuBQ;EAOI,qBAAA;AlBuyuBZ;;AkB9yuBQ;EAOI,qBAAA;AlB2yuBZ;;AkBlzuBQ;EAOI,qBAAA;AlB+yuBZ;;AkBtzuBQ;EAOI,qBAAA;AlBmzuBZ;;AkB1zuBQ;EAOI,qBAAA;AlBuzuBZ;;AkB9zuBQ;EAOI,qBAAA;AlB2zuBZ;;AkBl0uBQ;EAOI,qBAAA;AlB+zuBZ;;AkBt0uBQ;EAOI,sBAAA;AlBm0uBZ;;AkB10uBQ;EAOI,sBAAA;AlBu0uBZ;;AkB90uBQ;EAOI,sBAAA;AlB20uBZ;;AkBl1uBQ;EAOI,sBAAA;AlB+0uBZ;;AkBt1uBQ;EAOI,sBAAA;AlBm1uBZ;;AkB11uBQ;EAOI,sBAAA;AlBu1uBZ;;AkB91uBQ;EAOI,sBAAA;AlB21uBZ;;AkBl2uBQ;EAOI,sBAAA;AlB+1uBZ;;AkBt2uBQ;EAOI,sBAAA;AlBm2uBZ;;AkB12uBQ;EAOI,sBAAA;AlBu2uBZ;;AkB92uBQ;EAOI,sBAAA;AlB22uBZ;;AkBl3uBQ;EAOI,sBAAA;AlB+2uBZ;;AkBt3uBQ;EAOI,sBAAA;AlBm3uBZ;;AkB13uBQ;EAOI,sBAAA;AlBu3uBZ;;AkB93uBQ;EAOI,sBAAA;AlB23uBZ;;AkBl4uBQ;EAOI,sBAAA;AlB+3uBZ;;AkBt4uBQ;EAOI,sBAAA;AlBm4uBZ;;AkB14uBQ;EAOI,sBAAA;AlBu4uBZ;;AkB94uBQ;EAOI,uBAAA;AlB24uBZ;;AkBl5uBQ;EAOI,uBAAA;AlB+4uBZ;;AkBt5uBQ;EAOI,uBAAA;AlBm5uBZ;;AkB15uBQ;EAOI,uBAAA;AlBu5uBZ;;AkB95uBQ;EAOI,uBAAA;AlB25uBZ;;AkBl6uBQ;EAOI,uBAAA;AlB+5uBZ;;AkBt6uBQ;EAOI,uBAAA;AlBm6uBZ;;AkB16uBQ;EAOI,uBAAA;AlBu6uBZ;;AkB96uBQ;EAOI,uBAAA;AlB26uBZ;;AkBl7uBQ;EAOI,uBAAA;AlB+6uBZ;;AkBt7uBQ;EAOI,uBAAA;AlBm7uBZ;;AkB17uBQ;EAOI,uBAAA;AlBu7uBZ;;AkB97uBQ;EAOI,uBAAA;AlB27uBZ;;AkBl8uBQ;EAOI,uBAAA;AlB+7uBZ;;AkBt8uBQ;EAOI,uBAAA;AlBm8uBZ;;AkB18uBQ;EAOI,uBAAA;AlBu8uBZ;;AkB98uBQ;EAOI,uBAAA;AlB28uBZ;;AkBl9uBQ;EAOI,uBAAA;AlB+8uBZ;;AkBt9uBQ;EAOI,uBAAA;AlBm9uBZ;;AkB19uBQ;EAOI,uBAAA;AlBu9uBZ;;AkB99uBQ;EAOI,uBAAA;AlB29uBZ;;AkBl+uBQ;EAOI,uBAAA;AlB+9uBZ;;AkBt+uBQ;EAOI,uBAAA;AlBm+uBZ;;AkB1+uBQ;EAOI,uBAAA;AlBu+uBZ;;AkB9+uBQ;EAOI,uBAAA;AlB2+uBZ;;AkBl/uBQ;EAOI,uBAAA;AlB++uBZ;;AkBt/uBQ;EAOI,wBAAA;AlBm/uBZ;;AkB1/uBQ;EAOI,2BAAA;AlBu/uBZ;;AkB9/uBQ;EAOI,yBAAA;AlB2/uBZ;;AkBlgvBQ;EAOI,yBAAA;AlB+/uBZ;;AkBtgvBQ;EAOI,yBAAA;AlBmgvBZ;;AkB1gvBQ;EAOI,0BAAA;AlBugvBZ;;AkB9gvBQ;EAOI,0BAAA;AlB2gvBZ;;AkBlhvBQ;EAOI,yBAAA;AlB+gvBZ;;AkBthvBQ;EAOI,yBAAA;AlBmhvBZ;;AkB1hvBQ;EAOI,yBAAA;AlBuhvBZ;;AkB9hvBQ;EAOI,yBAAA;AlB2hvBZ;;AkBlivBQ;EAOI,yBAAA;AlB+hvBZ;;AkBtivBQ;EAOI,yBAAA;AlBmivBZ;;AkB1ivBQ;EAOI,yBAAA;AlBuivBZ;;AkB9ivBQ;EAOI,yBAAA;AlB2ivBZ;;AkBljvBQ;EAOI,yBAAA;AlB+ivBZ;;AkBtjvBQ;EAOI,0BAAA;AlBmjvBZ;;AkB1jvBQ;EAOI,0BAAA;AlBujvBZ;;AkB9jvBQ;EAOI,0BAAA;AlB2jvBZ;;AkBlkvBQ;EAOI,0BAAA;AlB+jvBZ;;AkBtkvBQ;EAOI,0BAAA;AlBmkvBZ;;AkB1kvBQ;EAOI,0BAAA;AlBukvBZ;;AkB9kvBQ;EAOI,0BAAA;AlB2kvBZ;;AkBllvBQ;EAOI,0BAAA;AlB+kvBZ;;AkBtlvBQ;EAOI,0BAAA;AlBmlvBZ;;AkB1lvBQ;EAOI,0BAAA;AlBulvBZ;;AkB9lvBQ;EAOI,0BAAA;AlB2lvBZ;;AkBlmvBQ;EAOI,0BAAA;AlB+lvBZ;;AkBtmvBQ;EAOI,0BAAA;AlBmmvBZ;;AkB1mvBQ;EAOI,0BAAA;AlBumvBZ;;AkB9mvBQ;EAOI,0BAAA;AlB2mvBZ;;AkBlnvBQ;EAOI,0BAAA;AlB+mvBZ;;AkBtnvBQ;EAOI,0BAAA;AlBmnvBZ;;AkB1nvBQ;EAOI,0BAAA;AlBunvBZ;;AkB9nvBQ;EAOI,2BAAA;AlB2nvBZ;;AkBlovBQ;EAOI,2BAAA;AlB+nvBZ;;AkBtovBQ;EAOI,2BAAA;AlBmovBZ;;AkB1ovBQ;EAOI,2BAAA;AlBuovBZ;;AkB9ovBQ;EAOI,2BAAA;AlB2ovBZ;;AkBlpvBQ;EAOI,2BAAA;AlB+ovBZ;;AkBtpvBQ;EAOI,2BAAA;AlBmpvBZ;;AkB1pvBQ;EAOI,2BAAA;AlBupvBZ;;AkB9pvBQ;EAOI,2BAAA;AlB2pvBZ;;AkBlqvBQ;EAOI,2BAAA;AlB+pvBZ;;AkBtqvBQ;EAOI,2BAAA;AlBmqvBZ;;AkB1qvBQ;EAOI,2BAAA;AlBuqvBZ;;AkB9qvBQ;EAOI,2BAAA;AlB2qvBZ;;AkBlrvBQ;EAOI,2BAAA;AlB+qvBZ;;AkBtrvBQ;EAOI,2BAAA;AlBmrvBZ;;AkB1rvBQ;EAOI,2BAAA;AlBurvBZ;;AkB9rvBQ;EAOI,2BAAA;AlB2rvBZ;;AkBlsvBQ;EAOI,2BAAA;AlB+rvBZ;;AkBtsvBQ;EAOI,2BAAA;AlBmsvBZ;;AkB1svBQ;EAOI,2BAAA;AlBusvBZ;;AkB9svBQ;EAOI,2BAAA;AlB2svBZ;;AkBltvBQ;EAOI,2BAAA;AlB+svBZ;;AkBttvBQ;EAOI,2BAAA;AlBmtvBZ;;AkB1tvBQ;EAOI,2BAAA;AlButvBZ;;AkB9tvBQ;EAOI,2BAAA;AlB2tvBZ;;AkBluvBQ;EAOI,2BAAA;AlB+tvBZ;;AkBtuvBQ;EAOI,4BAAA;AlBmuvBZ;;AkB1uvBQ;EAOI,uBAAA;AlBuuvBZ;;AkB9uvBQ;EAOI,2BAAA;AlB2uvBZ;;AkBlvvBQ;EAOI,wBAAA;AlB+uvBZ;;AkBtvvBQ;EAOI,sBAAA;AlBmvvBZ;;AkB1vvBQ;EAOI,sBAAA;AlBuvvBZ;;AkB9vvBQ;EAOI,sBAAA;AlB2vvBZ;;AkBlwvBQ;EAOI,uBAAA;AlB+vvBZ;;AkBtwvBQ;EAOI,uBAAA;AlBmwvBZ;;AkB1wvBQ;EAOI,sBAAA;AlBuwvBZ;;AkB9wvBQ;EAOI,sBAAA;AlB2wvBZ;;AkBlxvBQ;EAOI,sBAAA;AlB+wvBZ;;AkBtxvBQ;EAOI,sBAAA;AlBmxvBZ;;AkB1xvBQ;EAOI,sBAAA;AlBuxvBZ;;AkB9xvBQ;EAOI,sBAAA;AlB2xvBZ;;AkBlyvBQ;EAOI,sBAAA;AlB+xvBZ;;AkBtyvBQ;EAOI,sBAAA;AlBmyvBZ;;AkB1yvBQ;EAOI,sBAAA;AlBuyvBZ;;AkB9yvBQ;EAOI,uBAAA;AlB2yvBZ;;AkBlzvBQ;EAOI,uBAAA;AlB+yvBZ;;AkBtzvBQ;EAOI,uBAAA;AlBmzvBZ;;AkB1zvBQ;EAOI,uBAAA;AlBuzvBZ;;AkB9zvBQ;EAOI,uBAAA;AlB2zvBZ;;AkBl0vBQ;EAOI,uBAAA;AlB+zvBZ;;AkBt0vBQ;EAOI,uBAAA;AlBm0vBZ;;AkB10vBQ;EAOI,uBAAA;AlBu0vBZ;;AkB90vBQ;EAOI,uBAAA;AlB20vBZ;;AkBl1vBQ;EAOI,uBAAA;AlB+0vBZ;;AkBt1vBQ;EAOI,uBAAA;AlBm1vBZ;;AkB11vBQ;EAOI,uBAAA;AlBu1vBZ;;AkB91vBQ;EAOI,uBAAA;AlB21vBZ;;AkBl2vBQ;EAOI,uBAAA;AlB+1vBZ;;AkBt2vBQ;EAOI,uBAAA;AlBm2vBZ;;AkB12vBQ;EAOI,uBAAA;AlBu2vBZ;;AkB92vBQ;EAOI,uBAAA;AlB22vBZ;;AkBl3vBQ;EAOI,uBAAA;AlB+2vBZ;;AkBt3vBQ;EAOI,wBAAA;AlBm3vBZ;;AkB13vBQ;EAOI,wBAAA;AlBu3vBZ;;AkB93vBQ;EAOI,wBAAA;AlB23vBZ;;AkBl4vBQ;EAOI,wBAAA;AlB+3vBZ;;AkBt4vBQ;EAOI,wBAAA;AlBm4vBZ;;AkB14vBQ;EAOI,wBAAA;AlBu4vBZ;;AkB94vBQ;EAOI,wBAAA;AlB24vBZ;;AkBl5vBQ;EAOI,wBAAA;AlB+4vBZ;;AkBt5vBQ;EAOI,wBAAA;AlBm5vBZ;;AkB15vBQ;EAOI,wBAAA;AlBu5vBZ;;AkB95vBQ;EAOI,wBAAA;AlB25vBZ;;AkBl6vBQ;EAOI,wBAAA;AlB+5vBZ;;AkBt6vBQ;EAOI,wBAAA;AlBm6vBZ;;AkB16vBQ;EAOI,wBAAA;AlBu6vBZ;;AkB96vBQ;EAOI,wBAAA;AlB26vBZ;;AkBl7vBQ;EAOI,wBAAA;AlB+6vBZ;;AkBt7vBQ;EAOI,wBAAA;AlBm7vBZ;;AkB17vBQ;EAOI,wBAAA;AlBu7vBZ;;AkB97vBQ;EAOI,wBAAA;AlB27vBZ;;AkBl8vBQ;EAOI,wBAAA;AlB+7vBZ;;AkBt8vBQ;EAOI,wBAAA;AlBm8vBZ;;AkB18vBQ;EAOI,wBAAA;AlBu8vBZ;;AkB98vBQ;EAOI,wBAAA;AlB28vBZ;;AkBl9vBQ;EAOI,wBAAA;AlB+8vBZ;;AkBt9vBQ;EAOI,wBAAA;AlBm9vBZ;;AkB19vBQ;EAOI,wBAAA;AlBu9vBZ;;AkB99vBQ;EAOI,yBAAA;AlB29vBZ;;AkBl+vBQ;EAOI,4BAAA;AlB+9vBZ;;AkBt+vBQ;EAOI,0BAAA;AlBm+vBZ;;AkB1+vBQ;EAOI,0BAAA;AlBu+vBZ;;AkB9+vBQ;EAOI,0BAAA;AlB2+vBZ;;AkBl/vBQ;EAOI,2BAAA;AlB++vBZ;;AkBt/vBQ;EAOI,2BAAA;AlBm/vBZ;;AkB1/vBQ;EAOI,0BAAA;AlBu/vBZ;;AkB9/vBQ;EAOI,0BAAA;AlB2/vBZ;;AkBlgwBQ;EAOI,0BAAA;AlB+/vBZ;;AkBtgwBQ;EAOI,0BAAA;AlBmgwBZ;;AkB1gwBQ;EAOI,0BAAA;AlBugwBZ;;AkB9gwBQ;EAOI,0BAAA;AlB2gwBZ;;AkBlhwBQ;EAOI,0BAAA;AlB+gwBZ;;AkBthwBQ;EAOI,0BAAA;AlBmhwBZ;;AkB1hwBQ;EAOI,0BAAA;AlBuhwBZ;;AkB9hwBQ;EAOI,2BAAA;AlB2hwBZ;;AkBliwBQ;EAOI,2BAAA;AlB+hwBZ;;AkBtiwBQ;EAOI,2BAAA;AlBmiwBZ;;AkB1iwBQ;EAOI,2BAAA;AlBuiwBZ;;AkB9iwBQ;EAOI,2BAAA;AlB2iwBZ;;AkBljwBQ;EAOI,2BAAA;AlB+iwBZ;;AkBtjwBQ;EAOI,2BAAA;AlBmjwBZ;;AkB1jwBQ;EAOI,2BAAA;AlBujwBZ;;AkB9jwBQ;EAOI,2BAAA;AlB2jwBZ;;AkBlkwBQ;EAOI,2BAAA;AlB+jwBZ;;AkBtkwBQ;EAOI,2BAAA;AlBmkwBZ;;AkB1kwBQ;EAOI,2BAAA;AlBukwBZ;;AkB9kwBQ;EAOI,2BAAA;AlB2kwBZ;;AkBllwBQ;EAOI,2BAAA;AlB+kwBZ;;AkBtlwBQ;EAOI,2BAAA;AlBmlwBZ;;AkB1lwBQ;EAOI,2BAAA;AlBulwBZ;;AkB9lwBQ;EAOI,2BAAA;AlB2lwBZ;;AkBlmwBQ;EAOI,2BAAA;AlB+lwBZ;;AkBtmwBQ;EAOI,4BAAA;AlBmmwBZ;;AkB1mwBQ;EAOI,4BAAA;AlBumwBZ;;AkB9mwBQ;EAOI,4BAAA;AlB2mwBZ;;AkBlnwBQ;EAOI,4BAAA;AlB+mwBZ;;AkBtnwBQ;EAOI,4BAAA;AlBmnwBZ;;AkB1nwBQ;EAOI,4BAAA;AlBunwBZ;;AkB9nwBQ;EAOI,4BAAA;AlB2nwBZ;;AkBlowBQ;EAOI,4BAAA;AlB+nwBZ;;AkBtowBQ;EAOI,4BAAA;AlBmowBZ;;AkB1owBQ;EAOI,4BAAA;AlBuowBZ;;AkB9owBQ;EAOI,4BAAA;AlB2owBZ;;AkBlpwBQ;EAOI,4BAAA;AlB+owBZ;;AkBtpwBQ;EAOI,4BAAA;AlBmpwBZ;;AkB1pwBQ;EAOI,4BAAA;AlBupwBZ;;AkB9pwBQ;EAOI,4BAAA;AlB2pwBZ;;AkBlqwBQ;EAOI,4BAAA;AlB+pwBZ;;AkBtqwBQ;EAOI,4BAAA;AlBmqwBZ;;AkB1qwBQ;EAOI,4BAAA;AlBuqwBZ;;AkB9qwBQ;EAOI,4BAAA;AlB2qwBZ;;AkBlrwBQ;EAOI,4BAAA;AlB+qwBZ;;AkBtrwBQ;EAOI,4BAAA;AlBmrwBZ;;AkB1rwBQ;EAOI,4BAAA;AlBurwBZ;;AkB9rwBQ;EAOI,4BAAA;AlB2rwBZ;;AkBlswBQ;EAOI,4BAAA;AlB+rwBZ;;AkBtswBQ;EAOI,4BAAA;AlBmswBZ;;AkB1swBQ;EAOI,4BAAA;AlBuswBZ;;AkB9swBQ;EAOI,6BAAA;AlB2swBZ;;AkBltwBQ;EAOI,wBAAA;AlB+swBZ;;AkBttwBQ;EAOI,4BAAA;AlBmtwBZ;;AkB1twBQ;EAOI,yBAAA;AlButwBZ;;AkB9twBQ;EAOI,8BAAA;AlB2twBZ;;AkBluwBQ;EAOI,iCAAA;AlB+twBZ;;AkBtuwBQ;EAOI,sCAAA;AlBmuwBZ;;AkB1uwBQ;EAOI,yCAAA;AlBuuwBZ;;AkB9uwBQ;EAOI,uBAAA;AlB2uwBZ;;AkBlvwBQ;EAOI,uBAAA;AlB+uwBZ;;AkBtvwBQ;EAOI,yBAAA;AlBmvwBZ;;AkB1vwBQ;EAOI,yBAAA;AlBuvwBZ;;AkB9vwBQ;EAOI,0BAAA;AlB2vwBZ;;AkBlwwBQ;EAOI,4BAAA;AlB+vwBZ;;AkBtwwBQ;EAOI,kCAAA;AlBmwwBZ;;AkB1wwBQ;EAOI,sCAAA;AlBuwwBZ;;AkB9wwBQ;EAOI,oCAAA;AlB2wwBZ;;AkBlxwBQ;EAOI,kCAAA;AlB+wwBZ;;AkBtxwBQ;EAOI,yCAAA;AlBmxwBZ;;AkB1xwBQ;EAOI,wCAAA;AlBuxwBZ;;AkB9xwBQ;EAOI,wCAAA;AlB2xwBZ;;AkBlywBQ;EAOI,kCAAA;AlB+xwBZ;;AkBtywBQ;EAOI,gCAAA;AlBmywBZ;;AkB1ywBQ;EAOI,8BAAA;AlBuywBZ;;AkB9ywBQ;EAOI,gCAAA;AlB2ywBZ;;AkBlzwBQ;EAOI,+BAAA;AlB+ywBZ;;AkBtzwBQ;EAOI,oCAAA;AlBmzwBZ;;AkB1zwBQ;EAOI,kCAAA;AlBuzwBZ;;AkB9zwBQ;EAOI,gCAAA;AlB2zwBZ;;AkBl0wBQ;EAOI,uCAAA;AlB+zwBZ;;AkBt0wBQ;EAOI,sCAAA;AlBm0wBZ;;AkB10wBQ;EAOI,iCAAA;AlBu0wBZ;;AkB90wBQ;EAOI,2BAAA;AlB20wBZ;;AkBl1wBQ;EAOI,iCAAA;AlB+0wBZ;;AkBt1wBQ;EAOI,+BAAA;AlBm1wBZ;;AkB11wBQ;EAOI,6BAAA;AlBu1wBZ;;AkB91wBQ;EAOI,+BAAA;AlB21wBZ;;AkBl2wBQ;EAOI,8BAAA;AlB+1wBZ;;AkBt2wBQ;EAOI,oBAAA;AlBm2wBZ;;AkB12wBQ;EAOI,mBAAA;AlBu2wBZ;;AkB92wBQ;EAOI,mBAAA;AlB22wBZ;;AkBl3wBQ;EAOI,mBAAA;AlB+2wBZ;;AkBt3wBQ;EAOI,mBAAA;AlBm3wBZ;;AkB13wBQ;EAOI,mBAAA;AlBu3wBZ;;AkB93wBQ;EAOI,mBAAA;AlB23wBZ;;AkBl4wBQ;EAOI,mBAAA;AlB+3wBZ;;AkBt4wBQ;EAOI,oBAAA;AlBm4wBZ;;AkB14wBQ;EAOI,0BAAA;AlBu4wBZ;;AkB94wBQ;EAOI,yBAAA;AlB24wBZ;;AkBl5wBQ;EAOI,0BAAA;AlB+4wBZ;;AkBt5wBQ;EAOI,uBAAA;AlBm5wBZ;;AkB15wBQ;EAOI,0BAAA;AlBu5wBZ;;AkB95wBQ;EAOI,yBAAA;AlB25wBZ;;AkBl6wBQ;EAOI,0BAAA;AlB+5wBZ;;AkBt6wBQ;EAOI,uBAAA;AlBm6wBZ;;AkB16wBQ;EAOI,0BAAA;AlBu6wBZ;;AkB96wBQ;EAOI,yBAAA;AlB26wBZ;;AkBl7wBQ;EAOI,0BAAA;AlB+6wBZ;;AkBt7wBQ;EAOI,uBAAA;AlBm7wBZ;;AkB17wBQ;EAOI,0BAAA;AlBu7wBZ;;AkB97wBQ;EAOI,yBAAA;AlB27wBZ;;AkBl8wBQ;EAOI,0BAAA;AlB+7wBZ;;AkBt8wBQ;EAOI,uBAAA;AlBm8wBZ;;AkB18wBQ;EAOI,0BAAA;AlBu8wBZ;;AkB98wBQ;EAOI,yBAAA;AlB28wBZ;;AkBl9wBQ;EAOI,0BAAA;AlB+8wBZ;;AkBt9wBQ;EAOI,uBAAA;AlBm9wBZ;;AkB19wBQ;EAOI,uBAAA;AlBu9wBZ;;AkB99wBQ;EAOI,0BAAA;EAAA,yBAAA;AlB49wBZ;;AkBn+wBQ;EAOI,gCAAA;EAAA,+BAAA;AlBi+wBZ;;AkBx+wBQ;EAOI,+BAAA;EAAA,8BAAA;AlBs+wBZ;;AkB7+wBQ;EAOI,gCAAA;EAAA,+BAAA;AlB2+wBZ;;AkBl/wBQ;EAOI,6BAAA;EAAA,4BAAA;AlBg/wBZ;;AkBv/wBQ;EAOI,gCAAA;EAAA,+BAAA;AlBq/wBZ;;AkB5/wBQ;EAOI,+BAAA;EAAA,8BAAA;AlB0/wBZ;;AkBjgxBQ;EAOI,gCAAA;EAAA,+BAAA;AlB+/wBZ;;AkBtgxBQ;EAOI,6BAAA;EAAA,4BAAA;AlBogxBZ;;AkB3gxBQ;EAOI,gCAAA;EAAA,+BAAA;AlBygxBZ;;AkBhhxBQ;EAOI,+BAAA;EAAA,8BAAA;AlB8gxBZ;;AkBrhxBQ;EAOI,gCAAA;EAAA,+BAAA;AlBmhxBZ;;AkB1hxBQ;EAOI,6BAAA;EAAA,4BAAA;AlBwhxBZ;;AkB/hxBQ;EAOI,gCAAA;EAAA,+BAAA;AlB6hxBZ;;AkBpixBQ;EAOI,+BAAA;EAAA,8BAAA;AlBkixBZ;;AkBzixBQ;EAOI,gCAAA;EAAA,+BAAA;AlBuixBZ;;AkB9ixBQ;EAOI,6BAAA;EAAA,4BAAA;AlB4ixBZ;;AkBnjxBQ;EAOI,gCAAA;EAAA,+BAAA;AlBijxBZ;;AkBxjxBQ;EAOI,+BAAA;EAAA,8BAAA;AlBsjxBZ;;AkB7jxBQ;EAOI,gCAAA;EAAA,+BAAA;AlB2jxBZ;;AkBlkxBQ;EAOI,6BAAA;EAAA,4BAAA;AlBgkxBZ;;AkBvkxBQ;EAOI,6BAAA;EAAA,4BAAA;AlBqkxBZ;;AkB5kxBQ;EAOI,wBAAA;EAAA,2BAAA;AlB0kxBZ;;AkBjlxBQ;EAOI,8BAAA;EAAA,iCAAA;AlB+kxBZ;;AkBtlxBQ;EAOI,6BAAA;EAAA,gCAAA;AlBolxBZ;;AkB3lxBQ;EAOI,8BAAA;EAAA,iCAAA;AlBylxBZ;;AkBhmxBQ;EAOI,2BAAA;EAAA,8BAAA;AlB8lxBZ;;AkBrmxBQ;EAOI,8BAAA;EAAA,iCAAA;AlBmmxBZ;;AkB1mxBQ;EAOI,6BAAA;EAAA,gCAAA;AlBwmxBZ;;AkB/mxBQ;EAOI,8BAAA;EAAA,iCAAA;AlB6mxBZ;;AkBpnxBQ;EAOI,2BAAA;EAAA,8BAAA;AlBknxBZ;;AkBznxBQ;EAOI,8BAAA;EAAA,iCAAA;AlBunxBZ;;AkB9nxBQ;EAOI,6BAAA;EAAA,gCAAA;AlB4nxBZ;;AkBnoxBQ;EAOI,8BAAA;EAAA,iCAAA;AlBioxBZ;;AkBxoxBQ;EAOI,2BAAA;EAAA,8BAAA;AlBsoxBZ;;AkB7oxBQ;EAOI,8BAAA;EAAA,iCAAA;AlB2oxBZ;;AkBlpxBQ;EAOI,6BAAA;EAAA,gCAAA;AlBgpxBZ;;AkBvpxBQ;EAOI,8BAAA;EAAA,iCAAA;AlBqpxBZ;;AkB5pxBQ;EAOI,2BAAA;EAAA,8BAAA;AlB0pxBZ;;AkBjqxBQ;EAOI,8BAAA;EAAA,iCAAA;AlB+pxBZ;;AkBtqxBQ;EAOI,6BAAA;EAAA,gCAAA;AlBoqxBZ;;AkB3qxBQ;EAOI,8BAAA;EAAA,iCAAA;AlByqxBZ;;AkBhrxBQ;EAOI,2BAAA;EAAA,8BAAA;AlB8qxBZ;;AkBrrxBQ;EAOI,2BAAA;EAAA,8BAAA;AlBmrxBZ;;AkB1rxBQ;EAOI,wBAAA;AlBurxBZ;;AkB9rxBQ;EAOI,8BAAA;AlB2rxBZ;;AkBlsxBQ;EAOI,6BAAA;AlB+rxBZ;;AkBtsxBQ;EAOI,8BAAA;AlBmsxBZ;;AkB1sxBQ;EAOI,2BAAA;AlBusxBZ;;AkB9sxBQ;EAOI,8BAAA;AlB2sxBZ;;AkBltxBQ;EAOI,6BAAA;AlB+sxBZ;;AkBttxBQ;EAOI,8BAAA;AlBmtxBZ;;AkB1txBQ;EAOI,2BAAA;AlButxBZ;;AkB9txBQ;EAOI,8BAAA;AlB2txBZ;;AkBluxBQ;EAOI,6BAAA;AlB+txBZ;;AkBtuxBQ;EAOI,8BAAA;AlBmuxBZ;;AkB1uxBQ;EAOI,2BAAA;AlBuuxBZ;;AkB9uxBQ;EAOI,8BAAA;AlB2uxBZ;;AkBlvxBQ;EAOI,6BAAA;AlB+uxBZ;;AkBtvxBQ;EAOI,8BAAA;AlBmvxBZ;;AkB1vxBQ;EAOI,2BAAA;AlBuvxBZ;;AkB9vxBQ;EAOI,8BAAA;AlB2vxBZ;;AkBlwxBQ;EAOI,6BAAA;AlB+vxBZ;;AkBtwxBQ;EAOI,8BAAA;AlBmwxBZ;;AkB1wxBQ;EAOI,2BAAA;AlBuwxBZ;;AkB9wxBQ;EAOI,2BAAA;AlB2wxBZ;;AkBlxxBQ;EAOI,0BAAA;AlB+wxBZ;;AkBtxxBQ;EAOI,gCAAA;AlBmxxBZ;;AkB1xxBQ;EAOI,+BAAA;AlBuxxBZ;;AkB9xxBQ;EAOI,gCAAA;AlB2xxBZ;;AkBlyxBQ;EAOI,6BAAA;AlB+xxBZ;;AkBtyxBQ;EAOI,gCAAA;AlBmyxBZ;;AkB1yxBQ;EAOI,+BAAA;AlBuyxBZ;;AkB9yxBQ;EAOI,gCAAA;AlB2yxBZ;;AkBlzxBQ;EAOI,6BAAA;AlB+yxBZ;;AkBtzxBQ;EAOI,gCAAA;AlBmzxBZ;;AkB1zxBQ;EAOI,+BAAA;AlBuzxBZ;;AkB9zxBQ;EAOI,gCAAA;AlB2zxBZ;;AkBl0xBQ;EAOI,6BAAA;AlB+zxBZ;;AkBt0xBQ;EAOI,gCAAA;AlBm0xBZ;;AkB10xBQ;EAOI,+BAAA;AlBu0xBZ;;AkB90xBQ;EAOI,gCAAA;AlB20xBZ;;AkBl1xBQ;EAOI,6BAAA;AlB+0xBZ;;AkBt1xBQ;EAOI,gCAAA;AlBm1xBZ;;AkB11xBQ;EAOI,+BAAA;AlBu1xBZ;;AkB91xBQ;EAOI,gCAAA;AlB21xBZ;;AkBl2xBQ;EAOI,6BAAA;AlB+1xBZ;;AkBt2xBQ;EAOI,6BAAA;AlBm2xBZ;;AkB12xBQ;EAOI,2BAAA;AlBu2xBZ;;AkB92xBQ;EAOI,iCAAA;AlB22xBZ;;AkBl3xBQ;EAOI,gCAAA;AlB+2xBZ;;AkBt3xBQ;EAOI,iCAAA;AlBm3xBZ;;AkB13xBQ;EAOI,8BAAA;AlBu3xBZ;;AkB93xBQ;EAOI,iCAAA;AlB23xBZ;;AkBl4xBQ;EAOI,gCAAA;AlB+3xBZ;;AkBt4xBQ;EAOI,iCAAA;AlBm4xBZ;;AkB14xBQ;EAOI,8BAAA;AlBu4xBZ;;AkB94xBQ;EAOI,iCAAA;AlB24xBZ;;AkBl5xBQ;EAOI,gCAAA;AlB+4xBZ;;AkBt5xBQ;EAOI,iCAAA;AlBm5xBZ;;AkB15xBQ;EAOI,8BAAA;AlBu5xBZ;;AkB95xBQ;EAOI,iCAAA;AlB25xBZ;;AkBl6xBQ;EAOI,gCAAA;AlB+5xBZ;;AkBt6xBQ;EAOI,iCAAA;AlBm6xBZ;;AkB16xBQ;EAOI,8BAAA;AlBu6xBZ;;AkB96xBQ;EAOI,iCAAA;AlB26xBZ;;AkBl7xBQ;EAOI,gCAAA;AlB+6xBZ;;AkBt7xBQ;EAOI,iCAAA;AlBm7xBZ;;AkB17xBQ;EAOI,8BAAA;AlBu7xBZ;;AkB97xBQ;EAOI,8BAAA;AlB27xBZ;;AkBl8xBQ;EAOI,yBAAA;AlB+7xBZ;;AkBt8xBQ;EAOI,+BAAA;AlBm8xBZ;;AkB18xBQ;EAOI,8BAAA;AlBu8xBZ;;AkB98xBQ;EAOI,+BAAA;AlB28xBZ;;AkBl9xBQ;EAOI,4BAAA;AlB+8xBZ;;AkBt9xBQ;EAOI,+BAAA;AlBm9xBZ;;AkB19xBQ;EAOI,8BAAA;AlBu9xBZ;;AkB99xBQ;EAOI,+BAAA;AlB29xBZ;;AkBl+xBQ;EAOI,4BAAA;AlB+9xBZ;;AkBt+xBQ;EAOI,+BAAA;AlBm+xBZ;;AkB1+xBQ;EAOI,8BAAA;AlBu+xBZ;;AkB9+xBQ;EAOI,+BAAA;AlB2+xBZ;;AkBl/xBQ;EAOI,4BAAA;AlB++xBZ;;AkBt/xBQ;EAOI,+BAAA;AlBm/xBZ;;AkB1/xBQ;EAOI,8BAAA;AlBu/xBZ;;AkB9/xBQ;EAOI,+BAAA;AlB2/xBZ;;AkBlgyBQ;EAOI,4BAAA;AlB+/xBZ;;AkBtgyBQ;EAOI,+BAAA;AlBmgyBZ;;AkB1gyBQ;EAOI,8BAAA;AlBugyBZ;;AkB9gyBQ;EAOI,+BAAA;AlB2gyBZ;;AkBlhyBQ;EAOI,4BAAA;AlB+gyBZ;;AkBthyBQ;EAOI,4BAAA;AlBmhyBZ;;AkB1hyBQ;EAOI,2BAAA;AlBuhyBZ;;AkB9hyBQ;EAOI,0BAAA;AlB2hyBZ;;AkBliyBQ;EAOI,2BAAA;AlB+hyBZ;;AkBtiyBQ;EAOI,wBAAA;AlBmiyBZ;;AkB1iyBQ;EAOI,2BAAA;AlBuiyBZ;;AkB9iyBQ;EAOI,0BAAA;AlB2iyBZ;;AkBljyBQ;EAOI,2BAAA;AlB+iyBZ;;AkBtjyBQ;EAOI,wBAAA;AlBmjyBZ;;AkB1jyBQ;EAOI,2BAAA;AlBujyBZ;;AkB9jyBQ;EAOI,0BAAA;AlB2jyBZ;;AkBlkyBQ;EAOI,2BAAA;AlB+jyBZ;;AkBtkyBQ;EAOI,wBAAA;AlBmkyBZ;;AkB1kyBQ;EAOI,2BAAA;AlBukyBZ;;AkB9kyBQ;EAOI,0BAAA;AlB2kyBZ;;AkBllyBQ;EAOI,2BAAA;AlB+kyBZ;;AkBtlyBQ;EAOI,wBAAA;AlBmlyBZ;;AkB1lyBQ;EAOI,2BAAA;AlBulyBZ;;AkB9lyBQ;EAOI,0BAAA;AlB2lyBZ;;AkBlmyBQ;EAOI,2BAAA;AlB+lyBZ;;AkBtmyBQ;EAOI,wBAAA;AlBmmyBZ;;AkB1myBQ;EAOI,iCAAA;EAAA,gCAAA;AlBwmyBZ;;AkB/myBQ;EAOI,gCAAA;EAAA,+BAAA;AlB6myBZ;;AkBpnyBQ;EAOI,iCAAA;EAAA,gCAAA;AlBknyBZ;;AkBznyBQ;EAOI,8BAAA;EAAA,6BAAA;AlBunyBZ;;AkB9nyBQ;EAOI,iCAAA;EAAA,gCAAA;AlB4nyBZ;;AkBnoyBQ;EAOI,gCAAA;EAAA,+BAAA;AlBioyBZ;;AkBxoyBQ;EAOI,iCAAA;EAAA,gCAAA;AlBsoyBZ;;AkB7oyBQ;EAOI,8BAAA;EAAA,6BAAA;AlB2oyBZ;;AkBlpyBQ;EAOI,iCAAA;EAAA,gCAAA;AlBgpyBZ;;AkBvpyBQ;EAOI,gCAAA;EAAA,+BAAA;AlBqpyBZ;;AkB5pyBQ;EAOI,iCAAA;EAAA,gCAAA;AlB0pyBZ;;AkBjqyBQ;EAOI,8BAAA;EAAA,6BAAA;AlB+pyBZ;;AkBtqyBQ;EAOI,iCAAA;EAAA,gCAAA;AlBoqyBZ;;AkB3qyBQ;EAOI,gCAAA;EAAA,+BAAA;AlByqyBZ;;AkBhryBQ;EAOI,iCAAA;EAAA,gCAAA;AlB8qyBZ;;AkBrryBQ;EAOI,8BAAA;EAAA,6BAAA;AlBmryBZ;;AkB1ryBQ;EAOI,iCAAA;EAAA,gCAAA;AlBwryBZ;;AkB/ryBQ;EAOI,gCAAA;EAAA,+BAAA;AlB6ryBZ;;AkBpsyBQ;EAOI,iCAAA;EAAA,gCAAA;AlBksyBZ;;AkBzsyBQ;EAOI,8BAAA;EAAA,6BAAA;AlBusyBZ;;AkB9syBQ;EAOI,+BAAA;EAAA,kCAAA;AlB4syBZ;;AkBntyBQ;EAOI,8BAAA;EAAA,iCAAA;AlBityBZ;;AkBxtyBQ;EAOI,+BAAA;EAAA,kCAAA;AlBstyBZ;;AkB7tyBQ;EAOI,4BAAA;EAAA,+BAAA;AlB2tyBZ;;AkBluyBQ;EAOI,+BAAA;EAAA,kCAAA;AlBguyBZ;;AkBvuyBQ;EAOI,8BAAA;EAAA,iCAAA;AlBquyBZ;;AkB5uyBQ;EAOI,+BAAA;EAAA,kCAAA;AlB0uyBZ;;AkBjvyBQ;EAOI,4BAAA;EAAA,+BAAA;AlB+uyBZ;;AkBtvyBQ;EAOI,+BAAA;EAAA,kCAAA;AlBovyBZ;;AkB3vyBQ;EAOI,8BAAA;EAAA,iCAAA;AlByvyBZ;;AkBhwyBQ;EAOI,+BAAA;EAAA,kCAAA;AlB8vyBZ;;AkBrwyBQ;EAOI,4BAAA;EAAA,+BAAA;AlBmwyBZ;;AkB1wyBQ;EAOI,+BAAA;EAAA,kCAAA;AlBwwyBZ;;AkB/wyBQ;EAOI,8BAAA;EAAA,iCAAA;AlB6wyBZ;;AkBpxyBQ;EAOI,+BAAA;EAAA,kCAAA;AlBkxyBZ;;AkBzxyBQ;EAOI,4BAAA;EAAA,+BAAA;AlBuxyBZ;;AkB9xyBQ;EAOI,+BAAA;EAAA,kCAAA;AlB4xyBZ;;AkBnyyBQ;EAOI,8BAAA;EAAA,iCAAA;AlBiyyBZ;;AkBxyyBQ;EAOI,+BAAA;EAAA,kCAAA;AlBsyyBZ;;AkB7yyBQ;EAOI,4BAAA;EAAA,+BAAA;AlB2yyBZ;;AkBlzyBQ;EAOI,+BAAA;AlB+yyBZ;;AkBtzyBQ;EAOI,8BAAA;AlBmzyBZ;;AkB1zyBQ;EAOI,+BAAA;AlBuzyBZ;;AkB9zyBQ;EAOI,4BAAA;AlB2zyBZ;;AkBl0yBQ;EAOI,+BAAA;AlB+zyBZ;;AkBt0yBQ;EAOI,8BAAA;AlBm0yBZ;;AkB10yBQ;EAOI,+BAAA;AlBu0yBZ;;AkB90yBQ;EAOI,4BAAA;AlB20yBZ;;AkBl1yBQ;EAOI,+BAAA;AlB+0yBZ;;AkBt1yBQ;EAOI,8BAAA;AlBm1yBZ;;AkB11yBQ;EAOI,+BAAA;AlBu1yBZ;;AkB91yBQ;EAOI,4BAAA;AlB21yBZ;;AkBl2yBQ;EAOI,+BAAA;AlB+1yBZ;;AkBt2yBQ;EAOI,8BAAA;AlBm2yBZ;;AkB12yBQ;EAOI,+BAAA;AlBu2yBZ;;AkB92yBQ;EAOI,4BAAA;AlB22yBZ;;AkBl3yBQ;EAOI,+BAAA;AlB+2yBZ;;AkBt3yBQ;EAOI,8BAAA;AlBm3yBZ;;AkB13yBQ;EAOI,+BAAA;AlBu3yBZ;;AkB93yBQ;EAOI,4BAAA;AlB23yBZ;;AkBl4yBQ;EAOI,iCAAA;AlB+3yBZ;;AkBt4yBQ;EAOI,gCAAA;AlBm4yBZ;;AkB14yBQ;EAOI,iCAAA;AlBu4yBZ;;AkB94yBQ;EAOI,8BAAA;AlB24yBZ;;AkBl5yBQ;EAOI,iCAAA;AlB+4yBZ;;AkBt5yBQ;EAOI,gCAAA;AlBm5yBZ;;AkB15yBQ;EAOI,iCAAA;AlBu5yBZ;;AkB95yBQ;EAOI,8BAAA;AlB25yBZ;;AkBl6yBQ;EAOI,iCAAA;AlB+5yBZ;;AkBt6yBQ;EAOI,gCAAA;AlBm6yBZ;;AkB16yBQ;EAOI,iCAAA;AlBu6yBZ;;AkB96yBQ;EAOI,8BAAA;AlB26yBZ;;AkBl7yBQ;EAOI,iCAAA;AlB+6yBZ;;AkBt7yBQ;EAOI,gCAAA;AlBm7yBZ;;AkB17yBQ;EAOI,iCAAA;AlBu7yBZ;;AkB97yBQ;EAOI,8BAAA;AlB27yBZ;;AkBl8yBQ;EAOI,iCAAA;AlB+7yBZ;;AkBt8yBQ;EAOI,gCAAA;AlBm8yBZ;;AkB18yBQ;EAOI,iCAAA;AlBu8yBZ;;AkB98yBQ;EAOI,8BAAA;AlB28yBZ;;AkBl9yBQ;EAOI,kCAAA;AlB+8yBZ;;AkBt9yBQ;EAOI,iCAAA;AlBm9yBZ;;AkB19yBQ;EAOI,kCAAA;AlBu9yBZ;;AkB99yBQ;EAOI,+BAAA;AlB29yBZ;;AkBl+yBQ;EAOI,kCAAA;AlB+9yBZ;;AkBt+yBQ;EAOI,iCAAA;AlBm+yBZ;;AkB1+yBQ;EAOI,kCAAA;AlBu+yBZ;;AkB9+yBQ;EAOI,+BAAA;AlB2+yBZ;;AkBl/yBQ;EAOI,kCAAA;AlB++yBZ;;AkBt/yBQ;EAOI,iCAAA;AlBm/yBZ;;AkB1/yBQ;EAOI,kCAAA;AlBu/yBZ;;AkB9/yBQ;EAOI,+BAAA;AlB2/yBZ;;AkBlgzBQ;EAOI,kCAAA;AlB+/yBZ;;AkBtgzBQ;EAOI,iCAAA;AlBmgzBZ;;AkB1gzBQ;EAOI,kCAAA;AlBugzBZ;;AkB9gzBQ;EAOI,+BAAA;AlB2gzBZ;;AkBlhzBQ;EAOI,kCAAA;AlB+gzBZ;;AkBthzBQ;EAOI,iCAAA;AlBmhzBZ;;AkB1hzBQ;EAOI,kCAAA;AlBuhzBZ;;AkB9hzBQ;EAOI,+BAAA;AlB2hzBZ;;AkBlizBQ;EAOI,gCAAA;AlB+hzBZ;;AkBtizBQ;EAOI,+BAAA;AlBmizBZ;;AkB1izBQ;EAOI,gCAAA;AlBuizBZ;;AkB9izBQ;EAOI,6BAAA;AlB2izBZ;;AkBljzBQ;EAOI,gCAAA;AlB+izBZ;;AkBtjzBQ;EAOI,+BAAA;AlBmjzBZ;;AkB1jzBQ;EAOI,gCAAA;AlBujzBZ;;AkB9jzBQ;EAOI,6BAAA;AlB2jzBZ;;AkBlkzBQ;EAOI,gCAAA;AlB+jzBZ;;AkBtkzBQ;EAOI,+BAAA;AlBmkzBZ;;AkB1kzBQ;EAOI,gCAAA;AlBukzBZ;;AkB9kzBQ;EAOI,6BAAA;AlB2kzBZ;;AkBllzBQ;EAOI,gCAAA;AlB+kzBZ;;AkBtlzBQ;EAOI,+BAAA;AlBmlzBZ;;AkB1lzBQ;EAOI,gCAAA;AlBulzBZ;;AkB9lzBQ;EAOI,6BAAA;AlB2lzBZ;;AkBlmzBQ;EAOI,gCAAA;AlB+lzBZ;;AkBtmzBQ;EAOI,+BAAA;AlBmmzBZ;;AkB1mzBQ;EAOI,gCAAA;AlBumzBZ;;AkB9mzBQ;EAOI,6BAAA;AlB2mzBZ;;AkBlnzBQ;EAOI,qBAAA;AlB+mzBZ;;AkBtnzBQ;EAOI,2BAAA;AlBmnzBZ;;AkB1nzBQ;EAOI,0BAAA;AlBunzBZ;;AkB9nzBQ;EAOI,2BAAA;AlB2nzBZ;;AkBlozBQ;EAOI,wBAAA;AlB+nzBZ;;AkBtozBQ;EAOI,2BAAA;AlBmozBZ;;AkB1ozBQ;EAOI,0BAAA;AlBuozBZ;;AkB9ozBQ;EAOI,2BAAA;AlB2ozBZ;;AkBlpzBQ;EAOI,wBAAA;AlB+ozBZ;;AkBtpzBQ;EAOI,2BAAA;AlBmpzBZ;;AkB1pzBQ;EAOI,0BAAA;AlBupzBZ;;AkB9pzBQ;EAOI,2BAAA;AlB2pzBZ;;AkBlqzBQ;EAOI,wBAAA;AlB+pzBZ;;AkBtqzBQ;EAOI,2BAAA;AlBmqzBZ;;AkB1qzBQ;EAOI,0BAAA;AlBuqzBZ;;AkB9qzBQ;EAOI,2BAAA;AlB2qzBZ;;AkBlrzBQ;EAOI,wBAAA;AlB+qzBZ;;AkBtrzBQ;EAOI,2BAAA;AlBmrzBZ;;AkB1rzBQ;EAOI,0BAAA;AlBurzBZ;;AkB9rzBQ;EAOI,2BAAA;AlB2rzBZ;;AkBlszBQ;EAOI,wBAAA;AlB+rzBZ;;AkBtszBQ;EAOI,2BAAA;EAAA,0BAAA;AlBoszBZ;;AkB3szBQ;EAOI,iCAAA;EAAA,gCAAA;AlByszBZ;;AkBhtzBQ;EAOI,gCAAA;EAAA,+BAAA;AlB8szBZ;;AkBrtzBQ;EAOI,iCAAA;EAAA,gCAAA;AlBmtzBZ;;AkB1tzBQ;EAOI,8BAAA;EAAA,6BAAA;AlBwtzBZ;;AkB/tzBQ;EAOI,iCAAA;EAAA,gCAAA;AlB6tzBZ;;AkBpuzBQ;EAOI,gCAAA;EAAA,+BAAA;AlBkuzBZ;;AkBzuzBQ;EAOI,iCAAA;EAAA,gCAAA;AlBuuzBZ;;AkB9uzBQ;EAOI,8BAAA;EAAA,6BAAA;AlB4uzBZ;;AkBnvzBQ;EAOI,iCAAA;EAAA,gCAAA;AlBivzBZ;;AkBxvzBQ;EAOI,gCAAA;EAAA,+BAAA;AlBsvzBZ;;AkB7vzBQ;EAOI,iCAAA;EAAA,gCAAA;AlB2vzBZ;;AkBlwzBQ;EAOI,8BAAA;EAAA,6BAAA;AlBgwzBZ;;AkBvwzBQ;EAOI,iCAAA;EAAA,gCAAA;AlBqwzBZ;;AkB5wzBQ;EAOI,gCAAA;EAAA,+BAAA;AlB0wzBZ;;AkBjxzBQ;EAOI,iCAAA;EAAA,gCAAA;AlB+wzBZ;;AkBtxzBQ;EAOI,8BAAA;EAAA,6BAAA;AlBoxzBZ;;AkB3xzBQ;EAOI,iCAAA;EAAA,gCAAA;AlByxzBZ;;AkBhyzBQ;EAOI,gCAAA;EAAA,+BAAA;AlB8xzBZ;;AkBryzBQ;EAOI,iCAAA;EAAA,gCAAA;AlBmyzBZ;;AkB1yzBQ;EAOI,8BAAA;EAAA,6BAAA;AlBwyzBZ;;AkB/yzBQ;EAOI,yBAAA;EAAA,4BAAA;AlB6yzBZ;;AkBpzzBQ;EAOI,+BAAA;EAAA,kCAAA;AlBkzzBZ;;AkBzzzBQ;EAOI,8BAAA;EAAA,iCAAA;AlBuzzBZ;;AkB9zzBQ;EAOI,+BAAA;EAAA,kCAAA;AlB4zzBZ;;AkBn0zBQ;EAOI,4BAAA;EAAA,+BAAA;AlBi0zBZ;;AkBx0zBQ;EAOI,+BAAA;EAAA,kCAAA;AlBs0zBZ;;AkB70zBQ;EAOI,8BAAA;EAAA,iCAAA;AlB20zBZ;;AkBl1zBQ;EAOI,+BAAA;EAAA,kCAAA;AlBg1zBZ;;AkBv1zBQ;EAOI,4BAAA;EAAA,+BAAA;AlBq1zBZ;;AkB51zBQ;EAOI,+BAAA;EAAA,kCAAA;AlB01zBZ;;AkBj2zBQ;EAOI,8BAAA;EAAA,iCAAA;AlB+1zBZ;;AkBt2zBQ;EAOI,+BAAA;EAAA,kCAAA;AlBo2zBZ;;AkB32zBQ;EAOI,4BAAA;EAAA,+BAAA;AlBy2zBZ;;AkBh3zBQ;EAOI,+BAAA;EAAA,kCAAA;AlB82zBZ;;AkBr3zBQ;EAOI,8BAAA;EAAA,iCAAA;AlBm3zBZ;;AkB13zBQ;EAOI,+BAAA;EAAA,kCAAA;AlBw3zBZ;;AkB/3zBQ;EAOI,4BAAA;EAAA,+BAAA;AlB63zBZ;;AkBp4zBQ;EAOI,+BAAA;EAAA,kCAAA;AlBk4zBZ;;AkBz4zBQ;EAOI,8BAAA;EAAA,iCAAA;AlBu4zBZ;;AkB94zBQ;EAOI,+BAAA;EAAA,kCAAA;AlB44zBZ;;AkBn5zBQ;EAOI,4BAAA;EAAA,+BAAA;AlBi5zBZ;;AkBx5zBQ;EAOI,yBAAA;AlBq5zBZ;;AkB55zBQ;EAOI,+BAAA;AlBy5zBZ;;AkBh6zBQ;EAOI,8BAAA;AlB65zBZ;;AkBp6zBQ;EAOI,+BAAA;AlBi6zBZ;;AkBx6zBQ;EAOI,4BAAA;AlBq6zBZ;;AkB56zBQ;EAOI,+BAAA;AlBy6zBZ;;AkBh7zBQ;EAOI,8BAAA;AlB66zBZ;;AkBp7zBQ;EAOI,+BAAA;AlBi7zBZ;;AkBx7zBQ;EAOI,4BAAA;AlBq7zBZ;;AkB57zBQ;EAOI,+BAAA;AlBy7zBZ;;AkBh8zBQ;EAOI,8BAAA;AlB67zBZ;;AkBp8zBQ;EAOI,+BAAA;AlBi8zBZ;;AkBx8zBQ;EAOI,4BAAA;AlBq8zBZ;;AkB58zBQ;EAOI,+BAAA;AlBy8zBZ;;AkBh9zBQ;EAOI,8BAAA;AlB68zBZ;;AkBp9zBQ;EAOI,+BAAA;AlBi9zBZ;;AkBx9zBQ;EAOI,4BAAA;AlBq9zBZ;;AkB59zBQ;EAOI,+BAAA;AlBy9zBZ;;AkBh+zBQ;EAOI,8BAAA;AlB69zBZ;;AkBp+zBQ;EAOI,+BAAA;AlBi+zBZ;;AkBx+zBQ;EAOI,4BAAA;AlBq+zBZ;;AkB5+zBQ;EAOI,2BAAA;AlBy+zBZ;;AkBh/zBQ;EAOI,iCAAA;AlB6+zBZ;;AkBp/zBQ;EAOI,gCAAA;AlBi/zBZ;;AkBx/zBQ;EAOI,iCAAA;AlBq/zBZ;;AkB5/zBQ;EAOI,8BAAA;AlBy/zBZ;;AkBhg0BQ;EAOI,iCAAA;AlB6/zBZ;;AkBpg0BQ;EAOI,gCAAA;AlBig0BZ;;AkBxg0BQ;EAOI,iCAAA;AlBqg0BZ;;AkB5g0BQ;EAOI,8BAAA;AlByg0BZ;;AkBhh0BQ;EAOI,iCAAA;AlB6g0BZ;;AkBph0BQ;EAOI,gCAAA;AlBih0BZ;;AkBxh0BQ;EAOI,iCAAA;AlBqh0BZ;;AkB5h0BQ;EAOI,8BAAA;AlByh0BZ;;AkBhi0BQ;EAOI,iCAAA;AlB6h0BZ;;AkBpi0BQ;EAOI,gCAAA;AlBii0BZ;;AkBxi0BQ;EAOI,iCAAA;AlBqi0BZ;;AkB5i0BQ;EAOI,8BAAA;AlByi0BZ;;AkBhj0BQ;EAOI,iCAAA;AlB6i0BZ;;AkBpj0BQ;EAOI,gCAAA;AlBij0BZ;;AkBxj0BQ;EAOI,iCAAA;AlBqj0BZ;;AkB5j0BQ;EAOI,8BAAA;AlByj0BZ;;AkBhk0BQ;EAOI,4BAAA;AlB6j0BZ;;AkBpk0BQ;EAOI,kCAAA;AlBik0BZ;;AkBxk0BQ;EAOI,iCAAA;AlBqk0BZ;;AkB5k0BQ;EAOI,kCAAA;AlByk0BZ;;AkBhl0BQ;EAOI,+BAAA;AlB6k0BZ;;AkBpl0BQ;EAOI,kCAAA;AlBil0BZ;;AkBxl0BQ;EAOI,iCAAA;AlBql0BZ;;AkB5l0BQ;EAOI,kCAAA;AlByl0BZ;;AkBhm0BQ;EAOI,+BAAA;AlB6l0BZ;;AkBpm0BQ;EAOI,kCAAA;AlBim0BZ;;AkBxm0BQ;EAOI,iCAAA;AlBqm0BZ;;AkB5m0BQ;EAOI,kCAAA;AlBym0BZ;;AkBhn0BQ;EAOI,+BAAA;AlB6m0BZ;;AkBpn0BQ;EAOI,kCAAA;AlBin0BZ;;AkBxn0BQ;EAOI,iCAAA;AlBqn0BZ;;AkB5n0BQ;EAOI,kCAAA;AlByn0BZ;;AkBho0BQ;EAOI,+BAAA;AlB6n0BZ;;AkBpo0BQ;EAOI,kCAAA;AlBio0BZ;;AkBxo0BQ;EAOI,iCAAA;AlBqo0BZ;;AkB5o0BQ;EAOI,kCAAA;AlByo0BZ;;AkBhp0BQ;EAOI,+BAAA;AlB6o0BZ;;AkBpp0BQ;EAOI,0BAAA;AlBip0BZ;;AkBxp0BQ;EAOI,gCAAA;AlBqp0BZ;;AkB5p0BQ;EAOI,+BAAA;AlByp0BZ;;AkBhq0BQ;EAOI,gCAAA;AlB6p0BZ;;AkBpq0BQ;EAOI,6BAAA;AlBiq0BZ;;AkBxq0BQ;EAOI,gCAAA;AlBqq0BZ;;AkB5q0BQ;EAOI,+BAAA;AlByq0BZ;;AkBhr0BQ;EAOI,gCAAA;AlB6q0BZ;;AkBpr0BQ;EAOI,6BAAA;AlBir0BZ;;AkBxr0BQ;EAOI,gCAAA;AlBqr0BZ;;AkB5r0BQ;EAOI,+BAAA;AlByr0BZ;;AkBhs0BQ;EAOI,gCAAA;AlB6r0BZ;;AkBps0BQ;EAOI,6BAAA;AlBis0BZ;;AkBxs0BQ;EAOI,gCAAA;AlBqs0BZ;;AkB5s0BQ;EAOI,+BAAA;AlBys0BZ;;AkBht0BQ;EAOI,gCAAA;AlB6s0BZ;;AkBpt0BQ;EAOI,6BAAA;AlBit0BZ;;AkBxt0BQ;EAOI,gCAAA;AlBqt0BZ;;AkB5t0BQ;EAOI,+BAAA;AlByt0BZ;;AkBhu0BQ;EAOI,gCAAA;AlB6t0BZ;;AkBpu0BQ;EAOI,6BAAA;AlBiu0BZ;;AkBxu0BQ;EAOI,iBAAA;AlBqu0BZ;;AkB5u0BQ;EAOI,uBAAA;AlByu0BZ;;AkBhv0BQ;EAOI,sBAAA;AlB6u0BZ;;AkBpv0BQ;EAOI,uBAAA;AlBiv0BZ;;AkBxv0BQ;EAOI,oBAAA;AlBqv0BZ;;AkB5v0BQ;EAOI,uBAAA;AlByv0BZ;;AkBhw0BQ;EAOI,sBAAA;AlB6v0BZ;;AkBpw0BQ;EAOI,uBAAA;AlBiw0BZ;;AkBxw0BQ;EAOI,oBAAA;AlBqw0BZ;;AkB5w0BQ;EAOI,uBAAA;AlByw0BZ;;AkBhx0BQ;EAOI,sBAAA;AlB6w0BZ;;AkBpx0BQ;EAOI,uBAAA;AlBix0BZ;;AkBxx0BQ;EAOI,oBAAA;AlBqx0BZ;;AkB5x0BQ;EAOI,uBAAA;AlByx0BZ;;AkBhy0BQ;EAOI,sBAAA;AlB6x0BZ;;AkBpy0BQ;EAOI,uBAAA;AlBiy0BZ;;AkBxy0BQ;EAOI,oBAAA;AlBqy0BZ;;AkB5y0BQ;EAOI,uBAAA;AlByy0BZ;;AkBhz0BQ;EAOI,sBAAA;AlB6y0BZ;;AkBpz0BQ;EAOI,uBAAA;AlBiz0BZ;;AkBxz0BQ;EAOI,oBAAA;AlBqz0BZ;;AkB5z0BQ;EAOI,qBAAA;AlByz0BZ;;AkBh00BQ;EAOI,2BAAA;AlB6z0BZ;;AkBp00BQ;EAOI,0BAAA;AlBi00BZ;;AkBx00BQ;EAOI,2BAAA;AlBq00BZ;;AkB500BQ;EAOI,wBAAA;AlBy00BZ;;AkBh10BQ;EAOI,2BAAA;AlB600BZ;;AkBp10BQ;EAOI,0BAAA;AlBi10BZ;;AkBx10BQ;EAOI,2BAAA;AlBq10BZ;;AkB510BQ;EAOI,wBAAA;AlBy10BZ;;AkBh20BQ;EAOI,2BAAA;AlB610BZ;;AkBp20BQ;EAOI,0BAAA;AlBi20BZ;;AkBx20BQ;EAOI,2BAAA;AlBq20BZ;;AkB520BQ;EAOI,wBAAA;AlBy20BZ;;AkBh30BQ;EAOI,2BAAA;AlB620BZ;;AkBp30BQ;EAOI,0BAAA;AlBi30BZ;;AkBx30BQ;EAOI,2BAAA;AlBq30BZ;;AkB530BQ;EAOI,wBAAA;AlBy30BZ;;AkBh40BQ;EAOI,2BAAA;AlB630BZ;;AkBp40BQ;EAOI,0BAAA;AlBi40BZ;;AkBx40BQ;EAOI,2BAAA;AlBq40BZ;;AkB540BQ;EAOI,wBAAA;AlBy40BZ;;AkBh50BQ;EAOI,wBAAA;AlB640BZ;;AkBp50BQ;EAOI,8BAAA;AlBi50BZ;;AkBx50BQ;EAOI,6BAAA;AlBq50BZ;;AkB550BQ;EAOI,8BAAA;AlBy50BZ;;AkBh60BQ;EAOI,2BAAA;AlB650BZ;;AkBp60BQ;EAOI,8BAAA;AlBi60BZ;;AkBx60BQ;EAOI,6BAAA;AlBq60BZ;;AkB560BQ;EAOI,8BAAA;AlBy60BZ;;AkBh70BQ;EAOI,2BAAA;AlB660BZ;;AkBp70BQ;EAOI,8BAAA;AlBi70BZ;;AkBx70BQ;EAOI,6BAAA;AlBq70BZ;;AkB570BQ;EAOI,8BAAA;AlBy70BZ;;AkBh80BQ;EAOI,2BAAA;AlB670BZ;;AkBp80BQ;EAOI,8BAAA;AlBi80BZ;;AkBx80BQ;EAOI,6BAAA;AlBq80BZ;;AkB580BQ;EAOI,8BAAA;AlBy80BZ;;AkBh90BQ;EAOI,2BAAA;AlB680BZ;;AkBp90BQ;EAOI,8BAAA;AlBi90BZ;;AkBx90BQ;EAOI,6BAAA;AlBq90BZ;;AkB590BQ;EAOI,8BAAA;AlBy90BZ;;AkBh+0BQ;EAOI,2BAAA;AlB690BZ;;AkBp+0BQ;EAOI,gDAAA;AlBi+0BZ;;AkBx+0BQ;EAOI,0CAAA;AlBq+0BZ;;AkB5+0BQ;EAOI,4CAAA;AlBy+0BZ;;AkBh/0BQ;EAOI,4CAAA;AlB6+0BZ;;AkBp/0BQ;EAOI,6BAAA;AlBi/0BZ;;AkBx/0BQ;EAOI,6BAAA;AlBq/0BZ;;AkB5/0BQ;EAOI,8BAAA;AlBy/0BZ;;AkBhg1BQ;EAOI,6BAAA;AlB6/0BZ;;AkBpg1BQ;EAOI,6BAAA;AlBig1BZ;;AkBxg1BQ;EAOI,6BAAA;AlBqg1BZ;;AkB5g1BQ;EAOI,4BAAA;AlByg1BZ;;AkBhh1BQ;EAOI,0BAAA;AlB6g1BZ;;AkBph1BQ;EAOI,0BAAA;AlBih1BZ;;AkBxh1BQ;EAOI,4CAAA;AlBqh1BZ;;AkB5h1BQ;EAOI,2CAAA;AlByh1BZ;;AkBhi1BQ;EAOI,4CAAA;AlB6h1BZ;;AkBpi1BQ;EAOI,0CAAA;AlBii1BZ;;AkBxi1BQ;EAOI,4CAAA;AlBqi1BZ;;AkB5i1BQ;EAOI,2CAAA;AlByi1BZ;;AkBhj1BQ;EAOI,4CAAA;AlB6i1BZ;;AkBpj1BQ;EAOI,wCAAA;AlBij1BZ;;AkBxj1BQ;EAOI,4CAAA;AlBqj1BZ;;AkB5j1BQ;EAOI,2CAAA;AlByj1BZ;;AkBhk1BQ;EAOI,4CAAA;AlB6j1BZ;;AkBpk1BQ;EAOI,0CAAA;AlBik1BZ;;AkBxk1BQ;EAOI,4CAAA;AlBqk1BZ;;AkB5k1BQ;EAOI,2CAAA;AlByk1BZ;;AkBhl1BQ;EAOI,4CAAA;AlB6k1BZ;;AkBpl1BQ;EAOI,0CAAA;AlBil1BZ;;AkBxl1BQ;EAOI,6BAAA;AlBql1BZ;;AkB5l1BQ;EAOI,6BAAA;AlByl1BZ;;AkBhm1BQ;EAOI,+BAAA;AlB6l1BZ;;AkBpm1BQ;EAOI,2BAAA;AlBim1BZ;;AkBxm1BQ;EAOI,2BAAA;AlBqm1BZ;;AkB5m1BQ;EAOI,2BAAA;AlBym1BZ;;AkBhn1BQ;EAOI,2BAAA;AlB6m1BZ;;AkBpn1BQ;EAOI,2BAAA;AlBin1BZ;;AkBxn1BQ;EAOI,2BAAA;AlBqn1BZ;;AkB5n1BQ;EAOI,yBAAA;AlByn1BZ;;AkBho1BQ;EAOI,yBAAA;AlB6n1BZ;;AkBpo1BQ;EAOI,4BAAA;AlBio1BZ;;AkBxo1BQ;EAOI,2BAAA;AlBqo1BZ;;AkB5o1BQ;EAOI,4BAAA;AlByo1BZ;;AkBhp1BQ;EAOI,yBAAA;AlB6o1BZ;;AkBpp1BQ;EAOI,4BAAA;AlBip1BZ;;AkBxp1BQ;EAOI,2BAAA;AlBqp1BZ;;AkB5p1BQ;EAOI,4BAAA;AlByp1BZ;;AkBhq1BQ;EAOI,6BAAA;AlB6p1BZ;;AkBpq1BQ;EAOI,gCAAA;AlBiq1BZ;;AkBxq1BQ;EAOI,qCAAA;AlBqq1BZ;;AkB5q1BQ;EAOI,wCAAA;AlByq1BZ;;AkBhr1BQ;EAOI,oCAAA;AlB6q1BZ;;AkBpr1BQ;EAOI,oCAAA;AlBir1BZ;;AkBxr1BQ;EAOI,qCAAA;AlBqr1BZ;;AkB5r1BQ;EAOI,8BAAA;AlByr1BZ;;AkBhs1BQ;EAOI,8BAAA;AlB6r1BZ;;AkBlt1BQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AlBms1BZ;;AkBhr1BQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,mEAAA;AlBys1BZ;;AkBht1BQ;EAIQ,oBAAA;EAGJ,mEAAA;AlB8s1BZ;;AkBrt1BQ;EAIQ,oBAAA;EAGJ,qEAAA;AlBmt1BZ;;AkB1t1BQ;EAIQ,oBAAA;EAGJ,uEAAA;AlBwt1BZ;;AkB/t1BQ;EAIQ,oBAAA;EAGJ,qEAAA;AlB6t1BZ;;AkBpu1BQ;EAIQ,oBAAA;EAGJ,kEAAA;AlBku1BZ;;AkBzu1BQ;EAIQ,oBAAA;EAGJ,qEAAA;AlBuu1BZ;;AkB9u1BQ;EAIQ,oBAAA;EAGJ,oEAAA;AlB4u1BZ;;AkBnv1BQ;EAIQ,oBAAA;EAGJ,kEAAA;AlBiv1BZ;;AkBxv1BQ;EAIQ,oBAAA;EAGJ,mEAAA;AlBsv1BZ;;AkB7v1BQ;EAIQ,oBAAA;EAGJ,wEAAA;AlB2v1BZ;;AkBlw1BQ;EAIQ,oBAAA;EAGJ,2CAAA;AlBgw1BZ;;AkBvw1BQ;EAIQ,oBAAA;EAGJ,oCAAA;AlBqw1BZ;;AkB5w1BQ;EAIQ,oBAAA;EAGJ,0CAAA;AlB0w1BZ;;AkBjx1BQ;EAIQ,oBAAA;EAGJ,2CAAA;AlB+w1BZ;;AkBtx1BQ;EAIQ,oBAAA;EAGJ,0CAAA;AlBox1BZ;;AkB3x1BQ;EAIQ,oBAAA;EAGJ,0CAAA;AlByx1BZ;;AkBhy1BQ;EAIQ,oBAAA;EAGJ,yBAAA;AlB8x1BZ;;AkB/y1BQ;EACE,uBAAA;AlBkz1BV;;AkBnz1BQ;EACE,sBAAA;AlBsz1BV;;AkBvz1BQ;EACE,uBAAA;AlB0z1BV;;AkB3z1BQ;EACE,oBAAA;AlB8z1BV;;AkBrz1BQ;EAOI,iDAAA;AlBkz1BZ;;AkBzz1BQ;EAOI,mDAAA;AlBsz1BZ;;AkB7z1BQ;EAOI,iDAAA;AlB0z1BZ;;AkBj01BQ;EAOI,8CAAA;AlB8z1BZ;;AkBr01BQ;EAOI,iDAAA;AlBk01BZ;;AkBz01BQ;EAOI,gDAAA;AlBs01BZ;;AkB701BQ;EAOI,+CAAA;AlB001BZ;;AkBj11BQ;EAOI,8CAAA;AlB801BZ;;AkB/11BQ;EACE,sBAAA;AlBk21BV;;AkB911BU;EACE,sBAAA;AlBi21BZ;;AkBv21BQ;EACE,uBAAA;AlB021BV;;AkBt21BU;EACE,uBAAA;AlBy21BZ;;AkB/21BQ;EACE,sBAAA;AlBk31BV;;AkB921BU;EACE,sBAAA;AlBi31BZ;;AkBv31BQ;EACE,uBAAA;AlB031BV;;AkBt31BU;EACE,uBAAA;AlBy31BZ;;AkB/31BQ;EACE,oBAAA;AlBk41BV;;AkB931BU;EACE,oBAAA;AlBi41BZ;;AkB731BQ;EAOI,yCAAA;AlB031BZ;;AkBr31BU;EAOI,yCAAA;AlBk31Bd;;AkBr41BQ;EAOI,wCAAA;AlBk41BZ;;AkB731BU;EAOI,wCAAA;AlB031Bd;;AkB741BQ;EAOI,yCAAA;AlB041BZ;;AkBr41BU;EAOI,yCAAA;AlBk41Bd;;AkBr51BQ;EAIQ,8BAAA;EAGJ,6FAAA;AlBm51BZ;;AkB151BQ;EAIQ,8BAAA;EAGJ,6FAAA;AlBw51BZ;;AkB/51BQ;EAIQ,8BAAA;EAGJ,+FAAA;AlB651BZ;;AkBp61BQ;EAIQ,8BAAA;EAGJ,iGAAA;AlBk61BZ;;AkBz61BQ;EAIQ,8BAAA;EAGJ,+FAAA;AlBu61BZ;;AkB961BQ;EAIQ,8BAAA;EAGJ,4FAAA;AlB461BZ;;AkBn71BQ;EAIQ,8BAAA;EAGJ,+FAAA;AlBi71BZ;;AkBx71BQ;EAIQ,8BAAA;EAGJ,8FAAA;AlBs71BZ;;AkB771BQ;EAIQ,8BAAA;EAGJ,4FAAA;AlB271BZ;;AkBl81BQ;EAIQ,8BAAA;EAGJ,qGAAA;AlBg81BZ;;AkBj91BQ;EACE,8BAAA;AlBo91BV;;AkBh91BU;EACE,8BAAA;AlBm91BZ;;AkBz91BQ;EACE,gCAAA;AlB491BV;;AkBx91BU;EACE,gCAAA;AlB291BZ;;AkBj+1BQ;EACE,iCAAA;AlBo+1BV;;AkBh+1BU;EACE,iCAAA;AlBm+1BZ;;AkBz+1BQ;EACE,gCAAA;AlB4+1BV;;AkBx+1BU;EACE,gCAAA;AlB2+1BZ;;AkBj/1BQ;EACE,iCAAA;AlBo/1BV;;AkBh/1BU;EACE,iCAAA;AlBm/1BZ;;AkBz/1BQ;EACE,8BAAA;AlB4/1BV;;AkBx/1BU;EACE,8BAAA;AlB2/1BZ;;AkBv/1BQ;EAIQ,kBAAA;EAGJ,4EAAA;AlBq/1BZ;;AkB5/1BQ;EAIQ,kBAAA;EAGJ,4EAAA;AlB0/1BZ;;AkBjg2BQ;EAIQ,kBAAA;EAGJ,8EAAA;AlB+/1BZ;;AkBtg2BQ;EAIQ,kBAAA;EAGJ,gFAAA;AlBog2BZ;;AkB3g2BQ;EAIQ,kBAAA;EAGJ,8EAAA;AlByg2BZ;;AkBhh2BQ;EAIQ,kBAAA;EAGJ,2EAAA;AlB8g2BZ;;AkBrh2BQ;EAIQ,kBAAA;EAGJ,8EAAA;AlBmh2BZ;;AkB1h2BQ;EAIQ,kBAAA;EAGJ,6EAAA;AlBwh2BZ;;AkB/h2BQ;EAIQ,kBAAA;EAGJ,2EAAA;AlB6h2BZ;;AkBpi2BQ;EAIQ,kBAAA;EAGJ,4EAAA;AlBki2BZ;;AkBzi2BQ;EAIQ,kBAAA;EAGJ,8EAAA;AlBui2BZ;;AkB9i2BQ;EAIQ,kBAAA;EAGJ,wCAAA;AlB4i2BZ;;AkBnj2BQ;EAIQ,kBAAA;EAGJ,mFAAA;AlBij2BZ;;AkBxj2BQ;EAIQ,kBAAA;EAGJ,kFAAA;AlBsj2BZ;;AkBvk2BQ;EACE,oBAAA;AlB0k2BV;;AkB3k2BQ;EACE,qBAAA;AlB8k2BV;;AkB/k2BQ;EACE,oBAAA;AlBkl2BV;;AkBnl2BQ;EACE,qBAAA;AlBsl2BV;;AkBvl2BQ;EACE,kBAAA;AlB0l2BV;;AkBjl2BQ;EAOI,wDAAA;AlB8k2BZ;;AkBrl2BQ;EAOI,0DAAA;AlBkl2BZ;;AkBzl2BQ;EAOI,wDAAA;AlBsl2BZ;;AkB7l2BQ;EAOI,qDAAA;AlB0l2BZ;;AkBjm2BQ;EAOI,wDAAA;AlB8l2BZ;;AkBrm2BQ;EAOI,uDAAA;AlBkm2BZ;;AkBzm2BQ;EAOI,sDAAA;AlBsm2BZ;;AkB7m2BQ;EAOI,qDAAA;AlB0m2BZ;;AkBjn2BQ;EAOI,+CAAA;AlB8m2BZ;;AkBrn2BQ;EAOI,mCAAA;UAAA,2BAAA;AlBkn2BZ;;AkBzn2BQ;EAOI,oCAAA;UAAA,4BAAA;AlBsn2BZ;;AkB7n2BQ;EAOI,oCAAA;UAAA,4BAAA;AlB0n2BZ;;AkBjo2BQ;EAOI,+BAAA;AlB8n2BZ;;AkBro2BQ;EAOI,+BAAA;AlBko2BZ;;AkBzo2BQ;EAOI,iDAAA;AlBso2BZ;;AkB7o2BQ;EAOI,2BAAA;AlB0o2BZ;;AkBjp2BQ;EAOI,oDAAA;AlB8o2BZ;;AkBrp2BQ;EAOI,iDAAA;AlBkp2BZ;;AkBzp2BQ;EAOI,oDAAA;AlBsp2BZ;;AkB7p2BQ;EAOI,oDAAA;AlB0p2BZ;;AkBjq2BQ;EAOI,qDAAA;AlB8p2BZ;;AkBrq2BQ;EAOI,6BAAA;AlBkq2BZ;;AkBzq2BQ;EAOI,sDAAA;AlBsq2BZ;;AkB7q2BQ;EAOI,0DAAA;EAAA,2DAAA;AlB2q2BZ;;AkBlr2BQ;EAOI,oCAAA;EAAA,qCAAA;AlBgr2BZ;;AkBvr2BQ;EAOI,6DAAA;EAAA,8DAAA;AlBqr2BZ;;AkB5r2BQ;EAOI,0DAAA;EAAA,2DAAA;AlB0r2BZ;;AkBjs2BQ;EAOI,6DAAA;EAAA,8DAAA;AlB+r2BZ;;AkBts2BQ;EAOI,6DAAA;EAAA,8DAAA;AlBos2BZ;;AkB3s2BQ;EAOI,8DAAA;EAAA,+DAAA;AlBys2BZ;;AkBht2BQ;EAOI,sCAAA;EAAA,uCAAA;AlB8s2BZ;;AkBrt2BQ;EAOI,+DAAA;EAAA,gEAAA;AlBmt2BZ;;AkB1t2BQ;EAOI,2DAAA;EAAA,8DAAA;AlBwt2BZ;;AkB/t2BQ;EAOI,qCAAA;EAAA,wCAAA;AlB6t2BZ;;AkBpu2BQ;EAOI,8DAAA;EAAA,iEAAA;AlBku2BZ;;AkBzu2BQ;EAOI,2DAAA;EAAA,8DAAA;AlBuu2BZ;;AkB9u2BQ;EAOI,8DAAA;EAAA,iEAAA;AlB4u2BZ;;AkBnv2BQ;EAOI,8DAAA;EAAA,iEAAA;AlBiv2BZ;;AkBxv2BQ;EAOI,+DAAA;EAAA,kEAAA;AlBsv2BZ;;AkB7v2BQ;EAOI,uCAAA;EAAA,0CAAA;AlB2v2BZ;;AkBlw2BQ;EAOI,gEAAA;EAAA,mEAAA;AlBgw2BZ;;AkBvw2BQ;EAOI,8DAAA;EAAA,6DAAA;AlBqw2BZ;;AkB5w2BQ;EAOI,wCAAA;EAAA,uCAAA;AlB0w2BZ;;AkBjx2BQ;EAOI,iEAAA;EAAA,gEAAA;AlB+w2BZ;;AkBtx2BQ;EAOI,8DAAA;EAAA,6DAAA;AlBox2BZ;;AkB3x2BQ;EAOI,iEAAA;EAAA,gEAAA;AlByx2BZ;;AkBhy2BQ;EAOI,iEAAA;EAAA,gEAAA;AlB8x2BZ;;AkBry2BQ;EAOI,kEAAA;EAAA,iEAAA;AlBmy2BZ;;AkB1y2BQ;EAOI,0CAAA;EAAA,yCAAA;AlBwy2BZ;;AkB/y2BQ;EAOI,mEAAA;EAAA,kEAAA;AlB6y2BZ;;AkBpz2BQ;EAOI,6DAAA;EAAA,0DAAA;AlBkz2BZ;;AkBzz2BQ;EAOI,uCAAA;EAAA,oCAAA;AlBuz2BZ;;AkB9z2BQ;EAOI,gEAAA;EAAA,6DAAA;AlB4z2BZ;;AkBn02BQ;EAOI,6DAAA;EAAA,0DAAA;AlBi02BZ;;AkBx02BQ;EAOI,gEAAA;EAAA,6DAAA;AlBs02BZ;;AkB702BQ;EAOI,gEAAA;EAAA,6DAAA;AlB202BZ;;AkBl12BQ;EAOI,iEAAA;EAAA,8DAAA;AlBg12BZ;;AkBv12BQ;EAOI,yCAAA;EAAA,sCAAA;AlBq12BZ;;AkB512BQ;EAOI,kEAAA;EAAA,+DAAA;AlB012BZ;;AkBj22BQ;EAOI,8BAAA;AlB812BZ;;AkBr22BQ;EAOI,6BAAA;AlBk22BZ;;AkBz22BQ;EAOI,sBAAA;AlBs22BZ;;AkB722BQ;EAOI,sBAAA;AlB022BZ;;AkBj32BQ;EAOI,qBAAA;AlB822BZ;;AkBr32BQ;EAOI,qBAAA;AlBk32BZ;;AkBz32BQ;EAOI,qBAAA;AlBs32BZ;;AkB732BQ;EAOI,qBAAA;AlB032BZ;;AkBj42BQ;EAOI,qBAAA;AlB832BZ;;AkBz32BU;EAOI,qBAAA;AlBs32Bd;;AkBz42BQ;EAOI,wBAAA;AlBs42BZ;;AkBj42BU;EAOI,wBAAA;AlB832Bd;;AkBj52BQ;EAOI,uBAAA;AlB842BZ;;AkBz42BU;EAOI,uBAAA;AlBs42Bd;;AkBz52BQ;EAOI,wBAAA;AlBs52BZ;;AkBj52BU;EAOI,wBAAA;AlB842Bd;;AkBj62BQ;EAOI,uBAAA;AlB852BZ;;AkBz52BU;EAOI,uBAAA;AlBs52Bd;;AkBz62BQ;EAOI,wBAAA;AlBs62BZ;;AkBj62BU;EAOI,wBAAA;AlB852Bd;;AkBj72BQ;EAOI,uBAAA;AlB862BZ;;AkBz62BU;EAOI,uBAAA;AlBs62Bd;;AkBz72BQ;EAOI,wBAAA;AlBs72BZ;;AkBj72BU;EAOI,wBAAA;AlB862Bd;;AkBj82BQ;EAOI,qBAAA;AlB872BZ;;AkBz72BU;EAOI,qBAAA;AlBs72Bd;;AkBz82BQ;EAOI,2BAAA;AlBs82BZ;;AkB782BQ;EAOI,yBAAA;AlB082BZ;;AkBj92BQ;EAOI,yBAAA;AlB882BZ;;AkBr92BQ;EAOI,yBAAA;AlBk92BZ;;AkBz92BQ;EAOI,0BAAA;AlBs92BZ;;AkB792BQ;EAOI,0BAAA;AlB092BZ;;AkBj+2BQ;EAOI,yBAAA;AlB892BZ;;AkBr+2BQ;EAOI,yBAAA;AlBk+2BZ;;AkBz+2BQ;EAOI,yBAAA;AlBs+2BZ;;AkB7+2BQ;EAOI,yBAAA;AlB0+2BZ;;AkBj/2BQ;EAOI,yBAAA;AlB8+2BZ;;AkBr/2BQ;EAOI,yBAAA;AlBk/2BZ;;AkBz/2BQ;EAOI,yBAAA;AlBs/2BZ;;AkB7/2BQ;EAOI,yBAAA;AlB0/2BZ;;AkBjg3BQ;EAOI,yBAAA;AlB8/2BZ;;AkBrg3BQ;EAOI,0BAAA;AlBkg3BZ;;AkBzg3BQ;EAOI,0BAAA;AlBsg3BZ;;AkB7g3BQ;EAOI,0BAAA;AlB0g3BZ;;AkBjh3BQ;EAOI,0BAAA;AlB8g3BZ;;AkBrh3BQ;EAOI,0BAAA;AlBkh3BZ;;AkBzh3BQ;EAOI,0BAAA;AlBsh3BZ;;AkB7h3BQ;EAOI,0BAAA;AlB0h3BZ;;AkBji3BQ;EAOI,0BAAA;AlB8h3BZ;;AkBri3BQ;EAOI,0BAAA;AlBki3BZ;;AkBzi3BQ;EAOI,0BAAA;AlBsi3BZ;;AkB7i3BQ;EAOI,0BAAA;AlB0i3BZ;;AkBjj3BQ;EAOI,0BAAA;AlB8i3BZ;;AkBrj3BQ;EAOI,0BAAA;AlBkj3BZ;;AkBzj3BQ;EAOI,0BAAA;AlBsj3BZ;;AkB7j3BQ;EAOI,0BAAA;AlB0j3BZ;;AkBjk3BQ;EAOI,0BAAA;AlB8j3BZ;;AkBrk3BQ;EAOI,0BAAA;AlBkk3BZ;;AkBzk3BQ;EAOI,0BAAA;AlBsk3BZ;;AkB7k3BQ;EAOI,2BAAA;AlB0k3BZ;;AkBjl3BQ;EAOI,2BAAA;AlB8k3BZ;;AkBrl3BQ;EAOI,2BAAA;AlBkl3BZ;;AkBzl3BQ;EAOI,2BAAA;AlBsl3BZ;;AkB7l3BQ;EAOI,2BAAA;AlB0l3BZ;;AkBjm3BQ;EAOI,2BAAA;AlB8l3BZ;;AkBrm3BQ;EAOI,2BAAA;AlBkm3BZ;;AkBzm3BQ;EAOI,2BAAA;AlBsm3BZ;;AkB7m3BQ;EAOI,2BAAA;AlB0m3BZ;;AkBjn3BQ;EAOI,2BAAA;AlB8m3BZ;;AkBrn3BQ;EAOI,2BAAA;AlBkn3BZ;;AkBzn3BQ;EAOI,2BAAA;AlBsn3BZ;;AkB7n3BQ;EAOI,2BAAA;AlB0n3BZ;;AkBjo3BQ;EAOI,2BAAA;AlB8n3BZ;;AkBro3BQ;EAOI,2BAAA;AlBko3BZ;;AkBzo3BQ;EAOI,2BAAA;AlBso3BZ;;AkB7o3BQ;EAOI,2BAAA;AlB0o3BZ;;AkBjp3BQ;EAOI,2BAAA;AlB8o3BZ;;AkBrp3BQ;EAOI,2BAAA;AlBkp3BZ;;AkBzp3BQ;EAOI,2BAAA;AlBsp3BZ;;AkB7p3BQ;EAOI,2BAAA;AlB0p3BZ;;AkBjq3BQ;EAOI,2BAAA;AlB8p3BZ;;AkBrq3BQ;EAOI,2BAAA;AlBkq3BZ;;AkBzq3BQ;EAOI,2BAAA;AlBsq3BZ;;AkB7q3BQ;EAOI,2BAAA;AlB0q3BZ;;AkBjr3BQ;EAOI,2BAAA;AlB8q3BZ;;AkBrr3BQ;EAOI,4BAAA;AlBkr3BZ;;AkBzr3BQ;EAOI,4BAAA;AlBsr3BZ;;AkB7r3BQ;EAOI,0BAAA;AlB0r3BZ;;AkBjs3BQ;EAOI,0BAAA;AlB8r3BZ;;AkBrs3BQ;EAOI,0BAAA;AlBks3BZ;;AkBzs3BQ;EAOI,2BAAA;AlBss3BZ;;AkB7s3BQ;EAOI,2BAAA;AlB0s3BZ;;AkBjt3BQ;EAOI,0BAAA;AlB8s3BZ;;AkBrt3BQ;EAOI,0BAAA;AlBkt3BZ;;AkBzt3BQ;EAOI,0BAAA;AlBst3BZ;;AkB7t3BQ;EAOI,0BAAA;AlB0t3BZ;;AkBju3BQ;EAOI,0BAAA;AlB8t3BZ;;AkBru3BQ;EAOI,0BAAA;AlBku3BZ;;AkBzu3BQ;EAOI,0BAAA;AlBsu3BZ;;AkB7u3BQ;EAOI,0BAAA;AlB0u3BZ;;AkBjv3BQ;EAOI,0BAAA;AlB8u3BZ;;AkBrv3BQ;EAOI,2BAAA;AlBkv3BZ;;AkBzv3BQ;EAOI,2BAAA;AlBsv3BZ;;AkB7v3BQ;EAOI,2BAAA;AlB0v3BZ;;AkBjw3BQ;EAOI,2BAAA;AlB8v3BZ;;AkBrw3BQ;EAOI,2BAAA;AlBkw3BZ;;AkBzw3BQ;EAOI,2BAAA;AlBsw3BZ;;AkB7w3BQ;EAOI,2BAAA;AlB0w3BZ;;AkBjx3BQ;EAOI,2BAAA;AlB8w3BZ;;AkBrx3BQ;EAOI,2BAAA;AlBkx3BZ;;AkBzx3BQ;EAOI,2BAAA;AlBsx3BZ;;AkB7x3BQ;EAOI,2BAAA;AlB0x3BZ;;AkBjy3BQ;EAOI,2BAAA;AlB8x3BZ;;AkBry3BQ;EAOI,2BAAA;AlBky3BZ;;AkBzy3BQ;EAOI,2BAAA;AlBsy3BZ;;AkB7y3BQ;EAOI,2BAAA;AlB0y3BZ;;AkBjz3BQ;EAOI,2BAAA;AlB8y3BZ;;AkBrz3BQ;EAOI,2BAAA;AlBkz3BZ;;AkBzz3BQ;EAOI,2BAAA;AlBsz3BZ;;AkB7z3BQ;EAOI,4BAAA;AlB0z3BZ;;AkBj03BQ;EAOI,4BAAA;AlB8z3BZ;;AkBr03BQ;EAOI,4BAAA;AlBk03BZ;;AkBz03BQ;EAOI,4BAAA;AlBs03BZ;;AkB703BQ;EAOI,4BAAA;AlB003BZ;;AkBj13BQ;EAOI,4BAAA;AlB803BZ;;AkBr13BQ;EAOI,4BAAA;AlBk13BZ;;AkBz13BQ;EAOI,4BAAA;AlBs13BZ;;AkB713BQ;EAOI,4BAAA;AlB013BZ;;AkBj23BQ;EAOI,4BAAA;AlB813BZ;;AkBr23BQ;EAOI,4BAAA;AlBk23BZ;;AkBz23BQ;EAOI,4BAAA;AlBs23BZ;;AkB723BQ;EAOI,4BAAA;AlB023BZ;;AkBj33BQ;EAOI,4BAAA;AlB823BZ;;AkBr33BQ;EAOI,4BAAA;AlBk33BZ;;AkBz33BQ;EAOI,4BAAA;AlBs33BZ;;AkB733BQ;EAOI,4BAAA;AlB033BZ;;AkBj43BQ;EAOI,4BAAA;AlB833BZ;;AkBr43BQ;EAOI,4BAAA;AlBk43BZ;;AkBz43BQ;EAOI,4BAAA;AlBs43BZ;;AkB743BQ;EAOI,4BAAA;AlB043BZ;;AkBj53BQ;EAOI,4BAAA;AlB843BZ;;AkBr53BQ;EAOI,4BAAA;AlBk53BZ;;AkBz53BQ;EAOI,4BAAA;AlBs53BZ;;AkB753BQ;EAOI,4BAAA;AlB053BZ;;AkBj63BQ;EAOI,4BAAA;AlB853BZ;;AkBr63BQ;EAOI,6BAAA;AlBk63BZ;;AkBz63BQ;EAOI,8BAAA;AlBs63BZ;;AkB763BQ;EAOI,gCAAA;AlB063BZ;;AkBj73BQ;EAOI,gCAAA;AlB863BZ;;AkBr73BQ;EAOI,gCAAA;AlBk73BZ;;AkBz73BQ;EAOI,gCAAA;AlBs73BZ;;AkB773BQ;EAOI,gCAAA;AlB073BZ;;AkBj83BQ;EAOI,iCAAA;AlB873BZ;;AkBr83BQ;EAOI,mCAAA;AlBk83BZ;;AkBz83BQ;EAOI,mCAAA;AlBs83BZ;;AkB783BQ;EAOI,mCAAA;AlB083BZ;;AkBj93BQ;EAOI,mCAAA;AlB883BZ;;AkBr93BQ;EAOI,mCAAA;AlBk93BZ;;AkBz93BQ;EAOI,gCAAA;AlBs93BZ;;AkB793BQ;EAOI,kCAAA;AlB093BZ;;AkBj+3BQ;EAOI,kCAAA;AlB893BZ;;AkBr+3BQ;EAOI,kCAAA;AlBk+3BZ;;AkBz+3BQ;EAOI,kCAAA;AlBs+3BZ;;AkB7+3BQ;EAOI,kCAAA;AlB0+3BZ;;AkBj/3BQ;EAOI,+BAAA;AlB8+3BZ;;AkBr/3BQ;EAOI,iCAAA;AlBk/3BZ;;AkBz/3BQ;EAOI,iCAAA;AlBs/3BZ;;AkB7/3BQ;EAOI,iCAAA;AlB0/3BZ;;AkBjg4BQ;EAOI,iCAAA;AlB8/3BZ;;AkBrg4BQ;EAOI,iCAAA;AlBkg4BZ;;AkBzg4BQ;EAOI,iCAAA;AlBsg4BZ;;AkB7g4BQ;EAOI,mCAAA;AlB0g4BZ;;AkBjh4BQ;EAOI,mCAAA;AlB8g4BZ;;AkBrh4BQ;EAOI,kCAAA;AlBkh4BZ;;AkBzh4BQ;EAOI,iCAAA;AlBsh4BZ;;AUhi4BI;EQGI;IAOI,sBAAA;ElB2h4BV;;EkBli4BM;IAOI,uBAAA;ElB+h4BV;;EkBti4BM;IAOI,sBAAA;ElBmi4BV;;EkB1i4BM;IAOI,8BAAA;ElBui4BV;;EkB9i4BM;IAOI,4BAAA;ElB2i4BV;;EkBlj4BM;IAOI,2BAAA;ElB+i4BV;;EkBtj4BM;IAOI,iCAAA;ElBmj4BV;;EkB1j4BM;IAOI,2BAAA;ElBuj4BV;;EkB9j4BM;IAOI,0BAAA;ElB2j4BV;;EkBlk4BM;IAOI,gCAAA;ElB+j4BV;;EkBtk4BM;IAOI,yBAAA;ElBmk4BV;;EkB1k4BM;IAOI,wBAAA;ElBuk4BV;;EkB9k4BM;IAOI,+BAAA;ElB2k4BV;;EkBll4BM;IAOI,yBAAA;ElB+k4BV;;EkBtl4BM;IAOI,6BAAA;ElBml4BV;;EkB1l4BM;IAOI,8BAAA;ElBul4BV;;EkB9l4BM;IAOI,wBAAA;ElB2l4BV;;EkBlm4BM;IAOI,+BAAA;ElB+l4BV;;EkBtm4BM;IAOI,wBAAA;ElBmm4BV;;EkB1m4BM;IAOI,2BAAA;ElBum4BV;;EkB9m4BM;IAOI,6BAAA;ElB2m4BV;;EkBln4BM;IAOI,6BAAA;ElB+m4BV;;EkBtn4BM;IAOI,0BAAA;ElBmn4BV;;EkB1n4BM;IAOI,2BAAA;ElBun4BV;;EkB9n4BM;IAOI,uBAAA;ElB2n4BV;;EkBlo4BM;IAOI,qBAAA;ElB+n4BV;;EkBto4BM;IAOI,qBAAA;ElBmo4BV;;EkB1o4BM;IAOI,qBAAA;ElBuo4BV;;EkB9o4BM;IAOI,sBAAA;ElB2o4BV;;EkBlp4BM;IAOI,sBAAA;ElB+o4BV;;EkBtp4BM;IAOI,qBAAA;ElBmp4BV;;EkB1p4BM;IAOI,qBAAA;ElBup4BV;;EkB9p4BM;IAOI,qBAAA;ElB2p4BV;;EkBlq4BM;IAOI,qBAAA;ElB+p4BV;;EkBtq4BM;IAOI,qBAAA;ElBmq4BV;;EkB1q4BM;IAOI,qBAAA;ElBuq4BV;;EkB9q4BM;IAOI,qBAAA;ElB2q4BV;;EkBlr4BM;IAOI,qBAAA;ElB+q4BV;;EkBtr4BM;IAOI,qBAAA;ElBmr4BV;;EkB1r4BM;IAOI,sBAAA;ElBur4BV;;EkB9r4BM;IAOI,sBAAA;ElB2r4BV;;EkBls4BM;IAOI,sBAAA;ElB+r4BV;;EkBts4BM;IAOI,sBAAA;ElBms4BV;;EkB1s4BM;IAOI,sBAAA;ElBus4BV;;EkB9s4BM;IAOI,sBAAA;ElB2s4BV;;EkBlt4BM;IAOI,sBAAA;ElB+s4BV;;EkBtt4BM;IAOI,sBAAA;ElBmt4BV;;EkB1t4BM;IAOI,sBAAA;ElBut4BV;;EkB9t4BM;IAOI,sBAAA;ElB2t4BV;;EkBlu4BM;IAOI,sBAAA;ElB+t4BV;;EkBtu4BM;IAOI,sBAAA;ElBmu4BV;;EkB1u4BM;IAOI,sBAAA;ElBuu4BV;;EkB9u4BM;IAOI,sBAAA;ElB2u4BV;;EkBlv4BM;IAOI,sBAAA;ElB+u4BV;;EkBtv4BM;IAOI,sBAAA;ElBmv4BV;;EkB1v4BM;IAOI,sBAAA;ElBuv4BV;;EkB9v4BM;IAOI,sBAAA;ElB2v4BV;;EkBlw4BM;IAOI,uBAAA;ElB+v4BV;;EkBtw4BM;IAOI,uBAAA;ElBmw4BV;;EkB1w4BM;IAOI,uBAAA;ElBuw4BV;;EkB9w4BM;IAOI,uBAAA;ElB2w4BV;;EkBlx4BM;IAOI,uBAAA;ElB+w4BV;;EkBtx4BM;IAOI,uBAAA;ElBmx4BV;;EkB1x4BM;IAOI,uBAAA;ElBux4BV;;EkB9x4BM;IAOI,uBAAA;ElB2x4BV;;EkBly4BM;IAOI,uBAAA;ElB+x4BV;;EkBty4BM;IAOI,uBAAA;ElBmy4BV;;EkB1y4BM;IAOI,uBAAA;ElBuy4BV;;EkB9y4BM;IAOI,uBAAA;ElB2y4BV;;EkBlz4BM;IAOI,uBAAA;ElB+y4BV;;EkBtz4BM;IAOI,uBAAA;ElBmz4BV;;EkB1z4BM;IAOI,uBAAA;ElBuz4BV;;EkB9z4BM;IAOI,uBAAA;ElB2z4BV;;EkBl04BM;IAOI,uBAAA;ElB+z4BV;;EkBt04BM;IAOI,uBAAA;ElBm04BV;;EkB104BM;IAOI,uBAAA;ElBu04BV;;EkB904BM;IAOI,uBAAA;ElB204BV;;EkBl14BM;IAOI,uBAAA;ElB+04BV;;EkBt14BM;IAOI,uBAAA;ElBm14BV;;EkB114BM;IAOI,uBAAA;ElBu14BV;;EkB914BM;IAOI,uBAAA;ElB214BV;;EkBl24BM;IAOI,uBAAA;ElB+14BV;;EkBt24BM;IAOI,uBAAA;ElBm24BV;;EkB124BM;IAOI,wBAAA;ElBu24BV;;EkB924BM;IAOI,2BAAA;ElB224BV;;EkBl34BM;IAOI,yBAAA;ElB+24BV;;EkBt34BM;IAOI,yBAAA;ElBm34BV;;EkB134BM;IAOI,yBAAA;ElBu34BV;;EkB934BM;IAOI,0BAAA;ElB234BV;;EkBl44BM;IAOI,0BAAA;ElB+34BV;;EkBt44BM;IAOI,yBAAA;ElBm44BV;;EkB144BM;IAOI,yBAAA;ElBu44BV;;EkB944BM;IAOI,yBAAA;ElB244BV;;EkBl54BM;IAOI,yBAAA;ElB+44BV;;EkBt54BM;IAOI,yBAAA;ElBm54BV;;EkB154BM;IAOI,yBAAA;ElBu54BV;;EkB954BM;IAOI,yBAAA;ElB254BV;;EkBl64BM;IAOI,yBAAA;ElB+54BV;;EkBt64BM;IAOI,yBAAA;ElBm64BV;;EkB164BM;IAOI,0BAAA;ElBu64BV;;EkB964BM;IAOI,0BAAA;ElB264BV;;EkBl74BM;IAOI,0BAAA;ElB+64BV;;EkBt74BM;IAOI,0BAAA;ElBm74BV;;EkB174BM;IAOI,0BAAA;ElBu74BV;;EkB974BM;IAOI,0BAAA;ElB274BV;;EkBl84BM;IAOI,0BAAA;ElB+74BV;;EkBt84BM;IAOI,0BAAA;ElBm84BV;;EkB184BM;IAOI,0BAAA;ElBu84BV;;EkB984BM;IAOI,0BAAA;ElB284BV;;EkBl94BM;IAOI,0BAAA;ElB+84BV;;EkBt94BM;IAOI,0BAAA;ElBm94BV;;EkB194BM;IAOI,0BAAA;ElBu94BV;;EkB994BM;IAOI,0BAAA;ElB294BV;;EkBl+4BM;IAOI,0BAAA;ElB+94BV;;EkBt+4BM;IAOI,0BAAA;ElBm+4BV;;EkB1+4BM;IAOI,0BAAA;ElBu+4BV;;EkB9+4BM;IAOI,0BAAA;ElB2+4BV;;EkBl/4BM;IAOI,2BAAA;ElB++4BV;;EkBt/4BM;IAOI,2BAAA;ElBm/4BV;;EkB1/4BM;IAOI,2BAAA;ElBu/4BV;;EkB9/4BM;IAOI,2BAAA;ElB2/4BV;;EkBlg5BM;IAOI,2BAAA;ElB+/4BV;;EkBtg5BM;IAOI,2BAAA;ElBmg5BV;;EkB1g5BM;IAOI,2BAAA;ElBug5BV;;EkB9g5BM;IAOI,2BAAA;ElB2g5BV;;EkBlh5BM;IAOI,2BAAA;ElB+g5BV;;EkBth5BM;IAOI,2BAAA;ElBmh5BV;;EkB1h5BM;IAOI,2BAAA;ElBuh5BV;;EkB9h5BM;IAOI,2BAAA;ElB2h5BV;;EkBli5BM;IAOI,2BAAA;ElB+h5BV;;EkBti5BM;IAOI,2BAAA;ElBmi5BV;;EkB1i5BM;IAOI,2BAAA;ElBui5BV;;EkB9i5BM;IAOI,2BAAA;ElB2i5BV;;EkBlj5BM;IAOI,2BAAA;ElB+i5BV;;EkBtj5BM;IAOI,2BAAA;ElBmj5BV;;EkB1j5BM;IAOI,2BAAA;ElBuj5BV;;EkB9j5BM;IAOI,2BAAA;ElB2j5BV;;EkBlk5BM;IAOI,2BAAA;ElB+j5BV;;EkBtk5BM;IAOI,2BAAA;ElBmk5BV;;EkB1k5BM;IAOI,2BAAA;ElBuk5BV;;EkB9k5BM;IAOI,2BAAA;ElB2k5BV;;EkBll5BM;IAOI,2BAAA;ElB+k5BV;;EkBtl5BM;IAOI,2BAAA;ElBml5BV;;EkB1l5BM;IAOI,4BAAA;ElBul5BV;;EkB9l5BM;IAOI,wBAAA;ElB2l5BV;;EkBlm5BM;IAOI,sBAAA;ElB+l5BV;;EkBtm5BM;IAOI,sBAAA;ElBmm5BV;;EkB1m5BM;IAOI,sBAAA;ElBum5BV;;EkB9m5BM;IAOI,uBAAA;ElB2m5BV;;EkBln5BM;IAOI,uBAAA;ElB+m5BV;;EkBtn5BM;IAOI,sBAAA;ElBmn5BV;;EkB1n5BM;IAOI,sBAAA;ElBun5BV;;EkB9n5BM;IAOI,sBAAA;ElB2n5BV;;EkBlo5BM;IAOI,sBAAA;ElB+n5BV;;EkBto5BM;IAOI,sBAAA;ElBmo5BV;;EkB1o5BM;IAOI,sBAAA;ElBuo5BV;;EkB9o5BM;IAOI,sBAAA;ElB2o5BV;;EkBlp5BM;IAOI,sBAAA;ElB+o5BV;;EkBtp5BM;IAOI,sBAAA;ElBmp5BV;;EkB1p5BM;IAOI,uBAAA;ElBup5BV;;EkB9p5BM;IAOI,uBAAA;ElB2p5BV;;EkBlq5BM;IAOI,uBAAA;ElB+p5BV;;EkBtq5BM;IAOI,uBAAA;ElBmq5BV;;EkB1q5BM;IAOI,uBAAA;ElBuq5BV;;EkB9q5BM;IAOI,uBAAA;ElB2q5BV;;EkBlr5BM;IAOI,uBAAA;ElB+q5BV;;EkBtr5BM;IAOI,uBAAA;ElBmr5BV;;EkB1r5BM;IAOI,uBAAA;ElBur5BV;;EkB9r5BM;IAOI,uBAAA;ElB2r5BV;;EkBls5BM;IAOI,uBAAA;ElB+r5BV;;EkBts5BM;IAOI,uBAAA;ElBms5BV;;EkB1s5BM;IAOI,uBAAA;ElBus5BV;;EkB9s5BM;IAOI,uBAAA;ElB2s5BV;;EkBlt5BM;IAOI,uBAAA;ElB+s5BV;;EkBtt5BM;IAOI,uBAAA;ElBmt5BV;;EkB1t5BM;IAOI,uBAAA;ElBut5BV;;EkB9t5BM;IAOI,uBAAA;ElB2t5BV;;EkBlu5BM;IAOI,wBAAA;ElB+t5BV;;EkBtu5BM;IAOI,wBAAA;ElBmu5BV;;EkB1u5BM;IAOI,wBAAA;ElBuu5BV;;EkB9u5BM;IAOI,wBAAA;ElB2u5BV;;EkBlv5BM;IAOI,wBAAA;ElB+u5BV;;EkBtv5BM;IAOI,wBAAA;ElBmv5BV;;EkB1v5BM;IAOI,wBAAA;ElBuv5BV;;EkB9v5BM;IAOI,wBAAA;ElB2v5BV;;EkBlw5BM;IAOI,wBAAA;ElB+v5BV;;EkBtw5BM;IAOI,wBAAA;ElBmw5BV;;EkB1w5BM;IAOI,wBAAA;ElBuw5BV;;EkB9w5BM;IAOI,wBAAA;ElB2w5BV;;EkBlx5BM;IAOI,wBAAA;ElB+w5BV;;EkBtx5BM;IAOI,wBAAA;ElBmx5BV;;EkB1x5BM;IAOI,wBAAA;ElBux5BV;;EkB9x5BM;IAOI,wBAAA;ElB2x5BV;;EkBly5BM;IAOI,wBAAA;ElB+x5BV;;EkBty5BM;IAOI,wBAAA;ElBmy5BV;;EkB1y5BM;IAOI,wBAAA;ElBuy5BV;;EkB9y5BM;IAOI,wBAAA;ElB2y5BV;;EkBlz5BM;IAOI,wBAAA;ElB+y5BV;;EkBtz5BM;IAOI,wBAAA;ElBmz5BV;;EkB1z5BM;IAOI,wBAAA;ElBuz5BV;;EkB9z5BM;IAOI,wBAAA;ElB2z5BV;;EkBl05BM;IAOI,wBAAA;ElB+z5BV;;EkBt05BM;IAOI,wBAAA;ElBm05BV;;EkB105BM;IAOI,yBAAA;ElBu05BV;;EkB905BM;IAOI,4BAAA;ElB205BV;;EkBl15BM;IAOI,0BAAA;ElB+05BV;;EkBt15BM;IAOI,0BAAA;ElBm15BV;;EkB115BM;IAOI,0BAAA;ElBu15BV;;EkB915BM;IAOI,2BAAA;ElB215BV;;EkBl25BM;IAOI,2BAAA;ElB+15BV;;EkBt25BM;IAOI,0BAAA;ElBm25BV;;EkB125BM;IAOI,0BAAA;ElBu25BV;;EkB925BM;IAOI,0BAAA;ElB225BV;;EkBl35BM;IAOI,0BAAA;ElB+25BV;;EkBt35BM;IAOI,0BAAA;ElBm35BV;;EkB135BM;IAOI,0BAAA;ElBu35BV;;EkB935BM;IAOI,0BAAA;ElB235BV;;EkBl45BM;IAOI,0BAAA;ElB+35BV;;EkBt45BM;IAOI,0BAAA;ElBm45BV;;EkB145BM;IAOI,2BAAA;ElBu45BV;;EkB945BM;IAOI,2BAAA;ElB245BV;;EkBl55BM;IAOI,2BAAA;ElB+45BV;;EkBt55BM;IAOI,2BAAA;ElBm55BV;;EkB155BM;IAOI,2BAAA;ElBu55BV;;EkB955BM;IAOI,2BAAA;ElB255BV;;EkBl65BM;IAOI,2BAAA;ElB+55BV;;EkBt65BM;IAOI,2BAAA;ElBm65BV;;EkB165BM;IAOI,2BAAA;ElBu65BV;;EkB965BM;IAOI,2BAAA;ElB265BV;;EkBl75BM;IAOI,2BAAA;ElB+65BV;;EkBt75BM;IAOI,2BAAA;ElBm75BV;;EkB175BM;IAOI,2BAAA;ElBu75BV;;EkB975BM;IAOI,2BAAA;ElB275BV;;EkBl85BM;IAOI,2BAAA;ElB+75BV;;EkBt85BM;IAOI,2BAAA;ElBm85BV;;EkB185BM;IAOI,2BAAA;ElBu85BV;;EkB985BM;IAOI,2BAAA;ElB285BV;;EkBl95BM;IAOI,4BAAA;ElB+85BV;;EkBt95BM;IAOI,4BAAA;ElBm95BV;;EkB195BM;IAOI,4BAAA;ElBu95BV;;EkB995BM;IAOI,4BAAA;ElB295BV;;EkBl+5BM;IAOI,4BAAA;ElB+95BV;;EkBt+5BM;IAOI,4BAAA;ElBm+5BV;;EkB1+5BM;IAOI,4BAAA;ElBu+5BV;;EkB9+5BM;IAOI,4BAAA;ElB2+5BV;;EkBl/5BM;IAOI,4BAAA;ElB++5BV;;EkBt/5BM;IAOI,4BAAA;ElBm/5BV;;EkB1/5BM;IAOI,4BAAA;ElBu/5BV;;EkB9/5BM;IAOI,4BAAA;ElB2/5BV;;EkBlg6BM;IAOI,4BAAA;ElB+/5BV;;EkBtg6BM;IAOI,4BAAA;ElBmg6BV;;EkB1g6BM;IAOI,4BAAA;ElBug6BV;;EkB9g6BM;IAOI,4BAAA;ElB2g6BV;;EkBlh6BM;IAOI,4BAAA;ElB+g6BV;;EkBth6BM;IAOI,4BAAA;ElBmh6BV;;EkB1h6BM;IAOI,4BAAA;ElBuh6BV;;EkB9h6BM;IAOI,4BAAA;ElB2h6BV;;EkBli6BM;IAOI,4BAAA;ElB+h6BV;;EkBti6BM;IAOI,4BAAA;ElBmi6BV;;EkB1i6BM;IAOI,4BAAA;ElBui6BV;;EkB9i6BM;IAOI,4BAAA;ElB2i6BV;;EkBlj6BM;IAOI,4BAAA;ElB+i6BV;;EkBtj6BM;IAOI,4BAAA;ElBmj6BV;;EkB1j6BM;IAOI,6BAAA;ElBuj6BV;;EkB9j6BM;IAOI,yBAAA;ElB2j6BV;;EkBlk6BM;IAOI,8BAAA;ElB+j6BV;;EkBtk6BM;IAOI,iCAAA;ElBmk6BV;;EkB1k6BM;IAOI,sCAAA;ElBuk6BV;;EkB9k6BM;IAOI,yCAAA;ElB2k6BV;;EkBll6BM;IAOI,uBAAA;ElB+k6BV;;EkBtl6BM;IAOI,uBAAA;ElBml6BV;;EkB1l6BM;IAOI,yBAAA;ElBul6BV;;EkB9l6BM;IAOI,yBAAA;ElB2l6BV;;EkBlm6BM;IAOI,0BAAA;ElB+l6BV;;EkBtm6BM;IAOI,4BAAA;ElBmm6BV;;EkB1m6BM;IAOI,kCAAA;ElBum6BV;;EkB9m6BM;IAOI,sCAAA;ElB2m6BV;;EkBln6BM;IAOI,oCAAA;ElB+m6BV;;EkBtn6BM;IAOI,kCAAA;ElBmn6BV;;EkB1n6BM;IAOI,yCAAA;ElBun6BV;;EkB9n6BM;IAOI,wCAAA;ElB2n6BV;;EkBlo6BM;IAOI,wCAAA;ElB+n6BV;;EkBto6BM;IAOI,kCAAA;ElBmo6BV;;EkB1o6BM;IAOI,gCAAA;ElBuo6BV;;EkB9o6BM;IAOI,8BAAA;ElB2o6BV;;EkBlp6BM;IAOI,gCAAA;ElB+o6BV;;EkBtp6BM;IAOI,+BAAA;ElBmp6BV;;EkB1p6BM;IAOI,oCAAA;ElBup6BV;;EkB9p6BM;IAOI,kCAAA;ElB2p6BV;;EkBlq6BM;IAOI,gCAAA;ElB+p6BV;;EkBtq6BM;IAOI,uCAAA;ElBmq6BV;;EkB1q6BM;IAOI,sCAAA;ElBuq6BV;;EkB9q6BM;IAOI,iCAAA;ElB2q6BV;;EkBlr6BM;IAOI,2BAAA;ElB+q6BV;;EkBtr6BM;IAOI,iCAAA;ElBmr6BV;;EkB1r6BM;IAOI,+BAAA;ElBur6BV;;EkB9r6BM;IAOI,6BAAA;ElB2r6BV;;EkBls6BM;IAOI,+BAAA;ElB+r6BV;;EkBts6BM;IAOI,8BAAA;ElBms6BV;;EkB1s6BM;IAOI,oBAAA;ElBus6BV;;EkB9s6BM;IAOI,mBAAA;ElB2s6BV;;EkBlt6BM;IAOI,mBAAA;ElB+s6BV;;EkBtt6BM;IAOI,mBAAA;ElBmt6BV;;EkB1t6BM;IAOI,mBAAA;ElBut6BV;;EkB9t6BM;IAOI,mBAAA;ElB2t6BV;;EkBlu6BM;IAOI,mBAAA;ElB+t6BV;;EkBtu6BM;IAOI,mBAAA;ElBmu6BV;;EkB1u6BM;IAOI,oBAAA;ElBuu6BV;;EkB9u6BM;IAOI,0BAAA;ElB2u6BV;;EkBlv6BM;IAOI,yBAAA;ElB+u6BV;;EkBtv6BM;IAOI,0BAAA;ElBmv6BV;;EkB1v6BM;IAOI,uBAAA;ElBuv6BV;;EkB9v6BM;IAOI,0BAAA;ElB2v6BV;;EkBlw6BM;IAOI,yBAAA;ElB+v6BV;;EkBtw6BM;IAOI,0BAAA;ElBmw6BV;;EkB1w6BM;IAOI,uBAAA;ElBuw6BV;;EkB9w6BM;IAOI,0BAAA;ElB2w6BV;;EkBlx6BM;IAOI,yBAAA;ElB+w6BV;;EkBtx6BM;IAOI,0BAAA;ElBmx6BV;;EkB1x6BM;IAOI,uBAAA;ElBux6BV;;EkB9x6BM;IAOI,0BAAA;ElB2x6BV;;EkBly6BM;IAOI,yBAAA;ElB+x6BV;;EkBty6BM;IAOI,0BAAA;ElBmy6BV;;EkB1y6BM;IAOI,uBAAA;ElBuy6BV;;EkB9y6BM;IAOI,0BAAA;ElB2y6BV;;EkBlz6BM;IAOI,yBAAA;ElB+y6BV;;EkBtz6BM;IAOI,0BAAA;ElBmz6BV;;EkB1z6BM;IAOI,uBAAA;ElBuz6BV;;EkB9z6BM;IAOI,uBAAA;ElB2z6BV;;EkBl06BM;IAOI,0BAAA;IAAA,yBAAA;ElBg06BV;;EkBv06BM;IAOI,gCAAA;IAAA,+BAAA;ElBq06BV;;EkB506BM;IAOI,+BAAA;IAAA,8BAAA;ElB006BV;;EkBj16BM;IAOI,gCAAA;IAAA,+BAAA;ElB+06BV;;EkBt16BM;IAOI,6BAAA;IAAA,4BAAA;ElBo16BV;;EkB316BM;IAOI,gCAAA;IAAA,+BAAA;ElBy16BV;;EkBh26BM;IAOI,+BAAA;IAAA,8BAAA;ElB816BV;;EkBr26BM;IAOI,gCAAA;IAAA,+BAAA;ElBm26BV;;EkB126BM;IAOI,6BAAA;IAAA,4BAAA;ElBw26BV;;EkB/26BM;IAOI,gCAAA;IAAA,+BAAA;ElB626BV;;EkBp36BM;IAOI,+BAAA;IAAA,8BAAA;ElBk36BV;;EkBz36BM;IAOI,gCAAA;IAAA,+BAAA;ElBu36BV;;EkB936BM;IAOI,6BAAA;IAAA,4BAAA;ElB436BV;;EkBn46BM;IAOI,gCAAA;IAAA,+BAAA;ElBi46BV;;EkBx46BM;IAOI,+BAAA;IAAA,8BAAA;ElBs46BV;;EkB746BM;IAOI,gCAAA;IAAA,+BAAA;ElB246BV;;EkBl56BM;IAOI,6BAAA;IAAA,4BAAA;ElBg56BV;;EkBv56BM;IAOI,gCAAA;IAAA,+BAAA;ElBq56BV;;EkB556BM;IAOI,+BAAA;IAAA,8BAAA;ElB056BV;;EkBj66BM;IAOI,gCAAA;IAAA,+BAAA;ElB+56BV;;EkBt66BM;IAOI,6BAAA;IAAA,4BAAA;ElBo66BV;;EkB366BM;IAOI,6BAAA;IAAA,4BAAA;ElBy66BV;;EkBh76BM;IAOI,wBAAA;IAAA,2BAAA;ElB866BV;;EkBr76BM;IAOI,8BAAA;IAAA,iCAAA;ElBm76BV;;EkB176BM;IAOI,6BAAA;IAAA,gCAAA;ElBw76BV;;EkB/76BM;IAOI,8BAAA;IAAA,iCAAA;ElB676BV;;EkBp86BM;IAOI,2BAAA;IAAA,8BAAA;ElBk86BV;;EkBz86BM;IAOI,8BAAA;IAAA,iCAAA;ElBu86BV;;EkB986BM;IAOI,6BAAA;IAAA,gCAAA;ElB486BV;;EkBn96BM;IAOI,8BAAA;IAAA,iCAAA;ElBi96BV;;EkBx96BM;IAOI,2BAAA;IAAA,8BAAA;ElBs96BV;;EkB796BM;IAOI,8BAAA;IAAA,iCAAA;ElB296BV;;EkBl+6BM;IAOI,6BAAA;IAAA,gCAAA;ElBg+6BV;;EkBv+6BM;IAOI,8BAAA;IAAA,iCAAA;ElBq+6BV;;EkB5+6BM;IAOI,2BAAA;IAAA,8BAAA;ElB0+6BV;;EkBj/6BM;IAOI,8BAAA;IAAA,iCAAA;ElB++6BV;;EkBt/6BM;IAOI,6BAAA;IAAA,gCAAA;ElBo/6BV;;EkB3/6BM;IAOI,8BAAA;IAAA,iCAAA;ElBy/6BV;;EkBhg7BM;IAOI,2BAAA;IAAA,8BAAA;ElB8/6BV;;EkBrg7BM;IAOI,8BAAA;IAAA,iCAAA;ElBmg7BV;;EkB1g7BM;IAOI,6BAAA;IAAA,gCAAA;ElBwg7BV;;EkB/g7BM;IAOI,8BAAA;IAAA,iCAAA;ElB6g7BV;;EkBph7BM;IAOI,2BAAA;IAAA,8BAAA;ElBkh7BV;;EkBzh7BM;IAOI,2BAAA;IAAA,8BAAA;ElBuh7BV;;EkB9h7BM;IAOI,wBAAA;ElB2h7BV;;EkBli7BM;IAOI,8BAAA;ElB+h7BV;;EkBti7BM;IAOI,6BAAA;ElBmi7BV;;EkB1i7BM;IAOI,8BAAA;ElBui7BV;;EkB9i7BM;IAOI,2BAAA;ElB2i7BV;;EkBlj7BM;IAOI,8BAAA;ElB+i7BV;;EkBtj7BM;IAOI,6BAAA;ElBmj7BV;;EkB1j7BM;IAOI,8BAAA;ElBuj7BV;;EkB9j7BM;IAOI,2BAAA;ElB2j7BV;;EkBlk7BM;IAOI,8BAAA;ElB+j7BV;;EkBtk7BM;IAOI,6BAAA;ElBmk7BV;;EkB1k7BM;IAOI,8BAAA;ElBuk7BV;;EkB9k7BM;IAOI,2BAAA;ElB2k7BV;;EkBll7BM;IAOI,8BAAA;ElB+k7BV;;EkBtl7BM;IAOI,6BAAA;ElBml7BV;;EkB1l7BM;IAOI,8BAAA;ElBul7BV;;EkB9l7BM;IAOI,2BAAA;ElB2l7BV;;EkBlm7BM;IAOI,8BAAA;ElB+l7BV;;EkBtm7BM;IAOI,6BAAA;ElBmm7BV;;EkB1m7BM;IAOI,8BAAA;ElBum7BV;;EkB9m7BM;IAOI,2BAAA;ElB2m7BV;;EkBln7BM;IAOI,2BAAA;ElB+m7BV;;EkBtn7BM;IAOI,0BAAA;ElBmn7BV;;EkB1n7BM;IAOI,gCAAA;ElBun7BV;;EkB9n7BM;IAOI,+BAAA;ElB2n7BV;;EkBlo7BM;IAOI,gCAAA;ElB+n7BV;;EkBto7BM;IAOI,6BAAA;ElBmo7BV;;EkB1o7BM;IAOI,gCAAA;ElBuo7BV;;EkB9o7BM;IAOI,+BAAA;ElB2o7BV;;EkBlp7BM;IAOI,gCAAA;ElB+o7BV;;EkBtp7BM;IAOI,6BAAA;ElBmp7BV;;EkB1p7BM;IAOI,gCAAA;ElBup7BV;;EkB9p7BM;IAOI,+BAAA;ElB2p7BV;;EkBlq7BM;IAOI,gCAAA;ElB+p7BV;;EkBtq7BM;IAOI,6BAAA;ElBmq7BV;;EkB1q7BM;IAOI,gCAAA;ElBuq7BV;;EkB9q7BM;IAOI,+BAAA;ElB2q7BV;;EkBlr7BM;IAOI,gCAAA;ElB+q7BV;;EkBtr7BM;IAOI,6BAAA;ElBmr7BV;;EkB1r7BM;IAOI,gCAAA;ElBur7BV;;EkB9r7BM;IAOI,+BAAA;ElB2r7BV;;EkBls7BM;IAOI,gCAAA;ElB+r7BV;;EkBts7BM;IAOI,6BAAA;ElBms7BV;;EkB1s7BM;IAOI,6BAAA;ElBus7BV;;EkB9s7BM;IAOI,2BAAA;ElB2s7BV;;EkBlt7BM;IAOI,iCAAA;ElB+s7BV;;EkBtt7BM;IAOI,gCAAA;ElBmt7BV;;EkB1t7BM;IAOI,iCAAA;ElBut7BV;;EkB9t7BM;IAOI,8BAAA;ElB2t7BV;;EkBlu7BM;IAOI,iCAAA;ElB+t7BV;;EkBtu7BM;IAOI,gCAAA;ElBmu7BV;;EkB1u7BM;IAOI,iCAAA;ElBuu7BV;;EkB9u7BM;IAOI,8BAAA;ElB2u7BV;;EkBlv7BM;IAOI,iCAAA;ElB+u7BV;;EkBtv7BM;IAOI,gCAAA;ElBmv7BV;;EkB1v7BM;IAOI,iCAAA;ElBuv7BV;;EkB9v7BM;IAOI,8BAAA;ElB2v7BV;;EkBlw7BM;IAOI,iCAAA;ElB+v7BV;;EkBtw7BM;IAOI,gCAAA;ElBmw7BV;;EkB1w7BM;IAOI,iCAAA;ElBuw7BV;;EkB9w7BM;IAOI,8BAAA;ElB2w7BV;;EkBlx7BM;IAOI,iCAAA;ElB+w7BV;;EkBtx7BM;IAOI,gCAAA;ElBmx7BV;;EkB1x7BM;IAOI,iCAAA;ElBux7BV;;EkB9x7BM;IAOI,8BAAA;ElB2x7BV;;EkBly7BM;IAOI,8BAAA;ElB+x7BV;;EkBty7BM;IAOI,yBAAA;ElBmy7BV;;EkB1y7BM;IAOI,+BAAA;ElBuy7BV;;EkB9y7BM;IAOI,8BAAA;ElB2y7BV;;EkBlz7BM;IAOI,+BAAA;ElB+y7BV;;EkBtz7BM;IAOI,4BAAA;ElBmz7BV;;EkB1z7BM;IAOI,+BAAA;ElBuz7BV;;EkB9z7BM;IAOI,8BAAA;ElB2z7BV;;EkBl07BM;IAOI,+BAAA;ElB+z7BV;;EkBt07BM;IAOI,4BAAA;ElBm07BV;;EkB107BM;IAOI,+BAAA;ElBu07BV;;EkB907BM;IAOI,8BAAA;ElB207BV;;EkBl17BM;IAOI,+BAAA;ElB+07BV;;EkBt17BM;IAOI,4BAAA;ElBm17BV;;EkB117BM;IAOI,+BAAA;ElBu17BV;;EkB917BM;IAOI,8BAAA;ElB217BV;;EkBl27BM;IAOI,+BAAA;ElB+17BV;;EkBt27BM;IAOI,4BAAA;ElBm27BV;;EkB127BM;IAOI,+BAAA;ElBu27BV;;EkB927BM;IAOI,8BAAA;ElB227BV;;EkBl37BM;IAOI,+BAAA;ElB+27BV;;EkBt37BM;IAOI,4BAAA;ElBm37BV;;EkB137BM;IAOI,4BAAA;ElBu37BV;;EkB937BM;IAOI,2BAAA;ElB237BV;;EkBl47BM;IAOI,0BAAA;ElB+37BV;;EkBt47BM;IAOI,2BAAA;ElBm47BV;;EkB147BM;IAOI,wBAAA;ElBu47BV;;EkB947BM;IAOI,2BAAA;ElB247BV;;EkBl57BM;IAOI,0BAAA;ElB+47BV;;EkBt57BM;IAOI,2BAAA;ElBm57BV;;EkB157BM;IAOI,wBAAA;ElBu57BV;;EkB957BM;IAOI,2BAAA;ElB257BV;;EkBl67BM;IAOI,0BAAA;ElB+57BV;;EkBt67BM;IAOI,2BAAA;ElBm67BV;;EkB167BM;IAOI,wBAAA;ElBu67BV;;EkB967BM;IAOI,2BAAA;ElB267BV;;EkBl77BM;IAOI,0BAAA;ElB+67BV;;EkBt77BM;IAOI,2BAAA;ElBm77BV;;EkB177BM;IAOI,wBAAA;ElBu77BV;;EkB977BM;IAOI,2BAAA;ElB277BV;;EkBl87BM;IAOI,0BAAA;ElB+77BV;;EkBt87BM;IAOI,2BAAA;ElBm87BV;;EkB187BM;IAOI,wBAAA;ElBu87BV;;EkB987BM;IAOI,iCAAA;IAAA,gCAAA;ElB487BV;;EkBn97BM;IAOI,gCAAA;IAAA,+BAAA;ElBi97BV;;EkBx97BM;IAOI,iCAAA;IAAA,gCAAA;ElBs97BV;;EkB797BM;IAOI,8BAAA;IAAA,6BAAA;ElB297BV;;EkBl+7BM;IAOI,iCAAA;IAAA,gCAAA;ElBg+7BV;;EkBv+7BM;IAOI,gCAAA;IAAA,+BAAA;ElBq+7BV;;EkB5+7BM;IAOI,iCAAA;IAAA,gCAAA;ElB0+7BV;;EkBj/7BM;IAOI,8BAAA;IAAA,6BAAA;ElB++7BV;;EkBt/7BM;IAOI,iCAAA;IAAA,gCAAA;ElBo/7BV;;EkB3/7BM;IAOI,gCAAA;IAAA,+BAAA;ElBy/7BV;;EkBhg8BM;IAOI,iCAAA;IAAA,gCAAA;ElB8/7BV;;EkBrg8BM;IAOI,8BAAA;IAAA,6BAAA;ElBmg8BV;;EkB1g8BM;IAOI,iCAAA;IAAA,gCAAA;ElBwg8BV;;EkB/g8BM;IAOI,gCAAA;IAAA,+BAAA;ElB6g8BV;;EkBph8BM;IAOI,iCAAA;IAAA,gCAAA;ElBkh8BV;;EkBzh8BM;IAOI,8BAAA;IAAA,6BAAA;ElBuh8BV;;EkB9h8BM;IAOI,iCAAA;IAAA,gCAAA;ElB4h8BV;;EkBni8BM;IAOI,gCAAA;IAAA,+BAAA;ElBii8BV;;EkBxi8BM;IAOI,iCAAA;IAAA,gCAAA;ElBsi8BV;;EkB7i8BM;IAOI,8BAAA;IAAA,6BAAA;ElB2i8BV;;EkBlj8BM;IAOI,+BAAA;IAAA,kCAAA;ElBgj8BV;;EkBvj8BM;IAOI,8BAAA;IAAA,iCAAA;ElBqj8BV;;EkB5j8BM;IAOI,+BAAA;IAAA,kCAAA;ElB0j8BV;;EkBjk8BM;IAOI,4BAAA;IAAA,+BAAA;ElB+j8BV;;EkBtk8BM;IAOI,+BAAA;IAAA,kCAAA;ElBok8BV;;EkB3k8BM;IAOI,8BAAA;IAAA,iCAAA;ElByk8BV;;EkBhl8BM;IAOI,+BAAA;IAAA,kCAAA;ElB8k8BV;;EkBrl8BM;IAOI,4BAAA;IAAA,+BAAA;ElBml8BV;;EkB1l8BM;IAOI,+BAAA;IAAA,kCAAA;ElBwl8BV;;EkB/l8BM;IAOI,8BAAA;IAAA,iCAAA;ElB6l8BV;;EkBpm8BM;IAOI,+BAAA;IAAA,kCAAA;ElBkm8BV;;EkBzm8BM;IAOI,4BAAA;IAAA,+BAAA;ElBum8BV;;EkB9m8BM;IAOI,+BAAA;IAAA,kCAAA;ElB4m8BV;;EkBnn8BM;IAOI,8BAAA;IAAA,iCAAA;ElBin8BV;;EkBxn8BM;IAOI,+BAAA;IAAA,kCAAA;ElBsn8BV;;EkB7n8BM;IAOI,4BAAA;IAAA,+BAAA;ElB2n8BV;;EkBlo8BM;IAOI,+BAAA;IAAA,kCAAA;ElBgo8BV;;EkBvo8BM;IAOI,8BAAA;IAAA,iCAAA;ElBqo8BV;;EkB5o8BM;IAOI,+BAAA;IAAA,kCAAA;ElB0o8BV;;EkBjp8BM;IAOI,4BAAA;IAAA,+BAAA;ElB+o8BV;;EkBtp8BM;IAOI,+BAAA;ElBmp8BV;;EkB1p8BM;IAOI,8BAAA;ElBup8BV;;EkB9p8BM;IAOI,+BAAA;ElB2p8BV;;EkBlq8BM;IAOI,4BAAA;ElB+p8BV;;EkBtq8BM;IAOI,+BAAA;ElBmq8BV;;EkB1q8BM;IAOI,8BAAA;ElBuq8BV;;EkB9q8BM;IAOI,+BAAA;ElB2q8BV;;EkBlr8BM;IAOI,4BAAA;ElB+q8BV;;EkBtr8BM;IAOI,+BAAA;ElBmr8BV;;EkB1r8BM;IAOI,8BAAA;ElBur8BV;;EkB9r8BM;IAOI,+BAAA;ElB2r8BV;;EkBls8BM;IAOI,4BAAA;ElB+r8BV;;EkBts8BM;IAOI,+BAAA;ElBms8BV;;EkB1s8BM;IAOI,8BAAA;ElBus8BV;;EkB9s8BM;IAOI,+BAAA;ElB2s8BV;;EkBlt8BM;IAOI,4BAAA;ElB+s8BV;;EkBtt8BM;IAOI,+BAAA;ElBmt8BV;;EkB1t8BM;IAOI,8BAAA;ElBut8BV;;EkB9t8BM;IAOI,+BAAA;ElB2t8BV;;EkBlu8BM;IAOI,4BAAA;ElB+t8BV;;EkBtu8BM;IAOI,iCAAA;ElBmu8BV;;EkB1u8BM;IAOI,gCAAA;ElBuu8BV;;EkB9u8BM;IAOI,iCAAA;ElB2u8BV;;EkBlv8BM;IAOI,8BAAA;ElB+u8BV;;EkBtv8BM;IAOI,iCAAA;ElBmv8BV;;EkB1v8BM;IAOI,gCAAA;ElBuv8BV;;EkB9v8BM;IAOI,iCAAA;ElB2v8BV;;EkBlw8BM;IAOI,8BAAA;ElB+v8BV;;EkBtw8BM;IAOI,iCAAA;ElBmw8BV;;EkB1w8BM;IAOI,gCAAA;ElBuw8BV;;EkB9w8BM;IAOI,iCAAA;ElB2w8BV;;EkBlx8BM;IAOI,8BAAA;ElB+w8BV;;EkBtx8BM;IAOI,iCAAA;ElBmx8BV;;EkB1x8BM;IAOI,gCAAA;ElBux8BV;;EkB9x8BM;IAOI,iCAAA;ElB2x8BV;;EkBly8BM;IAOI,8BAAA;ElB+x8BV;;EkBty8BM;IAOI,iCAAA;ElBmy8BV;;EkB1y8BM;IAOI,gCAAA;ElBuy8BV;;EkB9y8BM;IAOI,iCAAA;ElB2y8BV;;EkBlz8BM;IAOI,8BAAA;ElB+y8BV;;EkBtz8BM;IAOI,kCAAA;ElBmz8BV;;EkB1z8BM;IAOI,iCAAA;ElBuz8BV;;EkB9z8BM;IAOI,kCAAA;ElB2z8BV;;EkBl08BM;IAOI,+BAAA;ElB+z8BV;;EkBt08BM;IAOI,kCAAA;ElBm08BV;;EkB108BM;IAOI,iCAAA;ElBu08BV;;EkB908BM;IAOI,kCAAA;ElB208BV;;EkBl18BM;IAOI,+BAAA;ElB+08BV;;EkBt18BM;IAOI,kCAAA;ElBm18BV;;EkB118BM;IAOI,iCAAA;ElBu18BV;;EkB918BM;IAOI,kCAAA;ElB218BV;;EkBl28BM;IAOI,+BAAA;ElB+18BV;;EkBt28BM;IAOI,kCAAA;ElBm28BV;;EkB128BM;IAOI,iCAAA;ElBu28BV;;EkB928BM;IAOI,kCAAA;ElB228BV;;EkBl38BM;IAOI,+BAAA;ElB+28BV;;EkBt38BM;IAOI,kCAAA;ElBm38BV;;EkB138BM;IAOI,iCAAA;ElBu38BV;;EkB938BM;IAOI,kCAAA;ElB238BV;;EkBl48BM;IAOI,+BAAA;ElB+38BV;;EkBt48BM;IAOI,gCAAA;ElBm48BV;;EkB148BM;IAOI,+BAAA;ElBu48BV;;EkB948BM;IAOI,gCAAA;ElB248BV;;EkBl58BM;IAOI,6BAAA;ElB+48BV;;EkBt58BM;IAOI,gCAAA;ElBm58BV;;EkB158BM;IAOI,+BAAA;ElBu58BV;;EkB958BM;IAOI,gCAAA;ElB258BV;;EkBl68BM;IAOI,6BAAA;ElB+58BV;;EkBt68BM;IAOI,gCAAA;ElBm68BV;;EkB168BM;IAOI,+BAAA;ElBu68BV;;EkB968BM;IAOI,gCAAA;ElB268BV;;EkBl78BM;IAOI,6BAAA;ElB+68BV;;EkBt78BM;IAOI,gCAAA;ElBm78BV;;EkB178BM;IAOI,+BAAA;ElBu78BV;;EkB978BM;IAOI,gCAAA;ElB278BV;;EkBl88BM;IAOI,6BAAA;ElB+78BV;;EkBt88BM;IAOI,gCAAA;ElBm88BV;;EkB188BM;IAOI,+BAAA;ElBu88BV;;EkB988BM;IAOI,gCAAA;ElB288BV;;EkBl98BM;IAOI,6BAAA;ElB+88BV;;EkBt98BM;IAOI,qBAAA;ElBm98BV;;EkB198BM;IAOI,2BAAA;ElBu98BV;;EkB998BM;IAOI,0BAAA;ElB298BV;;EkBl+8BM;IAOI,2BAAA;ElB+98BV;;EkBt+8BM;IAOI,wBAAA;ElBm+8BV;;EkB1+8BM;IAOI,2BAAA;ElBu+8BV;;EkB9+8BM;IAOI,0BAAA;ElB2+8BV;;EkBl/8BM;IAOI,2BAAA;ElB++8BV;;EkBt/8BM;IAOI,wBAAA;ElBm/8BV;;EkB1/8BM;IAOI,2BAAA;ElBu/8BV;;EkB9/8BM;IAOI,0BAAA;ElB2/8BV;;EkBlg9BM;IAOI,2BAAA;ElB+/8BV;;EkBtg9BM;IAOI,wBAAA;ElBmg9BV;;EkB1g9BM;IAOI,2BAAA;ElBug9BV;;EkB9g9BM;IAOI,0BAAA;ElB2g9BV;;EkBlh9BM;IAOI,2BAAA;ElB+g9BV;;EkBth9BM;IAOI,wBAAA;ElBmh9BV;;EkB1h9BM;IAOI,2BAAA;ElBuh9BV;;EkB9h9BM;IAOI,0BAAA;ElB2h9BV;;EkBli9BM;IAOI,2BAAA;ElB+h9BV;;EkBti9BM;IAOI,wBAAA;ElBmi9BV;;EkB1i9BM;IAOI,2BAAA;IAAA,0BAAA;ElBwi9BV;;EkB/i9BM;IAOI,iCAAA;IAAA,gCAAA;ElB6i9BV;;EkBpj9BM;IAOI,gCAAA;IAAA,+BAAA;ElBkj9BV;;EkBzj9BM;IAOI,iCAAA;IAAA,gCAAA;ElBuj9BV;;EkB9j9BM;IAOI,8BAAA;IAAA,6BAAA;ElB4j9BV;;EkBnk9BM;IAOI,iCAAA;IAAA,gCAAA;ElBik9BV;;EkBxk9BM;IAOI,gCAAA;IAAA,+BAAA;ElBsk9BV;;EkB7k9BM;IAOI,iCAAA;IAAA,gCAAA;ElB2k9BV;;EkBll9BM;IAOI,8BAAA;IAAA,6BAAA;ElBgl9BV;;EkBvl9BM;IAOI,iCAAA;IAAA,gCAAA;ElBql9BV;;EkB5l9BM;IAOI,gCAAA;IAAA,+BAAA;ElB0l9BV;;EkBjm9BM;IAOI,iCAAA;IAAA,gCAAA;ElB+l9BV;;EkBtm9BM;IAOI,8BAAA;IAAA,6BAAA;ElBom9BV;;EkB3m9BM;IAOI,iCAAA;IAAA,gCAAA;ElBym9BV;;EkBhn9BM;IAOI,gCAAA;IAAA,+BAAA;ElB8m9BV;;EkBrn9BM;IAOI,iCAAA;IAAA,gCAAA;ElBmn9BV;;EkB1n9BM;IAOI,8BAAA;IAAA,6BAAA;ElBwn9BV;;EkB/n9BM;IAOI,iCAAA;IAAA,gCAAA;ElB6n9BV;;EkBpo9BM;IAOI,gCAAA;IAAA,+BAAA;ElBko9BV;;EkBzo9BM;IAOI,iCAAA;IAAA,gCAAA;ElBuo9BV;;EkB9o9BM;IAOI,8BAAA;IAAA,6BAAA;ElB4o9BV;;EkBnp9BM;IAOI,yBAAA;IAAA,4BAAA;ElBip9BV;;EkBxp9BM;IAOI,+BAAA;IAAA,kCAAA;ElBsp9BV;;EkB7p9BM;IAOI,8BAAA;IAAA,iCAAA;ElB2p9BV;;EkBlq9BM;IAOI,+BAAA;IAAA,kCAAA;ElBgq9BV;;EkBvq9BM;IAOI,4BAAA;IAAA,+BAAA;ElBqq9BV;;EkB5q9BM;IAOI,+BAAA;IAAA,kCAAA;ElB0q9BV;;EkBjr9BM;IAOI,8BAAA;IAAA,iCAAA;ElB+q9BV;;EkBtr9BM;IAOI,+BAAA;IAAA,kCAAA;ElBor9BV;;EkB3r9BM;IAOI,4BAAA;IAAA,+BAAA;ElByr9BV;;EkBhs9BM;IAOI,+BAAA;IAAA,kCAAA;ElB8r9BV;;EkBrs9BM;IAOI,8BAAA;IAAA,iCAAA;ElBms9BV;;EkB1s9BM;IAOI,+BAAA;IAAA,kCAAA;ElBws9BV;;EkB/s9BM;IAOI,4BAAA;IAAA,+BAAA;ElB6s9BV;;EkBpt9BM;IAOI,+BAAA;IAAA,kCAAA;ElBkt9BV;;EkBzt9BM;IAOI,8BAAA;IAAA,iCAAA;ElBut9BV;;EkB9t9BM;IAOI,+BAAA;IAAA,kCAAA;ElB4t9BV;;EkBnu9BM;IAOI,4BAAA;IAAA,+BAAA;ElBiu9BV;;EkBxu9BM;IAOI,+BAAA;IAAA,kCAAA;ElBsu9BV;;EkB7u9BM;IAOI,8BAAA;IAAA,iCAAA;ElB2u9BV;;EkBlv9BM;IAOI,+BAAA;IAAA,kCAAA;ElBgv9BV;;EkBvv9BM;IAOI,4BAAA;IAAA,+BAAA;ElBqv9BV;;EkB5v9BM;IAOI,yBAAA;ElByv9BV;;EkBhw9BM;IAOI,+BAAA;ElB6v9BV;;EkBpw9BM;IAOI,8BAAA;ElBiw9BV;;EkBxw9BM;IAOI,+BAAA;ElBqw9BV;;EkB5w9BM;IAOI,4BAAA;ElByw9BV;;EkBhx9BM;IAOI,+BAAA;ElB6w9BV;;EkBpx9BM;IAOI,8BAAA;ElBix9BV;;EkBxx9BM;IAOI,+BAAA;ElBqx9BV;;EkB5x9BM;IAOI,4BAAA;ElByx9BV;;EkBhy9BM;IAOI,+BAAA;ElB6x9BV;;EkBpy9BM;IAOI,8BAAA;ElBiy9BV;;EkBxy9BM;IAOI,+BAAA;ElBqy9BV;;EkB5y9BM;IAOI,4BAAA;ElByy9BV;;EkBhz9BM;IAOI,+BAAA;ElB6y9BV;;EkBpz9BM;IAOI,8BAAA;ElBiz9BV;;EkBxz9BM;IAOI,+BAAA;ElBqz9BV;;EkB5z9BM;IAOI,4BAAA;ElByz9BV;;EkBh09BM;IAOI,+BAAA;ElB6z9BV;;EkBp09BM;IAOI,8BAAA;ElBi09BV;;EkBx09BM;IAOI,+BAAA;ElBq09BV;;EkB509BM;IAOI,4BAAA;ElBy09BV;;EkBh19BM;IAOI,2BAAA;ElB609BV;;EkBp19BM;IAOI,iCAAA;ElBi19BV;;EkBx19BM;IAOI,gCAAA;ElBq19BV;;EkB519BM;IAOI,iCAAA;ElBy19BV;;EkBh29BM;IAOI,8BAAA;ElB619BV;;EkBp29BM;IAOI,iCAAA;ElBi29BV;;EkBx29BM;IAOI,gCAAA;ElBq29BV;;EkB529BM;IAOI,iCAAA;ElBy29BV;;EkBh39BM;IAOI,8BAAA;ElB629BV;;EkBp39BM;IAOI,iCAAA;ElBi39BV;;EkBx39BM;IAOI,gCAAA;ElBq39BV;;EkB539BM;IAOI,iCAAA;ElBy39BV;;EkBh49BM;IAOI,8BAAA;ElB639BV;;EkBp49BM;IAOI,iCAAA;ElBi49BV;;EkBx49BM;IAOI,gCAAA;ElBq49BV;;EkB549BM;IAOI,iCAAA;ElBy49BV;;EkBh59BM;IAOI,8BAAA;ElB649BV;;EkBp59BM;IAOI,iCAAA;ElBi59BV;;EkBx59BM;IAOI,gCAAA;ElBq59BV;;EkB559BM;IAOI,iCAAA;ElBy59BV;;EkBh69BM;IAOI,8BAAA;ElB659BV;;EkBp69BM;IAOI,4BAAA;ElBi69BV;;EkBx69BM;IAOI,kCAAA;ElBq69BV;;EkB569BM;IAOI,iCAAA;ElBy69BV;;EkBh79BM;IAOI,kCAAA;ElB669BV;;EkBp79BM;IAOI,+BAAA;ElBi79BV;;EkBx79BM;IAOI,kCAAA;ElBq79BV;;EkB579BM;IAOI,iCAAA;ElBy79BV;;EkBh89BM;IAOI,kCAAA;ElB679BV;;EkBp89BM;IAOI,+BAAA;ElBi89BV;;EkBx89BM;IAOI,kCAAA;ElBq89BV;;EkB589BM;IAOI,iCAAA;ElBy89BV;;EkBh99BM;IAOI,kCAAA;ElB689BV;;EkBp99BM;IAOI,+BAAA;ElBi99BV;;EkBx99BM;IAOI,kCAAA;ElBq99BV;;EkB599BM;IAOI,iCAAA;ElBy99BV;;EkBh+9BM;IAOI,kCAAA;ElB699BV;;EkBp+9BM;IAOI,+BAAA;ElBi+9BV;;EkBx+9BM;IAOI,kCAAA;ElBq+9BV;;EkB5+9BM;IAOI,iCAAA;ElBy+9BV;;EkBh/9BM;IAOI,kCAAA;ElB6+9BV;;EkBp/9BM;IAOI,+BAAA;ElBi/9BV;;EkBx/9BM;IAOI,0BAAA;ElBq/9BV;;EkB5/9BM;IAOI,gCAAA;ElBy/9BV;;EkBhg+BM;IAOI,+BAAA;ElB6/9BV;;EkBpg+BM;IAOI,gCAAA;ElBig+BV;;EkBxg+BM;IAOI,6BAAA;ElBqg+BV;;EkB5g+BM;IAOI,gCAAA;ElByg+BV;;EkBhh+BM;IAOI,+BAAA;ElB6g+BV;;EkBph+BM;IAOI,gCAAA;ElBih+BV;;EkBxh+BM;IAOI,6BAAA;ElBqh+BV;;EkB5h+BM;IAOI,gCAAA;ElByh+BV;;EkBhi+BM;IAOI,+BAAA;ElB6h+BV;;EkBpi+BM;IAOI,gCAAA;ElBii+BV;;EkBxi+BM;IAOI,6BAAA;ElBqi+BV;;EkB5i+BM;IAOI,gCAAA;ElByi+BV;;EkBhj+BM;IAOI,+BAAA;ElB6i+BV;;EkBpj+BM;IAOI,gCAAA;ElBij+BV;;EkBxj+BM;IAOI,6BAAA;ElBqj+BV;;EkB5j+BM;IAOI,gCAAA;ElByj+BV;;EkBhk+BM;IAOI,+BAAA;ElB6j+BV;;EkBpk+BM;IAOI,gCAAA;ElBik+BV;;EkBxk+BM;IAOI,6BAAA;ElBqk+BV;;EkB5k+BM;IAOI,iBAAA;ElByk+BV;;EkBhl+BM;IAOI,uBAAA;ElB6k+BV;;EkBpl+BM;IAOI,sBAAA;ElBil+BV;;EkBxl+BM;IAOI,uBAAA;ElBql+BV;;EkB5l+BM;IAOI,oBAAA;ElByl+BV;;EkBhm+BM;IAOI,uBAAA;ElB6l+BV;;EkBpm+BM;IAOI,sBAAA;ElBim+BV;;EkBxm+BM;IAOI,uBAAA;ElBqm+BV;;EkB5m+BM;IAOI,oBAAA;ElBym+BV;;EkBhn+BM;IAOI,uBAAA;ElB6m+BV;;EkBpn+BM;IAOI,sBAAA;ElBin+BV;;EkBxn+BM;IAOI,uBAAA;ElBqn+BV;;EkB5n+BM;IAOI,oBAAA;ElByn+BV;;EkBho+BM;IAOI,uBAAA;ElB6n+BV;;EkBpo+BM;IAOI,sBAAA;ElBio+BV;;EkBxo+BM;IAOI,uBAAA;ElBqo+BV;;EkB5o+BM;IAOI,oBAAA;ElByo+BV;;EkBhp+BM;IAOI,uBAAA;ElB6o+BV;;EkBpp+BM;IAOI,sBAAA;ElBip+BV;;EkBxp+BM;IAOI,uBAAA;ElBqp+BV;;EkB5p+BM;IAOI,oBAAA;ElByp+BV;;EkBhq+BM;IAOI,qBAAA;ElB6p+BV;;EkBpq+BM;IAOI,2BAAA;ElBiq+BV;;EkBxq+BM;IAOI,0BAAA;ElBqq+BV;;EkB5q+BM;IAOI,2BAAA;ElByq+BV;;EkBhr+BM;IAOI,wBAAA;ElB6q+BV;;EkBpr+BM;IAOI,2BAAA;ElBir+BV;;EkBxr+BM;IAOI,0BAAA;ElBqr+BV;;EkB5r+BM;IAOI,2BAAA;ElByr+BV;;EkBhs+BM;IAOI,wBAAA;ElB6r+BV;;EkBps+BM;IAOI,2BAAA;ElBis+BV;;EkBxs+BM;IAOI,0BAAA;ElBqs+BV;;EkB5s+BM;IAOI,2BAAA;ElBys+BV;;EkBht+BM;IAOI,wBAAA;ElB6s+BV;;EkBpt+BM;IAOI,2BAAA;ElBit+BV;;EkBxt+BM;IAOI,0BAAA;ElBqt+BV;;EkB5t+BM;IAOI,2BAAA;ElByt+BV;;EkBhu+BM;IAOI,wBAAA;ElB6t+BV;;EkBpu+BM;IAOI,2BAAA;ElBiu+BV;;EkBxu+BM;IAOI,0BAAA;ElBqu+BV;;EkB5u+BM;IAOI,2BAAA;ElByu+BV;;EkBhv+BM;IAOI,wBAAA;ElB6u+BV;;EkBpv+BM;IAOI,wBAAA;ElBiv+BV;;EkBxv+BM;IAOI,8BAAA;ElBqv+BV;;EkB5v+BM;IAOI,6BAAA;ElByv+BV;;EkBhw+BM;IAOI,8BAAA;ElB6v+BV;;EkBpw+BM;IAOI,2BAAA;ElBiw+BV;;EkBxw+BM;IAOI,8BAAA;ElBqw+BV;;EkB5w+BM;IAOI,6BAAA;ElByw+BV;;EkBhx+BM;IAOI,8BAAA;ElB6w+BV;;EkBpx+BM;IAOI,2BAAA;ElBix+BV;;EkBxx+BM;IAOI,8BAAA;ElBqx+BV;;EkB5x+BM;IAOI,6BAAA;ElByx+BV;;EkBhy+BM;IAOI,8BAAA;ElB6x+BV;;EkBpy+BM;IAOI,2BAAA;ElBiy+BV;;EkBxy+BM;IAOI,8BAAA;ElBqy+BV;;EkB5y+BM;IAOI,6BAAA;ElByy+BV;;EkBhz+BM;IAOI,8BAAA;ElB6y+BV;;EkBpz+BM;IAOI,2BAAA;ElBiz+BV;;EkBxz+BM;IAOI,8BAAA;ElBqz+BV;;EkB5z+BM;IAOI,6BAAA;ElByz+BV;;EkBh0+BM;IAOI,8BAAA;ElB6z+BV;;EkBp0+BM;IAOI,2BAAA;ElBi0+BV;;EkBx0+BM;IAOI,0CAAA;ElBq0+BV;;EkB50+BM;IAOI,4CAAA;ElBy0+BV;;EkBh1+BM;IAOI,4CAAA;ElB60+BV;;EkBp1+BM;IAOI,6BAAA;ElBi1+BV;;EkBx1+BM;IAOI,6BAAA;ElBq1+BV;;EkB51+BM;IAOI,8BAAA;ElBy1+BV;;EkBh2+BM;IAOI,6BAAA;ElB61+BV;;EkBp2+BM;IAOI,6BAAA;ElBi2+BV;;EkBx2+BM;IAOI,6BAAA;ElBq2+BV;;EkB52+BM;IAOI,4BAAA;ElBy2+BV;;EkBh3+BM;IAOI,0BAAA;ElB62+BV;;EkBp3+BM;IAOI,0BAAA;ElBi3+BV;;EkBx3+BM;IAOI,4CAAA;ElBq3+BV;;EkB53+BM;IAOI,2CAAA;ElBy3+BV;;EkBh4+BM;IAOI,4CAAA;ElB63+BV;;EkBp4+BM;IAOI,0CAAA;ElBi4+BV;;EkBx4+BM;IAOI,4CAAA;ElBq4+BV;;EkB54+BM;IAOI,2CAAA;ElBy4+BV;;EkBh5+BM;IAOI,4CAAA;ElB64+BV;;EkBp5+BM;IAOI,wCAAA;ElBi5+BV;;EkBx5+BM;IAOI,4CAAA;ElBq5+BV;;EkB55+BM;IAOI,2CAAA;ElBy5+BV;;EkBh6+BM;IAOI,4CAAA;ElB65+BV;;EkBp6+BM;IAOI,0CAAA;ElBi6+BV;;EkBx6+BM;IAOI,4CAAA;ElBq6+BV;;EkB56+BM;IAOI,2CAAA;ElBy6+BV;;EkBh7+BM;IAOI,4CAAA;ElB66+BV;;EkBp7+BM;IAOI,0CAAA;ElBi7+BV;;EkBx7+BM;IAOI,2BAAA;ElBq7+BV;;EkB57+BM;IAOI,4BAAA;ElBy7+BV;;EkBh8+BM;IAOI,6BAAA;ElB67+BV;;EkBp8+BM;IAOI,2BAAA;ElBi8+BV;;EkBx8+BM;IAOI,yBAAA;ElBq8+BV;;EkB58+BM;IAOI,yBAAA;ElBy8+BV;;EkBh9+BM;IAOI,yBAAA;ElB68+BV;;EkBp9+BM;IAOI,0BAAA;ElBi9+BV;;EkBx9+BM;IAOI,0BAAA;ElBq9+BV;;EkB59+BM;IAOI,yBAAA;ElBy9+BV;;EkBh++BM;IAOI,yBAAA;ElB69+BV;;EkBp++BM;IAOI,yBAAA;ElBi++BV;;EkBx++BM;IAOI,yBAAA;ElBq++BV;;EkB5++BM;IAOI,yBAAA;ElBy++BV;;EkBh/+BM;IAOI,yBAAA;ElB6++BV;;EkBp/+BM;IAOI,yBAAA;ElBi/+BV;;EkBx/+BM;IAOI,yBAAA;ElBq/+BV;;EkB5/+BM;IAOI,yBAAA;ElBy/+BV;;EkBhg/BM;IAOI,0BAAA;ElB6/+BV;;EkBpg/BM;IAOI,0BAAA;ElBig/BV;;EkBxg/BM;IAOI,0BAAA;ElBqg/BV;;EkB5g/BM;IAOI,0BAAA;ElByg/BV;;EkBhh/BM;IAOI,0BAAA;ElB6g/BV;;EkBph/BM;IAOI,0BAAA;ElBih/BV;;EkBxh/BM;IAOI,0BAAA;ElBqh/BV;;EkB5h/BM;IAOI,0BAAA;ElByh/BV;;EkBhi/BM;IAOI,0BAAA;ElB6h/BV;;EkBpi/BM;IAOI,0BAAA;ElBii/BV;;EkBxi/BM;IAOI,0BAAA;ElBqi/BV;;EkB5i/BM;IAOI,0BAAA;ElByi/BV;;EkBhj/BM;IAOI,0BAAA;ElB6i/BV;;EkBpj/BM;IAOI,0BAAA;ElBij/BV;;EkBxj/BM;IAOI,0BAAA;ElBqj/BV;;EkB5j/BM;IAOI,0BAAA;ElByj/BV;;EkBhk/BM;IAOI,0BAAA;ElB6j/BV;;EkBpk/BM;IAOI,0BAAA;ElBik/BV;;EkBxk/BM;IAOI,2BAAA;ElBqk/BV;;EkB5k/BM;IAOI,2BAAA;ElByk/BV;;EkBhl/BM;IAOI,2BAAA;ElB6k/BV;;EkBpl/BM;IAOI,2BAAA;ElBil/BV;;EkBxl/BM;IAOI,2BAAA;ElBql/BV;;EkB5l/BM;IAOI,2BAAA;ElByl/BV;;EkBhm/BM;IAOI,2BAAA;ElB6l/BV;;EkBpm/BM;IAOI,2BAAA;ElBim/BV;;EkBxm/BM;IAOI,2BAAA;ElBqm/BV;;EkB5m/BM;IAOI,2BAAA;ElBym/BV;;EkBhn/BM;IAOI,2BAAA;ElB6m/BV;;EkBpn/BM;IAOI,2BAAA;ElBin/BV;;EkBxn/BM;IAOI,2BAAA;ElBqn/BV;;EkB5n/BM;IAOI,2BAAA;ElByn/BV;;EkBho/BM;IAOI,2BAAA;ElB6n/BV;;EkBpo/BM;IAOI,2BAAA;ElBio/BV;;EkBxo/BM;IAOI,2BAAA;ElBqo/BV;;EkB5o/BM;IAOI,2BAAA;ElByo/BV;;EkBhp/BM;IAOI,2BAAA;ElB6o/BV;;EkBpp/BM;IAOI,2BAAA;ElBip/BV;;EkBxp/BM;IAOI,2BAAA;ElBqp/BV;;EkB5p/BM;IAOI,2BAAA;ElByp/BV;;EkBhq/BM;IAOI,2BAAA;ElB6p/BV;;EkBpq/BM;IAOI,2BAAA;ElBiq/BV;;EkBxq/BM;IAOI,2BAAA;ElBqq/BV;;EkB5q/BM;IAOI,2BAAA;ElByq/BV;;EkBhr/BM;IAOI,4BAAA;ElB6q/BV;;EkBpr/BM;IAOI,4BAAA;ElBir/BV;;EkBxr/BM;IAOI,0BAAA;ElBqr/BV;;EkB5r/BM;IAOI,0BAAA;ElByr/BV;;EkBhs/BM;IAOI,0BAAA;ElB6r/BV;;EkBps/BM;IAOI,2BAAA;ElBis/BV;;EkBxs/BM;IAOI,2BAAA;ElBqs/BV;;EkB5s/BM;IAOI,0BAAA;ElBys/BV;;EkBht/BM;IAOI,0BAAA;ElB6s/BV;;EkBpt/BM;IAOI,0BAAA;ElBit/BV;;EkBxt/BM;IAOI,0BAAA;ElBqt/BV;;EkB5t/BM;IAOI,0BAAA;ElByt/BV;;EkBhu/BM;IAOI,0BAAA;ElB6t/BV;;EkBpu/BM;IAOI,0BAAA;ElBiu/BV;;EkBxu/BM;IAOI,0BAAA;ElBqu/BV;;EkB5u/BM;IAOI,0BAAA;ElByu/BV;;EkBhv/BM;IAOI,2BAAA;ElB6u/BV;;EkBpv/BM;IAOI,2BAAA;ElBiv/BV;;EkBxv/BM;IAOI,2BAAA;ElBqv/BV;;EkB5v/BM;IAOI,2BAAA;ElByv/BV;;EkBhw/BM;IAOI,2BAAA;ElB6v/BV;;EkBpw/BM;IAOI,2BAAA;ElBiw/BV;;EkBxw/BM;IAOI,2BAAA;ElBqw/BV;;EkB5w/BM;IAOI,2BAAA;ElByw/BV;;EkBhx/BM;IAOI,2BAAA;ElB6w/BV;;EkBpx/BM;IAOI,2BAAA;ElBix/BV;;EkBxx/BM;IAOI,2BAAA;ElBqx/BV;;EkB5x/BM;IAOI,2BAAA;ElByx/BV;;EkBhy/BM;IAOI,2BAAA;ElB6x/BV;;EkBpy/BM;IAOI,2BAAA;ElBiy/BV;;EkBxy/BM;IAOI,2BAAA;ElBqy/BV;;EkB5y/BM;IAOI,2BAAA;ElByy/BV;;EkBhz/BM;IAOI,2BAAA;ElB6y/BV;;EkBpz/BM;IAOI,2BAAA;ElBiz/BV;;EkBxz/BM;IAOI,4BAAA;ElBqz/BV;;EkB5z/BM;IAOI,4BAAA;ElByz/BV;;EkBh0/BM;IAOI,4BAAA;ElB6z/BV;;EkBp0/BM;IAOI,4BAAA;ElBi0/BV;;EkBx0/BM;IAOI,4BAAA;ElBq0/BV;;EkB50/BM;IAOI,4BAAA;ElBy0/BV;;EkBh1/BM;IAOI,4BAAA;ElB60/BV;;EkBp1/BM;IAOI,4BAAA;ElBi1/BV;;EkBx1/BM;IAOI,4BAAA;ElBq1/BV;;EkB51/BM;IAOI,4BAAA;ElBy1/BV;;EkBh2/BM;IAOI,4BAAA;ElB61/BV;;EkBp2/BM;IAOI,4BAAA;ElBi2/BV;;EkBx2/BM;IAOI,4BAAA;ElBq2/BV;;EkB52/BM;IAOI,4BAAA;ElBy2/BV;;EkBh3/BM;IAOI,4BAAA;ElB62/BV;;EkBp3/BM;IAOI,4BAAA;ElBi3/BV;;EkBx3/BM;IAOI,4BAAA;ElBq3/BV;;EkB53/BM;IAOI,4BAAA;ElBy3/BV;;EkBh4/BM;IAOI,4BAAA;ElB63/BV;;EkBp4/BM;IAOI,4BAAA;ElBi4/BV;;EkBx4/BM;IAOI,4BAAA;ElBq4/BV;;EkB54/BM;IAOI,4BAAA;ElBy4/BV;;EkBh5/BM;IAOI,4BAAA;ElB64/BV;;EkBp5/BM;IAOI,4BAAA;ElBi5/BV;;EkBx5/BM;IAOI,4BAAA;ElBq5/BV;;EkB55/BM;IAOI,4BAAA;ElBy5/BV;;EkBh6/BM;IAOI,6BAAA;ElB65/BV;AACF;AUx6/BI;EQGI;IAOI,sBAAA;ElBk6/BV;;EkBz6/BM;IAOI,uBAAA;ElBs6/BV;;EkB76/BM;IAOI,sBAAA;ElB06/BV;;EkBj7/BM;IAOI,8BAAA;ElB86/BV;;EkBr7/BM;IAOI,4BAAA;ElBk7/BV;;EkBz7/BM;IAOI,2BAAA;ElBs7/BV;;EkB77/BM;IAOI,iCAAA;ElB07/BV;;EkBj8/BM;IAOI,2BAAA;ElB87/BV;;EkBr8/BM;IAOI,0BAAA;ElBk8/BV;;EkBz8/BM;IAOI,gCAAA;ElBs8/BV;;EkB78/BM;IAOI,yBAAA;ElB08/BV;;EkBj9/BM;IAOI,wBAAA;ElB88/BV;;EkBr9/BM;IAOI,+BAAA;ElBk9/BV;;EkBz9/BM;IAOI,yBAAA;ElBs9/BV;;EkB79/BM;IAOI,6BAAA;ElB09/BV;;EkBj+/BM;IAOI,8BAAA;ElB89/BV;;EkBr+/BM;IAOI,wBAAA;ElBk+/BV;;EkBz+/BM;IAOI,+BAAA;ElBs+/BV;;EkB7+/BM;IAOI,wBAAA;ElB0+/BV;;EkBj//BM;IAOI,2BAAA;ElB8+/BV;;EkBr//BM;IAOI,6BAAA;ElBk//BV;;EkBz//BM;IAOI,6BAAA;ElBs//BV;;EkB7//BM;IAOI,0BAAA;ElB0//BV;;EkBjggCM;IAOI,2BAAA;ElB8//BV;;EkBrggCM;IAOI,uBAAA;ElBkggCV;;EkBzggCM;IAOI,qBAAA;ElBsggCV;;EkB7ggCM;IAOI,qBAAA;ElB0ggCV;;EkBjhgCM;IAOI,qBAAA;ElB8ggCV;;EkBrhgCM;IAOI,sBAAA;ElBkhgCV;;EkBzhgCM;IAOI,sBAAA;ElBshgCV;;EkB7hgCM;IAOI,qBAAA;ElB0hgCV;;EkBjigCM;IAOI,qBAAA;ElB8hgCV;;EkBrigCM;IAOI,qBAAA;ElBkigCV;;EkBzigCM;IAOI,qBAAA;ElBsigCV;;EkB7igCM;IAOI,qBAAA;ElB0igCV;;EkBjjgCM;IAOI,qBAAA;ElB8igCV;;EkBrjgCM;IAOI,qBAAA;ElBkjgCV;;EkBzjgCM;IAOI,qBAAA;ElBsjgCV;;EkB7jgCM;IAOI,qBAAA;ElB0jgCV;;EkBjkgCM;IAOI,sBAAA;ElB8jgCV;;EkBrkgCM;IAOI,sBAAA;ElBkkgCV;;EkBzkgCM;IAOI,sBAAA;ElBskgCV;;EkB7kgCM;IAOI,sBAAA;ElB0kgCV;;EkBjlgCM;IAOI,sBAAA;ElB8kgCV;;EkBrlgCM;IAOI,sBAAA;ElBklgCV;;EkBzlgCM;IAOI,sBAAA;ElBslgCV;;EkB7lgCM;IAOI,sBAAA;ElB0lgCV;;EkBjmgCM;IAOI,sBAAA;ElB8lgCV;;EkBrmgCM;IAOI,sBAAA;ElBkmgCV;;EkBzmgCM;IAOI,sBAAA;ElBsmgCV;;EkB7mgCM;IAOI,sBAAA;ElB0mgCV;;EkBjngCM;IAOI,sBAAA;ElB8mgCV;;EkBrngCM;IAOI,sBAAA;ElBkngCV;;EkBzngCM;IAOI,sBAAA;ElBsngCV;;EkB7ngCM;IAOI,sBAAA;ElB0ngCV;;EkBjogCM;IAOI,sBAAA;ElB8ngCV;;EkBrogCM;IAOI,sBAAA;ElBkogCV;;EkBzogCM;IAOI,uBAAA;ElBsogCV;;EkB7ogCM;IAOI,uBAAA;ElB0ogCV;;EkBjpgCM;IAOI,uBAAA;ElB8ogCV;;EkBrpgCM;IAOI,uBAAA;ElBkpgCV;;EkBzpgCM;IAOI,uBAAA;ElBspgCV;;EkB7pgCM;IAOI,uBAAA;ElB0pgCV;;EkBjqgCM;IAOI,uBAAA;ElB8pgCV;;EkBrqgCM;IAOI,uBAAA;ElBkqgCV;;EkBzqgCM;IAOI,uBAAA;ElBsqgCV;;EkB7qgCM;IAOI,uBAAA;ElB0qgCV;;EkBjrgCM;IAOI,uBAAA;ElB8qgCV;;EkBrrgCM;IAOI,uBAAA;ElBkrgCV;;EkBzrgCM;IAOI,uBAAA;ElBsrgCV;;EkB7rgCM;IAOI,uBAAA;ElB0rgCV;;EkBjsgCM;IAOI,uBAAA;ElB8rgCV;;EkBrsgCM;IAOI,uBAAA;ElBksgCV;;EkBzsgCM;IAOI,uBAAA;ElBssgCV;;EkB7sgCM;IAOI,uBAAA;ElB0sgCV;;EkBjtgCM;IAOI,uBAAA;ElB8sgCV;;EkBrtgCM;IAOI,uBAAA;ElBktgCV;;EkBztgCM;IAOI,uBAAA;ElBstgCV;;EkB7tgCM;IAOI,uBAAA;ElB0tgCV;;EkBjugCM;IAOI,uBAAA;ElB8tgCV;;EkBrugCM;IAOI,uBAAA;ElBkugCV;;EkBzugCM;IAOI,uBAAA;ElBsugCV;;EkB7ugCM;IAOI,uBAAA;ElB0ugCV;;EkBjvgCM;IAOI,wBAAA;ElB8ugCV;;EkBrvgCM;IAOI,2BAAA;ElBkvgCV;;EkBzvgCM;IAOI,yBAAA;ElBsvgCV;;EkB7vgCM;IAOI,yBAAA;ElB0vgCV;;EkBjwgCM;IAOI,yBAAA;ElB8vgCV;;EkBrwgCM;IAOI,0BAAA;ElBkwgCV;;EkBzwgCM;IAOI,0BAAA;ElBswgCV;;EkB7wgCM;IAOI,yBAAA;ElB0wgCV;;EkBjxgCM;IAOI,yBAAA;ElB8wgCV;;EkBrxgCM;IAOI,yBAAA;ElBkxgCV;;EkBzxgCM;IAOI,yBAAA;ElBsxgCV;;EkB7xgCM;IAOI,yBAAA;ElB0xgCV;;EkBjygCM;IAOI,yBAAA;ElB8xgCV;;EkBrygCM;IAOI,yBAAA;ElBkygCV;;EkBzygCM;IAOI,yBAAA;ElBsygCV;;EkB7ygCM;IAOI,yBAAA;ElB0ygCV;;EkBjzgCM;IAOI,0BAAA;ElB8ygCV;;EkBrzgCM;IAOI,0BAAA;ElBkzgCV;;EkBzzgCM;IAOI,0BAAA;ElBszgCV;;EkB7zgCM;IAOI,0BAAA;ElB0zgCV;;EkBj0gCM;IAOI,0BAAA;ElB8zgCV;;EkBr0gCM;IAOI,0BAAA;ElBk0gCV;;EkBz0gCM;IAOI,0BAAA;ElBs0gCV;;EkB70gCM;IAOI,0BAAA;ElB00gCV;;EkBj1gCM;IAOI,0BAAA;ElB80gCV;;EkBr1gCM;IAOI,0BAAA;ElBk1gCV;;EkBz1gCM;IAOI,0BAAA;ElBs1gCV;;EkB71gCM;IAOI,0BAAA;ElB01gCV;;EkBj2gCM;IAOI,0BAAA;ElB81gCV;;EkBr2gCM;IAOI,0BAAA;ElBk2gCV;;EkBz2gCM;IAOI,0BAAA;ElBs2gCV;;EkB72gCM;IAOI,0BAAA;ElB02gCV;;EkBj3gCM;IAOI,0BAAA;ElB82gCV;;EkBr3gCM;IAOI,0BAAA;ElBk3gCV;;EkBz3gCM;IAOI,2BAAA;ElBs3gCV;;EkB73gCM;IAOI,2BAAA;ElB03gCV;;EkBj4gCM;IAOI,2BAAA;ElB83gCV;;EkBr4gCM;IAOI,2BAAA;ElBk4gCV;;EkBz4gCM;IAOI,2BAAA;ElBs4gCV;;EkB74gCM;IAOI,2BAAA;ElB04gCV;;EkBj5gCM;IAOI,2BAAA;ElB84gCV;;EkBr5gCM;IAOI,2BAAA;ElBk5gCV;;EkBz5gCM;IAOI,2BAAA;ElBs5gCV;;EkB75gCM;IAOI,2BAAA;ElB05gCV;;EkBj6gCM;IAOI,2BAAA;ElB85gCV;;EkBr6gCM;IAOI,2BAAA;ElBk6gCV;;EkBz6gCM;IAOI,2BAAA;ElBs6gCV;;EkB76gCM;IAOI,2BAAA;ElB06gCV;;EkBj7gCM;IAOI,2BAAA;ElB86gCV;;EkBr7gCM;IAOI,2BAAA;ElBk7gCV;;EkBz7gCM;IAOI,2BAAA;ElBs7gCV;;EkB77gCM;IAOI,2BAAA;ElB07gCV;;EkBj8gCM;IAOI,2BAAA;ElB87gCV;;EkBr8gCM;IAOI,2BAAA;ElBk8gCV;;EkBz8gCM;IAOI,2BAAA;ElBs8gCV;;EkB78gCM;IAOI,2BAAA;ElB08gCV;;EkBj9gCM;IAOI,2BAAA;ElB88gCV;;EkBr9gCM;IAOI,2BAAA;ElBk9gCV;;EkBz9gCM;IAOI,2BAAA;ElBs9gCV;;EkB79gCM;IAOI,2BAAA;ElB09gCV;;EkBj+gCM;IAOI,4BAAA;ElB89gCV;;EkBr+gCM;IAOI,wBAAA;ElBk+gCV;;EkBz+gCM;IAOI,sBAAA;ElBs+gCV;;EkB7+gCM;IAOI,sBAAA;ElB0+gCV;;EkBj/gCM;IAOI,sBAAA;ElB8+gCV;;EkBr/gCM;IAOI,uBAAA;ElBk/gCV;;EkBz/gCM;IAOI,uBAAA;ElBs/gCV;;EkB7/gCM;IAOI,sBAAA;ElB0/gCV;;EkBjghCM;IAOI,sBAAA;ElB8/gCV;;EkBrghCM;IAOI,sBAAA;ElBkghCV;;EkBzghCM;IAOI,sBAAA;ElBsghCV;;EkB7ghCM;IAOI,sBAAA;ElB0ghCV;;EkBjhhCM;IAOI,sBAAA;ElB8ghCV;;EkBrhhCM;IAOI,sBAAA;ElBkhhCV;;EkBzhhCM;IAOI,sBAAA;ElBshhCV;;EkB7hhCM;IAOI,sBAAA;ElB0hhCV;;EkBjihCM;IAOI,uBAAA;ElB8hhCV;;EkBrihCM;IAOI,uBAAA;ElBkihCV;;EkBzihCM;IAOI,uBAAA;ElBsihCV;;EkB7ihCM;IAOI,uBAAA;ElB0ihCV;;EkBjjhCM;IAOI,uBAAA;ElB8ihCV;;EkBrjhCM;IAOI,uBAAA;ElBkjhCV;;EkBzjhCM;IAOI,uBAAA;ElBsjhCV;;EkB7jhCM;IAOI,uBAAA;ElB0jhCV;;EkBjkhCM;IAOI,uBAAA;ElB8jhCV;;EkBrkhCM;IAOI,uBAAA;ElBkkhCV;;EkBzkhCM;IAOI,uBAAA;ElBskhCV;;EkB7khCM;IAOI,uBAAA;ElB0khCV;;EkBjlhCM;IAOI,uBAAA;ElB8khCV;;EkBrlhCM;IAOI,uBAAA;ElBklhCV;;EkBzlhCM;IAOI,uBAAA;ElBslhCV;;EkB7lhCM;IAOI,uBAAA;ElB0lhCV;;EkBjmhCM;IAOI,uBAAA;ElB8lhCV;;EkBrmhCM;IAOI,uBAAA;ElBkmhCV;;EkBzmhCM;IAOI,wBAAA;ElBsmhCV;;EkB7mhCM;IAOI,wBAAA;ElB0mhCV;;EkBjnhCM;IAOI,wBAAA;ElB8mhCV;;EkBrnhCM;IAOI,wBAAA;ElBknhCV;;EkBznhCM;IAOI,wBAAA;ElBsnhCV;;EkB7nhCM;IAOI,wBAAA;ElB0nhCV;;EkBjohCM;IAOI,wBAAA;ElB8nhCV;;EkBrohCM;IAOI,wBAAA;ElBkohCV;;EkBzohCM;IAOI,wBAAA;ElBsohCV;;EkB7ohCM;IAOI,wBAAA;ElB0ohCV;;EkBjphCM;IAOI,wBAAA;ElB8ohCV;;EkBrphCM;IAOI,wBAAA;ElBkphCV;;EkBzphCM;IAOI,wBAAA;ElBsphCV;;EkB7phCM;IAOI,wBAAA;ElB0phCV;;EkBjqhCM;IAOI,wBAAA;ElB8phCV;;EkBrqhCM;IAOI,wBAAA;ElBkqhCV;;EkBzqhCM;IAOI,wBAAA;ElBsqhCV;;EkB7qhCM;IAOI,wBAAA;ElB0qhCV;;EkBjrhCM;IAOI,wBAAA;ElB8qhCV;;EkBrrhCM;IAOI,wBAAA;ElBkrhCV;;EkBzrhCM;IAOI,wBAAA;ElBsrhCV;;EkB7rhCM;IAOI,wBAAA;ElB0rhCV;;EkBjshCM;IAOI,wBAAA;ElB8rhCV;;EkBrshCM;IAOI,wBAAA;ElBkshCV;;EkBzshCM;IAOI,wBAAA;ElBsshCV;;EkB7shCM;IAOI,wBAAA;ElB0shCV;;EkBjthCM;IAOI,yBAAA;ElB8shCV;;EkBrthCM;IAOI,4BAAA;ElBkthCV;;EkBzthCM;IAOI,0BAAA;ElBsthCV;;EkB7thCM;IAOI,0BAAA;ElB0thCV;;EkBjuhCM;IAOI,0BAAA;ElB8thCV;;EkBruhCM;IAOI,2BAAA;ElBkuhCV;;EkBzuhCM;IAOI,2BAAA;ElBsuhCV;;EkB7uhCM;IAOI,0BAAA;ElB0uhCV;;EkBjvhCM;IAOI,0BAAA;ElB8uhCV;;EkBrvhCM;IAOI,0BAAA;ElBkvhCV;;EkBzvhCM;IAOI,0BAAA;ElBsvhCV;;EkB7vhCM;IAOI,0BAAA;ElB0vhCV;;EkBjwhCM;IAOI,0BAAA;ElB8vhCV;;EkBrwhCM;IAOI,0BAAA;ElBkwhCV;;EkBzwhCM;IAOI,0BAAA;ElBswhCV;;EkB7whCM;IAOI,0BAAA;ElB0whCV;;EkBjxhCM;IAOI,2BAAA;ElB8whCV;;EkBrxhCM;IAOI,2BAAA;ElBkxhCV;;EkBzxhCM;IAOI,2BAAA;ElBsxhCV;;EkB7xhCM;IAOI,2BAAA;ElB0xhCV;;EkBjyhCM;IAOI,2BAAA;ElB8xhCV;;EkBryhCM;IAOI,2BAAA;ElBkyhCV;;EkBzyhCM;IAOI,2BAAA;ElBsyhCV;;EkB7yhCM;IAOI,2BAAA;ElB0yhCV;;EkBjzhCM;IAOI,2BAAA;ElB8yhCV;;EkBrzhCM;IAOI,2BAAA;ElBkzhCV;;EkBzzhCM;IAOI,2BAAA;ElBszhCV;;EkB7zhCM;IAOI,2BAAA;ElB0zhCV;;EkBj0hCM;IAOI,2BAAA;ElB8zhCV;;EkBr0hCM;IAOI,2BAAA;ElBk0hCV;;EkBz0hCM;IAOI,2BAAA;ElBs0hCV;;EkB70hCM;IAOI,2BAAA;ElB00hCV;;EkBj1hCM;IAOI,2BAAA;ElB80hCV;;EkBr1hCM;IAOI,2BAAA;ElBk1hCV;;EkBz1hCM;IAOI,4BAAA;ElBs1hCV;;EkB71hCM;IAOI,4BAAA;ElB01hCV;;EkBj2hCM;IAOI,4BAAA;ElB81hCV;;EkBr2hCM;IAOI,4BAAA;ElBk2hCV;;EkBz2hCM;IAOI,4BAAA;ElBs2hCV;;EkB72hCM;IAOI,4BAAA;ElB02hCV;;EkBj3hCM;IAOI,4BAAA;ElB82hCV;;EkBr3hCM;IAOI,4BAAA;ElBk3hCV;;EkBz3hCM;IAOI,4BAAA;ElBs3hCV;;EkB73hCM;IAOI,4BAAA;ElB03hCV;;EkBj4hCM;IAOI,4BAAA;ElB83hCV;;EkBr4hCM;IAOI,4BAAA;ElBk4hCV;;EkBz4hCM;IAOI,4BAAA;ElBs4hCV;;EkB74hCM;IAOI,4BAAA;ElB04hCV;;EkBj5hCM;IAOI,4BAAA;ElB84hCV;;EkBr5hCM;IAOI,4BAAA;ElBk5hCV;;EkBz5hCM;IAOI,4BAAA;ElBs5hCV;;EkB75hCM;IAOI,4BAAA;ElB05hCV;;EkBj6hCM;IAOI,4BAAA;ElB85hCV;;EkBr6hCM;IAOI,4BAAA;ElBk6hCV;;EkBz6hCM;IAOI,4BAAA;ElBs6hCV;;EkB76hCM;IAOI,4BAAA;ElB06hCV;;EkBj7hCM;IAOI,4BAAA;ElB86hCV;;EkBr7hCM;IAOI,4BAAA;ElBk7hCV;;EkBz7hCM;IAOI,4BAAA;ElBs7hCV;;EkB77hCM;IAOI,4BAAA;ElB07hCV;;EkBj8hCM;IAOI,6BAAA;ElB87hCV;;EkBr8hCM;IAOI,yBAAA;ElBk8hCV;;EkBz8hCM;IAOI,8BAAA;ElBs8hCV;;EkB78hCM;IAOI,iCAAA;ElB08hCV;;EkBj9hCM;IAOI,sCAAA;ElB88hCV;;EkBr9hCM;IAOI,yCAAA;ElBk9hCV;;EkBz9hCM;IAOI,uBAAA;ElBs9hCV;;EkB79hCM;IAOI,uBAAA;ElB09hCV;;EkBj+hCM;IAOI,yBAAA;ElB89hCV;;EkBr+hCM;IAOI,yBAAA;ElBk+hCV;;EkBz+hCM;IAOI,0BAAA;ElBs+hCV;;EkB7+hCM;IAOI,4BAAA;ElB0+hCV;;EkBj/hCM;IAOI,kCAAA;ElB8+hCV;;EkBr/hCM;IAOI,sCAAA;ElBk/hCV;;EkBz/hCM;IAOI,oCAAA;ElBs/hCV;;EkB7/hCM;IAOI,kCAAA;ElB0/hCV;;EkBjgiCM;IAOI,yCAAA;ElB8/hCV;;EkBrgiCM;IAOI,wCAAA;ElBkgiCV;;EkBzgiCM;IAOI,wCAAA;ElBsgiCV;;EkB7giCM;IAOI,kCAAA;ElB0giCV;;EkBjhiCM;IAOI,gCAAA;ElB8giCV;;EkBrhiCM;IAOI,8BAAA;ElBkhiCV;;EkBzhiCM;IAOI,gCAAA;ElBshiCV;;EkB7hiCM;IAOI,+BAAA;ElB0hiCV;;EkBjiiCM;IAOI,oCAAA;ElB8hiCV;;EkBriiCM;IAOI,kCAAA;ElBkiiCV;;EkBziiCM;IAOI,gCAAA;ElBsiiCV;;EkB7iiCM;IAOI,uCAAA;ElB0iiCV;;EkBjjiCM;IAOI,sCAAA;ElB8iiCV;;EkBrjiCM;IAOI,iCAAA;ElBkjiCV;;EkBzjiCM;IAOI,2BAAA;ElBsjiCV;;EkB7jiCM;IAOI,iCAAA;ElB0jiCV;;EkBjkiCM;IAOI,+BAAA;ElB8jiCV;;EkBrkiCM;IAOI,6BAAA;ElBkkiCV;;EkBzkiCM;IAOI,+BAAA;ElBskiCV;;EkB7kiCM;IAOI,8BAAA;ElB0kiCV;;EkBjliCM;IAOI,oBAAA;ElB8kiCV;;EkBrliCM;IAOI,mBAAA;ElBkliCV;;EkBzliCM;IAOI,mBAAA;ElBsliCV;;EkB7liCM;IAOI,mBAAA;ElB0liCV;;EkBjmiCM;IAOI,mBAAA;ElB8liCV;;EkBrmiCM;IAOI,mBAAA;ElBkmiCV;;EkBzmiCM;IAOI,mBAAA;ElBsmiCV;;EkB7miCM;IAOI,mBAAA;ElB0miCV;;EkBjniCM;IAOI,oBAAA;ElB8miCV;;EkBrniCM;IAOI,0BAAA;ElBkniCV;;EkBzniCM;IAOI,yBAAA;ElBsniCV;;EkB7niCM;IAOI,0BAAA;ElB0niCV;;EkBjoiCM;IAOI,uBAAA;ElB8niCV;;EkBroiCM;IAOI,0BAAA;ElBkoiCV;;EkBzoiCM;IAOI,yBAAA;ElBsoiCV;;EkB7oiCM;IAOI,0BAAA;ElB0oiCV;;EkBjpiCM;IAOI,uBAAA;ElB8oiCV;;EkBrpiCM;IAOI,0BAAA;ElBkpiCV;;EkBzpiCM;IAOI,yBAAA;ElBspiCV;;EkB7piCM;IAOI,0BAAA;ElB0piCV;;EkBjqiCM;IAOI,uBAAA;ElB8piCV;;EkBrqiCM;IAOI,0BAAA;ElBkqiCV;;EkBzqiCM;IAOI,yBAAA;ElBsqiCV;;EkB7qiCM;IAOI,0BAAA;ElB0qiCV;;EkBjriCM;IAOI,uBAAA;ElB8qiCV;;EkBrriCM;IAOI,0BAAA;ElBkriCV;;EkBzriCM;IAOI,yBAAA;ElBsriCV;;EkB7riCM;IAOI,0BAAA;ElB0riCV;;EkBjsiCM;IAOI,uBAAA;ElB8riCV;;EkBrsiCM;IAOI,uBAAA;ElBksiCV;;EkBzsiCM;IAOI,0BAAA;IAAA,yBAAA;ElBusiCV;;EkB9siCM;IAOI,gCAAA;IAAA,+BAAA;ElB4siCV;;EkBntiCM;IAOI,+BAAA;IAAA,8BAAA;ElBitiCV;;EkBxtiCM;IAOI,gCAAA;IAAA,+BAAA;ElBstiCV;;EkB7tiCM;IAOI,6BAAA;IAAA,4BAAA;ElB2tiCV;;EkBluiCM;IAOI,gCAAA;IAAA,+BAAA;ElBguiCV;;EkBvuiCM;IAOI,+BAAA;IAAA,8BAAA;ElBquiCV;;EkB5uiCM;IAOI,gCAAA;IAAA,+BAAA;ElB0uiCV;;EkBjviCM;IAOI,6BAAA;IAAA,4BAAA;ElB+uiCV;;EkBtviCM;IAOI,gCAAA;IAAA,+BAAA;ElBoviCV;;EkB3viCM;IAOI,+BAAA;IAAA,8BAAA;ElByviCV;;EkBhwiCM;IAOI,gCAAA;IAAA,+BAAA;ElB8viCV;;EkBrwiCM;IAOI,6BAAA;IAAA,4BAAA;ElBmwiCV;;EkB1wiCM;IAOI,gCAAA;IAAA,+BAAA;ElBwwiCV;;EkB/wiCM;IAOI,+BAAA;IAAA,8BAAA;ElB6wiCV;;EkBpxiCM;IAOI,gCAAA;IAAA,+BAAA;ElBkxiCV;;EkBzxiCM;IAOI,6BAAA;IAAA,4BAAA;ElBuxiCV;;EkB9xiCM;IAOI,gCAAA;IAAA,+BAAA;ElB4xiCV;;EkBnyiCM;IAOI,+BAAA;IAAA,8BAAA;ElBiyiCV;;EkBxyiCM;IAOI,gCAAA;IAAA,+BAAA;ElBsyiCV;;EkB7yiCM;IAOI,6BAAA;IAAA,4BAAA;ElB2yiCV;;EkBlziCM;IAOI,6BAAA;IAAA,4BAAA;ElBgziCV;;EkBvziCM;IAOI,wBAAA;IAAA,2BAAA;ElBqziCV;;EkB5ziCM;IAOI,8BAAA;IAAA,iCAAA;ElB0ziCV;;EkBj0iCM;IAOI,6BAAA;IAAA,gCAAA;ElB+ziCV;;EkBt0iCM;IAOI,8BAAA;IAAA,iCAAA;ElBo0iCV;;EkB30iCM;IAOI,2BAAA;IAAA,8BAAA;ElBy0iCV;;EkBh1iCM;IAOI,8BAAA;IAAA,iCAAA;ElB80iCV;;EkBr1iCM;IAOI,6BAAA;IAAA,gCAAA;ElBm1iCV;;EkB11iCM;IAOI,8BAAA;IAAA,iCAAA;ElBw1iCV;;EkB/1iCM;IAOI,2BAAA;IAAA,8BAAA;ElB61iCV;;EkBp2iCM;IAOI,8BAAA;IAAA,iCAAA;ElBk2iCV;;EkBz2iCM;IAOI,6BAAA;IAAA,gCAAA;ElBu2iCV;;EkB92iCM;IAOI,8BAAA;IAAA,iCAAA;ElB42iCV;;EkBn3iCM;IAOI,2BAAA;IAAA,8BAAA;ElBi3iCV;;EkBx3iCM;IAOI,8BAAA;IAAA,iCAAA;ElBs3iCV;;EkB73iCM;IAOI,6BAAA;IAAA,gCAAA;ElB23iCV;;EkBl4iCM;IAOI,8BAAA;IAAA,iCAAA;ElBg4iCV;;EkBv4iCM;IAOI,2BAAA;IAAA,8BAAA;ElBq4iCV;;EkB54iCM;IAOI,8BAAA;IAAA,iCAAA;ElB04iCV;;EkBj5iCM;IAOI,6BAAA;IAAA,gCAAA;ElB+4iCV;;EkBt5iCM;IAOI,8BAAA;IAAA,iCAAA;ElBo5iCV;;EkB35iCM;IAOI,2BAAA;IAAA,8BAAA;ElBy5iCV;;EkBh6iCM;IAOI,2BAAA;IAAA,8BAAA;ElB85iCV;;EkBr6iCM;IAOI,wBAAA;ElBk6iCV;;EkBz6iCM;IAOI,8BAAA;ElBs6iCV;;EkB76iCM;IAOI,6BAAA;ElB06iCV;;EkBj7iCM;IAOI,8BAAA;ElB86iCV;;EkBr7iCM;IAOI,2BAAA;ElBk7iCV;;EkBz7iCM;IAOI,8BAAA;ElBs7iCV;;EkB77iCM;IAOI,6BAAA;ElB07iCV;;EkBj8iCM;IAOI,8BAAA;ElB87iCV;;EkBr8iCM;IAOI,2BAAA;ElBk8iCV;;EkBz8iCM;IAOI,8BAAA;ElBs8iCV;;EkB78iCM;IAOI,6BAAA;ElB08iCV;;EkBj9iCM;IAOI,8BAAA;ElB88iCV;;EkBr9iCM;IAOI,2BAAA;ElBk9iCV;;EkBz9iCM;IAOI,8BAAA;ElBs9iCV;;EkB79iCM;IAOI,6BAAA;ElB09iCV;;EkBj+iCM;IAOI,8BAAA;ElB89iCV;;EkBr+iCM;IAOI,2BAAA;ElBk+iCV;;EkBz+iCM;IAOI,8BAAA;ElBs+iCV;;EkB7+iCM;IAOI,6BAAA;ElB0+iCV;;EkBj/iCM;IAOI,8BAAA;ElB8+iCV;;EkBr/iCM;IAOI,2BAAA;ElBk/iCV;;EkBz/iCM;IAOI,2BAAA;ElBs/iCV;;EkB7/iCM;IAOI,0BAAA;ElB0/iCV;;EkBjgjCM;IAOI,gCAAA;ElB8/iCV;;EkBrgjCM;IAOI,+BAAA;ElBkgjCV;;EkBzgjCM;IAOI,gCAAA;ElBsgjCV;;EkB7gjCM;IAOI,6BAAA;ElB0gjCV;;EkBjhjCM;IAOI,gCAAA;ElB8gjCV;;EkBrhjCM;IAOI,+BAAA;ElBkhjCV;;EkBzhjCM;IAOI,gCAAA;ElBshjCV;;EkB7hjCM;IAOI,6BAAA;ElB0hjCV;;EkBjijCM;IAOI,gCAAA;ElB8hjCV;;EkBrijCM;IAOI,+BAAA;ElBkijCV;;EkBzijCM;IAOI,gCAAA;ElBsijCV;;EkB7ijCM;IAOI,6BAAA;ElB0ijCV;;EkBjjjCM;IAOI,gCAAA;ElB8ijCV;;EkBrjjCM;IAOI,+BAAA;ElBkjjCV;;EkBzjjCM;IAOI,gCAAA;ElBsjjCV;;EkB7jjCM;IAOI,6BAAA;ElB0jjCV;;EkBjkjCM;IAOI,gCAAA;ElB8jjCV;;EkBrkjCM;IAOI,+BAAA;ElBkkjCV;;EkBzkjCM;IAOI,gCAAA;ElBskjCV;;EkB7kjCM;IAOI,6BAAA;ElB0kjCV;;EkBjljCM;IAOI,6BAAA;ElB8kjCV;;EkBrljCM;IAOI,2BAAA;ElBkljCV;;EkBzljCM;IAOI,iCAAA;ElBsljCV;;EkB7ljCM;IAOI,gCAAA;ElB0ljCV;;EkBjmjCM;IAOI,iCAAA;ElB8ljCV;;EkBrmjCM;IAOI,8BAAA;ElBkmjCV;;EkBzmjCM;IAOI,iCAAA;ElBsmjCV;;EkB7mjCM;IAOI,gCAAA;ElB0mjCV;;EkBjnjCM;IAOI,iCAAA;ElB8mjCV;;EkBrnjCM;IAOI,8BAAA;ElBknjCV;;EkBznjCM;IAOI,iCAAA;ElBsnjCV;;EkB7njCM;IAOI,gCAAA;ElB0njCV;;EkBjojCM;IAOI,iCAAA;ElB8njCV;;EkBrojCM;IAOI,8BAAA;ElBkojCV;;EkBzojCM;IAOI,iCAAA;ElBsojCV;;EkB7ojCM;IAOI,gCAAA;ElB0ojCV;;EkBjpjCM;IAOI,iCAAA;ElB8ojCV;;EkBrpjCM;IAOI,8BAAA;ElBkpjCV;;EkBzpjCM;IAOI,iCAAA;ElBspjCV;;EkB7pjCM;IAOI,gCAAA;ElB0pjCV;;EkBjqjCM;IAOI,iCAAA;ElB8pjCV;;EkBrqjCM;IAOI,8BAAA;ElBkqjCV;;EkBzqjCM;IAOI,8BAAA;ElBsqjCV;;EkB7qjCM;IAOI,yBAAA;ElB0qjCV;;EkBjrjCM;IAOI,+BAAA;ElB8qjCV;;EkBrrjCM;IAOI,8BAAA;ElBkrjCV;;EkBzrjCM;IAOI,+BAAA;ElBsrjCV;;EkB7rjCM;IAOI,4BAAA;ElB0rjCV;;EkBjsjCM;IAOI,+BAAA;ElB8rjCV;;EkBrsjCM;IAOI,8BAAA;ElBksjCV;;EkBzsjCM;IAOI,+BAAA;ElBssjCV;;EkB7sjCM;IAOI,4BAAA;ElB0sjCV;;EkBjtjCM;IAOI,+BAAA;ElB8sjCV;;EkBrtjCM;IAOI,8BAAA;ElBktjCV;;EkBztjCM;IAOI,+BAAA;ElBstjCV;;EkB7tjCM;IAOI,4BAAA;ElB0tjCV;;EkBjujCM;IAOI,+BAAA;ElB8tjCV;;EkBrujCM;IAOI,8BAAA;ElBkujCV;;EkBzujCM;IAOI,+BAAA;ElBsujCV;;EkB7ujCM;IAOI,4BAAA;ElB0ujCV;;EkBjvjCM;IAOI,+BAAA;ElB8ujCV;;EkBrvjCM;IAOI,8BAAA;ElBkvjCV;;EkBzvjCM;IAOI,+BAAA;ElBsvjCV;;EkB7vjCM;IAOI,4BAAA;ElB0vjCV;;EkBjwjCM;IAOI,4BAAA;ElB8vjCV;;EkBrwjCM;IAOI,2BAAA;ElBkwjCV;;EkBzwjCM;IAOI,0BAAA;ElBswjCV;;EkB7wjCM;IAOI,2BAAA;ElB0wjCV;;EkBjxjCM;IAOI,wBAAA;ElB8wjCV;;EkBrxjCM;IAOI,2BAAA;ElBkxjCV;;EkBzxjCM;IAOI,0BAAA;ElBsxjCV;;EkB7xjCM;IAOI,2BAAA;ElB0xjCV;;EkBjyjCM;IAOI,wBAAA;ElB8xjCV;;EkBryjCM;IAOI,2BAAA;ElBkyjCV;;EkBzyjCM;IAOI,0BAAA;ElBsyjCV;;EkB7yjCM;IAOI,2BAAA;ElB0yjCV;;EkBjzjCM;IAOI,wBAAA;ElB8yjCV;;EkBrzjCM;IAOI,2BAAA;ElBkzjCV;;EkBzzjCM;IAOI,0BAAA;ElBszjCV;;EkB7zjCM;IAOI,2BAAA;ElB0zjCV;;EkBj0jCM;IAOI,wBAAA;ElB8zjCV;;EkBr0jCM;IAOI,2BAAA;ElBk0jCV;;EkBz0jCM;IAOI,0BAAA;ElBs0jCV;;EkB70jCM;IAOI,2BAAA;ElB00jCV;;EkBj1jCM;IAOI,wBAAA;ElB80jCV;;EkBr1jCM;IAOI,iCAAA;IAAA,gCAAA;ElBm1jCV;;EkB11jCM;IAOI,gCAAA;IAAA,+BAAA;ElBw1jCV;;EkB/1jCM;IAOI,iCAAA;IAAA,gCAAA;ElB61jCV;;EkBp2jCM;IAOI,8BAAA;IAAA,6BAAA;ElBk2jCV;;EkBz2jCM;IAOI,iCAAA;IAAA,gCAAA;ElBu2jCV;;EkB92jCM;IAOI,gCAAA;IAAA,+BAAA;ElB42jCV;;EkBn3jCM;IAOI,iCAAA;IAAA,gCAAA;ElBi3jCV;;EkBx3jCM;IAOI,8BAAA;IAAA,6BAAA;ElBs3jCV;;EkB73jCM;IAOI,iCAAA;IAAA,gCAAA;ElB23jCV;;EkBl4jCM;IAOI,gCAAA;IAAA,+BAAA;ElBg4jCV;;EkBv4jCM;IAOI,iCAAA;IAAA,gCAAA;ElBq4jCV;;EkB54jCM;IAOI,8BAAA;IAAA,6BAAA;ElB04jCV;;EkBj5jCM;IAOI,iCAAA;IAAA,gCAAA;ElB+4jCV;;EkBt5jCM;IAOI,gCAAA;IAAA,+BAAA;ElBo5jCV;;EkB35jCM;IAOI,iCAAA;IAAA,gCAAA;ElBy5jCV;;EkBh6jCM;IAOI,8BAAA;IAAA,6BAAA;ElB85jCV;;EkBr6jCM;IAOI,iCAAA;IAAA,gCAAA;ElBm6jCV;;EkB16jCM;IAOI,gCAAA;IAAA,+BAAA;ElBw6jCV;;EkB/6jCM;IAOI,iCAAA;IAAA,gCAAA;ElB66jCV;;EkBp7jCM;IAOI,8BAAA;IAAA,6BAAA;ElBk7jCV;;EkBz7jCM;IAOI,+BAAA;IAAA,kCAAA;ElBu7jCV;;EkB97jCM;IAOI,8BAAA;IAAA,iCAAA;ElB47jCV;;EkBn8jCM;IAOI,+BAAA;IAAA,kCAAA;ElBi8jCV;;EkBx8jCM;IAOI,4BAAA;IAAA,+BAAA;ElBs8jCV;;EkB78jCM;IAOI,+BAAA;IAAA,kCAAA;ElB28jCV;;EkBl9jCM;IAOI,8BAAA;IAAA,iCAAA;ElBg9jCV;;EkBv9jCM;IAOI,+BAAA;IAAA,kCAAA;ElBq9jCV;;EkB59jCM;IAOI,4BAAA;IAAA,+BAAA;ElB09jCV;;EkBj+jCM;IAOI,+BAAA;IAAA,kCAAA;ElB+9jCV;;EkBt+jCM;IAOI,8BAAA;IAAA,iCAAA;ElBo+jCV;;EkB3+jCM;IAOI,+BAAA;IAAA,kCAAA;ElBy+jCV;;EkBh/jCM;IAOI,4BAAA;IAAA,+BAAA;ElB8+jCV;;EkBr/jCM;IAOI,+BAAA;IAAA,kCAAA;ElBm/jCV;;EkB1/jCM;IAOI,8BAAA;IAAA,iCAAA;ElBw/jCV;;EkB//jCM;IAOI,+BAAA;IAAA,kCAAA;ElB6/jCV;;EkBpgkCM;IAOI,4BAAA;IAAA,+BAAA;ElBkgkCV;;EkBzgkCM;IAOI,+BAAA;IAAA,kCAAA;ElBugkCV;;EkB9gkCM;IAOI,8BAAA;IAAA,iCAAA;ElB4gkCV;;EkBnhkCM;IAOI,+BAAA;IAAA,kCAAA;ElBihkCV;;EkBxhkCM;IAOI,4BAAA;IAAA,+BAAA;ElBshkCV;;EkB7hkCM;IAOI,+BAAA;ElB0hkCV;;EkBjikCM;IAOI,8BAAA;ElB8hkCV;;EkBrikCM;IAOI,+BAAA;ElBkikCV;;EkBzikCM;IAOI,4BAAA;ElBsikCV;;EkB7ikCM;IAOI,+BAAA;ElB0ikCV;;EkBjjkCM;IAOI,8BAAA;ElB8ikCV;;EkBrjkCM;IAOI,+BAAA;ElBkjkCV;;EkBzjkCM;IAOI,4BAAA;ElBsjkCV;;EkB7jkCM;IAOI,+BAAA;ElB0jkCV;;EkBjkkCM;IAOI,8BAAA;ElB8jkCV;;EkBrkkCM;IAOI,+BAAA;ElBkkkCV;;EkBzkkCM;IAOI,4BAAA;ElBskkCV;;EkB7kkCM;IAOI,+BAAA;ElB0kkCV;;EkBjlkCM;IAOI,8BAAA;ElB8kkCV;;EkBrlkCM;IAOI,+BAAA;ElBklkCV;;EkBzlkCM;IAOI,4BAAA;ElBslkCV;;EkB7lkCM;IAOI,+BAAA;ElB0lkCV;;EkBjmkCM;IAOI,8BAAA;ElB8lkCV;;EkBrmkCM;IAOI,+BAAA;ElBkmkCV;;EkBzmkCM;IAOI,4BAAA;ElBsmkCV;;EkB7mkCM;IAOI,iCAAA;ElB0mkCV;;EkBjnkCM;IAOI,gCAAA;ElB8mkCV;;EkBrnkCM;IAOI,iCAAA;ElBknkCV;;EkBznkCM;IAOI,8BAAA;ElBsnkCV;;EkB7nkCM;IAOI,iCAAA;ElB0nkCV;;EkBjokCM;IAOI,gCAAA;ElB8nkCV;;EkBrokCM;IAOI,iCAAA;ElBkokCV;;EkBzokCM;IAOI,8BAAA;ElBsokCV;;EkB7okCM;IAOI,iCAAA;ElB0okCV;;EkBjpkCM;IAOI,gCAAA;ElB8okCV;;EkBrpkCM;IAOI,iCAAA;ElBkpkCV;;EkBzpkCM;IAOI,8BAAA;ElBspkCV;;EkB7pkCM;IAOI,iCAAA;ElB0pkCV;;EkBjqkCM;IAOI,gCAAA;ElB8pkCV;;EkBrqkCM;IAOI,iCAAA;ElBkqkCV;;EkBzqkCM;IAOI,8BAAA;ElBsqkCV;;EkB7qkCM;IAOI,iCAAA;ElB0qkCV;;EkBjrkCM;IAOI,gCAAA;ElB8qkCV;;EkBrrkCM;IAOI,iCAAA;ElBkrkCV;;EkBzrkCM;IAOI,8BAAA;ElBsrkCV;;EkB7rkCM;IAOI,kCAAA;ElB0rkCV;;EkBjskCM;IAOI,iCAAA;ElB8rkCV;;EkBrskCM;IAOI,kCAAA;ElBkskCV;;EkBzskCM;IAOI,+BAAA;ElBsskCV;;EkB7skCM;IAOI,kCAAA;ElB0skCV;;EkBjtkCM;IAOI,iCAAA;ElB8skCV;;EkBrtkCM;IAOI,kCAAA;ElBktkCV;;EkBztkCM;IAOI,+BAAA;ElBstkCV;;EkB7tkCM;IAOI,kCAAA;ElB0tkCV;;EkBjukCM;IAOI,iCAAA;ElB8tkCV;;EkBrukCM;IAOI,kCAAA;ElBkukCV;;EkBzukCM;IAOI,+BAAA;ElBsukCV;;EkB7ukCM;IAOI,kCAAA;ElB0ukCV;;EkBjvkCM;IAOI,iCAAA;ElB8ukCV;;EkBrvkCM;IAOI,kCAAA;ElBkvkCV;;EkBzvkCM;IAOI,+BAAA;ElBsvkCV;;EkB7vkCM;IAOI,kCAAA;ElB0vkCV;;EkBjwkCM;IAOI,iCAAA;ElB8vkCV;;EkBrwkCM;IAOI,kCAAA;ElBkwkCV;;EkBzwkCM;IAOI,+BAAA;ElBswkCV;;EkB7wkCM;IAOI,gCAAA;ElB0wkCV;;EkBjxkCM;IAOI,+BAAA;ElB8wkCV;;EkBrxkCM;IAOI,gCAAA;ElBkxkCV;;EkBzxkCM;IAOI,6BAAA;ElBsxkCV;;EkB7xkCM;IAOI,gCAAA;ElB0xkCV;;EkBjykCM;IAOI,+BAAA;ElB8xkCV;;EkBrykCM;IAOI,gCAAA;ElBkykCV;;EkBzykCM;IAOI,6BAAA;ElBsykCV;;EkB7ykCM;IAOI,gCAAA;ElB0ykCV;;EkBjzkCM;IAOI,+BAAA;ElB8ykCV;;EkBrzkCM;IAOI,gCAAA;ElBkzkCV;;EkBzzkCM;IAOI,6BAAA;ElBszkCV;;EkB7zkCM;IAOI,gCAAA;ElB0zkCV;;EkBj0kCM;IAOI,+BAAA;ElB8zkCV;;EkBr0kCM;IAOI,gCAAA;ElBk0kCV;;EkBz0kCM;IAOI,6BAAA;ElBs0kCV;;EkB70kCM;IAOI,gCAAA;ElB00kCV;;EkBj1kCM;IAOI,+BAAA;ElB80kCV;;EkBr1kCM;IAOI,gCAAA;ElBk1kCV;;EkBz1kCM;IAOI,6BAAA;ElBs1kCV;;EkB71kCM;IAOI,qBAAA;ElB01kCV;;EkBj2kCM;IAOI,2BAAA;ElB81kCV;;EkBr2kCM;IAOI,0BAAA;ElBk2kCV;;EkBz2kCM;IAOI,2BAAA;ElBs2kCV;;EkB72kCM;IAOI,wBAAA;ElB02kCV;;EkBj3kCM;IAOI,2BAAA;ElB82kCV;;EkBr3kCM;IAOI,0BAAA;ElBk3kCV;;EkBz3kCM;IAOI,2BAAA;ElBs3kCV;;EkB73kCM;IAOI,wBAAA;ElB03kCV;;EkBj4kCM;IAOI,2BAAA;ElB83kCV;;EkBr4kCM;IAOI,0BAAA;ElBk4kCV;;EkBz4kCM;IAOI,2BAAA;ElBs4kCV;;EkB74kCM;IAOI,wBAAA;ElB04kCV;;EkBj5kCM;IAOI,2BAAA;ElB84kCV;;EkBr5kCM;IAOI,0BAAA;ElBk5kCV;;EkBz5kCM;IAOI,2BAAA;ElBs5kCV;;EkB75kCM;IAOI,wBAAA;ElB05kCV;;EkBj6kCM;IAOI,2BAAA;ElB85kCV;;EkBr6kCM;IAOI,0BAAA;ElBk6kCV;;EkBz6kCM;IAOI,2BAAA;ElBs6kCV;;EkB76kCM;IAOI,wBAAA;ElB06kCV;;EkBj7kCM;IAOI,2BAAA;IAAA,0BAAA;ElB+6kCV;;EkBt7kCM;IAOI,iCAAA;IAAA,gCAAA;ElBo7kCV;;EkB37kCM;IAOI,gCAAA;IAAA,+BAAA;ElBy7kCV;;EkBh8kCM;IAOI,iCAAA;IAAA,gCAAA;ElB87kCV;;EkBr8kCM;IAOI,8BAAA;IAAA,6BAAA;ElBm8kCV;;EkB18kCM;IAOI,iCAAA;IAAA,gCAAA;ElBw8kCV;;EkB/8kCM;IAOI,gCAAA;IAAA,+BAAA;ElB68kCV;;EkBp9kCM;IAOI,iCAAA;IAAA,gCAAA;ElBk9kCV;;EkBz9kCM;IAOI,8BAAA;IAAA,6BAAA;ElBu9kCV;;EkB99kCM;IAOI,iCAAA;IAAA,gCAAA;ElB49kCV;;EkBn+kCM;IAOI,gCAAA;IAAA,+BAAA;ElBi+kCV;;EkBx+kCM;IAOI,iCAAA;IAAA,gCAAA;ElBs+kCV;;EkB7+kCM;IAOI,8BAAA;IAAA,6BAAA;ElB2+kCV;;EkBl/kCM;IAOI,iCAAA;IAAA,gCAAA;ElBg/kCV;;EkBv/kCM;IAOI,gCAAA;IAAA,+BAAA;ElBq/kCV;;EkB5/kCM;IAOI,iCAAA;IAAA,gCAAA;ElB0/kCV;;EkBjglCM;IAOI,8BAAA;IAAA,6BAAA;ElB+/kCV;;EkBtglCM;IAOI,iCAAA;IAAA,gCAAA;ElBoglCV;;EkB3glCM;IAOI,gCAAA;IAAA,+BAAA;ElByglCV;;EkBhhlCM;IAOI,iCAAA;IAAA,gCAAA;ElB8glCV;;EkBrhlCM;IAOI,8BAAA;IAAA,6BAAA;ElBmhlCV;;EkB1hlCM;IAOI,yBAAA;IAAA,4BAAA;ElBwhlCV;;EkB/hlCM;IAOI,+BAAA;IAAA,kCAAA;ElB6hlCV;;EkBpilCM;IAOI,8BAAA;IAAA,iCAAA;ElBkilCV;;EkBzilCM;IAOI,+BAAA;IAAA,kCAAA;ElBuilCV;;EkB9ilCM;IAOI,4BAAA;IAAA,+BAAA;ElB4ilCV;;EkBnjlCM;IAOI,+BAAA;IAAA,kCAAA;ElBijlCV;;EkBxjlCM;IAOI,8BAAA;IAAA,iCAAA;ElBsjlCV;;EkB7jlCM;IAOI,+BAAA;IAAA,kCAAA;ElB2jlCV;;EkBlklCM;IAOI,4BAAA;IAAA,+BAAA;ElBgklCV;;EkBvklCM;IAOI,+BAAA;IAAA,kCAAA;ElBqklCV;;EkB5klCM;IAOI,8BAAA;IAAA,iCAAA;ElB0klCV;;EkBjllCM;IAOI,+BAAA;IAAA,kCAAA;ElB+klCV;;EkBtllCM;IAOI,4BAAA;IAAA,+BAAA;ElBollCV;;EkB3llCM;IAOI,+BAAA;IAAA,kCAAA;ElByllCV;;EkBhmlCM;IAOI,8BAAA;IAAA,iCAAA;ElB8llCV;;EkBrmlCM;IAOI,+BAAA;IAAA,kCAAA;ElBmmlCV;;EkB1mlCM;IAOI,4BAAA;IAAA,+BAAA;ElBwmlCV;;EkB/mlCM;IAOI,+BAAA;IAAA,kCAAA;ElB6mlCV;;EkBpnlCM;IAOI,8BAAA;IAAA,iCAAA;ElBknlCV;;EkBznlCM;IAOI,+BAAA;IAAA,kCAAA;ElBunlCV;;EkB9nlCM;IAOI,4BAAA;IAAA,+BAAA;ElB4nlCV;;EkBnolCM;IAOI,yBAAA;ElBgolCV;;EkBvolCM;IAOI,+BAAA;ElBoolCV;;EkB3olCM;IAOI,8BAAA;ElBwolCV;;EkB/olCM;IAOI,+BAAA;ElB4olCV;;EkBnplCM;IAOI,4BAAA;ElBgplCV;;EkBvplCM;IAOI,+BAAA;ElBoplCV;;EkB3plCM;IAOI,8BAAA;ElBwplCV;;EkB/plCM;IAOI,+BAAA;ElB4plCV;;EkBnqlCM;IAOI,4BAAA;ElBgqlCV;;EkBvqlCM;IAOI,+BAAA;ElBoqlCV;;EkB3qlCM;IAOI,8BAAA;ElBwqlCV;;EkB/qlCM;IAOI,+BAAA;ElB4qlCV;;EkBnrlCM;IAOI,4BAAA;ElBgrlCV;;EkBvrlCM;IAOI,+BAAA;ElBorlCV;;EkB3rlCM;IAOI,8BAAA;ElBwrlCV;;EkB/rlCM;IAOI,+BAAA;ElB4rlCV;;EkBnslCM;IAOI,4BAAA;ElBgslCV;;EkBvslCM;IAOI,+BAAA;ElBoslCV;;EkB3slCM;IAOI,8BAAA;ElBwslCV;;EkB/slCM;IAOI,+BAAA;ElB4slCV;;EkBntlCM;IAOI,4BAAA;ElBgtlCV;;EkBvtlCM;IAOI,2BAAA;ElBotlCV;;EkB3tlCM;IAOI,iCAAA;ElBwtlCV;;EkB/tlCM;IAOI,gCAAA;ElB4tlCV;;EkBnulCM;IAOI,iCAAA;ElBgulCV;;EkBvulCM;IAOI,8BAAA;ElBoulCV;;EkB3ulCM;IAOI,iCAAA;ElBwulCV;;EkB/ulCM;IAOI,gCAAA;ElB4ulCV;;EkBnvlCM;IAOI,iCAAA;ElBgvlCV;;EkBvvlCM;IAOI,8BAAA;ElBovlCV;;EkB3vlCM;IAOI,iCAAA;ElBwvlCV;;EkB/vlCM;IAOI,gCAAA;ElB4vlCV;;EkBnwlCM;IAOI,iCAAA;ElBgwlCV;;EkBvwlCM;IAOI,8BAAA;ElBowlCV;;EkB3wlCM;IAOI,iCAAA;ElBwwlCV;;EkB/wlCM;IAOI,gCAAA;ElB4wlCV;;EkBnxlCM;IAOI,iCAAA;ElBgxlCV;;EkBvxlCM;IAOI,8BAAA;ElBoxlCV;;EkB3xlCM;IAOI,iCAAA;ElBwxlCV;;EkB/xlCM;IAOI,gCAAA;ElB4xlCV;;EkBnylCM;IAOI,iCAAA;ElBgylCV;;EkBvylCM;IAOI,8BAAA;ElBoylCV;;EkB3ylCM;IAOI,4BAAA;ElBwylCV;;EkB/ylCM;IAOI,kCAAA;ElB4ylCV;;EkBnzlCM;IAOI,iCAAA;ElBgzlCV;;EkBvzlCM;IAOI,kCAAA;ElBozlCV;;EkB3zlCM;IAOI,+BAAA;ElBwzlCV;;EkB/zlCM;IAOI,kCAAA;ElB4zlCV;;EkBn0lCM;IAOI,iCAAA;ElBg0lCV;;EkBv0lCM;IAOI,kCAAA;ElBo0lCV;;EkB30lCM;IAOI,+BAAA;ElBw0lCV;;EkB/0lCM;IAOI,kCAAA;ElB40lCV;;EkBn1lCM;IAOI,iCAAA;ElBg1lCV;;EkBv1lCM;IAOI,kCAAA;ElBo1lCV;;EkB31lCM;IAOI,+BAAA;ElBw1lCV;;EkB/1lCM;IAOI,kCAAA;ElB41lCV;;EkBn2lCM;IAOI,iCAAA;ElBg2lCV;;EkBv2lCM;IAOI,kCAAA;ElBo2lCV;;EkB32lCM;IAOI,+BAAA;ElBw2lCV;;EkB/2lCM;IAOI,kCAAA;ElB42lCV;;EkBn3lCM;IAOI,iCAAA;ElBg3lCV;;EkBv3lCM;IAOI,kCAAA;ElBo3lCV;;EkB33lCM;IAOI,+BAAA;ElBw3lCV;;EkB/3lCM;IAOI,0BAAA;ElB43lCV;;EkBn4lCM;IAOI,gCAAA;ElBg4lCV;;EkBv4lCM;IAOI,+BAAA;ElBo4lCV;;EkB34lCM;IAOI,gCAAA;ElBw4lCV;;EkB/4lCM;IAOI,6BAAA;ElB44lCV;;EkBn5lCM;IAOI,gCAAA;ElBg5lCV;;EkBv5lCM;IAOI,+BAAA;ElBo5lCV;;EkB35lCM;IAOI,gCAAA;ElBw5lCV;;EkB/5lCM;IAOI,6BAAA;ElB45lCV;;EkBn6lCM;IAOI,gCAAA;ElBg6lCV;;EkBv6lCM;IAOI,+BAAA;ElBo6lCV;;EkB36lCM;IAOI,gCAAA;ElBw6lCV;;EkB/6lCM;IAOI,6BAAA;ElB46lCV;;EkBn7lCM;IAOI,gCAAA;ElBg7lCV;;EkBv7lCM;IAOI,+BAAA;ElBo7lCV;;EkB37lCM;IAOI,gCAAA;ElBw7lCV;;EkB/7lCM;IAOI,6BAAA;ElB47lCV;;EkBn8lCM;IAOI,gCAAA;ElBg8lCV;;EkBv8lCM;IAOI,+BAAA;ElBo8lCV;;EkB38lCM;IAOI,gCAAA;ElBw8lCV;;EkB/8lCM;IAOI,6BAAA;ElB48lCV;;EkBn9lCM;IAOI,iBAAA;ElBg9lCV;;EkBv9lCM;IAOI,uBAAA;ElBo9lCV;;EkB39lCM;IAOI,sBAAA;ElBw9lCV;;EkB/9lCM;IAOI,uBAAA;ElB49lCV;;EkBn+lCM;IAOI,oBAAA;ElBg+lCV;;EkBv+lCM;IAOI,uBAAA;ElBo+lCV;;EkB3+lCM;IAOI,sBAAA;ElBw+lCV;;EkB/+lCM;IAOI,uBAAA;ElB4+lCV;;EkBn/lCM;IAOI,oBAAA;ElBg/lCV;;EkBv/lCM;IAOI,uBAAA;ElBo/lCV;;EkB3/lCM;IAOI,sBAAA;ElBw/lCV;;EkB//lCM;IAOI,uBAAA;ElB4/lCV;;EkBngmCM;IAOI,oBAAA;ElBggmCV;;EkBvgmCM;IAOI,uBAAA;ElBogmCV;;EkB3gmCM;IAOI,sBAAA;ElBwgmCV;;EkB/gmCM;IAOI,uBAAA;ElB4gmCV;;EkBnhmCM;IAOI,oBAAA;ElBghmCV;;EkBvhmCM;IAOI,uBAAA;ElBohmCV;;EkB3hmCM;IAOI,sBAAA;ElBwhmCV;;EkB/hmCM;IAOI,uBAAA;ElB4hmCV;;EkBnimCM;IAOI,oBAAA;ElBgimCV;;EkBvimCM;IAOI,qBAAA;ElBoimCV;;EkB3imCM;IAOI,2BAAA;ElBwimCV;;EkB/imCM;IAOI,0BAAA;ElB4imCV;;EkBnjmCM;IAOI,2BAAA;ElBgjmCV;;EkBvjmCM;IAOI,wBAAA;ElBojmCV;;EkB3jmCM;IAOI,2BAAA;ElBwjmCV;;EkB/jmCM;IAOI,0BAAA;ElB4jmCV;;EkBnkmCM;IAOI,2BAAA;ElBgkmCV;;EkBvkmCM;IAOI,wBAAA;ElBokmCV;;EkB3kmCM;IAOI,2BAAA;ElBwkmCV;;EkB/kmCM;IAOI,0BAAA;ElB4kmCV;;EkBnlmCM;IAOI,2BAAA;ElBglmCV;;EkBvlmCM;IAOI,wBAAA;ElBolmCV;;EkB3lmCM;IAOI,2BAAA;ElBwlmCV;;EkB/lmCM;IAOI,0BAAA;ElB4lmCV;;EkBnmmCM;IAOI,2BAAA;ElBgmmCV;;EkBvmmCM;IAOI,wBAAA;ElBommCV;;EkB3mmCM;IAOI,2BAAA;ElBwmmCV;;EkB/mmCM;IAOI,0BAAA;ElB4mmCV;;EkBnnmCM;IAOI,2BAAA;ElBgnmCV;;EkBvnmCM;IAOI,wBAAA;ElBonmCV;;EkB3nmCM;IAOI,wBAAA;ElBwnmCV;;EkB/nmCM;IAOI,8BAAA;ElB4nmCV;;EkBnomCM;IAOI,6BAAA;ElBgomCV;;EkBvomCM;IAOI,8BAAA;ElBoomCV;;EkB3omCM;IAOI,2BAAA;ElBwomCV;;EkB/omCM;IAOI,8BAAA;ElB4omCV;;EkBnpmCM;IAOI,6BAAA;ElBgpmCV;;EkBvpmCM;IAOI,8BAAA;ElBopmCV;;EkB3pmCM;IAOI,2BAAA;ElBwpmCV;;EkB/pmCM;IAOI,8BAAA;ElB4pmCV;;EkBnqmCM;IAOI,6BAAA;ElBgqmCV;;EkBvqmCM;IAOI,8BAAA;ElBoqmCV;;EkB3qmCM;IAOI,2BAAA;ElBwqmCV;;EkB/qmCM;IAOI,8BAAA;ElB4qmCV;;EkBnrmCM;IAOI,6BAAA;ElBgrmCV;;EkBvrmCM;IAOI,8BAAA;ElBormCV;;EkB3rmCM;IAOI,2BAAA;ElBwrmCV;;EkB/rmCM;IAOI,8BAAA;ElB4rmCV;;EkBnsmCM;IAOI,6BAAA;ElBgsmCV;;EkBvsmCM;IAOI,8BAAA;ElBosmCV;;EkB3smCM;IAOI,2BAAA;ElBwsmCV;;EkB/smCM;IAOI,0CAAA;ElB4smCV;;EkBntmCM;IAOI,4CAAA;ElBgtmCV;;EkBvtmCM;IAOI,4CAAA;ElBotmCV;;EkB3tmCM;IAOI,6BAAA;ElBwtmCV;;EkB/tmCM;IAOI,6BAAA;ElB4tmCV;;EkBnumCM;IAOI,8BAAA;ElBgumCV;;EkBvumCM;IAOI,6BAAA;ElBoumCV;;EkB3umCM;IAOI,6BAAA;ElBwumCV;;EkB/umCM;IAOI,6BAAA;ElB4umCV;;EkBnvmCM;IAOI,4BAAA;ElBgvmCV;;EkBvvmCM;IAOI,0BAAA;ElBovmCV;;EkB3vmCM;IAOI,0BAAA;ElBwvmCV;;EkB/vmCM;IAOI,4CAAA;ElB4vmCV;;EkBnwmCM;IAOI,2CAAA;ElBgwmCV;;EkBvwmCM;IAOI,4CAAA;ElBowmCV;;EkB3wmCM;IAOI,0CAAA;ElBwwmCV;;EkB/wmCM;IAOI,4CAAA;ElB4wmCV;;EkBnxmCM;IAOI,2CAAA;ElBgxmCV;;EkBvxmCM;IAOI,4CAAA;ElBoxmCV;;EkB3xmCM;IAOI,wCAAA;ElBwxmCV;;EkB/xmCM;IAOI,4CAAA;ElB4xmCV;;EkBnymCM;IAOI,2CAAA;ElBgymCV;;EkBvymCM;IAOI,4CAAA;ElBoymCV;;EkB3ymCM;IAOI,0CAAA;ElBwymCV;;EkB/ymCM;IAOI,4CAAA;ElB4ymCV;;EkBnzmCM;IAOI,2CAAA;ElBgzmCV;;EkBvzmCM;IAOI,4CAAA;ElBozmCV;;EkB3zmCM;IAOI,0CAAA;ElBwzmCV;;EkB/zmCM;IAOI,2BAAA;ElB4zmCV;;EkBn0mCM;IAOI,4BAAA;ElBg0mCV;;EkBv0mCM;IAOI,6BAAA;ElBo0mCV;;EkB30mCM;IAOI,2BAAA;ElBw0mCV;;EkB/0mCM;IAOI,yBAAA;ElB40mCV;;EkBn1mCM;IAOI,yBAAA;ElBg1mCV;;EkBv1mCM;IAOI,yBAAA;ElBo1mCV;;EkB31mCM;IAOI,0BAAA;ElBw1mCV;;EkB/1mCM;IAOI,0BAAA;ElB41mCV;;EkBn2mCM;IAOI,yBAAA;ElBg2mCV;;EkBv2mCM;IAOI,yBAAA;ElBo2mCV;;EkB32mCM;IAOI,yBAAA;ElBw2mCV;;EkB/2mCM;IAOI,yBAAA;ElB42mCV;;EkBn3mCM;IAOI,yBAAA;ElBg3mCV;;EkBv3mCM;IAOI,yBAAA;ElBo3mCV;;EkB33mCM;IAOI,yBAAA;ElBw3mCV;;EkB/3mCM;IAOI,yBAAA;ElB43mCV;;EkBn4mCM;IAOI,yBAAA;ElBg4mCV;;EkBv4mCM;IAOI,0BAAA;ElBo4mCV;;EkB34mCM;IAOI,0BAAA;ElBw4mCV;;EkB/4mCM;IAOI,0BAAA;ElB44mCV;;EkBn5mCM;IAOI,0BAAA;ElBg5mCV;;EkBv5mCM;IAOI,0BAAA;ElBo5mCV;;EkB35mCM;IAOI,0BAAA;ElBw5mCV;;EkB/5mCM;IAOI,0BAAA;ElB45mCV;;EkBn6mCM;IAOI,0BAAA;ElBg6mCV;;EkBv6mCM;IAOI,0BAAA;ElBo6mCV;;EkB36mCM;IAOI,0BAAA;ElBw6mCV;;EkB/6mCM;IAOI,0BAAA;ElB46mCV;;EkBn7mCM;IAOI,0BAAA;ElBg7mCV;;EkBv7mCM;IAOI,0BAAA;ElBo7mCV;;EkB37mCM;IAOI,0BAAA;ElBw7mCV;;EkB/7mCM;IAOI,0BAAA;ElB47mCV;;EkBn8mCM;IAOI,0BAAA;ElBg8mCV;;EkBv8mCM;IAOI,0BAAA;ElBo8mCV;;EkB38mCM;IAOI,0BAAA;ElBw8mCV;;EkB/8mCM;IAOI,2BAAA;ElB48mCV;;EkBn9mCM;IAOI,2BAAA;ElBg9mCV;;EkBv9mCM;IAOI,2BAAA;ElBo9mCV;;EkB39mCM;IAOI,2BAAA;ElBw9mCV;;EkB/9mCM;IAOI,2BAAA;ElB49mCV;;EkBn+mCM;IAOI,2BAAA;ElBg+mCV;;EkBv+mCM;IAOI,2BAAA;ElBo+mCV;;EkB3+mCM;IAOI,2BAAA;ElBw+mCV;;EkB/+mCM;IAOI,2BAAA;ElB4+mCV;;EkBn/mCM;IAOI,2BAAA;ElBg/mCV;;EkBv/mCM;IAOI,2BAAA;ElBo/mCV;;EkB3/mCM;IAOI,2BAAA;ElBw/mCV;;EkB//mCM;IAOI,2BAAA;ElB4/mCV;;EkBngnCM;IAOI,2BAAA;ElBggnCV;;EkBvgnCM;IAOI,2BAAA;ElBognCV;;EkB3gnCM;IAOI,2BAAA;ElBwgnCV;;EkB/gnCM;IAOI,2BAAA;ElB4gnCV;;EkBnhnCM;IAOI,2BAAA;ElBghnCV;;EkBvhnCM;IAOI,2BAAA;ElBohnCV;;EkB3hnCM;IAOI,2BAAA;ElBwhnCV;;EkB/hnCM;IAOI,2BAAA;ElB4hnCV;;EkBninCM;IAOI,2BAAA;ElBginCV;;EkBvinCM;IAOI,2BAAA;ElBoinCV;;EkB3inCM;IAOI,2BAAA;ElBwinCV;;EkB/inCM;IAOI,2BAAA;ElB4inCV;;EkBnjnCM;IAOI,2BAAA;ElBgjnCV;;EkBvjnCM;IAOI,4BAAA;ElBojnCV;;EkB3jnCM;IAOI,4BAAA;ElBwjnCV;;EkB/jnCM;IAOI,0BAAA;ElB4jnCV;;EkBnknCM;IAOI,0BAAA;ElBgknCV;;EkBvknCM;IAOI,0BAAA;ElBoknCV;;EkB3knCM;IAOI,2BAAA;ElBwknCV;;EkB/knCM;IAOI,2BAAA;ElB4knCV;;EkBnlnCM;IAOI,0BAAA;ElBglnCV;;EkBvlnCM;IAOI,0BAAA;ElBolnCV;;EkB3lnCM;IAOI,0BAAA;ElBwlnCV;;EkB/lnCM;IAOI,0BAAA;ElB4lnCV;;EkBnmnCM;IAOI,0BAAA;ElBgmnCV;;EkBvmnCM;IAOI,0BAAA;ElBomnCV;;EkB3mnCM;IAOI,0BAAA;ElBwmnCV;;EkB/mnCM;IAOI,0BAAA;ElB4mnCV;;EkBnnnCM;IAOI,0BAAA;ElBgnnCV;;EkBvnnCM;IAOI,2BAAA;ElBonnCV;;EkB3nnCM;IAOI,2BAAA;ElBwnnCV;;EkB/nnCM;IAOI,2BAAA;ElB4nnCV;;EkBnonCM;IAOI,2BAAA;ElBgonCV;;EkBvonCM;IAOI,2BAAA;ElBoonCV;;EkB3onCM;IAOI,2BAAA;ElBwonCV;;EkB/onCM;IAOI,2BAAA;ElB4onCV;;EkBnpnCM;IAOI,2BAAA;ElBgpnCV;;EkBvpnCM;IAOI,2BAAA;ElBopnCV;;EkB3pnCM;IAOI,2BAAA;ElBwpnCV;;EkB/pnCM;IAOI,2BAAA;ElB4pnCV;;EkBnqnCM;IAOI,2BAAA;ElBgqnCV;;EkBvqnCM;IAOI,2BAAA;ElBoqnCV;;EkB3qnCM;IAOI,2BAAA;ElBwqnCV;;EkB/qnCM;IAOI,2BAAA;ElB4qnCV;;EkBnrnCM;IAOI,2BAAA;ElBgrnCV;;EkBvrnCM;IAOI,2BAAA;ElBornCV;;EkB3rnCM;IAOI,2BAAA;ElBwrnCV;;EkB/rnCM;IAOI,4BAAA;ElB4rnCV;;EkBnsnCM;IAOI,4BAAA;ElBgsnCV;;EkBvsnCM;IAOI,4BAAA;ElBosnCV;;EkB3snCM;IAOI,4BAAA;ElBwsnCV;;EkB/snCM;IAOI,4BAAA;ElB4snCV;;EkBntnCM;IAOI,4BAAA;ElBgtnCV;;EkBvtnCM;IAOI,4BAAA;ElBotnCV;;EkB3tnCM;IAOI,4BAAA;ElBwtnCV;;EkB/tnCM;IAOI,4BAAA;ElB4tnCV;;EkBnunCM;IAOI,4BAAA;ElBgunCV;;EkBvunCM;IAOI,4BAAA;ElBounCV;;EkB3unCM;IAOI,4BAAA;ElBwunCV;;EkB/unCM;IAOI,4BAAA;ElB4unCV;;EkBnvnCM;IAOI,4BAAA;ElBgvnCV;;EkBvvnCM;IAOI,4BAAA;ElBovnCV;;EkB3vnCM;IAOI,4BAAA;ElBwvnCV;;EkB/vnCM;IAOI,4BAAA;ElB4vnCV;;EkBnwnCM;IAOI,4BAAA;ElBgwnCV;;EkBvwnCM;IAOI,4BAAA;ElBownCV;;EkB3wnCM;IAOI,4BAAA;ElBwwnCV;;EkB/wnCM;IAOI,4BAAA;ElB4wnCV;;EkBnxnCM;IAOI,4BAAA;ElBgxnCV;;EkBvxnCM;IAOI,4BAAA;ElBoxnCV;;EkB3xnCM;IAOI,4BAAA;ElBwxnCV;;EkB/xnCM;IAOI,4BAAA;ElB4xnCV;;EkBnynCM;IAOI,4BAAA;ElBgynCV;;EkBvynCM;IAOI,6BAAA;ElBoynCV;AACF;AU/ynCI;EQGI;IAOI,sBAAA;ElByynCV;;EkBhznCM;IAOI,uBAAA;ElB6ynCV;;EkBpznCM;IAOI,sBAAA;ElBiznCV;;EkBxznCM;IAOI,8BAAA;ElBqznCV;;EkB5znCM;IAOI,4BAAA;ElByznCV;;EkBh0nCM;IAOI,2BAAA;ElB6znCV;;EkBp0nCM;IAOI,iCAAA;ElBi0nCV;;EkBx0nCM;IAOI,2BAAA;ElBq0nCV;;EkB50nCM;IAOI,0BAAA;ElBy0nCV;;EkBh1nCM;IAOI,gCAAA;ElB60nCV;;EkBp1nCM;IAOI,yBAAA;ElBi1nCV;;EkBx1nCM;IAOI,wBAAA;ElBq1nCV;;EkB51nCM;IAOI,+BAAA;ElBy1nCV;;EkBh2nCM;IAOI,yBAAA;ElB61nCV;;EkBp2nCM;IAOI,6BAAA;ElBi2nCV;;EkBx2nCM;IAOI,8BAAA;ElBq2nCV;;EkB52nCM;IAOI,wBAAA;ElBy2nCV;;EkBh3nCM;IAOI,+BAAA;ElB62nCV;;EkBp3nCM;IAOI,wBAAA;ElBi3nCV;;EkBx3nCM;IAOI,2BAAA;ElBq3nCV;;EkB53nCM;IAOI,6BAAA;ElBy3nCV;;EkBh4nCM;IAOI,6BAAA;ElB63nCV;;EkBp4nCM;IAOI,0BAAA;ElBi4nCV;;EkBx4nCM;IAOI,2BAAA;ElBq4nCV;;EkB54nCM;IAOI,uBAAA;ElBy4nCV;;EkBh5nCM;IAOI,qBAAA;ElB64nCV;;EkBp5nCM;IAOI,qBAAA;ElBi5nCV;;EkBx5nCM;IAOI,qBAAA;ElBq5nCV;;EkB55nCM;IAOI,sBAAA;ElBy5nCV;;EkBh6nCM;IAOI,sBAAA;ElB65nCV;;EkBp6nCM;IAOI,qBAAA;ElBi6nCV;;EkBx6nCM;IAOI,qBAAA;ElBq6nCV;;EkB56nCM;IAOI,qBAAA;ElBy6nCV;;EkBh7nCM;IAOI,qBAAA;ElB66nCV;;EkBp7nCM;IAOI,qBAAA;ElBi7nCV;;EkBx7nCM;IAOI,qBAAA;ElBq7nCV;;EkB57nCM;IAOI,qBAAA;ElBy7nCV;;EkBh8nCM;IAOI,qBAAA;ElB67nCV;;EkBp8nCM;IAOI,qBAAA;ElBi8nCV;;EkBx8nCM;IAOI,sBAAA;ElBq8nCV;;EkB58nCM;IAOI,sBAAA;ElBy8nCV;;EkBh9nCM;IAOI,sBAAA;ElB68nCV;;EkBp9nCM;IAOI,sBAAA;ElBi9nCV;;EkBx9nCM;IAOI,sBAAA;ElBq9nCV;;EkB59nCM;IAOI,sBAAA;ElBy9nCV;;EkBh+nCM;IAOI,sBAAA;ElB69nCV;;EkBp+nCM;IAOI,sBAAA;ElBi+nCV;;EkBx+nCM;IAOI,sBAAA;ElBq+nCV;;EkB5+nCM;IAOI,sBAAA;ElBy+nCV;;EkBh/nCM;IAOI,sBAAA;ElB6+nCV;;EkBp/nCM;IAOI,sBAAA;ElBi/nCV;;EkBx/nCM;IAOI,sBAAA;ElBq/nCV;;EkB5/nCM;IAOI,sBAAA;ElBy/nCV;;EkBhgoCM;IAOI,sBAAA;ElB6/nCV;;EkBpgoCM;IAOI,sBAAA;ElBigoCV;;EkBxgoCM;IAOI,sBAAA;ElBqgoCV;;EkB5goCM;IAOI,sBAAA;ElBygoCV;;EkBhhoCM;IAOI,uBAAA;ElB6goCV;;EkBphoCM;IAOI,uBAAA;ElBihoCV;;EkBxhoCM;IAOI,uBAAA;ElBqhoCV;;EkB5hoCM;IAOI,uBAAA;ElByhoCV;;EkBhioCM;IAOI,uBAAA;ElB6hoCV;;EkBpioCM;IAOI,uBAAA;ElBiioCV;;EkBxioCM;IAOI,uBAAA;ElBqioCV;;EkB5ioCM;IAOI,uBAAA;ElByioCV;;EkBhjoCM;IAOI,uBAAA;ElB6ioCV;;EkBpjoCM;IAOI,uBAAA;ElBijoCV;;EkBxjoCM;IAOI,uBAAA;ElBqjoCV;;EkB5joCM;IAOI,uBAAA;ElByjoCV;;EkBhkoCM;IAOI,uBAAA;ElB6joCV;;EkBpkoCM;IAOI,uBAAA;ElBikoCV;;EkBxkoCM;IAOI,uBAAA;ElBqkoCV;;EkB5koCM;IAOI,uBAAA;ElBykoCV;;EkBhloCM;IAOI,uBAAA;ElB6koCV;;EkBploCM;IAOI,uBAAA;ElBiloCV;;EkBxloCM;IAOI,uBAAA;ElBqloCV;;EkB5loCM;IAOI,uBAAA;ElByloCV;;EkBhmoCM;IAOI,uBAAA;ElB6loCV;;EkBpmoCM;IAOI,uBAAA;ElBimoCV;;EkBxmoCM;IAOI,uBAAA;ElBqmoCV;;EkB5moCM;IAOI,uBAAA;ElBymoCV;;EkBhnoCM;IAOI,uBAAA;ElB6moCV;;EkBpnoCM;IAOI,uBAAA;ElBinoCV;;EkBxnoCM;IAOI,wBAAA;ElBqnoCV;;EkB5noCM;IAOI,2BAAA;ElBynoCV;;EkBhooCM;IAOI,yBAAA;ElB6noCV;;EkBpooCM;IAOI,yBAAA;ElBiooCV;;EkBxooCM;IAOI,yBAAA;ElBqooCV;;EkB5ooCM;IAOI,0BAAA;ElByooCV;;EkBhpoCM;IAOI,0BAAA;ElB6ooCV;;EkBppoCM;IAOI,yBAAA;ElBipoCV;;EkBxpoCM;IAOI,yBAAA;ElBqpoCV;;EkB5poCM;IAOI,yBAAA;ElBypoCV;;EkBhqoCM;IAOI,yBAAA;ElB6poCV;;EkBpqoCM;IAOI,yBAAA;ElBiqoCV;;EkBxqoCM;IAOI,yBAAA;ElBqqoCV;;EkB5qoCM;IAOI,yBAAA;ElByqoCV;;EkBhroCM;IAOI,yBAAA;ElB6qoCV;;EkBproCM;IAOI,yBAAA;ElBiroCV;;EkBxroCM;IAOI,0BAAA;ElBqroCV;;EkB5roCM;IAOI,0BAAA;ElByroCV;;EkBhsoCM;IAOI,0BAAA;ElB6roCV;;EkBpsoCM;IAOI,0BAAA;ElBisoCV;;EkBxsoCM;IAOI,0BAAA;ElBqsoCV;;EkB5soCM;IAOI,0BAAA;ElBysoCV;;EkBhtoCM;IAOI,0BAAA;ElB6soCV;;EkBptoCM;IAOI,0BAAA;ElBitoCV;;EkBxtoCM;IAOI,0BAAA;ElBqtoCV;;EkB5toCM;IAOI,0BAAA;ElBytoCV;;EkBhuoCM;IAOI,0BAAA;ElB6toCV;;EkBpuoCM;IAOI,0BAAA;ElBiuoCV;;EkBxuoCM;IAOI,0BAAA;ElBquoCV;;EkB5uoCM;IAOI,0BAAA;ElByuoCV;;EkBhvoCM;IAOI,0BAAA;ElB6uoCV;;EkBpvoCM;IAOI,0BAAA;ElBivoCV;;EkBxvoCM;IAOI,0BAAA;ElBqvoCV;;EkB5voCM;IAOI,0BAAA;ElByvoCV;;EkBhwoCM;IAOI,2BAAA;ElB6voCV;;EkBpwoCM;IAOI,2BAAA;ElBiwoCV;;EkBxwoCM;IAOI,2BAAA;ElBqwoCV;;EkB5woCM;IAOI,2BAAA;ElBywoCV;;EkBhxoCM;IAOI,2BAAA;ElB6woCV;;EkBpxoCM;IAOI,2BAAA;ElBixoCV;;EkBxxoCM;IAOI,2BAAA;ElBqxoCV;;EkB5xoCM;IAOI,2BAAA;ElByxoCV;;EkBhyoCM;IAOI,2BAAA;ElB6xoCV;;EkBpyoCM;IAOI,2BAAA;ElBiyoCV;;EkBxyoCM;IAOI,2BAAA;ElBqyoCV;;EkB5yoCM;IAOI,2BAAA;ElByyoCV;;EkBhzoCM;IAOI,2BAAA;ElB6yoCV;;EkBpzoCM;IAOI,2BAAA;ElBizoCV;;EkBxzoCM;IAOI,2BAAA;ElBqzoCV;;EkB5zoCM;IAOI,2BAAA;ElByzoCV;;EkBh0oCM;IAOI,2BAAA;ElB6zoCV;;EkBp0oCM;IAOI,2BAAA;ElBi0oCV;;EkBx0oCM;IAOI,2BAAA;ElBq0oCV;;EkB50oCM;IAOI,2BAAA;ElBy0oCV;;EkBh1oCM;IAOI,2BAAA;ElB60oCV;;EkBp1oCM;IAOI,2BAAA;ElBi1oCV;;EkBx1oCM;IAOI,2BAAA;ElBq1oCV;;EkB51oCM;IAOI,2BAAA;ElBy1oCV;;EkBh2oCM;IAOI,2BAAA;ElB61oCV;;EkBp2oCM;IAOI,2BAAA;ElBi2oCV;;EkBx2oCM;IAOI,4BAAA;ElBq2oCV;;EkB52oCM;IAOI,wBAAA;ElBy2oCV;;EkBh3oCM;IAOI,sBAAA;ElB62oCV;;EkBp3oCM;IAOI,sBAAA;ElBi3oCV;;EkBx3oCM;IAOI,sBAAA;ElBq3oCV;;EkB53oCM;IAOI,uBAAA;ElBy3oCV;;EkBh4oCM;IAOI,uBAAA;ElB63oCV;;EkBp4oCM;IAOI,sBAAA;ElBi4oCV;;EkBx4oCM;IAOI,sBAAA;ElBq4oCV;;EkB54oCM;IAOI,sBAAA;ElBy4oCV;;EkBh5oCM;IAOI,sBAAA;ElB64oCV;;EkBp5oCM;IAOI,sBAAA;ElBi5oCV;;EkBx5oCM;IAOI,sBAAA;ElBq5oCV;;EkB55oCM;IAOI,sBAAA;ElBy5oCV;;EkBh6oCM;IAOI,sBAAA;ElB65oCV;;EkBp6oCM;IAOI,sBAAA;ElBi6oCV;;EkBx6oCM;IAOI,uBAAA;ElBq6oCV;;EkB56oCM;IAOI,uBAAA;ElBy6oCV;;EkBh7oCM;IAOI,uBAAA;ElB66oCV;;EkBp7oCM;IAOI,uBAAA;ElBi7oCV;;EkBx7oCM;IAOI,uBAAA;ElBq7oCV;;EkB57oCM;IAOI,uBAAA;ElBy7oCV;;EkBh8oCM;IAOI,uBAAA;ElB67oCV;;EkBp8oCM;IAOI,uBAAA;ElBi8oCV;;EkBx8oCM;IAOI,uBAAA;ElBq8oCV;;EkB58oCM;IAOI,uBAAA;ElBy8oCV;;EkBh9oCM;IAOI,uBAAA;ElB68oCV;;EkBp9oCM;IAOI,uBAAA;ElBi9oCV;;EkBx9oCM;IAOI,uBAAA;ElBq9oCV;;EkB59oCM;IAOI,uBAAA;ElBy9oCV;;EkBh+oCM;IAOI,uBAAA;ElB69oCV;;EkBp+oCM;IAOI,uBAAA;ElBi+oCV;;EkBx+oCM;IAOI,uBAAA;ElBq+oCV;;EkB5+oCM;IAOI,uBAAA;ElBy+oCV;;EkBh/oCM;IAOI,wBAAA;ElB6+oCV;;EkBp/oCM;IAOI,wBAAA;ElBi/oCV;;EkBx/oCM;IAOI,wBAAA;ElBq/oCV;;EkB5/oCM;IAOI,wBAAA;ElBy/oCV;;EkBhgpCM;IAOI,wBAAA;ElB6/oCV;;EkBpgpCM;IAOI,wBAAA;ElBigpCV;;EkBxgpCM;IAOI,wBAAA;ElBqgpCV;;EkB5gpCM;IAOI,wBAAA;ElBygpCV;;EkBhhpCM;IAOI,wBAAA;ElB6gpCV;;EkBphpCM;IAOI,wBAAA;ElBihpCV;;EkBxhpCM;IAOI,wBAAA;ElBqhpCV;;EkB5hpCM;IAOI,wBAAA;ElByhpCV;;EkBhipCM;IAOI,wBAAA;ElB6hpCV;;EkBpipCM;IAOI,wBAAA;ElBiipCV;;EkBxipCM;IAOI,wBAAA;ElBqipCV;;EkB5ipCM;IAOI,wBAAA;ElByipCV;;EkBhjpCM;IAOI,wBAAA;ElB6ipCV;;EkBpjpCM;IAOI,wBAAA;ElBijpCV;;EkBxjpCM;IAOI,wBAAA;ElBqjpCV;;EkB5jpCM;IAOI,wBAAA;ElByjpCV;;EkBhkpCM;IAOI,wBAAA;ElB6jpCV;;EkBpkpCM;IAOI,wBAAA;ElBikpCV;;EkBxkpCM;IAOI,wBAAA;ElBqkpCV;;EkB5kpCM;IAOI,wBAAA;ElBykpCV;;EkBhlpCM;IAOI,wBAAA;ElB6kpCV;;EkBplpCM;IAOI,wBAAA;ElBilpCV;;EkBxlpCM;IAOI,yBAAA;ElBqlpCV;;EkB5lpCM;IAOI,4BAAA;ElBylpCV;;EkBhmpCM;IAOI,0BAAA;ElB6lpCV;;EkBpmpCM;IAOI,0BAAA;ElBimpCV;;EkBxmpCM;IAOI,0BAAA;ElBqmpCV;;EkB5mpCM;IAOI,2BAAA;ElBympCV;;EkBhnpCM;IAOI,2BAAA;ElB6mpCV;;EkBpnpCM;IAOI,0BAAA;ElBinpCV;;EkBxnpCM;IAOI,0BAAA;ElBqnpCV;;EkB5npCM;IAOI,0BAAA;ElBynpCV;;EkBhopCM;IAOI,0BAAA;ElB6npCV;;EkBpopCM;IAOI,0BAAA;ElBiopCV;;EkBxopCM;IAOI,0BAAA;ElBqopCV;;EkB5opCM;IAOI,0BAAA;ElByopCV;;EkBhppCM;IAOI,0BAAA;ElB6opCV;;EkBpppCM;IAOI,0BAAA;ElBippCV;;EkBxppCM;IAOI,2BAAA;ElBqppCV;;EkB5ppCM;IAOI,2BAAA;ElByppCV;;EkBhqpCM;IAOI,2BAAA;ElB6ppCV;;EkBpqpCM;IAOI,2BAAA;ElBiqpCV;;EkBxqpCM;IAOI,2BAAA;ElBqqpCV;;EkB5qpCM;IAOI,2BAAA;ElByqpCV;;EkBhrpCM;IAOI,2BAAA;ElB6qpCV;;EkBprpCM;IAOI,2BAAA;ElBirpCV;;EkBxrpCM;IAOI,2BAAA;ElBqrpCV;;EkB5rpCM;IAOI,2BAAA;ElByrpCV;;EkBhspCM;IAOI,2BAAA;ElB6rpCV;;EkBpspCM;IAOI,2BAAA;ElBispCV;;EkBxspCM;IAOI,2BAAA;ElBqspCV;;EkB5spCM;IAOI,2BAAA;ElByspCV;;EkBhtpCM;IAOI,2BAAA;ElB6spCV;;EkBptpCM;IAOI,2BAAA;ElBitpCV;;EkBxtpCM;IAOI,2BAAA;ElBqtpCV;;EkB5tpCM;IAOI,2BAAA;ElBytpCV;;EkBhupCM;IAOI,4BAAA;ElB6tpCV;;EkBpupCM;IAOI,4BAAA;ElBiupCV;;EkBxupCM;IAOI,4BAAA;ElBqupCV;;EkB5upCM;IAOI,4BAAA;ElByupCV;;EkBhvpCM;IAOI,4BAAA;ElB6upCV;;EkBpvpCM;IAOI,4BAAA;ElBivpCV;;EkBxvpCM;IAOI,4BAAA;ElBqvpCV;;EkB5vpCM;IAOI,4BAAA;ElByvpCV;;EkBhwpCM;IAOI,4BAAA;ElB6vpCV;;EkBpwpCM;IAOI,4BAAA;ElBiwpCV;;EkBxwpCM;IAOI,4BAAA;ElBqwpCV;;EkB5wpCM;IAOI,4BAAA;ElBywpCV;;EkBhxpCM;IAOI,4BAAA;ElB6wpCV;;EkBpxpCM;IAOI,4BAAA;ElBixpCV;;EkBxxpCM;IAOI,4BAAA;ElBqxpCV;;EkB5xpCM;IAOI,4BAAA;ElByxpCV;;EkBhypCM;IAOI,4BAAA;ElB6xpCV;;EkBpypCM;IAOI,4BAAA;ElBiypCV;;EkBxypCM;IAOI,4BAAA;ElBqypCV;;EkB5ypCM;IAOI,4BAAA;ElByypCV;;EkBhzpCM;IAOI,4BAAA;ElB6ypCV;;EkBpzpCM;IAOI,4BAAA;ElBizpCV;;EkBxzpCM;IAOI,4BAAA;ElBqzpCV;;EkB5zpCM;IAOI,4BAAA;ElByzpCV;;EkBh0pCM;IAOI,4BAAA;ElB6zpCV;;EkBp0pCM;IAOI,4BAAA;ElBi0pCV;;EkBx0pCM;IAOI,6BAAA;ElBq0pCV;;EkB50pCM;IAOI,yBAAA;ElBy0pCV;;EkBh1pCM;IAOI,8BAAA;ElB60pCV;;EkBp1pCM;IAOI,iCAAA;ElBi1pCV;;EkBx1pCM;IAOI,sCAAA;ElBq1pCV;;EkB51pCM;IAOI,yCAAA;ElBy1pCV;;EkBh2pCM;IAOI,uBAAA;ElB61pCV;;EkBp2pCM;IAOI,uBAAA;ElBi2pCV;;EkBx2pCM;IAOI,yBAAA;ElBq2pCV;;EkB52pCM;IAOI,yBAAA;ElBy2pCV;;EkBh3pCM;IAOI,0BAAA;ElB62pCV;;EkBp3pCM;IAOI,4BAAA;ElBi3pCV;;EkBx3pCM;IAOI,kCAAA;ElBq3pCV;;EkB53pCM;IAOI,sCAAA;ElBy3pCV;;EkBh4pCM;IAOI,oCAAA;ElB63pCV;;EkBp4pCM;IAOI,kCAAA;ElBi4pCV;;EkBx4pCM;IAOI,yCAAA;ElBq4pCV;;EkB54pCM;IAOI,wCAAA;ElBy4pCV;;EkBh5pCM;IAOI,wCAAA;ElB64pCV;;EkBp5pCM;IAOI,kCAAA;ElBi5pCV;;EkBx5pCM;IAOI,gCAAA;ElBq5pCV;;EkB55pCM;IAOI,8BAAA;ElBy5pCV;;EkBh6pCM;IAOI,gCAAA;ElB65pCV;;EkBp6pCM;IAOI,+BAAA;ElBi6pCV;;EkBx6pCM;IAOI,oCAAA;ElBq6pCV;;EkB56pCM;IAOI,kCAAA;ElBy6pCV;;EkBh7pCM;IAOI,gCAAA;ElB66pCV;;EkBp7pCM;IAOI,uCAAA;ElBi7pCV;;EkBx7pCM;IAOI,sCAAA;ElBq7pCV;;EkB57pCM;IAOI,iCAAA;ElBy7pCV;;EkBh8pCM;IAOI,2BAAA;ElB67pCV;;EkBp8pCM;IAOI,iCAAA;ElBi8pCV;;EkBx8pCM;IAOI,+BAAA;ElBq8pCV;;EkB58pCM;IAOI,6BAAA;ElBy8pCV;;EkBh9pCM;IAOI,+BAAA;ElB68pCV;;EkBp9pCM;IAOI,8BAAA;ElBi9pCV;;EkBx9pCM;IAOI,oBAAA;ElBq9pCV;;EkB59pCM;IAOI,mBAAA;ElBy9pCV;;EkBh+pCM;IAOI,mBAAA;ElB69pCV;;EkBp+pCM;IAOI,mBAAA;ElBi+pCV;;EkBx+pCM;IAOI,mBAAA;ElBq+pCV;;EkB5+pCM;IAOI,mBAAA;ElBy+pCV;;EkBh/pCM;IAOI,mBAAA;ElB6+pCV;;EkBp/pCM;IAOI,mBAAA;ElBi/pCV;;EkBx/pCM;IAOI,oBAAA;ElBq/pCV;;EkB5/pCM;IAOI,0BAAA;ElBy/pCV;;EkBhgqCM;IAOI,yBAAA;ElB6/pCV;;EkBpgqCM;IAOI,0BAAA;ElBigqCV;;EkBxgqCM;IAOI,uBAAA;ElBqgqCV;;EkB5gqCM;IAOI,0BAAA;ElBygqCV;;EkBhhqCM;IAOI,yBAAA;ElB6gqCV;;EkBphqCM;IAOI,0BAAA;ElBihqCV;;EkBxhqCM;IAOI,uBAAA;ElBqhqCV;;EkB5hqCM;IAOI,0BAAA;ElByhqCV;;EkBhiqCM;IAOI,yBAAA;ElB6hqCV;;EkBpiqCM;IAOI,0BAAA;ElBiiqCV;;EkBxiqCM;IAOI,uBAAA;ElBqiqCV;;EkB5iqCM;IAOI,0BAAA;ElByiqCV;;EkBhjqCM;IAOI,yBAAA;ElB6iqCV;;EkBpjqCM;IAOI,0BAAA;ElBijqCV;;EkBxjqCM;IAOI,uBAAA;ElBqjqCV;;EkB5jqCM;IAOI,0BAAA;ElByjqCV;;EkBhkqCM;IAOI,yBAAA;ElB6jqCV;;EkBpkqCM;IAOI,0BAAA;ElBikqCV;;EkBxkqCM;IAOI,uBAAA;ElBqkqCV;;EkB5kqCM;IAOI,uBAAA;ElBykqCV;;EkBhlqCM;IAOI,0BAAA;IAAA,yBAAA;ElB8kqCV;;EkBrlqCM;IAOI,gCAAA;IAAA,+BAAA;ElBmlqCV;;EkB1lqCM;IAOI,+BAAA;IAAA,8BAAA;ElBwlqCV;;EkB/lqCM;IAOI,gCAAA;IAAA,+BAAA;ElB6lqCV;;EkBpmqCM;IAOI,6BAAA;IAAA,4BAAA;ElBkmqCV;;EkBzmqCM;IAOI,gCAAA;IAAA,+BAAA;ElBumqCV;;EkB9mqCM;IAOI,+BAAA;IAAA,8BAAA;ElB4mqCV;;EkBnnqCM;IAOI,gCAAA;IAAA,+BAAA;ElBinqCV;;EkBxnqCM;IAOI,6BAAA;IAAA,4BAAA;ElBsnqCV;;EkB7nqCM;IAOI,gCAAA;IAAA,+BAAA;ElB2nqCV;;EkBloqCM;IAOI,+BAAA;IAAA,8BAAA;ElBgoqCV;;EkBvoqCM;IAOI,gCAAA;IAAA,+BAAA;ElBqoqCV;;EkB5oqCM;IAOI,6BAAA;IAAA,4BAAA;ElB0oqCV;;EkBjpqCM;IAOI,gCAAA;IAAA,+BAAA;ElB+oqCV;;EkBtpqCM;IAOI,+BAAA;IAAA,8BAAA;ElBopqCV;;EkB3pqCM;IAOI,gCAAA;IAAA,+BAAA;ElBypqCV;;EkBhqqCM;IAOI,6BAAA;IAAA,4BAAA;ElB8pqCV;;EkBrqqCM;IAOI,gCAAA;IAAA,+BAAA;ElBmqqCV;;EkB1qqCM;IAOI,+BAAA;IAAA,8BAAA;ElBwqqCV;;EkB/qqCM;IAOI,gCAAA;IAAA,+BAAA;ElB6qqCV;;EkBprqCM;IAOI,6BAAA;IAAA,4BAAA;ElBkrqCV;;EkBzrqCM;IAOI,6BAAA;IAAA,4BAAA;ElBurqCV;;EkB9rqCM;IAOI,wBAAA;IAAA,2BAAA;ElB4rqCV;;EkBnsqCM;IAOI,8BAAA;IAAA,iCAAA;ElBisqCV;;EkBxsqCM;IAOI,6BAAA;IAAA,gCAAA;ElBssqCV;;EkB7sqCM;IAOI,8BAAA;IAAA,iCAAA;ElB2sqCV;;EkBltqCM;IAOI,2BAAA;IAAA,8BAAA;ElBgtqCV;;EkBvtqCM;IAOI,8BAAA;IAAA,iCAAA;ElBqtqCV;;EkB5tqCM;IAOI,6BAAA;IAAA,gCAAA;ElB0tqCV;;EkBjuqCM;IAOI,8BAAA;IAAA,iCAAA;ElB+tqCV;;EkBtuqCM;IAOI,2BAAA;IAAA,8BAAA;ElBouqCV;;EkB3uqCM;IAOI,8BAAA;IAAA,iCAAA;ElByuqCV;;EkBhvqCM;IAOI,6BAAA;IAAA,gCAAA;ElB8uqCV;;EkBrvqCM;IAOI,8BAAA;IAAA,iCAAA;ElBmvqCV;;EkB1vqCM;IAOI,2BAAA;IAAA,8BAAA;ElBwvqCV;;EkB/vqCM;IAOI,8BAAA;IAAA,iCAAA;ElB6vqCV;;EkBpwqCM;IAOI,6BAAA;IAAA,gCAAA;ElBkwqCV;;EkBzwqCM;IAOI,8BAAA;IAAA,iCAAA;ElBuwqCV;;EkB9wqCM;IAOI,2BAAA;IAAA,8BAAA;ElB4wqCV;;EkBnxqCM;IAOI,8BAAA;IAAA,iCAAA;ElBixqCV;;EkBxxqCM;IAOI,6BAAA;IAAA,gCAAA;ElBsxqCV;;EkB7xqCM;IAOI,8BAAA;IAAA,iCAAA;ElB2xqCV;;EkBlyqCM;IAOI,2BAAA;IAAA,8BAAA;ElBgyqCV;;EkBvyqCM;IAOI,2BAAA;IAAA,8BAAA;ElBqyqCV;;EkB5yqCM;IAOI,wBAAA;ElByyqCV;;EkBhzqCM;IAOI,8BAAA;ElB6yqCV;;EkBpzqCM;IAOI,6BAAA;ElBizqCV;;EkBxzqCM;IAOI,8BAAA;ElBqzqCV;;EkB5zqCM;IAOI,2BAAA;ElByzqCV;;EkBh0qCM;IAOI,8BAAA;ElB6zqCV;;EkBp0qCM;IAOI,6BAAA;ElBi0qCV;;EkBx0qCM;IAOI,8BAAA;ElBq0qCV;;EkB50qCM;IAOI,2BAAA;ElBy0qCV;;EkBh1qCM;IAOI,8BAAA;ElB60qCV;;EkBp1qCM;IAOI,6BAAA;ElBi1qCV;;EkBx1qCM;IAOI,8BAAA;ElBq1qCV;;EkB51qCM;IAOI,2BAAA;ElBy1qCV;;EkBh2qCM;IAOI,8BAAA;ElB61qCV;;EkBp2qCM;IAOI,6BAAA;ElBi2qCV;;EkBx2qCM;IAOI,8BAAA;ElBq2qCV;;EkB52qCM;IAOI,2BAAA;ElBy2qCV;;EkBh3qCM;IAOI,8BAAA;ElB62qCV;;EkBp3qCM;IAOI,6BAAA;ElBi3qCV;;EkBx3qCM;IAOI,8BAAA;ElBq3qCV;;EkB53qCM;IAOI,2BAAA;ElBy3qCV;;EkBh4qCM;IAOI,2BAAA;ElB63qCV;;EkBp4qCM;IAOI,0BAAA;ElBi4qCV;;EkBx4qCM;IAOI,gCAAA;ElBq4qCV;;EkB54qCM;IAOI,+BAAA;ElBy4qCV;;EkBh5qCM;IAOI,gCAAA;ElB64qCV;;EkBp5qCM;IAOI,6BAAA;ElBi5qCV;;EkBx5qCM;IAOI,gCAAA;ElBq5qCV;;EkB55qCM;IAOI,+BAAA;ElBy5qCV;;EkBh6qCM;IAOI,gCAAA;ElB65qCV;;EkBp6qCM;IAOI,6BAAA;ElBi6qCV;;EkBx6qCM;IAOI,gCAAA;ElBq6qCV;;EkB56qCM;IAOI,+BAAA;ElBy6qCV;;EkBh7qCM;IAOI,gCAAA;ElB66qCV;;EkBp7qCM;IAOI,6BAAA;ElBi7qCV;;EkBx7qCM;IAOI,gCAAA;ElBq7qCV;;EkB57qCM;IAOI,+BAAA;ElBy7qCV;;EkBh8qCM;IAOI,gCAAA;ElB67qCV;;EkBp8qCM;IAOI,6BAAA;ElBi8qCV;;EkBx8qCM;IAOI,gCAAA;ElBq8qCV;;EkB58qCM;IAOI,+BAAA;ElBy8qCV;;EkBh9qCM;IAOI,gCAAA;ElB68qCV;;EkBp9qCM;IAOI,6BAAA;ElBi9qCV;;EkBx9qCM;IAOI,6BAAA;ElBq9qCV;;EkB59qCM;IAOI,2BAAA;ElBy9qCV;;EkBh+qCM;IAOI,iCAAA;ElB69qCV;;EkBp+qCM;IAOI,gCAAA;ElBi+qCV;;EkBx+qCM;IAOI,iCAAA;ElBq+qCV;;EkB5+qCM;IAOI,8BAAA;ElBy+qCV;;EkBh/qCM;IAOI,iCAAA;ElB6+qCV;;EkBp/qCM;IAOI,gCAAA;ElBi/qCV;;EkBx/qCM;IAOI,iCAAA;ElBq/qCV;;EkB5/qCM;IAOI,8BAAA;ElBy/qCV;;EkBhgrCM;IAOI,iCAAA;ElB6/qCV;;EkBpgrCM;IAOI,gCAAA;ElBigrCV;;EkBxgrCM;IAOI,iCAAA;ElBqgrCV;;EkB5grCM;IAOI,8BAAA;ElBygrCV;;EkBhhrCM;IAOI,iCAAA;ElB6grCV;;EkBphrCM;IAOI,gCAAA;ElBihrCV;;EkBxhrCM;IAOI,iCAAA;ElBqhrCV;;EkB5hrCM;IAOI,8BAAA;ElByhrCV;;EkBhirCM;IAOI,iCAAA;ElB6hrCV;;EkBpirCM;IAOI,gCAAA;ElBiirCV;;EkBxirCM;IAOI,iCAAA;ElBqirCV;;EkB5irCM;IAOI,8BAAA;ElByirCV;;EkBhjrCM;IAOI,8BAAA;ElB6irCV;;EkBpjrCM;IAOI,yBAAA;ElBijrCV;;EkBxjrCM;IAOI,+BAAA;ElBqjrCV;;EkB5jrCM;IAOI,8BAAA;ElByjrCV;;EkBhkrCM;IAOI,+BAAA;ElB6jrCV;;EkBpkrCM;IAOI,4BAAA;ElBikrCV;;EkBxkrCM;IAOI,+BAAA;ElBqkrCV;;EkB5krCM;IAOI,8BAAA;ElBykrCV;;EkBhlrCM;IAOI,+BAAA;ElB6krCV;;EkBplrCM;IAOI,4BAAA;ElBilrCV;;EkBxlrCM;IAOI,+BAAA;ElBqlrCV;;EkB5lrCM;IAOI,8BAAA;ElBylrCV;;EkBhmrCM;IAOI,+BAAA;ElB6lrCV;;EkBpmrCM;IAOI,4BAAA;ElBimrCV;;EkBxmrCM;IAOI,+BAAA;ElBqmrCV;;EkB5mrCM;IAOI,8BAAA;ElBymrCV;;EkBhnrCM;IAOI,+BAAA;ElB6mrCV;;EkBpnrCM;IAOI,4BAAA;ElBinrCV;;EkBxnrCM;IAOI,+BAAA;ElBqnrCV;;EkB5nrCM;IAOI,8BAAA;ElBynrCV;;EkBhorCM;IAOI,+BAAA;ElB6nrCV;;EkBporCM;IAOI,4BAAA;ElBiorCV;;EkBxorCM;IAOI,4BAAA;ElBqorCV;;EkB5orCM;IAOI,2BAAA;ElByorCV;;EkBhprCM;IAOI,0BAAA;ElB6orCV;;EkBpprCM;IAOI,2BAAA;ElBiprCV;;EkBxprCM;IAOI,wBAAA;ElBqprCV;;EkB5prCM;IAOI,2BAAA;ElByprCV;;EkBhqrCM;IAOI,0BAAA;ElB6prCV;;EkBpqrCM;IAOI,2BAAA;ElBiqrCV;;EkBxqrCM;IAOI,wBAAA;ElBqqrCV;;EkB5qrCM;IAOI,2BAAA;ElByqrCV;;EkBhrrCM;IAOI,0BAAA;ElB6qrCV;;EkBprrCM;IAOI,2BAAA;ElBirrCV;;EkBxrrCM;IAOI,wBAAA;ElBqrrCV;;EkB5rrCM;IAOI,2BAAA;ElByrrCV;;EkBhsrCM;IAOI,0BAAA;ElB6rrCV;;EkBpsrCM;IAOI,2BAAA;ElBisrCV;;EkBxsrCM;IAOI,wBAAA;ElBqsrCV;;EkB5srCM;IAOI,2BAAA;ElBysrCV;;EkBhtrCM;IAOI,0BAAA;ElB6srCV;;EkBptrCM;IAOI,2BAAA;ElBitrCV;;EkBxtrCM;IAOI,wBAAA;ElBqtrCV;;EkB5trCM;IAOI,iCAAA;IAAA,gCAAA;ElB0trCV;;EkBjurCM;IAOI,gCAAA;IAAA,+BAAA;ElB+trCV;;EkBturCM;IAOI,iCAAA;IAAA,gCAAA;ElBourCV;;EkB3urCM;IAOI,8BAAA;IAAA,6BAAA;ElByurCV;;EkBhvrCM;IAOI,iCAAA;IAAA,gCAAA;ElB8urCV;;EkBrvrCM;IAOI,gCAAA;IAAA,+BAAA;ElBmvrCV;;EkB1vrCM;IAOI,iCAAA;IAAA,gCAAA;ElBwvrCV;;EkB/vrCM;IAOI,8BAAA;IAAA,6BAAA;ElB6vrCV;;EkBpwrCM;IAOI,iCAAA;IAAA,gCAAA;ElBkwrCV;;EkBzwrCM;IAOI,gCAAA;IAAA,+BAAA;ElBuwrCV;;EkB9wrCM;IAOI,iCAAA;IAAA,gCAAA;ElB4wrCV;;EkBnxrCM;IAOI,8BAAA;IAAA,6BAAA;ElBixrCV;;EkBxxrCM;IAOI,iCAAA;IAAA,gCAAA;ElBsxrCV;;EkB7xrCM;IAOI,gCAAA;IAAA,+BAAA;ElB2xrCV;;EkBlyrCM;IAOI,iCAAA;IAAA,gCAAA;ElBgyrCV;;EkBvyrCM;IAOI,8BAAA;IAAA,6BAAA;ElBqyrCV;;EkB5yrCM;IAOI,iCAAA;IAAA,gCAAA;ElB0yrCV;;EkBjzrCM;IAOI,gCAAA;IAAA,+BAAA;ElB+yrCV;;EkBtzrCM;IAOI,iCAAA;IAAA,gCAAA;ElBozrCV;;EkB3zrCM;IAOI,8BAAA;IAAA,6BAAA;ElByzrCV;;EkBh0rCM;IAOI,+BAAA;IAAA,kCAAA;ElB8zrCV;;EkBr0rCM;IAOI,8BAAA;IAAA,iCAAA;ElBm0rCV;;EkB10rCM;IAOI,+BAAA;IAAA,kCAAA;ElBw0rCV;;EkB/0rCM;IAOI,4BAAA;IAAA,+BAAA;ElB60rCV;;EkBp1rCM;IAOI,+BAAA;IAAA,kCAAA;ElBk1rCV;;EkBz1rCM;IAOI,8BAAA;IAAA,iCAAA;ElBu1rCV;;EkB91rCM;IAOI,+BAAA;IAAA,kCAAA;ElB41rCV;;EkBn2rCM;IAOI,4BAAA;IAAA,+BAAA;ElBi2rCV;;EkBx2rCM;IAOI,+BAAA;IAAA,kCAAA;ElBs2rCV;;EkB72rCM;IAOI,8BAAA;IAAA,iCAAA;ElB22rCV;;EkBl3rCM;IAOI,+BAAA;IAAA,kCAAA;ElBg3rCV;;EkBv3rCM;IAOI,4BAAA;IAAA,+BAAA;ElBq3rCV;;EkB53rCM;IAOI,+BAAA;IAAA,kCAAA;ElB03rCV;;EkBj4rCM;IAOI,8BAAA;IAAA,iCAAA;ElB+3rCV;;EkBt4rCM;IAOI,+BAAA;IAAA,kCAAA;ElBo4rCV;;EkB34rCM;IAOI,4BAAA;IAAA,+BAAA;ElBy4rCV;;EkBh5rCM;IAOI,+BAAA;IAAA,kCAAA;ElB84rCV;;EkBr5rCM;IAOI,8BAAA;IAAA,iCAAA;ElBm5rCV;;EkB15rCM;IAOI,+BAAA;IAAA,kCAAA;ElBw5rCV;;EkB/5rCM;IAOI,4BAAA;IAAA,+BAAA;ElB65rCV;;EkBp6rCM;IAOI,+BAAA;ElBi6rCV;;EkBx6rCM;IAOI,8BAAA;ElBq6rCV;;EkB56rCM;IAOI,+BAAA;ElBy6rCV;;EkBh7rCM;IAOI,4BAAA;ElB66rCV;;EkBp7rCM;IAOI,+BAAA;ElBi7rCV;;EkBx7rCM;IAOI,8BAAA;ElBq7rCV;;EkB57rCM;IAOI,+BAAA;ElBy7rCV;;EkBh8rCM;IAOI,4BAAA;ElB67rCV;;EkBp8rCM;IAOI,+BAAA;ElBi8rCV;;EkBx8rCM;IAOI,8BAAA;ElBq8rCV;;EkB58rCM;IAOI,+BAAA;ElBy8rCV;;EkBh9rCM;IAOI,4BAAA;ElB68rCV;;EkBp9rCM;IAOI,+BAAA;ElBi9rCV;;EkBx9rCM;IAOI,8BAAA;ElBq9rCV;;EkB59rCM;IAOI,+BAAA;ElBy9rCV;;EkBh+rCM;IAOI,4BAAA;ElB69rCV;;EkBp+rCM;IAOI,+BAAA;ElBi+rCV;;EkBx+rCM;IAOI,8BAAA;ElBq+rCV;;EkB5+rCM;IAOI,+BAAA;ElBy+rCV;;EkBh/rCM;IAOI,4BAAA;ElB6+rCV;;EkBp/rCM;IAOI,iCAAA;ElBi/rCV;;EkBx/rCM;IAOI,gCAAA;ElBq/rCV;;EkB5/rCM;IAOI,iCAAA;ElBy/rCV;;EkBhgsCM;IAOI,8BAAA;ElB6/rCV;;EkBpgsCM;IAOI,iCAAA;ElBigsCV;;EkBxgsCM;IAOI,gCAAA;ElBqgsCV;;EkB5gsCM;IAOI,iCAAA;ElBygsCV;;EkBhhsCM;IAOI,8BAAA;ElB6gsCV;;EkBphsCM;IAOI,iCAAA;ElBihsCV;;EkBxhsCM;IAOI,gCAAA;ElBqhsCV;;EkB5hsCM;IAOI,iCAAA;ElByhsCV;;EkBhisCM;IAOI,8BAAA;ElB6hsCV;;EkBpisCM;IAOI,iCAAA;ElBiisCV;;EkBxisCM;IAOI,gCAAA;ElBqisCV;;EkB5isCM;IAOI,iCAAA;ElByisCV;;EkBhjsCM;IAOI,8BAAA;ElB6isCV;;EkBpjsCM;IAOI,iCAAA;ElBijsCV;;EkBxjsCM;IAOI,gCAAA;ElBqjsCV;;EkB5jsCM;IAOI,iCAAA;ElByjsCV;;EkBhksCM;IAOI,8BAAA;ElB6jsCV;;EkBpksCM;IAOI,kCAAA;ElBiksCV;;EkBxksCM;IAOI,iCAAA;ElBqksCV;;EkB5ksCM;IAOI,kCAAA;ElByksCV;;EkBhlsCM;IAOI,+BAAA;ElB6ksCV;;EkBplsCM;IAOI,kCAAA;ElBilsCV;;EkBxlsCM;IAOI,iCAAA;ElBqlsCV;;EkB5lsCM;IAOI,kCAAA;ElBylsCV;;EkBhmsCM;IAOI,+BAAA;ElB6lsCV;;EkBpmsCM;IAOI,kCAAA;ElBimsCV;;EkBxmsCM;IAOI,iCAAA;ElBqmsCV;;EkB5msCM;IAOI,kCAAA;ElBymsCV;;EkBhnsCM;IAOI,+BAAA;ElB6msCV;;EkBpnsCM;IAOI,kCAAA;ElBinsCV;;EkBxnsCM;IAOI,iCAAA;ElBqnsCV;;EkB5nsCM;IAOI,kCAAA;ElBynsCV;;EkBhosCM;IAOI,+BAAA;ElB6nsCV;;EkBposCM;IAOI,kCAAA;ElBiosCV;;EkBxosCM;IAOI,iCAAA;ElBqosCV;;EkB5osCM;IAOI,kCAAA;ElByosCV;;EkBhpsCM;IAOI,+BAAA;ElB6osCV;;EkBppsCM;IAOI,gCAAA;ElBipsCV;;EkBxpsCM;IAOI,+BAAA;ElBqpsCV;;EkB5psCM;IAOI,gCAAA;ElBypsCV;;EkBhqsCM;IAOI,6BAAA;ElB6psCV;;EkBpqsCM;IAOI,gCAAA;ElBiqsCV;;EkBxqsCM;IAOI,+BAAA;ElBqqsCV;;EkB5qsCM;IAOI,gCAAA;ElByqsCV;;EkBhrsCM;IAOI,6BAAA;ElB6qsCV;;EkBprsCM;IAOI,gCAAA;ElBirsCV;;EkBxrsCM;IAOI,+BAAA;ElBqrsCV;;EkB5rsCM;IAOI,gCAAA;ElByrsCV;;EkBhssCM;IAOI,6BAAA;ElB6rsCV;;EkBpssCM;IAOI,gCAAA;ElBissCV;;EkBxssCM;IAOI,+BAAA;ElBqssCV;;EkB5ssCM;IAOI,gCAAA;ElByssCV;;EkBhtsCM;IAOI,6BAAA;ElB6ssCV;;EkBptsCM;IAOI,gCAAA;ElBitsCV;;EkBxtsCM;IAOI,+BAAA;ElBqtsCV;;EkB5tsCM;IAOI,gCAAA;ElBytsCV;;EkBhusCM;IAOI,6BAAA;ElB6tsCV;;EkBpusCM;IAOI,qBAAA;ElBiusCV;;EkBxusCM;IAOI,2BAAA;ElBqusCV;;EkB5usCM;IAOI,0BAAA;ElByusCV;;EkBhvsCM;IAOI,2BAAA;ElB6usCV;;EkBpvsCM;IAOI,wBAAA;ElBivsCV;;EkBxvsCM;IAOI,2BAAA;ElBqvsCV;;EkB5vsCM;IAOI,0BAAA;ElByvsCV;;EkBhwsCM;IAOI,2BAAA;ElB6vsCV;;EkBpwsCM;IAOI,wBAAA;ElBiwsCV;;EkBxwsCM;IAOI,2BAAA;ElBqwsCV;;EkB5wsCM;IAOI,0BAAA;ElBywsCV;;EkBhxsCM;IAOI,2BAAA;ElB6wsCV;;EkBpxsCM;IAOI,wBAAA;ElBixsCV;;EkBxxsCM;IAOI,2BAAA;ElBqxsCV;;EkB5xsCM;IAOI,0BAAA;ElByxsCV;;EkBhysCM;IAOI,2BAAA;ElB6xsCV;;EkBpysCM;IAOI,wBAAA;ElBiysCV;;EkBxysCM;IAOI,2BAAA;ElBqysCV;;EkB5ysCM;IAOI,0BAAA;ElByysCV;;EkBhzsCM;IAOI,2BAAA;ElB6ysCV;;EkBpzsCM;IAOI,wBAAA;ElBizsCV;;EkBxzsCM;IAOI,2BAAA;IAAA,0BAAA;ElBszsCV;;EkB7zsCM;IAOI,iCAAA;IAAA,gCAAA;ElB2zsCV;;EkBl0sCM;IAOI,gCAAA;IAAA,+BAAA;ElBg0sCV;;EkBv0sCM;IAOI,iCAAA;IAAA,gCAAA;ElBq0sCV;;EkB50sCM;IAOI,8BAAA;IAAA,6BAAA;ElB00sCV;;EkBj1sCM;IAOI,iCAAA;IAAA,gCAAA;ElB+0sCV;;EkBt1sCM;IAOI,gCAAA;IAAA,+BAAA;ElBo1sCV;;EkB31sCM;IAOI,iCAAA;IAAA,gCAAA;ElBy1sCV;;EkBh2sCM;IAOI,8BAAA;IAAA,6BAAA;ElB81sCV;;EkBr2sCM;IAOI,iCAAA;IAAA,gCAAA;ElBm2sCV;;EkB12sCM;IAOI,gCAAA;IAAA,+BAAA;ElBw2sCV;;EkB/2sCM;IAOI,iCAAA;IAAA,gCAAA;ElB62sCV;;EkBp3sCM;IAOI,8BAAA;IAAA,6BAAA;ElBk3sCV;;EkBz3sCM;IAOI,iCAAA;IAAA,gCAAA;ElBu3sCV;;EkB93sCM;IAOI,gCAAA;IAAA,+BAAA;ElB43sCV;;EkBn4sCM;IAOI,iCAAA;IAAA,gCAAA;ElBi4sCV;;EkBx4sCM;IAOI,8BAAA;IAAA,6BAAA;ElBs4sCV;;EkB74sCM;IAOI,iCAAA;IAAA,gCAAA;ElB24sCV;;EkBl5sCM;IAOI,gCAAA;IAAA,+BAAA;ElBg5sCV;;EkBv5sCM;IAOI,iCAAA;IAAA,gCAAA;ElBq5sCV;;EkB55sCM;IAOI,8BAAA;IAAA,6BAAA;ElB05sCV;;EkBj6sCM;IAOI,yBAAA;IAAA,4BAAA;ElB+5sCV;;EkBt6sCM;IAOI,+BAAA;IAAA,kCAAA;ElBo6sCV;;EkB36sCM;IAOI,8BAAA;IAAA,iCAAA;ElBy6sCV;;EkBh7sCM;IAOI,+BAAA;IAAA,kCAAA;ElB86sCV;;EkBr7sCM;IAOI,4BAAA;IAAA,+BAAA;ElBm7sCV;;EkB17sCM;IAOI,+BAAA;IAAA,kCAAA;ElBw7sCV;;EkB/7sCM;IAOI,8BAAA;IAAA,iCAAA;ElB67sCV;;EkBp8sCM;IAOI,+BAAA;IAAA,kCAAA;ElBk8sCV;;EkBz8sCM;IAOI,4BAAA;IAAA,+BAAA;ElBu8sCV;;EkB98sCM;IAOI,+BAAA;IAAA,kCAAA;ElB48sCV;;EkBn9sCM;IAOI,8BAAA;IAAA,iCAAA;ElBi9sCV;;EkBx9sCM;IAOI,+BAAA;IAAA,kCAAA;ElBs9sCV;;EkB79sCM;IAOI,4BAAA;IAAA,+BAAA;ElB29sCV;;EkBl+sCM;IAOI,+BAAA;IAAA,kCAAA;ElBg+sCV;;EkBv+sCM;IAOI,8BAAA;IAAA,iCAAA;ElBq+sCV;;EkB5+sCM;IAOI,+BAAA;IAAA,kCAAA;ElB0+sCV;;EkBj/sCM;IAOI,4BAAA;IAAA,+BAAA;ElB++sCV;;EkBt/sCM;IAOI,+BAAA;IAAA,kCAAA;ElBo/sCV;;EkB3/sCM;IAOI,8BAAA;IAAA,iCAAA;ElBy/sCV;;EkBhgtCM;IAOI,+BAAA;IAAA,kCAAA;ElB8/sCV;;EkBrgtCM;IAOI,4BAAA;IAAA,+BAAA;ElBmgtCV;;EkB1gtCM;IAOI,yBAAA;ElBugtCV;;EkB9gtCM;IAOI,+BAAA;ElB2gtCV;;EkBlhtCM;IAOI,8BAAA;ElB+gtCV;;EkBthtCM;IAOI,+BAAA;ElBmhtCV;;EkB1htCM;IAOI,4BAAA;ElBuhtCV;;EkB9htCM;IAOI,+BAAA;ElB2htCV;;EkBlitCM;IAOI,8BAAA;ElB+htCV;;EkBtitCM;IAOI,+BAAA;ElBmitCV;;EkB1itCM;IAOI,4BAAA;ElBuitCV;;EkB9itCM;IAOI,+BAAA;ElB2itCV;;EkBljtCM;IAOI,8BAAA;ElB+itCV;;EkBtjtCM;IAOI,+BAAA;ElBmjtCV;;EkB1jtCM;IAOI,4BAAA;ElBujtCV;;EkB9jtCM;IAOI,+BAAA;ElB2jtCV;;EkBlktCM;IAOI,8BAAA;ElB+jtCV;;EkBtktCM;IAOI,+BAAA;ElBmktCV;;EkB1ktCM;IAOI,4BAAA;ElBuktCV;;EkB9ktCM;IAOI,+BAAA;ElB2ktCV;;EkBlltCM;IAOI,8BAAA;ElB+ktCV;;EkBtltCM;IAOI,+BAAA;ElBmltCV;;EkB1ltCM;IAOI,4BAAA;ElBultCV;;EkB9ltCM;IAOI,2BAAA;ElB2ltCV;;EkBlmtCM;IAOI,iCAAA;ElB+ltCV;;EkBtmtCM;IAOI,gCAAA;ElBmmtCV;;EkB1mtCM;IAOI,iCAAA;ElBumtCV;;EkB9mtCM;IAOI,8BAAA;ElB2mtCV;;EkBlntCM;IAOI,iCAAA;ElB+mtCV;;EkBtntCM;IAOI,gCAAA;ElBmntCV;;EkB1ntCM;IAOI,iCAAA;ElBuntCV;;EkB9ntCM;IAOI,8BAAA;ElB2ntCV;;EkBlotCM;IAOI,iCAAA;ElB+ntCV;;EkBtotCM;IAOI,gCAAA;ElBmotCV;;EkB1otCM;IAOI,iCAAA;ElBuotCV;;EkB9otCM;IAOI,8BAAA;ElB2otCV;;EkBlptCM;IAOI,iCAAA;ElB+otCV;;EkBtptCM;IAOI,gCAAA;ElBmptCV;;EkB1ptCM;IAOI,iCAAA;ElBuptCV;;EkB9ptCM;IAOI,8BAAA;ElB2ptCV;;EkBlqtCM;IAOI,iCAAA;ElB+ptCV;;EkBtqtCM;IAOI,gCAAA;ElBmqtCV;;EkB1qtCM;IAOI,iCAAA;ElBuqtCV;;EkB9qtCM;IAOI,8BAAA;ElB2qtCV;;EkBlrtCM;IAOI,4BAAA;ElB+qtCV;;EkBtrtCM;IAOI,kCAAA;ElBmrtCV;;EkB1rtCM;IAOI,iCAAA;ElBurtCV;;EkB9rtCM;IAOI,kCAAA;ElB2rtCV;;EkBlstCM;IAOI,+BAAA;ElB+rtCV;;EkBtstCM;IAOI,kCAAA;ElBmstCV;;EkB1stCM;IAOI,iCAAA;ElBustCV;;EkB9stCM;IAOI,kCAAA;ElB2stCV;;EkBlttCM;IAOI,+BAAA;ElB+stCV;;EkBtttCM;IAOI,kCAAA;ElBmttCV;;EkB1ttCM;IAOI,iCAAA;ElButtCV;;EkB9ttCM;IAOI,kCAAA;ElB2ttCV;;EkBlutCM;IAOI,+BAAA;ElB+ttCV;;EkBtutCM;IAOI,kCAAA;ElBmutCV;;EkB1utCM;IAOI,iCAAA;ElBuutCV;;EkB9utCM;IAOI,kCAAA;ElB2utCV;;EkBlvtCM;IAOI,+BAAA;ElB+utCV;;EkBtvtCM;IAOI,kCAAA;ElBmvtCV;;EkB1vtCM;IAOI,iCAAA;ElBuvtCV;;EkB9vtCM;IAOI,kCAAA;ElB2vtCV;;EkBlwtCM;IAOI,+BAAA;ElB+vtCV;;EkBtwtCM;IAOI,0BAAA;ElBmwtCV;;EkB1wtCM;IAOI,gCAAA;ElBuwtCV;;EkB9wtCM;IAOI,+BAAA;ElB2wtCV;;EkBlxtCM;IAOI,gCAAA;ElB+wtCV;;EkBtxtCM;IAOI,6BAAA;ElBmxtCV;;EkB1xtCM;IAOI,gCAAA;ElBuxtCV;;EkB9xtCM;IAOI,+BAAA;ElB2xtCV;;EkBlytCM;IAOI,gCAAA;ElB+xtCV;;EkBtytCM;IAOI,6BAAA;ElBmytCV;;EkB1ytCM;IAOI,gCAAA;ElBuytCV;;EkB9ytCM;IAOI,+BAAA;ElB2ytCV;;EkBlztCM;IAOI,gCAAA;ElB+ytCV;;EkBtztCM;IAOI,6BAAA;ElBmztCV;;EkB1ztCM;IAOI,gCAAA;ElBuztCV;;EkB9ztCM;IAOI,+BAAA;ElB2ztCV;;EkBl0tCM;IAOI,gCAAA;ElB+ztCV;;EkBt0tCM;IAOI,6BAAA;ElBm0tCV;;EkB10tCM;IAOI,gCAAA;ElBu0tCV;;EkB90tCM;IAOI,+BAAA;ElB20tCV;;EkBl1tCM;IAOI,gCAAA;ElB+0tCV;;EkBt1tCM;IAOI,6BAAA;ElBm1tCV;;EkB11tCM;IAOI,iBAAA;ElBu1tCV;;EkB91tCM;IAOI,uBAAA;ElB21tCV;;EkBl2tCM;IAOI,sBAAA;ElB+1tCV;;EkBt2tCM;IAOI,uBAAA;ElBm2tCV;;EkB12tCM;IAOI,oBAAA;ElBu2tCV;;EkB92tCM;IAOI,uBAAA;ElB22tCV;;EkBl3tCM;IAOI,sBAAA;ElB+2tCV;;EkBt3tCM;IAOI,uBAAA;ElBm3tCV;;EkB13tCM;IAOI,oBAAA;ElBu3tCV;;EkB93tCM;IAOI,uBAAA;ElB23tCV;;EkBl4tCM;IAOI,sBAAA;ElB+3tCV;;EkBt4tCM;IAOI,uBAAA;ElBm4tCV;;EkB14tCM;IAOI,oBAAA;ElBu4tCV;;EkB94tCM;IAOI,uBAAA;ElB24tCV;;EkBl5tCM;IAOI,sBAAA;ElB+4tCV;;EkBt5tCM;IAOI,uBAAA;ElBm5tCV;;EkB15tCM;IAOI,oBAAA;ElBu5tCV;;EkB95tCM;IAOI,uBAAA;ElB25tCV;;EkBl6tCM;IAOI,sBAAA;ElB+5tCV;;EkBt6tCM;IAOI,uBAAA;ElBm6tCV;;EkB16tCM;IAOI,oBAAA;ElBu6tCV;;EkB96tCM;IAOI,qBAAA;ElB26tCV;;EkBl7tCM;IAOI,2BAAA;ElB+6tCV;;EkBt7tCM;IAOI,0BAAA;ElBm7tCV;;EkB17tCM;IAOI,2BAAA;ElBu7tCV;;EkB97tCM;IAOI,wBAAA;ElB27tCV;;EkBl8tCM;IAOI,2BAAA;ElB+7tCV;;EkBt8tCM;IAOI,0BAAA;ElBm8tCV;;EkB18tCM;IAOI,2BAAA;ElBu8tCV;;EkB98tCM;IAOI,wBAAA;ElB28tCV;;EkBl9tCM;IAOI,2BAAA;ElB+8tCV;;EkBt9tCM;IAOI,0BAAA;ElBm9tCV;;EkB19tCM;IAOI,2BAAA;ElBu9tCV;;EkB99tCM;IAOI,wBAAA;ElB29tCV;;EkBl+tCM;IAOI,2BAAA;ElB+9tCV;;EkBt+tCM;IAOI,0BAAA;ElBm+tCV;;EkB1+tCM;IAOI,2BAAA;ElBu+tCV;;EkB9+tCM;IAOI,wBAAA;ElB2+tCV;;EkBl/tCM;IAOI,2BAAA;ElB++tCV;;EkBt/tCM;IAOI,0BAAA;ElBm/tCV;;EkB1/tCM;IAOI,2BAAA;ElBu/tCV;;EkB9/tCM;IAOI,wBAAA;ElB2/tCV;;EkBlguCM;IAOI,wBAAA;ElB+/tCV;;EkBtguCM;IAOI,8BAAA;ElBmguCV;;EkB1guCM;IAOI,6BAAA;ElBuguCV;;EkB9guCM;IAOI,8BAAA;ElB2guCV;;EkBlhuCM;IAOI,2BAAA;ElB+guCV;;EkBthuCM;IAOI,8BAAA;ElBmhuCV;;EkB1huCM;IAOI,6BAAA;ElBuhuCV;;EkB9huCM;IAOI,8BAAA;ElB2huCV;;EkBliuCM;IAOI,2BAAA;ElB+huCV;;EkBtiuCM;IAOI,8BAAA;ElBmiuCV;;EkB1iuCM;IAOI,6BAAA;ElBuiuCV;;EkB9iuCM;IAOI,8BAAA;ElB2iuCV;;EkBljuCM;IAOI,2BAAA;ElB+iuCV;;EkBtjuCM;IAOI,8BAAA;ElBmjuCV;;EkB1juCM;IAOI,6BAAA;ElBujuCV;;EkB9juCM;IAOI,8BAAA;ElB2juCV;;EkBlkuCM;IAOI,2BAAA;ElB+juCV;;EkBtkuCM;IAOI,8BAAA;ElBmkuCV;;EkB1kuCM;IAOI,6BAAA;ElBukuCV;;EkB9kuCM;IAOI,8BAAA;ElB2kuCV;;EkBlluCM;IAOI,2BAAA;ElB+kuCV;;EkBtluCM;IAOI,0CAAA;ElBmluCV;;EkB1luCM;IAOI,4CAAA;ElBuluCV;;EkB9luCM;IAOI,4CAAA;ElB2luCV;;EkBlmuCM;IAOI,6BAAA;ElB+luCV;;EkBtmuCM;IAOI,6BAAA;ElBmmuCV;;EkB1muCM;IAOI,8BAAA;ElBumuCV;;EkB9muCM;IAOI,6BAAA;ElB2muCV;;EkBlnuCM;IAOI,6BAAA;ElB+muCV;;EkBtnuCM;IAOI,6BAAA;ElBmnuCV;;EkB1nuCM;IAOI,4BAAA;ElBunuCV;;EkB9nuCM;IAOI,0BAAA;ElB2nuCV;;EkBlouCM;IAOI,0BAAA;ElB+nuCV;;EkBtouCM;IAOI,4CAAA;ElBmouCV;;EkB1ouCM;IAOI,2CAAA;ElBuouCV;;EkB9ouCM;IAOI,4CAAA;ElB2ouCV;;EkBlpuCM;IAOI,0CAAA;ElB+ouCV;;EkBtpuCM;IAOI,4CAAA;ElBmpuCV;;EkB1puCM;IAOI,2CAAA;ElBupuCV;;EkB9puCM;IAOI,4CAAA;ElB2puCV;;EkBlquCM;IAOI,wCAAA;ElB+puCV;;EkBtquCM;IAOI,4CAAA;ElBmquCV;;EkB1quCM;IAOI,2CAAA;ElBuquCV;;EkB9quCM;IAOI,4CAAA;ElB2quCV;;EkBlruCM;IAOI,0CAAA;ElB+quCV;;EkBtruCM;IAOI,4CAAA;ElBmruCV;;EkB1ruCM;IAOI,2CAAA;ElBuruCV;;EkB9ruCM;IAOI,4CAAA;ElB2ruCV;;EkBlsuCM;IAOI,0CAAA;ElB+ruCV;;EkBtsuCM;IAOI,2BAAA;ElBmsuCV;;EkB1suCM;IAOI,4BAAA;ElBusuCV;;EkB9suCM;IAOI,6BAAA;ElB2suCV;;EkBltuCM;IAOI,2BAAA;ElB+suCV;;EkBttuCM;IAOI,yBAAA;ElBmtuCV;;EkB1tuCM;IAOI,yBAAA;ElButuCV;;EkB9tuCM;IAOI,yBAAA;ElB2tuCV;;EkBluuCM;IAOI,0BAAA;ElB+tuCV;;EkBtuuCM;IAOI,0BAAA;ElBmuuCV;;EkB1uuCM;IAOI,yBAAA;ElBuuuCV;;EkB9uuCM;IAOI,yBAAA;ElB2uuCV;;EkBlvuCM;IAOI,yBAAA;ElB+uuCV;;EkBtvuCM;IAOI,yBAAA;ElBmvuCV;;EkB1vuCM;IAOI,yBAAA;ElBuvuCV;;EkB9vuCM;IAOI,yBAAA;ElB2vuCV;;EkBlwuCM;IAOI,yBAAA;ElB+vuCV;;EkBtwuCM;IAOI,yBAAA;ElBmwuCV;;EkB1wuCM;IAOI,yBAAA;ElBuwuCV;;EkB9wuCM;IAOI,0BAAA;ElB2wuCV;;EkBlxuCM;IAOI,0BAAA;ElB+wuCV;;EkBtxuCM;IAOI,0BAAA;ElBmxuCV;;EkB1xuCM;IAOI,0BAAA;ElBuxuCV;;EkB9xuCM;IAOI,0BAAA;ElB2xuCV;;EkBlyuCM;IAOI,0BAAA;ElB+xuCV;;EkBtyuCM;IAOI,0BAAA;ElBmyuCV;;EkB1yuCM;IAOI,0BAAA;ElBuyuCV;;EkB9yuCM;IAOI,0BAAA;ElB2yuCV;;EkBlzuCM;IAOI,0BAAA;ElB+yuCV;;EkBtzuCM;IAOI,0BAAA;ElBmzuCV;;EkB1zuCM;IAOI,0BAAA;ElBuzuCV;;EkB9zuCM;IAOI,0BAAA;ElB2zuCV;;EkBl0uCM;IAOI,0BAAA;ElB+zuCV;;EkBt0uCM;IAOI,0BAAA;ElBm0uCV;;EkB10uCM;IAOI,0BAAA;ElBu0uCV;;EkB90uCM;IAOI,0BAAA;ElB20uCV;;EkBl1uCM;IAOI,0BAAA;ElB+0uCV;;EkBt1uCM;IAOI,2BAAA;ElBm1uCV;;EkB11uCM;IAOI,2BAAA;ElBu1uCV;;EkB91uCM;IAOI,2BAAA;ElB21uCV;;EkBl2uCM;IAOI,2BAAA;ElB+1uCV;;EkBt2uCM;IAOI,2BAAA;ElBm2uCV;;EkB12uCM;IAOI,2BAAA;ElBu2uCV;;EkB92uCM;IAOI,2BAAA;ElB22uCV;;EkBl3uCM;IAOI,2BAAA;ElB+2uCV;;EkBt3uCM;IAOI,2BAAA;ElBm3uCV;;EkB13uCM;IAOI,2BAAA;ElBu3uCV;;EkB93uCM;IAOI,2BAAA;ElB23uCV;;EkBl4uCM;IAOI,2BAAA;ElB+3uCV;;EkBt4uCM;IAOI,2BAAA;ElBm4uCV;;EkB14uCM;IAOI,2BAAA;ElBu4uCV;;EkB94uCM;IAOI,2BAAA;ElB24uCV;;EkBl5uCM;IAOI,2BAAA;ElB+4uCV;;EkBt5uCM;IAOI,2BAAA;ElBm5uCV;;EkB15uCM;IAOI,2BAAA;ElBu5uCV;;EkB95uCM;IAOI,2BAAA;ElB25uCV;;EkBl6uCM;IAOI,2BAAA;ElB+5uCV;;EkBt6uCM;IAOI,2BAAA;ElBm6uCV;;EkB16uCM;IAOI,2BAAA;ElBu6uCV;;EkB96uCM;IAOI,2BAAA;ElB26uCV;;EkBl7uCM;IAOI,2BAAA;ElB+6uCV;;EkBt7uCM;IAOI,2BAAA;ElBm7uCV;;EkB17uCM;IAOI,2BAAA;ElBu7uCV;;EkB97uCM;IAOI,4BAAA;ElB27uCV;;EkBl8uCM;IAOI,4BAAA;ElB+7uCV;;EkBt8uCM;IAOI,0BAAA;ElBm8uCV;;EkB18uCM;IAOI,0BAAA;ElBu8uCV;;EkB98uCM;IAOI,0BAAA;ElB28uCV;;EkBl9uCM;IAOI,2BAAA;ElB+8uCV;;EkBt9uCM;IAOI,2BAAA;ElBm9uCV;;EkB19uCM;IAOI,0BAAA;ElBu9uCV;;EkB99uCM;IAOI,0BAAA;ElB29uCV;;EkBl+uCM;IAOI,0BAAA;ElB+9uCV;;EkBt+uCM;IAOI,0BAAA;ElBm+uCV;;EkB1+uCM;IAOI,0BAAA;ElBu+uCV;;EkB9+uCM;IAOI,0BAAA;ElB2+uCV;;EkBl/uCM;IAOI,0BAAA;ElB++uCV;;EkBt/uCM;IAOI,0BAAA;ElBm/uCV;;EkB1/uCM;IAOI,0BAAA;ElBu/uCV;;EkB9/uCM;IAOI,2BAAA;ElB2/uCV;;EkBlgvCM;IAOI,2BAAA;ElB+/uCV;;EkBtgvCM;IAOI,2BAAA;ElBmgvCV;;EkB1gvCM;IAOI,2BAAA;ElBugvCV;;EkB9gvCM;IAOI,2BAAA;ElB2gvCV;;EkBlhvCM;IAOI,2BAAA;ElB+gvCV;;EkBthvCM;IAOI,2BAAA;ElBmhvCV;;EkB1hvCM;IAOI,2BAAA;ElBuhvCV;;EkB9hvCM;IAOI,2BAAA;ElB2hvCV;;EkBlivCM;IAOI,2BAAA;ElB+hvCV;;EkBtivCM;IAOI,2BAAA;ElBmivCV;;EkB1ivCM;IAOI,2BAAA;ElBuivCV;;EkB9ivCM;IAOI,2BAAA;ElB2ivCV;;EkBljvCM;IAOI,2BAAA;ElB+ivCV;;EkBtjvCM;IAOI,2BAAA;ElBmjvCV;;EkB1jvCM;IAOI,2BAAA;ElBujvCV;;EkB9jvCM;IAOI,2BAAA;ElB2jvCV;;EkBlkvCM;IAOI,2BAAA;ElB+jvCV;;EkBtkvCM;IAOI,4BAAA;ElBmkvCV;;EkB1kvCM;IAOI,4BAAA;ElBukvCV;;EkB9kvCM;IAOI,4BAAA;ElB2kvCV;;EkBllvCM;IAOI,4BAAA;ElB+kvCV;;EkBtlvCM;IAOI,4BAAA;ElBmlvCV;;EkB1lvCM;IAOI,4BAAA;ElBulvCV;;EkB9lvCM;IAOI,4BAAA;ElB2lvCV;;EkBlmvCM;IAOI,4BAAA;ElB+lvCV;;EkBtmvCM;IAOI,4BAAA;ElBmmvCV;;EkB1mvCM;IAOI,4BAAA;ElBumvCV;;EkB9mvCM;IAOI,4BAAA;ElB2mvCV;;EkBlnvCM;IAOI,4BAAA;ElB+mvCV;;EkBtnvCM;IAOI,4BAAA;ElBmnvCV;;EkB1nvCM;IAOI,4BAAA;ElBunvCV;;EkB9nvCM;IAOI,4BAAA;ElB2nvCV;;EkBlovCM;IAOI,4BAAA;ElB+nvCV;;EkBtovCM;IAOI,4BAAA;ElBmovCV;;EkB1ovCM;IAOI,4BAAA;ElBuovCV;;EkB9ovCM;IAOI,4BAAA;ElB2ovCV;;EkBlpvCM;IAOI,4BAAA;ElB+ovCV;;EkBtpvCM;IAOI,4BAAA;ElBmpvCV;;EkB1pvCM;IAOI,4BAAA;ElBupvCV;;EkB9pvCM;IAOI,4BAAA;ElB2pvCV;;EkBlqvCM;IAOI,4BAAA;ElB+pvCV;;EkBtqvCM;IAOI,4BAAA;ElBmqvCV;;EkB1qvCM;IAOI,4BAAA;ElBuqvCV;;EkB9qvCM;IAOI,6BAAA;ElB2qvCV;AACF;AUtrvCI;EQGI;IAOI,sBAAA;ElBgrvCV;;EkBvrvCM;IAOI,uBAAA;ElBorvCV;;EkB3rvCM;IAOI,sBAAA;ElBwrvCV;;EkB/rvCM;IAOI,8BAAA;ElB4rvCV;;EkBnsvCM;IAOI,4BAAA;ElBgsvCV;;EkBvsvCM;IAOI,2BAAA;ElBosvCV;;EkB3svCM;IAOI,iCAAA;ElBwsvCV;;EkB/svCM;IAOI,2BAAA;ElB4svCV;;EkBntvCM;IAOI,0BAAA;ElBgtvCV;;EkBvtvCM;IAOI,gCAAA;ElBotvCV;;EkB3tvCM;IAOI,yBAAA;ElBwtvCV;;EkB/tvCM;IAOI,wBAAA;ElB4tvCV;;EkBnuvCM;IAOI,+BAAA;ElBguvCV;;EkBvuvCM;IAOI,yBAAA;ElBouvCV;;EkB3uvCM;IAOI,6BAAA;ElBwuvCV;;EkB/uvCM;IAOI,8BAAA;ElB4uvCV;;EkBnvvCM;IAOI,wBAAA;ElBgvvCV;;EkBvvvCM;IAOI,+BAAA;ElBovvCV;;EkB3vvCM;IAOI,wBAAA;ElBwvvCV;;EkB/vvCM;IAOI,2BAAA;ElB4vvCV;;EkBnwvCM;IAOI,6BAAA;ElBgwvCV;;EkBvwvCM;IAOI,6BAAA;ElBowvCV;;EkB3wvCM;IAOI,0BAAA;ElBwwvCV;;EkB/wvCM;IAOI,2BAAA;ElB4wvCV;;EkBnxvCM;IAOI,uBAAA;ElBgxvCV;;EkBvxvCM;IAOI,qBAAA;ElBoxvCV;;EkB3xvCM;IAOI,qBAAA;ElBwxvCV;;EkB/xvCM;IAOI,qBAAA;ElB4xvCV;;EkBnyvCM;IAOI,sBAAA;ElBgyvCV;;EkBvyvCM;IAOI,sBAAA;ElBoyvCV;;EkB3yvCM;IAOI,qBAAA;ElBwyvCV;;EkB/yvCM;IAOI,qBAAA;ElB4yvCV;;EkBnzvCM;IAOI,qBAAA;ElBgzvCV;;EkBvzvCM;IAOI,qBAAA;ElBozvCV;;EkB3zvCM;IAOI,qBAAA;ElBwzvCV;;EkB/zvCM;IAOI,qBAAA;ElB4zvCV;;EkBn0vCM;IAOI,qBAAA;ElBg0vCV;;EkBv0vCM;IAOI,qBAAA;ElBo0vCV;;EkB30vCM;IAOI,qBAAA;ElBw0vCV;;EkB/0vCM;IAOI,sBAAA;ElB40vCV;;EkBn1vCM;IAOI,sBAAA;ElBg1vCV;;EkBv1vCM;IAOI,sBAAA;ElBo1vCV;;EkB31vCM;IAOI,sBAAA;ElBw1vCV;;EkB/1vCM;IAOI,sBAAA;ElB41vCV;;EkBn2vCM;IAOI,sBAAA;ElBg2vCV;;EkBv2vCM;IAOI,sBAAA;ElBo2vCV;;EkB32vCM;IAOI,sBAAA;ElBw2vCV;;EkB/2vCM;IAOI,sBAAA;ElB42vCV;;EkBn3vCM;IAOI,sBAAA;ElBg3vCV;;EkBv3vCM;IAOI,sBAAA;ElBo3vCV;;EkB33vCM;IAOI,sBAAA;ElBw3vCV;;EkB/3vCM;IAOI,sBAAA;ElB43vCV;;EkBn4vCM;IAOI,sBAAA;ElBg4vCV;;EkBv4vCM;IAOI,sBAAA;ElBo4vCV;;EkB34vCM;IAOI,sBAAA;ElBw4vCV;;EkB/4vCM;IAOI,sBAAA;ElB44vCV;;EkBn5vCM;IAOI,sBAAA;ElBg5vCV;;EkBv5vCM;IAOI,uBAAA;ElBo5vCV;;EkB35vCM;IAOI,uBAAA;ElBw5vCV;;EkB/5vCM;IAOI,uBAAA;ElB45vCV;;EkBn6vCM;IAOI,uBAAA;ElBg6vCV;;EkBv6vCM;IAOI,uBAAA;ElBo6vCV;;EkB36vCM;IAOI,uBAAA;ElBw6vCV;;EkB/6vCM;IAOI,uBAAA;ElB46vCV;;EkBn7vCM;IAOI,uBAAA;ElBg7vCV;;EkBv7vCM;IAOI,uBAAA;ElBo7vCV;;EkB37vCM;IAOI,uBAAA;ElBw7vCV;;EkB/7vCM;IAOI,uBAAA;ElB47vCV;;EkBn8vCM;IAOI,uBAAA;ElBg8vCV;;EkBv8vCM;IAOI,uBAAA;ElBo8vCV;;EkB38vCM;IAOI,uBAAA;ElBw8vCV;;EkB/8vCM;IAOI,uBAAA;ElB48vCV;;EkBn9vCM;IAOI,uBAAA;ElBg9vCV;;EkBv9vCM;IAOI,uBAAA;ElBo9vCV;;EkB39vCM;IAOI,uBAAA;ElBw9vCV;;EkB/9vCM;IAOI,uBAAA;ElB49vCV;;EkBn+vCM;IAOI,uBAAA;ElBg+vCV;;EkBv+vCM;IAOI,uBAAA;ElBo+vCV;;EkB3+vCM;IAOI,uBAAA;ElBw+vCV;;EkB/+vCM;IAOI,uBAAA;ElB4+vCV;;EkBn/vCM;IAOI,uBAAA;ElBg/vCV;;EkBv/vCM;IAOI,uBAAA;ElBo/vCV;;EkB3/vCM;IAOI,uBAAA;ElBw/vCV;;EkB//vCM;IAOI,wBAAA;ElB4/vCV;;EkBngwCM;IAOI,2BAAA;ElBggwCV;;EkBvgwCM;IAOI,yBAAA;ElBogwCV;;EkB3gwCM;IAOI,yBAAA;ElBwgwCV;;EkB/gwCM;IAOI,yBAAA;ElB4gwCV;;EkBnhwCM;IAOI,0BAAA;ElBghwCV;;EkBvhwCM;IAOI,0BAAA;ElBohwCV;;EkB3hwCM;IAOI,yBAAA;ElBwhwCV;;EkB/hwCM;IAOI,yBAAA;ElB4hwCV;;EkBniwCM;IAOI,yBAAA;ElBgiwCV;;EkBviwCM;IAOI,yBAAA;ElBoiwCV;;EkB3iwCM;IAOI,yBAAA;ElBwiwCV;;EkB/iwCM;IAOI,yBAAA;ElB4iwCV;;EkBnjwCM;IAOI,yBAAA;ElBgjwCV;;EkBvjwCM;IAOI,yBAAA;ElBojwCV;;EkB3jwCM;IAOI,yBAAA;ElBwjwCV;;EkB/jwCM;IAOI,0BAAA;ElB4jwCV;;EkBnkwCM;IAOI,0BAAA;ElBgkwCV;;EkBvkwCM;IAOI,0BAAA;ElBokwCV;;EkB3kwCM;IAOI,0BAAA;ElBwkwCV;;EkB/kwCM;IAOI,0BAAA;ElB4kwCV;;EkBnlwCM;IAOI,0BAAA;ElBglwCV;;EkBvlwCM;IAOI,0BAAA;ElBolwCV;;EkB3lwCM;IAOI,0BAAA;ElBwlwCV;;EkB/lwCM;IAOI,0BAAA;ElB4lwCV;;EkBnmwCM;IAOI,0BAAA;ElBgmwCV;;EkBvmwCM;IAOI,0BAAA;ElBomwCV;;EkB3mwCM;IAOI,0BAAA;ElBwmwCV;;EkB/mwCM;IAOI,0BAAA;ElB4mwCV;;EkBnnwCM;IAOI,0BAAA;ElBgnwCV;;EkBvnwCM;IAOI,0BAAA;ElBonwCV;;EkB3nwCM;IAOI,0BAAA;ElBwnwCV;;EkB/nwCM;IAOI,0BAAA;ElB4nwCV;;EkBnowCM;IAOI,0BAAA;ElBgowCV;;EkBvowCM;IAOI,2BAAA;ElBoowCV;;EkB3owCM;IAOI,2BAAA;ElBwowCV;;EkB/owCM;IAOI,2BAAA;ElB4owCV;;EkBnpwCM;IAOI,2BAAA;ElBgpwCV;;EkBvpwCM;IAOI,2BAAA;ElBopwCV;;EkB3pwCM;IAOI,2BAAA;ElBwpwCV;;EkB/pwCM;IAOI,2BAAA;ElB4pwCV;;EkBnqwCM;IAOI,2BAAA;ElBgqwCV;;EkBvqwCM;IAOI,2BAAA;ElBoqwCV;;EkB3qwCM;IAOI,2BAAA;ElBwqwCV;;EkB/qwCM;IAOI,2BAAA;ElB4qwCV;;EkBnrwCM;IAOI,2BAAA;ElBgrwCV;;EkBvrwCM;IAOI,2BAAA;ElBorwCV;;EkB3rwCM;IAOI,2BAAA;ElBwrwCV;;EkB/rwCM;IAOI,2BAAA;ElB4rwCV;;EkBnswCM;IAOI,2BAAA;ElBgswCV;;EkBvswCM;IAOI,2BAAA;ElBoswCV;;EkB3swCM;IAOI,2BAAA;ElBwswCV;;EkB/swCM;IAOI,2BAAA;ElB4swCV;;EkBntwCM;IAOI,2BAAA;ElBgtwCV;;EkBvtwCM;IAOI,2BAAA;ElBotwCV;;EkB3twCM;IAOI,2BAAA;ElBwtwCV;;EkB/twCM;IAOI,2BAAA;ElB4twCV;;EkBnuwCM;IAOI,2BAAA;ElBguwCV;;EkBvuwCM;IAOI,2BAAA;ElBouwCV;;EkB3uwCM;IAOI,2BAAA;ElBwuwCV;;EkB/uwCM;IAOI,4BAAA;ElB4uwCV;;EkBnvwCM;IAOI,wBAAA;ElBgvwCV;;EkBvvwCM;IAOI,sBAAA;ElBovwCV;;EkB3vwCM;IAOI,sBAAA;ElBwvwCV;;EkB/vwCM;IAOI,sBAAA;ElB4vwCV;;EkBnwwCM;IAOI,uBAAA;ElBgwwCV;;EkBvwwCM;IAOI,uBAAA;ElBowwCV;;EkB3wwCM;IAOI,sBAAA;ElBwwwCV;;EkB/wwCM;IAOI,sBAAA;ElB4wwCV;;EkBnxwCM;IAOI,sBAAA;ElBgxwCV;;EkBvxwCM;IAOI,sBAAA;ElBoxwCV;;EkB3xwCM;IAOI,sBAAA;ElBwxwCV;;EkB/xwCM;IAOI,sBAAA;ElB4xwCV;;EkBnywCM;IAOI,sBAAA;ElBgywCV;;EkBvywCM;IAOI,sBAAA;ElBoywCV;;EkB3ywCM;IAOI,sBAAA;ElBwywCV;;EkB/ywCM;IAOI,uBAAA;ElB4ywCV;;EkBnzwCM;IAOI,uBAAA;ElBgzwCV;;EkBvzwCM;IAOI,uBAAA;ElBozwCV;;EkB3zwCM;IAOI,uBAAA;ElBwzwCV;;EkB/zwCM;IAOI,uBAAA;ElB4zwCV;;EkBn0wCM;IAOI,uBAAA;ElBg0wCV;;EkBv0wCM;IAOI,uBAAA;ElBo0wCV;;EkB30wCM;IAOI,uBAAA;ElBw0wCV;;EkB/0wCM;IAOI,uBAAA;ElB40wCV;;EkBn1wCM;IAOI,uBAAA;ElBg1wCV;;EkBv1wCM;IAOI,uBAAA;ElBo1wCV;;EkB31wCM;IAOI,uBAAA;ElBw1wCV;;EkB/1wCM;IAOI,uBAAA;ElB41wCV;;EkBn2wCM;IAOI,uBAAA;ElBg2wCV;;EkBv2wCM;IAOI,uBAAA;ElBo2wCV;;EkB32wCM;IAOI,uBAAA;ElBw2wCV;;EkB/2wCM;IAOI,uBAAA;ElB42wCV;;EkBn3wCM;IAOI,uBAAA;ElBg3wCV;;EkBv3wCM;IAOI,wBAAA;ElBo3wCV;;EkB33wCM;IAOI,wBAAA;ElBw3wCV;;EkB/3wCM;IAOI,wBAAA;ElB43wCV;;EkBn4wCM;IAOI,wBAAA;ElBg4wCV;;EkBv4wCM;IAOI,wBAAA;ElBo4wCV;;EkB34wCM;IAOI,wBAAA;ElBw4wCV;;EkB/4wCM;IAOI,wBAAA;ElB44wCV;;EkBn5wCM;IAOI,wBAAA;ElBg5wCV;;EkBv5wCM;IAOI,wBAAA;ElBo5wCV;;EkB35wCM;IAOI,wBAAA;ElBw5wCV;;EkB/5wCM;IAOI,wBAAA;ElB45wCV;;EkBn6wCM;IAOI,wBAAA;ElBg6wCV;;EkBv6wCM;IAOI,wBAAA;ElBo6wCV;;EkB36wCM;IAOI,wBAAA;ElBw6wCV;;EkB/6wCM;IAOI,wBAAA;ElB46wCV;;EkBn7wCM;IAOI,wBAAA;ElBg7wCV;;EkBv7wCM;IAOI,wBAAA;ElBo7wCV;;EkB37wCM;IAOI,wBAAA;ElBw7wCV;;EkB/7wCM;IAOI,wBAAA;ElB47wCV;;EkBn8wCM;IAOI,wBAAA;ElBg8wCV;;EkBv8wCM;IAOI,wBAAA;ElBo8wCV;;EkB38wCM;IAOI,wBAAA;ElBw8wCV;;EkB/8wCM;IAOI,wBAAA;ElB48wCV;;EkBn9wCM;IAOI,wBAAA;ElBg9wCV;;EkBv9wCM;IAOI,wBAAA;ElBo9wCV;;EkB39wCM;IAOI,wBAAA;ElBw9wCV;;EkB/9wCM;IAOI,yBAAA;ElB49wCV;;EkBn+wCM;IAOI,4BAAA;ElBg+wCV;;EkBv+wCM;IAOI,0BAAA;ElBo+wCV;;EkB3+wCM;IAOI,0BAAA;ElBw+wCV;;EkB/+wCM;IAOI,0BAAA;ElB4+wCV;;EkBn/wCM;IAOI,2BAAA;ElBg/wCV;;EkBv/wCM;IAOI,2BAAA;ElBo/wCV;;EkB3/wCM;IAOI,0BAAA;ElBw/wCV;;EkB//wCM;IAOI,0BAAA;ElB4/wCV;;EkBngxCM;IAOI,0BAAA;ElBggxCV;;EkBvgxCM;IAOI,0BAAA;ElBogxCV;;EkB3gxCM;IAOI,0BAAA;ElBwgxCV;;EkB/gxCM;IAOI,0BAAA;ElB4gxCV;;EkBnhxCM;IAOI,0BAAA;ElBghxCV;;EkBvhxCM;IAOI,0BAAA;ElBohxCV;;EkB3hxCM;IAOI,0BAAA;ElBwhxCV;;EkB/hxCM;IAOI,2BAAA;ElB4hxCV;;EkBnixCM;IAOI,2BAAA;ElBgixCV;;EkBvixCM;IAOI,2BAAA;ElBoixCV;;EkB3ixCM;IAOI,2BAAA;ElBwixCV;;EkB/ixCM;IAOI,2BAAA;ElB4ixCV;;EkBnjxCM;IAOI,2BAAA;ElBgjxCV;;EkBvjxCM;IAOI,2BAAA;ElBojxCV;;EkB3jxCM;IAOI,2BAAA;ElBwjxCV;;EkB/jxCM;IAOI,2BAAA;ElB4jxCV;;EkBnkxCM;IAOI,2BAAA;ElBgkxCV;;EkBvkxCM;IAOI,2BAAA;ElBokxCV;;EkB3kxCM;IAOI,2BAAA;ElBwkxCV;;EkB/kxCM;IAOI,2BAAA;ElB4kxCV;;EkBnlxCM;IAOI,2BAAA;ElBglxCV;;EkBvlxCM;IAOI,2BAAA;ElBolxCV;;EkB3lxCM;IAOI,2BAAA;ElBwlxCV;;EkB/lxCM;IAOI,2BAAA;ElB4lxCV;;EkBnmxCM;IAOI,2BAAA;ElBgmxCV;;EkBvmxCM;IAOI,4BAAA;ElBomxCV;;EkB3mxCM;IAOI,4BAAA;ElBwmxCV;;EkB/mxCM;IAOI,4BAAA;ElB4mxCV;;EkBnnxCM;IAOI,4BAAA;ElBgnxCV;;EkBvnxCM;IAOI,4BAAA;ElBonxCV;;EkB3nxCM;IAOI,4BAAA;ElBwnxCV;;EkB/nxCM;IAOI,4BAAA;ElB4nxCV;;EkBnoxCM;IAOI,4BAAA;ElBgoxCV;;EkBvoxCM;IAOI,4BAAA;ElBooxCV;;EkB3oxCM;IAOI,4BAAA;ElBwoxCV;;EkB/oxCM;IAOI,4BAAA;ElB4oxCV;;EkBnpxCM;IAOI,4BAAA;ElBgpxCV;;EkBvpxCM;IAOI,4BAAA;ElBopxCV;;EkB3pxCM;IAOI,4BAAA;ElBwpxCV;;EkB/pxCM;IAOI,4BAAA;ElB4pxCV;;EkBnqxCM;IAOI,4BAAA;ElBgqxCV;;EkBvqxCM;IAOI,4BAAA;ElBoqxCV;;EkB3qxCM;IAOI,4BAAA;ElBwqxCV;;EkB/qxCM;IAOI,4BAAA;ElB4qxCV;;EkBnrxCM;IAOI,4BAAA;ElBgrxCV;;EkBvrxCM;IAOI,4BAAA;ElBorxCV;;EkB3rxCM;IAOI,4BAAA;ElBwrxCV;;EkB/rxCM;IAOI,4BAAA;ElB4rxCV;;EkBnsxCM;IAOI,4BAAA;ElBgsxCV;;EkBvsxCM;IAOI,4BAAA;ElBosxCV;;EkB3sxCM;IAOI,4BAAA;ElBwsxCV;;EkB/sxCM;IAOI,6BAAA;ElB4sxCV;;EkBntxCM;IAOI,yBAAA;ElBgtxCV;;EkBvtxCM;IAOI,8BAAA;ElBotxCV;;EkB3txCM;IAOI,iCAAA;ElBwtxCV;;EkB/txCM;IAOI,sCAAA;ElB4txCV;;EkBnuxCM;IAOI,yCAAA;ElBguxCV;;EkBvuxCM;IAOI,uBAAA;ElBouxCV;;EkB3uxCM;IAOI,uBAAA;ElBwuxCV;;EkB/uxCM;IAOI,yBAAA;ElB4uxCV;;EkBnvxCM;IAOI,yBAAA;ElBgvxCV;;EkBvvxCM;IAOI,0BAAA;ElBovxCV;;EkB3vxCM;IAOI,4BAAA;ElBwvxCV;;EkB/vxCM;IAOI,kCAAA;ElB4vxCV;;EkBnwxCM;IAOI,sCAAA;ElBgwxCV;;EkBvwxCM;IAOI,oCAAA;ElBowxCV;;EkB3wxCM;IAOI,kCAAA;ElBwwxCV;;EkB/wxCM;IAOI,yCAAA;ElB4wxCV;;EkBnxxCM;IAOI,wCAAA;ElBgxxCV;;EkBvxxCM;IAOI,wCAAA;ElBoxxCV;;EkB3xxCM;IAOI,kCAAA;ElBwxxCV;;EkB/xxCM;IAOI,gCAAA;ElB4xxCV;;EkBnyxCM;IAOI,8BAAA;ElBgyxCV;;EkBvyxCM;IAOI,gCAAA;ElBoyxCV;;EkB3yxCM;IAOI,+BAAA;ElBwyxCV;;EkB/yxCM;IAOI,oCAAA;ElB4yxCV;;EkBnzxCM;IAOI,kCAAA;ElBgzxCV;;EkBvzxCM;IAOI,gCAAA;ElBozxCV;;EkB3zxCM;IAOI,uCAAA;ElBwzxCV;;EkB/zxCM;IAOI,sCAAA;ElB4zxCV;;EkBn0xCM;IAOI,iCAAA;ElBg0xCV;;EkBv0xCM;IAOI,2BAAA;ElBo0xCV;;EkB30xCM;IAOI,iCAAA;ElBw0xCV;;EkB/0xCM;IAOI,+BAAA;ElB40xCV;;EkBn1xCM;IAOI,6BAAA;ElBg1xCV;;EkBv1xCM;IAOI,+BAAA;ElBo1xCV;;EkB31xCM;IAOI,8BAAA;ElBw1xCV;;EkB/1xCM;IAOI,oBAAA;ElB41xCV;;EkBn2xCM;IAOI,mBAAA;ElBg2xCV;;EkBv2xCM;IAOI,mBAAA;ElBo2xCV;;EkB32xCM;IAOI,mBAAA;ElBw2xCV;;EkB/2xCM;IAOI,mBAAA;ElB42xCV;;EkBn3xCM;IAOI,mBAAA;ElBg3xCV;;EkBv3xCM;IAOI,mBAAA;ElBo3xCV;;EkB33xCM;IAOI,mBAAA;ElBw3xCV;;EkB/3xCM;IAOI,oBAAA;ElB43xCV;;EkBn4xCM;IAOI,0BAAA;ElBg4xCV;;EkBv4xCM;IAOI,yBAAA;ElBo4xCV;;EkB34xCM;IAOI,0BAAA;ElBw4xCV;;EkB/4xCM;IAOI,uBAAA;ElB44xCV;;EkBn5xCM;IAOI,0BAAA;ElBg5xCV;;EkBv5xCM;IAOI,yBAAA;ElBo5xCV;;EkB35xCM;IAOI,0BAAA;ElBw5xCV;;EkB/5xCM;IAOI,uBAAA;ElB45xCV;;EkBn6xCM;IAOI,0BAAA;ElBg6xCV;;EkBv6xCM;IAOI,yBAAA;ElBo6xCV;;EkB36xCM;IAOI,0BAAA;ElBw6xCV;;EkB/6xCM;IAOI,uBAAA;ElB46xCV;;EkBn7xCM;IAOI,0BAAA;ElBg7xCV;;EkBv7xCM;IAOI,yBAAA;ElBo7xCV;;EkB37xCM;IAOI,0BAAA;ElBw7xCV;;EkB/7xCM;IAOI,uBAAA;ElB47xCV;;EkBn8xCM;IAOI,0BAAA;ElBg8xCV;;EkBv8xCM;IAOI,yBAAA;ElBo8xCV;;EkB38xCM;IAOI,0BAAA;ElBw8xCV;;EkB/8xCM;IAOI,uBAAA;ElB48xCV;;EkBn9xCM;IAOI,uBAAA;ElBg9xCV;;EkBv9xCM;IAOI,0BAAA;IAAA,yBAAA;ElBq9xCV;;EkB59xCM;IAOI,gCAAA;IAAA,+BAAA;ElB09xCV;;EkBj+xCM;IAOI,+BAAA;IAAA,8BAAA;ElB+9xCV;;EkBt+xCM;IAOI,gCAAA;IAAA,+BAAA;ElBo+xCV;;EkB3+xCM;IAOI,6BAAA;IAAA,4BAAA;ElBy+xCV;;EkBh/xCM;IAOI,gCAAA;IAAA,+BAAA;ElB8+xCV;;EkBr/xCM;IAOI,+BAAA;IAAA,8BAAA;ElBm/xCV;;EkB1/xCM;IAOI,gCAAA;IAAA,+BAAA;ElBw/xCV;;EkB//xCM;IAOI,6BAAA;IAAA,4BAAA;ElB6/xCV;;EkBpgyCM;IAOI,gCAAA;IAAA,+BAAA;ElBkgyCV;;EkBzgyCM;IAOI,+BAAA;IAAA,8BAAA;ElBugyCV;;EkB9gyCM;IAOI,gCAAA;IAAA,+BAAA;ElB4gyCV;;EkBnhyCM;IAOI,6BAAA;IAAA,4BAAA;ElBihyCV;;EkBxhyCM;IAOI,gCAAA;IAAA,+BAAA;ElBshyCV;;EkB7hyCM;IAOI,+BAAA;IAAA,8BAAA;ElB2hyCV;;EkBliyCM;IAOI,gCAAA;IAAA,+BAAA;ElBgiyCV;;EkBviyCM;IAOI,6BAAA;IAAA,4BAAA;ElBqiyCV;;EkB5iyCM;IAOI,gCAAA;IAAA,+BAAA;ElB0iyCV;;EkBjjyCM;IAOI,+BAAA;IAAA,8BAAA;ElB+iyCV;;EkBtjyCM;IAOI,gCAAA;IAAA,+BAAA;ElBojyCV;;EkB3jyCM;IAOI,6BAAA;IAAA,4BAAA;ElByjyCV;;EkBhkyCM;IAOI,6BAAA;IAAA,4BAAA;ElB8jyCV;;EkBrkyCM;IAOI,wBAAA;IAAA,2BAAA;ElBmkyCV;;EkB1kyCM;IAOI,8BAAA;IAAA,iCAAA;ElBwkyCV;;EkB/kyCM;IAOI,6BAAA;IAAA,gCAAA;ElB6kyCV;;EkBplyCM;IAOI,8BAAA;IAAA,iCAAA;ElBklyCV;;EkBzlyCM;IAOI,2BAAA;IAAA,8BAAA;ElBulyCV;;EkB9lyCM;IAOI,8BAAA;IAAA,iCAAA;ElB4lyCV;;EkBnmyCM;IAOI,6BAAA;IAAA,gCAAA;ElBimyCV;;EkBxmyCM;IAOI,8BAAA;IAAA,iCAAA;ElBsmyCV;;EkB7myCM;IAOI,2BAAA;IAAA,8BAAA;ElB2myCV;;EkBlnyCM;IAOI,8BAAA;IAAA,iCAAA;ElBgnyCV;;EkBvnyCM;IAOI,6BAAA;IAAA,gCAAA;ElBqnyCV;;EkB5nyCM;IAOI,8BAAA;IAAA,iCAAA;ElB0nyCV;;EkBjoyCM;IAOI,2BAAA;IAAA,8BAAA;ElB+nyCV;;EkBtoyCM;IAOI,8BAAA;IAAA,iCAAA;ElBooyCV;;EkB3oyCM;IAOI,6BAAA;IAAA,gCAAA;ElByoyCV;;EkBhpyCM;IAOI,8BAAA;IAAA,iCAAA;ElB8oyCV;;EkBrpyCM;IAOI,2BAAA;IAAA,8BAAA;ElBmpyCV;;EkB1pyCM;IAOI,8BAAA;IAAA,iCAAA;ElBwpyCV;;EkB/pyCM;IAOI,6BAAA;IAAA,gCAAA;ElB6pyCV;;EkBpqyCM;IAOI,8BAAA;IAAA,iCAAA;ElBkqyCV;;EkBzqyCM;IAOI,2BAAA;IAAA,8BAAA;ElBuqyCV;;EkB9qyCM;IAOI,2BAAA;IAAA,8BAAA;ElB4qyCV;;EkBnryCM;IAOI,wBAAA;ElBgryCV;;EkBvryCM;IAOI,8BAAA;ElBoryCV;;EkB3ryCM;IAOI,6BAAA;ElBwryCV;;EkB/ryCM;IAOI,8BAAA;ElB4ryCV;;EkBnsyCM;IAOI,2BAAA;ElBgsyCV;;EkBvsyCM;IAOI,8BAAA;ElBosyCV;;EkB3syCM;IAOI,6BAAA;ElBwsyCV;;EkB/syCM;IAOI,8BAAA;ElB4syCV;;EkBntyCM;IAOI,2BAAA;ElBgtyCV;;EkBvtyCM;IAOI,8BAAA;ElBotyCV;;EkB3tyCM;IAOI,6BAAA;ElBwtyCV;;EkB/tyCM;IAOI,8BAAA;ElB4tyCV;;EkBnuyCM;IAOI,2BAAA;ElBguyCV;;EkBvuyCM;IAOI,8BAAA;ElBouyCV;;EkB3uyCM;IAOI,6BAAA;ElBwuyCV;;EkB/uyCM;IAOI,8BAAA;ElB4uyCV;;EkBnvyCM;IAOI,2BAAA;ElBgvyCV;;EkBvvyCM;IAOI,8BAAA;ElBovyCV;;EkB3vyCM;IAOI,6BAAA;ElBwvyCV;;EkB/vyCM;IAOI,8BAAA;ElB4vyCV;;EkBnwyCM;IAOI,2BAAA;ElBgwyCV;;EkBvwyCM;IAOI,2BAAA;ElBowyCV;;EkB3wyCM;IAOI,0BAAA;ElBwwyCV;;EkB/wyCM;IAOI,gCAAA;ElB4wyCV;;EkBnxyCM;IAOI,+BAAA;ElBgxyCV;;EkBvxyCM;IAOI,gCAAA;ElBoxyCV;;EkB3xyCM;IAOI,6BAAA;ElBwxyCV;;EkB/xyCM;IAOI,gCAAA;ElB4xyCV;;EkBnyyCM;IAOI,+BAAA;ElBgyyCV;;EkBvyyCM;IAOI,gCAAA;ElBoyyCV;;EkB3yyCM;IAOI,6BAAA;ElBwyyCV;;EkB/yyCM;IAOI,gCAAA;ElB4yyCV;;EkBnzyCM;IAOI,+BAAA;ElBgzyCV;;EkBvzyCM;IAOI,gCAAA;ElBozyCV;;EkB3zyCM;IAOI,6BAAA;ElBwzyCV;;EkB/zyCM;IAOI,gCAAA;ElB4zyCV;;EkBn0yCM;IAOI,+BAAA;ElBg0yCV;;EkBv0yCM;IAOI,gCAAA;ElBo0yCV;;EkB30yCM;IAOI,6BAAA;ElBw0yCV;;EkB/0yCM;IAOI,gCAAA;ElB40yCV;;EkBn1yCM;IAOI,+BAAA;ElBg1yCV;;EkBv1yCM;IAOI,gCAAA;ElBo1yCV;;EkB31yCM;IAOI,6BAAA;ElBw1yCV;;EkB/1yCM;IAOI,6BAAA;ElB41yCV;;EkBn2yCM;IAOI,2BAAA;ElBg2yCV;;EkBv2yCM;IAOI,iCAAA;ElBo2yCV;;EkB32yCM;IAOI,gCAAA;ElBw2yCV;;EkB/2yCM;IAOI,iCAAA;ElB42yCV;;EkBn3yCM;IAOI,8BAAA;ElBg3yCV;;EkBv3yCM;IAOI,iCAAA;ElBo3yCV;;EkB33yCM;IAOI,gCAAA;ElBw3yCV;;EkB/3yCM;IAOI,iCAAA;ElB43yCV;;EkBn4yCM;IAOI,8BAAA;ElBg4yCV;;EkBv4yCM;IAOI,iCAAA;ElBo4yCV;;EkB34yCM;IAOI,gCAAA;ElBw4yCV;;EkB/4yCM;IAOI,iCAAA;ElB44yCV;;EkBn5yCM;IAOI,8BAAA;ElBg5yCV;;EkBv5yCM;IAOI,iCAAA;ElBo5yCV;;EkB35yCM;IAOI,gCAAA;ElBw5yCV;;EkB/5yCM;IAOI,iCAAA;ElB45yCV;;EkBn6yCM;IAOI,8BAAA;ElBg6yCV;;EkBv6yCM;IAOI,iCAAA;ElBo6yCV;;EkB36yCM;IAOI,gCAAA;ElBw6yCV;;EkB/6yCM;IAOI,iCAAA;ElB46yCV;;EkBn7yCM;IAOI,8BAAA;ElBg7yCV;;EkBv7yCM;IAOI,8BAAA;ElBo7yCV;;EkB37yCM;IAOI,yBAAA;ElBw7yCV;;EkB/7yCM;IAOI,+BAAA;ElB47yCV;;EkBn8yCM;IAOI,8BAAA;ElBg8yCV;;EkBv8yCM;IAOI,+BAAA;ElBo8yCV;;EkB38yCM;IAOI,4BAAA;ElBw8yCV;;EkB/8yCM;IAOI,+BAAA;ElB48yCV;;EkBn9yCM;IAOI,8BAAA;ElBg9yCV;;EkBv9yCM;IAOI,+BAAA;ElBo9yCV;;EkB39yCM;IAOI,4BAAA;ElBw9yCV;;EkB/9yCM;IAOI,+BAAA;ElB49yCV;;EkBn+yCM;IAOI,8BAAA;ElBg+yCV;;EkBv+yCM;IAOI,+BAAA;ElBo+yCV;;EkB3+yCM;IAOI,4BAAA;ElBw+yCV;;EkB/+yCM;IAOI,+BAAA;ElB4+yCV;;EkBn/yCM;IAOI,8BAAA;ElBg/yCV;;EkBv/yCM;IAOI,+BAAA;ElBo/yCV;;EkB3/yCM;IAOI,4BAAA;ElBw/yCV;;EkB//yCM;IAOI,+BAAA;ElB4/yCV;;EkBngzCM;IAOI,8BAAA;ElBggzCV;;EkBvgzCM;IAOI,+BAAA;ElBogzCV;;EkB3gzCM;IAOI,4BAAA;ElBwgzCV;;EkB/gzCM;IAOI,4BAAA;ElB4gzCV;;EkBnhzCM;IAOI,2BAAA;ElBghzCV;;EkBvhzCM;IAOI,0BAAA;ElBohzCV;;EkB3hzCM;IAOI,2BAAA;ElBwhzCV;;EkB/hzCM;IAOI,wBAAA;ElB4hzCV;;EkBnizCM;IAOI,2BAAA;ElBgizCV;;EkBvizCM;IAOI,0BAAA;ElBoizCV;;EkB3izCM;IAOI,2BAAA;ElBwizCV;;EkB/izCM;IAOI,wBAAA;ElB4izCV;;EkBnjzCM;IAOI,2BAAA;ElBgjzCV;;EkBvjzCM;IAOI,0BAAA;ElBojzCV;;EkB3jzCM;IAOI,2BAAA;ElBwjzCV;;EkB/jzCM;IAOI,wBAAA;ElB4jzCV;;EkBnkzCM;IAOI,2BAAA;ElBgkzCV;;EkBvkzCM;IAOI,0BAAA;ElBokzCV;;EkB3kzCM;IAOI,2BAAA;ElBwkzCV;;EkB/kzCM;IAOI,wBAAA;ElB4kzCV;;EkBnlzCM;IAOI,2BAAA;ElBglzCV;;EkBvlzCM;IAOI,0BAAA;ElBolzCV;;EkB3lzCM;IAOI,2BAAA;ElBwlzCV;;EkB/lzCM;IAOI,wBAAA;ElB4lzCV;;EkBnmzCM;IAOI,iCAAA;IAAA,gCAAA;ElBimzCV;;EkBxmzCM;IAOI,gCAAA;IAAA,+BAAA;ElBsmzCV;;EkB7mzCM;IAOI,iCAAA;IAAA,gCAAA;ElB2mzCV;;EkBlnzCM;IAOI,8BAAA;IAAA,6BAAA;ElBgnzCV;;EkBvnzCM;IAOI,iCAAA;IAAA,gCAAA;ElBqnzCV;;EkB5nzCM;IAOI,gCAAA;IAAA,+BAAA;ElB0nzCV;;EkBjozCM;IAOI,iCAAA;IAAA,gCAAA;ElB+nzCV;;EkBtozCM;IAOI,8BAAA;IAAA,6BAAA;ElBoozCV;;EkB3ozCM;IAOI,iCAAA;IAAA,gCAAA;ElByozCV;;EkBhpzCM;IAOI,gCAAA;IAAA,+BAAA;ElB8ozCV;;EkBrpzCM;IAOI,iCAAA;IAAA,gCAAA;ElBmpzCV;;EkB1pzCM;IAOI,8BAAA;IAAA,6BAAA;ElBwpzCV;;EkB/pzCM;IAOI,iCAAA;IAAA,gCAAA;ElB6pzCV;;EkBpqzCM;IAOI,gCAAA;IAAA,+BAAA;ElBkqzCV;;EkBzqzCM;IAOI,iCAAA;IAAA,gCAAA;ElBuqzCV;;EkB9qzCM;IAOI,8BAAA;IAAA,6BAAA;ElB4qzCV;;EkBnrzCM;IAOI,iCAAA;IAAA,gCAAA;ElBirzCV;;EkBxrzCM;IAOI,gCAAA;IAAA,+BAAA;ElBsrzCV;;EkB7rzCM;IAOI,iCAAA;IAAA,gCAAA;ElB2rzCV;;EkBlszCM;IAOI,8BAAA;IAAA,6BAAA;ElBgszCV;;EkBvszCM;IAOI,+BAAA;IAAA,kCAAA;ElBqszCV;;EkB5szCM;IAOI,8BAAA;IAAA,iCAAA;ElB0szCV;;EkBjtzCM;IAOI,+BAAA;IAAA,kCAAA;ElB+szCV;;EkBttzCM;IAOI,4BAAA;IAAA,+BAAA;ElBotzCV;;EkB3tzCM;IAOI,+BAAA;IAAA,kCAAA;ElBytzCV;;EkBhuzCM;IAOI,8BAAA;IAAA,iCAAA;ElB8tzCV;;EkBruzCM;IAOI,+BAAA;IAAA,kCAAA;ElBmuzCV;;EkB1uzCM;IAOI,4BAAA;IAAA,+BAAA;ElBwuzCV;;EkB/uzCM;IAOI,+BAAA;IAAA,kCAAA;ElB6uzCV;;EkBpvzCM;IAOI,8BAAA;IAAA,iCAAA;ElBkvzCV;;EkBzvzCM;IAOI,+BAAA;IAAA,kCAAA;ElBuvzCV;;EkB9vzCM;IAOI,4BAAA;IAAA,+BAAA;ElB4vzCV;;EkBnwzCM;IAOI,+BAAA;IAAA,kCAAA;ElBiwzCV;;EkBxwzCM;IAOI,8BAAA;IAAA,iCAAA;ElBswzCV;;EkB7wzCM;IAOI,+BAAA;IAAA,kCAAA;ElB2wzCV;;EkBlxzCM;IAOI,4BAAA;IAAA,+BAAA;ElBgxzCV;;EkBvxzCM;IAOI,+BAAA;IAAA,kCAAA;ElBqxzCV;;EkB5xzCM;IAOI,8BAAA;IAAA,iCAAA;ElB0xzCV;;EkBjyzCM;IAOI,+BAAA;IAAA,kCAAA;ElB+xzCV;;EkBtyzCM;IAOI,4BAAA;IAAA,+BAAA;ElBoyzCV;;EkB3yzCM;IAOI,+BAAA;ElBwyzCV;;EkB/yzCM;IAOI,8BAAA;ElB4yzCV;;EkBnzzCM;IAOI,+BAAA;ElBgzzCV;;EkBvzzCM;IAOI,4BAAA;ElBozzCV;;EkB3zzCM;IAOI,+BAAA;ElBwzzCV;;EkB/zzCM;IAOI,8BAAA;ElB4zzCV;;EkBn0zCM;IAOI,+BAAA;ElBg0zCV;;EkBv0zCM;IAOI,4BAAA;ElBo0zCV;;EkB30zCM;IAOI,+BAAA;ElBw0zCV;;EkB/0zCM;IAOI,8BAAA;ElB40zCV;;EkBn1zCM;IAOI,+BAAA;ElBg1zCV;;EkBv1zCM;IAOI,4BAAA;ElBo1zCV;;EkB31zCM;IAOI,+BAAA;ElBw1zCV;;EkB/1zCM;IAOI,8BAAA;ElB41zCV;;EkBn2zCM;IAOI,+BAAA;ElBg2zCV;;EkBv2zCM;IAOI,4BAAA;ElBo2zCV;;EkB32zCM;IAOI,+BAAA;ElBw2zCV;;EkB/2zCM;IAOI,8BAAA;ElB42zCV;;EkBn3zCM;IAOI,+BAAA;ElBg3zCV;;EkBv3zCM;IAOI,4BAAA;ElBo3zCV;;EkB33zCM;IAOI,iCAAA;ElBw3zCV;;EkB/3zCM;IAOI,gCAAA;ElB43zCV;;EkBn4zCM;IAOI,iCAAA;ElBg4zCV;;EkBv4zCM;IAOI,8BAAA;ElBo4zCV;;EkB34zCM;IAOI,iCAAA;ElBw4zCV;;EkB/4zCM;IAOI,gCAAA;ElB44zCV;;EkBn5zCM;IAOI,iCAAA;ElBg5zCV;;EkBv5zCM;IAOI,8BAAA;ElBo5zCV;;EkB35zCM;IAOI,iCAAA;ElBw5zCV;;EkB/5zCM;IAOI,gCAAA;ElB45zCV;;EkBn6zCM;IAOI,iCAAA;ElBg6zCV;;EkBv6zCM;IAOI,8BAAA;ElBo6zCV;;EkB36zCM;IAOI,iCAAA;ElBw6zCV;;EkB/6zCM;IAOI,gCAAA;ElB46zCV;;EkBn7zCM;IAOI,iCAAA;ElBg7zCV;;EkBv7zCM;IAOI,8BAAA;ElBo7zCV;;EkB37zCM;IAOI,iCAAA;ElBw7zCV;;EkB/7zCM;IAOI,gCAAA;ElB47zCV;;EkBn8zCM;IAOI,iCAAA;ElBg8zCV;;EkBv8zCM;IAOI,8BAAA;ElBo8zCV;;EkB38zCM;IAOI,kCAAA;ElBw8zCV;;EkB/8zCM;IAOI,iCAAA;ElB48zCV;;EkBn9zCM;IAOI,kCAAA;ElBg9zCV;;EkBv9zCM;IAOI,+BAAA;ElBo9zCV;;EkB39zCM;IAOI,kCAAA;ElBw9zCV;;EkB/9zCM;IAOI,iCAAA;ElB49zCV;;EkBn+zCM;IAOI,kCAAA;ElBg+zCV;;EkBv+zCM;IAOI,+BAAA;ElBo+zCV;;EkB3+zCM;IAOI,kCAAA;ElBw+zCV;;EkB/+zCM;IAOI,iCAAA;ElB4+zCV;;EkBn/zCM;IAOI,kCAAA;ElBg/zCV;;EkBv/zCM;IAOI,+BAAA;ElBo/zCV;;EkB3/zCM;IAOI,kCAAA;ElBw/zCV;;EkB//zCM;IAOI,iCAAA;ElB4/zCV;;EkBng0CM;IAOI,kCAAA;ElBgg0CV;;EkBvg0CM;IAOI,+BAAA;ElBog0CV;;EkB3g0CM;IAOI,kCAAA;ElBwg0CV;;EkB/g0CM;IAOI,iCAAA;ElB4g0CV;;EkBnh0CM;IAOI,kCAAA;ElBgh0CV;;EkBvh0CM;IAOI,+BAAA;ElBoh0CV;;EkB3h0CM;IAOI,gCAAA;ElBwh0CV;;EkB/h0CM;IAOI,+BAAA;ElB4h0CV;;EkBni0CM;IAOI,gCAAA;ElBgi0CV;;EkBvi0CM;IAOI,6BAAA;ElBoi0CV;;EkB3i0CM;IAOI,gCAAA;ElBwi0CV;;EkB/i0CM;IAOI,+BAAA;ElB4i0CV;;EkBnj0CM;IAOI,gCAAA;ElBgj0CV;;EkBvj0CM;IAOI,6BAAA;ElBoj0CV;;EkB3j0CM;IAOI,gCAAA;ElBwj0CV;;EkB/j0CM;IAOI,+BAAA;ElB4j0CV;;EkBnk0CM;IAOI,gCAAA;ElBgk0CV;;EkBvk0CM;IAOI,6BAAA;ElBok0CV;;EkB3k0CM;IAOI,gCAAA;ElBwk0CV;;EkB/k0CM;IAOI,+BAAA;ElB4k0CV;;EkBnl0CM;IAOI,gCAAA;ElBgl0CV;;EkBvl0CM;IAOI,6BAAA;ElBol0CV;;EkB3l0CM;IAOI,gCAAA;ElBwl0CV;;EkB/l0CM;IAOI,+BAAA;ElB4l0CV;;EkBnm0CM;IAOI,gCAAA;ElBgm0CV;;EkBvm0CM;IAOI,6BAAA;ElBom0CV;;EkB3m0CM;IAOI,qBAAA;ElBwm0CV;;EkB/m0CM;IAOI,2BAAA;ElB4m0CV;;EkBnn0CM;IAOI,0BAAA;ElBgn0CV;;EkBvn0CM;IAOI,2BAAA;ElBon0CV;;EkB3n0CM;IAOI,wBAAA;ElBwn0CV;;EkB/n0CM;IAOI,2BAAA;ElB4n0CV;;EkBno0CM;IAOI,0BAAA;ElBgo0CV;;EkBvo0CM;IAOI,2BAAA;ElBoo0CV;;EkB3o0CM;IAOI,wBAAA;ElBwo0CV;;EkB/o0CM;IAOI,2BAAA;ElB4o0CV;;EkBnp0CM;IAOI,0BAAA;ElBgp0CV;;EkBvp0CM;IAOI,2BAAA;ElBop0CV;;EkB3p0CM;IAOI,wBAAA;ElBwp0CV;;EkB/p0CM;IAOI,2BAAA;ElB4p0CV;;EkBnq0CM;IAOI,0BAAA;ElBgq0CV;;EkBvq0CM;IAOI,2BAAA;ElBoq0CV;;EkB3q0CM;IAOI,wBAAA;ElBwq0CV;;EkB/q0CM;IAOI,2BAAA;ElB4q0CV;;EkBnr0CM;IAOI,0BAAA;ElBgr0CV;;EkBvr0CM;IAOI,2BAAA;ElBor0CV;;EkB3r0CM;IAOI,wBAAA;ElBwr0CV;;EkB/r0CM;IAOI,2BAAA;IAAA,0BAAA;ElB6r0CV;;EkBps0CM;IAOI,iCAAA;IAAA,gCAAA;ElBks0CV;;EkBzs0CM;IAOI,gCAAA;IAAA,+BAAA;ElBus0CV;;EkB9s0CM;IAOI,iCAAA;IAAA,gCAAA;ElB4s0CV;;EkBnt0CM;IAOI,8BAAA;IAAA,6BAAA;ElBit0CV;;EkBxt0CM;IAOI,iCAAA;IAAA,gCAAA;ElBst0CV;;EkB7t0CM;IAOI,gCAAA;IAAA,+BAAA;ElB2t0CV;;EkBlu0CM;IAOI,iCAAA;IAAA,gCAAA;ElBgu0CV;;EkBvu0CM;IAOI,8BAAA;IAAA,6BAAA;ElBqu0CV;;EkB5u0CM;IAOI,iCAAA;IAAA,gCAAA;ElB0u0CV;;EkBjv0CM;IAOI,gCAAA;IAAA,+BAAA;ElB+u0CV;;EkBtv0CM;IAOI,iCAAA;IAAA,gCAAA;ElBov0CV;;EkB3v0CM;IAOI,8BAAA;IAAA,6BAAA;ElByv0CV;;EkBhw0CM;IAOI,iCAAA;IAAA,gCAAA;ElB8v0CV;;EkBrw0CM;IAOI,gCAAA;IAAA,+BAAA;ElBmw0CV;;EkB1w0CM;IAOI,iCAAA;IAAA,gCAAA;ElBww0CV;;EkB/w0CM;IAOI,8BAAA;IAAA,6BAAA;ElB6w0CV;;EkBpx0CM;IAOI,iCAAA;IAAA,gCAAA;ElBkx0CV;;EkBzx0CM;IAOI,gCAAA;IAAA,+BAAA;ElBux0CV;;EkB9x0CM;IAOI,iCAAA;IAAA,gCAAA;ElB4x0CV;;EkBny0CM;IAOI,8BAAA;IAAA,6BAAA;ElBiy0CV;;EkBxy0CM;IAOI,yBAAA;IAAA,4BAAA;ElBsy0CV;;EkB7y0CM;IAOI,+BAAA;IAAA,kCAAA;ElB2y0CV;;EkBlz0CM;IAOI,8BAAA;IAAA,iCAAA;ElBgz0CV;;EkBvz0CM;IAOI,+BAAA;IAAA,kCAAA;ElBqz0CV;;EkB5z0CM;IAOI,4BAAA;IAAA,+BAAA;ElB0z0CV;;EkBj00CM;IAOI,+BAAA;IAAA,kCAAA;ElB+z0CV;;EkBt00CM;IAOI,8BAAA;IAAA,iCAAA;ElBo00CV;;EkB300CM;IAOI,+BAAA;IAAA,kCAAA;ElBy00CV;;EkBh10CM;IAOI,4BAAA;IAAA,+BAAA;ElB800CV;;EkBr10CM;IAOI,+BAAA;IAAA,kCAAA;ElBm10CV;;EkB110CM;IAOI,8BAAA;IAAA,iCAAA;ElBw10CV;;EkB/10CM;IAOI,+BAAA;IAAA,kCAAA;ElB610CV;;EkBp20CM;IAOI,4BAAA;IAAA,+BAAA;ElBk20CV;;EkBz20CM;IAOI,+BAAA;IAAA,kCAAA;ElBu20CV;;EkB920CM;IAOI,8BAAA;IAAA,iCAAA;ElB420CV;;EkBn30CM;IAOI,+BAAA;IAAA,kCAAA;ElBi30CV;;EkBx30CM;IAOI,4BAAA;IAAA,+BAAA;ElBs30CV;;EkB730CM;IAOI,+BAAA;IAAA,kCAAA;ElB230CV;;EkBl40CM;IAOI,8BAAA;IAAA,iCAAA;ElBg40CV;;EkBv40CM;IAOI,+BAAA;IAAA,kCAAA;ElBq40CV;;EkB540CM;IAOI,4BAAA;IAAA,+BAAA;ElB040CV;;EkBj50CM;IAOI,yBAAA;ElB840CV;;EkBr50CM;IAOI,+BAAA;ElBk50CV;;EkBz50CM;IAOI,8BAAA;ElBs50CV;;EkB750CM;IAOI,+BAAA;ElB050CV;;EkBj60CM;IAOI,4BAAA;ElB850CV;;EkBr60CM;IAOI,+BAAA;ElBk60CV;;EkBz60CM;IAOI,8BAAA;ElBs60CV;;EkB760CM;IAOI,+BAAA;ElB060CV;;EkBj70CM;IAOI,4BAAA;ElB860CV;;EkBr70CM;IAOI,+BAAA;ElBk70CV;;EkBz70CM;IAOI,8BAAA;ElBs70CV;;EkB770CM;IAOI,+BAAA;ElB070CV;;EkBj80CM;IAOI,4BAAA;ElB870CV;;EkBr80CM;IAOI,+BAAA;ElBk80CV;;EkBz80CM;IAOI,8BAAA;ElBs80CV;;EkB780CM;IAOI,+BAAA;ElB080CV;;EkBj90CM;IAOI,4BAAA;ElB880CV;;EkBr90CM;IAOI,+BAAA;ElBk90CV;;EkBz90CM;IAOI,8BAAA;ElBs90CV;;EkB790CM;IAOI,+BAAA;ElB090CV;;EkBj+0CM;IAOI,4BAAA;ElB890CV;;EkBr+0CM;IAOI,2BAAA;ElBk+0CV;;EkBz+0CM;IAOI,iCAAA;ElBs+0CV;;EkB7+0CM;IAOI,gCAAA;ElB0+0CV;;EkBj/0CM;IAOI,iCAAA;ElB8+0CV;;EkBr/0CM;IAOI,8BAAA;ElBk/0CV;;EkBz/0CM;IAOI,iCAAA;ElBs/0CV;;EkB7/0CM;IAOI,gCAAA;ElB0/0CV;;EkBjg1CM;IAOI,iCAAA;ElB8/0CV;;EkBrg1CM;IAOI,8BAAA;ElBkg1CV;;EkBzg1CM;IAOI,iCAAA;ElBsg1CV;;EkB7g1CM;IAOI,gCAAA;ElB0g1CV;;EkBjh1CM;IAOI,iCAAA;ElB8g1CV;;EkBrh1CM;IAOI,8BAAA;ElBkh1CV;;EkBzh1CM;IAOI,iCAAA;ElBsh1CV;;EkB7h1CM;IAOI,gCAAA;ElB0h1CV;;EkBji1CM;IAOI,iCAAA;ElB8h1CV;;EkBri1CM;IAOI,8BAAA;ElBki1CV;;EkBzi1CM;IAOI,iCAAA;ElBsi1CV;;EkB7i1CM;IAOI,gCAAA;ElB0i1CV;;EkBjj1CM;IAOI,iCAAA;ElB8i1CV;;EkBrj1CM;IAOI,8BAAA;ElBkj1CV;;EkBzj1CM;IAOI,4BAAA;ElBsj1CV;;EkB7j1CM;IAOI,kCAAA;ElB0j1CV;;EkBjk1CM;IAOI,iCAAA;ElB8j1CV;;EkBrk1CM;IAOI,kCAAA;ElBkk1CV;;EkBzk1CM;IAOI,+BAAA;ElBsk1CV;;EkB7k1CM;IAOI,kCAAA;ElB0k1CV;;EkBjl1CM;IAOI,iCAAA;ElB8k1CV;;EkBrl1CM;IAOI,kCAAA;ElBkl1CV;;EkBzl1CM;IAOI,+BAAA;ElBsl1CV;;EkB7l1CM;IAOI,kCAAA;ElB0l1CV;;EkBjm1CM;IAOI,iCAAA;ElB8l1CV;;EkBrm1CM;IAOI,kCAAA;ElBkm1CV;;EkBzm1CM;IAOI,+BAAA;ElBsm1CV;;EkB7m1CM;IAOI,kCAAA;ElB0m1CV;;EkBjn1CM;IAOI,iCAAA;ElB8m1CV;;EkBrn1CM;IAOI,kCAAA;ElBkn1CV;;EkBzn1CM;IAOI,+BAAA;ElBsn1CV;;EkB7n1CM;IAOI,kCAAA;ElB0n1CV;;EkBjo1CM;IAOI,iCAAA;ElB8n1CV;;EkBro1CM;IAOI,kCAAA;ElBko1CV;;EkBzo1CM;IAOI,+BAAA;ElBso1CV;;EkB7o1CM;IAOI,0BAAA;ElB0o1CV;;EkBjp1CM;IAOI,gCAAA;ElB8o1CV;;EkBrp1CM;IAOI,+BAAA;ElBkp1CV;;EkBzp1CM;IAOI,gCAAA;ElBsp1CV;;EkB7p1CM;IAOI,6BAAA;ElB0p1CV;;EkBjq1CM;IAOI,gCAAA;ElB8p1CV;;EkBrq1CM;IAOI,+BAAA;ElBkq1CV;;EkBzq1CM;IAOI,gCAAA;ElBsq1CV;;EkB7q1CM;IAOI,6BAAA;ElB0q1CV;;EkBjr1CM;IAOI,gCAAA;ElB8q1CV;;EkBrr1CM;IAOI,+BAAA;ElBkr1CV;;EkBzr1CM;IAOI,gCAAA;ElBsr1CV;;EkB7r1CM;IAOI,6BAAA;ElB0r1CV;;EkBjs1CM;IAOI,gCAAA;ElB8r1CV;;EkBrs1CM;IAOI,+BAAA;ElBks1CV;;EkBzs1CM;IAOI,gCAAA;ElBss1CV;;EkB7s1CM;IAOI,6BAAA;ElB0s1CV;;EkBjt1CM;IAOI,gCAAA;ElB8s1CV;;EkBrt1CM;IAOI,+BAAA;ElBkt1CV;;EkBzt1CM;IAOI,gCAAA;ElBst1CV;;EkB7t1CM;IAOI,6BAAA;ElB0t1CV;;EkBju1CM;IAOI,iBAAA;ElB8t1CV;;EkBru1CM;IAOI,uBAAA;ElBku1CV;;EkBzu1CM;IAOI,sBAAA;ElBsu1CV;;EkB7u1CM;IAOI,uBAAA;ElB0u1CV;;EkBjv1CM;IAOI,oBAAA;ElB8u1CV;;EkBrv1CM;IAOI,uBAAA;ElBkv1CV;;EkBzv1CM;IAOI,sBAAA;ElBsv1CV;;EkB7v1CM;IAOI,uBAAA;ElB0v1CV;;EkBjw1CM;IAOI,oBAAA;ElB8v1CV;;EkBrw1CM;IAOI,uBAAA;ElBkw1CV;;EkBzw1CM;IAOI,sBAAA;ElBsw1CV;;EkB7w1CM;IAOI,uBAAA;ElB0w1CV;;EkBjx1CM;IAOI,oBAAA;ElB8w1CV;;EkBrx1CM;IAOI,uBAAA;ElBkx1CV;;EkBzx1CM;IAOI,sBAAA;ElBsx1CV;;EkB7x1CM;IAOI,uBAAA;ElB0x1CV;;EkBjy1CM;IAOI,oBAAA;ElB8x1CV;;EkBry1CM;IAOI,uBAAA;ElBky1CV;;EkBzy1CM;IAOI,sBAAA;ElBsy1CV;;EkB7y1CM;IAOI,uBAAA;ElB0y1CV;;EkBjz1CM;IAOI,oBAAA;ElB8y1CV;;EkBrz1CM;IAOI,qBAAA;ElBkz1CV;;EkBzz1CM;IAOI,2BAAA;ElBsz1CV;;EkB7z1CM;IAOI,0BAAA;ElB0z1CV;;EkBj01CM;IAOI,2BAAA;ElB8z1CV;;EkBr01CM;IAOI,wBAAA;ElBk01CV;;EkBz01CM;IAOI,2BAAA;ElBs01CV;;EkB701CM;IAOI,0BAAA;ElB001CV;;EkBj11CM;IAOI,2BAAA;ElB801CV;;EkBr11CM;IAOI,wBAAA;ElBk11CV;;EkBz11CM;IAOI,2BAAA;ElBs11CV;;EkB711CM;IAOI,0BAAA;ElB011CV;;EkBj21CM;IAOI,2BAAA;ElB811CV;;EkBr21CM;IAOI,wBAAA;ElBk21CV;;EkBz21CM;IAOI,2BAAA;ElBs21CV;;EkB721CM;IAOI,0BAAA;ElB021CV;;EkBj31CM;IAOI,2BAAA;ElB821CV;;EkBr31CM;IAOI,wBAAA;ElBk31CV;;EkBz31CM;IAOI,2BAAA;ElBs31CV;;EkB731CM;IAOI,0BAAA;ElB031CV;;EkBj41CM;IAOI,2BAAA;ElB831CV;;EkBr41CM;IAOI,wBAAA;ElBk41CV;;EkBz41CM;IAOI,wBAAA;ElBs41CV;;EkB741CM;IAOI,8BAAA;ElB041CV;;EkBj51CM;IAOI,6BAAA;ElB841CV;;EkBr51CM;IAOI,8BAAA;ElBk51CV;;EkBz51CM;IAOI,2BAAA;ElBs51CV;;EkB751CM;IAOI,8BAAA;ElB051CV;;EkBj61CM;IAOI,6BAAA;ElB851CV;;EkBr61CM;IAOI,8BAAA;ElBk61CV;;EkBz61CM;IAOI,2BAAA;ElBs61CV;;EkB761CM;IAOI,8BAAA;ElB061CV;;EkBj71CM;IAOI,6BAAA;ElB861CV;;EkBr71CM;IAOI,8BAAA;ElBk71CV;;EkBz71CM;IAOI,2BAAA;ElBs71CV;;EkB771CM;IAOI,8BAAA;ElB071CV;;EkBj81CM;IAOI,6BAAA;ElB871CV;;EkBr81CM;IAOI,8BAAA;ElBk81CV;;EkBz81CM;IAOI,2BAAA;ElBs81CV;;EkB781CM;IAOI,8BAAA;ElB081CV;;EkBj91CM;IAOI,6BAAA;ElB881CV;;EkBr91CM;IAOI,8BAAA;ElBk91CV;;EkBz91CM;IAOI,2BAAA;ElBs91CV;;EkB791CM;IAOI,0CAAA;ElB091CV;;EkBj+1CM;IAOI,4CAAA;ElB891CV;;EkBr+1CM;IAOI,4CAAA;ElBk+1CV;;EkBz+1CM;IAOI,6BAAA;ElBs+1CV;;EkB7+1CM;IAOI,6BAAA;ElB0+1CV;;EkBj/1CM;IAOI,8BAAA;ElB8+1CV;;EkBr/1CM;IAOI,6BAAA;ElBk/1CV;;EkBz/1CM;IAOI,6BAAA;ElBs/1CV;;EkB7/1CM;IAOI,6BAAA;ElB0/1CV;;EkBjg2CM;IAOI,4BAAA;ElB8/1CV;;EkBrg2CM;IAOI,0BAAA;ElBkg2CV;;EkBzg2CM;IAOI,0BAAA;ElBsg2CV;;EkB7g2CM;IAOI,4CAAA;ElB0g2CV;;EkBjh2CM;IAOI,2CAAA;ElB8g2CV;;EkBrh2CM;IAOI,4CAAA;ElBkh2CV;;EkBzh2CM;IAOI,0CAAA;ElBsh2CV;;EkB7h2CM;IAOI,4CAAA;ElB0h2CV;;EkBji2CM;IAOI,2CAAA;ElB8h2CV;;EkBri2CM;IAOI,4CAAA;ElBki2CV;;EkBzi2CM;IAOI,wCAAA;ElBsi2CV;;EkB7i2CM;IAOI,4CAAA;ElB0i2CV;;EkBjj2CM;IAOI,2CAAA;ElB8i2CV;;EkBrj2CM;IAOI,4CAAA;ElBkj2CV;;EkBzj2CM;IAOI,0CAAA;ElBsj2CV;;EkB7j2CM;IAOI,4CAAA;ElB0j2CV;;EkBjk2CM;IAOI,2CAAA;ElB8j2CV;;EkBrk2CM;IAOI,4CAAA;ElBkk2CV;;EkBzk2CM;IAOI,0CAAA;ElBsk2CV;;EkB7k2CM;IAOI,2BAAA;ElB0k2CV;;EkBjl2CM;IAOI,4BAAA;ElB8k2CV;;EkBrl2CM;IAOI,6BAAA;ElBkl2CV;;EkBzl2CM;IAOI,2BAAA;ElBsl2CV;;EkB7l2CM;IAOI,yBAAA;ElB0l2CV;;EkBjm2CM;IAOI,yBAAA;ElB8l2CV;;EkBrm2CM;IAOI,yBAAA;ElBkm2CV;;EkBzm2CM;IAOI,0BAAA;ElBsm2CV;;EkB7m2CM;IAOI,0BAAA;ElB0m2CV;;EkBjn2CM;IAOI,yBAAA;ElB8m2CV;;EkBrn2CM;IAOI,yBAAA;ElBkn2CV;;EkBzn2CM;IAOI,yBAAA;ElBsn2CV;;EkB7n2CM;IAOI,yBAAA;ElB0n2CV;;EkBjo2CM;IAOI,yBAAA;ElB8n2CV;;EkBro2CM;IAOI,yBAAA;ElBko2CV;;EkBzo2CM;IAOI,yBAAA;ElBso2CV;;EkB7o2CM;IAOI,yBAAA;ElB0o2CV;;EkBjp2CM;IAOI,yBAAA;ElB8o2CV;;EkBrp2CM;IAOI,0BAAA;ElBkp2CV;;EkBzp2CM;IAOI,0BAAA;ElBsp2CV;;EkB7p2CM;IAOI,0BAAA;ElB0p2CV;;EkBjq2CM;IAOI,0BAAA;ElB8p2CV;;EkBrq2CM;IAOI,0BAAA;ElBkq2CV;;EkBzq2CM;IAOI,0BAAA;ElBsq2CV;;EkB7q2CM;IAOI,0BAAA;ElB0q2CV;;EkBjr2CM;IAOI,0BAAA;ElB8q2CV;;EkBrr2CM;IAOI,0BAAA;ElBkr2CV;;EkBzr2CM;IAOI,0BAAA;ElBsr2CV;;EkB7r2CM;IAOI,0BAAA;ElB0r2CV;;EkBjs2CM;IAOI,0BAAA;ElB8r2CV;;EkBrs2CM;IAOI,0BAAA;ElBks2CV;;EkBzs2CM;IAOI,0BAAA;ElBss2CV;;EkB7s2CM;IAOI,0BAAA;ElB0s2CV;;EkBjt2CM;IAOI,0BAAA;ElB8s2CV;;EkBrt2CM;IAOI,0BAAA;ElBkt2CV;;EkBzt2CM;IAOI,0BAAA;ElBst2CV;;EkB7t2CM;IAOI,2BAAA;ElB0t2CV;;EkBju2CM;IAOI,2BAAA;ElB8t2CV;;EkBru2CM;IAOI,2BAAA;ElBku2CV;;EkBzu2CM;IAOI,2BAAA;ElBsu2CV;;EkB7u2CM;IAOI,2BAAA;ElB0u2CV;;EkBjv2CM;IAOI,2BAAA;ElB8u2CV;;EkBrv2CM;IAOI,2BAAA;ElBkv2CV;;EkBzv2CM;IAOI,2BAAA;ElBsv2CV;;EkB7v2CM;IAOI,2BAAA;ElB0v2CV;;EkBjw2CM;IAOI,2BAAA;ElB8v2CV;;EkBrw2CM;IAOI,2BAAA;ElBkw2CV;;EkBzw2CM;IAOI,2BAAA;ElBsw2CV;;EkB7w2CM;IAOI,2BAAA;ElB0w2CV;;EkBjx2CM;IAOI,2BAAA;ElB8w2CV;;EkBrx2CM;IAOI,2BAAA;ElBkx2CV;;EkBzx2CM;IAOI,2BAAA;ElBsx2CV;;EkB7x2CM;IAOI,2BAAA;ElB0x2CV;;EkBjy2CM;IAOI,2BAAA;ElB8x2CV;;EkBry2CM;IAOI,2BAAA;ElBky2CV;;EkBzy2CM;IAOI,2BAAA;ElBsy2CV;;EkB7y2CM;IAOI,2BAAA;ElB0y2CV;;EkBjz2CM;IAOI,2BAAA;ElB8y2CV;;EkBrz2CM;IAOI,2BAAA;ElBkz2CV;;EkBzz2CM;IAOI,2BAAA;ElBsz2CV;;EkB7z2CM;IAOI,2BAAA;ElB0z2CV;;EkBj02CM;IAOI,2BAAA;ElB8z2CV;;EkBr02CM;IAOI,4BAAA;ElBk02CV;;EkBz02CM;IAOI,4BAAA;ElBs02CV;;EkB702CM;IAOI,0BAAA;ElB002CV;;EkBj12CM;IAOI,0BAAA;ElB802CV;;EkBr12CM;IAOI,0BAAA;ElBk12CV;;EkBz12CM;IAOI,2BAAA;ElBs12CV;;EkB712CM;IAOI,2BAAA;ElB012CV;;EkBj22CM;IAOI,0BAAA;ElB812CV;;EkBr22CM;IAOI,0BAAA;ElBk22CV;;EkBz22CM;IAOI,0BAAA;ElBs22CV;;EkB722CM;IAOI,0BAAA;ElB022CV;;EkBj32CM;IAOI,0BAAA;ElB822CV;;EkBr32CM;IAOI,0BAAA;ElBk32CV;;EkBz32CM;IAOI,0BAAA;ElBs32CV;;EkB732CM;IAOI,0BAAA;ElB032CV;;EkBj42CM;IAOI,0BAAA;ElB832CV;;EkBr42CM;IAOI,2BAAA;ElBk42CV;;EkBz42CM;IAOI,2BAAA;ElBs42CV;;EkB742CM;IAOI,2BAAA;ElB042CV;;EkBj52CM;IAOI,2BAAA;ElB842CV;;EkBr52CM;IAOI,2BAAA;ElBk52CV;;EkBz52CM;IAOI,2BAAA;ElBs52CV;;EkB752CM;IAOI,2BAAA;ElB052CV;;EkBj62CM;IAOI,2BAAA;ElB852CV;;EkBr62CM;IAOI,2BAAA;ElBk62CV;;EkBz62CM;IAOI,2BAAA;ElBs62CV;;EkB762CM;IAOI,2BAAA;ElB062CV;;EkBj72CM;IAOI,2BAAA;ElB862CV;;EkBr72CM;IAOI,2BAAA;ElBk72CV;;EkBz72CM;IAOI,2BAAA;ElBs72CV;;EkB772CM;IAOI,2BAAA;ElB072CV;;EkBj82CM;IAOI,2BAAA;ElB872CV;;EkBr82CM;IAOI,2BAAA;ElBk82CV;;EkBz82CM;IAOI,2BAAA;ElBs82CV;;EkB782CM;IAOI,4BAAA;ElB082CV;;EkBj92CM;IAOI,4BAAA;ElB882CV;;EkBr92CM;IAOI,4BAAA;ElBk92CV;;EkBz92CM;IAOI,4BAAA;ElBs92CV;;EkB792CM;IAOI,4BAAA;ElB092CV;;EkBj+2CM;IAOI,4BAAA;ElB892CV;;EkBr+2CM;IAOI,4BAAA;ElBk+2CV;;EkBz+2CM;IAOI,4BAAA;ElBs+2CV;;EkB7+2CM;IAOI,4BAAA;ElB0+2CV;;EkBj/2CM;IAOI,4BAAA;ElB8+2CV;;EkBr/2CM;IAOI,4BAAA;ElBk/2CV;;EkBz/2CM;IAOI,4BAAA;ElBs/2CV;;EkB7/2CM;IAOI,4BAAA;ElB0/2CV;;EkBjg3CM;IAOI,4BAAA;ElB8/2CV;;EkBrg3CM;IAOI,4BAAA;ElBkg3CV;;EkBzg3CM;IAOI,4BAAA;ElBsg3CV;;EkB7g3CM;IAOI,4BAAA;ElB0g3CV;;EkBjh3CM;IAOI,4BAAA;ElB8g3CV;;EkBrh3CM;IAOI,4BAAA;ElBkh3CV;;EkBzh3CM;IAOI,4BAAA;ElBsh3CV;;EkB7h3CM;IAOI,4BAAA;ElB0h3CV;;EkBji3CM;IAOI,4BAAA;ElB8h3CV;;EkBri3CM;IAOI,4BAAA;ElBki3CV;;EkBzi3CM;IAOI,4BAAA;ElBsi3CV;;EkB7i3CM;IAOI,4BAAA;ElB0i3CV;;EkBjj3CM;IAOI,4BAAA;ElB8i3CV;;EkBrj3CM;IAOI,6BAAA;ElBkj3CV;AACF;AU7j3CI;EQGI;IAOI,sBAAA;ElBuj3CV;;EkB9j3CM;IAOI,uBAAA;ElB2j3CV;;EkBlk3CM;IAOI,sBAAA;ElB+j3CV;;EkBtk3CM;IAOI,8BAAA;ElBmk3CV;;EkB1k3CM;IAOI,4BAAA;ElBuk3CV;;EkB9k3CM;IAOI,2BAAA;ElB2k3CV;;EkBll3CM;IAOI,iCAAA;ElB+k3CV;;EkBtl3CM;IAOI,2BAAA;ElBml3CV;;EkB1l3CM;IAOI,0BAAA;ElBul3CV;;EkB9l3CM;IAOI,gCAAA;ElB2l3CV;;EkBlm3CM;IAOI,yBAAA;ElB+l3CV;;EkBtm3CM;IAOI,wBAAA;ElBmm3CV;;EkB1m3CM;IAOI,+BAAA;ElBum3CV;;EkB9m3CM;IAOI,yBAAA;ElB2m3CV;;EkBln3CM;IAOI,6BAAA;ElB+m3CV;;EkBtn3CM;IAOI,8BAAA;ElBmn3CV;;EkB1n3CM;IAOI,wBAAA;ElBun3CV;;EkB9n3CM;IAOI,+BAAA;ElB2n3CV;;EkBlo3CM;IAOI,wBAAA;ElB+n3CV;;EkBto3CM;IAOI,2BAAA;ElBmo3CV;;EkB1o3CM;IAOI,6BAAA;ElBuo3CV;;EkB9o3CM;IAOI,6BAAA;ElB2o3CV;;EkBlp3CM;IAOI,0BAAA;ElB+o3CV;;EkBtp3CM;IAOI,2BAAA;ElBmp3CV;;EkB1p3CM;IAOI,uBAAA;ElBup3CV;;EkB9p3CM;IAOI,qBAAA;ElB2p3CV;;EkBlq3CM;IAOI,qBAAA;ElB+p3CV;;EkBtq3CM;IAOI,qBAAA;ElBmq3CV;;EkB1q3CM;IAOI,sBAAA;ElBuq3CV;;EkB9q3CM;IAOI,sBAAA;ElB2q3CV;;EkBlr3CM;IAOI,qBAAA;ElB+q3CV;;EkBtr3CM;IAOI,qBAAA;ElBmr3CV;;EkB1r3CM;IAOI,qBAAA;ElBur3CV;;EkB9r3CM;IAOI,qBAAA;ElB2r3CV;;EkBls3CM;IAOI,qBAAA;ElB+r3CV;;EkBts3CM;IAOI,qBAAA;ElBms3CV;;EkB1s3CM;IAOI,qBAAA;ElBus3CV;;EkB9s3CM;IAOI,qBAAA;ElB2s3CV;;EkBlt3CM;IAOI,qBAAA;ElB+s3CV;;EkBtt3CM;IAOI,sBAAA;ElBmt3CV;;EkB1t3CM;IAOI,sBAAA;ElBut3CV;;EkB9t3CM;IAOI,sBAAA;ElB2t3CV;;EkBlu3CM;IAOI,sBAAA;ElB+t3CV;;EkBtu3CM;IAOI,sBAAA;ElBmu3CV;;EkB1u3CM;IAOI,sBAAA;ElBuu3CV;;EkB9u3CM;IAOI,sBAAA;ElB2u3CV;;EkBlv3CM;IAOI,sBAAA;ElB+u3CV;;EkBtv3CM;IAOI,sBAAA;ElBmv3CV;;EkB1v3CM;IAOI,sBAAA;ElBuv3CV;;EkB9v3CM;IAOI,sBAAA;ElB2v3CV;;EkBlw3CM;IAOI,sBAAA;ElB+v3CV;;EkBtw3CM;IAOI,sBAAA;ElBmw3CV;;EkB1w3CM;IAOI,sBAAA;ElBuw3CV;;EkB9w3CM;IAOI,sBAAA;ElB2w3CV;;EkBlx3CM;IAOI,sBAAA;ElB+w3CV;;EkBtx3CM;IAOI,sBAAA;ElBmx3CV;;EkB1x3CM;IAOI,sBAAA;ElBux3CV;;EkB9x3CM;IAOI,uBAAA;ElB2x3CV;;EkBly3CM;IAOI,uBAAA;ElB+x3CV;;EkBty3CM;IAOI,uBAAA;ElBmy3CV;;EkB1y3CM;IAOI,uBAAA;ElBuy3CV;;EkB9y3CM;IAOI,uBAAA;ElB2y3CV;;EkBlz3CM;IAOI,uBAAA;ElB+y3CV;;EkBtz3CM;IAOI,uBAAA;ElBmz3CV;;EkB1z3CM;IAOI,uBAAA;ElBuz3CV;;EkB9z3CM;IAOI,uBAAA;ElB2z3CV;;EkBl03CM;IAOI,uBAAA;ElB+z3CV;;EkBt03CM;IAOI,uBAAA;ElBm03CV;;EkB103CM;IAOI,uBAAA;ElBu03CV;;EkB903CM;IAOI,uBAAA;ElB203CV;;EkBl13CM;IAOI,uBAAA;ElB+03CV;;EkBt13CM;IAOI,uBAAA;ElBm13CV;;EkB113CM;IAOI,uBAAA;ElBu13CV;;EkB913CM;IAOI,uBAAA;ElB213CV;;EkBl23CM;IAOI,uBAAA;ElB+13CV;;EkBt23CM;IAOI,uBAAA;ElBm23CV;;EkB123CM;IAOI,uBAAA;ElBu23CV;;EkB923CM;IAOI,uBAAA;ElB223CV;;EkBl33CM;IAOI,uBAAA;ElB+23CV;;EkBt33CM;IAOI,uBAAA;ElBm33CV;;EkB133CM;IAOI,uBAAA;ElBu33CV;;EkB933CM;IAOI,uBAAA;ElB233CV;;EkBl43CM;IAOI,uBAAA;ElB+33CV;;EkBt43CM;IAOI,wBAAA;ElBm43CV;;EkB143CM;IAOI,2BAAA;ElBu43CV;;EkB943CM;IAOI,yBAAA;ElB243CV;;EkBl53CM;IAOI,yBAAA;ElB+43CV;;EkBt53CM;IAOI,yBAAA;ElBm53CV;;EkB153CM;IAOI,0BAAA;ElBu53CV;;EkB953CM;IAOI,0BAAA;ElB253CV;;EkBl63CM;IAOI,yBAAA;ElB+53CV;;EkBt63CM;IAOI,yBAAA;ElBm63CV;;EkB163CM;IAOI,yBAAA;ElBu63CV;;EkB963CM;IAOI,yBAAA;ElB263CV;;EkBl73CM;IAOI,yBAAA;ElB+63CV;;EkBt73CM;IAOI,yBAAA;ElBm73CV;;EkB173CM;IAOI,yBAAA;ElBu73CV;;EkB973CM;IAOI,yBAAA;ElB273CV;;EkBl83CM;IAOI,yBAAA;ElB+73CV;;EkBt83CM;IAOI,0BAAA;ElBm83CV;;EkB183CM;IAOI,0BAAA;ElBu83CV;;EkB983CM;IAOI,0BAAA;ElB283CV;;EkBl93CM;IAOI,0BAAA;ElB+83CV;;EkBt93CM;IAOI,0BAAA;ElBm93CV;;EkB193CM;IAOI,0BAAA;ElBu93CV;;EkB993CM;IAOI,0BAAA;ElB293CV;;EkBl+3CM;IAOI,0BAAA;ElB+93CV;;EkBt+3CM;IAOI,0BAAA;ElBm+3CV;;EkB1+3CM;IAOI,0BAAA;ElBu+3CV;;EkB9+3CM;IAOI,0BAAA;ElB2+3CV;;EkBl/3CM;IAOI,0BAAA;ElB++3CV;;EkBt/3CM;IAOI,0BAAA;ElBm/3CV;;EkB1/3CM;IAOI,0BAAA;ElBu/3CV;;EkB9/3CM;IAOI,0BAAA;ElB2/3CV;;EkBlg4CM;IAOI,0BAAA;ElB+/3CV;;EkBtg4CM;IAOI,0BAAA;ElBmg4CV;;EkB1g4CM;IAOI,0BAAA;ElBug4CV;;EkB9g4CM;IAOI,2BAAA;ElB2g4CV;;EkBlh4CM;IAOI,2BAAA;ElB+g4CV;;EkBth4CM;IAOI,2BAAA;ElBmh4CV;;EkB1h4CM;IAOI,2BAAA;ElBuh4CV;;EkB9h4CM;IAOI,2BAAA;ElB2h4CV;;EkBli4CM;IAOI,2BAAA;ElB+h4CV;;EkBti4CM;IAOI,2BAAA;ElBmi4CV;;EkB1i4CM;IAOI,2BAAA;ElBui4CV;;EkB9i4CM;IAOI,2BAAA;ElB2i4CV;;EkBlj4CM;IAOI,2BAAA;ElB+i4CV;;EkBtj4CM;IAOI,2BAAA;ElBmj4CV;;EkB1j4CM;IAOI,2BAAA;ElBuj4CV;;EkB9j4CM;IAOI,2BAAA;ElB2j4CV;;EkBlk4CM;IAOI,2BAAA;ElB+j4CV;;EkBtk4CM;IAOI,2BAAA;ElBmk4CV;;EkB1k4CM;IAOI,2BAAA;ElBuk4CV;;EkB9k4CM;IAOI,2BAAA;ElB2k4CV;;EkBll4CM;IAOI,2BAAA;ElB+k4CV;;EkBtl4CM;IAOI,2BAAA;ElBml4CV;;EkB1l4CM;IAOI,2BAAA;ElBul4CV;;EkB9l4CM;IAOI,2BAAA;ElB2l4CV;;EkBlm4CM;IAOI,2BAAA;ElB+l4CV;;EkBtm4CM;IAOI,2BAAA;ElBmm4CV;;EkB1m4CM;IAOI,2BAAA;ElBum4CV;;EkB9m4CM;IAOI,2BAAA;ElB2m4CV;;EkBln4CM;IAOI,2BAAA;ElB+m4CV;;EkBtn4CM;IAOI,4BAAA;ElBmn4CV;;EkB1n4CM;IAOI,wBAAA;ElBun4CV;;EkB9n4CM;IAOI,sBAAA;ElB2n4CV;;EkBlo4CM;IAOI,sBAAA;ElB+n4CV;;EkBto4CM;IAOI,sBAAA;ElBmo4CV;;EkB1o4CM;IAOI,uBAAA;ElBuo4CV;;EkB9o4CM;IAOI,uBAAA;ElB2o4CV;;EkBlp4CM;IAOI,sBAAA;ElB+o4CV;;EkBtp4CM;IAOI,sBAAA;ElBmp4CV;;EkB1p4CM;IAOI,sBAAA;ElBup4CV;;EkB9p4CM;IAOI,sBAAA;ElB2p4CV;;EkBlq4CM;IAOI,sBAAA;ElB+p4CV;;EkBtq4CM;IAOI,sBAAA;ElBmq4CV;;EkB1q4CM;IAOI,sBAAA;ElBuq4CV;;EkB9q4CM;IAOI,sBAAA;ElB2q4CV;;EkBlr4CM;IAOI,sBAAA;ElB+q4CV;;EkBtr4CM;IAOI,uBAAA;ElBmr4CV;;EkB1r4CM;IAOI,uBAAA;ElBur4CV;;EkB9r4CM;IAOI,uBAAA;ElB2r4CV;;EkBls4CM;IAOI,uBAAA;ElB+r4CV;;EkBts4CM;IAOI,uBAAA;ElBms4CV;;EkB1s4CM;IAOI,uBAAA;ElBus4CV;;EkB9s4CM;IAOI,uBAAA;ElB2s4CV;;EkBlt4CM;IAOI,uBAAA;ElB+s4CV;;EkBtt4CM;IAOI,uBAAA;ElBmt4CV;;EkB1t4CM;IAOI,uBAAA;ElBut4CV;;EkB9t4CM;IAOI,uBAAA;ElB2t4CV;;EkBlu4CM;IAOI,uBAAA;ElB+t4CV;;EkBtu4CM;IAOI,uBAAA;ElBmu4CV;;EkB1u4CM;IAOI,uBAAA;ElBuu4CV;;EkB9u4CM;IAOI,uBAAA;ElB2u4CV;;EkBlv4CM;IAOI,uBAAA;ElB+u4CV;;EkBtv4CM;IAOI,uBAAA;ElBmv4CV;;EkB1v4CM;IAOI,uBAAA;ElBuv4CV;;EkB9v4CM;IAOI,wBAAA;ElB2v4CV;;EkBlw4CM;IAOI,wBAAA;ElB+v4CV;;EkBtw4CM;IAOI,wBAAA;ElBmw4CV;;EkB1w4CM;IAOI,wBAAA;ElBuw4CV;;EkB9w4CM;IAOI,wBAAA;ElB2w4CV;;EkBlx4CM;IAOI,wBAAA;ElB+w4CV;;EkBtx4CM;IAOI,wBAAA;ElBmx4CV;;EkB1x4CM;IAOI,wBAAA;ElBux4CV;;EkB9x4CM;IAOI,wBAAA;ElB2x4CV;;EkBly4CM;IAOI,wBAAA;ElB+x4CV;;EkBty4CM;IAOI,wBAAA;ElBmy4CV;;EkB1y4CM;IAOI,wBAAA;ElBuy4CV;;EkB9y4CM;IAOI,wBAAA;ElB2y4CV;;EkBlz4CM;IAOI,wBAAA;ElB+y4CV;;EkBtz4CM;IAOI,wBAAA;ElBmz4CV;;EkB1z4CM;IAOI,wBAAA;ElBuz4CV;;EkB9z4CM;IAOI,wBAAA;ElB2z4CV;;EkBl04CM;IAOI,wBAAA;ElB+z4CV;;EkBt04CM;IAOI,wBAAA;ElBm04CV;;EkB104CM;IAOI,wBAAA;ElBu04CV;;EkB904CM;IAOI,wBAAA;ElB204CV;;EkBl14CM;IAOI,wBAAA;ElB+04CV;;EkBt14CM;IAOI,wBAAA;ElBm14CV;;EkB114CM;IAOI,wBAAA;ElBu14CV;;EkB914CM;IAOI,wBAAA;ElB214CV;;EkBl24CM;IAOI,wBAAA;ElB+14CV;;EkBt24CM;IAOI,yBAAA;ElBm24CV;;EkB124CM;IAOI,4BAAA;ElBu24CV;;EkB924CM;IAOI,0BAAA;ElB224CV;;EkBl34CM;IAOI,0BAAA;ElB+24CV;;EkBt34CM;IAOI,0BAAA;ElBm34CV;;EkB134CM;IAOI,2BAAA;ElBu34CV;;EkB934CM;IAOI,2BAAA;ElB234CV;;EkBl44CM;IAOI,0BAAA;ElB+34CV;;EkBt44CM;IAOI,0BAAA;ElBm44CV;;EkB144CM;IAOI,0BAAA;ElBu44CV;;EkB944CM;IAOI,0BAAA;ElB244CV;;EkBl54CM;IAOI,0BAAA;ElB+44CV;;EkBt54CM;IAOI,0BAAA;ElBm54CV;;EkB154CM;IAOI,0BAAA;ElBu54CV;;EkB954CM;IAOI,0BAAA;ElB254CV;;EkBl64CM;IAOI,0BAAA;ElB+54CV;;EkBt64CM;IAOI,2BAAA;ElBm64CV;;EkB164CM;IAOI,2BAAA;ElBu64CV;;EkB964CM;IAOI,2BAAA;ElB264CV;;EkBl74CM;IAOI,2BAAA;ElB+64CV;;EkBt74CM;IAOI,2BAAA;ElBm74CV;;EkB174CM;IAOI,2BAAA;ElBu74CV;;EkB974CM;IAOI,2BAAA;ElB274CV;;EkBl84CM;IAOI,2BAAA;ElB+74CV;;EkBt84CM;IAOI,2BAAA;ElBm84CV;;EkB184CM;IAOI,2BAAA;ElBu84CV;;EkB984CM;IAOI,2BAAA;ElB284CV;;EkBl94CM;IAOI,2BAAA;ElB+84CV;;EkBt94CM;IAOI,2BAAA;ElBm94CV;;EkB194CM;IAOI,2BAAA;ElBu94CV;;EkB994CM;IAOI,2BAAA;ElB294CV;;EkBl+4CM;IAOI,2BAAA;ElB+94CV;;EkBt+4CM;IAOI,2BAAA;ElBm+4CV;;EkB1+4CM;IAOI,2BAAA;ElBu+4CV;;EkB9+4CM;IAOI,4BAAA;ElB2+4CV;;EkBl/4CM;IAOI,4BAAA;ElB++4CV;;EkBt/4CM;IAOI,4BAAA;ElBm/4CV;;EkB1/4CM;IAOI,4BAAA;ElBu/4CV;;EkB9/4CM;IAOI,4BAAA;ElB2/4CV;;EkBlg5CM;IAOI,4BAAA;ElB+/4CV;;EkBtg5CM;IAOI,4BAAA;ElBmg5CV;;EkB1g5CM;IAOI,4BAAA;ElBug5CV;;EkB9g5CM;IAOI,4BAAA;ElB2g5CV;;EkBlh5CM;IAOI,4BAAA;ElB+g5CV;;EkBth5CM;IAOI,4BAAA;ElBmh5CV;;EkB1h5CM;IAOI,4BAAA;ElBuh5CV;;EkB9h5CM;IAOI,4BAAA;ElB2h5CV;;EkBli5CM;IAOI,4BAAA;ElB+h5CV;;EkBti5CM;IAOI,4BAAA;ElBmi5CV;;EkB1i5CM;IAOI,4BAAA;ElBui5CV;;EkB9i5CM;IAOI,4BAAA;ElB2i5CV;;EkBlj5CM;IAOI,4BAAA;ElB+i5CV;;EkBtj5CM;IAOI,4BAAA;ElBmj5CV;;EkB1j5CM;IAOI,4BAAA;ElBuj5CV;;EkB9j5CM;IAOI,4BAAA;ElB2j5CV;;EkBlk5CM;IAOI,4BAAA;ElB+j5CV;;EkBtk5CM;IAOI,4BAAA;ElBmk5CV;;EkB1k5CM;IAOI,4BAAA;ElBuk5CV;;EkB9k5CM;IAOI,4BAAA;ElB2k5CV;;EkBll5CM;IAOI,4BAAA;ElB+k5CV;;EkBtl5CM;IAOI,6BAAA;ElBml5CV;;EkB1l5CM;IAOI,yBAAA;ElBul5CV;;EkB9l5CM;IAOI,8BAAA;ElB2l5CV;;EkBlm5CM;IAOI,iCAAA;ElB+l5CV;;EkBtm5CM;IAOI,sCAAA;ElBmm5CV;;EkB1m5CM;IAOI,yCAAA;ElBum5CV;;EkB9m5CM;IAOI,uBAAA;ElB2m5CV;;EkBln5CM;IAOI,uBAAA;ElB+m5CV;;EkBtn5CM;IAOI,yBAAA;ElBmn5CV;;EkB1n5CM;IAOI,yBAAA;ElBun5CV;;EkB9n5CM;IAOI,0BAAA;ElB2n5CV;;EkBlo5CM;IAOI,4BAAA;ElB+n5CV;;EkBto5CM;IAOI,kCAAA;ElBmo5CV;;EkB1o5CM;IAOI,sCAAA;ElBuo5CV;;EkB9o5CM;IAOI,oCAAA;ElB2o5CV;;EkBlp5CM;IAOI,kCAAA;ElB+o5CV;;EkBtp5CM;IAOI,yCAAA;ElBmp5CV;;EkB1p5CM;IAOI,wCAAA;ElBup5CV;;EkB9p5CM;IAOI,wCAAA;ElB2p5CV;;EkBlq5CM;IAOI,kCAAA;ElB+p5CV;;EkBtq5CM;IAOI,gCAAA;ElBmq5CV;;EkB1q5CM;IAOI,8BAAA;ElBuq5CV;;EkB9q5CM;IAOI,gCAAA;ElB2q5CV;;EkBlr5CM;IAOI,+BAAA;ElB+q5CV;;EkBtr5CM;IAOI,oCAAA;ElBmr5CV;;EkB1r5CM;IAOI,kCAAA;ElBur5CV;;EkB9r5CM;IAOI,gCAAA;ElB2r5CV;;EkBls5CM;IAOI,uCAAA;ElB+r5CV;;EkBts5CM;IAOI,sCAAA;ElBms5CV;;EkB1s5CM;IAOI,iCAAA;ElBus5CV;;EkB9s5CM;IAOI,2BAAA;ElB2s5CV;;EkBlt5CM;IAOI,iCAAA;ElB+s5CV;;EkBtt5CM;IAOI,+BAAA;ElBmt5CV;;EkB1t5CM;IAOI,6BAAA;ElBut5CV;;EkB9t5CM;IAOI,+BAAA;ElB2t5CV;;EkBlu5CM;IAOI,8BAAA;ElB+t5CV;;EkBtu5CM;IAOI,oBAAA;ElBmu5CV;;EkB1u5CM;IAOI,mBAAA;ElBuu5CV;;EkB9u5CM;IAOI,mBAAA;ElB2u5CV;;EkBlv5CM;IAOI,mBAAA;ElB+u5CV;;EkBtv5CM;IAOI,mBAAA;ElBmv5CV;;EkB1v5CM;IAOI,mBAAA;ElBuv5CV;;EkB9v5CM;IAOI,mBAAA;ElB2v5CV;;EkBlw5CM;IAOI,mBAAA;ElB+v5CV;;EkBtw5CM;IAOI,oBAAA;ElBmw5CV;;EkB1w5CM;IAOI,0BAAA;ElBuw5CV;;EkB9w5CM;IAOI,yBAAA;ElB2w5CV;;EkBlx5CM;IAOI,0BAAA;ElB+w5CV;;EkBtx5CM;IAOI,uBAAA;ElBmx5CV;;EkB1x5CM;IAOI,0BAAA;ElBux5CV;;EkB9x5CM;IAOI,yBAAA;ElB2x5CV;;EkBly5CM;IAOI,0BAAA;ElB+x5CV;;EkBty5CM;IAOI,uBAAA;ElBmy5CV;;EkB1y5CM;IAOI,0BAAA;ElBuy5CV;;EkB9y5CM;IAOI,yBAAA;ElB2y5CV;;EkBlz5CM;IAOI,0BAAA;ElB+y5CV;;EkBtz5CM;IAOI,uBAAA;ElBmz5CV;;EkB1z5CM;IAOI,0BAAA;ElBuz5CV;;EkB9z5CM;IAOI,yBAAA;ElB2z5CV;;EkBl05CM;IAOI,0BAAA;ElB+z5CV;;EkBt05CM;IAOI,uBAAA;ElBm05CV;;EkB105CM;IAOI,0BAAA;ElBu05CV;;EkB905CM;IAOI,yBAAA;ElB205CV;;EkBl15CM;IAOI,0BAAA;ElB+05CV;;EkBt15CM;IAOI,uBAAA;ElBm15CV;;EkB115CM;IAOI,uBAAA;ElBu15CV;;EkB915CM;IAOI,0BAAA;IAAA,yBAAA;ElB415CV;;EkBn25CM;IAOI,gCAAA;IAAA,+BAAA;ElBi25CV;;EkBx25CM;IAOI,+BAAA;IAAA,8BAAA;ElBs25CV;;EkB725CM;IAOI,gCAAA;IAAA,+BAAA;ElB225CV;;EkBl35CM;IAOI,6BAAA;IAAA,4BAAA;ElBg35CV;;EkBv35CM;IAOI,gCAAA;IAAA,+BAAA;ElBq35CV;;EkB535CM;IAOI,+BAAA;IAAA,8BAAA;ElB035CV;;EkBj45CM;IAOI,gCAAA;IAAA,+BAAA;ElB+35CV;;EkBt45CM;IAOI,6BAAA;IAAA,4BAAA;ElBo45CV;;EkB345CM;IAOI,gCAAA;IAAA,+BAAA;ElBy45CV;;EkBh55CM;IAOI,+BAAA;IAAA,8BAAA;ElB845CV;;EkBr55CM;IAOI,gCAAA;IAAA,+BAAA;ElBm55CV;;EkB155CM;IAOI,6BAAA;IAAA,4BAAA;ElBw55CV;;EkB/55CM;IAOI,gCAAA;IAAA,+BAAA;ElB655CV;;EkBp65CM;IAOI,+BAAA;IAAA,8BAAA;ElBk65CV;;EkBz65CM;IAOI,gCAAA;IAAA,+BAAA;ElBu65CV;;EkB965CM;IAOI,6BAAA;IAAA,4BAAA;ElB465CV;;EkBn75CM;IAOI,gCAAA;IAAA,+BAAA;ElBi75CV;;EkBx75CM;IAOI,+BAAA;IAAA,8BAAA;ElBs75CV;;EkB775CM;IAOI,gCAAA;IAAA,+BAAA;ElB275CV;;EkBl85CM;IAOI,6BAAA;IAAA,4BAAA;ElBg85CV;;EkBv85CM;IAOI,6BAAA;IAAA,4BAAA;ElBq85CV;;EkB585CM;IAOI,wBAAA;IAAA,2BAAA;ElB085CV;;EkBj95CM;IAOI,8BAAA;IAAA,iCAAA;ElB+85CV;;EkBt95CM;IAOI,6BAAA;IAAA,gCAAA;ElBo95CV;;EkB395CM;IAOI,8BAAA;IAAA,iCAAA;ElBy95CV;;EkBh+5CM;IAOI,2BAAA;IAAA,8BAAA;ElB895CV;;EkBr+5CM;IAOI,8BAAA;IAAA,iCAAA;ElBm+5CV;;EkB1+5CM;IAOI,6BAAA;IAAA,gCAAA;ElBw+5CV;;EkB/+5CM;IAOI,8BAAA;IAAA,iCAAA;ElB6+5CV;;EkBp/5CM;IAOI,2BAAA;IAAA,8BAAA;ElBk/5CV;;EkBz/5CM;IAOI,8BAAA;IAAA,iCAAA;ElBu/5CV;;EkB9/5CM;IAOI,6BAAA;IAAA,gCAAA;ElB4/5CV;;EkBng6CM;IAOI,8BAAA;IAAA,iCAAA;ElBig6CV;;EkBxg6CM;IAOI,2BAAA;IAAA,8BAAA;ElBsg6CV;;EkB7g6CM;IAOI,8BAAA;IAAA,iCAAA;ElB2g6CV;;EkBlh6CM;IAOI,6BAAA;IAAA,gCAAA;ElBgh6CV;;EkBvh6CM;IAOI,8BAAA;IAAA,iCAAA;ElBqh6CV;;EkB5h6CM;IAOI,2BAAA;IAAA,8BAAA;ElB0h6CV;;EkBji6CM;IAOI,8BAAA;IAAA,iCAAA;ElB+h6CV;;EkBti6CM;IAOI,6BAAA;IAAA,gCAAA;ElBoi6CV;;EkB3i6CM;IAOI,8BAAA;IAAA,iCAAA;ElByi6CV;;EkBhj6CM;IAOI,2BAAA;IAAA,8BAAA;ElB8i6CV;;EkBrj6CM;IAOI,2BAAA;IAAA,8BAAA;ElBmj6CV;;EkB1j6CM;IAOI,wBAAA;ElBuj6CV;;EkB9j6CM;IAOI,8BAAA;ElB2j6CV;;EkBlk6CM;IAOI,6BAAA;ElB+j6CV;;EkBtk6CM;IAOI,8BAAA;ElBmk6CV;;EkB1k6CM;IAOI,2BAAA;ElBuk6CV;;EkB9k6CM;IAOI,8BAAA;ElB2k6CV;;EkBll6CM;IAOI,6BAAA;ElB+k6CV;;EkBtl6CM;IAOI,8BAAA;ElBml6CV;;EkB1l6CM;IAOI,2BAAA;ElBul6CV;;EkB9l6CM;IAOI,8BAAA;ElB2l6CV;;EkBlm6CM;IAOI,6BAAA;ElB+l6CV;;EkBtm6CM;IAOI,8BAAA;ElBmm6CV;;EkB1m6CM;IAOI,2BAAA;ElBum6CV;;EkB9m6CM;IAOI,8BAAA;ElB2m6CV;;EkBln6CM;IAOI,6BAAA;ElB+m6CV;;EkBtn6CM;IAOI,8BAAA;ElBmn6CV;;EkB1n6CM;IAOI,2BAAA;ElBun6CV;;EkB9n6CM;IAOI,8BAAA;ElB2n6CV;;EkBlo6CM;IAOI,6BAAA;ElB+n6CV;;EkBto6CM;IAOI,8BAAA;ElBmo6CV;;EkB1o6CM;IAOI,2BAAA;ElBuo6CV;;EkB9o6CM;IAOI,2BAAA;ElB2o6CV;;EkBlp6CM;IAOI,0BAAA;ElB+o6CV;;EkBtp6CM;IAOI,gCAAA;ElBmp6CV;;EkB1p6CM;IAOI,+BAAA;ElBup6CV;;EkB9p6CM;IAOI,gCAAA;ElB2p6CV;;EkBlq6CM;IAOI,6BAAA;ElB+p6CV;;EkBtq6CM;IAOI,gCAAA;ElBmq6CV;;EkB1q6CM;IAOI,+BAAA;ElBuq6CV;;EkB9q6CM;IAOI,gCAAA;ElB2q6CV;;EkBlr6CM;IAOI,6BAAA;ElB+q6CV;;EkBtr6CM;IAOI,gCAAA;ElBmr6CV;;EkB1r6CM;IAOI,+BAAA;ElBur6CV;;EkB9r6CM;IAOI,gCAAA;ElB2r6CV;;EkBls6CM;IAOI,6BAAA;ElB+r6CV;;EkBts6CM;IAOI,gCAAA;ElBms6CV;;EkB1s6CM;IAOI,+BAAA;ElBus6CV;;EkB9s6CM;IAOI,gCAAA;ElB2s6CV;;EkBlt6CM;IAOI,6BAAA;ElB+s6CV;;EkBtt6CM;IAOI,gCAAA;ElBmt6CV;;EkB1t6CM;IAOI,+BAAA;ElBut6CV;;EkB9t6CM;IAOI,gCAAA;ElB2t6CV;;EkBlu6CM;IAOI,6BAAA;ElB+t6CV;;EkBtu6CM;IAOI,6BAAA;ElBmu6CV;;EkB1u6CM;IAOI,2BAAA;ElBuu6CV;;EkB9u6CM;IAOI,iCAAA;ElB2u6CV;;EkBlv6CM;IAOI,gCAAA;ElB+u6CV;;EkBtv6CM;IAOI,iCAAA;ElBmv6CV;;EkB1v6CM;IAOI,8BAAA;ElBuv6CV;;EkB9v6CM;IAOI,iCAAA;ElB2v6CV;;EkBlw6CM;IAOI,gCAAA;ElB+v6CV;;EkBtw6CM;IAOI,iCAAA;ElBmw6CV;;EkB1w6CM;IAOI,8BAAA;ElBuw6CV;;EkB9w6CM;IAOI,iCAAA;ElB2w6CV;;EkBlx6CM;IAOI,gCAAA;ElB+w6CV;;EkBtx6CM;IAOI,iCAAA;ElBmx6CV;;EkB1x6CM;IAOI,8BAAA;ElBux6CV;;EkB9x6CM;IAOI,iCAAA;ElB2x6CV;;EkBly6CM;IAOI,gCAAA;ElB+x6CV;;EkBty6CM;IAOI,iCAAA;ElBmy6CV;;EkB1y6CM;IAOI,8BAAA;ElBuy6CV;;EkB9y6CM;IAOI,iCAAA;ElB2y6CV;;EkBlz6CM;IAOI,gCAAA;ElB+y6CV;;EkBtz6CM;IAOI,iCAAA;ElBmz6CV;;EkB1z6CM;IAOI,8BAAA;ElBuz6CV;;EkB9z6CM;IAOI,8BAAA;ElB2z6CV;;EkBl06CM;IAOI,yBAAA;ElB+z6CV;;EkBt06CM;IAOI,+BAAA;ElBm06CV;;EkB106CM;IAOI,8BAAA;ElBu06CV;;EkB906CM;IAOI,+BAAA;ElB206CV;;EkBl16CM;IAOI,4BAAA;ElB+06CV;;EkBt16CM;IAOI,+BAAA;ElBm16CV;;EkB116CM;IAOI,8BAAA;ElBu16CV;;EkB916CM;IAOI,+BAAA;ElB216CV;;EkBl26CM;IAOI,4BAAA;ElB+16CV;;EkBt26CM;IAOI,+BAAA;ElBm26CV;;EkB126CM;IAOI,8BAAA;ElBu26CV;;EkB926CM;IAOI,+BAAA;ElB226CV;;EkBl36CM;IAOI,4BAAA;ElB+26CV;;EkBt36CM;IAOI,+BAAA;ElBm36CV;;EkB136CM;IAOI,8BAAA;ElBu36CV;;EkB936CM;IAOI,+BAAA;ElB236CV;;EkBl46CM;IAOI,4BAAA;ElB+36CV;;EkBt46CM;IAOI,+BAAA;ElBm46CV;;EkB146CM;IAOI,8BAAA;ElBu46CV;;EkB946CM;IAOI,+BAAA;ElB246CV;;EkBl56CM;IAOI,4BAAA;ElB+46CV;;EkBt56CM;IAOI,4BAAA;ElBm56CV;;EkB156CM;IAOI,2BAAA;ElBu56CV;;EkB956CM;IAOI,0BAAA;ElB256CV;;EkBl66CM;IAOI,2BAAA;ElB+56CV;;EkBt66CM;IAOI,wBAAA;ElBm66CV;;EkB166CM;IAOI,2BAAA;ElBu66CV;;EkB966CM;IAOI,0BAAA;ElB266CV;;EkBl76CM;IAOI,2BAAA;ElB+66CV;;EkBt76CM;IAOI,wBAAA;ElBm76CV;;EkB176CM;IAOI,2BAAA;ElBu76CV;;EkB976CM;IAOI,0BAAA;ElB276CV;;EkBl86CM;IAOI,2BAAA;ElB+76CV;;EkBt86CM;IAOI,wBAAA;ElBm86CV;;EkB186CM;IAOI,2BAAA;ElBu86CV;;EkB986CM;IAOI,0BAAA;ElB286CV;;EkBl96CM;IAOI,2BAAA;ElB+86CV;;EkBt96CM;IAOI,wBAAA;ElBm96CV;;EkB196CM;IAOI,2BAAA;ElBu96CV;;EkB996CM;IAOI,0BAAA;ElB296CV;;EkBl+6CM;IAOI,2BAAA;ElB+96CV;;EkBt+6CM;IAOI,wBAAA;ElBm+6CV;;EkB1+6CM;IAOI,iCAAA;IAAA,gCAAA;ElBw+6CV;;EkB/+6CM;IAOI,gCAAA;IAAA,+BAAA;ElB6+6CV;;EkBp/6CM;IAOI,iCAAA;IAAA,gCAAA;ElBk/6CV;;EkBz/6CM;IAOI,8BAAA;IAAA,6BAAA;ElBu/6CV;;EkB9/6CM;IAOI,iCAAA;IAAA,gCAAA;ElB4/6CV;;EkBng7CM;IAOI,gCAAA;IAAA,+BAAA;ElBig7CV;;EkBxg7CM;IAOI,iCAAA;IAAA,gCAAA;ElBsg7CV;;EkB7g7CM;IAOI,8BAAA;IAAA,6BAAA;ElB2g7CV;;EkBlh7CM;IAOI,iCAAA;IAAA,gCAAA;ElBgh7CV;;EkBvh7CM;IAOI,gCAAA;IAAA,+BAAA;ElBqh7CV;;EkB5h7CM;IAOI,iCAAA;IAAA,gCAAA;ElB0h7CV;;EkBji7CM;IAOI,8BAAA;IAAA,6BAAA;ElB+h7CV;;EkBti7CM;IAOI,iCAAA;IAAA,gCAAA;ElBoi7CV;;EkB3i7CM;IAOI,gCAAA;IAAA,+BAAA;ElByi7CV;;EkBhj7CM;IAOI,iCAAA;IAAA,gCAAA;ElB8i7CV;;EkBrj7CM;IAOI,8BAAA;IAAA,6BAAA;ElBmj7CV;;EkB1j7CM;IAOI,iCAAA;IAAA,gCAAA;ElBwj7CV;;EkB/j7CM;IAOI,gCAAA;IAAA,+BAAA;ElB6j7CV;;EkBpk7CM;IAOI,iCAAA;IAAA,gCAAA;ElBkk7CV;;EkBzk7CM;IAOI,8BAAA;IAAA,6BAAA;ElBuk7CV;;EkB9k7CM;IAOI,+BAAA;IAAA,kCAAA;ElB4k7CV;;EkBnl7CM;IAOI,8BAAA;IAAA,iCAAA;ElBil7CV;;EkBxl7CM;IAOI,+BAAA;IAAA,kCAAA;ElBsl7CV;;EkB7l7CM;IAOI,4BAAA;IAAA,+BAAA;ElB2l7CV;;EkBlm7CM;IAOI,+BAAA;IAAA,kCAAA;ElBgm7CV;;EkBvm7CM;IAOI,8BAAA;IAAA,iCAAA;ElBqm7CV;;EkB5m7CM;IAOI,+BAAA;IAAA,kCAAA;ElB0m7CV;;EkBjn7CM;IAOI,4BAAA;IAAA,+BAAA;ElB+m7CV;;EkBtn7CM;IAOI,+BAAA;IAAA,kCAAA;ElBon7CV;;EkB3n7CM;IAOI,8BAAA;IAAA,iCAAA;ElByn7CV;;EkBho7CM;IAOI,+BAAA;IAAA,kCAAA;ElB8n7CV;;EkBro7CM;IAOI,4BAAA;IAAA,+BAAA;ElBmo7CV;;EkB1o7CM;IAOI,+BAAA;IAAA,kCAAA;ElBwo7CV;;EkB/o7CM;IAOI,8BAAA;IAAA,iCAAA;ElB6o7CV;;EkBpp7CM;IAOI,+BAAA;IAAA,kCAAA;ElBkp7CV;;EkBzp7CM;IAOI,4BAAA;IAAA,+BAAA;ElBup7CV;;EkB9p7CM;IAOI,+BAAA;IAAA,kCAAA;ElB4p7CV;;EkBnq7CM;IAOI,8BAAA;IAAA,iCAAA;ElBiq7CV;;EkBxq7CM;IAOI,+BAAA;IAAA,kCAAA;ElBsq7CV;;EkB7q7CM;IAOI,4BAAA;IAAA,+BAAA;ElB2q7CV;;EkBlr7CM;IAOI,+BAAA;ElB+q7CV;;EkBtr7CM;IAOI,8BAAA;ElBmr7CV;;EkB1r7CM;IAOI,+BAAA;ElBur7CV;;EkB9r7CM;IAOI,4BAAA;ElB2r7CV;;EkBls7CM;IAOI,+BAAA;ElB+r7CV;;EkBts7CM;IAOI,8BAAA;ElBms7CV;;EkB1s7CM;IAOI,+BAAA;ElBus7CV;;EkB9s7CM;IAOI,4BAAA;ElB2s7CV;;EkBlt7CM;IAOI,+BAAA;ElB+s7CV;;EkBtt7CM;IAOI,8BAAA;ElBmt7CV;;EkB1t7CM;IAOI,+BAAA;ElBut7CV;;EkB9t7CM;IAOI,4BAAA;ElB2t7CV;;EkBlu7CM;IAOI,+BAAA;ElB+t7CV;;EkBtu7CM;IAOI,8BAAA;ElBmu7CV;;EkB1u7CM;IAOI,+BAAA;ElBuu7CV;;EkB9u7CM;IAOI,4BAAA;ElB2u7CV;;EkBlv7CM;IAOI,+BAAA;ElB+u7CV;;EkBtv7CM;IAOI,8BAAA;ElBmv7CV;;EkB1v7CM;IAOI,+BAAA;ElBuv7CV;;EkB9v7CM;IAOI,4BAAA;ElB2v7CV;;EkBlw7CM;IAOI,iCAAA;ElB+v7CV;;EkBtw7CM;IAOI,gCAAA;ElBmw7CV;;EkB1w7CM;IAOI,iCAAA;ElBuw7CV;;EkB9w7CM;IAOI,8BAAA;ElB2w7CV;;EkBlx7CM;IAOI,iCAAA;ElB+w7CV;;EkBtx7CM;IAOI,gCAAA;ElBmx7CV;;EkB1x7CM;IAOI,iCAAA;ElBux7CV;;EkB9x7CM;IAOI,8BAAA;ElB2x7CV;;EkBly7CM;IAOI,iCAAA;ElB+x7CV;;EkBty7CM;IAOI,gCAAA;ElBmy7CV;;EkB1y7CM;IAOI,iCAAA;ElBuy7CV;;EkB9y7CM;IAOI,8BAAA;ElB2y7CV;;EkBlz7CM;IAOI,iCAAA;ElB+y7CV;;EkBtz7CM;IAOI,gCAAA;ElBmz7CV;;EkB1z7CM;IAOI,iCAAA;ElBuz7CV;;EkB9z7CM;IAOI,8BAAA;ElB2z7CV;;EkBl07CM;IAOI,iCAAA;ElB+z7CV;;EkBt07CM;IAOI,gCAAA;ElBm07CV;;EkB107CM;IAOI,iCAAA;ElBu07CV;;EkB907CM;IAOI,8BAAA;ElB207CV;;EkBl17CM;IAOI,kCAAA;ElB+07CV;;EkBt17CM;IAOI,iCAAA;ElBm17CV;;EkB117CM;IAOI,kCAAA;ElBu17CV;;EkB917CM;IAOI,+BAAA;ElB217CV;;EkBl27CM;IAOI,kCAAA;ElB+17CV;;EkBt27CM;IAOI,iCAAA;ElBm27CV;;EkB127CM;IAOI,kCAAA;ElBu27CV;;EkB927CM;IAOI,+BAAA;ElB227CV;;EkBl37CM;IAOI,kCAAA;ElB+27CV;;EkBt37CM;IAOI,iCAAA;ElBm37CV;;EkB137CM;IAOI,kCAAA;ElBu37CV;;EkB937CM;IAOI,+BAAA;ElB237CV;;EkBl47CM;IAOI,kCAAA;ElB+37CV;;EkBt47CM;IAOI,iCAAA;ElBm47CV;;EkB147CM;IAOI,kCAAA;ElBu47CV;;EkB947CM;IAOI,+BAAA;ElB247CV;;EkBl57CM;IAOI,kCAAA;ElB+47CV;;EkBt57CM;IAOI,iCAAA;ElBm57CV;;EkB157CM;IAOI,kCAAA;ElBu57CV;;EkB957CM;IAOI,+BAAA;ElB257CV;;EkBl67CM;IAOI,gCAAA;ElB+57CV;;EkBt67CM;IAOI,+BAAA;ElBm67CV;;EkB167CM;IAOI,gCAAA;ElBu67CV;;EkB967CM;IAOI,6BAAA;ElB267CV;;EkBl77CM;IAOI,gCAAA;ElB+67CV;;EkBt77CM;IAOI,+BAAA;ElBm77CV;;EkB177CM;IAOI,gCAAA;ElBu77CV;;EkB977CM;IAOI,6BAAA;ElB277CV;;EkBl87CM;IAOI,gCAAA;ElB+77CV;;EkBt87CM;IAOI,+BAAA;ElBm87CV;;EkB187CM;IAOI,gCAAA;ElBu87CV;;EkB987CM;IAOI,6BAAA;ElB287CV;;EkBl97CM;IAOI,gCAAA;ElB+87CV;;EkBt97CM;IAOI,+BAAA;ElBm97CV;;EkB197CM;IAOI,gCAAA;ElBu97CV;;EkB997CM;IAOI,6BAAA;ElB297CV;;EkBl+7CM;IAOI,gCAAA;ElB+97CV;;EkBt+7CM;IAOI,+BAAA;ElBm+7CV;;EkB1+7CM;IAOI,gCAAA;ElBu+7CV;;EkB9+7CM;IAOI,6BAAA;ElB2+7CV;;EkBl/7CM;IAOI,qBAAA;ElB++7CV;;EkBt/7CM;IAOI,2BAAA;ElBm/7CV;;EkB1/7CM;IAOI,0BAAA;ElBu/7CV;;EkB9/7CM;IAOI,2BAAA;ElB2/7CV;;EkBlg8CM;IAOI,wBAAA;ElB+/7CV;;EkBtg8CM;IAOI,2BAAA;ElBmg8CV;;EkB1g8CM;IAOI,0BAAA;ElBug8CV;;EkB9g8CM;IAOI,2BAAA;ElB2g8CV;;EkBlh8CM;IAOI,wBAAA;ElB+g8CV;;EkBth8CM;IAOI,2BAAA;ElBmh8CV;;EkB1h8CM;IAOI,0BAAA;ElBuh8CV;;EkB9h8CM;IAOI,2BAAA;ElB2h8CV;;EkBli8CM;IAOI,wBAAA;ElB+h8CV;;EkBti8CM;IAOI,2BAAA;ElBmi8CV;;EkB1i8CM;IAOI,0BAAA;ElBui8CV;;EkB9i8CM;IAOI,2BAAA;ElB2i8CV;;EkBlj8CM;IAOI,wBAAA;ElB+i8CV;;EkBtj8CM;IAOI,2BAAA;ElBmj8CV;;EkB1j8CM;IAOI,0BAAA;ElBuj8CV;;EkB9j8CM;IAOI,2BAAA;ElB2j8CV;;EkBlk8CM;IAOI,wBAAA;ElB+j8CV;;EkBtk8CM;IAOI,2BAAA;IAAA,0BAAA;ElBok8CV;;EkB3k8CM;IAOI,iCAAA;IAAA,gCAAA;ElByk8CV;;EkBhl8CM;IAOI,gCAAA;IAAA,+BAAA;ElB8k8CV;;EkBrl8CM;IAOI,iCAAA;IAAA,gCAAA;ElBml8CV;;EkB1l8CM;IAOI,8BAAA;IAAA,6BAAA;ElBwl8CV;;EkB/l8CM;IAOI,iCAAA;IAAA,gCAAA;ElB6l8CV;;EkBpm8CM;IAOI,gCAAA;IAAA,+BAAA;ElBkm8CV;;EkBzm8CM;IAOI,iCAAA;IAAA,gCAAA;ElBum8CV;;EkB9m8CM;IAOI,8BAAA;IAAA,6BAAA;ElB4m8CV;;EkBnn8CM;IAOI,iCAAA;IAAA,gCAAA;ElBin8CV;;EkBxn8CM;IAOI,gCAAA;IAAA,+BAAA;ElBsn8CV;;EkB7n8CM;IAOI,iCAAA;IAAA,gCAAA;ElB2n8CV;;EkBlo8CM;IAOI,8BAAA;IAAA,6BAAA;ElBgo8CV;;EkBvo8CM;IAOI,iCAAA;IAAA,gCAAA;ElBqo8CV;;EkB5o8CM;IAOI,gCAAA;IAAA,+BAAA;ElB0o8CV;;EkBjp8CM;IAOI,iCAAA;IAAA,gCAAA;ElB+o8CV;;EkBtp8CM;IAOI,8BAAA;IAAA,6BAAA;ElBop8CV;;EkB3p8CM;IAOI,iCAAA;IAAA,gCAAA;ElByp8CV;;EkBhq8CM;IAOI,gCAAA;IAAA,+BAAA;ElB8p8CV;;EkBrq8CM;IAOI,iCAAA;IAAA,gCAAA;ElBmq8CV;;EkB1q8CM;IAOI,8BAAA;IAAA,6BAAA;ElBwq8CV;;EkB/q8CM;IAOI,yBAAA;IAAA,4BAAA;ElB6q8CV;;EkBpr8CM;IAOI,+BAAA;IAAA,kCAAA;ElBkr8CV;;EkBzr8CM;IAOI,8BAAA;IAAA,iCAAA;ElBur8CV;;EkB9r8CM;IAOI,+BAAA;IAAA,kCAAA;ElB4r8CV;;EkBns8CM;IAOI,4BAAA;IAAA,+BAAA;ElBis8CV;;EkBxs8CM;IAOI,+BAAA;IAAA,kCAAA;ElBss8CV;;EkB7s8CM;IAOI,8BAAA;IAAA,iCAAA;ElB2s8CV;;EkBlt8CM;IAOI,+BAAA;IAAA,kCAAA;ElBgt8CV;;EkBvt8CM;IAOI,4BAAA;IAAA,+BAAA;ElBqt8CV;;EkB5t8CM;IAOI,+BAAA;IAAA,kCAAA;ElB0t8CV;;EkBju8CM;IAOI,8BAAA;IAAA,iCAAA;ElB+t8CV;;EkBtu8CM;IAOI,+BAAA;IAAA,kCAAA;ElBou8CV;;EkB3u8CM;IAOI,4BAAA;IAAA,+BAAA;ElByu8CV;;EkBhv8CM;IAOI,+BAAA;IAAA,kCAAA;ElB8u8CV;;EkBrv8CM;IAOI,8BAAA;IAAA,iCAAA;ElBmv8CV;;EkB1v8CM;IAOI,+BAAA;IAAA,kCAAA;ElBwv8CV;;EkB/v8CM;IAOI,4BAAA;IAAA,+BAAA;ElB6v8CV;;EkBpw8CM;IAOI,+BAAA;IAAA,kCAAA;ElBkw8CV;;EkBzw8CM;IAOI,8BAAA;IAAA,iCAAA;ElBuw8CV;;EkB9w8CM;IAOI,+BAAA;IAAA,kCAAA;ElB4w8CV;;EkBnx8CM;IAOI,4BAAA;IAAA,+BAAA;ElBix8CV;;EkBxx8CM;IAOI,yBAAA;ElBqx8CV;;EkB5x8CM;IAOI,+BAAA;ElByx8CV;;EkBhy8CM;IAOI,8BAAA;ElB6x8CV;;EkBpy8CM;IAOI,+BAAA;ElBiy8CV;;EkBxy8CM;IAOI,4BAAA;ElBqy8CV;;EkB5y8CM;IAOI,+BAAA;ElByy8CV;;EkBhz8CM;IAOI,8BAAA;ElB6y8CV;;EkBpz8CM;IAOI,+BAAA;ElBiz8CV;;EkBxz8CM;IAOI,4BAAA;ElBqz8CV;;EkB5z8CM;IAOI,+BAAA;ElByz8CV;;EkBh08CM;IAOI,8BAAA;ElB6z8CV;;EkBp08CM;IAOI,+BAAA;ElBi08CV;;EkBx08CM;IAOI,4BAAA;ElBq08CV;;EkB508CM;IAOI,+BAAA;ElBy08CV;;EkBh18CM;IAOI,8BAAA;ElB608CV;;EkBp18CM;IAOI,+BAAA;ElBi18CV;;EkBx18CM;IAOI,4BAAA;ElBq18CV;;EkB518CM;IAOI,+BAAA;ElBy18CV;;EkBh28CM;IAOI,8BAAA;ElB618CV;;EkBp28CM;IAOI,+BAAA;ElBi28CV;;EkBx28CM;IAOI,4BAAA;ElBq28CV;;EkB528CM;IAOI,2BAAA;ElBy28CV;;EkBh38CM;IAOI,iCAAA;ElB628CV;;EkBp38CM;IAOI,gCAAA;ElBi38CV;;EkBx38CM;IAOI,iCAAA;ElBq38CV;;EkB538CM;IAOI,8BAAA;ElBy38CV;;EkBh48CM;IAOI,iCAAA;ElB638CV;;EkBp48CM;IAOI,gCAAA;ElBi48CV;;EkBx48CM;IAOI,iCAAA;ElBq48CV;;EkB548CM;IAOI,8BAAA;ElBy48CV;;EkBh58CM;IAOI,iCAAA;ElB648CV;;EkBp58CM;IAOI,gCAAA;ElBi58CV;;EkBx58CM;IAOI,iCAAA;ElBq58CV;;EkB558CM;IAOI,8BAAA;ElBy58CV;;EkBh68CM;IAOI,iCAAA;ElB658CV;;EkBp68CM;IAOI,gCAAA;ElBi68CV;;EkBx68CM;IAOI,iCAAA;ElBq68CV;;EkB568CM;IAOI,8BAAA;ElBy68CV;;EkBh78CM;IAOI,iCAAA;ElB668CV;;EkBp78CM;IAOI,gCAAA;ElBi78CV;;EkBx78CM;IAOI,iCAAA;ElBq78CV;;EkB578CM;IAOI,8BAAA;ElBy78CV;;EkBh88CM;IAOI,4BAAA;ElB678CV;;EkBp88CM;IAOI,kCAAA;ElBi88CV;;EkBx88CM;IAOI,iCAAA;ElBq88CV;;EkB588CM;IAOI,kCAAA;ElBy88CV;;EkBh98CM;IAOI,+BAAA;ElB688CV;;EkBp98CM;IAOI,kCAAA;ElBi98CV;;EkBx98CM;IAOI,iCAAA;ElBq98CV;;EkB598CM;IAOI,kCAAA;ElBy98CV;;EkBh+8CM;IAOI,+BAAA;ElB698CV;;EkBp+8CM;IAOI,kCAAA;ElBi+8CV;;EkBx+8CM;IAOI,iCAAA;ElBq+8CV;;EkB5+8CM;IAOI,kCAAA;ElBy+8CV;;EkBh/8CM;IAOI,+BAAA;ElB6+8CV;;EkBp/8CM;IAOI,kCAAA;ElBi/8CV;;EkBx/8CM;IAOI,iCAAA;ElBq/8CV;;EkB5/8CM;IAOI,kCAAA;ElBy/8CV;;EkBhg9CM;IAOI,+BAAA;ElB6/8CV;;EkBpg9CM;IAOI,kCAAA;ElBig9CV;;EkBxg9CM;IAOI,iCAAA;ElBqg9CV;;EkB5g9CM;IAOI,kCAAA;ElByg9CV;;EkBhh9CM;IAOI,+BAAA;ElB6g9CV;;EkBph9CM;IAOI,0BAAA;ElBih9CV;;EkBxh9CM;IAOI,gCAAA;ElBqh9CV;;EkB5h9CM;IAOI,+BAAA;ElByh9CV;;EkBhi9CM;IAOI,gCAAA;ElB6h9CV;;EkBpi9CM;IAOI,6BAAA;ElBii9CV;;EkBxi9CM;IAOI,gCAAA;ElBqi9CV;;EkB5i9CM;IAOI,+BAAA;ElByi9CV;;EkBhj9CM;IAOI,gCAAA;ElB6i9CV;;EkBpj9CM;IAOI,6BAAA;ElBij9CV;;EkBxj9CM;IAOI,gCAAA;ElBqj9CV;;EkB5j9CM;IAOI,+BAAA;ElByj9CV;;EkBhk9CM;IAOI,gCAAA;ElB6j9CV;;EkBpk9CM;IAOI,6BAAA;ElBik9CV;;EkBxk9CM;IAOI,gCAAA;ElBqk9CV;;EkB5k9CM;IAOI,+BAAA;ElByk9CV;;EkBhl9CM;IAOI,gCAAA;ElB6k9CV;;EkBpl9CM;IAOI,6BAAA;ElBil9CV;;EkBxl9CM;IAOI,gCAAA;ElBql9CV;;EkB5l9CM;IAOI,+BAAA;ElByl9CV;;EkBhm9CM;IAOI,gCAAA;ElB6l9CV;;EkBpm9CM;IAOI,6BAAA;ElBim9CV;;EkBxm9CM;IAOI,iBAAA;ElBqm9CV;;EkB5m9CM;IAOI,uBAAA;ElBym9CV;;EkBhn9CM;IAOI,sBAAA;ElB6m9CV;;EkBpn9CM;IAOI,uBAAA;ElBin9CV;;EkBxn9CM;IAOI,oBAAA;ElBqn9CV;;EkB5n9CM;IAOI,uBAAA;ElByn9CV;;EkBho9CM;IAOI,sBAAA;ElB6n9CV;;EkBpo9CM;IAOI,uBAAA;ElBio9CV;;EkBxo9CM;IAOI,oBAAA;ElBqo9CV;;EkB5o9CM;IAOI,uBAAA;ElByo9CV;;EkBhp9CM;IAOI,sBAAA;ElB6o9CV;;EkBpp9CM;IAOI,uBAAA;ElBip9CV;;EkBxp9CM;IAOI,oBAAA;ElBqp9CV;;EkB5p9CM;IAOI,uBAAA;ElByp9CV;;EkBhq9CM;IAOI,sBAAA;ElB6p9CV;;EkBpq9CM;IAOI,uBAAA;ElBiq9CV;;EkBxq9CM;IAOI,oBAAA;ElBqq9CV;;EkB5q9CM;IAOI,uBAAA;ElByq9CV;;EkBhr9CM;IAOI,sBAAA;ElB6q9CV;;EkBpr9CM;IAOI,uBAAA;ElBir9CV;;EkBxr9CM;IAOI,oBAAA;ElBqr9CV;;EkB5r9CM;IAOI,qBAAA;ElByr9CV;;EkBhs9CM;IAOI,2BAAA;ElB6r9CV;;EkBps9CM;IAOI,0BAAA;ElBis9CV;;EkBxs9CM;IAOI,2BAAA;ElBqs9CV;;EkB5s9CM;IAOI,wBAAA;ElBys9CV;;EkBht9CM;IAOI,2BAAA;ElB6s9CV;;EkBpt9CM;IAOI,0BAAA;ElBit9CV;;EkBxt9CM;IAOI,2BAAA;ElBqt9CV;;EkB5t9CM;IAOI,wBAAA;ElByt9CV;;EkBhu9CM;IAOI,2BAAA;ElB6t9CV;;EkBpu9CM;IAOI,0BAAA;ElBiu9CV;;EkBxu9CM;IAOI,2BAAA;ElBqu9CV;;EkB5u9CM;IAOI,wBAAA;ElByu9CV;;EkBhv9CM;IAOI,2BAAA;ElB6u9CV;;EkBpv9CM;IAOI,0BAAA;ElBiv9CV;;EkBxv9CM;IAOI,2BAAA;ElBqv9CV;;EkB5v9CM;IAOI,wBAAA;ElByv9CV;;EkBhw9CM;IAOI,2BAAA;ElB6v9CV;;EkBpw9CM;IAOI,0BAAA;ElBiw9CV;;EkBxw9CM;IAOI,2BAAA;ElBqw9CV;;EkB5w9CM;IAOI,wBAAA;ElByw9CV;;EkBhx9CM;IAOI,wBAAA;ElB6w9CV;;EkBpx9CM;IAOI,8BAAA;ElBix9CV;;EkBxx9CM;IAOI,6BAAA;ElBqx9CV;;EkB5x9CM;IAOI,8BAAA;ElByx9CV;;EkBhy9CM;IAOI,2BAAA;ElB6x9CV;;EkBpy9CM;IAOI,8BAAA;ElBiy9CV;;EkBxy9CM;IAOI,6BAAA;ElBqy9CV;;EkB5y9CM;IAOI,8BAAA;ElByy9CV;;EkBhz9CM;IAOI,2BAAA;ElB6y9CV;;EkBpz9CM;IAOI,8BAAA;ElBiz9CV;;EkBxz9CM;IAOI,6BAAA;ElBqz9CV;;EkB5z9CM;IAOI,8BAAA;ElByz9CV;;EkBh09CM;IAOI,2BAAA;ElB6z9CV;;EkBp09CM;IAOI,8BAAA;ElBi09CV;;EkBx09CM;IAOI,6BAAA;ElBq09CV;;EkB509CM;IAOI,8BAAA;ElBy09CV;;EkBh19CM;IAOI,2BAAA;ElB609CV;;EkBp19CM;IAOI,8BAAA;ElBi19CV;;EkBx19CM;IAOI,6BAAA;ElBq19CV;;EkB519CM;IAOI,8BAAA;ElBy19CV;;EkBh29CM;IAOI,2BAAA;ElB619CV;;EkBp29CM;IAOI,0CAAA;ElBi29CV;;EkBx29CM;IAOI,4CAAA;ElBq29CV;;EkB529CM;IAOI,4CAAA;ElBy29CV;;EkBh39CM;IAOI,6BAAA;ElB629CV;;EkBp39CM;IAOI,6BAAA;ElBi39CV;;EkBx39CM;IAOI,8BAAA;ElBq39CV;;EkB539CM;IAOI,6BAAA;ElBy39CV;;EkBh49CM;IAOI,6BAAA;ElB639CV;;EkBp49CM;IAOI,6BAAA;ElBi49CV;;EkBx49CM;IAOI,4BAAA;ElBq49CV;;EkB549CM;IAOI,0BAAA;ElBy49CV;;EkBh59CM;IAOI,0BAAA;ElB649CV;;EkBp59CM;IAOI,4CAAA;ElBi59CV;;EkBx59CM;IAOI,2CAAA;ElBq59CV;;EkB559CM;IAOI,4CAAA;ElBy59CV;;EkBh69CM;IAOI,0CAAA;ElB659CV;;EkBp69CM;IAOI,4CAAA;ElBi69CV;;EkBx69CM;IAOI,2CAAA;ElBq69CV;;EkB569CM;IAOI,4CAAA;ElBy69CV;;EkBh79CM;IAOI,wCAAA;ElB669CV;;EkBp79CM;IAOI,4CAAA;ElBi79CV;;EkBx79CM;IAOI,2CAAA;ElBq79CV;;EkB579CM;IAOI,4CAAA;ElBy79CV;;EkBh89CM;IAOI,0CAAA;ElB679CV;;EkBp89CM;IAOI,4CAAA;ElBi89CV;;EkBx89CM;IAOI,2CAAA;ElBq89CV;;EkB589CM;IAOI,4CAAA;ElBy89CV;;EkBh99CM;IAOI,0CAAA;ElB689CV;;EkBp99CM;IAOI,2BAAA;ElBi99CV;;EkBx99CM;IAOI,4BAAA;ElBq99CV;;EkB599CM;IAOI,6BAAA;ElBy99CV;;EkBh+9CM;IAOI,2BAAA;ElB699CV;;EkBp+9CM;IAOI,yBAAA;ElBi+9CV;;EkBx+9CM;IAOI,yBAAA;ElBq+9CV;;EkB5+9CM;IAOI,yBAAA;ElBy+9CV;;EkBh/9CM;IAOI,0BAAA;ElB6+9CV;;EkBp/9CM;IAOI,0BAAA;ElBi/9CV;;EkBx/9CM;IAOI,yBAAA;ElBq/9CV;;EkB5/9CM;IAOI,yBAAA;ElBy/9CV;;EkBhg+CM;IAOI,yBAAA;ElB6/9CV;;EkBpg+CM;IAOI,yBAAA;ElBig+CV;;EkBxg+CM;IAOI,yBAAA;ElBqg+CV;;EkB5g+CM;IAOI,yBAAA;ElByg+CV;;EkBhh+CM;IAOI,yBAAA;ElB6g+CV;;EkBph+CM;IAOI,yBAAA;ElBih+CV;;EkBxh+CM;IAOI,yBAAA;ElBqh+CV;;EkB5h+CM;IAOI,0BAAA;ElByh+CV;;EkBhi+CM;IAOI,0BAAA;ElB6h+CV;;EkBpi+CM;IAOI,0BAAA;ElBii+CV;;EkBxi+CM;IAOI,0BAAA;ElBqi+CV;;EkB5i+CM;IAOI,0BAAA;ElByi+CV;;EkBhj+CM;IAOI,0BAAA;ElB6i+CV;;EkBpj+CM;IAOI,0BAAA;ElBij+CV;;EkBxj+CM;IAOI,0BAAA;ElBqj+CV;;EkB5j+CM;IAOI,0BAAA;ElByj+CV;;EkBhk+CM;IAOI,0BAAA;ElB6j+CV;;EkBpk+CM;IAOI,0BAAA;ElBik+CV;;EkBxk+CM;IAOI,0BAAA;ElBqk+CV;;EkB5k+CM;IAOI,0BAAA;ElByk+CV;;EkBhl+CM;IAOI,0BAAA;ElB6k+CV;;EkBpl+CM;IAOI,0BAAA;ElBil+CV;;EkBxl+CM;IAOI,0BAAA;ElBql+CV;;EkB5l+CM;IAOI,0BAAA;ElByl+CV;;EkBhm+CM;IAOI,0BAAA;ElB6l+CV;;EkBpm+CM;IAOI,2BAAA;ElBim+CV;;EkBxm+CM;IAOI,2BAAA;ElBqm+CV;;EkB5m+CM;IAOI,2BAAA;ElBym+CV;;EkBhn+CM;IAOI,2BAAA;ElB6m+CV;;EkBpn+CM;IAOI,2BAAA;ElBin+CV;;EkBxn+CM;IAOI,2BAAA;ElBqn+CV;;EkB5n+CM;IAOI,2BAAA;ElByn+CV;;EkBho+CM;IAOI,2BAAA;ElB6n+CV;;EkBpo+CM;IAOI,2BAAA;ElBio+CV;;EkBxo+CM;IAOI,2BAAA;ElBqo+CV;;EkB5o+CM;IAOI,2BAAA;ElByo+CV;;EkBhp+CM;IAOI,2BAAA;ElB6o+CV;;EkBpp+CM;IAOI,2BAAA;ElBip+CV;;EkBxp+CM;IAOI,2BAAA;ElBqp+CV;;EkB5p+CM;IAOI,2BAAA;ElByp+CV;;EkBhq+CM;IAOI,2BAAA;ElB6p+CV;;EkBpq+CM;IAOI,2BAAA;ElBiq+CV;;EkBxq+CM;IAOI,2BAAA;ElBqq+CV;;EkB5q+CM;IAOI,2BAAA;ElByq+CV;;EkBhr+CM;IAOI,2BAAA;ElB6q+CV;;EkBpr+CM;IAOI,2BAAA;ElBir+CV;;EkBxr+CM;IAOI,2BAAA;ElBqr+CV;;EkB5r+CM;IAOI,2BAAA;ElByr+CV;;EkBhs+CM;IAOI,2BAAA;ElB6r+CV;;EkBps+CM;IAOI,2BAAA;ElBis+CV;;EkBxs+CM;IAOI,2BAAA;ElBqs+CV;;EkB5s+CM;IAOI,4BAAA;ElBys+CV;;EkBht+CM;IAOI,4BAAA;ElB6s+CV;;EkBpt+CM;IAOI,0BAAA;ElBit+CV;;EkBxt+CM;IAOI,0BAAA;ElBqt+CV;;EkB5t+CM;IAOI,0BAAA;ElByt+CV;;EkBhu+CM;IAOI,2BAAA;ElB6t+CV;;EkBpu+CM;IAOI,2BAAA;ElBiu+CV;;EkBxu+CM;IAOI,0BAAA;ElBqu+CV;;EkB5u+CM;IAOI,0BAAA;ElByu+CV;;EkBhv+CM;IAOI,0BAAA;ElB6u+CV;;EkBpv+CM;IAOI,0BAAA;ElBiv+CV;;EkBxv+CM;IAOI,0BAAA;ElBqv+CV;;EkB5v+CM;IAOI,0BAAA;ElByv+CV;;EkBhw+CM;IAOI,0BAAA;ElB6v+CV;;EkBpw+CM;IAOI,0BAAA;ElBiw+CV;;EkBxw+CM;IAOI,0BAAA;ElBqw+CV;;EkB5w+CM;IAOI,2BAAA;ElByw+CV;;EkBhx+CM;IAOI,2BAAA;ElB6w+CV;;EkBpx+CM;IAOI,2BAAA;ElBix+CV;;EkBxx+CM;IAOI,2BAAA;ElBqx+CV;;EkB5x+CM;IAOI,2BAAA;ElByx+CV;;EkBhy+CM;IAOI,2BAAA;ElB6x+CV;;EkBpy+CM;IAOI,2BAAA;ElBiy+CV;;EkBxy+CM;IAOI,2BAAA;ElBqy+CV;;EkB5y+CM;IAOI,2BAAA;ElByy+CV;;EkBhz+CM;IAOI,2BAAA;ElB6y+CV;;EkBpz+CM;IAOI,2BAAA;ElBiz+CV;;EkBxz+CM;IAOI,2BAAA;ElBqz+CV;;EkB5z+CM;IAOI,2BAAA;ElByz+CV;;EkBh0+CM;IAOI,2BAAA;ElB6z+CV;;EkBp0+CM;IAOI,2BAAA;ElBi0+CV;;EkBx0+CM;IAOI,2BAAA;ElBq0+CV;;EkB50+CM;IAOI,2BAAA;ElBy0+CV;;EkBh1+CM;IAOI,2BAAA;ElB60+CV;;EkBp1+CM;IAOI,4BAAA;ElBi1+CV;;EkBx1+CM;IAOI,4BAAA;ElBq1+CV;;EkB51+CM;IAOI,4BAAA;ElBy1+CV;;EkBh2+CM;IAOI,4BAAA;ElB61+CV;;EkBp2+CM;IAOI,4BAAA;ElBi2+CV;;EkBx2+CM;IAOI,4BAAA;ElBq2+CV;;EkB52+CM;IAOI,4BAAA;ElBy2+CV;;EkBh3+CM;IAOI,4BAAA;ElB62+CV;;EkBp3+CM;IAOI,4BAAA;ElBi3+CV;;EkBx3+CM;IAOI,4BAAA;ElBq3+CV;;EkB53+CM;IAOI,4BAAA;ElBy3+CV;;EkBh4+CM;IAOI,4BAAA;ElB63+CV;;EkBp4+CM;IAOI,4BAAA;ElBi4+CV;;EkBx4+CM;IAOI,4BAAA;ElBq4+CV;;EkB54+CM;IAOI,4BAAA;ElBy4+CV;;EkBh5+CM;IAOI,4BAAA;ElB64+CV;;EkBp5+CM;IAOI,4BAAA;ElBi5+CV;;EkBx5+CM;IAOI,4BAAA;ElBq5+CV;;EkB55+CM;IAOI,4BAAA;ElBy5+CV;;EkBh6+CM;IAOI,4BAAA;ElB65+CV;;EkBp6+CM;IAOI,4BAAA;ElBi6+CV;;EkBx6+CM;IAOI,4BAAA;ElBq6+CV;;EkB56+CM;IAOI,4BAAA;ElBy6+CV;;EkBh7+CM;IAOI,4BAAA;ElB66+CV;;EkBp7+CM;IAOI,4BAAA;ElBi7+CV;;EkBx7+CM;IAOI,4BAAA;ElBq7+CV;;EkB57+CM;IAOI,6BAAA;ElBy7+CV;AACF;AmBh/+CA;ED+CQ;IAOI,6BAAA;ElB87+CV;;EkBr8+CM;IAOI,4BAAA;ElBk8+CV;;EkBz8+CM;IAOI,6BAAA;ElBs8+CV;;EkB78+CM;IAOI,0BAAA;ElB08+CV;;EkBj9+CM;IAOI,6BAAA;ElB88+CV;;EkBr9+CM;IAOI,4BAAA;ElBk9+CV;;EkBz9+CM;IAOI,6BAAA;ElBs9+CV;;EkB79+CM;IAOI,0BAAA;ElB09+CV;;EkBj++CM;IAOI,6BAAA;ElB89+CV;;EkBr++CM;IAOI,4BAAA;ElBk++CV;;EkBz++CM;IAOI,6BAAA;ElBs++CV;;EkB7++CM;IAOI,0BAAA;ElB0++CV;;EkBj/+CM;IAOI,6BAAA;ElB8++CV;;EkBr/+CM;IAOI,4BAAA;ElBk/+CV;;EkBz/+CM;IAOI,6BAAA;ElBs/+CV;;EkB7/+CM;IAOI,0BAAA;ElB0/+CV;;EkBjg/CM;IAOI,6BAAA;ElB8/+CV;;EkBrg/CM;IAOI,4BAAA;ElBkg/CV;;EkBzg/CM;IAOI,6BAAA;ElBsg/CV;;EkB7g/CM;IAOI,6BAAA;ElB0g/CV;;EkBjh/CM;IAOI,4BAAA;ElB8g/CV;;EkBrh/CM;IAOI,6BAAA;ElBkh/CV;;EkBzh/CM;IAOI,0BAAA;ElBsh/CV;;EkB7h/CM;IAOI,6BAAA;ElB0h/CV;;EkBji/CM;IAOI,4BAAA;ElB8h/CV;;EkBri/CM;IAOI,6BAAA;ElBki/CV;;EkBzi/CM;IAOI,0BAAA;ElBsi/CV;;EkB7i/CM;IAOI,6BAAA;ElB0i/CV;;EkBjj/CM;IAOI,4BAAA;ElB8i/CV;;EkBrj/CM;IAOI,6BAAA;ElBkj/CV;;EkBzj/CM;IAOI,0BAAA;ElBsj/CV;;EkB7j/CM;IAOI,6BAAA;ElB0j/CV;;EkBjk/CM;IAOI,4BAAA;ElB8j/CV;;EkBrk/CM;IAOI,6BAAA;ElBkk/CV;;EkBzk/CM;IAOI,0BAAA;ElBsk/CV;;EkB7k/CM;IAOI,6BAAA;ElB0k/CV;;EkBjl/CM;IAOI,4BAAA;ElB8k/CV;;EkBrl/CM;IAOI,6BAAA;ElBkl/CV;;EkBzl/CM;IAOI,6BAAA;ElBsl/CV;;EkB7l/CM;IAOI,4BAAA;ElB0l/CV;;EkBjm/CM;IAOI,6BAAA;ElB8l/CV;;EkBrm/CM;IAOI,0BAAA;ElBkm/CV;;EkBzm/CM;IAOI,6BAAA;ElBsm/CV;;EkB7m/CM;IAOI,4BAAA;ElB0m/CV;;EkBjn/CM;IAOI,6BAAA;ElB8m/CV;;EkBrn/CM;IAOI,0BAAA;ElBkn/CV;;EkBzn/CM;IAOI,6BAAA;ElBsn/CV;;EkB7n/CM;IAOI,4BAAA;ElB0n/CV;;EkBjo/CM;IAOI,6BAAA;ElB8n/CV;;EkBro/CM;IAOI,0BAAA;ElBko/CV;;EkBzo/CM;IAOI,6BAAA;ElBso/CV;;EkB7o/CM;IAOI,4BAAA;ElB0o/CV;;EkBjp/CM;IAOI,6BAAA;ElB8o/CV;;EkBrp/CM;IAOI,0BAAA;ElBkp/CV;;EkBzp/CM;IAOI,6BAAA;ElBsp/CV;;EkB7p/CM;IAOI,4BAAA;ElB0p/CV;;EkBjq/CM;IAOI,6BAAA;ElB8p/CV;;EkBrq/CM;IAOI,6BAAA;ElBkq/CV;;EkBzq/CM;IAOI,4BAAA;ElBsq/CV;;EkB7q/CM;IAOI,6BAAA;ElB0q/CV;;EkBjr/CM;IAOI,0BAAA;ElB8q/CV;;EkBrr/CM;IAOI,6BAAA;ElBkr/CV;;EkBzr/CM;IAOI,4BAAA;ElBsr/CV;;EkB7r/CM;IAOI,6BAAA;ElB0r/CV;;EkBjs/CM;IAOI,0BAAA;ElB8r/CV;;EkBrs/CM;IAOI,6BAAA;ElBks/CV;;EkBzs/CM;IAOI,4BAAA;ElBss/CV;;EkB7s/CM;IAOI,6BAAA;ElB0s/CV;;EkBjt/CM;IAOI,0BAAA;ElB8s/CV;;EkBrt/CM;IAOI,6BAAA;ElBkt/CV;;EkBzt/CM;IAOI,4BAAA;ElBst/CV;;EkB7t/CM;IAOI,6BAAA;ElB0t/CV;;EkBju/CM;IAOI,0BAAA;ElB8t/CV;;EkBru/CM;IAOI,6BAAA;ElBku/CV;;EkBzu/CM;IAOI,4BAAA;ElBsu/CV;;EkB7u/CM;IAOI,6BAAA;ElB0u/CV;AACF;AmB9w/CA;ED4BQ;IAOI,0BAAA;ElB+u/CV;;EkBtv/CM;IAOI,gCAAA;ElBmv/CV;;EkB1v/CM;IAOI,yBAAA;ElBuv/CV;;EkB9v/CM;IAOI,wBAAA;ElB2v/CV;;EkBlw/CM;IAOI,+BAAA;ElB+v/CV;;EkBtw/CM;IAOI,yBAAA;ElBmw/CV;;EkB1w/CM;IAOI,6BAAA;ElBuw/CV;;EkB9w/CM;IAOI,8BAAA;ElB2w/CV;;EkBlx/CM;IAOI,wBAAA;ElB+w/CV;;EkBtx/CM;IAOI,+BAAA;ElBmx/CV;;EkB1x/CM;IAOI,wBAAA;ElBux/CV;AACF;A0E71/CA;EAIY,0BAAA;EACA,2BAAA;EADA,0BAAA;EACA,2BAAA;EADA,uBAAA;EACA,wBAAA;EADA,0BAAA;EACA,2BAAA;EADA,yBAAA;EACA,0BAAA;EADA,uBAAA;EACA,wBAAA;EAMJ,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAKA,SAAA;EAAA,aAAA;EAAA,aAAA;EAAA,aAAA;EAAA,cAAA;EAAA,eAAA;EAIJ,yBAAA;EACA,gCAAA;A1Eu2/CJ;;A2Eh3/CI;EACF,yBAAA;A3Em3/CF;A2Ej3/CQ;EACH,oCAAA;A3Em3/CL;;A2E51/CC;EACC,eAAA;A3E+1/CF;A2E71/CE;EACC,yBAAA;EACA,oCAAA;A3E+1/CH;;A2E11/CE;EACC,yBAAA;EACA,oCAAA;A3E61/CH;;A2Ez1/CC;EACC,eAAA;A3E41/CF;A2E11/CE;EAEC,yBAAA;EACA,oCAAA;A3E21/CH;;A2E54/CI;EACF,yBAAA;A3E+4/CF;A2E74/CQ;EACH,oCAAA;A3E+4/CL;;A2Ex3/CC;EACC,eAAA;A3E23/CF;A2Ez3/CE;EACC,yBAAA;EACA,oCAAA;A3E23/CH;;A2Et3/CE;EACC,yBAAA;EACA,oCAAA;A3Ey3/CH;;A2Er3/CC;EACC,eAAA;A3Ew3/CF;A2Et3/CE;EAEC,yBAAA;EACA,oCAAA;A3Eu3/CH;;A2Ej7/CE;EACC,oCAAA;A3Eo7/CH;A2El7/CG;EACC,oCAAA;A3Eo7/CJ;;A2E/6/CI;EACF,uBAAA;A3Ek7/CF;A2Eh7/CQ;EACH,oCAAA;A3Ek7/CL;;A2E76/CE;EACC,eAAA;A3Eg7/CH;A2E96/CG;EACC,oCAAA;A3Eg7/CJ;;A2E56/CE;EACC,eAAA;A3E+6/CH;A2E76/CG;EAEC,oCAAA;A3E86/CJ;;A2Ez6/CC;EACC,eAAA;A3E46/CF;A2E16/CE;EACC,uBAAA;EACA,oCAAA;A3E46/CH;;A2Ev6/CE;EACC,uBAAA;EACA,oCAAA;A3E06/CH;;A2Et6/CC;EACC,eAAA;A3Ey6/CF;A2Ev6/CE;EAEC,uBAAA;EACA,oCAAA;A3Ew6/CH;;A2Ez9/CI;EACF,yBAAA;A3E49/CF;A2E19/CQ;EACH,oCAAA;A3E49/CL;;A2Er8/CC;EACC,eAAA;A3Ew8/CF;A2Et8/CE;EACC,yBAAA;EACA,oCAAA;A3Ew8/CH;;A2En8/CE;EACC,yBAAA;EACA,oCAAA;A3Es8/CH;;A2El8/CC;EACC,eAAA;A3Eq8/CF;A2En8/CE;EAEC,yBAAA;EACA,oCAAA;A3Eo8/CH;;A2E9//CE;EACC,oCAAA;A3EiggDH;A2E///CG;EACC,oCAAA;A3EiggDJ;;A2E5//CI;EACF,wBAAA;A3E+//CF;A2E7//CQ;EACH,oCAAA;A3E+//CL;;A2E1//CE;EACC,eAAA;A3E6//CH;A2E3//CG;EACC,oCAAA;A3E6//CJ;;A2Ez//CE;EACC,eAAA;A3E4//CH;A2E1//CG;EAEC,oCAAA;A3E2//CJ;;A2Et//CC;EACC,eAAA;A3Ey//CF;A2Ev//CE;EACC,wBAAA;EACA,oCAAA;A3Ey//CH;;A2Ep//CE;EACC,wBAAA;EACA,oCAAA;A3Eu//CH;;A2En//CC;EACC,eAAA;A3Es//CF;A2Ep//CE;EAEC,wBAAA;EACA,oCAAA;A3Eq//CH;;A2E/igDE;EACC,oCAAA;A3EkjgDH;A2EhjgDG;EACC,oCAAA;A3EkjgDJ;;A2E7igDI;EACF,wBAAA;A3EgjgDF;A2E9igDQ;EACH,oCAAA;A3EgjgDL;;A2E3igDE;EACC,eAAA;A3E8igDH;A2E5igDG;EACC,oCAAA;A3E8igDJ;;A2E1igDE;EACC,eAAA;A3E6igDH;A2E3igDG;EAEC,oCAAA;A3E4igDJ;;A2EvigDC;EACC,eAAA;A3E0igDF;A2ExigDE;EACC,wBAAA;EACA,oCAAA;A3E0igDH;;A2ErigDE;EACC,wBAAA;EACA,oCAAA;A3EwigDH;;A2EpigDC;EACC,eAAA;A3EuigDF;A2ErigDE;EAEC,wBAAA;EACA,oCAAA;A3EsigDH;;A2EhmgDE;EACC,oCAAA;A3EmmgDH;A2EjmgDG;EACC,oCAAA;A3EmmgDJ;;A2E9lgDI;EACF,uBAAA;A3EimgDF;A2E/lgDQ;EACH,oCAAA;A3EimgDL;;A2E5lgDE;EACC,eAAA;A3E+lgDH;A2E7lgDG;EACC,oCAAA;A3E+lgDJ;;A2E3lgDE;EACC,eAAA;A3E8lgDH;A2E5lgDG;EAEC,oCAAA;A3E6lgDJ;;A2ExlgDC;EACC,eAAA;A3E2lgDF;A2EzlgDE;EACC,uBAAA;EACA,oCAAA;A3E2lgDH;;A2EtlgDE;EACC,uBAAA;EACA,oCAAA;A3EylgDH;;A2ErlgDC;EACC,eAAA;A3EwlgDF;A2EtlgDE;EAEC,uBAAA;EACA,oCAAA;A3EulgDH;;A2EjpgDE;EACC,oCAAA;A3EopgDH;A2ElpgDG;EACC,oCAAA;A3EopgDJ;;A2E/ogDI;EACF,wBAAA;A3EkpgDF;A2EhpgDQ;EACH,oCAAA;A3EkpgDL;;A2E7ogDE;EACC,eAAA;A3EgpgDH;A2E9ogDG;EACC,oCAAA;A3EgpgDJ;;A2E5ogDE;EACC,eAAA;A3E+ogDH;A2E7ogDG;EAEC,oCAAA;A3E8ogDJ;;A2EzogDC;EACC,eAAA;A3E4ogDF;A2E1ogDE;EACC,wBAAA;EACA,oCAAA;A3E4ogDH;;A2EvogDE;EACC,wBAAA;EACA,oCAAA;A3E0ogDH;;A2EtogDC;EACC,eAAA;A3EyogDF;A2EvogDE;EAEC,wBAAA;EACA,oCAAA;A3EwogDH;;A2ElsgDE;EACC,oCAAA;A3EqsgDH;A2EnsgDG;EACC,oCAAA;A3EqsgDJ;;A2EhsgDI;EACF,sBAAA;A3EmsgDF;A2EjsgDQ;EACH,oCAAA;A3EmsgDL;;A2E9rgDE;EACC,eAAA;A3EisgDH;A2E/rgDG;EACC,oCAAA;A3EisgDJ;;A2E7rgDE;EACC,eAAA;A3EgsgDH;A2E9rgDG;EAEC,oCAAA;A3E+rgDJ;;A2E1rgDC;EACC,eAAA;A3E6rgDF;A2E3rgDE;EACC,sBAAA;EACA,oCAAA;A3E6rgDH;;A2ExrgDE;EACC,sBAAA;EACA,oCAAA;A3E2rgDH;;A2EvrgDC;EACC,eAAA;A3E0rgDF;A2ExrgDE;EAEC,sBAAA;EACA,oCAAA;A3EyrgDH;;A2ElrgDI;EACF,oCAAA;A3EqrgDF;;A2EtrgDI;EACF,oCAAA;A3EyrgDF;;A2E1rgDI;EACF,oCAAA;A3E6rgDF;;A2E9rgDI;EACF,oCAAA;A3EisgDF;;A2ElsgDI;EACF,oCAAA;A3EqsgDF;;A2EtsgDI;EACF,oCAAA;A3EysgDF;;A2E1sgDI;EACF,oCAAA;A3E6sgDF;;A2E9sgDI;EACF,oCAAA;A3EitgDF;;A2EltgDI;EACF,oCAAA;A3EqtgDF;;A2E/sgDC;EACC,qDAAA;A3EktgDF;;A2E/sgDC;EACC,qDAAA;A3EktgDF;;A2E/sgDC;EACC,qDAAA;A3EktgDF;;A2E9sgDE;EAEC,qDAAA;A3EgtgDH;;A2E/tgDC;EACC,wDAAA;A3EkugDF;;A2E/tgDC;EACC,wDAAA;A3EkugDF;;A2E/tgDC;EACC,wDAAA;A3EkugDF;;A2E9tgDE;EAEC,wDAAA;A3EgugDH;;A2E/ugDC;EACC,uDAAA;A3EkvgDF;;A2E/ugDC;EACC,uDAAA;A3EkvgDF;;A2E/ugDC;EACC,uDAAA;A3EkvgDF;;A2E9ugDE;EAEC,uDAAA;A3EgvgDH;;A2E/vgDC;EACC,wDAAA;A3EkwgDF;;A2E/vgDC;EACC,wDAAA;A3EkwgDF;;A2E/vgDC;EACC,wDAAA;A3EkwgDF;;A2E9vgDE;EAEC,wDAAA;A3EgwgDH;;A2E/wgDC;EACC,uDAAA;A3EkxgDF;;A2E/wgDC;EACC,uDAAA;A3EkxgDF;;A2E/wgDC;EACC,uDAAA;A3EkxgDF;;A2E9wgDE;EAEC,uDAAA;A3EgxgDH;;A2E/xgDC;EACC,wDAAA;A3EkygDF;;A2E/xgDC;EACC,wDAAA;A3EkygDF;;A2E/xgDC;EACC,wDAAA;A3EkygDF;;A2E9xgDE;EAEC,wDAAA;A3EgygDH;;A2E/ygDC;EACC,uDAAA;A3EkzgDF;;A2E/ygDC;EACC,uDAAA;A3EkzgDF;;A2E/ygDC;EACC,uDAAA;A3EkzgDF;;A2E9ygDE;EAEC,uDAAA;A3EgzgDH;;A2E/zgDC;EACC,wDAAA;A3Ek0gDF;;A2E/zgDC;EACC,wDAAA;A3Ek0gDF;;A2E/zgDC;EACC,wDAAA;A3Ek0gDF;;A2E9zgDE;EAEC,wDAAA;A3Eg0gDH;;A2E/0gDC;EACC,qDAAA;A3Ek1gDF;;A2E/0gDC;EACC,qDAAA;A3Ek1gDF;;A2E/0gDC;EACC,qDAAA;A3Ek1gDF;;A2E90gDE;EAEC,qDAAA;A3Eg1gDH;;A2E10gDA;EACC,oCAAA;A3E60gDD;;A2Ez0gDA;EACC,yBAAA;EACA,oCAAA;A3E40gDD;;A2Ex0gDA;EACC,qDAAA;A3E20gDD;;A2Ex0gDA;EACC,eAAA;A3E20gDD;A2Ez0gDC;EACC,qDAAA;A3E20gDF;;A2Et0gDC;EACC,qDAAA;A3Ey0gDF;;A2Er0gDA;EACC,eAAA;A3Ew0gDD;A2Et0gDC;EAEC,qDAAA;A3Eu0gDF;;A2El0gDA;EACC,eAAA;EACG,yBnDgMgD;AxBqogDpD;A2En0gDI;EACI,yBnD6L4C;AxBwogDpD;;A2E/zgDA;EACC,4BAAA;A3Ek0gDD;;A2E9zgDA;EACC,0BAAA;A3Ei0gDD;;A2E9zgDA;EACC,6BAAA;A3Ei0gDD;;A2E9zgDA;EACC,6BAAA;A3Ei0gDD;;A2E9zgDA;EACC,2BAAA;A3Ei0gDD;;A2E9zgDA;EACC,4BAAA;A3Ei0gDD;;A2E9zgDA;EACC,6BAAA;A3Ei0gDD;;A2E9zgDA;EACC,0BAAA;A3Ei0gDD;;A2E9zgDA;EACC,6BAAA;A3Ei0gDD;;A2E9zgDA;EACC,2BAAA;A3Ei0gDD;;A2ExzgDE;EACC,qBAAA;A3E2zgDH;;A2ExzgDE;EACC,sBAAA;A3E2zgDH;;A2ExzgDE;EACC,wBAAA;A3E2zgDH;;A2EvzgDE;EACC,4BAAA;A3E0zgDH;;A2EvzgDE;EACC,2BAAA;A3E0zgDH;;AUl9gDI;EiEsIF;IACC,qBAAA;E3Eg1gDD;;E2E70gDA;IACC,sBAAA;E3Eg1gDD;;E2E70gDA;IACC,wBAAA;E3Eg1gDD;;E2E50gDA;IACC,4BAAA;E3E+0gDD;;E2E50gDA;IACC,2BAAA;E3E+0gDD;AACF;AUx+gDI;EiEsIF;IACC,qBAAA;E3Eq2gDD;;E2El2gDA;IACC,sBAAA;E3Eq2gDD;;E2El2gDA;IACC,wBAAA;E3Eq2gDD;;E2Ej2gDA;IACC,4BAAA;E3Eo2gDD;;E2Ej2gDA;IACC,2BAAA;E3Eo2gDD;AACF;AU7/gDI;EiEsIF;IACC,qBAAA;E3E03gDD;;E2Ev3gDA;IACC,sBAAA;E3E03gDD;;E2Ev3gDA;IACC,wBAAA;E3E03gDD;;E2Et3gDA;IACC,4BAAA;E3Ey3gDD;;E2Et3gDA;IACC,2BAAA;E3Ey3gDD;AACF;AUlhhDI;EiEsIF;IACC,qBAAA;E3E+4gDD;;E2E54gDA;IACC,sBAAA;E3E+4gDD;;E2E54gDA;IACC,wBAAA;E3E+4gDD;;E2E34gDA;IACC,4BAAA;E3E84gDD;;E2E34gDA;IACC,2BAAA;E3E84gDD;AACF;AUvihDI;EiEsIF;IACC,qBAAA;E3Eo6gDD;;E2Ej6gDA;IACC,sBAAA;E3Eo6gDD;;E2Ej6gDA;IACC,wBAAA;E3Eo6gDD;;E2Eh6gDA;IACC,4BAAA;E3Em6gDD;;E2Eh6gDA;IACC,2BAAA;E3Em6gDD;AACF;A4EvnhDA;EACI,oCAAA;A5EynhDJ;;A4EtnhDA;EACI,eAAA;EACA,oCAAA;A5EynhDJ;;A4EnnhDC;EACC,gCAAA;A5EsnhDF;;A4EvnhDC;EACC,gCAAA;A5E0nhDF;;A4E3nhDC;EACC,gCAAA;A5E8nhDF;;A4E/nhDC;EACC,gCAAA;A5EkohDF;;A4EnohDC;EACC,gCAAA;A5EsohDF;;A4EvohDC;EACC,gCAAA;A5E0ohDF;;A4E3ohDC;EACC,gCAAA;A5E8ohDF;;A4E/ohDC;EACC,gCAAA;A5EkphDF;;A4EnphDC;EACC,gCAAA;A5EsphDF;;A4EhphDI;EACI,gCAAA;A5EmphDR;;A4EhphDI;EACI,gCAAA;A5EmphDR;;A4ExphDI;EACI,gCAAA;A5E2phDR;;A4ExphDI;EACI,gCAAA;A5E2phDR;;A4EhqhDI;EACI,gCAAA;A5EmqhDR;;A4EhqhDI;EACI,gCAAA;A5EmqhDR;;A4ExqhDI;EACI,gCAAA;A5E2qhDR;;A4ExqhDI;EACI,gCAAA;A5E2qhDR;;A4EhrhDI;EACI,gCAAA;A5EmrhDR;;A4EhrhDI;EACI,gCAAA;A5EmrhDR;;A4ExrhDI;EACI,gCAAA;A5E2rhDR;;A4ExrhDI;EACI,gCAAA;A5E2rhDR;;A4EhshDI;EACI,gCAAA;A5EmshDR;;A4EhshDI;EACI,gCAAA;A5EmshDR;;A4ExshDI;EACI,gCAAA;A5E2shDR;;A4ExshDI;EACI,gCAAA;A5E2shDR;;A4EhthDI;EACI,gCAAA;A5EmthDR;;A4EhthDI;EACI,gCAAA;A5EmthDR;;A4E9shDA;EACI,oCAAA;A5EithDJ;;A4E7shDA;EACI,+BAAA;EACA,qBpD9BqB;AxB8uhDzB;;A4E7shDA;EACI,mCAAA;A5EgthDJ;;A4E7shDA;EACI,sCAAA;A5EgthDJ;;A4E7shDA;EACI,oCAAA;A5EgthDJ;;A4E7shDA;EACI,qCAAA;A5EgthDJ;;A4E5shDA;EACI,+BAAA;A5E+shDJ;;A4E5shDA;EACI,mCAAA;A5E+shDJ;;A4E5shDA;EACI,sCAAA;A5E+shDJ;;A4E5shDA;EACI,oCAAA;A5E+shDJ;;A4E5shDA;EACI,qCAAA;A5E+shDJ;;A4E3shDA;EACI,oCAAA;A5E8shDJ;;A4E1shDA;EACI,gCAAA;A5E6shDJ;;A4EzshDA;EACI,oCAAA;EACA,qCAAA;A5E4shDJ;;A4EzshDA;EACI,uCAAA;EACA,wCAAA;A5E4shDJ;;A4EzshDA;EACI,oCAAA;EACA,uCAAA;A5E4shDJ;;A4EzshDA;EACI,qCAAA;EACA,wCAAA;A5E4shDJ;;A4EzshDA;EACI,6BAAA;A5E4shDJ;;A6EnzhDQ;EACL,SAAA;A7EszhDH;;A6EnzhDQ;EACI,UAAA;A7EszhDZ;;A6EnzhDQ;EACI,cAAA;A7EszhDZ;;A6EnzhDQ;EACI,cAAA;A7EszhDZ;;A6EnzhDQ;EACI,cAAA;EACA,YAAA;A7EszhDZ;;A6EnzhDK;EACC,uBAAA;EACA,mBAAA;A7EszhDN;;A6EnzhDQ;EACL,8BAAA;EACG,mBAAA;A7EszhDN;;AU5xhDI;EmEtDI;IACL,SAAA;E7Es1hDD;;E6En1hDM;IACI,UAAA;E7Es1hDV;;E6En1hDM;IACI,cAAA;E7Es1hDV;;E6En1hDM;IACI,cAAA;E7Es1hDV;;E6En1hDM;IACI,cAAA;IACA,YAAA;E7Es1hDV;;E6En1hDG;IACC,uBAAA;IACA,mBAAA;E7Es1hDJ;;E6En1hDM;IACL,8BAAA;IACG,mBAAA;E7Es1hDJ;AACF;AU7zhDI;EmEtDI;IACL,SAAA;E7Es3hDD;;E6En3hDM;IACI,UAAA;E7Es3hDV;;E6En3hDM;IACI,cAAA;E7Es3hDV;;E6En3hDM;IACI,cAAA;E7Es3hDV;;E6En3hDM;IACI,cAAA;IACA,YAAA;E7Es3hDV;;E6En3hDG;IACC,uBAAA;IACA,mBAAA;E7Es3hDJ;;E6En3hDM;IACL,8BAAA;IACG,mBAAA;E7Es3hDJ;AACF;AU71hDI;EmEtDI;IACL,SAAA;E7Es5hDD;;E6En5hDM;IACI,UAAA;E7Es5hDV;;E6En5hDM;IACI,cAAA;E7Es5hDV;;E6En5hDM;IACI,cAAA;E7Es5hDV;;E6En5hDM;IACI,cAAA;IACA,YAAA;E7Es5hDV;;E6En5hDG;IACC,uBAAA;IACA,mBAAA;E7Es5hDJ;;E6En5hDM;IACL,8BAAA;IACG,mBAAA;E7Es5hDJ;AACF;AU73hDI;EmEtDI;IACL,SAAA;E7Es7hDD;;E6En7hDM;IACI,UAAA;E7Es7hDV;;E6En7hDM;IACI,cAAA;E7Es7hDV;;E6En7hDM;IACI,cAAA;E7Es7hDV;;E6En7hDM;IACI,cAAA;IACA,YAAA;E7Es7hDV;;E6En7hDG;IACC,uBAAA;IACA,mBAAA;E7Es7hDJ;;E6En7hDM;IACL,8BAAA;IACG,mBAAA;E7Es7hDJ;AACF;AU75hDI;EmEtDI;IACL,SAAA;E7Es9hDD;;E6En9hDM;IACI,UAAA;E7Es9hDV;;E6En9hDM;IACI,cAAA;E7Es9hDV;;E6En9hDM;IACI,cAAA;E7Es9hDV;;E6En9hDM;IACI,cAAA;IACA,YAAA;E7Es9hDV;;E6En9hDG;IACC,uBAAA;IACA,mBAAA;E7Es9hDJ;;E6En9hDM;IACL,8BAAA;IACG,mBAAA;E7Es9hDJ;AACF;A6El9hDA;EACI,YAAA;EACA,aAAA;EACA,cAAA;A7Eo9hDJ;;A8E7/hDA;EACI,wDtDkWgD;AxB8phDpD;;A+E9/hDI;EACI,yBAAA;A/EigiDR;;A+E5/hDQ;EACI,yBAAA;A/E+/hDZ;;A+En/hDI;EACI,uDvDqT4C;AxBishDpD;A+Ep/hDQ;EACI,uDvDkTwC;AxBoshDpD;A+En/hDQ;EACI,uDvD8SwC;EuD7SxC,yBAAA;A/Eq/hDZ;A+En/hDY;EACI,uDvD0SoC;EuDzShD,yBAAA;A/Eq/hDJ;AgFrhiDQ;EACI,0BAAA;EACA,aAAA;AhFuhiDZ;AgFnhiDY;EACI,0BAAA;AhFqhiDhB;;A+Ej/hDQ;EACI,uDvD6RwC;AxButhDpD;A+El/hDY;EACI,uDvD0RoC;AxB0thDpD;A+Ej/hDY;EACI,uDvDsRoC;EuDrRpC,yBAAA;A/Em/hDhB;A+Ej/hDgB;EACI,uDvDkRgC;EuDjRhC,yBAAA;A/Em/hDpB;AgF3iiDQ;EACI,0BAAA;EACA,aAAA;AhF6iiDZ;AgFziiDY;EACI,0BAAA;AhF2iiDhB;;A+E/+hDI;EACI,uDvDqQ4C;AxB6uhDpD;A+Eh/hDQ;EACI,uDvDkQwC;AxBgvhDpD;A+E/+hDQ;EACI,uDvD8PwC;EuD7PxC,yBAAA;A/Ei/hDZ;A+E/+hDY;EACI,uDvD0PoC;EuDzPpC,yBAAA;A/Ei/hDhB;AgFjkiDQ;EACI,0BAAA;EACA,aAAA;AhFmkiDZ;AgF/jiDY;EACI,0BAAA;AhFikiDhB;;A+E7+hDQ;EACI,uDvD6OwC;AxBmwhDpD;A+E9+hDY;EACI,uDvD0OoC;AxBswhDpD;A+E7+hDY;EACI,uDvDsOoC;EuDrOpC,yBAAA;A/E++hDhB;A+E7+hDgB;EACI,uDvDkOgC;EuDjOhC,yBAAA;A/E++hDpB;AgFvliDQ;EACI,0BAAA;EACA,aAAA;AhFyliDZ;AgFrliDY;EACI,0BAAA;AhFuliDhB;;A+E9liDI;EACI,yBAAA;A/EimiDR;;A+E5liDQ;EACI,yBAAA;A/E+liDZ;;A+EzliDQ;EACI,yBAAA;A/E4liDZ;;A+EvliDI;EACI,uDvDqT4C;AxBqyhDpD;A+ExliDQ;EACI,uDvDkTwC;AxBwyhDpD;A+EvliDQ;EACI,uDvD8SwC;EuD7SxC,yBAAA;A/EyliDZ;A+EvliDY;EACI,uDvD0SoC;EuDzShD,yBAAA;A/EyliDJ;AgFzniDQ;EACI,0BAAA;EACA,aAAA;AhF2niDZ;AgFvniDY;EACI,0BAAA;AhFyniDhB;;A+ErliDQ;EACI,uDvD6RwC;AxB2zhDpD;A+EtliDY;EACI,uDvD0RoC;AxB8zhDpD;A+ErliDY;EACI,uDvDsRoC;EuDrRpC,yBAAA;A/EuliDhB;A+ErliDgB;EACI,uDvDkRgC;EuDjRhC,yBAAA;A/EuliDpB;AgF/oiDQ;EACI,0BAAA;EACA,aAAA;AhFipiDZ;AgF7oiDY;EACI,0BAAA;AhF+oiDhB;;A+EnliDI;EACI,uDvDqQ4C;AxBi1hDpD;A+EpliDQ;EACI,uDvDkQwC;AxBo1hDpD;A+EnliDQ;EACI,uDvD8PwC;EuD7PxC,yBAAA;A/EqliDZ;A+EnliDY;EACI,uDvD0PoC;EuDzPpC,yBAAA;A/EqliDhB;AgFrqiDQ;EACI,0BAAA;EACA,aAAA;AhFuqiDZ;AgFnqiDY;EACI,0BAAA;AhFqqiDhB;;A+EjliDQ;EACI,uDvD6OwC;AxBu2hDpD;A+ElliDY;EACI,uDvD0OoC;AxB02hDpD;A+EjliDY;EACI,uDvDsOoC;EuDrOpC,yBAAA;A/EmliDhB;A+EjliDgB;EACI,uDvDkOgC;EuDjOhC,yBAAA;A/EmliDpB;AgF3riDQ;EACI,0BAAA;EACA,aAAA;AhF6riDZ;AgFzriDY;EACI,0BAAA;AhF2riDhB;;A+ElsiDI;EACI,yBAAA;A/EqsiDR;;A+EhsiDQ;EACI,yBAAA;A/EmsiDZ;;A+EvriDI;EACI,uDvDqT4C;AxBq4hDpD;A+ExriDQ;EACI,uDvDkTwC;AxBw4hDpD;A+EvriDQ;EACI,uDvD8SwC;EuD7SxC,yBAAA;A/EyriDZ;A+EvriDY;EACI,uDvD0SoC;EuDzShD,yBAAA;A/EyriDJ;AgFztiDQ;EACI,0BAAA;EACA,aAAA;AhF2tiDZ;AgFvtiDY;EACI,0BAAA;AhFytiDhB;;A+ErriDQ;EACI,uDvD6RwC;AxB25hDpD;A+EtriDY;EACI,uDvD0RoC;AxB85hDpD;A+ErriDY;EACI,uDvDsRoC;EuDrRpC,yBAAA;A/EuriDhB;A+ErriDgB;EACI,uDvDkRgC;EuDjRhC,yBAAA;A/EuriDpB;AgF/uiDQ;EACI,0BAAA;EACA,aAAA;AhFiviDZ;AgF7uiDY;EACI,0BAAA;AhF+uiDhB;;A+EnriDI;EACI,uDvDqQ4C;AxBi7hDpD;A+EpriDQ;EACI,uDvDkQwC;AxBo7hDpD;A+EnriDQ;EACI,uDvD8PwC;EuD7PxC,yBAAA;A/EqriDZ;A+EnriDY;EACI,uDvD0PoC;EuDzPpC,yBAAA;A/EqriDhB;AgFrwiDQ;EACI,0BAAA;EACA,aAAA;AhFuwiDZ;AgFnwiDY;EACI,0BAAA;AhFqwiDhB;;A+EjriDQ;EACI,uDvD6OwC;AxBu8hDpD;A+ElriDY;EACI,uDvD0OoC;AxB08hDpD;A+EjriDY;EACI,uDvDsOoC;EuDrOpC,yBAAA;A/EmriDhB;A+EjriDgB;EACI,uDvDkOgC;EuDjOhC,yBAAA;A/EmriDpB;AgF3xiDQ;EACI,0BAAA;EACA,aAAA;AhF6xiDZ;AgFzxiDY;EACI,0BAAA;AhF2xiDhB;;A+ElyiDI;EACI,yBAAA;A/EqyiDR;;A+EhyiDQ;EACI,yBAAA;A/EmyiDZ;;A+EvxiDI;EACI,uDvDqT4C;AxBq+hDpD;A+ExxiDQ;EACI,uDvDkTwC;AxBw+hDpD;A+EvxiDQ;EACI,uDvD8SwC;EuD7SxC,yBAAA;A/EyxiDZ;A+EvxiDY;EACI,uDvD0SoC;EuDzShD,yBAAA;A/EyxiDJ;AgFzziDQ;EACI,0BAAA;EACA,aAAA;AhF2ziDZ;AgFvziDY;EACI,0BAAA;AhFyziDhB;;A+ErxiDQ;EACI,uDvD6RwC;AxB2/hDpD;A+EtxiDY;EACI,uDvD0RoC;AxB8/hDpD;A+ErxiDY;EACI,uDvDsRoC;EuDrRpC,yBAAA;A/EuxiDhB;A+ErxiDgB;EACI,uDvDkRgC;EuDjRhC,yBAAA;A/EuxiDpB;AgF/0iDQ;EACI,0BAAA;EACA,aAAA;AhFi1iDZ;AgF70iDY;EACI,0BAAA;AhF+0iDhB;;A+EnxiDI;EACI,uDvDqQ4C;AxBihiDpD;A+EpxiDQ;EACI,uDvDkQwC;AxBohiDpD;A+EnxiDQ;EACI,uDvD8PwC;EuD7PxC,yBAAA;A/EqxiDZ;A+EnxiDY;EACI,uDvD0PoC;EuDzPpC,yBAAA;A/EqxiDhB;AgFr2iDQ;EACI,0BAAA;EACA,aAAA;AhFu2iDZ;AgFn2iDY;EACI,0BAAA;AhFq2iDhB;;A+EjxiDQ;EACI,uDvD6OwC;AxBuiiDpD;A+ElxiDY;EACI,uDvD0OoC;AxB0iiDpD;A+EjxiDY;EACI,uDvDsOoC;EuDrOpC,yBAAA;A/EmxiDhB;A+EjxiDgB;EACI,uDvDkOgC;EuDjOhC,yBAAA;A/EmxiDpB;AgF33iDQ;EACI,0BAAA;EACA,aAAA;AhF63iDZ;AgFz3iDY;EACI,0BAAA;AhF23iDhB;;A+El4iDI;EACI,yBAAA;A/Eq4iDR;;A+Eh4iDQ;EACI,yBAAA;A/Em4iDZ;;A+E73iDQ;EACI,yBAAA;A/Eg4iDZ;;A+E33iDI;EACI,uDvDqT4C;AxBykiDpD;A+E53iDQ;EACI,uDvDkTwC;AxB4kiDpD;A+E33iDQ;EACI,uDvD8SwC;EuD7SxC,yBAAA;A/E63iDZ;A+E33iDY;EACI,uDvD0SoC;EuDzShD,yBAAA;A/E63iDJ;AgF75iDQ;EACI,0BAAA;EACA,aAAA;AhF+5iDZ;AgF35iDY;EACI,0BAAA;AhF65iDhB;;A+Ez3iDQ;EACI,uDvD6RwC;AxB+liDpD;A+E13iDY;EACI,uDvD0RoC;AxBkmiDpD;A+Ez3iDY;EACI,uDvDsRoC;EuDrRpC,yBAAA;A/E23iDhB;A+Ez3iDgB;EACI,uDvDkRgC;EuDjRhC,yBAAA;A/E23iDpB;AgFn7iDQ;EACI,0BAAA;EACA,aAAA;AhFq7iDZ;AgFj7iDY;EACI,0BAAA;AhFm7iDhB;;A+Ev3iDI;EACI,uDvDqQ4C;AxBqniDpD;A+Ex3iDQ;EACI,uDvDkQwC;AxBwniDpD;A+Ev3iDQ;EACI,uDvD8PwC;EuD7PxC,yBAAA;A/Ey3iDZ;A+Ev3iDY;EACI,uDvD0PoC;EuDzPpC,yBAAA;A/Ey3iDhB;AgFz8iDQ;EACI,0BAAA;EACA,aAAA;AhF28iDZ;AgFv8iDY;EACI,0BAAA;AhFy8iDhB;;A+Er3iDQ;EACI,uDvD6OwC;AxB2oiDpD;A+Et3iDY;EACI,uDvD0OoC;AxB8oiDpD;A+Er3iDY;EACI,uDvDsOoC;EuDrOpC,yBAAA;A/Eu3iDhB;A+Er3iDgB;EACI,uDvDkOgC;EuDjOhC,yBAAA;A/Eu3iDpB;AgF/9iDQ;EACI,0BAAA;EACA,aAAA;AhFi+iDZ;AgF79iDY;EACI,0BAAA;AhF+9iDhB;;A+Et+iDI;EACI,yBAAA;A/Ey+iDR;;A+Ep+iDQ;EACI,yBAAA;A/Eu+iDZ;;A+Ej+iDQ;EACI,yBAAA;A/Eo+iDZ;;A+E/9iDI;EACI,uDvDqT4C;AxB6qiDpD;A+Eh+iDQ;EACI,uDvDkTwC;AxBgriDpD;A+E/9iDQ;EACI,uDvD8SwC;EuD7SxC,yBAAA;A/Ei+iDZ;A+E/9iDY;EACI,uDvD0SoC;EuDzShD,yBAAA;A/Ei+iDJ;AgFjgjDQ;EACI,0BAAA;EACA,aAAA;AhFmgjDZ;AgF//iDY;EACI,0BAAA;AhFigjDhB;;A+E79iDQ;EACI,uDvD6RwC;AxBmsiDpD;A+E99iDY;EACI,uDvD0RoC;AxBssiDpD;A+E79iDY;EACI,uDvDsRoC;EuDrRpC,yBAAA;A/E+9iDhB;A+E79iDgB;EACI,uDvDkRgC;EuDjRhC,yBAAA;A/E+9iDpB;AgFvhjDQ;EACI,0BAAA;EACA,aAAA;AhFyhjDZ;AgFrhjDY;EACI,0BAAA;AhFuhjDhB;;A+E39iDI;EACI,uDvDqQ4C;AxBytiDpD;A+E59iDQ;EACI,uDvDkQwC;AxB4tiDpD;A+E39iDQ;EACI,uDvD8PwC;EuD7PxC,yBAAA;A/E69iDZ;A+E39iDY;EACI,uDvD0PoC;EuDzPpC,yBAAA;A/E69iDhB;AgF7ijDQ;EACI,0BAAA;EACA,aAAA;AhF+ijDZ;AgF3ijDY;EACI,0BAAA;AhF6ijDhB;;A+Ez9iDQ;EACI,uDvD6OwC;AxB+uiDpD;A+E19iDY;EACI,uDvD0OoC;AxBkviDpD;A+Ez9iDY;EACI,uDvDsOoC;EuDrOpC,yBAAA;A/E29iDhB;A+Ez9iDgB;EACI,uDvDkOgC;EuDjOhC,yBAAA;A/E29iDpB;AgFnkjDQ;EACI,0BAAA;EACA,aAAA;AhFqkjDZ;AgFjkjDY;EACI,0BAAA;AhFmkjDhB;;A+E1kjDI;EACI,yBAAA;A/E6kjDR;;A+ExkjDQ;EACI,yBAAA;A/E2kjDZ;;A+ErkjDQ;EACI,yBAAA;A/EwkjDZ;;A+EnkjDI;EACI,uDvDqT4C;AxBixiDpD;A+EpkjDQ;EACI,uDvDkTwC;AxBoxiDpD;A+EnkjDQ;EACI,uDvD8SwC;EuD7SxC,yBAAA;A/EqkjDZ;A+EnkjDY;EACI,uDvD0SoC;EuDzShD,yBAAA;A/EqkjDJ;AgFrmjDQ;EACI,0BAAA;EACA,aAAA;AhFumjDZ;AgFnmjDY;EACI,0BAAA;AhFqmjDhB;;A+EjkjDQ;EACI,uDvD6RwC;AxBuyiDpD;A+ElkjDY;EACI,uDvD0RoC;AxB0yiDpD;A+EjkjDY;EACI,uDvDsRoC;EuDrRpC,yBAAA;A/EmkjDhB;A+EjkjDgB;EACI,uDvDkRgC;EuDjRhC,yBAAA;A/EmkjDpB;AgF3njDQ;EACI,0BAAA;EACA,aAAA;AhF6njDZ;AgFznjDY;EACI,0BAAA;AhF2njDhB;;A+E/jjDI;EACI,uDvDqQ4C;AxB6ziDpD;A+EhkjDQ;EACI,uDvDkQwC;AxBg0iDpD;A+E/jjDQ;EACI,uDvD8PwC;EuD7PxC,yBAAA;A/EikjDZ;A+E/jjDY;EACI,uDvD0PoC;EuDzPpC,yBAAA;A/EikjDhB;AgFjpjDQ;EACI,0BAAA;EACA,aAAA;AhFmpjDZ;AgF/ojDY;EACI,0BAAA;AhFipjDhB;;A+E7jjDQ;EACI,uDvD6OwC;AxBm1iDpD;A+E9jjDY;EACI,uDvD0OoC;AxBs1iDpD;A+E7jjDY;EACI,uDvDsOoC;EuDrOpC,yBAAA;A/E+jjDhB;A+E7jjDgB;EACI,uDvDkOgC;EuDjOhC,yBAAA;A/E+jjDpB;AgFvqjDQ;EACI,0BAAA;EACA,aAAA;AhFyqjDZ;AgFrqjDY;EACI,0BAAA;AhFuqjDhB;;A+E9qjDI;EACI,yBAAA;A/EirjDR;;A+E5qjDQ;EACI,yBAAA;A/E+qjDZ;;A+EzqjDQ;EACI,yBAAA;A/E4qjDZ;;A+EvqjDI;EACI,uDvDqT4C;AxBq3iDpD;A+ExqjDQ;EACI,uDvDkTwC;AxBw3iDpD;A+EvqjDQ;EACI,uDvD8SwC;EuD7SxC,yBAAA;A/EyqjDZ;A+EvqjDY;EACI,uDvD0SoC;EuDzShD,yBAAA;A/EyqjDJ;AgFzsjDQ;EACI,0BAAA;EACA,aAAA;AhF2sjDZ;AgFvsjDY;EACI,0BAAA;AhFysjDhB;;A+ErqjDQ;EACI,uDvD6RwC;AxB24iDpD;A+EtqjDY;EACI,uDvD0RoC;AxB84iDpD;A+ErqjDY;EACI,uDvDsRoC;EuDrRpC,yBAAA;A/EuqjDhB;A+ErqjDgB;EACI,uDvDkRgC;EuDjRhC,yBAAA;A/EuqjDpB;AgF/tjDQ;EACI,0BAAA;EACA,aAAA;AhFiujDZ;AgF7tjDY;EACI,0BAAA;AhF+tjDhB;;A+EnqjDI;EACI,uDvDqQ4C;AxBi6iDpD;A+EpqjDQ;EACI,uDvDkQwC;AxBo6iDpD;A+EnqjDQ;EACI,uDvD8PwC;EuD7PxC,yBAAA;A/EqqjDZ;A+EnqjDY;EACI,uDvD0PoC;EuDzPpC,yBAAA;A/EqqjDhB;AgFrvjDQ;EACI,0BAAA;EACA,aAAA;AhFuvjDZ;AgFnvjDY;EACI,0BAAA;AhFqvjDhB;;A+EjqjDQ;EACI,uDvD6OwC;AxBu7iDpD;A+ElqjDY;EACI,uDvD0OoC;AxB07iDpD;A+EjqjDY;EACI,uDvDsOoC;EuDrOpC,yBAAA;A/EmqjDhB;A+EjqjDgB;EACI,uDvDkOgC;EuDjOhC,yBAAA;A/EmqjDpB;AgF3wjDQ;EACI,0BAAA;EACA,aAAA;AhF6wjDZ;AgFzwjDY;EACI,0BAAA;AhF2wjDhB;;A+ElxjDI;EACI,yBAAA;A/EqxjDR;;A+EhxjDQ;EACI,yBAAA;A/EmxjDZ;;A+E7wjDQ;EACI,yBAAA;A/EgxjDZ;;A+E3wjDI;EACI,uDvDqT4C;AxBy9iDpD;A+E5wjDQ;EACI,uDvDkTwC;AxB49iDpD;A+E3wjDQ;EACI,uDvD8SwC;EuD7SxC,yBAAA;A/E6wjDZ;A+E3wjDY;EACI,uDvD0SoC;EuDzShD,yBAAA;A/E6wjDJ;AgF7yjDQ;EACI,0BAAA;EACA,aAAA;AhF+yjDZ;AgF3yjDY;EACI,0BAAA;AhF6yjDhB;;A+EzwjDQ;EACI,uDvD6RwC;AxB++iDpD;A+E1wjDY;EACI,uDvD0RoC;AxBk/iDpD;A+EzwjDY;EACI,uDvDsRoC;EuDrRpC,yBAAA;A/E2wjDhB;A+EzwjDgB;EACI,uDvDkRgC;EuDjRhC,yBAAA;A/E2wjDpB;AgFn0jDQ;EACI,0BAAA;EACA,aAAA;AhFq0jDZ;AgFj0jDY;EACI,0BAAA;AhFm0jDhB;;A+EvwjDI;EACI,uDvDqQ4C;AxBqgjDpD;A+ExwjDQ;EACI,uDvDkQwC;AxBwgjDpD;A+EvwjDQ;EACI,uDvD8PwC;EuD7PxC,yBAAA;A/EywjDZ;A+EvwjDY;EACI,uDvD0PoC;EuDzPpC,yBAAA;A/EywjDhB;AgFz1jDQ;EACI,0BAAA;EACA,aAAA;AhF21jDZ;AgFv1jDY;EACI,0BAAA;AhFy1jDhB;;A+ErwjDQ;EACI,uDvD6OwC;AxB2hjDpD;A+EtwjDY;EACI,uDvD0OoC;AxB8hjDpD;A+ErwjDY;EACI,uDvDsOoC;EuDrOpC,yBAAA;A/EuwjDhB;A+ErwjDgB;EACI,uDvDkOgC;EuDjOhC,yBAAA;A/EuwjDpB;AgF/2jDQ;EACI,0BAAA;EACA,aAAA;AhFi3jDZ;AgF72jDY;EACI,0BAAA;AhF+2jDhB;;A+Et3jDI;EACI,yBAAA;A/Ey3jDR;;A+Ev2jDI;EACI,uDvDqT4C;AxBqjjDpD;A+Ex2jDQ;EACI,uDvDkTwC;AxBwjjDpD;A+Ev2jDQ;EACI,uDvD8SwC;EuD7SxC,yBAAA;A/Ey2jDZ;A+Ev2jDY;EACI,uDvD0SoC;EuDzShD,yBAAA;A/Ey2jDJ;AgFz4jDQ;EACI,0BAAA;EACA,aAAA;AhF24jDZ;AgFv4jDY;EACI,0BAAA;AhFy4jDhB;;A+E70jDI;EACI,uDvDqQ4C;AxB2kjDpD;A+E90jDQ;EACI,uDvDkQwC;AxB8kjDpD;A+E70jDQ;EACI,uDvD8PwC;EuD7PxC,yBAAA;A/E+0jDZ;A+E70jDY;EACI,uDvD0PoC;EuDzPpC,yBAAA;A/E+0jDhB;AgF/5jDQ;EACI,0BAAA;EACA,aAAA;AhFi6jDZ;AgF75jDY;EACI,0BAAA;AhF+5jDhB;;A+Et6jDI;EACI,yBAAA;A/Ey6jDR;;A+Ev5jDI;EACI,uDvDqT4C;AxBqmjDpD;A+Ex5jDQ;EACI,uDvDkTwC;AxBwmjDpD;A+Ev5jDQ;EACI,uDvD8SwC;EuD7SxC,yBAAA;A/Ey5jDZ;A+Ev5jDY;EACI,uDvD0SoC;EuDzShD,yBAAA;A/Ey5jDJ;AgFz7jDQ;EACI,0BAAA;EACA,aAAA;AhF27jDZ;AgFv7jDY;EACI,0BAAA;AhFy7jDhB;;A+E73jDI;EACI,uDvDqQ4C;AxB2njDpD;A+E93jDQ;EACI,uDvDkQwC;AxB8njDpD;A+E73jDQ;EACI,uDvD8PwC;EuD7PxC,yBAAA;A/E+3jDZ;A+E73jDY;EACI,uDvD0PoC;EuDzPpC,yBAAA;A/E+3jDhB;AgF/8jDQ;EACI,0BAAA;EACA,aAAA;AhFi9jDZ;AgF78jDY;EACI,0BAAA;AhF+8jDhB;;A+Et9jDI;EACI,yBAAA;A/Ey9jDR;;A+Ev8jDI;EACI,uDvDqT4C;AxBqpjDpD;A+Ex8jDQ;EACI,uDvDkTwC;AxBwpjDpD;A+Ev8jDQ;EACI,uDvD8SwC;EuD7SxC,yBAAA;A/Ey8jDZ;A+Ev8jDY;EACI,uDvD0SoC;EuDzShD,yBAAA;A/Ey8jDJ;AgFz+jDQ;EACI,0BAAA;EACA,aAAA;AhF2+jDZ;AgFv+jDY;EACI,0BAAA;AhFy+jDhB;;A+E76jDI;EACI,uDvDqQ4C;AxB2qjDpD;A+E96jDQ;EACI,uDvDkQwC;AxB8qjDpD;A+E76jDQ;EACI,uDvD8PwC;EuD7PxC,yBAAA;A/E+6jDZ;A+E76jDY;EACI,uDvD0PoC;EuDzPpC,yBAAA;A/E+6jDhB;AgF//jDQ;EACI,0BAAA;EACA,aAAA;AhFigkDZ;AgF7/jDY;EACI,0BAAA;AhF+/jDhB;;A+EtgkDI;EACI,yBAAA;A/EygkDR;;A+Ev/jDI;EACI,uDvDqT4C;AxBqsjDpD;A+Ex/jDQ;EACI,uDvDkTwC;AxBwsjDpD;A+Ev/jDQ;EACI,uDvD8SwC;EuD7SxC,yBAAA;A/Ey/jDZ;A+Ev/jDY;EACI,uDvD0SoC;EuDzShD,yBAAA;A/Ey/jDJ;AgFzhkDQ;EACI,0BAAA;EACA,aAAA;AhF2hkDZ;AgFvhkDY;EACI,0BAAA;AhFyhkDhB;;A+E79jDI;EACI,uDvDqQ4C;AxB2tjDpD;A+E99jDQ;EACI,uDvDkQwC;AxB8tjDpD;A+E79jDQ;EACI,uDvD8PwC;EuD7PxC,yBAAA;A/E+9jDZ;A+E79jDY;EACI,uDvD0PoC;EuDzPpC,yBAAA;A/E+9jDhB;AgF/ikDQ;EACI,0BAAA;EACA,aAAA;AhFijkDZ;AgF7ikDY;EACI,0BAAA;AhF+ikDhB;;A+EtjkDI;EACI,yBAAA;A/EyjkDR;;A+EvikDI;EACI,uDvDqT4C;AxBqvjDpD;A+ExikDQ;EACI,uDvDkTwC;AxBwvjDpD;A+EvikDQ;EACI,uDvD8SwC;EuD7SxC,yBAAA;A/EyikDZ;A+EvikDY;EACI,uDvD0SoC;EuDzShD,yBAAA;A/EyikDJ;AgFzkkDQ;EACI,0BAAA;EACA,aAAA;AhF2kkDZ;AgFvkkDY;EACI,0BAAA;AhFykkDhB;;A+E7gkDI;EACI,uDvDqQ4C;AxB2wjDpD;A+E9gkDQ;EACI,uDvDkQwC;AxB8wjDpD;A+E7gkDQ;EACI,uDvD8PwC;EuD7PxC,yBAAA;A/E+gkDZ;A+E7gkDY;EACI,uDvD0PoC;EuDzPpC,yBAAA;A/E+gkDhB;AgF/lkDQ;EACI,0BAAA;EACA,aAAA;AhFimkDZ;AgF7lkDY;EACI,0BAAA;AhF+lkDhB;;A+EtmkDI;EACI,yBAAA;A/EymkDR;;A+EvlkDI;EACI,uDvDqT4C;AxBqyjDpD;A+ExlkDQ;EACI,uDvDkTwC;AxBwyjDpD;A+EvlkDQ;EACI,uDvD8SwC;EuD7SxC,yBAAA;A/EylkDZ;A+EvlkDY;EACI,uDvD0SoC;EuDzShD,yBAAA;A/EylkDJ;AgFznkDQ;EACI,0BAAA;EACA,aAAA;AhF2nkDZ;AgFvnkDY;EACI,0BAAA;AhFynkDhB;;A+E7jkDI;EACI,uDvDqQ4C;AxB2zjDpD;A+E9jkDQ;EACI,uDvDkQwC;AxB8zjDpD;A+E7jkDQ;EACI,uDvD8PwC;EuD7PxC,yBAAA;A/E+jkDZ;A+E7jkDY;EACI,uDvD0PoC;EuDzPpC,yBAAA;A/E+jkDhB;AgF/okDQ;EACI,0BAAA;EACA,aAAA;AhFipkDZ;AgF7okDY;EACI,0BAAA;AhF+okDhB;;A+EtpkDI;EACI,yBAAA;A/EypkDR;;A+EvokDI;EACI,uDvDqT4C;AxBq1jDpD;A+ExokDQ;EACI,uDvDkTwC;AxBw1jDpD;A+EvokDQ;EACI,uDvD8SwC;EuD7SxC,yBAAA;A/EyokDZ;A+EvokDY;EACI,uDvD0SoC;EuDzShD,yBAAA;A/EyokDJ;AgFzqkDQ;EACI,0BAAA;EACA,aAAA;AhF2qkDZ;AgFvqkDY;EACI,0BAAA;AhFyqkDhB;;A+E7mkDI;EACI,uDvDqQ4C;AxB22jDpD;A+E9mkDQ;EACI,uDvDkQwC;AxB82jDpD;A+E7mkDQ;EACI,uDvD8PwC;EuD7PxC,yBAAA;A/E+mkDZ;A+E7mkDY;EACI,uDvD0PoC;EuDzPpC,yBAAA;A/E+mkDhB;AgF/rkDQ;EACI,0BAAA;EACA,aAAA;AhFiskDZ;AgF7rkDY;EACI,0BAAA;AhF+rkDhB;;A+EtskDI;EACI,yBAAA;A/EyskDR;;A+EvrkDI;EACI,uDvDqT4C;AxBq4jDpD;A+ExrkDQ;EACI,uDvDkTwC;AxBw4jDpD;A+EvrkDQ;EACI,uDvD8SwC;EuD7SxC,yBAAA;A/EyrkDZ;A+EvrkDY;EACI,uDvD0SoC;EuDzShD,yBAAA;A/EyrkDJ;AgFztkDQ;EACI,0BAAA;EACA,aAAA;AhF2tkDZ;AgFvtkDY;EACI,0BAAA;AhFytkDhB;;A+E7pkDI;EACI,uDvDqQ4C;AxB25jDpD;A+E9pkDQ;EACI,uDvDkQwC;AxB85jDpD;A+E7pkDQ;EACI,uDvD8PwC;EuD7PxC,yBAAA;A/E+pkDZ;A+E7pkDY;EACI,uDvD0PoC;EuDzPpC,yBAAA;A/E+pkDhB;AgF/ukDQ;EACI,0BAAA;EACA,aAAA;AhFivkDZ;AgF7ukDY;EACI,0BAAA;AhF+ukDhB;;A+EtvkDI;EACI,yBAAA;A/EyvkDR;;A+EvukDI;EACI,uDvDqT4C;AxBq7jDpD;A+ExukDQ;EACI,uDvDkTwC;AxBw7jDpD;A+EvukDQ;EACI,uDvD8SwC;EuD7SxC,yBAAA;A/EyukDZ;A+EvukDY;EACI,uDvD0SoC;EuDzShD,yBAAA;A/EyukDJ;AgFzwkDQ;EACI,0BAAA;EACA,aAAA;AhF2wkDZ;AgFvwkDY;EACI,0BAAA;AhFywkDhB;;A+E7skDI;EACI,uDvDqQ4C;AxB28jDpD;A+E9skDQ;EACI,uDvDkQwC;AxB88jDpD;A+E7skDQ;EACI,uDvD8PwC;EuD7PxC,yBAAA;A/E+skDZ;A+E7skDY;EACI,uDvD0PoC;EuDzPpC,yBAAA;A/E+skDhB;AgF/xkDQ;EACI,0BAAA;EACA,aAAA;AhFiykDZ;AgF7xkDY;EACI,0BAAA;AhF+xkDhB;;A+EtykDI;EACI,yBAAA;A/EyykDR;;A+EvxkDI;EACI,uDvDqT4C;AxBq+jDpD;A+ExxkDQ;EACI,uDvDkTwC;AxBw+jDpD;A+EvxkDQ;EACI,uDvD8SwC;EuD7SxC,yBAAA;A/EyxkDZ;A+EvxkDY;EACI,uDvD0SoC;EuDzShD,yBAAA;A/EyxkDJ;AgFzzkDQ;EACI,0BAAA;EACA,aAAA;AhF2zkDZ;AgFvzkDY;EACI,0BAAA;AhFyzkDhB;;A+E7vkDI;EACI,uDvDqQ4C;AxB2/jDpD;A+E9vkDQ;EACI,uDvDkQwC;AxB8/jDpD;A+E7vkDQ;EACI,uDvD8PwC;EuD7PxC,yBAAA;A/E+vkDZ;A+E7vkDY;EACI,uDvD0PoC;EuDzPpC,yBAAA;A/E+vkDhB;AgF/0kDQ;EACI,0BAAA;EACA,aAAA;AhFi1kDZ;AgF70kDY;EACI,0BAAA;AhF+0kDhB;;A+ElukDA;EACI,2BAAA;A/EqukDJ;;A+EjukDA;EACI,kBAAA;A/EoukDJ;;A+EhukDA;EACI,eAAA;A/EmukDJ;;A+E/tkDA;EACI,eAAA;A/EkukDJ;;A+E/tkDA;EACI,YAAA;A/EkukDJ;;A+E9tkDA;EACI,cAAA;EACA,eAAA;EACA,cvD1IqB;AxB22kDzB;;A+E7tkDA;EACI,uDvDqLgD;AxB2ikDpD;A+E9tkDI;EACI,uDvDkL4C;AxB8ikDpD;;AiFx3kDC;EACC,qBAAA;AjF23kDF;;AiFt3kDE;EAEC,qBAAA;AjFw3kDH;;AiFh4kDC;EACC,wBAAA;AjFm4kDF;;AiF93kDE;EAEC,wBAAA;AjFg4kDH;;AiFx4kDC;EACC,uBAAA;AjF24kDF;;AiFt4kDE;EAEC,uBAAA;AjFw4kDH;;AiFh5kDC;EACC,wBAAA;AjFm5kDF;;AiF94kDE;EAEC,wBAAA;AjFg5kDH;;AiFx5kDC;EACC,uBAAA;AjF25kDF;;AiFt5kDE;EAEC,uBAAA;AjFw5kDH;;AiFh6kDC;EACC,wBAAA;AjFm6kDF;;AiF95kDE;EAEC,wBAAA;AjFg6kDH;;AiFx6kDC;EACC,uBAAA;AjF26kDF;;AiFt6kDE;EAEC,uBAAA;AjFw6kDH;;AiFh7kDC;EACC,wBAAA;AjFm7kDF;;AiF96kDE;EAEC,wBAAA;AjFg7kDH;;AiFx7kDC;EACC,qBAAA;AjF27kDF;;AiFt7kDE;EAEC,qBAAA;AjFw7kDH;;AkFl8kDA;EACI,wBAAA;EACA,2BAAA;AlFq8kDJ;;AmFt8kDA;EACE,sBAAA;EACA,yBAAA;AnFy8kDF;;AmFr8kDA;EACI;IACI,mCAAA;IACA,mBAAA;EnFw8kDN;EmFr8kDE;IACI,+BAAA;EnFu8kDN;AACF;AmFp8kDA;EACI,oCAAA;AnFs8kDJ;;AmFl8kDA;EACI;IACI,kCAAA;IACA,mBAAA;EnFq8kDN;EmFl8kDE;IACI,+BAAA;EnFo8kDN;AACF;AmFj8kDA;EACI,kCAAA;AnFm8kDJ;;AmF/7kDA;EACI;IACI,UAAA;EnFk8kDN;EmF/7kDE;IACI,UAAA;EnFi8kDN;AACF;AmF97kDA;EACI,+BAAA;AnFg8kDJ;;AmF57kDA;EACI;IACI,UAAA;EnF+7kDN;EmF57kDE;IACI,UAAA;EnF87kDN;AACF;AmF57kDA;EACI,gCAAA;AnF87kDJ;;AmF17kDA;EACI,qDAAA;AnF67kDJ;;AmF17kDA;EACI;IACI,kBAAA;EnF67kDN;AACF;AoFvglDA;EACC,wBAAA;EACA,0BAAA;EACA,4B5DCwB;AxBwglDzB;AoFvglDC;EACC,mBAAA;ApFyglDF;AoFtglDE;EACC,c5DHsB;E4DItB,SAAA;EACA,oCAAA;EACA,uD5D8TiD;E4D7TjD,iBAAA;EACA,cAAA;ApFwglDH;AoFnglDG;EACC,cAAA;ApFqglDJ;AoF//kDG;EACC,eAAA;ApFiglDJ;AoF3/kDC;;;EAGC,6BAAA;EACA,SAAA;EACA,gCAAA;EACA,uD5DmSkD;AxB0tkDpD;AoFz/kDC;EACC,wBAAA;ApF2/kDF;AoFz/kDE;EACC,mBAAA;ApF2/kDH;AoFz/kDG;EACC,wBAAA;ApF2/kDJ;AoFt/kDE;;;EAGC,wBAAA;ApFw/kDH;;AoFj/kDC;EACC,oBAAA;ApFo/kDF;AoFl/kDE;EACC,eAAA;ApFo/kDH;;AoF9+kDA;EACC,oBAAA;EACA,yBAAA;EACA,4BAAA;ApFi/kDD;AoF/+kDC;EACC,aAAA;EACA,oBAAA;EACA,yBAAA;EACA,4BAAA;ApFi/kDF;AoF9+kDC;EACC,aAAA;EACA,mBAAA;ApFg/kDF;;AoF3+kDA;EACC,gBAAA;E3DlFG,uBAAA;E2DoFH,yB5D/FwB;AxB6klDzB;AoF3+kDC;EACC,6BAAA;EACA,yBAAA;ApF6+kDF;AoFz+kDC;EACC,aAAA;ApF2+kDF;AoFz+kDE;;EAEC,kBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;ApF2+kDH;AoFx+kDE;EACC,oBAAA;ApF0+kDH;AoFx+kDG;EACC,WAAA;ApF0+kDJ;AoFv+kDG;EACC,eAAA;ApFy+kDJ;;AqFtmlDC;;EAEC,0BAAA;EACA,mBAAA;ArFymlDF;AqFtmlDY;;EACI,WAAA;EACA,uD7DkUoC;AxBuykDpD;AqFvmlDgB;;EACI,qBAAA;ArF0mlDpB;AqFvmlDgB;;EACI,aAAA;ArF0mlDpB;AqFrmlDQ;;EACL,6BAAA;EACA,yBAAA;EACA,wBAAA;EACA,kBAAA;ArFwmlDH;AqFtmlDG;;EACC,yBAAA;EACA,uD7D8SgD;AxB2zkDpD;AqFtmlDG;;EACC,cAAA;ArFymlDJ;AqFrmlDE;;EACC,aAAA;ArFwmlDH;;AsF/olDA;EACC,aAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;AtFkplDD;AsF9olDE;EACC,kBAAA;AtFgplDH;AsF1olDE;EACC,yBAAA;AtF4olDH;AsFtolDO;EACI,qB3CjBoB;A3CyplD/B;;AsFjolDA;EACI,oB9DguBiD;E8DvrBpD,mCAAA;EAmGA,iBAAA;AtF0/kDD;AsFpolDC;EACO,eAAA;AtFsolDR;AsFnolDC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uB9DqTkC;E8DpTlC,c9DmtBmD;E8DltBnD,iB9DktBmD;E8DjtBnD,gB9D4WkD;E8D3WlD,mB9DqWkC;E8D/VlC,mCAAA;EASA,iBAAA;EAMA,mCAAA;AtFmnlDF;AsFtolDE;EACC,kB9DmtBkD;AxBq7jDrD;AsFpolDE;;EAEC,cAAA;EACA,gB9D6sBkD;E8D5sBlD,e9D4sBkD;E8D1sBlD,uCAAA;AtFqolDH;AsFjolDE;EChCM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;AvFkqlDJ;AsFlolDE;ECrCM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;AvFwqlDJ;AsFholDE;EACC,yB9DwKiD;AxB09kDpD;AsFholDG;EACC,c9DrEqB;AxBuslDzB;AgF9slDQ;EACI,0BAAA;EACA,aAAA;AhFgtlDZ;AgF5slDY;EACI,0BAAA;AhF8slDhB;AsF/nlDE;EAaC,mCAAA;AtFqnlDH;AsFjolDG;EACC,c3CvFqB;A3C0tlDzB;AgF3tlDQ;EACI,0BAAA;EACA,aAAA;AhF6tlDZ;AgFztlDY;EACI,0BAAA;AhF2tlDhB;AsFnolDG;ECpEK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;AvFwslDJ;AsFpolDG;ECzEK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;AvF8slDJ;AsFnolDE;EAaC,mCAAA;AtFynlDH;AsFrolDG;EACC,c3C5GqB;A3CmvlDzB;AgFpvlDQ;EACI,0BAAA;EACA,aAAA;AhFsvlDZ;AgFlvlDY;EACI,0BAAA;AhFovlDhB;AsFvolDG;ECzFK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;AvFiulDJ;AsFxolDG;EC9FK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;AvFuulDJ;AsFvolDE;EAaC,mCAAA;AtF6nlDH;AsFzolDG;EACC,c3C9HwB;A3CywlD5B;AgF7wlDQ;EACI,0BAAA;EACA,aAAA;AhF+wlDZ;AgF3wlDY;EACI,0BAAA;AhF6wlDhB;AsF3olDG;EC9GK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;AvF0vlDJ;AsF5olDG;ECnHK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;AvFgwlDJ;AsF3olDE;EAaC,mCAAA;AtFiolDH;AsF7olDG;EACC,c9DnJqB;AxBkylDzB;AgFtylDQ;EACI,0BAAA;EACA,aAAA;AhFwylDZ;AgFpylDY;EACI,0BAAA;AhFsylDhB;AsF/olDG;ECnIK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;AvFmxlDJ;AsFhplDG;ECxIK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;AvFyxlDJ;;AUpvlDI;E4EwGH;IACC,qB9D+kBmD;ExBikkDnD;EsF9olDA;IACC,eAAA;EtFgplDD;AACF;AwFr0lDA;EACI,cAAA;EACA,SAAA;EACA,gCAAA;AxFu0lDJ;AwFr0lDI;EACI,2BAAA;EACA,4BhEDiB;AxBw0lDzB;AwFp0lDI;EACI,2BAAA;EACA,4BhENiB;AxB40lDzB;AwFn0lDI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AxFq0lDR;AwFn0lDQ;EAEI,YAAA;EACA,UAAA;EACA,gCAAA;AxFo0lDZ;AwFj0lDQ;EACI,qBAAA;AxFm0lDZ;AwFh0lDQ;EACI,oBAAA;AxFk0lDZ;AwF9zlDY;EAEI,2BAAA;EACA,4BhElCS;AxBi2lDzB;AwF1zlDY;EAEI,2BAAA;EACA,4BhE1CS;AxBq2lDzB;AwFrzlDgB;EAEI,gCAAA;AxFszlDpB;AwFxzlDgB;EAEI,gCAAA;AxFyzlDpB;AwF3zlDgB;EAEI,gCAAA;AxF4zlDpB;AwF9zlDgB;EAEI,gCAAA;AxF+zlDpB;AwFj0lDgB;EAEI,gCAAA;AxFk0lDpB;AwFp0lDgB;EAEI,gCAAA;AxFq0lDpB;AwFv0lDgB;EAEI,gCAAA;AxFw0lDpB;AwF10lDgB;EAEI,gCAAA;AxF20lDpB;AwF70lDgB;EAEI,gCAAA;AxF80lDpB;;AyFn4lDI;EACI,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AzFs4lDR;AyFp4lDQ;EACI,eAAA;EACA,UAAA;AzFs4lDZ;AyFp4lDY;EACI,eAAA;EACA,UAAA;AzFs4lDhB;AyFj4lDY;EACI,gBAAA;EACA,6BAAA;EACA,YjE80BoC;EiE70BpC,WjE60BoC;EiE50BpC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AzFm4lDhB;AyFj4lDgB;EACI,qBAAA;EACA,YAAA;EhEnBhB,kBAAA;EgEqBgB,yBAAA;EACA,yBjEhCK;EiEiCL,WjEg0BgC;EiE/zBhC,UjE+zBgC;AxBokkDpD;AyFh4lDgB;EACI,6BAAA;AzFk4lDpB;AyFh4lDoB;EACI,yBAAA;EACA,YjEwzB4B;EiEvzB5B,WjEuzB4B;EiEtzB5B,yBjE3CC;AxB66lDzB;AyF13lDI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;AzF43lDR;AyF13lDQ;EACI,YAAA;AzF43lDZ;AyFz3lDQ;EACI,YAAA;AzF23lDZ;AyFx3lDQ;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AzF03lDZ;;A0Fl8lDA;EACI,aAAA;A1Fq8lDJ;;A0Fj8lDA;;EAEI,aAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;A1Fo8lDJ;;A0Fh8lDA;EACI,aAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;A1Fm8lDJ;;A0F/7lDA;EACI,cAAA;EACA,UAAA;A1Fk8lDJ;A0F/7lDI;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,wBAAA;A1Fi8lDR;A0F97lDQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,oBAAA;A1Fg8lDZ;A0F97lDY;EACI,cAAA;A1Fg8lDhB;A0F37lDQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;A1F67lDZ;A0Fz7lDQ;EACI,aAAA;EACA,mBAAA;EACA,YAAA;A1F27lDZ;A0Fv7lDQ;EACI,cAAA;EACA,mBAAA;A1Fy7lDZ;A0Fr7lDQ;EACI,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;A1Fu7lDZ;A0Fr7lDY;EACI,cAAA;EACA,WAAA;EACA,YAAA;EH5DR,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EGyDY,mBAAA;EH9DR,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EG2DY,iBAAA;A1F67lDhB;A0Fv7lDI;EACI,qBAAA;A1Fy7lDR;;A0Fj7lDY;EACI,mCAAA;EACA,+BAAA;A1Fo7lDhB;;A0F76lDA;EACI,uBAAA;A1Fg7lDJ;;A0F95lDwB;ECvIvB,aAAA;EACA,yBAAA;EACA,+BAAA;A3FyimDD;A2FvimDC;EACC,aAAA;EACA,0BAAA;A3FyimDF;;A0Fh6lDY;EACI,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,oDAAA;EACA,YAAA;A1Fm6lDhB;A0Fh6lDgB;EAGI,aAAA;EAKI,2GAAA;A1F45lDxB;A0Fz5lDwB;EAGI,6GAAA;A1Fy5lD5B;;A0Fl5lDY;EACI,aAAA;A1Fq5lDhB;A0Fn5lDgB;EAEI,aAAA;A1Fo5lDpB;;A0F/4lDY;EACI,aAAA;A1Fk5lDhB;;A0F54lDoB;;EAEI,0BAAA;EACA,2BAAA;A1F+4lDxB;;A0F14lDY;EACI,sBAAA;EACA,WAAA;A1F64lDhB;;A0F14lDY;EACI,mBAAA;A1F64lDhB;A0F34lDgB;EACI,aAAA;EACA,mBAAA;A1F64lDpB;A0F14lDwB;EClNvB,aAAA;EACA,yBAAA;EACA,+BAAA;A3F+lmDD;A2F7lmDC;EACC,aAAA;EACA,0BAAA;A3F+lmDF;;A0F14lDgB;EjE9MZ,uBAAA;AzB4lmDJ;;A0Fv4lDgB;EACI,mBAAA;A1F04lDpB;;A0Fp4lDgB;EACI,2BAAA;A1Fu4lDpB;;A4F/mmDY;EFqIY;ICvIvB,aAAA;IACA,yBAAA;IACA,+BAAA;E3FsnmDC;E2FpnmDD;IACC,aAAA;IACA,0BAAA;E3FsnmDA;;E0F7+lDU;IACI,aAAA;IACA,uBAAA;IACA,yBAAA;IACA,oDAAA;IACA,YAAA;E1Fg/lDd;E0F7+lDc;IAGI,aAAA;IAKI,2GAAA;E1Fy+lDtB;E0Ft+lDsB;IAGI,6GAAA;E1Fs+lD1B;;E0F/9lDU;IACI,aAAA;E1Fk+lDd;E0Fh+lDc;IAEI,aAAA;E1Fi+lDlB;;E0F59lDU;IACI,aAAA;E1F+9lDd;;E0Fz9lDkB;;IAEI,0BAAA;IACA,2BAAA;E1F49lDtB;;E0Fv9lDU;IACI,sBAAA;IACA,WAAA;E1F09lDd;;E0Fv9lDU;IACI,mBAAA;E1F09lDd;E0Fx9lDc;IACI,aAAA;IACA,mBAAA;E1F09lDlB;E0Fv9lDsB;IClNvB,aAAA;IACA,yBAAA;IACA,+BAAA;E3F4qmDC;E2F1qmDD;IACC,aAAA;IACA,0BAAA;E3F4qmDA;;E0Fv9lDc;IjE9MZ,uBAAA;EzByqmDF;;E0Fp9lDc;IACI,mBAAA;E1Fu9lDlB;;E0Fj9lDc;IACI,2BAAA;E1Fo9lDlB;AACF;A4F7rmDY;EFqIY;ICvIvB,aAAA;IACA,yBAAA;IACA,+BAAA;E3FmsmDC;E2FjsmDD;IACC,aAAA;IACA,0BAAA;E3FmsmDA;;E0F1jmDU;IACI,aAAA;IACA,uBAAA;IACA,yBAAA;IACA,oDAAA;IACA,YAAA;E1F6jmDd;E0F1jmDc;IAGI,aAAA;IAKI,2GAAA;E1FsjmDtB;E0FnjmDsB;IAGI,6GAAA;E1FmjmD1B;;E0F5imDU;IACI,aAAA;E1F+imDd;E0F7imDc;IAEI,aAAA;E1F8imDlB;;E0FzimDU;IACI,aAAA;E1F4imDd;;E0FtimDkB;;IAEI,0BAAA;IACA,2BAAA;E1FyimDtB;;E0FpimDU;IACI,sBAAA;IACA,WAAA;E1FuimDd;;E0FpimDU;IACI,mBAAA;E1FuimDd;E0FrimDc;IACI,aAAA;IACA,mBAAA;E1FuimDlB;E0FpimDsB;IClNvB,aAAA;IACA,yBAAA;IACA,+BAAA;E3FyvmDC;E2FvvmDD;IACC,aAAA;IACA,0BAAA;E3FyvmDA;;E0FpimDc;IjE9MZ,uBAAA;EzBsvmDF;;E0FjimDc;IACI,mBAAA;E1FoimDlB;;E0F9hmDc;IACI,2BAAA;E1FiimDlB;AACF;A4F1wmDY;EFqIY;ICvIvB,aAAA;IACA,yBAAA;IACA,+BAAA;E3FgxmDC;E2F9wmDD;IACC,aAAA;IACA,0BAAA;E3FgxmDA;;E0FvomDU;IACI,aAAA;IACA,uBAAA;IACA,yBAAA;IACA,oDAAA;IACA,YAAA;E1F0omDd;E0FvomDc;IAGI,aAAA;IAKI,2GAAA;E1FmomDtB;E0FhomDsB;IAGI,6GAAA;E1FgomD1B;;E0FznmDU;IACI,aAAA;E1F4nmDd;E0F1nmDc;IAEI,aAAA;E1F2nmDlB;;E0FtnmDU;IACI,aAAA;E1FynmDd;;E0FnnmDkB;;IAEI,0BAAA;IACA,2BAAA;E1FsnmDtB;;E0FjnmDU;IACI,sBAAA;IACA,WAAA;E1FonmDd;;E0FjnmDU;IACI,mBAAA;E1FonmDd;E0FlnmDc;IACI,aAAA;IACA,mBAAA;E1FonmDlB;E0FjnmDsB;IClNvB,aAAA;IACA,yBAAA;IACA,+BAAA;E3Fs0mDC;E2Fp0mDD;IACC,aAAA;IACA,0BAAA;E3Fs0mDA;;E0FjnmDc;IjE9MZ,uBAAA;EzBm0mDF;;E0F9mmDc;IACI,mBAAA;E1FinmDlB;;E0F3mmDc;IACI,2BAAA;E1F8mmDlB;AACF;A4Fv1mDY;EFqIY;ICvIvB,aAAA;IACA,yBAAA;IACA,+BAAA;E3F61mDC;E2F31mDD;IACC,aAAA;IACA,0BAAA;E3F61mDA;;E0FptmDU;IACI,aAAA;IACA,uBAAA;IACA,yBAAA;IACA,oDAAA;IACA,YAAA;E1FutmDd;E0FptmDc;IAGI,aAAA;IAKI,2GAAA;E1FgtmDtB;E0F7smDsB;IAGI,6GAAA;E1F6smD1B;;E0FtsmDU;IACI,aAAA;E1FysmDd;E0FvsmDc;IAEI,aAAA;E1FwsmDlB;;E0FnsmDU;IACI,aAAA;E1FssmDd;;E0FhsmDkB;;IAEI,0BAAA;IACA,2BAAA;E1FmsmDtB;;E0F9rmDU;IACI,sBAAA;IACA,WAAA;E1FismDd;;E0F9rmDU;IACI,mBAAA;E1FismDd;E0F/rmDc;IACI,aAAA;IACA,mBAAA;E1FismDlB;E0F9rmDsB;IClNvB,aAAA;IACA,yBAAA;IACA,+BAAA;E3Fm5mDC;E2Fj5mDD;IACC,aAAA;IACA,0BAAA;E3Fm5mDA;;E0F9rmDc;IjE9MZ,uBAAA;EzBg5mDF;;E0F3rmDc;IACI,mBAAA;E1F8rmDlB;;E0FxrmDc;IACI,2BAAA;E1F2rmDlB;AACF;A4Fp6mDY;EFqIY;ICvIvB,aAAA;IACA,yBAAA;IACA,+BAAA;E3F06mDC;E2Fx6mDD;IACC,aAAA;IACA,0BAAA;E3F06mDA;;E0FjymDU;IACI,aAAA;IACA,uBAAA;IACA,yBAAA;IACA,oDAAA;IACA,YAAA;E1FoymDd;E0FjymDc;IAGI,aAAA;IAKI,2GAAA;E1F6xmDtB;E0F1xmDsB;IAGI,6GAAA;E1F0xmD1B;;E0FnxmDU;IACI,aAAA;E1FsxmDd;E0FpxmDc;IAEI,aAAA;E1FqxmDlB;;E0FhxmDU;IACI,aAAA;E1FmxmDd;;E0F7wmDkB;;IAEI,0BAAA;IACA,2BAAA;E1FgxmDtB;;E0F3wmDU;IACI,sBAAA;IACA,WAAA;E1F8wmDd;;E0F3wmDU;IACI,mBAAA;E1F8wmDd;E0F5wmDc;IACI,aAAA;IACA,mBAAA;E1F8wmDlB;E0F3wmDsB;IClNvB,aAAA;IACA,yBAAA;IACA,+BAAA;E3Fg+mDC;E2F99mDD;IACC,aAAA;IACA,0BAAA;E3Fg+mDA;;E0F3wmDc;IjE9MZ,uBAAA;EzB69mDF;;E0FxwmDc;IACI,mBAAA;E1F2wmDlB;;E0FrwmDc;IACI,2BAAA;E1FwwmDlB;AACF;A4Ft+mDY;EF0HY;ICvIvB,aAAA;IACA,yBAAA;IACA,+BAAA;E3Fu/mDC;E2Fr/mDD;IACC,aAAA;IACA,0BAAA;E3Fu/mDA;;E0F92mDU;IACI,aAAA;IACA,uBAAA;IACA,yBAAA;IACA,oDAAA;IACA,YAAA;E1Fi3mDd;E0F92mDc;IAGI,aAAA;IAKI,2GAAA;E1F02mDtB;E0Fv2mDsB;IAGI,6GAAA;E1Fu2mD1B;;E0Fh2mDU;IACI,aAAA;E1Fm2mDd;E0Fj2mDc;IAEI,aAAA;E1Fk2mDlB;;E0F71mDU;IACI,aAAA;E1Fg2mDd;;E0F11mDkB;;IAEI,0BAAA;IACA,2BAAA;E1F61mDtB;;E0Fx1mDU;IACI,sBAAA;IACA,WAAA;E1F21mDd;;E0Fx1mDU;IACI,mBAAA;E1F21mDd;E0Fz1mDc;IACI,aAAA;IACA,mBAAA;E1F21mDlB;E0Fx1mDsB;IClNvB,aAAA;IACA,yBAAA;IACA,+BAAA;E3F6inDC;E2F3inDD;IACC,aAAA;IACA,0BAAA;E3F6inDA;;E0Fx1mDc;IjE9MZ,uBAAA;EzB0inDF;;E0Fr1mDc;IACI,mBAAA;E1Fw1mDlB;;E0Fl1mDc;IACI,2BAAA;E1Fq1mDlB;AACF;A4FnjnDY;EF0HY;ICvIvB,aAAA;IACA,yBAAA;IACA,+BAAA;E3FoknDC;E2FlknDD;IACC,aAAA;IACA,0BAAA;E3FoknDA;;E0F37mDU;IACI,aAAA;IACA,uBAAA;IACA,yBAAA;IACA,oDAAA;IACA,YAAA;E1F87mDd;E0F37mDc;IAGI,aAAA;IAKI,2GAAA;E1Fu7mDtB;E0Fp7mDsB;IAGI,6GAAA;E1Fo7mD1B;;E0F76mDU;IACI,aAAA;E1Fg7mDd;E0F96mDc;IAEI,aAAA;E1F+6mDlB;;E0F16mDU;IACI,aAAA;E1F66mDd;;E0Fv6mDkB;;IAEI,0BAAA;IACA,2BAAA;E1F06mDtB;;E0Fr6mDU;IACI,sBAAA;IACA,WAAA;E1Fw6mDd;;E0Fr6mDU;IACI,mBAAA;E1Fw6mDd;E0Ft6mDc;IACI,aAAA;IACA,mBAAA;E1Fw6mDlB;E0Fr6mDsB;IClNvB,aAAA;IACA,yBAAA;IACA,+BAAA;E3F0nnDC;E2FxnnDD;IACC,aAAA;IACA,0BAAA;E3F0nnDA;;E0Fr6mDc;IjE9MZ,uBAAA;EzBunnDF;;E0Fl6mDc;IACI,mBAAA;E1Fq6mDlB;;E0F/5mDc;IACI,2BAAA;E1Fk6mDlB;AACF;A4FhonDY;EF0HY;ICvIvB,aAAA;IACA,yBAAA;IACA,+BAAA;E3FipnDC;E2F/onDD;IACC,aAAA;IACA,0BAAA;E3FipnDA;;E0FxgnDU;IACI,aAAA;IACA,uBAAA;IACA,yBAAA;IACA,oDAAA;IACA,YAAA;E1F2gnDd;E0FxgnDc;IAGI,aAAA;IAKI,2GAAA;E1FognDtB;E0FjgnDsB;IAGI,6GAAA;E1FignD1B;;E0F1/mDU;IACI,aAAA;E1F6/mDd;E0F3/mDc;IAEI,aAAA;E1F4/mDlB;;E0Fv/mDU;IACI,aAAA;E1F0/mDd;;E0Fp/mDkB;;IAEI,0BAAA;IACA,2BAAA;E1Fu/mDtB;;E0Fl/mDU;IACI,sBAAA;IACA,WAAA;E1Fq/mDd;;E0Fl/mDU;IACI,mBAAA;E1Fq/mDd;E0Fn/mDc;IACI,aAAA;IACA,mBAAA;E1Fq/mDlB;E0Fl/mDsB;IClNvB,aAAA;IACA,yBAAA;IACA,+BAAA;E3FusnDC;E2FrsnDD;IACC,aAAA;IACA,0BAAA;E3FusnDA;;E0Fl/mDc;IjE9MZ,uBAAA;EzBosnDF;;E0F/+mDc;IACI,mBAAA;E1Fk/mDlB;;E0F5+mDc;IACI,2BAAA;E1F++mDlB;AACF;A4F7snDY;EF0HY;ICvIvB,aAAA;IACA,yBAAA;IACA,+BAAA;E3F8tnDC;E2F5tnDD;IACC,aAAA;IACA,0BAAA;E3F8tnDA;;E0FrlnDU;IACI,aAAA;IACA,uBAAA;IACA,yBAAA;IACA,oDAAA;IACA,YAAA;E1FwlnDd;E0FrlnDc;IAGI,aAAA;IAKI,2GAAA;E1FilnDtB;E0F9knDsB;IAGI,6GAAA;E1F8knD1B;;E0FvknDU;IACI,aAAA;E1F0knDd;E0FxknDc;IAEI,aAAA;E1FyknDlB;;E0FpknDU;IACI,aAAA;E1FuknDd;;E0FjknDkB;;IAEI,0BAAA;IACA,2BAAA;E1FoknDtB;;E0F/jnDU;IACI,sBAAA;IACA,WAAA;E1FkknDd;;E0F/jnDU;IACI,mBAAA;E1FkknDd;E0FhknDc;IACI,aAAA;IACA,mBAAA;E1FkknDlB;E0F/jnDsB;IClNvB,aAAA;IACA,yBAAA;IACA,+BAAA;E3FoxnDC;E2FlxnDD;IACC,aAAA;IACA,0BAAA;E3FoxnDA;;E0F/jnDc;IjE9MZ,uBAAA;EzBixnDF;;E0F5jnDc;IACI,mBAAA;E1F+jnDlB;;E0FzjnDc;IACI,2BAAA;E1F4jnDlB;AACF;A4F1xnDY;EF0HY;ICvIvB,aAAA;IACA,yBAAA;IACA,+BAAA;E3F2ynDC;E2FzynDD;IACC,aAAA;IACA,0BAAA;E3F2ynDA;;E0FlqnDU;IACI,aAAA;IACA,uBAAA;IACA,yBAAA;IACA,oDAAA;IACA,YAAA;E1FqqnDd;E0FlqnDc;IAGI,aAAA;IAKI,2GAAA;E1F8pnDtB;E0F3pnDsB;IAGI,6GAAA;E1F2pnD1B;;E0FppnDU;IACI,aAAA;E1FupnDd;E0FrpnDc;IAEI,aAAA;E1FspnDlB;;E0FjpnDU;IACI,aAAA;E1FopnDd;;E0F9onDkB;;IAEI,0BAAA;IACA,2BAAA;E1FipnDtB;;E0F5onDU;IACI,sBAAA;IACA,WAAA;E1F+onDd;;E0F5onDU;IACI,mBAAA;E1F+onDd;E0F7onDc;IACI,aAAA;IACA,mBAAA;E1F+onDlB;E0F5onDsB;IClNvB,aAAA;IACA,yBAAA;IACA,+BAAA;E3Fi2nDC;E2F/1nDD;IACC,aAAA;IACA,0BAAA;E3Fi2nDA;;E0F5onDc;IjE9MZ,uBAAA;EzB81nDF;;E0FzonDc;IACI,mBAAA;E1F4onDlB;;E0FtonDc;IACI,2BAAA;E1FyonDlB;AACF;A2F70nDG;;EAEC,+BAAA;A3F+0nDJ;A2F10nDK;;EAEC,+BAAA;A3F40nDN;A2Fv0nDO;;EAEC,+BAAA;A3Fy0nDR;A2Fp0nDS;;EAEC,+BAAA;A3Fs0nDV;A2F1znDI;;EAEC,kBAAA;EACA,gBAAA;A3F4znDL;A2FvznDM;;EAEC,wBAAA;EACA,gBAAA;A3FyznDP;A2FpznDQ;;EAEC,wBAAA;EACA,gBAAA;A3FsznDT;A2FjznDU;;EAEC,wBAAA;EACA,gBAAA;A3FmznDX;;A0FnqnDA;EACI;IAAS,UAAA;E1FuqnDX;E0FtqnDE;IAAK,UAAA;E1FyqnDP;AACF;A0FvqnDA;EACI;IAAS,mBAAA;E1F0qnDX;E0FzqnDE;IAAK,aAAA;E1F4qnDP;AACF;A0F1qnDA;EACI;IAAS,sBAAA;E1F6qnDX;E0F5qnDE;IAAK,gBAAA;E1F+qnDP;AACF;A2FxwnDC;EAhDC,cnE0CkB;AxBixnDpB;A2FzznDE;EACC,cnEuCiB;AxBoxnDpB;A2FpznDG;EACC,cnE+BgB;AxBuxnDpB;AgFz7nDQ;EACI,0BAAA;EACA,aAAA;AhF27nDZ;AgFv7nDY;EACI,0BAAA;AhFy7nDhB;A2FjznDG;EACC,yBnEkBgB;AxBiynDpB;A2F5ynDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FoznDH;;A2FvynDC;EAhDC,cnE0CkB;AxBiznDpB;A2Fz1nDE;EACC,cnEuCiB;AxBoznDpB;;A2Fp1nDG;EACC,cnE+BgB;AxBwznDpB;AgF19nDQ;EACI,0BAAA;EACA,aAAA;AhF49nDZ;AgFx9nDY;EACI,0BAAA;AhF09nDhB;;A2Fl1nDG;EACC,yBnEkBgB;AxBm0nDpB;;A2F90nDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3Fu1nDH;;A2F10nDC;EAhDC,cnE0CkB;AxBo1nDpB;A2F53nDE;EACC,cnEuCiB;AxBu1nDpB;A2Fv3nDG;EACC,cnE+BgB;AxB01nDpB;AgF5/nDQ;EACI,0BAAA;EACA,aAAA;AhF8/nDZ;AgF1/nDY;EACI,0BAAA;AhF4/nDhB;A2Fp3nDG;EACC,yBnEkBgB;AxBo2nDpB;A2F/2nDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3Fu3nDH;;A2F12nDC;EAhDC,cnE0CkB;AxBo3nDpB;A2F55nDE;EACC,cnEuCiB;AxBu3nDpB;;A2Fv5nDG;EACC,cnE+BgB;AxB23nDpB;AgF7hoDQ;EACI,0BAAA;EACA,aAAA;AhF+hoDZ;AgF3hoDY;EACI,0BAAA;AhF6hoDhB;;A2Fr5nDG;EACC,yBnEkBgB;AxBs4nDpB;;A2Fj5nDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3F05nDH;;A2F74nDC;EAhDC,cnE0CkB;AxBu5nDpB;A2F/7nDE;EACC,cnEuCiB;AxB05nDpB;A2F17nDG;EACC,cnE+BgB;AxB65nDpB;AgF/joDQ;EACI,0BAAA;EACA,aAAA;AhFikoDZ;AgF7joDY;EACI,0BAAA;AhF+joDhB;A2Fv7nDG;EACC,yBnEkBgB;AxBu6nDpB;A2Fl7nDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3F07nDH;;A2F76nDC;EAhDC,cnE0CkB;AxBu7nDpB;A2F/9nDE;EACC,cnEuCiB;AxB07nDpB;;A2F19nDG;EACC,cnE+BgB;AxB87nDpB;AgFhmoDQ;EACI,0BAAA;EACA,aAAA;AhFkmoDZ;AgF9loDY;EACI,0BAAA;AhFgmoDhB;;A2Fx9nDG;EACC,yBnEkBgB;AxBy8nDpB;;A2Fp9nDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3F69nDH;;A2Fh9nDC;EAhDC,cnE0CkB;AxB09nDpB;A2FlgoDE;EACC,cnEuCiB;AxB69nDpB;A2F7/nDG;EACC,cnE+BgB;AxBg+nDpB;AgFlooDQ;EACI,0BAAA;EACA,aAAA;AhFoooDZ;AgFhooDY;EACI,0BAAA;AhFkooDhB;A2F1/nDG;EACC,yBnEkBgB;AxB0+nDpB;A2Fr/nDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3F6/nDH;;A2Fh/nDC;EAhDC,cnE0CkB;AxB0/nDpB;A2FlioDE;EACC,cnEuCiB;AxB6/nDpB;;A2F7hoDG;EACC,cnE+BgB;AxBigoDpB;AgFnqoDQ;EACI,0BAAA;EACA,aAAA;AhFqqoDZ;AgFjqoDY;EACI,0BAAA;AhFmqoDhB;;A2F3hoDG;EACC,yBnEkBgB;AxB4goDpB;;A2FvhoDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FgioDH;;A2FnhoDC;EAhDC,cnE0CkB;AxB6hoDpB;A2FrkoDE;EACC,cnEuCiB;AxBgioDpB;A2FhkoDG;EACC,cnE+BgB;AxBmioDpB;AgFrsoDQ;EACI,0BAAA;EACA,aAAA;AhFusoDZ;AgFnsoDY;EACI,0BAAA;AhFqsoDhB;A2F7joDG;EACC,yBnEkBgB;AxB6ioDpB;A2FxjoDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FgkoDH;;A2FnjoDC;EAhDC,cnE0CkB;AxB6joDpB;A2FrmoDE;EACC,cnEuCiB;AxBgkoDpB;;A2FhmoDG;EACC,cnE+BgB;AxBokoDpB;AgFtuoDQ;EACI,0BAAA;EACA,aAAA;AhFwuoDZ;AgFpuoDY;EACI,0BAAA;AhFsuoDhB;;A2F9loDG;EACC,yBnEkBgB;AxB+koDpB;;A2F1loDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FmmoDH;;A2FtloDC;EAhDC,cnE0CkB;AxBgmoDpB;A2FxooDE;EACC,cnEuCiB;AxBmmoDpB;A2FnooDG;EACC,cnE+BgB;AxBsmoDpB;AgFxwoDQ;EACI,0BAAA;EACA,aAAA;AhF0woDZ;AgFtwoDY;EACI,0BAAA;AhFwwoDhB;A2FhooDG;EACC,yBnEkBgB;AxBgnoDpB;A2F3noDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FmooDH;;A2FtnoDC;EAhDC,cnE0CkB;AxBgooDpB;A2FxqoDE;EACC,cnEuCiB;AxBmooDpB;;A2FnqoDG;EACC,cnE+BgB;AxBuooDpB;AgFzyoDQ;EACI,0BAAA;EACA,aAAA;AhF2yoDZ;AgFvyoDY;EACI,0BAAA;AhFyyoDhB;;A2FjqoDG;EACC,yBnEkBgB;AxBkpoDpB;;A2F7poDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FsqoDH;;A2FzpoDC;EAhDC,cnE0CkB;AxBmqoDpB;A2F3soDE;EACC,cnEuCiB;AxBsqoDpB;A2FtsoDG;EACC,cnE+BgB;AxByqoDpB;AgF30oDQ;EACI,0BAAA;EACA,aAAA;AhF60oDZ;AgFz0oDY;EACI,0BAAA;AhF20oDhB;A2FnsoDG;EACC,yBnEkBgB;AxBmroDpB;A2F9roDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FssoDH;;A2FzroDC;EAhDC,cnE0CkB;AxBmsoDpB;A2F3uoDE;EACC,cnEuCiB;AxBssoDpB;;A2FtuoDG;EACC,cnE+BgB;AxB0soDpB;AgF52oDQ;EACI,0BAAA;EACA,aAAA;AhF82oDZ;AgF12oDY;EACI,0BAAA;AhF42oDhB;;A2FpuoDG;EACC,yBnEkBgB;AxBqtoDpB;;A2FhuoDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FyuoDH;;A2F5toDC;EAhDC,cnE0CkB;AxBsuoDpB;A2F9woDE;EACC,cnEuCiB;AxByuoDpB;A2FzwoDG;EACC,cnE+BgB;AxB4uoDpB;AgF94oDQ;EACI,0BAAA;EACA,aAAA;AhFg5oDZ;AgF54oDY;EACI,0BAAA;AhF84oDhB;A2FtwoDG;EACC,yBnEkBgB;AxBsvoDpB;A2FjwoDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FywoDH;;A2F5voDC;EAhDC,cnE0CkB;AxBswoDpB;A2F9yoDE;EACC,cnEuCiB;AxBywoDpB;;A2FzyoDG;EACC,cnE+BgB;AxB6woDpB;AgF/6oDQ;EACI,0BAAA;EACA,aAAA;AhFi7oDZ;AgF76oDY;EACI,0BAAA;AhF+6oDhB;;A2FvyoDG;EACC,yBnEkBgB;AxBwxoDpB;;A2FnyoDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3F4yoDH;;A2F/xoDC;EAhDC,cnE0CkB;AxByyoDpB;A2Fj1oDE;EACC,cnEuCiB;AxB4yoDpB;A2F50oDG;EACC,cnE+BgB;AxB+yoDpB;AgFj9oDQ;EACI,0BAAA;EACA,aAAA;AhFm9oDZ;AgF/8oDY;EACI,0BAAA;AhFi9oDhB;A2Fz0oDG;EACC,yBnEkBgB;AxByzoDpB;A2Fp0oDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3F40oDH;;A2F/zoDC;EAhDC,cnE0CkB;AxBy0oDpB;A2Fj3oDE;EACC,cnEuCiB;AxB40oDpB;;A2F52oDG;EACC,cnE+BgB;AxBg1oDpB;AgFl/oDQ;EACI,0BAAA;EACA,aAAA;AhFo/oDZ;AgFh/oDY;EACI,0BAAA;AhFk/oDhB;;A2F12oDG;EACC,yBnEkBgB;AxB21oDpB;;A2Ft2oDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3F+2oDH;;A2Fl2oDC;EAhDC,cnE0CkB;AxB42oDpB;A2Fp5oDE;EACC,cnEuCiB;AxB+2oDpB;A2F/4oDG;EACC,cnE+BgB;AxBk3oDpB;AgFphpDQ;EACI,0BAAA;EACA,aAAA;AhFshpDZ;AgFlhpDY;EACI,0BAAA;AhFohpDhB;A2F54oDG;EACC,yBnEkBgB;AxB43oDpB;A2Fv4oDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3F+4oDH;;A2Fl4oDC;EAhDC,cnE0CkB;AxB44oDpB;A2Fp7oDE;EACC,cnEuCiB;AxB+4oDpB;;A2F/6oDG;EACC,cnE+BgB;AxBm5oDpB;AgFrjpDQ;EACI,0BAAA;EACA,aAAA;AhFujpDZ;AgFnjpDY;EACI,0BAAA;AhFqjpDhB;;A2F76oDG;EACC,yBnEkBgB;AxB85oDpB;;A2Fz6oDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3Fk7oDH;;A2Fr6oDC;EAhDC,cnE0CkB;AxB+6oDpB;A2Fv9oDE;EACC,cnEuCiB;AxBk7oDpB;A2Fl9oDG;EACC,cnE+BgB;AxBq7oDpB;AgFvlpDQ;EACI,0BAAA;EACA,aAAA;AhFylpDZ;AgFrlpDY;EACI,0BAAA;AhFulpDhB;A2F/8oDG;EACC,yBnEkBgB;AxB+7oDpB;A2F18oDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3Fk9oDH;;A2Fr8oDC;EAhDC,cnE0CkB;AxB+8oDpB;A2Fv/oDE;EACC,cnEuCiB;AxBk9oDpB;;A2Fl/oDG;EACC,cnE+BgB;AxBs9oDpB;AgFxnpDQ;EACI,0BAAA;EACA,aAAA;AhF0npDZ;AgFtnpDY;EACI,0BAAA;AhFwnpDhB;;A2Fh/oDG;EACC,yBnEkBgB;AxBi+oDpB;;A2F5+oDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3Fq/oDH;;A2Fx+oDC;EAhDC,cnE0CkB;AxBk/oDpB;A2F1hpDE;EACC,cnEuCiB;AxBq/oDpB;A2FrhpDG;EACC,cnE+BgB;AxBw/oDpB;AgF1ppDQ;EACI,0BAAA;EACA,aAAA;AhF4ppDZ;AgFxppDY;EACI,0BAAA;AhF0ppDhB;A2FlhpDG;EACC,yBnEkBgB;AxBkgpDpB;A2F7gpDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FqhpDH;;A2FxgpDC;EAhDC,cnE0CkB;AxBkhpDpB;A2F1jpDE;EACC,cnEuCiB;AxBqhpDpB;;A2FrjpDG;EACC,cnE+BgB;AxByhpDpB;AgF3rpDQ;EACI,0BAAA;EACA,aAAA;AhF6rpDZ;AgFzrpDY;EACI,0BAAA;AhF2rpDhB;;A2FnjpDG;EACC,yBnEkBgB;AxBoipDpB;;A2F/ipDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FwjpDH;;A2F3ipDC;EAhDC,cnE0CkB;AxBqjpDpB;A2F7lpDE;EACC,cnEuCiB;AxBwjpDpB;A2FxlpDG;EACC,cnE+BgB;AxB2jpDpB;AgF7tpDQ;EACI,0BAAA;EACA,aAAA;AhF+tpDZ;AgF3tpDY;EACI,0BAAA;AhF6tpDhB;A2FrlpDG;EACC,yBnEkBgB;AxBqkpDpB;A2FhlpDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FwlpDH;;A2F3kpDC;EAhDC,cnE0CkB;AxBqlpDpB;A2F7npDE;EACC,cnEuCiB;AxBwlpDpB;;A2FxnpDG;EACC,cnE+BgB;AxB4lpDpB;AgF9vpDQ;EACI,0BAAA;EACA,aAAA;AhFgwpDZ;AgF5vpDY;EACI,0BAAA;AhF8vpDhB;;A2FtnpDG;EACC,yBnEkBgB;AxBumpDpB;;A2FlnpDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3F2npDH;;A2F9mpDC;EAhDC,cnE0CkB;AxBwnpDpB;A2FhqpDE;EACC,cnEuCiB;AxB2npDpB;A2F3ppDG;EACC,cnE+BgB;AxB8npDpB;AgFhypDQ;EACI,0BAAA;EACA,aAAA;AhFkypDZ;AgF9xpDY;EACI,0BAAA;AhFgypDhB;A2FxppDG;EACC,yBnEkBgB;AxBwopDpB;A2FnppDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3F2ppDH;;A2F9opDC;EAhDC,cnE0CkB;AxBwppDpB;A2FhspDE;EACC,cnEuCiB;AxB2ppDpB;;A2F3rpDG;EACC,cnE+BgB;AxB+ppDpB;AgFj0pDQ;EACI,0BAAA;EACA,aAAA;AhFm0pDZ;AgF/zpDY;EACI,0BAAA;AhFi0pDhB;;A2FzrpDG;EACC,yBnEkBgB;AxB0qpDpB;;A2FrrpDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3F8rpDH;;A2FjrpDC;EAhDC,cnE0CkB;AxB2rpDpB;A2FnupDE;EACC,cnEuCiB;AxB8rpDpB;A2F9tpDG;EACC,cnE+BgB;AxBispDpB;AgFn2pDQ;EACI,0BAAA;EACA,aAAA;AhFq2pDZ;AgFj2pDY;EACI,0BAAA;AhFm2pDhB;A2F3tpDG;EACC,yBnEkBgB;AxB2spDpB;A2FttpDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3F8tpDH;;A2FjtpDC;EAhDC,cnE0CkB;AxB2tpDpB;A2FnwpDE;EACC,cnEuCiB;AxB8tpDpB;;A2F9vpDG;EACC,cnE+BgB;AxBkupDpB;AgFp4pDQ;EACI,0BAAA;EACA,aAAA;AhFs4pDZ;AgFl4pDY;EACI,0BAAA;AhFo4pDhB;;A2F5vpDG;EACC,yBnEkBgB;AxB6upDpB;;A2FxvpDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FiwpDH;;A2FpvpDC;EAhDC,cnE0CkB;AxB8vpDpB;A2FtypDE;EACC,cnEuCiB;AxBiwpDpB;A2FjypDG;EACC,cnE+BgB;AxBowpDpB;AgFt6pDQ;EACI,0BAAA;EACA,aAAA;AhFw6pDZ;AgFp6pDY;EACI,0BAAA;AhFs6pDhB;A2F9xpDG;EACC,yBnEkBgB;AxB8wpDpB;A2FzxpDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FiypDH;;A2FpxpDC;EAhDC,cnE0CkB;AxB8xpDpB;A2Ft0pDE;EACC,cnEuCiB;AxBiypDpB;;A2Fj0pDG;EACC,cnE+BgB;AxBqypDpB;AgFv8pDQ;EACI,0BAAA;EACA,aAAA;AhFy8pDZ;AgFr8pDY;EACI,0BAAA;AhFu8pDhB;;A2F/zpDG;EACC,yBnEkBgB;AxBgzpDpB;;A2F3zpDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3Fo0pDH;;A2FvzpDC;EAhDC,cnE0CkB;AxBi0pDpB;A2Fz2pDE;EACC,cnEuCiB;AxBo0pDpB;A2Fp2pDG;EACC,cnE+BgB;AxBu0pDpB;AgFz+pDQ;EACI,0BAAA;EACA,aAAA;AhF2+pDZ;AgFv+pDY;EACI,0BAAA;AhFy+pDhB;A2Fj2pDG;EACC,yBnEkBgB;AxBi1pDpB;A2F51pDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3Fo2pDH;;A2Fv1pDC;EAhDC,cnE0CkB;AxBi2pDpB;A2Fz4pDE;EACC,cnEuCiB;AxBo2pDpB;;A2Fp4pDG;EACC,cnE+BgB;AxBw2pDpB;AgF1gqDQ;EACI,0BAAA;EACA,aAAA;AhF4gqDZ;AgFxgqDY;EACI,0BAAA;AhF0gqDhB;;A2Fl4pDG;EACC,yBnEkBgB;AxBm3pDpB;;A2F93pDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3Fu4pDH;;A2F13pDC;EAhDC,cnE0CkB;AxBo4pDpB;A2F56pDE;EACC,cnEuCiB;AxBu4pDpB;A2Fv6pDG;EACC,cnE+BgB;AxB04pDpB;AgF5iqDQ;EACI,0BAAA;EACA,aAAA;AhF8iqDZ;AgF1iqDY;EACI,0BAAA;AhF4iqDhB;A2Fp6pDG;EACC,yBnEkBgB;AxBo5pDpB;A2F/5pDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3Fu6pDH;;A2F15pDC;EAhDC,cnE0CkB;AxBo6pDpB;A2F58pDE;EACC,cnEuCiB;AxBu6pDpB;;A2Fv8pDG;EACC,cnE+BgB;AxB26pDpB;AgF7kqDQ;EACI,0BAAA;EACA,aAAA;AhF+kqDZ;AgF3kqDY;EACI,0BAAA;AhF6kqDhB;;A2Fr8pDG;EACC,yBnEkBgB;AxBs7pDpB;;A2Fj8pDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3F08pDH;;A2F77pDC;EAhDC,cnE0CkB;AxBu8pDpB;A2F/+pDE;EACC,cnEuCiB;AxB08pDpB;A2F1+pDG;EACC,cnE+BgB;AxB68pDpB;AgF/mqDQ;EACI,0BAAA;EACA,aAAA;AhFinqDZ;AgF7mqDY;EACI,0BAAA;AhF+mqDhB;A2Fv+pDG;EACC,yBnEkBgB;AxBu9pDpB;A2Fl+pDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3F0+pDH;;A2F79pDC;EAhDC,cnE0CkB;AxBu+pDpB;A2F/gqDE;EACC,cnEuCiB;AxB0+pDpB;;A2F1gqDG;EACC,cnE+BgB;AxB8+pDpB;AgFhpqDQ;EACI,0BAAA;EACA,aAAA;AhFkpqDZ;AgF9oqDY;EACI,0BAAA;AhFgpqDhB;;A2FxgqDG;EACC,yBnEkBgB;AxBy/pDpB;;A2FpgqDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3F6gqDH;;A2Fn/pDC;EAEC,uDnEkJkD;EmErNlD,0CE9E8D;A7FuoqDhE;;A2Fr9pDC;EACC,uDnEgHkD;EmErNlD,0CExE6D;A7FsoqD/D;;A2Fn+pDC;EACC,uDnEyHkD;EmErNlD,0CElE6D;A7FqoqD/D;;A2Fl/pDC;EACC,uDnEmIkD;EmErNlD,0CE5D+D;A7FooqDjE;;A2FvgqDC;EAEC,uDnEkJkD;EmErNlD,0CEtD8D;A7FmoqDhE;A2Fz+pDC;EACC,uDnEgHkD;EmErNlD,0CErD6D;A7FsoqD/D;A2Ft/pDC;EACC,uDnEyHkD;EmErNlD,0CEpD6D;A7FyoqD/D;A2FpgqDC;EACC,uDnEmIkD;EmErNlD,0CEnD+D;A7F4oqDjE;;A2FxhqDC;EAEC,uDnEkJkD;EmEjNlD,chDvHuB;A3CitqDzB;A2FxlqDE;EACC,chD1HsB;A3CotqDzB;A2FnlqDG;EACC,chDlIqB;A3CutqDzB;AgFxtqDQ;EACI,0BAAA;EACA,aAAA;AhF0tqDZ;AgFttqDY;EACI,0BAAA;AhFwtqDhB;A2FhlqDG;EACC,yBhD/IqB;A3CiuqDzB;A2F3kqDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FmlqDH;;A2F/hqDC;EACC,uDnEyHkD;EmEjNlD,chDvHuB;A3CkvqDzB;A2FznqDE;EACC,chD1HsB;A3CqvqDzB;A2FpnqDG;EACC,chDlIqB;A3CwvqDzB;AgFzvqDQ;EACI,0BAAA;EACA,aAAA;AhF2vqDZ;AgFvvqDY;EACI,0BAAA;AhFyvqDhB;A2FjnqDG;EACC,yBhD/IqB;A3CkwqDzB;A2F5mqDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FonqDH;;A2FvjqDC;EACC,uDnEgHkD;EmEjNlD,chDvHuB;A3CmxqDzB;A2F1pqDE;EACC,chD1HsB;A3CsxqDzB;A2FrpqDG;EACC,chDlIqB;A3CyxqDzB;AgF1xqDQ;EACI,0BAAA;EACA,aAAA;AhF4xqDZ;AgFxxqDY;EACI,0BAAA;AhF0xqDhB;A2FlpqDG;EACC,yBhD/IqB;A3CmyqDzB;A2F7oqDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FqpqDH;;A2F3mqDC;EACC,uDnEmIkD;EmEjNlD,chDvHuB;A3CozqDzB;A2F3rqDE;EACC,chD1HsB;A3CuzqDzB;A2FtrqDG;EACC,chDlIqB;A3C0zqDzB;AgF3zqDQ;EACI,0BAAA;EACA,aAAA;AhF6zqDZ;AgFzzqDY;EACI,0BAAA;AhF2zqDhB;A2FnrqDG;EACC,yBhD/IqB;A3Co0qDzB;A2F9qqDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FsrqDH;;A2F5pqDC;EAEC,uDnEkJkD;EmEjNlD,chDvHuB;A3Cq1qDzB;A2F5tqDE;EACC,chD1HsB;A3Cw1qDzB;A2FvtqDG;EACC,chDlIqB;A3C21qDzB;AgF51qDQ;EACI,0BAAA;EACA,aAAA;AhF81qDZ;AgF11qDY;EACI,0BAAA;AhF41qDhB;A2FptqDG;EACC,yBhD/IqB;A3Cq2qDzB;A2F/sqDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FutqDH;A2FnqqDC;EACC,uDnEyHkD;EmEjNlD,chDvHuB;A3Cq3qDzB;A2F5vqDE;EACC,chD1HsB;A3Cw3qDzB;A2FvvqDG;EACC,chDlIqB;A3C23qDzB;AgF53qDQ;EACI,0BAAA;EACA,aAAA;AhF83qDZ;AgF13qDY;EACI,0BAAA;AhF43qDhB;A2FpvqDG;EACC,yBhD/IqB;A3Cq4qDzB;A2F/uqDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FuvqDH;A2F1rqDC;EACC,uDnEgHkD;EmEjNlD,chDvHuB;A3Cq5qDzB;A2F5xqDE;EACC,chD1HsB;A3Cw5qDzB;A2FvxqDG;EACC,chDlIqB;A3C25qDzB;AgF55qDQ;EACI,0BAAA;EACA,aAAA;AhF85qDZ;AgF15qDY;EACI,0BAAA;AhF45qDhB;A2FpxqDG;EACC,yBhD/IqB;A3Cq6qDzB;A2F/wqDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FuxqDH;A2F7uqDC;EACC,uDnEmIkD;EmEjNlD,chDvHuB;A3Cq7qDzB;A2F5zqDE;EACC,chD1HsB;A3Cw7qDzB;A2FvzqDG;EACC,chDlIqB;A3C27qDzB;AgF57qDQ;EACI,0BAAA;EACA,aAAA;AhF87qDZ;AgF17qDY;EACI,0BAAA;AhF47qDhB;A2FpzqDG;EACC,yBhD/IqB;A3Cq8qDzB;A2F/yqDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FuzqDH;;A2F7xqDC;EAEC,uDnEkJkD;EmErNlD,yBhDnHuB;EgDuHvB,chDpH0B;A3Co9qD5B;A2F91qDE;EACC,chDvHyB;A3Cu9qD5B;A2Fz1qDG;EACC,chD/HwB;A3C09qD5B;AgF99qDQ;EACI,0BAAA;EACA,aAAA;AhFg+qDZ;AgF59qDY;EACI,0BAAA;AhF89qDhB;A2Ft1qDG;EACC,yBhD5IwB;A3Co+qD5B;A2Fj1qDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3Fy1qDH;;A2FryqDC;EACC,uDnEyHkD;EmErNlD,yBhDnHuB;EgDuHvB,chDpH0B;A3Cs/qD5B;A2Fh4qDE;EACC,chDvHyB;A3Cy/qD5B;A2F33qDG;EACC,chD/HwB;A3C4/qD5B;AgFhgrDQ;EACI,0BAAA;EACA,aAAA;AhFkgrDZ;AgF9/qDY;EACI,0BAAA;AhFggrDhB;A2Fx3qDG;EACC,yBhD5IwB;A3CsgrD5B;A2Fn3qDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3F23qDH;;A2F9zqDC;EACC,uDnEgHkD;EmErNlD,yBhDnHuB;EgDuHvB,chDpH0B;A3CwhrD5B;A2Fl6qDE;EACC,chDvHyB;A3C2hrD5B;A2F75qDG;EACC,chD/HwB;A3C8hrD5B;AgFlirDQ;EACI,0BAAA;EACA,aAAA;AhFoirDZ;AgFhirDY;EACI,0BAAA;AhFkirDhB;A2F15qDG;EACC,yBhD5IwB;A3CwirD5B;A2Fr5qDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3F65qDH;;A2Fn3qDC;EACC,uDnEmIkD;EmErNlD,yBhDnHuB;EgDuHvB,chDpH0B;A3C0jrD5B;A2Fp8qDE;EACC,chDvHyB;A3C6jrD5B;A2F/7qDG;EACC,chD/HwB;A3CgkrD5B;AgFpkrDQ;EACI,0BAAA;EACA,aAAA;AhFskrDZ;AgFlkrDY;EACI,0BAAA;AhFokrDhB;A2F57qDG;EACC,yBhD5IwB;A3C0krD5B;A2Fv7qDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3F+7qDH;;A2Fr6qDC;EAEC,uDnEkJkD;EmErNlD,yBhDnHuB;EgDuHvB,chDpH0B;A3C4lrD5B;A2Ft+qDE;EACC,chDvHyB;A3C+lrD5B;A2Fj+qDG;EACC,chD/HwB;A3CkmrD5B;AgFtmrDQ;EACI,0BAAA;EACA,aAAA;AhFwmrDZ;AgFpmrDY;EACI,0BAAA;AhFsmrDhB;A2F99qDG;EACC,yBhD5IwB;A3C4mrD5B;A2Fz9qDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3Fi+qDH;A2F76qDC;EACC,uDnEyHkD;EmErNlD,yBhDnHuB;EgDuHvB,chDpH0B;A3C6nrD5B;A2FvgrDE;EACC,chDvHyB;A3CgorD5B;A2FlgrDG;EACC,chD/HwB;A3CmorD5B;AgFvorDQ;EACI,0BAAA;EACA,aAAA;AhFyorDZ;AgFrorDY;EACI,0BAAA;AhFuorDhB;A2F//qDG;EACC,yBhD5IwB;A3C6orD5B;A2F1/qDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FkgrDH;A2Fr8qDC;EACC,uDnEgHkD;EmErNlD,yBhDnHuB;EgDuHvB,chDpH0B;A3C8prD5B;A2FxirDE;EACC,chDvHyB;A3CiqrD5B;A2FnirDG;EACC,chD/HwB;A3CoqrD5B;AgFxqrDQ;EACI,0BAAA;EACA,aAAA;AhF0qrDZ;AgFtqrDY;EACI,0BAAA;AhFwqrDhB;A2FhirDG;EACC,yBhD5IwB;A3C8qrD5B;A2F3hrDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FmirDH;A2Fz/qDC;EACC,uDnEmIkD;EmErNlD,yBhDnHuB;EgDuHvB,chDpH0B;A3C+rrD5B;A2FzkrDE;EACC,chDvHyB;A3CksrD5B;A2FpkrDG;EACC,chD/HwB;A3CqsrD5B;AgFzsrDQ;EACI,0BAAA;EACA,aAAA;AhF2srDZ;AgFvsrDY;EACI,0BAAA;AhFysrDhB;A2FjkrDG;EACC,yBhD5IwB;A3C+srD5B;A2F5jrDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FokrDH;;A2FhhrDC;EACC,uDnEyHkD;EmErNlD,yBhDjH6B;EgDqH7B,chDvHuB;A3CourDzB;A2F3mrDE;EACC,chD1HsB;A3CuurDzB;A2FtmrDG;EACC,chDlIqB;A3C0urDzB;AgF3urDQ;EACI,0BAAA;EACA,aAAA;AhF6urDZ;AgFzurDY;EACI,0BAAA;AhF2urDhB;A2FnmrDG;EACC,yBhD/IqB;A3CovrDzB;A2F9lrDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FsmrDH;;A2FzirDC;EACC,uDnEgHkD;EmErNlD,yBhDjH6B;EgDqH7B,chDvHuB;A3CswrDzB;A2F7orDE;EACC,chD1HsB;A3CywrDzB;A2FxorDG;EACC,chDlIqB;A3C4wrDzB;AgF7wrDQ;EACI,0BAAA;EACA,aAAA;AhF+wrDZ;AgF3wrDY;EACI,0BAAA;AhF6wrDhB;A2FrorDG;EACC,yBhD/IqB;A3CsxrDzB;A2FhorDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FworDH;;A2F9mrDC;EAEC,uDnEkJkD;EmErNlD,yBhDjH6B;EgDqH7B,chDvHuB;A3CwyrDzB;A2F/qrDE;EACC,chD1HsB;A3C2yrDzB;A2F1qrDG;EACC,chDlIqB;A3C8yrDzB;AgF/yrDQ;EACI,0BAAA;EACA,aAAA;AhFizrDZ;AgF7yrDY;EACI,0BAAA;AhF+yrDhB;A2FvqrDG;EACC,yBhD/IqB;A3CwzrDzB;A2FlqrDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3F0qrDH;;A2FhorDC;EACC,uDnEmIkD;EmErNlD,yBhDjH6B;EgDqH7B,chDvHuB;A3C00rDzB;A2FjtrDE;EACC,chD1HsB;A3C60rDzB;A2F5srDG;EACC,chDlIqB;A3Cg1rDzB;AgFj1rDQ;EACI,0BAAA;EACA,aAAA;AhFm1rDZ;AgF/0rDY;EACI,0BAAA;AhFi1rDhB;A2FzsrDG;EACC,yBhD/IqB;A3C01rDzB;A2FpsrDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3F4srDH;;A2FxprDC;EACC,uDnEyHkD;EmErNlD,yBhDjH6B;EgDqH7B,chDvHuB;A3C42rDzB;A2FnvrDE;EACC,chD1HsB;A3C+2rDzB;A2F9urDG;EACC,chDlIqB;A3Ck3rDzB;AgFn3rDQ;EACI,0BAAA;EACA,aAAA;AhFq3rDZ;AgFj3rDY;EACI,0BAAA;AhFm3rDhB;A2F3urDG;EACC,yBhD/IqB;A3C43rDzB;A2FturDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3F8urDH;A2FjrrDC;EACC,uDnEgHkD;EmErNlD,yBhDjH6B;EgDqH7B,chDvHuB;A3C64rDzB;A2FpxrDE;EACC,chD1HsB;A3Cg5rDzB;A2F/wrDG;EACC,chDlIqB;A3Cm5rDzB;AgFp5rDQ;EACI,0BAAA;EACA,aAAA;AhFs5rDZ;AgFl5rDY;EACI,0BAAA;AhFo5rDhB;A2F5wrDG;EACC,yBhD/IqB;A3C65rDzB;A2FvwrDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3F+wrDH;A2FrvrDC;EAEC,uDnEkJkD;EmErNlD,yBhDjH6B;EgDqH7B,chDvHuB;A3C86rDzB;A2FrzrDE;EACC,chD1HsB;A3Ci7rDzB;A2FhzrDG;EACC,chDlIqB;A3Co7rDzB;AgFr7rDQ;EACI,0BAAA;EACA,aAAA;AhFu7rDZ;AgFn7rDY;EACI,0BAAA;AhFq7rDhB;A2F7yrDG;EACC,yBhD/IqB;A3C87rDzB;A2FxyrDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FgzrDH;A2FtwrDC;EACC,uDnEmIkD;EmErNlD,yBhDjH6B;EgDqH7B,chDvHuB;A3C+8rDzB;A2Ft1rDE;EACC,chD1HsB;A3Ck9rDzB;A2Fj1rDG;EACC,chDlIqB;A3Cq9rDzB;AgFt9rDQ;EACI,0BAAA;EACA,aAAA;AhFw9rDZ;AgFp9rDY;EACI,0BAAA;AhFs9rDhB;A2F90rDG;EACC,yBhD/IqB;A3C+9rDzB;A2Fz0rDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3Fi1rDH;;A2FvzrDC;EAEC,uDnEkJkD;EmEjNlD,chDvHuB;A3Cg/rDzB;A2Fv3rDE;EACC,chD1HsB;A3Cm/rDzB;;A2F5xrDC;EACC,uDnEgHkD;EmEjNlD,chDvHuB;A3Cw/rDzB;A2F/3rDE;EACC,chD1HsB;A3C2/rDzB;;A2F7yrDC;EACC,uDnEyHkD;EmEjNlD,chDvHuB;A3CggsDzB;A2Fv4rDE;EACC,chD1HsB;A3CmgsDzB;;A2F/zrDC;EACC,uDnEmIkD;EmEjNlD,chDvHuB;A3CwgsDzB;A2F/4rDE;EACC,chD1HsB;A3C2gsDzB;;A2Fv1rDC;EAEC,uDnEkJkD;EmEjNlD,chDvHuB;A3CghsDzB;A2Fv5rDE;EACC,chD1HsB;A3CmhsDzB;A2Fr0rDC;EACC,uDnEyHkD;EmEjNlD,chDvHuB;A3CuhsDzB;A2F95rDE;EACC,chD1HsB;A3C0hsDzB;A2Ft1rDC;EACC,uDnEmIkD;EmEjNlD,chDvHuB;A3C8hsDzB;A2Fr6rDE;EACC,chD1HsB;A3CiisDzB;;A2F72rDC;EAEC,uDnEkJkD;AxB6trDpD;A2Fp6rDG;EACC,chDlIqB;A3CwisDzB;AgFzisDQ;EACI,0BAAA;EACA,aAAA;AhF2isDZ;AgFvisDY;EACI,0BAAA;AhFyisDhB;;A2Fx1rDC;EACC,uDnEgHkD;AxB2urDpD;A2Fl7rDG;EACC,chDlIqB;A3CsjsDzB;AgFvjsDQ;EACI,0BAAA;EACA,aAAA;AhFyjsDZ;AgFrjsDY;EACI,0BAAA;AhFujsDhB;;A2F/2rDC;EACC,uDnEyHkD;AxByvrDpD;A2Fh8rDG;EACC,chDlIqB;A3CoksDzB;AgFrksDQ;EACI,0BAAA;EACA,aAAA;AhFuksDZ;AgFnksDY;EACI,0BAAA;AhFqksDhB;;A2Fv4rDC;EACC,uDnEmIkD;AxBuwrDpD;A2F98rDG;EACC,chDlIqB;A3CklsDzB;AgFnlsDQ;EACI,0BAAA;EACA,aAAA;AhFqlsDZ;AgFjlsDY;EACI,0BAAA;AhFmlsDhB;;A2Fr6rDC;EAEC,uDnEkJkD;AxBqxrDpD;A2F59rDG;EACC,chDlIqB;A3CgmsDzB;AgFjmsDQ;EACI,0BAAA;EACA,aAAA;AhFmmsDZ;AgF/lsDY;EACI,0BAAA;AhFimsDhB;A2Fz5rDC;EACC,uDnEyHkD;AxBkyrDpD;A2Fz+rDG;EACC,chDlIqB;A3C6msDzB;AgF9msDQ;EACI,0BAAA;EACA,aAAA;AhFgnsDZ;AgF5msDY;EACI,0BAAA;AhF8msDhB;A2Fh7rDC;EACC,uDnEmIkD;AxB+yrDpD;A2Ft/rDG;EACC,chDlIqB;A3C0nsDzB;AgF3nsDQ;EACI,0BAAA;EACA,aAAA;AhF6nsDZ;AgFznsDY;EACI,0BAAA;AhF2nsDhB;;A2F78rDC;EAEC,uDnEkJkD;AxB6zrDpD;A2Fv/rDG;EACC,yBhD/IqB;A3CwosDzB;;A2F17rDC;EACC,uDnEyHkD;AxBo0rDpD;A2F9/rDG;EACC,yBhD/IqB;A3C+osDzB;;A2Fx7rDC;EACC,uDnEgHkD;AxB20rDpD;A2FrgsDG;EACC,yBhD/IqB;A3CspsDzB;;A2Fl9rDC;EACC,uDnEmIkD;AxBk1rDpD;A2F5gsDG;EACC,yBhD/IqB;A3C6psDzB;;A2Fz+rDC;EAEC,uDnEkJkD;AxBy1rDpD;A2FnhsDG;EACC,yBhD/IqB;A3CoqsDzB;A2Ft9rDC;EACC,uDnEyHkD;AxB+1rDpD;A2FzhsDG;EACC,yBhD/IqB;A3C0qsDzB;A2Ft+rDC;EACC,uDnEmIkD;AxBq2rDpD;A2F/hsDG;EACC,yBhD/IqB;A3CgrsDzB;;A2F5/rDC;EAEC,uDnEkJkD;AxB42rDpD;A2F9hsDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FsisDH;;A2Fz+rDC;EACC,uDnEgHkD;AxB43rDpD;A2F9isDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FsjsDH;;A2FlgsDC;EACC,uDnEyHkD;AxB44rDpD;A2F9jsDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FsksDH;;A2F5hsDC;EACC,uDnEmIkD;AxB45rDpD;A2F9ksDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FslsDH;;A2F5jsDC;EAEC,uDnEkJkD;AxB46rDpD;A2F9lsDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FsmsDH;A2FljsDC;EACC,uDnEyHkD;AxB27rDpD;A2F7msDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FqnsDH;A2F3ksDC;EACC,uDnEmIkD;AxB08rDpD;A2F5nsDE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3FoosDH;;A8FlysDA;EACI,aAAA;EACA,mBAAA;A9FqysDJ;A8FnysDI;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,ctENiB;EsEOjB,yBtE0T4C;AxB2+rDpD;A8FnysDQ;EACI,YAAA;A9FqysDZ;A8FhysDQ;EACI,aAAA;A9FkysDZ;A8FhysDY;EACI,cnDvBS;EmDwBT,yBtE6SoC;AxBq/rDpD;;A+F7zsDA;EAIQ,SAAA;EAGJ,oDvEypBuB;AxBkqrD3B;A+FxzsDI;EACI,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,eAAA;EACA,gBvE2pBqB;EuE1pBrB,kBAAA;EACA,6BAAA;EACA,mDAAA;A/F0zsDR;A+FvzsDQ;EACI,aAAA;EACA,mBAAA;EACA,cvEipBwC;EuEhpBxC,cAAA;A/FyzsDZ;A+FvzsDY;EACI,uBAAA;EACA,uBAAA;A/FyzsDhB;A+FtzsDY;EACI,qBAAA;EACA,cAAA;A/FwzsDhB;A+FtzsDgB;EACI,kBAAA;EACA,cvE9BK;EuE+BL,cAAA;A/FwzsDpB;A+FtzsDoB;EAEI,cAAA;A/FuzsDxB;AgF10sDI;EACI,YAAA;EACA,WAAA;AhF40sDR;AgFp2sDQ;EACI,0BAAA;EACA,aAAA;AhFs2sDZ;AgFl2sDY;EACI,0BAAA;AhFo2sDhB;A+FxzsDY;;EAEI,gBAAA;EACA,mBAAA;EACA,cvE9CS;AxBw2sDzB;A+FvzsDY;EACI,qBAAA;EACA,eAAA;A/FyzsDhB;A+FrzsDY;EACI,cvE5DS;EuE6DT,eAAA;A/FuzsDhB;A+FnzsDY;EACI,gBAAA;A/FqzsDhB;A+FhzsDQ;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;A/FkzsDZ;A+F7ysDI;EACI,qBAAA;A/F+ysDR;A+F3ysDI;EACI,qBAAA;EACA,6BAAA;EACA,gDAAA;A/F6ysDR;A+FzysDI;EACI,kBAAA;EACA,cAAA;A/F2ysDR;A+FtysDQ;;;EAGI,eAAA;EACA,gBAAA;A/FwysDZ;A+FnysDQ;;;EAGI,cAAA;EACA,iBAAA;A/FqysDZ;A+FhysDQ;;;EAGI,UAAA;A/FkysDZ;A+F7xsDI;EACI,gBAAA;EACA,6CAAA;A/F+xsDR;A+F7xsDQ;EACI,iCAAA;A/F+xsDZ;A+F5xsDQ;EACI,8BAAA;A/F8xsDZ;A+FzxsDI;EACI,gBAAA;EACA,4CAAA;A/F2xsDR;A+FtxsDQ;EACI,gBAAA;A/FwxsDZ;A+FrxsDQ;EACI,aAAA;A/FuxsDZ;A+FnxsDI;EACI,oDvE6fmB;EuE5fnB,SAAA;A/FqxsDR;;A+F1wsDY;EACI,uCAAA;A/F6wsDhB;A+FzwsDY;EACI,sCAAA;A/F2wsDhB;A+FvwsDY;EACI,sCAAA;A/FywsDhB;A+FrwsDY;EACI,0CAAA;A/FuwsDhB;A+FnwsDY;EACI,sCAAA;A/FqwsDhB;A+FjwsDY;EACI,yBAAA;EACA,4BAAA;EACA,oBAAA;A/FmwsDhB;A+FjwsDgB;EACI,SAAA;EACA,oBAAA;A/FmwsDpB;AUx5sDI;EqFqHQ;IACI,uCAAA;E/FsysDd;E+FlysDU;IACI,sCAAA;E/FoysDd;E+FhysDU;IACI,sCAAA;E/FkysDd;E+F9xsDU;IACI,0CAAA;E/FgysDd;E+F5xsDU;IACI,sCAAA;E/F8xsDd;E+F1xsDU;IACI,yBAAA;IACA,4BAAA;IACA,oBAAA;E/F4xsDd;E+F1xsDc;IACI,SAAA;IACA,oBAAA;E/F4xsDlB;AACF;AUl7sDI;EqFqHQ;IACI,uCAAA;E/Fg0sDd;E+F5zsDU;IACI,sCAAA;E/F8zsDd;E+F1zsDU;IACI,sCAAA;E/F4zsDd;E+FxzsDU;IACI,0CAAA;E/F0zsDd;E+FtzsDU;IACI,sCAAA;E/FwzsDd;E+FpzsDU;IACI,yBAAA;IACA,4BAAA;IACA,oBAAA;E/FszsDd;E+FpzsDc;IACI,SAAA;IACA,oBAAA;E/FszsDlB;AACF;AU58sDI;EqFqHQ;IACI,uCAAA;E/F01sDd;E+Ft1sDU;IACI,sCAAA;E/Fw1sDd;E+Fp1sDU;IACI,sCAAA;E/Fs1sDd;E+Fl1sDU;IACI,0CAAA;E/Fo1sDd;E+Fh1sDU;IACI,sCAAA;E/Fk1sDd;E+F90sDU;IACI,yBAAA;IACA,4BAAA;IACA,oBAAA;E/Fg1sDd;E+F90sDc;IACI,SAAA;IACA,oBAAA;E/Fg1sDlB;AACF;AUt+sDI;EqFqHQ;IACI,uCAAA;E/Fo3sDd;E+Fh3sDU;IACI,sCAAA;E/Fk3sDd;E+F92sDU;IACI,sCAAA;E/Fg3sDd;E+F52sDU;IACI,0CAAA;E/F82sDd;E+F12sDU;IACI,sCAAA;E/F42sDd;E+Fx2sDU;IACI,yBAAA;IACA,4BAAA;IACA,oBAAA;E/F02sDd;E+Fx2sDc;IACI,SAAA;IACA,oBAAA;E/F02sDlB;AACF;AUhgtDI;EqFqHQ;IACI,uCAAA;E/F84sDd;E+F14sDU;IACI,sCAAA;E/F44sDd;E+Fx4sDU;IACI,sCAAA;E/F04sDd;E+Ft4sDU;IACI,0CAAA;E/Fw4sDd;E+Fp4sDU;IACI,sCAAA;E/Fs4sDd;E+Fl4sDU;IACI,yBAAA;IACA,4BAAA;IACA,oBAAA;E/Fo4sDd;E+Fl4sDc;IACI,SAAA;IACA,oBAAA;E/Fo4sDlB;AACF;;A+F73sDA;EACI,gCAAA;A/Fg4sDJ;;A+F73sDA;EACI,gCAAA;EACA,iCAAA;A/Fg4sDJ;;A+F73sDA;EACI,oDvE+buB;AxBi8rD3B;;A+F73sDA;EACI,4BAAA;EACA,+BAAA;A/Fg4sDJ;;A+F73sDA;EACI,uBvEmHgC;AxB6wsDpC;;A+F73sDA;EACI,gCvE+GgC;EuE9GhC,mCvE8GgC;AxBkxsDpC;;A+F73sDA;EACI,iCvE0GgC;EuEzGhC,oCvEyGgC;AxBuxsDpC;;A+F73sDA;EACI,gCvEqGgC;EuEpGhC,iCvEoGgC;AxB4xsDpC;;A+F73sDA;EACI,mCvEgGgC;EuE/FhC,oCvE+FgC;AxBiysDpC;;AUvjtDI;EqF6LI;IACI,mBvEoawC;IuEnaxC,sBvEmawC;ExB29rDlD;AACF;AgGrotDA;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,UAAA;EACA,SAAA;AhGuotDJ;AgGpotDI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,qBxE42B4C;AxB0xrDpD;AgGpotDQ;EACI,gBAAA;AhGsotDZ;AgGnotDQ;EACI,YAAA;EACA,oBxEo2BwC;AxBiyrDpD;AgGlotDQ;EACI,aAAA;AhGootDZ;AgGhotDY;EACI,aAAA;AhGkotDhB;;AgGzntDQ;EACI,YAAA;AhG4ntDZ;;AgGpntDQ;EACI,YAAA;AhGuntDZ;;AgG/mtDQ;EACI,aAAA;AhGkntDZ;;AiG3qtDA;EAEC,wBAAA;AjG6qtDD;AiG1qtDC;EACC,2BAAA;AjG4qtDF;AiGxqtDC;EACC,SAAA;EACA,+CAAA;AjG0qtDF;AiGxqtDE;EACC,iDAAA;AjG0qtDH;AiGvqtDE;EACC,gDAAA;AjGyqtDH;AiGpqtDC;EACC,SAAA;EACA,gBAAA;EACA,0BAAA;EACA,2BAAA;EACA,qBAAA;EACA,gBzEyXkD;AxB6ysDpD;AiGlqtDC;EACC,0BAAA;AjGoqtDF;AiGhqtDC;EACC,yBAAA;AjGkqtDF;AiG9ptDC;EC5CG,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,6BAAA;EACA,wBAAA;EACA,SAAA;EACA,UAAA;AlG6stDJ;AiGpqtDC;EACC,oBAAA;EACA,mBAAA;AjGsqtDF;;AiG/ptDC;EACC,oBAAA;EACA,ezEoVkC;EyEnVlC,sBAAA;EACA,sBAAA;EACA,cAAA;AjGkqtDF;AiG9ptDC;EACC,cAAA;EACA,cAAA;EACA,oBAAA;AjGgqtDF;AiG5ptDC;EACC,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,4C3F40BsC;E2F30BtC,2C3F20BsC;ANm1rDxC;AiG3ptDE;EACC,SAAA;AjG6ptDH;AiGzptDE;EACC,4C3Fm0BqC;E2Fl0BrC,2C3Fk0BqC;ANy1rDxC;AiGvptDE;EACC,6C3F8zBqC;E2F7zBrC,4C3F6zBqC;AN41rDxC;AiGtptDE;EACC,kBAAA;AjGwptDH;AiGrptDE;;EAEC,UAAA;EACA,SAAA;EACA,cAAA;AjGuptDH;;AiGjptDA;EACC,+BAAA;AjGoptDD;AiGlptDC;EACC,2BAAA;EACA,+BAAA;AjGoptDF;;AiGhptDA;EACC,+BAAA;AjGmptDD;AiGjptDC;EACC,qBAAA;EACA,+BAAA;AjGmptDF;;AiG/otDA;EACC,+BAAA;AjGkptDD;AiGhptDC;EACC,uBAAA;EACA,+BAAA;AjGkptDF;;AiG9otDA;EACC,+BAAA;AjGiptDD;AiG/otDC;EACC,wBAAA;EACA,+BAAA;AjGiptDF;;AmGhytDC;ECUO,cDTE;EC2BF,qB5EqFO;E4EjFP,yB5EiFO;AxBqrtDf;AoGxxtDQ;EACF,cDbS;AnGuytDf;AgFzytDQ;EACI,0BAAA;EACA,aAAA;AhF2ytDZ;AgFvytDY;EACI,0BAAA;AhFyytDhB;AoG1xtDQ;EACI,cDrBG;AnGiztDf;AoGhxtDI;EASQ,cDtCK;ECwDL,qBDtDY;EC0DZ,oCAAA;ApGsvtDZ;AoGxwtDY;EACF,cD1CY;AnGoztDtB;AgF3ztDQ;EACI,0BAAA;EACA,aAAA;AhF6ztDZ;AgFzztDY;EACI,0BAAA;AhF2ztDhB;AoG1wtDY;EACI,cDlDM;AnG8ztDtB;;AmGrytDE;ECJM,qB5EqFO;E4EjFP,yB5EiFO;AxByttDf;AoGvytDI;EASQ,cDQM;ECUN,qB5EmDG;E4E/CH,oCAAA;ApG6wtDZ;AoG/xtDY;EACF,cDIa;AnG6xtDvB;AgFl1tDQ;EACI,0BAAA;EACA,aAAA;AhFo1tDZ;AgFh1tDY;EACI,0BAAA;AhFk1tDhB;AoGjytDY;EACI,cDJO;AnGuytDvB;;AmG51tDC;ECUO,cDTE;EC2BF,qB5EqFO;E4EjFP,yB5EiFO;AxBivtDf;AoGp1tDQ;EACF,cDbS;AnGm2tDf;AgFr2tDQ;EACI,0BAAA;EACA,aAAA;AhFu2tDZ;AgFn2tDY;EACI,0BAAA;AhFq2tDhB;AoGt1tDQ;EACI,cDrBG;AnG62tDf;AoG50tDI;EASQ,cDtCK;ECwDL,qBDtDY;EC0DZ,oCAAA;ApGkztDZ;AoGp0tDY;EACF,cD1CY;AnGg3tDtB;AgFv3tDQ;EACI,0BAAA;EACA,aAAA;AhFy3tDZ;AgFr3tDY;EACI,0BAAA;AhFu3tDhB;AoGt0tDY;EACI,cDlDM;AnG03tDtB;;AmGj2tDE;ECJM,qB5EqFO;E4EjFP,yB5EiFO;AxBqxtDf;AoGn2tDI;EASQ,cDQM;ECUN,qB5EmDG;E4E/CH,oCAAA;ApGy0tDZ;AoG31tDY;EACF,cDIa;AnGy1tDvB;AgF94tDQ;EACI,0BAAA;EACA,aAAA;AhFg5tDZ;AgF54tDY;EACI,0BAAA;AhF84tDhB;AoG71tDY;EACI,cDJO;AnGm2tDvB;;AmGx5tDC;ECUO,cDTE;EC2BF,qB5EqFO;E4EjFP,yB5EiFO;AxB6ytDf;AoGh5tDQ;EACF,cDbS;AnG+5tDf;AgFj6tDQ;EACI,0BAAA;EACA,aAAA;AhFm6tDZ;AgF/5tDY;EACI,0BAAA;AhFi6tDhB;AoGl5tDQ;EACI,cDrBG;AnGy6tDf;AoGx4tDI;EASQ,cDtCK;ECwDL,qBDtDY;EC0DZ,oCAAA;ApG82tDZ;AoGh4tDY;EACF,cD1CY;AnG46tDtB;AgFn7tDQ;EACI,0BAAA;EACA,aAAA;AhFq7tDZ;AgFj7tDY;EACI,0BAAA;AhFm7tDhB;AoGl4tDY;EACI,cDlDM;AnGs7tDtB;;AmG76tDE;ECNM,c5EuGO;E4ErFP,qBDTU;ECaV,yBDZM;AnG+6tDd;AoGr7tDQ;EACF,c5EkGS;AxBq1tDf;AgFt8tDQ;EACI,0BAAA;EACA,aAAA;AhFw8tDZ;AgFp8tDY;EACI,0BAAA;AhFs8tDhB;AoGv7tDQ;EACI,c5E0FG;AxB+1tDf;AoG76tDI;EASQ,cDtBM;ECwCN,qB5EmDG;E4E/CH,oCAAA;ApGm5tDZ;AoGr6tDY;EACF,cD1Ba;AnGi8tDvB;AgFx9tDQ;EACI,0BAAA;EACA,aAAA;AhF09tDZ;AgFt9tDY;EACI,0BAAA;AhFw9tDhB;AoGv6tDY;EACI,cDlCO;AnG28tDvB;;AmGl8tDE;ECJM,qB5EqFO;E4EjFP,yB5EiFO;AxBs3tDf;AoGp8tDI;EASQ,cDQM;ECUN,qB5EmDG;E4E/CH,oCAAA;ApG06tDZ;AoG57tDY;EACF,cDIa;AnG07tDvB;AgF/+tDQ;EACI,0BAAA;EACA,aAAA;AhFi/tDZ;AgF7+tDY;EACI,0BAAA;AhF++tDhB;AoG97tDY;EACI,cDJO;AnGo8tDvB;;AoGt9tDI;EASQ,c5EqEG;E4EnDH,qBDOc;ECHd,oCAAA;ApG67tDZ;AoG/8tDY;EACF,c5EgEK;AxBi5tDf;AgFlguDQ;EACI,0BAAA;EACA,aAAA;AhFoguDZ;AgFhguDY;EACI,0BAAA;AhFkguDhB;AoGj9tDY;EACI,c5EwDD;AxB25tDf;AmGj8tDI;EACC,gCAAA;AnGm8tDL;;AmG/guDC;ECUO,cDTE;EC2BF,qB5EqFO;E4EjFP,yB5EiFO;AxBo6tDf;AoGvguDQ;EACF,cDbS;AnGshuDf;AgFxhuDQ;EACI,0BAAA;EACA,aAAA;AhF0huDZ;AgFthuDY;EACI,0BAAA;AhFwhuDhB;AoGzguDQ;EACI,cDrBG;AnGgiuDf;AoG//tDI;EASQ,cDtCK;ECwDL,qBDtDY;EC0DZ,oCAAA;ApGq+tDZ;AoGv/tDY;EACF,cD1CY;AnGmiuDtB;AgF1iuDQ;EACI,0BAAA;EACA,aAAA;AhF4iuDZ;AgFxiuDY;EACI,0BAAA;AhF0iuDhB;AoGz/tDY;EACI,cDlDM;AnG6iuDtB;;AmGphuDE;ECJM,qB5EqFO;E4EjFP,yB5EiFO;AxBw8tDf;AoGthuDI;EASQ,cDQM;ECUN,qB5EmDG;E4E/CH,oCAAA;ApG4/tDZ;AoG9guDY;EACF,cDIa;AnG4guDvB;AgFjkuDQ;EACI,0BAAA;EACA,aAAA;AhFmkuDZ;AgF/juDY;EACI,0BAAA;AhFikuDhB;AoGhhuDY;EACI,cDJO;AnGshuDvB;;AmG3kuDC;ECUO,cDTE;EC2BF,qB5EqFO;E4EjFP,yB5EiFO;AxBg+tDf;AoGnkuDQ;EACF,cDbS;AnGkluDf;AgFpluDQ;EACI,0BAAA;EACA,aAAA;AhFsluDZ;AgFlluDY;EACI,0BAAA;AhFoluDhB;AoGrkuDQ;EACI,cDrBG;AnG4luDf;AoG3juDI;EASQ,cDtCK;ECwDL,qBDtDY;EC0DZ,oCAAA;ApGiiuDZ;AoGnjuDY;EACF,cD1CY;AnG+luDtB;AgFtmuDQ;EACI,0BAAA;EACA,aAAA;AhFwmuDZ;AgFpmuDY;EACI,0BAAA;AhFsmuDhB;AoGrjuDY;EACI,cDlDM;AnGymuDtB;;AmGhmuDE;ECNM,c5EuGO;E4ErFP,qBDTU;ECaV,yBDZM;AnGkmuDd;AoGxmuDQ;EACF,c5EkGS;AxBwguDf;AgFznuDQ;EACI,0BAAA;EACA,aAAA;AhF2nuDZ;AgFvnuDY;EACI,0BAAA;AhFynuDhB;AoG1muDQ;EACI,c5E0FG;AxBkhuDf;AoGhmuDI;EASQ,cDtBM;ECwCN,qB5EmDG;E4E/CH,oCAAA;ApGskuDZ;AoGxluDY;EACF,cD1Ba;AnGonuDvB;AgF3ouDQ;EACI,0BAAA;EACA,aAAA;AhF6ouDZ;AgFzouDY;EACI,0BAAA;AhF2ouDhB;AoG1luDY;EACI,cDlCO;AnG8nuDvB;;AmGrnuDE;ECJM,qB5EqFO;E4EjFP,yB5EiFO;AxByiuDf;AoGvnuDI;EASQ,cDQM;ECUN,qB5EmDG;E4E/CH,oCAAA;ApG6luDZ;AoG/muDY;EACF,cDIa;AnG6muDvB;AgFlquDQ;EACI,0BAAA;EACA,aAAA;AhFoquDZ;AgFhquDY;EACI,0BAAA;AhFkquDhB;AoGjnuDY;EACI,cDJO;AnGunuDvB;;AoGzouDI;EASQ,c5EqEG;E4EnDH,qBDOc;ECHd,oCAAA;ApGgnuDZ;AoGlouDY;EACF,c5EgEK;AxBokuDf;AgFrruDQ;EACI,0BAAA;EACA,aAAA;AhFuruDZ;AgFnruDY;EACI,0BAAA;AhFqruDhB;AoGpouDY;EACI,c5EwDD;AxB8kuDf;AmGpnuDI;EACC,gCAAA;AnGsnuDL;;AmGlsuDC;ECUO,cDTE;EC2BF,qB5EqFO;E4EjFP,yB5EiFO;AxBuluDf;AoG1ruDQ;EACF,cDbS;AnGysuDf;AgF3suDQ;EACI,0BAAA;EACA,aAAA;AhF6suDZ;AgFzsuDY;EACI,0BAAA;AhF2suDhB;AoG5ruDQ;EACI,cDrBG;AnGmtuDf;AoGlruDI;EASQ,cDtCK;ECwDL,qBDtDY;EC0DZ,oCAAA;ApGwpuDZ;AoG1quDY;EACF,cD1CY;AnGstuDtB;AgF7tuDQ;EACI,0BAAA;EACA,aAAA;AhF+tuDZ;AgF3tuDY;EACI,0BAAA;AhF6tuDhB;AoG5quDY;EACI,cDlDM;AnGguuDtB;;AmGvtuDE;ECNM,c5EuGO;E4ErFP,qBDTU;ECaV,yBDZM;AnGytuDd;AoG/tuDQ;EACF,c5EkGS;AxB+nuDf;AgFhvuDQ;EACI,0BAAA;EACA,aAAA;AhFkvuDZ;AgF9uuDY;EACI,0BAAA;AhFgvuDhB;AoGjuuDQ;EACI,c5E0FG;AxByouDf;AoGvtuDI;EASQ,cDtBM;ECwCN,qB5EmDG;E4E/CH,oCAAA;ApG6ruDZ;AoG/suDY;EACF,cD1Ba;AnG2uuDvB;AgFlwuDQ;EACI,0BAAA;EACA,aAAA;AhFowuDZ;AgFhwuDY;EACI,0BAAA;AhFkwuDhB;AoGjtuDY;EACI,cDlCO;AnGqvuDvB;;AmG5uuDE;ECJM,qB5EqFO;E4EjFP,yB5EiFO;AxBgquDf;AoG9uuDI;EASQ,cDQM;ECUN,qB5EmDG;E4E/CH,oCAAA;ApGotuDZ;AoGtuuDY;EACF,cDIa;AnGouuDvB;AgFzxuDQ;EACI,0BAAA;EACA,aAAA;AhF2xuDZ;AgFvxuDY;EACI,0BAAA;AhFyxuDhB;AoGxuuDY;EACI,cDJO;AnG8uuDvB;;AoGhwuDI;EASQ,c5EqEG;E4EnDH,qBDOc;ECHd,oCAAA;ApGuuuDZ;AoGzvuDY;EACF,c5EgEK;AxB2ruDf;AgF5yuDQ;EACI,0BAAA;EACA,aAAA;AhF8yuDZ;AgF1yuDY;EACI,0BAAA;AhF4yuDhB;AoG3vuDY;EACI,c5EwDD;AxBqsuDf;AmG3uuDI;EACC,gCAAA;AnG6uuDL;;AmGzzuDC;ECUO,cDTE;EC2BF,qB5EqFO;E4EjFP,yB5EiFO;AxB8suDf;AoGjzuDQ;EACF,cDbS;AnGg0uDf;AgFl0uDQ;EACI,0BAAA;EACA,aAAA;AhFo0uDZ;AgFh0uDY;EACI,0BAAA;AhFk0uDhB;AoGnzuDQ;EACI,cDrBG;AnG00uDf;AoGzyuDI;EASQ,cDtCK;ECwDL,qBDtDY;EC0DZ,oCAAA;ApG+wuDZ;AoGjyuDY;EACF,cD1CY;AnG60uDtB;AgFp1uDQ;EACI,0BAAA;EACA,aAAA;AhFs1uDZ;AgFl1uDY;EACI,0BAAA;AhFo1uDhB;AoGnyuDY;EACI,cDlDM;AnGu1uDtB;;AmG90uDE;ECNM,c5EuGO;E4ErFP,qBDTU;ECaV,yBDZM;AnGg1uDd;AoGt1uDQ;EACF,c5EkGS;AxBsvuDf;AgFv2uDQ;EACI,0BAAA;EACA,aAAA;AhFy2uDZ;AgFr2uDY;EACI,0BAAA;AhFu2uDhB;AoGx1uDQ;EACI,c5E0FG;AxBgwuDf;AoG90uDI;EASQ,cDtBM;ECwCN,qB5EmDG;E4E/CH,oCAAA;ApGozuDZ;AoGt0uDY;EACF,cD1Ba;AnGk2uDvB;AgFz3uDQ;EACI,0BAAA;EACA,aAAA;AhF23uDZ;AgFv3uDY;EACI,0BAAA;AhFy3uDhB;AoGx0uDY;EACI,cDlCO;AnG42uDvB;;AmGn2uDE;ECJM,qB5EqFO;E4EjFP,yB5EiFO;AxBuxuDf;AoGr2uDI;EASQ,cDQM;ECUN,qB5EmDG;E4E/CH,oCAAA;ApG20uDZ;AoG71uDY;EACF,cDIa;AnG21uDvB;AgFh5uDQ;EACI,0BAAA;EACA,aAAA;AhFk5uDZ;AgF94uDY;EACI,0BAAA;AhFg5uDhB;AoG/1uDY;EACI,cDJO;AnGq2uDvB;;AoGv3uDI;EASQ,c5EqEG;E4EnDH,qBDOc;ECHd,oCAAA;ApG81uDZ;AoGh3uDY;EACF,c5EgEK;AxBkzuDf;AgFn6uDQ;EACI,0BAAA;EACA,aAAA;AhFq6uDZ;AgFj6uDY;EACI,0BAAA;AhFm6uDhB;AoGl3uDY;EACI,c5EwDD;AxB4zuDf;AmGl2uDI;EACC,gCAAA;AnGo2uDL;;AmGh7uDC;ECUO,cDTE;EC2BF,qB5EqFO;E4EjFP,yB5EiFO;AxBq0uDf;AoGx6uDQ;EACF,cDbS;AnGu7uDf;AgFz7uDQ;EACI,0BAAA;EACA,aAAA;AhF27uDZ;AgFv7uDY;EACI,0BAAA;AhFy7uDhB;AoG16uDQ;EACI,cDrBG;AnGi8uDf;AoGh6uDI;EASQ,cDtCK;ECwDL,qBDtDY;EC0DZ,oCAAA;ApGs4uDZ;AoGx5uDY;EACF,cD1CY;AnGo8uDtB;AgF38uDQ;EACI,0BAAA;EACA,aAAA;AhF68uDZ;AgFz8uDY;EACI,0BAAA;AhF28uDhB;AoG15uDY;EACI,cDlDM;AnG88uDtB;;AmGr8uDE;ECNM,c5EuGO;E4ErFP,qBDTU;ECaV,yBDZM;AnGu8uDd;AoG78uDQ;EACF,c5EkGS;AxB62uDf;AgF99uDQ;EACI,0BAAA;EACA,aAAA;AhFg+uDZ;AgF59uDY;EACI,0BAAA;AhF89uDhB;AoG/8uDQ;EACI,c5E0FG;AxBu3uDf;AoGr8uDI;EASQ,cDtBM;ECwCN,qB5EmDG;E4E/CH,oCAAA;ApG26uDZ;AoG77uDY;EACF,cD1Ba;AnGy9uDvB;AgFh/uDQ;EACI,0BAAA;EACA,aAAA;AhFk/uDZ;AgF9+uDY;EACI,0BAAA;AhFg/uDhB;AoG/7uDY;EACI,cDlCO;AnGm+uDvB;;AmG19uDE;ECJM,qB5EqFO;E4EjFP,yB5EiFO;AxB84uDf;AoG59uDI;EASQ,cDQM;ECUN,qB5EmDG;E4E/CH,oCAAA;ApGk8uDZ;AoGp9uDY;EACF,cDIa;AnGk9uDvB;AgFvgvDQ;EACI,0BAAA;EACA,aAAA;AhFygvDZ;AgFrgvDY;EACI,0BAAA;AhFugvDhB;AoGt9uDY;EACI,cDJO;AnG49uDvB;;AoG9+uDI;EASQ,c5EqEG;E4EnDH,qBDOc;ECHd,oCAAA;ApGq9uDZ;AoGv+uDY;EACF,c5EgEK;AxBy6uDf;AgF1hvDQ;EACI,0BAAA;EACA,aAAA;AhF4hvDZ;AgFxhvDY;EACI,0BAAA;AhF0hvDhB;AoGz+uDY;EACI,c5EwDD;AxBm7uDf;AmGz9uDI;EACC,gCAAA;AnG29uDL;;AmGvivDC;ECUO,cDTE;EC2BF,qB5EqFO;E4EjFP,yB5EiFO;AxB47uDf;AoG/hvDQ;EACF,cDbS;AnG8ivDf;AgFhjvDQ;EACI,0BAAA;EACA,aAAA;AhFkjvDZ;AgF9ivDY;EACI,0BAAA;AhFgjvDhB;AoGjivDQ;EACI,cDrBG;AnGwjvDf;AoGvhvDI;EASQ,cDtCK;ECwDL,qBDtDY;EC0DZ,oCAAA;ApG6/uDZ;AoG/gvDY;EACF,cD1CY;AnG2jvDtB;AgFlkvDQ;EACI,0BAAA;EACA,aAAA;AhFokvDZ;AgFhkvDY;EACI,0BAAA;AhFkkvDhB;AoGjhvDY;EACI,cDlDM;AnGqkvDtB;;AmG5jvDE;ECNM,c5EuGO;E4ErFP,qBDTU;ECaV,yBDZM;AnG8jvDd;AoGpkvDQ;EACF,c5EkGS;AxBo+uDf;AgFrlvDQ;EACI,0BAAA;EACA,aAAA;AhFulvDZ;AgFnlvDY;EACI,0BAAA;AhFqlvDhB;AoGtkvDQ;EACI,c5E0FG;AxB8+uDf;AoG5jvDI;EASQ,cDtBM;ECwCN,qB5EmDG;E4E/CH,oCAAA;ApGkivDZ;AoGpjvDY;EACF,cD1Ba;AnGglvDvB;AgFvmvDQ;EACI,0BAAA;EACA,aAAA;AhFymvDZ;AgFrmvDY;EACI,0BAAA;AhFumvDhB;AoGtjvDY;EACI,cDlCO;AnG0lvDvB;;AmGjlvDE;ECJM,qB5EqFO;E4EjFP,yB5EiFO;AxBqgvDf;AoGnlvDI;EASQ,cDQM;ECUN,qB5EmDG;E4E/CH,oCAAA;ApGyjvDZ;AoG3kvDY;EACF,cDIa;AnGykvDvB;AgF9nvDQ;EACI,0BAAA;EACA,aAAA;AhFgovDZ;AgF5nvDY;EACI,0BAAA;AhF8nvDhB;AoG7kvDY;EACI,cDJO;AnGmlvDvB;;AoGrmvDI;EASQ,c5EqEG;E4EnDH,qBDOc;ECHd,oCAAA;ApG4kvDZ;AoG9lvDY;EACF,c5EgEK;AxBgivDf;AgFjpvDQ;EACI,0BAAA;EACA,aAAA;AhFmpvDZ;AgF/ovDY;EACI,0BAAA;AhFipvDhB;AoGhmvDY;EACI,c5EwDD;AxB0ivDf;AmGhlvDI;EACC,gCAAA;AnGklvDL;;AmGvkvDE;EC7EM,c5EwJY;AxBggvDpB;AoGppvDQ;EACF,c5EmJc;AxBmgvDpB;AgFrqvDQ;EACI,0BAAA;EACA,aAAA;AhFuqvDZ;AgFnqvDY;EACI,0BAAA;AhFqqvDhB;AoGtpvDQ;EACI,c5E2IQ;AxB6gvDpB;AoG5ovDI;EASQ,c5EsHQ;AxBghvDpB;AoGlovDY;EACF,c5EiHU;AxBmhvDpB;AgFrrvDQ;EACI,0BAAA;EACA,aAAA;AhFurvDZ;AgFnrvDY;EACI,0BAAA;AhFqrvDhB;AoGpovDY;EACI,c5EyGI;AxB6hvDpB;;AoGjrvDQ;EACF,c5EmJc;AxBiivDpB;AgFnsvDQ;EACI,0BAAA;EACA,aAAA;AhFqsvDZ;AgFjsvDY;EACI,0BAAA;AhFmsvDhB;AoGprvDQ;EACI,c5E2IQ;AxB2ivDpB;AoG7pvDY;EACF,c5EiHU;AxB8ivDpB;AgFhtvDQ;EACI,0BAAA;EACA,aAAA;AhFktvDZ;AgF9svDY;EACI,0BAAA;AhFgtvDhB;AoG/pvDY;EACI,c5EyGI;AxBwjvDpB;;AmGvkvDE;ECzIM,c5EwJY;AxB4jvDpB;AoG3rvDI;EASQ,c5EsHQ;AxB+jvDpB;;AmG1ovDE;EC7EM,c5EwJY;AxBmkvDpB;AoGvtvDQ;EACF,c5EmJc;AxBskvDpB;AgFxuvDQ;EACI,0BAAA;EACA,aAAA;AhF0uvDZ;AgFtuvDY;EACI,0BAAA;AhFwuvDhB;AoGztvDQ;EACI,c5E2IQ;AxBglvDpB;AoG/svDI;EASQ,c5EsHQ;AxBmlvDpB;AoGrsvDY;EACF,c5EiHU;AxBslvDpB;AgFxvvDQ;EACI,0BAAA;EACA,aAAA;AhF0vvDZ;AgFtvvDY;EACI,0BAAA;AhFwvvDhB;AoGvsvDY;EACI,c5EyGI;AxBgmvDpB;;AoGpvvDQ;EACF,c5EmJc;AxBomvDpB;AgFtwvDQ;EACI,0BAAA;EACA,aAAA;AhFwwvDZ;AgFpwvDY;EACI,0BAAA;AhFswvDhB;AoGvvvDQ;EACI,c5E2IQ;AxB8mvDpB;AoGhuvDY;EACF,c5EiHU;AxBinvDpB;AgFnxvDQ;EACI,0BAAA;EACA,aAAA;AhFqxvDZ;AgFjxvDY;EACI,0BAAA;AhFmxvDhB;AoGluvDY;EACI,c5EyGI;AxB2nvDpB;;AmG1ovDE;ECzIM,c5EwJY;AxB+nvDpB;AoG9vvDI;EASQ,c5EsHQ;AxBkovDpB;;AmG7svDE;EC7EM,c5EwJY;AxBsovDpB;AoG1xvDQ;EACF,c5EmJc;AxByovDpB;AgF3yvDQ;EACI,0BAAA;EACA,aAAA;AhF6yvDZ;AgFzyvDY;EACI,0BAAA;AhF2yvDhB;AoG5xvDQ;EACI,c5E2IQ;AxBmpvDpB;AoGlxvDI;EASQ,c5EsHQ;AxBspvDpB;AoGxwvDY;EACF,c5EiHU;AxBypvDpB;AgF3zvDQ;EACI,0BAAA;EACA,aAAA;AhF6zvDZ;AgFzzvDY;EACI,0BAAA;AhF2zvDhB;AoG1wvDY;EACI,c5EyGI;AxBmqvDpB;;AoGvzvDQ;EACF,c5EmJc;AxBuqvDpB;AgFz0vDQ;EACI,0BAAA;EACA,aAAA;AhF20vDZ;AgFv0vDY;EACI,0BAAA;AhFy0vDhB;AoG1zvDQ;EACI,c5E2IQ;AxBirvDpB;AoGnyvDY;EACF,c5EiHU;AxBorvDpB;AgFt1vDQ;EACI,0BAAA;EACA,aAAA;AhFw1vDZ;AgFp1vDY;EACI,0BAAA;AhFs1vDhB;AoGryvDY;EACI,c5EyGI;AxB8rvDpB;;AmG7svDE;ECzIM,c5EwJY;AxBksvDpB;AoGj0vDI;EASQ,c5EsHQ;AxBqsvDpB;;AmGhxvDE;EC7EM,c5EwJY;AxBysvDpB;AoG71vDQ;EACF,c5EmJc;AxB4svDpB;AgF92vDQ;EACI,0BAAA;EACA,aAAA;AhFg3vDZ;AgF52vDY;EACI,0BAAA;AhF82vDhB;AoG/1vDQ;EACI,c5E2IQ;AxBstvDpB;AoGr1vDI;EASQ,c5EsHQ;AxBytvDpB;AoG30vDY;EACF,c5EiHU;AxB4tvDpB;AgF93vDQ;EACI,0BAAA;EACA,aAAA;AhFg4vDZ;AgF53vDY;EACI,0BAAA;AhF83vDhB;AoG70vDY;EACI,c5EyGI;AxBsuvDpB;;AoG13vDQ;EACF,c5EmJc;AxB0uvDpB;AgF54vDQ;EACI,0BAAA;EACA,aAAA;AhF84vDZ;AgF14vDY;EACI,0BAAA;AhF44vDhB;AoG73vDQ;EACI,c5E2IQ;AxBovvDpB;AoGt2vDY;EACF,c5EiHU;AxBuvvDpB;AgFz5vDQ;EACI,0BAAA;EACA,aAAA;AhF25vDZ;AgFv5vDY;EACI,0BAAA;AhFy5vDhB;AoGx2vDY;EACI,c5EyGI;AxBiwvDpB;;AmGhxvDE;ECzIM,c5EwJY;AxBqwvDpB;AoGp4vDI;EASQ,c5EsHQ;AxBwwvDpB;;AmGn1vDE;EC7EM,c5EwJY;AxB4wvDpB;AoGh6vDQ;EACF,c5EmJc;AxB+wvDpB;AgFj7vDQ;EACI,0BAAA;EACA,aAAA;AhFm7vDZ;AgF/6vDY;EACI,0BAAA;AhFi7vDhB;AoGl6vDQ;EACI,c5E2IQ;AxByxvDpB;AoGx5vDI;EASQ,c5EsHQ;AxB4xvDpB;AoG94vDY;EACF,c5EiHU;AxB+xvDpB;AgFj8vDQ;EACI,0BAAA;EACA,aAAA;AhFm8vDZ;AgF/7vDY;EACI,0BAAA;AhFi8vDhB;AoGh5vDY;EACI,c5EyGI;AxByyvDpB;;AoG77vDQ;EACF,c5EmJc;AxB6yvDpB;AgF/8vDQ;EACI,0BAAA;EACA,aAAA;AhFi9vDZ;AgF78vDY;EACI,0BAAA;AhF+8vDhB;AoGh8vDQ;EACI,c5E2IQ;AxBuzvDpB;AoGz6vDY;EACF,c5EiHU;AxB0zvDpB;AgF59vDQ;EACI,0BAAA;EACA,aAAA;AhF89vDZ;AgF19vDY;EACI,0BAAA;AhF49vDhB;AoG36vDY;EACI,c5EyGI;AxBo0vDpB;;AmGn1vDE;ECzIM,c5EwJY;AxBw0vDpB;AoGv8vDI;EASQ,c5EsHQ;AxB20vDpB;;AmGt5vDE;EC7EM,c5EwJY;AxB+0vDpB;AoGn+vDQ;EACF,c5EmJc;AxBk1vDpB;AgFp/vDQ;EACI,0BAAA;EACA,aAAA;AhFs/vDZ;AgFl/vDY;EACI,0BAAA;AhFo/vDhB;AoGr+vDQ;EACI,c5E2IQ;AxB41vDpB;AoG39vDI;EASQ,c5EsHQ;AxB+1vDpB;AoGj9vDY;EACF,c5EiHU;AxBk2vDpB;AgFpgwDQ;EACI,0BAAA;EACA,aAAA;AhFsgwDZ;AgFlgwDY;EACI,0BAAA;AhFogwDhB;AoGn9vDY;EACI,c5EyGI;AxB42vDpB;;AoGhgwDQ;EACF,c5EmJc;AxBg3vDpB;AgFlhwDQ;EACI,0BAAA;EACA,aAAA;AhFohwDZ;AgFhhwDY;EACI,0BAAA;AhFkhwDhB;AoGngwDQ;EACI,c5E2IQ;AxB03vDpB;AoG5+vDY;EACF,c5EiHU;AxB63vDpB;AgF/hwDQ;EACI,0BAAA;EACA,aAAA;AhFiiwDZ;AgF7hwDY;EACI,0BAAA;AhF+hwDhB;AoG9+vDY;EACI,c5EyGI;AxBu4vDpB;;AmGt5vDE;ECzIM,c5EwJY;AxB24vDpB;AoG1gwDI;EASQ,c5EsHQ;AxB84vDpB;;AmGz9vDE;EC7EM,c5EwJY;AxBk5vDpB;AoGtiwDQ;EACF,c5EmJc;AxBq5vDpB;AgFvjwDQ;EACI,0BAAA;EACA,aAAA;AhFyjwDZ;AgFrjwDY;EACI,0BAAA;AhFujwDhB;AoGxiwDQ;EACI,c5E2IQ;AxB+5vDpB;AoG9hwDI;EASQ,c5EsHQ;AxBk6vDpB;AoGphwDY;EACF,c5EiHU;AxBq6vDpB;AgFvkwDQ;EACI,0BAAA;EACA,aAAA;AhFykwDZ;AgFrkwDY;EACI,0BAAA;AhFukwDhB;AoGthwDY;EACI,c5EyGI;AxB+6vDpB;;AoGnkwDQ;EACF,c5EmJc;AxBm7vDpB;AgFrlwDQ;EACI,0BAAA;EACA,aAAA;AhFulwDZ;AgFnlwDY;EACI,0BAAA;AhFqlwDhB;AoGtkwDQ;EACI,c5E2IQ;AxB67vDpB;AoG/iwDY;EACF,c5EiHU;AxBg8vDpB;AgFlmwDQ;EACI,0BAAA;EACA,aAAA;AhFomwDZ;AgFhmwDY;EACI,0BAAA;AhFkmwDhB;AoGjjwDY;EACI,c5EyGI;AxB08vDpB;;AmGz9vDE;ECzIM,c5EwJY;AxB88vDpB;AoG7kwDI;EASQ,c5EsHQ;AxBi9vDpB;;AmG5hwDE;EC7EM,c5EwJY;AxBq9vDpB;AoGzmwDQ;EACF,c5EmJc;AxBw9vDpB;AgF1nwDQ;EACI,0BAAA;EACA,aAAA;AhF4nwDZ;AgFxnwDY;EACI,0BAAA;AhF0nwDhB;AoG3mwDQ;EACI,c5E2IQ;AxBk+vDpB;AoGjmwDI;EASQ,c5EsHQ;AxBq+vDpB;AoGvlwDY;EACF,c5EiHU;AxBw+vDpB;AgF1owDQ;EACI,0BAAA;EACA,aAAA;AhF4owDZ;AgFxowDY;EACI,0BAAA;AhF0owDhB;AoGzlwDY;EACI,c5EyGI;AxBk/vDpB;;AoGtowDQ;EACF,c5EmJc;AxBs/vDpB;AgFxpwDQ;EACI,0BAAA;EACA,aAAA;AhF0pwDZ;AgFtpwDY;EACI,0BAAA;AhFwpwDhB;AoGzowDQ;EACI,c5E2IQ;AxBggwDpB;AoGlnwDY;EACF,c5EiHU;AxBmgwDpB;AgFrqwDQ;EACI,0BAAA;EACA,aAAA;AhFuqwDZ;AgFnqwDY;EACI,0BAAA;AhFqqwDhB;AoGpnwDY;EACI,c5EyGI;AxB6gwDpB;;AmG5hwDE;ECzIM,c5EwJY;AxBihwDpB;AoGhpwDI;EASQ,c5EsHQ;AxBohwDpB;;AmG/lwDE;EC7EM,c5EwJY;AxBwhwDpB;AoG5qwDQ;EACF,c5EmJc;AxB2hwDpB;AgF7rwDQ;EACI,0BAAA;EACA,aAAA;AhF+rwDZ;AgF3rwDY;EACI,0BAAA;AhF6rwDhB;AoG9qwDQ;EACI,c5E2IQ;AxBqiwDpB;AoGpqwDI;EASQ,c5EsHQ;AxBwiwDpB;AoG1pwDY;EACF,c5EiHU;AxB2iwDpB;AgF7swDQ;EACI,0BAAA;EACA,aAAA;AhF+swDZ;AgF3swDY;EACI,0BAAA;AhF6swDhB;AoG5pwDY;EACI,c5EyGI;AxBqjwDpB;;AoGzswDQ;EACF,c5EmJc;AxByjwDpB;AgF3twDQ;EACI,0BAAA;EACA,aAAA;AhF6twDZ;AgFztwDY;EACI,0BAAA;AhF2twDhB;AoG5swDQ;EACI,c5E2IQ;AxBmkwDpB;AoGrrwDY;EACF,c5EiHU;AxBskwDpB;AgFxuwDQ;EACI,0BAAA;EACA,aAAA;AhF0uwDZ;AgFtuwDY;EACI,0BAAA;AhFwuwDhB;AoGvrwDY;EACI,c5EyGI;AxBglwDpB;;AmG/lwDE;ECzIM,c5EwJY;AxBolwDpB;AoGntwDI;EASQ,c5EsHQ;AxBulwDpB;;AmGlqwDE;EC7EM,c5EwJY;AxB2lwDpB;AoG/uwDQ;EACF,c5EmJc;AxB8lwDpB;AgFhwwDQ;EACI,0BAAA;EACA,aAAA;AhFkwwDZ;AgF9vwDY;EACI,0BAAA;AhFgwwDhB;AoGjvwDQ;EACI,c5E2IQ;AxBwmwDpB;AoGvuwDI;EASQ,c5EsHQ;AxB2mwDpB;AoG7twDY;EACF,c5EiHU;AxB8mwDpB;AgFhxwDQ;EACI,0BAAA;EACA,aAAA;AhFkxwDZ;AgF9wwDY;EACI,0BAAA;AhFgxwDhB;AoG/twDY;EACI,c5EyGI;AxBwnwDpB;;AoG5wwDQ;EACF,c5EmJc;AxB4nwDpB;AgF9xwDQ;EACI,0BAAA;EACA,aAAA;AhFgywDZ;AgF5xwDY;EACI,0BAAA;AhF8xwDhB;AoG/wwDQ;EACI,c5E2IQ;AxBsowDpB;AoGxvwDY;EACF,c5EiHU;AxByowDpB;AgF3ywDQ;EACI,0BAAA;EACA,aAAA;AhF6ywDZ;AgFzywDY;EACI,0BAAA;AhF2ywDhB;AoG1vwDY;EACI,c5EyGI;AxBmpwDpB;;AmGlqwDE;ECzIM,c5EwJY;AxBupwDpB;AoGtxwDI;EASQ,c5EsHQ;AxB0pwDpB;;AmGruwDE;EC7EM,c5EwJY;AxB8pwDpB;AoGlzwDQ;EACF,c5EmJc;AxBiqwDpB;AgFn0wDQ;EACI,0BAAA;EACA,aAAA;AhFq0wDZ;AgFj0wDY;EACI,0BAAA;AhFm0wDhB;AoGpzwDQ;EACI,c5E2IQ;AxB2qwDpB;AoG1ywDI;EASQ,c5EsHQ;AxB8qwDpB;AoGhywDY;EACF,c5EiHU;AxBirwDpB;AgFn1wDQ;EACI,0BAAA;EACA,aAAA;AhFq1wDZ;AgFj1wDY;EACI,0BAAA;AhFm1wDhB;AoGlywDY;EACI,c5EyGI;AxB2rwDpB;;AoG/0wDQ;EACF,c5EmJc;AxB+rwDpB;AgFj2wDQ;EACI,0BAAA;EACA,aAAA;AhFm2wDZ;AgF/1wDY;EACI,0BAAA;AhFi2wDhB;AoGl1wDQ;EACI,c5E2IQ;AxByswDpB;AoG3zwDY;EACF,c5EiHU;AxB4swDpB;AgF92wDQ;EACI,0BAAA;EACA,aAAA;AhFg3wDZ;AgF52wDY;EACI,0BAAA;AhF82wDhB;AoG7zwDY;EACI,c5EyGI;AxBstwDpB;;AmGruwDE;ECzIM,c5EwJY;AxB0twDpB;AoGz1wDI;EASQ,c5EsHQ;AxB6twDpB;;AmGxywDE;EC7EM,c5EwJY;AxBiuwDpB;AoGr3wDQ;EACF,c5EmJc;AxBouwDpB;AgFt4wDQ;EACI,0BAAA;EACA,aAAA;AhFw4wDZ;AgFp4wDY;EACI,0BAAA;AhFs4wDhB;AoGv3wDQ;EACI,c5E2IQ;AxB8uwDpB;AoG72wDI;EASQ,c5EsHQ;AxBivwDpB;AoGn2wDY;EACF,c5EiHU;AxBovwDpB;AgFt5wDQ;EACI,0BAAA;EACA,aAAA;AhFw5wDZ;AgFp5wDY;EACI,0BAAA;AhFs5wDhB;AoGr2wDY;EACI,c5EyGI;AxB8vwDpB;;AoGl5wDQ;EACF,c5EmJc;AxBkwwDpB;AgFp6wDQ;EACI,0BAAA;EACA,aAAA;AhFs6wDZ;AgFl6wDY;EACI,0BAAA;AhFo6wDhB;AoGr5wDQ;EACI,c5E2IQ;AxB4wwDpB;AoG93wDY;EACF,c5EiHU;AxB+wwDpB;AgFj7wDQ;EACI,0BAAA;EACA,aAAA;AhFm7wDZ;AgF/6wDY;EACI,0BAAA;AhFi7wDhB;AoGh4wDY;EACI,c5EyGI;AxByxwDpB;;AmGxywDE;ECzIM,c5EwJY;AxB6xwDpB;AoG55wDI;EASQ,c5EsHQ;AxBgywDpB;;AmG32wDE;EC7EM,c5EwJY;AxBoywDpB;AoGx7wDQ;EACF,c5EmJc;AxBuywDpB;AgFz8wDQ;EACI,0BAAA;EACA,aAAA;AhF28wDZ;AgFv8wDY;EACI,0BAAA;AhFy8wDhB;AoG17wDQ;EACI,c5E2IQ;AxBizwDpB;AoGh7wDI;EASQ,c5EsHQ;AxBozwDpB;AoGt6wDY;EACF,c5EiHU;AxBuzwDpB;AgFz9wDQ;EACI,0BAAA;EACA,aAAA;AhF29wDZ;AgFv9wDY;EACI,0BAAA;AhFy9wDhB;AoGx6wDY;EACI,c5EyGI;AxBi0wDpB;;AoGr9wDQ;EACF,c5EmJc;AxBq0wDpB;AgFv+wDQ;EACI,0BAAA;EACA,aAAA;AhFy+wDZ;AgFr+wDY;EACI,0BAAA;AhFu+wDhB;AoGx9wDQ;EACI,c5E2IQ;AxB+0wDpB;AoGj8wDY;EACF,c5EiHU;AxBk1wDpB;AgFp/wDQ;EACI,0BAAA;EACA,aAAA;AhFs/wDZ;AgFl/wDY;EACI,0BAAA;AhFo/wDhB;AoGn8wDY;EACI,c5EyGI;AxB41wDpB;;AmG32wDE;ECzIM,c5EwJY;AxBg2wDpB;AoG/9wDI;EASQ,c5EsHQ;AxBm2wDpB;;AmG96wDE;EC7EM,c5EwJY;AxBu2wDpB;AoG3/wDQ;EACF,c5EmJc;AxB02wDpB;AgF5gxDQ;EACI,0BAAA;EACA,aAAA;AhF8gxDZ;AgF1gxDY;EACI,0BAAA;AhF4gxDhB;AoG7/wDQ;EACI,c5E2IQ;AxBo3wDpB;AoGn/wDI;EASQ,c5EsHQ;AxBu3wDpB;AoGz+wDY;EACF,c5EiHU;AxB03wDpB;AgF5hxDQ;EACI,0BAAA;EACA,aAAA;AhF8hxDZ;AgF1hxDY;EACI,0BAAA;AhF4hxDhB;AoG3+wDY;EACI,c5EyGI;AxBo4wDpB;;AoGxhxDQ;EACF,c5EmJc;AxBw4wDpB;AgF1ixDQ;EACI,0BAAA;EACA,aAAA;AhF4ixDZ;AgFxixDY;EACI,0BAAA;AhF0ixDhB;AoG3hxDQ;EACI,c5E2IQ;AxBk5wDpB;AoGpgxDY;EACF,c5EiHU;AxBq5wDpB;AgFvjxDQ;EACI,0BAAA;EACA,aAAA;AhFyjxDZ;AgFrjxDY;EACI,0BAAA;AhFujxDhB;AoGtgxDY;EACI,c5EyGI;AxB+5wDpB;;AmG96wDE;ECzIM,c5EwJY;AxBm6wDpB;AoGlixDI;EASQ,c5EsHQ;AxBs6wDpB;;AmGj/wDE;EC7EM,c5EwJY;AxB06wDpB;AoG9jxDQ;EACF,c5EmJc;AxB66wDpB;AgF/kxDQ;EACI,0BAAA;EACA,aAAA;AhFilxDZ;AgF7kxDY;EACI,0BAAA;AhF+kxDhB;AoGhkxDQ;EACI,c5E2IQ;AxBu7wDpB;AoGtjxDI;EASQ,c5EsHQ;AxB07wDpB;AoG5ixDY;EACF,c5EiHU;AxB67wDpB;AgF/lxDQ;EACI,0BAAA;EACA,aAAA;AhFimxDZ;AgF7lxDY;EACI,0BAAA;AhF+lxDhB;AoG9ixDY;EACI,c5EyGI;AxBu8wDpB;;AoG3lxDQ;EACF,c5EmJc;AxB28wDpB;AgF7mxDQ;EACI,0BAAA;EACA,aAAA;AhF+mxDZ;AgF3mxDY;EACI,0BAAA;AhF6mxDhB;AoG9lxDQ;EACI,c5E2IQ;AxBq9wDpB;AoGvkxDY;EACF,c5EiHU;AxBw9wDpB;AgF1nxDQ;EACI,0BAAA;EACA,aAAA;AhF4nxDZ;AgFxnxDY;EACI,0BAAA;AhF0nxDhB;AoGzkxDY;EACI,c5EyGI;AxBk+wDpB;;AmGj/wDE;ECzIM,c5EwJY;AxBs+wDpB;AoGrmxDI;EASQ,c5EsHQ;AxBy+wDpB;;AmGpjxDE;EC7EM,c5EwJY;AxB6+wDpB;AoGjoxDQ;EACF,c5EmJc;AxBg/wDpB;AgFlpxDQ;EACI,0BAAA;EACA,aAAA;AhFopxDZ;AgFhpxDY;EACI,0BAAA;AhFkpxDhB;AoGnoxDQ;EACI,c5E2IQ;AxB0/wDpB;AoGznxDI;EASQ,c5EsHQ;AxB6/wDpB;AoG/mxDY;EACF,c5EiHU;AxBggxDpB;AgFlqxDQ;EACI,0BAAA;EACA,aAAA;AhFoqxDZ;AgFhqxDY;EACI,0BAAA;AhFkqxDhB;AoGjnxDY;EACI,c5EyGI;AxB0gxDpB;;AoG9pxDQ;EACF,c5EmJc;AxB8gxDpB;AgFhrxDQ;EACI,0BAAA;EACA,aAAA;AhFkrxDZ;AgF9qxDY;EACI,0BAAA;AhFgrxDhB;AoGjqxDQ;EACI,c5E2IQ;AxBwhxDpB;AoG1oxDY;EACF,c5EiHU;AxB2hxDpB;AgF7rxDQ;EACI,0BAAA;EACA,aAAA;AhF+rxDZ;AgF3rxDY;EACI,0BAAA;AhF6rxDhB;AoG5oxDY;EACI,c5EyGI;AxBqixDpB;;AmGpjxDE;ECzIM,c5EwJY;AxByixDpB;AoGxqxDI;EASQ,c5EsHQ;AxB4ixDpB;;AmGvnxDE;EC7EM,c5EwJY;AxBgjxDpB;AoGpsxDQ;EACF,c5EmJc;AxBmjxDpB;AgFrtxDQ;EACI,0BAAA;EACA,aAAA;AhFutxDZ;AgFntxDY;EACI,0BAAA;AhFqtxDhB;AoGtsxDQ;EACI,c5E2IQ;AxB6jxDpB;AoG5rxDI;EASQ,c5EsHQ;AxBgkxDpB;AoGlrxDY;EACF,c5EiHU;AxBmkxDpB;AgFruxDQ;EACI,0BAAA;EACA,aAAA;AhFuuxDZ;AgFnuxDY;EACI,0BAAA;AhFquxDhB;AoGprxDY;EACI,c5EyGI;AxB6kxDpB;;AoGjuxDQ;EACF,c5EmJc;AxBilxDpB;AgFnvxDQ;EACI,0BAAA;EACA,aAAA;AhFqvxDZ;AgFjvxDY;EACI,0BAAA;AhFmvxDhB;AoGpuxDQ;EACI,c5E2IQ;AxB2lxDpB;AoG7sxDY;EACF,c5EiHU;AxB8lxDpB;AgFhwxDQ;EACI,0BAAA;EACA,aAAA;AhFkwxDZ;AgF9vxDY;EACI,0BAAA;AhFgwxDhB;AoG/sxDY;EACI,c5EyGI;AxBwmxDpB;;AmGvnxDE;ECzIM,c5EwJY;AxB4mxDpB;AoG3uxDI;EASQ,c5EsHQ;AxB+mxDpB;;AmG1rxDE;EC7EM,c5EwJY;AxBmnxDpB;AoGvwxDQ;EACF,c5EmJc;AxBsnxDpB;AgFxxxDQ;EACI,0BAAA;EACA,aAAA;AhF0xxDZ;AgFtxxDY;EACI,0BAAA;AhFwxxDhB;AoGzwxDQ;EACI,c5E2IQ;AxBgoxDpB;AoG/vxDI;EASQ,c5EsHQ;AxBmoxDpB;AoGrvxDY;EACF,c5EiHU;AxBsoxDpB;AgFxyxDQ;EACI,0BAAA;EACA,aAAA;AhF0yxDZ;AgFtyxDY;EACI,0BAAA;AhFwyxDhB;AoGvvxDY;EACI,c5EyGI;AxBgpxDpB;;AoGpyxDQ;EACF,c5EmJc;AxBopxDpB;AgFtzxDQ;EACI,0BAAA;EACA,aAAA;AhFwzxDZ;AgFpzxDY;EACI,0BAAA;AhFszxDhB;AoGvyxDQ;EACI,c5E2IQ;AxB8pxDpB;AoGhxxDY;EACF,c5EiHU;AxBiqxDpB;AgFn0xDQ;EACI,0BAAA;EACA,aAAA;AhFq0xDZ;AgFj0xDY;EACI,0BAAA;AhFm0xDhB;AoGlxxDY;EACI,c5EyGI;AxB2qxDpB;;AmG1rxDE;ECzIM,c5EwJY;AxB+qxDpB;AoG9yxDI;EASQ,c5EsHQ;AxBkrxDpB;;AmG7vxDE;EC7EM,c5EwJY;AxBsrxDpB;AoG10xDQ;EACF,c5EmJc;AxByrxDpB;AgF31xDQ;EACI,0BAAA;EACA,aAAA;AhF61xDZ;AgFz1xDY;EACI,0BAAA;AhF21xDhB;AoG50xDQ;EACI,c5E2IQ;AxBmsxDpB;AoGl0xDI;EASQ,c5EsHQ;AxBssxDpB;AoGxzxDY;EACF,c5EiHU;AxBysxDpB;AgF32xDQ;EACI,0BAAA;EACA,aAAA;AhF62xDZ;AgFz2xDY;EACI,0BAAA;AhF22xDhB;AoG1zxDY;EACI,c5EyGI;AxBmtxDpB;;AoGv2xDQ;EACF,c5EmJc;AxButxDpB;AgFz3xDQ;EACI,0BAAA;EACA,aAAA;AhF23xDZ;AgFv3xDY;EACI,0BAAA;AhFy3xDhB;AoG12xDQ;EACI,c5E2IQ;AxBiuxDpB;AoGn1xDY;EACF,c5EiHU;AxBouxDpB;AgFt4xDQ;EACI,0BAAA;EACA,aAAA;AhFw4xDZ;AgFp4xDY;EACI,0BAAA;AhFs4xDhB;AoGr1xDY;EACI,c5EyGI;AxB8uxDpB;;AmG7vxDE;ECzIM,c5EwJY;AxBkvxDpB;AoGj3xDI;EASQ,c5EsHQ;AxBqvxDpB;;AmGluxDC;EC3KO,cD4KE;EC1JF,qBD4JS;ECxJT,yBDyJK;AnGouxDb;AoG/4xDQ;EACF,cDwKS;AnGyuxDf;AgFh6xDQ;EACI,0BAAA;EACA,aAAA;AhFk6xDZ;AgF95xDY;EACI,0BAAA;AhFg6xDhB;AoGj5xDQ;EACI,cDgKG;AnGmvxDf;AoGv4xDI;EA2BQ,qBD+HY;EC3HZ,oCAAA;ApG42xDZ;;AmG1uxDC;EC1LO,cD2LE;ECzKF,oCD4KS;ECxKT,wCDuKK;AnG6uxDb;AoGt6xDQ;EACF,cDuLS;AnGivxDf;AgFv7xDQ;EACI,0BAAA;EACA,aAAA;AhFy7xDZ;AgFr7xDY;EACI,0BAAA;AhFu7xDhB;AoGx6xDQ;EACI,cD+KG;AnG2vxDf;AoG95xDI;EASQ,cD8JK;EC5IL,qBD+IY;EC3IZ,oCAAA;ApGo4xDZ;AoGt5xDY;EACF,cD0JY;AnG8vxDtB;AgFz8xDQ;EACI,0BAAA;EACA,aAAA;AhF28xDZ;AgFv8xDY;EACI,0BAAA;AhFy8xDhB;AoGx5xDY;EACI,cDkJM;AnGwwxDtB;;AmG9xxDC;EC3KO,cD4KE;EC1JF,qBD4JS;ECxJT,yBDyJK;AnGgyxDb;AoG38xDQ;EACF,cDwKS;AnGqyxDf;AgF59xDQ;EACI,0BAAA;EACA,aAAA;AhF89xDZ;AgF19xDY;EACI,0BAAA;AhF49xDhB;AoG78xDQ;EACI,cDgKG;AnG+yxDf;AoGn8xDI;EA2BQ,qBD+HY;EC3HZ,oCAAA;ApGw6xDZ;;AmGtyxDC;EC1LO,cD2LE;ECzKF,oCD4KS;ECxKT,wCDuKK;AnGyyxDb;AoGl+xDQ;EACF,cDuLS;AnG6yxDf;AgFn/xDQ;EACI,0BAAA;EACA,aAAA;AhFq/xDZ;AgFj/xDY;EACI,0BAAA;AhFm/xDhB;AoGp+xDQ;EACI,cD+KG;AnGuzxDf;AoG19xDI;EASQ,cD8JK;EC5IL,qBD+IY;EC3IZ,oCAAA;ApGg8xDZ;AoGl9xDY;EACF,cD0JY;AnG0zxDtB;AgFrgyDQ;EACI,0BAAA;EACA,aAAA;AhFugyDZ;AgFngyDY;EACI,0BAAA;AhFqgyDhB;AoGp9xDY;EACI,cDkJM;AnGo0xDtB;;AmG11xDC;EC3KO,cD4KE;EC1JF,qBD4JS;ECxJT,yBDyJK;AnG41xDb;AoGvgyDQ;EACF,cDwKS;AnGi2xDf;AgFxhyDQ;EACI,0BAAA;EACA,aAAA;AhF0hyDZ;AgFthyDY;EACI,0BAAA;AhFwhyDhB;AoGzgyDQ;EACI,cDgKG;AnG22xDf;AoG//xDI;EA2BQ,qBD+HY;EC3HZ,oCAAA;ApGo+xDZ;;AmGl2xDC;EC1LO,cD2LE;ECzKF,qCD4KS;ECxKT,yCDuKK;AnGq2xDb;AoG9hyDQ;EACF,cDuLS;AnGy2xDf;AgF/iyDQ;EACI,0BAAA;EACA,aAAA;AhFijyDZ;AgF7iyDY;EACI,0BAAA;AhF+iyDhB;AoGhiyDQ;EACI,cD+KG;AnGm3xDf;AoGthyDI;EASQ,cD8JK;EC5IL,qBD+IY;EC3IZ,oCAAA;ApG4/xDZ;AoG9gyDY;EACF,cD0JY;AnGs3xDtB;AgFjkyDQ;EACI,0BAAA;EACA,aAAA;AhFmkyDZ;AgF/jyDY;EACI,0BAAA;AhFikyDhB;AoGhhyDY;EACI,cDkJM;AnGg4xDtB;;AmGt5xDC;EC3KO,cD4KE;EC1JF,qBD4JS;ECxJT,yBDyJK;AnGw5xDb;AoGnkyDQ;EACF,cDwKS;AnG65xDf;AgFplyDQ;EACI,0BAAA;EACA,aAAA;AhFslyDZ;AgFllyDY;EACI,0BAAA;AhFolyDhB;AoGrkyDQ;EACI,cDgKG;AnGu6xDf;AoG3jyDI;EA2BQ,qBD+HY;EC3HZ,oCAAA;ApGgiyDZ;;AmG95xDC;EC1LO,cD2LE;ECzKF,qCD4KS;ECxKT,yCDuKK;AnGi6xDb;AoG1lyDQ;EACF,cDuLS;AnGq6xDf;AgF3myDQ;EACI,0BAAA;EACA,aAAA;AhF6myDZ;AgFzmyDY;EACI,0BAAA;AhF2myDhB;AoG5lyDQ;EACI,cD+KG;AnG+6xDf;AoGllyDI;EASQ,cD8JK;EC5IL,qBD+IY;EC3IZ,oCAAA;ApGwjyDZ;AoG1kyDY;EACF,cD0JY;AnGk7xDtB;AgF7nyDQ;EACI,0BAAA;EACA,aAAA;AhF+nyDZ;AgF3nyDY;EACI,0BAAA;AhF6nyDhB;AoG5kyDY;EACI,cDkJM;AnG47xDtB;;AmGl9xDC;EC3KO,cD4KE;EC1JF,qBD4JS;ECxJT,yBDyJK;AnGo9xDb;AoG/nyDQ;EACF,cDwKS;AnGy9xDf;AgFhpyDQ;EACI,0BAAA;EACA,aAAA;AhFkpyDZ;AgF9oyDY;EACI,0BAAA;AhFgpyDhB;AoGjoyDQ;EACI,cDgKG;AnGm+xDf;AoGvnyDI;EA2BQ,qBD+HY;EC3HZ,oCAAA;ApG4lyDZ;;AmG19xDC;EC1LO,cD2LE;ECzKF,kCD4KS;ECxKT,sCDuKK;AnG69xDb;AoGtpyDQ;EACF,cDuLS;AnGi+xDf;AgFvqyDQ;EACI,0BAAA;EACA,aAAA;AhFyqyDZ;AgFrqyDY;EACI,0BAAA;AhFuqyDhB;AoGxpyDQ;EACI,cD+KG;AnG2+xDf;AoG9oyDI;EASQ,cD8JK;EC5IL,qBD+IY;EC3IZ,oCAAA;ApGonyDZ;AoGtoyDY;EACF,cD0JY;AnG8+xDtB;AgFzryDQ;EACI,0BAAA;EACA,aAAA;AhF2ryDZ;AgFvryDY;EACI,0BAAA;AhFyryDhB;AoGxoyDY;EACI,cDkJM;AnGw/xDtB;;AmG9gyDC;EC3KO,cD4KE;EC1JF,qBD4JS;ECxJT,yBDyJK;AnGghyDb;AoG3ryDQ;EACF,cDwKS;AnGqhyDf;AgF5syDQ;EACI,0BAAA;EACA,aAAA;AhF8syDZ;AgF1syDY;EACI,0BAAA;AhF4syDhB;AoG7ryDQ;EACI,cDgKG;AnG+hyDf;AoGnryDI;EA2BQ,qBD+HY;EC3HZ,oCAAA;ApGwpyDZ;;AmGthyDC;EC1LO,cD2LE;ECzKF,oCD4KS;ECxKT,wCDuKK;AnGyhyDb;AoGltyDQ;EACF,cDuLS;AnG6hyDf;AgFnuyDQ;EACI,0BAAA;EACA,aAAA;AhFquyDZ;AgFjuyDY;EACI,0BAAA;AhFmuyDhB;AoGptyDQ;EACI,cD+KG;AnGuiyDf;AoG1syDI;EASQ,cD8JK;EC5IL,qBD+IY;EC3IZ,oCAAA;ApGgryDZ;AoGlsyDY;EACF,cD0JY;AnG0iyDtB;AgFrvyDQ;EACI,0BAAA;EACA,aAAA;AhFuvyDZ;AgFnvyDY;EACI,0BAAA;AhFqvyDhB;AoGpsyDY;EACI,cDkJM;AnGojyDtB;;AmG3iyDA;EACC,iBAAA;EACA,oBAAA;AnG8iyDD;AoGjuyDI;EA2BQ,qBzD7Da;A3CswyDzB;;AmGjiyDA;EACC,iBAAA;EACA,oBAAA;EC9NO,c5EqEoB;E4EnDpB,qB5EzBiB;AxB2wyDzB;AoGhwyDQ;EACF,c5EgEsB;AxBksyD5B;AgFjxyDQ;EACI,0BAAA;EACA,aAAA;AhFmxyDZ;AgF/wyDY;EACI,0BAAA;AhFixyDhB;AoGlwyDQ;EACI,c5EwDgB;AxB4syD5B;AoGxvyDI;EASQ,czD3Ca;EyD6Db,qBzD7Da;EyDiEb,oCAAA;ApG8tyDZ;AoGhvyDY;EACF,czDhDe;A3CkyyDzB;AgFnyyDQ;EACI,0BAAA;EACA,aAAA;AhFqyyDZ;AgFjyyDY;EACI,0BAAA;AhFmyyDhB;AoGlvyDY;EACI,czDxDS;A3C4yyDzB;;AqGhzyDA;EACI,gB7E61BgD;E6E51BhD,c7E81BgD;E6E71BhD,oBAAA;EACA,kBAAA;EACA,yB7Eq1BgD;E6Ep1BhD,sB7Es1BgD;E6Er1BhD,gB7Es1BgD;E6Er1BhD,2C7Em1BgD;EC50BhD,qBAAA;AzB6yyDJ;;AsG1zyDA;EACC,2BAAA;AtG6zyDD;AsG1zyDC;EACC,c9EKuB;E8EJvB,yB9E4OkD;E8E3O7C,qB9EFkB;AxB8zyDzB;AsGxzyDC;EACC,yB9EsOkD;AxBolyDpD;AsGtzyDC;EACC,yB9EfuB;E8EgBvB,qB9EhBuB;E8EkBvB,c9EZuB;E8EavB,uD9EsTkD;AxBigyDpD;AuG50yDI;EACI,c/EKiB;AxBy0yDzB;AuG10yDI;EACI,cAAA;EACA,UAAA;AvG40yDR;AsG5zyDE;EAKC,yB9EqiBiD;E8EpiBjD,qB9EoiBiD;E8EniBjD,c9EtBsB;E8EuBtB,uD9E4SiD;AxB8gyDpD;AsGrzyDC;EACC,6BAAA;EACA,yBAAA;AtGuzyDF;AsGrzyDE;EAKC,6BAAA;EACA,yBAAA;AtGmzyDH;AsG9yyDC;EJxCA,SAAA;EACA,6BAAA;EACG,wBAAA;EACH,gBAAA;EACG,gBAAA;AlGy1yDJ;;AuGx2yDI;EACI,c/EKiB;AxBs2yDzB;;AuG52yDI;EACI,c/EDc;AxBo3yDtB;AuG/2yDI;EACI,c/ENc;E+EOd,UAAA;AvGi3yDR;;AsGtzyDA;EACC,YAAA;AtGyzyDD;;AwG93yDA;EACI,2BAAA;AxGi4yDJ;AwG93yDC;EAEC,yBhFFuB;EgFGvB,qBhFHuB;EgFIvB,chFEuB;EgFDvB,uDhFoUkD;AxB2jyDpD;AuGt4yDI;EACI,c/EKiB;AxBm4yDzB;AuGp4yDI;EACI,cAAA;EACA,UAAA;AvGs4yDR;AwGp4yDE;EAKC,yBhFmjBiD;EgFljBjD,gCAAA;EACA,chFRsB;EgFStB,uDhF0TiD;AxBwkyDpD;AwG73yDC;EAEC,6BAAA;EACA,yBAAA;EACA,chFhBuB;AxB84yDzB;AuGx5yDI;EACI,c/EKiB;AxBq5yDzB;AuGt5yDI;EACI,cAAA;EACA,UAAA;AvGw5yDR;AwGn4yDE;EAKC,6BAAA;EACA,oCAAA;EACA,chFzBsB;AxB05yDzB;;AyGp6yDI;EACI,eAAA;AzGu6yDR;AyGn6yDI;EACI,eAAA;EAGA,gBAAA;AzGq6yDR;AyGj6yDI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AzGm6yDR;AyGj6yDQ;EACI,SAAA;EACA,WAAA;EACA,cAAA;AzGm6yDZ;AyGh6yDQ;EACI,oBAAA;AzGk6yDZ;AyG55yDY;EACI,wBjFujBoC;AxBu2xDpD;AyGv5yDQ;EACI,SAAA;EACA,yBjFvCa;AxBg8yDzB;AyGv5yDY;EAEI,YAAA;EACA,yBjF5CS;AxBo8yDzB;AyGr5yDY;EACI,yB9DjDS;A3Cw8yDzB;AyG/4yDY;EACI,yB9DpDS;A3Cq8yDzB;AyGz4yDY;EACI,yB9DjDY;A3C47yD5B;AyGn4yDY;EACI,yB9DpDS;A3Cy7yDzB;;AyG53yDQ;EACI,cjF8fwC;EiF7fxC,ajF6fwC;AxBk4xDpD;AyG13yDQ;EACI,ejFwfwC;EiFvfxC,cjFufwC;AxBq4xDpD;;AyGr3yDI;EACI,ejFqhB4C;EiFphB5C,0DAAA;EACA,sBjFkhB4C;AxBs2xDpD;AyGt3yDQ;EACI,YAAA;EACA,yDAAA;AzGw3yDZ;AyGn3yDQ;EACI,cjF2gBwC;EiF1gBxC,ajFygBwC;AxB42xDpD;AyGh3yDQ;EACI,ejFsgBwC;EiFrgBxC,cjFogBwC;AxB82xDpD;;A0G9+yDI;EACI,yBlFCiB;EkFAvB,qBAAA;EjFWE,uBAAA;AzBu+yDJ;A0G/+yDQ;EjFQJ,uBAAA;AzB0+yDJ;A0G9+yDQ;EjFIJ,uBAAA;AzB6+yDJ;A0G7+yDQ;EACI,yBlFZa;EkFanB,qBlFbmB;AxB4/yDzB;A0G7+yDY;EACI,0BlFdS;AxB6/yDzB;A0G3+yDQ;EACI,6BAAA;EACN,yBAAA;A1G6+yDN;A0G3+yDY;EACI,0BlFvBS;AxBogzDzB;;A2GzgzDI;EACI,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,chEiBoB;EgEhBpB,qBAAA;EACA,iBAAA;A3G4gzDR;;A4GhhzDI;EACI,mBAAA;EACA,8BAAA;EnFmBJ,gCAAA;EACA,iCAAA;AzBigzDJ;A4GjhzDQ;EACI,gBAAA;A5GmhzDZ;A4G9gzDI;EACI,wBAAA;A5GghzDR;;A4G3gzDA;EAEQ,kCAAA;A5G6gzDR;;A6GnizDA;EACI,aAAA;EACA,oBAAA;EACA,8BAAA;A7GsizDJ;A6GpizDI;EACI,YAAA;EpFQJ,uBAAA;EoFNI,aAAA;EACA,qBAAA;EACA,kBAAA;A7GsizDR;A6GpizDQ;EACI,eAAA;A7GsizDZ;A6GnizDQ;EACI,UAAA;EpFHR,uBAAA;AzByizDJ;;A8GrjzDC;EACI,yBAAA;EACH,eAAA;EACA,kBAAA;A9GwjzDF;A8GrjzDC;EACC,4BAAA;A9GujzDF;A8GpjzDC;EACC,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;A9GsjzDF;A8GpjzDE;EACC,eAAA;A9GsjzDH;A8GnjzDE;EACC,gBAAA;A9GqjzDH;A8G/izDE;;EACC,2BAAA;A9GkjzDH;A8GhjzDG;;;EACC,2BAAA;A9GojzDJ;A8G9izDE;EACC,mBAAA;A9GgjzDH;A8G3izDC;EACC,uBtF0SkC;EsFzSlC,iBAAA;EACA,yBAAA;A9G6izDF;A8GxizDE;EACC,gBAAA;A9G0izDH;A8GpizDE;EACC,wBAAA;EACA,0BAAA;EACA,4BtFhEsB;AxBsmzDzB;A8GlizDG;EACC,gCAAA;A9GoizDJ;A8G7hzDE;EACC,wBAAA;EACA,2BAAA;EACA,4BtF/EsB;AxB8mzDzB;A8G3hzDG;EACC,gCAAA;A9G6hzDJ;A8GrhzDG;EACC,4BtF/EI;AxBsmzDR;A8GxhzDG;EACC,4BtF/EI;AxBymzDR;A8G3hzDG;EACC,4BtF/EI;AxB4mzDR;A8G9hzDG;EACC,4BtF/EI;AxB+mzDR;A8GjizDG;EACC,4BtF/EI;AxBknzDR;A8GpizDG;EACC,4BtF/EI;AxBqnzDR;A8GvizDG;EACC,4BtF/EI;AxBwnzDR;A8G1izDG;EACC,4BtF/EI;AxB2nzDR;A8G7izDG;EACC,4BtF/EI;AxB8nzDR;;A8GlizDI;EACC,atFuQK;AxB8xyDV;A8GlizDK;EACC,6BAAA;A9GoizDN;;A8G9hzDI;EACC,iBtF4PK;EsF3PL,oBtF2PK;AxBsyyDV;;A8G5hzDI;EACC,kBtFqPK;EsFpPL,mBtFoPK;AxB2yyDV;A8G5hzDK;EACC,6BAAA;A9G8hzDN;;A8GvhzDK;EACI,kBtFwOC;AxBkzyDV;A8GvhzDK;EACI,mBtFoOC;AxBqzyDV;A8GrhzDK;EACC,6BAAA;A9GuhzDN;;A8GhkzDI;EACC,gBtFuQK;AxB4zyDV;A8GhkzDK;EACC,gCAAA;A9GkkzDN;;A8G5jzDI;EACC,oBtF4PK;EsF3PL,uBtF2PK;AxBo0yDV;;A8G1jzDI;EACC,qBtFqPK;EsFpPL,sBtFoPK;AxBy0yDV;A8G1jzDK;EACC,gCAAA;A9G4jzDN;;A8GrjzDK;EACI,qBtFwOC;AxBg1yDV;A8GrjzDK;EACI,sBtFoOC;AxBm1yDV;A8GnjzDK;EACC,gCAAA;A9GqjzDN;;A8G9lzDI;EACC,etFuQK;AxB01yDV;A8G9lzDK;EACC,+BAAA;A9GgmzDN;;A8G1lzDI;EACC,mBtF4PK;EsF3PL,sBtF2PK;AxBk2yDV;;A8GxlzDI;EACC,oBtFqPK;EsFpPL,qBtFoPK;AxBu2yDV;A8GxlzDK;EACC,+BAAA;A9G0lzDN;;A8GnlzDK;EACI,oBtFwOC;AxB82yDV;A8GnlzDK;EACI,qBtFoOC;AxBi3yDV;A8GjlzDK;EACC,+BAAA;A9GmlzDN;;A8G5nzDI;EACC,gBtFuQK;AxBw3yDV;A8G5nzDK;EACC,gCAAA;A9G8nzDN;;A8GxnzDI;EACC,oBtF4PK;EsF3PL,uBtF2PK;AxBg4yDV;;A8GtnzDI;EACC,qBtFqPK;EsFpPL,sBtFoPK;AxBq4yDV;A8GtnzDK;EACC,gCAAA;A9GwnzDN;;A8GjnzDK;EACI,qBtFwOC;AxB44yDV;A8GjnzDK;EACI,sBtFoOC;AxB+4yDV;A8G/mzDK;EACC,gCAAA;A9GinzDN;;A8G1pzDI;EACC,atFuQK;AxBs5yDV;A8G1pzDK;EACC,6BAAA;A9G4pzDN;;A8GtpzDI;EACC,iBtF4PK;EsF3PL,oBtF2PK;AxB85yDV;;A8GppzDI;EACC,kBtFqPK;EsFpPL,mBtFoPK;AxBm6yDV;A8GppzDK;EACC,6BAAA;A9GspzDN;;A8G/ozDK;EACI,kBtFwOC;AxB06yDV;A8G/ozDK;EACI,mBtFoOC;AxB66yDV;A8G7ozDK;EACC,6BAAA;A9G+ozDN;;A8GxrzDI;EACC,gBtFuQK;AxBo7yDV;A8GxrzDK;EACC,gCAAA;A9G0rzDN;;A8GprzDI;EACC,oBtF4PK;EsF3PL,uBtF2PK;AxB47yDV;;A8GlrzDI;EACC,qBtFqPK;EsFpPL,sBtFoPK;AxBi8yDV;A8GlrzDK;EACC,gCAAA;A9GorzDN;;A8G7qzDK;EACI,qBtFwOC;AxBw8yDV;A8G7qzDK;EACI,sBtFoOC;AxB28yDV;A8G3qzDK;EACC,gCAAA;A9G6qzDN;;A8GttzDI;EACC,etFuQK;AxBk9yDV;A8GttzDK;EACC,+BAAA;A9GwtzDN;;A8GltzDI;EACC,mBtF4PK;EsF3PL,sBtF2PK;AxB09yDV;;A8GhtzDI;EACC,oBtFqPK;EsFpPL,qBtFoPK;AxB+9yDV;A8GhtzDK;EACC,+BAAA;A9GktzDN;;A8G3szDK;EACI,oBtFwOC;AxBs+yDV;A8G3szDK;EACI,qBtFoOC;AxBy+yDV;A8GzszDK;EACC,+BAAA;A9G2szDN;;A8GpvzDI;EACC,gBtFuQK;AxBg/yDV;A8GpvzDK;EACC,gCAAA;A9GsvzDN;;A8GhvzDI;EACC,oBtF4PK;EsF3PL,uBtF2PK;AxBw/yDV;;A8G9uzDI;EACC,qBtFqPK;EsFpPL,sBtFoPK;AxB6/yDV;A8G9uzDK;EACC,gCAAA;A9GgvzDN;;A8GzuzDK;EACI,qBtFwOC;AxBogzDV;A8GzuzDK;EACI,sBtFoOC;AxBugzDV;A8GvuzDK;EACC,gCAAA;A9GyuzDN;;A8GlxzDI;EACC,atFuQK;AxB8gzDV;A8GlxzDK;EACC,6BAAA;A9GoxzDN;;A8G9wzDI;EACC,iBtF4PK;EsF3PL,oBtF2PK;AxBshzDV;;A8G5wzDI;EACC,kBtFqPK;EsFpPL,mBtFoPK;AxB2hzDV;A8G5wzDK;EACC,6BAAA;A9G8wzDN;;A8GvwzDK;EACI,kBtFwOC;AxBkizDV;A8GvwzDK;EACI,mBtFoOC;AxBqizDV;A8GrwzDK;EACC,6BAAA;A9GuwzDN;;A8GhzzDI;EACC,gBtFuQK;AxB4izDV;A8GhzzDK;EACC,gCAAA;A9GkzzDN;;A8G5yzDI;EACC,oBtF4PK;EsF3PL,uBtF2PK;AxBojzDV;;A8G1yzDI;EACC,qBtFqPK;EsFpPL,sBtFoPK;AxByjzDV;A8G1yzDK;EACC,gCAAA;A9G4yzDN;;A8GryzDK;EACI,qBtFwOC;AxBgkzDV;A8GryzDK;EACI,sBtFoOC;AxBmkzDV;A8GnyzDK;EACC,gCAAA;A9GqyzDN;;A8G90zDI;EACC,etFuQK;AxB0kzDV;A8G90zDK;EACC,+BAAA;A9Gg1zDN;;A8G10zDI;EACC,mBtF4PK;EsF3PL,sBtF2PK;AxBklzDV;;A8Gx0zDI;EACC,oBtFqPK;EsFpPL,qBtFoPK;AxBulzDV;A8Gx0zDK;EACC,+BAAA;A9G00zDN;;A8Gn0zDK;EACI,oBtFwOC;AxB8lzDV;A8Gn0zDK;EACI,qBtFoOC;AxBimzDV;A8Gj0zDK;EACC,+BAAA;A9Gm0zDN;;AUh6zDI;EoGoDA;IACC,atFuQK;ExBymzDR;E8G72zDG;IACC,6BAAA;E9G+2zDJ;;E8Gz2zDE;IACC,iBtF4PK;IsF3PL,oBtF2PK;ExBinzDR;;E8Gv2zDE;IACC,kBtFqPK;IsFpPL,mBtFoPK;ExBsnzDR;E8Gv2zDG;IACC,6BAAA;E9Gy2zDJ;;E8Gl2zDG;IACI,kBtFwOC;ExB6nzDR;E8Gl2zDG;IACI,mBtFoOC;ExBgozDR;E8Gh2zDG;IACC,6BAAA;E9Gk2zDJ;;E8G34zDE;IACC,gBtFuQK;ExBuozDR;E8G34zDG;IACC,gCAAA;E9G64zDJ;;E8Gv4zDE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExB+ozDR;;E8Gr4zDE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExBopzDR;E8Gr4zDG;IACC,gCAAA;E9Gu4zDJ;;E8Gh4zDG;IACI,qBtFwOC;ExB2pzDR;E8Gh4zDG;IACI,sBtFoOC;ExB8pzDR;E8G93zDG;IACC,gCAAA;E9Gg4zDJ;;E8Gz6zDE;IACC,etFuQK;ExBqqzDR;E8Gz6zDG;IACC,+BAAA;E9G26zDJ;;E8Gr6zDE;IACC,mBtF4PK;IsF3PL,sBtF2PK;ExB6qzDR;;E8Gn6zDE;IACC,oBtFqPK;IsFpPL,qBtFoPK;ExBkrzDR;E8Gn6zDG;IACC,+BAAA;E9Gq6zDJ;;E8G95zDG;IACI,oBtFwOC;ExByrzDR;E8G95zDG;IACI,qBtFoOC;ExB4rzDR;E8G55zDG;IACC,+BAAA;E9G85zDJ;;E8Gv8zDE;IACC,gBtFuQK;ExBmszDR;E8Gv8zDG;IACC,gCAAA;E9Gy8zDJ;;E8Gn8zDE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExB2szDR;;E8Gj8zDE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExBgtzDR;E8Gj8zDG;IACC,gCAAA;E9Gm8zDJ;;E8G57zDG;IACI,qBtFwOC;ExButzDR;E8G57zDG;IACI,sBtFoOC;ExB0tzDR;E8G17zDG;IACC,gCAAA;E9G47zDJ;;E8Gr+zDE;IACC,atFuQK;ExBiuzDR;E8Gr+zDG;IACC,6BAAA;E9Gu+zDJ;;E8Gj+zDE;IACC,iBtF4PK;IsF3PL,oBtF2PK;ExByuzDR;;E8G/9zDE;IACC,kBtFqPK;IsFpPL,mBtFoPK;ExB8uzDR;E8G/9zDG;IACC,6BAAA;E9Gi+zDJ;;E8G19zDG;IACI,kBtFwOC;ExBqvzDR;E8G19zDG;IACI,mBtFoOC;ExBwvzDR;E8Gx9zDG;IACC,6BAAA;E9G09zDJ;;E8Gng0DE;IACC,gBtFuQK;ExB+vzDR;E8Gng0DG;IACC,gCAAA;E9Gqg0DJ;;E8G//zDE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExBuwzDR;;E8G7/zDE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExB4wzDR;E8G7/zDG;IACC,gCAAA;E9G+/zDJ;;E8Gx/zDG;IACI,qBtFwOC;ExBmxzDR;E8Gx/zDG;IACI,sBtFoOC;ExBsxzDR;E8Gt/zDG;IACC,gCAAA;E9Gw/zDJ;;E8Gji0DE;IACC,etFuQK;ExB6xzDR;E8Gji0DG;IACC,+BAAA;E9Gmi0DJ;;E8G7h0DE;IACC,mBtF4PK;IsF3PL,sBtF2PK;ExBqyzDR;;E8G3h0DE;IACC,oBtFqPK;IsFpPL,qBtFoPK;ExB0yzDR;E8G3h0DG;IACC,+BAAA;E9G6h0DJ;;E8Gth0DG;IACI,oBtFwOC;ExBizzDR;E8Gth0DG;IACI,qBtFoOC;ExBozzDR;E8Gph0DG;IACC,+BAAA;E9Gsh0DJ;;E8G/j0DE;IACC,gBtFuQK;ExB2zzDR;E8G/j0DG;IACC,gCAAA;E9Gik0DJ;;E8G3j0DE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExBm0zDR;;E8Gzj0DE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExBw0zDR;E8Gzj0DG;IACC,gCAAA;E9G2j0DJ;;E8Gpj0DG;IACI,qBtFwOC;ExB+0zDR;E8Gpj0DG;IACI,sBtFoOC;ExBk1zDR;E8Glj0DG;IACC,gCAAA;E9Goj0DJ;;E8G7l0DE;IACC,atFuQK;ExBy1zDR;E8G7l0DG;IACC,6BAAA;E9G+l0DJ;;E8Gzl0DE;IACC,iBtF4PK;IsF3PL,oBtF2PK;ExBi2zDR;;E8Gvl0DE;IACC,kBtFqPK;IsFpPL,mBtFoPK;ExBs2zDR;E8Gvl0DG;IACC,6BAAA;E9Gyl0DJ;;E8Gll0DG;IACI,kBtFwOC;ExB62zDR;E8Gll0DG;IACI,mBtFoOC;ExBg3zDR;E8Ghl0DG;IACC,6BAAA;E9Gkl0DJ;;E8G3n0DE;IACC,gBtFuQK;ExBu3zDR;E8G3n0DG;IACC,gCAAA;E9G6n0DJ;;E8Gvn0DE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExB+3zDR;;E8Grn0DE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExBo4zDR;E8Grn0DG;IACC,gCAAA;E9Gun0DJ;;E8Ghn0DG;IACI,qBtFwOC;ExB24zDR;E8Ghn0DG;IACI,sBtFoOC;ExB84zDR;E8G9m0DG;IACC,gCAAA;E9Ggn0DJ;;E8Gzp0DE;IACC,etFuQK;ExBq5zDR;E8Gzp0DG;IACC,+BAAA;E9G2p0DJ;;E8Grp0DE;IACC,mBtF4PK;IsF3PL,sBtF2PK;ExB65zDR;;E8Gnp0DE;IACC,oBtFqPK;IsFpPL,qBtFoPK;ExBk6zDR;E8Gnp0DG;IACC,+BAAA;E9Gqp0DJ;;E8G9o0DG;IACI,oBtFwOC;ExBy6zDR;E8G9o0DG;IACI,qBtFoOC;ExB46zDR;E8G5o0DG;IACC,+BAAA;E9G8o0DJ;AACF;AU5u0DI;EoGoDA;IACC,atFuQK;ExBo7zDR;E8Gxr0DG;IACC,6BAAA;E9G0r0DJ;;E8Gpr0DE;IACC,iBtF4PK;IsF3PL,oBtF2PK;ExB47zDR;;E8Glr0DE;IACC,kBtFqPK;IsFpPL,mBtFoPK;ExBi8zDR;E8Glr0DG;IACC,6BAAA;E9Gor0DJ;;E8G7q0DG;IACI,kBtFwOC;ExBw8zDR;E8G7q0DG;IACI,mBtFoOC;ExB28zDR;E8G3q0DG;IACC,6BAAA;E9G6q0DJ;;E8Gtt0DE;IACC,gBtFuQK;ExBk9zDR;E8Gtt0DG;IACC,gCAAA;E9Gwt0DJ;;E8Glt0DE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExB09zDR;;E8Ght0DE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExB+9zDR;E8Ght0DG;IACC,gCAAA;E9Gkt0DJ;;E8G3s0DG;IACI,qBtFwOC;ExBs+zDR;E8G3s0DG;IACI,sBtFoOC;ExBy+zDR;E8Gzs0DG;IACC,gCAAA;E9G2s0DJ;;E8Gpv0DE;IACC,etFuQK;ExBg/zDR;E8Gpv0DG;IACC,+BAAA;E9Gsv0DJ;;E8Ghv0DE;IACC,mBtF4PK;IsF3PL,sBtF2PK;ExBw/zDR;;E8G9u0DE;IACC,oBtFqPK;IsFpPL,qBtFoPK;ExB6/zDR;E8G9u0DG;IACC,+BAAA;E9Ggv0DJ;;E8Gzu0DG;IACI,oBtFwOC;ExBog0DR;E8Gzu0DG;IACI,qBtFoOC;ExBug0DR;E8Gvu0DG;IACC,+BAAA;E9Gyu0DJ;;E8Glx0DE;IACC,gBtFuQK;ExB8g0DR;E8Glx0DG;IACC,gCAAA;E9Gox0DJ;;E8G9w0DE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExBsh0DR;;E8G5w0DE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExB2h0DR;E8G5w0DG;IACC,gCAAA;E9G8w0DJ;;E8Gvw0DG;IACI,qBtFwOC;ExBki0DR;E8Gvw0DG;IACI,sBtFoOC;ExBqi0DR;E8Grw0DG;IACC,gCAAA;E9Guw0DJ;;E8Ghz0DE;IACC,atFuQK;ExB4i0DR;E8Ghz0DG;IACC,6BAAA;E9Gkz0DJ;;E8G5y0DE;IACC,iBtF4PK;IsF3PL,oBtF2PK;ExBoj0DR;;E8G1y0DE;IACC,kBtFqPK;IsFpPL,mBtFoPK;ExByj0DR;E8G1y0DG;IACC,6BAAA;E9G4y0DJ;;E8Gry0DG;IACI,kBtFwOC;ExBgk0DR;E8Gry0DG;IACI,mBtFoOC;ExBmk0DR;E8Gny0DG;IACC,6BAAA;E9Gqy0DJ;;E8G900DE;IACC,gBtFuQK;ExB0k0DR;E8G900DG;IACC,gCAAA;E9Gg10DJ;;E8G100DE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExBkl0DR;;E8Gx00DE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExBul0DR;E8Gx00DG;IACC,gCAAA;E9G000DJ;;E8Gn00DG;IACI,qBtFwOC;ExB8l0DR;E8Gn00DG;IACI,sBtFoOC;ExBim0DR;E8Gj00DG;IACC,gCAAA;E9Gm00DJ;;E8G520DE;IACC,etFuQK;ExBwm0DR;E8G520DG;IACC,+BAAA;E9G820DJ;;E8Gx20DE;IACC,mBtF4PK;IsF3PL,sBtF2PK;ExBgn0DR;;E8Gt20DE;IACC,oBtFqPK;IsFpPL,qBtFoPK;ExBqn0DR;E8Gt20DG;IACC,+BAAA;E9Gw20DJ;;E8Gj20DG;IACI,oBtFwOC;ExB4n0DR;E8Gj20DG;IACI,qBtFoOC;ExB+n0DR;E8G/10DG;IACC,+BAAA;E9Gi20DJ;;E8G140DE;IACC,gBtFuQK;ExBso0DR;E8G140DG;IACC,gCAAA;E9G440DJ;;E8Gt40DE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExB8o0DR;;E8Gp40DE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExBmp0DR;E8Gp40DG;IACC,gCAAA;E9Gs40DJ;;E8G/30DG;IACI,qBtFwOC;ExB0p0DR;E8G/30DG;IACI,sBtFoOC;ExB6p0DR;E8G730DG;IACC,gCAAA;E9G+30DJ;;E8Gx60DE;IACC,atFuQK;ExBoq0DR;E8Gx60DG;IACC,6BAAA;E9G060DJ;;E8Gp60DE;IACC,iBtF4PK;IsF3PL,oBtF2PK;ExB4q0DR;;E8Gl60DE;IACC,kBtFqPK;IsFpPL,mBtFoPK;ExBir0DR;E8Gl60DG;IACC,6BAAA;E9Go60DJ;;E8G750DG;IACI,kBtFwOC;ExBwr0DR;E8G750DG;IACI,mBtFoOC;ExB2r0DR;E8G350DG;IACC,6BAAA;E9G650DJ;;E8Gt80DE;IACC,gBtFuQK;ExBks0DR;E8Gt80DG;IACC,gCAAA;E9Gw80DJ;;E8Gl80DE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExB0s0DR;;E8Gh80DE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExB+s0DR;E8Gh80DG;IACC,gCAAA;E9Gk80DJ;;E8G370DG;IACI,qBtFwOC;ExBst0DR;E8G370DG;IACI,sBtFoOC;ExByt0DR;E8Gz70DG;IACC,gCAAA;E9G270DJ;;E8Gp+0DE;IACC,etFuQK;ExBgu0DR;E8Gp+0DG;IACC,+BAAA;E9Gs+0DJ;;E8Gh+0DE;IACC,mBtF4PK;IsF3PL,sBtF2PK;ExBwu0DR;;E8G990DE;IACC,oBtFqPK;IsFpPL,qBtFoPK;ExB6u0DR;E8G990DG;IACC,+BAAA;E9Gg+0DJ;;E8Gz90DG;IACI,oBtFwOC;ExBov0DR;E8Gz90DG;IACI,qBtFoOC;ExBuv0DR;E8Gv90DG;IACC,+BAAA;E9Gy90DJ;AACF;AUvj1DI;EoGoDA;IACC,atFuQK;ExB+v0DR;E8Gng1DG;IACC,6BAAA;E9Gqg1DJ;;E8G//0DE;IACC,iBtF4PK;IsF3PL,oBtF2PK;ExBuw0DR;;E8G7/0DE;IACC,kBtFqPK;IsFpPL,mBtFoPK;ExB4w0DR;E8G7/0DG;IACC,6BAAA;E9G+/0DJ;;E8Gx/0DG;IACI,kBtFwOC;ExBmx0DR;E8Gx/0DG;IACI,mBtFoOC;ExBsx0DR;E8Gt/0DG;IACC,6BAAA;E9Gw/0DJ;;E8Gji1DE;IACC,gBtFuQK;ExB6x0DR;E8Gji1DG;IACC,gCAAA;E9Gmi1DJ;;E8G7h1DE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExBqy0DR;;E8G3h1DE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExB0y0DR;E8G3h1DG;IACC,gCAAA;E9G6h1DJ;;E8Gth1DG;IACI,qBtFwOC;ExBiz0DR;E8Gth1DG;IACI,sBtFoOC;ExBoz0DR;E8Gph1DG;IACC,gCAAA;E9Gsh1DJ;;E8G/j1DE;IACC,etFuQK;ExB2z0DR;E8G/j1DG;IACC,+BAAA;E9Gik1DJ;;E8G3j1DE;IACC,mBtF4PK;IsF3PL,sBtF2PK;ExBm00DR;;E8Gzj1DE;IACC,oBtFqPK;IsFpPL,qBtFoPK;ExBw00DR;E8Gzj1DG;IACC,+BAAA;E9G2j1DJ;;E8Gpj1DG;IACI,oBtFwOC;ExB+00DR;E8Gpj1DG;IACI,qBtFoOC;ExBk10DR;E8Glj1DG;IACC,+BAAA;E9Goj1DJ;;E8G7l1DE;IACC,gBtFuQK;ExBy10DR;E8G7l1DG;IACC,gCAAA;E9G+l1DJ;;E8Gzl1DE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExBi20DR;;E8Gvl1DE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExBs20DR;E8Gvl1DG;IACC,gCAAA;E9Gyl1DJ;;E8Gll1DG;IACI,qBtFwOC;ExB620DR;E8Gll1DG;IACI,sBtFoOC;ExBg30DR;E8Ghl1DG;IACC,gCAAA;E9Gkl1DJ;;E8G3n1DE;IACC,atFuQK;ExBu30DR;E8G3n1DG;IACC,6BAAA;E9G6n1DJ;;E8Gvn1DE;IACC,iBtF4PK;IsF3PL,oBtF2PK;ExB+30DR;;E8Grn1DE;IACC,kBtFqPK;IsFpPL,mBtFoPK;ExBo40DR;E8Grn1DG;IACC,6BAAA;E9Gun1DJ;;E8Ghn1DG;IACI,kBtFwOC;ExB240DR;E8Ghn1DG;IACI,mBtFoOC;ExB840DR;E8G9m1DG;IACC,6BAAA;E9Ggn1DJ;;E8Gzp1DE;IACC,gBtFuQK;ExBq50DR;E8Gzp1DG;IACC,gCAAA;E9G2p1DJ;;E8Grp1DE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExB650DR;;E8Gnp1DE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExBk60DR;E8Gnp1DG;IACC,gCAAA;E9Gqp1DJ;;E8G9o1DG;IACI,qBtFwOC;ExBy60DR;E8G9o1DG;IACI,sBtFoOC;ExB460DR;E8G5o1DG;IACC,gCAAA;E9G8o1DJ;;E8Gvr1DE;IACC,etFuQK;ExBm70DR;E8Gvr1DG;IACC,+BAAA;E9Gyr1DJ;;E8Gnr1DE;IACC,mBtF4PK;IsF3PL,sBtF2PK;ExB270DR;;E8Gjr1DE;IACC,oBtFqPK;IsFpPL,qBtFoPK;ExBg80DR;E8Gjr1DG;IACC,+BAAA;E9Gmr1DJ;;E8G5q1DG;IACI,oBtFwOC;ExBu80DR;E8G5q1DG;IACI,qBtFoOC;ExB080DR;E8G1q1DG;IACC,+BAAA;E9G4q1DJ;;E8Grt1DE;IACC,gBtFuQK;ExBi90DR;E8Grt1DG;IACC,gCAAA;E9Gut1DJ;;E8Gjt1DE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExBy90DR;;E8G/s1DE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExB890DR;E8G/s1DG;IACC,gCAAA;E9Git1DJ;;E8G1s1DG;IACI,qBtFwOC;ExBq+0DR;E8G1s1DG;IACI,sBtFoOC;ExBw+0DR;E8Gxs1DG;IACC,gCAAA;E9G0s1DJ;;E8Gnv1DE;IACC,atFuQK;ExB++0DR;E8Gnv1DG;IACC,6BAAA;E9Gqv1DJ;;E8G/u1DE;IACC,iBtF4PK;IsF3PL,oBtF2PK;ExBu/0DR;;E8G7u1DE;IACC,kBtFqPK;IsFpPL,mBtFoPK;ExB4/0DR;E8G7u1DG;IACC,6BAAA;E9G+u1DJ;;E8Gxu1DG;IACI,kBtFwOC;ExBmg1DR;E8Gxu1DG;IACI,mBtFoOC;ExBsg1DR;E8Gtu1DG;IACC,6BAAA;E9Gwu1DJ;;E8Gjx1DE;IACC,gBtFuQK;ExB6g1DR;E8Gjx1DG;IACC,gCAAA;E9Gmx1DJ;;E8G7w1DE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExBqh1DR;;E8G3w1DE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExB0h1DR;E8G3w1DG;IACC,gCAAA;E9G6w1DJ;;E8Gtw1DG;IACI,qBtFwOC;ExBii1DR;E8Gtw1DG;IACI,sBtFoOC;ExBoi1DR;E8Gpw1DG;IACC,gCAAA;E9Gsw1DJ;;E8G/y1DE;IACC,etFuQK;ExB2i1DR;E8G/y1DG;IACC,+BAAA;E9Giz1DJ;;E8G3y1DE;IACC,mBtF4PK;IsF3PL,sBtF2PK;ExBmj1DR;;E8Gzy1DE;IACC,oBtFqPK;IsFpPL,qBtFoPK;ExBwj1DR;E8Gzy1DG;IACC,+BAAA;E9G2y1DJ;;E8Gpy1DG;IACI,oBtFwOC;ExB+j1DR;E8Gpy1DG;IACI,qBtFoOC;ExBkk1DR;E8Gly1DG;IACC,+BAAA;E9Goy1DJ;AACF;AUl41DI;EoGoDA;IACC,atFuQK;ExB0k1DR;E8G901DG;IACC,6BAAA;E9Gg11DJ;;E8G101DE;IACC,iBtF4PK;IsF3PL,oBtF2PK;ExBkl1DR;;E8Gx01DE;IACC,kBtFqPK;IsFpPL,mBtFoPK;ExBul1DR;E8Gx01DG;IACC,6BAAA;E9G001DJ;;E8Gn01DG;IACI,kBtFwOC;ExB8l1DR;E8Gn01DG;IACI,mBtFoOC;ExBim1DR;E8Gj01DG;IACC,6BAAA;E9Gm01DJ;;E8G521DE;IACC,gBtFuQK;ExBwm1DR;E8G521DG;IACC,gCAAA;E9G821DJ;;E8Gx21DE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExBgn1DR;;E8Gt21DE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExBqn1DR;E8Gt21DG;IACC,gCAAA;E9Gw21DJ;;E8Gj21DG;IACI,qBtFwOC;ExB4n1DR;E8Gj21DG;IACI,sBtFoOC;ExB+n1DR;E8G/11DG;IACC,gCAAA;E9Gi21DJ;;E8G141DE;IACC,etFuQK;ExBso1DR;E8G141DG;IACC,+BAAA;E9G441DJ;;E8Gt41DE;IACC,mBtF4PK;IsF3PL,sBtF2PK;ExB8o1DR;;E8Gp41DE;IACC,oBtFqPK;IsFpPL,qBtFoPK;ExBmp1DR;E8Gp41DG;IACC,+BAAA;E9Gs41DJ;;E8G/31DG;IACI,oBtFwOC;ExB0p1DR;E8G/31DG;IACI,qBtFoOC;ExB6p1DR;E8G731DG;IACC,+BAAA;E9G+31DJ;;E8Gx61DE;IACC,gBtFuQK;ExBoq1DR;E8Gx61DG;IACC,gCAAA;E9G061DJ;;E8Gp61DE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExB4q1DR;;E8Gl61DE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExBir1DR;E8Gl61DG;IACC,gCAAA;E9Go61DJ;;E8G751DG;IACI,qBtFwOC;ExBwr1DR;E8G751DG;IACI,sBtFoOC;ExB2r1DR;E8G351DG;IACC,gCAAA;E9G651DJ;;E8Gt81DE;IACC,atFuQK;ExBks1DR;E8Gt81DG;IACC,6BAAA;E9Gw81DJ;;E8Gl81DE;IACC,iBtF4PK;IsF3PL,oBtF2PK;ExB0s1DR;;E8Gh81DE;IACC,kBtFqPK;IsFpPL,mBtFoPK;ExB+s1DR;E8Gh81DG;IACC,6BAAA;E9Gk81DJ;;E8G371DG;IACI,kBtFwOC;ExBst1DR;E8G371DG;IACI,mBtFoOC;ExByt1DR;E8Gz71DG;IACC,6BAAA;E9G271DJ;;E8Gp+1DE;IACC,gBtFuQK;ExBgu1DR;E8Gp+1DG;IACC,gCAAA;E9Gs+1DJ;;E8Gh+1DE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExBwu1DR;;E8G991DE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExB6u1DR;E8G991DG;IACC,gCAAA;E9Gg+1DJ;;E8Gz91DG;IACI,qBtFwOC;ExBov1DR;E8Gz91DG;IACI,sBtFoOC;ExBuv1DR;E8Gv91DG;IACC,gCAAA;E9Gy91DJ;;E8Glg2DE;IACC,etFuQK;ExB8v1DR;E8Glg2DG;IACC,+BAAA;E9Gog2DJ;;E8G9/1DE;IACC,mBtF4PK;IsF3PL,sBtF2PK;ExBsw1DR;;E8G5/1DE;IACC,oBtFqPK;IsFpPL,qBtFoPK;ExB2w1DR;E8G5/1DG;IACC,+BAAA;E9G8/1DJ;;E8Gv/1DG;IACI,oBtFwOC;ExBkx1DR;E8Gv/1DG;IACI,qBtFoOC;ExBqx1DR;E8Gr/1DG;IACC,+BAAA;E9Gu/1DJ;;E8Ghi2DE;IACC,gBtFuQK;ExB4x1DR;E8Ghi2DG;IACC,gCAAA;E9Gki2DJ;;E8G5h2DE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExBoy1DR;;E8G1h2DE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExByy1DR;E8G1h2DG;IACC,gCAAA;E9G4h2DJ;;E8Grh2DG;IACI,qBtFwOC;ExBgz1DR;E8Grh2DG;IACI,sBtFoOC;ExBmz1DR;E8Gnh2DG;IACC,gCAAA;E9Gqh2DJ;;E8G9j2DE;IACC,atFuQK;ExB0z1DR;E8G9j2DG;IACC,6BAAA;E9Ggk2DJ;;E8G1j2DE;IACC,iBtF4PK;IsF3PL,oBtF2PK;ExBk01DR;;E8Gxj2DE;IACC,kBtFqPK;IsFpPL,mBtFoPK;ExBu01DR;E8Gxj2DG;IACC,6BAAA;E9G0j2DJ;;E8Gnj2DG;IACI,kBtFwOC;ExB801DR;E8Gnj2DG;IACI,mBtFoOC;ExBi11DR;E8Gjj2DG;IACC,6BAAA;E9Gmj2DJ;;E8G5l2DE;IACC,gBtFuQK;ExBw11DR;E8G5l2DG;IACC,gCAAA;E9G8l2DJ;;E8Gxl2DE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExBg21DR;;E8Gtl2DE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExBq21DR;E8Gtl2DG;IACC,gCAAA;E9Gwl2DJ;;E8Gjl2DG;IACI,qBtFwOC;ExB421DR;E8Gjl2DG;IACI,sBtFoOC;ExB+21DR;E8G/k2DG;IACC,gCAAA;E9Gil2DJ;;E8G1n2DE;IACC,etFuQK;ExBs31DR;E8G1n2DG;IACC,+BAAA;E9G4n2DJ;;E8Gtn2DE;IACC,mBtF4PK;IsF3PL,sBtF2PK;ExB831DR;;E8Gpn2DE;IACC,oBtFqPK;IsFpPL,qBtFoPK;ExBm41DR;E8Gpn2DG;IACC,+BAAA;E9Gsn2DJ;;E8G/m2DG;IACI,oBtFwOC;ExB041DR;E8G/m2DG;IACI,qBtFoOC;ExB641DR;E8G7m2DG;IACC,+BAAA;E9G+m2DJ;AACF;AU7s2DI;EoGoDA;IACC,atFuQK;ExBq51DR;E8Gzp2DG;IACC,6BAAA;E9G2p2DJ;;E8Grp2DE;IACC,iBtF4PK;IsF3PL,oBtF2PK;ExB651DR;;E8Gnp2DE;IACC,kBtFqPK;IsFpPL,mBtFoPK;ExBk61DR;E8Gnp2DG;IACC,6BAAA;E9Gqp2DJ;;E8G9o2DG;IACI,kBtFwOC;ExBy61DR;E8G9o2DG;IACI,mBtFoOC;ExB461DR;E8G5o2DG;IACC,6BAAA;E9G8o2DJ;;E8Gvr2DE;IACC,gBtFuQK;ExBm71DR;E8Gvr2DG;IACC,gCAAA;E9Gyr2DJ;;E8Gnr2DE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExB271DR;;E8Gjr2DE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExBg81DR;E8Gjr2DG;IACC,gCAAA;E9Gmr2DJ;;E8G5q2DG;IACI,qBtFwOC;ExBu81DR;E8G5q2DG;IACI,sBtFoOC;ExB081DR;E8G1q2DG;IACC,gCAAA;E9G4q2DJ;;E8Grt2DE;IACC,etFuQK;ExBi91DR;E8Grt2DG;IACC,+BAAA;E9Gut2DJ;;E8Gjt2DE;IACC,mBtF4PK;IsF3PL,sBtF2PK;ExBy91DR;;E8G/s2DE;IACC,oBtFqPK;IsFpPL,qBtFoPK;ExB891DR;E8G/s2DG;IACC,+BAAA;E9Git2DJ;;E8G1s2DG;IACI,oBtFwOC;ExBq+1DR;E8G1s2DG;IACI,qBtFoOC;ExBw+1DR;E8Gxs2DG;IACC,+BAAA;E9G0s2DJ;;E8Gnv2DE;IACC,gBtFuQK;ExB++1DR;E8Gnv2DG;IACC,gCAAA;E9Gqv2DJ;;E8G/u2DE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExBu/1DR;;E8G7u2DE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExB4/1DR;E8G7u2DG;IACC,gCAAA;E9G+u2DJ;;E8Gxu2DG;IACI,qBtFwOC;ExBmg2DR;E8Gxu2DG;IACI,sBtFoOC;ExBsg2DR;E8Gtu2DG;IACC,gCAAA;E9Gwu2DJ;;E8Gjx2DE;IACC,atFuQK;ExB6g2DR;E8Gjx2DG;IACC,6BAAA;E9Gmx2DJ;;E8G7w2DE;IACC,iBtF4PK;IsF3PL,oBtF2PK;ExBqh2DR;;E8G3w2DE;IACC,kBtFqPK;IsFpPL,mBtFoPK;ExB0h2DR;E8G3w2DG;IACC,6BAAA;E9G6w2DJ;;E8Gtw2DG;IACI,kBtFwOC;ExBii2DR;E8Gtw2DG;IACI,mBtFoOC;ExBoi2DR;E8Gpw2DG;IACC,6BAAA;E9Gsw2DJ;;E8G/y2DE;IACC,gBtFuQK;ExB2i2DR;E8G/y2DG;IACC,gCAAA;E9Giz2DJ;;E8G3y2DE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExBmj2DR;;E8Gzy2DE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExBwj2DR;E8Gzy2DG;IACC,gCAAA;E9G2y2DJ;;E8Gpy2DG;IACI,qBtFwOC;ExB+j2DR;E8Gpy2DG;IACI,sBtFoOC;ExBkk2DR;E8Gly2DG;IACC,gCAAA;E9Goy2DJ;;E8G702DE;IACC,etFuQK;ExByk2DR;E8G702DG;IACC,+BAAA;E9G+02DJ;;E8Gz02DE;IACC,mBtF4PK;IsF3PL,sBtF2PK;ExBil2DR;;E8Gv02DE;IACC,oBtFqPK;IsFpPL,qBtFoPK;ExBsl2DR;E8Gv02DG;IACC,+BAAA;E9Gy02DJ;;E8Gl02DG;IACI,oBtFwOC;ExB6l2DR;E8Gl02DG;IACI,qBtFoOC;ExBgm2DR;E8Gh02DG;IACC,+BAAA;E9Gk02DJ;;E8G322DE;IACC,gBtFuQK;ExBum2DR;E8G322DG;IACC,gCAAA;E9G622DJ;;E8Gv22DE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExB+m2DR;;E8Gr22DE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExBon2DR;E8Gr22DG;IACC,gCAAA;E9Gu22DJ;;E8Gh22DG;IACI,qBtFwOC;ExB2n2DR;E8Gh22DG;IACI,sBtFoOC;ExB8n2DR;E8G912DG;IACC,gCAAA;E9Gg22DJ;;E8Gz42DE;IACC,atFuQK;ExBqo2DR;E8Gz42DG;IACC,6BAAA;E9G242DJ;;E8Gr42DE;IACC,iBtF4PK;IsF3PL,oBtF2PK;ExB6o2DR;;E8Gn42DE;IACC,kBtFqPK;IsFpPL,mBtFoPK;ExBkp2DR;E8Gn42DG;IACC,6BAAA;E9Gq42DJ;;E8G932DG;IACI,kBtFwOC;ExByp2DR;E8G932DG;IACI,mBtFoOC;ExB4p2DR;E8G532DG;IACC,6BAAA;E9G832DJ;;E8Gv62DE;IACC,gBtFuQK;ExBmq2DR;E8Gv62DG;IACC,gCAAA;E9Gy62DJ;;E8Gn62DE;IACC,oBtF4PK;IsF3PL,uBtF2PK;ExB2q2DR;;E8Gj62DE;IACC,qBtFqPK;IsFpPL,sBtFoPK;ExBgr2DR;E8Gj62DG;IACC,gCAAA;E9Gm62DJ;;E8G552DG;IACI,qBtFwOC;ExBur2DR;E8G552DG;IACI,sBtFoOC;ExB0r2DR;E8G152DG;IACC,gCAAA;E9G452DJ;;E8Gr82DE;IACC,etFuQK;ExBis2DR;E8Gr82DG;IACC,+BAAA;E9Gu82DJ;;E8Gj82DE;IACC,mBtF4PK;IsF3PL,sBtF2PK;ExBys2DR;;E8G/72DE;IACC,oBtFqPK;IsFpPL,qBtFoPK;ExB8s2DR;E8G/72DG;IACC,+BAAA;E9Gi82DJ;;E8G172DG;IACI,oBtFwOC;ExBqt2DR;E8G172DG;IACI,qBtFoOC;ExBwt2DR;E8Gx72DG;IACC,+BAAA;E9G072DJ;AACF;A+Ghl3DI;EACI,evF4yBmC;EuF3yBnC,gBvF0yBmC;EuFzyBnC,gCAAA;A/Gkl3DR;A+G/k3DI;EACI,kBAAA;EACA,YvF8yB4C;EuF7yB5C,cvF8yB4C;EuF7yB5C,cvF2yB4C;EuF1yB5C,avF0yB4C;AxBuy1DpD;A+G/k3DQ;EACI,cvFTa;AxB0l3DzB;A+G7k3DY;EACI,cpElBS;A3Cim3DzB;A+G3k3DQ;EACI,sBAAA;A/G6k3DZ;;A+Gvk3DA;EChCI,yBxFWqB;EwFVrB,SAAA;AhH2m3DJ;AgHxm3DI;EACI,yBxFMiB;EwFLjB,cxFFiB;EwFGjB,4BxFGiB;AxBum3DzB;AgHtm3DI;EACI,cxFNiB;AxB8m3DzB;AgHlm3DY;EACI,yBxFhBS;AxBon3DzB;AgHjm3DY;EACI,yBxFZS;AxB+m3DzB;AgH5l3DY;EACI,2BxF5BS;AxB0n3DzB;AgH3l3DY;EACI,2BxFxBS;AxBqn3DzB;AgHtl3DY;EACI,4BxFxCS;AxBgo3DzB;AgHrl3DY;EACI,4BxFpCS;AxB2n3DzB;AgHll3DQ;EACI,4BxF1Ca;AxB8n3DzB;AgH9k3DY;EACI,0BxFzDS;AxByo3DzB;AgH7k3DY;EACI,0BxFrDS;AxBoo3DzB;;AiH7o3DI;EACI,oDzFgvBqB;AxBg61D7B;AiH5o3DQ;EACC,mBAAA;EACJ,eAAA;AjH8o3DL;AkHvp3DI;EACI,c1F+DuB;E0F9DvB,yB1FSiB;AxBgp3DzB;AkHnp3DY;EACI,yB1FES;AxBmp3DzB;AkH9o3DY;EACI,2B1FNS;AxBsp3DzB;AkHzo3DY;EACI,4B1FdS;AxByp3DzB;AkHpo3DY;EACI,0B1FtBS;AxB4p3DzB;;AmHrq3DC;EACC,eAAA;AnHwq3DF;AmHlq3DE;EACC,aAAA;EACA,cAAA;EACA,yB3F4TiD;E2F3TjD,wBAAA;EACA,mBAAA;EACA,uBAAA;AnHoq3DH;AmHlq3DG;EACI,cxEfkB;A3Cmr3DzB;AgFpr3DQ;EACI,0BAAA;EACA,aAAA;AhFsr3DZ;AgFlr3DY;EACI,0BAAA;AhFor3DhB;AmHjq3DG;EACC,yB3F2SgD;E2F1ShD,oBAAA;AnHmq3DJ;AmHjq3DI;EACI,c3F1BiB;AxB6r3DzB;AgFls3DQ;EACI,0BAAA;EACA,aAAA;AhFos3DZ;AgFhs3DY;EACI,0BAAA;AhFks3DhB;AmH7p3DE;EACC,SAAA;AnH+p3DH;AmHxp3DE;EACC,6BAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AnH0p3DH;;AoHtt3DA;EACI,aAAA;ApHyt3DJ;;AoHtt3DA;EACI,aAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,oDAAA;EACA,yBAAA;EACA,uBAAA;EACA,qBAAA;ApHyt3DJ;;AoHrt3DA;EACI,aAAA;EACA,yBAAA;EACA,SAAA;EACA,2BAAA;E3F+BA,yBAAA;EAMA,0BAAA;AzBqr3DJ;AoHtt3DI;EACI,QAAA;EACA,yBAAA;ApHwt3DR;;AqHjv3DA;EACC,kBAAA;EACA,qBAAA;E5FWG,uBAAA;E4FTH,4BAAA;EACA,sBAAA;ArHov3DD;AqHjv3DC;EACC,iCAAA;ArHmv3DF;AqH/u3DC;EACC,YAAA;EACA,aAAA;E5FFE,uBAAA;E4FIF,4BAAA;EACA,sBAAA;ArHiv3DF;AqH7u3DC;EACC,eAAA;EACA,kBAAA;EACA,gCAAA;ArH+u3DF;AqH3u3DC;EACC,UAAA;EACA,MAAA;ArH6u3DF;AqH3u3DE;EACC,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,UAAA;ArH6u3DH;AqHxu3DC;;EAEC,kBAAA;EACA,UAAA;EACA,SAAA;ArH0u3DF;AqHvu3DC;EACC,aAAA;ArHyu3DF;AqHpu3DE;EACC,aAAA;ArHsu3DH;AqHnu3DE;EACC,aAAA;ArHqu3DH;AqH/t3DE;;EAEC,aAAA;ArHiu3DH;AqH5t3DC;EACC,kBAAA;ArH8t3DF;AqH3t3DE;EACC,kBAAA;ArH6t3DH;AqHzt3DE;EACC,UAAA;EACA,MAAA;EACA,+BAAA;ArH2t3DH;AqHvt3DE;;EAEC,UAAA;EACA,SAAA;EACA,kCAAA;ArHyt3DH;AqHnt3DE;EACC,yBAAA;EACA,qDAAA;ArHqt3DH;;AsH3z3DA;EACI,qBAAA;EACA,cAAA;EACA,kBAAA;E7FWA,uBAAA;AzBoz3DJ;AsH3z3DI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,c9FFiB;E8FGjB,yB9FViB;E8FWjB,4BAAA;EACA,kCAAA;EACA,sBAAA;E7FFJ,uBAAA;AzBg03DJ;AsHzz3DI;EACI,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,MAAA;EACA,SAAA;EACA,uDAAA;AtH2z3DR;AsHvz3DI;EACI,WAAA;EACA,cAAA;EACA,qBAAA;E7FpBJ,uBAAA;AzB803DJ;AsHpz3DQ;;;EAGI,2BAAA;AtHsz3DZ;AsHhz3DQ;;;EAGI,kBAAA;AtHkz3DZ;AuHt23DI;EACI,WDwDiB;ECvDjB,YDuDiB;AtHiz3DzB;AuHr23DI;EACI,WDmDiB;EClDjB,YDkDiB;AtHqz3DzB;AuHn23DQ;EACI,WD6Ca;EC5Cb,YD4Ca;AtHyz3DzB;AuHl23DQ;EACI,WDwCa;ECvCb,YDuCa;ECtCb,eAAA;AvHo23DZ;AuH913DQ;EACI,YD+Ba;EC9Bb,WAAA;AvHg23DZ;AuH713DQ;EACI,YD0Ba;ECzBb,WAAA;EACA,eAAA;AvH+13DZ;AuHh43DI;EACI,W/FigCO;E+FhgCP,Y/FggCO;AxBk41Df;AuH/33DI;EACI,W/F4/BO;E+F3/BP,Y/F2/BO;AxBs41Df;AuH733DQ;EACI,W/Fs/BG;E+Fr/BH,Y/Fq/BG;AxB041Df;AuH533DQ;EACI,W/Fi/BG;E+Fh/BH,Y/Fg/BG;E+F/+BH,eAAA;AvH833DZ;AuHx33DQ;EACI,Y/Fw+BG;E+Fv+BH,WAAA;AvH033DZ;AuHv33DQ;EACI,Y/Fm+BG;E+Fl+BH,WAAA;EACA,eAAA;AvHy33DZ;AuH153DI;EACI,W/FigCO;E+FhgCP,Y/FggCO;AxB451Df;AuHz53DI;EACI,W/F4/BO;E+F3/BP,Y/F2/BO;AxBg61Df;AuHv53DQ;EACI,W/Fs/BG;E+Fr/BH,Y/Fq/BG;AxBo61Df;AuHt53DQ;EACI,W/Fi/BG;E+Fh/BH,Y/Fg/BG;E+F/+BH,eAAA;AvHw53DZ;AuHl53DQ;EACI,Y/Fw+BG;E+Fv+BH,aAAA;AvHo53DZ;AuHj53DQ;EACI,Y/Fm+BG;E+Fl+BH,aAAA;EACA,eAAA;AvHm53DZ;AuHp73DI;EACI,W/FigCO;E+FhgCP,Y/FggCO;AxBs71Df;AuHn73DI;EACI,W/F4/BO;E+F3/BP,Y/F2/BO;AxB071Df;AuHj73DQ;EACI,W/Fs/BG;E+Fr/BH,Y/Fq/BG;AxB871Df;AuHh73DQ;EACI,W/Fi/BG;E+Fh/BH,Y/Fg/BG;E+F/+BH,eAAA;AvHk73DZ;AuH563DQ;EACI,Y/Fw+BG;E+Fv+BH,WAAA;AvH863DZ;AuH363DQ;EACI,Y/Fm+BG;E+Fl+BH,WAAA;EACA,eAAA;AvH663DZ;AuH983DI;EACI,W/FigCO;E+FhgCP,Y/FggCO;AxBg91Df;AuH783DI;EACI,W/F4/BO;E+F3/BP,Y/F2/BO;AxBo91Df;AuH383DQ;EACI,W/Fs/BG;E+Fr/BH,Y/Fq/BG;AxBw91Df;AuH183DQ;EACI,W/Fi/BG;E+Fh/BH,Y/Fg/BG;E+F/+BH,eAAA;AvH483DZ;AuHt83DQ;EACI,Y/Fw+BG;E+Fv+BH,aAAA;AvHw83DZ;AuHr83DQ;EACI,Y/Fm+BG;E+Fl+BH,aAAA;EACA,eAAA;AvHu83DZ;AuHx+3DI;EACI,W/FigCO;E+FhgCP,Y/FggCO;AxB0+1Df;AuHv+3DI;EACI,W/F4/BO;E+F3/BP,Y/F2/BO;AxB8+1Df;AuHr+3DQ;EACI,W/Fs/BG;E+Fr/BH,Y/Fq/BG;AxBk/1Df;AuHp+3DQ;EACI,W/Fi/BG;E+Fh/BH,Y/Fg/BG;E+F/+BH,eAAA;AvHs+3DZ;AuHh+3DQ;EACI,Y/Fw+BG;E+Fv+BH,WAAA;AvHk+3DZ;AuH/93DQ;EACI,Y/Fm+BG;E+Fl+BH,WAAA;EACA,eAAA;AvHi+3DZ;AuHlg4DI;EACI,W/FigCO;E+FhgCP,Y/FggCO;AxBog2Df;AuHjg4DI;EACI,W/F4/BO;E+F3/BP,Y/F2/BO;AxBwg2Df;AuH//3DQ;EACI,W/Fs/BG;E+Fr/BH,Y/Fq/BG;AxB4g2Df;AuH9/3DQ;EACI,W/Fi/BG;E+Fh/BH,Y/Fg/BG;E+F/+BH,eAAA;AvHgg4DZ;AuH1/3DQ;EACI,Y/Fw+BG;E+Fv+BH,aAAA;AvH4/3DZ;AuHz/3DQ;EACI,Y/Fm+BG;E+Fl+BH,aAAA;EACA,eAAA;AvH2/3DZ;AuH5h4DI;EACI,W/FigCO;E+FhgCP,Y/FggCO;AxB8h2Df;AuH3h4DI;EACI,W/F4/BO;E+F3/BP,Y/F2/BO;AxBki2Df;AuHzh4DQ;EACI,W/Fs/BG;E+Fr/BH,Y/Fq/BG;AxBsi2Df;AuHxh4DQ;EACI,W/Fi/BG;E+Fh/BH,Y/Fg/BG;E+F/+BH,eAAA;AvH0h4DZ;AuHph4DQ;EACI,Y/Fw+BG;E+Fv+BH,WAAA;AvHsh4DZ;AuHnh4DQ;EACI,Y/Fm+BG;E+Fl+BH,WAAA;EACA,eAAA;AvHqh4DZ;AuHtj4DI;EACI,W/FigCO;E+FhgCP,Y/FggCO;AxBwj2Df;AuHrj4DI;EACI,W/F4/BO;E+F3/BP,Y/F2/BO;AxB4j2Df;AuHnj4DQ;EACI,W/Fs/BG;E+Fr/BH,Y/Fq/BG;AxBgk2Df;AuHlj4DQ;EACI,W/Fi/BG;E+Fh/BH,Y/Fg/BG;E+F/+BH,eAAA;AvHoj4DZ;AuH9i4DQ;EACI,Y/Fw+BG;E+Fv+BH,aAAA;AvHgj4DZ;AuH7i4DQ;EACI,Y/Fm+BG;E+Fl+BH,aAAA;EACA,eAAA;AvH+i4DZ;AuHhl4DI;EACI,W/FigCO;E+FhgCP,Y/FggCO;AxBkl2Df;AuH/k4DI;EACI,W/F4/BO;E+F3/BP,Y/F2/BO;AxBsl2Df;AuH7k4DQ;EACI,W/Fs/BG;E+Fr/BH,Y/Fq/BG;AxB0l2Df;AuH5k4DQ;EACI,W/Fi/BG;E+Fh/BH,Y/Fg/BG;E+F/+BH,eAAA;AvH8k4DZ;AuHxk4DQ;EACI,Y/Fw+BG;E+Fv+BH,WAAA;AvH0k4DZ;AuHvk4DQ;EACI,Y/Fm+BG;E+Fl+BH,WAAA;EACA,eAAA;AvHyk4DZ;AuH1m4DI;EACI,W/FigCO;E+FhgCP,Y/FggCO;AxB4m2Df;AuHzm4DI;EACI,W/F4/BO;E+F3/BP,Y/F2/BO;AxBgn2Df;AuHvm4DQ;EACI,W/Fs/BG;E+Fr/BH,Y/Fq/BG;AxBon2Df;AuHtm4DQ;EACI,W/Fi/BG;E+Fh/BH,Y/Fg/BG;E+F/+BH,eAAA;AvHwm4DZ;AuHlm4DQ;EACI,Y/Fw+BG;E+Fv+BH,aAAA;AvHom4DZ;AuHjm4DQ;EACI,Y/Fm+BG;E+Fl+BH,aAAA;EACA,eAAA;AvHmm4DZ;AuHpo4DI;EACI,W/FigCO;E+FhgCP,Y/FggCO;AxBso2Df;AuHno4DI;EACI,W/F4/BO;E+F3/BP,Y/F2/BO;AxB0o2Df;AuHjo4DQ;EACI,W/Fs/BG;E+Fr/BH,Y/Fq/BG;AxB8o2Df;AuHho4DQ;EACI,W/Fi/BG;E+Fh/BH,Y/Fg/BG;E+F/+BH,eAAA;AvHko4DZ;AuH5n4DQ;EACI,Y/Fw+BG;E+Fv+BH,YAAA;AvH8n4DZ;AuH3n4DQ;EACI,Y/Fm+BG;E+Fl+BH,YAAA;EACA,eAAA;AvH6n4DZ;AuH9p4DI;EACI,W/FigCO;E+FhgCP,Y/FggCO;AxBgq2Df;AuH7p4DI;EACI,W/F4/BO;E+F3/BP,Y/F2/BO;AxBoq2Df;AuH3p4DQ;EACI,W/Fs/BG;E+Fr/BH,Y/Fq/BG;AxBwq2Df;AuH1p4DQ;EACI,W/Fi/BG;E+Fh/BH,Y/Fg/BG;E+F/+BH,eAAA;AvH4p4DZ;AuHtp4DQ;EACI,Y/Fw+BG;E+Fv+BH,cAAA;AvHwp4DZ;AuHrp4DQ;EACI,Y/Fm+BG;E+Fl+BH,cAAA;EACA,eAAA;AvHup4DZ;AuHxr4DI;EACI,Y/FigCO;E+FhgCP,a/FggCO;AxB0r2Df;AuHvr4DI;EACI,Y/F4/BO;E+F3/BP,a/F2/BO;AxB8r2Df;AuHrr4DQ;EACI,Y/Fs/BG;E+Fr/BH,a/Fq/BG;AxBks2Df;AuHpr4DQ;EACI,Y/Fi/BG;E+Fh/BH,a/Fg/BG;E+F/+BH,eAAA;AvHsr4DZ;AuHhr4DQ;EACI,a/Fw+BG;E+Fv+BH,YAAA;AvHkr4DZ;AuH/q4DQ;EACI,a/Fm+BG;E+Fl+BH,YAAA;EACA,eAAA;AvHir4DZ;AuHlt4DI;EACI,Y/FigCO;E+FhgCP,a/FggCO;AxBot2Df;AuHjt4DI;EACI,Y/F4/BO;E+F3/BP,a/F2/BO;AxBwt2Df;AuH/s4DQ;EACI,Y/Fs/BG;E+Fr/BH,a/Fq/BG;AxB4t2Df;AuH9s4DQ;EACI,Y/Fi/BG;E+Fh/BH,a/Fg/BG;E+F/+BH,eAAA;AvHgt4DZ;AuH1s4DQ;EACI,a/Fw+BG;E+Fv+BH,cAAA;AvH4s4DZ;AuHzs4DQ;EACI,a/Fm+BG;E+Fl+BH,cAAA;EACA,eAAA;AvH2s4DZ;AuH5u4DI;EACI,Y/FigCO;E+FhgCP,a/FggCO;AxB8u2Df;AuH3u4DI;EACI,Y/F4/BO;E+F3/BP,a/F2/BO;AxBkv2Df;AuHzu4DQ;EACI,Y/Fs/BG;E+Fr/BH,a/Fq/BG;AxBsv2Df;AuHxu4DQ;EACI,Y/Fi/BG;E+Fh/BH,a/Fg/BG;E+F/+BH,eAAA;AvH0u4DZ;AuHpu4DQ;EACI,a/Fw+BG;E+Fv+BH,YAAA;AvHsu4DZ;AuHnu4DQ;EACI,a/Fm+BG;E+Fl+BH,YAAA;EACA,eAAA;AvHqu4DZ;AuHtw4DI;EACI,Y/FigCO;E+FhgCP,a/FggCO;AxBww2Df;AuHrw4DI;EACI,Y/F4/BO;E+F3/BP,a/F2/BO;AxB4w2Df;AuHnw4DQ;EACI,Y/Fs/BG;E+Fr/BH,a/Fq/BG;AxBgx2Df;AuHlw4DQ;EACI,Y/Fi/BG;E+Fh/BH,a/Fg/BG;E+F/+BH,eAAA;AvHow4DZ;AuH9v4DQ;EACI,a/Fw+BG;E+Fv+BH,YAAA;AvHgw4DZ;AuH7v4DQ;EACI,a/Fm+BG;E+Fl+BH,YAAA;EACA,eAAA;AvH+v4DZ;AuHhy4DI;EACI,Y/FigCO;E+FhgCP,a/FggCO;AxBky2Df;AuH/x4DI;EACI,Y/F4/BO;E+F3/BP,a/F2/BO;AxBsy2Df;AuH7x4DQ;EACI,Y/Fs/BG;E+Fr/BH,a/Fq/BG;AxB0y2Df;AuH5x4DQ;EACI,Y/Fi/BG;E+Fh/BH,a/Fg/BG;E+F/+BH,eAAA;AvH8x4DZ;AuHxx4DQ;EACI,a/Fw+BG;E+Fv+BH,cAAA;AvH0x4DZ;AuHvx4DQ;EACI,a/Fm+BG;E+Fl+BH,cAAA;EACA,eAAA;AvHyx4DZ;AuH1z4DI;EACI,Y/FigCO;E+FhgCP,a/FggCO;AxB4z2Df;AuHzz4DI;EACI,Y/F4/BO;E+F3/BP,a/F2/BO;AxBg02Df;AuHvz4DQ;EACI,Y/Fs/BG;E+Fr/BH,a/Fq/BG;AxBo02Df;AuHtz4DQ;EACI,Y/Fi/BG;E+Fh/BH,a/Fg/BG;E+F/+BH,eAAA;AvHwz4DZ;AuHlz4DQ;EACI,a/Fw+BG;E+Fv+BH,YAAA;AvHoz4DZ;AuHjz4DQ;EACI,a/Fm+BG;E+Fl+BH,YAAA;EACA,eAAA;AvHmz4DZ;AU1x4DI;E6G1DA;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBu12Db;EuHp14DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExB212Db;EuHl14DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExB+12Db;EuHj14DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHm14DV;EuH704DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvH+04DV;EuH504DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvH804DV;EuH/24DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBi32Db;EuH924DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBq32Db;EuH524DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBy32Db;EuH324DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvH624DV;EuHv24DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvHy24DV;EuHt24DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvHw24DV;EuHz44DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExB242Db;EuHx44DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExB+42Db;EuHt44DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBm52Db;EuHr44DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHu44DV;EuHj44DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvHm44DV;EuHh44DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvHk44DV;EuHn64DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBq62Db;EuHl64DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBy62Db;EuHh64DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExB662Db;EuH/54DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHi64DV;EuH354DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvH654DV;EuH154DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvH454DV;EuH774DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExB+72Db;EuH574DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBm82Db;EuH174DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBu82Db;EuHz74DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvH274DV;EuHr74DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvHu74DV;EuHp74DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvHs74DV;EuHv94DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBy92Db;EuHt94DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExB692Db;EuHp94DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBi+2Db;EuHn94DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHq94DV;EuH/84DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvHi94DV;EuH984DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvHg94DV;EuHj/4DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBm/2Db;EuHh/4DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBu/2Db;EuH9+4DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExB2/2Db;EuH7+4DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvH++4DV;EuHz+4DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvH2+4DV;EuHx+4DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvH0+4DV;EuH3g5DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExB6g3Db;EuH1g5DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBih3Db;EuHxg5DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBqh3Db;EuHvg5DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHyg5DV;EuHng5DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvHqg5DV;EuHlg5DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvHog5DV;EuHri5DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBui3Db;EuHpi5DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExB2i3Db;EuHli5DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExB+i3Db;EuHji5DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHmi5DV;EuH7h5DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvH+h5DV;EuH5h5DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvH8h5DV;EuH/j5DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBik3Db;EuH9j5DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBqk3Db;EuH5j5DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExByk3Db;EuH3j5DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvH6j5DV;EuHvj5DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvHyj5DV;EuHtj5DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvHwj5DV;EuHzl5DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExB2l3Db;EuHxl5DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExB+l3Db;EuHtl5DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBmm3Db;EuHrl5DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHul5DV;EuHjl5DM;IACI,Y/Fw+BG;I+Fv+BH,YAAA;EvHml5DV;EuHhl5DM;IACI,Y/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvHkl5DV;EuHnn5DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBqn3Db;EuHln5DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExByn3Db;EuHhn5DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExB6n3Db;EuH/m5DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHin5DV;EuH3m5DM;IACI,Y/Fw+BG;I+Fv+BH,cAAA;EvH6m5DV;EuH1m5DM;IACI,Y/Fm+BG;I+Fl+BH,cAAA;IACA,eAAA;EvH4m5DV;EuH7o5DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExB+o3Db;EuH5o5DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExBmp3Db;EuH1o5DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExBup3Db;EuHzo5DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvH2o5DV;EuHro5DM;IACI,a/Fw+BG;I+Fv+BH,YAAA;EvHuo5DV;EuHpo5DM;IACI,a/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvHso5DV;EuHvq5DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExByq3Db;EuHtq5DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExB6q3Db;EuHpq5DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExBir3Db;EuHnq5DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvHqq5DV;EuH/p5DM;IACI,a/Fw+BG;I+Fv+BH,cAAA;EvHiq5DV;EuH9p5DM;IACI,a/Fm+BG;I+Fl+BH,cAAA;IACA,eAAA;EvHgq5DV;EuHjs5DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExBms3Db;EuHhs5DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExBus3Db;EuH9r5DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExB2s3Db;EuH7r5DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvH+r5DV;EuHzr5DM;IACI,a/Fw+BG;I+Fv+BH,YAAA;EvH2r5DV;EuHxr5DM;IACI,a/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvH0r5DV;EuH3t5DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExB6t3Db;EuH1t5DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExBiu3Db;EuHxt5DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExBqu3Db;EuHvt5DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvHyt5DV;EuHnt5DM;IACI,a/Fw+BG;I+Fv+BH,YAAA;EvHqt5DV;EuHlt5DM;IACI,a/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvHot5DV;EuHrv5DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExBuv3Db;EuHpv5DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExB2v3Db;EuHlv5DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExB+v3Db;EuHjv5DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvHmv5DV;EuH7u5DM;IACI,a/Fw+BG;I+Fv+BH,cAAA;EvH+u5DV;EuH5u5DM;IACI,a/Fm+BG;I+Fl+BH,cAAA;IACA,eAAA;EvH8u5DV;EuH/w5DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExBix3Db;EuH9w5DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExBqx3Db;EuH5w5DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExByx3Db;EuH3w5DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvH6w5DV;EuHvw5DM;IACI,a/Fw+BG;I+Fv+BH,YAAA;EvHyw5DV;EuHtw5DM;IACI,a/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvHww5DV;AACF;AUhv5DI;E6G1DA;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExB6y3Db;EuH1y5DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBiz3Db;EuHxy5DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBqz3Db;EuHvy5DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHyy5DV;EuHny5DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvHqy5DV;EuHly5DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvHoy5DV;EuHr05DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBu03Db;EuHp05DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExB203Db;EuHl05DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExB+03Db;EuHj05DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHm05DV;EuH7z5DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvH+z5DV;EuH5z5DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvH8z5DV;EuH/15DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBi23Db;EuH915DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBq23Db;EuH515DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBy23Db;EuH315DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvH615DV;EuHv15DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvHy15DV;EuHt15DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvHw15DV;EuHz35DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExB233Db;EuHx35DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExB+33Db;EuHt35DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBm43Db;EuHr35DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHu35DV;EuHj35DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvHm35DV;EuHh35DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvHk35DV;EuHn55DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBq53Db;EuHl55DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBy53Db;EuHh55DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExB653Db;EuH/45DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHi55DV;EuH345DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvH645DV;EuH145DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvH445DV;EuH765DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExB+63Db;EuH565DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBm73Db;EuH165DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBu73Db;EuHz65DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvH265DV;EuHr65DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvHu65DV;EuHp65DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvHs65DV;EuHv85DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBy83Db;EuHt85DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExB683Db;EuHp85DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBi93Db;EuHn85DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHq85DV;EuH/75DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvHi85DV;EuH975DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvHg85DV;EuHj+5DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBm+3Db;EuHh+5DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBu+3Db;EuH995DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExB2+3Db;EuH795DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvH+95DV;EuHz95DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvH295DV;EuHx95DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvH095DV;EuH3/5DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExB6/3Db;EuH1/5DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBig4Db;EuHx/5DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBqg4Db;EuHv/5DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHy/5DV;EuHn/5DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvHq/5DV;EuHl/5DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvHo/5DV;EuHrh6DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBuh4Db;EuHph6DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExB2h4Db;EuHlh6DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExB+h4Db;EuHjh6DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHmh6DV;EuH7g6DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvH+g6DV;EuH5g6DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvH8g6DV;EuH/i6DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBij4Db;EuH9i6DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBqj4Db;EuH5i6DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExByj4Db;EuH3i6DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvH6i6DV;EuHvi6DM;IACI,Y/Fw+BG;I+Fv+BH,YAAA;EvHyi6DV;EuHti6DM;IACI,Y/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvHwi6DV;EuHzk6DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExB2k4Db;EuHxk6DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExB+k4Db;EuHtk6DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBml4Db;EuHrk6DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHuk6DV;EuHjk6DM;IACI,Y/Fw+BG;I+Fv+BH,cAAA;EvHmk6DV;EuHhk6DM;IACI,Y/Fm+BG;I+Fl+BH,cAAA;IACA,eAAA;EvHkk6DV;EuHnm6DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExBqm4Db;EuHlm6DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExBym4Db;EuHhm6DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExB6m4Db;EuH/l6DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvHim6DV;EuH3l6DM;IACI,a/Fw+BG;I+Fv+BH,YAAA;EvH6l6DV;EuH1l6DM;IACI,a/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvH4l6DV;EuH7n6DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExB+n4Db;EuH5n6DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExBmo4Db;EuH1n6DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExBuo4Db;EuHzn6DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvH2n6DV;EuHrn6DM;IACI,a/Fw+BG;I+Fv+BH,cAAA;EvHun6DV;EuHpn6DM;IACI,a/Fm+BG;I+Fl+BH,cAAA;IACA,eAAA;EvHsn6DV;EuHvp6DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExByp4Db;EuHtp6DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExB6p4Db;EuHpp6DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExBiq4Db;EuHnp6DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvHqp6DV;EuH/o6DM;IACI,a/Fw+BG;I+Fv+BH,YAAA;EvHip6DV;EuH9o6DM;IACI,a/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvHgp6DV;EuHjr6DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExBmr4Db;EuHhr6DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExBur4Db;EuH9q6DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExB2r4Db;EuH7q6DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvH+q6DV;EuHzq6DM;IACI,a/Fw+BG;I+Fv+BH,YAAA;EvH2q6DV;EuHxq6DM;IACI,a/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvH0q6DV;EuH3s6DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExB6s4Db;EuH1s6DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExBit4Db;EuHxs6DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExBqt4Db;EuHvs6DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvHys6DV;EuHns6DM;IACI,a/Fw+BG;I+Fv+BH,cAAA;EvHqs6DV;EuHls6DM;IACI,a/Fm+BG;I+Fl+BH,cAAA;IACA,eAAA;EvHos6DV;EuHru6DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExBuu4Db;EuHpu6DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExB2u4Db;EuHlu6DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExB+u4Db;EuHju6DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvHmu6DV;EuH7t6DM;IACI,a/Fw+BG;I+Fv+BH,YAAA;EvH+t6DV;EuH5t6DM;IACI,a/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvH8t6DV;AACF;AUts6DI;E6G1DA;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBmw4Db;EuHhw6DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBuw4Db;EuH9v6DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExB2w4Db;EuH7v6DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvH+v6DV;EuHzv6DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvH2v6DV;EuHxv6DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvH0v6DV;EuH3x6DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExB6x4Db;EuH1x6DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBiy4Db;EuHxx6DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBqy4Db;EuHvx6DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHyx6DV;EuHnx6DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvHqx6DV;EuHlx6DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvHox6DV;EuHrz6DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBuz4Db;EuHpz6DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExB2z4Db;EuHlz6DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExB+z4Db;EuHjz6DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHmz6DV;EuH7y6DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvH+y6DV;EuH5y6DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvH8y6DV;EuH/06DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBi14Db;EuH906DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBq14Db;EuH506DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBy14Db;EuH306DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvH606DV;EuHv06DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvHy06DV;EuHt06DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvHw06DV;EuHz26DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExB224Db;EuHx26DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExB+24Db;EuHt26DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBm34Db;EuHr26DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHu26DV;EuHj26DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvHm26DV;EuHh26DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvHk26DV;EuHn46DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBq44Db;EuHl46DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBy44Db;EuHh46DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExB644Db;EuH/36DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHi46DV;EuH336DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvH636DV;EuH136DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvH436DV;EuH756DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExB+54Db;EuH556DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBm64Db;EuH156DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBu64Db;EuHz56DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvH256DV;EuHr56DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvHu56DV;EuHp56DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvHs56DV;EuHv76DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBy74Db;EuHt76DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExB674Db;EuHp76DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBi84Db;EuHn76DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHq76DV;EuH/66DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvHi76DV;EuH966DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvHg76DV;EuHj96DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBm94Db;EuHh96DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBu94Db;EuH986DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExB294Db;EuH786DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvH+86DV;EuHz86DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvH286DV;EuHx86DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvH086DV;EuH3+6DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExB6+4Db;EuH1+6DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBi/4Db;EuHx+6DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBq/4Db;EuHv+6DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHy+6DV;EuHn+6DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvHq+6DV;EuHl+6DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvHo+6DV;EuHrg7DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBug5Db;EuHpg7DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExB2g5Db;EuHlg7DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExB+g5Db;EuHjg7DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHmg7DV;EuH7/6DM;IACI,Y/Fw+BG;I+Fv+BH,YAAA;EvH+/6DV;EuH5/6DM;IACI,Y/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvH8/6DV;EuH/h7DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBii5Db;EuH9h7DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBqi5Db;EuH5h7DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExByi5Db;EuH3h7DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvH6h7DV;EuHvh7DM;IACI,Y/Fw+BG;I+Fv+BH,cAAA;EvHyh7DV;EuHth7DM;IACI,Y/Fm+BG;I+Fl+BH,cAAA;IACA,eAAA;EvHwh7DV;EuHzj7DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExB2j5Db;EuHxj7DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExB+j5Db;EuHtj7DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExBmk5Db;EuHrj7DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvHuj7DV;EuHjj7DM;IACI,a/Fw+BG;I+Fv+BH,YAAA;EvHmj7DV;EuHhj7DM;IACI,a/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvHkj7DV;EuHnl7DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExBql5Db;EuHll7DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExByl5Db;EuHhl7DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExB6l5Db;EuH/k7DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvHil7DV;EuH3k7DM;IACI,a/Fw+BG;I+Fv+BH,cAAA;EvH6k7DV;EuH1k7DM;IACI,a/Fm+BG;I+Fl+BH,cAAA;IACA,eAAA;EvH4k7DV;EuH7m7DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExB+m5Db;EuH5m7DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExBmn5Db;EuH1m7DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExBun5Db;EuHzm7DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvH2m7DV;EuHrm7DM;IACI,a/Fw+BG;I+Fv+BH,YAAA;EvHum7DV;EuHpm7DM;IACI,a/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvHsm7DV;EuHvo7DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExByo5Db;EuHto7DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExB6o5Db;EuHpo7DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExBip5Db;EuHno7DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvHqo7DV;EuH/n7DM;IACI,a/Fw+BG;I+Fv+BH,YAAA;EvHio7DV;EuH9n7DM;IACI,a/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvHgo7DV;EuHjq7DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExBmq5Db;EuHhq7DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExBuq5Db;EuH9p7DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExB2q5Db;EuH7p7DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvH+p7DV;EuHzp7DM;IACI,a/Fw+BG;I+Fv+BH,cAAA;EvH2p7DV;EuHxp7DM;IACI,a/Fm+BG;I+Fl+BH,cAAA;IACA,eAAA;EvH0p7DV;EuH3r7DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExB6r5Db;EuH1r7DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExBis5Db;EuHxr7DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExBqs5Db;EuHvr7DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvHyr7DV;EuHnr7DM;IACI,a/Fw+BG;I+Fv+BH,YAAA;EvHqr7DV;EuHlr7DM;IACI,a/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvHor7DV;AACF;AU5p7DI;E6G1DA;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExByt5Db;EuHtt7DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExB6t5Db;EuHpt7DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBiu5Db;EuHnt7DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHqt7DV;EuH/s7DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvHit7DV;EuH9s7DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvHgt7DV;EuHjv7DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBmv5Db;EuHhv7DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBuv5Db;EuH9u7DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExB2v5Db;EuH7u7DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvH+u7DV;EuHzu7DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvH2u7DV;EuHxu7DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvH0u7DV;EuH3w7DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExB6w5Db;EuH1w7DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBix5Db;EuHxw7DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBqx5Db;EuHvw7DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHyw7DV;EuHnw7DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvHqw7DV;EuHlw7DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvHow7DV;EuHry7DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBuy5Db;EuHpy7DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExB2y5Db;EuHly7DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExB+y5Db;EuHjy7DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHmy7DV;EuH7x7DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvH+x7DV;EuH5x7DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvH8x7DV;EuH/z7DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBi05Db;EuH9z7DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBq05Db;EuH5z7DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBy05Db;EuH3z7DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvH6z7DV;EuHvz7DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvHyz7DV;EuHtz7DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvHwz7DV;EuHz17DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExB215Db;EuHx17DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExB+15Db;EuHt17DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBm25Db;EuHr17DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHu17DV;EuHj17DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvHm17DV;EuHh17DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvHk17DV;EuHn37DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBq35Db;EuHl37DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBy35Db;EuHh37DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExB635Db;EuH/27DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHi37DV;EuH327DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvH627DV;EuH127DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvH427DV;EuH747DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExB+45Db;EuH547DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBm55Db;EuH147DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBu55Db;EuHz47DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvH247DV;EuHr47DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvHu47DV;EuHp47DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvHs47DV;EuHv67DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBy65Db;EuHt67DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExB665Db;EuHp67DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBi75Db;EuHn67DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHq67DV;EuH/57DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvHi67DV;EuH957DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvHg67DV;EuHj87DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBm85Db;EuHh87DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBu85Db;EuH977DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExB285Db;EuH777DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvH+77DV;EuHz77DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvH277DV;EuHx77DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvH077DV;EuH397DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExB695Db;EuH197DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBi+5Db;EuHx97DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBq+5Db;EuHv97DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHy97DV;EuHn97DM;IACI,Y/Fw+BG;I+Fv+BH,YAAA;EvHq97DV;EuHl97DM;IACI,Y/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvHo97DV;EuHr/7DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBu/5Db;EuHp/7DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExB2/5Db;EuHl/7DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExB+/5Db;EuHj/7DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHm/7DV;EuH7+7DM;IACI,Y/Fw+BG;I+Fv+BH,cAAA;EvH++7DV;EuH5+7DM;IACI,Y/Fm+BG;I+Fl+BH,cAAA;IACA,eAAA;EvH8+7DV;EuH/g8DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExBih6Db;EuH9g8DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExBqh6Db;EuH5g8DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExByh6Db;EuH3g8DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvH6g8DV;EuHvg8DM;IACI,a/Fw+BG;I+Fv+BH,YAAA;EvHyg8DV;EuHtg8DM;IACI,a/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvHwg8DV;EuHzi8DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExB2i6Db;EuHxi8DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExB+i6Db;EuHti8DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExBmj6Db;EuHri8DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvHui8DV;EuHji8DM;IACI,a/Fw+BG;I+Fv+BH,cAAA;EvHmi8DV;EuHhi8DM;IACI,a/Fm+BG;I+Fl+BH,cAAA;IACA,eAAA;EvHki8DV;EuHnk8DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExBqk6Db;EuHlk8DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExByk6Db;EuHhk8DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExB6k6Db;EuH/j8DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvHik8DV;EuH3j8DM;IACI,a/Fw+BG;I+Fv+BH,YAAA;EvH6j8DV;EuH1j8DM;IACI,a/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvH4j8DV;EuH7l8DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExB+l6Db;EuH5l8DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExBmm6Db;EuH1l8DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExBum6Db;EuHzl8DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvH2l8DV;EuHrl8DM;IACI,a/Fw+BG;I+Fv+BH,YAAA;EvHul8DV;EuHpl8DM;IACI,a/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvHsl8DV;EuHvn8DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExByn6Db;EuHtn8DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExB6n6Db;EuHpn8DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExBio6Db;EuHnn8DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvHqn8DV;EuH/m8DM;IACI,a/Fw+BG;I+Fv+BH,cAAA;EvHin8DV;EuH9m8DM;IACI,a/Fm+BG;I+Fl+BH,cAAA;IACA,eAAA;EvHgn8DV;EuHjp8DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExBmp6Db;EuHhp8DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExBup6Db;EuH9o8DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExB2p6Db;EuH7o8DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvH+o8DV;EuHzo8DM;IACI,a/Fw+BG;I+Fv+BH,YAAA;EvH2o8DV;EuHxo8DM;IACI,a/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvH0o8DV;AACF;AUln8DI;E6G1DA;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExB+q6Db;EuH5q8DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBmr6Db;EuH1q8DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBur6Db;EuHzq8DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvH2q8DV;EuHrq8DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvHuq8DV;EuHpq8DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvHsq8DV;EuHvs8DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBys6Db;EuHts8DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExB6s6Db;EuHps8DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBit6Db;EuHns8DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHqs8DV;EuH/r8DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvHis8DV;EuH9r8DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvHgs8DV;EuHju8DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBmu6Db;EuHhu8DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBuu6Db;EuH9t8DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExB2u6Db;EuH7t8DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvH+t8DV;EuHzt8DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvH2t8DV;EuHxt8DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvH0t8DV;EuH3v8DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExB6v6Db;EuH1v8DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBiw6Db;EuHxv8DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBqw6Db;EuHvv8DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHyv8DV;EuHnv8DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvHqv8DV;EuHlv8DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvHov8DV;EuHrx8DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBux6Db;EuHpx8DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExB2x6Db;EuHlx8DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExB+x6Db;EuHjx8DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHmx8DV;EuH7w8DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvH+w8DV;EuH5w8DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvH8w8DV;EuH/y8DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBiz6Db;EuH9y8DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBqz6Db;EuH5y8DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExByz6Db;EuH3y8DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvH6y8DV;EuHvy8DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvHyy8DV;EuHty8DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvHwy8DV;EuHz08DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExB206Db;EuHx08DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExB+06Db;EuHt08DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBm16Db;EuHr08DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHu08DV;EuHj08DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvHm08DV;EuHh08DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvHk08DV;EuHn28DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBq26Db;EuHl28DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBy26Db;EuHh28DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExB626Db;EuH/18DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHi28DV;EuH318DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvH618DV;EuH118DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvH418DV;EuH738DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExB+36Db;EuH538DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBm46Db;EuH138DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBu46Db;EuHz38DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvH238DV;EuHr38DM;IACI,Y/Fw+BG;I+Fv+BH,WAAA;EvHu38DV;EuHp38DM;IACI,Y/Fm+BG;I+Fl+BH,WAAA;IACA,eAAA;EvHs38DV;EuHv58DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBy56Db;EuHt58DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExB656Db;EuHp58DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBi66Db;EuHn58DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHq58DV;EuH/48DM;IACI,Y/Fw+BG;I+Fv+BH,aAAA;EvHi58DV;EuH948DM;IACI,Y/Fm+BG;I+Fl+BH,aAAA;IACA,eAAA;EvHg58DV;EuHj78DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExBm76Db;EuHh78DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBu76Db;EuH968DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExB276Db;EuH768DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvH+68DV;EuHz68DM;IACI,Y/Fw+BG;I+Fv+BH,YAAA;EvH268DV;EuHx68DM;IACI,Y/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvH068DV;EuH388DE;IACI,W/FigCO;I+FhgCP,Y/FggCO;ExB686Db;EuH188DE;IACI,W/F4/BO;I+F3/BP,Y/F2/BO;ExBi96Db;EuHx88DM;IACI,W/Fs/BG;I+Fr/BH,Y/Fq/BG;ExBq96Db;EuHv88DM;IACI,W/Fi/BG;I+Fh/BH,Y/Fg/BG;I+F/+BH,eAAA;EvHy88DV;EuHn88DM;IACI,Y/Fw+BG;I+Fv+BH,cAAA;EvHq88DV;EuHl88DM;IACI,Y/Fm+BG;I+Fl+BH,cAAA;IACA,eAAA;EvHo88DV;EuHr+8DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExBu+6Db;EuHp+8DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExB2+6Db;EuHl+8DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExB++6Db;EuHj+8DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvHm+8DV;EuH798DM;IACI,a/Fw+BG;I+Fv+BH,YAAA;EvH+98DV;EuH598DM;IACI,a/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvH898DV;EuH//8DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExBig7Db;EuH9/8DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExBqg7Db;EuH5/8DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExByg7Db;EuH3/8DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvH6/8DV;EuHv/8DM;IACI,a/Fw+BG;I+Fv+BH,cAAA;EvHy/8DV;EuHt/8DM;IACI,a/Fm+BG;I+Fl+BH,cAAA;IACA,eAAA;EvHw/8DV;EuHzh9DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExB2h7Db;EuHxh9DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExB+h7Db;EuHth9DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExBmi7Db;EuHrh9DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvHuh9DV;EuHjh9DM;IACI,a/Fw+BG;I+Fv+BH,YAAA;EvHmh9DV;EuHhh9DM;IACI,a/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvHkh9DV;EuHnj9DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExBqj7Db;EuHlj9DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExByj7Db;EuHhj9DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExB6j7Db;EuH/i9DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvHij9DV;EuH3i9DM;IACI,a/Fw+BG;I+Fv+BH,YAAA;EvH6i9DV;EuH1i9DM;IACI,a/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvH4i9DV;EuH7k9DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExB+k7Db;EuH5k9DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExBml7Db;EuH1k9DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExBul7Db;EuHzk9DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvH2k9DV;EuHrk9DM;IACI,a/Fw+BG;I+Fv+BH,cAAA;EvHuk9DV;EuHpk9DM;IACI,a/Fm+BG;I+Fl+BH,cAAA;IACA,eAAA;EvHsk9DV;EuHvm9DE;IACI,Y/FigCO;I+FhgCP,a/FggCO;ExBym7Db;EuHtm9DE;IACI,Y/F4/BO;I+F3/BP,a/F2/BO;ExB6m7Db;EuHpm9DM;IACI,Y/Fs/BG;I+Fr/BH,a/Fq/BG;ExBin7Db;EuHnm9DM;IACI,Y/Fi/BG;I+Fh/BH,a/Fg/BG;I+F/+BH,eAAA;EvHqm9DV;EuH/l9DM;IACI,a/Fw+BG;I+Fv+BH,YAAA;EvHim9DV;EuH9l9DM;IACI,a/Fm+BG;I+Fl+BH,YAAA;IACA,eAAA;EvHgm9DV;AACF;;AsHvj9DA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AtH0j9DJ;AsHxj9DI;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AtH0j9DR;AsHxj9DQ;EACI,yBAAA;EACA,UAAA;AtH0j9DZ;AsHrj9DQ;EACI,eAAA;AtHuj9DZ;;AwHtp9DA;EACI,kBAAA;AxHyp9DJ;AwHpp9DY;EACI,qBhG2GD;AxB2i9Df;AwHvp9DY;EACI,qBhG2GD;AxB8i9Df;AwH1p9DY;EACI,qBhG2GD;AxBij9Df;AwH7p9DY;EACI,qBhG2GD;AxBoj9Df;AwHhq9DY;EACI,qBhG2GD;AxBuj9Df;AwHnq9DY;EACI,qBhG2GD;AxB0j9Df;AwHtq9DY;EACI,qBhG2GD;AxB6j9Df;AwHzq9DY;EACI,qBhG2GD;AxBgk9Df;AwH5q9DY;EACI,qBhG2GD;AxBmk9Df;;AwHxq9DA;EACI,cAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,wCAAA;EACA,mCAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBhGlBqB;AxB6r9DzB;;AwHxq9DA;EACI;IAAI,kCAAA;IAAoC,UAAA;ExH6q9D1C;EwH5q9DE;IAAK,kCAAA;IAAoC,UAAA;ExHgr9D3C;EwH/q9DE;IAAK,UAAA;ExHkr9DP;EwHjr9DE;IAAM,kCAAA;IAAoC,UAAA;ExHqr9D5C;AACF;AyHtt9DA;EACI,2BAAA;AzHwt9DJ;;AyHpt9DA;EACC,mBjG6OmD;EiG5OnD,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACG,aAAA;AzHut9DJ;AyHrt9DI;EACF,aAAA;EACA,uBAAA;EACG,mBAAA;AzHut9DL;;A0H1u9DA;EACI,eAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,uDlGyVgC;EkGxVhC,UAAA;EACA,uDlG8TgD;EC7ThD,uBAAA;AzB6u9DJ;AgFnu9DI;EACI,YAAA;EACA,WAAA;AhFqu9DR;AgF7v9DQ;EACI,0BAAA;EACA,aAAA;AhF+v9DZ;AgF3v9DY;EACI,0BAAA;AhF6v9DhB;A0Hjv9DI;EACI,iBAAA;EACA,cAAA;A1Hmv9DR;A0Hhv9DI;EACI,yBAAA;A1Hkv9DR;A0Hhv9DQ;EACI,cAAA;A1Hkv9DZ;AgF9w9DQ;EACI,0BAAA;EACA,aAAA;AhFgx9DZ;AgF5w9DY;EACI,0BAAA;AhF8w9DhB;A0Hjv9DI;EACI,YAAA;EACA,8CAAA;EACA,aAAA;A1Hmv9DR;A0Hjv9DQ;EACI,uDlG+RwC;EkG9RxC,UAAA;A1Hmv9DZ;AUzt9DI;EgHxEJ;IAoDQ,YAAA;IACA,WAAA;IACA,WAAA;IACA,YAAA;E1Hiv9DN;AACF;;A0H7u9DA;EACI;IAAS,oBAAA;E1Hiv9DX;E0Hhv9DE;IAAM,gBAAA;E1Hmv9DR;AACF;A2Hlz9DA;EACI,cAAA;A3Hoz9DJ;AgF5x9DI;EACI,eAAA;EACA,cAAA;AhF8x9DR;AgFtz9DQ;EACI,0BAAA;EACA,aAAA;AhFwz9DZ;AgFpz9DY;EACI,0BAAA;AhFsz9DhB;AgF7z9DQ;EACI,0BAAA;EACA,aAAA;AhF+z9DZ;AgF3z9DY;EACI,0BAAA;AhF6z9DhB;AgFp09DQ;EACI,0BAAA;EACA,aAAA;AhFs09DZ;AgFl09DY;EACI,0BAAA;AhFo09DhB;AgF309DQ;EACI,0BAAA;EACA,aAAA;AhF609DZ;AgFz09DY;EACI,0BAAA;AhF209DhB;AgFl19DQ;EACI,0BAAA;EACA,aAAA;AhFo19DZ;AgFh19DY;EACI,0BAAA;AhFk19DhB;AgFz19DQ;EACI,0BAAA;EACA,aAAA;AhF219DZ;AgFv19DY;EACI,0BAAA;AhFy19DhB;AgFh29DQ;EACI,0BAAA;EACA,aAAA;AhFk29DZ;AgF919DY;EACI,0BAAA;AhFg29DhB;AgFv29DQ;EACI,0BAAA;EACA,aAAA;AhFy29DZ;AgFr29DY;EACI,0BAAA;AhFu29DhB;AgF929DQ;EACI,0BAAA;EACA,aAAA;AhFg39DZ;AgF529DY;EACI,0BAAA;AhF829DhB;AgFr39DQ;EACI,0BAAA;EACA,aAAA;AhFu39DZ;AgFn39DY;EACI,0BAAA;AhFq39DhB;AgF539DQ;EACI,0BAAA;EACA,aAAA;AhF839DZ;AgF139DY;EACI,0BAAA;AhF439DhB;AgFn49DQ;EACI,0BAAA;EACA,aAAA;AhFq49DZ;AgFj49DY;EACI,0BAAA;AhFm49DhB;AgF149DQ;EACI,0BAAA;EACA,aAAA;AhF449DZ;AgFx49DY;EACI,0BAAA;AhF049DhB;AgFj59DQ;EACI,0BAAA;EACA,aAAA;AhFm59DZ;AgF/49DY;EACI,0BAAA;AhFi59DhB;AgFx59DQ;EACI,0BAAA;EACA,aAAA;AhF059DZ;AgFt59DY;EACI,0BAAA;AhFw59DhB;AgF/59DQ;EACI,0BAAA;EACA,aAAA;AhFi69DZ;AgF759DY;EACI,0BAAA;AhF+59DhB;AgFt69DQ;EACI,0BAAA;EACA,aAAA;AhFw69DZ;AgFp69DY;EACI,0BAAA;AhFs69DhB;AgF769DQ;EACI,0BAAA;EACA,aAAA;AhF+69DZ;AgF369DY;EACI,0BAAA;AhF669DhB;AgFp79DQ;EACI,0BAAA;EACA,aAAA;AhFs79DZ;AgFl79DY;EACI,0BAAA;AhFo79DhB;AgF379DQ;EACI,0BAAA;EACA,aAAA;AhF679DZ;AgFz79DY;EACI,0BAAA;AhF279DhB;AgF569DI;EACI,0BAAA;EACA,yBAAA;AhF869DR;AgFh79DI;EACI,yBAAA;EACA,wBAAA;AhFk79DR;AgFp79DI;EACI,0BAAA;EACA,yBAAA;AhFs79DR;AgFx79DI;EACI,0BAAA;EACA,yBAAA;AhF079DR;AgF579DI;EACI,0BAAA;EACA,yBAAA;AhF879DR;AgFh89DI;EACI,2BAAA;EACA,0BAAA;AhFk89DR;AgFp89DI;EACI,0BAAA;EACA,yBAAA;AhFs89DR;AgFx89DI;EACI,0BAAA;EACA,yBAAA;AhF089DR;AgF589DI;EACI,0BAAA;EACA,yBAAA;AhF889DR;AgFh99DI;EACI,yBAAA;EACA,wBAAA;AhFk99DR;AgFp99DI;EACI,uBAAA;EACA,sBAAA;AhFs99DR;AgFx99DI;EACI,uBAAA;EACA,sBAAA;AhF099DR;AgF599DI;EACI,uBAAA;EACA,sBAAA;AhF899DR;AgFh+9DI;EACI,0BAAA;EACA,yBAAA;AhFk+9DR;AgFp+9DI;EACI,yBAAA;EACA,wBAAA;AhFs+9DR;AgFx+9DI;EACI,0BAAA;EACA,yBAAA;AhF0+9DR;AgF5+9DI;EACI,uBAAA;EACA,sBAAA;AhF8+9DR;AgFh/9DI;EACI,0BAAA;EACA,yBAAA;AhFk/9DR;AgFp/9DI;EACI,yBAAA;EACA,wBAAA;AhFs/9DR;AgFx/9DI;EACI,0BAAA;EACA,yBAAA;AhF0/9DR;AgF5/9DI;EACI,uBAAA;EACA,sBAAA;AhF8/9DR;AgFhg+DI;EACI,0BAAA;EACA,yBAAA;AhFkg+DR;AgFpg+DI;EACI,yBAAA;EACA,wBAAA;AhFsg+DR;AgFxg+DI;EACI,0BAAA;EACA,yBAAA;AhF0g+DR;AgF5g+DI;EACI,uBAAA;EACA,sBAAA;AhF8g+DR;AgFhh+DI;EACI,0BAAA;EACA,yBAAA;AhFkh+DR;AgFph+DI;EACI,yBAAA;EACA,wBAAA;AhFsh+DR;AgFxh+DI;EACI,0BAAA;EACA,yBAAA;AhF0h+DR;AU1/9DI;EsElCA;IACI,0BAAA;IACA,yBAAA;EhF+h+DN;EgFji+DE;IACI,yBAAA;IACA,wBAAA;EhFmi+DN;EgFri+DE;IACI,0BAAA;IACA,yBAAA;EhFui+DN;EgFzi+DE;IACI,0BAAA;IACA,yBAAA;EhF2i+DN;EgF7i+DE;IACI,0BAAA;IACA,yBAAA;EhF+i+DN;EgFjj+DE;IACI,2BAAA;IACA,0BAAA;EhFmj+DN;EgFrj+DE;IACI,0BAAA;IACA,yBAAA;EhFuj+DN;EgFzj+DE;IACI,0BAAA;IACA,yBAAA;EhF2j+DN;EgF7j+DE;IACI,0BAAA;IACA,yBAAA;EhF+j+DN;EgFjk+DE;IACI,yBAAA;IACA,wBAAA;EhFmk+DN;EgFrk+DE;IACI,uBAAA;IACA,sBAAA;EhFuk+DN;EgFzk+DE;IACI,uBAAA;IACA,sBAAA;EhF2k+DN;EgF7k+DE;IACI,uBAAA;IACA,sBAAA;EhF+k+DN;EgFjl+DE;IACI,0BAAA;IACA,yBAAA;EhFml+DN;EgFrl+DE;IACI,yBAAA;IACA,wBAAA;EhFul+DN;EgFzl+DE;IACI,0BAAA;IACA,yBAAA;EhF2l+DN;EgF7l+DE;IACI,uBAAA;IACA,sBAAA;EhF+l+DN;EgFjm+DE;IACI,0BAAA;IACA,yBAAA;EhFmm+DN;EgFrm+DE;IACI,yBAAA;IACA,wBAAA;EhFum+DN;EgFzm+DE;IACI,0BAAA;IACA,yBAAA;EhF2m+DN;EgF7m+DE;IACI,uBAAA;IACA,sBAAA;EhF+m+DN;EgFjn+DE;IACI,0BAAA;IACA,yBAAA;EhFmn+DN;EgFrn+DE;IACI,yBAAA;IACA,wBAAA;EhFun+DN;EgFzn+DE;IACI,0BAAA;IACA,yBAAA;EhF2n+DN;EgF7n+DE;IACI,uBAAA;IACA,sBAAA;EhF+n+DN;EgFjo+DE;IACI,0BAAA;IACA,yBAAA;EhFmo+DN;EgFro+DE;IACI,yBAAA;IACA,wBAAA;EhFuo+DN;EgFzo+DE;IACI,0BAAA;IACA,yBAAA;EhF2o+DN;AACF;AU5m+DI;EsElCA;IACI,0BAAA;IACA,yBAAA;EhFip+DN;EgFnp+DE;IACI,yBAAA;IACA,wBAAA;EhFqp+DN;EgFvp+DE;IACI,0BAAA;IACA,yBAAA;EhFyp+DN;EgF3p+DE;IACI,0BAAA;IACA,yBAAA;EhF6p+DN;EgF/p+DE;IACI,0BAAA;IACA,yBAAA;EhFiq+DN;EgFnq+DE;IACI,2BAAA;IACA,0BAAA;EhFqq+DN;EgFvq+DE;IACI,0BAAA;IACA,yBAAA;EhFyq+DN;EgF3q+DE;IACI,0BAAA;IACA,yBAAA;EhF6q+DN;EgF/q+DE;IACI,0BAAA;IACA,yBAAA;EhFir+DN;EgFnr+DE;IACI,yBAAA;IACA,wBAAA;EhFqr+DN;EgFvr+DE;IACI,uBAAA;IACA,sBAAA;EhFyr+DN;EgF3r+DE;IACI,uBAAA;IACA,sBAAA;EhF6r+DN;EgF/r+DE;IACI,uBAAA;IACA,sBAAA;EhFis+DN;EgFns+DE;IACI,0BAAA;IACA,yBAAA;EhFqs+DN;EgFvs+DE;IACI,yBAAA;IACA,wBAAA;EhFys+DN;EgF3s+DE;IACI,0BAAA;IACA,yBAAA;EhF6s+DN;EgF/s+DE;IACI,uBAAA;IACA,sBAAA;EhFit+DN;EgFnt+DE;IACI,0BAAA;IACA,yBAAA;EhFqt+DN;EgFvt+DE;IACI,yBAAA;IACA,wBAAA;EhFyt+DN;EgF3t+DE;IACI,0BAAA;IACA,yBAAA;EhF6t+DN;EgF/t+DE;IACI,uBAAA;IACA,sBAAA;EhFiu+DN;EgFnu+DE;IACI,0BAAA;IACA,yBAAA;EhFqu+DN;EgFvu+DE;IACI,yBAAA;IACA,wBAAA;EhFyu+DN;EgF3u+DE;IACI,0BAAA;IACA,yBAAA;EhF6u+DN;EgF/u+DE;IACI,uBAAA;IACA,sBAAA;EhFiv+DN;EgFnv+DE;IACI,0BAAA;IACA,yBAAA;EhFqv+DN;EgFvv+DE;IACI,yBAAA;IACA,wBAAA;EhFyv+DN;EgF3v+DE;IACI,0BAAA;IACA,yBAAA;EhF6v+DN;AACF;AU9t+DI;EsElCA;IACI,0BAAA;IACA,yBAAA;EhFmw+DN;EgFrw+DE;IACI,yBAAA;IACA,wBAAA;EhFuw+DN;EgFzw+DE;IACI,0BAAA;IACA,yBAAA;EhF2w+DN;EgF7w+DE;IACI,0BAAA;IACA,yBAAA;EhF+w+DN;EgFjx+DE;IACI,0BAAA;IACA,yBAAA;EhFmx+DN;EgFrx+DE;IACI,2BAAA;IACA,0BAAA;EhFux+DN;EgFzx+DE;IACI,0BAAA;IACA,yBAAA;EhF2x+DN;EgF7x+DE;IACI,0BAAA;IACA,yBAAA;EhF+x+DN;EgFjy+DE;IACI,0BAAA;IACA,yBAAA;EhFmy+DN;EgFry+DE;IACI,yBAAA;IACA,wBAAA;EhFuy+DN;EgFzy+DE;IACI,uBAAA;IACA,sBAAA;EhF2y+DN;EgF7y+DE;IACI,uBAAA;IACA,sBAAA;EhF+y+DN;EgFjz+DE;IACI,uBAAA;IACA,sBAAA;EhFmz+DN;EgFrz+DE;IACI,0BAAA;IACA,yBAAA;EhFuz+DN;EgFzz+DE;IACI,yBAAA;IACA,wBAAA;EhF2z+DN;EgF7z+DE;IACI,0BAAA;IACA,yBAAA;EhF+z+DN;EgFj0+DE;IACI,uBAAA;IACA,sBAAA;EhFm0+DN;EgFr0+DE;IACI,0BAAA;IACA,yBAAA;EhFu0+DN;EgFz0+DE;IACI,yBAAA;IACA,wBAAA;EhF20+DN;EgF70+DE;IACI,0BAAA;IACA,yBAAA;EhF+0+DN;EgFj1+DE;IACI,uBAAA;IACA,sBAAA;EhFm1+DN;EgFr1+DE;IACI,0BAAA;IACA,yBAAA;EhFu1+DN;EgFz1+DE;IACI,yBAAA;IACA,wBAAA;EhF21+DN;EgF71+DE;IACI,0BAAA;IACA,yBAAA;EhF+1+DN;EgFj2+DE;IACI,uBAAA;IACA,sBAAA;EhFm2+DN;EgFr2+DE;IACI,0BAAA;IACA,yBAAA;EhFu2+DN;EgFz2+DE;IACI,yBAAA;IACA,wBAAA;EhF22+DN;EgF72+DE;IACI,0BAAA;IACA,yBAAA;EhF+2+DN;AACF;AUh1+DI;EsElCA;IACI,0BAAA;IACA,yBAAA;EhFq3+DN;EgFv3+DE;IACI,yBAAA;IACA,wBAAA;EhFy3+DN;EgF33+DE;IACI,0BAAA;IACA,yBAAA;EhF63+DN;EgF/3+DE;IACI,0BAAA;IACA,yBAAA;EhFi4+DN;EgFn4+DE;IACI,0BAAA;IACA,yBAAA;EhFq4+DN;EgFv4+DE;IACI,2BAAA;IACA,0BAAA;EhFy4+DN;EgF34+DE;IACI,0BAAA;IACA,yBAAA;EhF64+DN;EgF/4+DE;IACI,0BAAA;IACA,yBAAA;EhFi5+DN;EgFn5+DE;IACI,0BAAA;IACA,yBAAA;EhFq5+DN;EgFv5+DE;IACI,yBAAA;IACA,wBAAA;EhFy5+DN;EgF35+DE;IACI,uBAAA;IACA,sBAAA;EhF65+DN;EgF/5+DE;IACI,uBAAA;IACA,sBAAA;EhFi6+DN;EgFn6+DE;IACI,uBAAA;IACA,sBAAA;EhFq6+DN;EgFv6+DE;IACI,0BAAA;IACA,yBAAA;EhFy6+DN;EgF36+DE;IACI,yBAAA;IACA,wBAAA;EhF66+DN;EgF/6+DE;IACI,0BAAA;IACA,yBAAA;EhFi7+DN;EgFn7+DE;IACI,uBAAA;IACA,sBAAA;EhFq7+DN;EgFv7+DE;IACI,0BAAA;IACA,yBAAA;EhFy7+DN;EgF37+DE;IACI,yBAAA;IACA,wBAAA;EhF67+DN;EgF/7+DE;IACI,0BAAA;IACA,yBAAA;EhFi8+DN;EgFn8+DE;IACI,uBAAA;IACA,sBAAA;EhFq8+DN;EgFv8+DE;IACI,0BAAA;IACA,yBAAA;EhFy8+DN;EgF38+DE;IACI,yBAAA;IACA,wBAAA;EhF68+DN;EgF/8+DE;IACI,0BAAA;IACA,yBAAA;EhFi9+DN;EgFn9+DE;IACI,uBAAA;IACA,sBAAA;EhFq9+DN;EgFv9+DE;IACI,0BAAA;IACA,yBAAA;EhFy9+DN;EgF39+DE;IACI,yBAAA;IACA,wBAAA;EhF69+DN;EgF/9+DE;IACI,0BAAA;IACA,yBAAA;EhFi++DN;AACF;AUl8+DI;EsElCA;IACI,0BAAA;IACA,yBAAA;EhFu++DN;EgFz++DE;IACI,yBAAA;IACA,wBAAA;EhF2++DN;EgF7++DE;IACI,0BAAA;IACA,yBAAA;EhF+++DN;EgFj/+DE;IACI,0BAAA;IACA,yBAAA;EhFm/+DN;EgFr/+DE;IACI,0BAAA;IACA,yBAAA;EhFu/+DN;EgFz/+DE;IACI,2BAAA;IACA,0BAAA;EhF2/+DN;EgF7/+DE;IACI,0BAAA;IACA,yBAAA;EhF+/+DN;EgFjg/DE;IACI,0BAAA;IACA,yBAAA;EhFmg/DN;EgFrg/DE;IACI,0BAAA;IACA,yBAAA;EhFug/DN;EgFzg/DE;IACI,yBAAA;IACA,wBAAA;EhF2g/DN;EgF7g/DE;IACI,uBAAA;IACA,sBAAA;EhF+g/DN;EgFjh/DE;IACI,uBAAA;IACA,sBAAA;EhFmh/DN;EgFrh/DE;IACI,uBAAA;IACA,sBAAA;EhFuh/DN;EgFzh/DE;IACI,0BAAA;IACA,yBAAA;EhF2h/DN;EgF7h/DE;IACI,yBAAA;IACA,wBAAA;EhF+h/DN;EgFji/DE;IACI,0BAAA;IACA,yBAAA;EhFmi/DN;EgFri/DE;IACI,uBAAA;IACA,sBAAA;EhFui/DN;EgFzi/DE;IACI,0BAAA;IACA,yBAAA;EhF2i/DN;EgF7i/DE;IACI,yBAAA;IACA,wBAAA;EhF+i/DN;EgFjj/DE;IACI,0BAAA;IACA,yBAAA;EhFmj/DN;EgFrj/DE;IACI,uBAAA;IACA,sBAAA;EhFuj/DN;EgFzj/DE;IACI,0BAAA;IACA,yBAAA;EhF2j/DN;EgF7j/DE;IACI,yBAAA;IACA,wBAAA;EhF+j/DN;EgFjk/DE;IACI,0BAAA;IACA,yBAAA;EhFmk/DN;EgFrk/DE;IACI,uBAAA;IACA,sBAAA;EhFuk/DN;EgFzk/DE;IACI,0BAAA;IACA,yBAAA;EhF2k/DN;EgF7k/DE;IACI,yBAAA;IACA,wBAAA;EhF+k/DN;EgFjl/DE;IACI,0BAAA;IACA,yBAAA;EhFml/DN;AACF;;A4H5m/DC;EACC,kBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;A5H+m/DF;A4H5m/DG;EACC,YAAA;A5H8m/DJ;A4Hxm/DC;EACC,cAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;EACA,0BpGxBuB;AxBko/DzB;A4Htm/DC;EACC,UAAA;EACA,cAAA;EACA,kBAAA;A5Hwm/DF;A4Hpm/DC;EACC,WAAA;EACA,cAAA;EACA,qBAAA;A5Hsm/DF;A4Hjm/DE;EACC,mBAAA;A5Hmm/DH;A4Hhm/DgB;EACI,QAAA;A5Hkm/DpB;A4H7l/DgB;EACI,WAAA;A5H+l/DpB;;A6H1p/DA;EACI,kBAAA;A7H6p/DJ;A6Hvp/DI;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qCAAA;EACA,yBAAA;EACA,UAAA;A7Hyp/DR;A6Hnp/DQ;EACI,yBAAA;EACA,UAAA;A7Hqp/DZ;A6Hjp/DI;EACI,YAAA;A7Hmp/DR;;A8Hlr/DA;EACI,qBAAA;EACA,yBAAA;ErGYA,kBAAA;EqGVA,UAAA;EACA,WAAA;EACA,cAAA;A9Hqr/DJ;;A8Hjr/DA;EACI,UAAA;EACA,WAAA;EACA,8BAAA;A9Hor/DJ;;A8Hhr/DA;EACI,UAAA;EACA,WAAA;A9Hmr/DJ;;A8H/q/DA;EACI,UAAA;EACA,WAAA;EACA,mBAAA;A9Hkr/DJ;;A+H5s/DA;EACC,wBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,yBAAA;EACA,sCAAA;A/H+s/DD;A+H7s/DC;EACC,OAAA;EACA,4BAAA;A/H+s/DF;A+H5s/DC;EACC,QAAA;EACA,2BAAA;A/H8s/DF;A+H3s/DC;EACC,eAAA;EACA,gDAAA;EACA,sCAAA;A/H6s/DF;;A+Hxs/DA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,oCAAA;EACA,sDAAA;A/H2s/DD;;A+Hvs/DA;EACC,aAAA;A/H0s/DD;;A+Hts/DA;EACC;IAAS,UAAA;E/H0s/DR;E+Hzs/DD;IAAK,UAAA;E/H4s/DJ;AACF;AUtr/DI;EqHlBH;IACC,gBAAA;E/H2s/DA;AACF;AgIjw/DI;EAEI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,exG40B4C;EwG30B5C,kBxG20B4C;EwG10B5C,iBAAA;AhIkw/DR;AgI9v/DI;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,cxGk0B4C;AxB879DpD;AgI5v/DI;EACI,iBxG8zB4C;EwG7zB5C,kBxGqzB4C;AxBy89DpD;AgI5v/DQ;EACI,axG0zBwC;EwGzzBxC,cxGyzBwC;AxBq89DpD;AgI1v/DI;EACI,exGqzB4C;EwGpzB5C,exG4yB4C;AxBg99DpD;AgI1v/DQ;EACI,WxGizBwC;EwGhzBxC,YxGgzBwC;AxB489DpD;;AgItv/DI;EACI,cAAA;EACA,yBxGuEO;AxBkr/Df;;AgItv/DI;EACI,cxGmEO;AxBsr/Df;;AgI/v/DI;EACI,cAAA;EACA,yBxGuEO;AxB2r/Df;;AgI/v/DI;EACI,cxGmEO;AxB+r/Df;;AgIxw/DI;EACI,cAAA;EACA,yBxGuEO;AxBos/Df;;AgIxw/DI;EACI,cxGmEO;EwGlEP,yBAAA;AhI2w/DR;;AgIlx/DI;EACI,cAAA;EACA,yBxGuEO;AxB8s/Df;;AgIlx/DI;EACI,cxGmEO;AxBkt/Df;;AgI3x/DI;EACI,cAAA;EACA,yBxGuEO;AxBut/Df;;AgI3x/DI;EACI,cxGmEO;EwGlEP,yBAAA;AhI8x/DR;;AgIry/DI;EACI,cAAA;EACA,yBxGuEO;AxBiu/Df;;AgIry/DI;EACI,cxGmEO;EwGlEP,yBAAA;AhIwy/DR;;AgI/y/DI;EACI,cAAA;EACA,yBxGuEO;AxB2u/Df;;AgI/y/DI;EACI,cxGmEO;EwGlEP,yBAAA;AhIkz/DR;;AgIzz/DI;EACI,cAAA;EACA,yBxGuEO;AxBqv/Df;;AgIzz/DI;EACI,cxGmEO;EwGlEP,yBAAA;AhI4z/DR;;AgIn0/DI;EACI,cAAA;EACA,yBxGuEO;AxB+v/Df;;AgIn0/DI;EACI,cxGmEO;EwGlEP,yBAAA;AhIs0/DR;;AiIx3/DA;EACI,aAAA;AjI23/DJ;AiIz3/DI;EACI,qBAAA;AjI23/DR;;AiIt3/DI;EACI,aAAA;AjIy3/DR;;AkIh4/DA;EACI,oBAAA;EACA,mBAAA;AlIm4/DJ;;AkI/3/DI;EACI,+BATY;EAUZ,mCAAA;AlIk4/DR;AkIh4/DQ;EAGI,yBAAA;EACA,+BAhBQ;AlIg5/DpB;AkI93/DY;EAEI,0BAAA;AlI+3/DhB;;AkI13/DI;EACI,+BA1BY;EA2BZ,mCAAA;AlI63/DR;AkI33/DQ;EAGI,0BAAA;EACA,+BAjCQ;AlI45/DpB;AkIz3/DY;EAEI,yBAAA;AlI03/DhB;;AkIv5/DI;EACI,+BATY;EAUZ,mCAAA;AlI05/DR;AkIx5/DQ;EAGI,0BAAA;EACA,+BAhBQ;AlIw6/DpB;AkIt5/DY;EAEI,2BAAA;AlIu5/DhB;;AkIl5/DI;EACI,+BA1BY;EA2BZ,mCAAA;AlIq5/DR;AkIn5/DQ;EAGI,2BAAA;EACA,+BAjCQ;AlIo7/DpB;AkIj5/DY;EAEI,0BAAA;AlIk5/DhB;;AkI/6/DI;EACI,+BATY;EAUZ,mCAAA;AlIk7/DR;AkIh7/DQ;EAGI,0BAAA;EACA,+BAhBQ;AlIg8/DpB;AkI96/DY;EAEI,2BAAA;AlI+6/DhB;;AkI16/DI;EACI,+BA1BY;EA2BZ,mCAAA;AlI66/DR;AkI36/DQ;EAGI,2BAAA;EACA,+BAjCQ;AlI48/DpB;AkIz6/DY;EAEI,0BAAA;AlI06/DhB;;AUr5/DI;EyHxDA;;;;;;IAOI,qBAAA;ICRJ,oCAAA;EpIy9/DF;EmI98/DM;;;;;;IACI,aAAA;IACA,cAAA;EnIq9/DV;EoI/9/DE;;;;;;IACI,yBDayB;EnIy9/D/B;EoIj+/DM;;;;;;IAEI,oCAAA;EpIu+/DV;EoIp+/DU;;;;;;IACI,yBDEyC;EnIy+/DvD;AACF;AmIr+/DA;EACI,gBAAA;EACA,kBAAA;AnIu+/DJ;AUz7/DI;EyHhDJ;IAMQ,cAAA;EnIu+/DN;AACF;;AmIp+/DA;EACI,kBAAA;EACA,kBAAA;AnIu+/DJ;AUn8/DI;EyHtCJ;IAMQ,gBAAA;EnIu+/DN;AACF;;AmIp+/DA;EACI,kBAAA;EACA,kBAAA;AnIu+/DJ;AU78/DI;EyH5BJ;IAMQ,gBAAA;EnIu+/DN;AACF;;AmIn+/DA;EACI,kBAAA;AnIs+/DJ;AUn+/DI;EyHJJ;IAKQ,gBAAA;IAEA,sCAAA;IACA,uCAAA;IACA,qBAAA;IACA,sBAAA;EnIq+/DN;EmIn+/DM;IACI,gBAAA;IACA,eAAA;IACA,gBAAA;EnIq+/DV;EmIj+/DM;IAnBR;MAoBY,gBAAA;MACA,kBAAA;MACA,eAAA;MACA,gBAAA;InIo+/DR;EACF;AACF;AU5+/DI;EyHjBJ;IA6BQ,cAAA;EnIo+/DN;AACF;;AmIh+/DA;EACI,kBAAA;AnIm+/DJ;AUlggEI;EyH8BJ;IAKQ,kBAAA;IACA,sCAAA;IACA,qBAAA;EnIm+/DN;EmIj+/DM;IACI,kBAAA;IACA,eAAA;EnIm+/DV;EmI/9/DM;IAfR;MAgBY,kBAAA;MACA,kBAAA;MACA,eAAA;InIk+/DR;EACF;AACF;AUvggEI;EyHiBJ;IAwBQ,gBAAA;EnIk+/DN;AACF;;AmI99/DA;EACI,kBAAA;AnIi+/DJ;AU7hgEI;EyH2DJ;IAKQ,kBAAA;IACA,uCAAA;EnIi+/DN;EmI/9/DM;IACI,kBAAA;IACA,gBAAA;EnIi+/DV;EmI79/DM;IAdR;MAeY,kBAAA;MACA,kBAAA;MACA,gBAAA;InIg+/DR;EACF;AACF;AUjigEI;EyH8CJ;IAuBQ,gBAAA;EnIg+/DN;AACF;;AmI59/DA;EACI,kBAAA;EACA,kBAAA;EAEA,yBAAA;AnI89/DJ;AmI39/DI;EACI,4CAAA;AnI69/DR;AmI19/DI;EACI,4BAAA;EACA,sDAAA;AnI49/DR;AmIz9/DI;EACI,mBAAA;AnI29/DR;AmIv9/DI;EArBJ;IAsBQ,kBAAA;IACA,kBAAA;EnI09/DN;AACF;;AmIt9/DA;EACI,+BAAA;AnIy9/DJ;;AmIt9/DA;EACI,8BAAA;AnIy9/DJ;;AmIt9/DA;EACI,gCAAA;AnIy9/DJ;;AmIt9/DA;EACI,+BAAA;AnIy9/DJ;;AmIt9/DA;EACI,+BAAA;EACA,gCAAA;AnIy9/DJ;;AmIt9/DA;EACI,8BAAA;EACA,+BAAA;AnIy9/DJ;;AqI9pgEA;EACI,aAAA;EACA,mBAAA;ArIiqgEJ;;AqI9pgEA;EACI,6BAAA;EACA,wBAAA;ArIiqgEJ;AqI/pgEI;EACI,aAAA;ArIiqgER;;AqI7pgEA;EACI,UAAA;EACA,SAAA;ArIgqgEJ;AqI9pgEI;EACI,cAAA;EACA,cAAA;ArIgqgER;AqI7pgEI;EACI,cAAA;ArI+pgER;AgFprgEQ;EACI,0BAAA;EACA,aAAA;AhFsrgEZ;AgFlrgEY;EACI,0BAAA;AhForgEhB;;AqIjqgEA;EACI,eAAA;ArIoqgEJ;;AqI/pgEI;;EACI,cAAA;ArImqgER;AgFpsgEQ;;EACI,0BAAA;EACA,aAAA;AhFusgEZ;AgFnsgEY;;EACI,0BAAA;AhFssgEhB;;AqIpqgEA;EACI,cAAA;ArIuqgEJ;;AgFjtgEQ;EACI,0BAAA;EACA,aAAA;AhFotgEZ;AgFhtgEY;EACI,0BAAA;AhFktgEhB;;AqIxqgEA;EACI,cAAA;ArI2qgEJ;;AgF7tgEQ;EACI,0BAAA;EACA,aAAA;AhFgugEZ;AgF5tgEY;EACI,0BAAA;AhF8tgEhB;;AqI5qgEA;EACI,cAAA;ArI+qgEJ;;AgFzugEQ;EACI,0BAAA;EACA,aAAA;AhF4ugEZ;AgFxugEY;EACI,0BAAA;AhF0ugEhB;;AsIjvgEC;;EAEC,aAAA;AtIovgEF;AsIlvgEE;;EACC,aAAA;AtIqvgEH;AsIhvgEC;EACC,eAAA;AtIkvgEF;AsI7ugEE;EACC,aAAA;AtI+ugEH;AsI5ugEE;EACC,qBAAA;AtI8ugEH;AsI3ugEE;EACC,aAAA;AtI6ugEH;AsIxugEE;EACC,aAAA;AtI0ugEH;AsIvugEE;EACC,qBAAA;AtIyugEH;AsItugEE;EACC,aAAA;AtIwugEH;AsInugEE;EACC,qBAAA;AtIqugEH;AsIlugEE;EACC,qBAAA;AtIougEH;AsIjugEE;EACC,aAAA;AtImugEH;AsI9tgEE;EACC,qBAAA;AtIgugEH;AsI7tgEE;EACC,aAAA;AtI+tgEH;AsI5tgEE;EACC,qBAAA;AtI8tgEH;AsI3tgEE;EACC,aAAA;AtI6tgEH;;AuIlygEI;EACI,aAAA;AvIqygER;AuIjygEI;EACI,aAAA;EACA,mBAAA;EACA,uD/G+T4C;AxBo+/DpD;AuIhygEQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uD/GwTwC;E+GvTxC,WAnBK;EAoBL,YApBK;EAqBL,uB/GuUwB;E+GtUxB,yB5FlBmB;E4FmBnB,oBAAA;AvIkygEZ;AuIhygEY;EACI,aAAA;EACA,eAAA;AvIkygEhB;AuI/xgEY;EACI,gB/GwXoC;E+GvXpC,yBAAA;EACA,kBAAA;AvIiygEhB;AuI5xgEQ;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AvI8xgEZ;AuI5xgEY;EACI,c/GnCS;E+GoCT,gBAAA;EACA,kBAAA;EACA,qBAAA;AvI8xgEhB;AuI3xgEY;EACI,c/G7CS;AxB00gEzB;AuIxxgEQ;EACI,uD/GiRwC;AxByggEpD;AuIxxgEY;EACI,uD/G8QoC;E+G7QpC,yB5F3DS;A3Cq1gEzB;AuIxxgEgB;EACI,c5F9DK;E4F+DL,aAAA;AvI0xgEpB;AuIvxgEgB;EACI,yBAAA;EACA,kBAAA;AvIyxgEpB;AuIpxgEgB;EACI,c/GrEK;AxB21gEzB;AuInxgEgB;EACI,c/G3EK;AxBg2gEzB;AuI7wgEY;EACI,uD/GiPoC;E+GhPpC,yB5FtFe;A3Cq2gE/B;AuI7wgEgB;EACI,yBAAA;EACA,qBAAA;AvI+wgEpB;AuI5wgEgB;EACI,aAAA;AvI8wgEpB;AuIzwgEgB;EACI,c/GlGK;AxB62gEzB;AuIxwgEgB;EACI,c/GvGK;AxBi3gEzB;AuIjwgEQ;EACI,sBAAA;AvImwgEZ;AuI/vgEQ;EACI,kBAAA;EACA,UAAA;EACN,SAAA;EACM,sBAAA;AvIiwgEZ;AuI7vgEQ;EACI,UAAA;AvI+vgEZ;AuI3vgEQ;EACI,cAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,WAhJK;EAiJL,yBAAA;EACA,sBAAA;EACA,yBAAA;EACA,0B/GhJa;AxB64gEzB;AuIxvgEY;EACI,QAAA;AvI0vgEhB;AuIpvgEY;EACI,WAAA;AvIsvgEhB;;AwIt5gEQ;EACI,aAAA;AxIy5gEZ;AwIn5gEQ;EACI,aAAA;AxIq5gEZ;;AyIh6gEA;ECuBC,smCAAA;A1I64gED;;AyI/5gEA;ECkBC,8mDAAA;A1Ii5gED;;A2Iv6gEA;EACC,kBAAA;A3I06gED;A2Iv6gEC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,yBhGRuB;EgGSvB,+CAAA;EACA,cAAA;EACA,QAAA;EACA,QAAA;EACA,2CAAA;A3Iy6gEF;A2Iv6gEE;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;A3Iy6gEH;A2It6gEE;EACC,qBAAA;A3Iw6gEH;A2Il6gEE;EACC,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;A3Io6gEH;A2I/5gEE;EACC,MAAA;EACA,6CAAA;EACA,oCnH8SiC;EmH7SjC,mCnH6SiC;AxBongEpC;A2I55gEE;EACC,iCnHuSiC;EmHtSjC,gCnHsSiC;AxBwngEpC;A2Iz5gEE;EACC,QAAA;EACA,OAAA;EACA,WAAA;EACA,4CAAA;EACA,iCnH4RiC;EmH3RjC,oCnH2RiC;AxBgogEpC;A2It5gEE;EACC,gCnHqRiC;EmHpRjC,mCnHoRiC;AxBoogEpC;;A2Ih5gEE;EACC,UAAA;A3Im5gEH;A2Ij5gEG;EACC,iCnHwQgC;EmHvQhC,oCnHuQgC;AxB4ogEpC;A2Ij5gEI;EAEC,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;A3Ik5gEL;A2I/4gEI;EACC,2BAAA;EACA,sCAAA;EACA,OAAA;A3Ii5gEL;A2I14gEE;EACC,WAAA;A3I44gEH;A2I14gEG;EACC,gCnH8OgC;EmH7OhC,mCnH6OgC;AxB+pgEpC;A2I14gEI;EAEC,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;A3I24gEL;A2Ix4gEI;EACC,2BAAA;EACA,qCAAA;EACA,QAAA;A3I04gEL;;A2Il4gEA;EACC,kBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,2BAAA;A3Iq4gED;A2Il4gEC;EACC,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,gDAAA;EACA,2BAAA;EACA,+CAAA;EACA,0BAAA;A3Io4gEF;A2Ih4gEC;EACC,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,gDAAA;EACA,8CAAA;EACA,4BAAA;EACA,0BAAA;A3Ik4gEF;A2I93gEC;EACC,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,+CAAA;EACA,6CAAA;A3Ig4gEF;A2I53gEC;EACC,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,4BAAA;EACA,8CAAA;EACA,6CAAA;A3I83gEF;;A4IxjhEA;EACI,kBAAA;A5I2jhEJ;A4IzjhEI;EACI,yBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qCAAA;A5I2jhER;A4IzjhEQ;EACI,eAAA;EACA,cAAA;A5I2jhEZ;A4IvjhEI;EACI,aAAA;EACA,mBAAA;EnHTJ,uBAAA;EmHWI,oDpH0tBqB;EoHztBrB,yBpH6wB4C;EoH5wB5C,cAAA;EACA,gBpH2X4C;EoH1X5C,oBAAA;EACA,WAAA;EACA,mCAAA;A5IyjhER;A4IvjhEQ;EACI,qBAAA;A5IyjhEZ;;A6I5khEA;EACI,crHRqB;EqHSrB,yBrHhBkB;AxB+lhEtB;A6I7khEI;EAGI,crHrBc;EqHsBd,yBAxBU;A7IqmhElB;;A6IzkhEA;EACI,SAAA;A7I4khEJ;A6IzkhEQ;EACI,cAjCM;A7I4mhElB;AgFzmhEQ;EACI,0BAAA;EACA,aAAA;AhF2mhEZ;AgFvmhEY;EACI,0BAAA;AhFymhEhB;;A6IzkhEA;EACC,SAAA;EACG,crH1CkB;EqH2ClB,yBA7Cc;A7IynhElB;A6I1khEI;EACI,crH9Cc;EqH+Cd,yBA/CiB;A7I2nhEzB;;A6IxkhEA;EACC,SAAA;EACG,crH9CqB;EqH+CrB,yBrHpDqB;AxB+nhEzB;A6IzkhEI;EACI,crHhDiB;EqHiDjB,yBrHvDiB;AxBkohEzB;;A6IvkhEA;EACI,qCAAA;A7I0khEJ;A6IxkhEI;EAEI,qCAAA;EACA,yBAhEgB;A7IyohExB;;A6IrkhEA;EACI,cA3Ec;A7ImphElB;A6ItkhEI;EACI,cA5EiB;A7IophEzB;;A6IpkhEA;EACI,yBAAA;A7IukhEJ;;A6IpkhEA;EACI,cAlFc;A7IyphElB;AgF3phEQ;EACI,0BAAA;EACA,aAAA;AhF6phEZ;AgFzphEY;EACI,0BAAA;AhF2phEhB;;A6I1khEA;EACI,cA/Ea;A7I4phEjB;AgFtqhEQ;EACI,0BAAA;EACA,aAAA;AhFwqhEZ;AgFpqhEY;EACI,0BAAA;AhFsqhEhB;;A6IhlhEA;EACI,crH/FkB;EqHgGlB,yBAxFc;A7I2qhElB;;A6IhlhEA;EACI,crHpGkB;EqHqGlB,yBAlGc;A7IqrhElB;;A8I1rhEA;EACI,mBAAA;EACA,cAAA;A9I6rhEJ;;A+I7rhEI;EACF,aAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;A/IgshEF;A+I9rhEQ;EACL,kBAAA;EACA,cAAA;EACA,mBAAA;A/IgshEH;A+I9rhEG;EACC,YAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,6BAAA;EACA,uDvHsTgD;AxB04gEpD;A+I7rhEY;EACI,cvHdS;EuHeT,gBAAA;EACA,kBAAA;A/I+rhEhB;A+I3rhEY;EACR,uDvH2SgD;AxBk5gEpD;A+I3rhEI;EACC,cpGhCoB;A3C6thEzB;A+I1rhEI;EACC,yBpGpCoB;A3CguhEzB;A+IvrhEI;EACC,cvHvCoB;AxBguhEzB;;AgJtuhEA;EACC,kBAAA;AhJyuhED;AgJruhEC;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,yBxHRuB;AxB+uhEzB;AgJnuhEC;EACC,aAAA;EACM,uBAAA;EACN,kBAAA;EACA,qBAAA;AhJquhEF;AgJnuhEQ;EACI,gBAAA;AhJquhEZ;AgJjuhEC;EACC,WAzBgB;EA0BhB,cAAA;EACA,kBAAA;EACA,cxHrBuB;AxBwvhEzB;AgJhuhEC;EACC,cAAA;EACA,mBxH+MkD;EwH9MlD,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,uBAAA;EACA,oCAAA;AhJkuhEF;AgJhuhEE;EACC,cAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,yBxHnDsB;AxBqxhEzB;AgJ9thEC;EACC,YAAA;AhJguhEF;;AuG3xhEI;EACI,gC0CFiB;AjJgyhEzB;AuG1xhEI;EACI,gC0CPiB;E1CQjB,UAAA;AvG4xhER;;AkJpyhEA;EACI,sBAAA;EACA,kBAAA;AlJuyhEJ;AkJryhEI;EACI,yBAAA;EACA,eAAA;EACA,uD1HoU4C;E0HnU5C,0CAAA;AlJuyhER;AkJryhEQ;EACI,oCAAA;EACA,uD1H+TwC;E0H9TxC,WAAA;AlJuyhEZ;AkJnyhEI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AlJqyhER;;AmJ7zhEI;EACI,mBxGaoB;A3CmzhE5B;AmJ9zhEQ;EACI,mBxGQa;A3CwzhEzB;AmJ5zhEI;EACI,yBAAA;EACA,kDAAA;EACA,mBxGCiB;A3C6zhEzB;;AoJ/zhEA;EACI,yBARiB;ApJ00hErB;;AoJ/zhEA;EACI,cAZiB;ApJ80hErB;;AoJ/zhEA;EACI,0BAAA;ApJk0hEJ;;AoJ/zhEA;EACI,8BAAA;ApJk0hEJ;;AoJ/zhEA;EACI,kBAAA;ApJk0hEJ;AoJh0hEI;EACI,kBAAA;EACA,MAAA;EACA,cAAA;ApJk0hER;;AoJ7zhEA;EACI,aAAA;EACA,mBAAA;EACA,aApCoB;ApJo2hExB;AoJ7zhEI;EACI,cAAA;ApJ+zhER;AoJ5zhEI;EACI,aAAA;ApJ8zhER;AoJvzhEY;EACI,c5HpDM;AxB62hEtB;AoJjzhEgB;EACI,czG3DK;EyG4DL,0CAAA;ApJmzhEpB;AoJ5yhEI;EACI,UAAA;EACA,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,yB5H5Ec;E4H6Ed,qDAAA;EACA,YA5EuB;ApJ03hE/B;AoJ3yhEQ;EACI,cAAA;ApJ6yhEZ;AoJ1yhEQ;EACI,aAAA;ApJ4yhEZ;;AoJtyhEA;EACI,kBA7FoB;ApJs4hExB;;AUh0hEI;E0I6BA;IACI,YAnGkC;EpJ04hExC;EoJpyhEM;IACI,kBAAA;IACA,cAAA;EpJsyhEV;EoJlyhEM;IACI,YA3GqC;EpJ+4hE/C;EoJ7xhEc;IACI,czGpHK;IyGqHL,0CAAA;EpJ+xhElB;;EoJxxhEE;IACI,iBA9HkC;EpJy5hExC;AACF;AqJj6hEA;EACE,uBAAA;EACA,sBAAA;EACA,8BAAA;EACA,6CAAA;ArJm6hEF;;AqJh6hEA;;EAEI,YAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;EACA,gB7H8YgD;E6H7YhD,6C7HqYoC;E6HzXpC,mCAAA;EACA,kCAAA;ArJw5hEJ;AUv2hEI;E2IrEJ;;IAWQ,0BAAA;ErJs6hEN;AACF;AU72hEI;E2IrEJ;;IAgBQ,0BAAA;ErJu6hEN;AACF;AqJl6hEI;;;;;;EAGI,gCAAA;ArJu6hER;;AqJn6hEA;EACI,aAAA;EACA,sBAAA;EACA,c7HvBqB;AxB67hEzB;;AqJl6hEA;EACI,aAAA;ArJq6hEJ;;AqJl6hEA;EACI,yBAAA;UAAA,iBAAA;ArJq6hEJ;;AsJh9hEA;EACI;IACI,qBAAA;IACA,2BAAA;EtJm9hEN;EsJj9hEM;;;;;;;;;;IAOI,2BAAA;IACA,qBAAA;IACA,oBAAA;EtJs9hEV;EsJn9hEM;;;;;;;;IAQI,wBAAA;EtJq9hEV;AACF;AuJ9+hEA;EACC,yBCGoB;AxJ6+hErB;;AuJ5+hEA;EACC,cCFoB;AxJi/hErB;;AU57hEI;E6I7CH;;;;;;;IAGC,eAAA;EvJi/hEA;;EuJ7+hED;IACC,0DAAA;EvJg/hEA;EuJ7+hEA;IACC,kCAAA;IACA,mBAAA;EvJ++hED;EuJ3+hEA;IACC,kCAAA;IACA,kBAAA;EvJ6+hED;EuJz+hEA;IACC,iBAAA;EvJ2+hED;EuJv+hEA;IACC,kDAAA;EvJy+hED;AACF;AU78hEI;E6IrBH;;;;;;;IAGC,eAAA;IACA,eAAA;EvJy+hEA;;EuJn+hEA;IACC,iBAAA;EvJs+hED;EuJl+hEA;IACC,oEAAA;EvJo+hED;AACF;AU7+hEI;E+IzDH;IACC,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,kBAAA;IACA,UAAA;IACA,YAAA;IACA,0BAAA;EzJyiiEA;EyJtiiEA;IACC,eAAA;IACA,MAAA;IACA,QAAA;IACA,OAAA;IACA,YAAA;IACA,yBAAA;IACA,YAAA;IACA,UAAA;IACA,qDAAA;EzJwiiED;EyJpiiEA;IACC,gBAAA;EzJsiiED;EyJliiEA;IACC,WAAA;IACA,0BAAA;EzJoiiED;EyJhiiEA;IACC,UAAA;IACA,0BAAA;EzJkiiED;EyJ9hiEA;IACC,aAAA;EzJgiiED;AACF;AUpgiEI;E+ItBH;IACC,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,YAAA;IACA,kBAAA;IACA,UAAA;EzJ6hiEA;EyJ1hiEA;IACC,eAAA;IACA,MAAA;IACA,QAAA;IACA,OAAA;IACA,YAAA;IACA,YAAA;IACA,gBAAA;IACA,yBAAA;IAGC,qDAAA;EzJ0hiEF;EyJrhiEA;IACC,gBAAA;EzJuhiED;EyJnhiEA;IACC,aAAA;IACA,WAAA;EzJqhiED;EyJjhiEA;IACC,wBAAA;EzJmhiED;AACF;AyJ9giEA;EACC,kBAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,iBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2CAAA;EACA,2BAAA;AzJghiED;;AyJ9giEE;EACD,cAAA;EACA,YAAA;EACA,iBAAA;EACA,wBAAA;EACA,2BAAA;AzJihiED;;AyJ9giEE;EACD,mBAAA;AzJihiED;;AyJ9giEE;EACD,WAAA;EACA,YAAA;EACA,YAAA;AzJihiED;;A0J1oiEA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;A1J6oiEJ;;AUvliEI;EgJ/CI;IACL,gCAAA;IACQ,eAAA;IACR,MAAA;IACA,QAAA;IACA,OAAA;IACA,WAAA;IACS,qDAAA;E1J0oiEV;E0JtoiEA;IACC,mBAAA;E1JwoiED;E0JpoiEM;IACI,UAAA;IACA,SAAA;IACA,6BAAA;E1JsoiEV;E0JloiEA;IACC,WAAA;IACA,0BAAA;E1JooiED;E0JhoiEA;IACC,UAAA;IACA,0BAAA;E1JkoiED;AACF;AUtmiEI;EgJpBI;IACL,kDAAA;IACS,eAAA;IACA,MAAA;IACA,QAAA;IACA,OAAA;IACA,WAAA;IACA,qDAAA;E1J6niEV;E0JzniEA;IACC,mBAAA;E1J2niED;E0JvniEM;IACI,UAAA;IACT,SAAA;IACS,6BAAA;E1JyniEV;E0JrniEA;IACC,wBAAA;E1JuniED;AACF;A2JnsiEA;EACC,aAAA;EACA,sBAAA;EACA,8CAAA;EACA,UAAA;A3JqsiED;A2JlsiEC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;A3JosiEF;A2JlsiEE;EACC,6BAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;A3JosiEH;A2JjsiEE;EACC,qBAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;A3JmsiEH;A2J9riEC;EACC,yBAAA;A3JgsiEF;A2J7riEE;EACC,yBAAA;A3J+riEH;AgFnuiEQ;EACI,0BAAA;EACA,aAAA;AhFquiEZ;AgFjuiEY;EACI,0BAAA;AhFmuiEhB;A2J7riEE;EACC,4BAAA;A3J+riEH;A2J3riEE;EvDxCM,cuD0C0B;EvDpB1B,wCuDoB+C;A3J6riEvD;AoG9siEI;EASQ,cuDQmE;EvDcnE,mDAAA;ApGmriEZ;A2J/riEG;EACC,cAAA;A3JisiEJ;AgFxviEQ;EACI,0BAAA;EACA,aAAA;AhF0viEZ;AgFtviEY;EACI,0BAAA;AhFwviEhB;A2JjsiEC;EACC,yBnIhEoB;AxBmwiEtB;;AU1siEI;EiJaH;IACC,YAAA;IACA,2BAAA;E3JisiEA;E2J9riEA;IACC,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,YAAA;IACA,eAAA;E3JgsiED;E2J5riEA;IACC,YAAA;E3J8riED;E2J1riEA;IACC,eAAA;IACA,MAAA;IACA,SAAA;IACA,OAAA;IACA,YAAA;IACA,gBAAA;E3J4riED;E2JxriEA;IACC,kBAAA;IACA,UAAA;E3J0riED;E2JtriEA;IACC,WAAA;IACA,2BAAA;E3JwriED;E2JpriEE;IACC,qBAAA;E3JsriEH;E2JnriEE;IACC,aAAA;E3JqriEH;E2JhriEC;IACC,2BAAA;IACA,YAAA;IACA,gDAAA;E3JkriEF;E2J3qiEE;IACC,uBAAA;E3J6qiEH;E2J3qiEG;IACC,aAAA;E3J6qiEJ;E2J1qiEG;IACC,aAAA;E3J4qiEJ;E2JzqiEG;IACC,qBAAA;E3J2qiEJ;E2JrqiEG;;;IAEC,UAAA;IACA,6BAAA;E3JwqiEJ;E2JrqiEG;IACC,SAAA;IACA,gBAAA;IACA,4BAAA;E3JuqiEJ;E2JjqiEG;IACC,QAAA;IACA,UAAA;IACA,6BAAA;E3JmqiEJ;E2JhqiEG;IACC,WAAA;IACA,UAAA;IACA,6BAAA;E3JkqiEJ;AACF;AU1wiEI;EiJiHH;IACC,aAAA;E3J4piEA;E2JzpiEA;IACC,aAAA;E3J2piED;AACF;A2F10iEE;;EAEC,kBiEdkC;EjEelC,mBiEfkC;A5J21iErC;A2FtziEG;;EAEC,kCAAA;A3FwziEJ;A2FnziEK;;EAEC,iCAAA;A3FqziEN;A2FhziEO;;EAEC,kCAAA;A3FkziER;A2F7yiES;;EAEC,+BAAA;A3F+yiEV;A2FnyiEI;;EAEC,qBAAA;EACA,gBAAA;A3FqyiEL;A2FhyiEM;;EAEC,0BAAA;EACA,gBAAA;A3FkyiEP;A2F7xiEQ;;EAEC,2BAAA;EACA,gBAAA;A3F+xiET;A2F1xiEU;;EAEC,wBAAA;EACA,gBAAA;A3F4xiEX;A4Jx3iEI;EACI,UAAA;A5J03iER;A4Jv3iEQ;EACI,oBAAA;EACA,uBAAA;A5Jy3iEZ;A4Jr3iEQ;EACI,2BAAA;A5Ju3iEZ;;A4Jh3iEI;EACI,yBAAA;ExB5BJ,oCAAA;ApIg5iEJ;AoI74iEI;EACI,yBwB0ByB;A5Jq3iEjC;AoI14iEQ;EAEI,oCAAA;ApI24iEZ;AoIx4iEY;EACI,yBwBesD;A5J23iEtE;A4Jt3iEY;EACI,yBAAA;A5Jw3iEhB;A2FnviEC;EAhDC,ciEjF4C;A5Ju3iE9C;A2FpyiEE;EACC,ciEpF2C;A5J03iE9C;A2F/xiEG;EACC,ciE5FmD;A5J63iEvD;AgFp6iEQ;EACI,0BAAA;EACA,aAAA;AhFs6iEZ;AgFl6iEY;EACI,0BAAA;AhFo6iEhB;A2F5xiEG;EACC,yBiEzG4D;A5Ju4iEhE;A2FvxiEE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3F+xiEH;A2FrwiEC;EAEC,uDnEkJkD;EmErNlD,yBiE5E8E;EjEgF9E,cnEzHoB;AxBg8iEtB;A2Fr0iEE;EACC,cnE5HmB;AxBm8iEtB;A2Fh0iEG;EACC,chDlIqB;A3Co8iEzB;AgFr8iEQ;EACI,0BAAA;EACA,aAAA;AhFu8iEZ;AgFn8iEY;EACI,0BAAA;AhFq8iEhB;A2F7ziEG;EACC,yBhD/IqB;A3C88iEzB;A2FxziEE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3Fg0iEH;A2FnwiEC;EACC,uDnEgHkD;EmErNlD,yBiE3E6E;EjE+E7E,cnEzHoB;AxBi+iEtB;A2Ft2iEE;EACC,cnE5HmB;AxBo+iEtB;A2Fj2iEG;EACC,chDlIqB;A3Cq+iEzB;AgFt+iEQ;EACI,0BAAA;EACA,aAAA;AhFw+iEZ;AgFp+iEY;EACI,0BAAA;AhFs+iEhB;A2F91iEG;EACC,yBhD/IqB;A3C++iEzB;A2Fz1iEE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3Fi2iEH;A2F7yiEC;EACC,uDnEyHkD;EmErNlD,yBiE1E6E;EjE8E7E,cnEzHoB;AxBkgjEtB;A2Fv4iEE;EACC,cnE5HmB;AxBqgjEtB;A2Fl4iEG;EACC,chDlIqB;A3CsgjEzB;AgFvgjEQ;EACI,0BAAA;EACA,aAAA;AhFygjEZ;AgFrgjEY;EACI,0BAAA;AhFugjEhB;A2F/3iEG;EACC,yBhD/IqB;A3CghjEzB;A2F13iEE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3Fk4iEH;A2Fx1iEC;EACC,uDnEmIkD;EmErNlD,yBiEzE+E;EjE6E/E,cnEzHoB;AxBmijEtB;A2Fx6iEE;EACC,cnE5HmB;AxBsijEtB;A2Fn6iEG;EACC,chDlIqB;A3CuijEzB;AgFxijEQ;EACI,0BAAA;EACA,aAAA;AhF0ijEZ;AgFtijEY;EACI,0BAAA;AhFwijEhB;A2Fh6iEG;EACC,yBhD/IqB;A3CijjEzB;A2F35iEE;EJ5HM,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EIyHD,mBAAA;EJ9HK,4BAAA;EACA,2BAAA;EACA,6BAAA;EAGJ,0DAAA;EI2HD,iBAAA;A3Fm6iEH;;A4J3gjEQ;EACI,gBAAA;A5J8gjEZ;;AU1gjEI;EmJzDH;IACC,eAAA;E7JukjEA;E6JpkjEA;IACC,cAAA;E7JskjED;AACF;AUtgjEI;EmJ1DH;IACC,eAAA;E7JmkjEA;E6JhkjEA;IACC,cAAA;E7JkkjED;AACF;A8JtljEA;EACI,yBAAA;A9JwljEJ;;A+JxljEA;EACI;IACI,qBAAA;IACA,2BAAA;E/J2ljEN;E+JzljEM;;;;;;;;;;IAMI,2BAAA;IACA,qBAAA;IACA,oBAAA;E/J+ljEV;E+J5ljEM;;;;IAKI,wBAAA;E/J6ljEV;AACF;AgKnnjEA;EACC,yBCDqB;AjKsnjEtB;;AU5jjEI;EsJnDH;;;;;;;IAEC,eAAA;EhKwnjEA;;EgKpnjED;IACC,mBAAA;EhKunjEA;AACF;AU/jjEI;EsJlDH;;;;;;;IAEC,eAAA;IACA,eAAA;EhKynjEA;AACF;AUxljEI;EwJzDH;IACC,aAAA;IACA,8BAAA;IACA,mBAAA;ElKopjEA;AACF;AUlljEI;EwJ7DH;IACC,aAAA;IACA,8BAAA;IACA,mBAAA;ElKkpjEA;EkK/ojEA;IACC,wBAAA;ElKipjED;AACF;AmKnqjEA;EACC,aAAA;EACA,sBAAA;EACA,+CAAA;EACA,yBAAA;EACA,UAAA;AnKqqjED;;AUhnjEI;EyJhDH;IACC,eAAA;IACA,MAAA;IACA,SAAA;IACA,OAAA;IACA,YAAA;IACA,gBAAA;IACA,YAAA;EnKoqjEA;EmKjqjEA;IACC,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,eAAA;EnKmqjED;EmK/pjEA;IACC,YAAA;EnKiqjED;AACF;AUxnjEI;EyJnCH;IACC,aAAA;EnK8pjEA;EmK3pjEA;IACC,aAAA;EnK6pjED;AACF;A2FxrjEE;;EAEC,kByEdkC;EzEelC,mByEfkC;ApKysjErC;A2FpqjEG;;EAEC,kCAAA;A3FsqjEJ;A2FjqjEK;;EAEC,iCAAA;A3FmqjEN;A2F9pjEO;;EAEC,kCAAA;A3FgqjER;A2F3pjES;;EAEC,+BAAA;A3F6pjEV;A2FjpjEI;;EAEC,qBAAA;EACA,gBAAA;A3FmpjEL;A2F9ojEM;;EAEC,0BAAA;EACA,gBAAA;A3FgpjEP;A2F3ojEQ;;EAEC,2BAAA;EACA,gBAAA;A3F6ojET;A2FxojEU;;EAEC,wBAAA;EACA,gBAAA;A3F0ojEX;AoKtujEI;EACI,UAAA;ApKwujER;AoKrujEQ;EACI,gBAAA;EACA,oBAAA;EACA,uBAAA;ApKuujEZ;AoKnujEQ;EACI,2BAAA;ApKqujEZ;;AqK5vjEA;EACI,yB7ImPgD;E6IlPhD,SAAA;ArK+vjEJ","sourcesContent":["@charset \"UTF-8\";\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.text-bg-white {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-white-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-light {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-primary {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-secondary {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-success {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-info {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-warning {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-dark {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.link-white {\n  color: RGBA(var(--bs-white-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-white-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-white:hover, .link-white:focus {\n  color: RGBA(255, 255, 255, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(255, 255, 255, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-light {\n  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-light:hover, .link-light:focus {\n  color: RGBA(247, 249, 251, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(247, 249, 251, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-primary {\n  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-primary:hover, .link-primary:focus {\n  color: RGBA(51, 177, 249, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(51, 177, 249, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-secondary {\n  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-secondary:hover, .link-secondary:focus {\n  color: RGBA(233, 235, 242, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(233, 235, 242, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success {\n  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-success:hover, .link-success:focus {\n  color: RGBA(115, 215, 161, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(115, 215, 161, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-info {\n  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-info:hover, .link-info:focus {\n  color: RGBA(91, 46, 187, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(91, 46, 187, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-warning {\n  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-warning:hover, .link-warning:focus {\n  color: RGBA(255, 210, 51, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(255, 210, 51, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger {\n  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-danger:hover, .link-danger:focus {\n  color: RGBA(244, 103, 137, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(244, 103, 137, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-dark {\n  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-dark:hover, .link-dark:focus {\n  color: RGBA(19, 22, 40, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(19, 22, 40, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-body-emphasis {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-body-emphasis:hover, .link-body-emphasis:focus {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;\n}\n\n.focus-ring:focus {\n  outline: 0;\n  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);\n}\n\n.icon-link {\n  display: inline-flex;\n  gap: 0.375rem;\n  align-items: center;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));\n  text-underline-offset: 0.25em;\n  backface-visibility: hidden;\n}\n.icon-link > .bi {\n  flex-shrink: 0;\n  width: 1em;\n  height: 1em;\n  fill: currentcolor;\n  transition: 0.2s ease-in-out transform;\n}\n@media (prefers-reduced-motion: reduce) {\n  .icon-link > .bi {\n    transition: none;\n  }\n}\n\n.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {\n  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));\n}\n\n.ratio {\n  position: relative;\n  width: 100%;\n}\n.ratio::before {\n  display: block;\n  padding-top: var(--bs-aspect-ratio);\n  content: \"\";\n}\n.ratio > * {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ratio-1x1 {\n  --bs-aspect-ratio: 100%;\n}\n\n.ratio-4x3 {\n  --bs-aspect-ratio: calc(3 / 4 * 100%);\n}\n\n.ratio-16x9 {\n  --bs-aspect-ratio: calc(9 / 16 * 100%);\n}\n\n.ratio-21x9 {\n  --bs-aspect-ratio: calc(9 / 21 * 100%);\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.sticky-top {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n}\n\n.sticky-bottom {\n  position: sticky;\n  bottom: 0;\n  z-index: 1020;\n}\n\n@media (min-width: 576px) {\n  .sticky-sm-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n\n  .sticky-sm-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 768px) {\n  .sticky-md-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n\n  .sticky-md-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 992px) {\n  .sticky-lg-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n\n  .sticky-lg-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1200px) {\n  .sticky-xl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n\n  .sticky-xl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1400px) {\n  .sticky-xxl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n\n  .sticky-xxl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n.visually-hidden:not(caption),\n.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {\n  position: absolute !important;\n}\n.visually-hidden *,\n.visually-hidden-focusable:not(:focus):not(:focus-within) * {\n  overflow: hidden !important;\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  content: \"\";\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.vr {\n  display: inline-block;\n  align-self: stretch;\n  width: var(--bs-border-width);\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: 0.25;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.float-start {\n  float: left !important;\n}\n\n.float-end {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n.object-fit-contain {\n  object-fit: contain !important;\n}\n\n.object-fit-cover {\n  object-fit: cover !important;\n}\n\n.object-fit-fill {\n  object-fit: fill !important;\n}\n\n.object-fit-scale {\n  object-fit: scale-down !important;\n}\n\n.object-fit-none {\n  object-fit: none !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-scroll {\n  overflow: scroll !important;\n}\n\n.overflow-x-auto {\n  overflow-x: auto !important;\n}\n\n.overflow-x-hidden {\n  overflow-x: hidden !important;\n}\n\n.overflow-x-visible {\n  overflow-x: visible !important;\n}\n\n.overflow-x-scroll {\n  overflow-x: scroll !important;\n}\n\n.overflow-y-auto {\n  overflow-y: auto !important;\n}\n\n.overflow-y-hidden {\n  overflow-y: hidden !important;\n}\n\n.overflow-y-visible {\n  overflow-y: visible !important;\n}\n\n.overflow-y-scroll {\n  overflow-y: scroll !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-grid {\n  display: grid !important;\n}\n\n.d-inline-grid {\n  display: inline-grid !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.shadow {\n  box-shadow: var(--bs-box-shadow) !important;\n}\n\n.shadow-sm {\n  box-shadow: var(--bs-box-shadow-sm) !important;\n}\n\n.shadow-lg {\n  box-shadow: var(--bs-box-shadow-lg) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.focus-ring-white {\n  --bs-focus-ring-color: rgba(var(--bs-white-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-light {\n  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-primary {\n  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-secondary {\n  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-success {\n  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-info {\n  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-warning {\n  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-danger {\n  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-dark {\n  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.top-0 {\n  top: 0 !important;\n}\n\n.top-25 {\n  top: 25% !important;\n}\n\n.top-50 {\n  top: 50% !important;\n}\n\n.top-75 {\n  top: 75% !important;\n}\n\n.top-100 {\n  top: 100% !important;\n}\n\n.bottom-0 {\n  bottom: 0 !important;\n}\n\n.bottom-25 {\n  bottom: 25% !important;\n}\n\n.bottom-50 {\n  bottom: 50% !important;\n}\n\n.bottom-75 {\n  bottom: 75% !important;\n}\n\n.bottom-100 {\n  bottom: 100% !important;\n}\n\n.start-0 {\n  left: 0 !important;\n}\n\n.start-25 {\n  left: 25% !important;\n}\n\n.start-50 {\n  left: 50% !important;\n}\n\n.start-75 {\n  left: 75% !important;\n}\n\n.start-100 {\n  left: 100% !important;\n}\n\n.end-0 {\n  right: 0 !important;\n}\n\n.end-25 {\n  right: 25% !important;\n}\n\n.end-50 {\n  right: 50% !important;\n}\n\n.end-75 {\n  right: 75% !important;\n}\n\n.end-100 {\n  right: 100% !important;\n}\n\n.translate-middle {\n  transform: translate(-50%, -50%) !important;\n}\n\n.translate-middle-x {\n  transform: translateX(-50%) !important;\n}\n\n.translate-middle-y {\n  transform: translateY(-50%) !important;\n}\n\n.border {\n  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top {\n  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-end {\n  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-end-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom {\n  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-start {\n  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-start-0 {\n  border-left: 0 !important;\n}\n\n.border-white {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-light {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-secondary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-success {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-info {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-warning {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-dark {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-black {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary-subtle {\n  border-color: var(--bs-primary-border-subtle) !important;\n}\n\n.border-secondary-subtle {\n  border-color: var(--bs-secondary-border-subtle) !important;\n}\n\n.border-success-subtle {\n  border-color: var(--bs-success-border-subtle) !important;\n}\n\n.border-info-subtle {\n  border-color: var(--bs-info-border-subtle) !important;\n}\n\n.border-warning-subtle {\n  border-color: var(--bs-warning-border-subtle) !important;\n}\n\n.border-danger-subtle {\n  border-color: var(--bs-danger-border-subtle) !important;\n}\n\n.border-light-subtle {\n  border-color: var(--bs-light-border-subtle) !important;\n}\n\n.border-dark-subtle {\n  border-color: var(--bs-dark-border-subtle) !important;\n}\n\n.border-0 {\n  border-width: 0 !important;\n}\n\n.border-1 {\n  border-width: 1px !important;\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-4 {\n  border-width: 4px !important;\n}\n\n.border-5 {\n  border-width: 5px !important;\n}\n\n.border-opacity-10 {\n  --bs-border-opacity: 0.1;\n}\n\n.border-opacity-25 {\n  --bs-border-opacity: 0.25;\n}\n\n.border-opacity-50 {\n  --bs-border-opacity: 0.5;\n}\n\n.border-opacity-75 {\n  --bs-border-opacity: 0.75;\n}\n\n.border-opacity-100 {\n  --bs-border-opacity: 1;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n.order-first {\n  order: -1 !important;\n}\n\n.order-0 {\n  order: 0 !important;\n}\n\n.order-1 {\n  order: 1 !important;\n}\n\n.order-2 {\n  order: 2 !important;\n}\n\n.order-3 {\n  order: 3 !important;\n}\n\n.order-4 {\n  order: 4 !important;\n}\n\n.order-5 {\n  order: 5 !important;\n}\n\n.order-last {\n  order: 6 !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 0.75rem !important;\n}\n\n.m-4 {\n  margin: 1rem !important;\n}\n\n.m-5 {\n  margin: 1.25rem !important;\n}\n\n.m-6 {\n  margin: 1.5rem !important;\n}\n\n.m-7 {\n  margin: 1.75rem !important;\n}\n\n.m-8 {\n  margin: 2rem !important;\n}\n\n.m-9 {\n  margin: 2.25rem !important;\n}\n\n.m-10 {\n  margin: 2.5rem !important;\n}\n\n.m-11 {\n  margin: 2.75rem !important;\n}\n\n.m-12 {\n  margin: 3rem !important;\n}\n\n.m-13 {\n  margin: 3.25rem !important;\n}\n\n.m-14 {\n  margin: 3.5rem !important;\n}\n\n.m-15 {\n  margin: 3.75rem !important;\n}\n\n.m-16 {\n  margin: 4rem !important;\n}\n\n.m-17 {\n  margin: 4.25rem !important;\n}\n\n.m-18 {\n  margin: 4.5rem !important;\n}\n\n.m-19 {\n  margin: 4.75rem !important;\n}\n\n.m-20 {\n  margin: 5rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.mx-1 {\n  margin-right: 0.25rem !important;\n  margin-left: 0.25rem !important;\n}\n\n.mx-2 {\n  margin-right: 0.5rem !important;\n  margin-left: 0.5rem !important;\n}\n\n.mx-3 {\n  margin-right: 0.75rem !important;\n  margin-left: 0.75rem !important;\n}\n\n.mx-4 {\n  margin-right: 1rem !important;\n  margin-left: 1rem !important;\n}\n\n.mx-5 {\n  margin-right: 1.25rem !important;\n  margin-left: 1.25rem !important;\n}\n\n.mx-6 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n\n.mx-7 {\n  margin-right: 1.75rem !important;\n  margin-left: 1.75rem !important;\n}\n\n.mx-8 {\n  margin-right: 2rem !important;\n  margin-left: 2rem !important;\n}\n\n.mx-9 {\n  margin-right: 2.25rem !important;\n  margin-left: 2.25rem !important;\n}\n\n.mx-10 {\n  margin-right: 2.5rem !important;\n  margin-left: 2.5rem !important;\n}\n\n.mx-11 {\n  margin-right: 2.75rem !important;\n  margin-left: 2.75rem !important;\n}\n\n.mx-12 {\n  margin-right: 3rem !important;\n  margin-left: 3rem !important;\n}\n\n.mx-13 {\n  margin-right: 3.25rem !important;\n  margin-left: 3.25rem !important;\n}\n\n.mx-14 {\n  margin-right: 3.5rem !important;\n  margin-left: 3.5rem !important;\n}\n\n.mx-15 {\n  margin-right: 3.75rem !important;\n  margin-left: 3.75rem !important;\n}\n\n.mx-16 {\n  margin-right: 4rem !important;\n  margin-left: 4rem !important;\n}\n\n.mx-17 {\n  margin-right: 4.25rem !important;\n  margin-left: 4.25rem !important;\n}\n\n.mx-18 {\n  margin-right: 4.5rem !important;\n  margin-left: 4.5rem !important;\n}\n\n.mx-19 {\n  margin-right: 4.75rem !important;\n  margin-left: 4.75rem !important;\n}\n\n.mx-20 {\n  margin-right: 5rem !important;\n  margin-left: 5rem !important;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.my-1 {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n\n.my-2 {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n\n.my-3 {\n  margin-top: 0.75rem !important;\n  margin-bottom: 0.75rem !important;\n}\n\n.my-4 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n\n.my-5 {\n  margin-top: 1.25rem !important;\n  margin-bottom: 1.25rem !important;\n}\n\n.my-6 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.my-7 {\n  margin-top: 1.75rem !important;\n  margin-bottom: 1.75rem !important;\n}\n\n.my-8 {\n  margin-top: 2rem !important;\n  margin-bottom: 2rem !important;\n}\n\n.my-9 {\n  margin-top: 2.25rem !important;\n  margin-bottom: 2.25rem !important;\n}\n\n.my-10 {\n  margin-top: 2.5rem !important;\n  margin-bottom: 2.5rem !important;\n}\n\n.my-11 {\n  margin-top: 2.75rem !important;\n  margin-bottom: 2.75rem !important;\n}\n\n.my-12 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n\n.my-13 {\n  margin-top: 3.25rem !important;\n  margin-bottom: 3.25rem !important;\n}\n\n.my-14 {\n  margin-top: 3.5rem !important;\n  margin-bottom: 3.5rem !important;\n}\n\n.my-15 {\n  margin-top: 3.75rem !important;\n  margin-bottom: 3.75rem !important;\n}\n\n.my-16 {\n  margin-top: 4rem !important;\n  margin-bottom: 4rem !important;\n}\n\n.my-17 {\n  margin-top: 4.25rem !important;\n  margin-bottom: 4.25rem !important;\n}\n\n.my-18 {\n  margin-top: 4.5rem !important;\n  margin-bottom: 4.5rem !important;\n}\n\n.my-19 {\n  margin-top: 4.75rem !important;\n  margin-bottom: 4.75rem !important;\n}\n\n.my-20 {\n  margin-top: 5rem !important;\n  margin-bottom: 5rem !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mt-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mt-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mt-3 {\n  margin-top: 0.75rem !important;\n}\n\n.mt-4 {\n  margin-top: 1rem !important;\n}\n\n.mt-5 {\n  margin-top: 1.25rem !important;\n}\n\n.mt-6 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-7 {\n  margin-top: 1.75rem !important;\n}\n\n.mt-8 {\n  margin-top: 2rem !important;\n}\n\n.mt-9 {\n  margin-top: 2.25rem !important;\n}\n\n.mt-10 {\n  margin-top: 2.5rem !important;\n}\n\n.mt-11 {\n  margin-top: 2.75rem !important;\n}\n\n.mt-12 {\n  margin-top: 3rem !important;\n}\n\n.mt-13 {\n  margin-top: 3.25rem !important;\n}\n\n.mt-14 {\n  margin-top: 3.5rem !important;\n}\n\n.mt-15 {\n  margin-top: 3.75rem !important;\n}\n\n.mt-16 {\n  margin-top: 4rem !important;\n}\n\n.mt-17 {\n  margin-top: 4.25rem !important;\n}\n\n.mt-18 {\n  margin-top: 4.5rem !important;\n}\n\n.mt-19 {\n  margin-top: 4.75rem !important;\n}\n\n.mt-20 {\n  margin-top: 5rem !important;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.me-0 {\n  margin-right: 0 !important;\n}\n\n.me-1 {\n  margin-right: 0.25rem !important;\n}\n\n.me-2 {\n  margin-right: 0.5rem !important;\n}\n\n.me-3 {\n  margin-right: 0.75rem !important;\n}\n\n.me-4 {\n  margin-right: 1rem !important;\n}\n\n.me-5 {\n  margin-right: 1.25rem !important;\n}\n\n.me-6 {\n  margin-right: 1.5rem !important;\n}\n\n.me-7 {\n  margin-right: 1.75rem !important;\n}\n\n.me-8 {\n  margin-right: 2rem !important;\n}\n\n.me-9 {\n  margin-right: 2.25rem !important;\n}\n\n.me-10 {\n  margin-right: 2.5rem !important;\n}\n\n.me-11 {\n  margin-right: 2.75rem !important;\n}\n\n.me-12 {\n  margin-right: 3rem !important;\n}\n\n.me-13 {\n  margin-right: 3.25rem !important;\n}\n\n.me-14 {\n  margin-right: 3.5rem !important;\n}\n\n.me-15 {\n  margin-right: 3.75rem !important;\n}\n\n.me-16 {\n  margin-right: 4rem !important;\n}\n\n.me-17 {\n  margin-right: 4.25rem !important;\n}\n\n.me-18 {\n  margin-right: 4.5rem !important;\n}\n\n.me-19 {\n  margin-right: 4.75rem !important;\n}\n\n.me-20 {\n  margin-right: 5rem !important;\n}\n\n.me-auto {\n  margin-right: auto !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 0.75rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 1rem !important;\n}\n\n.mb-5 {\n  margin-bottom: 1.25rem !important;\n}\n\n.mb-6 {\n  margin-bottom: 1.5rem !important;\n}\n\n.mb-7 {\n  margin-bottom: 1.75rem !important;\n}\n\n.mb-8 {\n  margin-bottom: 2rem !important;\n}\n\n.mb-9 {\n  margin-bottom: 2.25rem !important;\n}\n\n.mb-10 {\n  margin-bottom: 2.5rem !important;\n}\n\n.mb-11 {\n  margin-bottom: 2.75rem !important;\n}\n\n.mb-12 {\n  margin-bottom: 3rem !important;\n}\n\n.mb-13 {\n  margin-bottom: 3.25rem !important;\n}\n\n.mb-14 {\n  margin-bottom: 3.5rem !important;\n}\n\n.mb-15 {\n  margin-bottom: 3.75rem !important;\n}\n\n.mb-16 {\n  margin-bottom: 4rem !important;\n}\n\n.mb-17 {\n  margin-bottom: 4.25rem !important;\n}\n\n.mb-18 {\n  margin-bottom: 4.5rem !important;\n}\n\n.mb-19 {\n  margin-bottom: 4.75rem !important;\n}\n\n.mb-20 {\n  margin-bottom: 5rem !important;\n}\n\n.mb-auto {\n  margin-bottom: auto !important;\n}\n\n.ms-0 {\n  margin-left: 0 !important;\n}\n\n.ms-1 {\n  margin-left: 0.25rem !important;\n}\n\n.ms-2 {\n  margin-left: 0.5rem !important;\n}\n\n.ms-3 {\n  margin-left: 0.75rem !important;\n}\n\n.ms-4 {\n  margin-left: 1rem !important;\n}\n\n.ms-5 {\n  margin-left: 1.25rem !important;\n}\n\n.ms-6 {\n  margin-left: 1.5rem !important;\n}\n\n.ms-7 {\n  margin-left: 1.75rem !important;\n}\n\n.ms-8 {\n  margin-left: 2rem !important;\n}\n\n.ms-9 {\n  margin-left: 2.25rem !important;\n}\n\n.ms-10 {\n  margin-left: 2.5rem !important;\n}\n\n.ms-11 {\n  margin-left: 2.75rem !important;\n}\n\n.ms-12 {\n  margin-left: 3rem !important;\n}\n\n.ms-13 {\n  margin-left: 3.25rem !important;\n}\n\n.ms-14 {\n  margin-left: 3.5rem !important;\n}\n\n.ms-15 {\n  margin-left: 3.75rem !important;\n}\n\n.ms-16 {\n  margin-left: 4rem !important;\n}\n\n.ms-17 {\n  margin-left: 4.25rem !important;\n}\n\n.ms-18 {\n  margin-left: 4.5rem !important;\n}\n\n.ms-19 {\n  margin-left: 4.75rem !important;\n}\n\n.ms-20 {\n  margin-left: 5rem !important;\n}\n\n.ms-auto {\n  margin-left: auto !important;\n}\n\n.m-n1 {\n  margin: -0.25rem !important;\n}\n\n.m-n2 {\n  margin: -0.5rem !important;\n}\n\n.m-n3 {\n  margin: -0.75rem !important;\n}\n\n.m-n4 {\n  margin: -1rem !important;\n}\n\n.m-n5 {\n  margin: -1.25rem !important;\n}\n\n.m-n6 {\n  margin: -1.5rem !important;\n}\n\n.m-n7 {\n  margin: -1.75rem !important;\n}\n\n.m-n8 {\n  margin: -2rem !important;\n}\n\n.m-n9 {\n  margin: -2.25rem !important;\n}\n\n.m-n10 {\n  margin: -2.5rem !important;\n}\n\n.m-n11 {\n  margin: -2.75rem !important;\n}\n\n.m-n12 {\n  margin: -3rem !important;\n}\n\n.m-n13 {\n  margin: -3.25rem !important;\n}\n\n.m-n14 {\n  margin: -3.5rem !important;\n}\n\n.m-n15 {\n  margin: -3.75rem !important;\n}\n\n.m-n16 {\n  margin: -4rem !important;\n}\n\n.m-n17 {\n  margin: -4.25rem !important;\n}\n\n.m-n18 {\n  margin: -4.5rem !important;\n}\n\n.m-n19 {\n  margin: -4.75rem !important;\n}\n\n.m-n20 {\n  margin: -5rem !important;\n}\n\n.mx-n1 {\n  margin-right: -0.25rem !important;\n  margin-left: -0.25rem !important;\n}\n\n.mx-n2 {\n  margin-right: -0.5rem !important;\n  margin-left: -0.5rem !important;\n}\n\n.mx-n3 {\n  margin-right: -0.75rem !important;\n  margin-left: -0.75rem !important;\n}\n\n.mx-n4 {\n  margin-right: -1rem !important;\n  margin-left: -1rem !important;\n}\n\n.mx-n5 {\n  margin-right: -1.25rem !important;\n  margin-left: -1.25rem !important;\n}\n\n.mx-n6 {\n  margin-right: -1.5rem !important;\n  margin-left: -1.5rem !important;\n}\n\n.mx-n7 {\n  margin-right: -1.75rem !important;\n  margin-left: -1.75rem !important;\n}\n\n.mx-n8 {\n  margin-right: -2rem !important;\n  margin-left: -2rem !important;\n}\n\n.mx-n9 {\n  margin-right: -2.25rem !important;\n  margin-left: -2.25rem !important;\n}\n\n.mx-n10 {\n  margin-right: -2.5rem !important;\n  margin-left: -2.5rem !important;\n}\n\n.mx-n11 {\n  margin-right: -2.75rem !important;\n  margin-left: -2.75rem !important;\n}\n\n.mx-n12 {\n  margin-right: -3rem !important;\n  margin-left: -3rem !important;\n}\n\n.mx-n13 {\n  margin-right: -3.25rem !important;\n  margin-left: -3.25rem !important;\n}\n\n.mx-n14 {\n  margin-right: -3.5rem !important;\n  margin-left: -3.5rem !important;\n}\n\n.mx-n15 {\n  margin-right: -3.75rem !important;\n  margin-left: -3.75rem !important;\n}\n\n.mx-n16 {\n  margin-right: -4rem !important;\n  margin-left: -4rem !important;\n}\n\n.mx-n17 {\n  margin-right: -4.25rem !important;\n  margin-left: -4.25rem !important;\n}\n\n.mx-n18 {\n  margin-right: -4.5rem !important;\n  margin-left: -4.5rem !important;\n}\n\n.mx-n19 {\n  margin-right: -4.75rem !important;\n  margin-left: -4.75rem !important;\n}\n\n.mx-n20 {\n  margin-right: -5rem !important;\n  margin-left: -5rem !important;\n}\n\n.my-n1 {\n  margin-top: -0.25rem !important;\n  margin-bottom: -0.25rem !important;\n}\n\n.my-n2 {\n  margin-top: -0.5rem !important;\n  margin-bottom: -0.5rem !important;\n}\n\n.my-n3 {\n  margin-top: -0.75rem !important;\n  margin-bottom: -0.75rem !important;\n}\n\n.my-n4 {\n  margin-top: -1rem !important;\n  margin-bottom: -1rem !important;\n}\n\n.my-n5 {\n  margin-top: -1.25rem !important;\n  margin-bottom: -1.25rem !important;\n}\n\n.my-n6 {\n  margin-top: -1.5rem !important;\n  margin-bottom: -1.5rem !important;\n}\n\n.my-n7 {\n  margin-top: -1.75rem !important;\n  margin-bottom: -1.75rem !important;\n}\n\n.my-n8 {\n  margin-top: -2rem !important;\n  margin-bottom: -2rem !important;\n}\n\n.my-n9 {\n  margin-top: -2.25rem !important;\n  margin-bottom: -2.25rem !important;\n}\n\n.my-n10 {\n  margin-top: -2.5rem !important;\n  margin-bottom: -2.5rem !important;\n}\n\n.my-n11 {\n  margin-top: -2.75rem !important;\n  margin-bottom: -2.75rem !important;\n}\n\n.my-n12 {\n  margin-top: -3rem !important;\n  margin-bottom: -3rem !important;\n}\n\n.my-n13 {\n  margin-top: -3.25rem !important;\n  margin-bottom: -3.25rem !important;\n}\n\n.my-n14 {\n  margin-top: -3.5rem !important;\n  margin-bottom: -3.5rem !important;\n}\n\n.my-n15 {\n  margin-top: -3.75rem !important;\n  margin-bottom: -3.75rem !important;\n}\n\n.my-n16 {\n  margin-top: -4rem !important;\n  margin-bottom: -4rem !important;\n}\n\n.my-n17 {\n  margin-top: -4.25rem !important;\n  margin-bottom: -4.25rem !important;\n}\n\n.my-n18 {\n  margin-top: -4.5rem !important;\n  margin-bottom: -4.5rem !important;\n}\n\n.my-n19 {\n  margin-top: -4.75rem !important;\n  margin-bottom: -4.75rem !important;\n}\n\n.my-n20 {\n  margin-top: -5rem !important;\n  margin-bottom: -5rem !important;\n}\n\n.mt-n1 {\n  margin-top: -0.25rem !important;\n}\n\n.mt-n2 {\n  margin-top: -0.5rem !important;\n}\n\n.mt-n3 {\n  margin-top: -0.75rem !important;\n}\n\n.mt-n4 {\n  margin-top: -1rem !important;\n}\n\n.mt-n5 {\n  margin-top: -1.25rem !important;\n}\n\n.mt-n6 {\n  margin-top: -1.5rem !important;\n}\n\n.mt-n7 {\n  margin-top: -1.75rem !important;\n}\n\n.mt-n8 {\n  margin-top: -2rem !important;\n}\n\n.mt-n9 {\n  margin-top: -2.25rem !important;\n}\n\n.mt-n10 {\n  margin-top: -2.5rem !important;\n}\n\n.mt-n11 {\n  margin-top: -2.75rem !important;\n}\n\n.mt-n12 {\n  margin-top: -3rem !important;\n}\n\n.mt-n13 {\n  margin-top: -3.25rem !important;\n}\n\n.mt-n14 {\n  margin-top: -3.5rem !important;\n}\n\n.mt-n15 {\n  margin-top: -3.75rem !important;\n}\n\n.mt-n16 {\n  margin-top: -4rem !important;\n}\n\n.mt-n17 {\n  margin-top: -4.25rem !important;\n}\n\n.mt-n18 {\n  margin-top: -4.5rem !important;\n}\n\n.mt-n19 {\n  margin-top: -4.75rem !important;\n}\n\n.mt-n20 {\n  margin-top: -5rem !important;\n}\n\n.me-n1 {\n  margin-right: -0.25rem !important;\n}\n\n.me-n2 {\n  margin-right: -0.5rem !important;\n}\n\n.me-n3 {\n  margin-right: -0.75rem !important;\n}\n\n.me-n4 {\n  margin-right: -1rem !important;\n}\n\n.me-n5 {\n  margin-right: -1.25rem !important;\n}\n\n.me-n6 {\n  margin-right: -1.5rem !important;\n}\n\n.me-n7 {\n  margin-right: -1.75rem !important;\n}\n\n.me-n8 {\n  margin-right: -2rem !important;\n}\n\n.me-n9 {\n  margin-right: -2.25rem !important;\n}\n\n.me-n10 {\n  margin-right: -2.5rem !important;\n}\n\n.me-n11 {\n  margin-right: -2.75rem !important;\n}\n\n.me-n12 {\n  margin-right: -3rem !important;\n}\n\n.me-n13 {\n  margin-right: -3.25rem !important;\n}\n\n.me-n14 {\n  margin-right: -3.5rem !important;\n}\n\n.me-n15 {\n  margin-right: -3.75rem !important;\n}\n\n.me-n16 {\n  margin-right: -4rem !important;\n}\n\n.me-n17 {\n  margin-right: -4.25rem !important;\n}\n\n.me-n18 {\n  margin-right: -4.5rem !important;\n}\n\n.me-n19 {\n  margin-right: -4.75rem !important;\n}\n\n.me-n20 {\n  margin-right: -5rem !important;\n}\n\n.mb-n1 {\n  margin-bottom: -0.25rem !important;\n}\n\n.mb-n2 {\n  margin-bottom: -0.5rem !important;\n}\n\n.mb-n3 {\n  margin-bottom: -0.75rem !important;\n}\n\n.mb-n4 {\n  margin-bottom: -1rem !important;\n}\n\n.mb-n5 {\n  margin-bottom: -1.25rem !important;\n}\n\n.mb-n6 {\n  margin-bottom: -1.5rem !important;\n}\n\n.mb-n7 {\n  margin-bottom: -1.75rem !important;\n}\n\n.mb-n8 {\n  margin-bottom: -2rem !important;\n}\n\n.mb-n9 {\n  margin-bottom: -2.25rem !important;\n}\n\n.mb-n10 {\n  margin-bottom: -2.5rem !important;\n}\n\n.mb-n11 {\n  margin-bottom: -2.75rem !important;\n}\n\n.mb-n12 {\n  margin-bottom: -3rem !important;\n}\n\n.mb-n13 {\n  margin-bottom: -3.25rem !important;\n}\n\n.mb-n14 {\n  margin-bottom: -3.5rem !important;\n}\n\n.mb-n15 {\n  margin-bottom: -3.75rem !important;\n}\n\n.mb-n16 {\n  margin-bottom: -4rem !important;\n}\n\n.mb-n17 {\n  margin-bottom: -4.25rem !important;\n}\n\n.mb-n18 {\n  margin-bottom: -4.5rem !important;\n}\n\n.mb-n19 {\n  margin-bottom: -4.75rem !important;\n}\n\n.mb-n20 {\n  margin-bottom: -5rem !important;\n}\n\n.ms-n1 {\n  margin-left: -0.25rem !important;\n}\n\n.ms-n2 {\n  margin-left: -0.5rem !important;\n}\n\n.ms-n3 {\n  margin-left: -0.75rem !important;\n}\n\n.ms-n4 {\n  margin-left: -1rem !important;\n}\n\n.ms-n5 {\n  margin-left: -1.25rem !important;\n}\n\n.ms-n6 {\n  margin-left: -1.5rem !important;\n}\n\n.ms-n7 {\n  margin-left: -1.75rem !important;\n}\n\n.ms-n8 {\n  margin-left: -2rem !important;\n}\n\n.ms-n9 {\n  margin-left: -2.25rem !important;\n}\n\n.ms-n10 {\n  margin-left: -2.5rem !important;\n}\n\n.ms-n11 {\n  margin-left: -2.75rem !important;\n}\n\n.ms-n12 {\n  margin-left: -3rem !important;\n}\n\n.ms-n13 {\n  margin-left: -3.25rem !important;\n}\n\n.ms-n14 {\n  margin-left: -3.5rem !important;\n}\n\n.ms-n15 {\n  margin-left: -3.75rem !important;\n}\n\n.ms-n16 {\n  margin-left: -4rem !important;\n}\n\n.ms-n17 {\n  margin-left: -4.25rem !important;\n}\n\n.ms-n18 {\n  margin-left: -4.5rem !important;\n}\n\n.ms-n19 {\n  margin-left: -4.75rem !important;\n}\n\n.ms-n20 {\n  margin-left: -5rem !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 0.75rem !important;\n}\n\n.p-4 {\n  padding: 1rem !important;\n}\n\n.p-5 {\n  padding: 1.25rem !important;\n}\n\n.p-6 {\n  padding: 1.5rem !important;\n}\n\n.p-7 {\n  padding: 1.75rem !important;\n}\n\n.p-8 {\n  padding: 2rem !important;\n}\n\n.p-9 {\n  padding: 2.25rem !important;\n}\n\n.p-10 {\n  padding: 2.5rem !important;\n}\n\n.p-11 {\n  padding: 2.75rem !important;\n}\n\n.p-12 {\n  padding: 3rem !important;\n}\n\n.p-13 {\n  padding: 3.25rem !important;\n}\n\n.p-14 {\n  padding: 3.5rem !important;\n}\n\n.p-15 {\n  padding: 3.75rem !important;\n}\n\n.p-16 {\n  padding: 4rem !important;\n}\n\n.p-17 {\n  padding: 4.25rem !important;\n}\n\n.p-18 {\n  padding: 4.5rem !important;\n}\n\n.p-19 {\n  padding: 4.75rem !important;\n}\n\n.p-20 {\n  padding: 5rem !important;\n}\n\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.px-1 {\n  padding-right: 0.25rem !important;\n  padding-left: 0.25rem !important;\n}\n\n.px-2 {\n  padding-right: 0.5rem !important;\n  padding-left: 0.5rem !important;\n}\n\n.px-3 {\n  padding-right: 0.75rem !important;\n  padding-left: 0.75rem !important;\n}\n\n.px-4 {\n  padding-right: 1rem !important;\n  padding-left: 1rem !important;\n}\n\n.px-5 {\n  padding-right: 1.25rem !important;\n  padding-left: 1.25rem !important;\n}\n\n.px-6 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n\n.px-7 {\n  padding-right: 1.75rem !important;\n  padding-left: 1.75rem !important;\n}\n\n.px-8 {\n  padding-right: 2rem !important;\n  padding-left: 2rem !important;\n}\n\n.px-9 {\n  padding-right: 2.25rem !important;\n  padding-left: 2.25rem !important;\n}\n\n.px-10 {\n  padding-right: 2.5rem !important;\n  padding-left: 2.5rem !important;\n}\n\n.px-11 {\n  padding-right: 2.75rem !important;\n  padding-left: 2.75rem !important;\n}\n\n.px-12 {\n  padding-right: 3rem !important;\n  padding-left: 3rem !important;\n}\n\n.px-13 {\n  padding-right: 3.25rem !important;\n  padding-left: 3.25rem !important;\n}\n\n.px-14 {\n  padding-right: 3.5rem !important;\n  padding-left: 3.5rem !important;\n}\n\n.px-15 {\n  padding-right: 3.75rem !important;\n  padding-left: 3.75rem !important;\n}\n\n.px-16 {\n  padding-right: 4rem !important;\n  padding-left: 4rem !important;\n}\n\n.px-17 {\n  padding-right: 4.25rem !important;\n  padding-left: 4.25rem !important;\n}\n\n.px-18 {\n  padding-right: 4.5rem !important;\n  padding-left: 4.5rem !important;\n}\n\n.px-19 {\n  padding-right: 4.75rem !important;\n  padding-left: 4.75rem !important;\n}\n\n.px-20 {\n  padding-right: 5rem !important;\n  padding-left: 5rem !important;\n}\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.py-1 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n\n.py-2 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n\n.py-3 {\n  padding-top: 0.75rem !important;\n  padding-bottom: 0.75rem !important;\n}\n\n.py-4 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n\n.py-5 {\n  padding-top: 1.25rem !important;\n  padding-bottom: 1.25rem !important;\n}\n\n.py-6 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n\n.py-7 {\n  padding-top: 1.75rem !important;\n  padding-bottom: 1.75rem !important;\n}\n\n.py-8 {\n  padding-top: 2rem !important;\n  padding-bottom: 2rem !important;\n}\n\n.py-9 {\n  padding-top: 2.25rem !important;\n  padding-bottom: 2.25rem !important;\n}\n\n.py-10 {\n  padding-top: 2.5rem !important;\n  padding-bottom: 2.5rem !important;\n}\n\n.py-11 {\n  padding-top: 2.75rem !important;\n  padding-bottom: 2.75rem !important;\n}\n\n.py-12 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n\n.py-13 {\n  padding-top: 3.25rem !important;\n  padding-bottom: 3.25rem !important;\n}\n\n.py-14 {\n  padding-top: 3.5rem !important;\n  padding-bottom: 3.5rem !important;\n}\n\n.py-15 {\n  padding-top: 3.75rem !important;\n  padding-bottom: 3.75rem !important;\n}\n\n.py-16 {\n  padding-top: 4rem !important;\n  padding-bottom: 4rem !important;\n}\n\n.py-17 {\n  padding-top: 4.25rem !important;\n  padding-bottom: 4.25rem !important;\n}\n\n.py-18 {\n  padding-top: 4.5rem !important;\n  padding-bottom: 4.5rem !important;\n}\n\n.py-19 {\n  padding-top: 4.75rem !important;\n  padding-bottom: 4.75rem !important;\n}\n\n.py-20 {\n  padding-top: 5rem !important;\n  padding-bottom: 5rem !important;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pt-3 {\n  padding-top: 0.75rem !important;\n}\n\n.pt-4 {\n  padding-top: 1rem !important;\n}\n\n.pt-5 {\n  padding-top: 1.25rem !important;\n}\n\n.pt-6 {\n  padding-top: 1.5rem !important;\n}\n\n.pt-7 {\n  padding-top: 1.75rem !important;\n}\n\n.pt-8 {\n  padding-top: 2rem !important;\n}\n\n.pt-9 {\n  padding-top: 2.25rem !important;\n}\n\n.pt-10 {\n  padding-top: 2.5rem !important;\n}\n\n.pt-11 {\n  padding-top: 2.75rem !important;\n}\n\n.pt-12 {\n  padding-top: 3rem !important;\n}\n\n.pt-13 {\n  padding-top: 3.25rem !important;\n}\n\n.pt-14 {\n  padding-top: 3.5rem !important;\n}\n\n.pt-15 {\n  padding-top: 3.75rem !important;\n}\n\n.pt-16 {\n  padding-top: 4rem !important;\n}\n\n.pt-17 {\n  padding-top: 4.25rem !important;\n}\n\n.pt-18 {\n  padding-top: 4.5rem !important;\n}\n\n.pt-19 {\n  padding-top: 4.75rem !important;\n}\n\n.pt-20 {\n  padding-top: 5rem !important;\n}\n\n.pe-0 {\n  padding-right: 0 !important;\n}\n\n.pe-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pe-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pe-3 {\n  padding-right: 0.75rem !important;\n}\n\n.pe-4 {\n  padding-right: 1rem !important;\n}\n\n.pe-5 {\n  padding-right: 1.25rem !important;\n}\n\n.pe-6 {\n  padding-right: 1.5rem !important;\n}\n\n.pe-7 {\n  padding-right: 1.75rem !important;\n}\n\n.pe-8 {\n  padding-right: 2rem !important;\n}\n\n.pe-9 {\n  padding-right: 2.25rem !important;\n}\n\n.pe-10 {\n  padding-right: 2.5rem !important;\n}\n\n.pe-11 {\n  padding-right: 2.75rem !important;\n}\n\n.pe-12 {\n  padding-right: 3rem !important;\n}\n\n.pe-13 {\n  padding-right: 3.25rem !important;\n}\n\n.pe-14 {\n  padding-right: 3.5rem !important;\n}\n\n.pe-15 {\n  padding-right: 3.75rem !important;\n}\n\n.pe-16 {\n  padding-right: 4rem !important;\n}\n\n.pe-17 {\n  padding-right: 4.25rem !important;\n}\n\n.pe-18 {\n  padding-right: 4.5rem !important;\n}\n\n.pe-19 {\n  padding-right: 4.75rem !important;\n}\n\n.pe-20 {\n  padding-right: 5rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pb-3 {\n  padding-bottom: 0.75rem !important;\n}\n\n.pb-4 {\n  padding-bottom: 1rem !important;\n}\n\n.pb-5 {\n  padding-bottom: 1.25rem !important;\n}\n\n.pb-6 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pb-7 {\n  padding-bottom: 1.75rem !important;\n}\n\n.pb-8 {\n  padding-bottom: 2rem !important;\n}\n\n.pb-9 {\n  padding-bottom: 2.25rem !important;\n}\n\n.pb-10 {\n  padding-bottom: 2.5rem !important;\n}\n\n.pb-11 {\n  padding-bottom: 2.75rem !important;\n}\n\n.pb-12 {\n  padding-bottom: 3rem !important;\n}\n\n.pb-13 {\n  padding-bottom: 3.25rem !important;\n}\n\n.pb-14 {\n  padding-bottom: 3.5rem !important;\n}\n\n.pb-15 {\n  padding-bottom: 3.75rem !important;\n}\n\n.pb-16 {\n  padding-bottom: 4rem !important;\n}\n\n.pb-17 {\n  padding-bottom: 4.25rem !important;\n}\n\n.pb-18 {\n  padding-bottom: 4.5rem !important;\n}\n\n.pb-19 {\n  padding-bottom: 4.75rem !important;\n}\n\n.pb-20 {\n  padding-bottom: 5rem !important;\n}\n\n.ps-0 {\n  padding-left: 0 !important;\n}\n\n.ps-1 {\n  padding-left: 0.25rem !important;\n}\n\n.ps-2 {\n  padding-left: 0.5rem !important;\n}\n\n.ps-3 {\n  padding-left: 0.75rem !important;\n}\n\n.ps-4 {\n  padding-left: 1rem !important;\n}\n\n.ps-5 {\n  padding-left: 1.25rem !important;\n}\n\n.ps-6 {\n  padding-left: 1.5rem !important;\n}\n\n.ps-7 {\n  padding-left: 1.75rem !important;\n}\n\n.ps-8 {\n  padding-left: 2rem !important;\n}\n\n.ps-9 {\n  padding-left: 2.25rem !important;\n}\n\n.ps-10 {\n  padding-left: 2.5rem !important;\n}\n\n.ps-11 {\n  padding-left: 2.75rem !important;\n}\n\n.ps-12 {\n  padding-left: 3rem !important;\n}\n\n.ps-13 {\n  padding-left: 3.25rem !important;\n}\n\n.ps-14 {\n  padding-left: 3.5rem !important;\n}\n\n.ps-15 {\n  padding-left: 3.75rem !important;\n}\n\n.ps-16 {\n  padding-left: 4rem !important;\n}\n\n.ps-17 {\n  padding-left: 4.25rem !important;\n}\n\n.ps-18 {\n  padding-left: 4.5rem !important;\n}\n\n.ps-19 {\n  padding-left: 4.75rem !important;\n}\n\n.ps-20 {\n  padding-left: 5rem !important;\n}\n\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-1 {\n  gap: 0.25rem !important;\n}\n\n.gap-2 {\n  gap: 0.5rem !important;\n}\n\n.gap-3 {\n  gap: 0.75rem !important;\n}\n\n.gap-4 {\n  gap: 1rem !important;\n}\n\n.gap-5 {\n  gap: 1.25rem !important;\n}\n\n.gap-6 {\n  gap: 1.5rem !important;\n}\n\n.gap-7 {\n  gap: 1.75rem !important;\n}\n\n.gap-8 {\n  gap: 2rem !important;\n}\n\n.gap-9 {\n  gap: 2.25rem !important;\n}\n\n.gap-10 {\n  gap: 2.5rem !important;\n}\n\n.gap-11 {\n  gap: 2.75rem !important;\n}\n\n.gap-12 {\n  gap: 3rem !important;\n}\n\n.gap-13 {\n  gap: 3.25rem !important;\n}\n\n.gap-14 {\n  gap: 3.5rem !important;\n}\n\n.gap-15 {\n  gap: 3.75rem !important;\n}\n\n.gap-16 {\n  gap: 4rem !important;\n}\n\n.gap-17 {\n  gap: 4.25rem !important;\n}\n\n.gap-18 {\n  gap: 4.5rem !important;\n}\n\n.gap-19 {\n  gap: 4.75rem !important;\n}\n\n.gap-20 {\n  gap: 5rem !important;\n}\n\n.row-gap-0 {\n  row-gap: 0 !important;\n}\n\n.row-gap-1 {\n  row-gap: 0.25rem !important;\n}\n\n.row-gap-2 {\n  row-gap: 0.5rem !important;\n}\n\n.row-gap-3 {\n  row-gap: 0.75rem !important;\n}\n\n.row-gap-4 {\n  row-gap: 1rem !important;\n}\n\n.row-gap-5 {\n  row-gap: 1.25rem !important;\n}\n\n.row-gap-6 {\n  row-gap: 1.5rem !important;\n}\n\n.row-gap-7 {\n  row-gap: 1.75rem !important;\n}\n\n.row-gap-8 {\n  row-gap: 2rem !important;\n}\n\n.row-gap-9 {\n  row-gap: 2.25rem !important;\n}\n\n.row-gap-10 {\n  row-gap: 2.5rem !important;\n}\n\n.row-gap-11 {\n  row-gap: 2.75rem !important;\n}\n\n.row-gap-12 {\n  row-gap: 3rem !important;\n}\n\n.row-gap-13 {\n  row-gap: 3.25rem !important;\n}\n\n.row-gap-14 {\n  row-gap: 3.5rem !important;\n}\n\n.row-gap-15 {\n  row-gap: 3.75rem !important;\n}\n\n.row-gap-16 {\n  row-gap: 4rem !important;\n}\n\n.row-gap-17 {\n  row-gap: 4.25rem !important;\n}\n\n.row-gap-18 {\n  row-gap: 4.5rem !important;\n}\n\n.row-gap-19 {\n  row-gap: 4.75rem !important;\n}\n\n.row-gap-20 {\n  row-gap: 5rem !important;\n}\n\n.column-gap-0 {\n  column-gap: 0 !important;\n}\n\n.column-gap-1 {\n  column-gap: 0.25rem !important;\n}\n\n.column-gap-2 {\n  column-gap: 0.5rem !important;\n}\n\n.column-gap-3 {\n  column-gap: 0.75rem !important;\n}\n\n.column-gap-4 {\n  column-gap: 1rem !important;\n}\n\n.column-gap-5 {\n  column-gap: 1.25rem !important;\n}\n\n.column-gap-6 {\n  column-gap: 1.5rem !important;\n}\n\n.column-gap-7 {\n  column-gap: 1.75rem !important;\n}\n\n.column-gap-8 {\n  column-gap: 2rem !important;\n}\n\n.column-gap-9 {\n  column-gap: 2.25rem !important;\n}\n\n.column-gap-10 {\n  column-gap: 2.5rem !important;\n}\n\n.column-gap-11 {\n  column-gap: 2.75rem !important;\n}\n\n.column-gap-12 {\n  column-gap: 3rem !important;\n}\n\n.column-gap-13 {\n  column-gap: 3.25rem !important;\n}\n\n.column-gap-14 {\n  column-gap: 3.5rem !important;\n}\n\n.column-gap-15 {\n  column-gap: 3.75rem !important;\n}\n\n.column-gap-16 {\n  column-gap: 4rem !important;\n}\n\n.column-gap-17 {\n  column-gap: 4.25rem !important;\n}\n\n.column-gap-18 {\n  column-gap: 4.5rem !important;\n}\n\n.column-gap-19 {\n  column-gap: 4.75rem !important;\n}\n\n.column-gap-20 {\n  column-gap: 5rem !important;\n}\n\n.font-monospace {\n  font-family: var(--bs-font-monospace) !important;\n}\n\n.fs-1 {\n  font-size: calc(1.3rem + 0.6vw) !important;\n}\n\n.fs-2 {\n  font-size: calc(1.275rem + 0.3vw) !important;\n}\n\n.fs-3 {\n  font-size: calc(1.26rem + 0.12vw) !important;\n}\n\n.fs-4 {\n  font-size: 1.25rem !important;\n}\n\n.fs-5 {\n  font-size: 1.15rem !important;\n}\n\n.fs-6 {\n  font-size: 1.075rem !important;\n}\n\n.fs-7 {\n  font-size: 0.95rem !important;\n}\n\n.fs-8 {\n  font-size: 0.85rem !important;\n}\n\n.fs-9 {\n  font-size: 0.75rem !important;\n}\n\n.fs-10 {\n  font-size: 0.5rem !important;\n}\n\n.fs-base {\n  font-size: 1rem !important;\n}\n\n.fs-fluid {\n  font-size: 100% !important;\n}\n\n.fs-2x {\n  font-size: calc(1.325rem + 0.9vw) !important;\n}\n\n.fs-2qx {\n  font-size: calc(1.35rem + 1.2vw) !important;\n}\n\n.fs-2hx {\n  font-size: calc(1.375rem + 1.5vw) !important;\n}\n\n.fs-2tx {\n  font-size: calc(1.4rem + 1.8vw) !important;\n}\n\n.fs-3x {\n  font-size: calc(1.425rem + 2.1vw) !important;\n}\n\n.fs-3qx {\n  font-size: calc(1.45rem + 2.4vw) !important;\n}\n\n.fs-3hx {\n  font-size: calc(1.475rem + 2.7vw) !important;\n}\n\n.fs-3tx {\n  font-size: calc(1.5rem + 3vw) !important;\n}\n\n.fs-4x {\n  font-size: calc(1.525rem + 3.3vw) !important;\n}\n\n.fs-4qx {\n  font-size: calc(1.55rem + 3.6vw) !important;\n}\n\n.fs-4hx {\n  font-size: calc(1.575rem + 3.9vw) !important;\n}\n\n.fs-4tx {\n  font-size: calc(1.6rem + 4.2vw) !important;\n}\n\n.fs-5x {\n  font-size: calc(1.625rem + 4.5vw) !important;\n}\n\n.fs-5qx {\n  font-size: calc(1.65rem + 4.8vw) !important;\n}\n\n.fs-5hx {\n  font-size: calc(1.675rem + 5.1vw) !important;\n}\n\n.fs-5tx {\n  font-size: calc(1.7rem + 5.4vw) !important;\n}\n\n.fst-italic {\n  font-style: italic !important;\n}\n\n.fst-normal {\n  font-style: normal !important;\n}\n\n.fw-lighter {\n  font-weight: lighter !important;\n}\n\n.fw-light {\n  font-weight: 300 !important;\n}\n\n.fw-normal {\n  font-weight: 400 !important;\n}\n\n.fw-medium {\n  font-weight: 500 !important;\n}\n\n.fw-semibold {\n  font-weight: 600 !important;\n}\n\n.fw-bold {\n  font-weight: 500 !important;\n}\n\n.fw-bolder {\n  font-weight: 600 !important;\n}\n\n.lh-1 {\n  line-height: 1 !important;\n}\n\n.lh-sm {\n  line-height: 1.25 !important;\n}\n\n.lh-base {\n  line-height: 1.5 !important;\n}\n\n.lh-lg {\n  line-height: 1.75 !important;\n}\n\n.text-start {\n  text-align: left !important;\n}\n\n.text-end {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-decoration-underline {\n  text-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n/* rtl:begin:remove */\n.text-break {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n/* rtl:end:remove */\n.text-white {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-light {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-primary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-secondary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-info {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-warning {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-dark {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-black {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-body {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-muted {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-black-50 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-body-secondary {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-body-tertiary {\n  --bs-text-opacity: 1;\n  color: var(--bs-tertiary-color) !important;\n}\n\n.text-body-emphasis {\n  --bs-text-opacity: 1;\n  color: var(--bs-emphasis-color) !important;\n}\n\n.text-reset {\n  --bs-text-opacity: 1;\n  color: inherit !important;\n}\n\n.text-opacity-25 {\n  --bs-text-opacity: 0.25;\n}\n\n.text-opacity-50 {\n  --bs-text-opacity: 0.5;\n}\n\n.text-opacity-75 {\n  --bs-text-opacity: 0.75;\n}\n\n.text-opacity-100 {\n  --bs-text-opacity: 1;\n}\n\n.text-primary-emphasis {\n  color: var(--bs-primary-text-emphasis) !important;\n}\n\n.text-secondary-emphasis {\n  color: var(--bs-secondary-text-emphasis) !important;\n}\n\n.text-success-emphasis {\n  color: var(--bs-success-text-emphasis) !important;\n}\n\n.text-info-emphasis {\n  color: var(--bs-info-text-emphasis) !important;\n}\n\n.text-warning-emphasis {\n  color: var(--bs-warning-text-emphasis) !important;\n}\n\n.text-danger-emphasis {\n  color: var(--bs-danger-text-emphasis) !important;\n}\n\n.text-light-emphasis {\n  color: var(--bs-light-text-emphasis) !important;\n}\n\n.text-dark-emphasis {\n  color: var(--bs-dark-text-emphasis) !important;\n}\n\n.link-opacity-10 {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-10-hover:hover {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-25 {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-25-hover:hover {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-50 {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-50-hover:hover {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-75 {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-75-hover:hover {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-100 {\n  --bs-link-opacity: 1;\n}\n\n.link-opacity-100-hover:hover {\n  --bs-link-opacity: 1;\n}\n\n.link-offset-1 {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-1-hover:hover {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-2 {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-2-hover:hover {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-3 {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-offset-3-hover:hover {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-underline-white {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-white-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-light {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-primary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-secondary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-success {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-info {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-warning {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-danger {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-dark {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-underline-opacity-0 {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-0-hover:hover {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-10 {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-10-hover:hover {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-25 {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-25-hover:hover {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-50 {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-50-hover:hover {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-75 {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-75-hover:hover {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-100 {\n  --bs-link-underline-opacity: 1;\n}\n\n.link-underline-opacity-100-hover:hover {\n  --bs-link-underline-opacity: 1;\n}\n\n.bg-white {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-light {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-primary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-info {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-black {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-transparent {\n  --bs-bg-opacity: 1;\n  background-color: transparent !important;\n}\n\n.bg-body-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body-tertiary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-opacity-10 {\n  --bs-bg-opacity: 0.1;\n}\n\n.bg-opacity-25 {\n  --bs-bg-opacity: 0.25;\n}\n\n.bg-opacity-50 {\n  --bs-bg-opacity: 0.5;\n}\n\n.bg-opacity-75 {\n  --bs-bg-opacity: 0.75;\n}\n\n.bg-opacity-100 {\n  --bs-bg-opacity: 1;\n}\n\n.bg-primary-subtle {\n  background-color: var(--bs-primary-bg-subtle) !important;\n}\n\n.bg-secondary-subtle {\n  background-color: var(--bs-secondary-bg-subtle) !important;\n}\n\n.bg-success-subtle {\n  background-color: var(--bs-success-bg-subtle) !important;\n}\n\n.bg-info-subtle {\n  background-color: var(--bs-info-bg-subtle) !important;\n}\n\n.bg-warning-subtle {\n  background-color: var(--bs-warning-bg-subtle) !important;\n}\n\n.bg-danger-subtle {\n  background-color: var(--bs-danger-bg-subtle) !important;\n}\n\n.bg-light-subtle {\n  background-color: var(--bs-light-bg-subtle) !important;\n}\n\n.bg-dark-subtle {\n  background-color: var(--bs-dark-bg-subtle) !important;\n}\n\n.bg-gradient {\n  background-image: var(--bs-gradient) !important;\n}\n\n.user-select-all {\n  user-select: all !important;\n}\n\n.user-select-auto {\n  user-select: auto !important;\n}\n\n.user-select-none {\n  user-select: none !important;\n}\n\n.pe-none {\n  pointer-events: none !important;\n}\n\n.pe-auto {\n  pointer-events: auto !important;\n}\n\n.rounded {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.rounded-1 {\n  border-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-2 {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-3 {\n  border-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-4 {\n  border-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-5 {\n  border-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-top {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-0 {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.rounded-top-1 {\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-top-2 {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-3 {\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-top-4 {\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-top-5 {\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-top-circle {\n  border-top-left-radius: 50% !important;\n  border-top-right-radius: 50% !important;\n}\n\n.rounded-top-pill {\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-end {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-end-1 {\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-end-2 {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-3 {\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-end-4 {\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-end-5 {\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-end-circle {\n  border-top-right-radius: 50% !important;\n  border-bottom-right-radius: 50% !important;\n}\n\n.rounded-end-pill {\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-0 {\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.rounded-bottom-1 {\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-bottom-2 {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-3 {\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-bottom-4 {\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-bottom-5 {\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-bottom-circle {\n  border-bottom-right-radius: 50% !important;\n  border-bottom-left-radius: 50% !important;\n}\n\n.rounded-bottom-pill {\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-start {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-0 {\n  border-bottom-left-radius: 0 !important;\n  border-top-left-radius: 0 !important;\n}\n\n.rounded-start-1 {\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-start-2 {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-3 {\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-start-4 {\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-start-5 {\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-start-circle {\n  border-bottom-left-radius: 50% !important;\n  border-top-left-radius: 50% !important;\n}\n\n.rounded-start-pill {\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n.z-n1 {\n  z-index: -1 !important;\n}\n\n.z-0 {\n  z-index: 0 !important;\n}\n\n.z-1 {\n  z-index: 1 !important;\n}\n\n.z-2 {\n  z-index: 2 !important;\n}\n\n.z-3 {\n  z-index: 3 !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-start {\n    float: left !important;\n  }\n\n  .float-sm-end {\n    float: right !important;\n  }\n\n  .float-sm-none {\n    float: none !important;\n  }\n\n  .object-fit-sm-contain {\n    object-fit: contain !important;\n  }\n\n  .object-fit-sm-cover {\n    object-fit: cover !important;\n  }\n\n  .object-fit-sm-fill {\n    object-fit: fill !important;\n  }\n\n  .object-fit-sm-scale {\n    object-fit: scale-down !important;\n  }\n\n  .object-fit-sm-none {\n    object-fit: none !important;\n  }\n\n  .d-sm-inline {\n    display: inline !important;\n  }\n\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-sm-block {\n    display: block !important;\n  }\n\n  .d-sm-grid {\n    display: grid !important;\n  }\n\n  .d-sm-inline-grid {\n    display: inline-grid !important;\n  }\n\n  .d-sm-table {\n    display: table !important;\n  }\n\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-sm-flex {\n    display: flex !important;\n  }\n\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-sm-none {\n    display: none !important;\n  }\n\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n\n  .justify-content-sm-evenly {\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n\n  .order-sm-first {\n    order: -1 !important;\n  }\n\n  .order-sm-0 {\n    order: 0 !important;\n  }\n\n  .order-sm-1 {\n    order: 1 !important;\n  }\n\n  .order-sm-2 {\n    order: 2 !important;\n  }\n\n  .order-sm-3 {\n    order: 3 !important;\n  }\n\n  .order-sm-4 {\n    order: 4 !important;\n  }\n\n  .order-sm-5 {\n    order: 5 !important;\n  }\n\n  .order-sm-last {\n    order: 6 !important;\n  }\n\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-sm-3 {\n    margin: 0.75rem !important;\n  }\n\n  .m-sm-4 {\n    margin: 1rem !important;\n  }\n\n  .m-sm-5 {\n    margin: 1.25rem !important;\n  }\n\n  .m-sm-6 {\n    margin: 1.5rem !important;\n  }\n\n  .m-sm-7 {\n    margin: 1.75rem !important;\n  }\n\n  .m-sm-8 {\n    margin: 2rem !important;\n  }\n\n  .m-sm-9 {\n    margin: 2.25rem !important;\n  }\n\n  .m-sm-10 {\n    margin: 2.5rem !important;\n  }\n\n  .m-sm-11 {\n    margin: 2.75rem !important;\n  }\n\n  .m-sm-12 {\n    margin: 3rem !important;\n  }\n\n  .m-sm-13 {\n    margin: 3.25rem !important;\n  }\n\n  .m-sm-14 {\n    margin: 3.5rem !important;\n  }\n\n  .m-sm-15 {\n    margin: 3.75rem !important;\n  }\n\n  .m-sm-16 {\n    margin: 4rem !important;\n  }\n\n  .m-sm-17 {\n    margin: 4.25rem !important;\n  }\n\n  .m-sm-18 {\n    margin: 4.5rem !important;\n  }\n\n  .m-sm-19 {\n    margin: 4.75rem !important;\n  }\n\n  .m-sm-20 {\n    margin: 5rem !important;\n  }\n\n  .m-sm-auto {\n    margin: auto !important;\n  }\n\n  .mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .mx-sm-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n\n  .mx-sm-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n\n  .mx-sm-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n\n  .mx-sm-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .mx-sm-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n\n  .mx-sm-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n\n  .mx-sm-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n\n  .mx-sm-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n\n  .mx-sm-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n\n  .mx-sm-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n\n  .mx-sm-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n\n  .mx-sm-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n\n  .mx-sm-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n\n  .mx-sm-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n\n  .mx-sm-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n\n  .mx-sm-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n\n  .mx-sm-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n\n  .mx-sm-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n\n  .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-sm-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-sm-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n\n  .my-sm-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-sm-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n\n  .my-sm-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-sm-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n\n  .my-sm-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n\n  .my-sm-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n\n  .my-sm-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n\n  .my-sm-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n\n  .my-sm-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-sm-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n\n  .my-sm-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-sm-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n\n  .my-sm-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-sm-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n\n  .my-sm-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-sm-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n\n  .my-sm-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-sm-0 {\n    margin-top: 0 !important;\n  }\n\n  .mt-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-sm-3 {\n    margin-top: 0.75rem !important;\n  }\n\n  .mt-sm-4 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-sm-5 {\n    margin-top: 1.25rem !important;\n  }\n\n  .mt-sm-6 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-sm-7 {\n    margin-top: 1.75rem !important;\n  }\n\n  .mt-sm-8 {\n    margin-top: 2rem !important;\n  }\n\n  .mt-sm-9 {\n    margin-top: 2.25rem !important;\n  }\n\n  .mt-sm-10 {\n    margin-top: 2.5rem !important;\n  }\n\n  .mt-sm-11 {\n    margin-top: 2.75rem !important;\n  }\n\n  .mt-sm-12 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-sm-13 {\n    margin-top: 3.25rem !important;\n  }\n\n  .mt-sm-14 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-sm-15 {\n    margin-top: 3.75rem !important;\n  }\n\n  .mt-sm-16 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-sm-17 {\n    margin-top: 4.25rem !important;\n  }\n\n  .mt-sm-18 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-sm-19 {\n    margin-top: 4.75rem !important;\n  }\n\n  .mt-sm-20 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-sm-auto {\n    margin-top: auto !important;\n  }\n\n  .me-sm-0 {\n    margin-right: 0 !important;\n  }\n\n  .me-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-sm-3 {\n    margin-right: 0.75rem !important;\n  }\n\n  .me-sm-4 {\n    margin-right: 1rem !important;\n  }\n\n  .me-sm-5 {\n    margin-right: 1.25rem !important;\n  }\n\n  .me-sm-6 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-sm-7 {\n    margin-right: 1.75rem !important;\n  }\n\n  .me-sm-8 {\n    margin-right: 2rem !important;\n  }\n\n  .me-sm-9 {\n    margin-right: 2.25rem !important;\n  }\n\n  .me-sm-10 {\n    margin-right: 2.5rem !important;\n  }\n\n  .me-sm-11 {\n    margin-right: 2.75rem !important;\n  }\n\n  .me-sm-12 {\n    margin-right: 3rem !important;\n  }\n\n  .me-sm-13 {\n    margin-right: 3.25rem !important;\n  }\n\n  .me-sm-14 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-sm-15 {\n    margin-right: 3.75rem !important;\n  }\n\n  .me-sm-16 {\n    margin-right: 4rem !important;\n  }\n\n  .me-sm-17 {\n    margin-right: 4.25rem !important;\n  }\n\n  .me-sm-18 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-sm-19 {\n    margin-right: 4.75rem !important;\n  }\n\n  .me-sm-20 {\n    margin-right: 5rem !important;\n  }\n\n  .me-sm-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-sm-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .mb-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-sm-3 {\n    margin-bottom: 0.75rem !important;\n  }\n\n  .mb-sm-4 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-sm-5 {\n    margin-bottom: 1.25rem !important;\n  }\n\n  .mb-sm-6 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-sm-7 {\n    margin-bottom: 1.75rem !important;\n  }\n\n  .mb-sm-8 {\n    margin-bottom: 2rem !important;\n  }\n\n  .mb-sm-9 {\n    margin-bottom: 2.25rem !important;\n  }\n\n  .mb-sm-10 {\n    margin-bottom: 2.5rem !important;\n  }\n\n  .mb-sm-11 {\n    margin-bottom: 2.75rem !important;\n  }\n\n  .mb-sm-12 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-sm-13 {\n    margin-bottom: 3.25rem !important;\n  }\n\n  .mb-sm-14 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-sm-15 {\n    margin-bottom: 3.75rem !important;\n  }\n\n  .mb-sm-16 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-sm-17 {\n    margin-bottom: 4.25rem !important;\n  }\n\n  .mb-sm-18 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-sm-19 {\n    margin-bottom: 4.75rem !important;\n  }\n\n  .mb-sm-20 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-sm-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-sm-0 {\n    margin-left: 0 !important;\n  }\n\n  .ms-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-sm-3 {\n    margin-left: 0.75rem !important;\n  }\n\n  .ms-sm-4 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-sm-5 {\n    margin-left: 1.25rem !important;\n  }\n\n  .ms-sm-6 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-sm-7 {\n    margin-left: 1.75rem !important;\n  }\n\n  .ms-sm-8 {\n    margin-left: 2rem !important;\n  }\n\n  .ms-sm-9 {\n    margin-left: 2.25rem !important;\n  }\n\n  .ms-sm-10 {\n    margin-left: 2.5rem !important;\n  }\n\n  .ms-sm-11 {\n    margin-left: 2.75rem !important;\n  }\n\n  .ms-sm-12 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-sm-13 {\n    margin-left: 3.25rem !important;\n  }\n\n  .ms-sm-14 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-sm-15 {\n    margin-left: 3.75rem !important;\n  }\n\n  .ms-sm-16 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-sm-17 {\n    margin-left: 4.25rem !important;\n  }\n\n  .ms-sm-18 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-sm-19 {\n    margin-left: 4.75rem !important;\n  }\n\n  .ms-sm-20 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-sm-auto {\n    margin-left: auto !important;\n  }\n\n  .m-sm-n1 {\n    margin: -0.25rem !important;\n  }\n\n  .m-sm-n2 {\n    margin: -0.5rem !important;\n  }\n\n  .m-sm-n3 {\n    margin: -0.75rem !important;\n  }\n\n  .m-sm-n4 {\n    margin: -1rem !important;\n  }\n\n  .m-sm-n5 {\n    margin: -1.25rem !important;\n  }\n\n  .m-sm-n6 {\n    margin: -1.5rem !important;\n  }\n\n  .m-sm-n7 {\n    margin: -1.75rem !important;\n  }\n\n  .m-sm-n8 {\n    margin: -2rem !important;\n  }\n\n  .m-sm-n9 {\n    margin: -2.25rem !important;\n  }\n\n  .m-sm-n10 {\n    margin: -2.5rem !important;\n  }\n\n  .m-sm-n11 {\n    margin: -2.75rem !important;\n  }\n\n  .m-sm-n12 {\n    margin: -3rem !important;\n  }\n\n  .m-sm-n13 {\n    margin: -3.25rem !important;\n  }\n\n  .m-sm-n14 {\n    margin: -3.5rem !important;\n  }\n\n  .m-sm-n15 {\n    margin: -3.75rem !important;\n  }\n\n  .m-sm-n16 {\n    margin: -4rem !important;\n  }\n\n  .m-sm-n17 {\n    margin: -4.25rem !important;\n  }\n\n  .m-sm-n18 {\n    margin: -4.5rem !important;\n  }\n\n  .m-sm-n19 {\n    margin: -4.75rem !important;\n  }\n\n  .m-sm-n20 {\n    margin: -5rem !important;\n  }\n\n  .mx-sm-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n\n  .mx-sm-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n\n  .mx-sm-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n\n  .mx-sm-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n\n  .mx-sm-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n\n  .mx-sm-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n\n  .mx-sm-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n\n  .mx-sm-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n\n  .mx-sm-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n\n  .mx-sm-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n\n  .mx-sm-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n\n  .mx-sm-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n\n  .mx-sm-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n\n  .mx-sm-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n\n  .mx-sm-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n\n  .mx-sm-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n\n  .mx-sm-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n\n  .mx-sm-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n\n  .mx-sm-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n\n  .mx-sm-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n\n  .my-sm-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n\n  .my-sm-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n\n  .my-sm-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n\n  .my-sm-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n\n  .my-sm-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n\n  .my-sm-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n\n  .my-sm-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n\n  .my-sm-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n\n  .my-sm-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n\n  .my-sm-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n\n  .my-sm-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n\n  .my-sm-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n\n  .my-sm-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n\n  .my-sm-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n\n  .my-sm-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n\n  .my-sm-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n\n  .my-sm-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n\n  .my-sm-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n\n  .my-sm-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n\n  .my-sm-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n\n  .mt-sm-n1 {\n    margin-top: -0.25rem !important;\n  }\n\n  .mt-sm-n2 {\n    margin-top: -0.5rem !important;\n  }\n\n  .mt-sm-n3 {\n    margin-top: -0.75rem !important;\n  }\n\n  .mt-sm-n4 {\n    margin-top: -1rem !important;\n  }\n\n  .mt-sm-n5 {\n    margin-top: -1.25rem !important;\n  }\n\n  .mt-sm-n6 {\n    margin-top: -1.5rem !important;\n  }\n\n  .mt-sm-n7 {\n    margin-top: -1.75rem !important;\n  }\n\n  .mt-sm-n8 {\n    margin-top: -2rem !important;\n  }\n\n  .mt-sm-n9 {\n    margin-top: -2.25rem !important;\n  }\n\n  .mt-sm-n10 {\n    margin-top: -2.5rem !important;\n  }\n\n  .mt-sm-n11 {\n    margin-top: -2.75rem !important;\n  }\n\n  .mt-sm-n12 {\n    margin-top: -3rem !important;\n  }\n\n  .mt-sm-n13 {\n    margin-top: -3.25rem !important;\n  }\n\n  .mt-sm-n14 {\n    margin-top: -3.5rem !important;\n  }\n\n  .mt-sm-n15 {\n    margin-top: -3.75rem !important;\n  }\n\n  .mt-sm-n16 {\n    margin-top: -4rem !important;\n  }\n\n  .mt-sm-n17 {\n    margin-top: -4.25rem !important;\n  }\n\n  .mt-sm-n18 {\n    margin-top: -4.5rem !important;\n  }\n\n  .mt-sm-n19 {\n    margin-top: -4.75rem !important;\n  }\n\n  .mt-sm-n20 {\n    margin-top: -5rem !important;\n  }\n\n  .me-sm-n1 {\n    margin-right: -0.25rem !important;\n  }\n\n  .me-sm-n2 {\n    margin-right: -0.5rem !important;\n  }\n\n  .me-sm-n3 {\n    margin-right: -0.75rem !important;\n  }\n\n  .me-sm-n4 {\n    margin-right: -1rem !important;\n  }\n\n  .me-sm-n5 {\n    margin-right: -1.25rem !important;\n  }\n\n  .me-sm-n6 {\n    margin-right: -1.5rem !important;\n  }\n\n  .me-sm-n7 {\n    margin-right: -1.75rem !important;\n  }\n\n  .me-sm-n8 {\n    margin-right: -2rem !important;\n  }\n\n  .me-sm-n9 {\n    margin-right: -2.25rem !important;\n  }\n\n  .me-sm-n10 {\n    margin-right: -2.5rem !important;\n  }\n\n  .me-sm-n11 {\n    margin-right: -2.75rem !important;\n  }\n\n  .me-sm-n12 {\n    margin-right: -3rem !important;\n  }\n\n  .me-sm-n13 {\n    margin-right: -3.25rem !important;\n  }\n\n  .me-sm-n14 {\n    margin-right: -3.5rem !important;\n  }\n\n  .me-sm-n15 {\n    margin-right: -3.75rem !important;\n  }\n\n  .me-sm-n16 {\n    margin-right: -4rem !important;\n  }\n\n  .me-sm-n17 {\n    margin-right: -4.25rem !important;\n  }\n\n  .me-sm-n18 {\n    margin-right: -4.5rem !important;\n  }\n\n  .me-sm-n19 {\n    margin-right: -4.75rem !important;\n  }\n\n  .me-sm-n20 {\n    margin-right: -5rem !important;\n  }\n\n  .mb-sm-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n\n  .mb-sm-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n\n  .mb-sm-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n\n  .mb-sm-n4 {\n    margin-bottom: -1rem !important;\n  }\n\n  .mb-sm-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n\n  .mb-sm-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n\n  .mb-sm-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n\n  .mb-sm-n8 {\n    margin-bottom: -2rem !important;\n  }\n\n  .mb-sm-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n\n  .mb-sm-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n\n  .mb-sm-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n\n  .mb-sm-n12 {\n    margin-bottom: -3rem !important;\n  }\n\n  .mb-sm-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n\n  .mb-sm-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n\n  .mb-sm-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n\n  .mb-sm-n16 {\n    margin-bottom: -4rem !important;\n  }\n\n  .mb-sm-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n\n  .mb-sm-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n\n  .mb-sm-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n\n  .mb-sm-n20 {\n    margin-bottom: -5rem !important;\n  }\n\n  .ms-sm-n1 {\n    margin-left: -0.25rem !important;\n  }\n\n  .ms-sm-n2 {\n    margin-left: -0.5rem !important;\n  }\n\n  .ms-sm-n3 {\n    margin-left: -0.75rem !important;\n  }\n\n  .ms-sm-n4 {\n    margin-left: -1rem !important;\n  }\n\n  .ms-sm-n5 {\n    margin-left: -1.25rem !important;\n  }\n\n  .ms-sm-n6 {\n    margin-left: -1.5rem !important;\n  }\n\n  .ms-sm-n7 {\n    margin-left: -1.75rem !important;\n  }\n\n  .ms-sm-n8 {\n    margin-left: -2rem !important;\n  }\n\n  .ms-sm-n9 {\n    margin-left: -2.25rem !important;\n  }\n\n  .ms-sm-n10 {\n    margin-left: -2.5rem !important;\n  }\n\n  .ms-sm-n11 {\n    margin-left: -2.75rem !important;\n  }\n\n  .ms-sm-n12 {\n    margin-left: -3rem !important;\n  }\n\n  .ms-sm-n13 {\n    margin-left: -3.25rem !important;\n  }\n\n  .ms-sm-n14 {\n    margin-left: -3.5rem !important;\n  }\n\n  .ms-sm-n15 {\n    margin-left: -3.75rem !important;\n  }\n\n  .ms-sm-n16 {\n    margin-left: -4rem !important;\n  }\n\n  .ms-sm-n17 {\n    margin-left: -4.25rem !important;\n  }\n\n  .ms-sm-n18 {\n    margin-left: -4.5rem !important;\n  }\n\n  .ms-sm-n19 {\n    margin-left: -4.75rem !important;\n  }\n\n  .ms-sm-n20 {\n    margin-left: -5rem !important;\n  }\n\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-sm-3 {\n    padding: 0.75rem !important;\n  }\n\n  .p-sm-4 {\n    padding: 1rem !important;\n  }\n\n  .p-sm-5 {\n    padding: 1.25rem !important;\n  }\n\n  .p-sm-6 {\n    padding: 1.5rem !important;\n  }\n\n  .p-sm-7 {\n    padding: 1.75rem !important;\n  }\n\n  .p-sm-8 {\n    padding: 2rem !important;\n  }\n\n  .p-sm-9 {\n    padding: 2.25rem !important;\n  }\n\n  .p-sm-10 {\n    padding: 2.5rem !important;\n  }\n\n  .p-sm-11 {\n    padding: 2.75rem !important;\n  }\n\n  .p-sm-12 {\n    padding: 3rem !important;\n  }\n\n  .p-sm-13 {\n    padding: 3.25rem !important;\n  }\n\n  .p-sm-14 {\n    padding: 3.5rem !important;\n  }\n\n  .p-sm-15 {\n    padding: 3.75rem !important;\n  }\n\n  .p-sm-16 {\n    padding: 4rem !important;\n  }\n\n  .p-sm-17 {\n    padding: 4.25rem !important;\n  }\n\n  .p-sm-18 {\n    padding: 4.5rem !important;\n  }\n\n  .p-sm-19 {\n    padding: 4.75rem !important;\n  }\n\n  .p-sm-20 {\n    padding: 5rem !important;\n  }\n\n  .px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .px-sm-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n\n  .px-sm-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n\n  .px-sm-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n\n  .px-sm-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .px-sm-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n\n  .px-sm-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n\n  .px-sm-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n\n  .px-sm-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n\n  .px-sm-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n\n  .px-sm-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n\n  .px-sm-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n\n  .px-sm-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n\n  .px-sm-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n\n  .px-sm-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n\n  .px-sm-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n\n  .px-sm-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n\n  .px-sm-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n\n  .px-sm-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n\n  .py-sm-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-sm-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n\n  .py-sm-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-sm-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n\n  .py-sm-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-sm-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n\n  .py-sm-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n\n  .py-sm-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n\n  .py-sm-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n\n  .py-sm-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n\n  .py-sm-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .py-sm-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n\n  .py-sm-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-sm-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n\n  .py-sm-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-sm-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n\n  .py-sm-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-sm-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n\n  .py-sm-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .pt-sm-0 {\n    padding-top: 0 !important;\n  }\n\n  .pt-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-sm-3 {\n    padding-top: 0.75rem !important;\n  }\n\n  .pt-sm-4 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-sm-5 {\n    padding-top: 1.25rem !important;\n  }\n\n  .pt-sm-6 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-sm-7 {\n    padding-top: 1.75rem !important;\n  }\n\n  .pt-sm-8 {\n    padding-top: 2rem !important;\n  }\n\n  .pt-sm-9 {\n    padding-top: 2.25rem !important;\n  }\n\n  .pt-sm-10 {\n    padding-top: 2.5rem !important;\n  }\n\n  .pt-sm-11 {\n    padding-top: 2.75rem !important;\n  }\n\n  .pt-sm-12 {\n    padding-top: 3rem !important;\n  }\n\n  .pt-sm-13 {\n    padding-top: 3.25rem !important;\n  }\n\n  .pt-sm-14 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-sm-15 {\n    padding-top: 3.75rem !important;\n  }\n\n  .pt-sm-16 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-sm-17 {\n    padding-top: 4.25rem !important;\n  }\n\n  .pt-sm-18 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-sm-19 {\n    padding-top: 4.75rem !important;\n  }\n\n  .pt-sm-20 {\n    padding-top: 5rem !important;\n  }\n\n  .pe-sm-0 {\n    padding-right: 0 !important;\n  }\n\n  .pe-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-sm-3 {\n    padding-right: 0.75rem !important;\n  }\n\n  .pe-sm-4 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-sm-5 {\n    padding-right: 1.25rem !important;\n  }\n\n  .pe-sm-6 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-sm-7 {\n    padding-right: 1.75rem !important;\n  }\n\n  .pe-sm-8 {\n    padding-right: 2rem !important;\n  }\n\n  .pe-sm-9 {\n    padding-right: 2.25rem !important;\n  }\n\n  .pe-sm-10 {\n    padding-right: 2.5rem !important;\n  }\n\n  .pe-sm-11 {\n    padding-right: 2.75rem !important;\n  }\n\n  .pe-sm-12 {\n    padding-right: 3rem !important;\n  }\n\n  .pe-sm-13 {\n    padding-right: 3.25rem !important;\n  }\n\n  .pe-sm-14 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-sm-15 {\n    padding-right: 3.75rem !important;\n  }\n\n  .pe-sm-16 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-sm-17 {\n    padding-right: 4.25rem !important;\n  }\n\n  .pe-sm-18 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-sm-19 {\n    padding-right: 4.75rem !important;\n  }\n\n  .pe-sm-20 {\n    padding-right: 5rem !important;\n  }\n\n  .pb-sm-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pb-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-sm-3 {\n    padding-bottom: 0.75rem !important;\n  }\n\n  .pb-sm-4 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-sm-5 {\n    padding-bottom: 1.25rem !important;\n  }\n\n  .pb-sm-6 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-sm-7 {\n    padding-bottom: 1.75rem !important;\n  }\n\n  .pb-sm-8 {\n    padding-bottom: 2rem !important;\n  }\n\n  .pb-sm-9 {\n    padding-bottom: 2.25rem !important;\n  }\n\n  .pb-sm-10 {\n    padding-bottom: 2.5rem !important;\n  }\n\n  .pb-sm-11 {\n    padding-bottom: 2.75rem !important;\n  }\n\n  .pb-sm-12 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pb-sm-13 {\n    padding-bottom: 3.25rem !important;\n  }\n\n  .pb-sm-14 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-sm-15 {\n    padding-bottom: 3.75rem !important;\n  }\n\n  .pb-sm-16 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-sm-17 {\n    padding-bottom: 4.25rem !important;\n  }\n\n  .pb-sm-18 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-sm-19 {\n    padding-bottom: 4.75rem !important;\n  }\n\n  .pb-sm-20 {\n    padding-bottom: 5rem !important;\n  }\n\n  .ps-sm-0 {\n    padding-left: 0 !important;\n  }\n\n  .ps-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-sm-3 {\n    padding-left: 0.75rem !important;\n  }\n\n  .ps-sm-4 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-sm-5 {\n    padding-left: 1.25rem !important;\n  }\n\n  .ps-sm-6 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-sm-7 {\n    padding-left: 1.75rem !important;\n  }\n\n  .ps-sm-8 {\n    padding-left: 2rem !important;\n  }\n\n  .ps-sm-9 {\n    padding-left: 2.25rem !important;\n  }\n\n  .ps-sm-10 {\n    padding-left: 2.5rem !important;\n  }\n\n  .ps-sm-11 {\n    padding-left: 2.75rem !important;\n  }\n\n  .ps-sm-12 {\n    padding-left: 3rem !important;\n  }\n\n  .ps-sm-13 {\n    padding-left: 3.25rem !important;\n  }\n\n  .ps-sm-14 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-sm-15 {\n    padding-left: 3.75rem !important;\n  }\n\n  .ps-sm-16 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-sm-17 {\n    padding-left: 4.25rem !important;\n  }\n\n  .ps-sm-18 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-sm-19 {\n    padding-left: 4.75rem !important;\n  }\n\n  .ps-sm-20 {\n    padding-left: 5rem !important;\n  }\n\n  .gap-sm-0 {\n    gap: 0 !important;\n  }\n\n  .gap-sm-1 {\n    gap: 0.25rem !important;\n  }\n\n  .gap-sm-2 {\n    gap: 0.5rem !important;\n  }\n\n  .gap-sm-3 {\n    gap: 0.75rem !important;\n  }\n\n  .gap-sm-4 {\n    gap: 1rem !important;\n  }\n\n  .gap-sm-5 {\n    gap: 1.25rem !important;\n  }\n\n  .gap-sm-6 {\n    gap: 1.5rem !important;\n  }\n\n  .gap-sm-7 {\n    gap: 1.75rem !important;\n  }\n\n  .gap-sm-8 {\n    gap: 2rem !important;\n  }\n\n  .gap-sm-9 {\n    gap: 2.25rem !important;\n  }\n\n  .gap-sm-10 {\n    gap: 2.5rem !important;\n  }\n\n  .gap-sm-11 {\n    gap: 2.75rem !important;\n  }\n\n  .gap-sm-12 {\n    gap: 3rem !important;\n  }\n\n  .gap-sm-13 {\n    gap: 3.25rem !important;\n  }\n\n  .gap-sm-14 {\n    gap: 3.5rem !important;\n  }\n\n  .gap-sm-15 {\n    gap: 3.75rem !important;\n  }\n\n  .gap-sm-16 {\n    gap: 4rem !important;\n  }\n\n  .gap-sm-17 {\n    gap: 4.25rem !important;\n  }\n\n  .gap-sm-18 {\n    gap: 4.5rem !important;\n  }\n\n  .gap-sm-19 {\n    gap: 4.75rem !important;\n  }\n\n  .gap-sm-20 {\n    gap: 5rem !important;\n  }\n\n  .row-gap-sm-0 {\n    row-gap: 0 !important;\n  }\n\n  .row-gap-sm-1 {\n    row-gap: 0.25rem !important;\n  }\n\n  .row-gap-sm-2 {\n    row-gap: 0.5rem !important;\n  }\n\n  .row-gap-sm-3 {\n    row-gap: 0.75rem !important;\n  }\n\n  .row-gap-sm-4 {\n    row-gap: 1rem !important;\n  }\n\n  .row-gap-sm-5 {\n    row-gap: 1.25rem !important;\n  }\n\n  .row-gap-sm-6 {\n    row-gap: 1.5rem !important;\n  }\n\n  .row-gap-sm-7 {\n    row-gap: 1.75rem !important;\n  }\n\n  .row-gap-sm-8 {\n    row-gap: 2rem !important;\n  }\n\n  .row-gap-sm-9 {\n    row-gap: 2.25rem !important;\n  }\n\n  .row-gap-sm-10 {\n    row-gap: 2.5rem !important;\n  }\n\n  .row-gap-sm-11 {\n    row-gap: 2.75rem !important;\n  }\n\n  .row-gap-sm-12 {\n    row-gap: 3rem !important;\n  }\n\n  .row-gap-sm-13 {\n    row-gap: 3.25rem !important;\n  }\n\n  .row-gap-sm-14 {\n    row-gap: 3.5rem !important;\n  }\n\n  .row-gap-sm-15 {\n    row-gap: 3.75rem !important;\n  }\n\n  .row-gap-sm-16 {\n    row-gap: 4rem !important;\n  }\n\n  .row-gap-sm-17 {\n    row-gap: 4.25rem !important;\n  }\n\n  .row-gap-sm-18 {\n    row-gap: 4.5rem !important;\n  }\n\n  .row-gap-sm-19 {\n    row-gap: 4.75rem !important;\n  }\n\n  .row-gap-sm-20 {\n    row-gap: 5rem !important;\n  }\n\n  .column-gap-sm-0 {\n    column-gap: 0 !important;\n  }\n\n  .column-gap-sm-1 {\n    column-gap: 0.25rem !important;\n  }\n\n  .column-gap-sm-2 {\n    column-gap: 0.5rem !important;\n  }\n\n  .column-gap-sm-3 {\n    column-gap: 0.75rem !important;\n  }\n\n  .column-gap-sm-4 {\n    column-gap: 1rem !important;\n  }\n\n  .column-gap-sm-5 {\n    column-gap: 1.25rem !important;\n  }\n\n  .column-gap-sm-6 {\n    column-gap: 1.5rem !important;\n  }\n\n  .column-gap-sm-7 {\n    column-gap: 1.75rem !important;\n  }\n\n  .column-gap-sm-8 {\n    column-gap: 2rem !important;\n  }\n\n  .column-gap-sm-9 {\n    column-gap: 2.25rem !important;\n  }\n\n  .column-gap-sm-10 {\n    column-gap: 2.5rem !important;\n  }\n\n  .column-gap-sm-11 {\n    column-gap: 2.75rem !important;\n  }\n\n  .column-gap-sm-12 {\n    column-gap: 3rem !important;\n  }\n\n  .column-gap-sm-13 {\n    column-gap: 3.25rem !important;\n  }\n\n  .column-gap-sm-14 {\n    column-gap: 3.5rem !important;\n  }\n\n  .column-gap-sm-15 {\n    column-gap: 3.75rem !important;\n  }\n\n  .column-gap-sm-16 {\n    column-gap: 4rem !important;\n  }\n\n  .column-gap-sm-17 {\n    column-gap: 4.25rem !important;\n  }\n\n  .column-gap-sm-18 {\n    column-gap: 4.5rem !important;\n  }\n\n  .column-gap-sm-19 {\n    column-gap: 4.75rem !important;\n  }\n\n  .column-gap-sm-20 {\n    column-gap: 5rem !important;\n  }\n\n  .text-sm-start {\n    text-align: left !important;\n  }\n\n  .text-sm-end {\n    text-align: right !important;\n  }\n\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-start {\n    float: left !important;\n  }\n\n  .float-md-end {\n    float: right !important;\n  }\n\n  .float-md-none {\n    float: none !important;\n  }\n\n  .object-fit-md-contain {\n    object-fit: contain !important;\n  }\n\n  .object-fit-md-cover {\n    object-fit: cover !important;\n  }\n\n  .object-fit-md-fill {\n    object-fit: fill !important;\n  }\n\n  .object-fit-md-scale {\n    object-fit: scale-down !important;\n  }\n\n  .object-fit-md-none {\n    object-fit: none !important;\n  }\n\n  .d-md-inline {\n    display: inline !important;\n  }\n\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-md-block {\n    display: block !important;\n  }\n\n  .d-md-grid {\n    display: grid !important;\n  }\n\n  .d-md-inline-grid {\n    display: inline-grid !important;\n  }\n\n  .d-md-table {\n    display: table !important;\n  }\n\n  .d-md-table-row {\n    display: table-row !important;\n  }\n\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-md-flex {\n    display: flex !important;\n  }\n\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-md-none {\n    display: none !important;\n  }\n\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n\n  .justify-content-md-evenly {\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-md-center {\n    align-items: center !important;\n  }\n\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-md-center {\n    align-content: center !important;\n  }\n\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-md-center {\n    align-self: center !important;\n  }\n\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n\n  .order-md-first {\n    order: -1 !important;\n  }\n\n  .order-md-0 {\n    order: 0 !important;\n  }\n\n  .order-md-1 {\n    order: 1 !important;\n  }\n\n  .order-md-2 {\n    order: 2 !important;\n  }\n\n  .order-md-3 {\n    order: 3 !important;\n  }\n\n  .order-md-4 {\n    order: 4 !important;\n  }\n\n  .order-md-5 {\n    order: 5 !important;\n  }\n\n  .order-md-last {\n    order: 6 !important;\n  }\n\n  .m-md-0 {\n    margin: 0 !important;\n  }\n\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-md-3 {\n    margin: 0.75rem !important;\n  }\n\n  .m-md-4 {\n    margin: 1rem !important;\n  }\n\n  .m-md-5 {\n    margin: 1.25rem !important;\n  }\n\n  .m-md-6 {\n    margin: 1.5rem !important;\n  }\n\n  .m-md-7 {\n    margin: 1.75rem !important;\n  }\n\n  .m-md-8 {\n    margin: 2rem !important;\n  }\n\n  .m-md-9 {\n    margin: 2.25rem !important;\n  }\n\n  .m-md-10 {\n    margin: 2.5rem !important;\n  }\n\n  .m-md-11 {\n    margin: 2.75rem !important;\n  }\n\n  .m-md-12 {\n    margin: 3rem !important;\n  }\n\n  .m-md-13 {\n    margin: 3.25rem !important;\n  }\n\n  .m-md-14 {\n    margin: 3.5rem !important;\n  }\n\n  .m-md-15 {\n    margin: 3.75rem !important;\n  }\n\n  .m-md-16 {\n    margin: 4rem !important;\n  }\n\n  .m-md-17 {\n    margin: 4.25rem !important;\n  }\n\n  .m-md-18 {\n    margin: 4.5rem !important;\n  }\n\n  .m-md-19 {\n    margin: 4.75rem !important;\n  }\n\n  .m-md-20 {\n    margin: 5rem !important;\n  }\n\n  .m-md-auto {\n    margin: auto !important;\n  }\n\n  .mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .mx-md-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n\n  .mx-md-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n\n  .mx-md-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n\n  .mx-md-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .mx-md-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n\n  .mx-md-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n\n  .mx-md-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n\n  .mx-md-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n\n  .mx-md-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n\n  .mx-md-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n\n  .mx-md-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n\n  .mx-md-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n\n  .mx-md-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n\n  .mx-md-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n\n  .mx-md-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n\n  .mx-md-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n\n  .mx-md-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n\n  .mx-md-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n\n  .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-md-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-md-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n\n  .my-md-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-md-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n\n  .my-md-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-md-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n\n  .my-md-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n\n  .my-md-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n\n  .my-md-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n\n  .my-md-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n\n  .my-md-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-md-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n\n  .my-md-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-md-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n\n  .my-md-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-md-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n\n  .my-md-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-md-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n\n  .my-md-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-md-0 {\n    margin-top: 0 !important;\n  }\n\n  .mt-md-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-md-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-md-3 {\n    margin-top: 0.75rem !important;\n  }\n\n  .mt-md-4 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-md-5 {\n    margin-top: 1.25rem !important;\n  }\n\n  .mt-md-6 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-md-7 {\n    margin-top: 1.75rem !important;\n  }\n\n  .mt-md-8 {\n    margin-top: 2rem !important;\n  }\n\n  .mt-md-9 {\n    margin-top: 2.25rem !important;\n  }\n\n  .mt-md-10 {\n    margin-top: 2.5rem !important;\n  }\n\n  .mt-md-11 {\n    margin-top: 2.75rem !important;\n  }\n\n  .mt-md-12 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-md-13 {\n    margin-top: 3.25rem !important;\n  }\n\n  .mt-md-14 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-md-15 {\n    margin-top: 3.75rem !important;\n  }\n\n  .mt-md-16 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-md-17 {\n    margin-top: 4.25rem !important;\n  }\n\n  .mt-md-18 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-md-19 {\n    margin-top: 4.75rem !important;\n  }\n\n  .mt-md-20 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-md-auto {\n    margin-top: auto !important;\n  }\n\n  .me-md-0 {\n    margin-right: 0 !important;\n  }\n\n  .me-md-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-md-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-md-3 {\n    margin-right: 0.75rem !important;\n  }\n\n  .me-md-4 {\n    margin-right: 1rem !important;\n  }\n\n  .me-md-5 {\n    margin-right: 1.25rem !important;\n  }\n\n  .me-md-6 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-md-7 {\n    margin-right: 1.75rem !important;\n  }\n\n  .me-md-8 {\n    margin-right: 2rem !important;\n  }\n\n  .me-md-9 {\n    margin-right: 2.25rem !important;\n  }\n\n  .me-md-10 {\n    margin-right: 2.5rem !important;\n  }\n\n  .me-md-11 {\n    margin-right: 2.75rem !important;\n  }\n\n  .me-md-12 {\n    margin-right: 3rem !important;\n  }\n\n  .me-md-13 {\n    margin-right: 3.25rem !important;\n  }\n\n  .me-md-14 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-md-15 {\n    margin-right: 3.75rem !important;\n  }\n\n  .me-md-16 {\n    margin-right: 4rem !important;\n  }\n\n  .me-md-17 {\n    margin-right: 4.25rem !important;\n  }\n\n  .me-md-18 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-md-19 {\n    margin-right: 4.75rem !important;\n  }\n\n  .me-md-20 {\n    margin-right: 5rem !important;\n  }\n\n  .me-md-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-md-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .mb-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-md-3 {\n    margin-bottom: 0.75rem !important;\n  }\n\n  .mb-md-4 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-md-5 {\n    margin-bottom: 1.25rem !important;\n  }\n\n  .mb-md-6 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-md-7 {\n    margin-bottom: 1.75rem !important;\n  }\n\n  .mb-md-8 {\n    margin-bottom: 2rem !important;\n  }\n\n  .mb-md-9 {\n    margin-bottom: 2.25rem !important;\n  }\n\n  .mb-md-10 {\n    margin-bottom: 2.5rem !important;\n  }\n\n  .mb-md-11 {\n    margin-bottom: 2.75rem !important;\n  }\n\n  .mb-md-12 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-md-13 {\n    margin-bottom: 3.25rem !important;\n  }\n\n  .mb-md-14 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-md-15 {\n    margin-bottom: 3.75rem !important;\n  }\n\n  .mb-md-16 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-md-17 {\n    margin-bottom: 4.25rem !important;\n  }\n\n  .mb-md-18 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-md-19 {\n    margin-bottom: 4.75rem !important;\n  }\n\n  .mb-md-20 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-md-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-md-0 {\n    margin-left: 0 !important;\n  }\n\n  .ms-md-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-md-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-md-3 {\n    margin-left: 0.75rem !important;\n  }\n\n  .ms-md-4 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-md-5 {\n    margin-left: 1.25rem !important;\n  }\n\n  .ms-md-6 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-md-7 {\n    margin-left: 1.75rem !important;\n  }\n\n  .ms-md-8 {\n    margin-left: 2rem !important;\n  }\n\n  .ms-md-9 {\n    margin-left: 2.25rem !important;\n  }\n\n  .ms-md-10 {\n    margin-left: 2.5rem !important;\n  }\n\n  .ms-md-11 {\n    margin-left: 2.75rem !important;\n  }\n\n  .ms-md-12 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-md-13 {\n    margin-left: 3.25rem !important;\n  }\n\n  .ms-md-14 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-md-15 {\n    margin-left: 3.75rem !important;\n  }\n\n  .ms-md-16 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-md-17 {\n    margin-left: 4.25rem !important;\n  }\n\n  .ms-md-18 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-md-19 {\n    margin-left: 4.75rem !important;\n  }\n\n  .ms-md-20 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-md-auto {\n    margin-left: auto !important;\n  }\n\n  .m-md-n1 {\n    margin: -0.25rem !important;\n  }\n\n  .m-md-n2 {\n    margin: -0.5rem !important;\n  }\n\n  .m-md-n3 {\n    margin: -0.75rem !important;\n  }\n\n  .m-md-n4 {\n    margin: -1rem !important;\n  }\n\n  .m-md-n5 {\n    margin: -1.25rem !important;\n  }\n\n  .m-md-n6 {\n    margin: -1.5rem !important;\n  }\n\n  .m-md-n7 {\n    margin: -1.75rem !important;\n  }\n\n  .m-md-n8 {\n    margin: -2rem !important;\n  }\n\n  .m-md-n9 {\n    margin: -2.25rem !important;\n  }\n\n  .m-md-n10 {\n    margin: -2.5rem !important;\n  }\n\n  .m-md-n11 {\n    margin: -2.75rem !important;\n  }\n\n  .m-md-n12 {\n    margin: -3rem !important;\n  }\n\n  .m-md-n13 {\n    margin: -3.25rem !important;\n  }\n\n  .m-md-n14 {\n    margin: -3.5rem !important;\n  }\n\n  .m-md-n15 {\n    margin: -3.75rem !important;\n  }\n\n  .m-md-n16 {\n    margin: -4rem !important;\n  }\n\n  .m-md-n17 {\n    margin: -4.25rem !important;\n  }\n\n  .m-md-n18 {\n    margin: -4.5rem !important;\n  }\n\n  .m-md-n19 {\n    margin: -4.75rem !important;\n  }\n\n  .m-md-n20 {\n    margin: -5rem !important;\n  }\n\n  .mx-md-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n\n  .mx-md-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n\n  .mx-md-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n\n  .mx-md-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n\n  .mx-md-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n\n  .mx-md-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n\n  .mx-md-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n\n  .mx-md-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n\n  .mx-md-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n\n  .mx-md-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n\n  .mx-md-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n\n  .mx-md-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n\n  .mx-md-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n\n  .mx-md-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n\n  .mx-md-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n\n  .mx-md-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n\n  .mx-md-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n\n  .mx-md-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n\n  .mx-md-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n\n  .mx-md-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n\n  .my-md-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n\n  .my-md-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n\n  .my-md-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n\n  .my-md-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n\n  .my-md-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n\n  .my-md-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n\n  .my-md-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n\n  .my-md-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n\n  .my-md-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n\n  .my-md-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n\n  .my-md-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n\n  .my-md-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n\n  .my-md-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n\n  .my-md-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n\n  .my-md-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n\n  .my-md-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n\n  .my-md-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n\n  .my-md-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n\n  .my-md-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n\n  .my-md-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n\n  .mt-md-n1 {\n    margin-top: -0.25rem !important;\n  }\n\n  .mt-md-n2 {\n    margin-top: -0.5rem !important;\n  }\n\n  .mt-md-n3 {\n    margin-top: -0.75rem !important;\n  }\n\n  .mt-md-n4 {\n    margin-top: -1rem !important;\n  }\n\n  .mt-md-n5 {\n    margin-top: -1.25rem !important;\n  }\n\n  .mt-md-n6 {\n    margin-top: -1.5rem !important;\n  }\n\n  .mt-md-n7 {\n    margin-top: -1.75rem !important;\n  }\n\n  .mt-md-n8 {\n    margin-top: -2rem !important;\n  }\n\n  .mt-md-n9 {\n    margin-top: -2.25rem !important;\n  }\n\n  .mt-md-n10 {\n    margin-top: -2.5rem !important;\n  }\n\n  .mt-md-n11 {\n    margin-top: -2.75rem !important;\n  }\n\n  .mt-md-n12 {\n    margin-top: -3rem !important;\n  }\n\n  .mt-md-n13 {\n    margin-top: -3.25rem !important;\n  }\n\n  .mt-md-n14 {\n    margin-top: -3.5rem !important;\n  }\n\n  .mt-md-n15 {\n    margin-top: -3.75rem !important;\n  }\n\n  .mt-md-n16 {\n    margin-top: -4rem !important;\n  }\n\n  .mt-md-n17 {\n    margin-top: -4.25rem !important;\n  }\n\n  .mt-md-n18 {\n    margin-top: -4.5rem !important;\n  }\n\n  .mt-md-n19 {\n    margin-top: -4.75rem !important;\n  }\n\n  .mt-md-n20 {\n    margin-top: -5rem !important;\n  }\n\n  .me-md-n1 {\n    margin-right: -0.25rem !important;\n  }\n\n  .me-md-n2 {\n    margin-right: -0.5rem !important;\n  }\n\n  .me-md-n3 {\n    margin-right: -0.75rem !important;\n  }\n\n  .me-md-n4 {\n    margin-right: -1rem !important;\n  }\n\n  .me-md-n5 {\n    margin-right: -1.25rem !important;\n  }\n\n  .me-md-n6 {\n    margin-right: -1.5rem !important;\n  }\n\n  .me-md-n7 {\n    margin-right: -1.75rem !important;\n  }\n\n  .me-md-n8 {\n    margin-right: -2rem !important;\n  }\n\n  .me-md-n9 {\n    margin-right: -2.25rem !important;\n  }\n\n  .me-md-n10 {\n    margin-right: -2.5rem !important;\n  }\n\n  .me-md-n11 {\n    margin-right: -2.75rem !important;\n  }\n\n  .me-md-n12 {\n    margin-right: -3rem !important;\n  }\n\n  .me-md-n13 {\n    margin-right: -3.25rem !important;\n  }\n\n  .me-md-n14 {\n    margin-right: -3.5rem !important;\n  }\n\n  .me-md-n15 {\n    margin-right: -3.75rem !important;\n  }\n\n  .me-md-n16 {\n    margin-right: -4rem !important;\n  }\n\n  .me-md-n17 {\n    margin-right: -4.25rem !important;\n  }\n\n  .me-md-n18 {\n    margin-right: -4.5rem !important;\n  }\n\n  .me-md-n19 {\n    margin-right: -4.75rem !important;\n  }\n\n  .me-md-n20 {\n    margin-right: -5rem !important;\n  }\n\n  .mb-md-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n\n  .mb-md-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n\n  .mb-md-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n\n  .mb-md-n4 {\n    margin-bottom: -1rem !important;\n  }\n\n  .mb-md-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n\n  .mb-md-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n\n  .mb-md-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n\n  .mb-md-n8 {\n    margin-bottom: -2rem !important;\n  }\n\n  .mb-md-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n\n  .mb-md-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n\n  .mb-md-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n\n  .mb-md-n12 {\n    margin-bottom: -3rem !important;\n  }\n\n  .mb-md-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n\n  .mb-md-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n\n  .mb-md-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n\n  .mb-md-n16 {\n    margin-bottom: -4rem !important;\n  }\n\n  .mb-md-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n\n  .mb-md-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n\n  .mb-md-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n\n  .mb-md-n20 {\n    margin-bottom: -5rem !important;\n  }\n\n  .ms-md-n1 {\n    margin-left: -0.25rem !important;\n  }\n\n  .ms-md-n2 {\n    margin-left: -0.5rem !important;\n  }\n\n  .ms-md-n3 {\n    margin-left: -0.75rem !important;\n  }\n\n  .ms-md-n4 {\n    margin-left: -1rem !important;\n  }\n\n  .ms-md-n5 {\n    margin-left: -1.25rem !important;\n  }\n\n  .ms-md-n6 {\n    margin-left: -1.5rem !important;\n  }\n\n  .ms-md-n7 {\n    margin-left: -1.75rem !important;\n  }\n\n  .ms-md-n8 {\n    margin-left: -2rem !important;\n  }\n\n  .ms-md-n9 {\n    margin-left: -2.25rem !important;\n  }\n\n  .ms-md-n10 {\n    margin-left: -2.5rem !important;\n  }\n\n  .ms-md-n11 {\n    margin-left: -2.75rem !important;\n  }\n\n  .ms-md-n12 {\n    margin-left: -3rem !important;\n  }\n\n  .ms-md-n13 {\n    margin-left: -3.25rem !important;\n  }\n\n  .ms-md-n14 {\n    margin-left: -3.5rem !important;\n  }\n\n  .ms-md-n15 {\n    margin-left: -3.75rem !important;\n  }\n\n  .ms-md-n16 {\n    margin-left: -4rem !important;\n  }\n\n  .ms-md-n17 {\n    margin-left: -4.25rem !important;\n  }\n\n  .ms-md-n18 {\n    margin-left: -4.5rem !important;\n  }\n\n  .ms-md-n19 {\n    margin-left: -4.75rem !important;\n  }\n\n  .ms-md-n20 {\n    margin-left: -5rem !important;\n  }\n\n  .p-md-0 {\n    padding: 0 !important;\n  }\n\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-md-3 {\n    padding: 0.75rem !important;\n  }\n\n  .p-md-4 {\n    padding: 1rem !important;\n  }\n\n  .p-md-5 {\n    padding: 1.25rem !important;\n  }\n\n  .p-md-6 {\n    padding: 1.5rem !important;\n  }\n\n  .p-md-7 {\n    padding: 1.75rem !important;\n  }\n\n  .p-md-8 {\n    padding: 2rem !important;\n  }\n\n  .p-md-9 {\n    padding: 2.25rem !important;\n  }\n\n  .p-md-10 {\n    padding: 2.5rem !important;\n  }\n\n  .p-md-11 {\n    padding: 2.75rem !important;\n  }\n\n  .p-md-12 {\n    padding: 3rem !important;\n  }\n\n  .p-md-13 {\n    padding: 3.25rem !important;\n  }\n\n  .p-md-14 {\n    padding: 3.5rem !important;\n  }\n\n  .p-md-15 {\n    padding: 3.75rem !important;\n  }\n\n  .p-md-16 {\n    padding: 4rem !important;\n  }\n\n  .p-md-17 {\n    padding: 4.25rem !important;\n  }\n\n  .p-md-18 {\n    padding: 4.5rem !important;\n  }\n\n  .p-md-19 {\n    padding: 4.75rem !important;\n  }\n\n  .p-md-20 {\n    padding: 5rem !important;\n  }\n\n  .px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .px-md-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n\n  .px-md-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n\n  .px-md-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n\n  .px-md-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .px-md-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n\n  .px-md-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n\n  .px-md-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n\n  .px-md-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n\n  .px-md-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n\n  .px-md-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n\n  .px-md-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n\n  .px-md-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n\n  .px-md-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n\n  .px-md-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n\n  .px-md-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n\n  .px-md-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n\n  .px-md-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n\n  .px-md-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n\n  .py-md-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-md-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n\n  .py-md-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-md-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n\n  .py-md-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-md-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n\n  .py-md-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n\n  .py-md-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n\n  .py-md-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n\n  .py-md-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n\n  .py-md-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .py-md-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n\n  .py-md-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-md-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n\n  .py-md-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-md-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n\n  .py-md-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-md-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n\n  .py-md-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .pt-md-0 {\n    padding-top: 0 !important;\n  }\n\n  .pt-md-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-md-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-md-3 {\n    padding-top: 0.75rem !important;\n  }\n\n  .pt-md-4 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-md-5 {\n    padding-top: 1.25rem !important;\n  }\n\n  .pt-md-6 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-md-7 {\n    padding-top: 1.75rem !important;\n  }\n\n  .pt-md-8 {\n    padding-top: 2rem !important;\n  }\n\n  .pt-md-9 {\n    padding-top: 2.25rem !important;\n  }\n\n  .pt-md-10 {\n    padding-top: 2.5rem !important;\n  }\n\n  .pt-md-11 {\n    padding-top: 2.75rem !important;\n  }\n\n  .pt-md-12 {\n    padding-top: 3rem !important;\n  }\n\n  .pt-md-13 {\n    padding-top: 3.25rem !important;\n  }\n\n  .pt-md-14 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-md-15 {\n    padding-top: 3.75rem !important;\n  }\n\n  .pt-md-16 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-md-17 {\n    padding-top: 4.25rem !important;\n  }\n\n  .pt-md-18 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-md-19 {\n    padding-top: 4.75rem !important;\n  }\n\n  .pt-md-20 {\n    padding-top: 5rem !important;\n  }\n\n  .pe-md-0 {\n    padding-right: 0 !important;\n  }\n\n  .pe-md-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-md-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-md-3 {\n    padding-right: 0.75rem !important;\n  }\n\n  .pe-md-4 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-md-5 {\n    padding-right: 1.25rem !important;\n  }\n\n  .pe-md-6 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-md-7 {\n    padding-right: 1.75rem !important;\n  }\n\n  .pe-md-8 {\n    padding-right: 2rem !important;\n  }\n\n  .pe-md-9 {\n    padding-right: 2.25rem !important;\n  }\n\n  .pe-md-10 {\n    padding-right: 2.5rem !important;\n  }\n\n  .pe-md-11 {\n    padding-right: 2.75rem !important;\n  }\n\n  .pe-md-12 {\n    padding-right: 3rem !important;\n  }\n\n  .pe-md-13 {\n    padding-right: 3.25rem !important;\n  }\n\n  .pe-md-14 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-md-15 {\n    padding-right: 3.75rem !important;\n  }\n\n  .pe-md-16 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-md-17 {\n    padding-right: 4.25rem !important;\n  }\n\n  .pe-md-18 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-md-19 {\n    padding-right: 4.75rem !important;\n  }\n\n  .pe-md-20 {\n    padding-right: 5rem !important;\n  }\n\n  .pb-md-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pb-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-md-3 {\n    padding-bottom: 0.75rem !important;\n  }\n\n  .pb-md-4 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-md-5 {\n    padding-bottom: 1.25rem !important;\n  }\n\n  .pb-md-6 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-md-7 {\n    padding-bottom: 1.75rem !important;\n  }\n\n  .pb-md-8 {\n    padding-bottom: 2rem !important;\n  }\n\n  .pb-md-9 {\n    padding-bottom: 2.25rem !important;\n  }\n\n  .pb-md-10 {\n    padding-bottom: 2.5rem !important;\n  }\n\n  .pb-md-11 {\n    padding-bottom: 2.75rem !important;\n  }\n\n  .pb-md-12 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pb-md-13 {\n    padding-bottom: 3.25rem !important;\n  }\n\n  .pb-md-14 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-md-15 {\n    padding-bottom: 3.75rem !important;\n  }\n\n  .pb-md-16 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-md-17 {\n    padding-bottom: 4.25rem !important;\n  }\n\n  .pb-md-18 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-md-19 {\n    padding-bottom: 4.75rem !important;\n  }\n\n  .pb-md-20 {\n    padding-bottom: 5rem !important;\n  }\n\n  .ps-md-0 {\n    padding-left: 0 !important;\n  }\n\n  .ps-md-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-md-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-md-3 {\n    padding-left: 0.75rem !important;\n  }\n\n  .ps-md-4 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-md-5 {\n    padding-left: 1.25rem !important;\n  }\n\n  .ps-md-6 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-md-7 {\n    padding-left: 1.75rem !important;\n  }\n\n  .ps-md-8 {\n    padding-left: 2rem !important;\n  }\n\n  .ps-md-9 {\n    padding-left: 2.25rem !important;\n  }\n\n  .ps-md-10 {\n    padding-left: 2.5rem !important;\n  }\n\n  .ps-md-11 {\n    padding-left: 2.75rem !important;\n  }\n\n  .ps-md-12 {\n    padding-left: 3rem !important;\n  }\n\n  .ps-md-13 {\n    padding-left: 3.25rem !important;\n  }\n\n  .ps-md-14 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-md-15 {\n    padding-left: 3.75rem !important;\n  }\n\n  .ps-md-16 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-md-17 {\n    padding-left: 4.25rem !important;\n  }\n\n  .ps-md-18 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-md-19 {\n    padding-left: 4.75rem !important;\n  }\n\n  .ps-md-20 {\n    padding-left: 5rem !important;\n  }\n\n  .gap-md-0 {\n    gap: 0 !important;\n  }\n\n  .gap-md-1 {\n    gap: 0.25rem !important;\n  }\n\n  .gap-md-2 {\n    gap: 0.5rem !important;\n  }\n\n  .gap-md-3 {\n    gap: 0.75rem !important;\n  }\n\n  .gap-md-4 {\n    gap: 1rem !important;\n  }\n\n  .gap-md-5 {\n    gap: 1.25rem !important;\n  }\n\n  .gap-md-6 {\n    gap: 1.5rem !important;\n  }\n\n  .gap-md-7 {\n    gap: 1.75rem !important;\n  }\n\n  .gap-md-8 {\n    gap: 2rem !important;\n  }\n\n  .gap-md-9 {\n    gap: 2.25rem !important;\n  }\n\n  .gap-md-10 {\n    gap: 2.5rem !important;\n  }\n\n  .gap-md-11 {\n    gap: 2.75rem !important;\n  }\n\n  .gap-md-12 {\n    gap: 3rem !important;\n  }\n\n  .gap-md-13 {\n    gap: 3.25rem !important;\n  }\n\n  .gap-md-14 {\n    gap: 3.5rem !important;\n  }\n\n  .gap-md-15 {\n    gap: 3.75rem !important;\n  }\n\n  .gap-md-16 {\n    gap: 4rem !important;\n  }\n\n  .gap-md-17 {\n    gap: 4.25rem !important;\n  }\n\n  .gap-md-18 {\n    gap: 4.5rem !important;\n  }\n\n  .gap-md-19 {\n    gap: 4.75rem !important;\n  }\n\n  .gap-md-20 {\n    gap: 5rem !important;\n  }\n\n  .row-gap-md-0 {\n    row-gap: 0 !important;\n  }\n\n  .row-gap-md-1 {\n    row-gap: 0.25rem !important;\n  }\n\n  .row-gap-md-2 {\n    row-gap: 0.5rem !important;\n  }\n\n  .row-gap-md-3 {\n    row-gap: 0.75rem !important;\n  }\n\n  .row-gap-md-4 {\n    row-gap: 1rem !important;\n  }\n\n  .row-gap-md-5 {\n    row-gap: 1.25rem !important;\n  }\n\n  .row-gap-md-6 {\n    row-gap: 1.5rem !important;\n  }\n\n  .row-gap-md-7 {\n    row-gap: 1.75rem !important;\n  }\n\n  .row-gap-md-8 {\n    row-gap: 2rem !important;\n  }\n\n  .row-gap-md-9 {\n    row-gap: 2.25rem !important;\n  }\n\n  .row-gap-md-10 {\n    row-gap: 2.5rem !important;\n  }\n\n  .row-gap-md-11 {\n    row-gap: 2.75rem !important;\n  }\n\n  .row-gap-md-12 {\n    row-gap: 3rem !important;\n  }\n\n  .row-gap-md-13 {\n    row-gap: 3.25rem !important;\n  }\n\n  .row-gap-md-14 {\n    row-gap: 3.5rem !important;\n  }\n\n  .row-gap-md-15 {\n    row-gap: 3.75rem !important;\n  }\n\n  .row-gap-md-16 {\n    row-gap: 4rem !important;\n  }\n\n  .row-gap-md-17 {\n    row-gap: 4.25rem !important;\n  }\n\n  .row-gap-md-18 {\n    row-gap: 4.5rem !important;\n  }\n\n  .row-gap-md-19 {\n    row-gap: 4.75rem !important;\n  }\n\n  .row-gap-md-20 {\n    row-gap: 5rem !important;\n  }\n\n  .column-gap-md-0 {\n    column-gap: 0 !important;\n  }\n\n  .column-gap-md-1 {\n    column-gap: 0.25rem !important;\n  }\n\n  .column-gap-md-2 {\n    column-gap: 0.5rem !important;\n  }\n\n  .column-gap-md-3 {\n    column-gap: 0.75rem !important;\n  }\n\n  .column-gap-md-4 {\n    column-gap: 1rem !important;\n  }\n\n  .column-gap-md-5 {\n    column-gap: 1.25rem !important;\n  }\n\n  .column-gap-md-6 {\n    column-gap: 1.5rem !important;\n  }\n\n  .column-gap-md-7 {\n    column-gap: 1.75rem !important;\n  }\n\n  .column-gap-md-8 {\n    column-gap: 2rem !important;\n  }\n\n  .column-gap-md-9 {\n    column-gap: 2.25rem !important;\n  }\n\n  .column-gap-md-10 {\n    column-gap: 2.5rem !important;\n  }\n\n  .column-gap-md-11 {\n    column-gap: 2.75rem !important;\n  }\n\n  .column-gap-md-12 {\n    column-gap: 3rem !important;\n  }\n\n  .column-gap-md-13 {\n    column-gap: 3.25rem !important;\n  }\n\n  .column-gap-md-14 {\n    column-gap: 3.5rem !important;\n  }\n\n  .column-gap-md-15 {\n    column-gap: 3.75rem !important;\n  }\n\n  .column-gap-md-16 {\n    column-gap: 4rem !important;\n  }\n\n  .column-gap-md-17 {\n    column-gap: 4.25rem !important;\n  }\n\n  .column-gap-md-18 {\n    column-gap: 4.5rem !important;\n  }\n\n  .column-gap-md-19 {\n    column-gap: 4.75rem !important;\n  }\n\n  .column-gap-md-20 {\n    column-gap: 5rem !important;\n  }\n\n  .text-md-start {\n    text-align: left !important;\n  }\n\n  .text-md-end {\n    text-align: right !important;\n  }\n\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-start {\n    float: left !important;\n  }\n\n  .float-lg-end {\n    float: right !important;\n  }\n\n  .float-lg-none {\n    float: none !important;\n  }\n\n  .object-fit-lg-contain {\n    object-fit: contain !important;\n  }\n\n  .object-fit-lg-cover {\n    object-fit: cover !important;\n  }\n\n  .object-fit-lg-fill {\n    object-fit: fill !important;\n  }\n\n  .object-fit-lg-scale {\n    object-fit: scale-down !important;\n  }\n\n  .object-fit-lg-none {\n    object-fit: none !important;\n  }\n\n  .d-lg-inline {\n    display: inline !important;\n  }\n\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-lg-block {\n    display: block !important;\n  }\n\n  .d-lg-grid {\n    display: grid !important;\n  }\n\n  .d-lg-inline-grid {\n    display: inline-grid !important;\n  }\n\n  .d-lg-table {\n    display: table !important;\n  }\n\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-lg-flex {\n    display: flex !important;\n  }\n\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-lg-none {\n    display: none !important;\n  }\n\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n\n  .justify-content-lg-evenly {\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n\n  .order-lg-first {\n    order: -1 !important;\n  }\n\n  .order-lg-0 {\n    order: 0 !important;\n  }\n\n  .order-lg-1 {\n    order: 1 !important;\n  }\n\n  .order-lg-2 {\n    order: 2 !important;\n  }\n\n  .order-lg-3 {\n    order: 3 !important;\n  }\n\n  .order-lg-4 {\n    order: 4 !important;\n  }\n\n  .order-lg-5 {\n    order: 5 !important;\n  }\n\n  .order-lg-last {\n    order: 6 !important;\n  }\n\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-lg-3 {\n    margin: 0.75rem !important;\n  }\n\n  .m-lg-4 {\n    margin: 1rem !important;\n  }\n\n  .m-lg-5 {\n    margin: 1.25rem !important;\n  }\n\n  .m-lg-6 {\n    margin: 1.5rem !important;\n  }\n\n  .m-lg-7 {\n    margin: 1.75rem !important;\n  }\n\n  .m-lg-8 {\n    margin: 2rem !important;\n  }\n\n  .m-lg-9 {\n    margin: 2.25rem !important;\n  }\n\n  .m-lg-10 {\n    margin: 2.5rem !important;\n  }\n\n  .m-lg-11 {\n    margin: 2.75rem !important;\n  }\n\n  .m-lg-12 {\n    margin: 3rem !important;\n  }\n\n  .m-lg-13 {\n    margin: 3.25rem !important;\n  }\n\n  .m-lg-14 {\n    margin: 3.5rem !important;\n  }\n\n  .m-lg-15 {\n    margin: 3.75rem !important;\n  }\n\n  .m-lg-16 {\n    margin: 4rem !important;\n  }\n\n  .m-lg-17 {\n    margin: 4.25rem !important;\n  }\n\n  .m-lg-18 {\n    margin: 4.5rem !important;\n  }\n\n  .m-lg-19 {\n    margin: 4.75rem !important;\n  }\n\n  .m-lg-20 {\n    margin: 5rem !important;\n  }\n\n  .m-lg-auto {\n    margin: auto !important;\n  }\n\n  .mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .mx-lg-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n\n  .mx-lg-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n\n  .mx-lg-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n\n  .mx-lg-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .mx-lg-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n\n  .mx-lg-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n\n  .mx-lg-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n\n  .mx-lg-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n\n  .mx-lg-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n\n  .mx-lg-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n\n  .mx-lg-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n\n  .mx-lg-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n\n  .mx-lg-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n\n  .mx-lg-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n\n  .mx-lg-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n\n  .mx-lg-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n\n  .mx-lg-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n\n  .mx-lg-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n\n  .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-lg-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-lg-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n\n  .my-lg-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-lg-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n\n  .my-lg-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-lg-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n\n  .my-lg-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n\n  .my-lg-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n\n  .my-lg-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n\n  .my-lg-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n\n  .my-lg-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-lg-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n\n  .my-lg-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-lg-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n\n  .my-lg-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-lg-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n\n  .my-lg-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-lg-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n\n  .my-lg-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-lg-0 {\n    margin-top: 0 !important;\n  }\n\n  .mt-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-lg-3 {\n    margin-top: 0.75rem !important;\n  }\n\n  .mt-lg-4 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-lg-5 {\n    margin-top: 1.25rem !important;\n  }\n\n  .mt-lg-6 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-lg-7 {\n    margin-top: 1.75rem !important;\n  }\n\n  .mt-lg-8 {\n    margin-top: 2rem !important;\n  }\n\n  .mt-lg-9 {\n    margin-top: 2.25rem !important;\n  }\n\n  .mt-lg-10 {\n    margin-top: 2.5rem !important;\n  }\n\n  .mt-lg-11 {\n    margin-top: 2.75rem !important;\n  }\n\n  .mt-lg-12 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-lg-13 {\n    margin-top: 3.25rem !important;\n  }\n\n  .mt-lg-14 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-lg-15 {\n    margin-top: 3.75rem !important;\n  }\n\n  .mt-lg-16 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-lg-17 {\n    margin-top: 4.25rem !important;\n  }\n\n  .mt-lg-18 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-lg-19 {\n    margin-top: 4.75rem !important;\n  }\n\n  .mt-lg-20 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-lg-auto {\n    margin-top: auto !important;\n  }\n\n  .me-lg-0 {\n    margin-right: 0 !important;\n  }\n\n  .me-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-lg-3 {\n    margin-right: 0.75rem !important;\n  }\n\n  .me-lg-4 {\n    margin-right: 1rem !important;\n  }\n\n  .me-lg-5 {\n    margin-right: 1.25rem !important;\n  }\n\n  .me-lg-6 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-lg-7 {\n    margin-right: 1.75rem !important;\n  }\n\n  .me-lg-8 {\n    margin-right: 2rem !important;\n  }\n\n  .me-lg-9 {\n    margin-right: 2.25rem !important;\n  }\n\n  .me-lg-10 {\n    margin-right: 2.5rem !important;\n  }\n\n  .me-lg-11 {\n    margin-right: 2.75rem !important;\n  }\n\n  .me-lg-12 {\n    margin-right: 3rem !important;\n  }\n\n  .me-lg-13 {\n    margin-right: 3.25rem !important;\n  }\n\n  .me-lg-14 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-lg-15 {\n    margin-right: 3.75rem !important;\n  }\n\n  .me-lg-16 {\n    margin-right: 4rem !important;\n  }\n\n  .me-lg-17 {\n    margin-right: 4.25rem !important;\n  }\n\n  .me-lg-18 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-lg-19 {\n    margin-right: 4.75rem !important;\n  }\n\n  .me-lg-20 {\n    margin-right: 5rem !important;\n  }\n\n  .me-lg-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-lg-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .mb-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-lg-3 {\n    margin-bottom: 0.75rem !important;\n  }\n\n  .mb-lg-4 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-lg-5 {\n    margin-bottom: 1.25rem !important;\n  }\n\n  .mb-lg-6 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-lg-7 {\n    margin-bottom: 1.75rem !important;\n  }\n\n  .mb-lg-8 {\n    margin-bottom: 2rem !important;\n  }\n\n  .mb-lg-9 {\n    margin-bottom: 2.25rem !important;\n  }\n\n  .mb-lg-10 {\n    margin-bottom: 2.5rem !important;\n  }\n\n  .mb-lg-11 {\n    margin-bottom: 2.75rem !important;\n  }\n\n  .mb-lg-12 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-lg-13 {\n    margin-bottom: 3.25rem !important;\n  }\n\n  .mb-lg-14 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-lg-15 {\n    margin-bottom: 3.75rem !important;\n  }\n\n  .mb-lg-16 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-lg-17 {\n    margin-bottom: 4.25rem !important;\n  }\n\n  .mb-lg-18 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-lg-19 {\n    margin-bottom: 4.75rem !important;\n  }\n\n  .mb-lg-20 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-lg-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-lg-0 {\n    margin-left: 0 !important;\n  }\n\n  .ms-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-lg-3 {\n    margin-left: 0.75rem !important;\n  }\n\n  .ms-lg-4 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-lg-5 {\n    margin-left: 1.25rem !important;\n  }\n\n  .ms-lg-6 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-lg-7 {\n    margin-left: 1.75rem !important;\n  }\n\n  .ms-lg-8 {\n    margin-left: 2rem !important;\n  }\n\n  .ms-lg-9 {\n    margin-left: 2.25rem !important;\n  }\n\n  .ms-lg-10 {\n    margin-left: 2.5rem !important;\n  }\n\n  .ms-lg-11 {\n    margin-left: 2.75rem !important;\n  }\n\n  .ms-lg-12 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-lg-13 {\n    margin-left: 3.25rem !important;\n  }\n\n  .ms-lg-14 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-lg-15 {\n    margin-left: 3.75rem !important;\n  }\n\n  .ms-lg-16 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-lg-17 {\n    margin-left: 4.25rem !important;\n  }\n\n  .ms-lg-18 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-lg-19 {\n    margin-left: 4.75rem !important;\n  }\n\n  .ms-lg-20 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-lg-auto {\n    margin-left: auto !important;\n  }\n\n  .m-lg-n1 {\n    margin: -0.25rem !important;\n  }\n\n  .m-lg-n2 {\n    margin: -0.5rem !important;\n  }\n\n  .m-lg-n3 {\n    margin: -0.75rem !important;\n  }\n\n  .m-lg-n4 {\n    margin: -1rem !important;\n  }\n\n  .m-lg-n5 {\n    margin: -1.25rem !important;\n  }\n\n  .m-lg-n6 {\n    margin: -1.5rem !important;\n  }\n\n  .m-lg-n7 {\n    margin: -1.75rem !important;\n  }\n\n  .m-lg-n8 {\n    margin: -2rem !important;\n  }\n\n  .m-lg-n9 {\n    margin: -2.25rem !important;\n  }\n\n  .m-lg-n10 {\n    margin: -2.5rem !important;\n  }\n\n  .m-lg-n11 {\n    margin: -2.75rem !important;\n  }\n\n  .m-lg-n12 {\n    margin: -3rem !important;\n  }\n\n  .m-lg-n13 {\n    margin: -3.25rem !important;\n  }\n\n  .m-lg-n14 {\n    margin: -3.5rem !important;\n  }\n\n  .m-lg-n15 {\n    margin: -3.75rem !important;\n  }\n\n  .m-lg-n16 {\n    margin: -4rem !important;\n  }\n\n  .m-lg-n17 {\n    margin: -4.25rem !important;\n  }\n\n  .m-lg-n18 {\n    margin: -4.5rem !important;\n  }\n\n  .m-lg-n19 {\n    margin: -4.75rem !important;\n  }\n\n  .m-lg-n20 {\n    margin: -5rem !important;\n  }\n\n  .mx-lg-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n\n  .mx-lg-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n\n  .mx-lg-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n\n  .mx-lg-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n\n  .mx-lg-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n\n  .mx-lg-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n\n  .mx-lg-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n\n  .mx-lg-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n\n  .mx-lg-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n\n  .mx-lg-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n\n  .mx-lg-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n\n  .mx-lg-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n\n  .mx-lg-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n\n  .mx-lg-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n\n  .mx-lg-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n\n  .mx-lg-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n\n  .mx-lg-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n\n  .mx-lg-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n\n  .mx-lg-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n\n  .mx-lg-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n\n  .my-lg-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n\n  .my-lg-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n\n  .my-lg-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n\n  .my-lg-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n\n  .my-lg-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n\n  .my-lg-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n\n  .my-lg-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n\n  .my-lg-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n\n  .my-lg-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n\n  .my-lg-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n\n  .my-lg-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n\n  .my-lg-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n\n  .my-lg-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n\n  .my-lg-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n\n  .my-lg-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n\n  .my-lg-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n\n  .my-lg-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n\n  .my-lg-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n\n  .my-lg-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n\n  .my-lg-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n\n  .mt-lg-n1 {\n    margin-top: -0.25rem !important;\n  }\n\n  .mt-lg-n2 {\n    margin-top: -0.5rem !important;\n  }\n\n  .mt-lg-n3 {\n    margin-top: -0.75rem !important;\n  }\n\n  .mt-lg-n4 {\n    margin-top: -1rem !important;\n  }\n\n  .mt-lg-n5 {\n    margin-top: -1.25rem !important;\n  }\n\n  .mt-lg-n6 {\n    margin-top: -1.5rem !important;\n  }\n\n  .mt-lg-n7 {\n    margin-top: -1.75rem !important;\n  }\n\n  .mt-lg-n8 {\n    margin-top: -2rem !important;\n  }\n\n  .mt-lg-n9 {\n    margin-top: -2.25rem !important;\n  }\n\n  .mt-lg-n10 {\n    margin-top: -2.5rem !important;\n  }\n\n  .mt-lg-n11 {\n    margin-top: -2.75rem !important;\n  }\n\n  .mt-lg-n12 {\n    margin-top: -3rem !important;\n  }\n\n  .mt-lg-n13 {\n    margin-top: -3.25rem !important;\n  }\n\n  .mt-lg-n14 {\n    margin-top: -3.5rem !important;\n  }\n\n  .mt-lg-n15 {\n    margin-top: -3.75rem !important;\n  }\n\n  .mt-lg-n16 {\n    margin-top: -4rem !important;\n  }\n\n  .mt-lg-n17 {\n    margin-top: -4.25rem !important;\n  }\n\n  .mt-lg-n18 {\n    margin-top: -4.5rem !important;\n  }\n\n  .mt-lg-n19 {\n    margin-top: -4.75rem !important;\n  }\n\n  .mt-lg-n20 {\n    margin-top: -5rem !important;\n  }\n\n  .me-lg-n1 {\n    margin-right: -0.25rem !important;\n  }\n\n  .me-lg-n2 {\n    margin-right: -0.5rem !important;\n  }\n\n  .me-lg-n3 {\n    margin-right: -0.75rem !important;\n  }\n\n  .me-lg-n4 {\n    margin-right: -1rem !important;\n  }\n\n  .me-lg-n5 {\n    margin-right: -1.25rem !important;\n  }\n\n  .me-lg-n6 {\n    margin-right: -1.5rem !important;\n  }\n\n  .me-lg-n7 {\n    margin-right: -1.75rem !important;\n  }\n\n  .me-lg-n8 {\n    margin-right: -2rem !important;\n  }\n\n  .me-lg-n9 {\n    margin-right: -2.25rem !important;\n  }\n\n  .me-lg-n10 {\n    margin-right: -2.5rem !important;\n  }\n\n  .me-lg-n11 {\n    margin-right: -2.75rem !important;\n  }\n\n  .me-lg-n12 {\n    margin-right: -3rem !important;\n  }\n\n  .me-lg-n13 {\n    margin-right: -3.25rem !important;\n  }\n\n  .me-lg-n14 {\n    margin-right: -3.5rem !important;\n  }\n\n  .me-lg-n15 {\n    margin-right: -3.75rem !important;\n  }\n\n  .me-lg-n16 {\n    margin-right: -4rem !important;\n  }\n\n  .me-lg-n17 {\n    margin-right: -4.25rem !important;\n  }\n\n  .me-lg-n18 {\n    margin-right: -4.5rem !important;\n  }\n\n  .me-lg-n19 {\n    margin-right: -4.75rem !important;\n  }\n\n  .me-lg-n20 {\n    margin-right: -5rem !important;\n  }\n\n  .mb-lg-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n\n  .mb-lg-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n\n  .mb-lg-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n\n  .mb-lg-n4 {\n    margin-bottom: -1rem !important;\n  }\n\n  .mb-lg-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n\n  .mb-lg-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n\n  .mb-lg-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n\n  .mb-lg-n8 {\n    margin-bottom: -2rem !important;\n  }\n\n  .mb-lg-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n\n  .mb-lg-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n\n  .mb-lg-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n\n  .mb-lg-n12 {\n    margin-bottom: -3rem !important;\n  }\n\n  .mb-lg-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n\n  .mb-lg-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n\n  .mb-lg-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n\n  .mb-lg-n16 {\n    margin-bottom: -4rem !important;\n  }\n\n  .mb-lg-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n\n  .mb-lg-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n\n  .mb-lg-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n\n  .mb-lg-n20 {\n    margin-bottom: -5rem !important;\n  }\n\n  .ms-lg-n1 {\n    margin-left: -0.25rem !important;\n  }\n\n  .ms-lg-n2 {\n    margin-left: -0.5rem !important;\n  }\n\n  .ms-lg-n3 {\n    margin-left: -0.75rem !important;\n  }\n\n  .ms-lg-n4 {\n    margin-left: -1rem !important;\n  }\n\n  .ms-lg-n5 {\n    margin-left: -1.25rem !important;\n  }\n\n  .ms-lg-n6 {\n    margin-left: -1.5rem !important;\n  }\n\n  .ms-lg-n7 {\n    margin-left: -1.75rem !important;\n  }\n\n  .ms-lg-n8 {\n    margin-left: -2rem !important;\n  }\n\n  .ms-lg-n9 {\n    margin-left: -2.25rem !important;\n  }\n\n  .ms-lg-n10 {\n    margin-left: -2.5rem !important;\n  }\n\n  .ms-lg-n11 {\n    margin-left: -2.75rem !important;\n  }\n\n  .ms-lg-n12 {\n    margin-left: -3rem !important;\n  }\n\n  .ms-lg-n13 {\n    margin-left: -3.25rem !important;\n  }\n\n  .ms-lg-n14 {\n    margin-left: -3.5rem !important;\n  }\n\n  .ms-lg-n15 {\n    margin-left: -3.75rem !important;\n  }\n\n  .ms-lg-n16 {\n    margin-left: -4rem !important;\n  }\n\n  .ms-lg-n17 {\n    margin-left: -4.25rem !important;\n  }\n\n  .ms-lg-n18 {\n    margin-left: -4.5rem !important;\n  }\n\n  .ms-lg-n19 {\n    margin-left: -4.75rem !important;\n  }\n\n  .ms-lg-n20 {\n    margin-left: -5rem !important;\n  }\n\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-lg-3 {\n    padding: 0.75rem !important;\n  }\n\n  .p-lg-4 {\n    padding: 1rem !important;\n  }\n\n  .p-lg-5 {\n    padding: 1.25rem !important;\n  }\n\n  .p-lg-6 {\n    padding: 1.5rem !important;\n  }\n\n  .p-lg-7 {\n    padding: 1.75rem !important;\n  }\n\n  .p-lg-8 {\n    padding: 2rem !important;\n  }\n\n  .p-lg-9 {\n    padding: 2.25rem !important;\n  }\n\n  .p-lg-10 {\n    padding: 2.5rem !important;\n  }\n\n  .p-lg-11 {\n    padding: 2.75rem !important;\n  }\n\n  .p-lg-12 {\n    padding: 3rem !important;\n  }\n\n  .p-lg-13 {\n    padding: 3.25rem !important;\n  }\n\n  .p-lg-14 {\n    padding: 3.5rem !important;\n  }\n\n  .p-lg-15 {\n    padding: 3.75rem !important;\n  }\n\n  .p-lg-16 {\n    padding: 4rem !important;\n  }\n\n  .p-lg-17 {\n    padding: 4.25rem !important;\n  }\n\n  .p-lg-18 {\n    padding: 4.5rem !important;\n  }\n\n  .p-lg-19 {\n    padding: 4.75rem !important;\n  }\n\n  .p-lg-20 {\n    padding: 5rem !important;\n  }\n\n  .px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .px-lg-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n\n  .px-lg-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n\n  .px-lg-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n\n  .px-lg-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .px-lg-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n\n  .px-lg-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n\n  .px-lg-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n\n  .px-lg-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n\n  .px-lg-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n\n  .px-lg-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n\n  .px-lg-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n\n  .px-lg-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n\n  .px-lg-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n\n  .px-lg-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n\n  .px-lg-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n\n  .px-lg-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n\n  .px-lg-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n\n  .px-lg-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n\n  .py-lg-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-lg-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n\n  .py-lg-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-lg-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n\n  .py-lg-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-lg-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n\n  .py-lg-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n\n  .py-lg-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n\n  .py-lg-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n\n  .py-lg-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n\n  .py-lg-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .py-lg-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n\n  .py-lg-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-lg-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n\n  .py-lg-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-lg-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n\n  .py-lg-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-lg-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n\n  .py-lg-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .pt-lg-0 {\n    padding-top: 0 !important;\n  }\n\n  .pt-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-lg-3 {\n    padding-top: 0.75rem !important;\n  }\n\n  .pt-lg-4 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-lg-5 {\n    padding-top: 1.25rem !important;\n  }\n\n  .pt-lg-6 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-lg-7 {\n    padding-top: 1.75rem !important;\n  }\n\n  .pt-lg-8 {\n    padding-top: 2rem !important;\n  }\n\n  .pt-lg-9 {\n    padding-top: 2.25rem !important;\n  }\n\n  .pt-lg-10 {\n    padding-top: 2.5rem !important;\n  }\n\n  .pt-lg-11 {\n    padding-top: 2.75rem !important;\n  }\n\n  .pt-lg-12 {\n    padding-top: 3rem !important;\n  }\n\n  .pt-lg-13 {\n    padding-top: 3.25rem !important;\n  }\n\n  .pt-lg-14 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-lg-15 {\n    padding-top: 3.75rem !important;\n  }\n\n  .pt-lg-16 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-lg-17 {\n    padding-top: 4.25rem !important;\n  }\n\n  .pt-lg-18 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-lg-19 {\n    padding-top: 4.75rem !important;\n  }\n\n  .pt-lg-20 {\n    padding-top: 5rem !important;\n  }\n\n  .pe-lg-0 {\n    padding-right: 0 !important;\n  }\n\n  .pe-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-lg-3 {\n    padding-right: 0.75rem !important;\n  }\n\n  .pe-lg-4 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-lg-5 {\n    padding-right: 1.25rem !important;\n  }\n\n  .pe-lg-6 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-lg-7 {\n    padding-right: 1.75rem !important;\n  }\n\n  .pe-lg-8 {\n    padding-right: 2rem !important;\n  }\n\n  .pe-lg-9 {\n    padding-right: 2.25rem !important;\n  }\n\n  .pe-lg-10 {\n    padding-right: 2.5rem !important;\n  }\n\n  .pe-lg-11 {\n    padding-right: 2.75rem !important;\n  }\n\n  .pe-lg-12 {\n    padding-right: 3rem !important;\n  }\n\n  .pe-lg-13 {\n    padding-right: 3.25rem !important;\n  }\n\n  .pe-lg-14 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-lg-15 {\n    padding-right: 3.75rem !important;\n  }\n\n  .pe-lg-16 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-lg-17 {\n    padding-right: 4.25rem !important;\n  }\n\n  .pe-lg-18 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-lg-19 {\n    padding-right: 4.75rem !important;\n  }\n\n  .pe-lg-20 {\n    padding-right: 5rem !important;\n  }\n\n  .pb-lg-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pb-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-lg-3 {\n    padding-bottom: 0.75rem !important;\n  }\n\n  .pb-lg-4 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-lg-5 {\n    padding-bottom: 1.25rem !important;\n  }\n\n  .pb-lg-6 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-lg-7 {\n    padding-bottom: 1.75rem !important;\n  }\n\n  .pb-lg-8 {\n    padding-bottom: 2rem !important;\n  }\n\n  .pb-lg-9 {\n    padding-bottom: 2.25rem !important;\n  }\n\n  .pb-lg-10 {\n    padding-bottom: 2.5rem !important;\n  }\n\n  .pb-lg-11 {\n    padding-bottom: 2.75rem !important;\n  }\n\n  .pb-lg-12 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pb-lg-13 {\n    padding-bottom: 3.25rem !important;\n  }\n\n  .pb-lg-14 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-lg-15 {\n    padding-bottom: 3.75rem !important;\n  }\n\n  .pb-lg-16 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-lg-17 {\n    padding-bottom: 4.25rem !important;\n  }\n\n  .pb-lg-18 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-lg-19 {\n    padding-bottom: 4.75rem !important;\n  }\n\n  .pb-lg-20 {\n    padding-bottom: 5rem !important;\n  }\n\n  .ps-lg-0 {\n    padding-left: 0 !important;\n  }\n\n  .ps-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-lg-3 {\n    padding-left: 0.75rem !important;\n  }\n\n  .ps-lg-4 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-lg-5 {\n    padding-left: 1.25rem !important;\n  }\n\n  .ps-lg-6 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-lg-7 {\n    padding-left: 1.75rem !important;\n  }\n\n  .ps-lg-8 {\n    padding-left: 2rem !important;\n  }\n\n  .ps-lg-9 {\n    padding-left: 2.25rem !important;\n  }\n\n  .ps-lg-10 {\n    padding-left: 2.5rem !important;\n  }\n\n  .ps-lg-11 {\n    padding-left: 2.75rem !important;\n  }\n\n  .ps-lg-12 {\n    padding-left: 3rem !important;\n  }\n\n  .ps-lg-13 {\n    padding-left: 3.25rem !important;\n  }\n\n  .ps-lg-14 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-lg-15 {\n    padding-left: 3.75rem !important;\n  }\n\n  .ps-lg-16 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-lg-17 {\n    padding-left: 4.25rem !important;\n  }\n\n  .ps-lg-18 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-lg-19 {\n    padding-left: 4.75rem !important;\n  }\n\n  .ps-lg-20 {\n    padding-left: 5rem !important;\n  }\n\n  .gap-lg-0 {\n    gap: 0 !important;\n  }\n\n  .gap-lg-1 {\n    gap: 0.25rem !important;\n  }\n\n  .gap-lg-2 {\n    gap: 0.5rem !important;\n  }\n\n  .gap-lg-3 {\n    gap: 0.75rem !important;\n  }\n\n  .gap-lg-4 {\n    gap: 1rem !important;\n  }\n\n  .gap-lg-5 {\n    gap: 1.25rem !important;\n  }\n\n  .gap-lg-6 {\n    gap: 1.5rem !important;\n  }\n\n  .gap-lg-7 {\n    gap: 1.75rem !important;\n  }\n\n  .gap-lg-8 {\n    gap: 2rem !important;\n  }\n\n  .gap-lg-9 {\n    gap: 2.25rem !important;\n  }\n\n  .gap-lg-10 {\n    gap: 2.5rem !important;\n  }\n\n  .gap-lg-11 {\n    gap: 2.75rem !important;\n  }\n\n  .gap-lg-12 {\n    gap: 3rem !important;\n  }\n\n  .gap-lg-13 {\n    gap: 3.25rem !important;\n  }\n\n  .gap-lg-14 {\n    gap: 3.5rem !important;\n  }\n\n  .gap-lg-15 {\n    gap: 3.75rem !important;\n  }\n\n  .gap-lg-16 {\n    gap: 4rem !important;\n  }\n\n  .gap-lg-17 {\n    gap: 4.25rem !important;\n  }\n\n  .gap-lg-18 {\n    gap: 4.5rem !important;\n  }\n\n  .gap-lg-19 {\n    gap: 4.75rem !important;\n  }\n\n  .gap-lg-20 {\n    gap: 5rem !important;\n  }\n\n  .row-gap-lg-0 {\n    row-gap: 0 !important;\n  }\n\n  .row-gap-lg-1 {\n    row-gap: 0.25rem !important;\n  }\n\n  .row-gap-lg-2 {\n    row-gap: 0.5rem !important;\n  }\n\n  .row-gap-lg-3 {\n    row-gap: 0.75rem !important;\n  }\n\n  .row-gap-lg-4 {\n    row-gap: 1rem !important;\n  }\n\n  .row-gap-lg-5 {\n    row-gap: 1.25rem !important;\n  }\n\n  .row-gap-lg-6 {\n    row-gap: 1.5rem !important;\n  }\n\n  .row-gap-lg-7 {\n    row-gap: 1.75rem !important;\n  }\n\n  .row-gap-lg-8 {\n    row-gap: 2rem !important;\n  }\n\n  .row-gap-lg-9 {\n    row-gap: 2.25rem !important;\n  }\n\n  .row-gap-lg-10 {\n    row-gap: 2.5rem !important;\n  }\n\n  .row-gap-lg-11 {\n    row-gap: 2.75rem !important;\n  }\n\n  .row-gap-lg-12 {\n    row-gap: 3rem !important;\n  }\n\n  .row-gap-lg-13 {\n    row-gap: 3.25rem !important;\n  }\n\n  .row-gap-lg-14 {\n    row-gap: 3.5rem !important;\n  }\n\n  .row-gap-lg-15 {\n    row-gap: 3.75rem !important;\n  }\n\n  .row-gap-lg-16 {\n    row-gap: 4rem !important;\n  }\n\n  .row-gap-lg-17 {\n    row-gap: 4.25rem !important;\n  }\n\n  .row-gap-lg-18 {\n    row-gap: 4.5rem !important;\n  }\n\n  .row-gap-lg-19 {\n    row-gap: 4.75rem !important;\n  }\n\n  .row-gap-lg-20 {\n    row-gap: 5rem !important;\n  }\n\n  .column-gap-lg-0 {\n    column-gap: 0 !important;\n  }\n\n  .column-gap-lg-1 {\n    column-gap: 0.25rem !important;\n  }\n\n  .column-gap-lg-2 {\n    column-gap: 0.5rem !important;\n  }\n\n  .column-gap-lg-3 {\n    column-gap: 0.75rem !important;\n  }\n\n  .column-gap-lg-4 {\n    column-gap: 1rem !important;\n  }\n\n  .column-gap-lg-5 {\n    column-gap: 1.25rem !important;\n  }\n\n  .column-gap-lg-6 {\n    column-gap: 1.5rem !important;\n  }\n\n  .column-gap-lg-7 {\n    column-gap: 1.75rem !important;\n  }\n\n  .column-gap-lg-8 {\n    column-gap: 2rem !important;\n  }\n\n  .column-gap-lg-9 {\n    column-gap: 2.25rem !important;\n  }\n\n  .column-gap-lg-10 {\n    column-gap: 2.5rem !important;\n  }\n\n  .column-gap-lg-11 {\n    column-gap: 2.75rem !important;\n  }\n\n  .column-gap-lg-12 {\n    column-gap: 3rem !important;\n  }\n\n  .column-gap-lg-13 {\n    column-gap: 3.25rem !important;\n  }\n\n  .column-gap-lg-14 {\n    column-gap: 3.5rem !important;\n  }\n\n  .column-gap-lg-15 {\n    column-gap: 3.75rem !important;\n  }\n\n  .column-gap-lg-16 {\n    column-gap: 4rem !important;\n  }\n\n  .column-gap-lg-17 {\n    column-gap: 4.25rem !important;\n  }\n\n  .column-gap-lg-18 {\n    column-gap: 4.5rem !important;\n  }\n\n  .column-gap-lg-19 {\n    column-gap: 4.75rem !important;\n  }\n\n  .column-gap-lg-20 {\n    column-gap: 5rem !important;\n  }\n\n  .text-lg-start {\n    text-align: left !important;\n  }\n\n  .text-lg-end {\n    text-align: right !important;\n  }\n\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-start {\n    float: left !important;\n  }\n\n  .float-xl-end {\n    float: right !important;\n  }\n\n  .float-xl-none {\n    float: none !important;\n  }\n\n  .object-fit-xl-contain {\n    object-fit: contain !important;\n  }\n\n  .object-fit-xl-cover {\n    object-fit: cover !important;\n  }\n\n  .object-fit-xl-fill {\n    object-fit: fill !important;\n  }\n\n  .object-fit-xl-scale {\n    object-fit: scale-down !important;\n  }\n\n  .object-fit-xl-none {\n    object-fit: none !important;\n  }\n\n  .d-xl-inline {\n    display: inline !important;\n  }\n\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-xl-block {\n    display: block !important;\n  }\n\n  .d-xl-grid {\n    display: grid !important;\n  }\n\n  .d-xl-inline-grid {\n    display: inline-grid !important;\n  }\n\n  .d-xl-table {\n    display: table !important;\n  }\n\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-xl-flex {\n    display: flex !important;\n  }\n\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-xl-none {\n    display: none !important;\n  }\n\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n\n  .justify-content-xl-evenly {\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n\n  .order-xl-first {\n    order: -1 !important;\n  }\n\n  .order-xl-0 {\n    order: 0 !important;\n  }\n\n  .order-xl-1 {\n    order: 1 !important;\n  }\n\n  .order-xl-2 {\n    order: 2 !important;\n  }\n\n  .order-xl-3 {\n    order: 3 !important;\n  }\n\n  .order-xl-4 {\n    order: 4 !important;\n  }\n\n  .order-xl-5 {\n    order: 5 !important;\n  }\n\n  .order-xl-last {\n    order: 6 !important;\n  }\n\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-xl-3 {\n    margin: 0.75rem !important;\n  }\n\n  .m-xl-4 {\n    margin: 1rem !important;\n  }\n\n  .m-xl-5 {\n    margin: 1.25rem !important;\n  }\n\n  .m-xl-6 {\n    margin: 1.5rem !important;\n  }\n\n  .m-xl-7 {\n    margin: 1.75rem !important;\n  }\n\n  .m-xl-8 {\n    margin: 2rem !important;\n  }\n\n  .m-xl-9 {\n    margin: 2.25rem !important;\n  }\n\n  .m-xl-10 {\n    margin: 2.5rem !important;\n  }\n\n  .m-xl-11 {\n    margin: 2.75rem !important;\n  }\n\n  .m-xl-12 {\n    margin: 3rem !important;\n  }\n\n  .m-xl-13 {\n    margin: 3.25rem !important;\n  }\n\n  .m-xl-14 {\n    margin: 3.5rem !important;\n  }\n\n  .m-xl-15 {\n    margin: 3.75rem !important;\n  }\n\n  .m-xl-16 {\n    margin: 4rem !important;\n  }\n\n  .m-xl-17 {\n    margin: 4.25rem !important;\n  }\n\n  .m-xl-18 {\n    margin: 4.5rem !important;\n  }\n\n  .m-xl-19 {\n    margin: 4.75rem !important;\n  }\n\n  .m-xl-20 {\n    margin: 5rem !important;\n  }\n\n  .m-xl-auto {\n    margin: auto !important;\n  }\n\n  .mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .mx-xl-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n\n  .mx-xl-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n\n  .mx-xl-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n\n  .mx-xl-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .mx-xl-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n\n  .mx-xl-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n\n  .mx-xl-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n\n  .mx-xl-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n\n  .mx-xl-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n\n  .mx-xl-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n\n  .mx-xl-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n\n  .mx-xl-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n\n  .mx-xl-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n\n  .mx-xl-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n\n  .mx-xl-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n\n  .mx-xl-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n\n  .mx-xl-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n\n  .mx-xl-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n\n  .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-xl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-xl-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n\n  .my-xl-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-xl-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n\n  .my-xl-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-xl-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n\n  .my-xl-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n\n  .my-xl-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n\n  .my-xl-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n\n  .my-xl-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n\n  .my-xl-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-xl-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n\n  .my-xl-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-xl-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n\n  .my-xl-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-xl-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n\n  .my-xl-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-xl-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n\n  .my-xl-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-xl-0 {\n    margin-top: 0 !important;\n  }\n\n  .mt-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-xl-3 {\n    margin-top: 0.75rem !important;\n  }\n\n  .mt-xl-4 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-xl-5 {\n    margin-top: 1.25rem !important;\n  }\n\n  .mt-xl-6 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-xl-7 {\n    margin-top: 1.75rem !important;\n  }\n\n  .mt-xl-8 {\n    margin-top: 2rem !important;\n  }\n\n  .mt-xl-9 {\n    margin-top: 2.25rem !important;\n  }\n\n  .mt-xl-10 {\n    margin-top: 2.5rem !important;\n  }\n\n  .mt-xl-11 {\n    margin-top: 2.75rem !important;\n  }\n\n  .mt-xl-12 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-xl-13 {\n    margin-top: 3.25rem !important;\n  }\n\n  .mt-xl-14 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-xl-15 {\n    margin-top: 3.75rem !important;\n  }\n\n  .mt-xl-16 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-xl-17 {\n    margin-top: 4.25rem !important;\n  }\n\n  .mt-xl-18 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-xl-19 {\n    margin-top: 4.75rem !important;\n  }\n\n  .mt-xl-20 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-xl-auto {\n    margin-top: auto !important;\n  }\n\n  .me-xl-0 {\n    margin-right: 0 !important;\n  }\n\n  .me-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-xl-3 {\n    margin-right: 0.75rem !important;\n  }\n\n  .me-xl-4 {\n    margin-right: 1rem !important;\n  }\n\n  .me-xl-5 {\n    margin-right: 1.25rem !important;\n  }\n\n  .me-xl-6 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-xl-7 {\n    margin-right: 1.75rem !important;\n  }\n\n  .me-xl-8 {\n    margin-right: 2rem !important;\n  }\n\n  .me-xl-9 {\n    margin-right: 2.25rem !important;\n  }\n\n  .me-xl-10 {\n    margin-right: 2.5rem !important;\n  }\n\n  .me-xl-11 {\n    margin-right: 2.75rem !important;\n  }\n\n  .me-xl-12 {\n    margin-right: 3rem !important;\n  }\n\n  .me-xl-13 {\n    margin-right: 3.25rem !important;\n  }\n\n  .me-xl-14 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-xl-15 {\n    margin-right: 3.75rem !important;\n  }\n\n  .me-xl-16 {\n    margin-right: 4rem !important;\n  }\n\n  .me-xl-17 {\n    margin-right: 4.25rem !important;\n  }\n\n  .me-xl-18 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-xl-19 {\n    margin-right: 4.75rem !important;\n  }\n\n  .me-xl-20 {\n    margin-right: 5rem !important;\n  }\n\n  .me-xl-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-xl-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .mb-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-xl-3 {\n    margin-bottom: 0.75rem !important;\n  }\n\n  .mb-xl-4 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-xl-5 {\n    margin-bottom: 1.25rem !important;\n  }\n\n  .mb-xl-6 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-xl-7 {\n    margin-bottom: 1.75rem !important;\n  }\n\n  .mb-xl-8 {\n    margin-bottom: 2rem !important;\n  }\n\n  .mb-xl-9 {\n    margin-bottom: 2.25rem !important;\n  }\n\n  .mb-xl-10 {\n    margin-bottom: 2.5rem !important;\n  }\n\n  .mb-xl-11 {\n    margin-bottom: 2.75rem !important;\n  }\n\n  .mb-xl-12 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-xl-13 {\n    margin-bottom: 3.25rem !important;\n  }\n\n  .mb-xl-14 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-xl-15 {\n    margin-bottom: 3.75rem !important;\n  }\n\n  .mb-xl-16 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-xl-17 {\n    margin-bottom: 4.25rem !important;\n  }\n\n  .mb-xl-18 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-xl-19 {\n    margin-bottom: 4.75rem !important;\n  }\n\n  .mb-xl-20 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-xl-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-xl-0 {\n    margin-left: 0 !important;\n  }\n\n  .ms-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-xl-3 {\n    margin-left: 0.75rem !important;\n  }\n\n  .ms-xl-4 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-xl-5 {\n    margin-left: 1.25rem !important;\n  }\n\n  .ms-xl-6 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-xl-7 {\n    margin-left: 1.75rem !important;\n  }\n\n  .ms-xl-8 {\n    margin-left: 2rem !important;\n  }\n\n  .ms-xl-9 {\n    margin-left: 2.25rem !important;\n  }\n\n  .ms-xl-10 {\n    margin-left: 2.5rem !important;\n  }\n\n  .ms-xl-11 {\n    margin-left: 2.75rem !important;\n  }\n\n  .ms-xl-12 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-xl-13 {\n    margin-left: 3.25rem !important;\n  }\n\n  .ms-xl-14 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-xl-15 {\n    margin-left: 3.75rem !important;\n  }\n\n  .ms-xl-16 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-xl-17 {\n    margin-left: 4.25rem !important;\n  }\n\n  .ms-xl-18 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-xl-19 {\n    margin-left: 4.75rem !important;\n  }\n\n  .ms-xl-20 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-xl-auto {\n    margin-left: auto !important;\n  }\n\n  .m-xl-n1 {\n    margin: -0.25rem !important;\n  }\n\n  .m-xl-n2 {\n    margin: -0.5rem !important;\n  }\n\n  .m-xl-n3 {\n    margin: -0.75rem !important;\n  }\n\n  .m-xl-n4 {\n    margin: -1rem !important;\n  }\n\n  .m-xl-n5 {\n    margin: -1.25rem !important;\n  }\n\n  .m-xl-n6 {\n    margin: -1.5rem !important;\n  }\n\n  .m-xl-n7 {\n    margin: -1.75rem !important;\n  }\n\n  .m-xl-n8 {\n    margin: -2rem !important;\n  }\n\n  .m-xl-n9 {\n    margin: -2.25rem !important;\n  }\n\n  .m-xl-n10 {\n    margin: -2.5rem !important;\n  }\n\n  .m-xl-n11 {\n    margin: -2.75rem !important;\n  }\n\n  .m-xl-n12 {\n    margin: -3rem !important;\n  }\n\n  .m-xl-n13 {\n    margin: -3.25rem !important;\n  }\n\n  .m-xl-n14 {\n    margin: -3.5rem !important;\n  }\n\n  .m-xl-n15 {\n    margin: -3.75rem !important;\n  }\n\n  .m-xl-n16 {\n    margin: -4rem !important;\n  }\n\n  .m-xl-n17 {\n    margin: -4.25rem !important;\n  }\n\n  .m-xl-n18 {\n    margin: -4.5rem !important;\n  }\n\n  .m-xl-n19 {\n    margin: -4.75rem !important;\n  }\n\n  .m-xl-n20 {\n    margin: -5rem !important;\n  }\n\n  .mx-xl-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n\n  .mx-xl-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n\n  .mx-xl-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n\n  .mx-xl-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n\n  .mx-xl-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n\n  .mx-xl-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n\n  .mx-xl-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n\n  .mx-xl-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n\n  .mx-xl-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n\n  .mx-xl-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n\n  .mx-xl-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n\n  .mx-xl-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n\n  .mx-xl-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n\n  .mx-xl-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n\n  .mx-xl-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n\n  .mx-xl-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n\n  .mx-xl-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n\n  .mx-xl-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n\n  .mx-xl-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n\n  .mx-xl-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n\n  .my-xl-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n\n  .my-xl-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n\n  .my-xl-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n\n  .my-xl-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n\n  .my-xl-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n\n  .my-xl-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n\n  .my-xl-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n\n  .my-xl-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n\n  .my-xl-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n\n  .my-xl-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n\n  .my-xl-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n\n  .my-xl-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n\n  .my-xl-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n\n  .my-xl-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n\n  .my-xl-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n\n  .my-xl-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n\n  .my-xl-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n\n  .my-xl-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n\n  .my-xl-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n\n  .my-xl-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n\n  .mt-xl-n1 {\n    margin-top: -0.25rem !important;\n  }\n\n  .mt-xl-n2 {\n    margin-top: -0.5rem !important;\n  }\n\n  .mt-xl-n3 {\n    margin-top: -0.75rem !important;\n  }\n\n  .mt-xl-n4 {\n    margin-top: -1rem !important;\n  }\n\n  .mt-xl-n5 {\n    margin-top: -1.25rem !important;\n  }\n\n  .mt-xl-n6 {\n    margin-top: -1.5rem !important;\n  }\n\n  .mt-xl-n7 {\n    margin-top: -1.75rem !important;\n  }\n\n  .mt-xl-n8 {\n    margin-top: -2rem !important;\n  }\n\n  .mt-xl-n9 {\n    margin-top: -2.25rem !important;\n  }\n\n  .mt-xl-n10 {\n    margin-top: -2.5rem !important;\n  }\n\n  .mt-xl-n11 {\n    margin-top: -2.75rem !important;\n  }\n\n  .mt-xl-n12 {\n    margin-top: -3rem !important;\n  }\n\n  .mt-xl-n13 {\n    margin-top: -3.25rem !important;\n  }\n\n  .mt-xl-n14 {\n    margin-top: -3.5rem !important;\n  }\n\n  .mt-xl-n15 {\n    margin-top: -3.75rem !important;\n  }\n\n  .mt-xl-n16 {\n    margin-top: -4rem !important;\n  }\n\n  .mt-xl-n17 {\n    margin-top: -4.25rem !important;\n  }\n\n  .mt-xl-n18 {\n    margin-top: -4.5rem !important;\n  }\n\n  .mt-xl-n19 {\n    margin-top: -4.75rem !important;\n  }\n\n  .mt-xl-n20 {\n    margin-top: -5rem !important;\n  }\n\n  .me-xl-n1 {\n    margin-right: -0.25rem !important;\n  }\n\n  .me-xl-n2 {\n    margin-right: -0.5rem !important;\n  }\n\n  .me-xl-n3 {\n    margin-right: -0.75rem !important;\n  }\n\n  .me-xl-n4 {\n    margin-right: -1rem !important;\n  }\n\n  .me-xl-n5 {\n    margin-right: -1.25rem !important;\n  }\n\n  .me-xl-n6 {\n    margin-right: -1.5rem !important;\n  }\n\n  .me-xl-n7 {\n    margin-right: -1.75rem !important;\n  }\n\n  .me-xl-n8 {\n    margin-right: -2rem !important;\n  }\n\n  .me-xl-n9 {\n    margin-right: -2.25rem !important;\n  }\n\n  .me-xl-n10 {\n    margin-right: -2.5rem !important;\n  }\n\n  .me-xl-n11 {\n    margin-right: -2.75rem !important;\n  }\n\n  .me-xl-n12 {\n    margin-right: -3rem !important;\n  }\n\n  .me-xl-n13 {\n    margin-right: -3.25rem !important;\n  }\n\n  .me-xl-n14 {\n    margin-right: -3.5rem !important;\n  }\n\n  .me-xl-n15 {\n    margin-right: -3.75rem !important;\n  }\n\n  .me-xl-n16 {\n    margin-right: -4rem !important;\n  }\n\n  .me-xl-n17 {\n    margin-right: -4.25rem !important;\n  }\n\n  .me-xl-n18 {\n    margin-right: -4.5rem !important;\n  }\n\n  .me-xl-n19 {\n    margin-right: -4.75rem !important;\n  }\n\n  .me-xl-n20 {\n    margin-right: -5rem !important;\n  }\n\n  .mb-xl-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n\n  .mb-xl-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n\n  .mb-xl-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n\n  .mb-xl-n4 {\n    margin-bottom: -1rem !important;\n  }\n\n  .mb-xl-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n\n  .mb-xl-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n\n  .mb-xl-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n\n  .mb-xl-n8 {\n    margin-bottom: -2rem !important;\n  }\n\n  .mb-xl-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n\n  .mb-xl-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n\n  .mb-xl-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n\n  .mb-xl-n12 {\n    margin-bottom: -3rem !important;\n  }\n\n  .mb-xl-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n\n  .mb-xl-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n\n  .mb-xl-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n\n  .mb-xl-n16 {\n    margin-bottom: -4rem !important;\n  }\n\n  .mb-xl-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n\n  .mb-xl-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n\n  .mb-xl-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n\n  .mb-xl-n20 {\n    margin-bottom: -5rem !important;\n  }\n\n  .ms-xl-n1 {\n    margin-left: -0.25rem !important;\n  }\n\n  .ms-xl-n2 {\n    margin-left: -0.5rem !important;\n  }\n\n  .ms-xl-n3 {\n    margin-left: -0.75rem !important;\n  }\n\n  .ms-xl-n4 {\n    margin-left: -1rem !important;\n  }\n\n  .ms-xl-n5 {\n    margin-left: -1.25rem !important;\n  }\n\n  .ms-xl-n6 {\n    margin-left: -1.5rem !important;\n  }\n\n  .ms-xl-n7 {\n    margin-left: -1.75rem !important;\n  }\n\n  .ms-xl-n8 {\n    margin-left: -2rem !important;\n  }\n\n  .ms-xl-n9 {\n    margin-left: -2.25rem !important;\n  }\n\n  .ms-xl-n10 {\n    margin-left: -2.5rem !important;\n  }\n\n  .ms-xl-n11 {\n    margin-left: -2.75rem !important;\n  }\n\n  .ms-xl-n12 {\n    margin-left: -3rem !important;\n  }\n\n  .ms-xl-n13 {\n    margin-left: -3.25rem !important;\n  }\n\n  .ms-xl-n14 {\n    margin-left: -3.5rem !important;\n  }\n\n  .ms-xl-n15 {\n    margin-left: -3.75rem !important;\n  }\n\n  .ms-xl-n16 {\n    margin-left: -4rem !important;\n  }\n\n  .ms-xl-n17 {\n    margin-left: -4.25rem !important;\n  }\n\n  .ms-xl-n18 {\n    margin-left: -4.5rem !important;\n  }\n\n  .ms-xl-n19 {\n    margin-left: -4.75rem !important;\n  }\n\n  .ms-xl-n20 {\n    margin-left: -5rem !important;\n  }\n\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-xl-3 {\n    padding: 0.75rem !important;\n  }\n\n  .p-xl-4 {\n    padding: 1rem !important;\n  }\n\n  .p-xl-5 {\n    padding: 1.25rem !important;\n  }\n\n  .p-xl-6 {\n    padding: 1.5rem !important;\n  }\n\n  .p-xl-7 {\n    padding: 1.75rem !important;\n  }\n\n  .p-xl-8 {\n    padding: 2rem !important;\n  }\n\n  .p-xl-9 {\n    padding: 2.25rem !important;\n  }\n\n  .p-xl-10 {\n    padding: 2.5rem !important;\n  }\n\n  .p-xl-11 {\n    padding: 2.75rem !important;\n  }\n\n  .p-xl-12 {\n    padding: 3rem !important;\n  }\n\n  .p-xl-13 {\n    padding: 3.25rem !important;\n  }\n\n  .p-xl-14 {\n    padding: 3.5rem !important;\n  }\n\n  .p-xl-15 {\n    padding: 3.75rem !important;\n  }\n\n  .p-xl-16 {\n    padding: 4rem !important;\n  }\n\n  .p-xl-17 {\n    padding: 4.25rem !important;\n  }\n\n  .p-xl-18 {\n    padding: 4.5rem !important;\n  }\n\n  .p-xl-19 {\n    padding: 4.75rem !important;\n  }\n\n  .p-xl-20 {\n    padding: 5rem !important;\n  }\n\n  .px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .px-xl-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n\n  .px-xl-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n\n  .px-xl-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n\n  .px-xl-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .px-xl-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n\n  .px-xl-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n\n  .px-xl-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n\n  .px-xl-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n\n  .px-xl-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n\n  .px-xl-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n\n  .px-xl-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n\n  .px-xl-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n\n  .px-xl-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n\n  .px-xl-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n\n  .px-xl-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n\n  .px-xl-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n\n  .px-xl-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n\n  .px-xl-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n\n  .py-xl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-xl-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n\n  .py-xl-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-xl-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n\n  .py-xl-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-xl-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n\n  .py-xl-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n\n  .py-xl-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n\n  .py-xl-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n\n  .py-xl-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n\n  .py-xl-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .py-xl-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n\n  .py-xl-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-xl-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n\n  .py-xl-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-xl-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n\n  .py-xl-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-xl-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n\n  .py-xl-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .pt-xl-0 {\n    padding-top: 0 !important;\n  }\n\n  .pt-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-xl-3 {\n    padding-top: 0.75rem !important;\n  }\n\n  .pt-xl-4 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-xl-5 {\n    padding-top: 1.25rem !important;\n  }\n\n  .pt-xl-6 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-xl-7 {\n    padding-top: 1.75rem !important;\n  }\n\n  .pt-xl-8 {\n    padding-top: 2rem !important;\n  }\n\n  .pt-xl-9 {\n    padding-top: 2.25rem !important;\n  }\n\n  .pt-xl-10 {\n    padding-top: 2.5rem !important;\n  }\n\n  .pt-xl-11 {\n    padding-top: 2.75rem !important;\n  }\n\n  .pt-xl-12 {\n    padding-top: 3rem !important;\n  }\n\n  .pt-xl-13 {\n    padding-top: 3.25rem !important;\n  }\n\n  .pt-xl-14 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-xl-15 {\n    padding-top: 3.75rem !important;\n  }\n\n  .pt-xl-16 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-xl-17 {\n    padding-top: 4.25rem !important;\n  }\n\n  .pt-xl-18 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-xl-19 {\n    padding-top: 4.75rem !important;\n  }\n\n  .pt-xl-20 {\n    padding-top: 5rem !important;\n  }\n\n  .pe-xl-0 {\n    padding-right: 0 !important;\n  }\n\n  .pe-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-xl-3 {\n    padding-right: 0.75rem !important;\n  }\n\n  .pe-xl-4 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-xl-5 {\n    padding-right: 1.25rem !important;\n  }\n\n  .pe-xl-6 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-xl-7 {\n    padding-right: 1.75rem !important;\n  }\n\n  .pe-xl-8 {\n    padding-right: 2rem !important;\n  }\n\n  .pe-xl-9 {\n    padding-right: 2.25rem !important;\n  }\n\n  .pe-xl-10 {\n    padding-right: 2.5rem !important;\n  }\n\n  .pe-xl-11 {\n    padding-right: 2.75rem !important;\n  }\n\n  .pe-xl-12 {\n    padding-right: 3rem !important;\n  }\n\n  .pe-xl-13 {\n    padding-right: 3.25rem !important;\n  }\n\n  .pe-xl-14 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-xl-15 {\n    padding-right: 3.75rem !important;\n  }\n\n  .pe-xl-16 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-xl-17 {\n    padding-right: 4.25rem !important;\n  }\n\n  .pe-xl-18 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-xl-19 {\n    padding-right: 4.75rem !important;\n  }\n\n  .pe-xl-20 {\n    padding-right: 5rem !important;\n  }\n\n  .pb-xl-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pb-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-xl-3 {\n    padding-bottom: 0.75rem !important;\n  }\n\n  .pb-xl-4 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-xl-5 {\n    padding-bottom: 1.25rem !important;\n  }\n\n  .pb-xl-6 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-xl-7 {\n    padding-bottom: 1.75rem !important;\n  }\n\n  .pb-xl-8 {\n    padding-bottom: 2rem !important;\n  }\n\n  .pb-xl-9 {\n    padding-bottom: 2.25rem !important;\n  }\n\n  .pb-xl-10 {\n    padding-bottom: 2.5rem !important;\n  }\n\n  .pb-xl-11 {\n    padding-bottom: 2.75rem !important;\n  }\n\n  .pb-xl-12 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pb-xl-13 {\n    padding-bottom: 3.25rem !important;\n  }\n\n  .pb-xl-14 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-xl-15 {\n    padding-bottom: 3.75rem !important;\n  }\n\n  .pb-xl-16 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-xl-17 {\n    padding-bottom: 4.25rem !important;\n  }\n\n  .pb-xl-18 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-xl-19 {\n    padding-bottom: 4.75rem !important;\n  }\n\n  .pb-xl-20 {\n    padding-bottom: 5rem !important;\n  }\n\n  .ps-xl-0 {\n    padding-left: 0 !important;\n  }\n\n  .ps-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-xl-3 {\n    padding-left: 0.75rem !important;\n  }\n\n  .ps-xl-4 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-xl-5 {\n    padding-left: 1.25rem !important;\n  }\n\n  .ps-xl-6 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-xl-7 {\n    padding-left: 1.75rem !important;\n  }\n\n  .ps-xl-8 {\n    padding-left: 2rem !important;\n  }\n\n  .ps-xl-9 {\n    padding-left: 2.25rem !important;\n  }\n\n  .ps-xl-10 {\n    padding-left: 2.5rem !important;\n  }\n\n  .ps-xl-11 {\n    padding-left: 2.75rem !important;\n  }\n\n  .ps-xl-12 {\n    padding-left: 3rem !important;\n  }\n\n  .ps-xl-13 {\n    padding-left: 3.25rem !important;\n  }\n\n  .ps-xl-14 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-xl-15 {\n    padding-left: 3.75rem !important;\n  }\n\n  .ps-xl-16 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-xl-17 {\n    padding-left: 4.25rem !important;\n  }\n\n  .ps-xl-18 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-xl-19 {\n    padding-left: 4.75rem !important;\n  }\n\n  .ps-xl-20 {\n    padding-left: 5rem !important;\n  }\n\n  .gap-xl-0 {\n    gap: 0 !important;\n  }\n\n  .gap-xl-1 {\n    gap: 0.25rem !important;\n  }\n\n  .gap-xl-2 {\n    gap: 0.5rem !important;\n  }\n\n  .gap-xl-3 {\n    gap: 0.75rem !important;\n  }\n\n  .gap-xl-4 {\n    gap: 1rem !important;\n  }\n\n  .gap-xl-5 {\n    gap: 1.25rem !important;\n  }\n\n  .gap-xl-6 {\n    gap: 1.5rem !important;\n  }\n\n  .gap-xl-7 {\n    gap: 1.75rem !important;\n  }\n\n  .gap-xl-8 {\n    gap: 2rem !important;\n  }\n\n  .gap-xl-9 {\n    gap: 2.25rem !important;\n  }\n\n  .gap-xl-10 {\n    gap: 2.5rem !important;\n  }\n\n  .gap-xl-11 {\n    gap: 2.75rem !important;\n  }\n\n  .gap-xl-12 {\n    gap: 3rem !important;\n  }\n\n  .gap-xl-13 {\n    gap: 3.25rem !important;\n  }\n\n  .gap-xl-14 {\n    gap: 3.5rem !important;\n  }\n\n  .gap-xl-15 {\n    gap: 3.75rem !important;\n  }\n\n  .gap-xl-16 {\n    gap: 4rem !important;\n  }\n\n  .gap-xl-17 {\n    gap: 4.25rem !important;\n  }\n\n  .gap-xl-18 {\n    gap: 4.5rem !important;\n  }\n\n  .gap-xl-19 {\n    gap: 4.75rem !important;\n  }\n\n  .gap-xl-20 {\n    gap: 5rem !important;\n  }\n\n  .row-gap-xl-0 {\n    row-gap: 0 !important;\n  }\n\n  .row-gap-xl-1 {\n    row-gap: 0.25rem !important;\n  }\n\n  .row-gap-xl-2 {\n    row-gap: 0.5rem !important;\n  }\n\n  .row-gap-xl-3 {\n    row-gap: 0.75rem !important;\n  }\n\n  .row-gap-xl-4 {\n    row-gap: 1rem !important;\n  }\n\n  .row-gap-xl-5 {\n    row-gap: 1.25rem !important;\n  }\n\n  .row-gap-xl-6 {\n    row-gap: 1.5rem !important;\n  }\n\n  .row-gap-xl-7 {\n    row-gap: 1.75rem !important;\n  }\n\n  .row-gap-xl-8 {\n    row-gap: 2rem !important;\n  }\n\n  .row-gap-xl-9 {\n    row-gap: 2.25rem !important;\n  }\n\n  .row-gap-xl-10 {\n    row-gap: 2.5rem !important;\n  }\n\n  .row-gap-xl-11 {\n    row-gap: 2.75rem !important;\n  }\n\n  .row-gap-xl-12 {\n    row-gap: 3rem !important;\n  }\n\n  .row-gap-xl-13 {\n    row-gap: 3.25rem !important;\n  }\n\n  .row-gap-xl-14 {\n    row-gap: 3.5rem !important;\n  }\n\n  .row-gap-xl-15 {\n    row-gap: 3.75rem !important;\n  }\n\n  .row-gap-xl-16 {\n    row-gap: 4rem !important;\n  }\n\n  .row-gap-xl-17 {\n    row-gap: 4.25rem !important;\n  }\n\n  .row-gap-xl-18 {\n    row-gap: 4.5rem !important;\n  }\n\n  .row-gap-xl-19 {\n    row-gap: 4.75rem !important;\n  }\n\n  .row-gap-xl-20 {\n    row-gap: 5rem !important;\n  }\n\n  .column-gap-xl-0 {\n    column-gap: 0 !important;\n  }\n\n  .column-gap-xl-1 {\n    column-gap: 0.25rem !important;\n  }\n\n  .column-gap-xl-2 {\n    column-gap: 0.5rem !important;\n  }\n\n  .column-gap-xl-3 {\n    column-gap: 0.75rem !important;\n  }\n\n  .column-gap-xl-4 {\n    column-gap: 1rem !important;\n  }\n\n  .column-gap-xl-5 {\n    column-gap: 1.25rem !important;\n  }\n\n  .column-gap-xl-6 {\n    column-gap: 1.5rem !important;\n  }\n\n  .column-gap-xl-7 {\n    column-gap: 1.75rem !important;\n  }\n\n  .column-gap-xl-8 {\n    column-gap: 2rem !important;\n  }\n\n  .column-gap-xl-9 {\n    column-gap: 2.25rem !important;\n  }\n\n  .column-gap-xl-10 {\n    column-gap: 2.5rem !important;\n  }\n\n  .column-gap-xl-11 {\n    column-gap: 2.75rem !important;\n  }\n\n  .column-gap-xl-12 {\n    column-gap: 3rem !important;\n  }\n\n  .column-gap-xl-13 {\n    column-gap: 3.25rem !important;\n  }\n\n  .column-gap-xl-14 {\n    column-gap: 3.5rem !important;\n  }\n\n  .column-gap-xl-15 {\n    column-gap: 3.75rem !important;\n  }\n\n  .column-gap-xl-16 {\n    column-gap: 4rem !important;\n  }\n\n  .column-gap-xl-17 {\n    column-gap: 4.25rem !important;\n  }\n\n  .column-gap-xl-18 {\n    column-gap: 4.5rem !important;\n  }\n\n  .column-gap-xl-19 {\n    column-gap: 4.75rem !important;\n  }\n\n  .column-gap-xl-20 {\n    column-gap: 5rem !important;\n  }\n\n  .text-xl-start {\n    text-align: left !important;\n  }\n\n  .text-xl-end {\n    text-align: right !important;\n  }\n\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1400px) {\n  .float-xxl-start {\n    float: left !important;\n  }\n\n  .float-xxl-end {\n    float: right !important;\n  }\n\n  .float-xxl-none {\n    float: none !important;\n  }\n\n  .object-fit-xxl-contain {\n    object-fit: contain !important;\n  }\n\n  .object-fit-xxl-cover {\n    object-fit: cover !important;\n  }\n\n  .object-fit-xxl-fill {\n    object-fit: fill !important;\n  }\n\n  .object-fit-xxl-scale {\n    object-fit: scale-down !important;\n  }\n\n  .object-fit-xxl-none {\n    object-fit: none !important;\n  }\n\n  .d-xxl-inline {\n    display: inline !important;\n  }\n\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-xxl-block {\n    display: block !important;\n  }\n\n  .d-xxl-grid {\n    display: grid !important;\n  }\n\n  .d-xxl-inline-grid {\n    display: inline-grid !important;\n  }\n\n  .d-xxl-table {\n    display: table !important;\n  }\n\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-xxl-flex {\n    display: flex !important;\n  }\n\n  .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-xxl-none {\n    display: none !important;\n  }\n\n  .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-xxl-row {\n    flex-direction: row !important;\n  }\n\n  .flex-xxl-column {\n    flex-direction: column !important;\n  }\n\n  .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .justify-content-xxl-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-xxl-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-xxl-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-xxl-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-xxl-around {\n    justify-content: space-around !important;\n  }\n\n  .justify-content-xxl-evenly {\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-xxl-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-xxl-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-xxl-center {\n    align-items: center !important;\n  }\n\n  .align-items-xxl-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-xxl-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-xxl-center {\n    align-content: center !important;\n  }\n\n  .align-content-xxl-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-xxl-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-xxl-center {\n    align-self: center !important;\n  }\n\n  .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n\n  .order-xxl-first {\n    order: -1 !important;\n  }\n\n  .order-xxl-0 {\n    order: 0 !important;\n  }\n\n  .order-xxl-1 {\n    order: 1 !important;\n  }\n\n  .order-xxl-2 {\n    order: 2 !important;\n  }\n\n  .order-xxl-3 {\n    order: 3 !important;\n  }\n\n  .order-xxl-4 {\n    order: 4 !important;\n  }\n\n  .order-xxl-5 {\n    order: 5 !important;\n  }\n\n  .order-xxl-last {\n    order: 6 !important;\n  }\n\n  .m-xxl-0 {\n    margin: 0 !important;\n  }\n\n  .m-xxl-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-xxl-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-xxl-3 {\n    margin: 0.75rem !important;\n  }\n\n  .m-xxl-4 {\n    margin: 1rem !important;\n  }\n\n  .m-xxl-5 {\n    margin: 1.25rem !important;\n  }\n\n  .m-xxl-6 {\n    margin: 1.5rem !important;\n  }\n\n  .m-xxl-7 {\n    margin: 1.75rem !important;\n  }\n\n  .m-xxl-8 {\n    margin: 2rem !important;\n  }\n\n  .m-xxl-9 {\n    margin: 2.25rem !important;\n  }\n\n  .m-xxl-10 {\n    margin: 2.5rem !important;\n  }\n\n  .m-xxl-11 {\n    margin: 2.75rem !important;\n  }\n\n  .m-xxl-12 {\n    margin: 3rem !important;\n  }\n\n  .m-xxl-13 {\n    margin: 3.25rem !important;\n  }\n\n  .m-xxl-14 {\n    margin: 3.5rem !important;\n  }\n\n  .m-xxl-15 {\n    margin: 3.75rem !important;\n  }\n\n  .m-xxl-16 {\n    margin: 4rem !important;\n  }\n\n  .m-xxl-17 {\n    margin: 4.25rem !important;\n  }\n\n  .m-xxl-18 {\n    margin: 4.5rem !important;\n  }\n\n  .m-xxl-19 {\n    margin: 4.75rem !important;\n  }\n\n  .m-xxl-20 {\n    margin: 5rem !important;\n  }\n\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n\n  .mx-xxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .mx-xxl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .mx-xxl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .mx-xxl-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n\n  .mx-xxl-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n\n  .mx-xxl-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n\n  .mx-xxl-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .mx-xxl-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n\n  .mx-xxl-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n\n  .mx-xxl-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n\n  .mx-xxl-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n\n  .mx-xxl-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n\n  .mx-xxl-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n\n  .mx-xxl-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n\n  .mx-xxl-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n\n  .mx-xxl-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n\n  .mx-xxl-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n\n  .mx-xxl-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n\n  .mx-xxl-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n\n  .mx-xxl-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n\n  .mx-xxl-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n\n  .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-xxl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .my-xxl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-xxl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-xxl-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n\n  .my-xxl-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-xxl-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n\n  .my-xxl-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-xxl-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n\n  .my-xxl-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n\n  .my-xxl-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n\n  .my-xxl-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n\n  .my-xxl-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n\n  .my-xxl-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-xxl-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n\n  .my-xxl-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-xxl-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n\n  .my-xxl-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-xxl-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n\n  .my-xxl-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-xxl-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n\n  .my-xxl-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-xxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-xxl-0 {\n    margin-top: 0 !important;\n  }\n\n  .mt-xxl-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-xxl-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-xxl-3 {\n    margin-top: 0.75rem !important;\n  }\n\n  .mt-xxl-4 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-xxl-5 {\n    margin-top: 1.25rem !important;\n  }\n\n  .mt-xxl-6 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-xxl-7 {\n    margin-top: 1.75rem !important;\n  }\n\n  .mt-xxl-8 {\n    margin-top: 2rem !important;\n  }\n\n  .mt-xxl-9 {\n    margin-top: 2.25rem !important;\n  }\n\n  .mt-xxl-10 {\n    margin-top: 2.5rem !important;\n  }\n\n  .mt-xxl-11 {\n    margin-top: 2.75rem !important;\n  }\n\n  .mt-xxl-12 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-xxl-13 {\n    margin-top: 3.25rem !important;\n  }\n\n  .mt-xxl-14 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-xxl-15 {\n    margin-top: 3.75rem !important;\n  }\n\n  .mt-xxl-16 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-xxl-17 {\n    margin-top: 4.25rem !important;\n  }\n\n  .mt-xxl-18 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-xxl-19 {\n    margin-top: 4.75rem !important;\n  }\n\n  .mt-xxl-20 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-xxl-auto {\n    margin-top: auto !important;\n  }\n\n  .me-xxl-0 {\n    margin-right: 0 !important;\n  }\n\n  .me-xxl-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-xxl-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-xxl-3 {\n    margin-right: 0.75rem !important;\n  }\n\n  .me-xxl-4 {\n    margin-right: 1rem !important;\n  }\n\n  .me-xxl-5 {\n    margin-right: 1.25rem !important;\n  }\n\n  .me-xxl-6 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-xxl-7 {\n    margin-right: 1.75rem !important;\n  }\n\n  .me-xxl-8 {\n    margin-right: 2rem !important;\n  }\n\n  .me-xxl-9 {\n    margin-right: 2.25rem !important;\n  }\n\n  .me-xxl-10 {\n    margin-right: 2.5rem !important;\n  }\n\n  .me-xxl-11 {\n    margin-right: 2.75rem !important;\n  }\n\n  .me-xxl-12 {\n    margin-right: 3rem !important;\n  }\n\n  .me-xxl-13 {\n    margin-right: 3.25rem !important;\n  }\n\n  .me-xxl-14 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-xxl-15 {\n    margin-right: 3.75rem !important;\n  }\n\n  .me-xxl-16 {\n    margin-right: 4rem !important;\n  }\n\n  .me-xxl-17 {\n    margin-right: 4.25rem !important;\n  }\n\n  .me-xxl-18 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-xxl-19 {\n    margin-right: 4.75rem !important;\n  }\n\n  .me-xxl-20 {\n    margin-right: 5rem !important;\n  }\n\n  .me-xxl-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .mb-xxl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-xxl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-xxl-3 {\n    margin-bottom: 0.75rem !important;\n  }\n\n  .mb-xxl-4 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-xxl-5 {\n    margin-bottom: 1.25rem !important;\n  }\n\n  .mb-xxl-6 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-xxl-7 {\n    margin-bottom: 1.75rem !important;\n  }\n\n  .mb-xxl-8 {\n    margin-bottom: 2rem !important;\n  }\n\n  .mb-xxl-9 {\n    margin-bottom: 2.25rem !important;\n  }\n\n  .mb-xxl-10 {\n    margin-bottom: 2.5rem !important;\n  }\n\n  .mb-xxl-11 {\n    margin-bottom: 2.75rem !important;\n  }\n\n  .mb-xxl-12 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-xxl-13 {\n    margin-bottom: 3.25rem !important;\n  }\n\n  .mb-xxl-14 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-xxl-15 {\n    margin-bottom: 3.75rem !important;\n  }\n\n  .mb-xxl-16 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-xxl-17 {\n    margin-bottom: 4.25rem !important;\n  }\n\n  .mb-xxl-18 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-xxl-19 {\n    margin-bottom: 4.75rem !important;\n  }\n\n  .mb-xxl-20 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-xxl-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-xxl-0 {\n    margin-left: 0 !important;\n  }\n\n  .ms-xxl-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-xxl-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-xxl-3 {\n    margin-left: 0.75rem !important;\n  }\n\n  .ms-xxl-4 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-xxl-5 {\n    margin-left: 1.25rem !important;\n  }\n\n  .ms-xxl-6 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-xxl-7 {\n    margin-left: 1.75rem !important;\n  }\n\n  .ms-xxl-8 {\n    margin-left: 2rem !important;\n  }\n\n  .ms-xxl-9 {\n    margin-left: 2.25rem !important;\n  }\n\n  .ms-xxl-10 {\n    margin-left: 2.5rem !important;\n  }\n\n  .ms-xxl-11 {\n    margin-left: 2.75rem !important;\n  }\n\n  .ms-xxl-12 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-xxl-13 {\n    margin-left: 3.25rem !important;\n  }\n\n  .ms-xxl-14 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-xxl-15 {\n    margin-left: 3.75rem !important;\n  }\n\n  .ms-xxl-16 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-xxl-17 {\n    margin-left: 4.25rem !important;\n  }\n\n  .ms-xxl-18 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-xxl-19 {\n    margin-left: 4.75rem !important;\n  }\n\n  .ms-xxl-20 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-xxl-auto {\n    margin-left: auto !important;\n  }\n\n  .m-xxl-n1 {\n    margin: -0.25rem !important;\n  }\n\n  .m-xxl-n2 {\n    margin: -0.5rem !important;\n  }\n\n  .m-xxl-n3 {\n    margin: -0.75rem !important;\n  }\n\n  .m-xxl-n4 {\n    margin: -1rem !important;\n  }\n\n  .m-xxl-n5 {\n    margin: -1.25rem !important;\n  }\n\n  .m-xxl-n6 {\n    margin: -1.5rem !important;\n  }\n\n  .m-xxl-n7 {\n    margin: -1.75rem !important;\n  }\n\n  .m-xxl-n8 {\n    margin: -2rem !important;\n  }\n\n  .m-xxl-n9 {\n    margin: -2.25rem !important;\n  }\n\n  .m-xxl-n10 {\n    margin: -2.5rem !important;\n  }\n\n  .m-xxl-n11 {\n    margin: -2.75rem !important;\n  }\n\n  .m-xxl-n12 {\n    margin: -3rem !important;\n  }\n\n  .m-xxl-n13 {\n    margin: -3.25rem !important;\n  }\n\n  .m-xxl-n14 {\n    margin: -3.5rem !important;\n  }\n\n  .m-xxl-n15 {\n    margin: -3.75rem !important;\n  }\n\n  .m-xxl-n16 {\n    margin: -4rem !important;\n  }\n\n  .m-xxl-n17 {\n    margin: -4.25rem !important;\n  }\n\n  .m-xxl-n18 {\n    margin: -4.5rem !important;\n  }\n\n  .m-xxl-n19 {\n    margin: -4.75rem !important;\n  }\n\n  .m-xxl-n20 {\n    margin: -5rem !important;\n  }\n\n  .mx-xxl-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n\n  .mx-xxl-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n\n  .mx-xxl-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n\n  .mx-xxl-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n\n  .mx-xxl-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n\n  .mx-xxl-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n\n  .mx-xxl-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n\n  .mx-xxl-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n\n  .mx-xxl-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n\n  .mx-xxl-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n\n  .mx-xxl-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n\n  .mx-xxl-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n\n  .mx-xxl-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n\n  .mx-xxl-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n\n  .mx-xxl-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n\n  .mx-xxl-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n\n  .mx-xxl-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n\n  .mx-xxl-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n\n  .mx-xxl-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n\n  .mx-xxl-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n\n  .my-xxl-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n\n  .my-xxl-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n\n  .my-xxl-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n\n  .my-xxl-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n\n  .my-xxl-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n\n  .my-xxl-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n\n  .my-xxl-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n\n  .my-xxl-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n\n  .my-xxl-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n\n  .my-xxl-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n\n  .my-xxl-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n\n  .my-xxl-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n\n  .my-xxl-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n\n  .my-xxl-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n\n  .my-xxl-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n\n  .my-xxl-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n\n  .my-xxl-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n\n  .my-xxl-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n\n  .my-xxl-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n\n  .my-xxl-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n\n  .mt-xxl-n1 {\n    margin-top: -0.25rem !important;\n  }\n\n  .mt-xxl-n2 {\n    margin-top: -0.5rem !important;\n  }\n\n  .mt-xxl-n3 {\n    margin-top: -0.75rem !important;\n  }\n\n  .mt-xxl-n4 {\n    margin-top: -1rem !important;\n  }\n\n  .mt-xxl-n5 {\n    margin-top: -1.25rem !important;\n  }\n\n  .mt-xxl-n6 {\n    margin-top: -1.5rem !important;\n  }\n\n  .mt-xxl-n7 {\n    margin-top: -1.75rem !important;\n  }\n\n  .mt-xxl-n8 {\n    margin-top: -2rem !important;\n  }\n\n  .mt-xxl-n9 {\n    margin-top: -2.25rem !important;\n  }\n\n  .mt-xxl-n10 {\n    margin-top: -2.5rem !important;\n  }\n\n  .mt-xxl-n11 {\n    margin-top: -2.75rem !important;\n  }\n\n  .mt-xxl-n12 {\n    margin-top: -3rem !important;\n  }\n\n  .mt-xxl-n13 {\n    margin-top: -3.25rem !important;\n  }\n\n  .mt-xxl-n14 {\n    margin-top: -3.5rem !important;\n  }\n\n  .mt-xxl-n15 {\n    margin-top: -3.75rem !important;\n  }\n\n  .mt-xxl-n16 {\n    margin-top: -4rem !important;\n  }\n\n  .mt-xxl-n17 {\n    margin-top: -4.25rem !important;\n  }\n\n  .mt-xxl-n18 {\n    margin-top: -4.5rem !important;\n  }\n\n  .mt-xxl-n19 {\n    margin-top: -4.75rem !important;\n  }\n\n  .mt-xxl-n20 {\n    margin-top: -5rem !important;\n  }\n\n  .me-xxl-n1 {\n    margin-right: -0.25rem !important;\n  }\n\n  .me-xxl-n2 {\n    margin-right: -0.5rem !important;\n  }\n\n  .me-xxl-n3 {\n    margin-right: -0.75rem !important;\n  }\n\n  .me-xxl-n4 {\n    margin-right: -1rem !important;\n  }\n\n  .me-xxl-n5 {\n    margin-right: -1.25rem !important;\n  }\n\n  .me-xxl-n6 {\n    margin-right: -1.5rem !important;\n  }\n\n  .me-xxl-n7 {\n    margin-right: -1.75rem !important;\n  }\n\n  .me-xxl-n8 {\n    margin-right: -2rem !important;\n  }\n\n  .me-xxl-n9 {\n    margin-right: -2.25rem !important;\n  }\n\n  .me-xxl-n10 {\n    margin-right: -2.5rem !important;\n  }\n\n  .me-xxl-n11 {\n    margin-right: -2.75rem !important;\n  }\n\n  .me-xxl-n12 {\n    margin-right: -3rem !important;\n  }\n\n  .me-xxl-n13 {\n    margin-right: -3.25rem !important;\n  }\n\n  .me-xxl-n14 {\n    margin-right: -3.5rem !important;\n  }\n\n  .me-xxl-n15 {\n    margin-right: -3.75rem !important;\n  }\n\n  .me-xxl-n16 {\n    margin-right: -4rem !important;\n  }\n\n  .me-xxl-n17 {\n    margin-right: -4.25rem !important;\n  }\n\n  .me-xxl-n18 {\n    margin-right: -4.5rem !important;\n  }\n\n  .me-xxl-n19 {\n    margin-right: -4.75rem !important;\n  }\n\n  .me-xxl-n20 {\n    margin-right: -5rem !important;\n  }\n\n  .mb-xxl-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n\n  .mb-xxl-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n\n  .mb-xxl-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n\n  .mb-xxl-n4 {\n    margin-bottom: -1rem !important;\n  }\n\n  .mb-xxl-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n\n  .mb-xxl-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n\n  .mb-xxl-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n\n  .mb-xxl-n8 {\n    margin-bottom: -2rem !important;\n  }\n\n  .mb-xxl-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n\n  .mb-xxl-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n\n  .mb-xxl-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n\n  .mb-xxl-n12 {\n    margin-bottom: -3rem !important;\n  }\n\n  .mb-xxl-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n\n  .mb-xxl-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n\n  .mb-xxl-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n\n  .mb-xxl-n16 {\n    margin-bottom: -4rem !important;\n  }\n\n  .mb-xxl-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n\n  .mb-xxl-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n\n  .mb-xxl-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n\n  .mb-xxl-n20 {\n    margin-bottom: -5rem !important;\n  }\n\n  .ms-xxl-n1 {\n    margin-left: -0.25rem !important;\n  }\n\n  .ms-xxl-n2 {\n    margin-left: -0.5rem !important;\n  }\n\n  .ms-xxl-n3 {\n    margin-left: -0.75rem !important;\n  }\n\n  .ms-xxl-n4 {\n    margin-left: -1rem !important;\n  }\n\n  .ms-xxl-n5 {\n    margin-left: -1.25rem !important;\n  }\n\n  .ms-xxl-n6 {\n    margin-left: -1.5rem !important;\n  }\n\n  .ms-xxl-n7 {\n    margin-left: -1.75rem !important;\n  }\n\n  .ms-xxl-n8 {\n    margin-left: -2rem !important;\n  }\n\n  .ms-xxl-n9 {\n    margin-left: -2.25rem !important;\n  }\n\n  .ms-xxl-n10 {\n    margin-left: -2.5rem !important;\n  }\n\n  .ms-xxl-n11 {\n    margin-left: -2.75rem !important;\n  }\n\n  .ms-xxl-n12 {\n    margin-left: -3rem !important;\n  }\n\n  .ms-xxl-n13 {\n    margin-left: -3.25rem !important;\n  }\n\n  .ms-xxl-n14 {\n    margin-left: -3.5rem !important;\n  }\n\n  .ms-xxl-n15 {\n    margin-left: -3.75rem !important;\n  }\n\n  .ms-xxl-n16 {\n    margin-left: -4rem !important;\n  }\n\n  .ms-xxl-n17 {\n    margin-left: -4.25rem !important;\n  }\n\n  .ms-xxl-n18 {\n    margin-left: -4.5rem !important;\n  }\n\n  .ms-xxl-n19 {\n    margin-left: -4.75rem !important;\n  }\n\n  .ms-xxl-n20 {\n    margin-left: -5rem !important;\n  }\n\n  .p-xxl-0 {\n    padding: 0 !important;\n  }\n\n  .p-xxl-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-xxl-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-xxl-3 {\n    padding: 0.75rem !important;\n  }\n\n  .p-xxl-4 {\n    padding: 1rem !important;\n  }\n\n  .p-xxl-5 {\n    padding: 1.25rem !important;\n  }\n\n  .p-xxl-6 {\n    padding: 1.5rem !important;\n  }\n\n  .p-xxl-7 {\n    padding: 1.75rem !important;\n  }\n\n  .p-xxl-8 {\n    padding: 2rem !important;\n  }\n\n  .p-xxl-9 {\n    padding: 2.25rem !important;\n  }\n\n  .p-xxl-10 {\n    padding: 2.5rem !important;\n  }\n\n  .p-xxl-11 {\n    padding: 2.75rem !important;\n  }\n\n  .p-xxl-12 {\n    padding: 3rem !important;\n  }\n\n  .p-xxl-13 {\n    padding: 3.25rem !important;\n  }\n\n  .p-xxl-14 {\n    padding: 3.5rem !important;\n  }\n\n  .p-xxl-15 {\n    padding: 3.75rem !important;\n  }\n\n  .p-xxl-16 {\n    padding: 4rem !important;\n  }\n\n  .p-xxl-17 {\n    padding: 4.25rem !important;\n  }\n\n  .p-xxl-18 {\n    padding: 4.5rem !important;\n  }\n\n  .p-xxl-19 {\n    padding: 4.75rem !important;\n  }\n\n  .p-xxl-20 {\n    padding: 5rem !important;\n  }\n\n  .px-xxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .px-xxl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .px-xxl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .px-xxl-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n\n  .px-xxl-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n\n  .px-xxl-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n\n  .px-xxl-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .px-xxl-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n\n  .px-xxl-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n\n  .px-xxl-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n\n  .px-xxl-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n\n  .px-xxl-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n\n  .px-xxl-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n\n  .px-xxl-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n\n  .px-xxl-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n\n  .px-xxl-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n\n  .px-xxl-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n\n  .px-xxl-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n\n  .px-xxl-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n\n  .px-xxl-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n\n  .px-xxl-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n\n  .py-xxl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n\n  .py-xxl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-xxl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-xxl-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n\n  .py-xxl-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-xxl-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n\n  .py-xxl-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-xxl-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n\n  .py-xxl-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n\n  .py-xxl-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n\n  .py-xxl-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n\n  .py-xxl-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n\n  .py-xxl-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .py-xxl-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n\n  .py-xxl-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-xxl-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n\n  .py-xxl-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-xxl-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n\n  .py-xxl-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-xxl-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n\n  .py-xxl-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .pt-xxl-0 {\n    padding-top: 0 !important;\n  }\n\n  .pt-xxl-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-xxl-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-xxl-3 {\n    padding-top: 0.75rem !important;\n  }\n\n  .pt-xxl-4 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-xxl-5 {\n    padding-top: 1.25rem !important;\n  }\n\n  .pt-xxl-6 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-xxl-7 {\n    padding-top: 1.75rem !important;\n  }\n\n  .pt-xxl-8 {\n    padding-top: 2rem !important;\n  }\n\n  .pt-xxl-9 {\n    padding-top: 2.25rem !important;\n  }\n\n  .pt-xxl-10 {\n    padding-top: 2.5rem !important;\n  }\n\n  .pt-xxl-11 {\n    padding-top: 2.75rem !important;\n  }\n\n  .pt-xxl-12 {\n    padding-top: 3rem !important;\n  }\n\n  .pt-xxl-13 {\n    padding-top: 3.25rem !important;\n  }\n\n  .pt-xxl-14 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-xxl-15 {\n    padding-top: 3.75rem !important;\n  }\n\n  .pt-xxl-16 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-xxl-17 {\n    padding-top: 4.25rem !important;\n  }\n\n  .pt-xxl-18 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-xxl-19 {\n    padding-top: 4.75rem !important;\n  }\n\n  .pt-xxl-20 {\n    padding-top: 5rem !important;\n  }\n\n  .pe-xxl-0 {\n    padding-right: 0 !important;\n  }\n\n  .pe-xxl-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-xxl-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-xxl-3 {\n    padding-right: 0.75rem !important;\n  }\n\n  .pe-xxl-4 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-xxl-5 {\n    padding-right: 1.25rem !important;\n  }\n\n  .pe-xxl-6 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-xxl-7 {\n    padding-right: 1.75rem !important;\n  }\n\n  .pe-xxl-8 {\n    padding-right: 2rem !important;\n  }\n\n  .pe-xxl-9 {\n    padding-right: 2.25rem !important;\n  }\n\n  .pe-xxl-10 {\n    padding-right: 2.5rem !important;\n  }\n\n  .pe-xxl-11 {\n    padding-right: 2.75rem !important;\n  }\n\n  .pe-xxl-12 {\n    padding-right: 3rem !important;\n  }\n\n  .pe-xxl-13 {\n    padding-right: 3.25rem !important;\n  }\n\n  .pe-xxl-14 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-xxl-15 {\n    padding-right: 3.75rem !important;\n  }\n\n  .pe-xxl-16 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-xxl-17 {\n    padding-right: 4.25rem !important;\n  }\n\n  .pe-xxl-18 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-xxl-19 {\n    padding-right: 4.75rem !important;\n  }\n\n  .pe-xxl-20 {\n    padding-right: 5rem !important;\n  }\n\n  .pb-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pb-xxl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-xxl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-xxl-3 {\n    padding-bottom: 0.75rem !important;\n  }\n\n  .pb-xxl-4 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-xxl-5 {\n    padding-bottom: 1.25rem !important;\n  }\n\n  .pb-xxl-6 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-xxl-7 {\n    padding-bottom: 1.75rem !important;\n  }\n\n  .pb-xxl-8 {\n    padding-bottom: 2rem !important;\n  }\n\n  .pb-xxl-9 {\n    padding-bottom: 2.25rem !important;\n  }\n\n  .pb-xxl-10 {\n    padding-bottom: 2.5rem !important;\n  }\n\n  .pb-xxl-11 {\n    padding-bottom: 2.75rem !important;\n  }\n\n  .pb-xxl-12 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pb-xxl-13 {\n    padding-bottom: 3.25rem !important;\n  }\n\n  .pb-xxl-14 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-xxl-15 {\n    padding-bottom: 3.75rem !important;\n  }\n\n  .pb-xxl-16 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-xxl-17 {\n    padding-bottom: 4.25rem !important;\n  }\n\n  .pb-xxl-18 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-xxl-19 {\n    padding-bottom: 4.75rem !important;\n  }\n\n  .pb-xxl-20 {\n    padding-bottom: 5rem !important;\n  }\n\n  .ps-xxl-0 {\n    padding-left: 0 !important;\n  }\n\n  .ps-xxl-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-xxl-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-xxl-3 {\n    padding-left: 0.75rem !important;\n  }\n\n  .ps-xxl-4 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-xxl-5 {\n    padding-left: 1.25rem !important;\n  }\n\n  .ps-xxl-6 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-xxl-7 {\n    padding-left: 1.75rem !important;\n  }\n\n  .ps-xxl-8 {\n    padding-left: 2rem !important;\n  }\n\n  .ps-xxl-9 {\n    padding-left: 2.25rem !important;\n  }\n\n  .ps-xxl-10 {\n    padding-left: 2.5rem !important;\n  }\n\n  .ps-xxl-11 {\n    padding-left: 2.75rem !important;\n  }\n\n  .ps-xxl-12 {\n    padding-left: 3rem !important;\n  }\n\n  .ps-xxl-13 {\n    padding-left: 3.25rem !important;\n  }\n\n  .ps-xxl-14 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-xxl-15 {\n    padding-left: 3.75rem !important;\n  }\n\n  .ps-xxl-16 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-xxl-17 {\n    padding-left: 4.25rem !important;\n  }\n\n  .ps-xxl-18 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-xxl-19 {\n    padding-left: 4.75rem !important;\n  }\n\n  .ps-xxl-20 {\n    padding-left: 5rem !important;\n  }\n\n  .gap-xxl-0 {\n    gap: 0 !important;\n  }\n\n  .gap-xxl-1 {\n    gap: 0.25rem !important;\n  }\n\n  .gap-xxl-2 {\n    gap: 0.5rem !important;\n  }\n\n  .gap-xxl-3 {\n    gap: 0.75rem !important;\n  }\n\n  .gap-xxl-4 {\n    gap: 1rem !important;\n  }\n\n  .gap-xxl-5 {\n    gap: 1.25rem !important;\n  }\n\n  .gap-xxl-6 {\n    gap: 1.5rem !important;\n  }\n\n  .gap-xxl-7 {\n    gap: 1.75rem !important;\n  }\n\n  .gap-xxl-8 {\n    gap: 2rem !important;\n  }\n\n  .gap-xxl-9 {\n    gap: 2.25rem !important;\n  }\n\n  .gap-xxl-10 {\n    gap: 2.5rem !important;\n  }\n\n  .gap-xxl-11 {\n    gap: 2.75rem !important;\n  }\n\n  .gap-xxl-12 {\n    gap: 3rem !important;\n  }\n\n  .gap-xxl-13 {\n    gap: 3.25rem !important;\n  }\n\n  .gap-xxl-14 {\n    gap: 3.5rem !important;\n  }\n\n  .gap-xxl-15 {\n    gap: 3.75rem !important;\n  }\n\n  .gap-xxl-16 {\n    gap: 4rem !important;\n  }\n\n  .gap-xxl-17 {\n    gap: 4.25rem !important;\n  }\n\n  .gap-xxl-18 {\n    gap: 4.5rem !important;\n  }\n\n  .gap-xxl-19 {\n    gap: 4.75rem !important;\n  }\n\n  .gap-xxl-20 {\n    gap: 5rem !important;\n  }\n\n  .row-gap-xxl-0 {\n    row-gap: 0 !important;\n  }\n\n  .row-gap-xxl-1 {\n    row-gap: 0.25rem !important;\n  }\n\n  .row-gap-xxl-2 {\n    row-gap: 0.5rem !important;\n  }\n\n  .row-gap-xxl-3 {\n    row-gap: 0.75rem !important;\n  }\n\n  .row-gap-xxl-4 {\n    row-gap: 1rem !important;\n  }\n\n  .row-gap-xxl-5 {\n    row-gap: 1.25rem !important;\n  }\n\n  .row-gap-xxl-6 {\n    row-gap: 1.5rem !important;\n  }\n\n  .row-gap-xxl-7 {\n    row-gap: 1.75rem !important;\n  }\n\n  .row-gap-xxl-8 {\n    row-gap: 2rem !important;\n  }\n\n  .row-gap-xxl-9 {\n    row-gap: 2.25rem !important;\n  }\n\n  .row-gap-xxl-10 {\n    row-gap: 2.5rem !important;\n  }\n\n  .row-gap-xxl-11 {\n    row-gap: 2.75rem !important;\n  }\n\n  .row-gap-xxl-12 {\n    row-gap: 3rem !important;\n  }\n\n  .row-gap-xxl-13 {\n    row-gap: 3.25rem !important;\n  }\n\n  .row-gap-xxl-14 {\n    row-gap: 3.5rem !important;\n  }\n\n  .row-gap-xxl-15 {\n    row-gap: 3.75rem !important;\n  }\n\n  .row-gap-xxl-16 {\n    row-gap: 4rem !important;\n  }\n\n  .row-gap-xxl-17 {\n    row-gap: 4.25rem !important;\n  }\n\n  .row-gap-xxl-18 {\n    row-gap: 4.5rem !important;\n  }\n\n  .row-gap-xxl-19 {\n    row-gap: 4.75rem !important;\n  }\n\n  .row-gap-xxl-20 {\n    row-gap: 5rem !important;\n  }\n\n  .column-gap-xxl-0 {\n    column-gap: 0 !important;\n  }\n\n  .column-gap-xxl-1 {\n    column-gap: 0.25rem !important;\n  }\n\n  .column-gap-xxl-2 {\n    column-gap: 0.5rem !important;\n  }\n\n  .column-gap-xxl-3 {\n    column-gap: 0.75rem !important;\n  }\n\n  .column-gap-xxl-4 {\n    column-gap: 1rem !important;\n  }\n\n  .column-gap-xxl-5 {\n    column-gap: 1.25rem !important;\n  }\n\n  .column-gap-xxl-6 {\n    column-gap: 1.5rem !important;\n  }\n\n  .column-gap-xxl-7 {\n    column-gap: 1.75rem !important;\n  }\n\n  .column-gap-xxl-8 {\n    column-gap: 2rem !important;\n  }\n\n  .column-gap-xxl-9 {\n    column-gap: 2.25rem !important;\n  }\n\n  .column-gap-xxl-10 {\n    column-gap: 2.5rem !important;\n  }\n\n  .column-gap-xxl-11 {\n    column-gap: 2.75rem !important;\n  }\n\n  .column-gap-xxl-12 {\n    column-gap: 3rem !important;\n  }\n\n  .column-gap-xxl-13 {\n    column-gap: 3.25rem !important;\n  }\n\n  .column-gap-xxl-14 {\n    column-gap: 3.5rem !important;\n  }\n\n  .column-gap-xxl-15 {\n    column-gap: 3.75rem !important;\n  }\n\n  .column-gap-xxl-16 {\n    column-gap: 4rem !important;\n  }\n\n  .column-gap-xxl-17 {\n    column-gap: 4.25rem !important;\n  }\n\n  .column-gap-xxl-18 {\n    column-gap: 4.5rem !important;\n  }\n\n  .column-gap-xxl-19 {\n    column-gap: 4.75rem !important;\n  }\n\n  .column-gap-xxl-20 {\n    column-gap: 5rem !important;\n  }\n\n  .text-xxl-start {\n    text-align: left !important;\n  }\n\n  .text-xxl-end {\n    text-align: right !important;\n  }\n\n  .text-xxl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .fs-1 {\n    font-size: 1.75rem !important;\n  }\n\n  .fs-2 {\n    font-size: 1.5rem !important;\n  }\n\n  .fs-3 {\n    font-size: 1.35rem !important;\n  }\n\n  .fs-2x {\n    font-size: 2rem !important;\n  }\n\n  .fs-2qx {\n    font-size: 2.25rem !important;\n  }\n\n  .fs-2hx {\n    font-size: 2.5rem !important;\n  }\n\n  .fs-2tx {\n    font-size: 2.75rem !important;\n  }\n\n  .fs-3x {\n    font-size: 3rem !important;\n  }\n\n  .fs-3qx {\n    font-size: 3.25rem !important;\n  }\n\n  .fs-3hx {\n    font-size: 3.5rem !important;\n  }\n\n  .fs-3tx {\n    font-size: 3.75rem !important;\n  }\n\n  .fs-4x {\n    font-size: 4rem !important;\n  }\n\n  .fs-4qx {\n    font-size: 4.25rem !important;\n  }\n\n  .fs-4hx {\n    font-size: 4.5rem !important;\n  }\n\n  .fs-4tx {\n    font-size: 4.75rem !important;\n  }\n\n  .fs-5x {\n    font-size: 5rem !important;\n  }\n\n  .fs-5qx {\n    font-size: 5.25rem !important;\n  }\n\n  .fs-5hx {\n    font-size: 5.5rem !important;\n  }\n\n  .fs-5tx {\n    font-size: 5.75rem !important;\n  }\n}\n@media print {\n  .d-print-inline {\n    display: inline !important;\n  }\n\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-print-block {\n    display: block !important;\n  }\n\n  .d-print-grid {\n    display: grid !important;\n  }\n\n  .d-print-inline-grid {\n    display: inline-grid !important;\n  }\n\n  .d-print-table {\n    display: table !important;\n  }\n\n  .d-print-table-row {\n    display: table-row !important;\n  }\n\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-print-flex {\n    display: flex !important;\n  }\n\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-print-none {\n    display: none !important;\n  }\n}\nbody > iframe[style*=\"2147483647\"] {\n  display: none;\n}\n\n:root,\n[data-bs-theme=light] {\n  --bs-blue: #009ef6;\n  --bs-indigo: #6610f2;\n  --bs-purple: #6f42c1;\n  --bs-pink: #d63384;\n  --bs-red: #dc3545;\n  --bs-orange: #fd7e14;\n  --bs-yellow: #ffc107;\n  --bs-green: #198754;\n  --bs-teal: #20c997;\n  --bs-cyan: #0dcaf0;\n  --bs-gray: #7E8299;\n  --bs-gray-dark: #3F4254;\n  --bs-gray-100: #F5F8FA;\n  --bs-gray-200: #EFF2F5;\n  --bs-gray-300: #E4E6EF;\n  --bs-gray-400: #B5B5C3;\n  --bs-gray-500: #A1A5B7;\n  --bs-gray-600: #7E8299;\n  --bs-gray-700: #5E6278;\n  --bs-gray-800: #3F4254;\n  --bs-gray-900: #181C32;\n  --bs-white: #ffffff;\n  --bs-light: #F5F8FA;\n  --bs-primary: #009EF7;\n  --bs-secondary: #E4E6EF;\n  --bs-success: #50CD89;\n  --bs-info: #7239EA;\n  --bs-warning: #FFC700;\n  --bs-danger: #F1416C;\n  --bs-dark: #181C32;\n  --bs-white-rgb: 255, 255, 255;\n  --bs-light-rgb: 245, 248, 250;\n  --bs-primary-rgb: 0, 158, 247;\n  --bs-secondary-rgb: 228, 230, 239;\n  --bs-success-rgb: 80, 205, 137;\n  --bs-info-rgb: 114, 57, 234;\n  --bs-warning-rgb: 255, 199, 0;\n  --bs-danger-rgb: 241, 65, 108;\n  --bs-dark-rgb: 24, 28, 50;\n  --bs-primary-text-emphasis: #003f63;\n  --bs-secondary-text-emphasis: #5b5c60;\n  --bs-success-text-emphasis: #205237;\n  --bs-info-text-emphasis: #2e175e;\n  --bs-warning-text-emphasis: #665000;\n  --bs-danger-text-emphasis: #601a2b;\n  --bs-light-text-emphasis: #5E6278;\n  --bs-dark-text-emphasis: #5E6278;\n  --bs-primary-bg-subtle: #ccecfd;\n  --bs-secondary-bg-subtle: #fafafc;\n  --bs-success-bg-subtle: #dcf5e7;\n  --bs-info-bg-subtle: #e3d7fb;\n  --bs-warning-bg-subtle: #fff4cc;\n  --bs-danger-bg-subtle: #fcd9e2;\n  --bs-light-bg-subtle: #fafcfd;\n  --bs-dark-bg-subtle: #B5B5C3;\n  --bs-primary-border-subtle: #99d8fc;\n  --bs-secondary-border-subtle: #f4f5f9;\n  --bs-success-border-subtle: #b9ebd0;\n  --bs-info-border-subtle: #c7b0f7;\n  --bs-warning-border-subtle: #ffe999;\n  --bs-danger-border-subtle: #f9b3c4;\n  --bs-light-border-subtle: #EFF2F5;\n  --bs-dark-border-subtle: #A1A5B7;\n  --bs-white-rgb: 255, 255, 255;\n  --bs-black-rgb: 0, 0, 0;\n  --bs-font-sans-serif: Poppins, Helvetica, \"sans-serif\";\n  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n  --bs-body-font-family: var(--bs-font-sans-serif);\n  --bs-body-font-size: 1rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.5;\n  --bs-body-color: #181C32;\n  --bs-body-color-rgb: 24, 28, 50;\n  --bs-body-bg: #ffffff;\n  --bs-body-bg-rgb: 255, 255, 255;\n  --bs-emphasis-color: #000000;\n  --bs-emphasis-color-rgb: 0, 0, 0;\n  --bs-secondary-color: rgba(24, 28, 50, 0.75);\n  --bs-secondary-color-rgb: 24, 28, 50;\n  --bs-secondary-bg: #EFF2F5;\n  --bs-secondary-bg-rgb: 239, 242, 245;\n  --bs-tertiary-color: rgba(24, 28, 50, 0.5);\n  --bs-tertiary-color-rgb: 24, 28, 50;\n  --bs-tertiary-bg: #F5F8FA;\n  --bs-tertiary-bg-rgb: 245, 248, 250;\n  --bs-heading-color: #181C32;\n  --bs-link-color: #009EF7;\n  --bs-link-color-rgb: 0, 158, 247;\n  --bs-link-decoration: none;\n  --bs-link-hover-color: #006dab;\n  --bs-link-hover-color-rgb: 0, 109, 171;\n  --bs-link-hover-decoration: underline;\n  --bs-code-color: #b93993;\n  --bs-highlight-color: #181C32;\n  --bs-highlight-bg: #fff3cd;\n  --bs-border-width: 1px;\n  --bs-border-style: solid;\n  --bs-border-color: #EFF2F5;\n  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);\n  --bs-border-radius: 0.475rem;\n  --bs-border-radius-sm: 0.275rem;\n  --bs-border-radius-lg: 0.775rem;\n  --bs-border-radius-xl: 1rem;\n  --bs-border-radius-xxl: 2rem;\n  --bs-border-radius-2xl: var(--bs-border-radius-xxl);\n  --bs-border-radius-pill: 50rem;\n  --bs-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);\n  --bs-box-shadow-sm: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);\n  --bs-box-shadow-lg: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.1);\n  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  --bs-focus-ring-width: 0.25rem;\n  --bs-focus-ring-opacity: 0.25;\n  --bs-focus-ring-color: rgba(0, 158, 247, 0.25);\n  --bs-form-valid-color: #50CD89;\n  --bs-form-valid-border-color: #50CD89;\n  --bs-form-invalid-color: #F1416C;\n  --bs-form-invalid-border-color: #F1416C;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--bs-body-font-family);\n  font-size: var(--bs-body-font-size);\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  color: var(--bs-body-color);\n  text-align: var(--bs-body-text-align);\n  background-color: var(--bs-body-bg);\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhr {\n  margin: 1rem 0;\n  color: inherit;\n  border: 0;\n  border-top: var(--bs-border-width) solid;\n  opacity: 0.25;\n}\n\nh6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  line-height: 1.2;\n  color: var(--bs-heading-color);\n}\n\nh1, .h1 {\n  font-size: calc(1.3rem + 0.6vw);\n}\n@media (min-width: 1200px) {\n  h1, .h1 {\n    font-size: 1.75rem;\n  }\n}\n\nh2, .h2 {\n  font-size: calc(1.275rem + 0.3vw);\n}\n@media (min-width: 1200px) {\n  h2, .h2 {\n    font-size: 1.5rem;\n  }\n}\n\nh3, .h3 {\n  font-size: calc(1.26rem + 0.12vw);\n}\n@media (min-width: 1200px) {\n  h3, .h3 {\n    font-size: 1.35rem;\n  }\n}\n\nh4, .h4 {\n  font-size: 1.25rem;\n}\n\nh5, .h5 {\n  font-size: 1.15rem;\n}\n\nh6, .h6 {\n  font-size: 1.075rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title] {\n  text-decoration: underline dotted;\n  cursor: help;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 500;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: 600;\n}\n\nsmall, .small {\n  font-size: 0.875em;\n}\n\nmark, .mark {\n  padding: 0.1875em;\n  color: var(--bs-highlight-color);\n  background-color: var(--bs-highlight-bg);\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 0.75em;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));\n  text-decoration: none;\n}\na:hover {\n  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);\n  text-decoration: underline;\n}\n\na:not([href]):not([class]), a:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: var(--bs-font-monospace);\n  font-size: 1em;\n}\n\npre {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  font-size: 0.875em;\n}\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\ncode {\n  font-size: 0.875em;\n  color: var(--bs-code-color);\n  word-wrap: break-word;\n}\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.1875rem 0.375rem;\n  font-size: 0.875em;\n  color: var(--bs-body-bg);\n  background-color: var(--bs-body-color);\n  border-radius: 0.275rem;\n}\nkbd kbd {\n  padding: 0;\n  font-size: 1em;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  color: var(--bs-secondary-color);\n  text-align: left;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\nlabel {\n  display: inline-block;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\nselect:disabled {\n  opacity: 1;\n}\n\n[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ntextarea {\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  float: left;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  line-height: inherit;\n  font-size: calc(1.275rem + 0.3vw);\n}\n@media (min-width: 1200px) {\n  legend {\n    font-size: 1.5rem;\n  }\n}\nlegend + * {\n  clear: left;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n[type=search]::-webkit-search-cancel-button {\n  cursor: pointer;\n  filter: grayscale(1);\n}\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n::file-selector-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\niframe {\n  border: 0;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.lead {\n  font-size: 1.25rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-weight: 600;\n  line-height: 1.2;\n  font-size: calc(1.625rem + 4.5vw);\n}\n@media (min-width: 1200px) {\n  .display-1 {\n    font-size: 5rem;\n  }\n}\n\n.display-2 {\n  font-weight: 600;\n  line-height: 1.2;\n  font-size: calc(1.575rem + 3.9vw);\n}\n@media (min-width: 1200px) {\n  .display-2 {\n    font-size: 4.5rem;\n  }\n}\n\n.display-3 {\n  font-weight: 600;\n  line-height: 1.2;\n  font-size: calc(1.525rem + 3.3vw);\n}\n@media (min-width: 1200px) {\n  .display-3 {\n    font-size: 4rem;\n  }\n}\n\n.display-4 {\n  font-weight: 600;\n  line-height: 1.2;\n  font-size: calc(1.475rem + 2.7vw);\n}\n@media (min-width: 1200px) {\n  .display-4 {\n    font-size: 3.5rem;\n  }\n}\n\n.display-5 {\n  font-weight: 600;\n  line-height: 1.2;\n  font-size: calc(1.425rem + 2.1vw);\n}\n@media (min-width: 1200px) {\n  .display-5 {\n    font-size: 3rem;\n  }\n}\n\n.display-6 {\n  font-weight: 600;\n  line-height: 1.2;\n  font-size: calc(1.375rem + 1.5vw);\n}\n@media (min-width: 1200px) {\n  .display-6 {\n    font-size: 2.5rem;\n  }\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 0.875em;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.25rem;\n}\n.blockquote > :last-child {\n  margin-bottom: 0;\n}\n\n.blockquote-footer {\n  margin-top: -1rem;\n  margin-bottom: 1rem;\n  font-size: 0.875em;\n  color: #7E8299;\n}\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: var(--bs-body-bg);\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  box-shadow: var(--bs-box-shadow-sm);\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 0.875em;\n  color: var(--bs-secondary-color);\n}\n\n.container,\n.container-fluid,\n.container-xxl,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * .5);\n  padding-left: calc(var(--bs-gutter-x) * .5);\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .container-sm, .container {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .container-md, .container-sm, .container {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .container-lg, .container-md, .container-sm, .container {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1140px;\n  }\n}\n@media (min-width: 1400px) {\n  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1320px;\n  }\n}\n:root {\n  --bs-breakpoint-xs: 0;\n  --bs-breakpoint-sm: 576px;\n  --bs-breakpoint-md: 768px;\n  --bs-breakpoint-lg: 992px;\n  --bs-breakpoint-xl: 1200px;\n  --bs-breakpoint-xxl: 1400px;\n}\n\n.row {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: calc(-1 * var(--bs-gutter-y));\n  margin-right: calc(-.5 * var(--bs-gutter-x));\n  margin-left: calc(-.5 * var(--bs-gutter-x));\n}\n.row > * {\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * .5);\n  padding-left: calc(var(--bs-gutter-x) * .5);\n  margin-top: var(--bs-gutter-y);\n}\n\n.col {\n  flex: 1 0 0;\n}\n\n.row-cols-auto > * {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.row-cols-1 > * {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.row-cols-2 > * {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.row-cols-3 > * {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.row-cols-4 > * {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.row-cols-5 > * {\n  flex: 0 0 auto;\n  width: 20%;\n}\n\n.row-cols-6 > * {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.col-1 {\n  flex: 0 0 auto;\n  width: 8.33333333%;\n}\n\n.col-2 {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-3 {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.col-5 {\n  flex: 0 0 auto;\n  width: 41.66666667%;\n}\n\n.col-6 {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 auto;\n  width: 58.33333333%;\n}\n\n.col-8 {\n  flex: 0 0 auto;\n  width: 66.66666667%;\n}\n\n.col-9 {\n  flex: 0 0 auto;\n  width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 auto;\n  width: 83.33333333%;\n}\n\n.col-11 {\n  flex: 0 0 auto;\n  width: 91.66666667%;\n}\n\n.col-12 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.offset-1 {\n  margin-left: 8.33333333%;\n}\n\n.offset-2 {\n  margin-left: 16.66666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.33333333%;\n}\n\n.offset-5 {\n  margin-left: 41.66666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.33333333%;\n}\n\n.offset-8 {\n  margin-left: 66.66666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.33333333%;\n}\n\n.offset-11 {\n  margin-left: 91.66666667%;\n}\n\n.g-0,\n.gx-0 {\n  --bs-gutter-x: 0rem;\n}\n\n.g-0,\n.gy-0 {\n  --bs-gutter-y: 0rem;\n}\n\n.g-1,\n.gx-1 {\n  --bs-gutter-x: 0.25rem;\n}\n\n.g-1,\n.gy-1 {\n  --bs-gutter-y: 0.25rem;\n}\n\n.g-2,\n.gx-2 {\n  --bs-gutter-x: 0.5rem;\n}\n\n.g-2,\n.gy-2 {\n  --bs-gutter-y: 0.5rem;\n}\n\n.g-3,\n.gx-3 {\n  --bs-gutter-x: 0.75rem;\n}\n\n.g-3,\n.gy-3 {\n  --bs-gutter-y: 0.75rem;\n}\n\n.g-4,\n.gx-4 {\n  --bs-gutter-x: 1rem;\n}\n\n.g-4,\n.gy-4 {\n  --bs-gutter-y: 1rem;\n}\n\n.g-5,\n.gx-5 {\n  --bs-gutter-x: 1.25rem;\n}\n\n.g-5,\n.gy-5 {\n  --bs-gutter-y: 1.25rem;\n}\n\n.g-6,\n.gx-6 {\n  --bs-gutter-x: 1.5rem;\n}\n\n.g-6,\n.gy-6 {\n  --bs-gutter-y: 1.5rem;\n}\n\n.g-7,\n.gx-7 {\n  --bs-gutter-x: 1.75rem;\n}\n\n.g-7,\n.gy-7 {\n  --bs-gutter-y: 1.75rem;\n}\n\n.g-8,\n.gx-8 {\n  --bs-gutter-x: 2rem;\n}\n\n.g-8,\n.gy-8 {\n  --bs-gutter-y: 2rem;\n}\n\n.g-9,\n.gx-9 {\n  --bs-gutter-x: 2.25rem;\n}\n\n.g-9,\n.gy-9 {\n  --bs-gutter-y: 2.25rem;\n}\n\n.g-10,\n.gx-10 {\n  --bs-gutter-x: 2.5rem;\n}\n\n.g-10,\n.gy-10 {\n  --bs-gutter-y: 2.5rem;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex: 1 0 0;\n  }\n\n  .row-cols-sm-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .row-cols-sm-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .row-cols-sm-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .row-cols-sm-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .row-cols-sm-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .row-cols-sm-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n\n  .row-cols-sm-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .col-sm-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n\n  .col-sm-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-sm-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .col-sm-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .col-sm-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n\n  .col-sm-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .col-sm-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n\n  .col-sm-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n\n  .col-sm-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n\n  .col-sm-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n\n  .col-sm-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n\n  .col-sm-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n\n  .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n\n  .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n\n  .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n\n  .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n\n  .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n\n  .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n\n  .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n\n  .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n\n  .g-sm-0,\n.gx-sm-0 {\n    --bs-gutter-x: 0rem;\n  }\n\n  .g-sm-0,\n.gy-sm-0 {\n    --bs-gutter-y: 0rem;\n  }\n\n  .g-sm-1,\n.gx-sm-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n\n  .g-sm-1,\n.gy-sm-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n\n  .g-sm-2,\n.gx-sm-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n\n  .g-sm-2,\n.gy-sm-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n\n  .g-sm-3,\n.gx-sm-3 {\n    --bs-gutter-x: 0.75rem;\n  }\n\n  .g-sm-3,\n.gy-sm-3 {\n    --bs-gutter-y: 0.75rem;\n  }\n\n  .g-sm-4,\n.gx-sm-4 {\n    --bs-gutter-x: 1rem;\n  }\n\n  .g-sm-4,\n.gy-sm-4 {\n    --bs-gutter-y: 1rem;\n  }\n\n  .g-sm-5,\n.gx-sm-5 {\n    --bs-gutter-x: 1.25rem;\n  }\n\n  .g-sm-5,\n.gy-sm-5 {\n    --bs-gutter-y: 1.25rem;\n  }\n\n  .g-sm-6,\n.gx-sm-6 {\n    --bs-gutter-x: 1.5rem;\n  }\n\n  .g-sm-6,\n.gy-sm-6 {\n    --bs-gutter-y: 1.5rem;\n  }\n\n  .g-sm-7,\n.gx-sm-7 {\n    --bs-gutter-x: 1.75rem;\n  }\n\n  .g-sm-7,\n.gy-sm-7 {\n    --bs-gutter-y: 1.75rem;\n  }\n\n  .g-sm-8,\n.gx-sm-8 {\n    --bs-gutter-x: 2rem;\n  }\n\n  .g-sm-8,\n.gy-sm-8 {\n    --bs-gutter-y: 2rem;\n  }\n\n  .g-sm-9,\n.gx-sm-9 {\n    --bs-gutter-x: 2.25rem;\n  }\n\n  .g-sm-9,\n.gy-sm-9 {\n    --bs-gutter-y: 2.25rem;\n  }\n\n  .g-sm-10,\n.gx-sm-10 {\n    --bs-gutter-x: 2.5rem;\n  }\n\n  .g-sm-10,\n.gy-sm-10 {\n    --bs-gutter-y: 2.5rem;\n  }\n}\n@media (min-width: 768px) {\n  .col-md {\n    flex: 1 0 0;\n  }\n\n  .row-cols-md-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .row-cols-md-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .row-cols-md-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .row-cols-md-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .row-cols-md-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .row-cols-md-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n\n  .row-cols-md-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .col-md-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n\n  .col-md-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-md-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .col-md-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .col-md-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n\n  .col-md-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .col-md-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n\n  .col-md-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n\n  .col-md-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n\n  .col-md-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n\n  .col-md-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n\n  .col-md-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .offset-md-0 {\n    margin-left: 0;\n  }\n\n  .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n\n  .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n\n  .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n\n  .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n\n  .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n\n  .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n\n  .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n\n  .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n\n  .g-md-0,\n.gx-md-0 {\n    --bs-gutter-x: 0rem;\n  }\n\n  .g-md-0,\n.gy-md-0 {\n    --bs-gutter-y: 0rem;\n  }\n\n  .g-md-1,\n.gx-md-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n\n  .g-md-1,\n.gy-md-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n\n  .g-md-2,\n.gx-md-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n\n  .g-md-2,\n.gy-md-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n\n  .g-md-3,\n.gx-md-3 {\n    --bs-gutter-x: 0.75rem;\n  }\n\n  .g-md-3,\n.gy-md-3 {\n    --bs-gutter-y: 0.75rem;\n  }\n\n  .g-md-4,\n.gx-md-4 {\n    --bs-gutter-x: 1rem;\n  }\n\n  .g-md-4,\n.gy-md-4 {\n    --bs-gutter-y: 1rem;\n  }\n\n  .g-md-5,\n.gx-md-5 {\n    --bs-gutter-x: 1.25rem;\n  }\n\n  .g-md-5,\n.gy-md-5 {\n    --bs-gutter-y: 1.25rem;\n  }\n\n  .g-md-6,\n.gx-md-6 {\n    --bs-gutter-x: 1.5rem;\n  }\n\n  .g-md-6,\n.gy-md-6 {\n    --bs-gutter-y: 1.5rem;\n  }\n\n  .g-md-7,\n.gx-md-7 {\n    --bs-gutter-x: 1.75rem;\n  }\n\n  .g-md-7,\n.gy-md-7 {\n    --bs-gutter-y: 1.75rem;\n  }\n\n  .g-md-8,\n.gx-md-8 {\n    --bs-gutter-x: 2rem;\n  }\n\n  .g-md-8,\n.gy-md-8 {\n    --bs-gutter-y: 2rem;\n  }\n\n  .g-md-9,\n.gx-md-9 {\n    --bs-gutter-x: 2.25rem;\n  }\n\n  .g-md-9,\n.gy-md-9 {\n    --bs-gutter-y: 2.25rem;\n  }\n\n  .g-md-10,\n.gx-md-10 {\n    --bs-gutter-x: 2.5rem;\n  }\n\n  .g-md-10,\n.gy-md-10 {\n    --bs-gutter-y: 2.5rem;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg {\n    flex: 1 0 0;\n  }\n\n  .row-cols-lg-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .row-cols-lg-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .row-cols-lg-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .row-cols-lg-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .row-cols-lg-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .row-cols-lg-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n\n  .row-cols-lg-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .col-lg-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n\n  .col-lg-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-lg-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .col-lg-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .col-lg-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n\n  .col-lg-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .col-lg-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n\n  .col-lg-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n\n  .col-lg-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n\n  .col-lg-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n\n  .col-lg-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n\n  .col-lg-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n\n  .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n\n  .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n\n  .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n\n  .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n\n  .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n\n  .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n\n  .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n\n  .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n\n  .g-lg-0,\n.gx-lg-0 {\n    --bs-gutter-x: 0rem;\n  }\n\n  .g-lg-0,\n.gy-lg-0 {\n    --bs-gutter-y: 0rem;\n  }\n\n  .g-lg-1,\n.gx-lg-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n\n  .g-lg-1,\n.gy-lg-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n\n  .g-lg-2,\n.gx-lg-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n\n  .g-lg-2,\n.gy-lg-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n\n  .g-lg-3,\n.gx-lg-3 {\n    --bs-gutter-x: 0.75rem;\n  }\n\n  .g-lg-3,\n.gy-lg-3 {\n    --bs-gutter-y: 0.75rem;\n  }\n\n  .g-lg-4,\n.gx-lg-4 {\n    --bs-gutter-x: 1rem;\n  }\n\n  .g-lg-4,\n.gy-lg-4 {\n    --bs-gutter-y: 1rem;\n  }\n\n  .g-lg-5,\n.gx-lg-5 {\n    --bs-gutter-x: 1.25rem;\n  }\n\n  .g-lg-5,\n.gy-lg-5 {\n    --bs-gutter-y: 1.25rem;\n  }\n\n  .g-lg-6,\n.gx-lg-6 {\n    --bs-gutter-x: 1.5rem;\n  }\n\n  .g-lg-6,\n.gy-lg-6 {\n    --bs-gutter-y: 1.5rem;\n  }\n\n  .g-lg-7,\n.gx-lg-7 {\n    --bs-gutter-x: 1.75rem;\n  }\n\n  .g-lg-7,\n.gy-lg-7 {\n    --bs-gutter-y: 1.75rem;\n  }\n\n  .g-lg-8,\n.gx-lg-8 {\n    --bs-gutter-x: 2rem;\n  }\n\n  .g-lg-8,\n.gy-lg-8 {\n    --bs-gutter-y: 2rem;\n  }\n\n  .g-lg-9,\n.gx-lg-9 {\n    --bs-gutter-x: 2.25rem;\n  }\n\n  .g-lg-9,\n.gy-lg-9 {\n    --bs-gutter-y: 2.25rem;\n  }\n\n  .g-lg-10,\n.gx-lg-10 {\n    --bs-gutter-x: 2.5rem;\n  }\n\n  .g-lg-10,\n.gy-lg-10 {\n    --bs-gutter-y: 2.5rem;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl {\n    flex: 1 0 0;\n  }\n\n  .row-cols-xl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .row-cols-xl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .row-cols-xl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .row-cols-xl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .row-cols-xl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .row-cols-xl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n\n  .row-cols-xl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .col-xl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n\n  .col-xl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-xl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .col-xl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .col-xl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n\n  .col-xl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .col-xl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n\n  .col-xl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n\n  .col-xl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n\n  .col-xl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n\n  .col-xl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n\n  .col-xl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n\n  .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n\n  .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n\n  .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n\n  .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n\n  .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n\n  .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n\n  .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n\n  .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n\n  .g-xl-0,\n.gx-xl-0 {\n    --bs-gutter-x: 0rem;\n  }\n\n  .g-xl-0,\n.gy-xl-0 {\n    --bs-gutter-y: 0rem;\n  }\n\n  .g-xl-1,\n.gx-xl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n\n  .g-xl-1,\n.gy-xl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n\n  .g-xl-2,\n.gx-xl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n\n  .g-xl-2,\n.gy-xl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n\n  .g-xl-3,\n.gx-xl-3 {\n    --bs-gutter-x: 0.75rem;\n  }\n\n  .g-xl-3,\n.gy-xl-3 {\n    --bs-gutter-y: 0.75rem;\n  }\n\n  .g-xl-4,\n.gx-xl-4 {\n    --bs-gutter-x: 1rem;\n  }\n\n  .g-xl-4,\n.gy-xl-4 {\n    --bs-gutter-y: 1rem;\n  }\n\n  .g-xl-5,\n.gx-xl-5 {\n    --bs-gutter-x: 1.25rem;\n  }\n\n  .g-xl-5,\n.gy-xl-5 {\n    --bs-gutter-y: 1.25rem;\n  }\n\n  .g-xl-6,\n.gx-xl-6 {\n    --bs-gutter-x: 1.5rem;\n  }\n\n  .g-xl-6,\n.gy-xl-6 {\n    --bs-gutter-y: 1.5rem;\n  }\n\n  .g-xl-7,\n.gx-xl-7 {\n    --bs-gutter-x: 1.75rem;\n  }\n\n  .g-xl-7,\n.gy-xl-7 {\n    --bs-gutter-y: 1.75rem;\n  }\n\n  .g-xl-8,\n.gx-xl-8 {\n    --bs-gutter-x: 2rem;\n  }\n\n  .g-xl-8,\n.gy-xl-8 {\n    --bs-gutter-y: 2rem;\n  }\n\n  .g-xl-9,\n.gx-xl-9 {\n    --bs-gutter-x: 2.25rem;\n  }\n\n  .g-xl-9,\n.gy-xl-9 {\n    --bs-gutter-y: 2.25rem;\n  }\n\n  .g-xl-10,\n.gx-xl-10 {\n    --bs-gutter-x: 2.5rem;\n  }\n\n  .g-xl-10,\n.gy-xl-10 {\n    --bs-gutter-y: 2.5rem;\n  }\n}\n@media (min-width: 1400px) {\n  .col-xxl {\n    flex: 1 0 0;\n  }\n\n  .row-cols-xxl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .row-cols-xxl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .row-cols-xxl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .row-cols-xxl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .row-cols-xxl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .row-cols-xxl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n\n  .row-cols-xxl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-xxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .col-xxl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n\n  .col-xxl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-xxl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .col-xxl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .col-xxl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n\n  .col-xxl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .col-xxl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n\n  .col-xxl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n\n  .col-xxl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n\n  .col-xxl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n\n  .col-xxl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n\n  .col-xxl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .offset-xxl-0 {\n    margin-left: 0;\n  }\n\n  .offset-xxl-1 {\n    margin-left: 8.33333333%;\n  }\n\n  .offset-xxl-2 {\n    margin-left: 16.66666667%;\n  }\n\n  .offset-xxl-3 {\n    margin-left: 25%;\n  }\n\n  .offset-xxl-4 {\n    margin-left: 33.33333333%;\n  }\n\n  .offset-xxl-5 {\n    margin-left: 41.66666667%;\n  }\n\n  .offset-xxl-6 {\n    margin-left: 50%;\n  }\n\n  .offset-xxl-7 {\n    margin-left: 58.33333333%;\n  }\n\n  .offset-xxl-8 {\n    margin-left: 66.66666667%;\n  }\n\n  .offset-xxl-9 {\n    margin-left: 75%;\n  }\n\n  .offset-xxl-10 {\n    margin-left: 83.33333333%;\n  }\n\n  .offset-xxl-11 {\n    margin-left: 91.66666667%;\n  }\n\n  .g-xxl-0,\n.gx-xxl-0 {\n    --bs-gutter-x: 0rem;\n  }\n\n  .g-xxl-0,\n.gy-xxl-0 {\n    --bs-gutter-y: 0rem;\n  }\n\n  .g-xxl-1,\n.gx-xxl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n\n  .g-xxl-1,\n.gy-xxl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n\n  .g-xxl-2,\n.gx-xxl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n\n  .g-xxl-2,\n.gy-xxl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n\n  .g-xxl-3,\n.gx-xxl-3 {\n    --bs-gutter-x: 0.75rem;\n  }\n\n  .g-xxl-3,\n.gy-xxl-3 {\n    --bs-gutter-y: 0.75rem;\n  }\n\n  .g-xxl-4,\n.gx-xxl-4 {\n    --bs-gutter-x: 1rem;\n  }\n\n  .g-xxl-4,\n.gy-xxl-4 {\n    --bs-gutter-y: 1rem;\n  }\n\n  .g-xxl-5,\n.gx-xxl-5 {\n    --bs-gutter-x: 1.25rem;\n  }\n\n  .g-xxl-5,\n.gy-xxl-5 {\n    --bs-gutter-y: 1.25rem;\n  }\n\n  .g-xxl-6,\n.gx-xxl-6 {\n    --bs-gutter-x: 1.5rem;\n  }\n\n  .g-xxl-6,\n.gy-xxl-6 {\n    --bs-gutter-y: 1.5rem;\n  }\n\n  .g-xxl-7,\n.gx-xxl-7 {\n    --bs-gutter-x: 1.75rem;\n  }\n\n  .g-xxl-7,\n.gy-xxl-7 {\n    --bs-gutter-y: 1.75rem;\n  }\n\n  .g-xxl-8,\n.gx-xxl-8 {\n    --bs-gutter-x: 2rem;\n  }\n\n  .g-xxl-8,\n.gy-xxl-8 {\n    --bs-gutter-y: 2rem;\n  }\n\n  .g-xxl-9,\n.gx-xxl-9 {\n    --bs-gutter-x: 2.25rem;\n  }\n\n  .g-xxl-9,\n.gy-xxl-9 {\n    --bs-gutter-y: 2.25rem;\n  }\n\n  .g-xxl-10,\n.gx-xxl-10 {\n    --bs-gutter-x: 2.5rem;\n  }\n\n  .g-xxl-10,\n.gy-xxl-10 {\n    --bs-gutter-y: 2.5rem;\n  }\n}\n.table {\n  --bs-table-color-type: initial;\n  --bs-table-bg-type: initial;\n  --bs-table-color-state: initial;\n  --bs-table-bg-state: initial;\n  --bs-table-color: #181C32;\n  --bs-table-bg: transparent;\n  --bs-table-border-color: #EFF2F5;\n  --bs-table-accent-bg: transparent;\n  --bs-table-striped-color: #181C32;\n  --bs-table-striped-bg: rgba(245, 248, 250, 0.75);\n  --bs-table-active-color: #181C32;\n  --bs-table-active-bg: #F5F8FA;\n  --bs-table-hover-color: #181C32;\n  --bs-table-hover-bg: #F5F8FA;\n  width: 100%;\n  margin-bottom: 1rem;\n  vertical-align: top;\n  border-color: var(--bs-table-border-color);\n}\n.table > :not(caption) > * > * {\n  padding: 0.75rem 0.75rem;\n  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));\n  background-color: var(--bs-table-bg);\n  border-bottom-width: 1px;\n  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));\n}\n.table > tbody {\n  vertical-align: inherit;\n}\n.table > thead {\n  vertical-align: bottom;\n}\n\n.table-group-divider {\n  border-top: calc(1px * 2) solid currentcolor;\n}\n\n.caption-top {\n  caption-side: top;\n}\n\n.table-sm > :not(caption) > * > * {\n  padding: 0.5rem 0.5rem;\n}\n\n.table-bordered > :not(caption) > * {\n  border-width: 1px 0;\n}\n.table-bordered > :not(caption) > * > * {\n  border-width: 0 1px;\n}\n\n.table-borderless > :not(caption) > * > * {\n  border-bottom-width: 0;\n}\n.table-borderless > :not(:first-child) {\n  border-top-width: 0;\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) > * {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-striped-columns > :not(caption) > tr > :nth-child(even) {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-active {\n  --bs-table-color-state: var(--bs-table-active-color);\n  --bs-table-bg-state: var(--bs-table-active-bg);\n}\n\n.table-hover > tbody > tr:hover > * {\n  --bs-table-color-state: var(--bs-table-hover-color);\n  --bs-table-bg-state: var(--bs-table-hover-bg);\n}\n\n.table-primary {\n  --bs-table-color: #000000;\n  --bs-table-bg: #ccecfd;\n  --bs-table-border-color: #b8d4e4;\n  --bs-table-striped-bg: #c2e0f0;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #b8d4e4;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #bddaea;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-secondary {\n  --bs-table-color: #000000;\n  --bs-table-bg: #fafafc;\n  --bs-table-border-color: #e1e1e3;\n  --bs-table-striped-bg: #eeeeef;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #e1e1e3;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #e7e7e9;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-success {\n  --bs-table-color: #000000;\n  --bs-table-bg: #dcf5e7;\n  --bs-table-border-color: #c6ddd0;\n  --bs-table-striped-bg: #d1e9db;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #c6ddd0;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #cce3d6;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-info {\n  --bs-table-color: #000000;\n  --bs-table-bg: #e3d7fb;\n  --bs-table-border-color: #ccc2e2;\n  --bs-table-striped-bg: #d8ccee;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #ccc2e2;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #d2c7e8;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-warning {\n  --bs-table-color: #000000;\n  --bs-table-bg: #fff4cc;\n  --bs-table-border-color: #e6dcb8;\n  --bs-table-striped-bg: #f2e8c2;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #e6dcb8;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #ece2bd;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-danger {\n  --bs-table-color: #000000;\n  --bs-table-bg: #fcd9e2;\n  --bs-table-border-color: #e3c3cb;\n  --bs-table-striped-bg: #efced7;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #e3c3cb;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #e9c9d1;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-light {\n  --bs-table-color: #000000;\n  --bs-table-bg: #F5F8FA;\n  --bs-table-border-color: #dddfe1;\n  --bs-table-striped-bg: #e9ecee;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #dddfe1;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #e3e5e7;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-dark {\n  --bs-table-color: #ffffff;\n  --bs-table-bg: #181C32;\n  --bs-table-border-color: #2f3347;\n  --bs-table-striped-bg: #24273c;\n  --bs-table-striped-color: #ffffff;\n  --bs-table-active-bg: #2f3347;\n  --bs-table-active-color: #ffffff;\n  --bs-table-hover-bg: #292d41;\n  --bs-table-hover-color: #ffffff;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1399.98px) {\n  .table-responsive-xxl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n.form-label {\n  margin-bottom: 0.5rem;\n  font-size: 1.05rem;\n  font-weight: 500;\n  color: #3F4254;\n}\n\n.col-form-label {\n  padding-top: calc(0.75rem + 1px);\n  padding-bottom: calc(0.75rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #3F4254;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.825rem + 1px);\n  padding-bottom: calc(0.825rem + 1px);\n  font-size: 1.15rem;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.65rem + 1px);\n  padding-bottom: calc(0.65rem + 1px);\n  font-size: 0.925rem;\n}\n\n.form-text {\n  margin-top: 0.5rem;\n  font-size: 0.925rem;\n  color: #A1A5B7;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.75rem 1rem;\n  font-size: 1.1rem;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #181C32;\n  appearance: none;\n  background-color: #ffffff;\n  background-clip: padding-box;\n  border: 1px solid #E4E6EF;\n  border-radius: 0.475rem;\n  box-shadow: var(--bs-box-shadow-inset);\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control[type=file] {\n  overflow: hidden;\n}\n.form-control[type=file]:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control:focus {\n  color: #181C32;\n  background-color: #ffffff;\n  border-color: #B5B5C3;\n  outline: 0;\n  box-shadow: var(--bs-box-shadow-inset), 0 0 0 0.25rem rgba(0, 158, 247, 0.25);\n}\n.form-control::-webkit-date-and-time-value {\n  min-width: 85px;\n  height: 1.5em;\n  margin: 0;\n}\n.form-control::-webkit-datetime-edit {\n  display: block;\n  padding: 0;\n}\n.form-control::placeholder {\n  color: #A1A5B7;\n  opacity: 1;\n}\n.form-control:disabled {\n  background-color: #EFF2F5;\n  opacity: 1;\n}\n.form-control::file-selector-button {\n  padding: 0.75rem 1rem;\n  margin: -0.75rem -1rem;\n  margin-inline-end: 1rem;\n  color: #181C32;\n  background-color: var(--bs-tertiary-bg);\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: 1px;\n  border-radius: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control::file-selector-button {\n    transition: none;\n  }\n}\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n  background-color: var(--bs-secondary-bg);\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.75rem 0;\n  margin-bottom: 0;\n  line-height: 1.5;\n  color: #181C32;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n.form-control-plaintext:focus {\n  outline: 0;\n}\n.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  min-height: calc(1.5em + 1.3rem + calc(1px * 2));\n  padding: 0.65rem 0.75rem;\n  font-size: 0.925rem;\n  border-radius: 0.475rem;\n}\n.form-control-sm::file-selector-button {\n  padding: 0.65rem 0.75rem;\n  margin: -0.65rem -0.75rem;\n  margin-inline-end: 0.75rem;\n}\n\n.form-control-lg {\n  min-height: calc(1.5em + 1.65rem + calc(1px * 2));\n  padding: 0.825rem 1.5rem;\n  font-size: 1.15rem;\n  border-radius: 0.475rem;\n}\n.form-control-lg::file-selector-button {\n  padding: 0.825rem 1.5rem;\n  margin: -0.825rem -1.5rem;\n  margin-inline-end: 1.5rem;\n}\n\ntextarea.form-control {\n  min-height: calc(1.5em + 1.5rem + calc(1px * 2));\n}\ntextarea.form-control-sm {\n  min-height: calc(1.5em + 1.3rem + calc(1px * 2));\n}\ntextarea.form-control-lg {\n  min-height: calc(1.5em + 1.65rem + calc(1px * 2));\n}\n\n.form-control-color {\n  width: 3rem;\n  height: calc(1.5em + 1.5rem + calc(1px * 2));\n  padding: 0.75rem;\n}\n.form-control-color:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control-color::-moz-color-swatch {\n  border: 0 !important;\n  border-radius: 0.475rem;\n}\n.form-control-color::-webkit-color-swatch {\n  border: 0 !important;\n  border-radius: 0.475rem;\n}\n.form-control-color.form-control-sm {\n  height: calc(1.5em + 1.3rem + calc(1px * 2));\n}\n.form-control-color.form-control-lg {\n  height: calc(1.5em + 1.65rem + calc(1px * 2));\n}\n\n.form-select {\n  --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%237E8299' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  display: block;\n  width: 100%;\n  padding: 0.75rem 3rem 0.75rem 1rem;\n  font-size: 1.1rem;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #181C32;\n  appearance: none;\n  background-color: #ffffff;\n  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: right 1rem center;\n  background-size: 16px 12px;\n  border: 1px solid #E4E6EF;\n  border-radius: 0.475rem;\n  box-shadow: var(--bs-box-shadow-inset);\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-select {\n    transition: none;\n  }\n}\n.form-select:focus {\n  border-color: #B5B5C3;\n  outline: 0;\n  box-shadow: var(--bs-box-shadow-inset), 0 0 0 0.25rem rgba(0, 158, 247, 0.25);\n}\n.form-select[multiple], .form-select[size]:not([size=\"1\"]) {\n  padding-right: 1rem;\n  background-image: none;\n}\n.form-select:disabled {\n  background-color: #EFF2F5;\n}\n.form-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #181C32;\n}\n\n.form-select-sm {\n  padding-top: 0.65rem;\n  padding-bottom: 0.65rem;\n  padding-left: 0.75rem;\n  font-size: 0.925rem;\n  border-radius: 0.475rem;\n}\n\n.form-select-lg {\n  padding-top: 0.825rem;\n  padding-bottom: 0.825rem;\n  padding-left: 1.5rem;\n  font-size: 1.15rem;\n  border-radius: 0.475rem;\n}\n\n.form-check {\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 2.25rem;\n  margin-bottom: 0.125rem;\n}\n.form-check .form-check-input {\n  float: left;\n  margin-left: -2.25rem;\n}\n\n.form-check-reverse {\n  padding-right: 2.25rem;\n  padding-left: 0;\n  text-align: right;\n}\n.form-check-reverse .form-check-input {\n  float: right;\n  margin-right: -2.25rem;\n  margin-left: 0;\n}\n\n.form-check-input {\n  --bs-form-check-bg: #ffffff;\n  flex-shrink: 0;\n  width: 1.75rem;\n  height: 1.75rem;\n  margin-top: -0.125rem;\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--bs-form-check-bg);\n  background-image: var(--bs-form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  print-color-adjust: exact;\n  transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-check-input {\n    transition: none;\n  }\n}\n.form-check-input[type=checkbox] {\n  border-radius: 0.45em;\n}\n.form-check-input[type=radio] {\n  border-radius: 50%;\n}\n.form-check-input:active {\n  filter: brightness(90%);\n}\n.form-check-input:focus {\n  border-color: #B5B5C3;\n  outline: 0;\n  box-shadow: none;\n}\n.form-check-input:checked {\n  background-color: #009EF7;\n  border-color: #009EF7;\n}\n.form-check-input:checked[type=checkbox] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 13 11' width='13' height='11' fill='none'%3e%3cpath d='M11.0426 1.02893C11.3258 0.695792 11.8254 0.655283 12.1585 0.938451C12.4917 1.22162 12.5322 1.72124 12.249 2.05437L5.51985 9.97104C5.23224 10.3094 4.72261 10.3451 4.3907 10.05L0.828197 6.88335C0.50141 6.59288 0.471975 6.09249 0.762452 5.7657C1.05293 5.43891 1.55332 5.40948 1.88011 5.69995L4.83765 8.32889L11.0426 1.02893Z' fill='%23FFFFFF'/%3e%3c/svg%3e\");\n}\n.form-check-input:checked[type=radio] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23FFFFFF'/%3e%3c/svg%3e\");\n}\n.form-check-input[type=checkbox]:indeterminate {\n  background-color: #009EF7;\n  border-color: #009EF7;\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23FFFFFF' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n}\n.form-check-input:disabled {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.5;\n}\n.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.form-switch {\n  padding-left: 3.75rem;\n}\n.form-switch .form-check-input {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n  width: 3.25rem;\n  margin-left: -3.75rem;\n  background-image: var(--bs-form-switch-bg);\n  background-position: left center;\n  border-radius: 3.25rem;\n  transition: background-position 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-switch .form-check-input {\n    transition: none;\n  }\n}\n.form-switch .form-check-input:focus {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23B5B5C3'/%3e%3c/svg%3e\");\n}\n.form-switch .form-check-input:checked {\n  background-position: right center;\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23FFFFFF'/%3e%3c/svg%3e\");\n}\n.form-switch.form-check-reverse {\n  padding-right: 3.75rem;\n  padding-left: 0;\n}\n.form-switch.form-check-reverse .form-check-input {\n  margin-right: -3.75rem;\n  margin-left: 0;\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: 1rem;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.btn-check[disabled] + .btn, .btn-check:disabled + .btn {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.6;\n}\n\n.form-range {\n  width: 100%;\n  height: 1.5rem;\n  padding: 0;\n  appearance: none;\n  background-color: transparent;\n}\n.form-range:focus {\n  outline: 0;\n}\n.form-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.25rem rgba(0, 158, 247, 0.25);\n}\n.form-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.25rem rgba(0, 158, 247, 0.25);\n}\n.form-range::-moz-focus-outer {\n  border: 0;\n}\n.form-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  appearance: none;\n  background-color: #009EF7;\n  border: 0;\n  border-radius: 1rem;\n  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n.form-range::-webkit-slider-thumb:active {\n  background-color: #b3e2fd;\n}\n.form-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--bs-secondary-bg);\n  border-color: transparent;\n  border-radius: 1rem;\n  box-shadow: var(--bs-box-shadow-inset);\n}\n.form-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  appearance: none;\n  background-color: #009EF7;\n  border: 0;\n  border-radius: 1rem;\n  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n.form-range::-moz-range-thumb:active {\n  background-color: #b3e2fd;\n}\n.form-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--bs-secondary-bg);\n  border-color: transparent;\n  border-radius: 1rem;\n  box-shadow: var(--bs-box-shadow-inset);\n}\n.form-range:disabled {\n  pointer-events: none;\n}\n.form-range:disabled::-webkit-slider-thumb {\n  background-color: var(--bs-secondary-color);\n}\n.form-range:disabled::-moz-range-thumb {\n  background-color: var(--bs-secondary-color);\n}\n\n.form-floating {\n  position: relative;\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext,\n.form-floating > .form-select {\n  height: calc(3.5rem + calc(1px * 2));\n  min-height: calc(3.5rem + calc(1px * 2));\n  line-height: 1.25;\n}\n.form-floating > label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  max-width: 100%;\n  height: 100%;\n  padding: 1rem 1rem;\n  overflow: hidden;\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  text-align: start;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  pointer-events: none;\n  border: 1px solid transparent;\n  transform-origin: 0 0;\n  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-floating > label {\n    transition: none;\n  }\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext {\n  padding: 1rem 1rem;\n}\n.form-floating > .form-control::placeholder,\n.form-floating > .form-control-plaintext::placeholder {\n  color: transparent;\n}\n.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),\n.form-floating > .form-control-plaintext:focus,\n.form-floating > .form-control-plaintext:not(:placeholder-shown) {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:-webkit-autofill,\n.form-floating > .form-control-plaintext:-webkit-autofill {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-select {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n  padding-left: 1rem;\n}\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-control-plaintext ~ label,\n.form-floating > .form-select ~ label {\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control:-webkit-autofill ~ label {\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > textarea:focus ~ label::after,\n.form-floating > textarea:not(:placeholder-shown) ~ label::after {\n  position: absolute;\n  inset: 1rem 0.5rem;\n  z-index: -1;\n  height: 1.5em;\n  content: \"\";\n  background-color: #ffffff;\n  border-radius: 0.475rem;\n}\n.form-floating > textarea:disabled ~ label::after {\n  background-color: #EFF2F5;\n}\n.form-floating > .form-control-plaintext ~ label {\n  border-width: 1px 0;\n}\n.form-floating > :disabled ~ label,\n.form-floating > .form-control:disabled ~ label {\n  color: #7E8299;\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n.input-group > .form-control,\n.input-group > .form-select,\n.input-group > .form-floating {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n}\n.input-group > .form-control:focus,\n.input-group > .form-select:focus,\n.input-group > .form-floating:focus-within {\n  z-index: 5;\n}\n.input-group .btn {\n  position: relative;\n  z-index: 2;\n}\n.input-group .btn:focus {\n  z-index: 5;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.75rem 1rem;\n  font-size: 1.1rem;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #181C32;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #F5F8FA;\n  border: 1px solid #E4E6EF;\n  border-radius: 0.475rem;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: 0.825rem 1.5rem;\n  font-size: 1.15rem;\n  border-radius: 0.475rem;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: 0.65rem 0.75rem;\n  font-size: 0.925rem;\n  border-radius: 0.475rem;\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: 4rem;\n}\n\n.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: calc(-1 * 1px);\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .form-floating:not(:first-child) > .form-control,\n.input-group > .form-floating:not(:first-child) > .form-select {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.5rem;\n  font-size: 0.925rem;\n  color: var(--bs-form-valid-color);\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.75rem 1rem;\n  margin-top: 0.1rem;\n  font-size: 0.925rem;\n  color: #fff;\n  background-color: var(--bs-success);\n  border-radius: 0.475rem;\n}\n\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip,\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n  padding-right: calc(1.5em + 1.5rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2350CD89' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.375rem) center;\n  background-size: calc(0.75em + 0.75rem) calc(0.75em + 0.75rem);\n}\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n  border-color: var(--bs-form-valid-border-color);\n  box-shadow: var(--bs-box-shadow-inset), 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.5em + 1.5rem);\n  background-position: top calc(0.375em + 0.375rem) right calc(0.375em + 0.375rem);\n}\n\n.was-validated .form-select:valid, .form-select.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n}\n.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size=\"1\"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2350CD89' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/%3e%3c/svg%3e\");\n  padding-right: 5.5rem;\n  background-position: right 1rem center, center right 3rem;\n  background-size: 16px 12px, calc(0.75em + 0.75rem) calc(0.75em + 0.75rem);\n}\n.was-validated .form-select:valid:focus, .form-select.is-valid:focus {\n  border-color: var(--bs-form-valid-border-color);\n  box-shadow: var(--bs-box-shadow-inset), 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated .form-control-color:valid, .form-control-color.is-valid {\n  width: calc(3rem + calc(1.5em + 1.5rem));\n}\n\n.was-validated .form-check-input:valid, .form-check-input.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n}\n.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {\n  background-color: var(--bs-form-valid-color);\n}\n.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: var(--bs-form-valid-color);\n}\n\n.form-check-inline .form-check-input ~ .valid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,\n.was-validated .input-group > .form-select:not(:focus):valid,\n.input-group > .form-select:not(:focus).is-valid,\n.was-validated .input-group > .form-floating:not(:focus-within):valid,\n.input-group > .form-floating:not(:focus-within).is-valid {\n  z-index: 3;\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.5rem;\n  font-size: 0.925rem;\n  color: var(--bs-form-invalid-color);\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.75rem 1rem;\n  margin-top: 0.1rem;\n  font-size: 0.925rem;\n  color: #fff;\n  background-color: var(--bs-danger);\n  border-radius: 0.475rem;\n}\n\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n  padding-right: calc(1.5em + 1.5rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23F1416C'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23F1416C' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.375rem) center;\n  background-size: calc(0.75em + 0.75rem) calc(0.75em + 0.75rem);\n}\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n  border-color: var(--bs-form-invalid-border-color);\n  box-shadow: var(--bs-box-shadow-inset), 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 1.5rem);\n  background-position: top calc(0.375em + 0.375rem) right calc(0.375em + 0.375rem);\n}\n\n.was-validated .form-select:invalid, .form-select.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n}\n.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size=\"1\"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23F1416C'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23F1416C' stroke='none'/%3e%3c/svg%3e\");\n  padding-right: 5.5rem;\n  background-position: right 1rem center, center right 3rem;\n  background-size: 16px 12px, calc(0.75em + 0.75rem) calc(0.75em + 0.75rem);\n}\n.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {\n  border-color: var(--bs-form-invalid-border-color);\n  box-shadow: var(--bs-box-shadow-inset), 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated .form-control-color:invalid, .form-control-color.is-invalid {\n  width: calc(3rem + calc(1.5em + 1.5rem));\n}\n\n.was-validated .form-check-input:invalid, .form-check-input.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n}\n.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {\n  background-color: var(--bs-form-invalid-color);\n}\n.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: var(--bs-form-invalid-color);\n}\n\n.form-check-inline .form-check-input ~ .invalid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,\n.was-validated .input-group > .form-select:not(:focus):invalid,\n.input-group > .form-select:not(:focus).is-invalid,\n.was-validated .input-group > .form-floating:not(:focus-within):invalid,\n.input-group > .form-floating:not(:focus-within).is-invalid {\n  z-index: 4;\n}\n\n.btn {\n  --bs-btn-padding-x: 1.5rem;\n  --bs-btn-padding-y: 0.75rem;\n  --bs-btn-font-family: ;\n  --bs-btn-font-size: 1.1rem;\n  --bs-btn-font-weight: 500;\n  --bs-btn-line-height: 1.5;\n  --bs-btn-color: var(--bs-body-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-width: 1px;\n  --bs-btn-border-color: transparent;\n  --bs-btn-border-radius: 0.475rem;\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\n  --bs-btn-disabled-opacity: 0.6;\n  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);\n  display: inline-block;\n  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);\n  font-family: var(--bs-btn-font-family);\n  font-size: var(--bs-btn-font-size);\n  font-weight: var(--bs-btn-font-weight);\n  line-height: var(--bs-btn-line-height);\n  color: var(--bs-btn-color);\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);\n  border-radius: var(--bs-btn-border-radius);\n  background-color: var(--bs-btn-bg);\n  box-shadow: var(--bs-btn-box-shadow);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n.btn:hover {\n  color: var(--bs-btn-hover-color);\n  text-decoration: none;\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n}\n.btn-check + .btn:hover {\n  color: var(--bs-btn-color);\n  background-color: var(--bs-btn-bg);\n  border-color: var(--bs-btn-border-color);\n}\n.btn:focus-visible {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-box-shadow), var(--bs-btn-focus-box-shadow);\n}\n.btn-check:focus-visible + .btn {\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-box-shadow), var(--bs-btn-focus-box-shadow);\n}\n.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {\n  color: var(--bs-btn-active-color);\n  background-color: var(--bs-btn-active-bg);\n  border-color: var(--bs-btn-active-border-color);\n  box-shadow: var(--bs-btn-active-shadow);\n}\n.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {\n  box-shadow: var(--bs-btn-active-shadow), var(--bs-btn-focus-box-shadow);\n}\n.btn-check:checked:focus-visible + .btn {\n  box-shadow: var(--bs-btn-active-shadow), var(--bs-btn-focus-box-shadow);\n}\n.btn:disabled, .btn.disabled, fieldset:disabled .btn {\n  color: var(--bs-btn-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-btn-disabled-bg);\n  border-color: var(--bs-btn-disabled-border-color);\n  opacity: var(--bs-btn-disabled-opacity);\n  box-shadow: none;\n}\n\n.btn-white {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #ffffff;\n  --bs-btn-border-color: #ffffff;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: white;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 217, 217, 217;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: white;\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #ffffff;\n  --bs-btn-disabled-border-color: #ffffff;\n}\n\n.btn-light {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #F5F8FA;\n  --bs-btn-border-color: #F5F8FA;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #d0d3d5;\n  --bs-btn-hover-border-color: #c4c6c8;\n  --bs-btn-focus-shadow-rgb: 208, 211, 213;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #c4c6c8;\n  --bs-btn-active-border-color: #b8babc;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #F5F8FA;\n  --bs-btn-disabled-border-color: #F5F8FA;\n}\n\n.btn-primary {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #009EF7;\n  --bs-btn-border-color: #009EF7;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #26adf8;\n  --bs-btn-hover-border-color: #1aa8f8;\n  --bs-btn-focus-shadow-rgb: 0, 134, 210;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #33b1f9;\n  --bs-btn-active-border-color: #1aa8f8;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #009EF7;\n  --bs-btn-disabled-border-color: #009EF7;\n}\n\n.btn-secondary {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #E4E6EF;\n  --bs-btn-border-color: #E4E6EF;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #e8eaf1;\n  --bs-btn-hover-border-color: #e7e9f1;\n  --bs-btn-focus-shadow-rgb: 194, 196, 203;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #e9ebf2;\n  --bs-btn-active-border-color: #e7e9f1;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #E4E6EF;\n  --bs-btn-disabled-border-color: #E4E6EF;\n}\n\n.btn-success {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #50CD89;\n  --bs-btn-border-color: #50CD89;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #6ad59b;\n  --bs-btn-hover-border-color: #62d295;\n  --bs-btn-focus-shadow-rgb: 68, 174, 116;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #73d7a1;\n  --bs-btn-active-border-color: #62d295;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #50CD89;\n  --bs-btn-disabled-border-color: #50CD89;\n}\n\n.btn-info {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #7239EA;\n  --bs-btn-border-color: #7239EA;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #6130c7;\n  --bs-btn-hover-border-color: #5b2ebb;\n  --bs-btn-focus-shadow-rgb: 135, 87, 237;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #5b2ebb;\n  --bs-btn-active-border-color: #562bb0;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #7239EA;\n  --bs-btn-disabled-border-color: #7239EA;\n}\n\n.btn-warning {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #FFC700;\n  --bs-btn-border-color: #FFC700;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #ffcf26;\n  --bs-btn-hover-border-color: #ffcd1a;\n  --bs-btn-focus-shadow-rgb: 217, 169, 0;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #ffd233;\n  --bs-btn-active-border-color: #ffcd1a;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #FFC700;\n  --bs-btn-disabled-border-color: #FFC700;\n}\n\n.btn-danger {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #F1416C;\n  --bs-btn-border-color: #F1416C;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #f35e82;\n  --bs-btn-hover-border-color: #f2547b;\n  --bs-btn-focus-shadow-rgb: 205, 55, 92;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #f46789;\n  --bs-btn-active-border-color: #f2547b;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #F1416C;\n  --bs-btn-disabled-border-color: #F1416C;\n}\n\n.btn-dark {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #181C32;\n  --bs-btn-border-color: #181C32;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #3b3e51;\n  --bs-btn-hover-border-color: #2f3347;\n  --bs-btn-focus-shadow-rgb: 59, 62, 81;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #46495b;\n  --bs-btn-active-border-color: #2f3347;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #181C32;\n  --bs-btn-disabled-border-color: #181C32;\n}\n\n.btn-outline-white {\n  --bs-btn-color: #ffffff;\n  --bs-btn-border-color: #ffffff;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #ffffff;\n  --bs-btn-hover-border-color: #ffffff;\n  --bs-btn-focus-shadow-rgb: 255, 255, 255;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #ffffff;\n  --bs-btn-active-border-color: #ffffff;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ffffff;\n  --bs-gradient: none;\n}\n\n.btn-outline-light {\n  --bs-btn-color: #F5F8FA;\n  --bs-btn-border-color: #F5F8FA;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #F5F8FA;\n  --bs-btn-hover-border-color: #F5F8FA;\n  --bs-btn-focus-shadow-rgb: 245, 248, 250;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #F5F8FA;\n  --bs-btn-active-border-color: #F5F8FA;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #F5F8FA;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #F5F8FA;\n  --bs-gradient: none;\n}\n\n.btn-outline-primary {\n  --bs-btn-color: #009EF7;\n  --bs-btn-border-color: #009EF7;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #009EF7;\n  --bs-btn-hover-border-color: #009EF7;\n  --bs-btn-focus-shadow-rgb: 0, 158, 247;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #009EF7;\n  --bs-btn-active-border-color: #009EF7;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #009EF7;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #009EF7;\n  --bs-gradient: none;\n}\n\n.btn-outline-secondary {\n  --bs-btn-color: #E4E6EF;\n  --bs-btn-border-color: #E4E6EF;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #E4E6EF;\n  --bs-btn-hover-border-color: #E4E6EF;\n  --bs-btn-focus-shadow-rgb: 228, 230, 239;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #E4E6EF;\n  --bs-btn-active-border-color: #E4E6EF;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #E4E6EF;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #E4E6EF;\n  --bs-gradient: none;\n}\n\n.btn-outline-success {\n  --bs-btn-color: #50CD89;\n  --bs-btn-border-color: #50CD89;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #50CD89;\n  --bs-btn-hover-border-color: #50CD89;\n  --bs-btn-focus-shadow-rgb: 80, 205, 137;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #50CD89;\n  --bs-btn-active-border-color: #50CD89;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #50CD89;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #50CD89;\n  --bs-gradient: none;\n}\n\n.btn-outline-info {\n  --bs-btn-color: #7239EA;\n  --bs-btn-border-color: #7239EA;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #7239EA;\n  --bs-btn-hover-border-color: #7239EA;\n  --bs-btn-focus-shadow-rgb: 114, 57, 234;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #7239EA;\n  --bs-btn-active-border-color: #7239EA;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #7239EA;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #7239EA;\n  --bs-gradient: none;\n}\n\n.btn-outline-warning {\n  --bs-btn-color: #FFC700;\n  --bs-btn-border-color: #FFC700;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #FFC700;\n  --bs-btn-hover-border-color: #FFC700;\n  --bs-btn-focus-shadow-rgb: 255, 199, 0;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #FFC700;\n  --bs-btn-active-border-color: #FFC700;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #FFC700;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #FFC700;\n  --bs-gradient: none;\n}\n\n.btn-outline-danger {\n  --bs-btn-color: #F1416C;\n  --bs-btn-border-color: #F1416C;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #F1416C;\n  --bs-btn-hover-border-color: #F1416C;\n  --bs-btn-focus-shadow-rgb: 241, 65, 108;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #F1416C;\n  --bs-btn-active-border-color: #F1416C;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #F1416C;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #F1416C;\n  --bs-gradient: none;\n}\n\n.btn-outline-dark {\n  --bs-btn-color: #181C32;\n  --bs-btn-border-color: #181C32;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #181C32;\n  --bs-btn-hover-border-color: #181C32;\n  --bs-btn-focus-shadow-rgb: 24, 28, 50;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #181C32;\n  --bs-btn-active-border-color: #181C32;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #181C32;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #181C32;\n  --bs-gradient: none;\n}\n\n.btn-link {\n  --bs-btn-font-weight: 400;\n  --bs-btn-color: #009EF7;\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: transparent;\n  --bs-btn-hover-color: #006dab;\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-active-color: #006dab;\n  --bs-btn-active-border-color: transparent;\n  --bs-btn-disabled-color: #7E8299;\n  --bs-btn-disabled-border-color: transparent;\n  --bs-btn-box-shadow: 0 0 0 #000;\n  --bs-btn-focus-shadow-rgb: 0, 134, 210;\n  text-decoration: none;\n}\n.btn-link:hover, .btn-link:focus-visible {\n  text-decoration: underline;\n}\n.btn-link:focus-visible {\n  color: var(--bs-btn-color);\n}\n.btn-link:hover {\n  color: var(--bs-btn-hover-color);\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  --bs-btn-padding-y: 0.825rem;\n  --bs-btn-padding-x: 1.75rem;\n  --bs-btn-font-size: 1.15rem;\n  --bs-btn-border-radius: 0.475rem;\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  --bs-btn-padding-y: 0.65rem;\n  --bs-btn-padding-x: 1.25rem;\n  --bs-btn-font-size: 0.925rem;\n  --bs-btn-border-radius: 0.475rem;\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n.collapsing.collapse-horizontal {\n  width: 0;\n  height: auto;\n  transition: width 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing.collapse-horizontal {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  --bs-dropdown-zindex: 1000;\n  --bs-dropdown-min-width: 10rem;\n  --bs-dropdown-padding-x: 0;\n  --bs-dropdown-padding-y: 0.5rem;\n  --bs-dropdown-spacer: 0.125rem;\n  --bs-dropdown-font-size: 1rem;\n  --bs-dropdown-color: var(--bs-body-color);\n  --bs-dropdown-bg: #ffffff;\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-border-radius: 0.475rem;\n  --bs-dropdown-border-width: 0;\n  --bs-dropdown-inner-border-radius: calc(0.475rem - 0);\n  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n  --bs-dropdown-divider-margin-y: 0.5rem;\n  --bs-dropdown-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  --bs-dropdown-link-color: var(--bs-body-color);\n  --bs-dropdown-link-hover-color: var(--bs-body-color);\n  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);\n  --bs-dropdown-link-active-color: #FFFFFF;\n  --bs-dropdown-link-active-bg: #009EF7;\n  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);\n  --bs-dropdown-item-padding-x: 1rem;\n  --bs-dropdown-item-padding-y: 0.25rem;\n  --bs-dropdown-header-color: #7E8299;\n  --bs-dropdown-header-padding-x: 1rem;\n  --bs-dropdown-header-padding-y: 0.5rem;\n  position: absolute;\n  z-index: var(--bs-dropdown-zindex);\n  display: none;\n  min-width: var(--bs-dropdown-min-width);\n  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);\n  margin: 0;\n  font-size: var(--bs-dropdown-font-size);\n  color: var(--bs-dropdown-color);\n  text-align: left;\n  list-style: none;\n  background-color: var(--bs-dropdown-bg);\n  background-clip: padding-box;\n  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);\n  border-radius: var(--bs-dropdown-border-radius);\n  box-shadow: var(--bs-dropdown-box-shadow);\n}\n.dropdown-menu[data-bs-popper] {\n  top: 100%;\n  left: 0;\n  margin-top: var(--bs-dropdown-spacer);\n}\n\n.dropdown-menu-start {\n  --bs-position: start;\n}\n.dropdown-menu-start[data-bs-popper] {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-end {\n  --bs-position: end;\n}\n.dropdown-menu-end[data-bs-popper] {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-sm-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-sm-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-sm-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 768px) {\n  .dropdown-menu-md-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-md-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-md-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-md-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 992px) {\n  .dropdown-menu-lg-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-lg-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-lg-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-lg-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-xl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1400px) {\n  .dropdown-menu-xxl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xxl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-xxl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xxl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n.dropup .dropdown-menu[data-bs-popper] {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: var(--bs-dropdown-spacer);\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropend .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: var(--bs-dropdown-spacer);\n}\n.dropend .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n.dropend .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropend .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropstart .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: var(--bs-dropdown-spacer);\n}\n.dropstart .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n.dropstart .dropdown-toggle::after {\n  display: none;\n}\n.dropstart .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n.dropstart .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: var(--bs-dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--bs-dropdown-divider-bg);\n  opacity: 1;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  clear: both;\n  font-weight: 400;\n  color: var(--bs-dropdown-link-color);\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n  border-radius: var(--bs-dropdown-item-border-radius, 0);\n}\n.dropdown-item:hover, .dropdown-item:focus {\n  color: var(--bs-dropdown-link-hover-color);\n  text-decoration: none;\n  background-color: var(--bs-dropdown-link-hover-bg);\n}\n.dropdown-item.active, .dropdown-item:active {\n  color: var(--bs-dropdown-link-active-color);\n  text-decoration: none;\n  background-color: var(--bs-dropdown-link-active-bg);\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: var(--bs-dropdown-link-disabled-color);\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);\n  margin-bottom: 0;\n  font-size: 0.925rem;\n  color: var(--bs-dropdown-header-color);\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  color: var(--bs-dropdown-link-color);\n}\n\n.dropdown-menu-dark {\n  --bs-dropdown-color: #E4E6EF;\n  --bs-dropdown-bg: #3F4254;\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-box-shadow: ;\n  --bs-dropdown-link-color: #E4E6EF;\n  --bs-dropdown-link-hover-color: #ffffff;\n  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);\n  --bs-dropdown-link-active-color: #FFFFFF;\n  --bs-dropdown-link-active-bg: #009EF7;\n  --bs-dropdown-link-disabled-color: #A1A5B7;\n  --bs-dropdown-header-color: #A1A5B7;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n.btn-group > .btn-check:checked + .btn,\n.btn-group > .btn-check:focus + .btn,\n.btn-group > .btn:hover,\n.btn-group > .btn:focus,\n.btn-group > .btn:active,\n.btn-group > .btn.active,\n.btn-group-vertical > .btn-check:checked + .btn,\n.btn-group-vertical > .btn-check:focus + .btn,\n.btn-group-vertical > .btn:hover,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group {\n  border-radius: 0.475rem;\n}\n.btn-group > :not(.btn-check:first-child) + .btn,\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: calc(-1 * 1px);\n}\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn.dropdown-toggle-split:first-child,\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:nth-child(n+3),\n.btn-group > :not(.btn-check) + .btn,\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 1.125rem;\n  padding-left: 1.125rem;\n}\n.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.9375rem;\n  padding-left: 0.9375rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 1.3125rem;\n  padding-left: 1.3125rem;\n}\n\n.btn-group.show .dropdown-toggle {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n}\n.btn-group.show .dropdown-toggle.btn-link {\n  box-shadow: none;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: calc(-1 * 1px);\n}\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn:nth-child(n+3),\n.btn-group-vertical > :not(.btn-check) + .btn,\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav {\n  --bs-nav-link-padding-x: 1rem;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-link-color);\n  --bs-nav-link-hover-color: var(--bs-link-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-secondary-color);\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n  font-size: var(--bs-nav-link-font-size);\n  font-weight: var(--bs-nav-link-font-weight);\n  color: var(--bs-nav-link-color);\n  background: none;\n  border: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .nav-link {\n    transition: none;\n  }\n}\n.nav-link:hover, .nav-link:focus {\n  color: var(--bs-nav-link-hover-color);\n  text-decoration: none;\n}\n.nav-link:focus-visible {\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(0, 158, 247, 0.25);\n}\n.nav-link.disabled, .nav-link:disabled {\n  color: var(--bs-nav-link-disabled-color);\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  --bs-nav-tabs-border-width: 1px;\n  --bs-nav-tabs-border-color: #EFF2F5;\n  --bs-nav-tabs-border-radius: var(--bs-border-radius);\n  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) #EFF2F5;\n  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);\n  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);\n  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);\n  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);\n}\n.nav-tabs .nav-link {\n  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));\n  border: var(--bs-nav-tabs-border-width) solid transparent;\n  border-top-left-radius: var(--bs-nav-tabs-border-radius);\n  border-top-right-radius: var(--bs-nav-tabs-border-radius);\n}\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  isolation: isolate;\n  border-color: var(--bs-nav-tabs-link-hover-border-color);\n}\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: var(--bs-nav-tabs-link-active-color);\n  background-color: var(--bs-nav-tabs-link-active-bg);\n  border-color: var(--bs-nav-tabs-link-active-border-color);\n}\n.nav-tabs .dropdown-menu {\n  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills {\n  --bs-nav-pills-border-radius: var(--bs-border-radius);\n  --bs-nav-pills-link-active-color: #FFFFFF;\n  --bs-nav-pills-link-active-bg: #009EF7;\n}\n.nav-pills .nav-link {\n  border-radius: var(--bs-nav-pills-border-radius);\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: var(--bs-nav-pills-link-active-color);\n  background-color: var(--bs-nav-pills-link-active-bg);\n}\n\n.nav-underline {\n  --bs-nav-underline-gap: 1rem;\n  --bs-nav-underline-border-width: 0.125rem;\n  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);\n  gap: var(--bs-nav-underline-gap);\n}\n.nav-underline .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n  border-bottom: var(--bs-nav-underline-border-width) solid transparent;\n}\n.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {\n  border-bottom-color: currentcolor;\n}\n.nav-underline .nav-link.active,\n.nav-underline .show > .nav-link {\n  font-weight: 500;\n  color: var(--bs-nav-underline-link-active-color);\n  border-bottom-color: currentcolor;\n}\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n  flex-grow: 1;\n  flex-basis: 0;\n  text-align: center;\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n  width: 100%;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  --bs-navbar-padding-x: 0;\n  --bs-navbar-padding-y: 0.5rem;\n  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);\n  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);\n  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);\n  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-brand-padding-y: 0.44375rem;\n  --bs-navbar-brand-margin-end: 1rem;\n  --bs-navbar-brand-font-size: 1.075rem;\n  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-nav-link-padding-x: 0.5rem;\n  --bs-navbar-toggler-padding-y: 0.25rem;\n  --bs-navbar-toggler-padding-x: 0.75rem;\n  --bs-navbar-toggler-font-size: 1.075rem;\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2824, 28, 50, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);\n  --bs-navbar-toggler-border-radius: 0.475rem;\n  --bs-navbar-toggler-focus-width: 0.25rem;\n  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);\n}\n.navbar > .container,\n.navbar > .container-fluid,\n.navbar > .container-sm,\n.navbar > .container-md,\n.navbar > .container-lg,\n.navbar > .container-xl,\n.navbar > .container-xxl {\n  display: flex;\n  flex-wrap: inherit;\n  align-items: center;\n  justify-content: space-between;\n}\n.navbar-brand {\n  padding-top: var(--bs-navbar-brand-padding-y);\n  padding-bottom: var(--bs-navbar-brand-padding-y);\n  margin-right: var(--bs-navbar-brand-margin-end);\n  font-size: var(--bs-navbar-brand-font-size);\n  color: var(--bs-navbar-brand-color);\n  white-space: nowrap;\n}\n.navbar-brand:hover, .navbar-brand:focus {\n  color: var(--bs-navbar-brand-hover-color);\n  text-decoration: none;\n}\n\n.navbar-nav {\n  --bs-nav-link-padding-x: 0;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-navbar-color);\n  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {\n  color: var(--bs-navbar-active-color);\n}\n.navbar-nav .dropdown-menu {\n  position: static;\n}\n\n.navbar-text {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: var(--bs-navbar-color);\n}\n.navbar-text a,\n.navbar-text a:hover,\n.navbar-text a:focus {\n  color: var(--bs-navbar-active-color);\n}\n\n.navbar-collapse {\n  flex-grow: 1;\n  flex-basis: 100%;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);\n  font-size: var(--bs-navbar-toggler-font-size);\n  line-height: 1;\n  color: var(--bs-navbar-color);\n  background-color: transparent;\n  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);\n  border-radius: var(--bs-navbar-toggler-border-radius);\n  transition: var(--bs-navbar-toggler-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .navbar-toggler {\n    transition: none;\n  }\n}\n.navbar-toggler:hover {\n  text-decoration: none;\n}\n.navbar-toggler:focus {\n  text-decoration: none;\n  outline: 0;\n  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--bs-navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--bs-scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-sm .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    box-shadow: none;\n    transition: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-md .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    box-shadow: none;\n    transition: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-lg .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    box-shadow: none;\n    transition: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    box-shadow: none;\n    transition: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .navbar-expand-xxl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xxl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xxl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xxl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xxl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xxl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    box-shadow: none;\n    transition: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n.navbar-expand {\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n}\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: var(--bs-navbar-nav-link-padding-x);\n  padding-left: var(--bs-navbar-nav-link-padding-x);\n}\n.navbar-expand .navbar-nav-scroll {\n  overflow: visible;\n}\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n.navbar-expand .offcanvas {\n  position: static;\n  z-index: auto;\n  flex-grow: 1;\n  width: auto !important;\n  height: auto !important;\n  visibility: visible !important;\n  background-color: transparent !important;\n  border: 0 !important;\n  transform: none !important;\n  box-shadow: none;\n  transition: none;\n}\n.navbar-expand .offcanvas .offcanvas-header {\n  display: none;\n}\n.navbar-expand .offcanvas .offcanvas-body {\n  display: flex;\n  flex-grow: 0;\n  padding: 0;\n  overflow-y: visible;\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=dark] {\n  --bs-navbar-color: rgba(255, 255, 255, 0.55);\n  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);\n  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);\n  --bs-navbar-active-color: #ffffff;\n  --bs-navbar-brand-color: #ffffff;\n  --bs-navbar-brand-hover-color: #ffffff;\n  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.card {\n  --bs-card-spacer-y: 1rem;\n  --bs-card-spacer-x: 1rem;\n  --bs-card-title-spacer-y: 0.5rem;\n  --bs-card-title-color: ;\n  --bs-card-subtitle-color: ;\n  --bs-card-border-width: var(--bs-border-width);\n  --bs-card-border-color: #EFF2F5;\n  --bs-card-border-radius: 0.475rem;\n  --bs-card-box-shadow: 0px 0px 20px 0px rgba(76, 87, 125, 0.02);\n  --bs-card-inner-border-radius: calc(0.475rem - (var(--bs-border-width)));\n  --bs-card-cap-padding-y: 0.5rem;\n  --bs-card-cap-padding-x: 1rem;\n  --bs-card-cap-bg: #ffffff;\n  --bs-card-cap-color: ;\n  --bs-card-height: ;\n  --bs-card-color: ;\n  --bs-card-bg: #ffffff;\n  --bs-card-img-overlay-padding: 1rem;\n  --bs-card-group-margin: 0.75rem;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  height: var(--bs-card-height);\n  color: var(--bs-body-color);\n  word-wrap: break-word;\n  background-color: var(--bs-card-bg);\n  background-clip: border-box;\n  border: var(--bs-card-border-width) solid var(--bs-card-border-color);\n  border-radius: var(--bs-card-border-radius);\n  box-shadow: var(--bs-card-box-shadow);\n}\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n.card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n.card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n.card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);\n  color: var(--bs-card-color);\n}\n\n.card-title {\n  margin-bottom: var(--bs-card-title-spacer-y);\n  color: var(--bs-card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--bs-card-title-spacer-y));\n  margin-bottom: 0;\n  color: var(--bs-card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link:hover {\n  text-decoration: none;\n}\n.card-link + .card-link {\n  margin-left: var(--bs-card-spacer-x);\n}\n\n.card-header {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  margin-bottom: 0;\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-header:first-child {\n  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;\n}\n\n.card-footer {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-footer:last-child {\n  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);\n}\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--bs-card-cap-padding-x));\n  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));\n  margin-left: calc(-.5 * var(--bs-card-cap-padding-x));\n  border-bottom: 0;\n}\n.card-header-tabs .nav-link.active {\n  background-color: var(--bs-card-bg);\n  border-bottom-color: var(--bs-card-bg);\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--bs-card-cap-padding-x));\n  margin-left: calc(-.5 * var(--bs-card-cap-padding-x));\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--bs-card-img-overlay-padding);\n  border-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-group > .card {\n  margin-bottom: var(--bs-card-group-margin);\n}\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap;\n  }\n  .card-group > .card {\n    flex: 1 0 0;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) > .card-img-top,\n.card-group > .card:not(:last-child) > .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) > .card-img-bottom,\n.card-group > .card:not(:last-child) > .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) > .card-img-top,\n.card-group > .card:not(:first-child) > .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) > .card-img-bottom,\n.card-group > .card:not(:first-child) > .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.accordion {\n  --bs-accordion-color: #181C32;\n  --bs-accordion-bg: var(--bs-body-bg);\n  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;\n  --bs-accordion-border-color: #EFF2F5;\n  --bs-accordion-border-width: var(--bs-border-width);\n  --bs-accordion-border-radius: 0.475rem;\n  --bs-accordion-inner-border-radius: calc(0.475rem - (var(--bs-border-width)));\n  --bs-accordion-btn-padding-x: 1.5rem;\n  --bs-accordion-btn-padding-y: 1.5rem;\n  --bs-accordion-btn-color: var(--bs-body-color);\n  --bs-accordion-btn-bg: var(--bs-accordion-bg);\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='%23181C32' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-icon-width: 1.15rem;\n  --bs-accordion-btn-icon-transform: rotate(-180deg);\n  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='%23009EF7' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-focus-box-shadow: none;\n  --bs-accordion-body-padding-x: 1.5rem;\n  --bs-accordion-body-padding-y: 1.5rem;\n  --bs-accordion-active-color: #009EF7;\n  --bs-accordion-active-bg: #F5F8FA;\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);\n  font-size: 1rem;\n  color: var(--bs-accordion-btn-color);\n  text-align: left;\n  background-color: var(--bs-accordion-btn-bg);\n  border: 0;\n  border-radius: 0;\n  overflow-anchor: none;\n  transition: var(--bs-accordion-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button {\n    transition: none;\n  }\n}\n.accordion-button:not(.collapsed) {\n  color: var(--bs-accordion-active-color);\n  background-color: var(--bs-accordion-active-bg);\n  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);\n}\n.accordion-button:not(.collapsed)::after {\n  background-image: var(--bs-accordion-btn-active-icon);\n  transform: var(--bs-accordion-btn-icon-transform);\n}\n.accordion-button::after {\n  flex-shrink: 0;\n  width: var(--bs-accordion-btn-icon-width);\n  height: var(--bs-accordion-btn-icon-width);\n  margin-left: auto;\n  content: \"\";\n  background-image: var(--bs-accordion-btn-icon);\n  background-repeat: no-repeat;\n  background-size: var(--bs-accordion-btn-icon-width);\n  transition: var(--bs-accordion-btn-icon-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button::after {\n    transition: none;\n  }\n}\n.accordion-button:hover {\n  z-index: 2;\n}\n.accordion-button:focus {\n  z-index: 3;\n  outline: 0;\n  box-shadow: var(--bs-accordion-btn-focus-box-shadow);\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--bs-accordion-color);\n  background-color: var(--bs-accordion-bg);\n  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);\n}\n.accordion-item:first-of-type {\n  border-top-left-radius: var(--bs-accordion-border-radius);\n  border-top-right-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:first-of-type > .accordion-header .accordion-button {\n  border-top-left-radius: var(--bs-accordion-inner-border-radius);\n  border-top-right-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:not(:first-of-type) {\n  border-top: 0;\n}\n.accordion-item:last-of-type {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {\n  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:last-of-type > .accordion-collapse {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n\n.accordion-body {\n  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);\n}\n\n.accordion-flush > .accordion-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n.accordion-flush > .accordion-item:first-child {\n  border-top: 0;\n}\n.accordion-flush > .accordion-item:last-child {\n  border-bottom: 0;\n}\n.accordion-flush > .accordion-item > .accordion-collapse,\n.accordion-flush > .accordion-item > .accordion-header .accordion-button,\n.accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {\n  border-radius: 0;\n}\n\n.breadcrumb {\n  --bs-breadcrumb-padding-x: 0;\n  --bs-breadcrumb-padding-y: 0;\n  --bs-breadcrumb-margin-bottom: 1rem;\n  --bs-breadcrumb-bg: ;\n  --bs-breadcrumb-border-radius: ;\n  --bs-breadcrumb-divider-color: #7E8299;\n  --bs-breadcrumb-item-padding-x: 0.5rem;\n  --bs-breadcrumb-item-active-color: #009EF7;\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);\n  margin-bottom: var(--bs-breadcrumb-margin-bottom);\n  font-size: var(--bs-breadcrumb-font-size);\n  list-style: none;\n  background-color: var(--bs-breadcrumb-bg);\n  border-radius: var(--bs-breadcrumb-border-radius);\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: var(--bs-breadcrumb-item-padding-x);\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  float: left;\n  padding-right: var(--bs-breadcrumb-item-padding-x);\n  color: var(--bs-breadcrumb-divider-color);\n  content: var(--bs-breadcrumb-divider, \"/\") /* rtl: var(--bs-breadcrumb-divider, \"/\") */;\n}\n.breadcrumb-item.active {\n  color: var(--bs-breadcrumb-item-active-color);\n}\n\n.pagination {\n  --bs-pagination-padding-x: 0.75rem;\n  --bs-pagination-padding-y: 0.375rem;\n  --bs-pagination-font-size: 1.075rem;\n  --bs-pagination-color: #5E6278;\n  --bs-pagination-bg: transparent;\n  --bs-pagination-border-width: 0;\n  --bs-pagination-border-color: transparent;\n  --bs-pagination-border-radius: 0.475rem;\n  --bs-pagination-hover-color: #009EF7;\n  --bs-pagination-hover-bg: #F1FAFF;\n  --bs-pagination-hover-border-color: transparent;\n  --bs-pagination-focus-color: #009EF7;\n  --bs-pagination-focus-bg: #F1FAFF;\n  --bs-pagination-focus-box-shadow: none;\n  --bs-pagination-active-color: #FFFFFF;\n  --bs-pagination-active-bg: #009EF7;\n  --bs-pagination-active-border-color: transparent;\n  --bs-pagination-disabled-color: #B5B5C3;\n  --bs-pagination-disabled-bg: transparent;\n  --bs-pagination-disabled-border-color: transparent;\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);\n  font-size: var(--bs-pagination-font-size);\n  color: var(--bs-pagination-color);\n  background-color: var(--bs-pagination-bg);\n  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .page-link {\n    transition: none;\n  }\n}\n.page-link:hover {\n  z-index: 2;\n  color: var(--bs-pagination-hover-color);\n  text-decoration: none;\n  background-color: var(--bs-pagination-hover-bg);\n  border-color: var(--bs-pagination-hover-border-color);\n}\n.page-link:focus {\n  z-index: 3;\n  color: var(--bs-pagination-focus-color);\n  background-color: var(--bs-pagination-focus-bg);\n  outline: 0;\n  box-shadow: var(--bs-pagination-focus-box-shadow);\n}\n.page-link.active, .active > .page-link {\n  z-index: 3;\n  color: var(--bs-pagination-active-color);\n  background-color: var(--bs-pagination-active-bg);\n  border-color: var(--bs-pagination-active-border-color);\n}\n.page-link.disabled, .disabled > .page-link {\n  color: var(--bs-pagination-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-pagination-disabled-bg);\n  border-color: var(--bs-pagination-disabled-border-color);\n}\n\n.page-item:not(:first-child) .page-link {\n  margin-left: calc(-1 * 0);\n}\n.page-item:first-child .page-link {\n  border-top-left-radius: var(--bs-pagination-border-radius);\n  border-bottom-left-radius: var(--bs-pagination-border-radius);\n}\n.page-item:last-child .page-link {\n  border-top-right-radius: var(--bs-pagination-border-radius);\n  border-bottom-right-radius: var(--bs-pagination-border-radius);\n}\n\n.pagination-lg {\n  --bs-pagination-padding-x: 1.5rem;\n  --bs-pagination-padding-y: 0.75rem;\n  --bs-pagination-font-size: 1.075rem;\n  --bs-pagination-border-radius: var(--bs-border-radius-lg);\n}\n\n.pagination-sm {\n  --bs-pagination-padding-x: 0.5rem;\n  --bs-pagination-padding-y: 0.25rem;\n  --bs-pagination-font-size: 0.925rem;\n  --bs-pagination-border-radius: var(--bs-border-radius-sm);\n}\n\n.badge {\n  --bs-badge-padding-x: 0.85em;\n  --bs-badge-padding-y: 0.5em;\n  --bs-badge-font-size: 0.85rem;\n  --bs-badge-font-weight: 600;\n  --bs-badge-color: #ffffff;\n  --bs-badge-border-radius: 0.475rem;\n  display: inline-block;\n  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);\n  font-size: var(--bs-badge-font-size);\n  font-weight: var(--bs-badge-font-weight);\n  line-height: 1;\n  color: var(--bs-badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: var(--bs-badge-border-radius);\n}\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.alert {\n  --bs-alert-bg: transparent;\n  --bs-alert-padding-x: 1rem;\n  --bs-alert-padding-y: 1rem;\n  --bs-alert-margin-bottom: 1rem;\n  --bs-alert-color: inherit;\n  --bs-alert-border-color: transparent;\n  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);\n  --bs-alert-border-radius: var(--bs-border-radius);\n  --bs-alert-link-color: inherit;\n  position: relative;\n  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);\n  margin-bottom: var(--bs-alert-margin-bottom);\n  color: var(--bs-alert-color);\n  background-color: var(--bs-alert-bg);\n  border: var(--bs-alert-border);\n  border-radius: var(--bs-alert-border-radius);\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 500;\n  color: var(--bs-alert-link-color);\n}\n\n.alert-dismissible {\n  padding-right: 3rem;\n}\n.alert-dismissible .btn-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 1.25rem 1rem;\n}\n\n.alert-white {\n  --bs-alert-color: var(--bs-white-text-emphasis);\n  --bs-alert-bg: var(--bs-white-bg-subtle);\n  --bs-alert-border-color: var(--bs-white-border-subtle);\n  --bs-alert-link-color: var(--bs-white-text-emphasis);\n}\n\n.alert-light {\n  --bs-alert-color: var(--bs-light-text-emphasis);\n  --bs-alert-bg: var(--bs-light-bg-subtle);\n  --bs-alert-border-color: var(--bs-light-border-subtle);\n  --bs-alert-link-color: var(--bs-light-text-emphasis);\n}\n\n.alert-primary {\n  --bs-alert-color: var(--bs-primary-text-emphasis);\n  --bs-alert-bg: var(--bs-primary-bg-subtle);\n  --bs-alert-border-color: var(--bs-primary-border-subtle);\n  --bs-alert-link-color: var(--bs-primary-text-emphasis);\n}\n\n.alert-secondary {\n  --bs-alert-color: var(--bs-secondary-text-emphasis);\n  --bs-alert-bg: var(--bs-secondary-bg-subtle);\n  --bs-alert-border-color: var(--bs-secondary-border-subtle);\n  --bs-alert-link-color: var(--bs-secondary-text-emphasis);\n}\n\n.alert-success {\n  --bs-alert-color: var(--bs-success-text-emphasis);\n  --bs-alert-bg: var(--bs-success-bg-subtle);\n  --bs-alert-border-color: var(--bs-success-border-subtle);\n  --bs-alert-link-color: var(--bs-success-text-emphasis);\n}\n\n.alert-info {\n  --bs-alert-color: var(--bs-info-text-emphasis);\n  --bs-alert-bg: var(--bs-info-bg-subtle);\n  --bs-alert-border-color: var(--bs-info-border-subtle);\n  --bs-alert-link-color: var(--bs-info-text-emphasis);\n}\n\n.alert-warning {\n  --bs-alert-color: var(--bs-warning-text-emphasis);\n  --bs-alert-bg: var(--bs-warning-bg-subtle);\n  --bs-alert-border-color: var(--bs-warning-border-subtle);\n  --bs-alert-link-color: var(--bs-warning-text-emphasis);\n}\n\n.alert-danger {\n  --bs-alert-color: var(--bs-danger-text-emphasis);\n  --bs-alert-bg: var(--bs-danger-bg-subtle);\n  --bs-alert-border-color: var(--bs-danger-border-subtle);\n  --bs-alert-link-color: var(--bs-danger-text-emphasis);\n}\n\n.alert-dark {\n  --bs-alert-color: var(--bs-dark-text-emphasis);\n  --bs-alert-bg: var(--bs-dark-bg-subtle);\n  --bs-alert-border-color: var(--bs-dark-border-subtle);\n  --bs-alert-link-color: var(--bs-dark-text-emphasis);\n}\n\n@keyframes progress-bar-stripes {\n  0% {\n    background-position-x: var(--bs-progress-height);\n  }\n}\n.progress,\n.progress-stacked {\n  --bs-progress-height: 1rem;\n  --bs-progress-font-size: 0.75rem;\n  --bs-progress-bg: #F5F8FA;\n  --bs-progress-border-radius: 6px;\n  --bs-progress-box-shadow: none;\n  --bs-progress-bar-color: #ffffff;\n  --bs-progress-bar-bg: #009EF7;\n  --bs-progress-bar-transition: width 0.6s ease;\n  display: flex;\n  height: var(--bs-progress-height);\n  overflow: hidden;\n  font-size: var(--bs-progress-font-size);\n  background-color: var(--bs-progress-bg);\n  border-radius: var(--bs-progress-border-radius);\n  box-shadow: var(--bs-progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--bs-progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-progress-bar-bg);\n  transition: var(--bs-progress-bar-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: var(--bs-progress-height) var(--bs-progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n.progress-bar-animated {\n  animation: 1s linear infinite progress-bar-stripes;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.list-group {\n  --bs-list-group-color: var(--bs-body-color);\n  --bs-list-group-bg: var(--bs-body-bg);\n  --bs-list-group-border-color: var(--bs-border-color);\n  --bs-list-group-border-width: var(--bs-border-width);\n  --bs-list-group-border-radius: var(--bs-border-radius);\n  --bs-list-group-item-padding-x: 1rem;\n  --bs-list-group-item-padding-y: 0.5rem;\n  --bs-list-group-action-color: var(--bs-secondary-color);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);\n  --bs-list-group-action-active-color: var(--bs-body-color);\n  --bs-list-group-action-active-bg: var(--bs-secondary-bg);\n  --bs-list-group-disabled-color: var(--bs-secondary-color);\n  --bs-list-group-disabled-bg: var(--bs-body-bg);\n  --bs-list-group-active-color: #FFFFFF;\n  --bs-list-group-active-bg: #009EF7;\n  --bs-list-group-active-border-color: #009EF7;\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: var(--bs-list-group-border-radius);\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n}\n.list-group-numbered > .list-group-item::before {\n  content: counters(section, \".\") \". \";\n  counter-increment: section;\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);\n  color: var(--bs-list-group-color);\n  background-color: var(--bs-list-group-bg);\n  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);\n}\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  color: var(--bs-list-group-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-list-group-disabled-bg);\n}\n.list-group-item.active {\n  z-index: 2;\n  color: var(--bs-list-group-active-color);\n  background-color: var(--bs-list-group-active-bg);\n  border-color: var(--bs-list-group-active-border-color);\n}\n.list-group-item + .list-group-item {\n  border-top-width: 0;\n}\n.list-group-item + .list-group-item.active {\n  margin-top: calc(-1 * var(--bs-list-group-border-width));\n  border-top-width: var(--bs-list-group-border-width);\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: var(--bs-list-group-action-color);\n  text-align: inherit;\n}\n.list-group-item-action:not(.active):hover, .list-group-item-action:not(.active):focus {\n  z-index: 1;\n  color: var(--bs-list-group-action-hover-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-action-hover-bg);\n}\n.list-group-item-action:not(.active):active {\n  color: var(--bs-list-group-action-active-color);\n  background-color: var(--bs-list-group-action-active-bg);\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n.list-group-horizontal > .list-group-item:first-child:not(:last-child) {\n  border-bottom-left-radius: var(--bs-list-group-border-radius);\n  border-top-right-radius: 0;\n}\n.list-group-horizontal > .list-group-item:last-child:not(:first-child) {\n  border-top-right-radius: var(--bs-list-group-border-radius);\n  border-bottom-left-radius: 0;\n}\n.list-group-horizontal > .list-group-item.active {\n  margin-top: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item {\n  border-top-width: var(--bs-list-group-border-width);\n  border-left-width: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n  margin-left: calc(-1 * var(--bs-list-group-border-width));\n  border-left-width: var(--bs-list-group-border-width);\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1400px) {\n  .list-group-horizontal-xxl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n.list-group-flush {\n  border-radius: 0;\n}\n.list-group-flush > .list-group-item {\n  border-width: 0 0 var(--bs-list-group-border-width);\n}\n.list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-white {\n  --bs-list-group-color: var(--bs-white-text-emphasis);\n  --bs-list-group-bg: var(--bs-white-bg-subtle);\n  --bs-list-group-border-color: var(--bs-white-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-white-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-white-border-subtle);\n  --bs-list-group-active-color: var(--bs-white-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-white-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-white-text-emphasis);\n}\n\n.list-group-item-light {\n  --bs-list-group-color: var(--bs-light-text-emphasis);\n  --bs-list-group-bg: var(--bs-light-bg-subtle);\n  --bs-list-group-border-color: var(--bs-light-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);\n  --bs-list-group-active-color: var(--bs-light-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-light-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);\n}\n\n.list-group-item-primary {\n  --bs-list-group-color: var(--bs-primary-text-emphasis);\n  --bs-list-group-bg: var(--bs-primary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-primary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-active-color: var(--bs-primary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);\n}\n\n.list-group-item-secondary {\n  --bs-list-group-color: var(--bs-secondary-text-emphasis);\n  --bs-list-group-bg: var(--bs-secondary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);\n}\n\n.list-group-item-success {\n  --bs-list-group-color: var(--bs-success-text-emphasis);\n  --bs-list-group-bg: var(--bs-success-bg-subtle);\n  --bs-list-group-border-color: var(--bs-success-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);\n  --bs-list-group-active-color: var(--bs-success-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-success-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);\n}\n\n.list-group-item-info {\n  --bs-list-group-color: var(--bs-info-text-emphasis);\n  --bs-list-group-bg: var(--bs-info-bg-subtle);\n  --bs-list-group-border-color: var(--bs-info-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);\n  --bs-list-group-active-color: var(--bs-info-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-info-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);\n}\n\n.list-group-item-warning {\n  --bs-list-group-color: var(--bs-warning-text-emphasis);\n  --bs-list-group-bg: var(--bs-warning-bg-subtle);\n  --bs-list-group-border-color: var(--bs-warning-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-active-color: var(--bs-warning-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);\n}\n\n.list-group-item-danger {\n  --bs-list-group-color: var(--bs-danger-text-emphasis);\n  --bs-list-group-bg: var(--bs-danger-bg-subtle);\n  --bs-list-group-border-color: var(--bs-danger-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-active-color: var(--bs-danger-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);\n}\n\n.list-group-item-dark {\n  --bs-list-group-color: var(--bs-dark-text-emphasis);\n  --bs-list-group-bg: var(--bs-dark-bg-subtle);\n  --bs-list-group-border-color: var(--bs-dark-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-active-color: var(--bs-dark-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);\n}\n\n.btn-close {\n  --bs-btn-close-color: #000000;\n  --bs-btn-close-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414'/%3e%3c/svg%3e\");\n  --bs-btn-close-opacity: 0.5;\n  --bs-btn-close-hover-opacity: 0.75;\n  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(0, 158, 247, 0.25);\n  --bs-btn-close-focus-opacity: 1;\n  --bs-btn-close-disabled-opacity: 0.25;\n  box-sizing: content-box;\n  width: 1em;\n  height: 1em;\n  padding: 0.25em 0.25em;\n  color: var(--bs-btn-close-color);\n  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;\n  filter: var(--bs-btn-close-filter);\n  border: 0;\n  border-radius: 0.475rem;\n  opacity: var(--bs-btn-close-opacity);\n}\n.btn-close:hover {\n  color: var(--bs-btn-close-color);\n  text-decoration: none;\n  opacity: var(--bs-btn-close-hover-opacity);\n}\n.btn-close:focus {\n  outline: 0;\n  box-shadow: var(--bs-btn-close-focus-shadow);\n  opacity: var(--bs-btn-close-focus-opacity);\n}\n.btn-close:disabled, .btn-close.disabled {\n  pointer-events: none;\n  user-select: none;\n  opacity: var(--bs-btn-close-disabled-opacity);\n}\n\n.btn-close-white {\n  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);\n}\n\n:root,\n[data-bs-theme=light] {\n  --bs-btn-close-filter: ;\n}\n\n.toast {\n  --bs-toast-zindex: 1090;\n  --bs-toast-padding-x: 0.75rem;\n  --bs-toast-padding-y: 0.5rem;\n  --bs-toast-spacing: 1.5rem;\n  --bs-toast-max-width: 350px;\n  --bs-toast-font-size: 0.875rem;\n  --bs-toast-color: ;\n  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);\n  --bs-toast-border-width: var(--bs-border-width);\n  --bs-toast-border-color: var(--bs-border-color-translucent);\n  --bs-toast-border-radius: var(--bs-border-radius);\n  --bs-toast-box-shadow: var(--bs-box-shadow);\n  --bs-toast-header-color: var(--bs-secondary-color);\n  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);\n  --bs-toast-header-border-color: var(--bs-border-color-translucent);\n  width: var(--bs-toast-max-width);\n  max-width: 100%;\n  font-size: var(--bs-toast-font-size);\n  color: var(--bs-toast-color);\n  pointer-events: auto;\n  background-color: var(--bs-toast-bg);\n  background-clip: padding-box;\n  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);\n  box-shadow: var(--bs-toast-box-shadow);\n  border-radius: var(--bs-toast-border-radius);\n}\n.toast.showing {\n  opacity: 0;\n}\n.toast:not(.show) {\n  display: none;\n}\n\n.toast-container {\n  --bs-toast-zindex: 1090;\n  position: absolute;\n  z-index: var(--bs-toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n}\n.toast-container > :not(:last-child) {\n  margin-bottom: var(--bs-toast-spacing);\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);\n  color: var(--bs-toast-header-color);\n  background-color: var(--bs-toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);\n  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n}\n.toast-header .btn-close {\n  margin-right: calc(-.5 * var(--bs-toast-padding-x));\n  margin-left: var(--bs-toast-padding-x);\n}\n\n.toast-body {\n  padding: var(--bs-toast-padding-x);\n  word-wrap: break-word;\n}\n\n.modal {\n  --bs-modal-zindex: 1055;\n  --bs-modal-width: 500px;\n  --bs-modal-padding: 1.75rem;\n  --bs-modal-margin: 0.5rem;\n  --bs-modal-color: var(--bs-body-color);\n  --bs-modal-bg: #ffffff;\n  --bs-modal-border-color: var(--bs-border-color-translucent);\n  --bs-modal-border-width: 0;\n  --bs-modal-border-radius: 0.475rem;\n  --bs-modal-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);\n  --bs-modal-inner-border-radius: 0.475rem;\n  --bs-modal-header-padding-x: 1.75rem;\n  --bs-modal-header-padding-y: 1.75rem;\n  --bs-modal-header-padding: 1.75rem 1.75rem;\n  --bs-modal-header-border-color: #EFF2F5;\n  --bs-modal-header-border-width: 1px;\n  --bs-modal-title-line-height: 1.5;\n  --bs-modal-footer-gap: 0.5rem;\n  --bs-modal-footer-bg: ;\n  --bs-modal-footer-border-color: #EFF2F5;\n  --bs-modal-footer-border-width: 1px;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--bs-modal-margin);\n  pointer-events: none;\n}\n.modal.fade .modal-dialog {\n  transform: translate(0, -50px);\n  transition: transform 0.3s ease-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n.modal.show .modal-dialog {\n  transform: none;\n}\n.modal.modal-static .modal-dialog {\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--bs-modal-margin) * 2);\n}\n.modal-dialog-scrollable .modal-content {\n  max-height: 100%;\n  overflow: hidden;\n}\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--bs-modal-margin) * 2);\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  color: var(--bs-modal-color);\n  pointer-events: auto;\n  background-color: var(--bs-modal-bg);\n  background-clip: padding-box;\n  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);\n  border-radius: var(--bs-modal-border-radius);\n  box-shadow: var(--bs-modal-box-shadow);\n  outline: 0;\n}\n\n.modal-backdrop {\n  --bs-backdrop-zindex: 1050;\n  --bs-backdrop-bg: #000000;\n  --bs-backdrop-opacity: 0.3;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-backdrop-zindex);\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--bs-backdrop-bg);\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.show {\n  opacity: var(--bs-backdrop-opacity);\n}\n\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--bs-modal-header-padding);\n  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);\n  border-top-left-radius: var(--bs-modal-inner-border-radius);\n  border-top-right-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-header .btn-close {\n  padding: calc(var(--bs-modal-header-padding-y) * .5) calc(var(--bs-modal-header-padding-x) * .5);\n  margin-top: calc(-.5 * var(--bs-modal-header-padding-y));\n  margin-right: calc(-.5 * var(--bs-modal-header-padding-x));\n  margin-bottom: calc(-.5 * var(--bs-modal-header-padding-y));\n  margin-left: auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--bs-modal-title-line-height);\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: var(--bs-modal-padding);\n}\n\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * .5);\n  background-color: var(--bs-modal-footer-bg);\n  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);\n  border-bottom-right-radius: var(--bs-modal-inner-border-radius);\n  border-bottom-left-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-footer > * {\n  margin: calc(var(--bs-modal-footer-gap) * .5);\n}\n\n@media (min-width: 576px) {\n  .modal {\n    --bs-modal-margin: 1.75rem;\n    --bs-modal-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);\n  }\n\n  .modal-dialog {\n    max-width: var(--bs-modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --bs-modal-width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg,\n.modal-xl {\n    --bs-modal-width: 800px;\n  }\n}\n@media (min-width: 1200px) {\n  .modal-xl {\n    --bs-modal-width: 1140px;\n  }\n}\n.modal-fullscreen {\n  width: 100vw;\n  max-width: none;\n  height: 100%;\n  margin: 0;\n}\n.modal-fullscreen .modal-content {\n  height: 100%;\n  border: 0;\n  border-radius: 0;\n}\n.modal-fullscreen .modal-header,\n.modal-fullscreen .modal-footer {\n  border-radius: 0;\n}\n.modal-fullscreen .modal-body {\n  overflow-y: auto;\n}\n\n@media (max-width: 575.98px) {\n  .modal-fullscreen-sm-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-sm-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-header,\n.modal-fullscreen-sm-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 767.98px) {\n  .modal-fullscreen-md-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-md-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-header,\n.modal-fullscreen-md-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 991.98px) {\n  .modal-fullscreen-lg-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-lg-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-header,\n.modal-fullscreen-lg-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1199.98px) {\n  .modal-fullscreen-xl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-header,\n.modal-fullscreen-xl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1399.98px) {\n  .modal-fullscreen-xxl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-header,\n.modal-fullscreen-xxl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n.tooltip {\n  --bs-tooltip-zindex: 1080;\n  --bs-tooltip-max-width: 200px;\n  --bs-tooltip-padding-x: 1rem;\n  --bs-tooltip-padding-y: 0.75rem;\n  --bs-tooltip-margin: 0;\n  --bs-tooltip-font-size: 0.925rem;\n  --bs-tooltip-color: #3F4254;\n  --bs-tooltip-bg: #ffffff;\n  --bs-tooltip-border-radius: 0.475rem;\n  --bs-tooltip-opacity: 1;\n  --bs-tooltip-arrow-width: 0.8rem;\n  --bs-tooltip-arrow-height: 0.4rem;\n  z-index: var(--bs-tooltip-zindex);\n  display: block;\n  margin: var(--bs-tooltip-margin);\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-tooltip-font-size);\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n  opacity: var(--bs-tooltip-opacity);\n}\n.tooltip .tooltip-arrow {\n  display: block;\n  width: var(--bs-tooltip-arrow-width);\n  height: var(--bs-tooltip-arrow-height);\n}\n.tooltip .tooltip-arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {\n  bottom: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n  top: -1px;\n  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * .5) 0;\n  border-top-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {\n  left: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n  right: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * .5) 0;\n  border-right-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {\n  top: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n  bottom: -1px;\n  border-width: 0 calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height);\n  border-bottom-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {\n  right: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n  left: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * .5) 0 calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height);\n  border-left-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.tooltip-inner {\n  max-width: var(--bs-tooltip-max-width);\n  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);\n  color: var(--bs-tooltip-color);\n  text-align: center;\n  background-color: var(--bs-tooltip-bg);\n  border-radius: var(--bs-tooltip-border-radius);\n}\n\n.popover {\n  --bs-popover-zindex: 1070;\n  --bs-popover-max-width: 276px;\n  --bs-popover-font-size: 1rem;\n  --bs-popover-bg: #ffffff;\n  --bs-popover-border-width: var(--bs-border-width);\n  --bs-popover-border-color: #ffffff;\n  --bs-popover-border-radius: 0.475rem;\n  --bs-popover-inner-border-radius: calc(0.475rem - var(--bs-border-width));\n  --bs-popover-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  --bs-popover-header-padding-x: 1.25rem;\n  --bs-popover-header-padding-y: 1rem;\n  --bs-popover-header-font-size: 1rem;\n  --bs-popover-header-color: #3F4254;\n  --bs-popover-header-bg: #ffffff;\n  --bs-popover-body-padding-x: 1.25rem;\n  --bs-popover-body-padding-y: 1.25rem;\n  --bs-popover-body-color: #3F4254;\n  --bs-popover-arrow-width: 1rem;\n  --bs-popover-arrow-height: 0.5rem;\n  --bs-popover-arrow-border: var(--bs-popover-border-color);\n  z-index: var(--bs-popover-zindex);\n  display: block;\n  max-width: var(--bs-popover-max-width);\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-popover-font-size);\n  word-wrap: break-word;\n  background-color: var(--bs-popover-bg);\n  background-clip: padding-box;\n  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-radius: var(--bs-popover-border-radius);\n  box-shadow: var(--bs-popover-box-shadow);\n}\n.popover .popover-arrow {\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  height: var(--bs-popover-arrow-height);\n}\n.popover .popover-arrow::before, .popover .popover-arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n  border-width: 0;\n}\n\n.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {\n  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * .5) 0;\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {\n  bottom: 0;\n  border-top-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  bottom: var(--bs-popover-border-width);\n  border-top-color: var(--bs-popover-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {\n  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * .5) 0;\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {\n  left: 0;\n  border-right-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  left: var(--bs-popover-border-width);\n  border-right-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {\n  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  border-width: 0 calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height);\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {\n  top: 0;\n  border-bottom-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  top: var(--bs-popover-border-width);\n  border-bottom-color: var(--bs-popover-bg);\n}\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  margin-left: calc(-.5 * var(--bs-popover-arrow-width));\n  content: \"\";\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {\n  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * .5) 0 calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {\n  right: 0;\n  border-left-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  right: var(--bs-popover-border-width);\n  border-left-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.popover-header {\n  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);\n  margin-bottom: 0;\n  font-size: var(--bs-popover-header-font-size);\n  color: var(--bs-popover-header-color);\n  background-color: var(--bs-popover-header-bg);\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-top-left-radius: var(--bs-popover-inner-border-radius);\n  border-top-right-radius: var(--bs-popover-inner-border-radius);\n}\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);\n  color: var(--bs-popover-body-color);\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-start,\n.carousel-fade .carousel-item-prev.carousel-item-end {\n  z-index: 1;\n  opacity: 1;\n}\n.carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  padding: 0;\n  color: #ffffff;\n  text-align: center;\n  background: none;\n  filter: var(--bs-carousel-control-icon-filter);\n  border: 0;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-control-prev,\n.carousel-control-next {\n    transition: none;\n  }\n}\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #ffffff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/%3e%3c/svg%3e\") /*rtl:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e\")*/;\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e\") /*rtl:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/%3e%3c/svg%3e\")*/;\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  margin-right: 15%;\n  margin-bottom: 1rem;\n  margin-left: 15%;\n}\n.carousel-indicators [data-bs-target] {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  padding: 0;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: var(--bs-carousel-indicator-active-bg);\n  background-clip: padding-box;\n  border: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators [data-bs-target] {\n    transition: none;\n  }\n}\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 1.25rem;\n  left: 15%;\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n  color: var(--bs-carousel-caption-color);\n  text-align: center;\n}\n\n.carousel-dark {\n  --bs-carousel-indicator-active-bg: #000000;\n  --bs-carousel-caption-color: #000000;\n  --bs-carousel-control-icon-filter: invert(1) grayscale(100);\n}\n\n:root,\n[data-bs-theme=light] {\n  --bs-carousel-indicator-active-bg: #ffffff;\n  --bs-carousel-caption-color: #ffffff;\n  --bs-carousel-control-icon-filter: ;\n}\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  flex-shrink: 0;\n  width: var(--bs-spinner-width);\n  height: var(--bs-spinner-height);\n  vertical-align: var(--bs-spinner-vertical-align);\n  border-radius: 50%;\n  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg) /* rtl:ignore */;\n  }\n}\n.spinner-border {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-border-width: 0.185em;\n  --bs-spinner-animation-speed: 0.65s;\n  --bs-spinner-animation-name: spinner-border;\n  border: var(--bs-spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n  --bs-spinner-border-width: 0.145em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n.spinner-grow {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-animation-speed: 0.65s;\n  --bs-spinner-animation-name: spinner-grow;\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spinner-border,\n.spinner-grow {\n    --bs-spinner-animation-speed: 1.3s;\n  }\n}\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.text-bg-white {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-white-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-light {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-primary {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-secondary {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-success {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-info {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-warning {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-dark {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.link-white {\n  color: RGBA(var(--bs-white-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-white-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-white:hover, .link-white:focus {\n  color: RGBA(255, 255, 255, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(255, 255, 255, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-light {\n  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-light:hover, .link-light:focus {\n  color: RGBA(247, 249, 251, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(247, 249, 251, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-primary {\n  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-primary:hover, .link-primary:focus {\n  color: RGBA(51, 177, 249, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(51, 177, 249, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-secondary {\n  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-secondary:hover, .link-secondary:focus {\n  color: RGBA(233, 235, 242, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(233, 235, 242, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success {\n  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-success:hover, .link-success:focus {\n  color: RGBA(115, 215, 161, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(115, 215, 161, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-info {\n  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-info:hover, .link-info:focus {\n  color: RGBA(91, 46, 187, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(91, 46, 187, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-warning {\n  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-warning:hover, .link-warning:focus {\n  color: RGBA(255, 210, 51, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(255, 210, 51, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger {\n  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-danger:hover, .link-danger:focus {\n  color: RGBA(244, 103, 137, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(244, 103, 137, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-dark {\n  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-dark:hover, .link-dark:focus {\n  color: RGBA(19, 22, 40, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(19, 22, 40, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-body-emphasis {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-body-emphasis:hover, .link-body-emphasis:focus {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;\n}\n\n.focus-ring:focus {\n  outline: 0;\n  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);\n}\n\n.icon-link {\n  display: inline-flex;\n  gap: 0.375rem;\n  align-items: center;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));\n  text-underline-offset: 0.25em;\n  backface-visibility: hidden;\n}\n.icon-link > .bi {\n  flex-shrink: 0;\n  width: 1em;\n  height: 1em;\n  fill: currentcolor;\n  transition: 0.2s ease-in-out transform;\n}\n@media (prefers-reduced-motion: reduce) {\n  .icon-link > .bi {\n    transition: none;\n  }\n}\n\n.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {\n  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));\n}\n\n.ratio {\n  position: relative;\n  width: 100%;\n}\n.ratio::before {\n  display: block;\n  padding-top: var(--bs-aspect-ratio);\n  content: \"\";\n}\n.ratio > * {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ratio-1x1 {\n  --bs-aspect-ratio: 100%;\n}\n\n.ratio-4x3 {\n  --bs-aspect-ratio: calc(3 / 4 * 100%);\n}\n\n.ratio-16x9 {\n  --bs-aspect-ratio: calc(9 / 16 * 100%);\n}\n\n.ratio-21x9 {\n  --bs-aspect-ratio: calc(9 / 21 * 100%);\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.sticky-top {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n}\n\n.sticky-bottom {\n  position: sticky;\n  bottom: 0;\n  z-index: 1020;\n}\n\n@media (min-width: 576px) {\n  .sticky-sm-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n\n  .sticky-sm-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 768px) {\n  .sticky-md-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n\n  .sticky-md-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 992px) {\n  .sticky-lg-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n\n  .sticky-lg-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1200px) {\n  .sticky-xl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n\n  .sticky-xl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1400px) {\n  .sticky-xxl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n\n  .sticky-xxl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n.visually-hidden:not(caption),\n.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {\n  position: absolute !important;\n}\n.visually-hidden *,\n.visually-hidden-focusable:not(:focus):not(:focus-within) * {\n  overflow: hidden !important;\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  content: \"\";\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.vr {\n  display: inline-block;\n  align-self: stretch;\n  width: var(--bs-border-width);\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: 0.25;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.float-start {\n  float: left !important;\n}\n\n.float-end {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n.object-fit-contain {\n  object-fit: contain !important;\n}\n\n.object-fit-cover {\n  object-fit: cover !important;\n}\n\n.object-fit-fill {\n  object-fit: fill !important;\n}\n\n.object-fit-scale {\n  object-fit: scale-down !important;\n}\n\n.object-fit-none {\n  object-fit: none !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-5 {\n  opacity: 0.05 !important;\n}\n\n.opacity-10 {\n  opacity: 0.1 !important;\n}\n\n.opacity-15 {\n  opacity: 0.15 !important;\n}\n\n.opacity-20 {\n  opacity: 0.2 !important;\n}\n\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-scroll {\n  overflow: scroll !important;\n}\n\n.overflow-x-auto {\n  overflow-x: auto !important;\n}\n\n.overflow-x-hidden {\n  overflow-x: hidden !important;\n}\n\n.overflow-x-visible {\n  overflow-x: visible !important;\n}\n\n.overflow-x-scroll {\n  overflow-x: scroll !important;\n}\n\n.overflow-y-auto {\n  overflow-y: auto !important;\n}\n\n.overflow-y-hidden {\n  overflow-y: hidden !important;\n}\n\n.overflow-y-visible {\n  overflow-y: visible !important;\n}\n\n.overflow-y-scroll {\n  overflow-y: scroll !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-grid {\n  display: grid !important;\n}\n\n.d-inline-grid {\n  display: inline-grid !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.shadow {\n  box-shadow: var(--bs-box-shadow) !important;\n}\n\n.shadow-sm {\n  box-shadow: var(--bs-box-shadow-sm) !important;\n}\n\n.shadow-lg {\n  box-shadow: var(--bs-box-shadow-lg) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.focus-ring-white {\n  --bs-focus-ring-color: rgba(var(--bs-white-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-light {\n  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-primary {\n  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-secondary {\n  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-success {\n  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-info {\n  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-warning {\n  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-danger {\n  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-dark {\n  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.top-0 {\n  top: 0 !important;\n}\n\n.top-25 {\n  top: 25% !important;\n}\n\n.top-50 {\n  top: 50% !important;\n}\n\n.top-75 {\n  top: 75% !important;\n}\n\n.top-100 {\n  top: 100% !important;\n}\n\n.bottom-0 {\n  bottom: 0 !important;\n}\n\n.bottom-25 {\n  bottom: 25% !important;\n}\n\n.bottom-50 {\n  bottom: 50% !important;\n}\n\n.bottom-75 {\n  bottom: 75% !important;\n}\n\n.bottom-100 {\n  bottom: 100% !important;\n}\n\n.start-0 {\n  left: 0 !important;\n}\n\n.start-25 {\n  left: 25% !important;\n}\n\n.start-50 {\n  left: 50% !important;\n}\n\n.start-75 {\n  left: 75% !important;\n}\n\n.start-100 {\n  left: 100% !important;\n}\n\n.end-0 {\n  right: 0 !important;\n}\n\n.end-25 {\n  right: 25% !important;\n}\n\n.end-50 {\n  right: 50% !important;\n}\n\n.end-75 {\n  right: 75% !important;\n}\n\n.end-100 {\n  right: 100% !important;\n}\n\n.translate-middle {\n  transform: translate(-50%, -50%) !important;\n}\n\n.translate-middle-x {\n  transform: translateX(-50%) !important;\n}\n\n.translate-middle-y {\n  transform: translateY(-50%) !important;\n}\n\n.border {\n  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top {\n  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-end {\n  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-end-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom {\n  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-start {\n  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-start-0 {\n  border-left: 0 !important;\n}\n\n.border-white {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-light {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-secondary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-success {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-info {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-warning {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-dark {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-black {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary-subtle {\n  border-color: var(--bs-primary-border-subtle) !important;\n}\n\n.border-secondary-subtle {\n  border-color: var(--bs-secondary-border-subtle) !important;\n}\n\n.border-success-subtle {\n  border-color: var(--bs-success-border-subtle) !important;\n}\n\n.border-info-subtle {\n  border-color: var(--bs-info-border-subtle) !important;\n}\n\n.border-warning-subtle {\n  border-color: var(--bs-warning-border-subtle) !important;\n}\n\n.border-danger-subtle {\n  border-color: var(--bs-danger-border-subtle) !important;\n}\n\n.border-light-subtle {\n  border-color: var(--bs-light-border-subtle) !important;\n}\n\n.border-dark-subtle {\n  border-color: var(--bs-dark-border-subtle) !important;\n}\n\n.border-0 {\n  border-width: 0 !important;\n}\n\n.border-1 {\n  border-width: 1px !important;\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-4 {\n  border-width: 4px !important;\n}\n\n.border-5 {\n  border-width: 5px !important;\n}\n\n.border-opacity-10 {\n  --bs-border-opacity: 0.1;\n}\n\n.border-opacity-25 {\n  --bs-border-opacity: 0.25;\n}\n\n.border-opacity-50 {\n  --bs-border-opacity: 0.5;\n}\n\n.border-opacity-75 {\n  --bs-border-opacity: 0.75;\n}\n\n.border-opacity-100 {\n  --bs-border-opacity: 1;\n}\n\n.w-unset {\n  width: unset !important;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.w-1px {\n  width: 1px !important;\n}\n\n.w-2px {\n  width: 2px !important;\n}\n\n.w-3px {\n  width: 3px !important;\n}\n\n.w-4px {\n  width: 4px !important;\n}\n\n.w-5px {\n  width: 5px !important;\n}\n\n.w-6px {\n  width: 6px !important;\n}\n\n.w-7px {\n  width: 7px !important;\n}\n\n.w-8px {\n  width: 8px !important;\n}\n\n.w-9px {\n  width: 9px !important;\n}\n\n.w-10px {\n  width: 10px !important;\n}\n\n.w-15px {\n  width: 15px !important;\n}\n\n.w-20px {\n  width: 20px !important;\n}\n\n.w-25px {\n  width: 25px !important;\n}\n\n.w-30px {\n  width: 30px !important;\n}\n\n.w-35px {\n  width: 35px !important;\n}\n\n.w-40px {\n  width: 40px !important;\n}\n\n.w-45px {\n  width: 45px !important;\n}\n\n.w-50px {\n  width: 50px !important;\n}\n\n.w-55px {\n  width: 55px !important;\n}\n\n.w-60px {\n  width: 60px !important;\n}\n\n.w-65px {\n  width: 65px !important;\n}\n\n.w-70px {\n  width: 70px !important;\n}\n\n.w-75px {\n  width: 75px !important;\n}\n\n.w-80px {\n  width: 80px !important;\n}\n\n.w-85px {\n  width: 85px !important;\n}\n\n.w-90px {\n  width: 90px !important;\n}\n\n.w-95px {\n  width: 95px !important;\n}\n\n.w-100px {\n  width: 100px !important;\n}\n\n.w-125px {\n  width: 125px !important;\n}\n\n.w-150px {\n  width: 150px !important;\n}\n\n.w-175px {\n  width: 175px !important;\n}\n\n.w-200px {\n  width: 200px !important;\n}\n\n.w-225px {\n  width: 225px !important;\n}\n\n.w-250px {\n  width: 250px !important;\n}\n\n.w-275px {\n  width: 275px !important;\n}\n\n.w-300px {\n  width: 300px !important;\n}\n\n.w-325px {\n  width: 325px !important;\n}\n\n.w-350px {\n  width: 350px !important;\n}\n\n.w-375px {\n  width: 375px !important;\n}\n\n.w-400px {\n  width: 400px !important;\n}\n\n.w-425px {\n  width: 425px !important;\n}\n\n.w-450px {\n  width: 450px !important;\n}\n\n.w-475px {\n  width: 475px !important;\n}\n\n.w-500px {\n  width: 500px !important;\n}\n\n.w-550px {\n  width: 550px !important;\n}\n\n.w-600px {\n  width: 600px !important;\n}\n\n.w-650px {\n  width: 650px !important;\n}\n\n.w-700px {\n  width: 700px !important;\n}\n\n.w-750px {\n  width: 750px !important;\n}\n\n.w-800px {\n  width: 800px !important;\n}\n\n.w-850px {\n  width: 850px !important;\n}\n\n.w-900px {\n  width: 900px !important;\n}\n\n.w-950px {\n  width: 950px !important;\n}\n\n.w-1000px {\n  width: 1000px !important;\n}\n\n.mw-unset {\n  max-width: unset !important;\n}\n\n.mw-25 {\n  max-width: 25% !important;\n}\n\n.mw-50 {\n  max-width: 50% !important;\n}\n\n.mw-75 {\n  max-width: 75% !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.mw-auto {\n  max-width: auto !important;\n}\n\n.mw-1px {\n  max-width: 1px !important;\n}\n\n.mw-2px {\n  max-width: 2px !important;\n}\n\n.mw-3px {\n  max-width: 3px !important;\n}\n\n.mw-4px {\n  max-width: 4px !important;\n}\n\n.mw-5px {\n  max-width: 5px !important;\n}\n\n.mw-6px {\n  max-width: 6px !important;\n}\n\n.mw-7px {\n  max-width: 7px !important;\n}\n\n.mw-8px {\n  max-width: 8px !important;\n}\n\n.mw-9px {\n  max-width: 9px !important;\n}\n\n.mw-10px {\n  max-width: 10px !important;\n}\n\n.mw-15px {\n  max-width: 15px !important;\n}\n\n.mw-20px {\n  max-width: 20px !important;\n}\n\n.mw-25px {\n  max-width: 25px !important;\n}\n\n.mw-30px {\n  max-width: 30px !important;\n}\n\n.mw-35px {\n  max-width: 35px !important;\n}\n\n.mw-40px {\n  max-width: 40px !important;\n}\n\n.mw-45px {\n  max-width: 45px !important;\n}\n\n.mw-50px {\n  max-width: 50px !important;\n}\n\n.mw-55px {\n  max-width: 55px !important;\n}\n\n.mw-60px {\n  max-width: 60px !important;\n}\n\n.mw-65px {\n  max-width: 65px !important;\n}\n\n.mw-70px {\n  max-width: 70px !important;\n}\n\n.mw-75px {\n  max-width: 75px !important;\n}\n\n.mw-80px {\n  max-width: 80px !important;\n}\n\n.mw-85px {\n  max-width: 85px !important;\n}\n\n.mw-90px {\n  max-width: 90px !important;\n}\n\n.mw-95px {\n  max-width: 95px !important;\n}\n\n.mw-100px {\n  max-width: 100px !important;\n}\n\n.mw-125px {\n  max-width: 125px !important;\n}\n\n.mw-150px {\n  max-width: 150px !important;\n}\n\n.mw-175px {\n  max-width: 175px !important;\n}\n\n.mw-200px {\n  max-width: 200px !important;\n}\n\n.mw-225px {\n  max-width: 225px !important;\n}\n\n.mw-250px {\n  max-width: 250px !important;\n}\n\n.mw-275px {\n  max-width: 275px !important;\n}\n\n.mw-300px {\n  max-width: 300px !important;\n}\n\n.mw-325px {\n  max-width: 325px !important;\n}\n\n.mw-350px {\n  max-width: 350px !important;\n}\n\n.mw-375px {\n  max-width: 375px !important;\n}\n\n.mw-400px {\n  max-width: 400px !important;\n}\n\n.mw-425px {\n  max-width: 425px !important;\n}\n\n.mw-450px {\n  max-width: 450px !important;\n}\n\n.mw-475px {\n  max-width: 475px !important;\n}\n\n.mw-500px {\n  max-width: 500px !important;\n}\n\n.mw-550px {\n  max-width: 550px !important;\n}\n\n.mw-600px {\n  max-width: 600px !important;\n}\n\n.mw-650px {\n  max-width: 650px !important;\n}\n\n.mw-700px {\n  max-width: 700px !important;\n}\n\n.mw-750px {\n  max-width: 750px !important;\n}\n\n.mw-800px {\n  max-width: 800px !important;\n}\n\n.mw-850px {\n  max-width: 850px !important;\n}\n\n.mw-900px {\n  max-width: 900px !important;\n}\n\n.mw-950px {\n  max-width: 950px !important;\n}\n\n.mw-1000px {\n  max-width: 1000px !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.h-unset {\n  height: unset !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.h-1px {\n  height: 1px !important;\n}\n\n.h-2px {\n  height: 2px !important;\n}\n\n.h-3px {\n  height: 3px !important;\n}\n\n.h-4px {\n  height: 4px !important;\n}\n\n.h-5px {\n  height: 5px !important;\n}\n\n.h-6px {\n  height: 6px !important;\n}\n\n.h-7px {\n  height: 7px !important;\n}\n\n.h-8px {\n  height: 8px !important;\n}\n\n.h-9px {\n  height: 9px !important;\n}\n\n.h-10px {\n  height: 10px !important;\n}\n\n.h-15px {\n  height: 15px !important;\n}\n\n.h-20px {\n  height: 20px !important;\n}\n\n.h-25px {\n  height: 25px !important;\n}\n\n.h-30px {\n  height: 30px !important;\n}\n\n.h-35px {\n  height: 35px !important;\n}\n\n.h-40px {\n  height: 40px !important;\n}\n\n.h-45px {\n  height: 45px !important;\n}\n\n.h-50px {\n  height: 50px !important;\n}\n\n.h-55px {\n  height: 55px !important;\n}\n\n.h-60px {\n  height: 60px !important;\n}\n\n.h-65px {\n  height: 65px !important;\n}\n\n.h-70px {\n  height: 70px !important;\n}\n\n.h-75px {\n  height: 75px !important;\n}\n\n.h-80px {\n  height: 80px !important;\n}\n\n.h-85px {\n  height: 85px !important;\n}\n\n.h-90px {\n  height: 90px !important;\n}\n\n.h-95px {\n  height: 95px !important;\n}\n\n.h-100px {\n  height: 100px !important;\n}\n\n.h-125px {\n  height: 125px !important;\n}\n\n.h-150px {\n  height: 150px !important;\n}\n\n.h-175px {\n  height: 175px !important;\n}\n\n.h-200px {\n  height: 200px !important;\n}\n\n.h-225px {\n  height: 225px !important;\n}\n\n.h-250px {\n  height: 250px !important;\n}\n\n.h-275px {\n  height: 275px !important;\n}\n\n.h-300px {\n  height: 300px !important;\n}\n\n.h-325px {\n  height: 325px !important;\n}\n\n.h-350px {\n  height: 350px !important;\n}\n\n.h-375px {\n  height: 375px !important;\n}\n\n.h-400px {\n  height: 400px !important;\n}\n\n.h-425px {\n  height: 425px !important;\n}\n\n.h-450px {\n  height: 450px !important;\n}\n\n.h-475px {\n  height: 475px !important;\n}\n\n.h-500px {\n  height: 500px !important;\n}\n\n.h-550px {\n  height: 550px !important;\n}\n\n.h-600px {\n  height: 600px !important;\n}\n\n.h-650px {\n  height: 650px !important;\n}\n\n.h-700px {\n  height: 700px !important;\n}\n\n.h-750px {\n  height: 750px !important;\n}\n\n.h-800px {\n  height: 800px !important;\n}\n\n.h-850px {\n  height: 850px !important;\n}\n\n.h-900px {\n  height: 900px !important;\n}\n\n.h-950px {\n  height: 950px !important;\n}\n\n.h-1000px {\n  height: 1000px !important;\n}\n\n.mh-unset {\n  max-height: unset !important;\n}\n\n.mh-25 {\n  max-height: 25% !important;\n}\n\n.mh-50 {\n  max-height: 50% !important;\n}\n\n.mh-75 {\n  max-height: 75% !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.mh-auto {\n  max-height: auto !important;\n}\n\n.mh-1px {\n  max-height: 1px !important;\n}\n\n.mh-2px {\n  max-height: 2px !important;\n}\n\n.mh-3px {\n  max-height: 3px !important;\n}\n\n.mh-4px {\n  max-height: 4px !important;\n}\n\n.mh-5px {\n  max-height: 5px !important;\n}\n\n.mh-6px {\n  max-height: 6px !important;\n}\n\n.mh-7px {\n  max-height: 7px !important;\n}\n\n.mh-8px {\n  max-height: 8px !important;\n}\n\n.mh-9px {\n  max-height: 9px !important;\n}\n\n.mh-10px {\n  max-height: 10px !important;\n}\n\n.mh-15px {\n  max-height: 15px !important;\n}\n\n.mh-20px {\n  max-height: 20px !important;\n}\n\n.mh-25px {\n  max-height: 25px !important;\n}\n\n.mh-30px {\n  max-height: 30px !important;\n}\n\n.mh-35px {\n  max-height: 35px !important;\n}\n\n.mh-40px {\n  max-height: 40px !important;\n}\n\n.mh-45px {\n  max-height: 45px !important;\n}\n\n.mh-50px {\n  max-height: 50px !important;\n}\n\n.mh-55px {\n  max-height: 55px !important;\n}\n\n.mh-60px {\n  max-height: 60px !important;\n}\n\n.mh-65px {\n  max-height: 65px !important;\n}\n\n.mh-70px {\n  max-height: 70px !important;\n}\n\n.mh-75px {\n  max-height: 75px !important;\n}\n\n.mh-80px {\n  max-height: 80px !important;\n}\n\n.mh-85px {\n  max-height: 85px !important;\n}\n\n.mh-90px {\n  max-height: 90px !important;\n}\n\n.mh-95px {\n  max-height: 95px !important;\n}\n\n.mh-100px {\n  max-height: 100px !important;\n}\n\n.mh-125px {\n  max-height: 125px !important;\n}\n\n.mh-150px {\n  max-height: 150px !important;\n}\n\n.mh-175px {\n  max-height: 175px !important;\n}\n\n.mh-200px {\n  max-height: 200px !important;\n}\n\n.mh-225px {\n  max-height: 225px !important;\n}\n\n.mh-250px {\n  max-height: 250px !important;\n}\n\n.mh-275px {\n  max-height: 275px !important;\n}\n\n.mh-300px {\n  max-height: 300px !important;\n}\n\n.mh-325px {\n  max-height: 325px !important;\n}\n\n.mh-350px {\n  max-height: 350px !important;\n}\n\n.mh-375px {\n  max-height: 375px !important;\n}\n\n.mh-400px {\n  max-height: 400px !important;\n}\n\n.mh-425px {\n  max-height: 425px !important;\n}\n\n.mh-450px {\n  max-height: 450px !important;\n}\n\n.mh-475px {\n  max-height: 475px !important;\n}\n\n.mh-500px {\n  max-height: 500px !important;\n}\n\n.mh-550px {\n  max-height: 550px !important;\n}\n\n.mh-600px {\n  max-height: 600px !important;\n}\n\n.mh-650px {\n  max-height: 650px !important;\n}\n\n.mh-700px {\n  max-height: 700px !important;\n}\n\n.mh-750px {\n  max-height: 750px !important;\n}\n\n.mh-800px {\n  max-height: 800px !important;\n}\n\n.mh-850px {\n  max-height: 850px !important;\n}\n\n.mh-900px {\n  max-height: 900px !important;\n}\n\n.mh-950px {\n  max-height: 950px !important;\n}\n\n.mh-1000px {\n  max-height: 1000px !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n.order-first {\n  order: -1 !important;\n}\n\n.order-0 {\n  order: 0 !important;\n}\n\n.order-1 {\n  order: 1 !important;\n}\n\n.order-2 {\n  order: 2 !important;\n}\n\n.order-3 {\n  order: 3 !important;\n}\n\n.order-4 {\n  order: 4 !important;\n}\n\n.order-5 {\n  order: 5 !important;\n}\n\n.order-last {\n  order: 6 !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 0.75rem !important;\n}\n\n.m-4 {\n  margin: 1rem !important;\n}\n\n.m-5 {\n  margin: 1.25rem !important;\n}\n\n.m-6 {\n  margin: 1.5rem !important;\n}\n\n.m-7 {\n  margin: 1.75rem !important;\n}\n\n.m-8 {\n  margin: 2rem !important;\n}\n\n.m-9 {\n  margin: 2.25rem !important;\n}\n\n.m-10 {\n  margin: 2.5rem !important;\n}\n\n.m-11 {\n  margin: 2.75rem !important;\n}\n\n.m-12 {\n  margin: 3rem !important;\n}\n\n.m-13 {\n  margin: 3.25rem !important;\n}\n\n.m-14 {\n  margin: 3.5rem !important;\n}\n\n.m-15 {\n  margin: 3.75rem !important;\n}\n\n.m-16 {\n  margin: 4rem !important;\n}\n\n.m-17 {\n  margin: 4.25rem !important;\n}\n\n.m-18 {\n  margin: 4.5rem !important;\n}\n\n.m-19 {\n  margin: 4.75rem !important;\n}\n\n.m-20 {\n  margin: 5rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.mx-1 {\n  margin-right: 0.25rem !important;\n  margin-left: 0.25rem !important;\n}\n\n.mx-2 {\n  margin-right: 0.5rem !important;\n  margin-left: 0.5rem !important;\n}\n\n.mx-3 {\n  margin-right: 0.75rem !important;\n  margin-left: 0.75rem !important;\n}\n\n.mx-4 {\n  margin-right: 1rem !important;\n  margin-left: 1rem !important;\n}\n\n.mx-5 {\n  margin-right: 1.25rem !important;\n  margin-left: 1.25rem !important;\n}\n\n.mx-6 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n\n.mx-7 {\n  margin-right: 1.75rem !important;\n  margin-left: 1.75rem !important;\n}\n\n.mx-8 {\n  margin-right: 2rem !important;\n  margin-left: 2rem !important;\n}\n\n.mx-9 {\n  margin-right: 2.25rem !important;\n  margin-left: 2.25rem !important;\n}\n\n.mx-10 {\n  margin-right: 2.5rem !important;\n  margin-left: 2.5rem !important;\n}\n\n.mx-11 {\n  margin-right: 2.75rem !important;\n  margin-left: 2.75rem !important;\n}\n\n.mx-12 {\n  margin-right: 3rem !important;\n  margin-left: 3rem !important;\n}\n\n.mx-13 {\n  margin-right: 3.25rem !important;\n  margin-left: 3.25rem !important;\n}\n\n.mx-14 {\n  margin-right: 3.5rem !important;\n  margin-left: 3.5rem !important;\n}\n\n.mx-15 {\n  margin-right: 3.75rem !important;\n  margin-left: 3.75rem !important;\n}\n\n.mx-16 {\n  margin-right: 4rem !important;\n  margin-left: 4rem !important;\n}\n\n.mx-17 {\n  margin-right: 4.25rem !important;\n  margin-left: 4.25rem !important;\n}\n\n.mx-18 {\n  margin-right: 4.5rem !important;\n  margin-left: 4.5rem !important;\n}\n\n.mx-19 {\n  margin-right: 4.75rem !important;\n  margin-left: 4.75rem !important;\n}\n\n.mx-20 {\n  margin-right: 5rem !important;\n  margin-left: 5rem !important;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.my-1 {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n\n.my-2 {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n\n.my-3 {\n  margin-top: 0.75rem !important;\n  margin-bottom: 0.75rem !important;\n}\n\n.my-4 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n\n.my-5 {\n  margin-top: 1.25rem !important;\n  margin-bottom: 1.25rem !important;\n}\n\n.my-6 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.my-7 {\n  margin-top: 1.75rem !important;\n  margin-bottom: 1.75rem !important;\n}\n\n.my-8 {\n  margin-top: 2rem !important;\n  margin-bottom: 2rem !important;\n}\n\n.my-9 {\n  margin-top: 2.25rem !important;\n  margin-bottom: 2.25rem !important;\n}\n\n.my-10 {\n  margin-top: 2.5rem !important;\n  margin-bottom: 2.5rem !important;\n}\n\n.my-11 {\n  margin-top: 2.75rem !important;\n  margin-bottom: 2.75rem !important;\n}\n\n.my-12 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n\n.my-13 {\n  margin-top: 3.25rem !important;\n  margin-bottom: 3.25rem !important;\n}\n\n.my-14 {\n  margin-top: 3.5rem !important;\n  margin-bottom: 3.5rem !important;\n}\n\n.my-15 {\n  margin-top: 3.75rem !important;\n  margin-bottom: 3.75rem !important;\n}\n\n.my-16 {\n  margin-top: 4rem !important;\n  margin-bottom: 4rem !important;\n}\n\n.my-17 {\n  margin-top: 4.25rem !important;\n  margin-bottom: 4.25rem !important;\n}\n\n.my-18 {\n  margin-top: 4.5rem !important;\n  margin-bottom: 4.5rem !important;\n}\n\n.my-19 {\n  margin-top: 4.75rem !important;\n  margin-bottom: 4.75rem !important;\n}\n\n.my-20 {\n  margin-top: 5rem !important;\n  margin-bottom: 5rem !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mt-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mt-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mt-3 {\n  margin-top: 0.75rem !important;\n}\n\n.mt-4 {\n  margin-top: 1rem !important;\n}\n\n.mt-5 {\n  margin-top: 1.25rem !important;\n}\n\n.mt-6 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-7 {\n  margin-top: 1.75rem !important;\n}\n\n.mt-8 {\n  margin-top: 2rem !important;\n}\n\n.mt-9 {\n  margin-top: 2.25rem !important;\n}\n\n.mt-10 {\n  margin-top: 2.5rem !important;\n}\n\n.mt-11 {\n  margin-top: 2.75rem !important;\n}\n\n.mt-12 {\n  margin-top: 3rem !important;\n}\n\n.mt-13 {\n  margin-top: 3.25rem !important;\n}\n\n.mt-14 {\n  margin-top: 3.5rem !important;\n}\n\n.mt-15 {\n  margin-top: 3.75rem !important;\n}\n\n.mt-16 {\n  margin-top: 4rem !important;\n}\n\n.mt-17 {\n  margin-top: 4.25rem !important;\n}\n\n.mt-18 {\n  margin-top: 4.5rem !important;\n}\n\n.mt-19 {\n  margin-top: 4.75rem !important;\n}\n\n.mt-20 {\n  margin-top: 5rem !important;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.me-0 {\n  margin-right: 0 !important;\n}\n\n.me-1 {\n  margin-right: 0.25rem !important;\n}\n\n.me-2 {\n  margin-right: 0.5rem !important;\n}\n\n.me-3 {\n  margin-right: 0.75rem !important;\n}\n\n.me-4 {\n  margin-right: 1rem !important;\n}\n\n.me-5 {\n  margin-right: 1.25rem !important;\n}\n\n.me-6 {\n  margin-right: 1.5rem !important;\n}\n\n.me-7 {\n  margin-right: 1.75rem !important;\n}\n\n.me-8 {\n  margin-right: 2rem !important;\n}\n\n.me-9 {\n  margin-right: 2.25rem !important;\n}\n\n.me-10 {\n  margin-right: 2.5rem !important;\n}\n\n.me-11 {\n  margin-right: 2.75rem !important;\n}\n\n.me-12 {\n  margin-right: 3rem !important;\n}\n\n.me-13 {\n  margin-right: 3.25rem !important;\n}\n\n.me-14 {\n  margin-right: 3.5rem !important;\n}\n\n.me-15 {\n  margin-right: 3.75rem !important;\n}\n\n.me-16 {\n  margin-right: 4rem !important;\n}\n\n.me-17 {\n  margin-right: 4.25rem !important;\n}\n\n.me-18 {\n  margin-right: 4.5rem !important;\n}\n\n.me-19 {\n  margin-right: 4.75rem !important;\n}\n\n.me-20 {\n  margin-right: 5rem !important;\n}\n\n.me-auto {\n  margin-right: auto !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 0.75rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 1rem !important;\n}\n\n.mb-5 {\n  margin-bottom: 1.25rem !important;\n}\n\n.mb-6 {\n  margin-bottom: 1.5rem !important;\n}\n\n.mb-7 {\n  margin-bottom: 1.75rem !important;\n}\n\n.mb-8 {\n  margin-bottom: 2rem !important;\n}\n\n.mb-9 {\n  margin-bottom: 2.25rem !important;\n}\n\n.mb-10 {\n  margin-bottom: 2.5rem !important;\n}\n\n.mb-11 {\n  margin-bottom: 2.75rem !important;\n}\n\n.mb-12 {\n  margin-bottom: 3rem !important;\n}\n\n.mb-13 {\n  margin-bottom: 3.25rem !important;\n}\n\n.mb-14 {\n  margin-bottom: 3.5rem !important;\n}\n\n.mb-15 {\n  margin-bottom: 3.75rem !important;\n}\n\n.mb-16 {\n  margin-bottom: 4rem !important;\n}\n\n.mb-17 {\n  margin-bottom: 4.25rem !important;\n}\n\n.mb-18 {\n  margin-bottom: 4.5rem !important;\n}\n\n.mb-19 {\n  margin-bottom: 4.75rem !important;\n}\n\n.mb-20 {\n  margin-bottom: 5rem !important;\n}\n\n.mb-auto {\n  margin-bottom: auto !important;\n}\n\n.ms-0 {\n  margin-left: 0 !important;\n}\n\n.ms-1 {\n  margin-left: 0.25rem !important;\n}\n\n.ms-2 {\n  margin-left: 0.5rem !important;\n}\n\n.ms-3 {\n  margin-left: 0.75rem !important;\n}\n\n.ms-4 {\n  margin-left: 1rem !important;\n}\n\n.ms-5 {\n  margin-left: 1.25rem !important;\n}\n\n.ms-6 {\n  margin-left: 1.5rem !important;\n}\n\n.ms-7 {\n  margin-left: 1.75rem !important;\n}\n\n.ms-8 {\n  margin-left: 2rem !important;\n}\n\n.ms-9 {\n  margin-left: 2.25rem !important;\n}\n\n.ms-10 {\n  margin-left: 2.5rem !important;\n}\n\n.ms-11 {\n  margin-left: 2.75rem !important;\n}\n\n.ms-12 {\n  margin-left: 3rem !important;\n}\n\n.ms-13 {\n  margin-left: 3.25rem !important;\n}\n\n.ms-14 {\n  margin-left: 3.5rem !important;\n}\n\n.ms-15 {\n  margin-left: 3.75rem !important;\n}\n\n.ms-16 {\n  margin-left: 4rem !important;\n}\n\n.ms-17 {\n  margin-left: 4.25rem !important;\n}\n\n.ms-18 {\n  margin-left: 4.5rem !important;\n}\n\n.ms-19 {\n  margin-left: 4.75rem !important;\n}\n\n.ms-20 {\n  margin-left: 5rem !important;\n}\n\n.ms-auto {\n  margin-left: auto !important;\n}\n\n.m-n1 {\n  margin: -0.25rem !important;\n}\n\n.m-n2 {\n  margin: -0.5rem !important;\n}\n\n.m-n3 {\n  margin: -0.75rem !important;\n}\n\n.m-n4 {\n  margin: -1rem !important;\n}\n\n.m-n5 {\n  margin: -1.25rem !important;\n}\n\n.m-n6 {\n  margin: -1.5rem !important;\n}\n\n.m-n7 {\n  margin: -1.75rem !important;\n}\n\n.m-n8 {\n  margin: -2rem !important;\n}\n\n.m-n9 {\n  margin: -2.25rem !important;\n}\n\n.m-n10 {\n  margin: -2.5rem !important;\n}\n\n.m-n11 {\n  margin: -2.75rem !important;\n}\n\n.m-n12 {\n  margin: -3rem !important;\n}\n\n.m-n13 {\n  margin: -3.25rem !important;\n}\n\n.m-n14 {\n  margin: -3.5rem !important;\n}\n\n.m-n15 {\n  margin: -3.75rem !important;\n}\n\n.m-n16 {\n  margin: -4rem !important;\n}\n\n.m-n17 {\n  margin: -4.25rem !important;\n}\n\n.m-n18 {\n  margin: -4.5rem !important;\n}\n\n.m-n19 {\n  margin: -4.75rem !important;\n}\n\n.m-n20 {\n  margin: -5rem !important;\n}\n\n.mx-n1 {\n  margin-right: -0.25rem !important;\n  margin-left: -0.25rem !important;\n}\n\n.mx-n2 {\n  margin-right: -0.5rem !important;\n  margin-left: -0.5rem !important;\n}\n\n.mx-n3 {\n  margin-right: -0.75rem !important;\n  margin-left: -0.75rem !important;\n}\n\n.mx-n4 {\n  margin-right: -1rem !important;\n  margin-left: -1rem !important;\n}\n\n.mx-n5 {\n  margin-right: -1.25rem !important;\n  margin-left: -1.25rem !important;\n}\n\n.mx-n6 {\n  margin-right: -1.5rem !important;\n  margin-left: -1.5rem !important;\n}\n\n.mx-n7 {\n  margin-right: -1.75rem !important;\n  margin-left: -1.75rem !important;\n}\n\n.mx-n8 {\n  margin-right: -2rem !important;\n  margin-left: -2rem !important;\n}\n\n.mx-n9 {\n  margin-right: -2.25rem !important;\n  margin-left: -2.25rem !important;\n}\n\n.mx-n10 {\n  margin-right: -2.5rem !important;\n  margin-left: -2.5rem !important;\n}\n\n.mx-n11 {\n  margin-right: -2.75rem !important;\n  margin-left: -2.75rem !important;\n}\n\n.mx-n12 {\n  margin-right: -3rem !important;\n  margin-left: -3rem !important;\n}\n\n.mx-n13 {\n  margin-right: -3.25rem !important;\n  margin-left: -3.25rem !important;\n}\n\n.mx-n14 {\n  margin-right: -3.5rem !important;\n  margin-left: -3.5rem !important;\n}\n\n.mx-n15 {\n  margin-right: -3.75rem !important;\n  margin-left: -3.75rem !important;\n}\n\n.mx-n16 {\n  margin-right: -4rem !important;\n  margin-left: -4rem !important;\n}\n\n.mx-n17 {\n  margin-right: -4.25rem !important;\n  margin-left: -4.25rem !important;\n}\n\n.mx-n18 {\n  margin-right: -4.5rem !important;\n  margin-left: -4.5rem !important;\n}\n\n.mx-n19 {\n  margin-right: -4.75rem !important;\n  margin-left: -4.75rem !important;\n}\n\n.mx-n20 {\n  margin-right: -5rem !important;\n  margin-left: -5rem !important;\n}\n\n.my-n1 {\n  margin-top: -0.25rem !important;\n  margin-bottom: -0.25rem !important;\n}\n\n.my-n2 {\n  margin-top: -0.5rem !important;\n  margin-bottom: -0.5rem !important;\n}\n\n.my-n3 {\n  margin-top: -0.75rem !important;\n  margin-bottom: -0.75rem !important;\n}\n\n.my-n4 {\n  margin-top: -1rem !important;\n  margin-bottom: -1rem !important;\n}\n\n.my-n5 {\n  margin-top: -1.25rem !important;\n  margin-bottom: -1.25rem !important;\n}\n\n.my-n6 {\n  margin-top: -1.5rem !important;\n  margin-bottom: -1.5rem !important;\n}\n\n.my-n7 {\n  margin-top: -1.75rem !important;\n  margin-bottom: -1.75rem !important;\n}\n\n.my-n8 {\n  margin-top: -2rem !important;\n  margin-bottom: -2rem !important;\n}\n\n.my-n9 {\n  margin-top: -2.25rem !important;\n  margin-bottom: -2.25rem !important;\n}\n\n.my-n10 {\n  margin-top: -2.5rem !important;\n  margin-bottom: -2.5rem !important;\n}\n\n.my-n11 {\n  margin-top: -2.75rem !important;\n  margin-bottom: -2.75rem !important;\n}\n\n.my-n12 {\n  margin-top: -3rem !important;\n  margin-bottom: -3rem !important;\n}\n\n.my-n13 {\n  margin-top: -3.25rem !important;\n  margin-bottom: -3.25rem !important;\n}\n\n.my-n14 {\n  margin-top: -3.5rem !important;\n  margin-bottom: -3.5rem !important;\n}\n\n.my-n15 {\n  margin-top: -3.75rem !important;\n  margin-bottom: -3.75rem !important;\n}\n\n.my-n16 {\n  margin-top: -4rem !important;\n  margin-bottom: -4rem !important;\n}\n\n.my-n17 {\n  margin-top: -4.25rem !important;\n  margin-bottom: -4.25rem !important;\n}\n\n.my-n18 {\n  margin-top: -4.5rem !important;\n  margin-bottom: -4.5rem !important;\n}\n\n.my-n19 {\n  margin-top: -4.75rem !important;\n  margin-bottom: -4.75rem !important;\n}\n\n.my-n20 {\n  margin-top: -5rem !important;\n  margin-bottom: -5rem !important;\n}\n\n.mt-n1 {\n  margin-top: -0.25rem !important;\n}\n\n.mt-n2 {\n  margin-top: -0.5rem !important;\n}\n\n.mt-n3 {\n  margin-top: -0.75rem !important;\n}\n\n.mt-n4 {\n  margin-top: -1rem !important;\n}\n\n.mt-n5 {\n  margin-top: -1.25rem !important;\n}\n\n.mt-n6 {\n  margin-top: -1.5rem !important;\n}\n\n.mt-n7 {\n  margin-top: -1.75rem !important;\n}\n\n.mt-n8 {\n  margin-top: -2rem !important;\n}\n\n.mt-n9 {\n  margin-top: -2.25rem !important;\n}\n\n.mt-n10 {\n  margin-top: -2.5rem !important;\n}\n\n.mt-n11 {\n  margin-top: -2.75rem !important;\n}\n\n.mt-n12 {\n  margin-top: -3rem !important;\n}\n\n.mt-n13 {\n  margin-top: -3.25rem !important;\n}\n\n.mt-n14 {\n  margin-top: -3.5rem !important;\n}\n\n.mt-n15 {\n  margin-top: -3.75rem !important;\n}\n\n.mt-n16 {\n  margin-top: -4rem !important;\n}\n\n.mt-n17 {\n  margin-top: -4.25rem !important;\n}\n\n.mt-n18 {\n  margin-top: -4.5rem !important;\n}\n\n.mt-n19 {\n  margin-top: -4.75rem !important;\n}\n\n.mt-n20 {\n  margin-top: -5rem !important;\n}\n\n.me-n1 {\n  margin-right: -0.25rem !important;\n}\n\n.me-n2 {\n  margin-right: -0.5rem !important;\n}\n\n.me-n3 {\n  margin-right: -0.75rem !important;\n}\n\n.me-n4 {\n  margin-right: -1rem !important;\n}\n\n.me-n5 {\n  margin-right: -1.25rem !important;\n}\n\n.me-n6 {\n  margin-right: -1.5rem !important;\n}\n\n.me-n7 {\n  margin-right: -1.75rem !important;\n}\n\n.me-n8 {\n  margin-right: -2rem !important;\n}\n\n.me-n9 {\n  margin-right: -2.25rem !important;\n}\n\n.me-n10 {\n  margin-right: -2.5rem !important;\n}\n\n.me-n11 {\n  margin-right: -2.75rem !important;\n}\n\n.me-n12 {\n  margin-right: -3rem !important;\n}\n\n.me-n13 {\n  margin-right: -3.25rem !important;\n}\n\n.me-n14 {\n  margin-right: -3.5rem !important;\n}\n\n.me-n15 {\n  margin-right: -3.75rem !important;\n}\n\n.me-n16 {\n  margin-right: -4rem !important;\n}\n\n.me-n17 {\n  margin-right: -4.25rem !important;\n}\n\n.me-n18 {\n  margin-right: -4.5rem !important;\n}\n\n.me-n19 {\n  margin-right: -4.75rem !important;\n}\n\n.me-n20 {\n  margin-right: -5rem !important;\n}\n\n.mb-n1 {\n  margin-bottom: -0.25rem !important;\n}\n\n.mb-n2 {\n  margin-bottom: -0.5rem !important;\n}\n\n.mb-n3 {\n  margin-bottom: -0.75rem !important;\n}\n\n.mb-n4 {\n  margin-bottom: -1rem !important;\n}\n\n.mb-n5 {\n  margin-bottom: -1.25rem !important;\n}\n\n.mb-n6 {\n  margin-bottom: -1.5rem !important;\n}\n\n.mb-n7 {\n  margin-bottom: -1.75rem !important;\n}\n\n.mb-n8 {\n  margin-bottom: -2rem !important;\n}\n\n.mb-n9 {\n  margin-bottom: -2.25rem !important;\n}\n\n.mb-n10 {\n  margin-bottom: -2.5rem !important;\n}\n\n.mb-n11 {\n  margin-bottom: -2.75rem !important;\n}\n\n.mb-n12 {\n  margin-bottom: -3rem !important;\n}\n\n.mb-n13 {\n  margin-bottom: -3.25rem !important;\n}\n\n.mb-n14 {\n  margin-bottom: -3.5rem !important;\n}\n\n.mb-n15 {\n  margin-bottom: -3.75rem !important;\n}\n\n.mb-n16 {\n  margin-bottom: -4rem !important;\n}\n\n.mb-n17 {\n  margin-bottom: -4.25rem !important;\n}\n\n.mb-n18 {\n  margin-bottom: -4.5rem !important;\n}\n\n.mb-n19 {\n  margin-bottom: -4.75rem !important;\n}\n\n.mb-n20 {\n  margin-bottom: -5rem !important;\n}\n\n.ms-n1 {\n  margin-left: -0.25rem !important;\n}\n\n.ms-n2 {\n  margin-left: -0.5rem !important;\n}\n\n.ms-n3 {\n  margin-left: -0.75rem !important;\n}\n\n.ms-n4 {\n  margin-left: -1rem !important;\n}\n\n.ms-n5 {\n  margin-left: -1.25rem !important;\n}\n\n.ms-n6 {\n  margin-left: -1.5rem !important;\n}\n\n.ms-n7 {\n  margin-left: -1.75rem !important;\n}\n\n.ms-n8 {\n  margin-left: -2rem !important;\n}\n\n.ms-n9 {\n  margin-left: -2.25rem !important;\n}\n\n.ms-n10 {\n  margin-left: -2.5rem !important;\n}\n\n.ms-n11 {\n  margin-left: -2.75rem !important;\n}\n\n.ms-n12 {\n  margin-left: -3rem !important;\n}\n\n.ms-n13 {\n  margin-left: -3.25rem !important;\n}\n\n.ms-n14 {\n  margin-left: -3.5rem !important;\n}\n\n.ms-n15 {\n  margin-left: -3.75rem !important;\n}\n\n.ms-n16 {\n  margin-left: -4rem !important;\n}\n\n.ms-n17 {\n  margin-left: -4.25rem !important;\n}\n\n.ms-n18 {\n  margin-left: -4.5rem !important;\n}\n\n.ms-n19 {\n  margin-left: -4.75rem !important;\n}\n\n.ms-n20 {\n  margin-left: -5rem !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 0.75rem !important;\n}\n\n.p-4 {\n  padding: 1rem !important;\n}\n\n.p-5 {\n  padding: 1.25rem !important;\n}\n\n.p-6 {\n  padding: 1.5rem !important;\n}\n\n.p-7 {\n  padding: 1.75rem !important;\n}\n\n.p-8 {\n  padding: 2rem !important;\n}\n\n.p-9 {\n  padding: 2.25rem !important;\n}\n\n.p-10 {\n  padding: 2.5rem !important;\n}\n\n.p-11 {\n  padding: 2.75rem !important;\n}\n\n.p-12 {\n  padding: 3rem !important;\n}\n\n.p-13 {\n  padding: 3.25rem !important;\n}\n\n.p-14 {\n  padding: 3.5rem !important;\n}\n\n.p-15 {\n  padding: 3.75rem !important;\n}\n\n.p-16 {\n  padding: 4rem !important;\n}\n\n.p-17 {\n  padding: 4.25rem !important;\n}\n\n.p-18 {\n  padding: 4.5rem !important;\n}\n\n.p-19 {\n  padding: 4.75rem !important;\n}\n\n.p-20 {\n  padding: 5rem !important;\n}\n\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.px-1 {\n  padding-right: 0.25rem !important;\n  padding-left: 0.25rem !important;\n}\n\n.px-2 {\n  padding-right: 0.5rem !important;\n  padding-left: 0.5rem !important;\n}\n\n.px-3 {\n  padding-right: 0.75rem !important;\n  padding-left: 0.75rem !important;\n}\n\n.px-4 {\n  padding-right: 1rem !important;\n  padding-left: 1rem !important;\n}\n\n.px-5 {\n  padding-right: 1.25rem !important;\n  padding-left: 1.25rem !important;\n}\n\n.px-6 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n\n.px-7 {\n  padding-right: 1.75rem !important;\n  padding-left: 1.75rem !important;\n}\n\n.px-8 {\n  padding-right: 2rem !important;\n  padding-left: 2rem !important;\n}\n\n.px-9 {\n  padding-right: 2.25rem !important;\n  padding-left: 2.25rem !important;\n}\n\n.px-10 {\n  padding-right: 2.5rem !important;\n  padding-left: 2.5rem !important;\n}\n\n.px-11 {\n  padding-right: 2.75rem !important;\n  padding-left: 2.75rem !important;\n}\n\n.px-12 {\n  padding-right: 3rem !important;\n  padding-left: 3rem !important;\n}\n\n.px-13 {\n  padding-right: 3.25rem !important;\n  padding-left: 3.25rem !important;\n}\n\n.px-14 {\n  padding-right: 3.5rem !important;\n  padding-left: 3.5rem !important;\n}\n\n.px-15 {\n  padding-right: 3.75rem !important;\n  padding-left: 3.75rem !important;\n}\n\n.px-16 {\n  padding-right: 4rem !important;\n  padding-left: 4rem !important;\n}\n\n.px-17 {\n  padding-right: 4.25rem !important;\n  padding-left: 4.25rem !important;\n}\n\n.px-18 {\n  padding-right: 4.5rem !important;\n  padding-left: 4.5rem !important;\n}\n\n.px-19 {\n  padding-right: 4.75rem !important;\n  padding-left: 4.75rem !important;\n}\n\n.px-20 {\n  padding-right: 5rem !important;\n  padding-left: 5rem !important;\n}\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.py-1 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n\n.py-2 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n\n.py-3 {\n  padding-top: 0.75rem !important;\n  padding-bottom: 0.75rem !important;\n}\n\n.py-4 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n\n.py-5 {\n  padding-top: 1.25rem !important;\n  padding-bottom: 1.25rem !important;\n}\n\n.py-6 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n\n.py-7 {\n  padding-top: 1.75rem !important;\n  padding-bottom: 1.75rem !important;\n}\n\n.py-8 {\n  padding-top: 2rem !important;\n  padding-bottom: 2rem !important;\n}\n\n.py-9 {\n  padding-top: 2.25rem !important;\n  padding-bottom: 2.25rem !important;\n}\n\n.py-10 {\n  padding-top: 2.5rem !important;\n  padding-bottom: 2.5rem !important;\n}\n\n.py-11 {\n  padding-top: 2.75rem !important;\n  padding-bottom: 2.75rem !important;\n}\n\n.py-12 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n\n.py-13 {\n  padding-top: 3.25rem !important;\n  padding-bottom: 3.25rem !important;\n}\n\n.py-14 {\n  padding-top: 3.5rem !important;\n  padding-bottom: 3.5rem !important;\n}\n\n.py-15 {\n  padding-top: 3.75rem !important;\n  padding-bottom: 3.75rem !important;\n}\n\n.py-16 {\n  padding-top: 4rem !important;\n  padding-bottom: 4rem !important;\n}\n\n.py-17 {\n  padding-top: 4.25rem !important;\n  padding-bottom: 4.25rem !important;\n}\n\n.py-18 {\n  padding-top: 4.5rem !important;\n  padding-bottom: 4.5rem !important;\n}\n\n.py-19 {\n  padding-top: 4.75rem !important;\n  padding-bottom: 4.75rem !important;\n}\n\n.py-20 {\n  padding-top: 5rem !important;\n  padding-bottom: 5rem !important;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pt-3 {\n  padding-top: 0.75rem !important;\n}\n\n.pt-4 {\n  padding-top: 1rem !important;\n}\n\n.pt-5 {\n  padding-top: 1.25rem !important;\n}\n\n.pt-6 {\n  padding-top: 1.5rem !important;\n}\n\n.pt-7 {\n  padding-top: 1.75rem !important;\n}\n\n.pt-8 {\n  padding-top: 2rem !important;\n}\n\n.pt-9 {\n  padding-top: 2.25rem !important;\n}\n\n.pt-10 {\n  padding-top: 2.5rem !important;\n}\n\n.pt-11 {\n  padding-top: 2.75rem !important;\n}\n\n.pt-12 {\n  padding-top: 3rem !important;\n}\n\n.pt-13 {\n  padding-top: 3.25rem !important;\n}\n\n.pt-14 {\n  padding-top: 3.5rem !important;\n}\n\n.pt-15 {\n  padding-top: 3.75rem !important;\n}\n\n.pt-16 {\n  padding-top: 4rem !important;\n}\n\n.pt-17 {\n  padding-top: 4.25rem !important;\n}\n\n.pt-18 {\n  padding-top: 4.5rem !important;\n}\n\n.pt-19 {\n  padding-top: 4.75rem !important;\n}\n\n.pt-20 {\n  padding-top: 5rem !important;\n}\n\n.pe-0 {\n  padding-right: 0 !important;\n}\n\n.pe-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pe-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pe-3 {\n  padding-right: 0.75rem !important;\n}\n\n.pe-4 {\n  padding-right: 1rem !important;\n}\n\n.pe-5 {\n  padding-right: 1.25rem !important;\n}\n\n.pe-6 {\n  padding-right: 1.5rem !important;\n}\n\n.pe-7 {\n  padding-right: 1.75rem !important;\n}\n\n.pe-8 {\n  padding-right: 2rem !important;\n}\n\n.pe-9 {\n  padding-right: 2.25rem !important;\n}\n\n.pe-10 {\n  padding-right: 2.5rem !important;\n}\n\n.pe-11 {\n  padding-right: 2.75rem !important;\n}\n\n.pe-12 {\n  padding-right: 3rem !important;\n}\n\n.pe-13 {\n  padding-right: 3.25rem !important;\n}\n\n.pe-14 {\n  padding-right: 3.5rem !important;\n}\n\n.pe-15 {\n  padding-right: 3.75rem !important;\n}\n\n.pe-16 {\n  padding-right: 4rem !important;\n}\n\n.pe-17 {\n  padding-right: 4.25rem !important;\n}\n\n.pe-18 {\n  padding-right: 4.5rem !important;\n}\n\n.pe-19 {\n  padding-right: 4.75rem !important;\n}\n\n.pe-20 {\n  padding-right: 5rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pb-3 {\n  padding-bottom: 0.75rem !important;\n}\n\n.pb-4 {\n  padding-bottom: 1rem !important;\n}\n\n.pb-5 {\n  padding-bottom: 1.25rem !important;\n}\n\n.pb-6 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pb-7 {\n  padding-bottom: 1.75rem !important;\n}\n\n.pb-8 {\n  padding-bottom: 2rem !important;\n}\n\n.pb-9 {\n  padding-bottom: 2.25rem !important;\n}\n\n.pb-10 {\n  padding-bottom: 2.5rem !important;\n}\n\n.pb-11 {\n  padding-bottom: 2.75rem !important;\n}\n\n.pb-12 {\n  padding-bottom: 3rem !important;\n}\n\n.pb-13 {\n  padding-bottom: 3.25rem !important;\n}\n\n.pb-14 {\n  padding-bottom: 3.5rem !important;\n}\n\n.pb-15 {\n  padding-bottom: 3.75rem !important;\n}\n\n.pb-16 {\n  padding-bottom: 4rem !important;\n}\n\n.pb-17 {\n  padding-bottom: 4.25rem !important;\n}\n\n.pb-18 {\n  padding-bottom: 4.5rem !important;\n}\n\n.pb-19 {\n  padding-bottom: 4.75rem !important;\n}\n\n.pb-20 {\n  padding-bottom: 5rem !important;\n}\n\n.ps-0 {\n  padding-left: 0 !important;\n}\n\n.ps-1 {\n  padding-left: 0.25rem !important;\n}\n\n.ps-2 {\n  padding-left: 0.5rem !important;\n}\n\n.ps-3 {\n  padding-left: 0.75rem !important;\n}\n\n.ps-4 {\n  padding-left: 1rem !important;\n}\n\n.ps-5 {\n  padding-left: 1.25rem !important;\n}\n\n.ps-6 {\n  padding-left: 1.5rem !important;\n}\n\n.ps-7 {\n  padding-left: 1.75rem !important;\n}\n\n.ps-8 {\n  padding-left: 2rem !important;\n}\n\n.ps-9 {\n  padding-left: 2.25rem !important;\n}\n\n.ps-10 {\n  padding-left: 2.5rem !important;\n}\n\n.ps-11 {\n  padding-left: 2.75rem !important;\n}\n\n.ps-12 {\n  padding-left: 3rem !important;\n}\n\n.ps-13 {\n  padding-left: 3.25rem !important;\n}\n\n.ps-14 {\n  padding-left: 3.5rem !important;\n}\n\n.ps-15 {\n  padding-left: 3.75rem !important;\n}\n\n.ps-16 {\n  padding-left: 4rem !important;\n}\n\n.ps-17 {\n  padding-left: 4.25rem !important;\n}\n\n.ps-18 {\n  padding-left: 4.5rem !important;\n}\n\n.ps-19 {\n  padding-left: 4.75rem !important;\n}\n\n.ps-20 {\n  padding-left: 5rem !important;\n}\n\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-1 {\n  gap: 0.25rem !important;\n}\n\n.gap-2 {\n  gap: 0.5rem !important;\n}\n\n.gap-3 {\n  gap: 0.75rem !important;\n}\n\n.gap-4 {\n  gap: 1rem !important;\n}\n\n.gap-5 {\n  gap: 1.25rem !important;\n}\n\n.gap-6 {\n  gap: 1.5rem !important;\n}\n\n.gap-7 {\n  gap: 1.75rem !important;\n}\n\n.gap-8 {\n  gap: 2rem !important;\n}\n\n.gap-9 {\n  gap: 2.25rem !important;\n}\n\n.gap-10 {\n  gap: 2.5rem !important;\n}\n\n.gap-11 {\n  gap: 2.75rem !important;\n}\n\n.gap-12 {\n  gap: 3rem !important;\n}\n\n.gap-13 {\n  gap: 3.25rem !important;\n}\n\n.gap-14 {\n  gap: 3.5rem !important;\n}\n\n.gap-15 {\n  gap: 3.75rem !important;\n}\n\n.gap-16 {\n  gap: 4rem !important;\n}\n\n.gap-17 {\n  gap: 4.25rem !important;\n}\n\n.gap-18 {\n  gap: 4.5rem !important;\n}\n\n.gap-19 {\n  gap: 4.75rem !important;\n}\n\n.gap-20 {\n  gap: 5rem !important;\n}\n\n.row-gap-0 {\n  row-gap: 0 !important;\n}\n\n.row-gap-1 {\n  row-gap: 0.25rem !important;\n}\n\n.row-gap-2 {\n  row-gap: 0.5rem !important;\n}\n\n.row-gap-3 {\n  row-gap: 0.75rem !important;\n}\n\n.row-gap-4 {\n  row-gap: 1rem !important;\n}\n\n.row-gap-5 {\n  row-gap: 1.25rem !important;\n}\n\n.row-gap-6 {\n  row-gap: 1.5rem !important;\n}\n\n.row-gap-7 {\n  row-gap: 1.75rem !important;\n}\n\n.row-gap-8 {\n  row-gap: 2rem !important;\n}\n\n.row-gap-9 {\n  row-gap: 2.25rem !important;\n}\n\n.row-gap-10 {\n  row-gap: 2.5rem !important;\n}\n\n.row-gap-11 {\n  row-gap: 2.75rem !important;\n}\n\n.row-gap-12 {\n  row-gap: 3rem !important;\n}\n\n.row-gap-13 {\n  row-gap: 3.25rem !important;\n}\n\n.row-gap-14 {\n  row-gap: 3.5rem !important;\n}\n\n.row-gap-15 {\n  row-gap: 3.75rem !important;\n}\n\n.row-gap-16 {\n  row-gap: 4rem !important;\n}\n\n.row-gap-17 {\n  row-gap: 4.25rem !important;\n}\n\n.row-gap-18 {\n  row-gap: 4.5rem !important;\n}\n\n.row-gap-19 {\n  row-gap: 4.75rem !important;\n}\n\n.row-gap-20 {\n  row-gap: 5rem !important;\n}\n\n.column-gap-0 {\n  column-gap: 0 !important;\n}\n\n.column-gap-1 {\n  column-gap: 0.25rem !important;\n}\n\n.column-gap-2 {\n  column-gap: 0.5rem !important;\n}\n\n.column-gap-3 {\n  column-gap: 0.75rem !important;\n}\n\n.column-gap-4 {\n  column-gap: 1rem !important;\n}\n\n.column-gap-5 {\n  column-gap: 1.25rem !important;\n}\n\n.column-gap-6 {\n  column-gap: 1.5rem !important;\n}\n\n.column-gap-7 {\n  column-gap: 1.75rem !important;\n}\n\n.column-gap-8 {\n  column-gap: 2rem !important;\n}\n\n.column-gap-9 {\n  column-gap: 2.25rem !important;\n}\n\n.column-gap-10 {\n  column-gap: 2.5rem !important;\n}\n\n.column-gap-11 {\n  column-gap: 2.75rem !important;\n}\n\n.column-gap-12 {\n  column-gap: 3rem !important;\n}\n\n.column-gap-13 {\n  column-gap: 3.25rem !important;\n}\n\n.column-gap-14 {\n  column-gap: 3.5rem !important;\n}\n\n.column-gap-15 {\n  column-gap: 3.75rem !important;\n}\n\n.column-gap-16 {\n  column-gap: 4rem !important;\n}\n\n.column-gap-17 {\n  column-gap: 4.25rem !important;\n}\n\n.column-gap-18 {\n  column-gap: 4.5rem !important;\n}\n\n.column-gap-19 {\n  column-gap: 4.75rem !important;\n}\n\n.column-gap-20 {\n  column-gap: 5rem !important;\n}\n\n.font-monospace {\n  font-family: var(--bs-font-monospace) !important;\n}\n\n.fs-1 {\n  font-size: calc(1.3rem + 0.6vw) !important;\n}\n\n.fs-2 {\n  font-size: calc(1.275rem + 0.3vw) !important;\n}\n\n.fs-3 {\n  font-size: calc(1.26rem + 0.12vw) !important;\n}\n\n.fs-4 {\n  font-size: 1.25rem !important;\n}\n\n.fs-5 {\n  font-size: 1.15rem !important;\n}\n\n.fs-6 {\n  font-size: 1.075rem !important;\n}\n\n.fs-7 {\n  font-size: 0.95rem !important;\n}\n\n.fs-8 {\n  font-size: 0.85rem !important;\n}\n\n.fs-9 {\n  font-size: 0.75rem !important;\n}\n\n.fs-10 {\n  font-size: 0.5rem !important;\n}\n\n.fs-base {\n  font-size: 1rem !important;\n}\n\n.fs-fluid {\n  font-size: 100% !important;\n}\n\n.fs-2x {\n  font-size: calc(1.325rem + 0.9vw) !important;\n}\n\n.fs-2qx {\n  font-size: calc(1.35rem + 1.2vw) !important;\n}\n\n.fs-2hx {\n  font-size: calc(1.375rem + 1.5vw) !important;\n}\n\n.fs-2tx {\n  font-size: calc(1.4rem + 1.8vw) !important;\n}\n\n.fs-3x {\n  font-size: calc(1.425rem + 2.1vw) !important;\n}\n\n.fs-3qx {\n  font-size: calc(1.45rem + 2.4vw) !important;\n}\n\n.fs-3hx {\n  font-size: calc(1.475rem + 2.7vw) !important;\n}\n\n.fs-3tx {\n  font-size: calc(1.5rem + 3vw) !important;\n}\n\n.fs-4x {\n  font-size: calc(1.525rem + 3.3vw) !important;\n}\n\n.fs-4qx {\n  font-size: calc(1.55rem + 3.6vw) !important;\n}\n\n.fs-4hx {\n  font-size: calc(1.575rem + 3.9vw) !important;\n}\n\n.fs-4tx {\n  font-size: calc(1.6rem + 4.2vw) !important;\n}\n\n.fs-5x {\n  font-size: calc(1.625rem + 4.5vw) !important;\n}\n\n.fs-5qx {\n  font-size: calc(1.65rem + 4.8vw) !important;\n}\n\n.fs-5hx {\n  font-size: calc(1.675rem + 5.1vw) !important;\n}\n\n.fs-5tx {\n  font-size: calc(1.7rem + 5.4vw) !important;\n}\n\n.fst-italic {\n  font-style: italic !important;\n}\n\n.fst-normal {\n  font-style: normal !important;\n}\n\n.fw-lighter {\n  font-weight: lighter !important;\n}\n\n.fw-light {\n  font-weight: 300 !important;\n}\n\n.fw-normal {\n  font-weight: 400 !important;\n}\n\n.fw-medium {\n  font-weight: 500 !important;\n}\n\n.fw-semibold {\n  font-weight: 600 !important;\n}\n\n.fw-bold {\n  font-weight: 500 !important;\n}\n\n.fw-bolder {\n  font-weight: 600 !important;\n}\n\n.lh-0 {\n  line-height: 0 !important;\n}\n\n.lh-1 {\n  line-height: 1 !important;\n}\n\n.lh-sm {\n  line-height: 1.25 !important;\n}\n\n.lh-base {\n  line-height: 1.5 !important;\n}\n\n.lh-lg {\n  line-height: 1.75 !important;\n}\n\n.lh-xl {\n  line-height: 2 !important;\n}\n\n.lh-xxl {\n  line-height: 2.25 !important;\n}\n\n.text-start {\n  text-align: left !important;\n}\n\n.text-end {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-decoration-underline {\n  text-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n/* rtl:begin:remove */\n.text-break {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n/* rtl:end:remove */\n.text-white {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-light {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-primary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-secondary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-info {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-warning {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-dark {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-black {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-body {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-muted {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-black-50 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-body-secondary {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-body-tertiary {\n  --bs-text-opacity: 1;\n  color: var(--bs-tertiary-color) !important;\n}\n\n.text-body-emphasis {\n  --bs-text-opacity: 1;\n  color: var(--bs-emphasis-color) !important;\n}\n\n.text-reset {\n  --bs-text-opacity: 1;\n  color: inherit !important;\n}\n\n.text-opacity-25 {\n  --bs-text-opacity: 0.25;\n}\n\n.text-opacity-50 {\n  --bs-text-opacity: 0.5;\n}\n\n.text-opacity-75 {\n  --bs-text-opacity: 0.75;\n}\n\n.text-opacity-100 {\n  --bs-text-opacity: 1;\n}\n\n.text-primary-emphasis {\n  color: var(--bs-primary-text-emphasis) !important;\n}\n\n.text-secondary-emphasis {\n  color: var(--bs-secondary-text-emphasis) !important;\n}\n\n.text-success-emphasis {\n  color: var(--bs-success-text-emphasis) !important;\n}\n\n.text-info-emphasis {\n  color: var(--bs-info-text-emphasis) !important;\n}\n\n.text-warning-emphasis {\n  color: var(--bs-warning-text-emphasis) !important;\n}\n\n.text-danger-emphasis {\n  color: var(--bs-danger-text-emphasis) !important;\n}\n\n.text-light-emphasis {\n  color: var(--bs-light-text-emphasis) !important;\n}\n\n.text-dark-emphasis {\n  color: var(--bs-dark-text-emphasis) !important;\n}\n\n.link-opacity-10 {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-10-hover:hover {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-25 {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-25-hover:hover {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-50 {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-50-hover:hover {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-75 {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-75-hover:hover {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-100 {\n  --bs-link-opacity: 1;\n}\n\n.link-opacity-100-hover:hover {\n  --bs-link-opacity: 1;\n}\n\n.link-offset-1 {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-1-hover:hover {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-2 {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-2-hover:hover {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-3 {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-offset-3-hover:hover {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-underline-white {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-white-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-light {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-primary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-secondary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-success {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-info {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-warning {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-danger {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-dark {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-underline-opacity-0 {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-0-hover:hover {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-10 {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-10-hover:hover {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-25 {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-25-hover:hover {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-50 {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-50-hover:hover {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-75 {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-75-hover:hover {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-100 {\n  --bs-link-underline-opacity: 1;\n}\n\n.link-underline-opacity-100-hover:hover {\n  --bs-link-underline-opacity: 1;\n}\n\n.bg-white {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-light {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-primary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-info {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-black {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-transparent {\n  --bs-bg-opacity: 1;\n  background-color: transparent !important;\n}\n\n.bg-body-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body-tertiary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-opacity-10 {\n  --bs-bg-opacity: 0.1;\n}\n\n.bg-opacity-25 {\n  --bs-bg-opacity: 0.25;\n}\n\n.bg-opacity-50 {\n  --bs-bg-opacity: 0.5;\n}\n\n.bg-opacity-75 {\n  --bs-bg-opacity: 0.75;\n}\n\n.bg-opacity-100 {\n  --bs-bg-opacity: 1;\n}\n\n.bg-primary-subtle {\n  background-color: var(--bs-primary-bg-subtle) !important;\n}\n\n.bg-secondary-subtle {\n  background-color: var(--bs-secondary-bg-subtle) !important;\n}\n\n.bg-success-subtle {\n  background-color: var(--bs-success-bg-subtle) !important;\n}\n\n.bg-info-subtle {\n  background-color: var(--bs-info-bg-subtle) !important;\n}\n\n.bg-warning-subtle {\n  background-color: var(--bs-warning-bg-subtle) !important;\n}\n\n.bg-danger-subtle {\n  background-color: var(--bs-danger-bg-subtle) !important;\n}\n\n.bg-light-subtle {\n  background-color: var(--bs-light-bg-subtle) !important;\n}\n\n.bg-dark-subtle {\n  background-color: var(--bs-dark-bg-subtle) !important;\n}\n\n.bg-gradient {\n  background-image: var(--bs-gradient) !important;\n}\n\n.user-select-all {\n  user-select: all !important;\n}\n\n.user-select-auto {\n  user-select: auto !important;\n}\n\n.user-select-none {\n  user-select: none !important;\n}\n\n.pe-none {\n  pointer-events: none !important;\n}\n\n.pe-auto {\n  pointer-events: auto !important;\n}\n\n.rounded {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.rounded-1 {\n  border-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-2 {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-3 {\n  border-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-4 {\n  border-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-5 {\n  border-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-top {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-0 {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.rounded-top-1 {\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-top-2 {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-3 {\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-top-4 {\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-top-5 {\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-top-circle {\n  border-top-left-radius: 50% !important;\n  border-top-right-radius: 50% !important;\n}\n\n.rounded-top-pill {\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-end {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-end-1 {\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-end-2 {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-3 {\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-end-4 {\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-end-5 {\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-end-circle {\n  border-top-right-radius: 50% !important;\n  border-bottom-right-radius: 50% !important;\n}\n\n.rounded-end-pill {\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-0 {\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.rounded-bottom-1 {\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-bottom-2 {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-3 {\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-bottom-4 {\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-bottom-5 {\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-bottom-circle {\n  border-bottom-right-radius: 50% !important;\n  border-bottom-left-radius: 50% !important;\n}\n\n.rounded-bottom-pill {\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-start {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-0 {\n  border-bottom-left-radius: 0 !important;\n  border-top-left-radius: 0 !important;\n}\n\n.rounded-start-1 {\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-start-2 {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-3 {\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-start-4 {\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-start-5 {\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-start-circle {\n  border-bottom-left-radius: 50% !important;\n  border-top-left-radius: 50% !important;\n}\n\n.rounded-start-pill {\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n.z-index-n1 {\n  z-index: -1 !important;\n}\n\n.z-index-n2 {\n  z-index: -2 !important;\n}\n\n.z-index-0 {\n  z-index: 0 !important;\n}\n\n.z-index-1 {\n  z-index: 1 !important;\n}\n\n.z-index-2 {\n  z-index: 2 !important;\n}\n\n.z-index-3 {\n  z-index: 3 !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-0-hover:hover {\n  opacity: 0 !important;\n}\n\n.opacity-5 {\n  opacity: 0.05 !important;\n}\n\n.opacity-5-hover:hover {\n  opacity: 0.05 !important;\n}\n\n.opacity-10 {\n  opacity: 0.1 !important;\n}\n\n.opacity-10-hover:hover {\n  opacity: 0.1 !important;\n}\n\n.opacity-15 {\n  opacity: 0.15 !important;\n}\n\n.opacity-15-hover:hover {\n  opacity: 0.15 !important;\n}\n\n.opacity-20 {\n  opacity: 0.2 !important;\n}\n\n.opacity-20-hover:hover {\n  opacity: 0.2 !important;\n}\n\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n\n.opacity-25-hover:hover {\n  opacity: 0.25 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-50-hover:hover {\n  opacity: 0.5 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.opacity-75-hover:hover {\n  opacity: 0.75 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.opacity-100-hover:hover {\n  opacity: 1 !important;\n}\n\n.min-w-unset {\n  min-width: unset !important;\n}\n\n.min-w-25 {\n  min-width: 25% !important;\n}\n\n.min-w-50 {\n  min-width: 50% !important;\n}\n\n.min-w-75 {\n  min-width: 75% !important;\n}\n\n.min-w-100 {\n  min-width: 100% !important;\n}\n\n.min-w-auto {\n  min-width: auto !important;\n}\n\n.min-w-1px {\n  min-width: 1px !important;\n}\n\n.min-w-2px {\n  min-width: 2px !important;\n}\n\n.min-w-3px {\n  min-width: 3px !important;\n}\n\n.min-w-4px {\n  min-width: 4px !important;\n}\n\n.min-w-5px {\n  min-width: 5px !important;\n}\n\n.min-w-6px {\n  min-width: 6px !important;\n}\n\n.min-w-7px {\n  min-width: 7px !important;\n}\n\n.min-w-8px {\n  min-width: 8px !important;\n}\n\n.min-w-9px {\n  min-width: 9px !important;\n}\n\n.min-w-10px {\n  min-width: 10px !important;\n}\n\n.min-w-15px {\n  min-width: 15px !important;\n}\n\n.min-w-20px {\n  min-width: 20px !important;\n}\n\n.min-w-25px {\n  min-width: 25px !important;\n}\n\n.min-w-30px {\n  min-width: 30px !important;\n}\n\n.min-w-35px {\n  min-width: 35px !important;\n}\n\n.min-w-40px {\n  min-width: 40px !important;\n}\n\n.min-w-45px {\n  min-width: 45px !important;\n}\n\n.min-w-50px {\n  min-width: 50px !important;\n}\n\n.min-w-55px {\n  min-width: 55px !important;\n}\n\n.min-w-60px {\n  min-width: 60px !important;\n}\n\n.min-w-65px {\n  min-width: 65px !important;\n}\n\n.min-w-70px {\n  min-width: 70px !important;\n}\n\n.min-w-75px {\n  min-width: 75px !important;\n}\n\n.min-w-80px {\n  min-width: 80px !important;\n}\n\n.min-w-85px {\n  min-width: 85px !important;\n}\n\n.min-w-90px {\n  min-width: 90px !important;\n}\n\n.min-w-95px {\n  min-width: 95px !important;\n}\n\n.min-w-100px {\n  min-width: 100px !important;\n}\n\n.min-w-125px {\n  min-width: 125px !important;\n}\n\n.min-w-150px {\n  min-width: 150px !important;\n}\n\n.min-w-175px {\n  min-width: 175px !important;\n}\n\n.min-w-200px {\n  min-width: 200px !important;\n}\n\n.min-w-225px {\n  min-width: 225px !important;\n}\n\n.min-w-250px {\n  min-width: 250px !important;\n}\n\n.min-w-275px {\n  min-width: 275px !important;\n}\n\n.min-w-300px {\n  min-width: 300px !important;\n}\n\n.min-w-325px {\n  min-width: 325px !important;\n}\n\n.min-w-350px {\n  min-width: 350px !important;\n}\n\n.min-w-375px {\n  min-width: 375px !important;\n}\n\n.min-w-400px {\n  min-width: 400px !important;\n}\n\n.min-w-425px {\n  min-width: 425px !important;\n}\n\n.min-w-450px {\n  min-width: 450px !important;\n}\n\n.min-w-475px {\n  min-width: 475px !important;\n}\n\n.min-w-500px {\n  min-width: 500px !important;\n}\n\n.min-w-550px {\n  min-width: 550px !important;\n}\n\n.min-w-600px {\n  min-width: 600px !important;\n}\n\n.min-w-650px {\n  min-width: 650px !important;\n}\n\n.min-w-700px {\n  min-width: 700px !important;\n}\n\n.min-w-750px {\n  min-width: 750px !important;\n}\n\n.min-w-800px {\n  min-width: 800px !important;\n}\n\n.min-w-850px {\n  min-width: 850px !important;\n}\n\n.min-w-900px {\n  min-width: 900px !important;\n}\n\n.min-w-950px {\n  min-width: 950px !important;\n}\n\n.min-w-1000px {\n  min-width: 1000px !important;\n}\n\n.min-h-unset {\n  min-height: unset !important;\n}\n\n.min-h-25 {\n  min-height: 25% !important;\n}\n\n.min-h-50 {\n  min-height: 50% !important;\n}\n\n.min-h-75 {\n  min-height: 75% !important;\n}\n\n.min-h-100 {\n  min-height: 100% !important;\n}\n\n.min-h-auto {\n  min-height: auto !important;\n}\n\n.min-h-1px {\n  min-height: 1px !important;\n}\n\n.min-h-2px {\n  min-height: 2px !important;\n}\n\n.min-h-3px {\n  min-height: 3px !important;\n}\n\n.min-h-4px {\n  min-height: 4px !important;\n}\n\n.min-h-5px {\n  min-height: 5px !important;\n}\n\n.min-h-6px {\n  min-height: 6px !important;\n}\n\n.min-h-7px {\n  min-height: 7px !important;\n}\n\n.min-h-8px {\n  min-height: 8px !important;\n}\n\n.min-h-9px {\n  min-height: 9px !important;\n}\n\n.min-h-10px {\n  min-height: 10px !important;\n}\n\n.min-h-15px {\n  min-height: 15px !important;\n}\n\n.min-h-20px {\n  min-height: 20px !important;\n}\n\n.min-h-25px {\n  min-height: 25px !important;\n}\n\n.min-h-30px {\n  min-height: 30px !important;\n}\n\n.min-h-35px {\n  min-height: 35px !important;\n}\n\n.min-h-40px {\n  min-height: 40px !important;\n}\n\n.min-h-45px {\n  min-height: 45px !important;\n}\n\n.min-h-50px {\n  min-height: 50px !important;\n}\n\n.min-h-55px {\n  min-height: 55px !important;\n}\n\n.min-h-60px {\n  min-height: 60px !important;\n}\n\n.min-h-65px {\n  min-height: 65px !important;\n}\n\n.min-h-70px {\n  min-height: 70px !important;\n}\n\n.min-h-75px {\n  min-height: 75px !important;\n}\n\n.min-h-80px {\n  min-height: 80px !important;\n}\n\n.min-h-85px {\n  min-height: 85px !important;\n}\n\n.min-h-90px {\n  min-height: 90px !important;\n}\n\n.min-h-95px {\n  min-height: 95px !important;\n}\n\n.min-h-100px {\n  min-height: 100px !important;\n}\n\n.min-h-125px {\n  min-height: 125px !important;\n}\n\n.min-h-150px {\n  min-height: 150px !important;\n}\n\n.min-h-175px {\n  min-height: 175px !important;\n}\n\n.min-h-200px {\n  min-height: 200px !important;\n}\n\n.min-h-225px {\n  min-height: 225px !important;\n}\n\n.min-h-250px {\n  min-height: 250px !important;\n}\n\n.min-h-275px {\n  min-height: 275px !important;\n}\n\n.min-h-300px {\n  min-height: 300px !important;\n}\n\n.min-h-325px {\n  min-height: 325px !important;\n}\n\n.min-h-350px {\n  min-height: 350px !important;\n}\n\n.min-h-375px {\n  min-height: 375px !important;\n}\n\n.min-h-400px {\n  min-height: 400px !important;\n}\n\n.min-h-425px {\n  min-height: 425px !important;\n}\n\n.min-h-450px {\n  min-height: 450px !important;\n}\n\n.min-h-475px {\n  min-height: 475px !important;\n}\n\n.min-h-500px {\n  min-height: 500px !important;\n}\n\n.min-h-550px {\n  min-height: 550px !important;\n}\n\n.min-h-600px {\n  min-height: 600px !important;\n}\n\n.min-h-650px {\n  min-height: 650px !important;\n}\n\n.min-h-700px {\n  min-height: 700px !important;\n}\n\n.min-h-750px {\n  min-height: 750px !important;\n}\n\n.min-h-800px {\n  min-height: 800px !important;\n}\n\n.min-h-850px {\n  min-height: 850px !important;\n}\n\n.min-h-900px {\n  min-height: 900px !important;\n}\n\n.min-h-950px {\n  min-height: 950px !important;\n}\n\n.min-h-1000px {\n  min-height: 1000px !important;\n}\n\n.border-top-0 {\n  border-top-width: 0 !important;\n}\n\n.border-top-1 {\n  border-top-width: 1px !important;\n}\n\n.border-top-2 {\n  border-top-width: 2px !important;\n}\n\n.border-top-3 {\n  border-top-width: 3px !important;\n}\n\n.border-top-4 {\n  border-top-width: 4px !important;\n}\n\n.border-top-5 {\n  border-top-width: 5px !important;\n}\n\n.border-bottom-0 {\n  border-bottom-width: 0 !important;\n}\n\n.border-bottom-1 {\n  border-bottom-width: 1px !important;\n}\n\n.border-bottom-2 {\n  border-bottom-width: 2px !important;\n}\n\n.border-bottom-3 {\n  border-bottom-width: 3px !important;\n}\n\n.border-bottom-4 {\n  border-bottom-width: 4px !important;\n}\n\n.border-bottom-5 {\n  border-bottom-width: 5px !important;\n}\n\n.border-right-0 {\n  border-right-width: 0 !important;\n}\n\n.border-right-1 {\n  border-right-width: 1px !important;\n}\n\n.border-right-2 {\n  border-right-width: 2px !important;\n}\n\n.border-right-3 {\n  border-right-width: 3px !important;\n}\n\n.border-right-4 {\n  border-right-width: 4px !important;\n}\n\n.border-right-5 {\n  border-right-width: 5px !important;\n}\n\n.border-left-0 {\n  border-left-width: 0 !important;\n}\n\n.border-left-1 {\n  border-left-width: 1px !important;\n}\n\n.border-left-2 {\n  border-left-width: 2px !important;\n}\n\n.border-left-3 {\n  border-left-width: 3px !important;\n}\n\n.border-left-4 {\n  border-left-width: 4px !important;\n}\n\n.border-left-5 {\n  border-left-width: 5px !important;\n}\n\n.ls-1 {\n  letter-spacing: 0.1rem !important;\n}\n\n.ls-2 {\n  letter-spacing: 0.115rem !important;\n}\n\n.ls-3 {\n  letter-spacing: 0.125rem !important;\n}\n\n.ls-4 {\n  letter-spacing: 0.25rem !important;\n}\n\n.ls-5 {\n  letter-spacing: 0.5rem !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-start {\n    float: left !important;\n  }\n\n  .float-sm-end {\n    float: right !important;\n  }\n\n  .float-sm-none {\n    float: none !important;\n  }\n\n  .object-fit-sm-contain {\n    object-fit: contain !important;\n  }\n\n  .object-fit-sm-cover {\n    object-fit: cover !important;\n  }\n\n  .object-fit-sm-fill {\n    object-fit: fill !important;\n  }\n\n  .object-fit-sm-scale {\n    object-fit: scale-down !important;\n  }\n\n  .object-fit-sm-none {\n    object-fit: none !important;\n  }\n\n  .d-sm-inline {\n    display: inline !important;\n  }\n\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-sm-block {\n    display: block !important;\n  }\n\n  .d-sm-grid {\n    display: grid !important;\n  }\n\n  .d-sm-inline-grid {\n    display: inline-grid !important;\n  }\n\n  .d-sm-table {\n    display: table !important;\n  }\n\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-sm-flex {\n    display: flex !important;\n  }\n\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-sm-none {\n    display: none !important;\n  }\n\n  .position-sm-static {\n    position: static !important;\n  }\n\n  .position-sm-relative {\n    position: relative !important;\n  }\n\n  .position-sm-absolute {\n    position: absolute !important;\n  }\n\n  .position-sm-fixed {\n    position: fixed !important;\n  }\n\n  .position-sm-sticky {\n    position: sticky !important;\n  }\n\n  .w-sm-unset {\n    width: unset !important;\n  }\n\n  .w-sm-25 {\n    width: 25% !important;\n  }\n\n  .w-sm-50 {\n    width: 50% !important;\n  }\n\n  .w-sm-75 {\n    width: 75% !important;\n  }\n\n  .w-sm-100 {\n    width: 100% !important;\n  }\n\n  .w-sm-auto {\n    width: auto !important;\n  }\n\n  .w-sm-1px {\n    width: 1px !important;\n  }\n\n  .w-sm-2px {\n    width: 2px !important;\n  }\n\n  .w-sm-3px {\n    width: 3px !important;\n  }\n\n  .w-sm-4px {\n    width: 4px !important;\n  }\n\n  .w-sm-5px {\n    width: 5px !important;\n  }\n\n  .w-sm-6px {\n    width: 6px !important;\n  }\n\n  .w-sm-7px {\n    width: 7px !important;\n  }\n\n  .w-sm-8px {\n    width: 8px !important;\n  }\n\n  .w-sm-9px {\n    width: 9px !important;\n  }\n\n  .w-sm-10px {\n    width: 10px !important;\n  }\n\n  .w-sm-15px {\n    width: 15px !important;\n  }\n\n  .w-sm-20px {\n    width: 20px !important;\n  }\n\n  .w-sm-25px {\n    width: 25px !important;\n  }\n\n  .w-sm-30px {\n    width: 30px !important;\n  }\n\n  .w-sm-35px {\n    width: 35px !important;\n  }\n\n  .w-sm-40px {\n    width: 40px !important;\n  }\n\n  .w-sm-45px {\n    width: 45px !important;\n  }\n\n  .w-sm-50px {\n    width: 50px !important;\n  }\n\n  .w-sm-55px {\n    width: 55px !important;\n  }\n\n  .w-sm-60px {\n    width: 60px !important;\n  }\n\n  .w-sm-65px {\n    width: 65px !important;\n  }\n\n  .w-sm-70px {\n    width: 70px !important;\n  }\n\n  .w-sm-75px {\n    width: 75px !important;\n  }\n\n  .w-sm-80px {\n    width: 80px !important;\n  }\n\n  .w-sm-85px {\n    width: 85px !important;\n  }\n\n  .w-sm-90px {\n    width: 90px !important;\n  }\n\n  .w-sm-95px {\n    width: 95px !important;\n  }\n\n  .w-sm-100px {\n    width: 100px !important;\n  }\n\n  .w-sm-125px {\n    width: 125px !important;\n  }\n\n  .w-sm-150px {\n    width: 150px !important;\n  }\n\n  .w-sm-175px {\n    width: 175px !important;\n  }\n\n  .w-sm-200px {\n    width: 200px !important;\n  }\n\n  .w-sm-225px {\n    width: 225px !important;\n  }\n\n  .w-sm-250px {\n    width: 250px !important;\n  }\n\n  .w-sm-275px {\n    width: 275px !important;\n  }\n\n  .w-sm-300px {\n    width: 300px !important;\n  }\n\n  .w-sm-325px {\n    width: 325px !important;\n  }\n\n  .w-sm-350px {\n    width: 350px !important;\n  }\n\n  .w-sm-375px {\n    width: 375px !important;\n  }\n\n  .w-sm-400px {\n    width: 400px !important;\n  }\n\n  .w-sm-425px {\n    width: 425px !important;\n  }\n\n  .w-sm-450px {\n    width: 450px !important;\n  }\n\n  .w-sm-475px {\n    width: 475px !important;\n  }\n\n  .w-sm-500px {\n    width: 500px !important;\n  }\n\n  .w-sm-550px {\n    width: 550px !important;\n  }\n\n  .w-sm-600px {\n    width: 600px !important;\n  }\n\n  .w-sm-650px {\n    width: 650px !important;\n  }\n\n  .w-sm-700px {\n    width: 700px !important;\n  }\n\n  .w-sm-750px {\n    width: 750px !important;\n  }\n\n  .w-sm-800px {\n    width: 800px !important;\n  }\n\n  .w-sm-850px {\n    width: 850px !important;\n  }\n\n  .w-sm-900px {\n    width: 900px !important;\n  }\n\n  .w-sm-950px {\n    width: 950px !important;\n  }\n\n  .w-sm-1000px {\n    width: 1000px !important;\n  }\n\n  .mw-sm-unset {\n    max-width: unset !important;\n  }\n\n  .mw-sm-25 {\n    max-width: 25% !important;\n  }\n\n  .mw-sm-50 {\n    max-width: 50% !important;\n  }\n\n  .mw-sm-75 {\n    max-width: 75% !important;\n  }\n\n  .mw-sm-100 {\n    max-width: 100% !important;\n  }\n\n  .mw-sm-auto {\n    max-width: auto !important;\n  }\n\n  .mw-sm-1px {\n    max-width: 1px !important;\n  }\n\n  .mw-sm-2px {\n    max-width: 2px !important;\n  }\n\n  .mw-sm-3px {\n    max-width: 3px !important;\n  }\n\n  .mw-sm-4px {\n    max-width: 4px !important;\n  }\n\n  .mw-sm-5px {\n    max-width: 5px !important;\n  }\n\n  .mw-sm-6px {\n    max-width: 6px !important;\n  }\n\n  .mw-sm-7px {\n    max-width: 7px !important;\n  }\n\n  .mw-sm-8px {\n    max-width: 8px !important;\n  }\n\n  .mw-sm-9px {\n    max-width: 9px !important;\n  }\n\n  .mw-sm-10px {\n    max-width: 10px !important;\n  }\n\n  .mw-sm-15px {\n    max-width: 15px !important;\n  }\n\n  .mw-sm-20px {\n    max-width: 20px !important;\n  }\n\n  .mw-sm-25px {\n    max-width: 25px !important;\n  }\n\n  .mw-sm-30px {\n    max-width: 30px !important;\n  }\n\n  .mw-sm-35px {\n    max-width: 35px !important;\n  }\n\n  .mw-sm-40px {\n    max-width: 40px !important;\n  }\n\n  .mw-sm-45px {\n    max-width: 45px !important;\n  }\n\n  .mw-sm-50px {\n    max-width: 50px !important;\n  }\n\n  .mw-sm-55px {\n    max-width: 55px !important;\n  }\n\n  .mw-sm-60px {\n    max-width: 60px !important;\n  }\n\n  .mw-sm-65px {\n    max-width: 65px !important;\n  }\n\n  .mw-sm-70px {\n    max-width: 70px !important;\n  }\n\n  .mw-sm-75px {\n    max-width: 75px !important;\n  }\n\n  .mw-sm-80px {\n    max-width: 80px !important;\n  }\n\n  .mw-sm-85px {\n    max-width: 85px !important;\n  }\n\n  .mw-sm-90px {\n    max-width: 90px !important;\n  }\n\n  .mw-sm-95px {\n    max-width: 95px !important;\n  }\n\n  .mw-sm-100px {\n    max-width: 100px !important;\n  }\n\n  .mw-sm-125px {\n    max-width: 125px !important;\n  }\n\n  .mw-sm-150px {\n    max-width: 150px !important;\n  }\n\n  .mw-sm-175px {\n    max-width: 175px !important;\n  }\n\n  .mw-sm-200px {\n    max-width: 200px !important;\n  }\n\n  .mw-sm-225px {\n    max-width: 225px !important;\n  }\n\n  .mw-sm-250px {\n    max-width: 250px !important;\n  }\n\n  .mw-sm-275px {\n    max-width: 275px !important;\n  }\n\n  .mw-sm-300px {\n    max-width: 300px !important;\n  }\n\n  .mw-sm-325px {\n    max-width: 325px !important;\n  }\n\n  .mw-sm-350px {\n    max-width: 350px !important;\n  }\n\n  .mw-sm-375px {\n    max-width: 375px !important;\n  }\n\n  .mw-sm-400px {\n    max-width: 400px !important;\n  }\n\n  .mw-sm-425px {\n    max-width: 425px !important;\n  }\n\n  .mw-sm-450px {\n    max-width: 450px !important;\n  }\n\n  .mw-sm-475px {\n    max-width: 475px !important;\n  }\n\n  .mw-sm-500px {\n    max-width: 500px !important;\n  }\n\n  .mw-sm-550px {\n    max-width: 550px !important;\n  }\n\n  .mw-sm-600px {\n    max-width: 600px !important;\n  }\n\n  .mw-sm-650px {\n    max-width: 650px !important;\n  }\n\n  .mw-sm-700px {\n    max-width: 700px !important;\n  }\n\n  .mw-sm-750px {\n    max-width: 750px !important;\n  }\n\n  .mw-sm-800px {\n    max-width: 800px !important;\n  }\n\n  .mw-sm-850px {\n    max-width: 850px !important;\n  }\n\n  .mw-sm-900px {\n    max-width: 900px !important;\n  }\n\n  .mw-sm-950px {\n    max-width: 950px !important;\n  }\n\n  .mw-sm-1000px {\n    max-width: 1000px !important;\n  }\n\n  .h-sm-unset {\n    height: unset !important;\n  }\n\n  .h-sm-25 {\n    height: 25% !important;\n  }\n\n  .h-sm-50 {\n    height: 50% !important;\n  }\n\n  .h-sm-75 {\n    height: 75% !important;\n  }\n\n  .h-sm-100 {\n    height: 100% !important;\n  }\n\n  .h-sm-auto {\n    height: auto !important;\n  }\n\n  .h-sm-1px {\n    height: 1px !important;\n  }\n\n  .h-sm-2px {\n    height: 2px !important;\n  }\n\n  .h-sm-3px {\n    height: 3px !important;\n  }\n\n  .h-sm-4px {\n    height: 4px !important;\n  }\n\n  .h-sm-5px {\n    height: 5px !important;\n  }\n\n  .h-sm-6px {\n    height: 6px !important;\n  }\n\n  .h-sm-7px {\n    height: 7px !important;\n  }\n\n  .h-sm-8px {\n    height: 8px !important;\n  }\n\n  .h-sm-9px {\n    height: 9px !important;\n  }\n\n  .h-sm-10px {\n    height: 10px !important;\n  }\n\n  .h-sm-15px {\n    height: 15px !important;\n  }\n\n  .h-sm-20px {\n    height: 20px !important;\n  }\n\n  .h-sm-25px {\n    height: 25px !important;\n  }\n\n  .h-sm-30px {\n    height: 30px !important;\n  }\n\n  .h-sm-35px {\n    height: 35px !important;\n  }\n\n  .h-sm-40px {\n    height: 40px !important;\n  }\n\n  .h-sm-45px {\n    height: 45px !important;\n  }\n\n  .h-sm-50px {\n    height: 50px !important;\n  }\n\n  .h-sm-55px {\n    height: 55px !important;\n  }\n\n  .h-sm-60px {\n    height: 60px !important;\n  }\n\n  .h-sm-65px {\n    height: 65px !important;\n  }\n\n  .h-sm-70px {\n    height: 70px !important;\n  }\n\n  .h-sm-75px {\n    height: 75px !important;\n  }\n\n  .h-sm-80px {\n    height: 80px !important;\n  }\n\n  .h-sm-85px {\n    height: 85px !important;\n  }\n\n  .h-sm-90px {\n    height: 90px !important;\n  }\n\n  .h-sm-95px {\n    height: 95px !important;\n  }\n\n  .h-sm-100px {\n    height: 100px !important;\n  }\n\n  .h-sm-125px {\n    height: 125px !important;\n  }\n\n  .h-sm-150px {\n    height: 150px !important;\n  }\n\n  .h-sm-175px {\n    height: 175px !important;\n  }\n\n  .h-sm-200px {\n    height: 200px !important;\n  }\n\n  .h-sm-225px {\n    height: 225px !important;\n  }\n\n  .h-sm-250px {\n    height: 250px !important;\n  }\n\n  .h-sm-275px {\n    height: 275px !important;\n  }\n\n  .h-sm-300px {\n    height: 300px !important;\n  }\n\n  .h-sm-325px {\n    height: 325px !important;\n  }\n\n  .h-sm-350px {\n    height: 350px !important;\n  }\n\n  .h-sm-375px {\n    height: 375px !important;\n  }\n\n  .h-sm-400px {\n    height: 400px !important;\n  }\n\n  .h-sm-425px {\n    height: 425px !important;\n  }\n\n  .h-sm-450px {\n    height: 450px !important;\n  }\n\n  .h-sm-475px {\n    height: 475px !important;\n  }\n\n  .h-sm-500px {\n    height: 500px !important;\n  }\n\n  .h-sm-550px {\n    height: 550px !important;\n  }\n\n  .h-sm-600px {\n    height: 600px !important;\n  }\n\n  .h-sm-650px {\n    height: 650px !important;\n  }\n\n  .h-sm-700px {\n    height: 700px !important;\n  }\n\n  .h-sm-750px {\n    height: 750px !important;\n  }\n\n  .h-sm-800px {\n    height: 800px !important;\n  }\n\n  .h-sm-850px {\n    height: 850px !important;\n  }\n\n  .h-sm-900px {\n    height: 900px !important;\n  }\n\n  .h-sm-950px {\n    height: 950px !important;\n  }\n\n  .h-sm-1000px {\n    height: 1000px !important;\n  }\n\n  .mh-sm-unset {\n    max-height: unset !important;\n  }\n\n  .mh-sm-25 {\n    max-height: 25% !important;\n  }\n\n  .mh-sm-50 {\n    max-height: 50% !important;\n  }\n\n  .mh-sm-75 {\n    max-height: 75% !important;\n  }\n\n  .mh-sm-100 {\n    max-height: 100% !important;\n  }\n\n  .mh-sm-auto {\n    max-height: auto !important;\n  }\n\n  .mh-sm-1px {\n    max-height: 1px !important;\n  }\n\n  .mh-sm-2px {\n    max-height: 2px !important;\n  }\n\n  .mh-sm-3px {\n    max-height: 3px !important;\n  }\n\n  .mh-sm-4px {\n    max-height: 4px !important;\n  }\n\n  .mh-sm-5px {\n    max-height: 5px !important;\n  }\n\n  .mh-sm-6px {\n    max-height: 6px !important;\n  }\n\n  .mh-sm-7px {\n    max-height: 7px !important;\n  }\n\n  .mh-sm-8px {\n    max-height: 8px !important;\n  }\n\n  .mh-sm-9px {\n    max-height: 9px !important;\n  }\n\n  .mh-sm-10px {\n    max-height: 10px !important;\n  }\n\n  .mh-sm-15px {\n    max-height: 15px !important;\n  }\n\n  .mh-sm-20px {\n    max-height: 20px !important;\n  }\n\n  .mh-sm-25px {\n    max-height: 25px !important;\n  }\n\n  .mh-sm-30px {\n    max-height: 30px !important;\n  }\n\n  .mh-sm-35px {\n    max-height: 35px !important;\n  }\n\n  .mh-sm-40px {\n    max-height: 40px !important;\n  }\n\n  .mh-sm-45px {\n    max-height: 45px !important;\n  }\n\n  .mh-sm-50px {\n    max-height: 50px !important;\n  }\n\n  .mh-sm-55px {\n    max-height: 55px !important;\n  }\n\n  .mh-sm-60px {\n    max-height: 60px !important;\n  }\n\n  .mh-sm-65px {\n    max-height: 65px !important;\n  }\n\n  .mh-sm-70px {\n    max-height: 70px !important;\n  }\n\n  .mh-sm-75px {\n    max-height: 75px !important;\n  }\n\n  .mh-sm-80px {\n    max-height: 80px !important;\n  }\n\n  .mh-sm-85px {\n    max-height: 85px !important;\n  }\n\n  .mh-sm-90px {\n    max-height: 90px !important;\n  }\n\n  .mh-sm-95px {\n    max-height: 95px !important;\n  }\n\n  .mh-sm-100px {\n    max-height: 100px !important;\n  }\n\n  .mh-sm-125px {\n    max-height: 125px !important;\n  }\n\n  .mh-sm-150px {\n    max-height: 150px !important;\n  }\n\n  .mh-sm-175px {\n    max-height: 175px !important;\n  }\n\n  .mh-sm-200px {\n    max-height: 200px !important;\n  }\n\n  .mh-sm-225px {\n    max-height: 225px !important;\n  }\n\n  .mh-sm-250px {\n    max-height: 250px !important;\n  }\n\n  .mh-sm-275px {\n    max-height: 275px !important;\n  }\n\n  .mh-sm-300px {\n    max-height: 300px !important;\n  }\n\n  .mh-sm-325px {\n    max-height: 325px !important;\n  }\n\n  .mh-sm-350px {\n    max-height: 350px !important;\n  }\n\n  .mh-sm-375px {\n    max-height: 375px !important;\n  }\n\n  .mh-sm-400px {\n    max-height: 400px !important;\n  }\n\n  .mh-sm-425px {\n    max-height: 425px !important;\n  }\n\n  .mh-sm-450px {\n    max-height: 450px !important;\n  }\n\n  .mh-sm-475px {\n    max-height: 475px !important;\n  }\n\n  .mh-sm-500px {\n    max-height: 500px !important;\n  }\n\n  .mh-sm-550px {\n    max-height: 550px !important;\n  }\n\n  .mh-sm-600px {\n    max-height: 600px !important;\n  }\n\n  .mh-sm-650px {\n    max-height: 650px !important;\n  }\n\n  .mh-sm-700px {\n    max-height: 700px !important;\n  }\n\n  .mh-sm-750px {\n    max-height: 750px !important;\n  }\n\n  .mh-sm-800px {\n    max-height: 800px !important;\n  }\n\n  .mh-sm-850px {\n    max-height: 850px !important;\n  }\n\n  .mh-sm-900px {\n    max-height: 900px !important;\n  }\n\n  .mh-sm-950px {\n    max-height: 950px !important;\n  }\n\n  .mh-sm-1000px {\n    max-height: 1000px !important;\n  }\n\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n\n  .justify-content-sm-evenly {\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n\n  .order-sm-first {\n    order: -1 !important;\n  }\n\n  .order-sm-0 {\n    order: 0 !important;\n  }\n\n  .order-sm-1 {\n    order: 1 !important;\n  }\n\n  .order-sm-2 {\n    order: 2 !important;\n  }\n\n  .order-sm-3 {\n    order: 3 !important;\n  }\n\n  .order-sm-4 {\n    order: 4 !important;\n  }\n\n  .order-sm-5 {\n    order: 5 !important;\n  }\n\n  .order-sm-last {\n    order: 6 !important;\n  }\n\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-sm-3 {\n    margin: 0.75rem !important;\n  }\n\n  .m-sm-4 {\n    margin: 1rem !important;\n  }\n\n  .m-sm-5 {\n    margin: 1.25rem !important;\n  }\n\n  .m-sm-6 {\n    margin: 1.5rem !important;\n  }\n\n  .m-sm-7 {\n    margin: 1.75rem !important;\n  }\n\n  .m-sm-8 {\n    margin: 2rem !important;\n  }\n\n  .m-sm-9 {\n    margin: 2.25rem !important;\n  }\n\n  .m-sm-10 {\n    margin: 2.5rem !important;\n  }\n\n  .m-sm-11 {\n    margin: 2.75rem !important;\n  }\n\n  .m-sm-12 {\n    margin: 3rem !important;\n  }\n\n  .m-sm-13 {\n    margin: 3.25rem !important;\n  }\n\n  .m-sm-14 {\n    margin: 3.5rem !important;\n  }\n\n  .m-sm-15 {\n    margin: 3.75rem !important;\n  }\n\n  .m-sm-16 {\n    margin: 4rem !important;\n  }\n\n  .m-sm-17 {\n    margin: 4.25rem !important;\n  }\n\n  .m-sm-18 {\n    margin: 4.5rem !important;\n  }\n\n  .m-sm-19 {\n    margin: 4.75rem !important;\n  }\n\n  .m-sm-20 {\n    margin: 5rem !important;\n  }\n\n  .m-sm-auto {\n    margin: auto !important;\n  }\n\n  .mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .mx-sm-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n\n  .mx-sm-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n\n  .mx-sm-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n\n  .mx-sm-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .mx-sm-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n\n  .mx-sm-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n\n  .mx-sm-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n\n  .mx-sm-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n\n  .mx-sm-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n\n  .mx-sm-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n\n  .mx-sm-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n\n  .mx-sm-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n\n  .mx-sm-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n\n  .mx-sm-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n\n  .mx-sm-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n\n  .mx-sm-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n\n  .mx-sm-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n\n  .mx-sm-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n\n  .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-sm-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-sm-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n\n  .my-sm-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-sm-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n\n  .my-sm-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-sm-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n\n  .my-sm-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n\n  .my-sm-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n\n  .my-sm-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n\n  .my-sm-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n\n  .my-sm-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-sm-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n\n  .my-sm-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-sm-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n\n  .my-sm-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-sm-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n\n  .my-sm-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-sm-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n\n  .my-sm-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-sm-0 {\n    margin-top: 0 !important;\n  }\n\n  .mt-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-sm-3 {\n    margin-top: 0.75rem !important;\n  }\n\n  .mt-sm-4 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-sm-5 {\n    margin-top: 1.25rem !important;\n  }\n\n  .mt-sm-6 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-sm-7 {\n    margin-top: 1.75rem !important;\n  }\n\n  .mt-sm-8 {\n    margin-top: 2rem !important;\n  }\n\n  .mt-sm-9 {\n    margin-top: 2.25rem !important;\n  }\n\n  .mt-sm-10 {\n    margin-top: 2.5rem !important;\n  }\n\n  .mt-sm-11 {\n    margin-top: 2.75rem !important;\n  }\n\n  .mt-sm-12 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-sm-13 {\n    margin-top: 3.25rem !important;\n  }\n\n  .mt-sm-14 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-sm-15 {\n    margin-top: 3.75rem !important;\n  }\n\n  .mt-sm-16 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-sm-17 {\n    margin-top: 4.25rem !important;\n  }\n\n  .mt-sm-18 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-sm-19 {\n    margin-top: 4.75rem !important;\n  }\n\n  .mt-sm-20 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-sm-auto {\n    margin-top: auto !important;\n  }\n\n  .me-sm-0 {\n    margin-right: 0 !important;\n  }\n\n  .me-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-sm-3 {\n    margin-right: 0.75rem !important;\n  }\n\n  .me-sm-4 {\n    margin-right: 1rem !important;\n  }\n\n  .me-sm-5 {\n    margin-right: 1.25rem !important;\n  }\n\n  .me-sm-6 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-sm-7 {\n    margin-right: 1.75rem !important;\n  }\n\n  .me-sm-8 {\n    margin-right: 2rem !important;\n  }\n\n  .me-sm-9 {\n    margin-right: 2.25rem !important;\n  }\n\n  .me-sm-10 {\n    margin-right: 2.5rem !important;\n  }\n\n  .me-sm-11 {\n    margin-right: 2.75rem !important;\n  }\n\n  .me-sm-12 {\n    margin-right: 3rem !important;\n  }\n\n  .me-sm-13 {\n    margin-right: 3.25rem !important;\n  }\n\n  .me-sm-14 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-sm-15 {\n    margin-right: 3.75rem !important;\n  }\n\n  .me-sm-16 {\n    margin-right: 4rem !important;\n  }\n\n  .me-sm-17 {\n    margin-right: 4.25rem !important;\n  }\n\n  .me-sm-18 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-sm-19 {\n    margin-right: 4.75rem !important;\n  }\n\n  .me-sm-20 {\n    margin-right: 5rem !important;\n  }\n\n  .me-sm-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-sm-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .mb-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-sm-3 {\n    margin-bottom: 0.75rem !important;\n  }\n\n  .mb-sm-4 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-sm-5 {\n    margin-bottom: 1.25rem !important;\n  }\n\n  .mb-sm-6 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-sm-7 {\n    margin-bottom: 1.75rem !important;\n  }\n\n  .mb-sm-8 {\n    margin-bottom: 2rem !important;\n  }\n\n  .mb-sm-9 {\n    margin-bottom: 2.25rem !important;\n  }\n\n  .mb-sm-10 {\n    margin-bottom: 2.5rem !important;\n  }\n\n  .mb-sm-11 {\n    margin-bottom: 2.75rem !important;\n  }\n\n  .mb-sm-12 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-sm-13 {\n    margin-bottom: 3.25rem !important;\n  }\n\n  .mb-sm-14 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-sm-15 {\n    margin-bottom: 3.75rem !important;\n  }\n\n  .mb-sm-16 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-sm-17 {\n    margin-bottom: 4.25rem !important;\n  }\n\n  .mb-sm-18 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-sm-19 {\n    margin-bottom: 4.75rem !important;\n  }\n\n  .mb-sm-20 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-sm-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-sm-0 {\n    margin-left: 0 !important;\n  }\n\n  .ms-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-sm-3 {\n    margin-left: 0.75rem !important;\n  }\n\n  .ms-sm-4 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-sm-5 {\n    margin-left: 1.25rem !important;\n  }\n\n  .ms-sm-6 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-sm-7 {\n    margin-left: 1.75rem !important;\n  }\n\n  .ms-sm-8 {\n    margin-left: 2rem !important;\n  }\n\n  .ms-sm-9 {\n    margin-left: 2.25rem !important;\n  }\n\n  .ms-sm-10 {\n    margin-left: 2.5rem !important;\n  }\n\n  .ms-sm-11 {\n    margin-left: 2.75rem !important;\n  }\n\n  .ms-sm-12 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-sm-13 {\n    margin-left: 3.25rem !important;\n  }\n\n  .ms-sm-14 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-sm-15 {\n    margin-left: 3.75rem !important;\n  }\n\n  .ms-sm-16 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-sm-17 {\n    margin-left: 4.25rem !important;\n  }\n\n  .ms-sm-18 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-sm-19 {\n    margin-left: 4.75rem !important;\n  }\n\n  .ms-sm-20 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-sm-auto {\n    margin-left: auto !important;\n  }\n\n  .m-sm-n1 {\n    margin: -0.25rem !important;\n  }\n\n  .m-sm-n2 {\n    margin: -0.5rem !important;\n  }\n\n  .m-sm-n3 {\n    margin: -0.75rem !important;\n  }\n\n  .m-sm-n4 {\n    margin: -1rem !important;\n  }\n\n  .m-sm-n5 {\n    margin: -1.25rem !important;\n  }\n\n  .m-sm-n6 {\n    margin: -1.5rem !important;\n  }\n\n  .m-sm-n7 {\n    margin: -1.75rem !important;\n  }\n\n  .m-sm-n8 {\n    margin: -2rem !important;\n  }\n\n  .m-sm-n9 {\n    margin: -2.25rem !important;\n  }\n\n  .m-sm-n10 {\n    margin: -2.5rem !important;\n  }\n\n  .m-sm-n11 {\n    margin: -2.75rem !important;\n  }\n\n  .m-sm-n12 {\n    margin: -3rem !important;\n  }\n\n  .m-sm-n13 {\n    margin: -3.25rem !important;\n  }\n\n  .m-sm-n14 {\n    margin: -3.5rem !important;\n  }\n\n  .m-sm-n15 {\n    margin: -3.75rem !important;\n  }\n\n  .m-sm-n16 {\n    margin: -4rem !important;\n  }\n\n  .m-sm-n17 {\n    margin: -4.25rem !important;\n  }\n\n  .m-sm-n18 {\n    margin: -4.5rem !important;\n  }\n\n  .m-sm-n19 {\n    margin: -4.75rem !important;\n  }\n\n  .m-sm-n20 {\n    margin: -5rem !important;\n  }\n\n  .mx-sm-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n\n  .mx-sm-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n\n  .mx-sm-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n\n  .mx-sm-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n\n  .mx-sm-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n\n  .mx-sm-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n\n  .mx-sm-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n\n  .mx-sm-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n\n  .mx-sm-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n\n  .mx-sm-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n\n  .mx-sm-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n\n  .mx-sm-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n\n  .mx-sm-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n\n  .mx-sm-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n\n  .mx-sm-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n\n  .mx-sm-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n\n  .mx-sm-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n\n  .mx-sm-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n\n  .mx-sm-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n\n  .mx-sm-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n\n  .my-sm-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n\n  .my-sm-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n\n  .my-sm-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n\n  .my-sm-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n\n  .my-sm-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n\n  .my-sm-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n\n  .my-sm-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n\n  .my-sm-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n\n  .my-sm-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n\n  .my-sm-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n\n  .my-sm-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n\n  .my-sm-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n\n  .my-sm-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n\n  .my-sm-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n\n  .my-sm-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n\n  .my-sm-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n\n  .my-sm-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n\n  .my-sm-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n\n  .my-sm-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n\n  .my-sm-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n\n  .mt-sm-n1 {\n    margin-top: -0.25rem !important;\n  }\n\n  .mt-sm-n2 {\n    margin-top: -0.5rem !important;\n  }\n\n  .mt-sm-n3 {\n    margin-top: -0.75rem !important;\n  }\n\n  .mt-sm-n4 {\n    margin-top: -1rem !important;\n  }\n\n  .mt-sm-n5 {\n    margin-top: -1.25rem !important;\n  }\n\n  .mt-sm-n6 {\n    margin-top: -1.5rem !important;\n  }\n\n  .mt-sm-n7 {\n    margin-top: -1.75rem !important;\n  }\n\n  .mt-sm-n8 {\n    margin-top: -2rem !important;\n  }\n\n  .mt-sm-n9 {\n    margin-top: -2.25rem !important;\n  }\n\n  .mt-sm-n10 {\n    margin-top: -2.5rem !important;\n  }\n\n  .mt-sm-n11 {\n    margin-top: -2.75rem !important;\n  }\n\n  .mt-sm-n12 {\n    margin-top: -3rem !important;\n  }\n\n  .mt-sm-n13 {\n    margin-top: -3.25rem !important;\n  }\n\n  .mt-sm-n14 {\n    margin-top: -3.5rem !important;\n  }\n\n  .mt-sm-n15 {\n    margin-top: -3.75rem !important;\n  }\n\n  .mt-sm-n16 {\n    margin-top: -4rem !important;\n  }\n\n  .mt-sm-n17 {\n    margin-top: -4.25rem !important;\n  }\n\n  .mt-sm-n18 {\n    margin-top: -4.5rem !important;\n  }\n\n  .mt-sm-n19 {\n    margin-top: -4.75rem !important;\n  }\n\n  .mt-sm-n20 {\n    margin-top: -5rem !important;\n  }\n\n  .me-sm-n1 {\n    margin-right: -0.25rem !important;\n  }\n\n  .me-sm-n2 {\n    margin-right: -0.5rem !important;\n  }\n\n  .me-sm-n3 {\n    margin-right: -0.75rem !important;\n  }\n\n  .me-sm-n4 {\n    margin-right: -1rem !important;\n  }\n\n  .me-sm-n5 {\n    margin-right: -1.25rem !important;\n  }\n\n  .me-sm-n6 {\n    margin-right: -1.5rem !important;\n  }\n\n  .me-sm-n7 {\n    margin-right: -1.75rem !important;\n  }\n\n  .me-sm-n8 {\n    margin-right: -2rem !important;\n  }\n\n  .me-sm-n9 {\n    margin-right: -2.25rem !important;\n  }\n\n  .me-sm-n10 {\n    margin-right: -2.5rem !important;\n  }\n\n  .me-sm-n11 {\n    margin-right: -2.75rem !important;\n  }\n\n  .me-sm-n12 {\n    margin-right: -3rem !important;\n  }\n\n  .me-sm-n13 {\n    margin-right: -3.25rem !important;\n  }\n\n  .me-sm-n14 {\n    margin-right: -3.5rem !important;\n  }\n\n  .me-sm-n15 {\n    margin-right: -3.75rem !important;\n  }\n\n  .me-sm-n16 {\n    margin-right: -4rem !important;\n  }\n\n  .me-sm-n17 {\n    margin-right: -4.25rem !important;\n  }\n\n  .me-sm-n18 {\n    margin-right: -4.5rem !important;\n  }\n\n  .me-sm-n19 {\n    margin-right: -4.75rem !important;\n  }\n\n  .me-sm-n20 {\n    margin-right: -5rem !important;\n  }\n\n  .mb-sm-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n\n  .mb-sm-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n\n  .mb-sm-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n\n  .mb-sm-n4 {\n    margin-bottom: -1rem !important;\n  }\n\n  .mb-sm-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n\n  .mb-sm-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n\n  .mb-sm-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n\n  .mb-sm-n8 {\n    margin-bottom: -2rem !important;\n  }\n\n  .mb-sm-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n\n  .mb-sm-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n\n  .mb-sm-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n\n  .mb-sm-n12 {\n    margin-bottom: -3rem !important;\n  }\n\n  .mb-sm-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n\n  .mb-sm-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n\n  .mb-sm-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n\n  .mb-sm-n16 {\n    margin-bottom: -4rem !important;\n  }\n\n  .mb-sm-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n\n  .mb-sm-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n\n  .mb-sm-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n\n  .mb-sm-n20 {\n    margin-bottom: -5rem !important;\n  }\n\n  .ms-sm-n1 {\n    margin-left: -0.25rem !important;\n  }\n\n  .ms-sm-n2 {\n    margin-left: -0.5rem !important;\n  }\n\n  .ms-sm-n3 {\n    margin-left: -0.75rem !important;\n  }\n\n  .ms-sm-n4 {\n    margin-left: -1rem !important;\n  }\n\n  .ms-sm-n5 {\n    margin-left: -1.25rem !important;\n  }\n\n  .ms-sm-n6 {\n    margin-left: -1.5rem !important;\n  }\n\n  .ms-sm-n7 {\n    margin-left: -1.75rem !important;\n  }\n\n  .ms-sm-n8 {\n    margin-left: -2rem !important;\n  }\n\n  .ms-sm-n9 {\n    margin-left: -2.25rem !important;\n  }\n\n  .ms-sm-n10 {\n    margin-left: -2.5rem !important;\n  }\n\n  .ms-sm-n11 {\n    margin-left: -2.75rem !important;\n  }\n\n  .ms-sm-n12 {\n    margin-left: -3rem !important;\n  }\n\n  .ms-sm-n13 {\n    margin-left: -3.25rem !important;\n  }\n\n  .ms-sm-n14 {\n    margin-left: -3.5rem !important;\n  }\n\n  .ms-sm-n15 {\n    margin-left: -3.75rem !important;\n  }\n\n  .ms-sm-n16 {\n    margin-left: -4rem !important;\n  }\n\n  .ms-sm-n17 {\n    margin-left: -4.25rem !important;\n  }\n\n  .ms-sm-n18 {\n    margin-left: -4.5rem !important;\n  }\n\n  .ms-sm-n19 {\n    margin-left: -4.75rem !important;\n  }\n\n  .ms-sm-n20 {\n    margin-left: -5rem !important;\n  }\n\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-sm-3 {\n    padding: 0.75rem !important;\n  }\n\n  .p-sm-4 {\n    padding: 1rem !important;\n  }\n\n  .p-sm-5 {\n    padding: 1.25rem !important;\n  }\n\n  .p-sm-6 {\n    padding: 1.5rem !important;\n  }\n\n  .p-sm-7 {\n    padding: 1.75rem !important;\n  }\n\n  .p-sm-8 {\n    padding: 2rem !important;\n  }\n\n  .p-sm-9 {\n    padding: 2.25rem !important;\n  }\n\n  .p-sm-10 {\n    padding: 2.5rem !important;\n  }\n\n  .p-sm-11 {\n    padding: 2.75rem !important;\n  }\n\n  .p-sm-12 {\n    padding: 3rem !important;\n  }\n\n  .p-sm-13 {\n    padding: 3.25rem !important;\n  }\n\n  .p-sm-14 {\n    padding: 3.5rem !important;\n  }\n\n  .p-sm-15 {\n    padding: 3.75rem !important;\n  }\n\n  .p-sm-16 {\n    padding: 4rem !important;\n  }\n\n  .p-sm-17 {\n    padding: 4.25rem !important;\n  }\n\n  .p-sm-18 {\n    padding: 4.5rem !important;\n  }\n\n  .p-sm-19 {\n    padding: 4.75rem !important;\n  }\n\n  .p-sm-20 {\n    padding: 5rem !important;\n  }\n\n  .px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .px-sm-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n\n  .px-sm-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n\n  .px-sm-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n\n  .px-sm-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .px-sm-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n\n  .px-sm-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n\n  .px-sm-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n\n  .px-sm-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n\n  .px-sm-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n\n  .px-sm-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n\n  .px-sm-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n\n  .px-sm-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n\n  .px-sm-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n\n  .px-sm-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n\n  .px-sm-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n\n  .px-sm-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n\n  .px-sm-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n\n  .px-sm-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n\n  .py-sm-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-sm-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n\n  .py-sm-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-sm-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n\n  .py-sm-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-sm-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n\n  .py-sm-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n\n  .py-sm-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n\n  .py-sm-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n\n  .py-sm-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n\n  .py-sm-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .py-sm-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n\n  .py-sm-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-sm-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n\n  .py-sm-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-sm-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n\n  .py-sm-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-sm-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n\n  .py-sm-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .pt-sm-0 {\n    padding-top: 0 !important;\n  }\n\n  .pt-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-sm-3 {\n    padding-top: 0.75rem !important;\n  }\n\n  .pt-sm-4 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-sm-5 {\n    padding-top: 1.25rem !important;\n  }\n\n  .pt-sm-6 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-sm-7 {\n    padding-top: 1.75rem !important;\n  }\n\n  .pt-sm-8 {\n    padding-top: 2rem !important;\n  }\n\n  .pt-sm-9 {\n    padding-top: 2.25rem !important;\n  }\n\n  .pt-sm-10 {\n    padding-top: 2.5rem !important;\n  }\n\n  .pt-sm-11 {\n    padding-top: 2.75rem !important;\n  }\n\n  .pt-sm-12 {\n    padding-top: 3rem !important;\n  }\n\n  .pt-sm-13 {\n    padding-top: 3.25rem !important;\n  }\n\n  .pt-sm-14 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-sm-15 {\n    padding-top: 3.75rem !important;\n  }\n\n  .pt-sm-16 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-sm-17 {\n    padding-top: 4.25rem !important;\n  }\n\n  .pt-sm-18 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-sm-19 {\n    padding-top: 4.75rem !important;\n  }\n\n  .pt-sm-20 {\n    padding-top: 5rem !important;\n  }\n\n  .pe-sm-0 {\n    padding-right: 0 !important;\n  }\n\n  .pe-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-sm-3 {\n    padding-right: 0.75rem !important;\n  }\n\n  .pe-sm-4 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-sm-5 {\n    padding-right: 1.25rem !important;\n  }\n\n  .pe-sm-6 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-sm-7 {\n    padding-right: 1.75rem !important;\n  }\n\n  .pe-sm-8 {\n    padding-right: 2rem !important;\n  }\n\n  .pe-sm-9 {\n    padding-right: 2.25rem !important;\n  }\n\n  .pe-sm-10 {\n    padding-right: 2.5rem !important;\n  }\n\n  .pe-sm-11 {\n    padding-right: 2.75rem !important;\n  }\n\n  .pe-sm-12 {\n    padding-right: 3rem !important;\n  }\n\n  .pe-sm-13 {\n    padding-right: 3.25rem !important;\n  }\n\n  .pe-sm-14 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-sm-15 {\n    padding-right: 3.75rem !important;\n  }\n\n  .pe-sm-16 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-sm-17 {\n    padding-right: 4.25rem !important;\n  }\n\n  .pe-sm-18 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-sm-19 {\n    padding-right: 4.75rem !important;\n  }\n\n  .pe-sm-20 {\n    padding-right: 5rem !important;\n  }\n\n  .pb-sm-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pb-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-sm-3 {\n    padding-bottom: 0.75rem !important;\n  }\n\n  .pb-sm-4 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-sm-5 {\n    padding-bottom: 1.25rem !important;\n  }\n\n  .pb-sm-6 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-sm-7 {\n    padding-bottom: 1.75rem !important;\n  }\n\n  .pb-sm-8 {\n    padding-bottom: 2rem !important;\n  }\n\n  .pb-sm-9 {\n    padding-bottom: 2.25rem !important;\n  }\n\n  .pb-sm-10 {\n    padding-bottom: 2.5rem !important;\n  }\n\n  .pb-sm-11 {\n    padding-bottom: 2.75rem !important;\n  }\n\n  .pb-sm-12 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pb-sm-13 {\n    padding-bottom: 3.25rem !important;\n  }\n\n  .pb-sm-14 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-sm-15 {\n    padding-bottom: 3.75rem !important;\n  }\n\n  .pb-sm-16 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-sm-17 {\n    padding-bottom: 4.25rem !important;\n  }\n\n  .pb-sm-18 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-sm-19 {\n    padding-bottom: 4.75rem !important;\n  }\n\n  .pb-sm-20 {\n    padding-bottom: 5rem !important;\n  }\n\n  .ps-sm-0 {\n    padding-left: 0 !important;\n  }\n\n  .ps-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-sm-3 {\n    padding-left: 0.75rem !important;\n  }\n\n  .ps-sm-4 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-sm-5 {\n    padding-left: 1.25rem !important;\n  }\n\n  .ps-sm-6 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-sm-7 {\n    padding-left: 1.75rem !important;\n  }\n\n  .ps-sm-8 {\n    padding-left: 2rem !important;\n  }\n\n  .ps-sm-9 {\n    padding-left: 2.25rem !important;\n  }\n\n  .ps-sm-10 {\n    padding-left: 2.5rem !important;\n  }\n\n  .ps-sm-11 {\n    padding-left: 2.75rem !important;\n  }\n\n  .ps-sm-12 {\n    padding-left: 3rem !important;\n  }\n\n  .ps-sm-13 {\n    padding-left: 3.25rem !important;\n  }\n\n  .ps-sm-14 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-sm-15 {\n    padding-left: 3.75rem !important;\n  }\n\n  .ps-sm-16 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-sm-17 {\n    padding-left: 4.25rem !important;\n  }\n\n  .ps-sm-18 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-sm-19 {\n    padding-left: 4.75rem !important;\n  }\n\n  .ps-sm-20 {\n    padding-left: 5rem !important;\n  }\n\n  .gap-sm-0 {\n    gap: 0 !important;\n  }\n\n  .gap-sm-1 {\n    gap: 0.25rem !important;\n  }\n\n  .gap-sm-2 {\n    gap: 0.5rem !important;\n  }\n\n  .gap-sm-3 {\n    gap: 0.75rem !important;\n  }\n\n  .gap-sm-4 {\n    gap: 1rem !important;\n  }\n\n  .gap-sm-5 {\n    gap: 1.25rem !important;\n  }\n\n  .gap-sm-6 {\n    gap: 1.5rem !important;\n  }\n\n  .gap-sm-7 {\n    gap: 1.75rem !important;\n  }\n\n  .gap-sm-8 {\n    gap: 2rem !important;\n  }\n\n  .gap-sm-9 {\n    gap: 2.25rem !important;\n  }\n\n  .gap-sm-10 {\n    gap: 2.5rem !important;\n  }\n\n  .gap-sm-11 {\n    gap: 2.75rem !important;\n  }\n\n  .gap-sm-12 {\n    gap: 3rem !important;\n  }\n\n  .gap-sm-13 {\n    gap: 3.25rem !important;\n  }\n\n  .gap-sm-14 {\n    gap: 3.5rem !important;\n  }\n\n  .gap-sm-15 {\n    gap: 3.75rem !important;\n  }\n\n  .gap-sm-16 {\n    gap: 4rem !important;\n  }\n\n  .gap-sm-17 {\n    gap: 4.25rem !important;\n  }\n\n  .gap-sm-18 {\n    gap: 4.5rem !important;\n  }\n\n  .gap-sm-19 {\n    gap: 4.75rem !important;\n  }\n\n  .gap-sm-20 {\n    gap: 5rem !important;\n  }\n\n  .row-gap-sm-0 {\n    row-gap: 0 !important;\n  }\n\n  .row-gap-sm-1 {\n    row-gap: 0.25rem !important;\n  }\n\n  .row-gap-sm-2 {\n    row-gap: 0.5rem !important;\n  }\n\n  .row-gap-sm-3 {\n    row-gap: 0.75rem !important;\n  }\n\n  .row-gap-sm-4 {\n    row-gap: 1rem !important;\n  }\n\n  .row-gap-sm-5 {\n    row-gap: 1.25rem !important;\n  }\n\n  .row-gap-sm-6 {\n    row-gap: 1.5rem !important;\n  }\n\n  .row-gap-sm-7 {\n    row-gap: 1.75rem !important;\n  }\n\n  .row-gap-sm-8 {\n    row-gap: 2rem !important;\n  }\n\n  .row-gap-sm-9 {\n    row-gap: 2.25rem !important;\n  }\n\n  .row-gap-sm-10 {\n    row-gap: 2.5rem !important;\n  }\n\n  .row-gap-sm-11 {\n    row-gap: 2.75rem !important;\n  }\n\n  .row-gap-sm-12 {\n    row-gap: 3rem !important;\n  }\n\n  .row-gap-sm-13 {\n    row-gap: 3.25rem !important;\n  }\n\n  .row-gap-sm-14 {\n    row-gap: 3.5rem !important;\n  }\n\n  .row-gap-sm-15 {\n    row-gap: 3.75rem !important;\n  }\n\n  .row-gap-sm-16 {\n    row-gap: 4rem !important;\n  }\n\n  .row-gap-sm-17 {\n    row-gap: 4.25rem !important;\n  }\n\n  .row-gap-sm-18 {\n    row-gap: 4.5rem !important;\n  }\n\n  .row-gap-sm-19 {\n    row-gap: 4.75rem !important;\n  }\n\n  .row-gap-sm-20 {\n    row-gap: 5rem !important;\n  }\n\n  .column-gap-sm-0 {\n    column-gap: 0 !important;\n  }\n\n  .column-gap-sm-1 {\n    column-gap: 0.25rem !important;\n  }\n\n  .column-gap-sm-2 {\n    column-gap: 0.5rem !important;\n  }\n\n  .column-gap-sm-3 {\n    column-gap: 0.75rem !important;\n  }\n\n  .column-gap-sm-4 {\n    column-gap: 1rem !important;\n  }\n\n  .column-gap-sm-5 {\n    column-gap: 1.25rem !important;\n  }\n\n  .column-gap-sm-6 {\n    column-gap: 1.5rem !important;\n  }\n\n  .column-gap-sm-7 {\n    column-gap: 1.75rem !important;\n  }\n\n  .column-gap-sm-8 {\n    column-gap: 2rem !important;\n  }\n\n  .column-gap-sm-9 {\n    column-gap: 2.25rem !important;\n  }\n\n  .column-gap-sm-10 {\n    column-gap: 2.5rem !important;\n  }\n\n  .column-gap-sm-11 {\n    column-gap: 2.75rem !important;\n  }\n\n  .column-gap-sm-12 {\n    column-gap: 3rem !important;\n  }\n\n  .column-gap-sm-13 {\n    column-gap: 3.25rem !important;\n  }\n\n  .column-gap-sm-14 {\n    column-gap: 3.5rem !important;\n  }\n\n  .column-gap-sm-15 {\n    column-gap: 3.75rem !important;\n  }\n\n  .column-gap-sm-16 {\n    column-gap: 4rem !important;\n  }\n\n  .column-gap-sm-17 {\n    column-gap: 4.25rem !important;\n  }\n\n  .column-gap-sm-18 {\n    column-gap: 4.5rem !important;\n  }\n\n  .column-gap-sm-19 {\n    column-gap: 4.75rem !important;\n  }\n\n  .column-gap-sm-20 {\n    column-gap: 5rem !important;\n  }\n\n  .fs-sm-1 {\n    font-size: calc(1.3rem + 0.6vw) !important;\n  }\n\n  .fs-sm-2 {\n    font-size: calc(1.275rem + 0.3vw) !important;\n  }\n\n  .fs-sm-3 {\n    font-size: calc(1.26rem + 0.12vw) !important;\n  }\n\n  .fs-sm-4 {\n    font-size: 1.25rem !important;\n  }\n\n  .fs-sm-5 {\n    font-size: 1.15rem !important;\n  }\n\n  .fs-sm-6 {\n    font-size: 1.075rem !important;\n  }\n\n  .fs-sm-7 {\n    font-size: 0.95rem !important;\n  }\n\n  .fs-sm-8 {\n    font-size: 0.85rem !important;\n  }\n\n  .fs-sm-9 {\n    font-size: 0.75rem !important;\n  }\n\n  .fs-sm-10 {\n    font-size: 0.5rem !important;\n  }\n\n  .fs-sm-base {\n    font-size: 1rem !important;\n  }\n\n  .fs-sm-fluid {\n    font-size: 100% !important;\n  }\n\n  .fs-sm-2x {\n    font-size: calc(1.325rem + 0.9vw) !important;\n  }\n\n  .fs-sm-2qx {\n    font-size: calc(1.35rem + 1.2vw) !important;\n  }\n\n  .fs-sm-2hx {\n    font-size: calc(1.375rem + 1.5vw) !important;\n  }\n\n  .fs-sm-2tx {\n    font-size: calc(1.4rem + 1.8vw) !important;\n  }\n\n  .fs-sm-3x {\n    font-size: calc(1.425rem + 2.1vw) !important;\n  }\n\n  .fs-sm-3qx {\n    font-size: calc(1.45rem + 2.4vw) !important;\n  }\n\n  .fs-sm-3hx {\n    font-size: calc(1.475rem + 2.7vw) !important;\n  }\n\n  .fs-sm-3tx {\n    font-size: calc(1.5rem + 3vw) !important;\n  }\n\n  .fs-sm-4x {\n    font-size: calc(1.525rem + 3.3vw) !important;\n  }\n\n  .fs-sm-4qx {\n    font-size: calc(1.55rem + 3.6vw) !important;\n  }\n\n  .fs-sm-4hx {\n    font-size: calc(1.575rem + 3.9vw) !important;\n  }\n\n  .fs-sm-4tx {\n    font-size: calc(1.6rem + 4.2vw) !important;\n  }\n\n  .fs-sm-5x {\n    font-size: calc(1.625rem + 4.5vw) !important;\n  }\n\n  .fs-sm-5qx {\n    font-size: calc(1.65rem + 4.8vw) !important;\n  }\n\n  .fs-sm-5hx {\n    font-size: calc(1.675rem + 5.1vw) !important;\n  }\n\n  .fs-sm-5tx {\n    font-size: calc(1.7rem + 5.4vw) !important;\n  }\n\n  .text-sm-start {\n    text-align: left !important;\n  }\n\n  .text-sm-end {\n    text-align: right !important;\n  }\n\n  .text-sm-center {\n    text-align: center !important;\n  }\n\n  .min-w-sm-unset {\n    min-width: unset !important;\n  }\n\n  .min-w-sm-25 {\n    min-width: 25% !important;\n  }\n\n  .min-w-sm-50 {\n    min-width: 50% !important;\n  }\n\n  .min-w-sm-75 {\n    min-width: 75% !important;\n  }\n\n  .min-w-sm-100 {\n    min-width: 100% !important;\n  }\n\n  .min-w-sm-auto {\n    min-width: auto !important;\n  }\n\n  .min-w-sm-1px {\n    min-width: 1px !important;\n  }\n\n  .min-w-sm-2px {\n    min-width: 2px !important;\n  }\n\n  .min-w-sm-3px {\n    min-width: 3px !important;\n  }\n\n  .min-w-sm-4px {\n    min-width: 4px !important;\n  }\n\n  .min-w-sm-5px {\n    min-width: 5px !important;\n  }\n\n  .min-w-sm-6px {\n    min-width: 6px !important;\n  }\n\n  .min-w-sm-7px {\n    min-width: 7px !important;\n  }\n\n  .min-w-sm-8px {\n    min-width: 8px !important;\n  }\n\n  .min-w-sm-9px {\n    min-width: 9px !important;\n  }\n\n  .min-w-sm-10px {\n    min-width: 10px !important;\n  }\n\n  .min-w-sm-15px {\n    min-width: 15px !important;\n  }\n\n  .min-w-sm-20px {\n    min-width: 20px !important;\n  }\n\n  .min-w-sm-25px {\n    min-width: 25px !important;\n  }\n\n  .min-w-sm-30px {\n    min-width: 30px !important;\n  }\n\n  .min-w-sm-35px {\n    min-width: 35px !important;\n  }\n\n  .min-w-sm-40px {\n    min-width: 40px !important;\n  }\n\n  .min-w-sm-45px {\n    min-width: 45px !important;\n  }\n\n  .min-w-sm-50px {\n    min-width: 50px !important;\n  }\n\n  .min-w-sm-55px {\n    min-width: 55px !important;\n  }\n\n  .min-w-sm-60px {\n    min-width: 60px !important;\n  }\n\n  .min-w-sm-65px {\n    min-width: 65px !important;\n  }\n\n  .min-w-sm-70px {\n    min-width: 70px !important;\n  }\n\n  .min-w-sm-75px {\n    min-width: 75px !important;\n  }\n\n  .min-w-sm-80px {\n    min-width: 80px !important;\n  }\n\n  .min-w-sm-85px {\n    min-width: 85px !important;\n  }\n\n  .min-w-sm-90px {\n    min-width: 90px !important;\n  }\n\n  .min-w-sm-95px {\n    min-width: 95px !important;\n  }\n\n  .min-w-sm-100px {\n    min-width: 100px !important;\n  }\n\n  .min-w-sm-125px {\n    min-width: 125px !important;\n  }\n\n  .min-w-sm-150px {\n    min-width: 150px !important;\n  }\n\n  .min-w-sm-175px {\n    min-width: 175px !important;\n  }\n\n  .min-w-sm-200px {\n    min-width: 200px !important;\n  }\n\n  .min-w-sm-225px {\n    min-width: 225px !important;\n  }\n\n  .min-w-sm-250px {\n    min-width: 250px !important;\n  }\n\n  .min-w-sm-275px {\n    min-width: 275px !important;\n  }\n\n  .min-w-sm-300px {\n    min-width: 300px !important;\n  }\n\n  .min-w-sm-325px {\n    min-width: 325px !important;\n  }\n\n  .min-w-sm-350px {\n    min-width: 350px !important;\n  }\n\n  .min-w-sm-375px {\n    min-width: 375px !important;\n  }\n\n  .min-w-sm-400px {\n    min-width: 400px !important;\n  }\n\n  .min-w-sm-425px {\n    min-width: 425px !important;\n  }\n\n  .min-w-sm-450px {\n    min-width: 450px !important;\n  }\n\n  .min-w-sm-475px {\n    min-width: 475px !important;\n  }\n\n  .min-w-sm-500px {\n    min-width: 500px !important;\n  }\n\n  .min-w-sm-550px {\n    min-width: 550px !important;\n  }\n\n  .min-w-sm-600px {\n    min-width: 600px !important;\n  }\n\n  .min-w-sm-650px {\n    min-width: 650px !important;\n  }\n\n  .min-w-sm-700px {\n    min-width: 700px !important;\n  }\n\n  .min-w-sm-750px {\n    min-width: 750px !important;\n  }\n\n  .min-w-sm-800px {\n    min-width: 800px !important;\n  }\n\n  .min-w-sm-850px {\n    min-width: 850px !important;\n  }\n\n  .min-w-sm-900px {\n    min-width: 900px !important;\n  }\n\n  .min-w-sm-950px {\n    min-width: 950px !important;\n  }\n\n  .min-w-sm-1000px {\n    min-width: 1000px !important;\n  }\n\n  .min-h-sm-unset {\n    min-height: unset !important;\n  }\n\n  .min-h-sm-25 {\n    min-height: 25% !important;\n  }\n\n  .min-h-sm-50 {\n    min-height: 50% !important;\n  }\n\n  .min-h-sm-75 {\n    min-height: 75% !important;\n  }\n\n  .min-h-sm-100 {\n    min-height: 100% !important;\n  }\n\n  .min-h-sm-auto {\n    min-height: auto !important;\n  }\n\n  .min-h-sm-1px {\n    min-height: 1px !important;\n  }\n\n  .min-h-sm-2px {\n    min-height: 2px !important;\n  }\n\n  .min-h-sm-3px {\n    min-height: 3px !important;\n  }\n\n  .min-h-sm-4px {\n    min-height: 4px !important;\n  }\n\n  .min-h-sm-5px {\n    min-height: 5px !important;\n  }\n\n  .min-h-sm-6px {\n    min-height: 6px !important;\n  }\n\n  .min-h-sm-7px {\n    min-height: 7px !important;\n  }\n\n  .min-h-sm-8px {\n    min-height: 8px !important;\n  }\n\n  .min-h-sm-9px {\n    min-height: 9px !important;\n  }\n\n  .min-h-sm-10px {\n    min-height: 10px !important;\n  }\n\n  .min-h-sm-15px {\n    min-height: 15px !important;\n  }\n\n  .min-h-sm-20px {\n    min-height: 20px !important;\n  }\n\n  .min-h-sm-25px {\n    min-height: 25px !important;\n  }\n\n  .min-h-sm-30px {\n    min-height: 30px !important;\n  }\n\n  .min-h-sm-35px {\n    min-height: 35px !important;\n  }\n\n  .min-h-sm-40px {\n    min-height: 40px !important;\n  }\n\n  .min-h-sm-45px {\n    min-height: 45px !important;\n  }\n\n  .min-h-sm-50px {\n    min-height: 50px !important;\n  }\n\n  .min-h-sm-55px {\n    min-height: 55px !important;\n  }\n\n  .min-h-sm-60px {\n    min-height: 60px !important;\n  }\n\n  .min-h-sm-65px {\n    min-height: 65px !important;\n  }\n\n  .min-h-sm-70px {\n    min-height: 70px !important;\n  }\n\n  .min-h-sm-75px {\n    min-height: 75px !important;\n  }\n\n  .min-h-sm-80px {\n    min-height: 80px !important;\n  }\n\n  .min-h-sm-85px {\n    min-height: 85px !important;\n  }\n\n  .min-h-sm-90px {\n    min-height: 90px !important;\n  }\n\n  .min-h-sm-95px {\n    min-height: 95px !important;\n  }\n\n  .min-h-sm-100px {\n    min-height: 100px !important;\n  }\n\n  .min-h-sm-125px {\n    min-height: 125px !important;\n  }\n\n  .min-h-sm-150px {\n    min-height: 150px !important;\n  }\n\n  .min-h-sm-175px {\n    min-height: 175px !important;\n  }\n\n  .min-h-sm-200px {\n    min-height: 200px !important;\n  }\n\n  .min-h-sm-225px {\n    min-height: 225px !important;\n  }\n\n  .min-h-sm-250px {\n    min-height: 250px !important;\n  }\n\n  .min-h-sm-275px {\n    min-height: 275px !important;\n  }\n\n  .min-h-sm-300px {\n    min-height: 300px !important;\n  }\n\n  .min-h-sm-325px {\n    min-height: 325px !important;\n  }\n\n  .min-h-sm-350px {\n    min-height: 350px !important;\n  }\n\n  .min-h-sm-375px {\n    min-height: 375px !important;\n  }\n\n  .min-h-sm-400px {\n    min-height: 400px !important;\n  }\n\n  .min-h-sm-425px {\n    min-height: 425px !important;\n  }\n\n  .min-h-sm-450px {\n    min-height: 450px !important;\n  }\n\n  .min-h-sm-475px {\n    min-height: 475px !important;\n  }\n\n  .min-h-sm-500px {\n    min-height: 500px !important;\n  }\n\n  .min-h-sm-550px {\n    min-height: 550px !important;\n  }\n\n  .min-h-sm-600px {\n    min-height: 600px !important;\n  }\n\n  .min-h-sm-650px {\n    min-height: 650px !important;\n  }\n\n  .min-h-sm-700px {\n    min-height: 700px !important;\n  }\n\n  .min-h-sm-750px {\n    min-height: 750px !important;\n  }\n\n  .min-h-sm-800px {\n    min-height: 800px !important;\n  }\n\n  .min-h-sm-850px {\n    min-height: 850px !important;\n  }\n\n  .min-h-sm-900px {\n    min-height: 900px !important;\n  }\n\n  .min-h-sm-950px {\n    min-height: 950px !important;\n  }\n\n  .min-h-sm-1000px {\n    min-height: 1000px !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-start {\n    float: left !important;\n  }\n\n  .float-md-end {\n    float: right !important;\n  }\n\n  .float-md-none {\n    float: none !important;\n  }\n\n  .object-fit-md-contain {\n    object-fit: contain !important;\n  }\n\n  .object-fit-md-cover {\n    object-fit: cover !important;\n  }\n\n  .object-fit-md-fill {\n    object-fit: fill !important;\n  }\n\n  .object-fit-md-scale {\n    object-fit: scale-down !important;\n  }\n\n  .object-fit-md-none {\n    object-fit: none !important;\n  }\n\n  .d-md-inline {\n    display: inline !important;\n  }\n\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-md-block {\n    display: block !important;\n  }\n\n  .d-md-grid {\n    display: grid !important;\n  }\n\n  .d-md-inline-grid {\n    display: inline-grid !important;\n  }\n\n  .d-md-table {\n    display: table !important;\n  }\n\n  .d-md-table-row {\n    display: table-row !important;\n  }\n\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-md-flex {\n    display: flex !important;\n  }\n\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-md-none {\n    display: none !important;\n  }\n\n  .position-md-static {\n    position: static !important;\n  }\n\n  .position-md-relative {\n    position: relative !important;\n  }\n\n  .position-md-absolute {\n    position: absolute !important;\n  }\n\n  .position-md-fixed {\n    position: fixed !important;\n  }\n\n  .position-md-sticky {\n    position: sticky !important;\n  }\n\n  .w-md-unset {\n    width: unset !important;\n  }\n\n  .w-md-25 {\n    width: 25% !important;\n  }\n\n  .w-md-50 {\n    width: 50% !important;\n  }\n\n  .w-md-75 {\n    width: 75% !important;\n  }\n\n  .w-md-100 {\n    width: 100% !important;\n  }\n\n  .w-md-auto {\n    width: auto !important;\n  }\n\n  .w-md-1px {\n    width: 1px !important;\n  }\n\n  .w-md-2px {\n    width: 2px !important;\n  }\n\n  .w-md-3px {\n    width: 3px !important;\n  }\n\n  .w-md-4px {\n    width: 4px !important;\n  }\n\n  .w-md-5px {\n    width: 5px !important;\n  }\n\n  .w-md-6px {\n    width: 6px !important;\n  }\n\n  .w-md-7px {\n    width: 7px !important;\n  }\n\n  .w-md-8px {\n    width: 8px !important;\n  }\n\n  .w-md-9px {\n    width: 9px !important;\n  }\n\n  .w-md-10px {\n    width: 10px !important;\n  }\n\n  .w-md-15px {\n    width: 15px !important;\n  }\n\n  .w-md-20px {\n    width: 20px !important;\n  }\n\n  .w-md-25px {\n    width: 25px !important;\n  }\n\n  .w-md-30px {\n    width: 30px !important;\n  }\n\n  .w-md-35px {\n    width: 35px !important;\n  }\n\n  .w-md-40px {\n    width: 40px !important;\n  }\n\n  .w-md-45px {\n    width: 45px !important;\n  }\n\n  .w-md-50px {\n    width: 50px !important;\n  }\n\n  .w-md-55px {\n    width: 55px !important;\n  }\n\n  .w-md-60px {\n    width: 60px !important;\n  }\n\n  .w-md-65px {\n    width: 65px !important;\n  }\n\n  .w-md-70px {\n    width: 70px !important;\n  }\n\n  .w-md-75px {\n    width: 75px !important;\n  }\n\n  .w-md-80px {\n    width: 80px !important;\n  }\n\n  .w-md-85px {\n    width: 85px !important;\n  }\n\n  .w-md-90px {\n    width: 90px !important;\n  }\n\n  .w-md-95px {\n    width: 95px !important;\n  }\n\n  .w-md-100px {\n    width: 100px !important;\n  }\n\n  .w-md-125px {\n    width: 125px !important;\n  }\n\n  .w-md-150px {\n    width: 150px !important;\n  }\n\n  .w-md-175px {\n    width: 175px !important;\n  }\n\n  .w-md-200px {\n    width: 200px !important;\n  }\n\n  .w-md-225px {\n    width: 225px !important;\n  }\n\n  .w-md-250px {\n    width: 250px !important;\n  }\n\n  .w-md-275px {\n    width: 275px !important;\n  }\n\n  .w-md-300px {\n    width: 300px !important;\n  }\n\n  .w-md-325px {\n    width: 325px !important;\n  }\n\n  .w-md-350px {\n    width: 350px !important;\n  }\n\n  .w-md-375px {\n    width: 375px !important;\n  }\n\n  .w-md-400px {\n    width: 400px !important;\n  }\n\n  .w-md-425px {\n    width: 425px !important;\n  }\n\n  .w-md-450px {\n    width: 450px !important;\n  }\n\n  .w-md-475px {\n    width: 475px !important;\n  }\n\n  .w-md-500px {\n    width: 500px !important;\n  }\n\n  .w-md-550px {\n    width: 550px !important;\n  }\n\n  .w-md-600px {\n    width: 600px !important;\n  }\n\n  .w-md-650px {\n    width: 650px !important;\n  }\n\n  .w-md-700px {\n    width: 700px !important;\n  }\n\n  .w-md-750px {\n    width: 750px !important;\n  }\n\n  .w-md-800px {\n    width: 800px !important;\n  }\n\n  .w-md-850px {\n    width: 850px !important;\n  }\n\n  .w-md-900px {\n    width: 900px !important;\n  }\n\n  .w-md-950px {\n    width: 950px !important;\n  }\n\n  .w-md-1000px {\n    width: 1000px !important;\n  }\n\n  .mw-md-unset {\n    max-width: unset !important;\n  }\n\n  .mw-md-25 {\n    max-width: 25% !important;\n  }\n\n  .mw-md-50 {\n    max-width: 50% !important;\n  }\n\n  .mw-md-75 {\n    max-width: 75% !important;\n  }\n\n  .mw-md-100 {\n    max-width: 100% !important;\n  }\n\n  .mw-md-auto {\n    max-width: auto !important;\n  }\n\n  .mw-md-1px {\n    max-width: 1px !important;\n  }\n\n  .mw-md-2px {\n    max-width: 2px !important;\n  }\n\n  .mw-md-3px {\n    max-width: 3px !important;\n  }\n\n  .mw-md-4px {\n    max-width: 4px !important;\n  }\n\n  .mw-md-5px {\n    max-width: 5px !important;\n  }\n\n  .mw-md-6px {\n    max-width: 6px !important;\n  }\n\n  .mw-md-7px {\n    max-width: 7px !important;\n  }\n\n  .mw-md-8px {\n    max-width: 8px !important;\n  }\n\n  .mw-md-9px {\n    max-width: 9px !important;\n  }\n\n  .mw-md-10px {\n    max-width: 10px !important;\n  }\n\n  .mw-md-15px {\n    max-width: 15px !important;\n  }\n\n  .mw-md-20px {\n    max-width: 20px !important;\n  }\n\n  .mw-md-25px {\n    max-width: 25px !important;\n  }\n\n  .mw-md-30px {\n    max-width: 30px !important;\n  }\n\n  .mw-md-35px {\n    max-width: 35px !important;\n  }\n\n  .mw-md-40px {\n    max-width: 40px !important;\n  }\n\n  .mw-md-45px {\n    max-width: 45px !important;\n  }\n\n  .mw-md-50px {\n    max-width: 50px !important;\n  }\n\n  .mw-md-55px {\n    max-width: 55px !important;\n  }\n\n  .mw-md-60px {\n    max-width: 60px !important;\n  }\n\n  .mw-md-65px {\n    max-width: 65px !important;\n  }\n\n  .mw-md-70px {\n    max-width: 70px !important;\n  }\n\n  .mw-md-75px {\n    max-width: 75px !important;\n  }\n\n  .mw-md-80px {\n    max-width: 80px !important;\n  }\n\n  .mw-md-85px {\n    max-width: 85px !important;\n  }\n\n  .mw-md-90px {\n    max-width: 90px !important;\n  }\n\n  .mw-md-95px {\n    max-width: 95px !important;\n  }\n\n  .mw-md-100px {\n    max-width: 100px !important;\n  }\n\n  .mw-md-125px {\n    max-width: 125px !important;\n  }\n\n  .mw-md-150px {\n    max-width: 150px !important;\n  }\n\n  .mw-md-175px {\n    max-width: 175px !important;\n  }\n\n  .mw-md-200px {\n    max-width: 200px !important;\n  }\n\n  .mw-md-225px {\n    max-width: 225px !important;\n  }\n\n  .mw-md-250px {\n    max-width: 250px !important;\n  }\n\n  .mw-md-275px {\n    max-width: 275px !important;\n  }\n\n  .mw-md-300px {\n    max-width: 300px !important;\n  }\n\n  .mw-md-325px {\n    max-width: 325px !important;\n  }\n\n  .mw-md-350px {\n    max-width: 350px !important;\n  }\n\n  .mw-md-375px {\n    max-width: 375px !important;\n  }\n\n  .mw-md-400px {\n    max-width: 400px !important;\n  }\n\n  .mw-md-425px {\n    max-width: 425px !important;\n  }\n\n  .mw-md-450px {\n    max-width: 450px !important;\n  }\n\n  .mw-md-475px {\n    max-width: 475px !important;\n  }\n\n  .mw-md-500px {\n    max-width: 500px !important;\n  }\n\n  .mw-md-550px {\n    max-width: 550px !important;\n  }\n\n  .mw-md-600px {\n    max-width: 600px !important;\n  }\n\n  .mw-md-650px {\n    max-width: 650px !important;\n  }\n\n  .mw-md-700px {\n    max-width: 700px !important;\n  }\n\n  .mw-md-750px {\n    max-width: 750px !important;\n  }\n\n  .mw-md-800px {\n    max-width: 800px !important;\n  }\n\n  .mw-md-850px {\n    max-width: 850px !important;\n  }\n\n  .mw-md-900px {\n    max-width: 900px !important;\n  }\n\n  .mw-md-950px {\n    max-width: 950px !important;\n  }\n\n  .mw-md-1000px {\n    max-width: 1000px !important;\n  }\n\n  .h-md-unset {\n    height: unset !important;\n  }\n\n  .h-md-25 {\n    height: 25% !important;\n  }\n\n  .h-md-50 {\n    height: 50% !important;\n  }\n\n  .h-md-75 {\n    height: 75% !important;\n  }\n\n  .h-md-100 {\n    height: 100% !important;\n  }\n\n  .h-md-auto {\n    height: auto !important;\n  }\n\n  .h-md-1px {\n    height: 1px !important;\n  }\n\n  .h-md-2px {\n    height: 2px !important;\n  }\n\n  .h-md-3px {\n    height: 3px !important;\n  }\n\n  .h-md-4px {\n    height: 4px !important;\n  }\n\n  .h-md-5px {\n    height: 5px !important;\n  }\n\n  .h-md-6px {\n    height: 6px !important;\n  }\n\n  .h-md-7px {\n    height: 7px !important;\n  }\n\n  .h-md-8px {\n    height: 8px !important;\n  }\n\n  .h-md-9px {\n    height: 9px !important;\n  }\n\n  .h-md-10px {\n    height: 10px !important;\n  }\n\n  .h-md-15px {\n    height: 15px !important;\n  }\n\n  .h-md-20px {\n    height: 20px !important;\n  }\n\n  .h-md-25px {\n    height: 25px !important;\n  }\n\n  .h-md-30px {\n    height: 30px !important;\n  }\n\n  .h-md-35px {\n    height: 35px !important;\n  }\n\n  .h-md-40px {\n    height: 40px !important;\n  }\n\n  .h-md-45px {\n    height: 45px !important;\n  }\n\n  .h-md-50px {\n    height: 50px !important;\n  }\n\n  .h-md-55px {\n    height: 55px !important;\n  }\n\n  .h-md-60px {\n    height: 60px !important;\n  }\n\n  .h-md-65px {\n    height: 65px !important;\n  }\n\n  .h-md-70px {\n    height: 70px !important;\n  }\n\n  .h-md-75px {\n    height: 75px !important;\n  }\n\n  .h-md-80px {\n    height: 80px !important;\n  }\n\n  .h-md-85px {\n    height: 85px !important;\n  }\n\n  .h-md-90px {\n    height: 90px !important;\n  }\n\n  .h-md-95px {\n    height: 95px !important;\n  }\n\n  .h-md-100px {\n    height: 100px !important;\n  }\n\n  .h-md-125px {\n    height: 125px !important;\n  }\n\n  .h-md-150px {\n    height: 150px !important;\n  }\n\n  .h-md-175px {\n    height: 175px !important;\n  }\n\n  .h-md-200px {\n    height: 200px !important;\n  }\n\n  .h-md-225px {\n    height: 225px !important;\n  }\n\n  .h-md-250px {\n    height: 250px !important;\n  }\n\n  .h-md-275px {\n    height: 275px !important;\n  }\n\n  .h-md-300px {\n    height: 300px !important;\n  }\n\n  .h-md-325px {\n    height: 325px !important;\n  }\n\n  .h-md-350px {\n    height: 350px !important;\n  }\n\n  .h-md-375px {\n    height: 375px !important;\n  }\n\n  .h-md-400px {\n    height: 400px !important;\n  }\n\n  .h-md-425px {\n    height: 425px !important;\n  }\n\n  .h-md-450px {\n    height: 450px !important;\n  }\n\n  .h-md-475px {\n    height: 475px !important;\n  }\n\n  .h-md-500px {\n    height: 500px !important;\n  }\n\n  .h-md-550px {\n    height: 550px !important;\n  }\n\n  .h-md-600px {\n    height: 600px !important;\n  }\n\n  .h-md-650px {\n    height: 650px !important;\n  }\n\n  .h-md-700px {\n    height: 700px !important;\n  }\n\n  .h-md-750px {\n    height: 750px !important;\n  }\n\n  .h-md-800px {\n    height: 800px !important;\n  }\n\n  .h-md-850px {\n    height: 850px !important;\n  }\n\n  .h-md-900px {\n    height: 900px !important;\n  }\n\n  .h-md-950px {\n    height: 950px !important;\n  }\n\n  .h-md-1000px {\n    height: 1000px !important;\n  }\n\n  .mh-md-unset {\n    max-height: unset !important;\n  }\n\n  .mh-md-25 {\n    max-height: 25% !important;\n  }\n\n  .mh-md-50 {\n    max-height: 50% !important;\n  }\n\n  .mh-md-75 {\n    max-height: 75% !important;\n  }\n\n  .mh-md-100 {\n    max-height: 100% !important;\n  }\n\n  .mh-md-auto {\n    max-height: auto !important;\n  }\n\n  .mh-md-1px {\n    max-height: 1px !important;\n  }\n\n  .mh-md-2px {\n    max-height: 2px !important;\n  }\n\n  .mh-md-3px {\n    max-height: 3px !important;\n  }\n\n  .mh-md-4px {\n    max-height: 4px !important;\n  }\n\n  .mh-md-5px {\n    max-height: 5px !important;\n  }\n\n  .mh-md-6px {\n    max-height: 6px !important;\n  }\n\n  .mh-md-7px {\n    max-height: 7px !important;\n  }\n\n  .mh-md-8px {\n    max-height: 8px !important;\n  }\n\n  .mh-md-9px {\n    max-height: 9px !important;\n  }\n\n  .mh-md-10px {\n    max-height: 10px !important;\n  }\n\n  .mh-md-15px {\n    max-height: 15px !important;\n  }\n\n  .mh-md-20px {\n    max-height: 20px !important;\n  }\n\n  .mh-md-25px {\n    max-height: 25px !important;\n  }\n\n  .mh-md-30px {\n    max-height: 30px !important;\n  }\n\n  .mh-md-35px {\n    max-height: 35px !important;\n  }\n\n  .mh-md-40px {\n    max-height: 40px !important;\n  }\n\n  .mh-md-45px {\n    max-height: 45px !important;\n  }\n\n  .mh-md-50px {\n    max-height: 50px !important;\n  }\n\n  .mh-md-55px {\n    max-height: 55px !important;\n  }\n\n  .mh-md-60px {\n    max-height: 60px !important;\n  }\n\n  .mh-md-65px {\n    max-height: 65px !important;\n  }\n\n  .mh-md-70px {\n    max-height: 70px !important;\n  }\n\n  .mh-md-75px {\n    max-height: 75px !important;\n  }\n\n  .mh-md-80px {\n    max-height: 80px !important;\n  }\n\n  .mh-md-85px {\n    max-height: 85px !important;\n  }\n\n  .mh-md-90px {\n    max-height: 90px !important;\n  }\n\n  .mh-md-95px {\n    max-height: 95px !important;\n  }\n\n  .mh-md-100px {\n    max-height: 100px !important;\n  }\n\n  .mh-md-125px {\n    max-height: 125px !important;\n  }\n\n  .mh-md-150px {\n    max-height: 150px !important;\n  }\n\n  .mh-md-175px {\n    max-height: 175px !important;\n  }\n\n  .mh-md-200px {\n    max-height: 200px !important;\n  }\n\n  .mh-md-225px {\n    max-height: 225px !important;\n  }\n\n  .mh-md-250px {\n    max-height: 250px !important;\n  }\n\n  .mh-md-275px {\n    max-height: 275px !important;\n  }\n\n  .mh-md-300px {\n    max-height: 300px !important;\n  }\n\n  .mh-md-325px {\n    max-height: 325px !important;\n  }\n\n  .mh-md-350px {\n    max-height: 350px !important;\n  }\n\n  .mh-md-375px {\n    max-height: 375px !important;\n  }\n\n  .mh-md-400px {\n    max-height: 400px !important;\n  }\n\n  .mh-md-425px {\n    max-height: 425px !important;\n  }\n\n  .mh-md-450px {\n    max-height: 450px !important;\n  }\n\n  .mh-md-475px {\n    max-height: 475px !important;\n  }\n\n  .mh-md-500px {\n    max-height: 500px !important;\n  }\n\n  .mh-md-550px {\n    max-height: 550px !important;\n  }\n\n  .mh-md-600px {\n    max-height: 600px !important;\n  }\n\n  .mh-md-650px {\n    max-height: 650px !important;\n  }\n\n  .mh-md-700px {\n    max-height: 700px !important;\n  }\n\n  .mh-md-750px {\n    max-height: 750px !important;\n  }\n\n  .mh-md-800px {\n    max-height: 800px !important;\n  }\n\n  .mh-md-850px {\n    max-height: 850px !important;\n  }\n\n  .mh-md-900px {\n    max-height: 900px !important;\n  }\n\n  .mh-md-950px {\n    max-height: 950px !important;\n  }\n\n  .mh-md-1000px {\n    max-height: 1000px !important;\n  }\n\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n\n  .justify-content-md-evenly {\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-md-center {\n    align-items: center !important;\n  }\n\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-md-center {\n    align-content: center !important;\n  }\n\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-md-center {\n    align-self: center !important;\n  }\n\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n\n  .order-md-first {\n    order: -1 !important;\n  }\n\n  .order-md-0 {\n    order: 0 !important;\n  }\n\n  .order-md-1 {\n    order: 1 !important;\n  }\n\n  .order-md-2 {\n    order: 2 !important;\n  }\n\n  .order-md-3 {\n    order: 3 !important;\n  }\n\n  .order-md-4 {\n    order: 4 !important;\n  }\n\n  .order-md-5 {\n    order: 5 !important;\n  }\n\n  .order-md-last {\n    order: 6 !important;\n  }\n\n  .m-md-0 {\n    margin: 0 !important;\n  }\n\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-md-3 {\n    margin: 0.75rem !important;\n  }\n\n  .m-md-4 {\n    margin: 1rem !important;\n  }\n\n  .m-md-5 {\n    margin: 1.25rem !important;\n  }\n\n  .m-md-6 {\n    margin: 1.5rem !important;\n  }\n\n  .m-md-7 {\n    margin: 1.75rem !important;\n  }\n\n  .m-md-8 {\n    margin: 2rem !important;\n  }\n\n  .m-md-9 {\n    margin: 2.25rem !important;\n  }\n\n  .m-md-10 {\n    margin: 2.5rem !important;\n  }\n\n  .m-md-11 {\n    margin: 2.75rem !important;\n  }\n\n  .m-md-12 {\n    margin: 3rem !important;\n  }\n\n  .m-md-13 {\n    margin: 3.25rem !important;\n  }\n\n  .m-md-14 {\n    margin: 3.5rem !important;\n  }\n\n  .m-md-15 {\n    margin: 3.75rem !important;\n  }\n\n  .m-md-16 {\n    margin: 4rem !important;\n  }\n\n  .m-md-17 {\n    margin: 4.25rem !important;\n  }\n\n  .m-md-18 {\n    margin: 4.5rem !important;\n  }\n\n  .m-md-19 {\n    margin: 4.75rem !important;\n  }\n\n  .m-md-20 {\n    margin: 5rem !important;\n  }\n\n  .m-md-auto {\n    margin: auto !important;\n  }\n\n  .mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .mx-md-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n\n  .mx-md-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n\n  .mx-md-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n\n  .mx-md-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .mx-md-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n\n  .mx-md-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n\n  .mx-md-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n\n  .mx-md-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n\n  .mx-md-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n\n  .mx-md-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n\n  .mx-md-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n\n  .mx-md-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n\n  .mx-md-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n\n  .mx-md-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n\n  .mx-md-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n\n  .mx-md-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n\n  .mx-md-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n\n  .mx-md-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n\n  .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-md-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-md-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n\n  .my-md-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-md-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n\n  .my-md-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-md-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n\n  .my-md-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n\n  .my-md-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n\n  .my-md-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n\n  .my-md-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n\n  .my-md-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-md-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n\n  .my-md-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-md-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n\n  .my-md-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-md-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n\n  .my-md-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-md-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n\n  .my-md-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-md-0 {\n    margin-top: 0 !important;\n  }\n\n  .mt-md-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-md-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-md-3 {\n    margin-top: 0.75rem !important;\n  }\n\n  .mt-md-4 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-md-5 {\n    margin-top: 1.25rem !important;\n  }\n\n  .mt-md-6 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-md-7 {\n    margin-top: 1.75rem !important;\n  }\n\n  .mt-md-8 {\n    margin-top: 2rem !important;\n  }\n\n  .mt-md-9 {\n    margin-top: 2.25rem !important;\n  }\n\n  .mt-md-10 {\n    margin-top: 2.5rem !important;\n  }\n\n  .mt-md-11 {\n    margin-top: 2.75rem !important;\n  }\n\n  .mt-md-12 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-md-13 {\n    margin-top: 3.25rem !important;\n  }\n\n  .mt-md-14 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-md-15 {\n    margin-top: 3.75rem !important;\n  }\n\n  .mt-md-16 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-md-17 {\n    margin-top: 4.25rem !important;\n  }\n\n  .mt-md-18 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-md-19 {\n    margin-top: 4.75rem !important;\n  }\n\n  .mt-md-20 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-md-auto {\n    margin-top: auto !important;\n  }\n\n  .me-md-0 {\n    margin-right: 0 !important;\n  }\n\n  .me-md-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-md-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-md-3 {\n    margin-right: 0.75rem !important;\n  }\n\n  .me-md-4 {\n    margin-right: 1rem !important;\n  }\n\n  .me-md-5 {\n    margin-right: 1.25rem !important;\n  }\n\n  .me-md-6 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-md-7 {\n    margin-right: 1.75rem !important;\n  }\n\n  .me-md-8 {\n    margin-right: 2rem !important;\n  }\n\n  .me-md-9 {\n    margin-right: 2.25rem !important;\n  }\n\n  .me-md-10 {\n    margin-right: 2.5rem !important;\n  }\n\n  .me-md-11 {\n    margin-right: 2.75rem !important;\n  }\n\n  .me-md-12 {\n    margin-right: 3rem !important;\n  }\n\n  .me-md-13 {\n    margin-right: 3.25rem !important;\n  }\n\n  .me-md-14 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-md-15 {\n    margin-right: 3.75rem !important;\n  }\n\n  .me-md-16 {\n    margin-right: 4rem !important;\n  }\n\n  .me-md-17 {\n    margin-right: 4.25rem !important;\n  }\n\n  .me-md-18 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-md-19 {\n    margin-right: 4.75rem !important;\n  }\n\n  .me-md-20 {\n    margin-right: 5rem !important;\n  }\n\n  .me-md-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-md-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .mb-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-md-3 {\n    margin-bottom: 0.75rem !important;\n  }\n\n  .mb-md-4 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-md-5 {\n    margin-bottom: 1.25rem !important;\n  }\n\n  .mb-md-6 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-md-7 {\n    margin-bottom: 1.75rem !important;\n  }\n\n  .mb-md-8 {\n    margin-bottom: 2rem !important;\n  }\n\n  .mb-md-9 {\n    margin-bottom: 2.25rem !important;\n  }\n\n  .mb-md-10 {\n    margin-bottom: 2.5rem !important;\n  }\n\n  .mb-md-11 {\n    margin-bottom: 2.75rem !important;\n  }\n\n  .mb-md-12 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-md-13 {\n    margin-bottom: 3.25rem !important;\n  }\n\n  .mb-md-14 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-md-15 {\n    margin-bottom: 3.75rem !important;\n  }\n\n  .mb-md-16 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-md-17 {\n    margin-bottom: 4.25rem !important;\n  }\n\n  .mb-md-18 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-md-19 {\n    margin-bottom: 4.75rem !important;\n  }\n\n  .mb-md-20 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-md-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-md-0 {\n    margin-left: 0 !important;\n  }\n\n  .ms-md-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-md-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-md-3 {\n    margin-left: 0.75rem !important;\n  }\n\n  .ms-md-4 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-md-5 {\n    margin-left: 1.25rem !important;\n  }\n\n  .ms-md-6 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-md-7 {\n    margin-left: 1.75rem !important;\n  }\n\n  .ms-md-8 {\n    margin-left: 2rem !important;\n  }\n\n  .ms-md-9 {\n    margin-left: 2.25rem !important;\n  }\n\n  .ms-md-10 {\n    margin-left: 2.5rem !important;\n  }\n\n  .ms-md-11 {\n    margin-left: 2.75rem !important;\n  }\n\n  .ms-md-12 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-md-13 {\n    margin-left: 3.25rem !important;\n  }\n\n  .ms-md-14 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-md-15 {\n    margin-left: 3.75rem !important;\n  }\n\n  .ms-md-16 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-md-17 {\n    margin-left: 4.25rem !important;\n  }\n\n  .ms-md-18 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-md-19 {\n    margin-left: 4.75rem !important;\n  }\n\n  .ms-md-20 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-md-auto {\n    margin-left: auto !important;\n  }\n\n  .m-md-n1 {\n    margin: -0.25rem !important;\n  }\n\n  .m-md-n2 {\n    margin: -0.5rem !important;\n  }\n\n  .m-md-n3 {\n    margin: -0.75rem !important;\n  }\n\n  .m-md-n4 {\n    margin: -1rem !important;\n  }\n\n  .m-md-n5 {\n    margin: -1.25rem !important;\n  }\n\n  .m-md-n6 {\n    margin: -1.5rem !important;\n  }\n\n  .m-md-n7 {\n    margin: -1.75rem !important;\n  }\n\n  .m-md-n8 {\n    margin: -2rem !important;\n  }\n\n  .m-md-n9 {\n    margin: -2.25rem !important;\n  }\n\n  .m-md-n10 {\n    margin: -2.5rem !important;\n  }\n\n  .m-md-n11 {\n    margin: -2.75rem !important;\n  }\n\n  .m-md-n12 {\n    margin: -3rem !important;\n  }\n\n  .m-md-n13 {\n    margin: -3.25rem !important;\n  }\n\n  .m-md-n14 {\n    margin: -3.5rem !important;\n  }\n\n  .m-md-n15 {\n    margin: -3.75rem !important;\n  }\n\n  .m-md-n16 {\n    margin: -4rem !important;\n  }\n\n  .m-md-n17 {\n    margin: -4.25rem !important;\n  }\n\n  .m-md-n18 {\n    margin: -4.5rem !important;\n  }\n\n  .m-md-n19 {\n    margin: -4.75rem !important;\n  }\n\n  .m-md-n20 {\n    margin: -5rem !important;\n  }\n\n  .mx-md-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n\n  .mx-md-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n\n  .mx-md-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n\n  .mx-md-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n\n  .mx-md-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n\n  .mx-md-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n\n  .mx-md-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n\n  .mx-md-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n\n  .mx-md-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n\n  .mx-md-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n\n  .mx-md-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n\n  .mx-md-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n\n  .mx-md-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n\n  .mx-md-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n\n  .mx-md-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n\n  .mx-md-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n\n  .mx-md-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n\n  .mx-md-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n\n  .mx-md-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n\n  .mx-md-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n\n  .my-md-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n\n  .my-md-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n\n  .my-md-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n\n  .my-md-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n\n  .my-md-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n\n  .my-md-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n\n  .my-md-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n\n  .my-md-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n\n  .my-md-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n\n  .my-md-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n\n  .my-md-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n\n  .my-md-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n\n  .my-md-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n\n  .my-md-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n\n  .my-md-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n\n  .my-md-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n\n  .my-md-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n\n  .my-md-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n\n  .my-md-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n\n  .my-md-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n\n  .mt-md-n1 {\n    margin-top: -0.25rem !important;\n  }\n\n  .mt-md-n2 {\n    margin-top: -0.5rem !important;\n  }\n\n  .mt-md-n3 {\n    margin-top: -0.75rem !important;\n  }\n\n  .mt-md-n4 {\n    margin-top: -1rem !important;\n  }\n\n  .mt-md-n5 {\n    margin-top: -1.25rem !important;\n  }\n\n  .mt-md-n6 {\n    margin-top: -1.5rem !important;\n  }\n\n  .mt-md-n7 {\n    margin-top: -1.75rem !important;\n  }\n\n  .mt-md-n8 {\n    margin-top: -2rem !important;\n  }\n\n  .mt-md-n9 {\n    margin-top: -2.25rem !important;\n  }\n\n  .mt-md-n10 {\n    margin-top: -2.5rem !important;\n  }\n\n  .mt-md-n11 {\n    margin-top: -2.75rem !important;\n  }\n\n  .mt-md-n12 {\n    margin-top: -3rem !important;\n  }\n\n  .mt-md-n13 {\n    margin-top: -3.25rem !important;\n  }\n\n  .mt-md-n14 {\n    margin-top: -3.5rem !important;\n  }\n\n  .mt-md-n15 {\n    margin-top: -3.75rem !important;\n  }\n\n  .mt-md-n16 {\n    margin-top: -4rem !important;\n  }\n\n  .mt-md-n17 {\n    margin-top: -4.25rem !important;\n  }\n\n  .mt-md-n18 {\n    margin-top: -4.5rem !important;\n  }\n\n  .mt-md-n19 {\n    margin-top: -4.75rem !important;\n  }\n\n  .mt-md-n20 {\n    margin-top: -5rem !important;\n  }\n\n  .me-md-n1 {\n    margin-right: -0.25rem !important;\n  }\n\n  .me-md-n2 {\n    margin-right: -0.5rem !important;\n  }\n\n  .me-md-n3 {\n    margin-right: -0.75rem !important;\n  }\n\n  .me-md-n4 {\n    margin-right: -1rem !important;\n  }\n\n  .me-md-n5 {\n    margin-right: -1.25rem !important;\n  }\n\n  .me-md-n6 {\n    margin-right: -1.5rem !important;\n  }\n\n  .me-md-n7 {\n    margin-right: -1.75rem !important;\n  }\n\n  .me-md-n8 {\n    margin-right: -2rem !important;\n  }\n\n  .me-md-n9 {\n    margin-right: -2.25rem !important;\n  }\n\n  .me-md-n10 {\n    margin-right: -2.5rem !important;\n  }\n\n  .me-md-n11 {\n    margin-right: -2.75rem !important;\n  }\n\n  .me-md-n12 {\n    margin-right: -3rem !important;\n  }\n\n  .me-md-n13 {\n    margin-right: -3.25rem !important;\n  }\n\n  .me-md-n14 {\n    margin-right: -3.5rem !important;\n  }\n\n  .me-md-n15 {\n    margin-right: -3.75rem !important;\n  }\n\n  .me-md-n16 {\n    margin-right: -4rem !important;\n  }\n\n  .me-md-n17 {\n    margin-right: -4.25rem !important;\n  }\n\n  .me-md-n18 {\n    margin-right: -4.5rem !important;\n  }\n\n  .me-md-n19 {\n    margin-right: -4.75rem !important;\n  }\n\n  .me-md-n20 {\n    margin-right: -5rem !important;\n  }\n\n  .mb-md-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n\n  .mb-md-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n\n  .mb-md-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n\n  .mb-md-n4 {\n    margin-bottom: -1rem !important;\n  }\n\n  .mb-md-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n\n  .mb-md-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n\n  .mb-md-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n\n  .mb-md-n8 {\n    margin-bottom: -2rem !important;\n  }\n\n  .mb-md-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n\n  .mb-md-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n\n  .mb-md-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n\n  .mb-md-n12 {\n    margin-bottom: -3rem !important;\n  }\n\n  .mb-md-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n\n  .mb-md-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n\n  .mb-md-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n\n  .mb-md-n16 {\n    margin-bottom: -4rem !important;\n  }\n\n  .mb-md-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n\n  .mb-md-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n\n  .mb-md-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n\n  .mb-md-n20 {\n    margin-bottom: -5rem !important;\n  }\n\n  .ms-md-n1 {\n    margin-left: -0.25rem !important;\n  }\n\n  .ms-md-n2 {\n    margin-left: -0.5rem !important;\n  }\n\n  .ms-md-n3 {\n    margin-left: -0.75rem !important;\n  }\n\n  .ms-md-n4 {\n    margin-left: -1rem !important;\n  }\n\n  .ms-md-n5 {\n    margin-left: -1.25rem !important;\n  }\n\n  .ms-md-n6 {\n    margin-left: -1.5rem !important;\n  }\n\n  .ms-md-n7 {\n    margin-left: -1.75rem !important;\n  }\n\n  .ms-md-n8 {\n    margin-left: -2rem !important;\n  }\n\n  .ms-md-n9 {\n    margin-left: -2.25rem !important;\n  }\n\n  .ms-md-n10 {\n    margin-left: -2.5rem !important;\n  }\n\n  .ms-md-n11 {\n    margin-left: -2.75rem !important;\n  }\n\n  .ms-md-n12 {\n    margin-left: -3rem !important;\n  }\n\n  .ms-md-n13 {\n    margin-left: -3.25rem !important;\n  }\n\n  .ms-md-n14 {\n    margin-left: -3.5rem !important;\n  }\n\n  .ms-md-n15 {\n    margin-left: -3.75rem !important;\n  }\n\n  .ms-md-n16 {\n    margin-left: -4rem !important;\n  }\n\n  .ms-md-n17 {\n    margin-left: -4.25rem !important;\n  }\n\n  .ms-md-n18 {\n    margin-left: -4.5rem !important;\n  }\n\n  .ms-md-n19 {\n    margin-left: -4.75rem !important;\n  }\n\n  .ms-md-n20 {\n    margin-left: -5rem !important;\n  }\n\n  .p-md-0 {\n    padding: 0 !important;\n  }\n\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-md-3 {\n    padding: 0.75rem !important;\n  }\n\n  .p-md-4 {\n    padding: 1rem !important;\n  }\n\n  .p-md-5 {\n    padding: 1.25rem !important;\n  }\n\n  .p-md-6 {\n    padding: 1.5rem !important;\n  }\n\n  .p-md-7 {\n    padding: 1.75rem !important;\n  }\n\n  .p-md-8 {\n    padding: 2rem !important;\n  }\n\n  .p-md-9 {\n    padding: 2.25rem !important;\n  }\n\n  .p-md-10 {\n    padding: 2.5rem !important;\n  }\n\n  .p-md-11 {\n    padding: 2.75rem !important;\n  }\n\n  .p-md-12 {\n    padding: 3rem !important;\n  }\n\n  .p-md-13 {\n    padding: 3.25rem !important;\n  }\n\n  .p-md-14 {\n    padding: 3.5rem !important;\n  }\n\n  .p-md-15 {\n    padding: 3.75rem !important;\n  }\n\n  .p-md-16 {\n    padding: 4rem !important;\n  }\n\n  .p-md-17 {\n    padding: 4.25rem !important;\n  }\n\n  .p-md-18 {\n    padding: 4.5rem !important;\n  }\n\n  .p-md-19 {\n    padding: 4.75rem !important;\n  }\n\n  .p-md-20 {\n    padding: 5rem !important;\n  }\n\n  .px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .px-md-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n\n  .px-md-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n\n  .px-md-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n\n  .px-md-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .px-md-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n\n  .px-md-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n\n  .px-md-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n\n  .px-md-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n\n  .px-md-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n\n  .px-md-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n\n  .px-md-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n\n  .px-md-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n\n  .px-md-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n\n  .px-md-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n\n  .px-md-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n\n  .px-md-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n\n  .px-md-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n\n  .px-md-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n\n  .py-md-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-md-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n\n  .py-md-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-md-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n\n  .py-md-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-md-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n\n  .py-md-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n\n  .py-md-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n\n  .py-md-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n\n  .py-md-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n\n  .py-md-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .py-md-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n\n  .py-md-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-md-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n\n  .py-md-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-md-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n\n  .py-md-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-md-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n\n  .py-md-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .pt-md-0 {\n    padding-top: 0 !important;\n  }\n\n  .pt-md-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-md-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-md-3 {\n    padding-top: 0.75rem !important;\n  }\n\n  .pt-md-4 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-md-5 {\n    padding-top: 1.25rem !important;\n  }\n\n  .pt-md-6 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-md-7 {\n    padding-top: 1.75rem !important;\n  }\n\n  .pt-md-8 {\n    padding-top: 2rem !important;\n  }\n\n  .pt-md-9 {\n    padding-top: 2.25rem !important;\n  }\n\n  .pt-md-10 {\n    padding-top: 2.5rem !important;\n  }\n\n  .pt-md-11 {\n    padding-top: 2.75rem !important;\n  }\n\n  .pt-md-12 {\n    padding-top: 3rem !important;\n  }\n\n  .pt-md-13 {\n    padding-top: 3.25rem !important;\n  }\n\n  .pt-md-14 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-md-15 {\n    padding-top: 3.75rem !important;\n  }\n\n  .pt-md-16 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-md-17 {\n    padding-top: 4.25rem !important;\n  }\n\n  .pt-md-18 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-md-19 {\n    padding-top: 4.75rem !important;\n  }\n\n  .pt-md-20 {\n    padding-top: 5rem !important;\n  }\n\n  .pe-md-0 {\n    padding-right: 0 !important;\n  }\n\n  .pe-md-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-md-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-md-3 {\n    padding-right: 0.75rem !important;\n  }\n\n  .pe-md-4 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-md-5 {\n    padding-right: 1.25rem !important;\n  }\n\n  .pe-md-6 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-md-7 {\n    padding-right: 1.75rem !important;\n  }\n\n  .pe-md-8 {\n    padding-right: 2rem !important;\n  }\n\n  .pe-md-9 {\n    padding-right: 2.25rem !important;\n  }\n\n  .pe-md-10 {\n    padding-right: 2.5rem !important;\n  }\n\n  .pe-md-11 {\n    padding-right: 2.75rem !important;\n  }\n\n  .pe-md-12 {\n    padding-right: 3rem !important;\n  }\n\n  .pe-md-13 {\n    padding-right: 3.25rem !important;\n  }\n\n  .pe-md-14 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-md-15 {\n    padding-right: 3.75rem !important;\n  }\n\n  .pe-md-16 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-md-17 {\n    padding-right: 4.25rem !important;\n  }\n\n  .pe-md-18 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-md-19 {\n    padding-right: 4.75rem !important;\n  }\n\n  .pe-md-20 {\n    padding-right: 5rem !important;\n  }\n\n  .pb-md-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pb-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-md-3 {\n    padding-bottom: 0.75rem !important;\n  }\n\n  .pb-md-4 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-md-5 {\n    padding-bottom: 1.25rem !important;\n  }\n\n  .pb-md-6 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-md-7 {\n    padding-bottom: 1.75rem !important;\n  }\n\n  .pb-md-8 {\n    padding-bottom: 2rem !important;\n  }\n\n  .pb-md-9 {\n    padding-bottom: 2.25rem !important;\n  }\n\n  .pb-md-10 {\n    padding-bottom: 2.5rem !important;\n  }\n\n  .pb-md-11 {\n    padding-bottom: 2.75rem !important;\n  }\n\n  .pb-md-12 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pb-md-13 {\n    padding-bottom: 3.25rem !important;\n  }\n\n  .pb-md-14 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-md-15 {\n    padding-bottom: 3.75rem !important;\n  }\n\n  .pb-md-16 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-md-17 {\n    padding-bottom: 4.25rem !important;\n  }\n\n  .pb-md-18 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-md-19 {\n    padding-bottom: 4.75rem !important;\n  }\n\n  .pb-md-20 {\n    padding-bottom: 5rem !important;\n  }\n\n  .ps-md-0 {\n    padding-left: 0 !important;\n  }\n\n  .ps-md-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-md-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-md-3 {\n    padding-left: 0.75rem !important;\n  }\n\n  .ps-md-4 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-md-5 {\n    padding-left: 1.25rem !important;\n  }\n\n  .ps-md-6 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-md-7 {\n    padding-left: 1.75rem !important;\n  }\n\n  .ps-md-8 {\n    padding-left: 2rem !important;\n  }\n\n  .ps-md-9 {\n    padding-left: 2.25rem !important;\n  }\n\n  .ps-md-10 {\n    padding-left: 2.5rem !important;\n  }\n\n  .ps-md-11 {\n    padding-left: 2.75rem !important;\n  }\n\n  .ps-md-12 {\n    padding-left: 3rem !important;\n  }\n\n  .ps-md-13 {\n    padding-left: 3.25rem !important;\n  }\n\n  .ps-md-14 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-md-15 {\n    padding-left: 3.75rem !important;\n  }\n\n  .ps-md-16 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-md-17 {\n    padding-left: 4.25rem !important;\n  }\n\n  .ps-md-18 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-md-19 {\n    padding-left: 4.75rem !important;\n  }\n\n  .ps-md-20 {\n    padding-left: 5rem !important;\n  }\n\n  .gap-md-0 {\n    gap: 0 !important;\n  }\n\n  .gap-md-1 {\n    gap: 0.25rem !important;\n  }\n\n  .gap-md-2 {\n    gap: 0.5rem !important;\n  }\n\n  .gap-md-3 {\n    gap: 0.75rem !important;\n  }\n\n  .gap-md-4 {\n    gap: 1rem !important;\n  }\n\n  .gap-md-5 {\n    gap: 1.25rem !important;\n  }\n\n  .gap-md-6 {\n    gap: 1.5rem !important;\n  }\n\n  .gap-md-7 {\n    gap: 1.75rem !important;\n  }\n\n  .gap-md-8 {\n    gap: 2rem !important;\n  }\n\n  .gap-md-9 {\n    gap: 2.25rem !important;\n  }\n\n  .gap-md-10 {\n    gap: 2.5rem !important;\n  }\n\n  .gap-md-11 {\n    gap: 2.75rem !important;\n  }\n\n  .gap-md-12 {\n    gap: 3rem !important;\n  }\n\n  .gap-md-13 {\n    gap: 3.25rem !important;\n  }\n\n  .gap-md-14 {\n    gap: 3.5rem !important;\n  }\n\n  .gap-md-15 {\n    gap: 3.75rem !important;\n  }\n\n  .gap-md-16 {\n    gap: 4rem !important;\n  }\n\n  .gap-md-17 {\n    gap: 4.25rem !important;\n  }\n\n  .gap-md-18 {\n    gap: 4.5rem !important;\n  }\n\n  .gap-md-19 {\n    gap: 4.75rem !important;\n  }\n\n  .gap-md-20 {\n    gap: 5rem !important;\n  }\n\n  .row-gap-md-0 {\n    row-gap: 0 !important;\n  }\n\n  .row-gap-md-1 {\n    row-gap: 0.25rem !important;\n  }\n\n  .row-gap-md-2 {\n    row-gap: 0.5rem !important;\n  }\n\n  .row-gap-md-3 {\n    row-gap: 0.75rem !important;\n  }\n\n  .row-gap-md-4 {\n    row-gap: 1rem !important;\n  }\n\n  .row-gap-md-5 {\n    row-gap: 1.25rem !important;\n  }\n\n  .row-gap-md-6 {\n    row-gap: 1.5rem !important;\n  }\n\n  .row-gap-md-7 {\n    row-gap: 1.75rem !important;\n  }\n\n  .row-gap-md-8 {\n    row-gap: 2rem !important;\n  }\n\n  .row-gap-md-9 {\n    row-gap: 2.25rem !important;\n  }\n\n  .row-gap-md-10 {\n    row-gap: 2.5rem !important;\n  }\n\n  .row-gap-md-11 {\n    row-gap: 2.75rem !important;\n  }\n\n  .row-gap-md-12 {\n    row-gap: 3rem !important;\n  }\n\n  .row-gap-md-13 {\n    row-gap: 3.25rem !important;\n  }\n\n  .row-gap-md-14 {\n    row-gap: 3.5rem !important;\n  }\n\n  .row-gap-md-15 {\n    row-gap: 3.75rem !important;\n  }\n\n  .row-gap-md-16 {\n    row-gap: 4rem !important;\n  }\n\n  .row-gap-md-17 {\n    row-gap: 4.25rem !important;\n  }\n\n  .row-gap-md-18 {\n    row-gap: 4.5rem !important;\n  }\n\n  .row-gap-md-19 {\n    row-gap: 4.75rem !important;\n  }\n\n  .row-gap-md-20 {\n    row-gap: 5rem !important;\n  }\n\n  .column-gap-md-0 {\n    column-gap: 0 !important;\n  }\n\n  .column-gap-md-1 {\n    column-gap: 0.25rem !important;\n  }\n\n  .column-gap-md-2 {\n    column-gap: 0.5rem !important;\n  }\n\n  .column-gap-md-3 {\n    column-gap: 0.75rem !important;\n  }\n\n  .column-gap-md-4 {\n    column-gap: 1rem !important;\n  }\n\n  .column-gap-md-5 {\n    column-gap: 1.25rem !important;\n  }\n\n  .column-gap-md-6 {\n    column-gap: 1.5rem !important;\n  }\n\n  .column-gap-md-7 {\n    column-gap: 1.75rem !important;\n  }\n\n  .column-gap-md-8 {\n    column-gap: 2rem !important;\n  }\n\n  .column-gap-md-9 {\n    column-gap: 2.25rem !important;\n  }\n\n  .column-gap-md-10 {\n    column-gap: 2.5rem !important;\n  }\n\n  .column-gap-md-11 {\n    column-gap: 2.75rem !important;\n  }\n\n  .column-gap-md-12 {\n    column-gap: 3rem !important;\n  }\n\n  .column-gap-md-13 {\n    column-gap: 3.25rem !important;\n  }\n\n  .column-gap-md-14 {\n    column-gap: 3.5rem !important;\n  }\n\n  .column-gap-md-15 {\n    column-gap: 3.75rem !important;\n  }\n\n  .column-gap-md-16 {\n    column-gap: 4rem !important;\n  }\n\n  .column-gap-md-17 {\n    column-gap: 4.25rem !important;\n  }\n\n  .column-gap-md-18 {\n    column-gap: 4.5rem !important;\n  }\n\n  .column-gap-md-19 {\n    column-gap: 4.75rem !important;\n  }\n\n  .column-gap-md-20 {\n    column-gap: 5rem !important;\n  }\n\n  .fs-md-1 {\n    font-size: calc(1.3rem + 0.6vw) !important;\n  }\n\n  .fs-md-2 {\n    font-size: calc(1.275rem + 0.3vw) !important;\n  }\n\n  .fs-md-3 {\n    font-size: calc(1.26rem + 0.12vw) !important;\n  }\n\n  .fs-md-4 {\n    font-size: 1.25rem !important;\n  }\n\n  .fs-md-5 {\n    font-size: 1.15rem !important;\n  }\n\n  .fs-md-6 {\n    font-size: 1.075rem !important;\n  }\n\n  .fs-md-7 {\n    font-size: 0.95rem !important;\n  }\n\n  .fs-md-8 {\n    font-size: 0.85rem !important;\n  }\n\n  .fs-md-9 {\n    font-size: 0.75rem !important;\n  }\n\n  .fs-md-10 {\n    font-size: 0.5rem !important;\n  }\n\n  .fs-md-base {\n    font-size: 1rem !important;\n  }\n\n  .fs-md-fluid {\n    font-size: 100% !important;\n  }\n\n  .fs-md-2x {\n    font-size: calc(1.325rem + 0.9vw) !important;\n  }\n\n  .fs-md-2qx {\n    font-size: calc(1.35rem + 1.2vw) !important;\n  }\n\n  .fs-md-2hx {\n    font-size: calc(1.375rem + 1.5vw) !important;\n  }\n\n  .fs-md-2tx {\n    font-size: calc(1.4rem + 1.8vw) !important;\n  }\n\n  .fs-md-3x {\n    font-size: calc(1.425rem + 2.1vw) !important;\n  }\n\n  .fs-md-3qx {\n    font-size: calc(1.45rem + 2.4vw) !important;\n  }\n\n  .fs-md-3hx {\n    font-size: calc(1.475rem + 2.7vw) !important;\n  }\n\n  .fs-md-3tx {\n    font-size: calc(1.5rem + 3vw) !important;\n  }\n\n  .fs-md-4x {\n    font-size: calc(1.525rem + 3.3vw) !important;\n  }\n\n  .fs-md-4qx {\n    font-size: calc(1.55rem + 3.6vw) !important;\n  }\n\n  .fs-md-4hx {\n    font-size: calc(1.575rem + 3.9vw) !important;\n  }\n\n  .fs-md-4tx {\n    font-size: calc(1.6rem + 4.2vw) !important;\n  }\n\n  .fs-md-5x {\n    font-size: calc(1.625rem + 4.5vw) !important;\n  }\n\n  .fs-md-5qx {\n    font-size: calc(1.65rem + 4.8vw) !important;\n  }\n\n  .fs-md-5hx {\n    font-size: calc(1.675rem + 5.1vw) !important;\n  }\n\n  .fs-md-5tx {\n    font-size: calc(1.7rem + 5.4vw) !important;\n  }\n\n  .text-md-start {\n    text-align: left !important;\n  }\n\n  .text-md-end {\n    text-align: right !important;\n  }\n\n  .text-md-center {\n    text-align: center !important;\n  }\n\n  .min-w-md-unset {\n    min-width: unset !important;\n  }\n\n  .min-w-md-25 {\n    min-width: 25% !important;\n  }\n\n  .min-w-md-50 {\n    min-width: 50% !important;\n  }\n\n  .min-w-md-75 {\n    min-width: 75% !important;\n  }\n\n  .min-w-md-100 {\n    min-width: 100% !important;\n  }\n\n  .min-w-md-auto {\n    min-width: auto !important;\n  }\n\n  .min-w-md-1px {\n    min-width: 1px !important;\n  }\n\n  .min-w-md-2px {\n    min-width: 2px !important;\n  }\n\n  .min-w-md-3px {\n    min-width: 3px !important;\n  }\n\n  .min-w-md-4px {\n    min-width: 4px !important;\n  }\n\n  .min-w-md-5px {\n    min-width: 5px !important;\n  }\n\n  .min-w-md-6px {\n    min-width: 6px !important;\n  }\n\n  .min-w-md-7px {\n    min-width: 7px !important;\n  }\n\n  .min-w-md-8px {\n    min-width: 8px !important;\n  }\n\n  .min-w-md-9px {\n    min-width: 9px !important;\n  }\n\n  .min-w-md-10px {\n    min-width: 10px !important;\n  }\n\n  .min-w-md-15px {\n    min-width: 15px !important;\n  }\n\n  .min-w-md-20px {\n    min-width: 20px !important;\n  }\n\n  .min-w-md-25px {\n    min-width: 25px !important;\n  }\n\n  .min-w-md-30px {\n    min-width: 30px !important;\n  }\n\n  .min-w-md-35px {\n    min-width: 35px !important;\n  }\n\n  .min-w-md-40px {\n    min-width: 40px !important;\n  }\n\n  .min-w-md-45px {\n    min-width: 45px !important;\n  }\n\n  .min-w-md-50px {\n    min-width: 50px !important;\n  }\n\n  .min-w-md-55px {\n    min-width: 55px !important;\n  }\n\n  .min-w-md-60px {\n    min-width: 60px !important;\n  }\n\n  .min-w-md-65px {\n    min-width: 65px !important;\n  }\n\n  .min-w-md-70px {\n    min-width: 70px !important;\n  }\n\n  .min-w-md-75px {\n    min-width: 75px !important;\n  }\n\n  .min-w-md-80px {\n    min-width: 80px !important;\n  }\n\n  .min-w-md-85px {\n    min-width: 85px !important;\n  }\n\n  .min-w-md-90px {\n    min-width: 90px !important;\n  }\n\n  .min-w-md-95px {\n    min-width: 95px !important;\n  }\n\n  .min-w-md-100px {\n    min-width: 100px !important;\n  }\n\n  .min-w-md-125px {\n    min-width: 125px !important;\n  }\n\n  .min-w-md-150px {\n    min-width: 150px !important;\n  }\n\n  .min-w-md-175px {\n    min-width: 175px !important;\n  }\n\n  .min-w-md-200px {\n    min-width: 200px !important;\n  }\n\n  .min-w-md-225px {\n    min-width: 225px !important;\n  }\n\n  .min-w-md-250px {\n    min-width: 250px !important;\n  }\n\n  .min-w-md-275px {\n    min-width: 275px !important;\n  }\n\n  .min-w-md-300px {\n    min-width: 300px !important;\n  }\n\n  .min-w-md-325px {\n    min-width: 325px !important;\n  }\n\n  .min-w-md-350px {\n    min-width: 350px !important;\n  }\n\n  .min-w-md-375px {\n    min-width: 375px !important;\n  }\n\n  .min-w-md-400px {\n    min-width: 400px !important;\n  }\n\n  .min-w-md-425px {\n    min-width: 425px !important;\n  }\n\n  .min-w-md-450px {\n    min-width: 450px !important;\n  }\n\n  .min-w-md-475px {\n    min-width: 475px !important;\n  }\n\n  .min-w-md-500px {\n    min-width: 500px !important;\n  }\n\n  .min-w-md-550px {\n    min-width: 550px !important;\n  }\n\n  .min-w-md-600px {\n    min-width: 600px !important;\n  }\n\n  .min-w-md-650px {\n    min-width: 650px !important;\n  }\n\n  .min-w-md-700px {\n    min-width: 700px !important;\n  }\n\n  .min-w-md-750px {\n    min-width: 750px !important;\n  }\n\n  .min-w-md-800px {\n    min-width: 800px !important;\n  }\n\n  .min-w-md-850px {\n    min-width: 850px !important;\n  }\n\n  .min-w-md-900px {\n    min-width: 900px !important;\n  }\n\n  .min-w-md-950px {\n    min-width: 950px !important;\n  }\n\n  .min-w-md-1000px {\n    min-width: 1000px !important;\n  }\n\n  .min-h-md-unset {\n    min-height: unset !important;\n  }\n\n  .min-h-md-25 {\n    min-height: 25% !important;\n  }\n\n  .min-h-md-50 {\n    min-height: 50% !important;\n  }\n\n  .min-h-md-75 {\n    min-height: 75% !important;\n  }\n\n  .min-h-md-100 {\n    min-height: 100% !important;\n  }\n\n  .min-h-md-auto {\n    min-height: auto !important;\n  }\n\n  .min-h-md-1px {\n    min-height: 1px !important;\n  }\n\n  .min-h-md-2px {\n    min-height: 2px !important;\n  }\n\n  .min-h-md-3px {\n    min-height: 3px !important;\n  }\n\n  .min-h-md-4px {\n    min-height: 4px !important;\n  }\n\n  .min-h-md-5px {\n    min-height: 5px !important;\n  }\n\n  .min-h-md-6px {\n    min-height: 6px !important;\n  }\n\n  .min-h-md-7px {\n    min-height: 7px !important;\n  }\n\n  .min-h-md-8px {\n    min-height: 8px !important;\n  }\n\n  .min-h-md-9px {\n    min-height: 9px !important;\n  }\n\n  .min-h-md-10px {\n    min-height: 10px !important;\n  }\n\n  .min-h-md-15px {\n    min-height: 15px !important;\n  }\n\n  .min-h-md-20px {\n    min-height: 20px !important;\n  }\n\n  .min-h-md-25px {\n    min-height: 25px !important;\n  }\n\n  .min-h-md-30px {\n    min-height: 30px !important;\n  }\n\n  .min-h-md-35px {\n    min-height: 35px !important;\n  }\n\n  .min-h-md-40px {\n    min-height: 40px !important;\n  }\n\n  .min-h-md-45px {\n    min-height: 45px !important;\n  }\n\n  .min-h-md-50px {\n    min-height: 50px !important;\n  }\n\n  .min-h-md-55px {\n    min-height: 55px !important;\n  }\n\n  .min-h-md-60px {\n    min-height: 60px !important;\n  }\n\n  .min-h-md-65px {\n    min-height: 65px !important;\n  }\n\n  .min-h-md-70px {\n    min-height: 70px !important;\n  }\n\n  .min-h-md-75px {\n    min-height: 75px !important;\n  }\n\n  .min-h-md-80px {\n    min-height: 80px !important;\n  }\n\n  .min-h-md-85px {\n    min-height: 85px !important;\n  }\n\n  .min-h-md-90px {\n    min-height: 90px !important;\n  }\n\n  .min-h-md-95px {\n    min-height: 95px !important;\n  }\n\n  .min-h-md-100px {\n    min-height: 100px !important;\n  }\n\n  .min-h-md-125px {\n    min-height: 125px !important;\n  }\n\n  .min-h-md-150px {\n    min-height: 150px !important;\n  }\n\n  .min-h-md-175px {\n    min-height: 175px !important;\n  }\n\n  .min-h-md-200px {\n    min-height: 200px !important;\n  }\n\n  .min-h-md-225px {\n    min-height: 225px !important;\n  }\n\n  .min-h-md-250px {\n    min-height: 250px !important;\n  }\n\n  .min-h-md-275px {\n    min-height: 275px !important;\n  }\n\n  .min-h-md-300px {\n    min-height: 300px !important;\n  }\n\n  .min-h-md-325px {\n    min-height: 325px !important;\n  }\n\n  .min-h-md-350px {\n    min-height: 350px !important;\n  }\n\n  .min-h-md-375px {\n    min-height: 375px !important;\n  }\n\n  .min-h-md-400px {\n    min-height: 400px !important;\n  }\n\n  .min-h-md-425px {\n    min-height: 425px !important;\n  }\n\n  .min-h-md-450px {\n    min-height: 450px !important;\n  }\n\n  .min-h-md-475px {\n    min-height: 475px !important;\n  }\n\n  .min-h-md-500px {\n    min-height: 500px !important;\n  }\n\n  .min-h-md-550px {\n    min-height: 550px !important;\n  }\n\n  .min-h-md-600px {\n    min-height: 600px !important;\n  }\n\n  .min-h-md-650px {\n    min-height: 650px !important;\n  }\n\n  .min-h-md-700px {\n    min-height: 700px !important;\n  }\n\n  .min-h-md-750px {\n    min-height: 750px !important;\n  }\n\n  .min-h-md-800px {\n    min-height: 800px !important;\n  }\n\n  .min-h-md-850px {\n    min-height: 850px !important;\n  }\n\n  .min-h-md-900px {\n    min-height: 900px !important;\n  }\n\n  .min-h-md-950px {\n    min-height: 950px !important;\n  }\n\n  .min-h-md-1000px {\n    min-height: 1000px !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-start {\n    float: left !important;\n  }\n\n  .float-lg-end {\n    float: right !important;\n  }\n\n  .float-lg-none {\n    float: none !important;\n  }\n\n  .object-fit-lg-contain {\n    object-fit: contain !important;\n  }\n\n  .object-fit-lg-cover {\n    object-fit: cover !important;\n  }\n\n  .object-fit-lg-fill {\n    object-fit: fill !important;\n  }\n\n  .object-fit-lg-scale {\n    object-fit: scale-down !important;\n  }\n\n  .object-fit-lg-none {\n    object-fit: none !important;\n  }\n\n  .d-lg-inline {\n    display: inline !important;\n  }\n\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-lg-block {\n    display: block !important;\n  }\n\n  .d-lg-grid {\n    display: grid !important;\n  }\n\n  .d-lg-inline-grid {\n    display: inline-grid !important;\n  }\n\n  .d-lg-table {\n    display: table !important;\n  }\n\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-lg-flex {\n    display: flex !important;\n  }\n\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-lg-none {\n    display: none !important;\n  }\n\n  .position-lg-static {\n    position: static !important;\n  }\n\n  .position-lg-relative {\n    position: relative !important;\n  }\n\n  .position-lg-absolute {\n    position: absolute !important;\n  }\n\n  .position-lg-fixed {\n    position: fixed !important;\n  }\n\n  .position-lg-sticky {\n    position: sticky !important;\n  }\n\n  .w-lg-unset {\n    width: unset !important;\n  }\n\n  .w-lg-25 {\n    width: 25% !important;\n  }\n\n  .w-lg-50 {\n    width: 50% !important;\n  }\n\n  .w-lg-75 {\n    width: 75% !important;\n  }\n\n  .w-lg-100 {\n    width: 100% !important;\n  }\n\n  .w-lg-auto {\n    width: auto !important;\n  }\n\n  .w-lg-1px {\n    width: 1px !important;\n  }\n\n  .w-lg-2px {\n    width: 2px !important;\n  }\n\n  .w-lg-3px {\n    width: 3px !important;\n  }\n\n  .w-lg-4px {\n    width: 4px !important;\n  }\n\n  .w-lg-5px {\n    width: 5px !important;\n  }\n\n  .w-lg-6px {\n    width: 6px !important;\n  }\n\n  .w-lg-7px {\n    width: 7px !important;\n  }\n\n  .w-lg-8px {\n    width: 8px !important;\n  }\n\n  .w-lg-9px {\n    width: 9px !important;\n  }\n\n  .w-lg-10px {\n    width: 10px !important;\n  }\n\n  .w-lg-15px {\n    width: 15px !important;\n  }\n\n  .w-lg-20px {\n    width: 20px !important;\n  }\n\n  .w-lg-25px {\n    width: 25px !important;\n  }\n\n  .w-lg-30px {\n    width: 30px !important;\n  }\n\n  .w-lg-35px {\n    width: 35px !important;\n  }\n\n  .w-lg-40px {\n    width: 40px !important;\n  }\n\n  .w-lg-45px {\n    width: 45px !important;\n  }\n\n  .w-lg-50px {\n    width: 50px !important;\n  }\n\n  .w-lg-55px {\n    width: 55px !important;\n  }\n\n  .w-lg-60px {\n    width: 60px !important;\n  }\n\n  .w-lg-65px {\n    width: 65px !important;\n  }\n\n  .w-lg-70px {\n    width: 70px !important;\n  }\n\n  .w-lg-75px {\n    width: 75px !important;\n  }\n\n  .w-lg-80px {\n    width: 80px !important;\n  }\n\n  .w-lg-85px {\n    width: 85px !important;\n  }\n\n  .w-lg-90px {\n    width: 90px !important;\n  }\n\n  .w-lg-95px {\n    width: 95px !important;\n  }\n\n  .w-lg-100px {\n    width: 100px !important;\n  }\n\n  .w-lg-125px {\n    width: 125px !important;\n  }\n\n  .w-lg-150px {\n    width: 150px !important;\n  }\n\n  .w-lg-175px {\n    width: 175px !important;\n  }\n\n  .w-lg-200px {\n    width: 200px !important;\n  }\n\n  .w-lg-225px {\n    width: 225px !important;\n  }\n\n  .w-lg-250px {\n    width: 250px !important;\n  }\n\n  .w-lg-275px {\n    width: 275px !important;\n  }\n\n  .w-lg-300px {\n    width: 300px !important;\n  }\n\n  .w-lg-325px {\n    width: 325px !important;\n  }\n\n  .w-lg-350px {\n    width: 350px !important;\n  }\n\n  .w-lg-375px {\n    width: 375px !important;\n  }\n\n  .w-lg-400px {\n    width: 400px !important;\n  }\n\n  .w-lg-425px {\n    width: 425px !important;\n  }\n\n  .w-lg-450px {\n    width: 450px !important;\n  }\n\n  .w-lg-475px {\n    width: 475px !important;\n  }\n\n  .w-lg-500px {\n    width: 500px !important;\n  }\n\n  .w-lg-550px {\n    width: 550px !important;\n  }\n\n  .w-lg-600px {\n    width: 600px !important;\n  }\n\n  .w-lg-650px {\n    width: 650px !important;\n  }\n\n  .w-lg-700px {\n    width: 700px !important;\n  }\n\n  .w-lg-750px {\n    width: 750px !important;\n  }\n\n  .w-lg-800px {\n    width: 800px !important;\n  }\n\n  .w-lg-850px {\n    width: 850px !important;\n  }\n\n  .w-lg-900px {\n    width: 900px !important;\n  }\n\n  .w-lg-950px {\n    width: 950px !important;\n  }\n\n  .w-lg-1000px {\n    width: 1000px !important;\n  }\n\n  .mw-lg-unset {\n    max-width: unset !important;\n  }\n\n  .mw-lg-25 {\n    max-width: 25% !important;\n  }\n\n  .mw-lg-50 {\n    max-width: 50% !important;\n  }\n\n  .mw-lg-75 {\n    max-width: 75% !important;\n  }\n\n  .mw-lg-100 {\n    max-width: 100% !important;\n  }\n\n  .mw-lg-auto {\n    max-width: auto !important;\n  }\n\n  .mw-lg-1px {\n    max-width: 1px !important;\n  }\n\n  .mw-lg-2px {\n    max-width: 2px !important;\n  }\n\n  .mw-lg-3px {\n    max-width: 3px !important;\n  }\n\n  .mw-lg-4px {\n    max-width: 4px !important;\n  }\n\n  .mw-lg-5px {\n    max-width: 5px !important;\n  }\n\n  .mw-lg-6px {\n    max-width: 6px !important;\n  }\n\n  .mw-lg-7px {\n    max-width: 7px !important;\n  }\n\n  .mw-lg-8px {\n    max-width: 8px !important;\n  }\n\n  .mw-lg-9px {\n    max-width: 9px !important;\n  }\n\n  .mw-lg-10px {\n    max-width: 10px !important;\n  }\n\n  .mw-lg-15px {\n    max-width: 15px !important;\n  }\n\n  .mw-lg-20px {\n    max-width: 20px !important;\n  }\n\n  .mw-lg-25px {\n    max-width: 25px !important;\n  }\n\n  .mw-lg-30px {\n    max-width: 30px !important;\n  }\n\n  .mw-lg-35px {\n    max-width: 35px !important;\n  }\n\n  .mw-lg-40px {\n    max-width: 40px !important;\n  }\n\n  .mw-lg-45px {\n    max-width: 45px !important;\n  }\n\n  .mw-lg-50px {\n    max-width: 50px !important;\n  }\n\n  .mw-lg-55px {\n    max-width: 55px !important;\n  }\n\n  .mw-lg-60px {\n    max-width: 60px !important;\n  }\n\n  .mw-lg-65px {\n    max-width: 65px !important;\n  }\n\n  .mw-lg-70px {\n    max-width: 70px !important;\n  }\n\n  .mw-lg-75px {\n    max-width: 75px !important;\n  }\n\n  .mw-lg-80px {\n    max-width: 80px !important;\n  }\n\n  .mw-lg-85px {\n    max-width: 85px !important;\n  }\n\n  .mw-lg-90px {\n    max-width: 90px !important;\n  }\n\n  .mw-lg-95px {\n    max-width: 95px !important;\n  }\n\n  .mw-lg-100px {\n    max-width: 100px !important;\n  }\n\n  .mw-lg-125px {\n    max-width: 125px !important;\n  }\n\n  .mw-lg-150px {\n    max-width: 150px !important;\n  }\n\n  .mw-lg-175px {\n    max-width: 175px !important;\n  }\n\n  .mw-lg-200px {\n    max-width: 200px !important;\n  }\n\n  .mw-lg-225px {\n    max-width: 225px !important;\n  }\n\n  .mw-lg-250px {\n    max-width: 250px !important;\n  }\n\n  .mw-lg-275px {\n    max-width: 275px !important;\n  }\n\n  .mw-lg-300px {\n    max-width: 300px !important;\n  }\n\n  .mw-lg-325px {\n    max-width: 325px !important;\n  }\n\n  .mw-lg-350px {\n    max-width: 350px !important;\n  }\n\n  .mw-lg-375px {\n    max-width: 375px !important;\n  }\n\n  .mw-lg-400px {\n    max-width: 400px !important;\n  }\n\n  .mw-lg-425px {\n    max-width: 425px !important;\n  }\n\n  .mw-lg-450px {\n    max-width: 450px !important;\n  }\n\n  .mw-lg-475px {\n    max-width: 475px !important;\n  }\n\n  .mw-lg-500px {\n    max-width: 500px !important;\n  }\n\n  .mw-lg-550px {\n    max-width: 550px !important;\n  }\n\n  .mw-lg-600px {\n    max-width: 600px !important;\n  }\n\n  .mw-lg-650px {\n    max-width: 650px !important;\n  }\n\n  .mw-lg-700px {\n    max-width: 700px !important;\n  }\n\n  .mw-lg-750px {\n    max-width: 750px !important;\n  }\n\n  .mw-lg-800px {\n    max-width: 800px !important;\n  }\n\n  .mw-lg-850px {\n    max-width: 850px !important;\n  }\n\n  .mw-lg-900px {\n    max-width: 900px !important;\n  }\n\n  .mw-lg-950px {\n    max-width: 950px !important;\n  }\n\n  .mw-lg-1000px {\n    max-width: 1000px !important;\n  }\n\n  .h-lg-unset {\n    height: unset !important;\n  }\n\n  .h-lg-25 {\n    height: 25% !important;\n  }\n\n  .h-lg-50 {\n    height: 50% !important;\n  }\n\n  .h-lg-75 {\n    height: 75% !important;\n  }\n\n  .h-lg-100 {\n    height: 100% !important;\n  }\n\n  .h-lg-auto {\n    height: auto !important;\n  }\n\n  .h-lg-1px {\n    height: 1px !important;\n  }\n\n  .h-lg-2px {\n    height: 2px !important;\n  }\n\n  .h-lg-3px {\n    height: 3px !important;\n  }\n\n  .h-lg-4px {\n    height: 4px !important;\n  }\n\n  .h-lg-5px {\n    height: 5px !important;\n  }\n\n  .h-lg-6px {\n    height: 6px !important;\n  }\n\n  .h-lg-7px {\n    height: 7px !important;\n  }\n\n  .h-lg-8px {\n    height: 8px !important;\n  }\n\n  .h-lg-9px {\n    height: 9px !important;\n  }\n\n  .h-lg-10px {\n    height: 10px !important;\n  }\n\n  .h-lg-15px {\n    height: 15px !important;\n  }\n\n  .h-lg-20px {\n    height: 20px !important;\n  }\n\n  .h-lg-25px {\n    height: 25px !important;\n  }\n\n  .h-lg-30px {\n    height: 30px !important;\n  }\n\n  .h-lg-35px {\n    height: 35px !important;\n  }\n\n  .h-lg-40px {\n    height: 40px !important;\n  }\n\n  .h-lg-45px {\n    height: 45px !important;\n  }\n\n  .h-lg-50px {\n    height: 50px !important;\n  }\n\n  .h-lg-55px {\n    height: 55px !important;\n  }\n\n  .h-lg-60px {\n    height: 60px !important;\n  }\n\n  .h-lg-65px {\n    height: 65px !important;\n  }\n\n  .h-lg-70px {\n    height: 70px !important;\n  }\n\n  .h-lg-75px {\n    height: 75px !important;\n  }\n\n  .h-lg-80px {\n    height: 80px !important;\n  }\n\n  .h-lg-85px {\n    height: 85px !important;\n  }\n\n  .h-lg-90px {\n    height: 90px !important;\n  }\n\n  .h-lg-95px {\n    height: 95px !important;\n  }\n\n  .h-lg-100px {\n    height: 100px !important;\n  }\n\n  .h-lg-125px {\n    height: 125px !important;\n  }\n\n  .h-lg-150px {\n    height: 150px !important;\n  }\n\n  .h-lg-175px {\n    height: 175px !important;\n  }\n\n  .h-lg-200px {\n    height: 200px !important;\n  }\n\n  .h-lg-225px {\n    height: 225px !important;\n  }\n\n  .h-lg-250px {\n    height: 250px !important;\n  }\n\n  .h-lg-275px {\n    height: 275px !important;\n  }\n\n  .h-lg-300px {\n    height: 300px !important;\n  }\n\n  .h-lg-325px {\n    height: 325px !important;\n  }\n\n  .h-lg-350px {\n    height: 350px !important;\n  }\n\n  .h-lg-375px {\n    height: 375px !important;\n  }\n\n  .h-lg-400px {\n    height: 400px !important;\n  }\n\n  .h-lg-425px {\n    height: 425px !important;\n  }\n\n  .h-lg-450px {\n    height: 450px !important;\n  }\n\n  .h-lg-475px {\n    height: 475px !important;\n  }\n\n  .h-lg-500px {\n    height: 500px !important;\n  }\n\n  .h-lg-550px {\n    height: 550px !important;\n  }\n\n  .h-lg-600px {\n    height: 600px !important;\n  }\n\n  .h-lg-650px {\n    height: 650px !important;\n  }\n\n  .h-lg-700px {\n    height: 700px !important;\n  }\n\n  .h-lg-750px {\n    height: 750px !important;\n  }\n\n  .h-lg-800px {\n    height: 800px !important;\n  }\n\n  .h-lg-850px {\n    height: 850px !important;\n  }\n\n  .h-lg-900px {\n    height: 900px !important;\n  }\n\n  .h-lg-950px {\n    height: 950px !important;\n  }\n\n  .h-lg-1000px {\n    height: 1000px !important;\n  }\n\n  .mh-lg-unset {\n    max-height: unset !important;\n  }\n\n  .mh-lg-25 {\n    max-height: 25% !important;\n  }\n\n  .mh-lg-50 {\n    max-height: 50% !important;\n  }\n\n  .mh-lg-75 {\n    max-height: 75% !important;\n  }\n\n  .mh-lg-100 {\n    max-height: 100% !important;\n  }\n\n  .mh-lg-auto {\n    max-height: auto !important;\n  }\n\n  .mh-lg-1px {\n    max-height: 1px !important;\n  }\n\n  .mh-lg-2px {\n    max-height: 2px !important;\n  }\n\n  .mh-lg-3px {\n    max-height: 3px !important;\n  }\n\n  .mh-lg-4px {\n    max-height: 4px !important;\n  }\n\n  .mh-lg-5px {\n    max-height: 5px !important;\n  }\n\n  .mh-lg-6px {\n    max-height: 6px !important;\n  }\n\n  .mh-lg-7px {\n    max-height: 7px !important;\n  }\n\n  .mh-lg-8px {\n    max-height: 8px !important;\n  }\n\n  .mh-lg-9px {\n    max-height: 9px !important;\n  }\n\n  .mh-lg-10px {\n    max-height: 10px !important;\n  }\n\n  .mh-lg-15px {\n    max-height: 15px !important;\n  }\n\n  .mh-lg-20px {\n    max-height: 20px !important;\n  }\n\n  .mh-lg-25px {\n    max-height: 25px !important;\n  }\n\n  .mh-lg-30px {\n    max-height: 30px !important;\n  }\n\n  .mh-lg-35px {\n    max-height: 35px !important;\n  }\n\n  .mh-lg-40px {\n    max-height: 40px !important;\n  }\n\n  .mh-lg-45px {\n    max-height: 45px !important;\n  }\n\n  .mh-lg-50px {\n    max-height: 50px !important;\n  }\n\n  .mh-lg-55px {\n    max-height: 55px !important;\n  }\n\n  .mh-lg-60px {\n    max-height: 60px !important;\n  }\n\n  .mh-lg-65px {\n    max-height: 65px !important;\n  }\n\n  .mh-lg-70px {\n    max-height: 70px !important;\n  }\n\n  .mh-lg-75px {\n    max-height: 75px !important;\n  }\n\n  .mh-lg-80px {\n    max-height: 80px !important;\n  }\n\n  .mh-lg-85px {\n    max-height: 85px !important;\n  }\n\n  .mh-lg-90px {\n    max-height: 90px !important;\n  }\n\n  .mh-lg-95px {\n    max-height: 95px !important;\n  }\n\n  .mh-lg-100px {\n    max-height: 100px !important;\n  }\n\n  .mh-lg-125px {\n    max-height: 125px !important;\n  }\n\n  .mh-lg-150px {\n    max-height: 150px !important;\n  }\n\n  .mh-lg-175px {\n    max-height: 175px !important;\n  }\n\n  .mh-lg-200px {\n    max-height: 200px !important;\n  }\n\n  .mh-lg-225px {\n    max-height: 225px !important;\n  }\n\n  .mh-lg-250px {\n    max-height: 250px !important;\n  }\n\n  .mh-lg-275px {\n    max-height: 275px !important;\n  }\n\n  .mh-lg-300px {\n    max-height: 300px !important;\n  }\n\n  .mh-lg-325px {\n    max-height: 325px !important;\n  }\n\n  .mh-lg-350px {\n    max-height: 350px !important;\n  }\n\n  .mh-lg-375px {\n    max-height: 375px !important;\n  }\n\n  .mh-lg-400px {\n    max-height: 400px !important;\n  }\n\n  .mh-lg-425px {\n    max-height: 425px !important;\n  }\n\n  .mh-lg-450px {\n    max-height: 450px !important;\n  }\n\n  .mh-lg-475px {\n    max-height: 475px !important;\n  }\n\n  .mh-lg-500px {\n    max-height: 500px !important;\n  }\n\n  .mh-lg-550px {\n    max-height: 550px !important;\n  }\n\n  .mh-lg-600px {\n    max-height: 600px !important;\n  }\n\n  .mh-lg-650px {\n    max-height: 650px !important;\n  }\n\n  .mh-lg-700px {\n    max-height: 700px !important;\n  }\n\n  .mh-lg-750px {\n    max-height: 750px !important;\n  }\n\n  .mh-lg-800px {\n    max-height: 800px !important;\n  }\n\n  .mh-lg-850px {\n    max-height: 850px !important;\n  }\n\n  .mh-lg-900px {\n    max-height: 900px !important;\n  }\n\n  .mh-lg-950px {\n    max-height: 950px !important;\n  }\n\n  .mh-lg-1000px {\n    max-height: 1000px !important;\n  }\n\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n\n  .justify-content-lg-evenly {\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n\n  .order-lg-first {\n    order: -1 !important;\n  }\n\n  .order-lg-0 {\n    order: 0 !important;\n  }\n\n  .order-lg-1 {\n    order: 1 !important;\n  }\n\n  .order-lg-2 {\n    order: 2 !important;\n  }\n\n  .order-lg-3 {\n    order: 3 !important;\n  }\n\n  .order-lg-4 {\n    order: 4 !important;\n  }\n\n  .order-lg-5 {\n    order: 5 !important;\n  }\n\n  .order-lg-last {\n    order: 6 !important;\n  }\n\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-lg-3 {\n    margin: 0.75rem !important;\n  }\n\n  .m-lg-4 {\n    margin: 1rem !important;\n  }\n\n  .m-lg-5 {\n    margin: 1.25rem !important;\n  }\n\n  .m-lg-6 {\n    margin: 1.5rem !important;\n  }\n\n  .m-lg-7 {\n    margin: 1.75rem !important;\n  }\n\n  .m-lg-8 {\n    margin: 2rem !important;\n  }\n\n  .m-lg-9 {\n    margin: 2.25rem !important;\n  }\n\n  .m-lg-10 {\n    margin: 2.5rem !important;\n  }\n\n  .m-lg-11 {\n    margin: 2.75rem !important;\n  }\n\n  .m-lg-12 {\n    margin: 3rem !important;\n  }\n\n  .m-lg-13 {\n    margin: 3.25rem !important;\n  }\n\n  .m-lg-14 {\n    margin: 3.5rem !important;\n  }\n\n  .m-lg-15 {\n    margin: 3.75rem !important;\n  }\n\n  .m-lg-16 {\n    margin: 4rem !important;\n  }\n\n  .m-lg-17 {\n    margin: 4.25rem !important;\n  }\n\n  .m-lg-18 {\n    margin: 4.5rem !important;\n  }\n\n  .m-lg-19 {\n    margin: 4.75rem !important;\n  }\n\n  .m-lg-20 {\n    margin: 5rem !important;\n  }\n\n  .m-lg-auto {\n    margin: auto !important;\n  }\n\n  .mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .mx-lg-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n\n  .mx-lg-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n\n  .mx-lg-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n\n  .mx-lg-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .mx-lg-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n\n  .mx-lg-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n\n  .mx-lg-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n\n  .mx-lg-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n\n  .mx-lg-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n\n  .mx-lg-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n\n  .mx-lg-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n\n  .mx-lg-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n\n  .mx-lg-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n\n  .mx-lg-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n\n  .mx-lg-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n\n  .mx-lg-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n\n  .mx-lg-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n\n  .mx-lg-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n\n  .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-lg-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-lg-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n\n  .my-lg-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-lg-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n\n  .my-lg-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-lg-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n\n  .my-lg-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n\n  .my-lg-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n\n  .my-lg-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n\n  .my-lg-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n\n  .my-lg-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-lg-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n\n  .my-lg-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-lg-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n\n  .my-lg-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-lg-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n\n  .my-lg-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-lg-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n\n  .my-lg-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-lg-0 {\n    margin-top: 0 !important;\n  }\n\n  .mt-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-lg-3 {\n    margin-top: 0.75rem !important;\n  }\n\n  .mt-lg-4 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-lg-5 {\n    margin-top: 1.25rem !important;\n  }\n\n  .mt-lg-6 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-lg-7 {\n    margin-top: 1.75rem !important;\n  }\n\n  .mt-lg-8 {\n    margin-top: 2rem !important;\n  }\n\n  .mt-lg-9 {\n    margin-top: 2.25rem !important;\n  }\n\n  .mt-lg-10 {\n    margin-top: 2.5rem !important;\n  }\n\n  .mt-lg-11 {\n    margin-top: 2.75rem !important;\n  }\n\n  .mt-lg-12 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-lg-13 {\n    margin-top: 3.25rem !important;\n  }\n\n  .mt-lg-14 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-lg-15 {\n    margin-top: 3.75rem !important;\n  }\n\n  .mt-lg-16 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-lg-17 {\n    margin-top: 4.25rem !important;\n  }\n\n  .mt-lg-18 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-lg-19 {\n    margin-top: 4.75rem !important;\n  }\n\n  .mt-lg-20 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-lg-auto {\n    margin-top: auto !important;\n  }\n\n  .me-lg-0 {\n    margin-right: 0 !important;\n  }\n\n  .me-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-lg-3 {\n    margin-right: 0.75rem !important;\n  }\n\n  .me-lg-4 {\n    margin-right: 1rem !important;\n  }\n\n  .me-lg-5 {\n    margin-right: 1.25rem !important;\n  }\n\n  .me-lg-6 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-lg-7 {\n    margin-right: 1.75rem !important;\n  }\n\n  .me-lg-8 {\n    margin-right: 2rem !important;\n  }\n\n  .me-lg-9 {\n    margin-right: 2.25rem !important;\n  }\n\n  .me-lg-10 {\n    margin-right: 2.5rem !important;\n  }\n\n  .me-lg-11 {\n    margin-right: 2.75rem !important;\n  }\n\n  .me-lg-12 {\n    margin-right: 3rem !important;\n  }\n\n  .me-lg-13 {\n    margin-right: 3.25rem !important;\n  }\n\n  .me-lg-14 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-lg-15 {\n    margin-right: 3.75rem !important;\n  }\n\n  .me-lg-16 {\n    margin-right: 4rem !important;\n  }\n\n  .me-lg-17 {\n    margin-right: 4.25rem !important;\n  }\n\n  .me-lg-18 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-lg-19 {\n    margin-right: 4.75rem !important;\n  }\n\n  .me-lg-20 {\n    margin-right: 5rem !important;\n  }\n\n  .me-lg-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-lg-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .mb-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-lg-3 {\n    margin-bottom: 0.75rem !important;\n  }\n\n  .mb-lg-4 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-lg-5 {\n    margin-bottom: 1.25rem !important;\n  }\n\n  .mb-lg-6 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-lg-7 {\n    margin-bottom: 1.75rem !important;\n  }\n\n  .mb-lg-8 {\n    margin-bottom: 2rem !important;\n  }\n\n  .mb-lg-9 {\n    margin-bottom: 2.25rem !important;\n  }\n\n  .mb-lg-10 {\n    margin-bottom: 2.5rem !important;\n  }\n\n  .mb-lg-11 {\n    margin-bottom: 2.75rem !important;\n  }\n\n  .mb-lg-12 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-lg-13 {\n    margin-bottom: 3.25rem !important;\n  }\n\n  .mb-lg-14 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-lg-15 {\n    margin-bottom: 3.75rem !important;\n  }\n\n  .mb-lg-16 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-lg-17 {\n    margin-bottom: 4.25rem !important;\n  }\n\n  .mb-lg-18 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-lg-19 {\n    margin-bottom: 4.75rem !important;\n  }\n\n  .mb-lg-20 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-lg-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-lg-0 {\n    margin-left: 0 !important;\n  }\n\n  .ms-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-lg-3 {\n    margin-left: 0.75rem !important;\n  }\n\n  .ms-lg-4 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-lg-5 {\n    margin-left: 1.25rem !important;\n  }\n\n  .ms-lg-6 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-lg-7 {\n    margin-left: 1.75rem !important;\n  }\n\n  .ms-lg-8 {\n    margin-left: 2rem !important;\n  }\n\n  .ms-lg-9 {\n    margin-left: 2.25rem !important;\n  }\n\n  .ms-lg-10 {\n    margin-left: 2.5rem !important;\n  }\n\n  .ms-lg-11 {\n    margin-left: 2.75rem !important;\n  }\n\n  .ms-lg-12 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-lg-13 {\n    margin-left: 3.25rem !important;\n  }\n\n  .ms-lg-14 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-lg-15 {\n    margin-left: 3.75rem !important;\n  }\n\n  .ms-lg-16 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-lg-17 {\n    margin-left: 4.25rem !important;\n  }\n\n  .ms-lg-18 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-lg-19 {\n    margin-left: 4.75rem !important;\n  }\n\n  .ms-lg-20 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-lg-auto {\n    margin-left: auto !important;\n  }\n\n  .m-lg-n1 {\n    margin: -0.25rem !important;\n  }\n\n  .m-lg-n2 {\n    margin: -0.5rem !important;\n  }\n\n  .m-lg-n3 {\n    margin: -0.75rem !important;\n  }\n\n  .m-lg-n4 {\n    margin: -1rem !important;\n  }\n\n  .m-lg-n5 {\n    margin: -1.25rem !important;\n  }\n\n  .m-lg-n6 {\n    margin: -1.5rem !important;\n  }\n\n  .m-lg-n7 {\n    margin: -1.75rem !important;\n  }\n\n  .m-lg-n8 {\n    margin: -2rem !important;\n  }\n\n  .m-lg-n9 {\n    margin: -2.25rem !important;\n  }\n\n  .m-lg-n10 {\n    margin: -2.5rem !important;\n  }\n\n  .m-lg-n11 {\n    margin: -2.75rem !important;\n  }\n\n  .m-lg-n12 {\n    margin: -3rem !important;\n  }\n\n  .m-lg-n13 {\n    margin: -3.25rem !important;\n  }\n\n  .m-lg-n14 {\n    margin: -3.5rem !important;\n  }\n\n  .m-lg-n15 {\n    margin: -3.75rem !important;\n  }\n\n  .m-lg-n16 {\n    margin: -4rem !important;\n  }\n\n  .m-lg-n17 {\n    margin: -4.25rem !important;\n  }\n\n  .m-lg-n18 {\n    margin: -4.5rem !important;\n  }\n\n  .m-lg-n19 {\n    margin: -4.75rem !important;\n  }\n\n  .m-lg-n20 {\n    margin: -5rem !important;\n  }\n\n  .mx-lg-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n\n  .mx-lg-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n\n  .mx-lg-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n\n  .mx-lg-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n\n  .mx-lg-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n\n  .mx-lg-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n\n  .mx-lg-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n\n  .mx-lg-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n\n  .mx-lg-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n\n  .mx-lg-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n\n  .mx-lg-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n\n  .mx-lg-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n\n  .mx-lg-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n\n  .mx-lg-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n\n  .mx-lg-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n\n  .mx-lg-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n\n  .mx-lg-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n\n  .mx-lg-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n\n  .mx-lg-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n\n  .mx-lg-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n\n  .my-lg-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n\n  .my-lg-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n\n  .my-lg-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n\n  .my-lg-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n\n  .my-lg-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n\n  .my-lg-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n\n  .my-lg-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n\n  .my-lg-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n\n  .my-lg-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n\n  .my-lg-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n\n  .my-lg-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n\n  .my-lg-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n\n  .my-lg-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n\n  .my-lg-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n\n  .my-lg-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n\n  .my-lg-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n\n  .my-lg-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n\n  .my-lg-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n\n  .my-lg-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n\n  .my-lg-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n\n  .mt-lg-n1 {\n    margin-top: -0.25rem !important;\n  }\n\n  .mt-lg-n2 {\n    margin-top: -0.5rem !important;\n  }\n\n  .mt-lg-n3 {\n    margin-top: -0.75rem !important;\n  }\n\n  .mt-lg-n4 {\n    margin-top: -1rem !important;\n  }\n\n  .mt-lg-n5 {\n    margin-top: -1.25rem !important;\n  }\n\n  .mt-lg-n6 {\n    margin-top: -1.5rem !important;\n  }\n\n  .mt-lg-n7 {\n    margin-top: -1.75rem !important;\n  }\n\n  .mt-lg-n8 {\n    margin-top: -2rem !important;\n  }\n\n  .mt-lg-n9 {\n    margin-top: -2.25rem !important;\n  }\n\n  .mt-lg-n10 {\n    margin-top: -2.5rem !important;\n  }\n\n  .mt-lg-n11 {\n    margin-top: -2.75rem !important;\n  }\n\n  .mt-lg-n12 {\n    margin-top: -3rem !important;\n  }\n\n  .mt-lg-n13 {\n    margin-top: -3.25rem !important;\n  }\n\n  .mt-lg-n14 {\n    margin-top: -3.5rem !important;\n  }\n\n  .mt-lg-n15 {\n    margin-top: -3.75rem !important;\n  }\n\n  .mt-lg-n16 {\n    margin-top: -4rem !important;\n  }\n\n  .mt-lg-n17 {\n    margin-top: -4.25rem !important;\n  }\n\n  .mt-lg-n18 {\n    margin-top: -4.5rem !important;\n  }\n\n  .mt-lg-n19 {\n    margin-top: -4.75rem !important;\n  }\n\n  .mt-lg-n20 {\n    margin-top: -5rem !important;\n  }\n\n  .me-lg-n1 {\n    margin-right: -0.25rem !important;\n  }\n\n  .me-lg-n2 {\n    margin-right: -0.5rem !important;\n  }\n\n  .me-lg-n3 {\n    margin-right: -0.75rem !important;\n  }\n\n  .me-lg-n4 {\n    margin-right: -1rem !important;\n  }\n\n  .me-lg-n5 {\n    margin-right: -1.25rem !important;\n  }\n\n  .me-lg-n6 {\n    margin-right: -1.5rem !important;\n  }\n\n  .me-lg-n7 {\n    margin-right: -1.75rem !important;\n  }\n\n  .me-lg-n8 {\n    margin-right: -2rem !important;\n  }\n\n  .me-lg-n9 {\n    margin-right: -2.25rem !important;\n  }\n\n  .me-lg-n10 {\n    margin-right: -2.5rem !important;\n  }\n\n  .me-lg-n11 {\n    margin-right: -2.75rem !important;\n  }\n\n  .me-lg-n12 {\n    margin-right: -3rem !important;\n  }\n\n  .me-lg-n13 {\n    margin-right: -3.25rem !important;\n  }\n\n  .me-lg-n14 {\n    margin-right: -3.5rem !important;\n  }\n\n  .me-lg-n15 {\n    margin-right: -3.75rem !important;\n  }\n\n  .me-lg-n16 {\n    margin-right: -4rem !important;\n  }\n\n  .me-lg-n17 {\n    margin-right: -4.25rem !important;\n  }\n\n  .me-lg-n18 {\n    margin-right: -4.5rem !important;\n  }\n\n  .me-lg-n19 {\n    margin-right: -4.75rem !important;\n  }\n\n  .me-lg-n20 {\n    margin-right: -5rem !important;\n  }\n\n  .mb-lg-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n\n  .mb-lg-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n\n  .mb-lg-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n\n  .mb-lg-n4 {\n    margin-bottom: -1rem !important;\n  }\n\n  .mb-lg-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n\n  .mb-lg-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n\n  .mb-lg-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n\n  .mb-lg-n8 {\n    margin-bottom: -2rem !important;\n  }\n\n  .mb-lg-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n\n  .mb-lg-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n\n  .mb-lg-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n\n  .mb-lg-n12 {\n    margin-bottom: -3rem !important;\n  }\n\n  .mb-lg-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n\n  .mb-lg-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n\n  .mb-lg-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n\n  .mb-lg-n16 {\n    margin-bottom: -4rem !important;\n  }\n\n  .mb-lg-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n\n  .mb-lg-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n\n  .mb-lg-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n\n  .mb-lg-n20 {\n    margin-bottom: -5rem !important;\n  }\n\n  .ms-lg-n1 {\n    margin-left: -0.25rem !important;\n  }\n\n  .ms-lg-n2 {\n    margin-left: -0.5rem !important;\n  }\n\n  .ms-lg-n3 {\n    margin-left: -0.75rem !important;\n  }\n\n  .ms-lg-n4 {\n    margin-left: -1rem !important;\n  }\n\n  .ms-lg-n5 {\n    margin-left: -1.25rem !important;\n  }\n\n  .ms-lg-n6 {\n    margin-left: -1.5rem !important;\n  }\n\n  .ms-lg-n7 {\n    margin-left: -1.75rem !important;\n  }\n\n  .ms-lg-n8 {\n    margin-left: -2rem !important;\n  }\n\n  .ms-lg-n9 {\n    margin-left: -2.25rem !important;\n  }\n\n  .ms-lg-n10 {\n    margin-left: -2.5rem !important;\n  }\n\n  .ms-lg-n11 {\n    margin-left: -2.75rem !important;\n  }\n\n  .ms-lg-n12 {\n    margin-left: -3rem !important;\n  }\n\n  .ms-lg-n13 {\n    margin-left: -3.25rem !important;\n  }\n\n  .ms-lg-n14 {\n    margin-left: -3.5rem !important;\n  }\n\n  .ms-lg-n15 {\n    margin-left: -3.75rem !important;\n  }\n\n  .ms-lg-n16 {\n    margin-left: -4rem !important;\n  }\n\n  .ms-lg-n17 {\n    margin-left: -4.25rem !important;\n  }\n\n  .ms-lg-n18 {\n    margin-left: -4.5rem !important;\n  }\n\n  .ms-lg-n19 {\n    margin-left: -4.75rem !important;\n  }\n\n  .ms-lg-n20 {\n    margin-left: -5rem !important;\n  }\n\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-lg-3 {\n    padding: 0.75rem !important;\n  }\n\n  .p-lg-4 {\n    padding: 1rem !important;\n  }\n\n  .p-lg-5 {\n    padding: 1.25rem !important;\n  }\n\n  .p-lg-6 {\n    padding: 1.5rem !important;\n  }\n\n  .p-lg-7 {\n    padding: 1.75rem !important;\n  }\n\n  .p-lg-8 {\n    padding: 2rem !important;\n  }\n\n  .p-lg-9 {\n    padding: 2.25rem !important;\n  }\n\n  .p-lg-10 {\n    padding: 2.5rem !important;\n  }\n\n  .p-lg-11 {\n    padding: 2.75rem !important;\n  }\n\n  .p-lg-12 {\n    padding: 3rem !important;\n  }\n\n  .p-lg-13 {\n    padding: 3.25rem !important;\n  }\n\n  .p-lg-14 {\n    padding: 3.5rem !important;\n  }\n\n  .p-lg-15 {\n    padding: 3.75rem !important;\n  }\n\n  .p-lg-16 {\n    padding: 4rem !important;\n  }\n\n  .p-lg-17 {\n    padding: 4.25rem !important;\n  }\n\n  .p-lg-18 {\n    padding: 4.5rem !important;\n  }\n\n  .p-lg-19 {\n    padding: 4.75rem !important;\n  }\n\n  .p-lg-20 {\n    padding: 5rem !important;\n  }\n\n  .px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .px-lg-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n\n  .px-lg-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n\n  .px-lg-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n\n  .px-lg-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .px-lg-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n\n  .px-lg-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n\n  .px-lg-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n\n  .px-lg-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n\n  .px-lg-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n\n  .px-lg-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n\n  .px-lg-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n\n  .px-lg-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n\n  .px-lg-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n\n  .px-lg-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n\n  .px-lg-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n\n  .px-lg-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n\n  .px-lg-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n\n  .px-lg-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n\n  .py-lg-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-lg-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n\n  .py-lg-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-lg-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n\n  .py-lg-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-lg-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n\n  .py-lg-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n\n  .py-lg-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n\n  .py-lg-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n\n  .py-lg-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n\n  .py-lg-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .py-lg-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n\n  .py-lg-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-lg-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n\n  .py-lg-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-lg-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n\n  .py-lg-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-lg-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n\n  .py-lg-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .pt-lg-0 {\n    padding-top: 0 !important;\n  }\n\n  .pt-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-lg-3 {\n    padding-top: 0.75rem !important;\n  }\n\n  .pt-lg-4 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-lg-5 {\n    padding-top: 1.25rem !important;\n  }\n\n  .pt-lg-6 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-lg-7 {\n    padding-top: 1.75rem !important;\n  }\n\n  .pt-lg-8 {\n    padding-top: 2rem !important;\n  }\n\n  .pt-lg-9 {\n    padding-top: 2.25rem !important;\n  }\n\n  .pt-lg-10 {\n    padding-top: 2.5rem !important;\n  }\n\n  .pt-lg-11 {\n    padding-top: 2.75rem !important;\n  }\n\n  .pt-lg-12 {\n    padding-top: 3rem !important;\n  }\n\n  .pt-lg-13 {\n    padding-top: 3.25rem !important;\n  }\n\n  .pt-lg-14 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-lg-15 {\n    padding-top: 3.75rem !important;\n  }\n\n  .pt-lg-16 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-lg-17 {\n    padding-top: 4.25rem !important;\n  }\n\n  .pt-lg-18 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-lg-19 {\n    padding-top: 4.75rem !important;\n  }\n\n  .pt-lg-20 {\n    padding-top: 5rem !important;\n  }\n\n  .pe-lg-0 {\n    padding-right: 0 !important;\n  }\n\n  .pe-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-lg-3 {\n    padding-right: 0.75rem !important;\n  }\n\n  .pe-lg-4 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-lg-5 {\n    padding-right: 1.25rem !important;\n  }\n\n  .pe-lg-6 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-lg-7 {\n    padding-right: 1.75rem !important;\n  }\n\n  .pe-lg-8 {\n    padding-right: 2rem !important;\n  }\n\n  .pe-lg-9 {\n    padding-right: 2.25rem !important;\n  }\n\n  .pe-lg-10 {\n    padding-right: 2.5rem !important;\n  }\n\n  .pe-lg-11 {\n    padding-right: 2.75rem !important;\n  }\n\n  .pe-lg-12 {\n    padding-right: 3rem !important;\n  }\n\n  .pe-lg-13 {\n    padding-right: 3.25rem !important;\n  }\n\n  .pe-lg-14 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-lg-15 {\n    padding-right: 3.75rem !important;\n  }\n\n  .pe-lg-16 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-lg-17 {\n    padding-right: 4.25rem !important;\n  }\n\n  .pe-lg-18 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-lg-19 {\n    padding-right: 4.75rem !important;\n  }\n\n  .pe-lg-20 {\n    padding-right: 5rem !important;\n  }\n\n  .pb-lg-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pb-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-lg-3 {\n    padding-bottom: 0.75rem !important;\n  }\n\n  .pb-lg-4 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-lg-5 {\n    padding-bottom: 1.25rem !important;\n  }\n\n  .pb-lg-6 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-lg-7 {\n    padding-bottom: 1.75rem !important;\n  }\n\n  .pb-lg-8 {\n    padding-bottom: 2rem !important;\n  }\n\n  .pb-lg-9 {\n    padding-bottom: 2.25rem !important;\n  }\n\n  .pb-lg-10 {\n    padding-bottom: 2.5rem !important;\n  }\n\n  .pb-lg-11 {\n    padding-bottom: 2.75rem !important;\n  }\n\n  .pb-lg-12 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pb-lg-13 {\n    padding-bottom: 3.25rem !important;\n  }\n\n  .pb-lg-14 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-lg-15 {\n    padding-bottom: 3.75rem !important;\n  }\n\n  .pb-lg-16 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-lg-17 {\n    padding-bottom: 4.25rem !important;\n  }\n\n  .pb-lg-18 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-lg-19 {\n    padding-bottom: 4.75rem !important;\n  }\n\n  .pb-lg-20 {\n    padding-bottom: 5rem !important;\n  }\n\n  .ps-lg-0 {\n    padding-left: 0 !important;\n  }\n\n  .ps-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-lg-3 {\n    padding-left: 0.75rem !important;\n  }\n\n  .ps-lg-4 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-lg-5 {\n    padding-left: 1.25rem !important;\n  }\n\n  .ps-lg-6 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-lg-7 {\n    padding-left: 1.75rem !important;\n  }\n\n  .ps-lg-8 {\n    padding-left: 2rem !important;\n  }\n\n  .ps-lg-9 {\n    padding-left: 2.25rem !important;\n  }\n\n  .ps-lg-10 {\n    padding-left: 2.5rem !important;\n  }\n\n  .ps-lg-11 {\n    padding-left: 2.75rem !important;\n  }\n\n  .ps-lg-12 {\n    padding-left: 3rem !important;\n  }\n\n  .ps-lg-13 {\n    padding-left: 3.25rem !important;\n  }\n\n  .ps-lg-14 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-lg-15 {\n    padding-left: 3.75rem !important;\n  }\n\n  .ps-lg-16 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-lg-17 {\n    padding-left: 4.25rem !important;\n  }\n\n  .ps-lg-18 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-lg-19 {\n    padding-left: 4.75rem !important;\n  }\n\n  .ps-lg-20 {\n    padding-left: 5rem !important;\n  }\n\n  .gap-lg-0 {\n    gap: 0 !important;\n  }\n\n  .gap-lg-1 {\n    gap: 0.25rem !important;\n  }\n\n  .gap-lg-2 {\n    gap: 0.5rem !important;\n  }\n\n  .gap-lg-3 {\n    gap: 0.75rem !important;\n  }\n\n  .gap-lg-4 {\n    gap: 1rem !important;\n  }\n\n  .gap-lg-5 {\n    gap: 1.25rem !important;\n  }\n\n  .gap-lg-6 {\n    gap: 1.5rem !important;\n  }\n\n  .gap-lg-7 {\n    gap: 1.75rem !important;\n  }\n\n  .gap-lg-8 {\n    gap: 2rem !important;\n  }\n\n  .gap-lg-9 {\n    gap: 2.25rem !important;\n  }\n\n  .gap-lg-10 {\n    gap: 2.5rem !important;\n  }\n\n  .gap-lg-11 {\n    gap: 2.75rem !important;\n  }\n\n  .gap-lg-12 {\n    gap: 3rem !important;\n  }\n\n  .gap-lg-13 {\n    gap: 3.25rem !important;\n  }\n\n  .gap-lg-14 {\n    gap: 3.5rem !important;\n  }\n\n  .gap-lg-15 {\n    gap: 3.75rem !important;\n  }\n\n  .gap-lg-16 {\n    gap: 4rem !important;\n  }\n\n  .gap-lg-17 {\n    gap: 4.25rem !important;\n  }\n\n  .gap-lg-18 {\n    gap: 4.5rem !important;\n  }\n\n  .gap-lg-19 {\n    gap: 4.75rem !important;\n  }\n\n  .gap-lg-20 {\n    gap: 5rem !important;\n  }\n\n  .row-gap-lg-0 {\n    row-gap: 0 !important;\n  }\n\n  .row-gap-lg-1 {\n    row-gap: 0.25rem !important;\n  }\n\n  .row-gap-lg-2 {\n    row-gap: 0.5rem !important;\n  }\n\n  .row-gap-lg-3 {\n    row-gap: 0.75rem !important;\n  }\n\n  .row-gap-lg-4 {\n    row-gap: 1rem !important;\n  }\n\n  .row-gap-lg-5 {\n    row-gap: 1.25rem !important;\n  }\n\n  .row-gap-lg-6 {\n    row-gap: 1.5rem !important;\n  }\n\n  .row-gap-lg-7 {\n    row-gap: 1.75rem !important;\n  }\n\n  .row-gap-lg-8 {\n    row-gap: 2rem !important;\n  }\n\n  .row-gap-lg-9 {\n    row-gap: 2.25rem !important;\n  }\n\n  .row-gap-lg-10 {\n    row-gap: 2.5rem !important;\n  }\n\n  .row-gap-lg-11 {\n    row-gap: 2.75rem !important;\n  }\n\n  .row-gap-lg-12 {\n    row-gap: 3rem !important;\n  }\n\n  .row-gap-lg-13 {\n    row-gap: 3.25rem !important;\n  }\n\n  .row-gap-lg-14 {\n    row-gap: 3.5rem !important;\n  }\n\n  .row-gap-lg-15 {\n    row-gap: 3.75rem !important;\n  }\n\n  .row-gap-lg-16 {\n    row-gap: 4rem !important;\n  }\n\n  .row-gap-lg-17 {\n    row-gap: 4.25rem !important;\n  }\n\n  .row-gap-lg-18 {\n    row-gap: 4.5rem !important;\n  }\n\n  .row-gap-lg-19 {\n    row-gap: 4.75rem !important;\n  }\n\n  .row-gap-lg-20 {\n    row-gap: 5rem !important;\n  }\n\n  .column-gap-lg-0 {\n    column-gap: 0 !important;\n  }\n\n  .column-gap-lg-1 {\n    column-gap: 0.25rem !important;\n  }\n\n  .column-gap-lg-2 {\n    column-gap: 0.5rem !important;\n  }\n\n  .column-gap-lg-3 {\n    column-gap: 0.75rem !important;\n  }\n\n  .column-gap-lg-4 {\n    column-gap: 1rem !important;\n  }\n\n  .column-gap-lg-5 {\n    column-gap: 1.25rem !important;\n  }\n\n  .column-gap-lg-6 {\n    column-gap: 1.5rem !important;\n  }\n\n  .column-gap-lg-7 {\n    column-gap: 1.75rem !important;\n  }\n\n  .column-gap-lg-8 {\n    column-gap: 2rem !important;\n  }\n\n  .column-gap-lg-9 {\n    column-gap: 2.25rem !important;\n  }\n\n  .column-gap-lg-10 {\n    column-gap: 2.5rem !important;\n  }\n\n  .column-gap-lg-11 {\n    column-gap: 2.75rem !important;\n  }\n\n  .column-gap-lg-12 {\n    column-gap: 3rem !important;\n  }\n\n  .column-gap-lg-13 {\n    column-gap: 3.25rem !important;\n  }\n\n  .column-gap-lg-14 {\n    column-gap: 3.5rem !important;\n  }\n\n  .column-gap-lg-15 {\n    column-gap: 3.75rem !important;\n  }\n\n  .column-gap-lg-16 {\n    column-gap: 4rem !important;\n  }\n\n  .column-gap-lg-17 {\n    column-gap: 4.25rem !important;\n  }\n\n  .column-gap-lg-18 {\n    column-gap: 4.5rem !important;\n  }\n\n  .column-gap-lg-19 {\n    column-gap: 4.75rem !important;\n  }\n\n  .column-gap-lg-20 {\n    column-gap: 5rem !important;\n  }\n\n  .fs-lg-1 {\n    font-size: calc(1.3rem + 0.6vw) !important;\n  }\n\n  .fs-lg-2 {\n    font-size: calc(1.275rem + 0.3vw) !important;\n  }\n\n  .fs-lg-3 {\n    font-size: calc(1.26rem + 0.12vw) !important;\n  }\n\n  .fs-lg-4 {\n    font-size: 1.25rem !important;\n  }\n\n  .fs-lg-5 {\n    font-size: 1.15rem !important;\n  }\n\n  .fs-lg-6 {\n    font-size: 1.075rem !important;\n  }\n\n  .fs-lg-7 {\n    font-size: 0.95rem !important;\n  }\n\n  .fs-lg-8 {\n    font-size: 0.85rem !important;\n  }\n\n  .fs-lg-9 {\n    font-size: 0.75rem !important;\n  }\n\n  .fs-lg-10 {\n    font-size: 0.5rem !important;\n  }\n\n  .fs-lg-base {\n    font-size: 1rem !important;\n  }\n\n  .fs-lg-fluid {\n    font-size: 100% !important;\n  }\n\n  .fs-lg-2x {\n    font-size: calc(1.325rem + 0.9vw) !important;\n  }\n\n  .fs-lg-2qx {\n    font-size: calc(1.35rem + 1.2vw) !important;\n  }\n\n  .fs-lg-2hx {\n    font-size: calc(1.375rem + 1.5vw) !important;\n  }\n\n  .fs-lg-2tx {\n    font-size: calc(1.4rem + 1.8vw) !important;\n  }\n\n  .fs-lg-3x {\n    font-size: calc(1.425rem + 2.1vw) !important;\n  }\n\n  .fs-lg-3qx {\n    font-size: calc(1.45rem + 2.4vw) !important;\n  }\n\n  .fs-lg-3hx {\n    font-size: calc(1.475rem + 2.7vw) !important;\n  }\n\n  .fs-lg-3tx {\n    font-size: calc(1.5rem + 3vw) !important;\n  }\n\n  .fs-lg-4x {\n    font-size: calc(1.525rem + 3.3vw) !important;\n  }\n\n  .fs-lg-4qx {\n    font-size: calc(1.55rem + 3.6vw) !important;\n  }\n\n  .fs-lg-4hx {\n    font-size: calc(1.575rem + 3.9vw) !important;\n  }\n\n  .fs-lg-4tx {\n    font-size: calc(1.6rem + 4.2vw) !important;\n  }\n\n  .fs-lg-5x {\n    font-size: calc(1.625rem + 4.5vw) !important;\n  }\n\n  .fs-lg-5qx {\n    font-size: calc(1.65rem + 4.8vw) !important;\n  }\n\n  .fs-lg-5hx {\n    font-size: calc(1.675rem + 5.1vw) !important;\n  }\n\n  .fs-lg-5tx {\n    font-size: calc(1.7rem + 5.4vw) !important;\n  }\n\n  .text-lg-start {\n    text-align: left !important;\n  }\n\n  .text-lg-end {\n    text-align: right !important;\n  }\n\n  .text-lg-center {\n    text-align: center !important;\n  }\n\n  .min-w-lg-unset {\n    min-width: unset !important;\n  }\n\n  .min-w-lg-25 {\n    min-width: 25% !important;\n  }\n\n  .min-w-lg-50 {\n    min-width: 50% !important;\n  }\n\n  .min-w-lg-75 {\n    min-width: 75% !important;\n  }\n\n  .min-w-lg-100 {\n    min-width: 100% !important;\n  }\n\n  .min-w-lg-auto {\n    min-width: auto !important;\n  }\n\n  .min-w-lg-1px {\n    min-width: 1px !important;\n  }\n\n  .min-w-lg-2px {\n    min-width: 2px !important;\n  }\n\n  .min-w-lg-3px {\n    min-width: 3px !important;\n  }\n\n  .min-w-lg-4px {\n    min-width: 4px !important;\n  }\n\n  .min-w-lg-5px {\n    min-width: 5px !important;\n  }\n\n  .min-w-lg-6px {\n    min-width: 6px !important;\n  }\n\n  .min-w-lg-7px {\n    min-width: 7px !important;\n  }\n\n  .min-w-lg-8px {\n    min-width: 8px !important;\n  }\n\n  .min-w-lg-9px {\n    min-width: 9px !important;\n  }\n\n  .min-w-lg-10px {\n    min-width: 10px !important;\n  }\n\n  .min-w-lg-15px {\n    min-width: 15px !important;\n  }\n\n  .min-w-lg-20px {\n    min-width: 20px !important;\n  }\n\n  .min-w-lg-25px {\n    min-width: 25px !important;\n  }\n\n  .min-w-lg-30px {\n    min-width: 30px !important;\n  }\n\n  .min-w-lg-35px {\n    min-width: 35px !important;\n  }\n\n  .min-w-lg-40px {\n    min-width: 40px !important;\n  }\n\n  .min-w-lg-45px {\n    min-width: 45px !important;\n  }\n\n  .min-w-lg-50px {\n    min-width: 50px !important;\n  }\n\n  .min-w-lg-55px {\n    min-width: 55px !important;\n  }\n\n  .min-w-lg-60px {\n    min-width: 60px !important;\n  }\n\n  .min-w-lg-65px {\n    min-width: 65px !important;\n  }\n\n  .min-w-lg-70px {\n    min-width: 70px !important;\n  }\n\n  .min-w-lg-75px {\n    min-width: 75px !important;\n  }\n\n  .min-w-lg-80px {\n    min-width: 80px !important;\n  }\n\n  .min-w-lg-85px {\n    min-width: 85px !important;\n  }\n\n  .min-w-lg-90px {\n    min-width: 90px !important;\n  }\n\n  .min-w-lg-95px {\n    min-width: 95px !important;\n  }\n\n  .min-w-lg-100px {\n    min-width: 100px !important;\n  }\n\n  .min-w-lg-125px {\n    min-width: 125px !important;\n  }\n\n  .min-w-lg-150px {\n    min-width: 150px !important;\n  }\n\n  .min-w-lg-175px {\n    min-width: 175px !important;\n  }\n\n  .min-w-lg-200px {\n    min-width: 200px !important;\n  }\n\n  .min-w-lg-225px {\n    min-width: 225px !important;\n  }\n\n  .min-w-lg-250px {\n    min-width: 250px !important;\n  }\n\n  .min-w-lg-275px {\n    min-width: 275px !important;\n  }\n\n  .min-w-lg-300px {\n    min-width: 300px !important;\n  }\n\n  .min-w-lg-325px {\n    min-width: 325px !important;\n  }\n\n  .min-w-lg-350px {\n    min-width: 350px !important;\n  }\n\n  .min-w-lg-375px {\n    min-width: 375px !important;\n  }\n\n  .min-w-lg-400px {\n    min-width: 400px !important;\n  }\n\n  .min-w-lg-425px {\n    min-width: 425px !important;\n  }\n\n  .min-w-lg-450px {\n    min-width: 450px !important;\n  }\n\n  .min-w-lg-475px {\n    min-width: 475px !important;\n  }\n\n  .min-w-lg-500px {\n    min-width: 500px !important;\n  }\n\n  .min-w-lg-550px {\n    min-width: 550px !important;\n  }\n\n  .min-w-lg-600px {\n    min-width: 600px !important;\n  }\n\n  .min-w-lg-650px {\n    min-width: 650px !important;\n  }\n\n  .min-w-lg-700px {\n    min-width: 700px !important;\n  }\n\n  .min-w-lg-750px {\n    min-width: 750px !important;\n  }\n\n  .min-w-lg-800px {\n    min-width: 800px !important;\n  }\n\n  .min-w-lg-850px {\n    min-width: 850px !important;\n  }\n\n  .min-w-lg-900px {\n    min-width: 900px !important;\n  }\n\n  .min-w-lg-950px {\n    min-width: 950px !important;\n  }\n\n  .min-w-lg-1000px {\n    min-width: 1000px !important;\n  }\n\n  .min-h-lg-unset {\n    min-height: unset !important;\n  }\n\n  .min-h-lg-25 {\n    min-height: 25% !important;\n  }\n\n  .min-h-lg-50 {\n    min-height: 50% !important;\n  }\n\n  .min-h-lg-75 {\n    min-height: 75% !important;\n  }\n\n  .min-h-lg-100 {\n    min-height: 100% !important;\n  }\n\n  .min-h-lg-auto {\n    min-height: auto !important;\n  }\n\n  .min-h-lg-1px {\n    min-height: 1px !important;\n  }\n\n  .min-h-lg-2px {\n    min-height: 2px !important;\n  }\n\n  .min-h-lg-3px {\n    min-height: 3px !important;\n  }\n\n  .min-h-lg-4px {\n    min-height: 4px !important;\n  }\n\n  .min-h-lg-5px {\n    min-height: 5px !important;\n  }\n\n  .min-h-lg-6px {\n    min-height: 6px !important;\n  }\n\n  .min-h-lg-7px {\n    min-height: 7px !important;\n  }\n\n  .min-h-lg-8px {\n    min-height: 8px !important;\n  }\n\n  .min-h-lg-9px {\n    min-height: 9px !important;\n  }\n\n  .min-h-lg-10px {\n    min-height: 10px !important;\n  }\n\n  .min-h-lg-15px {\n    min-height: 15px !important;\n  }\n\n  .min-h-lg-20px {\n    min-height: 20px !important;\n  }\n\n  .min-h-lg-25px {\n    min-height: 25px !important;\n  }\n\n  .min-h-lg-30px {\n    min-height: 30px !important;\n  }\n\n  .min-h-lg-35px {\n    min-height: 35px !important;\n  }\n\n  .min-h-lg-40px {\n    min-height: 40px !important;\n  }\n\n  .min-h-lg-45px {\n    min-height: 45px !important;\n  }\n\n  .min-h-lg-50px {\n    min-height: 50px !important;\n  }\n\n  .min-h-lg-55px {\n    min-height: 55px !important;\n  }\n\n  .min-h-lg-60px {\n    min-height: 60px !important;\n  }\n\n  .min-h-lg-65px {\n    min-height: 65px !important;\n  }\n\n  .min-h-lg-70px {\n    min-height: 70px !important;\n  }\n\n  .min-h-lg-75px {\n    min-height: 75px !important;\n  }\n\n  .min-h-lg-80px {\n    min-height: 80px !important;\n  }\n\n  .min-h-lg-85px {\n    min-height: 85px !important;\n  }\n\n  .min-h-lg-90px {\n    min-height: 90px !important;\n  }\n\n  .min-h-lg-95px {\n    min-height: 95px !important;\n  }\n\n  .min-h-lg-100px {\n    min-height: 100px !important;\n  }\n\n  .min-h-lg-125px {\n    min-height: 125px !important;\n  }\n\n  .min-h-lg-150px {\n    min-height: 150px !important;\n  }\n\n  .min-h-lg-175px {\n    min-height: 175px !important;\n  }\n\n  .min-h-lg-200px {\n    min-height: 200px !important;\n  }\n\n  .min-h-lg-225px {\n    min-height: 225px !important;\n  }\n\n  .min-h-lg-250px {\n    min-height: 250px !important;\n  }\n\n  .min-h-lg-275px {\n    min-height: 275px !important;\n  }\n\n  .min-h-lg-300px {\n    min-height: 300px !important;\n  }\n\n  .min-h-lg-325px {\n    min-height: 325px !important;\n  }\n\n  .min-h-lg-350px {\n    min-height: 350px !important;\n  }\n\n  .min-h-lg-375px {\n    min-height: 375px !important;\n  }\n\n  .min-h-lg-400px {\n    min-height: 400px !important;\n  }\n\n  .min-h-lg-425px {\n    min-height: 425px !important;\n  }\n\n  .min-h-lg-450px {\n    min-height: 450px !important;\n  }\n\n  .min-h-lg-475px {\n    min-height: 475px !important;\n  }\n\n  .min-h-lg-500px {\n    min-height: 500px !important;\n  }\n\n  .min-h-lg-550px {\n    min-height: 550px !important;\n  }\n\n  .min-h-lg-600px {\n    min-height: 600px !important;\n  }\n\n  .min-h-lg-650px {\n    min-height: 650px !important;\n  }\n\n  .min-h-lg-700px {\n    min-height: 700px !important;\n  }\n\n  .min-h-lg-750px {\n    min-height: 750px !important;\n  }\n\n  .min-h-lg-800px {\n    min-height: 800px !important;\n  }\n\n  .min-h-lg-850px {\n    min-height: 850px !important;\n  }\n\n  .min-h-lg-900px {\n    min-height: 900px !important;\n  }\n\n  .min-h-lg-950px {\n    min-height: 950px !important;\n  }\n\n  .min-h-lg-1000px {\n    min-height: 1000px !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-start {\n    float: left !important;\n  }\n\n  .float-xl-end {\n    float: right !important;\n  }\n\n  .float-xl-none {\n    float: none !important;\n  }\n\n  .object-fit-xl-contain {\n    object-fit: contain !important;\n  }\n\n  .object-fit-xl-cover {\n    object-fit: cover !important;\n  }\n\n  .object-fit-xl-fill {\n    object-fit: fill !important;\n  }\n\n  .object-fit-xl-scale {\n    object-fit: scale-down !important;\n  }\n\n  .object-fit-xl-none {\n    object-fit: none !important;\n  }\n\n  .d-xl-inline {\n    display: inline !important;\n  }\n\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-xl-block {\n    display: block !important;\n  }\n\n  .d-xl-grid {\n    display: grid !important;\n  }\n\n  .d-xl-inline-grid {\n    display: inline-grid !important;\n  }\n\n  .d-xl-table {\n    display: table !important;\n  }\n\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-xl-flex {\n    display: flex !important;\n  }\n\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-xl-none {\n    display: none !important;\n  }\n\n  .position-xl-static {\n    position: static !important;\n  }\n\n  .position-xl-relative {\n    position: relative !important;\n  }\n\n  .position-xl-absolute {\n    position: absolute !important;\n  }\n\n  .position-xl-fixed {\n    position: fixed !important;\n  }\n\n  .position-xl-sticky {\n    position: sticky !important;\n  }\n\n  .w-xl-unset {\n    width: unset !important;\n  }\n\n  .w-xl-25 {\n    width: 25% !important;\n  }\n\n  .w-xl-50 {\n    width: 50% !important;\n  }\n\n  .w-xl-75 {\n    width: 75% !important;\n  }\n\n  .w-xl-100 {\n    width: 100% !important;\n  }\n\n  .w-xl-auto {\n    width: auto !important;\n  }\n\n  .w-xl-1px {\n    width: 1px !important;\n  }\n\n  .w-xl-2px {\n    width: 2px !important;\n  }\n\n  .w-xl-3px {\n    width: 3px !important;\n  }\n\n  .w-xl-4px {\n    width: 4px !important;\n  }\n\n  .w-xl-5px {\n    width: 5px !important;\n  }\n\n  .w-xl-6px {\n    width: 6px !important;\n  }\n\n  .w-xl-7px {\n    width: 7px !important;\n  }\n\n  .w-xl-8px {\n    width: 8px !important;\n  }\n\n  .w-xl-9px {\n    width: 9px !important;\n  }\n\n  .w-xl-10px {\n    width: 10px !important;\n  }\n\n  .w-xl-15px {\n    width: 15px !important;\n  }\n\n  .w-xl-20px {\n    width: 20px !important;\n  }\n\n  .w-xl-25px {\n    width: 25px !important;\n  }\n\n  .w-xl-30px {\n    width: 30px !important;\n  }\n\n  .w-xl-35px {\n    width: 35px !important;\n  }\n\n  .w-xl-40px {\n    width: 40px !important;\n  }\n\n  .w-xl-45px {\n    width: 45px !important;\n  }\n\n  .w-xl-50px {\n    width: 50px !important;\n  }\n\n  .w-xl-55px {\n    width: 55px !important;\n  }\n\n  .w-xl-60px {\n    width: 60px !important;\n  }\n\n  .w-xl-65px {\n    width: 65px !important;\n  }\n\n  .w-xl-70px {\n    width: 70px !important;\n  }\n\n  .w-xl-75px {\n    width: 75px !important;\n  }\n\n  .w-xl-80px {\n    width: 80px !important;\n  }\n\n  .w-xl-85px {\n    width: 85px !important;\n  }\n\n  .w-xl-90px {\n    width: 90px !important;\n  }\n\n  .w-xl-95px {\n    width: 95px !important;\n  }\n\n  .w-xl-100px {\n    width: 100px !important;\n  }\n\n  .w-xl-125px {\n    width: 125px !important;\n  }\n\n  .w-xl-150px {\n    width: 150px !important;\n  }\n\n  .w-xl-175px {\n    width: 175px !important;\n  }\n\n  .w-xl-200px {\n    width: 200px !important;\n  }\n\n  .w-xl-225px {\n    width: 225px !important;\n  }\n\n  .w-xl-250px {\n    width: 250px !important;\n  }\n\n  .w-xl-275px {\n    width: 275px !important;\n  }\n\n  .w-xl-300px {\n    width: 300px !important;\n  }\n\n  .w-xl-325px {\n    width: 325px !important;\n  }\n\n  .w-xl-350px {\n    width: 350px !important;\n  }\n\n  .w-xl-375px {\n    width: 375px !important;\n  }\n\n  .w-xl-400px {\n    width: 400px !important;\n  }\n\n  .w-xl-425px {\n    width: 425px !important;\n  }\n\n  .w-xl-450px {\n    width: 450px !important;\n  }\n\n  .w-xl-475px {\n    width: 475px !important;\n  }\n\n  .w-xl-500px {\n    width: 500px !important;\n  }\n\n  .w-xl-550px {\n    width: 550px !important;\n  }\n\n  .w-xl-600px {\n    width: 600px !important;\n  }\n\n  .w-xl-650px {\n    width: 650px !important;\n  }\n\n  .w-xl-700px {\n    width: 700px !important;\n  }\n\n  .w-xl-750px {\n    width: 750px !important;\n  }\n\n  .w-xl-800px {\n    width: 800px !important;\n  }\n\n  .w-xl-850px {\n    width: 850px !important;\n  }\n\n  .w-xl-900px {\n    width: 900px !important;\n  }\n\n  .w-xl-950px {\n    width: 950px !important;\n  }\n\n  .w-xl-1000px {\n    width: 1000px !important;\n  }\n\n  .mw-xl-unset {\n    max-width: unset !important;\n  }\n\n  .mw-xl-25 {\n    max-width: 25% !important;\n  }\n\n  .mw-xl-50 {\n    max-width: 50% !important;\n  }\n\n  .mw-xl-75 {\n    max-width: 75% !important;\n  }\n\n  .mw-xl-100 {\n    max-width: 100% !important;\n  }\n\n  .mw-xl-auto {\n    max-width: auto !important;\n  }\n\n  .mw-xl-1px {\n    max-width: 1px !important;\n  }\n\n  .mw-xl-2px {\n    max-width: 2px !important;\n  }\n\n  .mw-xl-3px {\n    max-width: 3px !important;\n  }\n\n  .mw-xl-4px {\n    max-width: 4px !important;\n  }\n\n  .mw-xl-5px {\n    max-width: 5px !important;\n  }\n\n  .mw-xl-6px {\n    max-width: 6px !important;\n  }\n\n  .mw-xl-7px {\n    max-width: 7px !important;\n  }\n\n  .mw-xl-8px {\n    max-width: 8px !important;\n  }\n\n  .mw-xl-9px {\n    max-width: 9px !important;\n  }\n\n  .mw-xl-10px {\n    max-width: 10px !important;\n  }\n\n  .mw-xl-15px {\n    max-width: 15px !important;\n  }\n\n  .mw-xl-20px {\n    max-width: 20px !important;\n  }\n\n  .mw-xl-25px {\n    max-width: 25px !important;\n  }\n\n  .mw-xl-30px {\n    max-width: 30px !important;\n  }\n\n  .mw-xl-35px {\n    max-width: 35px !important;\n  }\n\n  .mw-xl-40px {\n    max-width: 40px !important;\n  }\n\n  .mw-xl-45px {\n    max-width: 45px !important;\n  }\n\n  .mw-xl-50px {\n    max-width: 50px !important;\n  }\n\n  .mw-xl-55px {\n    max-width: 55px !important;\n  }\n\n  .mw-xl-60px {\n    max-width: 60px !important;\n  }\n\n  .mw-xl-65px {\n    max-width: 65px !important;\n  }\n\n  .mw-xl-70px {\n    max-width: 70px !important;\n  }\n\n  .mw-xl-75px {\n    max-width: 75px !important;\n  }\n\n  .mw-xl-80px {\n    max-width: 80px !important;\n  }\n\n  .mw-xl-85px {\n    max-width: 85px !important;\n  }\n\n  .mw-xl-90px {\n    max-width: 90px !important;\n  }\n\n  .mw-xl-95px {\n    max-width: 95px !important;\n  }\n\n  .mw-xl-100px {\n    max-width: 100px !important;\n  }\n\n  .mw-xl-125px {\n    max-width: 125px !important;\n  }\n\n  .mw-xl-150px {\n    max-width: 150px !important;\n  }\n\n  .mw-xl-175px {\n    max-width: 175px !important;\n  }\n\n  .mw-xl-200px {\n    max-width: 200px !important;\n  }\n\n  .mw-xl-225px {\n    max-width: 225px !important;\n  }\n\n  .mw-xl-250px {\n    max-width: 250px !important;\n  }\n\n  .mw-xl-275px {\n    max-width: 275px !important;\n  }\n\n  .mw-xl-300px {\n    max-width: 300px !important;\n  }\n\n  .mw-xl-325px {\n    max-width: 325px !important;\n  }\n\n  .mw-xl-350px {\n    max-width: 350px !important;\n  }\n\n  .mw-xl-375px {\n    max-width: 375px !important;\n  }\n\n  .mw-xl-400px {\n    max-width: 400px !important;\n  }\n\n  .mw-xl-425px {\n    max-width: 425px !important;\n  }\n\n  .mw-xl-450px {\n    max-width: 450px !important;\n  }\n\n  .mw-xl-475px {\n    max-width: 475px !important;\n  }\n\n  .mw-xl-500px {\n    max-width: 500px !important;\n  }\n\n  .mw-xl-550px {\n    max-width: 550px !important;\n  }\n\n  .mw-xl-600px {\n    max-width: 600px !important;\n  }\n\n  .mw-xl-650px {\n    max-width: 650px !important;\n  }\n\n  .mw-xl-700px {\n    max-width: 700px !important;\n  }\n\n  .mw-xl-750px {\n    max-width: 750px !important;\n  }\n\n  .mw-xl-800px {\n    max-width: 800px !important;\n  }\n\n  .mw-xl-850px {\n    max-width: 850px !important;\n  }\n\n  .mw-xl-900px {\n    max-width: 900px !important;\n  }\n\n  .mw-xl-950px {\n    max-width: 950px !important;\n  }\n\n  .mw-xl-1000px {\n    max-width: 1000px !important;\n  }\n\n  .h-xl-unset {\n    height: unset !important;\n  }\n\n  .h-xl-25 {\n    height: 25% !important;\n  }\n\n  .h-xl-50 {\n    height: 50% !important;\n  }\n\n  .h-xl-75 {\n    height: 75% !important;\n  }\n\n  .h-xl-100 {\n    height: 100% !important;\n  }\n\n  .h-xl-auto {\n    height: auto !important;\n  }\n\n  .h-xl-1px {\n    height: 1px !important;\n  }\n\n  .h-xl-2px {\n    height: 2px !important;\n  }\n\n  .h-xl-3px {\n    height: 3px !important;\n  }\n\n  .h-xl-4px {\n    height: 4px !important;\n  }\n\n  .h-xl-5px {\n    height: 5px !important;\n  }\n\n  .h-xl-6px {\n    height: 6px !important;\n  }\n\n  .h-xl-7px {\n    height: 7px !important;\n  }\n\n  .h-xl-8px {\n    height: 8px !important;\n  }\n\n  .h-xl-9px {\n    height: 9px !important;\n  }\n\n  .h-xl-10px {\n    height: 10px !important;\n  }\n\n  .h-xl-15px {\n    height: 15px !important;\n  }\n\n  .h-xl-20px {\n    height: 20px !important;\n  }\n\n  .h-xl-25px {\n    height: 25px !important;\n  }\n\n  .h-xl-30px {\n    height: 30px !important;\n  }\n\n  .h-xl-35px {\n    height: 35px !important;\n  }\n\n  .h-xl-40px {\n    height: 40px !important;\n  }\n\n  .h-xl-45px {\n    height: 45px !important;\n  }\n\n  .h-xl-50px {\n    height: 50px !important;\n  }\n\n  .h-xl-55px {\n    height: 55px !important;\n  }\n\n  .h-xl-60px {\n    height: 60px !important;\n  }\n\n  .h-xl-65px {\n    height: 65px !important;\n  }\n\n  .h-xl-70px {\n    height: 70px !important;\n  }\n\n  .h-xl-75px {\n    height: 75px !important;\n  }\n\n  .h-xl-80px {\n    height: 80px !important;\n  }\n\n  .h-xl-85px {\n    height: 85px !important;\n  }\n\n  .h-xl-90px {\n    height: 90px !important;\n  }\n\n  .h-xl-95px {\n    height: 95px !important;\n  }\n\n  .h-xl-100px {\n    height: 100px !important;\n  }\n\n  .h-xl-125px {\n    height: 125px !important;\n  }\n\n  .h-xl-150px {\n    height: 150px !important;\n  }\n\n  .h-xl-175px {\n    height: 175px !important;\n  }\n\n  .h-xl-200px {\n    height: 200px !important;\n  }\n\n  .h-xl-225px {\n    height: 225px !important;\n  }\n\n  .h-xl-250px {\n    height: 250px !important;\n  }\n\n  .h-xl-275px {\n    height: 275px !important;\n  }\n\n  .h-xl-300px {\n    height: 300px !important;\n  }\n\n  .h-xl-325px {\n    height: 325px !important;\n  }\n\n  .h-xl-350px {\n    height: 350px !important;\n  }\n\n  .h-xl-375px {\n    height: 375px !important;\n  }\n\n  .h-xl-400px {\n    height: 400px !important;\n  }\n\n  .h-xl-425px {\n    height: 425px !important;\n  }\n\n  .h-xl-450px {\n    height: 450px !important;\n  }\n\n  .h-xl-475px {\n    height: 475px !important;\n  }\n\n  .h-xl-500px {\n    height: 500px !important;\n  }\n\n  .h-xl-550px {\n    height: 550px !important;\n  }\n\n  .h-xl-600px {\n    height: 600px !important;\n  }\n\n  .h-xl-650px {\n    height: 650px !important;\n  }\n\n  .h-xl-700px {\n    height: 700px !important;\n  }\n\n  .h-xl-750px {\n    height: 750px !important;\n  }\n\n  .h-xl-800px {\n    height: 800px !important;\n  }\n\n  .h-xl-850px {\n    height: 850px !important;\n  }\n\n  .h-xl-900px {\n    height: 900px !important;\n  }\n\n  .h-xl-950px {\n    height: 950px !important;\n  }\n\n  .h-xl-1000px {\n    height: 1000px !important;\n  }\n\n  .mh-xl-unset {\n    max-height: unset !important;\n  }\n\n  .mh-xl-25 {\n    max-height: 25% !important;\n  }\n\n  .mh-xl-50 {\n    max-height: 50% !important;\n  }\n\n  .mh-xl-75 {\n    max-height: 75% !important;\n  }\n\n  .mh-xl-100 {\n    max-height: 100% !important;\n  }\n\n  .mh-xl-auto {\n    max-height: auto !important;\n  }\n\n  .mh-xl-1px {\n    max-height: 1px !important;\n  }\n\n  .mh-xl-2px {\n    max-height: 2px !important;\n  }\n\n  .mh-xl-3px {\n    max-height: 3px !important;\n  }\n\n  .mh-xl-4px {\n    max-height: 4px !important;\n  }\n\n  .mh-xl-5px {\n    max-height: 5px !important;\n  }\n\n  .mh-xl-6px {\n    max-height: 6px !important;\n  }\n\n  .mh-xl-7px {\n    max-height: 7px !important;\n  }\n\n  .mh-xl-8px {\n    max-height: 8px !important;\n  }\n\n  .mh-xl-9px {\n    max-height: 9px !important;\n  }\n\n  .mh-xl-10px {\n    max-height: 10px !important;\n  }\n\n  .mh-xl-15px {\n    max-height: 15px !important;\n  }\n\n  .mh-xl-20px {\n    max-height: 20px !important;\n  }\n\n  .mh-xl-25px {\n    max-height: 25px !important;\n  }\n\n  .mh-xl-30px {\n    max-height: 30px !important;\n  }\n\n  .mh-xl-35px {\n    max-height: 35px !important;\n  }\n\n  .mh-xl-40px {\n    max-height: 40px !important;\n  }\n\n  .mh-xl-45px {\n    max-height: 45px !important;\n  }\n\n  .mh-xl-50px {\n    max-height: 50px !important;\n  }\n\n  .mh-xl-55px {\n    max-height: 55px !important;\n  }\n\n  .mh-xl-60px {\n    max-height: 60px !important;\n  }\n\n  .mh-xl-65px {\n    max-height: 65px !important;\n  }\n\n  .mh-xl-70px {\n    max-height: 70px !important;\n  }\n\n  .mh-xl-75px {\n    max-height: 75px !important;\n  }\n\n  .mh-xl-80px {\n    max-height: 80px !important;\n  }\n\n  .mh-xl-85px {\n    max-height: 85px !important;\n  }\n\n  .mh-xl-90px {\n    max-height: 90px !important;\n  }\n\n  .mh-xl-95px {\n    max-height: 95px !important;\n  }\n\n  .mh-xl-100px {\n    max-height: 100px !important;\n  }\n\n  .mh-xl-125px {\n    max-height: 125px !important;\n  }\n\n  .mh-xl-150px {\n    max-height: 150px !important;\n  }\n\n  .mh-xl-175px {\n    max-height: 175px !important;\n  }\n\n  .mh-xl-200px {\n    max-height: 200px !important;\n  }\n\n  .mh-xl-225px {\n    max-height: 225px !important;\n  }\n\n  .mh-xl-250px {\n    max-height: 250px !important;\n  }\n\n  .mh-xl-275px {\n    max-height: 275px !important;\n  }\n\n  .mh-xl-300px {\n    max-height: 300px !important;\n  }\n\n  .mh-xl-325px {\n    max-height: 325px !important;\n  }\n\n  .mh-xl-350px {\n    max-height: 350px !important;\n  }\n\n  .mh-xl-375px {\n    max-height: 375px !important;\n  }\n\n  .mh-xl-400px {\n    max-height: 400px !important;\n  }\n\n  .mh-xl-425px {\n    max-height: 425px !important;\n  }\n\n  .mh-xl-450px {\n    max-height: 450px !important;\n  }\n\n  .mh-xl-475px {\n    max-height: 475px !important;\n  }\n\n  .mh-xl-500px {\n    max-height: 500px !important;\n  }\n\n  .mh-xl-550px {\n    max-height: 550px !important;\n  }\n\n  .mh-xl-600px {\n    max-height: 600px !important;\n  }\n\n  .mh-xl-650px {\n    max-height: 650px !important;\n  }\n\n  .mh-xl-700px {\n    max-height: 700px !important;\n  }\n\n  .mh-xl-750px {\n    max-height: 750px !important;\n  }\n\n  .mh-xl-800px {\n    max-height: 800px !important;\n  }\n\n  .mh-xl-850px {\n    max-height: 850px !important;\n  }\n\n  .mh-xl-900px {\n    max-height: 900px !important;\n  }\n\n  .mh-xl-950px {\n    max-height: 950px !important;\n  }\n\n  .mh-xl-1000px {\n    max-height: 1000px !important;\n  }\n\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n\n  .justify-content-xl-evenly {\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n\n  .order-xl-first {\n    order: -1 !important;\n  }\n\n  .order-xl-0 {\n    order: 0 !important;\n  }\n\n  .order-xl-1 {\n    order: 1 !important;\n  }\n\n  .order-xl-2 {\n    order: 2 !important;\n  }\n\n  .order-xl-3 {\n    order: 3 !important;\n  }\n\n  .order-xl-4 {\n    order: 4 !important;\n  }\n\n  .order-xl-5 {\n    order: 5 !important;\n  }\n\n  .order-xl-last {\n    order: 6 !important;\n  }\n\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-xl-3 {\n    margin: 0.75rem !important;\n  }\n\n  .m-xl-4 {\n    margin: 1rem !important;\n  }\n\n  .m-xl-5 {\n    margin: 1.25rem !important;\n  }\n\n  .m-xl-6 {\n    margin: 1.5rem !important;\n  }\n\n  .m-xl-7 {\n    margin: 1.75rem !important;\n  }\n\n  .m-xl-8 {\n    margin: 2rem !important;\n  }\n\n  .m-xl-9 {\n    margin: 2.25rem !important;\n  }\n\n  .m-xl-10 {\n    margin: 2.5rem !important;\n  }\n\n  .m-xl-11 {\n    margin: 2.75rem !important;\n  }\n\n  .m-xl-12 {\n    margin: 3rem !important;\n  }\n\n  .m-xl-13 {\n    margin: 3.25rem !important;\n  }\n\n  .m-xl-14 {\n    margin: 3.5rem !important;\n  }\n\n  .m-xl-15 {\n    margin: 3.75rem !important;\n  }\n\n  .m-xl-16 {\n    margin: 4rem !important;\n  }\n\n  .m-xl-17 {\n    margin: 4.25rem !important;\n  }\n\n  .m-xl-18 {\n    margin: 4.5rem !important;\n  }\n\n  .m-xl-19 {\n    margin: 4.75rem !important;\n  }\n\n  .m-xl-20 {\n    margin: 5rem !important;\n  }\n\n  .m-xl-auto {\n    margin: auto !important;\n  }\n\n  .mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .mx-xl-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n\n  .mx-xl-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n\n  .mx-xl-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n\n  .mx-xl-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .mx-xl-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n\n  .mx-xl-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n\n  .mx-xl-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n\n  .mx-xl-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n\n  .mx-xl-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n\n  .mx-xl-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n\n  .mx-xl-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n\n  .mx-xl-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n\n  .mx-xl-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n\n  .mx-xl-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n\n  .mx-xl-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n\n  .mx-xl-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n\n  .mx-xl-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n\n  .mx-xl-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n\n  .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-xl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-xl-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n\n  .my-xl-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-xl-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n\n  .my-xl-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-xl-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n\n  .my-xl-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n\n  .my-xl-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n\n  .my-xl-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n\n  .my-xl-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n\n  .my-xl-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-xl-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n\n  .my-xl-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-xl-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n\n  .my-xl-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-xl-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n\n  .my-xl-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-xl-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n\n  .my-xl-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-xl-0 {\n    margin-top: 0 !important;\n  }\n\n  .mt-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-xl-3 {\n    margin-top: 0.75rem !important;\n  }\n\n  .mt-xl-4 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-xl-5 {\n    margin-top: 1.25rem !important;\n  }\n\n  .mt-xl-6 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-xl-7 {\n    margin-top: 1.75rem !important;\n  }\n\n  .mt-xl-8 {\n    margin-top: 2rem !important;\n  }\n\n  .mt-xl-9 {\n    margin-top: 2.25rem !important;\n  }\n\n  .mt-xl-10 {\n    margin-top: 2.5rem !important;\n  }\n\n  .mt-xl-11 {\n    margin-top: 2.75rem !important;\n  }\n\n  .mt-xl-12 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-xl-13 {\n    margin-top: 3.25rem !important;\n  }\n\n  .mt-xl-14 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-xl-15 {\n    margin-top: 3.75rem !important;\n  }\n\n  .mt-xl-16 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-xl-17 {\n    margin-top: 4.25rem !important;\n  }\n\n  .mt-xl-18 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-xl-19 {\n    margin-top: 4.75rem !important;\n  }\n\n  .mt-xl-20 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-xl-auto {\n    margin-top: auto !important;\n  }\n\n  .me-xl-0 {\n    margin-right: 0 !important;\n  }\n\n  .me-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-xl-3 {\n    margin-right: 0.75rem !important;\n  }\n\n  .me-xl-4 {\n    margin-right: 1rem !important;\n  }\n\n  .me-xl-5 {\n    margin-right: 1.25rem !important;\n  }\n\n  .me-xl-6 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-xl-7 {\n    margin-right: 1.75rem !important;\n  }\n\n  .me-xl-8 {\n    margin-right: 2rem !important;\n  }\n\n  .me-xl-9 {\n    margin-right: 2.25rem !important;\n  }\n\n  .me-xl-10 {\n    margin-right: 2.5rem !important;\n  }\n\n  .me-xl-11 {\n    margin-right: 2.75rem !important;\n  }\n\n  .me-xl-12 {\n    margin-right: 3rem !important;\n  }\n\n  .me-xl-13 {\n    margin-right: 3.25rem !important;\n  }\n\n  .me-xl-14 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-xl-15 {\n    margin-right: 3.75rem !important;\n  }\n\n  .me-xl-16 {\n    margin-right: 4rem !important;\n  }\n\n  .me-xl-17 {\n    margin-right: 4.25rem !important;\n  }\n\n  .me-xl-18 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-xl-19 {\n    margin-right: 4.75rem !important;\n  }\n\n  .me-xl-20 {\n    margin-right: 5rem !important;\n  }\n\n  .me-xl-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-xl-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .mb-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-xl-3 {\n    margin-bottom: 0.75rem !important;\n  }\n\n  .mb-xl-4 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-xl-5 {\n    margin-bottom: 1.25rem !important;\n  }\n\n  .mb-xl-6 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-xl-7 {\n    margin-bottom: 1.75rem !important;\n  }\n\n  .mb-xl-8 {\n    margin-bottom: 2rem !important;\n  }\n\n  .mb-xl-9 {\n    margin-bottom: 2.25rem !important;\n  }\n\n  .mb-xl-10 {\n    margin-bottom: 2.5rem !important;\n  }\n\n  .mb-xl-11 {\n    margin-bottom: 2.75rem !important;\n  }\n\n  .mb-xl-12 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-xl-13 {\n    margin-bottom: 3.25rem !important;\n  }\n\n  .mb-xl-14 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-xl-15 {\n    margin-bottom: 3.75rem !important;\n  }\n\n  .mb-xl-16 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-xl-17 {\n    margin-bottom: 4.25rem !important;\n  }\n\n  .mb-xl-18 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-xl-19 {\n    margin-bottom: 4.75rem !important;\n  }\n\n  .mb-xl-20 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-xl-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-xl-0 {\n    margin-left: 0 !important;\n  }\n\n  .ms-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-xl-3 {\n    margin-left: 0.75rem !important;\n  }\n\n  .ms-xl-4 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-xl-5 {\n    margin-left: 1.25rem !important;\n  }\n\n  .ms-xl-6 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-xl-7 {\n    margin-left: 1.75rem !important;\n  }\n\n  .ms-xl-8 {\n    margin-left: 2rem !important;\n  }\n\n  .ms-xl-9 {\n    margin-left: 2.25rem !important;\n  }\n\n  .ms-xl-10 {\n    margin-left: 2.5rem !important;\n  }\n\n  .ms-xl-11 {\n    margin-left: 2.75rem !important;\n  }\n\n  .ms-xl-12 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-xl-13 {\n    margin-left: 3.25rem !important;\n  }\n\n  .ms-xl-14 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-xl-15 {\n    margin-left: 3.75rem !important;\n  }\n\n  .ms-xl-16 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-xl-17 {\n    margin-left: 4.25rem !important;\n  }\n\n  .ms-xl-18 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-xl-19 {\n    margin-left: 4.75rem !important;\n  }\n\n  .ms-xl-20 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-xl-auto {\n    margin-left: auto !important;\n  }\n\n  .m-xl-n1 {\n    margin: -0.25rem !important;\n  }\n\n  .m-xl-n2 {\n    margin: -0.5rem !important;\n  }\n\n  .m-xl-n3 {\n    margin: -0.75rem !important;\n  }\n\n  .m-xl-n4 {\n    margin: -1rem !important;\n  }\n\n  .m-xl-n5 {\n    margin: -1.25rem !important;\n  }\n\n  .m-xl-n6 {\n    margin: -1.5rem !important;\n  }\n\n  .m-xl-n7 {\n    margin: -1.75rem !important;\n  }\n\n  .m-xl-n8 {\n    margin: -2rem !important;\n  }\n\n  .m-xl-n9 {\n    margin: -2.25rem !important;\n  }\n\n  .m-xl-n10 {\n    margin: -2.5rem !important;\n  }\n\n  .m-xl-n11 {\n    margin: -2.75rem !important;\n  }\n\n  .m-xl-n12 {\n    margin: -3rem !important;\n  }\n\n  .m-xl-n13 {\n    margin: -3.25rem !important;\n  }\n\n  .m-xl-n14 {\n    margin: -3.5rem !important;\n  }\n\n  .m-xl-n15 {\n    margin: -3.75rem !important;\n  }\n\n  .m-xl-n16 {\n    margin: -4rem !important;\n  }\n\n  .m-xl-n17 {\n    margin: -4.25rem !important;\n  }\n\n  .m-xl-n18 {\n    margin: -4.5rem !important;\n  }\n\n  .m-xl-n19 {\n    margin: -4.75rem !important;\n  }\n\n  .m-xl-n20 {\n    margin: -5rem !important;\n  }\n\n  .mx-xl-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n\n  .mx-xl-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n\n  .mx-xl-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n\n  .mx-xl-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n\n  .mx-xl-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n\n  .mx-xl-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n\n  .mx-xl-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n\n  .mx-xl-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n\n  .mx-xl-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n\n  .mx-xl-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n\n  .mx-xl-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n\n  .mx-xl-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n\n  .mx-xl-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n\n  .mx-xl-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n\n  .mx-xl-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n\n  .mx-xl-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n\n  .mx-xl-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n\n  .mx-xl-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n\n  .mx-xl-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n\n  .mx-xl-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n\n  .my-xl-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n\n  .my-xl-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n\n  .my-xl-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n\n  .my-xl-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n\n  .my-xl-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n\n  .my-xl-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n\n  .my-xl-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n\n  .my-xl-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n\n  .my-xl-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n\n  .my-xl-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n\n  .my-xl-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n\n  .my-xl-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n\n  .my-xl-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n\n  .my-xl-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n\n  .my-xl-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n\n  .my-xl-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n\n  .my-xl-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n\n  .my-xl-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n\n  .my-xl-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n\n  .my-xl-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n\n  .mt-xl-n1 {\n    margin-top: -0.25rem !important;\n  }\n\n  .mt-xl-n2 {\n    margin-top: -0.5rem !important;\n  }\n\n  .mt-xl-n3 {\n    margin-top: -0.75rem !important;\n  }\n\n  .mt-xl-n4 {\n    margin-top: -1rem !important;\n  }\n\n  .mt-xl-n5 {\n    margin-top: -1.25rem !important;\n  }\n\n  .mt-xl-n6 {\n    margin-top: -1.5rem !important;\n  }\n\n  .mt-xl-n7 {\n    margin-top: -1.75rem !important;\n  }\n\n  .mt-xl-n8 {\n    margin-top: -2rem !important;\n  }\n\n  .mt-xl-n9 {\n    margin-top: -2.25rem !important;\n  }\n\n  .mt-xl-n10 {\n    margin-top: -2.5rem !important;\n  }\n\n  .mt-xl-n11 {\n    margin-top: -2.75rem !important;\n  }\n\n  .mt-xl-n12 {\n    margin-top: -3rem !important;\n  }\n\n  .mt-xl-n13 {\n    margin-top: -3.25rem !important;\n  }\n\n  .mt-xl-n14 {\n    margin-top: -3.5rem !important;\n  }\n\n  .mt-xl-n15 {\n    margin-top: -3.75rem !important;\n  }\n\n  .mt-xl-n16 {\n    margin-top: -4rem !important;\n  }\n\n  .mt-xl-n17 {\n    margin-top: -4.25rem !important;\n  }\n\n  .mt-xl-n18 {\n    margin-top: -4.5rem !important;\n  }\n\n  .mt-xl-n19 {\n    margin-top: -4.75rem !important;\n  }\n\n  .mt-xl-n20 {\n    margin-top: -5rem !important;\n  }\n\n  .me-xl-n1 {\n    margin-right: -0.25rem !important;\n  }\n\n  .me-xl-n2 {\n    margin-right: -0.5rem !important;\n  }\n\n  .me-xl-n3 {\n    margin-right: -0.75rem !important;\n  }\n\n  .me-xl-n4 {\n    margin-right: -1rem !important;\n  }\n\n  .me-xl-n5 {\n    margin-right: -1.25rem !important;\n  }\n\n  .me-xl-n6 {\n    margin-right: -1.5rem !important;\n  }\n\n  .me-xl-n7 {\n    margin-right: -1.75rem !important;\n  }\n\n  .me-xl-n8 {\n    margin-right: -2rem !important;\n  }\n\n  .me-xl-n9 {\n    margin-right: -2.25rem !important;\n  }\n\n  .me-xl-n10 {\n    margin-right: -2.5rem !important;\n  }\n\n  .me-xl-n11 {\n    margin-right: -2.75rem !important;\n  }\n\n  .me-xl-n12 {\n    margin-right: -3rem !important;\n  }\n\n  .me-xl-n13 {\n    margin-right: -3.25rem !important;\n  }\n\n  .me-xl-n14 {\n    margin-right: -3.5rem !important;\n  }\n\n  .me-xl-n15 {\n    margin-right: -3.75rem !important;\n  }\n\n  .me-xl-n16 {\n    margin-right: -4rem !important;\n  }\n\n  .me-xl-n17 {\n    margin-right: -4.25rem !important;\n  }\n\n  .me-xl-n18 {\n    margin-right: -4.5rem !important;\n  }\n\n  .me-xl-n19 {\n    margin-right: -4.75rem !important;\n  }\n\n  .me-xl-n20 {\n    margin-right: -5rem !important;\n  }\n\n  .mb-xl-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n\n  .mb-xl-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n\n  .mb-xl-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n\n  .mb-xl-n4 {\n    margin-bottom: -1rem !important;\n  }\n\n  .mb-xl-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n\n  .mb-xl-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n\n  .mb-xl-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n\n  .mb-xl-n8 {\n    margin-bottom: -2rem !important;\n  }\n\n  .mb-xl-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n\n  .mb-xl-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n\n  .mb-xl-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n\n  .mb-xl-n12 {\n    margin-bottom: -3rem !important;\n  }\n\n  .mb-xl-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n\n  .mb-xl-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n\n  .mb-xl-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n\n  .mb-xl-n16 {\n    margin-bottom: -4rem !important;\n  }\n\n  .mb-xl-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n\n  .mb-xl-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n\n  .mb-xl-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n\n  .mb-xl-n20 {\n    margin-bottom: -5rem !important;\n  }\n\n  .ms-xl-n1 {\n    margin-left: -0.25rem !important;\n  }\n\n  .ms-xl-n2 {\n    margin-left: -0.5rem !important;\n  }\n\n  .ms-xl-n3 {\n    margin-left: -0.75rem !important;\n  }\n\n  .ms-xl-n4 {\n    margin-left: -1rem !important;\n  }\n\n  .ms-xl-n5 {\n    margin-left: -1.25rem !important;\n  }\n\n  .ms-xl-n6 {\n    margin-left: -1.5rem !important;\n  }\n\n  .ms-xl-n7 {\n    margin-left: -1.75rem !important;\n  }\n\n  .ms-xl-n8 {\n    margin-left: -2rem !important;\n  }\n\n  .ms-xl-n9 {\n    margin-left: -2.25rem !important;\n  }\n\n  .ms-xl-n10 {\n    margin-left: -2.5rem !important;\n  }\n\n  .ms-xl-n11 {\n    margin-left: -2.75rem !important;\n  }\n\n  .ms-xl-n12 {\n    margin-left: -3rem !important;\n  }\n\n  .ms-xl-n13 {\n    margin-left: -3.25rem !important;\n  }\n\n  .ms-xl-n14 {\n    margin-left: -3.5rem !important;\n  }\n\n  .ms-xl-n15 {\n    margin-left: -3.75rem !important;\n  }\n\n  .ms-xl-n16 {\n    margin-left: -4rem !important;\n  }\n\n  .ms-xl-n17 {\n    margin-left: -4.25rem !important;\n  }\n\n  .ms-xl-n18 {\n    margin-left: -4.5rem !important;\n  }\n\n  .ms-xl-n19 {\n    margin-left: -4.75rem !important;\n  }\n\n  .ms-xl-n20 {\n    margin-left: -5rem !important;\n  }\n\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-xl-3 {\n    padding: 0.75rem !important;\n  }\n\n  .p-xl-4 {\n    padding: 1rem !important;\n  }\n\n  .p-xl-5 {\n    padding: 1.25rem !important;\n  }\n\n  .p-xl-6 {\n    padding: 1.5rem !important;\n  }\n\n  .p-xl-7 {\n    padding: 1.75rem !important;\n  }\n\n  .p-xl-8 {\n    padding: 2rem !important;\n  }\n\n  .p-xl-9 {\n    padding: 2.25rem !important;\n  }\n\n  .p-xl-10 {\n    padding: 2.5rem !important;\n  }\n\n  .p-xl-11 {\n    padding: 2.75rem !important;\n  }\n\n  .p-xl-12 {\n    padding: 3rem !important;\n  }\n\n  .p-xl-13 {\n    padding: 3.25rem !important;\n  }\n\n  .p-xl-14 {\n    padding: 3.5rem !important;\n  }\n\n  .p-xl-15 {\n    padding: 3.75rem !important;\n  }\n\n  .p-xl-16 {\n    padding: 4rem !important;\n  }\n\n  .p-xl-17 {\n    padding: 4.25rem !important;\n  }\n\n  .p-xl-18 {\n    padding: 4.5rem !important;\n  }\n\n  .p-xl-19 {\n    padding: 4.75rem !important;\n  }\n\n  .p-xl-20 {\n    padding: 5rem !important;\n  }\n\n  .px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .px-xl-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n\n  .px-xl-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n\n  .px-xl-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n\n  .px-xl-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .px-xl-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n\n  .px-xl-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n\n  .px-xl-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n\n  .px-xl-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n\n  .px-xl-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n\n  .px-xl-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n\n  .px-xl-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n\n  .px-xl-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n\n  .px-xl-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n\n  .px-xl-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n\n  .px-xl-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n\n  .px-xl-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n\n  .px-xl-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n\n  .px-xl-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n\n  .py-xl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-xl-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n\n  .py-xl-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-xl-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n\n  .py-xl-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-xl-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n\n  .py-xl-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n\n  .py-xl-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n\n  .py-xl-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n\n  .py-xl-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n\n  .py-xl-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .py-xl-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n\n  .py-xl-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-xl-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n\n  .py-xl-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-xl-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n\n  .py-xl-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-xl-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n\n  .py-xl-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .pt-xl-0 {\n    padding-top: 0 !important;\n  }\n\n  .pt-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-xl-3 {\n    padding-top: 0.75rem !important;\n  }\n\n  .pt-xl-4 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-xl-5 {\n    padding-top: 1.25rem !important;\n  }\n\n  .pt-xl-6 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-xl-7 {\n    padding-top: 1.75rem !important;\n  }\n\n  .pt-xl-8 {\n    padding-top: 2rem !important;\n  }\n\n  .pt-xl-9 {\n    padding-top: 2.25rem !important;\n  }\n\n  .pt-xl-10 {\n    padding-top: 2.5rem !important;\n  }\n\n  .pt-xl-11 {\n    padding-top: 2.75rem !important;\n  }\n\n  .pt-xl-12 {\n    padding-top: 3rem !important;\n  }\n\n  .pt-xl-13 {\n    padding-top: 3.25rem !important;\n  }\n\n  .pt-xl-14 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-xl-15 {\n    padding-top: 3.75rem !important;\n  }\n\n  .pt-xl-16 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-xl-17 {\n    padding-top: 4.25rem !important;\n  }\n\n  .pt-xl-18 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-xl-19 {\n    padding-top: 4.75rem !important;\n  }\n\n  .pt-xl-20 {\n    padding-top: 5rem !important;\n  }\n\n  .pe-xl-0 {\n    padding-right: 0 !important;\n  }\n\n  .pe-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-xl-3 {\n    padding-right: 0.75rem !important;\n  }\n\n  .pe-xl-4 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-xl-5 {\n    padding-right: 1.25rem !important;\n  }\n\n  .pe-xl-6 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-xl-7 {\n    padding-right: 1.75rem !important;\n  }\n\n  .pe-xl-8 {\n    padding-right: 2rem !important;\n  }\n\n  .pe-xl-9 {\n    padding-right: 2.25rem !important;\n  }\n\n  .pe-xl-10 {\n    padding-right: 2.5rem !important;\n  }\n\n  .pe-xl-11 {\n    padding-right: 2.75rem !important;\n  }\n\n  .pe-xl-12 {\n    padding-right: 3rem !important;\n  }\n\n  .pe-xl-13 {\n    padding-right: 3.25rem !important;\n  }\n\n  .pe-xl-14 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-xl-15 {\n    padding-right: 3.75rem !important;\n  }\n\n  .pe-xl-16 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-xl-17 {\n    padding-right: 4.25rem !important;\n  }\n\n  .pe-xl-18 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-xl-19 {\n    padding-right: 4.75rem !important;\n  }\n\n  .pe-xl-20 {\n    padding-right: 5rem !important;\n  }\n\n  .pb-xl-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pb-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-xl-3 {\n    padding-bottom: 0.75rem !important;\n  }\n\n  .pb-xl-4 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-xl-5 {\n    padding-bottom: 1.25rem !important;\n  }\n\n  .pb-xl-6 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-xl-7 {\n    padding-bottom: 1.75rem !important;\n  }\n\n  .pb-xl-8 {\n    padding-bottom: 2rem !important;\n  }\n\n  .pb-xl-9 {\n    padding-bottom: 2.25rem !important;\n  }\n\n  .pb-xl-10 {\n    padding-bottom: 2.5rem !important;\n  }\n\n  .pb-xl-11 {\n    padding-bottom: 2.75rem !important;\n  }\n\n  .pb-xl-12 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pb-xl-13 {\n    padding-bottom: 3.25rem !important;\n  }\n\n  .pb-xl-14 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-xl-15 {\n    padding-bottom: 3.75rem !important;\n  }\n\n  .pb-xl-16 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-xl-17 {\n    padding-bottom: 4.25rem !important;\n  }\n\n  .pb-xl-18 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-xl-19 {\n    padding-bottom: 4.75rem !important;\n  }\n\n  .pb-xl-20 {\n    padding-bottom: 5rem !important;\n  }\n\n  .ps-xl-0 {\n    padding-left: 0 !important;\n  }\n\n  .ps-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-xl-3 {\n    padding-left: 0.75rem !important;\n  }\n\n  .ps-xl-4 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-xl-5 {\n    padding-left: 1.25rem !important;\n  }\n\n  .ps-xl-6 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-xl-7 {\n    padding-left: 1.75rem !important;\n  }\n\n  .ps-xl-8 {\n    padding-left: 2rem !important;\n  }\n\n  .ps-xl-9 {\n    padding-left: 2.25rem !important;\n  }\n\n  .ps-xl-10 {\n    padding-left: 2.5rem !important;\n  }\n\n  .ps-xl-11 {\n    padding-left: 2.75rem !important;\n  }\n\n  .ps-xl-12 {\n    padding-left: 3rem !important;\n  }\n\n  .ps-xl-13 {\n    padding-left: 3.25rem !important;\n  }\n\n  .ps-xl-14 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-xl-15 {\n    padding-left: 3.75rem !important;\n  }\n\n  .ps-xl-16 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-xl-17 {\n    padding-left: 4.25rem !important;\n  }\n\n  .ps-xl-18 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-xl-19 {\n    padding-left: 4.75rem !important;\n  }\n\n  .ps-xl-20 {\n    padding-left: 5rem !important;\n  }\n\n  .gap-xl-0 {\n    gap: 0 !important;\n  }\n\n  .gap-xl-1 {\n    gap: 0.25rem !important;\n  }\n\n  .gap-xl-2 {\n    gap: 0.5rem !important;\n  }\n\n  .gap-xl-3 {\n    gap: 0.75rem !important;\n  }\n\n  .gap-xl-4 {\n    gap: 1rem !important;\n  }\n\n  .gap-xl-5 {\n    gap: 1.25rem !important;\n  }\n\n  .gap-xl-6 {\n    gap: 1.5rem !important;\n  }\n\n  .gap-xl-7 {\n    gap: 1.75rem !important;\n  }\n\n  .gap-xl-8 {\n    gap: 2rem !important;\n  }\n\n  .gap-xl-9 {\n    gap: 2.25rem !important;\n  }\n\n  .gap-xl-10 {\n    gap: 2.5rem !important;\n  }\n\n  .gap-xl-11 {\n    gap: 2.75rem !important;\n  }\n\n  .gap-xl-12 {\n    gap: 3rem !important;\n  }\n\n  .gap-xl-13 {\n    gap: 3.25rem !important;\n  }\n\n  .gap-xl-14 {\n    gap: 3.5rem !important;\n  }\n\n  .gap-xl-15 {\n    gap: 3.75rem !important;\n  }\n\n  .gap-xl-16 {\n    gap: 4rem !important;\n  }\n\n  .gap-xl-17 {\n    gap: 4.25rem !important;\n  }\n\n  .gap-xl-18 {\n    gap: 4.5rem !important;\n  }\n\n  .gap-xl-19 {\n    gap: 4.75rem !important;\n  }\n\n  .gap-xl-20 {\n    gap: 5rem !important;\n  }\n\n  .row-gap-xl-0 {\n    row-gap: 0 !important;\n  }\n\n  .row-gap-xl-1 {\n    row-gap: 0.25rem !important;\n  }\n\n  .row-gap-xl-2 {\n    row-gap: 0.5rem !important;\n  }\n\n  .row-gap-xl-3 {\n    row-gap: 0.75rem !important;\n  }\n\n  .row-gap-xl-4 {\n    row-gap: 1rem !important;\n  }\n\n  .row-gap-xl-5 {\n    row-gap: 1.25rem !important;\n  }\n\n  .row-gap-xl-6 {\n    row-gap: 1.5rem !important;\n  }\n\n  .row-gap-xl-7 {\n    row-gap: 1.75rem !important;\n  }\n\n  .row-gap-xl-8 {\n    row-gap: 2rem !important;\n  }\n\n  .row-gap-xl-9 {\n    row-gap: 2.25rem !important;\n  }\n\n  .row-gap-xl-10 {\n    row-gap: 2.5rem !important;\n  }\n\n  .row-gap-xl-11 {\n    row-gap: 2.75rem !important;\n  }\n\n  .row-gap-xl-12 {\n    row-gap: 3rem !important;\n  }\n\n  .row-gap-xl-13 {\n    row-gap: 3.25rem !important;\n  }\n\n  .row-gap-xl-14 {\n    row-gap: 3.5rem !important;\n  }\n\n  .row-gap-xl-15 {\n    row-gap: 3.75rem !important;\n  }\n\n  .row-gap-xl-16 {\n    row-gap: 4rem !important;\n  }\n\n  .row-gap-xl-17 {\n    row-gap: 4.25rem !important;\n  }\n\n  .row-gap-xl-18 {\n    row-gap: 4.5rem !important;\n  }\n\n  .row-gap-xl-19 {\n    row-gap: 4.75rem !important;\n  }\n\n  .row-gap-xl-20 {\n    row-gap: 5rem !important;\n  }\n\n  .column-gap-xl-0 {\n    column-gap: 0 !important;\n  }\n\n  .column-gap-xl-1 {\n    column-gap: 0.25rem !important;\n  }\n\n  .column-gap-xl-2 {\n    column-gap: 0.5rem !important;\n  }\n\n  .column-gap-xl-3 {\n    column-gap: 0.75rem !important;\n  }\n\n  .column-gap-xl-4 {\n    column-gap: 1rem !important;\n  }\n\n  .column-gap-xl-5 {\n    column-gap: 1.25rem !important;\n  }\n\n  .column-gap-xl-6 {\n    column-gap: 1.5rem !important;\n  }\n\n  .column-gap-xl-7 {\n    column-gap: 1.75rem !important;\n  }\n\n  .column-gap-xl-8 {\n    column-gap: 2rem !important;\n  }\n\n  .column-gap-xl-9 {\n    column-gap: 2.25rem !important;\n  }\n\n  .column-gap-xl-10 {\n    column-gap: 2.5rem !important;\n  }\n\n  .column-gap-xl-11 {\n    column-gap: 2.75rem !important;\n  }\n\n  .column-gap-xl-12 {\n    column-gap: 3rem !important;\n  }\n\n  .column-gap-xl-13 {\n    column-gap: 3.25rem !important;\n  }\n\n  .column-gap-xl-14 {\n    column-gap: 3.5rem !important;\n  }\n\n  .column-gap-xl-15 {\n    column-gap: 3.75rem !important;\n  }\n\n  .column-gap-xl-16 {\n    column-gap: 4rem !important;\n  }\n\n  .column-gap-xl-17 {\n    column-gap: 4.25rem !important;\n  }\n\n  .column-gap-xl-18 {\n    column-gap: 4.5rem !important;\n  }\n\n  .column-gap-xl-19 {\n    column-gap: 4.75rem !important;\n  }\n\n  .column-gap-xl-20 {\n    column-gap: 5rem !important;\n  }\n\n  .fs-xl-1 {\n    font-size: calc(1.3rem + 0.6vw) !important;\n  }\n\n  .fs-xl-2 {\n    font-size: calc(1.275rem + 0.3vw) !important;\n  }\n\n  .fs-xl-3 {\n    font-size: calc(1.26rem + 0.12vw) !important;\n  }\n\n  .fs-xl-4 {\n    font-size: 1.25rem !important;\n  }\n\n  .fs-xl-5 {\n    font-size: 1.15rem !important;\n  }\n\n  .fs-xl-6 {\n    font-size: 1.075rem !important;\n  }\n\n  .fs-xl-7 {\n    font-size: 0.95rem !important;\n  }\n\n  .fs-xl-8 {\n    font-size: 0.85rem !important;\n  }\n\n  .fs-xl-9 {\n    font-size: 0.75rem !important;\n  }\n\n  .fs-xl-10 {\n    font-size: 0.5rem !important;\n  }\n\n  .fs-xl-base {\n    font-size: 1rem !important;\n  }\n\n  .fs-xl-fluid {\n    font-size: 100% !important;\n  }\n\n  .fs-xl-2x {\n    font-size: calc(1.325rem + 0.9vw) !important;\n  }\n\n  .fs-xl-2qx {\n    font-size: calc(1.35rem + 1.2vw) !important;\n  }\n\n  .fs-xl-2hx {\n    font-size: calc(1.375rem + 1.5vw) !important;\n  }\n\n  .fs-xl-2tx {\n    font-size: calc(1.4rem + 1.8vw) !important;\n  }\n\n  .fs-xl-3x {\n    font-size: calc(1.425rem + 2.1vw) !important;\n  }\n\n  .fs-xl-3qx {\n    font-size: calc(1.45rem + 2.4vw) !important;\n  }\n\n  .fs-xl-3hx {\n    font-size: calc(1.475rem + 2.7vw) !important;\n  }\n\n  .fs-xl-3tx {\n    font-size: calc(1.5rem + 3vw) !important;\n  }\n\n  .fs-xl-4x {\n    font-size: calc(1.525rem + 3.3vw) !important;\n  }\n\n  .fs-xl-4qx {\n    font-size: calc(1.55rem + 3.6vw) !important;\n  }\n\n  .fs-xl-4hx {\n    font-size: calc(1.575rem + 3.9vw) !important;\n  }\n\n  .fs-xl-4tx {\n    font-size: calc(1.6rem + 4.2vw) !important;\n  }\n\n  .fs-xl-5x {\n    font-size: calc(1.625rem + 4.5vw) !important;\n  }\n\n  .fs-xl-5qx {\n    font-size: calc(1.65rem + 4.8vw) !important;\n  }\n\n  .fs-xl-5hx {\n    font-size: calc(1.675rem + 5.1vw) !important;\n  }\n\n  .fs-xl-5tx {\n    font-size: calc(1.7rem + 5.4vw) !important;\n  }\n\n  .text-xl-start {\n    text-align: left !important;\n  }\n\n  .text-xl-end {\n    text-align: right !important;\n  }\n\n  .text-xl-center {\n    text-align: center !important;\n  }\n\n  .min-w-xl-unset {\n    min-width: unset !important;\n  }\n\n  .min-w-xl-25 {\n    min-width: 25% !important;\n  }\n\n  .min-w-xl-50 {\n    min-width: 50% !important;\n  }\n\n  .min-w-xl-75 {\n    min-width: 75% !important;\n  }\n\n  .min-w-xl-100 {\n    min-width: 100% !important;\n  }\n\n  .min-w-xl-auto {\n    min-width: auto !important;\n  }\n\n  .min-w-xl-1px {\n    min-width: 1px !important;\n  }\n\n  .min-w-xl-2px {\n    min-width: 2px !important;\n  }\n\n  .min-w-xl-3px {\n    min-width: 3px !important;\n  }\n\n  .min-w-xl-4px {\n    min-width: 4px !important;\n  }\n\n  .min-w-xl-5px {\n    min-width: 5px !important;\n  }\n\n  .min-w-xl-6px {\n    min-width: 6px !important;\n  }\n\n  .min-w-xl-7px {\n    min-width: 7px !important;\n  }\n\n  .min-w-xl-8px {\n    min-width: 8px !important;\n  }\n\n  .min-w-xl-9px {\n    min-width: 9px !important;\n  }\n\n  .min-w-xl-10px {\n    min-width: 10px !important;\n  }\n\n  .min-w-xl-15px {\n    min-width: 15px !important;\n  }\n\n  .min-w-xl-20px {\n    min-width: 20px !important;\n  }\n\n  .min-w-xl-25px {\n    min-width: 25px !important;\n  }\n\n  .min-w-xl-30px {\n    min-width: 30px !important;\n  }\n\n  .min-w-xl-35px {\n    min-width: 35px !important;\n  }\n\n  .min-w-xl-40px {\n    min-width: 40px !important;\n  }\n\n  .min-w-xl-45px {\n    min-width: 45px !important;\n  }\n\n  .min-w-xl-50px {\n    min-width: 50px !important;\n  }\n\n  .min-w-xl-55px {\n    min-width: 55px !important;\n  }\n\n  .min-w-xl-60px {\n    min-width: 60px !important;\n  }\n\n  .min-w-xl-65px {\n    min-width: 65px !important;\n  }\n\n  .min-w-xl-70px {\n    min-width: 70px !important;\n  }\n\n  .min-w-xl-75px {\n    min-width: 75px !important;\n  }\n\n  .min-w-xl-80px {\n    min-width: 80px !important;\n  }\n\n  .min-w-xl-85px {\n    min-width: 85px !important;\n  }\n\n  .min-w-xl-90px {\n    min-width: 90px !important;\n  }\n\n  .min-w-xl-95px {\n    min-width: 95px !important;\n  }\n\n  .min-w-xl-100px {\n    min-width: 100px !important;\n  }\n\n  .min-w-xl-125px {\n    min-width: 125px !important;\n  }\n\n  .min-w-xl-150px {\n    min-width: 150px !important;\n  }\n\n  .min-w-xl-175px {\n    min-width: 175px !important;\n  }\n\n  .min-w-xl-200px {\n    min-width: 200px !important;\n  }\n\n  .min-w-xl-225px {\n    min-width: 225px !important;\n  }\n\n  .min-w-xl-250px {\n    min-width: 250px !important;\n  }\n\n  .min-w-xl-275px {\n    min-width: 275px !important;\n  }\n\n  .min-w-xl-300px {\n    min-width: 300px !important;\n  }\n\n  .min-w-xl-325px {\n    min-width: 325px !important;\n  }\n\n  .min-w-xl-350px {\n    min-width: 350px !important;\n  }\n\n  .min-w-xl-375px {\n    min-width: 375px !important;\n  }\n\n  .min-w-xl-400px {\n    min-width: 400px !important;\n  }\n\n  .min-w-xl-425px {\n    min-width: 425px !important;\n  }\n\n  .min-w-xl-450px {\n    min-width: 450px !important;\n  }\n\n  .min-w-xl-475px {\n    min-width: 475px !important;\n  }\n\n  .min-w-xl-500px {\n    min-width: 500px !important;\n  }\n\n  .min-w-xl-550px {\n    min-width: 550px !important;\n  }\n\n  .min-w-xl-600px {\n    min-width: 600px !important;\n  }\n\n  .min-w-xl-650px {\n    min-width: 650px !important;\n  }\n\n  .min-w-xl-700px {\n    min-width: 700px !important;\n  }\n\n  .min-w-xl-750px {\n    min-width: 750px !important;\n  }\n\n  .min-w-xl-800px {\n    min-width: 800px !important;\n  }\n\n  .min-w-xl-850px {\n    min-width: 850px !important;\n  }\n\n  .min-w-xl-900px {\n    min-width: 900px !important;\n  }\n\n  .min-w-xl-950px {\n    min-width: 950px !important;\n  }\n\n  .min-w-xl-1000px {\n    min-width: 1000px !important;\n  }\n\n  .min-h-xl-unset {\n    min-height: unset !important;\n  }\n\n  .min-h-xl-25 {\n    min-height: 25% !important;\n  }\n\n  .min-h-xl-50 {\n    min-height: 50% !important;\n  }\n\n  .min-h-xl-75 {\n    min-height: 75% !important;\n  }\n\n  .min-h-xl-100 {\n    min-height: 100% !important;\n  }\n\n  .min-h-xl-auto {\n    min-height: auto !important;\n  }\n\n  .min-h-xl-1px {\n    min-height: 1px !important;\n  }\n\n  .min-h-xl-2px {\n    min-height: 2px !important;\n  }\n\n  .min-h-xl-3px {\n    min-height: 3px !important;\n  }\n\n  .min-h-xl-4px {\n    min-height: 4px !important;\n  }\n\n  .min-h-xl-5px {\n    min-height: 5px !important;\n  }\n\n  .min-h-xl-6px {\n    min-height: 6px !important;\n  }\n\n  .min-h-xl-7px {\n    min-height: 7px !important;\n  }\n\n  .min-h-xl-8px {\n    min-height: 8px !important;\n  }\n\n  .min-h-xl-9px {\n    min-height: 9px !important;\n  }\n\n  .min-h-xl-10px {\n    min-height: 10px !important;\n  }\n\n  .min-h-xl-15px {\n    min-height: 15px !important;\n  }\n\n  .min-h-xl-20px {\n    min-height: 20px !important;\n  }\n\n  .min-h-xl-25px {\n    min-height: 25px !important;\n  }\n\n  .min-h-xl-30px {\n    min-height: 30px !important;\n  }\n\n  .min-h-xl-35px {\n    min-height: 35px !important;\n  }\n\n  .min-h-xl-40px {\n    min-height: 40px !important;\n  }\n\n  .min-h-xl-45px {\n    min-height: 45px !important;\n  }\n\n  .min-h-xl-50px {\n    min-height: 50px !important;\n  }\n\n  .min-h-xl-55px {\n    min-height: 55px !important;\n  }\n\n  .min-h-xl-60px {\n    min-height: 60px !important;\n  }\n\n  .min-h-xl-65px {\n    min-height: 65px !important;\n  }\n\n  .min-h-xl-70px {\n    min-height: 70px !important;\n  }\n\n  .min-h-xl-75px {\n    min-height: 75px !important;\n  }\n\n  .min-h-xl-80px {\n    min-height: 80px !important;\n  }\n\n  .min-h-xl-85px {\n    min-height: 85px !important;\n  }\n\n  .min-h-xl-90px {\n    min-height: 90px !important;\n  }\n\n  .min-h-xl-95px {\n    min-height: 95px !important;\n  }\n\n  .min-h-xl-100px {\n    min-height: 100px !important;\n  }\n\n  .min-h-xl-125px {\n    min-height: 125px !important;\n  }\n\n  .min-h-xl-150px {\n    min-height: 150px !important;\n  }\n\n  .min-h-xl-175px {\n    min-height: 175px !important;\n  }\n\n  .min-h-xl-200px {\n    min-height: 200px !important;\n  }\n\n  .min-h-xl-225px {\n    min-height: 225px !important;\n  }\n\n  .min-h-xl-250px {\n    min-height: 250px !important;\n  }\n\n  .min-h-xl-275px {\n    min-height: 275px !important;\n  }\n\n  .min-h-xl-300px {\n    min-height: 300px !important;\n  }\n\n  .min-h-xl-325px {\n    min-height: 325px !important;\n  }\n\n  .min-h-xl-350px {\n    min-height: 350px !important;\n  }\n\n  .min-h-xl-375px {\n    min-height: 375px !important;\n  }\n\n  .min-h-xl-400px {\n    min-height: 400px !important;\n  }\n\n  .min-h-xl-425px {\n    min-height: 425px !important;\n  }\n\n  .min-h-xl-450px {\n    min-height: 450px !important;\n  }\n\n  .min-h-xl-475px {\n    min-height: 475px !important;\n  }\n\n  .min-h-xl-500px {\n    min-height: 500px !important;\n  }\n\n  .min-h-xl-550px {\n    min-height: 550px !important;\n  }\n\n  .min-h-xl-600px {\n    min-height: 600px !important;\n  }\n\n  .min-h-xl-650px {\n    min-height: 650px !important;\n  }\n\n  .min-h-xl-700px {\n    min-height: 700px !important;\n  }\n\n  .min-h-xl-750px {\n    min-height: 750px !important;\n  }\n\n  .min-h-xl-800px {\n    min-height: 800px !important;\n  }\n\n  .min-h-xl-850px {\n    min-height: 850px !important;\n  }\n\n  .min-h-xl-900px {\n    min-height: 900px !important;\n  }\n\n  .min-h-xl-950px {\n    min-height: 950px !important;\n  }\n\n  .min-h-xl-1000px {\n    min-height: 1000px !important;\n  }\n}\n@media (min-width: 1400px) {\n  .float-xxl-start {\n    float: left !important;\n  }\n\n  .float-xxl-end {\n    float: right !important;\n  }\n\n  .float-xxl-none {\n    float: none !important;\n  }\n\n  .object-fit-xxl-contain {\n    object-fit: contain !important;\n  }\n\n  .object-fit-xxl-cover {\n    object-fit: cover !important;\n  }\n\n  .object-fit-xxl-fill {\n    object-fit: fill !important;\n  }\n\n  .object-fit-xxl-scale {\n    object-fit: scale-down !important;\n  }\n\n  .object-fit-xxl-none {\n    object-fit: none !important;\n  }\n\n  .d-xxl-inline {\n    display: inline !important;\n  }\n\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-xxl-block {\n    display: block !important;\n  }\n\n  .d-xxl-grid {\n    display: grid !important;\n  }\n\n  .d-xxl-inline-grid {\n    display: inline-grid !important;\n  }\n\n  .d-xxl-table {\n    display: table !important;\n  }\n\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-xxl-flex {\n    display: flex !important;\n  }\n\n  .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-xxl-none {\n    display: none !important;\n  }\n\n  .position-xxl-static {\n    position: static !important;\n  }\n\n  .position-xxl-relative {\n    position: relative !important;\n  }\n\n  .position-xxl-absolute {\n    position: absolute !important;\n  }\n\n  .position-xxl-fixed {\n    position: fixed !important;\n  }\n\n  .position-xxl-sticky {\n    position: sticky !important;\n  }\n\n  .w-xxl-unset {\n    width: unset !important;\n  }\n\n  .w-xxl-25 {\n    width: 25% !important;\n  }\n\n  .w-xxl-50 {\n    width: 50% !important;\n  }\n\n  .w-xxl-75 {\n    width: 75% !important;\n  }\n\n  .w-xxl-100 {\n    width: 100% !important;\n  }\n\n  .w-xxl-auto {\n    width: auto !important;\n  }\n\n  .w-xxl-1px {\n    width: 1px !important;\n  }\n\n  .w-xxl-2px {\n    width: 2px !important;\n  }\n\n  .w-xxl-3px {\n    width: 3px !important;\n  }\n\n  .w-xxl-4px {\n    width: 4px !important;\n  }\n\n  .w-xxl-5px {\n    width: 5px !important;\n  }\n\n  .w-xxl-6px {\n    width: 6px !important;\n  }\n\n  .w-xxl-7px {\n    width: 7px !important;\n  }\n\n  .w-xxl-8px {\n    width: 8px !important;\n  }\n\n  .w-xxl-9px {\n    width: 9px !important;\n  }\n\n  .w-xxl-10px {\n    width: 10px !important;\n  }\n\n  .w-xxl-15px {\n    width: 15px !important;\n  }\n\n  .w-xxl-20px {\n    width: 20px !important;\n  }\n\n  .w-xxl-25px {\n    width: 25px !important;\n  }\n\n  .w-xxl-30px {\n    width: 30px !important;\n  }\n\n  .w-xxl-35px {\n    width: 35px !important;\n  }\n\n  .w-xxl-40px {\n    width: 40px !important;\n  }\n\n  .w-xxl-45px {\n    width: 45px !important;\n  }\n\n  .w-xxl-50px {\n    width: 50px !important;\n  }\n\n  .w-xxl-55px {\n    width: 55px !important;\n  }\n\n  .w-xxl-60px {\n    width: 60px !important;\n  }\n\n  .w-xxl-65px {\n    width: 65px !important;\n  }\n\n  .w-xxl-70px {\n    width: 70px !important;\n  }\n\n  .w-xxl-75px {\n    width: 75px !important;\n  }\n\n  .w-xxl-80px {\n    width: 80px !important;\n  }\n\n  .w-xxl-85px {\n    width: 85px !important;\n  }\n\n  .w-xxl-90px {\n    width: 90px !important;\n  }\n\n  .w-xxl-95px {\n    width: 95px !important;\n  }\n\n  .w-xxl-100px {\n    width: 100px !important;\n  }\n\n  .w-xxl-125px {\n    width: 125px !important;\n  }\n\n  .w-xxl-150px {\n    width: 150px !important;\n  }\n\n  .w-xxl-175px {\n    width: 175px !important;\n  }\n\n  .w-xxl-200px {\n    width: 200px !important;\n  }\n\n  .w-xxl-225px {\n    width: 225px !important;\n  }\n\n  .w-xxl-250px {\n    width: 250px !important;\n  }\n\n  .w-xxl-275px {\n    width: 275px !important;\n  }\n\n  .w-xxl-300px {\n    width: 300px !important;\n  }\n\n  .w-xxl-325px {\n    width: 325px !important;\n  }\n\n  .w-xxl-350px {\n    width: 350px !important;\n  }\n\n  .w-xxl-375px {\n    width: 375px !important;\n  }\n\n  .w-xxl-400px {\n    width: 400px !important;\n  }\n\n  .w-xxl-425px {\n    width: 425px !important;\n  }\n\n  .w-xxl-450px {\n    width: 450px !important;\n  }\n\n  .w-xxl-475px {\n    width: 475px !important;\n  }\n\n  .w-xxl-500px {\n    width: 500px !important;\n  }\n\n  .w-xxl-550px {\n    width: 550px !important;\n  }\n\n  .w-xxl-600px {\n    width: 600px !important;\n  }\n\n  .w-xxl-650px {\n    width: 650px !important;\n  }\n\n  .w-xxl-700px {\n    width: 700px !important;\n  }\n\n  .w-xxl-750px {\n    width: 750px !important;\n  }\n\n  .w-xxl-800px {\n    width: 800px !important;\n  }\n\n  .w-xxl-850px {\n    width: 850px !important;\n  }\n\n  .w-xxl-900px {\n    width: 900px !important;\n  }\n\n  .w-xxl-950px {\n    width: 950px !important;\n  }\n\n  .w-xxl-1000px {\n    width: 1000px !important;\n  }\n\n  .mw-xxl-unset {\n    max-width: unset !important;\n  }\n\n  .mw-xxl-25 {\n    max-width: 25% !important;\n  }\n\n  .mw-xxl-50 {\n    max-width: 50% !important;\n  }\n\n  .mw-xxl-75 {\n    max-width: 75% !important;\n  }\n\n  .mw-xxl-100 {\n    max-width: 100% !important;\n  }\n\n  .mw-xxl-auto {\n    max-width: auto !important;\n  }\n\n  .mw-xxl-1px {\n    max-width: 1px !important;\n  }\n\n  .mw-xxl-2px {\n    max-width: 2px !important;\n  }\n\n  .mw-xxl-3px {\n    max-width: 3px !important;\n  }\n\n  .mw-xxl-4px {\n    max-width: 4px !important;\n  }\n\n  .mw-xxl-5px {\n    max-width: 5px !important;\n  }\n\n  .mw-xxl-6px {\n    max-width: 6px !important;\n  }\n\n  .mw-xxl-7px {\n    max-width: 7px !important;\n  }\n\n  .mw-xxl-8px {\n    max-width: 8px !important;\n  }\n\n  .mw-xxl-9px {\n    max-width: 9px !important;\n  }\n\n  .mw-xxl-10px {\n    max-width: 10px !important;\n  }\n\n  .mw-xxl-15px {\n    max-width: 15px !important;\n  }\n\n  .mw-xxl-20px {\n    max-width: 20px !important;\n  }\n\n  .mw-xxl-25px {\n    max-width: 25px !important;\n  }\n\n  .mw-xxl-30px {\n    max-width: 30px !important;\n  }\n\n  .mw-xxl-35px {\n    max-width: 35px !important;\n  }\n\n  .mw-xxl-40px {\n    max-width: 40px !important;\n  }\n\n  .mw-xxl-45px {\n    max-width: 45px !important;\n  }\n\n  .mw-xxl-50px {\n    max-width: 50px !important;\n  }\n\n  .mw-xxl-55px {\n    max-width: 55px !important;\n  }\n\n  .mw-xxl-60px {\n    max-width: 60px !important;\n  }\n\n  .mw-xxl-65px {\n    max-width: 65px !important;\n  }\n\n  .mw-xxl-70px {\n    max-width: 70px !important;\n  }\n\n  .mw-xxl-75px {\n    max-width: 75px !important;\n  }\n\n  .mw-xxl-80px {\n    max-width: 80px !important;\n  }\n\n  .mw-xxl-85px {\n    max-width: 85px !important;\n  }\n\n  .mw-xxl-90px {\n    max-width: 90px !important;\n  }\n\n  .mw-xxl-95px {\n    max-width: 95px !important;\n  }\n\n  .mw-xxl-100px {\n    max-width: 100px !important;\n  }\n\n  .mw-xxl-125px {\n    max-width: 125px !important;\n  }\n\n  .mw-xxl-150px {\n    max-width: 150px !important;\n  }\n\n  .mw-xxl-175px {\n    max-width: 175px !important;\n  }\n\n  .mw-xxl-200px {\n    max-width: 200px !important;\n  }\n\n  .mw-xxl-225px {\n    max-width: 225px !important;\n  }\n\n  .mw-xxl-250px {\n    max-width: 250px !important;\n  }\n\n  .mw-xxl-275px {\n    max-width: 275px !important;\n  }\n\n  .mw-xxl-300px {\n    max-width: 300px !important;\n  }\n\n  .mw-xxl-325px {\n    max-width: 325px !important;\n  }\n\n  .mw-xxl-350px {\n    max-width: 350px !important;\n  }\n\n  .mw-xxl-375px {\n    max-width: 375px !important;\n  }\n\n  .mw-xxl-400px {\n    max-width: 400px !important;\n  }\n\n  .mw-xxl-425px {\n    max-width: 425px !important;\n  }\n\n  .mw-xxl-450px {\n    max-width: 450px !important;\n  }\n\n  .mw-xxl-475px {\n    max-width: 475px !important;\n  }\n\n  .mw-xxl-500px {\n    max-width: 500px !important;\n  }\n\n  .mw-xxl-550px {\n    max-width: 550px !important;\n  }\n\n  .mw-xxl-600px {\n    max-width: 600px !important;\n  }\n\n  .mw-xxl-650px {\n    max-width: 650px !important;\n  }\n\n  .mw-xxl-700px {\n    max-width: 700px !important;\n  }\n\n  .mw-xxl-750px {\n    max-width: 750px !important;\n  }\n\n  .mw-xxl-800px {\n    max-width: 800px !important;\n  }\n\n  .mw-xxl-850px {\n    max-width: 850px !important;\n  }\n\n  .mw-xxl-900px {\n    max-width: 900px !important;\n  }\n\n  .mw-xxl-950px {\n    max-width: 950px !important;\n  }\n\n  .mw-xxl-1000px {\n    max-width: 1000px !important;\n  }\n\n  .h-xxl-unset {\n    height: unset !important;\n  }\n\n  .h-xxl-25 {\n    height: 25% !important;\n  }\n\n  .h-xxl-50 {\n    height: 50% !important;\n  }\n\n  .h-xxl-75 {\n    height: 75% !important;\n  }\n\n  .h-xxl-100 {\n    height: 100% !important;\n  }\n\n  .h-xxl-auto {\n    height: auto !important;\n  }\n\n  .h-xxl-1px {\n    height: 1px !important;\n  }\n\n  .h-xxl-2px {\n    height: 2px !important;\n  }\n\n  .h-xxl-3px {\n    height: 3px !important;\n  }\n\n  .h-xxl-4px {\n    height: 4px !important;\n  }\n\n  .h-xxl-5px {\n    height: 5px !important;\n  }\n\n  .h-xxl-6px {\n    height: 6px !important;\n  }\n\n  .h-xxl-7px {\n    height: 7px !important;\n  }\n\n  .h-xxl-8px {\n    height: 8px !important;\n  }\n\n  .h-xxl-9px {\n    height: 9px !important;\n  }\n\n  .h-xxl-10px {\n    height: 10px !important;\n  }\n\n  .h-xxl-15px {\n    height: 15px !important;\n  }\n\n  .h-xxl-20px {\n    height: 20px !important;\n  }\n\n  .h-xxl-25px {\n    height: 25px !important;\n  }\n\n  .h-xxl-30px {\n    height: 30px !important;\n  }\n\n  .h-xxl-35px {\n    height: 35px !important;\n  }\n\n  .h-xxl-40px {\n    height: 40px !important;\n  }\n\n  .h-xxl-45px {\n    height: 45px !important;\n  }\n\n  .h-xxl-50px {\n    height: 50px !important;\n  }\n\n  .h-xxl-55px {\n    height: 55px !important;\n  }\n\n  .h-xxl-60px {\n    height: 60px !important;\n  }\n\n  .h-xxl-65px {\n    height: 65px !important;\n  }\n\n  .h-xxl-70px {\n    height: 70px !important;\n  }\n\n  .h-xxl-75px {\n    height: 75px !important;\n  }\n\n  .h-xxl-80px {\n    height: 80px !important;\n  }\n\n  .h-xxl-85px {\n    height: 85px !important;\n  }\n\n  .h-xxl-90px {\n    height: 90px !important;\n  }\n\n  .h-xxl-95px {\n    height: 95px !important;\n  }\n\n  .h-xxl-100px {\n    height: 100px !important;\n  }\n\n  .h-xxl-125px {\n    height: 125px !important;\n  }\n\n  .h-xxl-150px {\n    height: 150px !important;\n  }\n\n  .h-xxl-175px {\n    height: 175px !important;\n  }\n\n  .h-xxl-200px {\n    height: 200px !important;\n  }\n\n  .h-xxl-225px {\n    height: 225px !important;\n  }\n\n  .h-xxl-250px {\n    height: 250px !important;\n  }\n\n  .h-xxl-275px {\n    height: 275px !important;\n  }\n\n  .h-xxl-300px {\n    height: 300px !important;\n  }\n\n  .h-xxl-325px {\n    height: 325px !important;\n  }\n\n  .h-xxl-350px {\n    height: 350px !important;\n  }\n\n  .h-xxl-375px {\n    height: 375px !important;\n  }\n\n  .h-xxl-400px {\n    height: 400px !important;\n  }\n\n  .h-xxl-425px {\n    height: 425px !important;\n  }\n\n  .h-xxl-450px {\n    height: 450px !important;\n  }\n\n  .h-xxl-475px {\n    height: 475px !important;\n  }\n\n  .h-xxl-500px {\n    height: 500px !important;\n  }\n\n  .h-xxl-550px {\n    height: 550px !important;\n  }\n\n  .h-xxl-600px {\n    height: 600px !important;\n  }\n\n  .h-xxl-650px {\n    height: 650px !important;\n  }\n\n  .h-xxl-700px {\n    height: 700px !important;\n  }\n\n  .h-xxl-750px {\n    height: 750px !important;\n  }\n\n  .h-xxl-800px {\n    height: 800px !important;\n  }\n\n  .h-xxl-850px {\n    height: 850px !important;\n  }\n\n  .h-xxl-900px {\n    height: 900px !important;\n  }\n\n  .h-xxl-950px {\n    height: 950px !important;\n  }\n\n  .h-xxl-1000px {\n    height: 1000px !important;\n  }\n\n  .mh-xxl-unset {\n    max-height: unset !important;\n  }\n\n  .mh-xxl-25 {\n    max-height: 25% !important;\n  }\n\n  .mh-xxl-50 {\n    max-height: 50% !important;\n  }\n\n  .mh-xxl-75 {\n    max-height: 75% !important;\n  }\n\n  .mh-xxl-100 {\n    max-height: 100% !important;\n  }\n\n  .mh-xxl-auto {\n    max-height: auto !important;\n  }\n\n  .mh-xxl-1px {\n    max-height: 1px !important;\n  }\n\n  .mh-xxl-2px {\n    max-height: 2px !important;\n  }\n\n  .mh-xxl-3px {\n    max-height: 3px !important;\n  }\n\n  .mh-xxl-4px {\n    max-height: 4px !important;\n  }\n\n  .mh-xxl-5px {\n    max-height: 5px !important;\n  }\n\n  .mh-xxl-6px {\n    max-height: 6px !important;\n  }\n\n  .mh-xxl-7px {\n    max-height: 7px !important;\n  }\n\n  .mh-xxl-8px {\n    max-height: 8px !important;\n  }\n\n  .mh-xxl-9px {\n    max-height: 9px !important;\n  }\n\n  .mh-xxl-10px {\n    max-height: 10px !important;\n  }\n\n  .mh-xxl-15px {\n    max-height: 15px !important;\n  }\n\n  .mh-xxl-20px {\n    max-height: 20px !important;\n  }\n\n  .mh-xxl-25px {\n    max-height: 25px !important;\n  }\n\n  .mh-xxl-30px {\n    max-height: 30px !important;\n  }\n\n  .mh-xxl-35px {\n    max-height: 35px !important;\n  }\n\n  .mh-xxl-40px {\n    max-height: 40px !important;\n  }\n\n  .mh-xxl-45px {\n    max-height: 45px !important;\n  }\n\n  .mh-xxl-50px {\n    max-height: 50px !important;\n  }\n\n  .mh-xxl-55px {\n    max-height: 55px !important;\n  }\n\n  .mh-xxl-60px {\n    max-height: 60px !important;\n  }\n\n  .mh-xxl-65px {\n    max-height: 65px !important;\n  }\n\n  .mh-xxl-70px {\n    max-height: 70px !important;\n  }\n\n  .mh-xxl-75px {\n    max-height: 75px !important;\n  }\n\n  .mh-xxl-80px {\n    max-height: 80px !important;\n  }\n\n  .mh-xxl-85px {\n    max-height: 85px !important;\n  }\n\n  .mh-xxl-90px {\n    max-height: 90px !important;\n  }\n\n  .mh-xxl-95px {\n    max-height: 95px !important;\n  }\n\n  .mh-xxl-100px {\n    max-height: 100px !important;\n  }\n\n  .mh-xxl-125px {\n    max-height: 125px !important;\n  }\n\n  .mh-xxl-150px {\n    max-height: 150px !important;\n  }\n\n  .mh-xxl-175px {\n    max-height: 175px !important;\n  }\n\n  .mh-xxl-200px {\n    max-height: 200px !important;\n  }\n\n  .mh-xxl-225px {\n    max-height: 225px !important;\n  }\n\n  .mh-xxl-250px {\n    max-height: 250px !important;\n  }\n\n  .mh-xxl-275px {\n    max-height: 275px !important;\n  }\n\n  .mh-xxl-300px {\n    max-height: 300px !important;\n  }\n\n  .mh-xxl-325px {\n    max-height: 325px !important;\n  }\n\n  .mh-xxl-350px {\n    max-height: 350px !important;\n  }\n\n  .mh-xxl-375px {\n    max-height: 375px !important;\n  }\n\n  .mh-xxl-400px {\n    max-height: 400px !important;\n  }\n\n  .mh-xxl-425px {\n    max-height: 425px !important;\n  }\n\n  .mh-xxl-450px {\n    max-height: 450px !important;\n  }\n\n  .mh-xxl-475px {\n    max-height: 475px !important;\n  }\n\n  .mh-xxl-500px {\n    max-height: 500px !important;\n  }\n\n  .mh-xxl-550px {\n    max-height: 550px !important;\n  }\n\n  .mh-xxl-600px {\n    max-height: 600px !important;\n  }\n\n  .mh-xxl-650px {\n    max-height: 650px !important;\n  }\n\n  .mh-xxl-700px {\n    max-height: 700px !important;\n  }\n\n  .mh-xxl-750px {\n    max-height: 750px !important;\n  }\n\n  .mh-xxl-800px {\n    max-height: 800px !important;\n  }\n\n  .mh-xxl-850px {\n    max-height: 850px !important;\n  }\n\n  .mh-xxl-900px {\n    max-height: 900px !important;\n  }\n\n  .mh-xxl-950px {\n    max-height: 950px !important;\n  }\n\n  .mh-xxl-1000px {\n    max-height: 1000px !important;\n  }\n\n  .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-xxl-row {\n    flex-direction: row !important;\n  }\n\n  .flex-xxl-column {\n    flex-direction: column !important;\n  }\n\n  .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .justify-content-xxl-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-xxl-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-xxl-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-xxl-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-xxl-around {\n    justify-content: space-around !important;\n  }\n\n  .justify-content-xxl-evenly {\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-xxl-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-xxl-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-xxl-center {\n    align-items: center !important;\n  }\n\n  .align-items-xxl-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-xxl-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-xxl-center {\n    align-content: center !important;\n  }\n\n  .align-content-xxl-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-xxl-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-xxl-center {\n    align-self: center !important;\n  }\n\n  .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n\n  .order-xxl-first {\n    order: -1 !important;\n  }\n\n  .order-xxl-0 {\n    order: 0 !important;\n  }\n\n  .order-xxl-1 {\n    order: 1 !important;\n  }\n\n  .order-xxl-2 {\n    order: 2 !important;\n  }\n\n  .order-xxl-3 {\n    order: 3 !important;\n  }\n\n  .order-xxl-4 {\n    order: 4 !important;\n  }\n\n  .order-xxl-5 {\n    order: 5 !important;\n  }\n\n  .order-xxl-last {\n    order: 6 !important;\n  }\n\n  .m-xxl-0 {\n    margin: 0 !important;\n  }\n\n  .m-xxl-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-xxl-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-xxl-3 {\n    margin: 0.75rem !important;\n  }\n\n  .m-xxl-4 {\n    margin: 1rem !important;\n  }\n\n  .m-xxl-5 {\n    margin: 1.25rem !important;\n  }\n\n  .m-xxl-6 {\n    margin: 1.5rem !important;\n  }\n\n  .m-xxl-7 {\n    margin: 1.75rem !important;\n  }\n\n  .m-xxl-8 {\n    margin: 2rem !important;\n  }\n\n  .m-xxl-9 {\n    margin: 2.25rem !important;\n  }\n\n  .m-xxl-10 {\n    margin: 2.5rem !important;\n  }\n\n  .m-xxl-11 {\n    margin: 2.75rem !important;\n  }\n\n  .m-xxl-12 {\n    margin: 3rem !important;\n  }\n\n  .m-xxl-13 {\n    margin: 3.25rem !important;\n  }\n\n  .m-xxl-14 {\n    margin: 3.5rem !important;\n  }\n\n  .m-xxl-15 {\n    margin: 3.75rem !important;\n  }\n\n  .m-xxl-16 {\n    margin: 4rem !important;\n  }\n\n  .m-xxl-17 {\n    margin: 4.25rem !important;\n  }\n\n  .m-xxl-18 {\n    margin: 4.5rem !important;\n  }\n\n  .m-xxl-19 {\n    margin: 4.75rem !important;\n  }\n\n  .m-xxl-20 {\n    margin: 5rem !important;\n  }\n\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n\n  .mx-xxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .mx-xxl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .mx-xxl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .mx-xxl-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n\n  .mx-xxl-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n\n  .mx-xxl-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n\n  .mx-xxl-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .mx-xxl-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n\n  .mx-xxl-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n\n  .mx-xxl-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n\n  .mx-xxl-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n\n  .mx-xxl-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n\n  .mx-xxl-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n\n  .mx-xxl-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n\n  .mx-xxl-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n\n  .mx-xxl-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n\n  .mx-xxl-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n\n  .mx-xxl-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n\n  .mx-xxl-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n\n  .mx-xxl-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n\n  .mx-xxl-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n\n  .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-xxl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .my-xxl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-xxl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-xxl-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n\n  .my-xxl-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-xxl-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n\n  .my-xxl-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-xxl-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n\n  .my-xxl-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n\n  .my-xxl-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n\n  .my-xxl-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n\n  .my-xxl-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n\n  .my-xxl-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-xxl-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n\n  .my-xxl-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-xxl-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n\n  .my-xxl-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-xxl-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n\n  .my-xxl-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-xxl-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n\n  .my-xxl-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-xxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-xxl-0 {\n    margin-top: 0 !important;\n  }\n\n  .mt-xxl-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-xxl-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-xxl-3 {\n    margin-top: 0.75rem !important;\n  }\n\n  .mt-xxl-4 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-xxl-5 {\n    margin-top: 1.25rem !important;\n  }\n\n  .mt-xxl-6 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-xxl-7 {\n    margin-top: 1.75rem !important;\n  }\n\n  .mt-xxl-8 {\n    margin-top: 2rem !important;\n  }\n\n  .mt-xxl-9 {\n    margin-top: 2.25rem !important;\n  }\n\n  .mt-xxl-10 {\n    margin-top: 2.5rem !important;\n  }\n\n  .mt-xxl-11 {\n    margin-top: 2.75rem !important;\n  }\n\n  .mt-xxl-12 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-xxl-13 {\n    margin-top: 3.25rem !important;\n  }\n\n  .mt-xxl-14 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-xxl-15 {\n    margin-top: 3.75rem !important;\n  }\n\n  .mt-xxl-16 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-xxl-17 {\n    margin-top: 4.25rem !important;\n  }\n\n  .mt-xxl-18 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-xxl-19 {\n    margin-top: 4.75rem !important;\n  }\n\n  .mt-xxl-20 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-xxl-auto {\n    margin-top: auto !important;\n  }\n\n  .me-xxl-0 {\n    margin-right: 0 !important;\n  }\n\n  .me-xxl-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-xxl-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-xxl-3 {\n    margin-right: 0.75rem !important;\n  }\n\n  .me-xxl-4 {\n    margin-right: 1rem !important;\n  }\n\n  .me-xxl-5 {\n    margin-right: 1.25rem !important;\n  }\n\n  .me-xxl-6 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-xxl-7 {\n    margin-right: 1.75rem !important;\n  }\n\n  .me-xxl-8 {\n    margin-right: 2rem !important;\n  }\n\n  .me-xxl-9 {\n    margin-right: 2.25rem !important;\n  }\n\n  .me-xxl-10 {\n    margin-right: 2.5rem !important;\n  }\n\n  .me-xxl-11 {\n    margin-right: 2.75rem !important;\n  }\n\n  .me-xxl-12 {\n    margin-right: 3rem !important;\n  }\n\n  .me-xxl-13 {\n    margin-right: 3.25rem !important;\n  }\n\n  .me-xxl-14 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-xxl-15 {\n    margin-right: 3.75rem !important;\n  }\n\n  .me-xxl-16 {\n    margin-right: 4rem !important;\n  }\n\n  .me-xxl-17 {\n    margin-right: 4.25rem !important;\n  }\n\n  .me-xxl-18 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-xxl-19 {\n    margin-right: 4.75rem !important;\n  }\n\n  .me-xxl-20 {\n    margin-right: 5rem !important;\n  }\n\n  .me-xxl-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .mb-xxl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-xxl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-xxl-3 {\n    margin-bottom: 0.75rem !important;\n  }\n\n  .mb-xxl-4 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-xxl-5 {\n    margin-bottom: 1.25rem !important;\n  }\n\n  .mb-xxl-6 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-xxl-7 {\n    margin-bottom: 1.75rem !important;\n  }\n\n  .mb-xxl-8 {\n    margin-bottom: 2rem !important;\n  }\n\n  .mb-xxl-9 {\n    margin-bottom: 2.25rem !important;\n  }\n\n  .mb-xxl-10 {\n    margin-bottom: 2.5rem !important;\n  }\n\n  .mb-xxl-11 {\n    margin-bottom: 2.75rem !important;\n  }\n\n  .mb-xxl-12 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-xxl-13 {\n    margin-bottom: 3.25rem !important;\n  }\n\n  .mb-xxl-14 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-xxl-15 {\n    margin-bottom: 3.75rem !important;\n  }\n\n  .mb-xxl-16 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-xxl-17 {\n    margin-bottom: 4.25rem !important;\n  }\n\n  .mb-xxl-18 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-xxl-19 {\n    margin-bottom: 4.75rem !important;\n  }\n\n  .mb-xxl-20 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-xxl-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-xxl-0 {\n    margin-left: 0 !important;\n  }\n\n  .ms-xxl-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-xxl-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-xxl-3 {\n    margin-left: 0.75rem !important;\n  }\n\n  .ms-xxl-4 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-xxl-5 {\n    margin-left: 1.25rem !important;\n  }\n\n  .ms-xxl-6 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-xxl-7 {\n    margin-left: 1.75rem !important;\n  }\n\n  .ms-xxl-8 {\n    margin-left: 2rem !important;\n  }\n\n  .ms-xxl-9 {\n    margin-left: 2.25rem !important;\n  }\n\n  .ms-xxl-10 {\n    margin-left: 2.5rem !important;\n  }\n\n  .ms-xxl-11 {\n    margin-left: 2.75rem !important;\n  }\n\n  .ms-xxl-12 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-xxl-13 {\n    margin-left: 3.25rem !important;\n  }\n\n  .ms-xxl-14 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-xxl-15 {\n    margin-left: 3.75rem !important;\n  }\n\n  .ms-xxl-16 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-xxl-17 {\n    margin-left: 4.25rem !important;\n  }\n\n  .ms-xxl-18 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-xxl-19 {\n    margin-left: 4.75rem !important;\n  }\n\n  .ms-xxl-20 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-xxl-auto {\n    margin-left: auto !important;\n  }\n\n  .m-xxl-n1 {\n    margin: -0.25rem !important;\n  }\n\n  .m-xxl-n2 {\n    margin: -0.5rem !important;\n  }\n\n  .m-xxl-n3 {\n    margin: -0.75rem !important;\n  }\n\n  .m-xxl-n4 {\n    margin: -1rem !important;\n  }\n\n  .m-xxl-n5 {\n    margin: -1.25rem !important;\n  }\n\n  .m-xxl-n6 {\n    margin: -1.5rem !important;\n  }\n\n  .m-xxl-n7 {\n    margin: -1.75rem !important;\n  }\n\n  .m-xxl-n8 {\n    margin: -2rem !important;\n  }\n\n  .m-xxl-n9 {\n    margin: -2.25rem !important;\n  }\n\n  .m-xxl-n10 {\n    margin: -2.5rem !important;\n  }\n\n  .m-xxl-n11 {\n    margin: -2.75rem !important;\n  }\n\n  .m-xxl-n12 {\n    margin: -3rem !important;\n  }\n\n  .m-xxl-n13 {\n    margin: -3.25rem !important;\n  }\n\n  .m-xxl-n14 {\n    margin: -3.5rem !important;\n  }\n\n  .m-xxl-n15 {\n    margin: -3.75rem !important;\n  }\n\n  .m-xxl-n16 {\n    margin: -4rem !important;\n  }\n\n  .m-xxl-n17 {\n    margin: -4.25rem !important;\n  }\n\n  .m-xxl-n18 {\n    margin: -4.5rem !important;\n  }\n\n  .m-xxl-n19 {\n    margin: -4.75rem !important;\n  }\n\n  .m-xxl-n20 {\n    margin: -5rem !important;\n  }\n\n  .mx-xxl-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n\n  .mx-xxl-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n\n  .mx-xxl-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n\n  .mx-xxl-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n\n  .mx-xxl-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n\n  .mx-xxl-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n\n  .mx-xxl-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n\n  .mx-xxl-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n\n  .mx-xxl-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n\n  .mx-xxl-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n\n  .mx-xxl-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n\n  .mx-xxl-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n\n  .mx-xxl-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n\n  .mx-xxl-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n\n  .mx-xxl-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n\n  .mx-xxl-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n\n  .mx-xxl-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n\n  .mx-xxl-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n\n  .mx-xxl-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n\n  .mx-xxl-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n\n  .my-xxl-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n\n  .my-xxl-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n\n  .my-xxl-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n\n  .my-xxl-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n\n  .my-xxl-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n\n  .my-xxl-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n\n  .my-xxl-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n\n  .my-xxl-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n\n  .my-xxl-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n\n  .my-xxl-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n\n  .my-xxl-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n\n  .my-xxl-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n\n  .my-xxl-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n\n  .my-xxl-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n\n  .my-xxl-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n\n  .my-xxl-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n\n  .my-xxl-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n\n  .my-xxl-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n\n  .my-xxl-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n\n  .my-xxl-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n\n  .mt-xxl-n1 {\n    margin-top: -0.25rem !important;\n  }\n\n  .mt-xxl-n2 {\n    margin-top: -0.5rem !important;\n  }\n\n  .mt-xxl-n3 {\n    margin-top: -0.75rem !important;\n  }\n\n  .mt-xxl-n4 {\n    margin-top: -1rem !important;\n  }\n\n  .mt-xxl-n5 {\n    margin-top: -1.25rem !important;\n  }\n\n  .mt-xxl-n6 {\n    margin-top: -1.5rem !important;\n  }\n\n  .mt-xxl-n7 {\n    margin-top: -1.75rem !important;\n  }\n\n  .mt-xxl-n8 {\n    margin-top: -2rem !important;\n  }\n\n  .mt-xxl-n9 {\n    margin-top: -2.25rem !important;\n  }\n\n  .mt-xxl-n10 {\n    margin-top: -2.5rem !important;\n  }\n\n  .mt-xxl-n11 {\n    margin-top: -2.75rem !important;\n  }\n\n  .mt-xxl-n12 {\n    margin-top: -3rem !important;\n  }\n\n  .mt-xxl-n13 {\n    margin-top: -3.25rem !important;\n  }\n\n  .mt-xxl-n14 {\n    margin-top: -3.5rem !important;\n  }\n\n  .mt-xxl-n15 {\n    margin-top: -3.75rem !important;\n  }\n\n  .mt-xxl-n16 {\n    margin-top: -4rem !important;\n  }\n\n  .mt-xxl-n17 {\n    margin-top: -4.25rem !important;\n  }\n\n  .mt-xxl-n18 {\n    margin-top: -4.5rem !important;\n  }\n\n  .mt-xxl-n19 {\n    margin-top: -4.75rem !important;\n  }\n\n  .mt-xxl-n20 {\n    margin-top: -5rem !important;\n  }\n\n  .me-xxl-n1 {\n    margin-right: -0.25rem !important;\n  }\n\n  .me-xxl-n2 {\n    margin-right: -0.5rem !important;\n  }\n\n  .me-xxl-n3 {\n    margin-right: -0.75rem !important;\n  }\n\n  .me-xxl-n4 {\n    margin-right: -1rem !important;\n  }\n\n  .me-xxl-n5 {\n    margin-right: -1.25rem !important;\n  }\n\n  .me-xxl-n6 {\n    margin-right: -1.5rem !important;\n  }\n\n  .me-xxl-n7 {\n    margin-right: -1.75rem !important;\n  }\n\n  .me-xxl-n8 {\n    margin-right: -2rem !important;\n  }\n\n  .me-xxl-n9 {\n    margin-right: -2.25rem !important;\n  }\n\n  .me-xxl-n10 {\n    margin-right: -2.5rem !important;\n  }\n\n  .me-xxl-n11 {\n    margin-right: -2.75rem !important;\n  }\n\n  .me-xxl-n12 {\n    margin-right: -3rem !important;\n  }\n\n  .me-xxl-n13 {\n    margin-right: -3.25rem !important;\n  }\n\n  .me-xxl-n14 {\n    margin-right: -3.5rem !important;\n  }\n\n  .me-xxl-n15 {\n    margin-right: -3.75rem !important;\n  }\n\n  .me-xxl-n16 {\n    margin-right: -4rem !important;\n  }\n\n  .me-xxl-n17 {\n    margin-right: -4.25rem !important;\n  }\n\n  .me-xxl-n18 {\n    margin-right: -4.5rem !important;\n  }\n\n  .me-xxl-n19 {\n    margin-right: -4.75rem !important;\n  }\n\n  .me-xxl-n20 {\n    margin-right: -5rem !important;\n  }\n\n  .mb-xxl-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n\n  .mb-xxl-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n\n  .mb-xxl-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n\n  .mb-xxl-n4 {\n    margin-bottom: -1rem !important;\n  }\n\n  .mb-xxl-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n\n  .mb-xxl-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n\n  .mb-xxl-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n\n  .mb-xxl-n8 {\n    margin-bottom: -2rem !important;\n  }\n\n  .mb-xxl-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n\n  .mb-xxl-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n\n  .mb-xxl-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n\n  .mb-xxl-n12 {\n    margin-bottom: -3rem !important;\n  }\n\n  .mb-xxl-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n\n  .mb-xxl-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n\n  .mb-xxl-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n\n  .mb-xxl-n16 {\n    margin-bottom: -4rem !important;\n  }\n\n  .mb-xxl-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n\n  .mb-xxl-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n\n  .mb-xxl-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n\n  .mb-xxl-n20 {\n    margin-bottom: -5rem !important;\n  }\n\n  .ms-xxl-n1 {\n    margin-left: -0.25rem !important;\n  }\n\n  .ms-xxl-n2 {\n    margin-left: -0.5rem !important;\n  }\n\n  .ms-xxl-n3 {\n    margin-left: -0.75rem !important;\n  }\n\n  .ms-xxl-n4 {\n    margin-left: -1rem !important;\n  }\n\n  .ms-xxl-n5 {\n    margin-left: -1.25rem !important;\n  }\n\n  .ms-xxl-n6 {\n    margin-left: -1.5rem !important;\n  }\n\n  .ms-xxl-n7 {\n    margin-left: -1.75rem !important;\n  }\n\n  .ms-xxl-n8 {\n    margin-left: -2rem !important;\n  }\n\n  .ms-xxl-n9 {\n    margin-left: -2.25rem !important;\n  }\n\n  .ms-xxl-n10 {\n    margin-left: -2.5rem !important;\n  }\n\n  .ms-xxl-n11 {\n    margin-left: -2.75rem !important;\n  }\n\n  .ms-xxl-n12 {\n    margin-left: -3rem !important;\n  }\n\n  .ms-xxl-n13 {\n    margin-left: -3.25rem !important;\n  }\n\n  .ms-xxl-n14 {\n    margin-left: -3.5rem !important;\n  }\n\n  .ms-xxl-n15 {\n    margin-left: -3.75rem !important;\n  }\n\n  .ms-xxl-n16 {\n    margin-left: -4rem !important;\n  }\n\n  .ms-xxl-n17 {\n    margin-left: -4.25rem !important;\n  }\n\n  .ms-xxl-n18 {\n    margin-left: -4.5rem !important;\n  }\n\n  .ms-xxl-n19 {\n    margin-left: -4.75rem !important;\n  }\n\n  .ms-xxl-n20 {\n    margin-left: -5rem !important;\n  }\n\n  .p-xxl-0 {\n    padding: 0 !important;\n  }\n\n  .p-xxl-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-xxl-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-xxl-3 {\n    padding: 0.75rem !important;\n  }\n\n  .p-xxl-4 {\n    padding: 1rem !important;\n  }\n\n  .p-xxl-5 {\n    padding: 1.25rem !important;\n  }\n\n  .p-xxl-6 {\n    padding: 1.5rem !important;\n  }\n\n  .p-xxl-7 {\n    padding: 1.75rem !important;\n  }\n\n  .p-xxl-8 {\n    padding: 2rem !important;\n  }\n\n  .p-xxl-9 {\n    padding: 2.25rem !important;\n  }\n\n  .p-xxl-10 {\n    padding: 2.5rem !important;\n  }\n\n  .p-xxl-11 {\n    padding: 2.75rem !important;\n  }\n\n  .p-xxl-12 {\n    padding: 3rem !important;\n  }\n\n  .p-xxl-13 {\n    padding: 3.25rem !important;\n  }\n\n  .p-xxl-14 {\n    padding: 3.5rem !important;\n  }\n\n  .p-xxl-15 {\n    padding: 3.75rem !important;\n  }\n\n  .p-xxl-16 {\n    padding: 4rem !important;\n  }\n\n  .p-xxl-17 {\n    padding: 4.25rem !important;\n  }\n\n  .p-xxl-18 {\n    padding: 4.5rem !important;\n  }\n\n  .p-xxl-19 {\n    padding: 4.75rem !important;\n  }\n\n  .p-xxl-20 {\n    padding: 5rem !important;\n  }\n\n  .px-xxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .px-xxl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .px-xxl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .px-xxl-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n\n  .px-xxl-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n\n  .px-xxl-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n\n  .px-xxl-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .px-xxl-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n\n  .px-xxl-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n\n  .px-xxl-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n\n  .px-xxl-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n\n  .px-xxl-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n\n  .px-xxl-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n\n  .px-xxl-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n\n  .px-xxl-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n\n  .px-xxl-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n\n  .px-xxl-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n\n  .px-xxl-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n\n  .px-xxl-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n\n  .px-xxl-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n\n  .px-xxl-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n\n  .py-xxl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n\n  .py-xxl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-xxl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-xxl-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n\n  .py-xxl-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-xxl-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n\n  .py-xxl-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-xxl-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n\n  .py-xxl-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n\n  .py-xxl-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n\n  .py-xxl-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n\n  .py-xxl-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n\n  .py-xxl-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .py-xxl-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n\n  .py-xxl-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-xxl-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n\n  .py-xxl-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-xxl-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n\n  .py-xxl-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-xxl-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n\n  .py-xxl-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .pt-xxl-0 {\n    padding-top: 0 !important;\n  }\n\n  .pt-xxl-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-xxl-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-xxl-3 {\n    padding-top: 0.75rem !important;\n  }\n\n  .pt-xxl-4 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-xxl-5 {\n    padding-top: 1.25rem !important;\n  }\n\n  .pt-xxl-6 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-xxl-7 {\n    padding-top: 1.75rem !important;\n  }\n\n  .pt-xxl-8 {\n    padding-top: 2rem !important;\n  }\n\n  .pt-xxl-9 {\n    padding-top: 2.25rem !important;\n  }\n\n  .pt-xxl-10 {\n    padding-top: 2.5rem !important;\n  }\n\n  .pt-xxl-11 {\n    padding-top: 2.75rem !important;\n  }\n\n  .pt-xxl-12 {\n    padding-top: 3rem !important;\n  }\n\n  .pt-xxl-13 {\n    padding-top: 3.25rem !important;\n  }\n\n  .pt-xxl-14 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-xxl-15 {\n    padding-top: 3.75rem !important;\n  }\n\n  .pt-xxl-16 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-xxl-17 {\n    padding-top: 4.25rem !important;\n  }\n\n  .pt-xxl-18 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-xxl-19 {\n    padding-top: 4.75rem !important;\n  }\n\n  .pt-xxl-20 {\n    padding-top: 5rem !important;\n  }\n\n  .pe-xxl-0 {\n    padding-right: 0 !important;\n  }\n\n  .pe-xxl-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-xxl-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-xxl-3 {\n    padding-right: 0.75rem !important;\n  }\n\n  .pe-xxl-4 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-xxl-5 {\n    padding-right: 1.25rem !important;\n  }\n\n  .pe-xxl-6 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-xxl-7 {\n    padding-right: 1.75rem !important;\n  }\n\n  .pe-xxl-8 {\n    padding-right: 2rem !important;\n  }\n\n  .pe-xxl-9 {\n    padding-right: 2.25rem !important;\n  }\n\n  .pe-xxl-10 {\n    padding-right: 2.5rem !important;\n  }\n\n  .pe-xxl-11 {\n    padding-right: 2.75rem !important;\n  }\n\n  .pe-xxl-12 {\n    padding-right: 3rem !important;\n  }\n\n  .pe-xxl-13 {\n    padding-right: 3.25rem !important;\n  }\n\n  .pe-xxl-14 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-xxl-15 {\n    padding-right: 3.75rem !important;\n  }\n\n  .pe-xxl-16 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-xxl-17 {\n    padding-right: 4.25rem !important;\n  }\n\n  .pe-xxl-18 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-xxl-19 {\n    padding-right: 4.75rem !important;\n  }\n\n  .pe-xxl-20 {\n    padding-right: 5rem !important;\n  }\n\n  .pb-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pb-xxl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-xxl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-xxl-3 {\n    padding-bottom: 0.75rem !important;\n  }\n\n  .pb-xxl-4 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-xxl-5 {\n    padding-bottom: 1.25rem !important;\n  }\n\n  .pb-xxl-6 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-xxl-7 {\n    padding-bottom: 1.75rem !important;\n  }\n\n  .pb-xxl-8 {\n    padding-bottom: 2rem !important;\n  }\n\n  .pb-xxl-9 {\n    padding-bottom: 2.25rem !important;\n  }\n\n  .pb-xxl-10 {\n    padding-bottom: 2.5rem !important;\n  }\n\n  .pb-xxl-11 {\n    padding-bottom: 2.75rem !important;\n  }\n\n  .pb-xxl-12 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pb-xxl-13 {\n    padding-bottom: 3.25rem !important;\n  }\n\n  .pb-xxl-14 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-xxl-15 {\n    padding-bottom: 3.75rem !important;\n  }\n\n  .pb-xxl-16 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-xxl-17 {\n    padding-bottom: 4.25rem !important;\n  }\n\n  .pb-xxl-18 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-xxl-19 {\n    padding-bottom: 4.75rem !important;\n  }\n\n  .pb-xxl-20 {\n    padding-bottom: 5rem !important;\n  }\n\n  .ps-xxl-0 {\n    padding-left: 0 !important;\n  }\n\n  .ps-xxl-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-xxl-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-xxl-3 {\n    padding-left: 0.75rem !important;\n  }\n\n  .ps-xxl-4 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-xxl-5 {\n    padding-left: 1.25rem !important;\n  }\n\n  .ps-xxl-6 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-xxl-7 {\n    padding-left: 1.75rem !important;\n  }\n\n  .ps-xxl-8 {\n    padding-left: 2rem !important;\n  }\n\n  .ps-xxl-9 {\n    padding-left: 2.25rem !important;\n  }\n\n  .ps-xxl-10 {\n    padding-left: 2.5rem !important;\n  }\n\n  .ps-xxl-11 {\n    padding-left: 2.75rem !important;\n  }\n\n  .ps-xxl-12 {\n    padding-left: 3rem !important;\n  }\n\n  .ps-xxl-13 {\n    padding-left: 3.25rem !important;\n  }\n\n  .ps-xxl-14 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-xxl-15 {\n    padding-left: 3.75rem !important;\n  }\n\n  .ps-xxl-16 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-xxl-17 {\n    padding-left: 4.25rem !important;\n  }\n\n  .ps-xxl-18 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-xxl-19 {\n    padding-left: 4.75rem !important;\n  }\n\n  .ps-xxl-20 {\n    padding-left: 5rem !important;\n  }\n\n  .gap-xxl-0 {\n    gap: 0 !important;\n  }\n\n  .gap-xxl-1 {\n    gap: 0.25rem !important;\n  }\n\n  .gap-xxl-2 {\n    gap: 0.5rem !important;\n  }\n\n  .gap-xxl-3 {\n    gap: 0.75rem !important;\n  }\n\n  .gap-xxl-4 {\n    gap: 1rem !important;\n  }\n\n  .gap-xxl-5 {\n    gap: 1.25rem !important;\n  }\n\n  .gap-xxl-6 {\n    gap: 1.5rem !important;\n  }\n\n  .gap-xxl-7 {\n    gap: 1.75rem !important;\n  }\n\n  .gap-xxl-8 {\n    gap: 2rem !important;\n  }\n\n  .gap-xxl-9 {\n    gap: 2.25rem !important;\n  }\n\n  .gap-xxl-10 {\n    gap: 2.5rem !important;\n  }\n\n  .gap-xxl-11 {\n    gap: 2.75rem !important;\n  }\n\n  .gap-xxl-12 {\n    gap: 3rem !important;\n  }\n\n  .gap-xxl-13 {\n    gap: 3.25rem !important;\n  }\n\n  .gap-xxl-14 {\n    gap: 3.5rem !important;\n  }\n\n  .gap-xxl-15 {\n    gap: 3.75rem !important;\n  }\n\n  .gap-xxl-16 {\n    gap: 4rem !important;\n  }\n\n  .gap-xxl-17 {\n    gap: 4.25rem !important;\n  }\n\n  .gap-xxl-18 {\n    gap: 4.5rem !important;\n  }\n\n  .gap-xxl-19 {\n    gap: 4.75rem !important;\n  }\n\n  .gap-xxl-20 {\n    gap: 5rem !important;\n  }\n\n  .row-gap-xxl-0 {\n    row-gap: 0 !important;\n  }\n\n  .row-gap-xxl-1 {\n    row-gap: 0.25rem !important;\n  }\n\n  .row-gap-xxl-2 {\n    row-gap: 0.5rem !important;\n  }\n\n  .row-gap-xxl-3 {\n    row-gap: 0.75rem !important;\n  }\n\n  .row-gap-xxl-4 {\n    row-gap: 1rem !important;\n  }\n\n  .row-gap-xxl-5 {\n    row-gap: 1.25rem !important;\n  }\n\n  .row-gap-xxl-6 {\n    row-gap: 1.5rem !important;\n  }\n\n  .row-gap-xxl-7 {\n    row-gap: 1.75rem !important;\n  }\n\n  .row-gap-xxl-8 {\n    row-gap: 2rem !important;\n  }\n\n  .row-gap-xxl-9 {\n    row-gap: 2.25rem !important;\n  }\n\n  .row-gap-xxl-10 {\n    row-gap: 2.5rem !important;\n  }\n\n  .row-gap-xxl-11 {\n    row-gap: 2.75rem !important;\n  }\n\n  .row-gap-xxl-12 {\n    row-gap: 3rem !important;\n  }\n\n  .row-gap-xxl-13 {\n    row-gap: 3.25rem !important;\n  }\n\n  .row-gap-xxl-14 {\n    row-gap: 3.5rem !important;\n  }\n\n  .row-gap-xxl-15 {\n    row-gap: 3.75rem !important;\n  }\n\n  .row-gap-xxl-16 {\n    row-gap: 4rem !important;\n  }\n\n  .row-gap-xxl-17 {\n    row-gap: 4.25rem !important;\n  }\n\n  .row-gap-xxl-18 {\n    row-gap: 4.5rem !important;\n  }\n\n  .row-gap-xxl-19 {\n    row-gap: 4.75rem !important;\n  }\n\n  .row-gap-xxl-20 {\n    row-gap: 5rem !important;\n  }\n\n  .column-gap-xxl-0 {\n    column-gap: 0 !important;\n  }\n\n  .column-gap-xxl-1 {\n    column-gap: 0.25rem !important;\n  }\n\n  .column-gap-xxl-2 {\n    column-gap: 0.5rem !important;\n  }\n\n  .column-gap-xxl-3 {\n    column-gap: 0.75rem !important;\n  }\n\n  .column-gap-xxl-4 {\n    column-gap: 1rem !important;\n  }\n\n  .column-gap-xxl-5 {\n    column-gap: 1.25rem !important;\n  }\n\n  .column-gap-xxl-6 {\n    column-gap: 1.5rem !important;\n  }\n\n  .column-gap-xxl-7 {\n    column-gap: 1.75rem !important;\n  }\n\n  .column-gap-xxl-8 {\n    column-gap: 2rem !important;\n  }\n\n  .column-gap-xxl-9 {\n    column-gap: 2.25rem !important;\n  }\n\n  .column-gap-xxl-10 {\n    column-gap: 2.5rem !important;\n  }\n\n  .column-gap-xxl-11 {\n    column-gap: 2.75rem !important;\n  }\n\n  .column-gap-xxl-12 {\n    column-gap: 3rem !important;\n  }\n\n  .column-gap-xxl-13 {\n    column-gap: 3.25rem !important;\n  }\n\n  .column-gap-xxl-14 {\n    column-gap: 3.5rem !important;\n  }\n\n  .column-gap-xxl-15 {\n    column-gap: 3.75rem !important;\n  }\n\n  .column-gap-xxl-16 {\n    column-gap: 4rem !important;\n  }\n\n  .column-gap-xxl-17 {\n    column-gap: 4.25rem !important;\n  }\n\n  .column-gap-xxl-18 {\n    column-gap: 4.5rem !important;\n  }\n\n  .column-gap-xxl-19 {\n    column-gap: 4.75rem !important;\n  }\n\n  .column-gap-xxl-20 {\n    column-gap: 5rem !important;\n  }\n\n  .fs-xxl-1 {\n    font-size: calc(1.3rem + 0.6vw) !important;\n  }\n\n  .fs-xxl-2 {\n    font-size: calc(1.275rem + 0.3vw) !important;\n  }\n\n  .fs-xxl-3 {\n    font-size: calc(1.26rem + 0.12vw) !important;\n  }\n\n  .fs-xxl-4 {\n    font-size: 1.25rem !important;\n  }\n\n  .fs-xxl-5 {\n    font-size: 1.15rem !important;\n  }\n\n  .fs-xxl-6 {\n    font-size: 1.075rem !important;\n  }\n\n  .fs-xxl-7 {\n    font-size: 0.95rem !important;\n  }\n\n  .fs-xxl-8 {\n    font-size: 0.85rem !important;\n  }\n\n  .fs-xxl-9 {\n    font-size: 0.75rem !important;\n  }\n\n  .fs-xxl-10 {\n    font-size: 0.5rem !important;\n  }\n\n  .fs-xxl-base {\n    font-size: 1rem !important;\n  }\n\n  .fs-xxl-fluid {\n    font-size: 100% !important;\n  }\n\n  .fs-xxl-2x {\n    font-size: calc(1.325rem + 0.9vw) !important;\n  }\n\n  .fs-xxl-2qx {\n    font-size: calc(1.35rem + 1.2vw) !important;\n  }\n\n  .fs-xxl-2hx {\n    font-size: calc(1.375rem + 1.5vw) !important;\n  }\n\n  .fs-xxl-2tx {\n    font-size: calc(1.4rem + 1.8vw) !important;\n  }\n\n  .fs-xxl-3x {\n    font-size: calc(1.425rem + 2.1vw) !important;\n  }\n\n  .fs-xxl-3qx {\n    font-size: calc(1.45rem + 2.4vw) !important;\n  }\n\n  .fs-xxl-3hx {\n    font-size: calc(1.475rem + 2.7vw) !important;\n  }\n\n  .fs-xxl-3tx {\n    font-size: calc(1.5rem + 3vw) !important;\n  }\n\n  .fs-xxl-4x {\n    font-size: calc(1.525rem + 3.3vw) !important;\n  }\n\n  .fs-xxl-4qx {\n    font-size: calc(1.55rem + 3.6vw) !important;\n  }\n\n  .fs-xxl-4hx {\n    font-size: calc(1.575rem + 3.9vw) !important;\n  }\n\n  .fs-xxl-4tx {\n    font-size: calc(1.6rem + 4.2vw) !important;\n  }\n\n  .fs-xxl-5x {\n    font-size: calc(1.625rem + 4.5vw) !important;\n  }\n\n  .fs-xxl-5qx {\n    font-size: calc(1.65rem + 4.8vw) !important;\n  }\n\n  .fs-xxl-5hx {\n    font-size: calc(1.675rem + 5.1vw) !important;\n  }\n\n  .fs-xxl-5tx {\n    font-size: calc(1.7rem + 5.4vw) !important;\n  }\n\n  .text-xxl-start {\n    text-align: left !important;\n  }\n\n  .text-xxl-end {\n    text-align: right !important;\n  }\n\n  .text-xxl-center {\n    text-align: center !important;\n  }\n\n  .min-w-xxl-unset {\n    min-width: unset !important;\n  }\n\n  .min-w-xxl-25 {\n    min-width: 25% !important;\n  }\n\n  .min-w-xxl-50 {\n    min-width: 50% !important;\n  }\n\n  .min-w-xxl-75 {\n    min-width: 75% !important;\n  }\n\n  .min-w-xxl-100 {\n    min-width: 100% !important;\n  }\n\n  .min-w-xxl-auto {\n    min-width: auto !important;\n  }\n\n  .min-w-xxl-1px {\n    min-width: 1px !important;\n  }\n\n  .min-w-xxl-2px {\n    min-width: 2px !important;\n  }\n\n  .min-w-xxl-3px {\n    min-width: 3px !important;\n  }\n\n  .min-w-xxl-4px {\n    min-width: 4px !important;\n  }\n\n  .min-w-xxl-5px {\n    min-width: 5px !important;\n  }\n\n  .min-w-xxl-6px {\n    min-width: 6px !important;\n  }\n\n  .min-w-xxl-7px {\n    min-width: 7px !important;\n  }\n\n  .min-w-xxl-8px {\n    min-width: 8px !important;\n  }\n\n  .min-w-xxl-9px {\n    min-width: 9px !important;\n  }\n\n  .min-w-xxl-10px {\n    min-width: 10px !important;\n  }\n\n  .min-w-xxl-15px {\n    min-width: 15px !important;\n  }\n\n  .min-w-xxl-20px {\n    min-width: 20px !important;\n  }\n\n  .min-w-xxl-25px {\n    min-width: 25px !important;\n  }\n\n  .min-w-xxl-30px {\n    min-width: 30px !important;\n  }\n\n  .min-w-xxl-35px {\n    min-width: 35px !important;\n  }\n\n  .min-w-xxl-40px {\n    min-width: 40px !important;\n  }\n\n  .min-w-xxl-45px {\n    min-width: 45px !important;\n  }\n\n  .min-w-xxl-50px {\n    min-width: 50px !important;\n  }\n\n  .min-w-xxl-55px {\n    min-width: 55px !important;\n  }\n\n  .min-w-xxl-60px {\n    min-width: 60px !important;\n  }\n\n  .min-w-xxl-65px {\n    min-width: 65px !important;\n  }\n\n  .min-w-xxl-70px {\n    min-width: 70px !important;\n  }\n\n  .min-w-xxl-75px {\n    min-width: 75px !important;\n  }\n\n  .min-w-xxl-80px {\n    min-width: 80px !important;\n  }\n\n  .min-w-xxl-85px {\n    min-width: 85px !important;\n  }\n\n  .min-w-xxl-90px {\n    min-width: 90px !important;\n  }\n\n  .min-w-xxl-95px {\n    min-width: 95px !important;\n  }\n\n  .min-w-xxl-100px {\n    min-width: 100px !important;\n  }\n\n  .min-w-xxl-125px {\n    min-width: 125px !important;\n  }\n\n  .min-w-xxl-150px {\n    min-width: 150px !important;\n  }\n\n  .min-w-xxl-175px {\n    min-width: 175px !important;\n  }\n\n  .min-w-xxl-200px {\n    min-width: 200px !important;\n  }\n\n  .min-w-xxl-225px {\n    min-width: 225px !important;\n  }\n\n  .min-w-xxl-250px {\n    min-width: 250px !important;\n  }\n\n  .min-w-xxl-275px {\n    min-width: 275px !important;\n  }\n\n  .min-w-xxl-300px {\n    min-width: 300px !important;\n  }\n\n  .min-w-xxl-325px {\n    min-width: 325px !important;\n  }\n\n  .min-w-xxl-350px {\n    min-width: 350px !important;\n  }\n\n  .min-w-xxl-375px {\n    min-width: 375px !important;\n  }\n\n  .min-w-xxl-400px {\n    min-width: 400px !important;\n  }\n\n  .min-w-xxl-425px {\n    min-width: 425px !important;\n  }\n\n  .min-w-xxl-450px {\n    min-width: 450px !important;\n  }\n\n  .min-w-xxl-475px {\n    min-width: 475px !important;\n  }\n\n  .min-w-xxl-500px {\n    min-width: 500px !important;\n  }\n\n  .min-w-xxl-550px {\n    min-width: 550px !important;\n  }\n\n  .min-w-xxl-600px {\n    min-width: 600px !important;\n  }\n\n  .min-w-xxl-650px {\n    min-width: 650px !important;\n  }\n\n  .min-w-xxl-700px {\n    min-width: 700px !important;\n  }\n\n  .min-w-xxl-750px {\n    min-width: 750px !important;\n  }\n\n  .min-w-xxl-800px {\n    min-width: 800px !important;\n  }\n\n  .min-w-xxl-850px {\n    min-width: 850px !important;\n  }\n\n  .min-w-xxl-900px {\n    min-width: 900px !important;\n  }\n\n  .min-w-xxl-950px {\n    min-width: 950px !important;\n  }\n\n  .min-w-xxl-1000px {\n    min-width: 1000px !important;\n  }\n\n  .min-h-xxl-unset {\n    min-height: unset !important;\n  }\n\n  .min-h-xxl-25 {\n    min-height: 25% !important;\n  }\n\n  .min-h-xxl-50 {\n    min-height: 50% !important;\n  }\n\n  .min-h-xxl-75 {\n    min-height: 75% !important;\n  }\n\n  .min-h-xxl-100 {\n    min-height: 100% !important;\n  }\n\n  .min-h-xxl-auto {\n    min-height: auto !important;\n  }\n\n  .min-h-xxl-1px {\n    min-height: 1px !important;\n  }\n\n  .min-h-xxl-2px {\n    min-height: 2px !important;\n  }\n\n  .min-h-xxl-3px {\n    min-height: 3px !important;\n  }\n\n  .min-h-xxl-4px {\n    min-height: 4px !important;\n  }\n\n  .min-h-xxl-5px {\n    min-height: 5px !important;\n  }\n\n  .min-h-xxl-6px {\n    min-height: 6px !important;\n  }\n\n  .min-h-xxl-7px {\n    min-height: 7px !important;\n  }\n\n  .min-h-xxl-8px {\n    min-height: 8px !important;\n  }\n\n  .min-h-xxl-9px {\n    min-height: 9px !important;\n  }\n\n  .min-h-xxl-10px {\n    min-height: 10px !important;\n  }\n\n  .min-h-xxl-15px {\n    min-height: 15px !important;\n  }\n\n  .min-h-xxl-20px {\n    min-height: 20px !important;\n  }\n\n  .min-h-xxl-25px {\n    min-height: 25px !important;\n  }\n\n  .min-h-xxl-30px {\n    min-height: 30px !important;\n  }\n\n  .min-h-xxl-35px {\n    min-height: 35px !important;\n  }\n\n  .min-h-xxl-40px {\n    min-height: 40px !important;\n  }\n\n  .min-h-xxl-45px {\n    min-height: 45px !important;\n  }\n\n  .min-h-xxl-50px {\n    min-height: 50px !important;\n  }\n\n  .min-h-xxl-55px {\n    min-height: 55px !important;\n  }\n\n  .min-h-xxl-60px {\n    min-height: 60px !important;\n  }\n\n  .min-h-xxl-65px {\n    min-height: 65px !important;\n  }\n\n  .min-h-xxl-70px {\n    min-height: 70px !important;\n  }\n\n  .min-h-xxl-75px {\n    min-height: 75px !important;\n  }\n\n  .min-h-xxl-80px {\n    min-height: 80px !important;\n  }\n\n  .min-h-xxl-85px {\n    min-height: 85px !important;\n  }\n\n  .min-h-xxl-90px {\n    min-height: 90px !important;\n  }\n\n  .min-h-xxl-95px {\n    min-height: 95px !important;\n  }\n\n  .min-h-xxl-100px {\n    min-height: 100px !important;\n  }\n\n  .min-h-xxl-125px {\n    min-height: 125px !important;\n  }\n\n  .min-h-xxl-150px {\n    min-height: 150px !important;\n  }\n\n  .min-h-xxl-175px {\n    min-height: 175px !important;\n  }\n\n  .min-h-xxl-200px {\n    min-height: 200px !important;\n  }\n\n  .min-h-xxl-225px {\n    min-height: 225px !important;\n  }\n\n  .min-h-xxl-250px {\n    min-height: 250px !important;\n  }\n\n  .min-h-xxl-275px {\n    min-height: 275px !important;\n  }\n\n  .min-h-xxl-300px {\n    min-height: 300px !important;\n  }\n\n  .min-h-xxl-325px {\n    min-height: 325px !important;\n  }\n\n  .min-h-xxl-350px {\n    min-height: 350px !important;\n  }\n\n  .min-h-xxl-375px {\n    min-height: 375px !important;\n  }\n\n  .min-h-xxl-400px {\n    min-height: 400px !important;\n  }\n\n  .min-h-xxl-425px {\n    min-height: 425px !important;\n  }\n\n  .min-h-xxl-450px {\n    min-height: 450px !important;\n  }\n\n  .min-h-xxl-475px {\n    min-height: 475px !important;\n  }\n\n  .min-h-xxl-500px {\n    min-height: 500px !important;\n  }\n\n  .min-h-xxl-550px {\n    min-height: 550px !important;\n  }\n\n  .min-h-xxl-600px {\n    min-height: 600px !important;\n  }\n\n  .min-h-xxl-650px {\n    min-height: 650px !important;\n  }\n\n  .min-h-xxl-700px {\n    min-height: 700px !important;\n  }\n\n  .min-h-xxl-750px {\n    min-height: 750px !important;\n  }\n\n  .min-h-xxl-800px {\n    min-height: 800px !important;\n  }\n\n  .min-h-xxl-850px {\n    min-height: 850px !important;\n  }\n\n  .min-h-xxl-900px {\n    min-height: 900px !important;\n  }\n\n  .min-h-xxl-950px {\n    min-height: 950px !important;\n  }\n\n  .min-h-xxl-1000px {\n    min-height: 1000px !important;\n  }\n}\n@media (min-width: 1200px) {\n  .fs-1 {\n    font-size: 1.75rem !important;\n  }\n\n  .fs-2 {\n    font-size: 1.5rem !important;\n  }\n\n  .fs-3 {\n    font-size: 1.35rem !important;\n  }\n\n  .fs-2x {\n    font-size: 2rem !important;\n  }\n\n  .fs-2qx {\n    font-size: 2.25rem !important;\n  }\n\n  .fs-2hx {\n    font-size: 2.5rem !important;\n  }\n\n  .fs-2tx {\n    font-size: 2.75rem !important;\n  }\n\n  .fs-3x {\n    font-size: 3rem !important;\n  }\n\n  .fs-3qx {\n    font-size: 3.25rem !important;\n  }\n\n  .fs-3hx {\n    font-size: 3.5rem !important;\n  }\n\n  .fs-3tx {\n    font-size: 3.75rem !important;\n  }\n\n  .fs-4x {\n    font-size: 4rem !important;\n  }\n\n  .fs-4qx {\n    font-size: 4.25rem !important;\n  }\n\n  .fs-4hx {\n    font-size: 4.5rem !important;\n  }\n\n  .fs-4tx {\n    font-size: 4.75rem !important;\n  }\n\n  .fs-5x {\n    font-size: 5rem !important;\n  }\n\n  .fs-5qx {\n    font-size: 5.25rem !important;\n  }\n\n  .fs-5hx {\n    font-size: 5.5rem !important;\n  }\n\n  .fs-5tx {\n    font-size: 5.75rem !important;\n  }\n\n  .fs-sm-1 {\n    font-size: 1.75rem !important;\n  }\n\n  .fs-sm-2 {\n    font-size: 1.5rem !important;\n  }\n\n  .fs-sm-3 {\n    font-size: 1.35rem !important;\n  }\n\n  .fs-sm-2x {\n    font-size: 2rem !important;\n  }\n\n  .fs-sm-2qx {\n    font-size: 2.25rem !important;\n  }\n\n  .fs-sm-2hx {\n    font-size: 2.5rem !important;\n  }\n\n  .fs-sm-2tx {\n    font-size: 2.75rem !important;\n  }\n\n  .fs-sm-3x {\n    font-size: 3rem !important;\n  }\n\n  .fs-sm-3qx {\n    font-size: 3.25rem !important;\n  }\n\n  .fs-sm-3hx {\n    font-size: 3.5rem !important;\n  }\n\n  .fs-sm-3tx {\n    font-size: 3.75rem !important;\n  }\n\n  .fs-sm-4x {\n    font-size: 4rem !important;\n  }\n\n  .fs-sm-4qx {\n    font-size: 4.25rem !important;\n  }\n\n  .fs-sm-4hx {\n    font-size: 4.5rem !important;\n  }\n\n  .fs-sm-4tx {\n    font-size: 4.75rem !important;\n  }\n\n  .fs-sm-5x {\n    font-size: 5rem !important;\n  }\n\n  .fs-sm-5qx {\n    font-size: 5.25rem !important;\n  }\n\n  .fs-sm-5hx {\n    font-size: 5.5rem !important;\n  }\n\n  .fs-sm-5tx {\n    font-size: 5.75rem !important;\n  }\n\n  .fs-md-1 {\n    font-size: 1.75rem !important;\n  }\n\n  .fs-md-2 {\n    font-size: 1.5rem !important;\n  }\n\n  .fs-md-3 {\n    font-size: 1.35rem !important;\n  }\n\n  .fs-md-2x {\n    font-size: 2rem !important;\n  }\n\n  .fs-md-2qx {\n    font-size: 2.25rem !important;\n  }\n\n  .fs-md-2hx {\n    font-size: 2.5rem !important;\n  }\n\n  .fs-md-2tx {\n    font-size: 2.75rem !important;\n  }\n\n  .fs-md-3x {\n    font-size: 3rem !important;\n  }\n\n  .fs-md-3qx {\n    font-size: 3.25rem !important;\n  }\n\n  .fs-md-3hx {\n    font-size: 3.5rem !important;\n  }\n\n  .fs-md-3tx {\n    font-size: 3.75rem !important;\n  }\n\n  .fs-md-4x {\n    font-size: 4rem !important;\n  }\n\n  .fs-md-4qx {\n    font-size: 4.25rem !important;\n  }\n\n  .fs-md-4hx {\n    font-size: 4.5rem !important;\n  }\n\n  .fs-md-4tx {\n    font-size: 4.75rem !important;\n  }\n\n  .fs-md-5x {\n    font-size: 5rem !important;\n  }\n\n  .fs-md-5qx {\n    font-size: 5.25rem !important;\n  }\n\n  .fs-md-5hx {\n    font-size: 5.5rem !important;\n  }\n\n  .fs-md-5tx {\n    font-size: 5.75rem !important;\n  }\n\n  .fs-lg-1 {\n    font-size: 1.75rem !important;\n  }\n\n  .fs-lg-2 {\n    font-size: 1.5rem !important;\n  }\n\n  .fs-lg-3 {\n    font-size: 1.35rem !important;\n  }\n\n  .fs-lg-2x {\n    font-size: 2rem !important;\n  }\n\n  .fs-lg-2qx {\n    font-size: 2.25rem !important;\n  }\n\n  .fs-lg-2hx {\n    font-size: 2.5rem !important;\n  }\n\n  .fs-lg-2tx {\n    font-size: 2.75rem !important;\n  }\n\n  .fs-lg-3x {\n    font-size: 3rem !important;\n  }\n\n  .fs-lg-3qx {\n    font-size: 3.25rem !important;\n  }\n\n  .fs-lg-3hx {\n    font-size: 3.5rem !important;\n  }\n\n  .fs-lg-3tx {\n    font-size: 3.75rem !important;\n  }\n\n  .fs-lg-4x {\n    font-size: 4rem !important;\n  }\n\n  .fs-lg-4qx {\n    font-size: 4.25rem !important;\n  }\n\n  .fs-lg-4hx {\n    font-size: 4.5rem !important;\n  }\n\n  .fs-lg-4tx {\n    font-size: 4.75rem !important;\n  }\n\n  .fs-lg-5x {\n    font-size: 5rem !important;\n  }\n\n  .fs-lg-5qx {\n    font-size: 5.25rem !important;\n  }\n\n  .fs-lg-5hx {\n    font-size: 5.5rem !important;\n  }\n\n  .fs-lg-5tx {\n    font-size: 5.75rem !important;\n  }\n}\n@media print {\n  .d-print-inline {\n    display: inline !important;\n  }\n\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-print-block {\n    display: block !important;\n  }\n\n  .d-print-grid {\n    display: grid !important;\n  }\n\n  .d-print-inline-grid {\n    display: inline-grid !important;\n  }\n\n  .d-print-table {\n    display: table !important;\n  }\n\n  .d-print-table-row {\n    display: table-row !important;\n  }\n\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-print-flex {\n    display: flex !important;\n  }\n\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-print-none {\n    display: none !important;\n  }\n}\n:root {\n  --bs-light-primary:#F1FAFF;\n  --bs-active-primary:#0095E8;\n  --bs-light-success:#E8FFF3;\n  --bs-active-success:#47BE7D;\n  --bs-light-info:#F8F5FF;\n  --bs-active-info:#5014D0;\n  --bs-light-warning:#FFF8DD;\n  --bs-active-warning:#F1BC00;\n  --bs-light-danger:#FFF5F8;\n  --bs-active-danger:#D9214E;\n  --bs-light-dark:#EFF2F5;\n  --bs-active-dark:#131628;\n  --bs-gray-100:#F5F8FA;\n  --bs-gray-200:#EFF2F5;\n  --bs-gray-300:#E4E6EF;\n  --bs-gray-400:#B5B5C3;\n  --bs-gray-500:#A1A5B7;\n  --bs-gray-600:#7E8299;\n  --bs-gray-700:#5E6278;\n  --bs-gray-800:#3F4254;\n  --bs-gray-900:#181C32;\n  --bs-xs:0;\n  --bs-sm:576px;\n  --bs-md:768px;\n  --bs-lg:992px;\n  --bs-xl:1200px;\n  --bs-xxl:1400px;\n  --bs-border-color:#EFF2F5;\n  --bs-border-dashed-color:#E4E6EF;\n}\n\n.bg-white {\n  --bg-color: 255, 255, 255;\n}\n.bg-white.hoverable:hover {\n  background-color: #F5F8FA !important;\n}\n\n.bg-hover-white {\n  cursor: pointer;\n}\n.bg-hover-white:hover {\n  --bg-color: 255, 255, 255;\n  background-color: #ffffff !important;\n}\n\n.bg-active-white.active {\n  --bg-color: 255, 255, 255;\n  background-color: #ffffff !important;\n}\n\n.bg-state-white {\n  cursor: pointer;\n}\n.bg-state-white.active, .bg-state-white:hover {\n  --bg-color: 255, 255, 255;\n  background-color: #ffffff !important;\n}\n\n.bg-light {\n  --bg-color: 245, 248, 250;\n}\n.bg-light.hoverable:hover {\n  background-color: #EFF2F5 !important;\n}\n\n.bg-hover-light {\n  cursor: pointer;\n}\n.bg-hover-light:hover {\n  --bg-color: 245, 248, 250;\n  background-color: #F5F8FA !important;\n}\n\n.bg-active-light.active {\n  --bg-color: 245, 248, 250;\n  background-color: #F5F8FA !important;\n}\n\n.bg-state-light {\n  cursor: pointer;\n}\n.bg-state-light.active, .bg-state-light:hover {\n  --bg-color: 245, 248, 250;\n  background-color: #F5F8FA !important;\n}\n\n.bg-light-primary {\n  background-color: #F1FAFF !important;\n}\n.bg-light-primary.hoverable:hover {\n  background-color: #d2efff !important;\n}\n\n.bg-primary {\n  --bg-color: 0, 158, 247;\n}\n.bg-primary.hoverable:hover {\n  background-color: #0095E8 !important;\n}\n\n.bg-hover-light-primary {\n  cursor: pointer;\n}\n.bg-hover-light-primary:hover {\n  background-color: #F1FAFF !important;\n}\n\n.bg-state-light-primary {\n  cursor: pointer;\n}\n.bg-state-light-primary.active, .bg-state-light-primary:hover {\n  background-color: #F1FAFF !important;\n}\n\n.bg-hover-primary {\n  cursor: pointer;\n}\n.bg-hover-primary:hover {\n  --bg-color: 0, 158, 247;\n  background-color: #009EF7 !important;\n}\n\n.bg-active-primary.active {\n  --bg-color: 0, 158, 247;\n  background-color: #009EF7 !important;\n}\n\n.bg-state-primary {\n  cursor: pointer;\n}\n.bg-state-primary.active, .bg-state-primary:hover {\n  --bg-color: 0, 158, 247;\n  background-color: #009EF7 !important;\n}\n\n.bg-secondary {\n  --bg-color: 228, 230, 239;\n}\n.bg-secondary.hoverable:hover {\n  background-color: #B5B5C3 !important;\n}\n\n.bg-hover-secondary {\n  cursor: pointer;\n}\n.bg-hover-secondary:hover {\n  --bg-color: 228, 230, 239;\n  background-color: #E4E6EF !important;\n}\n\n.bg-active-secondary.active {\n  --bg-color: 228, 230, 239;\n  background-color: #E4E6EF !important;\n}\n\n.bg-state-secondary {\n  cursor: pointer;\n}\n.bg-state-secondary.active, .bg-state-secondary:hover {\n  --bg-color: 228, 230, 239;\n  background-color: #E4E6EF !important;\n}\n\n.bg-light-success {\n  background-color: #E8FFF3 !important;\n}\n.bg-light-success.hoverable:hover {\n  background-color: #c9ffe3 !important;\n}\n\n.bg-success {\n  --bg-color: 80, 205, 137;\n}\n.bg-success.hoverable:hover {\n  background-color: #47BE7D !important;\n}\n\n.bg-hover-light-success {\n  cursor: pointer;\n}\n.bg-hover-light-success:hover {\n  background-color: #E8FFF3 !important;\n}\n\n.bg-state-light-success {\n  cursor: pointer;\n}\n.bg-state-light-success.active, .bg-state-light-success:hover {\n  background-color: #E8FFF3 !important;\n}\n\n.bg-hover-success {\n  cursor: pointer;\n}\n.bg-hover-success:hover {\n  --bg-color: 80, 205, 137;\n  background-color: #50CD89 !important;\n}\n\n.bg-active-success.active {\n  --bg-color: 80, 205, 137;\n  background-color: #50CD89 !important;\n}\n\n.bg-state-success {\n  cursor: pointer;\n}\n.bg-state-success.active, .bg-state-success:hover {\n  --bg-color: 80, 205, 137;\n  background-color: #50CD89 !important;\n}\n\n.bg-light-info {\n  background-color: #F8F5FF !important;\n}\n.bg-light-info.hoverable:hover {\n  background-color: #e3d6ff !important;\n}\n\n.bg-info {\n  --bg-color: 114, 57, 234;\n}\n.bg-info.hoverable:hover {\n  background-color: #5014D0 !important;\n}\n\n.bg-hover-light-info {\n  cursor: pointer;\n}\n.bg-hover-light-info:hover {\n  background-color: #F8F5FF !important;\n}\n\n.bg-state-light-info {\n  cursor: pointer;\n}\n.bg-state-light-info.active, .bg-state-light-info:hover {\n  background-color: #F8F5FF !important;\n}\n\n.bg-hover-info {\n  cursor: pointer;\n}\n.bg-hover-info:hover {\n  --bg-color: 114, 57, 234;\n  background-color: #7239EA !important;\n}\n\n.bg-active-info.active {\n  --bg-color: 114, 57, 234;\n  background-color: #7239EA !important;\n}\n\n.bg-state-info {\n  cursor: pointer;\n}\n.bg-state-info.active, .bg-state-info:hover {\n  --bg-color: 114, 57, 234;\n  background-color: #7239EA !important;\n}\n\n.bg-light-warning {\n  background-color: #FFF8DD !important;\n}\n.bg-light-warning.hoverable:hover {\n  background-color: #fff2be !important;\n}\n\n.bg-warning {\n  --bg-color: 255, 199, 0;\n}\n.bg-warning.hoverable:hover {\n  background-color: #F1BC00 !important;\n}\n\n.bg-hover-light-warning {\n  cursor: pointer;\n}\n.bg-hover-light-warning:hover {\n  background-color: #FFF8DD !important;\n}\n\n.bg-state-light-warning {\n  cursor: pointer;\n}\n.bg-state-light-warning.active, .bg-state-light-warning:hover {\n  background-color: #FFF8DD !important;\n}\n\n.bg-hover-warning {\n  cursor: pointer;\n}\n.bg-hover-warning:hover {\n  --bg-color: 255, 199, 0;\n  background-color: #FFC700 !important;\n}\n\n.bg-active-warning.active {\n  --bg-color: 255, 199, 0;\n  background-color: #FFC700 !important;\n}\n\n.bg-state-warning {\n  cursor: pointer;\n}\n.bg-state-warning.active, .bg-state-warning:hover {\n  --bg-color: 255, 199, 0;\n  background-color: #FFC700 !important;\n}\n\n.bg-light-danger {\n  background-color: #FFF5F8 !important;\n}\n.bg-light-danger.hoverable:hover {\n  background-color: #ffd6e3 !important;\n}\n\n.bg-danger {\n  --bg-color: 241, 65, 108;\n}\n.bg-danger.hoverable:hover {\n  background-color: #D9214E !important;\n}\n\n.bg-hover-light-danger {\n  cursor: pointer;\n}\n.bg-hover-light-danger:hover {\n  background-color: #FFF5F8 !important;\n}\n\n.bg-state-light-danger {\n  cursor: pointer;\n}\n.bg-state-light-danger.active, .bg-state-light-danger:hover {\n  background-color: #FFF5F8 !important;\n}\n\n.bg-hover-danger {\n  cursor: pointer;\n}\n.bg-hover-danger:hover {\n  --bg-color: 241, 65, 108;\n  background-color: #F1416C !important;\n}\n\n.bg-active-danger.active {\n  --bg-color: 241, 65, 108;\n  background-color: #F1416C !important;\n}\n\n.bg-state-danger {\n  cursor: pointer;\n}\n.bg-state-danger.active, .bg-state-danger:hover {\n  --bg-color: 241, 65, 108;\n  background-color: #F1416C !important;\n}\n\n.bg-light-dark {\n  background-color: #EFF2F5 !important;\n}\n.bg-light-dark.hoverable:hover {\n  background-color: #dce3e9 !important;\n}\n\n.bg-dark {\n  --bg-color: 24, 28, 50;\n}\n.bg-dark.hoverable:hover {\n  background-color: #131628 !important;\n}\n\n.bg-hover-light-dark {\n  cursor: pointer;\n}\n.bg-hover-light-dark:hover {\n  background-color: #EFF2F5 !important;\n}\n\n.bg-state-light-dark {\n  cursor: pointer;\n}\n.bg-state-light-dark.active, .bg-state-light-dark:hover {\n  background-color: #EFF2F5 !important;\n}\n\n.bg-hover-dark {\n  cursor: pointer;\n}\n.bg-hover-dark:hover {\n  --bg-color: 24, 28, 50;\n  background-color: #181C32 !important;\n}\n\n.bg-active-dark.active {\n  --bg-color: 24, 28, 50;\n  background-color: #181C32 !important;\n}\n\n.bg-state-dark {\n  cursor: pointer;\n}\n.bg-state-dark.active, .bg-state-dark:hover {\n  --bg-color: 24, 28, 50;\n  background-color: #181C32 !important;\n}\n\n.bg-gray-100 {\n  background-color: #F5F8FA !important;\n}\n\n.bg-gray-200 {\n  background-color: #EFF2F5 !important;\n}\n\n.bg-gray-300 {\n  background-color: #E4E6EF !important;\n}\n\n.bg-gray-400 {\n  background-color: #B5B5C3 !important;\n}\n\n.bg-gray-500 {\n  background-color: #A1A5B7 !important;\n}\n\n.bg-gray-600 {\n  background-color: #7E8299 !important;\n}\n\n.bg-gray-700 {\n  background-color: #5E6278 !important;\n}\n\n.bg-gray-800 {\n  background-color: #3F4254 !important;\n}\n\n.bg-gray-900 {\n  background-color: #181C32 !important;\n}\n\n.bg-opacity-0 {\n  background-color: rgba(var(--bg-color), 0) !important;\n}\n\n.bg-hover-opacity-0:hover {\n  background-color: rgba(var(--bg-color), 0) !important;\n}\n\n.bg-active-opacity-0.active {\n  background-color: rgba(var(--bg-color), 0) !important;\n}\n\n.bg-state-opacity-0 .active, .bg-state-opacity-0:hover {\n  background-color: rgba(var(--bg-color), 0) !important;\n}\n\n.bg-opacity-5 {\n  background-color: rgba(var(--bg-color), 0.05) !important;\n}\n\n.bg-hover-opacity-5:hover {\n  background-color: rgba(var(--bg-color), 0.05) !important;\n}\n\n.bg-active-opacity-5.active {\n  background-color: rgba(var(--bg-color), 0.05) !important;\n}\n\n.bg-state-opacity-5 .active, .bg-state-opacity-5:hover {\n  background-color: rgba(var(--bg-color), 0.05) !important;\n}\n\n.bg-opacity-10 {\n  background-color: rgba(var(--bg-color), 0.1) !important;\n}\n\n.bg-hover-opacity-10:hover {\n  background-color: rgba(var(--bg-color), 0.1) !important;\n}\n\n.bg-active-opacity-10.active {\n  background-color: rgba(var(--bg-color), 0.1) !important;\n}\n\n.bg-state-opacity-10 .active, .bg-state-opacity-10:hover {\n  background-color: rgba(var(--bg-color), 0.1) !important;\n}\n\n.bg-opacity-15 {\n  background-color: rgba(var(--bg-color), 0.15) !important;\n}\n\n.bg-hover-opacity-15:hover {\n  background-color: rgba(var(--bg-color), 0.15) !important;\n}\n\n.bg-active-opacity-15.active {\n  background-color: rgba(var(--bg-color), 0.15) !important;\n}\n\n.bg-state-opacity-15 .active, .bg-state-opacity-15:hover {\n  background-color: rgba(var(--bg-color), 0.15) !important;\n}\n\n.bg-opacity-20 {\n  background-color: rgba(var(--bg-color), 0.2) !important;\n}\n\n.bg-hover-opacity-20:hover {\n  background-color: rgba(var(--bg-color), 0.2) !important;\n}\n\n.bg-active-opacity-20.active {\n  background-color: rgba(var(--bg-color), 0.2) !important;\n}\n\n.bg-state-opacity-20 .active, .bg-state-opacity-20:hover {\n  background-color: rgba(var(--bg-color), 0.2) !important;\n}\n\n.bg-opacity-25 {\n  background-color: rgba(var(--bg-color), 0.25) !important;\n}\n\n.bg-hover-opacity-25:hover {\n  background-color: rgba(var(--bg-color), 0.25) !important;\n}\n\n.bg-active-opacity-25.active {\n  background-color: rgba(var(--bg-color), 0.25) !important;\n}\n\n.bg-state-opacity-25 .active, .bg-state-opacity-25:hover {\n  background-color: rgba(var(--bg-color), 0.25) !important;\n}\n\n.bg-opacity-50 {\n  background-color: rgba(var(--bg-color), 0.5) !important;\n}\n\n.bg-hover-opacity-50:hover {\n  background-color: rgba(var(--bg-color), 0.5) !important;\n}\n\n.bg-active-opacity-50.active {\n  background-color: rgba(var(--bg-color), 0.5) !important;\n}\n\n.bg-state-opacity-50 .active, .bg-state-opacity-50:hover {\n  background-color: rgba(var(--bg-color), 0.5) !important;\n}\n\n.bg-opacity-75 {\n  background-color: rgba(var(--bg-color), 0.75) !important;\n}\n\n.bg-hover-opacity-75:hover {\n  background-color: rgba(var(--bg-color), 0.75) !important;\n}\n\n.bg-active-opacity-75.active {\n  background-color: rgba(var(--bg-color), 0.75) !important;\n}\n\n.bg-state-opacity-75 .active, .bg-state-opacity-75:hover {\n  background-color: rgba(var(--bg-color), 0.75) !important;\n}\n\n.bg-opacity-100 {\n  background-color: rgba(var(--bg-color), 1) !important;\n}\n\n.bg-hover-opacity-100:hover {\n  background-color: rgba(var(--bg-color), 1) !important;\n}\n\n.bg-active-opacity-100.active {\n  background-color: rgba(var(--bg-color), 1) !important;\n}\n\n.bg-state-opacity-100 .active, .bg-state-opacity-100:hover {\n  background-color: rgba(var(--bg-color), 1) !important;\n}\n\n.bg-black {\n  background-color: #000000 !important;\n}\n\n.bg-body {\n  --bg-color: 255, 255, 255;\n  background-color: #ffffff !important;\n}\n\n.bg-lighten {\n  background-color: rgba(245, 248, 250, 0.5) !important;\n}\n\n.bg-hover-lighten {\n  cursor: pointer;\n}\n.bg-hover-lighten:hover {\n  background-color: rgba(245, 248, 250, 0.5) !important;\n}\n\n.bg-active-lighten.active {\n  background-color: rgba(245, 248, 250, 0.5) !important;\n}\n\n.bg-state-lighten {\n  cursor: pointer;\n}\n.bg-state-lighten.active, .bg-state-lighten:hover {\n  background-color: rgba(245, 248, 250, 0.5) !important;\n}\n\n.hoverable {\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.hoverable:hover {\n  transition: all 0.2s ease;\n}\n\n.bgi-no-repeat {\n  background-repeat: no-repeat;\n}\n\n.bgi-position-y-top {\n  background-position-y: top;\n}\n\n.bgi-position-y-bottom {\n  background-position-y: bottom;\n}\n\n.bgi-position-y-center {\n  background-position-y: center;\n}\n\n.bgi-position-x-start {\n  background-position-x: left;\n}\n\n.bgi-position-x-end {\n  background-position-x: right;\n}\n\n.bgi-position-x-center {\n  background-position-x: center;\n}\n\n.bgi-position-top {\n  background-position: 0 top;\n}\n\n.bgi-position-bottom {\n  background-position: 0 bottom;\n}\n\n.bgi-position-center {\n  background-position: center;\n}\n\n.bgi-size-auto {\n  background-size: auto;\n}\n\n.bgi-size-cover {\n  background-size: cover;\n}\n\n.bgi-size-contain {\n  background-size: contain;\n}\n\n.bgi-attachment-fixed {\n  background-attachment: fixed;\n}\n\n.bgi-attachment-auto {\n  background-attachment: auto;\n}\n\n@media (min-width: 576px) {\n  .bgi-size-sm-auto {\n    background-size: auto;\n  }\n\n  .bgi-size-sm-cover {\n    background-size: cover;\n  }\n\n  .bgi-size-sm-contain {\n    background-size: contain;\n  }\n\n  .bgi-attachment-sm-fixed {\n    background-attachment: fixed;\n  }\n\n  .bgi-attachment-sm-auto {\n    background-attachment: auto;\n  }\n}\n@media (min-width: 768px) {\n  .bgi-size-md-auto {\n    background-size: auto;\n  }\n\n  .bgi-size-md-cover {\n    background-size: cover;\n  }\n\n  .bgi-size-md-contain {\n    background-size: contain;\n  }\n\n  .bgi-attachment-md-fixed {\n    background-attachment: fixed;\n  }\n\n  .bgi-attachment-md-auto {\n    background-attachment: auto;\n  }\n}\n@media (min-width: 992px) {\n  .bgi-size-lg-auto {\n    background-size: auto;\n  }\n\n  .bgi-size-lg-cover {\n    background-size: cover;\n  }\n\n  .bgi-size-lg-contain {\n    background-size: contain;\n  }\n\n  .bgi-attachment-lg-fixed {\n    background-attachment: fixed;\n  }\n\n  .bgi-attachment-lg-auto {\n    background-attachment: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .bgi-size-xl-auto {\n    background-size: auto;\n  }\n\n  .bgi-size-xl-cover {\n    background-size: cover;\n  }\n\n  .bgi-size-xl-contain {\n    background-size: contain;\n  }\n\n  .bgi-attachment-xl-fixed {\n    background-attachment: fixed;\n  }\n\n  .bgi-attachment-xl-auto {\n    background-attachment: auto;\n  }\n}\n@media (min-width: 1400px) {\n  .bgi-size-xxl-auto {\n    background-size: auto;\n  }\n\n  .bgi-size-xxl-cover {\n    background-size: cover;\n  }\n\n  .bgi-size-xxl-contain {\n    background-size: contain;\n  }\n\n  .bgi-attachment-xxl-fixed {\n    background-attachment: fixed;\n  }\n\n  .bgi-attachment-xxl-auto {\n    background-attachment: auto;\n  }\n}\n.border-active:not(.active):not(:active):not(:hover):not(:focus) {\n  border-color: transparent !important;\n}\n\n.border-hover:not(:hover):not(:focus):not(.active):not(:active) {\n  cursor: pointer;\n  border-color: transparent !important;\n}\n\n.border-gray-100 {\n  border-color: #F5F8FA !important;\n}\n\n.border-gray-200 {\n  border-color: #EFF2F5 !important;\n}\n\n.border-gray-300 {\n  border-color: #E4E6EF !important;\n}\n\n.border-gray-400 {\n  border-color: #B5B5C3 !important;\n}\n\n.border-gray-500 {\n  border-color: #A1A5B7 !important;\n}\n\n.border-gray-600 {\n  border-color: #7E8299 !important;\n}\n\n.border-gray-700 {\n  border-color: #5E6278 !important;\n}\n\n.border-gray-800 {\n  border-color: #3F4254 !important;\n}\n\n.border-gray-900 {\n  border-color: #181C32 !important;\n}\n\n.border-hover-white:hover {\n  border-color: #ffffff !important;\n}\n\n.border-active-white.active {\n  border-color: #ffffff !important;\n}\n\n.border-hover-light:hover {\n  border-color: #F5F8FA !important;\n}\n\n.border-active-light.active {\n  border-color: #F5F8FA !important;\n}\n\n.border-hover-primary:hover {\n  border-color: #009EF7 !important;\n}\n\n.border-active-primary.active {\n  border-color: #009EF7 !important;\n}\n\n.border-hover-secondary:hover {\n  border-color: #E4E6EF !important;\n}\n\n.border-active-secondary.active {\n  border-color: #E4E6EF !important;\n}\n\n.border-hover-success:hover {\n  border-color: #50CD89 !important;\n}\n\n.border-active-success.active {\n  border-color: #50CD89 !important;\n}\n\n.border-hover-info:hover {\n  border-color: #7239EA !important;\n}\n\n.border-active-info.active {\n  border-color: #7239EA !important;\n}\n\n.border-hover-warning:hover {\n  border-color: #FFC700 !important;\n}\n\n.border-active-warning.active {\n  border-color: #FFC700 !important;\n}\n\n.border-hover-danger:hover {\n  border-color: #F1416C !important;\n}\n\n.border-active-danger.active {\n  border-color: #F1416C !important;\n}\n\n.border-hover-dark:hover {\n  border-color: #181C32 !important;\n}\n\n.border-active-dark.active {\n  border-color: #181C32 !important;\n}\n\n.border-hover-transparent:hover {\n  border-color: transparent !important;\n}\n\n.border-dashed {\n  border-style: dashed !important;\n  border-color: #E4E6EF;\n}\n\n.border-top-dashed {\n  border-top-style: dashed !important;\n}\n\n.border-bottom-dashed {\n  border-bottom-style: dashed !important;\n}\n\n.border-start-dashed {\n  border-left-style: dashed !important;\n}\n\n.border-end-dashed {\n  border-right-style: dashed !important;\n}\n\n.border-dotted {\n  border-style: dotted !important;\n}\n\n.border-top-dotted {\n  border-top-style: dotted !important;\n}\n\n.border-bottom-dotted {\n  border-bottom-style: dotted !important;\n}\n\n.border-start-dotted {\n  border-left-style: dotted !important;\n}\n\n.border-end-dotted {\n  border-right-style: dotted !important;\n}\n\n.border-transparent {\n  border-color: transparent !important;\n}\n\n.border-body {\n  border-color: #ffffff !important;\n}\n\n.rounded-top-0 {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.rounded-bottom-0 {\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-start-0 {\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.rounded-end-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.flex-root {\n  flex: 1;\n}\n\n.flex-column-auto {\n  flex: none;\n}\n\n.flex-column-fluid {\n  flex: 1 0 auto;\n}\n\n.flex-row-auto {\n  flex: 0 0 auto;\n}\n\n.flex-row-fluid {\n  flex: 1 auto;\n  min-width: 0;\n}\n\n.flex-center {\n  justify-content: center;\n  align-items: center;\n}\n\n.flex-stack {\n  justify-content: space-between;\n  align-items: center;\n}\n\n@media (min-width: 576px) {\n  .flex-sm-root {\n    flex: 1;\n  }\n\n  .flex-sm-column-auto {\n    flex: none;\n  }\n\n  .flex-sm-column-fluid {\n    flex: 1 0 auto;\n  }\n\n  .flex-sm-row-auto {\n    flex: 0 0 auto;\n  }\n\n  .flex-sm-row-fluid {\n    flex: 1 auto;\n    min-width: 0;\n  }\n\n  .flex-sm-center {\n    justify-content: center;\n    align-items: center;\n  }\n\n  .flex-sm-stack {\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n@media (min-width: 768px) {\n  .flex-md-root {\n    flex: 1;\n  }\n\n  .flex-md-column-auto {\n    flex: none;\n  }\n\n  .flex-md-column-fluid {\n    flex: 1 0 auto;\n  }\n\n  .flex-md-row-auto {\n    flex: 0 0 auto;\n  }\n\n  .flex-md-row-fluid {\n    flex: 1 auto;\n    min-width: 0;\n  }\n\n  .flex-md-center {\n    justify-content: center;\n    align-items: center;\n  }\n\n  .flex-md-stack {\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n@media (min-width: 992px) {\n  .flex-lg-root {\n    flex: 1;\n  }\n\n  .flex-lg-column-auto {\n    flex: none;\n  }\n\n  .flex-lg-column-fluid {\n    flex: 1 0 auto;\n  }\n\n  .flex-lg-row-auto {\n    flex: 0 0 auto;\n  }\n\n  .flex-lg-row-fluid {\n    flex: 1 auto;\n    min-width: 0;\n  }\n\n  .flex-lg-center {\n    justify-content: center;\n    align-items: center;\n  }\n\n  .flex-lg-stack {\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n@media (min-width: 1200px) {\n  .flex-xl-root {\n    flex: 1;\n  }\n\n  .flex-xl-column-auto {\n    flex: none;\n  }\n\n  .flex-xl-column-fluid {\n    flex: 1 0 auto;\n  }\n\n  .flex-xl-row-auto {\n    flex: 0 0 auto;\n  }\n\n  .flex-xl-row-fluid {\n    flex: 1 auto;\n    min-width: 0;\n  }\n\n  .flex-xl-center {\n    justify-content: center;\n    align-items: center;\n  }\n\n  .flex-xl-stack {\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n@media (min-width: 1400px) {\n  .flex-xxl-root {\n    flex: 1;\n  }\n\n  .flex-xxl-column-auto {\n    flex: none;\n  }\n\n  .flex-xxl-column-fluid {\n    flex: 1 0 auto;\n  }\n\n  .flex-xxl-row-auto {\n    flex: 0 0 auto;\n  }\n\n  .flex-xxl-row-fluid {\n    flex: 1 auto;\n    min-width: 0;\n  }\n\n  .flex-xxl-center {\n    justify-content: center;\n    align-items: center;\n  }\n\n  .flex-xxl-stack {\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n.flex-equal {\n  flex-grow: 1;\n  flex-basis: 0;\n  flex-shrink: 0;\n}\n\n.shadow-xs {\n  box-shadow: 0 0.1rem 0.75rem 0.25rem rgba(0, 0, 0, 0.05);\n}\n\n.text-white {\n  color: #ffffff !important;\n}\n\n.text-inverse-white {\n  color: #7E8299 !important;\n}\n\n.text-hover-white {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-white i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-white:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #ffffff !important;\n}\n.text-hover-white:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #ffffff !important;\n}\n.text-hover-white:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.text-hover-white:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-hover-inverse-white {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-inverse-white i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-inverse-white:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #7E8299 !important;\n}\n.text-hover-inverse-white:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #7E8299 !important;\n}\n.text-hover-inverse-white:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7E8299;\n}\n.text-hover-inverse-white:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-white {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-white i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-white.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #ffffff !important;\n}\n.text-active-white.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #ffffff !important;\n}\n.text-active-white.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.text-active-white.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-inverse-white {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-inverse-white i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-inverse-white.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #7E8299 !important;\n}\n.text-active-inverse-white.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #7E8299 !important;\n}\n.text-active-inverse-white.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7E8299;\n}\n.text-active-inverse-white.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-primary {\n  color: #009EF7 !important;\n}\n\n.text-inverse-primary {\n  color: #FFFFFF !important;\n}\n\n.text-light-primary {\n  color: #F1FAFF !important;\n}\n\n.text-hover-primary {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-primary i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-primary:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #009EF7 !important;\n}\n.text-hover-primary:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #009EF7 !important;\n}\n.text-hover-primary:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.text-hover-primary:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-hover-inverse-primary {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-inverse-primary i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-inverse-primary:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFFFFF !important;\n}\n.text-hover-inverse-primary:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFFFFF !important;\n}\n.text-hover-inverse-primary:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.text-hover-inverse-primary:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-primary {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-primary i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-primary.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #009EF7 !important;\n}\n.text-active-primary.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #009EF7 !important;\n}\n.text-active-primary.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.text-active-primary.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-inverse-primary {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-inverse-primary i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-inverse-primary.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFFFFF !important;\n}\n.text-active-inverse-primary.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFFFFF !important;\n}\n.text-active-inverse-primary.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.text-active-inverse-primary.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-secondary {\n  color: #E4E6EF !important;\n}\n\n.text-inverse-secondary {\n  color: #3F4254 !important;\n}\n\n.text-hover-secondary {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-secondary i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-secondary:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #E4E6EF !important;\n}\n.text-hover-secondary:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #E4E6EF !important;\n}\n.text-hover-secondary:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #E4E6EF;\n}\n.text-hover-secondary:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-hover-inverse-secondary {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-inverse-secondary i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-inverse-secondary:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #3F4254 !important;\n}\n.text-hover-inverse-secondary:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #3F4254 !important;\n}\n.text-hover-inverse-secondary:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #3F4254;\n}\n.text-hover-inverse-secondary:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-secondary {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-secondary i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-secondary.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #E4E6EF !important;\n}\n.text-active-secondary.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #E4E6EF !important;\n}\n.text-active-secondary.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #E4E6EF;\n}\n.text-active-secondary.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-inverse-secondary {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-inverse-secondary i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-inverse-secondary.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #3F4254 !important;\n}\n.text-active-inverse-secondary.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #3F4254 !important;\n}\n.text-active-inverse-secondary.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #3F4254;\n}\n.text-active-inverse-secondary.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-light {\n  color: #F5F8FA !important;\n}\n\n.text-inverse-light {\n  color: #7E8299 !important;\n}\n\n.text-hover-light {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-light i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-light:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #F5F8FA !important;\n}\n.text-hover-light:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #F5F8FA !important;\n}\n.text-hover-light:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F5F8FA;\n}\n.text-hover-light:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-hover-inverse-light {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-inverse-light i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-inverse-light:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #7E8299 !important;\n}\n.text-hover-inverse-light:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #7E8299 !important;\n}\n.text-hover-inverse-light:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7E8299;\n}\n.text-hover-inverse-light:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-light {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-light i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-light.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #F5F8FA !important;\n}\n.text-active-light.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #F5F8FA !important;\n}\n.text-active-light.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F5F8FA;\n}\n.text-active-light.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-inverse-light {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-inverse-light i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-inverse-light.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #7E8299 !important;\n}\n.text-active-inverse-light.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #7E8299 !important;\n}\n.text-active-inverse-light.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7E8299;\n}\n.text-active-inverse-light.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-success {\n  color: #50CD89 !important;\n}\n\n.text-inverse-success {\n  color: #FFFFFF !important;\n}\n\n.text-light-success {\n  color: #E8FFF3 !important;\n}\n\n.text-hover-success {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-success i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-success:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #50CD89 !important;\n}\n.text-hover-success:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #50CD89 !important;\n}\n.text-hover-success:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #50CD89;\n}\n.text-hover-success:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-hover-inverse-success {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-inverse-success i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-inverse-success:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFFFFF !important;\n}\n.text-hover-inverse-success:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFFFFF !important;\n}\n.text-hover-inverse-success:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.text-hover-inverse-success:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-success {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-success i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-success.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #50CD89 !important;\n}\n.text-active-success.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #50CD89 !important;\n}\n.text-active-success.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #50CD89;\n}\n.text-active-success.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-inverse-success {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-inverse-success i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-inverse-success.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFFFFF !important;\n}\n.text-active-inverse-success.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFFFFF !important;\n}\n.text-active-inverse-success.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.text-active-inverse-success.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-info {\n  color: #7239EA !important;\n}\n\n.text-inverse-info {\n  color: #FFFFFF !important;\n}\n\n.text-light-info {\n  color: #F8F5FF !important;\n}\n\n.text-hover-info {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-info i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-info:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #7239EA !important;\n}\n.text-hover-info:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #7239EA !important;\n}\n.text-hover-info:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7239EA;\n}\n.text-hover-info:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-hover-inverse-info {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-inverse-info i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-inverse-info:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFFFFF !important;\n}\n.text-hover-inverse-info:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFFFFF !important;\n}\n.text-hover-inverse-info:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.text-hover-inverse-info:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-info {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-info i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-info.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #7239EA !important;\n}\n.text-active-info.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #7239EA !important;\n}\n.text-active-info.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7239EA;\n}\n.text-active-info.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-inverse-info {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-inverse-info i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-inverse-info.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFFFFF !important;\n}\n.text-active-inverse-info.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFFFFF !important;\n}\n.text-active-inverse-info.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.text-active-inverse-info.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-warning {\n  color: #FFC700 !important;\n}\n\n.text-inverse-warning {\n  color: #FFFFFF !important;\n}\n\n.text-light-warning {\n  color: #FFF8DD !important;\n}\n\n.text-hover-warning {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-warning i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-warning:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFC700 !important;\n}\n.text-hover-warning:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFC700 !important;\n}\n.text-hover-warning:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFC700;\n}\n.text-hover-warning:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-hover-inverse-warning {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-inverse-warning i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-inverse-warning:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFFFFF !important;\n}\n.text-hover-inverse-warning:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFFFFF !important;\n}\n.text-hover-inverse-warning:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.text-hover-inverse-warning:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-warning {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-warning i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-warning.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFC700 !important;\n}\n.text-active-warning.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFC700 !important;\n}\n.text-active-warning.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFC700;\n}\n.text-active-warning.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-inverse-warning {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-inverse-warning i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-inverse-warning.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFFFFF !important;\n}\n.text-active-inverse-warning.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFFFFF !important;\n}\n.text-active-inverse-warning.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.text-active-inverse-warning.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-danger {\n  color: #F1416C !important;\n}\n\n.text-inverse-danger {\n  color: #FFFFFF !important;\n}\n\n.text-light-danger {\n  color: #FFF5F8 !important;\n}\n\n.text-hover-danger {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-danger i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-danger:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #F1416C !important;\n}\n.text-hover-danger:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #F1416C !important;\n}\n.text-hover-danger:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F1416C;\n}\n.text-hover-danger:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-hover-inverse-danger {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-inverse-danger i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-inverse-danger:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFFFFF !important;\n}\n.text-hover-inverse-danger:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFFFFF !important;\n}\n.text-hover-inverse-danger:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.text-hover-inverse-danger:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-danger {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-danger i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-danger.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #F1416C !important;\n}\n.text-active-danger.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #F1416C !important;\n}\n.text-active-danger.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F1416C;\n}\n.text-active-danger.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-inverse-danger {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-inverse-danger i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-inverse-danger.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFFFFF !important;\n}\n.text-active-inverse-danger.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #FFFFFF !important;\n}\n.text-active-inverse-danger.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.text-active-inverse-danger.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-dark {\n  color: #181C32 !important;\n}\n\n.text-inverse-dark {\n  color: #ffffff !important;\n}\n\n.text-light-dark {\n  color: #EFF2F5 !important;\n}\n\n.text-hover-dark {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-dark i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-dark:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #181C32 !important;\n}\n.text-hover-dark:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #181C32 !important;\n}\n.text-hover-dark:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #181C32;\n}\n.text-hover-dark:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-hover-inverse-dark {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-inverse-dark i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-inverse-dark:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #ffffff !important;\n}\n.text-hover-inverse-dark:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #ffffff !important;\n}\n.text-hover-inverse-dark:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.text-hover-inverse-dark:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-dark {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-dark i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-dark.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #181C32 !important;\n}\n.text-active-dark.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #181C32 !important;\n}\n.text-active-dark.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #181C32;\n}\n.text-active-dark.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-inverse-dark {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-inverse-dark i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-inverse-dark.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #ffffff !important;\n}\n.text-active-inverse-dark.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #ffffff !important;\n}\n.text-active-inverse-dark.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.text-active-inverse-dark.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-muted {\n  color: #A1A5B7 !important;\n}\n\n.text-hover-muted {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-muted i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-muted:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #A1A5B7 !important;\n}\n.text-hover-muted:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #A1A5B7 !important;\n}\n.text-hover-muted:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #A1A5B7;\n}\n.text-hover-muted:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-muted {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-muted i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-muted.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #A1A5B7 !important;\n}\n.text-active-muted.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #A1A5B7 !important;\n}\n.text-active-muted.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #A1A5B7;\n}\n.text-active-muted.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-gray-100 {\n  color: #F5F8FA !important;\n}\n\n.text-hover-gray-100 {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-gray-100 i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-gray-100:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #F5F8FA !important;\n}\n.text-hover-gray-100:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #F5F8FA !important;\n}\n.text-hover-gray-100:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F5F8FA;\n}\n.text-hover-gray-100:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-gray-100 {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-gray-100 i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-gray-100.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #F5F8FA !important;\n}\n.text-active-gray-100.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #F5F8FA !important;\n}\n.text-active-gray-100.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F5F8FA;\n}\n.text-active-gray-100.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-gray-200 {\n  color: #EFF2F5 !important;\n}\n\n.text-hover-gray-200 {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-gray-200 i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-gray-200:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #EFF2F5 !important;\n}\n.text-hover-gray-200:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #EFF2F5 !important;\n}\n.text-hover-gray-200:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #EFF2F5;\n}\n.text-hover-gray-200:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-gray-200 {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-gray-200 i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-gray-200.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #EFF2F5 !important;\n}\n.text-active-gray-200.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #EFF2F5 !important;\n}\n.text-active-gray-200.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #EFF2F5;\n}\n.text-active-gray-200.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-gray-300 {\n  color: #E4E6EF !important;\n}\n\n.text-hover-gray-300 {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-gray-300 i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-gray-300:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #E4E6EF !important;\n}\n.text-hover-gray-300:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #E4E6EF !important;\n}\n.text-hover-gray-300:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #E4E6EF;\n}\n.text-hover-gray-300:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-gray-300 {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-gray-300 i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-gray-300.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #E4E6EF !important;\n}\n.text-active-gray-300.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #E4E6EF !important;\n}\n.text-active-gray-300.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #E4E6EF;\n}\n.text-active-gray-300.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-gray-400 {\n  color: #B5B5C3 !important;\n}\n\n.text-hover-gray-400 {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-gray-400 i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-gray-400:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #B5B5C3 !important;\n}\n.text-hover-gray-400:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #B5B5C3 !important;\n}\n.text-hover-gray-400:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #B5B5C3;\n}\n.text-hover-gray-400:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-gray-400 {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-gray-400 i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-gray-400.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #B5B5C3 !important;\n}\n.text-active-gray-400.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #B5B5C3 !important;\n}\n.text-active-gray-400.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #B5B5C3;\n}\n.text-active-gray-400.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-gray-500 {\n  color: #A1A5B7 !important;\n}\n\n.text-hover-gray-500 {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-gray-500 i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-gray-500:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #A1A5B7 !important;\n}\n.text-hover-gray-500:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #A1A5B7 !important;\n}\n.text-hover-gray-500:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #A1A5B7;\n}\n.text-hover-gray-500:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-gray-500 {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-gray-500 i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-gray-500.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #A1A5B7 !important;\n}\n.text-active-gray-500.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #A1A5B7 !important;\n}\n.text-active-gray-500.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #A1A5B7;\n}\n.text-active-gray-500.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-gray-600 {\n  color: #7E8299 !important;\n}\n\n.text-hover-gray-600 {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-gray-600 i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-gray-600:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #7E8299 !important;\n}\n.text-hover-gray-600:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #7E8299 !important;\n}\n.text-hover-gray-600:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7E8299;\n}\n.text-hover-gray-600:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-gray-600 {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-gray-600 i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-gray-600.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #7E8299 !important;\n}\n.text-active-gray-600.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #7E8299 !important;\n}\n.text-active-gray-600.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7E8299;\n}\n.text-active-gray-600.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-gray-700 {\n  color: #5E6278 !important;\n}\n\n.text-hover-gray-700 {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-gray-700 i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-gray-700:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #5E6278 !important;\n}\n.text-hover-gray-700:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #5E6278 !important;\n}\n.text-hover-gray-700:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #5E6278;\n}\n.text-hover-gray-700:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-gray-700 {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-gray-700 i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-gray-700.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #5E6278 !important;\n}\n.text-active-gray-700.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #5E6278 !important;\n}\n.text-active-gray-700.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #5E6278;\n}\n.text-active-gray-700.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-gray-800 {\n  color: #3F4254 !important;\n}\n\n.text-hover-gray-800 {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-gray-800 i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-gray-800:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #3F4254 !important;\n}\n.text-hover-gray-800:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #3F4254 !important;\n}\n.text-hover-gray-800:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #3F4254;\n}\n.text-hover-gray-800:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-gray-800 {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-gray-800 i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-gray-800.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #3F4254 !important;\n}\n.text-active-gray-800.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #3F4254 !important;\n}\n.text-active-gray-800.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #3F4254;\n}\n.text-active-gray-800.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-gray-900 {\n  color: #181C32 !important;\n}\n\n.text-hover-gray-900 {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-gray-900 i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-hover-gray-900:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #181C32 !important;\n}\n.text-hover-gray-900:hover i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #181C32 !important;\n}\n.text-hover-gray-900:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #181C32;\n}\n.text-hover-gray-900:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.text-active-gray-900 {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-gray-900 i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.text-active-gray-900.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #181C32 !important;\n}\n.text-active-gray-900.active i {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #181C32 !important;\n}\n.text-active-gray-900.active .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #181C32;\n}\n.text-active-gray-900.active .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.fw-boldest {\n  font-weight: 700 !important;\n}\n\n.text-transparent {\n  color: transparent;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-default {\n  cursor: default;\n}\n\n.cursor-move {\n  cursor: move;\n}\n\ni {\n  line-height: 1;\n  font-size: 1rem;\n  color: #A1A5B7;\n}\n\na {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\na:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n\n.opacity-active-0.active {\n  opacity: 0 !important;\n}\n\n.opacity-state-0:hover, .opacity-state-0.active {\n  opacity: 0 !important;\n}\n\n.opacity-active-5.active {\n  opacity: 0.05 !important;\n}\n\n.opacity-state-5:hover, .opacity-state-5.active {\n  opacity: 0.05 !important;\n}\n\n.opacity-active-10.active {\n  opacity: 0.1 !important;\n}\n\n.opacity-state-10:hover, .opacity-state-10.active {\n  opacity: 0.1 !important;\n}\n\n.opacity-active-15.active {\n  opacity: 0.15 !important;\n}\n\n.opacity-state-15:hover, .opacity-state-15.active {\n  opacity: 0.15 !important;\n}\n\n.opacity-active-20.active {\n  opacity: 0.2 !important;\n}\n\n.opacity-state-20:hover, .opacity-state-20.active {\n  opacity: 0.2 !important;\n}\n\n.opacity-active-25.active {\n  opacity: 0.25 !important;\n}\n\n.opacity-state-25:hover, .opacity-state-25.active {\n  opacity: 0.25 !important;\n}\n\n.opacity-active-50.active {\n  opacity: 0.5 !important;\n}\n\n.opacity-state-50:hover, .opacity-state-50.active {\n  opacity: 0.5 !important;\n}\n\n.opacity-active-75.active {\n  opacity: 0.75 !important;\n}\n\n.opacity-state-75:hover, .opacity-state-75.active {\n  opacity: 0.75 !important;\n}\n\n.opacity-active-100.active {\n  opacity: 1 !important;\n}\n\n.opacity-state-100:hover, .opacity-state-100.active {\n  opacity: 1 !important;\n}\n\n.transform-90 {\n  transform: rotate(90deg);\n  transform-origin: right top;\n}\n\n.animation {\n  animation-duration: 1s;\n  animation-fill-mode: both;\n}\n\n@keyframes animationSlideInDown {\n  from {\n    transform: translate3d(0, -100%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n.animation-slide-in-down {\n  animation-name: animationSlideInDown;\n}\n\n@keyframes animationSlideInUp {\n  from {\n    transform: translate3d(0, 100%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n.animation-slide-in-up {\n  animation-name: animationSlideInUp;\n}\n\n@keyframes animationFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.animation-fade-in {\n  animation-name: animationFadeIn;\n}\n\n@keyframes animationFadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n.animation-fade-out {\n  animation-name: animationFadeOut;\n}\n\n.animation-blink {\n  animation: animationBlink 1s steps(5, start) infinite;\n}\n\n@keyframes animationBlink {\n  to {\n    visibility: hidden;\n  }\n}\n.nav-line-tabs {\n  border-bottom-width: 1px;\n  border-bottom-style: solid;\n  border-bottom-color: #EFF2F5;\n}\n.nav-line-tabs .nav-item {\n  margin-bottom: -1px;\n}\n.nav-line-tabs .nav-item .nav-link {\n  color: #A1A5B7;\n  border: 0;\n  border-bottom: 1px solid transparent;\n  transition: color 0.2s ease, background-color 0.2s ease;\n  padding: 0.5rem 0;\n  margin: 0 1rem;\n}\n.nav-line-tabs .nav-item:first-child .nav-link {\n  margin-left: 0;\n}\n.nav-line-tabs .nav-item:last-child .nav-link {\n  margin-right: 0;\n}\n.nav-line-tabs .nav-item .nav-link.active,\n.nav-line-tabs .nav-item.show .nav-link,\n.nav-line-tabs .nav-item .nav-link:hover:not(.disabled) {\n  background-color: transparent;\n  border: 0;\n  border-bottom: 1px solid #009EF7;\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.nav-line-tabs.nav-line-tabs-2x {\n  border-bottom-width: 2px;\n}\n.nav-line-tabs.nav-line-tabs-2x .nav-item {\n  margin-bottom: -2px;\n}\n.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link {\n  border-bottom-width: 2px;\n}\n.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link.active,\n.nav-line-tabs.nav-line-tabs-2x .nav-item.show .nav-link,\n.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link:hover:not(.disabled) {\n  border-bottom-width: 2px;\n}\n\n.nav-pills .nav-item {\n  margin-right: 0.5rem;\n}\n.nav-pills .nav-item:last-child {\n  margin-right: 0;\n}\n\n.nav-stretch {\n  align-items: stretch;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n.nav-stretch .nav-item {\n  display: flex;\n  align-items: stretch;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n.nav-stretch .nav-link {\n  display: flex;\n  align-items: center;\n}\n\n.nav-group {\n  padding: 0.35rem;\n  border-radius: 0.475rem;\n  background-color: #F5F8FA;\n}\n.nav-group.nav-group-outline {\n  background-color: transparent;\n  border: 1px solid #EFF2F5;\n}\n.nav-group.nav-group-fluid {\n  display: flex;\n}\n.nav-group.nav-group-fluid > label,\n.nav-group.nav-group-fluid > .btn {\n  position: relative;\n  flex-shrink: 0;\n  flex-grow: 1;\n  flex-basis: 0;\n}\n.nav-group.nav-group-fluid > label {\n  margin-right: 0.1rem;\n}\n.nav-group.nav-group-fluid > label > .btn {\n  width: 100%;\n}\n.nav-group.nav-group-fluid > label:last-child {\n  margin-right: 0;\n}\n\n.nav.nav-pills.nav-pills-custom .show > .nav-link,\n.nav.nav-pills.nav-pills-custom .nav-link {\n  border: 1px dashed #E4E6EF;\n  border-radius: 12px;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img,\n.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img {\n  width: 30px;\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img.default,\n.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img.default {\n  display: inline-block;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img.active,\n.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img.active {\n  display: none;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link.active,\n.nav.nav-pills.nav-pills-custom .nav-link.active {\n  background-color: transparent;\n  border: 1px solid #E4E6EF;\n  transition-duration: 1ms;\n  position: relative;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link.active .nav-text,\n.nav.nav-pills.nav-pills-custom .nav-link.active .nav-text {\n  color: #3F4254 !important;\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link.active .bullet-custom,\n.nav.nav-pills.nav-pills-custom .nav-link.active .bullet-custom {\n  display: block;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link .bullet-custom,\n.nav.nav-pills.nav-pills-custom .nav-link .bullet-custom {\n  display: none;\n}\n\n.pagination {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin: 0;\n}\n.pagination.pagination-circle .page-link {\n  border-radius: 50%;\n}\n.pagination.pagination-outline .page-link {\n  border: 1px solid #EFF2F5;\n}\n.pagination.pagination-outline .page-item:hover .page-link, .pagination.pagination-outline .page-item.active .page-link {\n  border-color: #F1FAFF;\n}\n\n.page-item {\n  margin-right: 0.5rem;\n  /*rtl:options:{\"autoRename\":false}*/\n  /*rtl:end:ignore*/\n}\n.page-item:last-child {\n  margin-right: 0;\n}\n.page-item .page-link {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 0.475rem;\n  height: 2.5rem;\n  min-width: 2.5rem;\n  font-weight: 500;\n  font-size: 1.075rem;\n  /*rtl:options:{\"autoRename\":false}*/\n  /*rtl:end:ignore*/\n  /*rtl:options:{\"autoRename\":false}*/\n}\n.page-item .page-link i {\n  font-size: 0.85rem;\n}\n.page-item .page-link .previous,\n.page-item .page-link .next {\n  display: block;\n  height: 0.875rem;\n  width: 0.875rem;\n  /*rtl:raw:transform: rotateZ(-180deg);*/\n}\n.page-item .page-link .previous {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%235E6278'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n}\n.page-item .page-link .next {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%235E6278'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n}\n.page-item.next .page-link, .page-item.previous .page-link {\n  background-color: #ffffff;\n}\n.page-item.next .page-link i, .page-item.previous .page-link i {\n  color: #5E6278;\n}\n.page-item.next .page-link .svg-icon svg [fill]:not(.permanent):not(g), .page-item.previous .page-link .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #5E6278;\n}\n.page-item.next .page-link .svg-icon svg:hover [fill]:not(.permanent):not(g), .page-item.previous .page-link .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.page-item:focus .page-link {\n  /*rtl:options:{\"autoRename\":false}*/\n}\n.page-item:focus .page-link i {\n  color: #009EF7;\n}\n.page-item:focus .page-link .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.page-item:focus .page-link .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.page-item:focus .page-link .previous {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n}\n.page-item:focus .page-link .next {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n}\n.page-item:hover .page-link {\n  /*rtl:options:{\"autoRename\":false}*/\n}\n.page-item:hover .page-link i {\n  color: #009EF7;\n}\n.page-item:hover .page-link .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.page-item:hover .page-link .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.page-item:hover .page-link .previous {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n}\n.page-item:hover .page-link .next {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n}\n.page-item.active .page-link {\n  /*rtl:options:{\"autoRename\":false}*/\n}\n.page-item.active .page-link i {\n  color: #FFFFFF;\n}\n.page-item.active .page-link .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.page-item.active .page-link .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.page-item.active .page-link .previous {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23FFFFFF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n}\n.page-item.active .page-link .next {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23FFFFFF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n}\n.page-item.disabled .page-link {\n  /*rtl:options:{\"autoRename\":false}*/\n}\n.page-item.disabled .page-link i {\n  color: #B5B5C3;\n}\n.page-item.disabled .page-link .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #B5B5C3;\n}\n.page-item.disabled .page-link .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.page-item.disabled .page-link .previous {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23B5B5C3'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n}\n.page-item.disabled .page-link .next {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23B5B5C3'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n}\n\n@media (max-width: 991.98px) {\n  .page-item {\n    margin-right: 0.25rem;\n  }\n  .page-item:last-child {\n    margin-right: 0;\n  }\n}\n.separator {\n  display: block;\n  height: 0;\n  border-bottom: 1px solid #EFF2F5;\n}\n.separator.separator-dotted {\n  border-bottom-style: dotted;\n  border-bottom-color: #E4E6EF;\n}\n.separator.separator-dashed {\n  border-bottom-style: dashed;\n  border-bottom-color: #E4E6EF;\n}\n.separator.separator-content {\n  display: flex;\n  align-items: center;\n  border-bottom: 0;\n  text-align: center;\n}\n.separator.separator-content::before, .separator.separator-content::after {\n  content: \" \";\n  width: 50%;\n  border-bottom: 1px solid #EFF2F5;\n}\n.separator.separator-content::before {\n  margin-right: 1.25rem;\n}\n.separator.separator-content::after {\n  margin-left: 1.25rem;\n}\n.separator.separator-content.separator-dotted::before, .separator.separator-content.separator-dotted::after {\n  border-bottom-style: dotted;\n  border-bottom-color: #E4E6EF;\n}\n.separator.separator-content.separator-dashed::before, .separator.separator-content.separator-dashed::after {\n  border-bottom-style: dashed;\n  border-bottom-color: #E4E6EF;\n}\n.separator.separator-content.border-white::before, .separator.separator-content.border-white::after {\n  border-color: #ffffff !important;\n}\n.separator.separator-content.border-light::before, .separator.separator-content.border-light::after {\n  border-color: #F5F8FA !important;\n}\n.separator.separator-content.border-primary::before, .separator.separator-content.border-primary::after {\n  border-color: #009EF7 !important;\n}\n.separator.separator-content.border-secondary::before, .separator.separator-content.border-secondary::after {\n  border-color: #E4E6EF !important;\n}\n.separator.separator-content.border-success::before, .separator.separator-content.border-success::after {\n  border-color: #50CD89 !important;\n}\n.separator.separator-content.border-info::before, .separator.separator-content.border-info::after {\n  border-color: #7239EA !important;\n}\n.separator.separator-content.border-warning::before, .separator.separator-content.border-warning::after {\n  border-color: #FFC700 !important;\n}\n.separator.separator-content.border-danger::before, .separator.separator-content.border-danger::after {\n  border-color: #F1416C !important;\n}\n.separator.separator-content.border-dark::before, .separator.separator-content.border-dark::after {\n  border-color: #181C32 !important;\n}\n\n.carousel.carousel-custom .carousel-indicators {\n  align-items: center;\n  position: static;\n  z-index: auto;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.carousel.carousel-custom .carousel-indicators li {\n  transform: none;\n  opacity: 1;\n}\n.carousel.carousel-custom .carousel-indicators li.active {\n  transform: none;\n  opacity: 1;\n}\n.carousel.carousel-custom .carousel-indicators.carousel-indicators-dots li {\n  border-radius: 0;\n  background-color: transparent;\n  height: 13px;\n  width: 13px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n.carousel.carousel-custom .carousel-indicators.carousel-indicators-dots li:after {\n  display: inline-block;\n  content: \" \";\n  border-radius: 50%;\n  transition: all 0.3s ease;\n  background-color: #EFF2F5;\n  height: 9px;\n  width: 9px;\n}\n.carousel.carousel-custom .carousel-indicators.carousel-indicators-dots li.active {\n  background-color: transparent;\n}\n.carousel.carousel-custom .carousel-indicators.carousel-indicators-dots li.active:after {\n  transition: all 0.3s ease;\n  height: 13px;\n  width: 13px;\n  background-color: #E4E6EF;\n}\n.carousel.carousel-custom.carousel-stretch {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.carousel.carousel-custom.carousel-stretch .carousel-inner {\n  flex-grow: 1;\n}\n.carousel.carousel-custom.carousel-stretch .carousel-item {\n  height: 100%;\n}\n.carousel.carousel-custom.carousel-stretch .carousel-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.menu-group {\n  display: flex;\n}\n\n.menu,\n.menu-wrapper {\n  display: flex;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.menu-sub {\n  display: none;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  flex-direction: column;\n}\n\n.menu-item {\n  display: block;\n  padding: 0;\n}\n.menu-item .menu-link {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  padding: 0;\n  flex: 0 0 100%;\n  padding: 0.65rem 1rem;\n  transition: none;\n  outline: none !important;\n}\n.menu-item .menu-link .menu-icon {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  margin-right: 0.5rem;\n}\n.menu-item .menu-link .menu-icon .svg-icon {\n  line-height: 1;\n}\n.menu-item .menu-link .menu-bullet {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.25rem;\n  margin-right: 0.5rem;\n}\n.menu-item .menu-link .menu-title {\n  display: flex;\n  align-items: center;\n  flex-grow: 1;\n}\n.menu-item .menu-link .menu-badge {\n  flex-shrink: 0;\n  margin-left: 0.5rem;\n}\n.menu-item .menu-link .menu-arrow {\n  display: flex;\n  align-items: stretch;\n  position: relative;\n  overflow: hidden;\n  flex-shrink: 0;\n  margin-left: 0.5rem;\n  width: 0.8rem;\n  height: 0.8rem;\n}\n.menu-item .menu-link .menu-arrow:after {\n  display: block;\n  width: 100%;\n  content: \" \";\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23A1A5B7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23A1A5B7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-item .menu-content {\n  padding: 0.65rem 1rem;\n}\n\n.menu-item.show .menu-link .menu-arrow:after {\n  -webkit-backface-visibility: hidden;\n  transition: transform 0.3s ease;\n}\n\n.menu-center {\n  justify-content: center;\n}\n\n.menu-item.menu-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n  /*rtl:ignore*/\n  transform: rotateZ(90deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .menu-item.menu-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, [direction=rtl] .menu-item.menu-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n  /*rtl:ignore*/\n  transform: rotateZ(-90deg);\n}\n\n.menu-sub-dropdown {\n  display: none;\n  border-radius: 0.475rem;\n  background-color: #ffffff;\n  box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  z-index: 105;\n}\n.show.menu-dropdown > .menu-sub-dropdown, .menu-sub-dropdown.menu.show, .menu-sub-dropdown.show[data-popper-placement] {\n  display: flex;\n  animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n}\n.show.menu-dropdown > .menu-sub-dropdown[data-popper-placement=top], .show.menu-dropdown > .menu-sub-dropdown[data-popper-placement=top-start], .show.menu-dropdown > .menu-sub-dropdown[data-popper-placement=top-end], .menu-sub-dropdown.menu.show[data-popper-placement=top], .menu-sub-dropdown.menu.show[data-popper-placement=top-start], .menu-sub-dropdown.menu.show[data-popper-placement=top-end], .menu-sub-dropdown.show[data-popper-placement][data-popper-placement=top], .menu-sub-dropdown.show[data-popper-placement][data-popper-placement=top-start], .menu-sub-dropdown.show[data-popper-placement][data-popper-placement=top-end] {\n  animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-down 0.3s ease 1;\n}\n\n.menu-sub-accordion {\n  display: none;\n}\n.show:not(.menu-dropdown) > .menu-sub-accordion, .menu-sub-accordion.show {\n  display: flex;\n}\n\n.menu-inline {\n  display: flex;\n}\n\n.menu-fit > .menu-item > .menu-content,\n.menu-fit > .menu-item > .menu-link {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.menu-column {\n  flex-direction: column;\n  width: 100%;\n}\n\n.menu-row {\n  flex-direction: row;\n}\n.menu-row > .menu-item {\n  display: flex;\n  align-items: center;\n}\n.menu-row > .menu-item > .menu-link .menu-arrow:after {\n  /*rtl:ignore*/\n  transform: rotateZ(90deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .menu-row > .menu-item > .menu-link .menu-arrow:after {\n  /*rtl:ignore*/\n  transform: rotateZ(-90deg);\n}\n\n.menu-rounded .menu-link {\n  border-radius: 0.475rem;\n}\n\n.menu-pill .menu-link {\n  border-radius: 50px;\n}\n\n.menu-rounded-0 .menu-link {\n  border-radius: 0 !important;\n}\n\n@media (min-width: 576px) {\n  .menu-item.menu-sm-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-sm-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  [direction=rtl] .menu-item.menu-sm-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, [direction=rtl] .menu-item.menu-sm-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n  }\n\n  .menu-sub-sm-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: #ffffff;\n    box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n    z-index: 105;\n  }\n  .show.menu-dropdown > .menu-sub-sm-dropdown, .menu-sub-sm-dropdown.menu.show, .menu-sub-sm-dropdown.show[data-popper-placement] {\n    display: flex;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .show.menu-dropdown > .menu-sub-sm-dropdown[data-popper-placement=top], .show.menu-dropdown > .menu-sub-sm-dropdown[data-popper-placement=top-start], .show.menu-dropdown > .menu-sub-sm-dropdown[data-popper-placement=top-end], .menu-sub-sm-dropdown.menu.show[data-popper-placement=top], .menu-sub-sm-dropdown.menu.show[data-popper-placement=top-start], .menu-sub-sm-dropdown.menu.show[data-popper-placement=top-end], .menu-sub-sm-dropdown.show[data-popper-placement][data-popper-placement=top], .menu-sub-sm-dropdown.show[data-popper-placement][data-popper-placement=top-start], .menu-sub-sm-dropdown.show[data-popper-placement][data-popper-placement=top-end] {\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-down 0.3s ease 1;\n  }\n\n  .menu-sub-sm-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-sm-accordion, .menu-sub-sm-accordion.show {\n    display: flex;\n  }\n\n  .menu-sm-inline {\n    display: flex;\n  }\n\n  .menu-sm-fit > .menu-item > .menu-content,\n.menu-sm-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .menu-sm-column {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .menu-sm-row {\n    flex-direction: row;\n  }\n  .menu-sm-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-sm-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  [direction=rtl] .menu-sm-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n  }\n\n  .menu-sm-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n\n  .menu-sm-pill .menu-link {\n    border-radius: 50px;\n  }\n\n  .menu-sm-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (min-width: 768px) {\n  .menu-item.menu-md-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-md-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  [direction=rtl] .menu-item.menu-md-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, [direction=rtl] .menu-item.menu-md-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n  }\n\n  .menu-sub-md-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: #ffffff;\n    box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n    z-index: 105;\n  }\n  .show.menu-dropdown > .menu-sub-md-dropdown, .menu-sub-md-dropdown.menu.show, .menu-sub-md-dropdown.show[data-popper-placement] {\n    display: flex;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .show.menu-dropdown > .menu-sub-md-dropdown[data-popper-placement=top], .show.menu-dropdown > .menu-sub-md-dropdown[data-popper-placement=top-start], .show.menu-dropdown > .menu-sub-md-dropdown[data-popper-placement=top-end], .menu-sub-md-dropdown.menu.show[data-popper-placement=top], .menu-sub-md-dropdown.menu.show[data-popper-placement=top-start], .menu-sub-md-dropdown.menu.show[data-popper-placement=top-end], .menu-sub-md-dropdown.show[data-popper-placement][data-popper-placement=top], .menu-sub-md-dropdown.show[data-popper-placement][data-popper-placement=top-start], .menu-sub-md-dropdown.show[data-popper-placement][data-popper-placement=top-end] {\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-down 0.3s ease 1;\n  }\n\n  .menu-sub-md-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-md-accordion, .menu-sub-md-accordion.show {\n    display: flex;\n  }\n\n  .menu-md-inline {\n    display: flex;\n  }\n\n  .menu-md-fit > .menu-item > .menu-content,\n.menu-md-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .menu-md-column {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .menu-md-row {\n    flex-direction: row;\n  }\n  .menu-md-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-md-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  [direction=rtl] .menu-md-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n  }\n\n  .menu-md-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n\n  .menu-md-pill .menu-link {\n    border-radius: 50px;\n  }\n\n  .menu-md-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (min-width: 992px) {\n  .menu-item.menu-lg-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-lg-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  [direction=rtl] .menu-item.menu-lg-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, [direction=rtl] .menu-item.menu-lg-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n  }\n\n  .menu-sub-lg-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: #ffffff;\n    box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n    z-index: 105;\n  }\n  .show.menu-dropdown > .menu-sub-lg-dropdown, .menu-sub-lg-dropdown.menu.show, .menu-sub-lg-dropdown.show[data-popper-placement] {\n    display: flex;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .show.menu-dropdown > .menu-sub-lg-dropdown[data-popper-placement=top], .show.menu-dropdown > .menu-sub-lg-dropdown[data-popper-placement=top-start], .show.menu-dropdown > .menu-sub-lg-dropdown[data-popper-placement=top-end], .menu-sub-lg-dropdown.menu.show[data-popper-placement=top], .menu-sub-lg-dropdown.menu.show[data-popper-placement=top-start], .menu-sub-lg-dropdown.menu.show[data-popper-placement=top-end], .menu-sub-lg-dropdown.show[data-popper-placement][data-popper-placement=top], .menu-sub-lg-dropdown.show[data-popper-placement][data-popper-placement=top-start], .menu-sub-lg-dropdown.show[data-popper-placement][data-popper-placement=top-end] {\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-down 0.3s ease 1;\n  }\n\n  .menu-sub-lg-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-lg-accordion, .menu-sub-lg-accordion.show {\n    display: flex;\n  }\n\n  .menu-lg-inline {\n    display: flex;\n  }\n\n  .menu-lg-fit > .menu-item > .menu-content,\n.menu-lg-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .menu-lg-column {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .menu-lg-row {\n    flex-direction: row;\n  }\n  .menu-lg-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-lg-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  [direction=rtl] .menu-lg-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n  }\n\n  .menu-lg-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n\n  .menu-lg-pill .menu-link {\n    border-radius: 50px;\n  }\n\n  .menu-lg-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (min-width: 1200px) {\n  .menu-item.menu-xl-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xl-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  [direction=rtl] .menu-item.menu-xl-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, [direction=rtl] .menu-item.menu-xl-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n  }\n\n  .menu-sub-xl-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: #ffffff;\n    box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n    z-index: 105;\n  }\n  .show.menu-dropdown > .menu-sub-xl-dropdown, .menu-sub-xl-dropdown.menu.show, .menu-sub-xl-dropdown.show[data-popper-placement] {\n    display: flex;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .show.menu-dropdown > .menu-sub-xl-dropdown[data-popper-placement=top], .show.menu-dropdown > .menu-sub-xl-dropdown[data-popper-placement=top-start], .show.menu-dropdown > .menu-sub-xl-dropdown[data-popper-placement=top-end], .menu-sub-xl-dropdown.menu.show[data-popper-placement=top], .menu-sub-xl-dropdown.menu.show[data-popper-placement=top-start], .menu-sub-xl-dropdown.menu.show[data-popper-placement=top-end], .menu-sub-xl-dropdown.show[data-popper-placement][data-popper-placement=top], .menu-sub-xl-dropdown.show[data-popper-placement][data-popper-placement=top-start], .menu-sub-xl-dropdown.show[data-popper-placement][data-popper-placement=top-end] {\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-down 0.3s ease 1;\n  }\n\n  .menu-sub-xl-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-xl-accordion, .menu-sub-xl-accordion.show {\n    display: flex;\n  }\n\n  .menu-xl-inline {\n    display: flex;\n  }\n\n  .menu-xl-fit > .menu-item > .menu-content,\n.menu-xl-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .menu-xl-column {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .menu-xl-row {\n    flex-direction: row;\n  }\n  .menu-xl-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-xl-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  [direction=rtl] .menu-xl-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n  }\n\n  .menu-xl-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n\n  .menu-xl-pill .menu-link {\n    border-radius: 50px;\n  }\n\n  .menu-xl-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (min-width: 1400px) {\n  .menu-item.menu-xxl-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xxl-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  [direction=rtl] .menu-item.menu-xxl-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, [direction=rtl] .menu-item.menu-xxl-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n  }\n\n  .menu-sub-xxl-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: #ffffff;\n    box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n    z-index: 105;\n  }\n  .show.menu-dropdown > .menu-sub-xxl-dropdown, .menu-sub-xxl-dropdown.menu.show, .menu-sub-xxl-dropdown.show[data-popper-placement] {\n    display: flex;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .show.menu-dropdown > .menu-sub-xxl-dropdown[data-popper-placement=top], .show.menu-dropdown > .menu-sub-xxl-dropdown[data-popper-placement=top-start], .show.menu-dropdown > .menu-sub-xxl-dropdown[data-popper-placement=top-end], .menu-sub-xxl-dropdown.menu.show[data-popper-placement=top], .menu-sub-xxl-dropdown.menu.show[data-popper-placement=top-start], .menu-sub-xxl-dropdown.menu.show[data-popper-placement=top-end], .menu-sub-xxl-dropdown.show[data-popper-placement][data-popper-placement=top], .menu-sub-xxl-dropdown.show[data-popper-placement][data-popper-placement=top-start], .menu-sub-xxl-dropdown.show[data-popper-placement][data-popper-placement=top-end] {\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-down 0.3s ease 1;\n  }\n\n  .menu-sub-xxl-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-xxl-accordion, .menu-sub-xxl-accordion.show {\n    display: flex;\n  }\n\n  .menu-xxl-inline {\n    display: flex;\n  }\n\n  .menu-xxl-fit > .menu-item > .menu-content,\n.menu-xxl-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .menu-xxl-column {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .menu-xxl-row {\n    flex-direction: row;\n  }\n  .menu-xxl-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-xxl-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  [direction=rtl] .menu-xxl-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n  }\n\n  .menu-xxl-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n\n  .menu-xxl-pill .menu-link {\n    border-radius: 50px;\n  }\n\n  .menu-xxl-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (max-width: 575.98px) {\n  .menu-item.menu-sm-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-sm-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  [direction=rtl] .menu-item.menu-sm-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, [direction=rtl] .menu-item.menu-sm-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n  }\n\n  .menu-sub-sm-down-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: #ffffff;\n    box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n    z-index: 105;\n  }\n  .show.menu-dropdown > .menu-sub-sm-down-dropdown, .menu-sub-sm-down-dropdown.menu.show, .menu-sub-sm-down-dropdown.show[data-popper-placement] {\n    display: flex;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .show.menu-dropdown > .menu-sub-sm-down-dropdown[data-popper-placement=top], .show.menu-dropdown > .menu-sub-sm-down-dropdown[data-popper-placement=top-start], .show.menu-dropdown > .menu-sub-sm-down-dropdown[data-popper-placement=top-end], .menu-sub-sm-down-dropdown.menu.show[data-popper-placement=top], .menu-sub-sm-down-dropdown.menu.show[data-popper-placement=top-start], .menu-sub-sm-down-dropdown.menu.show[data-popper-placement=top-end], .menu-sub-sm-down-dropdown.show[data-popper-placement][data-popper-placement=top], .menu-sub-sm-down-dropdown.show[data-popper-placement][data-popper-placement=top-start], .menu-sub-sm-down-dropdown.show[data-popper-placement][data-popper-placement=top-end] {\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-down 0.3s ease 1;\n  }\n\n  .menu-sub-sm-down-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-sm-down-accordion, .menu-sub-sm-down-accordion.show {\n    display: flex;\n  }\n\n  .menu-sm-down-inline {\n    display: flex;\n  }\n\n  .menu-sm-down-fit > .menu-item > .menu-content,\n.menu-sm-down-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .menu-sm-down-column {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .menu-sm-down-row {\n    flex-direction: row;\n  }\n  .menu-sm-down-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-sm-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  [direction=rtl] .menu-sm-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n  }\n\n  .menu-sm-down-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n\n  .menu-sm-down-pill .menu-link {\n    border-radius: 50px;\n  }\n\n  .menu-sm-down-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (max-width: 767.98px) {\n  .menu-item.menu-md-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-md-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  [direction=rtl] .menu-item.menu-md-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, [direction=rtl] .menu-item.menu-md-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n  }\n\n  .menu-sub-md-down-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: #ffffff;\n    box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n    z-index: 105;\n  }\n  .show.menu-dropdown > .menu-sub-md-down-dropdown, .menu-sub-md-down-dropdown.menu.show, .menu-sub-md-down-dropdown.show[data-popper-placement] {\n    display: flex;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .show.menu-dropdown > .menu-sub-md-down-dropdown[data-popper-placement=top], .show.menu-dropdown > .menu-sub-md-down-dropdown[data-popper-placement=top-start], .show.menu-dropdown > .menu-sub-md-down-dropdown[data-popper-placement=top-end], .menu-sub-md-down-dropdown.menu.show[data-popper-placement=top], .menu-sub-md-down-dropdown.menu.show[data-popper-placement=top-start], .menu-sub-md-down-dropdown.menu.show[data-popper-placement=top-end], .menu-sub-md-down-dropdown.show[data-popper-placement][data-popper-placement=top], .menu-sub-md-down-dropdown.show[data-popper-placement][data-popper-placement=top-start], .menu-sub-md-down-dropdown.show[data-popper-placement][data-popper-placement=top-end] {\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-down 0.3s ease 1;\n  }\n\n  .menu-sub-md-down-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-md-down-accordion, .menu-sub-md-down-accordion.show {\n    display: flex;\n  }\n\n  .menu-md-down-inline {\n    display: flex;\n  }\n\n  .menu-md-down-fit > .menu-item > .menu-content,\n.menu-md-down-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .menu-md-down-column {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .menu-md-down-row {\n    flex-direction: row;\n  }\n  .menu-md-down-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-md-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  [direction=rtl] .menu-md-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n  }\n\n  .menu-md-down-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n\n  .menu-md-down-pill .menu-link {\n    border-radius: 50px;\n  }\n\n  .menu-md-down-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (max-width: 991.98px) {\n  .menu-item.menu-lg-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-lg-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  [direction=rtl] .menu-item.menu-lg-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, [direction=rtl] .menu-item.menu-lg-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n  }\n\n  .menu-sub-lg-down-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: #ffffff;\n    box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n    z-index: 105;\n  }\n  .show.menu-dropdown > .menu-sub-lg-down-dropdown, .menu-sub-lg-down-dropdown.menu.show, .menu-sub-lg-down-dropdown.show[data-popper-placement] {\n    display: flex;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .show.menu-dropdown > .menu-sub-lg-down-dropdown[data-popper-placement=top], .show.menu-dropdown > .menu-sub-lg-down-dropdown[data-popper-placement=top-start], .show.menu-dropdown > .menu-sub-lg-down-dropdown[data-popper-placement=top-end], .menu-sub-lg-down-dropdown.menu.show[data-popper-placement=top], .menu-sub-lg-down-dropdown.menu.show[data-popper-placement=top-start], .menu-sub-lg-down-dropdown.menu.show[data-popper-placement=top-end], .menu-sub-lg-down-dropdown.show[data-popper-placement][data-popper-placement=top], .menu-sub-lg-down-dropdown.show[data-popper-placement][data-popper-placement=top-start], .menu-sub-lg-down-dropdown.show[data-popper-placement][data-popper-placement=top-end] {\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-down 0.3s ease 1;\n  }\n\n  .menu-sub-lg-down-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-lg-down-accordion, .menu-sub-lg-down-accordion.show {\n    display: flex;\n  }\n\n  .menu-lg-down-inline {\n    display: flex;\n  }\n\n  .menu-lg-down-fit > .menu-item > .menu-content,\n.menu-lg-down-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .menu-lg-down-column {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .menu-lg-down-row {\n    flex-direction: row;\n  }\n  .menu-lg-down-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-lg-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  [direction=rtl] .menu-lg-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n  }\n\n  .menu-lg-down-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n\n  .menu-lg-down-pill .menu-link {\n    border-radius: 50px;\n  }\n\n  .menu-lg-down-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (max-width: 1199.98px) {\n  .menu-item.menu-xl-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xl-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  [direction=rtl] .menu-item.menu-xl-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, [direction=rtl] .menu-item.menu-xl-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n  }\n\n  .menu-sub-xl-down-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: #ffffff;\n    box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n    z-index: 105;\n  }\n  .show.menu-dropdown > .menu-sub-xl-down-dropdown, .menu-sub-xl-down-dropdown.menu.show, .menu-sub-xl-down-dropdown.show[data-popper-placement] {\n    display: flex;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .show.menu-dropdown > .menu-sub-xl-down-dropdown[data-popper-placement=top], .show.menu-dropdown > .menu-sub-xl-down-dropdown[data-popper-placement=top-start], .show.menu-dropdown > .menu-sub-xl-down-dropdown[data-popper-placement=top-end], .menu-sub-xl-down-dropdown.menu.show[data-popper-placement=top], .menu-sub-xl-down-dropdown.menu.show[data-popper-placement=top-start], .menu-sub-xl-down-dropdown.menu.show[data-popper-placement=top-end], .menu-sub-xl-down-dropdown.show[data-popper-placement][data-popper-placement=top], .menu-sub-xl-down-dropdown.show[data-popper-placement][data-popper-placement=top-start], .menu-sub-xl-down-dropdown.show[data-popper-placement][data-popper-placement=top-end] {\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-down 0.3s ease 1;\n  }\n\n  .menu-sub-xl-down-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-xl-down-accordion, .menu-sub-xl-down-accordion.show {\n    display: flex;\n  }\n\n  .menu-xl-down-inline {\n    display: flex;\n  }\n\n  .menu-xl-down-fit > .menu-item > .menu-content,\n.menu-xl-down-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .menu-xl-down-column {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .menu-xl-down-row {\n    flex-direction: row;\n  }\n  .menu-xl-down-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-xl-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  [direction=rtl] .menu-xl-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n  }\n\n  .menu-xl-down-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n\n  .menu-xl-down-pill .menu-link {\n    border-radius: 50px;\n  }\n\n  .menu-xl-down-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (max-width: 1399.98px) {\n  .menu-item.menu-xxl-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xxl-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  [direction=rtl] .menu-item.menu-xxl-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, [direction=rtl] .menu-item.menu-xxl-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n  }\n\n  .menu-sub-xxl-down-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: #ffffff;\n    box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n    z-index: 105;\n  }\n  .show.menu-dropdown > .menu-sub-xxl-down-dropdown, .menu-sub-xxl-down-dropdown.menu.show, .menu-sub-xxl-down-dropdown.show[data-popper-placement] {\n    display: flex;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .show.menu-dropdown > .menu-sub-xxl-down-dropdown[data-popper-placement=top], .show.menu-dropdown > .menu-sub-xxl-down-dropdown[data-popper-placement=top-start], .show.menu-dropdown > .menu-sub-xxl-down-dropdown[data-popper-placement=top-end], .menu-sub-xxl-down-dropdown.menu.show[data-popper-placement=top], .menu-sub-xxl-down-dropdown.menu.show[data-popper-placement=top-start], .menu-sub-xxl-down-dropdown.menu.show[data-popper-placement=top-end], .menu-sub-xxl-down-dropdown.show[data-popper-placement][data-popper-placement=top], .menu-sub-xxl-down-dropdown.show[data-popper-placement][data-popper-placement=top-start], .menu-sub-xxl-down-dropdown.show[data-popper-placement][data-popper-placement=top-end] {\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-down 0.3s ease 1;\n  }\n\n  .menu-sub-xxl-down-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-xxl-down-accordion, .menu-sub-xxl-down-accordion.show {\n    display: flex;\n  }\n\n  .menu-xxl-down-inline {\n    display: flex;\n  }\n\n  .menu-xxl-down-fit > .menu-item > .menu-content,\n.menu-xxl-down-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .menu-xxl-down-column {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .menu-xxl-down-row {\n    flex-direction: row;\n  }\n  .menu-xxl-down-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-xxl-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  [direction=rtl] .menu-xxl-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n  }\n\n  .menu-xxl-down-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n\n  .menu-xxl-down-pill .menu-link {\n    border-radius: 50px;\n  }\n\n  .menu-xxl-down-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n.menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: calc(1rem + 1rem);\n}\n.menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: calc(2rem + 1rem);\n}\n.menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: calc(3rem + 1rem);\n}\n.menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: calc(4rem + 1rem);\n}\n.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: 1rem;\n  padding-right: 0;\n}\n.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: calc(2rem);\n  padding-right: 0;\n}\n.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: calc(3rem);\n  padding-right: 0;\n}\n.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: calc(4rem);\n  padding-right: 0;\n}\n\n@keyframes menu-sub-dropdown-animation-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes menu-sub-dropdown-animation-move-up {\n  from {\n    margin-top: 0.75rem;\n  }\n  to {\n    margin-top: 0;\n  }\n}\n@keyframes menu-sub-dropdown-animation-move-down {\n  from {\n    margin-bottom: 0.75rem;\n  }\n  to {\n    margin-bottom: 0;\n  }\n}\n.menu-white .menu-item .menu-link {\n  color: #ffffff;\n}\n.menu-white .menu-item .menu-link .menu-title {\n  color: #ffffff;\n}\n.menu-white .menu-item .menu-link .menu-icon i {\n  color: #ffffff;\n}\n.menu-white .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.menu-white .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-white .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #ffffff;\n}\n.menu-white .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23ffffff'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23ffffff'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-white .menu-item .menu-link {\n  color: #ffffff;\n}\n.menu-title-white .menu-item .menu-link .menu-title {\n  color: #ffffff;\n}\n\n.menu-icon-white .menu-item .menu-link .menu-icon i {\n  color: #ffffff;\n}\n.menu-icon-white .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.menu-icon-white .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-bullet-white .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #ffffff;\n}\n\n.menu-arrow-white .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23ffffff'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23ffffff'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-primary .menu-item .menu-link {\n  color: #009EF7;\n}\n.menu-primary .menu-item .menu-link .menu-title {\n  color: #009EF7;\n}\n.menu-primary .menu-item .menu-link .menu-icon i {\n  color: #009EF7;\n}\n.menu-primary .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-primary .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-primary .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n.menu-primary .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-primary .menu-item .menu-link {\n  color: #009EF7;\n}\n.menu-title-primary .menu-item .menu-link .menu-title {\n  color: #009EF7;\n}\n\n.menu-icon-primary .menu-item .menu-link .menu-icon i {\n  color: #009EF7;\n}\n.menu-icon-primary .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-icon-primary .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-bullet-primary .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n\n.menu-arrow-primary .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-secondary .menu-item .menu-link {\n  color: #E4E6EF;\n}\n.menu-secondary .menu-item .menu-link .menu-title {\n  color: #E4E6EF;\n}\n.menu-secondary .menu-item .menu-link .menu-icon i {\n  color: #E4E6EF;\n}\n.menu-secondary .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #E4E6EF;\n}\n.menu-secondary .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-secondary .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #E4E6EF;\n}\n.menu-secondary .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23E4E6EF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23E4E6EF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-secondary .menu-item .menu-link {\n  color: #E4E6EF;\n}\n.menu-title-secondary .menu-item .menu-link .menu-title {\n  color: #E4E6EF;\n}\n\n.menu-icon-secondary .menu-item .menu-link .menu-icon i {\n  color: #E4E6EF;\n}\n.menu-icon-secondary .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #E4E6EF;\n}\n.menu-icon-secondary .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-bullet-secondary .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #E4E6EF;\n}\n\n.menu-arrow-secondary .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23E4E6EF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23E4E6EF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-light .menu-item .menu-link {\n  color: #F5F8FA;\n}\n.menu-light .menu-item .menu-link .menu-title {\n  color: #F5F8FA;\n}\n.menu-light .menu-item .menu-link .menu-icon i {\n  color: #F5F8FA;\n}\n.menu-light .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F5F8FA;\n}\n.menu-light .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-light .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #F5F8FA;\n}\n.menu-light .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23F5F8FA'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23F5F8FA'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-light .menu-item .menu-link {\n  color: #F5F8FA;\n}\n.menu-title-light .menu-item .menu-link .menu-title {\n  color: #F5F8FA;\n}\n\n.menu-icon-light .menu-item .menu-link .menu-icon i {\n  color: #F5F8FA;\n}\n.menu-icon-light .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F5F8FA;\n}\n.menu-icon-light .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-bullet-light .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #F5F8FA;\n}\n\n.menu-arrow-light .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23F5F8FA'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23F5F8FA'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-success .menu-item .menu-link {\n  color: #50CD89;\n}\n.menu-success .menu-item .menu-link .menu-title {\n  color: #50CD89;\n}\n.menu-success .menu-item .menu-link .menu-icon i {\n  color: #50CD89;\n}\n.menu-success .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #50CD89;\n}\n.menu-success .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-success .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #50CD89;\n}\n.menu-success .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%2350CD89'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%2350CD89'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-success .menu-item .menu-link {\n  color: #50CD89;\n}\n.menu-title-success .menu-item .menu-link .menu-title {\n  color: #50CD89;\n}\n\n.menu-icon-success .menu-item .menu-link .menu-icon i {\n  color: #50CD89;\n}\n.menu-icon-success .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #50CD89;\n}\n.menu-icon-success .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-bullet-success .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #50CD89;\n}\n\n.menu-arrow-success .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%2350CD89'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%2350CD89'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-info .menu-item .menu-link {\n  color: #7239EA;\n}\n.menu-info .menu-item .menu-link .menu-title {\n  color: #7239EA;\n}\n.menu-info .menu-item .menu-link .menu-icon i {\n  color: #7239EA;\n}\n.menu-info .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7239EA;\n}\n.menu-info .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-info .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #7239EA;\n}\n.menu-info .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%237239EA'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%237239EA'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-info .menu-item .menu-link {\n  color: #7239EA;\n}\n.menu-title-info .menu-item .menu-link .menu-title {\n  color: #7239EA;\n}\n\n.menu-icon-info .menu-item .menu-link .menu-icon i {\n  color: #7239EA;\n}\n.menu-icon-info .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7239EA;\n}\n.menu-icon-info .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-bullet-info .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #7239EA;\n}\n\n.menu-arrow-info .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%237239EA'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%237239EA'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-warning .menu-item .menu-link {\n  color: #FFC700;\n}\n.menu-warning .menu-item .menu-link .menu-title {\n  color: #FFC700;\n}\n.menu-warning .menu-item .menu-link .menu-icon i {\n  color: #FFC700;\n}\n.menu-warning .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFC700;\n}\n.menu-warning .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-warning .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #FFC700;\n}\n.menu-warning .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23FFC700'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23FFC700'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-warning .menu-item .menu-link {\n  color: #FFC700;\n}\n.menu-title-warning .menu-item .menu-link .menu-title {\n  color: #FFC700;\n}\n\n.menu-icon-warning .menu-item .menu-link .menu-icon i {\n  color: #FFC700;\n}\n.menu-icon-warning .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFC700;\n}\n.menu-icon-warning .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-bullet-warning .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #FFC700;\n}\n\n.menu-arrow-warning .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23FFC700'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23FFC700'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-danger .menu-item .menu-link {\n  color: #F1416C;\n}\n.menu-danger .menu-item .menu-link .menu-title {\n  color: #F1416C;\n}\n.menu-danger .menu-item .menu-link .menu-icon i {\n  color: #F1416C;\n}\n.menu-danger .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F1416C;\n}\n.menu-danger .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-danger .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #F1416C;\n}\n.menu-danger .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23F1416C'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23F1416C'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-danger .menu-item .menu-link {\n  color: #F1416C;\n}\n.menu-title-danger .menu-item .menu-link .menu-title {\n  color: #F1416C;\n}\n\n.menu-icon-danger .menu-item .menu-link .menu-icon i {\n  color: #F1416C;\n}\n.menu-icon-danger .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F1416C;\n}\n.menu-icon-danger .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-bullet-danger .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #F1416C;\n}\n\n.menu-arrow-danger .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23F1416C'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23F1416C'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-dark .menu-item .menu-link {\n  color: #181C32;\n}\n.menu-dark .menu-item .menu-link .menu-title {\n  color: #181C32;\n}\n.menu-dark .menu-item .menu-link .menu-icon i {\n  color: #181C32;\n}\n.menu-dark .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #181C32;\n}\n.menu-dark .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-dark .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #181C32;\n}\n.menu-dark .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23181C32'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23181C32'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-dark .menu-item .menu-link {\n  color: #181C32;\n}\n.menu-title-dark .menu-item .menu-link .menu-title {\n  color: #181C32;\n}\n\n.menu-icon-dark .menu-item .menu-link .menu-icon i {\n  color: #181C32;\n}\n.menu-icon-dark .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #181C32;\n}\n.menu-icon-dark .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-bullet-dark .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #181C32;\n}\n\n.menu-arrow-dark .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23181C32'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23181C32'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-muted .menu-item .menu-link {\n  color: #A1A5B7;\n}\n.menu-muted .menu-item .menu-link .menu-title {\n  color: #A1A5B7;\n}\n.menu-muted .menu-item .menu-link .menu-icon i {\n  color: #A1A5B7;\n}\n.menu-muted .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #A1A5B7;\n}\n.menu-muted .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-muted .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #A1A5B7;\n}\n.menu-muted .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23A1A5B7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23A1A5B7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-muted .menu-item .menu-link {\n  color: #A1A5B7;\n}\n.menu-title-muted .menu-item .menu-link .menu-title {\n  color: #A1A5B7;\n}\n\n.menu-icon-muted .menu-item .menu-link .menu-icon i {\n  color: #A1A5B7;\n}\n.menu-icon-muted .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #A1A5B7;\n}\n.menu-icon-muted .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-bullet-muted .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #A1A5B7;\n}\n\n.menu-arrow-muted .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23A1A5B7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23A1A5B7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-100 .menu-item .menu-link {\n  color: #F5F8FA;\n}\n.menu-gray-100 .menu-item .menu-link .menu-title {\n  color: #F5F8FA;\n}\n.menu-gray-100 .menu-item .menu-link .menu-icon i {\n  color: #F5F8FA;\n}\n.menu-gray-100 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F5F8FA;\n}\n.menu-gray-100 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-gray-100 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #F5F8FA;\n}\n.menu-gray-100 .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23F5F8FA'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23F5F8FA'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-100 .menu-item .menu-link {\n  color: #F5F8FA;\n}\n.menu-title-gray-100 .menu-item .menu-link .menu-title {\n  color: #F5F8FA;\n}\n\n.menu-icon-gray-100 .menu-item .menu-link .menu-icon i {\n  color: #F5F8FA;\n}\n.menu-icon-gray-100 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F5F8FA;\n}\n.menu-icon-gray-100 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-bullet-gray-100 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #F5F8FA;\n}\n\n.menu-arrow-gray-100 .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23F5F8FA'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23F5F8FA'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-200 .menu-item .menu-link {\n  color: #EFF2F5;\n}\n.menu-gray-200 .menu-item .menu-link .menu-title {\n  color: #EFF2F5;\n}\n.menu-gray-200 .menu-item .menu-link .menu-icon i {\n  color: #EFF2F5;\n}\n.menu-gray-200 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #EFF2F5;\n}\n.menu-gray-200 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-gray-200 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #EFF2F5;\n}\n.menu-gray-200 .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23EFF2F5'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23EFF2F5'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-200 .menu-item .menu-link {\n  color: #EFF2F5;\n}\n.menu-title-gray-200 .menu-item .menu-link .menu-title {\n  color: #EFF2F5;\n}\n\n.menu-icon-gray-200 .menu-item .menu-link .menu-icon i {\n  color: #EFF2F5;\n}\n.menu-icon-gray-200 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #EFF2F5;\n}\n.menu-icon-gray-200 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-bullet-gray-200 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #EFF2F5;\n}\n\n.menu-arrow-gray-200 .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23EFF2F5'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23EFF2F5'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-300 .menu-item .menu-link {\n  color: #E4E6EF;\n}\n.menu-gray-300 .menu-item .menu-link .menu-title {\n  color: #E4E6EF;\n}\n.menu-gray-300 .menu-item .menu-link .menu-icon i {\n  color: #E4E6EF;\n}\n.menu-gray-300 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #E4E6EF;\n}\n.menu-gray-300 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-gray-300 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #E4E6EF;\n}\n.menu-gray-300 .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23E4E6EF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23E4E6EF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-300 .menu-item .menu-link {\n  color: #E4E6EF;\n}\n.menu-title-gray-300 .menu-item .menu-link .menu-title {\n  color: #E4E6EF;\n}\n\n.menu-icon-gray-300 .menu-item .menu-link .menu-icon i {\n  color: #E4E6EF;\n}\n.menu-icon-gray-300 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #E4E6EF;\n}\n.menu-icon-gray-300 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-bullet-gray-300 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #E4E6EF;\n}\n\n.menu-arrow-gray-300 .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23E4E6EF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23E4E6EF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-400 .menu-item .menu-link {\n  color: #B5B5C3;\n}\n.menu-gray-400 .menu-item .menu-link .menu-title {\n  color: #B5B5C3;\n}\n.menu-gray-400 .menu-item .menu-link .menu-icon i {\n  color: #B5B5C3;\n}\n.menu-gray-400 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #B5B5C3;\n}\n.menu-gray-400 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-gray-400 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #B5B5C3;\n}\n.menu-gray-400 .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23B5B5C3'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23B5B5C3'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-400 .menu-item .menu-link {\n  color: #B5B5C3;\n}\n.menu-title-gray-400 .menu-item .menu-link .menu-title {\n  color: #B5B5C3;\n}\n\n.menu-icon-gray-400 .menu-item .menu-link .menu-icon i {\n  color: #B5B5C3;\n}\n.menu-icon-gray-400 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #B5B5C3;\n}\n.menu-icon-gray-400 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-bullet-gray-400 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #B5B5C3;\n}\n\n.menu-arrow-gray-400 .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23B5B5C3'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23B5B5C3'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-500 .menu-item .menu-link {\n  color: #A1A5B7;\n}\n.menu-gray-500 .menu-item .menu-link .menu-title {\n  color: #A1A5B7;\n}\n.menu-gray-500 .menu-item .menu-link .menu-icon i {\n  color: #A1A5B7;\n}\n.menu-gray-500 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #A1A5B7;\n}\n.menu-gray-500 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-gray-500 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #A1A5B7;\n}\n.menu-gray-500 .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23A1A5B7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23A1A5B7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-500 .menu-item .menu-link {\n  color: #A1A5B7;\n}\n.menu-title-gray-500 .menu-item .menu-link .menu-title {\n  color: #A1A5B7;\n}\n\n.menu-icon-gray-500 .menu-item .menu-link .menu-icon i {\n  color: #A1A5B7;\n}\n.menu-icon-gray-500 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #A1A5B7;\n}\n.menu-icon-gray-500 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-bullet-gray-500 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #A1A5B7;\n}\n\n.menu-arrow-gray-500 .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23A1A5B7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23A1A5B7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-600 .menu-item .menu-link {\n  color: #7E8299;\n}\n.menu-gray-600 .menu-item .menu-link .menu-title {\n  color: #7E8299;\n}\n.menu-gray-600 .menu-item .menu-link .menu-icon i {\n  color: #7E8299;\n}\n.menu-gray-600 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7E8299;\n}\n.menu-gray-600 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-gray-600 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #7E8299;\n}\n.menu-gray-600 .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%237E8299'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%237E8299'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-600 .menu-item .menu-link {\n  color: #7E8299;\n}\n.menu-title-gray-600 .menu-item .menu-link .menu-title {\n  color: #7E8299;\n}\n\n.menu-icon-gray-600 .menu-item .menu-link .menu-icon i {\n  color: #7E8299;\n}\n.menu-icon-gray-600 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7E8299;\n}\n.menu-icon-gray-600 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-bullet-gray-600 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #7E8299;\n}\n\n.menu-arrow-gray-600 .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%237E8299'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%237E8299'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-700 .menu-item .menu-link {\n  color: #5E6278;\n}\n.menu-gray-700 .menu-item .menu-link .menu-title {\n  color: #5E6278;\n}\n.menu-gray-700 .menu-item .menu-link .menu-icon i {\n  color: #5E6278;\n}\n.menu-gray-700 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #5E6278;\n}\n.menu-gray-700 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-gray-700 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #5E6278;\n}\n.menu-gray-700 .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%235E6278'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%235E6278'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-700 .menu-item .menu-link {\n  color: #5E6278;\n}\n.menu-title-gray-700 .menu-item .menu-link .menu-title {\n  color: #5E6278;\n}\n\n.menu-icon-gray-700 .menu-item .menu-link .menu-icon i {\n  color: #5E6278;\n}\n.menu-icon-gray-700 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #5E6278;\n}\n.menu-icon-gray-700 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-bullet-gray-700 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #5E6278;\n}\n\n.menu-arrow-gray-700 .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%235E6278'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%235E6278'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-800 .menu-item .menu-link {\n  color: #3F4254;\n}\n.menu-gray-800 .menu-item .menu-link .menu-title {\n  color: #3F4254;\n}\n.menu-gray-800 .menu-item .menu-link .menu-icon i {\n  color: #3F4254;\n}\n.menu-gray-800 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #3F4254;\n}\n.menu-gray-800 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-gray-800 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #3F4254;\n}\n.menu-gray-800 .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%233F4254'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%233F4254'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-800 .menu-item .menu-link {\n  color: #3F4254;\n}\n.menu-title-gray-800 .menu-item .menu-link .menu-title {\n  color: #3F4254;\n}\n\n.menu-icon-gray-800 .menu-item .menu-link .menu-icon i {\n  color: #3F4254;\n}\n.menu-icon-gray-800 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #3F4254;\n}\n.menu-icon-gray-800 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-bullet-gray-800 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #3F4254;\n}\n\n.menu-arrow-gray-800 .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%233F4254'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%233F4254'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-900 .menu-item .menu-link {\n  color: #181C32;\n}\n.menu-gray-900 .menu-item .menu-link .menu-title {\n  color: #181C32;\n}\n.menu-gray-900 .menu-item .menu-link .menu-icon i {\n  color: #181C32;\n}\n.menu-gray-900 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #181C32;\n}\n.menu-gray-900 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-gray-900 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #181C32;\n}\n.menu-gray-900 .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23181C32'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23181C32'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-900 .menu-item .menu-link {\n  color: #181C32;\n}\n.menu-title-gray-900 .menu-item .menu-link .menu-title {\n  color: #181C32;\n}\n\n.menu-icon-gray-900 .menu-item .menu-link .menu-icon i {\n  color: #181C32;\n}\n.menu-icon-gray-900 .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #181C32;\n}\n.menu-icon-gray-900 .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-bullet-gray-900 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #181C32;\n}\n\n.menu-arrow-gray-900 .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23181C32'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23181C32'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: rgba(245, 248, 250, 0.8);\n}\n\n.menu-here-bg .menu-item.here > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: rgba(245, 248, 250, 0.8);\n}\n\n.menu-show-bg .menu-item.show > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: rgba(245, 248, 250, 0.8);\n}\n\n.menu-active-bg .menu-item .menu-link.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: rgba(245, 248, 250, 0.8);\n}\n\n.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: rgba(245, 248, 250, 0.8);\n}\n.menu-state-bg .menu-item.here > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: rgba(245, 248, 250, 0.8);\n}\n.menu-state-bg .menu-item.show > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: rgba(245, 248, 250, 0.8);\n}\n.menu-state-bg .menu-item .menu-link.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: rgba(245, 248, 250, 0.8);\n}\n\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #009EF7;\n}\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: #009EF7;\n}\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: #009EF7;\n}\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g), .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g), .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-show-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #009EF7;\n}\n.menu-show-primary .menu-item.show > .menu-link .menu-title {\n  color: #009EF7;\n}\n.menu-show-primary .menu-item.show > .menu-link .menu-icon i {\n  color: #009EF7;\n}\n.menu-show-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-show-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-show-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n.menu-show-primary .menu-item.show > .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-here-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #009EF7;\n}\n.menu-here-primary .menu-item.here > .menu-link .menu-title {\n  color: #009EF7;\n}\n.menu-here-primary .menu-item.here > .menu-link .menu-icon i {\n  color: #009EF7;\n}\n.menu-here-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-here-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-here-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n.menu-here-primary .menu-item.here > .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-active-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #009EF7;\n}\n.menu-active-primary .menu-item .menu-link.active .menu-title {\n  color: #009EF7;\n}\n.menu-active-primary .menu-item .menu-link.active .menu-icon i {\n  color: #009EF7;\n}\n.menu-active-primary .menu-item .menu-link.active .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-active-primary .menu-item .menu-link.active .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-active-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n.menu-active-primary .menu-item .menu-link.active .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #009EF7;\n}\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: #009EF7;\n}\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: #009EF7;\n}\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g), .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g), .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #009EF7;\n}\n.menu-state-primary .menu-item.show > .menu-link .menu-title {\n  color: #009EF7;\n}\n.menu-state-primary .menu-item.show > .menu-link .menu-icon i {\n  color: #009EF7;\n}\n.menu-state-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-state-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-state-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n.menu-state-primary .menu-item.show > .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #009EF7;\n}\n.menu-state-primary .menu-item.here > .menu-link .menu-title {\n  color: #009EF7;\n}\n.menu-state-primary .menu-item.here > .menu-link .menu-icon i {\n  color: #009EF7;\n}\n.menu-state-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-state-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-state-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n.menu-state-primary .menu-item.here > .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #009EF7;\n}\n.menu-state-primary .menu-item .menu-link.active .menu-title {\n  color: #009EF7;\n}\n.menu-state-primary .menu-item .menu-link.active .menu-icon i {\n  color: #009EF7;\n}\n.menu-state-primary .menu-item .menu-link.active .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-state-primary .menu-item .menu-link.active .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-state-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n.menu-state-primary .menu-item .menu-link.active .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: #009EF7;\n  color: #FFFFFF;\n}\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: #FFFFFF;\n}\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: #FFFFFF;\n}\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g), .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g), .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: #FFFFFF;\n}\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23FFFFFF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23FFFFFF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-show-bg-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: #009EF7;\n  color: #FFFFFF;\n}\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-title {\n  color: #FFFFFF;\n}\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon i {\n  color: #FFFFFF;\n}\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: #FFFFFF;\n}\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23FFFFFF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23FFFFFF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-here-bg-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: #009EF7;\n  color: #FFFFFF;\n}\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-title {\n  color: #FFFFFF;\n}\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon i {\n  color: #FFFFFF;\n}\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: #FFFFFF;\n}\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23FFFFFF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23FFFFFF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-active-bg-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: #009EF7;\n  color: #FFFFFF;\n}\n.menu-active-bg-primary .menu-item .menu-link.active .menu-title {\n  color: #FFFFFF;\n}\n.menu-active-bg-primary .menu-item .menu-link.active .menu-icon i {\n  color: #FFFFFF;\n}\n.menu-active-bg-primary .menu-item .menu-link.active .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.menu-active-bg-primary .menu-item .menu-link.active .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-active-bg-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: #FFFFFF;\n}\n.menu-active-bg-primary .menu-item .menu-link.active .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23FFFFFF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23FFFFFF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: #009EF7;\n  color: #FFFFFF;\n}\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: #FFFFFF;\n}\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: #FFFFFF;\n}\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g), .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g), .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: #FFFFFF;\n}\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23FFFFFF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23FFFFFF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: #009EF7;\n  color: #FFFFFF;\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-title {\n  color: #FFFFFF;\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon i {\n  color: #FFFFFF;\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: #FFFFFF;\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23FFFFFF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23FFFFFF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: #009EF7;\n  color: #FFFFFF;\n}\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-title {\n  color: #FFFFFF;\n}\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon i {\n  color: #FFFFFF;\n}\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: #FFFFFF;\n}\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23FFFFFF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23FFFFFF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: #009EF7;\n  color: #FFFFFF;\n}\n.menu-state-bg-primary .menu-item .menu-link.active .menu-title {\n  color: #FFFFFF;\n}\n.menu-state-bg-primary .menu-item .menu-link.active .menu-icon i {\n  color: #FFFFFF;\n}\n.menu-state-bg-primary .menu-item .menu-link.active .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.menu-state-bg-primary .menu-item .menu-link.active .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-state-bg-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: #FFFFFF;\n}\n.menu-state-bg-primary .menu-item .menu-link.active .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23FFFFFF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23FFFFFF'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-show-bg-light-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: #F1FAFF;\n  color: #009EF7;\n}\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-title {\n  color: #009EF7;\n}\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon i {\n  color: #009EF7;\n}\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-here-bg-light-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: #F1FAFF;\n  color: #009EF7;\n}\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-title {\n  color: #009EF7;\n}\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon i {\n  color: #009EF7;\n}\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: #F1FAFF;\n  color: #009EF7;\n}\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: #009EF7;\n}\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: #009EF7;\n}\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g), .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g), .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-active-bg-light-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: #F1FAFF;\n  color: #009EF7;\n}\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-title {\n  color: #009EF7;\n}\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon i {\n  color: #009EF7;\n}\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-bg-light-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: #F1FAFF;\n  color: #009EF7;\n}\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-title {\n  color: #009EF7;\n}\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon i {\n  color: #009EF7;\n}\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-light-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: #F1FAFF;\n  color: #009EF7;\n}\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-title {\n  color: #009EF7;\n}\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon i {\n  color: #009EF7;\n}\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: #F1FAFF;\n  color: #009EF7;\n}\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: #009EF7;\n}\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: #009EF7;\n}\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g), .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g), .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-light-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: #F1FAFF;\n  color: #009EF7;\n}\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-title {\n  color: #009EF7;\n}\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon i {\n  color: #009EF7;\n}\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-hover-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #009EF7;\n}\n.menu-hover-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: #009EF7;\n}\n\n.menu-here-title-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #009EF7;\n}\n.menu-here-title-primary .menu-item.here > .menu-link .menu-title {\n  color: #009EF7;\n}\n\n.menu-show-title-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #009EF7;\n}\n.menu-show-title-primary .menu-item.show > .menu-link .menu-title {\n  color: #009EF7;\n}\n\n.menu-active-title-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #009EF7;\n}\n.menu-active-title-primary .menu-item .menu-link.active .menu-title {\n  color: #009EF7;\n}\n\n.menu-state-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #009EF7;\n}\n.menu-state-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: #009EF7;\n}\n.menu-state-title-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #009EF7;\n}\n.menu-state-title-primary .menu-item.show > .menu-link .menu-title {\n  color: #009EF7;\n}\n.menu-state-title-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #009EF7;\n}\n.menu-state-title-primary .menu-item .menu-link.active .menu-title {\n  color: #009EF7;\n}\n\n.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: #009EF7;\n}\n.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g), .menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g), .menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-here-icon-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon i {\n  color: #009EF7;\n}\n.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-show-icon-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon i {\n  color: #009EF7;\n}\n.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-active-icon-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.menu-active-icon-primary .menu-item .menu-link.active .menu-icon i {\n  color: #009EF7;\n}\n.menu-active-icon-primary .menu-item .menu-link.active .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-active-icon-primary .menu-item .menu-link.active .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: #009EF7;\n}\n.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g), .menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g), .menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-state-icon-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon i {\n  color: #009EF7;\n}\n.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.menu-state-icon-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.menu-state-icon-primary .menu-item .menu-link.active .menu-icon i {\n  color: #009EF7;\n}\n.menu-state-icon-primary .menu-item .menu-link.active .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.menu-state-icon-primary .menu-item .menu-link.active .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.menu-hover-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.menu-hover-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n\n.menu-show-bullet-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.menu-show-bullet-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n\n.menu-here-bullet-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.menu-here-bullet-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n\n.menu-active-bullet-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.menu-active-bullet-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n\n.menu-state-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.menu-state-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n.menu-state-bullet-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.menu-state-bullet-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n.menu-state-bullet-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.menu-state-bullet-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n\n.menu-hover-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.menu-hover-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-here-arrow-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.menu-here-arrow-primary .menu-item.here > .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-show-arrow-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.menu-show-arrow-primary .menu-item.show > .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-active-arrow-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.menu-active-arrow-primary .menu-item .menu-link.active .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.menu-state-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-arrow-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.menu-state-arrow-primary .menu-item.show > .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-arrow-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.menu-state-arrow-primary .menu-item .menu-link.active .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23009EF7'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.anchor {\n  display: flex;\n  align-items: center;\n}\n.anchor a {\n  position: relative;\n  display: none;\n  align-items: center;\n  justify-content: flex-start;\n  height: 1em;\n  width: 1.25em;\n  margin-left: -1.25em;\n  font-weight: 500;\n  font-size: 0.8em;\n  color: #A1A5B7;\n  transition: all 0.2s ease;\n}\n.anchor a:before {\n  content: \"#\";\n}\n.anchor:hover a {\n  display: flex;\n}\n.anchor:hover a:hover {\n  color: #009EF7;\n  transition: all 0.2s ease;\n}\n\n.card {\n  border: 0;\n  box-shadow: 0px 0px 20px 0px rgba(76, 87, 125, 0.02);\n}\n.card .card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  flex-wrap: wrap;\n  min-height: 70px;\n  padding: 0 2.25rem;\n  background-color: transparent;\n  border-bottom: var(--bs-border-width) solid #EFF2F5;\n}\n.card .card-header .card-title {\n  display: flex;\n  align-items: center;\n  margin: 0.5rem;\n  margin-left: 0;\n}\n.card .card-header .card-title.flex-column {\n  align-items: flex-start;\n  justify-content: center;\n}\n.card .card-header .card-title .card-icon {\n  margin-right: 0.75rem;\n  line-height: 0;\n}\n.card .card-header .card-title .card-icon i {\n  font-size: 1.25rem;\n  color: #7E8299;\n  line-height: 0;\n}\n.card .card-header .card-title .card-icon i:after, .card .card-header .card-title .card-icon i:before {\n  line-height: 0;\n}\n.card .card-header .card-title .card-icon .svg-icon svg {\n  height: 24px;\n  width: 24px;\n}\n.card .card-header .card-title .card-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7E8299;\n}\n.card .card-header .card-title .card-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.card .card-header .card-title,\n.card .card-header .card-title .card-label {\n  font-weight: 500;\n  font-size: 1.275rem;\n  color: #181C32;\n}\n.card .card-header .card-title .card-label {\n  margin: 0 0.75rem 0 0;\n  flex-wrap: wrap;\n}\n.card .card-header .card-title small, .card .card-header .card-title .small {\n  color: #A1A5B7;\n  font-size: 1rem;\n}\n.card .card-header .card-title h1, .card .card-header .card-title .h1, .card .card-header .card-title h2, .card .card-header .card-title .h2, .card .card-header .card-title h3, .card .card-header .card-title .h3, .card .card-header .card-title h4, .card .card-header .card-title .h4, .card .card-header .card-title h5, .card .card-header .card-title .h5, .card .card-header .card-title h6, .card .card-header .card-title .h6 {\n  margin-bottom: 0;\n}\n.card .card-header .card-toolbar {\n  display: flex;\n  align-items: center;\n  margin: 0.5rem 0;\n  flex-wrap: wrap;\n}\n.card .card-body {\n  padding: 2rem 2.25rem;\n}\n.card .card-footer {\n  padding: 2rem 2.25rem;\n  background-color: transparent;\n  border-top: var(--bs-border-width) solid #EFF2F5;\n}\n.card .card-scroll {\n  position: relative;\n  overflow: auto;\n}\n.card.card-px-0 .card-header,\n.card.card-px-0 .card-body,\n.card.card-px-0 .card-footer {\n  padding-left: 0;\n  padding-right: 0;\n}\n.card.card-py-0 .card-header,\n.card.card-py-0 .card-body,\n.card.card-py-0 .card-footer {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.card.card-p-0 .card-header,\n.card.card-p-0 .card-body,\n.card.card-p-0 .card-footer {\n  padding: 0;\n}\n.card.card-dashed {\n  box-shadow: none;\n  border: var(--bs-border-width) dashed #E4E6EF;\n}\n.card.card-dashed > .card-header {\n  border-bottom: 1px dashed #E4E6EF;\n}\n.card.card-dashed > .card-footer {\n  border-top: 1px dashed #E4E6EF;\n}\n.card.card-bordered {\n  box-shadow: none;\n  border: var(--bs-border-width) solid #EFF2F5;\n}\n.card.card-flush > .card-header {\n  border-bottom: 0;\n}\n.card.card-flush > .card-footer {\n  border-top: 0;\n}\n.card.card-shadow {\n  box-shadow: 0px 0px 20px 0px rgba(76, 87, 125, 0.02);\n  border: 0;\n}\n\n.card.card-stretch {\n  height: calc(100% - var(--bs-gutter-y));\n}\n.card.card-stretch-75 {\n  height: calc(75% - var(--bs-gutter-y));\n}\n.card.card-stretch-50 {\n  height: calc(50% - var(--bs-gutter-y));\n}\n.card.card-stretch-33 {\n  height: calc(33.333% - var(--bs-gutter-y));\n}\n.card.card-stretch-25 {\n  height: calc(25% - var(--bs-gutter-y));\n}\n.card .card-header-stretch {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  align-items: stretch;\n}\n.card .card-header-stretch .card-toolbar {\n  margin: 0;\n  align-items: stretch;\n}\n@media (min-width: 576px) {\n  .card.card-sm-stretch {\n    height: calc(100% - var(--bs-gutter-y));\n  }\n  .card.card-sm-stretch-75 {\n    height: calc(75% - var(--bs-gutter-y));\n  }\n  .card.card-sm-stretch-50 {\n    height: calc(50% - var(--bs-gutter-y));\n  }\n  .card.card-sm-stretch-33 {\n    height: calc(33.333% - var(--bs-gutter-y));\n  }\n  .card.card-sm-stretch-25 {\n    height: calc(25% - var(--bs-gutter-y));\n  }\n  .card .card-header-sm-stretch {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    align-items: stretch;\n  }\n  .card .card-header-sm-stretch .card-toolbar {\n    margin: 0;\n    align-items: stretch;\n  }\n}\n@media (min-width: 768px) {\n  .card.card-md-stretch {\n    height: calc(100% - var(--bs-gutter-y));\n  }\n  .card.card-md-stretch-75 {\n    height: calc(75% - var(--bs-gutter-y));\n  }\n  .card.card-md-stretch-50 {\n    height: calc(50% - var(--bs-gutter-y));\n  }\n  .card.card-md-stretch-33 {\n    height: calc(33.333% - var(--bs-gutter-y));\n  }\n  .card.card-md-stretch-25 {\n    height: calc(25% - var(--bs-gutter-y));\n  }\n  .card .card-header-md-stretch {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    align-items: stretch;\n  }\n  .card .card-header-md-stretch .card-toolbar {\n    margin: 0;\n    align-items: stretch;\n  }\n}\n@media (min-width: 992px) {\n  .card.card-lg-stretch {\n    height: calc(100% - var(--bs-gutter-y));\n  }\n  .card.card-lg-stretch-75 {\n    height: calc(75% - var(--bs-gutter-y));\n  }\n  .card.card-lg-stretch-50 {\n    height: calc(50% - var(--bs-gutter-y));\n  }\n  .card.card-lg-stretch-33 {\n    height: calc(33.333% - var(--bs-gutter-y));\n  }\n  .card.card-lg-stretch-25 {\n    height: calc(25% - var(--bs-gutter-y));\n  }\n  .card .card-header-lg-stretch {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    align-items: stretch;\n  }\n  .card .card-header-lg-stretch .card-toolbar {\n    margin: 0;\n    align-items: stretch;\n  }\n}\n@media (min-width: 1200px) {\n  .card.card-xl-stretch {\n    height: calc(100% - var(--bs-gutter-y));\n  }\n  .card.card-xl-stretch-75 {\n    height: calc(75% - var(--bs-gutter-y));\n  }\n  .card.card-xl-stretch-50 {\n    height: calc(50% - var(--bs-gutter-y));\n  }\n  .card.card-xl-stretch-33 {\n    height: calc(33.333% - var(--bs-gutter-y));\n  }\n  .card.card-xl-stretch-25 {\n    height: calc(25% - var(--bs-gutter-y));\n  }\n  .card .card-header-xl-stretch {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    align-items: stretch;\n  }\n  .card .card-header-xl-stretch .card-toolbar {\n    margin: 0;\n    align-items: stretch;\n  }\n}\n@media (min-width: 1400px) {\n  .card.card-xxl-stretch {\n    height: calc(100% - var(--bs-gutter-y));\n  }\n  .card.card-xxl-stretch-75 {\n    height: calc(75% - var(--bs-gutter-y));\n  }\n  .card.card-xxl-stretch-50 {\n    height: calc(50% - var(--bs-gutter-y));\n  }\n  .card.card-xxl-stretch-33 {\n    height: calc(33.333% - var(--bs-gutter-y));\n  }\n  .card.card-xxl-stretch-25 {\n    height: calc(25% - var(--bs-gutter-y));\n  }\n  .card .card-header-xxl-stretch {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    align-items: stretch;\n  }\n  .card .card-header-xxl-stretch .card-toolbar {\n    margin: 0;\n    align-items: stretch;\n  }\n}\n\n.card-p {\n  padding: 2rem 2.25rem !important;\n}\n\n.card-px {\n  padding-left: 2.25rem !important;\n  padding-right: 2.25rem !important;\n}\n\n.card-shadow {\n  box-shadow: 0px 0px 20px 0px rgba(76, 87, 125, 0.02);\n}\n\n.card-py {\n  padding-top: 2rem !important;\n  padding-bottom: 2rem !important;\n}\n\n.card-rounded {\n  border-radius: 0.475rem;\n}\n\n.card-rounded-start {\n  border-top-left-radius: 0.475rem;\n  border-bottom-left-radius: 0.475rem;\n}\n\n.card-rounded-end {\n  border-top-right-radius: 0.475rem;\n  border-bottom-right-radius: 0.475rem;\n}\n\n.card-rounded-top {\n  border-top-left-radius: 0.475rem;\n  border-top-right-radius: 0.475rem;\n}\n\n.card-rounded-bottom {\n  border-bottom-left-radius: 0.475rem;\n  border-bottom-right-radius: 0.475rem;\n}\n\n@media (max-width: 767.98px) {\n  .card > .card-header:not(.flex-nowrap) {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n}\n.breadcrumb {\n  display: flex;\n  align-items: center;\n  background-color: transparent;\n  padding: 0;\n  margin: 0;\n}\n.breadcrumb .breadcrumb-item {\n  display: flex;\n  align-items: center;\n  padding-left: 0;\n  padding-right: 0.5rem;\n}\n.breadcrumb .breadcrumb-item:last-child {\n  padding-right: 0;\n}\n.breadcrumb .breadcrumb-item:after {\n  content: \"/\";\n  padding-left: 0.5rem;\n}\n.breadcrumb .breadcrumb-item:before {\n  display: none;\n}\n.breadcrumb .breadcrumb-item:last-child:after {\n  display: none;\n}\n\n.breadcrumb-line .breadcrumb-item:after {\n  content: \"-\";\n}\n\n.breadcrumb-dot .breadcrumb-item:after {\n  content: \"•\";\n}\n\n.breadcrumb-separatorless .breadcrumb-item:after {\n  display: none;\n}\n\n.btn {\n  outline: none !important;\n}\n.btn:not(.btn-shadow):not(.shadow):not(.shadow-sm):not(.shadow-lg) {\n  box-shadow: none !important;\n}\n.btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon) {\n  border: 0;\n  padding: calc(0.75rem + 1px) calc(1.5rem + 1px);\n}\n.btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon).btn-lg, .btn-group-lg > .btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon) {\n  padding: calc(0.825rem + 1px) calc(1.75rem + 1px);\n}\n.btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon).btn-sm, .btn-group-sm > .btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon) {\n  padding: calc(0.65rem + 1px) calc(1.25rem + 1px);\n}\n.btn.btn-link {\n  border: 0;\n  border-radius: 0;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  text-decoration: none;\n  font-weight: 500;\n}\n.btn.btn-outline-dashed {\n  border: 1px dashed #E4E6EF;\n}\n.btn.btn-outline-default {\n  border: 1px solid #E4E6EF;\n}\n.btn.btn-flush {\n  appearance: none;\n  box-shadow: none;\n  border-radius: 0;\n  border: none;\n  cursor: pointer;\n  background-color: transparent;\n  outline: none !important;\n  margin: 0;\n  padding: 0;\n}\n.btn.btn-flex {\n  display: inline-flex;\n  align-items: center;\n}\n\n.btn i {\n  display: inline-flex;\n  font-size: 1rem;\n  padding-right: 0.35rem;\n  vertical-align: middle;\n  line-height: 0;\n}\n.btn .svg-icon {\n  flex-shrink: 0;\n  line-height: 0;\n  margin-right: 0.5rem;\n}\n.btn.btn-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  height: calc(1.5em + 1.5rem + calc(1px * 2));\n  width: calc(1.5em + 1.5rem + calc(1px * 2));\n}\n.btn.btn-icon:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush) {\n  border: 0;\n}\n.btn.btn-icon.btn-sm, .btn-group-sm > .btn.btn-icon {\n  height: calc(1.5em + 1.3rem + calc(1px * 2));\n  width: calc(1.5em + 1.3rem + calc(1px * 2));\n}\n.btn.btn-icon.btn-lg, .btn-group-lg > .btn.btn-icon {\n  height: calc(1.5em + 1.65rem + calc(1px * 2));\n  width: calc(1.5em + 1.65rem + calc(1px * 2));\n}\n.btn.btn-icon.btn-circle {\n  border-radius: 50%;\n}\n.btn.btn-icon i,\n.btn.btn-icon .svg-icon {\n  padding: 0;\n  margin: 0;\n  line-height: 1;\n}\n\n.btn.btn-hover-rise {\n  transition: transform 0.3s ease;\n}\n.btn.btn-hover-rise:hover {\n  transform: translateY(-10%);\n  transition: transform 0.3s ease;\n}\n\n.btn.btn-hover-scale {\n  transition: transform 0.3s ease;\n}\n.btn.btn-hover-scale:hover {\n  transform: scale(1.1);\n  transition: transform 0.3s ease;\n}\n\n.btn.btn-hover-rotate-end {\n  transition: transform 0.3s ease;\n}\n.btn.btn-hover-rotate-end:hover {\n  transform: rotate(4deg);\n  transition: transform 0.3s ease;\n}\n\n.btn.btn-hover-rotate-start {\n  transition: transform 0.3s ease;\n}\n.btn.btn-hover-rotate-start:hover {\n  transform: rotate(-4deg);\n  transition: transform 0.3s ease;\n}\n\n.btn.btn-white {\n  color: #7E8299;\n  border-color: #ffffff;\n  background-color: #ffffff;\n}\n.btn.btn-white i {\n  color: #7E8299;\n}\n.btn.btn-white .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7E8299;\n}\n.btn.btn-white .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-white.dropdown-toggle:after {\n  color: #7E8299;\n}\n.btn-check:checked + .btn.btn-white, .btn-check:active + .btn.btn-white, .btn.btn-white:focus:not(.btn-active), .btn.btn-white:hover:not(.btn-active), .btn.btn-white:active:not(.btn-active), .btn.btn-white.active, .btn.btn-white.show, .show > .btn.btn-white {\n  color: #7E8299;\n  border-color: #F5F8FA;\n  background-color: #F5F8FA !important;\n}\n.btn-check:checked + .btn.btn-white i, .btn-check:active + .btn.btn-white i, .btn.btn-white:focus:not(.btn-active) i, .btn.btn-white:hover:not(.btn-active) i, .btn.btn-white:active:not(.btn-active) i, .btn.btn-white.active i, .btn.btn-white.show i, .show > .btn.btn-white i {\n  color: #7E8299;\n}\n.btn-check:checked + .btn.btn-white .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-white .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-white:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-white:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-white:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-white.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-white.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-white .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7E8299;\n}\n.btn-check:checked + .btn.btn-white .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-white .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-white:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-white:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-white:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-white.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-white.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-white .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-white.dropdown-toggle:after, .btn-check:active + .btn.btn-white.dropdown-toggle:after, .btn.btn-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-white.active.dropdown-toggle:after, .btn.btn-white.show.dropdown-toggle:after, .show > .btn.btn-white.dropdown-toggle:after {\n  color: #7E8299;\n}\n\n.btn.btn-bg-white {\n  border-color: #ffffff;\n  background-color: #ffffff;\n}\n.btn-check:checked + .btn.btn-active-white, .btn-check:active + .btn.btn-active-white, .btn.btn-active-white:focus:not(.btn-active), .btn.btn-active-white:hover:not(.btn-active), .btn.btn-active-white:active:not(.btn-active), .btn.btn-active-white.active, .btn.btn-active-white.show, .show > .btn.btn-active-white {\n  color: #7E8299;\n  border-color: #ffffff;\n  background-color: #ffffff !important;\n}\n.btn-check:checked + .btn.btn-active-white i, .btn-check:active + .btn.btn-active-white i, .btn.btn-active-white:focus:not(.btn-active) i, .btn.btn-active-white:hover:not(.btn-active) i, .btn.btn-active-white:active:not(.btn-active) i, .btn.btn-active-white.active i, .btn.btn-active-white.show i, .show > .btn.btn-active-white i {\n  color: #7E8299;\n}\n.btn-check:checked + .btn.btn-active-white .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-white .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-white:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-white:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-white:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-white.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-white.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-white .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7E8299;\n}\n.btn-check:checked + .btn.btn-active-white .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-white .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-white:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-white:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-white:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-white.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-white.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-white .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-white.dropdown-toggle:after, .btn-check:active + .btn.btn-active-white.dropdown-toggle:after, .btn.btn-active-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-white.active.dropdown-toggle:after, .btn.btn-active-white.show.dropdown-toggle:after, .show > .btn.btn-active-white.dropdown-toggle:after {\n  color: #7E8299;\n}\n\n.btn.btn-light {\n  color: #7E8299;\n  border-color: #F5F8FA;\n  background-color: #F5F8FA;\n}\n.btn.btn-light i {\n  color: #7E8299;\n}\n.btn.btn-light .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7E8299;\n}\n.btn.btn-light .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-light.dropdown-toggle:after {\n  color: #7E8299;\n}\n.btn-check:checked + .btn.btn-light, .btn-check:active + .btn.btn-light, .btn.btn-light:focus:not(.btn-active), .btn.btn-light:hover:not(.btn-active), .btn.btn-light:active:not(.btn-active), .btn.btn-light.active, .btn.btn-light.show, .show > .btn.btn-light {\n  color: #7E8299;\n  border-color: #EFF2F5;\n  background-color: #EFF2F5 !important;\n}\n.btn-check:checked + .btn.btn-light i, .btn-check:active + .btn.btn-light i, .btn.btn-light:focus:not(.btn-active) i, .btn.btn-light:hover:not(.btn-active) i, .btn.btn-light:active:not(.btn-active) i, .btn.btn-light.active i, .btn.btn-light.show i, .show > .btn.btn-light i {\n  color: #7E8299;\n}\n.btn-check:checked + .btn.btn-light .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7E8299;\n}\n.btn-check:checked + .btn.btn-light .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-light.dropdown-toggle:after, .btn-check:active + .btn.btn-light.dropdown-toggle:after, .btn.btn-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light.active.dropdown-toggle:after, .btn.btn-light.show.dropdown-toggle:after, .show > .btn.btn-light.dropdown-toggle:after {\n  color: #7E8299;\n}\n\n.btn.btn-bg-light {\n  border-color: #F5F8FA;\n  background-color: #F5F8FA;\n}\n.btn-check:checked + .btn.btn-active-light, .btn-check:active + .btn.btn-active-light, .btn.btn-active-light:focus:not(.btn-active), .btn.btn-active-light:hover:not(.btn-active), .btn.btn-active-light:active:not(.btn-active), .btn.btn-active-light.active, .btn.btn-active-light.show, .show > .btn.btn-active-light {\n  color: #7E8299;\n  border-color: #F5F8FA;\n  background-color: #F5F8FA !important;\n}\n.btn-check:checked + .btn.btn-active-light i, .btn-check:active + .btn.btn-active-light i, .btn.btn-active-light:focus:not(.btn-active) i, .btn.btn-active-light:hover:not(.btn-active) i, .btn.btn-active-light:active:not(.btn-active) i, .btn.btn-active-light.active i, .btn.btn-active-light.show i, .show > .btn.btn-active-light i {\n  color: #7E8299;\n}\n.btn-check:checked + .btn.btn-active-light .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-light .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7E8299;\n}\n.btn-check:checked + .btn.btn-active-light .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-light .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light.dropdown-toggle:after, .btn.btn-active-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light.active.dropdown-toggle:after, .btn.btn-active-light.show.dropdown-toggle:after, .show > .btn.btn-active-light.dropdown-toggle:after {\n  color: #7E8299;\n}\n\n.btn.btn-primary {\n  color: #FFFFFF;\n  border-color: #009EF7;\n  background-color: #009EF7;\n}\n.btn.btn-primary i {\n  color: #FFFFFF;\n}\n.btn.btn-primary .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.btn.btn-primary .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-primary.dropdown-toggle:after {\n  color: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-primary, .btn-check:active + .btn.btn-primary, .btn.btn-primary:focus:not(.btn-active), .btn.btn-primary:hover:not(.btn-active), .btn.btn-primary:active:not(.btn-active), .btn.btn-primary.active, .btn.btn-primary.show, .show > .btn.btn-primary {\n  color: #FFFFFF;\n  border-color: #0095E8;\n  background-color: #0095E8 !important;\n}\n.btn-check:checked + .btn.btn-primary i, .btn-check:active + .btn.btn-primary i, .btn.btn-primary:focus:not(.btn-active) i, .btn.btn-primary:hover:not(.btn-active) i, .btn.btn-primary:active:not(.btn-active) i, .btn.btn-primary.active i, .btn.btn-primary.show i, .show > .btn.btn-primary i {\n  color: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-primary:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-primary:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-primary:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-primary.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-primary.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-primary .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-primary:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-primary:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-primary:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-primary.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-primary.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-primary .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-primary.dropdown-toggle:after, .btn.btn-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-primary.active.dropdown-toggle:after, .btn.btn-primary.show.dropdown-toggle:after, .show > .btn.btn-primary.dropdown-toggle:after {\n  color: #FFFFFF;\n}\n\n.btn.btn-light-primary {\n  color: #009EF7;\n  border-color: #F1FAFF;\n  background-color: #F1FAFF;\n}\n.btn.btn-light-primary i {\n  color: #009EF7;\n}\n.btn.btn-light-primary .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.btn.btn-light-primary .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-light-primary.dropdown-toggle:after {\n  color: #009EF7;\n}\n.btn-check:checked + .btn.btn-light-primary, .btn-check:active + .btn.btn-light-primary, .btn.btn-light-primary:focus:not(.btn-active), .btn.btn-light-primary:hover:not(.btn-active), .btn.btn-light-primary:active:not(.btn-active), .btn.btn-light-primary.active, .btn.btn-light-primary.show, .show > .btn.btn-light-primary {\n  color: #FFFFFF;\n  border-color: #009EF7;\n  background-color: #009EF7 !important;\n}\n.btn-check:checked + .btn.btn-light-primary i, .btn-check:active + .btn.btn-light-primary i, .btn.btn-light-primary:focus:not(.btn-active) i, .btn.btn-light-primary:hover:not(.btn-active) i, .btn.btn-light-primary:active:not(.btn-active) i, .btn.btn-light-primary.active i, .btn.btn-light-primary.show i, .show > .btn.btn-light-primary i {\n  color: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-light-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-primary:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-primary:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-primary:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-primary.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-primary.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-primary .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-light-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-primary:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-primary:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-primary:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-primary.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-primary.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-primary .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-light-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-light-primary.dropdown-toggle:after, .btn.btn-light-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary.active.dropdown-toggle:after, .btn.btn-light-primary.show.dropdown-toggle:after, .show > .btn.btn-light-primary.dropdown-toggle:after {\n  color: #FFFFFF;\n}\n\n.btn.btn-bg-primary {\n  border-color: #009EF7;\n  background-color: #009EF7;\n}\n.btn-check:checked + .btn.btn-active-primary, .btn-check:active + .btn.btn-active-primary, .btn.btn-active-primary:focus:not(.btn-active), .btn.btn-active-primary:hover:not(.btn-active), .btn.btn-active-primary:active:not(.btn-active), .btn.btn-active-primary.active, .btn.btn-active-primary.show, .show > .btn.btn-active-primary {\n  color: #FFFFFF;\n  border-color: #009EF7;\n  background-color: #009EF7 !important;\n}\n.btn-check:checked + .btn.btn-active-primary i, .btn-check:active + .btn.btn-active-primary i, .btn.btn-active-primary:focus:not(.btn-active) i, .btn.btn-active-primary:hover:not(.btn-active) i, .btn.btn-active-primary:active:not(.btn-active) i, .btn.btn-active-primary.active i, .btn.btn-active-primary.show i, .show > .btn.btn-active-primary i {\n  color: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-active-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-primary:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-primary:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-primary:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-primary.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-primary.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-primary .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-active-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-primary:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-primary:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-primary:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-primary.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-primary.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-primary .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-primary.dropdown-toggle:after, .btn.btn-active-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary.active.dropdown-toggle:after, .btn.btn-active-primary.show.dropdown-toggle:after, .show > .btn.btn-active-primary.dropdown-toggle:after {\n  color: #FFFFFF;\n}\n\n.btn-check:checked + .btn.btn-active-light-primary, .btn-check:active + .btn.btn-active-light-primary, .btn.btn-active-light-primary:focus:not(.btn-active), .btn.btn-active-light-primary:hover:not(.btn-active), .btn.btn-active-light-primary:active:not(.btn-active), .btn.btn-active-light-primary.active, .btn.btn-active-light-primary.show, .show > .btn.btn-active-light-primary {\n  color: #009EF7;\n  border-color: #F1FAFF;\n  background-color: #F1FAFF !important;\n}\n.btn-check:checked + .btn.btn-active-light-primary i, .btn-check:active + .btn.btn-active-light-primary i, .btn.btn-active-light-primary:focus:not(.btn-active) i, .btn.btn-active-light-primary:hover:not(.btn-active) i, .btn.btn-active-light-primary:active:not(.btn-active) i, .btn.btn-active-light-primary.active i, .btn.btn-active-light-primary.show i, .show > .btn.btn-active-light-primary i {\n  color: #009EF7;\n}\n.btn-check:checked + .btn.btn-active-light-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-primary:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-primary:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-primary:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-primary.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-primary.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-primary .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.btn-check:checked + .btn.btn-active-light-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-primary:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-primary:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-primary:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-primary.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-primary.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-primary .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-light-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-primary.dropdown-toggle:after, .btn.btn-active-light-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary.active.dropdown-toggle:after, .btn.btn-active-light-primary.show.dropdown-toggle:after, .show > .btn.btn-active-light-primary.dropdown-toggle:after {\n  color: #009EF7;\n}\n.btn.btn-active-light-primary.btn-outline:not(.btn-outline-default) {\n  border-color: #009EF7 !important;\n}\n\n.btn.btn-secondary {\n  color: #3F4254;\n  border-color: #E4E6EF;\n  background-color: #E4E6EF;\n}\n.btn.btn-secondary i {\n  color: #3F4254;\n}\n.btn.btn-secondary .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #3F4254;\n}\n.btn.btn-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-secondary.dropdown-toggle:after {\n  color: #3F4254;\n}\n.btn-check:checked + .btn.btn-secondary, .btn-check:active + .btn.btn-secondary, .btn.btn-secondary:focus:not(.btn-active), .btn.btn-secondary:hover:not(.btn-active), .btn.btn-secondary:active:not(.btn-active), .btn.btn-secondary.active, .btn.btn-secondary.show, .show > .btn.btn-secondary {\n  color: #3F4254;\n  border-color: #B5B5C3;\n  background-color: #B5B5C3 !important;\n}\n.btn-check:checked + .btn.btn-secondary i, .btn-check:active + .btn.btn-secondary i, .btn.btn-secondary:focus:not(.btn-active) i, .btn.btn-secondary:hover:not(.btn-active) i, .btn.btn-secondary:active:not(.btn-active) i, .btn.btn-secondary.active i, .btn.btn-secondary.show i, .show > .btn.btn-secondary i {\n  color: #3F4254;\n}\n.btn-check:checked + .btn.btn-secondary .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-secondary .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-secondary:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-secondary:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-secondary:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-secondary.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-secondary.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-secondary .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #3F4254;\n}\n.btn-check:checked + .btn.btn-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-secondary:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-secondary:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-secondary:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-secondary.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-secondary.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-secondary.dropdown-toggle:after, .btn.btn-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary.active.dropdown-toggle:after, .btn.btn-secondary.show.dropdown-toggle:after, .show > .btn.btn-secondary.dropdown-toggle:after {\n  color: #3F4254;\n}\n\n.btn.btn-bg-secondary {\n  border-color: #E4E6EF;\n  background-color: #E4E6EF;\n}\n.btn-check:checked + .btn.btn-active-secondary, .btn-check:active + .btn.btn-active-secondary, .btn.btn-active-secondary:focus:not(.btn-active), .btn.btn-active-secondary:hover:not(.btn-active), .btn.btn-active-secondary:active:not(.btn-active), .btn.btn-active-secondary.active, .btn.btn-active-secondary.show, .show > .btn.btn-active-secondary {\n  color: #3F4254;\n  border-color: #E4E6EF;\n  background-color: #E4E6EF !important;\n}\n.btn-check:checked + .btn.btn-active-secondary i, .btn-check:active + .btn.btn-active-secondary i, .btn.btn-active-secondary:focus:not(.btn-active) i, .btn.btn-active-secondary:hover:not(.btn-active) i, .btn.btn-active-secondary:active:not(.btn-active) i, .btn.btn-active-secondary.active i, .btn.btn-active-secondary.show i, .show > .btn.btn-active-secondary i {\n  color: #3F4254;\n}\n.btn-check:checked + .btn.btn-active-secondary .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-secondary .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-secondary:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-secondary:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-secondary:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-secondary.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-secondary.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-secondary .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #3F4254;\n}\n.btn-check:checked + .btn.btn-active-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-secondary:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-secondary:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-secondary:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-secondary.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-secondary.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-secondary.dropdown-toggle:after, .btn.btn-active-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary.active.dropdown-toggle:after, .btn.btn-active-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-secondary.dropdown-toggle:after {\n  color: #3F4254;\n}\n\n.btn.btn-success {\n  color: #FFFFFF;\n  border-color: #50CD89;\n  background-color: #50CD89;\n}\n.btn.btn-success i {\n  color: #FFFFFF;\n}\n.btn.btn-success .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.btn.btn-success .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-success.dropdown-toggle:after {\n  color: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-success, .btn-check:active + .btn.btn-success, .btn.btn-success:focus:not(.btn-active), .btn.btn-success:hover:not(.btn-active), .btn.btn-success:active:not(.btn-active), .btn.btn-success.active, .btn.btn-success.show, .show > .btn.btn-success {\n  color: #FFFFFF;\n  border-color: #47BE7D;\n  background-color: #47BE7D !important;\n}\n.btn-check:checked + .btn.btn-success i, .btn-check:active + .btn.btn-success i, .btn.btn-success:focus:not(.btn-active) i, .btn.btn-success:hover:not(.btn-active) i, .btn.btn-success:active:not(.btn-active) i, .btn.btn-success.active i, .btn.btn-success.show i, .show > .btn.btn-success i {\n  color: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-success .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-success .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-success:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-success:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-success:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-success.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-success.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-success .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-success:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-success:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-success:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-success.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-success.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-success .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-success.dropdown-toggle:after, .btn-check:active + .btn.btn-success.dropdown-toggle:after, .btn.btn-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-success.active.dropdown-toggle:after, .btn.btn-success.show.dropdown-toggle:after, .show > .btn.btn-success.dropdown-toggle:after {\n  color: #FFFFFF;\n}\n\n.btn.btn-light-success {\n  color: #50CD89;\n  border-color: #E8FFF3;\n  background-color: #E8FFF3;\n}\n.btn.btn-light-success i {\n  color: #50CD89;\n}\n.btn.btn-light-success .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #50CD89;\n}\n.btn.btn-light-success .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-light-success.dropdown-toggle:after {\n  color: #50CD89;\n}\n.btn-check:checked + .btn.btn-light-success, .btn-check:active + .btn.btn-light-success, .btn.btn-light-success:focus:not(.btn-active), .btn.btn-light-success:hover:not(.btn-active), .btn.btn-light-success:active:not(.btn-active), .btn.btn-light-success.active, .btn.btn-light-success.show, .show > .btn.btn-light-success {\n  color: #FFFFFF;\n  border-color: #50CD89;\n  background-color: #50CD89 !important;\n}\n.btn-check:checked + .btn.btn-light-success i, .btn-check:active + .btn.btn-light-success i, .btn.btn-light-success:focus:not(.btn-active) i, .btn.btn-light-success:hover:not(.btn-active) i, .btn.btn-light-success:active:not(.btn-active) i, .btn.btn-light-success.active i, .btn.btn-light-success.show i, .show > .btn.btn-light-success i {\n  color: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-light-success .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-success .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-success:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-success:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-success:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-success.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-success.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-success .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-light-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-success:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-success:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-success:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-success.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-success.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-success .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-light-success.dropdown-toggle:after, .btn-check:active + .btn.btn-light-success.dropdown-toggle:after, .btn.btn-light-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success.active.dropdown-toggle:after, .btn.btn-light-success.show.dropdown-toggle:after, .show > .btn.btn-light-success.dropdown-toggle:after {\n  color: #FFFFFF;\n}\n\n.btn.btn-bg-success {\n  border-color: #50CD89;\n  background-color: #50CD89;\n}\n.btn-check:checked + .btn.btn-active-success, .btn-check:active + .btn.btn-active-success, .btn.btn-active-success:focus:not(.btn-active), .btn.btn-active-success:hover:not(.btn-active), .btn.btn-active-success:active:not(.btn-active), .btn.btn-active-success.active, .btn.btn-active-success.show, .show > .btn.btn-active-success {\n  color: #FFFFFF;\n  border-color: #50CD89;\n  background-color: #50CD89 !important;\n}\n.btn-check:checked + .btn.btn-active-success i, .btn-check:active + .btn.btn-active-success i, .btn.btn-active-success:focus:not(.btn-active) i, .btn.btn-active-success:hover:not(.btn-active) i, .btn.btn-active-success:active:not(.btn-active) i, .btn.btn-active-success.active i, .btn.btn-active-success.show i, .show > .btn.btn-active-success i {\n  color: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-active-success .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-success .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-success:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-success:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-success:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-success.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-success.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-success .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-active-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-success:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-success:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-success:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-success.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-success.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-success .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-success.dropdown-toggle:after, .btn.btn-active-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success.active.dropdown-toggle:after, .btn.btn-active-success.show.dropdown-toggle:after, .show > .btn.btn-active-success.dropdown-toggle:after {\n  color: #FFFFFF;\n}\n\n.btn-check:checked + .btn.btn-active-light-success, .btn-check:active + .btn.btn-active-light-success, .btn.btn-active-light-success:focus:not(.btn-active), .btn.btn-active-light-success:hover:not(.btn-active), .btn.btn-active-light-success:active:not(.btn-active), .btn.btn-active-light-success.active, .btn.btn-active-light-success.show, .show > .btn.btn-active-light-success {\n  color: #50CD89;\n  border-color: #E8FFF3;\n  background-color: #E8FFF3 !important;\n}\n.btn-check:checked + .btn.btn-active-light-success i, .btn-check:active + .btn.btn-active-light-success i, .btn.btn-active-light-success:focus:not(.btn-active) i, .btn.btn-active-light-success:hover:not(.btn-active) i, .btn.btn-active-light-success:active:not(.btn-active) i, .btn.btn-active-light-success.active i, .btn.btn-active-light-success.show i, .show > .btn.btn-active-light-success i {\n  color: #50CD89;\n}\n.btn-check:checked + .btn.btn-active-light-success .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-success .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-success:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-success:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-success:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-success.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-success.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-success .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #50CD89;\n}\n.btn-check:checked + .btn.btn-active-light-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-success:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-success:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-success:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-success.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-success.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-success .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-light-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-success.dropdown-toggle:after, .btn.btn-active-light-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success.active.dropdown-toggle:after, .btn.btn-active-light-success.show.dropdown-toggle:after, .show > .btn.btn-active-light-success.dropdown-toggle:after {\n  color: #50CD89;\n}\n.btn.btn-active-light-success.btn-outline:not(.btn-outline-default) {\n  border-color: #50CD89 !important;\n}\n\n.btn.btn-info {\n  color: #FFFFFF;\n  border-color: #7239EA;\n  background-color: #7239EA;\n}\n.btn.btn-info i {\n  color: #FFFFFF;\n}\n.btn.btn-info .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.btn.btn-info .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-info.dropdown-toggle:after {\n  color: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-info, .btn-check:active + .btn.btn-info, .btn.btn-info:focus:not(.btn-active), .btn.btn-info:hover:not(.btn-active), .btn.btn-info:active:not(.btn-active), .btn.btn-info.active, .btn.btn-info.show, .show > .btn.btn-info {\n  color: #FFFFFF;\n  border-color: #5014D0;\n  background-color: #5014D0 !important;\n}\n.btn-check:checked + .btn.btn-info i, .btn-check:active + .btn.btn-info i, .btn.btn-info:focus:not(.btn-active) i, .btn.btn-info:hover:not(.btn-active) i, .btn.btn-info:active:not(.btn-active) i, .btn.btn-info.active i, .btn.btn-info.show i, .show > .btn.btn-info i {\n  color: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-info .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-info .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-info:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-info:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-info:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-info.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-info.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-info .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-info:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-info:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-info:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-info.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-info.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-info .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-info.dropdown-toggle:after, .btn-check:active + .btn.btn-info.dropdown-toggle:after, .btn.btn-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-info.active.dropdown-toggle:after, .btn.btn-info.show.dropdown-toggle:after, .show > .btn.btn-info.dropdown-toggle:after {\n  color: #FFFFFF;\n}\n\n.btn.btn-light-info {\n  color: #7239EA;\n  border-color: #F8F5FF;\n  background-color: #F8F5FF;\n}\n.btn.btn-light-info i {\n  color: #7239EA;\n}\n.btn.btn-light-info .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7239EA;\n}\n.btn.btn-light-info .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-light-info.dropdown-toggle:after {\n  color: #7239EA;\n}\n.btn-check:checked + .btn.btn-light-info, .btn-check:active + .btn.btn-light-info, .btn.btn-light-info:focus:not(.btn-active), .btn.btn-light-info:hover:not(.btn-active), .btn.btn-light-info:active:not(.btn-active), .btn.btn-light-info.active, .btn.btn-light-info.show, .show > .btn.btn-light-info {\n  color: #FFFFFF;\n  border-color: #7239EA;\n  background-color: #7239EA !important;\n}\n.btn-check:checked + .btn.btn-light-info i, .btn-check:active + .btn.btn-light-info i, .btn.btn-light-info:focus:not(.btn-active) i, .btn.btn-light-info:hover:not(.btn-active) i, .btn.btn-light-info:active:not(.btn-active) i, .btn.btn-light-info.active i, .btn.btn-light-info.show i, .show > .btn.btn-light-info i {\n  color: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-light-info .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-info .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-info:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-info:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-info:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-info.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-info.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-info .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-light-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-info:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-info:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-info:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-info.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-info.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-info .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-light-info.dropdown-toggle:after, .btn-check:active + .btn.btn-light-info.dropdown-toggle:after, .btn.btn-light-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info.active.dropdown-toggle:after, .btn.btn-light-info.show.dropdown-toggle:after, .show > .btn.btn-light-info.dropdown-toggle:after {\n  color: #FFFFFF;\n}\n\n.btn.btn-bg-info {\n  border-color: #7239EA;\n  background-color: #7239EA;\n}\n.btn-check:checked + .btn.btn-active-info, .btn-check:active + .btn.btn-active-info, .btn.btn-active-info:focus:not(.btn-active), .btn.btn-active-info:hover:not(.btn-active), .btn.btn-active-info:active:not(.btn-active), .btn.btn-active-info.active, .btn.btn-active-info.show, .show > .btn.btn-active-info {\n  color: #FFFFFF;\n  border-color: #7239EA;\n  background-color: #7239EA !important;\n}\n.btn-check:checked + .btn.btn-active-info i, .btn-check:active + .btn.btn-active-info i, .btn.btn-active-info:focus:not(.btn-active) i, .btn.btn-active-info:hover:not(.btn-active) i, .btn.btn-active-info:active:not(.btn-active) i, .btn.btn-active-info.active i, .btn.btn-active-info.show i, .show > .btn.btn-active-info i {\n  color: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-active-info .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-info .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-info:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-info:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-info:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-info.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-info.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-info .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-active-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-info:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-info:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-info:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-info.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-info.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-info .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-info.dropdown-toggle:after, .btn.btn-active-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info.active.dropdown-toggle:after, .btn.btn-active-info.show.dropdown-toggle:after, .show > .btn.btn-active-info.dropdown-toggle:after {\n  color: #FFFFFF;\n}\n\n.btn-check:checked + .btn.btn-active-light-info, .btn-check:active + .btn.btn-active-light-info, .btn.btn-active-light-info:focus:not(.btn-active), .btn.btn-active-light-info:hover:not(.btn-active), .btn.btn-active-light-info:active:not(.btn-active), .btn.btn-active-light-info.active, .btn.btn-active-light-info.show, .show > .btn.btn-active-light-info {\n  color: #7239EA;\n  border-color: #F8F5FF;\n  background-color: #F8F5FF !important;\n}\n.btn-check:checked + .btn.btn-active-light-info i, .btn-check:active + .btn.btn-active-light-info i, .btn.btn-active-light-info:focus:not(.btn-active) i, .btn.btn-active-light-info:hover:not(.btn-active) i, .btn.btn-active-light-info:active:not(.btn-active) i, .btn.btn-active-light-info.active i, .btn.btn-active-light-info.show i, .show > .btn.btn-active-light-info i {\n  color: #7239EA;\n}\n.btn-check:checked + .btn.btn-active-light-info .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-info .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-info:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-info:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-info:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-info.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-info.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-info .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7239EA;\n}\n.btn-check:checked + .btn.btn-active-light-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-info:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-info:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-info:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-info.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-info.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-info .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-light-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-info.dropdown-toggle:after, .btn.btn-active-light-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info.active.dropdown-toggle:after, .btn.btn-active-light-info.show.dropdown-toggle:after, .show > .btn.btn-active-light-info.dropdown-toggle:after {\n  color: #7239EA;\n}\n.btn.btn-active-light-info.btn-outline:not(.btn-outline-default) {\n  border-color: #7239EA !important;\n}\n\n.btn.btn-warning {\n  color: #FFFFFF;\n  border-color: #FFC700;\n  background-color: #FFC700;\n}\n.btn.btn-warning i {\n  color: #FFFFFF;\n}\n.btn.btn-warning .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.btn.btn-warning .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-warning.dropdown-toggle:after {\n  color: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-warning, .btn-check:active + .btn.btn-warning, .btn.btn-warning:focus:not(.btn-active), .btn.btn-warning:hover:not(.btn-active), .btn.btn-warning:active:not(.btn-active), .btn.btn-warning.active, .btn.btn-warning.show, .show > .btn.btn-warning {\n  color: #FFFFFF;\n  border-color: #F1BC00;\n  background-color: #F1BC00 !important;\n}\n.btn-check:checked + .btn.btn-warning i, .btn-check:active + .btn.btn-warning i, .btn.btn-warning:focus:not(.btn-active) i, .btn.btn-warning:hover:not(.btn-active) i, .btn.btn-warning:active:not(.btn-active) i, .btn.btn-warning.active i, .btn.btn-warning.show i, .show > .btn.btn-warning i {\n  color: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-warning:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-warning:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-warning:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-warning.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-warning.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-warning .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-warning:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-warning:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-warning:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-warning.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-warning.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-warning .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-warning.dropdown-toggle:after, .btn.btn-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-warning.active.dropdown-toggle:after, .btn.btn-warning.show.dropdown-toggle:after, .show > .btn.btn-warning.dropdown-toggle:after {\n  color: #FFFFFF;\n}\n\n.btn.btn-light-warning {\n  color: #FFC700;\n  border-color: #FFF8DD;\n  background-color: #FFF8DD;\n}\n.btn.btn-light-warning i {\n  color: #FFC700;\n}\n.btn.btn-light-warning .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFC700;\n}\n.btn.btn-light-warning .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-light-warning.dropdown-toggle:after {\n  color: #FFC700;\n}\n.btn-check:checked + .btn.btn-light-warning, .btn-check:active + .btn.btn-light-warning, .btn.btn-light-warning:focus:not(.btn-active), .btn.btn-light-warning:hover:not(.btn-active), .btn.btn-light-warning:active:not(.btn-active), .btn.btn-light-warning.active, .btn.btn-light-warning.show, .show > .btn.btn-light-warning {\n  color: #FFFFFF;\n  border-color: #FFC700;\n  background-color: #FFC700 !important;\n}\n.btn-check:checked + .btn.btn-light-warning i, .btn-check:active + .btn.btn-light-warning i, .btn.btn-light-warning:focus:not(.btn-active) i, .btn.btn-light-warning:hover:not(.btn-active) i, .btn.btn-light-warning:active:not(.btn-active) i, .btn.btn-light-warning.active i, .btn.btn-light-warning.show i, .show > .btn.btn-light-warning i {\n  color: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-light-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-warning:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-warning:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-warning:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-warning.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-warning.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-warning .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-light-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-warning:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-warning:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-warning:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-warning.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-warning.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-warning .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-light-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-light-warning.dropdown-toggle:after, .btn.btn-light-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning.active.dropdown-toggle:after, .btn.btn-light-warning.show.dropdown-toggle:after, .show > .btn.btn-light-warning.dropdown-toggle:after {\n  color: #FFFFFF;\n}\n\n.btn.btn-bg-warning {\n  border-color: #FFC700;\n  background-color: #FFC700;\n}\n.btn-check:checked + .btn.btn-active-warning, .btn-check:active + .btn.btn-active-warning, .btn.btn-active-warning:focus:not(.btn-active), .btn.btn-active-warning:hover:not(.btn-active), .btn.btn-active-warning:active:not(.btn-active), .btn.btn-active-warning.active, .btn.btn-active-warning.show, .show > .btn.btn-active-warning {\n  color: #FFFFFF;\n  border-color: #FFC700;\n  background-color: #FFC700 !important;\n}\n.btn-check:checked + .btn.btn-active-warning i, .btn-check:active + .btn.btn-active-warning i, .btn.btn-active-warning:focus:not(.btn-active) i, .btn.btn-active-warning:hover:not(.btn-active) i, .btn.btn-active-warning:active:not(.btn-active) i, .btn.btn-active-warning.active i, .btn.btn-active-warning.show i, .show > .btn.btn-active-warning i {\n  color: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-active-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-warning:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-warning:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-warning:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-warning.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-warning.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-warning .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-active-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-warning:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-warning:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-warning:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-warning.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-warning.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-warning .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-warning.dropdown-toggle:after, .btn.btn-active-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning.active.dropdown-toggle:after, .btn.btn-active-warning.show.dropdown-toggle:after, .show > .btn.btn-active-warning.dropdown-toggle:after {\n  color: #FFFFFF;\n}\n\n.btn-check:checked + .btn.btn-active-light-warning, .btn-check:active + .btn.btn-active-light-warning, .btn.btn-active-light-warning:focus:not(.btn-active), .btn.btn-active-light-warning:hover:not(.btn-active), .btn.btn-active-light-warning:active:not(.btn-active), .btn.btn-active-light-warning.active, .btn.btn-active-light-warning.show, .show > .btn.btn-active-light-warning {\n  color: #FFC700;\n  border-color: #FFF8DD;\n  background-color: #FFF8DD !important;\n}\n.btn-check:checked + .btn.btn-active-light-warning i, .btn-check:active + .btn.btn-active-light-warning i, .btn.btn-active-light-warning:focus:not(.btn-active) i, .btn.btn-active-light-warning:hover:not(.btn-active) i, .btn.btn-active-light-warning:active:not(.btn-active) i, .btn.btn-active-light-warning.active i, .btn.btn-active-light-warning.show i, .show > .btn.btn-active-light-warning i {\n  color: #FFC700;\n}\n.btn-check:checked + .btn.btn-active-light-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-warning:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-warning:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-warning:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-warning.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-warning.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-warning .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFC700;\n}\n.btn-check:checked + .btn.btn-active-light-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-warning:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-warning:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-warning:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-warning.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-warning.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-warning .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-light-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-warning.dropdown-toggle:after, .btn.btn-active-light-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning.active.dropdown-toggle:after, .btn.btn-active-light-warning.show.dropdown-toggle:after, .show > .btn.btn-active-light-warning.dropdown-toggle:after {\n  color: #FFC700;\n}\n.btn.btn-active-light-warning.btn-outline:not(.btn-outline-default) {\n  border-color: #FFC700 !important;\n}\n\n.btn.btn-danger {\n  color: #FFFFFF;\n  border-color: #F1416C;\n  background-color: #F1416C;\n}\n.btn.btn-danger i {\n  color: #FFFFFF;\n}\n.btn.btn-danger .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.btn.btn-danger .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-danger.dropdown-toggle:after {\n  color: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-danger, .btn-check:active + .btn.btn-danger, .btn.btn-danger:focus:not(.btn-active), .btn.btn-danger:hover:not(.btn-active), .btn.btn-danger:active:not(.btn-active), .btn.btn-danger.active, .btn.btn-danger.show, .show > .btn.btn-danger {\n  color: #FFFFFF;\n  border-color: #D9214E;\n  background-color: #D9214E !important;\n}\n.btn-check:checked + .btn.btn-danger i, .btn-check:active + .btn.btn-danger i, .btn.btn-danger:focus:not(.btn-active) i, .btn.btn-danger:hover:not(.btn-active) i, .btn.btn-danger:active:not(.btn-active) i, .btn.btn-danger.active i, .btn.btn-danger.show i, .show > .btn.btn-danger i {\n  color: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-danger:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-danger:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-danger:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-danger.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-danger.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-danger .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-danger:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-danger:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-danger:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-danger.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-danger.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-danger .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-danger.dropdown-toggle:after, .btn.btn-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-danger.active.dropdown-toggle:after, .btn.btn-danger.show.dropdown-toggle:after, .show > .btn.btn-danger.dropdown-toggle:after {\n  color: #FFFFFF;\n}\n\n.btn.btn-light-danger {\n  color: #F1416C;\n  border-color: #FFF5F8;\n  background-color: #FFF5F8;\n}\n.btn.btn-light-danger i {\n  color: #F1416C;\n}\n.btn.btn-light-danger .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F1416C;\n}\n.btn.btn-light-danger .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-light-danger.dropdown-toggle:after {\n  color: #F1416C;\n}\n.btn-check:checked + .btn.btn-light-danger, .btn-check:active + .btn.btn-light-danger, .btn.btn-light-danger:focus:not(.btn-active), .btn.btn-light-danger:hover:not(.btn-active), .btn.btn-light-danger:active:not(.btn-active), .btn.btn-light-danger.active, .btn.btn-light-danger.show, .show > .btn.btn-light-danger {\n  color: #FFFFFF;\n  border-color: #F1416C;\n  background-color: #F1416C !important;\n}\n.btn-check:checked + .btn.btn-light-danger i, .btn-check:active + .btn.btn-light-danger i, .btn.btn-light-danger:focus:not(.btn-active) i, .btn.btn-light-danger:hover:not(.btn-active) i, .btn.btn-light-danger:active:not(.btn-active) i, .btn.btn-light-danger.active i, .btn.btn-light-danger.show i, .show > .btn.btn-light-danger i {\n  color: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-light-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-danger:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-danger:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-danger:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-danger.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-danger.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-danger .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-light-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-danger:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-danger:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-danger:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-danger.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-danger.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-danger .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-light-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-light-danger.dropdown-toggle:after, .btn.btn-light-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger.active.dropdown-toggle:after, .btn.btn-light-danger.show.dropdown-toggle:after, .show > .btn.btn-light-danger.dropdown-toggle:after {\n  color: #FFFFFF;\n}\n\n.btn.btn-bg-danger {\n  border-color: #F1416C;\n  background-color: #F1416C;\n}\n.btn-check:checked + .btn.btn-active-danger, .btn-check:active + .btn.btn-active-danger, .btn.btn-active-danger:focus:not(.btn-active), .btn.btn-active-danger:hover:not(.btn-active), .btn.btn-active-danger:active:not(.btn-active), .btn.btn-active-danger.active, .btn.btn-active-danger.show, .show > .btn.btn-active-danger {\n  color: #FFFFFF;\n  border-color: #F1416C;\n  background-color: #F1416C !important;\n}\n.btn-check:checked + .btn.btn-active-danger i, .btn-check:active + .btn.btn-active-danger i, .btn.btn-active-danger:focus:not(.btn-active) i, .btn.btn-active-danger:hover:not(.btn-active) i, .btn.btn-active-danger:active:not(.btn-active) i, .btn.btn-active-danger.active i, .btn.btn-active-danger.show i, .show > .btn.btn-active-danger i {\n  color: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-active-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-danger:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-danger:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-danger:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-danger.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-danger.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-danger .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFFFFF;\n}\n.btn-check:checked + .btn.btn-active-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-danger:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-danger:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-danger:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-danger.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-danger.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-danger .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-danger.dropdown-toggle:after, .btn.btn-active-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger.active.dropdown-toggle:after, .btn.btn-active-danger.show.dropdown-toggle:after, .show > .btn.btn-active-danger.dropdown-toggle:after {\n  color: #FFFFFF;\n}\n\n.btn-check:checked + .btn.btn-active-light-danger, .btn-check:active + .btn.btn-active-light-danger, .btn.btn-active-light-danger:focus:not(.btn-active), .btn.btn-active-light-danger:hover:not(.btn-active), .btn.btn-active-light-danger:active:not(.btn-active), .btn.btn-active-light-danger.active, .btn.btn-active-light-danger.show, .show > .btn.btn-active-light-danger {\n  color: #F1416C;\n  border-color: #FFF5F8;\n  background-color: #FFF5F8 !important;\n}\n.btn-check:checked + .btn.btn-active-light-danger i, .btn-check:active + .btn.btn-active-light-danger i, .btn.btn-active-light-danger:focus:not(.btn-active) i, .btn.btn-active-light-danger:hover:not(.btn-active) i, .btn.btn-active-light-danger:active:not(.btn-active) i, .btn.btn-active-light-danger.active i, .btn.btn-active-light-danger.show i, .show > .btn.btn-active-light-danger i {\n  color: #F1416C;\n}\n.btn-check:checked + .btn.btn-active-light-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-danger:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-danger:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-danger:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-danger.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-danger.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-danger .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F1416C;\n}\n.btn-check:checked + .btn.btn-active-light-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-danger:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-danger:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-danger:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-danger.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-danger.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-danger .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-light-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-danger.dropdown-toggle:after, .btn.btn-active-light-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger.active.dropdown-toggle:after, .btn.btn-active-light-danger.show.dropdown-toggle:after, .show > .btn.btn-active-light-danger.dropdown-toggle:after {\n  color: #F1416C;\n}\n.btn.btn-active-light-danger.btn-outline:not(.btn-outline-default) {\n  border-color: #F1416C !important;\n}\n\n.btn.btn-dark {\n  color: #ffffff;\n  border-color: #181C32;\n  background-color: #181C32;\n}\n.btn.btn-dark i {\n  color: #ffffff;\n}\n.btn.btn-dark .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.btn.btn-dark .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-dark.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-dark, .btn-check:active + .btn.btn-dark, .btn.btn-dark:focus:not(.btn-active), .btn.btn-dark:hover:not(.btn-active), .btn.btn-dark:active:not(.btn-active), .btn.btn-dark.active, .btn.btn-dark.show, .show > .btn.btn-dark {\n  color: #ffffff;\n  border-color: #131628;\n  background-color: #131628 !important;\n}\n.btn-check:checked + .btn.btn-dark i, .btn-check:active + .btn.btn-dark i, .btn.btn-dark:focus:not(.btn-active) i, .btn.btn-dark:hover:not(.btn-active) i, .btn.btn-dark:active:not(.btn-active) i, .btn.btn-dark.active i, .btn.btn-dark.show i, .show > .btn.btn-dark i {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-dark:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-dark:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-dark:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-dark.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-dark.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-dark .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.btn-check:checked + .btn.btn-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-dark:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-dark:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-dark:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-dark.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-dark.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-dark .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-dark.dropdown-toggle:after, .btn.btn-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-dark.active.dropdown-toggle:after, .btn.btn-dark.show.dropdown-toggle:after, .show > .btn.btn-dark.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-light-dark {\n  color: #181C32;\n  border-color: #EFF2F5;\n  background-color: #EFF2F5;\n}\n.btn.btn-light-dark i {\n  color: #181C32;\n}\n.btn.btn-light-dark .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #181C32;\n}\n.btn.btn-light-dark .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-light-dark.dropdown-toggle:after {\n  color: #181C32;\n}\n.btn-check:checked + .btn.btn-light-dark, .btn-check:active + .btn.btn-light-dark, .btn.btn-light-dark:focus:not(.btn-active), .btn.btn-light-dark:hover:not(.btn-active), .btn.btn-light-dark:active:not(.btn-active), .btn.btn-light-dark.active, .btn.btn-light-dark.show, .show > .btn.btn-light-dark {\n  color: #ffffff;\n  border-color: #181C32;\n  background-color: #181C32 !important;\n}\n.btn-check:checked + .btn.btn-light-dark i, .btn-check:active + .btn.btn-light-dark i, .btn.btn-light-dark:focus:not(.btn-active) i, .btn.btn-light-dark:hover:not(.btn-active) i, .btn.btn-light-dark:active:not(.btn-active) i, .btn.btn-light-dark.active i, .btn.btn-light-dark.show i, .show > .btn.btn-light-dark i {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-dark:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-dark:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-dark:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-dark.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-dark.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-dark .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-dark:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-dark:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-dark:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-dark.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-dark.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-dark .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-light-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-light-dark.dropdown-toggle:after, .btn.btn-light-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark.active.dropdown-toggle:after, .btn.btn-light-dark.show.dropdown-toggle:after, .show > .btn.btn-light-dark.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-bg-dark {\n  border-color: #181C32;\n  background-color: #181C32;\n}\n.btn-check:checked + .btn.btn-active-dark, .btn-check:active + .btn.btn-active-dark, .btn.btn-active-dark:focus:not(.btn-active), .btn.btn-active-dark:hover:not(.btn-active), .btn.btn-active-dark:active:not(.btn-active), .btn.btn-active-dark.active, .btn.btn-active-dark.show, .show > .btn.btn-active-dark {\n  color: #ffffff;\n  border-color: #181C32;\n  background-color: #181C32 !important;\n}\n.btn-check:checked + .btn.btn-active-dark i, .btn-check:active + .btn.btn-active-dark i, .btn.btn-active-dark:focus:not(.btn-active) i, .btn.btn-active-dark:hover:not(.btn-active) i, .btn.btn-active-dark:active:not(.btn-active) i, .btn.btn-active-dark.active i, .btn.btn-active-dark.show i, .show > .btn.btn-active-dark i {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-active-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-dark:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-dark:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-dark:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-dark.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-dark.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-dark .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.btn-check:checked + .btn.btn-active-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-dark:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-dark:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-dark:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-dark.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-dark.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-dark .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-dark.dropdown-toggle:after, .btn.btn-active-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark.active.dropdown-toggle:after, .btn.btn-active-dark.show.dropdown-toggle:after, .show > .btn.btn-active-dark.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn-check:checked + .btn.btn-active-light-dark, .btn-check:active + .btn.btn-active-light-dark, .btn.btn-active-light-dark:focus:not(.btn-active), .btn.btn-active-light-dark:hover:not(.btn-active), .btn.btn-active-light-dark:active:not(.btn-active), .btn.btn-active-light-dark.active, .btn.btn-active-light-dark.show, .show > .btn.btn-active-light-dark {\n  color: #181C32;\n  border-color: #EFF2F5;\n  background-color: #EFF2F5 !important;\n}\n.btn-check:checked + .btn.btn-active-light-dark i, .btn-check:active + .btn.btn-active-light-dark i, .btn.btn-active-light-dark:focus:not(.btn-active) i, .btn.btn-active-light-dark:hover:not(.btn-active) i, .btn.btn-active-light-dark:active:not(.btn-active) i, .btn.btn-active-light-dark.active i, .btn.btn-active-light-dark.show i, .show > .btn.btn-active-light-dark i {\n  color: #181C32;\n}\n.btn-check:checked + .btn.btn-active-light-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-dark:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-dark:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-dark:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-dark.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-light-dark.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-dark .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #181C32;\n}\n.btn-check:checked + .btn.btn-active-light-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-light-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-dark:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-dark:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-dark:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-dark.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-light-dark.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-light-dark .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-light-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-dark.dropdown-toggle:after, .btn.btn-active-light-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark.active.dropdown-toggle:after, .btn.btn-active-light-dark.show.dropdown-toggle:after, .show > .btn.btn-active-light-dark.dropdown-toggle:after {\n  color: #181C32;\n}\n.btn.btn-active-light-dark.btn-outline:not(.btn-outline-default) {\n  border-color: #181C32 !important;\n}\n\n.btn.btn-color-white {\n  color: #ffffff;\n}\n.btn.btn-color-white i {\n  color: #ffffff;\n}\n.btn.btn-color-white .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.btn.btn-color-white .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-color-white.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-active-color-white, .btn-check:active + .btn.btn-active-color-white, .btn.btn-active-color-white:focus:not(.btn-active), .btn.btn-active-color-white:hover:not(.btn-active), .btn.btn-active-color-white:active:not(.btn-active), .btn.btn-active-color-white.active, .btn.btn-active-color-white.show, .show > .btn.btn-active-color-white {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-active-color-white i, .btn-check:active + .btn.btn-active-color-white i, .btn.btn-active-color-white:focus:not(.btn-active) i, .btn.btn-active-color-white:hover:not(.btn-active) i, .btn.btn-active-color-white:active:not(.btn-active) i, .btn.btn-active-color-white.active i, .btn.btn-active-color-white.show i, .show > .btn.btn-active-color-white i {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-active-color-white .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-white .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-white:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-white:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-white:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-white.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-white.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-white .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.btn-check:checked + .btn.btn-active-color-white .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-white .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-white:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-white:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-white:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-white.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-white.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-white .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-color-white.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-white.dropdown-toggle:after, .btn.btn-active-color-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white.active.dropdown-toggle:after, .btn.btn-active-color-white.show.dropdown-toggle:after, .show > .btn.btn-active-color-white.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-icon-white i {\n  color: #ffffff;\n}\n.btn.btn-icon-white .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.btn.btn-icon-white .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-icon-white.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-active-icon-white i, .btn-check:active + .btn.btn-active-icon-white i, .btn.btn-active-icon-white:focus:not(.btn-active) i, .btn.btn-active-icon-white:hover:not(.btn-active) i, .btn.btn-active-icon-white:active:not(.btn-active) i, .btn.btn-active-icon-white.active i, .btn.btn-active-icon-white.show i, .show > .btn.btn-active-icon-white i {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-active-icon-white .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-white .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-white:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-white:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-white:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-white.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-white.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-white .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.btn-check:checked + .btn.btn-active-icon-white .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-white .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-white:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-white:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-white:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-white.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-white.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-white .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-icon-white.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-white.dropdown-toggle:after, .btn.btn-active-icon-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white.active.dropdown-toggle:after, .btn.btn-active-icon-white.show.dropdown-toggle:after, .show > .btn.btn-active-icon-white.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-text-white {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-active-text-white, .btn-check:active + .btn.btn-active-text-white, .btn.btn-active-text-white:focus:not(.btn-active), .btn.btn-active-text-white:hover:not(.btn-active), .btn.btn-active-text-white:active:not(.btn-active), .btn.btn-active-text-white.active, .btn.btn-active-text-white.show, .show > .btn.btn-active-text-white {\n  color: #ffffff;\n}\n\n.btn.btn-color-primary {\n  color: #009EF7;\n}\n.btn.btn-color-primary i {\n  color: #009EF7;\n}\n.btn.btn-color-primary .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.btn.btn-color-primary .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-color-primary.dropdown-toggle:after {\n  color: #009EF7;\n}\n.btn-check:checked + .btn.btn-active-color-primary, .btn-check:active + .btn.btn-active-color-primary, .btn.btn-active-color-primary:focus:not(.btn-active), .btn.btn-active-color-primary:hover:not(.btn-active), .btn.btn-active-color-primary:active:not(.btn-active), .btn.btn-active-color-primary.active, .btn.btn-active-color-primary.show, .show > .btn.btn-active-color-primary {\n  color: #009EF7;\n}\n.btn-check:checked + .btn.btn-active-color-primary i, .btn-check:active + .btn.btn-active-color-primary i, .btn.btn-active-color-primary:focus:not(.btn-active) i, .btn.btn-active-color-primary:hover:not(.btn-active) i, .btn.btn-active-color-primary:active:not(.btn-active) i, .btn.btn-active-color-primary.active i, .btn.btn-active-color-primary.show i, .show > .btn.btn-active-color-primary i {\n  color: #009EF7;\n}\n.btn-check:checked + .btn.btn-active-color-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-primary:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-primary:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-primary:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-primary.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-primary.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-primary .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.btn-check:checked + .btn.btn-active-color-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-primary:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-primary:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-primary:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-primary.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-primary.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-primary .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-color-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-primary.dropdown-toggle:after, .btn.btn-active-color-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary.active.dropdown-toggle:after, .btn.btn-active-color-primary.show.dropdown-toggle:after, .show > .btn.btn-active-color-primary.dropdown-toggle:after {\n  color: #009EF7;\n}\n\n.btn.btn-icon-primary i {\n  color: #009EF7;\n}\n.btn.btn-icon-primary .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.btn.btn-icon-primary .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-icon-primary.dropdown-toggle:after {\n  color: #009EF7;\n}\n.btn-check:checked + .btn.btn-active-icon-primary i, .btn-check:active + .btn.btn-active-icon-primary i, .btn.btn-active-icon-primary:focus:not(.btn-active) i, .btn.btn-active-icon-primary:hover:not(.btn-active) i, .btn.btn-active-icon-primary:active:not(.btn-active) i, .btn.btn-active-icon-primary.active i, .btn.btn-active-icon-primary.show i, .show > .btn.btn-active-icon-primary i {\n  color: #009EF7;\n}\n.btn-check:checked + .btn.btn-active-icon-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-primary .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-primary:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-primary:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-primary:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-primary.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-primary.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-primary .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.btn-check:checked + .btn.btn-active-icon-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-primary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-primary:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-primary:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-primary:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-primary.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-primary.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-primary .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-icon-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-primary.dropdown-toggle:after, .btn.btn-active-icon-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary.active.dropdown-toggle:after, .btn.btn-active-icon-primary.show.dropdown-toggle:after, .show > .btn.btn-active-icon-primary.dropdown-toggle:after {\n  color: #009EF7;\n}\n\n.btn.btn-text-primary {\n  color: #009EF7;\n}\n.btn-check:checked + .btn.btn-active-text-primary, .btn-check:active + .btn.btn-active-text-primary, .btn.btn-active-text-primary:focus:not(.btn-active), .btn.btn-active-text-primary:hover:not(.btn-active), .btn.btn-active-text-primary:active:not(.btn-active), .btn.btn-active-text-primary.active, .btn.btn-active-text-primary.show, .show > .btn.btn-active-text-primary {\n  color: #009EF7;\n}\n\n.btn.btn-color-secondary {\n  color: #E4E6EF;\n}\n.btn.btn-color-secondary i {\n  color: #E4E6EF;\n}\n.btn.btn-color-secondary .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #E4E6EF;\n}\n.btn.btn-color-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-color-secondary.dropdown-toggle:after {\n  color: #E4E6EF;\n}\n.btn-check:checked + .btn.btn-active-color-secondary, .btn-check:active + .btn.btn-active-color-secondary, .btn.btn-active-color-secondary:focus:not(.btn-active), .btn.btn-active-color-secondary:hover:not(.btn-active), .btn.btn-active-color-secondary:active:not(.btn-active), .btn.btn-active-color-secondary.active, .btn.btn-active-color-secondary.show, .show > .btn.btn-active-color-secondary {\n  color: #E4E6EF;\n}\n.btn-check:checked + .btn.btn-active-color-secondary i, .btn-check:active + .btn.btn-active-color-secondary i, .btn.btn-active-color-secondary:focus:not(.btn-active) i, .btn.btn-active-color-secondary:hover:not(.btn-active) i, .btn.btn-active-color-secondary:active:not(.btn-active) i, .btn.btn-active-color-secondary.active i, .btn.btn-active-color-secondary.show i, .show > .btn.btn-active-color-secondary i {\n  color: #E4E6EF;\n}\n.btn-check:checked + .btn.btn-active-color-secondary .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-secondary .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-secondary:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-secondary:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-secondary:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-secondary.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-secondary.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-secondary .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #E4E6EF;\n}\n.btn-check:checked + .btn.btn-active-color-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-secondary:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-secondary:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-secondary:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-secondary.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-secondary.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-color-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-secondary.dropdown-toggle:after, .btn.btn-active-color-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary.active.dropdown-toggle:after, .btn.btn-active-color-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-color-secondary.dropdown-toggle:after {\n  color: #E4E6EF;\n}\n\n.btn.btn-icon-secondary i {\n  color: #E4E6EF;\n}\n.btn.btn-icon-secondary .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #E4E6EF;\n}\n.btn.btn-icon-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-icon-secondary.dropdown-toggle:after {\n  color: #E4E6EF;\n}\n.btn-check:checked + .btn.btn-active-icon-secondary i, .btn-check:active + .btn.btn-active-icon-secondary i, .btn.btn-active-icon-secondary:focus:not(.btn-active) i, .btn.btn-active-icon-secondary:hover:not(.btn-active) i, .btn.btn-active-icon-secondary:active:not(.btn-active) i, .btn.btn-active-icon-secondary.active i, .btn.btn-active-icon-secondary.show i, .show > .btn.btn-active-icon-secondary i {\n  color: #E4E6EF;\n}\n.btn-check:checked + .btn.btn-active-icon-secondary .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-secondary .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-secondary:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-secondary:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-secondary:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-secondary.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-secondary.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-secondary .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #E4E6EF;\n}\n.btn-check:checked + .btn.btn-active-icon-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-secondary:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-secondary:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-secondary:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-secondary.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-secondary.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-secondary .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-icon-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-secondary.dropdown-toggle:after, .btn.btn-active-icon-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary.active.dropdown-toggle:after, .btn.btn-active-icon-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-icon-secondary.dropdown-toggle:after {\n  color: #E4E6EF;\n}\n\n.btn.btn-text-secondary {\n  color: #E4E6EF;\n}\n.btn-check:checked + .btn.btn-active-text-secondary, .btn-check:active + .btn.btn-active-text-secondary, .btn.btn-active-text-secondary:focus:not(.btn-active), .btn.btn-active-text-secondary:hover:not(.btn-active), .btn.btn-active-text-secondary:active:not(.btn-active), .btn.btn-active-text-secondary.active, .btn.btn-active-text-secondary.show, .show > .btn.btn-active-text-secondary {\n  color: #E4E6EF;\n}\n\n.btn.btn-color-light {\n  color: #F5F8FA;\n}\n.btn.btn-color-light i {\n  color: #F5F8FA;\n}\n.btn.btn-color-light .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F5F8FA;\n}\n.btn.btn-color-light .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-color-light.dropdown-toggle:after {\n  color: #F5F8FA;\n}\n.btn-check:checked + .btn.btn-active-color-light, .btn-check:active + .btn.btn-active-color-light, .btn.btn-active-color-light:focus:not(.btn-active), .btn.btn-active-color-light:hover:not(.btn-active), .btn.btn-active-color-light:active:not(.btn-active), .btn.btn-active-color-light.active, .btn.btn-active-color-light.show, .show > .btn.btn-active-color-light {\n  color: #F5F8FA;\n}\n.btn-check:checked + .btn.btn-active-color-light i, .btn-check:active + .btn.btn-active-color-light i, .btn.btn-active-color-light:focus:not(.btn-active) i, .btn.btn-active-color-light:hover:not(.btn-active) i, .btn.btn-active-color-light:active:not(.btn-active) i, .btn.btn-active-color-light.active i, .btn.btn-active-color-light.show i, .show > .btn.btn-active-color-light i {\n  color: #F5F8FA;\n}\n.btn-check:checked + .btn.btn-active-color-light .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-light .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-light:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-light:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-light:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-light.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-light.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-light .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F5F8FA;\n}\n.btn-check:checked + .btn.btn-active-color-light .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-light .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-light:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-light:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-light:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-light.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-light.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-light .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-color-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-light.dropdown-toggle:after, .btn.btn-active-color-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light.active.dropdown-toggle:after, .btn.btn-active-color-light.show.dropdown-toggle:after, .show > .btn.btn-active-color-light.dropdown-toggle:after {\n  color: #F5F8FA;\n}\n\n.btn.btn-icon-light i {\n  color: #F5F8FA;\n}\n.btn.btn-icon-light .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F5F8FA;\n}\n.btn.btn-icon-light .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-icon-light.dropdown-toggle:after {\n  color: #F5F8FA;\n}\n.btn-check:checked + .btn.btn-active-icon-light i, .btn-check:active + .btn.btn-active-icon-light i, .btn.btn-active-icon-light:focus:not(.btn-active) i, .btn.btn-active-icon-light:hover:not(.btn-active) i, .btn.btn-active-icon-light:active:not(.btn-active) i, .btn.btn-active-icon-light.active i, .btn.btn-active-icon-light.show i, .show > .btn.btn-active-icon-light i {\n  color: #F5F8FA;\n}\n.btn-check:checked + .btn.btn-active-icon-light .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-light .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-light:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-light:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-light:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-light.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-light.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-light .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F5F8FA;\n}\n.btn-check:checked + .btn.btn-active-icon-light .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-light .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-light:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-light:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-light:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-light.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-light.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-light .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-icon-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-light.dropdown-toggle:after, .btn.btn-active-icon-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light.active.dropdown-toggle:after, .btn.btn-active-icon-light.show.dropdown-toggle:after, .show > .btn.btn-active-icon-light.dropdown-toggle:after {\n  color: #F5F8FA;\n}\n\n.btn.btn-text-light {\n  color: #F5F8FA;\n}\n.btn-check:checked + .btn.btn-active-text-light, .btn-check:active + .btn.btn-active-text-light, .btn.btn-active-text-light:focus:not(.btn-active), .btn.btn-active-text-light:hover:not(.btn-active), .btn.btn-active-text-light:active:not(.btn-active), .btn.btn-active-text-light.active, .btn.btn-active-text-light.show, .show > .btn.btn-active-text-light {\n  color: #F5F8FA;\n}\n\n.btn.btn-color-success {\n  color: #50CD89;\n}\n.btn.btn-color-success i {\n  color: #50CD89;\n}\n.btn.btn-color-success .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #50CD89;\n}\n.btn.btn-color-success .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-color-success.dropdown-toggle:after {\n  color: #50CD89;\n}\n.btn-check:checked + .btn.btn-active-color-success, .btn-check:active + .btn.btn-active-color-success, .btn.btn-active-color-success:focus:not(.btn-active), .btn.btn-active-color-success:hover:not(.btn-active), .btn.btn-active-color-success:active:not(.btn-active), .btn.btn-active-color-success.active, .btn.btn-active-color-success.show, .show > .btn.btn-active-color-success {\n  color: #50CD89;\n}\n.btn-check:checked + .btn.btn-active-color-success i, .btn-check:active + .btn.btn-active-color-success i, .btn.btn-active-color-success:focus:not(.btn-active) i, .btn.btn-active-color-success:hover:not(.btn-active) i, .btn.btn-active-color-success:active:not(.btn-active) i, .btn.btn-active-color-success.active i, .btn.btn-active-color-success.show i, .show > .btn.btn-active-color-success i {\n  color: #50CD89;\n}\n.btn-check:checked + .btn.btn-active-color-success .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-success .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-success:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-success:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-success:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-success.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-success.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-success .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #50CD89;\n}\n.btn-check:checked + .btn.btn-active-color-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-success:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-success:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-success:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-success.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-success.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-success .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-color-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-success.dropdown-toggle:after, .btn.btn-active-color-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success.active.dropdown-toggle:after, .btn.btn-active-color-success.show.dropdown-toggle:after, .show > .btn.btn-active-color-success.dropdown-toggle:after {\n  color: #50CD89;\n}\n\n.btn.btn-icon-success i {\n  color: #50CD89;\n}\n.btn.btn-icon-success .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #50CD89;\n}\n.btn.btn-icon-success .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-icon-success.dropdown-toggle:after {\n  color: #50CD89;\n}\n.btn-check:checked + .btn.btn-active-icon-success i, .btn-check:active + .btn.btn-active-icon-success i, .btn.btn-active-icon-success:focus:not(.btn-active) i, .btn.btn-active-icon-success:hover:not(.btn-active) i, .btn.btn-active-icon-success:active:not(.btn-active) i, .btn.btn-active-icon-success.active i, .btn.btn-active-icon-success.show i, .show > .btn.btn-active-icon-success i {\n  color: #50CD89;\n}\n.btn-check:checked + .btn.btn-active-icon-success .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-success .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-success:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-success:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-success:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-success.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-success.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-success .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #50CD89;\n}\n.btn-check:checked + .btn.btn-active-icon-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-success .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-success:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-success:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-success:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-success.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-success.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-success .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-icon-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-success.dropdown-toggle:after, .btn.btn-active-icon-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success.active.dropdown-toggle:after, .btn.btn-active-icon-success.show.dropdown-toggle:after, .show > .btn.btn-active-icon-success.dropdown-toggle:after {\n  color: #50CD89;\n}\n\n.btn.btn-text-success {\n  color: #50CD89;\n}\n.btn-check:checked + .btn.btn-active-text-success, .btn-check:active + .btn.btn-active-text-success, .btn.btn-active-text-success:focus:not(.btn-active), .btn.btn-active-text-success:hover:not(.btn-active), .btn.btn-active-text-success:active:not(.btn-active), .btn.btn-active-text-success.active, .btn.btn-active-text-success.show, .show > .btn.btn-active-text-success {\n  color: #50CD89;\n}\n\n.btn.btn-color-info {\n  color: #7239EA;\n}\n.btn.btn-color-info i {\n  color: #7239EA;\n}\n.btn.btn-color-info .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7239EA;\n}\n.btn.btn-color-info .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-color-info.dropdown-toggle:after {\n  color: #7239EA;\n}\n.btn-check:checked + .btn.btn-active-color-info, .btn-check:active + .btn.btn-active-color-info, .btn.btn-active-color-info:focus:not(.btn-active), .btn.btn-active-color-info:hover:not(.btn-active), .btn.btn-active-color-info:active:not(.btn-active), .btn.btn-active-color-info.active, .btn.btn-active-color-info.show, .show > .btn.btn-active-color-info {\n  color: #7239EA;\n}\n.btn-check:checked + .btn.btn-active-color-info i, .btn-check:active + .btn.btn-active-color-info i, .btn.btn-active-color-info:focus:not(.btn-active) i, .btn.btn-active-color-info:hover:not(.btn-active) i, .btn.btn-active-color-info:active:not(.btn-active) i, .btn.btn-active-color-info.active i, .btn.btn-active-color-info.show i, .show > .btn.btn-active-color-info i {\n  color: #7239EA;\n}\n.btn-check:checked + .btn.btn-active-color-info .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-info .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-info:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-info:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-info:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-info.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-info.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-info .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7239EA;\n}\n.btn-check:checked + .btn.btn-active-color-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-info:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-info:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-info:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-info.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-info.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-info .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-color-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-info.dropdown-toggle:after, .btn.btn-active-color-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info.active.dropdown-toggle:after, .btn.btn-active-color-info.show.dropdown-toggle:after, .show > .btn.btn-active-color-info.dropdown-toggle:after {\n  color: #7239EA;\n}\n\n.btn.btn-icon-info i {\n  color: #7239EA;\n}\n.btn.btn-icon-info .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7239EA;\n}\n.btn.btn-icon-info .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-icon-info.dropdown-toggle:after {\n  color: #7239EA;\n}\n.btn-check:checked + .btn.btn-active-icon-info i, .btn-check:active + .btn.btn-active-icon-info i, .btn.btn-active-icon-info:focus:not(.btn-active) i, .btn.btn-active-icon-info:hover:not(.btn-active) i, .btn.btn-active-icon-info:active:not(.btn-active) i, .btn.btn-active-icon-info.active i, .btn.btn-active-icon-info.show i, .show > .btn.btn-active-icon-info i {\n  color: #7239EA;\n}\n.btn-check:checked + .btn.btn-active-icon-info .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-info .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-info:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-info:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-info:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-info.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-info.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-info .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7239EA;\n}\n.btn-check:checked + .btn.btn-active-icon-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-info .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-info:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-info:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-info:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-info.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-info.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-info .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-icon-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-info.dropdown-toggle:after, .btn.btn-active-icon-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info.active.dropdown-toggle:after, .btn.btn-active-icon-info.show.dropdown-toggle:after, .show > .btn.btn-active-icon-info.dropdown-toggle:after {\n  color: #7239EA;\n}\n\n.btn.btn-text-info {\n  color: #7239EA;\n}\n.btn-check:checked + .btn.btn-active-text-info, .btn-check:active + .btn.btn-active-text-info, .btn.btn-active-text-info:focus:not(.btn-active), .btn.btn-active-text-info:hover:not(.btn-active), .btn.btn-active-text-info:active:not(.btn-active), .btn.btn-active-text-info.active, .btn.btn-active-text-info.show, .show > .btn.btn-active-text-info {\n  color: #7239EA;\n}\n\n.btn.btn-color-warning {\n  color: #FFC700;\n}\n.btn.btn-color-warning i {\n  color: #FFC700;\n}\n.btn.btn-color-warning .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFC700;\n}\n.btn.btn-color-warning .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-color-warning.dropdown-toggle:after {\n  color: #FFC700;\n}\n.btn-check:checked + .btn.btn-active-color-warning, .btn-check:active + .btn.btn-active-color-warning, .btn.btn-active-color-warning:focus:not(.btn-active), .btn.btn-active-color-warning:hover:not(.btn-active), .btn.btn-active-color-warning:active:not(.btn-active), .btn.btn-active-color-warning.active, .btn.btn-active-color-warning.show, .show > .btn.btn-active-color-warning {\n  color: #FFC700;\n}\n.btn-check:checked + .btn.btn-active-color-warning i, .btn-check:active + .btn.btn-active-color-warning i, .btn.btn-active-color-warning:focus:not(.btn-active) i, .btn.btn-active-color-warning:hover:not(.btn-active) i, .btn.btn-active-color-warning:active:not(.btn-active) i, .btn.btn-active-color-warning.active i, .btn.btn-active-color-warning.show i, .show > .btn.btn-active-color-warning i {\n  color: #FFC700;\n}\n.btn-check:checked + .btn.btn-active-color-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-warning:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-warning:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-warning:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-warning.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-warning.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-warning .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFC700;\n}\n.btn-check:checked + .btn.btn-active-color-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-warning:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-warning:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-warning:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-warning.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-warning.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-warning .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-color-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-warning.dropdown-toggle:after, .btn.btn-active-color-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning.active.dropdown-toggle:after, .btn.btn-active-color-warning.show.dropdown-toggle:after, .show > .btn.btn-active-color-warning.dropdown-toggle:after {\n  color: #FFC700;\n}\n\n.btn.btn-icon-warning i {\n  color: #FFC700;\n}\n.btn.btn-icon-warning .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFC700;\n}\n.btn.btn-icon-warning .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-icon-warning.dropdown-toggle:after {\n  color: #FFC700;\n}\n.btn-check:checked + .btn.btn-active-icon-warning i, .btn-check:active + .btn.btn-active-icon-warning i, .btn.btn-active-icon-warning:focus:not(.btn-active) i, .btn.btn-active-icon-warning:hover:not(.btn-active) i, .btn.btn-active-icon-warning:active:not(.btn-active) i, .btn.btn-active-icon-warning.active i, .btn.btn-active-icon-warning.show i, .show > .btn.btn-active-icon-warning i {\n  color: #FFC700;\n}\n.btn-check:checked + .btn.btn-active-icon-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-warning .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-warning:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-warning:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-warning:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-warning.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-warning.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-warning .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFC700;\n}\n.btn-check:checked + .btn.btn-active-icon-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-warning .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-warning:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-warning:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-warning:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-warning.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-warning.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-warning .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-icon-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-warning.dropdown-toggle:after, .btn.btn-active-icon-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning.active.dropdown-toggle:after, .btn.btn-active-icon-warning.show.dropdown-toggle:after, .show > .btn.btn-active-icon-warning.dropdown-toggle:after {\n  color: #FFC700;\n}\n\n.btn.btn-text-warning {\n  color: #FFC700;\n}\n.btn-check:checked + .btn.btn-active-text-warning, .btn-check:active + .btn.btn-active-text-warning, .btn.btn-active-text-warning:focus:not(.btn-active), .btn.btn-active-text-warning:hover:not(.btn-active), .btn.btn-active-text-warning:active:not(.btn-active), .btn.btn-active-text-warning.active, .btn.btn-active-text-warning.show, .show > .btn.btn-active-text-warning {\n  color: #FFC700;\n}\n\n.btn.btn-color-danger {\n  color: #F1416C;\n}\n.btn.btn-color-danger i {\n  color: #F1416C;\n}\n.btn.btn-color-danger .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F1416C;\n}\n.btn.btn-color-danger .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-color-danger.dropdown-toggle:after {\n  color: #F1416C;\n}\n.btn-check:checked + .btn.btn-active-color-danger, .btn-check:active + .btn.btn-active-color-danger, .btn.btn-active-color-danger:focus:not(.btn-active), .btn.btn-active-color-danger:hover:not(.btn-active), .btn.btn-active-color-danger:active:not(.btn-active), .btn.btn-active-color-danger.active, .btn.btn-active-color-danger.show, .show > .btn.btn-active-color-danger {\n  color: #F1416C;\n}\n.btn-check:checked + .btn.btn-active-color-danger i, .btn-check:active + .btn.btn-active-color-danger i, .btn.btn-active-color-danger:focus:not(.btn-active) i, .btn.btn-active-color-danger:hover:not(.btn-active) i, .btn.btn-active-color-danger:active:not(.btn-active) i, .btn.btn-active-color-danger.active i, .btn.btn-active-color-danger.show i, .show > .btn.btn-active-color-danger i {\n  color: #F1416C;\n}\n.btn-check:checked + .btn.btn-active-color-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-danger:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-danger:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-danger:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-danger.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-danger.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-danger .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F1416C;\n}\n.btn-check:checked + .btn.btn-active-color-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-danger:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-danger:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-danger:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-danger.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-danger.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-danger .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-color-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-danger.dropdown-toggle:after, .btn.btn-active-color-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger.active.dropdown-toggle:after, .btn.btn-active-color-danger.show.dropdown-toggle:after, .show > .btn.btn-active-color-danger.dropdown-toggle:after {\n  color: #F1416C;\n}\n\n.btn.btn-icon-danger i {\n  color: #F1416C;\n}\n.btn.btn-icon-danger .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F1416C;\n}\n.btn.btn-icon-danger .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-icon-danger.dropdown-toggle:after {\n  color: #F1416C;\n}\n.btn-check:checked + .btn.btn-active-icon-danger i, .btn-check:active + .btn.btn-active-icon-danger i, .btn.btn-active-icon-danger:focus:not(.btn-active) i, .btn.btn-active-icon-danger:hover:not(.btn-active) i, .btn.btn-active-icon-danger:active:not(.btn-active) i, .btn.btn-active-icon-danger.active i, .btn.btn-active-icon-danger.show i, .show > .btn.btn-active-icon-danger i {\n  color: #F1416C;\n}\n.btn-check:checked + .btn.btn-active-icon-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-danger .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-danger:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-danger:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-danger:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-danger.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-danger.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-danger .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F1416C;\n}\n.btn-check:checked + .btn.btn-active-icon-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-danger .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-danger:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-danger:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-danger:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-danger.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-danger.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-danger .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-icon-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-danger.dropdown-toggle:after, .btn.btn-active-icon-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger.active.dropdown-toggle:after, .btn.btn-active-icon-danger.show.dropdown-toggle:after, .show > .btn.btn-active-icon-danger.dropdown-toggle:after {\n  color: #F1416C;\n}\n\n.btn.btn-text-danger {\n  color: #F1416C;\n}\n.btn-check:checked + .btn.btn-active-text-danger, .btn-check:active + .btn.btn-active-text-danger, .btn.btn-active-text-danger:focus:not(.btn-active), .btn.btn-active-text-danger:hover:not(.btn-active), .btn.btn-active-text-danger:active:not(.btn-active), .btn.btn-active-text-danger.active, .btn.btn-active-text-danger.show, .show > .btn.btn-active-text-danger {\n  color: #F1416C;\n}\n\n.btn.btn-color-dark {\n  color: #181C32;\n}\n.btn.btn-color-dark i {\n  color: #181C32;\n}\n.btn.btn-color-dark .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #181C32;\n}\n.btn.btn-color-dark .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-color-dark.dropdown-toggle:after {\n  color: #181C32;\n}\n.btn-check:checked + .btn.btn-active-color-dark, .btn-check:active + .btn.btn-active-color-dark, .btn.btn-active-color-dark:focus:not(.btn-active), .btn.btn-active-color-dark:hover:not(.btn-active), .btn.btn-active-color-dark:active:not(.btn-active), .btn.btn-active-color-dark.active, .btn.btn-active-color-dark.show, .show > .btn.btn-active-color-dark {\n  color: #181C32;\n}\n.btn-check:checked + .btn.btn-active-color-dark i, .btn-check:active + .btn.btn-active-color-dark i, .btn.btn-active-color-dark:focus:not(.btn-active) i, .btn.btn-active-color-dark:hover:not(.btn-active) i, .btn.btn-active-color-dark:active:not(.btn-active) i, .btn.btn-active-color-dark.active i, .btn.btn-active-color-dark.show i, .show > .btn.btn-active-color-dark i {\n  color: #181C32;\n}\n.btn-check:checked + .btn.btn-active-color-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-dark:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-dark:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-dark:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-dark.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-dark.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-dark .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #181C32;\n}\n.btn-check:checked + .btn.btn-active-color-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-dark:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-dark:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-dark:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-dark.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-dark.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-dark .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-color-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-dark.dropdown-toggle:after, .btn.btn-active-color-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark.active.dropdown-toggle:after, .btn.btn-active-color-dark.show.dropdown-toggle:after, .show > .btn.btn-active-color-dark.dropdown-toggle:after {\n  color: #181C32;\n}\n\n.btn.btn-icon-dark i {\n  color: #181C32;\n}\n.btn.btn-icon-dark .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #181C32;\n}\n.btn.btn-icon-dark .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-icon-dark.dropdown-toggle:after {\n  color: #181C32;\n}\n.btn-check:checked + .btn.btn-active-icon-dark i, .btn-check:active + .btn.btn-active-icon-dark i, .btn.btn-active-icon-dark:focus:not(.btn-active) i, .btn.btn-active-icon-dark:hover:not(.btn-active) i, .btn.btn-active-icon-dark:active:not(.btn-active) i, .btn.btn-active-icon-dark.active i, .btn.btn-active-icon-dark.show i, .show > .btn.btn-active-icon-dark i {\n  color: #181C32;\n}\n.btn-check:checked + .btn.btn-active-icon-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-dark .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-dark:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-dark:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-dark:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-dark.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-dark.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-dark .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #181C32;\n}\n.btn-check:checked + .btn.btn-active-icon-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-dark .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-dark:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-dark:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-dark:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-dark.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-dark.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-dark .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-icon-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-dark.dropdown-toggle:after, .btn.btn-active-icon-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark.active.dropdown-toggle:after, .btn.btn-active-icon-dark.show.dropdown-toggle:after, .show > .btn.btn-active-icon-dark.dropdown-toggle:after {\n  color: #181C32;\n}\n\n.btn.btn-text-dark {\n  color: #181C32;\n}\n.btn-check:checked + .btn.btn-active-text-dark, .btn-check:active + .btn.btn-active-text-dark, .btn.btn-active-text-dark:focus:not(.btn-active), .btn.btn-active-text-dark:hover:not(.btn-active), .btn.btn-active-text-dark:active:not(.btn-active), .btn.btn-active-text-dark.active, .btn.btn-active-text-dark.show, .show > .btn.btn-active-text-dark {\n  color: #181C32;\n}\n\n.btn.btn-color-muted {\n  color: #A1A5B7;\n}\n.btn.btn-color-muted i {\n  color: #A1A5B7;\n}\n.btn.btn-color-muted .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #A1A5B7;\n}\n.btn.btn-color-muted .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-color-muted.dropdown-toggle:after {\n  color: #A1A5B7;\n}\n.btn-check:checked + .btn.btn-active-color-muted, .btn-check:active + .btn.btn-active-color-muted, .btn.btn-active-color-muted:focus:not(.btn-active), .btn.btn-active-color-muted:hover:not(.btn-active), .btn.btn-active-color-muted:active:not(.btn-active), .btn.btn-active-color-muted.active, .btn.btn-active-color-muted.show, .show > .btn.btn-active-color-muted {\n  color: #A1A5B7;\n}\n.btn-check:checked + .btn.btn-active-color-muted i, .btn-check:active + .btn.btn-active-color-muted i, .btn.btn-active-color-muted:focus:not(.btn-active) i, .btn.btn-active-color-muted:hover:not(.btn-active) i, .btn.btn-active-color-muted:active:not(.btn-active) i, .btn.btn-active-color-muted.active i, .btn.btn-active-color-muted.show i, .show > .btn.btn-active-color-muted i {\n  color: #A1A5B7;\n}\n.btn-check:checked + .btn.btn-active-color-muted .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-muted .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-muted:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-muted:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-muted:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-muted.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-muted.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-muted .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #A1A5B7;\n}\n.btn-check:checked + .btn.btn-active-color-muted .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-muted .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-muted:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-muted:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-muted:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-muted.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-muted.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-muted .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-color-muted.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-muted.dropdown-toggle:after, .btn.btn-active-color-muted:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted.active.dropdown-toggle:after, .btn.btn-active-color-muted.show.dropdown-toggle:after, .show > .btn.btn-active-color-muted.dropdown-toggle:after {\n  color: #A1A5B7;\n}\n\n.btn.btn-icon-muted i {\n  color: #A1A5B7;\n}\n.btn.btn-icon-muted .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #A1A5B7;\n}\n.btn.btn-icon-muted .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-icon-muted.dropdown-toggle:after {\n  color: #A1A5B7;\n}\n.btn-check:checked + .btn.btn-active-icon-muted i, .btn-check:active + .btn.btn-active-icon-muted i, .btn.btn-active-icon-muted:focus:not(.btn-active) i, .btn.btn-active-icon-muted:hover:not(.btn-active) i, .btn.btn-active-icon-muted:active:not(.btn-active) i, .btn.btn-active-icon-muted.active i, .btn.btn-active-icon-muted.show i, .show > .btn.btn-active-icon-muted i {\n  color: #A1A5B7;\n}\n.btn-check:checked + .btn.btn-active-icon-muted .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-muted .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-muted:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-muted:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-muted:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-muted.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-muted.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-muted .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #A1A5B7;\n}\n.btn-check:checked + .btn.btn-active-icon-muted .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-muted .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-muted:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-muted:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-muted:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-muted.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-muted.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-muted .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-icon-muted.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-muted.dropdown-toggle:after, .btn.btn-active-icon-muted:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted.active.dropdown-toggle:after, .btn.btn-active-icon-muted.show.dropdown-toggle:after, .show > .btn.btn-active-icon-muted.dropdown-toggle:after {\n  color: #A1A5B7;\n}\n\n.btn.btn-text-muted {\n  color: #A1A5B7;\n}\n.btn-check:checked + .btn.btn-active-text-muted, .btn-check:active + .btn.btn-active-text-muted, .btn.btn-active-text-muted:focus:not(.btn-active), .btn.btn-active-text-muted:hover:not(.btn-active), .btn.btn-active-text-muted:active:not(.btn-active), .btn.btn-active-text-muted.active, .btn.btn-active-text-muted.show, .show > .btn.btn-active-text-muted {\n  color: #A1A5B7;\n}\n\n.btn.btn-color-gray-100 {\n  color: #F5F8FA;\n}\n.btn.btn-color-gray-100 i {\n  color: #F5F8FA;\n}\n.btn.btn-color-gray-100 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F5F8FA;\n}\n.btn.btn-color-gray-100 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-color-gray-100.dropdown-toggle:after {\n  color: #F5F8FA;\n}\n.btn-check:checked + .btn.btn-active-color-gray-100, .btn-check:active + .btn.btn-active-color-gray-100, .btn.btn-active-color-gray-100:focus:not(.btn-active), .btn.btn-active-color-gray-100:hover:not(.btn-active), .btn.btn-active-color-gray-100:active:not(.btn-active), .btn.btn-active-color-gray-100.active, .btn.btn-active-color-gray-100.show, .show > .btn.btn-active-color-gray-100 {\n  color: #F5F8FA;\n}\n.btn-check:checked + .btn.btn-active-color-gray-100 i, .btn-check:active + .btn.btn-active-color-gray-100 i, .btn.btn-active-color-gray-100:focus:not(.btn-active) i, .btn.btn-active-color-gray-100:hover:not(.btn-active) i, .btn.btn-active-color-gray-100:active:not(.btn-active) i, .btn.btn-active-color-gray-100.active i, .btn.btn-active-color-gray-100.show i, .show > .btn.btn-active-color-gray-100 i {\n  color: #F5F8FA;\n}\n.btn-check:checked + .btn.btn-active-color-gray-100 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-100 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-100:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-100:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-100:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-100.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-100.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-100 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F5F8FA;\n}\n.btn-check:checked + .btn.btn-active-color-gray-100 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-100 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-100:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-100:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-100:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-100.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-100.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-100 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-color-gray-100.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-100.dropdown-toggle:after, .btn.btn-active-color-gray-100:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100.active.dropdown-toggle:after, .btn.btn-active-color-gray-100.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-100.dropdown-toggle:after {\n  color: #F5F8FA;\n}\n\n.btn.btn-icon-gray-100 i {\n  color: #F5F8FA;\n}\n.btn.btn-icon-gray-100 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F5F8FA;\n}\n.btn.btn-icon-gray-100 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-icon-gray-100.dropdown-toggle:after {\n  color: #F5F8FA;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-100 i, .btn-check:active + .btn.btn-active-icon-gray-100 i, .btn.btn-active-icon-gray-100:focus:not(.btn-active) i, .btn.btn-active-icon-gray-100:hover:not(.btn-active) i, .btn.btn-active-icon-gray-100:active:not(.btn-active) i, .btn.btn-active-icon-gray-100.active i, .btn.btn-active-icon-gray-100.show i, .show > .btn.btn-active-icon-gray-100 i {\n  color: #F5F8FA;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-100 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-100 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-100:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-100:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-100:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-100.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-100.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-100 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F5F8FA;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-100 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-100 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-100:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-100:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-100:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-100.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-100.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-100 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-100.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-100.dropdown-toggle:after, .btn.btn-active-icon-gray-100:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100.active.dropdown-toggle:after, .btn.btn-active-icon-gray-100.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-100.dropdown-toggle:after {\n  color: #F5F8FA;\n}\n\n.btn.btn-text-gray-100 {\n  color: #F5F8FA;\n}\n.btn-check:checked + .btn.btn-active-text-gray-100, .btn-check:active + .btn.btn-active-text-gray-100, .btn.btn-active-text-gray-100:focus:not(.btn-active), .btn.btn-active-text-gray-100:hover:not(.btn-active), .btn.btn-active-text-gray-100:active:not(.btn-active), .btn.btn-active-text-gray-100.active, .btn.btn-active-text-gray-100.show, .show > .btn.btn-active-text-gray-100 {\n  color: #F5F8FA;\n}\n\n.btn.btn-color-gray-200 {\n  color: #EFF2F5;\n}\n.btn.btn-color-gray-200 i {\n  color: #EFF2F5;\n}\n.btn.btn-color-gray-200 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #EFF2F5;\n}\n.btn.btn-color-gray-200 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-color-gray-200.dropdown-toggle:after {\n  color: #EFF2F5;\n}\n.btn-check:checked + .btn.btn-active-color-gray-200, .btn-check:active + .btn.btn-active-color-gray-200, .btn.btn-active-color-gray-200:focus:not(.btn-active), .btn.btn-active-color-gray-200:hover:not(.btn-active), .btn.btn-active-color-gray-200:active:not(.btn-active), .btn.btn-active-color-gray-200.active, .btn.btn-active-color-gray-200.show, .show > .btn.btn-active-color-gray-200 {\n  color: #EFF2F5;\n}\n.btn-check:checked + .btn.btn-active-color-gray-200 i, .btn-check:active + .btn.btn-active-color-gray-200 i, .btn.btn-active-color-gray-200:focus:not(.btn-active) i, .btn.btn-active-color-gray-200:hover:not(.btn-active) i, .btn.btn-active-color-gray-200:active:not(.btn-active) i, .btn.btn-active-color-gray-200.active i, .btn.btn-active-color-gray-200.show i, .show > .btn.btn-active-color-gray-200 i {\n  color: #EFF2F5;\n}\n.btn-check:checked + .btn.btn-active-color-gray-200 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-200 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-200:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-200:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-200:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-200.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-200.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-200 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #EFF2F5;\n}\n.btn-check:checked + .btn.btn-active-color-gray-200 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-200 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-200:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-200:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-200:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-200.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-200.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-200 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-color-gray-200.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-200.dropdown-toggle:after, .btn.btn-active-color-gray-200:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200.active.dropdown-toggle:after, .btn.btn-active-color-gray-200.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-200.dropdown-toggle:after {\n  color: #EFF2F5;\n}\n\n.btn.btn-icon-gray-200 i {\n  color: #EFF2F5;\n}\n.btn.btn-icon-gray-200 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #EFF2F5;\n}\n.btn.btn-icon-gray-200 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-icon-gray-200.dropdown-toggle:after {\n  color: #EFF2F5;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-200 i, .btn-check:active + .btn.btn-active-icon-gray-200 i, .btn.btn-active-icon-gray-200:focus:not(.btn-active) i, .btn.btn-active-icon-gray-200:hover:not(.btn-active) i, .btn.btn-active-icon-gray-200:active:not(.btn-active) i, .btn.btn-active-icon-gray-200.active i, .btn.btn-active-icon-gray-200.show i, .show > .btn.btn-active-icon-gray-200 i {\n  color: #EFF2F5;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-200 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-200 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-200:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-200:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-200:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-200.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-200.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-200 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #EFF2F5;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-200 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-200 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-200:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-200:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-200:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-200.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-200.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-200 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-200.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-200.dropdown-toggle:after, .btn.btn-active-icon-gray-200:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200.active.dropdown-toggle:after, .btn.btn-active-icon-gray-200.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-200.dropdown-toggle:after {\n  color: #EFF2F5;\n}\n\n.btn.btn-text-gray-200 {\n  color: #EFF2F5;\n}\n.btn-check:checked + .btn.btn-active-text-gray-200, .btn-check:active + .btn.btn-active-text-gray-200, .btn.btn-active-text-gray-200:focus:not(.btn-active), .btn.btn-active-text-gray-200:hover:not(.btn-active), .btn.btn-active-text-gray-200:active:not(.btn-active), .btn.btn-active-text-gray-200.active, .btn.btn-active-text-gray-200.show, .show > .btn.btn-active-text-gray-200 {\n  color: #EFF2F5;\n}\n\n.btn.btn-color-gray-300 {\n  color: #E4E6EF;\n}\n.btn.btn-color-gray-300 i {\n  color: #E4E6EF;\n}\n.btn.btn-color-gray-300 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #E4E6EF;\n}\n.btn.btn-color-gray-300 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-color-gray-300.dropdown-toggle:after {\n  color: #E4E6EF;\n}\n.btn-check:checked + .btn.btn-active-color-gray-300, .btn-check:active + .btn.btn-active-color-gray-300, .btn.btn-active-color-gray-300:focus:not(.btn-active), .btn.btn-active-color-gray-300:hover:not(.btn-active), .btn.btn-active-color-gray-300:active:not(.btn-active), .btn.btn-active-color-gray-300.active, .btn.btn-active-color-gray-300.show, .show > .btn.btn-active-color-gray-300 {\n  color: #E4E6EF;\n}\n.btn-check:checked + .btn.btn-active-color-gray-300 i, .btn-check:active + .btn.btn-active-color-gray-300 i, .btn.btn-active-color-gray-300:focus:not(.btn-active) i, .btn.btn-active-color-gray-300:hover:not(.btn-active) i, .btn.btn-active-color-gray-300:active:not(.btn-active) i, .btn.btn-active-color-gray-300.active i, .btn.btn-active-color-gray-300.show i, .show > .btn.btn-active-color-gray-300 i {\n  color: #E4E6EF;\n}\n.btn-check:checked + .btn.btn-active-color-gray-300 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-300 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-300:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-300:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-300:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-300.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-300.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-300 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #E4E6EF;\n}\n.btn-check:checked + .btn.btn-active-color-gray-300 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-300 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-300:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-300:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-300:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-300.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-300.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-300 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-color-gray-300.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-300.dropdown-toggle:after, .btn.btn-active-color-gray-300:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300.active.dropdown-toggle:after, .btn.btn-active-color-gray-300.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-300.dropdown-toggle:after {\n  color: #E4E6EF;\n}\n\n.btn.btn-icon-gray-300 i {\n  color: #E4E6EF;\n}\n.btn.btn-icon-gray-300 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #E4E6EF;\n}\n.btn.btn-icon-gray-300 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-icon-gray-300.dropdown-toggle:after {\n  color: #E4E6EF;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-300 i, .btn-check:active + .btn.btn-active-icon-gray-300 i, .btn.btn-active-icon-gray-300:focus:not(.btn-active) i, .btn.btn-active-icon-gray-300:hover:not(.btn-active) i, .btn.btn-active-icon-gray-300:active:not(.btn-active) i, .btn.btn-active-icon-gray-300.active i, .btn.btn-active-icon-gray-300.show i, .show > .btn.btn-active-icon-gray-300 i {\n  color: #E4E6EF;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-300 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-300 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-300:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-300:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-300:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-300.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-300.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-300 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #E4E6EF;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-300 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-300 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-300:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-300:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-300:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-300.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-300.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-300 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-300.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-300.dropdown-toggle:after, .btn.btn-active-icon-gray-300:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300.active.dropdown-toggle:after, .btn.btn-active-icon-gray-300.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-300.dropdown-toggle:after {\n  color: #E4E6EF;\n}\n\n.btn.btn-text-gray-300 {\n  color: #E4E6EF;\n}\n.btn-check:checked + .btn.btn-active-text-gray-300, .btn-check:active + .btn.btn-active-text-gray-300, .btn.btn-active-text-gray-300:focus:not(.btn-active), .btn.btn-active-text-gray-300:hover:not(.btn-active), .btn.btn-active-text-gray-300:active:not(.btn-active), .btn.btn-active-text-gray-300.active, .btn.btn-active-text-gray-300.show, .show > .btn.btn-active-text-gray-300 {\n  color: #E4E6EF;\n}\n\n.btn.btn-color-gray-400 {\n  color: #B5B5C3;\n}\n.btn.btn-color-gray-400 i {\n  color: #B5B5C3;\n}\n.btn.btn-color-gray-400 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #B5B5C3;\n}\n.btn.btn-color-gray-400 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-color-gray-400.dropdown-toggle:after {\n  color: #B5B5C3;\n}\n.btn-check:checked + .btn.btn-active-color-gray-400, .btn-check:active + .btn.btn-active-color-gray-400, .btn.btn-active-color-gray-400:focus:not(.btn-active), .btn.btn-active-color-gray-400:hover:not(.btn-active), .btn.btn-active-color-gray-400:active:not(.btn-active), .btn.btn-active-color-gray-400.active, .btn.btn-active-color-gray-400.show, .show > .btn.btn-active-color-gray-400 {\n  color: #B5B5C3;\n}\n.btn-check:checked + .btn.btn-active-color-gray-400 i, .btn-check:active + .btn.btn-active-color-gray-400 i, .btn.btn-active-color-gray-400:focus:not(.btn-active) i, .btn.btn-active-color-gray-400:hover:not(.btn-active) i, .btn.btn-active-color-gray-400:active:not(.btn-active) i, .btn.btn-active-color-gray-400.active i, .btn.btn-active-color-gray-400.show i, .show > .btn.btn-active-color-gray-400 i {\n  color: #B5B5C3;\n}\n.btn-check:checked + .btn.btn-active-color-gray-400 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-400 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-400:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-400:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-400:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-400.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-400.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-400 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #B5B5C3;\n}\n.btn-check:checked + .btn.btn-active-color-gray-400 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-400 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-400:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-400:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-400:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-400.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-400.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-400 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-color-gray-400.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-400.dropdown-toggle:after, .btn.btn-active-color-gray-400:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400.active.dropdown-toggle:after, .btn.btn-active-color-gray-400.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-400.dropdown-toggle:after {\n  color: #B5B5C3;\n}\n\n.btn.btn-icon-gray-400 i {\n  color: #B5B5C3;\n}\n.btn.btn-icon-gray-400 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #B5B5C3;\n}\n.btn.btn-icon-gray-400 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-icon-gray-400.dropdown-toggle:after {\n  color: #B5B5C3;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-400 i, .btn-check:active + .btn.btn-active-icon-gray-400 i, .btn.btn-active-icon-gray-400:focus:not(.btn-active) i, .btn.btn-active-icon-gray-400:hover:not(.btn-active) i, .btn.btn-active-icon-gray-400:active:not(.btn-active) i, .btn.btn-active-icon-gray-400.active i, .btn.btn-active-icon-gray-400.show i, .show > .btn.btn-active-icon-gray-400 i {\n  color: #B5B5C3;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-400 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-400 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-400:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-400:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-400:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-400.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-400.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-400 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #B5B5C3;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-400 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-400 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-400:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-400:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-400:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-400.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-400.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-400 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-400.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-400.dropdown-toggle:after, .btn.btn-active-icon-gray-400:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400.active.dropdown-toggle:after, .btn.btn-active-icon-gray-400.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-400.dropdown-toggle:after {\n  color: #B5B5C3;\n}\n\n.btn.btn-text-gray-400 {\n  color: #B5B5C3;\n}\n.btn-check:checked + .btn.btn-active-text-gray-400, .btn-check:active + .btn.btn-active-text-gray-400, .btn.btn-active-text-gray-400:focus:not(.btn-active), .btn.btn-active-text-gray-400:hover:not(.btn-active), .btn.btn-active-text-gray-400:active:not(.btn-active), .btn.btn-active-text-gray-400.active, .btn.btn-active-text-gray-400.show, .show > .btn.btn-active-text-gray-400 {\n  color: #B5B5C3;\n}\n\n.btn.btn-color-gray-500 {\n  color: #A1A5B7;\n}\n.btn.btn-color-gray-500 i {\n  color: #A1A5B7;\n}\n.btn.btn-color-gray-500 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #A1A5B7;\n}\n.btn.btn-color-gray-500 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-color-gray-500.dropdown-toggle:after {\n  color: #A1A5B7;\n}\n.btn-check:checked + .btn.btn-active-color-gray-500, .btn-check:active + .btn.btn-active-color-gray-500, .btn.btn-active-color-gray-500:focus:not(.btn-active), .btn.btn-active-color-gray-500:hover:not(.btn-active), .btn.btn-active-color-gray-500:active:not(.btn-active), .btn.btn-active-color-gray-500.active, .btn.btn-active-color-gray-500.show, .show > .btn.btn-active-color-gray-500 {\n  color: #A1A5B7;\n}\n.btn-check:checked + .btn.btn-active-color-gray-500 i, .btn-check:active + .btn.btn-active-color-gray-500 i, .btn.btn-active-color-gray-500:focus:not(.btn-active) i, .btn.btn-active-color-gray-500:hover:not(.btn-active) i, .btn.btn-active-color-gray-500:active:not(.btn-active) i, .btn.btn-active-color-gray-500.active i, .btn.btn-active-color-gray-500.show i, .show > .btn.btn-active-color-gray-500 i {\n  color: #A1A5B7;\n}\n.btn-check:checked + .btn.btn-active-color-gray-500 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-500 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-500:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-500:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-500:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-500.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-500.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-500 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #A1A5B7;\n}\n.btn-check:checked + .btn.btn-active-color-gray-500 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-500 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-500:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-500:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-500:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-500.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-500.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-500 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-color-gray-500.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-500.dropdown-toggle:after, .btn.btn-active-color-gray-500:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500.active.dropdown-toggle:after, .btn.btn-active-color-gray-500.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-500.dropdown-toggle:after {\n  color: #A1A5B7;\n}\n\n.btn.btn-icon-gray-500 i {\n  color: #A1A5B7;\n}\n.btn.btn-icon-gray-500 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #A1A5B7;\n}\n.btn.btn-icon-gray-500 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-icon-gray-500.dropdown-toggle:after {\n  color: #A1A5B7;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-500 i, .btn-check:active + .btn.btn-active-icon-gray-500 i, .btn.btn-active-icon-gray-500:focus:not(.btn-active) i, .btn.btn-active-icon-gray-500:hover:not(.btn-active) i, .btn.btn-active-icon-gray-500:active:not(.btn-active) i, .btn.btn-active-icon-gray-500.active i, .btn.btn-active-icon-gray-500.show i, .show > .btn.btn-active-icon-gray-500 i {\n  color: #A1A5B7;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-500 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-500 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-500:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-500:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-500:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-500.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-500.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-500 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #A1A5B7;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-500 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-500 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-500:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-500:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-500:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-500.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-500.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-500 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-500.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-500.dropdown-toggle:after, .btn.btn-active-icon-gray-500:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500.active.dropdown-toggle:after, .btn.btn-active-icon-gray-500.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-500.dropdown-toggle:after {\n  color: #A1A5B7;\n}\n\n.btn.btn-text-gray-500 {\n  color: #A1A5B7;\n}\n.btn-check:checked + .btn.btn-active-text-gray-500, .btn-check:active + .btn.btn-active-text-gray-500, .btn.btn-active-text-gray-500:focus:not(.btn-active), .btn.btn-active-text-gray-500:hover:not(.btn-active), .btn.btn-active-text-gray-500:active:not(.btn-active), .btn.btn-active-text-gray-500.active, .btn.btn-active-text-gray-500.show, .show > .btn.btn-active-text-gray-500 {\n  color: #A1A5B7;\n}\n\n.btn.btn-color-gray-600 {\n  color: #7E8299;\n}\n.btn.btn-color-gray-600 i {\n  color: #7E8299;\n}\n.btn.btn-color-gray-600 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7E8299;\n}\n.btn.btn-color-gray-600 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-color-gray-600.dropdown-toggle:after {\n  color: #7E8299;\n}\n.btn-check:checked + .btn.btn-active-color-gray-600, .btn-check:active + .btn.btn-active-color-gray-600, .btn.btn-active-color-gray-600:focus:not(.btn-active), .btn.btn-active-color-gray-600:hover:not(.btn-active), .btn.btn-active-color-gray-600:active:not(.btn-active), .btn.btn-active-color-gray-600.active, .btn.btn-active-color-gray-600.show, .show > .btn.btn-active-color-gray-600 {\n  color: #7E8299;\n}\n.btn-check:checked + .btn.btn-active-color-gray-600 i, .btn-check:active + .btn.btn-active-color-gray-600 i, .btn.btn-active-color-gray-600:focus:not(.btn-active) i, .btn.btn-active-color-gray-600:hover:not(.btn-active) i, .btn.btn-active-color-gray-600:active:not(.btn-active) i, .btn.btn-active-color-gray-600.active i, .btn.btn-active-color-gray-600.show i, .show > .btn.btn-active-color-gray-600 i {\n  color: #7E8299;\n}\n.btn-check:checked + .btn.btn-active-color-gray-600 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-600 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-600:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-600:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-600:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-600.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-600.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-600 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7E8299;\n}\n.btn-check:checked + .btn.btn-active-color-gray-600 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-600 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-600:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-600:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-600:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-600.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-600.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-600 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-color-gray-600.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-600.dropdown-toggle:after, .btn.btn-active-color-gray-600:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600.active.dropdown-toggle:after, .btn.btn-active-color-gray-600.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-600.dropdown-toggle:after {\n  color: #7E8299;\n}\n\n.btn.btn-icon-gray-600 i {\n  color: #7E8299;\n}\n.btn.btn-icon-gray-600 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7E8299;\n}\n.btn.btn-icon-gray-600 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-icon-gray-600.dropdown-toggle:after {\n  color: #7E8299;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-600 i, .btn-check:active + .btn.btn-active-icon-gray-600 i, .btn.btn-active-icon-gray-600:focus:not(.btn-active) i, .btn.btn-active-icon-gray-600:hover:not(.btn-active) i, .btn.btn-active-icon-gray-600:active:not(.btn-active) i, .btn.btn-active-icon-gray-600.active i, .btn.btn-active-icon-gray-600.show i, .show > .btn.btn-active-icon-gray-600 i {\n  color: #7E8299;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-600 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-600 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-600:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-600:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-600:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-600.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-600.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-600 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7E8299;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-600 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-600 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-600:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-600:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-600:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-600.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-600.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-600 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-600.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-600.dropdown-toggle:after, .btn.btn-active-icon-gray-600:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600.active.dropdown-toggle:after, .btn.btn-active-icon-gray-600.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-600.dropdown-toggle:after {\n  color: #7E8299;\n}\n\n.btn.btn-text-gray-600 {\n  color: #7E8299;\n}\n.btn-check:checked + .btn.btn-active-text-gray-600, .btn-check:active + .btn.btn-active-text-gray-600, .btn.btn-active-text-gray-600:focus:not(.btn-active), .btn.btn-active-text-gray-600:hover:not(.btn-active), .btn.btn-active-text-gray-600:active:not(.btn-active), .btn.btn-active-text-gray-600.active, .btn.btn-active-text-gray-600.show, .show > .btn.btn-active-text-gray-600 {\n  color: #7E8299;\n}\n\n.btn.btn-color-gray-700 {\n  color: #5E6278;\n}\n.btn.btn-color-gray-700 i {\n  color: #5E6278;\n}\n.btn.btn-color-gray-700 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #5E6278;\n}\n.btn.btn-color-gray-700 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-color-gray-700.dropdown-toggle:after {\n  color: #5E6278;\n}\n.btn-check:checked + .btn.btn-active-color-gray-700, .btn-check:active + .btn.btn-active-color-gray-700, .btn.btn-active-color-gray-700:focus:not(.btn-active), .btn.btn-active-color-gray-700:hover:not(.btn-active), .btn.btn-active-color-gray-700:active:not(.btn-active), .btn.btn-active-color-gray-700.active, .btn.btn-active-color-gray-700.show, .show > .btn.btn-active-color-gray-700 {\n  color: #5E6278;\n}\n.btn-check:checked + .btn.btn-active-color-gray-700 i, .btn-check:active + .btn.btn-active-color-gray-700 i, .btn.btn-active-color-gray-700:focus:not(.btn-active) i, .btn.btn-active-color-gray-700:hover:not(.btn-active) i, .btn.btn-active-color-gray-700:active:not(.btn-active) i, .btn.btn-active-color-gray-700.active i, .btn.btn-active-color-gray-700.show i, .show > .btn.btn-active-color-gray-700 i {\n  color: #5E6278;\n}\n.btn-check:checked + .btn.btn-active-color-gray-700 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-700 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-700:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-700:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-700:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-700.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-700.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-700 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #5E6278;\n}\n.btn-check:checked + .btn.btn-active-color-gray-700 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-700 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-700:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-700:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-700:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-700.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-700.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-700 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-color-gray-700.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-700.dropdown-toggle:after, .btn.btn-active-color-gray-700:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700.active.dropdown-toggle:after, .btn.btn-active-color-gray-700.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-700.dropdown-toggle:after {\n  color: #5E6278;\n}\n\n.btn.btn-icon-gray-700 i {\n  color: #5E6278;\n}\n.btn.btn-icon-gray-700 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #5E6278;\n}\n.btn.btn-icon-gray-700 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-icon-gray-700.dropdown-toggle:after {\n  color: #5E6278;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-700 i, .btn-check:active + .btn.btn-active-icon-gray-700 i, .btn.btn-active-icon-gray-700:focus:not(.btn-active) i, .btn.btn-active-icon-gray-700:hover:not(.btn-active) i, .btn.btn-active-icon-gray-700:active:not(.btn-active) i, .btn.btn-active-icon-gray-700.active i, .btn.btn-active-icon-gray-700.show i, .show > .btn.btn-active-icon-gray-700 i {\n  color: #5E6278;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-700 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-700 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-700:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-700:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-700:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-700.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-700.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-700 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #5E6278;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-700 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-700 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-700:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-700:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-700:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-700.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-700.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-700 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-700.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-700.dropdown-toggle:after, .btn.btn-active-icon-gray-700:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700.active.dropdown-toggle:after, .btn.btn-active-icon-gray-700.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-700.dropdown-toggle:after {\n  color: #5E6278;\n}\n\n.btn.btn-text-gray-700 {\n  color: #5E6278;\n}\n.btn-check:checked + .btn.btn-active-text-gray-700, .btn-check:active + .btn.btn-active-text-gray-700, .btn.btn-active-text-gray-700:focus:not(.btn-active), .btn.btn-active-text-gray-700:hover:not(.btn-active), .btn.btn-active-text-gray-700:active:not(.btn-active), .btn.btn-active-text-gray-700.active, .btn.btn-active-text-gray-700.show, .show > .btn.btn-active-text-gray-700 {\n  color: #5E6278;\n}\n\n.btn.btn-color-gray-800 {\n  color: #3F4254;\n}\n.btn.btn-color-gray-800 i {\n  color: #3F4254;\n}\n.btn.btn-color-gray-800 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #3F4254;\n}\n.btn.btn-color-gray-800 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-color-gray-800.dropdown-toggle:after {\n  color: #3F4254;\n}\n.btn-check:checked + .btn.btn-active-color-gray-800, .btn-check:active + .btn.btn-active-color-gray-800, .btn.btn-active-color-gray-800:focus:not(.btn-active), .btn.btn-active-color-gray-800:hover:not(.btn-active), .btn.btn-active-color-gray-800:active:not(.btn-active), .btn.btn-active-color-gray-800.active, .btn.btn-active-color-gray-800.show, .show > .btn.btn-active-color-gray-800 {\n  color: #3F4254;\n}\n.btn-check:checked + .btn.btn-active-color-gray-800 i, .btn-check:active + .btn.btn-active-color-gray-800 i, .btn.btn-active-color-gray-800:focus:not(.btn-active) i, .btn.btn-active-color-gray-800:hover:not(.btn-active) i, .btn.btn-active-color-gray-800:active:not(.btn-active) i, .btn.btn-active-color-gray-800.active i, .btn.btn-active-color-gray-800.show i, .show > .btn.btn-active-color-gray-800 i {\n  color: #3F4254;\n}\n.btn-check:checked + .btn.btn-active-color-gray-800 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-800 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-800:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-800:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-800:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-800.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-800.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-800 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #3F4254;\n}\n.btn-check:checked + .btn.btn-active-color-gray-800 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-800 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-800:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-800:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-800:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-800.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-800.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-800 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-color-gray-800.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-800.dropdown-toggle:after, .btn.btn-active-color-gray-800:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800.active.dropdown-toggle:after, .btn.btn-active-color-gray-800.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-800.dropdown-toggle:after {\n  color: #3F4254;\n}\n\n.btn.btn-icon-gray-800 i {\n  color: #3F4254;\n}\n.btn.btn-icon-gray-800 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #3F4254;\n}\n.btn.btn-icon-gray-800 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-icon-gray-800.dropdown-toggle:after {\n  color: #3F4254;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-800 i, .btn-check:active + .btn.btn-active-icon-gray-800 i, .btn.btn-active-icon-gray-800:focus:not(.btn-active) i, .btn.btn-active-icon-gray-800:hover:not(.btn-active) i, .btn.btn-active-icon-gray-800:active:not(.btn-active) i, .btn.btn-active-icon-gray-800.active i, .btn.btn-active-icon-gray-800.show i, .show > .btn.btn-active-icon-gray-800 i {\n  color: #3F4254;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-800 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-800 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-800:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-800:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-800:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-800.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-800.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-800 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #3F4254;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-800 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-800 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-800:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-800:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-800:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-800.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-800.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-800 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-800.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-800.dropdown-toggle:after, .btn.btn-active-icon-gray-800:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800.active.dropdown-toggle:after, .btn.btn-active-icon-gray-800.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-800.dropdown-toggle:after {\n  color: #3F4254;\n}\n\n.btn.btn-text-gray-800 {\n  color: #3F4254;\n}\n.btn-check:checked + .btn.btn-active-text-gray-800, .btn-check:active + .btn.btn-active-text-gray-800, .btn.btn-active-text-gray-800:focus:not(.btn-active), .btn.btn-active-text-gray-800:hover:not(.btn-active), .btn.btn-active-text-gray-800:active:not(.btn-active), .btn.btn-active-text-gray-800.active, .btn.btn-active-text-gray-800.show, .show > .btn.btn-active-text-gray-800 {\n  color: #3F4254;\n}\n\n.btn.btn-color-gray-900 {\n  color: #181C32;\n}\n.btn.btn-color-gray-900 i {\n  color: #181C32;\n}\n.btn.btn-color-gray-900 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #181C32;\n}\n.btn.btn-color-gray-900 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-color-gray-900.dropdown-toggle:after {\n  color: #181C32;\n}\n.btn-check:checked + .btn.btn-active-color-gray-900, .btn-check:active + .btn.btn-active-color-gray-900, .btn.btn-active-color-gray-900:focus:not(.btn-active), .btn.btn-active-color-gray-900:hover:not(.btn-active), .btn.btn-active-color-gray-900:active:not(.btn-active), .btn.btn-active-color-gray-900.active, .btn.btn-active-color-gray-900.show, .show > .btn.btn-active-color-gray-900 {\n  color: #181C32;\n}\n.btn-check:checked + .btn.btn-active-color-gray-900 i, .btn-check:active + .btn.btn-active-color-gray-900 i, .btn.btn-active-color-gray-900:focus:not(.btn-active) i, .btn.btn-active-color-gray-900:hover:not(.btn-active) i, .btn.btn-active-color-gray-900:active:not(.btn-active) i, .btn.btn-active-color-gray-900.active i, .btn.btn-active-color-gray-900.show i, .show > .btn.btn-active-color-gray-900 i {\n  color: #181C32;\n}\n.btn-check:checked + .btn.btn-active-color-gray-900 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-900 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-900:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-900:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-900:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-900.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-900.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-900 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #181C32;\n}\n.btn-check:checked + .btn.btn-active-color-gray-900 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-color-gray-900 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-900:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-900:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-900:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-900.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-color-gray-900.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-color-gray-900 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-color-gray-900.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-900.dropdown-toggle:after, .btn.btn-active-color-gray-900:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900.active.dropdown-toggle:after, .btn.btn-active-color-gray-900.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-900.dropdown-toggle:after {\n  color: #181C32;\n}\n\n.btn.btn-icon-gray-900 i {\n  color: #181C32;\n}\n.btn.btn-icon-gray-900 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #181C32;\n}\n.btn.btn-icon-gray-900 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-icon-gray-900.dropdown-toggle:after {\n  color: #181C32;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-900 i, .btn-check:active + .btn.btn-active-icon-gray-900 i, .btn.btn-active-icon-gray-900:focus:not(.btn-active) i, .btn.btn-active-icon-gray-900:hover:not(.btn-active) i, .btn.btn-active-icon-gray-900:active:not(.btn-active) i, .btn.btn-active-icon-gray-900.active i, .btn.btn-active-icon-gray-900.show i, .show > .btn.btn-active-icon-gray-900 i {\n  color: #181C32;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-900 .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-900 .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-900:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-900:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-900:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-900.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-900.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-900 .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #181C32;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-900 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-active-icon-gray-900 .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-900:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-900:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-900:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-900.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-active-icon-gray-900.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-active-icon-gray-900 .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-active-icon-gray-900.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-900.dropdown-toggle:after, .btn.btn-active-icon-gray-900:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900.active.dropdown-toggle:after, .btn.btn-active-icon-gray-900.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-900.dropdown-toggle:after {\n  color: #181C32;\n}\n\n.btn.btn-text-gray-900 {\n  color: #181C32;\n}\n.btn-check:checked + .btn.btn-active-text-gray-900, .btn-check:active + .btn.btn-active-text-gray-900, .btn.btn-active-text-gray-900:focus:not(.btn-active), .btn.btn-active-text-gray-900:hover:not(.btn-active), .btn.btn-active-text-gray-900:active:not(.btn-active), .btn.btn-active-text-gray-900.active, .btn.btn-active-text-gray-900.show, .show > .btn.btn-active-text-gray-900 {\n  color: #181C32;\n}\n\n.btn.btn-facebook {\n  color: #ffffff;\n  border-color: #3b5998;\n  background-color: #3b5998;\n}\n.btn.btn-facebook i {\n  color: #ffffff;\n}\n.btn.btn-facebook .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.btn.btn-facebook .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-facebook.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-facebook, .btn-check:active + .btn.btn-facebook, .btn.btn-facebook:focus:not(.btn-active), .btn.btn-facebook:hover:not(.btn-active), .btn.btn-facebook:active:not(.btn-active), .btn.btn-facebook.active, .btn.btn-facebook.show, .show > .btn.btn-facebook {\n  border-color: #30497c;\n  background-color: #30497c !important;\n}\n\n.btn.btn-light-facebook {\n  color: #3b5998;\n  border-color: rgba(59, 89, 152, 0.1);\n  background-color: rgba(59, 89, 152, 0.1);\n}\n.btn.btn-light-facebook i {\n  color: #3b5998;\n}\n.btn.btn-light-facebook .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #3b5998;\n}\n.btn.btn-light-facebook .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-light-facebook.dropdown-toggle:after {\n  color: #3b5998;\n}\n.btn-check:checked + .btn.btn-light-facebook, .btn-check:active + .btn.btn-light-facebook, .btn.btn-light-facebook:focus:not(.btn-active), .btn.btn-light-facebook:hover:not(.btn-active), .btn.btn-light-facebook:active:not(.btn-active), .btn.btn-light-facebook.active, .btn.btn-light-facebook.show, .show > .btn.btn-light-facebook {\n  color: #ffffff;\n  border-color: #3b5998;\n  background-color: #3b5998 !important;\n}\n.btn-check:checked + .btn.btn-light-facebook i, .btn-check:active + .btn.btn-light-facebook i, .btn.btn-light-facebook:focus:not(.btn-active) i, .btn.btn-light-facebook:hover:not(.btn-active) i, .btn.btn-light-facebook:active:not(.btn-active) i, .btn.btn-light-facebook.active i, .btn.btn-light-facebook.show i, .show > .btn.btn-light-facebook i {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-facebook .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-facebook .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-facebook:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-facebook:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-facebook:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-facebook.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-facebook.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-facebook .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-facebook .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-facebook .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-facebook:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-facebook:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-facebook:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-facebook.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-facebook.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-facebook .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-light-facebook.dropdown-toggle:after, .btn-check:active + .btn.btn-light-facebook.dropdown-toggle:after, .btn.btn-light-facebook:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook.active.dropdown-toggle:after, .btn.btn-light-facebook.show.dropdown-toggle:after, .show > .btn.btn-light-facebook.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-google {\n  color: #ffffff;\n  border-color: #dd4b39;\n  background-color: #dd4b39;\n}\n.btn.btn-google i {\n  color: #ffffff;\n}\n.btn.btn-google .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.btn.btn-google .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-google.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-google, .btn-check:active + .btn.btn-google, .btn.btn-google:focus:not(.btn-active), .btn.btn-google:hover:not(.btn-active), .btn.btn-google:active:not(.btn-active), .btn.btn-google.active, .btn.btn-google.show, .show > .btn.btn-google {\n  border-color: #cd3623;\n  background-color: #cd3623 !important;\n}\n\n.btn.btn-light-google {\n  color: #dd4b39;\n  border-color: rgba(221, 75, 57, 0.1);\n  background-color: rgba(221, 75, 57, 0.1);\n}\n.btn.btn-light-google i {\n  color: #dd4b39;\n}\n.btn.btn-light-google .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #dd4b39;\n}\n.btn.btn-light-google .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-light-google.dropdown-toggle:after {\n  color: #dd4b39;\n}\n.btn-check:checked + .btn.btn-light-google, .btn-check:active + .btn.btn-light-google, .btn.btn-light-google:focus:not(.btn-active), .btn.btn-light-google:hover:not(.btn-active), .btn.btn-light-google:active:not(.btn-active), .btn.btn-light-google.active, .btn.btn-light-google.show, .show > .btn.btn-light-google {\n  color: #ffffff;\n  border-color: #dd4b39;\n  background-color: #dd4b39 !important;\n}\n.btn-check:checked + .btn.btn-light-google i, .btn-check:active + .btn.btn-light-google i, .btn.btn-light-google:focus:not(.btn-active) i, .btn.btn-light-google:hover:not(.btn-active) i, .btn.btn-light-google:active:not(.btn-active) i, .btn.btn-light-google.active i, .btn.btn-light-google.show i, .show > .btn.btn-light-google i {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-google .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-google .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-google:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-google:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-google:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-google.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-google.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-google .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-google .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-google .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-google:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-google:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-google:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-google.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-google.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-google .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-light-google.dropdown-toggle:after, .btn-check:active + .btn.btn-light-google.dropdown-toggle:after, .btn.btn-light-google:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google.active.dropdown-toggle:after, .btn.btn-light-google.show.dropdown-toggle:after, .show > .btn.btn-light-google.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-twitter {\n  color: #ffffff;\n  border-color: #1da1f2;\n  background-color: #1da1f2;\n}\n.btn.btn-twitter i {\n  color: #ffffff;\n}\n.btn.btn-twitter .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.btn.btn-twitter .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-twitter.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-twitter, .btn-check:active + .btn.btn-twitter, .btn.btn-twitter:focus:not(.btn-active), .btn.btn-twitter:hover:not(.btn-active), .btn.btn-twitter:active:not(.btn-active), .btn.btn-twitter.active, .btn.btn-twitter.show, .show > .btn.btn-twitter {\n  border-color: #0d8ddc;\n  background-color: #0d8ddc !important;\n}\n\n.btn.btn-light-twitter {\n  color: #1da1f2;\n  border-color: rgba(29, 161, 242, 0.1);\n  background-color: rgba(29, 161, 242, 0.1);\n}\n.btn.btn-light-twitter i {\n  color: #1da1f2;\n}\n.btn.btn-light-twitter .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #1da1f2;\n}\n.btn.btn-light-twitter .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-light-twitter.dropdown-toggle:after {\n  color: #1da1f2;\n}\n.btn-check:checked + .btn.btn-light-twitter, .btn-check:active + .btn.btn-light-twitter, .btn.btn-light-twitter:focus:not(.btn-active), .btn.btn-light-twitter:hover:not(.btn-active), .btn.btn-light-twitter:active:not(.btn-active), .btn.btn-light-twitter.active, .btn.btn-light-twitter.show, .show > .btn.btn-light-twitter {\n  color: #ffffff;\n  border-color: #1da1f2;\n  background-color: #1da1f2 !important;\n}\n.btn-check:checked + .btn.btn-light-twitter i, .btn-check:active + .btn.btn-light-twitter i, .btn.btn-light-twitter:focus:not(.btn-active) i, .btn.btn-light-twitter:hover:not(.btn-active) i, .btn.btn-light-twitter:active:not(.btn-active) i, .btn.btn-light-twitter.active i, .btn.btn-light-twitter.show i, .show > .btn.btn-light-twitter i {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-twitter .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-twitter .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-twitter:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-twitter:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-twitter:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-twitter.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-twitter.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-twitter .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-twitter .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-twitter .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-twitter:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-twitter:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-twitter:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-twitter.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-twitter.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-twitter .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-light-twitter.dropdown-toggle:after, .btn-check:active + .btn.btn-light-twitter.dropdown-toggle:after, .btn.btn-light-twitter:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter.active.dropdown-toggle:after, .btn.btn-light-twitter.show.dropdown-toggle:after, .show > .btn.btn-light-twitter.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-instagram {\n  color: #ffffff;\n  border-color: #e1306c;\n  background-color: #e1306c;\n}\n.btn.btn-instagram i {\n  color: #ffffff;\n}\n.btn.btn-instagram .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.btn.btn-instagram .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-instagram.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-instagram, .btn-check:active + .btn.btn-instagram, .btn.btn-instagram:focus:not(.btn-active), .btn.btn-instagram:hover:not(.btn-active), .btn.btn-instagram:active:not(.btn-active), .btn.btn-instagram.active, .btn.btn-instagram.show, .show > .btn.btn-instagram {\n  border-color: #cd1e59;\n  background-color: #cd1e59 !important;\n}\n\n.btn.btn-light-instagram {\n  color: #e1306c;\n  border-color: rgba(225, 48, 108, 0.1);\n  background-color: rgba(225, 48, 108, 0.1);\n}\n.btn.btn-light-instagram i {\n  color: #e1306c;\n}\n.btn.btn-light-instagram .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #e1306c;\n}\n.btn.btn-light-instagram .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-light-instagram.dropdown-toggle:after {\n  color: #e1306c;\n}\n.btn-check:checked + .btn.btn-light-instagram, .btn-check:active + .btn.btn-light-instagram, .btn.btn-light-instagram:focus:not(.btn-active), .btn.btn-light-instagram:hover:not(.btn-active), .btn.btn-light-instagram:active:not(.btn-active), .btn.btn-light-instagram.active, .btn.btn-light-instagram.show, .show > .btn.btn-light-instagram {\n  color: #ffffff;\n  border-color: #e1306c;\n  background-color: #e1306c !important;\n}\n.btn-check:checked + .btn.btn-light-instagram i, .btn-check:active + .btn.btn-light-instagram i, .btn.btn-light-instagram:focus:not(.btn-active) i, .btn.btn-light-instagram:hover:not(.btn-active) i, .btn.btn-light-instagram:active:not(.btn-active) i, .btn.btn-light-instagram.active i, .btn.btn-light-instagram.show i, .show > .btn.btn-light-instagram i {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-instagram .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-instagram .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-instagram:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-instagram:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-instagram:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-instagram.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-instagram.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-instagram .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-instagram .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-instagram .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-instagram:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-instagram:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-instagram:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-instagram.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-instagram.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-instagram .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-light-instagram.dropdown-toggle:after, .btn-check:active + .btn.btn-light-instagram.dropdown-toggle:after, .btn.btn-light-instagram:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram.active.dropdown-toggle:after, .btn.btn-light-instagram.show.dropdown-toggle:after, .show > .btn.btn-light-instagram.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-youtube {\n  color: #ffffff;\n  border-color: #ff0000;\n  background-color: #ff0000;\n}\n.btn.btn-youtube i {\n  color: #ffffff;\n}\n.btn.btn-youtube .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.btn.btn-youtube .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-youtube.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-youtube, .btn-check:active + .btn.btn-youtube, .btn.btn-youtube:focus:not(.btn-active), .btn.btn-youtube:hover:not(.btn-active), .btn.btn-youtube:active:not(.btn-active), .btn.btn-youtube.active, .btn.btn-youtube.show, .show > .btn.btn-youtube {\n  border-color: #d90000;\n  background-color: #d90000 !important;\n}\n\n.btn.btn-light-youtube {\n  color: #ff0000;\n  border-color: rgba(255, 0, 0, 0.1);\n  background-color: rgba(255, 0, 0, 0.1);\n}\n.btn.btn-light-youtube i {\n  color: #ff0000;\n}\n.btn.btn-light-youtube .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ff0000;\n}\n.btn.btn-light-youtube .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-light-youtube.dropdown-toggle:after {\n  color: #ff0000;\n}\n.btn-check:checked + .btn.btn-light-youtube, .btn-check:active + .btn.btn-light-youtube, .btn.btn-light-youtube:focus:not(.btn-active), .btn.btn-light-youtube:hover:not(.btn-active), .btn.btn-light-youtube:active:not(.btn-active), .btn.btn-light-youtube.active, .btn.btn-light-youtube.show, .show > .btn.btn-light-youtube {\n  color: #ffffff;\n  border-color: #ff0000;\n  background-color: #ff0000 !important;\n}\n.btn-check:checked + .btn.btn-light-youtube i, .btn-check:active + .btn.btn-light-youtube i, .btn.btn-light-youtube:focus:not(.btn-active) i, .btn.btn-light-youtube:hover:not(.btn-active) i, .btn.btn-light-youtube:active:not(.btn-active) i, .btn.btn-light-youtube.active i, .btn.btn-light-youtube.show i, .show > .btn.btn-light-youtube i {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-youtube .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-youtube .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-youtube:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-youtube:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-youtube:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-youtube.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-youtube.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-youtube .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-youtube .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-youtube .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-youtube:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-youtube:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-youtube:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-youtube.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-youtube.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-youtube .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-light-youtube.dropdown-toggle:after, .btn-check:active + .btn.btn-light-youtube.dropdown-toggle:after, .btn.btn-light-youtube:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube.active.dropdown-toggle:after, .btn.btn-light-youtube.show.dropdown-toggle:after, .show > .btn.btn-light-youtube.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-linkedin {\n  color: #ffffff;\n  border-color: #0077b5;\n  background-color: #0077b5;\n}\n.btn.btn-linkedin i {\n  color: #ffffff;\n}\n.btn.btn-linkedin .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.btn.btn-linkedin .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-linkedin.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-linkedin, .btn-check:active + .btn.btn-linkedin, .btn.btn-linkedin:focus:not(.btn-active), .btn.btn-linkedin:hover:not(.btn-active), .btn.btn-linkedin:active:not(.btn-active), .btn.btn-linkedin.active, .btn.btn-linkedin.show, .show > .btn.btn-linkedin {\n  border-color: #005e8f;\n  background-color: #005e8f !important;\n}\n\n.btn.btn-light-linkedin {\n  color: #0077b5;\n  border-color: rgba(0, 119, 181, 0.1);\n  background-color: rgba(0, 119, 181, 0.1);\n}\n.btn.btn-light-linkedin i {\n  color: #0077b5;\n}\n.btn.btn-light-linkedin .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #0077b5;\n}\n.btn.btn-light-linkedin .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-light-linkedin.dropdown-toggle:after {\n  color: #0077b5;\n}\n.btn-check:checked + .btn.btn-light-linkedin, .btn-check:active + .btn.btn-light-linkedin, .btn.btn-light-linkedin:focus:not(.btn-active), .btn.btn-light-linkedin:hover:not(.btn-active), .btn.btn-light-linkedin:active:not(.btn-active), .btn.btn-light-linkedin.active, .btn.btn-light-linkedin.show, .show > .btn.btn-light-linkedin {\n  color: #ffffff;\n  border-color: #0077b5;\n  background-color: #0077b5 !important;\n}\n.btn-check:checked + .btn.btn-light-linkedin i, .btn-check:active + .btn.btn-light-linkedin i, .btn.btn-light-linkedin:focus:not(.btn-active) i, .btn.btn-light-linkedin:hover:not(.btn-active) i, .btn.btn-light-linkedin:active:not(.btn-active) i, .btn.btn-light-linkedin.active i, .btn.btn-light-linkedin.show i, .show > .btn.btn-light-linkedin i {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-linkedin .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-linkedin .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-linkedin:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-linkedin:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-linkedin:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-linkedin.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-light-linkedin.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-light-linkedin .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-linkedin .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-light-linkedin .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-linkedin:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-linkedin:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-linkedin:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-linkedin.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-light-linkedin.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-light-linkedin .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-light-linkedin.dropdown-toggle:after, .btn-check:active + .btn.btn-light-linkedin.dropdown-toggle:after, .btn.btn-light-linkedin:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin.active.dropdown-toggle:after, .btn.btn-light-linkedin.show.dropdown-toggle:after, .show > .btn.btn-light-linkedin.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-outline.btn-outline-dashed {\n  border-width: 1px;\n  border-style: dashed;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-dashed, .btn-check:active + .btn.btn-outline.btn-outline-dashed, .btn.btn-outline.btn-outline-dashed:focus:not(.btn-active), .btn.btn-outline.btn-outline-dashed:hover:not(.btn-active), .btn.btn-outline.btn-outline-dashed:active:not(.btn-active), .btn.btn-outline.btn-outline-dashed.active, .btn.btn-outline.btn-outline-dashed.show, .show > .btn.btn-outline.btn-outline-dashed {\n  border-color: #009EF7;\n}\n\n.btn.btn-outline.btn-outline-dashed.btn-outline-default {\n  border-width: 1px;\n  border-style: dashed;\n  color: #7E8299;\n  border-color: #E4E6EF;\n}\n.btn.btn-outline.btn-outline-dashed.btn-outline-default i {\n  color: #7E8299;\n}\n.btn.btn-outline.btn-outline-dashed.btn-outline-default .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7E8299;\n}\n.btn.btn-outline.btn-outline-dashed.btn-outline-default .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn.btn-outline.btn-outline-dashed.btn-outline-default.dropdown-toggle:after {\n  color: #7E8299;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-dashed.btn-outline-default, .btn-check:active + .btn.btn-outline.btn-outline-dashed.btn-outline-default, .btn.btn-outline.btn-outline-dashed.btn-outline-default:focus:not(.btn-active), .btn.btn-outline.btn-outline-dashed.btn-outline-default:hover:not(.btn-active), .btn.btn-outline.btn-outline-dashed.btn-outline-default:active:not(.btn-active), .btn.btn-outline.btn-outline-dashed.btn-outline-default.active, .btn.btn-outline.btn-outline-dashed.btn-outline-default.show, .show > .btn.btn-outline.btn-outline-dashed.btn-outline-default {\n  color: #009EF7;\n  border-color: #009EF7;\n  background-color: #F1FAFF !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-dashed.btn-outline-default i, .btn-check:active + .btn.btn-outline.btn-outline-dashed.btn-outline-default i, .btn.btn-outline.btn-outline-dashed.btn-outline-default:focus:not(.btn-active) i, .btn.btn-outline.btn-outline-dashed.btn-outline-default:hover:not(.btn-active) i, .btn.btn-outline.btn-outline-dashed.btn-outline-default:active:not(.btn-active) i, .btn.btn-outline.btn-outline-dashed.btn-outline-default.active i, .btn.btn-outline.btn-outline-dashed.btn-outline-default.show i, .show > .btn.btn-outline.btn-outline-dashed.btn-outline-default i {\n  color: #009EF7;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-dashed.btn-outline-default .svg-icon svg [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-outline.btn-outline-dashed.btn-outline-default .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-outline.btn-outline-dashed.btn-outline-default:focus:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-outline.btn-outline-dashed.btn-outline-default:hover:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-outline.btn-outline-dashed.btn-outline-default:active:not(.btn-active) .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-outline.btn-outline-dashed.btn-outline-default.active .svg-icon svg [fill]:not(.permanent):not(g), .btn.btn-outline.btn-outline-dashed.btn-outline-default.show .svg-icon svg [fill]:not(.permanent):not(g), .show > .btn.btn-outline.btn-outline-dashed.btn-outline-default .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-dashed.btn-outline-default .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn-check:active + .btn.btn-outline.btn-outline-dashed.btn-outline-default .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-outline.btn-outline-dashed.btn-outline-default:focus:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-outline.btn-outline-dashed.btn-outline-default:hover:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-outline.btn-outline-dashed.btn-outline-default:active:not(.btn-active) .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-outline.btn-outline-dashed.btn-outline-default.active .svg-icon svg:hover [fill]:not(.permanent):not(g), .btn.btn-outline.btn-outline-dashed.btn-outline-default.show .svg-icon svg:hover [fill]:not(.permanent):not(g), .show > .btn.btn-outline.btn-outline-dashed.btn-outline-default .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-dashed.btn-outline-default.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-dashed.btn-outline-default.dropdown-toggle:after, .btn.btn-outline.btn-outline-dashed.btn-outline-default:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dashed.btn-outline-default:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dashed.btn-outline-default:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dashed.btn-outline-default.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-dashed.btn-outline-default.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-dashed.btn-outline-default.dropdown-toggle:after {\n  color: #009EF7;\n}\n\ncode:not([class*=language-]) {\n  font-weight: 400;\n  color: #b93993;\n  line-height: inherit;\n  font-size: inherit;\n  background-color: #F1F3F8;\n  padding: 0.1rem 0.4rem;\n  margin: 0 0.5rem;\n  box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.08);\n  border-radius: 0.3rem;\n}\n\n.form-control {\n  box-shadow: none !important;\n}\n.dropdown.show > .form-control {\n  color: #181C32;\n  background-color: #ffffff;\n  border-color: #B5B5C3;\n}\n.form-control[readonly] {\n  background-color: #ffffff;\n}\n.form-control.form-control-solid {\n  background-color: #F5F8FA;\n  border-color: #F5F8FA;\n  color: #5E6278;\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.form-control.form-control-solid::placeholder {\n  color: #A1A5B7;\n}\n.form-control.form-control-solid::-moz-placeholder {\n  color: #A1A5B7;\n  opacity: 1;\n}\n.dropdown.show > .form-control.form-control-solid, .form-control.form-control-solid:active, .form-control.form-control-solid.active, .form-control.form-control-solid:focus, .form-control.form-control-solid.focus {\n  background-color: #eef3f7;\n  border-color: #eef3f7;\n  color: #5E6278;\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.form-control.form-control-transparent {\n  background-color: transparent;\n  border-color: transparent;\n}\n.dropdown.show > .form-control.form-control-transparent, .form-control.form-control-transparent:active, .form-control.form-control-transparent.active, .form-control.form-control-transparent:focus, .form-control.form-control-transparent.focus {\n  background-color: transparent;\n  border-color: transparent;\n}\n.form-control.form-control-flush {\n  border: 0;\n  background-color: transparent;\n  outline: none !important;\n  box-shadow: none;\n  border-radius: 0;\n}\n\n.placeholder-gray-500::placeholder {\n  color: #A1A5B7;\n}\n.placeholder-gray-500::-moz-placeholder {\n  color: #A1A5B7;\n  opacity: 1;\n}\n\n.placeholder-white::placeholder {\n  color: #ffffff;\n}\n.placeholder-white::-moz-placeholder {\n  color: #ffffff;\n  opacity: 1;\n}\n\n.resize-none {\n  resize: none;\n}\n\n.form-select {\n  box-shadow: none !important;\n}\n.form-select.form-select-solid {\n  background-color: #F5F8FA;\n  border-color: #F5F8FA;\n  color: #5E6278;\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.form-select.form-select-solid::placeholder {\n  color: #A1A5B7;\n}\n.form-select.form-select-solid::-moz-placeholder {\n  color: #A1A5B7;\n  opacity: 1;\n}\n.dropdown.show > .form-select.form-select-solid, .form-select.form-select-solid:active, .form-select.form-select-solid.active, .form-select.form-select-solid:focus, .form-select.form-select-solid.focus {\n  background-color: #eef3f7;\n  border-color: #eef3f7 !important;\n  color: #5E6278;\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.form-select.form-select-transparent {\n  background-color: transparent;\n  border-color: transparent;\n  color: #181C32;\n}\n.form-select.form-select-transparent::placeholder {\n  color: #A1A5B7;\n}\n.form-select.form-select-transparent::-moz-placeholder {\n  color: #A1A5B7;\n  opacity: 1;\n}\n.dropdown.show > .form-select.form-select-transparent, .form-select.form-select-transparent:active, .form-select.form-select-transparent.active, .form-select.form-select-transparent:focus, .form-select.form-select-transparent.focus {\n  background-color: transparent;\n  border-color: transparent !important;\n  color: #181C32;\n}\n\n.form-check .form-check-label {\n  cursor: pointer;\n}\n.form-check .form-check-input {\n  cursor: pointer;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n.form-check.form-check-custom {\n  display: flex;\n  align-items: center;\n  padding-left: 0;\n  margin: 0;\n}\n.form-check.form-check-custom .form-check-input {\n  margin: 0;\n  float: none;\n  flex-shrink: 0;\n}\n.form-check.form-check-custom .form-check-label {\n  margin-left: 0.55rem;\n}\n.form-check:not(.form-switch) .form-check-input[type=checkbox] {\n  background-size: 60% 60%;\n}\n.form-check.form-check-solid .form-check-input {\n  border: 0;\n  background-color: #EFF2F5;\n}\n.form-check.form-check-solid .form-check-input:active, .form-check.form-check-solid .form-check-input:focus {\n  filter: none;\n  background-color: #EFF2F5;\n}\n.form-check.form-check-solid .form-check-input:checked {\n  background-color: #009EF7;\n}\n.form-check.form-check-success .form-check-input:checked {\n  background-color: #50CD89;\n}\n.form-check.form-check-danger .form-check-input:checked {\n  background-color: #F1416C;\n}\n.form-check.form-check-warning .form-check-input:checked {\n  background-color: #FFC700;\n}\n\n.form-check.form-check-custom.form-check-sm .form-check-input {\n  height: 1.5rem;\n  width: 1.5rem;\n}\n.form-check.form-check-custom.form-check-lg .form-check-input {\n  height: 2.25rem;\n  width: 2.25rem;\n}\n\n.form-switch.form-check-solid .form-check-input {\n  height: 2.25rem;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23ffffff'/%3e%3c/svg%3e\");\n  border-radius: 3.25rem;\n}\n.form-switch.form-check-solid .form-check-input:checked {\n  filter: none;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23FFFFFF'/%3e%3c/svg%3e\");\n}\n.form-switch.form-check-solid.form-switch-sm .form-check-input {\n  height: 1.5rem;\n  width: 2.5rem;\n}\n.form-switch.form-check-solid.form-switch-lg .form-check-input {\n  height: 2.75rem;\n  width: 3.75rem;\n}\n\n.input-group.input-group-solid {\n  background-color: #F5F8FA;\n  border-color: #F5F8FA;\n  border-radius: 0.475rem;\n}\n.input-group.input-group-solid.input-group-sm {\n  border-radius: 0.475rem;\n}\n.input-group.input-group-solid.input-group-lg {\n  border-radius: 0.475rem;\n}\n.input-group.input-group-solid .input-group-text {\n  background-color: #F5F8FA;\n  border-color: #F5F8FA;\n}\n.input-group.input-group-solid .input-group-text + .form-control {\n  border-left-color: #E4E6EF;\n}\n.input-group.input-group-solid .form-control {\n  background-color: transparent;\n  border-color: transparent;\n}\n.input-group.input-group-solid .form-control + .input-group-text {\n  border-left-color: #E4E6EF;\n}\n\n.required:after {\n  content: \"*\";\n  position: relative;\n  font-size: inherit;\n  color: #F1416C;\n  padding-left: 0.25rem;\n  font-weight: bold;\n}\n\n.modal .modal-header {\n  align-items: center;\n  justify-content: space-between;\n  border-top-left-radius: 0.475rem;\n  border-top-right-radius: 0.475rem;\n}\n.modal .modal-header h1, .modal .modal-header .h1, .modal .modal-header h2, .modal .modal-header .h2, .modal .modal-header h3, .modal .modal-header .h3, .modal .modal-header h4, .modal .modal-header .h4, .modal .modal-header h5, .modal .modal-header .h5, .modal .modal-header h6, .modal .modal-header .h6 {\n  margin-bottom: 0;\n}\n.modal .modal-dialog {\n  outline: none !important;\n}\n\n.modal-rounded {\n  border-radius: 0.475rem !important;\n}\n\n.progress-vertical {\n  display: flex;\n  align-items: stretch;\n  justify-content: space-between;\n}\n.progress-vertical .progress {\n  height: 100%;\n  border-radius: 0.475rem;\n  display: flex;\n  align-items: flex-end;\n  margin-right: 1rem;\n}\n.progress-vertical .progress:last-child {\n  margin-right: 0;\n}\n.progress-vertical .progress .progress-bar {\n  width: 8px;\n  border-radius: 0.475rem;\n}\n\n.table > :not(:first-child) {\n  border-color: transparent;\n  border-width: 0;\n  border-style: none;\n}\n.table > :not(:last-child) > :last-child > * {\n  border-bottom-color: inherit;\n}\n.table tr, .table th, .table td {\n  border-color: inherit;\n  border-width: inherit;\n  border-style: inherit;\n  text-transform: inherit;\n  font-weight: inherit;\n  font-size: inherit;\n  color: inherit;\n  height: inherit;\n  min-height: inherit;\n}\n.table tr:first-child, .table th:first-child, .table td:first-child {\n  padding-left: 0;\n}\n.table tr:last-child, .table th:last-child, .table td:last-child {\n  padding-right: 0;\n}\n.table tfoot tr:last-child,\n.table tbody tr:last-child {\n  border-bottom: 0 !important;\n}\n.table tfoot tr:last-child th, .table tfoot tr:last-child td,\n.table tbody tr:last-child th,\n.table tbody tr:last-child td {\n  border-bottom: 0 !important;\n}\n.table tfoot th, .table tfoot td {\n  border-top: inherit;\n}\n.table.table-rounded {\n  border-radius: 0.475rem;\n  border-spacing: 0;\n  border-collapse: separate;\n}\n.table.table-flush tr, .table.table-flush th, .table.table-flush td {\n  padding: inherit;\n}\n.table.table-row-bordered tr {\n  border-bottom-width: 1px;\n  border-bottom-style: solid;\n  border-bottom-color: #EFF2F5;\n}\n.table.table-row-bordered tfoot th, .table.table-row-bordered tfoot td {\n  border-top-width: 1px !important;\n}\n.table.table-row-dashed tr {\n  border-bottom-width: 1px;\n  border-bottom-style: dashed;\n  border-bottom-color: #EFF2F5;\n}\n.table.table-row-dashed tfoot th, .table.table-row-dashed tfoot td {\n  border-top-width: 1px !important;\n}\n.table.table-row-gray-100 tr {\n  border-bottom-color: #F5F8FA;\n}\n.table.table-row-gray-200 tr {\n  border-bottom-color: #EFF2F5;\n}\n.table.table-row-gray-300 tr {\n  border-bottom-color: #E4E6EF;\n}\n.table.table-row-gray-400 tr {\n  border-bottom-color: #B5B5C3;\n}\n.table.table-row-gray-500 tr {\n  border-bottom-color: #A1A5B7;\n}\n.table.table-row-gray-600 tr {\n  border-bottom-color: #7E8299;\n}\n.table.table-row-gray-700 tr {\n  border-bottom-color: #5E6278;\n}\n.table.table-row-gray-800 tr {\n  border-bottom-color: #3F4254;\n}\n.table.table-row-gray-900 tr {\n  border-bottom-color: #181C32;\n}\n\n.table.g-0 th, .table.g-0 td {\n  padding: 0rem;\n}\n.table.g-0 th.dtr-control, .table.g-0 td.dtr-control {\n  padding-left: 0rem !important;\n}\n\n.table.gy-0 th, .table.gy-0 td {\n  padding-top: 0rem;\n  padding-bottom: 0rem;\n}\n\n.table.gx-0 th, .table.gx-0 td {\n  padding-left: 0rem;\n  padding-right: 0rem;\n}\n.table.gx-0 th.dtr-control, .table.gx-0 td.dtr-control {\n  padding-left: 0rem !important;\n}\n\n.table.gs-0 th:first-child, .table.gs-0 td:first-child {\n  padding-left: 0rem;\n}\n.table.gs-0 th:last-child, .table.gs-0 td:last-child {\n  padding-right: 0rem;\n}\n.table.gs-0 th.dtr-control:first-child, .table.gs-0 td.dtr-control:first-child {\n  padding-left: 0rem !important;\n}\n\n.table.g-1 th, .table.g-1 td {\n  padding: 0.25rem;\n}\n.table.g-1 th.dtr-control, .table.g-1 td.dtr-control {\n  padding-left: 0.25rem !important;\n}\n\n.table.gy-1 th, .table.gy-1 td {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n}\n\n.table.gx-1 th, .table.gx-1 td {\n  padding-left: 0.25rem;\n  padding-right: 0.25rem;\n}\n.table.gx-1 th.dtr-control, .table.gx-1 td.dtr-control {\n  padding-left: 0.25rem !important;\n}\n\n.table.gs-1 th:first-child, .table.gs-1 td:first-child {\n  padding-left: 0.25rem;\n}\n.table.gs-1 th:last-child, .table.gs-1 td:last-child {\n  padding-right: 0.25rem;\n}\n.table.gs-1 th.dtr-control:first-child, .table.gs-1 td.dtr-control:first-child {\n  padding-left: 0.25rem !important;\n}\n\n.table.g-2 th, .table.g-2 td {\n  padding: 0.5rem;\n}\n.table.g-2 th.dtr-control, .table.g-2 td.dtr-control {\n  padding-left: 0.5rem !important;\n}\n\n.table.gy-2 th, .table.gy-2 td {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.table.gx-2 th, .table.gx-2 td {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n.table.gx-2 th.dtr-control, .table.gx-2 td.dtr-control {\n  padding-left: 0.5rem !important;\n}\n\n.table.gs-2 th:first-child, .table.gs-2 td:first-child {\n  padding-left: 0.5rem;\n}\n.table.gs-2 th:last-child, .table.gs-2 td:last-child {\n  padding-right: 0.5rem;\n}\n.table.gs-2 th.dtr-control:first-child, .table.gs-2 td.dtr-control:first-child {\n  padding-left: 0.5rem !important;\n}\n\n.table.g-3 th, .table.g-3 td {\n  padding: 0.75rem;\n}\n.table.g-3 th.dtr-control, .table.g-3 td.dtr-control {\n  padding-left: 0.75rem !important;\n}\n\n.table.gy-3 th, .table.gy-3 td {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n\n.table.gx-3 th, .table.gx-3 td {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n}\n.table.gx-3 th.dtr-control, .table.gx-3 td.dtr-control {\n  padding-left: 0.75rem !important;\n}\n\n.table.gs-3 th:first-child, .table.gs-3 td:first-child {\n  padding-left: 0.75rem;\n}\n.table.gs-3 th:last-child, .table.gs-3 td:last-child {\n  padding-right: 0.75rem;\n}\n.table.gs-3 th.dtr-control:first-child, .table.gs-3 td.dtr-control:first-child {\n  padding-left: 0.75rem !important;\n}\n\n.table.g-4 th, .table.g-4 td {\n  padding: 1rem;\n}\n.table.g-4 th.dtr-control, .table.g-4 td.dtr-control {\n  padding-left: 1rem !important;\n}\n\n.table.gy-4 th, .table.gy-4 td {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.table.gx-4 th, .table.gx-4 td {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n.table.gx-4 th.dtr-control, .table.gx-4 td.dtr-control {\n  padding-left: 1rem !important;\n}\n\n.table.gs-4 th:first-child, .table.gs-4 td:first-child {\n  padding-left: 1rem;\n}\n.table.gs-4 th:last-child, .table.gs-4 td:last-child {\n  padding-right: 1rem;\n}\n.table.gs-4 th.dtr-control:first-child, .table.gs-4 td.dtr-control:first-child {\n  padding-left: 1rem !important;\n}\n\n.table.g-5 th, .table.g-5 td {\n  padding: 1.25rem;\n}\n.table.g-5 th.dtr-control, .table.g-5 td.dtr-control {\n  padding-left: 1.25rem !important;\n}\n\n.table.gy-5 th, .table.gy-5 td {\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n}\n\n.table.gx-5 th, .table.gx-5 td {\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n.table.gx-5 th.dtr-control, .table.gx-5 td.dtr-control {\n  padding-left: 1.25rem !important;\n}\n\n.table.gs-5 th:first-child, .table.gs-5 td:first-child {\n  padding-left: 1.25rem;\n}\n.table.gs-5 th:last-child, .table.gs-5 td:last-child {\n  padding-right: 1.25rem;\n}\n.table.gs-5 th.dtr-control:first-child, .table.gs-5 td.dtr-control:first-child {\n  padding-left: 1.25rem !important;\n}\n\n.table.g-6 th, .table.g-6 td {\n  padding: 1.5rem;\n}\n.table.g-6 th.dtr-control, .table.g-6 td.dtr-control {\n  padding-left: 1.5rem !important;\n}\n\n.table.gy-6 th, .table.gy-6 td {\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n}\n\n.table.gx-6 th, .table.gx-6 td {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n.table.gx-6 th.dtr-control, .table.gx-6 td.dtr-control {\n  padding-left: 1.5rem !important;\n}\n\n.table.gs-6 th:first-child, .table.gs-6 td:first-child {\n  padding-left: 1.5rem;\n}\n.table.gs-6 th:last-child, .table.gs-6 td:last-child {\n  padding-right: 1.5rem;\n}\n.table.gs-6 th.dtr-control:first-child, .table.gs-6 td.dtr-control:first-child {\n  padding-left: 1.5rem !important;\n}\n\n.table.g-7 th, .table.g-7 td {\n  padding: 1.75rem;\n}\n.table.g-7 th.dtr-control, .table.g-7 td.dtr-control {\n  padding-left: 1.75rem !important;\n}\n\n.table.gy-7 th, .table.gy-7 td {\n  padding-top: 1.75rem;\n  padding-bottom: 1.75rem;\n}\n\n.table.gx-7 th, .table.gx-7 td {\n  padding-left: 1.75rem;\n  padding-right: 1.75rem;\n}\n.table.gx-7 th.dtr-control, .table.gx-7 td.dtr-control {\n  padding-left: 1.75rem !important;\n}\n\n.table.gs-7 th:first-child, .table.gs-7 td:first-child {\n  padding-left: 1.75rem;\n}\n.table.gs-7 th:last-child, .table.gs-7 td:last-child {\n  padding-right: 1.75rem;\n}\n.table.gs-7 th.dtr-control:first-child, .table.gs-7 td.dtr-control:first-child {\n  padding-left: 1.75rem !important;\n}\n\n.table.g-8 th, .table.g-8 td {\n  padding: 2rem;\n}\n.table.g-8 th.dtr-control, .table.g-8 td.dtr-control {\n  padding-left: 2rem !important;\n}\n\n.table.gy-8 th, .table.gy-8 td {\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n\n.table.gx-8 th, .table.gx-8 td {\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n.table.gx-8 th.dtr-control, .table.gx-8 td.dtr-control {\n  padding-left: 2rem !important;\n}\n\n.table.gs-8 th:first-child, .table.gs-8 td:first-child {\n  padding-left: 2rem;\n}\n.table.gs-8 th:last-child, .table.gs-8 td:last-child {\n  padding-right: 2rem;\n}\n.table.gs-8 th.dtr-control:first-child, .table.gs-8 td.dtr-control:first-child {\n  padding-left: 2rem !important;\n}\n\n.table.g-9 th, .table.g-9 td {\n  padding: 2.25rem;\n}\n.table.g-9 th.dtr-control, .table.g-9 td.dtr-control {\n  padding-left: 2.25rem !important;\n}\n\n.table.gy-9 th, .table.gy-9 td {\n  padding-top: 2.25rem;\n  padding-bottom: 2.25rem;\n}\n\n.table.gx-9 th, .table.gx-9 td {\n  padding-left: 2.25rem;\n  padding-right: 2.25rem;\n}\n.table.gx-9 th.dtr-control, .table.gx-9 td.dtr-control {\n  padding-left: 2.25rem !important;\n}\n\n.table.gs-9 th:first-child, .table.gs-9 td:first-child {\n  padding-left: 2.25rem;\n}\n.table.gs-9 th:last-child, .table.gs-9 td:last-child {\n  padding-right: 2.25rem;\n}\n.table.gs-9 th.dtr-control:first-child, .table.gs-9 td.dtr-control:first-child {\n  padding-left: 2.25rem !important;\n}\n\n.table.g-10 th, .table.g-10 td {\n  padding: 2.5rem;\n}\n.table.g-10 th.dtr-control, .table.g-10 td.dtr-control {\n  padding-left: 2.5rem !important;\n}\n\n.table.gy-10 th, .table.gy-10 td {\n  padding-top: 2.5rem;\n  padding-bottom: 2.5rem;\n}\n\n.table.gx-10 th, .table.gx-10 td {\n  padding-left: 2.5rem;\n  padding-right: 2.5rem;\n}\n.table.gx-10 th.dtr-control, .table.gx-10 td.dtr-control {\n  padding-left: 2.5rem !important;\n}\n\n.table.gs-10 th:first-child, .table.gs-10 td:first-child {\n  padding-left: 2.5rem;\n}\n.table.gs-10 th:last-child, .table.gs-10 td:last-child {\n  padding-right: 2.5rem;\n}\n.table.gs-10 th.dtr-control:first-child, .table.gs-10 td.dtr-control:first-child {\n  padding-left: 2.5rem !important;\n}\n\n@media (min-width: 576px) {\n  .table.g-sm-0 th, .table.g-sm-0 td {\n    padding: 0rem;\n  }\n  .table.g-sm-0 th.dtr-control, .table.g-sm-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n\n  .table.gy-sm-0 th, .table.gy-sm-0 td {\n    padding-top: 0rem;\n    padding-bottom: 0rem;\n  }\n\n  .table.gx-sm-0 th, .table.gx-sm-0 td {\n    padding-left: 0rem;\n    padding-right: 0rem;\n  }\n  .table.gx-sm-0 th.dtr-control, .table.gx-sm-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n\n  .table.gs-sm-0 th:first-child, .table.gs-sm-0 td:first-child {\n    padding-left: 0rem;\n  }\n  .table.gs-sm-0 th:last-child, .table.gs-sm-0 td:last-child {\n    padding-right: 0rem;\n  }\n  .table.gs-sm-0 th.dtr-control:first-child, .table.gs-sm-0 td.dtr-control:first-child {\n    padding-left: 0rem !important;\n  }\n\n  .table.g-sm-1 th, .table.g-sm-1 td {\n    padding: 0.25rem;\n  }\n  .table.g-sm-1 th.dtr-control, .table.g-sm-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.gy-sm-1 th, .table.gy-sm-1 td {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n\n  .table.gx-sm-1 th, .table.gx-sm-1 td {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .table.gx-sm-1 th.dtr-control, .table.gx-sm-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.gs-sm-1 th:first-child, .table.gs-sm-1 td:first-child {\n    padding-left: 0.25rem;\n  }\n  .table.gs-sm-1 th:last-child, .table.gs-sm-1 td:last-child {\n    padding-right: 0.25rem;\n  }\n  .table.gs-sm-1 th.dtr-control:first-child, .table.gs-sm-1 td.dtr-control:first-child {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.g-sm-2 th, .table.g-sm-2 td {\n    padding: 0.5rem;\n  }\n  .table.g-sm-2 th.dtr-control, .table.g-sm-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.gy-sm-2 th, .table.gy-sm-2 td {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n\n  .table.gx-sm-2 th, .table.gx-sm-2 td {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .table.gx-sm-2 th.dtr-control, .table.gx-sm-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.gs-sm-2 th:first-child, .table.gs-sm-2 td:first-child {\n    padding-left: 0.5rem;\n  }\n  .table.gs-sm-2 th:last-child, .table.gs-sm-2 td:last-child {\n    padding-right: 0.5rem;\n  }\n  .table.gs-sm-2 th.dtr-control:first-child, .table.gs-sm-2 td.dtr-control:first-child {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.g-sm-3 th, .table.g-sm-3 td {\n    padding: 0.75rem;\n  }\n  .table.g-sm-3 th.dtr-control, .table.g-sm-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.gy-sm-3 th, .table.gy-sm-3 td {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n\n  .table.gx-sm-3 th, .table.gx-sm-3 td {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .table.gx-sm-3 th.dtr-control, .table.gx-sm-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.gs-sm-3 th:first-child, .table.gs-sm-3 td:first-child {\n    padding-left: 0.75rem;\n  }\n  .table.gs-sm-3 th:last-child, .table.gs-sm-3 td:last-child {\n    padding-right: 0.75rem;\n  }\n  .table.gs-sm-3 th.dtr-control:first-child, .table.gs-sm-3 td.dtr-control:first-child {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.g-sm-4 th, .table.g-sm-4 td {\n    padding: 1rem;\n  }\n  .table.g-sm-4 th.dtr-control, .table.g-sm-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n\n  .table.gy-sm-4 th, .table.gy-sm-4 td {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n\n  .table.gx-sm-4 th, .table.gx-sm-4 td {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .table.gx-sm-4 th.dtr-control, .table.gx-sm-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n\n  .table.gs-sm-4 th:first-child, .table.gs-sm-4 td:first-child {\n    padding-left: 1rem;\n  }\n  .table.gs-sm-4 th:last-child, .table.gs-sm-4 td:last-child {\n    padding-right: 1rem;\n  }\n  .table.gs-sm-4 th.dtr-control:first-child, .table.gs-sm-4 td.dtr-control:first-child {\n    padding-left: 1rem !important;\n  }\n\n  .table.g-sm-5 th, .table.g-sm-5 td {\n    padding: 1.25rem;\n  }\n  .table.g-sm-5 th.dtr-control, .table.g-sm-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.gy-sm-5 th, .table.gy-sm-5 td {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n\n  .table.gx-sm-5 th, .table.gx-sm-5 td {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .table.gx-sm-5 th.dtr-control, .table.gx-sm-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.gs-sm-5 th:first-child, .table.gs-sm-5 td:first-child {\n    padding-left: 1.25rem;\n  }\n  .table.gs-sm-5 th:last-child, .table.gs-sm-5 td:last-child {\n    padding-right: 1.25rem;\n  }\n  .table.gs-sm-5 th.dtr-control:first-child, .table.gs-sm-5 td.dtr-control:first-child {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.g-sm-6 th, .table.g-sm-6 td {\n    padding: 1.5rem;\n  }\n  .table.g-sm-6 th.dtr-control, .table.g-sm-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.gy-sm-6 th, .table.gy-sm-6 td {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n\n  .table.gx-sm-6 th, .table.gx-sm-6 td {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .table.gx-sm-6 th.dtr-control, .table.gx-sm-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.gs-sm-6 th:first-child, .table.gs-sm-6 td:first-child {\n    padding-left: 1.5rem;\n  }\n  .table.gs-sm-6 th:last-child, .table.gs-sm-6 td:last-child {\n    padding-right: 1.5rem;\n  }\n  .table.gs-sm-6 th.dtr-control:first-child, .table.gs-sm-6 td.dtr-control:first-child {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.g-sm-7 th, .table.g-sm-7 td {\n    padding: 1.75rem;\n  }\n  .table.g-sm-7 th.dtr-control, .table.g-sm-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.gy-sm-7 th, .table.gy-sm-7 td {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n\n  .table.gx-sm-7 th, .table.gx-sm-7 td {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .table.gx-sm-7 th.dtr-control, .table.gx-sm-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.gs-sm-7 th:first-child, .table.gs-sm-7 td:first-child {\n    padding-left: 1.75rem;\n  }\n  .table.gs-sm-7 th:last-child, .table.gs-sm-7 td:last-child {\n    padding-right: 1.75rem;\n  }\n  .table.gs-sm-7 th.dtr-control:first-child, .table.gs-sm-7 td.dtr-control:first-child {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.g-sm-8 th, .table.g-sm-8 td {\n    padding: 2rem;\n  }\n  .table.g-sm-8 th.dtr-control, .table.g-sm-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n\n  .table.gy-sm-8 th, .table.gy-sm-8 td {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n\n  .table.gx-sm-8 th, .table.gx-sm-8 td {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .table.gx-sm-8 th.dtr-control, .table.gx-sm-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n\n  .table.gs-sm-8 th:first-child, .table.gs-sm-8 td:first-child {\n    padding-left: 2rem;\n  }\n  .table.gs-sm-8 th:last-child, .table.gs-sm-8 td:last-child {\n    padding-right: 2rem;\n  }\n  .table.gs-sm-8 th.dtr-control:first-child, .table.gs-sm-8 td.dtr-control:first-child {\n    padding-left: 2rem !important;\n  }\n\n  .table.g-sm-9 th, .table.g-sm-9 td {\n    padding: 2.25rem;\n  }\n  .table.g-sm-9 th.dtr-control, .table.g-sm-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.gy-sm-9 th, .table.gy-sm-9 td {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n\n  .table.gx-sm-9 th, .table.gx-sm-9 td {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .table.gx-sm-9 th.dtr-control, .table.gx-sm-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.gs-sm-9 th:first-child, .table.gs-sm-9 td:first-child {\n    padding-left: 2.25rem;\n  }\n  .table.gs-sm-9 th:last-child, .table.gs-sm-9 td:last-child {\n    padding-right: 2.25rem;\n  }\n  .table.gs-sm-9 th.dtr-control:first-child, .table.gs-sm-9 td.dtr-control:first-child {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.g-sm-10 th, .table.g-sm-10 td {\n    padding: 2.5rem;\n  }\n  .table.g-sm-10 th.dtr-control, .table.g-sm-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n\n  .table.gy-sm-10 th, .table.gy-sm-10 td {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n\n  .table.gx-sm-10 th, .table.gx-sm-10 td {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .table.gx-sm-10 th.dtr-control, .table.gx-sm-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n\n  .table.gs-sm-10 th:first-child, .table.gs-sm-10 td:first-child {\n    padding-left: 2.5rem;\n  }\n  .table.gs-sm-10 th:last-child, .table.gs-sm-10 td:last-child {\n    padding-right: 2.5rem;\n  }\n  .table.gs-sm-10 th.dtr-control:first-child, .table.gs-sm-10 td.dtr-control:first-child {\n    padding-left: 2.5rem !important;\n  }\n}\n@media (min-width: 768px) {\n  .table.g-md-0 th, .table.g-md-0 td {\n    padding: 0rem;\n  }\n  .table.g-md-0 th.dtr-control, .table.g-md-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n\n  .table.gy-md-0 th, .table.gy-md-0 td {\n    padding-top: 0rem;\n    padding-bottom: 0rem;\n  }\n\n  .table.gx-md-0 th, .table.gx-md-0 td {\n    padding-left: 0rem;\n    padding-right: 0rem;\n  }\n  .table.gx-md-0 th.dtr-control, .table.gx-md-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n\n  .table.gs-md-0 th:first-child, .table.gs-md-0 td:first-child {\n    padding-left: 0rem;\n  }\n  .table.gs-md-0 th:last-child, .table.gs-md-0 td:last-child {\n    padding-right: 0rem;\n  }\n  .table.gs-md-0 th.dtr-control:first-child, .table.gs-md-0 td.dtr-control:first-child {\n    padding-left: 0rem !important;\n  }\n\n  .table.g-md-1 th, .table.g-md-1 td {\n    padding: 0.25rem;\n  }\n  .table.g-md-1 th.dtr-control, .table.g-md-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.gy-md-1 th, .table.gy-md-1 td {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n\n  .table.gx-md-1 th, .table.gx-md-1 td {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .table.gx-md-1 th.dtr-control, .table.gx-md-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.gs-md-1 th:first-child, .table.gs-md-1 td:first-child {\n    padding-left: 0.25rem;\n  }\n  .table.gs-md-1 th:last-child, .table.gs-md-1 td:last-child {\n    padding-right: 0.25rem;\n  }\n  .table.gs-md-1 th.dtr-control:first-child, .table.gs-md-1 td.dtr-control:first-child {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.g-md-2 th, .table.g-md-2 td {\n    padding: 0.5rem;\n  }\n  .table.g-md-2 th.dtr-control, .table.g-md-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.gy-md-2 th, .table.gy-md-2 td {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n\n  .table.gx-md-2 th, .table.gx-md-2 td {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .table.gx-md-2 th.dtr-control, .table.gx-md-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.gs-md-2 th:first-child, .table.gs-md-2 td:first-child {\n    padding-left: 0.5rem;\n  }\n  .table.gs-md-2 th:last-child, .table.gs-md-2 td:last-child {\n    padding-right: 0.5rem;\n  }\n  .table.gs-md-2 th.dtr-control:first-child, .table.gs-md-2 td.dtr-control:first-child {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.g-md-3 th, .table.g-md-3 td {\n    padding: 0.75rem;\n  }\n  .table.g-md-3 th.dtr-control, .table.g-md-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.gy-md-3 th, .table.gy-md-3 td {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n\n  .table.gx-md-3 th, .table.gx-md-3 td {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .table.gx-md-3 th.dtr-control, .table.gx-md-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.gs-md-3 th:first-child, .table.gs-md-3 td:first-child {\n    padding-left: 0.75rem;\n  }\n  .table.gs-md-3 th:last-child, .table.gs-md-3 td:last-child {\n    padding-right: 0.75rem;\n  }\n  .table.gs-md-3 th.dtr-control:first-child, .table.gs-md-3 td.dtr-control:first-child {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.g-md-4 th, .table.g-md-4 td {\n    padding: 1rem;\n  }\n  .table.g-md-4 th.dtr-control, .table.g-md-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n\n  .table.gy-md-4 th, .table.gy-md-4 td {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n\n  .table.gx-md-4 th, .table.gx-md-4 td {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .table.gx-md-4 th.dtr-control, .table.gx-md-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n\n  .table.gs-md-4 th:first-child, .table.gs-md-4 td:first-child {\n    padding-left: 1rem;\n  }\n  .table.gs-md-4 th:last-child, .table.gs-md-4 td:last-child {\n    padding-right: 1rem;\n  }\n  .table.gs-md-4 th.dtr-control:first-child, .table.gs-md-4 td.dtr-control:first-child {\n    padding-left: 1rem !important;\n  }\n\n  .table.g-md-5 th, .table.g-md-5 td {\n    padding: 1.25rem;\n  }\n  .table.g-md-5 th.dtr-control, .table.g-md-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.gy-md-5 th, .table.gy-md-5 td {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n\n  .table.gx-md-5 th, .table.gx-md-5 td {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .table.gx-md-5 th.dtr-control, .table.gx-md-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.gs-md-5 th:first-child, .table.gs-md-5 td:first-child {\n    padding-left: 1.25rem;\n  }\n  .table.gs-md-5 th:last-child, .table.gs-md-5 td:last-child {\n    padding-right: 1.25rem;\n  }\n  .table.gs-md-5 th.dtr-control:first-child, .table.gs-md-5 td.dtr-control:first-child {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.g-md-6 th, .table.g-md-6 td {\n    padding: 1.5rem;\n  }\n  .table.g-md-6 th.dtr-control, .table.g-md-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.gy-md-6 th, .table.gy-md-6 td {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n\n  .table.gx-md-6 th, .table.gx-md-6 td {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .table.gx-md-6 th.dtr-control, .table.gx-md-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.gs-md-6 th:first-child, .table.gs-md-6 td:first-child {\n    padding-left: 1.5rem;\n  }\n  .table.gs-md-6 th:last-child, .table.gs-md-6 td:last-child {\n    padding-right: 1.5rem;\n  }\n  .table.gs-md-6 th.dtr-control:first-child, .table.gs-md-6 td.dtr-control:first-child {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.g-md-7 th, .table.g-md-7 td {\n    padding: 1.75rem;\n  }\n  .table.g-md-7 th.dtr-control, .table.g-md-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.gy-md-7 th, .table.gy-md-7 td {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n\n  .table.gx-md-7 th, .table.gx-md-7 td {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .table.gx-md-7 th.dtr-control, .table.gx-md-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.gs-md-7 th:first-child, .table.gs-md-7 td:first-child {\n    padding-left: 1.75rem;\n  }\n  .table.gs-md-7 th:last-child, .table.gs-md-7 td:last-child {\n    padding-right: 1.75rem;\n  }\n  .table.gs-md-7 th.dtr-control:first-child, .table.gs-md-7 td.dtr-control:first-child {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.g-md-8 th, .table.g-md-8 td {\n    padding: 2rem;\n  }\n  .table.g-md-8 th.dtr-control, .table.g-md-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n\n  .table.gy-md-8 th, .table.gy-md-8 td {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n\n  .table.gx-md-8 th, .table.gx-md-8 td {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .table.gx-md-8 th.dtr-control, .table.gx-md-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n\n  .table.gs-md-8 th:first-child, .table.gs-md-8 td:first-child {\n    padding-left: 2rem;\n  }\n  .table.gs-md-8 th:last-child, .table.gs-md-8 td:last-child {\n    padding-right: 2rem;\n  }\n  .table.gs-md-8 th.dtr-control:first-child, .table.gs-md-8 td.dtr-control:first-child {\n    padding-left: 2rem !important;\n  }\n\n  .table.g-md-9 th, .table.g-md-9 td {\n    padding: 2.25rem;\n  }\n  .table.g-md-9 th.dtr-control, .table.g-md-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.gy-md-9 th, .table.gy-md-9 td {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n\n  .table.gx-md-9 th, .table.gx-md-9 td {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .table.gx-md-9 th.dtr-control, .table.gx-md-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.gs-md-9 th:first-child, .table.gs-md-9 td:first-child {\n    padding-left: 2.25rem;\n  }\n  .table.gs-md-9 th:last-child, .table.gs-md-9 td:last-child {\n    padding-right: 2.25rem;\n  }\n  .table.gs-md-9 th.dtr-control:first-child, .table.gs-md-9 td.dtr-control:first-child {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.g-md-10 th, .table.g-md-10 td {\n    padding: 2.5rem;\n  }\n  .table.g-md-10 th.dtr-control, .table.g-md-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n\n  .table.gy-md-10 th, .table.gy-md-10 td {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n\n  .table.gx-md-10 th, .table.gx-md-10 td {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .table.gx-md-10 th.dtr-control, .table.gx-md-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n\n  .table.gs-md-10 th:first-child, .table.gs-md-10 td:first-child {\n    padding-left: 2.5rem;\n  }\n  .table.gs-md-10 th:last-child, .table.gs-md-10 td:last-child {\n    padding-right: 2.5rem;\n  }\n  .table.gs-md-10 th.dtr-control:first-child, .table.gs-md-10 td.dtr-control:first-child {\n    padding-left: 2.5rem !important;\n  }\n}\n@media (min-width: 992px) {\n  .table.g-lg-0 th, .table.g-lg-0 td {\n    padding: 0rem;\n  }\n  .table.g-lg-0 th.dtr-control, .table.g-lg-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n\n  .table.gy-lg-0 th, .table.gy-lg-0 td {\n    padding-top: 0rem;\n    padding-bottom: 0rem;\n  }\n\n  .table.gx-lg-0 th, .table.gx-lg-0 td {\n    padding-left: 0rem;\n    padding-right: 0rem;\n  }\n  .table.gx-lg-0 th.dtr-control, .table.gx-lg-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n\n  .table.gs-lg-0 th:first-child, .table.gs-lg-0 td:first-child {\n    padding-left: 0rem;\n  }\n  .table.gs-lg-0 th:last-child, .table.gs-lg-0 td:last-child {\n    padding-right: 0rem;\n  }\n  .table.gs-lg-0 th.dtr-control:first-child, .table.gs-lg-0 td.dtr-control:first-child {\n    padding-left: 0rem !important;\n  }\n\n  .table.g-lg-1 th, .table.g-lg-1 td {\n    padding: 0.25rem;\n  }\n  .table.g-lg-1 th.dtr-control, .table.g-lg-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.gy-lg-1 th, .table.gy-lg-1 td {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n\n  .table.gx-lg-1 th, .table.gx-lg-1 td {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .table.gx-lg-1 th.dtr-control, .table.gx-lg-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.gs-lg-1 th:first-child, .table.gs-lg-1 td:first-child {\n    padding-left: 0.25rem;\n  }\n  .table.gs-lg-1 th:last-child, .table.gs-lg-1 td:last-child {\n    padding-right: 0.25rem;\n  }\n  .table.gs-lg-1 th.dtr-control:first-child, .table.gs-lg-1 td.dtr-control:first-child {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.g-lg-2 th, .table.g-lg-2 td {\n    padding: 0.5rem;\n  }\n  .table.g-lg-2 th.dtr-control, .table.g-lg-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.gy-lg-2 th, .table.gy-lg-2 td {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n\n  .table.gx-lg-2 th, .table.gx-lg-2 td {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .table.gx-lg-2 th.dtr-control, .table.gx-lg-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.gs-lg-2 th:first-child, .table.gs-lg-2 td:first-child {\n    padding-left: 0.5rem;\n  }\n  .table.gs-lg-2 th:last-child, .table.gs-lg-2 td:last-child {\n    padding-right: 0.5rem;\n  }\n  .table.gs-lg-2 th.dtr-control:first-child, .table.gs-lg-2 td.dtr-control:first-child {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.g-lg-3 th, .table.g-lg-3 td {\n    padding: 0.75rem;\n  }\n  .table.g-lg-3 th.dtr-control, .table.g-lg-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.gy-lg-3 th, .table.gy-lg-3 td {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n\n  .table.gx-lg-3 th, .table.gx-lg-3 td {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .table.gx-lg-3 th.dtr-control, .table.gx-lg-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.gs-lg-3 th:first-child, .table.gs-lg-3 td:first-child {\n    padding-left: 0.75rem;\n  }\n  .table.gs-lg-3 th:last-child, .table.gs-lg-3 td:last-child {\n    padding-right: 0.75rem;\n  }\n  .table.gs-lg-3 th.dtr-control:first-child, .table.gs-lg-3 td.dtr-control:first-child {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.g-lg-4 th, .table.g-lg-4 td {\n    padding: 1rem;\n  }\n  .table.g-lg-4 th.dtr-control, .table.g-lg-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n\n  .table.gy-lg-4 th, .table.gy-lg-4 td {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n\n  .table.gx-lg-4 th, .table.gx-lg-4 td {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .table.gx-lg-4 th.dtr-control, .table.gx-lg-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n\n  .table.gs-lg-4 th:first-child, .table.gs-lg-4 td:first-child {\n    padding-left: 1rem;\n  }\n  .table.gs-lg-4 th:last-child, .table.gs-lg-4 td:last-child {\n    padding-right: 1rem;\n  }\n  .table.gs-lg-4 th.dtr-control:first-child, .table.gs-lg-4 td.dtr-control:first-child {\n    padding-left: 1rem !important;\n  }\n\n  .table.g-lg-5 th, .table.g-lg-5 td {\n    padding: 1.25rem;\n  }\n  .table.g-lg-5 th.dtr-control, .table.g-lg-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.gy-lg-5 th, .table.gy-lg-5 td {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n\n  .table.gx-lg-5 th, .table.gx-lg-5 td {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .table.gx-lg-5 th.dtr-control, .table.gx-lg-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.gs-lg-5 th:first-child, .table.gs-lg-5 td:first-child {\n    padding-left: 1.25rem;\n  }\n  .table.gs-lg-5 th:last-child, .table.gs-lg-5 td:last-child {\n    padding-right: 1.25rem;\n  }\n  .table.gs-lg-5 th.dtr-control:first-child, .table.gs-lg-5 td.dtr-control:first-child {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.g-lg-6 th, .table.g-lg-6 td {\n    padding: 1.5rem;\n  }\n  .table.g-lg-6 th.dtr-control, .table.g-lg-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.gy-lg-6 th, .table.gy-lg-6 td {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n\n  .table.gx-lg-6 th, .table.gx-lg-6 td {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .table.gx-lg-6 th.dtr-control, .table.gx-lg-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.gs-lg-6 th:first-child, .table.gs-lg-6 td:first-child {\n    padding-left: 1.5rem;\n  }\n  .table.gs-lg-6 th:last-child, .table.gs-lg-6 td:last-child {\n    padding-right: 1.5rem;\n  }\n  .table.gs-lg-6 th.dtr-control:first-child, .table.gs-lg-6 td.dtr-control:first-child {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.g-lg-7 th, .table.g-lg-7 td {\n    padding: 1.75rem;\n  }\n  .table.g-lg-7 th.dtr-control, .table.g-lg-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.gy-lg-7 th, .table.gy-lg-7 td {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n\n  .table.gx-lg-7 th, .table.gx-lg-7 td {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .table.gx-lg-7 th.dtr-control, .table.gx-lg-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.gs-lg-7 th:first-child, .table.gs-lg-7 td:first-child {\n    padding-left: 1.75rem;\n  }\n  .table.gs-lg-7 th:last-child, .table.gs-lg-7 td:last-child {\n    padding-right: 1.75rem;\n  }\n  .table.gs-lg-7 th.dtr-control:first-child, .table.gs-lg-7 td.dtr-control:first-child {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.g-lg-8 th, .table.g-lg-8 td {\n    padding: 2rem;\n  }\n  .table.g-lg-8 th.dtr-control, .table.g-lg-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n\n  .table.gy-lg-8 th, .table.gy-lg-8 td {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n\n  .table.gx-lg-8 th, .table.gx-lg-8 td {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .table.gx-lg-8 th.dtr-control, .table.gx-lg-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n\n  .table.gs-lg-8 th:first-child, .table.gs-lg-8 td:first-child {\n    padding-left: 2rem;\n  }\n  .table.gs-lg-8 th:last-child, .table.gs-lg-8 td:last-child {\n    padding-right: 2rem;\n  }\n  .table.gs-lg-8 th.dtr-control:first-child, .table.gs-lg-8 td.dtr-control:first-child {\n    padding-left: 2rem !important;\n  }\n\n  .table.g-lg-9 th, .table.g-lg-9 td {\n    padding: 2.25rem;\n  }\n  .table.g-lg-9 th.dtr-control, .table.g-lg-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.gy-lg-9 th, .table.gy-lg-9 td {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n\n  .table.gx-lg-9 th, .table.gx-lg-9 td {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .table.gx-lg-9 th.dtr-control, .table.gx-lg-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.gs-lg-9 th:first-child, .table.gs-lg-9 td:first-child {\n    padding-left: 2.25rem;\n  }\n  .table.gs-lg-9 th:last-child, .table.gs-lg-9 td:last-child {\n    padding-right: 2.25rem;\n  }\n  .table.gs-lg-9 th.dtr-control:first-child, .table.gs-lg-9 td.dtr-control:first-child {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.g-lg-10 th, .table.g-lg-10 td {\n    padding: 2.5rem;\n  }\n  .table.g-lg-10 th.dtr-control, .table.g-lg-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n\n  .table.gy-lg-10 th, .table.gy-lg-10 td {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n\n  .table.gx-lg-10 th, .table.gx-lg-10 td {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .table.gx-lg-10 th.dtr-control, .table.gx-lg-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n\n  .table.gs-lg-10 th:first-child, .table.gs-lg-10 td:first-child {\n    padding-left: 2.5rem;\n  }\n  .table.gs-lg-10 th:last-child, .table.gs-lg-10 td:last-child {\n    padding-right: 2.5rem;\n  }\n  .table.gs-lg-10 th.dtr-control:first-child, .table.gs-lg-10 td.dtr-control:first-child {\n    padding-left: 2.5rem !important;\n  }\n}\n@media (min-width: 1200px) {\n  .table.g-xl-0 th, .table.g-xl-0 td {\n    padding: 0rem;\n  }\n  .table.g-xl-0 th.dtr-control, .table.g-xl-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n\n  .table.gy-xl-0 th, .table.gy-xl-0 td {\n    padding-top: 0rem;\n    padding-bottom: 0rem;\n  }\n\n  .table.gx-xl-0 th, .table.gx-xl-0 td {\n    padding-left: 0rem;\n    padding-right: 0rem;\n  }\n  .table.gx-xl-0 th.dtr-control, .table.gx-xl-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n\n  .table.gs-xl-0 th:first-child, .table.gs-xl-0 td:first-child {\n    padding-left: 0rem;\n  }\n  .table.gs-xl-0 th:last-child, .table.gs-xl-0 td:last-child {\n    padding-right: 0rem;\n  }\n  .table.gs-xl-0 th.dtr-control:first-child, .table.gs-xl-0 td.dtr-control:first-child {\n    padding-left: 0rem !important;\n  }\n\n  .table.g-xl-1 th, .table.g-xl-1 td {\n    padding: 0.25rem;\n  }\n  .table.g-xl-1 th.dtr-control, .table.g-xl-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.gy-xl-1 th, .table.gy-xl-1 td {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n\n  .table.gx-xl-1 th, .table.gx-xl-1 td {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .table.gx-xl-1 th.dtr-control, .table.gx-xl-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.gs-xl-1 th:first-child, .table.gs-xl-1 td:first-child {\n    padding-left: 0.25rem;\n  }\n  .table.gs-xl-1 th:last-child, .table.gs-xl-1 td:last-child {\n    padding-right: 0.25rem;\n  }\n  .table.gs-xl-1 th.dtr-control:first-child, .table.gs-xl-1 td.dtr-control:first-child {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.g-xl-2 th, .table.g-xl-2 td {\n    padding: 0.5rem;\n  }\n  .table.g-xl-2 th.dtr-control, .table.g-xl-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.gy-xl-2 th, .table.gy-xl-2 td {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n\n  .table.gx-xl-2 th, .table.gx-xl-2 td {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .table.gx-xl-2 th.dtr-control, .table.gx-xl-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.gs-xl-2 th:first-child, .table.gs-xl-2 td:first-child {\n    padding-left: 0.5rem;\n  }\n  .table.gs-xl-2 th:last-child, .table.gs-xl-2 td:last-child {\n    padding-right: 0.5rem;\n  }\n  .table.gs-xl-2 th.dtr-control:first-child, .table.gs-xl-2 td.dtr-control:first-child {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.g-xl-3 th, .table.g-xl-3 td {\n    padding: 0.75rem;\n  }\n  .table.g-xl-3 th.dtr-control, .table.g-xl-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.gy-xl-3 th, .table.gy-xl-3 td {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n\n  .table.gx-xl-3 th, .table.gx-xl-3 td {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .table.gx-xl-3 th.dtr-control, .table.gx-xl-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.gs-xl-3 th:first-child, .table.gs-xl-3 td:first-child {\n    padding-left: 0.75rem;\n  }\n  .table.gs-xl-3 th:last-child, .table.gs-xl-3 td:last-child {\n    padding-right: 0.75rem;\n  }\n  .table.gs-xl-3 th.dtr-control:first-child, .table.gs-xl-3 td.dtr-control:first-child {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.g-xl-4 th, .table.g-xl-4 td {\n    padding: 1rem;\n  }\n  .table.g-xl-4 th.dtr-control, .table.g-xl-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n\n  .table.gy-xl-4 th, .table.gy-xl-4 td {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n\n  .table.gx-xl-4 th, .table.gx-xl-4 td {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .table.gx-xl-4 th.dtr-control, .table.gx-xl-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n\n  .table.gs-xl-4 th:first-child, .table.gs-xl-4 td:first-child {\n    padding-left: 1rem;\n  }\n  .table.gs-xl-4 th:last-child, .table.gs-xl-4 td:last-child {\n    padding-right: 1rem;\n  }\n  .table.gs-xl-4 th.dtr-control:first-child, .table.gs-xl-4 td.dtr-control:first-child {\n    padding-left: 1rem !important;\n  }\n\n  .table.g-xl-5 th, .table.g-xl-5 td {\n    padding: 1.25rem;\n  }\n  .table.g-xl-5 th.dtr-control, .table.g-xl-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.gy-xl-5 th, .table.gy-xl-5 td {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n\n  .table.gx-xl-5 th, .table.gx-xl-5 td {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .table.gx-xl-5 th.dtr-control, .table.gx-xl-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.gs-xl-5 th:first-child, .table.gs-xl-5 td:first-child {\n    padding-left: 1.25rem;\n  }\n  .table.gs-xl-5 th:last-child, .table.gs-xl-5 td:last-child {\n    padding-right: 1.25rem;\n  }\n  .table.gs-xl-5 th.dtr-control:first-child, .table.gs-xl-5 td.dtr-control:first-child {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.g-xl-6 th, .table.g-xl-6 td {\n    padding: 1.5rem;\n  }\n  .table.g-xl-6 th.dtr-control, .table.g-xl-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.gy-xl-6 th, .table.gy-xl-6 td {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n\n  .table.gx-xl-6 th, .table.gx-xl-6 td {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .table.gx-xl-6 th.dtr-control, .table.gx-xl-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.gs-xl-6 th:first-child, .table.gs-xl-6 td:first-child {\n    padding-left: 1.5rem;\n  }\n  .table.gs-xl-6 th:last-child, .table.gs-xl-6 td:last-child {\n    padding-right: 1.5rem;\n  }\n  .table.gs-xl-6 th.dtr-control:first-child, .table.gs-xl-6 td.dtr-control:first-child {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.g-xl-7 th, .table.g-xl-7 td {\n    padding: 1.75rem;\n  }\n  .table.g-xl-7 th.dtr-control, .table.g-xl-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.gy-xl-7 th, .table.gy-xl-7 td {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n\n  .table.gx-xl-7 th, .table.gx-xl-7 td {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .table.gx-xl-7 th.dtr-control, .table.gx-xl-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.gs-xl-7 th:first-child, .table.gs-xl-7 td:first-child {\n    padding-left: 1.75rem;\n  }\n  .table.gs-xl-7 th:last-child, .table.gs-xl-7 td:last-child {\n    padding-right: 1.75rem;\n  }\n  .table.gs-xl-7 th.dtr-control:first-child, .table.gs-xl-7 td.dtr-control:first-child {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.g-xl-8 th, .table.g-xl-8 td {\n    padding: 2rem;\n  }\n  .table.g-xl-8 th.dtr-control, .table.g-xl-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n\n  .table.gy-xl-8 th, .table.gy-xl-8 td {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n\n  .table.gx-xl-8 th, .table.gx-xl-8 td {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .table.gx-xl-8 th.dtr-control, .table.gx-xl-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n\n  .table.gs-xl-8 th:first-child, .table.gs-xl-8 td:first-child {\n    padding-left: 2rem;\n  }\n  .table.gs-xl-8 th:last-child, .table.gs-xl-8 td:last-child {\n    padding-right: 2rem;\n  }\n  .table.gs-xl-8 th.dtr-control:first-child, .table.gs-xl-8 td.dtr-control:first-child {\n    padding-left: 2rem !important;\n  }\n\n  .table.g-xl-9 th, .table.g-xl-9 td {\n    padding: 2.25rem;\n  }\n  .table.g-xl-9 th.dtr-control, .table.g-xl-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.gy-xl-9 th, .table.gy-xl-9 td {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n\n  .table.gx-xl-9 th, .table.gx-xl-9 td {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .table.gx-xl-9 th.dtr-control, .table.gx-xl-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.gs-xl-9 th:first-child, .table.gs-xl-9 td:first-child {\n    padding-left: 2.25rem;\n  }\n  .table.gs-xl-9 th:last-child, .table.gs-xl-9 td:last-child {\n    padding-right: 2.25rem;\n  }\n  .table.gs-xl-9 th.dtr-control:first-child, .table.gs-xl-9 td.dtr-control:first-child {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.g-xl-10 th, .table.g-xl-10 td {\n    padding: 2.5rem;\n  }\n  .table.g-xl-10 th.dtr-control, .table.g-xl-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n\n  .table.gy-xl-10 th, .table.gy-xl-10 td {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n\n  .table.gx-xl-10 th, .table.gx-xl-10 td {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .table.gx-xl-10 th.dtr-control, .table.gx-xl-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n\n  .table.gs-xl-10 th:first-child, .table.gs-xl-10 td:first-child {\n    padding-left: 2.5rem;\n  }\n  .table.gs-xl-10 th:last-child, .table.gs-xl-10 td:last-child {\n    padding-right: 2.5rem;\n  }\n  .table.gs-xl-10 th.dtr-control:first-child, .table.gs-xl-10 td.dtr-control:first-child {\n    padding-left: 2.5rem !important;\n  }\n}\n@media (min-width: 1400px) {\n  .table.g-xxl-0 th, .table.g-xxl-0 td {\n    padding: 0rem;\n  }\n  .table.g-xxl-0 th.dtr-control, .table.g-xxl-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n\n  .table.gy-xxl-0 th, .table.gy-xxl-0 td {\n    padding-top: 0rem;\n    padding-bottom: 0rem;\n  }\n\n  .table.gx-xxl-0 th, .table.gx-xxl-0 td {\n    padding-left: 0rem;\n    padding-right: 0rem;\n  }\n  .table.gx-xxl-0 th.dtr-control, .table.gx-xxl-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n\n  .table.gs-xxl-0 th:first-child, .table.gs-xxl-0 td:first-child {\n    padding-left: 0rem;\n  }\n  .table.gs-xxl-0 th:last-child, .table.gs-xxl-0 td:last-child {\n    padding-right: 0rem;\n  }\n  .table.gs-xxl-0 th.dtr-control:first-child, .table.gs-xxl-0 td.dtr-control:first-child {\n    padding-left: 0rem !important;\n  }\n\n  .table.g-xxl-1 th, .table.g-xxl-1 td {\n    padding: 0.25rem;\n  }\n  .table.g-xxl-1 th.dtr-control, .table.g-xxl-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.gy-xxl-1 th, .table.gy-xxl-1 td {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n\n  .table.gx-xxl-1 th, .table.gx-xxl-1 td {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .table.gx-xxl-1 th.dtr-control, .table.gx-xxl-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.gs-xxl-1 th:first-child, .table.gs-xxl-1 td:first-child {\n    padding-left: 0.25rem;\n  }\n  .table.gs-xxl-1 th:last-child, .table.gs-xxl-1 td:last-child {\n    padding-right: 0.25rem;\n  }\n  .table.gs-xxl-1 th.dtr-control:first-child, .table.gs-xxl-1 td.dtr-control:first-child {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.g-xxl-2 th, .table.g-xxl-2 td {\n    padding: 0.5rem;\n  }\n  .table.g-xxl-2 th.dtr-control, .table.g-xxl-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.gy-xxl-2 th, .table.gy-xxl-2 td {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n\n  .table.gx-xxl-2 th, .table.gx-xxl-2 td {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .table.gx-xxl-2 th.dtr-control, .table.gx-xxl-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.gs-xxl-2 th:first-child, .table.gs-xxl-2 td:first-child {\n    padding-left: 0.5rem;\n  }\n  .table.gs-xxl-2 th:last-child, .table.gs-xxl-2 td:last-child {\n    padding-right: 0.5rem;\n  }\n  .table.gs-xxl-2 th.dtr-control:first-child, .table.gs-xxl-2 td.dtr-control:first-child {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.g-xxl-3 th, .table.g-xxl-3 td {\n    padding: 0.75rem;\n  }\n  .table.g-xxl-3 th.dtr-control, .table.g-xxl-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.gy-xxl-3 th, .table.gy-xxl-3 td {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n\n  .table.gx-xxl-3 th, .table.gx-xxl-3 td {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .table.gx-xxl-3 th.dtr-control, .table.gx-xxl-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.gs-xxl-3 th:first-child, .table.gs-xxl-3 td:first-child {\n    padding-left: 0.75rem;\n  }\n  .table.gs-xxl-3 th:last-child, .table.gs-xxl-3 td:last-child {\n    padding-right: 0.75rem;\n  }\n  .table.gs-xxl-3 th.dtr-control:first-child, .table.gs-xxl-3 td.dtr-control:first-child {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.g-xxl-4 th, .table.g-xxl-4 td {\n    padding: 1rem;\n  }\n  .table.g-xxl-4 th.dtr-control, .table.g-xxl-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n\n  .table.gy-xxl-4 th, .table.gy-xxl-4 td {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n\n  .table.gx-xxl-4 th, .table.gx-xxl-4 td {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .table.gx-xxl-4 th.dtr-control, .table.gx-xxl-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n\n  .table.gs-xxl-4 th:first-child, .table.gs-xxl-4 td:first-child {\n    padding-left: 1rem;\n  }\n  .table.gs-xxl-4 th:last-child, .table.gs-xxl-4 td:last-child {\n    padding-right: 1rem;\n  }\n  .table.gs-xxl-4 th.dtr-control:first-child, .table.gs-xxl-4 td.dtr-control:first-child {\n    padding-left: 1rem !important;\n  }\n\n  .table.g-xxl-5 th, .table.g-xxl-5 td {\n    padding: 1.25rem;\n  }\n  .table.g-xxl-5 th.dtr-control, .table.g-xxl-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.gy-xxl-5 th, .table.gy-xxl-5 td {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n\n  .table.gx-xxl-5 th, .table.gx-xxl-5 td {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .table.gx-xxl-5 th.dtr-control, .table.gx-xxl-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.gs-xxl-5 th:first-child, .table.gs-xxl-5 td:first-child {\n    padding-left: 1.25rem;\n  }\n  .table.gs-xxl-5 th:last-child, .table.gs-xxl-5 td:last-child {\n    padding-right: 1.25rem;\n  }\n  .table.gs-xxl-5 th.dtr-control:first-child, .table.gs-xxl-5 td.dtr-control:first-child {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.g-xxl-6 th, .table.g-xxl-6 td {\n    padding: 1.5rem;\n  }\n  .table.g-xxl-6 th.dtr-control, .table.g-xxl-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.gy-xxl-6 th, .table.gy-xxl-6 td {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n\n  .table.gx-xxl-6 th, .table.gx-xxl-6 td {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .table.gx-xxl-6 th.dtr-control, .table.gx-xxl-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.gs-xxl-6 th:first-child, .table.gs-xxl-6 td:first-child {\n    padding-left: 1.5rem;\n  }\n  .table.gs-xxl-6 th:last-child, .table.gs-xxl-6 td:last-child {\n    padding-right: 1.5rem;\n  }\n  .table.gs-xxl-6 th.dtr-control:first-child, .table.gs-xxl-6 td.dtr-control:first-child {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.g-xxl-7 th, .table.g-xxl-7 td {\n    padding: 1.75rem;\n  }\n  .table.g-xxl-7 th.dtr-control, .table.g-xxl-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.gy-xxl-7 th, .table.gy-xxl-7 td {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n\n  .table.gx-xxl-7 th, .table.gx-xxl-7 td {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .table.gx-xxl-7 th.dtr-control, .table.gx-xxl-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.gs-xxl-7 th:first-child, .table.gs-xxl-7 td:first-child {\n    padding-left: 1.75rem;\n  }\n  .table.gs-xxl-7 th:last-child, .table.gs-xxl-7 td:last-child {\n    padding-right: 1.75rem;\n  }\n  .table.gs-xxl-7 th.dtr-control:first-child, .table.gs-xxl-7 td.dtr-control:first-child {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.g-xxl-8 th, .table.g-xxl-8 td {\n    padding: 2rem;\n  }\n  .table.g-xxl-8 th.dtr-control, .table.g-xxl-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n\n  .table.gy-xxl-8 th, .table.gy-xxl-8 td {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n\n  .table.gx-xxl-8 th, .table.gx-xxl-8 td {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .table.gx-xxl-8 th.dtr-control, .table.gx-xxl-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n\n  .table.gs-xxl-8 th:first-child, .table.gs-xxl-8 td:first-child {\n    padding-left: 2rem;\n  }\n  .table.gs-xxl-8 th:last-child, .table.gs-xxl-8 td:last-child {\n    padding-right: 2rem;\n  }\n  .table.gs-xxl-8 th.dtr-control:first-child, .table.gs-xxl-8 td.dtr-control:first-child {\n    padding-left: 2rem !important;\n  }\n\n  .table.g-xxl-9 th, .table.g-xxl-9 td {\n    padding: 2.25rem;\n  }\n  .table.g-xxl-9 th.dtr-control, .table.g-xxl-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.gy-xxl-9 th, .table.gy-xxl-9 td {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n\n  .table.gx-xxl-9 th, .table.gx-xxl-9 td {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .table.gx-xxl-9 th.dtr-control, .table.gx-xxl-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.gs-xxl-9 th:first-child, .table.gs-xxl-9 td:first-child {\n    padding-left: 2.25rem;\n  }\n  .table.gs-xxl-9 th:last-child, .table.gs-xxl-9 td:last-child {\n    padding-right: 2.25rem;\n  }\n  .table.gs-xxl-9 th.dtr-control:first-child, .table.gs-xxl-9 td.dtr-control:first-child {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.g-xxl-10 th, .table.g-xxl-10 td {\n    padding: 2.5rem;\n  }\n  .table.g-xxl-10 th.dtr-control, .table.g-xxl-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n\n  .table.gy-xxl-10 th, .table.gy-xxl-10 td {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n\n  .table.gx-xxl-10 th, .table.gx-xxl-10 td {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .table.gx-xxl-10 th.dtr-control, .table.gx-xxl-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n\n  .table.gs-xxl-10 th:first-child, .table.gs-xxl-10 td:first-child {\n    padding-left: 2.5rem;\n  }\n  .table.gs-xxl-10 th:last-child, .table.gs-xxl-10 td:last-child {\n    padding-right: 2.5rem;\n  }\n  .table.gs-xxl-10 th.dtr-control:first-child, .table.gs-xxl-10 td.dtr-control:first-child {\n    padding-left: 2.5rem !important;\n  }\n}\n.popover .popover-header {\n  font-size: 1rem;\n  font-weight: 500;\n  border-bottom: 1px solid #F5F8FA;\n}\n.popover .popover-dismiss {\n  position: absolute;\n  top: 0.85rem;\n  right: 0.85rem;\n  height: 1.5rem;\n  width: 1.5rem;\n}\n.popover .popover-dismiss i {\n  color: #A1A5B7;\n}\n.popover .popover-dismiss:hover i {\n  color: #009EF7;\n}\n.popover .popover-dismiss + .popover-header {\n  padding-right: 2.75rem;\n}\n\n.popover-dark {\n  background-color: #181C32;\n  border: 0;\n}\n.popover-dark .popover-header {\n  background-color: #181C32;\n  color: #EFF2F5;\n  border-bottom-color: #3F4254;\n}\n.popover-dark .popover-body {\n  color: #B5B5C3;\n}\n.popover-dark.bs-popover-top > .popover-arrow::before, .popover-dark.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {\n  border-top-color: #F5F8FA;\n}\n.popover-dark.bs-popover-top > .popover-arrow::after, .popover-dark.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  border-top-color: #181C32;\n}\n.popover-dark.bs-popover-end > .popover-arrow::before, .popover-dark.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {\n  border-right-color: #F5F8FA;\n}\n.popover-dark.bs-popover-end > .popover-arrow::after, .popover-dark.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  border-right-color: #181C32;\n}\n.popover-dark.bs-popover-bottom > .popover-arrow::before, .popover-dark.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {\n  border-bottom-color: #F5F8FA;\n}\n.popover-dark.bs-popover-bottom > .popover-arrow::after, .popover-dark.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  border-bottom-color: #181C32;\n}\n.popover-dark.bs-popover-bottom .popover-header::before, .popover-dark.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n  border-bottom-color: #181C32;\n}\n.popover-dark.bs-popover-start > .popover-arrow::before, .popover-dark.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {\n  border-left-color: #F5F8FA;\n}\n.popover-dark.bs-popover-start > .popover-arrow::after, .popover-dark.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  border-left-color: #181C32;\n}\n\n.tooltip .tooltip-inner {\n  box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n}\n.tooltip.tooltop-auto-width .tooltip-inner {\n  white-space: nowrap;\n  max-width: none;\n}\n.tooltip.tooltip-dark .tooltip-inner {\n  color: #ffffff;\n  background-color: #181C32;\n}\n.tooltip.tooltip-dark.bs-tooltip-top .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n  border-top-color: #181C32;\n}\n.tooltip.tooltip-dark.bs-tooltip-end .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n  border-right-color: #181C32;\n}\n.tooltip.tooltip-dark.bs-tooltip-bottom .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n  border-bottom-color: #181C32;\n}\n.tooltip.tooltip-dark.bs-tooltip-start .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n  border-left-color: #181C32;\n}\n\n.accordion .accordion-header {\n  cursor: pointer;\n}\n.accordion.accordion-icon-toggle .accordion-icon {\n  display: flex;\n  flex-shrink: 0;\n  transition: all 0.2s ease;\n  transform: rotate(90deg);\n  align-items: center;\n  justify-content: center;\n}\n.accordion.accordion-icon-toggle .accordion-icon i {\n  color: #009EF7;\n}\n.accordion.accordion-icon-toggle .accordion-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.accordion.accordion-icon-toggle .accordion-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.accordion.accordion-icon-toggle .collapsed .accordion-icon {\n  transition: all 0.2s ease;\n  transform: rotate(0);\n}\n.accordion.accordion-icon-toggle .collapsed .accordion-icon i {\n  color: #A1A5B7;\n}\n.accordion.accordion-icon-toggle .collapsed .accordion-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #A1A5B7;\n}\n.accordion.accordion-icon-toggle .collapsed .accordion-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.accordion.accordion-borderless .accordion-item {\n  border: 0;\n}\n.accordion.accordion-flush .accordion-item {\n  background-color: transparent;\n  border: 0;\n  border-radius: none;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.feedback {\n  display: none;\n}\n\n.feedback-popup {\n  display: flex;\n  justify-content: center;\n  margin: 0 auto;\n  position: fixed;\n  z-index: 1000;\n  box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  background-color: #ffffff;\n  border-radius: 0.475rem;\n  padding: 1rem 1.25rem;\n}\n\n.feedback-top-center {\n  display: flex;\n  transition: top 0.6s ease;\n  left: 50%;\n  transform: translateX(-50%);\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.feedback-top-center.feedback-shown {\n  top: 0px;\n  transition: top 0.6s ease;\n}\n\n.image-input {\n  position: relative;\n  display: inline-block;\n  border-radius: 0.475rem;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.image-input:not(.image-input-empty) {\n  background-image: none !important;\n}\n.image-input .image-input-wrapper {\n  width: 120px;\n  height: 120px;\n  border-radius: 0.475rem;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.image-input [data-kt-image-input-action] {\n  cursor: pointer;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n.image-input [data-kt-image-input-action=change] {\n  left: 100%;\n  top: 0;\n}\n.image-input [data-kt-image-input-action=change] input {\n  width: 0 !important;\n  height: 0 !important;\n  overflow: hidden;\n  opacity: 0;\n}\n.image-input [data-kt-image-input-action=cancel],\n.image-input [data-kt-image-input-action=remove] {\n  position: absolute;\n  left: 100%;\n  top: 100%;\n}\n.image-input [data-kt-image-input-action=cancel] {\n  display: none;\n}\n.image-input.image-input-changed [data-kt-image-input-action=cancel] {\n  display: flex;\n}\n.image-input.image-input-changed [data-kt-image-input-action=remove] {\n  display: none;\n}\n.image-input.image-input-empty [data-kt-image-input-action=remove],\n.image-input.image-input-empty [data-kt-image-input-action=cancel] {\n  display: none;\n}\n.image-input.image-input-circle {\n  border-radius: 50%;\n}\n.image-input.image-input-circle .image-input-wrapper {\n  border-radius: 50%;\n}\n.image-input.image-input-circle [data-kt-image-input-action=change] {\n  left: 100%;\n  top: 0;\n  transform: translate(-100%, 0%);\n}\n.image-input.image-input-circle [data-kt-image-input-action=cancel],\n.image-input.image-input-circle [data-kt-image-input-action=remove] {\n  left: 100%;\n  top: 100%;\n  transform: translate(-100%, -100%);\n}\n.image-input.image-input-outline .image-input-wrapper {\n  border: 3px solid #ffffff;\n  box-shadow: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);\n}\n\n.symbol {\n  display: inline-block;\n  flex-shrink: 0;\n  position: relative;\n  border-radius: 0.475rem;\n}\n.symbol .symbol-label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 500;\n  color: #3F4254;\n  background-color: #F5F8FA;\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n  border-radius: 0.475rem;\n}\n.symbol .symbol-badge {\n  position: absolute;\n  border: 2px solid #ffffff;\n  border-radius: 100%;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%) !important;\n}\n.symbol > img {\n  width: 100%;\n  flex-shrink: 0;\n  display: inline-block;\n  border-radius: 0.475rem;\n}\n.symbol.symbol-square,\n.symbol.symbol-square > img,\n.symbol.symbol-square .symbol-label {\n  border-radius: 0 !important;\n}\n.symbol.symbol-circle,\n.symbol.symbol-circle > img,\n.symbol.symbol-circle .symbol-label {\n  border-radius: 50%;\n}\n.symbol > img {\n  width: 50px;\n  height: 50px;\n}\n.symbol .symbol-label {\n  width: 50px;\n  height: 50px;\n}\n.symbol.symbol-fixed .symbol-label {\n  width: 50px;\n  height: 50px;\n}\n.symbol.symbol-fixed > img {\n  width: 50px;\n  height: 50px;\n  max-width: auto;\n}\n.symbol.symbol-2by3 .symbol-label {\n  height: 50px;\n  width: 75px;\n}\n.symbol.symbol-2by3 > img {\n  height: 50px;\n  width: 75px;\n  max-width: auto;\n}\n.symbol.symbol-20px > img {\n  width: 20px;\n  height: 20px;\n}\n.symbol.symbol-20px .symbol-label {\n  width: 20px;\n  height: 20px;\n}\n.symbol.symbol-20px.symbol-fixed .symbol-label {\n  width: 20px;\n  height: 20px;\n}\n.symbol.symbol-20px.symbol-fixed > img {\n  width: 20px;\n  height: 20px;\n  max-width: auto;\n}\n.symbol.symbol-20px.symbol-2by3 .symbol-label {\n  height: 20px;\n  width: 30px;\n}\n.symbol.symbol-20px.symbol-2by3 > img {\n  height: 20px;\n  width: 30px;\n  max-width: auto;\n}\n.symbol.symbol-25px > img {\n  width: 25px;\n  height: 25px;\n}\n.symbol.symbol-25px .symbol-label {\n  width: 25px;\n  height: 25px;\n}\n.symbol.symbol-25px.symbol-fixed .symbol-label {\n  width: 25px;\n  height: 25px;\n}\n.symbol.symbol-25px.symbol-fixed > img {\n  width: 25px;\n  height: 25px;\n  max-width: auto;\n}\n.symbol.symbol-25px.symbol-2by3 .symbol-label {\n  height: 25px;\n  width: 37.5px;\n}\n.symbol.symbol-25px.symbol-2by3 > img {\n  height: 25px;\n  width: 37.5px;\n  max-width: auto;\n}\n.symbol.symbol-30px > img {\n  width: 30px;\n  height: 30px;\n}\n.symbol.symbol-30px .symbol-label {\n  width: 30px;\n  height: 30px;\n}\n.symbol.symbol-30px.symbol-fixed .symbol-label {\n  width: 30px;\n  height: 30px;\n}\n.symbol.symbol-30px.symbol-fixed > img {\n  width: 30px;\n  height: 30px;\n  max-width: auto;\n}\n.symbol.symbol-30px.symbol-2by3 .symbol-label {\n  height: 30px;\n  width: 45px;\n}\n.symbol.symbol-30px.symbol-2by3 > img {\n  height: 30px;\n  width: 45px;\n  max-width: auto;\n}\n.symbol.symbol-35px > img {\n  width: 35px;\n  height: 35px;\n}\n.symbol.symbol-35px .symbol-label {\n  width: 35px;\n  height: 35px;\n}\n.symbol.symbol-35px.symbol-fixed .symbol-label {\n  width: 35px;\n  height: 35px;\n}\n.symbol.symbol-35px.symbol-fixed > img {\n  width: 35px;\n  height: 35px;\n  max-width: auto;\n}\n.symbol.symbol-35px.symbol-2by3 .symbol-label {\n  height: 35px;\n  width: 52.5px;\n}\n.symbol.symbol-35px.symbol-2by3 > img {\n  height: 35px;\n  width: 52.5px;\n  max-width: auto;\n}\n.symbol.symbol-40px > img {\n  width: 40px;\n  height: 40px;\n}\n.symbol.symbol-40px .symbol-label {\n  width: 40px;\n  height: 40px;\n}\n.symbol.symbol-40px.symbol-fixed .symbol-label {\n  width: 40px;\n  height: 40px;\n}\n.symbol.symbol-40px.symbol-fixed > img {\n  width: 40px;\n  height: 40px;\n  max-width: auto;\n}\n.symbol.symbol-40px.symbol-2by3 .symbol-label {\n  height: 40px;\n  width: 60px;\n}\n.symbol.symbol-40px.symbol-2by3 > img {\n  height: 40px;\n  width: 60px;\n  max-width: auto;\n}\n.symbol.symbol-45px > img {\n  width: 45px;\n  height: 45px;\n}\n.symbol.symbol-45px .symbol-label {\n  width: 45px;\n  height: 45px;\n}\n.symbol.symbol-45px.symbol-fixed .symbol-label {\n  width: 45px;\n  height: 45px;\n}\n.symbol.symbol-45px.symbol-fixed > img {\n  width: 45px;\n  height: 45px;\n  max-width: auto;\n}\n.symbol.symbol-45px.symbol-2by3 .symbol-label {\n  height: 45px;\n  width: 67.5px;\n}\n.symbol.symbol-45px.symbol-2by3 > img {\n  height: 45px;\n  width: 67.5px;\n  max-width: auto;\n}\n.symbol.symbol-50px > img {\n  width: 50px;\n  height: 50px;\n}\n.symbol.symbol-50px .symbol-label {\n  width: 50px;\n  height: 50px;\n}\n.symbol.symbol-50px.symbol-fixed .symbol-label {\n  width: 50px;\n  height: 50px;\n}\n.symbol.symbol-50px.symbol-fixed > img {\n  width: 50px;\n  height: 50px;\n  max-width: auto;\n}\n.symbol.symbol-50px.symbol-2by3 .symbol-label {\n  height: 50px;\n  width: 75px;\n}\n.symbol.symbol-50px.symbol-2by3 > img {\n  height: 50px;\n  width: 75px;\n  max-width: auto;\n}\n.symbol.symbol-55px > img {\n  width: 55px;\n  height: 55px;\n}\n.symbol.symbol-55px .symbol-label {\n  width: 55px;\n  height: 55px;\n}\n.symbol.symbol-55px.symbol-fixed .symbol-label {\n  width: 55px;\n  height: 55px;\n}\n.symbol.symbol-55px.symbol-fixed > img {\n  width: 55px;\n  height: 55px;\n  max-width: auto;\n}\n.symbol.symbol-55px.symbol-2by3 .symbol-label {\n  height: 55px;\n  width: 82.5px;\n}\n.symbol.symbol-55px.symbol-2by3 > img {\n  height: 55px;\n  width: 82.5px;\n  max-width: auto;\n}\n.symbol.symbol-60px > img {\n  width: 60px;\n  height: 60px;\n}\n.symbol.symbol-60px .symbol-label {\n  width: 60px;\n  height: 60px;\n}\n.symbol.symbol-60px.symbol-fixed .symbol-label {\n  width: 60px;\n  height: 60px;\n}\n.symbol.symbol-60px.symbol-fixed > img {\n  width: 60px;\n  height: 60px;\n  max-width: auto;\n}\n.symbol.symbol-60px.symbol-2by3 .symbol-label {\n  height: 60px;\n  width: 90px;\n}\n.symbol.symbol-60px.symbol-2by3 > img {\n  height: 60px;\n  width: 90px;\n  max-width: auto;\n}\n.symbol.symbol-65px > img {\n  width: 65px;\n  height: 65px;\n}\n.symbol.symbol-65px .symbol-label {\n  width: 65px;\n  height: 65px;\n}\n.symbol.symbol-65px.symbol-fixed .symbol-label {\n  width: 65px;\n  height: 65px;\n}\n.symbol.symbol-65px.symbol-fixed > img {\n  width: 65px;\n  height: 65px;\n  max-width: auto;\n}\n.symbol.symbol-65px.symbol-2by3 .symbol-label {\n  height: 65px;\n  width: 97.5px;\n}\n.symbol.symbol-65px.symbol-2by3 > img {\n  height: 65px;\n  width: 97.5px;\n  max-width: auto;\n}\n.symbol.symbol-70px > img {\n  width: 70px;\n  height: 70px;\n}\n.symbol.symbol-70px .symbol-label {\n  width: 70px;\n  height: 70px;\n}\n.symbol.symbol-70px.symbol-fixed .symbol-label {\n  width: 70px;\n  height: 70px;\n}\n.symbol.symbol-70px.symbol-fixed > img {\n  width: 70px;\n  height: 70px;\n  max-width: auto;\n}\n.symbol.symbol-70px.symbol-2by3 .symbol-label {\n  height: 70px;\n  width: 105px;\n}\n.symbol.symbol-70px.symbol-2by3 > img {\n  height: 70px;\n  width: 105px;\n  max-width: auto;\n}\n.symbol.symbol-75px > img {\n  width: 75px;\n  height: 75px;\n}\n.symbol.symbol-75px .symbol-label {\n  width: 75px;\n  height: 75px;\n}\n.symbol.symbol-75px.symbol-fixed .symbol-label {\n  width: 75px;\n  height: 75px;\n}\n.symbol.symbol-75px.symbol-fixed > img {\n  width: 75px;\n  height: 75px;\n  max-width: auto;\n}\n.symbol.symbol-75px.symbol-2by3 .symbol-label {\n  height: 75px;\n  width: 112.5px;\n}\n.symbol.symbol-75px.symbol-2by3 > img {\n  height: 75px;\n  width: 112.5px;\n  max-width: auto;\n}\n.symbol.symbol-100px > img {\n  width: 100px;\n  height: 100px;\n}\n.symbol.symbol-100px .symbol-label {\n  width: 100px;\n  height: 100px;\n}\n.symbol.symbol-100px.symbol-fixed .symbol-label {\n  width: 100px;\n  height: 100px;\n}\n.symbol.symbol-100px.symbol-fixed > img {\n  width: 100px;\n  height: 100px;\n  max-width: auto;\n}\n.symbol.symbol-100px.symbol-2by3 .symbol-label {\n  height: 100px;\n  width: 150px;\n}\n.symbol.symbol-100px.symbol-2by3 > img {\n  height: 100px;\n  width: 150px;\n  max-width: auto;\n}\n.symbol.symbol-125px > img {\n  width: 125px;\n  height: 125px;\n}\n.symbol.symbol-125px .symbol-label {\n  width: 125px;\n  height: 125px;\n}\n.symbol.symbol-125px.symbol-fixed .symbol-label {\n  width: 125px;\n  height: 125px;\n}\n.symbol.symbol-125px.symbol-fixed > img {\n  width: 125px;\n  height: 125px;\n  max-width: auto;\n}\n.symbol.symbol-125px.symbol-2by3 .symbol-label {\n  height: 125px;\n  width: 187.5px;\n}\n.symbol.symbol-125px.symbol-2by3 > img {\n  height: 125px;\n  width: 187.5px;\n  max-width: auto;\n}\n.symbol.symbol-150px > img {\n  width: 150px;\n  height: 150px;\n}\n.symbol.symbol-150px .symbol-label {\n  width: 150px;\n  height: 150px;\n}\n.symbol.symbol-150px.symbol-fixed .symbol-label {\n  width: 150px;\n  height: 150px;\n}\n.symbol.symbol-150px.symbol-fixed > img {\n  width: 150px;\n  height: 150px;\n  max-width: auto;\n}\n.symbol.symbol-150px.symbol-2by3 .symbol-label {\n  height: 150px;\n  width: 225px;\n}\n.symbol.symbol-150px.symbol-2by3 > img {\n  height: 150px;\n  width: 225px;\n  max-width: auto;\n}\n.symbol.symbol-160px > img {\n  width: 160px;\n  height: 160px;\n}\n.symbol.symbol-160px .symbol-label {\n  width: 160px;\n  height: 160px;\n}\n.symbol.symbol-160px.symbol-fixed .symbol-label {\n  width: 160px;\n  height: 160px;\n}\n.symbol.symbol-160px.symbol-fixed > img {\n  width: 160px;\n  height: 160px;\n  max-width: auto;\n}\n.symbol.symbol-160px.symbol-2by3 .symbol-label {\n  height: 160px;\n  width: 240px;\n}\n.symbol.symbol-160px.symbol-2by3 > img {\n  height: 160px;\n  width: 240px;\n  max-width: auto;\n}\n.symbol.symbol-175px > img {\n  width: 175px;\n  height: 175px;\n}\n.symbol.symbol-175px .symbol-label {\n  width: 175px;\n  height: 175px;\n}\n.symbol.symbol-175px.symbol-fixed .symbol-label {\n  width: 175px;\n  height: 175px;\n}\n.symbol.symbol-175px.symbol-fixed > img {\n  width: 175px;\n  height: 175px;\n  max-width: auto;\n}\n.symbol.symbol-175px.symbol-2by3 .symbol-label {\n  height: 175px;\n  width: 262.5px;\n}\n.symbol.symbol-175px.symbol-2by3 > img {\n  height: 175px;\n  width: 262.5px;\n  max-width: auto;\n}\n.symbol.symbol-200px > img {\n  width: 200px;\n  height: 200px;\n}\n.symbol.symbol-200px .symbol-label {\n  width: 200px;\n  height: 200px;\n}\n.symbol.symbol-200px.symbol-fixed .symbol-label {\n  width: 200px;\n  height: 200px;\n}\n.symbol.symbol-200px.symbol-fixed > img {\n  width: 200px;\n  height: 200px;\n  max-width: auto;\n}\n.symbol.symbol-200px.symbol-2by3 .symbol-label {\n  height: 200px;\n  width: 300px;\n}\n.symbol.symbol-200px.symbol-2by3 > img {\n  height: 200px;\n  width: 300px;\n  max-width: auto;\n}\n@media (min-width: 576px) {\n  .symbol.symbol-sm-20px > img {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-sm-20px .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-sm-20px.symbol-fixed .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-sm-20px.symbol-fixed > img {\n    width: 20px;\n    height: 20px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-20px.symbol-2by3 .symbol-label {\n    height: 20px;\n    width: 30px;\n  }\n  .symbol.symbol-sm-20px.symbol-2by3 > img {\n    height: 20px;\n    width: 30px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-25px > img {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-sm-25px .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-sm-25px.symbol-fixed .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-sm-25px.symbol-fixed > img {\n    width: 25px;\n    height: 25px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-25px.symbol-2by3 .symbol-label {\n    height: 25px;\n    width: 37.5px;\n  }\n  .symbol.symbol-sm-25px.symbol-2by3 > img {\n    height: 25px;\n    width: 37.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-30px > img {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-sm-30px .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-sm-30px.symbol-fixed .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-sm-30px.symbol-fixed > img {\n    width: 30px;\n    height: 30px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-30px.symbol-2by3 .symbol-label {\n    height: 30px;\n    width: 45px;\n  }\n  .symbol.symbol-sm-30px.symbol-2by3 > img {\n    height: 30px;\n    width: 45px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-35px > img {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-sm-35px .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-sm-35px.symbol-fixed .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-sm-35px.symbol-fixed > img {\n    width: 35px;\n    height: 35px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-35px.symbol-2by3 .symbol-label {\n    height: 35px;\n    width: 52.5px;\n  }\n  .symbol.symbol-sm-35px.symbol-2by3 > img {\n    height: 35px;\n    width: 52.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-40px > img {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-sm-40px .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-sm-40px.symbol-fixed .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-sm-40px.symbol-fixed > img {\n    width: 40px;\n    height: 40px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-40px.symbol-2by3 .symbol-label {\n    height: 40px;\n    width: 60px;\n  }\n  .symbol.symbol-sm-40px.symbol-2by3 > img {\n    height: 40px;\n    width: 60px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-45px > img {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-sm-45px .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-sm-45px.symbol-fixed .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-sm-45px.symbol-fixed > img {\n    width: 45px;\n    height: 45px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-45px.symbol-2by3 .symbol-label {\n    height: 45px;\n    width: 67.5px;\n  }\n  .symbol.symbol-sm-45px.symbol-2by3 > img {\n    height: 45px;\n    width: 67.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-50px > img {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-sm-50px .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-sm-50px.symbol-fixed .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-sm-50px.symbol-fixed > img {\n    width: 50px;\n    height: 50px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-50px.symbol-2by3 .symbol-label {\n    height: 50px;\n    width: 75px;\n  }\n  .symbol.symbol-sm-50px.symbol-2by3 > img {\n    height: 50px;\n    width: 75px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-55px > img {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-sm-55px .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-sm-55px.symbol-fixed .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-sm-55px.symbol-fixed > img {\n    width: 55px;\n    height: 55px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-55px.symbol-2by3 .symbol-label {\n    height: 55px;\n    width: 82.5px;\n  }\n  .symbol.symbol-sm-55px.symbol-2by3 > img {\n    height: 55px;\n    width: 82.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-60px > img {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-sm-60px .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-sm-60px.symbol-fixed .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-sm-60px.symbol-fixed > img {\n    width: 60px;\n    height: 60px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-60px.symbol-2by3 .symbol-label {\n    height: 60px;\n    width: 90px;\n  }\n  .symbol.symbol-sm-60px.symbol-2by3 > img {\n    height: 60px;\n    width: 90px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-65px > img {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-sm-65px .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-sm-65px.symbol-fixed .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-sm-65px.symbol-fixed > img {\n    width: 65px;\n    height: 65px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-65px.symbol-2by3 .symbol-label {\n    height: 65px;\n    width: 97.5px;\n  }\n  .symbol.symbol-sm-65px.symbol-2by3 > img {\n    height: 65px;\n    width: 97.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-70px > img {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-sm-70px .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-sm-70px.symbol-fixed .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-sm-70px.symbol-fixed > img {\n    width: 70px;\n    height: 70px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-70px.symbol-2by3 .symbol-label {\n    height: 70px;\n    width: 105px;\n  }\n  .symbol.symbol-sm-70px.symbol-2by3 > img {\n    height: 70px;\n    width: 105px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-75px > img {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-sm-75px .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-sm-75px.symbol-fixed .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-sm-75px.symbol-fixed > img {\n    width: 75px;\n    height: 75px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-75px.symbol-2by3 .symbol-label {\n    height: 75px;\n    width: 112.5px;\n  }\n  .symbol.symbol-sm-75px.symbol-2by3 > img {\n    height: 75px;\n    width: 112.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-100px > img {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-sm-100px .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-sm-100px.symbol-fixed .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-sm-100px.symbol-fixed > img {\n    width: 100px;\n    height: 100px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-100px.symbol-2by3 .symbol-label {\n    height: 100px;\n    width: 150px;\n  }\n  .symbol.symbol-sm-100px.symbol-2by3 > img {\n    height: 100px;\n    width: 150px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-125px > img {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-sm-125px .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-sm-125px.symbol-fixed .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-sm-125px.symbol-fixed > img {\n    width: 125px;\n    height: 125px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-125px.symbol-2by3 .symbol-label {\n    height: 125px;\n    width: 187.5px;\n  }\n  .symbol.symbol-sm-125px.symbol-2by3 > img {\n    height: 125px;\n    width: 187.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-150px > img {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-sm-150px .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-sm-150px.symbol-fixed .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-sm-150px.symbol-fixed > img {\n    width: 150px;\n    height: 150px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-150px.symbol-2by3 .symbol-label {\n    height: 150px;\n    width: 225px;\n  }\n  .symbol.symbol-sm-150px.symbol-2by3 > img {\n    height: 150px;\n    width: 225px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-160px > img {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-sm-160px .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-sm-160px.symbol-fixed .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-sm-160px.symbol-fixed > img {\n    width: 160px;\n    height: 160px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-160px.symbol-2by3 .symbol-label {\n    height: 160px;\n    width: 240px;\n  }\n  .symbol.symbol-sm-160px.symbol-2by3 > img {\n    height: 160px;\n    width: 240px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-175px > img {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-sm-175px .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-sm-175px.symbol-fixed .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-sm-175px.symbol-fixed > img {\n    width: 175px;\n    height: 175px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-175px.symbol-2by3 .symbol-label {\n    height: 175px;\n    width: 262.5px;\n  }\n  .symbol.symbol-sm-175px.symbol-2by3 > img {\n    height: 175px;\n    width: 262.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-200px > img {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-sm-200px .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-sm-200px.symbol-fixed .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-sm-200px.symbol-fixed > img {\n    width: 200px;\n    height: 200px;\n    max-width: auto;\n  }\n  .symbol.symbol-sm-200px.symbol-2by3 .symbol-label {\n    height: 200px;\n    width: 300px;\n  }\n  .symbol.symbol-sm-200px.symbol-2by3 > img {\n    height: 200px;\n    width: 300px;\n    max-width: auto;\n  }\n}\n@media (min-width: 768px) {\n  .symbol.symbol-md-20px > img {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-md-20px .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-md-20px.symbol-fixed .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-md-20px.symbol-fixed > img {\n    width: 20px;\n    height: 20px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-20px.symbol-2by3 .symbol-label {\n    height: 20px;\n    width: 30px;\n  }\n  .symbol.symbol-md-20px.symbol-2by3 > img {\n    height: 20px;\n    width: 30px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-25px > img {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-md-25px .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-md-25px.symbol-fixed .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-md-25px.symbol-fixed > img {\n    width: 25px;\n    height: 25px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-25px.symbol-2by3 .symbol-label {\n    height: 25px;\n    width: 37.5px;\n  }\n  .symbol.symbol-md-25px.symbol-2by3 > img {\n    height: 25px;\n    width: 37.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-30px > img {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-md-30px .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-md-30px.symbol-fixed .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-md-30px.symbol-fixed > img {\n    width: 30px;\n    height: 30px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-30px.symbol-2by3 .symbol-label {\n    height: 30px;\n    width: 45px;\n  }\n  .symbol.symbol-md-30px.symbol-2by3 > img {\n    height: 30px;\n    width: 45px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-35px > img {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-md-35px .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-md-35px.symbol-fixed .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-md-35px.symbol-fixed > img {\n    width: 35px;\n    height: 35px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-35px.symbol-2by3 .symbol-label {\n    height: 35px;\n    width: 52.5px;\n  }\n  .symbol.symbol-md-35px.symbol-2by3 > img {\n    height: 35px;\n    width: 52.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-40px > img {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-md-40px .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-md-40px.symbol-fixed .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-md-40px.symbol-fixed > img {\n    width: 40px;\n    height: 40px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-40px.symbol-2by3 .symbol-label {\n    height: 40px;\n    width: 60px;\n  }\n  .symbol.symbol-md-40px.symbol-2by3 > img {\n    height: 40px;\n    width: 60px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-45px > img {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-md-45px .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-md-45px.symbol-fixed .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-md-45px.symbol-fixed > img {\n    width: 45px;\n    height: 45px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-45px.symbol-2by3 .symbol-label {\n    height: 45px;\n    width: 67.5px;\n  }\n  .symbol.symbol-md-45px.symbol-2by3 > img {\n    height: 45px;\n    width: 67.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-50px > img {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-md-50px .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-md-50px.symbol-fixed .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-md-50px.symbol-fixed > img {\n    width: 50px;\n    height: 50px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-50px.symbol-2by3 .symbol-label {\n    height: 50px;\n    width: 75px;\n  }\n  .symbol.symbol-md-50px.symbol-2by3 > img {\n    height: 50px;\n    width: 75px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-55px > img {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-md-55px .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-md-55px.symbol-fixed .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-md-55px.symbol-fixed > img {\n    width: 55px;\n    height: 55px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-55px.symbol-2by3 .symbol-label {\n    height: 55px;\n    width: 82.5px;\n  }\n  .symbol.symbol-md-55px.symbol-2by3 > img {\n    height: 55px;\n    width: 82.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-60px > img {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-md-60px .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-md-60px.symbol-fixed .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-md-60px.symbol-fixed > img {\n    width: 60px;\n    height: 60px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-60px.symbol-2by3 .symbol-label {\n    height: 60px;\n    width: 90px;\n  }\n  .symbol.symbol-md-60px.symbol-2by3 > img {\n    height: 60px;\n    width: 90px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-65px > img {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-md-65px .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-md-65px.symbol-fixed .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-md-65px.symbol-fixed > img {\n    width: 65px;\n    height: 65px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-65px.symbol-2by3 .symbol-label {\n    height: 65px;\n    width: 97.5px;\n  }\n  .symbol.symbol-md-65px.symbol-2by3 > img {\n    height: 65px;\n    width: 97.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-70px > img {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-md-70px .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-md-70px.symbol-fixed .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-md-70px.symbol-fixed > img {\n    width: 70px;\n    height: 70px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-70px.symbol-2by3 .symbol-label {\n    height: 70px;\n    width: 105px;\n  }\n  .symbol.symbol-md-70px.symbol-2by3 > img {\n    height: 70px;\n    width: 105px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-75px > img {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-md-75px .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-md-75px.symbol-fixed .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-md-75px.symbol-fixed > img {\n    width: 75px;\n    height: 75px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-75px.symbol-2by3 .symbol-label {\n    height: 75px;\n    width: 112.5px;\n  }\n  .symbol.symbol-md-75px.symbol-2by3 > img {\n    height: 75px;\n    width: 112.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-100px > img {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-md-100px .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-md-100px.symbol-fixed .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-md-100px.symbol-fixed > img {\n    width: 100px;\n    height: 100px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-100px.symbol-2by3 .symbol-label {\n    height: 100px;\n    width: 150px;\n  }\n  .symbol.symbol-md-100px.symbol-2by3 > img {\n    height: 100px;\n    width: 150px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-125px > img {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-md-125px .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-md-125px.symbol-fixed .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-md-125px.symbol-fixed > img {\n    width: 125px;\n    height: 125px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-125px.symbol-2by3 .symbol-label {\n    height: 125px;\n    width: 187.5px;\n  }\n  .symbol.symbol-md-125px.symbol-2by3 > img {\n    height: 125px;\n    width: 187.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-150px > img {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-md-150px .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-md-150px.symbol-fixed .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-md-150px.symbol-fixed > img {\n    width: 150px;\n    height: 150px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-150px.symbol-2by3 .symbol-label {\n    height: 150px;\n    width: 225px;\n  }\n  .symbol.symbol-md-150px.symbol-2by3 > img {\n    height: 150px;\n    width: 225px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-160px > img {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-md-160px .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-md-160px.symbol-fixed .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-md-160px.symbol-fixed > img {\n    width: 160px;\n    height: 160px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-160px.symbol-2by3 .symbol-label {\n    height: 160px;\n    width: 240px;\n  }\n  .symbol.symbol-md-160px.symbol-2by3 > img {\n    height: 160px;\n    width: 240px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-175px > img {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-md-175px .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-md-175px.symbol-fixed .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-md-175px.symbol-fixed > img {\n    width: 175px;\n    height: 175px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-175px.symbol-2by3 .symbol-label {\n    height: 175px;\n    width: 262.5px;\n  }\n  .symbol.symbol-md-175px.symbol-2by3 > img {\n    height: 175px;\n    width: 262.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-200px > img {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-md-200px .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-md-200px.symbol-fixed .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-md-200px.symbol-fixed > img {\n    width: 200px;\n    height: 200px;\n    max-width: auto;\n  }\n  .symbol.symbol-md-200px.symbol-2by3 .symbol-label {\n    height: 200px;\n    width: 300px;\n  }\n  .symbol.symbol-md-200px.symbol-2by3 > img {\n    height: 200px;\n    width: 300px;\n    max-width: auto;\n  }\n}\n@media (min-width: 992px) {\n  .symbol.symbol-lg-20px > img {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-lg-20px .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-lg-20px.symbol-fixed .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-lg-20px.symbol-fixed > img {\n    width: 20px;\n    height: 20px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-20px.symbol-2by3 .symbol-label {\n    height: 20px;\n    width: 30px;\n  }\n  .symbol.symbol-lg-20px.symbol-2by3 > img {\n    height: 20px;\n    width: 30px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-25px > img {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-lg-25px .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-lg-25px.symbol-fixed .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-lg-25px.symbol-fixed > img {\n    width: 25px;\n    height: 25px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-25px.symbol-2by3 .symbol-label {\n    height: 25px;\n    width: 37.5px;\n  }\n  .symbol.symbol-lg-25px.symbol-2by3 > img {\n    height: 25px;\n    width: 37.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-30px > img {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-lg-30px .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-lg-30px.symbol-fixed .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-lg-30px.symbol-fixed > img {\n    width: 30px;\n    height: 30px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-30px.symbol-2by3 .symbol-label {\n    height: 30px;\n    width: 45px;\n  }\n  .symbol.symbol-lg-30px.symbol-2by3 > img {\n    height: 30px;\n    width: 45px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-35px > img {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-lg-35px .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-lg-35px.symbol-fixed .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-lg-35px.symbol-fixed > img {\n    width: 35px;\n    height: 35px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-35px.symbol-2by3 .symbol-label {\n    height: 35px;\n    width: 52.5px;\n  }\n  .symbol.symbol-lg-35px.symbol-2by3 > img {\n    height: 35px;\n    width: 52.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-40px > img {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-lg-40px .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-lg-40px.symbol-fixed .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-lg-40px.symbol-fixed > img {\n    width: 40px;\n    height: 40px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-40px.symbol-2by3 .symbol-label {\n    height: 40px;\n    width: 60px;\n  }\n  .symbol.symbol-lg-40px.symbol-2by3 > img {\n    height: 40px;\n    width: 60px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-45px > img {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-lg-45px .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-lg-45px.symbol-fixed .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-lg-45px.symbol-fixed > img {\n    width: 45px;\n    height: 45px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-45px.symbol-2by3 .symbol-label {\n    height: 45px;\n    width: 67.5px;\n  }\n  .symbol.symbol-lg-45px.symbol-2by3 > img {\n    height: 45px;\n    width: 67.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-50px > img {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-lg-50px .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-lg-50px.symbol-fixed .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-lg-50px.symbol-fixed > img {\n    width: 50px;\n    height: 50px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-50px.symbol-2by3 .symbol-label {\n    height: 50px;\n    width: 75px;\n  }\n  .symbol.symbol-lg-50px.symbol-2by3 > img {\n    height: 50px;\n    width: 75px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-55px > img {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-lg-55px .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-lg-55px.symbol-fixed .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-lg-55px.symbol-fixed > img {\n    width: 55px;\n    height: 55px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-55px.symbol-2by3 .symbol-label {\n    height: 55px;\n    width: 82.5px;\n  }\n  .symbol.symbol-lg-55px.symbol-2by3 > img {\n    height: 55px;\n    width: 82.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-60px > img {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-lg-60px .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-lg-60px.symbol-fixed .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-lg-60px.symbol-fixed > img {\n    width: 60px;\n    height: 60px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-60px.symbol-2by3 .symbol-label {\n    height: 60px;\n    width: 90px;\n  }\n  .symbol.symbol-lg-60px.symbol-2by3 > img {\n    height: 60px;\n    width: 90px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-65px > img {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-lg-65px .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-lg-65px.symbol-fixed .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-lg-65px.symbol-fixed > img {\n    width: 65px;\n    height: 65px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-65px.symbol-2by3 .symbol-label {\n    height: 65px;\n    width: 97.5px;\n  }\n  .symbol.symbol-lg-65px.symbol-2by3 > img {\n    height: 65px;\n    width: 97.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-70px > img {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-lg-70px .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-lg-70px.symbol-fixed .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-lg-70px.symbol-fixed > img {\n    width: 70px;\n    height: 70px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-70px.symbol-2by3 .symbol-label {\n    height: 70px;\n    width: 105px;\n  }\n  .symbol.symbol-lg-70px.symbol-2by3 > img {\n    height: 70px;\n    width: 105px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-75px > img {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-lg-75px .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-lg-75px.symbol-fixed .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-lg-75px.symbol-fixed > img {\n    width: 75px;\n    height: 75px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-75px.symbol-2by3 .symbol-label {\n    height: 75px;\n    width: 112.5px;\n  }\n  .symbol.symbol-lg-75px.symbol-2by3 > img {\n    height: 75px;\n    width: 112.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-100px > img {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-lg-100px .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-lg-100px.symbol-fixed .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-lg-100px.symbol-fixed > img {\n    width: 100px;\n    height: 100px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-100px.symbol-2by3 .symbol-label {\n    height: 100px;\n    width: 150px;\n  }\n  .symbol.symbol-lg-100px.symbol-2by3 > img {\n    height: 100px;\n    width: 150px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-125px > img {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-lg-125px .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-lg-125px.symbol-fixed .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-lg-125px.symbol-fixed > img {\n    width: 125px;\n    height: 125px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-125px.symbol-2by3 .symbol-label {\n    height: 125px;\n    width: 187.5px;\n  }\n  .symbol.symbol-lg-125px.symbol-2by3 > img {\n    height: 125px;\n    width: 187.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-150px > img {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-lg-150px .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-lg-150px.symbol-fixed .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-lg-150px.symbol-fixed > img {\n    width: 150px;\n    height: 150px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-150px.symbol-2by3 .symbol-label {\n    height: 150px;\n    width: 225px;\n  }\n  .symbol.symbol-lg-150px.symbol-2by3 > img {\n    height: 150px;\n    width: 225px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-160px > img {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-lg-160px .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-lg-160px.symbol-fixed .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-lg-160px.symbol-fixed > img {\n    width: 160px;\n    height: 160px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-160px.symbol-2by3 .symbol-label {\n    height: 160px;\n    width: 240px;\n  }\n  .symbol.symbol-lg-160px.symbol-2by3 > img {\n    height: 160px;\n    width: 240px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-175px > img {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-lg-175px .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-lg-175px.symbol-fixed .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-lg-175px.symbol-fixed > img {\n    width: 175px;\n    height: 175px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-175px.symbol-2by3 .symbol-label {\n    height: 175px;\n    width: 262.5px;\n  }\n  .symbol.symbol-lg-175px.symbol-2by3 > img {\n    height: 175px;\n    width: 262.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-200px > img {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-lg-200px .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-lg-200px.symbol-fixed .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-lg-200px.symbol-fixed > img {\n    width: 200px;\n    height: 200px;\n    max-width: auto;\n  }\n  .symbol.symbol-lg-200px.symbol-2by3 .symbol-label {\n    height: 200px;\n    width: 300px;\n  }\n  .symbol.symbol-lg-200px.symbol-2by3 > img {\n    height: 200px;\n    width: 300px;\n    max-width: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .symbol.symbol-xl-20px > img {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xl-20px .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xl-20px.symbol-fixed .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xl-20px.symbol-fixed > img {\n    width: 20px;\n    height: 20px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-20px.symbol-2by3 .symbol-label {\n    height: 20px;\n    width: 30px;\n  }\n  .symbol.symbol-xl-20px.symbol-2by3 > img {\n    height: 20px;\n    width: 30px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-25px > img {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xl-25px .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xl-25px.symbol-fixed .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xl-25px.symbol-fixed > img {\n    width: 25px;\n    height: 25px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-25px.symbol-2by3 .symbol-label {\n    height: 25px;\n    width: 37.5px;\n  }\n  .symbol.symbol-xl-25px.symbol-2by3 > img {\n    height: 25px;\n    width: 37.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-30px > img {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xl-30px .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xl-30px.symbol-fixed .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xl-30px.symbol-fixed > img {\n    width: 30px;\n    height: 30px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-30px.symbol-2by3 .symbol-label {\n    height: 30px;\n    width: 45px;\n  }\n  .symbol.symbol-xl-30px.symbol-2by3 > img {\n    height: 30px;\n    width: 45px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-35px > img {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xl-35px .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xl-35px.symbol-fixed .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xl-35px.symbol-fixed > img {\n    width: 35px;\n    height: 35px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-35px.symbol-2by3 .symbol-label {\n    height: 35px;\n    width: 52.5px;\n  }\n  .symbol.symbol-xl-35px.symbol-2by3 > img {\n    height: 35px;\n    width: 52.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-40px > img {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xl-40px .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xl-40px.symbol-fixed .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xl-40px.symbol-fixed > img {\n    width: 40px;\n    height: 40px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-40px.symbol-2by3 .symbol-label {\n    height: 40px;\n    width: 60px;\n  }\n  .symbol.symbol-xl-40px.symbol-2by3 > img {\n    height: 40px;\n    width: 60px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-45px > img {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xl-45px .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xl-45px.symbol-fixed .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xl-45px.symbol-fixed > img {\n    width: 45px;\n    height: 45px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-45px.symbol-2by3 .symbol-label {\n    height: 45px;\n    width: 67.5px;\n  }\n  .symbol.symbol-xl-45px.symbol-2by3 > img {\n    height: 45px;\n    width: 67.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-50px > img {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xl-50px .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xl-50px.symbol-fixed .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xl-50px.symbol-fixed > img {\n    width: 50px;\n    height: 50px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-50px.symbol-2by3 .symbol-label {\n    height: 50px;\n    width: 75px;\n  }\n  .symbol.symbol-xl-50px.symbol-2by3 > img {\n    height: 50px;\n    width: 75px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-55px > img {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xl-55px .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xl-55px.symbol-fixed .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xl-55px.symbol-fixed > img {\n    width: 55px;\n    height: 55px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-55px.symbol-2by3 .symbol-label {\n    height: 55px;\n    width: 82.5px;\n  }\n  .symbol.symbol-xl-55px.symbol-2by3 > img {\n    height: 55px;\n    width: 82.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-60px > img {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xl-60px .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xl-60px.symbol-fixed .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xl-60px.symbol-fixed > img {\n    width: 60px;\n    height: 60px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-60px.symbol-2by3 .symbol-label {\n    height: 60px;\n    width: 90px;\n  }\n  .symbol.symbol-xl-60px.symbol-2by3 > img {\n    height: 60px;\n    width: 90px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-65px > img {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xl-65px .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xl-65px.symbol-fixed .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xl-65px.symbol-fixed > img {\n    width: 65px;\n    height: 65px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-65px.symbol-2by3 .symbol-label {\n    height: 65px;\n    width: 97.5px;\n  }\n  .symbol.symbol-xl-65px.symbol-2by3 > img {\n    height: 65px;\n    width: 97.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-70px > img {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xl-70px .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xl-70px.symbol-fixed .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xl-70px.symbol-fixed > img {\n    width: 70px;\n    height: 70px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-70px.symbol-2by3 .symbol-label {\n    height: 70px;\n    width: 105px;\n  }\n  .symbol.symbol-xl-70px.symbol-2by3 > img {\n    height: 70px;\n    width: 105px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-75px > img {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xl-75px .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xl-75px.symbol-fixed .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xl-75px.symbol-fixed > img {\n    width: 75px;\n    height: 75px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-75px.symbol-2by3 .symbol-label {\n    height: 75px;\n    width: 112.5px;\n  }\n  .symbol.symbol-xl-75px.symbol-2by3 > img {\n    height: 75px;\n    width: 112.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-100px > img {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xl-100px .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xl-100px.symbol-fixed .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xl-100px.symbol-fixed > img {\n    width: 100px;\n    height: 100px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-100px.symbol-2by3 .symbol-label {\n    height: 100px;\n    width: 150px;\n  }\n  .symbol.symbol-xl-100px.symbol-2by3 > img {\n    height: 100px;\n    width: 150px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-125px > img {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xl-125px .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xl-125px.symbol-fixed .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xl-125px.symbol-fixed > img {\n    width: 125px;\n    height: 125px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-125px.symbol-2by3 .symbol-label {\n    height: 125px;\n    width: 187.5px;\n  }\n  .symbol.symbol-xl-125px.symbol-2by3 > img {\n    height: 125px;\n    width: 187.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-150px > img {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xl-150px .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xl-150px.symbol-fixed .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xl-150px.symbol-fixed > img {\n    width: 150px;\n    height: 150px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-150px.symbol-2by3 .symbol-label {\n    height: 150px;\n    width: 225px;\n  }\n  .symbol.symbol-xl-150px.symbol-2by3 > img {\n    height: 150px;\n    width: 225px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-160px > img {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xl-160px .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xl-160px.symbol-fixed .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xl-160px.symbol-fixed > img {\n    width: 160px;\n    height: 160px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-160px.symbol-2by3 .symbol-label {\n    height: 160px;\n    width: 240px;\n  }\n  .symbol.symbol-xl-160px.symbol-2by3 > img {\n    height: 160px;\n    width: 240px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-175px > img {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xl-175px .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xl-175px.symbol-fixed .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xl-175px.symbol-fixed > img {\n    width: 175px;\n    height: 175px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-175px.symbol-2by3 .symbol-label {\n    height: 175px;\n    width: 262.5px;\n  }\n  .symbol.symbol-xl-175px.symbol-2by3 > img {\n    height: 175px;\n    width: 262.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-200px > img {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xl-200px .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xl-200px.symbol-fixed .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xl-200px.symbol-fixed > img {\n    width: 200px;\n    height: 200px;\n    max-width: auto;\n  }\n  .symbol.symbol-xl-200px.symbol-2by3 .symbol-label {\n    height: 200px;\n    width: 300px;\n  }\n  .symbol.symbol-xl-200px.symbol-2by3 > img {\n    height: 200px;\n    width: 300px;\n    max-width: auto;\n  }\n}\n@media (min-width: 1400px) {\n  .symbol.symbol-xxl-20px > img {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xxl-20px .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xxl-20px.symbol-fixed .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xxl-20px.symbol-fixed > img {\n    width: 20px;\n    height: 20px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-20px.symbol-2by3 .symbol-label {\n    height: 20px;\n    width: 30px;\n  }\n  .symbol.symbol-xxl-20px.symbol-2by3 > img {\n    height: 20px;\n    width: 30px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-25px > img {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xxl-25px .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xxl-25px.symbol-fixed .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xxl-25px.symbol-fixed > img {\n    width: 25px;\n    height: 25px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-25px.symbol-2by3 .symbol-label {\n    height: 25px;\n    width: 37.5px;\n  }\n  .symbol.symbol-xxl-25px.symbol-2by3 > img {\n    height: 25px;\n    width: 37.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-30px > img {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xxl-30px .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xxl-30px.symbol-fixed .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xxl-30px.symbol-fixed > img {\n    width: 30px;\n    height: 30px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-30px.symbol-2by3 .symbol-label {\n    height: 30px;\n    width: 45px;\n  }\n  .symbol.symbol-xxl-30px.symbol-2by3 > img {\n    height: 30px;\n    width: 45px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-35px > img {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xxl-35px .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xxl-35px.symbol-fixed .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xxl-35px.symbol-fixed > img {\n    width: 35px;\n    height: 35px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-35px.symbol-2by3 .symbol-label {\n    height: 35px;\n    width: 52.5px;\n  }\n  .symbol.symbol-xxl-35px.symbol-2by3 > img {\n    height: 35px;\n    width: 52.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-40px > img {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xxl-40px .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xxl-40px.symbol-fixed .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xxl-40px.symbol-fixed > img {\n    width: 40px;\n    height: 40px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-40px.symbol-2by3 .symbol-label {\n    height: 40px;\n    width: 60px;\n  }\n  .symbol.symbol-xxl-40px.symbol-2by3 > img {\n    height: 40px;\n    width: 60px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-45px > img {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xxl-45px .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xxl-45px.symbol-fixed .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xxl-45px.symbol-fixed > img {\n    width: 45px;\n    height: 45px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-45px.symbol-2by3 .symbol-label {\n    height: 45px;\n    width: 67.5px;\n  }\n  .symbol.symbol-xxl-45px.symbol-2by3 > img {\n    height: 45px;\n    width: 67.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-50px > img {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xxl-50px .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xxl-50px.symbol-fixed .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xxl-50px.symbol-fixed > img {\n    width: 50px;\n    height: 50px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-50px.symbol-2by3 .symbol-label {\n    height: 50px;\n    width: 75px;\n  }\n  .symbol.symbol-xxl-50px.symbol-2by3 > img {\n    height: 50px;\n    width: 75px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-55px > img {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xxl-55px .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xxl-55px.symbol-fixed .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xxl-55px.symbol-fixed > img {\n    width: 55px;\n    height: 55px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-55px.symbol-2by3 .symbol-label {\n    height: 55px;\n    width: 82.5px;\n  }\n  .symbol.symbol-xxl-55px.symbol-2by3 > img {\n    height: 55px;\n    width: 82.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-60px > img {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xxl-60px .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xxl-60px.symbol-fixed .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xxl-60px.symbol-fixed > img {\n    width: 60px;\n    height: 60px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-60px.symbol-2by3 .symbol-label {\n    height: 60px;\n    width: 90px;\n  }\n  .symbol.symbol-xxl-60px.symbol-2by3 > img {\n    height: 60px;\n    width: 90px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-65px > img {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xxl-65px .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xxl-65px.symbol-fixed .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xxl-65px.symbol-fixed > img {\n    width: 65px;\n    height: 65px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-65px.symbol-2by3 .symbol-label {\n    height: 65px;\n    width: 97.5px;\n  }\n  .symbol.symbol-xxl-65px.symbol-2by3 > img {\n    height: 65px;\n    width: 97.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-70px > img {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xxl-70px .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xxl-70px.symbol-fixed .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xxl-70px.symbol-fixed > img {\n    width: 70px;\n    height: 70px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-70px.symbol-2by3 .symbol-label {\n    height: 70px;\n    width: 105px;\n  }\n  .symbol.symbol-xxl-70px.symbol-2by3 > img {\n    height: 70px;\n    width: 105px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-75px > img {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xxl-75px .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xxl-75px.symbol-fixed .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xxl-75px.symbol-fixed > img {\n    width: 75px;\n    height: 75px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-75px.symbol-2by3 .symbol-label {\n    height: 75px;\n    width: 112.5px;\n  }\n  .symbol.symbol-xxl-75px.symbol-2by3 > img {\n    height: 75px;\n    width: 112.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-100px > img {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xxl-100px .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xxl-100px.symbol-fixed .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xxl-100px.symbol-fixed > img {\n    width: 100px;\n    height: 100px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-100px.symbol-2by3 .symbol-label {\n    height: 100px;\n    width: 150px;\n  }\n  .symbol.symbol-xxl-100px.symbol-2by3 > img {\n    height: 100px;\n    width: 150px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-125px > img {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xxl-125px .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xxl-125px.symbol-fixed .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xxl-125px.symbol-fixed > img {\n    width: 125px;\n    height: 125px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-125px.symbol-2by3 .symbol-label {\n    height: 125px;\n    width: 187.5px;\n  }\n  .symbol.symbol-xxl-125px.symbol-2by3 > img {\n    height: 125px;\n    width: 187.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-150px > img {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xxl-150px .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xxl-150px.symbol-fixed .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xxl-150px.symbol-fixed > img {\n    width: 150px;\n    height: 150px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-150px.symbol-2by3 .symbol-label {\n    height: 150px;\n    width: 225px;\n  }\n  .symbol.symbol-xxl-150px.symbol-2by3 > img {\n    height: 150px;\n    width: 225px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-160px > img {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xxl-160px .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xxl-160px.symbol-fixed .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xxl-160px.symbol-fixed > img {\n    width: 160px;\n    height: 160px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-160px.symbol-2by3 .symbol-label {\n    height: 160px;\n    width: 240px;\n  }\n  .symbol.symbol-xxl-160px.symbol-2by3 > img {\n    height: 160px;\n    width: 240px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-175px > img {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xxl-175px .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xxl-175px.symbol-fixed .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xxl-175px.symbol-fixed > img {\n    width: 175px;\n    height: 175px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-175px.symbol-2by3 .symbol-label {\n    height: 175px;\n    width: 262.5px;\n  }\n  .symbol.symbol-xxl-175px.symbol-2by3 > img {\n    height: 175px;\n    width: 262.5px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-200px > img {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xxl-200px .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xxl-200px.symbol-fixed .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xxl-200px.symbol-fixed > img {\n    width: 200px;\n    height: 200px;\n    max-width: auto;\n  }\n  .symbol.symbol-xxl-200px.symbol-2by3 .symbol-label {\n    height: 200px;\n    width: 300px;\n  }\n  .symbol.symbol-xxl-200px.symbol-2by3 > img {\n    height: 200px;\n    width: 300px;\n    max-width: auto;\n  }\n}\n\n.symbol-group {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-left: 10px;\n}\n.symbol-group .symbol {\n  position: relative;\n  z-index: 0;\n  margin-left: -10px;\n  border: 2px solid #ffffff;\n  transition: all 0.3s ease;\n}\n.symbol-group .symbol:hover {\n  transition: all 0.3s ease;\n  z-index: 1;\n}\n.symbol-group.symbol-hover .symbol {\n  cursor: pointer;\n}\n\n.pulse {\n  position: relative;\n}\n.pulse.pulse-white .pulse-ring {\n  border-color: #ffffff;\n}\n.pulse.pulse-light .pulse-ring {\n  border-color: #F5F8FA;\n}\n.pulse.pulse-primary .pulse-ring {\n  border-color: #009EF7;\n}\n.pulse.pulse-secondary .pulse-ring {\n  border-color: #E4E6EF;\n}\n.pulse.pulse-success .pulse-ring {\n  border-color: #50CD89;\n}\n.pulse.pulse-info .pulse-ring {\n  border-color: #7239EA;\n}\n.pulse.pulse-warning .pulse-ring {\n  border-color: #FFC700;\n}\n.pulse.pulse-danger .pulse-ring {\n  border-color: #F1416C;\n}\n.pulse.pulse-dark .pulse-ring {\n  border-color: #181C32;\n}\n\n.pulse-ring {\n  display: block;\n  border-radius: 40px;\n  height: 40px;\n  width: 40px;\n  position: absolute;\n  animation: animation-pulse 3.5s ease-out;\n  animation-iteration-count: infinite;\n  opacity: 0;\n  border-width: 3px;\n  border-style: solid;\n  border-color: #A1A5B7;\n}\n\n@keyframes animation-pulse {\n  0% {\n    -webkit-transform: scale(0.1, 0.1);\n    opacity: 0;\n  }\n  60% {\n    -webkit-transform: scale(0.1, 0.1);\n    opacity: 0;\n  }\n  65% {\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scale(1.2, 1.2);\n    opacity: 0;\n  }\n}\n.page-loading * {\n  transition: none !important;\n}\n\n.page-loader {\n  background: #ffffff;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  display: none;\n}\n.page-loading .page-loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.scrolltop {\n  position: fixed;\n  display: none;\n  cursor: pointer;\n  z-index: 100;\n  justify-content: center;\n  align-items: center;\n  width: 36px;\n  height: 36px;\n  bottom: 40px;\n  right: 20px;\n  background-color: #009EF7;\n  box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);\n  opacity: 0;\n  transition: color 0.2s ease, background-color 0.2s ease;\n  border-radius: 0.475rem;\n}\n.scrolltop .svg-icon svg {\n  height: 24px;\n  width: 24px;\n}\n.scrolltop .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.scrolltop .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.scrolltop > i {\n  font-size: 1.3rem;\n  color: #ffffff;\n}\n.scrolltop:hover {\n  background-color: #009EF7;\n}\n.scrolltop:hover > i {\n  color: #ffffff;\n}\n.scrolltop:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.scrolltop:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n[data-kt-scrolltop=on] .scrolltop {\n  opacity: 0.3;\n  animation: animation-scrolltop 0.4s ease-out 1;\n  display: flex;\n}\n[data-kt-scrolltop=on] .scrolltop:hover {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  opacity: 1;\n}\n@media (max-width: 991.98px) {\n  .scrolltop {\n    bottom: 30px;\n    right: 15px;\n    width: 30px;\n    height: 30px;\n  }\n}\n\n@keyframes animation-scrolltop {\n  from {\n    margin-bottom: -15px;\n  }\n  to {\n    margin-bottom: 0;\n  }\n}\n.svg-icon {\n  line-height: 1;\n}\n.svg-icon svg {\n  height: 1.15rem;\n  width: 1.15rem;\n}\n.svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #A1A5B7;\n}\n.svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.svg-icon.svg-icon-white svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #ffffff;\n}\n.svg-icon.svg-icon-white svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.svg-icon.svg-icon-primary svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.svg-icon.svg-icon-primary svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.svg-icon.svg-icon-secondary svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #E4E6EF;\n}\n.svg-icon.svg-icon-secondary svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.svg-icon.svg-icon-light svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F5F8FA;\n}\n.svg-icon.svg-icon-light svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.svg-icon.svg-icon-success svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #50CD89;\n}\n.svg-icon.svg-icon-success svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.svg-icon.svg-icon-info svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7239EA;\n}\n.svg-icon.svg-icon-info svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.svg-icon.svg-icon-warning svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFC700;\n}\n.svg-icon.svg-icon-warning svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.svg-icon.svg-icon-danger svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F1416C;\n}\n.svg-icon.svg-icon-danger svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.svg-icon.svg-icon-dark svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #181C32;\n}\n.svg-icon.svg-icon-dark svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.svg-icon.svg-icon-muted svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #A1A5B7;\n}\n.svg-icon.svg-icon-muted svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.svg-icon.svg-icon-gray-100 svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F5F8FA;\n}\n.svg-icon.svg-icon-gray-100 svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.svg-icon.svg-icon-gray-200 svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #EFF2F5;\n}\n.svg-icon.svg-icon-gray-200 svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.svg-icon.svg-icon-gray-300 svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #E4E6EF;\n}\n.svg-icon.svg-icon-gray-300 svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.svg-icon.svg-icon-gray-400 svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #B5B5C3;\n}\n.svg-icon.svg-icon-gray-400 svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.svg-icon.svg-icon-gray-500 svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #A1A5B7;\n}\n.svg-icon.svg-icon-gray-500 svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.svg-icon.svg-icon-gray-600 svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #7E8299;\n}\n.svg-icon.svg-icon-gray-600 svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.svg-icon.svg-icon-gray-700 svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #5E6278;\n}\n.svg-icon.svg-icon-gray-700 svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.svg-icon.svg-icon-gray-800 svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #3F4254;\n}\n.svg-icon.svg-icon-gray-800 svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.svg-icon.svg-icon-gray-900 svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #181C32;\n}\n.svg-icon.svg-icon-gray-900 svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.svg-icon.svg-icon-1 svg {\n  height: 1.75rem !important;\n  width: 1.75rem !important;\n}\n.svg-icon.svg-icon-2 svg {\n  height: 1.5rem !important;\n  width: 1.5rem !important;\n}\n.svg-icon.svg-icon-3 svg {\n  height: 1.35rem !important;\n  width: 1.35rem !important;\n}\n.svg-icon.svg-icon-4 svg {\n  height: 1.25rem !important;\n  width: 1.25rem !important;\n}\n.svg-icon.svg-icon-5 svg {\n  height: 1.15rem !important;\n  width: 1.15rem !important;\n}\n.svg-icon.svg-icon-6 svg {\n  height: 1.075rem !important;\n  width: 1.075rem !important;\n}\n.svg-icon.svg-icon-7 svg {\n  height: 0.95rem !important;\n  width: 0.95rem !important;\n}\n.svg-icon.svg-icon-8 svg {\n  height: 0.85rem !important;\n  width: 0.85rem !important;\n}\n.svg-icon.svg-icon-9 svg {\n  height: 0.75rem !important;\n  width: 0.75rem !important;\n}\n.svg-icon.svg-icon-10 svg {\n  height: 0.5rem !important;\n  width: 0.5rem !important;\n}\n.svg-icon.svg-icon-base svg {\n  height: 1rem !important;\n  width: 1rem !important;\n}\n.svg-icon.svg-icon-fluid svg {\n  height: 100% !important;\n  width: 100% !important;\n}\n.svg-icon.svg-icon-2x svg {\n  height: 2rem !important;\n  width: 2rem !important;\n}\n.svg-icon.svg-icon-2qx svg {\n  height: 2.25rem !important;\n  width: 2.25rem !important;\n}\n.svg-icon.svg-icon-2hx svg {\n  height: 2.5rem !important;\n  width: 2.5rem !important;\n}\n.svg-icon.svg-icon-2tx svg {\n  height: 2.75rem !important;\n  width: 2.75rem !important;\n}\n.svg-icon.svg-icon-3x svg {\n  height: 3rem !important;\n  width: 3rem !important;\n}\n.svg-icon.svg-icon-3qx svg {\n  height: 3.25rem !important;\n  width: 3.25rem !important;\n}\n.svg-icon.svg-icon-3hx svg {\n  height: 3.5rem !important;\n  width: 3.5rem !important;\n}\n.svg-icon.svg-icon-3tx svg {\n  height: 3.75rem !important;\n  width: 3.75rem !important;\n}\n.svg-icon.svg-icon-4x svg {\n  height: 4rem !important;\n  width: 4rem !important;\n}\n.svg-icon.svg-icon-4qx svg {\n  height: 4.25rem !important;\n  width: 4.25rem !important;\n}\n.svg-icon.svg-icon-4hx svg {\n  height: 4.5rem !important;\n  width: 4.5rem !important;\n}\n.svg-icon.svg-icon-4tx svg {\n  height: 4.75rem !important;\n  width: 4.75rem !important;\n}\n.svg-icon.svg-icon-5x svg {\n  height: 5rem !important;\n  width: 5rem !important;\n}\n.svg-icon.svg-icon-5qx svg {\n  height: 5.25rem !important;\n  width: 5.25rem !important;\n}\n.svg-icon.svg-icon-5hx svg {\n  height: 5.5rem !important;\n  width: 5.5rem !important;\n}\n.svg-icon.svg-icon-5tx svg {\n  height: 5.75rem !important;\n  width: 5.75rem !important;\n}\n@media (min-width: 576px) {\n  .svg-icon.svg-icon-sm-1 svg {\n    height: 1.75rem !important;\n    width: 1.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-2 svg {\n    height: 1.5rem !important;\n    width: 1.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-3 svg {\n    height: 1.35rem !important;\n    width: 1.35rem !important;\n  }\n  .svg-icon.svg-icon-sm-4 svg {\n    height: 1.25rem !important;\n    width: 1.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-5 svg {\n    height: 1.15rem !important;\n    width: 1.15rem !important;\n  }\n  .svg-icon.svg-icon-sm-6 svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-sm-7 svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-sm-8 svg {\n    height: 0.85rem !important;\n    width: 0.85rem !important;\n  }\n  .svg-icon.svg-icon-sm-9 svg {\n    height: 0.75rem !important;\n    width: 0.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-10 svg {\n    height: 0.5rem !important;\n    width: 0.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-base svg {\n    height: 1rem !important;\n    width: 1rem !important;\n  }\n  .svg-icon.svg-icon-sm-fluid svg {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .svg-icon.svg-icon-sm-2x svg {\n    height: 2rem !important;\n    width: 2rem !important;\n  }\n  .svg-icon.svg-icon-sm-2qx svg {\n    height: 2.25rem !important;\n    width: 2.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-2hx svg {\n    height: 2.5rem !important;\n    width: 2.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-2tx svg {\n    height: 2.75rem !important;\n    width: 2.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-3x svg {\n    height: 3rem !important;\n    width: 3rem !important;\n  }\n  .svg-icon.svg-icon-sm-3qx svg {\n    height: 3.25rem !important;\n    width: 3.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-3hx svg {\n    height: 3.5rem !important;\n    width: 3.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-3tx svg {\n    height: 3.75rem !important;\n    width: 3.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-4x svg {\n    height: 4rem !important;\n    width: 4rem !important;\n  }\n  .svg-icon.svg-icon-sm-4qx svg {\n    height: 4.25rem !important;\n    width: 4.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-4hx svg {\n    height: 4.5rem !important;\n    width: 4.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-4tx svg {\n    height: 4.75rem !important;\n    width: 4.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-5x svg {\n    height: 5rem !important;\n    width: 5rem !important;\n  }\n  .svg-icon.svg-icon-sm-5qx svg {\n    height: 5.25rem !important;\n    width: 5.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-5hx svg {\n    height: 5.5rem !important;\n    width: 5.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-5tx svg {\n    height: 5.75rem !important;\n    width: 5.75rem !important;\n  }\n}\n@media (min-width: 768px) {\n  .svg-icon.svg-icon-md-1 svg {\n    height: 1.75rem !important;\n    width: 1.75rem !important;\n  }\n  .svg-icon.svg-icon-md-2 svg {\n    height: 1.5rem !important;\n    width: 1.5rem !important;\n  }\n  .svg-icon.svg-icon-md-3 svg {\n    height: 1.35rem !important;\n    width: 1.35rem !important;\n  }\n  .svg-icon.svg-icon-md-4 svg {\n    height: 1.25rem !important;\n    width: 1.25rem !important;\n  }\n  .svg-icon.svg-icon-md-5 svg {\n    height: 1.15rem !important;\n    width: 1.15rem !important;\n  }\n  .svg-icon.svg-icon-md-6 svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-md-7 svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-md-8 svg {\n    height: 0.85rem !important;\n    width: 0.85rem !important;\n  }\n  .svg-icon.svg-icon-md-9 svg {\n    height: 0.75rem !important;\n    width: 0.75rem !important;\n  }\n  .svg-icon.svg-icon-md-10 svg {\n    height: 0.5rem !important;\n    width: 0.5rem !important;\n  }\n  .svg-icon.svg-icon-md-base svg {\n    height: 1rem !important;\n    width: 1rem !important;\n  }\n  .svg-icon.svg-icon-md-fluid svg {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .svg-icon.svg-icon-md-2x svg {\n    height: 2rem !important;\n    width: 2rem !important;\n  }\n  .svg-icon.svg-icon-md-2qx svg {\n    height: 2.25rem !important;\n    width: 2.25rem !important;\n  }\n  .svg-icon.svg-icon-md-2hx svg {\n    height: 2.5rem !important;\n    width: 2.5rem !important;\n  }\n  .svg-icon.svg-icon-md-2tx svg {\n    height: 2.75rem !important;\n    width: 2.75rem !important;\n  }\n  .svg-icon.svg-icon-md-3x svg {\n    height: 3rem !important;\n    width: 3rem !important;\n  }\n  .svg-icon.svg-icon-md-3qx svg {\n    height: 3.25rem !important;\n    width: 3.25rem !important;\n  }\n  .svg-icon.svg-icon-md-3hx svg {\n    height: 3.5rem !important;\n    width: 3.5rem !important;\n  }\n  .svg-icon.svg-icon-md-3tx svg {\n    height: 3.75rem !important;\n    width: 3.75rem !important;\n  }\n  .svg-icon.svg-icon-md-4x svg {\n    height: 4rem !important;\n    width: 4rem !important;\n  }\n  .svg-icon.svg-icon-md-4qx svg {\n    height: 4.25rem !important;\n    width: 4.25rem !important;\n  }\n  .svg-icon.svg-icon-md-4hx svg {\n    height: 4.5rem !important;\n    width: 4.5rem !important;\n  }\n  .svg-icon.svg-icon-md-4tx svg {\n    height: 4.75rem !important;\n    width: 4.75rem !important;\n  }\n  .svg-icon.svg-icon-md-5x svg {\n    height: 5rem !important;\n    width: 5rem !important;\n  }\n  .svg-icon.svg-icon-md-5qx svg {\n    height: 5.25rem !important;\n    width: 5.25rem !important;\n  }\n  .svg-icon.svg-icon-md-5hx svg {\n    height: 5.5rem !important;\n    width: 5.5rem !important;\n  }\n  .svg-icon.svg-icon-md-5tx svg {\n    height: 5.75rem !important;\n    width: 5.75rem !important;\n  }\n}\n@media (min-width: 992px) {\n  .svg-icon.svg-icon-lg-1 svg {\n    height: 1.75rem !important;\n    width: 1.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-2 svg {\n    height: 1.5rem !important;\n    width: 1.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-3 svg {\n    height: 1.35rem !important;\n    width: 1.35rem !important;\n  }\n  .svg-icon.svg-icon-lg-4 svg {\n    height: 1.25rem !important;\n    width: 1.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-5 svg {\n    height: 1.15rem !important;\n    width: 1.15rem !important;\n  }\n  .svg-icon.svg-icon-lg-6 svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-lg-7 svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-lg-8 svg {\n    height: 0.85rem !important;\n    width: 0.85rem !important;\n  }\n  .svg-icon.svg-icon-lg-9 svg {\n    height: 0.75rem !important;\n    width: 0.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-10 svg {\n    height: 0.5rem !important;\n    width: 0.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-base svg {\n    height: 1rem !important;\n    width: 1rem !important;\n  }\n  .svg-icon.svg-icon-lg-fluid svg {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .svg-icon.svg-icon-lg-2x svg {\n    height: 2rem !important;\n    width: 2rem !important;\n  }\n  .svg-icon.svg-icon-lg-2qx svg {\n    height: 2.25rem !important;\n    width: 2.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-2hx svg {\n    height: 2.5rem !important;\n    width: 2.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-2tx svg {\n    height: 2.75rem !important;\n    width: 2.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-3x svg {\n    height: 3rem !important;\n    width: 3rem !important;\n  }\n  .svg-icon.svg-icon-lg-3qx svg {\n    height: 3.25rem !important;\n    width: 3.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-3hx svg {\n    height: 3.5rem !important;\n    width: 3.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-3tx svg {\n    height: 3.75rem !important;\n    width: 3.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-4x svg {\n    height: 4rem !important;\n    width: 4rem !important;\n  }\n  .svg-icon.svg-icon-lg-4qx svg {\n    height: 4.25rem !important;\n    width: 4.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-4hx svg {\n    height: 4.5rem !important;\n    width: 4.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-4tx svg {\n    height: 4.75rem !important;\n    width: 4.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-5x svg {\n    height: 5rem !important;\n    width: 5rem !important;\n  }\n  .svg-icon.svg-icon-lg-5qx svg {\n    height: 5.25rem !important;\n    width: 5.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-5hx svg {\n    height: 5.5rem !important;\n    width: 5.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-5tx svg {\n    height: 5.75rem !important;\n    width: 5.75rem !important;\n  }\n}\n@media (min-width: 1200px) {\n  .svg-icon.svg-icon-xl-1 svg {\n    height: 1.75rem !important;\n    width: 1.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-2 svg {\n    height: 1.5rem !important;\n    width: 1.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-3 svg {\n    height: 1.35rem !important;\n    width: 1.35rem !important;\n  }\n  .svg-icon.svg-icon-xl-4 svg {\n    height: 1.25rem !important;\n    width: 1.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-5 svg {\n    height: 1.15rem !important;\n    width: 1.15rem !important;\n  }\n  .svg-icon.svg-icon-xl-6 svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-xl-7 svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-xl-8 svg {\n    height: 0.85rem !important;\n    width: 0.85rem !important;\n  }\n  .svg-icon.svg-icon-xl-9 svg {\n    height: 0.75rem !important;\n    width: 0.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-10 svg {\n    height: 0.5rem !important;\n    width: 0.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-base svg {\n    height: 1rem !important;\n    width: 1rem !important;\n  }\n  .svg-icon.svg-icon-xl-fluid svg {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .svg-icon.svg-icon-xl-2x svg {\n    height: 2rem !important;\n    width: 2rem !important;\n  }\n  .svg-icon.svg-icon-xl-2qx svg {\n    height: 2.25rem !important;\n    width: 2.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-2hx svg {\n    height: 2.5rem !important;\n    width: 2.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-2tx svg {\n    height: 2.75rem !important;\n    width: 2.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-3x svg {\n    height: 3rem !important;\n    width: 3rem !important;\n  }\n  .svg-icon.svg-icon-xl-3qx svg {\n    height: 3.25rem !important;\n    width: 3.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-3hx svg {\n    height: 3.5rem !important;\n    width: 3.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-3tx svg {\n    height: 3.75rem !important;\n    width: 3.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-4x svg {\n    height: 4rem !important;\n    width: 4rem !important;\n  }\n  .svg-icon.svg-icon-xl-4qx svg {\n    height: 4.25rem !important;\n    width: 4.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-4hx svg {\n    height: 4.5rem !important;\n    width: 4.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-4tx svg {\n    height: 4.75rem !important;\n    width: 4.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-5x svg {\n    height: 5rem !important;\n    width: 5rem !important;\n  }\n  .svg-icon.svg-icon-xl-5qx svg {\n    height: 5.25rem !important;\n    width: 5.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-5hx svg {\n    height: 5.5rem !important;\n    width: 5.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-5tx svg {\n    height: 5.75rem !important;\n    width: 5.75rem !important;\n  }\n}\n@media (min-width: 1400px) {\n  .svg-icon.svg-icon-xxl-1 svg {\n    height: 1.75rem !important;\n    width: 1.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-2 svg {\n    height: 1.5rem !important;\n    width: 1.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-3 svg {\n    height: 1.35rem !important;\n    width: 1.35rem !important;\n  }\n  .svg-icon.svg-icon-xxl-4 svg {\n    height: 1.25rem !important;\n    width: 1.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-5 svg {\n    height: 1.15rem !important;\n    width: 1.15rem !important;\n  }\n  .svg-icon.svg-icon-xxl-6 svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-xxl-7 svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-xxl-8 svg {\n    height: 0.85rem !important;\n    width: 0.85rem !important;\n  }\n  .svg-icon.svg-icon-xxl-9 svg {\n    height: 0.75rem !important;\n    width: 0.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-10 svg {\n    height: 0.5rem !important;\n    width: 0.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-base svg {\n    height: 1rem !important;\n    width: 1rem !important;\n  }\n  .svg-icon.svg-icon-xxl-fluid svg {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .svg-icon.svg-icon-xxl-2x svg {\n    height: 2rem !important;\n    width: 2rem !important;\n  }\n  .svg-icon.svg-icon-xxl-2qx svg {\n    height: 2.25rem !important;\n    width: 2.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-2hx svg {\n    height: 2.5rem !important;\n    width: 2.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-2tx svg {\n    height: 2.75rem !important;\n    width: 2.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-3x svg {\n    height: 3rem !important;\n    width: 3rem !important;\n  }\n  .svg-icon.svg-icon-xxl-3qx svg {\n    height: 3.25rem !important;\n    width: 3.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-3hx svg {\n    height: 3.5rem !important;\n    width: 3.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-3tx svg {\n    height: 3.75rem !important;\n    width: 3.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-4x svg {\n    height: 4rem !important;\n    width: 4rem !important;\n  }\n  .svg-icon.svg-icon-xxl-4qx svg {\n    height: 4.25rem !important;\n    width: 4.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-4hx svg {\n    height: 4.5rem !important;\n    width: 4.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-4tx svg {\n    height: 4.75rem !important;\n    width: 4.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-5x svg {\n    height: 5rem !important;\n    width: 5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-5qx svg {\n    height: 5.25rem !important;\n    width: 5.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-5hx svg {\n    height: 5.5rem !important;\n    width: 5.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-5tx svg {\n    height: 5.75rem !important;\n    width: 5.75rem !important;\n  }\n}\n\n.timeline .timeline-item {\n  position: relative;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: flex-start;\n}\n.timeline .timeline-item:last-child .timeline-line {\n  bottom: 100%;\n}\n.timeline .timeline-line {\n  display: block;\n  content: \" \";\n  justify-content: center;\n  position: absolute;\n  z-index: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  transform: translate(50%);\n  border-left-width: 1px;\n  border-left-style: dashed;\n  border-left-color: #E4E6EF;\n}\n.timeline .timeline-icon {\n  z-index: 1;\n  flex-shrink: 0;\n  margin-right: 1rem;\n}\n.timeline .timeline-content {\n  width: 100%;\n  overflow: auto;\n  margin-bottom: 1.5rem;\n}\n.timeline.timeline-center .timeline-item {\n  align-items: center;\n}\n.timeline.timeline-center .timeline-item:first-child .timeline-line {\n  top: 50%;\n}\n.timeline.timeline-center .timeline-item:last-child .timeline-line {\n  bottom: 50%;\n}\n\n.overlay {\n  position: relative;\n}\n.overlay .overlay-layer {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n  opacity: 0;\n}\n.overlay.overlay-show .overlay-layer, .overlay.overlay-block .overlay-layer, .overlay:hover .overlay-layer {\n  transition: all 0.3s ease;\n  opacity: 1;\n}\n.overlay.overlay-block {\n  cursor: wait;\n}\n\n.bullet {\n  display: inline-block;\n  background-color: #B5B5C3;\n  border-radius: 6px;\n  width: 8px;\n  height: 4px;\n  flex-shrink: 0;\n}\n\n.bullet-dot {\n  width: 4px;\n  height: 4px;\n  border-radius: 100% !important;\n}\n\n.bullet-vertical {\n  width: 4px;\n  height: 8px;\n}\n\n.bullet-line {\n  width: 5px;\n  height: 1px;\n  border-radius: none;\n}\n\n.drawer {\n  display: flex !important;\n  overflow: auto;\n  z-index: 110;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  background-color: #ffffff;\n  transition: transform 0.3s ease-in-out;\n}\n.drawer.drawer-start {\n  left: 0;\n  transform: translateX(-100%);\n}\n.drawer.drawer-end {\n  right: 0;\n  transform: translateX(100%);\n}\n.drawer.drawer-on {\n  transform: none;\n  box-shadow: 0px 1px 9px -3px rgba(0, 0, 0, 0.05);\n  transition: transform 0.3s ease-in-out;\n}\n\n.drawer-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  overflow: hidden;\n  z-index: 109;\n  background-color: rgba(0, 0, 0, 0.2);\n  animation: animation-drawer-fade-in 0.3s ease-in-out 1;\n}\n\n[data-kt-drawer=true] {\n  display: none;\n}\n\n@keyframes animation-drawer-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@media (max-width: 991.98px) {\n  body[data-kt-drawer=on] {\n    overflow: hidden;\n  }\n}\n.badge.badge-circle, .badge.badge-square {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 1.75rem;\n  min-width: 1.75rem;\n  padding: 0 0.1rem;\n}\n.badge.badge-circle {\n  border-radius: 50%;\n  padding: 0;\n  min-width: unset;\n  width: 1.75rem;\n}\n.badge.badge-sm {\n  min-width: 1.5rem;\n  font-size: 0.85rem;\n}\n.badge.badge-sm.badge-circle {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n.badge.badge-lg {\n  min-width: 2rem;\n  font-size: 1rem;\n}\n.badge.badge-lg.badge-circle {\n  width: 2rem;\n  height: 2rem;\n}\n\n.badge-white {\n  color: #7E8299;\n  background-color: #ffffff;\n}\n\n.badge-light-white {\n  color: #ffffff;\n}\n\n.badge-light {\n  color: #7E8299;\n  background-color: #F5F8FA;\n}\n\n.badge-light-light {\n  color: #F5F8FA;\n}\n\n.badge-primary {\n  color: #FFFFFF;\n  background-color: #009EF7;\n}\n\n.badge-light-primary {\n  color: #009EF7;\n  background-color: #F1FAFF;\n}\n\n.badge-secondary {\n  color: #3F4254;\n  background-color: #E4E6EF;\n}\n\n.badge-light-secondary {\n  color: #E4E6EF;\n}\n\n.badge-success {\n  color: #FFFFFF;\n  background-color: #50CD89;\n}\n\n.badge-light-success {\n  color: #50CD89;\n  background-color: #E8FFF3;\n}\n\n.badge-info {\n  color: #FFFFFF;\n  background-color: #7239EA;\n}\n\n.badge-light-info {\n  color: #7239EA;\n  background-color: #F8F5FF;\n}\n\n.badge-warning {\n  color: #FFFFFF;\n  background-color: #FFC700;\n}\n\n.badge-light-warning {\n  color: #FFC700;\n  background-color: #FFF8DD;\n}\n\n.badge-danger {\n  color: #FFFFFF;\n  background-color: #F1416C;\n}\n\n.badge-light-danger {\n  color: #F1416C;\n  background-color: #FFF5F8;\n}\n\n.badge-dark {\n  color: #ffffff;\n  background-color: #181C32;\n}\n\n.badge-light-dark {\n  color: #181C32;\n  background-color: #EFF2F5;\n}\n\n.indicator-progress {\n  display: none;\n}\n[data-kt-indicator=on] > .indicator-progress {\n  display: inline-block;\n}\n\n[data-kt-indicator=on] > .indicator-label {\n  display: none;\n}\n\n.rotate {\n  display: inline-flex;\n  align-items: center;\n}\n\n.rotate-90 {\n  transition: transform 0.3s ease;\n  -webkit-backface-visibility: hidden;\n}\n.collapsible:not(.collapsed) > .rotate-90, .active > .rotate-90 {\n  transform: rotateZ(90deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-90, [direction=rtl] .active > .rotate-90 {\n  transform: rotateZ(-90deg);\n}\n\n.rotate-n90 {\n  transition: transform 0.3s ease;\n  -webkit-backface-visibility: hidden;\n}\n.collapsible:not(.collapsed) > .rotate-n90, .active > .rotate-n90 {\n  transform: rotateZ(-90deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-n90, [direction=rtl] .active > .rotate-n90 {\n  transform: rotateZ(90deg);\n}\n\n.rotate-180 {\n  transition: transform 0.3s ease;\n  -webkit-backface-visibility: hidden;\n}\n.collapsible:not(.collapsed) > .rotate-180, .active > .rotate-180 {\n  transform: rotateZ(180deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-180, [direction=rtl] .active > .rotate-180 {\n  transform: rotateZ(-180deg);\n}\n\n.rotate-n180 {\n  transition: transform 0.3s ease;\n  -webkit-backface-visibility: hidden;\n}\n.collapsible:not(.collapsed) > .rotate-n180, .active > .rotate-n180 {\n  transform: rotateZ(-180deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-n180, [direction=rtl] .active > .rotate-n180 {\n  transform: rotateZ(180deg);\n}\n\n.rotate-270 {\n  transition: transform 0.3s ease;\n  -webkit-backface-visibility: hidden;\n}\n.collapsible:not(.collapsed) > .rotate-270, .active > .rotate-270 {\n  transform: rotateZ(270deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-270, [direction=rtl] .active > .rotate-270 {\n  transform: rotateZ(-270deg);\n}\n\n.rotate-n270 {\n  transition: transform 0.3s ease;\n  -webkit-backface-visibility: hidden;\n}\n.collapsible:not(.collapsed) > .rotate-n270, .active > .rotate-n270 {\n  transform: rotateZ(-270deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-n270, [direction=rtl] .active > .rotate-n270 {\n  transform: rotateZ(270deg);\n}\n\n@media (min-width: 992px) {\n  main,\nspan,\nol,\nul,\npre,\ndiv {\n    scrollbar-width: thin;\n    scrollbar-color: #EFF2F5 transparent;\n  }\n  main::-webkit-scrollbar,\nspan::-webkit-scrollbar,\nol::-webkit-scrollbar,\nul::-webkit-scrollbar,\npre::-webkit-scrollbar,\ndiv::-webkit-scrollbar {\n    width: 0.4rem;\n    height: 0.4rem;\n  }\n  main::-webkit-scrollbar-thumb,\nspan::-webkit-scrollbar-thumb,\nol::-webkit-scrollbar-thumb,\nul::-webkit-scrollbar-thumb,\npre::-webkit-scrollbar-thumb,\ndiv::-webkit-scrollbar-thumb {\n    background-color: #EFF2F5;\n  }\n  main:hover,\nspan:hover,\nol:hover,\nul:hover,\npre:hover,\ndiv:hover {\n    scrollbar-color: #e9edf1 transparent;\n  }\n  main:hover::-webkit-scrollbar-thumb,\nspan:hover::-webkit-scrollbar-thumb,\nol:hover::-webkit-scrollbar-thumb,\nul:hover::-webkit-scrollbar-thumb,\npre:hover::-webkit-scrollbar-thumb,\ndiv:hover::-webkit-scrollbar-thumb {\n    background-color: #e9edf1;\n  }\n}\n.scroll {\n  overflow: scroll;\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .scroll {\n    overflow: auto;\n  }\n}\n\n.scroll-x {\n  overflow-x: scroll;\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .scroll-x {\n    overflow-x: auto;\n  }\n}\n\n.scroll-y {\n  overflow-y: scroll;\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .scroll-y {\n    overflow-y: auto;\n  }\n}\n\n.hover-scroll {\n  position: relative;\n}\n@media (min-width: 992px) {\n  .hover-scroll {\n    overflow: hidden;\n    border-right: 0.4rem solid transparent;\n    border-bottom: 0.4rem solid transparent;\n    margin-right: -0.4rem;\n    margin-bottom: -0.4rem;\n  }\n  .hover-scroll:hover {\n    overflow: scroll;\n    border-right: 0;\n    border-bottom: 0;\n  }\n  @-moz-document url-prefix() {\n    .hover-scroll {\n      overflow: scroll;\n      position: relative;\n      border-right: 0;\n      border-bottom: 0;\n    }\n  }\n}\n@media (max-width: 991.98px) {\n  .hover-scroll {\n    overflow: auto;\n  }\n}\n\n.hover-scroll-y {\n  position: relative;\n}\n@media (min-width: 992px) {\n  .hover-scroll-y {\n    overflow-y: hidden;\n    border-right: 0.4rem solid transparent;\n    margin-right: -0.4rem;\n  }\n  .hover-scroll-y:hover {\n    overflow-y: scroll;\n    border-right: 0;\n  }\n  @-moz-document url-prefix() {\n    .hover-scroll-y {\n      overflow-y: scroll;\n      position: relative;\n      border-right: 0;\n    }\n  }\n}\n@media (max-width: 991.98px) {\n  .hover-scroll-y {\n    overflow-y: auto;\n  }\n}\n\n.hover-scroll-x {\n  position: relative;\n}\n@media (min-width: 992px) {\n  .hover-scroll-x {\n    overflow-x: hidden;\n    border-bottom: 0.4rem solid transparent;\n  }\n  .hover-scroll-x:hover {\n    overflow-x: scroll;\n    border-bottom: 0;\n  }\n  @-moz-document url-prefix() {\n    .hover-scroll-x {\n      overflow-x: scroll;\n      position: relative;\n      border-bottom: 0;\n    }\n  }\n}\n@media (max-width: 991.98px) {\n  .hover-scroll-x {\n    overflow-x: auto;\n  }\n}\n\n.hover-scroll-overlay-y {\n  overflow-y: hidden;\n  position: relative;\n  --scrollbar-space: 0.5rem;\n}\n.hover-scroll-overlay-y::-webkit-scrollbar {\n  width: calc(0.4rem + var(--scrollbar-space));\n}\n.hover-scroll-overlay-y::-webkit-scrollbar-thumb {\n  background-clip: content-box;\n  border-right: var(--scrollbar-space) solid transparent;\n}\n.hover-scroll-overlay-y:hover {\n  overflow-y: overlay;\n}\n@-moz-document url-prefix() {\n  .hover-scroll-overlay-y {\n    overflow-y: scroll;\n    position: relative;\n  }\n}\n\n.scroll-ps {\n  padding-left: 0.4rem !important;\n}\n\n.scroll-ms {\n  margin-left: 0.4rem !important;\n}\n\n.scroll-pe {\n  padding-right: 0.4rem !important;\n}\n\n.scroll-me {\n  margin-right: 0.4rem !important;\n}\n\n.scroll-px {\n  padding-left: 0.4rem !important;\n  padding-right: 0.4rem !important;\n}\n\n.scroll-mx {\n  margin-left: 0.4rem !important;\n  margin-right: 0.4rem !important;\n}\n\n.rating {\n  display: flex;\n  align-items: center;\n}\n\n.rating-input {\n  position: absolute !important;\n  left: -9999px !important;\n}\n.rating-input[disabled] {\n  display: none;\n}\n\n.rating-label {\n  padding: 0;\n  margin: 0;\n}\n.rating-label > i {\n  line-height: 1;\n  color: #B5B5C3;\n}\n.rating-label > .svg-icon {\n  line-height: 1;\n}\n.rating-label > .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #B5B5C3;\n}\n.rating-label > .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\nlabel.rating-label {\n  cursor: pointer;\n}\n\ndiv.rating-label.checked > i,\nlabel.rating-label > i {\n  color: #FFAD0F;\n}\ndiv.rating-label.checked > .svg-icon svg [fill]:not(.permanent):not(g),\nlabel.rating-label > .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFAD0F;\n}\ndiv.rating-label.checked > .svg-icon svg:hover [fill]:not(.permanent):not(g),\nlabel.rating-label > .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.rating-input:checked ~ .rating-label > i {\n  color: #B5B5C3;\n}\n\n.rating-input:checked ~ .rating-label > .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #B5B5C3;\n}\n.rating-input:checked ~ .rating-label > .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.rating:hover label.rating-label > i {\n  color: #FFAD0F;\n}\n\n.rating:hover label.rating-label > .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #FFAD0F;\n}\n.rating:hover label.rating-label > .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\nlabel.rating-label:hover ~ .rating-label > i {\n  color: #B5B5C3;\n}\n\nlabel.rating-label:hover ~ .rating-label > .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #B5B5C3;\n}\nlabel.rating-label:hover ~ .rating-label > .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.stepper [data-kt-stepper-element=info],\n.stepper [data-kt-stepper-element=content] {\n  display: none;\n}\n.stepper [data-kt-stepper-element=info].current,\n.stepper [data-kt-stepper-element=content].current {\n  display: flex;\n}\n.stepper .stepper-item[data-kt-stepper-action=step] {\n  cursor: pointer;\n}\n.stepper [data-kt-stepper-action=previous] {\n  display: none;\n}\n.stepper [data-kt-stepper-action=next] {\n  display: inline-block;\n}\n.stepper [data-kt-stepper-action=submit] {\n  display: none;\n}\n.stepper.first [data-kt-stepper-action=previous] {\n  display: none;\n}\n.stepper.first [data-kt-stepper-action=next] {\n  display: inline-block;\n}\n.stepper.first [data-kt-stepper-action=submit] {\n  display: none;\n}\n.stepper.between [data-kt-stepper-action=previous] {\n  display: inline-block;\n}\n.stepper.between [data-kt-stepper-action=next] {\n  display: inline-block;\n}\n.stepper.between [data-kt-stepper-action=submit] {\n  display: none;\n}\n.stepper.last [data-kt-stepper-action=previous] {\n  display: inline-block;\n}\n.stepper.last [data-kt-stepper-action=next] {\n  display: none;\n}\n.stepper.last [data-kt-stepper-action=submit] {\n  display: inline-block;\n}\n.stepper.last [data-kt-stepper-action=submit].btn-flex {\n  display: flex;\n}\n\n.stepper.stepper-pills .stepper-nav {\n  display: flex;\n}\n.stepper.stepper-pills .stepper-item {\n  display: flex;\n  align-items: center;\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.stepper.stepper-pills .stepper-item .stepper-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s ease, background-color 0.2s ease;\n  width: 40px;\n  height: 40px;\n  border-radius: 0.475rem;\n  background-color: #F1FAFF;\n  margin-right: 1.5rem;\n}\n.stepper.stepper-pills .stepper-item .stepper-icon .stepper-check {\n  display: none;\n  font-size: 1rem;\n}\n.stepper.stepper-pills .stepper-item .stepper-icon .stepper-number {\n  font-weight: 600;\n  color: #009EF7 !important;\n  font-size: 1.25rem;\n}\n.stepper.stepper-pills .stepper-item .stepper-label {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.stepper.stepper-pills .stepper-item .stepper-label .stepper-title {\n  color: #3F4254;\n  font-weight: 600;\n  font-size: 1.25rem;\n  margin-bottom: 0.3rem;\n}\n.stepper.stepper-pills .stepper-item .stepper-label .stepper-desc {\n  color: #A1A5B7;\n}\n.stepper.stepper-pills .stepper-item.current {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.stepper.stepper-pills .stepper-item.current .stepper-icon {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: #009EF7;\n}\n.stepper.stepper-pills .stepper-item.current .stepper-icon .stepper-check {\n  color: #009EF7;\n  display: none;\n}\n.stepper.stepper-pills .stepper-item.current .stepper-icon .stepper-number {\n  color: #ffffff !important;\n  font-size: 1.35rem;\n}\n.stepper.stepper-pills .stepper-item.current .stepper-label .stepper-title {\n  color: #7E8299;\n}\n.stepper.stepper-pills .stepper-item.current .stepper-label .stepper-desc {\n  color: #B5B5C3;\n}\n.stepper.stepper-pills .stepper-item.current:last-child .stepper-icon, .stepper.stepper-pills .stepper-item.completed .stepper-icon {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: #F1FAFF;\n}\n.stepper.stepper-pills .stepper-item.current:last-child .stepper-icon .stepper-check, .stepper.stepper-pills .stepper-item.completed .stepper-icon .stepper-check {\n  color: #009EF7 !important;\n  display: inline-block;\n}\n.stepper.stepper-pills .stepper-item.current:last-child .stepper-icon .stepper-number, .stepper.stepper-pills .stepper-item.completed .stepper-icon .stepper-number {\n  display: none;\n}\n.stepper.stepper-pills .stepper-item.current:last-child .stepper-label .stepper-title, .stepper.stepper-pills .stepper-item.completed .stepper-label .stepper-title {\n  color: #A1A5B7;\n}\n.stepper.stepper-pills .stepper-item.current:last-child .stepper-label .stepper-desc, .stepper.stepper-pills .stepper-item.completed .stepper-label .stepper-desc {\n  color: #B5B5C3;\n}\n.stepper.stepper-pills.stepper-column .stepper-nav {\n  flex-direction: column;\n}\n.stepper.stepper-pills.stepper-column .stepper-item {\n  position: relative;\n  padding: 0;\n  margin: 0;\n  padding-bottom: 2.5rem;\n}\n.stepper.stepper-pills.stepper-column .stepper-icon {\n  z-index: 1;\n}\n.stepper.stepper-pills.stepper-column .stepper-line {\n  display: block;\n  content: \" \";\n  justify-content: center;\n  position: absolute;\n  z-index: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 40px;\n  transform: translate(50%);\n  border-left-width: 1px;\n  border-left-style: dashed;\n  border-left-color: #E4E6EF;\n}\n.stepper.stepper-pills.stepper-column .stepper-item:first-child .stepper-line {\n  top: 50%;\n}\n.stepper.stepper-pills.stepper-column .stepper-item:last-child .stepper-line {\n  bottom: 50%;\n}\n\n.toggle.collapsible:not(.collapsed) .toggle-off, .toggle.active .toggle-off {\n  display: none;\n}\n.toggle.collapsible.collapsed .toggle-on, .toggle:not(.collapsible):not(.active) .toggle-on {\n  display: none;\n}\n\n.xehagon {\n  clip-path: polygon(45% 1.3397459622%, 46.5797985667% 0.6030737921%, 48.2635182233% 0.1519224699%, 50% 0%, 51.7364817767% 0.1519224699%, 53.4202014333% 0.6030737921%, 55% 1.3397459622%, 89.6410161514% 21.3397459622%, 91.0688922482% 22.3395555688%, 92.3014605826% 23.5721239031%, 93.3012701892% 25%, 94.0379423592% 26.5797985667%, 94.4890936815% 28.2635182233%, 94.6410161514% 30%, 94.6410161514% 70%, 94.4890936815% 71.7364817767%, 94.0379423592% 73.4202014333%, 93.3012701892% 75%, 92.3014605826% 76.4278760969%, 91.0688922482% 77.6604444312%, 89.6410161514% 78.6602540378%, 55% 98.6602540378%, 53.4202014333% 99.3969262079%, 51.7364817767% 99.8480775301%, 50% 100%, 48.2635182233% 99.8480775301%, 46.5797985667% 99.3969262079%, 45% 98.6602540378%, 10.3589838486% 78.6602540378%, 8.9311077518% 77.6604444312%, 7.6985394174% 76.4278760969%, 6.6987298108% 75%, 5.9620576408% 73.4202014333%, 5.5109063185% 71.7364817767%, 5.3589838486% 70%, 5.3589838486% 30%, 5.5109063185% 28.2635182233%, 5.9620576408% 26.5797985667%, 6.6987298108% 25%, 7.6985394174% 23.5721239031%, 8.9311077518% 22.3395555688%, 10.3589838486% 21.3397459622%);\n}\n\n.octagon {\n  clip-path: polygon(46.1731656763% 0.7612046749%, 47.411809549% 0.3407417371%, 48.6947380778% 0.0855513863%, 50% 0%, 51.3052619222% 0.0855513863%, 52.588190451% 0.3407417371%, 53.8268343237% 0.7612046749%, 82.1111055711% 12.4769334274%, 83.2842712475% 13.0554747147%, 84.3718855375% 13.7821953496%, 85.3553390593% 14.6446609407%, 86.2178046504% 15.6281144625%, 86.9445252853% 16.7157287525%, 87.5230665726% 17.8888944289%, 99.2387953251% 46.1731656763%, 99.6592582629% 47.411809549%, 99.9144486137% 48.6947380778%, 100% 50%, 99.9144486137% 51.3052619222%, 99.6592582629% 52.588190451%, 99.2387953251% 53.8268343237%, 87.5230665726% 82.1111055711%, 86.9445252853% 83.2842712475%, 86.2178046504% 84.3718855375%, 85.3553390593% 85.3553390593%, 84.3718855375% 86.2178046504%, 83.2842712475% 86.9445252853%, 82.1111055711% 87.5230665726%, 53.8268343237% 99.2387953251%, 52.588190451% 99.6592582629%, 51.3052619222% 99.9144486137%, 50% 100%, 48.6947380778% 99.9144486137%, 47.411809549% 99.6592582629%, 46.1731656763% 99.2387953251%, 17.8888944289% 87.5230665726%, 16.7157287525% 86.9445252853%, 15.6281144625% 86.2178046504%, 14.6446609407% 85.3553390593%, 13.7821953496% 84.3718855375%, 13.0554747147% 83.2842712475%, 12.4769334274% 82.1111055711%, 0.7612046749% 53.8268343237%, 0.3407417371% 52.588190451%, 0.0855513863% 51.3052619222%, 0% 50%, 0.0855513863% 48.6947380778%, 0.3407417371% 47.411809549%, 0.7612046749% 46.1731656763%, 12.4769334274% 17.8888944289%, 13.0554747147% 16.7157287525%, 13.7821953496% 15.6281144625%, 14.6446609407% 14.6446609407%, 15.6281144625% 13.7821953496%, 16.7157287525% 13.0554747147%, 17.8888944289% 12.4769334274%);\n}\n\n.ribbon {\n  position: relative;\n}\n.ribbon .ribbon-label {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5px 10px;\n  position: absolute;\n  z-index: 1;\n  background-color: #009EF7;\n  box-shadow: 0px -1px 5px 0px rgba(0, 0, 0, 0.1);\n  color: #FFFFFF;\n  top: 50%;\n  right: 0;\n  transform: translateX(5px) translateY(-50%);\n}\n.ribbon .ribbon-label > .ribbon-inner {\n  z-index: -1;\n  position: absolute;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n.ribbon .ribbon-label:after {\n  border-color: #003c5e;\n}\n.ribbon-vertical .ribbon-label {\n  padding: 5px 10px;\n  min-width: 36px;\n  min-height: 46px;\n  text-align: center;\n}\n.ribbon.ribbon-top .ribbon-label {\n  top: 0;\n  transform: translateX(-15px) translateY(-4px);\n  border-bottom-right-radius: 0.475rem;\n  border-bottom-left-radius: 0.475rem;\n}\n.ribbon.ribbon-bottom .ribbon-label {\n  border-top-right-radius: 0.475rem;\n  border-top-left-radius: 0.475rem;\n}\n.ribbon.ribbon-start .ribbon-label {\n  top: 50%;\n  left: 0;\n  right: auto;\n  transform: translateX(-5px) translateY(-50%);\n  border-top-right-radius: 0.475rem;\n  border-bottom-right-radius: 0.475rem;\n}\n.ribbon.ribbon-end .ribbon-label {\n  border-top-left-radius: 0.475rem;\n  border-bottom-left-radius: 0.475rem;\n}\n\n.ribbon.ribbon-clip.ribbon-start .ribbon-label {\n  left: -5px;\n}\n.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner {\n  border-top-right-radius: 0.475rem;\n  border-bottom-right-radius: 0.475rem;\n}\n.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:before, .ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:after {\n  content: \"\";\n  position: absolute;\n  border-style: solid;\n  border-color: transparent !important;\n  bottom: -10px;\n}\n.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:before {\n  border-width: 0 10px 10px 0;\n  border-right-color: #181C32 !important;\n  left: 0;\n}\n.ribbon.ribbon-clip.ribbon-end .ribbon-label {\n  right: -5px;\n}\n.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner {\n  border-top-left-radius: 0.475rem;\n  border-bottom-left-radius: 0.475rem;\n}\n.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:before, .ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:after {\n  content: \"\";\n  position: absolute;\n  border-style: solid;\n  border-color: transparent !important;\n  bottom: -10px;\n}\n.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:before {\n  border-width: 0 0 10px 10px;\n  border-left-color: #181C32 !important;\n  right: 0;\n}\n\n.ribbon.ribbon-triangle {\n  position: absolute;\n  z-index: 1;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.ribbon.ribbon-triangle.ribbon-top-start {\n  top: 0;\n  left: 0;\n  width: 4rem;\n  height: 4rem;\n  border-bottom: solid 2rem transparent !important;\n  border-left: solid 2rem red;\n  border-right: solid 2rem transparent !important;\n  border-top: solid 2rem red;\n}\n.ribbon.ribbon-triangle.ribbon-top-end {\n  top: 0;\n  right: 0;\n  width: 4rem;\n  height: 4rem;\n  border-bottom: solid 2rem transparent !important;\n  border-left: solid 2rem transparent !important;\n  border-right: solid 2rem red;\n  border-top: solid 2rem red;\n}\n.ribbon.ribbon-triangle.ribbon-bottom-start {\n  bottom: 0;\n  left: 0;\n  width: 4rem;\n  height: 4rem;\n  border-bottom: solid 2rem red;\n  border-left: solid 2rem red;\n  border-right: solid 2rem transparent !important;\n  border-top: solid 2rem transparent !important;\n}\n.ribbon.ribbon-triangle.ribbon-bottom-end {\n  bottom: 0;\n  right: 0;\n  width: 4rem;\n  height: 4rem;\n  border-bottom: solid 2rem red;\n  border-right: solid 2rem red;\n  border-left: solid 2rem transparent !important;\n  border-top: solid 2rem transparent !important;\n}\n\n.blockui {\n  position: relative;\n}\n.blockui .blockui-overlay {\n  transition: all 0.3s ease;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.05);\n}\n.blockui .blockui-overlay .spinner-border {\n  height: 1.35rem;\n  width: 1.35rem;\n}\n.blockui .blockui-message {\n  display: flex;\n  align-items: center;\n  border-radius: 0.475rem;\n  box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  background-color: #ffffff;\n  color: #7E8299;\n  font-weight: 500;\n  margin: 0 !important;\n  width: auto;\n  padding: 0.85rem 1.75rem !important;\n}\n.blockui .blockui-message .spinner-border {\n  margin-right: 0.65rem;\n}\n\n.explore-btn-toggle {\n  color: #7E8299;\n  background-color: #ffffff;\n}\n.explore-btn-toggle:hover, .explore-btn-toggle:focus, .explore-btn-toggle:active {\n  color: #ffffff;\n  background-color: #00B2FF;\n}\n\n.explore-btn-dismiss {\n  border: 0;\n}\n.explore-btn-dismiss:hover i {\n  color: #00B2FF;\n}\n.explore-btn-dismiss:hover .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #00B2FF;\n}\n.explore-btn-dismiss:hover .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.explore-btn-primary {\n  border: 0;\n  color: #ffffff;\n  background-color: #00B2FF;\n}\n.explore-btn-primary:hover {\n  color: #ffffff;\n  background-color: #0098DA;\n}\n\n.explore-btn-secondary {\n  border: 0;\n  color: #7E8299;\n  background-color: #F5F8FA;\n}\n.explore-btn-secondary:hover {\n  color: #3F4254;\n  background-color: #EFF2F5;\n}\n\n.explore-btn-outline {\n  border: 1px dashed #E4E6EF !important;\n}\n.explore-btn-outline:hover, .explore-btn-outline.active {\n  border: 1px dashed #50CD89 !important;\n  background-color: #E8FFF3;\n}\n\n.explore-link {\n  color: #00B2FF;\n}\n.explore-link:hover {\n  color: #0098DA;\n}\n\n.explore-link-hover:hover {\n  color: #00B2FF !important;\n}\n\n.explore-icon-success {\n  color: #50CD89;\n}\n.explore-icon-success svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #50CD89;\n}\n.explore-icon-success svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.explore-icon-danger {\n  color: #F1416C;\n}\n.explore-icon-danger svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #F1416C;\n}\n.explore-icon-danger svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n\n.explore-label-free {\n  color: #ffffff;\n  background-color: #FFC700;\n}\n\n.explore-label-pro {\n  color: #ffffff;\n  background-color: #50CD89;\n}\n\n.cookiealert {\n  background: inherit;\n  color: inherit;\n}\n\n.stepper.stepper-links .stepper-nav {\n  display: flex;\n  margin: 0 auto;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.stepper.stepper-links .stepper-nav .stepper-item {\n  position: relative;\n  flex-shrink: 0;\n  margin: 1rem 1.5rem;\n}\n.stepper.stepper-links .stepper-nav .stepper-item:after {\n  content: \" \";\n  position: absolute;\n  top: 2.3rem;\n  left: 0;\n  height: 2px;\n  width: 100%;\n  background-color: transparent;\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.stepper.stepper-links .stepper-nav .stepper-item .stepper-title {\n  color: #181C32;\n  font-weight: 600;\n  font-size: 1.25rem;\n}\n.stepper.stepper-links .stepper-nav .stepper-item.current {\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.stepper.stepper-links .stepper-nav .stepper-item.current .stepper-title {\n  color: #009EF7;\n}\n.stepper.stepper-links .stepper-nav .stepper-item.current:after {\n  background-color: #009EF7;\n}\n.stepper.stepper-links .stepper-nav .stepper-item.completed .stepper-title {\n  color: #B5B5C3;\n}\n\n.timeline-label {\n  position: relative;\n}\n.timeline-label:before {\n  content: \"\";\n  position: absolute;\n  left: 51px;\n  width: 3px;\n  top: 0;\n  bottom: 0;\n  background-color: #EFF2F5;\n}\n.timeline-label .timeline-item {\n  display: flex;\n  align-items: flex-start;\n  position: relative;\n  margin-bottom: 1.7rem;\n}\n.timeline-label .timeline-item:last-child {\n  margin-bottom: 0;\n}\n.timeline-label .timeline-label {\n  width: 50px;\n  flex-shrink: 0;\n  position: relative;\n  color: #3F4254;\n}\n.timeline-label .timeline-badge {\n  flex-shrink: 0;\n  background: #ffffff;\n  width: 1rem;\n  height: 1rem;\n  border-radius: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n  position: relative;\n  margin-top: 1px;\n  margin-left: -0.5rem;\n  padding: 3px !important;\n  border: 6px solid #ffffff !important;\n}\n.timeline-label .timeline-badge span {\n  display: block;\n  border-radius: 100%;\n  width: 6px;\n  height: 6px;\n  background-color: #EFF2F5;\n}\n.timeline-label .timeline-content {\n  flex-grow: 1;\n}\n\n.placeholder-white-opacity-75::placeholder {\n  color: rgba(255, 255, 255, 0.75);\n}\n.placeholder-white-opacity-75::-moz-placeholder {\n  color: rgba(255, 255, 255, 0.75);\n  opacity: 1;\n}\n\n.item-border-hover {\n  border: 1px solid #fff;\n  border-radius: 6px;\n}\n.item-border-hover:hover {\n  border: 1px solid #EFF2F5;\n  cursor: pointer;\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: rgba(245, 248, 250, 0.3);\n}\n.item-border-hover:hover .label {\n  background-color: #00A3FF !important;\n  transition: color 0.2s ease, background-color 0.2s ease;\n  color: #fff;\n}\n.item-border-hover .label {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 6px;\n}\n\n.noUi-target.noUi-target-success .noUi-connects {\n  background: #E8FFF3;\n}\n.noUi-target.noUi-target-success .noUi-connects .noUi-connect {\n  background: #50CD89;\n}\n.noUi-target.noUi-target-success .noUi-handle {\n  border: 1px solid #50CD89;\n  box-shadow: 0 3px 6px -3px rgba(80, 205, 137, 0.7);\n  background: #50CD89;\n}\n\n.landing-dark-bg {\n  background-color: #13263C;\n}\n\n.landing-dark-color {\n  color: #13263C;\n}\n\n.landing-dark-border {\n  border: 1px dashed #2C3F5B;\n}\n\n.landing-dark-separator {\n  border-top: 1px dashed #2C3F5B;\n}\n\n.landing-curve {\n  position: relative;\n}\n.landing-curve svg {\n  position: relative;\n  top: 0;\n  display: block;\n}\n\n.landing-header {\n  display: flex;\n  align-items: center;\n  height: 100px;\n}\n.landing-header .logo-default {\n  display: block;\n}\n.landing-header .logo-sticky {\n  display: none;\n}\n.landing-header .menu .menu-link.active {\n  color: #ffffff;\n}\n[data-kt-sticky-landing-header=on] .landing-header .menu .menu-link.active {\n  color: #009EF7;\n  background-color: rgba(239, 242, 245, 0.4);\n}\n[data-kt-sticky-landing-header=on] .landing-header {\n  padding: 0;\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 100;\n  background-color: #ffffff;\n  box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);\n  height: 70px;\n}\n[data-kt-sticky-landing-header=on] .landing-header .logo-sticky {\n  display: block;\n}\n[data-kt-sticky-landing-header=on] .landing-header .logo-default {\n  display: none;\n}\n\nbody[data-kt-sticky-landing-header=on] {\n  padding-top: 100px;\n}\n\n@media (max-width: 991.98px) {\n  .landing-header {\n    height: 70px;\n  }\n  .landing-header .landing-menu-wrapper {\n    position: relative;\n    overflow: auto;\n  }\n  [data-kt-sticky-landing-header=on] .landing-header {\n    height: 70px;\n  }\n  .landing-header .menu .menu-link.active {\n    color: #009EF7;\n    background-color: rgba(239, 242, 245, 0.4);\n  }\n\n  body[data-kt-sticky-landing-header=on] {\n    padding-top: 70px;\n  }\n}\nhtml {\n  font-family: sans-serif;\n  text-size-adjust: 100%;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhtml,\nbody {\n  height: 100%;\n  margin: 0px;\n  padding: 0px;\n  font-size: 13px !important;\n  font-weight: 400;\n  font-family: Poppins, Helvetica, \"sans-serif\";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n@media (max-width: 991.98px) {\n  html,\nbody {\n    font-size: 13px !important;\n  }\n}\n@media (max-width: 767.98px) {\n  html,\nbody {\n    font-size: 12px !important;\n  }\n}\nhtml a:hover,\nhtml a:active,\nhtml a:focus,\nbody a:hover,\nbody a:active,\nbody a:focus {\n  text-decoration: none !important;\n}\n\nbody {\n  display: flex;\n  flex-direction: column;\n  color: #181C32;\n}\n\nrouter-outlet {\n  display: none;\n}\n\ncanvas {\n  user-select: none;\n}\n\n@media print {\n  .print-content-only {\n    padding: 0 !important;\n    background: none !important;\n  }\n  .print-content-only .wrapper,\n.print-content-only .page,\n.print-content-only .page-title .content,\n.print-content-only .container,\n.print-content-only .container-xxl,\n.print-content-only .container-fluid,\n.print-content-only .container-sm,\n.print-content-only .container-md,\n.print-content-only .container-lg,\n.print-content-only .container-xl {\n    background: none !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n  .print-content-only .aside,\n.print-content-only .sidebar,\n.print-content-only .scrolltop,\n.print-content-only .header,\n.print-content-only .footer,\n.print-content-only .toolbar,\n.print-content-only .drawer,\n.print-content-only .btn {\n    display: none !important;\n  }\n}\nbody {\n  background-color: #F5F8FA;\n}\n\n.text-page-bg {\n  color: #F5F8FA;\n}\n\n@media (min-width: 992px) {\n  .container,\n.container-xxl,\n.container-fluid,\n.container-sm,\n.container-md,\n.container-lg,\n.container-xl {\n    padding: 0 30px;\n  }\n\n  .wrapper {\n    transition: padding-left 0.3s ease, margin-right 0.3s ease;\n  }\n  .aside-enabled.aside-fixed .wrapper {\n    transition: padding-left 0.3s ease;\n    padding-left: 265px;\n  }\n  .aside-enabled.aside-fixed[data-kt-aside-minimize=on] .wrapper {\n    transition: padding-left 0.3s ease;\n    padding-left: 75px;\n  }\n  .header-fixed .wrapper {\n    padding-top: 65px;\n  }\n  .header-fixed.toolbar-fixed .wrapper {\n    padding-top: calc(65px + var(--kt-toolbar-height));\n  }\n}\n@media (max-width: 991.98px) {\n  .container,\n.container-xxl,\n.container-fluid,\n.container-sm,\n.container-md,\n.container-lg,\n.container-xl {\n    max-width: none;\n    padding: 0 15px;\n  }\n\n  .header-tablet-and-mobile-fixed .wrapper {\n    padding-top: 55px;\n  }\n  .header-tablet-and-mobile-fixed.toolbar-tablet-and-mobile-fixed .wrapper {\n    padding-top: calc(55px + var(--kt-toolbar-height-tablet-and-mobile));\n  }\n}\n@media (min-width: 992px) {\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n    z-index: 2;\n    height: 65px;\n    transition: left 0.3s ease;\n  }\n  .header-fixed .header {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 100;\n    background-color: #ffffff;\n    height: 65px;\n    padding: 0;\n    box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);\n  }\n  .header-fixed.toolbar-fixed .header {\n    box-shadow: none;\n  }\n  .aside-enabled.aside-fixed.header-fixed .header {\n    left: 265px;\n    transition: left 0.3s ease;\n  }\n  .aside-enabled.aside-fixed.header-fixed[data-kt-aside-minimize=on] .header {\n    left: 75px;\n    transition: left 0.3s ease;\n  }\n  .header .header-menu {\n    display: flex;\n  }\n}\n@media (max-width: 991.98px) {\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 55px;\n    position: relative;\n    z-index: 3;\n  }\n  .header-tablet-and-mobile-fixed .header {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 100;\n    height: 55px;\n    min-height: 55px;\n    background-color: #ffffff;\n    box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);\n  }\n  .header-tablet-and-mobile-fixed.toolbar-tablet-and-mobile-fixed .header {\n    box-shadow: none;\n  }\n  .header .header-menu {\n    display: none;\n    z-index: 99;\n  }\n  .header .page-title {\n    display: none !important;\n  }\n}\n.horizontal-scroll-wrapper {\n  position: absolute;\n  display: block;\n  top: 0;\n  left: 0;\n  width: 80px;\n  max-height: 500px;\n  margin: 0;\n  background: white;\n  overflow-y: auto;\n  overflow-x: hidden;\n  transform: rotate(-90deg) translateY(-80px);\n  transform-origin: right top;\n}\n\n.horizontal-scroll-wrapper > div {\n  display: block;\n  padding: 5px;\n  background: white;\n  transform: rotate(90deg);\n  transform-origin: right top;\n}\n\n.squares {\n  padding: 60px 0 0 0;\n}\n\n.squares > div {\n  width: 80px;\n  height: 60px;\n  margin: 10px;\n}\n\n.toolbar {\n  display: flex;\n  align-items: center;\n  background-color: #ffffff;\n  padding: 0.5rem 0;\n}\n\n@media (min-width: 992px) {\n  .toolbar-fixed .toolbar {\n    height: var(--kt-toolbar-height);\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 99;\n    box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);\n  }\n  .toolbar-enabled:not(.toolbar-fixed) .toolbar {\n    margin-bottom: 30px;\n  }\n  .header-fixed.toolbar-fixed .toolbar {\n    padding: 0;\n    top: 65px;\n    border-top: 1px solid #EFF2F5;\n  }\n  .aside-enabled.aside-fixed.toolbar-fixed .toolbar {\n    left: 265px;\n    transition: left 0.3s ease;\n  }\n  .aside-enabled.aside-fixed.toolbar-fixed[data-kt-aside-minimize=on] .toolbar {\n    left: 75px;\n    transition: left 0.3s ease;\n  }\n}\n@media (max-width: 991.98px) {\n  .toolbar-tablet-and-mobile-fixed .toolbar {\n    height: var(--kt-toolbar-height-tablet-and-mobile);\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 99;\n    box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);\n  }\n  .toolbar-enabled:not(.toolbar-tablet-and-mobile-fixed) .toolbar {\n    margin-bottom: 15px;\n  }\n  .header-tablet-and-mobile-fixed.toolbar-tablet-and-mobile-fixed .toolbar {\n    padding: 0;\n    top: 55px;\n    border-top: 1px solid #EFF2F5;\n  }\n  .toolbar .page-title[data-kt-swapper=true] {\n    display: none !important;\n  }\n}\n.aside {\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 0 28px 0 rgba(82, 63, 105, 0.05);\n  padding: 0;\n}\n.aside .btn-custom {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-left: 0;\n  padding-right: 0;\n}\n.aside .btn-custom .btn-label {\n  transition: opacity 0.3s ease;\n  display: inline-block;\n  white-space: nowrap;\n  overflow: hidden;\n  opacity: 1;\n}\n.aside .btn-custom .btn-icon {\n  display: inline-block;\n  transition: opacity 0.3s ease;\n  overflow: hidden;\n  opacity: 0;\n  margin: 0;\n  width: 0;\n}\n.aside.aside-dark {\n  background-color: #1e1e2d;\n}\n.aside.aside-dark .aside-logo {\n  background-color: #1a1a27;\n}\n.aside.aside-dark .aside-toggle svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #494b74;\n}\n.aside.aside-dark .aside-toggle svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.aside.aside-dark .separator {\n  border-bottom-color: #282a3d;\n}\n.aside.aside-dark .btn-custom {\n  color: #B5B5C3;\n  background-color: rgba(63, 66, 84, 0.35);\n}\n.btn-check:checked + .aside.aside-dark .btn-custom, .btn-check:active + .aside.aside-dark .btn-custom, .aside.aside-dark .btn-custom:focus:not(.btn-active), .aside.aside-dark .btn-custom:hover:not(.btn-active), .aside.aside-dark .btn-custom:active:not(.btn-active), .aside.aside-dark .btn-custom.active, .aside.aside-dark .btn-custom.show, .show > .aside.aside-dark .btn-custom {\n  color: #B5B5C3;\n  background-color: rgba(63, 66, 84, 0.35) !important;\n}\n.aside.aside-dark .btn-custom .btn-icon {\n  color: #B5B5C3;\n}\n.aside.aside-dark .btn-custom .btn-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #B5B5C3;\n}\n.aside.aside-dark .btn-custom .btn-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.aside.aside-light {\n  background-color: #ffffff;\n}\n\n@media (min-width: 992px) {\n  .aside {\n    width: 265px;\n    transition: width 0.3s ease;\n  }\n  .aside .aside-logo {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 65px;\n    padding: 0 25px;\n  }\n  .aside .aside-menu {\n    width: 265px;\n  }\n  .aside-fixed .aside {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 101;\n    overflow: hidden;\n  }\n  .aside-static .aside {\n    position: relative;\n    z-index: 1;\n  }\n  [data-kt-aside-minimize=on] .aside {\n    width: 75px;\n    transition: width 0.3s ease;\n  }\n  [data-kt-aside-minimize=on] .aside .aside-logo .logo-default {\n    display: inline-block;\n  }\n  [data-kt-aside-minimize=on] .aside .aside-logo .logo-minimize {\n    display: none;\n  }\n  [data-kt-aside-minimize=on] .aside.aside-hoverable:hover:not(.animating) {\n    transition: width 0.3s ease;\n    width: 265px;\n    box-shadow: 5px 0px 10px rgba(70, 78, 95, 0.075);\n  }\n  [data-kt-aside-minimize=on] .aside:not(.aside-hoverable) .aside-logo, [data-kt-aside-minimize=on] .aside:not(:hover) .aside-logo {\n    justify-content: center;\n  }\n  [data-kt-aside-minimize=on] .aside:not(.aside-hoverable) .aside-logo .logo, [data-kt-aside-minimize=on] .aside:not(:hover) .aside-logo .logo {\n    display: none;\n  }\n  [data-kt-aside-minimize=on] .aside:not(.aside-hoverable) .aside-logo .logo-default, [data-kt-aside-minimize=on] .aside:not(:hover) .aside-logo .logo-default {\n    display: none;\n  }\n  [data-kt-aside-minimize=on] .aside:not(.aside-hoverable) .aside-logo .logo-minimize, [data-kt-aside-minimize=on] .aside:not(:hover) .aside-logo .logo-minimize {\n    display: inline-block;\n  }\n  [data-kt-aside-minimize=on] .aside:not(.aside-hoverable) .aside-menu .menu-content,\n[data-kt-aside-minimize=on] .aside:not(.aside-hoverable) .aside-menu .menu-title, [data-kt-aside-minimize=on] .aside:not(:hover) .aside-menu .menu-content,\n[data-kt-aside-minimize=on] .aside:not(:hover) .aside-menu .menu-title {\n    opacity: 0;\n    transition: opacity 0.3s ease;\n  }\n  [data-kt-aside-minimize=on] .aside:not(.aside-hoverable) .aside-menu .menu-item.show > .menu-sub, [data-kt-aside-minimize=on] .aside:not(:hover) .aside-menu .menu-item.show > .menu-sub {\n    height: 0;\n    overflow: hidden;\n    transition: height 0.3s ease;\n  }\n  [data-kt-aside-minimize=on] .aside:not(.aside-hoverable) .btn-custom .btn-label, [data-kt-aside-minimize=on] .aside:not(:hover) .btn-custom .btn-label {\n    width: 0;\n    opacity: 0;\n    transition: opacity 0.3s ease;\n  }\n  [data-kt-aside-minimize=on] .aside:not(.aside-hoverable) .btn-custom .btn-icon, [data-kt-aside-minimize=on] .aside:not(:hover) .btn-custom .btn-icon {\n    width: auto;\n    opacity: 1;\n    transition: opacity 0.3s ease;\n  }\n}\n@media (max-width: 991.98px) {\n  .aside {\n    display: none;\n  }\n  .aside .aside-logo {\n    display: none;\n  }\n}\n.aside-menu .menu .menu-item .menu-link,\n.aside-menu .menu .menu-item .menu-content {\n  padding-left: 25px;\n  padding-right: 25px;\n}\n.aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: calc(0.75rem + 25px);\n}\n.aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: calc(1.5rem + 25px);\n}\n.aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: calc(2.25rem + 25px);\n}\n.aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: calc(3rem + 25px);\n}\n.menu-fit .aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-fit .aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: 0.75rem;\n  padding-right: 0;\n}\n.menu-fit .aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-fit .aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: calc(1.5rem);\n  padding-right: 0;\n}\n.menu-fit .aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-fit .aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: calc(2.25rem);\n  padding-right: 0;\n}\n.menu-fit .aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-fit .aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: calc(3rem);\n  padding-right: 0;\n}\n.aside-menu .menu-item {\n  padding: 0;\n}\n.aside-menu .menu-item .menu-link {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n.aside-menu .menu-item .menu-icon {\n  justify-content: flex-start;\n}\n\n.aside-dark .hover-scroll-overlay-y {\n  --scrollbar-space: 0.4rem;\n  scrollbar-color: #3b3b64 transparent;\n}\n.aside-dark .hover-scroll-overlay-y::-webkit-scrollbar-thumb {\n  background-color: #3b3b64;\n}\n.aside-dark .hover-scroll-overlay-y:hover {\n  scrollbar-color: #41416e transparent;\n}\n.aside-dark .hover-scroll-overlay-y:hover::-webkit-scrollbar-thumb {\n  background-color: #41416e;\n}\n.aside-dark .menu .menu-item .menu-section {\n  color: #b2b3c2 !important;\n}\n.aside-dark .menu .menu-item .menu-link {\n  color: #9899ac;\n}\n.aside-dark .menu .menu-item .menu-link .menu-title {\n  color: #9899ac;\n}\n.aside-dark .menu .menu-item .menu-link .menu-icon i {\n  color: #494b74;\n}\n.aside-dark .menu .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #494b74;\n}\n.aside-dark .menu .menu-item .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.aside-dark .menu .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #9899ac;\n}\n.aside-dark .menu .menu-item .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%239899ac'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%239899ac'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.aside-dark .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .aside-dark .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: #1b1b28;\n  color: #ffffff;\n}\n.aside-dark .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .aside-dark .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: #ffffff;\n}\n.aside-dark .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .aside-dark .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: #009EF7;\n}\n.aside-dark .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g), .aside-dark .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.aside-dark .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g), .aside-dark .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.aside-dark .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .aside-dark .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n.aside-dark .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .aside-dark .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23ffffff'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23ffffff'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.aside-dark .menu .menu-item.here > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: #1b1b28;\n  color: #ffffff;\n}\n.aside-dark .menu .menu-item.here > .menu-link .menu-title {\n  color: #ffffff;\n}\n.aside-dark .menu .menu-item.here > .menu-link .menu-icon i {\n  color: #009EF7;\n}\n.aside-dark .menu .menu-item.here > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.aside-dark .menu .menu-item.here > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.aside-dark .menu .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n.aside-dark .menu .menu-item.here > .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23ffffff'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23ffffff'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.aside-dark .menu .menu-item.show > .menu-link {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: #1b1b28;\n  color: #ffffff;\n}\n.aside-dark .menu .menu-item.show > .menu-link .menu-title {\n  color: #ffffff;\n}\n.aside-dark .menu .menu-item.show > .menu-link .menu-icon i {\n  color: #009EF7;\n}\n.aside-dark .menu .menu-item.show > .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.aside-dark .menu .menu-item.show > .menu-link .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.aside-dark .menu .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n.aside-dark .menu .menu-item.show > .menu-link .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23ffffff'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23ffffff'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.aside-dark .menu .menu-item .menu-link.active {\n  transition: color 0.2s ease, background-color 0.2s ease;\n  background-color: #1b1b28;\n  color: #ffffff;\n}\n.aside-dark .menu .menu-item .menu-link.active .menu-title {\n  color: #ffffff;\n}\n.aside-dark .menu .menu-item .menu-link.active .menu-icon i {\n  color: #009EF7;\n}\n.aside-dark .menu .menu-item .menu-link.active .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n  fill: #009EF7;\n}\n.aside-dark .menu .menu-item .menu-link.active .menu-icon .svg-icon svg:hover [fill]:not(.permanent):not(g) {\n  transition: fill 0.3s ease;\n}\n.aside-dark .menu .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: #009EF7;\n}\n.aside-dark .menu .menu-item .menu-link.active .menu-arrow:after {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23ffffff'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='%23ffffff'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.aside-light .menu .menu-title {\n  font-weight: 500;\n}\n\n@media (min-width: 992px) {\n  .content {\n    padding: 30px 0;\n  }\n  .toolbar-enabled:not(.toolbar-fixed) .content {\n    padding-top: 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .content {\n    padding: 15px 0;\n  }\n  .toolbar-enabled:not(.toolbar-tablet-and-mobile-fixed) .content {\n    padding-top: 0;\n  }\n}\n.footer {\n  background-color: #ffffff;\n}\n\n@media print {\n  .print-content-only {\n    padding: 0 !important;\n    background: none !important;\n  }\n  .print-content-only .docs-wrapper,\n.print-content-only .docs-page,\n.print-content-only .docs-page-title .docs-content,\n.print-content-only .container,\n.print-content-only .container-fluid,\n.print-content-only .container-sm,\n.print-content-only .container-md,\n.print-content-only .container-lg,\n.print-content-only .container-xl,\n.print-content-only .container-xxl {\n    background: none !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n  .print-content-only .docs-aside, .print-content-only docs- .scrolltop,\n.print-content-only .docs-header,\n.print-content-only .drawer,\n.print-content-only .btn {\n    display: none !important;\n  }\n}\n.docs-wrapper {\n  background-color: #F5F8FA;\n}\n\n@media (min-width: 992px) {\n  .container,\n.container-fluid,\n.container-sm,\n.container-md,\n.container-lg,\n.container-xl,\n.container-xxl {\n    padding: 0 30px;\n  }\n\n  .docs-wrapper {\n    padding-left: 265px;\n  }\n}\n@media (max-width: 991.98px) {\n  .container,\n.container-fluid,\n.container-sm,\n.container-md,\n.container-lg,\n.container-xl,\n.container-xxl {\n    max-width: none;\n    padding: 0 15px;\n  }\n}\n@media (min-width: 992px) {\n  .docs-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n@media (max-width: 991.98px) {\n  .docs-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .docs-header .docs-page-title[data-kt-swapper=true] {\n    display: none !important;\n  }\n}\n.docs-aside {\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 0 28px 0 rgba(82, 63, 105, 0.025);\n  background-color: #ffffff;\n  padding: 0;\n}\n\n@media (min-width: 992px) {\n  .docs-aside {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 101;\n    overflow: hidden;\n    width: 265px;\n  }\n  .docs-aside .docs-aside-logo {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 25px;\n  }\n  .docs-aside .docs-aside-menu {\n    width: 265px;\n  }\n}\n@media (max-width: 991.98px) {\n  .docs-aside {\n    display: none;\n  }\n  .docs-aside .docs-aside-logo {\n    display: none;\n  }\n}\n.docs-aside-menu .menu .menu-item .menu-link,\n.docs-aside-menu .menu .menu-item .menu-content {\n  padding-left: 25px;\n  padding-right: 25px;\n}\n.docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: calc(0.75rem + 25px);\n}\n.docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: calc(1.5rem + 25px);\n}\n.docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: calc(2.25rem + 25px);\n}\n.docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: calc(3rem + 25px);\n}\n.menu-fit .docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-fit .docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: 0.75rem;\n  padding-right: 0;\n}\n.menu-fit .docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-fit .docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: calc(1.5rem);\n  padding-right: 0;\n}\n.menu-fit .docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-fit .docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: calc(2.25rem);\n  padding-right: 0;\n}\n.menu-fit .docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-fit .docs-aside-menu .menu .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link {\n  padding-left: calc(3rem);\n  padding-right: 0;\n}\n.docs-aside-menu .menu-item {\n  padding: 0;\n}\n.docs-aside-menu .menu-item .menu-link {\n  font-weight: 500;\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n.docs-aside-menu .menu-item .menu-icon {\n  justify-content: flex-start;\n}\n\n.card.card-docs {\n  background-color: #ffffff;\n  border: 0;\n}","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.2 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG/#contrast-minimum\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(-1 * #{$pagination-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               var(--#{$prefix}body-color) !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n$carousel-control-icon-filter:       null !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default; // Deprecated in v5.3.4\n$carousel-dark-caption-color:        $black !default; // Deprecated in v5.3.4\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default; // Deprecated in v5.3.4\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-filter:           null !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default; // Deprecated in v5.3.4\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n\n  // Fix to prevent overflowing children to become focusable\n  * {\n    overflow: hidden !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/WAI/WCAG22/Techniques/general/G1.html\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","//\n// Main init file of global bootstrap and theme functions, mixins, variables and config\n//\n\n\n// Custom functions & mixins\n@import \"./core/base/functions\";\n@import \"./core/base/mixins\";\n@import \"./core/components/mixins\";\n@import \"./core/vendors/plugins/mixins\";\n\n\n// Custom variables\n@import \"components/variables.custom\";\n@import \"./core/components/variables\";\n\n\n// // Bootstrap initializaton\n// @import \"~bootstrap/scss/functions\";\n// @import \"~bootstrap/scss/variables\";\n// @import \"~bootstrap/scss/mixins\";\n// @import \"~bootstrap/scss/utilities\";\n@import \"~bootstrap/scss/functions\";\n@import \"~bootstrap/scss/variables\";\n@import \"~bootstrap/scss/maps\";\n@import \"~bootstrap/scss/mixins\";\n@import \"~bootstrap/scss/utilities\";\n@import \"~bootstrap/scss/helpers\";\n@import \"~bootstrap/scss/utilities/api\";\n\n\n// 3rd-Party plugins variables\n@import \"./core/vendors/plugins/variables\";\n\n\n// Custom layout variables\n@import \"layout/variables\";\n@import \"./core/layout/docs/variables\";\n\n\n\nbody > iframe[style*='2147483647']{\n    display: none;\n  }",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n  @include font-size($legend-font-size);\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n\n  // 3. Better affordance and consistent appearance for search cancel button\n  &::-webkit-search-cancel-button {\n    cursor: pointer;\n    filter: grayscale(1);\n  }\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","//\n// Global variables for Bootstrap customization.\n// To override any Bootstrap variable safely you can use _variables.demo.scss\n//\n\n// Bootstrap base colors\n$white:    \t\t\t\t\t\t\t\t\t\t\t#ffffff !default;\n$black:    \t\t\t\t\t\t\t\t\t\t\t#000000 !default;\n$gray-100: \t\t\t\t\t\t\t\t\t\t    if(isDarkMode(), #1b1b29, #F5F8FA) !default;\n$gray-200: \t\t\t\t\t\t\t\t\t\t    if(isDarkMode(), #2B2B40, #EFF2F5) !default;\n$gray-300: \t\t\t\t\t\t\t\t\t\t    if(isDarkMode(), #323248, #E4E6EF) !default;\n$gray-400: \t\t\t\t\t\t\t\t\t\t    if(isDarkMode(), #474761, #B5B5C3) !default;\n$gray-500: \t\t\t\t\t\t\t\t\t\t    if(isDarkMode(), #565674, #A1A5B7) !default;\n$gray-600: \t\t\t\t\t\t\t\t\t\t    if(isDarkMode(), #6D6D80, #7E8299) !default;\n$gray-700: \t\t\t\t\t\t\t\t\t\t    if(isDarkMode(), #92929F, #5E6278) !default;\n$gray-800: \t\t\t\t\t\t\t\t\t\t    if(isDarkMode(), #CDCDDE, #3F4254) !default;\n$gray-900: \t\t\t\t\t\t\t\t\t\t    if(isDarkMode(), #FFFFFF, #181C32) !default;\n$text-muted:                                        $gray-500 !default;\n\n// Dark Mode\n$dark-mode-page-bg-color:                           #151521 !default;\n\n// Bootstrap gray colors map\n$grays: (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n\t\"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n) !default; // Custom variable\n\n// Bootstrap custom colors\n$blue:                                             #009ef6 !default;\n$indigo:                                           #6610f2 !default;\n$purple:                                           #6f42c1 !default;\n$pink:                                             #d63384 !default;\n$red:                                              #dc3545 !default;\n$orange:                                           #fd7e14 !default;\n$yellow:                                           #ffc107 !default;\n$green:                                            #198754 !default;\n$teal:                                             #20c997 !default;\n$cyan:                                             #0dcaf0 !default;\n\n// Bootstrap colors map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n\n\n// Bootstrap contextual colors\n// Dark colors\n$dark:          \t\t\t\t\t\t\t\t\t$gray-900 !default; // Bootstrap variable\n$dark-active:          \t\t\t\t\t\t\t\tif(isDarkMode(), darken($gray-900, 9%), darken($gray-900, 3%)) !default;\n$dark-light:          \t\t\t\t\t\t\t    $gray-200 !default; // Custom variable\n$dark-inverse:         \t\t\t\t\t\t\t\tif(isDarkMode(), $gray-100, $white) !default; // Custom variable\n\n// Primary colors\n$primary:       \t\t\t\t\t\t\t\t\t#3699FF !default; // Bootstrap variable\n$primary-active:    \t\t\t\t\t\t\t\t#187DE4 !default; // Custom variable\n$primary-light:    \t\t\t\t\t\t\t\t    if(isDarkMode(), #212E48, #F1FAFF) !default; // Custom variable\n$primary-inverse:  \t\t\t\t\t\t\t\t\t$white !default;  // Custom variable\n\n// Secondary colors\n$secondary:     \t\t\t\t\t\t\t\t\t$gray-300 !default; // Bootstrap variable\n$secondary-active:  \t\t\t\t\t\t\t\t$gray-400 !default; // Custom variable\n$secondary-light:  \t\t\t\t\t\t\t\t\t$gray-100 !default; // Custom variable\n$secondary-inverse:\t\t\t\t\t\t\t\t\t$gray-800 !default; // Custom variable\n\n// Light colors\n$light:     \t\t\t\t\t\t\t\t\t    if(isDarkMode(),$gray-300, $gray-100) !default; // Bootstrap variable\n$light-active:  \t\t\t\t\t\t\t\t    if(isDarkMode(),$gray-400, $gray-200) !default; // Custom variable\n$light-inverse:\t\t\t\t\t\t\t\t\t    if(isDarkMode(),$gray-800, $gray-600) !default; // Custom variable\n$lighten:                                           rgba($light, 0.5); // Custom variable\n\n// Success colors\n$success:       \t\t\t\t\t\t\t\t\t#1BC5BD !default; // Bootstrap variable\n$success-active:    \t\t\t\t\t\t\t\t#0BB7AF !default; // Custom variable\n$success-light:    \t\t\t\t\t\t\t\t\tif(isDarkMode(), #1C3833, #C9F7F5) !default; // Custom variable\n$success-inverse:  \t\t\t\t\t\t\t\t\t$white !default; // Custom variable\n\n// Inco colors\n$info:         \t\t \t\t\t\t\t\t\t\t#8950FC !default; // Bootstrap variable\n$info-active:   \t\t \t\t\t\t\t\t\t#7337EE !default; // Custom variable\n$info-light:   \t\t \t\t\t\t\t\t\t\tif(isDarkMode(), #2F264F, #EEE5FF) !default; // Custom variable\n$info-inverse: \t\t \t\t\t\t\t\t\t\t$white !default; // Custom variable\n\n// Warning colors\n$warning:       \t\t\t\t\t\t\t\t\t#FFA800 !default; // Bootstrap variable\n$warning-active:    \t\t\t\t\t\t\t\t#EE9D01 !default; // Custom variable\n$warning-light:    \t\t\t\t\t\t\t\t\tif(isDarkMode(), #392F28, #FFF4DE) !default; // Custom variable\n$warning-inverse:  \t\t\t\t\t\t\t\t\t$white !default; // Custom variable\n\n// Danger colors\n$danger:        \t\t\t\t\t\t\t\t\t#F64E60 !default; // Bootstrap variable\n$danger-active:     \t\t\t\t\t\t\t\t#EE2D41 !default; // Custom variable\n$danger-light:     \t\t\t\t\t\t\t\t\tif(isDarkMode(), #3A2434, #FFE2E5) !default; // Custom variable\n$danger-inverse:   \t\t\t\t\t\t\t\t\t$white !default; // Custom variable\n\n// White colors\n$white:    \t\t\t\t\t\t\t\t\t\t\t$white !default; // Bootstrap variable\n$white-active:    \t\t\t\t\t\t\t\t\t$gray-100 !default; // Custom variable\n$white-inverse:    \t\t\t\t\t\t\t\t\t$gray-600 !default; // Custom variable\n\n\n// Theme colors\n$theme-colors: (\n\t\"white\":      $white,  // custom color type\n    \"light\":      $light,\n    \"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"dark\":       $dark\n) !default;\n\n// Hover colors\n$theme-active-colors: (\n\t\"white\":      $white-active,   // custom color type\n\t\"primary\":    $primary-active,\n    \"secondary\":  $secondary-active,\n    \"light\":      $light-active,\n    \"success\":    $success-active,\n    \"info\":       $info-active,\n    \"warning\":    $warning-active,\n    \"danger\":     $danger-active,\n    \"dark\":       $dark-active\n) !default;  // Custom variable\n\n// Inverse colors\n$theme-inverse-colors: (\n\t\"white\":      $white-inverse,\n\t\"primary\":    $primary-inverse,\n    \"secondary\":  $secondary-inverse,\n    \"light\":      $light-inverse,\n    \"success\":    $success-inverse,\n    \"info\":       $info-inverse,\n    \"warning\":    $warning-inverse,\n    \"danger\":     $danger-inverse,\n    \"dark\":       $dark-inverse\n) !default;  // Custom variable\n\n// Light colors\n$theme-light-colors: (\n\t\"primary\":    $primary-light,\n    \"success\":    $success-light,\n    \"info\":       $info-light,\n    \"warning\":    $warning-light,\n    \"danger\":     $danger-light,\n    \"dark\":       $dark-light\n) !default;  // Custom variable\n\n// Text colors\n$theme-text-colors: (\n    \"white\":      $white,\n\t\"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"light\":      $light,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"dark\":       $dark,\n    \"muted\":      $text-muted,\n    \"gray-100\":   $gray-100,\n    \"gray-200\":   $gray-200,\n    \"gray-300\":   $gray-300,\n    \"gray-400\":   $gray-400,\n    \"gray-500\":   $gray-500,\n    \"gray-600\":   $gray-600,\n    \"gray-700\":   $gray-700,\n    \"gray-800\":   $gray-800,\n    \"gray-900\":   $gray-900\n) !default;  // Custom variable\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n$enable-rounded: \t\t\t\t\t\t\t\t\ttrue !default;\n$enable-shadows:                              \t\ttrue !default;\n$enable-negative-margins:                           true !default;\n$enable-smooth-scroll:                              false !default;\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n$spacer: 1rem !default;\n\n// stylelint-disable-next-line scss/dollar-variable-default\n$spacers: (\n    0: 0,\n    1: ($spacer * .25),  \t// 3.5px\n    2: ($spacer * .5),   \t// 7px;\n\t3: ($spacer * .75),  \t// 10.5px\n\t4: ($spacer * 1),    \t// 14px\n\t5: ($spacer * 1.25), \t// 17.5px\n\t6: ($spacer * 1.5),  \t// 21px\n\t7: ($spacer * 1.75), \t// 24.5px\n\t8: ($spacer * 2),    \t// 28px\n\t9: ($spacer * 2.25), \t// 31.5px\n\t10: ($spacer * 2.5), \t// 35px\n\t11: ($spacer * 2.75),\t// 38.5px\n\t12: ($spacer * 3),   \t// 42px\n\t13: ($spacer * 3.25),\t// 45.5px\n\t14: ($spacer * 3.5), \t// 49px\n\t15: ($spacer * 3.75), \t// 52.5px\n\t16: ($spacer * 4), \t\t// 55px\n\t17: ($spacer * 4.25), \t// 58.5px\n\t18: ($spacer * 4.5), \t// 62px\n\t19: ($spacer * 4.75), \t// 65.5px\n\t20: ($spacer * 5), \t\t// 69px\n);\n\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n$position-values: (\n  0: 0,\n  25: 25%,\n  50: 50%,\n  75: 75%,\n  100: 100%\n) !default;\n\n\n// Body\n//\n// Settings for the `<body>` element.\n$body-bg:                                           if(isDarkMode(), #1E1E2D, $white) !default;\n$body-color:                                        $gray-900 !default;\n$body-text-align:                                   null !default;\n\n\n// Links\n//\n// Style anchor elements.\n$link-color:                                        $primary !default;\n$link-decoration:                                   none !default;\n$link-hover-color:                                  darken($primary, 15%) !default;\n$link-hover-decoration:                             underline !default;\n// Darken percentage for links with `.text-*` class (e.g. `.text-success`)\n$emphasized-link-hover-darken-percentage:           15% !default;\n\n\n\n// Paragraphs\n//\n// Style p element.\n$paragraph-margin-bottom:                           1rem !default;\n\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n    xs: 0,\n    sm: 576px,\n    md: 768px,\n    lg: 992px,\n    xl: 1200px,\n    xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n    sm: 540px,\n    md: 720px,\n    lg: 960px,\n    xl: 1140px,\n    xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$border-width:                                      1px !default;\n$border-color:                                      $gray-200 !default;\n$border-dashed-color:                               $gray-300 !default;  // Custom variable\n\n$border-widths: (\n  0: 0,\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n\n$rounded-pill:                                      50rem !default;\n\n$component-active-color:                            $primary-inverse !default;\n$component-active-bg:                               $primary !default;\n$component-hover-bg:                                $primary-light !default;\n$component-hover-color:                             $primary !default;\n\n$caret-width:                                       .3em !default;\n$caret-vertical-align:                              $caret-width * .85 !default;\n$caret-spacing:                                     $caret-width * .85 !default;\n\n$transition-base:                                   all .2s ease !default;\n$transition-fade:                                   opacity .15s linear !default;\n$transition-collapse:                               height .35s ease !default;\n$transition-link:                                   color .2s ease, background-color .2s ease !default;  // Custom variable\n$transition-input:                                  color .2s ease, background-color .2s ease !default;  // Custom variable\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$component-active-color:                            $primary-inverse !default;\n$component-active-bg:                               $primary !default;\n\n// Custom hover and active background colors\n$hover-bg:                                          rgba($gray-100, 0.8) !default; // Custom variable(to remove)\n$active-bg:                                         $hover-bg !default; // Custom variable(to remove)\n\n\n// Border Radiues\n$border-radius-sm:            \t\t\t\t\t\t.275rem !default;\n$border-radius:               \t\t\t\t\t\t.475rem !default;\n$border-radius-lg:            \t\t\t\t\t\t.775rem !default;\n$border-radius-xl:                                  1rem !default; // Custom variable\n\n// Box shadow\n$box-shadow-xs:                                     0 .1rem 0.75rem 0.25rem rgba($black, 0.05) !default; // Custom variable\n$box-shadow-sm:               \t\t\t\t\t\t0 .1rem 1rem 0.25rem rgba($black, .05) !default;\n$box-shadow:                  \t\t\t\t\t\t0 .5rem 1.5rem 0.5rem rgba($black, .075) !default;\n$box-shadow-lg:               \t\t\t\t\t\t0 1rem 2rem 1rem rgba($black, .1) !default;\n\n\n// Border settings\n$border-color:                                      $gray-200 !default;\n$border-dashed-color:                               $gray-300 !default;  // Custom variable\n$border-width:                                      1px !default;\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                                      12 !default;\n$grid-gutter-width:                                 1.5rem !default;\n$grid-row-columns:                                  6 !default;\n\n$gutters: (\n    0: 0rem,\n    1: ($spacer * .25),  \t// 3.5px\n    2: ($spacer * .5),   \t// 7px;\n    3: ($spacer * .75),  \t// 10.5px\n    4: ($spacer * 1),    \t// 14px\n    5: ($spacer * 1.25), \t// 17.5px\n    6: ($spacer * 1.5),  \t// 21px\n    7: ($spacer * 1.75), \t// 24.5px\n    8: ($spacer * 2),    \t// 28px\n    9: ($spacer * 2.25), \t// 31.5px\n    10: ($spacer * 2.5), \t// 35px\n) !default;\n\n// Container padding\n\n$container-padding-x:                               $grid-gutter-width !default;\n\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// Font family\n$font-family-sans-serif:            \t\t\t\tPoppins, Helvetica, \"sans-serif\" !default;\n\n$font-size-base:              \t\t\t\t\t\t1rem !default; // Assumes the browser default, typically `13px`\n$font-size-lg:               \t \t\t\t\t\t$font-size-base * 1.075 !default;   // 14.04px\n$font-size-sm:                \t\t\t\t\t\t$font-size-base * .925 !default;   // 12.025px\n\n$font-weight-lighter:                               lighter !default;\n$font-weight-light:                                 300 !default;\n$font-weight-normal:                                400 !default;\n$font-weight-bold:                                  500 !default;\n$font-weight-bolder:                                600 !default;\n$font-weight-boldest:                               700 !default;\n\n$font-weight-base:                                  $font-weight-normal !default;\n\n// Line heights\n$line-height-base:                                  1.5 !default;\n$line-height-sm:                                    1.25 !default;\n$line-height-lg:                                    1.75 !default;\n$line-height-xl:                                    2 !default;\n$line-height-xxl:                                   2.25 !default;\n\n\n// Heading sizes\n$h1-font-size:                                      $font-size-base * 1.75 !default;   // 22.75px\n$h2-font-size:                                      $font-size-base * 1.5 !default;    // 19.50px\n$h3-font-size:                                      $font-size-base * 1.35 !default;   // 17.55px\n$h4-font-size:                                      $font-size-base * 1.25 !default;   // 16.25px\n$h5-font-size:                                      $font-size-base * 1.15 !default;   // 14.95px\n$h6-font-size:                                      $font-size-base * 1.075 !default;  // 13.97px\n\n// Font Sizes\n$font-sizes: (\n    1: $h1-font-size,   // 22.75px\n    2: $h2-font-size,   // 19.50px\n    3: $h3-font-size,   // 17.55px\n    4: $h4-font-size,   // 16.25px\n    5: $h5-font-size,   // 14.95px\n    6: $h6-font-size,   // 13.95px\n\n    7: $font-size-base * 0.95,  // 12.35px\n    8: $font-size-base * 0.85,  // 11.05px\n    9: $font-size-base * 0.75,  // 9.75px\n    10: $font-size-base * 0.5,  // 6.50px\n\n    base: $font-size-base, // 13px\n    fluid: 100%, // 100%\n\n    2x: $font-size-base * 2,        // 26px\n    2qx: $font-size-base * 2.25,    // 29.25px\n    2hx: $font-size-base * 2.5,     // 32.5px\n    2tx: $font-size-base * 2.75,    // 35.75px\n\n    3x: $font-size-base * 3,        // 39px\n    3qx: $font-size-base * 3.25,    // 42.25px\n    3hx: $font-size-base * 3.5,     // 45.5px\n    3tx: $font-size-base * 3.75,    // 48.75px\n\n    4x: $font-size-base * 4,        // 52px\n    4qx: $font-size-base * 4.25,    // 55.25px\n    4hx: $font-size-base * 4.5,     // 58.5px\n    4tx: $font-size-base * 4.75,    // 61.75px\n    \n    5x: $font-size-base * 5,        // 65px\n    5qx: $font-size-base * 5.25,    // 68.25px\n    5hx: $font-size-base * 5.5,     // 71.5px\n    5tx: $font-size-base * 5.75     // 74.75px\n) !default;\n\n$headings-margin-bottom:                            $spacer * 0.5 !default;\n$headings-font-family:                              null !default;\n$headings-font-style:                               null !default;\n$headings-font-weight:                              $font-weight-bolder !default;\n$headings-line-height:                              1.2 !default;\n$headings-color:                                    $gray-900 !default;\n\n$display-font-sizes: (\n    1: 5rem,\n    2: 4.5rem,\n    3: 4rem,\n    4: 3.5rem,\n    5: 3rem,\n    6: 2.5rem\n) !default;\n\n$display-font-weight:                               $font-weight-bolder !default;\n$display-line-height:                               $headings-line-height !default;\n\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y:                               .75rem !default;\n$input-btn-padding-x:                               1rem !default;\n$input-btn-font-family:                             null !default;\n$input-btn-font-size:                               $font-size-base * 1.1 !default;\n$input-btn-line-height:                             $line-height-base !default;\n\n$input-btn-focus-width:                             .25rem !default;\n$input-btn-focus-color-opacity:                     .25 !default;\n$input-btn-focus-color:                             rgba($component-active-bg, $input-btn-focus-color-opacity) !default;\n$input-btn-focus-box-shadow:                        null !default;\n\n$input-placeholder-color:                           $gray-500 !default;\n$input-plaintext-color:                             $body-color !default;\n\n$input-btn-padding-y-sm:                            .65rem !default;\n$input-btn-padding-x-sm:                            .75rem !default;\n$input-btn-font-size-sm:                            $font-size-sm !default;\n\n$input-btn-padding-y-lg:                            .825rem !default;\n$input-btn-padding-x-lg:                            1.5rem !default;\n$input-btn-font-size-lg:                            $font-size-base * 1.15 !default;\n\n$input-btn-border-width:                            $border-width !default;\n\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y:                                     $input-btn-padding-y !default;\n$btn-padding-x:                                     1.5rem !default;\n$btn-font-family:                                   $input-btn-font-family !default;\n$btn-font-size:                                     $input-btn-font-size !default;\n$btn-font-weight:                                   $font-weight-bold !default;\n$btn-line-height:                                   $input-btn-line-height !default;\n$btn-white-space:                                   null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:                                  $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:                                  1.25rem !default;\n$btn-font-size-sm:                                  $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:                                  $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:                                  1.75rem !default;\n$btn-font-size-lg:                                  $input-btn-font-size-lg !default;\n\n$btn-border-width:                                  $input-btn-border-width !default;\n\n$btn-box-shadow:                                    null !default;\n$btn-focus-width:                                   $input-btn-focus-width !default;\n$btn-focus-box-shadow:                              null !default;\n$btn-disabled-opacity:                              .6 !default;\n$btn-active-box-shadow:                             null !default;\n\n$btn-link-color:                                    $link-color !default;\n$btn-link-hover-color:                              $link-hover-color !default;\n$btn-link-disabled-color:                           $gray-600 !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:                                 $border-radius !default;\n$btn-border-radius-sm:                              $border-radius !default;\n$btn-border-radius-lg:                              $border-radius !default;\n\n$btn-transition:                                    color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-extended-variants:                             true !default; // Custom variable\n\n\n// Forms\n$form-label-margin-bottom:                          .5rem !default;\n$form-label-font-size:                              1.05rem !default;\n$form-label-font-weight:                            500 !default;\n$form-label-color:                                  $gray-800 !default;\n\n$form-text-margin-top:                              .5rem !default;\n$form-text-font-size:                               $font-size-sm !default;\n$form-text-color:                                   $text-muted !default;\n\n$input-padding-y:                                   $input-btn-padding-y !default;\n$input-padding-x:                                   $input-btn-padding-x !default;\n$input-font-family:                                 $input-btn-font-family !default;\n$input-font-size:                                   $input-btn-font-size !default;\n$input-font-weight:                                 $font-weight-bold !default;\n$input-line-height:                                 $input-btn-line-height !default;\n\n$input-solid-bg:                                    $gray-100 !default; // Custom variable\n$input-solid-bg-focus:                              darken($gray-100, 2%) !default; // Custom variable\n$input-solid-placeholder-color:                     $input-placeholder-color !default;  // Custom variable\n$input-solid-color:                              \t$gray-700 !default; // Custom variable\n\n$input-bg:                                          $body-bg !default;\n$input-disabled-bg:                                 $gray-200 !default;\n$input-readonly-bg:                                 $input-bg !default;  // Custom variable\n$input-disabled-border-color:                       null !default;\n\n$input-color:                                       $body-color !default;\n$input-border-color:                                $gray-300 !default;\n$input-border-width:                                $input-btn-border-width !default;\n\n$input-border-radius:                               $btn-border-radius !default;\n$input-border-radius-sm:                            $btn-border-radius-sm !default;\n$input-border-radius-lg:                            $btn-border-radius-lg !default;\n\n$input-focus-border-color:                          $gray-400 !default;\n$input-focus-color:                                 $input-color !default;\n\n$form-check-input-width:                            1.75rem !default;\n$form-check-input-width-sm:                         1.5rem !default;\n$form-check-input-width-lg:                         2.25rem !default;\n$form-check-input-bg-size:                          60% 60% !default; // Custom variable\n$form-check-min-height:                             $font-size-base * $line-height-base !default;\n$form-check-padding-start:                          $form-check-input-width + .5rem !default;\n$form-check-padding-left:                           $form-check-input-width + .5rem !default;\n$form-check-margin-bottom:                          .125rem !default;\n$form-check-label-color:                            null !default;\n$form-check-label-cursor:                           null !default;\n$form-check-transition:                             background-color .15s ease-in-out, background-position .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-check-input-active-filter:                    brightness(90%) !default;\n\n$form-check-input-bg:                               $body-bg !default;\n$form-check-input-bg-solid:                         $gray-200 !default; // Custom variable\n$form-check-input-border:                           1px solid rgba(0, 0, 0, .25) !default;\n$form-check-input-border-radius:                    .45em !default;\n$form-check-radio-border-radius:                    50% !default;\n$form-check-input-focus-border:                     $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:                 none !default;\n\n$form-check-input-checked-color:                    $component-active-color !default;\n$form-check-input-checked-bg-color:                 $component-active-bg !default;\n$form-check-input-checked-border-color:             $component-active-bg !default;\n$form-check-input-checked-bg-image:                 url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 13 11' width='13' height='11' fill='none'><path d='M11.0426 1.02893C11.3258 0.695792 11.8254 0.655283 12.1585 0.938451C12.4917 1.22162 12.5322 1.72124 12.249 2.05437L5.51985 9.97104C5.23224 10.3094 4.72261 10.3451 4.3907 10.05L0.828197 6.88335C0.50141 6.59288 0.471975 6.09249 0.762452 5.7657C1.05293 5.43891 1.55332 5.40948 1.88011 5.69995L4.83765 8.32889L11.0426 1.02893Z' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n$form-check-radio-checked-bg-image:                 url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:              $component-active-color !default;\n$form-check-input-indeterminate-bg-color:           $component-active-bg !default;\n$form-check-input-indeterminate-border-color:       $component-active-bg !default;\n$form-check-input-indeterminate-bg-image:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:                 .5 !default;\n$form-check-label-disabled-opacity:                 $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:             $btn-disabled-opacity !default;\n\n$form-switch-color:                                 rgba(0, 0, 0, .25) !default;\n$form-switch-color-solid:                           if(isDarkMode(), $gray-500, $white) !default;\n$form-switch-width:                                 3.25rem !default;\n$form-switch-height:                                2.25rem !default; // Custom variable\n$form-switch-width-sm:                              2.5rem !default; // Custom variable\n$form-switch-height-sm:                             1.5rem !default; // Custom variable\n$form-switch-width-lg:                              3.75rem !default; // Custom variable\n$form-switch-height-lg:                             2.75rem !default; // Custom variable\n\n$form-switch-padding-start:                         $form-switch-width + .5rem !default;\n$form-switch-padding-left:                          $form-switch-width + .5rem !default;\n$form-switch-bg-image:                              url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-bg-image-solid:                        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color-solid}'/></svg>\") !default;\n$form-switch-border-radius:                         $form-switch-width !default;\n\n$form-switch-focus-color:                           $input-focus-border-color !default;\n$form-switch-focus-bg-image:                        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:                         $component-active-color !default;\n$form-switch-checked-bg-image:                      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position:                   right center !default;\n\n$form-check-inline-margin-right:                    1rem !default;\n\n$input-group-addon-bg:                              $gray-100 !default;\n\n$form-select-indicator-color:                       $gray-600 !default;\n$form-select-border-radius:                         $border-radius !default;\n\n// Navs\n$nav-tabs-border-color:                             $border-color !default;\n$nav-tabs-border-width:                             $border-width !default;\n\n\n\n// Card\n$card-bg:                                           $body-bg !default;\n$card-box-shadow: \t\t\t\t\t\t\t\t\tif(isDarkMode(), none, 0px 0px 20px 0px rgba(76,87,125,0.02)) !default;\n$card-border-color:                 \t\t\t\t$border-color !default;\n$card-border-style:                                 solid !default; // Custom variable\n$card-border-dashed-color:                 \t\t\t$border-dashed-color !default;\n$card-cap-bg:                       \t\t\t\t$white !default;\n$card-py:                     \t\t\t\t        2rem !default;\n$card-px:                    \t\t\t\t\t    2.25rem !default;\n$card-border-radius:                \t\t\t\t$border-radius !default;\n\n$card-header-py:                                    0.5rem !default; // Custom variable\n$card-header-height: \t\t\t\t\t\t\t\t70px !default; // Custom variable\n\n$card-border-enabled:                               false !default; // Custom variable\n\n// Accordion\n$accordion-color:                                   $body-color !default;\n$accordion-padding-y:                               1.5rem !default;\n$accordion-padding-x:                               1.5rem !default;\n$accordion-border-color:                            $border-color !default;\n$accordion-border-radius:                           $border-radius !default;\n\n$accordion-body-padding-y:                          $accordion-padding-y !default;\n$accordion-body-padding-x:                          $accordion-padding-x !default;\n\n$accordion-button-padding-y:                        $accordion-padding-y !default;\n$accordion-button-padding-x:                        $accordion-padding-x !default;\n$accordion-transition:                              $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:                        $gray-100 !default;\n$accordion-button-active-color:                     $primary !default;\n\n$accordion-button-focus-border-color:               $border-color  !default;\n$accordion-button-focus-box-shadow:                 none !default;\n\n$accordion-icon-width:                              1.15rem !default;\n$accordion-icon-active-color:                       $accordion-button-active-color !default;\n\n\n// Modals\n\n// Padding applied to the modal body\n$modal-inner-padding:              \t\t\t\t\t1.75rem !default;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between:       \t\t\t\t.5rem !default;\n\n$modal-dialog-margin:               \t\t\t\t.5rem !default;\n$modal-dialog-margin-y-sm-up:       \t\t\t\t1.75rem !default;\n\n$modal-header-border-color:                         $border-color !default;\n$modal-footer-border-color:                         $modal-header-border-color !default;\n$modal-header-border-width:                         1px !default;\n$modal-footer-border-width:                         1px !default;\n\n$modal-content-color:               \t\t\t\tnull !default;\n$modal-content-bg:                  \t\t\t\t$body-bg !default;\n$modal-content-border-color:        \t\t\t\tnull !default;\n$modal-content-border-width:        \t\t\t\t0 !default;\n$modal-content-border-radius:       \t\t\t\t$border-radius !default;\n$modal-content-inner-border-radius: \t\t\t\t$border-radius !default;\n\n$modal-content-box-shadow:       \t\t\t\t    0 .25rem .5rem rgba($black, .05) !default;\n$modal-content-box-shadow-xs:       \t\t\t\t0 .25rem .5rem rgba($black, .1) !default;\n$modal-content-box-shadow-sm-up:   \t\t\t\t\t0 .5rem 1rem rgba($black, .1) !default;\n\n$modal-backdrop-bg:                \t\t \t\t\t$black !default;\n$modal-backdrop-opacity:            \t\t\t\tif(isDarkMode(), 0.4, 0.3) !default;\n\n$modal-xl:                         \t\t \t\t\t1140px !default;\n$modal-lg:                          \t\t\t\t800px !default;\n$modal-md:                          \t\t\t\t500px !default;\n$modal-sm:                          \t\t\t\t300px !default;\n\n\n// Alerts\n// Define alert colors, border radius, and padding.\n$alert-color-scale:                                 if(isDarkMode(), 60%, 40%) !default;\n$alert-border-scale:                                if(isDarkMode(), -60%, -70%) !default;\n$alert-bg-scale:                                    if(isDarkMode(), -60%, -80%) !default;\n\n\n\n// Dropdowns\n// Dropdown menu container and contents.\n$dropdown-box-shadow:\t\t\t\t\t\t\t\tif(isDarkMode(), 0px 0px 30px rgba(0, 0, 0, 0.3), 0px 0px 50px 0px rgba(82,63,105, 0.15)) !default;\n$dropdown-border-radius:                            $border-radius !default;\n$dropdown-border-width:                             0 !default;\n$dropdown-bg:                                       $body-bg !default;\n\n\n\n// Pagination\n\n$pagination-item-height:                             2.5rem !default; // Custom variable\n$pagination-item-bg:                                 $body-bg !default; // Custom variable\n$pagination-item-space:                              0.5rem !default; // Custom variable\n$pagination-item-space-tablet-and-mobile:            0.25rem !default; // Custom variable\n$pagination-font-weight:                             $font-weight-bold !default; // Custom variable\n$pagination-font-size:                               $font-size-lg !default; // Custom variable\n$pagination-icon-font-size:                          0.85rem !default; // Custom variable\n$pagination-icon-height:                             $pagination-item-height * 0.35 !default; // Custom variable\n\n$pagination-padding-y:                              .375rem !default;\n$pagination-padding-x:                              .75rem !default;\n$pagination-padding-y-sm:                           .25rem !default;\n$pagination-padding-x-sm:                           .5rem !default;\n$pagination-padding-y-lg:                           .75rem !default;\n$pagination-padding-x-lg:                           1.5rem !default;\n\n$pagination-color:                                  $gray-700 !default;\n$pagination-bg:                                     transparent !default;\n$pagination-border-width:                           0 !default;\n$pagination-border-radius:                          $btn-border-radius !default;\n$pagination-margin-left:                            0 !default;\n$pagination-border-color:                           transparent !default;\n\n$pagination-focus-color:                            $component-hover-color !default;\n$pagination-focus-bg:                               $component-hover-bg !default;\n$pagination-focus-box-shadow:                       none !default;\n$pagination-focus-outline:                          0 !default;\n\n$pagination-hover-color:                            $component-hover-color !default;\n$pagination-hover-bg:                               $component-hover-bg !default;\n$pagination-hover-border-color:                     transparent !default;\n\n$pagination-active-color:                           $component-active-color !default;\n$pagination-active-bg:                              $component-active-bg !default;\n$pagination-active-border-color:                    transparent !default;\n\n$pagination-disabled-color:                         $gray-400 !default;\n$pagination-disabled-bg:                            transparent !default;\n$pagination-disabled-border-color:                  transparent !default;\n\n$pagination-transition:                             color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n// Popovers\n$popover-bg:                                        if(isDarkMode(), $gray-200, $body-bg) !default;\n$popover-font-size:                 \t\t\t\t$font-size-base !default;\n$popover-border-color:              \t\t\t\t$popover-bg !default;\n$popover-border-radius:             \t\t\t\t$border-radius !default;\n$popover-box-shadow:                \t\t\t\t$dropdown-box-shadow !default;\n$popover-header-bg:                 \t\t\t\t$popover-bg !default;\n$popover-header-color:              \t\t\t\t$gray-800 !default;\n$popover-header-font-weight:           \t\t\t\t500 !default;  // Custom variable\n$popover-header-font-size:             \t\t\t\t1rem !default;  // Custom variable\n$popover-header-padding-y:          \t\t\t\t1rem !default;\n$popover-header-padding-x:          \t\t\t\t1.25rem !default;\n$popover-header-border-color:                       if(isDarkMode(), $gray-300, $gray-100) !default;  // Custom variable\n$popover-body-color:                \t\t\t\t$gray-800 !default;\n$popover-body-padding-y:                            1.25rem !default;\n$popover-body-padding-x:                            1.25rem !default;\n\n$popover-dissmis-btn-height:                        1.5rem !default;  // Custom variable\n$popover-dissmis-btn-top:                           0.85rem !default;  // Custom variable\n$popover-dissmis-btn-end:                           0.85rem !default;  // Custom variable\n\n// Tooltips\n$tooltip-font-size:                 \t\t\t\t$font-size-sm !default;\n$tooltip-max-width:                 \t\t\t\t200px !default;\n$tooltip-color:                     \t\t\t\t$gray-800 !default;\n$tooltip-bg:                        \t\t\t\t$popover-bg !default;\n$tooltip-border-radius:             \t\t\t\t$btn-border-radius !default;\n$tooltip-opacity:                   \t\t\t\t1 !default;\n$tooltip-box-shadow:                \t\t\t\t$popover-box-shadow !default; // Custom variable\n$tooltip-padding-y:                 \t\t\t\t.75rem !default;\n$tooltip-padding-x:                 \t\t\t\t1rem !default;\n$tooltip-margin:                    \t\t\t\t0 !default;\n\n\n\n// Badges\n$badge-font-size:                                   .85rem !default;\n$badge-font-size-sm:                                .85rem !default;\n$badge-font-size-lg:                                1rem !default;\n$badge-font-weight:                                 $font-weight-bolder !default;\n$badge-color:                                       $body-bg !default;\n$badge-padding-y:                                   .5em !default;\n$badge-padding-x:                                   .85em !default;\n$badge-border-radius:                               $border-radius !default;\n$badge-size:                                        1.75rem !default; // Custom variable\n$badge-size-sm:                                     1.5rem !default; // Custom variable\n$badge-size-lg:                                     2rem !default; // Custom variable\n\n\n\n// Code\n$code-bg:                                           if(isDarkMode(), $gray-200, #F1F3F8) !default; // Custom variable\n$code-box-shadow:                                   0px 3px 9px rgba(0, 0, 0, 0.08) !default; // Custom variable\n$code-padding:                                      0.1rem 0.4rem !default; // Custom variable\n$code-margin:                                       0 0.5rem !default; // Custom variable\n$code-font-weight:                                  400 !default; // Custom variable\n$code-border-radius:                                0.3rem !default;  // Custom variable\n$code-color:                                        #b93993 !default;  // Custom variable\n$code-space:                                        0.25rem !default;  // Custom variable\n\n\n\n// Carousel\n$carousel-custom-dots-indicator-default-size:       9px !default;\n$carousel-custom-dots-indicator-active-size:        13px !default;\n$carousel-custom-indicator-transition-speed:        0.3s !default;\n$carousel-custom-indicator-default-bg-color:        $gray-200 !default;\n$carousel-custom-indicator-active-bg-color:         $gray-300 !default;\n\n\n\n// Spinners\n\n$spinner-border-width:                              .185em !default;\n$spinner-animation-speed:                           .65s !default;\n$spinner-border-width-sm:                           .145em !default;\n\n\n\n// Breadcrumbs\n$breadcrumb-divider-color:                          $gray-600 !default;\n$breadcrumb-active-color:                           $primary !default;\n$breadcrumb-item-padding-x:                         .5rem !default;\n\n\n\n// Progress bars\n$progress-height:                                   1rem !default;\n$progress-font-size:                                $font-size-base * .75 !default;\n$progress-bg:                                       $gray-100 !default;\n$progress-border-radius:                            6px !default;\n$progress-box-shadow:                               none !default;\n\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding-y:                              .75rem !default;\n$table-cell-padding-x:                              .75rem !default;\n$table-cell-padding-y-sm:                           .5rem !default;\n$table-cell-padding-x-sm:                           .5rem !default;\n\n$table-color:                                       $body-color !default;\n$table-bg:                                          transparent !default;\n$table-striped-color:                               $table-color !default;\n$table-striped-bg:                                  rgba($gray-100, 0.75) !default;\n\n$table-active-color:                                $table-color !default;\n$table-active-bg:                                   $gray-100 !default;\n\n$table-hover-color:                                 $table-color !default;\n$table-hover-bg:                                    $gray-100 !default;\n\n$table-border-factor:                               .1 !default;\n$table-border-width:                                $border-width !default;\n$table-border-color:                                $border-color !default;\n\n\n\n // Opacity\n $opacity-values: (\n     0: 0,\n     5: .05,\n     10: .1,\n     15: .15,\n     20: .20,\n     25: .25,\n     50: .5,\n     75: .75,\n     100: 1,\n ) !default;\n\n// Zindex\n$zindex-values: (\n    n1: -1,\n    n2: -2,\n    0: 0,\n    1: 1,\n    2: 2,\n    3: 3\n) !default;\n\n// Letter spacing\n$letter-spacing-values: (\n    1: 0.1rem,\n    2: 0.115rem,\n    3: 0.125rem,\n    4: 0.25rem,\n    5: 0.5rem\n) !default;\n\n// Custom hight and width sizes\n$custom-sizes: (\n    unset: unset,\n    25: 25%,\n    50: 50%,\n    75: 75%,\n    100: 100%,\n    auto: auto,\n  \t1px: 1px,\n  \t2px: 2px,\n  \t3px: 3px,\n  \t4px: 4px,\n  \t5px: 5px,\n    6px: 6px,\n    7px: 7px,\n    8px: 8px,\n    9px: 9px,\n  \t10px: 10px,\n  \t15px: 15px,\n  \t20px: 20px,\n  \t25px: 25px,\n  \t30px: 30px,\n  \t35px: 35px,\n  \t40px: 40px,\n  \t45px: 45px,\n  \t50px: 50px,\n  \t55px: 55px,\n  \t60px: 60px,\n  \t65px: 65px,\n  \t70px: 70px,\n  \t75px: 75px,\n  \t80px: 80px,\n  \t85px: 85px,\n  \t90px: 90px,\n  \t95px: 95px,\n  \t100px: 100px,\n  \t125px: 125px,\n  \t150px: 150px,\n\t175px: 175px,\n  \t200px: 200px,\n    225px: 225px,\n  \t250px: 250px,\n    275px: 275px,\n  \t300px: 300px,\n    325px: 325px,\n  \t350px: 350px,\n    375px: 375px,\n  \t400px: 400px,\n    425px: 425px,\n  \t450px: 450px,\n    475px: 475px,\n  \t500px: 500px,\n  \t550px: 550px,\n  \t600px: 600px,\n  \t650px: 650px,\n  \t700px: 700px,\n  \t750px: 750px,\n  \t800px: 800px,\n  \t850px: 850px,\n  \t900px: 900px,\n  \t950px: 950px,\n  \t1000px: 1000px\n) !default;\n\n\n\n// Symbol Sizes\n$symbol-sizes: (\n    20px: 20px,\n    25px: 25px,\n    30px: 30px,\n    35px: 35px,\n    40px: 40px,\n    45px: 45px,\n    default: 50px,\n    50px: 50px,\n    55px: 55px,\n    60px: 60px,\n    65px: 65px,\n    70px: 70px,\n    75px: 75px,\n    100px:100px,\n\t125px:125px,\n    150px:150px,\n    160px:160px,\n    175px:175px,\n    200px:200px\n) !default;\n\n\n\n// Bullet\n$bullet: (\n\tbg-color: $gray-400,\n\tdot-size: 4px,\n\tbar-height: 4px,\n\tbar-width: 8px,\n    bar-border-radius: 6px,\n    line-height: 1px,\n\tline-width: 5px,\n) !default;\n\n\n\n// Scrolltop\n$scrolltop: (\n    opacity: (\n        default: 0,\n        on: 0.3,\n        hover: 1\n    ),\n    bottom: (\n        desktop: 40px,\n        tablet-and-mobile: 30px\n    ),\n    right: (\n        desktop: 20px,\n        tablet-and-mobile: 15px\n    ),\n    size: (\n        desktop: 36px,\n        tablet-and-mobile: 30px\n    ),\n    bg-color: (\n        default: $primary,\n        hover: $primary\n    ),\n    icon-color: (\n        default: $white,\n        hover: $white\n    )\n) !default;\n\n\n\n// Sticky Toolbar\n$sticky-toolbar: (\n\tz-index: 95\n) !default;\n\n\n\n// Drawer\n$drawer: (\n\tz-index: 110, // Drawer's z-index\n\tbox-shadow: if(isDarkMode(), 0px 0px 30px rgba(0, 0, 0, 0.1), 0px 1px 9px -3px rgba(0,0,0, 0.05)), // Drawer's box shadow\n\tbg-color: $body-bg, // Drawer's background color\n\ttransition-speed: 0.3s,\n\toverlay-bg-color: if(isDarkMode(), rgba($black, 0.4), rgba($black, 0.2)), // Offcanvas overlay background color\n\toverlay-animation-speed: 0.3s\n) !default;\n\n\n\n// Menu\n$menu: (\n\tdropdown: (\n\t\tbox-shadow: $dropdown-box-shadow,\n\t\tz-index: 105,\n\t\tbackground-color: $body-bg,\n        border-radius: $border-radius,\n        animation: true,\n        animation-speed: 0.3s,\n        animation-move-offset: 0.75rem\n\t),\n\n\taccordion: (\n        indention: 1rem,\n        arrow-transition: transform 0.3s ease\n\t),\n\n\titem: (\n\t\tself: (\n            padding-y: 0.15rem,\n            padding-x: 0\n\t\t)\n\t),\n\n\tlink: (\n\t\tself: (\n            padding-y: 0.65rem,\n            padding-x: 1rem,\n\t\t\tbg-color: (\n\t\t\t\thover: $hover-bg,\n\t\t\t\tshow: $hover-bg,\n                here: $hover-bg,\n\t\t\t\tactive: $active-bg\n\t\t\t)\n\t\t),\n\n\t\ticon: (\n\t\t\twidth: 2rem,\n\t\t\tspace: 0.5rem\n\t\t),\n\n\t\tbullet: (\n\t\t\twidth: 1.25rem,\n\t\t\tspace: 0.5rem\n\t\t),\n\n\t\tbadge: (\n\t\t\tspace: 0.5rem\n\t\t),\n\n\t\tarrow: (\n            height: 0.8rem,\n            width: 0.8rem,\n\t\t\tspace: 0.5rem\n\t\t)\n\t)\n) !default;\n\n\n\n// Feedback\n$feedback: (\n\tpopup: (\n\t\tz-index: 1000,\n\t\tbox-shadow: $dropdown-box-shadow,\n\t\tbackground-color: $body-bg,\n\t\tborder-radius: $border-radius,\n\t\ttransition-speed: 0.6s,\n\t\tpadding: 1rem 1.25rem\n\t)\n) !default;\n\n\n\n// Custom scrollbar\n$scrollbar: (\n    space: 0.5rem,\n    width: 0.4rem,\n    height: 0.4rem,\n    color: $gray-200,\n    hover-color: darken($gray-200, 2%)\n) !default;\n\n\n\n// Overlay\n$overlay: (\n    bg: rgba($black, 0.05)\n) !default;\n\n\n\n// BlockUI\n$blockui: (\n    overlay-bg: rgba($black, 0.05)\n) !default;\n\n\n\n// Rating\n$rating: (\n    color: (\n        default: $gray-400,\n        active: #FFAD0F\n    )\n) !default;\n\n\n\n// Social Network Colors Used With Boostrap Buttons(see: https://brandcolors.net)\n$social-colors: (\n\tfacebook: (\n\t\tbase: #3b5998,\n\t\tinverse: #ffffff,\n        light: rgba(#3b5998, 0.1),\n        active: darken(#3b5998, 7.5%)\n\t),\n\tgoogle: (\n\t\tbase: #dd4b39,\n\t\tinverse: #ffffff,\n        light: rgba(#dd4b39, 0.1),\n        active: darken(#dd4b39, 7.5%)\n\t),\n\ttwitter: (\n\t\tbase: #1da1f2,\n\t\tinverse: #ffffff,\n        light: rgba(#1da1f2, 0.1),\n        active: darken(#1da1f2, 7.5%)\n\t),\n\tinstagram: (\n\t\tbase: #e1306c,\n\t\tinverse: #ffffff,\n        light: rgba(#e1306c, 0.1),\n        active: darken(#e1306c, 7.5%)\n\t),\n\tyoutube: (\n\t\tbase: #ff0000,\n\t\tinverse: #ffffff,\n        light: rgba(#ff0000, 0.1),\n        active: darken(#ff0000, 7.5%)\n\t),\n    linkedin: (\n        base: #0077b5,\n        inverse: #ffffff,\n        light: rgba(#0077b5, 0.1),\n        active: darken(#0077b5, 7.5%)\n    )\n) !default; // Custom variable","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n    @include font-size($font-size);\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","@mixin box-shadow($shadow...) {\n  @if $enable-shadows {\n    $result: ();\n    $has-single-value: false;\n    $single-value: null;\n\n    @each $value in $shadow {\n      @if $value != null {\n        @if $value == none or $value == initial or $value == inherit or $value == unset {\n          $has-single-value: true;\n          $single-value: $value;\n        } @else {\n          $result: append($result, $value, \"comma\");\n        }\n      }\n    }\n\n    @if $has-single-value {\n      box-shadow: $single-value;\n    } @else if (length($result) > 0) {\n      box-shadow: $result;\n    }\n  }\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0;\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","//\n// To make future updates easier consider overriding the global variables from _variables.bootstrap.scss and _variables.custom.scss for current demo in this file.\n// Note that this file is included first and variables defined in _variables.bootstrap.scss and _variables.custom.scss\n// are not accessible in this file but you can override any global variable as shown below:\n//\n\n// Theme colors\n// Primary\n$primary:       \t\t\t\t\t\t\t\t\tif(isDarkMode(), #3699FF, #009EF7);\n$primary-active:    \t\t\t\t\t\t\t\tif(isDarkMode(), #187DE4, #0095E8);\n$primary-light:    \t\t\t\t\t\t\t\t    if(isDarkMode(), #212E48, #F1FAFF);\n$primary-inverse:  \t\t\t\t\t\t\t\t\t#FFFFFF;\n\n// Success\n$success:       \t\t\t\t\t\t\t\t\tif(isDarkMode(), #0BB783, #50CD89);\n$success-active:    \t\t\t\t\t\t\t\tif(isDarkMode(), #04AA77, #47BE7D);\n$success-light:    \t\t\t\t\t\t\t\t\tif(isDarkMode(), #1C3238, #E8FFF3);\n$success-inverse:  \t\t\t\t\t\t\t\t\t#FFFFFF;\n\n// Info\n$info:       \t\t\t\t\t\t\t\t\t    if(isDarkMode(), #8950FC, #7239EA);\n$info-active:    \t\t\t\t\t\t\t\t\tif(isDarkMode(), #7337EE, #5014D0);\n$info-light:    \t\t\t\t\t\t\t\t\tif(isDarkMode(), #2F264F, #F8F5FF);\n$info-inverse:  \t\t\t\t\t\t\t\t\t#FFFFFF;\n\n// Danger\n$danger:       \t\t\t\t\t\t\t\t\t    if(isDarkMode(), #F64E60, #F1416C);\n$danger-active:    \t\t\t\t\t\t\t\t\tif(isDarkMode(), #EE2D41, #D9214E);\n$danger-light:    \t\t\t\t\t\t\t\t\tif(isDarkMode(), #3A2434, #FFF5F8);\n$danger-inverse:  \t\t\t\t\t\t\t\t\t#FFFFFF;\n\n// Warning\n$warning:       \t\t\t\t\t\t\t\t\tif(isDarkMode(), #FFA800, #FFC700);\n$warning-active:    \t\t\t\t\t\t\t\tif(isDarkMode(), #EE9D01, #F1BC00);\n$warning-light:    \t\t\t\t\t\t\t\t\tif(isDarkMode(), #392F28, #FFF8DD);\n$warning-inverse:  \t\t\t\t\t\t\t\t\t#FFFFFF;","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    max-width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n    padding-left: $form-floating-padding-x;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  > textarea:focus,\n  > textarea:not(:placeholder-shown) {\n    ~ label::after {\n      position: absolute;\n      inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n      z-index: -1;\n      height: $form-floating-label-height;\n      content: \"\";\n      background-color: $input-bg;\n      @include border-radius($input-border-radius);\n    }\n  }\n  > textarea:disabled ~ label::after {\n    background-color: $input-disabled-bg;\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(-1 * #{$input-border-width}); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  // The top radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-grow: 1;\n    flex-basis: 0;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-grow: 1;\n  flex-basis: 100%;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      flex: 1 0 0;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-collapse,\n    > .accordion-header .accordion-button,\n    > .accordion-header .accordion-button.collapsed {\n      @include border-radius(0);\n    }\n    // stylelint-enable selector-max-class\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(-1 * #{$pagination-border-width}) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: var(--#{$prefix}progress-height); }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  &:not(.active) {\n    // Hover state\n    &:hover,\n    &:focus {\n      z-index: 1; // Place hover/focus items above their siblings for proper border styling\n      color: var(--#{$prefix}list-group-action-hover-color);\n      text-decoration: none;\n      background-color: var(--#{$prefix}list-group-action-hover-bg);\n    }\n\n    &:active {\n      color: var(--#{$prefix}list-group-action-active-color);\n      background-color: var(--#{$prefix}list-group-action-active-bg);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  filter: var(--#{$prefix}btn-close-filter);\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter-dark};\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include btn-close-white();\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    transform: $modal-fade-transform;\n    @include transition($modal-transition);\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}modal-header-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-left: auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  filter: var(--#{$prefix}carousel-control-icon-filter);\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: var(--#{$prefix}carousel-indicator-active-bg);\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: var(--#{$prefix}carousel-caption-color);\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg-dark};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color-dark};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter-dark};\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include carousel-dark();\n  }\n}\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  flex-shrink: 0;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","//\n// Root CSS Variables\n//\n\n:root {\n    // Theme colors\n    @each $name, $value in $theme-colors {\n        @if ( theme-light-color($name) ) {\n            --#{$variable-prefix}light-#{$name}:#{theme-light-color($name)};\n            --#{$variable-prefix}active-#{$name}:#{theme-active-color($name)};\n        }\n    }\n\n    // Gray colors\n    @each $name, $value in $grays {\n        --#{$variable-prefix}gray-#{$name}:#{$value};\n    }\n\n    // Breakpoints\n    @each $breakpoint, $value in $grid-breakpoints {\n        --#{$variable-prefix}#{$breakpoint}:#{$value};\n    }\n\n    // Border\n    --#{$variable-prefix}border-color:#{$border-color};\n    --#{$variable-prefix}border-dashed-color:#{$border-dashed-color};\n}","//\n// Custom background helpers\n//\n\n// Background theme light colors\n@each $color, $value in $theme-colors {\n\t@if (theme-light-color($color)) {\n\t\t.bg-light-#{$color} {\n\t\t\tbackground-color: theme-light-color($color) !important;\n\n\t\t\t&.hoverable:hover {\n\t\t\t\tbackground-color: darken(theme-light-color($color), 6%) !important;\n\t\t\t}\n\t\t}\n\t}\n\n    .bg-#{$color} {\n\t\t--bg-color: #{red($value)}, #{green($value)}, #{blue($value)};\n\n        &.hoverable:hover {\n\t\t   background-color: theme-active-color($color) !important;\n       }\n\t}\n\n\t@if (theme-light-color($color)) {\n\t\t.bg-hover-light-#{$color} {\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: theme-light-color($color) !important;\n\t\t\t}\n\t\t}\n\n\t\t.bg-state-light-#{$color} {\n\t\t\tcursor: pointer;\n\n\t\t\t&.active,\n\t\t\t&:hover {\t\t\t\t\n\t\t\t\tbackground-color: theme-light-color($color) !important;\n\t\t\t}\n\t\t}\n\t}\n\n\t.bg-hover-#{$color} {\n\t\tcursor: pointer;\n\n\t\t&:hover {\n\t\t\t--bg-color: #{red($value)}, #{green($value)}, #{blue($value)};\n\t\t\tbackground-color: $value !important;\n\t\t}\n\t}\n\n\t.bg-active-#{$color} {\n\t\t&.active {\n\t\t\t--bg-color: #{red($value)}, #{green($value)}, #{blue($value)};\n\t\t\tbackground-color: $value !important;\n\t\t}\n\t}\n\n\t.bg-state-#{$color} {\n\t\tcursor: pointer;\n\n\t\t&.active,\n\t\t&:hover {\t\t\t\t\n\t\t\t--bg-color: #{red($value)}, #{green($value)}, #{blue($value)};\n\t\t\tbackground-color: $value !important;\n\t\t}\n\t}\n}\n\n// Background gray colors\n@each $color, $value in $grays {\n    .bg-gray-#{$color} {\n\t\tbackground-color: $value !important;\n\t}\n}\n\n// Opacity\n@each $name, $value in $opacity-values {\n\t.bg-opacity-#{$name} {\n\t\tbackground-color: rgba(var(--bg-color), #{$value}) !important;\n\t}\n\n\t.bg-hover-opacity-#{$name}:hover {\n\t\tbackground-color: rgba(var(--bg-color), #{$value}) !important;\n\t}\n\n\t.bg-active-opacity-#{$name}.active {\n\t\tbackground-color: rgba(var(--bg-color), #{$value}) !important;\n\t}\n\n\t.bg-state-opacity-#{$name} {\n\t\t.active,\n\t\t&:hover {\n\t\t\tbackground-color: rgba(var(--bg-color), #{$value}) !important;\n\t\t}\t\t\n\t}\n}\n\n// Background black color\n.bg-black {\n\tbackground-color: $black !important;\n}\n\n// Background body color\n.bg-body {\n\t--bg-color: #{red($body-bg)}, #{green($body-bg)}, #{blue($body-bg)};\n\tbackground-color: $body-bg !important;\n}\n\n// Lighten bg states\n.bg-lighten {\n\tbackground-color: $lighten !important;\n}\n\n.bg-hover-lighten {\n\tcursor: pointer;\n\n\t&:hover {\n\t\tbackground-color: $lighten !important;\n\t}\n}\n\n.bg-active-lighten {\n\t&.active {\n\t\tbackground-color: $lighten !important;\n\t}\n}\n\n.bg-state-lighten {\n\tcursor: pointer;\n\n\t&.active,\n\t&:hover {\t\t\t\t\n\t\tbackground-color: $lighten !important;\n\t}\n}\n\n// Hoverable\n.hoverable {\n\tcursor: pointer;\n    transition: $transition-base;\n\n    &:hover {\n        transition: $transition-base;\n    }\n}\n\n// Background image helpers\n// Background repeat\n.bgi-no-repeat {\n\tbackground-repeat: no-repeat;\n}\n\n// Background positions\n.bgi-position-y-top {\n\tbackground-position-y: top;\n}\n\n.bgi-position-y-bottom {\n\tbackground-position-y: bottom;\n}\n\n.bgi-position-y-center {\n\tbackground-position-y: center;\n}\n\n.bgi-position-x-start {\n\tbackground-position-x: left;\n}\n\n.bgi-position-x-end {\n\tbackground-position-x: right;\n}\n\n.bgi-position-x-center {\n\tbackground-position-x: center;\n}\n\n.bgi-position-top {\n\tbackground-position: 0 top;\n}\n\n.bgi-position-bottom {\n\tbackground-position: 0 bottom;\n}\n\n.bgi-position-center {\n\tbackground-position: center;\n}\n\n// Responsive helpers\n@each $breakpoint in map-keys($grid-breakpoints) {\n    @include media-breakpoint-up($breakpoint) {\n\t\t$infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\t\t\n\t\t// Background sizes\n\t\t.bgi-size#{$infix}-auto {\n\t\t\tbackground-size: auto;\n\t\t}\n\n\t\t.bgi-size#{$infix}-cover {\n\t\t\tbackground-size: cover;\n\t\t}\n\n\t\t.bgi-size#{$infix}-contain {\n\t\t\tbackground-size: contain;\n\t\t}\t\n\n\t\t// Background attachment\n\t\t.bgi-attachment#{$infix}-fixed {\n\t\t\tbackground-attachment: fixed;\n\t\t}\n\n\t\t.bgi-attachment#{$infix}-auto {\n\t\t\tbackground-attachment: auto;\n\t\t}\n\t}\n}\n\n\n\n","//\n// Border\n//\n\n.border-active:not(.active):not(:active):not(:hover):not(:focus) {\n    border-color: transparent !important;\n}\n\n.border-hover:not(:hover):not(:focus):not(.active):not(:active) {\n    cursor: pointer;\n    border-color: transparent !important;\n}\n\n// Gray border colors\n@each $color, $value in $grays {\n\t// Initial\n\t.border-gray-#{$color} {\n\t\tborder-color: $value !important;\n\t}\n}\n\n// Hover border colors\n@each $color, $value in $theme-colors {\n    .border-hover-#{$color}:hover {\n        border-color: $value !important;\n    }\n\n    .border-active-#{$color}.active {\n        border-color: $value !important;\n    }   \n}\n\n// Hover transparent\n.border-hover-transparent:hover {\n    border-color: transparent !important;\n}\n\n// Dashed style\n.border-dashed {\n    border-style: dashed !important;\n    border-color: $border-dashed-color;\n}\n\n.border-top-dashed {\n    border-top-style: dashed !important;\n}\n\n.border-bottom-dashed {\n    border-bottom-style: dashed !important;\n}\n\n.border-start-dashed {\n    border-left-style: dashed !important;\n}\n\n.border-end-dashed {\n    border-right-style: dashed !important;\n}\n\n// Dotted style\n.border-dotted {\n    border-style: dotted !important;\n}\n\n.border-top-dotted {\n    border-top-style: dotted !important;\n}\n\n.border-bottom-dotted {\n    border-bottom-style: dotted !important;\n}\n\n.border-start-dotted {\n    border-left-style: dotted !important;\n}\n\n.border-end-dotted {\n    border-right-style: dotted !important;\n}\n\n// Border transparent\n.border-transparent {\n    border-color: transparent !important;\n}\n\n// Border body\n.border-body {\n    border-color: $body-bg !important;\n}\n\n// Border radiuses\n.rounded-top-0 {\n    border-top-left-radius: 0 !important;\n    border-top-right-radius: 0 !important;\n}\n\n.rounded-bottom-0 {\n    border-bottom-left-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n}\n\n.rounded-start-0 {\n    border-top-left-radius: 0 !important;\n    border-bottom-left-radius: 0 !important;\n}\n\n.rounded-end-0 {\n    border-top-right-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n}\n\n.rounded-circle {\n    border-radius: 50% !important;\n}\n","//\n// Flex Utilities\n//\n\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n    @include media-breakpoint-up($breakpoint) {\n        $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n        .flex#{$infix}-root {\n\t\t\tflex: 1;\n\t\t}\n\n        .flex#{$infix}-column-auto {\n            flex: none;\n        }\n\n        .flex#{$infix}-column-fluid {\n            flex: 1 0 auto;\n        }\n\n        .flex#{$infix}-row-auto {\n            flex: 0 0 auto;\n        }\n\n        .flex#{$infix}-row-fluid {\n            flex: 1 auto;\n            min-width: 0;\n        }\n\n    \t.flex#{$infix}-center {\n    \t\tjustify-content: center;\n    \t\talign-items: center;\n    \t}\n\n        .flex#{$infix}-stack {\n\t\t\tjustify-content: space-between;\n    \t\talign-items: center;\n\t\t}\n    }\n}\n\n.flex-equal {\n    flex-grow: 1;\n    flex-basis: 0;\n    flex-shrink: 0;\n}\n","//\n// Shadow\n//\n\n.shadow-xs {\n    box-shadow: $box-shadow-xs;\n}","//\n// Text\n//\n\n// Text colors\n@each $name, $color in $theme-text-colors {\n    // Base color\n    .text-#{$name} {\n        color: $color !important;\n    }\n\n    // Inverse color\n    @if (theme-inverse-color($name)) {\n        .text-inverse-#{$name} {\n            color: theme-inverse-color($name) !important;\n        }\n    }\n\n    @if (theme-light-color($name)) {\n        // Light colors\n        .text-light-#{$name} {\n            color: theme-light-color($name) !important;\n        }\n    }\n\n    // Hover\n    .text-hover-#{$name} {\n        transition: $transition-link;\n\n        i {\n            transition: $transition-link;\n        }\n\n        &:hover {\n            transition: $transition-link;\n            color: $color !important;\n\n            i {\n                transition: $transition-link;\n\t\t\t\tcolor: $color !important;\n\t\t\t}\n\n\t\t\t.svg-icon {\n\t\t\t\t@include svg-icon-color($color);\n\t\t\t}\n        }\n    }\n\n    // Hover inverse\n    @if (theme-inverse-color($name)) {\n        .text-hover-inverse-#{$name} {\n            transition: $transition-link;\n\n            i {\n                transition: $transition-link;\n            }\n\n            &:hover {\n                transition: $transition-link;\n                color: theme-inverse-color($name) !important;\n\n                i {\n                    transition: $transition-link;\n                    color: theme-inverse-color($name) !important;\n                }\n\n                .svg-icon {\n                    @include svg-icon-color(theme-inverse-color($name));\n                }\n            }\n        }\n    }\n\n    // Active\n    .text-active-#{$name} {\n        transition: $transition-link;        \n\n        i {\n            transition: $transition-link;\n        }\n\n        &.active {\n            transition: $transition-link;\n            color: $color !important;\n            \n            i {\n                transition: $transition-link;\n                color: $color !important;\n            }\n    \n            .svg-icon {\n                @include svg-icon-color($color);\n            }\n        }\n    }\n\n    // Active inverse\n    @if (theme-inverse-color($name)) {\n        .text-active-inverse-#{$name} {\n            transition: $transition-link;        \n\n            i {\n                transition: $transition-link;\n            }\n\n            &.active {\n                transition: $transition-link;\n                color: theme-inverse-color($name) !important;\n\n                i {\n                    transition: $transition-link;\n                    color: theme-inverse-color($name) !important;\n                }\n\n                .svg-icon {\n                    @include svg-icon-color(theme-inverse-color($name));\n                }\n            }\n        }\n    }\n}\n\n// Text transparent\n.fw-boldest {\n    font-weight: $font-weight-boldest !important;\n}\n\n// Text transparent\n.text-transparent {\n    color: transparent;\n}\n\n// Cursor pointer\n.cursor-pointer {\n    cursor: pointer;\n}\n\n// Cursor default\n.cursor-default {\n    cursor: default;\n}\n// Cursor move\n.cursor-move {\n    cursor: move;\n}\n\n// Icons\ni {\n    line-height: 1;\n    font-size: 1rem;\n    color: $text-muted;\n}\n\n// Link transition\na {\n    transition: $transition-link;\n\n    &:hover {\n        transition:$transition-link;\n    }\n}\n","//\n// SVG Icon\n//\n\n\n@mixin svg-icon-color($color, $important: false) {\n    svg {\n        [fill]:not(.permanent):not(g) {\n            transition: fill 0.3s ease;\n            fill: $color valueif($important, !important, null);\n        }\n\n        &:hover {\n            [fill]:not(.permanent):not(g) {\n                transition: fill 0.3s ease;\n            }\n        }\n    }\n}\n\n@mixin svg-icon-transition() {\n    svg {\n        [fill]:not(g) {\n            transition: fill 0.3s ease;\n        }\n    }\n}\n\n@mixin svg-icon-size($size, $important: false) {\n    svg {\n        height: $size valueif($important, !important, null);\n        width: $size valueif($important, !important, null);\n    }\n}\n","//\n// Opacity\n//\n\n@each $name, $value in $opacity-values {\n\t// Active state\n\t.opacity-active-#{$name}.active {\n\t\topacity: #{$value} !important;\n\t}\n\n\t// Active and hover states\n\t.opacity-state-#{$name} {\n\t\t&:hover,\n\t\t&.active {\n\t\t\topacity: #{$value} !important;\n\t\t}\n\t}\n}","//\n// Transform\n//\n\n.transform-90 {\n    transform: rotate(90deg);\n    transform-origin: right top;\n}","//\n// Animation\n//\n\n// Base\n.animation {\n  animation-duration: 1s;\n  animation-fill-mode: both;\n}\n\n// Slide In Down\n@keyframes animationSlideInDown {\n    from {\n        transform: translate3d(0, -100%, 0);\n        visibility: visible;\n    }\n\n    to {\n        transform: translate3d(0, 0, 0);\n    }\n}\n\n.animation-slide-in-down {\n    animation-name: animationSlideInDown;\n}\n\n// Slide In Up\n@keyframes animationSlideInUp {\n    from {\n        transform: translate3d(0, 100%, 0);\n        visibility: visible;\n    }\n\n    to {\n        transform: translate3d(0, 0, 0);\n    }\n}\n\n.animation-slide-in-up {\n    animation-name: animationSlideInUp;\n}\n\n// Fade In\n@keyframes animationFadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n.animation-fade-in {\n    animation-name: animationFadeIn;\n}\n\n// Fade Out\n@keyframes animationFadeOut {\n    from {\n        opacity: 1;\n    }\n\n    to {\n        opacity: 0;\n    }\n}\n.animation-fade-out {\n    animation-name: animationFadeOut;\n}\n\n// Blink\n.animation-blink {\n    animation: animationBlink 1s steps(5, start) infinite;\n}\n\n@keyframes animationBlink {\n    to {\n        visibility: hidden;\n    }\n}","//\n// Nav\n//\n\n// Line tabs\n.nav-line-tabs {\n\tborder-bottom-width: 1px;\n\tborder-bottom-style: solid;\n\tborder-bottom-color: $border-color;\n\n\t.nav-item {\n\t\tmargin-bottom: -1px;\n\n\t\t// Base link\n\t\t.nav-link {\n\t\t\tcolor: $gray-500;\n\t\t\tborder: 0;\n\t\t\tborder-bottom: 1px solid transparent;\n\t\t\ttransition: $transition-link;\n\t\t\tpadding: 0.5rem 0;\n\t\t\tmargin: 0 1rem;\n\t\t}\n\n\t\t// First Item\n\t\t&:first-child {\n\t\t\t.nav-link {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\t\t}\n\n\t\t// Last Item\n\t\t&:last-child {\n\t\t\t.nav-link {\n\t\t\t\tmargin-right: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t// Active & Hover States\n\t.nav-item .nav-link.active,\n  \t.nav-item.show .nav-link,\n\t.nav-item .nav-link:hover:not(.disabled) {\n\t\tbackground-color: transparent;\n\t\tborder: 0;\n\t\tborder-bottom: 1px solid $primary;\n\t\ttransition: $transition-link;\n  \t}\n\n\t// 2x Line\n\t&.nav-line-tabs-2x {\n\t\tborder-bottom-width: 2px;\n\n\t\t.nav-item {\n\t\t\tmargin-bottom: -2px;\n\n\t\t\t.nav-link {\n\t\t\t\tborder-bottom-width: 2px;\n\t\t\t}\n\t\t}\n\n\t\t// Active & Hover States\n\t\t.nav-item .nav-link.active,\n\t  \t.nav-item.show .nav-link,\n\t\t.nav-item .nav-link:hover:not(.disabled) {\n\t\t\tborder-bottom-width: 2px;\n\t\t}\n\t}\n}\n\n// Nav Pills\n.nav-pills {\n\t.nav-item {\n\t\tmargin-right: 0.5rem;\n\n\t\t&:last-child {\n\t\t\tmargin-right: 0;\n\t\t}\n\t}\n}\n\n// Stretch items\n.nav-stretch {\n\talign-items: stretch;\n\tpadding-top: 0 !important;\n\tpadding-bottom: 0 !important;\n\n\t.nav-item {\n\t\tdisplay: flex;\n\t\talign-items: stretch;\n\t\tpadding-top: 0 !important;\n\t\tpadding-bottom: 0 !important;\n\t}\n\n\t.nav-link {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n}\n\n// Nav group\n.nav-group {\n\tpadding: 0.35rem;\n\t@include border-radius($border-radius);\n\tbackground-color: $gray-100;\n\n\t// Outline nav group\n\t&.nav-group-outline {\t\n\t\tbackground-color: transparent;\n\t\tborder: 1px solid $border-color;\t\n\t}\n\n\t// Fluid option\n\t&.nav-group-fluid {\n\t\tdisplay: flex;\n\n\t\t> label,\n\t\t> .btn {\n\t\t\tposition: relative;\n\t\t\tflex-shrink: 0;\n\t\t\tflex-grow: 1;\n\t\t\tflex-basis: 0;\n\t\t}\n\n\t\t> label {\n\t\t\tmargin-right: 0.1rem;\n\n\t\t\t> .btn {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\n\t\t\t&:last-child {\n\t\t\t\tmargin-right: 0;\n\t\t\t}\n\t\t}\n\t}\n}","//\n// Custom Nav Pills\n//\n\n.nav.nav-pills.nav-pills-custom {\n\t// States\n\t.show > .nav-link,\n\t.nav-link{\t\t\n\t\tborder: 1px dashed $border-dashed-color;\n\t\tborder-radius: 12px;\n\t\t\n        .nav-icon {\n            img {\n                width: 30px;\n                transition: $transition-link;\n\n                &.default {\n                    display: inline-block;\n                }\n\n                &.active {\n                    display: none;\n                }\n            }\n        }\n\n        &.active {\t\n\t\t\tbackground-color: transparent;\t\t\n\t\t\tborder: 1px solid $border-dashed-color;\n\t\t\ttransition-duration: 1ms;\t\t\t\n\t\t\tposition: relative;\n\n\t\t\t.nav-text {\n\t\t\t\tcolor: $gray-800 !important;\n\t\t\t\ttransition: $transition-link;\n\t\t\t}\n\t\t\t\n\t\t\t.bullet-custom {\n\t\t\t\tdisplay: block;\t\t\t  \t\n\t\t\t}\n\t\t}\n\n\t\t.bullet-custom {\n\t\t\tdisplay: none;\t\t\t  \t\n\t\t}\n\t}\n}\n","//\n// Pagination\n//\n\n.pagination {\n\tdisplay:flex;\n\tflex-wrap: wrap;\n\tjustify-content: center;\n\tmargin: 0;\n\n\t// Pagination circle\n\t&.pagination-circle {\n\t\t.page-link {\n\t\t\tborder-radius: 50%;\n\t\t}\n\t}\n\n\t// Pagination outline\n\t&.pagination-outline {\n\t\t.page-link {\n\t\t\tborder: 1px solid $border-color;\n\t\t}\n\n\t\t.page-item {\n\t\t\t&:hover,\n\t\t    &.active {\n\t\t\t    .page-link {\n\t\t\t        border-color: $primary-light;\n\t\t\t\t}\t\n\t\t\t}\n\t\t}\n\t}\t\t\n}\n\n.page-item {\n    margin-right: $pagination-item-space;\n\n\t&:last-child {\n        margin-right: 0;\n    }\n\n\t.page-link {\n\t\tdisplay:flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tborder-radius: $btn-border-radius;\n\t\theight: $pagination-item-height;\n\t\tmin-width: $pagination-item-height;\n\t\tfont-weight: $pagination-font-weight;\n\t\tfont-size: $pagination-font-size;\n\n\t\ti {\n\t\t\tfont-size: $pagination-icon-font-size;\n\t\t}\n\n\t\t/*rtl:options:{\"autoRename\":false}*/\n\t\t.previous,\n\t\t.next {\n\t\t\tdisplay: block;\n\t\t\theight: $pagination-icon-height;\n\t\t\twidth: $pagination-icon-height;\n\n\t\t\t/*rtl:raw:transform: rotateZ(-180deg);*/\n\t\t}\n\t\t/*rtl:end:ignore*/\n\n\t\t.previous {\n\t\t\t\t@include svg-bg-icon(arrow-start, $pagination-color);\n\t\t\t}\n\n\t\t/*rtl:options:{\"autoRename\":false}*/\n\t\t.next {\n\t\t\t@include svg-bg-icon(arrow-end, $pagination-color);\n\t\t}\n\t}\n\n\t/*rtl:options:{\"autoRename\":false}*/\n\t&.next,\n\t&.previous {\n\t\t.page-link {\n\t\t\tbackground-color: $pagination-item-bg;\n\n\t\t\ti {\n\t\t\t\tcolor: $pagination-color;\n\t\t\t}\n\t\n\t\t\t.svg-icon {\n\t\t\t\t@include svg-icon-color($pagination-color);\n\t\t\t}\n\t\t}\n\t}\n\n\t&:focus {\n\t\t.page-link {\n\t\t\ti {\n\t\t\t\tcolor: $pagination-focus-color;\n\t\t\t}\n\t\n\t\t\t.svg-icon {\n\t\t\t\t@include svg-icon-color($pagination-focus-color);\n\t\t\t}\n\n\t\t\t.previous {\n\t\t\t\t@include svg-bg-icon(arrow-start, $pagination-focus-color);\n\t\t\t}\n\n\t\t\t/*rtl:options:{\"autoRename\":false}*/\n\t\t\t.next {\n\t\t\t\t@include svg-bg-icon(arrow-end, $pagination-focus-color);\n\t\t\t}\n\t\t}\n\t}\n\n\t&:hover {\n\t\t.page-link {\n\t\t\ti {\n\t\t\t\tcolor: $pagination-hover-color;\n\t\t\t}\n\t\n\t\t\t.svg-icon {\n\t\t\t\t@include svg-icon-color($pagination-hover-color);\n\t\t\t}\n\n\t\t\t.previous {\n\t\t\t\t@include svg-bg-icon(arrow-start, $pagination-hover-color);\n\t\t\t}\n\n\t\t\t/*rtl:options:{\"autoRename\":false}*/\n\t\t\t.next {\n\t\t\t\t@include svg-bg-icon(arrow-end, $pagination-hover-color);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.active {\n\t\t.page-link {\n\t\t\ti {\n\t\t\t\tcolor: $pagination-active-color;\n\t\t\t}\n\t\n\t\t\t.svg-icon {\n\t\t\t\t@include svg-icon-color($pagination-active-color);\n\t\t\t}\n\n\t\t\t.previous {\n\t\t\t\t@include svg-bg-icon(arrow-start, $pagination-active-color);\n\t\t\t}\n\n\t\t\t/*rtl:options:{\"autoRename\":false}*/\n\t\t\t.next {\n\t\t\t\t@include svg-bg-icon(arrow-end, $pagination-active-color);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.disabled {\n\t\t.page-link {\n\t\t\ti {\n\t\t\t\tcolor: $pagination-disabled-color;\n\t\t\t}\n\t\n\t\t\t.svg-icon {\n\t\t\t\t@include svg-icon-color($pagination-disabled-color);\n\t\t\t}\n\n\t\t\t.previous {\n\t\t\t\t@include svg-bg-icon(arrow-start, $pagination-disabled-color);\n\t\t\t}\n\n\t\t\t/*rtl:options:{\"autoRename\":false}*/\n\t\t\t.next {\n\t\t\t\t@include svg-bg-icon(arrow-end, $pagination-disabled-color);\n\t\t\t}\n\t\t}\n\t}\n\t/*rtl:end:ignore*/\n}\n\n// Tablet & mobile modes\n@include media-breakpoint-down(lg) {\n\t.page-item {\n\t\tmargin-right: $pagination-item-space-tablet-and-mobile;\n\n\t\t&:last-child {\n\t\t\tmargin-right: 0;\n\t\t}\n\t}\n}\n\n","//\n// SVG Bg Icons\n//\n\n@mixin svg-bg-icon($type, $color, $update: false) {\n    $bg-image: '';\n\n    // Icon type;\n    @if ($type == close) {\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\");\n    }\n\n    @if ($type == check) {\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'><path fill='#{$color}' d='M4.89557 6.49823L2.79487 4.26513C2.26967 3.70683 1.38251 3.70683 0.857309 4.26513C0.375593 4.77721 0.375593 5.57574 0.857309 6.08781L4.74989 10.2257C5.14476 10.6455 5.81176 10.6455 6.20663 10.2257L13.1427 2.85252C13.6244 2.34044 13.6244 1.54191 13.1427 1.02984C12.6175 0.471537 11.7303 0.471536 11.2051 1.02984L6.06096 6.49823C5.74506 6.83403 5.21146 6.83403 4.89557 6.49823Z'/></svg>\");\n    }\n\n    @if ($type == arrow-top) {\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9 8' fill='#{$color}'><path fill-rule='evenodd' clip-rule='evenodd' d='M4.42111 2.06463C4.22088 1.96161 3.9637 1.9809 3.78597 2.12863L0.177181 5.12847C-0.046034 5.31402 -0.0602611 5.63049 0.145404 5.83532C0.351069 6.04015 0.698744 6.05578 0.921959 5.87023L4.14137 3.19406L7.06417 5.84414C7.27904 6.03896 7.62686 6.03835 7.84105 5.84278C8.05524 5.64721 8.05469 5.33073 7.83982 5.13591L4.54449 2.14806C4.50704 2.1141 4.46541 2.08629 4.42111 2.06463Z'/></svg>\");\n    }\n\n    @if ($type == arrow-bottom) {\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9 8' fill='#{$color}'><path fill-rule='evenodd' clip-rule='evenodd' d='M4.42111 5.93537C4.22088 6.03839 3.9637 6.0191 3.78597 5.87137L0.177181 2.87153C-0.046034 2.68598 -0.060261 2.36951 0.145404 2.16468C0.351069 1.95985 0.698744 1.94422 0.921959 2.12977L4.14137 4.80594L7.06417 2.15586C7.27904 1.96104 7.62686 1.96165 7.84105 2.15722C8.05524 2.35279 8.05469 2.66927 7.83982 2.86409L4.54449 5.85194C4.50704 5.8859 4.46541 5.91371 4.42111 5.93537Z'/></svg>\");\n    }\n\n    @if ($type == arrow-start) {\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='#{$color}'><path fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/></svg>\");\n    }\n\n    @if ($type == arrow-end) {\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='#{$color}'><path fill-rule='evenodd' clip-rule='evenodd' d='M5.93537 4.57889C6.03839 4.77912 6.0191 5.0363 5.87137 5.21403L2.87153 8.82282C2.68598 9.04603 2.36951 9.06026 2.16468 8.8546C1.95985 8.64893 1.94422 8.30126 2.12977 8.07804L4.80594 4.85863L2.15586 1.93583C1.96104 1.72096 1.96165 1.37314 2.15722 1.15895C2.35279 0.944757 2.66927 0.945311 2.86409 1.16018L5.85194 4.45551C5.8859 4.49296 5.91371 4.53459 5.93537 4.57889Z'/></svg>\");\n    }\n\n    // Icon style\n    @if $update == false {\n        background-repeat: no-repeat;\n        background-position: center;\n        background-color: transparent; \n    }   \n\n    background-image: escape-svg($bg-image);\n}\n\n","//\n// Separator\n//\n\n.separator {\n    display: block;\n    height: 0;\n    border-bottom: 1px solid $border-color;\n\n    &.separator-dotted {\n        border-bottom-style: dotted;\n        border-bottom-color: $border-dashed-color;\n    }\n\n    &.separator-dashed {\n        border-bottom-style: dashed;\n        border-bottom-color: $border-dashed-color;\n    }\n\n    &.separator-content {\n        display: flex;\n        align-items: center;\n        border-bottom: 0;\n        text-align: center;\n\n        &::before,\n        &::after {\n            content: \" \";\n            width: 50%;\n            border-bottom: 1px solid $border-color;\n        }\n\n        &::before{\n            margin-right: 1.25rem;\n        }\n\n        &::after{\n            margin-left: 1.25rem;\n        }\n\n        &.separator-dotted {\n            &::before,\n            &::after {\n                border-bottom-style: dotted;\n                border-bottom-color: $border-dashed-color;\n            }\n        }\n\n        &.separator-dashed {\n            &::before,\n            &::after {\n                border-bottom-style: dashed;\n                border-bottom-color: $border-dashed-color;\n            }\n        }\n\n        @each $color, $value in $theme-colors {\n            &.border-#{$color}{\n                &::before,\n                &::after {\n                    border-color: $value !important; \n                }\n            }\n        }\n    }\n}\n","//\n// Carousel\n//\n\n\n.carousel.carousel-custom {\n    // Indicators\n    .carousel-indicators {\n        align-items: center;\n        position: static;\n        z-index: auto;\n        margin: 0;\n        padding: 0;\n        list-style: none;\n\n        li {\n            transform: none;\n            opacity: 1;\n\n            &.active {\n                transform: none;\n                opacity: 1;\n            }\n        }\n\n        &.carousel-indicators-dots {\n            li {\n                border-radius: 0;\n                background-color: transparent;\n                height: $carousel-custom-dots-indicator-active-size;\n                width: $carousel-custom-dots-indicator-active-size;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                text-align: center;\n\n                &:after {\n                    display: inline-block;\n                    content: \" \";\n                    @include border-radius(50%);\n                    transition: all $carousel-custom-indicator-transition-speed ease;\n                    background-color: $carousel-custom-indicator-default-bg-color;\n                    height: $carousel-custom-dots-indicator-default-size;\n                    width: $carousel-custom-dots-indicator-default-size;\n                }\n\n                &.active {\n                    background-color: transparent;\n\n                    &:after {\n                        transition: all $carousel-custom-indicator-transition-speed ease;\n                        height: $carousel-custom-dots-indicator-active-size;\n                        width: $carousel-custom-dots-indicator-active-size;\n                        background-color: $carousel-custom-indicator-active-bg-color;\n                    }\n                }\n            }\n        }\n    }\n\n    // Stretch mode\n    &.carousel-stretch {\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n\n        .carousel-inner {\n            flex-grow: 1;\n        }\n\n        .carousel-item {\n            height: 100%;\n        }\n\n        .carousel-wrapper {\n            display: flex;\n            flex-direction: column;\n            height: 100%;\n        }\n    }   \n}\n","//\n// Menu Base\n//\n\n// Menu group\n.menu-group {\n    display: flex;\n}\n\n// Menu & wrapper\n.menu,\n.menu-wrapper {\n    display: flex;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n\n// Sub menu\n.menu-sub {\n    display: none;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    flex-direction: column;\n}\n\n// Menu item\n.menu-item {\n    display: block;\n    padding: 0;\n\n    // Menu Link\n    .menu-link {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        padding: 0;\n        flex: 0 0 100%;\n        padding: get($menu, link, self, padding-y) get($menu, link, self, padding-x);\n        transition: none;\n        outline: none !important;\n\n        // Menu Icon\n        .menu-icon {\n            flex-shrink: 0;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: get($menu, link, icon, width);\n            margin-right: get($menu, link, icon, space);\n\n            .svg-icon {\n                line-height: 1;\n            }\n        }\n\n        // Menu Icon\n        .menu-bullet {\n            flex-shrink: 0;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: get($menu, link, bullet, width);\n            margin-right: get($menu, link, bullet, space);\n        }\n\n        // Menu Label\n        .menu-title {\n            display: flex;\n            align-items: center;\n            flex-grow: 1;\n        }\n\n        // Menu Label\n        .menu-badge {\n            flex-shrink: 0;\n            margin-left: get($menu, link, badge, space);\n        }\n\n        // Menu Arrow\n        .menu-arrow {\n            display: flex;\n            align-items: stretch;\n            position: relative;\n            overflow: hidden;\n            flex-shrink: 0;\n            margin-left: get($menu, link, arrow, space);\n            width: get($menu, link, arrow, width);\n            height: get($menu, link, arrow, height);\n\n            &:after {\n                display: block;\n                width: 100%;\n                content: \" \";\n                @include svg-bg-icon(arrow-start, $text-muted);\n                /*rtl:begin:remove*/\n                @include svg-bg-icon(arrow-end, $text-muted);\n                /*rtl:end:remove*/\n            }\n        }\n    }\n\n    // Menu Content\n    .menu-content {\n        padding: get($menu, link, self, padding-y) get($menu, link, self, padding-x);\n    }\n}\n\n// Accordion arrows\n.menu-item {    \n    &.show {\n        .menu-link {\n            .menu-arrow:after {\n                -webkit-backface-visibility: hidden;\n                transition: get($menu, accordion, arrow-transition);\n            }\n        }\n    }\n}\n\n// Center alignment\n.menu-center {\n    justify-content: center;\n}\n\n// Responsive \n@each $direction in (up, down) {\n    @each $breakpoint in map-keys($grid-breakpoints) {\n        $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n        @if $infix and $direction == down {\n            $infix: $infix + \"-\" + $direction;\n        }\n\n        @include media-breakpoint-direction($direction, $breakpoint) {\n            // Accordion arrow\n            .menu-item.menu#{$infix}-accordion {\n                &.showing:not(.menu-dropdown),\n                &.show:not(.hiding):not(.menu-dropdown) {\n                    > .menu-link {\n                        .menu-arrow:after {\n                            @include menu-link-arrow-rotate(90deg, -90deg);\n                        }\n                    }\n                }\n            }\n\n            // Sub dropdown\n            .menu-sub#{$infix}-dropdown {\n                display: none;\n                border-radius: get($menu, dropdown, border-radius);\n                background-color: get($menu, dropdown, background-color);\n                box-shadow: get($menu, dropdown, box-shadow);\n                z-index: get($menu, dropdown, z-index);\n\n                // Dropdown show\n                .show.menu-dropdown > &,\n                &.menu.show,\n                &.show[data-popper-placement] {\n                    display: flex;\n\n                    // Animation\n                    @if (get($menu, dropdown, animation) == true) {\n                        // Move up\n                        animation: menu-sub-dropdown-animation-fade-in #{get($menu, dropdown, animation-speed)} ease 1, menu-sub-dropdown-animation-move-up #{get($menu, dropdown, animation-speed)} ease 1;\n                        \n                        // Move down\n                        &[data-popper-placement=\"top\"],\n                        &[data-popper-placement=\"top-start\"],\n                        &[data-popper-placement=\"top-end\"] {\n                            animation: menu-sub-dropdown-animation-fade-in #{get($menu, dropdown, animation-speed)} ease 1, menu-sub-dropdown-animation-move-down #{get($menu, dropdown, animation-speed)} ease 1;\n                        }                        \n                    }                    \n                }\n            }\n\n            // Sub accordion\n            .menu-sub#{$infix}-accordion {\n                display: none;\n\n                .show:not(.menu-dropdown) > &,\n                &.show {\n                    display: flex;\n                }\n            }\n\n            // Inline\n            .menu#{$infix}-inline {\n                display: flex;\n            }\n\n            // Reset link left & right paddings of level 1 menu links\n            .menu#{$infix}-fit {\n                > .menu-item {\n                    > .menu-content,\n                    > .menu-link {\n                        padding-left: 0 !important;\n                        padding-right: 0 !important;\n                    }\n                }\n            }\n\n            .menu#{$infix}-column {\n                flex-direction: column;\n                width: 100%;\n            }\n\n            .menu#{$infix}-row {\n                flex-direction: row;\n\n                > .menu-item {\n                    display: flex;\n                    align-items: center;\n\n                    > .menu-link {\n                        .menu-arrow:after {\n                            @include menu-link-arrow-rotate(90deg, -90deg);\n                        }\n                    }\n                }\n            }\n\n            // Border radiuses\n            .menu#{$infix}-rounded {\n                .menu-link {\n                    @include border-radius($border-radius);\n                }\n            }\n\n            // Border radiuses\n            .menu#{$infix}-pill {\n                .menu-link {\n                    border-radius: 50px;\n                }\n            }\n\n            // Reset border radiuses\n            .menu#{$infix}-rounded-0 {\n                .menu-link {\n                    border-radius: 0 !important;\n                }\n            }\n        }\n    }\n}\n\n// Menu indention\n@include menu-link-indention(get($menu, accordion, indention), get($menu, link, self, padding-x));\n\n// Menu animations\n@keyframes menu-sub-dropdown-animation-fade-in {\n    from   { opacity: 0; }\n    to { opacity: 1; }\n}\n\n@keyframes menu-sub-dropdown-animation-move-up {\n    from   { margin-top: #{get($menu, dropdown, animation-move-offset)} }\n    to { margin-top: 0 }\n}\n\n@keyframes menu-sub-dropdown-animation-move-down {\n    from   { margin-bottom: #{get($menu, dropdown, animation-move-offset)} }\n    to { margin-bottom: 0 }\n}","//\n// Label\n//\n\n// Set arrow direction\n@mixin menu-link-arrow-rotate($angle, $angleRtl) {\n\t/*rtl:ignore*/\n\ttransform: rotateZ($angle);\n\ttransition: get($menu, accordion, arrow-transition);\n\t\n\t[direction=\"rtl\"] & {\n\t\t/*rtl:ignore*/\n\t\ttransform: rotateZ($angleRtl);\n\t}\n}\n\n// Set menu link padding x\n@mixin menu-link-padding-x($value) {\n\t// Menu item\n\t.menu-item {\n\t\t.menu-link,\n\t\t.menu-content {\n\t\t\tpadding-left: $value;\n\t\t\tpadding-right: $value;\n\t\t}\n\t}\n}\n\n// Set menu link padding y\n@mixin menu-link-padding-y($value) {\n\t// Menu item\n\t.menu-item {\n\t\t.menu-link,\n\t\t.menu-content {\n\t\t\tpadding-top: $value;\n\t\t\tpadding-bottom: $value;\n\t\t}\n\t}\n}\n\n// Set menu indention\n@mixin menu-link-indention($value, $offset) {\n\t// Accordion mode\t\t\t\n\t.menu-sub:not([data-popper-placement]) {\n\t\t> .menu-item {\n\t\t\t> .menu-content,\n\t\t\t> .menu-link {\n\t\t\t\tpadding-left: calc(#{1 * $value} + #{$offset});\n\t\t\t}\n\n\t\t\t> .menu-sub:not([data-popper-placement]) {\n\t\t\t\t> .menu-item {\n\t\t\t\t\t> .menu-content,\n\t\t\t\t\t> .menu-link {\n\t\t\t\t\t\tpadding-left: calc(#{2 * $value} + #{$offset});\n\t\t\t\t\t}\n\n\t\t\t\t\t> .menu-sub:not([data-popper-placement]) {\n\t\t\t\t\t\t> .menu-item {\n\t\t\t\t\t\t\t> .menu-content,\n\t\t\t\t\t\t\t> .menu-link {\n\t\t\t\t\t\t\t\tpadding-left: calc(#{3 * $value} + #{$offset});\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t> .menu-sub:not([data-popper-placement]) {\n\t\t\t\t\t\t\t\t> .menu-item {\n\t\t\t\t\t\t\t\t\t> .menu-content,\n\t\t\t\t\t\t\t\t\t> .menu-link {\n\t\t\t\t\t\t\t\t\t\tpadding-left: calc(#{4 * $value} + #{$offset});\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.menu-fit & {\n\t\t\t> .menu-item {\n\t\t\t\t> .menu-content,\n\t\t\t\t> .menu-link {\n\t\t\t\t\tpadding-left: #{$value};\n\t\t\t\t\tpadding-right: 0;\n\t\t\t\t}\n\t\t\n\t\t\t\t> .menu-sub:not([data-popper-placement]) {\n\t\t\t\t\t> .menu-item {\n\t\t\t\t\t\t> .menu-content,\n\t\t\t\t\t\t> .menu-link {\n\t\t\t\t\t\t\tpadding-left: calc(#{2 * $value});\n\t\t\t\t\t\t\tpadding-right: 0;\n\t\t\t\t\t\t}\n\t\t\n\t\t\t\t\t\t> .menu-sub:not([data-popper-placement]) {\n\t\t\t\t\t\t\t> .menu-item {\n\t\t\t\t\t\t\t\t> .menu-content,\n\t\t\t\t\t\t\t\t> .menu-link {\n\t\t\t\t\t\t\t\t\tpadding-left: calc(#{3 * $value});\n\t\t\t\t\t\t\t\t\tpadding-right: 0;\n\t\t\t\t\t\t\t\t}\n\t\t\n\t\t\t\t\t\t\t\t> .menu-sub:not([data-popper-placement]) {\n\t\t\t\t\t\t\t\t\t> .menu-item {\n\t\t\t\t\t\t\t\t\t\t> .menu-content,\n\t\t\t\t\t\t\t\t\t\t> .menu-link {\n\t\t\t\t\t\t\t\t\t\t\tpadding-left: calc(#{4 * $value});\n\t\t\t\t\t\t\t\t\t\t\tpadding-right: 0;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n// Set menu link theme\n@mixin menu-link-theme($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color: null) {\n\t@if ( $bg-color != null ) {\n\t\tbackground-color: $bg-color;\n\t}\n\n\t@if ( $title-color != null ) {\n\t\tcolor: $title-color;\n\n\t\t.menu-title {\n\t\t\tcolor: $title-color;\n\t\t}\n\t}\n\n\t@if ( $icon-color != null ) {\n\t\t.menu-icon {\n\t\t\t// Font Icon\n\t\t\ti {\n\t\t\t\tcolor: $icon-color;\n\t\t\t}\n\n\t\t\t// Svg icon\n\t\t\t.svg-icon {\n\t\t\t\t@include svg-icon-color($icon-color);\n\t\t\t}\n\t\t}\n\t}\n\n\t@if ( $bullet-color != null ) {\n\t\t.menu-bullet {\n\t\t\t.bullet {\n\t\t\t\tbackground-color: $bullet-color;\n\t\t\t}\n\t\t}\n\t}\n\n\t@if ( $arrow-color != null ) {\n\t\t// Arrow\n\t\t.menu-arrow:after {\n\t\t\t@include svg-bg-icon(arrow-start, $arrow-color);\n\t\t\t/*rtl:begin:remove*/\n\t\t\t@include svg-bg-icon(arrow-end, $arrow-color);\n\t\t\t/*rtl:end:remove*/\n\t\t}\n\t}\n}\n\n// Set menu link default state\n@mixin menu-link-default-state($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color: null, $all-links: true) {\n\t$sel: '';\n\n\t@if ($all-links == false) {\n\t\t$sel: '& > ';\n\t}\n\n\t#{$sel}.menu-link {\n\t\t@include menu-link-theme($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color);\n\t}\n}\n\n// Set menu link hover state\n@mixin menu-link-hover-state($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color: null, $all-links: true) {\n\t$sel: '&:not(.here) ';\n\n\t@if ($all-links == false) {\n\t\t$sel: '&:not(.here) > ';\n\t}\n\n\t&.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here),\n\t#{$sel}.menu-link:hover:not(.disabled):not(.active):not(.here) {\n\t\ttransition: $transition-link;\n\n\t\t@include menu-link-theme($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color);\n\t}\n}\n\n// Set menu link active state\n@mixin menu-link-active-state($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color: null, $all-links: true) {\n\t$sel: '';\n\n\t@if ($all-links == false) {\n\t\t$sel: '& > ';\n\t}\n\n\t#{$sel}.menu-link.active {\n\t\ttransition: $transition-link;\n\n\t\t@include menu-link-theme($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color);\n\t}\n}\n\n// Set menu link show state\n@mixin menu-link-show-state($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color: null, $all-links: true) {\n\t//&.here > .menu-link,\n\t&.show > .menu-link {\n\t\ttransition: $transition-link;\n\n\t\t@include menu-link-theme($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color);\n\t}\n}\n\n// Set menu link here state\n@mixin menu-link-here-state($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color: null, $all-links: true) {\n\t&.here > .menu-link {\n\t\ttransition: $transition-link;\n\n\t\t@include menu-link-theme($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color);\n\t}\n}\n","// Media of at most the maximum and minimum breakpoint widths. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint.\n\n@mixin media-breakpoint-direction($direction, $name, $breakpoints: $grid-breakpoints) {\n    @if $direction == up {\n        $min: breakpoint-min($name, $breakpoints);\n\n        @if $min {\n            @media (min-width: $min) {\n                @content;\n            }\n        } @else {\n            @content;\n        }\n\n    } @else if $direction == down {\n        $max: breakpoint-max($name, $breakpoints);\n\n        @if $max {\n            @media (max-width: $max) {\n                @content;\n            }\n        }\n    }\n}","//\n// Menu Theme\n//\n\n// Theme text colors\n@each $name, $color in $theme-text-colors {\n    .menu-#{$name} {\n        .menu-item {\n            //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n            @include menu-link-default-state( $color, $color, $color, $color, null );\n        }\n    }\n\n    .menu-title-#{$name} {\n        .menu-item {\n            //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n            @include menu-link-default-state( $color, null, null, null, null );\n        }\n    }\n\n    .menu-icon-#{$name} {\n        .menu-item {\n            //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n            @include menu-link-default-state( null, $color, null, null, null );\n        }\n    }\n\n    .menu-bullet-#{$name} {\n        .menu-item {\n            //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n            @include menu-link-default-state( null, null, $color, null, null );\n        }\n    }\n\n    .menu-arrow-#{$name} {\n        .menu-item {\n            //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n            @include menu-link-default-state( null, null, null, $color, null );\n        }\n    }\n}\n\n// Default background states\n.menu-hover-bg {\n    .menu-item {\n        @include menu-link-hover-state( null, null, null, null, get($menu, link, self, bg-color, hover) );\n    }\n}\n\n.menu-here-bg {\n    .menu-item {\n        @include menu-link-here-state( null, null, null, null, get($menu, link, self, bg-color, here) );\n    }\n}\n\n.menu-show-bg {\n    .menu-item {\n        @include menu-link-show-state( null, null, null, null, get($menu, link, self, bg-color, show) );\n    }\n}\n\n.menu-active-bg {\n    .menu-item {\n        @include menu-link-active-state( null, null, null, null, get($menu, link, self, bg-color, active) );\n    }\n}\n\n.menu-state-bg {\n    .menu-item {\n        @include menu-link-hover-state( null, null, null, null, get($menu, link, self, bg-color, hover) );\n        @include menu-link-here-state( null, null, null, null, get($menu, link, self, bg-color, here) );\n        @include menu-link-show-state( null, null, null, null, get($menu, link, self, bg-color, show) );\n        @include menu-link-active-state( null, null, null, null, get($menu, link, self, bg-color, active) );\n    }\n}\n\n// Primary text states\n.menu-hover-primary {\n    .menu-item {\n        @include menu-link-hover-state( $primary, $primary, $primary, $primary, null );\n    }\n}\n\n.menu-show-primary {\n    .menu-item {\n        @include menu-link-show-state( $primary, $primary, $primary, $primary, null );\n    }\n}\n\n.menu-here-primary {\n    .menu-item {\n        @include menu-link-here-state( $primary, $primary, $primary, $primary, null );\n    }\n}\n\n.menu-active-primary {\n    .menu-item {\n        @include menu-link-active-state( $primary, $primary, $primary, $primary, null );\n    }\n}\n\n.menu-state-primary {\n    .menu-item {\n        @include menu-link-hover-state( $primary, $primary, $primary, $primary, null );\n        @include menu-link-show-state( $primary, $primary, $primary, $primary, null );\n        @include menu-link-here-state( $primary, $primary, $primary, $primary, null );\n        @include menu-link-active-state( $primary, $primary, $primary, $primary, null );\n    }\n}\n\n// Primary background states\n.menu-hover-bg-primary {\n    .menu-item {\n        @include menu-link-hover-state( $primary-inverse, $primary-inverse, $primary-inverse, $primary-inverse, $primary );\n    }\n}\n\n.menu-show-bg-primary {\n    .menu-item {\n        @include menu-link-show-state( $primary-inverse, $primary-inverse, $primary-inverse, $primary-inverse, $primary );\n    }\n}\n\n.menu-here-bg-primary {\n    .menu-item {\n        @include menu-link-here-state( $primary-inverse, $primary-inverse, $primary-inverse, $primary-inverse, $primary );\n    }\n}\n\n.menu-active-bg-primary {\n    .menu-item {\n        @include menu-link-active-state( $primary-inverse, $primary-inverse, $primary-inverse, $primary-inverse, $primary );\n    }\n}\n\n.menu-state-bg-primary {\n    .menu-item {\n        @include menu-link-hover-state( $primary-inverse, $primary-inverse, $primary-inverse, $primary-inverse, $primary );\n        @include menu-link-show-state( $primary-inverse, $primary-inverse, $primary-inverse, $primary-inverse, $primary );\n        @include menu-link-here-state( $primary-inverse, $primary-inverse, $primary-inverse, $primary-inverse, $primary );\n        @include menu-link-active-state( $primary-inverse, $primary-inverse, $primary-inverse, $primary-inverse, $primary );\n    }\n}\n\n// Light primary background states\n.menu-show-bg-light-primary {\n    .menu-item {\n        @include menu-link-show-state( $primary, $primary, $primary, $primary, $primary-light );\n    }\n}\n\n.menu-here-bg-light-primary {\n    .menu-item {\n        @include menu-link-here-state( $primary, $primary, $primary, $primary, $primary-light );\n    }\n}\n\n.menu-hover-bg-light-primary {\n    .menu-item {\n        @include menu-link-hover-state( $primary, $primary, $primary, $primary, $primary-light );\n    }\n}\n\n.menu-active-bg-light-primary {\n    .menu-item {\n        @include menu-link-active-state( $primary, $primary, $primary, $primary, $primary-light );\n    }\n}\n\n.menu-state-bg-light-primary {\n    .menu-item {\n        @include menu-link-show-state( $primary, $primary, $primary, $primary, $primary-light );\n        @include menu-link-here-state( $primary, $primary, $primary, $primary, $primary-light );\n        @include menu-link-hover-state( $primary, $primary, $primary, $primary, $primary-light );\n        @include menu-link-active-state( $primary, $primary, $primary, $primary, $primary-light );\n    }\n}\n\n// Primary title states\n.menu-hover-title-primary {\n    .menu-item {\n        @include menu-link-hover-state( $primary, null, null, null, null );\n    }\n}\n\n.menu-here-title-primary {\n    .menu-item {\n        @include menu-link-here-state( $primary, null, null, null, null );\n    }\n}\n\n.menu-show-title-primary {\n    .menu-item {\n        @include menu-link-show-state( $primary, null, null, null, null );\n    }\n}\n\n.menu-active-title-primary {\n    .menu-item {\n        @include menu-link-active-state( $primary, null, null, null, null );\n    }\n}\n\n.menu-state-title-primary {\n    .menu-item {\n        @include menu-link-hover-state( $primary, null, null, null, null );\n        @include menu-link-show-state( $primary, null, null, null, null );\n        @include menu-link-active-state( $primary, null, null, null, null );\n    }\n}\n\n// Primary icon states\n.menu-hover-icon-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-hover-state( null, $primary, null, null, null );\n    }\n}\n\n.menu-here-icon-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-here-state( null, $primary, null, null, null );\n    }\n}\n\n.menu-show-icon-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-show-state( null, $primary, null, null, null );\n    }\n}\n\n.menu-active-icon-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-active-state( null, $primary, null, null, null );\n    }\n}\n\n.menu-state-icon-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-hover-state( null, $primary, null, null, null );\n        @include menu-link-show-state( null, $primary, null, null, null );\n        @include menu-link-active-state( null, $primary, null, null, null );\n    }\n}\n\n// Primary bullet states\n.menu-hover-bullet-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-hover-state( null, null, $primary, null, null );\n    }\n}\n\n.menu-show-bullet-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-show-state( null, null, $primary, null, null );\n    }\n}\n\n.menu-here-bullet-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-here-state( null, null, $primary, null, null );\n    }\n}\n\n.menu-active-bullet-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-active-state( null, null, $primary, null, null );\n    }\n}\n\n.menu-state-bullet-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-hover-state( null, null, $primary, null, null );\n        @include menu-link-show-state( null, null, $primary, null, null );\n        @include menu-link-active-state( null, null, $primary, null, null );\n    }\n}\n\n// Primary arrow states\n.menu-hover-arrow-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-hover-state( null, null, null, $primary, null );\n    }\n}\n\n.menu-here-arrow-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-here-state( null, null, null, $primary, null );\n    }\n}\n\n.menu-show-arrow-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-show-state( null, null, null, $primary, null );\n    }\n}\n\n.menu-active-arrow-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-active-state( null, null, null, $primary, null );\n    }\n}\n\n.menu-state-arrow-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-hover-state( null, null, null, $primary, null );\n        @include menu-link-show-state( null, null, null, $primary, null );\n        @include menu-link-active-state( null, null, null, $primary, null );\n    }\n}\n","//\n// Anchor\n//\n\n.anchor {\n    display: flex;\n    align-items: center;\n\n    a {\n        position: relative;\n        display: none;\n        align-items: center;\n        justify-content:flex-start;\n        height: 1em;\n        width: 1.25em;\n        margin-left: -1.25em;\n        font-weight: 500;\n        font-size: 0.8em;\n        color: $text-muted;\n        transition: $transition-base;\n\n        &:before {\n            content: '#';\n        }\n    }\n\n    &:hover {\n        a {\n            display: flex;\n\n            &:hover {\n                color: $primary;\n                transition: $transition-base;\n            }\n        }\n    }\n}\n","//\n// Card\n//\n\n// Base\n.card {    \n    @if ($card-border-enabled)  {\n        border: $card-border-width $card-border-style $card-border-color;\n    } @else {\n        border: 0;\n    }  \n    \n    box-shadow: $card-box-shadow;  \n\n    // Header\n    .card-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: stretch;\n        flex-wrap: wrap;\n        min-height: $card-header-height;\n        padding: 0 $card-px;\n        background-color: transparent;\n        border-bottom: $card-border-width $card-border-style $card-border-color;\n\n        // Title\n        .card-title {\n            display: flex;\n            align-items: center;\n            margin: $card-header-py;\n            margin-left: 0;\n\n            &.flex-column {\n                align-items: flex-start;\n                justify-content: center;\n            }\n\n            .card-icon {\n                margin-right: 0.75rem;\n                line-height: 0;\n\n                i {\n                    font-size: 1.25rem;\n                    color: $gray-600;\n                    line-height: 0;\n\n                    &:after,\n                    &:before {\n                        line-height: 0;\n                    }\n                }\n\n                .svg-icon {\n                    @include svg-icon-size(24px);\n                    @include svg-icon-color($gray-600);\n                }\n            }\n\n            &,\n            .card-label {\n                font-weight: 500;\n                font-size: 1.275rem;\n                color: $dark;\n            }\n\n            .card-label {\n                margin: 0 0.75rem 0 0;\n                flex-wrap: wrap;\n            }\n\n            // Description\n            small {\n                color: $text-muted;\n                font-size: 1rem;\n            }\n\n            // Headings\n            h1, h2, h3, h4, h5, h6 {\n                margin-bottom: 0;\n            }\n        }\n\n        // Toolbar\n        .card-toolbar {\n            display: flex;\n            align-items: center;\n            margin: $card-header-py 0;\n            flex-wrap: wrap;\n        }\n    }\n\n    // Body\n    .card-body {\n        padding: $card-py $card-px;\n    }\n\n    // Footer\n    .card-footer {\n        padding: $card-py $card-px;\n        background-color: transparent;\n        border-top: $card-border-width $card-border-style $card-border-color;\n    }\n\n    // Scroll\n    .card-scroll {\n        position: relative;\n        overflow: auto;\n    }\n\n    // Reset padding x\n    &.card-px-0 {\n        .card-header,\n        .card-body,\n        .card-footer {\n            padding-left: 0;\n            padding-right: 0;\n        }\n    }\n\n    &.card-py-0 {\n        .card-header,\n        .card-body,\n        .card-footer {\n            padding-top: 0;\n            padding-bottom: 0;\n        }\n    }\n\n    &.card-p-0 {\n        .card-header,\n        .card-body,\n        .card-footer {\n            padding: 0;\n        }\n    }\n\n    // Dashed style\n    &.card-dashed {\n        box-shadow: none;\n        border: $card-border-width dashed $card-border-dashed-color;\n\n        > .card-header {\n            border-bottom: 1px dashed $card-border-dashed-color;\n        }\n\n        > .card-footer {\n            border-top: 1px dashed $card-border-dashed-color;\n        }\n    }\n\n    // Bordered style\n    &.card-bordered {\n        box-shadow: none;\n        border: $card-border-width $card-border-style $card-border-color;\n    }\n\n    // Flush header and footer borders\n    &.card-flush {\n        > .card-header {\n            border-bottom: 0;\n        }\n\n        > .card-footer {\n            border-top: 0;\n        }\n    }\n    \n    &.card-shadow {\n        box-shadow: $card-box-shadow;\n        border: 0;\n    }\n}\n\n// Responsive stretch heights\n.card {\n    @each $breakpoint in map-keys($grid-breakpoints) {\n    \t@include media-breakpoint-up($breakpoint) {\n    \t\t$infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n            // Stretch\n            &.card#{$infix}-stretch {\n                height: calc(100% - var(--bs-gutter-y));\n            }\n\n            // Stretch 75\n            &.card#{$infix}-stretch-75 {\n                height: calc(75% - var(--bs-gutter-y));\n            }\n\n            // Stretch 50\n            &.card#{$infix}-stretch-50 {\n                height: calc(50% - var(--bs-gutter-y));\n            }\n\n             // Stretch 33\n            &.card#{$infix}-stretch-33 {\n                height: calc(33.333% - var(--bs-gutter-y));\n            }\n\n            // Stretch 25\n            &.card#{$infix}-stretch-25 {\n                height: calc(25% - var(--bs-gutter-y));\n            }\n\n            // Header stretch\n            .card-header#{$infix}-stretch {\n                padding-top: 0 !important;\n                padding-bottom: 0 !important;\n                align-items: stretch;\n    \n                .card-toolbar {\n                    margin: 0;\n                    align-items: stretch;\n                }\n            }\n        }\n    }\n}\n\n// Utilities\n.card-p {\n    padding: $card-py $card-px !important;\n}\n\n.card-px {\n    padding-left: $card-px !important;\n    padding-right: $card-px !important;\n}\n\n.card-shadow {\n    box-shadow: $card-box-shadow;\n}\n\n.card-py {\n    padding-top: $card-py !important;\n    padding-bottom: $card-py !important;\n}\n\n.card-rounded {\n    border-radius: $card-border-radius;\n}\n\n.card-rounded-start {\n    border-top-left-radius: $card-border-radius;\n    border-bottom-left-radius: $card-border-radius;\n}\n\n.card-rounded-end {\n    border-top-right-radius: $card-border-radius;\n    border-bottom-right-radius: $card-border-radius;\n}\n\n.card-rounded-top {\n    border-top-left-radius: $card-border-radius;\n    border-top-right-radius: $card-border-radius;\n}\n\n.card-rounded-bottom {\n    border-bottom-left-radius: $card-border-radius;\n    border-bottom-right-radius: $card-border-radius;\n}\n\n// Mobile mode\n@include media-breakpoint-down(md) {\n    .card {\n        > .card-header:not(.flex-nowrap) {\n            padding-top: $card-header-py;\n            padding-bottom: $card-header-py;\n        }\n    }\n}\n","//\n// Breadcrumb\n//\n\n// Breadcrumb\n.breadcrumb {\n    display: flex;\n    align-items: center;\n    background-color: transparent;\n    padding: 0;\n    margin: 0;    \n\n    // Item breadcrumb\n    .breadcrumb-item {\n        display: flex;\n        align-items: center;\n        padding-left: 0;\n        padding-right: $breadcrumb-item-padding-x;\n\n        &:last-child {\n            padding-right: 0;\n        }\n\n        &:after {\n            content: \"/\";\n            padding-left: $breadcrumb-item-padding-x;\n        }\n\n        &:before {\n            display: none;\n        }\n\n        &:last-child {\n            &:after {\n                display: none;\n            }\n        }\n    }\n}\n\n// Breadcrumb line style\n.breadcrumb-line {\n    .breadcrumb-item {\n        &:after {\n            content: \"-\";\n        }\n    }\n}\n\n// Breadcrumb dot style\n.breadcrumb-dot {\n    .breadcrumb-item {\n        &:after {\n            content: \"\\2022\";\n        }\n    }\n}\n\n// Breadcrumb separatorless style\n.breadcrumb-separatorless {\n    .breadcrumb-item {\n        &:after {\n            display:none;\n        }\n    }\n}","//\n// Buttons Base\n//\n\n// Button\n.btn {\n\t// Reset outline\n\toutline: none !important;\t\n\n\t// Reset focus shadow\n\t&:not(.btn-shadow):not(.shadow):not(.shadow-sm):not(.shadow-lg) {\n\t\tbox-shadow: none !important;\n\t}\n\n\t// Remove border\n\t&:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon) {\n\t\tborder: 0;\n\t\tpadding: calc(#{$btn-padding-y} + #{$btn-border-width}) calc(#{$btn-padding-x} + #{$btn-border-width});\n\n\t\t&.btn-lg {\n\t\t\tpadding: calc(#{$btn-padding-y-lg} + #{$btn-border-width}) calc(#{$btn-padding-x-lg} + #{$btn-border-width});\n\t\t}\n\n\t\t&.btn-sm {\n\t\t\tpadding: calc(#{$btn-padding-y-sm} + #{$btn-border-width}) calc(#{$btn-padding-x-sm} + #{$btn-border-width});\n\t\t}\n\t}\n\n\t// Link\n\t&.btn-link {\n\t\tborder: 0;\n\t\tborder-radius: 0;\n\t\tpadding-left: 0 !important;\n\t\tpadding-right: 0 !important;\n\t\ttext-decoration: none;\n\t\tfont-weight: $btn-font-weight;\n\t}\n\n\t// Outline dashed\n\t&.btn-outline-dashed {\n\t\tborder: 1px dashed $border-dashed-color;\n\t}\n\n\t// Outline default\n\t&.btn-outline-default {\n\t\tborder: 1px solid $input-border-color;\n\t}\n\n\t// Flush\n\t&.btn-flush {\n\t\t@include button-reset();\n\t}\n\n\t// Flex\n\t&.btn-flex {\t\t\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t}\n}\n\n// Icons\n.btn {\n\t// Font icon\n\ti {\n\t\tdisplay: inline-flex;\n\t\tfont-size: $font-size-base;\n\t\tpadding-right: 0.35rem;\n\t\tvertical-align: middle;\n\t\tline-height: 0;\n\t}\n\n\t// Svg icon\n\t.svg-icon {\n\t\tflex-shrink: 0;\n\t\tline-height: 0;\n\t\tmargin-right: 0.5rem;\n\t}\n\n\t// Icon only button\n\t&.btn-icon {\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tpadding: 0;\n\t\theight: $input-height;\n\t\twidth: $input-height;\n\n\t\t// Remove border\n\t\t&:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush) {\n\t\t\tborder: 0;\n\t\t}\n\n\t\t// Sizes\n\t\t&.btn-sm {\n\t\t\theight: $input-height-sm;\n\t\t\twidth: $input-height-sm;\n\t\t\t \n\t\t}\n\n\t\t&.btn-lg {\n\t\t\theight: $input-height-lg;\n\t\t\twidth: $input-height-lg;\n\t\t}\n\n\t\t&.btn-circle {\n\t\t\tborder-radius: 50%;\n\t\t}\n\n\t\ti,\n\t\t.svg-icon {\n\t\t\tpadding: 0;\n\t\t\tmargin: 0;\n\t\t\tline-height: 1;\n\t\t}\n\t}\n}\n\n// Hover effects\n.btn.btn-hover-rise {\n\ttransition: transform 0.3s ease;\n\n\t&:hover {\n\t\ttransform: translateY(-10%);\n\t\ttransition: transform 0.3s ease;\n\t}\n}\n\n.btn.btn-hover-scale {\n\ttransition: transform 0.3s ease;\n\n\t&:hover {\n\t\ttransform: scale(1.1);\n\t\ttransition: transform 0.3s ease;\n\t}\n}\n\n.btn.btn-hover-rotate-end {\n\ttransition: transform 0.3s ease;\n\n\t&:hover {\n\t\ttransform: rotate(4deg);\n\t\ttransition: transform 0.3s ease;\n\t}\n}\n\n.btn.btn-hover-rotate-start {\n\ttransition: transform 0.3s ease;\n\n\t&:hover {\n\t\ttransform: rotate(-4deg);\n\t\ttransition: transform 0.3s ease;\n\t}\n}","//\n// Reset\n//\n\n@mixin button-reset() {\n    appearance: none;\n    box-shadow: none;\n    border-radius: 0;\n    border: none;\n    cursor: pointer;\n    background-color: transparent;\n    outline: none  !important;\n    margin: 0;\n    padding: 0;\n}\n\n@mixin input-reset() {\n\tborder: 0;\n\tbackground-color: transparent;\n    outline: none !important;\n\tbox-shadow: none;\n    border-radius: 0;\n}\n","//\n// Buttons Theme\n//\n\n// Theme colors\n@each $name, $value in $theme-colors {\n\t// Base\n\t.btn.btn-#{$name} {\n\t\t$color: theme-inverse-color($name);\n\t\t$icon-color: theme-inverse-color($name);\n\t\t$border-color: $value;\n\t\t$bg-color: $value;\n\n\t\t$color-active: theme-inverse-color($name);\n\t\t$icon-color-active: theme-inverse-color($name);\n\t\t$border-color-active: theme-active-color($name);\n\t\t$bg-color-active: theme-active-color($name);\n\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t}\n\n\t// Light\n\t@if (theme-light-color($name)) {\n\t\t.btn.btn-light-#{$name} {\n\t\t\t$color: $value;\n\t\t\t$icon-color: $value;\n\t\t\t$border-color: theme-light-color($name);\n\t\t\t$bg-color: theme-light-color($name);\n\t\n\t\t\t$color-active: theme-inverse-color($name);\n\t\t\t$icon-color-active: theme-inverse-color($name);\n\t\t\t$border-color-active: $value;\n\t\t\t$bg-color-active: $value;\n\t\n\t\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t\t}\n\t}\t\n\n\t@if ( $btn-extended-variants == true or $name == primary or $name == light ) {\n\t\t.btn.btn-bg-#{$name} {\n\t\t\t$color: null;\n\t\t\t$icon-color: null;\n\t\t\t$border-color: $value;\n\t\t\t$bg-color: $value;\t\t\t\n\n\t\t\t$color-active: null;\n\t\t\t$icon-color-active: null;\n\t\t\t$border-color-active: null;\n\t\t\t$bg-color-active: null;\t\t\t\n\n\t\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t\t}\n\n\t\t.btn.btn-active-#{$name} {\n\t\t\t$color: null;\n\t\t\t$icon-color: null;\n\t\t\t$border-color: null;\n\t\t\t$bg-color: null;\n\n\t\t\t$color-active: theme-inverse-color($name);\n\t\t\t$icon-color-active: theme-inverse-color($name);\n\t\t\t$border-color-active: $value;\n\t\t\t$bg-color-active: $value;\n\n\t\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t\t}\n\n\t\t@if (theme-light-color($name)) {\n\t\t\t.btn.btn-active-light-#{$name} {\n\t\t\t\t$color: null;\n\t\t\t\t$icon-color: null;\n\t\t\t\t$border-color: null;\n\t\t\t\t$bg-color: null;\n\n\t\t\t\t$color-active: $value;\n\t\t\t\t$icon-color-active: $value;\n\t\t\t\t$border-color-active: theme-light-color($name);\n\t\t\t\t$bg-color-active: theme-light-color($name);\n\n\t\t\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\n\t\t\t\t// Don't change the border color for outline style\n\t\t\t\t&.btn-outline:not(.btn-outline-default) {\n\t\t\t\t\tborder-color: $value !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n// Theme text colors\n@each $name, $value in $theme-text-colors {\n\t@if ( $btn-extended-variants == true or $name == primary or $name == muted ) {\n\t\t// Text and icon colors\n\t\t.btn.btn-color-#{$name} {\n\t\t\t$color: $value;\n\t\t\t$icon-color: $value;\n\t\t\t$bg-color: null;\n\t\t\t$border-color: null;\n\n\t\t\t$color-active: null;\n\t\t\t$icon-color-active: null;\n\t\t\t$border-color-active: null;\n\t\t\t$bg-color-active: null;\n\n\t\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t\t}\n\n\t\t// Text and icon colors active state\n\t\t.btn.btn-active-color-#{$name} {\n\t\t\t$color: null;\n\t\t\t$icon-color: null;\n\t\t\t$border-color: null;\n\t\t\t$bg-color: null;\n\n\t\t\t$color-active: $value;\n\t\t\t$icon-color-active: $value;\n\t\t\t$border-color-active: null;\n\t\t\t$bg-color-active: null;\n\n\t\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t\t}\n\n\t\t// Icon colors \n\t\t.btn.btn-icon-#{$name} {\n\t\t\t$color: null;\n\t\t\t$icon-color: $value;\n\t\t\t$bg-color: null;\n\t\t\t$border-color: null;\n\n\t\t\t$color-active: null;\n\t\t\t$icon-color-active: null;\n\t\t\t$border-color-active: null;\n\t\t\t$bg-color-active: null;\n\n\t\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t\t}\n\n\t\t// Icon colors active state\n\t\t.btn.btn-active-icon-#{$name} {\n\t\t\t$color: null;\n\t\t\t$icon-color: null;\n\t\t\t$bg-color: null;\n\t\t\t$border-color: null;\n\n\t\t\t$color-active: null;\n\t\t\t$icon-color-active: $value;\n\t\t\t$border-color-active: null;\n\t\t\t$bg-color-active: null;\n\n\t\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t\t}\n\n\t\t// Text colors\n\t\t.btn.btn-text-#{$name} {\n\t\t\t$color: $value;\n\t\t\t$icon-color: null;\n\t\t\t$bg-color: null;\n\t\t\t$border-color: null;\n\n\t\t\t$color-active: null;\n\t\t\t$icon-color-active: null;\n\t\t\t$border-color-active: null;\n\t\t\t$bg-color-active: null;\n\n\t\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t\t}\n\n\t\t// Text colors active state\n\t\t.btn.btn-active-text-#{$name} {\n\t\t\t$color: null;\n\t\t\t$icon-color: null;\n\t\t\t$bg-color: null;\n\t\t\t$border-color: null;\n\n\t\t\t$color-active: $value;\n\t\t\t$icon-color-active: null;\n\t\t\t$border-color-active: null;\n\t\t\t$bg-color-active: null;\n\n\t\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t\t}\t\t\n\t}\n}\n\n// Social colors\n@each $name, $value in $social-colors {\n\t// Base\n\t.btn.btn-#{$name} {\n\t\t$color: get($value, inverse);\n\t\t$icon-color: get($value, inverse);\n\t\t$border-color: get($value, base);\n\t\t$bg-color: get($value, base);\n\n\t\t$color-active: null;\n\t\t$icon-color-active: null;\n\t\t$border-color-active: get($value, active);\n\t\t$bg-color-active: get($value, active);\n\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t}\n\n\t// Light\n\t.btn.btn-light-#{$name} {\n\t\t$color: get($value, base);\n\t\t$icon-color: get($value, base);\n\t\t$bg-color: get($value, light);\n\t\t$border-color: get($value, light);\n\n\t\t$color-active: get($value, inverse);\n\t\t$icon-color-active: get($value, inverse);\n\t\t$bg-color-active: get($value, base);\n\t\t$border-color-active: get($value, base);\n\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t}\n}\n\n// Outline dashed basic style\n.btn.btn-outline.btn-outline-dashed {\n\tborder-width: 1px;\n\tborder-style: dashed;\t\n\t\n\t$color: null;\n\t$icon-color: null;\n\t$border-color: null;\n\t$bg-color: null;;\n\n\t$color-active: null;\n\t$icon-color-active: null;\n\t$border-color-active: $primary;\n\t$bg-color-active: null;\n\n\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n}\n\n// Outline dashed default style\n.btn.btn-outline.btn-outline-dashed.btn-outline-default {\n\tborder-width: 1px;\n\tborder-style: dashed;\t\n\t\n\t$color: $light-inverse;\n\t$icon-color: $light-inverse;\n\t$border-color: $gray-300;\n\t$bg-color: null;\n\n\t$color-active: $primary;\n\t$icon-color-active: $primary;\n\t$border-color-active: $primary;\n\t$bg-color-active: $primary-light;\n\n\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n}","//\n// Button Mixins\n//\n\n// Custom variant\n@mixin button-custom-variant(\n    $color,\n    $icon-color,\n    $border-color,\n    $bg-color,\n    $color-active,\n    $icon-color-active,\n    $border-color-active,\n    $bg-color-active\n) {\n\n    @if ( $color != null ) {\n        color: $color;\n    }\n\n    @if ( $icon-color != null ) {\n        i {\n    \t\tcolor: $icon-color;\n    \t}\n\n    \t.svg-icon {\n    \t\t@include svg-icon-color($icon-color);\n    \t}\n\n        &.dropdown-toggle:after {\n            color: $icon-color;\n        }\n    }\n\n    @if ( $border-color != null ) {\n        border-color: $border-color;\n    }\n\n    @if ( $bg-color != null ) {\n        background-color: $bg-color;\n    }\n\n    .btn-check:checked + &,\n    .btn-check:active + &,\n    &:focus:not(.btn-active),\n    &:hover:not(.btn-active),\n    &:active:not(.btn-active),\n    &.active,\n    &.show,\n    .show > & {\n        @if ( $color-active != null ) {\n            color: $color-active;\n        }\n\n        @if ( $icon-color-active != null ) {\n            i {\n        \t\tcolor: $icon-color-active;\n        \t}\n\n        \t.svg-icon {\n        \t\t@include svg-icon-color($icon-color-active);\n        \t}\n\n            &.dropdown-toggle:after {\n                color: $icon-color-active;\n            }\n        }\n\n        @if ( $border-color-active != null ) {\n            border-color: $border-color-active;\n        }\n\n        @if ( $bg-color-active != null ) {\n            background-color: $bg-color-active !important;\n        }\n    }\n}\n","//\n// Code\n//\n\ncode:not([class*=\"language-\"]) {\n    font-weight: $code-font-weight;\n    color: $code-color;\n    line-height: inherit;\n    font-size: inherit;\n    background-color: $code-bg;\n    padding: $code-padding;\n    margin: $code-margin;\n    box-shadow: $code-box-shadow;\n    @include border-radius($code-border-radius);\n}\n","//\n// Form Control\n//\n\n\n// Form control\n.form-control {\n\tbox-shadow: none !important;\n\n\t// Dropdown shown state\n\t.dropdown.show > & {\n\t\tcolor: $input-focus-color;\n\t\tbackground-color: $input-focus-bg;\n  \t    border-color: $input-focus-border-color;\n\t}\n\n\t// Readonly state\n\t&[readonly] {\n\t\tbackground-color: $input-readonly-bg;\n\t}\n\n\t// Solid style\n\t&.form-control-solid {\n\t\tbackground-color: $input-solid-bg;\n\t\tborder-color: $input-solid-bg;\n\t\t@include placeholder($input-solid-placeholder-color);\n\t\tcolor: $input-solid-color;\n\t\ttransition: $transition-input;\n\n\t\t.dropdown.show > &,\n\t\t&:active,\n\t\t&.active,\n\t\t&:focus,\n\t\t&.focus {\n\t\t\tbackground-color: $input-solid-bg-focus;\n\t\t\tborder-color: $input-solid-bg-focus;\n\t\t\tcolor: $input-solid-color;\n\t\t\ttransition: $transition-input;\n\t\t}\n\t}\n\n\t// Transparent style\n\t&.form-control-transparent {\n\t\tbackground-color: transparent;\n\t\tborder-color: transparent;\n\n\t\t.dropdown.show > &,\n\t\t&:active,\n\t\t&.active,\n\t\t&:focus,\n\t\t&.focus {\n\t\t\tbackground-color: transparent;\n\t\t\tborder-color: transparent;\n\t\t}\n\t}\n\n\t// Flush\n\t&.form-control-flush {\n\t\t@include input-reset();\n\t}\n}\n\n// Placeholder colors\n.placeholder-gray-500 {\n\t@include placeholder($gray-500);\n}\n\n.placeholder-white {\n\t@include placeholder($white);\n}\n\n// Textarea reset resize\n.resize-none {\n\tresize: none;\n}\n","//\n// Input placeholder color\n//\n\n@mixin placeholder($color) {\n    // Chrome, Firefox, Opera, Safari 10.1+\n    &::placeholder { \n        color: $color;\n    }\n    \n    // Firefox\n    &::-moz-placeholder {\n        color: $color;\n        opacity: 1;\n    }\n}\n","//\n// Form Select\n//\n\n.form-select {\n    box-shadow: none !important;\n\n    // Solid style\n\t&.form-select-solid {\n\t\t@include placeholder($input-solid-placeholder-color);\n\t\tbackground-color: $input-solid-bg;\n\t\tborder-color: $input-solid-bg;\n\t\tcolor: $input-solid-color;\n\t\ttransition: $transition-input;\n\t\t\n\t\t.dropdown.show > &,\n\t\t&:active,\n\t\t&.active,\n\t\t&:focus,\n\t\t&.focus {\n\t\t\tbackground-color: $input-solid-bg-focus;\n\t\t\tborder-color: $input-solid-bg-focus !important;\n\t\t\tcolor: $input-solid-color;\n\t\t\ttransition: $transition-input;\n\t\t}\n\t}\n\n\t// Transparent style\n\t&.form-select-transparent {\n\t\t@include placeholder($input-placeholder-color);\n\t\tbackground-color: transparent;\n\t\tborder-color: transparent;\n\t\tcolor: $input-color;\n\n\t\t.dropdown.show > &,\n\t\t&:active,\n\t\t&.active,\n\t\t&:focus,\n\t\t&.focus {\n\t\t\tbackground-color: transparent;\n\t\t\tborder-color: transparent !important;\n\t\t\tcolor: $input-color;\n\t\t}\n\t}\n}\n","//\n// Form Check\n//\n\n.form-check {\n    // Label\n    .form-check-label {\n        cursor: pointer;\n    }\n\n    // Input\n    .form-check-input {\n        cursor: pointer;\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n    }\n\n    // Custom\n    &.form-check-custom {\n        display: flex;\n        align-items: center;\n        padding-left: 0;\n        margin: 0;\n\n        .form-check-input {\n            margin: 0;\n            float: none;\n            flex-shrink: 0;\n        }\n\n        .form-check-label {\n            margin-left: 0.55rem;\n        }\n    }\n\n    &:not(.form-switch) {\n        .form-check-input {\n            &[type=\"checkbox\"] {\n                background-size: $form-check-input-bg-size;\n            }\n        }\n    }\n\n    // Solid\n    &.form-check-solid {\n        .form-check-input {\n            border: 0;\n            background-color: $form-check-input-bg-solid;\n\n            &:active,\n            &:focus {\n                filter: none;\n                background-color: $form-check-input-bg-solid;\n            }\n\n            &:checked {\n                background-color: $form-check-input-checked-bg-color;\n            }\n        }\n    }\n\n    // Success state\n    &.form-check-success {\n        .form-check-input {\n            &:checked {\n                background-color: $success;\n            }\n        }\n    }\n\n    // Danger state\n    &.form-check-danger {\n        .form-check-input {\n            &:checked {\n                background-color: $danger;\n            }\n        }\n    }\n\n    // Warning state\n    &.form-check-warning {\n        .form-check-input {\n            &:checked {\n                background-color: $warning;\n            }\n        }\n    }\n}\n\n// Sizing\n.form-check.form-check-custom {   \n    &.form-check-sm {\n        .form-check-input {\n            height: $form-check-input-width-sm;\n            width: $form-check-input-width-sm;\n        }\n    }\n\n    &.form-check-lg {\n        .form-check-input {\n            height: $form-check-input-width-lg;\n            width: $form-check-input-width-lg;\n        }\n    }\n}\n\n// Form switch\n.form-switch.form-check-solid {\n    .form-check-input {\n        height: $form-switch-height;\n        background-image: escape-svg($form-switch-bg-image-solid);\n        border-radius: $form-switch-border-radius;\n\n        &:checked {\n            filter: none;\n            background-image: escape-svg($form-switch-checked-bg-image);\n        }\n    }\n\n    &.form-switch-sm {\n        .form-check-input {\n            height: $form-switch-height-sm;\n            width: $form-switch-width-sm;\n        }\n    }\n\n    &.form-switch-lg {\n        .form-check-input {\n            height: $form-switch-height-lg;\n            width: $form-switch-width-lg;\n        }\n    }\n}\n","//\n// Input Group\n//\n\n// Form control\n.input-group {\n    &.input-group-solid {\n        background-color: $input-solid-bg;\n\t\tborder-color: $input-solid-bg;\n        @include border-radius($input-border-radius);\n\n        &.input-group-sm {\n            @include border-radius($input-border-radius-sm);\n        }\n\n        &.input-group-lg {\n            @include border-radius($input-border-radius-lg);\n        }\n\n        .input-group-text {\n            background-color: $input-solid-bg;\n\t\t    border-color: $input-solid-bg;\n\n            & + .form-control {\n                border-left-color: $input-border-color;\n            }\n        }\n\n        .form-control {\n            background-color: transparent;\n    \t\tborder-color: transparent;\n\n            & + .input-group-text {\n                border-left-color: $input-border-color;\n            }\n        }\n    }\n}\n","//\n// Required Label\n//\n\n.required {\n    &:after {\n        content: \"*\";\n        position: relative;\n        font-size: inherit;\n        color: $danger;\n        padding-left: 0.25rem;\n        font-weight: bold;\n    }\n}","//\n// Modal\n//\n\n// Base\n.modal {\n    // Mobile header\n    .modal-header {\n        align-items: center;\n        justify-content: space-between;\n        @include border-top-radius($modal-content-border-radius);\n\n        // Headings\n        h1,h2,h3,h4,h5,h6 {\n            margin-bottom: 0;\n        }\n    }\n\n    // Mobile dialog\n    .modal-dialog {\n        outline: none !important;\n    }\n}\n\n// Utilities\n.modal-rounded {\n    @if $enable-rounded {\n        border-radius: $modal-content-border-radius !important;\n    }\n}","//\n// Progress\n//\n\n// Vertical Position\n.progress-vertical {\n    display: flex;\n    align-items: stretch;\n    justify-content: space-between;\n\n    .progress {\n        height: 100%;\n        @include border-radius($border-radius);\n        display: flex;\n        align-items: flex-end;\n        margin-right: 1rem;\n\n        &:last-child {\n            margin-right: 0;\n        }\n\n        .progress-bar {\n            width: 8px;\n            @include border-radius($border-radius);\n        }\n    }\n}\n","//\n// Table\n//\n\n// Table\n.table {\n\t// Fix for BS 5.1.2 update\n\t& > :not(:first-child) {\n    \tborder-color: transparent;\n\t\tborder-width: 0;\n\t\tborder-style: none;\n\t}\n\t\n\t>:not(:last-child)>:last-child>* {\n\t\tborder-bottom-color: inherit;\n\t}\n\n\ttr, th, td {\n\t\tborder-color: inherit;\n\t\tborder-width: inherit;\n\t\tborder-style: inherit;\n\t\ttext-transform: inherit;\n\t\tfont-weight: inherit;\n\t\tfont-size: inherit;\n\t\tcolor: inherit;\n\t\theight: inherit;\n\t\tmin-height: inherit;\n\n\t\t&:first-child {\n\t\t\tpadding-left: 0;\n\t\t}\n\n\t\t&:last-child {\n\t\t\tpadding-right: 0;\n\t\t}\n\t}\n\n\ttfoot,\n\ttbody {\n\t\ttr:last-child {\n\t\t\tborder-bottom: 0 !important;\n\n\t\t\tth, td {\n\t\t\t\tborder-bottom: 0 !important;\n\t\t\t}\n\t\t}\n\t}\n\n\ttfoot {\n\t\tth, td {\n\t\t\tborder-top: inherit;\n\t\t}\n\t}\n\n\t// Rounded\n\t&.table-rounded {\n\t\tborder-radius: $border-radius;\n\t\tborder-spacing: 0;\n\t\tborder-collapse: separate;\n\t}\n\n\t// Flush\n\t&.table-flush {\n\t\ttr, th, td {\n\t\t\tpadding: inherit;\n\t\t}\n\t}\n\n\t// Row bordered\n\t&.table-row-bordered {\n\t\ttr {\n\t\t\tborder-bottom-width: 1px;\n\t\t\tborder-bottom-style: solid;\n\t\t\tborder-bottom-color: $border-color;\n\t\t}\n\n\t\ttfoot {\n\t\t\tth, td {\n\t\t\t\tborder-top-width: 1px !important;\n\t\t\t}\n\t\t}\n\t}\n\n\t// Row dashed\n\t&.table-row-dashed {\n\t\ttr {\n\t\t\tborder-bottom-width: 1px;\n\t\t\tborder-bottom-style: dashed;\n\t\t\tborder-bottom-color: $border-color;\n\t\t}\n\n\t\ttfoot {\n\t\t\tth, td {\n\t\t\t\tborder-top-width: 1px !important;\n\t\t\t}\n\t\t}\n\t}\n\n\t// Row border colors\n\t@each $color, $value in $grays {\n\t\t&.table-row-gray-#{$color} {\n\t\t\ttr { \n\t\t\t\tborder-bottom-color: $value;\n\t\t\t}\n\t\t}\n\t}\n}\n\n// Cell gutters\n@each $breakpoint in map-keys($grid-breakpoints) {\n    @include media-breakpoint-up($breakpoint) {\n        $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n        @each $name, $value in $gutters {\n\t\t\t.table.g#{$infix}-#{$name} {\n\t\t\t\tth, td {\n\t\t\t\t\tpadding: $value;\n\n\t\t\t\t\t// Datatables responsive mode fix\n\t\t\t\t\t&.dtr-control {\n\t\t\t\t\t\tpadding-left: $value !important;\n\t\t\t\t\t}\n\t\t\t\t}\n            }\n\n            .table.gy#{$infix}-#{$name} {\n\t\t\t\tth, td {\n\t\t\t\t\tpadding-top: $value;\n\t\t\t\t\tpadding-bottom: $value;\n\t\t\t\t}\n            }\n\n\t\t\t.table.gx#{$infix}-#{$name} {\n\t\t\t\tth, td {\n\t\t\t\t\tpadding-left: $value;\n\t\t\t\t\tpadding-right: $value;\n\n\t\t\t\t\t// Datatables responsive mode fix\n\t\t\t\t\t&.dtr-control {\n\t\t\t\t\t\tpadding-left: $value !important;\n\t\t\t\t\t}\n\t\t\t\t}\n            }\n\n\t\t\t.table.gs#{$infix}-#{$name} {\n\t\t\t\t th, td {\n\t\t\t\t\t&:first-child {\n\t   \t\t\t\t\tpadding-left: $value;\n\t\t\t\t\t}\n\n\t\t\t\t\t&:last-child {\n\t   \t\t\t\t\tpadding-right: $value;\n\t\t\t\t\t}\n\n\t\t\t\t\t// Datatables responsive mode fix\n\t\t\t\t\t&.dtr-control:first-child {\n\t\t\t\t\t\tpadding-left: $value !important;\n\t\t\t\t\t}\n\t\t\t\t}\n            }\n        }\n    }\n}\n","//\n// Popover\n//\n\n\n// Base\n.popover {\n    .popover-header {\n        font-size: $popover-header-font-size;\n        font-weight: $popover-header-font-weight;\n        border-bottom: 1px solid $popover-header-border-color;\n    }\n\n    .popover-dismiss {\n        position: absolute;\n        top: $popover-dissmis-btn-top;\n        right: $popover-dissmis-btn-end;\n        height: $popover-dissmis-btn-height;\n        width: $popover-dissmis-btn-height;\n\n        i {\n            color: $gray-500;\n        }\n\n        &:hover {\n            i {\n                color: $primary;\n            }\n        }\n\n        & + .popover-header {\n            padding-right: $popover-body-padding-x + $popover-dissmis-btn-height;\n        }\n    }\n}\n\n// Dark Mode\n.popover-dark {\n    @include popover-theme($gray-900, $gray-800, $gray-900, $gray-200, $gray-400, $gray-100, $gray-900);\n    // $bg-color, $border-color, $header-bg-color, $header-color, $body-color, $arrow-outer-color, $arrow-color\n}","//\n// Popover Mixin\n//\n\n@mixin popover-theme($bg-color, $border-color, $header-bg-color, $header-color, $body-color, $arrow-outer-color, $arrow-color) {\n    background-color: $bg-color;\n    border: 0;\n\n    // Header\n    .popover-header {\n        background-color: $header-bg-color;\n        color: $header-color;\n        border-bottom-color: $border-color;\n    }\n\n    // Body\n    .popover-body {\n        color: $body-color;\n    }\n\n    // Arrows\n    &.bs-popover-top {\n        > .popover-arrow {\n            &::before {\n                border-top-color:  $arrow-outer-color;\n            }\n\n            &::after {\n                border-top-color: $arrow-color;\n            }\n        }\n    }\n\n    &.bs-popover-end {\n        > .popover-arrow {\n            &::before {\n                border-right-color: $arrow-outer-color;\n            }\n\n            &::after {\n                border-right-color: $arrow-color;\n            }\n        }\n    }\n\n    &.bs-popover-bottom {\n        > .popover-arrow {\n            &::before {\n                border-bottom-color: $arrow-outer-color;\n            }\n\n            &::after {\n                border-bottom-color: $arrow-color;\n            }\n        }\n\n        // This will remove the popover-header's border just below the arrow\n        .popover-header::before {\n            border-bottom-color: $header-bg-color;\n        }\n    }\n\n    &.bs-popover-start {\n        > .popover-arrow {\n            &::before {\n                border-left-color: $arrow-outer-color;\n            }\n\n            &::after {\n                border-left-color: $arrow-color;\n            }\n        }\n    }\n}","//\n//  Tooltip\n//\n\n\n// Base\n.tooltip {\n    .tooltip-inner {\n        box-shadow: $tooltip-box-shadow;\n    }\n\n    &.tooltop-auto-width {\n       \t.tooltip-inner {\n       \t\twhite-space: nowrap;\n  \t\t\tmax-width: none;\n        }\n    }\n\n    // Dark Theme\n    &.tooltip-dark {\n        @include tooltip-theme($dark, $dark-inverse, $dark);\n    }\n}\n","//\n// Tooltip Mixin\n//\n\n@mixin tooltip-theme($bg-color, $color, $arrow-color) {\n    .tooltip-inner {\n        color: $color;\n        background-color: $bg-color;\n    }\n\n    // Arrows\n    &.bs-tooltip-top {\n        .tooltip-arrow {\n            &::before {\n                border-top-color: $arrow-color;\n            }\n        }\n    }\n\n    &.bs-tooltip-end {\n        .tooltip-arrow {\n            &::before {\n                border-right-color: $arrow-color;\n            }\n        }\n    }\n\n    &.bs-tooltip-bottom {\n        .tooltip-arrow {\n            &::before {\n                border-bottom-color: $arrow-color;\n            }\n        }\n    }\n\n    &.bs-tooltip-start {\n        .tooltip-arrow {\n            &::before {\n                border-left-color: $arrow-color;\n            }\n        }\n    }\n}\n","//\n// Accordion\n//\n\n// Base\n.accordion {\n\t// According heading\n\t.accordion-header {\n\t\tcursor: pointer;\n\t}\n\n\t// Icon toggle mode\n\t&.accordion-icon-toggle {\n\t\t// Accordion icon expaned mode\n\t\t.accordion-icon {\n\t\t\tdisplay: flex;\n\t\t\tflex-shrink: 0;\n\t\t\ttransition: $transition-base;\n\t\t\ttransform: rotate(90deg);\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\n\t\t\ti {\n\t    \t\tcolor: $primary;\n\t    \t}\n\n\t    \t.svg-icon {\n\t    \t\t@include svg-icon-color($primary);\n\t    \t}\n\t\t}\n\n\t\t// Accordion icon collapsed mode\n\t\t.collapsed {\n\t\t\t.accordion-icon {\n\t\t\t\ttransition: $transition-base;\n\t\t\t\ttransform: rotate(0);\n\n\t\t\t\ti {\n\t\t    \t\tcolor: $text-muted;\n\t\t    \t}\n\n\t\t\t\t.svg-icon {\n\t\t    \t\t@include svg-icon-color($text-muted);\n\t\t    \t}\n\t\t\t}\n\t\t}\n\t}\n\n\t// Reset accordion item border\n\t&.accordion-borderless {\n\t\t// According item\n\t\t.accordion-item {\n\t\t\tborder: 0;\n\t\t}\n\t}\n\n\t// Reset accordion item border, border radiues and background color\n\t&.accordion-flush {\n\t\t// According item\n\t\t.accordion-item {\n\t\t\tbackground-color: transparent;\n\t\t\tborder: 0;\n\t\t\tborder-radius: none;\n\t\t\tpadding-left: 0;\n\t\t\tpadding-right: 0;\n\t\t}\n\t}\t\n}\n","//\n// Loading\n//\n\n.feedback {\n    display: none;\n}\n\n.feedback-popup {\n    display: flex;\n    justify-content: center;\n    margin: 0 auto;\n    position: fixed;\n    z-index: get($feedback, popup, z-index);\n    box-shadow: get($feedback, popup, box-shadow);\n    background-color: get($feedback, popup, background-color);\n    border-radius: get($feedback, popup, border-radius);\n    padding: get($feedback, popup, padding);\n}\n\n// Placement\n.feedback-top-center {\n    display: flex;\n    transition: top get($feedback, popup, transition-speed) ease;\n    left: 50%;\n    transform: translateX(-50%);\n    @include border-top-start-radius(0);\n    @include border-top-end-radius(0);\n    \n    &.feedback-shown {\n        top: 0px;\n        transition: top get($feedback, popup, transition-speed) ease;\n    }\n}\n","//\n// Avatar\n//\n\n\n// Base\n.image-input {\n\tposition: relative;\n\tdisplay: inline-block;\n\t@include border-radius($border-radius);\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\n\t// Empty state\n\t&:not(.image-input-empty) {\n\t\tbackground-image: none !important;\n\t}\n\n\t// Wrapper\n\t.image-input-wrapper {\n\t\twidth: 120px;\n\t\theight: 120px;\n\t\t@include border-radius($border-radius);\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-size: cover;\n\t}\n\n\t// Actions\n\t[data-kt-image-input-action] {\n\t\tcursor: pointer;\n\t\tposition: absolute;\n\t\ttransform: translate(-50%,-50%);\n\t}\n\n\t// Change Button\n\t[data-kt-image-input-action=\"change\"] {\n\t\tleft: 100%;\n\t\ttop: 0;\n\n\t\tinput {\n\t\t\twidth: 0 !important;\n\t\t\theight: 0 !important;\n\t\t\toverflow: hidden;\n\t\t\topacity: 0;\n\t\t}\n\t}\n\n\t// Cancel & Remove Buttons\n\t[data-kt-image-input-action=\"cancel\"],\n\t[data-kt-image-input-action=\"remove\"] {\n\t\tposition: absolute;\n\t\tleft: 100%;\n\t\ttop: 100%;\n\t}\n\n\t[data-kt-image-input-action=\"cancel\"] {\n\t\tdisplay: none;\n\t}\n\n\t// Input Changed State\n\t&.image-input-changed {\n\t\t[data-kt-image-input-action=\"cancel\"] {\n\t\t\tdisplay: flex;\n\t\t}\n\n\t\t[data-kt-image-input-action=\"remove\"] {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t// Input Empty State\n\t&.image-input-empty {\n\t\t[data-kt-image-input-action=\"remove\"],\n\t\t[data-kt-image-input-action=\"cancel\"] {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t// Circle style\n\t&.image-input-circle {\n\t\tborder-radius: 50%;\n\n\t\t// Wrapper\n\t\t.image-input-wrapper {\n\t\t\tborder-radius: 50%;\n\t\t}\n\n\t\t// Change Control\n\t\t[data-kt-image-input-action=\"change\"] {\n\t\t\tleft: 100%;\n\t\t\ttop: 0;\n\t\t\ttransform: translate(-100%, 0%);\n\t\t}\n\n\t\t// Cancel & Remove Buttons\n\t\t[data-kt-image-input-action=\"cancel\"],\n\t\t[data-kt-image-input-action=\"remove\"] {\n\t\t\tleft: 100%;\n\t\t\ttop: 100%;\n\t\t\ttransform: translate(-100%,-100%);\n\t\t}\n\t}\n\n\t// Bordered style\n\t&.image-input-outline {\n\t\t.image-input-wrapper {\n\t\t\tborder: 3px solid $body-bg;\n\t\t\tbox-shadow: if(isDarkMode(), $box-shadow, $box-shadow-sm);\n\t\t}\n\t}\n}\n","//\n// symbol\n//\n\n// Base\n.symbol {\n    display: inline-block;;\n    flex-shrink: 0;\n    position: relative;\n    @include border-radius($border-radius);\n\n    // Label\n    .symbol-label {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-weight: 500;\n        color: $gray-800;\n        background-color: $gray-100;\n        background-repeat: no-repeat;\n        background-position: center center;\n        background-size: cover;\n        @include border-radius($border-radius);\n    }\n\n    // Badge\n    .symbol-badge {\n        position: absolute;\n        border: 2px solid $body-bg;\n        border-radius: 100%;\n        top: 0;\n        left: 50%;\n        transform: translateX(-50%) translateY(-50%) !important;\n    }\n\n    // Image\n    > img {\n        width: 100%;\n        flex-shrink: 0;\n        display: inline-block;\n        @include border-radius($border-radius);\n    }\n\n    // Square\n    &.symbol-square {\n        &,\n        > img,\n        .symbol-label {\n            border-radius: 0 !important;\n        }\n    }\n\n    // Circle\n    &.symbol-circle {\n        &,\n        > img,\n        .symbol-label {\n            border-radius: 50%;\n        }\n    }\n\n    // Sizes\n    @include symbol-size(get($symbol-sizes, default));\n\n    @each $breakpoint in map-keys($grid-breakpoints) {\n        @include media-breakpoint-up($breakpoint) {\n            $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n            @each $name, $value in $symbol-sizes {\n                @if ($name != 'default') {\n                    &.symbol#{$infix}-#{$name} {\n                        @include symbol-size($value);\n                    }\n                }\n            }\n        }\n    }\n}\n\n// Group\n.symbol-group {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-left: 10px;\n\n    .symbol {\n        position: relative;\n        z-index: 0;\n        margin-left: -10px;\n        border: 2px solid $body-bg;\n        transition: all 0.3s ease;\n\n        &:hover {\n            transition: all 0.3s ease;\n            z-index: 1;\n        }\n    }\n\n    &.symbol-hover {\n        .symbol {\n            cursor: pointer;\n        }\n    }\n}\n","//\n// Symbol\n//\n\n@mixin symbol-size($size) {\n    > img {\n        width: $size;\n        height: $size;\n    }\n\n    .symbol-label {\n        width: $size;\n        height: $size;\n    }\n\n    &.symbol-fixed {\n        .symbol-label {\n            width: $size;\n            height: $size;\n        }\n\n        > img {\n            width: $size;\n            height: $size;\n            max-width: auto;\n        }\n    }\n\n    // Ratios\n    &.symbol-2by3 {\n        .symbol-label {\n            height: $size;\n            width:  $size * divide(3, 2);\n        }\n\n        > img {\n            height: $size;\n            width:  $size * divide(3, 2);\n            max-width: auto;\n        }\n    }\n}\n","//\n// Pulse\n//\n\n\n// Base\n.pulse {\n    position: relative;\n\n    // Theme Colors\n    @each $name, $color in $theme-colors {\n        &.pulse-#{$name} {\n            .pulse-ring {\n                border-color: $color;\n            }\n        }\n    }\n}\n\n.pulse-ring {\n    display: block;\n    border-radius: 40px;\n    height: 40px;\n    width: 40px;\n    position: absolute;\n    animation: animation-pulse 3.5s ease-out;\n    animation-iteration-count: infinite;\n    opacity: 0;\n    border-width: 3px;\n    border-style: solid;\n    border-color: $gray-500;\n}\n\n@keyframes animation-pulse {\n    0% {-webkit-transform: scale(0.1, 0.1); opacity: 0.0;}\n    60% {-webkit-transform: scale(0.1, 0.1); opacity: 0.0;}\n    65% {opacity: 1;}\n    100% {-webkit-transform: scale(1.2, 1.2); opacity: 0.0;}\n}\n","//\n// Page loader\n//\n\n// CSS3 Transitions only after page load(.page-loading class added to body tag and remove with JS on page load)\n.page-loading * {\n    transition: none !important;\n}\n\n// Base\n.page-loader {\n\tbackground: $body-bg;\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 1000;\n   \tdisplay: none;\n\n   \t.page-loading & {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n   \t\talign-items: center;\n\t}\n}\n","//\n// Scrolltop\n//\n\n.scrolltop {    \n    position: fixed;\n    display: none;\n    cursor: pointer;\n    z-index: 100;\n    justify-content: center;\n    align-items: center;\n    width: get($scrolltop, size, desktop);\n    height: get($scrolltop, size, desktop);\n    bottom: get($scrolltop, bottom, desktop);\n    right: get($scrolltop, right, desktop);    \n    background-color: get($scrolltop, bg-color, default);\n    box-shadow: $box-shadow;\n    opacity: get($scrolltop, opacity, default);\n    transition: $transition-link;\n    @include border-radius($border-radius);\n\n    .svg-icon {\n        @include svg-icon-size(24px);\n        @include svg-icon-color(get($scrolltop, icon-color, default));\n    }\n\n    > i {\n        font-size: 1.3rem;\n        color: get($scrolltop, icon-color, default);\n    }\n\n    &:hover {\n        background-color: get($scrolltop, bg-color, hover);\n\n        > i {\n            color: get($scrolltop, icon-color, hover);\n        }\n\n        .svg-icon {\n            @include svg-icon-color(get($scrolltop, icon-color, hover));\n        }\n    }\n\n    [data-kt-scrolltop=\"on\"] & {\n        opacity: get($scrolltop, opacity, on);\n        animation: animation-scrolltop .4s ease-out 1;\n        display: flex;\n\n        &:hover {\n            transition: $transition-link;\n            opacity: get($scrolltop, opacity, hover);\n        }\n    }\n\n    // Tablet & Mobile Modess\n    @include media-breakpoint-down(lg) {\n        bottom: get($scrolltop, bottom, tablet-and-mobile);\n        right: get($scrolltop, right, tablet-and-mobile);\n        width: get($scrolltop, size, tablet-and-mobile);\n        height: get($scrolltop, size, tablet-and-mobile);\n    }\n}\n\n// Animations\n@keyframes animation-scrolltop {\n    from   { margin-bottom: -15px; }\n    to {  margin-bottom: 0; }\n}\n","//\n// SVG Icon\n//\n\n.svg-icon {\n    line-height: 1;\n    \n    @include svg-icon-size(get($font-sizes, 5));\n    @include svg-icon-color($text-muted);\n\n    // Theme colors\n    @each $name, $color in $theme-text-colors {\n        &.svg-icon-#{$name} {\n            @include svg-icon-color($color);\n        }\n    }\n\n    // Responsive icon sizes\n    @each $breakpoint in map-keys($grid-breakpoints) {\n        @include media-breakpoint-up($breakpoint) {\n            $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n            // Sizes\n            @each $name, $value in $font-sizes {\n                &.svg-icon#{$infix}-#{$name} {\n                    @include svg-icon-size($value, true);\n                }\n            }\n        }\n    }\n}\n","//\n// Timeline\n//\n\n// Base\n.timeline {\n\t// Item\n\t.timeline-item {\n\t\tposition: relative;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tdisplay: flex;\n\t\talign-items: flex-start;\n\n\t\t&:last-child {\n\t\t\t.timeline-line {\n\t\t\t\tbottom: 100%;\n\t\t\t}\n\t\t}\n\t}        \n\n\t// Line\n\t.timeline-line {\n\t\tdisplay: block;\n\t\tcontent: \" \";\n\t\tjustify-content: center;     \n\t\tposition: absolute;\n\t\tz-index: 0;\n\t\tleft: 0;\n\t\ttop:0;\n\t\tbottom: 0;\n\t\ttransform: translate(50%);\n\t\tborder-left-width: 1px;\n\t\tborder-left-style: dashed;\n\t\tborder-left-color: $gray-300; \n\t}\n\n\t// Icon\n\t.timeline-icon {\n\t\tz-index: 1;\n\t\tflex-shrink: 0;\n\t\tmargin-right: 1rem;\n\t}\n\n\t// Content\n\t.timeline-content {\n\t\twidth: 100%;\n\t\toverflow: auto;\n\t\tmargin-bottom: 1.5rem;\n\t}\n\n\t// Vertical center \n\t&.timeline-center {\n\t\t.timeline-item {\n\t\t\talign-items: center;\n\n\t\t\t&:first-child {\n                .timeline-line {\n                    top: 50%;\n                }\n            }\n\n            &:last-child {\n                .timeline-line {\n                    bottom: 50%;\n                }\n            }\n\t\t}\n\t}\n}\n","//\n// Demo\n//\n\n\n.overlay  {\n    position: relative;\n\n    .overlay-wrapper {\n\n    }\n\n    .overlay-layer {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background-color: get($overlay, bg);\n        transition: all 0.3s ease;\n        opacity: 0;\n    }\n\n    &.overlay-show,\n    &.overlay-block,\n    &:hover {\n        .overlay-layer {\n            transition: all 0.3s ease;\n            opacity: 1;\n        }\n    }\n\n    &.overlay-block {\n        cursor: wait;\n    }\n}\n","//\n// Bullet\n//\n\n// Base\n.bullet {\n    display: inline-block;\n    background-color: get($bullet, bg-color);\n    @include border-radius(get($bullet, bar-border-radius));\n    width: get($bullet, bar-width);\n    height: get($bullet, bar-height);\n    flex-shrink: 0;\n}\n\n// Dot bullet\n.bullet-dot {\n    width: get($bullet, dot-size);\n    height: get($bullet, dot-size);\n    border-radius: 100% !important;\n}\n\n// Vertical bullet\n.bullet-vertical {\n    width: get($bullet, bar-height);\n    height: get($bullet, bar-width);\n}\n\n// Vertical line\n.bullet-line {\n    width: get($bullet, line-width);\n    height: get($bullet, line-height);\n    border-radius: none;\n}","//\n// Drawer\n//\n\n// Drawer\n.drawer {\n\tdisplay: flex !important;\n\toverflow: auto;\n\tz-index: get($drawer, z-index);\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tbackground-color: get($drawer, bg-color);\n\ttransition: transform get($drawer, transition-speed) ease-in-out;\n\n\t&.drawer-start {\n\t\tleft: 0;\n\t\ttransform: translateX(-100%);\n\t}\n\n\t&.drawer-end {\n\t\tright: 0;\n\t\ttransform: translateX(100%);\n\t}\n\n\t&.drawer-on {\n\t\ttransform: none;\n\t\tbox-shadow: get($drawer, box-shadow);\n\t\ttransition: transform get($drawer, transition-speed) ease-in-out;\n\t}\n}\n\n// Drawer Overlay\n.drawer-overlay {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n\tright: 0;\n\toverflow: hidden;\n\tz-index: get($drawer, z-index) - 1;\n\tbackground-color: get($drawer, overlay-bg-color);\n\tanimation: animation-drawer-fade-in get($drawer, overlay-animation-speed) ease-in-out 1;\n}\n\n// Initial state\n[data-kt-drawer=\"true\"] {\n\tdisplay: none;\n}\n\n// Animation\n@keyframes animation-drawer-fade-in {\n\tfrom   { opacity: 0; }\n\tto { opacity: 1; }\n}\n\n// Tablet & Mobile Modes\n@include media-breakpoint-down(lg) {\n\tbody[data-kt-drawer=\"on\"] {\n\t\toverflow: hidden;\n\t}\n}\n","//\n// Badge\n//\n\n.badge {\n    // Fixed size\n    &.badge-circle,\n    &.badge-square {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        height: $badge-size;\n        min-width: $badge-size;\n        padding: 0 0.1rem;\n    }\n\n    // Circle\n    &.badge-circle {\n        border-radius: 50%;\n        padding: 0;\n        min-width: unset;\n        width: $badge-size;\n    }\n\n    // Sizes\n    &.badge-sm {\n        min-width: $badge-size-sm;\n        font-size: $badge-font-size-sm;\n\n        &.badge-circle {\n            width: $badge-size-sm;\n            height: $badge-size-sm;\n        }\n    }\n\n    &.badge-lg {\n        min-width: $badge-size-lg;\n        font-size: $badge-font-size-lg;\n\n        &.badge-circle {\n            width: $badge-size-lg;\n            height: $badge-size-lg;\n        }\n    }\n}\n\n@each $name, $value in $theme-colors {\n    .badge-#{$name} {\n        color: theme-inverse-color($name);\n        background-color: $value;\n    }\n\n    .badge-light-#{$name} {\n        color: $value;\n        background-color: theme-light-color($name);\n    }\n}\n","//\n// Indicator\n//\n\n.indicator-progress {\n    display: none;\n\n    [data-kt-indicator=\"on\"] > & {\n        display: inline-block;\n    }\n}\n\n.indicator-label {\n    [data-kt-indicator=\"on\"] > & {\n        display: none;\n    }\n}","//\n// Rotate\n// \n\n\n$rotate-transition: transform 0.3s ease;\n\n.rotate {\n    display: inline-flex;\n    align-items: center;\n}\n\n@each $value in (90, 180, 270) {\n    .rotate-#{$value} {\n        transition: $rotate-transition;\n        -webkit-backface-visibility: hidden;\n\n        .collapsible:not(.collapsed)> & ,\n        .active > & {\n\n            transform: rotateZ(#{$value}deg);\n            transition: $rotate-transition;\n\n            [direction=\"rtl\"] & {\n\n                transform: rotateZ(-#{$value}deg);\n            }\n        }\n    }\n\n    .rotate-n#{$value} {\n        transition: $rotate-transition;\n        -webkit-backface-visibility: hidden;\n\n        .collapsible:not(.collapsed)> &,\n        .active > & {\n\n            transform: rotateZ(-#{$value}deg);\n            transition: $rotate-transition;\n\n            [direction=\"rtl\"] & {\n\n                transform: rotateZ(#{$value}deg);\n            }\n        }\n    }\n}","//\n// Scroll\n//\n\n\n// Customize native scrollbars only for desktop mode\n@include media-breakpoint-up(lg) {\n    main,\n    span,\n    ol,\n    ul,\n    pre,\n    div {\n        // Firefox\n        scrollbar-width: thin;\n\n        // Webkit\n        &::-webkit-scrollbar {\n            width: get($scrollbar, width);\n            height: get($scrollbar, height);\n        }\n\n        // Default color\n        @include scrollbar-color(get($scrollbar, color), get($scrollbar, hover-color));\n    }\n}\n\n// Overflow scroll\n.scroll {\n    overflow: scroll;\n    position: relative;\n\n    // Tablet & mobile modes\n    @include media-breakpoint-down(lg) {\n        overflow: auto;\n    }\n}\n\n.scroll-x {\n    overflow-x: scroll;\n    position: relative;\n\n    // Tablet & mobile modes\n    @include media-breakpoint-down(lg) {\n        overflow-x: auto;\n    }\n}\n\n.scroll-y {\n    overflow-y: scroll;\n    position: relative;\n\n    // Tablet & mobile modes\n    @include media-breakpoint-down(lg) {\n        overflow-y: auto;\n    }\n}\n\n// Hover overflow scroll\n.hover-scroll {\n    position: relative;\n\n    // Desktop mode\n    @include media-breakpoint-up(lg) {\n        overflow: hidden;\n\n        border-right: get($scrollbar, width) solid transparent;\n        border-bottom: get($scrollbar, height) solid transparent;\n        margin-right: -#{get($scrollbar, width)};\n        margin-bottom: -#{get($scrollbar, height)};\n\n        &:hover {\n            overflow: scroll;\n            border-right: 0;\n            border-bottom: 0;\n        }\n\n        // Firefox hack\n        @-moz-document url-prefix() {\n            overflow: scroll;\n            position: relative;\n            border-right: 0;\n            border-bottom: 0;\n        }\n    }\n\n    // Tablet & mobile modes\n    @include media-breakpoint-down(lg) {\n        overflow: auto;\n    }\n}\n\n// Hover overflow scroll y\n.hover-scroll-y {\n    position: relative;\n\n    // Desktop mode\n    @include media-breakpoint-up(lg) {\n        overflow-y: hidden;\n        border-right: get($scrollbar, width) solid transparent;\n        margin-right: -#{get($scrollbar, width)};\n\n        &:hover {\n            overflow-y: scroll;\n            border-right: 0;\n        }\n\n        // Firefox hack\n        @-moz-document url-prefix() {\n            overflow-y: scroll;\n            position: relative;\n            border-right: 0;\n        }\n    }\n\n    // Tablet & mobile modes\n    @include media-breakpoint-down(lg) {\n        overflow-y: auto;\n    }\n}\n\n// Hover overflow scroll x\n.hover-scroll-x {\n    position: relative;\n\n    // Desktop mode\n    @include media-breakpoint-up(lg) {\n        overflow-x: hidden;\n        border-bottom: get($scrollbar, height) solid transparent;\n\n        &:hover {\n            overflow-x: scroll;\n            border-bottom: 0;\n        }\n\n        // Firefox hack\n        @-moz-document url-prefix() {\n            overflow-x: scroll;\n            position: relative;\n            border-bottom: 0;\n        }\n    }\n\n    // Tablet & mobile modes\n    @include media-breakpoint-down(lg) {\n        overflow-x: auto;\n    }\n}\n\n// Hover overflow overlay\n.hover-scroll-overlay-y {\n    overflow-y: hidden;\n    position: relative;\n\n    --scrollbar-space: #{get($scrollbar, space)};\n\n    // Webkit\n    &::-webkit-scrollbar {\n        width: calc(#{get($scrollbar, width)} + var(--scrollbar-space));\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-clip: content-box;\n        border-right: var(--scrollbar-space) solid transparent;\n    }\n\n    &:hover {\n        overflow-y: overlay;\n    }\n\n    // Firefox hack\n    @-moz-document url-prefix() {\n        overflow-y: scroll;\n        position: relative;\n    }\n}\n\n// Utility classes\n.scroll-ps {\n    padding-left: get($scrollbar, width) !important;\n}\n\n.scroll-ms {\n    margin-left: get($scrollbar, width) !important;\n}\n\n.scroll-pe {\n    padding-right: get($scrollbar, width) !important;\n}\n\n.scroll-me {\n    margin-right: get($scrollbar, width) !important;\n}\n\n.scroll-px {\n    padding-left: get($scrollbar, width) !important;\n    padding-right: get($scrollbar, width) !important;\n}\n\n.scroll-mx {\n    margin-left: get($scrollbar, width) !important;\n    margin-right: get($scrollbar, width) !important;\n}","//\n// Scroll mixins\n//\n\n@mixin scrollbar-color($color, $hover-color: null) {\n    // Firefox\n    scrollbar-color: $color transparent;\n\n    // Webkit\n    &::-webkit-scrollbar-thumb {\n        background-color: $color;\n    }\n\n    @if ($hover-color != null) {\n        // Hover state\n        &:hover {\n            // Firefox\n            scrollbar-color: $hover-color transparent;\n\n            // Webkit\n            &::-webkit-scrollbar-thumb {\n                background-color: $hover-color;\n            }\n        }\n    }\n}\n","//\n// Rating\n//\n\n.rating {\n    display: flex;\n    align-items: center;\n}\n\n.rating-input {\n    position: absolute !important;\n    left: -9999px !important;\n\n    &[disabled] {\n        display: none;\n    }\n}\n\n.rating-label {\n    padding: 0;\n    margin: 0;\n\n    & > i {\n        line-height: 1;\n        color: get($rating, color, default);\n    }\n\n    & > .svg-icon {\n        line-height: 1;\n        @include svg-icon-color(get($rating, color, default));\n    }\n}\n\nlabel.rating-label {\n    cursor: pointer;\n}\n\ndiv.rating-label.checked,\nlabel.rating-label {\n    & > i {\n        color: get($rating, color, active);\n    }\n\n    & > .svg-icon {\n        @include svg-icon-color(get($rating, color, active));\n    }\n}\n\n.rating-input:checked ~ .rating-label > i {\n    color: get($rating, color, default);\n}\n\n.rating-input:checked ~ .rating-label > .svg-icon {\n    @include svg-icon-color(get($rating, color, default));\n}\n\n.rating:hover label.rating-label > i {\n    color: get($rating, color, active);\n}\n\n.rating:hover label.rating-label > .svg-icon {\n    @include svg-icon-color(get($rating, color, active));\n}\n\nlabel.rating-label:hover ~ .rating-label > i {\n    color: get($rating, color, default);\n}\n\nlabel.rating-label:hover ~ .rating-label > .svg-icon {\n    @include svg-icon-color(get($rating, color, default));\n}\n","//\n// Stepper\n//\n\n// Base\n.stepper {\n\t// Content\n\t[data-kt-stepper-element=\"info\"],\n\t[data-kt-stepper-element=\"content\"] {\n\t\tdisplay: none;\n\n\t\t&.current {\n\t\t\tdisplay: flex;\n\t\t}\n\t}\n\n\t// Enable cursor pointer on clickable steppers\n\t.stepper-item[data-kt-stepper-action=\"step\"] {\n\t\tcursor: pointer;\n\t}\n\n\t// States\n\t& {\n\t\t[data-kt-stepper-action=\"previous\"] {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"next\"] {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"submit\"] {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t&.first {\n\t\t[data-kt-stepper-action=\"previous\"] {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"next\"] {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"submit\"] {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t&.between {\n\t\t[data-kt-stepper-action=\"previous\"] {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"next\"] {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"submit\"] {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t&.last {\n\t\t[data-kt-stepper-action=\"previous\"] {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"next\"] {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"submit\"] {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"submit\"].btn-flex {\n\t\t\tdisplay: flex;\n\t\t}\n\t}\n}","//\n// Stepper Pills\n//\n\n// Base\n.stepper.stepper-pills {\n    $pills-size: 40px;\n\n    // Nav\n    .stepper-nav {\n        display: flex;\n    }\n\n    // Item\n    .stepper-item {\n        display: flex;\n        align-items: center;\n        transition: $transition-link;            \n\n        // Icon\n        .stepper-icon {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            transition: $transition-link;\n            width: $pills-size;\n            height: $pills-size;\n            border-radius: $border-radius;\n            background-color: $primary-light;\n            margin-right: 1.5rem;\n\n            .stepper-check {\n                display: none;\n                font-size: 1rem;\n            }\n\n            .stepper-number {\n                font-weight: $font-weight-bolder;\n                color: $primary !important;\n                font-size: 1.25rem;\n            }\n        }\n\n        // Label\n        .stepper-label {\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n\n            .stepper-title {\n                color: $gray-800;\n                font-weight: 600;\n                font-size: 1.25rem;\n                margin-bottom: .3rem;\n            }\n\n            .stepper-desc {\n                color: $text-muted;\n            }\n        }\n\n        // Current\n        &.current {\n            transition: $transition-link;\n\n            .stepper-icon {\n                transition: $transition-link;\n                background-color: $primary;\n\n                .stepper-check {\n                    color: $primary;\n                    display: none;\n                }\n\n                .stepper-number {\n                    color: $white !important;\n                    font-size: 1.35rem;\n                }\n            }\n\n            .stepper-label {\n                .stepper-title {\n                    color: $gray-600;\n                }\n\n                .stepper-desc {\n                    color: $gray-400;\n                }\n            }\n        }\n\n        // Completed\n        &.current:last-child,\n        &.completed {\n            .stepper-icon {\n                transition: $transition-link;\n                background-color: $primary-light;\n\n                .stepper-check {\n                    color: $primary !important;\n                    display: inline-block;\n                }\n\n                .stepper-number {\n                    display: none;\n                }\n            }\n\n            .stepper-label {\n                .stepper-title {\n                    color: $text-muted;\n                }\n\n                .stepper-desc {\n                    color: $gray-400;\n                }\n            }\n        }\n    }\n\n    // Column\n    &.stepper-column {\n        // Nav\n        .stepper-nav {\n            flex-direction: column;\n        }\n\n        // Item\n        .stepper-item {\n            position: relative;\n            padding: 0;\n\t\t    margin: 0;\n            padding-bottom: 2.5rem;\n        }\n\n        // Icon\n        .stepper-icon {\n            z-index: 1;\n        }\n\n        // Line\n        .stepper-line {\n            display: block;\n            content: \" \";\n            justify-content: center;     \n            position: absolute;\n            z-index: 0;\n            left: 0;\n            top:0;\n            bottom: 0;\n            width: $pills-size;\n            transform: translate(50%);\n            border-left-width: 1px;\n            border-left-style: dashed;\n            border-left-color: $gray-300; \n        }\n\n        // First item\n        .stepper-item:first-child {\n            .stepper-line {\n                top: 50%;\n            }\n        }\n\n        // Last item\n        .stepper-item:last-child {\n            .stepper-line {\n                bottom: 50%;\n            }\n        }\n    }    \n}\n","//\n// Toggle\n//\n\n.toggle {\n    &.collapsible:not(.collapsed), // Integration with Bootstrap Collapse\n    &.active {\n        .toggle-off {\n            display: none;\n        }\n    }\n\n    &.collapsible.collapsed, // Integration with Bootstrap Collapse\n    &:not(.collapsible):not(.active) {\n        .toggle-on {\n            display: none;\n        }\n    }\n}","//\n// Shape\n// \n\n.xehagon {\n    //$edges-number: 6, $main-radius: 30%, $rounding-radius: 10%, $rotated: true, $precision: 20\n    @include shape(6);\n}\n\n.octagon {\n    //$edges-number: 6, $main-radius: 30%, $rounding-radius: 10%, $rotated: true, $precision: 20\n    @include shape(8);\n}","\n@use 'sass:math';\n\n@mixin shape($edges-number: 6, $main-radius: 30%, $rounding-radius: 10%, $rotated: true, $precision: 20) {\n\t$central-angle: divide(360deg, $edges-number);\n\t$angle: ($edges-number - 2) * divide(180deg, $edges-number);\n\t$max-var-angle: 2 * (90deg - divide($angle, 2));\n\t$precision: 6;\n\t$unit-var-angle: divide($max-var-angle, $precision);\t\n\t$r-diff: $main-radius + $rounding-radius;\n\n\t$points: ();\n\n\t@for $i from 0 to $edges-number {\n\t\t$vertex-angle: $i * $central-angle + if($rotated, -90deg, 0deg);\n\t\t$vertex-x: 50% + $r-diff * math.cos($vertex-angle);\n\t\t$vertex-y: 50% + $r-diff * math.sin($vertex-angle);\n\n\t\t@for $j from 0 through $precision {\n\t\t\t$curr-angle: $vertex-angle + ($j - 0.5 * $precision) * $unit-var-angle;\n\t\t\t$x: $vertex-x + $rounding-radius * math.cos($curr-angle);\n\t\t\t$y: $vertex-y + $rounding-radius * math.sin($curr-angle);\n\n\t\t\t$points: $points, $x $y;\n\t\t}\n\t}\n\t\n\tclip-path: polygon($points);\n}","//\n// Ribbon\n//\n\n// Base\n.ribbon {\n\tposition: relative;\n\n\t// Ribbon target\n\t.ribbon-label {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tpadding: 5px 10px;\n\t\tposition: absolute;\n\t\tz-index: 1;\n\t\tbackground-color: $primary;\n\t\tbox-shadow: 0px -1px 5px 0px rgba(#000, 0.1);\n\t\tcolor: theme-inverse-color(\"primary\");\n\t\ttop: 50%;\n\t\tright: 0;\n\t\ttransform: translateX(5px) translateY(-50%);\n\n\t\t> .ribbon-inner {\n\t\t\tz-index: -1;\n\t\t\tposition: absolute;\n\t\t\tpadding: 0;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t}\n\n\t\t&:after {\n\t\t\tborder-color: darken($primary, 30%);\n\t\t}\n\t}\n\n\t// Vertical aligment\n\t&-vertical {\n\t\t.ribbon-label {\n\t\t\tpadding: 5px 10px;\n\t\t\tmin-width: 36px;\n\t\t\tmin-height: 46px;\n\t\t\ttext-align: center;\n\t\t}\n\t}\n\n\t&.ribbon-top {\n\t\t.ribbon-label {\n\t\t\ttop: 0;\n\t\t\ttransform: translateX(-15px) translateY(-4px);\n\t\t\tborder-bottom-right-radius: $border-radius;\n\t\t\tborder-bottom-left-radius: $border-radius;\n\t\t}\n\t}\n\n\t&.ribbon-bottom {\n\t\t.ribbon-label {\n\t\t\tborder-top-right-radius: $border-radius;\n\t\t\tborder-top-left-radius: $border-radius;\n\t\t}\n\t}\n\n\t&.ribbon-start {\n\t\t.ribbon-label {\n\t\t\ttop: 50%;\n\t\t\tleft: 0;\n\t\t\tright: auto;\n\t\t\ttransform: translateX(-5px) translateY(-50%);\n\t\t\tborder-top-right-radius: $border-radius;\n\t\t\tborder-bottom-right-radius: $border-radius;\n\t\t}\n\t}\n\n\t&.ribbon-end {\n\t\t.ribbon-label {\n\t\t\tborder-top-left-radius: $border-radius;\n\t\t\tborder-bottom-left-radius: $border-radius;\n\t\t}\n\t}\n}\n\n// Clip style\n.ribbon.ribbon-clip {\n\t&.ribbon-start {\n\t\t.ribbon-label {\n\t\t\tleft: -5px;\n\n\t\t\t.ribbon-inner {\n\t\t\t\tborder-top-right-radius: $border-radius;\n\t\t\t\tborder-bottom-right-radius: $border-radius;\n\n\t\t\t\t&:before,\n\t\t\t\t&:after {\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tborder-style: solid;\n\t\t\t\t\tborder-color: transparent !important;\n\t\t\t\t\tbottom: -10px;\n\t\t\t\t}\n\n\t\t\t\t&:before {\n\t\t\t\t\tborder-width: 0 10px 10px 0;\n\t\t\t\t\tborder-right-color: if(isDarkMode(), $light, $dark) !important;\n\t\t\t\t\tleft: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ribbon-end {\n\t\t.ribbon-label {\n\t\t\tright: -5px;\n\n\t\t\t.ribbon-inner {\n\t\t\t\tborder-top-left-radius: $border-radius;\n\t\t\t\tborder-bottom-left-radius: $border-radius;\n\n\t\t\t\t&:before,\n\t\t\t\t&:after {\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tborder-style: solid;\n\t\t\t\t\tborder-color: transparent !important;\n\t\t\t\t\tbottom: -10px;\n\t\t\t\t}\n\n\t\t\t\t&:before {\n\t\t\t\t\tborder-width: 0 0 10px 10px;\n\t\t\t\t\tborder-left-color: if(isDarkMode(), $light, $dark) !important;\n\t\t\t\t\tright: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n// Triangle style\n.ribbon.ribbon-triangle {\n\tposition: absolute;\n\tz-index: 1;\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\n\t// Top start position\n\t&.ribbon-top-start {\n\t\ttop: 0;\n\t\tleft: 0;\n\t\twidth: 4rem;\n\t\theight: 4rem;\n\t\tborder-bottom: solid 2rem transparent !important;\n\t\tborder-left: solid 2rem red;\n\t\tborder-right: solid 2rem transparent !important;\n\t\tborder-top: solid 2rem red;\t \n\t}\n\n\t// Top end position\n\t&.ribbon-top-end {\n\t\ttop: 0;\n\t\tright: 0;\n\t\twidth: 4rem;\n\t\theight: 4rem;\n\t\tborder-bottom: solid 2rem transparent !important;\n\t\tborder-left: solid 2rem transparent !important;\n\t\tborder-right: solid 2rem red;\n\t\tborder-top: solid 2rem red;\t\t \n\t}\n\n\t// Botton start position\n\t&.ribbon-bottom-start {\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\twidth: 4rem;\n\t\theight: 4rem;\n\t\tborder-bottom: solid 2rem red;\n\t\tborder-left: solid 2rem red;\n\t\tborder-right: solid 2rem transparent !important;\n\t\tborder-top: solid 2rem transparent !important;\t\n\t}\t\n\t\n\t// Botton end position\n\t&.ribbon-bottom-end {\n\t\tbottom: 0;\n\t\tright: 0;\n\t\twidth: 4rem;\n\t\theight: 4rem;\n\t\tborder-bottom: solid 2rem red;\n\t\tborder-right: solid 2rem red;\n\t\tborder-left: solid 2rem transparent !important;\n\t\tborder-top: solid 2rem transparent !important;\t\t\t \n\t}\t\t \n}\n\n","//\n// BlockUI\n//\n\n\n.blockui  {\n    position: relative;\n\n    .blockui-overlay {\n        transition: all 0.3s ease;\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background-color: get($blockui, overlay-bg);\n\n        .spinner-border {\n            height: 1.35rem;\n            width: 1.35rem;\n        }\n    }\n\n    .blockui-message {\n        display: flex;\n        align-items: center;\n        @include border-radius($border-radius);\n        box-shadow: $dropdown-box-shadow;\n        background-color: $tooltip-bg;\n        color: if(isDarkMode(), $gray-700, $gray-600);\n        font-weight: $font-weight-bold;\n        margin: 0 !important;\n        width: auto;\n        padding: 0.85rem 1.75rem !important;\n\n        .spinner-border {\n            margin-right: 0.65rem;\n        }\n    }\n}\n","//\n// Explore(used for demo product demo)\n//\n\n$explore-primary: #00B2FF;\n$explore-primary-light: #F1FAFF;\n$explore-primary-active: #0098DA;\n$explore-primary-inverse: $white;\n\n$explore-success: #50CD89;\n$explore-success-light: #E8FFF3;\n$explore-success-active: #47BE7D;\n$explore-success-inverse: $white;\n\n$explore-warning: #FFC700;\n$explore-warning-inverse: $white;\n\n$explore-danger: #F1416C;\n$explore-warning-inverse: $white;\n\n.explore-btn-toggle {\n    color: $gray-600;\n    background-color: $white;\n\n    &:hover,\n    &:focus,\n    &:active {\n        color: $explore-primary-inverse;\n        background-color: $explore-primary;\n    }\n}\n\n.explore-btn-dismiss {\t\n    border: 0;\n\n    &:hover {\n        i {\n            color: $explore-primary;\n        }\n        \n        .svg-icon {\n    \t\t@include svg-icon-color($explore-primary);\n    \t}\n    }\n}\n\n.explore-btn-primary {\t\n\tborder: 0;\n    color: $explore-primary-inverse;\n    background-color: $explore-primary;\n\n    &:hover {\n        color: $explore-primary-inverse;\n        background-color: $explore-primary-active;\n    }\n}\n\n.explore-btn-secondary {\t\n\tborder: 0;\n    color: $gray-600;\n    background-color: $gray-100;\n\n    &:hover {\n        color: $gray-800;\n        background-color: $gray-200;\n    }\n}\n\n.explore-btn-outline {\n    border: 1px dashed $gray-300 !important;\n\n    &:hover,\n    &.active {\n        border: 1px dashed $explore-success !important;\n        background-color: $explore-success-light;\n    }\n}\n\n.explore-link {\t\n    color: $explore-primary;\n\n    &:hover {\n        color: $explore-primary-active;\n    }\n}\n\n.explore-link-hover:hover {\t\n    color: $explore-primary !important;\n}\n\n.explore-icon-success {\t\n    color: $explore-success;\n    @include svg-icon-color($explore-success);\n}\n\n.explore-icon-danger {\t\n    color: $explore-danger;\n    @include svg-icon-color($explore-danger);\n}\n\n.explore-label-free {\n    color: $explore-warning-inverse;\n    background-color: $explore-warning;\n}\n\n.explore-label-pro {\n    color: $explore-success-inverse;\n    background-color: $explore-success;\n}","//\n// Cookie Alert\n//\n\n.cookiealert{\n    background: inherit;\n    color: inherit;\n}","//\n// Stepper Links\n//\n\n// Base\n.stepper.stepper-links {\n    .stepper-nav {\n\t\tdisplay: flex;\n\t\tmargin: 0 auto;\n\t\tjustify-content: center;\n\t\talign-items: center;\t\n\t\tflex-wrap: wrap;\n\n        .stepper-item {\n\t\t\tposition: relative;\n\t\t\tflex-shrink: 0;\n\t\t\tmargin: 1rem 1.5rem;\n\n\t\t\t&:after {\n\t\t\t\tcontent: \" \";\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 2.3rem;\n\t\t\t\tleft: 0;\n\t\t\t\theight: 2px;\n\t\t\t\twidth: 100%;\n\t\t\t\tbackground-color: transparent;\n\t\t\t\ttransition: $transition-link;\n\t\t\t}           \n\n            .stepper-title {\n                color: $dark;\n                font-weight: 600;\n                font-size: 1.25rem; \n            }             \n\n            // Current\n            &.current {\n\t\t\t\ttransition: $transition-link;\n\t\t\t\t\n\t\t\t\t.stepper-title {\n\t\t\t\t\tcolor: $primary;\t\t\t\t\t \n\t\t\t\t}               \n                \n\t\t\t\t&:after {\t\t\t\t\t\n\t\t\t\t\tbackground-color: $primary;\n\t\t\t\t}\t\t\t\t                              \n\t\t\t} \n\t\t\t\n\t\t\t&.completed {\n\t\t\t\t.stepper-title {\n\t\t\t\t\tcolor: $gray-400;\n\t\t\t\t}  \t\t\t\n\t\t\t}\n        }\n    }     \n}","//\n// Timeline Label\n//\n\n\n.timeline-label {\n\tposition: relative;\n\n    $label-width: 50px;\n\n\t&:before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tleft: $label-width + 1px;\n\t\twidth: 3px;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tbackground-color: $gray-200;\n\t}\n\n\t// \n\t.timeline-item {\n\t\tdisplay: flex;\n        align-items: flex-start;\n\t\tposition: relative;\n\t\tmargin-bottom: 1.7rem;\n\n        &:last-child {\n            margin-bottom: 0;\n        }\n\t}\n\n\t.timeline-label {\n\t\twidth: $label-width;\n\t\tflex-shrink: 0;\n\t\tposition: relative;\n\t\tcolor: $gray-800;\n\t}\n\n\t.timeline-badge {\n\t\tflex-shrink: 0;\n\t\tbackground: $body-bg;\n\t\twidth: 1rem;\n\t\theight: 1rem;\n\t\tborder-radius: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tz-index: 1;\n\t\tposition: relative;\n\t\tmargin-top: 1px;\n\t\tmargin-left: -0.5rem;\n\t\tpadding: 3px !important;\n\t\tborder: 6px solid $body-bg !important;\n\n\t\tspan {\n\t\t\tdisplay: block;\n\t\t\tborder-radius: 100%;\n\t\t\twidth: 6px;\n\t\t\theight: 6px;\n\t\t\tbackground-color: $gray-200;\n\t\t}\n\t}\n\n\t.timeline-content {\n\t\tflex-grow: 1;\n\t}\n}\n","//\n// Custom Placeholder \n//\n\n.placeholder-white-opacity-75 {\n    @include placeholder(rgba($white, 0.75));\n}","//\n// Item Hover Custom\n//\n\n\n.item-border-hover {\n    border: 1px solid #fff;\n    border-radius: 6px;\n\n    &:hover {\n        border: 1px solid #EFF2F5;\n        cursor: pointer;\n        transition: $transition-link;\n        background-color: rgba(245, 248, 250, 0.3);\n\n        .label {\n            background-color: #00A3FF !important;\n            transition: $transition-link;\n            color: #fff;\n        }\n    }\n\n    .label {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        border-radius: 6px;\n    }\n}\n","// NoUiSlider success color option\n.noUi-target.noUi-target-success {\n    .noUi-connects {\n        background: $success-light;\n\n        .noUi-connect {\n            background: $success;\n        }\n    }\n\n    .noUi-handle {\n        border: 1px solid $success;\n        box-shadow: 0 3px 6px -3px rgba($success, 0.7);\n        background: $success;\n    }\n}","//\n// Landing elements\n//\n\n// Variables\n$landing-dark-color: #13263C;\n$landing-header-height: 100px;\n$landing-header-height-tablet-and-mobile: 70px;\n$landing-header-sticky-height: 70px;\n$landing-header-sticky-height-tablet-and-mobile: 70px;\n\n// Utility classes\n.landing-dark-bg {\n    background-color: $landing-dark-color;\n}\n\n.landing-dark-color {\n    color: $landing-dark-color;\n}\n\n.landing-dark-border {\n    border:1px dashed #2C3F5B;\n}\n\n.landing-dark-separator {\n    border-top:1px dashed #2C3F5B;\n}\n\n.landing-curve  {\n    position: relative;\n\n    svg {\n        position: relative;\n        top: 0;  \n        display: block;\n    }\n}\n\n// Landing header\n.landing-header {\n    display: flex;\n    align-items: center;    \n    height: $landing-header-height;\n\n    // Logos\n    .logo-default {\n        display: block;\n    }\n\n    .logo-sticky {\n        display: none;\n    }\n\n    // Menu\n    .menu {\n        // Menu link\n        .menu-link {\n            &.active {\n                color: $white;\n            }\n        }\n\n        // Header menu sticky mode\n        [data-kt-sticky-landing-header=\"on\"] & {\n            // Menu link\n            .menu-link {\n                &.active {\n                    color: $primary;\n                    background-color: rgba(#EFF2F5, 0.4);\n                }\n            }\n        }\n    }\n\n    // Sticky header modes\n    [data-kt-sticky-landing-header=\"on\"] & {        \n        padding: 0;\n        position: fixed;\n        top: 0;\n        right: 0;\n        left: 0;\n        z-index: 100;\n        background-color: $white;\n        box-shadow: 0px 10px 30px 0px rgba(82,63,105,0.05);\n        height: $landing-header-sticky-height;\n        \n        // Logos\n        .logo-sticky {\n            display: block;\n        }\n\n        .logo-default {\n            display: none;\n        }\n    }\n}\n\n// Fix body padding top when Landing sticky header is on\nbody[data-kt-sticky-landing-header=\"on\"] {\n    padding-top: $landing-header-height;\n}\n\n// Tablet & mobile modes\n@include media-breakpoint-down(lg) {\n    // Landing header\n    .landing-header {\n        height: $landing-header-height-tablet-and-mobile;\n\n        // Menu wrapper\n        .landing-menu-wrapper {\n            position: relative;\n            overflow: auto;\n        }\n\n        // Sticky header modes\n        [data-kt-sticky-landing-header=\"on\"] & { \n            height: $landing-header-sticky-height-tablet-and-mobile;\n        }\n\n        // Menu\n        .menu {\n            // Menu link\n            .menu-link {\n                &.active {\n                    color: $primary;\n                    background-color: rgba(#EFF2F5, 0.4);\n                }\n            }\n        }\n    }\n\n    // Fix body padding top when Landing sticky header is on\n    body[data-kt-sticky-landing-header=\"on\"] {\n        padding-top: $landing-header-height-tablet-and-mobile;\n    }\n}","html {\n  font-family: sans-serif; // 1\n  text-size-adjust: 100%; // 2\n  -webkit-text-size-adjust: 100%; // 2\n  -webkit-tap-highlight-color: rgba(0,0,0,0);\n}\n\nhtml,\nbody {\n    height: 100%;\n    margin: 0px;\n    padding: 0px;\n    font-size: $root-font-size !important;\n    font-weight: $font-weight-base;\n    font-family: $font-family-sans-serif;\n\n    // Tablet mode\n    @include media-breakpoint-down(lg) {\n        font-size: $root-font-size-lg !important;\n    }\n\n    // Mobile mode\n    @include media-breakpoint-down(md) {\n        font-size: $root-font-size-md !important;\n    }\n\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n\n    a:hover,\n    a:active,\n    a:focus {\n        text-decoration: none !important;\n    }\n}\n\nbody {\n    display: flex;\n    flex-direction: column;\n    color: $body-color;\n}\n\n// Angular integration\nrouter-outlet {\n    display: none;\n}\n\ncanvas {\n    user-select: none;\n}\n","//\n// Print Mode\n//\n\n// Add .print-content-only class to body element in order to allow printing only the content area\n@media print {\n    .print-content-only {\n        padding: 0 !important;\n        background: none !important;\n\n        .wrapper,\n        .page,\n        .page-title\n        .content,\n        .container,\n        .container-xxl,\n        .container-fluid {\n            background: none !important;\n            padding: 0 !important;\n            margin: 0 !important;\n        }\n\n        .aside,\n        .sidebar,\n        .scrolltop,\n        .header,\n        .footer,\n        .toolbar,\n        .drawer,\n        .btn {\n            display: none !important;\n        }\n    }\n}\n","//\n// Main\n//\n\n\n// Body\nbody {\n\tbackground-color: $page-bg;\n}\n\n// Font color from Content background color\n.text-page-bg {\n\tcolor: $page-bg;\n}\n\n// Desktop Mode\n@include media-breakpoint-up(lg) {\n\t// Containers\n\t.container,\n\t.container-xxl,\n\t.container-fluid {\n\t\tpadding: 0 get($content-spacing, desktop);\n\t}\n\n\t// Wrapper\n\t.wrapper {\n\t\ttransition: padding-left get($aside-config, transition-speed) ease,  margin-right get($aside-config, transition-speed) ease;\n\n\t\t// Aside default enabled and aside fixed modes\n\t\t.aside-enabled.aside-fixed & {\n\t\t\ttransition: padding-left get($aside-config, transition-speed) ease;\n\t\t\tpadding-left: get($aside-config, width);\n\t\t}\n\n\t\t// Aside default enabled, aside fixed and aside minimize modes\n\t\t.aside-enabled.aside-fixed[data-kt-aside-minimize=\"on\"] & {\n\t\t\ttransition: padding-left get($aside-config, transition-speed) ease;\n\t\t\tpadding-left: get($aside-config, minimized-width);\n\t\t}\n\n\t\t// Fixed header mode\n\t\t.header-fixed & {\n\t\t\tpadding-top: get($header-config, fixed, height, desktop);\n\t\t}\n\n\t\t// Fixed header & fixed toolbar modes\n\t\t.header-fixed.toolbar-fixed & {\n\t\t\tpadding-top: calc(#{get($header-config, fixed, height, desktop)} + var(--kt-toolbar-height));\n\t\t}\n\t}\n}\n\n// Tablet & mobile modes\n@include media-breakpoint-down(lg) {\n\t// Containers\n\t.container,\n\t.container-xxl,\n\t.container-fluid {\n\t\tmax-width: none;\n\t\tpadding: 0 get($content-spacing, tablet-and-mobile);\n\t}\n\n\t// Wrapper\n\t.wrapper {\n\t\t// Fixed header mode\n\t\t.header-tablet-and-mobile-fixed & {\n\t\t\tpadding-top: get($header-config, fixed, height, tablet-and-mobile);\n\t\t}\n\n\t\t// Fixed header & fixed toolbar modes\n\t\t.header-tablet-and-mobile-fixed.toolbar-tablet-and-mobile-fixed & {\n\t\t\tpadding-top: calc(#{get($header-config, fixed, height, tablet-and-mobile)} + var(--kt-toolbar-height-tablet-and-mobile));\n\t\t}\n\t}\n}\n","//\n// Layout Config\n//\n\n// Root font Sizes\n$root-font-size:                                    13px; // Root font size for desktop mode\n$root-font-size-lg:                             \t13px; // Root font size for tablet mode\n$root-font-size-md:                             \t12px; // Root font size for mobile mode\n\n// Page bg\n$page-bg: \t\t\t\t\t\t\t\t\t\t\tif(isDarkMode(), #151521, $gray-100) !default;\n\n// Content border radius\n$content-border-radius:\t\t\t\t\t\t\t\t1.5rem !default;\n\n// Content Spacing\n$content-spacing: (\n\tdesktop: 30px, // Padding for desktop mode\n\ttablet-and-mobile: 15px // Padding for tablet and mobile modes\n) !default;\n\n// Header\n$header-config: (\n\t// Default Mode\n\tdefault: (\n\t\theight: (\n\t\t\tdesktop: 65px,\n\t\t\ttablet-and-mobile: 55px\n\t\t),\n\t\tbg-color: if(isDarkMode(),#1E1E2D, $white),\n\t),\n\n\t// Fixed Mode\n\tfixed: (\n\t\theight: (\n\t\t\tdesktop: 65px,\n\t\t\ttablet-and-mobile: 55px\n\t\t),\n\t\tz-index: 100,\n\t\tbg-color: if(isDarkMode(), #1E1E2D, $white),\n\t\tbox-shadow: if(isDarkMode(), none, 0px 10px 30px 0px rgba(82,63,105,0.05))\n\t)\n) !default;\n\n// Toolbar\n$toolbar-config: (\n\tz-index: 99,\n\theight: (\n\t\tdesktop: 75px,\n\t\ttablet-and-mobile: 60px\n\t),\n\tpadding: 0.5rem 0,\n\tbg-color: if(isDarkMode(), darken(#1e1e2d, 2%), $white),\n\tbox-shadow: if(isDarkMode(), none, 0px 10px 30px 0px rgba(82,63,105,0.05)),\n\tborder-top: if(isDarkMode(), 0, 1px solid $border-color)\n) !default;\n\n// Aside\n$aside-config: (\n\tz-index: 101, // Aside's z-index property\n\ttransition-speed: 0.3s, // transition speed\n\tpadding-x: 25px,\n\tmenu-indention: 0.75rem,\n\tbg-color: #1e1e2d,\n\tlogo-bg-color: darken(#1e1e2d, 2%),\n\tscrollbar-color: if(isDarkMode(), $gray-200, #3b3b64),\n\tscrollbar-hover-color: if(isDarkMode(), $gray-300, lighten(#3b3b64, 3%)),\n\twidth: 265px, // Aside width for desktop mode\n\tminimized-width: 75px,  // Aside minimized width for desktop mode\n\tbox-shadow: if(isDarkMode(), none, 0 0 28px 0 rgba(82,63,105,.05)), // Aside box shadow\n\tminimized-hover-box-shadow: if(isDarkMode(), none, 5px 0px 10px rgba(70, 78, 95, 0.075)) // Monimized hover box shadow\n) !default;\n\n// Footer\n$footer-config: (\t\n\tbg-color: if(isDarkMode(), #1B1B28, $white),\n) !default;\n","//\n// Header\n//\n\n// Desktop mode\n@include media-breakpoint-up(lg) {\n\t.header {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tposition: relative;\n\t\tz-index: 2;\n\t\theight: get($header-config, default, height, desktop);\n\t\ttransition: left get($aside-config, transition-speed) ease;\n\n\t\t// Fixed header & sticky header modes\n\t\t.header-fixed & {\n\t\t\tposition: fixed;\n\t\t\ttop: 0;\n\t\t\tright: 0;\n\t\t\tleft: 0;\n\t\t\tz-index: get($header-config, fixed, z-index);\n\t\t\tbackground-color: get($header-config, fixed, bg-color);\n\t\t\theight: get($header-config, fixed, height, desktop);\n\t\t\tpadding: 0;\n\t\t\tbox-shadow: get($header-config, fixed, box-shadow);\n\t\t}\n\n\t\t// Fixed header and fixed toolbar modes\n\t\t.header-fixed.toolbar-fixed & {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t// Aside default enabled, aside fixed & header sticky modes\n\t\t.aside-enabled.aside-fixed.header-fixed & {\n\t\t\tleft: get($aside-config, width);\n\t\t\ttransition: left get($aside-config, transition-speed) ease;\n\t\t}\n\n\t\t// Aside default enabled, aside fixed, header sticky & aside minimize modes\n\t\t.aside-enabled.aside-fixed.header-fixed[data-kt-aside-minimize=\"on\"] & {\n\t\t\tleft: get($aside-config, minimized-width);\n\t\t\ttransition: left get($aside-config, transition-speed) ease;\n\t\t}\n\n\t\t// Header menu\n\t\t.header-menu {\n\t\t\tdisplay: flex;\n\t\t}\n\t}\n}\n\n// Tablet & mobile modes\n@include media-breakpoint-down(lg) {\n\t.header {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\theight: get($header-config, default, height, tablet-and-mobile);\n\t\tposition: relative;\n\t\tz-index: 3;\n\n\t\t// Fixed header and header sticky modes\n\t\t.header-tablet-and-mobile-fixed & {\n\t\t\tposition: fixed;\n\t\t\ttop: 0;\n\t\t\tright: 0;\n\t\t\tleft: 0;\n\t\t\tz-index: get($header-config, fixed, z-index);\n\t\t\theight: get($header-config, fixed, height, tablet-and-mobile);\n\t\t\tmin-height: get($header-config, fixed, height, tablet-and-mobile);\n\t\t\tbackground-color: get($header-config, fixed, bg-color);\n\n\t\t\t@if isDefaultSkin() {         \n\t\t\t\tbox-shadow: get($header-config, fixed, box-shadow);\n            }\n\t\t}\n\n\t\t// Fixed header and fixed toolbar modes\n\t\t.header-tablet-and-mobile-fixed.toolbar-tablet-and-mobile-fixed & {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t// Header menu\n\t\t.header-menu {\n\t\t\tdisplay: none;\n\t\t\tz-index: get($header-config, fixed, z-index) - 1;\n\t\t}\n\n\t\t// Page title\n\t\t.page-title {\n\t\t\tdisplay: none !important;\n\t\t}\n\t}\n}\n\n//Scrollable Top bar\n.horizontal-scroll-wrapper{\n\tposition:absolute;\n\tdisplay:block;\n\ttop:0;\n\tleft:0;\n\twidth:80px;\n\tmax-height:500px;\n\tmargin:0;\n\tbackground:white;\n\toverflow-y:auto;\n\toverflow-x:hidden;\n\ttransform:rotate(-90deg) translateY(-80px);\n\ttransform-origin:right top;\n  }\n  .horizontal-scroll-wrapper > div{\n\tdisplay:block;\n\tpadding:5px;\n\tbackground: white;\n\ttransform:rotate(90deg);\n\ttransform-origin: right top;\n  }\n  \n  .squares{\n\tpadding:60px 0 0 0;\n  }\n  \n  .squares > div{\n\twidth:80px;\n\theight:60px;\n\tmargin:10px;\n  }","//\n// toolbar\n//\n\n// General mode\n.toolbar {\n    display: flex;\n    align-items: center;\n    background-color: get($toolbar-config, bg-color);\n    padding: get($toolbar-config, padding);\n}\n\n// Desktop mode\n@include media-breakpoint-up(lg) {\n    .toolbar {\n        // Fixed toolbar\n        .toolbar-fixed & {\n\t\t\theight: var(--kt-toolbar-height);\n      \t    position: fixed;\n\t\t\ttop: 0;\n\t\t\tright: 0;\n\t\t\tleft: 0;\n\t\t\tz-index: get($toolbar-config, z-index);\t\t\t\n            box-shadow: get($toolbar-config, box-shadow);\n        }\n\n\t\t// toolbar enabled & toolbar not fixed modes\n\t\t.toolbar-enabled:not(.toolbar-fixed) & {\n\t\t\tmargin-bottom: get($content-spacing, desktop);\n\t\t}\n\n        // Fixed header & fixed toolbar modes\n        .header-fixed.toolbar-fixed & {\n            padding: 0;\n            top: get($header-config, fixed, height, desktop);\n            border-top: get($toolbar-config, border-top);\n        }\n\n        // Aside default enabled, aside fixed & header sticky modes\n\t\t.aside-enabled.aside-fixed.toolbar-fixed & {\n\t\t\tleft: get($aside-config, width);\n\t\t\ttransition: left get($aside-config, transition-speed) ease;\n\t\t}\n\n\t\t// Aside default enabled, aside header sticky & aside minimize modes\n\t\t.aside-enabled.aside-fixed.toolbar-fixed[data-kt-aside-minimize=\"on\"] & {\n\t\t\tleft: get($aside-config, minimized-width);\n\t\t\ttransition: left get($aside-config, transition-speed) ease;\n\t\t}\n    }\n}\n\n// Tablet & mobile modes\n@include media-breakpoint-down(lg) {\n    .toolbar {\n        // Fixed toolbar mode\n        .toolbar-tablet-and-mobile-fixed & {\n\t\t\theight: var(--kt-toolbar-height-tablet-and-mobile);\n            position: fixed;\n            top: 0;\n            right: 0;\n            left: 0;\n            z-index: get($toolbar-config, z-index);\n            box-shadow: get($toolbar-config, box-shadow);\n        }\n\n        // Toolbar enabled & toolbar not fixed modes\n\t\t.toolbar-enabled:not(.toolbar-tablet-and-mobile-fixed) & {\n\t\t\tmargin-bottom: get($content-spacing, tablet-and-mobile);\n\t\t}\n\n        // Fixed header & fixed toolbar modes\n        .header-tablet-and-mobile-fixed.toolbar-tablet-and-mobile-fixed & {\n            padding: 0;\n\t\t\ttop: get($header-config, default, height, tablet-and-mobile);\n            border-top: get($toolbar-config, border-top);\n        }\n\n        // Page title\n\t\t.page-title[data-kt-swapper=\"true\"] {\n\t\t\tdisplay: none !important;\n\t\t}\n    }\n}","//\n// Aside Default\n//\n\n// General mode(all devices)\n.aside {\n\tdisplay: flex;\n\tflex-direction: column;\n\tbox-shadow: get($aside-config, box-shadow);\n\tpadding: 0;\n\n\t// Custom button\n\t.btn-custom {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\t\t\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\n\t\t.btn-label {\n\t\t\ttransition: opacity get($aside-config, transition-speed) ease;\n\t\t\tdisplay: inline-block;\n\t\t\twhite-space: nowrap;\n\t\t\toverflow: hidden;\t\t\n\t\t\topacity: 1;\t\n\t\t}\t\n\n\t\t.btn-icon {\n\t\t\tdisplay: inline-block;\n\t\t\ttransition: opacity get($aside-config, transition-speed) ease;\n\t\t\toverflow: hidden;\t\t\n\t\t\topacity: 0;\t\n\t\t\tmargin: 0;\n\t\t\twidth: 0;\n\t\t}\n\t}\n\n\t// Dark theme\n\t&.aside-dark {\n\t\tbackground-color: get($aside-config, bg-color);\n\n\t\t// Logo\n\t\t.aside-logo {\n\t\t\tbackground-color: get($aside-config, logo-bg-color);\n\t\t}\n\n\t\t// Aside toggle\n\t\t.aside-toggle {\n\t\t\t@include svg-icon-color(#494b74);\n\t\t}\n\n\t\t// Separator\n\t\t.separator {\n\t\t\tborder-bottom-color: #282a3d;\n\t\t}\n\n\t\t// Custom button\n\t\t.btn-custom {\n\t\t\t//$color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active\n\t\t\t@include button-custom-variant(#B5B5C3, null, null, rgba(63, 66, 84, 0.35), #B5B5C3, null, null, rgba(63, 66, 84, 0.35));\n\n\t\t\t.btn-icon {\n\t\t\t\tcolor: #B5B5C3;\n\t\t\t\t@include svg-icon-color(#B5B5C3);\n\t\t\t}\n\t\t}\n\t}\n\n\t// Light theme\n\t&.aside-light {\n\t\tbackground-color: $white;\n\t}\n}\n\n// Desktop mode\n@include media-breakpoint-up(lg) {\n\t.aside {\n\t\twidth: get($aside-config, width);\n\t\ttransition: width get($aside-config, transition-speed) ease;\n\n\t\t// Logo\n\t\t.aside-logo {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t\theight: get($header-config, default, height, desktop);\n\t\t\tpadding: 0 get($aside-config, padding-x);\n\t\t}\n\n\t\t// Aside menu\n\t\t.aside-menu {\n\t\t\twidth: get($aside-config, width); \n\t\t}\n\t\t\n\t\t// Fixed aside mode\n\t\t.aside-fixed & {\n\t\t\tposition: fixed;\n\t\t\ttop: 0;\n\t\t\tbottom: 0;\n\t\t\tleft: 0;\n\t\t\tz-index: get($aside-config, z-index);\n\t\t\toverflow: hidden;\n\t\t}\n\n\t\t// Static aside mode\n\t\t.aside-static & {\n\t\t\tposition: relative;\n\t\t\tz-index: 1;\n\t\t}\n\n\t\t// Minimize aside mode\n\t\t[data-kt-aside-minimize=\"on\"] & {\n\t\t\twidth: get($aside-config, minimized-width);\n\t\t\ttransition: width get($aside-config, transition-speed) ease;\n\n\t\t\t// Logo\n\t\t\t.aside-logo {\n\t\t\t\t.logo-default {\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t}\n\t\n\t\t\t\t.logo-minimize {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t// Hoverable\n\t\t\t&.aside-hoverable:hover:not(.animating) {\n\t\t\t\ttransition: width get($aside-config, transition-speed) ease;\n\t\t\t\twidth: get($aside-config, width);\n\t\t\t\tbox-shadow: get($aside-config, minimized-hover-box-shadow);\n\t\t\t}\n\n\t\t\t// Not hovered mode\n\t\t\t&:not(.aside-hoverable),\n\t\t\t&:not(:hover) {\n\t\t\t\t// Logo\n\t\t\t\t.aside-logo {\n\t\t\t\t\tjustify-content: center;\n\n\t\t\t\t\t.logo {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\n\t\t\t\t\t.logo-default {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\n\t\t\t\t\t.logo-minimize {\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t}\n\t\t\t\t}\t\t\t\t\n\n\t\t\t\t// Menu\n\t\t\t\t.aside-menu {\n\t\t\t\t\t.menu-content,\n\t\t\t\t\t.menu-title {\n\t\t\t\t\t\topacity: 0;\n\t\t\t\t\t\ttransition: opacity get($aside-config, transition-speed) ease;\n\t\t\t\t\t}\n\n\t\t\t\t\t.menu-item.show > .menu-sub {\n\t\t\t\t\t\theight: 0;\n\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\ttransition: height get($aside-config, transition-speed) ease;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t// Custom button\n\t\t\t\t.btn-custom {\n\t\t\t\t\t.btn-label {\n\t\t\t\t\t\twidth: 0;\n\t\t\t\t\t\topacity: 0;\n\t\t\t\t\t\ttransition: opacity get($aside-config, transition-speed) ease;\n\t\t\t\t\t}\t\n\n\t\t\t\t\t.btn-icon {\n\t\t\t\t\t\twidth: auto;\n\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\ttransition: opacity get($aside-config, transition-speed) ease;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n// Tablet & mobile modes\n@include media-breakpoint-down(lg) {\n\t.aside {\n\t\tdisplay: none;\n\n\t\t// Logo\n\t\t.aside-logo {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n","//\n// Menu\n//\n\n// Aside menu\n.aside-menu {\n    .menu {\n        // Link padding x\n        @include menu-link-padding-x(get($aside-config, padding-x));\n\n        // Menu indention\n        @include menu-link-indention(get($aside-config, menu-indention), get($aside-config, padding-x));\n    }\n\n    // Item\n    .menu-item {\n        padding: 0;\n\n        // Menu Link\n        .menu-link {\n            padding-top: 0.75rem;\n            padding-bottom: 0.75rem;\n        }\n\n        // Icon\n        .menu-icon {\n            justify-content: flex-start;\n        }\n    }\n}\n\n// Aside dark theme\n.aside-dark {\n    .hover-scroll-overlay-y {\n        --scrollbar-space: 0.4rem;\n        \n        @include scrollbar-color(get($aside-config, scrollbar-color), get($aside-config, scrollbar-hover-color));\n    }\n\n    .menu {\n        .menu-item {\n            .menu-section {\n                color: #b2b3c2 !important;\n            }\n\n            //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n            @include menu-link-default-state( #9899ac, #494b74, #9899ac, #9899ac, null);\n            @include menu-link-hover-state( $white, $primary, $primary, $white, #1b1b28);\n            @include menu-link-here-state( $white, $primary, $primary, $white, #1b1b28);\n            @include menu-link-show-state( $white, $primary, $primary, $white, #1b1b28);\n            @include menu-link-active-state( $white, $primary, $primary, $white, #1b1b28);\n        }\n    }\n}\n\n// Aside light theme\n.aside-light {\n    .menu {\n        .menu-title {\n            font-weight: 500;\n        }\n    }\n}","//\n// Content\n//\n\n// Desktop mode\n@include media-breakpoint-up(lg) {\n\t.content {\n\t\tpadding: get($content-spacing, desktop) 0;\n\n\t\t// Toolbar enabled and toolbar not fixed mode\n\t\t.toolbar-enabled:not(.toolbar-fixed) & {\n\t\t\tpadding-top: 0;\n\t\t}\n\t}\n}\n\n// Tablet & mobile modes\n@include media-breakpoint-down(lg) {\n\t.content {\n\t\tpadding: get($content-spacing, tablet-and-mobile) 0;\n\n\t\t// Toolbar enabled mode and toolbar not fixed mode\n\t\t.toolbar-enabled:not(.toolbar-tablet-and-mobile-fixed) & {\n\t\t\tpadding-top: 0;\n\t\t}\n\t}\n}\n","//\n// Footer\n// \n\n.footer {\n    background-color: get($footer-config, bg-color);\n}","//\n// Print Mode\n//\n\n// Add .print-content-only class to body element in order to allow printing only the content area\n@media print {\n    .print-content-only {\n        padding: 0 !important;\n        background: none !important;\n\n        .docs-wrapper,\n        .docs-page,\n        .docs-page-title\n        .docs-content,\n        .container,\n        .container-fluid {\n            background: none !important;\n            padding: 0 !important;\n            margin: 0 !important;\n        }\n\n        .docs-aside,docs-\n        .scrolltop,\n        .docs-header,\n        .drawer,\n        .btn {\n            display: none !important;\n        }\n    }\n}\n","//\n// Main\n//\n\n// Wrapper\n.docs-wrapper {\n\tbackground-color: $docs-page-bg-color;\n}\n\n// Desktop Mode\n@include media-breakpoint-up(lg) {\n\t// Containers\n\t.container,\n\t.container-fluid {\n\t\tpadding: 0 get($docs-content-spacing, desktop);\n\t}\n\n\t// Wrapper\n\t.docs-wrapper {\n\t\tpadding-left: get($docs-aside-config, width);\n\t}\n}\n\n// Tablet & mobile modes\n@include media-breakpoint-down(lg) {\n\t// Containers\n\t.container,\n\t.container-fluid {\n\t\tmax-width: none;\n\t\tpadding: 0 get($docs-content-spacing, tablet-and-mobile);\n\t}\n}\n","//\n// Layout Config\n//\n\n// Content background Color\n$docs-page-bg-color:  if(isDarkMode(), #151521, $gray-100) !default;\n\n// Content Spacing\n$docs-content-spacing: (\n\tdesktop: 30px, // Padding for desktop mode\n\ttablet-and-mobile: 15px // Padding for tablet and mobile modes\n) !default;\n\n// Aside\n$docs-aside-config: (\n\tz-index: 101, // Aside's z-index property\n\tpadding-x: 25px,\n\tmenu-indention: 0.75rem,\n\twidth: 265px, // Aside width for desktop mode\n\tbg-color: if(isDarkMode(), #1e1e2d, $white),\n\tbox-shadow: 0 0 28px 0 rgba(82,63,105,.025), // Aside box shadow\n) !default;\n","//\n// Header\n//\n\n// Desktop mode\n@include media-breakpoint-up(lg) {\n\t.docs-header {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t}\n}\n\n// Tablet & mobile modes\n@include media-breakpoint-down(lg) {\n\t.docs-header {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\n\t\t// Page title\n\t\t.docs-page-title[data-kt-swapper=\"true\"]{\n\t\t\tdisplay: none !important;\n\t\t}\n\t}\n}\n","//\n// Aside Default\n//\n\n// General mode(all devices)\n.docs-aside {\n\tdisplay: flex;\n\tflex-direction: column;\n\tbox-shadow: get($docs-aside-config, box-shadow);\n\tbackground-color: get($docs-aside-config, bg-color);\n\tpadding: 0;\n}\n\n// Desktop mode\n@include media-breakpoint-up(lg) {\n\t.docs-aside {\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tz-index: get($docs-aside-config, z-index);\n\t\toverflow: hidden;\n\t\twidth: get($docs-aside-config, width);\n\n\t\t// Logo\n\t\t.docs-aside-logo {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t\tpadding: 0 get($docs-aside-config, padding-x);\n\t\t}\n\n\t\t// Aside menu\n\t\t.docs-aside-menu {\n\t\t\twidth: get($docs-aside-config, width); \n\t\t}\n\t}\n}\n\n// Tablet & mobile modes\n@include media-breakpoint-down(lg) {\n\t.docs-aside {\n\t\tdisplay: none;\n\n\t\t// Logo\n\t\t.docs-aside-logo {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n","//\n// Menu\n//\n\n// Aside menu\n.docs-aside-menu {\n    .menu {\n        // Link padding x\n        @include menu-link-padding-x(get($docs-aside-config, padding-x));\n\n        // Menu indention\n        @include menu-link-indention(get($docs-aside-config, menu-indention), get($docs-aside-config, padding-x));\n    }\n\n    // Item\n    .menu-item {\n        padding: 0;\n\n        // Menu Link\n        .menu-link {\n            font-weight: 500;\n            padding-top: 0.75rem;\n            padding-bottom: 0.75rem;\n        }\n\n        // Icon\n        .menu-icon {\n            justify-content: flex-start;\n        }\n    }\n}","//\n// Card\n//\n\n.card.card-docs {\n    background-color: $body-bg;\n    border: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
